import * as React from "react";
import React__default, { createContext, useMemo, createElement, useContext, useCallback, useLayoutEffect, useRef, useEffect, useState, forwardRef, Children, isValidElement, cloneElement, Fragment, useReducer, memo as memo$2, PureComponent, useImperativeHandle, Component } from "react";
import * as ReactDOM from "react-dom";
import ReactDOM__default, { flushSync as flushSync$1, unstable_batchedUpdates, createPortal } from "react-dom";
import { jsx, jsxs, Fragment as Fragment$1 } from "react/jsx-runtime";
function r$2(e3) {
  var t3, f2, n2 = "";
  if ("string" == typeof e3 || "number" == typeof e3) n2 += e3;
  else if ("object" == typeof e3) if (Array.isArray(e3)) {
    var o2 = e3.length;
    for (t3 = 0; t3 < o2; t3++) e3[t3] && (f2 = r$2(e3[t3])) && (n2 && (n2 += " "), n2 += f2);
  } else for (f2 in e3) e3[f2] && (n2 && (n2 += " "), n2 += f2);
  return n2;
}
function clsx() {
  for (var e3, t3, f2 = 0, n2 = "", o2 = arguments.length; f2 < o2; f2++) (e3 = arguments[f2]) && (t3 = r$2(e3)) && (n2 && (n2 += " "), n2 += t3);
  return n2;
}
const AVAILABLE_COLORS = [
  "green",
  "yellow",
  "red",
  "blue",
  "purple",
  "brown",
  "pink",
  "orange",
  "grey",
  "transparent"
];
const getColorByState = (state) => {
  switch (state) {
    case "information":
      return "blue";
    case "warning":
      return "yellow";
    case "error":
      return "red";
    case "experiment":
      return "purple";
    case "success":
      return "green";
    default:
      return "grey";
  }
};
const getOutlineColorShadeClasses = (state) => {
  switch (state) {
    case "green":
      return "border-green-700 text-green-700";
    case "yellow":
      return "border-yellow-700 text-yellow-700";
    case "red":
      return "border-red-500 text-red-500";
    case "blue":
      return "border-blue-500 text-blue-500";
    case "purple":
      return "border-purple-700 text-purple-700";
    case "brown":
      return "border-brown-700 text-brown-700";
    case "pink":
      return "border-pink-700 text-pink-700";
    case "orange":
      return "border-orange-700 text-orange-700";
    case "transparent":
    case "grey":
    default:
      return "border-grey-700 text-grey-700";
  }
};
const getSubtleColorShadeClasses = (value) => {
  switch (value) {
    case "green":
      return "wcag-green-100";
    case "yellow":
      return "wcag-yellow-100";
    case "red":
      return "wcag-red-100";
    case "blue":
      return "wcag-blue-100";
    case "purple":
      return "wcag-purple-100";
    case "brown":
      return "wcag-brown-100";
    case "pink":
      return "wcag-pink-100";
    case "orange":
      return "wcag-orange-100";
    case "transparent":
      return "wcag-transparent";
    case "grey":
    default:
      return "wcag-grey-200";
  }
};
const getColorShadeClasses = (value) => {
  switch (value) {
    case "green":
      return "wcag-green-700";
    case "yellow":
      return "wcag-yellow-500";
    case "red":
      return "wcag-red-500";
    case "blue":
      return "wcag-blue-500";
    case "purple":
      return "wcag-purple-700";
    case "brown":
      return "wcag-brown-700";
    case "pink":
      return "wcag-pink-500";
    case "orange":
      return "wcag-orange-700";
    case "transparent":
      return "wcag-transparent";
    case "grey":
    default:
      return "wcag-grey-700";
  }
};
function IconAccountPreview(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M19.25 3c.966 0 1.75.784 1.75 1.75V11h-1.5V4.75a.25.25 0 00-.193-.243L19.25 4.5H4.75a.25.25 0 00-.243.193L4.5 4.75v14.5a.25.25 0 00.193.243l.057.007H11V21H4.75A1.75 1.75 0 013 19.25V4.75C3 3.784 3.784 3 4.75 3h14.5zm-4.5 7.25a4.5 4.5 0 013.632 7.158l.036-.05 2.362 2.362a.75.75 0 01-.976 1.133l-.084-.073-2.363-2.362-.112.077a4.5 4.5 0 11-2.495-8.245zm0 1.5a3 3 0 100 6 3 3 0 000-6zm-7 3.25a.75.75 0 110 1.5h-.5a.75.75 0 110-1.5h.5zm0-4a.75.75 0 110 1.5h-.5a.75.75 0 110-1.5h.5zm9-4a.75.75 0 110 1.5h-6.5a.75.75 0 010-1.5h6.5zm-9 0a.75.75 0 010 1.5h-.5a.75.75 0 010-1.5h.5z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const AccountPreview = React.forwardRef(IconAccountPreview);
function IconAccountingYearCancel(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M4.5 16.25v3a.25.25 0 00.193.243l.057.007H13V21H4.75A1.75 1.75 0 013 19.25v-3h1.5zm4.946-6.103l.084.073 3 3a.75.75 0 01.073.976l-.073.084-3 3a.75.75 0 01-1.133-.976l.073-.084 1.718-1.72H3.75a.75.75 0 01-.102-1.493L3.75 13h6.44l-1.72-1.72a.75.75 0 01-.073-.976l.073-.084a.75.75 0 01.976-.073zM16.25 2a.75.75 0 01.75.75V3h2.25c.966 0 1.75.784 1.75 1.75V13h-1.5V8h-15v3.25H3v-6.5C3 3.784 3.784 3 4.75 3H7v-.25a.75.75 0 011.5 0V3h7v-.25a.75.75 0 01.75-.75zM7 4.5H4.75a.25.25 0 00-.243.193L4.5 4.75V6.5h15V4.75a.25.25 0 00-.193-.243L19.25 4.5H17v.25a.75.75 0 11-1.5 0V4.5h-7v.25a.75.75 0 01-1.5 0V4.5zm12.804 10.147a.75.75 0 011.049 1.05l-.073.083-1.969 1.97 1.97 1.97a.75.75 0 01-.977 1.133l-.084-.073-1.97-1.969-1.97 1.97-.084.072a.75.75 0 01-1.049-1.05l.073-.083 1.969-1.97-1.97-1.97a.75.75 0 01.977-1.133l.084.073 1.97 1.969 1.97-1.97.084-.072z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const AccountingYearCancel = React.forwardRef(IconAccountingYearCancel);
function IconAccountingYear(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M16.25 2a.75.75 0 01.75.75V3h2.25c.966 0 1.75.784 1.75 1.75v14.5A1.75 1.75 0 0119.25 21H4.75A1.75 1.75 0 013 19.25v-3h1.5v3a.25.25 0 00.193.243l.057.007h14.5a.25.25 0 00.243-.193l.007-.057V8h-15v3.25H3v-6.5C3 3.784 3.784 3 4.75 3H7v-.25a.75.75 0 011.5 0V3h7v-.25a.75.75 0 01.75-.75zm-6.804 8.147l.084.073 3 3a.75.75 0 01.073.976l-.073.084-3 3a.75.75 0 01-1.133-.976l.073-.084 1.719-1.72H3.75a.75.75 0 01-.102-1.493L3.75 13h6.439l-1.72-1.72a.75.75 0 01-.072-.976l.073-.084a.75.75 0 01.976-.073zM7 4.5H4.75a.25.25 0 00-.243.193L4.5 4.75V6.5h15V4.75a.25.25 0 00-.193-.243L19.25 4.5H17v.25a.75.75 0 11-1.5 0V4.5h-7v.25a.75.75 0 01-1.5 0V4.5z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const AccountingYear = React.forwardRef(IconAccountingYear);
function IconAccounting(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M18.25 2c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0118.25 22H5.75A1.75 1.75 0 014 20.25V3.75C4 2.784 4.784 2 5.75 2h12.5zM13 17.5H6.5a.5.5 0 00-.492.41L6 18v1.5a.5.5 0 00.41.492L6.5 20H13a.5.5 0 00.492-.41l.008-.09V18a.5.5 0 00-.41-.492L13 17.5zm4.5 0h-2a.5.5 0 00-.492.41L15 18v1.5a.5.5 0 00.41.492l.09.008h2a.5.5 0 00.492-.41L18 19.5V18a.5.5 0 00-.41-.492l-.09-.008zm-9-3.5h-2a.5.5 0 00-.492.41L6 14.5V16a.5.5 0 00.41.492l.09.008h2a.5.5 0 00.492-.41L9 16v-1.5a.5.5 0 00-.41-.492L8.5 14zm9 0h-2a.5.5 0 00-.492.41L15 14.5V16a.5.5 0 00.41.492l.09.008h2a.5.5 0 00.492-.41L18 16v-1.5a.5.5 0 00-.41-.492L17.5 14zM13 14h-2a.5.5 0 00-.492.41l-.008.09V16a.5.5 0 00.41.492l.09.008h2a.5.5 0 00.492-.41L13.5 16v-1.5a.5.5 0 00-.41-.492L13 14zm-4.5-3.5h-2a.5.5 0 00-.492.41L6 11v1.5a.5.5 0 00.41.492L6.5 13h2a.5.5 0 00.492-.41L9 12.5V11a.5.5 0 00-.41-.492L8.5 10.5zm9 0h-2a.5.5 0 00-.492.41L15 11v1.5a.5.5 0 00.41.492l.09.008h2a.5.5 0 00.492-.41L18 12.5V11a.5.5 0 00-.41-.492l-.09-.008zm-4.5 0h-2a.5.5 0 00-.492.41L10.5 11v1.5a.5.5 0 00.41.492L11 13h2a.5.5 0 00.492-.41l.008-.09V11a.5.5 0 00-.41-.492L13 10.5zM17.5 4h-11a.5.5 0 00-.492.41L6 4.5V8a.5.5 0 00.41.492l.09.008h11a.5.5 0 00.492-.41L18 8V4.5a.5.5 0 00-.41-.492L17.5 4zm-1 1a.5.5 0 01.5.5V7a.5.5 0 01-.5.5h-1A.5.5 0 0115 7V5.5a.5.5 0 01.5-.5h1z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Accounting = React.forwardRef(IconAccounting);
function IconAiChatSolid(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.823 2.122a.188.188 0 01.352 0l.874 2.364c.02.051.06.092.111.11l2.364.875a.188.188 0 010 .352l-2.364.875a.188.188 0 00-.11.11l-.875 2.364a.188.188 0 01-.352 0l-.875-2.364a.187.187 0 00-.11-.11l-2.364-.875a.188.188 0 010-.352l2.364-.874a.187.187 0 00.11-.111l.875-2.364zm1.667 7a.188.188 0 01.351 0l.515 1.39a.19.19 0 00.11.112l1.39.514a.188.188 0 010 .352l-1.39.514a.188.188 0 00-.11.111l-.515 1.39a.187.187 0 01-.351 0l-.515-1.39a.187.187 0 00-.11-.11l-1.391-.515a.188.188 0 010-.352l1.39-.514a.187.187 0 00.111-.111l.515-1.39zm-5.363-2.36c-.889-.328-1.014-1.455-.374-2.008a12.291 12.291 0 00-3.864-.606C5.979 4.148 2 6.884 2 10.26c0 2.393 1.999 4.463 4.91 5.467L4.513 19.99a.556.556 0 00.832.706l5.406-4.325.426-.003c3.493-.076 6.477-1.538 7.829-3.612l-.879-.325c-1.034-.383-1.034-1.845 0-2.228l.234-.086a1.168 1.168 0 01-.476-.595l-.745-2.013-2.013-.745z",
      fill: "currentColor"
    }
  ));
}
const AiChatSolid = React.forwardRef(IconAiChatSolid);
function IconAiStars(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement("mask", { id: "ai-stars_svg__a", fill: "#fff" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.324 2.476a.188.188 0 01.351 0l.875 2.364c.019.05.06.091.11.11l2.364.875a.188.188 0 010 .352l-2.363.874a.187.187 0 00-.111.11l-.875 2.365a.188.188 0 01-.351 0l-.875-2.364a.188.188 0 00-.11-.11l-2.364-.875a.188.188 0 010-.352l2.363-.875a.188.188 0 00.111-.11l.875-2.364zM8.226 4.931c.266-.719 1.281-.719 1.547 0l1.566 4.23 4.23 1.566c.719.266.719 1.282 0 1.547l-4.23 1.566-1.566 4.23c-.266.72-1.281.72-1.547 0L6.66 13.84l-4.23-1.566c-.719-.265-.719-1.281 0-1.547l4.23-1.566 1.566-4.23zM9 7.16L7.96 9.974a.825.825 0 01-.488.487L4.66 11.5l2.81 1.041a.825.825 0 01.488.487L9 15.84l1.04-2.812a.825.825 0 01.488-.487l2.811-1.04-2.81-1.04a.825.825 0 01-.488-.488L9 7.162zm8.675 7.315a.188.188 0 00-.351 0l-.875 2.364a.188.188 0 01-.11.11l-2.364.875a.188.188 0 000 .352l2.363.874c.052.02.092.06.111.11l.875 2.364c.06.164.291.164.351 0l.875-2.363a.187.187 0 01.11-.11l2.364-.875a.188.188 0 000-.352l-2.363-.875a.187.187 0 01-.111-.11l-.875-2.364z"
    }
  )), /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.324 2.476a.188.188 0 01.351 0l.875 2.364c.019.05.06.091.11.11l2.364.875a.188.188 0 010 .352l-2.363.874a.187.187 0 00-.111.11l-.875 2.365a.188.188 0 01-.351 0l-.875-2.364a.188.188 0 00-.11-.11l-2.364-.875a.188.188 0 010-.352l2.363-.875a.188.188 0 00.111-.11l.875-2.364zM8.226 4.931c.266-.719 1.281-.719 1.547 0l1.566 4.23 4.23 1.566c.719.266.719 1.282 0 1.547l-4.23 1.566-1.566 4.23c-.266.72-1.281.72-1.547 0L6.66 13.84l-4.23-1.566c-.719-.265-.719-1.281 0-1.547l4.23-1.566 1.566-4.23zM9 7.16L7.96 9.974a.825.825 0 01-.488.487L4.66 11.5l2.81 1.041a.825.825 0 01.488.487L9 15.84l1.04-2.812a.825.825 0 01.488-.487l2.811-1.04-2.81-1.04a.825.825 0 01-.488-.488L9 7.162zm8.675 7.315a.188.188 0 00-.351 0l-.875 2.364a.188.188 0 01-.11.11l-2.364.875a.188.188 0 000 .352l2.363.874c.052.02.092.06.111.11l.875 2.364c.06.164.291.164.351 0l.875-2.363a.187.187 0 01.11-.11l2.364-.875a.188.188 0 000-.352l-2.363-.875a.187.187 0 01-.111-.11l-.875-2.364z",
      fill: "currentColor"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M17.675 2.476l.704-.26-.704.26zm-.351 0l-.704-.26.704.26zM18.55 4.84l.703-.26-.703.26zm.11.11l-.26.704.26-.704zm2.364.875l.26-.704-.26.704zm0 .352l-.26-.704.26.704zm-2.363.874l-.26-.703.26.703zm-.111.11l.703.261-.703-.26zm-.875 2.365l.704.26-.704-.26zm-.351 0l-.704.26.704-.26zm-.875-2.364l.703-.26-.703.26zm-.11-.11l.26-.704-.26.703zm-2.364-.875l-.26.703.26-.703zm0-.352l-.26-.704.26.704zm2.363-.875l.26.704-.26-.704zm.111-.11l.703.26-.703-.26zm-6.676.09l-.703.26.703-.26zm-1.547 0l.703.26-.703-.26zm3.113 4.231l-.704.26.12.324.323.12.26-.704zm4.23 1.566l-.26.703.26-.703zm0 1.547l-.26-.703.26.704zm-4.23 1.566l-.26-.703-.324.12-.12.323.704.26zm-1.566 4.23l-.703-.26.703.26zm-1.547 0l.703-.26-.703.26zM6.66 13.84l.704-.26-.12-.324-.324-.12-.26.704zm-4.23-1.566l.26-.703-.26.704zm0-1.547l.26.703-.26-.703zm4.23-1.566l.26.704.324-.12.12-.323-.704-.26zm1.3.812l.703.26-.704-.26zM9 7.162l.703-.26L9 5l-.704 1.9.704.26zM7.472 10.46l-.26-.703.26.704zM4.66 11.5l-.26-.703-1.901.704 1.9.703.26-.703zm2.81 1.041l.261-.703-.26.703zm.488.487l.704-.26-.704.26zM9 15.84l-.703.26L9 18l.703-1.9L9 15.84zm1.04-2.812l.704.26-.703-.26zm.488-.487l-.26-.703.26.703zm2.811-1.04l.26.703 1.901-.703-1.9-.704-.26.704zm-2.81-1.04l.26-.704-.26.704zm-.488-.488l.703-.26-.703.26zm7.284 4.503l-.704-.26.704.26zm.351 0l.704-.26-.704.26zM16.45 16.84l.703.26-.703-.26zm-.11.11l.26.704-.26-.704zm-2.364.875l-.26-.703.26.703zm0 .352l.26-.704-.26.704zm2.363.874l-.26.704.26-.704zm.111.11l.703-.26-.703.26zm.875 2.364l-.704.26.704-.26zm.351 0l.704.26-.704-.26zm.875-2.363l.703.26-.703-.26zm.11-.11l.261.703-.26-.704zm2.364-.875l.26.703-.26-.703zm0-.352l.26-.703-.26.703zm-2.363-.875l-.26.704.26-.704zm-.111-.11l.703-.26-.703.26zM18.38 2.216c-.302-.817-1.457-.817-1.759 0l1.407.52a.563.563 0 01-1.055 0l1.407-.52zm.874 2.363l-.874-2.363-1.407.52.875 2.364 1.406-.52zm-.332-.332a.562.562 0 01.332.332l-1.406.52a.937.937 0 00.553.555l.521-1.407zm2.364.874l-2.364-.874-.52 1.407 2.363.874.52-1.407zm0 1.759c.816-.302.816-1.456 0-1.759l-.521 1.407a.563.563 0 010-1.055l.52 1.407zm-2.364.875l2.364-.875-.521-1.407-2.363.875.52 1.407zm.332-.333a.562.562 0 01-.332.333l-.52-1.407a.937.937 0 00-.554.554l1.406.52zm-.874 2.364l.874-2.364-1.406-.52-.875 2.363 1.407.52zm-1.759 0c.302.816 1.457.816 1.759 0l-1.407-.52a.563.563 0 011.055 0l-1.407.52zm-.874-2.364l.874 2.364 1.407-.52-.875-2.364-1.406.52zm.332.333a.562.562 0 01-.332-.333l1.406-.52a.938.938 0 00-.553-.554l-.521 1.407zm-2.364-.875l2.364.875.52-1.407-2.363-.875-.52 1.407zm0-1.759c-.816.303-.816 1.457 0 1.759l.521-1.407c.49.181.49.874 0 1.055l-.52-1.407zm2.364-.874l-2.364.874.521 1.407 2.364-.874-.521-1.407zm-.332.332a.562.562 0 01.332-.332l.52 1.407a.938.938 0 00.555-.554l-1.407-.52zm.874-2.363l-.874 2.363 1.406.52.875-2.363-1.407-.52zM10.477 4.67c-.508-1.37-2.447-1.37-2.955 0l1.407.52a.1.1 0 01.015-.027.041.041 0 01.01-.01A.085.085 0 019 5.142c.021 0 .037.006.045.011a.041.041 0 01.01.01.1.1 0 01.015.028l1.407-.52zm1.565 4.231l-1.565-4.23-1.407.52 1.565 4.23 1.407-.52zm3.788 1.123L11.6 8.458l-.521 1.407 4.23 1.565.521-1.406zm0 2.954c1.371-.508 1.371-2.447 0-2.954l-.52 1.406a.103.103 0 01.028.015.044.044 0 01.009.01.084.084 0 01.011.046.084.084 0 01-.011.045.04.04 0 01-.01.01.102.102 0 01-.028.015l.521 1.407zm-4.23 1.565l4.23-1.565-.52-1.407-4.232 1.566.521 1.406zm-1.123 3.788l1.565-4.23-1.407-.521-1.565 4.23 1.407.521zm-2.955 0c.508 1.371 2.447 1.371 2.955 0l-1.407-.52a.1.1 0 01-.015.028.04.04 0 01-.01.009.085.085 0 01-.045.012.085.085 0 01-.046-.012.04.04 0 01-.01-.01.1.1 0 01-.015-.027l-1.407.52zm-1.565-4.23l1.565 4.23 1.407-.52-1.565-4.231-1.407.52zm-3.788-1.123l4.23 1.565.521-1.406-4.23-1.566-.521 1.407zm0-2.954c-1.371.507-1.371 2.446 0 2.954l.52-1.407a.1.1 0 01-.028-.015.04.04 0 01-.009-.01.085.085 0 01-.011-.045.09.09 0 01.011-.046.043.043 0 01.01-.01.099.099 0 01.028-.015l-.521-1.406zm4.23-1.566l-4.23 1.566.52 1.406L6.92 9.865 6.4 8.458zM7.523 4.67L5.957 8.901l1.407.52 1.565-4.23-1.407-.52zm1.14 5.563l1.04-2.81-1.406-.521-1.04 2.81 1.407.521zm-.93.93c.431-.159.771-.498.93-.93l-1.406-.52a.075.075 0 01-.044.044l.52 1.407zm-2.811 1.041l2.811-1.04-.52-1.407-2.812 1.04.52 1.407zm2.811-.366l-2.811-1.04-.52 1.406 2.81 1.04.521-1.406zm.93.93a1.574 1.574 0 00-.93-.93l-.52 1.406c.02.008.036.024.044.045l1.407-.52zm1.04 2.811l-1.04-2.81-1.406.52 1.04 2.81 1.407-.52zm-.366-2.81l-1.04 2.81 1.407.52 1.04-2.81-1.407-.52zm.93-.931c-.43.16-.77.499-.93.93l1.407.52a.075.075 0 01.044-.044l-.52-1.406zm2.812-1.04l-2.811 1.04.52 1.406 2.812-1.04-.52-1.407zm-2.811.366l2.811 1.04.52-1.407-2.81-1.04-.521 1.407zm-.93-.93c.159.43.499.77.93.93l.52-1.407a.075.075 0 01-.044-.044l-1.407.52zm-1.04-2.812l1.04 2.811 1.406-.52-1.04-2.811-1.407.52zm9.73 7.314a.563.563 0 01-1.055 0l1.407-.52c-.302-.816-1.457-.816-1.759 0l1.407.52zm-.875 2.364l.875-2.364-1.407-.52-.874 2.363 1.406.52zm-.553.554a.938.938 0 00.553-.554l-1.406-.52a.563.563 0 01.332-.333l.52 1.407zm-2.364.874l2.364-.874-.521-1.407-2.364.875.521 1.406zm0-1.055c.49.181.49.874 0 1.055l-.52-1.406c-.817.302-.817 1.456 0 1.758l.52-1.407zm2.364.875l-2.364-.875-.52 1.407 2.363.875.52-1.407zm.553.554a.938.938 0 00-.553-.554l-.521 1.407a.563.563 0 01-.332-.333l1.406-.52zm.875 2.363l-.875-2.363-1.406.52.874 2.364 1.407-.52zm-1.055 0a.563.563 0 011.055 0l-1.407.52c.302.817 1.457.817 1.759 0l-1.407-.52zm.875-2.363l-.875 2.363 1.407.52.874-2.363-1.406-.52zm.553-.554a.937.937 0 00-.553.554l1.406.52a.562.562 0 01-.332.333l-.52-1.407zm2.364-.875l-2.363.875.52 1.407 2.364-.875-.521-1.407zm0 1.055a.563.563 0 010-1.055l.52 1.407c.817-.302.817-1.456 0-1.758l-.52 1.406zm-2.363-.874l2.363.874.52-1.406-2.363-.875-.52 1.407zm-.554-.554a.938.938 0 00.553.554l.521-1.407a.562.562 0 01.332.332l-1.406.52zm-.875-2.364l.875 2.364 1.406-.52-.874-2.364-1.407.52z",
      fill: "currentColor",
      mask: "url(#ai-stars_svg__a)"
    }
  ));
}
const AiStars = React.forwardRef(IconAiStars);
function IconArrowBottom(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M8.25 18h7.5a.75.75 0 110 1.5h-7.5a.75.75 0 110-1.5zM12 4.5a.75.75 0 01.743.648l.007.102v8.189l2.22-2.22a.75.75 0 011.133.977l-.073.084-3.5 3.5a.754.754 0 01-.078.069l.078-.069-.042.04-.052.04-.114.068-.098.038-.084.02-.088.012L12 16l-.029-.002h-.023l-.021-.003-.054-.006-.07-.015-.072-.024-.1-.047-.082-.054-.08-.069-3.5-3.5a.75.75 0 01.977-1.133l.084.073 2.22 2.219V5.25A.75.75 0 0112 4.5z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const ArrowBottom = React.forwardRef(IconArrowBottom);
function IconArrowDown(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M12 6.25a.75.75 0 01.743.648L12.75 7l-.001 8.189 2.22-2.22a.75.75 0 011.134.977l-.073.084-3.5 3.5-.038.036-.046.037h-.002l-.008.007-.081.051-.134.056-.085.02-.084.011h-.103l-.12-.018-.12-.039-.078-.038-.082-.054-.08-.069-3.5-3.5a.75.75 0 01.977-1.133l.084.073 2.219 2.218L11.25 7a.75.75 0 01.75-.75z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const ArrowDown = React.forwardRef(IconArrowDown);
function IconArrowEnd(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M18.75 7.5a.75.75 0 01.75.75v7.5a.75.75 0 11-1.5 0v-7.5a.75.75 0 01.75-.75zm-6.554.397l.084.073 3.5 3.5c.025.024.048.05.069.078l-.069-.078.04.042.04.052.068.114.038.098.02.084.012.088v.104l-.018.119-.03.098-.047.1-.032.051-.027.038-.064.072-3.5 3.5a.75.75 0 01-1.133-.976l.073-.084 2.219-2.22H5.25a.75.75 0 01-.102-1.493l.102-.007h8.189l-2.22-2.22a.75.75 0 01.977-1.133z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const ArrowEnd = React.forwardRef(IconArrowEnd);
function IconArrowLeft(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M11.03 7.97a.75.75 0 01.073.976l-.073.084-2.219 2.219L17 11.25a.75.75 0 01.102 1.493L17 12.75l-8.19-.001 2.22 2.22a.75.75 0 01-.976 1.134l-.084-.073-3.5-3.5-.08-.094-.051-.081-.05-.116-.027-.103-.01-.089v-.094l.018-.124.03-.099.047-.099.054-.082.069-.08 3.5-3.5a.75.75 0 011.06 0z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const ArrowLeft = React.forwardRef(IconArrowLeft);
function IconArrowRight(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M13.946 7.897l.084.073 3.5 3.5.036.038.044.056.051.081.05.116.027.103.01.084v.103l-.018.12-.039.12-.038.078-.06.09-.063.071-3.5 3.5a.75.75 0 01-1.133-.976l.073-.084 2.218-2.22H7a.75.75 0 01-.102-1.493L7 11.25h8.189l-2.22-2.22a.75.75 0 01.977-1.133z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const ArrowRight = React.forwardRef(IconArrowRight);
function IconArrowStart(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M5.25 7.5a.75.75 0 01.75.75v7.5a.75.75 0 11-1.5 0v-7.5a.75.75 0 01.75-.75zm7.53.47a.75.75 0 01.073.976l-.073.084-2.219 2.22h8.189a.75.75 0 01.102 1.493l-.102.007h-8.189l2.22 2.22a.75.75 0 01-.977 1.133l-.084-.073-3.5-3.5-.055-.06-.046-.065-.049-.088-.044-.12-.018-.089L8 11.965l.019-.136.03-.098.047-.1.054-.082.069-.08 3.5-3.5a.75.75 0 011.06 0z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const ArrowStart = React.forwardRef(IconArrowStart);
function IconArrowTop(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M11.86 8.013l.067-.01.125-.001.119.018.098.03.1.047.051.032.038.027.072.064 3.5 3.5a.75.75 0 01-.976 1.133l-.084-.073-2.22-2.219v8.189a.75.75 0 01-1.493.102l-.007-.102v-8.189l-2.22 2.22a.75.75 0 01-1.133-.977l.073-.084 3.5-3.5.042-.04.052-.04.114-.068.098-.038.084-.02zM15.75 4.5a.75.75 0 110 1.5h-7.5a.75.75 0 010-1.5h7.5z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const ArrowTop = React.forwardRef(IconArrowTop);
function IconArrowUp(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M11.864 6.262l.089-.01h.095l.123.018.12.039.078.038.09.06.071.063 3.5 3.5a.75.75 0 01-.976 1.133l-.084-.073-2.22-2.219V17a.75.75 0 01-1.493.102L11.25 17V8.81l-2.22 2.22a.75.75 0 01-1.133-.976l.073-.084 3.5-3.5.094-.08.081-.051.134-.056.085-.02z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const ArrowUp = React.forwardRef(IconArrowUp);
function IconAttachAuto(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M7.916 10.159l1.06 1.06-2.663 2.665a3.75 3.75 0 005.159 5.44l.144-.137 6.657-6.657a.75.75 0 011.128.984l-.067.077-6.657 6.657a5.25 5.25 0 01-7.575-7.269l.15-.156 2.664-2.664zm11.771-6.468a3.75 3.75 0 01.137 5.16l-.137.144-9.132 9.132a2.25 2.25 0 01-3.287-3.07l.105-.112 6.657-6.657a.75.75 0 011.128.984l-.067.076-6.657 6.657a.75.75 0 00.984 1.128l.077-.067 9.132-9.132a2.25 2.25 0 00-3.07-3.287l-.112.105-2.933 2.932-1.061-1.061 2.933-2.932a3.75 3.75 0 015.303 0zM4 9a2 2 0 002 2 2 2 0 00-1.995 1.85L4 13l-.004-.132A2 2 0 002 11a2 2 0 002-2zm6-2.5a2 2 0 002 2 2 2 0 00-1.995 1.85L10 10.5l-.004-.132A2 2 0 008 8.5a2 2 0 002-2zM6.5 2c0 2.21 2.015 4 4.5 4-2.412 0-4.381 1.687-4.495 3.806L6.5 10l-.01-.263C6.338 7.65 4.386 6 2 6c2.485 0 4.5-1.79 4.5-4z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const AttachAuto = React.forwardRef(IconAttachAuto);
function IconAttachCancel(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M19.026 18.467a.75.75 0 01-.977 1.133l-.084-.073-2.288-2.288-3.005 3.006a5.25 5.25 0 01-7.574-7.269l.15-.156 3.005-3.005-2.288-2.288a.75.75 0 01.977-1.133l.084.073 12 12zm-9.713-7.592l-3.005 3.006a3.75 3.75 0 005.16 5.44l.144-.137 3.005-3.005-1.061-1.061-3.005 3.005a2.25 2.25 0 01-3.287-3.069l.105-.113 3.005-3.005-1.061-1.061zm2.122 2.122L8.43 16.002a.75.75 0 00.984 1.128l.076-.067 3.005-3.006-1.06-1.06zm7.894-.47a.75.75 0 01.067.984l-.067.077-1.53 1.53-1.061-1.061 1.53-1.53a.75.75 0 011.061 0zm.354-8.839a3.75 3.75 0 01.137 5.16l-.137.144-4.006 4.004-1.06-1.06 4.005-4.005a2.25 2.25 0 00-3.07-3.287l-.112.105-4.005 4.005-1.061-1.061 4.005-4.005a3.75 3.75 0 015.304 0zm-4.596 4.597a.75.75 0 01.067.983l-.067.077-1.531 1.53-1.061-1.061 1.53-1.53a.75.75 0 011.062 0z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const AttachCancel = React.forwardRef(IconAttachCancel);
function IconAttachWarning(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.38 3.688a3.75 3.75 0 015.44 5.16l-.137.144-9.132 9.131a2.25 2.25 0 01-3.287-3.069l.105-.113 6.657-6.656a.75.75 0 011.128.983l-.068.077-6.656 6.657a.75.75 0 00.984 1.128l.076-.067 9.132-9.132a2.25 2.25 0 00-3.07-3.287l-.112.105-9.132 9.132a3.75 3.75 0 005.16 5.44l.144-.137 1.934-1.935a6.062 6.062 0 00.09 2.031l-.964.965a5.25 5.25 0 01-7.574-7.269l.15-.156 9.131-9.132zM22 18a4.5 4.5 0 10-9 0 4.5 4.5 0 009 0zm-5.243-2.852a.75.75 0 011.493.102v3.5l-.007.102a.75.75 0 01-1.493-.102v-3.5l.007-.102zM17.5 20a.75.75 0 100 1.5.75.75 0 000-1.5z",
      fill: "currentColor"
    }
  ));
}
const AttachWarning = React.forwardRef(IconAttachWarning);
function IconAttach(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M14.38 3.688a3.75 3.75 0 015.44 5.16l-.137.144-9.132 9.131a2.25 2.25 0 01-3.287-3.069l.105-.113 6.657-6.656a.75.75 0 011.128.983l-.067.077-6.657 6.657a.75.75 0 00.984 1.128l.076-.067 9.132-9.132a2.25 2.25 0 00-3.07-3.287l-.112.105-9.132 9.132a3.75 3.75 0 005.16 5.44l.144-.137 6.657-6.657a.75.75 0 011.127.984l-.067.077-6.657 6.657a5.25 5.25 0 01-7.574-7.269l.15-.156 9.131-9.132z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Attach = React.forwardRef(IconAttach);
function IconAutopayPaused(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.356 2.503a.743.743 0 10.449 1.417 9.323 9.323 0 011.909-.391 8.998 8.998 0 011.883.013.743.743 0 10.168-1.476 10.484 10.484 0 00-2.195-.016 10.81 10.81 0 00-2.214.453zM7.46 5.037a.743.743 0 10-.817-1.241c-.628.413-1.215.893-1.747 1.433-.52.528-.978 1.103-1.366 1.712a.743.743 0 101.253.798 8.928 8.928 0 011.17-1.467A9.28 9.28 0 017.46 5.037zm9.14-2.22a.743.743 0 00-.59 1.363 7.904 7.904 0 011.611.935c.484.363.914.776 1.287 1.229a.743.743 0 001.147-.945 9.004 9.004 0 00-1.54-1.472 9.387 9.387 0 00-1.915-1.11zM3.767 10.008a.743.743 0 10-1.432-.396A9.316 9.316 0 002 11.795a.743.743 0 101.485.048 7.83 7.83 0 01.282-1.835zm17.716-2.152a.743.743 0 10-1.389.529c.21.549.353 1.126.425 1.723a.743.743 0 101.476-.18 8.81 8.81 0 00-.512-2.072zm-9.28-.732c-.26 0-.527.127-.527.505v.406c-1.567.145-2.577 1.085-2.577 2.426 0 1.125.639 1.862 1.907 2.182l1.296.285c.836.18 1.167.435 1.167.87 0 .558-.441.923-1.26.923-.586 0-1.154-.244-1.67-.714-.332-.278-.54-.36-.796-.36-.412 0-.743.256-.743.709 0 .348.186.684.51.98.482.447 1.26.72 2.143.796v.354c0 .371.272.505.533.505.262 0 .529-.134.529-.505v-.366c1.625-.191 2.64-1.143 2.64-2.519 0-1.133-.652-1.845-1.978-2.156l-1.3-.27c-.738-.145-1.075-.424-1.075-.859 0-.488.436-.876 1.12-.876.581 0 .999.185 1.492.655.29.25.528.36.842.36.366 0 .667-.267.667-.65 0-.325-.174-.667-.499-.975-.43-.418-1.12-.685-1.892-.783v-.418c0-.372-.267-.505-.528-.505zm8.802 8.025a.743.743 0 00-.946.457 7.718 7.718 0 01-2.763 3.704 8.23 8.23 0 01-4.48 1.548 8.628 8.628 0 01-4.69-1.152c-.906-.524-1.649-1.03-2.262-1.749l.79.276a.743.743 0 10.49-1.404l-2.732-.952a.743.743 0 00-.946.458l-.997 2.86a.743.743 0 101.403.49l.45-1.294c.84 1.193 1.88 1.918 3.06 2.601a10.114 10.114 0 005.5 1.35 9.715 9.715 0 005.287-1.83 9.204 9.204 0 003.293-4.417.743.743 0 00-.457-.946z",
      fill: "currentColor"
    }
  ));
}
const AutopayPaused = React.forwardRef(IconAutopayPaused);
function IconAutopay(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.367 6.142a.734.734 0 011.003.269l.83 1.438a9.885 9.885 0 017.774-5.769 9.993 9.993 0 015.73.975 10.135 10.135 0 014.249 4.002.734.734 0 01-1.272.734 8.667 8.667 0 00-3.633-3.422 8.525 8.525 0 00-4.888-.832 8.417 8.417 0 00-6.355 4.376l.749-.433a.734.734 0 01.734 1.271l-2.56 1.479a.734.734 0 01-1.004-.269L1.098 7.145a.734.734 0 01.27-1.003zm2.895 10.273a.734.734 0 011.003.269 7.627 7.627 0 003.384 3.09 8.195 8.195 0 004.668.668 8.64 8.64 0 004.376-2.005c.792-.684 1.427-1.318 1.895-2.138l-.731.422a.734.734 0 01-.734-1.27l2.495-1.442a.734.734 0 011.003.27l1.501 2.6a.734.734 0 01-1.271.734l-.683-1.183c-.6 1.326-1.485 2.229-2.516 3.118a10.107 10.107 0 01-5.122 2.346 9.664 9.664 0 01-5.504-.79 9.095 9.095 0 01-4.032-3.686.734.734 0 01.268-1.003zm7.382-8.75c0-.372.264-.498.522-.498s.521.132.521.499v.413c.763.097 1.446.361 1.87.774.321.304.493.642.493.963 0 .379-.298.643-.66.643-.309 0-.544-.11-.83-.356-.488-.464-.901-.648-1.475-.648-.676 0-1.107.384-1.107.866 0 .43.333.706 1.062.849l1.285.267c1.31.307 1.955 1.01 1.955 2.13 0 1.36-1.004 2.3-2.61 2.489v.361c0 .367-.264.5-.522.5s-.527-.133-.527-.5v-.35c-.872-.074-1.64-.344-2.116-.785-.322-.293-.505-.625-.505-.97 0-.447.327-.7.734-.7.252 0 .459.081.786.357.51.464 1.072.705 1.651.705.809 0 1.245-.361 1.245-.912 0-.43-.327-.682-1.153-.86l-1.281-.282c-1.253-.316-1.885-1.044-1.885-2.155 0-1.325.998-2.254 2.547-2.398v-.401z",
      fill: "currentColor"
    }
  ));
}
const Autopay = React.forwardRef(IconAutopay);
function IconAutotextInsert(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M14.75 5.75a.25.25 0 00-.193-.243L14.5 5.5H14a.75.75 0 01-.102-1.493L14 4h.5c.372 0 .718.116 1.001.315.242-.17.53-.28.841-.308L16.5 4h.5l.102.007a.75.75 0 010 1.486L17 5.5h-.5l-.057.007a.25.25 0 00-.184.175l-.009.068V8h4c.966 0 1.75.784 1.75 1.75v4.5A1.75 1.75 0 0120.25 16h-4v2.25l.007.057a.25.25 0 00.175.184l.068.009h.5l.102.007a.75.75 0 010 1.486L17 20h-.5l-.144-.006a1.74 1.74 0 01-.856-.308 1.734 1.734 0 01-.856.308L14.5 20H14a.75.75 0 01-.102-1.493L14 18.5h.5a.25.25 0 00.243-.193l.007-.057V5.75zm5.5 3.75h-4v5h4a.25.25 0 00.243-.193l.007-.057v-4.5a.25.25 0 00-.193-.243L20.25 9.5zM6 11a1 1 0 110 2 1 1 0 010-2zm3.5 0a1 1 0 110 2 1 1 0 010-2zm3.5 0c.087 0 .17.011.25.032v1.936A1.002 1.002 0 0112 12a1 1 0 011-1zm-9.25 5A1.75 1.75 0 012 14.25v-4.5C2 8.784 2.784 8 3.75 8h9.5v1.5h-9.5a.25.25 0 00-.243.193L3.5 9.75v4.5a.25.25 0 00.193.243l.057.007h9.5V16h-9.5z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const AutotextInsert = React.forwardRef(IconAutotextInsert);
function IconAutotext(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M20.25 8c.966 0 1.75.784 1.75 1.75v4.5A1.75 1.75 0 0120.25 16H3.75A1.75 1.75 0 012 14.25v-4.5C2 8.784 2.784 8 3.75 8h16.5zm0 1.5H3.75a.25.25 0 00-.243.193L3.5 9.75v4.5a.25.25 0 00.193.243l.057.007h16.5a.25.25 0 00.243-.193l.007-.057v-4.5a.25.25 0 00-.193-.243L20.25 9.5zM6 11a1 1 0 110 2 1 1 0 010-2z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Autotext = React.forwardRef(IconAutotext);
function IconBasicTabs(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M18.5 12.25l1.5 1.5V21a1 1 0 01-1 1H5a1 1 0 01-1-1v-7.25l1.5-1.5v8.25h13v-8.25zm-6.875.582l.375.375.375-.375a1.591 1.591 0 112.25 2.25L12 17.707l-2.625-2.625a1.591 1.591 0 012.25-2.25zm.821-10.685l.084.073L17 6.689V5.5a.5.5 0 01.5-.5h.5a.5.5 0 01.5.5v2.689l3.03 3.03a.75.75 0 01-.976 1.134l-.084-.073L12 3.811l-8.47 8.47a.75.75 0 01-.976.072l-.084-.073a.75.75 0 01-.073-.976l.073-.084 9-9a.75.75 0 01.976-.073z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const BasicTabs = React.forwardRef(IconBasicTabs);
function IconBasic(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M15.25 18.999V21h-2.5v-2.001h2.5zM21 16.75v2.5A1.75 1.75 0 0119.25 21h-2.5v-2.001H19V16.75h2zm-11.5-4c.966 0 1.75.784 1.75 1.75v4.75A1.75 1.75 0 019.5 21H4.75A1.75 1.75 0 013 19.25V14.5c0-.966.784-1.75 1.75-1.75H9.5zm11.5 0v2.5h-2v-2.5h2zm0-4v2.5h-2v-2.5h2zm-16 0v2.5H3v-2.5h2zM19.25 3c.966 0 1.75.784 1.75 1.75v2.5h-2V4.999h-2.25V3h2.5zm-12 0v1.999H5V7.25H3v-2.5C3 3.784 3.784 3 4.75 3h2.5zm4 0v1.999h-2.5V3h2.5zm4 0v1.999h-2.5V3h2.5z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Basic = React.forwardRef(IconBasic);
function IconBellSolid(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M14.5 19.5a2.5 2.5 0 01-4.995.164L9.5 19.5h5zM12 2c.915 0 1.686.767 1.924 1.815A6.002 6.002 0 0118 9.5V15l1.6 1.2A1 1 0 0119 18H5a1 1 0 01-.6-1.8L6 15V9.5a6.003 6.003 0 014.077-5.685C10.314 2.767 11.085 2 12 2z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const BellSolid = React.forwardRef(IconBellSolid);
function IconBook(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M17 4.5c1.583 0 3.165.45 4.748 1.352a.5.5 0 01.252.435V19.15a.5.5 0 01-.728.445C19.848 18.865 18.424 18.5 17 18.5c-1.667 0-3.333.5-5 1.5-1.667-1-3.333-1.5-5-1.5-1.424 0-2.848.365-4.272 1.095A.5.5 0 012 19.15V6.287a.5.5 0 01.252-.435C3.835 4.951 5.417 4.5 7 4.5c1.667 0 3.333.5 5 1.5 1.667-1 3.333-1.5 5-1.5zM17 6c-1.284 0-2.586.363-3.92 1.108l-.308.178L12 7.75l-.772-.463C9.786 6.421 8.383 6 7 6c-1.11 0-2.232.271-3.378.825l-.122.062v10.739l.056-.02a10.363 10.363 0 013.059-.598L7 17c1.585 0 3.156.382 4.704 1.134l.296.149.296-.149c1.429-.694 2.878-1.073 4.339-1.127L17 17c1.027 0 2.05.16 3.065.48l.435.147V6.887l-.122-.062c-1.041-.504-2.064-.773-3.075-.818L17 6zm0 7.75c.836 0 1.669.115 2.5.344v1.567a7.98 7.98 0 00-2.5-.411c-1.16 0-2.325.266-3.501.804v-1.627A9.628 9.628 0 0117 13.75zm0-3c.836 0 1.669.115 2.5.344v1.567a7.98 7.98 0 00-2.5-.411c-1.16 0-2.325.266-3.501.804v-1.627A9.628 9.628 0 0117 10.75zm0-3c.836 0 1.669.115 2.5.344v1.567A7.98 7.98 0 0017 9.25c-1.16 0-2.325.266-3.501.804V8.427A9.628 9.628 0 0117 7.75z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Book = React.forwardRef(IconBook);
function IconBooking(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M19.25 2a.75.75 0 01.743.648L20 2.75v18.5a.75.75 0 01-.648.743L19.25 22H6.75a2.75 2.75 0 01-2.739-3H4V5l.043.001A.749.749 0 014 4.75a2.75 2.75 0 012.582-2.745L6.75 2h12.5zm-.75 16H6.75a1.25 1.25 0 00-.128 2.494l.128.006H18.5v-.75H6.75a.5.5 0 110-1H18.5V18zM5.506 4.622L5.5 4.75a.749.749 0 01-.043.251L5.5 5v11.8a2.732 2.732 0 011-.289V3.525a1.25 1.25 0 00-.994 1.097zM18.5 3.5h-11v13h11v-13zM14.25 9a.75.75 0 110 1.5h-2.5a.75.75 0 110-1.5h2.5zm2-3a.75.75 0 110 1.5h-6.5a.75.75 0 010-1.5h6.5z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Booking = React.forwardRef(IconBooking);
function IconBudget(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10.75 11c.966 0 1.75.784 1.75 1.75v7.5A1.75 1.75 0 0110.75 22h-6A1.75 1.75 0 013 20.25v-7.5c0-.966.784-1.75 1.75-1.75h6zm.25 8.5H9.5v1H11v-1zm-2.5 0h-4v1h4v-1zM14.586 2a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707v9.836A1.75 1.75 0 0119.25 20H13.5v-1.5h5.75a.25.25 0 00.243-.193l.007-.057V9h-3.75a1.75 1.75 0 01-1.744-1.606L14 7.25V3.499L8.25 3.5a.25.25 0 00-.243.193L8 3.75V10H6.5V3.75C6.5 2.784 7.284 2 8.25 2h6.336zM11 17.5H9.5v1H11v-1zm-2.5 0H7v1h1.5v-1zm-2.5 0H4.5v1H6v-1zm10.016-6.984c.152 0 .333.058.371.263l.008.084v.242c.554.063 1.043.247 1.34.536.21.203.32.418.32.644 0 .29-.239.492-.516.492-.242 0-.437-.074-.648-.234-.328-.25-.586-.348-.93-.348-.379 0-.61.23-.61.48 0 .226.168.369.56.457l.14.028.687.121c1 .176 1.508.68 1.508 1.508 0 .908-.638 1.554-1.67 1.741l-.185.029v.175c0 .27-.207.352-.375.352-.157 0-.34-.065-.38-.269l-.007-.083v-.164c-.649-.047-1.211-.242-1.543-.558-.2-.196-.316-.41-.316-.645 0-.347.265-.543.59-.543.159 0 .308.044.495.162l.118.08c.343.254.726.395 1.043.395.48 0 .722-.203.722-.5 0-.217-.177-.353-.617-.458l-.14-.03-.672-.133c-.996-.192-1.489-.703-1.489-1.54 0-.885.638-1.523 1.633-1.683l.18-.023v-.23c0-.274.21-.348.383-.348zM11 15.5H9.5v1H11v-1zm-2.5 0H7v1h1.5v-1zm-2.5 0H4.5v1H6v-1zm5-3H4.5v2H11v-2zm4.5-7.881V7.25a.25.25 0 00.193.243l.057.007h2.631L15.5 4.619z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Budget = React.forwardRef(IconBudget);
function IconCalendar(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M16.25 2c.414 0 .75.294.75.656V3h2.25c.966 0 1.75.83 1.75 1.853v14.294C21 20.17 20.216 21 19.25 21H4.75C3.784 21 3 20.17 3 19.147V4.853C3 3.83 3.784 3 4.75 3H7v-.344C7 2.294 7.336 2 7.75 2s.75.294.75.656V3h7v-.344c0-.362.336-.656.75-.656zm3.25 6h-15v11.147c0 .125.082.23.193.258l.057.007h14.5a.254.254 0 00.243-.204l.007-.06V8zm-11 7a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h2zm4.5 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h2zm4.5 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h2zm-9-4.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-2A.5.5 0 016 12v-1a.5.5 0 01.5-.5h2zm4.5 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h2zm4.5 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h2zM7 4.588H4.75a.254.254 0 00-.243.204l-.007.06V6.5h15V4.853a.262.262 0 00-.193-.258l-.057-.007H17v.256c0 .362-.336.656-.75.656s-.75-.294-.75-.656v-.256h-7v.256c0 .362-.336.656-.75.656S7 5.206 7 4.844v-.256z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Calendar$1 = React.forwardRef(IconCalendar);
function IconCashAccount(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M20 8a2 2 0 012 2v9a2 2 0 01-2 2H8a2 2 0 01-2-2v-9a2 2 0 012-2h12zm.5 5h-13v6a.5.5 0 00.41.492L8 19.5h12a.5.5 0 00.492-.41L20.5 19v-6zM12 15a.5.5 0 01.5.5V17a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-1.5a.5.5 0 01.5-.5h2zm4.607-10.568L17.294 7h-1.553l-.583-2.18a.5.5 0 00-.524-.369l-.089.016L3.92 7.314a.5.5 0 00-.369.523l.016.089L5 13.276v3.905a1.992 1.992 0 01-.812-1.14l-2.07-7.727a2 2 0 011.414-2.45l10.625-2.846a2 2 0 012.45 1.414zM20 9.5H8a.5.5 0 00-.492.41L7.5 10v1.5h13V10a.5.5 0 00-.41-.492L20 9.5z",
      fill: "currentColor"
    }
  ));
}
const CashAccount = React.forwardRef(IconCashAccount);
function IconCashReports(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M13.586 2a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V20.25A1.75 1.75 0 0118.25 22H5.75A1.75 1.75 0 014 20.25V3.75C4 2.784 4.784 2 5.75 2h7.836zM13 3.5H5.75a.25.25 0 00-.243.193L5.5 3.75v16.5a.25.25 0 00.193.243l.057.007h12.5a.25.25 0 00.243-.193l.007-.057V9h-3.75a1.75 1.75 0 01-1.744-1.606L13 7.25V3.5zm-1.143 6.234c.215 0 .434.097.48.36l.009.107v.387c.714.091 1.353.338 1.75.725.301.285.463.602.463.902 0 .355-.28.602-.618.602-.29 0-.51-.102-.779-.333-.456-.435-.843-.607-1.38-.607-.634 0-1.037.36-1.037.811 0 .372.266.62.843.762l.15.033 1.016.21c1.353.263 2.02.934 2.02 2.035 0 1.218-.86 2.076-2.251 2.304l-.193.027v.338c0 .344-.247.468-.49.468-.214 0-.437-.098-.484-.361l-.01-.107v-.327c-.816-.07-1.535-.322-1.981-.736-.301-.274-.473-.585-.473-.908 0-.419.306-.655.688-.655.236 0 .43.075.735.333.478.435 1.005.66 1.547.66.758 0 1.166-.338 1.166-.853 0-.374-.264-.605-.921-.77l-.159-.036-1.01-.22c-1.3-.269-1.955-.967-1.955-2.063 0-1.187.855-2.034 2.199-2.223l.186-.022v-.376c0-.349.247-.467.489-.467zM14.5 4.62v2.63a.25.25 0 00.193.243l.057.007h2.63L14.5 4.621z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const CashReports = React.forwardRef(IconCashReports);
function IconChartArea(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.5 4.75a.75.75 0 00-1.5 0v14.5c0 .414.336.75.75.75h18.5a.75.75 0 000-1.5h-1.5V6a.75.75 0 00-1.14-.64l-6.88 4.188-3.045-2.682a.75.75 0 00-.921-.055L3.5 9.745V4.75zm0 6.816V18.5h14.75V7.335l-6.211 3.782a.75.75 0 01-.886-.078l-3.02-2.66L3.5 11.565z",
      fill: "currentColor"
    }
  ));
}
const ChartArea = React.forwardRef(IconChartArea);
function IconChartBar(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11 17.75A1.75 1.75 0 009.25 16h-4.5A1.75 1.75 0 003 17.75v1.5c0 .966.784 1.75 1.75 1.75h4.5A1.75 1.75 0 0011 19.25v-1.5zm6-6.5a1.75 1.75 0 00-1.75-1.75H4.75A1.75 1.75 0 003 11.25v1.5c0 .966.784 1.75 1.75 1.75h10.5A1.75 1.75 0 0017 12.75v-1.5zm4-6.5A1.75 1.75 0 0019.25 3H4.75A1.75 1.75 0 003 4.75v1.5C3 7.216 3.784 8 4.75 8h14.5A1.75 1.75 0 0021 6.25v-1.5zm-11.5 13v1.5a.25.25 0 01-.193.243l-.057.007h-4.5a.25.25 0 01-.243-.193L4.5 19.25v-1.5a.25.25 0 01.193-.243l.057-.007h4.5a.25.25 0 01.243.193l.007.057zm6-6.5v1.5a.25.25 0 01-.193.243L15.25 13H4.75a.25.25 0 01-.243-.193L4.5 12.75v-1.5a.25.25 0 01.193-.243L4.75 11h10.5a.25.25 0 01.243.193l.007.057zm4-6.5v1.5a.25.25 0 01-.193.243l-.057.007H4.75a.25.25 0 01-.243-.193L4.5 6.25v-1.5a.25.25 0 01.193-.243L4.75 4.5h14.5a.25.25 0 01.243.193l.007.057z",
      fill: "currentColor"
    }
  ));
}
const ChartBar = React.forwardRef(IconChartBar);
function IconChartLine(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.5 4.75a.75.75 0 00-1.5 0v14.5c0 .414.336.75.75.75h18.5a.75.75 0 000-1.5H3.5V4.75zm18.06 2.53a.75.75 0 10-1.06-1.06l-5.97 5.97-3.47-3.47a.75.75 0 00-1.06 0l-4.47 4.47a.75.75 0 001.061 1.06l3.94-3.94L14 13.78a.75.75 0 001.06 0l6.5-6.5z",
      fill: "currentColor"
    }
  ));
}
const ChartLine = React.forwardRef(IconChartLine);
function IconChartPie(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10.25 4.25A.75.75 0 0111 5v8h8a.75.75 0 01.743.648l.007.102c0 4.97-4.03 8.5-9 8.5a9 9 0 01-9-9c0-4.97 3.53-9 8.5-9zM9.5 5.787l-.209.024c-3.69.47-6.041 3.622-6.041 7.439a7.5 7.5 0 007.5 7.5c3.817 0 6.968-2.352 7.44-6.041l.022-.209H10.25a.75.75 0 01-.743-.648L9.5 13.75V5.787zm3.75-4.037a9 9 0 019 9 .75.75 0 01-.75.75h-8.25a.75.75 0 01-.75-.75V2.5a.75.75 0 01.75-.75zM14 3.287V10h6.712l-.023-.209a7.504 7.504 0 00-6.48-6.48L14 3.287z",
      fill: "currentColor"
    }
  ));
}
const ChartPie = React.forwardRef(IconChartPie);
function IconChartTable(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.5 4.5h15v3.75h-15V4.5zM3 9.75V4.5A1.5 1.5 0 014.5 3h15A1.5 1.5 0 0121 4.5v15a1.5 1.5 0 01-1.5 1.5h-15A1.5 1.5 0 013 19.5V9.75zM4.5 14V9.75h4V14h-4zm0 1.5v4h4v-4h-4zm5.5 4h4v-4h-4v4zm5.5 0h4v-4h-4v4zm4-5.5V9.75h-4V14h4zM10 9.75h4V14h-4V9.75z",
      fill: "currentColor"
    }
  ));
}
const ChartTable = React.forwardRef(IconChartTable);
function IconChatSolid(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M19.557 13.056c1.474.7 2.443 1.881 2.443 3.222 0 1.294-.903 2.44-2.292 3.147l.89 1.582a.556.556 0 01-.748.761l-.084-.055-2.059-1.647a7.87 7.87 0 01-1.263.1c-2.853 0-5.205-1.506-5.52-3.444 2.666-.007 5.071-.766 6.817-1.966a7.924 7.924 0 001.802-1.682l.014-.018zM10.889 3.5c4.91 0 8.889 2.736 8.889 6.111 0 3.309-3.825 6.004-8.601 6.108l-.426.003-5.406 4.324a.556.556 0 01-.832-.706l2.398-4.262C3.999 14.074 2 12.003 2 9.61 2 6.236 5.98 3.5 10.889 3.5z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const ChatSolid = React.forwardRef(IconChatSolid);
function IconChat(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M20.313 12.156c.59.664.937 1.466.937 2.344 0 1.01-.467 1.944-1.272 2.68l-.21.179.885 1.77c.174.348.174.753.01 1.096l-.068.125-.084.118c-.352.44-.948.585-1.501.347l-.127-.062-.129-.09-2.446-1.955-.233.021-.19.012-.385.009c-2.065 0-3.908-.798-4.923-2.035a13.97 13.97 0 002.216-.108c.728.397 1.667.643 2.707.643.209 0 .415-.01.619-.03l.303-.037.323-.047 2.059 1.649-.969-1.94.582-.36c.86-.533 1.333-1.252 1.333-1.985 0-.371-.122-.733-.343-1.065.3-.336.562-.69.781-1.06l.125-.219zM11 3.25c4.786 0 8.75 2.725 8.75 6.25 0 3.455-3.81 6.143-8.47 6.247l-.139.001-4.662 3.73a1.25 1.25 0 01-1.567-.004l-.1-.09-.09-.102a1.25 1.25 0 01-.174-1.27l.06-.124 1.737-3.087-.23-.106c-2.193-1.046-3.646-2.768-3.842-4.737l-.017-.228-.006-.23c0-3.525 3.964-6.25 8.75-6.25zm0 1.5c-4.05 0-7.25 2.2-7.25 4.75 0 1.679 1.397 3.263 3.66 4.119l.255.092.85.293-1.969 3.498 4.072-3.255.267.002.384-.002c3.922-.095 6.981-2.253 6.981-4.747 0-2.55-3.2-4.75-7.25-4.75z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Chat = React.forwardRef(IconChat);
function IconChevronDownDouble(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M6.47 6.47a.75.75 0 01.976-.073l.084.073L12 10.939l4.47-4.47a.75.75 0 01.976-.072l.084.073a.75.75 0 01.073.976l-.073.084-5 5a.75.75 0 01-.976.073l-.084-.073-5-5a.75.75 0 010-1.06zm0 5a.75.75 0 01.976-.073l.084.073L12 15.939l4.47-4.47a.75.75 0 01.976-.072l.084.073a.75.75 0 01.073.976l-.073.084-5 5a.75.75 0 01-.976.073l-.084-.073-5-5a.75.75 0 010-1.06z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const ChevronDownDouble = React.forwardRef(IconChevronDownDouble);
function IconChevronDownSolid(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M5.854 9.354l5.792 5.792a.5.5 0 00.708 0l5.792-5.792a.5.5 0 00-.353-.854H6.207a.5.5 0 00-.353.854z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const ChevronDownSolid = React.forwardRef(IconChevronDownSolid);
function IconChevronDown(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M6.47 10.03a.75.75 0 01.976-1.133l.084.073L12 13.439l4.47-4.47a.75.75 0 01.976-.072l.084.073a.75.75 0 01.073.976l-.073.084-5 5a.75.75 0 01-.976.073l-.084-.073-5-5z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const ChevronDown = React.forwardRef(IconChevronDown);
function IconChevronLeftDouble(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M17.53 6.47a.75.75 0 01.073.976l-.073.084L13.061 12l4.47 4.47a.75.75 0 01.072.976l-.073.084a.75.75 0 01-.976.073l-.084-.073-5-5a.75.75 0 01-.073-.976l.073-.084 5-5a.75.75 0 011.06 0zm-5 0a.75.75 0 01.073.976l-.073.084L8.061 12l4.47 4.47a.75.75 0 01.072.976l-.073.084a.75.75 0 01-.976.073l-.084-.073-5-5a.75.75 0 01-.073-.976l.073-.084 5-5a.75.75 0 011.06 0z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const ChevronLeftDouble = React.forwardRef(IconChevronLeftDouble);
function IconChevronLeftSolid(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.5 6.207a.5.5 0 00-.854-.353l-5.792 5.792a.5.5 0 000 .708l5.792 5.792a.5.5 0 00.854-.353V6.207z",
      fill: "currentColor"
    }
  ));
}
const ChevronLeftSolid = React.forwardRef(IconChevronLeftSolid);
function IconChevronLeft(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M13.97 6.47a.75.75 0 011.133.976l-.073.084L10.561 12l4.47 4.47a.75.75 0 01.072.976l-.073.084a.75.75 0 01-.976.073l-.084-.073-5-5a.75.75 0 01-.073-.976l.073-.084 5-5z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const ChevronLeft = React.forwardRef(IconChevronLeft);
function IconChevronRightDouble(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M11.47 6.47a.75.75 0 01.976-.073l.084.073 5 5 .073.084a.75.75 0 01.007.882l-.08.094-5 5-.084.073a.75.75 0 01-.882.007l-.094-.08-.073-.084a.75.75 0 01-.007-.882l.08-.094L15.939 12l-4.47-4.47-.072-.084a.75.75 0 01.073-.976zm-5 0a.75.75 0 01.976-.073l.084.073 5 5 .073.084a.75.75 0 01.007.882l-.08.094-5 5-.084.073a.75.75 0 01-.882.007l-.094-.08-.073-.084a.75.75 0 01-.007-.882l.08-.094L10.939 12l-4.47-4.47-.072-.084a.75.75 0 01.073-.976z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const ChevronRightDouble = React.forwardRef(IconChevronRightDouble);
function IconChevronRightSolid(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.5 17.793a.5.5 0 00.854.353l5.792-5.792a.5.5 0 000-.708L9.354 5.854a.5.5 0 00-.854.353v11.586z",
      fill: "currentColor"
    }
  ));
}
const ChevronRightSolid = React.forwardRef(IconChevronRightSolid);
function IconChevronRight(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10.03 6.47a.75.75 0 00-1.133.976l.073.084L13.439 12l-4.47 4.47a.75.75 0 00-.072.976l.073.084a.75.75 0 00.976.073l.084-.073 5-5a.75.75 0 00.073-.976l-.073-.084-5-5z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const ChevronRight = React.forwardRef(IconChevronRight);
function IconChevronUpDouble(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M6.47 12.53a.75.75 0 01-.073-.976l.073-.084 5-5 .084-.073a.75.75 0 01.882-.007l.094.08 5 5 .073.084a.75.75 0 01.007.882l-.08.094-.084.073a.75.75 0 01-.882.007l-.094-.08L12 8.061l-4.47 4.47-.084.072a.75.75 0 01-.976-.073zm0 5a.75.75 0 01-.073-.976l.073-.084 5-5 .084-.073a.75.75 0 01.882-.007l.094.08 5 5 .073.084a.75.75 0 01.007.882l-.08.094-.084.073a.75.75 0 01-.882.007l-.094-.08L12 13.061l-4.47 4.47-.084.072a.75.75 0 01-.976-.073z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const ChevronUpDouble = React.forwardRef(IconChevronUpDouble);
function IconChevronUpSolid(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M5.854 14.646l5.792-5.792a.5.5 0 01.708 0l5.792 5.792a.5.5 0 01-.353.854H6.207a.5.5 0 01-.353-.854z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const ChevronUpSolid = React.forwardRef(IconChevronUpSolid);
function IconChevronUp(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M17.53 13.97a.75.75 0 01-.976 1.133l-.084-.073L12 10.561l-4.47 4.47a.75.75 0 01-.976.072l-.084-.073a.75.75 0 01-.073-.976l.073-.084 5-5a.75.75 0 01.976-.073l.084.073 5 5z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const ChevronUp = React.forwardRef(IconChevronUp);
function IconCircleClose(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 1.5a8.5 8.5 0 100 17 8.5 8.5 0 000-17zM8.641 8.641a.75.75 0 01.984-.067l.077.067L12 10.94l2.298-2.298a.75.75 0 011.128.984l-.067.077L13.06 12l2.298 2.298a.75.75 0 01-.984 1.128l-.077-.067L12 13.06l-2.298 2.298a.75.75 0 01-1.128-.984l.067-.077L10.94 12 8.641 9.702a.75.75 0 010-1.06z"
    }
  ));
}
const CircleClose = React.forwardRef(IconCircleClose);
function IconCircleInformation(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 1.5a8.5 8.5 0 100 17 8.5 8.5 0 000-17zm-.267 5.753a1 1 0 10-.001-2.001 1 1 0 00.001 2.001zM14 16.754a.75.75 0 000-1.502h-1.267V11.5a.752.752 0 00-.75-.751H10a.75.75 0 000 1.502h1.233v3H10a.75.75 0 000 1.503h4z",
      fill: "currentColor"
    }
  ));
}
const CircleInformation = React.forwardRef(IconCircleInformation);
function IconCircleMinus(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 1.5a8.5 8.5 0 100 17 8.5 8.5 0 000-17zm4 7.75c.934 0 1.027 1.366.102 1.493-8 0 0 0-8.102.007-.934 0-1.027-1.366-.102-1.493z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const CircleMinus = React.forwardRef(IconCircleMinus);
function IconCirclePlus(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 1.5a8.5 8.5 0 100 17 8.5 8.5 0 000-17zm0 3.75a.75.75 0 01.743.648L12.75 8v3.25H16a.75.75 0 01.102 1.493L16 12.75h-3.25V16a.75.75 0 01-1.493.102L11.25 16v-3.25H8a.75.75 0 01-.102-1.493L8 11.25h3.25V8a.75.75 0 01.75-.75z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const CirclePlus = React.forwardRef(IconCirclePlus);
function IconCircleQuestionmark(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 1.5a8.5 8.5 0 100 17 8.5 8.5 0 000-17zm.58 10.15a.71.71 0 00.226-.543v-1.272a.306.306 0 01.045-.143.522.522 0 01.136-.133 3.91 3.91 0 01.285-.18l.028-.016c.112-.066.242-.143.387-.237.706-.454 1.156-1.012 1.156-1.838 0-.673-.37-1.19-.887-1.53-.513-.336-1.183-.508-1.845-.508-.552 0-1.234.096-1.79.317a2.441 2.441 0 00-.574.315c-.09.069-.174.146-.245.232a1.15 1.15 0 00-.154.238 1.474 1.474 0 00-.148.625c0 .075.01.118.02.167.036.159.12.3.254.401a.77.77 0 00.47.147.768.768 0 00.745-.517l.004-.013c.053-.17.226-.306.517-.4.282-.09.611-.116.852-.116.267 0 .575.078.809.213.241.139.345.298.345.44 0 .188-.051.32-.152.444-.11.136-.285.27-.55.444h-.002l-.136.091h-.001c-.232.153-.49.322-.695.513-.252.234-.467.537-.467.938v1.38c0 .226.087.421.248.556.155.13.357.185.56.185.21 0 .41-.064.558-.2zm-.559 3.1c.504 0 .924-.4.924-.904 0-.512-.423-.9-.924-.9a.908.908 0 00-.92.9c0 .504.42.904.92.904z",
      fill: "currentColor"
    }
  ));
}
const CircleQuestionmark = React.forwardRef(IconCircleQuestionmark);
function IconCircleTick(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 1.5a8.5 8.5 0 100 17 8.5 8.5 0 000-17zm4.403 3.867a.75.75 0 01.282.938l-.052.098-5.091 8a.75.75 0 01-1.145.145l-.074-.08-2.909-3.636a.75.75 0 011.096-1.018l.076.081 2.253 2.817 4.528-7.115a.75.75 0 011.036-.23z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const CircleTick = React.forwardRef(IconCircleTick);
function IconCircleWarning(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 1.5a8.5 8.5 0 100 17 8.5 8.5 0 000-17zm0 3.75a.97.97 0 00-.974.989L11.2 12.5c.01.417.352.749.771.749a.768.768 0 00.77-.74l.23-4.26a.97.97 0 00-.97-1zm0 9.5a1 1 0 100-2 1 1 0 000 2z",
      fill: "currentColor"
    }
  ));
}
const CircleWarning = React.forwardRef(IconCircleWarning);
function IconClampOpen(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M11.03 12.97a.75.75 0 01.073.976l-.073.084-5.72 5.72H8.5a.75.75 0 01.743.648l.007.102a.75.75 0 01-.648.743l-.102.007-5.051-.002-.12-.018-.068-.019-.06-.023-.07-.035-.082-.054-.08-.07a.749.749 0 01-.096-.118l-.05-.09-.04-.103a.737.737 0 01-.026-.116L2.75 20.5v-5a.75.75 0 011.493-.102l.007.102-.001 3.189 5.72-5.72a.75.75 0 011.061 0zm4.368-10.213l.102-.007h5l.07.003.101.017.068.019.06.023.07.035.082.054.08.07a.749.749 0 01.096.118l.05.09.04.103c.012.037.02.076.026.116l.007.102v5a.75.75 0 01-1.493.102L19.75 8.5V5.31l-5.72 5.72a.75.75 0 01-1.133-.976l.073-.084 5.718-5.72H15.5a.75.75 0 01-.743-.648L14.75 3.5a.75.75 0 01.648-.743z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const ClampOpen = React.forwardRef(IconClampOpen);
function IconClamp(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M5.398 12.757l.102-.007h5l.07.003.101.017.068.019.06.023.07.035.082.054.08.07a.749.749 0 01.096.118l.05.09.04.103c.012.037.02.076.026.116l.007.102v5a.75.75 0 01-1.493.102L9.75 18.5v-3.19l-5.72 5.72a.75.75 0 01-1.133-.976l.073-.084 5.718-5.72H5.5a.75.75 0 01-.743-.648L4.75 13.5a.75.75 0 01.648-.743zM21.03 2.97a.75.75 0 01.073.976l-.073.084-5.72 5.72h3.19a.75.75 0 01.743.648l.007.102a.75.75 0 01-.648.743l-.102.007-5.051-.002-.12-.018-.068-.019-.06-.023-.07-.035-.082-.054-.08-.07a.749.749 0 01-.096-.118l-.05-.09-.04-.103a.737.737 0 01-.026-.116l-.007-.102v-5a.75.75 0 011.493-.102l.007.102v3.188l5.72-5.718a.75.75 0 011.06 0z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Clamp = React.forwardRef(IconClamp);
function IconClose(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M16.554 6.397a.75.75 0 011.049 1.05l-.073.083L13.061 12l4.47 4.47a.75.75 0 01-.977 1.133l-.084-.073L12 13.061l-4.47 4.47-.084.072a.75.75 0 01-1.049-1.05l.073-.083L10.939 12l-4.47-4.47a.75.75 0 01.977-1.133l.084.073L12 10.939l4.47-4.47.084-.072z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Close$3 = React.forwardRef(IconClose);
function IconColumnFreeze(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14 4.5h-4v15h4v-15zm1.5 0v15h3.75a.25.25 0 00.25-.25V4.75a.25.25 0 00-.25-.25H15.5zM4.75 3A1.75 1.75 0 003 4.75v14.5c0 .966.784 1.75 1.75 1.75h14.5A1.75 1.75 0 0021 19.25V4.75A1.75 1.75 0 0019.25 3H4.75z",
      fill: "currentColor"
    }
  ));
}
const ColumnFreeze = React.forwardRef(IconColumnFreeze);
function IconColumnUnfreeze(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.6 4.5H14v15h-2.378a2.26 2.26 0 010 1.5h7.628A1.75 1.75 0 0021 19.25V4.75A1.75 1.75 0 0019.25 3H4.75A1.75 1.75 0 003 4.75v6.75c.576 0 1.152.22 1.591.659l1.659 1.659 1.659-1.659a2.244 2.244 0 011.691-.657V4.5zm5.9 15v-15h3.75a.25.25 0 01.25.25v14.5a.25.25 0 01-.25.25H15.5zM2.47 20.78a.75.75 0 010-1.06L5.19 17l-2.72-2.72a.75.75 0 111.06-1.06l2.72 2.72 2.72-2.72a.75.75 0 111.06 1.06L7.31 17l2.72 2.72a.75.75 0 11-1.06 1.06l-2.72-2.72-2.72 2.72a.75.75 0 01-1.06 0z",
      fill: "currentColor"
    }
  ));
}
const ColumnUnfreeze = React.forwardRef(IconColumnUnfreeze);
function IconColumns(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14 4.5h-4v15h4v-15zm1.5 0v15h3.75a.25.25 0 00.25-.25V4.75a.25.25 0 00-.25-.25H15.5zm-10.75 0H8.5v15H4.75a.25.25 0 01-.25-.25V4.75a.25.25 0 01.25-.25zm0-1.5A1.75 1.75 0 003 4.75v14.5c0 .966.784 1.75 1.75 1.75h14.5A1.75 1.75 0 0021 19.25V4.75A1.75 1.75 0 0019.25 3H4.75z",
      fill: "currentColor"
    }
  ));
}
const Columns = React.forwardRef(IconColumns);
function IconConnectionEnable(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M19 9a3 3 0 11-2.877 3.854H7.877A3.001 3.001 0 012 12a3 3 0 015.93-.647h8.14A3.001 3.001 0 0119 9zM5 10.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm14 0a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
      fill: "currentColor"
    }
  ));
}
const ConnectionEnable = React.forwardRef(IconConnectionEnable);
function IconConnectionRevoke(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M16.66 4.174a.75.75 0 01.32.933l-.045.091-8.298 14.373a.75.75 0 01-1.344-.659l.045-.091 8.298-14.373a.75.75 0 011.025-.274zM5 9a3.001 3.001 0 012.935 2.374.685.685 0 01.169-.02h1.814l-.866 1.5h-.948a.75.75 0 01-.22-.033A2.998 2.998 0 012 12a3 3 0 013-3zm14 0a3 3 0 11-2.877 3.854h-1.875l.866-1.5.956-.001A3.001 3.001 0 0119 9zM5 10.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm14 0a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
      fill: "currentColor"
    }
  ));
}
const ConnectionRevoke = React.forwardRef(IconConnectionRevoke);
function IconContacts(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M18.25 2c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0118.25 22H5.75A1.75 1.75 0 014 20.25V18h-.5a.75.75 0 110-1.5H4v-3.75h-.5a.75.75 0 110-1.5H4V8h-.5a.75.75 0 010-1.5H4V3.75C4 2.784 4.784 2 5.75 2h12.5zm0 1.5H5.75a.25.25 0 00-.243.193L5.5 3.75V6.5H6A.75.75 0 016 8h-.5v3.25H6a.75.75 0 110 1.5h-.5v3.75H6A.75.75 0 116 18h-.5v2.25a.25.25 0 00.193.243l.057.007h12.5a.25.25 0 00.243-.193l.007-.057V3.75a.25.25 0 00-.193-.243L18.25 3.5zM11.866 12c2.434 0 3.88 1.316 4.34 3.95A1.75 1.75 0 0114.482 18H9.25a1.75 1.75 0 01-1.724-2.05c.46-2.634 1.906-3.95 4.34-3.95zm0-5.5c1.104 0 2 1.12 2 2.5s-.896 2.5-2 2.5c-1.105 0-2-1.12-2-2.5s.895-2.5 2-2.5z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Contacts = React.forwardRef(IconContacts);
function IconCopy(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M6 5v1.5h-.25a.25.25 0 00-.243.193L5.5 6.75v13.5a.25.25 0 00.193.243l.057.007h9.5a.25.25 0 00.243-.193l.007-.057V20H17v.25A1.75 1.75 0 0115.25 22h-9.5A1.75 1.75 0 014 20.25V6.75C4 5.784 4.784 5 5.75 5H6zm7.586-3a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707v8.836A1.75 1.75 0 0118.25 19h-9.5A1.75 1.75 0 017 17.25V3.75C7 2.784 7.784 2 8.75 2h4.836zM13 3.5H8.75a.25.25 0 00-.243.193L8.5 3.75v13.5a.25.25 0 00.193.243l.057.007h9.5a.25.25 0 00.243-.193l.007-.057V9h-3.75a1.75 1.75 0 01-1.744-1.606L13 7.25V3.5zm1.5 1.121V7.25a.25.25 0 00.193.243l.057.007h2.629L14.5 4.621z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Copy = React.forwardRef(IconCopy);
function IconCourses(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M11.441 3.441a1.25 1.25 0 01.983-.058l.135.058 9.598 4.799a.85.85 0 01.464.859l-.001 6.151a.75.75 0 11-1.5 0v-4.971L19 11.339V17.5c0 1.657-3.134 3-7 3-3.772 0-6.847-1.278-6.994-2.88L5 17.5v-6.162L1.842 9.76a.85.85 0 01-.421-1.042l.041-.098a.85.85 0 01.286-.325l.094-.055 9.598-4.799zm-4.942 8.647v5.395c.009.095.385.448 1.217.791C8.82 18.73 10.351 19 12 19c1.689 0 3.253-.284 4.359-.757.472-.203.822-.425 1.023-.629l.11-.117c.003-.003.005-.004.006-.003l.002.006v-5.411l-4.941 2.47a1.25 1.25 0 01-.983.058l-.135-.058-4.942-2.471zM12 4.838L3.677 8.999l8.322 4.162 8.323-4.162L12 4.838z",
      fill: "currentColor"
    }
  ));
}
const Courses = React.forwardRef(IconCourses);
function IconCredit(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M6.499 15l.001 5.25a.25.25 0 00.193.243l.057.007h9.5a.25.25 0 00.243-.193l.007-.057V20H18v.25A1.75 1.75 0 0116.25 22h-9.5A1.75 1.75 0 015 20.25L4.999 15h1.5zm8.087-13a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707v8.836A1.75 1.75 0 0119.25 19h-9.5A1.75 1.75 0 018 17.25L7.999 15h1.5l.001 2.25a.25.25 0 00.193.243l.057.007h9.5a.25.25 0 00.243-.193l.007-.057L19.499 9H15.75a1.75 1.75 0 01-1.744-1.606L14 7.25l-.001-3.75H9.75a.25.25 0 00-.243.193L9.5 3.75 9.499 5h-1.5L8 3.75C8 2.784 8.784 2 9.75 2h4.836zM4.392 8.956a.5.5 0 01.55-.147l.082.038 2.143 1.237.074.052a.5.5 0 01.147.55l-.038.081-.052.074a.5.5 0 01-.55.147l-.081-.038-.878-.505a2.5 2.5 0 004 1.525.75.75 0 11.925 1.181 4.002 4.002 0 01-6.343-2.173l-.402.695-.052.074a.5.5 0 01-.852-.492l.038-.082L4.341 9.03l.051-.074zM8.25 6a4.001 4.001 0 013.92 3.197l.358-.62a.5.5 0 01.6-.221l.083.038a.5.5 0 01.22.601l-.037.082-1.238 2.143a.5.5 0 01-.6.221l-.083-.038-2.143-1.237a.5.5 0 01.418-.904l.082.038.914.528A2.5 2.5 0 006.711 8.03a.75.75 0 11-.925-1.181A3.985 3.985 0 018.25 6zm7.249-1.38l.001 2.63a.25.25 0 00.193.243l.057.007h2.629l-2.88-2.88z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Credit = React.forwardRef(IconCredit);
function IconDeletePermanently(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M12 2a4.5 4.5 0 014.472 4h-1.514a3 3 0 00-5.917 0H20.25a.75.75 0 110 1.5h-.75V18a4 4 0 01-4 4h-7a4 4 0 01-4-4V7.5h-.75a.75.75 0 010-1.5h3.777A4.5 4.5 0 0112 2zm6 5.5H6V18a2.5 2.5 0 002.336 2.495l.164.005h7a2.5 2.5 0 002.495-2.336L18 18V7.5zm-3.946 3.397a.75.75 0 011.049 1.05l-.073.083L13.061 14l1.97 1.97a.75.75 0 01-.977 1.133l-.084-.073L12 15.061l-1.97 1.97-.084.072a.75.75 0 01-1.049-1.05l.073-.083L10.939 14l-1.97-1.97a.75.75 0 01.977-1.133l.084.073L12 12.939l1.97-1.97.084-.072z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const DeletePermanently = React.forwardRef(IconDeletePermanently);
function IconDelete(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M12 2a4.5 4.5 0 014.472 4h3.778a.75.75 0 110 1.5h-.75V18a4 4 0 01-4 4h-7a4 4 0 01-4-4V7.5h-.75a.75.75 0 010-1.5h3.777A4.5 4.5 0 0112 2zm6 5.5H6V18a2.5 2.5 0 002.336 2.495l.164.005h7a2.5 2.5 0 002.495-2.336L18 18V7.5zm-8.25 2a.75.75 0 01.75.75v7.5a.75.75 0 11-1.5 0v-7.5a.75.75 0 01.75-.75zm4.5 0a.75.75 0 01.75.75v7.5a.75.75 0 11-1.5 0v-7.5a.75.75 0 01.75-.75zM12 3.5A3 3 0 009.041 6h5.917A3 3 0 0012 3.5z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Delete = React.forwardRef(IconDelete);
function IconDepecriate(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M16.25 2a.75.75 0 01.75.75V3h2.25c.966 0 1.75.784 1.75 1.75v14.5A1.75 1.75 0 0119.25 21H17v-1.5h2.25a.25.25 0 00.243-.193l.007-.057V8h-15v11.25a.25.25 0 00.193.243l.057.007H7V21H4.75A1.75 1.75 0 013 19.25V4.75C3 3.784 3.784 3 4.75 3H7v-.25a.75.75 0 011.5 0V3h7v-.25a.75.75 0 01.75-.75zM12 11.25a.75.75 0 01.743.648l.007.102v6.439l1.72-1.72a.75.75 0 01.976-.072l.084.073a.75.75 0 01.073.976l-.073.084-3 3a.75.75 0 01-.976.073l-.084-.073-3-3a.75.75 0 01.976-1.133l.084.073 1.72 1.719V12a.75.75 0 01.75-.75zM7 4.5H4.75a.25.25 0 00-.243.193L4.5 4.75V6.5h15V4.75a.25.25 0 00-.193-.243L19.25 4.5H17v.25a.75.75 0 11-1.5 0V4.5h-7v.25a.75.75 0 01-1.5 0V4.5z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Depecriate = React.forwardRef(IconDepecriate);
function IconDeveloper(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M14.303 2.787a1.25 1.25 0 01.934 1.39l-.024.126-4 16a1.25 1.25 0 01-2.45-.48l.024-.126 4-16a1.25 1.25 0 011.516-.91zM7.05 5.04a1.25 1.25 0 01.242 1.65l-.082.11L2.877 12l4.333 5.2a1.25 1.25 0 01-.06 1.667l-.1.093a1.25 1.25 0 01-1.667-.06l-.093-.1-5-6a1.25 1.25 0 01-.083-1.49l.083-.11 5-6a1.25 1.25 0 011.76-.16zm9.9 0a1.25 1.25 0 011.667.06l.093.1 5 6 .083.11a1.25 1.25 0 010 1.38l-.083.11-5 6-.093.1a1.25 1.25 0 01-1.558.142l-.11-.082-.1-.093a1.25 1.25 0 01-.14-1.558l.08-.11L21.124 12 16.79 6.8l-.082-.11a1.25 1.25 0 01.242-1.65z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Developer = React.forwardRef(IconDeveloper);
function IconDistributionTemplate(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M20.5 17a.5.5 0 01.5.5v4a.5.5 0 01-.5.5h-4a.5.5 0 01-.5-.5v-4a.5.5 0 01.5-.5h4zm-1 1.5h-2v2h2v-2zm-5-14.75a.75.75 0 01.102 1.493l-.102.007H13a.25.25 0 00-.243.193l-.007.057v5.75h1.75a.75.75 0 01.102 1.493l-.102.007h-1.75v5.75a.25.25 0 00.193.243l.057.007h1.5a.75.75 0 01.102 1.493l-.102.007H13a1.75 1.75 0 01-1.744-1.606l-.006-.144v-5.75H9.5a.75.75 0 01-.102-1.493l.102-.007h1.75V5.5a1.75 1.75 0 011.606-1.744L13 3.75h1.5zm6 5.75a.5.5 0 01.5.5v4a.5.5 0 01-.5.5h-4a.5.5 0 01-.5-.5v-4a.5.5 0 01.5-.5h4zm-13 0a.5.5 0 01.5.5v4a.5.5 0 01-.5.5h-4A.5.5 0 013 14v-4a.5.5 0 01.5-.5h4zm12 1.5h-2v2h2v-2zm-13 0h-2v2h2v-2zm14-9a.5.5 0 01.5.5v4a.5.5 0 01-.5.5h-4a.5.5 0 01-.5-.5v-4a.5.5 0 01.5-.5h4zm-1 1.5h-2v2h2v-2z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const DistributionTemplate = React.forwardRef(IconDistributionTemplate);
function IconDocumentApprove(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M13.586 2a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V14h-1.5V9h-3.75a1.75 1.75 0 01-1.744-1.606L13 7.25V3.5H5.75a.25.25 0 00-.243.193L5.5 3.75v16.5a.25.25 0 00.193.243l.057.007H10V22H5.75A1.75 1.75 0 014 20.25V3.75C4 2.784 4.784 2 5.75 2h7.836zm6.194 13.72a.75.75 0 01.073.976l-.073.084-5 5a.75.75 0 01-.976.073l-.084-.073-3-3a.75.75 0 01.976-1.133l.084.073 2.47 2.469 4.47-4.47a.75.75 0 011.06 0zm-2.4-8.22L14.5 4.621V7.25a.25.25 0 00.193.243l.057.007h2.63z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const DocumentApprove = React.forwardRef(IconDocumentApprove);
function IconDocumentCreateEntry(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M13.586 2a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V13h-1.5V9h-3.75a1.75 1.75 0 01-1.744-1.606L13 7.25V3.5H5.75a.25.25 0 00-.243.193L5.5 3.75v16.5a.25.25 0 00.193.243l.057.007H12V22H5.75A1.75 1.75 0 014 20.25V3.75C4 2.784 4.784 2 5.75 2h7.836zm2.164 11.5a.75.75 0 01.743.648l.007.102V17h2.75a.75.75 0 01.102 1.493l-.102.007H16.5v2.75a.75.75 0 01-1.493.102L15 21.25V18.5h-2.75a.75.75 0 01-.102-1.493L12.25 17H15v-2.75a.75.75 0 01.75-.75zM14.5 4.621V7.25a.25.25 0 00.193.243l.057.007h2.63L14.5 4.621z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const DocumentCreateEntry = React.forwardRef(IconDocumentCreateEntry);
function IconDocumentCut(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M11.95 11.146l2.219 3.843.868.234a2.5 2.5 0 111.826 2.042l-1.633-.438.845 1.464a2.5 2.5 0 11-2.444-1.235l-.45-.778-4.287-1.148a.75.75 0 11.388-1.45l2.839.761-1.47-2.545a.75.75 0 011.3-.75zM13.586 2a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V11h-1.5V9h-3.75a1.75 1.75 0 01-1.744-1.606L13 7.25V3.5H5.75a.25.25 0 00-.243.193L5.5 3.75v16.5a.25.25 0 00.193.243l.057.007H10V22H5.75A1.75 1.75 0 014 20.25V3.75C4 2.784 4.784 2 5.75 2h7.836zm-.176 16.675a1 1 0 101 1.732 1 1 0 00-1-1.732zm3.134-4.084a1 1 0 101.932.518 1 1 0 00-1.932-.518zM14.5 4.621V7.25a.25.25 0 00.193.243l.057.007h2.63L14.5 4.621z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const DocumentCut = React.forwardRef(IconDocumentCut);
function IconDocumentError(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M13.586 2a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V20.25A1.75 1.75 0 0118.25 22H5.75A1.75 1.75 0 014 20.25V3.75C4 2.784 4.784 2 5.75 2h7.836zM13 3.5H5.75a.25.25 0 00-.243.193L5.5 3.75v16.5a.25.25 0 00.193.243l.057.007h12.5a.25.25 0 00.243-.193l.007-.057V9h-3.75a1.75 1.75 0 01-1.744-1.606L13 7.25V3.5zm-1 12.91c.516 0 .935.333.935.849 0 .515-.42.848-.935.848-.516 0-.94-.333-.94-.848 0-.516.424-.849.94-.849zm0-5.978c.509 0 .883.352.917.807l.001.106-.15 3.62a.754.754 0 01-.768.736.757.757 0 01-.768-.632l-.01-.104-.135-3.62c-.022-.505.37-.913.913-.913zm2.5-5.811V7.25a.25.25 0 00.193.243l.057.007h2.63L14.5 4.621z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const DocumentError = React.forwardRef(IconDocumentError);
function IconDocumentIsolatePage(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M13.586 2a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707v4.336h-1.5V9h-3.75a1.75 1.75 0 01-1.744-1.606L13 7.25V3.5H5.75a.25.25 0 00-.243.193L5.5 3.75v16.5a.25.25 0 00.193.243l.057.007h5V22h-5A1.75 1.75 0 014 20.25V3.75C4 2.784 4.784 2 5.75 2h7.836zm5.664 12.25a.75.75 0 01.743.648L20 15v4.5a.75.75 0 01-1.493.102L18.5 19.5v-2.69l-4.97 4.97a.75.75 0 01-1.133-.976l.073-.084 4.968-4.97H14.75a.75.75 0 01-.743-.648L14 15a.75.75 0 01.648-.743l.102-.007h4.5zM14.5 4.621V7.25a.25.25 0 00.193.243l.057.007h2.63L14.5 4.621z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const DocumentIsolatePage = React.forwardRef(IconDocumentIsolatePage);
function IconDocumentMerge(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M16.586 2a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707v8.836A1.75 1.75 0 0119.25 17H15v3.25A1.75 1.75 0 0113.25 22h-8.5A1.75 1.75 0 013 20.25V8.75C3 7.784 3.784 7 4.75 7H9V3.75C9 2.784 9.784 2 10.75 2h5.836zM15.5 3.499l-4.75.001a.25.25 0 00-.243.193l-.007.057V7h1v1.5h-1V10H9V8.5H4.75a.25.25 0 00-.243.193L4.5 8.75v11.5a.25.25 0 00.193.243l.057.007h8.5a.25.25 0 00.243-.193l.007-.057V17h-1v-1.5h1V14H15v1.5h4.25a.25.25 0 00.243-.193l.007-.057V7.5h-2.25a1.75 1.75 0 01-1.744-1.606L15.5 5.75V3.499zM10.5 14v1.25a.25.25 0 00.193.243l.057.007h.75V17h-.75A1.75 1.75 0 019 15.25V14h1.5zm4.5-3v2h-1.5v-2H15zm-4.5 0v2H9v-2h1.5zm2-4h.75c.966 0 1.75.784 1.75 1.75V10h-1.5V8.75a.25.25 0 00-.193-.243L13.25 8.5h-.75V7zM17 4.12v1.63a.25.25 0 00.193.243L17.25 6h1.631L17 4.12z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const DocumentMerge = React.forwardRef(IconDocumentMerge);
function IconDocumentMove(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M13.586 2a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V20.25A1.75 1.75 0 0118.25 22H5.75A1.75 1.75 0 014 20.25V12h1.5v8.25a.25.25 0 00.193.243l.057.007h12.5a.25.25 0 00.243-.193l.007-.057V9h-3.75a1.75 1.75 0 01-1.744-1.606L13 7.25V3.5h-2V2h2.586zM4.433 7.25a.5.5 0 01-.717.661l-.07-.057-1-1-.057-.07a.5.5 0 010-.568l.057-.07 1-1 .07-.057a.5.5 0 01.568 0l.07.057.057.07a.5.5 0 01.022.535L6.25 5.75V3.933a.5.5 0 01-.534-.022l-.07-.057a.5.5 0 01-.057-.638l.057-.07 1-1 .07-.057a.5.5 0 01.568 0l.07.057 1 1 .057.07a.5.5 0 010 .568l-.057.07-.07.057a.5.5 0 01-.534.022V5.75h1.817a.5.5 0 01.022-.534l.057-.07a.5.5 0 01.638-.057l.07.057 1 1a.5.5 0 01.057.638l-.057.07-1 1a.5.5 0 01-.787-.604H7.75v1.817a.5.5 0 01.534.022l.07.057a.5.5 0 01.057.638l-.057.07-1 1a.5.5 0 01-.638.057l-.07-.057-1-1a.5.5 0 01.605-.787L6.25 7.25H4.433zM14.5 4.621V7.25a.25.25 0 00.193.243l.057.007h2.63L14.5 4.621z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const DocumentMove = React.forwardRef(IconDocumentMove);
function IconDocumentPreview(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M13.586 2a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V12h-1.5V9h-3.75a1.75 1.75 0 01-1.744-1.606L13 7.25V3.5H5.75a.25.25 0 00-.243.193L5.5 3.75v16.5a.25.25 0 00.193.243l.057.007H10V22H5.75A1.75 1.75 0 014 20.25V3.75C4 2.784 4.784 2 5.75 2h7.836zm.164 10.75a3 3 0 100 6 3 3 0 000-6zm.75-8.129V7.25a.25.25 0 00.193.243l.057.007h2.63L14.5 4.621zm-.75 15.629a4.5 4.5 0 113.632-1.842l.036-.05 2.362 2.362a.75.75 0 01-.976 1.133l-.084-.073-2.363-2.362-.112.077a4.479 4.479 0 01-2.495.755z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const DocumentPreview = React.forwardRef(IconDocumentPreview);
function IconDocumentReceived(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M13.586 2a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V12.5h-1.5V9h-3.75a1.75 1.75 0 01-1.744-1.606L13 7.25V3.5H5.75a.25.25 0 00-.243.193L5.5 3.75v16.5a.25.25 0 00.193.243l.057.007h12.5a.25.25 0 00.243-.193l.007-.057V17H20v3.25A1.75 1.75 0 0118.25 22H5.75A1.75 1.75 0 014 20.25V3.75C4 2.784 4.784 2 5.75 2h7.836zm-.032 9.147a.75.75 0 01.882-.007l.094.08.073.084a.75.75 0 01.007.882l-.08.094L12.811 14h6.439l.102.007a.75.75 0 010 1.486l-.102.007h-6.439l1.72 1.72.072.084a.75.75 0 01-1.05 1.049l-.083-.073-3-3-.073-.084a.75.75 0 01-.007-.882l.08-.094 3-3 .084-.073zm.946-6.526V7.25a.25.25 0 00.193.243l.057.007h2.63L14.5 4.621z",
      fill: "currentColor"
    }
  ));
}
const DocumentReceived = React.forwardRef(IconDocumentReceived);
function IconDocumentRejectedRequest(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M13.586 2a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V14h-1.5V9h-3.75a1.75 1.75 0 01-1.744-1.606L13 7.25V3.5H5.75a.25.25 0 00-.243.193L5.5 3.75v16.5a.25.25 0 00.193.243l.057.007H12V22H5.75A1.75 1.75 0 014 20.25V3.75C4 2.784 4.784 2 5.75 2h7.836zm5.218 13.647a.75.75 0 011.049 1.05l-.073.083-1.969 1.97 1.97 1.97a.75.75 0 01-.977 1.133l-.084-.073-1.97-1.969-1.97 1.97-.084.072a.75.75 0 01-1.049-1.05l.073-.083 1.969-1.97-1.97-1.97a.75.75 0 01.977-1.133l.084.073 1.97 1.969 1.97-1.97.084-.072zM14.5 4.621V7.25a.25.25 0 00.193.243l.057.007h2.63L14.5 4.621z",
      fill: "currentColor"
    }
  ));
}
const DocumentRejectedRequest = React.forwardRef(IconDocumentRejectedRequest);
function IconDocumentSignedSolid(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M13 2v5.25l.006.144a1.75 1.75 0 001.593 1.6L14.75 9H20v11.25A1.75 1.75 0 0118.25 22H5.75A1.75 1.75 0 014 20.25V3.75C4 2.784 4.784 2 5.75 2H13zm-3 7.75c-1.572 0-2.858 1.745-3.337 3.877l-.048.23-.039.217c-.138.832-.124 1.608.046 2.26l.07.238.055.148-.191.101c-.33.166-.672.305-1.025.413a.75.75 0 00.339 1.457l.1-.023.281-.092c.35-.122.691-.268 1.02-.435l.325-.174.098-.059.02.014c.302.18.66.293 1.074.32L9 18.25l.255-.004c1.076-.038 1.983-.315 2.706-.82l.193-.145.124-.104.014.052c.044.14.098.262.164.369l.069.102.086.107c.579.665 1.275.432 2.018-.32l.117-.122.102-.115.021.104c.043.2.09.356.163.512.209.456.598.755 1.132.708.582-.052 1.196-.55 2.042-1.612l.162-.206.32-.425.17-.23a.75.75 0 00-1.144-.965l-.071.085-.293.396-.28.362-.251.308-.22.256-.187.205-.11.112-.082-.493-.042-.199-.024-.09c-.083-.294-.201-.52-.436-.692-.598-.437-1.122-.163-1.695.514l-.258.312-.107.118-.007-.214a12.73 12.73 0 01.094-1.533c.1-.89-1.135-1.152-1.438-.372l-.033.103-.057.203c-.397 1.321-1.216 2.03-2.562 2.195l-.217.022-.176.009.199-.19a8.876 8.876 0 001.813-2.556c1.013-2.18.695-4.247-1.274-4.247zm0 1.5c.406 0 .531.695-.005 1.934l-.081.181-.116.237a7.434 7.434 0 01-1.401 1.893l-.25.236-.105.089-.032-.177c-.06-.406-.037-.911.077-1.5C8.402 12.53 9.306 11.25 10 11.25zm4.5-4V2L20 7.5h-5.25l-.057-.007a.25.25 0 01-.184-.175L14.5 7.25z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const DocumentSignedSolid = React.forwardRef(IconDocumentSignedSolid);
function IconDocumentSigned(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.293 2.293A1 1 0 0013.586 2H5.75A1.75 1.75 0 004 3.75v16.5c0 .966.784 1.75 1.75 1.75h12.5A1.75 1.75 0 0020 20.25V8.414a1 1 0 00-.293-.707l-5.414-5.414zM5.75 3.5H13v3.75l.006.144A1.75 1.75 0 0014.75 9h3.75v11.25l-.007.057a.25.25 0 01-.243.193H5.75l-.057-.007a.25.25 0 01-.193-.243V3.75l.007-.057A.25.25 0 015.75 3.5zm8.75 1.121V7.25a.25.25 0 00.193.243l.057.007h2.63L14.5 4.621zm-6.693 9.425C8.183 12.37 9.194 11 10.43 11c1.547 0 1.796 1.624 1 3.337a6.972 6.972 0 01-1.424 2.009l-.156.148.138-.007.17-.017c1.058-.13 1.702-.687 2.014-1.725l.044-.16.026-.08c.239-.613 1.208-.407 1.13.292a10.03 10.03 0 00-.074 1.205l.006.168.084-.093.202-.245c.451-.532.863-.748 1.332-.404.185.135.278.313.343.543l.019.072.033.156.064.387.087-.088.147-.16.172-.202.197-.242.22-.284.23-.312.057-.067a.59.59 0 01.898.758l-.133.182-.252.334-.127.162c-.665.834-1.147 1.225-1.605 1.266-.419.037-.725-.198-.889-.556a1.83 1.83 0 01-.128-.403l-.016-.081-.08.09-.093.096c-.583.591-1.13.773-1.585.251l-.068-.084-.054-.08a1.31 1.31 0 01-.128-.29l-.011-.04-.098.082-.152.112c-.568.398-1.28.616-2.126.645l-.2.003-.167-.005a1.862 1.862 0 01-.843-.253l-.016-.01-.077.046-.256.137a6.378 6.378 0 01-.8.342l-.222.072-.078.018a.59.59 0 01-.267-1.145 5.16 5.16 0 00.806-.324l.15-.08-.043-.116-.056-.188c-.133-.511-.144-1.121-.036-1.775l.031-.17.038-.181zm2.617-.347c.422-.975.323-1.52.004-1.52-.545 0-1.255 1.006-1.502 2.273-.09.462-.108.86-.061 1.178l.025.14.082-.07.197-.186a5.84 5.84 0 001.1-1.488l.091-.185.064-.142z",
      fill: "currentColor"
    }
  ));
}
const DocumentSigned = React.forwardRef(IconDocumentSigned);
function IconDocumentSplit(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M20 14v6.25A1.75 1.75 0 0118.25 22H5.75A1.75 1.75 0 014 20.25V14h4v1.5H5.5v4.75a.25.25 0 00.193.243l.057.007h12.5a.25.25 0 00.243-.193l.007-.057V15.5H16V14h4zm-6 0v1.5h-4V14h4zm0-3v1.5h-4V11h4zm.5-6.379V7.25a.25.25 0 00.193.243l.057.007h2.63L14.5 4.621zM4 3.75C4 2.784 4.784 2 5.75 2h7.836a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V12.5h-4V11h2.5V9h-3.75a1.75 1.75 0 01-1.744-1.606L13 7.25V3.5H5.75a.25.25 0 00-.243.193L5.5 3.75V11H8v1.5H4V3.75z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const DocumentSplit = React.forwardRef(IconDocumentSplit);
function IconDocumentTime(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M13.586 2a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V20.25A1.75 1.75 0 0118.25 22H16v-1.5h2.25a.25.25 0 00.243-.193l.007-.057V9h-3.75a1.75 1.75 0 01-1.744-1.606L13 7.25V3.5H5.75a.25.25 0 00-.243.193L5.5 3.75V10H4V3.75C4 2.784 4.784 2 5.75 2h7.836zM10 10a6 6 0 110 12 6 6 0 010-12zm0 1.5a4.5 4.5 0 100 9 4.5 4.5 0 000-9zm0 .75a.75.75 0 01.743.648l.007.102v3a.75.75 0 01-.648.743L10 16.75H8a.75.75 0 01-.102-1.493L8 15.25l1.25-.001V13a.75.75 0 01.648-.743L10 12.25zm4.5-7.629V7.25a.25.25 0 00.193.243l.057.007h2.63L14.5 4.621z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const DocumentTime = React.forwardRef(IconDocumentTime);
function IconDocument(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M13.586 2a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V20.25A1.75 1.75 0 0118.25 22H5.75A1.75 1.75 0 014 20.25V3.75C4 2.784 4.784 2 5.75 2h7.836zM13 3.5H5.75a.25.25 0 00-.243.193L5.5 3.75v16.5a.25.25 0 00.193.243l.057.007h12.5a.25.25 0 00.243-.193l.007-.057V9h-3.75a1.75 1.75 0 01-1.744-1.606L13 7.25V3.5zm2.5 12.25a.75.75 0 01.102 1.493l-.102.007h-7a.75.75 0 01-.102-1.493l.102-.007h7zm0-4a.75.75 0 01.102 1.493l-.102.007h-7a.75.75 0 01-.102-1.493l.102-.007h7zm-1-7.129V7.25a.25.25 0 00.193.243l.057.007h2.63L14.5 4.621z",
      fill: "currentColor"
    }
  ));
}
const Document = React.forwardRef(IconDocument);
function IconDownload(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M20.25 16.25a.75.75 0 01.743.648L21 17v1.25a3.75 3.75 0 01-3.55 3.745l-.2.005H6.75a3.75 3.75 0 01-3.745-3.55L3 18.25V17a.75.75 0 011.493-.102L4.5 17v1.25a2.25 2.25 0 002.096 2.245l.154.005h10.5a2.25 2.25 0 002.245-2.096l.005-.154V17a.75.75 0 01.75-.75zm-3.5.75a.75.75 0 110 1.5h-9.5a.75.75 0 110-1.5h9.5zM12 2a.75.75 0 01.743.648l.007.102v9.189l2.22-2.22a.75.75 0 011.133.977l-.073.084-3.5 3.5a.754.754 0 01-.078.069l.078-.069-.042.04-.052.04-.114.068-.098.038-.084.02-.088.012L12 14.5l-.052-.002-.119-.018-.098-.03-.1-.047-.082-.054-.08-.069-3.5-3.5a.75.75 0 01.977-1.133l.084.073 2.22 2.219V2.75A.75.75 0 0112 2z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Download = React.forwardRef(IconDownload);
function IconDrag(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M9.5 15.5a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm5 0a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm-5-5a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm5 0a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm-5-5a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm5 0a1.5 1.5 0 110 3 1.5 1.5 0 010-3z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Drag = React.forwardRef(IconDrag);
function IconECopedia(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M17 4c1.583 0 3.165.45 4.748 1.352a.5.5 0 01.252.435V18.65a.5.5 0 01-.728.445C19.848 18.365 18.424 18 17 18c-1.667 0-3.333.5-5 1.5-1.667-1-3.333-1.5-5-1.5-1.424 0-2.848.365-4.272 1.095A.5.5 0 012 18.65V5.787a.5.5 0 01.252-.435C3.835 4.451 5.417 4 7 4c1.667 0 3.333.5 5 1.5 1.667-1 3.333-1.5 5-1.5zM7 13.5c-1.227 0-2.289.177-3.186.536a.5.5 0 10.372.928c.77-.308 1.707-.464 2.814-.464s2.044.156 2.814.464a.5.5 0 10.372-.928C9.289 13.677 8.226 13.5 7 13.5zm10 0c-1.227 0-2.289.177-3.186.536a.5.5 0 10.372.928c.77-.308 1.707-.464 2.814-.464s2.044.156 2.814.464a.5.5 0 10.372-.928c-.897-.359-1.96-.536-3.186-.536zm-10-3c-1.227 0-2.289.177-3.186.536a.5.5 0 10.372.928c.77-.308 1.707-.464 2.814-.464s2.044.156 2.814.464a.5.5 0 10.372-.928C9.289 10.677 8.226 10.5 7 10.5zm10 0c-1.227 0-2.289.177-3.186.536a.5.5 0 10.372.928c.77-.308 1.707-.464 2.814-.464s2.044.156 2.814.464a.5.5 0 10.372-.928c-.897-.359-1.96-.536-3.186-.536zm-10-3c-1.227 0-2.289.177-3.186.536a.5.5 0 00.372.928C4.956 8.656 5.893 8.5 7 8.5s2.044.156 2.814.464a.5.5 0 10.372-.928C9.289 7.677 8.226 7.5 7 7.5zm10 0c-1.227 0-2.289.177-3.186.536a.5.5 0 00.372.928c.77-.308 1.707-.464 2.814-.464s2.044.156 2.814.464a.5.5 0 10.372-.928C19.289 7.677 18.226 7.5 17 7.5z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const ECopedia = React.forwardRef(IconECopedia);
function IconEditSimple(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.013 4.513a1.75 1.75 0 012.35-.114l.124.114 1.586 1.585a1.75 1.75 0 01.114 2.35l-.114.125L8.061 20.586H4v-4.06L16.013 4.512zm-1.514 3.633l-8.999 9v1.94h1.938l9-9.001-1.939-1.939zm2.928-2.573a.25.25 0 00-.3-.04l-.054.04-1.513 1.512 1.939 1.939 1.514-1.511a.25.25 0 00.065-.24l-.025-.06-.04-.054-1.586-1.586z",
      fill: "currentColor"
    }
  ));
}
const EditSimple = React.forwardRef(IconEditSimple);
function IconEdit(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M20.25 20.5a.75.75 0 110 1.5H3.75a.75.75 0 110-1.5h16.5zM16.013 2.927a1.75 1.75 0 012.35-.114l.124.114 1.586 1.586a1.75 1.75 0 01.114 2.35l-.114.124L8.061 19H4v-4.06L16.013 2.926zM14.499 6.56l-8.999 9v1.94h1.938l9-9-1.939-1.94zm2.928-2.573a.25.25 0 00-.3-.04l-.054.04L15.56 5.5l1.939 1.94 1.514-1.512a.25.25 0 00.065-.24l-.025-.06-.04-.054-1.586-1.586z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Edit = React.forwardRef(IconEdit);
function IconEllipsisHorizontal(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M12 10.5a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm-5 0a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm10 0a1.5 1.5 0 110 3 1.5 1.5 0 010-3z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const EllipsisHorizontal = React.forwardRef(IconEllipsisHorizontal);
function IconEllipsisVertical(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M12 15.5a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm0-5a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm0-5a1.5 1.5 0 110 3 1.5 1.5 0 010-3z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const EllipsisVertical = React.forwardRef(IconEllipsisVertical);
function IconEntriesOnAccount(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M19.25 3c.966 0 1.75.784 1.75 1.75v14.5A1.75 1.75 0 0119.25 21H4.75A1.75 1.75 0 013 19.25V4.75C3 3.784 3.784 3 4.75 3h14.5zm.25 3h-15v13.25a.25.25 0 00.193.243l.057.007h14.5a.25.25 0 00.243-.193l.007-.057V6zm-2.25 9.5a.75.75 0 110 1.5H6.75a.75.75 0 110-1.5h10.5zm0-3.5a.75.75 0 110 1.5H6.75a.75.75 0 110-1.5h10.5zm0-3.5a.75.75 0 110 1.5H6.75a.75.75 0 010-1.5h10.5z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const EntriesOnAccount = React.forwardRef(IconEntriesOnAccount);
function IconEntriesOpen(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M19.25 3c.966 0 1.75.784 1.75 1.75v14.5A1.75 1.75 0 0119.25 21H4.75A1.75 1.75 0 013 19.25V4.75C3 3.784 3.784 3 4.75 3h14.5zm.25 3h-15v13.25a.25.25 0 00.193.243l.057.007h14.5a.25.25 0 00.243-.193l.007-.057V6zm-7.25 2a.5.5 0 01.5.5v9a.5.5 0 01-.5.5h-.5a.5.5 0 01-.5-.5v-9a.5.5 0 01.5-.5h.5zm-3.5 7.5a.75.75 0 110 1.5h-2a.75.75 0 110-1.5h2zm0-3.5a.75.75 0 110 1.5h-2a.75.75 0 110-1.5h2zm0-3.5a.75.75 0 010 1.5h-2a.75.75 0 010-1.5h2zm8.5 0a.75.75 0 110 1.5h-2a.75.75 0 110-1.5h2z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const EntriesOpen = React.forwardRef(IconEntriesOpen);
function IconEntriesWarning(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M18.75 12.5a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm.5-9.5c.966 0 1.75.784 1.75 1.75l.001 6.687a5.96 5.96 0 00-1.5-.39L19.5 6h-15v13.25a.25.25 0 00.193.243l.057.007h8.544a5.99 5.99 0 00.985 1.5H4.75A1.75 1.75 0 013 19.25V4.75C3 3.784 3.784 3 4.75 3h14.5zm-.5 16a.75.75 0 100 1.5.75.75 0 000-1.5zm0-5.5a.75.75 0 00-.743.648L18 14.25v3.5a.75.75 0 001.493.102l.007-.102v-3.5a.75.75 0 00-.75-.75zM12.25 8a.5.5 0 01.5.5v9a.5.5 0 01-.5.5h-.5a.5.5 0 01-.5-.5v-9a.5.5 0 01.5-.5h.5zm-3.5 7.5a.75.75 0 110 1.5h-2a.75.75 0 110-1.5h2zm0-3.5a.75.75 0 110 1.5h-2a.75.75 0 110-1.5h2zm0-3.5a.75.75 0 010 1.5h-2a.75.75 0 010-1.5h2zm8.5 0a.75.75 0 110 1.5h-2a.75.75 0 110-1.5h2z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const EntriesWarning = React.forwardRef(IconEntriesWarning);
function IconEntryTypeCustomerInvoice(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M7.5 16c2.434 0 3.88 1.316 4.34 3.95A1.75 1.75 0 0110.116 22H4.884a1.75 1.75 0 01-1.724-2.05C3.62 17.315 5.066 16 7.5 16zm.25-12.5a.25.25 0 00-.243.193L7.5 3.75V9.5c-.54 0-1.053.164-1.5.464V3.75C6 2.784 6.784 2 7.75 2h7.525c.464 0 .91.184 1.238.513l3.974 3.974c.329.329.513.774.513 1.238V18.25A1.75 1.75 0 0119.25 20h-6.038l-.01-.063a11.184 11.184 0 00-.369-1.437h6.417a.25.25 0 00.243-.193l.007-.057v-10h-3a1.75 1.75 0 01-1.744-1.606L14.75 6.5v-3h-7zm-.25 7c1.105 0 2 1.12 2 2.5s-.895 2.5-2 2.5-2-1.12-2-2.5.895-2.5 2-2.5zm9.75 3a.75.75 0 110 1.5h-5.5a.75.75 0 110-1.5h5.5zm0-3a.75.75 0 110 1.5h-6a.75.75 0 110-1.5h6zm1.378-3.75L16.25 4.371V6.5a.25.25 0 00.193.243l.057.007h2.128z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const EntryTypeCustomerInvoice = React.forwardRef(IconEntryTypeCustomerInvoice);
function IconEntryTypeCustomerPayment(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M7.5 16c2.434 0 3.88 1.316 4.34 3.95A1.75 1.75 0 0110.116 22H4.884a1.75 1.75 0 01-1.724-2.05C3.62 17.315 5.066 16 7.5 16zm14.263-3.75c.155.24.237.491.237.75 0 1.272-1.978 2.358-4.77 2.795l-.516.072c-.7.087-1.443.133-2.214.133-1.25 0-2.43-.122-3.466-.339a4.583 4.583 0 00-1.063-.672c.175-.294.313-.626.404-.984.945.25 2.042.417 3.225.474l.612.019.288.002.453-.006c3.293-.078 6.014-1.006 6.81-2.243zM7.5 10.5c1.105 0 2 1.12 2 2.5s-.895 2.5-2 2.5-2-1.12-2-2.5.895-2.5 2-2.5zm14.263-1.75c.155.24.237.491.237.75 0 1.272-1.978 2.358-4.77 2.795l-.516.072c-.7.087-1.443.133-2.214.133-1.524 0-2.941-.182-4.125-.494a3.637 3.637 0 00-.68-1.398 3.187 3.187 0 00-.47-.478c1.163.463 2.705.773 4.423.85l.564.018.288.002.453-.006c3.293-.078 6.014-1.006 6.81-2.243zM14.5 3c.77 0 1.514.046 2.214.133l.516.072C20.022 3.642 22 4.728 22 6s-1.978 2.358-4.77 2.795l-.516.072c-.7.087-1.443.133-2.214.133-.77 0-1.514-.046-2.214-.133l-.516-.072C8.978 8.358 7 7.272 7 6s1.978-2.358 4.77-2.795l.516-.072A18.02 18.02 0 0114.5 3zm0 1.5c-1.835 0-3.538.288-4.746.771-.456.183-.81.381-1.042.57L8.538 6l.082.078c.225.212.613.442 1.134.65 1.208.484 2.91.772 4.746.772 1.835 0 3.538-.288 4.746-.771.456-.183.81-.381 1.042-.57L20.461 6l-.081-.078c-.225-.212-.613-.442-1.134-.65-1.208-.484-2.91-.772-4.746-.772z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const EntryTypeCustomerPayment = React.forwardRef(IconEntryTypeCustomerPayment);
function IconEntryTypeJournalEntry(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10.275 17.75c.702.931 2.675 1.627 5.072 1.735l.378.012.275.003.356-.005c2.53-.061 4.638-.776 5.37-1.745.178.236.274.489.274.75 0 1.38-2.686 2.5-6 2.5s-6-1.12-6-2.5c0-.261.096-.514.275-.75zM14.25 3c.966 0 1.75.784 1.75 1.75V9c-.516 0-1.018.026-1.5.074V5.5h-11v10.75a.25.25 0 00.193.243l.057.007H9V18H3.75A1.75 1.75 0 012 16.25V4.75C2 3.784 2.784 3 3.75 3h10.5zm-3.975 11.75c.702.931 2.675 1.627 5.072 1.735l.378.012.275.003.356-.005c2.53-.061 4.638-.776 5.37-1.745.178.236.274.489.274.75 0 1.38-2.686 2.5-6 2.5s-6-1.12-6-2.5c0-.261.096-.514.275-.75zM16 10c3.314 0 6 1.12 6 2.5S19.314 15 16 15s-6-1.12-6-2.5 2.686-2.5 6-2.5zm-8.25 3a.75.75 0 110 1.5h-1.5a.75.75 0 110-1.5h1.5zM16 11.5c-1.425 0-2.742.232-3.666.617a3.354 3.354 0 00-.65.347l-.048.036.048.036c.126.091.292.186.493.278l.157.07c.924.384 2.24.616 3.666.616 1.425 0 2.742-.232 3.666-.617.273-.114.492-.233.65-.347l.047-.037-.047-.035a3.044 3.044 0 00-.493-.278l-.157-.07c-.924-.384-2.24-.616-3.666-.616zM8.25 10a.75.75 0 110 1.5h-2a.75.75 0 110-1.5h2zm3.5-3a.75.75 0 110 1.5h-5.5a.75.75 0 010-1.5h5.5z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const EntryTypeJournalEntry = React.forwardRef(IconEntryTypeJournalEntry);
function IconEntryTypeManualCustomerInvoice(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M20.371 18.835l1.564 1.565a.998.998 0 010 1.414l-.392.393a.996.996 0 01-1.414 0l-1.565-1.565 1.807-1.807zM7.5 16c2.434 0 3.88 1.316 4.34 3.95A1.75 1.75 0 0110.116 22H4.884a1.75 1.75 0 01-1.724-2.05C3.62 17.315 5.066 16 7.5 16zm7.5 2.5l1.498 1.5h-3.286l-.01-.063a11.184 11.184 0 00-.369-1.437H15zm.453-4.586l4.212 4.213-1.808 1.808-4.21-4.213-.005-1.762 1.811-.046zM15.275 2c.464 0 .91.184 1.238.513l3.974 3.974c.329.329.513.774.513 1.238v10.334l-1.5-1.501V8.25h-3a1.75 1.75 0 01-1.744-1.606L14.75 6.5v-3h-7a.25.25 0 00-.243.193L7.5 3.75V9.5c-.54 0-1.053.164-1.5.464V3.75C6 2.784 6.784 2 7.75 2h7.525zM7.5 10.5c1.105 0 2 1.12 2 2.5s-.895 2.5-2 2.5-2-1.12-2-2.5.895-2.5 2-2.5zm7.25 1a.75.75 0 110 1.5h-3.5a.75.75 0 110-1.5h3.5zm1.5-7.129V6.5a.25.25 0 00.193.243l.057.007h2.128L16.25 4.371z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const EntryTypeManualCustomerInvoice = React.forwardRef(IconEntryTypeManualCustomerInvoice);
function IconEntryTypeSupplierInvoice(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M19.5 8l3 3v8.25A1.75 1.75 0 0120.75 21h-7.5a1.75 1.75 0 01-1.75-1.75v-9.5c0-.966.784-1.75 1.75-1.75h6.25zm-1 1.5h-5.25a.25.25 0 00-.243.193L13 9.75v9.5a.25.25 0 00.193.243l.057.007h7.5a.25.25 0 00.243-.193L21 19.25V12h-2.5V9.5zm.25 7a.75.75 0 110 1.5h-3.5a.75.75 0 110-1.5h3.5zM6.25 14a1.5 1.5 0 110 3 1.5 1.5 0 010-3zM18 3a1.75 1.75 0 011.744 1.606l.006.144V7h-6.27a3.11 3.11 0 00-1.955.675l-.152.13a2.654 2.654 0 00-.866 1.757l-.007.188v5.5H8.738a2.5 2.5 0 00-2.324-2.245L6.25 13a2.5 2.5 0 00-2.488 2.25H2.25l-.102-.007a.75.75 0 01-.641-.641L1.5 14.5V9.929l.008-.108a.75.75 0 01.112-.3l.066-.086 3-3.429.076-.075a.75.75 0 01.381-.173l.107-.008h2.5v-1a1.75 1.75 0 011.606-1.744L9.5 3H18zm.75 10.5a.75.75 0 110 1.5h-3.5a.75.75 0 110-1.5h3.5zM7 7.25H5.59L4 9.068V10h3V7.25z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const EntryTypeSupplierInvoice = React.forwardRef(IconEntryTypeSupplierInvoice);
function IconEntryTypeSupplierPayment(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10.775 17.75c.702.931 2.675 1.627 5.072 1.735l.378.012.275.003.356-.005c2.53-.061 4.638-.776 5.37-1.745.178.236.274.489.274.75 0 1.38-2.686 2.5-6 2.5s-6-1.12-6-2.5c0-.261.096-.514.275-.75zm0-3c.702.931 2.675 1.627 5.072 1.735l.378.012.275.003.356-.005c2.53-.061 4.638-.776 5.37-1.745.178.236.274.489.274.75 0 1.38-2.686 2.5-6 2.5s-6-1.12-6-2.5c0-.261.096-.514.275-.75zM6.25 14a1.5 1.5 0 110 3 1.5 1.5 0 010-3zM18 3a1.75 1.75 0 011.744 1.606l.006.144.001 4.617A13.959 13.959 0 0016.5 9c-1.809 0-3.443.316-4.627.81-.695.289-1.247.646-1.628 1.029-.458.46-.695.97-.738 1.488L9.5 12.5v2.75h-.762a2.5 2.5 0 00-2.324-2.245L6.25 13a2.5 2.5 0 00-2.488 2.25H2.25l-.102-.007a.75.75 0 01-.641-.641L1.5 14.5V9.929l.008-.108a.75.75 0 01.112-.3l.066-.086 3-3.429.076-.075a.75.75 0 01.381-.173l.107-.008h2.5v-1a1.75 1.75 0 011.606-1.744L9.5 3H18zm-1.5 7c3.314 0 6 1.12 6 2.5s-2.686 2.5-6 2.5-6-1.12-6-2.5 2.686-2.5 6-2.5zm0 1.5c-1.425 0-2.742.232-3.666.617a3.354 3.354 0 00-.65.347l-.048.036.048.036c.126.091.292.186.493.278l.157.07c.924.384 2.24.616 3.666.616 1.425 0 2.742-.232 3.666-.617.273-.114.492-.233.65-.347l.047-.037-.047-.035a3.044 3.044 0 00-.493-.278l-.157-.07c-.924-.384-2.24-.616-3.666-.616zM7 7.25H5.59L4 9.068V10h3V7.25z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const EntryTypeSupplierPayment = React.forwardRef(IconEntryTypeSupplierPayment);
function IconEnvelopeApproved(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M20.25 4c.966 0 1.75.784 1.75 1.75v6.14l-1.5-.001v-5.55l-8.04 6.253a.75.75 0 01-.826.062l-.094-.062L3.5 6.339V18.25a.25.25 0 00.193.243l.057.007H12V20H3.75A1.75 1.75 0 012 18.25V5.75C2 4.784 2.784 4 3.75 4h16.5zm1.53 9.72a.75.75 0 01.073.976l-.073.084-5 5a.75.75 0 01-.976.073l-.084-.073-3-3a.75.75 0 01.976-1.133l.084.073 2.47 2.469 4.47-4.47a.75.75 0 011.06 0zM19.134 5.5H4.865L12 11.049 19.134 5.5z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const EnvelopeApproved = React.forwardRef(IconEnvelopeApproved);
function IconEnvelopeSolid(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.137 5.07l8.77 7.016a1.75 1.75 0 002.186 0l8.77-7.016c.088.209.137.439.137.68v12.5A1.75 1.75 0 0120.25 20H3.75A1.75 1.75 0 012 18.25V5.75c0-.241.049-.471.137-.68zM3.28 4.064c.15-.042.307-.064.47-.064h16.5c.163 0 .32.022.47.064l-8.564 6.85a.25.25 0 01-.312 0L3.28 4.064z",
      fill: "currentColor"
    }
  ));
}
const EnvelopeSolid = React.forwardRef(IconEnvelopeSolid);
function IconEnvelope(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M20.25 4c.966 0 1.75.784 1.75 1.75v12.5A1.75 1.75 0 0120.25 20H3.75A1.75 1.75 0 012 18.25V5.75C2 4.784 2.784 4 3.75 4h16.5zm.25 2.339l-8.04 6.253a.75.75 0 01-.826.062l-.094-.062L3.5 6.339V18.25a.25.25 0 00.193.243l.057.007h16.5a.25.25 0 00.243-.193l.007-.057V6.339zM19.134 5.5H4.865L12 11.049 19.134 5.5z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Envelope = React.forwardRef(IconEnvelope);
function IconExpandView(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M19.25 3c.966 0 1.75.784 1.75 1.75v14.5A1.75 1.75 0 0119.25 21H13.5v-1.5h5.75a.25.25 0 00.243-.193l.007-.057V4.75a.25.25 0 00-.193-.243L19.25 4.5H4.75a.25.25 0 00-.243.193L4.5 4.75v5.75H3V4.75C3 3.784 3.784 3 4.75 3h14.5zm-9 9c.966 0 1.75.784 1.75 1.75v5.5A1.75 1.75 0 0110.25 21h-5.5A1.75 1.75 0 013 19.25v-5.5c0-.966.784-1.75 1.75-1.75h5.5zm0 1.5h-5.5a.25.25 0 00-.243.193l-.007.057v5.5a.25.25 0 00.193.243l.057.007h5.5a.25.25 0 00.243-.193l.007-.057v-5.5a.25.25 0 00-.193-.243l-.057-.007zm7.25-7.75a.75.75 0 01.743.648l.007.102V10a.75.75 0 01-1.493.102L16.75 10V8.31l-3.22 3.22a.75.75 0 01-1.133-.976l.073-.084 3.218-3.22H14a.75.75 0 01-.743-.648L13.25 6.5a.75.75 0 01.648-.743L14 5.75h3.5z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const ExpandView = React.forwardRef(IconExpandView);
function IconExpenses(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M18.25 2a1.75 1.75 0 011.744 1.606L20 3.75v16a.75.75 0 01-.177.484l-.074.076-1.813 1.613a.75.75 0 01-.908.068l-.089-.068-1.314-1.17-1.314 1.17a.75.75 0 01-.811.121l-.097-.053-.089-.068L12 20.753l-1.314 1.17a.75.75 0 01-.811.121l-.097-.053-.089-.068-1.314-1.17-1.314 1.17a.75.75 0 01-.811.121l-.097-.053-.089-.068-1.813-1.613a.75.75 0 01-.243-.454L4 19.75v-16a1.75 1.75 0 011.606-1.744L5.75 2h12.5zm0 1.5H5.75a.25.25 0 00-.243.193L5.5 3.75v15.662l1.063.946 1.313-1.168a.75.75 0 01.812-.122l.096.053.09.069 1.314 1.168 1.313-1.168a.75.75 0 01.812-.122l.096.053.09.069 1.314 1.168 1.313-1.168a.75.75 0 01.812-.122l.096.053.09.069 1.314 1.168 1.062-.945V3.75a.25.25 0 00-.13-.22l-.063-.023-.057-.007zm-2.5 9.5a.75.75 0 110 1.5h-7.5a.75.75 0 110-1.5h7.5zm-3-3.5a.75.75 0 110 1.5h-4.5a.75.75 0 110-1.5h4.5zm3-3.5a.75.75 0 110 1.5h-7.5a.75.75 0 010-1.5h7.5z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Expenses = React.forwardRef(IconExpenses);
function IconExperiment(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.962 9.26V5.313h2.843V9.28c0 .376.796 1.24 1.049 1.511L14.5 12.5c-.507.218-3.166-1.19-4.341-.211C7.159 14.789 6 13 6.5 12c.316-.632 2.462-1.803 2.462-2.74zm.24-4.469a.762.762 0 00-.752.772v3.696a.61.61 0 01-.177.43l-2.592 2.6c-.911.913-.281 2.502.992 2.502h7.154c1.25 0 1.89-1.538 1.027-2.466l-2.446-2.63a.61.61 0 01-.162-.415V5.563a.762.762 0 00-.752-.772H9.202z",
      fill: "currentColor",
      stroke: "currentColor"
    }
  ));
}
const Experiment = React.forwardRef(IconExperiment);
function IconExportToExcel(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M13.586 2a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V20.25A1.75 1.75 0 0118.25 22H12.5v-1.5h5.75a.25.25 0 00.243-.193l.007-.057V9h-3.75a1.75 1.75 0 01-1.744-1.606L13 7.25V3.5H5.75a.25.25 0 00-.243.193L5.5 3.75v8.75H4V3.75C4 2.784 4.784 2 5.75 2h7.836zM4.648 14.507l.102-.007h5l.07.003.101.017.068.019.06.023.07.035.082.054.08.07a.749.749 0 01.096.118l.05.09.04.103c.012.037.02.076.026.116l.007.102v5a.75.75 0 01-1.493.102L9 20.25v-3.19l-4.72 4.72a.75.75 0 01-1.133-.976l.073-.084L7.938 16H4.75a.75.75 0 01-.743-.648L4 15.25a.75.75 0 01.648-.743zM16.5 16.5v2h-4v-2h4zm0-3v2h-4v-2h4zm-5-3v2h-4v-2h4zm5 0v2h-4v-2h4zm-2-5.879V7.25a.25.25 0 00.193.243l.057.007h2.63L14.5 4.621z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const ExportToExcel = React.forwardRef(IconExportToExcel);
function IconExportToPdf(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M13.586 2a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V20.25A1.75 1.75 0 0118.25 22H12.5v-1.5h5.75a.25.25 0 00.243-.193l.007-.057V9h-3.75a1.75 1.75 0 01-1.744-1.606L13 7.25V3.5H5.75a.25.25 0 00-.243.193L5.5 3.75v8.75H4V3.75C4 2.784 4.784 2 5.75 2h7.836zM4.648 14.507l.102-.007h5l.07.003.101.017.068.019.06.023.07.035.082.054.08.07a.749.749 0 01.096.118l.05.09.04.103c.012.037.02.076.026.116l.007.102v5a.75.75 0 01-1.493.102L9 20.25v-3.19l-4.72 4.72a.75.75 0 01-1.133-.976l.073-.084L7.938 16H4.75a.75.75 0 01-.743-.648L4 15.25a.75.75 0 01.648-.743zM14.5 4.62v2.63a.25.25 0 00.193.243l.057.007h2.63L14.5 4.621z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const ExportToPdf = React.forwardRef(IconExportToPdf);
function IconExport(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M8.5 7.999V9.5H5.75a.25.25 0 00-.243.193L5.5 9.75v10.5a.25.25 0 00.193.243l.057.007h12.5a.25.25 0 00.243-.193l.007-.057V9.75a.25.25 0 00-.193-.243L18.25 9.5H15.5V7.999L18.25 8c.966 0 1.75.784 1.75 1.75v10.5A1.75 1.75 0 0118.25 22H5.75A1.75 1.75 0 014 20.25V9.75C4 8.784 4.784 8 5.75 8l2.75-.001zM11.992 2l.1.006.076.013.08.023.107.047.091.058.084.073 3 3a.75.75 0 01-.976 1.133l-.084-.073-1.72-1.719V15.25a.75.75 0 01-1.493.102l-.007-.102V4.561l-1.72 1.72a.75.75 0 01-1.133-.977l.073-.084 3-3a.753.753 0 01.125-.101l.088-.049.119-.043.106-.021A.754.754 0 0111.992 2z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Export = React.forwardRef(IconExport);
function IconEyeOff(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.53 2.47a.75.75 0 00-1.06 1.06l3.605 3.605a10.258 10.258 0 00-4.097 6.208.75.75 0 101.466.314 8.757 8.757 0 013.71-5.443l1.987 1.988a4 4 0 005.656 5.656l5.673 5.672a.75.75 0 101.06-1.06l-18-18zm10.207 12.328l-3.535-3.535a2.5 2.5 0 003.535 3.535zM12.061 9L16 12.94A4 4 0 0012.06 9zM8.815 5.754l1.218 1.218a8.753 8.753 0 0110.523 6.685.75.75 0 101.467-.314C21.032 8.718 16.922 5.25 12 5.25c-1.112 0-2.182.177-3.185.504z",
      fill: "currentColor"
    }
  ));
}
const EyeOff = React.forwardRef(IconEyeOff);
function IconEyeOn(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.444 13.657a8.753 8.753 0 0117.112 0 .75.75 0 101.466-.314C21.033 8.718 16.922 5.25 12 5.25c-4.922 0-9.031 3.468-10.022 8.093a.75.75 0 101.466.314zM14.5 13a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zm1.5 0a4 4 0 11-8 0 4 4 0 018 0z",
      fill: "currentColor"
    }
  ));
}
const EyeOn = React.forwardRef(IconEyeOn);
function IconFilterSolid(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M20.25 2a.75.75 0 01.75.75v2a.75.75 0 01-.15.45l-5.7 7.6a.75.75 0 00-.15.45v6.725a.75.75 0 01-.494.705l-4 1.454A.75.75 0 019.5 21.43v-8.163a.75.75 0 00-.168-.473L3.168 5.207A.75.75 0 013 4.734V2.75A.75.75 0 013.75 2h16.5z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const FilterSolid = React.forwardRef(IconFilterSolid);
function IconFilter(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M20.25 2a.75.75 0 01.75.75v2a.75.75 0 01-.15.45l-5.7 7.6a.75.75 0 00-.15.45v6.725a.75.75 0 01-.494.705l-4 1.454A.75.75 0 019.5 21.43v-8.163a.75.75 0 00-.168-.473L3.168 5.207A.75.75 0 013 4.734V2.75A.75.75 0 013.75 2h16.5zm-.75 1.5h-15v.967l5.996 7.38c.285.351.457.779.496 1.226l.008.193v7.092l2.5-.91V13.25c0-.426.12-.842.347-1.2l.103-.15 5.55-7.401V3.5z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Filter$1 = React.forwardRef(IconFilter);
function IconFontSize(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.75 3.75A.75.75 0 019.5 3h12a.75.75 0 01.75.75v1.5a.75.75 0 01-1.5 0V4.5h-4.5v15h1.25a.75.75 0 010 1.5h-4a.75.75 0 010-1.5h1.25v-15h-4.5v.75a.75.75 0 01-1.5 0v-1.5zM6.5 9.25h4a.75.75 0 01.75.75v1.5a.75.75 0 01-1.5 0v-.75h-2.5v8.75H8.5a.75.75 0 010 1.5h-4a.75.75 0 010-1.5h1.25v-8.75h-2.5v.75a.75.75 0 01-1.5 0V10a.75.75 0 01.75-.75h4z",
      fill: "currentColor"
    }
  ));
}
const FontSize = React.forwardRef(IconFontSize);
function IconGraphSolid(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M19.25 3c.966 0 1.75.784 1.75 1.75v14.5A1.75 1.75 0 0119.25 21H4.75A1.75 1.75 0 013 19.25V4.75C3 3.784 3.784 3 4.75 3h14.5zm-.925 3.324a.75.75 0 00-.95.263l-.051.088-4.124 8.591-2.924-6.09-.057-.1a.751.751 0 00-1.238 0l-.057.1-1.724 3.59-.524-1.09-.05-.09a.75.75 0 00-1.34.644l.038.095 1.2 2.5.057.1a.751.751 0 001.238 0l.057-.1L9.6 11.233l2.924 6.092.057.1a.751.751 0 001.238 0l.057-.1 4.8-10 .038-.095a.75.75 0 00-.39-.906z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const GraphSolid = React.forwardRef(IconGraphSolid);
function IconHash(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M18.158 2.017a.75.75 0 01.59.79l-.015.102-1.047 4.841H20a.75.75 0 01.102 1.493L20 9.25h-2.638l-1.189 5.5H18.5a.75.75 0 01.102 1.493l-.102.007h-2.652l-1.115 5.159a.75.75 0 01-1.48-.216l.014-.101 1.046-4.842H7.848l-1.115 5.159a.75.75 0 01-1.48-.216l.014-.101 1.046-4.842H4a.75.75 0 01-.102-1.493L4 14.75h2.637l1.189-5.5H5.5a.75.75 0 01-.102-1.493L5.5 7.75h2.651l1.116-5.158a.75.75 0 011.48.216l-.014.1L9.686 7.75h6.465l1.116-5.158a.75.75 0 01.891-.575zM14.637 14.75l1.189-5.5H9.362l-1.189 5.5h6.464z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Hash = React.forwardRef(IconHash);
function IconHeightExtraTall(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.53 2.97a.75.75 0 00-1.06 0l-3 3a.75.75 0 001.06 1.06l1.72-1.72v13.38l-1.72-1.72a.75.75 0 10-1.06 1.06l3 3a.75.75 0 001.06 0l3-3a.75.75 0 10-1.06-1.06l-1.72 1.72V5.31l1.72 1.72a.75.75 0 101.06-1.06l-3-3zM3 19.25a.75.75 0 000 1.5h8.5a.75.75 0 000-1.5H3zM2.25 12a.75.75 0 01.75-.75h8.5a.75.75 0 010 1.5H3a.75.75 0 01-.75-.75zM3 3.25a.75.75 0 000 1.5h8.5a.75.75 0 000-1.5H3z",
      fill: "currentColor"
    }
  ));
}
const HeightExtraTall = React.forwardRef(IconHeightExtraTall);
function IconHeightMedium(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.53 2.97a.75.75 0 00-1.06 0l-3 3a.75.75 0 001.06 1.06l1.72-1.72v13.38l-1.72-1.72a.75.75 0 10-1.06 1.06l3 3a.75.75 0 001.06 0l3-3a.75.75 0 10-1.06-1.06l-1.72 1.72V5.31l1.72 1.72a.75.75 0 101.06-1.06l-3-3zM2.25 7.5A.75.75 0 013 6.75h8.5a.75.75 0 010 1.5H3a.75.75 0 01-.75-.75zM3 11.25a.75.75 0 000 1.5h8.5a.75.75 0 000-1.5H3zm0 4.5a.75.75 0 000 1.5h8.5a.75.75 0 000-1.5H3z",
      fill: "currentColor"
    }
  ));
}
const HeightMedium = React.forwardRef(IconHeightMedium);
function IconHeightShort(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.53 2.97a.75.75 0 00-1.06 0l-3 3a.75.75 0 001.06 1.06l1.72-1.72v13.38l-1.72-1.72a.75.75 0 10-1.06 1.06l3 3a.75.75 0 001.06 0l3-3a.75.75 0 10-1.06-1.06l-1.72 1.72V5.31l1.72 1.72a.75.75 0 101.06-1.06l-3-3zM2.25 9A.75.75 0 013 8.25h8.5a.75.75 0 010 1.5H3A.75.75 0 012.25 9zM3 11.25a.75.75 0 000 1.5h8.5a.75.75 0 000-1.5H3zm0 3a.75.75 0 000 1.5h8.5a.75.75 0 000-1.5H3z",
      fill: "currentColor"
    }
  ));
}
const HeightShort = React.forwardRef(IconHeightShort);
function IconHeightTall(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.53 2.97a.75.75 0 00-1.06 0l-3 3a.75.75 0 001.06 1.06l1.72-1.72v13.38l-1.72-1.72a.75.75 0 10-1.06 1.06l3 3a.75.75 0 001.06 0l3-3a.75.75 0 10-1.06-1.06l-1.72 1.72V5.31l1.72 1.72a.75.75 0 101.06-1.06l-3-3zM2.25 6A.75.75 0 013 5.25h8.5a.75.75 0 010 1.5H3A.75.75 0 012.25 6zM3 11.25a.75.75 0 000 1.5h8.5a.75.75 0 000-1.5H3zm0 6a.75.75 0 000 1.5h8.5a.75.75 0 000-1.5H3z",
      fill: "currentColor"
    }
  ));
}
const HeightTall = React.forwardRef(IconHeightTall);
function IconHouseSolid(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M12 6l8 8v7a1 1 0 01-1 1h-5v-5a1 1 0 00-.883-.993L13 16h-2a1 1 0 00-.993.883L10 17v5H5a1 1 0 01-1-1v-7l8-8zm.613-3.79l.094.083L17 6.585V4.75a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v3.835l2.707 2.708a1 1 0 01-1.32 1.497l-.094-.083L12 4.415l-8.293 8.292a1 1 0 01-1.32.083l-.094-.083a1 1 0 01-.083-1.32l.083-.094 9-9a1 1 0 011.32-.083z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const HouseSolid = React.forwardRef(IconHouseSolid);
function IconHouse(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.116 2.823a1.25 1.25 0 011.768 0L17.25 7.19V6a.75.75 0 011.5 0v2.69l2.78 2.78a.75.75 0 01-1.06 1.06l-2.994-2.993-.013-.013L12 4.061l-8.47 8.47a.75.75 0 01-1.06-1.061l8.646-8.647zm1.768 3.25l7 7c.234.235.366.553.366.884v6.293c0 .69-.56 1.25-1.25 1.25h-4c-.69 0-1.25-.56-1.25-1.25V16.5h-3.5v3.75c0 .69-.56 1.25-1.25 1.25H5c-.69 0-1.25-.56-1.25-1.25v-6.293c0-.332.132-.65.366-.884l7-7a1.25 1.25 0 011.768 0zM12 7.311l-6.75 6.75V20h3.5v-3.75c0-.69.56-1.25 1.25-1.25h4c.69 0 1.25.56 1.25 1.25V20h3.5v-5.94L12 7.31z",
      fill: "currentColor"
    }
  ));
}
const House = React.forwardRef(IconHouse);
function IconId(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20.25 5c.966 0 1.75.784 1.75 1.75v10.5A1.75 1.75 0 0120.25 19H3.75A1.75 1.75 0 012 17.25V6.75C2 5.784 2.784 5 3.75 5h16.5zm0 1.5H3.75a.25.25 0 00-.243.193L3.5 6.75v10.5a.25.25 0 00.193.243l.057.007h16.5a.25.25 0 00.243-.193l.007-.057V6.75a.25.25 0 00-.193-.243L20.25 6.5zm-9.268 7.993c-.316-1.81-1.31-2.714-2.982-2.714-1.673 0-2.667.905-2.982 2.714a1.204 1.204 0 001.184 1.41h3.595a1.204 1.204 0 001.185-1.41zM8 8c.76 0 1.374.77 1.374 1.718 0 .949-.615 1.718-1.374 1.718-.759 0-1.374-.77-1.374-1.718C6.626 8.769 7.24 8 8 8zm11 .75a.75.75 0 00-.75-.75h-6a.75.75 0 000 1.5h6a.75.75 0 00.75-.75zM18.25 14a.75.75 0 010 1.5h-4.5a.75.75 0 010-1.5h4.5zm.75-2.25a.75.75 0 00-.75-.75h-4.5a.75.75 0 000 1.5h4.5a.75.75 0 00.75-.75z",
      fill: "currentColor"
    }
  ));
}
const Id = React.forwardRef(IconId);
function IconImages(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M16.25 6c.966 0 1.75.784 1.75 1.75v11.5A1.75 1.75 0 0116.25 21H4.75A1.75 1.75 0 013 19.25V7.75C3 6.784 3.784 6 4.75 6h11.5zm0 1.5H4.75a.25.25 0 00-.243.193L4.5 7.75v11.5a.25.25 0 00.193.243l.057.007h11.5a.25.25 0 00.243-.193l.007-.057V7.75a.25.25 0 00-.193-.243L16.25 7.5zm-4.264 6.889l3.164 3.961h-9.5l2.375-3.164 1.605 2.148 2.356-2.945zM19.25 3a1.75 1.75 0 011.744 1.606L21 4.75v12.5a.75.75 0 01-1.493.102l-.007-.102V4.75a.25.25 0 00-.193-.243L19.25 4.5H6.75a.75.75 0 01-.102-1.493L6.75 3h12.5z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Images = React.forwardRef(IconImages);
function IconImport(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M8.5 8v1.5H5.75a.25.25 0 00-.243.193L5.5 9.75v10.5a.25.25 0 00.193.243l.057.007h12.5a.25.25 0 00.243-.193l.007-.057V9.75a.25.25 0 00-.193-.243L18.25 9.5H15.5V8h2.75c.966 0 1.75.784 1.75 1.75v10.5A1.75 1.75 0 0118.25 22H5.75A1.75 1.75 0 014 20.25V9.75C4 8.784 4.784 8 5.75 8H8.5zM12 2a.75.75 0 01.743.648l.007.102v10.689l1.72-1.72a.75.75 0 011.133.977l-.073.084-3 3a.753.753 0 01-.125.101l-.088.049-.119.043-.106.021-.041.004-.07.002-.073-.006-.076-.013-.08-.023-.1-.043a.75.75 0 01-.182-.135l-3-3a.75.75 0 01.976-1.133l.084.073 1.72 1.719V2.75A.75.75 0 0112 2z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Import = React.forwardRef(IconImport);
function IconInboxEinvoicing(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 3.997v2H6.918l-2.8 8h3.229a1 1 0 01.916.598l.974 2.221a1 1 0 00.916.598h3.694a1 1 0 00.915-.598l.976-2.22a1 1 0 01.915-.599h3.228l-.525-1.5h2.118l.428 1.22c.065.185.098.38.098.578v3.952a1.75 1.75 0 01-1.607 1.744l-.143.006H3.75A1.75 1.75 0 012 18.247v-3.952c0-.197.033-.393.098-.578L5.09 5.169a1.75 1.75 0 011.652-1.172H12zM17.966 1c2.373 0 4.052 1.688 4.052 3.99 0 .988-.267 1.349-1.03 1.386l-.14.003h-4.72v.404c.01 1.301.836 2.136 2.216 2.136.64 0 1.114-.139 1.502-.41l.403-.307c.267-.196.425-.276.705-.276.483 0 .817.334.817.844 0 .367-.2.72-.554 1.016l-.278.216c-.63.455-1.627.727-2.745.727-2.653 0-4.32-1.515-4.416-4.023l-.005-.23V5.27c0-2.547 1.688-4.27 4.193-4.27zM18 2.763c-1.09 0-1.805.769-1.868 1.932l-.004.186h3.674v-.017c0-1.275-.703-2.101-1.802-2.101z",
      fill: "currentColor"
    }
  ));
}
const InboxEinvoicing = React.forwardRef(IconInboxEinvoicing);
function IconInboxScanning(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.5 4v2H6.918l-2.8 8h3.229a1 1 0 01.916.598l.974 2.22a1 1 0 00.916.599h3.694a1 1 0 00.915-.598l.976-2.221a1 1 0 01.915-.598h3.228l-.525-1.5h2.118l.428 1.22c.065.185.098.38.098.577v3.953a1.75 1.75 0 01-1.607 1.744L20.25 20H3.75A1.75 1.75 0 012 18.25v-3.953c0-.197.033-.392.098-.578L5.09 5.172A1.75 1.75 0 016.742 4H13.5zM20 1l3 3v6c0 .51-.388.935-.884.993L22 11h-6.005a.998.998 0 01-.988-.884L15 10l.005-8a1 1 0 01.879-.993L16 1h4zm-1 1v3h3l-3-3z",
      fill: "currentColor"
    }
  ));
}
const InboxScanning = React.forwardRef(IconInboxScanning);
function IconInboxSmart(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 4v2H6.918l-2.8 8h3.229a1 1 0 01.916.598l.974 2.22a1 1 0 00.916.599h3.694a1 1 0 00.915-.598l.976-2.221a1 1 0 01.915-.598h3.228l-.525-1.5h2.118l.428 1.22c.065.185.098.38.098.577v3.953a1.75 1.75 0 01-1.607 1.744L20.25 20H3.75A1.75 1.75 0 012 18.25v-3.953c0-.197.033-.392.098-.578L5.09 5.172A1.75 1.75 0 016.742 4H12zm6.167-2.76a.35.35 0 01.631-.074l.036.074 1.145 3.115 3.183.179c.283.016.421.342.286.57l-.043.058-.037.036-2.476 2.104.823 3.226c.073.288-.182.527-.43.46l-.068-.025-.042-.024L18.5 9.121l-2.674 1.816c-.24.163-.535-.018-.552-.286l.003-.075.01-.049.821-3.226-2.475-2.104a.384.384 0 01.088-.637l.068-.02.05-.007 3.183-.179 1.145-3.115z",
      fill: "currentColor"
    }
  ));
}
const InboxSmart = React.forwardRef(IconInboxSmart);
function IconInbox(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.258 4c.744 0 1.407.47 1.652 1.172l2.992 8.547c.065.186.098.382.098.578v3.953a1.75 1.75 0 01-1.607 1.744L20.25 20H3.75A1.75 1.75 0 012 18.25v-3.953c0-.197.033-.392.098-.578L5.09 5.172A1.75 1.75 0 016.742 4h10.516zm-.177 2H6.918l-2.8 8h3.229a1 1 0 01.916.598l.974 2.22a1 1 0 00.916.599h3.694a1 1 0 00.915-.598l.976-2.221a1 1 0 01.915-.598h3.228l-2.8-8z",
      fill: "currentColor"
    }
  ));
}
const Inbox = React.forwardRef(IconInbox);
function IconInfo(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.75 18.249A.75.75 0 0114 19h-4a.75.75 0 010-1.503h1.233V11H10a.75.75 0 010-1.503h1.983a.75.75 0 01.75.752v7.248H14a.75.75 0 01.75.752z",
      fill: "currentColor"
    }
  ), /* @__PURE__ */ React.createElement("path", { d: "M12.733 6.002a1 1 0 11-2.001.001 1 1 0 012.001-.001z", fill: "currentColor" }));
}
const Info = React.forwardRef(IconInfo);
function IconInventoryMatrix(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M19.25 3c.966 0 1.75.784 1.75 1.75v14.5A1.75 1.75 0 0119.25 21H4.75A1.75 1.75 0 013 19.25V4.75C3 3.784 3.784 3 4.75 3h14.5zm-8 12.25H4.5v4a.25.25 0 00.193.243l.057.007h6.5v-4.25zm8.25-5h-6.75v9.25h6.5a.25.25 0 00.243-.193l.007-.057v-9zm-2.996 2.383c.419 0 .71.26.755.67l.007.115v3.945c0 .442-.23.688-.637.688-.373 0-.597-.207-.635-.573l-.006-.115v-3.511h-.015l-.41.277c-.204.129-.313.168-.442.168a.431.431 0 01-.445-.445c0-.165.086-.314.256-.445l.091-.063.637-.426c.305-.195.582-.285.844-.285zM11.25 4.5h-6.5a.25.25 0 00-.243.193L4.5 4.75v9h6.75V4.5zM7.883 6.57c1.074 0 1.86.657 1.86 1.551 0 .505-.224.954-.764 1.519l-1.268 1.282v.055h1.625c.363 0 .59.195.59.515 0 .285-.18.468-.484.502L9.336 12H6.664c-.379 0-.629-.215-.629-.543 0-.208.102-.392.399-.699l.12-.121 1.352-1.39c.418-.427.594-.708.594-1.005 0-.383-.277-.64-.688-.64-.332 0-.574.168-.746.515-.171.266-.32.367-.546.367-.31 0-.524-.21-.524-.507 0-.727.82-1.407 1.887-1.407zM19.25 4.5h-6.5v4.25h6.75v-4a.25.25 0 00-.193-.243L19.25 4.5z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const InventoryMatrix = React.forwardRef(IconInventoryMatrix);
function IconInventory(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10 15a3.5 3.5 0 110 7 3.5 3.5 0 010-7zm0 2.25a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm11.518-1.94l.04.121a1.25 1.25 0 01-.762 1.492l-.122.04-6.175 1.654.001-.117a4.48 4.48 0 00-.633-2.302l6.16-1.65a1.25 1.25 0 011.491.762zm-3.375-9.442l1.812 6.762a1 1 0 01-.707 1.224l-5.943 1.592a4.496 4.496 0 00-2.268-1.326L9.45 8.197a1 1 0 01.707-1.224l6.761-1.812a1 1 0 011.225.707zM3.657 1.536l.128.049 2.69 1.184c.304.133.54.381.66.686l.044.134L9.97 14l-.18.005a4.475 4.475 0 00-2.218.706L4.919 4.815l-2.141-.942a1.25 1.25 0 01-.69-1.52l.05-.128c.259-.59.918-.879 1.519-.689zM15.44 7.37a.75.75 0 00-.819-.55l-.1.02-1.449.388a.75.75 0 00.288 1.469l.1-.02 1.45-.388a.75.75 0 00.53-.919z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Inventory = React.forwardRef(IconInventory);
function IconJournalPro(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M16.737 3.668c-.055 1.093.226 2.033.894 2.7.668.669 1.608.95 2.7.897a18.08 18.08 0 01-3.09 4.184 27.666 27.666 0 01-3.127 2.706v3.318a.553.553 0 01-.162.39l-3.975 3.975a.553.553 0 01-.943-.39V18.32a.55.55 0 01.162-.39l1.24-1.24a.553.553 0 00.161-.39v-.133c-1.238.463-2.218.487-2.735-.03-.517-.517-.493-1.497-.03-2.735H7.7a.553.553 0 00-.325.105l-.066.057-1.24 1.24a.553.553 0 01-.303.154l-.087.007H2.553a.553.553 0 01-.455-.867l.064-.076 3.975-3.975a.553.553 0 01.304-.155l.086-.007h3.318a27.666 27.666 0 012.706-3.126 18.078 18.078 0 014.186-3.092zM21.93 2.07c.104.105.095.547-.048 1.212l-.083.35-.107.386-.061.204-.142.43c-.154.444-.345.928-.575 1.436-1.073.193-1.96.04-2.501-.5-.523-.523-.684-1.37-.52-2.395l.019-.107a16.762 16.762 0 011.654-.649l.416-.13.197-.055.368-.095c.76-.18 1.27-.2 1.383-.087z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const JournalPro = React.forwardRef(IconJournalPro);
function IconLayoutBoth(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10 3a1 1 0 011 1v16a1 1 0 01-1 1H4a1 1 0 01-1-1V4a1 1 0 011-1h6zm10 0a1 1 0 011 1v16a1 1 0 01-1 1h-6a1 1 0 01-1-1V4a1 1 0 011-1h6z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const LayoutBoth = React.forwardRef(IconLayoutBoth);
function IconLayoutFirst(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M20 3a1 1 0 011 1v16a1 1 0 01-1 1h-6a1 1 0 01-1-1V4a1 1 0 011-1h6zM10 3a1 1 0 011 1v16a1 1 0 01-1 1H4a1 1 0 01-1-1V4a1 1 0 011-1h6zm9.5 1.5h-5v15h5v-15z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const LayoutFirst = React.forwardRef(IconLayoutFirst);
function IconLayoutLast(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10 3a1 1 0 01.993.883L11 4v16a1 1 0 01-.883.993L10 21H4a1 1 0 01-.993-.883L3 20V4a1 1 0 01.883-.993L4 3h6zm10 0a1 1 0 01.993.883L21 4v16a1 1 0 01-.883.993L20 21h-6a1 1 0 01-.993-.883L13 20V4a1 1 0 01.883-.993L14 3h6zM9.5 4.5h-5v15h5v-15z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const LayoutLast = React.forwardRef(IconLayoutLast);
function IconLayoutNone(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M20 3a1 1 0 011 1v16a1 1 0 01-1 1h-6a1 1 0 01-1-1V4a1 1 0 011-1h6zM10 3a1 1 0 01.993.883L11 4v16a1 1 0 01-.883.993L10 21H4a1 1 0 01-.993-.883L3 20V4a1 1 0 01.883-.993L4 3h6zm9.5 1.5h-5v15h5v-15zm-10 0h-5v15h5v-15z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const LayoutNone = React.forwardRef(IconLayoutNone);
function IconLayout(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M14.5 20.5V22h-5v-1.5h5zm-9-2.5v2.25a.25.25 0 00.193.243l.057.007H8V22H5.75A1.75 1.75 0 014 20.25V18h1.5zM20 18v2.25A1.75 1.75 0 0118.25 22H16v-1.5h2.25a.25.25 0 00.243-.193l.007-.057V18H20zm0-5.25v3.75h-1.5v-3.75H20zm-14.5 0v3.75H4v-3.75h1.5zM16.326 2.676a1.752 1.752 0 012.349-.113l.125.113.594.593c.59.589.676 1.502.21 2.216l-.094.131-.115.128-7.504 7.5-3 .008-.078-3.067 7.513-7.509zm-.796 2.916l-5.202 5.199.025.957.914-.002 5.209-5.207-.946-.947zM20 9v2.25h-1.5V9H20zM5.5 7.5v3.75H4V7.5h1.5zM8 2v1.5H5.75a.25.25 0 00-.243.193L5.5 3.75V6H4V3.75C4 2.784 4.784 2 5.75 2H8zm9.687 1.697a.252.252 0 00-.248 0l-.053.04-.796.795.946.947.82-.82a.248.248 0 00.043-.216l-.021-.053-.044-.06-.594-.593-.053-.04zM13 2v1.499L9.5 3.5V2H13z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Layout$1 = React.forwardRef(IconLayout);
function IconLedgerCardCustomerReminder(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10.5 11.5c1.69 0 3.093.4 4.212 1.198a4.49 4.49 0 00-.83 1.255C12.996 13.307 11.875 13 10.5 13c-3.37 0-5.211 1.84-5.806 6.002a1.313 1.313 0 001.165 1.491l.134.007h6.506L12.5 22H5.993a2.813 2.813 0 01-2.784-3.21c.695-4.86 3.125-7.29 7.291-7.29zm8.725 9.474A1.259 1.259 0 0118 22c-.605 0-1.11-.44-1.225-1.026h2.45zM18 12c.456 0 .841.392.961.927A3 3 0 0121 15.769v2.898l.835.642a.5.5 0 01-.213.888l-.092.008h-7.06a.5.5 0 01-.305-.896l.835-.642v-2.898c0-1.32.854-2.442 2.04-2.843.119-.534.504-.926.96-.926zM10.5 2C12.433 2 14 3.903 14 6.25s-1.567 4.25-3.5 4.25S7 8.597 7 6.25 8.567 2 10.5 2zm0 1.5c-1.033 0-2 1.174-2 2.75S9.467 9 10.5 9s2-1.174 2-2.75-.967-2.75-2-2.75z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const LedgerCardCustomerReminder = React.forwardRef(IconLedgerCardCustomerReminder);
function IconLedgerCardManualCustomerInvoice(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M19.25 3c.966 0 1.75.784 1.75 1.75v14.5A1.75 1.75 0 0119.25 21H4.75A1.75 1.75 0 013 19.25V4.75C3 3.784 3.784 3 4.75 3h14.5zm.25 3h-15v13.25a.25.25 0 00.193.243l.057.007h14.5a.25.25 0 00.243-.193l.007-.057V6zm-8.75 9.5a.75.75 0 110 1.5h-4a.75.75 0 110-1.5h4zm6.5 0a.75.75 0 110 1.5h-4a.75.75 0 110-1.5h4zm-6.5-3.5a.75.75 0 110 1.5h-4a.75.75 0 110-1.5h4zm6.5 0a.75.75 0 110 1.5h-4a.75.75 0 110-1.5h4zm-6.5-3.5a.75.75 0 110 1.5h-4a.75.75 0 010-1.5h4zm6.5 0a.75.75 0 110 1.5h-4a.75.75 0 110-1.5h4z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const LedgerCardManualCustomerInvoice = React.forwardRef(IconLedgerCardManualCustomerInvoice);
function IconLedgerCardObsoleteStock(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M7.25 16.5V18h-2.5a.75.75 0 110-1.5h2.5zm12 0a.75.75 0 110 1.5h-2.5v-1.5h2.5zm-7.75 0V18H8.25v-1.5h3.25zm4.25 0V18H12.5v-1.5h3.25zm-8.5-3.501v1.5l-2.5.001a.75.75 0 110-1.5l2.5-.001zm12 .001a.75.75 0 110 1.5l-2.5-.001v-1.5l2.5.001zm-7.75-.001v1.5H8.25v-1.5h3.25zm4.25 0v1.5H12.5v-1.5h3.25zM7.25 9.5V11h-2.5a.75.75 0 110-1.5h2.5zm12 0a.75.75 0 110 1.5h-2.5V9.5h2.5zm-7.75 0V11H8.25V9.5h3.25zm4.25 0V11H12.5V9.5h3.25zM7.25 6v1.5h-2.5a.75.75 0 010-1.5h2.5zm12 0a.75.75 0 110 1.5h-2.5V6h2.5zM11.5 6v1.5H8.25V6h3.25zm4.25 0v1.5H12.5V6h3.25z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const LedgerCardObsoleteStock = React.forwardRef(IconLedgerCardObsoleteStock);
function IconLedgerCardOpeningEntry(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M18.567 12.105a.4.4 0 01.1.309l-.29 2.798 2.434 1.41a.4.4 0 01-.116.737l-2.752.587-.587 2.752a.4.4 0 01-.738.116L15.21 18.38l-2.798.292a.4.4 0 01-.339-.666l1.88-2.092-1.141-2.571a.4.4 0 01.528-.528l2.57 1.141 2.093-1.88a.4.4 0 01.565.03zM19.25 3c.966 0 1.75.784 1.75 1.75V11h-1.5V6h-15v13.25a.25.25 0 00.193.243l.057.007H11V21H4.75A1.75 1.75 0 013 19.25V4.75C3 3.784 3.784 3 4.75 3h14.5zm-8.5 12.5a.75.75 0 110 1.5h-4a.75.75 0 110-1.5h4zm0-3.5a.75.75 0 110 1.5h-4a.75.75 0 110-1.5h4zm0-3.5a.75.75 0 110 1.5h-4a.75.75 0 010-1.5h4zm6.5 0a.75.75 0 110 1.5h-4a.75.75 0 110-1.5h4z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const LedgerCardOpeningEntry = React.forwardRef(IconLedgerCardOpeningEntry);
function IconLedgerCardReservedEntry(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M19.25 3c.966 0 1.75.784 1.75 1.75v14.5A1.75 1.75 0 0119.25 21H4.75a1.75 1.75 0 01-1.732-1.499L19.25 19.5a.25.25 0 00.243-.193l.007-.057L19.499 6h-15v3.5h-1.5L3 4.75C3 3.784 3.784 3 4.75 3h14.5zM6.28 10.97a.75.75 0 01.073.976l-.073.084-1.719 1.719 5.689.001a.75.75 0 110 1.5l-5.69-.001 1.72 1.72a.75.75 0 01-.976 1.134l-.084-.073-3-3-.08-.094-.051-.081-.05-.116-.027-.103-.01-.089v-.094l.018-.124.03-.099.047-.099.054-.082.069-.08 3-3a.75.75 0 011.06 0zm10.97 4.53a.75.75 0 110 1.5h-3.5a.75.75 0 110-1.5h3.5zm0-3.5a.75.75 0 110 1.5h-3.5a.75.75 0 110-1.5h3.5zm0-3.5a.75.75 0 110 1.5h-8.5a.75.75 0 010-1.5h8.5z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const LedgerCardReservedEntry = React.forwardRef(IconLedgerCardReservedEntry);
function IconLedgerCardShrinkagePilferage(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M12 15.25a.75.75 0 01.743.648l.007.102v3.439l1.22-1.22a.75.75 0 011.133.977l-.073.084-2.5 2.5a.754.754 0 01-.078.069l.078-.069-.042.04-.052.04-.114.068-.098.038-.116.026-.056.006h-.104l-.119-.018-.098-.03-.1-.047-.082-.054-.08-.069-2.5-2.5a.75.75 0 01.977-1.133l.084.073 1.22 1.219V16a.75.75 0 01.75-.75zm-4.75-2.751v1.5L4.75 14a.75.75 0 110-1.5l2.5-.001zm12 .001a.75.75 0 110 1.5l-2.5-.001v-1.5l2.5.001zm-7.75-.001v1.5H8.25v-1.5h3.25zm4.25 0v1.5H12.5v-1.5h3.25zm-8.5-3.5v1.5l-2.5.001a.75.75 0 110-1.5l2.5-.001zm12 .001a.75.75 0 110 1.5l-2.5-.001v-1.5l2.5.001zm-7.75-.001v1.5H8.25v-1.5h3.25zm4.25 0v1.5H12.5v-1.5h3.25zm3.5-3.499a.75.75 0 110 1.5H4.75a.75.75 0 010-1.5h14.5zm0-3.5a.75.75 0 110 1.5H4.75a.75.75 0 010-1.5h14.5z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const LedgerCardShrinkagePilferage = React.forwardRef(IconLedgerCardShrinkagePilferage);
function IconLedgerCardStockAdjustment(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M19.25 20.5a.75.75 0 110 1.5H4.75a.75.75 0 110-1.5h14.5zm0-3.5a.75.75 0 110 1.5H4.75a.75.75 0 110-1.5h14.5zm0-3.5a.75.75 0 110 1.5H4.75a.75.75 0 110-1.5h14.5zm0-3.5a.75.75 0 110 1.5H4.75a.75.75 0 110-1.5h14.5zm-2.5-8a.75.75 0 01.743.648l.007.102v3.439l1.22-1.22a.75.75 0 011.133.977l-.073.084-2.5 2.5a.754.754 0 01-.078.069l.078-.069-.042.04-.052.04-.114.068-.098.038-.084.02-.088.012-.052.002-.052-.002-.119-.018-.098-.03-.1-.047-.082-.054-.08-.069-2.5-2.5a.75.75 0 01.977-1.133l.084.073L16 6.189V2.75a.75.75 0 01.75-.75zm-9.576.004l.128-.002.119.018.098.03.1.047.051.032.038.027.072.064 2.5 2.5a.75.75 0 01-.976 1.133L9.22 5.78 7.999 4.56 8 8a.75.75 0 01-1.493.102L6.5 8l-.001-3.438L5.28 5.78a.75.75 0 01-1.133-.976l.073-.084 2.5-2.5.042-.04.052-.04.114-.068.098-.038.084-.02a.75.75 0 01.064-.01z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const LedgerCardStockAdjustment = React.forwardRef(IconLedgerCardStockAdjustment);
function IconLedgerCardTransferredOpeningEntry(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M18.567 12.105a.4.4 0 01.1.309l-.29 2.798 2.434 1.41a.4.4 0 01-.116.737l-2.752.587-.587 2.752a.4.4 0 01-.738.116L15.21 18.38l-2.798.292a.4.4 0 01-.339-.666l1.88-2.092-1.141-2.571a.4.4 0 01.528-.528l2.57 1.141 2.093-1.88a.4.4 0 01.565.03zM4.5 15v4.25a.25.25 0 00.193.243l.057.007H11V21H4.75A1.75 1.75 0 013 19.25V15h1.5zm6.28-1.72l-3 3-.084.073a.75.75 0 01-1.049-1.05l.073-.083 1.718-1.72H2.75a.75.75 0 110-1.5h5.689l-1.72-1.72a.75.75 0 01.977-1.133l.084.073 3 3a.754.754 0 01.092.11l.054.095.035.086.027.103.01.084-.001.121-.017.102-.019.068-.023.06-.035.07-.06.09-.063.071zM19.25 3c.966 0 1.75.784 1.75 1.75V11h-1.5V6h-15v4.5H3V4.75C3 3.784 3.784 3 4.75 3h14.5z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const LedgerCardTransferredOpeningEntry = React.forwardRef(IconLedgerCardTransferredOpeningEntry);
function IconLedgerCard(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M7.5 16c2.434 0 3.88 1.316 4.34 3.95A1.75 1.75 0 0110.116 22H4.884a1.75 1.75 0 01-1.724-2.05C3.62 17.315 5.066 16 7.5 16zM19.25 2c.966 0 1.75.784 1.75 1.75v14.5A1.75 1.75 0 0119.25 20h-6.038l-.01-.063a11.184 11.184 0 00-.369-1.437h6.417a.25.25 0 00.243-.193l.007-.057V3.75a.25.25 0 00-.193-.243L19.25 3.5H7.75a.25.25 0 00-.243.193L7.5 3.75V9.5c-.54 0-1.053.164-1.5.464V3.75C6 2.784 6.784 2 7.75 2h11.5zM7.5 10.5c1.105 0 2 1.12 2 2.5s-.895 2.5-2 2.5-2-1.12-2-2.5.895-2.5 2-2.5zm9.75 3.5a.75.75 0 110 1.5h-4.5a.75.75 0 110-1.5h4.5zm0-4a.75.75 0 110 1.5h-6a.75.75 0 110-1.5h6zm0-4a.75.75 0 110 1.5h-7.5a.75.75 0 010-1.5h7.5z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const LedgerCard = React.forwardRef(IconLedgerCard);
function IconLightbulb(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M14.598 20.501a2.999 2.999 0 01-5.196 0h5.196zm.152-2.251a.75.75 0 110 1.5h-5.5a.75.75 0 110-1.5h5.5zM12 4.5c3.314 0 6 2.716 6 6.067 0 1.502-.517 2.528-1.087 3.398l-.265.392-.39.561c-.418.614-.761 1.208-.82 1.929l-.01.22c0 .256-.112.4-.338.428L15 17.5H9c-.254 0-.395-.114-.423-.342l-.006-.091c0-.774-.328-1.414-.75-2.064l-.262-.392-.273-.402-.24-.364C6.492 12.978 6 11.973 6 10.567 6 7.217 8.686 4.5 12 4.5zM12 6c-2.482 0-4.5 2.04-4.5 4.567 0 .931.245 1.599.876 2.573l.647.96.152.234c.322.512.56.988.709 1.474l.052.192h4.128l.054-.192c.126-.402.314-.796.561-1.208l.156-.25.235-.352.408-.587c.736-1.07 1.022-1.78 1.022-2.844C16.5 8.04 14.482 6 12 6zm-5.846 7.875a.75.75 0 01-.19.968l-.084.057-.866.5a.75.75 0 01-.835-1.243l.085-.057.866-.5a.75.75 0 011.024.275zm12.625-.32l.091.045.866.5a.75.75 0 01-.658 1.344l-.092-.044-.866-.5a.75.75 0 01.659-1.344zm2.33-4.661a.75.75 0 01-.509.844l-.099.025-.985.173a.75.75 0 01-.36-1.453l.1-.024.985-.174a.75.75 0 01.868.609zm-17.451-.62l.101.011.985.174a.75.75 0 01-.159 1.488l-.101-.01-.985-.174a.75.75 0 01.159-1.489zm14.288-4.86a.75.75 0 01.152.974l-.06.083-.643.766a.75.75 0 01-1.209-.882l.06-.082.643-.766a.75.75 0 011.057-.093zM7.04 3.433l.07.074.644.766A.75.75 0 016.675 5.31l-.07-.073-.643-.766A.75.75 0 017.04 3.433zM12 1.25a.75.75 0 01.743.648L12.75 2v1a.75.75 0 01-1.493.102L11.25 3V2a.75.75 0 01.75-.75z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Lightbulb = React.forwardRef(IconLightbulb);
function IconLine(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M18 11.25a.75.75 0 01.102 1.493L18 12.75H6a.75.75 0 01-.102-1.493L6 11.25h12z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Line$2 = React.forwardRef(IconLine);
function IconLinkExternal(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M11 5.5H7.25A1.75 1.75 0 005.5 7.25v9.5c0 .966.784 1.75 1.75 1.75h9.5a1.75 1.75 0 001.75-1.75V13H17v3.75a.25.25 0 01-.25.25h-9.5a.25.25 0 01-.25-.25v-9.5A.25.25 0 017.25 7H11V5.5z"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M17.75 5.5a.75.75 0 01.743.648l.007.102v3.5a.75.75 0 01-1.493.102L17 9.75V8.06l-3.97 3.97a.75.75 0 01-1.133-.976l.073-.084L15.938 7H14.25a.75.75 0 01-.743-.648L13.5 6.25a.75.75 0 01.648-.743l.102-.007h3.5z",
      clipRule: "evenodd"
    }
  ));
}
const LinkExternal = React.forwardRef(IconLinkExternal);
function IconListBulleted(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M6.25 16a.75.75 0 01.75.75v2.5a.75.75 0 01-.75.75h-2.5a.75.75 0 01-.75-.75v-2.5a.75.75 0 01.75-.75h2.5zm14 1.25a.75.75 0 01.102 1.493l-.102.007H10a.75.75 0 01-.102-1.493L10 17.25h10.25zM6.25 10a.75.75 0 01.75.75v2.5a.75.75 0 01-.75.75h-2.5a.75.75 0 01-.75-.75v-2.5a.75.75 0 01.75-.75h2.5zm14 1.25a.75.75 0 01.102 1.493l-.102.007H10a.75.75 0 01-.102-1.493L10 11.25h10.25zM6.25 4a.75.75 0 01.75.75v2.5a.75.75 0 01-.75.75h-2.5A.75.75 0 013 7.25v-2.5A.75.75 0 013.75 4h2.5zm14 1.25a.75.75 0 01.102 1.493l-.102.007H10a.75.75 0 01-.102-1.493L10 5.25h10.25z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const ListBulleted = React.forwardRef(IconListBulleted);
function IconListSearch(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M17.5 11a4.5 4.5 0 013.632 7.158l.036-.05 1.862 1.862a.75.75 0 01-.976 1.133l-.084-.073-1.863-1.862-.112.077A4.5 4.5 0 1117.5 11zm-6.25 7.5a.75.75 0 110 1.5h-8.5a.75.75 0 110-1.5h8.5zm6.25-6a3 3 0 100 6 3 3 0 000-6zm-7.25 1.167a.75.75 0 110 1.5h-7.5a.75.75 0 010-1.5h7.5zm3-4.834a.75.75 0 110 1.5H2.75a.75.75 0 110-1.5h10.5zm8-4.833a.75.75 0 110 1.5H2.75a.75.75 0 010-1.5h18.5z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const ListSearch = React.forwardRef(IconListSearch);
function IconList(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M19.25 18a.75.75 0 110 1.5H4.75a.75.75 0 110-1.5h14.5zm0-4.5a.75.75 0 110 1.5H4.75a.75.75 0 110-1.5h14.5zm0-4.5a.75.75 0 110 1.5H4.75a.75.75 0 110-1.5h14.5zm0-4.5a.75.75 0 110 1.5H4.75a.75.75 0 010-1.5h14.5z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const List$2 = React.forwardRef(IconList);
function IconLocation(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M5.843 4.568a8.707 8.707 0 0112.314 12.314l-1.187 1.174c-.875.858-2.01 1.962-3.406 3.312a2.25 2.25 0 01-3.128 0l-3.491-3.396c-.44-.431-.806-.794-1.102-1.09a8.707 8.707 0 010-12.314zm11.253 1.06A7.207 7.207 0 106.903 15.822l1.488 1.468c.818.801 1.848 1.801 3.088 3a.75.75 0 001.042 0l3.395-3.3c.47-.461.863-.85 1.18-1.168a7.207 7.207 0 000-10.192zM12 7.999a3.002 3.002 0 110 6.004A3.002 3.002 0 0112 8zm0 1.5a1.502 1.502 0 100 3.004A1.502 1.502 0 0012 9.5z",
      fill: "currentColor"
    }
  ));
}
const Location = React.forwardRef(IconLocation);
function IconLockOpen(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M12 1a5.001 5.001 0 014.87 3.863.75.75 0 01-1.461.34 3.502 3.502 0 00-6.904.605L8.5 6v2h9.75c.966 0 1.75.784 1.75 1.75v10.5A1.75 1.75 0 0118.25 22H5.75A1.75 1.75 0 014 20.25V9.75C4 8.784 4.784 8 5.75 8H7V6a5 5 0 015-5zm6.25 8.5H5.75a.25.25 0 00-.243.193L5.5 9.75v10.5a.25.25 0 00.193.243l.057.007h12.5a.25.25 0 00.243-.193l.007-.057V9.75a.25.25 0 00-.193-.243L18.25 9.5zM12 13a1.5 1.5 0 01.751 2.799l-.001.951a.75.75 0 11-1.5 0v-.95A1.5 1.5 0 0112 13z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const LockOpen = React.forwardRef(IconLockOpen);
function IconLock(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 1a5 5 0 015 5v2h1.25c.966 0 1.75.784 1.75 1.75v10.5A1.75 1.75 0 0118.25 22H5.75A1.75 1.75 0 014 20.25V9.75C4 8.784 4.784 8 5.75 8H7V6a5 5 0 015-5zm6.25 8.5H5.75a.25.25 0 00-.243.193L5.5 9.75v10.5a.25.25 0 00.193.243l.057.007h12.5a.25.25 0 00.243-.193l.007-.057V9.75a.25.25 0 00-.193-.243L18.25 9.5zM12 13a1.5 1.5 0 01.751 2.799l-.001.951a.75.75 0 01-1.5 0v-.95A1.5 1.5 0 0112 13zm0-10.5a3.5 3.5 0 00-3.495 3.308L8.5 6v2h7V6a3.5 3.5 0 00-3.308-3.495L12 2.5z",
      fill: "currentColor"
    }
  ));
}
const Lock = React.forwardRef(IconLock);
function IconLogOut(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.25 4.5H6.5v15h6.75a1.25 1.25 0 110 2.5h-7A2.25 2.25 0 014 19.75V4.25A2.25 2.25 0 016.25 2h7a1.25 1.25 0 110 2.5zm6.384 2.616l-.102-.091a1.25 1.25 0 00-1.666 1.859l1.867 1.866H11.75l-.128.007a1.25 1.25 0 00.128 2.493h7.982l-1.866 1.866-.091.102a1.25 1.25 0 001.859 1.666l4-4 .08-.089.05-.063.068-.106.058-.112.049-.127.03-.108.016-.088.012-.112L24 12l-.004-.096-.016-.13-.03-.127-.03-.087-.046-.107-.046-.086-.065-.1a1.267 1.267 0 00-.13-.15l-4-4zm4.084 4.094l-.084-.094c.03.03.058.061.084.094z",
      fill: "currentColor"
    }
  ));
}
const LogOut = React.forwardRef(IconLogOut);
function IconLog(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M13.586 2a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V10.5h-1.5V9h-3.75a1.75 1.75 0 01-1.744-1.606L13 7.25V3.5H5.75a.25.25 0 00-.243.193L5.5 3.75v16.5a.25.25 0 00.193.243l.057.007h12.5a.25.25 0 00.243-.193l.007-.057V19H20v1.25A1.75 1.75 0 0118.25 22H5.75A1.75 1.75 0 014 20.25V3.75C4 2.784 4.784 2 5.75 2h7.836zm-.105 10.074c1.447 0 2.3.875 2.367 2.279l.004.178v.621c0 1.5-.863 2.446-2.371 2.446-1.444 0-2.304-.872-2.371-2.268l-.004-.178v-.62c0-1.516.871-2.458 2.375-2.458zm5.362 0c1.328 0 2.058.776 2.172 1.653l.012.132h-1.25c-.074-.414-.406-.734-.945-.734-.638 0-1.007.443-1.05 1.222l-.005.16v.626c0 .805.293 1.414 1.09 1.414.598 0 .914-.34.956-.745l.005-.095v-.234h-.93v-.903h2.14v1.04c0 1.038-.667 1.988-2.199 1.988-1.57 0-2.3-.987-2.355-2.296l-.004-.165v-.64c0-1.427.84-2.423 2.363-2.423zm-10.182.094v4.262h2.141v1.07H7.376v-5.332h1.285zm4.82.95c-.597 0-1.012.415-1.062 1.23l-.005.168v.64c0 .926.43 1.399 1.067 1.399.593 0 1.008-.416 1.057-1.23l.005-.169v-.64c0-.926-.43-1.399-1.062-1.399zM14.5 4.62v2.63a.25.25 0 00.193.243l.057.007h2.63L14.5 4.621z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Log = React.forwardRef(IconLog);
function IconMarket(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M7 17.5a.5.5 0 01.5.5v3.5a.5.5 0 01-.5.5H3.5a.5.5 0 01-.5-.5V18a.5.5 0 01.5-.5H7zm5.5 0a.5.5 0 01.5.5v3.5a.5.5 0 01-.5.5H9a.5.5 0 01-.5-.5V18a.5.5 0 01.5-.5h3.5zm5.5 0a.5.5 0 01.5.5v3.5a.5.5 0 01-.5.5h-3.5a.5.5 0 01-.5-.5V18a.5.5 0 01.5-.5H18zM7 12a.5.5 0 01.5.5V16a.5.5 0 01-.5.5H3.5A.5.5 0 013 16v-3.5a.5.5 0 01.5-.5H7zm5.5 0a.5.5 0 01.5.5V16a.5.5 0 01-.5.5H9a.5.5 0 01-.5-.5v-3.5A.5.5 0 019 12h3.5zm6.97-2.523l.906 3.381a.5.5 0 01-.353.612l-3.381.906a.5.5 0 01-.612-.353l-.906-3.381a.5.5 0 01.353-.612l3.381-.906a.5.5 0 01.612.353zM7 6.5a.5.5 0 01.5.5v3.5a.5.5 0 01-.5.5H3.5a.5.5 0 01-.5-.5V7a.5.5 0 01.5-.5H7zm3.642-2.376l3.38.906a.5.5 0 01.354.612l-.906 3.38a.5.5 0 01-.612.354l-3.38-.906a.5.5 0 01-.354-.612l.906-3.38a.5.5 0 01.612-.354zM20 2a.5.5 0 01.5.5V6a.5.5 0 01-.5.5h-3.5A.5.5 0 0116 6V2.5a.5.5 0 01.5-.5H20z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Market = React.forwardRef(IconMarket);
function IconMastercardOs(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M14.698 7.314H9.286v9.66h5.412v-9.66z", fill: "#FF5A00" }), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M9.646 12.144c0-1.963.929-3.704 2.354-4.83A6.178 6.178 0 008.185 6C4.766 6 2 8.748 2 12.144s2.766 6.143 6.185 6.143A6.178 6.178 0 0012 16.973a6.117 6.117 0 01-2.354-4.83z",
      fill: "#EB001B"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M22 12.144c0 3.396-2.766 6.143-6.185 6.143A6.178 6.178 0 0112 16.973a6.095 6.095 0 002.354-4.83A6.146 6.146 0 0012 7.315 6.168 6.168 0 0115.813 6C19.233 6 22 8.766 22 12.144z",
      fill: "#F79E1B"
    }
  ));
}
const MastercardOs = React.forwardRef(IconMastercardOs);
function IconMatchAmount(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M13.586 2a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V20.25A1.75 1.75 0 0118.25 22H13l-.001-1.5h5.251a.25.25 0 00.243-.193l.007-.057L18.499 9H14.75a1.75 1.75 0 01-1.744-1.606L13 7.25l-.001-3.75H5.75a.25.25 0 00-.243.193L5.5 3.75 5.499 13H4V3.75C4 2.784 4.784 2 5.75 2h7.836zM4.142 16.956a.5.5 0 01.55-.147l.082.038 2.143 1.237.074.052a.5.5 0 01.147.55l-.038.081-.052.074a.5.5 0 01-.55.147l-.081-.038-.878-.505a2.5 2.5 0 004 1.525.75.75 0 11.925 1.181 4.002 4.002 0 01-6.343-2.173l-.402.695-.052.074a.5.5 0 01-.852-.492l.038-.082 1.238-2.143.051-.074zM8 14a4.001 4.001 0 013.92 3.197l.358-.62a.5.5 0 01.6-.221l.083.038a.5.5 0 01.22.601l-.037.082-1.238 2.143a.5.5 0 01-.6.221l-.083-.038-2.143-1.237a.5.5 0 01.418-.904l.082.038.914.528a2.5 2.5 0 00-4.033-1.798.75.75 0 11-.925-1.181A3.985 3.985 0 018 14zm6.499-9.38l.001 2.63a.25.25 0 00.193.243l.057.007h2.629l-2.88-2.88z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const MatchAmount = React.forwardRef(IconMatchAmount);
function IconMatchEntries(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M19.25 3a1.75 1.75 0 011.744 1.606L21 4.75v14.5a1.75 1.75 0 01-1.606 1.744L19.25 21H12v-1.5h7.25a.25.25 0 00.243-.193l.007-.057V5.996L19.406 6H4.5l.001 6H3V4.75a1.75 1.75 0 011.606-1.744L4.75 3h14.5zM3.696 15.809l.082.038 2.143 1.237.074.052a.5.5 0 01.147.55l-.038.081-.052.074a.5.5 0 01-.55.147l-.081-.038-.878-.505a2.5 2.5 0 004 1.525.75.75 0 11.925 1.181 4.002 4.002 0 01-6.343-2.173l-.402.695-.052.074a.5.5 0 01-.852-.492l.038-.082 1.238-2.143.051-.074a.5.5 0 01.55-.147zM7.002 13a4.001 4.001 0 013.92 3.197l.357-.62a.5.5 0 01.602-.221l.081.038a.5.5 0 01.221.601l-.038.082-1.237 2.143a.5.5 0 01-.601.221l-.082-.038-2.143-1.237a.5.5 0 01.418-.904l.082.038.914.528a2.5 2.5 0 00-4.034-1.798.75.75 0 11-.924-1.181A3.985 3.985 0 017.002 13zm10.248 2a.75.75 0 110 1.5h-2.5a.75.75 0 110-1.5h2.5zm-.125-3.5c.483 0 .875.336.875.75s-.392.75-.875.75h-5.25c-.483 0-.875-.336-.875-.75s.392-.75.875-.75h5.25zM17.25 8a.75.75 0 110 1.5H6.75a.75.75 0 010-1.5h10.5z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const MatchEntries = React.forwardRef(IconMatchEntries);
function IconMenu(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M4 19h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zm0-6h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zM3 6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1z",
      fill: "currentColor"
    }
  ));
}
const Menu$2 = React.forwardRef(IconMenu);
function IconMileage(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M12 2c5.523 0 10 4.477 10 10 0 1.806-.479 3.5-1.316 4.962L20.66 17a.75.75 0 01-.933.32l-.091-.045-1.516-.875a.75.75 0 01.659-1.344l.091.044.84.485c.406-.874.67-1.83.757-2.834l-.967-.001a.75.75 0 01-.102-1.493l.102-.007h.967a8.447 8.447 0 00-.757-2.834l-.84.484a.75.75 0 01-.835-1.243l.085-.057.838-.483a8.548 8.548 0 00-2.075-2.075l-.483.838a.75.75 0 01-1.344-.659l.044-.091.484-.84a8.447 8.447 0 00-2.833-.757l-.001.967a.75.75 0 01-1.493.102L11.25 4.5v-.967a8.447 8.447 0 00-2.834.757l.484.84a.75.75 0 01-1.243.835L7.6 5.88l-.483-.838a8.548 8.548 0 00-2.075 2.075l.838.483a.75.75 0 01-.659 1.344L5.13 8.9l-.84-.484a8.447 8.447 0 00-.757 2.834H4.5a.75.75 0 01.102 1.493l-.102.007h-.967a8.427 8.427 0 00.758 2.835l.839-.485a.75.75 0 01.835 1.243l-.085.057-1.516.875A.75.75 0 013.34 17l-.02-.04-.003.003A9.954 9.954 0 012 12C2 6.477 6.477 2 12 2zm4.03 5.97a.75.75 0 01.073.976l-.073.084-2.792 2.794a1.25 1.25 0 11-1.061-1.061L14.97 7.97a.75.75 0 011.06 0z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Mileage = React.forwardRef(IconMileage);
function IconModalResize(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M12 15.5a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm5 0a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm-10 0a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm5-5a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm5 0a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm0-5a1.5 1.5 0 110 3 1.5 1.5 0 010-3z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const ModalResize = React.forwardRef(IconModalResize);
function IconModalShrink(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M19.25 3c.966 0 1.75.784 1.75 1.75v14.5A1.75 1.75 0 0119.25 21H13.5v-1.5h5.75a.25.25 0 00.243-.193l.007-.057V4.75a.25.25 0 00-.193-.243L19.25 4.5H4.75a.25.25 0 00-.243.193L4.5 4.75v5.75H3V4.75C3 3.784 3.784 3 4.75 3h14.5zm-9 9c.966 0 1.75.784 1.75 1.75v5.5A1.75 1.75 0 0110.25 21h-5.5A1.75 1.75 0 013 19.25v-5.5c0-.966.784-1.75 1.75-1.75h5.5zm0 1.5h-5.5a.25.25 0 00-.243.193l-.007.057v5.5a.25.25 0 00.193.243l.057.007h5.5a.25.25 0 00.243-.193l.007-.057v-5.5a.25.25 0 00-.193-.243l-.057-.007zm7.78-7.53a.75.75 0 01.073.976l-.073.084-3.22 3.22h1.69a.75.75 0 01.743.648l.007.102a.75.75 0 01-.648.743l-.102.007H13a.75.75 0 01-.743-.648L12.25 11V7.5a.75.75 0 011.493-.102l.007.102v1.688l3.22-3.218a.75.75 0 011.06 0z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const ModalShrink = React.forwardRef(IconModalShrink);
function IconMoreSolid(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 8.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm0 5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm0-10a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const MoreSolid = React.forwardRef(IconMoreSolid);
function IconMore(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M12 10a2 2 0 110 4 2 2 0 010-4zm0 6.5a2 2 0 110 4 2 2 0 010-4zm0-13a2 2 0 110 4 2 2 0 010-4z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const More = React.forwardRef(IconMore);
function IconMove(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M6.924 6.254l.128-.002.119.018.098.03.1.047.051.032.038.027.072.064 3.5 3.5a.75.75 0 01-.976 1.133l-.084-.073-2.22-2.219V17a.75.75 0 01-1.493.102L6.25 17V8.811l-2.22 2.22a.75.75 0 01-1.133-.977l.073-.084 3.5-3.5.042-.04.052-.04.114-.068.098-.038.084-.02a.75.75 0 01.064-.01zM17 6.25a.75.75 0 01.743.648L17.75 7l-.001 8.19 2.22-2.22a.75.75 0 011.134.976l-.073.084-3.5 3.5a.754.754 0 01-.078.069l.078-.069-.042.04-.052.04-.114.068-.098.038-.084.02-.088.012-.052.002-.052-.002-.119-.018-.098-.03-.1-.047-.082-.054-.08-.069-3.5-3.5a.75.75 0 01.977-1.133l.084.073 2.219 2.218L16.25 7a.75.75 0 01.75-.75z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Move = React.forwardRef(IconMove);
function IconNavigationList(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M5.5 22v-.018A1.75 1.75 0 014 20.25V3.75c0-.882.652-1.61 1.5-1.732V2h12.75c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0118.25 22H5.5zM9 18.3H5.5v1.95a.25.25 0 00.193.243l.057.007H9v-2.2zm9.25-14.8H10.5v17h7.75a.25.25 0 00.243-.193l.007-.057V3.75a.25.25 0 00-.193-.243L18.25 3.5zM9 14.6H5.5v2.2H9v-2.2zm0-3.7H5.5v2.2H9v-2.2zm0-3.7H5.5v2.2H9V7.2zm0-3.7H5.75a.25.25 0 00-.243.193L5.5 3.75V5.7H9V3.5z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const NavigationList = React.forwardRef(IconNavigationList);
function IconNoteFollowUp(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M18.25 2c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0118.25 22H14v-1.5h4.25a.25.25 0 00.243-.193l.007-.057V3.75a.25.25 0 00-.193-.243L18.25 3.5H5.75a.25.25 0 00-.243.193L5.5 3.75V11H4V3.75C4 2.784 4.784 2 5.75 2h12.5zM9.225 20.974A1.259 1.259 0 018 22c-.605 0-1.11-.44-1.225-1.026h2.45zM8 12c.456 0 .841.392.961.927A3 3 0 0111 15.769v2.898l.835.642a.5.5 0 01-.305.896H4.47a.5.5 0 01-.305-.896L5 18.667v-2.898c0-1.32.854-2.442 2.04-2.843.119-.534.504-.926.96-.926zm7.25 2.5a.75.75 0 110 1.5h-1.5a.75.75 0 110-1.5h1.5zm0-3.5a.75.75 0 110 1.5h-3.5a.75.75 0 110-1.5h3.5zm0-3.5a.75.75 0 110 1.5h-6.5a.75.75 0 010-1.5h6.5z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const NoteFollowUp = React.forwardRef(IconNoteFollowUp);
function IconNoteRead(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M16.75 2a.75.75 0 01.75.75V3h1.75a1.75 1.75 0 011.744 1.606L21 4.75v14.5a1.75 1.75 0 01-1.606 1.744L19.25 21H4.75a1.75 1.75 0 01-1.744-1.606L3 19.25V4.75a1.75 1.75 0 011.606-1.744L4.75 3H6.5v-.25a.75.75 0 011.5 0V3h3.25v-.25a.75.75 0 111.5 0V3H16v-.25a.75.75 0 01.75-.75zM6.499 4.5H4.75l-.057.007a.25.25 0 00-.184.175L4.5 4.75v14.5l.007.057a.25.25 0 00.175.184l.068.009h14.5l.057-.007a.25.25 0 00.184-.175l.009-.068V4.75l-.007-.057a.25.25 0 00-.175-.184L19.25 4.5H17.5v.25a.75.75 0 11-1.5 0V4.5h-3.25v.25a.75.75 0 11-1.5 0V4.5H7.999L8 4.75a.75.75 0 01-1.5 0l-.001-.25zM16.25 12a.75.75 0 110 1.5h-8.5a.75.75 0 110-1.5h8.5zm0-3a.75.75 0 110 1.5h-8.5a.75.75 0 110-1.5h8.5z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const NoteRead = React.forwardRef(IconNoteRead);
function IconNote(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M16.75 2a.75.75 0 01.75.75V3h1.75a1.75 1.75 0 011.744 1.606L21 4.75V14h-1.5V4.75l-.007-.057a.25.25 0 00-.175-.184L19.25 4.5H17.5v.25a.75.75 0 11-1.5 0V4.5h-3.25v.25a.75.75 0 11-1.5 0V4.5H7.999L8 4.75a.75.75 0 01-1.5 0l-.001-.25H4.75l-.057.007a.25.25 0 00-.184.175L4.5 4.75v14.5l.007.057a.25.25 0 00.175.184l.068.009H14V21H4.75a1.75 1.75 0 01-1.744-1.606L3 19.25V4.75a1.75 1.75 0 011.606-1.744L4.75 3H6.5v-.25a.75.75 0 011.5 0V3h3.25v-.25a.75.75 0 111.5 0V3H16v-.25a.75.75 0 01.75-.75zm-3.94 7.75l7.513 7.513a1.75 1.75 0 01.114 2.35l-.114.124-.586.586a1.75 1.75 0 01-2.35.114l-.124-.114-7.513-7.512V9.75h3.06zm5.697 7.818l-.938.94.754.755a.25.25 0 00.24.065l.06-.025.054-.04.586-.586a.25.25 0 00.04-.3l-.04-.054-.756-.755zm-6.318-6.318h-.939v.939l5.258 5.258.938-.94-5.257-5.257z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Note = React.forwardRef(IconNote);
function IconNovemberFirst(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M21.484 8.828C19.73 3.592 14.065.768 8.829 2.519 3.592 4.271.767 9.936 2.519 15.172c1.752 5.237 7.418 8.06 12.655 6.308a9.997 9.997 0 006.31-12.653z",
      fill: "#0D2840"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M13.977 7.263v5.445l-4.14-5.445H7.264l.78 1.156v7.686h1.919v-5.619l4.28 5.62H15.9V7.262h-1.922z",
      fill: "#2CD7B3"
    }
  ));
}
const NovemberFirst = React.forwardRef(IconNovemberFirst);
function IconNumbers(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M3.203 16.625c0 .602.328.96.875.96.555 0 .875-.35.875-.96V7.898c0-.671-.437-1.132-1.078-1.132-.375 0-.742.14-1.273.515L1.125 8.344c-.367.25-.54.508-.54.789 0 .367.282.656.65.656.195 0 .382-.07.663-.266l1.258-.898h.047v8zm4.149.031c0 .516.414.844 1.046.844h5.22c.53 0 .843-.281.843-.734 0-.461-.328-.743-.844-.743H9.648v-.101l2.665-2.953c1.367-1.492 1.812-2.313 1.812-3.36 0-1.742-1.43-2.984-3.422-2.984-2.086 0-3.492 1.375-3.492 2.742 0 .485.312.813.766.813.367 0 .617-.211.804-.657.266-.906.93-1.43 1.82-1.43 1.063 0 1.774.665 1.774 1.657 0 .688-.344 1.313-1.21 2.266l-3.071 3.406c-.563.601-.742.89-.742 1.234zm8.562-1.375c0 1.242 1.555 2.446 3.617 2.446 2.274 0 3.867-1.297 3.867-3.141 0-1.352-.992-2.484-2.296-2.617v-.11c1.078-.171 1.953-1.257 1.953-2.421 0-1.649-1.461-2.813-3.524-2.813-1.984 0-3.414 1.156-3.414 2.39 0 .454.305.766.742.766.344 0 .578-.164.782-.578.367-.742 1.007-1.156 1.851-1.156 1.086 0 1.828.648 1.828 1.61 0 .952-.758 1.64-1.804 1.64h-.813c-.43 0-.726.305-.726.71 0 .423.304.735.726.735h.86c1.25 0 2.085.719 2.085 1.79 0 1.077-.82 1.765-2.093 1.765-.961 0-1.711-.422-2.14-1.188-.25-.414-.47-.57-.782-.57-.422 0-.719.313-.719.742z",
      fill: "currentColor"
    }
  ));
}
const Numbers = React.forwardRef(IconNumbers);
function IconPartnerApi(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M9.884 11.616a1.25 1.25 0 01.091 1.666l-.091.102-1.868 1.866H19a1.25 1.25 0 01.128 2.494L19 17.75H8.017l1.867 1.866a1.25 1.25 0 01-1.666 1.859l-.102-.091-4-4a1.26 1.26 0 01-.13-.152l-.068-.106-.042-.079-.046-.107-.03-.087-.03-.127-.016-.126-.004-.1.002-.08.013-.111.016-.088.03-.108.05-.127.086-.16.062-.088.064-.076 4.043-4.046a1.25 1.25 0 011.768 0zm5.898-9.091l.102.091 4 4c.03.03.058.061.084.094l-.084-.094c.048.048.09.099.13.152l.064.099.046.086.046.107.03.087.03.127.016.13.004.096-.002.08-.013.111-.016.088-.03.108-.05.127-.057.112-.069.106-.048.063-.081.089-4 4a1.25 1.25 0 01-1.859-1.666l.091-.102 1.866-1.866H5a1.25 1.25 0 01-.128-2.494L5 6.25h10.983l-1.867-1.866a1.25 1.25 0 011.666-1.859z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const PartnerApi = React.forwardRef(IconPartnerApi);
function IconPaymentPaid(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.535 6.5h2.715a.25.25 0 01.25.25v2.715A3.502 3.502 0 0117.535 6.5zm-11.07 0H3.75a.25.25 0 00-.25.25v2.715A3.502 3.502 0 006.465 6.5zm1.51 0A5.002 5.002 0 013.5 10.975v2.05A5.002 5.002 0 017.975 17.5H14.5V19H3.75A1.75 1.75 0 012 17.25V6.75C2 5.784 2.784 5 3.75 5h16.5c.966 0 1.75.784 1.75 1.75v4.75h-1.5v-.525A5.002 5.002 0 0116.025 6.5h-8.05zM3.5 17.25v-2.715A3.502 3.502 0 016.465 17.5H3.75a.25.25 0 01-.25-.25zM14 12a2 2 0 11-4 0 2 2 0 014 0zm1.5 0a3.5 3.5 0 11-7 0 3.5 3.5 0 017 0zm5.095 1.608a.86.86 0 011.049-.14c.344.201.467.603.306.937l-.057.098-3.118 4.152-.07.087a.859.859 0 01-1.17.059l-.079-.08-1.878-2.164-.068-.092a.713.713 0 01.194-.962.863.863 0 011.06.035l.081.082 1.169 1.345 2.51-3.268.071-.089z",
      fill: "currentColor"
    }
  ));
}
const PaymentPaid = React.forwardRef(IconPaymentPaid);
function IconPaymentUnpaid(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.535 6.5h2.715a.25.25 0 01.25.25v2.715A3.502 3.502 0 0117.535 6.5zm-11.07 0H3.75a.25.25 0 00-.25.25v2.715A3.502 3.502 0 006.465 6.5zm1.51 0A5.002 5.002 0 013.5 10.975v2.05A5.002 5.002 0 017.975 17.5H14.5V19H3.75A1.75 1.75 0 012 17.25V6.75C2 5.784 2.784 5 3.75 5h16.5c.966 0 1.75.784 1.75 1.75v4.75h-1.5v-.525A5.002 5.002 0 0116.025 6.5h-8.05zM3.5 17.25v-2.715A3.502 3.502 0 016.465 17.5H3.75a.25.25 0 01-.25-.25zM14 12a2 2 0 11-4 0 2 2 0 014 0zm1.5 0a3.5 3.5 0 11-7 0 3.5 3.5 0 017 0zm6.297 1.203a.692.692 0 00-.901-.067l-.078.067L19 15.02l-1.818-1.818-.078-.067a.692.692 0 00-.901 1.046L18.02 16l-1.818 1.818-.067.078a.692.692 0 00.968.968l.078-.067L19 16.98l1.818 1.818.078.067a.692.692 0 00.901-1.046L19.98 16l1.818-1.818.067-.078a.692.692 0 00-.067-.901z",
      fill: "currentColor"
    }
  ));
}
const PaymentUnpaid = React.forwardRef(IconPaymentUnpaid);
function IconPeriod(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M20.25 6c.966 0 1.75.784 1.75 1.75v12.5A1.75 1.75 0 0120.25 22H7.75A1.75 1.75 0 016 20.25V19h1.5v1.25a.25.25 0 00.193.243l.057.007h12.5a.25.25 0 00.243-.193l.007-.057V7.75a.25.25 0 00-.193-.243L20.25 7.5H19V6h1.25zm-7-5a.75.75 0 01.75.75V2h2.25c.966 0 1.75.784 1.75 1.75v12.5A1.75 1.75 0 0116.25 18H3.75A1.75 1.75 0 012 16.25V3.75C2 2.784 2.784 2 3.75 2H6v-.25a.75.75 0 011.5 0V2h5v-.25a.75.75 0 01.75-.75zm3.25 6.5h-13v8.75a.25.25 0 00.193.243l.057.007h12.5a.25.25 0 00.243-.193l.007-.057V7.5zm-6.195 1.277c.38 0 .62.21.662.554l.006.107v4.554c0 .356-.235.59-.582.59-.313 0-.538-.19-.58-.487l-.006-.103V9.957H9.78l-.824.574a.48.48 0 01-.312.106.402.402 0 01-.415-.422c0-.15.05-.267.172-.377l.082-.065L9.602 9a1.09 1.09 0 01.703-.223zM6 3.5H3.75a.25.25 0 00-.243.193L3.5 3.75V6h13V3.75a.25.25 0 00-.193-.243L16.25 3.5H14v.25a.75.75 0 11-1.5 0V3.5h-5v.25a.75.75 0 01-1.5 0V3.5z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Period = React.forwardRef(IconPeriod);
function IconPersonChange(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M14.75 11.5c4.166 0 6.596 2.43 7.291 7.29A2.813 2.813 0 0119.257 22h-9.014a2.813 2.813 0 01-2.784-3.21c.695-4.86 3.125-7.29 7.291-7.29zm0 1.5c-3.37 0-5.211 1.84-5.806 6.002a1.313 1.313 0 001.165 1.491l.134.007h9.014a1.313 1.313 0 001.3-1.498C19.96 14.84 18.12 13 14.75 13zM6.446 6.397l.084.073 3 3a.75.75 0 01.073.976l-.073.084-3 3a.75.75 0 01-1.133-.976l.073-.084 1.719-1.72H1.75a.75.75 0 01-.102-1.493l.102-.007h5.439l-1.72-1.72a.75.75 0 01-.072-.976l.073-.084a.75.75 0 01.976-.073zM14.75 2c1.933 0 3.5 1.903 3.5 4.25s-1.567 4.25-3.5 4.25-3.5-1.903-3.5-4.25S12.817 2 14.75 2zm0 1.5c-1.033 0-2 1.174-2 2.75s.967 2.75 2 2.75 2-1.174 2-2.75-.967-2.75-2-2.75z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const PersonChange = React.forwardRef(IconPersonChange);
function IconPersonMinus(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10.5 11.5c1.486 0 2.751.31 3.796.928-.462.29-.881.644-1.246 1.047-.726-.32-1.574-.475-2.55-.475-3.37 0-5.211 1.84-5.806 6.002a1.313 1.313 0 001.165 1.491l.134.007 6.31.001a6.027 6.027 0 001.23 1.5L5.992 22a2.813 2.813 0 01-2.784-3.21c.695-4.86 3.125-7.29 7.291-7.29zm7 1.5a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm2.25 3.75h-4.5a.75.75 0 00-.102 1.493l.102.007h4.5a.75.75 0 00.102-1.493l-.102-.007zM10.5 2C12.433 2 14 3.903 14 6.25s-1.567 4.25-3.5 4.25S7 8.597 7 6.25 8.567 2 10.5 2zm0 1.5c-1.033 0-2 1.174-2 2.75S9.467 9 10.5 9s2-1.174 2-2.75-.967-2.75-2-2.75z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const PersonMinus = React.forwardRef(IconPersonMinus);
function IconPersonPlus(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10.5 11.5c1.486 0 2.751.31 3.796.928-.462.29-.881.644-1.246 1.047-.726-.32-1.574-.475-2.55-.475-3.37 0-5.211 1.84-5.806 6.002a1.313 1.313 0 001.165 1.491l.134.007 6.31.001a6.027 6.027 0 001.23 1.5L5.992 22a2.813 2.813 0 01-2.784-3.21c.695-4.86 3.125-7.29 7.291-7.29zm7 1.5a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm0 1.5a.75.75 0 00-.743.648l-.007.102v1.5h-1.5a.75.75 0 00-.743.648l-.007.102c0 .38.282.693.648.743l.102.007h1.5v1.5c0 .38.282.693.648.743l.102.007a.75.75 0 00.743-.648l.007-.102v-1.5h1.5a.75.75 0 00.743-.648l.007-.102a.75.75 0 00-.648-.743l-.102-.007h-1.5v-1.5a.75.75 0 00-.648-.743L17.5 14.5zM10.5 2C12.433 2 14 3.903 14 6.25s-1.567 4.25-3.5 4.25S7 8.597 7 6.25 8.567 2 10.5 2zm0 1.5c-1.033 0-2 1.174-2 2.75S9.467 9 10.5 9s2-1.174 2-2.75-.967-2.75-2-2.75z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const PersonPlus = React.forwardRef(IconPersonPlus);
function IconPersonSolid(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 11.5c4.553 0 7.21 2.43 7.969 7.29.24 1.537-.928 2.962-2.608 3.182-.144.018-.29.028-.435.028H7.074C5.376 22 4 20.74 4 19.187c0-.133.01-.266.03-.398C4.79 13.93 7.448 11.5 12 11.5zM12 2c2.112 0 3.825 1.903 3.825 4.25S14.112 10.5 12 10.5c-2.113 0-3.825-1.903-3.825-4.25S9.887 2 12 2z",
      fill: "currentColor"
    }
  ));
}
const PersonSolid = React.forwardRef(IconPersonSolid);
function IconPersonTick(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10.5 11.5c1.486 0 2.751.31 3.796.928-.462.29-.881.644-1.246 1.047-.726-.32-1.574-.475-2.55-.475-3.37 0-5.211 1.84-5.806 6.002a1.313 1.313 0 001.165 1.491l.134.007 6.31.001a6.027 6.027 0 001.23 1.5L5.992 22a2.813 2.813 0 01-2.784-3.21c.695-4.86 3.125-7.29 7.291-7.29zm7 1.5a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm2.403 1.867a.75.75 0 00-.97.141l-.066.09-1.983 3.114-.798-.999-.076-.081a.75.75 0 00-1.159.927l.063.091 1.455 1.819.073.079a.75.75 0 001.081-.059l.064-.086 2.546-4 .052-.098a.75.75 0 00-.282-.938zM10.5 2C12.433 2 14 3.903 14 6.25s-1.567 4.25-3.5 4.25S7 8.597 7 6.25 8.567 2 10.5 2zm0 1.5c-1.033 0-2 1.174-2 2.75S9.467 9 10.5 9s2-1.174 2-2.75-.967-2.75-2-2.75z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const PersonTick = React.forwardRef(IconPersonTick);
function IconPerson(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 11.5c4.553 0 7.21 2.43 7.969 7.29.24 1.537-.928 2.962-2.608 3.182-.144.018-.29.028-.435.028H7.074C5.376 22 4 20.74 4 19.187c0-.133.01-.266.03-.398C4.79 13.93 7.448 11.5 12 11.5zm0 1.5c-3.684 0-5.696 1.84-6.346 6.002-.01.061-.015.123-.015.186 0 .68.565 1.238 1.288 1.305l.147.007h9.852c.068 0 .136-.004.203-.013.784-.103 1.329-.768 1.217-1.485C17.696 14.84 15.684 13 12 13zm0-11c2.112 0 3.825 1.903 3.825 4.25S14.112 10.5 12 10.5c-2.113 0-3.825-1.903-3.825-4.25S9.887 2 12 2zm0 1.5c-1.13 0-2.186 1.174-2.186 2.75S10.87 9 12 9s2.186-1.174 2.186-2.75S13.129 3.5 12 3.5z",
      fill: "currentColor"
    }
  ));
}
const Person = React.forwardRef(IconPerson);
function IconPhoneSolid(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M5.357 4.384l.891-.58c.835-.542 1.942-.323 2.586.513l1.28 1.663c.56.724.628 1.734.17 2.496l-1.273 2.12c.372.965.962 1.855 1.77 2.67a8.253 8.253 0 002.701 1.844l1.876-1.253c.711-.475 1.645-.398 2.317.19l1.565 1.373c.782.685.99 1.862.487 2.755l-.538.957c-.536.952-1.517 1.508-2.576 1.46-2.498-.115-5.197-1.718-8.096-4.811-2.903-3.098-4.408-5.983-4.514-8.655-.045-1.125.47-2.168 1.354-2.742z",
      fill: "currentColor"
    }
  ));
}
const PhoneSolid = React.forwardRef(IconPhoneSolid);
function IconPhone(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M4.742 3.998l1.036-.641a2.75 2.75 0 013.58.6l1.39 1.703a2.75 2.75 0 01.2 3.196l-1.082 1.732a.25.25 0 00-.035.17c.06.396.52 1.073 1.397 1.95.638.638 1.174 1.062 1.59 1.27.289.144.43.154.48.123l1.783-1.114a2.75 2.75 0 013.195.201l1.696 1.383a2.75 2.75 0 01.606 3.57l-.639 1.04a3.75 3.75 0 01-3.234 1.788c-2.86-.03-5.846-1.636-8.974-4.763-3.133-3.133-4.739-6.124-4.764-8.986a3.75 3.75 0 011.775-3.222zm.79 1.276a2.25 2.25 0 00-1.065 1.932c.021 2.408 1.445 5.06 4.324 7.939 2.876 2.876 5.524 4.3 7.93 4.324a2.25 2.25 0 001.94-1.072l.639-1.04a1.25 1.25 0 00-.276-1.623l-1.696-1.383a1.25 1.25 0 00-1.452-.092l-1.787 1.117c-1.04.64-2.31.005-3.922-1.607-1.086-1.087-1.698-1.988-1.82-2.786a1.75 1.75 0 01.247-1.19l1.083-1.732a1.25 1.25 0 00-.092-1.453l-1.39-1.704a1.25 1.25 0 00-1.627-.272l-1.036.642z",
      fill: "currentColor"
    }
  ));
}
const Phone = React.forwardRef(IconPhone);
function IconPlay(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 1.5a8.5 8.5 0 100 17 8.5 8.5 0 000-17zM9.8 8a.7.7 0 011.05-.606l.084.057 4.86 3.84a.7.7 0 01.081 1.023l-.081.075-4.86 3.84a.7.7 0 01-1.127-.449l-.007-.1V8zm1.4 1.445v4.789l3.03-2.395-3.03-2.394z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Play = React.forwardRef(IconPlay);
function IconPlusMinus(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M6.169 17.055c.43 0 .734-.305.734-.75V13.43h2.649c.453 0 .757-.297.757-.72 0-.429-.304-.726-.757-.726H6.903V9.258c0-.445-.304-.758-.734-.758s-.727.313-.727.758v2.726H2.825c-.445 0-.758.297-.758.727 0 .422.313.719.758.719h2.617v2.875c0 .445.305.75.727.75zm5.598 2.453c.352 0 .64-.211.735-.555l3.453-12.25a1.17 1.17 0 00.047-.258c.007-.406-.336-.75-.766-.75-.36 0-.648.211-.742.547l-3.446 12.25a.749.749 0 00.719 1.016zm9.388-6.11c.578 0 .882-.32.882-.78 0-.462-.304-.766-.882-.766h-3.68c-.57 0-.883.312-.883.765 0 .461.305.781.883.781h3.68z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const PlusMinus = React.forwardRef(IconPlusMinus);
function IconPrint(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M16.75 2c.966 0 1.75.784 1.75 1.75v1.758A3.75 3.75 0 0122 9.25v7.5a1.75 1.75 0 01-1.75 1.75H18.5v1.75A1.75 1.75 0 0116.75 22h-9.5a1.75 1.75 0 01-1.75-1.75V18.5H3.75A1.75 1.75 0 012 16.75v-7.5a3.75 3.75 0 013.5-3.742V3.75C5.5 2.784 6.284 2 7.25 2h9.5zM17 14.5H7v5.75a.25.25 0 00.193.243l.057.007h9.5a.25.25 0 00.243-.193L17 20.25V14.5zM18.25 7H5.75a2.25 2.25 0 00-2.245 2.096L3.5 9.25v7.5a.25.25 0 00.193.243L3.75 17H5.5v-3.25a.75.75 0 01.75-.75h11.5a.75.75 0 01.75.75V17h1.75a.25.25 0 00.243-.193l.007-.057v-7.5a2.25 2.25 0 00-2.096-2.245L18.25 7zm-.5 3a.75.75 0 110 1.5h-2.5a.75.75 0 110-1.5h2.5zm-1-6.5h-9.5a.25.25 0 00-.243.193L7 3.75V5.5h10V3.75a.25.25 0 00-.193-.243L16.75 3.5z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Print$1 = React.forwardRef(IconPrint);
function IconProcessPayment(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M16.247 2a.75.75 0 01.75.75l-.001.25h2.25c.967 0 1.75.784 1.75 1.75v14.5a1.75 1.75 0 01-1.75 1.75h-7.25v-1.5h7.25a.25.25 0 00.244-.193l.007-.057L19.496 8h-15v4h-1.5V4.75c0-.966.784-1.75 1.75-1.75h2.25v-.25a.75.75 0 011.5 0V3h7v-.25a.75.75 0 01.75-.75zM3.139 15.956a.5.5 0 01.631-.11l2.144 1.238.073.052a.5.5 0 01.11.631l-.052.074a.5.5 0 01-.631.11l-.878-.506a2.5 2.5 0 004 1.525.75.75 0 11.925 1.181 4.002 4.002 0 01-6.343-2.173l-.402.695-.052.074a.5.5 0 01-.814-.574l1.237-2.143zM6.997 13a4.001 4.001 0 013.92 3.197l.358-.62a.5.5 0 01.6-.221l.083.038a.5.5 0 01.22.601l-.037.082-1.238 2.143a.5.5 0 01-.601.221l-.082-.038-2.143-1.237a.5.5 0 01.418-.904l.082.038.914.528a2.5 2.5 0 00-4.033-1.798.75.75 0 11-.925-1.181A3.985 3.985 0 016.997 13zm-.001-8.5h-2.25a.25.25 0 00-.243.193l-.006.057-.001 1.75h15V4.75a.25.25 0 00-.192-.243l-.057-.007h-2.251v.25a.75.75 0 11-1.5 0V4.5h-7v.25a.75.75 0 01-1.5 0V4.5z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const ProcessPayment = React.forwardRef(IconProcessPayment);
function IconProductLedgerCard(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M7.797 9c.464 0 .91.184 1.237.513l6.229 6.228a1.75 1.75 0 010 2.475l-4.047 4.047a1.75 1.75 0 01-2.475 0l-6.228-6.229A1.75 1.75 0 012 14.797V10.75C2 9.784 2.784 9 3.75 9h4.047zM18.25 2c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0118.25 22H14.5v-1.5h3.75a.25.25 0 00.243-.193l.007-.057V3.75a.25.25 0 00-.193-.243L18.25 3.5H5.75a.25.25 0 00-.243.193L5.5 3.75V8H4V3.75C4 2.784 4.784 2 5.75 2h12.5zM7.797 10.5H3.75a.25.25 0 00-.243.193l-.007.057v4.047a.25.25 0 00.033.125l.04.052 6.228 6.228a.25.25 0 00.3.04l.054-.04 4.047-4.047a.25.25 0 00.04-.3l-.04-.054-6.228-6.228a.25.25 0 00-.112-.064l-.065-.009zm-2.504 1.793a1 1 0 111.414 1.414 1 1 0 01-1.414-1.414zM15.75 9.5a.75.75 0 110 1.5h-2.5a.75.75 0 110-1.5h2.5zm0-3.5a.75.75 0 110 1.5h-7.5a.75.75 0 010-1.5h7.5z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const ProductLedgerCard = React.forwardRef(IconProductLedgerCard);
function IconProfile(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12a9.97 9.97 0 003.047 7.187A9.967 9.967 0 0012 22a9.967 9.967 0 006.953-2.813A9.97 9.97 0 0022 12zM5.704 16.936A7.986 7.986 0 0012 20a7.986 7.986 0 006.296-3.064A7 7 0 0012 13a7 7 0 00-6.296 3.936zM12 12a3.5 3.5 0 100-7 3.5 3.5 0 000 7z",
      fill: "currentColor"
    }
  ));
}
const Profile = React.forwardRef(IconProfile);
function IconProjectCards(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M19.25 3c.966 0 1.75.784 1.75 1.75v14.5A1.75 1.75 0 0119.25 21H4.75A1.75 1.75 0 013 19.25V4.75C3 3.784 3.784 3 4.75 3h14.5zm0 1.5H4.75a.25.25 0 00-.243.193L4.5 4.75v14.5a.25.25 0 00.193.243l.057.007h14.5a.25.25 0 00.243-.193l.007-.057V4.75a.25.25 0 00-.193-.243L19.25 4.5zM8.25 15a.75.75 0 01.75.75v1a.75.75 0 01-.75.75h-1a.75.75 0 01-.75-.75v-1a.75.75 0 01.75-.75h1zm8.5 1a.75.75 0 110 1.5h-4.5a.75.75 0 110-1.5h4.5zm0-3.167a.75.75 0 010 1.5h-4.5a.75.75 0 110-1.5h4.5zm0-3.166a.75.75 0 110 1.5h-4.5a.75.75 0 010-1.5h4.5zM8.25 6.5a.75.75 0 01.75.75v1a.75.75 0 01-.75.75h-1a.75.75 0 01-.75-.75v-1a.75.75 0 01.75-.75h1zm8.5 0a.75.75 0 110 1.5h-4.5a.75.75 0 110-1.5h4.5z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const ProjectCards = React.forwardRef(IconProjectCards);
function IconProjects(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 3a1 1 0 00-.993.883L11 6v6.02l.01.118.022.113.023.077.03.075.047.093.062.096.07.085.072.071.096.075.099.06.075.036 3.5 1.5.11.04a1 1 0 00.782-1.826l-.104-.052L13 11.34V6l-.007-.117A1 1 0 0012 5z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Projects = React.forwardRef(IconProjects);
function IconQuestionMarkBold(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M5.367 7.727a.476.476 0 00.484.48h3.147c.274 0 .492-.222.537-.493.184-1.108.965-1.9 2.266-1.9 1.161 0 2.252.623 2.252 2.053 0 1.246-.864 1.841-2.195 2.705-1.714 1.09-2.634 2.534-2.422 4.715l.008.173a.5.5 0 00.5.478h3a.5.5 0 00.5-.5v-.18c0-1.514.665-1.953 2.322-3.072 1.374-.934 2.86-2.025 2.86-4.545 0-3.569-3.002-5.325-6.556-5.325-3.361 0-6.618 1.557-6.703 5.411zm3.432 12.247c0 1.388 1.09 2.322 2.776 2.322 1.741 0 2.817-.934 2.817-2.322 0-1.416-1.09-2.35-2.817-2.35-1.7 0-2.776.934-2.776 2.35z",
      fill: "currentColor"
    }
  ));
}
const QuestionMarkBold = React.forwardRef(IconQuestionMarkBold);
function IconQuestionMark(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M12 14.489c.5 0 .838-.302.832-.764v-1.998c.052-.665.604-.8 1.548-1.413C15.415 9.649 16 8.885 16 7.78 16 6.011 14.077 5 12.139 5c-.822 0-1.831.145-2.639.466a3.39 3.39 0 00-.803.438 1.94 1.94 0 00-.317.3c-.076.09-.14.188-.189.29a1.904 1.904 0 00-.132.356c-.04.153-.059.304-.059.448a.65.65 0 00.022.173c.076.335.34.55.748.55a.806.806 0 00.792-.55c.278-.902 1.709-1.078 2.502-1.078.96 0 2.183.555 2.183 1.405 0 .764-.44 1.163-1.268 1.706-.856.573-1.848 1.137-1.848 2.074v2.147c0 .492.369.764.869.764zM12 19c.579 0 1.047-.457 1.047-1.018 0-.566-.468-1.012-1.047-1.012-.573 0-1.042.446-1.042 1.012 0 .561.47 1.018 1.042 1.018z",
      fill: "currentColor"
    }
  ));
}
const QuestionMark = React.forwardRef(IconQuestionMark);
function IconQuicklinks(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M7.102 11.125c.753 0 1.472.295 2.007.817l.142.148 4.806 5.407c.183.206.434.337.705.37l.136.008h3.416L17.22 16.78l-.073-.084a.75.75 0 011.05-1.049l.083.073 2.5 2.5a.753.753 0 01.097.118l.053.094.028.07.023.08.013.075.006.102-.002.042-.009.075-.027.111-.043.102-.038.066-.027.04-.035.043-.039.042-2.5 2.5-.084.073a.75.75 0 01-1.049-1.05l.073-.083 1.095-1.096-3.417.001a2.875 2.875 0 01-2.007-.817l-.142-.148-4.806-5.407a1.125 1.125 0 00-.705-.37l-.136-.008H3.75a.875.875 0 01-.11-1.743l.11-.007h3.352zm11.094-8.978l.084.073 2.5 2.5a.63.63 0 01.101.125l.049.088.043.119.021.106.004.042.002.069-.006.073-.013.076-.023.08-.047.107-.058.091-.073.084-2.5 2.5a.75.75 0 01-1.133-.976l.073-.084 1.095-1.096-3.426.001-.136.008c-.223.027-.433.12-.603.268l-.096.095-2.905 3.215-.085.083a.875.875 0 01-1.287-1.162l.074-.094 2.904-3.215.141-.146a2.875 2.875 0 011.79-.795l.203-.007 3.424-.001L17.22 3.28a.75.75 0 01.976-1.133z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Quicklinks = React.forwardRef(IconQuicklinks);
function IconRatingBankruptcy(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm.035 4.982c-.264 0-.533.13-.533.51v.41C9.92 8.05 8.9 8.998 8.9 10.352c0 1.135.646 1.88 1.926 2.202l1.309.288c.844.181 1.178.44 1.178.879 0 .562-.446.931-1.272.931-.592 0-1.166-.246-1.687-.72-.334-.282-.545-.364-.803-.364-.416 0-.75.258-.75.715 0 .352.187.692.515.99.487.452 1.272.727 2.163.803v.358c0 .375.275.51.539.51.263 0 .533-.135.533-.51v-.37c1.64-.193 2.666-1.154 2.666-2.543 0-1.143-.66-1.862-1.997-2.176l-1.314-.273c-.744-.146-1.084-.427-1.084-.867 0-.492.44-.885 1.131-.885.586 0 1.008.188 1.506.662.293.252.533.364.85.364.369 0 .673-.27.673-.657 0-.328-.175-.673-.503-.984-.434-.422-1.131-.691-1.91-.79v-.423c0-.375-.27-.51-.534-.51z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const RatingBankruptcy = React.forwardRef(IconRatingBankruptcy);
function IconRatingPaymentProblems(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M21.25 11.25A.75.75 0 0122 12c0 5.523-4.477 10-10 10a9.986 9.986 0 01-7.638-3.545l-.038 1.071a.75.75 0 01-1.496.05l-.003-.102.099-2.827a.75.75 0 01.775-.723l2.827.098a.75.75 0 01.05 1.496l-.102.004-.966-.034A8.5 8.5 0 0020.5 12a.75.75 0 01.75-.75zm-9.215-4.268c.237 0 .48.11.526.405l.007.105v.422c.78.1 1.477.37 1.91.791.329.31.504.656.504.984 0 .387-.304.657-.673.657-.317 0-.557-.112-.85-.364-.498-.474-.92-.662-1.506-.662-.691 0-1.13.393-1.13.885 0 .406.289.677.919.831l.164.036 1.108.229c1.476.287 2.203 1.02 2.203 2.22 0 1.331-.942 2.27-2.464 2.515l-.202.028v.37c0 .375-.27.51-.533.51-.238 0-.485-.11-.532-.405l-.007-.105v-.358c-.891-.076-1.676-.351-2.163-.803-.328-.298-.515-.638-.515-.99 0-.457.334-.715.75-.715.258 0 .469.082.803.364.521.474 1.095.72 1.687.72.826 0 1.271-.369 1.271-.931 0-.41-.29-.662-1.015-.842l-.162-.037-1.102-.24c-1.418-.293-2.133-1.055-2.133-2.25 0-1.298.937-2.223 2.407-2.427l.195-.023v-.41c0-.38.27-.51.533-.51zM12 2c3 0 5.77 1.332 7.639 3.545l.037-1.071a.75.75 0 011.496-.05l.003.102-.099 2.827a.75.75 0 01-.674.72l-.101.003-2.827-.098a.75.75 0 01-.05-1.496l.102-.004.966.034A8.5 8.5 0 003.5 12 .75.75 0 112 12C2 6.477 6.477 2 12 2z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const RatingPaymentProblems = React.forwardRef(IconRatingPaymentProblems);
function IconReconciled(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M17 7a5 5 0 01.217 9.995L17 17h-2.5a.75.75 0 01-.102-1.493l.102-.007H17a3.5 3.5 0 00.192-6.995L17 8.5h-2.5a.75.75 0 01-.102-1.493L14.5 7H17zM9.5 7a.75.75 0 01.102 1.493L9.5 8.5H7a3.5 3.5 0 00-.192 6.995L7 15.5h2.5a.75.75 0 01.102 1.493L9.5 17H7a5 5 0 01-.217-9.995L7 7h2.5zm7.5 4.25a.75.75 0 110 1.5H7a.75.75 0 110-1.5h10z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Reconciled = React.forwardRef(IconReconciled);
function IconRefresh(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M12.268 21.246L12 21.25l-.323-.006-.32-.016-.3-.025-.329-.04a9.166 9.166 0 01-2.067-.534l-.288-.117-.353-.16-.237-.117-.358-.193-.385-.233-.263-.173-.3-.215-.23-.177-.238-.196-.356-.319a9.308 9.308 0 01-.345-.343l-.151-.162a9.197 9.197 0 01-1.662-2.58l-.126-.311-.134-.372-.087-.268-.08-.285A9.229 9.229 0 012.75 12c0-.893.127-1.757.363-2.574l.137-.431.077-.218.169-.421a9.17 9.17 0 01.768-1.431l.171-.25c.213-.303.447-.595.701-.876l.168-.18c.174-.183.356-.36.545-.528l.197-.17.345-.278.328-.239.302-.202.117-.072a8.88 8.88 0 01.664-.375l.484-.23.37-.152.427-.153.353-.11.263-.071.145-.036A9.232 9.232 0 0112 2.75l.24.003.317.014.389.031.284.033.487.079.43.091.287.073.39.116.293.099.336.127.17.07.379.172.259.129.25.135.416.248.255.166a9.12 9.12 0 011.14.911V3.222a.75.75 0 01.638-.742l.111-.008a.75.75 0 01.742.639l.008.11v3.83a.75.75 0 01-.64.741l-.11.008h-3.828a.75.75 0 01-.111-1.492l.11-.008h2.009l-.197-.177-.22-.182-.131-.102-.2-.147-.225-.156-.235-.15-.236-.139-.149-.081-.222-.115-.268-.126-.121-.053a7.709 7.709 0 00-1.013-.352l-.263-.067-.258-.055-.262-.047-.278-.04-.349-.036-.353-.02L12 4.25l-.183.002-.376.018-.294.026-.248.032-.335.055-.344.073-.243.061-.202.058a7.72 7.72 0 00-.54.183l-.282.114-.204.09-.317.156-.24.13a7.755 7.755 0 00-.629.397l-.383.285-.21.174-.075.064a7.796 7.796 0 00-.195.178l-.18.174-.239.25-.175.198-.152.184a7.778 7.778 0 00-.59.84l-.174.305-.116.222-.112.232a7.079 7.079 0 00-.15.346l-.11.29-.122.368-.046.16c-.084.304-.15.612-.197.923l-.05.409.01-.098c-.05.453-.06.91-.03 1.364l.024.285c.031.307.081.611.15.913l.073.3.058.204c.072.245.157.486.255.724l.085.2c.05.112.102.223.156.332l.091.175.137.245.148.246.058.088a7.766 7.766 0 00.436.604l.141.173.093.107.174.191.174.18.18.175.246.22.324.264.349.255.123.083.24.151.2.118.259.14.257.128.33.146.24.095c.195.073.393.139.594.196l.359.094.136.03.124.026.297.053.329.045.246.024.097.008c.091.006.183.011.275.014l.275.005A7.75 7.75 0 0019.75 12a.75.75 0 111.5 0 9.25 9.25 0 01-8.982 9.246z",
      fill: "currentColor"
    }
  ));
}
const Refresh = React.forwardRef(IconRefresh);
function IconReportSolid(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M6.5 12a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6a1 1 0 011-1h2.5zm6.75-5a1 1 0 011 1v11a1 1 0 01-1 1h-2.5a1 1 0 01-1-1V8a1 1 0 011-1h2.5zM20 4a1 1 0 011 1v14a1 1 0 01-1 1h-2.5a1 1 0 01-1-1V5a1 1 0 011-1H20z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const ReportSolid = React.forwardRef(IconReportSolid);
function IconReport(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M6.25 12c.966 0 1.75.784 1.75 1.75v4.5A1.75 1.75 0 016.25 20h-1.5A1.75 1.75 0 013 18.25v-4.5c0-.966.784-1.75 1.75-1.75h1.5zm6.5-5c.966 0 1.75.784 1.75 1.75v9.5A1.75 1.75 0 0112.75 20h-1.5a1.75 1.75 0 01-1.75-1.75v-9.5c0-.966.784-1.75 1.75-1.75h1.5zm6.5-3c.966 0 1.75.784 1.75 1.75v12.5A1.75 1.75 0 0119.25 20h-1.5A1.75 1.75 0 0116 18.25V5.75c0-.966.784-1.75 1.75-1.75h1.5zm-13 9.5h-1.5a.25.25 0 00-.243.193l-.007.057v4.5a.25.25 0 00.193.243l.057.007h1.5a.25.25 0 00.243-.193l.007-.057v-4.5a.25.25 0 00-.193-.243L6.25 13.5zm6.5-5h-1.5a.25.25 0 00-.243.193L11 8.75v9.5a.25.25 0 00.193.243l.057.007h1.5a.25.25 0 00.243-.193L13 18.25v-9.5a.25.25 0 00-.193-.243L12.75 8.5zm6.5-3h-1.5a.25.25 0 00-.243.193l-.007.057v12.5a.25.25 0 00.193.243l.057.007h1.5a.25.25 0 00.243-.193l.007-.057V5.75a.25.25 0 00-.193-.243L19.25 5.5z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Report$1 = React.forwardRef(IconReport);
function IconRestore(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M18 9.25a.75.75 0 01.743.648l.007.102v8.25a3.75 3.75 0 01-3.55 3.745L15 22h-5a3.75 3.75 0 01-3.745-3.55l-.005-.2V10a.75.75 0 01.648-.743L7 9.25h11zm-.75 1.5h-9.5v7.5a2.25 2.25 0 001.938 2.229l.158.016.154.005h5a2.25 2.25 0 002.245-2.096l.005-.154v-7.5zm-6.75 1.5a.75.75 0 01.743.648l.007.102v5.25a.75.75 0 01-1.493.102l-.007-.102V13a.75.75 0 01.75-.75zm4 0a.75.75 0 01.743.648l.007.102v5.25a.75.75 0 01-1.493.102l-.007-.102V13a.75.75 0 01.75-.75zm2.372-9.849a3.847 3.847 0 012.03 4.45l2.668 1.302a.75.75 0 01-.563 1.386l-.094-.038L9.086 3.732a.75.75 0 01.563-1.386l.094.038 2.373 1.157a3.847 3.847 0 014.756-1.14zM3 4.25a.75.75 0 01.743.648L3.75 5v.63c2.434-1.684 5.714-1.245 7.542 1.11a.75.75 0 11-1.185.919C8.819 6 6.547 5.647 4.777 6.749l.723.001a.75.75 0 01.743.648l.007.102a.75.75 0 01-.648.743L5.5 8.25H3a.75.75 0 01-.743-.648L2.25 7.5V5A.75.75 0 013 4.25zm10.507-.031l4.005 1.953a2.347 2.347 0 00-4.005-1.953z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Restore = React.forwardRef(IconRestore);
function IconRotateLeft(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M12 2.75a9.25 9.25 0 016.54 15.79.75.75 0 11-1.06-1.06 7.75 7.75 0 10-13.224-5.797l.714-.713.084-.073a.75.75 0 011.049 1.05l-.073.083-2 2-.084.073a.75.75 0 01-.882.007l-.094-.08-2-2-.073-.084a.75.75 0 01-.007-.882l.08-.094.084-.073a.75.75 0 01.882-.007l.094.08.725.724A9.25 9.25 0 0112 2.75z",
      fill: "currentColor"
    }
  ));
}
const RotateLeft = React.forwardRef(IconRotateLeft);
function IconRotateRight(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M12 2.75a9.25 9.25 0 019.245 8.944l.725-.724a.75.75 0 01.976-.073l.084.073a.75.75 0 01.073.976l-.073.084-2 2a.75.75 0 01-.976.073l-.084-.073-2-2a.75.75 0 01.976-1.133l.084.073.714.712A7.75 7.75 0 106.52 17.48a.75.75 0 11-1.06 1.06A9.25 9.25 0 0112 2.75z",
      fill: "currentColor"
    }
  ));
}
const RotateRight = React.forwardRef(IconRotateRight);
function IconSales(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M12.021 23.316c.594 0 1.121-.33 1.121-1.12V21.14c3.546-.382 5.761-2.465 5.761-5.498 0-2.61-1.569-4.192-4.825-4.904l-2.676-.606C9.727 9.763 8.91 8.999 8.91 7.878c0-1.344 1.16-2.32 2.98-2.32 1.476 0 2.504.5 3.651 1.78.58.606 1.029.83 1.635.83.738 0 1.305-.514 1.305-1.279 0-.738-.435-1.542-1.173-2.267-.976-.923-2.439-1.53-4.087-1.74V1.787c0-.777-.527-1.107-1.134-1.107-.593 0-1.12.316-1.12 1.107v1.055c-3.415.317-5.59 2.36-5.59 5.287 0 2.557 1.569 4.258 4.575 4.93l2.676.62c1.951.461 2.755 1.147 2.755 2.307 0 1.503-1.173 2.452-3.27 2.452-1.568 0-2.873-.593-4.06-1.872-.672-.672-1.041-.817-1.542-.817-.805 0-1.411.514-1.411 1.397 0 .778.448 1.582 1.252 2.281 1.055.962 2.703 1.556 4.536 1.727v1.042c0 .79.527 1.12 1.133 1.12z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Sales = React.forwardRef(IconSales);
function IconSearchBold(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M9.75 2a7.75 7.75 0 016.292 12.275l5.592 5.591a1.25 1.25 0 01-1.666 1.859l-.102-.091-5.59-5.592A7.75 7.75 0 119.75 2zm0 2.5a5.25 5.25 0 100 10.5 5.25 5.25 0 000-10.5z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const SearchBold = React.forwardRef(IconSearchBold);
function IconSearch(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10 2.25a7.75 7.75 0 015.985 12.674l5.545 5.546a.75.75 0 01-.976 1.133l-.084-.073-5.546-5.545A7.75 7.75 0 1110 2.25zm0 1.5a6.25 6.25 0 100 12.5 6.25 6.25 0 000-12.5z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Search$2 = React.forwardRef(IconSearch);
function IconSecureTick(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M12.01 2.25a.75.75 0 01.665.402c.72 1.376 3.174 2.323 7.389 2.683a.75.75 0 01.686.748c0 7.747-1.54 11.378-5.945 14.213l-.502.312-.525.306a26.51 26.51 0 01-.834.452l-.29.148-.323.16a.75.75 0 01-.654.003c-6.293-3-8.427-6.542-8.427-15.594a.75.75 0 01.686-.748c4.215-.36 6.67-1.307 7.389-2.683a.75.75 0 01.56-.395l.126-.007zM12 4.245l-.064.067C10.702 5.54 8.479 6.317 5.277 6.705l-.523.058.01.54c.012.53.033 1.039.063 1.525l.052.713c.472 5.577 2.312 8.141 6.618 10.372l.272.139.228.113.262-.133c4.685-2.43 6.538-5.033 6.915-11.21l.038-.743.025-.778.007-.402.001-.136-.522-.058c-3.068-.372-5.238-1.1-6.5-2.242l-.159-.15L12 4.244zm4.903 4.104l.077.067a.75.75 0 01.067.984l-.067.077-5.52 5.52-3.382-3.38a.75.75 0 01.984-1.129l.076.067 2.32 2.322 4.461-4.46a.75.75 0 01.984-.068z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const SecureTick = React.forwardRef(IconSecureTick);
function IconSecure(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M12.01 2.25a.75.75 0 01.665.402c.72 1.376 3.174 2.323 7.389 2.683a.75.75 0 01.686.748c0 7.747-1.54 11.378-5.945 14.213l-.502.312-.525.306a26.51 26.51 0 01-.834.452l-.29.148-.323.16a.75.75 0 01-.654.003c-6.293-3-8.427-6.542-8.427-15.594a.75.75 0 01.686-.748c4.215-.36 6.67-1.307 7.389-2.683a.75.75 0 01.56-.395l.126-.007zM12 4.245l-.064.067C10.702 5.54 8.479 6.317 5.277 6.705l-.523.058.01.54c.012.53.033 1.039.063 1.525l.052.713c.472 5.577 2.312 8.141 6.618 10.372l.272.139.228.113.262-.133c4.685-2.43 6.538-5.033 6.915-11.21l.038-.743.025-.778.007-.402.001-.136-.522-.058c-3.068-.372-5.238-1.1-6.5-2.242l-.159-.15L12 4.244zM12 8l.15.005a2 2 0 01.98 3.645L14 16h-4l.87-4.35a2 2 0 01.982-3.644L11.999 8z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Secure = React.forwardRef(IconSecure);
function IconSettingsSolid(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M13 2a1 1 0 011 1v1.77a7.44 7.44 0 011.698.703l1.252-1.251a1 1 0 011.414 0l1.414 1.414a1 1 0 010 1.414l-1.251 1.252c.3.53.538 1.099.703 1.698H21a1 1 0 011 1v2a1 1 0 01-1 1h-1.77a7.454 7.454 0 01-.703 1.698l1.251 1.252a1 1 0 010 1.414l-1.414 1.414a1 1 0 01-1.414 0l-1.252-1.251a7.47 7.47 0 01-1.697.703L14 21a1 1 0 01-1 1h-2a1 1 0 01-1-1v-1.77a7.454 7.454 0 01-1.698-.703L7.05 19.778a1 1 0 01-1.414 0l-1.414-1.414a1 1 0 010-1.414l1.251-1.252A7.454 7.454 0 014.77 14H3a1 1 0 01-1-1v-2a1 1 0 011-1h1.77a7.44 7.44 0 01.703-1.698L4.222 7.05a1 1 0 010-1.414l1.414-1.414a1 1 0 011.414 0l1.252 1.251c.53-.3 1.099-.538 1.698-.703V3a1 1 0 011-1h2zm-1 6a4 4 0 100 8 4 4 0 000-8z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const SettingsSolid = React.forwardRef(IconSettingsSolid);
function IconSettings(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M13.056 2c.918 0 1.67.707 1.744 1.606l.006.144v.787l.243.093.154.063.093.042.554-.553a1.75 1.75 0 012.217-.212l.133.1.125.113 1.492 1.492a1.75 1.75 0 01.114 2.35l-.113.125-.524.523.046.1.068.156.064.157.039.108h.74a1.75 1.75 0 011.725 1.459l.018.148.006.143v2.112a1.75 1.75 0 01-1.606 1.744l-.144.006h-.739l-.04.108-.063.158-.068.156-.047.098.524.524c.553.551.663 1.389.29 2.08l-.08.136-.095.131-.115.128-1.492 1.492c-.59.59-1.502.676-2.216.21l-.131-.095-.128-.115-.554-.554-.093.043-.154.064-.243.092v.789a1.752 1.752 0 01-1.459 1.725l-.148.018-.143.006h-2.111A1.75 1.75 0 019.2 20.393l-.006-.143v-.848l-.08-.03-.148-.06-.214-.097-.602.603a1.75 1.75 0 01-2.217.212l-.133-.1-.125-.113-1.492-1.492a1.75 1.75 0 01-.114-2.35l.114-.125.632-.634-.09-.204-.079-.206h-.897a1.752 1.752 0 01-1.725-1.459l-.018-.148L2 13.056v-2.112A1.75 1.75 0 013.606 9.2l.144-.006h.896l.08-.206.089-.205-.632-.633a1.75 1.75 0 01-.213-2.217l.099-.133.114-.125 1.492-1.492c.59-.59 1.502-.676 2.216-.21l.131.095.128.115.602.601.214-.095.149-.062.079-.03V3.75c0-.791.528-1.469 1.294-1.684l.146-.035.151-.023.16-.008h2.111zm-2.069 1.499l-.073.003a.25.25 0 00-.212.186l-.007.062v1.377a.75.75 0 01-.528.717c-.417.129-.818.3-1.2.51a.75.75 0 01-.809-.054l-.083-.071-.952-.954-.058-.053a.25.25 0 00-.27-.023l-.059.044-1.493 1.493a.25.25 0 00-.04.3l.04.054 1.009 1.008a.75.75 0 01.132.883c-.2.375-.361.769-.483 1.177a.75.75 0 01-.61.528l-.108.008H3.75a.25.25 0 00-.243.193l-.007.057v2.11c0 .12.083.22.193.245l.057.007h1.433a.75.75 0 01.719.537c.121.408.283.802.482 1.176a.75.75 0 01-.061.8l-.071.083-1.009 1.008a.25.25 0 00-.04.3l.04.054 1.493 1.493a.25.25 0 00.3.04l.054-.04.985-.986a.75.75 0 01.893-.126c.38.21.782.382 1.199.511a.75.75 0 01.52.609l.008.108v1.377a.25.25 0 00.192.243l.057.007h2.111a.251.251 0 00.244-.193l.007-.057v-1.331a.75.75 0 01.545-.721 6.398 6.398 0 001.247-.503.75.75 0 01.8.06l.083.072.896.898.058.053a.25.25 0 00.27.023l.059-.044 1.462-1.46.052-.057a.25.25 0 00.023-.27l-.044-.06-.907-.905a.75.75 0 01-.126-.894 6.4 6.4 0 00.533-1.269.75.75 0 01.61-.528l.108-.008h1.275a.25.25 0 00.243-.193l.007-.057v-2.111a.25.25 0 00-.193-.244l-.057-.007h-1.275a.75.75 0 01-.718-.536 6.4 6.4 0 00-.533-1.269.75.75 0 01.055-.81l.071-.083.907-.906a.25.25 0 00.04-.3l-.04-.054-1.493-1.493a.25.25 0 00-.3-.04l-.054.04-.93.93a.75.75 0 01-.882.132 6.398 6.398 0 00-1.247-.503.75.75 0 01-.536-.611l-.008-.11-.001-1.33a.251.251 0 00-.194-.244l-.056-.007-2.069-.001zM12 7.533a4.467 4.467 0 110 8.934 4.467 4.467 0 010-8.934zm0 1.5a2.967 2.967 0 100 5.934 2.967 2.967 0 000-5.934z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Settings$1 = React.forwardRef(IconSettings);
function IconShortcuts(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M20.25 5c.966 0 1.75.784 1.75 1.75v10.5A1.75 1.75 0 0120.25 19H3.75A1.75 1.75 0 012 17.25V6.75C2 5.784 2.784 5 3.75 5h16.5zm0 1.5H3.75a.25.25 0 00-.243.193L3.5 6.75v10.5a.25.25 0 00.193.243l.057.007h16.5a.25.25 0 00.243-.193l.007-.057V6.75a.25.25 0 00-.193-.243L20.25 6.5zM6.5 14a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h1zm9 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-7a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h7zm3 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h1zm-12-3a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h1zm3 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h1zm3 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h1zm3 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h1zm3 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h1zm-12-3a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h1zm3 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h1zm3 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h1zm3 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h1zm3 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h1z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Shortcuts = React.forwardRef(IconShortcuts);
function IconShowAll(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M19.25 6a1.75 1.75 0 011.744 1.606L21 7.75V11h-1.5V7.75l-.007-.057a.25.25 0 00-.175-.184L19.25 7.5H7.75l-.057.007a.25.25 0 00-.184.175L7.5 7.75v11.5l.007.057a.25.25 0 00.175.184l.068.009H11V21H7.75a1.75 1.75 0 01-1.744-1.606L6 19.25V7.75a1.75 1.75 0 011.606-1.744L7.75 6h11.5zm-2-3l.102.007a.75.75 0 010 1.486l-.102.007H4.75l-.057.007a.25.25 0 00-.184.175L4.5 4.75v12.5l-.007.102a.75.75 0 01-1.486 0L3 17.25V4.75l.006-.144a1.75 1.75 0 011.593-1.6L4.75 3h12.5zm-2.5 8.75a3 3 0 100 6 3 3 0 000-6zm0 7.5a4.5 4.5 0 113.632-1.842l.036-.05 2.362 2.362a.75.75 0 01-.976 1.133l-.084-.073-2.363-2.362-.112.077a4.479 4.479 0 01-2.495.755z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const ShowAll = React.forwardRef(IconShowAll);
function IconShowLess(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M3.75 4a.75.75 0 01.75.75v14.5a.75.75 0 11-1.5 0V4.75A.75.75 0 013.75 4zm3.5 0a.75.75 0 01.75.75v14.5a.75.75 0 11-1.5 0V4.75A.75.75 0 017.25 4zm7.78 3.97a.75.75 0 01.073.976l-.073.084-2.219 2.22h7.439a.75.75 0 01.102 1.493l-.102.007h-7.439l2.22 2.22a.75.75 0 01-.977 1.133l-.084-.073-3.5-3.5-.055-.06-.046-.065-.049-.088-.044-.12-.018-.089-.007-.143.019-.136.03-.098.047-.1.054-.082.069-.08 3.5-3.5a.75.75 0 011.06 0z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const ShowLess = React.forwardRef(IconShowLess);
function IconShowMore(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M3.75 4a.75.75 0 01.75.75v14.5a.75.75 0 11-1.5 0V4.75A.75.75 0 013.75 4zm3.5 0a.75.75 0 01.75.75v14.5a.75.75 0 11-1.5 0V4.75A.75.75 0 017.25 4zm3.5 0a.75.75 0 01.75.75v6.5h6.939l-2.22-2.22a.75.75 0 01.977-1.133l.084.073 3.5 3.5c.025.024.048.05.069.078l-.069-.078.04.042.04.052.068.114.038.098.02.084.012.088v.104l-.003.02-.006.055-.015.07-.024.072-.047.1-.032.051-.027.038-.064.072-3.5 3.5a.75.75 0 01-1.133-.976l.073-.084 2.219-2.22h-6.94l.001 6.5a.75.75 0 11-1.5 0V4.75a.75.75 0 01.75-.75z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const ShowMore = React.forwardRef(IconShowMore);
function IconShowTemplate(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M5.5 18v2.25a.25.25 0 00.193.243l.057.007H8V22H5.75A1.75 1.75 0 014 20.25V18h1.5zm8.25-5.25a3 3 0 100 6 3 3 0 000-6zm-8.25 0v3.75H4v-3.75h1.5zM20 7.5v3.75h-1.5V7.5H20zm-14.5 0v3.75H4V7.5h1.5zM18.25 2c.966 0 1.75.784 1.75 1.75V6h-1.5V3.75a.25.25 0 00-.193-.243L18.25 3.5 16 3.499V2h2.25zM8 2v1.5H5.75a.25.25 0 00-.243.193L5.5 3.75V6H4V3.75C4 2.784 4.784 2 5.75 2H8zm6.5 0v1.499l-5 .001V2h5zm-.75 18.25a4.5 4.5 0 113.632-1.842l.036-.05 2.362 2.362a.75.75 0 01-.976 1.133l-.084-.073-2.363-2.362-.112.077a4.479 4.479 0 01-2.495.755z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const ShowTemplate = React.forwardRef(IconShowTemplate);
function IconSliders(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M2.5 12.75H7a.75.75 0 110 1.5H5.5v7a.75.75 0 11-1.5 0v-7H2.5a.75.75 0 110-1.5zm9.5-2a.75.75 0 01.75.75v9.75a.75.75 0 11-1.5 0V11.5a.75.75 0 01.75-.75zm9.5 4a.75.75 0 110 1.5H20v5a.75.75 0 11-1.5 0v-5H17a.75.75 0 110-1.5h4.5zM19.25 2a.75.75 0 01.75.75v9.75a.75.75 0 11-1.5 0V2.75a.75.75 0 01.75-.75zM4.75 2a.75.75 0 01.75.75v7.75a.75.75 0 11-1.5 0V2.75A.75.75 0 014.75 2zM12 2a.75.75 0 01.75.75v5h1.5a.75.75 0 110 1.5h-4.5a.75.75 0 010-1.5h1.5v-5A.75.75 0 0112 2z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Sliders = React.forwardRef(IconSliders);
function IconSmartpay(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M19.25 3c.966 0 1.75.784 1.75 1.75V7.5h-5a5 5 0 00-4.995 4.783L11 12.5a5 5 0 004.783 4.995L16 17.5h5v1.75A1.75 1.75 0 0119.25 21H4.75A1.75 1.75 0 013 19.25V4.75C3 3.784 3.784 3 4.75 3h14.5zm1.5 6c.69 0 1.25.56 1.25 1.25v4.5c0 .69-.56 1.25-1.25 1.25H16a3.5 3.5 0 010-7h4.75zM16 11a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Smartpay = React.forwardRef(IconSmartpay);
function IconSortBy(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M5.25 18a.75.75 0 110 1.5h-2.5a.75.75 0 110-1.5h2.5zm12.5-13.5a.75.75 0 01.743.648l.007.102v11.689l2.22-2.22a.75.75 0 011.133.977l-.073.084-3.5 3.5a.753.753 0 01-.125.101l-.088.049-.119.043-.106.021-.041.004-.07.002-.073-.006-.076-.013-.08-.023-.1-.043a.75.75 0 01-.182-.135l-3.5-3.5a.75.75 0 01.976-1.133l.084.073L17 16.939V5.25a.75.75 0 01.75-.75zm-9.5 9a.75.75 0 110 1.5h-5.5a.75.75 0 110-1.5h5.5zm3-4.5a.75.75 0 110 1.5h-8.5a.75.75 0 110-1.5h8.5zm3-4.5a.75.75 0 110 1.5H2.75a.75.75 0 010-1.5h11.5z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const SortBy = React.forwardRef(IconSortBy);
function IconStarSolid(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M8.895 8.726l-6.683.358-.105.012c-.608.114-.833.91-.328 1.319l5.197 4.217-1.725 6.467-.02.098c-.085.616.605 1.08 1.152.725L12 18.28l5.617 3.64.087.05c.56.27 1.214-.242 1.045-.872l-1.726-6.467 5.198-4.217.077-.072c.425-.45.14-1.225-.51-1.26l-6.684-.357L12.7 2.481a.75.75 0 00-1.4 0L8.895 8.726z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const StarSolid = React.forwardRef(IconStarSolid);
function IconStar(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M8.895 8.726l-6.683.358-.105.012c-.608.114-.833.91-.328 1.319l5.197 4.217-1.725 6.467-.02.098c-.085.616.605 1.08 1.152.725L12 18.28l5.617 3.64.087.05c.56.27 1.214-.242 1.045-.872l-1.726-6.467 5.198-4.217.077-.072c.425-.45.14-1.225-.51-1.26l-6.684-.357L12.7 2.481a.75.75 0 00-1.4 0L8.895 8.726zM12 4.836l1.88 4.883.046.1a.75.75 0 00.614.38l5.223.278-4.062 3.297-.08.075a.75.75 0 00-.172.7l1.349 5.055-4.39-2.845-.096-.053a.75.75 0 00-.72.053l-4.391 2.845 1.35-5.054.02-.108a.75.75 0 00-.272-.668l-4.063-3.297 5.224-.278a.75.75 0 00.66-.48L12 4.836z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Star = React.forwardRef(IconStar);
function IconSubscriptions(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M18.25 2c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0118.25 22H13l-.001-1.5h5.251a.25.25 0 00.243-.193l.007-.057V3.75a.25.25 0 00-.193-.243L18.25 3.5H5.75a.25.25 0 00-.243.193L5.5 3.75 5.499 13H4V3.75C4 2.784 4.784 2 5.75 2h12.5zM4.142 16.956a.5.5 0 01.55-.147l.082.038 2.143 1.237.074.052a.5.5 0 01.147.55l-.038.081-.052.074a.5.5 0 01-.55.147l-.081-.038-.878-.505a2.5 2.5 0 004 1.525.75.75 0 11.925 1.181 4.002 4.002 0 01-6.343-2.173l-.402.695-.052.074a.5.5 0 01-.852-.492l.038-.082 1.238-2.143.051-.074zM8 14a4.001 4.001 0 013.92 3.197l.358-.62a.5.5 0 01.6-.221l.083.038a.5.5 0 01.22.601l-.037.082-1.238 2.143a.5.5 0 01-.6.221l-.083-.038-2.143-1.237a.5.5 0 01.418-.904l.082.038.914.528a2.5 2.5 0 00-4.033-1.798.75.75 0 11-.925-1.181A3.985 3.985 0 018 14zm7.75-1a.75.75 0 110 1.5h-2.5a.75.75 0 110-1.5h2.5zm0-3.5a.75.75 0 110 1.5h-7.5a.75.75 0 110-1.5h7.5zm0-3.5a.75.75 0 110 1.5h-7.5a.75.75 0 010-1.5h7.5z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Subscriptions = React.forwardRef(IconSubscriptions);
function IconSystemEntries(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M19.25 3c.966 0 1.75.784 1.75 1.75v14.5A1.75 1.75 0 0119.25 21H4.75A1.75 1.75 0 013 19.25V4.75C3 3.784 3.784 3 4.75 3h14.5zm.25 3h-15v13.25a.25.25 0 00.193.243l.057.007h14.5a.25.25 0 00.243-.193l.007-.057V6zm-8.75 9.5a.75.75 0 110 1.5h-4a.75.75 0 110-1.5h4zm6.5 0a.75.75 0 110 1.5h-4a.75.75 0 110-1.5h4zm-6.5-3.5a.75.75 0 110 1.5h-4a.75.75 0 110-1.5h4zm6.5 0a.75.75 0 110 1.5h-4a.75.75 0 110-1.5h4zm-6.5-3.5a.75.75 0 110 1.5h-4a.75.75 0 010-1.5h4zm6.5 0a.75.75 0 110 1.5h-4a.75.75 0 110-1.5h4z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const SystemEntries = React.forwardRef(IconSystemEntries);
function IconTag(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10.356 2c.464 0 .909.184 1.237.513l9.92 9.919a1.75 1.75 0 010 2.475l-6.606 6.606a1.75 1.75 0 01-2.475 0l-9.92-9.92A1.75 1.75 0 012 10.356V3.75C2 2.784 2.784 2 3.75 2h6.606zm0 1.5H3.75a.25.25 0 00-.243.193L3.5 3.75v6.606a.25.25 0 00.033.125l.04.051 9.92 9.92a.25.25 0 00.3.04l.053-.04 6.606-6.606a.25.25 0 00.04-.3l-.04-.053-9.92-9.92a.25.25 0 00-.111-.064l-.065-.009zm1.57 5.394c.365-.007.652.086.852.287.256.255.225.645-.02.89-.215.215-.453.322-.78.366-.512.07-.826.211-1.13.515-.335.335-.335.742-.114.963.203.203.484.176.923-.106l.123-.084.715-.5c1.04-.729 1.934-.732 2.666 0 .809.809.81 1.956.044 3.041l-.12.163.155.155c.238.238.128.494-.02.642-.14.14-.364.246-.581.093l-.072-.062-.145-.145c-.615.532-1.285.857-1.858.87-.349.004-.642-.082-.85-.29-.306-.307-.244-.714.042-1 .145-.146.32-.24.605-.301l.151-.028c.529-.08.991-.293 1.271-.573.425-.425.46-.818.197-1.08-.193-.194-.473-.155-.963.148l-.139.09-.71.476c-1.05.711-1.938.694-2.677-.045-.789-.79-.783-1.929-.026-2.957l.12-.154-.204-.203c-.242-.242-.121-.494.03-.646.138-.137.353-.246.57-.09l.073.062.214.214c.546-.435 1.14-.704 1.657-.71zM6.042 6.043a1 1 0 111.414 1.414 1 1 0 01-1.414-1.414z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Tag$1 = React.forwardRef(IconTag);
function IconTemplateOverride(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M14.5 20.5V22h-5v-1.5h5zm-9-2.5v2.25a.25.25 0 00.193.243l.057.007H8V22H5.75A1.75 1.75 0 014 20.25V18h1.5zM20 18v2.25A1.75 1.75 0 0118.25 22H16v-1.5h2.25a.25.25 0 00.243-.193l.007-.057V18H20zm0-5.25v3.75h-1.5v-3.75H20zm-14.5 0v3.75H4v-3.75h1.5zM20 7.5v3.75h-1.5V7.5H20zM4 11.25V7.5h9.25a.75.75 0 01.75.75v2.25a.75.75 0 01-.75.75H4zM18.25 2c.966 0 1.75.784 1.75 1.75V6h-1.5V3.75a.25.25 0 00-.193-.243L18.25 3.5 16 3.499V2h2.25zM8 2v1.5H5.75a.25.25 0 00-.243.193L5.5 3.75V6H4V3.75C4 2.784 4.784 2 5.75 2H8zm6.5 0v1.499l-5 .001V2h5z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const TemplateOverride = React.forwardRef(IconTemplateOverride);
function IconTemplates(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M14.5 20.5V22h-5v-1.5h5zm-9-2.5v2.25a.25.25 0 00.193.243l.057.007H8V22H5.75A1.75 1.75 0 014 20.25V18h1.5zM20 18v2.25A1.75 1.75 0 0118.25 22H16v-1.5h2.25a.25.25 0 00.243-.193l.007-.057V18H20zm0-5.25v3.75h-1.5v-3.75H20zm-14.5 0v3.75H4v-3.75h1.5zM12.25 14a.75.75 0 110 1.5h-3.5a.75.75 0 110-1.5h3.5zm0-4a.75.75 0 110 1.5h-3.5a.75.75 0 110-1.5h3.5zM20 7.5v3.75h-1.5V7.5H20zm-14.5 0v3.75H4V7.5h1.5zM15.25 6a.75.75 0 110 1.5h-6.5a.75.75 0 010-1.5h6.5zm3-4c.966 0 1.75.784 1.75 1.75V6h-1.5V3.75a.25.25 0 00-.193-.243L18.25 3.5 16 3.499V2h2.25zM8 2v1.5H5.75a.25.25 0 00-.243.193L5.5 3.75V6H4V3.75C4 2.784 4.784 2 5.75 2H8zm6.5 0v1.499l-5 .001V2h5z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Templates = React.forwardRef(IconTemplates);
function IconThumbBoth(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M18 11.25a1.75 1.75 0 011.744 1.606l.006.144v4.586c0 .406-.141.797-.396 1.109l-.117.128-3.304 3.305a1.25 1.25 0 01-2.114-1.11l.032-.133.642-2.135H12.5a1.75 1.75 0 01-1.726-1.458l-.018-.148L10.75 17c0-.173.026-.345.076-.51l.059-.163 1.666-4a1.75 1.75 0 011.465-1.07l.15-.007H18zm0 1.5h-3.833a.25.25 0 00-.202.102l-.03.052-1.666 4a.25.25 0 00.174.34l.057.006h2.866a.85.85 0 01.838.99l-.024.104-.606 2.023 2.603-2.604a.25.25 0 00.064-.112l.009-.065V13a.25.25 0 00-.193-.243L18 12.75zm4-1.5c.513 0 .94.441.994 1.003l.006.122v4.5c0 .619-.45 1.125-1 1.125-.513 0-.94-.441-.994-1.003L21 16.875v-4.5c0-.619.45-1.125 1-1.125zM2 6c.513 0 .94.441.994 1.003L3 7.125v4.5c0 .619-.45 1.125-1 1.125-.513 0-.94-.441-.994-1.003L1 11.625v-4.5C1 6.506 1.45 6 2 6zm6.067-4.128a1.25 1.25 0 012.114 1.11l-.032.133-.642 2.135H11.5c.867 0 1.587.63 1.726 1.458l.018.148.006.144c0 .173-.026.345-.076.51l-.059.163-1.666 4a1.75 1.75 0 01-1.465 1.07l-.15.007H6a1.75 1.75 0 01-1.744-1.606L4.25 11V6.414c0-.406.141-.797.396-1.109l.117-.128 3.304-3.305zm.359 1.761L5.823 6.237a.25.25 0 00-.064.112l-.009.065V11a.25.25 0 00.193.243L6 11.25h3.833a.25.25 0 00.202-.102l.03-.052 1.666-4a.25.25 0 00-.174-.34L11.5 6.75H8.634c-.123-.006-.123-.006-.244-.036a.85.85 0 01-.594-.954l.024-.104.606-2.023z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const ThumbBoth = React.forwardRef(IconThumbBoth);
function IconThumbDownSolid(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M14.839 4c.935 0 1.709.754 1.784 1.705l.006.152v9.277c0 .438-.149.86-.414 1.19l-.105.12-4.96 5.144a1.298 1.298 0 01-1.888.01 1.427 1.427 0 01-.389-1.118l.022-.155.85-4.253H4.687c-1.868 0-3.145-1.925-2.531-3.719l.06-.163 2.919-7.066c.266-.63.84-1.06 1.495-1.117L6.782 4h8.057zm5.37 0c.936 0 1.71.754 1.785 1.705l.006.152v7.43c0 1.02-.806 1.856-1.79 1.856-.936 0-1.71-.754-1.785-1.705l-.006-.152V5.857c0-1.021.806-1.857 1.79-1.857z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const ThumbDownSolid = React.forwardRef(IconThumbDownSolid);
function IconThumbDown(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M14.839 4c.935 0 1.709.754 1.784 1.705l.006.152v9.277c0 .438-.149.86-.414 1.19l-.105.12-4.96 5.144a1.298 1.298 0 01-1.888.01 1.427 1.427 0 01-.389-1.118l.022-.155.85-4.253H4.687c-1.868 0-3.145-1.925-2.531-3.719l.06-.163 2.919-7.066c.266-.63.84-1.06 1.495-1.117L6.782 4h8.057zm0 1.5H6.782a.284.284 0 00-.223.129l-.038.067-2.916 7.062c-.34.83.192 1.728.97 1.808l.112.006h6.888l-1.114 5.57 4.569-4.74a.373.373 0 00.092-.19l.007-.078V5.857c0-.18-.112-.318-.237-.35L14.84 5.5zm5.37-1.5c.936 0 1.71.754 1.785 1.705l.006.152v7.43c0 1.02-.806 1.856-1.79 1.856-.936 0-1.71-.754-1.785-1.705l-.006-.152V5.857c0-1.021.806-1.857 1.79-1.857z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const ThumbDown = React.forwardRef(IconThumbDown);
function IconThumbUpSolid(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M12.85 2.412a1.298 1.298 0 011.888-.01c.287.298.425.705.389 1.118l-.022.155-.85 4.253h5.058c1.868 0 3.145 1.925 2.531 3.719l-.06.163-2.919 7.066a1.811 1.811 0 01-1.495 1.117l-.152.007H9.161c-.935 0-1.709-.754-1.784-1.705l-.006-.152V8.866c0-.438.149-.86.414-1.19l.105-.12 4.96-5.144zM3.79 8.857c.936 0 1.71.754 1.785 1.705l.006.152v7.429C5.58 19.164 4.775 20 3.79 20c-.936 0-1.71-.754-1.785-1.705L2 18.143v-7.43c0-1.02.806-1.856 1.79-1.856z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const ThumbUpSolid = React.forwardRef(IconThumbUpSolid);
function IconThumbUp(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M14.738 2.403c.287.297.425.704.389 1.117l-.022.155-.85 4.253h5.058c1.868 0 3.145 1.925 2.531 3.719l-.06.163-2.919 7.066a1.811 1.811 0 01-1.495 1.117l-.152.007H9.161c-.935 0-1.709-.754-1.784-1.705l-.006-.152V8.866c0-.438.149-.86.414-1.19l.105-.12 4.96-5.144a1.298 1.298 0 011.888-.01zM3.79 8.857c.936 0 1.71.754 1.785 1.705l.006.152v7.429C5.58 19.164 4.775 20 3.79 20c-.936 0-1.71-.754-1.785-1.705L2 18.143v-7.43c0-1.02.806-1.856 1.79-1.856zm9.749-4.999L8.97 8.598a.373.373 0 00-.092.19l-.007.078v9.277c0 .18.112.318.237.35l.053.007h8.057c.08 0 .166-.047.223-.129l.038-.067 2.916-7.062c.34-.83-.192-1.728-.97-1.808l-.112-.006h-6.888l1.114-5.57z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const ThumbUp = React.forwardRef(IconThumbUp);
function IconTickBold(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.832 4.752a1.5 1.5 0 01.416 2.08l-8 12a1.5 1.5 0 01-2.496 0l-4-6a1.5 1.5 0 112.496-1.664L10 15.296l6.752-10.128a1.5 1.5 0 012.08-.416z",
      fill: "currentColor"
    }
  ));
}
const TickBold = React.forwardRef(IconTickBold);
function IconTick(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M16.867 6.097a.75.75 0 011.318.708l-.052.098-7 11a.75.75 0 01-1.145.145l-.074-.08-4-5A.75.75 0 017.01 11.95l.076.081 3.344 4.181 6.437-10.115z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Tick = React.forwardRef(IconTick);
function IconTime(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M16.5 16c2.434 0 3.88 1.316 4.34 3.95A1.75 1.75 0 0119.116 22h-5.232a1.75 1.75 0 01-1.724-2.05c.46-2.634 1.906-3.95 4.34-3.95zM12 2c5.523 0 10 4.477 10 10a9.96 9.96 0 01-1.005 4.374 5.097 5.097 0 00-1.182-1.017A8.488 8.488 0 0020.5 12a8.5 8.5 0 10-9.996 8.369c.02.578.196 1.118.487 1.58C5.942 21.444 2 17.183 2 12 2 6.477 6.477 2 12 2zm4.5 8.5c1.105 0 2 1.12 2 2.5s-.895 2.5-2 2.5-2-1.12-2-2.5.895-2.5 2-2.5zM12 5.25a.75.75 0 01.743.648L12.75 6v6a.75.75 0 01-.648.743L12 12.75H7.5a.75.75 0 01-.102-1.493l.102-.007h3.75V6a.75.75 0 01.75-.75z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Time = React.forwardRef(IconTime);
function IconTransferCancel(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M18.804 15.647a.75.75 0 011.049 1.05l-.073.083-1.969 1.97 1.97 1.97a.75.75 0 01-.977 1.133l-.084-.073-1.97-1.969-1.97 1.97-.084.072a.75.75 0 01-1.049-1.05l.073-.083 1.969-1.97-1.97-1.97a.75.75 0 01.977-1.133l.084.073 1.97 1.969 1.97-1.97.084-.072z",
      fill: "#CF3C16",
      fillRule: "nonzero"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M5.5 16.5v3.75a.25.25 0 00.193.243l.057.007H12V22H5.75A1.75 1.75 0 014 20.25V16.5h1.5zm2.946-6.103l.084.073 3 3a.75.75 0 01.073.976l-.073.084-3 3a.75.75 0 01-1.133-.976l.073-.084 1.719-1.72H2.75a.75.75 0 01-.102-1.493l.102-.007h6.439l-1.72-1.72a.75.75 0 01-.072-.976l.073-.084a.75.75 0 01.976-.073zM13.586 2a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V14h-1.5V9h-3.75a1.75 1.75 0 01-1.744-1.606L13 7.25V3.5H5.75a.25.25 0 00-.243.193L5.5 3.75v7.75H4V3.75C4 2.784 4.784 2 5.75 2h7.836zm.914 2.621V7.25a.25.25 0 00.193.243l.057.007h2.63L14.5 4.621z",
      fill: "currentColor"
    }
  )));
}
const TransferCancel = React.forwardRef(IconTransferCancel);
function IconTransferLocked(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M5.5 16.5v3.75a.25.25 0 00.193.243l.057.007h4.75V22H5.75A1.75 1.75 0 014 20.25V16.5h1.5zM16 12a3 3 0 013 3v1a1 1 0 011 1v4a1 1 0 01-1 1h-6a1 1 0 01-1-1v-4a1 1 0 011-1v-1a3 3 0 013-3zm0 5.5a1 1 0 00-.5 1.866V20a.5.5 0 00.992.09L16.5 20l.001-.634A1 1 0 0016 17.5zm-7.554-7.103l.084.073 3 3a.75.75 0 01.073.976l-.073.084-3 3a.75.75 0 01-1.133-.976l.073-.084 1.719-1.72H2.75a.75.75 0 01-.102-1.493l.102-.007h6.439l-1.72-1.72a.75.75 0 01-.072-.976l.073-.084a.75.75 0 01.976-.073zM16 13.5a1.5 1.5 0 00-1.493 1.356L14.5 15v1h3v-1a1.5 1.5 0 00-1.356-1.493L16 13.5zM13.586 2a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V11.5h-1.5V9h-3.75a1.75 1.75 0 01-1.744-1.606L13 7.25V3.5H5.75a.25.25 0 00-.243.193L5.5 3.75v7.75H4V3.75C4 2.784 4.784 2 5.75 2h7.836zm.914 2.621V7.25a.25.25 0 00.193.243l.057.007h2.63L14.5 4.621z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const TransferLocked = React.forwardRef(IconTransferLocked);
function IconTransfer(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M13.586 2a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V20.25A1.75 1.75 0 0118.25 22H5.75A1.75 1.75 0 014 20.25V16.5h1.5v3.75a.25.25 0 00.193.243l.057.007h12.5a.25.25 0 00.243-.193l.007-.057V9h-3.75a1.75 1.75 0 01-1.744-1.606L13 7.25V3.5H5.75a.25.25 0 00-.243.193L5.5 3.75v7.75H4V3.75C4 2.784 4.784 2 5.75 2h7.836zm-5.14 8.397l.084.073 3 3a.75.75 0 01.073.976l-.073.084-3 3a.75.75 0 01-1.133-.976l.073-.084 1.719-1.72H2.75a.75.75 0 01-.102-1.493l.102-.007h6.439l-1.72-1.72a.75.75 0 01-.072-.976l.073-.084a.75.75 0 01.976-.073zM14.5 4.621V7.25a.25.25 0 00.193.243l.057.007h2.63L14.5 4.621z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Transfer = React.forwardRef(IconTransfer);
function IconUndo(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6.75 4.75l-4 4 4 4", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M3 8.75h13c2.9 0 5.25 2.35 5.25 5.25v0c0 2.9-2.35 5.25-5.25 5.25h-5.5",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round"
    }
  ));
}
const Undo = React.forwardRef(IconUndo);
function IconUndock(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M12 5v1.5H4.75a.25.25 0 00-.243.193L4.5 6.75v12.5a.25.25 0 00.193.243l.057.007h12.5a.25.25 0 00.243-.193l.007-.057V12H19v7.25A1.75 1.75 0 0117.25 21H4.75A1.75 1.75 0 013 19.25V6.75C3 5.784 3.784 5 4.75 5H12zm8.25-2a.75.75 0 01.743.648L21 3.75v4.5a.75.75 0 01-1.493.102L19.5 8.25V5.56l-4.97 4.97a.75.75 0 01-1.133-.976l.073-.084 4.968-4.97H15.75a.75.75 0 01-.743-.648L15 3.75a.75.75 0 01.648-.743L15.75 3h4.5z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Undock = React.forwardRef(IconUndock);
function IconUnreconciled(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M3.368 4.346l.092.062 18 14a.75.75 0 01-.828 1.246l-.092-.062-3.34-2.597L17 17h-2.5a.75.75 0 01-.102-1.493l.102-.007h.778l-3.536-2.75H7a.75.75 0 110-1.5h2.814l-3.46-2.69a3.501 3.501 0 00.454 6.935L7 15.5h2.5a.75.75 0 01.102 1.493L9.5 17H7a5 5 0 01-2.074-9.55L2.54 5.591a.75.75 0 01.828-1.246zM17 7a5 5 0 013.39 8.676l-1.208-.94a3.5 3.5 0 00-1.99-6.231L17 8.5h-2.5a.75.75 0 01-.102-1.493L14.5 7H17zm0 4.25a.75.75 0 110 1.5h-.372l-1.929-1.5H17z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Unreconciled = React.forwardRef(IconUnreconciled);
function IconWallet(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.75 4.5h14.5a.25.25 0 01.25.25V7H16a5 5 0 000 10h3.5v2.25a.25.25 0 01-.25.25H4.75a.25.25 0 01-.25-.25V4.75a.25.25 0 01.25-.25zM22 7h-1V4.75A1.75 1.75 0 0019.25 3H4.75A1.75 1.75 0 003 4.75v14.5c0 .966.784 1.75 1.75 1.75h14.5A1.75 1.75 0 0021 19.25V17h1a1 1 0 001-1V8a1 1 0 00-1-1zm-.5 1.5H16a3.5 3.5 0 100 7h5.5v-7zm-5.5 5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
      fill: "currentColor"
    }
  ));
}
const Wallet = React.forwardRef(IconWallet);
function IconWarning(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M13 18a1 1 0 11-2 0 1 1 0 012 0zM11.055 5.99A.97.97 0 0112.03 5a.97.97 0 01.971 1l-.23 7.76a.768.768 0 01-.77.74.768.768 0 01-.77-.748l-.175-7.763z",
      fill: "currentColor"
    }
  ));
}
const Warning = React.forwardRef(IconWarning);
function IconWebshop(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M11 15.5a2.25 2.25 0 110 4.5 2.25 2.25 0 010-4.5zm5.831 0a2.25 2.25 0 110 4.5 2.25 2.25 0 010-4.5zM11 17a.75.75 0 100 1.5.75.75 0 000-1.5zm5.831 0a.75.75 0 100 1.5.75.75 0 000-1.5zM5.287 4a1.75 1.75 0 011.56.955l.062.138 3.24 8a.25.25 0 00.173.15l.06.007h7.743a.25.25 0 00.204-.105l.028-.054 2.159-5.496a.25.25 0 00-.141-.324l-.045-.013-.047-.005-10.04-.003a.75.75 0 01-.102-1.493l.102-.007 10.04.003A1.75 1.75 0 0121.962 8l-.049.143-2.158 5.497a1.75 1.75 0 01-1.476 1.103l-.153.007h-7.743a1.75 1.75 0 01-1.56-.955l-.062-.138-3.24-8a.25.25 0 00-.173-.15l-.06-.007H2.75a.75.75 0 01-.102-1.493L2.75 4h2.537z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Webshop = React.forwardRef(IconWebshop);
function IconWebsite(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M20.25 4c.966 0 1.75.784 1.75 1.75v12.5A1.75 1.75 0 0120.25 20H3.75A1.75 1.75 0 012 18.25V5.75C2 4.784 2.784 4 3.75 4h16.5zm.25 6h-17v8.25a.25.25 0 00.193.243l.057.007h16.5a.25.25 0 00.243-.193l.007-.057V10zm-.25-4.5H3.75a.25.25 0 00-.243.193L3.5 5.75V8.5h17V5.75a.25.25 0 00-.193-.243L20.25 5.5zM5.5 6.5v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Website = React.forwardRef(IconWebsite);
function IconWorkflowTemplateBasic(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 1l5.762 3.12v6.161L23 13.117v6.763L17.238 23 12 20.164 6.762 23 1 19.88v-6.762l5.238-2.837V4.137L12 1zM6.761 11.183l-4.144 2.244 4.144 2.243 4.143-2.243-4.143-2.244zm4.714 3.12l-4.19 2.269v4.96l4.19-2.27v-4.96zm1.048 4.96l4.19 2.268v-4.96l-4.19-2.268v4.96zm.57-5.837l4.144 2.244 4.144-2.243-4.144-2.244-4.143 2.244zm8.858.877l-4.19 2.269v4.96l4.19-2.27v-4.96zm-9.428-1.753l4.19-2.269V5.305l-4.19 2.27v4.975zm-1.048-4.975l-4.19-2.256v4.962l4.19 2.27V7.574zm-3.62-3.133L12 6.672l4.144-2.243-4.142-2.243-4.145 2.256zm-1.618 17.09v-4.96l-4.19-2.27v4.96l4.19 2.27z",
      fill: "currentColor"
    }
  ));
}
const WorkflowTemplateBasic = React.forwardRef(IconWorkflowTemplateBasic);
function IconWorkflow(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M19.144 16.292a2.853 2.853 0 00-2.754 2.144H7.722a2.857 2.857 0 01-2.856-2.858 2.857 2.857 0 012.856-2.859h1.53a2.842 2.842 0 005.508 0h1.529a4.286 4.286 0 004.283-4.287 4.286 4.286 0 00-4.283-4.288H7.62A2.856 2.856 0 002 4.859a2.856 2.856 0 005.62.715h8.669a2.857 2.857 0 012.855 2.858 2.857 2.857 0 01-2.855 2.858h-1.53a2.842 2.842 0 00-5.508 0h-1.53a4.286 4.286 0 00-4.283 4.288 4.286 4.286 0 004.284 4.287h8.668a2.85 2.85 0 005.6-.964 2.852 2.852 0 00-2.846-2.609zM4.866 6.288a1.429 1.429 0 11.002-2.857 1.429 1.429 0 01-.002 2.857zm7.14 4.287a1.429 1.429 0 11-.002 2.857 1.429 1.429 0 01.001-2.857zm7.138 10.005a1.429 1.429 0 11.002-2.857 1.429 1.429 0 01-.002 2.857z",
      fill: "currentColor"
    }
  ));
}
const Workflow = React.forwardRef(IconWorkflow);
function IconZoom(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: svgRef, ...props }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10 2.25a7.75 7.75 0 015.985 12.674l5.545 5.546a.75.75 0 01-.976 1.133l-.084-.073-5.546-5.545A7.75 7.75 0 1110 2.25zm0 1.5a6.25 6.25 0 100 12.5 6.25 6.25 0 000-12.5zm0 2.75a.75.75 0 01.75.75v2h2a.75.75 0 110 1.5h-2v2a.75.75 0 11-1.5 0v-2h-2a.75.75 0 110-1.5h2v-2A.75.75 0 0110 6.5z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ));
}
const Zoom = React.forwardRef(IconZoom);
const icons = {
  "account-preview": AccountPreview,
  "accounting-year-cancel": AccountingYearCancel,
  "accounting-year": AccountingYear,
  accounting: Accounting,
  "ai-chat-solid": AiChatSolid,
  "ai-stars": AiStars,
  "arrow-bottom": ArrowBottom,
  "arrow-down": ArrowDown,
  "arrow-end": ArrowEnd,
  "arrow-left": ArrowLeft,
  "arrow-right": ArrowRight,
  "arrow-start": ArrowStart,
  "arrow-top": ArrowTop,
  "arrow-up": ArrowUp,
  "attach-auto": AttachAuto,
  "attach-cancel": AttachCancel,
  "attach-warning": AttachWarning,
  attach: Attach,
  "autopay-paused": AutopayPaused,
  autopay: Autopay,
  "autotext-insert": AutotextInsert,
  autotext: Autotext,
  "basic-tabs": BasicTabs,
  basic: Basic,
  "bell-solid": BellSolid,
  book: Book,
  booking: Booking,
  budget: Budget,
  calendar: Calendar$1,
  "cash-account": CashAccount,
  "cash-reports": CashReports,
  "chart-area": ChartArea,
  "chart-bar": ChartBar,
  "chart-line": ChartLine,
  "chart-pie": ChartPie,
  "chart-table": ChartTable,
  "chat-solid": ChatSolid,
  chat: Chat,
  "chevron-down-double": ChevronDownDouble,
  "chevron-down-solid": ChevronDownSolid,
  "chevron-down": ChevronDown,
  "chevron-left-double": ChevronLeftDouble,
  "chevron-left-solid": ChevronLeftSolid,
  "chevron-left": ChevronLeft,
  "chevron-right-double": ChevronRightDouble,
  "chevron-right-solid": ChevronRightSolid,
  "chevron-right": ChevronRight,
  "chevron-up-double": ChevronUpDouble,
  "chevron-up-solid": ChevronUpSolid,
  "chevron-up": ChevronUp,
  "circle-close": CircleClose,
  "circle-information": CircleInformation,
  "circle-minus": CircleMinus,
  "circle-plus": CirclePlus,
  "circle-questionmark": CircleQuestionmark,
  "circle-tick": CircleTick,
  "circle-warning": CircleWarning,
  "clamp-open": ClampOpen,
  clamp: Clamp,
  close: Close$3,
  "column-freeze": ColumnFreeze,
  "column-unfreeze": ColumnUnfreeze,
  columns: Columns,
  "connection-enable": ConnectionEnable,
  "connection-revoke": ConnectionRevoke,
  contacts: Contacts,
  copy: Copy,
  courses: Courses,
  credit: Credit,
  "delete-permanently": DeletePermanently,
  delete: Delete,
  depecriate: Depecriate,
  developer: Developer,
  "distribution-template": DistributionTemplate,
  "document-approve": DocumentApprove,
  "document-create-entry": DocumentCreateEntry,
  "document-cut": DocumentCut,
  "document-error": DocumentError,
  "document-isolate-page": DocumentIsolatePage,
  "document-merge": DocumentMerge,
  "document-move": DocumentMove,
  "document-preview": DocumentPreview,
  "document-received": DocumentReceived,
  "document-rejected-request": DocumentRejectedRequest,
  "document-signed-solid": DocumentSignedSolid,
  "document-signed": DocumentSigned,
  "document-split": DocumentSplit,
  "document-time": DocumentTime,
  document: Document,
  download: Download,
  drag: Drag,
  "e-copedia": ECopedia,
  "edit-simple": EditSimple,
  edit: Edit,
  "ellipsis-horizontal": EllipsisHorizontal,
  "ellipsis-vertical": EllipsisVertical,
  "entries-on-account": EntriesOnAccount,
  "entries-open": EntriesOpen,
  "entries-warning": EntriesWarning,
  "entry-type-customer-invoice": EntryTypeCustomerInvoice,
  "entry-type-customer-payment": EntryTypeCustomerPayment,
  "entry-type-journal-entry": EntryTypeJournalEntry,
  "entry-type-manual-customer-invoice": EntryTypeManualCustomerInvoice,
  "entry-type-supplier-invoice": EntryTypeSupplierInvoice,
  "entry-type-supplier-payment": EntryTypeSupplierPayment,
  "envelope-approved": EnvelopeApproved,
  "envelope-solid": EnvelopeSolid,
  envelope: Envelope,
  "expand-view": ExpandView,
  expenses: Expenses,
  experiment: Experiment,
  "export-to-excel": ExportToExcel,
  "export-to-pdf": ExportToPdf,
  export: Export,
  "eye-off": EyeOff,
  "eye-on": EyeOn,
  "filter-solid": FilterSolid,
  filter: Filter$1,
  "font-size": FontSize,
  "graph-solid": GraphSolid,
  hash: Hash,
  "height-extra-tall": HeightExtraTall,
  "height-medium": HeightMedium,
  "height-short": HeightShort,
  "height-tall": HeightTall,
  "house-solid": HouseSolid,
  house: House,
  id: Id,
  images: Images,
  import: Import,
  "inbox-einvoicing": InboxEinvoicing,
  "inbox-scanning": InboxScanning,
  "inbox-smart": InboxSmart,
  inbox: Inbox,
  info: Info,
  "inventory-matrix": InventoryMatrix,
  inventory: Inventory,
  "journal-pro": JournalPro,
  "layout-both": LayoutBoth,
  "layout-first": LayoutFirst,
  "layout-last": LayoutLast,
  "layout-none": LayoutNone,
  layout: Layout$1,
  "ledger-card-customer-reminder": LedgerCardCustomerReminder,
  "ledger-card-manual-customer-invoice": LedgerCardManualCustomerInvoice,
  "ledger-card-obsolete-stock": LedgerCardObsoleteStock,
  "ledger-card-opening-entry": LedgerCardOpeningEntry,
  "ledger-card-reserved-entry": LedgerCardReservedEntry,
  "ledger-card-shrinkage-pilferage": LedgerCardShrinkagePilferage,
  "ledger-card-stock-adjustment": LedgerCardStockAdjustment,
  "ledger-card-transferred-opening-entry": LedgerCardTransferredOpeningEntry,
  "ledger-card": LedgerCard,
  lightbulb: Lightbulb,
  line: Line$2,
  "link-external": LinkExternal,
  "list-bulleted": ListBulleted,
  "list-search": ListSearch,
  list: List$2,
  location: Location,
  "lock-open": LockOpen,
  lock: Lock,
  "log-out": LogOut,
  log: Log,
  market: Market,
  "mastercard-os": MastercardOs,
  "match-amount": MatchAmount,
  "match-entries": MatchEntries,
  menu: Menu$2,
  mileage: Mileage,
  "modal-resize": ModalResize,
  "modal-shrink": ModalShrink,
  "more-solid": MoreSolid,
  more: More,
  move: Move,
  "navigation-list": NavigationList,
  "note-follow-up": NoteFollowUp,
  "note-read": NoteRead,
  note: Note,
  "november-first": NovemberFirst,
  numbers: Numbers,
  "partner-api": PartnerApi,
  "payment-paid": PaymentPaid,
  "payment-unpaid": PaymentUnpaid,
  period: Period,
  "person-change": PersonChange,
  "person-minus": PersonMinus,
  "person-plus": PersonPlus,
  "person-solid": PersonSolid,
  "person-tick": PersonTick,
  person: Person,
  "phone-solid": PhoneSolid,
  phone: Phone,
  play: Play,
  "plus-minus": PlusMinus,
  print: Print$1,
  "process-payment": ProcessPayment,
  "product-ledger-card": ProductLedgerCard,
  profile: Profile,
  "project-cards": ProjectCards,
  projects: Projects,
  "question-mark-bold": QuestionMarkBold,
  "question-mark": QuestionMark,
  quicklinks: Quicklinks,
  "rating-bankruptcy": RatingBankruptcy,
  "rating-payment-problems": RatingPaymentProblems,
  reconciled: Reconciled,
  refresh: Refresh,
  "report-solid": ReportSolid,
  report: Report$1,
  restore: Restore,
  "rotate-left": RotateLeft,
  "rotate-right": RotateRight,
  sales: Sales,
  "search-bold": SearchBold,
  search: Search$2,
  "secure-tick": SecureTick,
  secure: Secure,
  "settings-solid": SettingsSolid,
  settings: Settings$1,
  shortcuts: Shortcuts,
  "show-all": ShowAll,
  "show-less": ShowLess,
  "show-more": ShowMore,
  "show-template": ShowTemplate,
  sliders: Sliders,
  smartpay: Smartpay,
  "sort-by": SortBy,
  "star-solid": StarSolid,
  star: Star,
  subscriptions: Subscriptions,
  "system-entries": SystemEntries,
  tag: Tag$1,
  "template-override": TemplateOverride,
  templates: Templates,
  "thumb-both": ThumbBoth,
  "thumb-down-solid": ThumbDownSolid,
  "thumb-down": ThumbDown,
  "thumb-up-solid": ThumbUpSolid,
  "thumb-up": ThumbUp,
  "tick-bold": TickBold,
  tick: Tick,
  time: Time,
  "transfer-cancel": TransferCancel,
  "transfer-locked": TransferLocked,
  transfer: Transfer,
  undo: Undo,
  undock: Undock,
  unreconciled: Unreconciled,
  wallet: Wallet,
  warning: Warning,
  webshop: Webshop,
  website: Website,
  "workflow-template-basic": WorkflowTemplateBasic,
  workflow: Workflow,
  zoom: Zoom
};
const Icon$1 = React__default.forwardRef(function Icon2(props, ref) {
  var _a;
  const { name, ...otherProps } = props;
  const Component2 = icons[name];
  const className = clsx("inline-flex h-[1.715em] w-[1.715em] flex-shrink-0", props.className, {
    "p-[3px]": (_a = props.className) == null ? void 0 : _a.includes("rounded-full")
  });
  return Component2 ? /* @__PURE__ */ React__default.createElement(
    Component2,
    {
      ...otherProps,
      className,
      "data-taco": "icon",
      "data-icon-name": name,
      focusable: "false",
      ref,
      role: "img"
    }
  ) : null;
});
const BadgeIcon = React.forwardRef(function Badge(props, ref) {
  const { color: color2, icon, subtle, small, ...otherProps } = props;
  const className = clsx(
    `rounded-full border overflow-hidden whitespace-nowrap inline-flex items-center justify-center border-transparent [&>*]:max-h-full shrink-0`,
    { "w-5 h-5": !small },
    { "w-4 h-4 text-xs": small },
    { [getSubtleColorShadeClasses(color2)]: subtle, [getColorShadeClasses(color2)]: !subtle },
    props.className
  );
  const iconProps = {
    strokeWidth: 1,
    stroke: "currentColor"
  };
  return /* @__PURE__ */ React.createElement(
    "span",
    {
      ...otherProps,
      "aria-label": "icon",
      className,
      "data-taco": "badge-icon",
      ref,
      role: "status",
      title: props["aria-label"]
    },
    /* @__PURE__ */ React.createElement(Icon$1, { name: icon, ...iconProps })
  );
});
const getIconName = (state) => {
  switch (state) {
    case "information":
      return "info";
    case "warning":
      return "warning";
    case "error":
      return "close";
    case "experiment":
      return "experiment";
    case "success":
      return "tick";
    default:
      return "question-mark";
  }
};
const Alert$1 = React__default.forwardRef(function Alert2(props, ref) {
  const { children, title, state, onClose } = props;
  const className = clsx(
    `flex w-full flex-row items-start gap-2 rounded-md border-transparent p-3 ${getSubtleColorShadeClasses(
      getColorByState(state)
    )}`,
    props.className
  );
  return /* @__PURE__ */ React__default.createElement("div", { ...props, ref, className, "data-taco": "alert", role: "alert" }, /* @__PURE__ */ React__default.createElement(BadgeIcon, { className: "flex-none", icon: getIconName(state), color: getColorByState(state) }), /* @__PURE__ */ React__default.createElement("div", { className: "grow text-sm" }, title && /* @__PURE__ */ React__default.createElement("div", { className: "font-bold" }, title), children), onClose && /* @__PURE__ */ React__default.createElement(Icon$1, { className: "flex-none cursor-pointer", name: "close", onClick: onClose }));
});
function _extends$z() {
  return _extends$z = Object.assign ? Object.assign.bind() : function(n2) {
    for (var e3 = 1; e3 < arguments.length; e3++) {
      var t3 = arguments[e3];
      for (var r2 in t3) ({}).hasOwnProperty.call(t3, r2) && (n2[r2] = t3[r2]);
    }
    return n2;
  }, _extends$z.apply(null, arguments);
}
function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
  const Context2 = /* @__PURE__ */ createContext(defaultContext);
  function Provider2(props) {
    const { children, ...context } = props;
    const value = useMemo(
      () => context,
      Object.values(context)
    );
    return /* @__PURE__ */ createElement(Context2.Provider, {
      value
    }, children);
  }
  function useContext$1(consumerName) {
    const context = useContext(Context2);
    if (context) return context;
    if (defaultContext !== void 0) return defaultContext;
    throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
  }
  Provider2.displayName = rootComponentName + "Provider";
  return [
    Provider2,
    useContext$1
  ];
}
function $c512c27ab02ef895$export$50c7b4e9d9f19c1$1(scopeName, createContextScopeDeps = []) {
  let defaultContexts = [];
  function $c512c27ab02ef895$export$fd42f52fd3ae11092(rootComponentName, defaultContext) {
    const BaseContext = /* @__PURE__ */ createContext(defaultContext);
    const index2 = defaultContexts.length;
    defaultContexts = [
      ...defaultContexts,
      defaultContext
    ];
    function Provider2(props) {
      const { scope, children, ...context } = props;
      const Context2 = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index2]) || BaseContext;
      const value = useMemo(
        () => context,
        Object.values(context)
      );
      return /* @__PURE__ */ createElement(Context2.Provider, {
        value
      }, children);
    }
    function useContext$1(consumerName, scope) {
      const Context2 = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index2]) || BaseContext;
      const context = useContext(Context2);
      if (context) return context;
      if (defaultContext !== void 0) return defaultContext;
      throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider2.displayName = rootComponentName + "Provider";
    return [
      Provider2,
      useContext$1
    ];
  }
  const createScope = () => {
    const scopeContexts = defaultContexts.map((defaultContext) => {
      return /* @__PURE__ */ createContext(defaultContext);
    });
    return function useScope(scope) {
      const contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
      return useMemo(
        () => ({
          [`__scope${scopeName}`]: {
            ...scope,
            [scopeName]: contexts
          }
        }),
        [
          scope,
          contexts
        ]
      );
    };
  };
  createScope.scopeName = scopeName;
  return [
    $c512c27ab02ef895$export$fd42f52fd3ae11092,
    $c512c27ab02ef895$var$composeContextScopes$1(createScope, ...createContextScopeDeps)
  ];
}
function $c512c27ab02ef895$var$composeContextScopes$1(...scopes) {
  const baseScope = scopes[0];
  if (scopes.length === 1) return baseScope;
  const createScope1 = () => {
    const scopeHooks = scopes.map(
      (createScope) => ({
        useScope: createScope(),
        scopeName: createScope.scopeName
      })
    );
    return function useComposedScopes(overrideScopes) {
      const nextScopes1 = scopeHooks.reduce((nextScopes, { useScope, scopeName }) => {
        const scopeProps = useScope(overrideScopes);
        const currentScope = scopeProps[`__scope${scopeName}`];
        return {
          ...nextScopes,
          ...currentScope
        };
      }, {});
      return useMemo(
        () => ({
          [`__scope${baseScope.scopeName}`]: nextScopes1
        }),
        [
          nextScopes1
        ]
      );
    };
  };
  createScope1.scopeName = baseScope.scopeName;
  return createScope1;
}
function $6ed0406888f73fc4$var$setRef$1(ref, value) {
  if (typeof ref === "function") ref(value);
  else if (ref !== null && ref !== void 0) ref.current = value;
}
function $6ed0406888f73fc4$export$43e446d32b3d21af$1(...refs) {
  return (node) => refs.forEach(
    (ref) => $6ed0406888f73fc4$var$setRef$1(ref, node)
  );
}
function $6ed0406888f73fc4$export$c7b2cbe3552a0d05$1(...refs) {
  return useCallback($6ed0406888f73fc4$export$43e446d32b3d21af$1(...refs), refs);
}
function $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(originalEventHandler, ourEventHandler, { checkForDefaultPrevented = true } = {}) {
  return function handleEvent(event) {
    originalEventHandler === null || originalEventHandler === void 0 || originalEventHandler(event);
    if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
  };
}
const $9f79659886946c16$export$e5c5a5f917a5871c$5 = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) ? useLayoutEffect : () => {
};
const $1746a345f3d73bb7$var$useReactId$1 = React["useId".toString()] || (() => void 0);
let $1746a345f3d73bb7$var$count$1 = 0;
function $1746a345f3d73bb7$export$f680877a34711e37$1(deterministicId) {
  const [id2, setId] = React.useState($1746a345f3d73bb7$var$useReactId$1());
  $9f79659886946c16$export$e5c5a5f917a5871c$5(() => {
    setId(
      (reactId) => reactId !== null && reactId !== void 0 ? reactId : String($1746a345f3d73bb7$var$count$1++)
    );
  }, [
    deterministicId
  ]);
  return deterministicId || (id2 ? `radix-${id2}` : "");
}
function $b1b2314f5f9a1d84$export$25bec8c6f54ee79a$1(callback) {
  const callbackRef = useRef(callback);
  useEffect(() => {
    callbackRef.current = callback;
  });
  return useMemo(
    () => (...args) => {
      var _callbackRef$current;
      return (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 ? void 0 : _callbackRef$current.call(callbackRef, ...args);
    },
    []
  );
}
function $71cd76cc60e0454e$export$6f32135080cb4c3$1({ prop, defaultProp, onChange = () => {
} }) {
  const [uncontrolledProp, setUncontrolledProp] = $71cd76cc60e0454e$var$useUncontrolledState$1({
    defaultProp,
    onChange
  });
  const isControlled = prop !== void 0;
  const value1 = isControlled ? prop : uncontrolledProp;
  const handleChange = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a$1(onChange);
  const setValue = useCallback((nextValue) => {
    if (isControlled) {
      const setter = nextValue;
      const value = typeof nextValue === "function" ? setter(prop) : nextValue;
      if (value !== prop) handleChange(value);
    } else setUncontrolledProp(nextValue);
  }, [
    isControlled,
    prop,
    setUncontrolledProp,
    handleChange
  ]);
  return [
    value1,
    setValue
  ];
}
function $71cd76cc60e0454e$var$useUncontrolledState$1({ defaultProp, onChange }) {
  const uncontrolledState = useState(defaultProp);
  const [value] = uncontrolledState;
  const prevValueRef = useRef(value);
  const handleChange = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a$1(onChange);
  useEffect(() => {
    if (prevValueRef.current !== value) {
      handleChange(value);
      prevValueRef.current = value;
    }
  }, [
    value,
    prevValueRef,
    handleChange
  ]);
  return uncontrolledState;
}
const $5e63c961fc1ce211$export$8c6ed5c666ac1360$1 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { children, ...slotProps } = props;
  const childrenArray = Children.toArray(children);
  const slottable = childrenArray.find($5e63c961fc1ce211$var$isSlottable$1);
  if (slottable) {
    const newElement = slottable.props.children;
    const newChildren = childrenArray.map((child) => {
      if (child === slottable) {
        if (Children.count(newElement) > 1) return Children.only(null);
        return /* @__PURE__ */ isValidElement(newElement) ? newElement.props.children : null;
      } else return child;
    });
    return /* @__PURE__ */ createElement($5e63c961fc1ce211$var$SlotClone$1, _extends$z({}, slotProps, {
      ref: forwardedRef
    }), /* @__PURE__ */ isValidElement(newElement) ? /* @__PURE__ */ cloneElement(newElement, void 0, newChildren) : null);
  }
  return /* @__PURE__ */ createElement($5e63c961fc1ce211$var$SlotClone$1, _extends$z({}, slotProps, {
    ref: forwardedRef
  }), children);
});
$5e63c961fc1ce211$export$8c6ed5c666ac1360$1.displayName = "Slot";
const $5e63c961fc1ce211$var$SlotClone$1 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { children, ...slotProps } = props;
  if (/* @__PURE__ */ isValidElement(children)) return /* @__PURE__ */ cloneElement(children, {
    ...$5e63c961fc1ce211$var$mergeProps$1(slotProps, children.props),
    ref: $6ed0406888f73fc4$export$43e446d32b3d21af$1(forwardedRef, children.ref)
  });
  return Children.count(children) > 1 ? Children.only(null) : null;
});
$5e63c961fc1ce211$var$SlotClone$1.displayName = "SlotClone";
const $5e63c961fc1ce211$export$d9f1ccf0bdb05d45$1 = ({ children }) => {
  return /* @__PURE__ */ createElement(Fragment, null, children);
};
function $5e63c961fc1ce211$var$isSlottable$1(child) {
  return /* @__PURE__ */ isValidElement(child) && child.type === $5e63c961fc1ce211$export$d9f1ccf0bdb05d45$1;
}
function $5e63c961fc1ce211$var$mergeProps$1(slotProps, childProps) {
  const overrideProps = {
    ...childProps
  };
  for (const propName in childProps) {
    const slotPropValue = slotProps[propName];
    const childPropValue = childProps[propName];
    const isHandler = /^on[A-Z]/.test(propName);
    if (isHandler) {
      if (slotPropValue && childPropValue) overrideProps[propName] = (...args) => {
        childPropValue(...args);
        slotPropValue(...args);
      };
      else if (slotPropValue) overrideProps[propName] = slotPropValue;
    } else if (propName === "style") overrideProps[propName] = {
      ...slotPropValue,
      ...childPropValue
    };
    else if (propName === "className") overrideProps[propName] = [
      slotPropValue,
      childPropValue
    ].filter(Boolean).join(" ");
  }
  return {
    ...slotProps,
    ...overrideProps
  };
}
const $8927f6f2acc4f386$var$NODES$1 = [
  "a",
  "button",
  "div",
  "h2",
  "h3",
  "img",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
];
const $8927f6f2acc4f386$export$250ffa63cdc0d034$1 = $8927f6f2acc4f386$var$NODES$1.reduce((primitive, node) => {
  const Node2 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
    const { asChild, ...primitiveProps } = props;
    const Comp = asChild ? $5e63c961fc1ce211$export$8c6ed5c666ac1360$1 : node;
    useEffect(() => {
      window[Symbol.for("radix-ui")] = true;
    }, []);
    return /* @__PURE__ */ createElement(Comp, _extends$z({}, primitiveProps, {
      ref: forwardedRef
    }));
  });
  Node2.displayName = `Primitive.${node}`;
  return {
    ...primitive,
    [node]: Node2
  };
}, {});
function $8927f6f2acc4f386$export$6d1a0317bde7de7f(target, event) {
  if (target) flushSync$1(
    () => target.dispatchEvent(event)
  );
}
function $addc16e1bbe58fd0$export$3a72a57244d6e765(onEscapeKeyDownProp, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
  const onEscapeKeyDown = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a$1(onEscapeKeyDownProp);
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") onEscapeKeyDown(event);
    };
    ownerDocument.addEventListener("keydown", handleKeyDown);
    return () => ownerDocument.removeEventListener("keydown", handleKeyDown);
  }, [
    onEscapeKeyDown,
    ownerDocument
  ]);
}
const $5cb92bef7577960e$var$CONTEXT_UPDATE = "dismissableLayer.update";
const $5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
const $5cb92bef7577960e$var$FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
let $5cb92bef7577960e$var$originalBodyPointerEvents;
const $5cb92bef7577960e$var$DismissableLayerContext = /* @__PURE__ */ createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
});
const $5cb92bef7577960e$export$177fb62ff3ec1f22 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  var _node$ownerDocument;
  const { disableOutsidePointerEvents = false, onEscapeKeyDown, onPointerDownOutside, onFocusOutside, onInteractOutside, onDismiss, ...layerProps } = props;
  const context = useContext($5cb92bef7577960e$var$DismissableLayerContext);
  const [node1, setNode] = useState(null);
  const ownerDocument = (_node$ownerDocument = node1 === null || node1 === void 0 ? void 0 : node1.ownerDocument) !== null && _node$ownerDocument !== void 0 ? _node$ownerDocument : globalThis === null || globalThis === void 0 ? void 0 : globalThis.document;
  const [, force] = useState({});
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05$1(
    forwardedRef,
    (node) => setNode(node)
  );
  const layers = Array.from(context.layers);
  const [highestLayerWithOutsidePointerEventsDisabled] = [
    ...context.layersWithOutsidePointerEventsDisabled
  ].slice(-1);
  const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled);
  const index2 = node1 ? layers.indexOf(node1) : -1;
  const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
  const isPointerEventsEnabled = index2 >= highestLayerWithOutsidePointerEventsDisabledIndex;
  const pointerDownOutside = $5cb92bef7577960e$var$usePointerDownOutside((event) => {
    const target = event.target;
    const isPointerDownOnBranch = [
      ...context.branches
    ].some(
      (branch) => branch.contains(target)
    );
    if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
    onPointerDownOutside === null || onPointerDownOutside === void 0 || onPointerDownOutside(event);
    onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
    if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
  }, ownerDocument);
  const focusOutside = $5cb92bef7577960e$var$useFocusOutside((event) => {
    const target = event.target;
    const isFocusInBranch = [
      ...context.branches
    ].some(
      (branch) => branch.contains(target)
    );
    if (isFocusInBranch) return;
    onFocusOutside === null || onFocusOutside === void 0 || onFocusOutside(event);
    onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
    if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
  }, ownerDocument);
  $addc16e1bbe58fd0$export$3a72a57244d6e765((event) => {
    const isHighestLayer = index2 === context.layers.size - 1;
    if (!isHighestLayer) return;
    onEscapeKeyDown === null || onEscapeKeyDown === void 0 || onEscapeKeyDown(event);
    if (!event.defaultPrevented && onDismiss) {
      event.preventDefault();
      onDismiss();
    }
  }, ownerDocument);
  useEffect(() => {
    if (!node1) return;
    if (disableOutsidePointerEvents) {
      if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
        $5cb92bef7577960e$var$originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
        ownerDocument.body.style.pointerEvents = "none";
      }
      context.layersWithOutsidePointerEventsDisabled.add(node1);
    }
    context.layers.add(node1);
    $5cb92bef7577960e$var$dispatchUpdate();
    return () => {
      if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) ownerDocument.body.style.pointerEvents = $5cb92bef7577960e$var$originalBodyPointerEvents;
    };
  }, [
    node1,
    ownerDocument,
    disableOutsidePointerEvents,
    context
  ]);
  useEffect(() => {
    return () => {
      if (!node1) return;
      context.layers.delete(node1);
      context.layersWithOutsidePointerEventsDisabled.delete(node1);
      $5cb92bef7577960e$var$dispatchUpdate();
    };
  }, [
    node1,
    context
  ]);
  useEffect(() => {
    const handleUpdate = () => force({});
    document.addEventListener($5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate);
    return () => document.removeEventListener($5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate);
  }, []);
  return /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.div, _extends$z({}, layerProps, {
    ref: composedRefs,
    style: {
      pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : void 0,
      ...props.style
    },
    onFocusCapture: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(props.onFocusCapture, focusOutside.onFocusCapture),
    onBlurCapture: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(props.onBlurCapture, focusOutside.onBlurCapture),
    onPointerDownCapture: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
  }));
});
function $5cb92bef7577960e$var$usePointerDownOutside(onPointerDownOutside, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
  const handlePointerDownOutside = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a$1(onPointerDownOutside);
  const isPointerInsideReactTreeRef = useRef(false);
  const handleClickRef = useRef(() => {
  });
  useEffect(() => {
    const handlePointerDown = (event) => {
      if (event.target && !isPointerInsideReactTreeRef.current) {
        let handleAndDispatchPointerDownOutsideEvent = function() {
          $5cb92bef7577960e$var$handleAndDispatchCustomEvent($5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
            discrete: true
          });
        };
        const eventDetail = {
          originalEvent: event
        };
        if (event.pointerType === "touch") {
          ownerDocument.removeEventListener("click", handleClickRef.current);
          handleClickRef.current = handleAndDispatchPointerDownOutsideEvent;
          ownerDocument.addEventListener("click", handleClickRef.current, {
            once: true
          });
        } else handleAndDispatchPointerDownOutsideEvent();
      }
      isPointerInsideReactTreeRef.current = false;
    };
    const timerId = window.setTimeout(() => {
      ownerDocument.addEventListener("pointerdown", handlePointerDown);
    }, 0);
    return () => {
      window.clearTimeout(timerId);
      ownerDocument.removeEventListener("pointerdown", handlePointerDown);
      ownerDocument.removeEventListener("click", handleClickRef.current);
    };
  }, [
    ownerDocument,
    handlePointerDownOutside
  ]);
  return {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => isPointerInsideReactTreeRef.current = true
  };
}
function $5cb92bef7577960e$var$useFocusOutside(onFocusOutside, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
  const handleFocusOutside = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a$1(onFocusOutside);
  const isFocusInsideReactTreeRef = useRef(false);
  useEffect(() => {
    const handleFocus = (event) => {
      if (event.target && !isFocusInsideReactTreeRef.current) {
        const eventDetail = {
          originalEvent: event
        };
        $5cb92bef7577960e$var$handleAndDispatchCustomEvent($5cb92bef7577960e$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
          discrete: false
        });
      }
    };
    ownerDocument.addEventListener("focusin", handleFocus);
    return () => ownerDocument.removeEventListener("focusin", handleFocus);
  }, [
    ownerDocument,
    handleFocusOutside
  ]);
  return {
    onFocusCapture: () => isFocusInsideReactTreeRef.current = true,
    onBlurCapture: () => isFocusInsideReactTreeRef.current = false
  };
}
function $5cb92bef7577960e$var$dispatchUpdate() {
  const event = new CustomEvent($5cb92bef7577960e$var$CONTEXT_UPDATE);
  document.dispatchEvent(event);
}
function $5cb92bef7577960e$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete }) {
  const target = detail.originalEvent.target;
  const event = new CustomEvent(name, {
    bubbles: false,
    cancelable: true,
    detail
  });
  if (handler) target.addEventListener(name, handler, {
    once: true
  });
  if (discrete) $8927f6f2acc4f386$export$6d1a0317bde7de7f(target, event);
  else target.dispatchEvent(event);
}
const $d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount";
const $d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount";
const $d3863c46a17e8a28$var$EVENT_OPTIONS = {
  bubbles: false,
  cancelable: true
};
const $d3863c46a17e8a28$export$20e40289641fbbb6 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { loop = false, trapped = false, onMountAutoFocus: onMountAutoFocusProp, onUnmountAutoFocus: onUnmountAutoFocusProp, ...scopeProps } = props;
  const [container1, setContainer] = useState(null);
  const onMountAutoFocus = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a$1(onMountAutoFocusProp);
  const onUnmountAutoFocus = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a$1(onUnmountAutoFocusProp);
  const lastFocusedElementRef = useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05$1(
    forwardedRef,
    (node) => setContainer(node)
  );
  const focusScope = useRef({
    paused: false,
    pause() {
      this.paused = true;
    },
    resume() {
      this.paused = false;
    }
  }).current;
  useEffect(() => {
    if (trapped) {
      let handleFocusIn = function(event) {
        if (focusScope.paused || !container1) return;
        const target = event.target;
        if (container1.contains(target)) lastFocusedElementRef.current = target;
        else $d3863c46a17e8a28$var$focus(lastFocusedElementRef.current, {
          select: true
        });
      }, handleFocusOut = function(event) {
        if (focusScope.paused || !container1) return;
        if (!container1.contains(event.relatedTarget)) $d3863c46a17e8a28$var$focus(lastFocusedElementRef.current, {
          select: true
        });
      };
      document.addEventListener("focusin", handleFocusIn);
      document.addEventListener("focusout", handleFocusOut);
      return () => {
        document.removeEventListener("focusin", handleFocusIn);
        document.removeEventListener("focusout", handleFocusOut);
      };
    }
  }, [
    trapped,
    container1,
    focusScope.paused
  ]);
  useEffect(() => {
    if (container1) {
      $d3863c46a17e8a28$var$focusScopesStack.add(focusScope);
      const previouslyFocusedElement = document.activeElement;
      const hasFocusedCandidate = container1.contains(previouslyFocusedElement);
      if (!hasFocusedCandidate) {
        const mountEvent = new CustomEvent($d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, $d3863c46a17e8a28$var$EVENT_OPTIONS);
        container1.addEventListener($d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
        container1.dispatchEvent(mountEvent);
        if (!mountEvent.defaultPrevented) {
          $d3863c46a17e8a28$var$focusFirst($d3863c46a17e8a28$var$removeLinks($d3863c46a17e8a28$var$getTabbableCandidates(container1)), {
            select: true
          });
          if (document.activeElement === previouslyFocusedElement) $d3863c46a17e8a28$var$focus(container1);
        }
      }
      return () => {
        container1.removeEventListener($d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
        setTimeout(() => {
          const unmountEvent = new CustomEvent($d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, $d3863c46a17e8a28$var$EVENT_OPTIONS);
          container1.addEventListener($d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
          container1.dispatchEvent(unmountEvent);
          if (!unmountEvent.defaultPrevented) $d3863c46a17e8a28$var$focus(previouslyFocusedElement !== null && previouslyFocusedElement !== void 0 ? previouslyFocusedElement : document.body, {
            select: true
          });
          container1.removeEventListener($d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
          $d3863c46a17e8a28$var$focusScopesStack.remove(focusScope);
        }, 0);
      };
    }
  }, [
    container1,
    onMountAutoFocus,
    onUnmountAutoFocus,
    focusScope
  ]);
  const handleKeyDown = useCallback((event) => {
    if (!loop && !trapped) return;
    if (focusScope.paused) return;
    const isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey;
    const focusedElement = document.activeElement;
    if (isTabKey && focusedElement) {
      const container = event.currentTarget;
      const [first, last2] = $d3863c46a17e8a28$var$getTabbableEdges(container);
      const hasTabbableElementsInside = first && last2;
      if (!hasTabbableElementsInside) {
        if (focusedElement === container) event.preventDefault();
      } else {
        if (!event.shiftKey && focusedElement === last2) {
          event.preventDefault();
          if (loop) $d3863c46a17e8a28$var$focus(first, {
            select: true
          });
        } else if (event.shiftKey && focusedElement === first) {
          event.preventDefault();
          if (loop) $d3863c46a17e8a28$var$focus(last2, {
            select: true
          });
        }
      }
    }
  }, [
    loop,
    trapped,
    focusScope.paused
  ]);
  return /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.div, _extends$z({
    tabIndex: -1
  }, scopeProps, {
    ref: composedRefs,
    onKeyDown: handleKeyDown
  }));
});
function $d3863c46a17e8a28$var$focusFirst(candidates, { select = false } = {}) {
  const previouslyFocusedElement = document.activeElement;
  for (const candidate of candidates) {
    $d3863c46a17e8a28$var$focus(candidate, {
      select
    });
    if (document.activeElement !== previouslyFocusedElement) return;
  }
}
function $d3863c46a17e8a28$var$getTabbableEdges(container) {
  const candidates = $d3863c46a17e8a28$var$getTabbableCandidates(container);
  const first = $d3863c46a17e8a28$var$findVisible(candidates, container);
  const last2 = $d3863c46a17e8a28$var$findVisible(candidates.reverse(), container);
  return [
    first,
    last2
  ];
}
function $d3863c46a17e8a28$var$getTabbableCandidates(container) {
  const nodes = [];
  const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (node) => {
      const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
      if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP;
      return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  while (walker.nextNode()) nodes.push(walker.currentNode);
  return nodes;
}
function $d3863c46a17e8a28$var$findVisible(elements, container) {
  for (const element of elements) {
    if (!$d3863c46a17e8a28$var$isHidden(element, {
      upTo: container
    })) return element;
  }
}
function $d3863c46a17e8a28$var$isHidden(node, { upTo }) {
  if (getComputedStyle(node).visibility === "hidden") return true;
  while (node) {
    if (upTo !== void 0 && node === upTo) return false;
    if (getComputedStyle(node).display === "none") return true;
    node = node.parentElement;
  }
  return false;
}
function $d3863c46a17e8a28$var$isSelectableInput(element) {
  return element instanceof HTMLInputElement && "select" in element;
}
function $d3863c46a17e8a28$var$focus(element, { select = false } = {}) {
  if (element && element.focus) {
    const previouslyFocusedElement = document.activeElement;
    element.focus({
      preventScroll: true
    });
    if (element !== previouslyFocusedElement && $d3863c46a17e8a28$var$isSelectableInput(element) && select) element.select();
  }
}
const $d3863c46a17e8a28$var$focusScopesStack = $d3863c46a17e8a28$var$createFocusScopesStack();
function $d3863c46a17e8a28$var$createFocusScopesStack() {
  let stack = [];
  return {
    add(focusScope) {
      const activeFocusScope = stack[0];
      if (focusScope !== activeFocusScope) activeFocusScope === null || activeFocusScope === void 0 || activeFocusScope.pause();
      stack = $d3863c46a17e8a28$var$arrayRemove(stack, focusScope);
      stack.unshift(focusScope);
    },
    remove(focusScope) {
      var _stack$;
      stack = $d3863c46a17e8a28$var$arrayRemove(stack, focusScope);
      (_stack$ = stack[0]) === null || _stack$ === void 0 || _stack$.resume();
    }
  };
}
function $d3863c46a17e8a28$var$arrayRemove(array2, item) {
  const updatedArray = [
    ...array2
  ];
  const index2 = updatedArray.indexOf(item);
  if (index2 !== -1) updatedArray.splice(index2, 1);
  return updatedArray;
}
function $d3863c46a17e8a28$var$removeLinks(items) {
  return items.filter(
    (item) => item.tagName !== "A"
  );
}
const $f1701beae083dbae$export$602eac185826482c = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  var _globalThis$document;
  const { container = globalThis === null || globalThis === void 0 ? void 0 : (_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.body, ...portalProps } = props;
  return container ? /* @__PURE__ */ ReactDOM__default.createPortal(/* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.div, _extends$z({}, portalProps, {
    ref: forwardedRef
  })), container) : null;
});
const $9f79659886946c16$export$e5c5a5f917a5871c$4 = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) ? useLayoutEffect : () => {
};
function $fe963b355347cc68$export$3e6543de14f8614f$1(initialState, machine) {
  return useReducer((state, event) => {
    const nextState = machine[state][event];
    return nextState !== null && nextState !== void 0 ? nextState : state;
  }, initialState);
}
const $921a889cee6df7e8$export$99c2b779aa4e8b8b$1 = (props) => {
  const { present, children } = props;
  const presence = $921a889cee6df7e8$var$usePresence$1(present);
  const child = typeof children === "function" ? children({
    present: presence.isPresent
  }) : Children.only(children);
  const ref = $6ed0406888f73fc4$export$c7b2cbe3552a0d05$1(presence.ref, child.ref);
  const forceMount = typeof children === "function";
  return forceMount || presence.isPresent ? /* @__PURE__ */ cloneElement(child, {
    ref
  }) : null;
};
$921a889cee6df7e8$export$99c2b779aa4e8b8b$1.displayName = "Presence";
function $921a889cee6df7e8$var$usePresence$1(present) {
  const [node1, setNode] = useState();
  const stylesRef = useRef({});
  const prevPresentRef = useRef(present);
  const prevAnimationNameRef = useRef("none");
  const initialState = present ? "mounted" : "unmounted";
  const [state, send] = $fe963b355347cc68$export$3e6543de14f8614f$1(initialState, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  useEffect(() => {
    const currentAnimationName = $921a889cee6df7e8$var$getAnimationName$1(stylesRef.current);
    prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
  }, [
    state
  ]);
  $9f79659886946c16$export$e5c5a5f917a5871c$4(() => {
    const styles = stylesRef.current;
    const wasPresent = prevPresentRef.current;
    const hasPresentChanged = wasPresent !== present;
    if (hasPresentChanged) {
      const prevAnimationName = prevAnimationNameRef.current;
      const currentAnimationName = $921a889cee6df7e8$var$getAnimationName$1(styles);
      if (present) send("MOUNT");
      else if (currentAnimationName === "none" || (styles === null || styles === void 0 ? void 0 : styles.display) === "none")
        send("UNMOUNT");
      else {
        const isAnimating = prevAnimationName !== currentAnimationName;
        if (wasPresent && isAnimating) send("ANIMATION_OUT");
        else send("UNMOUNT");
      }
      prevPresentRef.current = present;
    }
  }, [
    present,
    send
  ]);
  $9f79659886946c16$export$e5c5a5f917a5871c$4(() => {
    if (node1) {
      const handleAnimationEnd = (event) => {
        const currentAnimationName = $921a889cee6df7e8$var$getAnimationName$1(stylesRef.current);
        const isCurrentAnimation = currentAnimationName.includes(event.animationName);
        if (event.target === node1 && isCurrentAnimation)
          flushSync$1(
            () => send("ANIMATION_END")
          );
      };
      const handleAnimationStart = (event) => {
        if (event.target === node1)
          prevAnimationNameRef.current = $921a889cee6df7e8$var$getAnimationName$1(stylesRef.current);
      };
      node1.addEventListener("animationstart", handleAnimationStart);
      node1.addEventListener("animationcancel", handleAnimationEnd);
      node1.addEventListener("animationend", handleAnimationEnd);
      return () => {
        node1.removeEventListener("animationstart", handleAnimationStart);
        node1.removeEventListener("animationcancel", handleAnimationEnd);
        node1.removeEventListener("animationend", handleAnimationEnd);
      };
    } else
      send("ANIMATION_END");
  }, [
    node1,
    send
  ]);
  return {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(state),
    ref: useCallback((node) => {
      if (node) stylesRef.current = getComputedStyle(node);
      setNode(node);
    }, [])
  };
}
function $921a889cee6df7e8$var$getAnimationName$1(styles) {
  return (styles === null || styles === void 0 ? void 0 : styles.animationName) || "none";
}
let $3db38b7d1fb3fe6a$var$count = 0;
function $3db38b7d1fb3fe6a$export$b7ece24a22aeda8c() {
  useEffect(() => {
    var _edgeGuards$, _edgeGuards$2;
    const edgeGuards = document.querySelectorAll("[data-radix-focus-guard]");
    document.body.insertAdjacentElement("afterbegin", (_edgeGuards$ = edgeGuards[0]) !== null && _edgeGuards$ !== void 0 ? _edgeGuards$ : $3db38b7d1fb3fe6a$var$createFocusGuard());
    document.body.insertAdjacentElement("beforeend", (_edgeGuards$2 = edgeGuards[1]) !== null && _edgeGuards$2 !== void 0 ? _edgeGuards$2 : $3db38b7d1fb3fe6a$var$createFocusGuard());
    $3db38b7d1fb3fe6a$var$count++;
    return () => {
      if ($3db38b7d1fb3fe6a$var$count === 1) document.querySelectorAll("[data-radix-focus-guard]").forEach(
        (node) => node.remove()
      );
      $3db38b7d1fb3fe6a$var$count--;
    };
  }, []);
}
function $3db38b7d1fb3fe6a$var$createFocusGuard() {
  const element = document.createElement("span");
  element.setAttribute("data-radix-focus-guard", "");
  element.tabIndex = 0;
  element.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none";
  return element;
}
var extendStatics = function(d4, b3) {
  extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d5, b4) {
    d5.__proto__ = b4;
  } || function(d5, b4) {
    for (var p2 in b4) if (Object.prototype.hasOwnProperty.call(b4, p2)) d5[p2] = b4[p2];
  };
  return extendStatics(d4, b3);
};
function __extends(d4, b3) {
  if (typeof b3 !== "function" && b3 !== null)
    throw new TypeError("Class extends value " + String(b3) + " is not a constructor or null");
  extendStatics(d4, b3);
  function __() {
    this.constructor = d4;
  }
  d4.prototype = b3 === null ? Object.create(b3) : (__.prototype = b3.prototype, new __());
}
var __assign$1 = function() {
  __assign$1 = Object.assign || function __assign2(t3) {
    for (var s4, i3 = 1, n2 = arguments.length; i3 < n2; i3++) {
      s4 = arguments[i3];
      for (var p2 in s4) if (Object.prototype.hasOwnProperty.call(s4, p2)) t3[p2] = s4[p2];
    }
    return t3;
  };
  return __assign$1.apply(this, arguments);
};
function __rest$1(s4, e3) {
  var t3 = {};
  for (var p2 in s4) if (Object.prototype.hasOwnProperty.call(s4, p2) && e3.indexOf(p2) < 0)
    t3[p2] = s4[p2];
  if (s4 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i3 = 0, p2 = Object.getOwnPropertySymbols(s4); i3 < p2.length; i3++) {
      if (e3.indexOf(p2[i3]) < 0 && Object.prototype.propertyIsEnumerable.call(s4, p2[i3]))
        t3[p2[i3]] = s4[p2[i3]];
    }
  return t3;
}
function __values$1(o2) {
  var s4 = typeof Symbol === "function" && Symbol.iterator, m4 = s4 && o2[s4], i3 = 0;
  if (m4) return m4.call(o2);
  if (o2 && typeof o2.length === "number") return {
    next: function() {
      if (o2 && i3 >= o2.length) o2 = void 0;
      return { value: o2 && o2[i3++], done: !o2 };
    }
  };
  throw new TypeError(s4 ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o2, n2) {
  var m4 = typeof Symbol === "function" && o2[Symbol.iterator];
  if (!m4) return o2;
  var i3 = m4.call(o2), r2, ar = [], e3;
  try {
    while ((n2 === void 0 || n2-- > 0) && !(r2 = i3.next()).done) ar.push(r2.value);
  } catch (error) {
    e3 = { error };
  } finally {
    try {
      if (r2 && !r2.done && (m4 = i3["return"])) m4.call(i3);
    } finally {
      if (e3) throw e3.error;
    }
  }
  return ar;
}
function __spreadArray$1(to, from, pack) {
  if (pack || arguments.length === 2) for (var i3 = 0, l2 = from.length, ar; i3 < l2; i3++) {
    if (ar || !(i3 in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i3);
      ar[i3] = from[i3];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}
typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
  var e3 = new Error(message);
  return e3.name = "SuppressedError", e3.error = error, e3.suppressed = suppressed, e3;
};
var zeroRightClassName = "right-scroll-bar-position";
var fullWidthClassName = "width-before-scroll-bar";
var noScrollbarsClassName = "with-scroll-bars-hidden";
var removedBarSizeVariable = "--removed-body-scroll-bar-size";
function assignRef(ref, value) {
  if (typeof ref === "function") {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
  return ref;
}
function useCallbackRef(initialValue, callback) {
  var ref = useState(function() {
    return {
      // value
      value: initialValue,
      // last callback
      callback,
      // "memoized" public interface
      facade: {
        get current() {
          return ref.value;
        },
        set current(value) {
          var last2 = ref.value;
          if (last2 !== value) {
            ref.value = value;
            ref.callback(value, last2);
          }
        }
      }
    };
  })[0];
  ref.callback = callback;
  return ref.facade;
}
var useIsomorphicLayoutEffect$4 = typeof window !== "undefined" ? React.useLayoutEffect : React.useEffect;
var currentValues = /* @__PURE__ */ new WeakMap();
function useMergeRefs(refs, defaultValue2) {
  var callbackRef = useCallbackRef(null, function(newValue) {
    return refs.forEach(function(ref) {
      return assignRef(ref, newValue);
    });
  });
  useIsomorphicLayoutEffect$4(function() {
    var oldValue = currentValues.get(callbackRef);
    if (oldValue) {
      var prevRefs_1 = new Set(oldValue);
      var nextRefs_1 = new Set(refs);
      var current_1 = callbackRef.current;
      prevRefs_1.forEach(function(ref) {
        if (!nextRefs_1.has(ref)) {
          assignRef(ref, null);
        }
      });
      nextRefs_1.forEach(function(ref) {
        if (!prevRefs_1.has(ref)) {
          assignRef(ref, current_1);
        }
      });
    }
    currentValues.set(callbackRef, refs);
  }, [refs]);
  return callbackRef;
}
function ItoI(a4) {
  return a4;
}
function innerCreateMedium(defaults2, middleware) {
  if (middleware === void 0) {
    middleware = ItoI;
  }
  var buffer = [];
  var assigned = false;
  var medium = {
    read: function() {
      if (assigned) {
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      }
      if (buffer.length) {
        return buffer[buffer.length - 1];
      }
      return defaults2;
    },
    useMedium: function(data) {
      var item = middleware(data, assigned);
      buffer.push(item);
      return function() {
        buffer = buffer.filter(function(x3) {
          return x3 !== item;
        });
      };
    },
    assignSyncMedium: function(cb2) {
      assigned = true;
      while (buffer.length) {
        var cbs = buffer;
        buffer = [];
        cbs.forEach(cb2);
      }
      buffer = {
        push: function(x3) {
          return cb2(x3);
        },
        filter: function() {
          return buffer;
        }
      };
    },
    assignMedium: function(cb2) {
      assigned = true;
      var pendingQueue = [];
      if (buffer.length) {
        var cbs = buffer;
        buffer = [];
        cbs.forEach(cb2);
        pendingQueue = buffer;
      }
      var executeQueue = function() {
        var cbs2 = pendingQueue;
        pendingQueue = [];
        cbs2.forEach(cb2);
      };
      var cycle = function() {
        return Promise.resolve().then(executeQueue);
      };
      cycle();
      buffer = {
        push: function(x3) {
          pendingQueue.push(x3);
          cycle();
        },
        filter: function(filter2) {
          pendingQueue = pendingQueue.filter(filter2);
          return buffer;
        }
      };
    }
  };
  return medium;
}
function createSidecarMedium(options) {
  if (options === void 0) {
    options = {};
  }
  var medium = innerCreateMedium(null);
  medium.options = __assign$1({ async: true, ssr: false }, options);
  return medium;
}
var SideCar$1 = function(_a) {
  var sideCar = _a.sideCar, rest = __rest$1(_a, ["sideCar"]);
  if (!sideCar) {
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  }
  var Target = sideCar.read();
  if (!Target) {
    throw new Error("Sidecar medium not found");
  }
  return React.createElement(Target, __assign$1({}, rest));
};
SideCar$1.isSideCarExport = true;
function exportSidecar(medium, exported) {
  medium.useMedium(exported);
  return SideCar$1;
}
var effectCar = createSidecarMedium();
var nothing = function() {
  return;
};
var RemoveScroll = React.forwardRef(function(props, parentRef) {
  var ref = React.useRef(null);
  var _a = React.useState({
    onScrollCapture: nothing,
    onWheelCapture: nothing,
    onTouchMoveCapture: nothing
  }), callbacks = _a[0], setCallbacks = _a[1];
  var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container2 = _b === void 0 ? "div" : _b, rest = __rest$1(props, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]);
  var SideCar2 = sideCar;
  var containerRef = useMergeRefs([ref, parentRef]);
  var containerProps = __assign$1(__assign$1({}, rest), callbacks);
  return React.createElement(
    React.Fragment,
    null,
    enabled && React.createElement(SideCar2, { sideCar: effectCar, removeScrollBar, shards, noIsolation, inert, setCallbacks, allowPinchZoom: !!allowPinchZoom, lockRef: ref }),
    forwardProps ? React.cloneElement(React.Children.only(children), __assign$1(__assign$1({}, containerProps), { ref: containerRef })) : React.createElement(Container2, __assign$1({}, containerProps, { className, ref: containerRef }), children)
  );
});
RemoveScroll.defaultProps = {
  enabled: true,
  removeScrollBar: true,
  inert: false
};
RemoveScroll.classNames = {
  fullWidth: fullWidthClassName,
  zeroRight: zeroRightClassName
};
var getNonce = function() {
  if (typeof __webpack_nonce__ !== "undefined") {
    return __webpack_nonce__;
  }
  return void 0;
};
function makeStyleTag() {
  if (!document)
    return null;
  var tag = document.createElement("style");
  tag.type = "text/css";
  var nonce = getNonce();
  if (nonce) {
    tag.setAttribute("nonce", nonce);
  }
  return tag;
}
function injectStyles(tag, css) {
  if (tag.styleSheet) {
    tag.styleSheet.cssText = css;
  } else {
    tag.appendChild(document.createTextNode(css));
  }
}
function insertStyleTag(tag) {
  var head = document.head || document.getElementsByTagName("head")[0];
  head.appendChild(tag);
}
var stylesheetSingleton = function() {
  var counter2 = 0;
  var stylesheet = null;
  return {
    add: function(style) {
      if (counter2 == 0) {
        if (stylesheet = makeStyleTag()) {
          injectStyles(stylesheet, style);
          insertStyleTag(stylesheet);
        }
      }
      counter2++;
    },
    remove: function() {
      counter2--;
      if (!counter2 && stylesheet) {
        stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
        stylesheet = null;
      }
    }
  };
};
var styleHookSingleton = function() {
  var sheet = stylesheetSingleton();
  return function(styles, isDynamic) {
    React.useEffect(function() {
      sheet.add(styles);
      return function() {
        sheet.remove();
      };
    }, [styles && isDynamic]);
  };
};
var styleSingleton = function() {
  var useStyle2 = styleHookSingleton();
  var Sheet = function(_a) {
    var styles = _a.styles, dynamic = _a.dynamic;
    useStyle2(styles, dynamic);
    return null;
  };
  return Sheet;
};
var zeroGap = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
};
var parse$2 = function(x3) {
  return parseInt(x3 || "", 10) || 0;
};
var getOffset$1 = function(gapMode) {
  var cs = window.getComputedStyle(document.body);
  var left = cs[gapMode === "padding" ? "paddingLeft" : "marginLeft"];
  var top = cs[gapMode === "padding" ? "paddingTop" : "marginTop"];
  var right = cs[gapMode === "padding" ? "paddingRight" : "marginRight"];
  return [parse$2(left), parse$2(top), parse$2(right)];
};
var getGapWidth = function(gapMode) {
  if (gapMode === void 0) {
    gapMode = "margin";
  }
  if (typeof window === "undefined") {
    return zeroGap;
  }
  var offsets = getOffset$1(gapMode);
  var documentWidth = document.documentElement.clientWidth;
  var windowWidth = window.innerWidth;
  return {
    left: offsets[0],
    top: offsets[1],
    right: offsets[2],
    gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
  };
};
var Style = styleSingleton();
var lockAttribute = "data-scroll-locked";
var getStyles$2 = function(_a, allowRelative, gapMode, important) {
  var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
  if (gapMode === void 0) {
    gapMode = "margin";
  }
  return "\n  .".concat(noScrollbarsClassName, " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body[").concat(lockAttribute, "] {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
    allowRelative && "position: relative ".concat(important, ";"),
    gapMode === "margin" && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
    gapMode === "padding" && "padding-right: ".concat(gap, "px ").concat(important, ";")
  ].filter(Boolean).join(""), "\n  }\n  \n  .").concat(zeroRightClassName, " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat(fullWidthClassName, " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat(zeroRightClassName, " .").concat(zeroRightClassName, " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat(fullWidthClassName, " .").concat(fullWidthClassName, " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body[").concat(lockAttribute, "] {\n    ").concat(removedBarSizeVariable, ": ").concat(gap, "px;\n  }\n");
};
var getCurrentUseCounter = function() {
  var counter2 = parseInt(document.body.getAttribute(lockAttribute) || "0", 10);
  return isFinite(counter2) ? counter2 : 0;
};
var useLockAttribute = function() {
  React.useEffect(function() {
    document.body.setAttribute(lockAttribute, (getCurrentUseCounter() + 1).toString());
    return function() {
      var newCounter = getCurrentUseCounter() - 1;
      if (newCounter <= 0) {
        document.body.removeAttribute(lockAttribute);
      } else {
        document.body.setAttribute(lockAttribute, newCounter.toString());
      }
    };
  }, []);
};
var RemoveScrollBar = function(_a) {
  var noRelative = _a.noRelative, noImportant = _a.noImportant, _b = _a.gapMode, gapMode = _b === void 0 ? "margin" : _b;
  useLockAttribute();
  var gap = React.useMemo(function() {
    return getGapWidth(gapMode);
  }, [gapMode]);
  return React.createElement(Style, { styles: getStyles$2(gap, !noRelative, gapMode, !noImportant ? "!important" : "") });
};
var passiveSupported$1 = false;
if (typeof window !== "undefined") {
  try {
    var options = Object.defineProperty({}, "passive", {
      get: function() {
        passiveSupported$1 = true;
        return true;
      }
    });
    window.addEventListener("test", options, options);
    window.removeEventListener("test", options, options);
  } catch (err) {
    passiveSupported$1 = false;
  }
}
var nonPassive = passiveSupported$1 ? { passive: false } : false;
var alwaysContainsScroll = function(node) {
  return node.tagName === "TEXTAREA";
};
var elementCanBeScrolled = function(node, overflow) {
  var styles = window.getComputedStyle(node);
  return (
    // not-not-scrollable
    styles[overflow] !== "hidden" && // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !alwaysContainsScroll(node) && styles[overflow] === "visible")
  );
};
var elementCouldBeVScrolled = function(node) {
  return elementCanBeScrolled(node, "overflowY");
};
var elementCouldBeHScrolled = function(node) {
  return elementCanBeScrolled(node, "overflowX");
};
var locationCouldBeScrolled = function(axis, node) {
  var current = node;
  do {
    if (typeof ShadowRoot !== "undefined" && current instanceof ShadowRoot) {
      current = current.host;
    }
    var isScrollable2 = elementCouldBeScrolled(axis, current);
    if (isScrollable2) {
      var _a = getScrollVariables(axis, current), s4 = _a[1], d4 = _a[2];
      if (s4 > d4) {
        return true;
      }
    }
    current = current.parentNode;
  } while (current && current !== document.body);
  return false;
};
var getVScrollVariables = function(_a) {
  var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
  return [
    scrollTop,
    scrollHeight,
    clientHeight
  ];
};
var getHScrollVariables = function(_a) {
  var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
  return [
    scrollLeft,
    scrollWidth,
    clientWidth
  ];
};
var elementCouldBeScrolled = function(axis, node) {
  return axis === "v" ? elementCouldBeVScrolled(node) : elementCouldBeHScrolled(node);
};
var getScrollVariables = function(axis, node) {
  return axis === "v" ? getVScrollVariables(node) : getHScrollVariables(node);
};
var getDirectionFactor = function(axis, direction) {
  return axis === "h" && direction === "rtl" ? -1 : 1;
};
var handleScroll = function(axis, endTarget, event, sourceDelta, noOverscroll) {
  var directionFactor = getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
  var delta = directionFactor * sourceDelta;
  var target = event.target;
  var targetInLock = endTarget.contains(target);
  var shouldCancelScroll = false;
  var isDeltaPositive = delta > 0;
  var availableScroll = 0;
  var availableScrollTop = 0;
  do {
    var _a = getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
    var elementScroll3 = scroll_1 - capacity - directionFactor * position;
    if (position || elementScroll3) {
      if (elementCouldBeScrolled(axis, target)) {
        availableScroll += elementScroll3;
        availableScrollTop += position;
      }
    }
    target = target.parentNode;
  } while (
    // portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target)
  );
  if (isDeltaPositive && (availableScroll === 0 || false)) {
    shouldCancelScroll = true;
  } else if (!isDeltaPositive && (availableScrollTop === 0 || false)) {
    shouldCancelScroll = true;
  }
  return shouldCancelScroll;
};
var getTouchXY = function(event) {
  return "changedTouches" in event ? [event.changedTouches[0].clientX, event.changedTouches[0].clientY] : [0, 0];
};
var getDeltaXY = function(event) {
  return [event.deltaX, event.deltaY];
};
var extractRef = function(ref) {
  return ref && "current" in ref ? ref.current : ref;
};
var deltaCompare = function(x3, y4) {
  return x3[0] === y4[0] && x3[1] === y4[1];
};
var generateStyle = function(id2) {
  return "\n  .block-interactivity-".concat(id2, " {pointer-events: none;}\n  .allow-interactivity-").concat(id2, " {pointer-events: all;}\n");
};
var idCounter$1 = 0;
var lockStack = [];
function RemoveScrollSideCar(props) {
  var shouldPreventQueue = React.useRef([]);
  var touchStartRef = React.useRef([0, 0]);
  var activeAxis = React.useRef();
  var id2 = React.useState(idCounter$1++)[0];
  var Style2 = React.useState(function() {
    return styleSingleton();
  })[0];
  var lastProps = React.useRef(props);
  React.useEffect(function() {
    lastProps.current = props;
  }, [props]);
  React.useEffect(function() {
    if (props.inert) {
      document.body.classList.add("block-interactivity-".concat(id2));
      var allow_1 = __spreadArray$1([props.lockRef.current], (props.shards || []).map(extractRef), true).filter(Boolean);
      allow_1.forEach(function(el) {
        return el.classList.add("allow-interactivity-".concat(id2));
      });
      return function() {
        document.body.classList.remove("block-interactivity-".concat(id2));
        allow_1.forEach(function(el) {
          return el.classList.remove("allow-interactivity-".concat(id2));
        });
      };
    }
    return;
  }, [props.inert, props.lockRef.current, props.shards]);
  var shouldCancelEvent = React.useCallback(function(event, parent) {
    if ("touches" in event && event.touches.length === 2) {
      return !lastProps.current.allowPinchZoom;
    }
    var touch = getTouchXY(event);
    var touchStart = touchStartRef.current;
    var deltaX = "deltaX" in event ? event.deltaX : touchStart[0] - touch[0];
    var deltaY = "deltaY" in event ? event.deltaY : touchStart[1] - touch[1];
    var currentAxis;
    var target = event.target;
    var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? "h" : "v";
    if ("touches" in event && moveDirection === "h" && target.type === "range") {
      return false;
    }
    var canBeScrolledInMainDirection = locationCouldBeScrolled(moveDirection, target);
    if (!canBeScrolledInMainDirection) {
      return true;
    }
    if (canBeScrolledInMainDirection) {
      currentAxis = moveDirection;
    } else {
      currentAxis = moveDirection === "v" ? "h" : "v";
      canBeScrolledInMainDirection = locationCouldBeScrolled(moveDirection, target);
    }
    if (!canBeScrolledInMainDirection) {
      return false;
    }
    if (!activeAxis.current && "changedTouches" in event && (deltaX || deltaY)) {
      activeAxis.current = currentAxis;
    }
    if (!currentAxis) {
      return true;
    }
    var cancelingAxis = activeAxis.current || currentAxis;
    return handleScroll(cancelingAxis, parent, event, cancelingAxis === "h" ? deltaX : deltaY);
  }, []);
  var shouldPrevent = React.useCallback(function(_event) {
    var event = _event;
    if (!lockStack.length || lockStack[lockStack.length - 1] !== Style2) {
      return;
    }
    var delta = "deltaY" in event ? getDeltaXY(event) : getTouchXY(event);
    var sourceEvent = shouldPreventQueue.current.filter(function(e3) {
      return e3.name === event.type && e3.target === event.target && deltaCompare(e3.delta, delta);
    })[0];
    if (sourceEvent && sourceEvent.should) {
      if (event.cancelable) {
        event.preventDefault();
      }
      return;
    }
    if (!sourceEvent) {
      var shardNodes = (lastProps.current.shards || []).map(extractRef).filter(Boolean).filter(function(node) {
        return node.contains(event.target);
      });
      var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
      if (shouldStop) {
        if (event.cancelable) {
          event.preventDefault();
        }
      }
    }
  }, []);
  var shouldCancel = React.useCallback(function(name, delta, target, should) {
    var event = { name, delta, target, should };
    shouldPreventQueue.current.push(event);
    setTimeout(function() {
      shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e3) {
        return e3 !== event;
      });
    }, 1);
  }, []);
  var scrollTouchStart = React.useCallback(function(event) {
    touchStartRef.current = getTouchXY(event);
    activeAxis.current = void 0;
  }, []);
  var scrollWheel = React.useCallback(function(event) {
    shouldCancel(event.type, getDeltaXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
  }, []);
  var scrollTouchMove = React.useCallback(function(event) {
    shouldCancel(event.type, getTouchXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
  }, []);
  React.useEffect(function() {
    lockStack.push(Style2);
    props.setCallbacks({
      onScrollCapture: scrollWheel,
      onWheelCapture: scrollWheel,
      onTouchMoveCapture: scrollTouchMove
    });
    document.addEventListener("wheel", shouldPrevent, nonPassive);
    document.addEventListener("touchmove", shouldPrevent, nonPassive);
    document.addEventListener("touchstart", scrollTouchStart, nonPassive);
    return function() {
      lockStack = lockStack.filter(function(inst) {
        return inst !== Style2;
      });
      document.removeEventListener("wheel", shouldPrevent, nonPassive);
      document.removeEventListener("touchmove", shouldPrevent, nonPassive);
      document.removeEventListener("touchstart", scrollTouchStart, nonPassive);
    };
  }, []);
  var removeScrollBar = props.removeScrollBar, inert = props.inert;
  return React.createElement(
    React.Fragment,
    null,
    inert ? React.createElement(Style2, { styles: generateStyle(id2) }) : null,
    removeScrollBar ? React.createElement(RemoveScrollBar, { gapMode: "margin" }) : null
  );
}
const SideCar = exportSidecar(effectCar, RemoveScrollSideCar);
var ReactRemoveScroll = React.forwardRef(function(props, ref) {
  return React.createElement(RemoveScroll, __assign$1({}, props, { ref, sideCar: SideCar }));
});
ReactRemoveScroll.classNames = RemoveScroll.classNames;
var getDefaultParent = function(originalTarget) {
  if (typeof document === "undefined") {
    return null;
  }
  var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
  return sampleTarget.ownerDocument.body;
};
var counterMap = /* @__PURE__ */ new WeakMap();
var uncontrolledNodes = /* @__PURE__ */ new WeakMap();
var markerMap = {};
var lockCount = 0;
var unwrapHost = function(node) {
  return node && (node.host || unwrapHost(node.parentNode));
};
var correctTargets = function(parent, targets) {
  return targets.map(function(target) {
    if (parent.contains(target)) {
      return target;
    }
    var correctedTarget = unwrapHost(target);
    if (correctedTarget && parent.contains(correctedTarget)) {
      return correctedTarget;
    }
    console.error("aria-hidden", target, "in not contained inside", parent, ". Doing nothing");
    return null;
  }).filter(function(x3) {
    return Boolean(x3);
  });
};
var applyAttributeToOthers = function(originalTarget, parentNode, markerName, controlAttribute) {
  var targets = correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [originalTarget]);
  if (!markerMap[markerName]) {
    markerMap[markerName] = /* @__PURE__ */ new WeakMap();
  }
  var markerCounter = markerMap[markerName];
  var hiddenNodes = [];
  var elementsToKeep = /* @__PURE__ */ new Set();
  var elementsToStop = new Set(targets);
  var keep = function(el) {
    if (!el || elementsToKeep.has(el)) {
      return;
    }
    elementsToKeep.add(el);
    keep(el.parentNode);
  };
  targets.forEach(keep);
  var deep = function(parent) {
    if (!parent || elementsToStop.has(parent)) {
      return;
    }
    Array.prototype.forEach.call(parent.children, function(node) {
      if (elementsToKeep.has(node)) {
        deep(node);
      } else {
        try {
          var attr = node.getAttribute(controlAttribute);
          var alreadyHidden = attr !== null && attr !== "false";
          var counterValue = (counterMap.get(node) || 0) + 1;
          var markerValue = (markerCounter.get(node) || 0) + 1;
          counterMap.set(node, counterValue);
          markerCounter.set(node, markerValue);
          hiddenNodes.push(node);
          if (counterValue === 1 && alreadyHidden) {
            uncontrolledNodes.set(node, true);
          }
          if (markerValue === 1) {
            node.setAttribute(markerName, "true");
          }
          if (!alreadyHidden) {
            node.setAttribute(controlAttribute, "true");
          }
        } catch (e3) {
          console.error("aria-hidden: cannot operate on ", node, e3);
        }
      }
    });
  };
  deep(parentNode);
  elementsToKeep.clear();
  lockCount++;
  return function() {
    hiddenNodes.forEach(function(node) {
      var counterValue = counterMap.get(node) - 1;
      var markerValue = markerCounter.get(node) - 1;
      counterMap.set(node, counterValue);
      markerCounter.set(node, markerValue);
      if (!counterValue) {
        if (!uncontrolledNodes.has(node)) {
          node.removeAttribute(controlAttribute);
        }
        uncontrolledNodes.delete(node);
      }
      if (!markerValue) {
        node.removeAttribute(markerName);
      }
    });
    lockCount--;
    if (!lockCount) {
      counterMap = /* @__PURE__ */ new WeakMap();
      counterMap = /* @__PURE__ */ new WeakMap();
      uncontrolledNodes = /* @__PURE__ */ new WeakMap();
      markerMap = {};
    }
  };
};
var hideOthers = function(originalTarget, parentNode, markerName) {
  if (markerName === void 0) {
    markerName = "data-aria-hidden";
  }
  var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [originalTarget]);
  var activeParentNode = getDefaultParent(originalTarget);
  if (!activeParentNode) {
    return function() {
      return null;
    };
  }
  targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll("[aria-live]")));
  return applyAttributeToOthers(targets, activeParentNode, markerName, "aria-hidden");
};
const $5d3850c4d0b4e6c7$var$DIALOG_NAME = "Dialog";
const [$5d3850c4d0b4e6c7$var$createDialogContext, $5d3850c4d0b4e6c7$export$cc702773b8ea3e41] = $c512c27ab02ef895$export$50c7b4e9d9f19c1$1($5d3850c4d0b4e6c7$var$DIALOG_NAME);
const [$5d3850c4d0b4e6c7$var$DialogProvider, $5d3850c4d0b4e6c7$var$useDialogContext] = $5d3850c4d0b4e6c7$var$createDialogContext($5d3850c4d0b4e6c7$var$DIALOG_NAME);
const $5d3850c4d0b4e6c7$export$3ddf2d174ce01153 = (props) => {
  const { __scopeDialog, children, open: openProp, defaultOpen, onOpenChange, modal = true } = props;
  const triggerRef = useRef(null);
  const contentRef = useRef(null);
  const [open = false, setOpen] = $71cd76cc60e0454e$export$6f32135080cb4c3$1({
    prop: openProp,
    defaultProp: defaultOpen,
    onChange: onOpenChange
  });
  return /* @__PURE__ */ createElement($5d3850c4d0b4e6c7$var$DialogProvider, {
    scope: __scopeDialog,
    triggerRef,
    contentRef,
    contentId: $1746a345f3d73bb7$export$f680877a34711e37$1(),
    titleId: $1746a345f3d73bb7$export$f680877a34711e37$1(),
    descriptionId: $1746a345f3d73bb7$export$f680877a34711e37$1(),
    open,
    onOpenChange: setOpen,
    onOpenToggle: useCallback(
      () => setOpen(
        (prevOpen) => !prevOpen
      ),
      [
        setOpen
      ]
    ),
    modal
  }, children);
};
const $5d3850c4d0b4e6c7$var$TRIGGER_NAME = "DialogTrigger";
const $5d3850c4d0b4e6c7$export$2e1e1122cf0cba88 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeDialog, ...triggerProps } = props;
  const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$TRIGGER_NAME, __scopeDialog);
  const composedTriggerRef = $6ed0406888f73fc4$export$c7b2cbe3552a0d05$1(forwardedRef, context.triggerRef);
  return /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.button, _extends$z({
    type: "button",
    "aria-haspopup": "dialog",
    "aria-expanded": context.open,
    "aria-controls": context.contentId,
    "data-state": $5d3850c4d0b4e6c7$var$getState(context.open)
  }, triggerProps, {
    ref: composedTriggerRef,
    onClick: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(props.onClick, context.onOpenToggle)
  }));
});
const $5d3850c4d0b4e6c7$var$PORTAL_NAME = "DialogPortal";
const [$5d3850c4d0b4e6c7$var$PortalProvider, $5d3850c4d0b4e6c7$var$usePortalContext] = $5d3850c4d0b4e6c7$var$createDialogContext($5d3850c4d0b4e6c7$var$PORTAL_NAME, {
  forceMount: void 0
});
const $5d3850c4d0b4e6c7$export$dad7c95542bacce0 = (props) => {
  const { __scopeDialog, forceMount, children, container } = props;
  const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$PORTAL_NAME, __scopeDialog);
  return /* @__PURE__ */ createElement($5d3850c4d0b4e6c7$var$PortalProvider, {
    scope: __scopeDialog,
    forceMount
  }, Children.map(
    children,
    (child) => /* @__PURE__ */ createElement($921a889cee6df7e8$export$99c2b779aa4e8b8b$1, {
      present: forceMount || context.open
    }, /* @__PURE__ */ createElement($f1701beae083dbae$export$602eac185826482c, {
      asChild: true,
      container
    }, child))
  ));
};
const $5d3850c4d0b4e6c7$var$OVERLAY_NAME = "DialogOverlay";
const $5d3850c4d0b4e6c7$export$bd1d06c79be19e17 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const portalContext = $5d3850c4d0b4e6c7$var$usePortalContext($5d3850c4d0b4e6c7$var$OVERLAY_NAME, props.__scopeDialog);
  const { forceMount = portalContext.forceMount, ...overlayProps } = props;
  const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$OVERLAY_NAME, props.__scopeDialog);
  return context.modal ? /* @__PURE__ */ createElement($921a889cee6df7e8$export$99c2b779aa4e8b8b$1, {
    present: forceMount || context.open
  }, /* @__PURE__ */ createElement($5d3850c4d0b4e6c7$var$DialogOverlayImpl, _extends$z({}, overlayProps, {
    ref: forwardedRef
  }))) : null;
});
const $5d3850c4d0b4e6c7$var$DialogOverlayImpl = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeDialog, ...overlayProps } = props;
  const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$OVERLAY_NAME, __scopeDialog);
  return (
    // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
    // ie. when `Overlay` and `Content` are siblings
    /* @__PURE__ */ createElement(ReactRemoveScroll, {
      as: $5e63c961fc1ce211$export$8c6ed5c666ac1360$1,
      allowPinchZoom: true,
      shards: [
        context.contentRef
      ]
    }, /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.div, _extends$z({
      "data-state": $5d3850c4d0b4e6c7$var$getState(context.open)
    }, overlayProps, {
      ref: forwardedRef,
      style: {
        pointerEvents: "auto",
        ...overlayProps.style
      }
    })))
  );
});
const $5d3850c4d0b4e6c7$var$CONTENT_NAME = "DialogContent";
const $5d3850c4d0b4e6c7$export$b6d9565de1e068cf = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const portalContext = $5d3850c4d0b4e6c7$var$usePortalContext($5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
  const { forceMount = portalContext.forceMount, ...contentProps } = props;
  const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
  return /* @__PURE__ */ createElement($921a889cee6df7e8$export$99c2b779aa4e8b8b$1, {
    present: forceMount || context.open
  }, context.modal ? /* @__PURE__ */ createElement($5d3850c4d0b4e6c7$var$DialogContentModal, _extends$z({}, contentProps, {
    ref: forwardedRef
  })) : /* @__PURE__ */ createElement($5d3850c4d0b4e6c7$var$DialogContentNonModal, _extends$z({}, contentProps, {
    ref: forwardedRef
  })));
});
/* @__PURE__ */ Object.assign($5d3850c4d0b4e6c7$export$b6d9565de1e068cf, {
  displayName: $5d3850c4d0b4e6c7$var$CONTENT_NAME
});
const $5d3850c4d0b4e6c7$var$DialogContentModal = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
  const contentRef = useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05$1(forwardedRef, context.contentRef, contentRef);
  useEffect(() => {
    const content = contentRef.current;
    if (content) return hideOthers(content);
  }, []);
  return /* @__PURE__ */ createElement($5d3850c4d0b4e6c7$var$DialogContentImpl, _extends$z({}, props, {
    ref: composedRefs,
    trapFocus: context.open,
    disableOutsidePointerEvents: true,
    onCloseAutoFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(props.onCloseAutoFocus, (event) => {
      var _context$triggerRef$c;
      event.preventDefault();
      (_context$triggerRef$c = context.triggerRef.current) === null || _context$triggerRef$c === void 0 || _context$triggerRef$c.focus();
    }),
    onPointerDownOutside: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(props.onPointerDownOutside, (event) => {
      const originalEvent = event.detail.originalEvent;
      const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
      const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
      if (isRightClick) event.preventDefault();
    }),
    onFocusOutside: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(
      props.onFocusOutside,
      (event) => event.preventDefault()
    )
  }));
});
const $5d3850c4d0b4e6c7$var$DialogContentNonModal = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
  const hasInteractedOutsideRef = useRef(false);
  return /* @__PURE__ */ createElement($5d3850c4d0b4e6c7$var$DialogContentImpl, _extends$z({}, props, {
    ref: forwardedRef,
    trapFocus: false,
    disableOutsidePointerEvents: false,
    onCloseAutoFocus: (event) => {
      var _props$onCloseAutoFoc;
      (_props$onCloseAutoFoc = props.onCloseAutoFocus) === null || _props$onCloseAutoFoc === void 0 || _props$onCloseAutoFoc.call(props, event);
      if (!event.defaultPrevented) {
        var _context$triggerRef$c2;
        if (!hasInteractedOutsideRef.current) (_context$triggerRef$c2 = context.triggerRef.current) === null || _context$triggerRef$c2 === void 0 || _context$triggerRef$c2.focus();
        event.preventDefault();
      }
      hasInteractedOutsideRef.current = false;
    },
    onInteractOutside: (event) => {
      var _props$onInteractOuts, _context$triggerRef$c3;
      (_props$onInteractOuts = props.onInteractOutside) === null || _props$onInteractOuts === void 0 || _props$onInteractOuts.call(props, event);
      if (!event.defaultPrevented) hasInteractedOutsideRef.current = true;
      const target = event.target;
      const targetIsTrigger = (_context$triggerRef$c3 = context.triggerRef.current) === null || _context$triggerRef$c3 === void 0 ? void 0 : _context$triggerRef$c3.contains(target);
      if (targetIsTrigger) event.preventDefault();
    }
  }));
});
const $5d3850c4d0b4e6c7$var$DialogContentImpl = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeDialog, trapFocus, onOpenAutoFocus, onCloseAutoFocus, ...contentProps } = props;
  const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$CONTENT_NAME, __scopeDialog);
  const contentRef = useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05$1(forwardedRef, contentRef);
  $3db38b7d1fb3fe6a$export$b7ece24a22aeda8c();
  return /* @__PURE__ */ createElement(Fragment, null, /* @__PURE__ */ createElement($d3863c46a17e8a28$export$20e40289641fbbb6, {
    asChild: true,
    loop: true,
    trapped: trapFocus,
    onMountAutoFocus: onOpenAutoFocus,
    onUnmountAutoFocus: onCloseAutoFocus
  }, /* @__PURE__ */ createElement($5cb92bef7577960e$export$177fb62ff3ec1f22, _extends$z({
    role: "dialog",
    id: context.contentId,
    "aria-describedby": context.descriptionId,
    "aria-labelledby": context.titleId,
    "data-state": $5d3850c4d0b4e6c7$var$getState(context.open)
  }, contentProps, {
    ref: composedRefs,
    onDismiss: () => context.onOpenChange(false)
  }))), false);
});
const $5d3850c4d0b4e6c7$var$TITLE_NAME = "DialogTitle";
const $5d3850c4d0b4e6c7$export$16f7638e4a34b909 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeDialog, ...titleProps } = props;
  const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$TITLE_NAME, __scopeDialog);
  return /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.h2, _extends$z({
    id: context.titleId
  }, titleProps, {
    ref: forwardedRef
  }));
});
/* @__PURE__ */ Object.assign($5d3850c4d0b4e6c7$export$16f7638e4a34b909, {
  displayName: $5d3850c4d0b4e6c7$var$TITLE_NAME
});
const $5d3850c4d0b4e6c7$var$DESCRIPTION_NAME = "DialogDescription";
const $5d3850c4d0b4e6c7$export$94e94c2ec2c954d5 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeDialog, ...descriptionProps } = props;
  const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$DESCRIPTION_NAME, __scopeDialog);
  return /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.p, _extends$z({
    id: context.descriptionId
  }, descriptionProps, {
    ref: forwardedRef
  }));
});
/* @__PURE__ */ Object.assign($5d3850c4d0b4e6c7$export$94e94c2ec2c954d5, {
  displayName: $5d3850c4d0b4e6c7$var$DESCRIPTION_NAME
});
const $5d3850c4d0b4e6c7$var$CLOSE_NAME = "DialogClose";
const $5d3850c4d0b4e6c7$export$fba2fb7cd781b7ac = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeDialog, ...closeProps } = props;
  const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$CLOSE_NAME, __scopeDialog);
  return /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.button, _extends$z({
    type: "button"
  }, closeProps, {
    ref: forwardedRef,
    onClick: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(
      props.onClick,
      () => context.onOpenChange(false)
    )
  }));
});
/* @__PURE__ */ Object.assign($5d3850c4d0b4e6c7$export$fba2fb7cd781b7ac, {
  displayName: $5d3850c4d0b4e6c7$var$CLOSE_NAME
});
function $5d3850c4d0b4e6c7$var$getState(open) {
  return open ? "open" : "closed";
}
const $5d3850c4d0b4e6c7$var$TITLE_WARNING_NAME = "DialogTitleWarning";
const [$5d3850c4d0b4e6c7$export$69b62a49393917d6, $5d3850c4d0b4e6c7$var$useWarningContext] = $c512c27ab02ef895$export$fd42f52fd3ae1109($5d3850c4d0b4e6c7$var$TITLE_WARNING_NAME, {
  contentName: $5d3850c4d0b4e6c7$var$CONTENT_NAME,
  titleName: $5d3850c4d0b4e6c7$var$TITLE_NAME,
  docsSlug: "dialog"
});
const $5d3850c4d0b4e6c7$export$be92b6f5f03c0fe9 = $5d3850c4d0b4e6c7$export$3ddf2d174ce01153;
const $5d3850c4d0b4e6c7$export$41fb9f06171c75f4 = $5d3850c4d0b4e6c7$export$2e1e1122cf0cba88;
const $5d3850c4d0b4e6c7$export$602eac185826482c = $5d3850c4d0b4e6c7$export$dad7c95542bacce0;
const $5d3850c4d0b4e6c7$export$c6fdb837b070b4ff = $5d3850c4d0b4e6c7$export$bd1d06c79be19e17;
const $5d3850c4d0b4e6c7$export$7c6e2c02157bb7d2 = $5d3850c4d0b4e6c7$export$b6d9565de1e068cf;
const $5d3850c4d0b4e6c7$export$f99233281efd08a0 = $5d3850c4d0b4e6c7$export$16f7638e4a34b909;
const $5d3850c4d0b4e6c7$export$f39c2d165cd861fe = $5d3850c4d0b4e6c7$export$fba2fb7cd781b7ac;
const $905f4ae918aab1aa$var$ROOT_NAME = "AlertDialog";
const [$905f4ae918aab1aa$var$createAlertDialogContext, $905f4ae918aab1aa$export$b8891880751c2c5b] = $c512c27ab02ef895$export$50c7b4e9d9f19c1$1($905f4ae918aab1aa$var$ROOT_NAME, [
  $5d3850c4d0b4e6c7$export$cc702773b8ea3e41
]);
const $905f4ae918aab1aa$var$useDialogScope = $5d3850c4d0b4e6c7$export$cc702773b8ea3e41();
const $905f4ae918aab1aa$export$de466dd8317b0b75 = (props) => {
  const { __scopeAlertDialog, ...alertDialogProps } = props;
  const dialogScope = $905f4ae918aab1aa$var$useDialogScope(__scopeAlertDialog);
  return /* @__PURE__ */ createElement($5d3850c4d0b4e6c7$export$be92b6f5f03c0fe9, _extends$z({}, dialogScope, alertDialogProps, {
    modal: true
  }));
};
const $905f4ae918aab1aa$export$6edd7a623ef0f40b = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeAlertDialog, ...triggerProps } = props;
  const dialogScope = $905f4ae918aab1aa$var$useDialogScope(__scopeAlertDialog);
  return /* @__PURE__ */ createElement($5d3850c4d0b4e6c7$export$41fb9f06171c75f4, _extends$z({}, dialogScope, triggerProps, {
    ref: forwardedRef
  }));
});
const $905f4ae918aab1aa$export$660f2bfdb986706c = (props) => {
  const { __scopeAlertDialog, ...portalProps } = props;
  const dialogScope = $905f4ae918aab1aa$var$useDialogScope(__scopeAlertDialog);
  return /* @__PURE__ */ createElement($5d3850c4d0b4e6c7$export$602eac185826482c, _extends$z({}, dialogScope, portalProps));
};
const $905f4ae918aab1aa$export$a707a4895ce23256 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeAlertDialog, ...overlayProps } = props;
  const dialogScope = $905f4ae918aab1aa$var$useDialogScope(__scopeAlertDialog);
  return /* @__PURE__ */ createElement($5d3850c4d0b4e6c7$export$c6fdb837b070b4ff, _extends$z({}, dialogScope, overlayProps, {
    ref: forwardedRef
  }));
});
const $905f4ae918aab1aa$var$CONTENT_NAME = "AlertDialogContent";
const [$905f4ae918aab1aa$var$AlertDialogContentProvider, $905f4ae918aab1aa$var$useAlertDialogContentContext] = $905f4ae918aab1aa$var$createAlertDialogContext($905f4ae918aab1aa$var$CONTENT_NAME);
const $905f4ae918aab1aa$export$94e6af45f0af4efd = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeAlertDialog, children, ...contentProps } = props;
  const dialogScope = $905f4ae918aab1aa$var$useDialogScope(__scopeAlertDialog);
  const contentRef = useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05$1(forwardedRef, contentRef);
  const cancelRef = useRef(null);
  return /* @__PURE__ */ createElement($5d3850c4d0b4e6c7$export$69b62a49393917d6, {
    contentName: $905f4ae918aab1aa$var$CONTENT_NAME,
    titleName: $905f4ae918aab1aa$var$TITLE_NAME,
    docsSlug: "alert-dialog"
  }, /* @__PURE__ */ createElement($905f4ae918aab1aa$var$AlertDialogContentProvider, {
    scope: __scopeAlertDialog,
    cancelRef
  }, /* @__PURE__ */ createElement($5d3850c4d0b4e6c7$export$7c6e2c02157bb7d2, _extends$z({
    role: "alertdialog"
  }, dialogScope, contentProps, {
    ref: composedRefs,
    onOpenAutoFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(contentProps.onOpenAutoFocus, (event) => {
      var _cancelRef$current;
      event.preventDefault();
      (_cancelRef$current = cancelRef.current) === null || _cancelRef$current === void 0 || _cancelRef$current.focus({
        preventScroll: true
      });
    }),
    onPointerDownOutside: (event) => event.preventDefault(),
    onInteractOutside: (event) => event.preventDefault()
  }), /* @__PURE__ */ createElement($5e63c961fc1ce211$export$d9f1ccf0bdb05d45$1, null, children), false)));
});
const $905f4ae918aab1aa$var$TITLE_NAME = "AlertDialogTitle";
const $905f4ae918aab1aa$export$225e0da62d314b7 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeAlertDialog, ...titleProps } = props;
  const dialogScope = $905f4ae918aab1aa$var$useDialogScope(__scopeAlertDialog);
  return /* @__PURE__ */ createElement($5d3850c4d0b4e6c7$export$f99233281efd08a0, _extends$z({}, dialogScope, titleProps, {
    ref: forwardedRef
  }));
});
const $905f4ae918aab1aa$export$b454f818c58ee85d = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeAlertDialog, ...actionProps } = props;
  const dialogScope = $905f4ae918aab1aa$var$useDialogScope(__scopeAlertDialog);
  return /* @__PURE__ */ createElement($5d3850c4d0b4e6c7$export$f39c2d165cd861fe, _extends$z({}, dialogScope, actionProps, {
    ref: forwardedRef
  }));
});
const $905f4ae918aab1aa$var$CANCEL_NAME = "AlertDialogCancel";
const $905f4ae918aab1aa$export$2f67a923571aaea0 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeAlertDialog, ...cancelProps } = props;
  const { cancelRef } = $905f4ae918aab1aa$var$useAlertDialogContentContext($905f4ae918aab1aa$var$CANCEL_NAME, __scopeAlertDialog);
  const dialogScope = $905f4ae918aab1aa$var$useDialogScope(__scopeAlertDialog);
  const ref = $6ed0406888f73fc4$export$c7b2cbe3552a0d05$1(forwardedRef, cancelRef);
  return /* @__PURE__ */ createElement($5d3850c4d0b4e6c7$export$f39c2d165cd861fe, _extends$z({}, dialogScope, cancelProps, {
    ref
  }));
});
const $905f4ae918aab1aa$export$be92b6f5f03c0fe9 = $905f4ae918aab1aa$export$de466dd8317b0b75;
const $905f4ae918aab1aa$export$41fb9f06171c75f4 = $905f4ae918aab1aa$export$6edd7a623ef0f40b;
const $905f4ae918aab1aa$export$602eac185826482c = $905f4ae918aab1aa$export$660f2bfdb986706c;
const $905f4ae918aab1aa$export$c6fdb837b070b4ff = $905f4ae918aab1aa$export$a707a4895ce23256;
const $905f4ae918aab1aa$export$7c6e2c02157bb7d2 = $905f4ae918aab1aa$export$94e6af45f0af4efd;
const $905f4ae918aab1aa$export$e19cd5f9376f8cee = $905f4ae918aab1aa$export$b454f818c58ee85d;
const $905f4ae918aab1aa$export$848c9b7ead0df967 = $905f4ae918aab1aa$export$2f67a923571aaea0;
const $905f4ae918aab1aa$export$f99233281efd08a0 = $905f4ae918aab1aa$export$225e0da62d314b7;
const AlertDialogContext = React__default.createContext({
  props: {},
  ref: null
});
const useCurrentAlertDialog = () => {
  return React__default.useContext(AlertDialogContext);
};
function mergeRefs(refs) {
  return (value) => {
    refs.forEach((ref) => {
      if (typeof ref === "function") {
        ref(value);
      } else if (ref != null) {
        ref.current = value;
      }
    });
  };
}
const Trigger$7 = React.forwardRef(function AlertDialogTrigger(props, externalRef) {
  const { ref: parentRef, props: parentProps } = useCurrentAlertDialog();
  const refCallback = mergeRefs([parentRef, externalRef]);
  return /* @__PURE__ */ React.createElement($905f4ae918aab1aa$export$41fb9f06171c75f4, { ...parentProps, ...props, ref: refCallback, asChild: true });
});
const Footer$4 = React.forwardRef(function AlertDialogFooter(props, ref) {
  const className = "flex justify-end gap-2";
  return /* @__PURE__ */ React.createElement("div", { ...props, className, ref }, props.children);
});
const Cancel = React.forwardRef(function AlertDialogCancel(props, ref) {
  return /* @__PURE__ */ React.createElement($905f4ae918aab1aa$export$848c9b7ead0df967, { ...props, ref, asChild: true });
});
const Action$1 = React.forwardRef(function AlertDialogAction(props, ref) {
  return /* @__PURE__ */ React.createElement($905f4ae918aab1aa$export$e19cd5f9376f8cee, { ...props, className: props.className, ref, asChild: true });
});
const Backdrop = React.forwardRef(function Backdrop2(props, ref) {
  const className = clsx(
    "fixed inset-0 cursor-default overflow-y-auto bg-blue-900/[0.3] aria-hidden:invisible print:overflow-visible print:absolute",
    props.className
  );
  return /* @__PURE__ */ React.createElement("div", { ...props, className, "data-taco": "backdrop", ref });
});
const getDialogSizeClassnames = (size2) => {
  switch (size2) {
    case "dialog":
      return "w-128";
    case "xs":
      return "w-xs";
    case "sm":
      return "w-sm";
    case "md":
      return "w-md";
    case "lg":
      return "w-lg";
  }
};
const getDialogPositionClassnames = () => "mt-16 mx-auto";
const getDialogStylingClassnames = () => "bg-white rounded animate-[fade-in_150ms] shadow-[0_6px_9px_0_rgba(89,85,98,0.3),0_0_1px_0_rgba(89,85,98,0.2)]";
const iconPropsByVariant = (variant) => {
  switch (variant) {
    case "information":
      return {
        color: "blue",
        icon: "info"
      };
    case "error":
      return {
        color: "red",
        icon: "close"
      };
    case "warning":
      return {
        color: "yellow",
        icon: "warning"
      };
    default:
      return void 0;
  }
};
const Title$5 = React.forwardRef(function AlertDialogTitle(props, ref) {
  const { props: parentProps } = useCurrentAlertDialog();
  const iconProps = iconPropsByVariant(parentProps.variant);
  return /* @__PURE__ */ React.createElement($905f4ae918aab1aa$export$f99233281efd08a0, { ...props, className: clsx("flex items-center", props.className), ref }, iconProps ? /* @__PURE__ */ React.createElement(BadgeIcon, { ...iconProps, className: "mr-2" }) : void 0, props.children);
});
const Content$a = React.forwardRef(function AlertDialogContent(props, ref) {
  const className = clsx("p-6", getDialogPositionClassnames(), getDialogStylingClassnames(), getDialogSizeClassnames("dialog"));
  return /* @__PURE__ */ React.createElement($905f4ae918aab1aa$export$602eac185826482c, null, /* @__PURE__ */ React.createElement($905f4ae918aab1aa$export$c6fdb837b070b4ff, { asChild: true }, /* @__PURE__ */ React.createElement(Backdrop, null, /* @__PURE__ */ React.createElement(
    $905f4ae918aab1aa$export$7c6e2c02157bb7d2,
    {
      ...props,
      ref,
      className,
      onEscapeKeyDown: (event) => event.preventDefault()
    },
    props.children
  ))));
});
const AlertDialog = React.forwardRef(function AlertDialog2(props, ref) {
  const { children: initialChildren, defaultOpen, onChange, open, trigger, ...otherProps } = props;
  const context = React.useMemo(
    () => ({
      props: otherProps,
      ref
    }),
    [open, otherProps]
  );
  return /* @__PURE__ */ React.createElement(AlertDialogContext.Provider, { value: context }, /* @__PURE__ */ React.createElement($905f4ae918aab1aa$export$be92b6f5f03c0fe9, { ...props, defaultOpen, open, onOpenChange: onChange }, trigger && /* @__PURE__ */ React.createElement(Trigger$7, null, trigger), props.children));
});
AlertDialog.Trigger = Trigger$7;
AlertDialog.Content = Content$a;
AlertDialog.Title = Title$5;
AlertDialog.Cancel = Cancel;
AlertDialog.Action = Action$1;
AlertDialog.Footer = Footer$4;
const $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c = typeof document !== "undefined" ? React__default.useLayoutEffect : () => {
};
function $8ae05eaa5c114e9c$export$7f54fc3180508a52(fn) {
  const ref = useRef(null);
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    ref.current = fn;
  }, [
    fn
  ]);
  return useCallback((...args) => {
    const f2 = ref.current;
    return f2 === null || f2 === void 0 ? void 0 : f2(...args);
  }, []);
}
function $1dbecbe27a04f9af$export$14d238f342723f25(defaultValue2) {
  let [value, setValue] = useState(defaultValue2);
  let effect = useRef(null);
  let nextRef = $8ae05eaa5c114e9c$export$7f54fc3180508a52(() => {
    if (!effect.current) return;
    let newValue = effect.current.next();
    if (newValue.done) {
      effect.current = null;
      return;
    }
    if (value === newValue.value) nextRef();
    else setValue(newValue.value);
  });
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    if (effect.current) nextRef();
  });
  let queue = $8ae05eaa5c114e9c$export$7f54fc3180508a52((fn) => {
    effect.current = fn(value);
    nextRef();
  });
  return [
    value,
    queue
  ];
}
const $b5e257d569688ac6$var$defaultContext = {
  prefix: String(Math.round(Math.random() * 1e10)),
  current: 0
};
const $b5e257d569688ac6$var$SSRContext = /* @__PURE__ */ React__default.createContext($b5e257d569688ac6$var$defaultContext);
const $b5e257d569688ac6$var$IsSSRContext = /* @__PURE__ */ React__default.createContext(false);
let $b5e257d569688ac6$var$canUseDOM = Boolean(typeof window !== "undefined" && window.document && window.document.createElement);
let $b5e257d569688ac6$var$componentIds = /* @__PURE__ */ new WeakMap();
function $b5e257d569688ac6$var$useCounter(isDisabled = false) {
  let ctx = useContext($b5e257d569688ac6$var$SSRContext);
  let ref = useRef(null);
  if (ref.current === null && !isDisabled) {
    var _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner, _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    let currentOwner = (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = React__default.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED === void 0 ? void 0 : (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner = _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner === void 0 ? void 0 : _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner.current;
    if (currentOwner) {
      let prevComponentValue = $b5e257d569688ac6$var$componentIds.get(currentOwner);
      if (prevComponentValue == null)
        $b5e257d569688ac6$var$componentIds.set(currentOwner, {
          id: ctx.current,
          state: currentOwner.memoizedState
        });
      else if (currentOwner.memoizedState !== prevComponentValue.state) {
        ctx.current = prevComponentValue.id;
        $b5e257d569688ac6$var$componentIds.delete(currentOwner);
      }
    }
    ref.current = ++ctx.current;
  }
  return ref.current;
}
function $b5e257d569688ac6$var$useLegacySSRSafeId(defaultId) {
  let ctx = useContext($b5e257d569688ac6$var$SSRContext);
  if (ctx === $b5e257d569688ac6$var$defaultContext && !$b5e257d569688ac6$var$canUseDOM) console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
  let counter2 = $b5e257d569688ac6$var$useCounter(!!defaultId);
  let prefix2 = ctx === $b5e257d569688ac6$var$defaultContext && process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${ctx.prefix}`;
  return defaultId || `${prefix2}-${counter2}`;
}
function $b5e257d569688ac6$var$useModernSSRSafeId(defaultId) {
  let id2 = React__default.useId();
  let [didSSR] = useState($b5e257d569688ac6$export$535bd6ca7f90a273());
  let prefix2 = didSSR || process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${$b5e257d569688ac6$var$defaultContext.prefix}`;
  return defaultId || `${prefix2}-${id2}`;
}
const $b5e257d569688ac6$export$619500959fc48b26 = typeof React__default["useId"] === "function" ? $b5e257d569688ac6$var$useModernSSRSafeId : $b5e257d569688ac6$var$useLegacySSRSafeId;
function $b5e257d569688ac6$var$getSnapshot() {
  return false;
}
function $b5e257d569688ac6$var$getServerSnapshot() {
  return true;
}
function $b5e257d569688ac6$var$subscribe(onStoreChange) {
  return () => {
  };
}
function $b5e257d569688ac6$export$535bd6ca7f90a273() {
  if (typeof React__default["useSyncExternalStore"] === "function") return React__default["useSyncExternalStore"]($b5e257d569688ac6$var$subscribe, $b5e257d569688ac6$var$getSnapshot, $b5e257d569688ac6$var$getServerSnapshot);
  return useContext($b5e257d569688ac6$var$IsSSRContext);
}
let $bdb11010cef70236$var$canUseDOM = Boolean(typeof window !== "undefined" && window.document && window.document.createElement);
let $bdb11010cef70236$export$d41a04c74483c6ef = /* @__PURE__ */ new Map();
let $bdb11010cef70236$var$registry;
if (typeof FinalizationRegistry !== "undefined") $bdb11010cef70236$var$registry = new FinalizationRegistry((heldValue) => {
  $bdb11010cef70236$export$d41a04c74483c6ef.delete(heldValue);
});
function $bdb11010cef70236$export$f680877a34711e37(defaultId) {
  let [value, setValue] = useState(defaultId);
  let nextId = useRef(null);
  let res = $b5e257d569688ac6$export$619500959fc48b26(value);
  let cleanupRef = useRef(null);
  if ($bdb11010cef70236$var$registry) $bdb11010cef70236$var$registry.register(cleanupRef, res);
  if ($bdb11010cef70236$var$canUseDOM) {
    const cacheIdRef = $bdb11010cef70236$export$d41a04c74483c6ef.get(res);
    if (cacheIdRef && !cacheIdRef.includes(nextId)) cacheIdRef.push(nextId);
    else $bdb11010cef70236$export$d41a04c74483c6ef.set(res, [
      nextId
    ]);
  }
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    let r2 = res;
    return () => {
      if ($bdb11010cef70236$var$registry) $bdb11010cef70236$var$registry.unregister(cleanupRef);
      $bdb11010cef70236$export$d41a04c74483c6ef.delete(r2);
    };
  }, [
    res
  ]);
  useEffect(() => {
    let newId = nextId.current;
    if (newId) setValue(newId);
    return () => {
      if (newId) nextId.current = null;
    };
  });
  return res;
}
function $bdb11010cef70236$export$cd8c9cb68f842629(idA, idB) {
  if (idA === idB) return idA;
  let setIdsA = $bdb11010cef70236$export$d41a04c74483c6ef.get(idA);
  if (setIdsA) {
    setIdsA.forEach((ref) => ref.current = idB);
    return idB;
  }
  let setIdsB = $bdb11010cef70236$export$d41a04c74483c6ef.get(idB);
  if (setIdsB) {
    setIdsB.forEach((ref) => ref.current = idA);
    return idA;
  }
  return idB;
}
function $bdb11010cef70236$export$b4cc09c592e8fdb8(depArray = []) {
  let id2 = $bdb11010cef70236$export$f680877a34711e37();
  let [resolvedId, setResolvedId] = $1dbecbe27a04f9af$export$14d238f342723f25(id2);
  let updateId = useCallback(() => {
    setResolvedId(function* () {
      yield id2;
      yield document.getElementById(id2) ? id2 : void 0;
    });
  }, [
    id2,
    setResolvedId
  ]);
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(updateId, [
    id2,
    updateId,
    ...depArray
  ]);
  return resolvedId;
}
function $ff5963eb1fccf552$export$e08e3b67e392101e(...callbacks) {
  return (...args) => {
    for (let callback of callbacks) if (typeof callback === "function") callback(...args);
  };
}
const $431fbd86ca7dc216$export$b204af158042fbac = (el) => {
  var _el_ownerDocument;
  return (_el_ownerDocument = el === null || el === void 0 ? void 0 : el.ownerDocument) !== null && _el_ownerDocument !== void 0 ? _el_ownerDocument : document;
};
const $431fbd86ca7dc216$export$f21a1ffae260145a = (el) => {
  if (el && "window" in el && el.window === el) return el;
  const doc = $431fbd86ca7dc216$export$b204af158042fbac(el);
  return doc.defaultView || window;
};
function $431fbd86ca7dc216$var$isNode(value) {
  return value !== null && typeof value === "object" && "nodeType" in value && typeof value.nodeType === "number";
}
function $431fbd86ca7dc216$export$af51f0f06c0f328a(node) {
  return $431fbd86ca7dc216$var$isNode(node) && node.nodeType === Node.DOCUMENT_FRAGMENT_NODE && "host" in node;
}
let $f4e2df6bd15f8569$var$_shadowDOM = false;
function $f4e2df6bd15f8569$export$98658e8c59125e6a() {
  return $f4e2df6bd15f8569$var$_shadowDOM;
}
function $d4ee10de306f2510$export$4282f70798064fe0(node, otherNode) {
  if (!$f4e2df6bd15f8569$export$98658e8c59125e6a()) return otherNode && node ? node.contains(otherNode) : false;
  if (!node || !otherNode) return false;
  let currentNode = otherNode;
  while (currentNode !== null) {
    if (currentNode === node) return true;
    if (currentNode.tagName === "SLOT" && currentNode.assignedSlot)
      currentNode = currentNode.assignedSlot.parentNode;
    else if ($431fbd86ca7dc216$export$af51f0f06c0f328a(currentNode))
      currentNode = currentNode.host;
    else currentNode = currentNode.parentNode;
  }
  return false;
}
const $d4ee10de306f2510$export$cd4e5573fbe2b576 = (doc = document) => {
  var _activeElement_shadowRoot;
  if (!$f4e2df6bd15f8569$export$98658e8c59125e6a()) return doc.activeElement;
  let activeElement = doc.activeElement;
  while (activeElement && "shadowRoot" in activeElement && ((_activeElement_shadowRoot = activeElement.shadowRoot) === null || _activeElement_shadowRoot === void 0 ? void 0 : _activeElement_shadowRoot.activeElement)) activeElement = activeElement.shadowRoot.activeElement;
  return activeElement;
};
function $d4ee10de306f2510$export$e58f029f0fbfdb29(event) {
  if ($f4e2df6bd15f8569$export$98658e8c59125e6a() && event.target.shadowRoot) {
    if (event.composedPath) return event.composedPath()[0];
  }
  return event.target;
}
class $dfc540311bf7f109$export$63eb3ababa9c55c4 {
  get currentNode() {
    return this._currentNode;
  }
  set currentNode(node) {
    if (!$d4ee10de306f2510$export$4282f70798064fe0(this.root, node)) throw new Error("Cannot set currentNode to a node that is not contained by the root node.");
    const walkers = [];
    let curNode = node;
    let currentWalkerCurrentNode = node;
    this._currentNode = node;
    while (curNode && curNode !== this.root) if (curNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
      const shadowRoot = curNode;
      const walker2 = this._doc.createTreeWalker(shadowRoot, this.whatToShow, {
        acceptNode: this._acceptNode
      });
      walkers.push(walker2);
      walker2.currentNode = currentWalkerCurrentNode;
      this._currentSetFor.add(walker2);
      curNode = currentWalkerCurrentNode = shadowRoot.host;
    } else curNode = curNode.parentNode;
    const walker = this._doc.createTreeWalker(this.root, this.whatToShow, {
      acceptNode: this._acceptNode
    });
    walkers.push(walker);
    walker.currentNode = currentWalkerCurrentNode;
    this._currentSetFor.add(walker);
    this._walkerStack = walkers;
  }
  get doc() {
    return this._doc;
  }
  firstChild() {
    let currentNode = this.currentNode;
    let newNode = this.nextNode();
    if (!$d4ee10de306f2510$export$4282f70798064fe0(currentNode, newNode)) {
      this.currentNode = currentNode;
      return null;
    }
    if (newNode) this.currentNode = newNode;
    return newNode;
  }
  lastChild() {
    let walker = this._walkerStack[0];
    let newNode = walker.lastChild();
    if (newNode) this.currentNode = newNode;
    return newNode;
  }
  nextNode() {
    const nextNode = this._walkerStack[0].nextNode();
    if (nextNode) {
      const shadowRoot = nextNode.shadowRoot;
      if (shadowRoot) {
        var _this_filter;
        let nodeResult;
        if (typeof this.filter === "function") nodeResult = this.filter(nextNode);
        else if ((_this_filter = this.filter) === null || _this_filter === void 0 ? void 0 : _this_filter.acceptNode) nodeResult = this.filter.acceptNode(nextNode);
        if (nodeResult === NodeFilter.FILTER_ACCEPT) {
          this.currentNode = nextNode;
          return nextNode;
        }
        let newNode = this.nextNode();
        if (newNode) this.currentNode = newNode;
        return newNode;
      }
      if (nextNode) this.currentNode = nextNode;
      return nextNode;
    } else {
      if (this._walkerStack.length > 1) {
        this._walkerStack.shift();
        let newNode = this.nextNode();
        if (newNode) this.currentNode = newNode;
        return newNode;
      } else return null;
    }
  }
  previousNode() {
    const currentWalker = this._walkerStack[0];
    if (currentWalker.currentNode === currentWalker.root) {
      if (this._currentSetFor.has(currentWalker)) {
        this._currentSetFor.delete(currentWalker);
        if (this._walkerStack.length > 1) {
          this._walkerStack.shift();
          let newNode = this.previousNode();
          if (newNode) this.currentNode = newNode;
          return newNode;
        } else return null;
      }
      return null;
    }
    const previousNode = currentWalker.previousNode();
    if (previousNode) {
      const shadowRoot = previousNode.shadowRoot;
      if (shadowRoot) {
        var _this_filter;
        let nodeResult;
        if (typeof this.filter === "function") nodeResult = this.filter(previousNode);
        else if ((_this_filter = this.filter) === null || _this_filter === void 0 ? void 0 : _this_filter.acceptNode) nodeResult = this.filter.acceptNode(previousNode);
        if (nodeResult === NodeFilter.FILTER_ACCEPT) {
          if (previousNode) this.currentNode = previousNode;
          return previousNode;
        }
        let newNode = this.lastChild();
        if (newNode) this.currentNode = newNode;
        return newNode;
      }
      if (previousNode) this.currentNode = previousNode;
      return previousNode;
    } else {
      if (this._walkerStack.length > 1) {
        this._walkerStack.shift();
        let newNode = this.previousNode();
        if (newNode) this.currentNode = newNode;
        return newNode;
      } else return null;
    }
  }
  /**
   * @deprecated
   */
  nextSibling() {
    return null;
  }
  /**
   * @deprecated
   */
  previousSibling() {
    return null;
  }
  /**
   * @deprecated
   */
  parentNode() {
    return null;
  }
  constructor(doc, root, whatToShow, filter2) {
    this._walkerStack = [];
    this._currentSetFor = /* @__PURE__ */ new Set();
    this._acceptNode = (node) => {
      if (node.nodeType === Node.ELEMENT_NODE) {
        const shadowRoot2 = node.shadowRoot;
        if (shadowRoot2) {
          const walker = this._doc.createTreeWalker(shadowRoot2, this.whatToShow, {
            acceptNode: this._acceptNode
          });
          this._walkerStack.unshift(walker);
          return NodeFilter.FILTER_ACCEPT;
        } else {
          var _this_filter;
          if (typeof this.filter === "function") return this.filter(node);
          else if ((_this_filter = this.filter) === null || _this_filter === void 0 ? void 0 : _this_filter.acceptNode) return this.filter.acceptNode(node);
          else if (this.filter === null) return NodeFilter.FILTER_ACCEPT;
        }
      }
      return NodeFilter.FILTER_SKIP;
    };
    this._doc = doc;
    this.root = root;
    this.filter = filter2 !== null && filter2 !== void 0 ? filter2 : null;
    this.whatToShow = whatToShow !== null && whatToShow !== void 0 ? whatToShow : NodeFilter.SHOW_ALL;
    this._currentNode = root;
    this._walkerStack.unshift(doc.createTreeWalker(root, whatToShow, this._acceptNode));
    const shadowRoot = root.shadowRoot;
    if (shadowRoot) {
      const walker = this._doc.createTreeWalker(shadowRoot, this.whatToShow, {
        acceptNode: this._acceptNode
      });
      this._walkerStack.unshift(walker);
    }
  }
}
function $dfc540311bf7f109$export$4d0f8be8b12a7ef6(doc, root, whatToShow, filter2) {
  if ($f4e2df6bd15f8569$export$98658e8c59125e6a()) return new $dfc540311bf7f109$export$63eb3ababa9c55c4(doc, root, whatToShow, filter2);
  return doc.createTreeWalker(root, whatToShow, filter2);
}
function $3ef42575df84b30b$export$9d1611c77c2fe928(...args) {
  let result = {
    ...args[0]
  };
  for (let i3 = 1; i3 < args.length; i3++) {
    let props = args[i3];
    for (let key in props) {
      let a4 = result[key];
      let b3 = props[key];
      if (typeof a4 === "function" && typeof b3 === "function" && // This is a lot faster than a regex.
      key[0] === "o" && key[1] === "n" && key.charCodeAt(2) >= /* 'A' */
      65 && key.charCodeAt(2) <= /* 'Z' */
      90) result[key] = $ff5963eb1fccf552$export$e08e3b67e392101e(a4, b3);
      else if ((key === "className" || key === "UNSAFE_className") && typeof a4 === "string" && typeof b3 === "string") result[key] = clsx(a4, b3);
      else if (key === "id" && a4 && b3) result.id = $bdb11010cef70236$export$cd8c9cb68f842629(a4, b3);
      else result[key] = b3 !== void 0 ? b3 : a4;
    }
  }
  return result;
}
function $5dc95899b306f630$export$c9058316764c140e(...refs) {
  if (refs.length === 1 && refs[0]) return refs[0];
  return (value) => {
    for (let ref of refs) {
      if (typeof ref === "function") ref(value);
      else if (ref != null) ref.current = value;
    }
  };
}
const $65484d02dcb7eb3e$var$DOMPropNames = /* @__PURE__ */ new Set([
  "id"
]);
const $65484d02dcb7eb3e$var$labelablePropNames = /* @__PURE__ */ new Set([
  "aria-label",
  "aria-labelledby",
  "aria-describedby",
  "aria-details"
]);
const $65484d02dcb7eb3e$var$linkPropNames = /* @__PURE__ */ new Set([
  "href",
  "hrefLang",
  "target",
  "rel",
  "download",
  "ping",
  "referrerPolicy"
]);
const $65484d02dcb7eb3e$var$propRe = /^(data-.*)$/;
function $65484d02dcb7eb3e$export$457c3d6518dd4c6f(props, opts = {}) {
  let { labelable, isLink, propNames } = opts;
  let filteredProps = {};
  for (const prop in props) if (Object.prototype.hasOwnProperty.call(props, prop) && ($65484d02dcb7eb3e$var$DOMPropNames.has(prop) || labelable && $65484d02dcb7eb3e$var$labelablePropNames.has(prop) || isLink && $65484d02dcb7eb3e$var$linkPropNames.has(prop) || (propNames === null || propNames === void 0 ? void 0 : propNames.has(prop)) || $65484d02dcb7eb3e$var$propRe.test(prop))) filteredProps[prop] = props[prop];
  return filteredProps;
}
function $7215afc6de606d6b$export$de79e2c695e052f3(element) {
  if ($7215afc6de606d6b$var$supportsPreventScroll()) element.focus({
    preventScroll: true
  });
  else {
    let scrollableElements = $7215afc6de606d6b$var$getScrollableElements(element);
    element.focus();
    $7215afc6de606d6b$var$restoreScrollPosition(scrollableElements);
  }
}
let $7215afc6de606d6b$var$supportsPreventScrollCached = null;
function $7215afc6de606d6b$var$supportsPreventScroll() {
  if ($7215afc6de606d6b$var$supportsPreventScrollCached == null) {
    $7215afc6de606d6b$var$supportsPreventScrollCached = false;
    try {
      let focusElem = document.createElement("div");
      focusElem.focus({
        get preventScroll() {
          $7215afc6de606d6b$var$supportsPreventScrollCached = true;
          return true;
        }
      });
    } catch {
    }
  }
  return $7215afc6de606d6b$var$supportsPreventScrollCached;
}
function $7215afc6de606d6b$var$getScrollableElements(element) {
  let parent = element.parentNode;
  let scrollableElements = [];
  let rootScrollingElement = document.scrollingElement || document.documentElement;
  while (parent instanceof HTMLElement && parent !== rootScrollingElement) {
    if (parent.offsetHeight < parent.scrollHeight || parent.offsetWidth < parent.scrollWidth) scrollableElements.push({
      element: parent,
      scrollTop: parent.scrollTop,
      scrollLeft: parent.scrollLeft
    });
    parent = parent.parentNode;
  }
  if (rootScrollingElement instanceof HTMLElement) scrollableElements.push({
    element: rootScrollingElement,
    scrollTop: rootScrollingElement.scrollTop,
    scrollLeft: rootScrollingElement.scrollLeft
  });
  return scrollableElements;
}
function $7215afc6de606d6b$var$restoreScrollPosition(scrollableElements) {
  for (let { element, scrollTop, scrollLeft } of scrollableElements) {
    element.scrollTop = scrollTop;
    element.scrollLeft = scrollLeft;
  }
}
function $c87311424ea30a05$var$testUserAgent(re2) {
  var _window_navigator_userAgentData;
  if (typeof window === "undefined" || window.navigator == null) return false;
  return ((_window_navigator_userAgentData = window.navigator["userAgentData"]) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.brands.some((brand) => re2.test(brand.brand))) || re2.test(window.navigator.userAgent);
}
function $c87311424ea30a05$var$testPlatform(re2) {
  var _window_navigator_userAgentData;
  return typeof window !== "undefined" && window.navigator != null ? re2.test(((_window_navigator_userAgentData = window.navigator["userAgentData"]) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.platform) || window.navigator.platform) : false;
}
function $c87311424ea30a05$var$cached(fn) {
  let res = null;
  return () => {
    if (res == null) res = fn();
    return res;
  };
}
const $c87311424ea30a05$export$9ac100e40613ea10 = $c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$var$testPlatform(/^Mac/i);
});
const $c87311424ea30a05$export$186c6964ca17d99 = $c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$var$testPlatform(/^iPhone/i);
});
const $c87311424ea30a05$export$7bef049ce92e4224 = $c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  $c87311424ea30a05$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
});
const $c87311424ea30a05$export$fedb369cb70207f1 = $c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$export$186c6964ca17d99() || $c87311424ea30a05$export$7bef049ce92e4224();
});
const $c87311424ea30a05$export$78551043582a6a98 = $c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$var$testUserAgent(/AppleWebKit/i) && !$c87311424ea30a05$export$6446a186d09e379e();
});
const $c87311424ea30a05$export$6446a186d09e379e = $c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$var$testUserAgent(/Chrome/i);
});
const $c87311424ea30a05$export$a11b0059900ceec8 = $c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$var$testUserAgent(/Android/i);
});
const $c87311424ea30a05$export$b7d78993b74f766d = $c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$var$testUserAgent(/Firefox/i);
});
function $ea8dcbcb9ea1b556$export$95185d699e05d4d7(target, modifiers2, setOpening = true) {
  var _window_event_type, _window_event;
  let { metaKey, ctrlKey, altKey, shiftKey } = modifiers2;
  if ($c87311424ea30a05$export$b7d78993b74f766d() && ((_window_event = window.event) === null || _window_event === void 0 ? void 0 : (_window_event_type = _window_event.type) === null || _window_event_type === void 0 ? void 0 : _window_event_type.startsWith("key")) && target.target === "_blank") {
    if ($c87311424ea30a05$export$9ac100e40613ea10()) metaKey = true;
    else ctrlKey = true;
  }
  let event = $c87311424ea30a05$export$78551043582a6a98() && $c87311424ea30a05$export$9ac100e40613ea10() && !$c87311424ea30a05$export$7bef049ce92e4224() && true ? new KeyboardEvent("keydown", {
    keyIdentifier: "Enter",
    metaKey,
    ctrlKey,
    altKey,
    shiftKey
  }) : new MouseEvent("click", {
    metaKey,
    ctrlKey,
    altKey,
    shiftKey,
    bubbles: true,
    cancelable: true
  });
  $ea8dcbcb9ea1b556$export$95185d699e05d4d7.isOpening = setOpening;
  $7215afc6de606d6b$export$de79e2c695e052f3(target);
  target.dispatchEvent(event);
  $ea8dcbcb9ea1b556$export$95185d699e05d4d7.isOpening = false;
}
$ea8dcbcb9ea1b556$export$95185d699e05d4d7.isOpening = false;
let $bbed8b41f857bcc0$var$transitionsByElement = /* @__PURE__ */ new Map();
let $bbed8b41f857bcc0$var$transitionCallbacks = /* @__PURE__ */ new Set();
function $bbed8b41f857bcc0$var$setupGlobalEvents() {
  if (typeof window === "undefined") return;
  function isTransitionEvent(event) {
    return "propertyName" in event;
  }
  let onTransitionStart = (e3) => {
    if (!isTransitionEvent(e3) || !e3.target) return;
    let transitions = $bbed8b41f857bcc0$var$transitionsByElement.get(e3.target);
    if (!transitions) {
      transitions = /* @__PURE__ */ new Set();
      $bbed8b41f857bcc0$var$transitionsByElement.set(e3.target, transitions);
      e3.target.addEventListener("transitioncancel", onTransitionEnd, {
        once: true
      });
    }
    transitions.add(e3.propertyName);
  };
  let onTransitionEnd = (e3) => {
    if (!isTransitionEvent(e3) || !e3.target) return;
    let properties2 = $bbed8b41f857bcc0$var$transitionsByElement.get(e3.target);
    if (!properties2) return;
    properties2.delete(e3.propertyName);
    if (properties2.size === 0) {
      e3.target.removeEventListener("transitioncancel", onTransitionEnd);
      $bbed8b41f857bcc0$var$transitionsByElement.delete(e3.target);
    }
    if ($bbed8b41f857bcc0$var$transitionsByElement.size === 0) {
      for (let cb2 of $bbed8b41f857bcc0$var$transitionCallbacks) cb2();
      $bbed8b41f857bcc0$var$transitionCallbacks.clear();
    }
  };
  document.body.addEventListener("transitionrun", onTransitionStart);
  document.body.addEventListener("transitionend", onTransitionEnd);
}
if (typeof document !== "undefined") {
  if (document.readyState !== "loading") $bbed8b41f857bcc0$var$setupGlobalEvents();
  else document.addEventListener("DOMContentLoaded", $bbed8b41f857bcc0$var$setupGlobalEvents);
}
function $bbed8b41f857bcc0$export$24490316f764c430(fn) {
  requestAnimationFrame(() => {
    if ($bbed8b41f857bcc0$var$transitionsByElement.size === 0) fn();
    else $bbed8b41f857bcc0$var$transitionCallbacks.add(fn);
  });
}
function $03deb23ff14920c4$export$4eaf04e54aa8eed6() {
  let globalListeners = useRef(/* @__PURE__ */ new Map());
  let addGlobalListener = useCallback((eventTarget, type, listener, options) => {
    let fn = (options === null || options === void 0 ? void 0 : options.once) ? (...args) => {
      globalListeners.current.delete(listener);
      listener(...args);
    } : listener;
    globalListeners.current.set(listener, {
      type,
      eventTarget,
      fn,
      options
    });
    eventTarget.addEventListener(type, fn, options);
  }, []);
  let removeGlobalListener = useCallback((eventTarget, type, listener, options) => {
    var _globalListeners_current_get;
    let fn = ((_globalListeners_current_get = globalListeners.current.get(listener)) === null || _globalListeners_current_get === void 0 ? void 0 : _globalListeners_current_get.fn) || listener;
    eventTarget.removeEventListener(type, fn, options);
    globalListeners.current.delete(listener);
  }, []);
  let removeAllGlobalListeners = useCallback(() => {
    globalListeners.current.forEach((value, key) => {
      removeGlobalListener(value.eventTarget, value.type, key, value.options);
    });
  }, [
    removeGlobalListener
  ]);
  useEffect(() => {
    return removeAllGlobalListeners;
  }, [
    removeAllGlobalListeners
  ]);
  return {
    addGlobalListener,
    removeGlobalListener,
    removeAllGlobalListeners
  };
}
function $313b98861ee5dd6c$export$d6875122194c7b44(props, defaultLabel) {
  let { id: id2, "aria-label": label, "aria-labelledby": labelledBy } = props;
  id2 = $bdb11010cef70236$export$f680877a34711e37(id2);
  if (labelledBy && label) {
    let ids2 = /* @__PURE__ */ new Set([
      id2,
      ...labelledBy.trim().split(/\s+/)
    ]);
    labelledBy = [
      ...ids2
    ].join(" ");
  } else if (labelledBy) labelledBy = labelledBy.trim().split(/\s+/).join(" ");
  if (!label && !labelledBy && defaultLabel) label = defaultLabel;
  return {
    id: id2,
    "aria-label": label,
    "aria-labelledby": labelledBy
  };
}
function $df56164dff5785e2$export$4338b53315abf666(forwardedRef) {
  const objRef = useRef(null);
  return useMemo(() => ({
    get current() {
      return objRef.current;
    },
    set current(value) {
      objRef.current = value;
      if (typeof forwardedRef === "function") forwardedRef(value);
      else if (forwardedRef) forwardedRef.current = value;
    }
  }), [
    forwardedRef
  ]);
}
function $e7801be82b4b2a53$export$4debdb1a3f0fa79e(context, ref) {
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    if (context && context.ref && ref) {
      context.ref.current = ref.current;
      return () => {
        if (context.ref) context.ref.current = null;
      };
    }
  });
}
function $e9faafb641e167db$export$90fc3a17d93f704c(ref, event, handler, options) {
  let handleEvent = $8ae05eaa5c114e9c$export$7f54fc3180508a52(handler);
  let isDisabled = handler == null;
  useEffect(() => {
    if (isDisabled || !ref.current) return;
    let element = ref.current;
    element.addEventListener(event, handleEvent, options);
    return () => {
      element.removeEventListener(event, handleEvent, options);
    };
  }, [
    ref,
    event,
    options,
    isDisabled,
    handleEvent
  ]);
}
function $6a7db85432448f7f$export$60278871457622de(event) {
  if (event.mozInputSource === 0 && event.isTrusted) return true;
  if ($c87311424ea30a05$export$a11b0059900ceec8() && event.pointerType) return event.type === "click" && event.buttons === 1;
  return event.detail === 0 && !event.pointerType;
}
function $6a7db85432448f7f$export$29bf1b5f2c56cf63(event) {
  return !$c87311424ea30a05$export$a11b0059900ceec8() && event.width === 0 && event.height === 0 || event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === "mouse";
}
function $99facab73266f662$export$5add1d006293d136(ref, initialValue, onReset) {
  let resetValue = useRef(initialValue);
  let handleReset = $8ae05eaa5c114e9c$export$7f54fc3180508a52(() => {
    if (onReset) onReset(resetValue.current);
  });
  useEffect(() => {
    var _ref_current;
    let form = ref === null || ref === void 0 ? void 0 : (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.form;
    form === null || form === void 0 ? void 0 : form.addEventListener("reset", handleReset);
    return () => {
      form === null || form === void 0 ? void 0 : form.removeEventListener("reset", handleReset);
    };
  }, [
    ref,
    handleReset
  ]);
}
const $b4b717babfbb907b$var$focusableElements = [
  "input:not([disabled]):not([type=hidden])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  '[contenteditable]:not([contenteditable^="false"])'
];
const $b4b717babfbb907b$var$FOCUSABLE_ELEMENT_SELECTOR = $b4b717babfbb907b$var$focusableElements.join(":not([hidden]),") + ",[tabindex]:not([disabled]):not([hidden])";
$b4b717babfbb907b$var$focusableElements.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
const $b4b717babfbb907b$var$TABBABLE_ELEMENT_SELECTOR = $b4b717babfbb907b$var$focusableElements.join(':not([hidden]):not([tabindex="-1"]),');
function $b4b717babfbb907b$export$4c063cf1350e6fed(element) {
  return element.matches($b4b717babfbb907b$var$FOCUSABLE_ELEMENT_SELECTOR);
}
function $b4b717babfbb907b$export$bebd5a1431fec25d(element) {
  return element.matches($b4b717babfbb907b$var$TABBABLE_ELEMENT_SELECTOR);
}
function $458b0a5536c1a7cf$export$40bfa8c7b0832715(value, defaultValue2, onChange) {
  let [stateValue, setStateValue] = useState(value || defaultValue2);
  let isControlledRef = useRef(value !== void 0);
  let isControlled = value !== void 0;
  useEffect(() => {
    let wasControlled = isControlledRef.current;
    if (wasControlled !== isControlled) console.warn(`WARN: A component changed from ${wasControlled ? "controlled" : "uncontrolled"} to ${isControlled ? "controlled" : "uncontrolled"}.`);
    isControlledRef.current = isControlled;
  }, [
    isControlled
  ]);
  let currentValue = isControlled ? value : stateValue;
  let setValue = useCallback((value2, ...args) => {
    let onChangeCaller = (value3, ...onChangeArgs) => {
      if (onChange) {
        if (!Object.is(currentValue, value3)) onChange(value3, ...onChangeArgs);
      }
      if (!isControlled)
        currentValue = value3;
    };
    if (typeof value2 === "function") {
      console.warn("We can not support a function callback. See Github Issues for details https://github.com/adobe/react-spectrum/issues/2320");
      let updateFunction = (oldValue, ...functionArgs) => {
        let interceptedValue = value2(isControlled ? currentValue : oldValue, ...functionArgs);
        onChangeCaller(interceptedValue, ...args);
        if (!isControlled) return interceptedValue;
        return oldValue;
      };
      setStateValue(updateFunction);
    } else {
      if (!isControlled) setStateValue(value2);
      onChangeCaller(value2, ...args);
    }
  }, [
    isControlled,
    currentValue,
    onChange
  ]);
  return [
    currentValue,
    setValue
  ];
}
const $64fa3d84918910a7$export$c62b8e45d58ddad9 = Symbol("default");
function $64fa3d84918910a7$export$2881499e37b75b9a({ values, children }) {
  for (let [Context2, value] of values)
    children = /* @__PURE__ */ React__default.createElement(Context2.Provider, {
      value
    }, children);
  return children;
}
function $64fa3d84918910a7$export$4d86445c2cf5e3(props) {
  let { className, style, children, defaultClassName, defaultChildren, defaultStyle, values } = props;
  return useMemo(() => {
    let computedClassName;
    let computedStyle;
    let computedChildren;
    if (typeof className === "function") computedClassName = className({
      ...values,
      defaultClassName
    });
    else computedClassName = className;
    if (typeof style === "function") computedStyle = style({
      ...values,
      defaultStyle: defaultStyle || {}
    });
    else computedStyle = style;
    if (typeof children === "function") computedChildren = children({
      ...values,
      defaultChildren
    });
    else if (children == null) computedChildren = defaultChildren;
    else computedChildren = children;
    return {
      className: computedClassName !== null && computedClassName !== void 0 ? computedClassName : defaultClassName,
      style: computedStyle || defaultStyle ? {
        ...defaultStyle,
        ...computedStyle
      } : void 0,
      children: computedChildren !== null && computedChildren !== void 0 ? computedChildren : defaultChildren,
      "data-rac": ""
    };
  }, [
    className,
    style,
    children,
    defaultClassName,
    defaultChildren,
    defaultStyle,
    values
  ]);
}
function $64fa3d84918910a7$export$fabf2dc03a41866e(context, slot) {
  let ctx = useContext(context);
  if (slot === null)
    return null;
  if (ctx && typeof ctx === "object" && "slots" in ctx && ctx.slots) {
    let slotKey = slot || $64fa3d84918910a7$export$c62b8e45d58ddad9;
    if (!ctx.slots[slotKey]) {
      let availableSlots = new Intl.ListFormat().format(Object.keys(ctx.slots).map((p2) => `"${p2}"`));
      let errorMessage = slot ? `Invalid slot "${slot}".` : "A slot prop is required.";
      throw new Error(`${errorMessage} Valid slot names are ${availableSlots}.`);
    }
    return ctx.slots[slotKey];
  }
  return ctx;
}
function $64fa3d84918910a7$export$29f1550f4b0d4415(props, ref, context) {
  let ctx = $64fa3d84918910a7$export$fabf2dc03a41866e(context, props.slot) || {};
  let { ref: contextRef, ...contextProps } = ctx;
  let mergedRef = $df56164dff5785e2$export$4338b53315abf666(useMemo(() => $5dc95899b306f630$export$c9058316764c140e(ref, contextRef), [
    ref,
    contextRef
  ]));
  let mergedProps = $3ef42575df84b30b$export$9d1611c77c2fe928(contextProps, props);
  if ("style" in contextProps && contextProps.style && "style" in props && props.style) {
    if (typeof contextProps.style === "function" || typeof props.style === "function")
      mergedProps.style = (renderProps) => {
        let contextStyle = typeof contextProps.style === "function" ? contextProps.style(renderProps) : contextProps.style;
        let defaultStyle = {
          ...renderProps.defaultStyle,
          ...contextStyle
        };
        let style = typeof props.style === "function" ? props.style({
          ...renderProps,
          defaultStyle
        }) : props.style;
        return {
          ...defaultStyle,
          ...style
        };
      };
    else
      mergedProps.style = {
        ...contextProps.style,
        ...props.style
      };
  }
  return [
    mergedProps,
    mergedRef
  ];
}
function $64fa3d84918910a7$export$9d4c57ee4c6ffdd8(initialState = true) {
  let [hasSlot, setHasSlot] = useState(initialState);
  let hasRun = useRef(false);
  let ref = useCallback((el) => {
    hasRun.current = true;
    setHasSlot(!!el);
  }, []);
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    if (!hasRun.current) setHasSlot(false);
  }, []);
  return [
    ref,
    hasSlot
  ];
}
function $64fa3d84918910a7$export$ef03459518577ad4(props) {
  const prefix2 = /^(data-.*)$/;
  let filteredProps = {};
  for (const prop in props) if (!prefix2.test(prop)) filteredProps[prop] = props[prop];
  return filteredProps;
}
if (typeof HTMLTemplateElement !== "undefined") {
  const getFirstChild = Object.getOwnPropertyDescriptor(Node.prototype, "firstChild").get;
  Object.defineProperty(HTMLTemplateElement.prototype, "firstChild", {
    configurable: true,
    enumerable: true,
    get: function() {
      if (this.dataset.reactAriaHidden) return this.content.firstChild;
      else return getFirstChild.call(this);
    }
  });
}
const $f39a9eba43920ace$export$94b6d0abf7d33e8c = /* @__PURE__ */ createContext(false);
function $f39a9eba43920ace$export$86427a43e3e48ebb(fn) {
  let Wrapper = (props, ref) => {
    let isHidden = useContext($f39a9eba43920ace$export$94b6d0abf7d33e8c);
    if (isHidden) return null;
    return fn(props, ref);
  };
  Wrapper.displayName = fn.displayName || fn.name;
  return forwardRef(Wrapper);
}
let $14c0b72509d70225$var$state = "default";
let $14c0b72509d70225$var$savedUserSelect = "";
let $14c0b72509d70225$var$modifiedElementMap = /* @__PURE__ */ new WeakMap();
function $14c0b72509d70225$export$16a4697467175487(target) {
  if ($c87311424ea30a05$export$fedb369cb70207f1()) {
    if ($14c0b72509d70225$var$state === "default") {
      const documentObject = $431fbd86ca7dc216$export$b204af158042fbac(target);
      $14c0b72509d70225$var$savedUserSelect = documentObject.documentElement.style.webkitUserSelect;
      documentObject.documentElement.style.webkitUserSelect = "none";
    }
    $14c0b72509d70225$var$state = "disabled";
  } else if (target instanceof HTMLElement || target instanceof SVGElement) {
    let property = "userSelect" in target.style ? "userSelect" : "webkitUserSelect";
    $14c0b72509d70225$var$modifiedElementMap.set(target, target.style[property]);
    target.style[property] = "none";
  }
}
function $14c0b72509d70225$export$b0d6fa1ab32e3295(target) {
  if ($c87311424ea30a05$export$fedb369cb70207f1()) {
    if ($14c0b72509d70225$var$state !== "disabled") return;
    $14c0b72509d70225$var$state = "restoring";
    setTimeout(() => {
      $bbed8b41f857bcc0$export$24490316f764c430(() => {
        if ($14c0b72509d70225$var$state === "restoring") {
          const documentObject = $431fbd86ca7dc216$export$b204af158042fbac(target);
          if (documentObject.documentElement.style.webkitUserSelect === "none") documentObject.documentElement.style.webkitUserSelect = $14c0b72509d70225$var$savedUserSelect || "";
          $14c0b72509d70225$var$savedUserSelect = "";
          $14c0b72509d70225$var$state = "default";
        }
      });
    }, 300);
  } else if (target instanceof HTMLElement || target instanceof SVGElement) {
    if (target && $14c0b72509d70225$var$modifiedElementMap.has(target)) {
      let targetOldUserSelect = $14c0b72509d70225$var$modifiedElementMap.get(target);
      let property = "userSelect" in target.style ? "userSelect" : "webkitUserSelect";
      if (target.style[property] === "none") target.style[property] = targetOldUserSelect;
      if (target.getAttribute("style") === "") target.removeAttribute("style");
      $14c0b72509d70225$var$modifiedElementMap.delete(target);
    }
  }
}
const $ae1eeba8b9eafd08$export$5165eccb35aaadb5 = React__default.createContext({
  register: () => {
  }
});
$ae1eeba8b9eafd08$export$5165eccb35aaadb5.displayName = "PressResponderContext";
class $8a9cb279dc87e130$export$905e7fc544a71f36 {
  isDefaultPrevented() {
    return this.nativeEvent.defaultPrevented;
  }
  preventDefault() {
    this.defaultPrevented = true;
    this.nativeEvent.preventDefault();
  }
  stopPropagation() {
    this.nativeEvent.stopPropagation();
    this.isPropagationStopped = () => true;
  }
  isPropagationStopped() {
    return false;
  }
  persist() {
  }
  constructor(type, nativeEvent) {
    this.nativeEvent = nativeEvent;
    this.target = nativeEvent.target;
    this.currentTarget = nativeEvent.currentTarget;
    this.relatedTarget = nativeEvent.relatedTarget;
    this.bubbles = nativeEvent.bubbles;
    this.cancelable = nativeEvent.cancelable;
    this.defaultPrevented = nativeEvent.defaultPrevented;
    this.eventPhase = nativeEvent.eventPhase;
    this.isTrusted = nativeEvent.isTrusted;
    this.timeStamp = nativeEvent.timeStamp;
    this.type = type;
  }
}
function $8a9cb279dc87e130$export$715c682d09d639cc(onBlur) {
  let stateRef = useRef({
    isFocused: false,
    observer: null
  });
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    const state = stateRef.current;
    return () => {
      if (state.observer) {
        state.observer.disconnect();
        state.observer = null;
      }
    };
  }, []);
  let dispatchBlur = $8ae05eaa5c114e9c$export$7f54fc3180508a52((e3) => {
    onBlur === null || onBlur === void 0 ? void 0 : onBlur(e3);
  });
  return useCallback((e3) => {
    if (e3.target instanceof HTMLButtonElement || e3.target instanceof HTMLInputElement || e3.target instanceof HTMLTextAreaElement || e3.target instanceof HTMLSelectElement) {
      stateRef.current.isFocused = true;
      let target = e3.target;
      let onBlurHandler = (e4) => {
        stateRef.current.isFocused = false;
        if (target.disabled)
          dispatchBlur(new $8a9cb279dc87e130$export$905e7fc544a71f36("blur", e4));
        if (stateRef.current.observer) {
          stateRef.current.observer.disconnect();
          stateRef.current.observer = null;
        }
      };
      target.addEventListener("focusout", onBlurHandler, {
        once: true
      });
      stateRef.current.observer = new MutationObserver(() => {
        if (stateRef.current.isFocused && target.disabled) {
          var _stateRef_current_observer;
          (_stateRef_current_observer = stateRef.current.observer) === null || _stateRef_current_observer === void 0 ? void 0 : _stateRef_current_observer.disconnect();
          let relatedTargetEl = target === document.activeElement ? null : document.activeElement;
          target.dispatchEvent(new FocusEvent("blur", {
            relatedTarget: relatedTargetEl
          }));
          target.dispatchEvent(new FocusEvent("focusout", {
            bubbles: true,
            relatedTarget: relatedTargetEl
          }));
        }
      });
      stateRef.current.observer.observe(target, {
        attributes: true,
        attributeFilter: [
          "disabled"
        ]
      });
    }
  }, [
    dispatchBlur
  ]);
}
let $8a9cb279dc87e130$export$fda7da73ab5d4c48 = false;
function $8a9cb279dc87e130$export$cabe61c495ee3649(target) {
  while (target && !$b4b717babfbb907b$export$4c063cf1350e6fed(target)) target = target.parentElement;
  let window2 = $431fbd86ca7dc216$export$f21a1ffae260145a(target);
  let activeElement = window2.document.activeElement;
  if (!activeElement || activeElement === target) return;
  $8a9cb279dc87e130$export$fda7da73ab5d4c48 = true;
  let isRefocusing = false;
  let onBlur = (e3) => {
    if (e3.target === activeElement || isRefocusing) e3.stopImmediatePropagation();
  };
  let onFocusOut = (e3) => {
    if (e3.target === activeElement || isRefocusing) {
      e3.stopImmediatePropagation();
      if (!target && !isRefocusing) {
        isRefocusing = true;
        $7215afc6de606d6b$export$de79e2c695e052f3(activeElement);
        cleanup();
      }
    }
  };
  let onFocus = (e3) => {
    if (e3.target === target || isRefocusing) e3.stopImmediatePropagation();
  };
  let onFocusIn = (e3) => {
    if (e3.target === target || isRefocusing) {
      e3.stopImmediatePropagation();
      if (!isRefocusing) {
        isRefocusing = true;
        $7215afc6de606d6b$export$de79e2c695e052f3(activeElement);
        cleanup();
      }
    }
  };
  window2.addEventListener("blur", onBlur, true);
  window2.addEventListener("focusout", onFocusOut, true);
  window2.addEventListener("focusin", onFocusIn, true);
  window2.addEventListener("focus", onFocus, true);
  let cleanup = () => {
    cancelAnimationFrame(raf);
    window2.removeEventListener("blur", onBlur, true);
    window2.removeEventListener("focusout", onFocusOut, true);
    window2.removeEventListener("focusin", onFocusIn, true);
    window2.removeEventListener("focus", onFocus, true);
    $8a9cb279dc87e130$export$fda7da73ab5d4c48 = false;
    isRefocusing = false;
  };
  let raf = requestAnimationFrame(cleanup);
  return cleanup;
}
function _class_apply_descriptor_get(receiver, descriptor) {
  if (descriptor.get) return descriptor.get.call(receiver);
  return descriptor.value;
}
function _class_extract_field_descriptor(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
  return privateMap.get(receiver);
}
function _class_private_field_get(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor(receiver, privateMap, "get");
  return _class_apply_descriptor_get(receiver, descriptor);
}
function _check_private_redeclaration(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _class_private_field_init(obj, privateMap, value) {
  _check_private_redeclaration(obj, privateMap);
  privateMap.set(obj, value);
}
function _class_apply_descriptor_set(receiver, descriptor, value) {
  if (descriptor.set) descriptor.set.call(receiver, value);
  else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _class_private_field_set(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor(receiver, privateMap, "set");
  _class_apply_descriptor_set(receiver, descriptor, value);
  return value;
}
function $f6c31cce2adf654f$var$usePressResponderContext(props) {
  let context = useContext($ae1eeba8b9eafd08$export$5165eccb35aaadb5);
  if (context) {
    let { register, ...contextProps } = context;
    props = $3ef42575df84b30b$export$9d1611c77c2fe928(contextProps, props);
    register();
  }
  $e7801be82b4b2a53$export$4debdb1a3f0fa79e(context, props.ref);
  return props;
}
var $f6c31cce2adf654f$var$_shouldStopPropagation = /* @__PURE__ */ new WeakMap();
class $f6c31cce2adf654f$var$PressEvent {
  continuePropagation() {
    _class_private_field_set(this, $f6c31cce2adf654f$var$_shouldStopPropagation, false);
  }
  get shouldStopPropagation() {
    return _class_private_field_get(this, $f6c31cce2adf654f$var$_shouldStopPropagation);
  }
  constructor(type, pointerType, originalEvent, state) {
    _class_private_field_init(this, $f6c31cce2adf654f$var$_shouldStopPropagation, {
      writable: true,
      value: void 0
    });
    _class_private_field_set(this, $f6c31cce2adf654f$var$_shouldStopPropagation, true);
    var _state_target;
    let currentTarget = (_state_target = state === null || state === void 0 ? void 0 : state.target) !== null && _state_target !== void 0 ? _state_target : originalEvent.currentTarget;
    const rect = currentTarget === null || currentTarget === void 0 ? void 0 : currentTarget.getBoundingClientRect();
    let x3, y4 = 0;
    let clientX, clientY = null;
    if (originalEvent.clientX != null && originalEvent.clientY != null) {
      clientX = originalEvent.clientX;
      clientY = originalEvent.clientY;
    }
    if (rect) {
      if (clientX != null && clientY != null) {
        x3 = clientX - rect.left;
        y4 = clientY - rect.top;
      } else {
        x3 = rect.width / 2;
        y4 = rect.height / 2;
      }
    }
    this.type = type;
    this.pointerType = pointerType;
    this.target = originalEvent.currentTarget;
    this.shiftKey = originalEvent.shiftKey;
    this.metaKey = originalEvent.metaKey;
    this.ctrlKey = originalEvent.ctrlKey;
    this.altKey = originalEvent.altKey;
    this.x = x3;
    this.y = y4;
  }
}
const $f6c31cce2adf654f$var$LINK_CLICKED = Symbol("linkClicked");
function $f6c31cce2adf654f$export$45712eceda6fad21(props) {
  let {
    onPress,
    onPressChange,
    onPressStart,
    onPressEnd,
    onPressUp,
    isDisabled,
    isPressed: isPressedProp,
    preventFocusOnPress,
    shouldCancelOnPointerExit,
    allowTextSelectionOnPress,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ref: _,
    ...domProps
  } = $f6c31cce2adf654f$var$usePressResponderContext(props);
  let [isPressed, setPressed] = useState(false);
  let ref = useRef({
    isPressed: false,
    ignoreEmulatedMouseEvents: false,
    didFirePressStart: false,
    isTriggeringEvent: false,
    activePointerId: null,
    target: null,
    isOverTarget: false,
    pointerType: null,
    disposables: []
  });
  let { addGlobalListener, removeAllGlobalListeners } = $03deb23ff14920c4$export$4eaf04e54aa8eed6();
  let triggerPressStart = $8ae05eaa5c114e9c$export$7f54fc3180508a52((originalEvent, pointerType) => {
    let state = ref.current;
    if (isDisabled || state.didFirePressStart) return false;
    let shouldStopPropagation = true;
    state.isTriggeringEvent = true;
    if (onPressStart) {
      let event = new $f6c31cce2adf654f$var$PressEvent("pressstart", pointerType, originalEvent);
      onPressStart(event);
      shouldStopPropagation = event.shouldStopPropagation;
    }
    if (onPressChange) onPressChange(true);
    state.isTriggeringEvent = false;
    state.didFirePressStart = true;
    setPressed(true);
    return shouldStopPropagation;
  });
  let triggerPressEnd = $8ae05eaa5c114e9c$export$7f54fc3180508a52((originalEvent, pointerType, wasPressed = true) => {
    let state = ref.current;
    if (!state.didFirePressStart) return false;
    state.didFirePressStart = false;
    state.isTriggeringEvent = true;
    let shouldStopPropagation = true;
    if (onPressEnd) {
      let event = new $f6c31cce2adf654f$var$PressEvent("pressend", pointerType, originalEvent);
      onPressEnd(event);
      shouldStopPropagation = event.shouldStopPropagation;
    }
    if (onPressChange) onPressChange(false);
    setPressed(false);
    if (onPress && wasPressed && !isDisabled) {
      let event = new $f6c31cce2adf654f$var$PressEvent("press", pointerType, originalEvent);
      onPress(event);
      shouldStopPropagation && (shouldStopPropagation = event.shouldStopPropagation);
    }
    state.isTriggeringEvent = false;
    return shouldStopPropagation;
  });
  let triggerPressUp = $8ae05eaa5c114e9c$export$7f54fc3180508a52((originalEvent, pointerType) => {
    let state = ref.current;
    if (isDisabled) return false;
    if (onPressUp) {
      state.isTriggeringEvent = true;
      let event = new $f6c31cce2adf654f$var$PressEvent("pressup", pointerType, originalEvent);
      onPressUp(event);
      state.isTriggeringEvent = false;
      return event.shouldStopPropagation;
    }
    return true;
  });
  let cancel = $8ae05eaa5c114e9c$export$7f54fc3180508a52((e3) => {
    let state = ref.current;
    if (state.isPressed && state.target) {
      if (state.didFirePressStart && state.pointerType != null) triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e3), state.pointerType, false);
      state.isPressed = false;
      state.isOverTarget = false;
      state.activePointerId = null;
      state.pointerType = null;
      removeAllGlobalListeners();
      if (!allowTextSelectionOnPress) $14c0b72509d70225$export$b0d6fa1ab32e3295(state.target);
      for (let dispose of state.disposables) dispose();
      state.disposables = [];
    }
  });
  let cancelOnPointerExit = $8ae05eaa5c114e9c$export$7f54fc3180508a52((e3) => {
    if (shouldCancelOnPointerExit) cancel(e3);
  });
  let pressProps = useMemo(() => {
    let state = ref.current;
    let pressProps2 = {
      onKeyDown(e3) {
        if ($f6c31cce2adf654f$var$isValidKeyboardEvent(e3.nativeEvent, e3.currentTarget) && $d4ee10de306f2510$export$4282f70798064fe0(e3.currentTarget, $d4ee10de306f2510$export$e58f029f0fbfdb29(e3.nativeEvent))) {
          var _state_metaKeyEvents;
          if ($f6c31cce2adf654f$var$shouldPreventDefaultKeyboard($d4ee10de306f2510$export$e58f029f0fbfdb29(e3.nativeEvent), e3.key)) e3.preventDefault();
          let shouldStopPropagation = true;
          if (!state.isPressed && !e3.repeat) {
            state.target = e3.currentTarget;
            state.isPressed = true;
            state.pointerType = "keyboard";
            shouldStopPropagation = triggerPressStart(e3, "keyboard");
            let originalTarget = e3.currentTarget;
            let pressUp = (e4) => {
              if ($f6c31cce2adf654f$var$isValidKeyboardEvent(e4, originalTarget) && !e4.repeat && $d4ee10de306f2510$export$4282f70798064fe0(originalTarget, $d4ee10de306f2510$export$e58f029f0fbfdb29(e4)) && state.target) triggerPressUp($f6c31cce2adf654f$var$createEvent(state.target, e4), "keyboard");
            };
            addGlobalListener($431fbd86ca7dc216$export$b204af158042fbac(e3.currentTarget), "keyup", $ff5963eb1fccf552$export$e08e3b67e392101e(pressUp, onKeyUp), true);
          }
          if (shouldStopPropagation) e3.stopPropagation();
          if (e3.metaKey && $c87311424ea30a05$export$9ac100e40613ea10()) (_state_metaKeyEvents = state.metaKeyEvents) === null || _state_metaKeyEvents === void 0 ? void 0 : _state_metaKeyEvents.set(e3.key, e3.nativeEvent);
        } else if (e3.key === "Meta") state.metaKeyEvents = /* @__PURE__ */ new Map();
      },
      onClick(e3) {
        if (e3 && !$d4ee10de306f2510$export$4282f70798064fe0(e3.currentTarget, $d4ee10de306f2510$export$e58f029f0fbfdb29(e3.nativeEvent))) return;
        if (e3 && e3.button === 0 && !state.isTriggeringEvent && !$ea8dcbcb9ea1b556$export$95185d699e05d4d7.isOpening) {
          let shouldStopPropagation = true;
          if (isDisabled) e3.preventDefault();
          if (!state.ignoreEmulatedMouseEvents && !state.isPressed && (state.pointerType === "virtual" || $6a7db85432448f7f$export$60278871457622de(e3.nativeEvent))) {
            let stopPressStart = triggerPressStart(e3, "virtual");
            let stopPressUp = triggerPressUp(e3, "virtual");
            let stopPressEnd = triggerPressEnd(e3, "virtual");
            shouldStopPropagation = stopPressStart && stopPressUp && stopPressEnd;
          } else if (state.isPressed && state.pointerType !== "keyboard") {
            let pointerType = state.pointerType || e3.nativeEvent.pointerType || "virtual";
            shouldStopPropagation = triggerPressEnd($f6c31cce2adf654f$var$createEvent(e3.currentTarget, e3), pointerType, true);
            state.isOverTarget = false;
            cancel(e3);
          }
          state.ignoreEmulatedMouseEvents = false;
          if (shouldStopPropagation) e3.stopPropagation();
        }
      }
    };
    let onKeyUp = (e3) => {
      var _state_metaKeyEvents;
      if (state.isPressed && state.target && $f6c31cce2adf654f$var$isValidKeyboardEvent(e3, state.target)) {
        var _state_metaKeyEvents1;
        if ($f6c31cce2adf654f$var$shouldPreventDefaultKeyboard($d4ee10de306f2510$export$e58f029f0fbfdb29(e3), e3.key)) e3.preventDefault();
        let target = $d4ee10de306f2510$export$e58f029f0fbfdb29(e3);
        triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e3), "keyboard", $d4ee10de306f2510$export$4282f70798064fe0(state.target, $d4ee10de306f2510$export$e58f029f0fbfdb29(e3)));
        removeAllGlobalListeners();
        if (e3.key !== "Enter" && $f6c31cce2adf654f$var$isHTMLAnchorLink(state.target) && $d4ee10de306f2510$export$4282f70798064fe0(state.target, target) && !e3[$f6c31cce2adf654f$var$LINK_CLICKED]) {
          e3[$f6c31cce2adf654f$var$LINK_CLICKED] = true;
          $ea8dcbcb9ea1b556$export$95185d699e05d4d7(state.target, e3, false);
        }
        state.isPressed = false;
        (_state_metaKeyEvents1 = state.metaKeyEvents) === null || _state_metaKeyEvents1 === void 0 ? void 0 : _state_metaKeyEvents1.delete(e3.key);
      } else if (e3.key === "Meta" && ((_state_metaKeyEvents = state.metaKeyEvents) === null || _state_metaKeyEvents === void 0 ? void 0 : _state_metaKeyEvents.size)) {
        var _state_target;
        let events2 = state.metaKeyEvents;
        state.metaKeyEvents = void 0;
        for (let event of events2.values()) (_state_target = state.target) === null || _state_target === void 0 ? void 0 : _state_target.dispatchEvent(new KeyboardEvent("keyup", event));
      }
    };
    if (typeof PointerEvent !== "undefined") {
      pressProps2.onPointerDown = (e3) => {
        if (e3.button !== 0 || !$d4ee10de306f2510$export$4282f70798064fe0(e3.currentTarget, $d4ee10de306f2510$export$e58f029f0fbfdb29(e3.nativeEvent))) return;
        if ($6a7db85432448f7f$export$29bf1b5f2c56cf63(e3.nativeEvent)) {
          state.pointerType = "virtual";
          return;
        }
        state.pointerType = e3.pointerType;
        let shouldStopPropagation = true;
        if (!state.isPressed) {
          state.isPressed = true;
          state.isOverTarget = true;
          state.activePointerId = e3.pointerId;
          state.target = e3.currentTarget;
          if (!allowTextSelectionOnPress) $14c0b72509d70225$export$16a4697467175487(state.target);
          shouldStopPropagation = triggerPressStart(e3, state.pointerType);
          let target = $d4ee10de306f2510$export$e58f029f0fbfdb29(e3.nativeEvent);
          if ("releasePointerCapture" in target) target.releasePointerCapture(e3.pointerId);
          addGlobalListener($431fbd86ca7dc216$export$b204af158042fbac(e3.currentTarget), "pointerup", onPointerUp, false);
          addGlobalListener($431fbd86ca7dc216$export$b204af158042fbac(e3.currentTarget), "pointercancel", onPointerCancel, false);
        }
        if (shouldStopPropagation) e3.stopPropagation();
      };
      pressProps2.onMouseDown = (e3) => {
        if (!$d4ee10de306f2510$export$4282f70798064fe0(e3.currentTarget, $d4ee10de306f2510$export$e58f029f0fbfdb29(e3.nativeEvent))) return;
        if (e3.button === 0) {
          if (preventFocusOnPress) {
            let dispose = $8a9cb279dc87e130$export$cabe61c495ee3649(e3.target);
            if (dispose) state.disposables.push(dispose);
          }
          e3.stopPropagation();
        }
      };
      pressProps2.onPointerUp = (e3) => {
        if (!$d4ee10de306f2510$export$4282f70798064fe0(e3.currentTarget, $d4ee10de306f2510$export$e58f029f0fbfdb29(e3.nativeEvent)) || state.pointerType === "virtual") return;
        if (e3.button === 0) triggerPressUp(e3, state.pointerType || e3.pointerType);
      };
      pressProps2.onPointerEnter = (e3) => {
        if (e3.pointerId === state.activePointerId && state.target && !state.isOverTarget && state.pointerType != null) {
          state.isOverTarget = true;
          triggerPressStart($f6c31cce2adf654f$var$createEvent(state.target, e3), state.pointerType);
        }
      };
      pressProps2.onPointerLeave = (e3) => {
        if (e3.pointerId === state.activePointerId && state.target && state.isOverTarget && state.pointerType != null) {
          state.isOverTarget = false;
          triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e3), state.pointerType, false);
          cancelOnPointerExit(e3);
        }
      };
      let onPointerUp = (e3) => {
        if (e3.pointerId === state.activePointerId && state.isPressed && e3.button === 0 && state.target) {
          if ($d4ee10de306f2510$export$4282f70798064fe0(state.target, $d4ee10de306f2510$export$e58f029f0fbfdb29(e3)) && state.pointerType != null) {
            let clicked = false;
            let timeout = setTimeout(() => {
              if (state.isPressed && state.target instanceof HTMLElement) {
                if (clicked) cancel(e3);
                else {
                  $7215afc6de606d6b$export$de79e2c695e052f3(state.target);
                  state.target.click();
                }
              }
            }, 80);
            addGlobalListener(e3.currentTarget, "click", () => clicked = true, true);
            state.disposables.push(() => clearTimeout(timeout));
          } else cancel(e3);
          state.isOverTarget = false;
        }
      };
      let onPointerCancel = (e3) => {
        cancel(e3);
      };
      pressProps2.onDragStart = (e3) => {
        if (!$d4ee10de306f2510$export$4282f70798064fe0(e3.currentTarget, $d4ee10de306f2510$export$e58f029f0fbfdb29(e3.nativeEvent))) return;
        cancel(e3);
      };
    } else {
      pressProps2.onMouseDown = (e3) => {
        if (e3.button !== 0 || !$d4ee10de306f2510$export$4282f70798064fe0(e3.currentTarget, $d4ee10de306f2510$export$e58f029f0fbfdb29(e3.nativeEvent))) return;
        if (state.ignoreEmulatedMouseEvents) {
          e3.stopPropagation();
          return;
        }
        state.isPressed = true;
        state.isOverTarget = true;
        state.target = e3.currentTarget;
        state.pointerType = $6a7db85432448f7f$export$60278871457622de(e3.nativeEvent) ? "virtual" : "mouse";
        let shouldStopPropagation = flushSync$1(() => triggerPressStart(e3, state.pointerType));
        if (shouldStopPropagation) e3.stopPropagation();
        if (preventFocusOnPress) {
          let dispose = $8a9cb279dc87e130$export$cabe61c495ee3649(e3.target);
          if (dispose) state.disposables.push(dispose);
        }
        addGlobalListener($431fbd86ca7dc216$export$b204af158042fbac(e3.currentTarget), "mouseup", onMouseUp, false);
      };
      pressProps2.onMouseEnter = (e3) => {
        if (!$d4ee10de306f2510$export$4282f70798064fe0(e3.currentTarget, $d4ee10de306f2510$export$e58f029f0fbfdb29(e3.nativeEvent))) return;
        let shouldStopPropagation = true;
        if (state.isPressed && !state.ignoreEmulatedMouseEvents && state.pointerType != null) {
          state.isOverTarget = true;
          shouldStopPropagation = triggerPressStart(e3, state.pointerType);
        }
        if (shouldStopPropagation) e3.stopPropagation();
      };
      pressProps2.onMouseLeave = (e3) => {
        if (!$d4ee10de306f2510$export$4282f70798064fe0(e3.currentTarget, $d4ee10de306f2510$export$e58f029f0fbfdb29(e3.nativeEvent))) return;
        let shouldStopPropagation = true;
        if (state.isPressed && !state.ignoreEmulatedMouseEvents && state.pointerType != null) {
          state.isOverTarget = false;
          shouldStopPropagation = triggerPressEnd(e3, state.pointerType, false);
          cancelOnPointerExit(e3);
        }
        if (shouldStopPropagation) e3.stopPropagation();
      };
      pressProps2.onMouseUp = (e3) => {
        if (!$d4ee10de306f2510$export$4282f70798064fe0(e3.currentTarget, $d4ee10de306f2510$export$e58f029f0fbfdb29(e3.nativeEvent))) return;
        if (!state.ignoreEmulatedMouseEvents && e3.button === 0) triggerPressUp(e3, state.pointerType || "mouse");
      };
      let onMouseUp = (e3) => {
        if (e3.button !== 0) return;
        if (state.ignoreEmulatedMouseEvents) {
          state.ignoreEmulatedMouseEvents = false;
          return;
        }
        if (state.target && state.target.contains(e3.target) && state.pointerType != null) ;
        else cancel(e3);
        state.isOverTarget = false;
      };
      pressProps2.onTouchStart = (e3) => {
        if (!$d4ee10de306f2510$export$4282f70798064fe0(e3.currentTarget, $d4ee10de306f2510$export$e58f029f0fbfdb29(e3.nativeEvent))) return;
        let touch = $f6c31cce2adf654f$var$getTouchFromEvent(e3.nativeEvent);
        if (!touch) return;
        state.activePointerId = touch.identifier;
        state.ignoreEmulatedMouseEvents = true;
        state.isOverTarget = true;
        state.isPressed = true;
        state.target = e3.currentTarget;
        state.pointerType = "touch";
        if (!allowTextSelectionOnPress) $14c0b72509d70225$export$16a4697467175487(state.target);
        let shouldStopPropagation = triggerPressStart($f6c31cce2adf654f$var$createTouchEvent(state.target, e3), state.pointerType);
        if (shouldStopPropagation) e3.stopPropagation();
        addGlobalListener($431fbd86ca7dc216$export$f21a1ffae260145a(e3.currentTarget), "scroll", onScroll, true);
      };
      pressProps2.onTouchMove = (e3) => {
        if (!$d4ee10de306f2510$export$4282f70798064fe0(e3.currentTarget, $d4ee10de306f2510$export$e58f029f0fbfdb29(e3.nativeEvent))) return;
        if (!state.isPressed) {
          e3.stopPropagation();
          return;
        }
        let touch = $f6c31cce2adf654f$var$getTouchById(e3.nativeEvent, state.activePointerId);
        let shouldStopPropagation = true;
        if (touch && $f6c31cce2adf654f$var$isOverTarget(touch, e3.currentTarget)) {
          if (!state.isOverTarget && state.pointerType != null) {
            state.isOverTarget = true;
            shouldStopPropagation = triggerPressStart($f6c31cce2adf654f$var$createTouchEvent(state.target, e3), state.pointerType);
          }
        } else if (state.isOverTarget && state.pointerType != null) {
          state.isOverTarget = false;
          shouldStopPropagation = triggerPressEnd($f6c31cce2adf654f$var$createTouchEvent(state.target, e3), state.pointerType, false);
          cancelOnPointerExit($f6c31cce2adf654f$var$createTouchEvent(state.target, e3));
        }
        if (shouldStopPropagation) e3.stopPropagation();
      };
      pressProps2.onTouchEnd = (e3) => {
        if (!$d4ee10de306f2510$export$4282f70798064fe0(e3.currentTarget, $d4ee10de306f2510$export$e58f029f0fbfdb29(e3.nativeEvent))) return;
        if (!state.isPressed) {
          e3.stopPropagation();
          return;
        }
        let touch = $f6c31cce2adf654f$var$getTouchById(e3.nativeEvent, state.activePointerId);
        let shouldStopPropagation = true;
        if (touch && $f6c31cce2adf654f$var$isOverTarget(touch, e3.currentTarget) && state.pointerType != null) {
          triggerPressUp($f6c31cce2adf654f$var$createTouchEvent(state.target, e3), state.pointerType);
          shouldStopPropagation = triggerPressEnd($f6c31cce2adf654f$var$createTouchEvent(state.target, e3), state.pointerType);
        } else if (state.isOverTarget && state.pointerType != null) shouldStopPropagation = triggerPressEnd($f6c31cce2adf654f$var$createTouchEvent(state.target, e3), state.pointerType, false);
        if (shouldStopPropagation) e3.stopPropagation();
        state.isPressed = false;
        state.activePointerId = null;
        state.isOverTarget = false;
        state.ignoreEmulatedMouseEvents = true;
        if (state.target && !allowTextSelectionOnPress) $14c0b72509d70225$export$b0d6fa1ab32e3295(state.target);
        removeAllGlobalListeners();
      };
      pressProps2.onTouchCancel = (e3) => {
        if (!$d4ee10de306f2510$export$4282f70798064fe0(e3.currentTarget, $d4ee10de306f2510$export$e58f029f0fbfdb29(e3.nativeEvent))) return;
        e3.stopPropagation();
        if (state.isPressed) cancel($f6c31cce2adf654f$var$createTouchEvent(state.target, e3));
      };
      let onScroll = (e3) => {
        if (state.isPressed && $d4ee10de306f2510$export$4282f70798064fe0($d4ee10de306f2510$export$e58f029f0fbfdb29(e3), state.target)) cancel({
          currentTarget: state.target,
          shiftKey: false,
          ctrlKey: false,
          metaKey: false,
          altKey: false
        });
      };
      pressProps2.onDragStart = (e3) => {
        if (!$d4ee10de306f2510$export$4282f70798064fe0(e3.currentTarget, $d4ee10de306f2510$export$e58f029f0fbfdb29(e3.nativeEvent))) return;
        cancel(e3);
      };
    }
    return pressProps2;
  }, [
    addGlobalListener,
    isDisabled,
    preventFocusOnPress,
    removeAllGlobalListeners,
    allowTextSelectionOnPress,
    cancel,
    cancelOnPointerExit,
    triggerPressEnd,
    triggerPressStart,
    triggerPressUp
  ]);
  useEffect(() => {
    let state = ref.current;
    return () => {
      var _state_target;
      if (!allowTextSelectionOnPress) $14c0b72509d70225$export$b0d6fa1ab32e3295((_state_target = state.target) !== null && _state_target !== void 0 ? _state_target : void 0);
      for (let dispose of state.disposables) dispose();
      state.disposables = [];
    };
  }, [
    allowTextSelectionOnPress
  ]);
  return {
    isPressed: isPressedProp || isPressed,
    pressProps: $3ef42575df84b30b$export$9d1611c77c2fe928(domProps, pressProps)
  };
}
function $f6c31cce2adf654f$var$isHTMLAnchorLink(target) {
  return target.tagName === "A" && target.hasAttribute("href");
}
function $f6c31cce2adf654f$var$isValidKeyboardEvent(event, currentTarget) {
  const { key, code } = event;
  const element = currentTarget;
  const role = element.getAttribute("role");
  return (key === "Enter" || key === " " || key === "Spacebar" || code === "Space") && !(element instanceof $431fbd86ca7dc216$export$f21a1ffae260145a(element).HTMLInputElement && !$f6c31cce2adf654f$var$isValidInputKey(element, key) || element instanceof $431fbd86ca7dc216$export$f21a1ffae260145a(element).HTMLTextAreaElement || element.isContentEditable) && // Links should only trigger with Enter key
  !((role === "link" || !role && $f6c31cce2adf654f$var$isHTMLAnchorLink(element)) && key !== "Enter");
}
function $f6c31cce2adf654f$var$getTouchFromEvent(event) {
  const { targetTouches } = event;
  if (targetTouches.length > 0) return targetTouches[0];
  return null;
}
function $f6c31cce2adf654f$var$getTouchById(event, pointerId) {
  const changedTouches = event.changedTouches;
  for (let i3 = 0; i3 < changedTouches.length; i3++) {
    const touch = changedTouches[i3];
    if (touch.identifier === pointerId) return touch;
  }
  return null;
}
function $f6c31cce2adf654f$var$createTouchEvent(target, e3) {
  let clientX = 0;
  let clientY = 0;
  if (e3.targetTouches && e3.targetTouches.length === 1) {
    clientX = e3.targetTouches[0].clientX;
    clientY = e3.targetTouches[0].clientY;
  }
  return {
    currentTarget: target,
    shiftKey: e3.shiftKey,
    ctrlKey: e3.ctrlKey,
    metaKey: e3.metaKey,
    altKey: e3.altKey,
    clientX,
    clientY
  };
}
function $f6c31cce2adf654f$var$createEvent(target, e3) {
  let clientX = e3.clientX;
  let clientY = e3.clientY;
  return {
    currentTarget: target,
    shiftKey: e3.shiftKey,
    ctrlKey: e3.ctrlKey,
    metaKey: e3.metaKey,
    altKey: e3.altKey,
    clientX,
    clientY
  };
}
function $f6c31cce2adf654f$var$getPointClientRect(point2) {
  let offsetX = 0;
  let offsetY = 0;
  if (point2.width !== void 0) offsetX = point2.width / 2;
  else if (point2.radiusX !== void 0) offsetX = point2.radiusX;
  if (point2.height !== void 0) offsetY = point2.height / 2;
  else if (point2.radiusY !== void 0) offsetY = point2.radiusY;
  return {
    top: point2.clientY - offsetY,
    right: point2.clientX + offsetX,
    bottom: point2.clientY + offsetY,
    left: point2.clientX - offsetX
  };
}
function $f6c31cce2adf654f$var$areRectanglesOverlapping(a4, b3) {
  if (a4.left > b3.right || b3.left > a4.right) return false;
  if (a4.top > b3.bottom || b3.top > a4.bottom) return false;
  return true;
}
function $f6c31cce2adf654f$var$isOverTarget(point2, target) {
  let rect = target.getBoundingClientRect();
  let pointRect = $f6c31cce2adf654f$var$getPointClientRect(point2);
  return $f6c31cce2adf654f$var$areRectanglesOverlapping(rect, pointRect);
}
function $f6c31cce2adf654f$var$shouldPreventDefaultUp(target) {
  if (target instanceof HTMLInputElement) return false;
  if (target instanceof HTMLButtonElement) return target.type !== "submit" && target.type !== "reset";
  if ($f6c31cce2adf654f$var$isHTMLAnchorLink(target)) return false;
  return true;
}
function $f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(target, key) {
  if (target instanceof HTMLInputElement) return !$f6c31cce2adf654f$var$isValidInputKey(target, key);
  return $f6c31cce2adf654f$var$shouldPreventDefaultUp(target);
}
const $f6c31cce2adf654f$var$nonTextInputTypes = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function $f6c31cce2adf654f$var$isValidInputKey(target, key) {
  return target.type === "checkbox" || target.type === "radio" ? key === " " : $f6c31cce2adf654f$var$nonTextInputTypes.has(target.type);
}
let $507fabe10e71c6fb$var$currentModality = null;
let $507fabe10e71c6fb$var$changeHandlers = /* @__PURE__ */ new Set();
let $507fabe10e71c6fb$export$d90243b58daecda7 = /* @__PURE__ */ new Map();
let $507fabe10e71c6fb$var$hasEventBeforeFocus = false;
let $507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
const $507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS = {
  Tab: true,
  Escape: true
};
function $507fabe10e71c6fb$var$triggerChangeHandlers(modality, e3) {
  for (let handler of $507fabe10e71c6fb$var$changeHandlers) handler(modality, e3);
}
function $507fabe10e71c6fb$var$isValidKey(e3) {
  return !(e3.metaKey || !$c87311424ea30a05$export$9ac100e40613ea10() && e3.altKey || e3.ctrlKey || e3.key === "Control" || e3.key === "Shift" || e3.key === "Meta");
}
function $507fabe10e71c6fb$var$handleKeyboardEvent(e3) {
  $507fabe10e71c6fb$var$hasEventBeforeFocus = true;
  if ($507fabe10e71c6fb$var$isValidKey(e3)) {
    $507fabe10e71c6fb$var$currentModality = "keyboard";
    $507fabe10e71c6fb$var$triggerChangeHandlers("keyboard", e3);
  }
}
function $507fabe10e71c6fb$var$handlePointerEvent(e3) {
  $507fabe10e71c6fb$var$currentModality = "pointer";
  if (e3.type === "mousedown" || e3.type === "pointerdown") {
    $507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    $507fabe10e71c6fb$var$triggerChangeHandlers("pointer", e3);
  }
}
function $507fabe10e71c6fb$var$handleClickEvent(e3) {
  if ($6a7db85432448f7f$export$60278871457622de(e3)) {
    $507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    $507fabe10e71c6fb$var$currentModality = "virtual";
  }
}
function $507fabe10e71c6fb$var$handleFocusEvent(e3) {
  if (e3.target === window || e3.target === document || $8a9cb279dc87e130$export$fda7da73ab5d4c48 || !e3.isTrusted) return;
  if (!$507fabe10e71c6fb$var$hasEventBeforeFocus && !$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
    $507fabe10e71c6fb$var$currentModality = "virtual";
    $507fabe10e71c6fb$var$triggerChangeHandlers("virtual", e3);
  }
  $507fabe10e71c6fb$var$hasEventBeforeFocus = false;
  $507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}
function $507fabe10e71c6fb$var$handleWindowBlur() {
  if ($8a9cb279dc87e130$export$fda7da73ab5d4c48) return;
  $507fabe10e71c6fb$var$hasEventBeforeFocus = false;
  $507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}
function $507fabe10e71c6fb$var$setupGlobalFocusEvents(element) {
  if (typeof window === "undefined" || $507fabe10e71c6fb$export$d90243b58daecda7.get($431fbd86ca7dc216$export$f21a1ffae260145a(element))) return;
  const windowObject = $431fbd86ca7dc216$export$f21a1ffae260145a(element);
  const documentObject = $431fbd86ca7dc216$export$b204af158042fbac(element);
  let focus = windowObject.HTMLElement.prototype.focus;
  windowObject.HTMLElement.prototype.focus = function() {
    $507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    focus.apply(this, arguments);
  };
  documentObject.addEventListener("keydown", $507fabe10e71c6fb$var$handleKeyboardEvent, true);
  documentObject.addEventListener("keyup", $507fabe10e71c6fb$var$handleKeyboardEvent, true);
  documentObject.addEventListener("click", $507fabe10e71c6fb$var$handleClickEvent, true);
  windowObject.addEventListener("focus", $507fabe10e71c6fb$var$handleFocusEvent, true);
  windowObject.addEventListener("blur", $507fabe10e71c6fb$var$handleWindowBlur, false);
  if (typeof PointerEvent !== "undefined") {
    documentObject.addEventListener("pointerdown", $507fabe10e71c6fb$var$handlePointerEvent, true);
    documentObject.addEventListener("pointermove", $507fabe10e71c6fb$var$handlePointerEvent, true);
    documentObject.addEventListener("pointerup", $507fabe10e71c6fb$var$handlePointerEvent, true);
  } else {
    documentObject.addEventListener("mousedown", $507fabe10e71c6fb$var$handlePointerEvent, true);
    documentObject.addEventListener("mousemove", $507fabe10e71c6fb$var$handlePointerEvent, true);
    documentObject.addEventListener("mouseup", $507fabe10e71c6fb$var$handlePointerEvent, true);
  }
  windowObject.addEventListener("beforeunload", () => {
    $507fabe10e71c6fb$var$tearDownWindowFocusTracking(element);
  }, {
    once: true
  });
  $507fabe10e71c6fb$export$d90243b58daecda7.set(windowObject, {
    focus
  });
}
const $507fabe10e71c6fb$var$tearDownWindowFocusTracking = (element, loadListener) => {
  const windowObject = $431fbd86ca7dc216$export$f21a1ffae260145a(element);
  const documentObject = $431fbd86ca7dc216$export$b204af158042fbac(element);
  if (loadListener) documentObject.removeEventListener("DOMContentLoaded", loadListener);
  if (!$507fabe10e71c6fb$export$d90243b58daecda7.has(windowObject)) return;
  windowObject.HTMLElement.prototype.focus = $507fabe10e71c6fb$export$d90243b58daecda7.get(windowObject).focus;
  documentObject.removeEventListener("keydown", $507fabe10e71c6fb$var$handleKeyboardEvent, true);
  documentObject.removeEventListener("keyup", $507fabe10e71c6fb$var$handleKeyboardEvent, true);
  documentObject.removeEventListener("click", $507fabe10e71c6fb$var$handleClickEvent, true);
  windowObject.removeEventListener("focus", $507fabe10e71c6fb$var$handleFocusEvent, true);
  windowObject.removeEventListener("blur", $507fabe10e71c6fb$var$handleWindowBlur, false);
  if (typeof PointerEvent !== "undefined") {
    documentObject.removeEventListener("pointerdown", $507fabe10e71c6fb$var$handlePointerEvent, true);
    documentObject.removeEventListener("pointermove", $507fabe10e71c6fb$var$handlePointerEvent, true);
    documentObject.removeEventListener("pointerup", $507fabe10e71c6fb$var$handlePointerEvent, true);
  } else {
    documentObject.removeEventListener("mousedown", $507fabe10e71c6fb$var$handlePointerEvent, true);
    documentObject.removeEventListener("mousemove", $507fabe10e71c6fb$var$handlePointerEvent, true);
    documentObject.removeEventListener("mouseup", $507fabe10e71c6fb$var$handlePointerEvent, true);
  }
  $507fabe10e71c6fb$export$d90243b58daecda7.delete(windowObject);
};
function $507fabe10e71c6fb$export$2f1888112f558a7d(element) {
  const documentObject = $431fbd86ca7dc216$export$b204af158042fbac(element);
  let loadListener;
  if (documentObject.readyState !== "loading") $507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
  else {
    loadListener = () => {
      $507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
    };
    documentObject.addEventListener("DOMContentLoaded", loadListener);
  }
  return () => $507fabe10e71c6fb$var$tearDownWindowFocusTracking(element, loadListener);
}
if (typeof document !== "undefined") $507fabe10e71c6fb$export$2f1888112f558a7d();
function $507fabe10e71c6fb$export$b9b3dfddab17db27() {
  return $507fabe10e71c6fb$var$currentModality !== "pointer";
}
function $507fabe10e71c6fb$export$630ff653c5ada6a9() {
  return $507fabe10e71c6fb$var$currentModality;
}
function $507fabe10e71c6fb$export$8397ddfc504fdb9a(modality) {
  $507fabe10e71c6fb$var$currentModality = modality;
  $507fabe10e71c6fb$var$triggerChangeHandlers(modality, null);
}
const $507fabe10e71c6fb$var$nonTextInputTypes = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function $507fabe10e71c6fb$var$isKeyboardFocusEvent(isTextInput, modality, e3) {
  let document1 = $431fbd86ca7dc216$export$b204af158042fbac(e3 === null || e3 === void 0 ? void 0 : e3.target);
  const IHTMLInputElement = typeof window !== "undefined" ? $431fbd86ca7dc216$export$f21a1ffae260145a(e3 === null || e3 === void 0 ? void 0 : e3.target).HTMLInputElement : HTMLInputElement;
  const IHTMLTextAreaElement = typeof window !== "undefined" ? $431fbd86ca7dc216$export$f21a1ffae260145a(e3 === null || e3 === void 0 ? void 0 : e3.target).HTMLTextAreaElement : HTMLTextAreaElement;
  const IHTMLElement = typeof window !== "undefined" ? $431fbd86ca7dc216$export$f21a1ffae260145a(e3 === null || e3 === void 0 ? void 0 : e3.target).HTMLElement : HTMLElement;
  const IKeyboardEvent = typeof window !== "undefined" ? $431fbd86ca7dc216$export$f21a1ffae260145a(e3 === null || e3 === void 0 ? void 0 : e3.target).KeyboardEvent : KeyboardEvent;
  isTextInput = isTextInput || document1.activeElement instanceof IHTMLInputElement && !$507fabe10e71c6fb$var$nonTextInputTypes.has(document1.activeElement.type) || document1.activeElement instanceof IHTMLTextAreaElement || document1.activeElement instanceof IHTMLElement && document1.activeElement.isContentEditable;
  return !(isTextInput && modality === "keyboard" && e3 instanceof IKeyboardEvent && !$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS[e3.key]);
}
function $507fabe10e71c6fb$export$ec71b4b83ac08ec3(fn, deps, opts) {
  $507fabe10e71c6fb$var$setupGlobalFocusEvents();
  useEffect(() => {
    let handler = (modality, e3) => {
      if (!$507fabe10e71c6fb$var$isKeyboardFocusEvent(!!(opts === null || opts === void 0 ? void 0 : opts.isTextInput), modality, e3)) return;
      fn($507fabe10e71c6fb$export$b9b3dfddab17db27());
    };
    $507fabe10e71c6fb$var$changeHandlers.add(handler);
    return () => {
      $507fabe10e71c6fb$var$changeHandlers.delete(handler);
    };
  }, deps);
}
function $3ad3f6e1647bc98d$export$80f3e147d781571c(element) {
  const ownerDocument = $431fbd86ca7dc216$export$b204af158042fbac(element);
  const activeElement = $d4ee10de306f2510$export$cd4e5573fbe2b576(ownerDocument);
  if ($507fabe10e71c6fb$export$630ff653c5ada6a9() === "virtual") {
    let lastFocusedElement = activeElement;
    $bbed8b41f857bcc0$export$24490316f764c430(() => {
      if ($d4ee10de306f2510$export$cd4e5573fbe2b576(ownerDocument) === lastFocusedElement && element.isConnected) $7215afc6de606d6b$export$de79e2c695e052f3(element);
    });
  } else $7215afc6de606d6b$export$de79e2c695e052f3(element);
}
function $a1ea59d68270f0dd$export$f8168d8dd8fd66e6(props) {
  let { isDisabled, onFocus: onFocusProp, onBlur: onBlurProp, onFocusChange } = props;
  const onBlur = useCallback((e3) => {
    if (e3.target === e3.currentTarget) {
      if (onBlurProp) onBlurProp(e3);
      if (onFocusChange) onFocusChange(false);
      return true;
    }
  }, [
    onBlurProp,
    onFocusChange
  ]);
  const onSyntheticFocus = $8a9cb279dc87e130$export$715c682d09d639cc(onBlur);
  const onFocus = useCallback((e3) => {
    const ownerDocument = $431fbd86ca7dc216$export$b204af158042fbac(e3.target);
    const activeElement = ownerDocument ? $d4ee10de306f2510$export$cd4e5573fbe2b576(ownerDocument) : $d4ee10de306f2510$export$cd4e5573fbe2b576();
    if (e3.target === e3.currentTarget && activeElement === $d4ee10de306f2510$export$e58f029f0fbfdb29(e3.nativeEvent)) {
      if (onFocusProp) onFocusProp(e3);
      if (onFocusChange) onFocusChange(true);
      onSyntheticFocus(e3);
    }
  }, [
    onFocusChange,
    onFocusProp,
    onSyntheticFocus
  ]);
  return {
    focusProps: {
      onFocus: !isDisabled && (onFocusProp || onFocusChange || onBlurProp) ? onFocus : void 0,
      onBlur: !isDisabled && (onBlurProp || onFocusChange) ? onBlur : void 0
    }
  };
}
function $93925083ecbb358c$export$48d1ea6320830260(handler) {
  if (!handler) return void 0;
  let shouldStopPropagation = true;
  return (e3) => {
    let event = {
      ...e3,
      preventDefault() {
        e3.preventDefault();
      },
      isDefaultPrevented() {
        return e3.isDefaultPrevented();
      },
      stopPropagation() {
        if (shouldStopPropagation) console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.");
        else shouldStopPropagation = true;
      },
      continuePropagation() {
        shouldStopPropagation = false;
      },
      isPropagationStopped() {
        return shouldStopPropagation;
      }
    };
    handler(event);
    if (shouldStopPropagation) e3.stopPropagation();
  };
}
function $46d819fcbaf35654$export$8f71654801c2f7cd(props) {
  return {
    keyboardProps: props.isDisabled ? {} : {
      onKeyDown: $93925083ecbb358c$export$48d1ea6320830260(props.onKeyDown),
      onKeyUp: $93925083ecbb358c$export$48d1ea6320830260(props.onKeyUp)
    }
  };
}
let $f645667febf57a63$export$f9762fab77588ecb = /* @__PURE__ */ React__default.createContext(null);
function $f645667febf57a63$var$useFocusableContext(ref) {
  let context = useContext($f645667febf57a63$export$f9762fab77588ecb) || {};
  $e7801be82b4b2a53$export$4debdb1a3f0fa79e(context, ref);
  let { ref: _, ...otherProps } = context;
  return otherProps;
}
function $f645667febf57a63$export$4c014de7c8940b4c(props, domRef) {
  let { focusProps } = $a1ea59d68270f0dd$export$f8168d8dd8fd66e6(props);
  let { keyboardProps } = $46d819fcbaf35654$export$8f71654801c2f7cd(props);
  let interactions = $3ef42575df84b30b$export$9d1611c77c2fe928(focusProps, keyboardProps);
  let domProps = $f645667febf57a63$var$useFocusableContext(domRef);
  let interactionProps = props.isDisabled ? {} : domProps;
  let autoFocusRef = useRef(props.autoFocus);
  useEffect(() => {
    if (autoFocusRef.current && domRef.current) $3ad3f6e1647bc98d$export$80f3e147d781571c(domRef.current);
    autoFocusRef.current = false;
  }, [
    domRef
  ]);
  let tabIndex = props.excludeFromTabOrder ? -1 : 0;
  if (props.isDisabled) tabIndex = void 0;
  return {
    focusableProps: $3ef42575df84b30b$export$9d1611c77c2fe928({
      ...interactions,
      tabIndex
    }, interactionProps)
  };
}
function $9ab94262bd0047c7$export$420e68273165f4ec(props) {
  let { isDisabled, onBlurWithin, onFocusWithin, onFocusWithinChange } = props;
  let state = useRef({
    isFocusWithin: false
  });
  let { addGlobalListener, removeAllGlobalListeners } = $03deb23ff14920c4$export$4eaf04e54aa8eed6();
  let onBlur = useCallback((e3) => {
    if (!e3.currentTarget.contains(e3.target)) return;
    if (state.current.isFocusWithin && !e3.currentTarget.contains(e3.relatedTarget)) {
      state.current.isFocusWithin = false;
      removeAllGlobalListeners();
      if (onBlurWithin) onBlurWithin(e3);
      if (onFocusWithinChange) onFocusWithinChange(false);
    }
  }, [
    onBlurWithin,
    onFocusWithinChange,
    state,
    removeAllGlobalListeners
  ]);
  let onSyntheticFocus = $8a9cb279dc87e130$export$715c682d09d639cc(onBlur);
  let onFocus = useCallback((e3) => {
    if (!e3.currentTarget.contains(e3.target)) return;
    const ownerDocument = $431fbd86ca7dc216$export$b204af158042fbac(e3.target);
    const activeElement = $d4ee10de306f2510$export$cd4e5573fbe2b576(ownerDocument);
    if (!state.current.isFocusWithin && activeElement === $d4ee10de306f2510$export$e58f029f0fbfdb29(e3.nativeEvent)) {
      if (onFocusWithin) onFocusWithin(e3);
      if (onFocusWithinChange) onFocusWithinChange(true);
      state.current.isFocusWithin = true;
      onSyntheticFocus(e3);
      let currentTarget = e3.currentTarget;
      addGlobalListener(ownerDocument, "focus", (e4) => {
        if (state.current.isFocusWithin && !$d4ee10de306f2510$export$4282f70798064fe0(currentTarget, e4.target)) {
          let event = new $8a9cb279dc87e130$export$905e7fc544a71f36("blur", new ownerDocument.defaultView.FocusEvent("blur", {
            relatedTarget: e4.target
          }));
          event.target = currentTarget;
          event.currentTarget = currentTarget;
          onBlur(event);
        }
      }, {
        capture: true
      });
    }
  }, [
    onFocusWithin,
    onFocusWithinChange,
    onSyntheticFocus,
    addGlobalListener,
    onBlur
  ]);
  if (isDisabled) return {
    focusWithinProps: {
      // These cannot be null, that would conflict in mergeProps
      onFocus: void 0,
      onBlur: void 0
    }
  };
  return {
    focusWithinProps: {
      onFocus,
      onBlur
    }
  };
}
let $6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
let $6179b936705e76d3$var$hoverCount = 0;
function $6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents() {
  $6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = true;
  setTimeout(() => {
    $6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
  }, 50);
}
function $6179b936705e76d3$var$handleGlobalPointerEvent(e3) {
  if (e3.pointerType === "touch") $6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents();
}
function $6179b936705e76d3$var$setupGlobalTouchEvents() {
  if (typeof document === "undefined") return;
  if (typeof PointerEvent !== "undefined") document.addEventListener("pointerup", $6179b936705e76d3$var$handleGlobalPointerEvent);
  else document.addEventListener("touchend", $6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents);
  $6179b936705e76d3$var$hoverCount++;
  return () => {
    $6179b936705e76d3$var$hoverCount--;
    if ($6179b936705e76d3$var$hoverCount > 0) return;
    if (typeof PointerEvent !== "undefined") document.removeEventListener("pointerup", $6179b936705e76d3$var$handleGlobalPointerEvent);
    else document.removeEventListener("touchend", $6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents);
  };
}
function $6179b936705e76d3$export$ae780daf29e6d456(props) {
  let { onHoverStart, onHoverChange, onHoverEnd, isDisabled } = props;
  let [isHovered, setHovered] = useState(false);
  let state = useRef({
    isHovered: false,
    ignoreEmulatedMouseEvents: false,
    pointerType: "",
    target: null
  }).current;
  useEffect($6179b936705e76d3$var$setupGlobalTouchEvents, []);
  let { addGlobalListener, removeAllGlobalListeners } = $03deb23ff14920c4$export$4eaf04e54aa8eed6();
  let { hoverProps, triggerHoverEnd } = useMemo(() => {
    let triggerHoverStart = (event, pointerType) => {
      state.pointerType = pointerType;
      if (isDisabled || pointerType === "touch" || state.isHovered || !event.currentTarget.contains(event.target)) return;
      state.isHovered = true;
      let target = event.currentTarget;
      state.target = target;
      addGlobalListener($431fbd86ca7dc216$export$b204af158042fbac(event.target), "pointerover", (e3) => {
        if (state.isHovered && state.target && !$d4ee10de306f2510$export$4282f70798064fe0(state.target, e3.target)) triggerHoverEnd2(e3, e3.pointerType);
      }, {
        capture: true
      });
      if (onHoverStart) onHoverStart({
        type: "hoverstart",
        target,
        pointerType
      });
      if (onHoverChange) onHoverChange(true);
      setHovered(true);
    };
    let triggerHoverEnd2 = (event, pointerType) => {
      let target = state.target;
      state.pointerType = "";
      state.target = null;
      if (pointerType === "touch" || !state.isHovered || !target) return;
      state.isHovered = false;
      removeAllGlobalListeners();
      if (onHoverEnd) onHoverEnd({
        type: "hoverend",
        target,
        pointerType
      });
      if (onHoverChange) onHoverChange(false);
      setHovered(false);
    };
    let hoverProps2 = {};
    if (typeof PointerEvent !== "undefined") {
      hoverProps2.onPointerEnter = (e3) => {
        if ($6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents && e3.pointerType === "mouse") return;
        triggerHoverStart(e3, e3.pointerType);
      };
      hoverProps2.onPointerLeave = (e3) => {
        if (!isDisabled && e3.currentTarget.contains(e3.target)) triggerHoverEnd2(e3, e3.pointerType);
      };
    } else {
      hoverProps2.onTouchStart = () => {
        state.ignoreEmulatedMouseEvents = true;
      };
      hoverProps2.onMouseEnter = (e3) => {
        if (!state.ignoreEmulatedMouseEvents && !$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents) triggerHoverStart(e3, "mouse");
        state.ignoreEmulatedMouseEvents = false;
      };
      hoverProps2.onMouseLeave = (e3) => {
        if (!isDisabled && e3.currentTarget.contains(e3.target)) triggerHoverEnd2(e3, "mouse");
      };
    }
    return {
      hoverProps: hoverProps2,
      triggerHoverEnd: triggerHoverEnd2
    };
  }, [
    onHoverStart,
    onHoverChange,
    onHoverEnd,
    isDisabled,
    state,
    addGlobalListener,
    removeAllGlobalListeners
  ]);
  useEffect(() => {
    if (isDisabled) triggerHoverEnd({
      currentTarget: state.target
    }, state.pointerType);
  }, [
    isDisabled
  ]);
  return {
    hoverProps,
    isHovered
  };
}
function $e8a7022cf87cba2a$export$36da96379f79f245(props) {
  let { onMoveStart, onMove, onMoveEnd } = props;
  let state = useRef({
    didMove: false,
    lastPosition: null,
    id: null
  });
  let { addGlobalListener, removeGlobalListener } = $03deb23ff14920c4$export$4eaf04e54aa8eed6();
  let move = $8ae05eaa5c114e9c$export$7f54fc3180508a52((originalEvent, pointerType, deltaX, deltaY) => {
    if (deltaX === 0 && deltaY === 0) return;
    if (!state.current.didMove) {
      state.current.didMove = true;
      onMoveStart === null || onMoveStart === void 0 ? void 0 : onMoveStart({
        type: "movestart",
        pointerType,
        shiftKey: originalEvent.shiftKey,
        metaKey: originalEvent.metaKey,
        ctrlKey: originalEvent.ctrlKey,
        altKey: originalEvent.altKey
      });
    }
    onMove === null || onMove === void 0 ? void 0 : onMove({
      type: "move",
      pointerType,
      deltaX,
      deltaY,
      shiftKey: originalEvent.shiftKey,
      metaKey: originalEvent.metaKey,
      ctrlKey: originalEvent.ctrlKey,
      altKey: originalEvent.altKey
    });
  });
  let end = $8ae05eaa5c114e9c$export$7f54fc3180508a52((originalEvent, pointerType) => {
    $14c0b72509d70225$export$b0d6fa1ab32e3295();
    if (state.current.didMove) onMoveEnd === null || onMoveEnd === void 0 ? void 0 : onMoveEnd({
      type: "moveend",
      pointerType,
      shiftKey: originalEvent.shiftKey,
      metaKey: originalEvent.metaKey,
      ctrlKey: originalEvent.ctrlKey,
      altKey: originalEvent.altKey
    });
  });
  let moveProps = useMemo(() => {
    let moveProps2 = {};
    let start = () => {
      $14c0b72509d70225$export$16a4697467175487();
      state.current.didMove = false;
    };
    if (typeof PointerEvent === "undefined") {
      let onMouseMove = (e3) => {
        if (e3.button === 0) {
          var _state_current_lastPosition, _state_current_lastPosition1;
          var _state_current_lastPosition_pageX, _state_current_lastPosition_pageY;
          move(e3, "mouse", e3.pageX - ((_state_current_lastPosition_pageX = (_state_current_lastPosition = state.current.lastPosition) === null || _state_current_lastPosition === void 0 ? void 0 : _state_current_lastPosition.pageX) !== null && _state_current_lastPosition_pageX !== void 0 ? _state_current_lastPosition_pageX : 0), e3.pageY - ((_state_current_lastPosition_pageY = (_state_current_lastPosition1 = state.current.lastPosition) === null || _state_current_lastPosition1 === void 0 ? void 0 : _state_current_lastPosition1.pageY) !== null && _state_current_lastPosition_pageY !== void 0 ? _state_current_lastPosition_pageY : 0));
          state.current.lastPosition = {
            pageX: e3.pageX,
            pageY: e3.pageY
          };
        }
      };
      let onMouseUp = (e3) => {
        if (e3.button === 0) {
          end(e3, "mouse");
          removeGlobalListener(window, "mousemove", onMouseMove, false);
          removeGlobalListener(window, "mouseup", onMouseUp, false);
        }
      };
      moveProps2.onMouseDown = (e3) => {
        if (e3.button === 0) {
          start();
          e3.stopPropagation();
          e3.preventDefault();
          state.current.lastPosition = {
            pageX: e3.pageX,
            pageY: e3.pageY
          };
          addGlobalListener(window, "mousemove", onMouseMove, false);
          addGlobalListener(window, "mouseup", onMouseUp, false);
        }
      };
      let onTouchMove = (e3) => {
        let touch = [
          ...e3.changedTouches
        ].findIndex(({ identifier }) => identifier === state.current.id);
        if (touch >= 0) {
          var _state_current_lastPosition, _state_current_lastPosition1;
          let { pageX, pageY } = e3.changedTouches[touch];
          var _state_current_lastPosition_pageX, _state_current_lastPosition_pageY;
          move(e3, "touch", pageX - ((_state_current_lastPosition_pageX = (_state_current_lastPosition = state.current.lastPosition) === null || _state_current_lastPosition === void 0 ? void 0 : _state_current_lastPosition.pageX) !== null && _state_current_lastPosition_pageX !== void 0 ? _state_current_lastPosition_pageX : 0), pageY - ((_state_current_lastPosition_pageY = (_state_current_lastPosition1 = state.current.lastPosition) === null || _state_current_lastPosition1 === void 0 ? void 0 : _state_current_lastPosition1.pageY) !== null && _state_current_lastPosition_pageY !== void 0 ? _state_current_lastPosition_pageY : 0));
          state.current.lastPosition = {
            pageX,
            pageY
          };
        }
      };
      let onTouchEnd = (e3) => {
        let touch = [
          ...e3.changedTouches
        ].findIndex(({ identifier }) => identifier === state.current.id);
        if (touch >= 0) {
          end(e3, "touch");
          state.current.id = null;
          removeGlobalListener(window, "touchmove", onTouchMove);
          removeGlobalListener(window, "touchend", onTouchEnd);
          removeGlobalListener(window, "touchcancel", onTouchEnd);
        }
      };
      moveProps2.onTouchStart = (e3) => {
        if (e3.changedTouches.length === 0 || state.current.id != null) return;
        let { pageX, pageY, identifier } = e3.changedTouches[0];
        start();
        e3.stopPropagation();
        e3.preventDefault();
        state.current.lastPosition = {
          pageX,
          pageY
        };
        state.current.id = identifier;
        addGlobalListener(window, "touchmove", onTouchMove, false);
        addGlobalListener(window, "touchend", onTouchEnd, false);
        addGlobalListener(window, "touchcancel", onTouchEnd, false);
      };
    } else {
      let onPointerMove = (e3) => {
        if (e3.pointerId === state.current.id) {
          var _state_current_lastPosition, _state_current_lastPosition1;
          let pointerType = e3.pointerType || "mouse";
          var _state_current_lastPosition_pageX, _state_current_lastPosition_pageY;
          move(e3, pointerType, e3.pageX - ((_state_current_lastPosition_pageX = (_state_current_lastPosition = state.current.lastPosition) === null || _state_current_lastPosition === void 0 ? void 0 : _state_current_lastPosition.pageX) !== null && _state_current_lastPosition_pageX !== void 0 ? _state_current_lastPosition_pageX : 0), e3.pageY - ((_state_current_lastPosition_pageY = (_state_current_lastPosition1 = state.current.lastPosition) === null || _state_current_lastPosition1 === void 0 ? void 0 : _state_current_lastPosition1.pageY) !== null && _state_current_lastPosition_pageY !== void 0 ? _state_current_lastPosition_pageY : 0));
          state.current.lastPosition = {
            pageX: e3.pageX,
            pageY: e3.pageY
          };
        }
      };
      let onPointerUp = (e3) => {
        if (e3.pointerId === state.current.id) {
          let pointerType = e3.pointerType || "mouse";
          end(e3, pointerType);
          state.current.id = null;
          removeGlobalListener(window, "pointermove", onPointerMove, false);
          removeGlobalListener(window, "pointerup", onPointerUp, false);
          removeGlobalListener(window, "pointercancel", onPointerUp, false);
        }
      };
      moveProps2.onPointerDown = (e3) => {
        if (e3.button === 0 && state.current.id == null) {
          start();
          e3.stopPropagation();
          e3.preventDefault();
          state.current.lastPosition = {
            pageX: e3.pageX,
            pageY: e3.pageY
          };
          state.current.id = e3.pointerId;
          addGlobalListener(window, "pointermove", onPointerMove, false);
          addGlobalListener(window, "pointerup", onPointerUp, false);
          addGlobalListener(window, "pointercancel", onPointerUp, false);
        }
      };
    }
    let triggerKeyboardMove = (e3, deltaX, deltaY) => {
      start();
      move(e3, "keyboard", deltaX, deltaY);
      end(e3, "keyboard");
    };
    moveProps2.onKeyDown = (e3) => {
      switch (e3.key) {
        case "Left":
        case "ArrowLeft":
          e3.preventDefault();
          e3.stopPropagation();
          triggerKeyboardMove(e3, -1, 0);
          break;
        case "Right":
        case "ArrowRight":
          e3.preventDefault();
          e3.stopPropagation();
          triggerKeyboardMove(e3, 1, 0);
          break;
        case "Up":
        case "ArrowUp":
          e3.preventDefault();
          e3.stopPropagation();
          triggerKeyboardMove(e3, 0, -1);
          break;
        case "Down":
        case "ArrowDown":
          e3.preventDefault();
          e3.stopPropagation();
          triggerKeyboardMove(e3, 0, 1);
          break;
      }
    };
    return moveProps2;
  }, [
    state,
    addGlobalListener,
    removeGlobalListener,
    move,
    end
  ]);
  return {
    moveProps
  };
}
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x3) {
  return x3 && x3.__esModule && Object.prototype.hasOwnProperty.call(x3, "default") ? x3["default"] : x3;
}
const $148a7a147e38ea7f$var$RTL_SCRIPTS = /* @__PURE__ */ new Set([
  "Arab",
  "Syrc",
  "Samr",
  "Mand",
  "Thaa",
  "Mend",
  "Nkoo",
  "Adlm",
  "Rohg",
  "Hebr"
]);
const $148a7a147e38ea7f$var$RTL_LANGS = /* @__PURE__ */ new Set([
  "ae",
  "ar",
  "arc",
  "bcc",
  "bqi",
  "ckb",
  "dv",
  "fa",
  "glk",
  "he",
  "ku",
  "mzn",
  "nqo",
  "pnb",
  "ps",
  "sd",
  "ug",
  "ur",
  "yi"
]);
function $148a7a147e38ea7f$export$702d680b21cbd764(localeString) {
  if (Intl.Locale) {
    let locale2 = new Intl.Locale(localeString).maximize();
    let textInfo = typeof locale2.getTextInfo === "function" ? locale2.getTextInfo() : locale2.textInfo;
    if (textInfo) return textInfo.direction === "rtl";
    if (locale2.script) return $148a7a147e38ea7f$var$RTL_SCRIPTS.has(locale2.script);
  }
  let lang = localeString.split("-")[0];
  return $148a7a147e38ea7f$var$RTL_LANGS.has(lang);
}
const $1e5a04cdaf7d1af8$var$localeSymbol = Symbol.for("react-aria.i18n.locale");
function $1e5a04cdaf7d1af8$export$f09106e7c6677ec5() {
  let locale2 = typeof window !== "undefined" && window[$1e5a04cdaf7d1af8$var$localeSymbol] || typeof navigator !== "undefined" && (navigator.language || navigator.userLanguage) || "en-US";
  try {
    Intl.DateTimeFormat.supportedLocalesOf([
      locale2
    ]);
  } catch {
    locale2 = "en-US";
  }
  return {
    locale: locale2,
    direction: $148a7a147e38ea7f$export$702d680b21cbd764(locale2) ? "rtl" : "ltr"
  };
}
let $1e5a04cdaf7d1af8$var$currentLocale = $1e5a04cdaf7d1af8$export$f09106e7c6677ec5();
let $1e5a04cdaf7d1af8$var$listeners = /* @__PURE__ */ new Set();
function $1e5a04cdaf7d1af8$var$updateLocale() {
  $1e5a04cdaf7d1af8$var$currentLocale = $1e5a04cdaf7d1af8$export$f09106e7c6677ec5();
  for (let listener of $1e5a04cdaf7d1af8$var$listeners) listener($1e5a04cdaf7d1af8$var$currentLocale);
}
function $1e5a04cdaf7d1af8$export$188ec29ebc2bdc3a() {
  let isSSR = $b5e257d569688ac6$export$535bd6ca7f90a273();
  let [defaultLocale2, setDefaultLocale] = useState($1e5a04cdaf7d1af8$var$currentLocale);
  useEffect(() => {
    if ($1e5a04cdaf7d1af8$var$listeners.size === 0) window.addEventListener("languagechange", $1e5a04cdaf7d1af8$var$updateLocale);
    $1e5a04cdaf7d1af8$var$listeners.add(setDefaultLocale);
    return () => {
      $1e5a04cdaf7d1af8$var$listeners.delete(setDefaultLocale);
      if ($1e5a04cdaf7d1af8$var$listeners.size === 0) window.removeEventListener("languagechange", $1e5a04cdaf7d1af8$var$updateLocale);
    };
  }, []);
  if (isSSR) return {
    locale: "en-US",
    direction: "ltr"
  };
  return defaultLocale2;
}
const $18f2051aff69b9bf$var$I18nContext = /* @__PURE__ */ React__default.createContext(null);
function $18f2051aff69b9bf$export$43bb16f9c6d9e3f7() {
  let defaultLocale2 = $1e5a04cdaf7d1af8$export$188ec29ebc2bdc3a();
  let context = useContext($18f2051aff69b9bf$var$I18nContext);
  return context || defaultLocale2;
}
function $701a24aa0da5b062$export$ea18c227d4417cc3(props, ref) {
  let {
    elementType = "button",
    isDisabled,
    onPress,
    onPressStart,
    onPressEnd,
    onPressUp,
    onPressChange,
    preventFocusOnPress,
    allowFocusWhenDisabled,
    // @ts-ignore
    onClick: deprecatedOnClick,
    href,
    target,
    rel,
    type = "button"
  } = props;
  let additionalProps;
  if (elementType === "button") additionalProps = {
    type,
    disabled: isDisabled
  };
  else additionalProps = {
    role: "button",
    href: elementType === "a" && !isDisabled ? href : void 0,
    target: elementType === "a" ? target : void 0,
    type: elementType === "input" ? type : void 0,
    disabled: elementType === "input" ? isDisabled : void 0,
    "aria-disabled": !isDisabled || elementType === "input" ? void 0 : isDisabled,
    rel: elementType === "a" ? rel : void 0
  };
  let { pressProps, isPressed } = $f6c31cce2adf654f$export$45712eceda6fad21({
    onPressStart,
    onPressEnd,
    onPressChange,
    onPress,
    onPressUp,
    isDisabled,
    preventFocusOnPress,
    ref
  });
  let { focusableProps } = $f645667febf57a63$export$4c014de7c8940b4c(props, ref);
  if (allowFocusWhenDisabled) focusableProps.tabIndex = isDisabled ? -1 : focusableProps.tabIndex;
  let buttonProps = $3ef42575df84b30b$export$9d1611c77c2fe928(focusableProps, pressProps, $65484d02dcb7eb3e$export$457c3d6518dd4c6f(props, {
    labelable: true
  }));
  return {
    isPressed,
    buttonProps: $3ef42575df84b30b$export$9d1611c77c2fe928(additionalProps, buttonProps, {
      "aria-haspopup": props["aria-haspopup"],
      "aria-expanded": props["aria-expanded"],
      "aria-controls": props["aria-controls"],
      "aria-pressed": props["aria-pressed"],
      "aria-current": props["aria-current"],
      onClick: (e3) => {
        if (deprecatedOnClick) {
          deprecatedOnClick(e3);
          console.warn("onClick is deprecated, please use onPress");
        }
      }
    })
  };
}
function $645f2e67b85a24c9$var$isStyleVisible(element) {
  const windowObject = $431fbd86ca7dc216$export$f21a1ffae260145a(element);
  if (!(element instanceof windowObject.HTMLElement) && !(element instanceof windowObject.SVGElement)) return false;
  let { display, visibility } = element.style;
  let isVisible2 = display !== "none" && visibility !== "hidden" && visibility !== "collapse";
  if (isVisible2) {
    const { getComputedStyle: getComputedStyle2 } = element.ownerDocument.defaultView;
    let { display: computedDisplay, visibility: computedVisibility } = getComputedStyle2(element);
    isVisible2 = computedDisplay !== "none" && computedVisibility !== "hidden" && computedVisibility !== "collapse";
  }
  return isVisible2;
}
function $645f2e67b85a24c9$var$isAttributeVisible(element, childElement) {
  return !element.hasAttribute("hidden") && // Ignore HiddenSelect when tree walking.
  !element.hasAttribute("data-react-aria-prevent-focus") && (element.nodeName === "DETAILS" && childElement && childElement.nodeName !== "SUMMARY" ? element.hasAttribute("open") : true);
}
function $645f2e67b85a24c9$export$e989c0fffaa6b27a(element, childElement) {
  return element.nodeName !== "#comment" && $645f2e67b85a24c9$var$isStyleVisible(element) && $645f2e67b85a24c9$var$isAttributeVisible(element, childElement) && (!element.parentElement || $645f2e67b85a24c9$export$e989c0fffaa6b27a(element.parentElement, element));
}
const $9bf71ea28793e738$var$FocusContext = /* @__PURE__ */ React__default.createContext(null);
const $9bf71ea28793e738$var$RESTORE_FOCUS_EVENT = "react-aria-focus-scope-restore";
let $9bf71ea28793e738$var$activeScope = null;
function $9bf71ea28793e738$export$20e40289641fbbb6(props) {
  let { children, contain, restoreFocus, autoFocus } = props;
  let startRef = useRef(null);
  let endRef = useRef(null);
  let scopeRef = useRef([]);
  let { parentNode } = useContext($9bf71ea28793e738$var$FocusContext) || {};
  let node = useMemo(() => new $9bf71ea28793e738$var$TreeNode({
    scopeRef
  }), [
    scopeRef
  ]);
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    let parent = parentNode || $9bf71ea28793e738$export$d06fae2ee68b101e.root;
    if ($9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(parent.scopeRef) && $9bf71ea28793e738$var$activeScope && !$9bf71ea28793e738$var$isAncestorScope($9bf71ea28793e738$var$activeScope, parent.scopeRef)) {
      let activeNode = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode($9bf71ea28793e738$var$activeScope);
      if (activeNode) parent = activeNode;
    }
    parent.addChild(node);
    $9bf71ea28793e738$export$d06fae2ee68b101e.addNode(node);
  }, [
    node,
    parentNode
  ]);
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    let node2 = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef);
    if (node2) node2.contain = !!contain;
  }, [
    contain
  ]);
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    var _startRef_current;
    let node2 = (_startRef_current = startRef.current) === null || _startRef_current === void 0 ? void 0 : _startRef_current.nextSibling;
    let nodes = [];
    let stopPropagation2 = (e3) => e3.stopPropagation();
    while (node2 && node2 !== endRef.current) {
      nodes.push(node2);
      node2.addEventListener($9bf71ea28793e738$var$RESTORE_FOCUS_EVENT, stopPropagation2);
      node2 = node2.nextSibling;
    }
    scopeRef.current = nodes;
    return () => {
      for (let node3 of nodes) node3.removeEventListener($9bf71ea28793e738$var$RESTORE_FOCUS_EVENT, stopPropagation2);
    };
  }, [
    children
  ]);
  $9bf71ea28793e738$var$useActiveScopeTracker(scopeRef, restoreFocus, contain);
  $9bf71ea28793e738$var$useFocusContainment(scopeRef, contain);
  $9bf71ea28793e738$var$useRestoreFocus(scopeRef, restoreFocus, contain);
  $9bf71ea28793e738$var$useAutoFocus(scopeRef, autoFocus);
  useEffect(() => {
    const activeElement = $d4ee10de306f2510$export$cd4e5573fbe2b576($431fbd86ca7dc216$export$b204af158042fbac(scopeRef.current ? scopeRef.current[0] : void 0));
    let scope = null;
    if ($9bf71ea28793e738$var$isElementInScope(activeElement, scopeRef.current)) {
      for (let node2 of $9bf71ea28793e738$export$d06fae2ee68b101e.traverse()) if (node2.scopeRef && $9bf71ea28793e738$var$isElementInScope(activeElement, node2.scopeRef.current)) scope = node2;
      if (scope === $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef)) $9bf71ea28793e738$var$activeScope = scope.scopeRef;
    }
  }, [
    scopeRef
  ]);
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    return () => {
      var _focusScopeTree_getTreeNode_parent, _focusScopeTree_getTreeNode;
      var _focusScopeTree_getTreeNode_parent_scopeRef;
      let parentScope = (_focusScopeTree_getTreeNode_parent_scopeRef = (_focusScopeTree_getTreeNode = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef)) === null || _focusScopeTree_getTreeNode === void 0 ? void 0 : (_focusScopeTree_getTreeNode_parent = _focusScopeTree_getTreeNode.parent) === null || _focusScopeTree_getTreeNode_parent === void 0 ? void 0 : _focusScopeTree_getTreeNode_parent.scopeRef) !== null && _focusScopeTree_getTreeNode_parent_scopeRef !== void 0 ? _focusScopeTree_getTreeNode_parent_scopeRef : null;
      if ((scopeRef === $9bf71ea28793e738$var$activeScope || $9bf71ea28793e738$var$isAncestorScope(scopeRef, $9bf71ea28793e738$var$activeScope)) && (!parentScope || $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(parentScope))) $9bf71ea28793e738$var$activeScope = parentScope;
      $9bf71ea28793e738$export$d06fae2ee68b101e.removeTreeNode(scopeRef);
    };
  }, [
    scopeRef
  ]);
  let focusManager = useMemo(() => $9bf71ea28793e738$var$createFocusManagerForScope(scopeRef), []);
  let value = useMemo(() => ({
    focusManager,
    parentNode: node
  }), [
    node,
    focusManager
  ]);
  return /* @__PURE__ */ React__default.createElement($9bf71ea28793e738$var$FocusContext.Provider, {
    value
  }, /* @__PURE__ */ React__default.createElement("span", {
    "data-focus-scope-start": true,
    hidden: true,
    ref: startRef
  }), children, /* @__PURE__ */ React__default.createElement("span", {
    "data-focus-scope-end": true,
    hidden: true,
    ref: endRef
  }));
}
function $9bf71ea28793e738$export$10c5169755ce7bd7() {
  var _useContext;
  return (_useContext = useContext($9bf71ea28793e738$var$FocusContext)) === null || _useContext === void 0 ? void 0 : _useContext.focusManager;
}
function $9bf71ea28793e738$var$createFocusManagerForScope(scopeRef) {
  return {
    focusNext(opts = {}) {
      let scope = scopeRef.current;
      let { from, tabbable, wrap, accept } = opts;
      var _scope_;
      let node = from || $d4ee10de306f2510$export$cd4e5573fbe2b576($431fbd86ca7dc216$export$b204af158042fbac((_scope_ = scope[0]) !== null && _scope_ !== void 0 ? _scope_ : void 0));
      let sentinel = scope[0].previousElementSibling;
      let scopeRoot = $9bf71ea28793e738$var$getScopeRoot(scope);
      let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(scopeRoot, {
        tabbable,
        accept
      }, scope);
      walker.currentNode = $9bf71ea28793e738$var$isElementInScope(node, scope) ? node : sentinel;
      let nextNode = walker.nextNode();
      if (!nextNode && wrap) {
        walker.currentNode = sentinel;
        nextNode = walker.nextNode();
      }
      if (nextNode) $9bf71ea28793e738$var$focusElement(nextNode, true);
      return nextNode;
    },
    focusPrevious(opts = {}) {
      let scope = scopeRef.current;
      let { from, tabbable, wrap, accept } = opts;
      var _scope_;
      let node = from || $d4ee10de306f2510$export$cd4e5573fbe2b576($431fbd86ca7dc216$export$b204af158042fbac((_scope_ = scope[0]) !== null && _scope_ !== void 0 ? _scope_ : void 0));
      let sentinel = scope[scope.length - 1].nextElementSibling;
      let scopeRoot = $9bf71ea28793e738$var$getScopeRoot(scope);
      let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(scopeRoot, {
        tabbable,
        accept
      }, scope);
      walker.currentNode = $9bf71ea28793e738$var$isElementInScope(node, scope) ? node : sentinel;
      let previousNode = walker.previousNode();
      if (!previousNode && wrap) {
        walker.currentNode = sentinel;
        previousNode = walker.previousNode();
      }
      if (previousNode) $9bf71ea28793e738$var$focusElement(previousNode, true);
      return previousNode;
    },
    focusFirst(opts = {}) {
      let scope = scopeRef.current;
      let { tabbable, accept } = opts;
      let scopeRoot = $9bf71ea28793e738$var$getScopeRoot(scope);
      let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(scopeRoot, {
        tabbable,
        accept
      }, scope);
      walker.currentNode = scope[0].previousElementSibling;
      let nextNode = walker.nextNode();
      if (nextNode) $9bf71ea28793e738$var$focusElement(nextNode, true);
      return nextNode;
    },
    focusLast(opts = {}) {
      let scope = scopeRef.current;
      let { tabbable, accept } = opts;
      let scopeRoot = $9bf71ea28793e738$var$getScopeRoot(scope);
      let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(scopeRoot, {
        tabbable,
        accept
      }, scope);
      walker.currentNode = scope[scope.length - 1].nextElementSibling;
      let previousNode = walker.previousNode();
      if (previousNode) $9bf71ea28793e738$var$focusElement(previousNode, true);
      return previousNode;
    }
  };
}
function $9bf71ea28793e738$var$getScopeRoot(scope) {
  return scope[0].parentElement;
}
function $9bf71ea28793e738$var$shouldContainFocus(scopeRef) {
  let scope = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode($9bf71ea28793e738$var$activeScope);
  while (scope && scope.scopeRef !== scopeRef) {
    if (scope.contain) return false;
    scope = scope.parent;
  }
  return true;
}
function $9bf71ea28793e738$var$useFocusContainment(scopeRef, contain) {
  let focusedNode = useRef(void 0);
  let raf = useRef(void 0);
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    let scope = scopeRef.current;
    if (!contain) {
      if (raf.current) {
        cancelAnimationFrame(raf.current);
        raf.current = void 0;
      }
      return;
    }
    const ownerDocument = $431fbd86ca7dc216$export$b204af158042fbac(scope ? scope[0] : void 0);
    let onKeyDown = (e3) => {
      if (e3.key !== "Tab" || e3.altKey || e3.ctrlKey || e3.metaKey || !$9bf71ea28793e738$var$shouldContainFocus(scopeRef) || e3.isComposing) return;
      let focusedElement = $d4ee10de306f2510$export$cd4e5573fbe2b576(ownerDocument);
      let scope2 = scopeRef.current;
      if (!scope2 || !$9bf71ea28793e738$var$isElementInScope(focusedElement, scope2)) return;
      let scopeRoot = $9bf71ea28793e738$var$getScopeRoot(scope2);
      let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(scopeRoot, {
        tabbable: true
      }, scope2);
      if (!focusedElement) return;
      walker.currentNode = focusedElement;
      let nextElement = e3.shiftKey ? walker.previousNode() : walker.nextNode();
      if (!nextElement) {
        walker.currentNode = e3.shiftKey ? scope2[scope2.length - 1].nextElementSibling : scope2[0].previousElementSibling;
        nextElement = e3.shiftKey ? walker.previousNode() : walker.nextNode();
      }
      e3.preventDefault();
      if (nextElement) $9bf71ea28793e738$var$focusElement(nextElement, true);
    };
    let onFocus = (e3) => {
      if ((!$9bf71ea28793e738$var$activeScope || $9bf71ea28793e738$var$isAncestorScope($9bf71ea28793e738$var$activeScope, scopeRef)) && $9bf71ea28793e738$var$isElementInScope($d4ee10de306f2510$export$e58f029f0fbfdb29(e3), scopeRef.current)) {
        $9bf71ea28793e738$var$activeScope = scopeRef;
        focusedNode.current = $d4ee10de306f2510$export$e58f029f0fbfdb29(e3);
      } else if ($9bf71ea28793e738$var$shouldContainFocus(scopeRef) && !$9bf71ea28793e738$var$isElementInChildScope($d4ee10de306f2510$export$e58f029f0fbfdb29(e3), scopeRef)) {
        if (focusedNode.current) focusedNode.current.focus();
        else if ($9bf71ea28793e738$var$activeScope && $9bf71ea28793e738$var$activeScope.current) $9bf71ea28793e738$var$focusFirstInScope($9bf71ea28793e738$var$activeScope.current);
      } else if ($9bf71ea28793e738$var$shouldContainFocus(scopeRef)) focusedNode.current = $d4ee10de306f2510$export$e58f029f0fbfdb29(e3);
    };
    let onBlur = (e3) => {
      if (raf.current) cancelAnimationFrame(raf.current);
      raf.current = requestAnimationFrame(() => {
        let modality = $507fabe10e71c6fb$export$630ff653c5ada6a9();
        let shouldSkipFocusRestore = (modality === "virtual" || modality === null) && $c87311424ea30a05$export$a11b0059900ceec8() && $c87311424ea30a05$export$6446a186d09e379e();
        let activeElement = $d4ee10de306f2510$export$cd4e5573fbe2b576(ownerDocument);
        if (!shouldSkipFocusRestore && activeElement && $9bf71ea28793e738$var$shouldContainFocus(scopeRef) && !$9bf71ea28793e738$var$isElementInChildScope(activeElement, scopeRef)) {
          $9bf71ea28793e738$var$activeScope = scopeRef;
          let target = $d4ee10de306f2510$export$e58f029f0fbfdb29(e3);
          if (target && target.isConnected) {
            var _focusedNode_current;
            focusedNode.current = target;
            (_focusedNode_current = focusedNode.current) === null || _focusedNode_current === void 0 ? void 0 : _focusedNode_current.focus();
          } else if ($9bf71ea28793e738$var$activeScope.current) $9bf71ea28793e738$var$focusFirstInScope($9bf71ea28793e738$var$activeScope.current);
        }
      });
    };
    ownerDocument.addEventListener("keydown", onKeyDown, false);
    ownerDocument.addEventListener("focusin", onFocus, false);
    scope === null || scope === void 0 ? void 0 : scope.forEach((element) => element.addEventListener("focusin", onFocus, false));
    scope === null || scope === void 0 ? void 0 : scope.forEach((element) => element.addEventListener("focusout", onBlur, false));
    return () => {
      ownerDocument.removeEventListener("keydown", onKeyDown, false);
      ownerDocument.removeEventListener("focusin", onFocus, false);
      scope === null || scope === void 0 ? void 0 : scope.forEach((element) => element.removeEventListener("focusin", onFocus, false));
      scope === null || scope === void 0 ? void 0 : scope.forEach((element) => element.removeEventListener("focusout", onBlur, false));
    };
  }, [
    scopeRef,
    contain
  ]);
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    return () => {
      if (raf.current) cancelAnimationFrame(raf.current);
    };
  }, [
    raf
  ]);
}
function $9bf71ea28793e738$var$isElementInAnyScope(element) {
  return $9bf71ea28793e738$var$isElementInChildScope(element);
}
function $9bf71ea28793e738$var$isElementInScope(element, scope) {
  if (!element) return false;
  if (!scope) return false;
  return scope.some((node) => node.contains(element));
}
function $9bf71ea28793e738$var$isElementInChildScope(element, scope = null) {
  if (element instanceof Element && element.closest("[data-react-aria-top-layer]")) return true;
  for (let { scopeRef: s4 } of $9bf71ea28793e738$export$d06fae2ee68b101e.traverse($9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scope))) {
    if (s4 && $9bf71ea28793e738$var$isElementInScope(element, s4.current)) return true;
  }
  return false;
}
function $9bf71ea28793e738$var$isAncestorScope(ancestor, scope) {
  var _focusScopeTree_getTreeNode;
  let parent = (_focusScopeTree_getTreeNode = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scope)) === null || _focusScopeTree_getTreeNode === void 0 ? void 0 : _focusScopeTree_getTreeNode.parent;
  while (parent) {
    if (parent.scopeRef === ancestor) return true;
    parent = parent.parent;
  }
  return false;
}
function $9bf71ea28793e738$var$focusElement(element, scroll2 = false) {
  if (element != null && !scroll2) try {
    (0, $3ad3f6e1647bc98d$export$80f3e147d781571c)(element);
  } catch {
  }
  else if (element != null) try {
    element.focus();
  } catch {
  }
}
function $9bf71ea28793e738$var$getFirstInScope(scope, tabbable = true) {
  let sentinel = scope[0].previousElementSibling;
  let scopeRoot = $9bf71ea28793e738$var$getScopeRoot(scope);
  let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(scopeRoot, {
    tabbable
  }, scope);
  walker.currentNode = sentinel;
  let nextNode = walker.nextNode();
  if (tabbable && !nextNode) {
    scopeRoot = $9bf71ea28793e738$var$getScopeRoot(scope);
    walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(scopeRoot, {
      tabbable: false
    }, scope);
    walker.currentNode = sentinel;
    nextNode = walker.nextNode();
  }
  return nextNode;
}
function $9bf71ea28793e738$var$focusFirstInScope(scope, tabbable = true) {
  $9bf71ea28793e738$var$focusElement($9bf71ea28793e738$var$getFirstInScope(scope, tabbable));
}
function $9bf71ea28793e738$var$useAutoFocus(scopeRef, autoFocus) {
  const autoFocusRef = React__default.useRef(autoFocus);
  useEffect(() => {
    if (autoFocusRef.current) {
      $9bf71ea28793e738$var$activeScope = scopeRef;
      const ownerDocument = $431fbd86ca7dc216$export$b204af158042fbac(scopeRef.current ? scopeRef.current[0] : void 0);
      if (!$9bf71ea28793e738$var$isElementInScope($d4ee10de306f2510$export$cd4e5573fbe2b576(ownerDocument), $9bf71ea28793e738$var$activeScope.current) && scopeRef.current) $9bf71ea28793e738$var$focusFirstInScope(scopeRef.current);
    }
    autoFocusRef.current = false;
  }, [
    scopeRef
  ]);
}
function $9bf71ea28793e738$var$useActiveScopeTracker(scopeRef, restore, contain) {
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    if (restore || contain) return;
    let scope = scopeRef.current;
    const ownerDocument = $431fbd86ca7dc216$export$b204af158042fbac(scope ? scope[0] : void 0);
    let onFocus = (e3) => {
      let target = $d4ee10de306f2510$export$e58f029f0fbfdb29(e3);
      if ($9bf71ea28793e738$var$isElementInScope(target, scopeRef.current)) $9bf71ea28793e738$var$activeScope = scopeRef;
      else if (!$9bf71ea28793e738$var$isElementInAnyScope(target)) $9bf71ea28793e738$var$activeScope = null;
    };
    ownerDocument.addEventListener("focusin", onFocus, false);
    scope === null || scope === void 0 ? void 0 : scope.forEach((element) => element.addEventListener("focusin", onFocus, false));
    return () => {
      ownerDocument.removeEventListener("focusin", onFocus, false);
      scope === null || scope === void 0 ? void 0 : scope.forEach((element) => element.removeEventListener("focusin", onFocus, false));
    };
  }, [
    scopeRef,
    restore,
    contain
  ]);
}
function $9bf71ea28793e738$var$shouldRestoreFocus(scopeRef) {
  let scope = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode($9bf71ea28793e738$var$activeScope);
  while (scope && scope.scopeRef !== scopeRef) {
    if (scope.nodeToRestore) return false;
    scope = scope.parent;
  }
  return (scope === null || scope === void 0 ? void 0 : scope.scopeRef) === scopeRef;
}
function $9bf71ea28793e738$var$useRestoreFocus(scopeRef, restoreFocus, contain) {
  const nodeToRestoreRef = useRef(typeof document !== "undefined" ? $d4ee10de306f2510$export$cd4e5573fbe2b576($431fbd86ca7dc216$export$b204af158042fbac(scopeRef.current ? scopeRef.current[0] : void 0)) : null);
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    let scope = scopeRef.current;
    const ownerDocument = $431fbd86ca7dc216$export$b204af158042fbac(scope ? scope[0] : void 0);
    if (!restoreFocus || contain) return;
    let onFocus = () => {
      if ((!$9bf71ea28793e738$var$activeScope || $9bf71ea28793e738$var$isAncestorScope($9bf71ea28793e738$var$activeScope, scopeRef)) && $9bf71ea28793e738$var$isElementInScope($d4ee10de306f2510$export$cd4e5573fbe2b576(ownerDocument), scopeRef.current)) $9bf71ea28793e738$var$activeScope = scopeRef;
    };
    ownerDocument.addEventListener("focusin", onFocus, false);
    scope === null || scope === void 0 ? void 0 : scope.forEach((element) => element.addEventListener("focusin", onFocus, false));
    return () => {
      ownerDocument.removeEventListener("focusin", onFocus, false);
      scope === null || scope === void 0 ? void 0 : scope.forEach((element) => element.removeEventListener("focusin", onFocus, false));
    };
  }, [
    scopeRef,
    contain
  ]);
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    const ownerDocument = $431fbd86ca7dc216$export$b204af158042fbac(scopeRef.current ? scopeRef.current[0] : void 0);
    if (!restoreFocus) return;
    let onKeyDown = (e3) => {
      if (e3.key !== "Tab" || e3.altKey || e3.ctrlKey || e3.metaKey || !$9bf71ea28793e738$var$shouldContainFocus(scopeRef) || e3.isComposing) return;
      let focusedElement = ownerDocument.activeElement;
      if (!$9bf71ea28793e738$var$isElementInChildScope(focusedElement, scopeRef) || !$9bf71ea28793e738$var$shouldRestoreFocus(scopeRef)) return;
      let treeNode = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef);
      if (!treeNode) return;
      let nodeToRestore = treeNode.nodeToRestore;
      let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(ownerDocument.body, {
        tabbable: true
      });
      walker.currentNode = focusedElement;
      let nextElement = e3.shiftKey ? walker.previousNode() : walker.nextNode();
      if (!nodeToRestore || !nodeToRestore.isConnected || nodeToRestore === ownerDocument.body) {
        nodeToRestore = void 0;
        treeNode.nodeToRestore = void 0;
      }
      if ((!nextElement || !$9bf71ea28793e738$var$isElementInChildScope(nextElement, scopeRef)) && nodeToRestore) {
        walker.currentNode = nodeToRestore;
        do
          nextElement = e3.shiftKey ? walker.previousNode() : walker.nextNode();
        while ($9bf71ea28793e738$var$isElementInChildScope(nextElement, scopeRef));
        e3.preventDefault();
        e3.stopPropagation();
        if (nextElement) $9bf71ea28793e738$var$focusElement(nextElement, true);
        else if (!$9bf71ea28793e738$var$isElementInAnyScope(nodeToRestore)) focusedElement.blur();
        else $9bf71ea28793e738$var$focusElement(nodeToRestore, true);
      }
    };
    if (!contain) ownerDocument.addEventListener("keydown", onKeyDown, true);
    return () => {
      if (!contain) ownerDocument.removeEventListener("keydown", onKeyDown, true);
    };
  }, [
    scopeRef,
    restoreFocus,
    contain
  ]);
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    const ownerDocument = $431fbd86ca7dc216$export$b204af158042fbac(scopeRef.current ? scopeRef.current[0] : void 0);
    if (!restoreFocus) return;
    let treeNode = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef);
    if (!treeNode) return;
    var _nodeToRestoreRef_current;
    treeNode.nodeToRestore = (_nodeToRestoreRef_current = nodeToRestoreRef.current) !== null && _nodeToRestoreRef_current !== void 0 ? _nodeToRestoreRef_current : void 0;
    return () => {
      let treeNode2 = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef);
      if (!treeNode2) return;
      let nodeToRestore = treeNode2.nodeToRestore;
      let activeElement = $d4ee10de306f2510$export$cd4e5573fbe2b576(ownerDocument);
      if (restoreFocus && nodeToRestore && (activeElement && $9bf71ea28793e738$var$isElementInChildScope(activeElement, scopeRef) || activeElement === ownerDocument.body && $9bf71ea28793e738$var$shouldRestoreFocus(scopeRef))) {
        let clonedTree = $9bf71ea28793e738$export$d06fae2ee68b101e.clone();
        requestAnimationFrame(() => {
          if (ownerDocument.activeElement === ownerDocument.body) {
            let treeNode3 = clonedTree.getTreeNode(scopeRef);
            while (treeNode3) {
              if (treeNode3.nodeToRestore && treeNode3.nodeToRestore.isConnected) {
                $9bf71ea28793e738$var$restoreFocusToElement(treeNode3.nodeToRestore);
                return;
              }
              treeNode3 = treeNode3.parent;
            }
            treeNode3 = clonedTree.getTreeNode(scopeRef);
            while (treeNode3) {
              if (treeNode3.scopeRef && treeNode3.scopeRef.current && $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(treeNode3.scopeRef)) {
                let node = $9bf71ea28793e738$var$getFirstInScope(treeNode3.scopeRef.current, true);
                $9bf71ea28793e738$var$restoreFocusToElement(node);
                return;
              }
              treeNode3 = treeNode3.parent;
            }
          }
        });
      }
    };
  }, [
    scopeRef,
    restoreFocus
  ]);
}
function $9bf71ea28793e738$var$restoreFocusToElement(node) {
  if (node.dispatchEvent(new CustomEvent($9bf71ea28793e738$var$RESTORE_FOCUS_EVENT, {
    bubbles: true,
    cancelable: true
  }))) $9bf71ea28793e738$var$focusElement(node);
}
function $9bf71ea28793e738$export$2d6ec8fc375ceafa(root, opts, scope) {
  let filter2 = (opts === null || opts === void 0 ? void 0 : opts.tabbable) ? $b4b717babfbb907b$export$bebd5a1431fec25d : $b4b717babfbb907b$export$4c063cf1350e6fed;
  let rootElement = (root === null || root === void 0 ? void 0 : root.nodeType) === Node.ELEMENT_NODE ? root : null;
  let doc = $431fbd86ca7dc216$export$b204af158042fbac(rootElement);
  let walker = $dfc540311bf7f109$export$4d0f8be8b12a7ef6(doc, root || doc, NodeFilter.SHOW_ELEMENT, {
    acceptNode(node) {
      var _opts_from;
      if (opts === null || opts === void 0 ? void 0 : (_opts_from = opts.from) === null || _opts_from === void 0 ? void 0 : _opts_from.contains(node)) return NodeFilter.FILTER_REJECT;
      if (filter2(node) && $645f2e67b85a24c9$export$e989c0fffaa6b27a(node) && (!scope || $9bf71ea28793e738$var$isElementInScope(node, scope)) && (!(opts === null || opts === void 0 ? void 0 : opts.accept) || opts.accept(node))) return NodeFilter.FILTER_ACCEPT;
      return NodeFilter.FILTER_SKIP;
    }
  });
  if (opts === null || opts === void 0 ? void 0 : opts.from) walker.currentNode = opts.from;
  return walker;
}
class $9bf71ea28793e738$var$Tree {
  get size() {
    return this.fastMap.size;
  }
  getTreeNode(data) {
    return this.fastMap.get(data);
  }
  addTreeNode(scopeRef, parent, nodeToRestore) {
    let parentNode = this.fastMap.get(parent !== null && parent !== void 0 ? parent : null);
    if (!parentNode) return;
    let node = new $9bf71ea28793e738$var$TreeNode({
      scopeRef
    });
    parentNode.addChild(node);
    node.parent = parentNode;
    this.fastMap.set(scopeRef, node);
    if (nodeToRestore) node.nodeToRestore = nodeToRestore;
  }
  addNode(node) {
    this.fastMap.set(node.scopeRef, node);
  }
  removeTreeNode(scopeRef) {
    if (scopeRef === null) return;
    let node = this.fastMap.get(scopeRef);
    if (!node) return;
    let parentNode = node.parent;
    for (let current of this.traverse()) if (current !== node && node.nodeToRestore && current.nodeToRestore && node.scopeRef && node.scopeRef.current && $9bf71ea28793e738$var$isElementInScope(current.nodeToRestore, node.scopeRef.current)) current.nodeToRestore = node.nodeToRestore;
    let children = node.children;
    if (parentNode) {
      parentNode.removeChild(node);
      if (children.size > 0) children.forEach((child) => parentNode && parentNode.addChild(child));
    }
    this.fastMap.delete(node.scopeRef);
  }
  // Pre Order Depth First
  *traverse(node = this.root) {
    if (node.scopeRef != null) yield node;
    if (node.children.size > 0) for (let child of node.children) yield* this.traverse(child);
  }
  clone() {
    var _node_parent;
    let newTree = new $9bf71ea28793e738$var$Tree();
    var _node_parent_scopeRef;
    for (let node of this.traverse()) newTree.addTreeNode(node.scopeRef, (_node_parent_scopeRef = (_node_parent = node.parent) === null || _node_parent === void 0 ? void 0 : _node_parent.scopeRef) !== null && _node_parent_scopeRef !== void 0 ? _node_parent_scopeRef : null, node.nodeToRestore);
    return newTree;
  }
  constructor() {
    this.fastMap = /* @__PURE__ */ new Map();
    this.root = new $9bf71ea28793e738$var$TreeNode({
      scopeRef: null
    });
    this.fastMap.set(null, this.root);
  }
}
class $9bf71ea28793e738$var$TreeNode {
  addChild(node) {
    this.children.add(node);
    node.parent = this;
  }
  removeChild(node) {
    this.children.delete(node);
    node.parent = void 0;
  }
  constructor(props) {
    this.children = /* @__PURE__ */ new Set();
    this.contain = false;
    this.scopeRef = props.scopeRef;
  }
}
let $9bf71ea28793e738$export$d06fae2ee68b101e = new $9bf71ea28793e738$var$Tree();
function $f7dceffc5ad7768b$export$4e328f61c538687f(props = {}) {
  let { autoFocus = false, isTextInput, within } = props;
  let state = useRef({
    isFocused: false,
    isFocusVisible: autoFocus || $507fabe10e71c6fb$export$b9b3dfddab17db27()
  });
  let [isFocused, setFocused] = useState(false);
  let [isFocusVisibleState, setFocusVisible] = useState(() => state.current.isFocused && state.current.isFocusVisible);
  let updateState = useCallback(() => setFocusVisible(state.current.isFocused && state.current.isFocusVisible), []);
  let onFocusChange = useCallback((isFocused2) => {
    state.current.isFocused = isFocused2;
    setFocused(isFocused2);
    updateState();
  }, [
    updateState
  ]);
  $507fabe10e71c6fb$export$ec71b4b83ac08ec3((isFocusVisible) => {
    state.current.isFocusVisible = isFocusVisible;
    updateState();
  }, [], {
    isTextInput
  });
  let { focusProps } = $a1ea59d68270f0dd$export$f8168d8dd8fd66e6({
    isDisabled: within,
    onFocusChange
  });
  let { focusWithinProps } = $9ab94262bd0047c7$export$420e68273165f4ec({
    isDisabled: !within,
    onFocusWithinChange: onFocusChange
  });
  return {
    isFocused,
    isFocusVisible: isFocusVisibleState,
    focusProps: within ? focusWithinProps : focusProps
  };
}
const $319e236875307eab$var$LIVEREGION_TIMEOUT_DELAY = 7e3;
let $319e236875307eab$var$liveAnnouncer = null;
function $319e236875307eab$export$a9b970dcc4ae71a9(message, assertiveness = "assertive", timeout = $319e236875307eab$var$LIVEREGION_TIMEOUT_DELAY) {
  if (!$319e236875307eab$var$liveAnnouncer) {
    $319e236875307eab$var$liveAnnouncer = new $319e236875307eab$var$LiveAnnouncer();
    if (!(typeof IS_REACT_ACT_ENVIRONMENT === "boolean" ? IS_REACT_ACT_ENVIRONMENT : typeof jest !== "undefined")) setTimeout(() => {
      if ($319e236875307eab$var$liveAnnouncer === null || $319e236875307eab$var$liveAnnouncer === void 0 ? void 0 : $319e236875307eab$var$liveAnnouncer.isAttached()) $319e236875307eab$var$liveAnnouncer === null || $319e236875307eab$var$liveAnnouncer === void 0 ? void 0 : $319e236875307eab$var$liveAnnouncer.announce(message, assertiveness, timeout);
    }, 100);
    else $319e236875307eab$var$liveAnnouncer.announce(message, assertiveness, timeout);
  } else $319e236875307eab$var$liveAnnouncer.announce(message, assertiveness, timeout);
}
class $319e236875307eab$var$LiveAnnouncer {
  isAttached() {
    var _this_node;
    return (_this_node = this.node) === null || _this_node === void 0 ? void 0 : _this_node.isConnected;
  }
  createLog(ariaLive) {
    let node = document.createElement("div");
    node.setAttribute("role", "log");
    node.setAttribute("aria-live", ariaLive);
    node.setAttribute("aria-relevant", "additions");
    return node;
  }
  destroy() {
    if (!this.node) return;
    document.body.removeChild(this.node);
    this.node = null;
  }
  announce(message, assertiveness = "assertive", timeout = $319e236875307eab$var$LIVEREGION_TIMEOUT_DELAY) {
    var _this_assertiveLog, _this_politeLog;
    if (!this.node) return;
    let node = document.createElement("div");
    if (typeof message === "object") {
      node.setAttribute("role", "img");
      node.setAttribute("aria-labelledby", message["aria-labelledby"]);
    } else node.textContent = message;
    if (assertiveness === "assertive") (_this_assertiveLog = this.assertiveLog) === null || _this_assertiveLog === void 0 ? void 0 : _this_assertiveLog.appendChild(node);
    else (_this_politeLog = this.politeLog) === null || _this_politeLog === void 0 ? void 0 : _this_politeLog.appendChild(node);
    if (message !== "") setTimeout(() => {
      node.remove();
    }, timeout);
  }
  clear(assertiveness) {
    if (!this.node) return;
    if ((!assertiveness || assertiveness === "assertive") && this.assertiveLog) this.assertiveLog.innerHTML = "";
    if ((!assertiveness || assertiveness === "polite") && this.politeLog) this.politeLog.innerHTML = "";
  }
  constructor() {
    this.node = null;
    this.assertiveLog = null;
    this.politeLog = null;
    if (typeof document !== "undefined") {
      this.node = document.createElement("div");
      this.node.dataset.liveAnnouncer = "true";
      Object.assign(this.node.style, {
        border: 0,
        clip: "rect(0 0 0 0)",
        clipPath: "inset(50%)",
        height: "1px",
        margin: "-1px",
        overflow: "hidden",
        padding: 0,
        position: "absolute",
        width: "1px",
        whiteSpace: "nowrap"
      });
      this.assertiveLog = this.createLog("assertive");
      this.node.appendChild(this.assertiveLog);
      this.politeLog = this.createLog("polite");
      this.node.appendChild(this.politeLog);
      document.body.prepend(this.node);
    }
  }
}
const $e5be200c675c3b3a$export$aca958c65c314e6c = {
  badInput: false,
  customError: false,
  patternMismatch: false,
  rangeOverflow: false,
  rangeUnderflow: false,
  stepMismatch: false,
  tooLong: false,
  tooShort: false,
  typeMismatch: false,
  valueMissing: false,
  valid: true
};
const $e5be200c675c3b3a$var$CUSTOM_VALIDITY_STATE = {
  ...$e5be200c675c3b3a$export$aca958c65c314e6c,
  customError: true,
  valid: false
};
const $e5be200c675c3b3a$export$dad6ae84456c676a = {
  isInvalid: false,
  validationDetails: $e5be200c675c3b3a$export$aca958c65c314e6c,
  validationErrors: []
};
const $e5be200c675c3b3a$export$571b5131b7e65c11 = createContext({});
const $e5be200c675c3b3a$export$a763b9476acd3eb = "__formValidationState" + Date.now();
function $e5be200c675c3b3a$export$fc1a364ae1f3ff10(props) {
  if (props[$e5be200c675c3b3a$export$a763b9476acd3eb]) {
    let { realtimeValidation, displayValidation, updateValidation, resetValidation, commitValidation } = props[$e5be200c675c3b3a$export$a763b9476acd3eb];
    return {
      realtimeValidation,
      displayValidation,
      updateValidation,
      resetValidation,
      commitValidation
    };
  }
  return $e5be200c675c3b3a$var$useFormValidationStateImpl(props);
}
function $e5be200c675c3b3a$var$useFormValidationStateImpl(props) {
  let { isInvalid, validationState, name, value, builtinValidation, validate, validationBehavior = "aria" } = props;
  if (validationState) isInvalid || (isInvalid = validationState === "invalid");
  let controlledError = isInvalid !== void 0 ? {
    isInvalid,
    validationErrors: [],
    validationDetails: $e5be200c675c3b3a$var$CUSTOM_VALIDITY_STATE
  } : null;
  let clientError = useMemo(() => {
    if (!validate || value == null) return null;
    let validateErrors = $e5be200c675c3b3a$var$runValidate(validate, value);
    return $e5be200c675c3b3a$var$getValidationResult(validateErrors);
  }, [
    validate,
    value
  ]);
  if (builtinValidation === null || builtinValidation === void 0 ? void 0 : builtinValidation.validationDetails.valid) builtinValidation = void 0;
  let serverErrors = useContext($e5be200c675c3b3a$export$571b5131b7e65c11);
  let serverErrorMessages = useMemo(() => {
    if (name) return Array.isArray(name) ? name.flatMap((name2) => $e5be200c675c3b3a$var$asArray(serverErrors[name2])) : $e5be200c675c3b3a$var$asArray(serverErrors[name]);
    return [];
  }, [
    serverErrors,
    name
  ]);
  let [lastServerErrors, setLastServerErrors] = useState(serverErrors);
  let [isServerErrorCleared, setServerErrorCleared] = useState(false);
  if (serverErrors !== lastServerErrors) {
    setLastServerErrors(serverErrors);
    setServerErrorCleared(false);
  }
  let serverError = useMemo(() => $e5be200c675c3b3a$var$getValidationResult(isServerErrorCleared ? [] : serverErrorMessages), [
    isServerErrorCleared,
    serverErrorMessages
  ]);
  let nextValidation = useRef($e5be200c675c3b3a$export$dad6ae84456c676a);
  let [currentValidity, setCurrentValidity] = useState($e5be200c675c3b3a$export$dad6ae84456c676a);
  let lastError = useRef($e5be200c675c3b3a$export$dad6ae84456c676a);
  let commitValidation = () => {
    if (!commitQueued) return;
    setCommitQueued(false);
    let error = clientError || builtinValidation || nextValidation.current;
    if (!$e5be200c675c3b3a$var$isEqualValidation(error, lastError.current)) {
      lastError.current = error;
      setCurrentValidity(error);
    }
  };
  let [commitQueued, setCommitQueued] = useState(false);
  useEffect(commitValidation);
  let realtimeValidation = controlledError || serverError || clientError || builtinValidation || $e5be200c675c3b3a$export$dad6ae84456c676a;
  let displayValidation = validationBehavior === "native" ? controlledError || serverError || currentValidity : controlledError || serverError || clientError || builtinValidation || currentValidity;
  return {
    realtimeValidation,
    displayValidation,
    updateValidation(value2) {
      if (validationBehavior === "aria" && !$e5be200c675c3b3a$var$isEqualValidation(currentValidity, value2)) setCurrentValidity(value2);
      else nextValidation.current = value2;
    },
    resetValidation() {
      let error = $e5be200c675c3b3a$export$dad6ae84456c676a;
      if (!$e5be200c675c3b3a$var$isEqualValidation(error, lastError.current)) {
        lastError.current = error;
        setCurrentValidity(error);
      }
      if (validationBehavior === "native") setCommitQueued(false);
      setServerErrorCleared(true);
    },
    commitValidation() {
      if (validationBehavior === "native") setCommitQueued(true);
      setServerErrorCleared(true);
    }
  };
}
function $e5be200c675c3b3a$var$asArray(v2) {
  if (!v2) return [];
  return Array.isArray(v2) ? v2 : [
    v2
  ];
}
function $e5be200c675c3b3a$var$runValidate(validate, value) {
  if (typeof validate === "function") {
    let e3 = validate(value);
    if (e3 && typeof e3 !== "boolean") return $e5be200c675c3b3a$var$asArray(e3);
  }
  return [];
}
function $e5be200c675c3b3a$var$getValidationResult(errors) {
  return errors.length ? {
    isInvalid: true,
    validationErrors: errors,
    validationDetails: $e5be200c675c3b3a$var$CUSTOM_VALIDITY_STATE
  } : null;
}
function $e5be200c675c3b3a$var$isEqualValidation(a4, b3) {
  if (a4 === b3) return true;
  return !!a4 && !!b3 && a4.isInvalid === b3.isInvalid && a4.validationErrors.length === b3.validationErrors.length && a4.validationErrors.every((a5, i3) => a5 === b3.validationErrors[i3]) && Object.entries(a4.validationDetails).every(([k3, v2]) => b3.validationDetails[k3] === v2);
}
function $e93e671b31057976$export$b8473d3665f3a75a(props, state, ref) {
  let { validationBehavior, focus } = props;
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    if (validationBehavior === "native" && (ref === null || ref === void 0 ? void 0 : ref.current) && !ref.current.disabled) {
      let errorMessage = state.realtimeValidation.isInvalid ? state.realtimeValidation.validationErrors.join(" ") || "Invalid value." : "";
      ref.current.setCustomValidity(errorMessage);
      if (!ref.current.hasAttribute("title")) ref.current.title = "";
      if (!state.realtimeValidation.isInvalid) state.updateValidation($e93e671b31057976$var$getNativeValidity(ref.current));
    }
  });
  let onReset = $8ae05eaa5c114e9c$export$7f54fc3180508a52(() => {
    state.resetValidation();
  });
  let onInvalid = $8ae05eaa5c114e9c$export$7f54fc3180508a52((e3) => {
    var _ref_current;
    if (!state.displayValidation.isInvalid) state.commitValidation();
    let form = ref === null || ref === void 0 ? void 0 : (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.form;
    if (!e3.defaultPrevented && ref && form && $e93e671b31057976$var$getFirstInvalidInput(form) === ref.current) {
      var _ref_current1;
      if (focus) focus();
      else (_ref_current1 = ref.current) === null || _ref_current1 === void 0 ? void 0 : _ref_current1.focus();
      $507fabe10e71c6fb$export$8397ddfc504fdb9a("keyboard");
    }
    e3.preventDefault();
  });
  let onChange = $8ae05eaa5c114e9c$export$7f54fc3180508a52(() => {
    state.commitValidation();
  });
  useEffect(() => {
    let input = ref === null || ref === void 0 ? void 0 : ref.current;
    if (!input) return;
    let form = input.form;
    input.addEventListener("invalid", onInvalid);
    input.addEventListener("change", onChange);
    form === null || form === void 0 ? void 0 : form.addEventListener("reset", onReset);
    return () => {
      input.removeEventListener("invalid", onInvalid);
      input.removeEventListener("change", onChange);
      form === null || form === void 0 ? void 0 : form.removeEventListener("reset", onReset);
    };
  }, [
    ref,
    onInvalid,
    onChange,
    onReset,
    validationBehavior
  ]);
}
function $e93e671b31057976$var$getValidity(input) {
  let validity = input.validity;
  return {
    badInput: validity.badInput,
    customError: validity.customError,
    patternMismatch: validity.patternMismatch,
    rangeOverflow: validity.rangeOverflow,
    rangeUnderflow: validity.rangeUnderflow,
    stepMismatch: validity.stepMismatch,
    tooLong: validity.tooLong,
    tooShort: validity.tooShort,
    typeMismatch: validity.typeMismatch,
    valueMissing: validity.valueMissing,
    valid: validity.valid
  };
}
function $e93e671b31057976$var$getNativeValidity(input) {
  return {
    isInvalid: !input.validity.valid,
    validationDetails: $e93e671b31057976$var$getValidity(input),
    validationErrors: input.validationMessage ? [
      input.validationMessage
    ] : []
  };
}
function $e93e671b31057976$var$getFirstInvalidInput(form) {
  for (let i3 = 0; i3 < form.elements.length; i3++) {
    let element = form.elements[i3];
    if (!element.validity.valid) return element;
  }
  return null;
}
function $d191a55c9702f145$export$8467354a121f1b9f(props) {
  let { id: id2, label, "aria-labelledby": ariaLabelledby, "aria-label": ariaLabel, labelElementType = "label" } = props;
  id2 = $bdb11010cef70236$export$f680877a34711e37(id2);
  let labelId = $bdb11010cef70236$export$f680877a34711e37();
  let labelProps = {};
  if (label) {
    ariaLabelledby = ariaLabelledby ? `${labelId} ${ariaLabelledby}` : labelId;
    labelProps = {
      id: labelId,
      htmlFor: labelElementType === "label" ? id2 : void 0
    };
  } else if (!ariaLabelledby && !ariaLabel) console.warn("If you do not provide a visible label, you must specify an aria-label or aria-labelledby attribute for accessibility");
  let fieldProps = $313b98861ee5dd6c$export$d6875122194c7b44({
    id: id2,
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledby
  });
  return {
    labelProps,
    fieldProps
  };
}
function $2baaea4c71418dea$export$294aa081a6c6f55d(props) {
  let { description, errorMessage, isInvalid, validationState } = props;
  let { labelProps, fieldProps } = $d191a55c9702f145$export$8467354a121f1b9f(props);
  let descriptionId = $bdb11010cef70236$export$b4cc09c592e8fdb8([
    Boolean(description),
    Boolean(errorMessage),
    isInvalid,
    validationState
  ]);
  let errorMessageId = $bdb11010cef70236$export$b4cc09c592e8fdb8([
    Boolean(description),
    Boolean(errorMessage),
    isInvalid,
    validationState
  ]);
  fieldProps = $3ef42575df84b30b$export$9d1611c77c2fe928(fieldProps, {
    "aria-describedby": [
      descriptionId,
      // Use aria-describedby for error message because aria-errormessage is unsupported using VoiceOver or NVDA. See https://github.com/adobe/react-spectrum/issues/1346#issuecomment-740136268
      errorMessageId,
      props["aria-describedby"]
    ].filter(Boolean).join(" ") || void 0
  });
  return {
    labelProps,
    fieldProps,
    descriptionProps: {
      id: descriptionId
    },
    errorMessageProps: {
      id: errorMessageId
    }
  };
}
const $5c3e21d68f1c4674$var$styles = {
  border: 0,
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  width: "1px",
  whiteSpace: "nowrap"
};
function $5c3e21d68f1c4674$export$a966af930f325cab(props = {}) {
  let { style, isFocusable } = props;
  let [isFocused, setFocused] = useState(false);
  let { focusWithinProps } = $9ab94262bd0047c7$export$420e68273165f4ec({
    isDisabled: !isFocusable,
    onFocusWithinChange: (val) => setFocused(val)
  });
  let combinedStyles = useMemo(() => {
    if (isFocused) return style;
    else if (style) return {
      ...$5c3e21d68f1c4674$var$styles,
      ...style
    };
    else return $5c3e21d68f1c4674$var$styles;
  }, [
    isFocused
  ]);
  return {
    visuallyHiddenProps: {
      ...focusWithinProps,
      style: combinedStyles
    }
  };
}
function $5c3e21d68f1c4674$export$439d29a4e110a164(props) {
  let { children, elementType: Element2 = "div", isFocusable, style, ...otherProps } = props;
  let { visuallyHiddenProps } = $5c3e21d68f1c4674$export$a966af930f325cab(props);
  return /* @__PURE__ */ React__default.createElement(Element2, $3ef42575df84b30b$export$9d1611c77c2fe928(otherProps, visuallyHiddenProps), children);
}
function $5e910fae8e128ead$export$6e3e27031a30522f(props, state, ref) {
  let { isDisabled } = props;
  let triggerId = $bdb11010cef70236$export$f680877a34711e37();
  let panelId = $bdb11010cef70236$export$f680877a34711e37();
  let isSSR = $b5e257d569688ac6$export$535bd6ca7f90a273();
  let supportsBeforeMatch = !isSSR && "onbeforematch" in document.body;
  let raf = useRef(null);
  let handleBeforeMatch = useCallback(() => {
    raf.current = requestAnimationFrame(() => {
      if (ref.current) ref.current.setAttribute("hidden", "until-found");
    });
    flushSync$1(() => {
      state.toggle();
    });
  }, [
    ref,
    state
  ]);
  $e9faafb641e167db$export$90fc3a17d93f704c(ref, "beforematch", supportsBeforeMatch ? handleBeforeMatch : null);
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    if (raf.current) cancelAnimationFrame(raf.current);
    if (supportsBeforeMatch && ref.current && !isDisabled) {
      if (state.isExpanded) ref.current.removeAttribute("hidden");
      else ref.current.setAttribute("hidden", "until-found");
    }
  }, [
    isDisabled,
    ref,
    state.isExpanded,
    supportsBeforeMatch
  ]);
  useEffect(() => {
    return () => {
      if (raf.current) cancelAnimationFrame(raf.current);
    };
  }, []);
  return {
    buttonProps: {
      id: triggerId,
      "aria-expanded": state.isExpanded,
      "aria-controls": panelId,
      onPress: (e3) => {
        if (!isDisabled && e3.pointerType !== "keyboard") state.toggle();
      },
      isDisabled,
      onPressStart(e3) {
        if (e3.pointerType === "keyboard" && !isDisabled) state.toggle();
      }
    },
    panelProps: {
      id: panelId,
      // This can be overridden at the panel element level.
      role: "group",
      "aria-labelledby": triggerId,
      "aria-hidden": !state.isExpanded,
      hidden: supportsBeforeMatch ? true : !state.isExpanded
    }
  };
}
const $884aeceb3d67f00f$export$37b65e5b5444d35c = /* @__PURE__ */ new WeakMap();
function $0d5c49892c1215da$export$37b0961d2f4751e2(props, state, ref) {
  let { value, children, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledby } = props;
  const isDisabled = props.isDisabled || state.isDisabled;
  let hasChildren = children != null;
  let hasAriaLabel = ariaLabel != null || ariaLabelledby != null;
  if (!hasChildren && !hasAriaLabel) console.warn("If you do not provide children, you must specify an aria-label for accessibility");
  let checked = state.selectedValue === value;
  let onChange = (e3) => {
    e3.stopPropagation();
    state.setSelectedValue(value);
  };
  let { pressProps, isPressed } = $f6c31cce2adf654f$export$45712eceda6fad21({
    isDisabled
  });
  let { pressProps: labelProps, isPressed: isLabelPressed } = $f6c31cce2adf654f$export$45712eceda6fad21({
    isDisabled,
    onPress() {
      var _ref_current;
      state.setSelectedValue(value);
      (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.focus();
    }
  });
  let { focusableProps } = $f645667febf57a63$export$4c014de7c8940b4c($3ef42575df84b30b$export$9d1611c77c2fe928(props, {
    onFocus: () => state.setLastFocusedValue(value)
  }), ref);
  let interactions = $3ef42575df84b30b$export$9d1611c77c2fe928(pressProps, focusableProps);
  let domProps = $65484d02dcb7eb3e$export$457c3d6518dd4c6f(props, {
    labelable: true
  });
  let tabIndex = -1;
  if (state.selectedValue != null) {
    if (state.selectedValue === value) tabIndex = 0;
  } else if (state.lastFocusedValue === value || state.lastFocusedValue == null) tabIndex = 0;
  if (isDisabled) tabIndex = void 0;
  let { name, descriptionId, errorMessageId, validationBehavior } = $884aeceb3d67f00f$export$37b65e5b5444d35c.get(state);
  $99facab73266f662$export$5add1d006293d136(ref, state.selectedValue, state.setSelectedValue);
  $e93e671b31057976$export$b8473d3665f3a75a({
    validationBehavior
  }, state, ref);
  return {
    labelProps: $3ef42575df84b30b$export$9d1611c77c2fe928(labelProps, {
      onClick: (e3) => e3.preventDefault()
    }),
    inputProps: $3ef42575df84b30b$export$9d1611c77c2fe928(domProps, {
      ...interactions,
      type: "radio",
      name,
      tabIndex,
      disabled: isDisabled,
      required: state.isRequired && validationBehavior === "native",
      checked,
      value,
      onChange,
      "aria-describedby": [
        props["aria-describedby"],
        state.isInvalid ? errorMessageId : null,
        descriptionId
      ].filter(Boolean).join(" ") || void 0
    }),
    isDisabled,
    isSelected: checked,
    isPressed: isPressed || isLabelPressed
  };
}
function $430f30ed08ec25fa$export$62b9571f283ff5c2(props, state) {
  let { name, isReadOnly, isRequired, isDisabled, orientation = "vertical", validationBehavior = "aria" } = props;
  let { direction } = $18f2051aff69b9bf$export$43bb16f9c6d9e3f7();
  let { isInvalid, validationErrors, validationDetails } = state.displayValidation;
  let { labelProps, fieldProps, descriptionProps, errorMessageProps } = $2baaea4c71418dea$export$294aa081a6c6f55d({
    ...props,
    // Radio group is not an HTML input element so it
    // shouldn't be labeled by a <label> element.
    labelElementType: "span",
    isInvalid: state.isInvalid,
    errorMessage: props.errorMessage || validationErrors
  });
  let domProps = $65484d02dcb7eb3e$export$457c3d6518dd4c6f(props, {
    labelable: true
  });
  let { focusWithinProps } = $9ab94262bd0047c7$export$420e68273165f4ec({
    onBlurWithin(e3) {
      var _props_onBlur;
      (_props_onBlur = props.onBlur) === null || _props_onBlur === void 0 ? void 0 : _props_onBlur.call(props, e3);
      if (!state.selectedValue) state.setLastFocusedValue(null);
    },
    onFocusWithin: props.onFocus,
    onFocusWithinChange: props.onFocusChange
  });
  let onKeyDown = (e3) => {
    let nextDir;
    switch (e3.key) {
      case "ArrowRight":
        if (direction === "rtl" && orientation !== "vertical") nextDir = "prev";
        else nextDir = "next";
        break;
      case "ArrowLeft":
        if (direction === "rtl" && orientation !== "vertical") nextDir = "next";
        else nextDir = "prev";
        break;
      case "ArrowDown":
        nextDir = "next";
        break;
      case "ArrowUp":
        nextDir = "prev";
        break;
      default:
        return;
    }
    e3.preventDefault();
    let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(e3.currentTarget, {
      from: e3.target
    });
    let nextElem;
    if (nextDir === "next") {
      nextElem = walker.nextNode();
      if (!nextElem) {
        walker.currentNode = e3.currentTarget;
        nextElem = walker.firstChild();
      }
    } else {
      nextElem = walker.previousNode();
      if (!nextElem) {
        walker.currentNode = e3.currentTarget;
        nextElem = walker.lastChild();
      }
    }
    if (nextElem) {
      nextElem.focus();
      state.setSelectedValue(nextElem.value);
    }
  };
  let groupName = $bdb11010cef70236$export$f680877a34711e37(name);
  $884aeceb3d67f00f$export$37b65e5b5444d35c.set(state, {
    name: groupName,
    descriptionId: descriptionProps.id,
    errorMessageId: errorMessageProps.id,
    validationBehavior
  });
  return {
    radioGroupProps: $3ef42575df84b30b$export$9d1611c77c2fe928(domProps, {
      // https://www.w3.org/TR/wai-aria-1.2/#radiogroup
      role: "radiogroup",
      onKeyDown,
      "aria-invalid": state.isInvalid || void 0,
      "aria-errormessage": props["aria-errormessage"],
      "aria-readonly": isReadOnly || void 0,
      "aria-required": isRequired || void 0,
      "aria-disabled": isDisabled || void 0,
      "aria-orientation": orientation,
      ...fieldProps,
      ...focusWithinProps
    }),
    labelProps,
    descriptionProps,
    errorMessageProps,
    isInvalid,
    validationErrors,
    validationDetails
  };
}
const $01b77f81d0f07f68$export$75b6ee27786ba447 = /* @__PURE__ */ createContext({});
const $0393f8ab869a0f1a$export$e9f3bf65a26ce129 = /* @__PURE__ */ createContext(null);
const $d2b4bc8c273e7be6$var$additionalButtonHTMLAttributes = /* @__PURE__ */ new Set([
  "form",
  "formAction",
  "formEncType",
  "formMethod",
  "formNoValidate",
  "formTarget",
  "name",
  "value"
]);
const $d2b4bc8c273e7be6$export$24d547caef80ccd1 = /* @__PURE__ */ createContext({});
const $d2b4bc8c273e7be6$export$353f5b6fc5456de1 = /* @__PURE__ */ $f39a9eba43920ace$export$86427a43e3e48ebb(function Button(props, ref) {
  [props, ref] = $64fa3d84918910a7$export$29f1550f4b0d4415(props, ref, $d2b4bc8c273e7be6$export$24d547caef80ccd1);
  props = $d2b4bc8c273e7be6$var$disablePendingProps(props);
  let ctx = props;
  let { isPending } = ctx;
  let { buttonProps, isPressed } = $701a24aa0da5b062$export$ea18c227d4417cc3(props, ref);
  let { focusProps, isFocused, isFocusVisible } = $f7dceffc5ad7768b$export$4e328f61c538687f(props);
  let { hoverProps, isHovered } = $6179b936705e76d3$export$ae780daf29e6d456({
    ...props,
    isDisabled: props.isDisabled || isPending
  });
  let renderValues = {
    isHovered,
    isPressed: (ctx.isPressed || isPressed) && !isPending,
    isFocused,
    isFocusVisible,
    isDisabled: props.isDisabled || false,
    isPending: isPending !== null && isPending !== void 0 ? isPending : false
  };
  let renderProps = $64fa3d84918910a7$export$4d86445c2cf5e3({
    ...props,
    values: renderValues,
    defaultClassName: "react-aria-Button"
  });
  let buttonId = $bdb11010cef70236$export$f680877a34711e37(buttonProps.id);
  let progressId = $bdb11010cef70236$export$f680877a34711e37();
  let ariaLabelledby = buttonProps["aria-labelledby"];
  if (isPending) {
    if (ariaLabelledby) ariaLabelledby = `${ariaLabelledby} ${progressId}`;
    else if (buttonProps["aria-label"]) ariaLabelledby = `${buttonId} ${progressId}`;
  }
  let wasPending = useRef(isPending);
  useEffect(() => {
    let message = {
      "aria-labelledby": ariaLabelledby || buttonId
    };
    if (!wasPending.current && isFocused && isPending) $319e236875307eab$export$a9b970dcc4ae71a9(message, "assertive");
    else if (wasPending.current && isFocused && !isPending) $319e236875307eab$export$a9b970dcc4ae71a9(message, "assertive");
    wasPending.current = isPending;
  }, [
    isPending,
    isFocused,
    ariaLabelledby,
    buttonId
  ]);
  return /* @__PURE__ */ React__default.createElement("button", {
    ...$65484d02dcb7eb3e$export$457c3d6518dd4c6f(props, {
      propNames: $d2b4bc8c273e7be6$var$additionalButtonHTMLAttributes
    }),
    ...$3ef42575df84b30b$export$9d1611c77c2fe928(buttonProps, focusProps, hoverProps),
    ...renderProps,
    type: buttonProps.type === "submit" && isPending ? "button" : buttonProps.type,
    id: buttonId,
    ref,
    "aria-labelledby": ariaLabelledby,
    slot: props.slot || void 0,
    "aria-disabled": isPending ? "true" : buttonProps["aria-disabled"],
    "data-disabled": props.isDisabled || void 0,
    "data-pressed": renderValues.isPressed || void 0,
    "data-hovered": isHovered || void 0,
    "data-focused": isFocused || void 0,
    "data-pending": isPending || void 0,
    "data-focus-visible": isFocusVisible || void 0
  }, /* @__PURE__ */ React__default.createElement($0393f8ab869a0f1a$export$e9f3bf65a26ce129.Provider, {
    value: {
      id: progressId
    }
  }, renderProps.children));
});
function $d2b4bc8c273e7be6$var$disablePendingProps(props) {
  if (props.isPending) {
    props.onPress = void 0;
    props.onPressStart = void 0;
    props.onPressEnd = void 0;
    props.onPressChange = void 0;
    props.onPressUp = void 0;
    props.onKeyDown = void 0;
    props.onKeyUp = void 0;
    props.onClick = void 0;
    props.href = void 0;
  }
  return props;
}
const $514c0188e459b4c0$export$9afb8bc826b033ea = /* @__PURE__ */ createContext({});
const $ee014567cb39d3f0$export$ff05c3ac10437e03 = /* @__PURE__ */ createContext(null);
function $bf996d45f4a36925$export$3fcbf6e4407997e0(props) {
  let [isExpanded, setExpanded] = $458b0a5536c1a7cf$export$40bfa8c7b0832715(props.isExpanded, props.defaultExpanded || false, props.onExpandedChange);
  const expand = useCallback(() => {
    setExpanded(true);
  }, [
    setExpanded
  ]);
  const collapse = useCallback(() => {
    setExpanded(false);
  }, [
    setExpanded
  ]);
  const toggle = useCallback(() => {
    setExpanded(!isExpanded);
  }, [
    setExpanded,
    isExpanded
  ]);
  return {
    isExpanded,
    setExpanded,
    expand,
    collapse,
    toggle
  };
}
function $9385b3affbdec831$export$f36461af0ef4707d(props) {
  let { allowsMultipleExpanded = false, isDisabled = false } = props;
  let [expandedKeys, setExpandedKeys] = $458b0a5536c1a7cf$export$40bfa8c7b0832715(useMemo(() => props.expandedKeys ? new Set(props.expandedKeys) : void 0, [
    props.expandedKeys
  ]), useMemo(() => props.defaultExpandedKeys ? new Set(props.defaultExpandedKeys) : /* @__PURE__ */ new Set(), [
    props.defaultExpandedKeys
  ]), props.onExpandedChange);
  useEffect(() => {
    if (!allowsMultipleExpanded && expandedKeys.size > 1) setExpandedKeys(/* @__PURE__ */ new Set([
      expandedKeys.values().next().value
    ]));
  });
  return {
    allowsMultipleExpanded,
    isDisabled,
    expandedKeys,
    setExpandedKeys,
    toggleKey(key) {
      let keys2;
      if (allowsMultipleExpanded) {
        keys2 = new Set(expandedKeys);
        if (keys2.has(key)) keys2.delete(key);
        else keys2.add(key);
      } else keys2 = new Set(expandedKeys.has(key) ? [] : [
        key
      ]);
      setExpandedKeys(keys2);
    }
  };
}
let $a54cdc5c1942b639$var$instance = Math.round(Math.random() * 1e10);
let $a54cdc5c1942b639$var$i = 0;
function $a54cdc5c1942b639$export$bca9d026f8e704eb(props) {
  let name = useMemo(() => props.name || `radio-group-${$a54cdc5c1942b639$var$instance}-${++$a54cdc5c1942b639$var$i}`, [
    props.name
  ]);
  var _props_defaultValue;
  let [selectedValue, setSelected] = $458b0a5536c1a7cf$export$40bfa8c7b0832715(props.value, (_props_defaultValue = props.defaultValue) !== null && _props_defaultValue !== void 0 ? _props_defaultValue : null, props.onChange);
  let [lastFocusedValue, setLastFocusedValue] = useState(null);
  let validation = $e5be200c675c3b3a$export$fc1a364ae1f3ff10({
    ...props,
    value: selectedValue
  });
  let setSelectedValue = (value) => {
    if (!props.isReadOnly && !props.isDisabled) {
      setSelected(value);
      validation.commitValidation();
    }
  };
  let isInvalid = validation.displayValidation.isInvalid;
  return {
    ...validation,
    name,
    selectedValue,
    setSelectedValue,
    lastFocusedValue,
    setLastFocusedValue,
    isDisabled: props.isDisabled || false,
    isReadOnly: props.isReadOnly || false,
    isRequired: props.isRequired || false,
    validationState: props.validationState || (isInvalid ? "invalid" : null),
    isInvalid
  };
}
const $d3e0e05bdfcf66bd$export$c24727297075ec6a = /* @__PURE__ */ createContext(null);
const $28f4fd908f0de97f$export$1d40e3e0cc4d5de = /* @__PURE__ */ createContext(null);
const $28f4fd908f0de97f$export$944aceb4f8c89f10 = /* @__PURE__ */ forwardRef(function DisclosureGroup(props, ref) {
  let state = $9385b3affbdec831$export$f36461af0ef4707d(props);
  let renderProps = $64fa3d84918910a7$export$4d86445c2cf5e3({
    ...props,
    defaultClassName: "react-aria-DisclosureGroup",
    values: {
      isDisabled: state.isDisabled,
      state
    }
  });
  let domProps = $65484d02dcb7eb3e$export$457c3d6518dd4c6f(props);
  return /* @__PURE__ */ React__default.createElement("div", {
    ...domProps,
    ...renderProps,
    ref,
    "data-disabled": props.isDisabled || void 0
  }, /* @__PURE__ */ React__default.createElement($28f4fd908f0de97f$export$1d40e3e0cc4d5de.Provider, {
    value: state
  }, renderProps.children));
});
const $28f4fd908f0de97f$export$d665dd135a51b28a = /* @__PURE__ */ createContext(null);
const $28f4fd908f0de97f$export$dab3ea4a6ef094da = /* @__PURE__ */ createContext(null);
const $28f4fd908f0de97f$var$InternalDisclosureContext = /* @__PURE__ */ createContext(null);
const $28f4fd908f0de97f$export$74a362b31437ec83 = /* @__PURE__ */ forwardRef(function Disclosure(props, ref) {
  [props, ref] = $64fa3d84918910a7$export$29f1550f4b0d4415(props, ref, $28f4fd908f0de97f$export$d665dd135a51b28a);
  let groupState = useContext($28f4fd908f0de97f$export$1d40e3e0cc4d5de);
  let { id: id2, ...otherProps } = props;
  let defaultId = $bdb11010cef70236$export$f680877a34711e37();
  id2 || (id2 = defaultId);
  let isExpanded = groupState ? groupState.expandedKeys.has(id2) : props.isExpanded;
  let state = $bf996d45f4a36925$export$3fcbf6e4407997e0({
    ...props,
    isExpanded,
    onExpandedChange(isExpanded2) {
      var _props_onExpandedChange;
      if (groupState) groupState.toggleKey(id2);
      (_props_onExpandedChange = props.onExpandedChange) === null || _props_onExpandedChange === void 0 ? void 0 : _props_onExpandedChange.call(props, isExpanded2);
    }
  });
  let panelRef = React__default.useRef(null);
  let isDisabled = props.isDisabled || (groupState === null || groupState === void 0 ? void 0 : groupState.isDisabled) || false;
  let { buttonProps, panelProps } = $5e910fae8e128ead$export$6e3e27031a30522f({
    ...props,
    isExpanded,
    isDisabled
  }, state, panelRef);
  let { isFocusVisible: isFocusVisibleWithin, focusProps: focusWithinProps } = $f7dceffc5ad7768b$export$4e328f61c538687f({
    within: true
  });
  let renderProps = $64fa3d84918910a7$export$4d86445c2cf5e3({
    ...props,
    id: void 0,
    defaultClassName: "react-aria-Disclosure",
    values: {
      isExpanded: state.isExpanded,
      isDisabled,
      isFocusVisibleWithin,
      state
    }
  });
  let domProps = $65484d02dcb7eb3e$export$457c3d6518dd4c6f(otherProps);
  return /* @__PURE__ */ React__default.createElement($64fa3d84918910a7$export$2881499e37b75b9a, {
    values: [
      [
        $d2b4bc8c273e7be6$export$24d547caef80ccd1,
        {
          slots: {
            [$64fa3d84918910a7$export$c62b8e45d58ddad9]: {},
            trigger: buttonProps
          }
        }
      ],
      [
        $28f4fd908f0de97f$var$InternalDisclosureContext,
        {
          panelProps,
          panelRef
        }
      ],
      [
        $28f4fd908f0de97f$export$dab3ea4a6ef094da,
        state
      ]
    ]
  }, /* @__PURE__ */ React__default.createElement("div", {
    ref,
    "data-expanded": state.isExpanded || void 0,
    "data-disabled": isDisabled || void 0,
    "data-focus-visible-within": isFocusVisibleWithin || void 0,
    ...domProps,
    ...focusWithinProps,
    ...renderProps
  }, renderProps.children));
});
const $28f4fd908f0de97f$export$feabaa331e1d464c = /* @__PURE__ */ forwardRef(function DisclosurePanel(props, ref) {
  let { role = "group" } = props;
  let { panelProps, panelRef } = useContext($28f4fd908f0de97f$var$InternalDisclosureContext);
  let { isFocusVisible: isFocusVisibleWithin, focusProps: focusWithinProps } = $f7dceffc5ad7768b$export$4e328f61c538687f({
    within: true
  });
  let renderProps = $64fa3d84918910a7$export$4d86445c2cf5e3({
    ...props,
    defaultClassName: "react-aria-DisclosurePanel",
    values: {
      isFocusVisibleWithin
    }
  });
  let DOMProps = $65484d02dcb7eb3e$export$457c3d6518dd4c6f(props);
  return /* @__PURE__ */ React__default.createElement("div", {
    ...DOMProps,
    ref: $5dc95899b306f630$export$c9058316764c140e(ref, panelRef),
    ...$3ef42575df84b30b$export$9d1611c77c2fe928(panelProps, focusWithinProps),
    ...renderProps,
    role,
    "data-focus-visible-within": isFocusVisibleWithin || void 0
  }, /* @__PURE__ */ React__default.createElement($64fa3d84918910a7$export$2881499e37b75b9a, {
    values: [
      [
        $d2b4bc8c273e7be6$export$24d547caef80ccd1,
        null
      ]
    ]
  }, props.children));
});
const $b6c3ddc6086f204d$export$a79eda4ff50e30b6 = /* @__PURE__ */ createContext(null);
const $b6c3ddc6086f204d$export$b118023277d4a5c3 = /* @__PURE__ */ createContext(null);
const $b6c3ddc6086f204d$export$29d84393af70866c = /* @__PURE__ */ createContext(null);
const $b6c3ddc6086f204d$export$a98f0dcb43a68a25 = /* @__PURE__ */ forwardRef(function RadioGroup(props, ref) {
  [props, ref] = $64fa3d84918910a7$export$29f1550f4b0d4415(props, ref, $b6c3ddc6086f204d$export$a79eda4ff50e30b6);
  let { validationBehavior: formValidationBehavior } = $64fa3d84918910a7$export$fabf2dc03a41866e($d3e0e05bdfcf66bd$export$c24727297075ec6a) || {};
  var _props_validationBehavior, _ref;
  let validationBehavior = (_ref = (_props_validationBehavior = props.validationBehavior) !== null && _props_validationBehavior !== void 0 ? _props_validationBehavior : formValidationBehavior) !== null && _ref !== void 0 ? _ref : "native";
  let state = $a54cdc5c1942b639$export$bca9d026f8e704eb({
    ...props,
    validationBehavior
  });
  let [labelRef, label] = $64fa3d84918910a7$export$9d4c57ee4c6ffdd8(!props["aria-label"] && !props["aria-labelledby"]);
  let { radioGroupProps, labelProps, descriptionProps, errorMessageProps, ...validation } = $430f30ed08ec25fa$export$62b9571f283ff5c2({
    ...props,
    label,
    validationBehavior
  }, state);
  let renderProps = $64fa3d84918910a7$export$4d86445c2cf5e3({
    ...props,
    values: {
      orientation: props.orientation || "vertical",
      isDisabled: state.isDisabled,
      isReadOnly: state.isReadOnly,
      isRequired: state.isRequired,
      isInvalid: state.isInvalid,
      state
    },
    defaultClassName: "react-aria-RadioGroup"
  });
  return /* @__PURE__ */ React__default.createElement("div", {
    ...radioGroupProps,
    ...renderProps,
    ref,
    slot: props.slot || void 0,
    "data-orientation": props.orientation || "vertical",
    "data-invalid": state.isInvalid || void 0,
    "data-disabled": state.isDisabled || void 0,
    "data-readonly": state.isReadOnly || void 0,
    "data-required": state.isRequired || void 0
  }, /* @__PURE__ */ React__default.createElement($64fa3d84918910a7$export$2881499e37b75b9a, {
    values: [
      [
        $b6c3ddc6086f204d$export$29d84393af70866c,
        state
      ],
      [
        $01b77f81d0f07f68$export$75b6ee27786ba447,
        {
          ...labelProps,
          ref: labelRef,
          elementType: "span"
        }
      ],
      [
        $514c0188e459b4c0$export$9afb8bc826b033ea,
        {
          slots: {
            description: descriptionProps,
            errorMessage: errorMessageProps
          }
        }
      ],
      [
        $ee014567cb39d3f0$export$ff05c3ac10437e03,
        validation
      ]
    ]
  }, renderProps.children));
});
const $b6c3ddc6086f204d$export$d7b12c4107be0d61 = /* @__PURE__ */ forwardRef(function Radio(props, ref) {
  let { inputRef: userProvidedInputRef = null, ...otherProps } = props;
  [props, ref] = $64fa3d84918910a7$export$29f1550f4b0d4415(otherProps, ref, $b6c3ddc6086f204d$export$b118023277d4a5c3);
  let state = React__default.useContext($b6c3ddc6086f204d$export$29d84393af70866c);
  let inputRef = $df56164dff5785e2$export$4338b53315abf666($5dc95899b306f630$export$c9058316764c140e(userProvidedInputRef, props.inputRef !== void 0 ? props.inputRef : null));
  let { labelProps, inputProps, isSelected, isDisabled, isPressed } = $0d5c49892c1215da$export$37b0961d2f4751e2({
    ...$64fa3d84918910a7$export$ef03459518577ad4(props),
    // ReactNode type doesn't allow function children.
    children: typeof props.children === "function" ? true : props.children
  }, state, inputRef);
  let { isFocused, isFocusVisible, focusProps } = $f7dceffc5ad7768b$export$4e328f61c538687f();
  let interactionDisabled = isDisabled || state.isReadOnly;
  let { hoverProps, isHovered } = $6179b936705e76d3$export$ae780daf29e6d456({
    ...props,
    isDisabled: interactionDisabled
  });
  let renderProps = $64fa3d84918910a7$export$4d86445c2cf5e3({
    ...props,
    defaultClassName: "react-aria-Radio",
    values: {
      isSelected,
      isPressed,
      isHovered,
      isFocused,
      isFocusVisible,
      isDisabled,
      isReadOnly: state.isReadOnly,
      isInvalid: state.isInvalid,
      isRequired: state.isRequired
    }
  });
  let DOMProps = $65484d02dcb7eb3e$export$457c3d6518dd4c6f(props);
  delete DOMProps.id;
  return /* @__PURE__ */ React__default.createElement("label", {
    ...$3ef42575df84b30b$export$9d1611c77c2fe928(DOMProps, labelProps, hoverProps, renderProps),
    ref,
    "data-selected": isSelected || void 0,
    "data-pressed": isPressed || void 0,
    "data-hovered": isHovered || void 0,
    "data-focused": isFocused || void 0,
    "data-focus-visible": isFocusVisible || void 0,
    "data-disabled": isDisabled || void 0,
    "data-readonly": state.isReadOnly || void 0,
    "data-invalid": state.isInvalid || void 0,
    "data-required": state.isRequired || void 0
  }, /* @__PURE__ */ React__default.createElement($5c3e21d68f1c4674$export$439d29a4e110a164, {
    elementType: "span"
  }, /* @__PURE__ */ React__default.createElement("input", {
    ...$3ef42575df84b30b$export$9d1611c77c2fe928(inputProps, focusProps),
    ref: inputRef
  })), renderProps.children);
});
const AccordionContext = React__default.createContext({
  headingLevel: "h2"
});
const Trigger$6 = React__default.forwardRef(function AccordionTrigger(props, ref) {
  const { headingLevel: Heading } = React__default.useContext(AccordionContext);
  const className = clsx(
    "w-full inline-flex justify-between items-center align-middle focus-within:yt-focus focus:rounded-sm group",
    props.className
  );
  return /* @__PURE__ */ React__default.createElement(Heading, { className: "my-3" }, /* @__PURE__ */ React__default.createElement($d2b4bc8c273e7be6$export$353f5b6fc5456de1, { ...props, className, "data-taco": "accordion-trigger", ref, slot: "trigger" }, props.children, /* @__PURE__ */ React__default.createElement(Icon$1, { name: "chevron-down", "aria-hidden": true, className: "group-aria-expanded:rotate-180" })));
});
const Content$9 = React__default.forwardRef(function AccordionContent(props, ref) {
  return /* @__PURE__ */ React__default.createElement($28f4fd908f0de97f$export$feabaa331e1d464c, { ...props, "data-taco": "accordion-panel", ref });
});
const Item$4 = React__default.forwardRef(function AccordionItem(props, ref) {
  const { disabled, ...otherProps } = props;
  const disclosureClassName = clsx("group data-[disabled]:opacity-50", props.className);
  return /* @__PURE__ */ React__default.createElement($28f4fd908f0de97f$export$74a362b31437ec83, { ...otherProps, className: disclosureClassName, isDisabled: disabled, ref });
});
function Accordion(props) {
  const { disabled, id: id2, defaultId, onChange, as: headingLevel = "h2", ...otherProps } = props;
  const context = React__default.useMemo(() => ({ headingLevel }), [headingLevel]);
  let expandedKeys;
  let handleExpandedChange;
  let defaultExpandedKeys;
  if (onChange) {
    expandedKeys = typeof id2 === "string" ? [id2] : id2;
    handleExpandedChange = (expandedItems) => {
      const expandedItemsArray = Array.from(expandedItems).map(String);
      const isSingleSelect = typeof id2 === "string";
      if (isSingleSelect) {
        onChange(expandedItemsArray[0]);
      } else {
        onChange(expandedItemsArray);
      }
    };
  } else {
    defaultExpandedKeys = typeof defaultId === "string" ? [defaultId] : defaultId;
  }
  return /* @__PURE__ */ React__default.createElement(AccordionContext.Provider, { value: context }, /* @__PURE__ */ React__default.createElement(
    $28f4fd908f0de97f$export$944aceb4f8c89f10,
    {
      ...otherProps,
      allowsMultipleExpanded: Array.isArray(defaultId) || Array.isArray(id2),
      className: clsx("divide-grey-200 divide-y", props.className),
      "data-taco": "accordion",
      defaultExpandedKeys,
      expandedKeys,
      isDisabled: disabled,
      onExpandedChange: handleExpandedChange
    }
  ));
}
Accordion.Item = Item$4;
Accordion.Trigger = Trigger$6;
Accordion.Content = Content$9;
const VisuallyHidden = React.forwardRef(function VisuallyHidden2(props, ref) {
  return /* @__PURE__ */ React.createElement("span", { ...props, className: "sr-only", ref });
});
const Badge2 = React.forwardRef(function Badge22(props, ref) {
  const {
    children,
    compact: compact2 = false,
    outline = false,
    status = false,
    subtle = false,
    small = false,
    color: color2,
    ...otherProps
  } = props;
  const isTransparent = color2 === "transparent";
  const className = clsx(
    "rounded-full border box-border overflow-hidden whitespace-nowrap inline-flex items-center justify-center",
    {
      [`border ${getOutlineColorShadeClasses(color2)}`]: outline,
      [`border-none font-normal ${getSubtleColorShadeClasses(color2)}`]: subtle,
      [`border-none ${getColorShadeClasses(color2)}`]: !outline && !subtle,
      "h-4 min-w-0 py-0 px-1 text-xs": small,
      "h-2 w-2 min-w-0": compact2,
      "font-bold": outline || !subtle,
      "text-sm": !small,
      "h-5 py-0 px-1.5": !compact2 && !small,
      // custom padding keeps single digits in a perfect circle
      "!bg-grey-700": compact2 && isTransparent
    },
    props.className
  );
  const content = () => {
    if (compact2) {
      return /* @__PURE__ */ React.createElement(VisuallyHidden, null, children);
    }
    const contentToRender = typeof children === "string" ? /* @__PURE__ */ React.createElement("span", { className: "items-center truncate" }, children) : children;
    if (status) {
      return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: clsx("mr-1 h-2 w-2 shrink-0 rounded-full", getColorShadeClasses(color2)) }), contentToRender);
    }
    return contentToRender;
  };
  return /* @__PURE__ */ React.createElement("span", { ...otherProps, className, "data-taco": "badge", ref, role: "status", title: props["aria-label"] }, content());
});
const getBannerIcon = (type) => {
  return /* @__PURE__ */ React__default.createElement("div", { className: "mt-[5px] self-start" }, (() => {
    switch (type) {
      case "success":
        return /* @__PURE__ */ React__default.createElement(BadgeIcon, { icon: "tick", color: "green" });
      case "error":
        return /* @__PURE__ */ React__default.createElement(BadgeIcon, { icon: "close", color: "red" });
      case "experiment":
        return /* @__PURE__ */ React__default.createElement(BadgeIcon, { icon: "experiment", color: "purple" });
      case "warning":
        return /* @__PURE__ */ React__default.createElement(BadgeIcon, { icon: "warning", color: "yellow" });
      case "information":
        return /* @__PURE__ */ React__default.createElement(BadgeIcon, { icon: "info", color: "blue" });
      default:
        return null;
    }
  })());
};
const useMergedRef = (ref) => {
  const internalRef = React__default.useRef(null);
  React__default.useEffect(() => {
    if (ref) {
      if (typeof ref === "function") {
        ref(internalRef.current);
      } else {
        ref.current = internalRef.current;
      }
    }
  }, [ref]);
  return internalRef;
};
const FOCUSABLE_ELEMENTS = [
  "[tabindex]:not([disabled])",
  "input:not([disabled])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  "[contenteditable]",
  "details:not([disabled])",
  "summary:not(:disabled)"
];
const hasFocusableElement = (element) => {
  if (!element) {
    return null;
  }
  return !!element.querySelector(FOCUSABLE_ELEMENTS.join(","));
};
const getIndexOfFirstChildOverflowingParent = (element, overscan = 0) => {
  let index2 = 0;
  let boundaryChildIndex = null;
  const clientRect = element.getBoundingClientRect();
  for (const child of Array.from(element.children)) {
    const right = child.getBoundingClientRect().right - clientRect.left;
    const width = clientRect.width - overscan;
    if (right > width) {
      boundaryChildIndex = index2;
      break;
    }
    index2++;
  }
  return boundaryChildIndex;
};
const getNextFocussableElement = (currentElement) => {
  if (!currentElement) {
    return null;
  }
  let focussableElements = [...document.querySelectorAll(FOCUSABLE_ELEMENTS.join(","))];
  const currentElementIndex = focussableElements.indexOf(currentElement);
  if (currentElementIndex > -1) {
    focussableElements = focussableElements.slice(currentElementIndex + 1).filter((element) => element.getAttribute("tabindex") !== "-1");
    if (focussableElements.length) {
      focussableElements = focussableElements.filter((element) => {
        var _a;
        return ((_a = element.checkVisibility) == null ? void 0 : _a.call(element)) ?? true;
      });
      return focussableElements[0] ?? null;
    }
  }
  return null;
};
const getOverlaySelector = (element) => {
  switch (element == null ? void 0 : element.getAttribute("role")) {
    case "dialog":
      return `[aria-controls='${element.id}']`;
    case "menu":
      return `#${element.getAttribute("aria-labelledby")}`;
    default:
      return void 0;
  }
};
function isElementTriggeredFromContainer(element, container) {
  const selector = getOverlaySelector(element) ?? getOverlaySelector((element == null ? void 0 : element.closest("[role=dialog],[role=menu]")) ?? null);
  if (selector) {
    const escapedSelector = CSS.escape(selector);
    if (container == null ? void 0 : container.querySelector(escapedSelector)) {
      return true;
    }
    const elementInDocument = document.querySelector(escapedSelector);
    if (elementInDocument === container) {
      return true;
    }
    if (elementInDocument) {
      return isElementTriggeredFromContainer(elementInDocument, container);
    }
    return false;
  }
  return false;
}
function isElementInsideOrTriggeredFromContainer(element, container) {
  return isElementTriggeredFromContainer(element, container) || !!(container == null ? void 0 : container.contains(element));
}
function isElementInsideOverlay(element) {
  return !!(element == null ? void 0 : element.closest("[role=dialog],[role=menu]"));
}
function isSiblingElementInsideSameParentOverlay(element, sibling) {
  var _a;
  return !!((_a = element == null ? void 0 : element.closest("[role=dialog],[role=menu]")) == null ? void 0 : _a.contains(sibling));
}
function isElementInteractive(element) {
  if (!element) {
    return false;
  }
  const interactiveElements = ["A", "BUTTON", "INPUT", "TEXTAREA", "SELECT", "LABEL", "OPTION"];
  const isInteractive = interactiveElements.includes(element.tagName) && !element.hidden && !element.disabled && !element.readOnly;
  if (!isInteractive) {
    const focusableParent = element.closest(FOCUSABLE_ELEMENTS.join(","));
    return focusableParent ? interactiveElements.includes(focusableParent.tagName) : false;
  }
  return isInteractive;
}
function isElementInsideTable3OrReport(element) {
  return !!(element == null ? void 0 : element.closest("[data-taco^=table]"));
}
function setDataFocusAttribute(target) {
  target.setAttribute("data-focus", "programmatic");
  const cleanup = () => {
    target.removeAttribute("data-focus");
    target.removeEventListener("blur", cleanup);
  };
  target.addEventListener("blur", cleanup);
}
function isPressingMetaKey(event) {
  return isMacOs() ? event.metaKey : event.ctrlKey;
}
function shouldTriggerShortcut(event, key) {
  const keyOptions = typeof key === "string" ? { key, meta: false, shift: false } : key;
  if (keyOptions.meta && (isMacOs() ? !event.metaKey : !event.ctrlKey) || !keyOptions.meta && (isMacOs() ? event.metaKey : event.ctrlKey)) {
    return false;
  }
  if (keyOptions.shift && !event.shiftKey || keyOptions.shift === false && event.shiftKey) {
    return false;
  }
  return event.key.toLowerCase() === keyOptions.key.toLowerCase();
}
function createShortcutKeyDownHandler(key, handler, stopPropagation2 = true) {
  return function(event) {
    var _a;
    if (event.target !== event.currentTarget && isElementInteractive(event.target) && !isPressingMetaKey(event)) {
      return;
    }
    const condition = shouldTriggerShortcut(event, key);
    if (condition) {
      if (stopPropagation2) {
        event.stopPropagation();
        (_a = event.stopImmediatePropagation) == null ? void 0 : _a.call(event);
      }
      handler(event);
    }
  };
}
const isMacOs = () => window == null ? void 0 : window.navigator.userAgent.includes("Mac");
const useGlobalKeyDown = (shortcut2, handler) => {
  React__default.useEffect(() => {
    let handleKeyDown;
    if (shortcut2) {
      handleKeyDown = createShortcutKeyDownHandler(
        shortcut2,
        handler,
        false
      );
      document.addEventListener("keydown", handleKeyDown);
    }
    return () => {
      if (handleKeyDown) {
        document.removeEventListener("keydown", handleKeyDown);
      }
    };
  }, [shortcut2, handler]);
};
const Button$5 = React.forwardRef(function Button2(props, ref) {
  const { disabled, shortcut: shortcut2, target, type = "button", ...otherProps } = props;
  const internalRef = useMergedRef(ref);
  useGlobalKeyDown(shortcut2, (event) => {
    var _a;
    event == null ? void 0 : event.preventDefault();
    const dialog = document.querySelector('[role="dialog"]');
    if (dialog && !(dialog == null ? void 0 : dialog.contains(internalRef.current))) {
      return;
    }
    (_a = internalRef.current) == null ? void 0 : _a.click();
  });
  const Tag2 = props.href ? "a" : "button";
  return /* @__PURE__ */ React.createElement(
    Tag2,
    {
      ...otherProps,
      href: disabled ? void 0 : props.href,
      "aria-disabled": disabled ? "true" : void 0,
      disabled,
      target: Tag2 === "a" ? target : void 0,
      type: Tag2 !== "a" ? type : void 0,
      ref: internalRef
    },
    React.Children.count(props.children) > 1 ? React.Children.map(props.children, (child) => typeof child === "string" ? /* @__PURE__ */ React.createElement("span", null, child) : child) : props.children
  );
});
function t(t3) {
  return t3.split("-")[0];
}
function e(t3) {
  return t3.split("-")[1];
}
function n$1(e3) {
  return ["top", "bottom"].includes(t(e3)) ? "x" : "y";
}
function r$1(t3) {
  return "y" === t3 ? "height" : "width";
}
function i$1(i3, o2, a4) {
  let { reference: l2, floating: s4 } = i3;
  const c3 = l2.x + l2.width / 2 - s4.width / 2, f2 = l2.y + l2.height / 2 - s4.height / 2, u3 = n$1(o2), m4 = r$1(u3), g2 = l2[m4] / 2 - s4[m4] / 2, d4 = "x" === u3;
  let p2;
  switch (t(o2)) {
    case "top":
      p2 = { x: c3, y: l2.y - s4.height };
      break;
    case "bottom":
      p2 = { x: c3, y: l2.y + l2.height };
      break;
    case "right":
      p2 = { x: l2.x + l2.width, y: f2 };
      break;
    case "left":
      p2 = { x: l2.x - s4.width, y: f2 };
      break;
    default:
      p2 = { x: l2.x, y: l2.y };
  }
  switch (e(o2)) {
    case "start":
      p2[u3] -= g2 * (a4 && d4 ? -1 : 1);
      break;
    case "end":
      p2[u3] += g2 * (a4 && d4 ? -1 : 1);
  }
  return p2;
}
const o$1 = async (t3, e3, n2) => {
  const { placement: r2 = "bottom", strategy: o2 = "absolute", middleware: a4 = [], platform: l2 } = n2, s4 = await (null == l2.isRTL ? void 0 : l2.isRTL(e3));
  let c3 = await l2.getElementRects({ reference: t3, floating: e3, strategy: o2 }), { x: f2, y: u3 } = i$1(c3, r2, s4), m4 = r2, g2 = {}, d4 = 0;
  for (let n3 = 0; n3 < a4.length; n3++) {
    const { name: p2, fn: h4 } = a4[n3], { x: y4, y: x3, data: w3, reset: v2 } = await h4({ x: f2, y: u3, initialPlacement: r2, placement: m4, strategy: o2, middlewareData: g2, rects: c3, platform: l2, elements: { reference: t3, floating: e3 } });
    f2 = null != y4 ? y4 : f2, u3 = null != x3 ? x3 : u3, g2 = { ...g2, [p2]: { ...g2[p2], ...w3 } }, v2 && d4 <= 50 && (d4++, "object" == typeof v2 && (v2.placement && (m4 = v2.placement), v2.rects && (c3 = true === v2.rects ? await l2.getElementRects({ reference: t3, floating: e3, strategy: o2 }) : v2.rects), { x: f2, y: u3 } = i$1(c3, m4, s4)), n3 = -1);
  }
  return { x: f2, y: u3, placement: m4, strategy: o2, middlewareData: g2 };
};
function a$3(t3) {
  return "number" != typeof t3 ? function(t4) {
    return { top: 0, right: 0, bottom: 0, left: 0, ...t4 };
  }(t3) : { top: t3, right: t3, bottom: t3, left: t3 };
}
function l$1(t3) {
  return { ...t3, top: t3.y, left: t3.x, right: t3.x + t3.width, bottom: t3.y + t3.height };
}
async function s$2(t3, e3) {
  var n2;
  void 0 === e3 && (e3 = {});
  const { x: r2, y: i3, platform: o2, rects: s4, elements: c3, strategy: f2 } = t3, { boundary: u3 = "clippingAncestors", rootBoundary: m4 = "viewport", elementContext: g2 = "floating", altBoundary: d4 = false, padding: p2 = 0 } = e3, h4 = a$3(p2), y4 = c3[d4 ? "floating" === g2 ? "reference" : "floating" : g2], x3 = l$1(await o2.getClippingRect({ element: null == (n2 = await (null == o2.isElement ? void 0 : o2.isElement(y4))) || n2 ? y4 : y4.contextElement || await (null == o2.getDocumentElement ? void 0 : o2.getDocumentElement(c3.floating)), boundary: u3, rootBoundary: m4, strategy: f2 })), w3 = l$1(o2.convertOffsetParentRelativeRectToViewportRelativeRect ? await o2.convertOffsetParentRelativeRectToViewportRelativeRect({ rect: "floating" === g2 ? { ...s4.floating, x: r2, y: i3 } : s4.reference, offsetParent: await (null == o2.getOffsetParent ? void 0 : o2.getOffsetParent(c3.floating)), strategy: f2 }) : s4[g2]);
  return { top: x3.top - w3.top + h4.top, bottom: w3.bottom - x3.bottom + h4.bottom, left: x3.left - w3.left + h4.left, right: w3.right - x3.right + h4.right };
}
const c$3 = Math.min, f$1 = Math.max;
function u$1(t3, e3, n2) {
  return f$1(t3, c$3(e3, n2));
}
const m$1 = (t3) => ({ name: "arrow", options: t3, async fn(i3) {
  const { element: o2, padding: l2 = 0 } = null != t3 ? t3 : {}, { x: s4, y: c3, placement: f2, rects: m4, platform: g2 } = i3;
  if (null == o2) return {};
  const d4 = a$3(l2), p2 = { x: s4, y: c3 }, h4 = n$1(f2), y4 = e(f2), x3 = r$1(h4), w3 = await g2.getDimensions(o2), v2 = "y" === h4 ? "top" : "left", b3 = "y" === h4 ? "bottom" : "right", R3 = m4.reference[x3] + m4.reference[h4] - p2[h4] - m4.floating[x3], A2 = p2[h4] - m4.reference[h4], P2 = await (null == g2.getOffsetParent ? void 0 : g2.getOffsetParent(o2));
  let T3 = P2 ? "y" === h4 ? P2.clientHeight || 0 : P2.clientWidth || 0 : 0;
  0 === T3 && (T3 = m4.floating[x3]);
  const O3 = R3 / 2 - A2 / 2, D3 = d4[v2], L3 = T3 - w3[x3] - d4[b3], k3 = T3 / 2 - w3[x3] / 2 + O3, E3 = u$1(D3, k3, L3), C2 = ("start" === y4 ? d4[v2] : d4[b3]) > 0 && k3 !== E3 && m4.reference[x3] <= m4.floating[x3];
  return { [h4]: p2[h4] - (C2 ? k3 < D3 ? D3 - k3 : L3 - k3 : 0), data: { [h4]: E3, centerOffset: k3 - E3 } };
} }), g$1 = { left: "right", right: "left", bottom: "top", top: "bottom" };
function d$1(t3) {
  return t3.replace(/left|right|bottom|top/g, (t4) => g$1[t4]);
}
function p$1(t3, i3, o2) {
  void 0 === o2 && (o2 = false);
  const a4 = e(t3), l2 = n$1(t3), s4 = r$1(l2);
  let c3 = "x" === l2 ? a4 === (o2 ? "end" : "start") ? "right" : "left" : "start" === a4 ? "bottom" : "top";
  return i3.reference[s4] > i3.floating[s4] && (c3 = d$1(c3)), { main: c3, cross: d$1(c3) };
}
const h$1 = { start: "end", end: "start" };
function y$2(t3) {
  return t3.replace(/start|end/g, (t4) => h$1[t4]);
}
const x$2 = ["top", "right", "bottom", "left"];
x$2.reduce((t3, e3) => t3.concat(e3, e3 + "-start", e3 + "-end"), []);
const b$2 = function(e3) {
  return void 0 === e3 && (e3 = {}), { name: "flip", options: e3, async fn(n2) {
    var r2;
    const { placement: i3, middlewareData: o2, rects: a4, initialPlacement: l2, platform: c3, elements: f2 } = n2, { mainAxis: u3 = true, crossAxis: m4 = true, fallbackPlacements: g2, fallbackStrategy: h4 = "bestFit", flipAlignment: x3 = true, ...w3 } = e3, v2 = t(i3), b3 = g2 || (v2 === l2 || !x3 ? [d$1(l2)] : function(t3) {
      const e4 = d$1(t3);
      return [y$2(t3), e4, y$2(e4)];
    }(l2)), R3 = [l2, ...b3], A2 = await s$2(n2, w3), P2 = [];
    let T3 = (null == (r2 = o2.flip) ? void 0 : r2.overflows) || [];
    if (u3 && P2.push(A2[v2]), m4) {
      const { main: t3, cross: e4 } = p$1(i3, a4, await (null == c3.isRTL ? void 0 : c3.isRTL(f2.floating)));
      P2.push(A2[t3], A2[e4]);
    }
    if (T3 = [...T3, { placement: i3, overflows: P2 }], !P2.every((t3) => t3 <= 0)) {
      var O3, D3;
      const t3 = (null != (O3 = null == (D3 = o2.flip) ? void 0 : D3.index) ? O3 : 0) + 1, e4 = R3[t3];
      if (e4) return { data: { index: t3, overflows: T3 }, reset: { placement: e4 } };
      let n3 = "bottom";
      switch (h4) {
        case "bestFit": {
          var L3;
          const t4 = null == (L3 = T3.map((t5) => [t5, t5.overflows.filter((t6) => t6 > 0).reduce((t6, e6) => t6 + e6, 0)]).sort((t5, e6) => t5[1] - e6[1])[0]) ? void 0 : L3[0].placement;
          t4 && (n3 = t4);
          break;
        }
        case "initialPlacement":
          n3 = l2;
      }
      if (i3 !== n3) return { reset: { placement: n3 } };
    }
    return {};
  } };
};
function R$1(t3, e3) {
  return { top: t3.top - e3.height, right: t3.right - e3.width, bottom: t3.bottom - e3.height, left: t3.left - e3.width };
}
function A(t3) {
  return x$2.some((e3) => t3[e3] >= 0);
}
const P$1 = function(t3) {
  let { strategy: e3 = "referenceHidden", ...n2 } = void 0 === t3 ? {} : t3;
  return { name: "hide", async fn(t4) {
    const { rects: r2 } = t4;
    switch (e3) {
      case "referenceHidden": {
        const e4 = R$1(await s$2(t4, { ...n2, elementContext: "reference" }), r2.reference);
        return { data: { referenceHiddenOffsets: e4, referenceHidden: A(e4) } };
      }
      case "escaped": {
        const e4 = R$1(await s$2(t4, { ...n2, altBoundary: true }), r2.floating);
        return { data: { escapedOffsets: e4, escaped: A(e4) } };
      }
      default:
        return {};
    }
  } };
};
const T$1 = function(r2) {
  return void 0 === r2 && (r2 = 0), { name: "offset", options: r2, async fn(i3) {
    const { x: o2, y: a4 } = i3, l2 = await async function(r3, i4) {
      const { placement: o3, platform: a5, elements: l3 } = r3, s4 = await (null == a5.isRTL ? void 0 : a5.isRTL(l3.floating)), c3 = t(o3), f2 = e(o3), u3 = "x" === n$1(o3), m4 = ["left", "top"].includes(c3) ? -1 : 1, g2 = s4 && u3 ? -1 : 1, d4 = "function" == typeof i4 ? i4(r3) : i4;
      let { mainAxis: p2, crossAxis: h4, alignmentAxis: y4 } = "number" == typeof d4 ? { mainAxis: d4, crossAxis: 0, alignmentAxis: null } : { mainAxis: 0, crossAxis: 0, alignmentAxis: null, ...d4 };
      return f2 && "number" == typeof y4 && (h4 = "end" === f2 ? -1 * y4 : y4), u3 ? { x: h4 * g2, y: p2 * m4 } : { x: p2 * m4, y: h4 * g2 };
    }(i3, r2);
    return { x: o2 + l2.x, y: a4 + l2.y, data: l2 };
  } };
};
function O(t3) {
  return "x" === t3 ? "y" : "x";
}
const D$1 = function(e3) {
  return void 0 === e3 && (e3 = {}), { name: "shift", options: e3, async fn(r2) {
    const { x: i3, y: o2, placement: a4 } = r2, { mainAxis: l2 = true, crossAxis: c3 = false, limiter: f2 = { fn: (t3) => {
      let { x: e4, y: n2 } = t3;
      return { x: e4, y: n2 };
    } }, ...m4 } = e3, g2 = { x: i3, y: o2 }, d4 = await s$2(r2, m4), p2 = n$1(t(a4)), h4 = O(p2);
    let y4 = g2[p2], x3 = g2[h4];
    if (l2) {
      const t3 = "y" === p2 ? "bottom" : "right";
      y4 = u$1(y4 + d4["y" === p2 ? "top" : "left"], y4, y4 - d4[t3]);
    }
    if (c3) {
      const t3 = "y" === h4 ? "bottom" : "right";
      x3 = u$1(x3 + d4["y" === h4 ? "top" : "left"], x3, x3 - d4[t3]);
    }
    const w3 = f2.fn({ ...r2, [p2]: y4, [h4]: x3 });
    return { ...w3, data: { x: w3.x - i3, y: w3.y - o2 } };
  } };
}, L$1 = function(e3) {
  return void 0 === e3 && (e3 = {}), { options: e3, fn(r2) {
    const { x: i3, y: o2, placement: a4, rects: l2, middlewareData: s4 } = r2, { offset: c3 = 0, mainAxis: f2 = true, crossAxis: u3 = true } = e3, m4 = { x: i3, y: o2 }, g2 = n$1(a4), d4 = O(g2);
    let p2 = m4[g2], h4 = m4[d4];
    const y4 = "function" == typeof c3 ? c3({ ...l2, placement: a4 }) : c3, x3 = "number" == typeof y4 ? { mainAxis: y4, crossAxis: 0 } : { mainAxis: 0, crossAxis: 0, ...y4 };
    if (f2) {
      const t3 = "y" === g2 ? "height" : "width", e4 = l2.reference[g2] - l2.floating[t3] + x3.mainAxis, n2 = l2.reference[g2] + l2.reference[t3] - x3.mainAxis;
      p2 < e4 ? p2 = e4 : p2 > n2 && (p2 = n2);
    }
    if (u3) {
      var w3, v2, b3, R3;
      const e4 = "y" === g2 ? "width" : "height", n2 = ["top", "left"].includes(t(a4)), r3 = l2.reference[d4] - l2.floating[e4] + (n2 && null != (w3 = null == (v2 = s4.offset) ? void 0 : v2[d4]) ? w3 : 0) + (n2 ? 0 : x3.crossAxis), i4 = l2.reference[d4] + l2.reference[e4] + (n2 ? 0 : null != (b3 = null == (R3 = s4.offset) ? void 0 : R3[d4]) ? b3 : 0) - (n2 ? x3.crossAxis : 0);
      h4 < r3 ? h4 = r3 : h4 > i4 && (h4 = i4);
    }
    return { [g2]: p2, [d4]: h4 };
  } };
};
function n(t3) {
  return t3 && t3.document && t3.location && t3.alert && t3.setInterval;
}
function o(t3) {
  if (null == t3) return window;
  if (!n(t3)) {
    const e3 = t3.ownerDocument;
    return e3 && e3.defaultView || window;
  }
  return t3;
}
function i(t3) {
  return o(t3).getComputedStyle(t3);
}
function r(t3) {
  return n(t3) ? "" : t3 ? (t3.nodeName || "").toLowerCase() : "";
}
function l() {
  const t3 = navigator.userAgentData;
  return null != t3 && t3.brands ? t3.brands.map((t4) => t4.brand + "/" + t4.version).join(" ") : navigator.userAgent;
}
function c$2(t3) {
  return t3 instanceof o(t3).HTMLElement;
}
function f(t3) {
  return t3 instanceof o(t3).Element;
}
function s$1(t3) {
  if ("undefined" == typeof ShadowRoot) return false;
  return t3 instanceof o(t3).ShadowRoot || t3 instanceof ShadowRoot;
}
function u(t3) {
  const { overflow: e3, overflowX: n2, overflowY: o2 } = i(t3);
  return /auto|scroll|overlay|hidden/.test(e3 + o2 + n2);
}
function d(t3) {
  return ["table", "td", "th"].includes(r(t3));
}
function h(t3) {
  const e3 = /firefox/i.test(l()), n2 = i(t3);
  return "none" !== n2.transform || "none" !== n2.perspective || "paint" === n2.contain || ["transform", "perspective"].includes(n2.willChange) || e3 && "filter" === n2.willChange || e3 && !!n2.filter && "none" !== n2.filter;
}
function a$2() {
  return !/^((?!chrome|android).)*safari/i.test(l());
}
const g = Math.min, p = Math.max, m = Math.round;
function w(t3, e3, n2) {
  var i3, r2, l2, s4;
  void 0 === e3 && (e3 = false), void 0 === n2 && (n2 = false);
  const u3 = t3.getBoundingClientRect();
  let d4 = 1, h4 = 1;
  e3 && c$2(t3) && (d4 = t3.offsetWidth > 0 && m(u3.width) / t3.offsetWidth || 1, h4 = t3.offsetHeight > 0 && m(u3.height) / t3.offsetHeight || 1);
  const g2 = f(t3) ? o(t3) : window, p2 = !a$2() && n2, w3 = (u3.left + (p2 && null != (i3 = null == (r2 = g2.visualViewport) ? void 0 : r2.offsetLeft) ? i3 : 0)) / d4, v2 = (u3.top + (p2 && null != (l2 = null == (s4 = g2.visualViewport) ? void 0 : s4.offsetTop) ? l2 : 0)) / h4, y4 = u3.width / d4, x3 = u3.height / h4;
  return { width: y4, height: x3, top: v2, right: w3 + y4, bottom: v2 + x3, left: w3, x: w3, y: v2 };
}
function v(t3) {
  return (e3 = t3, (e3 instanceof o(e3).Node ? t3.ownerDocument : t3.document) || window.document).documentElement;
  var e3;
}
function y$1(t3) {
  return f(t3) ? { scrollLeft: t3.scrollLeft, scrollTop: t3.scrollTop } : { scrollLeft: t3.pageXOffset, scrollTop: t3.pageYOffset };
}
function x$1(t3) {
  return w(v(t3)).left + y$1(t3).scrollLeft;
}
function b$1(t3, e3, n2) {
  const o2 = c$2(e3), i3 = v(e3), l2 = w(t3, o2 && function(t4) {
    const e4 = w(t4);
    return m(e4.width) !== t4.offsetWidth || m(e4.height) !== t4.offsetHeight;
  }(e3), "fixed" === n2);
  let f2 = { scrollLeft: 0, scrollTop: 0 };
  const s4 = { x: 0, y: 0 };
  if (o2 || !o2 && "fixed" !== n2) if (("body" !== r(e3) || u(i3)) && (f2 = y$1(e3)), c$2(e3)) {
    const t4 = w(e3, true);
    s4.x = t4.x + e3.clientLeft, s4.y = t4.y + e3.clientTop;
  } else i3 && (s4.x = x$1(i3));
  return { x: l2.left + f2.scrollLeft - s4.x, y: l2.top + f2.scrollTop - s4.y, width: l2.width, height: l2.height };
}
function L(t3) {
  return "html" === r(t3) ? t3 : t3.assignedSlot || t3.parentNode || (s$1(t3) ? t3.host : null) || v(t3);
}
function R(t3) {
  return c$2(t3) && "fixed" !== getComputedStyle(t3).position ? t3.offsetParent : null;
}
function T(t3) {
  const e3 = o(t3);
  let n2 = R(t3);
  for (; n2 && d(n2) && "static" === getComputedStyle(n2).position; ) n2 = R(n2);
  return n2 && ("html" === r(n2) || "body" === r(n2) && "static" === getComputedStyle(n2).position && !h(n2)) ? e3 : n2 || function(t4) {
    let e4 = L(t4);
    for (s$1(e4) && (e4 = e4.host); c$2(e4) && !["html", "body"].includes(r(e4)); ) {
      if (h(e4)) return e4;
      e4 = e4.parentNode;
    }
    return null;
  }(t3) || e3;
}
function W(t3) {
  if (c$2(t3)) return { width: t3.offsetWidth, height: t3.offsetHeight };
  const e3 = w(t3);
  return { width: e3.width, height: e3.height };
}
function E(t3) {
  const e3 = L(t3);
  return ["html", "body", "#document"].includes(r(e3)) ? t3.ownerDocument.body : c$2(e3) && u(e3) ? e3 : E(e3);
}
function H(t3, e3) {
  var n2;
  void 0 === e3 && (e3 = []);
  const i3 = E(t3), r2 = i3 === (null == (n2 = t3.ownerDocument) ? void 0 : n2.body), l2 = o(i3), c3 = r2 ? [l2].concat(l2.visualViewport || [], u(i3) ? i3 : []) : i3, f2 = e3.concat(c3);
  return r2 ? f2 : f2.concat(H(c3));
}
function C(e3, n2, r2) {
  return "viewport" === n2 ? l$1(function(t3, e4) {
    const n3 = o(t3), i3 = v(t3), r3 = n3.visualViewport;
    let l2 = i3.clientWidth, c3 = i3.clientHeight, f2 = 0, s4 = 0;
    if (r3) {
      l2 = r3.width, c3 = r3.height;
      const t4 = a$2();
      (t4 || !t4 && "fixed" === e4) && (f2 = r3.offsetLeft, s4 = r3.offsetTop);
    }
    return { width: l2, height: c3, x: f2, y: s4 };
  }(e3, r2)) : f(n2) ? function(t3, e4) {
    const n3 = w(t3, false, "fixed" === e4), o2 = n3.top + t3.clientTop, i3 = n3.left + t3.clientLeft;
    return { top: o2, left: i3, x: i3, y: o2, right: i3 + t3.clientWidth, bottom: o2 + t3.clientHeight, width: t3.clientWidth, height: t3.clientHeight };
  }(n2, r2) : l$1(function(t3) {
    var e4;
    const n3 = v(t3), o2 = y$1(t3), r3 = null == (e4 = t3.ownerDocument) ? void 0 : e4.body, l2 = p(n3.scrollWidth, n3.clientWidth, r3 ? r3.scrollWidth : 0, r3 ? r3.clientWidth : 0), c3 = p(n3.scrollHeight, n3.clientHeight, r3 ? r3.scrollHeight : 0, r3 ? r3.clientHeight : 0);
    let f2 = -o2.scrollLeft + x$1(t3);
    const s4 = -o2.scrollTop;
    return "rtl" === i(r3 || n3).direction && (f2 += p(n3.clientWidth, r3 ? r3.clientWidth : 0) - l2), { width: l2, height: c3, x: f2, y: s4 };
  }(v(e3)));
}
function S(t3) {
  const e3 = H(t3), n2 = ["absolute", "fixed"].includes(i(t3).position) && c$2(t3) ? T(t3) : t3;
  return f(n2) ? e3.filter((t4) => f(t4) && function(t5, e4) {
    const n3 = null == e4.getRootNode ? void 0 : e4.getRootNode();
    if (t5.contains(e4)) return true;
    if (n3 && s$1(n3)) {
      let n4 = e4;
      do {
        if (n4 && t5 === n4) return true;
        n4 = n4.parentNode || n4.host;
      } while (n4);
    }
    return false;
  }(t4, n2) && "body" !== r(t4)) : [];
}
const D = { getClippingRect: function(t3) {
  let { element: e3, boundary: n2, rootBoundary: o2, strategy: i3 } = t3;
  const r2 = [..."clippingAncestors" === n2 ? S(e3) : [].concat(n2), o2], l2 = r2[0], c3 = r2.reduce((t4, n3) => {
    const o3 = C(e3, n3, i3);
    return t4.top = p(o3.top, t4.top), t4.right = g(o3.right, t4.right), t4.bottom = g(o3.bottom, t4.bottom), t4.left = p(o3.left, t4.left), t4;
  }, C(e3, l2, i3));
  return { width: c3.right - c3.left, height: c3.bottom - c3.top, x: c3.left, y: c3.top };
}, convertOffsetParentRelativeRectToViewportRelativeRect: function(t3) {
  let { rect: e3, offsetParent: n2, strategy: o2 } = t3;
  const i3 = c$2(n2), l2 = v(n2);
  if (n2 === l2) return e3;
  let f2 = { scrollLeft: 0, scrollTop: 0 };
  const s4 = { x: 0, y: 0 };
  if ((i3 || !i3 && "fixed" !== o2) && (("body" !== r(n2) || u(l2)) && (f2 = y$1(n2)), c$2(n2))) {
    const t4 = w(n2, true);
    s4.x = t4.x + n2.clientLeft, s4.y = t4.y + n2.clientTop;
  }
  return { ...e3, x: e3.x - f2.scrollLeft + s4.x, y: e3.y - f2.scrollTop + s4.y };
}, isElement: f, getDimensions: W, getOffsetParent: T, getDocumentElement: v, getElementRects: (t3) => {
  let { reference: e3, floating: n2, strategy: o2 } = t3;
  return { reference: b$1(e3, T(n2), o2), floating: { ...W(n2), x: 0, y: 0 } };
}, getClientRects: (t3) => Array.from(t3.getClientRects()), isRTL: (t3) => "rtl" === i(t3).direction };
function N(t3, e3, n2, o2) {
  void 0 === o2 && (o2 = {});
  const { ancestorScroll: i3 = true, ancestorResize: r2 = true, elementResize: l2 = true, animationFrame: c3 = false } = o2, s4 = i3 && !c3, u3 = r2 && !c3, d4 = s4 || u3 ? [...f(t3) ? H(t3) : [], ...H(e3)] : [];
  d4.forEach((t4) => {
    s4 && t4.addEventListener("scroll", n2, { passive: true }), u3 && t4.addEventListener("resize", n2);
  });
  let h4, a4 = null;
  if (l2) {
    let o3 = true;
    a4 = new ResizeObserver(() => {
      o3 || n2(), o3 = false;
    }), f(t3) && !c3 && a4.observe(t3), a4.observe(e3);
  }
  let g2 = c3 ? w(t3) : null;
  return c3 && function e4() {
    const o3 = w(t3);
    !g2 || o3.x === g2.x && o3.y === g2.y && o3.width === g2.width && o3.height === g2.height || n2();
    g2 = o3, h4 = requestAnimationFrame(e4);
  }(), n2(), () => {
    var t4;
    d4.forEach((t5) => {
      s4 && t5.removeEventListener("scroll", n2), u3 && t5.removeEventListener("resize", n2);
    }), null == (t4 = a4) || t4.disconnect(), a4 = null, c3 && cancelAnimationFrame(h4);
  };
}
const z = (t3, n2, o2) => o$1(t3, n2, { platform: D, ...o2 });
var index = typeof document !== "undefined" ? useLayoutEffect : useEffect;
function deepEqual$1(a4, b3) {
  if (a4 === b3) {
    return true;
  }
  if (typeof a4 !== typeof b3) {
    return false;
  }
  if (typeof a4 === "function" && a4.toString() === b3.toString()) {
    return true;
  }
  let length, i3, keys2;
  if (a4 && b3 && typeof a4 == "object") {
    if (Array.isArray(a4)) {
      length = a4.length;
      if (length != b3.length) return false;
      for (i3 = length; i3-- !== 0; ) {
        if (!deepEqual$1(a4[i3], b3[i3])) {
          return false;
        }
      }
      return true;
    }
    keys2 = Object.keys(a4);
    length = keys2.length;
    if (length !== Object.keys(b3).length) {
      return false;
    }
    for (i3 = length; i3-- !== 0; ) {
      if (!Object.prototype.hasOwnProperty.call(b3, keys2[i3])) {
        return false;
      }
    }
    for (i3 = length; i3-- !== 0; ) {
      const key = keys2[i3];
      if (key === "_owner" && a4.$$typeof) {
        continue;
      }
      if (!deepEqual$1(a4[key], b3[key])) {
        return false;
      }
    }
    return true;
  }
  return a4 !== a4 && b3 !== b3;
}
function useLatestRef(value) {
  const ref = React.useRef(value);
  index(() => {
    ref.current = value;
  });
  return ref;
}
function useFloating(_temp) {
  let {
    middleware,
    placement = "bottom",
    strategy = "absolute",
    whileElementsMounted
  } = _temp === void 0 ? {} : _temp;
  const reference = React.useRef(null);
  const floating = React.useRef(null);
  const whileElementsMountedRef = useLatestRef(whileElementsMounted);
  const cleanupRef = React.useRef(null);
  const [data, setData] = React.useState({
    // Setting these to `null` will allow the consumer to determine if
    // `computePosition()` has run yet
    x: null,
    y: null,
    strategy,
    placement,
    middlewareData: {}
  });
  const [latestMiddleware, setLatestMiddleware] = React.useState(middleware);
  if (!deepEqual$1(latestMiddleware == null ? void 0 : latestMiddleware.map((_ref) => {
    let {
      options
    } = _ref;
    return options;
  }), middleware == null ? void 0 : middleware.map((_ref2) => {
    let {
      options
    } = _ref2;
    return options;
  }))) {
    setLatestMiddleware(middleware);
  }
  const update2 = React.useCallback(() => {
    if (!reference.current || !floating.current) {
      return;
    }
    z(reference.current, floating.current, {
      middleware: latestMiddleware,
      placement,
      strategy
    }).then((data2) => {
      if (isMountedRef.current) {
        ReactDOM.flushSync(() => {
          setData(data2);
        });
      }
    });
  }, [latestMiddleware, placement, strategy]);
  index(() => {
    if (isMountedRef.current) {
      update2();
    }
  }, [update2]);
  const isMountedRef = React.useRef(false);
  index(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  const runElementMountCallback = React.useCallback(() => {
    if (typeof cleanupRef.current === "function") {
      cleanupRef.current();
      cleanupRef.current = null;
    }
    if (reference.current && floating.current) {
      if (whileElementsMountedRef.current) {
        const cleanupFn = whileElementsMountedRef.current(reference.current, floating.current, update2);
        cleanupRef.current = cleanupFn;
      } else {
        update2();
      }
    }
  }, [update2, whileElementsMountedRef]);
  const setReference = React.useCallback((node) => {
    reference.current = node;
    runElementMountCallback();
  }, [runElementMountCallback]);
  const setFloating = React.useCallback((node) => {
    floating.current = node;
    runElementMountCallback();
  }, [runElementMountCallback]);
  const refs = React.useMemo(() => ({
    reference,
    floating
  }), []);
  return React.useMemo(() => ({
    ...data,
    update: update2,
    refs,
    reference: setReference,
    floating: setFloating
  }), [data, update2, refs, setReference, setFloating]);
}
const arrow$1 = (options) => {
  const {
    element,
    padding
  } = options;
  function isRef(value) {
    return Object.prototype.hasOwnProperty.call(value, "current");
  }
  return {
    name: "arrow",
    options,
    fn(args) {
      if (isRef(element)) {
        if (element.current != null) {
          return m$1({
            element: element.current,
            padding
          }).fn(args);
        }
        return {};
      } else if (element) {
        return m$1({
          element,
          padding
        }).fn(args);
      }
      return {};
    }
  };
};
const $7e8f5cd07187803e$export$21b07c8f274aebd5 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { children, width = 10, height = 5, ...arrowProps } = props;
  return /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.svg, _extends$z({}, arrowProps, {
    ref: forwardedRef,
    width,
    height,
    viewBox: "0 0 30 10",
    preserveAspectRatio: "none"
  }), props.asChild ? children : /* @__PURE__ */ createElement("polygon", {
    points: "0,0 30,0 15,10"
  }));
});
const $7e8f5cd07187803e$export$be92b6f5f03c0fe9 = $7e8f5cd07187803e$export$21b07c8f274aebd5;
const $9f79659886946c16$export$e5c5a5f917a5871c$3 = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) ? useLayoutEffect : () => {
};
const $9f79659886946c16$export$e5c5a5f917a5871c$2 = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) ? useLayoutEffect : () => {
};
function $db6c3485150b8e66$export$1ab7ae714698c4b8(element) {
  const [size2, setSize] = useState(void 0);
  $9f79659886946c16$export$e5c5a5f917a5871c$2(() => {
    if (element) {
      setSize({
        width: element.offsetWidth,
        height: element.offsetHeight
      });
      const resizeObserver = new ResizeObserver((entries) => {
        if (!Array.isArray(entries)) return;
        if (!entries.length) return;
        const entry = entries[0];
        let width;
        let height;
        if ("borderBoxSize" in entry) {
          const borderSizeEntry = entry["borderBoxSize"];
          const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
          width = borderSize["inlineSize"];
          height = borderSize["blockSize"];
        } else {
          width = element.offsetWidth;
          height = element.offsetHeight;
        }
        setSize({
          width,
          height
        });
      });
      resizeObserver.observe(element, {
        box: "border-box"
      });
      return () => resizeObserver.unobserve(element);
    } else
      setSize(void 0);
  }, [
    element
  ]);
  return size2;
}
const $cf1ac5d9fe0e8206$var$POPPER_NAME = "Popper";
const [$cf1ac5d9fe0e8206$var$createPopperContext, $cf1ac5d9fe0e8206$export$722aac194ae923] = $c512c27ab02ef895$export$50c7b4e9d9f19c1$1($cf1ac5d9fe0e8206$var$POPPER_NAME);
const [$cf1ac5d9fe0e8206$var$PopperProvider, $cf1ac5d9fe0e8206$var$usePopperContext] = $cf1ac5d9fe0e8206$var$createPopperContext($cf1ac5d9fe0e8206$var$POPPER_NAME);
const $cf1ac5d9fe0e8206$export$badac9ada3a0bdf9 = (props) => {
  const { __scopePopper, children } = props;
  const [anchor, setAnchor] = useState(null);
  return /* @__PURE__ */ createElement($cf1ac5d9fe0e8206$var$PopperProvider, {
    scope: __scopePopper,
    anchor,
    onAnchorChange: setAnchor
  }, children);
};
const $cf1ac5d9fe0e8206$var$ANCHOR_NAME = "PopperAnchor";
const $cf1ac5d9fe0e8206$export$ecd4e1ccab6ed6d = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopePopper, virtualRef, ...anchorProps } = props;
  const context = $cf1ac5d9fe0e8206$var$usePopperContext($cf1ac5d9fe0e8206$var$ANCHOR_NAME, __scopePopper);
  const ref = useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05$1(forwardedRef, ref);
  useEffect(() => {
    context.onAnchorChange((virtualRef === null || virtualRef === void 0 ? void 0 : virtualRef.current) || ref.current);
  });
  return virtualRef ? null : /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.div, _extends$z({}, anchorProps, {
    ref: composedRefs
  }));
});
const $cf1ac5d9fe0e8206$var$CONTENT_NAME = "PopperContent";
const [$cf1ac5d9fe0e8206$var$PopperContentProvider, $cf1ac5d9fe0e8206$var$useContentContext] = $cf1ac5d9fe0e8206$var$createPopperContext($cf1ac5d9fe0e8206$var$CONTENT_NAME);
const [$cf1ac5d9fe0e8206$var$PositionContextProvider, $cf1ac5d9fe0e8206$var$usePositionContext] = $cf1ac5d9fe0e8206$var$createPopperContext($cf1ac5d9fe0e8206$var$CONTENT_NAME, {
  hasParent: false,
  positionUpdateFns: /* @__PURE__ */ new Set()
});
const $cf1ac5d9fe0e8206$export$bc4ae5855d3c4fc = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  var _arrowSize$width, _arrowSize$height, _middlewareData$arrow, _middlewareData$arrow2, _middlewareData$arrow3, _middlewareData$hide, _middlewareData$trans, _middlewareData$trans2;
  const { __scopePopper, side = "bottom", sideOffset = 0, align = "center", alignOffset = 0, arrowPadding = 0, collisionBoundary = [], collisionPadding: collisionPaddingProp = 0, sticky = "partial", hideWhenDetached = false, avoidCollisions = true, ...contentProps } = props;
  const context = $cf1ac5d9fe0e8206$var$usePopperContext($cf1ac5d9fe0e8206$var$CONTENT_NAME, __scopePopper);
  const [content, setContent] = useState(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05$1(
    forwardedRef,
    (node) => setContent(node)
  );
  const [arrow2, setArrow] = useState(null);
  const arrowSize = $db6c3485150b8e66$export$1ab7ae714698c4b8(arrow2);
  const arrowWidth = (_arrowSize$width = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.width) !== null && _arrowSize$width !== void 0 ? _arrowSize$width : 0;
  const arrowHeight = (_arrowSize$height = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.height) !== null && _arrowSize$height !== void 0 ? _arrowSize$height : 0;
  const desiredPlacement = side + (align !== "center" ? "-" + align : "");
  const collisionPadding = typeof collisionPaddingProp === "number" ? collisionPaddingProp : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...collisionPaddingProp
  };
  const boundary = Array.isArray(collisionBoundary) ? collisionBoundary : [
    collisionBoundary
  ];
  const hasExplicitBoundaries = boundary.length > 0;
  const detectOverflowOptions = {
    padding: collisionPadding,
    boundary: boundary.filter($cf1ac5d9fe0e8206$var$isNotNull),
    // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
    altBoundary: hasExplicitBoundaries
  };
  const { reference, floating, strategy, x: x3, y: y4, placement, middlewareData, update: update2 } = useFloating({
    // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
    strategy: "fixed",
    placement: desiredPlacement,
    whileElementsMounted: N,
    middleware: [
      T$1({
        mainAxis: sideOffset + arrowHeight,
        alignmentAxis: alignOffset
      }),
      avoidCollisions ? D$1({
        mainAxis: true,
        crossAxis: false,
        limiter: sticky === "partial" ? L$1() : void 0,
        ...detectOverflowOptions
      }) : void 0,
      arrow2 ? arrow$1({
        element: arrow2,
        padding: arrowPadding
      }) : void 0,
      avoidCollisions ? b$2({
        ...detectOverflowOptions
      }) : void 0,
      $cf1ac5d9fe0e8206$var$transformOrigin({
        arrowWidth,
        arrowHeight
      }),
      hideWhenDetached ? P$1({
        strategy: "referenceHidden"
      }) : void 0
    ].filter($cf1ac5d9fe0e8206$var$isDefined)
  });
  $9f79659886946c16$export$e5c5a5f917a5871c$3(() => {
    reference(context.anchor);
  }, [
    reference,
    context.anchor
  ]);
  const isPlaced = x3 !== null && y4 !== null;
  const [placedSide, placedAlign] = $cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement);
  const arrowX = (_middlewareData$arrow = middlewareData.arrow) === null || _middlewareData$arrow === void 0 ? void 0 : _middlewareData$arrow.x;
  const arrowY = (_middlewareData$arrow2 = middlewareData.arrow) === null || _middlewareData$arrow2 === void 0 ? void 0 : _middlewareData$arrow2.y;
  const cannotCenterArrow = ((_middlewareData$arrow3 = middlewareData.arrow) === null || _middlewareData$arrow3 === void 0 ? void 0 : _middlewareData$arrow3.centerOffset) !== 0;
  const [contentZIndex, setContentZIndex] = useState();
  $9f79659886946c16$export$e5c5a5f917a5871c$3(() => {
    if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
  }, [
    content
  ]);
  const { hasParent, positionUpdateFns } = $cf1ac5d9fe0e8206$var$usePositionContext($cf1ac5d9fe0e8206$var$CONTENT_NAME, __scopePopper);
  const isRoot = !hasParent;
  useLayoutEffect(() => {
    if (!isRoot) {
      positionUpdateFns.add(update2);
      return () => {
        positionUpdateFns.delete(update2);
      };
    }
  }, [
    isRoot,
    positionUpdateFns,
    update2
  ]);
  useLayoutEffect(() => {
    if (isRoot && isPlaced) Array.from(positionUpdateFns).reverse().forEach(
      (fn) => requestAnimationFrame(fn)
    );
  }, [
    isRoot,
    isPlaced,
    positionUpdateFns
  ]);
  const commonProps = {
    "data-side": placedSide,
    "data-align": placedAlign,
    ...contentProps,
    ref: composedRefs,
    style: {
      ...contentProps.style,
      // if the PopperContent hasn't been placed yet (not all measurements done)
      // we prevent animations so that users's animation don't kick in too early referring wrong sides
      animation: !isPlaced ? "none" : void 0,
      // hide the content if using the hide middleware and should be hidden
      opacity: (_middlewareData$hide = middlewareData.hide) !== null && _middlewareData$hide !== void 0 && _middlewareData$hide.referenceHidden ? 0 : void 0
    }
  };
  return /* @__PURE__ */ createElement("div", {
    ref: floating,
    "data-radix-popper-content-wrapper": "",
    style: {
      position: strategy,
      left: 0,
      top: 0,
      transform: isPlaced ? `translate3d(${Math.round(x3)}px, ${Math.round(y4)}px, 0)` : "translate3d(0, -200%, 0)",
      // keep off the page when measuring
      minWidth: "max-content",
      zIndex: contentZIndex,
      ["--radix-popper-transform-origin"]: [
        (_middlewareData$trans = middlewareData.transformOrigin) === null || _middlewareData$trans === void 0 ? void 0 : _middlewareData$trans.x,
        (_middlewareData$trans2 = middlewareData.transformOrigin) === null || _middlewareData$trans2 === void 0 ? void 0 : _middlewareData$trans2.y
      ].join(" ")
    }
  }, /* @__PURE__ */ createElement($cf1ac5d9fe0e8206$var$PopperContentProvider, {
    scope: __scopePopper,
    placedSide,
    onArrowChange: setArrow,
    arrowX,
    arrowY,
    shouldHideArrow: cannotCenterArrow
  }, isRoot ? /* @__PURE__ */ createElement($cf1ac5d9fe0e8206$var$PositionContextProvider, {
    scope: __scopePopper,
    hasParent: true,
    positionUpdateFns
  }, /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.div, commonProps)) : /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.div, commonProps)));
});
const $cf1ac5d9fe0e8206$var$ARROW_NAME = "PopperArrow";
const $cf1ac5d9fe0e8206$var$OPPOSITE_SIDE = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
};
const $cf1ac5d9fe0e8206$export$79d62cd4e10a3fd0 = /* @__PURE__ */ forwardRef(function $cf1ac5d9fe0e8206$export$79d62cd4e10a3fd02(props, forwardedRef) {
  const { __scopePopper, ...arrowProps } = props;
  const contentContext = $cf1ac5d9fe0e8206$var$useContentContext($cf1ac5d9fe0e8206$var$ARROW_NAME, __scopePopper);
  const baseSide = $cf1ac5d9fe0e8206$var$OPPOSITE_SIDE[contentContext.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ createElement("span", {
      ref: contentContext.onArrowChange,
      style: {
        position: "absolute",
        left: contentContext.arrowX,
        top: contentContext.arrowY,
        [baseSide]: 0,
        transformOrigin: {
          top: "",
          right: "0 0",
          bottom: "center 0",
          left: "100% 0"
        }[contentContext.placedSide],
        transform: {
          top: "translateY(100%)",
          right: "translateY(50%) rotate(90deg) translateX(-50%)",
          bottom: `rotate(180deg)`,
          left: "translateY(50%) rotate(-90deg) translateX(50%)"
        }[contentContext.placedSide],
        visibility: contentContext.shouldHideArrow ? "hidden" : void 0
      }
    }, /* @__PURE__ */ createElement($7e8f5cd07187803e$export$be92b6f5f03c0fe9, _extends$z({}, arrowProps, {
      ref: forwardedRef,
      style: {
        ...arrowProps.style,
        // ensures the element can be measured correctly (mostly for if SVG)
        display: "block"
      }
    })))
  );
});
/* @__PURE__ */ Object.assign($cf1ac5d9fe0e8206$export$79d62cd4e10a3fd0, {
  displayName: $cf1ac5d9fe0e8206$var$ARROW_NAME
});
function $cf1ac5d9fe0e8206$var$isDefined(value) {
  return value !== void 0;
}
function $cf1ac5d9fe0e8206$var$isNotNull(value) {
  return value !== null;
}
const $cf1ac5d9fe0e8206$var$transformOrigin = (options) => ({
  name: "transformOrigin",
  options,
  fn(data) {
    var _middlewareData$arrow4, _middlewareData$arrow5, _middlewareData$arrow6, _middlewareData$arrow7, _middlewareData$arrow8;
    const { placement, rects, middlewareData } = data;
    const cannotCenterArrow = ((_middlewareData$arrow4 = middlewareData.arrow) === null || _middlewareData$arrow4 === void 0 ? void 0 : _middlewareData$arrow4.centerOffset) !== 0;
    const isArrowHidden = cannotCenterArrow;
    const arrowWidth = isArrowHidden ? 0 : options.arrowWidth;
    const arrowHeight = isArrowHidden ? 0 : options.arrowHeight;
    const [placedSide, placedAlign] = $cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement);
    const noArrowAlign = {
      start: "0%",
      center: "50%",
      end: "100%"
    }[placedAlign];
    const arrowXCenter = ((_middlewareData$arrow5 = (_middlewareData$arrow6 = middlewareData.arrow) === null || _middlewareData$arrow6 === void 0 ? void 0 : _middlewareData$arrow6.x) !== null && _middlewareData$arrow5 !== void 0 ? _middlewareData$arrow5 : 0) + arrowWidth / 2;
    const arrowYCenter = ((_middlewareData$arrow7 = (_middlewareData$arrow8 = middlewareData.arrow) === null || _middlewareData$arrow8 === void 0 ? void 0 : _middlewareData$arrow8.y) !== null && _middlewareData$arrow7 !== void 0 ? _middlewareData$arrow7 : 0) + arrowHeight / 2;
    let x3 = "";
    let y4 = "";
    if (placedSide === "bottom") {
      x3 = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
      y4 = `${-arrowHeight}px`;
    } else if (placedSide === "top") {
      x3 = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
      y4 = `${rects.floating.height + arrowHeight}px`;
    } else if (placedSide === "right") {
      x3 = `${-arrowHeight}px`;
      y4 = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
    } else if (placedSide === "left") {
      x3 = `${rects.floating.width + arrowHeight}px`;
      y4 = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
    }
    return {
      data: {
        x: x3,
        y: y4
      }
    };
  }
});
function $cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement) {
  const [side, align = "center"] = placement.split("-");
  return [
    side,
    align
  ];
}
const $cf1ac5d9fe0e8206$export$be92b6f5f03c0fe9 = $cf1ac5d9fe0e8206$export$badac9ada3a0bdf9;
const $cf1ac5d9fe0e8206$export$b688253958b8dfe7 = $cf1ac5d9fe0e8206$export$ecd4e1ccab6ed6d;
const $cf1ac5d9fe0e8206$export$7c6e2c02157bb7d2 = $cf1ac5d9fe0e8206$export$bc4ae5855d3c4fc;
const $cf1ac5d9fe0e8206$export$21b07c8f274aebd5 = $cf1ac5d9fe0e8206$export$79d62cd4e10a3fd0;
const $ea1ef594cf570d83$export$439d29a4e110a164 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  return /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.span, _extends$z({}, props, {
    ref: forwardedRef,
    style: {
      // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
      position: "absolute",
      border: 0,
      width: 1,
      height: 1,
      padding: 0,
      margin: -1,
      overflow: "hidden",
      clip: "rect(0, 0, 0, 0)",
      whiteSpace: "nowrap",
      wordWrap: "normal",
      ...props.style
    }
  }));
});
const $ea1ef594cf570d83$export$be92b6f5f03c0fe9 = $ea1ef594cf570d83$export$439d29a4e110a164;
const [$a093c7e1ec25a057$var$createTooltipContext, $a093c7e1ec25a057$export$1c540a2224f0d865] = $c512c27ab02ef895$export$50c7b4e9d9f19c1$1("Tooltip", [
  $cf1ac5d9fe0e8206$export$722aac194ae923
]);
const $a093c7e1ec25a057$var$usePopperScope = $cf1ac5d9fe0e8206$export$722aac194ae923();
const $a093c7e1ec25a057$var$PROVIDER_NAME = "TooltipProvider";
const $a093c7e1ec25a057$var$DEFAULT_DELAY_DURATION = 700;
const $a093c7e1ec25a057$var$TOOLTIP_OPEN = "tooltip.open";
const [$a093c7e1ec25a057$var$TooltipProviderContextProvider, $a093c7e1ec25a057$var$useTooltipProviderContext] = $a093c7e1ec25a057$var$createTooltipContext($a093c7e1ec25a057$var$PROVIDER_NAME);
const $a093c7e1ec25a057$export$f78649fb9ca566b8 = (props) => {
  const { __scopeTooltip, delayDuration = $a093c7e1ec25a057$var$DEFAULT_DELAY_DURATION, skipDelayDuration = 300, disableHoverableContent = false, children } = props;
  const [isOpenDelayed, setIsOpenDelayed] = useState(true);
  const isPointerInTransitRef = useRef(false);
  const skipDelayTimerRef = useRef(0);
  useEffect(() => {
    const skipDelayTimer = skipDelayTimerRef.current;
    return () => window.clearTimeout(skipDelayTimer);
  }, []);
  return /* @__PURE__ */ createElement($a093c7e1ec25a057$var$TooltipProviderContextProvider, {
    scope: __scopeTooltip,
    isOpenDelayed,
    delayDuration,
    onOpen: useCallback(() => {
      window.clearTimeout(skipDelayTimerRef.current);
      setIsOpenDelayed(false);
    }, []),
    onClose: useCallback(() => {
      window.clearTimeout(skipDelayTimerRef.current);
      skipDelayTimerRef.current = window.setTimeout(
        () => setIsOpenDelayed(true),
        skipDelayDuration
      );
    }, [
      skipDelayDuration
    ]),
    isPointerInTransitRef,
    onPointerInTransitChange: useCallback((inTransit) => {
      isPointerInTransitRef.current = inTransit;
    }, []),
    disableHoverableContent
  }, children);
};
const $a093c7e1ec25a057$var$TOOLTIP_NAME = "Tooltip";
const [$a093c7e1ec25a057$var$TooltipContextProvider, $a093c7e1ec25a057$var$useTooltipContext] = $a093c7e1ec25a057$var$createTooltipContext($a093c7e1ec25a057$var$TOOLTIP_NAME);
const $a093c7e1ec25a057$export$28c660c63b792dea = (props) => {
  const { __scopeTooltip, children, open: openProp, defaultOpen = false, onOpenChange, disableHoverableContent: disableHoverableContentProp, delayDuration: delayDurationProp } = props;
  const providerContext = $a093c7e1ec25a057$var$useTooltipProviderContext($a093c7e1ec25a057$var$TOOLTIP_NAME, props.__scopeTooltip);
  const popperScope = $a093c7e1ec25a057$var$usePopperScope(__scopeTooltip);
  const [trigger, setTrigger] = useState(null);
  const contentId = $1746a345f3d73bb7$export$f680877a34711e37$1();
  const openTimerRef = useRef(0);
  const disableHoverableContent = disableHoverableContentProp !== null && disableHoverableContentProp !== void 0 ? disableHoverableContentProp : providerContext.disableHoverableContent;
  const delayDuration = delayDurationProp !== null && delayDurationProp !== void 0 ? delayDurationProp : providerContext.delayDuration;
  const wasOpenDelayedRef = useRef(false);
  const [open1 = false, setOpen] = $71cd76cc60e0454e$export$6f32135080cb4c3$1({
    prop: openProp,
    defaultProp: defaultOpen,
    onChange: (open) => {
      if (open) {
        providerContext.onOpen();
        document.dispatchEvent(new CustomEvent($a093c7e1ec25a057$var$TOOLTIP_OPEN));
      } else providerContext.onClose();
      onOpenChange === null || onOpenChange === void 0 || onOpenChange(open);
    }
  });
  const stateAttribute = useMemo(() => {
    return open1 ? wasOpenDelayedRef.current ? "delayed-open" : "instant-open" : "closed";
  }, [
    open1
  ]);
  const handleOpen = useCallback(() => {
    window.clearTimeout(openTimerRef.current);
    wasOpenDelayedRef.current = false;
    setOpen(true);
  }, [
    setOpen
  ]);
  const handleClose = useCallback(() => {
    window.clearTimeout(openTimerRef.current);
    setOpen(false);
  }, [
    setOpen
  ]);
  const handleDelayedOpen = useCallback(() => {
    window.clearTimeout(openTimerRef.current);
    openTimerRef.current = window.setTimeout(() => {
      wasOpenDelayedRef.current = true;
      setOpen(true);
    }, delayDuration);
  }, [
    delayDuration,
    setOpen
  ]);
  useEffect(() => {
    return () => window.clearTimeout(openTimerRef.current);
  }, []);
  return /* @__PURE__ */ createElement($cf1ac5d9fe0e8206$export$be92b6f5f03c0fe9, popperScope, /* @__PURE__ */ createElement($a093c7e1ec25a057$var$TooltipContextProvider, {
    scope: __scopeTooltip,
    contentId,
    open: open1,
    stateAttribute,
    trigger,
    onTriggerChange: setTrigger,
    onTriggerEnter: useCallback(() => {
      if (providerContext.isOpenDelayed) handleDelayedOpen();
      else handleOpen();
    }, [
      providerContext.isOpenDelayed,
      handleDelayedOpen,
      handleOpen
    ]),
    onTriggerLeave: useCallback(() => {
      if (disableHoverableContent) handleClose();
      else
        window.clearTimeout(openTimerRef.current);
    }, [
      handleClose,
      disableHoverableContent
    ]),
    onOpen: handleOpen,
    onClose: handleClose,
    disableHoverableContent
  }, children));
};
const $a093c7e1ec25a057$var$TRIGGER_NAME = "TooltipTrigger";
const $a093c7e1ec25a057$export$8c610744efcf8a1d = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeTooltip, ...triggerProps } = props;
  const context = $a093c7e1ec25a057$var$useTooltipContext($a093c7e1ec25a057$var$TRIGGER_NAME, __scopeTooltip);
  const providerContext = $a093c7e1ec25a057$var$useTooltipProviderContext($a093c7e1ec25a057$var$TRIGGER_NAME, __scopeTooltip);
  const popperScope = $a093c7e1ec25a057$var$usePopperScope(__scopeTooltip);
  const ref = useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05$1(forwardedRef, ref, context.onTriggerChange);
  const isPointerDownRef = useRef(false);
  const hasPointerMoveOpenedRef = useRef(false);
  const handlePointerUp = useCallback(
    () => isPointerDownRef.current = false,
    []
  );
  useEffect(() => {
    return () => document.removeEventListener("pointerup", handlePointerUp);
  }, [
    handlePointerUp
  ]);
  return /* @__PURE__ */ createElement($cf1ac5d9fe0e8206$export$b688253958b8dfe7, _extends$z({
    asChild: true
  }, popperScope), /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.button, _extends$z({
    // We purposefully avoid adding `type=button` here because tooltip triggers are also
    // commonly anchors and the anchor `type` attribute signifies MIME type.
    "aria-describedby": context.open ? context.contentId : void 0,
    "data-state": context.stateAttribute
  }, triggerProps, {
    ref: composedRefs,
    onPointerMove: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(props.onPointerMove, (event) => {
      if (event.pointerType === "touch") return;
      if (!hasPointerMoveOpenedRef.current && !providerContext.isPointerInTransitRef.current) {
        context.onTriggerEnter();
        hasPointerMoveOpenedRef.current = true;
      }
    }),
    onPointerLeave: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(props.onPointerLeave, () => {
      context.onTriggerLeave();
      hasPointerMoveOpenedRef.current = false;
    }),
    onPointerDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(props.onPointerDown, () => {
      isPointerDownRef.current = true;
      document.addEventListener("pointerup", handlePointerUp, {
        once: true
      });
    }),
    onFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(props.onFocus, () => {
      if (!isPointerDownRef.current) context.onOpen();
    }),
    onBlur: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(props.onBlur, context.onClose),
    onClick: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(props.onClick, context.onClose)
  })));
});
const $a093c7e1ec25a057$var$PORTAL_NAME = "TooltipPortal";
const [$a093c7e1ec25a057$var$PortalProvider, $a093c7e1ec25a057$var$usePortalContext] = $a093c7e1ec25a057$var$createTooltipContext($a093c7e1ec25a057$var$PORTAL_NAME, {
  forceMount: void 0
});
const $a093c7e1ec25a057$export$7b36b8f925ab7497 = (props) => {
  const { __scopeTooltip, forceMount, children, container } = props;
  const context = $a093c7e1ec25a057$var$useTooltipContext($a093c7e1ec25a057$var$PORTAL_NAME, __scopeTooltip);
  return /* @__PURE__ */ createElement($a093c7e1ec25a057$var$PortalProvider, {
    scope: __scopeTooltip,
    forceMount
  }, /* @__PURE__ */ createElement($921a889cee6df7e8$export$99c2b779aa4e8b8b$1, {
    present: forceMount || context.open
  }, /* @__PURE__ */ createElement($f1701beae083dbae$export$602eac185826482c, {
    asChild: true,
    container
  }, children)));
};
const $a093c7e1ec25a057$var$CONTENT_NAME = "TooltipContent";
const $a093c7e1ec25a057$export$e9003e2be37ec060 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const portalContext = $a093c7e1ec25a057$var$usePortalContext($a093c7e1ec25a057$var$CONTENT_NAME, props.__scopeTooltip);
  const { forceMount = portalContext.forceMount, side = "top", ...contentProps } = props;
  const context = $a093c7e1ec25a057$var$useTooltipContext($a093c7e1ec25a057$var$CONTENT_NAME, props.__scopeTooltip);
  return /* @__PURE__ */ createElement($921a889cee6df7e8$export$99c2b779aa4e8b8b$1, {
    present: forceMount || context.open
  }, context.disableHoverableContent ? /* @__PURE__ */ createElement($a093c7e1ec25a057$var$TooltipContentImpl, _extends$z({
    side
  }, contentProps, {
    ref: forwardedRef
  })) : /* @__PURE__ */ createElement($a093c7e1ec25a057$var$TooltipContentHoverable, _extends$z({
    side
  }, contentProps, {
    ref: forwardedRef
  })));
});
const $a093c7e1ec25a057$var$TooltipContentHoverable = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const context = $a093c7e1ec25a057$var$useTooltipContext($a093c7e1ec25a057$var$CONTENT_NAME, props.__scopeTooltip);
  const providerContext = $a093c7e1ec25a057$var$useTooltipProviderContext($a093c7e1ec25a057$var$CONTENT_NAME, props.__scopeTooltip);
  const ref = useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05$1(forwardedRef, ref);
  const [pointerGraceArea, setPointerGraceArea] = useState(null);
  const { trigger, onClose } = context;
  const content = ref.current;
  const { onPointerInTransitChange } = providerContext;
  const handleRemoveGraceArea = useCallback(() => {
    setPointerGraceArea(null);
    onPointerInTransitChange(false);
  }, [
    onPointerInTransitChange
  ]);
  const handleCreateGraceArea = useCallback((event, hoverTarget) => {
    const currentTarget = event.currentTarget;
    const exitPoint = {
      x: event.clientX,
      y: event.clientY
    };
    const exitSide = $a093c7e1ec25a057$var$getExitSideFromRect(exitPoint, currentTarget.getBoundingClientRect());
    const bleed = exitSide === "right" || exitSide === "bottom" ? -5 : 5;
    const isXAxis = exitSide === "right" || exitSide === "left";
    const startPoint = isXAxis ? {
      x: event.clientX + bleed,
      y: event.clientY
    } : {
      x: event.clientX,
      y: event.clientY + bleed
    };
    const hoverTargetPoints = $a093c7e1ec25a057$var$getPointsFromRect(hoverTarget.getBoundingClientRect());
    const graceArea = $a093c7e1ec25a057$var$getHull([
      startPoint,
      ...hoverTargetPoints
    ]);
    setPointerGraceArea(graceArea);
    onPointerInTransitChange(true);
  }, [
    onPointerInTransitChange
  ]);
  useEffect(() => {
    return () => handleRemoveGraceArea();
  }, [
    handleRemoveGraceArea
  ]);
  useEffect(() => {
    if (trigger && content) {
      const handleTriggerLeave = (event) => handleCreateGraceArea(event, content);
      const handleContentLeave = (event) => handleCreateGraceArea(event, trigger);
      trigger.addEventListener("pointerleave", handleTriggerLeave);
      content.addEventListener("pointerleave", handleContentLeave);
      return () => {
        trigger.removeEventListener("pointerleave", handleTriggerLeave);
        content.removeEventListener("pointerleave", handleContentLeave);
      };
    }
  }, [
    trigger,
    content,
    handleCreateGraceArea,
    handleRemoveGraceArea
  ]);
  useEffect(() => {
    if (pointerGraceArea) {
      const handleTrackPointerGrace = (event) => {
        const target = event.target;
        const pointerPosition = {
          x: event.clientX,
          y: event.clientY
        };
        const hasEnteredTarget = (trigger === null || trigger === void 0 ? void 0 : trigger.contains(target)) || (content === null || content === void 0 ? void 0 : content.contains(target));
        const isPointerOutsideGraceArea = !$a093c7e1ec25a057$var$isPointInPolygon(pointerPosition, pointerGraceArea);
        if (hasEnteredTarget) handleRemoveGraceArea();
        else if (isPointerOutsideGraceArea) {
          handleRemoveGraceArea();
          onClose();
        }
      };
      document.addEventListener("pointermove", handleTrackPointerGrace);
      return () => document.removeEventListener("pointermove", handleTrackPointerGrace);
    }
  }, [
    trigger,
    content,
    pointerGraceArea,
    onClose,
    handleRemoveGraceArea
  ]);
  return /* @__PURE__ */ createElement($a093c7e1ec25a057$var$TooltipContentImpl, _extends$z({}, props, {
    ref: composedRefs
  }));
});
const [$a093c7e1ec25a057$var$VisuallyHiddenContentContextProvider, $a093c7e1ec25a057$var$useVisuallyHiddenContentContext] = $a093c7e1ec25a057$var$createTooltipContext($a093c7e1ec25a057$var$TOOLTIP_NAME, {
  isInside: false
});
const $a093c7e1ec25a057$var$TooltipContentImpl = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeTooltip, children, "aria-label": ariaLabel, onEscapeKeyDown, onPointerDownOutside, ...contentProps } = props;
  const context = $a093c7e1ec25a057$var$useTooltipContext($a093c7e1ec25a057$var$CONTENT_NAME, __scopeTooltip);
  const popperScope = $a093c7e1ec25a057$var$usePopperScope(__scopeTooltip);
  const { onClose } = context;
  useEffect(() => {
    document.addEventListener($a093c7e1ec25a057$var$TOOLTIP_OPEN, onClose);
    return () => document.removeEventListener($a093c7e1ec25a057$var$TOOLTIP_OPEN, onClose);
  }, [
    onClose
  ]);
  useEffect(() => {
    if (context.trigger) {
      const handleScroll2 = (event) => {
        const target = event.target;
        if (target !== null && target !== void 0 && target.contains(context.trigger)) onClose();
      };
      window.addEventListener("scroll", handleScroll2, {
        capture: true
      });
      return () => window.removeEventListener("scroll", handleScroll2, {
        capture: true
      });
    }
  }, [
    context.trigger,
    onClose
  ]);
  return /* @__PURE__ */ createElement($5cb92bef7577960e$export$177fb62ff3ec1f22, {
    asChild: true,
    disableOutsidePointerEvents: false,
    onEscapeKeyDown,
    onPointerDownOutside,
    onFocusOutside: (event) => event.preventDefault(),
    onDismiss: onClose
  }, /* @__PURE__ */ createElement($cf1ac5d9fe0e8206$export$7c6e2c02157bb7d2, _extends$z({
    "data-state": context.stateAttribute
  }, popperScope, contentProps, {
    ref: forwardedRef,
    style: {
      ...contentProps.style,
      // re-namespace exposed content custom property
      ["--radix-tooltip-content-transform-origin"]: "var(--radix-popper-transform-origin)"
    }
  }), /* @__PURE__ */ createElement($5e63c961fc1ce211$export$d9f1ccf0bdb05d45$1, null, children), /* @__PURE__ */ createElement($a093c7e1ec25a057$var$VisuallyHiddenContentContextProvider, {
    scope: __scopeTooltip,
    isInside: true
  }, /* @__PURE__ */ createElement($ea1ef594cf570d83$export$be92b6f5f03c0fe9, {
    id: context.contentId,
    role: "tooltip"
  }, ariaLabel || children))));
});
const $a093c7e1ec25a057$var$ARROW_NAME = "TooltipArrow";
const $a093c7e1ec25a057$export$c27ee0ad710f7559 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeTooltip, ...arrowProps } = props;
  const popperScope = $a093c7e1ec25a057$var$usePopperScope(__scopeTooltip);
  const visuallyHiddenContentContext = $a093c7e1ec25a057$var$useVisuallyHiddenContentContext($a093c7e1ec25a057$var$ARROW_NAME, __scopeTooltip);
  return visuallyHiddenContentContext.isInside ? null : /* @__PURE__ */ createElement($cf1ac5d9fe0e8206$export$21b07c8f274aebd5, _extends$z({}, popperScope, arrowProps, {
    ref: forwardedRef
  }));
});
function $a093c7e1ec25a057$var$getExitSideFromRect(point2, rect) {
  const top = Math.abs(rect.top - point2.y);
  const bottom = Math.abs(rect.bottom - point2.y);
  const right = Math.abs(rect.right - point2.x);
  const left = Math.abs(rect.left - point2.x);
  switch (Math.min(top, bottom, right, left)) {
    case left:
      return "left";
    case right:
      return "right";
    case top:
      return "top";
    case bottom:
      return "bottom";
    default:
      return null;
  }
}
function $a093c7e1ec25a057$var$getPointsFromRect(rect) {
  const { top, right, bottom, left } = rect;
  return [
    {
      x: left,
      y: top
    },
    {
      x: right,
      y: top
    },
    {
      x: right,
      y: bottom
    },
    {
      x: left,
      y: bottom
    }
  ];
}
function $a093c7e1ec25a057$var$isPointInPolygon(point2, polygon) {
  const { x: x3, y: y4 } = point2;
  let inside = false;
  for (let i3 = 0, j = polygon.length - 1; i3 < polygon.length; j = i3++) {
    const xi = polygon[i3].x;
    const yi = polygon[i3].y;
    const xj = polygon[j].x;
    const yj = polygon[j].y;
    const intersect = yi > y4 !== yj > y4 && x3 < (xj - xi) * (y4 - yi) / (yj - yi) + xi;
    if (intersect) inside = !inside;
  }
  return inside;
}
function $a093c7e1ec25a057$var$getHull(points) {
  const newPoints = points.slice();
  newPoints.sort((a4, b3) => {
    if (a4.x < b3.x) return -1;
    else if (a4.x > b3.x) return 1;
    else if (a4.y < b3.y) return -1;
    else if (a4.y > b3.y) return 1;
    else return 0;
  });
  return $a093c7e1ec25a057$var$getHullPresorted(newPoints);
}
function $a093c7e1ec25a057$var$getHullPresorted(points) {
  if (points.length <= 1) return points.slice();
  const upperHull = [];
  for (let i3 = 0; i3 < points.length; i3++) {
    const p2 = points[i3];
    while (upperHull.length >= 2) {
      const q2 = upperHull[upperHull.length - 1];
      const r2 = upperHull[upperHull.length - 2];
      if ((q2.x - r2.x) * (p2.y - r2.y) >= (q2.y - r2.y) * (p2.x - r2.x)) upperHull.pop();
      else break;
    }
    upperHull.push(p2);
  }
  upperHull.pop();
  const lowerHull = [];
  for (let i1 = points.length - 1; i1 >= 0; i1--) {
    const p2 = points[i1];
    while (lowerHull.length >= 2) {
      const q2 = lowerHull[lowerHull.length - 1];
      const r2 = lowerHull[lowerHull.length - 2];
      if ((q2.x - r2.x) * (p2.y - r2.y) >= (q2.y - r2.y) * (p2.x - r2.x)) lowerHull.pop();
      else break;
    }
    lowerHull.push(p2);
  }
  lowerHull.pop();
  if (upperHull.length === 1 && lowerHull.length === 1 && upperHull[0].x === lowerHull[0].x && upperHull[0].y === lowerHull[0].y) return upperHull;
  else return upperHull.concat(lowerHull);
}
const $a093c7e1ec25a057$export$2881499e37b75b9a = $a093c7e1ec25a057$export$f78649fb9ca566b8;
const $a093c7e1ec25a057$export$be92b6f5f03c0fe9 = $a093c7e1ec25a057$export$28c660c63b792dea;
const $a093c7e1ec25a057$export$41fb9f06171c75f4 = $a093c7e1ec25a057$export$8c610744efcf8a1d;
const $a093c7e1ec25a057$export$602eac185826482c = $a093c7e1ec25a057$export$7b36b8f925ab7497;
const $a093c7e1ec25a057$export$7c6e2c02157bb7d2 = $a093c7e1ec25a057$export$e9003e2be37ec060;
const $a093c7e1ec25a057$export$21b07c8f274aebd5 = $a093c7e1ec25a057$export$c27ee0ad710f7559;
const Tooltip$3 = React.forwardRef(function Tooltip2(props, ref) {
  const { title, children, placement, hide: hide2 = false, ...otherProps } = props;
  const className = clsx("break-words", otherProps.className);
  if (hide2) {
    return children;
  }
  return /* @__PURE__ */ React.createElement($a093c7e1ec25a057$export$be92b6f5f03c0fe9, { delayDuration: 250 }, /* @__PURE__ */ React.createElement($a093c7e1ec25a057$export$41fb9f06171c75f4, { asChild: true, ref }, children), /* @__PURE__ */ React.createElement($a093c7e1ec25a057$export$602eac185826482c, null, /* @__PURE__ */ React.createElement($a093c7e1ec25a057$export$7c6e2c02157bb7d2, { ...otherProps, asChild: true, className, side: placement, sideOffset: 3 }, /* @__PURE__ */ React.createElement(
    "div",
    {
      className: "xs:max-w-[theme(spacing.56)] max-w-[theme(spacing.32)] animate-[fade-in_150ms] rounded bg-blue-900 px-2 py-1 text-xs text-white print:hidden",
      "data-taco": "tooltip",
      style: {
        transformOrigin: "var(--radix-tooltip-content-transform-origin)"
      }
    },
    /* @__PURE__ */ React.createElement($a093c7e1ec25a057$export$21b07c8f274aebd5, { className: "-mt-px fill-blue-900 stroke-blue-900" }),
    title
  ))));
});
const getButtonClasses$1 = () => {
  return "flex-shrink-0 min-h-[theme(spacing.8)] min-w-[theme(spacing.8)] gap-1 h-max leading-5 inline-flex items-center justify-center focus-visible:yt-focus data-[state=instant-open]:yt-focus aria-disabled:cursor-not-allowed";
};
const getAppearanceClasses = (value, icon = false) => {
  switch (value) {
    case "primary":
      return `wcag-blue-500 visited:wcag-blue-500 hover:wcag-blue-700 hover:active:wcag-blue-500 aria-disabled:bg-blue-500/50 aria-disabled:active:bg-blue-500/50`;
    case "danger":
      return `wcag-red-500 visited:wcag-red-500 hover:wcag-red-700 hover:active:wcag-red-500 aria-disabled:bg-red-500/50 aria-disabled:active:bg-red-500/50`;
    case "ghost":
      return `bg-white border border-blue-500 text-blue-500 visited:text-blue-500 hover:bg-blue-100 hover:text-blue-700 aria-disabled:border-blue-500/50 aria-disabled:text-blue-500/50 aria-disabled:bg-white`;
    case "discrete": {
      if (icon) {
        return `bg-transparent text-black visited:text-black hover:bg-[#000]/[0.08] aria-disabled:text-black/30`;
      }
      return `bg-transparent text-blue-500 visited:text-blue-500 hover:text-blue-700 aria-disabled:text-blue-500/50`;
    }
    case "transparent": {
      return `bg-transparent text-black visited:text-black hover:text-black hover:bg-[#000]/[0.08] aria-disabled:text-black/30 aria-disabled:bg-transparent`;
    }
    default:
      return `wcag-grey-200 visited:wcag-grey-200 hover:wcag-grey-300 aria-disabled:bg-grey-200/50 aria-disabled:text-black/30`;
  }
};
const createButtonWithTooltip = (props, className, ref) => {
  const { tooltip, ...buttonProps } = props;
  const button = /* @__PURE__ */ React__default.createElement(Button$5, { ...buttonProps, className, ref });
  if (tooltip) {
    return /* @__PURE__ */ React__default.createElement(Tooltip$3, { title: tooltip }, button);
  }
  return button;
};
const createButtonWithOverlays = (props, buttonBase2) => {
  const { dialog, drawer, hanger, menu, popover } = props;
  let button = buttonBase2;
  if (typeof dialog === "function") {
    button = dialog({ trigger: button });
  } else if (typeof drawer === "function") {
    button = drawer({ trigger: button });
  } else if (typeof menu === "function") {
    button = menu({ trigger: button });
  } else if (typeof popover === "function") {
    button = popover({ trigger: button });
  }
  if (typeof hanger === "function") {
    button = hanger({ anchor: button });
  }
  return button;
};
const Base$1 = React.forwardRef(function IconButtonBase(props, ref) {
  const { icon, rounded = false, ...otherProps } = props;
  const className = clsx(
    "w-8",
    getButtonClasses$1(),
    getAppearanceClasses(otherProps.appearance, true),
    {
      "rounded-full": rounded,
      rounded: !rounded
    },
    props.className
  );
  if (!icon) {
    return null;
  }
  return createButtonWithTooltip(
    { ...otherProps, children: /* @__PURE__ */ React.createElement(Icon$1, { name: icon, className: "m-0 p-0" }), "data-taco": "icon-button" },
    className,
    ref
  );
});
const IconButton = React.forwardRef(function Button3(props, ref) {
  const { dialog, hanger, menu, popover, ...buttonProps } = props;
  const button = /* @__PURE__ */ React.createElement(Base$1, { ...buttonProps, ref });
  return createButtonWithOverlays({ dialog, hanger, menu, popover }, button);
});
const defaultLocalisationTexts = {
  banner: {
    close: "Close"
  },
  calendar: {
    months: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    weekdaysShort: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
    weekdays: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
    actions: {
      previousMonth: "Previous month",
      nextMonth: "Next month",
      previousYear: "Previous year",
      nextYear: "Next year",
      today: "Today"
    }
  },
  card: {
    menu: "Open menu"
  },
  combobox: {
    tooltip: "Search in list"
  },
  datepicker: {
    calendar: "Calendar",
    clear: "Clear",
    expand: "Show calendar",
    shortcuts: "Shortcuts"
  },
  dialog: {
    close: "Close",
    drag: "Drag"
  },
  hanger: {
    close: "Close"
  },
  header: {
    addAgreement: "Add agreement",
    logout: "Log off",
    more: "More",
    new: "New",
    search: "Search for agreement..."
  },
  listbox: {
    loading: "Loading results...",
    empty: "No results found",
    allOption: "All"
  },
  pagination: {
    label: "Pagination",
    pageSize: "Items per page",
    showingXofYofTotal: "Showing [X] - [Y] of [total]",
    actions: {
      firstPage: "Goto first page",
      firstPageWithShortcut: "Goto first page (Home)",
      previousPage: "Goto previous page",
      previousPageWithShortcut: "Goto previous page (Page Up)",
      nextPage: "Goto next page",
      nextPageWithShortcut: "Goto next page (Page Down)",
      lastPage: "Goto last page",
      lastPageWithShortcut: "Goto last page (End)",
      pageX: "Goto page [X]"
    }
  },
  legacyTable: {
    actions: "Other actions",
    edit: "Edit (e)",
    copy: "Copy (c)",
    del: "Delete (del)",
    newSubRow: "New row (shift + n)",
    loading: "Loading..."
  },
  table: {
    columns: {
      actions: {
        tooltip: "Row actions"
      },
      drag: {
        tooltip: "Drag row"
      },
      expansion: {
        collapse: "Collapse row",
        collapseAll: "Collapse all rows",
        expand: "Expand row",
        expandAll: "Expand all rows"
      },
      menu: {
        editFilter: "Edit filter",
        filter: "Filter",
        freezeFirstColumn: "Freeze the first column",
        freezeUptoColumn: `Freeze first [TOTAL] columns`,
        gotoRow: "Go to",
        hideColumn: "Hide column",
        unfreezeColumns: "Unfreeze all columns",
        sorting: "Sorting",
        sortingOrder: {
          ascending: "Ascending order",
          descending: "Descending order",
          unsorted: "No sorting"
        }
      },
      resize: {
        tooltip: "Resize column"
      },
      select: {
        deselect: "Deselect row",
        deselectAll: "Deselect all rows",
        select: "Select row",
        selectAll: "Select all rows"
      }
    },
    columnSettings: {
      search: "Search column...",
      tooltip: "Column settings",
      button: "Column settings",
      noResults: "No results"
    },
    filters: {
      button: "Filters",
      buttons: {
        addFilter: "Add new filter",
        clearFilters: "Clear all filters",
        cancel: "Cancel",
        clear: "Clear",
        apply: "Apply"
      },
      comparators: {
        contains: "Contains",
        doesNotContain: "Does not contain",
        isEqualTo: "Is",
        isNotEqualTo: "Is not",
        isGreaterThan: "Is greater than",
        isLessThan: "Is less than",
        isBetween: "Is between",
        isOneOf: "Is one of",
        isNoneOf: "Is none of",
        isAllOf: "Is all of",
        isEmpty: "Is empty",
        isNotEmpty: "Is not empty",
        isBefore: "Is before",
        isAfter: "Is after",
        isOnOrBefore: "Is on or before",
        isOnOrAfter: "Is on or after",
        isLessThanOrEqualTo: "Is less than or equal to",
        isGreaterThanOrEqualTo: "Is greater than or equal to",
        hasAnyOf: "Has any of",
        hasAllOf: "Has all of",
        hasNoneOf: "Has none of"
      },
      conditions: {
        and: "And",
        where: "Where"
      },
      emptyFilter: {
        condition: "Condition",
        value: "Value"
      },
      hiddenColumn: "Hidden column",
      hiddenGroupedColumn: "Hidden grouped column",
      tooltip: "Apply filters",
      total: "Viewing [CURRENT] of [TOTAL]"
    },
    fontSize: {
      tooltip: "Font size",
      sizes: {
        small: "Small",
        medium: "Medium",
        large: "Large"
      }
    },
    footer: {
      summary: {
        count: "of",
        records: "Records:",
        selected: "Records selected:"
      }
    },
    print: {
      error: "An error occurred while creating a print preview",
      loading: "Creating a print preview",
      tooltip: "Print",
      warningDialog: {
        title: "Extra loading time",
        description: "Please note that printing a large amount of data may result in a slightly longer waiting time due to data loading.",
        checkboxVisibilityLabel: "Don't show again",
        cancelButtonText: "Cancel",
        printButtonText: "Print"
      },
      settingsDialog: {
        title: "Print settings",
        size: "Paper size",
        sizeA5: "A5",
        sizeA4: "A4",
        sizeA3: "A3",
        sizeLetter: "Letter",
        sizeLegal: "Legal",
        orientation: "Paper orientation",
        orientationLandscape: "Landscape",
        orientationPortrait: "Portrait",
        rows: "Print rows",
        rowsAll: "All",
        rowsSelected: "Selected",
        layout: "Page layout",
        layoutSplitGroups: "New page for each [COLUMN]"
      }
    },
    rowHeight: {
      tooltip: "Row height",
      sizes: {
        short: "Short",
        medium: "Medium",
        tall: "Tall",
        extraTall: "Extra tall"
      }
    },
    search: {
      excludeUnmatchedResults: "Show only search results",
      placeholder: "Search..."
    },
    otherOptions: {
      tooltip: "Table settings"
    }
  },
  table3: {
    editing: {
      actions: {
        tooltip: "Row actions",
        save: "Save",
        clear: "Clear changes",
        exit: "Exit edit mode"
      },
      buttons: {
        edit: {
          tooltip: "Edit table"
        },
        create: {
          label: "New",
          disabled: "Existing new row must be saved",
          saving: "Saving..."
        }
      },
      clearChangesConfirmationDialog: {
        title: "Discard changes",
        description: "Are you sure you want to discard changes? Your changes will be lost.",
        cancel: "Continue editing",
        confirm: "Discard"
      },
      rowIndicator: {
        rowWillMove: "Row will move due to sorting",
        rowWillBeHidden: "Row will hide due to filtering",
        rowWillMoveReasonSearch: "Due to a search filter applied to this table, this row will be hidden as soon as you select another row",
        rowWillMoveReasonFilter: "Due to a filter applied to the column '[COLUMN]', this row will be hidden as soon as you select another row",
        rowWillMoveReasonSorting: "Due to sorting applied to the column '[COLUMN]', this row will move position as soon as you select another row"
      },
      saving: {
        progress: "Saving...",
        complete: "Saved"
      },
      validation: {
        alert: {
          titleOne: "[COUNT] unsaved row:",
          titlePlural: "[COUNT] unsaved rows:",
          messageOne: "[COLUMN] [ROW] is incomplete and hasn't been saved.",
          messagePlural: "[COLUMN] [ROW] are incomplete and haven't been saved.",
          messageRow: "Row",
          messageAnd: "and"
        },
        resetFiltersDialog: {
          title: "Row is hidden",
          description: "The row is hidden due to filtering.",
          cancel: "Cancel",
          confirm: "Remove filters"
        }
      }
    }
  },
  searchInput: {
    button: "Search",
    findNext: "Next",
    findPrevious: "Previous",
    placeholder: "Search...",
    clear: "Clear"
  },
  select: {
    allOptionsSelected: "All"
  },
  select2: {
    allSelect: "Select all",
    allDeselect: "Deselect all",
    cancel: "Cancel",
    chooseColor: "Pick a color",
    create: "Create",
    delete: "Delete",
    save: "Save",
    search: "Search...",
    searchOrCreate: "Search or create...",
    selectAll: "Select all",
    selectAllResults: "Select all results",
    deselectAll: "Deselect all",
    deselectAllResults: "Deselect all results"
  },
  toasts: {
    dismiss: "Dismiss"
  },
  tour: {
    back: "Back",
    close: "Close",
    skip: "Close and complete",
    last: "Done",
    next: "Next",
    open: "Open"
  },
  drawer: {
    close: "Close",
    back: "Back"
  }
};
const defaultLocalizationContext = {
  locale: "da-DK",
  texts: defaultLocalisationTexts,
  formatting: {
    date: "dd.mm.yy"
  }
};
const LocalizationContext = React.createContext(defaultLocalizationContext);
const LocalizationProvider = ({ localization, children }) => {
  return /* @__PURE__ */ React.createElement(LocalizationContext.Provider, { value: localization ?? defaultLocalizationContext }, children);
};
const useLocalization = () => React.useContext(LocalizationContext);
const Banner = React.forwardRef(function Banner2(props, ref) {
  const { children, state, onClose } = props;
  const { texts } = useLocalization();
  const className = clsx("bg-white relative flex items-center gap-2 py-2 px-4 leading-6 shadow-md z-10", props.className);
  return /* @__PURE__ */ React.createElement("div", { className, "data-taco": "banner", ref }, getBannerIcon(state), children, onClose ? /* @__PURE__ */ React.createElement(
    IconButton,
    {
      "aria-label": texts.banner.close,
      className: "-mr-2 ml-auto self-start",
      icon: "close",
      appearance: "discrete",
      onClick: onClose
    }
  ) : null);
});
const Base = React.forwardRef(function ButtonBase(props, ref) {
  const { appearance, fluid, ...otherProps } = props;
  const className = clsx(
    getButtonClasses$1(),
    getAppearanceClasses(appearance),
    "rounded px-3",
    {
      "w-full": fluid
    },
    props.className
  );
  return createButtonWithTooltip(
    {
      ...otherProps,
      "data-taco": "button",
      "data-appearance": appearance
    },
    className,
    ref
  );
});
const Button$4 = React.forwardRef(function Button22(props, ref) {
  const { dialog, drawer, hanger, menu, popover, ...buttonProps } = props;
  let children = buttonProps.children;
  if (typeof menu === "function") {
    children = Array.isArray(children) ? [...children, /* @__PURE__ */ React.createElement(Icon$1, { key: "chevron-down", name: "chevron-down" })] : [children, /* @__PURE__ */ React.createElement(Icon$1, { key: "chevron-down", name: "chevron-down" })];
  }
  const button = /* @__PURE__ */ React.createElement(Base, { ...buttonProps, ref }, children);
  return createButtonWithOverlays({ dialog, drawer, hanger, menu, popover }, button);
});
function _typeof$O(o2) {
  "@babel/helpers - typeof";
  return _typeof$O = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof$O(o2);
}
function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }
  var number2 = Number(dirtyNumber);
  if (isNaN(number2)) {
    return number2;
  }
  return number2 < 0 ? Math.ceil(number2) : Math.floor(number2);
}
function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
  }
}
function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument);
  if (argument instanceof Date || _typeof$O(argument) === "object" && argStr === "[object Date]") {
    return new Date(argument.getTime());
  } else if (typeof argument === "number" || argStr === "[object Number]") {
    return new Date(argument);
  } else {
    if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
      console.warn(new Error().stack);
    }
    return /* @__PURE__ */ new Date(NaN);
  }
}
function addDays(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date2 = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);
  if (isNaN(amount)) {
    return /* @__PURE__ */ new Date(NaN);
  }
  if (!amount) {
    return date2;
  }
  date2.setDate(date2.getDate() + amount);
  return date2;
}
function addMonths(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date2 = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);
  if (isNaN(amount)) {
    return /* @__PURE__ */ new Date(NaN);
  }
  if (!amount) {
    return date2;
  }
  var dayOfMonth = date2.getDate();
  var endOfDesiredMonth = new Date(date2.getTime());
  endOfDesiredMonth.setMonth(date2.getMonth() + amount + 1, 0);
  var daysInMonth = endOfDesiredMonth.getDate();
  if (dayOfMonth >= daysInMonth) {
    return endOfDesiredMonth;
  } else {
    date2.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
    return date2;
  }
}
function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}
var defaultOptions$3 = {};
function getDefaultOptions() {
  return defaultOptions$3;
}
function startOfWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions2 = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  var date2 = toDate(dirtyDate);
  var day = date2.getDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date2.setDate(date2.getDate() - diff);
  date2.setHours(0, 0, 0, 0);
  return date2;
}
function startOfISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  return startOfWeek(dirtyDate, {
    weekStartsOn: 1
  });
}
function getISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date2 = toDate(dirtyDate);
  var year = date2.getFullYear();
  var fourthOfJanuaryOfNextYear = /* @__PURE__ */ new Date(0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  var startOfNextYear = startOfISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = /* @__PURE__ */ new Date(0);
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
  var startOfThisYear = startOfISOWeek(fourthOfJanuaryOfThisYear);
  if (date2.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date2.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
function startOfISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getISOWeekYear(dirtyDate);
  var fourthOfJanuary = /* @__PURE__ */ new Date(0);
  fourthOfJanuary.setFullYear(year, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  var date2 = startOfISOWeek(fourthOfJanuary);
  return date2;
}
function getTimezoneOffsetInMilliseconds(date2) {
  var utcDate2 = new Date(Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate(), date2.getHours(), date2.getMinutes(), date2.getSeconds(), date2.getMilliseconds()));
  utcDate2.setUTCFullYear(date2.getFullYear());
  return date2.getTime() - utcDate2.getTime();
}
function startOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date2 = toDate(dirtyDate);
  date2.setHours(0, 0, 0, 0);
  return date2;
}
var MILLISECONDS_IN_DAY$1 = 864e5;
function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var startOfDayLeft = startOfDay(dirtyDateLeft);
  var startOfDayRight = startOfDay(dirtyDateRight);
  var timestampLeft = startOfDayLeft.getTime() - getTimezoneOffsetInMilliseconds(startOfDayLeft);
  var timestampRight = startOfDayRight.getTime() - getTimezoneOffsetInMilliseconds(startOfDayRight);
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY$1);
}
function addWeeks(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  var days = amount * 7;
  return addDays(dirtyDate, days);
}
function addYears(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMonths(dirtyDate, amount * 12);
}
function max$3(dirtyDatesArray) {
  requiredArgs(1, arguments);
  var datesArray;
  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === "function") {
    datesArray = dirtyDatesArray;
  } else if (_typeof$O(dirtyDatesArray) === "object" && dirtyDatesArray !== null) {
    datesArray = Array.prototype.slice.call(dirtyDatesArray);
  } else {
    return /* @__PURE__ */ new Date(NaN);
  }
  var result;
  datesArray.forEach(function(dirtyDate) {
    var currentDate = toDate(dirtyDate);
    if (result === void 0 || result < currentDate || isNaN(Number(currentDate))) {
      result = currentDate;
    }
  });
  return result || /* @__PURE__ */ new Date(NaN);
}
function min$3(dirtyDatesArray) {
  requiredArgs(1, arguments);
  var datesArray;
  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === "function") {
    datesArray = dirtyDatesArray;
  } else if (_typeof$O(dirtyDatesArray) === "object" && dirtyDatesArray !== null) {
    datesArray = Array.prototype.slice.call(dirtyDatesArray);
  } else {
    return /* @__PURE__ */ new Date(NaN);
  }
  var result;
  datesArray.forEach(function(dirtyDate) {
    var currentDate = toDate(dirtyDate);
    if (result === void 0 || result > currentDate || isNaN(currentDate.getDate())) {
      result = currentDate;
    }
  });
  return result || /* @__PURE__ */ new Date(NaN);
}
function isSameDay(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeftStartOfDay = startOfDay(dirtyDateLeft);
  var dateRightStartOfDay = startOfDay(dirtyDateRight);
  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}
function isDate(value) {
  requiredArgs(1, arguments);
  return value instanceof Date || _typeof$O(value) === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
function isValid(dirtyDate) {
  requiredArgs(1, arguments);
  if (!isDate(dirtyDate) && typeof dirtyDate !== "number") {
    return false;
  }
  var date2 = toDate(dirtyDate);
  return !isNaN(Number(date2));
}
function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
  var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
  return yearDiff * 12 + monthDiff;
}
var MILLISECONDS_IN_WEEK$4 = 6048e5;
function differenceInCalendarWeeks(dirtyDateLeft, dirtyDateRight, options) {
  requiredArgs(2, arguments);
  var startOfWeekLeft = startOfWeek(dirtyDateLeft, options);
  var startOfWeekRight = startOfWeek(dirtyDateRight, options);
  var timestampLeft = startOfWeekLeft.getTime() - getTimezoneOffsetInMilliseconds(startOfWeekLeft);
  var timestampRight = startOfWeekRight.getTime() - getTimezoneOffsetInMilliseconds(startOfWeekRight);
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK$4);
}
function endOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date2 = toDate(dirtyDate);
  var month = date2.getMonth();
  date2.setFullYear(date2.getFullYear(), month + 1, 0);
  date2.setHours(23, 59, 59, 999);
  return date2;
}
function startOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date2 = toDate(dirtyDate);
  date2.setDate(1);
  date2.setHours(0, 0, 0, 0);
  return date2;
}
function startOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var cleanDate = toDate(dirtyDate);
  var date2 = /* @__PURE__ */ new Date(0);
  date2.setFullYear(cleanDate.getFullYear(), 0, 1);
  date2.setHours(0, 0, 0, 0);
  return date2;
}
function endOfWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions2 = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  var date2 = toDate(dirtyDate);
  var day = date2.getDay();
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
  date2.setDate(date2.getDate() + diff);
  date2.setHours(23, 59, 59, 999);
  return date2;
}
function endOfISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  return endOfWeek(dirtyDate, {
    weekStartsOn: 1
  });
}
function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}
var MILLISECONDS_IN_DAY = 864e5;
function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date2 = toDate(dirtyDate);
  var timestamp = date2.getTime();
  date2.setUTCMonth(0, 1);
  date2.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date2.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}
function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date2 = toDate(dirtyDate);
  var day = date2.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date2.setUTCDate(date2.getUTCDate() - diff);
  date2.setUTCHours(0, 0, 0, 0);
  return date2;
}
function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date2 = toDate(dirtyDate);
  var year = date2.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = /* @__PURE__ */ new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = /* @__PURE__ */ new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);
  if (date2.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date2.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = /* @__PURE__ */ new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date2 = startOfUTCISOWeek(fourthOfJanuary);
  return date2;
}
var MILLISECONDS_IN_WEEK$3 = 6048e5;
function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date2 = toDate(dirtyDate);
  var diff = startOfUTCISOWeek(date2).getTime() - startOfUTCISOWeekYear(date2).getTime();
  return Math.round(diff / MILLISECONDS_IN_WEEK$3) + 1;
}
function startOfUTCWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions2 = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  var date2 = toDate(dirtyDate);
  var day = date2.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date2.setUTCDate(date2.getUTCDate() - diff);
  date2.setUTCHours(0, 0, 0, 0);
  return date2;
}
function getUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var date2 = toDate(dirtyDate);
  var year = date2.getUTCFullYear();
  var defaultOptions2 = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  }
  var firstWeekOfNextYear = /* @__PURE__ */ new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = /* @__PURE__ */ new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, options);
  if (date2.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date2.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
function startOfUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions2 = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = getUTCWeekYear(dirtyDate, options);
  var firstWeek = /* @__PURE__ */ new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date2 = startOfUTCWeek(firstWeek, options);
  return date2;
}
var MILLISECONDS_IN_WEEK$2 = 6048e5;
function getUTCWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date2 = toDate(dirtyDate);
  var diff = startOfUTCWeek(date2, options).getTime() - startOfUTCWeekYear(date2, options).getTime();
  return Math.round(diff / MILLISECONDS_IN_WEEK$2) + 1;
}
function addLeadingZeros(number2, targetLength) {
  var sign2 = number2 < 0 ? "-" : "";
  var output = Math.abs(number2).toString();
  while (output.length < targetLength) {
    output = "0" + output;
  }
  return sign2 + output;
}
var formatters$2 = {
  // Year
  y: function y(date2, token) {
    var signedYear = date2.getUTCFullYear();
    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === "yy" ? year % 100 : year, token.length);
  },
  // Month
  M: function M(date2, token) {
    var month = date2.getUTCMonth();
    return token === "M" ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function d2(date2, token) {
    return addLeadingZeros(date2.getUTCDate(), token.length);
  },
  // AM or PM
  a: function a(date2, token) {
    var dayPeriodEnumValue = date2.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (token) {
      case "a":
      case "aa":
        return dayPeriodEnumValue.toUpperCase();
      case "aaa":
        return dayPeriodEnumValue;
      case "aaaaa":
        return dayPeriodEnumValue[0];
      case "aaaa":
      default:
        return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function h2(date2, token) {
    return addLeadingZeros(date2.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function H2(date2, token) {
    return addLeadingZeros(date2.getUTCHours(), token.length);
  },
  // Minute
  m: function m2(date2, token) {
    return addLeadingZeros(date2.getUTCMinutes(), token.length);
  },
  // Second
  s: function s(date2, token) {
    return addLeadingZeros(date2.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function S2(date2, token) {
    var numberOfDigits = token.length;
    var milliseconds = date2.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};
var dayPeriodEnum = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
};
var formatters$1 = {
  // Era
  G: function G(date2, token, localize2) {
    var era = date2.getUTCFullYear() > 0 ? 1 : 0;
    switch (token) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return localize2.era(era, {
          width: "abbreviated"
        });
      // A, B
      case "GGGGG":
        return localize2.era(era, {
          width: "narrow"
        });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return localize2.era(era, {
          width: "wide"
        });
    }
  },
  // Year
  y: function y2(date2, token, localize2) {
    if (token === "yo") {
      var signedYear = date2.getUTCFullYear();
      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize2.ordinalNumber(year, {
        unit: "year"
      });
    }
    return formatters$2.y(date2, token);
  },
  // Local week-numbering year
  Y: function Y(date2, token, localize2, options) {
    var signedWeekYear = getUTCWeekYear(date2, options);
    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
    if (token === "YY") {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }
    if (token === "Yo") {
      return localize2.ordinalNumber(weekYear, {
        unit: "year"
      });
    }
    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function R2(date2, token) {
    var isoWeekYear = getUTCISOWeekYear(date2);
    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function u2(date2, token) {
    var year = date2.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function Q(date2, token, localize2) {
    var quarter = Math.ceil((date2.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case "Q":
        return String(quarter);
      // 01, 02, 03, 04
      case "QQ":
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return localize2.ordinalNumber(quarter, {
          unit: "quarter"
        });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return localize2.quarter(quarter, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return localize2.quarter(quarter, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return localize2.quarter(quarter, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function q(date2, token, localize2) {
    var quarter = Math.ceil((date2.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case "q":
        return String(quarter);
      // 01, 02, 03, 04
      case "qq":
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return localize2.ordinalNumber(quarter, {
          unit: "quarter"
        });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return localize2.quarter(quarter, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return localize2.quarter(quarter, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return localize2.quarter(quarter, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function M2(date2, token, localize2) {
    var month = date2.getUTCMonth();
    switch (token) {
      case "M":
      case "MM":
        return formatters$2.M(date2, token);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return localize2.ordinalNumber(month + 1, {
          unit: "month"
        });
      // Jan, Feb, ..., Dec
      case "MMM":
        return localize2.month(month, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return localize2.month(month, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return localize2.month(month, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function L2(date2, token, localize2) {
    var month = date2.getUTCMonth();
    switch (token) {
      // 1, 2, ..., 12
      case "L":
        return String(month + 1);
      // 01, 02, ..., 12
      case "LL":
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return localize2.ordinalNumber(month + 1, {
          unit: "month"
        });
      // Jan, Feb, ..., Dec
      case "LLL":
        return localize2.month(month, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return localize2.month(month, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return localize2.month(month, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function w2(date2, token, localize2, options) {
    var week = getUTCWeek(date2, options);
    if (token === "wo") {
      return localize2.ordinalNumber(week, {
        unit: "week"
      });
    }
    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function I(date2, token, localize2) {
    var isoWeek = getUTCISOWeek(date2);
    if (token === "Io") {
      return localize2.ordinalNumber(isoWeek, {
        unit: "week"
      });
    }
    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function d3(date2, token, localize2) {
    if (token === "do") {
      return localize2.ordinalNumber(date2.getUTCDate(), {
        unit: "date"
      });
    }
    return formatters$2.d(date2, token);
  },
  // Day of year
  D: function D2(date2, token, localize2) {
    var dayOfYear = getUTCDayOfYear(date2);
    if (token === "Do") {
      return localize2.ordinalNumber(dayOfYear, {
        unit: "dayOfYear"
      });
    }
    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function E2(date2, token, localize2) {
    var dayOfWeek = date2.getUTCDay();
    switch (token) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function e2(date2, token, localize2, options) {
    var dayOfWeek = date2.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(localDayOfWeek);
      // Padded numerical value
      case "ee":
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return localize2.ordinalNumber(localDayOfWeek, {
          unit: "day"
        });
      case "eee":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function c(date2, token, localize2, options) {
    var dayOfWeek = date2.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (same as in `e`)
      case "c":
        return String(localDayOfWeek);
      // Padded numerical value
      case "cc":
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return localize2.ordinalNumber(localDayOfWeek, {
          unit: "day"
        });
      case "ccc":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function i2(date2, token, localize2) {
    var dayOfWeek = date2.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      // 2
      case "i":
        return String(isoDayOfWeek);
      // 02
      case "ii":
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd
      case "io":
        return localize2.ordinalNumber(isoDayOfWeek, {
          unit: "day"
        });
      // Tue
      case "iii":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function a2(date2, token, localize2) {
    var hours = date2.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    switch (token) {
      case "a":
      case "aa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function b(date2, token, localize2) {
    var hours = date2.getUTCHours();
    var dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    }
    switch (token) {
      case "b":
      case "bb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function B(date2, token, localize2) {
    var hours = date2.getUTCHours();
    var dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token) {
      case "B":
      case "BB":
      case "BBB":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function h3(date2, token, localize2) {
    if (token === "ho") {
      var hours = date2.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize2.ordinalNumber(hours, {
        unit: "hour"
      });
    }
    return formatters$2.h(date2, token);
  },
  // Hour [0-23]
  H: function H3(date2, token, localize2) {
    if (token === "Ho") {
      return localize2.ordinalNumber(date2.getUTCHours(), {
        unit: "hour"
      });
    }
    return formatters$2.H(date2, token);
  },
  // Hour [0-11]
  K: function K(date2, token, localize2) {
    var hours = date2.getUTCHours() % 12;
    if (token === "Ko") {
      return localize2.ordinalNumber(hours, {
        unit: "hour"
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function k(date2, token, localize2) {
    var hours = date2.getUTCHours();
    if (hours === 0) hours = 24;
    if (token === "ko") {
      return localize2.ordinalNumber(hours, {
        unit: "hour"
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function m3(date2, token, localize2) {
    if (token === "mo") {
      return localize2.ordinalNumber(date2.getUTCMinutes(), {
        unit: "minute"
      });
    }
    return formatters$2.m(date2, token);
  },
  // Second
  s: function s2(date2, token, localize2) {
    if (token === "so") {
      return localize2.ordinalNumber(date2.getUTCSeconds(), {
        unit: "second"
      });
    }
    return formatters$2.s(date2, token);
  },
  // Fraction of second
  S: function S3(date2, token) {
    return formatters$2.S(date2, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function X(date2, token, _localize, options) {
    var originalDate = options._originalDate || date2;
    var timezoneOffset = originalDate.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return "Z";
    }
    switch (token) {
      // Hours and optional minutes
      case "X":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function x(date2, token, _localize, options) {
    var originalDate = options._originalDate || date2;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Hours and optional minutes
      case "x":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },
  // Timezone (GMT)
  O: function O2(date2, token, _localize, options) {
    var originalDate = options._originalDate || date2;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },
  // Timezone (specific non-location)
  z: function z2(date2, token, _localize, options) {
    var originalDate = options._originalDate || date2;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },
  // Seconds timestamp
  t: function t2(date2, token, _localize, options) {
    var originalDate = options._originalDate || date2;
    var timestamp = Math.floor(originalDate.getTime() / 1e3);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function T2(date2, token, _localize, options) {
    var originalDate = options._originalDate || date2;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};
function formatTimezoneShort(offset2, dirtyDelimiter) {
  var sign2 = offset2 > 0 ? "-" : "+";
  var absOffset = Math.abs(offset2);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  if (minutes === 0) {
    return sign2 + String(hours);
  }
  var delimiter = dirtyDelimiter;
  return sign2 + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset2, dirtyDelimiter) {
  if (offset2 % 60 === 0) {
    var sign2 = offset2 > 0 ? "-" : "+";
    return sign2 + addLeadingZeros(Math.abs(offset2) / 60, 2);
  }
  return formatTimezone(offset2, dirtyDelimiter);
}
function formatTimezone(offset2, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || "";
  var sign2 = offset2 > 0 ? "-" : "+";
  var absOffset = Math.abs(offset2);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign2 + hours + delimiter + minutes;
}
var dateLongFormatter = function dateLongFormatter2(pattern, formatLong2) {
  switch (pattern) {
    case "P":
      return formatLong2.date({
        width: "short"
      });
    case "PP":
      return formatLong2.date({
        width: "medium"
      });
    case "PPP":
      return formatLong2.date({
        width: "long"
      });
    case "PPPP":
    default:
      return formatLong2.date({
        width: "full"
      });
  }
};
var timeLongFormatter = function timeLongFormatter2(pattern, formatLong2) {
  switch (pattern) {
    case "p":
      return formatLong2.time({
        width: "short"
      });
    case "pp":
      return formatLong2.time({
        width: "medium"
      });
    case "ppp":
      return formatLong2.time({
        width: "long"
      });
    case "pppp":
    default:
      return formatLong2.time({
        width: "full"
      });
  }
};
var dateTimeLongFormatter = function dateTimeLongFormatter2(pattern, formatLong2) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong2);
  }
  var dateTimeFormat;
  switch (datePattern) {
    case "P":
      dateTimeFormat = formatLong2.dateTime({
        width: "short"
      });
      break;
    case "PP":
      dateTimeFormat = formatLong2.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      dateTimeFormat = formatLong2.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      dateTimeFormat = formatLong2.dateTime({
        width: "full"
      });
      break;
  }
  return dateTimeFormat.replace("{{date}}", dateLongFormatter(datePattern, formatLong2)).replace("{{time}}", timeLongFormatter(timePattern, formatLong2));
};
var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
var protectedDayOfYearTokens = ["D", "DD"];
var protectedWeekYearTokens = ["YY", "YYYY"];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format2, input) {
  if (token === "YYYY") {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format2, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === "YY") {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format2, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === "D") {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format2, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === "DD") {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format2, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  }
}
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
};
var formatDistance = function formatDistance2(token, count2, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count2 === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", count2.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "in " + result;
    } else {
      return result + " ago";
    }
  }
  return result;
};
function buildFormatLongFn(args) {
  return function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format2 = args.formats[width] || args.formats[args.defaultWidth];
    return format2;
  };
}
var dateFormats = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
};
var timeFormats = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: "full"
  })
};
var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
};
var formatRelative = function formatRelative2(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};
function buildLocalizeFn(args) {
  return function(dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : "standalone";
    var valuesArray;
    if (context === "formatting" && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;
      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }
    var index2 = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    return valuesArray[index2];
  };
}
var eraValues = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
};
var quarterValues = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
};
var monthValues = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
};
var dayValues = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
};
var dayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
};
var ordinalNumber = function ordinalNumber2(dirtyNumber, _options) {
  var number2 = Number(dirtyNumber);
  var rem100 = number2 % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number2 + "st";
      case 2:
        return number2 + "nd";
      case 3:
        return number2 + "rd";
    }
  }
  return number2 + "th";
};
var localize = {
  ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: "wide",
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: "wide"
  })
};
function buildMatchFn(args) {
  return function(string2) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string2.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex$1(parsePatterns, function(pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function(pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string2.slice(matchedString.length);
    return {
      value,
      rest
    };
  };
}
function findKey(object2, predicate) {
  for (var key in object2) {
    if (object2.hasOwnProperty(key) && predicate(object2[key])) {
      return key;
    }
  }
  return void 0;
}
function findIndex$1(array2, predicate) {
  for (var key = 0; key < array2.length; key++) {
    if (predicate(array2[key])) {
      return key;
    }
  }
  return void 0;
}
function buildMatchPatternFn(args) {
  return function(string2) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var matchResult = string2.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string2.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string2.slice(matchedString.length);
    return {
      value,
      rest
    };
  };
}
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: "any",
    valueCallback: function valueCallback2(index2) {
      return index2 + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: "any"
  })
};
var locale$2 = {
  code: "en-US",
  formatDistance,
  formatLong,
  formatRelative,
  localize,
  match,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function format$2(dirtyDate, dirtyFormatStr, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var defaultOptions2 = getDefaultOptions();
  var locale2 = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions2.locale) !== null && _ref !== void 0 ? _ref : locale$2;
  var firstWeekContainsDate = toInteger((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions2.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  }
  var weekStartsOn = toInteger((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions2.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions2.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  if (!locale2.localize) {
    throw new RangeError("locale must contain localize property");
  }
  if (!locale2.formatLong) {
    throw new RangeError("locale must contain formatLong property");
  }
  var originalDate = toDate(dirtyDate);
  if (!isValid(originalDate)) {
    throw new RangeError("Invalid time value");
  }
  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate2 = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale: locale2,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function(substring) {
    var firstCharacter = substring[0];
    if (firstCharacter === "p" || firstCharacter === "P") {
      var longFormatter = longFormatters[firstCharacter];
      return longFormatter(substring, locale2.formatLong);
    }
    return substring;
  }).join("").match(formattingTokensRegExp).map(function(substring) {
    if (substring === "''") {
      return "'";
    }
    var firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }
    var formatter = formatters$1[firstCharacter];
    if (formatter) {
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      return formatter(utcDate2, substring, locale2.localize, formatterOptions);
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
    }
    return substring;
  }).join("");
  return result;
}
function cleanEscapedString(input) {
  var matched = input.match(escapedStringRegExp);
  if (!matched) {
    return input;
  }
  return matched[1].replace(doubleQuoteRegExp, "'");
}
function getDaysInMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date2 = toDate(dirtyDate);
  var year = date2.getFullYear();
  var monthIndex = date2.getMonth();
  var lastDayOfMonth2 = /* @__PURE__ */ new Date(0);
  lastDayOfMonth2.setFullYear(year, monthIndex + 1, 0);
  lastDayOfMonth2.setHours(0, 0, 0, 0);
  return lastDayOfMonth2.getDate();
}
var MILLISECONDS_IN_WEEK$1 = 6048e5;
function getISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date2 = toDate(dirtyDate);
  var diff = startOfISOWeek(date2).getTime() - startOfISOWeekYear(date2).getTime();
  return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
}
function getTime$1(dirtyDate) {
  requiredArgs(1, arguments);
  var date2 = toDate(dirtyDate);
  var timestamp = date2.getTime();
  return timestamp;
}
function getUnixTime(dirtyDate) {
  requiredArgs(1, arguments);
  return Math.floor(getTime$1(dirtyDate) / 1e3);
}
function getWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var date2 = toDate(dirtyDate);
  var year = date2.getFullYear();
  var defaultOptions2 = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  }
  var firstWeekOfNextYear = /* @__PURE__ */ new Date(0);
  firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setHours(0, 0, 0, 0);
  var startOfNextYear = startOfWeek(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = /* @__PURE__ */ new Date(0);
  firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setHours(0, 0, 0, 0);
  var startOfThisYear = startOfWeek(firstWeekOfThisYear, options);
  if (date2.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date2.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
function startOfWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions2 = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = getWeekYear(dirtyDate, options);
  var firstWeek = /* @__PURE__ */ new Date(0);
  firstWeek.setFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setHours(0, 0, 0, 0);
  var date2 = startOfWeek(firstWeek, options);
  return date2;
}
var MILLISECONDS_IN_WEEK = 6048e5;
function getWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date2 = toDate(dirtyDate);
  var diff = startOfWeek(date2, options).getTime() - startOfWeekYear(date2, options).getTime();
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}
function lastDayOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date2 = toDate(dirtyDate);
  var month = date2.getMonth();
  date2.setFullYear(date2.getFullYear(), month + 1, 0);
  date2.setHours(0, 0, 0, 0);
  return date2;
}
function getWeeksInMonth(date2, options) {
  requiredArgs(1, arguments);
  return differenceInCalendarWeeks(lastDayOfMonth(date2), startOfMonth(date2), options) + 1;
}
function isAfter(dirtyDate, dirtyDateToCompare) {
  requiredArgs(2, arguments);
  var date2 = toDate(dirtyDate);
  var dateToCompare = toDate(dirtyDateToCompare);
  return date2.getTime() > dateToCompare.getTime();
}
function isBefore(dirtyDate, dirtyDateToCompare) {
  requiredArgs(2, arguments);
  var date2 = toDate(dirtyDate);
  var dateToCompare = toDate(dirtyDateToCompare);
  return date2.getTime() < dateToCompare.getTime();
}
function isEqual$2(dirtyLeftDate, dirtyRightDate) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyLeftDate);
  var dateRight = toDate(dirtyRightDate);
  return dateLeft.getTime() === dateRight.getTime();
}
function _assertThisInitialized$l(e3) {
  if (void 0 === e3) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e3;
}
function _setPrototypeOf$l(t3, e3) {
  return _setPrototypeOf$l = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e4) {
    return t4.__proto__ = e4, t4;
  }, _setPrototypeOf$l(t3, e3);
}
function isSameMonth(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}
function isSameYear(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear();
}
function subDays(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addDays(dirtyDate, -amount);
}
function setMonth(dirtyDate, dirtyMonth) {
  requiredArgs(2, arguments);
  var date2 = toDate(dirtyDate);
  var month = toInteger(dirtyMonth);
  var year = date2.getFullYear();
  var day = date2.getDate();
  var dateWithDesiredMonth = /* @__PURE__ */ new Date(0);
  dateWithDesiredMonth.setFullYear(year, month, 15);
  dateWithDesiredMonth.setHours(0, 0, 0, 0);
  var daysInMonth = getDaysInMonth(dateWithDesiredMonth);
  date2.setMonth(month, Math.min(day, daysInMonth));
  return date2;
}
function setYear(dirtyDate, dirtyYear) {
  requiredArgs(2, arguments);
  var date2 = toDate(dirtyDate);
  var year = toInteger(dirtyYear);
  if (isNaN(date2.getTime())) {
    return /* @__PURE__ */ new Date(NaN);
  }
  date2.setFullYear(year);
  return date2;
}
var __assign = function() {
  __assign = Object.assign || function __assign2(t3) {
    for (var s4, i3 = 1, n2 = arguments.length; i3 < n2; i3++) {
      s4 = arguments[i3];
      for (var p2 in s4) if (Object.prototype.hasOwnProperty.call(s4, p2)) t3[p2] = s4[p2];
    }
    return t3;
  };
  return __assign.apply(this, arguments);
};
function __rest(s4, e3) {
  var t3 = {};
  for (var p2 in s4) if (Object.prototype.hasOwnProperty.call(s4, p2) && e3.indexOf(p2) < 0)
    t3[p2] = s4[p2];
  if (s4 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i3 = 0, p2 = Object.getOwnPropertySymbols(s4); i3 < p2.length; i3++) {
      if (e3.indexOf(p2[i3]) < 0 && Object.prototype.propertyIsEnumerable.call(s4, p2[i3]))
        t3[p2[i3]] = s4[p2[i3]];
    }
  return t3;
}
function __spreadArray(to, from, pack) {
  for (var i3 = 0, l2 = from.length, ar; i3 < l2; i3++) {
    if (ar || !(i3 in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i3);
      ar[i3] = from[i3];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}
typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
  var e3 = new Error(message);
  return e3.name = "SuppressedError", e3.error = error, e3.suppressed = suppressed, e3;
};
function isDayPickerMultiple(props) {
  return props.mode === "multiple";
}
function isDayPickerRange(props) {
  return props.mode === "range";
}
function isDayPickerSingle(props) {
  return props.mode === "single";
}
var defaultClassNames = {
  root: "rdp",
  multiple_months: "rdp-multiple_months",
  with_weeknumber: "rdp-with_weeknumber",
  vhidden: "rdp-vhidden",
  button_reset: "rdp-button_reset",
  button: "rdp-button",
  caption: "rdp-caption",
  caption_start: "rdp-caption_start",
  caption_end: "rdp-caption_end",
  caption_between: "rdp-caption_between",
  caption_label: "rdp-caption_label",
  caption_dropdowns: "rdp-caption_dropdowns",
  dropdown: "rdp-dropdown",
  dropdown_month: "rdp-dropdown_month",
  dropdown_year: "rdp-dropdown_year",
  dropdown_icon: "rdp-dropdown_icon",
  months: "rdp-months",
  month: "rdp-month",
  table: "rdp-table",
  tbody: "rdp-tbody",
  tfoot: "rdp-tfoot",
  head: "rdp-head",
  head_row: "rdp-head_row",
  head_cell: "rdp-head_cell",
  nav: "rdp-nav",
  nav_button: "rdp-nav_button",
  nav_button_previous: "rdp-nav_button_previous",
  nav_button_next: "rdp-nav_button_next",
  nav_icon: "rdp-nav_icon",
  row: "rdp-row",
  weeknumber: "rdp-weeknumber",
  cell: "rdp-cell",
  day: "rdp-day",
  day_today: "rdp-day_today",
  day_outside: "rdp-day_outside",
  day_selected: "rdp-day_selected",
  day_disabled: "rdp-day_disabled",
  day_hidden: "rdp-day_hidden",
  day_range_start: "rdp-day_range_start",
  day_range_end: "rdp-day_range_end",
  day_range_middle: "rdp-day_range_middle"
};
function formatCaption(month, options) {
  return format$2(month, "LLLL y", options);
}
function formatDay(day, options) {
  return format$2(day, "d", options);
}
function formatMonthCaption(month, options) {
  return format$2(month, "LLLL", options);
}
function formatWeekNumber(weekNumber) {
  return "".concat(weekNumber);
}
function formatWeekdayName(weekday, options) {
  return format$2(weekday, "cccccc", options);
}
function formatYearCaption(year, options) {
  return format$2(year, "yyyy", options);
}
var formatters = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  formatCaption,
  formatDay,
  formatMonthCaption,
  formatWeekNumber,
  formatWeekdayName,
  formatYearCaption
});
var labelDay = function(day, activeModifiers, options) {
  return format$2(day, "do MMMM (EEEE)", options);
};
var labelMonthDropdown = function() {
  return "Month: ";
};
var labelNext = function() {
  return "Go to next month";
};
var labelPrevious = function() {
  return "Go to previous month";
};
var labelWeekday = function(day, options) {
  return format$2(day, "cccc", options);
};
var labelWeekNumber = function(n2) {
  return "Week n. ".concat(n2);
};
var labelYearDropdown = function() {
  return "Year: ";
};
var labels = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  labelDay,
  labelMonthDropdown,
  labelNext,
  labelPrevious,
  labelWeekNumber,
  labelWeekday,
  labelYearDropdown
});
function getDefaultContextValues() {
  var captionLayout = "buttons";
  var classNames = defaultClassNames;
  var locale2 = locale$2;
  var modifiersClassNames = {};
  var modifiers2 = {};
  var numberOfMonths = 1;
  var styles = {};
  var today = /* @__PURE__ */ new Date();
  return {
    captionLayout,
    classNames,
    formatters,
    labels,
    locale: locale2,
    modifiersClassNames,
    modifiers: modifiers2,
    numberOfMonths,
    styles,
    today,
    mode: "default"
  };
}
function parseFromToProps(props) {
  var fromYear = props.fromYear, toYear = props.toYear, fromMonth = props.fromMonth, toMonth = props.toMonth;
  var fromDate = props.fromDate, toDate2 = props.toDate;
  if (fromMonth) {
    fromDate = startOfMonth(fromMonth);
  } else if (fromYear) {
    fromDate = new Date(fromYear, 0, 1);
  }
  if (toMonth) {
    toDate2 = endOfMonth(toMonth);
  } else if (toYear) {
    toDate2 = new Date(toYear, 11, 31);
  }
  return {
    fromDate: fromDate ? startOfDay(fromDate) : void 0,
    toDate: toDate2 ? startOfDay(toDate2) : void 0
  };
}
var DayPickerContext = createContext(void 0);
function DayPickerProvider(props) {
  var _a;
  var initialProps = props.initialProps;
  var defaultContextValues = getDefaultContextValues();
  var _b = parseFromToProps(initialProps), fromDate = _b.fromDate, toDate2 = _b.toDate;
  var captionLayout = (_a = initialProps.captionLayout) !== null && _a !== void 0 ? _a : defaultContextValues.captionLayout;
  if (captionLayout !== "buttons" && (!fromDate || !toDate2)) {
    captionLayout = "buttons";
  }
  var onSelect;
  if (isDayPickerSingle(initialProps) || isDayPickerMultiple(initialProps) || isDayPickerRange(initialProps)) {
    onSelect = initialProps.onSelect;
  }
  var value = __assign(__assign(__assign({}, defaultContextValues), initialProps), { captionLayout, classNames: __assign(__assign({}, defaultContextValues.classNames), initialProps.classNames), components: __assign({}, initialProps.components), formatters: __assign(__assign({}, defaultContextValues.formatters), initialProps.formatters), fromDate, labels: __assign(__assign({}, defaultContextValues.labels), initialProps.labels), mode: initialProps.mode || defaultContextValues.mode, modifiers: __assign(__assign({}, defaultContextValues.modifiers), initialProps.modifiers), modifiersClassNames: __assign(__assign({}, defaultContextValues.modifiersClassNames), initialProps.modifiersClassNames), onSelect, styles: __assign(__assign({}, defaultContextValues.styles), initialProps.styles), toDate: toDate2 });
  return jsx(DayPickerContext.Provider, { value, children: props.children });
}
function useDayPicker() {
  var context = useContext(DayPickerContext);
  if (!context) {
    throw new Error("useDayPicker must be used within a DayPickerProvider.");
  }
  return context;
}
function CaptionLabel(props) {
  var _a = useDayPicker(), locale2 = _a.locale, classNames = _a.classNames, styles = _a.styles, formatCaption2 = _a.formatters.formatCaption;
  return jsx("div", { className: classNames.caption_label, style: styles.caption_label, "aria-live": "polite", role: "presentation", id: props.id, children: formatCaption2(props.displayMonth, { locale: locale2 }) });
}
function IconDropdown(props) {
  return jsx("svg", __assign({ width: "8px", height: "8px", viewBox: "0 0 120 120", "data-testid": "iconDropdown" }, props, { children: jsx("path", { d: "M4.22182541,48.2218254 C8.44222828,44.0014225 15.2388494,43.9273804 19.5496459,47.9996989 L19.7781746,48.2218254 L60,88.443 L100.221825,48.2218254 C104.442228,44.0014225 111.238849,43.9273804 115.549646,47.9996989 L115.778175,48.2218254 C119.998577,52.4422283 120.07262,59.2388494 116.000301,63.5496459 L115.778175,63.7781746 L67.7781746,111.778175 C63.5577717,115.998577 56.7611506,116.07262 52.4503541,112.000301 L52.2218254,111.778175 L4.22182541,63.7781746 C-0.0739418023,59.4824074 -0.0739418023,52.5175926 4.22182541,48.2218254 Z", fill: "currentColor", fillRule: "nonzero" }) }));
}
function Dropdown(props) {
  var _a, _b;
  var onChange = props.onChange, value = props.value, children = props.children, caption = props.caption, className = props.className, style = props.style;
  var dayPicker = useDayPicker();
  var IconDropdownComponent = (_b = (_a = dayPicker.components) === null || _a === void 0 ? void 0 : _a.IconDropdown) !== null && _b !== void 0 ? _b : IconDropdown;
  return jsxs("div", { className, style, children: [jsx("span", { className: dayPicker.classNames.vhidden, children: props["aria-label"] }), jsx("select", { name: props.name, "aria-label": props["aria-label"], className: dayPicker.classNames.dropdown, style: dayPicker.styles.dropdown, value, onChange, children }), jsxs("div", { className: dayPicker.classNames.caption_label, style: dayPicker.styles.caption_label, "aria-hidden": "true", children: [caption, jsx(IconDropdownComponent, { className: dayPicker.classNames.dropdown_icon, style: dayPicker.styles.dropdown_icon })] })] });
}
function MonthsDropdown(props) {
  var _a;
  var _b = useDayPicker(), fromDate = _b.fromDate, toDate2 = _b.toDate, styles = _b.styles, locale2 = _b.locale, formatMonthCaption2 = _b.formatters.formatMonthCaption, classNames = _b.classNames, components = _b.components, labelMonthDropdown2 = _b.labels.labelMonthDropdown;
  if (!fromDate)
    return jsx(Fragment$1, {});
  if (!toDate2)
    return jsx(Fragment$1, {});
  var dropdownMonths = [];
  if (isSameYear(fromDate, toDate2)) {
    var date2 = startOfMonth(fromDate);
    for (var month = fromDate.getMonth(); month <= toDate2.getMonth(); month++) {
      dropdownMonths.push(setMonth(date2, month));
    }
  } else {
    var date2 = startOfMonth(/* @__PURE__ */ new Date());
    for (var month = 0; month <= 11; month++) {
      dropdownMonths.push(setMonth(date2, month));
    }
  }
  var handleChange = function(e3) {
    var selectedMonth = Number(e3.target.value);
    var newMonth = setMonth(startOfMonth(props.displayMonth), selectedMonth);
    props.onChange(newMonth);
  };
  var DropdownComponent = (_a = components === null || components === void 0 ? void 0 : components.Dropdown) !== null && _a !== void 0 ? _a : Dropdown;
  return jsx(DropdownComponent, { name: "months", "aria-label": labelMonthDropdown2(), className: classNames.dropdown_month, style: styles.dropdown_month, onChange: handleChange, value: props.displayMonth.getMonth(), caption: formatMonthCaption2(props.displayMonth, { locale: locale2 }), children: dropdownMonths.map(function(m4) {
    return jsx("option", { value: m4.getMonth(), children: formatMonthCaption2(m4, { locale: locale2 }) }, m4.getMonth());
  }) });
}
function YearsDropdown(props) {
  var _a;
  var displayMonth = props.displayMonth;
  var _b = useDayPicker(), fromDate = _b.fromDate, toDate2 = _b.toDate, locale2 = _b.locale, styles = _b.styles, classNames = _b.classNames, components = _b.components, formatYearCaption2 = _b.formatters.formatYearCaption, labelYearDropdown2 = _b.labels.labelYearDropdown;
  var years2 = [];
  if (!fromDate)
    return jsx(Fragment$1, {});
  if (!toDate2)
    return jsx(Fragment$1, {});
  var fromYear = fromDate.getFullYear();
  var toYear = toDate2.getFullYear();
  for (var year = fromYear; year <= toYear; year++) {
    years2.push(setYear(startOfYear(/* @__PURE__ */ new Date()), year));
  }
  var handleChange = function(e3) {
    var newMonth = setYear(startOfMonth(displayMonth), Number(e3.target.value));
    props.onChange(newMonth);
  };
  var DropdownComponent = (_a = components === null || components === void 0 ? void 0 : components.Dropdown) !== null && _a !== void 0 ? _a : Dropdown;
  return jsx(DropdownComponent, { name: "years", "aria-label": labelYearDropdown2(), className: classNames.dropdown_year, style: styles.dropdown_year, onChange: handleChange, value: displayMonth.getFullYear(), caption: formatYearCaption2(displayMonth, { locale: locale2 }), children: years2.map(function(year2) {
    return jsx("option", { value: year2.getFullYear(), children: formatYearCaption2(year2, { locale: locale2 }) }, year2.getFullYear());
  }) });
}
function useControlledValue(defaultValue2, controlledValue) {
  var _a = useState(defaultValue2), uncontrolledValue = _a[0], setValue = _a[1];
  var value = controlledValue === void 0 ? uncontrolledValue : controlledValue;
  return [value, setValue];
}
function getInitialMonth(context) {
  var month = context.month, defaultMonth = context.defaultMonth, today = context.today;
  var initialMonth = month || defaultMonth || today || /* @__PURE__ */ new Date();
  var toDate2 = context.toDate, fromDate = context.fromDate, _a = context.numberOfMonths, numberOfMonths = _a === void 0 ? 1 : _a;
  if (toDate2 && differenceInCalendarMonths(toDate2, initialMonth) < 0) {
    var offset2 = -1 * (numberOfMonths - 1);
    initialMonth = addMonths(toDate2, offset2);
  }
  if (fromDate && differenceInCalendarMonths(initialMonth, fromDate) < 0) {
    initialMonth = fromDate;
  }
  return startOfMonth(initialMonth);
}
function useNavigationState() {
  var context = useDayPicker();
  var initialMonth = getInitialMonth(context);
  var _a = useControlledValue(initialMonth, context.month), month = _a[0], setMonth2 = _a[1];
  var goToMonth = function(date2) {
    var _a2;
    if (context.disableNavigation)
      return;
    var month2 = startOfMonth(date2);
    setMonth2(month2);
    (_a2 = context.onMonthChange) === null || _a2 === void 0 ? void 0 : _a2.call(context, month2);
  };
  return [month, goToMonth];
}
function getDisplayMonths(month, _a) {
  var reverseMonths = _a.reverseMonths, numberOfMonths = _a.numberOfMonths;
  var start = startOfMonth(month);
  var end = startOfMonth(addMonths(start, numberOfMonths));
  var monthsDiff = differenceInCalendarMonths(end, start);
  var months = [];
  for (var i3 = 0; i3 < monthsDiff; i3++) {
    var nextMonth = addMonths(start, i3);
    months.push(nextMonth);
  }
  if (reverseMonths)
    months = months.reverse();
  return months;
}
function getNextMonth(startingMonth, options) {
  if (options.disableNavigation) {
    return void 0;
  }
  var toDate2 = options.toDate, pagedNavigation = options.pagedNavigation, _a = options.numberOfMonths, numberOfMonths = _a === void 0 ? 1 : _a;
  var offset2 = pagedNavigation ? numberOfMonths : 1;
  var month = startOfMonth(startingMonth);
  if (!toDate2) {
    return addMonths(month, offset2);
  }
  var monthsDiff = differenceInCalendarMonths(toDate2, startingMonth);
  if (monthsDiff < numberOfMonths) {
    return void 0;
  }
  return addMonths(month, offset2);
}
function getPreviousMonth(startingMonth, options) {
  if (options.disableNavigation) {
    return void 0;
  }
  var fromDate = options.fromDate, pagedNavigation = options.pagedNavigation, _a = options.numberOfMonths, numberOfMonths = _a === void 0 ? 1 : _a;
  var offset2 = pagedNavigation ? numberOfMonths : 1;
  var month = startOfMonth(startingMonth);
  if (!fromDate) {
    return addMonths(month, -offset2);
  }
  var monthsDiff = differenceInCalendarMonths(month, fromDate);
  if (monthsDiff <= 0) {
    return void 0;
  }
  return addMonths(month, -offset2);
}
var NavigationContext = createContext(void 0);
function NavigationProvider(props) {
  var dayPicker = useDayPicker();
  var _a = useNavigationState(), currentMonth = _a[0], goToMonth = _a[1];
  var displayMonths = getDisplayMonths(currentMonth, dayPicker);
  var nextMonth = getNextMonth(currentMonth, dayPicker);
  var previousMonth = getPreviousMonth(currentMonth, dayPicker);
  var isDateDisplayed = function(date2) {
    return displayMonths.some(function(displayMonth) {
      return isSameMonth(date2, displayMonth);
    });
  };
  var goToDate = function(date2, refDate) {
    if (isDateDisplayed(date2)) {
      return;
    }
    if (refDate && isBefore(date2, refDate)) {
      goToMonth(addMonths(date2, 1 + dayPicker.numberOfMonths * -1));
    } else {
      goToMonth(date2);
    }
  };
  var value = {
    currentMonth,
    displayMonths,
    goToMonth,
    goToDate,
    previousMonth,
    nextMonth,
    isDateDisplayed
  };
  return jsx(NavigationContext.Provider, { value, children: props.children });
}
function useNavigation() {
  var context = useContext(NavigationContext);
  if (!context) {
    throw new Error("useNavigation must be used within a NavigationProvider");
  }
  return context;
}
function CaptionDropdowns(props) {
  var _a;
  var _b = useDayPicker(), classNames = _b.classNames, styles = _b.styles, components = _b.components;
  var goToMonth = useNavigation().goToMonth;
  var handleMonthChange = function(newMonth) {
    goToMonth(addMonths(newMonth, props.displayIndex ? -props.displayIndex : 0));
  };
  var CaptionLabelComponent = (_a = components === null || components === void 0 ? void 0 : components.CaptionLabel) !== null && _a !== void 0 ? _a : CaptionLabel;
  var captionLabel = jsx(CaptionLabelComponent, { id: props.id, displayMonth: props.displayMonth });
  return jsxs("div", { className: classNames.caption_dropdowns, style: styles.caption_dropdowns, children: [jsx("div", { className: classNames.vhidden, children: captionLabel }), jsx(MonthsDropdown, { onChange: handleMonthChange, displayMonth: props.displayMonth }), jsx(YearsDropdown, { onChange: handleMonthChange, displayMonth: props.displayMonth })] });
}
function IconLeft(props) {
  return jsx("svg", __assign({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, props, { children: jsx("path", { d: "M69.490332,3.34314575 C72.6145263,0.218951416 77.6798462,0.218951416 80.8040405,3.34314575 C83.8617626,6.40086786 83.9268205,11.3179931 80.9992143,14.4548388 L80.8040405,14.6568542 L35.461,60 L80.8040405,105.343146 C83.8617626,108.400868 83.9268205,113.317993 80.9992143,116.454839 L80.8040405,116.656854 C77.7463184,119.714576 72.8291931,119.779634 69.6923475,116.852028 L69.490332,116.656854 L18.490332,65.6568542 C15.4326099,62.5991321 15.367552,57.6820069 18.2951583,54.5451612 L18.490332,54.3431458 L69.490332,3.34314575 Z", fill: "currentColor", fillRule: "nonzero" }) }));
}
function IconRight(props) {
  return jsx("svg", __assign({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, props, { children: jsx("path", { d: "M49.8040405,3.34314575 C46.6798462,0.218951416 41.6145263,0.218951416 38.490332,3.34314575 C35.4326099,6.40086786 35.367552,11.3179931 38.2951583,14.4548388 L38.490332,14.6568542 L83.8333725,60 L38.490332,105.343146 C35.4326099,108.400868 35.367552,113.317993 38.2951583,116.454839 L38.490332,116.656854 C41.5480541,119.714576 46.4651794,119.779634 49.602025,116.852028 L49.8040405,116.656854 L100.804041,65.6568542 C103.861763,62.5991321 103.926821,57.6820069 100.999214,54.5451612 L100.804041,54.3431458 L49.8040405,3.34314575 Z", fill: "currentColor" }) }));
}
var Button$3 = forwardRef(function(props, ref) {
  var _a = useDayPicker(), classNames = _a.classNames, styles = _a.styles;
  var classNamesArr = [classNames.button_reset, classNames.button];
  if (props.className) {
    classNamesArr.push(props.className);
  }
  var className = classNamesArr.join(" ");
  var style = __assign(__assign({}, styles.button_reset), styles.button);
  if (props.style) {
    Object.assign(style, props.style);
  }
  return jsx("button", __assign({}, props, { ref, type: "button", className, style }));
});
function Navigation$1(props) {
  var _a, _b;
  var _c = useDayPicker(), dir = _c.dir, locale2 = _c.locale, classNames = _c.classNames, styles = _c.styles, _d = _c.labels, labelPrevious2 = _d.labelPrevious, labelNext2 = _d.labelNext, components = _c.components;
  if (!props.nextMonth && !props.previousMonth) {
    return jsx(Fragment$1, {});
  }
  var previousLabel = labelPrevious2(props.previousMonth, { locale: locale2 });
  var previousClassName = [
    classNames.nav_button,
    classNames.nav_button_previous
  ].join(" ");
  var nextLabel = labelNext2(props.nextMonth, { locale: locale2 });
  var nextClassName = [
    classNames.nav_button,
    classNames.nav_button_next
  ].join(" ");
  var IconRightComponent = (_a = components === null || components === void 0 ? void 0 : components.IconRight) !== null && _a !== void 0 ? _a : IconRight;
  var IconLeftComponent = (_b = components === null || components === void 0 ? void 0 : components.IconLeft) !== null && _b !== void 0 ? _b : IconLeft;
  return jsxs("div", { className: classNames.nav, style: styles.nav, children: [!props.hidePrevious && jsx(Button$3, { name: "previous-month", "aria-label": previousLabel, className: previousClassName, style: styles.nav_button_previous, disabled: !props.previousMonth, onClick: props.onPreviousClick, children: dir === "rtl" ? jsx(IconRightComponent, { className: classNames.nav_icon, style: styles.nav_icon }) : jsx(IconLeftComponent, { className: classNames.nav_icon, style: styles.nav_icon }) }), !props.hideNext && jsx(Button$3, { name: "next-month", "aria-label": nextLabel, className: nextClassName, style: styles.nav_button_next, disabled: !props.nextMonth, onClick: props.onNextClick, children: dir === "rtl" ? jsx(IconLeftComponent, { className: classNames.nav_icon, style: styles.nav_icon }) : jsx(IconRightComponent, { className: classNames.nav_icon, style: styles.nav_icon }) })] });
}
function CaptionNavigation(props) {
  var numberOfMonths = useDayPicker().numberOfMonths;
  var _a = useNavigation(), previousMonth = _a.previousMonth, nextMonth = _a.nextMonth, goToMonth = _a.goToMonth, displayMonths = _a.displayMonths;
  var displayIndex = displayMonths.findIndex(function(month) {
    return isSameMonth(props.displayMonth, month);
  });
  var isFirst = displayIndex === 0;
  var isLast = displayIndex === displayMonths.length - 1;
  var hideNext = numberOfMonths > 1 && (isFirst || !isLast);
  var hidePrevious = numberOfMonths > 1 && (isLast || !isFirst);
  var handlePreviousClick = function() {
    if (!previousMonth)
      return;
    goToMonth(previousMonth);
  };
  var handleNextClick = function() {
    if (!nextMonth)
      return;
    goToMonth(nextMonth);
  };
  return jsx(Navigation$1, { displayMonth: props.displayMonth, hideNext, hidePrevious, nextMonth, previousMonth, onPreviousClick: handlePreviousClick, onNextClick: handleNextClick });
}
function Caption(props) {
  var _a;
  var _b = useDayPicker(), classNames = _b.classNames, disableNavigation = _b.disableNavigation, styles = _b.styles, captionLayout = _b.captionLayout, components = _b.components;
  var CaptionLabelComponent = (_a = components === null || components === void 0 ? void 0 : components.CaptionLabel) !== null && _a !== void 0 ? _a : CaptionLabel;
  var caption;
  if (disableNavigation) {
    caption = jsx(CaptionLabelComponent, { id: props.id, displayMonth: props.displayMonth });
  } else if (captionLayout === "dropdown") {
    caption = jsx(CaptionDropdowns, { displayMonth: props.displayMonth, id: props.id });
  } else if (captionLayout === "dropdown-buttons") {
    caption = jsxs(Fragment$1, { children: [jsx(CaptionDropdowns, { displayMonth: props.displayMonth, displayIndex: props.displayIndex, id: props.id }), jsx(CaptionNavigation, { displayMonth: props.displayMonth, displayIndex: props.displayIndex, id: props.id })] });
  } else {
    caption = jsxs(Fragment$1, { children: [jsx(CaptionLabelComponent, { id: props.id, displayMonth: props.displayMonth, displayIndex: props.displayIndex }), jsx(CaptionNavigation, { displayMonth: props.displayMonth, id: props.id })] });
  }
  return jsx("div", { className: classNames.caption, style: styles.caption, children: caption });
}
function Footer$3(props) {
  var _a = useDayPicker(), footer = _a.footer, styles = _a.styles, tfoot = _a.classNames.tfoot;
  if (!footer)
    return jsx(Fragment$1, {});
  return jsx("tfoot", { className: tfoot, style: styles.tfoot, children: jsx("tr", { children: jsx("td", { colSpan: 8, children: footer }) }) });
}
function getWeekdays(locale2, weekStartsOn, ISOWeek) {
  var start = ISOWeek ? startOfISOWeek(/* @__PURE__ */ new Date()) : startOfWeek(/* @__PURE__ */ new Date(), { locale: locale2, weekStartsOn });
  var days = [];
  for (var i3 = 0; i3 < 7; i3++) {
    var day = addDays(start, i3);
    days.push(day);
  }
  return days;
}
function HeadRow() {
  var _a = useDayPicker(), classNames = _a.classNames, styles = _a.styles, showWeekNumber = _a.showWeekNumber, locale2 = _a.locale, weekStartsOn = _a.weekStartsOn, ISOWeek = _a.ISOWeek, formatWeekdayName2 = _a.formatters.formatWeekdayName, labelWeekday2 = _a.labels.labelWeekday;
  var weekdays = getWeekdays(locale2, weekStartsOn, ISOWeek);
  return jsxs("tr", { style: styles.head_row, className: classNames.head_row, children: [showWeekNumber && jsx("td", { style: styles.head_cell, className: classNames.head_cell }), weekdays.map(function(weekday, i3) {
    return jsx("th", { scope: "col", className: classNames.head_cell, style: styles.head_cell, "aria-label": labelWeekday2(weekday, { locale: locale2 }), children: formatWeekdayName2(weekday, { locale: locale2 }) }, i3);
  })] });
}
function Head() {
  var _a;
  var _b = useDayPicker(), classNames = _b.classNames, styles = _b.styles, components = _b.components;
  var HeadRowComponent = (_a = components === null || components === void 0 ? void 0 : components.HeadRow) !== null && _a !== void 0 ? _a : HeadRow;
  return jsx("thead", { style: styles.head, className: classNames.head, children: jsx(HeadRowComponent, {}) });
}
function DayContent(props) {
  var _a = useDayPicker(), locale2 = _a.locale, formatDay2 = _a.formatters.formatDay;
  return jsx(Fragment$1, { children: formatDay2(props.date, { locale: locale2 }) });
}
var SelectMultipleContext = createContext(void 0);
function SelectMultipleProvider(props) {
  if (!isDayPickerMultiple(props.initialProps)) {
    var emptyContextValue = {
      selected: void 0,
      modifiers: {
        disabled: []
      }
    };
    return jsx(SelectMultipleContext.Provider, { value: emptyContextValue, children: props.children });
  }
  return jsx(SelectMultipleProviderInternal, { initialProps: props.initialProps, children: props.children });
}
function SelectMultipleProviderInternal(_a) {
  var initialProps = _a.initialProps, children = _a.children;
  var selected = initialProps.selected, min2 = initialProps.min, max2 = initialProps.max;
  var onDayClick = function(day, activeModifiers, e3) {
    var _a2, _b;
    (_a2 = initialProps.onDayClick) === null || _a2 === void 0 ? void 0 : _a2.call(initialProps, day, activeModifiers, e3);
    var isMinSelected = Boolean(activeModifiers.selected && min2 && (selected === null || selected === void 0 ? void 0 : selected.length) === min2);
    if (isMinSelected) {
      return;
    }
    var isMaxSelected = Boolean(!activeModifiers.selected && max2 && (selected === null || selected === void 0 ? void 0 : selected.length) === max2);
    if (isMaxSelected) {
      return;
    }
    var selectedDays = selected ? __spreadArray([], selected) : [];
    if (activeModifiers.selected) {
      var index2 = selectedDays.findIndex(function(selectedDay) {
        return isSameDay(day, selectedDay);
      });
      selectedDays.splice(index2, 1);
    } else {
      selectedDays.push(day);
    }
    (_b = initialProps.onSelect) === null || _b === void 0 ? void 0 : _b.call(initialProps, selectedDays, day, activeModifiers, e3);
  };
  var modifiers2 = {
    disabled: []
  };
  if (selected) {
    modifiers2.disabled.push(function(day) {
      var isMaxSelected = max2 && selected.length > max2 - 1;
      var isSelected = selected.some(function(selectedDay) {
        return isSameDay(selectedDay, day);
      });
      return Boolean(isMaxSelected && !isSelected);
    });
  }
  var contextValue = {
    selected,
    onDayClick,
    modifiers: modifiers2
  };
  return jsx(SelectMultipleContext.Provider, { value: contextValue, children });
}
function useSelectMultiple() {
  var context = useContext(SelectMultipleContext);
  if (!context) {
    throw new Error("useSelectMultiple must be used within a SelectMultipleProvider");
  }
  return context;
}
function addToRange(day, range3) {
  var _a = range3 || {}, from = _a.from, to = _a.to;
  if (from && to) {
    if (isSameDay(to, day) && isSameDay(from, day)) {
      return void 0;
    }
    if (isSameDay(to, day)) {
      return { from: to, to: void 0 };
    }
    if (isSameDay(from, day)) {
      return void 0;
    }
    if (isAfter(from, day)) {
      return { from: day, to };
    }
    return { from, to: day };
  }
  if (to) {
    if (isAfter(day, to)) {
      return { from: to, to: day };
    }
    return { from: day, to };
  }
  if (from) {
    if (isBefore(day, from)) {
      return { from: day, to: from };
    }
    return { from, to: day };
  }
  return { from: day, to: void 0 };
}
var SelectRangeContext = createContext(void 0);
function SelectRangeProvider(props) {
  if (!isDayPickerRange(props.initialProps)) {
    var emptyContextValue = {
      selected: void 0,
      modifiers: {
        range_start: [],
        range_end: [],
        range_middle: [],
        disabled: []
      }
    };
    return jsx(SelectRangeContext.Provider, { value: emptyContextValue, children: props.children });
  }
  return jsx(SelectRangeProviderInternal, { initialProps: props.initialProps, children: props.children });
}
function SelectRangeProviderInternal(_a) {
  var initialProps = _a.initialProps, children = _a.children;
  var selected = initialProps.selected;
  var _b = selected || {}, selectedFrom = _b.from, selectedTo = _b.to;
  var min2 = initialProps.min;
  var max2 = initialProps.max;
  var onDayClick = function(day, activeModifiers, e3) {
    var _a2, _b2;
    (_a2 = initialProps.onDayClick) === null || _a2 === void 0 ? void 0 : _a2.call(initialProps, day, activeModifiers, e3);
    var newRange = addToRange(day, selected);
    (_b2 = initialProps.onSelect) === null || _b2 === void 0 ? void 0 : _b2.call(initialProps, newRange, day, activeModifiers, e3);
  };
  var modifiers2 = {
    range_start: [],
    range_end: [],
    range_middle: [],
    disabled: []
  };
  if (selectedFrom) {
    modifiers2.range_start = [selectedFrom];
    if (!selectedTo) {
      modifiers2.range_end = [selectedFrom];
    } else {
      modifiers2.range_end = [selectedTo];
      if (!isSameDay(selectedFrom, selectedTo)) {
        modifiers2.range_middle = [
          {
            after: selectedFrom,
            before: selectedTo
          }
        ];
      }
    }
  } else if (selectedTo) {
    modifiers2.range_start = [selectedTo];
    modifiers2.range_end = [selectedTo];
  }
  if (min2) {
    if (selectedFrom && !selectedTo) {
      modifiers2.disabled.push({
        after: subDays(selectedFrom, min2 - 1),
        before: addDays(selectedFrom, min2 - 1)
      });
    }
    if (selectedFrom && selectedTo) {
      modifiers2.disabled.push({
        after: selectedFrom,
        before: addDays(selectedFrom, min2 - 1)
      });
    }
    if (!selectedFrom && selectedTo) {
      modifiers2.disabled.push({
        after: subDays(selectedTo, min2 - 1),
        before: addDays(selectedTo, min2 - 1)
      });
    }
  }
  if (max2) {
    if (selectedFrom && !selectedTo) {
      modifiers2.disabled.push({
        before: addDays(selectedFrom, -max2 + 1)
      });
      modifiers2.disabled.push({
        after: addDays(selectedFrom, max2 - 1)
      });
    }
    if (selectedFrom && selectedTo) {
      var selectedCount = differenceInCalendarDays(selectedTo, selectedFrom) + 1;
      var offset2 = max2 - selectedCount;
      modifiers2.disabled.push({
        before: subDays(selectedFrom, offset2)
      });
      modifiers2.disabled.push({
        after: addDays(selectedTo, offset2)
      });
    }
    if (!selectedFrom && selectedTo) {
      modifiers2.disabled.push({
        before: addDays(selectedTo, -max2 + 1)
      });
      modifiers2.disabled.push({
        after: addDays(selectedTo, max2 - 1)
      });
    }
  }
  return jsx(SelectRangeContext.Provider, { value: { selected, onDayClick, modifiers: modifiers2 }, children });
}
function useSelectRange() {
  var context = useContext(SelectRangeContext);
  if (!context) {
    throw new Error("useSelectRange must be used within a SelectRangeProvider");
  }
  return context;
}
function matcherToArray(matcher) {
  if (Array.isArray(matcher)) {
    return __spreadArray([], matcher);
  } else if (matcher !== void 0) {
    return [matcher];
  } else {
    return [];
  }
}
function getCustomModifiers(dayModifiers) {
  var customModifiers = {};
  Object.entries(dayModifiers).forEach(function(_a) {
    var modifier = _a[0], matcher = _a[1];
    customModifiers[modifier] = matcherToArray(matcher);
  });
  return customModifiers;
}
var InternalModifier;
(function(InternalModifier2) {
  InternalModifier2["Outside"] = "outside";
  InternalModifier2["Disabled"] = "disabled";
  InternalModifier2["Selected"] = "selected";
  InternalModifier2["Hidden"] = "hidden";
  InternalModifier2["Today"] = "today";
  InternalModifier2["RangeStart"] = "range_start";
  InternalModifier2["RangeEnd"] = "range_end";
  InternalModifier2["RangeMiddle"] = "range_middle";
})(InternalModifier || (InternalModifier = {}));
var Selected = InternalModifier.Selected, Disabled = InternalModifier.Disabled, Hidden = InternalModifier.Hidden, Today = InternalModifier.Today, RangeEnd = InternalModifier.RangeEnd, RangeMiddle = InternalModifier.RangeMiddle, RangeStart = InternalModifier.RangeStart, Outside = InternalModifier.Outside;
function getInternalModifiers(dayPicker, selectMultiple, selectRange) {
  var _a;
  var internalModifiers = (_a = {}, _a[Selected] = matcherToArray(dayPicker.selected), _a[Disabled] = matcherToArray(dayPicker.disabled), _a[Hidden] = matcherToArray(dayPicker.hidden), _a[Today] = [dayPicker.today], _a[RangeEnd] = [], _a[RangeMiddle] = [], _a[RangeStart] = [], _a[Outside] = [], _a);
  if (dayPicker.fromDate) {
    internalModifiers[Disabled].push({ before: dayPicker.fromDate });
  }
  if (dayPicker.toDate) {
    internalModifiers[Disabled].push({ after: dayPicker.toDate });
  }
  if (isDayPickerMultiple(dayPicker)) {
    internalModifiers[Disabled] = internalModifiers[Disabled].concat(selectMultiple.modifiers[Disabled]);
  } else if (isDayPickerRange(dayPicker)) {
    internalModifiers[Disabled] = internalModifiers[Disabled].concat(selectRange.modifiers[Disabled]);
    internalModifiers[RangeStart] = selectRange.modifiers[RangeStart];
    internalModifiers[RangeMiddle] = selectRange.modifiers[RangeMiddle];
    internalModifiers[RangeEnd] = selectRange.modifiers[RangeEnd];
  }
  return internalModifiers;
}
var ModifiersContext = createContext(void 0);
function ModifiersProvider(props) {
  var dayPicker = useDayPicker();
  var selectMultiple = useSelectMultiple();
  var selectRange = useSelectRange();
  var internalModifiers = getInternalModifiers(dayPicker, selectMultiple, selectRange);
  var customModifiers = getCustomModifiers(dayPicker.modifiers);
  var modifiers2 = __assign(__assign({}, internalModifiers), customModifiers);
  return jsx(ModifiersContext.Provider, { value: modifiers2, children: props.children });
}
function useModifiers() {
  var context = useContext(ModifiersContext);
  if (!context) {
    throw new Error("useModifiers must be used within a ModifiersProvider");
  }
  return context;
}
function isDateInterval(matcher) {
  return Boolean(matcher && typeof matcher === "object" && "before" in matcher && "after" in matcher);
}
function isDateRange(value) {
  return Boolean(value && typeof value === "object" && "from" in value);
}
function isDateAfterType(value) {
  return Boolean(value && typeof value === "object" && "after" in value);
}
function isDateBeforeType(value) {
  return Boolean(value && typeof value === "object" && "before" in value);
}
function isDayOfWeekType(value) {
  return Boolean(value && typeof value === "object" && "dayOfWeek" in value);
}
function isDateInRange(date2, range3) {
  var _a;
  var from = range3.from, to = range3.to;
  if (from && to) {
    var isRangeInverted = differenceInCalendarDays(to, from) < 0;
    if (isRangeInverted) {
      _a = [to, from], from = _a[0], to = _a[1];
    }
    var isInRange = differenceInCalendarDays(date2, from) >= 0 && differenceInCalendarDays(to, date2) >= 0;
    return isInRange;
  }
  if (to) {
    return isSameDay(to, date2);
  }
  if (from) {
    return isSameDay(from, date2);
  }
  return false;
}
function isDateType(value) {
  return isDate(value);
}
function isArrayOfDates(value) {
  return Array.isArray(value) && value.every(isDate);
}
function isMatch(day, matchers) {
  return matchers.some(function(matcher) {
    if (typeof matcher === "boolean") {
      return matcher;
    }
    if (isDateType(matcher)) {
      return isSameDay(day, matcher);
    }
    if (isArrayOfDates(matcher)) {
      return matcher.includes(day);
    }
    if (isDateRange(matcher)) {
      return isDateInRange(day, matcher);
    }
    if (isDayOfWeekType(matcher)) {
      return matcher.dayOfWeek.includes(day.getDay());
    }
    if (isDateInterval(matcher)) {
      var diffBefore = differenceInCalendarDays(matcher.before, day);
      var diffAfter = differenceInCalendarDays(matcher.after, day);
      var isDayBefore = diffBefore > 0;
      var isDayAfter = diffAfter < 0;
      var isClosedInterval = isAfter(matcher.before, matcher.after);
      if (isClosedInterval) {
        return isDayAfter && isDayBefore;
      } else {
        return isDayBefore || isDayAfter;
      }
    }
    if (isDateAfterType(matcher)) {
      return differenceInCalendarDays(day, matcher.after) > 0;
    }
    if (isDateBeforeType(matcher)) {
      return differenceInCalendarDays(matcher.before, day) > 0;
    }
    if (typeof matcher === "function") {
      return matcher(day);
    }
    return false;
  });
}
function getActiveModifiers(day, modifiers2, displayMonth) {
  var matchedModifiers = Object.keys(modifiers2).reduce(function(result, key) {
    var modifier = modifiers2[key];
    if (isMatch(day, modifier)) {
      result.push(key);
    }
    return result;
  }, []);
  var activeModifiers = {};
  matchedModifiers.forEach(function(modifier) {
    return activeModifiers[modifier] = true;
  });
  if (displayMonth && !isSameMonth(day, displayMonth)) {
    activeModifiers.outside = true;
  }
  return activeModifiers;
}
function getInitialFocusTarget(displayMonths, modifiers2) {
  var firstDayInMonth = startOfMonth(displayMonths[0]);
  var lastDayInMonth = endOfMonth(displayMonths[displayMonths.length - 1]);
  var firstFocusableDay;
  var today;
  var date2 = firstDayInMonth;
  while (date2 <= lastDayInMonth) {
    var activeModifiers = getActiveModifiers(date2, modifiers2);
    var isFocusable = !activeModifiers.disabled && !activeModifiers.hidden;
    if (!isFocusable) {
      date2 = addDays(date2, 1);
      continue;
    }
    if (activeModifiers.selected) {
      return date2;
    }
    if (activeModifiers.today && !today) {
      today = date2;
    }
    if (!firstFocusableDay) {
      firstFocusableDay = date2;
    }
    date2 = addDays(date2, 1);
  }
  if (today) {
    return today;
  } else {
    return firstFocusableDay;
  }
}
var MAX_RETRY = 365;
function getNextFocus(focusedDay, options) {
  var moveBy = options.moveBy, direction = options.direction, context = options.context, modifiers2 = options.modifiers, _a = options.retry, retry = _a === void 0 ? { count: 0, lastFocused: focusedDay } : _a;
  var weekStartsOn = context.weekStartsOn, fromDate = context.fromDate, toDate2 = context.toDate, locale2 = context.locale;
  var moveFns = {
    day: addDays,
    week: addWeeks,
    month: addMonths,
    year: addYears,
    startOfWeek: function(date2) {
      return context.ISOWeek ? startOfISOWeek(date2) : startOfWeek(date2, { locale: locale2, weekStartsOn });
    },
    endOfWeek: function(date2) {
      return context.ISOWeek ? endOfISOWeek(date2) : endOfWeek(date2, { locale: locale2, weekStartsOn });
    }
  };
  var newFocusedDay = moveFns[moveBy](focusedDay, direction === "after" ? 1 : -1);
  if (direction === "before" && fromDate) {
    newFocusedDay = max$3([fromDate, newFocusedDay]);
  } else if (direction === "after" && toDate2) {
    newFocusedDay = min$3([toDate2, newFocusedDay]);
  }
  var isFocusable = true;
  if (modifiers2) {
    var activeModifiers = getActiveModifiers(newFocusedDay, modifiers2);
    isFocusable = !activeModifiers.disabled && !activeModifiers.hidden;
  }
  if (isFocusable) {
    return newFocusedDay;
  } else {
    if (retry.count > MAX_RETRY) {
      return retry.lastFocused;
    }
    return getNextFocus(newFocusedDay, {
      moveBy,
      direction,
      context,
      modifiers: modifiers2,
      retry: __assign(__assign({}, retry), { count: retry.count + 1 })
    });
  }
}
var FocusContext = createContext(void 0);
function FocusProvider(props) {
  var navigation = useNavigation();
  var modifiers2 = useModifiers();
  var _a = useState(), focusedDay = _a[0], setFocusedDay = _a[1];
  var _b = useState(), lastFocused = _b[0], setLastFocused = _b[1];
  var initialFocusTarget = getInitialFocusTarget(navigation.displayMonths, modifiers2);
  var focusTarget = (focusedDay !== null && focusedDay !== void 0 ? focusedDay : lastFocused && navigation.isDateDisplayed(lastFocused)) ? lastFocused : initialFocusTarget;
  var blur = function() {
    setLastFocused(focusedDay);
    setFocusedDay(void 0);
  };
  var focus = function(date2) {
    setFocusedDay(date2);
  };
  var context = useDayPicker();
  var moveFocus = function(moveBy, direction) {
    if (!focusedDay)
      return;
    var nextFocused = getNextFocus(focusedDay, {
      moveBy,
      direction,
      context,
      modifiers: modifiers2
    });
    if (isSameDay(focusedDay, nextFocused))
      return void 0;
    navigation.goToDate(nextFocused, focusedDay);
    focus(nextFocused);
  };
  var value = {
    focusedDay,
    focusTarget,
    blur,
    focus,
    focusDayAfter: function() {
      return moveFocus("day", "after");
    },
    focusDayBefore: function() {
      return moveFocus("day", "before");
    },
    focusWeekAfter: function() {
      return moveFocus("week", "after");
    },
    focusWeekBefore: function() {
      return moveFocus("week", "before");
    },
    focusMonthBefore: function() {
      return moveFocus("month", "before");
    },
    focusMonthAfter: function() {
      return moveFocus("month", "after");
    },
    focusYearBefore: function() {
      return moveFocus("year", "before");
    },
    focusYearAfter: function() {
      return moveFocus("year", "after");
    },
    focusStartOfWeek: function() {
      return moveFocus("startOfWeek", "before");
    },
    focusEndOfWeek: function() {
      return moveFocus("endOfWeek", "after");
    }
  };
  return jsx(FocusContext.Provider, { value, children: props.children });
}
function useFocusContext() {
  var context = useContext(FocusContext);
  if (!context) {
    throw new Error("useFocusContext must be used within a FocusProvider");
  }
  return context;
}
function useActiveModifiers(day, displayMonth) {
  var modifiers2 = useModifiers();
  var activeModifiers = getActiveModifiers(day, modifiers2, displayMonth);
  return activeModifiers;
}
var SelectSingleContext = createContext(void 0);
function SelectSingleProvider(props) {
  if (!isDayPickerSingle(props.initialProps)) {
    var emptyContextValue = {
      selected: void 0
    };
    return jsx(SelectSingleContext.Provider, { value: emptyContextValue, children: props.children });
  }
  return jsx(SelectSingleProviderInternal, { initialProps: props.initialProps, children: props.children });
}
function SelectSingleProviderInternal(_a) {
  var initialProps = _a.initialProps, children = _a.children;
  var onDayClick = function(day, activeModifiers, e3) {
    var _a2, _b, _c;
    (_a2 = initialProps.onDayClick) === null || _a2 === void 0 ? void 0 : _a2.call(initialProps, day, activeModifiers, e3);
    if (activeModifiers.selected && !initialProps.required) {
      (_b = initialProps.onSelect) === null || _b === void 0 ? void 0 : _b.call(initialProps, void 0, day, activeModifiers, e3);
      return;
    }
    (_c = initialProps.onSelect) === null || _c === void 0 ? void 0 : _c.call(initialProps, day, day, activeModifiers, e3);
  };
  var contextValue = {
    selected: initialProps.selected,
    onDayClick
  };
  return jsx(SelectSingleContext.Provider, { value: contextValue, children });
}
function useSelectSingle() {
  var context = useContext(SelectSingleContext);
  if (!context) {
    throw new Error("useSelectSingle must be used within a SelectSingleProvider");
  }
  return context;
}
function useDayEventHandlers(date2, activeModifiers) {
  var dayPicker = useDayPicker();
  var single = useSelectSingle();
  var multiple = useSelectMultiple();
  var range3 = useSelectRange();
  var _a = useFocusContext(), focusDayAfter = _a.focusDayAfter, focusDayBefore = _a.focusDayBefore, focusWeekAfter = _a.focusWeekAfter, focusWeekBefore = _a.focusWeekBefore, blur = _a.blur, focus = _a.focus, focusMonthBefore = _a.focusMonthBefore, focusMonthAfter = _a.focusMonthAfter, focusYearBefore = _a.focusYearBefore, focusYearAfter = _a.focusYearAfter, focusStartOfWeek = _a.focusStartOfWeek, focusEndOfWeek = _a.focusEndOfWeek;
  var onClick = function(e3) {
    var _a2, _b, _c, _d;
    if (isDayPickerSingle(dayPicker)) {
      (_a2 = single.onDayClick) === null || _a2 === void 0 ? void 0 : _a2.call(single, date2, activeModifiers, e3);
    } else if (isDayPickerMultiple(dayPicker)) {
      (_b = multiple.onDayClick) === null || _b === void 0 ? void 0 : _b.call(multiple, date2, activeModifiers, e3);
    } else if (isDayPickerRange(dayPicker)) {
      (_c = range3.onDayClick) === null || _c === void 0 ? void 0 : _c.call(range3, date2, activeModifiers, e3);
    } else {
      (_d = dayPicker.onDayClick) === null || _d === void 0 ? void 0 : _d.call(dayPicker, date2, activeModifiers, e3);
    }
  };
  var onFocus = function(e3) {
    var _a2;
    focus(date2);
    (_a2 = dayPicker.onDayFocus) === null || _a2 === void 0 ? void 0 : _a2.call(dayPicker, date2, activeModifiers, e3);
  };
  var onBlur = function(e3) {
    var _a2;
    blur();
    (_a2 = dayPicker.onDayBlur) === null || _a2 === void 0 ? void 0 : _a2.call(dayPicker, date2, activeModifiers, e3);
  };
  var onMouseEnter = function(e3) {
    var _a2;
    (_a2 = dayPicker.onDayMouseEnter) === null || _a2 === void 0 ? void 0 : _a2.call(dayPicker, date2, activeModifiers, e3);
  };
  var onMouseLeave = function(e3) {
    var _a2;
    (_a2 = dayPicker.onDayMouseLeave) === null || _a2 === void 0 ? void 0 : _a2.call(dayPicker, date2, activeModifiers, e3);
  };
  var onPointerEnter = function(e3) {
    var _a2;
    (_a2 = dayPicker.onDayPointerEnter) === null || _a2 === void 0 ? void 0 : _a2.call(dayPicker, date2, activeModifiers, e3);
  };
  var onPointerLeave = function(e3) {
    var _a2;
    (_a2 = dayPicker.onDayPointerLeave) === null || _a2 === void 0 ? void 0 : _a2.call(dayPicker, date2, activeModifiers, e3);
  };
  var onTouchCancel = function(e3) {
    var _a2;
    (_a2 = dayPicker.onDayTouchCancel) === null || _a2 === void 0 ? void 0 : _a2.call(dayPicker, date2, activeModifiers, e3);
  };
  var onTouchEnd = function(e3) {
    var _a2;
    (_a2 = dayPicker.onDayTouchEnd) === null || _a2 === void 0 ? void 0 : _a2.call(dayPicker, date2, activeModifiers, e3);
  };
  var onTouchMove = function(e3) {
    var _a2;
    (_a2 = dayPicker.onDayTouchMove) === null || _a2 === void 0 ? void 0 : _a2.call(dayPicker, date2, activeModifiers, e3);
  };
  var onTouchStart = function(e3) {
    var _a2;
    (_a2 = dayPicker.onDayTouchStart) === null || _a2 === void 0 ? void 0 : _a2.call(dayPicker, date2, activeModifiers, e3);
  };
  var onKeyUp = function(e3) {
    var _a2;
    (_a2 = dayPicker.onDayKeyUp) === null || _a2 === void 0 ? void 0 : _a2.call(dayPicker, date2, activeModifiers, e3);
  };
  var onKeyDown = function(e3) {
    var _a2;
    switch (e3.key) {
      case "ArrowLeft":
        e3.preventDefault();
        e3.stopPropagation();
        dayPicker.dir === "rtl" ? focusDayAfter() : focusDayBefore();
        break;
      case "ArrowRight":
        e3.preventDefault();
        e3.stopPropagation();
        dayPicker.dir === "rtl" ? focusDayBefore() : focusDayAfter();
        break;
      case "ArrowDown":
        e3.preventDefault();
        e3.stopPropagation();
        focusWeekAfter();
        break;
      case "ArrowUp":
        e3.preventDefault();
        e3.stopPropagation();
        focusWeekBefore();
        break;
      case "PageUp":
        e3.preventDefault();
        e3.stopPropagation();
        e3.shiftKey ? focusYearBefore() : focusMonthBefore();
        break;
      case "PageDown":
        e3.preventDefault();
        e3.stopPropagation();
        e3.shiftKey ? focusYearAfter() : focusMonthAfter();
        break;
      case "Home":
        e3.preventDefault();
        e3.stopPropagation();
        focusStartOfWeek();
        break;
      case "End":
        e3.preventDefault();
        e3.stopPropagation();
        focusEndOfWeek();
        break;
    }
    (_a2 = dayPicker.onDayKeyDown) === null || _a2 === void 0 ? void 0 : _a2.call(dayPicker, date2, activeModifiers, e3);
  };
  var eventHandlers = {
    onClick,
    onFocus,
    onBlur,
    onKeyDown,
    onKeyUp,
    onMouseEnter,
    onMouseLeave,
    onPointerEnter,
    onPointerLeave,
    onTouchCancel,
    onTouchEnd,
    onTouchMove,
    onTouchStart
  };
  return eventHandlers;
}
function useSelectedDays() {
  var dayPicker = useDayPicker();
  var single = useSelectSingle();
  var multiple = useSelectMultiple();
  var range3 = useSelectRange();
  var selectedDays = isDayPickerSingle(dayPicker) ? single.selected : isDayPickerMultiple(dayPicker) ? multiple.selected : isDayPickerRange(dayPicker) ? range3.selected : void 0;
  return selectedDays;
}
function isInternalModifier(modifier) {
  return Object.values(InternalModifier).includes(modifier);
}
function getDayClassNames(dayPicker, activeModifiers) {
  var classNames = [dayPicker.classNames.day];
  Object.keys(activeModifiers).forEach(function(modifier) {
    var customClassName = dayPicker.modifiersClassNames[modifier];
    if (customClassName) {
      classNames.push(customClassName);
    } else if (isInternalModifier(modifier)) {
      var internalClassName = dayPicker.classNames["day_".concat(modifier)];
      if (internalClassName) {
        classNames.push(internalClassName);
      }
    }
  });
  return classNames;
}
function getDayStyle(dayPicker, activeModifiers) {
  var style = __assign({}, dayPicker.styles.day);
  Object.keys(activeModifiers).forEach(function(modifier) {
    var _a;
    style = __assign(__assign({}, style), (_a = dayPicker.modifiersStyles) === null || _a === void 0 ? void 0 : _a[modifier]);
  });
  return style;
}
function useDayRender(day, displayMonth, buttonRef) {
  var _a;
  var _b, _c;
  var dayPicker = useDayPicker();
  var focusContext = useFocusContext();
  var activeModifiers = useActiveModifiers(day, displayMonth);
  var eventHandlers = useDayEventHandlers(day, activeModifiers);
  var selectedDays = useSelectedDays();
  var isButton = Boolean(dayPicker.onDayClick || dayPicker.mode !== "default");
  useEffect(function() {
    var _a2;
    if (activeModifiers.outside)
      return;
    if (!focusContext.focusedDay)
      return;
    if (!isButton)
      return;
    if (isSameDay(focusContext.focusedDay, day)) {
      (_a2 = buttonRef.current) === null || _a2 === void 0 ? void 0 : _a2.focus();
    }
  }, [
    focusContext.focusedDay,
    day,
    buttonRef,
    isButton,
    activeModifiers.outside
  ]);
  var className = getDayClassNames(dayPicker, activeModifiers).join(" ");
  var style = getDayStyle(dayPicker, activeModifiers);
  var isHidden = Boolean(activeModifiers.outside && !dayPicker.showOutsideDays || activeModifiers.hidden);
  var DayContentComponent = (_c = (_b = dayPicker.components) === null || _b === void 0 ? void 0 : _b.DayContent) !== null && _c !== void 0 ? _c : DayContent;
  var children = jsx(DayContentComponent, { date: day, displayMonth, activeModifiers });
  var divProps = {
    style,
    className,
    children,
    role: "gridcell"
  };
  var isFocusTarget = focusContext.focusTarget && isSameDay(focusContext.focusTarget, day) && !activeModifiers.outside;
  var isFocused = focusContext.focusedDay && isSameDay(focusContext.focusedDay, day);
  var buttonProps = __assign(__assign(__assign({}, divProps), (_a = { disabled: activeModifiers.disabled, role: "gridcell" }, _a["aria-selected"] = activeModifiers.selected, _a.tabIndex = isFocused || isFocusTarget ? 0 : -1, _a)), eventHandlers);
  var dayRender = {
    isButton,
    isHidden,
    activeModifiers,
    selectedDays,
    buttonProps,
    divProps
  };
  return dayRender;
}
function Day(props) {
  var buttonRef = useRef(null);
  var dayRender = useDayRender(props.date, props.displayMonth, buttonRef);
  if (dayRender.isHidden) {
    return jsx("div", { role: "gridcell" });
  }
  if (!dayRender.isButton) {
    return jsx("div", __assign({}, dayRender.divProps));
  }
  return jsx(Button$3, __assign({ name: "day", ref: buttonRef }, dayRender.buttonProps));
}
function WeekNumber(props) {
  var weekNumber = props.number, dates = props.dates;
  var _a = useDayPicker(), onWeekNumberClick = _a.onWeekNumberClick, styles = _a.styles, classNames = _a.classNames, locale2 = _a.locale, labelWeekNumber2 = _a.labels.labelWeekNumber, formatWeekNumber2 = _a.formatters.formatWeekNumber;
  var content = formatWeekNumber2(Number(weekNumber), { locale: locale2 });
  if (!onWeekNumberClick) {
    return jsx("span", { className: classNames.weeknumber, style: styles.weeknumber, children: content });
  }
  var label = labelWeekNumber2(Number(weekNumber), { locale: locale2 });
  var handleClick = function(e3) {
    onWeekNumberClick(weekNumber, dates, e3);
  };
  return jsx(Button$3, { name: "week-number", "aria-label": label, className: classNames.weeknumber, style: styles.weeknumber, onClick: handleClick, children: content });
}
function Row$3(props) {
  var _a, _b;
  var _c = useDayPicker(), styles = _c.styles, classNames = _c.classNames, showWeekNumber = _c.showWeekNumber, components = _c.components;
  var DayComponent = (_a = components === null || components === void 0 ? void 0 : components.Day) !== null && _a !== void 0 ? _a : Day;
  var WeeknumberComponent = (_b = components === null || components === void 0 ? void 0 : components.WeekNumber) !== null && _b !== void 0 ? _b : WeekNumber;
  var weekNumberCell;
  if (showWeekNumber) {
    weekNumberCell = jsx("td", { className: classNames.cell, style: styles.cell, children: jsx(WeeknumberComponent, { number: props.weekNumber, dates: props.dates }) });
  }
  return jsxs("tr", { className: classNames.row, style: styles.row, children: [weekNumberCell, props.dates.map(function(date2) {
    return jsx("td", { className: classNames.cell, style: styles.cell, role: "presentation", children: jsx(DayComponent, { displayMonth: props.displayMonth, date: date2 }) }, getUnixTime(date2));
  })] });
}
function daysToMonthWeeks(fromDate, toDate2, options) {
  var toWeek = (options === null || options === void 0 ? void 0 : options.ISOWeek) ? endOfISOWeek(toDate2) : endOfWeek(toDate2, options);
  var fromWeek = (options === null || options === void 0 ? void 0 : options.ISOWeek) ? startOfISOWeek(fromDate) : startOfWeek(fromDate, options);
  var nOfDays = differenceInCalendarDays(toWeek, fromWeek);
  var days = [];
  for (var i3 = 0; i3 <= nOfDays; i3++) {
    days.push(addDays(fromWeek, i3));
  }
  var weeksInMonth = days.reduce(function(result, date2) {
    var weekNumber = (options === null || options === void 0 ? void 0 : options.ISOWeek) ? getISOWeek(date2) : getWeek(date2, options);
    var existingWeek = result.find(function(value) {
      return value.weekNumber === weekNumber;
    });
    if (existingWeek) {
      existingWeek.dates.push(date2);
      return result;
    }
    result.push({
      weekNumber,
      dates: [date2]
    });
    return result;
  }, []);
  return weeksInMonth;
}
function getMonthWeeks(month, options) {
  var weeksInMonth = daysToMonthWeeks(startOfMonth(month), endOfMonth(month), options);
  if (options === null || options === void 0 ? void 0 : options.useFixedWeeks) {
    var nrOfMonthWeeks = getWeeksInMonth(month, options);
    if (nrOfMonthWeeks < 6) {
      var lastWeek = weeksInMonth[weeksInMonth.length - 1];
      var lastDate = lastWeek.dates[lastWeek.dates.length - 1];
      var toDate2 = addWeeks(lastDate, 6 - nrOfMonthWeeks);
      var extraWeeks = daysToMonthWeeks(addWeeks(lastDate, 1), toDate2, options);
      weeksInMonth.push.apply(weeksInMonth, extraWeeks);
    }
  }
  return weeksInMonth;
}
function Table$2(props) {
  var _a, _b, _c;
  var _d = useDayPicker(), locale2 = _d.locale, classNames = _d.classNames, styles = _d.styles, hideHead = _d.hideHead, fixedWeeks = _d.fixedWeeks, components = _d.components, weekStartsOn = _d.weekStartsOn, firstWeekContainsDate = _d.firstWeekContainsDate, ISOWeek = _d.ISOWeek;
  var weeks = getMonthWeeks(props.displayMonth, {
    useFixedWeeks: Boolean(fixedWeeks),
    ISOWeek,
    locale: locale2,
    weekStartsOn,
    firstWeekContainsDate
  });
  var HeadComponent = (_a = components === null || components === void 0 ? void 0 : components.Head) !== null && _a !== void 0 ? _a : Head;
  var RowComponent = (_b = components === null || components === void 0 ? void 0 : components.Row) !== null && _b !== void 0 ? _b : Row$3;
  var FooterComponent = (_c = components === null || components === void 0 ? void 0 : components.Footer) !== null && _c !== void 0 ? _c : Footer$3;
  return jsxs("table", { id: props.id, className: classNames.table, style: styles.table, role: "grid", "aria-labelledby": props["aria-labelledby"], children: [!hideHead && jsx(HeadComponent, {}), jsx("tbody", { className: classNames.tbody, style: styles.tbody, children: weeks.map(function(week) {
    return jsx(RowComponent, { displayMonth: props.displayMonth, dates: week.dates, weekNumber: week.weekNumber }, week.weekNumber);
  }) }), jsx(FooterComponent, { displayMonth: props.displayMonth })] });
}
function canUseDOM$3() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}
var useIsomorphicLayoutEffect$3 = canUseDOM$3() ? useLayoutEffect : useEffect;
var serverHandoffComplete = false;
var id$1 = 0;
function genId() {
  return "react-day-picker-".concat(++id$1);
}
function useId$2(providedId) {
  var _a;
  var initialId = providedId !== null && providedId !== void 0 ? providedId : serverHandoffComplete ? genId() : null;
  var _b = useState(initialId), id2 = _b[0], setId = _b[1];
  useIsomorphicLayoutEffect$3(function() {
    if (id2 === null) {
      setId(genId());
    }
  }, []);
  useEffect(function() {
    if (serverHandoffComplete === false) {
      serverHandoffComplete = true;
    }
  }, []);
  return (_a = providedId !== null && providedId !== void 0 ? providedId : id2) !== null && _a !== void 0 ? _a : void 0;
}
function Month(props) {
  var _a;
  var _b;
  var dayPicker = useDayPicker();
  var dir = dayPicker.dir, classNames = dayPicker.classNames, styles = dayPicker.styles, components = dayPicker.components;
  var displayMonths = useNavigation().displayMonths;
  var captionId = useId$2(dayPicker.id ? "".concat(dayPicker.id, "-").concat(props.displayIndex) : void 0);
  var tableId = dayPicker.id ? "".concat(dayPicker.id, "-grid-").concat(props.displayIndex) : void 0;
  var className = [classNames.month];
  var style = styles.month;
  var isStart = props.displayIndex === 0;
  var isEnd = props.displayIndex === displayMonths.length - 1;
  var isCenter = !isStart && !isEnd;
  if (dir === "rtl") {
    _a = [isStart, isEnd], isEnd = _a[0], isStart = _a[1];
  }
  if (isStart) {
    className.push(classNames.caption_start);
    style = __assign(__assign({}, style), styles.caption_start);
  }
  if (isEnd) {
    className.push(classNames.caption_end);
    style = __assign(__assign({}, style), styles.caption_end);
  }
  if (isCenter) {
    className.push(classNames.caption_between);
    style = __assign(__assign({}, style), styles.caption_between);
  }
  var CaptionComponent = (_b = components === null || components === void 0 ? void 0 : components.Caption) !== null && _b !== void 0 ? _b : Caption;
  return jsxs("div", { className: className.join(" "), style, children: [jsx(CaptionComponent, { id: captionId, displayMonth: props.displayMonth, displayIndex: props.displayIndex }), jsx(Table$2, { id: tableId, "aria-labelledby": captionId, displayMonth: props.displayMonth })] }, props.displayIndex);
}
function Months(props) {
  var _a = useDayPicker(), classNames = _a.classNames, styles = _a.styles;
  return jsx("div", { className: classNames.months, style: styles.months, children: props.children });
}
function Root$2(_a) {
  var _b, _c;
  var initialProps = _a.initialProps;
  var dayPicker = useDayPicker();
  var focusContext = useFocusContext();
  var navigation = useNavigation();
  var _d = useState(false), hasInitialFocus = _d[0], setHasInitialFocus = _d[1];
  useEffect(function() {
    if (!dayPicker.initialFocus)
      return;
    if (!focusContext.focusTarget)
      return;
    if (hasInitialFocus)
      return;
    focusContext.focus(focusContext.focusTarget);
    setHasInitialFocus(true);
  }, [
    dayPicker.initialFocus,
    hasInitialFocus,
    focusContext.focus,
    focusContext.focusTarget,
    focusContext
  ]);
  var classNames = [dayPicker.classNames.root, dayPicker.className];
  if (dayPicker.numberOfMonths > 1) {
    classNames.push(dayPicker.classNames.multiple_months);
  }
  if (dayPicker.showWeekNumber) {
    classNames.push(dayPicker.classNames.with_weeknumber);
  }
  var style = __assign(__assign({}, dayPicker.styles.root), dayPicker.style);
  var dataAttributes = Object.keys(initialProps).filter(function(key) {
    return key.startsWith("data-");
  }).reduce(function(attrs, key) {
    var _a2;
    return __assign(__assign({}, attrs), (_a2 = {}, _a2[key] = initialProps[key], _a2));
  }, {});
  var MonthsComponent = (_c = (_b = initialProps.components) === null || _b === void 0 ? void 0 : _b.Months) !== null && _c !== void 0 ? _c : Months;
  return jsx("div", __assign({ className: classNames.join(" "), style, dir: dayPicker.dir, id: dayPicker.id, nonce: initialProps.nonce, title: initialProps.title, lang: initialProps.lang }, dataAttributes, { children: jsx(MonthsComponent, { children: navigation.displayMonths.map(function(month, i3) {
    return jsx(Month, { displayIndex: i3, displayMonth: month }, i3);
  }) }) }));
}
function RootProvider(props) {
  var children = props.children, initialProps = __rest(props, ["children"]);
  return jsx(DayPickerProvider, { initialProps, children: jsx(NavigationProvider, { children: jsx(SelectSingleProvider, { initialProps, children: jsx(SelectMultipleProvider, { initialProps, children: jsx(SelectRangeProvider, { initialProps, children: jsx(ModifiersProvider, { children: jsx(FocusProvider, { children }) }) }) }) }) }) });
}
function DayPicker(props) {
  return jsx(RootProvider, __assign({}, props, { children: jsx(Root$2, { initialProps: props }) }));
}
const thisYear = (/* @__PURE__ */ new Date()).getFullYear();
const years = [];
for (let i3 = thisYear - 50; i3 <= thisYear + 10; i3 += 1) {
  years.push(i3);
}
const Navbar = React.memo(({ onMonthChange, value = /* @__PURE__ */ new Date() }) => {
  const {
    texts: {
      calendar: { actions, months }
    }
  } = useLocalization();
  const handleChange = (event) => {
    const { year, month } = event.target.form;
    onMonthChange(new Date(year.value, month.value));
  };
  const onNextClick = () => {
    onMonthChange(new Date(value.getFullYear(), value.getMonth() + 1, value.getDay()));
  };
  const onPreviousClick = () => {
    onMonthChange(new Date(value.getFullYear(), value.getMonth() - 1, value.getDay()));
  };
  return /* @__PURE__ */ React.createElement("div", { className: "mb-3 flex items-center justify-between" }, /* @__PURE__ */ React.createElement("form", { className: "inline-flex space-x-1" }, /* @__PURE__ */ React.createElement("select", { className: "h-8 px-2", name: "month", onChange: handleChange, value: value.getMonth() }, months.map((month, i3) => /* @__PURE__ */ React.createElement("option", { key: month, value: i3 }, month))), /* @__PURE__ */ React.createElement("select", { className: "h-8 px-2", name: "year", onChange: handleChange, value: value.getFullYear() }, years.map((year) => /* @__PURE__ */ React.createElement("option", { key: year, value: year }, String(year))))), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Tooltip$3, { title: actions.previousMonth }, /* @__PURE__ */ React.createElement(
    IconButton,
    {
      appearance: "discrete",
      icon: "chevron-left",
      "aria-label": actions.previousMonth,
      onClick: onPreviousClick,
      rounded: true
    }
  )), /* @__PURE__ */ React.createElement(Tooltip$3, { title: actions.nextMonth }, /* @__PURE__ */ React.createElement(
    IconButton,
    {
      appearance: "discrete",
      icon: "chevron-right",
      "aria-label": actions.nextMonth,
      onClick: onNextClick,
      rounded: true
    }
  ))));
});
const TodayButton = ({ handleChange }) => {
  const { texts } = useLocalization();
  const handleCalendarClickToday = () => {
    const today = /* @__PURE__ */ new Date();
    today.setHours(12);
    today.setMinutes(0);
    today.setSeconds(0);
    handleChange(today);
  };
  return /* @__PURE__ */ React.createElement(
    Button$3,
    {
      className: "cursor-pointer border-none bg-transparent text-xs text-blue-500 hover:text-blue-300",
      onClick: handleCalendarClickToday
    },
    texts.calendar.actions.today
  );
};
const Calendar = (props) => {
  const { onChange: handleChange, value, disabledDays, ...otherProps } = props;
  const [visibleMonth, setVisibleMonth] = React.useState(value ?? /* @__PURE__ */ new Date());
  const { texts } = useLocalization();
  React.useEffect(() => {
    if (visibleMonth !== value) {
      setVisibleMonth(value ?? /* @__PURE__ */ new Date());
    }
  }, [value]);
  const handleDayClick = (date2, modifiers2, event) => {
    if (modifiers2.outside || modifiers2.disabled) {
      return;
    }
    handleChange(date2, event);
  };
  const className = clsx("flex bg-white text-xs p-2", otherProps.className);
  return /* @__PURE__ */ React.createElement("div", { "data-taco": "calendar" }, /* @__PURE__ */ React.createElement(
    DayPicker,
    {
      className,
      captionLayout: "dropdown-buttons",
      weekStartsOn: 1,
      month: visibleMonth,
      numberOfMonths: 1,
      components: {
        Caption: (props2) => /* @__PURE__ */ React.createElement(Navbar, { ...props2, onMonthChange: setVisibleMonth, value: visibleMonth }),
        Footer: () => /* @__PURE__ */ React.createElement("tfoot", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", { colSpan: 7, className: "text-center" }, /* @__PURE__ */ React.createElement(TodayButton, { handleChange })))),
        HeadRow: () => /* @__PURE__ */ React.createElement("tr", null, texts.calendar.weekdaysShort.map((weekday, index2) => {
          const label = texts.calendar.weekdays && texts.calendar.weekdays[index2];
          return /* @__PURE__ */ React.createElement("th", { key: weekday, "aria-label": label, className: "rdp-head_cell", title: label }, weekday);
        }))
      },
      onDayClick: handleDayClick,
      selected: value,
      disabled: disabledDays
    }
  ));
};
const isElementTruncated = (targetElement) => {
  if (targetElement !== null) {
    return targetElement.offsetWidth < targetElement.scrollWidth;
  }
  return false;
};
const useTruncated = (element, deps = []) => {
  const [isTruncated, setIsTruncated] = React__default.useState(isElementTruncated(element));
  React__default.useEffect(() => {
    setIsTruncated(isElementTruncated(element));
  }, [element, ...deps]);
  return { isTruncated };
};
const Truncate = ({ children, tooltip }) => {
  const ref = React__default.useRef(null);
  const [mounted, setMounted] = React__default.useState(false);
  const { isTruncated } = useTruncated(ref.current, [mounted]);
  React__default.useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);
  const clonedChildrenWithRef = React__default.cloneElement(React__default.Children.only(children), {
    ref,
    className: clsx(children.props.className, "truncate", { "hover:cursor-pointer": isTruncated })
  });
  if (isTruncated) {
    return /* @__PURE__ */ React__default.createElement(Tooltip$3, { title: tooltip }, clonedChildrenWithRef);
  }
  return clonedChildrenWithRef;
};
const Content$8 = React.forwardRef(function CardContent(externalProps, ref) {
  const { noPadding, ...props } = externalProps;
  const className = clsx(
    "flex-grow overflow-auto",
    {
      "px-4 pb-4": !noPadding
    },
    props.className
  );
  return /* @__PURE__ */ React.createElement("div", { ...props, className, "data-taco": "card-content", ref });
});
const Card = React.forwardRef(function Card2(props, ref) {
  const { title, menu, children, className, ...otherProps } = props;
  const localization = useLocalization();
  const cardClassName = clsx(
    "bg-white flex flex-col rounded-xl border border-solid border-radius-[12px] border-grey-300 hover:border-grey-500",
    className
  );
  return /* @__PURE__ */ React.createElement("div", { ...otherProps, className: cardClassName, "data-taco": "card", ref }, /* @__PURE__ */ React.createElement("div", { className: "flex justify-between px-4 pb-2 pt-4" }, title && /* @__PURE__ */ React.createElement(Truncate, { tooltip: title }, /* @__PURE__ */ React.createElement("h4", { className: "mb-0 flex-grow truncate text-left" }, title)), menu ? /* @__PURE__ */ React.createElement(
    IconButton,
    {
      "aria-label": localization.texts.card.menu,
      icon: "ellipsis-horizontal",
      appearance: "discrete",
      menu,
      className: "-mt-[4px]"
    }
  ) : null), children);
});
Card.Content = Content$8;
function $010c2913dbd2fe3d$export$5cae361ad82dce8b(value) {
  const ref = useRef({
    value,
    previous: value
  });
  return useMemo(() => {
    if (ref.current.value !== value) {
      ref.current.previous = ref.current.value;
      ref.current.value = value;
    }
    return ref.current.previous;
  }, [
    value
  ]);
}
const $e698a72e93240346$var$CHECKBOX_NAME = "Checkbox";
const [$e698a72e93240346$var$createCheckboxContext, $e698a72e93240346$export$b566c4ff5488ea01] = $c512c27ab02ef895$export$50c7b4e9d9f19c1$1($e698a72e93240346$var$CHECKBOX_NAME);
const [$e698a72e93240346$var$CheckboxProvider, $e698a72e93240346$var$useCheckboxContext] = $e698a72e93240346$var$createCheckboxContext($e698a72e93240346$var$CHECKBOX_NAME);
const $e698a72e93240346$export$48513f6b9f8ce62d = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeCheckbox, name, checked: checkedProp, defaultChecked, required, disabled, value = "on", onCheckedChange, ...checkboxProps } = props;
  const [button, setButton] = useState(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05$1(
    forwardedRef,
    (node) => setButton(node)
  );
  const hasConsumerStoppedPropagationRef = useRef(false);
  const isFormControl = button ? Boolean(button.closest("form")) : true;
  const [checked = false, setChecked] = $71cd76cc60e0454e$export$6f32135080cb4c3$1({
    prop: checkedProp,
    defaultProp: defaultChecked,
    onChange: onCheckedChange
  });
  return /* @__PURE__ */ createElement($e698a72e93240346$var$CheckboxProvider, {
    scope: __scopeCheckbox,
    state: checked,
    disabled
  }, /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.button, _extends$z({
    type: "button",
    role: "checkbox",
    "aria-checked": $e698a72e93240346$var$isIndeterminate(checked) ? "mixed" : checked,
    "aria-required": required,
    "data-state": $e698a72e93240346$var$getState(checked),
    "data-disabled": disabled ? "" : void 0,
    disabled,
    value
  }, checkboxProps, {
    ref: composedRefs,
    onKeyDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(props.onKeyDown, (event) => {
      if (event.key === "Enter") event.preventDefault();
    }),
    onClick: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(props.onClick, (event) => {
      setChecked(
        (prevChecked) => $e698a72e93240346$var$isIndeterminate(prevChecked) ? true : !prevChecked
      );
      if (isFormControl) {
        hasConsumerStoppedPropagationRef.current = event.isPropagationStopped();
        if (!hasConsumerStoppedPropagationRef.current) event.stopPropagation();
      }
    })
  })), isFormControl && /* @__PURE__ */ createElement($e698a72e93240346$var$BubbleInput, {
    control: button,
    bubbles: !hasConsumerStoppedPropagationRef.current,
    name,
    value,
    checked,
    required,
    disabled,
    style: {
      transform: "translateX(-100%)"
    }
  }));
});
const $e698a72e93240346$var$INDICATOR_NAME = "CheckboxIndicator";
const $e698a72e93240346$export$59aad738f51d1c05 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeCheckbox, forceMount, ...indicatorProps } = props;
  const context = $e698a72e93240346$var$useCheckboxContext($e698a72e93240346$var$INDICATOR_NAME, __scopeCheckbox);
  return /* @__PURE__ */ createElement($921a889cee6df7e8$export$99c2b779aa4e8b8b$1, {
    present: forceMount || $e698a72e93240346$var$isIndeterminate(context.state) || context.state === true
  }, /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.span, _extends$z({
    "data-state": $e698a72e93240346$var$getState(context.state),
    "data-disabled": context.disabled ? "" : void 0
  }, indicatorProps, {
    ref: forwardedRef,
    style: {
      pointerEvents: "none",
      ...props.style
    }
  })));
});
const $e698a72e93240346$var$BubbleInput = (props) => {
  const { control, checked, bubbles = true, ...inputProps } = props;
  const ref = useRef(null);
  const prevChecked = $010c2913dbd2fe3d$export$5cae361ad82dce8b(checked);
  const controlSize = $db6c3485150b8e66$export$1ab7ae714698c4b8(control);
  useEffect(() => {
    const input = ref.current;
    const inputProto = window.HTMLInputElement.prototype;
    const descriptor = Object.getOwnPropertyDescriptor(inputProto, "checked");
    const setChecked = descriptor.set;
    if (prevChecked !== checked && setChecked) {
      const event = new Event("click", {
        bubbles
      });
      input.indeterminate = $e698a72e93240346$var$isIndeterminate(checked);
      setChecked.call(input, $e698a72e93240346$var$isIndeterminate(checked) ? false : checked);
      input.dispatchEvent(event);
    }
  }, [
    prevChecked,
    checked,
    bubbles
  ]);
  return /* @__PURE__ */ createElement("input", _extends$z({
    type: "checkbox",
    "aria-hidden": true,
    defaultChecked: $e698a72e93240346$var$isIndeterminate(checked) ? false : checked
  }, inputProps, {
    tabIndex: -1,
    ref,
    style: {
      ...props.style,
      ...controlSize,
      position: "absolute",
      pointerEvents: "none",
      opacity: 0,
      margin: 0
    }
  }));
};
function $e698a72e93240346$var$isIndeterminate(checked) {
  return checked === "indeterminate";
}
function $e698a72e93240346$var$getState(checked) {
  return $e698a72e93240346$var$isIndeterminate(checked) ? "indeterminate" : checked ? "checked" : "unchecked";
}
const $e698a72e93240346$export$be92b6f5f03c0fe9 = $e698a72e93240346$export$48513f6b9f8ce62d;
const $e698a72e93240346$export$adb584737d712b70 = $e698a72e93240346$export$59aad738f51d1c05;
const urlAlphabet = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
let nanoid = (size2 = 21) => {
  let id2 = "";
  let bytes = crypto.getRandomValues(new Uint8Array(size2 |= 0));
  while (size2--) {
    id2 += urlAlphabet[bytes[size2] & 63];
  }
  return id2;
};
const useId$1 = (nativeId) => {
  return React__default.useMemo(() => nativeId ?? nanoid(), []);
};
const Spinner = React__default.forwardRef(function Spinner2(props, ref) {
  const { delay = 350, label, ...otherProps } = props;
  const [visible, setVisibility] = React__default.useState(!delay);
  React__default.useEffect(() => {
    let timeout;
    if (delay) {
      timeout = window.setTimeout(() => setVisibility(true), delay);
    }
    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [delay]);
  if (!visible) {
    return null;
  }
  const className = clsx("inline-flex flex-col relative items-center", otherProps.className);
  return /* @__PURE__ */ React__default.createElement("div", { ...otherProps, className, "data-taco": "spinner", ref }, /* @__PURE__ */ React__default.createElement(
    "svg",
    {
      className: "h-10 w-10 animate-[spinnerRotation_2s_linear_infinite]",
      viewBox: "0 0 100 100",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React__default.createElement("circle", { cx: "50", cy: "50", r: "45" })
  ), label && /* @__PURE__ */ React__default.createElement("span", { className: "mt-4" }, label));
});
const Checkbox$2 = React.forwardRef(function Checkbox2(props, ref) {
  const { checked, indeterminate, invalid, label, loading, onChange, ...otherProps } = props;
  const id2 = useId$1(props.id);
  const className = clsx(
    "bg-white h-5 w-5 border rounded text-sm flex-shrink-0 focus-visible:yt-focus disabled:cursor-not-allowed text-white",
    {
      "self-start": !!label,
      "mt-[0.1rem]": !label
    },
    invalid ? {
      "border-red-500 hover:border-red-700 aria-checked:border-red-500 aria-checked-mixed:border-red-500 aria-checked:bg-red-500 aria-checked-mixed:bg-red-500 aria-checked:hover:border-red-700 aria-checked-mixed:hover:border-red-700 aria-checked:hover:bg-red-700 aria-checked-mixed:hover:bg-red-700": !props.disabled,
      "border-red-500/50 aria-checked:wcag-red-500/50 aria-checked-mixed:wcag-red-500/50": props.disabled
    } : {
      "border-grey-500 hover:border-grey-700 aria-checked:border-blue-500 aria-checked-mixed:border-blue-500 aria-checked:bg-blue-500 aria-checked-mixed:bg-blue-500 aria-checked:hover:border-blue-700 aria-checked-mixed:hover:border-blue-700 aria-checked:hover:bg-blue-700 aria-checked-mixed:hover:bg-blue-700": !props.disabled,
      "border-grey-500/50 aria-checked:bg-blue-500/50 aria-checked-mixed:bg-blue-500/50": props.disabled
    },
    props.className
  );
  let handleChange;
  if (onChange) {
    handleChange = (checked2) => onChange(checked2 === "indeterminate" ? false : checked2);
  }
  let labelledByProps = null;
  if (label) {
    labelledByProps = {
      "aria-labelledby": `${id2}-label`,
      id: id2
    };
  }
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.currentTarget.click();
    }
  };
  const spinnerClassname = clsx(
    //Spinner is slightly bigger then 'line' and 'tick' icons, so making it 2px smaller from each side
    "m-0.5 !h-[calc(100%-theme('spacing.1'))] !w-[calc(100%-theme('spacing.1'))]",
    { "text-blue-500": !checked && !indeterminate }
  );
  const element = /* @__PURE__ */ React.createElement(
    $e698a72e93240346$export$be92b6f5f03c0fe9,
    {
      ...otherProps,
      ...labelledByProps,
      "aria-invalid": invalid ? "true" : void 0,
      "data-taco": "checkbox",
      checked: indeterminate ? "indeterminate" : checked,
      className,
      onCheckedChange: handleChange,
      onKeyDown: handleKeyDown,
      ref
    },
    loading ? /* @__PURE__ */ React.createElement(Spinner, { className: spinnerClassname }) : /* @__PURE__ */ React.createElement($e698a72e93240346$export$adb584737d712b70, { className: "flex h-full w-full" }, /* @__PURE__ */ React.createElement(Icon$1, { name: indeterminate ? "line" : "tick", className: "!h-full !w-full" }))
  );
  if (label) {
    const labelContainerClassName = clsx("flex items-center cursor-pointer gap-2", {
      "cursor-not-allowed text-grey-300": props.disabled
    });
    return /* @__PURE__ */ React.createElement("span", { className: labelContainerClassName, "data-taco": "checkbox-container" }, element, /* @__PURE__ */ React.createElement("label", { htmlFor: id2, id: `${id2}-label` }, label));
  }
  return element;
});
Checkbox$2.displayName = "Checkbox";
const $cb5cc270b50c6fcd$var$POPOVER_NAME = "Popover";
const [$cb5cc270b50c6fcd$var$createPopoverContext, $cb5cc270b50c6fcd$export$c8393c9e73286932] = $c512c27ab02ef895$export$50c7b4e9d9f19c1$1($cb5cc270b50c6fcd$var$POPOVER_NAME, [
  $cf1ac5d9fe0e8206$export$722aac194ae923
]);
const $cb5cc270b50c6fcd$var$usePopperScope = $cf1ac5d9fe0e8206$export$722aac194ae923();
const [$cb5cc270b50c6fcd$var$PopoverProvider, $cb5cc270b50c6fcd$var$usePopoverContext] = $cb5cc270b50c6fcd$var$createPopoverContext($cb5cc270b50c6fcd$var$POPOVER_NAME);
const $cb5cc270b50c6fcd$export$5b6b19405a83ff9d = (props) => {
  const { __scopePopover, children, open: openProp, defaultOpen, onOpenChange, modal = false } = props;
  const popperScope = $cb5cc270b50c6fcd$var$usePopperScope(__scopePopover);
  const triggerRef = useRef(null);
  const [hasCustomAnchor, setHasCustomAnchor] = useState(false);
  const [open = false, setOpen] = $71cd76cc60e0454e$export$6f32135080cb4c3$1({
    prop: openProp,
    defaultProp: defaultOpen,
    onChange: onOpenChange
  });
  return /* @__PURE__ */ createElement($cf1ac5d9fe0e8206$export$be92b6f5f03c0fe9, popperScope, /* @__PURE__ */ createElement($cb5cc270b50c6fcd$var$PopoverProvider, {
    scope: __scopePopover,
    contentId: $1746a345f3d73bb7$export$f680877a34711e37$1(),
    triggerRef,
    open,
    onOpenChange: setOpen,
    onOpenToggle: useCallback(
      () => setOpen(
        (prevOpen) => !prevOpen
      ),
      [
        setOpen
      ]
    ),
    hasCustomAnchor,
    onCustomAnchorAdd: useCallback(
      () => setHasCustomAnchor(true),
      []
    ),
    onCustomAnchorRemove: useCallback(
      () => setHasCustomAnchor(false),
      []
    ),
    modal
  }, children));
};
const $cb5cc270b50c6fcd$var$ANCHOR_NAME = "PopoverAnchor";
const $cb5cc270b50c6fcd$export$96e5381f42521a79 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopePopover, ...anchorProps } = props;
  const context = $cb5cc270b50c6fcd$var$usePopoverContext($cb5cc270b50c6fcd$var$ANCHOR_NAME, __scopePopover);
  const popperScope = $cb5cc270b50c6fcd$var$usePopperScope(__scopePopover);
  const { onCustomAnchorAdd, onCustomAnchorRemove } = context;
  useEffect(() => {
    onCustomAnchorAdd();
    return () => onCustomAnchorRemove();
  }, [
    onCustomAnchorAdd,
    onCustomAnchorRemove
  ]);
  return /* @__PURE__ */ createElement($cf1ac5d9fe0e8206$export$b688253958b8dfe7, _extends$z({}, popperScope, anchorProps, {
    ref: forwardedRef
  }));
});
const $cb5cc270b50c6fcd$var$TRIGGER_NAME = "PopoverTrigger";
const $cb5cc270b50c6fcd$export$7dacb05d26466c3 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopePopover, ...triggerProps } = props;
  const context = $cb5cc270b50c6fcd$var$usePopoverContext($cb5cc270b50c6fcd$var$TRIGGER_NAME, __scopePopover);
  const popperScope = $cb5cc270b50c6fcd$var$usePopperScope(__scopePopover);
  const composedTriggerRef = $6ed0406888f73fc4$export$c7b2cbe3552a0d05$1(forwardedRef, context.triggerRef);
  const trigger = /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.button, _extends$z({
    type: "button",
    "aria-haspopup": "dialog",
    "aria-expanded": context.open,
    "aria-controls": context.contentId,
    "data-state": $cb5cc270b50c6fcd$var$getState(context.open)
  }, triggerProps, {
    ref: composedTriggerRef,
    onClick: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(props.onClick, context.onOpenToggle)
  }));
  return context.hasCustomAnchor ? trigger : /* @__PURE__ */ createElement($cf1ac5d9fe0e8206$export$b688253958b8dfe7, _extends$z({
    asChild: true
  }, popperScope), trigger);
});
const $cb5cc270b50c6fcd$var$PORTAL_NAME = "PopoverPortal";
const [$cb5cc270b50c6fcd$var$PortalProvider, $cb5cc270b50c6fcd$var$usePortalContext] = $cb5cc270b50c6fcd$var$createPopoverContext($cb5cc270b50c6fcd$var$PORTAL_NAME, {
  forceMount: void 0
});
const $cb5cc270b50c6fcd$export$dd679ffb4362d2d4 = (props) => {
  const { __scopePopover, forceMount, children, container } = props;
  const context = $cb5cc270b50c6fcd$var$usePopoverContext($cb5cc270b50c6fcd$var$PORTAL_NAME, __scopePopover);
  return /* @__PURE__ */ createElement($cb5cc270b50c6fcd$var$PortalProvider, {
    scope: __scopePopover,
    forceMount
  }, /* @__PURE__ */ createElement($921a889cee6df7e8$export$99c2b779aa4e8b8b$1, {
    present: forceMount || context.open
  }, /* @__PURE__ */ createElement($f1701beae083dbae$export$602eac185826482c, {
    asChild: true,
    container
  }, children)));
};
const $cb5cc270b50c6fcd$var$CONTENT_NAME = "PopoverContent";
const $cb5cc270b50c6fcd$export$d7e1f420b25549ff = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const portalContext = $cb5cc270b50c6fcd$var$usePortalContext($cb5cc270b50c6fcd$var$CONTENT_NAME, props.__scopePopover);
  const { forceMount = portalContext.forceMount, ...contentProps } = props;
  const context = $cb5cc270b50c6fcd$var$usePopoverContext($cb5cc270b50c6fcd$var$CONTENT_NAME, props.__scopePopover);
  return /* @__PURE__ */ createElement($921a889cee6df7e8$export$99c2b779aa4e8b8b$1, {
    present: forceMount || context.open
  }, context.modal ? /* @__PURE__ */ createElement($cb5cc270b50c6fcd$var$PopoverContentModal, _extends$z({}, contentProps, {
    ref: forwardedRef
  })) : /* @__PURE__ */ createElement($cb5cc270b50c6fcd$var$PopoverContentNonModal, _extends$z({}, contentProps, {
    ref: forwardedRef
  })));
});
const $cb5cc270b50c6fcd$var$PopoverContentModal = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const context = $cb5cc270b50c6fcd$var$usePopoverContext($cb5cc270b50c6fcd$var$CONTENT_NAME, props.__scopePopover);
  const contentRef = useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05$1(forwardedRef, contentRef);
  const isRightClickOutsideRef = useRef(false);
  useEffect(() => {
    const content = contentRef.current;
    if (content) return hideOthers(content);
  }, []);
  return /* @__PURE__ */ createElement(ReactRemoveScroll, {
    as: $5e63c961fc1ce211$export$8c6ed5c666ac1360$1,
    allowPinchZoom: true
  }, /* @__PURE__ */ createElement($cb5cc270b50c6fcd$var$PopoverContentImpl, _extends$z({}, props, {
    ref: composedRefs,
    trapFocus: context.open,
    disableOutsidePointerEvents: true,
    onCloseAutoFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(props.onCloseAutoFocus, (event) => {
      var _context$triggerRef$c;
      event.preventDefault();
      if (!isRightClickOutsideRef.current) (_context$triggerRef$c = context.triggerRef.current) === null || _context$triggerRef$c === void 0 || _context$triggerRef$c.focus();
    }),
    onPointerDownOutside: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(props.onPointerDownOutside, (event) => {
      const originalEvent = event.detail.originalEvent;
      const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
      const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
      isRightClickOutsideRef.current = isRightClick;
    }, {
      checkForDefaultPrevented: false
    }),
    onFocusOutside: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(
      props.onFocusOutside,
      (event) => event.preventDefault(),
      {
        checkForDefaultPrevented: false
      }
    )
  })));
});
const $cb5cc270b50c6fcd$var$PopoverContentNonModal = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const context = $cb5cc270b50c6fcd$var$usePopoverContext($cb5cc270b50c6fcd$var$CONTENT_NAME, props.__scopePopover);
  const hasInteractedOutsideRef = useRef(false);
  return /* @__PURE__ */ createElement($cb5cc270b50c6fcd$var$PopoverContentImpl, _extends$z({}, props, {
    ref: forwardedRef,
    trapFocus: false,
    disableOutsidePointerEvents: false,
    onCloseAutoFocus: (event) => {
      var _props$onCloseAutoFoc;
      (_props$onCloseAutoFoc = props.onCloseAutoFocus) === null || _props$onCloseAutoFoc === void 0 || _props$onCloseAutoFoc.call(props, event);
      if (!event.defaultPrevented) {
        var _context$triggerRef$c2;
        if (!hasInteractedOutsideRef.current) (_context$triggerRef$c2 = context.triggerRef.current) === null || _context$triggerRef$c2 === void 0 || _context$triggerRef$c2.focus();
        event.preventDefault();
      }
      hasInteractedOutsideRef.current = false;
    },
    onInteractOutside: (event) => {
      var _props$onInteractOuts, _context$triggerRef$c3;
      (_props$onInteractOuts = props.onInteractOutside) === null || _props$onInteractOuts === void 0 || _props$onInteractOuts.call(props, event);
      if (!event.defaultPrevented) hasInteractedOutsideRef.current = true;
      const target = event.target;
      const targetIsTrigger = (_context$triggerRef$c3 = context.triggerRef.current) === null || _context$triggerRef$c3 === void 0 ? void 0 : _context$triggerRef$c3.contains(target);
      if (targetIsTrigger) event.preventDefault();
    }
  }));
});
const $cb5cc270b50c6fcd$var$PopoverContentImpl = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopePopover, trapFocus, onOpenAutoFocus, onCloseAutoFocus, disableOutsidePointerEvents, onEscapeKeyDown, onPointerDownOutside, onFocusOutside, onInteractOutside, ...contentProps } = props;
  const context = $cb5cc270b50c6fcd$var$usePopoverContext($cb5cc270b50c6fcd$var$CONTENT_NAME, __scopePopover);
  const popperScope = $cb5cc270b50c6fcd$var$usePopperScope(__scopePopover);
  $3db38b7d1fb3fe6a$export$b7ece24a22aeda8c();
  return /* @__PURE__ */ createElement($d3863c46a17e8a28$export$20e40289641fbbb6, {
    asChild: true,
    loop: true,
    trapped: trapFocus,
    onMountAutoFocus: onOpenAutoFocus,
    onUnmountAutoFocus: onCloseAutoFocus
  }, /* @__PURE__ */ createElement($5cb92bef7577960e$export$177fb62ff3ec1f22, {
    asChild: true,
    disableOutsidePointerEvents,
    onInteractOutside,
    onEscapeKeyDown,
    onPointerDownOutside,
    onFocusOutside,
    onDismiss: () => context.onOpenChange(false)
  }, /* @__PURE__ */ createElement($cf1ac5d9fe0e8206$export$7c6e2c02157bb7d2, _extends$z({
    "data-state": $cb5cc270b50c6fcd$var$getState(context.open),
    role: "dialog",
    id: context.contentId
  }, popperScope, contentProps, {
    ref: forwardedRef,
    style: {
      ...contentProps.style,
      // re-namespace exposed content custom property
      ["--radix-popover-content-transform-origin"]: "var(--radix-popper-transform-origin)"
    }
  }))));
});
const $cb5cc270b50c6fcd$var$CLOSE_NAME = "PopoverClose";
const $cb5cc270b50c6fcd$export$d6ac43ebaa40d53e = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopePopover, ...closeProps } = props;
  const context = $cb5cc270b50c6fcd$var$usePopoverContext($cb5cc270b50c6fcd$var$CLOSE_NAME, __scopePopover);
  return /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.button, _extends$z({
    type: "button"
  }, closeProps, {
    ref: forwardedRef,
    onClick: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(
      props.onClick,
      () => context.onOpenChange(false)
    )
  }));
});
const $cb5cc270b50c6fcd$export$3152841115e061b2 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopePopover, ...arrowProps } = props;
  const popperScope = $cb5cc270b50c6fcd$var$usePopperScope(__scopePopover);
  return /* @__PURE__ */ createElement($cf1ac5d9fe0e8206$export$21b07c8f274aebd5, _extends$z({}, popperScope, arrowProps, {
    ref: forwardedRef
  }));
});
function $cb5cc270b50c6fcd$var$getState(open) {
  return open ? "open" : "closed";
}
const $cb5cc270b50c6fcd$export$be92b6f5f03c0fe9 = $cb5cc270b50c6fcd$export$5b6b19405a83ff9d;
const $cb5cc270b50c6fcd$export$b688253958b8dfe7 = $cb5cc270b50c6fcd$export$96e5381f42521a79;
const $cb5cc270b50c6fcd$export$41fb9f06171c75f4 = $cb5cc270b50c6fcd$export$7dacb05d26466c3;
const $cb5cc270b50c6fcd$export$602eac185826482c = $cb5cc270b50c6fcd$export$dd679ffb4362d2d4;
const $cb5cc270b50c6fcd$export$7c6e2c02157bb7d2 = $cb5cc270b50c6fcd$export$d7e1f420b25549ff;
const $cb5cc270b50c6fcd$export$f39c2d165cd861fe = $cb5cc270b50c6fcd$export$d6ac43ebaa40d53e;
const $cb5cc270b50c6fcd$export$21b07c8f274aebd5 = $cb5cc270b50c6fcd$export$3152841115e061b2;
const getInputClasses = (props) => {
  const disabled = props.disabled || !!props["aria-disabled"];
  const readOnly = props.readOnly || !!props["aria-readonly"];
  const invalid = props.invalid || !!props["aria-invalid"];
  return clsx(
    "peer text-black text-sm border font-normal not-italic no-underline rounded flex items-center leading-6 px-2 relative w-full text-ellipsis transition-colors transition-opacity ease-in min-h-[theme(spacing.8)] focus:yt-focus",
    // hide the arrow controls on input[type=number]
    "[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none",
    {
      "bg-white": !props.highlighted && !readOnly,
      // default
      "border-grey-300 enabled:hover:border-grey-500 disabled:border-grey-200": !invalid,
      // disabled
      "text-opacity-25 cursor-not-allowed placeholder:text-grey-700": disabled,
      // highlighted
      "bg-yellow-100/50": props.highlighted && disabled,
      "bg-yellow-100": props.highlighted && !disabled,
      // invalid
      "border-red-500 enabled:hover:border-red-700 disabled:border-red-500/50": invalid,
      // readOnly
      "cursor-not-allowed text-black bg-grey-200": readOnly
    }
  );
};
const getButtonStateClasses = (invalid, disabled = false) => {
  if (invalid) {
    return clsx("border border-red-500 group-peer-hover:enabled:border-red-700 transition-colors ease-in", {
      "border-red-500/30": disabled
    });
  }
  return "border border-grey-300 group-peer-hover:enabled:border-grey-500 transition-colors transition-opacity ease-in";
};
const debounce$2 = (fn, delay) => {
  let timeoutId;
  return function(...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn.apply(this, args), delay);
  };
};
const getVisibility = (element) => Boolean(element && (element.offsetWidth || element.offsetHeight || element.getClientRects().length));
const useBoundingClientRectListener = (ref, dependencies) => {
  const [dimensions, setDimensions] = React.useState(void 0);
  const isRefElementVisible = getVisibility(ref.current);
  const [visibility, setVisibility] = React.useState(isRefElementVisible);
  const resize = () => {
    var _a;
    if (visibility) {
      setDimensions((_a = ref.current) == null ? void 0 : _a.getBoundingClientRect());
    }
  };
  React.useEffect(() => {
    const timeout = setTimeout(resize, 0);
    const debouncedResize = debounce$2(resize, 250);
    window.addEventListener("resize", debouncedResize);
    return () => {
      clearTimeout(timeout);
      window.removeEventListener("resize", debouncedResize);
    };
  }, [ref.current, visibility]);
  React.useEffect(() => {
    const newRefElementVisibility = getVisibility(ref.current);
    if (visibility !== newRefElementVisibility) {
      setVisibility(newRefElementVisibility);
    }
  });
  React.useEffect(() => {
    var _a;
    if (dependencies) {
      setDimensions((_a = ref.current) == null ? void 0 : _a.getBoundingClientRect());
    }
  }, dependencies);
  return dimensions;
};
const validSetSelectionRangeTypes = ["text", "search", "url", "tel", "password"];
const InputWithoutDeprecatedFeatures = React.forwardRef(function InputWithoutDeprecatedFeatures2(props, ref) {
  const { highlighted, invalid, onKeyDown, postfix, prefix: prefix2, type = "text", ...attributes } = props;
  const internalRef = useMergedRef(ref);
  React.useLayoutEffect(() => {
    if (internalRef.current && type === "number") {
      (function(fn) {
        internalRef.current.setSelectionRange = function(...args) {
          if (this.type === "number") {
            this.type = "text";
            fn.apply(this, args);
            this.type = "number";
          } else {
            fn.apply(this, args);
          }
        };
      })(internalRef.current.setSelectionRange);
    }
  }, []);
  const handleKeyDown = (event) => {
    if (event.key.length === 1 && !isPressingMetaKey(event)) {
      event.stopPropagation();
    }
    if (validSetSelectionRangeTypes.includes(type)) {
      if (!event.shiftKey && (event.key === "Home" || event.key === "End")) {
        event.preventDefault();
        const position = event.key === "End" ? event.currentTarget.value.length : 0;
        event.currentTarget.setSelectionRange(position, position);
        if (internalRef.current) {
          const scrollPosition = event.key === "End" ? internalRef.current.scrollWidth : 0;
          internalRef.current.scrollLeft = scrollPosition;
        }
      }
    }
    if (typeof onKeyDown === "function") {
      onKeyDown(event);
    }
  };
  const prefixRef = React.useRef(null);
  const prefixRect = useBoundingClientRectListener(prefixRef);
  const postfixRef = React.useRef(null);
  const postfixRect = useBoundingClientRectListener(postfixRef, [postfix]);
  const className = clsx(
    getInputClasses(props),
    {
      "pl-8": !!prefix2,
      "pr-8": !!postfix
    },
    attributes.className
  );
  const typeAttributes = {
    type
  };
  if (type === "number") {
    typeAttributes.onWheelCapture = (event) => {
      if (document.activeElement === event.currentTarget) {
        requestAnimationFrame(() => {
          event.target.focus();
        });
      }
      event.currentTarget.blur();
    };
  }
  return /* @__PURE__ */ React.createElement("div", { className: "relative inline-flex h-fit w-full", "data-taco": "input-container", style: { opacity: 0.999 } }, /* @__PURE__ */ React.createElement(
    "input",
    {
      ...attributes,
      ...typeAttributes,
      "aria-invalid": invalid,
      className,
      "data-highlighted": highlighted,
      "data-taco": "input",
      onKeyDown: handleKeyDown,
      ref: internalRef,
      style: {
        paddingLeft: prefixRect ? `${prefixRect.width - 1}px` : void 0,
        paddingRight: postfixRect ? `${postfixRect.width - 1}px` : void 0
      }
    }
  ), prefix2 ? /* @__PURE__ */ React.createElement(Affix, { type: "prefix", children: prefix2, disabled: attributes.disabled, ref: prefixRef }) : null, postfix ? /* @__PURE__ */ React.createElement(Affix, { type: "postfix", children: postfix, disabled: attributes.disabled, ref: postfixRef }) : null);
});
const Affix = React.memo(
  React.forwardRef(function Affix2(props, ref) {
    const { children, disabled, type } = props;
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: clsx(
          "group absolute top-0 flex h-full items-center justify-center px-2",
          // icon
          '[&_[data-taco="icon"]]:!h-5 [&_[data-taco="icon"]]:!w-5',
          {
            "text-grey-300": disabled,
            "text-grey-700": !disabled,
            "left-0 [&>button]:!-ml-2": type === "prefix",
            "right-0 [&>button]:!-mr-2": type === "postfix"
          }
        ),
        "data-affix-type": type,
        ref
      },
      children
    );
  })
);
const Input = React.forwardRef(function LegacyInput(props, ref) {
  const { button, icon, ...attributes } = props;
  let postfix;
  if (button) {
    const disabled = button.props.disabled || attributes.disabled;
    const buttonClassName = clsx(
      "items-center focus:z-10 flex justify-center rounded-l-none rounded-r h-full focus:rounded focus:outline-none",
      getButtonStateClasses(attributes.invalid, disabled),
      button.props.className
    );
    postfix = React.cloneElement(button, {
      className: buttonClassName,
      disabled
    });
  } else if (icon) {
    postfix = typeof icon === "string" ? /* @__PURE__ */ React.createElement(Icon$1, { name: icon }) : icon;
  }
  return /* @__PURE__ */ React.createElement(InputWithoutDeprecatedFeatures, { ...attributes, postfix: attributes.postfix ?? postfix, ref });
});
var isObject_1;
var hasRequiredIsObject;
function requireIsObject() {
  if (hasRequiredIsObject) return isObject_1;
  hasRequiredIsObject = 1;
  function isObject2(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
  }
  isObject_1 = isObject2;
  return isObject_1;
}
var _freeGlobal;
var hasRequired_freeGlobal;
function require_freeGlobal() {
  if (hasRequired_freeGlobal) return _freeGlobal;
  hasRequired_freeGlobal = 1;
  var freeGlobal = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
  _freeGlobal = freeGlobal;
  return _freeGlobal;
}
var _root;
var hasRequired_root;
function require_root() {
  if (hasRequired_root) return _root;
  hasRequired_root = 1;
  var freeGlobal = require_freeGlobal();
  var freeSelf = typeof self == "object" && self && self.Object === Object && self;
  var root = freeGlobal || freeSelf || Function("return this")();
  _root = root;
  return _root;
}
var now_1;
var hasRequiredNow;
function requireNow() {
  if (hasRequiredNow) return now_1;
  hasRequiredNow = 1;
  var root = require_root();
  var now2 = function() {
    return root.Date.now();
  };
  now_1 = now2;
  return now_1;
}
var _trimmedEndIndex;
var hasRequired_trimmedEndIndex;
function require_trimmedEndIndex() {
  if (hasRequired_trimmedEndIndex) return _trimmedEndIndex;
  hasRequired_trimmedEndIndex = 1;
  var reWhitespace = /\s/;
  function trimmedEndIndex(string2) {
    var index2 = string2.length;
    while (index2-- && reWhitespace.test(string2.charAt(index2))) {
    }
    return index2;
  }
  _trimmedEndIndex = trimmedEndIndex;
  return _trimmedEndIndex;
}
var _baseTrim;
var hasRequired_baseTrim;
function require_baseTrim() {
  if (hasRequired_baseTrim) return _baseTrim;
  hasRequired_baseTrim = 1;
  var trimmedEndIndex = require_trimmedEndIndex();
  var reTrimStart = /^\s+/;
  function baseTrim(string2) {
    return string2 ? string2.slice(0, trimmedEndIndex(string2) + 1).replace(reTrimStart, "") : string2;
  }
  _baseTrim = baseTrim;
  return _baseTrim;
}
var _Symbol;
var hasRequired_Symbol;
function require_Symbol() {
  if (hasRequired_Symbol) return _Symbol;
  hasRequired_Symbol = 1;
  var root = require_root();
  var Symbol2 = root.Symbol;
  _Symbol = Symbol2;
  return _Symbol;
}
var _getRawTag;
var hasRequired_getRawTag;
function require_getRawTag() {
  if (hasRequired_getRawTag) return _getRawTag;
  hasRequired_getRawTag = 1;
  var Symbol2 = require_Symbol();
  var objectProto = Object.prototype;
  var hasOwnProperty2 = objectProto.hasOwnProperty;
  var nativeObjectToString = objectProto.toString;
  var symToStringTag = Symbol2 ? Symbol2.toStringTag : void 0;
  function getRawTag(value) {
    var isOwn = hasOwnProperty2.call(value, symToStringTag), tag = value[symToStringTag];
    try {
      value[symToStringTag] = void 0;
      var unmasked = true;
    } catch (e3) {
    }
    var result = nativeObjectToString.call(value);
    if (unmasked) {
      if (isOwn) {
        value[symToStringTag] = tag;
      } else {
        delete value[symToStringTag];
      }
    }
    return result;
  }
  _getRawTag = getRawTag;
  return _getRawTag;
}
var _objectToString;
var hasRequired_objectToString;
function require_objectToString() {
  if (hasRequired_objectToString) return _objectToString;
  hasRequired_objectToString = 1;
  var objectProto = Object.prototype;
  var nativeObjectToString = objectProto.toString;
  function objectToString(value) {
    return nativeObjectToString.call(value);
  }
  _objectToString = objectToString;
  return _objectToString;
}
var _baseGetTag;
var hasRequired_baseGetTag;
function require_baseGetTag() {
  if (hasRequired_baseGetTag) return _baseGetTag;
  hasRequired_baseGetTag = 1;
  var Symbol2 = require_Symbol(), getRawTag = require_getRawTag(), objectToString = require_objectToString();
  var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
  var symToStringTag = Symbol2 ? Symbol2.toStringTag : void 0;
  function baseGetTag(value) {
    if (value == null) {
      return value === void 0 ? undefinedTag : nullTag;
    }
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
  }
  _baseGetTag = baseGetTag;
  return _baseGetTag;
}
var isObjectLike_1;
var hasRequiredIsObjectLike;
function requireIsObjectLike() {
  if (hasRequiredIsObjectLike) return isObjectLike_1;
  hasRequiredIsObjectLike = 1;
  function isObjectLike(value) {
    return value != null && typeof value == "object";
  }
  isObjectLike_1 = isObjectLike;
  return isObjectLike_1;
}
var isSymbol_1;
var hasRequiredIsSymbol;
function requireIsSymbol() {
  if (hasRequiredIsSymbol) return isSymbol_1;
  hasRequiredIsSymbol = 1;
  var baseGetTag = require_baseGetTag(), isObjectLike = requireIsObjectLike();
  var symbolTag = "[object Symbol]";
  function isSymbol(value) {
    return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
  }
  isSymbol_1 = isSymbol;
  return isSymbol_1;
}
var toNumber_1;
var hasRequiredToNumber;
function requireToNumber() {
  if (hasRequiredToNumber) return toNumber_1;
  hasRequiredToNumber = 1;
  var baseTrim = require_baseTrim(), isObject2 = requireIsObject(), isSymbol = requireIsSymbol();
  var NAN = 0 / 0;
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
  var reIsBinary = /^0b[01]+$/i;
  var reIsOctal = /^0o[0-7]+$/i;
  var freeParseInt = parseInt;
  function toNumber(value) {
    if (typeof value == "number") {
      return value;
    }
    if (isSymbol(value)) {
      return NAN;
    }
    if (isObject2(value)) {
      var other = typeof value.valueOf == "function" ? value.valueOf() : value;
      value = isObject2(other) ? other + "" : other;
    }
    if (typeof value != "string") {
      return value === 0 ? value : +value;
    }
    value = baseTrim(value);
    var isBinary = reIsBinary.test(value);
    return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
  }
  toNumber_1 = toNumber;
  return toNumber_1;
}
var debounce_1;
var hasRequiredDebounce;
function requireDebounce() {
  if (hasRequiredDebounce) return debounce_1;
  hasRequiredDebounce = 1;
  var isObject2 = requireIsObject(), now2 = requireNow(), toNumber = requireToNumber();
  var FUNC_ERROR_TEXT = "Expected a function";
  var nativeMax = Math.max, nativeMin = Math.min;
  function debounce2(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") {
      throw new TypeError(FUNC_ERROR_TEXT);
    }
    wait = toNumber(wait) || 0;
    if (isObject2(options)) {
      leading = !!options.leading;
      maxing = "maxWait" in options;
      maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
      trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time2) {
      var args = lastArgs, thisArg = lastThis;
      lastArgs = lastThis = void 0;
      lastInvokeTime = time2;
      result = func.apply(thisArg, args);
      return result;
    }
    function leadingEdge(time2) {
      lastInvokeTime = time2;
      timerId = setTimeout(timerExpired, wait);
      return leading ? invokeFunc(time2) : result;
    }
    function remainingWait(time2) {
      var timeSinceLastCall = time2 - lastCallTime, timeSinceLastInvoke = time2 - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
      return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time2) {
      var timeSinceLastCall = time2 - lastCallTime, timeSinceLastInvoke = time2 - lastInvokeTime;
      return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
      var time2 = now2();
      if (shouldInvoke(time2)) {
        return trailingEdge(time2);
      }
      timerId = setTimeout(timerExpired, remainingWait(time2));
    }
    function trailingEdge(time2) {
      timerId = void 0;
      if (trailing && lastArgs) {
        return invokeFunc(time2);
      }
      lastArgs = lastThis = void 0;
      return result;
    }
    function cancel() {
      if (timerId !== void 0) {
        clearTimeout(timerId);
      }
      lastInvokeTime = 0;
      lastArgs = lastCallTime = lastThis = timerId = void 0;
    }
    function flush() {
      return timerId === void 0 ? result : trailingEdge(now2());
    }
    function debounced() {
      var time2 = now2(), isInvoking = shouldInvoke(time2);
      lastArgs = arguments;
      lastThis = this;
      lastCallTime = time2;
      if (isInvoking) {
        if (timerId === void 0) {
          return leadingEdge(lastCallTime);
        }
        if (maxing) {
          clearTimeout(timerId);
          timerId = setTimeout(timerExpired, wait);
          return invokeFunc(lastCallTime);
        }
      }
      if (timerId === void 0) {
        timerId = setTimeout(timerExpired, wait);
      }
      return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
  }
  debounce_1 = debounce2;
  return debounce_1;
}
var debounceExports = requireDebounce();
const debounce$1 = /* @__PURE__ */ getDefaultExportFromCjs(debounceExports);
const getNextIndexFromKey = (key, length, index2, direction = "vertical") => {
  const previousKey = direction === "horizontal" ? "ArrowLeft" : "ArrowUp";
  const nextKey = direction === "horizontal" ? "ArrowRight" : "ArrowDown";
  switch (key) {
    case previousKey:
      return index2 !== void 0 ? index2 - 1 < 0 ? 0 : index2 - 1 : index2;
    case nextKey:
      return index2 !== void 0 ? index2 + 1 >= length ? index2 : index2 + 1 : index2;
    case "Home":
      return 0;
    case "End":
      return length - 1;
    default:
      return;
  }
};
const useListKeyboardNavigation = (length = 0, options = {
  direction: "vertical"
}) => {
  const [index2, setIndex] = React__default.useState(options.initialIndex);
  const getNextIndex2 = (event) => {
    const nextIndex = getNextIndexFromKey(event.key, length, index2, options.direction);
    if (nextIndex !== void 0) {
      event.preventDefault();
    }
    return nextIndex;
  };
  return [index2, setIndex, getNextIndex2];
};
const scrollToChildElement = (parent, child) => {
  const clientHeight = parent.clientHeight;
  if (parent.scrollHeight > clientHeight) {
    const scrollTop = parent.scrollTop;
    const scrollBottom = clientHeight + scrollTop;
    const childBottom = child.offsetTop + child.offsetHeight;
    if (childBottom > scrollBottom) {
      parent.scrollTop = childBottom - clientHeight;
    } else if (child.offsetTop < scrollTop) {
      parent.scrollTop = child.offsetTop;
    }
  }
};
const useListScrollTo = (internalRef, itemRefs) => {
  const scrollTo2 = (index2) => {
    if (internalRef && internalRef.current) {
      if (index2 !== void 0) {
        const activeRef = itemRefs[index2];
        if (activeRef && activeRef.current) {
          scrollToChildElement(internalRef.current, activeRef.current);
        }
      } else {
        internalRef.current.scrollTop = 0;
      }
    }
  };
  return { scrollTo: scrollTo2 };
};
const getId = (id2, value) => `${id2}_${value}`;
const getNextEnabledItem$1 = (event, data, index2) => {
  const nextIndex = getNextIndexFromKey(event.key, data.length, index2);
  if (nextIndex) {
    if (nextIndex === index2) {
      return index2;
    } else if (data[nextIndex] && data[nextIndex].disabled) {
      return getNextEnabledItem$1(event, data, nextIndex);
    }
  }
  return nextIndex;
};
const ScrollableList = React.forwardRef(function ScrollableList2(props, ref) {
  const {
    data,
    disabled,
    highlighted,
    id: id2,
    invalid: _,
    loading,
    onChange: setCurrentIndex,
    onClick,
    onFocus,
    onKeyDown,
    readOnly,
    scrollOnFocus = false,
    value: currentIndex,
    multiselect,
    selectedIndexes = [],
    allOptionsSelected = false,
    ...otherProps
  } = props;
  const listRef = useMergedRef(ref);
  const itemRefs = React.useMemo(() => data.map(() => React.createRef()), [data]);
  const { texts } = useLocalization();
  const { scrollTo: scrollTo2 } = useListScrollTo(listRef, itemRefs);
  React.useEffect(() => {
    var _a, _b;
    if (currentIndex && ((_a = itemRefs[currentIndex]) == null ? void 0 : _a.current)) {
      (_b = itemRefs[currentIndex].current) == null ? void 0 : _b.scrollIntoView({
        block: "center"
      });
    }
  }, []);
  React.useEffect(() => {
    scrollTo2(currentIndex);
  }, [currentIndex]);
  const handleKeyDown = (event) => {
    const nextIndex = getNextEnabledItem$1(event, data, currentIndex);
    if (nextIndex !== void 0 && nextIndex !== currentIndex) {
      event.preventDefault();
      scrollTo2(nextIndex);
      setCurrentIndex(nextIndex);
    }
    if (onKeyDown) {
      event.persist();
      const index2 = nextIndex !== void 0 ? nextIndex : currentIndex;
      onKeyDown(event, index2);
    }
    event.stopPropagation();
  };
  const handleClick = (index2) => (event) => {
    setCurrentIndex(index2);
    if (onClick) {
      event.persist();
      onClick(event, index2);
    }
  };
  const handleFocus = (event) => {
    if (scrollOnFocus) {
      scrollTo2(currentIndex);
    }
    if (onFocus) {
      event.persist();
      onFocus(event);
    }
  };
  const getOptionCheckedState = (optionValue, index2) => {
    if (optionValue === "#ALL-OPTIONS#") {
      return allOptionsSelected;
    } else if (!optionValue || !selectedIndexes) {
      return false;
    } else {
      return selectedIndexes.findIndex((i3) => i3 === index2) !== -1;
    }
  };
  const options = data.map((option, index2) => {
    const depth = option.path ? option.path.split(".").length - 1 : 0;
    return {
      "aria-selected": multiselect ? getOptionCheckedState(String(option.value), index2) : currentIndex === index2,
      "data-focused": currentIndex === index2,
      children: option.text,
      className: clsx(
        "flex items-center px-3 w-full cursor-pointer bg-white flex-[0_0_2rem] focus:wcag-blue-500 focus:border-blue-500",
        {
          "sticky top-0 font-bold": depth === 0 && !!option.hasChildren
        }
      ),
      disabled: option.disabled,
      icon: option.icon,
      id: getId(id2, option.value),
      key: getId(id2, option.value),
      onClick: !disabled && !readOnly ? handleClick(index2) : void 0,
      ref: itemRefs[index2],
      role: "option",
      style: depth > 0 ? {
        paddingLeft: `${depth + 1}rem`
      } : void 0
    };
  });
  const list = {
    ...otherProps,
    className: clsx(
      "inline-flex flex-col list-none !p-0 m-0 overflow-y-auto h-auto",
      getInputClasses(props),
      {
        "yt-list--multiselect": multiselect,
        "pointer-events-none": disabled,
        "cursor-not-allowed": disabled || readOnly
      },
      otherProps.className
    ),
    disabled,
    id: id2,
    onFocus: !disabled && !readOnly ? handleFocus : void 0,
    onKeyDown: !disabled && !readOnly ? handleKeyDown : void 0,
    readOnly,
    ref: listRef,
    role: options.length <= 0 || loading ? "presentation" : "listbox",
    tabIndex: otherProps.tabIndex || 0
  };
  return /* @__PURE__ */ React.createElement("ul", { ...list, "data-taco": "scrollable-list" }, loading ? /* @__PURE__ */ React.createElement("li", { className: "yt-list__empty" }, /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(Spinner, { delay: 0 })), /* @__PURE__ */ React.createElement("span", null, texts.listbox.loading)) : options.length ? options.map(({ children, icon, ...optionProps }) => /* @__PURE__ */ React.createElement("li", { ...optionProps }, icon, /* @__PURE__ */ React.createElement("span", { className: "flex-grow truncate text-left" }, children), multiselect && /* @__PURE__ */ React.createElement(
    Checkbox$2,
    {
      "aria-hidden": true,
      tabIndex: -1,
      checked: optionProps["aria-selected"],
      onChange: () => null,
      className: "pointer-events-none ml-2 self-center p-px"
    }
  ))) : /* @__PURE__ */ React.createElement("li", { className: "yt-list__empty" }, /* @__PURE__ */ React.createElement("span", null, texts.listbox.empty)));
});
const createCustomEvent = (eventType) => {
  let customEvent;
  if (typeof Event === "function") {
    customEvent = new Event(eventType, { bubbles: true });
  } else {
    customEvent = document.createEvent("Event");
    customEvent.initEvent(eventType, true, true);
  }
  return customEvent;
};
const createCustomKeyboardEvent = (event) => {
  let customKeyboardEvent;
  if (typeof KeyboardEvent === "function") {
    customKeyboardEvent = new KeyboardEvent(event.type, event);
  } else {
    customKeyboardEvent = document.createEvent("Event");
    customKeyboardEvent.initEvent(event.type, true, true);
    customKeyboardEvent.key = event.key;
    customKeyboardEvent.charCode = event.charCode;
  }
  return customKeyboardEvent;
};
const setInputValueByRef$1 = (input, value, event = "change") => {
  if (!input) {
    return;
  }
  const previousValue = input.value;
  input.value = value || "";
  const tracker = input._valueTracker;
  if (tracker) {
    tracker.setValue(previousValue);
  }
  input.dispatchEvent(createCustomEvent(event));
};
const getValue = (value) => String(value ?? "");
const setInputValueByRef = (input, value, event = "change") => {
  setInputValueByRef$1(input, getValue(value), event);
};
const getIndexFromValue = (data, value) => {
  const index2 = data.findIndex((option) => getValue(option.value) === getValue(value));
  return index2 > -1 ? index2 : void 0;
};
const getSelectedIndexesFromValue = (data, value) => {
  if (typeof value !== "string") return [];
  return value.split(",").map((v2) => data.findIndex((o2) => String(o2.value) === v2)).filter((v2) => v2 !== -1);
};
const findByValue = (data, value) => {
  return data.find((option) => getValue(option.value) === getValue(value));
};
const searchForString = (child, value, strategy = "includes") => {
  var _a, _b, _c;
  try {
    if (typeof child !== "string" && ((_a = child.props) == null ? void 0 : _a.children)) {
      if (Array.isArray((_b = child.props) == null ? void 0 : _b.children)) {
        return !!child.props.children.find(
          (subChild) => searchForString(subChild, value, strategy)
        );
      }
      return searchForString((_c = child.props) == null ? void 0 : _c.children, value, strategy);
    } else {
      return child.toString().toLowerCase()[strategy](String(value).toLowerCase());
    }
  } catch {
    return false;
  }
};
const getIndexInRangeByValue = (data, query, firstIndex, lastIndex = data.length) => {
  const index2 = data.slice(firstIndex, lastIndex).findIndex((option) => {
    if (option.disabled) {
      return false;
    }
    return searchForString(option.text, query, "startsWith");
  });
  return index2 > -1 ? index2 + firstIndex : -1;
};
const findNextIndexByValue = (data, query, activeIndex) => {
  const firstIndex = activeIndex === void 0 ? 0 : activeIndex + 1;
  let index2 = getIndexInRangeByValue(data, query, firstIndex);
  if (index2 === -1) {
    index2 = getIndexInRangeByValue(data, query, 0, activeIndex);
  }
  return index2;
};
const getActiveDescendant = (data, currentIndex, id2) => {
  return currentIndex !== void 0 && data[currentIndex] ? getId(id2, data[currentIndex].value) : void 0;
};
const useFlattenedData = (data) => {
  return React__default.useMemo(() => {
    const items = [];
    const flatten = (item, path, parentPath, parentDisabled) => {
      const currentPath = parentPath ? `${parentPath}.${path}` : `${path}`;
      const isItemDisabled = parentDisabled || item.disabled;
      items.push({
        ...item,
        disabled: isItemDisabled,
        path: currentPath,
        hasChildren: !!item.children
      });
      if (item.children) {
        item.children.forEach(
          (childItem, childPath) => flatten(childItem, childPath, currentPath, isItemDisabled)
        );
      }
    };
    data.forEach((item, index2) => {
      flatten(item, index2);
    });
    return items;
  }, [data]);
};
const sanitizeItem = (item) => {
  if (item) {
    const { hasChildren: _1, path: _2, ...rest } = item;
    return rest;
  }
  return void 0;
};
const getOptionParents = (data, path) => {
  const indexes = (path == null ? void 0 : path.split(".")) ?? [];
  if (indexes.length > 1) {
    indexes.pop();
    let lastPath;
    return indexes.map((i3) => {
      lastPath = lastPath ? [lastPath, i3].join(".") : i3;
      return sanitizeItem(data.find((i22) => i22.path === lastPath));
    });
  }
  return null;
};
const filterData = (data, value = "") => {
  if (value === "" || value === null) {
    return data;
  }
  const filteredOptionValues = /* @__PURE__ */ new Set();
  const shouldFilterOption = (option) => {
    if (option.disabled) {
      return false;
    }
    return searchForString(option.text, String(value));
  };
  data.forEach((option) => {
    if (shouldFilterOption(option)) {
      const parents = getOptionParents(data, option.path);
      filteredOptionValues.add(option.value);
      if (parents !== null) {
        parents.forEach((option2) => filteredOptionValues.add(option2 == null ? void 0 : option2.value));
      }
    }
  });
  return data.filter(({ value: value2 }) => filteredOptionValues.has(value2));
};
const debouncer = debounce$1((f2) => f2(), 200);
const convertToInputValue = (value) => String(value ?? "");
const useCombobox = (props, ref) => {
  const {
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy,
    data: unfilteredData = [],
    defaultValue: defaultValue2,
    disabled,
    id: nativeId,
    inline,
    loading: __,
    onChange,
    onClick,
    onKeyDown,
    onSearch,
    readOnly,
    value,
    ...otherProps
  } = props;
  const inputRef = useMergedRef(ref);
  const buttonRef = React.useRef(null);
  const listRef = React.useRef(null);
  const [open, setOpen] = React.useState(false);
  const listId = React.useMemo(() => nanoid(), []);
  const [inputValue, setInputValue] = React.useState(convertToInputValue(value));
  const shouldFilterData = !onSearch && (!inline || inline && inputValue !== convertToInputValue(value));
  const flattenedData = useFlattenedData(unfilteredData);
  const data = React.useMemo(
    () => shouldFilterData ? filterData(flattenedData, inputValue) : flattenedData,
    [shouldFilterData, inputValue, flattenedData]
  );
  const [currentIndex, setCurrentIndex] = React.useState(
    inputValue !== void 0 ? getIndexFromValue(data, inputValue) : void 0
  );
  const setInputValueByIndex = (index2, event) => {
    if (index2 !== void 0) {
      const option = data[index2];
      if (option && !option.disabled) {
        const eventType = event ?? "focusout";
        setInputValueByRef(inputRef.current, option.value, eventType);
      }
    }
  };
  const setCurrentValue = (index2, event) => {
    if (index2 === void 0) {
      return;
    }
    const option = data[index2];
    if (option.value !== value) {
      setInputValueByIndex(index2, event);
    } else {
      setInputValue(convertToInputValue(value));
    }
  };
  React.useEffect(() => {
    if (defaultValue2 && !value) {
      setInputValueByIndex(getIndexFromValue(data, defaultValue2));
    }
  }, [data]);
  React.useEffect(() => {
    if (value !== void 0 && value !== inputValue) {
      setInputValue(convertToInputValue(value));
    }
  }, [value]);
  React.useEffect(() => {
    if (onSearch) {
      debouncer(() => {
        onSearch(inputValue);
      });
    }
  }, [inputValue]);
  React.useEffect(() => {
    const isCurrentValue = value !== void 0 && value !== null && inputValue === String(value);
    if (inputValue && data.length && !isCurrentValue) {
      setCurrentIndex(0);
      if (!open) {
        setOpen(true);
      }
    } else {
      setOpen(false);
    }
  }, [inputValue, data]);
  React.useEffect(() => {
    if (open) {
      setCurrentIndex(getIndexFromValue(data, inputValue) || 0);
    } else {
      setCurrentIndex(void 0);
    }
  }, [open]);
  const handleInputBlur = (event) => {
    event.persist();
    if (listRef.current && event.relatedTarget === listRef.current) {
      event.preventDefault();
      return;
    }
    if (onChange && event.target.value !== String(value)) {
      const item = findByValue(flattenedData, event.target.value);
      event.detail = sanitizeItem(item);
      const parents = getOptionParents(flattenedData, item == null ? void 0 : item.path);
      if (parents !== null && parents.length > 0) {
        event.detail.parents = parents;
      }
      onChange(event);
    }
    if (props.onBlur) {
      props.onBlur(event);
    }
  };
  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };
  const handleInputClick = (event) => {
    if (inline || !open && inputValue && data.length) {
      setOpen(true);
    }
    if (onClick) {
      event.persist();
      onClick(event);
    }
  };
  const handleInputKeyDown = (event) => {
    event.persist();
    if (!event.ctrlKey && !event.metaKey) {
      switch (event.key) {
        case "Backspace": {
          return;
        }
        case "Escape": {
          event.preventDefault();
          setInputValue(convertToInputValue(value));
          setOpen(false);
          return;
        }
        case "Tab": {
          setCurrentValue(currentIndex, "change");
          setOpen(false);
          return;
        }
        case "Enter": {
          event.preventDefault();
          if (isElementInsideTable3OrReport(event.currentTarget)) {
            if (inline && !open) {
              setOpen(true);
            } else if (buttonRef.current && !open) {
              buttonRef.current.click();
            }
          }
          if (open) {
            setCurrentValue(currentIndex, "focusout");
            setOpen(false);
          }
          return;
        }
        case "ArrowDown":
          if (open) {
            event.preventDefault();
          } else {
            if (!inline && buttonRef.current && !isElementInsideTable3OrReport(event.currentTarget)) {
              buttonRef.current.click();
            }
          }
          break;
        case "ArrowUp":
        case "Home":
        case "End": {
          if (open) {
            event.preventDefault();
          }
          break;
        }
      }
      if (listRef.current) {
        listRef.current.dispatchEvent(createCustomKeyboardEvent(event));
      }
      if (inline && !open) {
        if ((event.key === "ArrowUp" || event.key === "ArrowDown") && !isElementInsideTable3OrReport(event.currentTarget)) {
          event.preventDefault();
          const initialIndex = event.key === "ArrowUp" ? data.length - 1 : 0;
          setCurrentIndex(currentIndex !== void 0 ? currentIndex : initialIndex);
          setOpen(true);
        }
      }
    }
    if (!event.isDefaultPrevented() && onKeyDown) {
      event.persist();
      onKeyDown(event);
    }
  };
  const handleListboxChange = (index2) => {
    setCurrentIndex(index2);
  };
  const handleListboxClick = (event, index2) => {
    event.preventDefault();
    setCurrentValue(index2);
    setOpen(false);
  };
  const combobox = {
    "aria-expanded": open,
    "aria-owns": listId,
    "aria-haspopup": "listbox",
    role: "combobox"
  };
  const input = {
    ...otherProps,
    "aria-controls": listId,
    // Indicates that the autocomplete behavior of the text input is to suggest a list of possible values in a popup and that the suggestions
    // are related to the string that is present in the textbox
    "aria-autocomplete": "list",
    // Enables assistive technologies to know which element the application regards as focused while DOM focus remains on the input element
    "aria-activedescendant": currentIndex !== void 0 && data[currentIndex] ? getId(listId, String(data[currentIndex].value)) : void 0,
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy,
    disabled,
    onBlur: !disabled && !readOnly ? handleInputBlur : void 0,
    onChange: !disabled && !readOnly ? handleInputChange : void 0,
    onClick: !disabled && !readOnly ? handleInputClick : void 0,
    onKeyDown: !disabled && !readOnly ? handleInputKeyDown : void 0,
    readOnly,
    ref: inputRef,
    type: "text",
    value: inputValue ?? ""
  };
  const list = {
    "aria-labelledby": ariaLabelledBy,
    data,
    disabled,
    id: listId,
    onChange: handleListboxChange,
    onClick: handleListboxClick,
    ref: listRef,
    scrollOnFocus: false,
    tabIndex: -1,
    value: currentIndex
  };
  const button = {
    ref: buttonRef
  };
  return {
    combobox,
    input,
    list,
    button,
    popover: {
      open,
      onOpenChange: setOpen
      //visible: !data.length ? false : open,
    }
  };
};
const Combobox = React.forwardRef(function Combobox2(props, ref) {
  const { className: externalClassName, dialog, style, ...otherProps } = props;
  const { combobox, button, input, popover, list } = useCombobox(otherProps, ref);
  const internalRef = React.useRef(null);
  const { texts } = useLocalization();
  const selectDimensions = useBoundingClientRectListener(internalRef);
  const className = clsx(
    "inline-flex relative",
    {
      "yt-combobox--inline": props.inline
    },
    externalClassName
  );
  return /* @__PURE__ */ React.createElement("span", { className, "data-taco": "combobox", style }, /* @__PURE__ */ React.createElement($cb5cc270b50c6fcd$export$be92b6f5f03c0fe9, { ...popover }, /* @__PURE__ */ React.createElement($cb5cc270b50c6fcd$export$b688253958b8dfe7, { asChild: true, ref: internalRef }, /* @__PURE__ */ React.createElement("div", { ...combobox, className: "inline w-full", ref }, /* @__PURE__ */ React.createElement(
    Input,
    {
      ...input,
      autoComplete: "off",
      button: props.readOnly ? void 0 : props.inline ? /* @__PURE__ */ React.createElement(
        IconButton,
        {
          "aria-hidden": true,
          appearance: "discrete",
          className: "!border-l-0 focus:!border-none focus:!shadow-none active:!border-none",
          icon: popover.open ? "chevron-up" : "chevron-down",
          onClick: () => {
            var _a;
            popover.onOpenChange(true);
            (_a = input.ref.current) == null ? void 0 : _a.focus();
          },
          tabIndex: -1
        }
      ) : dialog ? /* @__PURE__ */ React.createElement(
        IconButton,
        {
          "aria-label": texts.combobox.tooltip,
          icon: "list-search",
          disabled: props.readOnly || props.disabled,
          dialog,
          onFocus: (event) => {
            var _a;
            event.preventDefault();
            (_a = input.ref.current) == null ? void 0 : _a.focus();
          },
          ref: button.ref,
          tabIndex: -1,
          tooltip: texts.combobox.tooltip
        }
      ) : void 0
    }
  ))), /* @__PURE__ */ React.createElement($cb5cc270b50c6fcd$export$602eac185826482c, null, /* @__PURE__ */ React.createElement(
    $cb5cc270b50c6fcd$export$7c6e2c02157bb7d2,
    {
      align: "start",
      onOpenAutoFocus: (event) => {
        event.preventDefault();
      },
      sideOffset: 4
    },
    /* @__PURE__ */ React.createElement(
      ScrollableList,
      {
        ...list,
        className: clsx("max-h-[calc(12rem+2px)] w-auto max-w-[theme(spacing.96)] !border-blue-500"),
        style: { minWidth: selectDimensions == null ? void 0 : selectDimensions.width },
        tabIndex: popover.open ? 0 : -1
      }
    )
  ))));
});
const isWeakEqual$1 = (leftDate, rightDate) => {
  return leftDate.getFullYear() === rightDate.getFullYear() && leftDate.getMonth() === rightDate.getMonth() && leftDate.getDate() === rightDate.getDate();
};
function parse$1(date2) {
  let value;
  if (isDate(date2)) {
    value = date2;
  } else if (typeof date2 === "string") {
    value = parseFromISOString(date2);
  }
  if (!isValid(value)) {
    return void 0;
  }
  return value;
}
function format$1(date2, mask = "dd.mm.yy") {
  if (date2 === void 0) {
    return void 0;
  }
  const value = parse$1(date2);
  if (!isValid(value) || value === void 0) {
    return void 0;
  }
  const pad2 = (v2) => String(v2).length === 1 ? `0${v2}` : v2.toString();
  return mask.replace("dd", pad2(value.getDate())).replace("mm", pad2(value.getMonth() + 1)).replace("yy", String(value.getFullYear()).slice(2));
}
const parseFromCustomString = (date2 = "", mask = "dd.mm.yy", defaultMonth = void 0, defaultYear = void 0) => {
  if (!date2 || !date2.length) {
    return void 0;
  }
  const sanitizedMask = mask.split(/[^dmy]/);
  const dd = sanitizedMask.findIndex((x3) => x3 === "dd");
  const mm = sanitizedMask.findIndex((x3) => x3 === "mm");
  const yy = sanitizedMask.findIndex((x3) => x3 === "yy" || x3 === "yyyy");
  let day;
  let month;
  let year;
  const getFullYear = (y4) => {
    if (y4 && y4.length === 2) {
      const z3 = Number.parseInt(y4, 10);
      return z3 > 50 ? `19${y4}` : `20${y4}`;
    }
    return y4;
  };
  const inputParts = date2.split(/\D/);
  if (inputParts.length === 1) {
    const fullDate = inputParts[0];
    const unseparatedMask = mask.replace(/[^dmy]/g, "");
    day = fullDate.slice(unseparatedMask.indexOf("d"), unseparatedMask.lastIndexOf("d") + 1);
    month = fullDate.slice(unseparatedMask.indexOf("m"), unseparatedMask.lastIndexOf("m") + 1);
    year = getFullYear(fullDate.slice(unseparatedMask.indexOf("y"), unseparatedMask.lastIndexOf("y") + 3));
  } else {
    day = inputParts[dd];
    month = inputParts[mm];
    year = getFullYear(inputParts[yy]);
  }
  day = Number.parseInt(day, 10);
  month = Number.parseInt(month, 10);
  year = Number.parseInt(year, 10);
  const currentDate = /* @__PURE__ */ new Date();
  return new Date(
    /* year */
    Object.is(year, NaN) ? defaultYear ?? currentDate.getFullYear() : year,
    /* month */
    Object.is(month, NaN) ? defaultMonth ?? currentDate.getMonth() : month - 1,
    // months are zero based in javascript, so subtract a day
    /* day */
    Object.is(day, NaN) ? currentDate.getDate() : day,
    /* hours */
    12,
    /* minutes */
    0
    // set to midday to avoid UTC offset causing dates to be mismatched server side
  );
};
const parseFromISOString = (date2) => {
  const tempDate = new Date(date2);
  return isValid(tempDate) ? parseFromCustomString(format$1(new Date(date2))) : void 0;
};
const useDatepicker = ({ defaultValue: _, calendar: calendar2, onBlur, onChange, value, ...props }, ref) => {
  const inputRef = useMergedRef(ref);
  const { formatting } = useLocalization();
  const [internalValue, setInternalValue] = React.useState(format$1(value, formatting.date) ?? "");
  const originalValueAsDate = parse$1(value);
  React.useEffect(() => {
    const formattedValue = format$1(value, formatting.date);
    if (formattedValue !== internalValue) {
      setInternalValue(formattedValue ?? "");
    }
  }, [value]);
  const isDisabledDay = React.useMemo(() => {
    if (originalValueAsDate && (calendar2 == null ? void 0 : calendar2.disabledDays)) {
      return isMatch(originalValueAsDate, calendar2 == null ? void 0 : calendar2.disabledDays);
    }
    return false;
  }, [originalValueAsDate]);
  const handleInputBlur = (event) => {
    event.persist();
    const valueAsDate = parseFromCustomString(
      event.target.value,
      "dd.mm.yy",
      originalValueAsDate == null ? void 0 : originalValueAsDate.getMonth(),
      originalValueAsDate == null ? void 0 : originalValueAsDate.getFullYear()
    );
    const formattedValue = valueAsDate ? format$1(valueAsDate) || "" : "";
    event.target.value = formattedValue;
    if (onChange) {
      event.detail = valueAsDate;
      onChange(event);
    } else {
      setInternalValue(formattedValue);
    }
    if (onBlur) {
      onBlur(event);
    }
  };
  const handleInputChange = (event) => {
    setInternalValue(event.target.value);
  };
  const handleChange = (date2) => {
    setInputValueByRef$1(inputRef.current, format$1(date2, formatting.date), "focusout");
  };
  const handleKeyDown = (event) => {
    if (props.onKeyDown) {
      props.onKeyDown(event);
    }
    if (event.key === "Enter") {
      event.target.dispatchEvent(new Event("focusout", { bubbles: true }));
    }
  };
  const inputProps = {
    ...props,
    autoComplete: "off",
    invalid: props.invalid || isDisabledDay,
    onBlur: handleInputBlur,
    onChange: handleInputChange,
    onKeyDown: handleKeyDown,
    ref: inputRef,
    type: "text",
    value: internalValue
  };
  const calendarProps = {
    ...calendar2,
    onChange: handleChange,
    value: originalValueAsDate
  };
  return {
    input: inputProps,
    calendar: calendarProps
  };
};
const UnstyledArrow$1 = React.forwardRef(function PopoverArrow(props, ref) {
  return /* @__PURE__ */ React.createElement($cb5cc270b50c6fcd$export$21b07c8f274aebd5, { className: "pointer-events-none -mt-px", asChild: true, offset: 2, width: 30, height: 11 }, /* @__PURE__ */ React.createElement("svg", { ...props, ref, viewBox: "0 19 30 11", style: { transform: "rotateZ(180deg)" } }, /* @__PURE__ */ React.createElement(
    "path",
    {
      className: "text-[rgba(89, 85, 98, 0.35)] fill-current",
      d: "M23.7,27.1L17,19.9C16.5,19.3,15.8,19,15,19s-1.6,0.3-2.1,0.9l-6.6,7.2C5.3,28.1,3.4,29,2,29h26 C26.7,29,24.6,28.1,23.7,27.1z"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      className: "fill-current",
      d: "M23,27.8c1.1,1.2,3.4,2.2,5,2.2h2H0h2c1.7,0,3.9-1,5-2.2l6.6-7.2c0.7-0.8,2-0.8,2.7,0L23,27.8L23,27.8z"
    }
  )));
});
const getPopoverStyleClassnames = () => "bg-white focus:border-blue-300 border border-transparent rounded p-3 yt-shadow focus:yt-focus outline-none group";
const PopoverContext = React.createContext({
  props: {},
  ref: null
});
const Anchor$1 = React.forwardRef(function PopoverAnchor(props, ref) {
  return /* @__PURE__ */ React.createElement($cb5cc270b50c6fcd$export$b688253958b8dfe7, { ...props, asChild: true, ref });
});
const Trigger$5 = React.forwardRef(function PopoverTrigger(props, externalRef) {
  var _a;
  const { ref: parentRef, props: parentProps } = React.useContext(PopoverContext);
  const refCallback = mergeRefs([parentRef, externalRef]);
  let children = props.children;
  if (React.isValidElement(props.children) && typeof ((_a = props.children) == null ? void 0 : _a.type) === "function") {
    console.warn(
      `Popover.Trigger requires its child to forwardRef so that it can attach to the dom element. Did you mean to wrap '${props.children.type.name}' in React.forwardRef()? Taco has wrapped '${props.children.type.name}' in a 'span' to maintain functionality, but this may cause unintended behaviour`
    );
    children = /* @__PURE__ */ React.createElement("span", null, props.children);
  }
  return /* @__PURE__ */ React.createElement($cb5cc270b50c6fcd$export$41fb9f06171c75f4, { ...parentProps, ...props, ref: refCallback, asChild: true }, children);
});
const RenderPropWrapper$2 = React.forwardRef(function RenderPropWrapper2({ children, onClick }, ref) {
  const close = () => {
    onClick(new CustomEvent("hide"));
  };
  return children({ close, ref });
});
const Content$7 = React.forwardRef(function PopoverContent(props, ref) {
  const { placement: side, ...popoverContentProps } = props;
  const className = clsx(getPopoverStyleClassnames(), props.className);
  let output;
  if (typeof props.children === "function") {
    output = /* @__PURE__ */ React.createElement($cb5cc270b50c6fcd$export$f39c2d165cd861fe, { asChild: true }, /* @__PURE__ */ React.createElement(RenderPropWrapper$2, null, props.children));
  } else {
    output = props.children;
  }
  return /* @__PURE__ */ React.createElement($cb5cc270b50c6fcd$export$602eac185826482c, null, /* @__PURE__ */ React.createElement(
    $cb5cc270b50c6fcd$export$7c6e2c02157bb7d2,
    {
      ...popoverContentProps,
      className,
      "data-taco": "popover",
      side,
      sideOffset: 1,
      ref
    },
    output,
    /* @__PURE__ */ React.createElement(UnstyledArrow$1, { className: "text-white" })
  ));
});
const Close$2 = React.forwardRef(
  (props, ref) => /* @__PURE__ */ React.createElement($cb5cc270b50c6fcd$export$f39c2d165cd861fe, { ...props, ref, asChild: true })
);
const Popover = React.forwardRef(function Popover2(props, ref) {
  const { anchor, children, defaultOpen, modal = false, open, onChange, trigger, ...otherProps } = props;
  const context = React.useMemo(() => ({ props: otherProps, ref }), [otherProps]);
  return /* @__PURE__ */ React.createElement(PopoverContext.Provider, { value: context }, /* @__PURE__ */ React.createElement($cb5cc270b50c6fcd$export$be92b6f5f03c0fe9, { defaultOpen, modal, open, onOpenChange: onChange }, anchor ? /* @__PURE__ */ React.createElement(Anchor$1, null, anchor) : null, trigger && !anchor ? /* @__PURE__ */ React.createElement(Trigger$5, null, trigger) : null, children));
});
Popover.Anchor = Anchor$1;
Popover.Trigger = Trigger$5;
Popover.Content = Content$7;
Popover.Close = Close$2;
Popover.Portal = $cb5cc270b50c6fcd$export$602eac185826482c;
const Datepicker = React.forwardRef(function Datepicker2(props, ref) {
  const { className: externalClassName, onReset: handleReset, style, shortcuts, shortcutsText, ...otherProps } = props;
  const { calendar: calendar2, input } = useDatepicker(otherProps, ref);
  const { texts } = useLocalization();
  const className = clsx("inline-flex w-full text-black font-normal", externalClassName);
  const popoverContentRef = React.useRef(null);
  const handleOpenAutofocus = React.useCallback(
    (e3) => {
      var _a;
      e3.preventDefault();
      const currentDay = ((_a = popoverContentRef == null ? void 0 : popoverContentRef.current) == null ? void 0 : _a.querySelector('table button[name="day"][aria-selected="true"]')) ?? null;
      currentDay == null ? void 0 : currentDay.focus();
    },
    [popoverContentRef]
  );
  const handleCloseAutoFocus = React.useCallback(
    (e3) => {
      var _a;
      e3.preventDefault();
      (_a = input.ref.current) == null ? void 0 : _a.focus();
    },
    [input.ref]
  );
  const handleInputKeyDown = (event) => {
    var _a, _b;
    (_a = props.onKeyDown) == null ? void 0 : _a.call(props, event);
    if (!event.defaultPrevented) {
      (_b = input.onKeyDown) == null ? void 0 : _b.call(input, event);
    }
  };
  return /* @__PURE__ */ React.createElement("span", { className, "data-taco": "datepicker", style }, /* @__PURE__ */ React.createElement(
    Input,
    {
      ...input,
      onKeyDown: handleInputKeyDown,
      button: input.readOnly ? void 0 : /* @__PURE__ */ React.createElement(
        IconButton,
        {
          "aria-label": texts.datepicker.expand,
          disabled: input.disabled || input.readOnly,
          icon: "calendar",
          tabIndex: -1,
          popover: (props2) => /* @__PURE__ */ React.createElement(Popover, { ...props2 }, /* @__PURE__ */ React.createElement(
            Popover.Content,
            {
              onOpenAutoFocus: handleOpenAutofocus,
              onCloseAutoFocus: handleCloseAutoFocus
            },
            ({ close }) => /* @__PURE__ */ React.createElement(
              "div",
              {
                className: '[&_button[name="day"]:focus]:yt-focus -m-3 flex',
                ref: popoverContentRef
              },
              /* @__PURE__ */ React.createElement(
                Calendar,
                {
                  ...calendar2,
                  onChange: (date2, event) => {
                    calendar2.onChange(date2, event);
                    close();
                  }
                }
              ),
              shortcuts && /* @__PURE__ */ React.createElement("div", { className: "border-grey-300 flex flex-col border-l" }, /* @__PURE__ */ React.createElement("span", { className: "m-4 mb-3 flex h-8 w-32 items-center text-xs font-semibold" }, shortcutsText ?? texts.datepicker.shortcuts), /* @__PURE__ */ React.createElement("ul", null, shortcuts.map((shortcut2) => /* @__PURE__ */ React.createElement("li", { key: shortcut2.text }, /* @__PURE__ */ React.createElement(
                "button",
                {
                  type: "button",
                  className: "hover:wcag-grey-200 flex w-full items-start px-4 py-1 text-xs",
                  onClick: (event) => {
                    event.persist();
                    shortcut2.onClick(event);
                    close();
                  }
                },
                shortcut2.text
              )))), handleReset && /* @__PURE__ */ React.createElement(
                "button",
                {
                  type: "button",
                  className: "mx-auto my-4 mt-auto inline-flex cursor-pointer border-none bg-transparent text-xs text-blue-500 hover:text-blue-300",
                  onClick: (event) => {
                    event.persist();
                    handleReset(event);
                    close();
                  }
                },
                texts.datepicker.clear
              ))
            )
          )),
          tooltip: texts.datepicker.calendar
        }
      )
    }
  ));
});
Datepicker.displayName = "Datepicker";
const DialogContext = React.createContext({
  closeOnEscape: true,
  draggable: false,
  drawer: {
    open: false,
    toggle: () => {
    }
  },
  elements: {
    drawer: void 0,
    extra: void 0
  },
  onClose: () => {
  },
  props: {},
  ref: null,
  showCloseButton: true,
  size: "sm"
});
const useCurrentDialog = () => {
  return React.useContext(DialogContext);
};
const Trigger$4 = React.forwardRef(function DialogTrigger(props, externalRef) {
  const { ref: parentRef, props: parentProps } = useCurrentDialog();
  const refCallback = mergeRefs([parentRef, externalRef]);
  return /* @__PURE__ */ React.createElement($5d3850c4d0b4e6c7$export$41fb9f06171c75f4, { ...parentProps, ...props, ref: refCallback, asChild: true });
});
const useDraggable$1 = (ref) => {
  const [position, setPosition] = React__default.useState({
    x: 0,
    y: 0
  });
  const [dragging, setDragging] = React__default.useState(false);
  const { moveProps } = $e8a7022cf87cba2a$export$36da96379f79f245({
    onMoveStart() {
      setDragging(true);
    },
    onMove(event) {
      var _a;
      const rect = (_a = ref.current) == null ? void 0 : _a.getBoundingClientRect();
      if (rect && (rect.left + event.deltaX < 0 || rect.right + event.deltaX > window.innerWidth || rect.top + event.deltaY < 0 || rect.bottom + event.deltaY > window.innerHeight)) {
        return;
      }
      setPosition(({ x: x3, y: y4 }) => {
        x3 += event.deltaX;
        y4 += event.deltaY;
        return { x: x3, y: y4 };
      });
    },
    onMoveEnd() {
      setDragging(false);
    }
  });
  const resetPosition = () => {
    setPosition({
      x: 0,
      y: 0
    });
  };
  return {
    position,
    dragging,
    handleProps: moveProps,
    resetPosition
  };
};
const Title$4 = React.forwardRef(function DialogTitle(props, ref) {
  const className = clsx("text-center", props.className);
  return /* @__PURE__ */ React.createElement($5d3850c4d0b4e6c7$export$f99233281efd08a0, { ...props, className, ref });
});
const Footer$2 = React.forwardRef(function DialogFooter(props, ref) {
  const className = clsx("mt-8 flex justify-end", props.className);
  return /* @__PURE__ */ React.createElement("div", { ...props, className, ref }, props.children);
});
const Close$1 = React.forwardRef(function DialogClose(props, ref) {
  const dialog = useCurrentDialog();
  return /* @__PURE__ */ React.createElement($5d3850c4d0b4e6c7$export$f39c2d165cd861fe, { onClick: dialog.onClose, ...props, ref, asChild: true });
});
const RenderPropWrapper$1 = React.forwardRef(function RenderPropWrapper22({ children, onClick, renderProps }, ref) {
  const close = () => {
    onClick(new CustomEvent("close"));
  };
  return children({ close, ref, ...renderProps });
});
const Content$6 = React.forwardRef(function DialogContent(props, ref) {
  const dialog = useCurrentDialog();
  const internalRef = useMergedRef(ref);
  const { position, dragging, handleProps: dragHandleProps } = useDraggable$1(internalRef);
  const { texts } = useLocalization();
  const className = clsx(
    "relative bg-white animate-[fade-in_150ms] rounded print:!static",
    getDialogPositionClassnames(),
    getDialogSizeClassnames(dialog.size),
    "print:w-full print:h-max print:m-0 print:overflow-visible"
  );
  const containerClassName = clsx(
    "bg-white p-6 rounded relative z-10 shadow print:p-0",
    // The `!fixed` property is crucial to ensure that when a draggable dialog is moved, the printed document still displays its content across the full page.
    "print:overflow-visible print:h-max print:!transform-none print:!inset-0 print:!m-0",
    {
      "rounded-b-none": !!dialog.elements.extra
    },
    props.className
  );
  const handleEscapeKeyDown = (event) => {
    if (!dialog.closeOnEscape) {
      event.preventDefault();
    } else if (dialog.onClose) {
      dialog.onClose();
    }
  };
  const handleInteractOutside = (event) => event.preventDefault();
  let output;
  if (typeof props.children === "function") {
    output = /* @__PURE__ */ React.createElement(Close$1, null, /* @__PURE__ */ React.createElement(RenderPropWrapper$1, { renderProps: { drawer: dialog.drawer } }, props.children));
  } else {
    output = props.children;
  }
  return /* @__PURE__ */ React.createElement($5d3850c4d0b4e6c7$export$602eac185826482c, null, /* @__PURE__ */ React.createElement($5d3850c4d0b4e6c7$export$c6fdb837b070b4ff, { asChild: true }, /* @__PURE__ */ React.createElement(Backdrop, null, /* @__PURE__ */ React.createElement(
    $5d3850c4d0b4e6c7$export$7c6e2c02157bb7d2,
    {
      ...props,
      className,
      onEscapeKeyDown: handleEscapeKeyDown,
      onInteractOutside: handleInteractOutside,
      ref: internalRef,
      style: {
        ...props.style,
        left: dialog.draggable ? `${position.x}px` : void 0,
        top: dialog.draggable ? `${position.y}px` : void 0
      }
    },
    /* @__PURE__ */ React.createElement("div", { className: containerClassName, "data-taco": "dialog" }, output, dialog.draggable && /* @__PURE__ */ React.createElement(
      "div",
      {
        ...dragHandleProps,
        role: "button",
        draggable: true,
        "aria-grabbed": dragging,
        "aria-label": texts.dialog.drag,
        className: "yt-dialog__drag absolute-center-x bg-grey-100 top-1.5 h-3 w-24 cursor-move rounded text-center print:hidden"
      }
    ), dialog.showCloseButton ? /* @__PURE__ */ React.createElement($5d3850c4d0b4e6c7$export$f39c2d165cd861fe, { onClick: dialog.onClose, asChild: true }, /* @__PURE__ */ React.createElement(
      IconButton,
      {
        appearance: "discrete",
        "aria-label": texts.dialog.close,
        className: "absolute right-0 top-0 mr-2 mt-2 print:hidden",
        icon: "close"
      }
    )) : null),
    dialog.elements.drawer,
    dialog.elements.extra
  ))));
});
var defaultEnvironment = "production";
var env = typeof process === "undefined" || process.env === void 0 ? defaultEnvironment : process.env.NODE_ENV || defaultEnvironment;
var createDefinition = function(propNames) {
  return {
    isEnabled: function(props) {
      return propNames.some(function(name) {
        return !!props[name];
      });
    }
  };
};
var featureDefinitions = {
  measureLayout: createDefinition(["layout", "layoutId", "drag"]),
  animation: createDefinition([
    "animate",
    "exit",
    "variants",
    "whileHover",
    "whileTap",
    "whileFocus",
    "whileDrag",
    "whileInView"
  ]),
  exit: createDefinition(["exit"]),
  drag: createDefinition(["drag", "dragControls"]),
  focus: createDefinition(["whileFocus"]),
  hover: createDefinition(["whileHover", "onHoverStart", "onHoverEnd"]),
  tap: createDefinition(["whileTap", "onTap", "onTapStart", "onTapCancel"]),
  pan: createDefinition([
    "onPan",
    "onPanStart",
    "onPanSessionStart",
    "onPanEnd"
  ]),
  inView: createDefinition([
    "whileInView",
    "onViewportEnter",
    "onViewportLeave"
  ])
};
function loadFeatures(features) {
  for (var key in features) {
    if (features[key] === null)
      continue;
    if (key === "projectionNodeConstructor") {
      featureDefinitions.projectionNodeConstructor = features[key];
    } else {
      featureDefinitions[key].Component = features[key];
    }
  }
}
var warning = function() {
};
var invariant$1 = function() {
};
if (process.env.NODE_ENV !== "production") {
  warning = function(check, message) {
    if (!check && typeof console !== "undefined") {
      console.warn(message);
    }
  };
  invariant$1 = function(check, message) {
    if (!check) {
      throw new Error(message);
    }
  };
}
var LazyContext = createContext({ strict: false });
var featureNames = Object.keys(featureDefinitions);
var numFeatures = featureNames.length;
function useFeatures(props, visualElement2, preloadedFeatures) {
  var features = [];
  var lazyContext = useContext(LazyContext);
  if (!visualElement2)
    return null;
  if (env !== "production" && preloadedFeatures && lazyContext.strict) {
    invariant$1(false, "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.");
  }
  for (var i3 = 0; i3 < numFeatures; i3++) {
    var name_1 = featureNames[i3];
    var _a = featureDefinitions[name_1], isEnabled = _a.isEnabled, Component2 = _a.Component;
    if (isEnabled(props) && Component2) {
      features.push(React.createElement(Component2, __assign$1({ key: name_1 }, props, { visualElement: visualElement2 })));
    }
  }
  return features;
}
var MotionConfigContext = createContext({
  transformPagePoint: function(p2) {
    return p2;
  },
  isStatic: false,
  reducedMotion: "never"
});
var MotionContext = createContext({});
function useVisualElementContext() {
  return useContext(MotionContext).visualElement;
}
var PresenceContext = createContext(null);
var isBrowser$1 = typeof document !== "undefined";
var useIsomorphicLayoutEffect$2 = isBrowser$1 ? useLayoutEffect : useEffect;
var prefersReducedMotion = { current: null };
var hasDetected = false;
function initPrefersReducedMotion() {
  hasDetected = true;
  if (!isBrowser$1)
    return;
  if (window.matchMedia) {
    var motionMediaQuery_1 = window.matchMedia("(prefers-reduced-motion)");
    var setReducedMotionPreferences = function() {
      return prefersReducedMotion.current = motionMediaQuery_1.matches;
    };
    motionMediaQuery_1.addListener(setReducedMotionPreferences);
    setReducedMotionPreferences();
  } else {
    prefersReducedMotion.current = false;
  }
}
function useReducedMotion() {
  !hasDetected && initPrefersReducedMotion();
  var _a = __read(useState(prefersReducedMotion.current), 1), shouldReduceMotion = _a[0];
  return shouldReduceMotion;
}
function useReducedMotionConfig() {
  var reducedMotionPreference = useReducedMotion();
  var reducedMotion = useContext(MotionConfigContext).reducedMotion;
  if (reducedMotion === "never") {
    return false;
  } else if (reducedMotion === "always") {
    return true;
  } else {
    return reducedMotionPreference;
  }
}
function useVisualElement(Component2, visualState, props, createVisualElement) {
  var lazyContext = useContext(LazyContext);
  var parent = useVisualElementContext();
  var presenceContext = useContext(PresenceContext);
  var shouldReduceMotion = useReducedMotionConfig();
  var visualElementRef = useRef(void 0);
  if (!createVisualElement)
    createVisualElement = lazyContext.renderer;
  if (!visualElementRef.current && createVisualElement) {
    visualElementRef.current = createVisualElement(Component2, {
      visualState,
      parent,
      props,
      presenceId: presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.id,
      blockInitialAnimation: (presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.initial) === false,
      shouldReduceMotion
    });
  }
  var visualElement2 = visualElementRef.current;
  useIsomorphicLayoutEffect$2(function() {
    visualElement2 === null || visualElement2 === void 0 ? void 0 : visualElement2.syncRender();
  });
  useEffect(function() {
    var _a;
    (_a = visualElement2 === null || visualElement2 === void 0 ? void 0 : visualElement2.animationState) === null || _a === void 0 ? void 0 : _a.animateChanges();
  });
  useIsomorphicLayoutEffect$2(function() {
    return function() {
      return visualElement2 === null || visualElement2 === void 0 ? void 0 : visualElement2.notifyUnmount();
    };
  }, []);
  return visualElement2;
}
function isRefObject(ref) {
  return typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}
function useMotionRef(visualState, visualElement2, externalRef) {
  return useCallback(
    function(instance) {
      var _a;
      instance && ((_a = visualState.mount) === null || _a === void 0 ? void 0 : _a.call(visualState, instance));
      if (visualElement2) {
        instance ? visualElement2.mount(instance) : visualElement2.unmount();
      }
      if (externalRef) {
        if (typeof externalRef === "function") {
          externalRef(instance);
        } else if (isRefObject(externalRef)) {
          externalRef.current = instance;
        }
      }
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [visualElement2]
  );
}
function isVariantLabels(v2) {
  return Array.isArray(v2);
}
function isVariantLabel(v2) {
  return typeof v2 === "string" || isVariantLabels(v2);
}
function getCurrent(visualElement2) {
  var current = {};
  visualElement2.forEachValue(function(value, key) {
    return current[key] = value.get();
  });
  return current;
}
function getVelocity$1(visualElement2) {
  var velocity = {};
  visualElement2.forEachValue(function(value, key) {
    return velocity[key] = value.getVelocity();
  });
  return velocity;
}
function resolveVariantFromProps(props, definition, custom, currentValues2, currentVelocity) {
  var _a;
  if (currentValues2 === void 0) {
    currentValues2 = {};
  }
  if (currentVelocity === void 0) {
    currentVelocity = {};
  }
  if (typeof definition === "function") {
    definition = definition(custom !== null && custom !== void 0 ? custom : props.custom, currentValues2, currentVelocity);
  }
  if (typeof definition === "string") {
    definition = (_a = props.variants) === null || _a === void 0 ? void 0 : _a[definition];
  }
  if (typeof definition === "function") {
    definition = definition(custom !== null && custom !== void 0 ? custom : props.custom, currentValues2, currentVelocity);
  }
  return definition;
}
function resolveVariant(visualElement2, definition, custom) {
  var props = visualElement2.getProps();
  return resolveVariantFromProps(props, definition, custom !== null && custom !== void 0 ? custom : props.custom, getCurrent(visualElement2), getVelocity$1(visualElement2));
}
function checkIfControllingVariants(props) {
  var _a;
  return typeof ((_a = props.animate) === null || _a === void 0 ? void 0 : _a.start) === "function" || isVariantLabel(props.initial) || isVariantLabel(props.animate) || isVariantLabel(props.whileHover) || isVariantLabel(props.whileDrag) || isVariantLabel(props.whileTap) || isVariantLabel(props.whileFocus) || isVariantLabel(props.exit);
}
function checkIfVariantNode(props) {
  return Boolean(checkIfControllingVariants(props) || props.variants);
}
function getCurrentTreeVariants(props, context) {
  if (checkIfControllingVariants(props)) {
    var initial = props.initial, animate2 = props.animate;
    return {
      initial: initial === false || isVariantLabel(initial) ? initial : void 0,
      animate: isVariantLabel(animate2) ? animate2 : void 0
    };
  }
  return props.inherit !== false ? context : {};
}
function useCreateMotionContext(props) {
  var _a = getCurrentTreeVariants(props, useContext(MotionContext)), initial = _a.initial, animate2 = _a.animate;
  return useMemo(function() {
    return { initial, animate: animate2 };
  }, [variantLabelsAsDependency(initial), variantLabelsAsDependency(animate2)]);
}
function variantLabelsAsDependency(prop) {
  return Array.isArray(prop) ? prop.join(" ") : prop;
}
function useConstant(init) {
  var ref = useRef(null);
  if (ref.current === null) {
    ref.current = init();
  }
  return ref.current;
}
var globalProjectionState = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: true,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: false
};
var id = 1;
function useProjectionId() {
  return useConstant(function() {
    if (globalProjectionState.hasEverUpdated) {
      return id++;
    }
  });
}
var LayoutGroupContext = createContext({});
var SwitchLayoutGroupContext = createContext({});
function useProjection(projectionId, _a, visualElement2, ProjectionNodeConstructor) {
  var _b;
  var layoutId = _a.layoutId, layout = _a.layout, drag2 = _a.drag, dragConstraints = _a.dragConstraints, layoutScroll = _a.layoutScroll;
  var initialPromotionConfig = useContext(SwitchLayoutGroupContext);
  if (!ProjectionNodeConstructor || !visualElement2 || (visualElement2 === null || visualElement2 === void 0 ? void 0 : visualElement2.projection)) {
    return;
  }
  visualElement2.projection = new ProjectionNodeConstructor(projectionId, visualElement2.getLatestValues(), (_b = visualElement2.parent) === null || _b === void 0 ? void 0 : _b.projection);
  visualElement2.projection.setOptions({
    layoutId,
    layout,
    alwaysMeasureLayout: Boolean(drag2) || dragConstraints && isRefObject(dragConstraints),
    visualElement: visualElement2,
    scheduleRender: function() {
      return visualElement2.scheduleRender();
    },
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof layout === "string" ? layout : "both",
    initialPromotionConfig,
    layoutScroll
  });
}
var VisualElementHandler = (
  /** @class */
  function(_super) {
    __extends(VisualElementHandler2, _super);
    function VisualElementHandler2() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    VisualElementHandler2.prototype.getSnapshotBeforeUpdate = function() {
      this.updateProps();
      return null;
    };
    VisualElementHandler2.prototype.componentDidUpdate = function() {
    };
    VisualElementHandler2.prototype.updateProps = function() {
      var _a = this.props, visualElement2 = _a.visualElement, props = _a.props;
      if (visualElement2)
        visualElement2.setProps(props);
    };
    VisualElementHandler2.prototype.render = function() {
      return this.props.children;
    };
    return VisualElementHandler2;
  }(React__default.Component)
);
function createMotionComponent(_a) {
  var preloadedFeatures = _a.preloadedFeatures, createVisualElement = _a.createVisualElement, projectionNodeConstructor = _a.projectionNodeConstructor, useRender = _a.useRender, useVisualState = _a.useVisualState, Component2 = _a.Component;
  preloadedFeatures && loadFeatures(preloadedFeatures);
  function MotionComponent(props, externalRef) {
    var layoutId = useLayoutId(props);
    props = __assign$1(__assign$1({}, props), { layoutId });
    var config2 = useContext(MotionConfigContext);
    var features = null;
    var context = useCreateMotionContext(props);
    var projectionId = config2.isStatic ? void 0 : useProjectionId();
    var visualState = useVisualState(props, config2.isStatic);
    if (!config2.isStatic && isBrowser$1) {
      context.visualElement = useVisualElement(Component2, visualState, __assign$1(__assign$1({}, config2), props), createVisualElement);
      useProjection(projectionId, props, context.visualElement, projectionNodeConstructor || featureDefinitions.projectionNodeConstructor);
      features = useFeatures(props, context.visualElement, preloadedFeatures);
    }
    return React.createElement(
      VisualElementHandler,
      { visualElement: context.visualElement, props: __assign$1(__assign$1({}, config2), props) },
      features,
      React.createElement(MotionContext.Provider, { value: context }, useRender(Component2, props, projectionId, useMotionRef(visualState, context.visualElement, externalRef), visualState, config2.isStatic, context.visualElement))
    );
  }
  return forwardRef(MotionComponent);
}
function useLayoutId(_a) {
  var _b;
  var layoutId = _a.layoutId;
  var layoutGroupId = (_b = useContext(LayoutGroupContext)) === null || _b === void 0 ? void 0 : _b.id;
  return layoutGroupId && layoutId !== void 0 ? layoutGroupId + "-" + layoutId : layoutId;
}
function createMotionProxy(createConfig) {
  function custom(Component2, customMotionComponentConfig) {
    if (customMotionComponentConfig === void 0) {
      customMotionComponentConfig = {};
    }
    return createMotionComponent(createConfig(Component2, customMotionComponentConfig));
  }
  if (typeof Proxy === "undefined") {
    return custom;
  }
  var componentCache = /* @__PURE__ */ new Map();
  return new Proxy(custom, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: function(_target, key) {
      if (!componentCache.has(key)) {
        componentCache.set(key, custom(key));
      }
      return componentCache.get(key);
    }
  });
}
var lowercaseSVGElements = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "svg",
  "switch",
  "symbol",
  "text",
  "tspan",
  "use",
  "view"
];
function isSVGComponent(Component2) {
  if (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof Component2 !== "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    Component2.includes("-")
  ) {
    return false;
  } else if (
    /**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */
    lowercaseSVGElements.indexOf(Component2) > -1 || /**
     * If it contains a capital letter, it's an SVG component
     */
    /[A-Z]/.test(Component2)
  ) {
    return true;
  }
  return false;
}
var scaleCorrectors = {};
function addScaleCorrector(correctors) {
  Object.assign(scaleCorrectors, correctors);
}
var transformAxes = ["", "X", "Y", "Z"];
var order = ["translate", "scale", "rotate", "skew"];
var transformProps = ["transformPerspective", "x", "y", "z"];
order.forEach(function(operationKey) {
  return transformAxes.forEach(function(axesKey) {
    return transformProps.push(operationKey + axesKey);
  });
});
function sortTransformProps(a4, b3) {
  return transformProps.indexOf(a4) - transformProps.indexOf(b3);
}
var transformPropSet = new Set(transformProps);
function isTransformProp(key) {
  return transformPropSet.has(key);
}
var transformOriginProps = /* @__PURE__ */ new Set(["originX", "originY", "originZ"]);
function isTransformOriginProp(key) {
  return transformOriginProps.has(key);
}
function isForcedMotionValue(key, _a) {
  var layout = _a.layout, layoutId = _a.layoutId;
  return isTransformProp(key) || isTransformOriginProp(key) || (layout || layoutId !== void 0) && (!!scaleCorrectors[key] || key === "opacity");
}
var isMotionValue = function(value) {
  return Boolean(value !== null && typeof value === "object" && value.getVelocity);
};
var translateAlias = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
};
function buildTransform(_a, _b, transformIsDefault, transformTemplate) {
  var transform = _a.transform, transformKeys2 = _a.transformKeys;
  var _c = _b.enableHardwareAcceleration, enableHardwareAcceleration = _c === void 0 ? true : _c, _d = _b.allowTransformNone, allowTransformNone = _d === void 0 ? true : _d;
  var transformString = "";
  transformKeys2.sort(sortTransformProps);
  var transformHasZ = false;
  var numTransformKeys = transformKeys2.length;
  for (var i3 = 0; i3 < numTransformKeys; i3++) {
    var key = transformKeys2[i3];
    transformString += "".concat(translateAlias[key] || key, "(").concat(transform[key], ") ");
    if (key === "z")
      transformHasZ = true;
  }
  if (!transformHasZ && enableHardwareAcceleration) {
    transformString += "translateZ(0)";
  } else {
    transformString = transformString.trim();
  }
  if (transformTemplate) {
    transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
  } else if (allowTransformNone && transformIsDefault) {
    transformString = "none";
  }
  return transformString;
}
function buildTransformOrigin(_a) {
  var _b = _a.originX, originX = _b === void 0 ? "50%" : _b, _c = _a.originY, originY = _c === void 0 ? "50%" : _c, _d = _a.originZ, originZ = _d === void 0 ? 0 : _d;
  return "".concat(originX, " ").concat(originY, " ").concat(originZ);
}
function isCSSVariable$1(key) {
  return key.startsWith("--");
}
var getValueAsType = function(value, type) {
  return type && typeof value === "number" ? type.transform(value) : value;
};
const clamp$1 = (min2, max2) => (v2) => Math.max(Math.min(v2, max2), min2);
const sanitize = (v2) => v2 % 1 ? Number(v2.toFixed(5)) : v2;
const floatRegex = /(-)?([\d]*\.?[\d])+/g;
const colorRegex = /(#[0-9a-f]{6}|#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))/gi;
const singleColorRegex = /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))$/i;
function isString$1(v2) {
  return typeof v2 === "string";
}
const number$3 = {
  test: (v2) => typeof v2 === "number",
  parse: parseFloat,
  transform: (v2) => v2
};
const alpha$1 = Object.assign(Object.assign({}, number$3), { transform: clamp$1(0, 1) });
const scale = Object.assign(Object.assign({}, number$3), { default: 1 });
const createUnitType = (unit2) => ({
  test: (v2) => isString$1(v2) && v2.endsWith(unit2) && v2.split(" ").length === 1,
  parse: parseFloat,
  transform: (v2) => `${v2}${unit2}`
});
const degrees = createUnitType("deg");
const percent = createUnitType("%");
const px = createUnitType("px");
const vh = createUnitType("vh");
const vw = createUnitType("vw");
const progressPercentage = Object.assign(Object.assign({}, percent), { parse: (v2) => percent.parse(v2) / 100, transform: (v2) => percent.transform(v2 * 100) });
const isColorString = (type, testProp) => (v2) => {
  return Boolean(isString$1(v2) && singleColorRegex.test(v2) && v2.startsWith(type) || testProp && Object.prototype.hasOwnProperty.call(v2, testProp));
};
const splitColor = (aName, bName, cName) => (v2) => {
  if (!isString$1(v2))
    return v2;
  const [a4, b3, c3, alpha3] = v2.match(floatRegex);
  return {
    [aName]: parseFloat(a4),
    [bName]: parseFloat(b3),
    [cName]: parseFloat(c3),
    alpha: alpha3 !== void 0 ? parseFloat(alpha3) : 1
  };
};
const hsla$1 = {
  test: isColorString("hsl", "hue"),
  parse: splitColor("hue", "saturation", "lightness"),
  transform: ({ hue, saturation, lightness, alpha: alpha$1$1 = 1 }) => {
    return "hsla(" + Math.round(hue) + ", " + percent.transform(sanitize(saturation)) + ", " + percent.transform(sanitize(lightness)) + ", " + sanitize(alpha$1.transform(alpha$1$1)) + ")";
  }
};
const clampRgbUnit = clamp$1(0, 255);
const rgbUnit = Object.assign(Object.assign({}, number$3), { transform: (v2) => Math.round(clampRgbUnit(v2)) });
const rgba$1 = {
  test: isColorString("rgb", "red"),
  parse: splitColor("red", "green", "blue"),
  transform: ({ red, green, blue, alpha: alpha$1$1 = 1 }) => "rgba(" + rgbUnit.transform(red) + ", " + rgbUnit.transform(green) + ", " + rgbUnit.transform(blue) + ", " + sanitize(alpha$1.transform(alpha$1$1)) + ")"
};
function parseHex(v2) {
  let r2 = "";
  let g2 = "";
  let b3 = "";
  let a4 = "";
  if (v2.length > 5) {
    r2 = v2.substr(1, 2);
    g2 = v2.substr(3, 2);
    b3 = v2.substr(5, 2);
    a4 = v2.substr(7, 2);
  } else {
    r2 = v2.substr(1, 1);
    g2 = v2.substr(2, 1);
    b3 = v2.substr(3, 1);
    a4 = v2.substr(4, 1);
    r2 += r2;
    g2 += g2;
    b3 += b3;
    a4 += a4;
  }
  return {
    red: parseInt(r2, 16),
    green: parseInt(g2, 16),
    blue: parseInt(b3, 16),
    alpha: a4 ? parseInt(a4, 16) / 255 : 1
  };
}
const hex$1 = {
  test: isColorString("#"),
  parse: parseHex,
  transform: rgba$1.transform
};
const color$1 = {
  test: (v2) => rgba$1.test(v2) || hex$1.test(v2) || hsla$1.test(v2),
  parse: (v2) => {
    if (rgba$1.test(v2)) {
      return rgba$1.parse(v2);
    } else if (hsla$1.test(v2)) {
      return hsla$1.parse(v2);
    } else {
      return hex$1.parse(v2);
    }
  },
  transform: (v2) => {
    return isString$1(v2) ? v2 : v2.hasOwnProperty("red") ? rgba$1.transform(v2) : hsla$1.transform(v2);
  }
};
const colorToken = "${c}";
const numberToken = "${n}";
function test(v2) {
  var _a, _b, _c, _d;
  return isNaN(v2) && isString$1(v2) && ((_b = (_a = v2.match(floatRegex)) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) + ((_d = (_c = v2.match(colorRegex)) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0) > 0;
}
function analyse$1(v2) {
  if (typeof v2 === "number")
    v2 = `${v2}`;
  const values = [];
  let numColors = 0;
  const colors2 = v2.match(colorRegex);
  if (colors2) {
    numColors = colors2.length;
    v2 = v2.replace(colorRegex, colorToken);
    values.push(...colors2.map(color$1.parse));
  }
  const numbers2 = v2.match(floatRegex);
  if (numbers2) {
    v2 = v2.replace(floatRegex, numberToken);
    values.push(...numbers2.map(number$3.parse));
  }
  return { values, numColors, tokenised: v2 };
}
function parse(v2) {
  return analyse$1(v2).values;
}
function createTransformer(v2) {
  const { values, numColors, tokenised } = analyse$1(v2);
  const numValues = values.length;
  return (v3) => {
    let output = tokenised;
    for (let i3 = 0; i3 < numValues; i3++) {
      output = output.replace(i3 < numColors ? colorToken : numberToken, i3 < numColors ? color$1.transform(v3[i3]) : sanitize(v3[i3]));
    }
    return output;
  };
}
const convertNumbersToZero = (v2) => typeof v2 === "number" ? 0 : v2;
function getAnimatableNone$1(v2) {
  const parsed = parse(v2);
  const transformer2 = createTransformer(v2);
  return transformer2(parsed.map(convertNumbersToZero));
}
const complex = { test, parse, createTransformer, getAnimatableNone: getAnimatableNone$1 };
const maxDefaults = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function applyDefaultFilter(v2) {
  let [name, value] = v2.slice(0, -1).split("(");
  if (name === "drop-shadow")
    return v2;
  const [number2] = value.match(floatRegex) || [];
  if (!number2)
    return v2;
  const unit2 = value.replace(number2, "");
  let defaultValue2 = maxDefaults.has(name) ? 1 : 0;
  if (number2 !== value)
    defaultValue2 *= 100;
  return name + "(" + defaultValue2 + unit2 + ")";
}
const functionRegex = /([a-z-]*)\(.*?\)/g;
const filter = Object.assign(Object.assign({}, complex), { getAnimatableNone: (v2) => {
  const functions = v2.match(functionRegex);
  return functions ? functions.map(applyDefaultFilter).join(" ") : v2;
} });
var int = __assign$1(__assign$1({}, number$3), { transform: Math.round });
var numberValueTypes = {
  // Border props
  borderWidth: px,
  borderTopWidth: px,
  borderRightWidth: px,
  borderBottomWidth: px,
  borderLeftWidth: px,
  borderRadius: px,
  radius: px,
  borderTopLeftRadius: px,
  borderTopRightRadius: px,
  borderBottomRightRadius: px,
  borderBottomLeftRadius: px,
  // Positioning props
  width: px,
  maxWidth: px,
  height: px,
  maxHeight: px,
  size: px,
  top: px,
  right: px,
  bottom: px,
  left: px,
  // Spacing props
  padding: px,
  paddingTop: px,
  paddingRight: px,
  paddingBottom: px,
  paddingLeft: px,
  margin: px,
  marginTop: px,
  marginRight: px,
  marginBottom: px,
  marginLeft: px,
  // Transform props
  rotate: degrees,
  rotateX: degrees,
  rotateY: degrees,
  rotateZ: degrees,
  scale,
  scaleX: scale,
  scaleY: scale,
  scaleZ: scale,
  skew: degrees,
  skewX: degrees,
  skewY: degrees,
  distance: px,
  translateX: px,
  translateY: px,
  translateZ: px,
  x: px,
  y: px,
  z: px,
  perspective: px,
  transformPerspective: px,
  opacity: alpha$1,
  originX: progressPercentage,
  originY: progressPercentage,
  originZ: px,
  // Misc
  zIndex: int,
  // SVG
  fillOpacity: alpha$1,
  strokeOpacity: alpha$1,
  numOctaves: int
};
function buildHTMLStyles(state, latestValues, options, transformTemplate) {
  var _a;
  var style = state.style, vars = state.vars, transform = state.transform, transformKeys2 = state.transformKeys, transformOrigin = state.transformOrigin;
  transformKeys2.length = 0;
  var hasTransform2 = false;
  var hasTransformOrigin = false;
  var transformIsNone = true;
  for (var key in latestValues) {
    var value = latestValues[key];
    if (isCSSVariable$1(key)) {
      vars[key] = value;
      continue;
    }
    var valueType = numberValueTypes[key];
    var valueAsType = getValueAsType(value, valueType);
    if (isTransformProp(key)) {
      hasTransform2 = true;
      transform[key] = valueAsType;
      transformKeys2.push(key);
      if (!transformIsNone)
        continue;
      if (value !== ((_a = valueType.default) !== null && _a !== void 0 ? _a : 0))
        transformIsNone = false;
    } else if (isTransformOriginProp(key)) {
      transformOrigin[key] = valueAsType;
      hasTransformOrigin = true;
    } else {
      style[key] = valueAsType;
    }
  }
  if (hasTransform2) {
    style.transform = buildTransform(state, options, transformIsNone, transformTemplate);
  } else if (transformTemplate) {
    style.transform = transformTemplate({}, "");
  } else if (!latestValues.transform && style.transform) {
    style.transform = "none";
  }
  if (hasTransformOrigin) {
    style.transformOrigin = buildTransformOrigin(transformOrigin);
  }
}
var createHtmlRenderState = function() {
  return {
    style: {},
    transform: {},
    transformKeys: [],
    transformOrigin: {},
    vars: {}
  };
};
function copyRawValuesOnly(target, source, props) {
  for (var key in source) {
    if (!isMotionValue(source[key]) && !isForcedMotionValue(key, props)) {
      target[key] = source[key];
    }
  }
}
function useInitialMotionValues(_a, visualState, isStatic) {
  var transformTemplate = _a.transformTemplate;
  return useMemo(function() {
    var state = createHtmlRenderState();
    buildHTMLStyles(state, visualState, { enableHardwareAcceleration: !isStatic }, transformTemplate);
    var vars = state.vars, style = state.style;
    return __assign$1(__assign$1({}, vars), style);
  }, [visualState]);
}
function useStyle(props, visualState, isStatic) {
  var styleProp = props.style || {};
  var style = {};
  copyRawValuesOnly(style, styleProp, props);
  Object.assign(style, useInitialMotionValues(props, visualState, isStatic));
  if (props.transformValues) {
    style = props.transformValues(style);
  }
  return style;
}
function useHTMLProps(props, visualState, isStatic) {
  var htmlProps = {};
  var style = useStyle(props, visualState, isStatic);
  if (Boolean(props.drag) && props.dragListener !== false) {
    htmlProps.draggable = false;
    style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
    style.touchAction = props.drag === true ? "none" : "pan-".concat(props.drag === "x" ? "y" : "x");
  }
  htmlProps.style = style;
  return htmlProps;
}
var validMotionProps = /* @__PURE__ */ new Set([
  "initial",
  "animate",
  "exit",
  "style",
  "variants",
  "transition",
  "transformTemplate",
  "transformValues",
  "custom",
  "inherit",
  "layout",
  "layoutId",
  "layoutDependency",
  "onLayoutAnimationStart",
  "onLayoutAnimationComplete",
  "onLayoutMeasure",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "drag",
  "dragControls",
  "dragListener",
  "dragConstraints",
  "dragDirectionLock",
  "dragSnapToOrigin",
  "_dragX",
  "_dragY",
  "dragElastic",
  "dragMomentum",
  "dragPropagation",
  "dragTransition",
  "whileDrag",
  "onPan",
  "onPanStart",
  "onPanEnd",
  "onPanSessionStart",
  "onTap",
  "onTapStart",
  "onTapCancel",
  "onHoverStart",
  "onHoverEnd",
  "whileFocus",
  "whileTap",
  "whileHover",
  "whileInView",
  "onViewportEnter",
  "onViewportLeave",
  "viewport",
  "layoutScroll"
]);
function isValidMotionProp(key) {
  return validMotionProps.has(key);
}
var shouldForward = function(key) {
  return !isValidMotionProp(key);
};
function loadExternalIsValidProp(isValidProp) {
  if (!isValidProp)
    return;
  shouldForward = function(key) {
    return key.startsWith("on") ? !isValidMotionProp(key) : isValidProp(key);
  };
}
try {
  loadExternalIsValidProp(require("@emotion/is-prop-valid").default);
} catch (_a) {
}
function filterProps$1(props, isDom, forwardMotionProps) {
  var filteredProps = {};
  for (var key in props) {
    if (shouldForward(key) || forwardMotionProps === true && isValidMotionProp(key) || !isDom && !isValidMotionProp(key) || // If trying to use native HTML drag events, forward drag listeners
    props["draggable"] && key.startsWith("onDrag")) {
      filteredProps[key] = props[key];
    }
  }
  return filteredProps;
}
function calcOrigin$1(origin, offset2, size2) {
  return typeof origin === "string" ? origin : px.transform(offset2 + size2 * origin);
}
function calcSVGTransformOrigin(dimensions, originX, originY) {
  var pxOriginX = calcOrigin$1(originX, dimensions.x, dimensions.width);
  var pxOriginY = calcOrigin$1(originY, dimensions.y, dimensions.height);
  return "".concat(pxOriginX, " ").concat(pxOriginY);
}
var camelKeys = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function buildSVGPath(attrs, length, spacing, offset2, useDashCase) {
  if (spacing === void 0) {
    spacing = 1;
  }
  if (offset2 === void 0) {
    offset2 = 0;
  }
  attrs.pathLength = 1;
  var keys2 = camelKeys;
  attrs[keys2.offset] = px.transform(-offset2);
  var pathLength = px.transform(length);
  var pathSpacing = px.transform(spacing);
  attrs[keys2.array] = "".concat(pathLength, " ").concat(pathSpacing);
}
function buildSVGAttrs(state, _a, options, transformTemplate) {
  var attrX = _a.attrX, attrY = _a.attrY, originX = _a.originX, originY = _a.originY, pathLength = _a.pathLength, _b = _a.pathSpacing, pathSpacing = _b === void 0 ? 1 : _b, _c = _a.pathOffset, pathOffset = _c === void 0 ? 0 : _c, latest = __rest$1(_a, ["attrX", "attrY", "originX", "originY", "pathLength", "pathSpacing", "pathOffset"]);
  buildHTMLStyles(state, latest, options, transformTemplate);
  state.attrs = state.style;
  state.style = {};
  var attrs = state.attrs, style = state.style, dimensions = state.dimensions;
  if (attrs.transform) {
    if (dimensions)
      style.transform = attrs.transform;
    delete attrs.transform;
  }
  if (dimensions && (originX !== void 0 || originY !== void 0 || style.transform)) {
    style.transformOrigin = calcSVGTransformOrigin(dimensions, originX !== void 0 ? originX : 0.5, originY !== void 0 ? originY : 0.5);
  }
  if (attrX !== void 0)
    attrs.x = attrX;
  if (attrY !== void 0)
    attrs.y = attrY;
  if (pathLength !== void 0) {
    buildSVGPath(attrs, pathLength, pathSpacing, pathOffset);
  }
}
var createSvgRenderState = function() {
  return __assign$1(__assign$1({}, createHtmlRenderState()), { attrs: {} });
};
function useSVGProps(props, visualState) {
  var visualProps = useMemo(function() {
    var state = createSvgRenderState();
    buildSVGAttrs(state, visualState, { enableHardwareAcceleration: false }, props.transformTemplate);
    return __assign$1(__assign$1({}, state.attrs), { style: __assign$1({}, state.style) });
  }, [visualState]);
  if (props.style) {
    var rawStyles = {};
    copyRawValuesOnly(rawStyles, props.style, props);
    visualProps.style = __assign$1(__assign$1({}, rawStyles), visualProps.style);
  }
  return visualProps;
}
function createUseRender(forwardMotionProps) {
  if (forwardMotionProps === void 0) {
    forwardMotionProps = false;
  }
  var useRender = function(Component2, props, projectionId, ref, _a, isStatic) {
    var latestValues = _a.latestValues;
    var useVisualProps = isSVGComponent(Component2) ? useSVGProps : useHTMLProps;
    var visualProps = useVisualProps(props, latestValues, isStatic);
    var filteredProps = filterProps$1(props, typeof Component2 === "string", forwardMotionProps);
    var elementProps = __assign$1(__assign$1(__assign$1({}, filteredProps), visualProps), { ref });
    if (projectionId) {
      elementProps["data-projection-id"] = projectionId;
    }
    return createElement(Component2, elementProps);
  };
  return useRender;
}
var CAMEL_CASE_PATTERN = /([a-z])([A-Z])/g;
var REPLACE_TEMPLATE = "$1-$2";
var camelToDash = function(str) {
  return str.replace(CAMEL_CASE_PATTERN, REPLACE_TEMPLATE).toLowerCase();
};
function renderHTML(element, _a, styleProp, projection) {
  var style = _a.style, vars = _a.vars;
  Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
  for (var key in vars) {
    element.style.setProperty(key, vars[key]);
  }
}
var camelCaseAttributes = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength"
]);
function renderSVG(element, renderState, _styleProp, projection) {
  renderHTML(element, renderState, void 0, projection);
  for (var key in renderState.attrs) {
    element.setAttribute(!camelCaseAttributes.has(key) ? camelToDash(key) : key, renderState.attrs[key]);
  }
}
function scrapeMotionValuesFromProps$1(props) {
  var style = props.style;
  var newValues = {};
  for (var key in style) {
    if (isMotionValue(style[key]) || isForcedMotionValue(key, props)) {
      newValues[key] = style[key];
    }
  }
  return newValues;
}
function scrapeMotionValuesFromProps(props) {
  var newValues = scrapeMotionValuesFromProps$1(props);
  for (var key in props) {
    if (isMotionValue(props[key])) {
      var targetKey = key === "x" || key === "y" ? "attr" + key.toUpperCase() : key;
      newValues[targetKey] = props[key];
    }
  }
  return newValues;
}
function isAnimationControls(v2) {
  return typeof v2 === "object" && typeof v2.start === "function";
}
var isKeyframesTarget = function(v2) {
  return Array.isArray(v2);
};
var isCustomValue = function(v2) {
  return Boolean(v2 && typeof v2 === "object" && v2.mix && v2.toValue);
};
var resolveFinalValueInKeyframes = function(v2) {
  return isKeyframesTarget(v2) ? v2[v2.length - 1] || 0 : v2;
};
function resolveMotionValue(value) {
  var unwrappedValue = isMotionValue(value) ? value.get() : value;
  return isCustomValue(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}
function makeState(_a, props, context, presenceContext) {
  var scrapeMotionValuesFromProps2 = _a.scrapeMotionValuesFromProps, createRenderState = _a.createRenderState, onMount = _a.onMount;
  var state = {
    latestValues: makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps2),
    renderState: createRenderState()
  };
  if (onMount) {
    state.mount = function(instance) {
      return onMount(props, instance, state);
    };
  }
  return state;
}
var makeUseVisualState = function(config2) {
  return function(props, isStatic) {
    var context = useContext(MotionContext);
    var presenceContext = useContext(PresenceContext);
    return isStatic ? makeState(config2, props, context, presenceContext) : useConstant(function() {
      return makeState(config2, props, context, presenceContext);
    });
  };
};
function makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
  var values = {};
  var blockInitialAnimation = (presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.initial) === false;
  var motionValues = scrapeMotionValues(props);
  for (var key in motionValues) {
    values[key] = resolveMotionValue(motionValues[key]);
  }
  var initial = props.initial, animate2 = props.animate;
  var isControllingVariants = checkIfControllingVariants(props);
  var isVariantNode = checkIfVariantNode(props);
  if (context && isVariantNode && !isControllingVariants && props.inherit !== false) {
    initial !== null && initial !== void 0 ? initial : initial = context.initial;
    animate2 !== null && animate2 !== void 0 ? animate2 : animate2 = context.animate;
  }
  var initialAnimationIsBlocked = blockInitialAnimation || initial === false;
  var variantToSet = initialAnimationIsBlocked ? animate2 : initial;
  if (variantToSet && typeof variantToSet !== "boolean" && !isAnimationControls(variantToSet)) {
    var list = Array.isArray(variantToSet) ? variantToSet : [variantToSet];
    list.forEach(function(definition) {
      var resolved = resolveVariantFromProps(props, definition);
      if (!resolved)
        return;
      var transitionEnd = resolved.transitionEnd;
      resolved.transition;
      var target = __rest$1(resolved, ["transitionEnd", "transition"]);
      for (var key2 in target) {
        var valueTarget = target[key2];
        if (Array.isArray(valueTarget)) {
          var index2 = initialAnimationIsBlocked ? valueTarget.length - 1 : 0;
          valueTarget = valueTarget[index2];
        }
        if (valueTarget !== null) {
          values[key2] = valueTarget;
        }
      }
      for (var key2 in transitionEnd)
        values[key2] = transitionEnd[key2];
    });
  }
  return values;
}
var svgMotionConfig = {
  useVisualState: makeUseVisualState({
    scrapeMotionValuesFromProps,
    createRenderState: createSvgRenderState,
    onMount: function(props, instance, _a) {
      var renderState = _a.renderState, latestValues = _a.latestValues;
      try {
        renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
      } catch (e3) {
        renderState.dimensions = {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        };
      }
      buildSVGAttrs(renderState, latestValues, { enableHardwareAcceleration: false }, props.transformTemplate);
      renderSVG(instance, renderState);
    }
  })
};
var htmlMotionConfig = {
  useVisualState: makeUseVisualState({
    scrapeMotionValuesFromProps: scrapeMotionValuesFromProps$1,
    createRenderState: createHtmlRenderState
  })
};
function createDomMotionConfig(Component2, _a, preloadedFeatures, createVisualElement, projectionNodeConstructor) {
  var _b = _a.forwardMotionProps, forwardMotionProps = _b === void 0 ? false : _b;
  var baseConfig = isSVGComponent(Component2) ? svgMotionConfig : htmlMotionConfig;
  return __assign$1(__assign$1({}, baseConfig), { preloadedFeatures, useRender: createUseRender(forwardMotionProps), createVisualElement, projectionNodeConstructor, Component: Component2 });
}
var AnimationType;
(function(AnimationType2) {
  AnimationType2["Animate"] = "animate";
  AnimationType2["Hover"] = "whileHover";
  AnimationType2["Tap"] = "whileTap";
  AnimationType2["Drag"] = "whileDrag";
  AnimationType2["Focus"] = "whileFocus";
  AnimationType2["InView"] = "whileInView";
  AnimationType2["Exit"] = "exit";
})(AnimationType || (AnimationType = {}));
function addDomEvent(target, eventName, handler, options) {
  if (options === void 0) {
    options = { passive: true };
  }
  target.addEventListener(eventName, handler, options);
  return function() {
    return target.removeEventListener(eventName, handler);
  };
}
function useDomEvent(ref, eventName, handler, options) {
  useEffect(function() {
    var element = ref.current;
    if (handler && element) {
      return addDomEvent(element, eventName, handler, options);
    }
  }, [ref, eventName, handler, options]);
}
function useFocusGesture(_a) {
  var whileFocus = _a.whileFocus, visualElement2 = _a.visualElement;
  var onFocus = function() {
    var _a2;
    (_a2 = visualElement2.animationState) === null || _a2 === void 0 ? void 0 : _a2.setActive(AnimationType.Focus, true);
  };
  var onBlur = function() {
    var _a2;
    (_a2 = visualElement2.animationState) === null || _a2 === void 0 ? void 0 : _a2.setActive(AnimationType.Focus, false);
  };
  useDomEvent(visualElement2, "focus", whileFocus ? onFocus : void 0);
  useDomEvent(visualElement2, "blur", whileFocus ? onBlur : void 0);
}
function isMouseEvent(event) {
  if (typeof PointerEvent !== "undefined" && event instanceof PointerEvent) {
    return !!(event.pointerType === "mouse");
  }
  return event instanceof MouseEvent;
}
function isTouchEvent$1(event) {
  var hasTouches = !!event.touches;
  return hasTouches;
}
function filterPrimaryPointer(eventHandler) {
  return function(event) {
    var isMouseEvent2 = event instanceof MouseEvent;
    var isPrimaryPointer = !isMouseEvent2 || isMouseEvent2 && event.button === 0;
    if (isPrimaryPointer) {
      eventHandler(event);
    }
  };
}
var defaultPagePoint = { pageX: 0, pageY: 0 };
function pointFromTouch(e3, pointType) {
  if (pointType === void 0) {
    pointType = "page";
  }
  var primaryTouch = e3.touches[0] || e3.changedTouches[0];
  var point2 = primaryTouch || defaultPagePoint;
  return {
    x: point2[pointType + "X"],
    y: point2[pointType + "Y"]
  };
}
function pointFromMouse(point2, pointType) {
  if (pointType === void 0) {
    pointType = "page";
  }
  return {
    x: point2[pointType + "X"],
    y: point2[pointType + "Y"]
  };
}
function extractEventInfo(event, pointType) {
  if (pointType === void 0) {
    pointType = "page";
  }
  return {
    point: isTouchEvent$1(event) ? pointFromTouch(event, pointType) : pointFromMouse(event, pointType)
  };
}
var wrapHandler = function(handler, shouldFilterPrimaryPointer) {
  if (shouldFilterPrimaryPointer === void 0) {
    shouldFilterPrimaryPointer = false;
  }
  var listener = function(event) {
    return handler(event, extractEventInfo(event));
  };
  return shouldFilterPrimaryPointer ? filterPrimaryPointer(listener) : listener;
};
var supportsPointerEvents = function() {
  return isBrowser$1 && window.onpointerdown === null;
};
var supportsTouchEvents = function() {
  return isBrowser$1 && window.ontouchstart === null;
};
var supportsMouseEvents = function() {
  return isBrowser$1 && window.onmousedown === null;
};
var mouseEventNames = {
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointercancel: "mousecancel",
  pointerover: "mouseover",
  pointerout: "mouseout",
  pointerenter: "mouseenter",
  pointerleave: "mouseleave"
};
var touchEventNames = {
  pointerdown: "touchstart",
  pointermove: "touchmove",
  pointerup: "touchend",
  pointercancel: "touchcancel"
};
function getPointerEventName(name) {
  if (supportsPointerEvents()) {
    return name;
  } else if (supportsTouchEvents()) {
    return touchEventNames[name];
  } else if (supportsMouseEvents()) {
    return mouseEventNames[name];
  }
  return name;
}
function addPointerEvent(target, eventName, handler, options) {
  return addDomEvent(target, getPointerEventName(eventName), wrapHandler(handler, eventName === "pointerdown"), options);
}
function usePointerEvent(ref, eventName, handler, options) {
  return useDomEvent(ref, getPointerEventName(eventName), handler && wrapHandler(handler, eventName === "pointerdown"), options);
}
function createLock(name) {
  var lock = null;
  return function() {
    var openLock = function() {
      lock = null;
    };
    if (lock === null) {
      lock = name;
      return openLock;
    }
    return false;
  };
}
var globalHorizontalLock = createLock("dragHorizontal");
var globalVerticalLock = createLock("dragVertical");
function getGlobalLock(drag2) {
  var lock = false;
  if (drag2 === "y") {
    lock = globalVerticalLock();
  } else if (drag2 === "x") {
    lock = globalHorizontalLock();
  } else {
    var openHorizontal_1 = globalHorizontalLock();
    var openVertical_1 = globalVerticalLock();
    if (openHorizontal_1 && openVertical_1) {
      lock = function() {
        openHorizontal_1();
        openVertical_1();
      };
    } else {
      if (openHorizontal_1)
        openHorizontal_1();
      if (openVertical_1)
        openVertical_1();
    }
  }
  return lock;
}
function isDragActive() {
  var openGestureLock = getGlobalLock(true);
  if (!openGestureLock)
    return true;
  openGestureLock();
  return false;
}
function createHoverEvent(visualElement2, isActive, callback) {
  return function(event, info) {
    var _a;
    if (!isMouseEvent(event) || isDragActive())
      return;
    (_a = visualElement2.animationState) === null || _a === void 0 ? void 0 : _a.setActive(AnimationType.Hover, isActive);
    callback === null || callback === void 0 ? void 0 : callback(event, info);
  };
}
function useHoverGesture(_a) {
  var onHoverStart = _a.onHoverStart, onHoverEnd = _a.onHoverEnd, whileHover = _a.whileHover, visualElement2 = _a.visualElement;
  usePointerEvent(visualElement2, "pointerenter", onHoverStart || whileHover ? createHoverEvent(visualElement2, true, onHoverStart) : void 0, { passive: !onHoverStart });
  usePointerEvent(visualElement2, "pointerleave", onHoverEnd || whileHover ? createHoverEvent(visualElement2, false, onHoverEnd) : void 0, { passive: !onHoverEnd });
}
var isNodeOrChild = function(parent, child) {
  if (!child) {
    return false;
  } else if (parent === child) {
    return true;
  } else {
    return isNodeOrChild(parent, child.parentElement);
  }
};
function useUnmountEffect(callback) {
  return useEffect(function() {
    return function() {
      return callback();
    };
  }, []);
}
const clamp = (min2, max2, v2) => Math.min(Math.max(v2, min2), max2);
const safeMin = 1e-3;
const minDuration = 0.01;
const maxDuration = 10;
const minDamping = 0.05;
const maxDamping = 1;
function findSpring({ duration = 800, bounce = 0.25, velocity = 0, mass = 1 }) {
  let envelope;
  let derivative;
  warning(duration <= maxDuration * 1e3, "Spring duration must be 10 seconds or less");
  let dampingRatio = 1 - bounce;
  dampingRatio = clamp(minDamping, maxDamping, dampingRatio);
  duration = clamp(minDuration, maxDuration, duration / 1e3);
  if (dampingRatio < 1) {
    envelope = (undampedFreq2) => {
      const exponentialDecay = undampedFreq2 * dampingRatio;
      const delta = exponentialDecay * duration;
      const a4 = exponentialDecay - velocity;
      const b3 = calcAngularFreq(undampedFreq2, dampingRatio);
      const c3 = Math.exp(-delta);
      return safeMin - a4 / b3 * c3;
    };
    derivative = (undampedFreq2) => {
      const exponentialDecay = undampedFreq2 * dampingRatio;
      const delta = exponentialDecay * duration;
      const d4 = delta * velocity + velocity;
      const e3 = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq2, 2) * duration;
      const f2 = Math.exp(-delta);
      const g2 = calcAngularFreq(Math.pow(undampedFreq2, 2), dampingRatio);
      const factor = -envelope(undampedFreq2) + safeMin > 0 ? -1 : 1;
      return factor * ((d4 - e3) * f2) / g2;
    };
  } else {
    envelope = (undampedFreq2) => {
      const a4 = Math.exp(-undampedFreq2 * duration);
      const b3 = (undampedFreq2 - velocity) * duration + 1;
      return -1e-3 + a4 * b3;
    };
    derivative = (undampedFreq2) => {
      const a4 = Math.exp(-undampedFreq2 * duration);
      const b3 = (velocity - undampedFreq2) * (duration * duration);
      return a4 * b3;
    };
  }
  const initialGuess = 5 / duration;
  const undampedFreq = approximateRoot(envelope, derivative, initialGuess);
  duration = duration * 1e3;
  if (isNaN(undampedFreq)) {
    return {
      stiffness: 100,
      damping: 10,
      duration
    };
  } else {
    const stiffness = Math.pow(undampedFreq, 2) * mass;
    return {
      stiffness,
      damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
      duration
    };
  }
}
const rootIterations = 12;
function approximateRoot(envelope, derivative, initialGuess) {
  let result = initialGuess;
  for (let i3 = 1; i3 < rootIterations; i3++) {
    result = result - envelope(result) / derivative(result);
  }
  return result;
}
function calcAngularFreq(undampedFreq, dampingRatio) {
  return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}
const durationKeys = ["duration", "bounce"];
const physicsKeys = ["stiffness", "damping", "mass"];
function isSpringType(options, keys2) {
  return keys2.some((key) => options[key] !== void 0);
}
function getSpringOptions(options) {
  let springOptions = Object.assign({ velocity: 0, stiffness: 100, damping: 10, mass: 1, isResolvedFromDuration: false }, options);
  if (!isSpringType(options, physicsKeys) && isSpringType(options, durationKeys)) {
    const derived = findSpring(options);
    springOptions = Object.assign(Object.assign(Object.assign({}, springOptions), derived), { velocity: 0, mass: 1 });
    springOptions.isResolvedFromDuration = true;
  }
  return springOptions;
}
function spring(_a) {
  var { from = 0, to = 1, restSpeed = 2, restDelta } = _a, options = __rest$1(_a, ["from", "to", "restSpeed", "restDelta"]);
  const state = { done: false, value: from };
  let { stiffness, damping, mass, velocity, duration, isResolvedFromDuration } = getSpringOptions(options);
  let resolveSpring = zero$2;
  let resolveVelocity = zero$2;
  function createSpring() {
    const initialVelocity = velocity ? -(velocity / 1e3) : 0;
    const initialDelta = to - from;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const undampedAngularFreq = Math.sqrt(stiffness / mass) / 1e3;
    if (restDelta === void 0) {
      restDelta = Math.min(Math.abs(to - from) / 100, 0.4);
    }
    if (dampingRatio < 1) {
      const angularFreq = calcAngularFreq(undampedAngularFreq, dampingRatio);
      resolveSpring = (t3) => {
        const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t3);
        return to - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t3) + initialDelta * Math.cos(angularFreq * t3));
      };
      resolveVelocity = (t3) => {
        const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t3);
        return dampingRatio * undampedAngularFreq * envelope * (Math.sin(angularFreq * t3) * (initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq + initialDelta * Math.cos(angularFreq * t3)) - envelope * (Math.cos(angularFreq * t3) * (initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) - angularFreq * initialDelta * Math.sin(angularFreq * t3));
      };
    } else if (dampingRatio === 1) {
      resolveSpring = (t3) => to - Math.exp(-undampedAngularFreq * t3) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t3);
    } else {
      const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
      resolveSpring = (t3) => {
        const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t3);
        const freqForT = Math.min(dampedAngularFreq * t3, 300);
        return to - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
      };
    }
  }
  createSpring();
  return {
    next: (t3) => {
      const current = resolveSpring(t3);
      if (!isResolvedFromDuration) {
        const currentVelocity = resolveVelocity(t3) * 1e3;
        const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
        const isBelowDisplacementThreshold = Math.abs(to - current) <= restDelta;
        state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
      } else {
        state.done = t3 >= duration;
      }
      state.value = state.done ? to : current;
      return state;
    },
    flipTarget: () => {
      velocity = -velocity;
      [from, to] = [to, from];
      createSpring();
    }
  };
}
spring.needsInterpolation = (a4, b3) => typeof a4 === "string" || typeof b3 === "string";
const zero$2 = (_t) => 0;
const progress = (from, to, value) => {
  const toFromDifference = to - from;
  return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};
const mix = (from, to, progress2) => -progress2 * from + progress2 * to + from;
function hueToRgb(p2, q2, t3) {
  if (t3 < 0)
    t3 += 1;
  if (t3 > 1)
    t3 -= 1;
  if (t3 < 1 / 6)
    return p2 + (q2 - p2) * 6 * t3;
  if (t3 < 1 / 2)
    return q2;
  if (t3 < 2 / 3)
    return p2 + (q2 - p2) * (2 / 3 - t3) * 6;
  return p2;
}
function hslaToRgba({ hue, saturation, lightness, alpha: alpha3 }) {
  hue /= 360;
  saturation /= 100;
  lightness /= 100;
  let red = 0;
  let green = 0;
  let blue = 0;
  if (!saturation) {
    red = green = blue = lightness;
  } else {
    const q2 = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
    const p2 = 2 * lightness - q2;
    red = hueToRgb(p2, q2, hue + 1 / 3);
    green = hueToRgb(p2, q2, hue);
    blue = hueToRgb(p2, q2, hue - 1 / 3);
  }
  return {
    red: Math.round(red * 255),
    green: Math.round(green * 255),
    blue: Math.round(blue * 255),
    alpha: alpha3
  };
}
const mixLinearColor = (from, to, v2) => {
  const fromExpo = from * from;
  const toExpo = to * to;
  return Math.sqrt(Math.max(0, v2 * (toExpo - fromExpo) + fromExpo));
};
const colorTypes = [hex$1, rgba$1, hsla$1];
const getColorType = (v2) => colorTypes.find((type) => type.test(v2));
const notAnimatable = (color2) => `'${color2}' is not an animatable color. Use the equivalent color code instead.`;
const mixColor = (from, to) => {
  let fromColorType = getColorType(from);
  let toColorType = getColorType(to);
  invariant$1(!!fromColorType, notAnimatable(from));
  invariant$1(!!toColorType, notAnimatable(to));
  let fromColor = fromColorType.parse(from);
  let toColor = toColorType.parse(to);
  if (fromColorType === hsla$1) {
    fromColor = hslaToRgba(fromColor);
    fromColorType = rgba$1;
  }
  if (toColorType === hsla$1) {
    toColor = hslaToRgba(toColor);
    toColorType = rgba$1;
  }
  const blended = Object.assign({}, fromColor);
  return (v2) => {
    for (const key in blended) {
      if (key !== "alpha") {
        blended[key] = mixLinearColor(fromColor[key], toColor[key], v2);
      }
    }
    blended.alpha = mix(fromColor.alpha, toColor.alpha, v2);
    return fromColorType.transform(blended);
  };
};
const isNum = (v2) => typeof v2 === "number";
const combineFunctions = (a4, b3) => (v2) => b3(a4(v2));
const pipe = (...transformers) => transformers.reduce(combineFunctions);
function getMixer(origin, target) {
  if (isNum(origin)) {
    return (v2) => mix(origin, target, v2);
  } else if (color$1.test(origin)) {
    return mixColor(origin, target);
  } else {
    return mixComplex(origin, target);
  }
}
const mixArray = (from, to) => {
  const output = [...from];
  const numValues = output.length;
  const blendValue = from.map((fromThis, i3) => getMixer(fromThis, to[i3]));
  return (v2) => {
    for (let i3 = 0; i3 < numValues; i3++) {
      output[i3] = blendValue[i3](v2);
    }
    return output;
  };
};
const mixObject = (origin, target) => {
  const output = Object.assign(Object.assign({}, origin), target);
  const blendValue = {};
  for (const key in output) {
    if (origin[key] !== void 0 && target[key] !== void 0) {
      blendValue[key] = getMixer(origin[key], target[key]);
    }
  }
  return (v2) => {
    for (const key in blendValue) {
      output[key] = blendValue[key](v2);
    }
    return output;
  };
};
function analyse(value) {
  const parsed = complex.parse(value);
  const numValues = parsed.length;
  let numNumbers = 0;
  let numRGB = 0;
  let numHSL = 0;
  for (let i3 = 0; i3 < numValues; i3++) {
    if (numNumbers || typeof parsed[i3] === "number") {
      numNumbers++;
    } else {
      if (parsed[i3].hue !== void 0) {
        numHSL++;
      } else {
        numRGB++;
      }
    }
  }
  return { parsed, numNumbers, numRGB, numHSL };
}
const mixComplex = (origin, target) => {
  const template = complex.createTransformer(target);
  const originStats = analyse(origin);
  const targetStats = analyse(target);
  const canInterpolate = originStats.numHSL === targetStats.numHSL && originStats.numRGB === targetStats.numRGB && originStats.numNumbers >= targetStats.numNumbers;
  if (canInterpolate) {
    return pipe(mixArray(originStats.parsed, targetStats.parsed), template);
  } else {
    warning(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
    return (p2) => `${p2 > 0 ? target : origin}`;
  }
};
const mixNumber = (from, to) => (p2) => mix(from, to, p2);
function detectMixerFactory(v2) {
  if (typeof v2 === "number") {
    return mixNumber;
  } else if (typeof v2 === "string") {
    if (color$1.test(v2)) {
      return mixColor;
    } else {
      return mixComplex;
    }
  } else if (Array.isArray(v2)) {
    return mixArray;
  } else if (typeof v2 === "object") {
    return mixObject;
  }
}
function createMixers(output, ease, customMixer) {
  const mixers = [];
  const mixerFactory = customMixer || detectMixerFactory(output[0]);
  const numMixers = output.length - 1;
  for (let i3 = 0; i3 < numMixers; i3++) {
    let mixer = mixerFactory(output[i3], output[i3 + 1]);
    if (ease) {
      const easingFunction = Array.isArray(ease) ? ease[i3] : ease;
      mixer = pipe(easingFunction, mixer);
    }
    mixers.push(mixer);
  }
  return mixers;
}
function fastInterpolate([from, to], [mixer]) {
  return (v2) => mixer(progress(from, to, v2));
}
function slowInterpolate(input, mixers) {
  const inputLength = input.length;
  const lastInputIndex = inputLength - 1;
  return (v2) => {
    let mixerIndex = 0;
    let foundMixerIndex = false;
    if (v2 <= input[0]) {
      foundMixerIndex = true;
    } else if (v2 >= input[lastInputIndex]) {
      mixerIndex = lastInputIndex - 1;
      foundMixerIndex = true;
    }
    if (!foundMixerIndex) {
      let i3 = 1;
      for (; i3 < inputLength; i3++) {
        if (input[i3] > v2 || i3 === lastInputIndex) {
          break;
        }
      }
      mixerIndex = i3 - 1;
    }
    const progressInRange = progress(input[mixerIndex], input[mixerIndex + 1], v2);
    return mixers[mixerIndex](progressInRange);
  };
}
function interpolate$1(input, output, { clamp: isClamp = true, ease, mixer } = {}) {
  const inputLength = input.length;
  invariant$1(inputLength === output.length, "Both input and output ranges must be the same length");
  invariant$1(!ease || !Array.isArray(ease) || ease.length === inputLength - 1, "Array of easing functions must be of length `input.length - 1`, as it applies to the transitions **between** the defined values.");
  if (input[0] > input[inputLength - 1]) {
    input = [].concat(input);
    output = [].concat(output);
    input.reverse();
    output.reverse();
  }
  const mixers = createMixers(output, ease, mixer);
  const interpolator = inputLength === 2 ? fastInterpolate(input, mixers) : slowInterpolate(input, mixers);
  return isClamp ? (v2) => interpolator(clamp(input[0], input[inputLength - 1], v2)) : interpolator;
}
const reverseEasing = (easing) => (p2) => 1 - easing(1 - p2);
const mirrorEasing = (easing) => (p2) => p2 <= 0.5 ? easing(2 * p2) / 2 : (2 - easing(2 * (1 - p2))) / 2;
const createExpoIn = (power) => (p2) => Math.pow(p2, power);
const createBackIn = (power) => (p2) => p2 * p2 * ((power + 1) * p2 - power);
const createAnticipate = (power) => {
  const backEasing = createBackIn(power);
  return (p2) => (p2 *= 2) < 1 ? 0.5 * backEasing(p2) : 0.5 * (2 - Math.pow(2, -10 * (p2 - 1)));
};
const DEFAULT_OVERSHOOT_STRENGTH = 1.525;
const BOUNCE_FIRST_THRESHOLD = 4 / 11;
const BOUNCE_SECOND_THRESHOLD = 8 / 11;
const BOUNCE_THIRD_THRESHOLD = 9 / 10;
const linear$2 = (p2) => p2;
const easeIn = createExpoIn(2);
const easeOut = reverseEasing(easeIn);
const easeInOut = mirrorEasing(easeIn);
const circIn = (p2) => 1 - Math.sin(Math.acos(p2));
const circOut = reverseEasing(circIn);
const circInOut = mirrorEasing(circOut);
const backIn = createBackIn(DEFAULT_OVERSHOOT_STRENGTH);
const backOut = reverseEasing(backIn);
const backInOut = mirrorEasing(backIn);
const anticipate = createAnticipate(DEFAULT_OVERSHOOT_STRENGTH);
const ca = 4356 / 361;
const cb = 35442 / 1805;
const cc = 16061 / 1805;
const bounceOut = (p2) => {
  if (p2 === 1 || p2 === 0)
    return p2;
  const p22 = p2 * p2;
  return p2 < BOUNCE_FIRST_THRESHOLD ? 7.5625 * p22 : p2 < BOUNCE_SECOND_THRESHOLD ? 9.075 * p22 - 9.9 * p2 + 3.4 : p2 < BOUNCE_THIRD_THRESHOLD ? ca * p22 - cb * p2 + cc : 10.8 * p2 * p2 - 20.52 * p2 + 10.72;
};
const bounceIn = reverseEasing(bounceOut);
const bounceInOut = (p2) => p2 < 0.5 ? 0.5 * (1 - bounceOut(1 - p2 * 2)) : 0.5 * bounceOut(p2 * 2 - 1) + 0.5;
function defaultEasing(values, easing) {
  return values.map(() => easing || easeInOut).splice(0, values.length - 1);
}
function defaultOffset(values) {
  const numValues = values.length;
  return values.map((_value, i3) => i3 !== 0 ? i3 / (numValues - 1) : 0);
}
function convertOffsetToTimes(offset2, duration) {
  return offset2.map((o2) => o2 * duration);
}
function keyframes$1({ from = 0, to = 1, ease, offset: offset2, duration = 300 }) {
  const state = { done: false, value: from };
  const values = Array.isArray(to) ? to : [from, to];
  const times = convertOffsetToTimes(offset2 && offset2.length === values.length ? offset2 : defaultOffset(values), duration);
  function createInterpolator() {
    return interpolate$1(times, values, {
      ease: Array.isArray(ease) ? ease : defaultEasing(values, ease)
    });
  }
  let interpolator = createInterpolator();
  return {
    next: (t3) => {
      state.value = interpolator(t3);
      state.done = t3 >= duration;
      return state;
    },
    flipTarget: () => {
      values.reverse();
      interpolator = createInterpolator();
    }
  };
}
function decay({ velocity = 0, from = 0, power = 0.8, timeConstant = 350, restDelta = 0.5, modifyTarget }) {
  const state = { done: false, value: from };
  let amplitude = power * velocity;
  const ideal = from + amplitude;
  const target = modifyTarget === void 0 ? ideal : modifyTarget(ideal);
  if (target !== ideal)
    amplitude = target - from;
  return {
    next: (t3) => {
      const delta = -amplitude * Math.exp(-t3 / timeConstant);
      state.done = !(delta > restDelta || delta < -restDelta);
      state.value = state.done ? target : target + delta;
      return state;
    },
    flipTarget: () => {
    }
  };
}
const types = { keyframes: keyframes$1, spring, decay };
function detectAnimationFromOptions(config2) {
  if (Array.isArray(config2.to)) {
    return keyframes$1;
  } else if (types[config2.type]) {
    return types[config2.type];
  }
  const keys2 = new Set(Object.keys(config2));
  if (keys2.has("ease") || keys2.has("duration") && !keys2.has("dampingRatio")) {
    return keyframes$1;
  } else if (keys2.has("dampingRatio") || keys2.has("stiffness") || keys2.has("mass") || keys2.has("damping") || keys2.has("restSpeed") || keys2.has("restDelta")) {
    return spring;
  }
  return keyframes$1;
}
const defaultTimestep = 1 / 60 * 1e3;
const getCurrentTime = typeof performance !== "undefined" ? () => performance.now() : () => Date.now();
const onNextFrame = typeof window !== "undefined" ? (callback) => window.requestAnimationFrame(callback) : (callback) => setTimeout(() => callback(getCurrentTime()), defaultTimestep);
function createRenderStep(runNextFrame2) {
  let toRun = [];
  let toRunNextFrame = [];
  let numToRun = 0;
  let isProcessing2 = false;
  let flushNextFrame = false;
  const toKeepAlive = /* @__PURE__ */ new WeakSet();
  const step = {
    schedule: (callback, keepAlive = false, immediate = false) => {
      const addToCurrentFrame = immediate && isProcessing2;
      const buffer = addToCurrentFrame ? toRun : toRunNextFrame;
      if (keepAlive)
        toKeepAlive.add(callback);
      if (buffer.indexOf(callback) === -1) {
        buffer.push(callback);
        if (addToCurrentFrame && isProcessing2)
          numToRun = toRun.length;
      }
      return callback;
    },
    cancel: (callback) => {
      const index2 = toRunNextFrame.indexOf(callback);
      if (index2 !== -1)
        toRunNextFrame.splice(index2, 1);
      toKeepAlive.delete(callback);
    },
    process: (frameData) => {
      if (isProcessing2) {
        flushNextFrame = true;
        return;
      }
      isProcessing2 = true;
      [toRun, toRunNextFrame] = [toRunNextFrame, toRun];
      toRunNextFrame.length = 0;
      numToRun = toRun.length;
      if (numToRun) {
        for (let i3 = 0; i3 < numToRun; i3++) {
          const callback = toRun[i3];
          callback(frameData);
          if (toKeepAlive.has(callback)) {
            step.schedule(callback);
            runNextFrame2();
          }
        }
      }
      isProcessing2 = false;
      if (flushNextFrame) {
        flushNextFrame = false;
        step.process(frameData);
      }
    }
  };
  return step;
}
const maxElapsed = 40;
let useDefaultElapsed = true;
let runNextFrame = false;
let isProcessing = false;
const frame = {
  delta: 0,
  timestamp: 0
};
const stepsOrder = [
  "read",
  "update",
  "preRender",
  "render",
  "postRender"
];
const steps = stepsOrder.reduce((acc, key) => {
  acc[key] = createRenderStep(() => runNextFrame = true);
  return acc;
}, {});
const sync = stepsOrder.reduce((acc, key) => {
  const step = steps[key];
  acc[key] = (process2, keepAlive = false, immediate = false) => {
    if (!runNextFrame)
      startLoop();
    return step.schedule(process2, keepAlive, immediate);
  };
  return acc;
}, {});
const cancelSync = stepsOrder.reduce((acc, key) => {
  acc[key] = steps[key].cancel;
  return acc;
}, {});
const flushSync = stepsOrder.reduce((acc, key) => {
  acc[key] = () => steps[key].process(frame);
  return acc;
}, {});
const processStep = (stepId) => steps[stepId].process(frame);
const processFrame = (timestamp) => {
  runNextFrame = false;
  frame.delta = useDefaultElapsed ? defaultTimestep : Math.max(Math.min(timestamp - frame.timestamp, maxElapsed), 1);
  frame.timestamp = timestamp;
  isProcessing = true;
  stepsOrder.forEach(processStep);
  isProcessing = false;
  if (runNextFrame) {
    useDefaultElapsed = false;
    onNextFrame(processFrame);
  }
};
const startLoop = () => {
  runNextFrame = true;
  useDefaultElapsed = true;
  if (!isProcessing)
    onNextFrame(processFrame);
};
const getFrameData = () => frame;
function loopElapsed(elapsed, duration, delay = 0) {
  return elapsed - duration - delay;
}
function reverseElapsed(elapsed, duration, delay = 0, isForwardPlayback = true) {
  return isForwardPlayback ? loopElapsed(duration + -elapsed, duration, delay) : duration - (elapsed - duration) + delay;
}
function hasRepeatDelayElapsed(elapsed, duration, delay, isForwardPlayback) {
  return isForwardPlayback ? elapsed >= duration + delay : elapsed <= -delay;
}
const framesync = (update2) => {
  const passTimestamp = ({ delta }) => update2(delta);
  return {
    start: () => sync.update(passTimestamp, true),
    stop: () => cancelSync.update(passTimestamp)
  };
};
function animate$1(_a) {
  var _b, _c;
  var { from, autoplay = true, driver = framesync, elapsed = 0, repeat: repeatMax = 0, repeatType = "loop", repeatDelay = 0, onPlay, onStop, onComplete, onRepeat, onUpdate: onUpdate2 } = _a, options = __rest$1(_a, ["from", "autoplay", "driver", "elapsed", "repeat", "repeatType", "repeatDelay", "onPlay", "onStop", "onComplete", "onRepeat", "onUpdate"]);
  let { to } = options;
  let driverControls;
  let repeatCount = 0;
  let computedDuration = options.duration;
  let latest;
  let isComplete = false;
  let isForwardPlayback = true;
  let interpolateFromNumber;
  const animator = detectAnimationFromOptions(options);
  if ((_c = (_b = animator).needsInterpolation) === null || _c === void 0 ? void 0 : _c.call(_b, from, to)) {
    interpolateFromNumber = interpolate$1([0, 100], [from, to], {
      clamp: false
    });
    from = 0;
    to = 100;
  }
  const animation = animator(Object.assign(Object.assign({}, options), { from, to }));
  function repeat() {
    repeatCount++;
    if (repeatType === "reverse") {
      isForwardPlayback = repeatCount % 2 === 0;
      elapsed = reverseElapsed(elapsed, computedDuration, repeatDelay, isForwardPlayback);
    } else {
      elapsed = loopElapsed(elapsed, computedDuration, repeatDelay);
      if (repeatType === "mirror")
        animation.flipTarget();
    }
    isComplete = false;
    onRepeat && onRepeat();
  }
  function complete() {
    driverControls.stop();
    onComplete && onComplete();
  }
  function update2(delta) {
    if (!isForwardPlayback)
      delta = -delta;
    elapsed += delta;
    if (!isComplete) {
      const state = animation.next(Math.max(0, elapsed));
      latest = state.value;
      if (interpolateFromNumber)
        latest = interpolateFromNumber(latest);
      isComplete = isForwardPlayback ? state.done : elapsed <= 0;
    }
    onUpdate2 === null || onUpdate2 === void 0 ? void 0 : onUpdate2(latest);
    if (isComplete) {
      if (repeatCount === 0)
        computedDuration !== null && computedDuration !== void 0 ? computedDuration : computedDuration = elapsed;
      if (repeatCount < repeatMax) {
        hasRepeatDelayElapsed(elapsed, computedDuration, repeatDelay, isForwardPlayback) && repeat();
      } else {
        complete();
      }
    }
  }
  function play() {
    onPlay === null || onPlay === void 0 ? void 0 : onPlay();
    driverControls = driver(update2);
    driverControls.start();
  }
  autoplay && play();
  return {
    stop: () => {
      onStop === null || onStop === void 0 ? void 0 : onStop();
      driverControls.stop();
    }
  };
}
function velocityPerSecond(velocity, frameDuration) {
  return frameDuration ? velocity * (1e3 / frameDuration) : 0;
}
function inertia({ from = 0, velocity = 0, min: min2, max: max2, power = 0.8, timeConstant = 750, bounceStiffness = 500, bounceDamping = 10, restDelta = 1, modifyTarget, driver, onUpdate: onUpdate2, onComplete, onStop }) {
  let currentAnimation;
  function isOutOfBounds(v2) {
    return min2 !== void 0 && v2 < min2 || max2 !== void 0 && v2 > max2;
  }
  function boundaryNearest(v2) {
    if (min2 === void 0)
      return max2;
    if (max2 === void 0)
      return min2;
    return Math.abs(min2 - v2) < Math.abs(max2 - v2) ? min2 : max2;
  }
  function startAnimation2(options) {
    currentAnimation === null || currentAnimation === void 0 ? void 0 : currentAnimation.stop();
    currentAnimation = animate$1(Object.assign(Object.assign({}, options), {
      driver,
      onUpdate: (v2) => {
        var _a;
        onUpdate2 === null || onUpdate2 === void 0 ? void 0 : onUpdate2(v2);
        (_a = options.onUpdate) === null || _a === void 0 ? void 0 : _a.call(options, v2);
      },
      onComplete,
      onStop
    }));
  }
  function startSpring(options) {
    startAnimation2(Object.assign({ type: "spring", stiffness: bounceStiffness, damping: bounceDamping, restDelta }, options));
  }
  if (isOutOfBounds(from)) {
    startSpring({ from, velocity, to: boundaryNearest(from) });
  } else {
    let target = power * velocity + from;
    if (typeof modifyTarget !== "undefined")
      target = modifyTarget(target);
    const boundary = boundaryNearest(target);
    const heading = boundary === min2 ? -1 : 1;
    let prev;
    let current;
    const checkBoundary = (v2) => {
      prev = current;
      current = v2;
      velocity = velocityPerSecond(v2 - prev, getFrameData().delta);
      if (heading === 1 && v2 > boundary || heading === -1 && v2 < boundary) {
        startSpring({ from: v2, to: boundary, velocity });
      }
    };
    startAnimation2({
      type: "decay",
      from,
      velocity,
      timeConstant,
      power,
      restDelta,
      modifyTarget,
      onUpdate: isOutOfBounds(target) ? checkBoundary : void 0
    });
  }
  return {
    stop: () => currentAnimation === null || currentAnimation === void 0 ? void 0 : currentAnimation.stop()
  };
}
const isPoint = (point2) => point2.hasOwnProperty("x") && point2.hasOwnProperty("y");
const isPoint3D = (point2) => isPoint(point2) && point2.hasOwnProperty("z");
const distance1D = (a4, b3) => Math.abs(a4 - b3);
function distance(a4, b3) {
  if (isNum(a4) && isNum(b3)) {
    return distance1D(a4, b3);
  } else if (isPoint(a4) && isPoint(b3)) {
    const xDelta = distance1D(a4.x, b3.x);
    const yDelta = distance1D(a4.y, b3.y);
    const zDelta = isPoint3D(a4) && isPoint3D(b3) ? distance1D(a4.z, b3.z) : 0;
    return Math.sqrt(Math.pow(xDelta, 2) + Math.pow(yDelta, 2) + Math.pow(zDelta, 2));
  }
}
const a$1 = (a1, a22) => 1 - 3 * a22 + 3 * a1;
const b2 = (a1, a22) => 3 * a22 - 6 * a1;
const c$1 = (a1) => 3 * a1;
const calcBezier = (t3, a1, a22) => ((a$1(a1, a22) * t3 + b2(a1, a22)) * t3 + c$1(a1)) * t3;
const getSlope = (t3, a1, a22) => 3 * a$1(a1, a22) * t3 * t3 + 2 * b2(a1, a22) * t3 + c$1(a1);
const subdivisionPrecision = 1e-7;
const subdivisionMaxIterations = 10;
function binarySubdivide(aX, aA, aB, mX1, mX2) {
  let currentX;
  let currentT;
  let i3 = 0;
  do {
    currentT = aA + (aB - aA) / 2;
    currentX = calcBezier(currentT, mX1, mX2) - aX;
    if (currentX > 0) {
      aB = currentT;
    } else {
      aA = currentT;
    }
  } while (Math.abs(currentX) > subdivisionPrecision && ++i3 < subdivisionMaxIterations);
  return currentT;
}
const newtonIterations = 8;
const newtonMinSlope = 1e-3;
function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
  for (let i3 = 0; i3 < newtonIterations; ++i3) {
    const currentSlope = getSlope(aGuessT, mX1, mX2);
    if (currentSlope === 0) {
      return aGuessT;
    }
    const currentX = calcBezier(aGuessT, mX1, mX2) - aX;
    aGuessT -= currentX / currentSlope;
  }
  return aGuessT;
}
const kSplineTableSize = 11;
const kSampleStepSize = 1 / (kSplineTableSize - 1);
function cubicBezier$1(mX1, mY1, mX2, mY2) {
  if (mX1 === mY1 && mX2 === mY2)
    return linear$2;
  const sampleValues = new Float32Array(kSplineTableSize);
  for (let i3 = 0; i3 < kSplineTableSize; ++i3) {
    sampleValues[i3] = calcBezier(i3 * kSampleStepSize, mX1, mX2);
  }
  function getTForX(aX) {
    let intervalStart = 0;
    let currentSample = 1;
    const lastSample = kSplineTableSize - 1;
    for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
      intervalStart += kSampleStepSize;
    }
    --currentSample;
    const dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
    const guessForT = intervalStart + dist * kSampleStepSize;
    const initialSlope = getSlope(guessForT, mX1, mX2);
    if (initialSlope >= newtonMinSlope) {
      return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
    } else if (initialSlope === 0) {
      return guessForT;
    } else {
      return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
    }
  }
  return (t3) => t3 === 0 || t3 === 1 ? t3 : calcBezier(getTForX(t3), mY1, mY2);
}
function useTapGesture(_a) {
  var onTap = _a.onTap, onTapStart = _a.onTapStart, onTapCancel = _a.onTapCancel, whileTap = _a.whileTap, visualElement2 = _a.visualElement;
  var hasPressListeners = onTap || onTapStart || onTapCancel || whileTap;
  var isPressing = useRef(false);
  var cancelPointerEndListeners = useRef(null);
  var eventOptions = {
    passive: !(onTapStart || onTap || onTapCancel || onPointerDown)
  };
  function removePointerEndListener() {
    var _a2;
    (_a2 = cancelPointerEndListeners.current) === null || _a2 === void 0 ? void 0 : _a2.call(cancelPointerEndListeners);
    cancelPointerEndListeners.current = null;
  }
  function checkPointerEnd() {
    var _a2;
    removePointerEndListener();
    isPressing.current = false;
    (_a2 = visualElement2.animationState) === null || _a2 === void 0 ? void 0 : _a2.setActive(AnimationType.Tap, false);
    return !isDragActive();
  }
  function onPointerUp(event, info) {
    if (!checkPointerEnd())
      return;
    !isNodeOrChild(visualElement2.getInstance(), event.target) ? onTapCancel === null || onTapCancel === void 0 ? void 0 : onTapCancel(event, info) : onTap === null || onTap === void 0 ? void 0 : onTap(event, info);
  }
  function onPointerCancel(event, info) {
    if (!checkPointerEnd())
      return;
    onTapCancel === null || onTapCancel === void 0 ? void 0 : onTapCancel(event, info);
  }
  function onPointerDown(event, info) {
    var _a2;
    removePointerEndListener();
    if (isPressing.current)
      return;
    isPressing.current = true;
    cancelPointerEndListeners.current = pipe(addPointerEvent(window, "pointerup", onPointerUp, eventOptions), addPointerEvent(window, "pointercancel", onPointerCancel, eventOptions));
    (_a2 = visualElement2.animationState) === null || _a2 === void 0 ? void 0 : _a2.setActive(AnimationType.Tap, true);
    onTapStart === null || onTapStart === void 0 ? void 0 : onTapStart(event, info);
  }
  usePointerEvent(visualElement2, "pointerdown", hasPressListeners ? onPointerDown : void 0, eventOptions);
  useUnmountEffect(removePointerEndListener);
}
var warned = /* @__PURE__ */ new Set();
function warnOnce(condition, message, element) {
  if (condition || warned.has(message))
    return;
  console.warn(message);
  warned.add(message);
}
var observerCallbacks = /* @__PURE__ */ new WeakMap();
var observers = /* @__PURE__ */ new WeakMap();
var fireObserverCallback = function(entry) {
  var _a;
  (_a = observerCallbacks.get(entry.target)) === null || _a === void 0 ? void 0 : _a(entry);
};
var fireAllObserverCallbacks = function(entries) {
  entries.forEach(fireObserverCallback);
};
function initIntersectionObserver(_a) {
  var root = _a.root, options = __rest$1(_a, ["root"]);
  var lookupRoot = root || document;
  if (!observers.has(lookupRoot)) {
    observers.set(lookupRoot, {});
  }
  var rootObservers = observers.get(lookupRoot);
  var key = JSON.stringify(options);
  if (!rootObservers[key]) {
    rootObservers[key] = new IntersectionObserver(fireAllObserverCallbacks, __assign$1({ root }, options));
  }
  return rootObservers[key];
}
function observeIntersection(element, options, callback) {
  var rootInteresectionObserver = initIntersectionObserver(options);
  observerCallbacks.set(element, callback);
  rootInteresectionObserver.observe(element);
  return function() {
    observerCallbacks.delete(element);
    rootInteresectionObserver.unobserve(element);
  };
}
function useViewport(_a) {
  var visualElement2 = _a.visualElement, whileInView = _a.whileInView, onViewportEnter = _a.onViewportEnter, onViewportLeave = _a.onViewportLeave, _b = _a.viewport, viewport = _b === void 0 ? {} : _b;
  var state = useRef({
    hasEnteredView: false,
    isInView: false
  });
  var shouldObserve = Boolean(whileInView || onViewportEnter || onViewportLeave);
  if (viewport.once && state.current.hasEnteredView)
    shouldObserve = false;
  var useObserver = typeof IntersectionObserver === "undefined" ? useMissingIntersectionObserver : useIntersectionObserver$1;
  useObserver(shouldObserve, state.current, visualElement2, viewport);
}
var thresholdNames = {
  some: 0,
  all: 1
};
function useIntersectionObserver$1(shouldObserve, state, visualElement2, _a) {
  var root = _a.root, rootMargin = _a.margin, _b = _a.amount, amount = _b === void 0 ? "some" : _b, once2 = _a.once;
  useEffect(function() {
    if (!shouldObserve)
      return;
    var options = {
      root: root === null || root === void 0 ? void 0 : root.current,
      rootMargin,
      threshold: typeof amount === "number" ? amount : thresholdNames[amount]
    };
    var intersectionCallback = function(entry) {
      var _a2;
      var isIntersecting = entry.isIntersecting;
      if (state.isInView === isIntersecting)
        return;
      state.isInView = isIntersecting;
      if (once2 && !isIntersecting && state.hasEnteredView) {
        return;
      } else if (isIntersecting) {
        state.hasEnteredView = true;
      }
      (_a2 = visualElement2.animationState) === null || _a2 === void 0 ? void 0 : _a2.setActive(AnimationType.InView, isIntersecting);
      var props = visualElement2.getProps();
      var callback = isIntersecting ? props.onViewportEnter : props.onViewportLeave;
      callback === null || callback === void 0 ? void 0 : callback(entry);
    };
    return observeIntersection(visualElement2.getInstance(), options, intersectionCallback);
  }, [shouldObserve, root, rootMargin, amount]);
}
function useMissingIntersectionObserver(shouldObserve, state, visualElement2, _a) {
  var _b = _a.fallback, fallback = _b === void 0 ? true : _b;
  useEffect(function() {
    if (!shouldObserve || !fallback)
      return;
    if (env !== "production") {
      warnOnce(false, "IntersectionObserver not available on this device. whileInView animations will trigger on mount.");
    }
    requestAnimationFrame(function() {
      var _a2;
      state.hasEnteredView = true;
      var onViewportEnter = visualElement2.getProps().onViewportEnter;
      onViewportEnter === null || onViewportEnter === void 0 ? void 0 : onViewportEnter(null);
      (_a2 = visualElement2.animationState) === null || _a2 === void 0 ? void 0 : _a2.setActive(AnimationType.InView, true);
    });
  }, [shouldObserve]);
}
var makeRenderlessComponent = function(hook) {
  return function(props) {
    hook(props);
    return null;
  };
};
var gestureAnimations = {
  inView: makeRenderlessComponent(useViewport),
  tap: makeRenderlessComponent(useTapGesture),
  focus: makeRenderlessComponent(useFocusGesture),
  hover: makeRenderlessComponent(useHoverGesture)
};
var counter = 0;
var incrementId = function() {
  return counter++;
};
var useId = function() {
  return useConstant(incrementId);
};
function usePresence() {
  var context = useContext(PresenceContext);
  if (context === null)
    return [true, null];
  var isPresent = context.isPresent, onExitComplete = context.onExitComplete, register = context.register;
  var id2 = useId();
  useEffect(function() {
    return register(id2);
  }, []);
  var safeToRemove = function() {
    return onExitComplete === null || onExitComplete === void 0 ? void 0 : onExitComplete(id2);
  };
  return !isPresent && onExitComplete ? [false, safeToRemove] : [true];
}
function shallowCompare(next, prev) {
  if (!Array.isArray(prev))
    return false;
  var prevLength = prev.length;
  if (prevLength !== next.length)
    return false;
  for (var i3 = 0; i3 < prevLength; i3++) {
    if (prev[i3] !== next[i3])
      return false;
  }
  return true;
}
var secondsToMilliseconds = function(seconds) {
  return seconds * 1e3;
};
var easingLookup = {
  linear: linear$2,
  easeIn,
  easeInOut,
  easeOut,
  circIn,
  circInOut,
  circOut,
  backIn,
  backInOut,
  backOut,
  anticipate,
  bounceIn,
  bounceInOut,
  bounceOut
};
var easingDefinitionToFunction = function(definition) {
  if (Array.isArray(definition)) {
    invariant$1(definition.length === 4, "Cubic bezier arrays must contain four numerical values.");
    var _a = __read(definition, 4), x1 = _a[0], y1 = _a[1], x22 = _a[2], y22 = _a[3];
    return cubicBezier$1(x1, y1, x22, y22);
  } else if (typeof definition === "string") {
    invariant$1(easingLookup[definition] !== void 0, "Invalid easing type '".concat(definition, "'"));
    return easingLookup[definition];
  }
  return definition;
};
var isEasingArray = function(ease) {
  return Array.isArray(ease) && typeof ease[0] !== "number";
};
var isAnimatable = function(key, value) {
  if (key === "zIndex")
    return false;
  if (typeof value === "number" || Array.isArray(value))
    return true;
  if (typeof value === "string" && // It's animatable if we have a string
  complex.test(value) && // And it contains numbers and/or colors
  !value.startsWith("url(")) {
    return true;
  }
  return false;
};
var underDampedSpring = function() {
  return {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
  };
};
var criticallyDampedSpring = function(to) {
  return {
    type: "spring",
    stiffness: 550,
    damping: to === 0 ? 2 * Math.sqrt(550) : 30,
    restSpeed: 10
  };
};
var linearTween = function() {
  return {
    type: "keyframes",
    ease: "linear",
    duration: 0.3
  };
};
var keyframes = function(values) {
  return {
    type: "keyframes",
    duration: 0.8,
    values
  };
};
var defaultTransitions = {
  x: underDampedSpring,
  y: underDampedSpring,
  z: underDampedSpring,
  rotate: underDampedSpring,
  rotateX: underDampedSpring,
  rotateY: underDampedSpring,
  rotateZ: underDampedSpring,
  scaleX: criticallyDampedSpring,
  scaleY: criticallyDampedSpring,
  scale: criticallyDampedSpring,
  opacity: linearTween,
  backgroundColor: linearTween,
  color: linearTween,
  default: criticallyDampedSpring
};
var getDefaultTransition = function(valueKey, to) {
  var transitionFactory;
  if (isKeyframesTarget(to)) {
    transitionFactory = keyframes;
  } else {
    transitionFactory = defaultTransitions[valueKey] || defaultTransitions.default;
  }
  return __assign$1({ to }, transitionFactory(to));
};
var defaultValueTypes = __assign$1(__assign$1({}, numberValueTypes), {
  // Color props
  color: color$1,
  backgroundColor: color$1,
  outlineColor: color$1,
  fill: color$1,
  stroke: color$1,
  // Border props
  borderColor: color$1,
  borderTopColor: color$1,
  borderRightColor: color$1,
  borderBottomColor: color$1,
  borderLeftColor: color$1,
  filter,
  WebkitFilter: filter
});
var getDefaultValueType = function(key) {
  return defaultValueTypes[key];
};
function getAnimatableNone(key, value) {
  var _a;
  var defaultValueType = getDefaultValueType(key);
  if (defaultValueType !== filter)
    defaultValueType = complex;
  return (_a = defaultValueType.getAnimatableNone) === null || _a === void 0 ? void 0 : _a.call(defaultValueType, value);
}
function isTransitionDefined(_a) {
  _a.when;
  _a.delay;
  _a.delayChildren;
  _a.staggerChildren;
  _a.staggerDirection;
  _a.repeat;
  _a.repeatType;
  _a.repeatDelay;
  _a.from;
  var transition = __rest$1(_a, ["when", "delay", "delayChildren", "staggerChildren", "staggerDirection", "repeat", "repeatType", "repeatDelay", "from"]);
  return !!Object.keys(transition).length;
}
var legacyRepeatWarning = false;
function convertTransitionToAnimationOptions(_a) {
  var ease = _a.ease, times = _a.times, yoyo = _a.yoyo, flip2 = _a.flip, loop = _a.loop, transition = __rest$1(_a, ["ease", "times", "yoyo", "flip", "loop"]);
  var options = __assign$1({}, transition);
  if (times)
    options["offset"] = times;
  if (transition.duration)
    options["duration"] = secondsToMilliseconds(transition.duration);
  if (transition.repeatDelay)
    options.repeatDelay = secondsToMilliseconds(transition.repeatDelay);
  if (ease) {
    options["ease"] = isEasingArray(ease) ? ease.map(easingDefinitionToFunction) : easingDefinitionToFunction(ease);
  }
  if (transition.type === "tween")
    options.type = "keyframes";
  if (yoyo || loop || flip2) {
    warning(!legacyRepeatWarning, "yoyo, loop and flip have been removed from the API. Replace with repeat and repeatType options.");
    legacyRepeatWarning = true;
    if (yoyo) {
      options.repeatType = "reverse";
    } else if (loop) {
      options.repeatType = "loop";
    } else if (flip2) {
      options.repeatType = "mirror";
    }
    options.repeat = loop || yoyo || flip2 || transition.repeat;
  }
  if (transition.type !== "spring")
    options.type = "keyframes";
  return options;
}
function getDelayFromTransition(transition, key) {
  var _a, _b;
  var valueTransition = getValueTransition(transition, key) || {};
  return (_b = (_a = valueTransition.delay) !== null && _a !== void 0 ? _a : transition.delay) !== null && _b !== void 0 ? _b : 0;
}
function hydrateKeyframes(options) {
  if (Array.isArray(options.to) && options.to[0] === null) {
    options.to = __spreadArray$1([], __read(options.to), false);
    options.to[0] = options.from;
  }
  return options;
}
function getPopmotionAnimationOptions(transition, options, key) {
  var _a;
  if (Array.isArray(options.to)) {
    (_a = transition.duration) !== null && _a !== void 0 ? _a : transition.duration = 0.8;
  }
  hydrateKeyframes(options);
  if (!isTransitionDefined(transition)) {
    transition = __assign$1(__assign$1({}, transition), getDefaultTransition(key, options.to));
  }
  return __assign$1(__assign$1({}, options), convertTransitionToAnimationOptions(transition));
}
function getAnimation(key, value, target, transition, onComplete) {
  var _a;
  var valueTransition = getValueTransition(transition, key);
  var origin = (_a = valueTransition.from) !== null && _a !== void 0 ? _a : value.get();
  var isTargetAnimatable = isAnimatable(key, target);
  if (origin === "none" && isTargetAnimatable && typeof target === "string") {
    origin = getAnimatableNone(key, target);
  } else if (isZero(origin) && typeof target === "string") {
    origin = getZeroUnit(target);
  } else if (!Array.isArray(target) && isZero(target) && typeof origin === "string") {
    target = getZeroUnit(origin);
  }
  var isOriginAnimatable = isAnimatable(key, origin);
  warning(isOriginAnimatable === isTargetAnimatable, "You are trying to animate ".concat(key, ' from "').concat(origin, '" to "').concat(target, '". ').concat(origin, " is not an animatable value - to enable this animation set ").concat(origin, " to a value animatable to ").concat(target, " via the `style` property."));
  function start() {
    var options = {
      from: origin,
      to: target,
      velocity: value.getVelocity(),
      onComplete,
      onUpdate: function(v2) {
        return value.set(v2);
      }
    };
    return valueTransition.type === "inertia" || valueTransition.type === "decay" ? inertia(__assign$1(__assign$1({}, options), valueTransition)) : animate$1(__assign$1(__assign$1({}, getPopmotionAnimationOptions(valueTransition, options, key)), { onUpdate: function(v2) {
      var _a2;
      options.onUpdate(v2);
      (_a2 = valueTransition.onUpdate) === null || _a2 === void 0 ? void 0 : _a2.call(valueTransition, v2);
    }, onComplete: function() {
      var _a2;
      options.onComplete();
      (_a2 = valueTransition.onComplete) === null || _a2 === void 0 ? void 0 : _a2.call(valueTransition);
    } }));
  }
  function set2() {
    var _a2, _b;
    var finalTarget = resolveFinalValueInKeyframes(target);
    value.set(finalTarget);
    onComplete();
    (_a2 = valueTransition === null || valueTransition === void 0 ? void 0 : valueTransition.onUpdate) === null || _a2 === void 0 ? void 0 : _a2.call(valueTransition, finalTarget);
    (_b = valueTransition === null || valueTransition === void 0 ? void 0 : valueTransition.onComplete) === null || _b === void 0 ? void 0 : _b.call(valueTransition);
    return { stop: function() {
    } };
  }
  return !isOriginAnimatable || !isTargetAnimatable || valueTransition.type === false ? set2 : start;
}
function isZero(value) {
  return value === 0 || typeof value === "string" && parseFloat(value) === 0 && value.indexOf(" ") === -1;
}
function getZeroUnit(potentialUnitType) {
  return typeof potentialUnitType === "number" ? 0 : getAnimatableNone("", potentialUnitType);
}
function getValueTransition(transition, key) {
  return transition[key] || transition["default"] || transition;
}
function startAnimation(key, value, target, transition) {
  if (transition === void 0) {
    transition = {};
  }
  return value.start(function(onComplete) {
    var delayTimer;
    var controls;
    var animation = getAnimation(key, value, target, transition, onComplete);
    var delay = getDelayFromTransition(transition, key);
    var start = function() {
      return controls = animation();
    };
    if (delay) {
      delayTimer = window.setTimeout(start, secondsToMilliseconds(delay));
    } else {
      start();
    }
    return function() {
      clearTimeout(delayTimer);
      controls === null || controls === void 0 ? void 0 : controls.stop();
    };
  });
}
var isNumericalString = function(v2) {
  return /^\-?\d*\.?\d+$/.test(v2);
};
var isZeroValueString = function(v2) {
  return /^0[^.\s]+$/.test(v2);
};
function addUniqueItem(arr, item) {
  arr.indexOf(item) === -1 && arr.push(item);
}
function removeItem(arr, item) {
  var index2 = arr.indexOf(item);
  index2 > -1 && arr.splice(index2, 1);
}
var SubscriptionManager = (
  /** @class */
  function() {
    function SubscriptionManager2() {
      this.subscriptions = [];
    }
    SubscriptionManager2.prototype.add = function(handler) {
      var _this = this;
      addUniqueItem(this.subscriptions, handler);
      return function() {
        return removeItem(_this.subscriptions, handler);
      };
    };
    SubscriptionManager2.prototype.notify = function(a4, b3, c3) {
      var numSubscriptions = this.subscriptions.length;
      if (!numSubscriptions)
        return;
      if (numSubscriptions === 1) {
        this.subscriptions[0](a4, b3, c3);
      } else {
        for (var i3 = 0; i3 < numSubscriptions; i3++) {
          var handler = this.subscriptions[i3];
          handler && handler(a4, b3, c3);
        }
      }
    };
    SubscriptionManager2.prototype.getSize = function() {
      return this.subscriptions.length;
    };
    SubscriptionManager2.prototype.clear = function() {
      this.subscriptions.length = 0;
    };
    return SubscriptionManager2;
  }()
);
var isFloat = function(value) {
  return !isNaN(parseFloat(value));
};
var MotionValue = (
  /** @class */
  function() {
    function MotionValue2(init) {
      var _this = this;
      this.version = "6.5.1";
      this.timeDelta = 0;
      this.lastUpdated = 0;
      this.updateSubscribers = new SubscriptionManager();
      this.velocityUpdateSubscribers = new SubscriptionManager();
      this.renderSubscribers = new SubscriptionManager();
      this.canTrackVelocity = false;
      this.updateAndNotify = function(v2, render) {
        if (render === void 0) {
          render = true;
        }
        _this.prev = _this.current;
        _this.current = v2;
        var _a = getFrameData(), delta = _a.delta, timestamp = _a.timestamp;
        if (_this.lastUpdated !== timestamp) {
          _this.timeDelta = delta;
          _this.lastUpdated = timestamp;
          sync.postRender(_this.scheduleVelocityCheck);
        }
        if (_this.prev !== _this.current) {
          _this.updateSubscribers.notify(_this.current);
        }
        if (_this.velocityUpdateSubscribers.getSize()) {
          _this.velocityUpdateSubscribers.notify(_this.getVelocity());
        }
        if (render) {
          _this.renderSubscribers.notify(_this.current);
        }
      };
      this.scheduleVelocityCheck = function() {
        return sync.postRender(_this.velocityCheck);
      };
      this.velocityCheck = function(_a) {
        var timestamp = _a.timestamp;
        if (timestamp !== _this.lastUpdated) {
          _this.prev = _this.current;
          _this.velocityUpdateSubscribers.notify(_this.getVelocity());
        }
      };
      this.hasAnimated = false;
      this.prev = this.current = init;
      this.canTrackVelocity = isFloat(this.current);
    }
    MotionValue2.prototype.onChange = function(subscription) {
      return this.updateSubscribers.add(subscription);
    };
    MotionValue2.prototype.clearListeners = function() {
      this.updateSubscribers.clear();
    };
    MotionValue2.prototype.onRenderRequest = function(subscription) {
      subscription(this.get());
      return this.renderSubscribers.add(subscription);
    };
    MotionValue2.prototype.attach = function(passiveEffect) {
      this.passiveEffect = passiveEffect;
    };
    MotionValue2.prototype.set = function(v2, render) {
      if (render === void 0) {
        render = true;
      }
      if (!render || !this.passiveEffect) {
        this.updateAndNotify(v2, render);
      } else {
        this.passiveEffect(v2, this.updateAndNotify);
      }
    };
    MotionValue2.prototype.get = function() {
      return this.current;
    };
    MotionValue2.prototype.getPrevious = function() {
      return this.prev;
    };
    MotionValue2.prototype.getVelocity = function() {
      return this.canTrackVelocity ? (
        // These casts could be avoided if parseFloat would be typed better
        velocityPerSecond(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta)
      ) : 0;
    };
    MotionValue2.prototype.start = function(animation) {
      var _this = this;
      this.stop();
      return new Promise(function(resolve) {
        _this.hasAnimated = true;
        _this.stopAnimation = animation(resolve);
      }).then(function() {
        return _this.clearAnimation();
      });
    };
    MotionValue2.prototype.stop = function() {
      if (this.stopAnimation)
        this.stopAnimation();
      this.clearAnimation();
    };
    MotionValue2.prototype.isAnimating = function() {
      return !!this.stopAnimation;
    };
    MotionValue2.prototype.clearAnimation = function() {
      this.stopAnimation = null;
    };
    MotionValue2.prototype.destroy = function() {
      this.updateSubscribers.clear();
      this.renderSubscribers.clear();
      this.stop();
    };
    return MotionValue2;
  }()
);
function motionValue(init) {
  return new MotionValue(init);
}
var testValueType = function(v2) {
  return function(type) {
    return type.test(v2);
  };
};
var auto = {
  test: function(v2) {
    return v2 === "auto";
  },
  parse: function(v2) {
    return v2;
  }
};
var dimensionValueTypes = [number$3, px, percent, degrees, vw, vh, auto];
var findDimensionValueType = function(v2) {
  return dimensionValueTypes.find(testValueType(v2));
};
var valueTypes = __spreadArray$1(__spreadArray$1([], __read(dimensionValueTypes), false), [color$1, complex], false);
var findValueType = function(v2) {
  return valueTypes.find(testValueType(v2));
};
function setMotionValue(visualElement2, key, value) {
  if (visualElement2.hasValue(key)) {
    visualElement2.getValue(key).set(value);
  } else {
    visualElement2.addValue(key, motionValue(value));
  }
}
function setTarget(visualElement2, definition) {
  var resolved = resolveVariant(visualElement2, definition);
  var _a = resolved ? visualElement2.makeTargetAnimatable(resolved, false) : {}, _b = _a.transitionEnd, transitionEnd = _b === void 0 ? {} : _b;
  _a.transition;
  var target = __rest$1(_a, ["transitionEnd", "transition"]);
  target = __assign$1(__assign$1({}, target), transitionEnd);
  for (var key in target) {
    var value = resolveFinalValueInKeyframes(target[key]);
    setMotionValue(visualElement2, key, value);
  }
}
function setVariants(visualElement2, variantLabels) {
  var reversedLabels = __spreadArray$1([], __read(variantLabels), false).reverse();
  reversedLabels.forEach(function(key) {
    var _a;
    var variant = visualElement2.getVariant(key);
    variant && setTarget(visualElement2, variant);
    (_a = visualElement2.variantChildren) === null || _a === void 0 ? void 0 : _a.forEach(function(child) {
      setVariants(child, variantLabels);
    });
  });
}
function setValues(visualElement2, definition) {
  if (Array.isArray(definition)) {
    return setVariants(visualElement2, definition);
  } else if (typeof definition === "string") {
    return setVariants(visualElement2, [definition]);
  } else {
    setTarget(visualElement2, definition);
  }
}
function checkTargetForNewValues(visualElement2, target, origin) {
  var _a, _b, _c;
  var _d;
  var newValueKeys = Object.keys(target).filter(function(key2) {
    return !visualElement2.hasValue(key2);
  });
  var numNewValues = newValueKeys.length;
  if (!numNewValues)
    return;
  for (var i3 = 0; i3 < numNewValues; i3++) {
    var key = newValueKeys[i3];
    var targetValue = target[key];
    var value = null;
    if (Array.isArray(targetValue)) {
      value = targetValue[0];
    }
    if (value === null) {
      value = (_b = (_a = origin[key]) !== null && _a !== void 0 ? _a : visualElement2.readValue(key)) !== null && _b !== void 0 ? _b : target[key];
    }
    if (value === void 0 || value === null)
      continue;
    if (typeof value === "string" && (isNumericalString(value) || isZeroValueString(value))) {
      value = parseFloat(value);
    } else if (!findValueType(value) && complex.test(targetValue)) {
      value = getAnimatableNone(key, targetValue);
    }
    visualElement2.addValue(key, motionValue(value));
    (_c = (_d = origin)[key]) !== null && _c !== void 0 ? _c : _d[key] = value;
    visualElement2.setBaseTarget(key, value);
  }
}
function getOriginFromTransition(key, transition) {
  if (!transition)
    return;
  var valueTransition = transition[key] || transition["default"] || transition;
  return valueTransition.from;
}
function getOrigin(target, transition, visualElement2) {
  var _a, _b;
  var origin = {};
  for (var key in target) {
    origin[key] = (_a = getOriginFromTransition(key, transition)) !== null && _a !== void 0 ? _a : (_b = visualElement2.getValue(key)) === null || _b === void 0 ? void 0 : _b.get();
  }
  return origin;
}
function animateVisualElement(visualElement2, definition, options) {
  if (options === void 0) {
    options = {};
  }
  visualElement2.notifyAnimationStart(definition);
  var animation;
  if (Array.isArray(definition)) {
    var animations2 = definition.map(function(variant) {
      return animateVariant(visualElement2, variant, options);
    });
    animation = Promise.all(animations2);
  } else if (typeof definition === "string") {
    animation = animateVariant(visualElement2, definition, options);
  } else {
    var resolvedDefinition = typeof definition === "function" ? resolveVariant(visualElement2, definition, options.custom) : definition;
    animation = animateTarget(visualElement2, resolvedDefinition, options);
  }
  return animation.then(function() {
    return visualElement2.notifyAnimationComplete(definition);
  });
}
function animateVariant(visualElement2, variant, options) {
  var _a;
  if (options === void 0) {
    options = {};
  }
  var resolved = resolveVariant(visualElement2, variant, options.custom);
  var _b = (resolved || {}).transition, transition = _b === void 0 ? visualElement2.getDefaultTransition() || {} : _b;
  if (options.transitionOverride) {
    transition = options.transitionOverride;
  }
  var getAnimation2 = resolved ? function() {
    return animateTarget(visualElement2, resolved, options);
  } : function() {
    return Promise.resolve();
  };
  var getChildAnimations = ((_a = visualElement2.variantChildren) === null || _a === void 0 ? void 0 : _a.size) ? function(forwardDelay) {
    if (forwardDelay === void 0) {
      forwardDelay = 0;
    }
    var _a2 = transition.delayChildren, delayChildren = _a2 === void 0 ? 0 : _a2, staggerChildren = transition.staggerChildren, staggerDirection = transition.staggerDirection;
    return animateChildren(visualElement2, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
  } : function() {
    return Promise.resolve();
  };
  var when = transition.when;
  if (when) {
    var _c = __read(when === "beforeChildren" ? [getAnimation2, getChildAnimations] : [getChildAnimations, getAnimation2], 2), first = _c[0], last2 = _c[1];
    return first().then(last2);
  } else {
    return Promise.all([getAnimation2(), getChildAnimations(options.delay)]);
  }
}
function animateTarget(visualElement2, definition, _a) {
  var _b;
  var _c = _a === void 0 ? {} : _a, _d = _c.delay, delay = _d === void 0 ? 0 : _d, transitionOverride = _c.transitionOverride, type = _c.type;
  var _e = visualElement2.makeTargetAnimatable(definition), _f = _e.transition, transition = _f === void 0 ? visualElement2.getDefaultTransition() : _f, transitionEnd = _e.transitionEnd, target = __rest$1(_e, ["transition", "transitionEnd"]);
  if (transitionOverride)
    transition = transitionOverride;
  var animations2 = [];
  var animationTypeState = type && ((_b = visualElement2.animationState) === null || _b === void 0 ? void 0 : _b.getState()[type]);
  for (var key in target) {
    var value = visualElement2.getValue(key);
    var valueTarget = target[key];
    if (!value || valueTarget === void 0 || animationTypeState && shouldBlockAnimation(animationTypeState, key)) {
      continue;
    }
    var valueTransition = __assign$1({ delay }, transition);
    if (visualElement2.shouldReduceMotion && isTransformProp(key)) {
      valueTransition = __assign$1(__assign$1({}, valueTransition), { type: false, delay: 0 });
    }
    var animation = startAnimation(key, value, valueTarget, valueTransition);
    animations2.push(animation);
  }
  return Promise.all(animations2).then(function() {
    transitionEnd && setTarget(visualElement2, transitionEnd);
  });
}
function animateChildren(visualElement2, variant, delayChildren, staggerChildren, staggerDirection, options) {
  if (delayChildren === void 0) {
    delayChildren = 0;
  }
  if (staggerChildren === void 0) {
    staggerChildren = 0;
  }
  if (staggerDirection === void 0) {
    staggerDirection = 1;
  }
  var animations2 = [];
  var maxStaggerDuration = (visualElement2.variantChildren.size - 1) * staggerChildren;
  var generateStaggerDuration = staggerDirection === 1 ? function(i3) {
    if (i3 === void 0) {
      i3 = 0;
    }
    return i3 * staggerChildren;
  } : function(i3) {
    if (i3 === void 0) {
      i3 = 0;
    }
    return maxStaggerDuration - i3 * staggerChildren;
  };
  Array.from(visualElement2.variantChildren).sort(sortByTreeOrder).forEach(function(child, i3) {
    animations2.push(animateVariant(child, variant, __assign$1(__assign$1({}, options), { delay: delayChildren + generateStaggerDuration(i3) })).then(function() {
      return child.notifyAnimationComplete(variant);
    }));
  });
  return Promise.all(animations2);
}
function stopAnimation(visualElement2) {
  visualElement2.forEachValue(function(value) {
    return value.stop();
  });
}
function sortByTreeOrder(a4, b3) {
  return a4.sortNodePosition(b3);
}
function shouldBlockAnimation(_a, key) {
  var protectedKeys = _a.protectedKeys, needsAnimating = _a.needsAnimating;
  var shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
  needsAnimating[key] = false;
  return shouldBlock;
}
var variantPriorityOrder = [
  AnimationType.Animate,
  AnimationType.InView,
  AnimationType.Focus,
  AnimationType.Hover,
  AnimationType.Tap,
  AnimationType.Drag,
  AnimationType.Exit
];
var reversePriorityOrder = __spreadArray$1([], __read(variantPriorityOrder), false).reverse();
var numAnimationTypes = variantPriorityOrder.length;
function animateList(visualElement2) {
  return function(animations2) {
    return Promise.all(animations2.map(function(_a) {
      var animation = _a.animation, options = _a.options;
      return animateVisualElement(visualElement2, animation, options);
    }));
  };
}
function createAnimationState(visualElement2) {
  var animate2 = animateList(visualElement2);
  var state = createState();
  var allAnimatedKeys = {};
  var isInitialRender = true;
  var buildResolvedTypeValues = function(acc, definition) {
    var resolved = resolveVariant(visualElement2, definition);
    if (resolved) {
      resolved.transition;
      var transitionEnd = resolved.transitionEnd, target = __rest$1(resolved, ["transition", "transitionEnd"]);
      acc = __assign$1(__assign$1(__assign$1({}, acc), target), transitionEnd);
    }
    return acc;
  };
  function isAnimated(key) {
    return allAnimatedKeys[key] !== void 0;
  }
  function setAnimateFunction(makeAnimator) {
    animate2 = makeAnimator(visualElement2);
  }
  function animateChanges(options, changedActiveType) {
    var _a;
    var props = visualElement2.getProps();
    var context = visualElement2.getVariantContext(true) || {};
    var animations2 = [];
    var removedKeys = /* @__PURE__ */ new Set();
    var encounteredKeys = {};
    var removedVariantIndex = Infinity;
    var _loop_1 = function(i4) {
      var type = reversePriorityOrder[i4];
      var typeState = state[type];
      var prop = (_a = props[type]) !== null && _a !== void 0 ? _a : context[type];
      var propIsVariant = isVariantLabel(prop);
      var activeDelta = type === changedActiveType ? typeState.isActive : null;
      if (activeDelta === false)
        removedVariantIndex = i4;
      var isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
      if (isInherited && isInitialRender && visualElement2.manuallyAnimateOnMount) {
        isInherited = false;
      }
      typeState.protectedKeys = __assign$1({}, encounteredKeys);
      if (
        // If it isn't active and hasn't *just* been set as inactive
        !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
        !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
        isAnimationControls(prop) || typeof prop === "boolean"
      ) {
        return "continue";
      }
      var variantDidChange = checkVariantsDidChange(typeState.prevProp, prop);
      var shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
      type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
      i4 > removedVariantIndex && propIsVariant;
      var definitionList = Array.isArray(prop) ? prop : [prop];
      var resolvedValues = definitionList.reduce(buildResolvedTypeValues, {});
      if (activeDelta === false)
        resolvedValues = {};
      var _b = typeState.prevResolvedValues, prevResolvedValues = _b === void 0 ? {} : _b;
      var allKeys = __assign$1(__assign$1({}, prevResolvedValues), resolvedValues);
      var markToAnimate = function(key2) {
        shouldAnimateType = true;
        removedKeys.delete(key2);
        typeState.needsAnimating[key2] = true;
      };
      for (var key in allKeys) {
        var next = resolvedValues[key];
        var prev = prevResolvedValues[key];
        if (encounteredKeys.hasOwnProperty(key))
          continue;
        if (next !== prev) {
          if (isKeyframesTarget(next) && isKeyframesTarget(prev)) {
            if (!shallowCompare(next, prev) || variantDidChange) {
              markToAnimate(key);
            } else {
              typeState.protectedKeys[key] = true;
            }
          } else if (next !== void 0) {
            markToAnimate(key);
          } else {
            removedKeys.add(key);
          }
        } else if (next !== void 0 && removedKeys.has(key)) {
          markToAnimate(key);
        } else {
          typeState.protectedKeys[key] = true;
        }
      }
      typeState.prevProp = prop;
      typeState.prevResolvedValues = resolvedValues;
      if (typeState.isActive) {
        encounteredKeys = __assign$1(__assign$1({}, encounteredKeys), resolvedValues);
      }
      if (isInitialRender && visualElement2.blockInitialAnimation) {
        shouldAnimateType = false;
      }
      if (shouldAnimateType && !isInherited) {
        animations2.push.apply(animations2, __spreadArray$1([], __read(definitionList.map(function(animation) {
          return {
            animation,
            options: __assign$1({ type }, options)
          };
        })), false));
      }
    };
    for (var i3 = 0; i3 < numAnimationTypes; i3++) {
      _loop_1(i3);
    }
    allAnimatedKeys = __assign$1({}, encounteredKeys);
    if (removedKeys.size) {
      var fallbackAnimation_1 = {};
      removedKeys.forEach(function(key) {
        var fallbackTarget = visualElement2.getBaseTarget(key);
        if (fallbackTarget !== void 0) {
          fallbackAnimation_1[key] = fallbackTarget;
        }
      });
      animations2.push({ animation: fallbackAnimation_1 });
    }
    var shouldAnimate = Boolean(animations2.length);
    if (isInitialRender && props.initial === false && !visualElement2.manuallyAnimateOnMount) {
      shouldAnimate = false;
    }
    isInitialRender = false;
    return shouldAnimate ? animate2(animations2) : Promise.resolve();
  }
  function setActive(type, isActive, options) {
    var _a;
    if (state[type].isActive === isActive)
      return Promise.resolve();
    (_a = visualElement2.variantChildren) === null || _a === void 0 ? void 0 : _a.forEach(function(child) {
      var _a2;
      return (_a2 = child.animationState) === null || _a2 === void 0 ? void 0 : _a2.setActive(type, isActive);
    });
    state[type].isActive = isActive;
    var animations2 = animateChanges(options, type);
    for (var key in state) {
      state[key].protectedKeys = {};
    }
    return animations2;
  }
  return {
    isAnimated,
    animateChanges,
    setActive,
    setAnimateFunction,
    getState: function() {
      return state;
    }
  };
}
function checkVariantsDidChange(prev, next) {
  if (typeof next === "string") {
    return next !== prev;
  } else if (isVariantLabels(next)) {
    return !shallowCompare(next, prev);
  }
  return false;
}
function createTypeState(isActive) {
  if (isActive === void 0) {
    isActive = false;
  }
  return {
    isActive,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function createState() {
  var _a;
  return _a = {}, _a[AnimationType.Animate] = createTypeState(true), _a[AnimationType.InView] = createTypeState(), _a[AnimationType.Hover] = createTypeState(), _a[AnimationType.Tap] = createTypeState(), _a[AnimationType.Drag] = createTypeState(), _a[AnimationType.Focus] = createTypeState(), _a[AnimationType.Exit] = createTypeState(), _a;
}
var animations = {
  animation: makeRenderlessComponent(function(_a) {
    var visualElement2 = _a.visualElement, animate2 = _a.animate;
    visualElement2.animationState || (visualElement2.animationState = createAnimationState(visualElement2));
    if (isAnimationControls(animate2)) {
      useEffect(function() {
        return animate2.subscribe(visualElement2);
      }, [animate2]);
    }
  }),
  exit: makeRenderlessComponent(function(props) {
    var custom = props.custom, visualElement2 = props.visualElement;
    var _a = __read(usePresence(), 2), isPresent = _a[0], safeToRemove = _a[1];
    var presenceContext = useContext(PresenceContext);
    useEffect(function() {
      var _a2, _b;
      visualElement2.isPresent = isPresent;
      var animation = (_a2 = visualElement2.animationState) === null || _a2 === void 0 ? void 0 : _a2.setActive(AnimationType.Exit, !isPresent, { custom: (_b = presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.custom) !== null && _b !== void 0 ? _b : custom });
      !isPresent && (animation === null || animation === void 0 ? void 0 : animation.then(safeToRemove));
    }, [isPresent]);
  })
};
var PanSession = (
  /** @class */
  function() {
    function PanSession2(event, handlers, _a) {
      var _this = this;
      var _b = _a === void 0 ? {} : _a, transformPagePoint = _b.transformPagePoint;
      this.startEvent = null;
      this.lastMoveEvent = null;
      this.lastMoveEventInfo = null;
      this.handlers = {};
      this.updatePoint = function() {
        if (!(_this.lastMoveEvent && _this.lastMoveEventInfo))
          return;
        var info2 = getPanInfo(_this.lastMoveEventInfo, _this.history);
        var isPanStarted = _this.startEvent !== null;
        var isDistancePastThreshold = distance(info2.offset, { x: 0, y: 0 }) >= 3;
        if (!isPanStarted && !isDistancePastThreshold)
          return;
        var point3 = info2.point;
        var timestamp2 = getFrameData().timestamp;
        _this.history.push(__assign$1(__assign$1({}, point3), { timestamp: timestamp2 }));
        var _a2 = _this.handlers, onStart = _a2.onStart, onMove = _a2.onMove;
        if (!isPanStarted) {
          onStart && onStart(_this.lastMoveEvent, info2);
          _this.startEvent = _this.lastMoveEvent;
        }
        onMove && onMove(_this.lastMoveEvent, info2);
      };
      this.handlePointerMove = function(event2, info2) {
        _this.lastMoveEvent = event2;
        _this.lastMoveEventInfo = transformPoint(info2, _this.transformPagePoint);
        if (isMouseEvent(event2) && event2.buttons === 0) {
          _this.handlePointerUp(event2, info2);
          return;
        }
        sync.update(_this.updatePoint, true);
      };
      this.handlePointerUp = function(event2, info2) {
        _this.end();
        var _a2 = _this.handlers, onEnd = _a2.onEnd, onSessionEnd = _a2.onSessionEnd;
        var panInfo = getPanInfo(transformPoint(info2, _this.transformPagePoint), _this.history);
        if (_this.startEvent && onEnd) {
          onEnd(event2, panInfo);
        }
        onSessionEnd && onSessionEnd(event2, panInfo);
      };
      if (isTouchEvent$1(event) && event.touches.length > 1)
        return;
      this.handlers = handlers;
      this.transformPagePoint = transformPagePoint;
      var info = extractEventInfo(event);
      var initialInfo = transformPoint(info, this.transformPagePoint);
      var point2 = initialInfo.point;
      var timestamp = getFrameData().timestamp;
      this.history = [__assign$1(__assign$1({}, point2), { timestamp })];
      var onSessionStart = handlers.onSessionStart;
      onSessionStart && onSessionStart(event, getPanInfo(initialInfo, this.history));
      this.removeListeners = pipe(addPointerEvent(window, "pointermove", this.handlePointerMove), addPointerEvent(window, "pointerup", this.handlePointerUp), addPointerEvent(window, "pointercancel", this.handlePointerUp));
    }
    PanSession2.prototype.updateHandlers = function(handlers) {
      this.handlers = handlers;
    };
    PanSession2.prototype.end = function() {
      this.removeListeners && this.removeListeners();
      cancelSync.update(this.updatePoint);
    };
    return PanSession2;
  }()
);
function transformPoint(info, transformPagePoint) {
  return transformPagePoint ? { point: transformPagePoint(info.point) } : info;
}
function subtractPoint(a4, b3) {
  return { x: a4.x - b3.x, y: a4.y - b3.y };
}
function getPanInfo(_a, history) {
  var point2 = _a.point;
  return {
    point: point2,
    delta: subtractPoint(point2, lastDevicePoint(history)),
    offset: subtractPoint(point2, startDevicePoint(history)),
    velocity: getVelocity(history, 0.1)
  };
}
function startDevicePoint(history) {
  return history[0];
}
function lastDevicePoint(history) {
  return history[history.length - 1];
}
function getVelocity(history, timeDelta) {
  if (history.length < 2) {
    return { x: 0, y: 0 };
  }
  var i3 = history.length - 1;
  var timestampedPoint = null;
  var lastPoint = lastDevicePoint(history);
  while (i3 >= 0) {
    timestampedPoint = history[i3];
    if (lastPoint.timestamp - timestampedPoint.timestamp > secondsToMilliseconds(timeDelta)) {
      break;
    }
    i3--;
  }
  if (!timestampedPoint) {
    return { x: 0, y: 0 };
  }
  var time2 = (lastPoint.timestamp - timestampedPoint.timestamp) / 1e3;
  if (time2 === 0) {
    return { x: 0, y: 0 };
  }
  var currentVelocity = {
    x: (lastPoint.x - timestampedPoint.x) / time2,
    y: (lastPoint.y - timestampedPoint.y) / time2
  };
  if (currentVelocity.x === Infinity) {
    currentVelocity.x = 0;
  }
  if (currentVelocity.y === Infinity) {
    currentVelocity.y = 0;
  }
  return currentVelocity;
}
function calcLength(axis) {
  return axis.max - axis.min;
}
function isNear(value, target, maxDistance) {
  if (target === void 0) {
    target = 0;
  }
  if (maxDistance === void 0) {
    maxDistance = 0.01;
  }
  return distance(value, target) < maxDistance;
}
function calcAxisDelta(delta, source, target, origin) {
  if (origin === void 0) {
    origin = 0.5;
  }
  delta.origin = origin;
  delta.originPoint = mix(source.min, source.max, delta.origin);
  delta.scale = calcLength(target) / calcLength(source);
  if (isNear(delta.scale, 1, 1e-4) || isNaN(delta.scale))
    delta.scale = 1;
  delta.translate = mix(target.min, target.max, delta.origin) - delta.originPoint;
  if (isNear(delta.translate) || isNaN(delta.translate))
    delta.translate = 0;
}
function calcBoxDelta(delta, source, target, origin) {
  calcAxisDelta(delta.x, source.x, target.x, origin === null || origin === void 0 ? void 0 : origin.originX);
  calcAxisDelta(delta.y, source.y, target.y, origin === null || origin === void 0 ? void 0 : origin.originY);
}
function calcRelativeAxis(target, relative, parent) {
  target.min = parent.min + relative.min;
  target.max = target.min + calcLength(relative);
}
function calcRelativeBox(target, relative, parent) {
  calcRelativeAxis(target.x, relative.x, parent.x);
  calcRelativeAxis(target.y, relative.y, parent.y);
}
function calcRelativeAxisPosition(target, layout, parent) {
  target.min = layout.min - parent.min;
  target.max = target.min + calcLength(layout);
}
function calcRelativePosition(target, layout, parent) {
  calcRelativeAxisPosition(target.x, layout.x, parent.x);
  calcRelativeAxisPosition(target.y, layout.y, parent.y);
}
function applyConstraints(point2, _a, elastic) {
  var min2 = _a.min, max2 = _a.max;
  if (min2 !== void 0 && point2 < min2) {
    point2 = elastic ? mix(min2, point2, elastic.min) : Math.max(point2, min2);
  } else if (max2 !== void 0 && point2 > max2) {
    point2 = elastic ? mix(max2, point2, elastic.max) : Math.min(point2, max2);
  }
  return point2;
}
function calcRelativeAxisConstraints(axis, min2, max2) {
  return {
    min: min2 !== void 0 ? axis.min + min2 : void 0,
    max: max2 !== void 0 ? axis.max + max2 - (axis.max - axis.min) : void 0
  };
}
function calcRelativeConstraints(layoutBox, _a) {
  var top = _a.top, left = _a.left, bottom = _a.bottom, right = _a.right;
  return {
    x: calcRelativeAxisConstraints(layoutBox.x, left, right),
    y: calcRelativeAxisConstraints(layoutBox.y, top, bottom)
  };
}
function calcViewportAxisConstraints(layoutAxis, constraintsAxis) {
  var _a;
  var min2 = constraintsAxis.min - layoutAxis.min;
  var max2 = constraintsAxis.max - layoutAxis.max;
  if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) {
    _a = __read([max2, min2], 2), min2 = _a[0], max2 = _a[1];
  }
  return { min: min2, max: max2 };
}
function calcViewportConstraints(layoutBox, constraintsBox) {
  return {
    x: calcViewportAxisConstraints(layoutBox.x, constraintsBox.x),
    y: calcViewportAxisConstraints(layoutBox.y, constraintsBox.y)
  };
}
function calcOrigin(source, target) {
  var origin = 0.5;
  var sourceLength = calcLength(source);
  var targetLength = calcLength(target);
  if (targetLength > sourceLength) {
    origin = progress(target.min, target.max - sourceLength, source.min);
  } else if (sourceLength > targetLength) {
    origin = progress(source.min, source.max - targetLength, target.min);
  }
  return clamp(0, 1, origin);
}
function rebaseAxisConstraints(layout, constraints) {
  var relativeConstraints = {};
  if (constraints.min !== void 0) {
    relativeConstraints.min = constraints.min - layout.min;
  }
  if (constraints.max !== void 0) {
    relativeConstraints.max = constraints.max - layout.min;
  }
  return relativeConstraints;
}
var defaultElastic = 0.35;
function resolveDragElastic(dragElastic) {
  if (dragElastic === void 0) {
    dragElastic = defaultElastic;
  }
  if (dragElastic === false) {
    dragElastic = 0;
  } else if (dragElastic === true) {
    dragElastic = defaultElastic;
  }
  return {
    x: resolveAxisElastic(dragElastic, "left", "right"),
    y: resolveAxisElastic(dragElastic, "top", "bottom")
  };
}
function resolveAxisElastic(dragElastic, minLabel, maxLabel) {
  return {
    min: resolvePointElastic(dragElastic, minLabel),
    max: resolvePointElastic(dragElastic, maxLabel)
  };
}
function resolvePointElastic(dragElastic, label) {
  var _a;
  return typeof dragElastic === "number" ? dragElastic : (_a = dragElastic[label]) !== null && _a !== void 0 ? _a : 0;
}
var createAxisDelta = function() {
  return {
    translate: 0,
    scale: 1,
    origin: 0,
    originPoint: 0
  };
};
var createDelta = function() {
  return {
    x: createAxisDelta(),
    y: createAxisDelta()
  };
};
var createAxis = function() {
  return { min: 0, max: 0 };
};
var createBox = function() {
  return {
    x: createAxis(),
    y: createAxis()
  };
};
function eachAxis(callback) {
  return [callback("x"), callback("y")];
}
function convertBoundingBoxToBox(_a) {
  var top = _a.top, left = _a.left, right = _a.right, bottom = _a.bottom;
  return {
    x: { min: left, max: right },
    y: { min: top, max: bottom }
  };
}
function convertBoxToBoundingBox(_a) {
  var x3 = _a.x, y4 = _a.y;
  return { top: y4.min, right: x3.max, bottom: y4.max, left: x3.min };
}
function transformBoxPoints(point2, transformPoint2) {
  if (!transformPoint2)
    return point2;
  var topLeft = transformPoint2({ x: point2.left, y: point2.top });
  var bottomRight = transformPoint2({ x: point2.right, y: point2.bottom });
  return {
    top: topLeft.y,
    left: topLeft.x,
    bottom: bottomRight.y,
    right: bottomRight.x
  };
}
function isIdentityScale(scale2) {
  return scale2 === void 0 || scale2 === 1;
}
function hasScale(_a) {
  var scale2 = _a.scale, scaleX = _a.scaleX, scaleY = _a.scaleY;
  return !isIdentityScale(scale2) || !isIdentityScale(scaleX) || !isIdentityScale(scaleY);
}
function hasTransform(values) {
  return hasScale(values) || hasTranslate(values.x) || hasTranslate(values.y) || values.z || values.rotate || values.rotateX || values.rotateY;
}
function hasTranslate(value) {
  return value && value !== "0%";
}
function scalePoint(point2, scale2, originPoint) {
  var distanceFromOrigin = point2 - originPoint;
  var scaled = scale2 * distanceFromOrigin;
  return originPoint + scaled;
}
function applyPointDelta(point2, translate, scale2, originPoint, boxScale) {
  if (boxScale !== void 0) {
    point2 = scalePoint(point2, boxScale, originPoint);
  }
  return scalePoint(point2, scale2, originPoint) + translate;
}
function applyAxisDelta(axis, translate, scale2, originPoint, boxScale) {
  if (translate === void 0) {
    translate = 0;
  }
  if (scale2 === void 0) {
    scale2 = 1;
  }
  axis.min = applyPointDelta(axis.min, translate, scale2, originPoint, boxScale);
  axis.max = applyPointDelta(axis.max, translate, scale2, originPoint, boxScale);
}
function applyBoxDelta(box, _a) {
  var x3 = _a.x, y4 = _a.y;
  applyAxisDelta(box.x, x3.translate, x3.scale, x3.originPoint);
  applyAxisDelta(box.y, y4.translate, y4.scale, y4.originPoint);
}
function applyTreeDeltas(box, treeScale, treePath, isSharedTransition) {
  var _a, _b;
  if (isSharedTransition === void 0) {
    isSharedTransition = false;
  }
  var treeLength = treePath.length;
  if (!treeLength)
    return;
  treeScale.x = treeScale.y = 1;
  var node;
  var delta;
  for (var i3 = 0; i3 < treeLength; i3++) {
    node = treePath[i3];
    delta = node.projectionDelta;
    if (((_b = (_a = node.instance) === null || _a === void 0 ? void 0 : _a.style) === null || _b === void 0 ? void 0 : _b.display) === "contents")
      continue;
    if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) {
      transformBox(box, { x: -node.scroll.x, y: -node.scroll.y });
    }
    if (delta) {
      treeScale.x *= delta.x.scale;
      treeScale.y *= delta.y.scale;
      applyBoxDelta(box, delta);
    }
    if (isSharedTransition && hasTransform(node.latestValues)) {
      transformBox(box, node.latestValues);
    }
  }
}
function translateAxis(axis, distance2) {
  axis.min = axis.min + distance2;
  axis.max = axis.max + distance2;
}
function transformAxis(axis, transforms, _a) {
  var _b = __read(_a, 3), key = _b[0], scaleKey = _b[1], originKey = _b[2];
  var axisOrigin = transforms[originKey] !== void 0 ? transforms[originKey] : 0.5;
  var originPoint = mix(axis.min, axis.max, axisOrigin);
  applyAxisDelta(axis, transforms[key], transforms[scaleKey], originPoint, transforms.scale);
}
var xKeys$1 = ["x", "scaleX", "originX"];
var yKeys$1 = ["y", "scaleY", "originY"];
function transformBox(box, transform) {
  transformAxis(box.x, transform, xKeys$1);
  transformAxis(box.y, transform, yKeys$1);
}
function measureViewportBox(instance, transformPoint2) {
  return convertBoundingBoxToBox(transformBoxPoints(instance.getBoundingClientRect(), transformPoint2));
}
function measurePageBox(element, rootProjectionNode2, transformPagePoint) {
  var viewportBox = measureViewportBox(element, transformPagePoint);
  var scroll2 = rootProjectionNode2.scroll;
  if (scroll2) {
    translateAxis(viewportBox.x, scroll2.x);
    translateAxis(viewportBox.y, scroll2.y);
  }
  return viewportBox;
}
var elementDragControls = /* @__PURE__ */ new WeakMap();
var VisualElementDragControls = (
  /** @class */
  function() {
    function VisualElementDragControls2(visualElement2) {
      this.openGlobalLock = null;
      this.isDragging = false;
      this.currentDirection = null;
      this.originPoint = { x: 0, y: 0 };
      this.constraints = false;
      this.hasMutatedConstraints = false;
      this.elastic = createBox();
      this.visualElement = visualElement2;
    }
    VisualElementDragControls2.prototype.start = function(originEvent, _a) {
      var _this = this;
      var _b = _a === void 0 ? {} : _a, _c = _b.snapToCursor, snapToCursor = _c === void 0 ? false : _c;
      if (this.visualElement.isPresent === false)
        return;
      var onSessionStart = function(event) {
        _this.stopAnimation();
        if (snapToCursor) {
          _this.snapToCursor(extractEventInfo(event, "page").point);
        }
      };
      var onStart = function(event, info) {
        var _a2;
        var _b2 = _this.getProps(), drag2 = _b2.drag, dragPropagation = _b2.dragPropagation, onDragStart = _b2.onDragStart;
        if (drag2 && !dragPropagation) {
          if (_this.openGlobalLock)
            _this.openGlobalLock();
          _this.openGlobalLock = getGlobalLock(drag2);
          if (!_this.openGlobalLock)
            return;
        }
        _this.isDragging = true;
        _this.currentDirection = null;
        _this.resolveConstraints();
        if (_this.visualElement.projection) {
          _this.visualElement.projection.isAnimationBlocked = true;
          _this.visualElement.projection.target = void 0;
        }
        eachAxis(function(axis) {
          var _a3, _b3;
          var current = _this.getAxisMotionValue(axis).get() || 0;
          if (percent.test(current)) {
            var measuredAxis = (_b3 = (_a3 = _this.visualElement.projection) === null || _a3 === void 0 ? void 0 : _a3.layout) === null || _b3 === void 0 ? void 0 : _b3.actual[axis];
            if (measuredAxis) {
              var length_1 = calcLength(measuredAxis);
              current = length_1 * (parseFloat(current) / 100);
            }
          }
          _this.originPoint[axis] = current;
        });
        onDragStart === null || onDragStart === void 0 ? void 0 : onDragStart(event, info);
        (_a2 = _this.visualElement.animationState) === null || _a2 === void 0 ? void 0 : _a2.setActive(AnimationType.Drag, true);
      };
      var onMove = function(event, info) {
        var _a2 = _this.getProps(), dragPropagation = _a2.dragPropagation, dragDirectionLock = _a2.dragDirectionLock, onDirectionLock = _a2.onDirectionLock, onDrag = _a2.onDrag;
        if (!dragPropagation && !_this.openGlobalLock)
          return;
        var offset2 = info.offset;
        if (dragDirectionLock && _this.currentDirection === null) {
          _this.currentDirection = getCurrentDirection(offset2);
          if (_this.currentDirection !== null) {
            onDirectionLock === null || onDirectionLock === void 0 ? void 0 : onDirectionLock(_this.currentDirection);
          }
          return;
        }
        _this.updateAxis("x", info.point, offset2);
        _this.updateAxis("y", info.point, offset2);
        _this.visualElement.syncRender();
        onDrag === null || onDrag === void 0 ? void 0 : onDrag(event, info);
      };
      var onSessionEnd = function(event, info) {
        return _this.stop(event, info);
      };
      this.panSession = new PanSession(originEvent, {
        onSessionStart,
        onStart,
        onMove,
        onSessionEnd
      }, { transformPagePoint: this.visualElement.getTransformPagePoint() });
    };
    VisualElementDragControls2.prototype.stop = function(event, info) {
      var isDragging = this.isDragging;
      this.cancel();
      if (!isDragging)
        return;
      var velocity = info.velocity;
      this.startAnimation(velocity);
      var onDragEnd = this.getProps().onDragEnd;
      onDragEnd === null || onDragEnd === void 0 ? void 0 : onDragEnd(event, info);
    };
    VisualElementDragControls2.prototype.cancel = function() {
      var _a, _b;
      this.isDragging = false;
      if (this.visualElement.projection) {
        this.visualElement.projection.isAnimationBlocked = false;
      }
      (_a = this.panSession) === null || _a === void 0 ? void 0 : _a.end();
      this.panSession = void 0;
      var dragPropagation = this.getProps().dragPropagation;
      if (!dragPropagation && this.openGlobalLock) {
        this.openGlobalLock();
        this.openGlobalLock = null;
      }
      (_b = this.visualElement.animationState) === null || _b === void 0 ? void 0 : _b.setActive(AnimationType.Drag, false);
    };
    VisualElementDragControls2.prototype.updateAxis = function(axis, _point, offset2) {
      var drag2 = this.getProps().drag;
      if (!offset2 || !shouldDrag(axis, drag2, this.currentDirection))
        return;
      var axisValue = this.getAxisMotionValue(axis);
      var next = this.originPoint[axis] + offset2[axis];
      if (this.constraints && this.constraints[axis]) {
        next = applyConstraints(next, this.constraints[axis], this.elastic[axis]);
      }
      axisValue.set(next);
    };
    VisualElementDragControls2.prototype.resolveConstraints = function() {
      var _this = this;
      var _a = this.getProps(), dragConstraints = _a.dragConstraints, dragElastic = _a.dragElastic;
      var layout = (this.visualElement.projection || {}).layout;
      var prevConstraints = this.constraints;
      if (dragConstraints && isRefObject(dragConstraints)) {
        if (!this.constraints) {
          this.constraints = this.resolveRefConstraints();
        }
      } else {
        if (dragConstraints && layout) {
          this.constraints = calcRelativeConstraints(layout.actual, dragConstraints);
        } else {
          this.constraints = false;
        }
      }
      this.elastic = resolveDragElastic(dragElastic);
      if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) {
        eachAxis(function(axis) {
          if (_this.getAxisMotionValue(axis)) {
            _this.constraints[axis] = rebaseAxisConstraints(layout.actual[axis], _this.constraints[axis]);
          }
        });
      }
    };
    VisualElementDragControls2.prototype.resolveRefConstraints = function() {
      var _a = this.getProps(), constraints = _a.dragConstraints, onMeasureDragConstraints = _a.onMeasureDragConstraints;
      if (!constraints || !isRefObject(constraints))
        return false;
      var constraintsElement = constraints.current;
      invariant$1(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
      var projection = this.visualElement.projection;
      if (!projection || !projection.layout)
        return false;
      var constraintsBox = measurePageBox(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
      var measuredConstraints = calcViewportConstraints(projection.layout.actual, constraintsBox);
      if (onMeasureDragConstraints) {
        var userConstraints = onMeasureDragConstraints(convertBoxToBoundingBox(measuredConstraints));
        this.hasMutatedConstraints = !!userConstraints;
        if (userConstraints) {
          measuredConstraints = convertBoundingBoxToBox(userConstraints);
        }
      }
      return measuredConstraints;
    };
    VisualElementDragControls2.prototype.startAnimation = function(velocity) {
      var _this = this;
      var _a = this.getProps(), drag2 = _a.drag, dragMomentum = _a.dragMomentum, dragElastic = _a.dragElastic, dragTransition = _a.dragTransition, dragSnapToOrigin = _a.dragSnapToOrigin, onDragTransitionEnd = _a.onDragTransitionEnd;
      var constraints = this.constraints || {};
      var momentumAnimations = eachAxis(function(axis) {
        var _a2;
        if (!shouldDrag(axis, drag2, _this.currentDirection)) {
          return;
        }
        var transition = (_a2 = constraints === null || constraints === void 0 ? void 0 : constraints[axis]) !== null && _a2 !== void 0 ? _a2 : {};
        if (dragSnapToOrigin)
          transition = { min: 0, max: 0 };
        var bounceStiffness = dragElastic ? 200 : 1e6;
        var bounceDamping = dragElastic ? 40 : 1e7;
        var inertia2 = __assign$1(__assign$1({ type: "inertia", velocity: dragMomentum ? velocity[axis] : 0, bounceStiffness, bounceDamping, timeConstant: 750, restDelta: 1, restSpeed: 10 }, dragTransition), transition);
        return _this.startAxisValueAnimation(axis, inertia2);
      });
      return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    };
    VisualElementDragControls2.prototype.startAxisValueAnimation = function(axis, transition) {
      var axisValue = this.getAxisMotionValue(axis);
      return startAnimation(axis, axisValue, 0, transition);
    };
    VisualElementDragControls2.prototype.stopAnimation = function() {
      var _this = this;
      eachAxis(function(axis) {
        return _this.getAxisMotionValue(axis).stop();
      });
    };
    VisualElementDragControls2.prototype.getAxisMotionValue = function(axis) {
      var _a, _b;
      var dragKey = "_drag" + axis.toUpperCase();
      var externalMotionValue = this.visualElement.getProps()[dragKey];
      return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (_b = (_a = this.visualElement.getProps().initial) === null || _a === void 0 ? void 0 : _a[axis]) !== null && _b !== void 0 ? _b : 0);
    };
    VisualElementDragControls2.prototype.snapToCursor = function(point2) {
      var _this = this;
      eachAxis(function(axis) {
        var drag2 = _this.getProps().drag;
        if (!shouldDrag(axis, drag2, _this.currentDirection))
          return;
        var projection = _this.visualElement.projection;
        var axisValue = _this.getAxisMotionValue(axis);
        if (projection && projection.layout) {
          var _a = projection.layout.actual[axis], min2 = _a.min, max2 = _a.max;
          axisValue.set(point2[axis] - mix(min2, max2, 0.5));
        }
      });
    };
    VisualElementDragControls2.prototype.scalePositionWithinConstraints = function() {
      var _this = this;
      var _a;
      var _b = this.getProps(), drag2 = _b.drag, dragConstraints = _b.dragConstraints;
      var projection = this.visualElement.projection;
      if (!isRefObject(dragConstraints) || !projection || !this.constraints)
        return;
      this.stopAnimation();
      var boxProgress = { x: 0, y: 0 };
      eachAxis(function(axis) {
        var axisValue = _this.getAxisMotionValue(axis);
        if (axisValue) {
          var latest = axisValue.get();
          boxProgress[axis] = calcOrigin({ min: latest, max: latest }, _this.constraints[axis]);
        }
      });
      var transformTemplate = this.visualElement.getProps().transformTemplate;
      this.visualElement.getInstance().style.transform = transformTemplate ? transformTemplate({}, "") : "none";
      (_a = projection.root) === null || _a === void 0 ? void 0 : _a.updateScroll();
      projection.updateLayout();
      this.resolveConstraints();
      eachAxis(function(axis) {
        if (!shouldDrag(axis, drag2, null))
          return;
        var axisValue = _this.getAxisMotionValue(axis);
        var _a2 = _this.constraints[axis], min2 = _a2.min, max2 = _a2.max;
        axisValue.set(mix(min2, max2, boxProgress[axis]));
      });
    };
    VisualElementDragControls2.prototype.addListeners = function() {
      var _this = this;
      var _a;
      elementDragControls.set(this.visualElement, this);
      var element = this.visualElement.getInstance();
      var stopPointerListener = addPointerEvent(element, "pointerdown", function(event) {
        var _a2 = _this.getProps(), drag2 = _a2.drag, _b = _a2.dragListener, dragListener = _b === void 0 ? true : _b;
        drag2 && dragListener && _this.start(event);
      });
      var measureDragConstraints = function() {
        var dragConstraints = _this.getProps().dragConstraints;
        if (isRefObject(dragConstraints)) {
          _this.constraints = _this.resolveRefConstraints();
        }
      };
      var projection = this.visualElement.projection;
      var stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
      if (projection && !projection.layout) {
        (_a = projection.root) === null || _a === void 0 ? void 0 : _a.updateScroll();
        projection.updateLayout();
      }
      measureDragConstraints();
      var stopResizeListener = addDomEvent(window, "resize", function() {
        return _this.scalePositionWithinConstraints();
      });
      projection.addEventListener("didUpdate", function(_a2) {
        var delta = _a2.delta, hasLayoutChanged = _a2.hasLayoutChanged;
        if (_this.isDragging && hasLayoutChanged) {
          eachAxis(function(axis) {
            var motionValue2 = _this.getAxisMotionValue(axis);
            if (!motionValue2)
              return;
            _this.originPoint[axis] += delta[axis].translate;
            motionValue2.set(motionValue2.get() + delta[axis].translate);
          });
          _this.visualElement.syncRender();
        }
      });
      return function() {
        stopResizeListener();
        stopPointerListener();
        stopMeasureLayoutListener();
      };
    };
    VisualElementDragControls2.prototype.getProps = function() {
      var props = this.visualElement.getProps();
      var _a = props.drag, drag2 = _a === void 0 ? false : _a, _b = props.dragDirectionLock, dragDirectionLock = _b === void 0 ? false : _b, _c = props.dragPropagation, dragPropagation = _c === void 0 ? false : _c, _d = props.dragConstraints, dragConstraints = _d === void 0 ? false : _d, _e = props.dragElastic, dragElastic = _e === void 0 ? defaultElastic : _e, _f = props.dragMomentum, dragMomentum = _f === void 0 ? true : _f;
      return __assign$1(__assign$1({}, props), { drag: drag2, dragDirectionLock, dragPropagation, dragConstraints, dragElastic, dragMomentum });
    };
    return VisualElementDragControls2;
  }()
);
function shouldDrag(direction, drag2, currentDirection) {
  return (drag2 === true || drag2 === direction) && (currentDirection === null || currentDirection === direction);
}
function getCurrentDirection(offset2, lockThreshold) {
  if (lockThreshold === void 0) {
    lockThreshold = 10;
  }
  var direction = null;
  if (Math.abs(offset2.y) > lockThreshold) {
    direction = "y";
  } else if (Math.abs(offset2.x) > lockThreshold) {
    direction = "x";
  }
  return direction;
}
function useDrag(props) {
  var groupDragControls = props.dragControls, visualElement2 = props.visualElement;
  var dragControls = useConstant(function() {
    return new VisualElementDragControls(visualElement2);
  });
  useEffect(function() {
    return groupDragControls && groupDragControls.subscribe(dragControls);
  }, [dragControls, groupDragControls]);
  useEffect(function() {
    return dragControls.addListeners();
  }, [dragControls]);
}
function usePanGesture(_a) {
  var onPan = _a.onPan, onPanStart = _a.onPanStart, onPanEnd = _a.onPanEnd, onPanSessionStart = _a.onPanSessionStart, visualElement2 = _a.visualElement;
  var hasPanEvents = onPan || onPanStart || onPanEnd || onPanSessionStart;
  var panSession = useRef(null);
  var transformPagePoint = useContext(MotionConfigContext).transformPagePoint;
  var handlers = {
    onSessionStart: onPanSessionStart,
    onStart: onPanStart,
    onMove: onPan,
    onEnd: function(event, info) {
      panSession.current = null;
      onPanEnd && onPanEnd(event, info);
    }
  };
  useEffect(function() {
    if (panSession.current !== null) {
      panSession.current.updateHandlers(handlers);
    }
  });
  function onPointerDown(event) {
    panSession.current = new PanSession(event, handlers, {
      transformPagePoint
    });
  }
  usePointerEvent(visualElement2, "pointerdown", hasPanEvents && onPointerDown);
  useUnmountEffect(function() {
    return panSession.current && panSession.current.end();
  });
}
var drag = {
  pan: makeRenderlessComponent(usePanGesture),
  drag: makeRenderlessComponent(useDrag)
};
var names = [
  "LayoutMeasure",
  "BeforeLayoutMeasure",
  "LayoutUpdate",
  "ViewportBoxUpdate",
  "Update",
  "Render",
  "AnimationComplete",
  "LayoutAnimationComplete",
  "AnimationStart",
  "LayoutAnimationStart",
  "SetAxisTarget",
  "Unmount"
];
function createLifecycles() {
  var managers = names.map(function() {
    return new SubscriptionManager();
  });
  var propSubscriptions = {};
  var lifecycles = {
    clearAllListeners: function() {
      return managers.forEach(function(manager) {
        return manager.clear();
      });
    },
    updatePropListeners: function(props) {
      names.forEach(function(name) {
        var _a;
        var on2 = "on" + name;
        var propListener = props[on2];
        (_a = propSubscriptions[name]) === null || _a === void 0 ? void 0 : _a.call(propSubscriptions);
        if (propListener) {
          propSubscriptions[name] = lifecycles[on2](propListener);
        }
      });
    }
  };
  managers.forEach(function(manager, i3) {
    lifecycles["on" + names[i3]] = function(handler) {
      return manager.add(handler);
    };
    lifecycles["notify" + names[i3]] = function() {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      return manager.notify.apply(manager, __spreadArray$1([], __read(args), false));
    };
  });
  return lifecycles;
}
function updateMotionValuesFromProps(element, next, prev) {
  var _a;
  for (var key in next) {
    var nextValue = next[key];
    var prevValue = prev[key];
    if (isMotionValue(nextValue)) {
      element.addValue(key, nextValue);
      if (process.env.NODE_ENV === "development") {
        warnOnce(nextValue.version === "6.5.1", "Attempting to mix Framer Motion versions ".concat(nextValue.version, " with 6.5.1 may not work as expected."));
      }
    } else if (isMotionValue(prevValue)) {
      element.addValue(key, motionValue(nextValue));
    } else if (prevValue !== nextValue) {
      if (element.hasValue(key)) {
        var existingValue = element.getValue(key);
        !existingValue.hasAnimated && existingValue.set(nextValue);
      } else {
        element.addValue(key, motionValue((_a = element.getStaticValue(key)) !== null && _a !== void 0 ? _a : nextValue));
      }
    }
  }
  for (var key in prev) {
    if (next[key] === void 0)
      element.removeValue(key);
  }
  return next;
}
var visualElement = function(_a) {
  var _b = _a.treeType, treeType = _b === void 0 ? "" : _b, build = _a.build, getBaseTarget = _a.getBaseTarget, makeTargetAnimatable = _a.makeTargetAnimatable, measureViewportBox2 = _a.measureViewportBox, renderInstance = _a.render, readValueFromInstance = _a.readValueFromInstance, removeValueFromRenderState = _a.removeValueFromRenderState, sortNodePosition = _a.sortNodePosition, scrapeMotionValuesFromProps2 = _a.scrapeMotionValuesFromProps;
  return function(_a2, options) {
    var parent = _a2.parent, props = _a2.props, presenceId = _a2.presenceId, blockInitialAnimation = _a2.blockInitialAnimation, visualState = _a2.visualState, shouldReduceMotion = _a2.shouldReduceMotion;
    if (options === void 0) {
      options = {};
    }
    var isMounted = false;
    var latestValues = visualState.latestValues, renderState = visualState.renderState;
    var instance;
    var lifecycles = createLifecycles();
    var values = /* @__PURE__ */ new Map();
    var valueSubscriptions = /* @__PURE__ */ new Map();
    var prevMotionValues = {};
    var baseTarget = __assign$1({}, latestValues);
    var removeFromVariantTree;
    function render() {
      if (!instance || !isMounted)
        return;
      triggerBuild();
      renderInstance(instance, renderState, props.style, element.projection);
    }
    function triggerBuild() {
      build(element, renderState, latestValues, options, props);
    }
    function update2() {
      lifecycles.notifyUpdate(latestValues);
    }
    function bindToMotionValue(key2, value2) {
      var removeOnChange = value2.onChange(function(latestValue) {
        latestValues[key2] = latestValue;
        props.onUpdate && sync.update(update2, false, true);
      });
      var removeOnRenderRequest = value2.onRenderRequest(element.scheduleRender);
      valueSubscriptions.set(key2, function() {
        removeOnChange();
        removeOnRenderRequest();
      });
    }
    var initialMotionValues = scrapeMotionValuesFromProps2(props);
    for (var key in initialMotionValues) {
      var value = initialMotionValues[key];
      if (latestValues[key] !== void 0 && isMotionValue(value)) {
        value.set(latestValues[key], false);
      }
    }
    var isControllingVariants = checkIfControllingVariants(props);
    var isVariantNode = checkIfVariantNode(props);
    var element = __assign$1(__assign$1({
      treeType,
      /**
       * This is a mirror of the internal instance prop, which keeps
       * VisualElement type-compatible with React's RefObject.
       */
      current: null,
      /**
       * The depth of this visual element within the visual element tree.
       */
      depth: parent ? parent.depth + 1 : 0,
      parent,
      children: /* @__PURE__ */ new Set(),
      /**
       *
       */
      presenceId,
      shouldReduceMotion,
      /**
       * If this component is part of the variant tree, it should track
       * any children that are also part of the tree. This is essentially
       * a shadow tree to simplify logic around how to stagger over children.
       */
      variantChildren: isVariantNode ? /* @__PURE__ */ new Set() : void 0,
      /**
       * Whether this instance is visible. This can be changed imperatively
       * by the projection tree, is analogous to CSS's visibility in that
       * hidden elements should take up layout, and needs enacting by the configured
       * render function.
       */
      isVisible: void 0,
      /**
       * Normally, if a component is controlled by a parent's variants, it can
       * rely on that ancestor to trigger animations further down the tree.
       * However, if a component is created after its parent is mounted, the parent
       * won't trigger that mount animation so the child needs to.
       *
       * TODO: This might be better replaced with a method isParentMounted
       */
      manuallyAnimateOnMount: Boolean(parent === null || parent === void 0 ? void 0 : parent.isMounted()),
      /**
       * This can be set by AnimatePresence to force components that mount
       * at the same time as it to mount as if they have initial={false} set.
       */
      blockInitialAnimation,
      /**
       * Determine whether this component has mounted yet. This is mostly used
       * by variant children to determine whether they need to trigger their
       * own animations on mount.
       */
      isMounted: function() {
        return Boolean(instance);
      },
      mount: function(newInstance) {
        isMounted = true;
        instance = element.current = newInstance;
        if (element.projection) {
          element.projection.mount(newInstance);
        }
        if (isVariantNode && parent && !isControllingVariants) {
          removeFromVariantTree = parent === null || parent === void 0 ? void 0 : parent.addVariantChild(element);
        }
        values.forEach(function(value2, key2) {
          return bindToMotionValue(key2, value2);
        });
        parent === null || parent === void 0 ? void 0 : parent.children.add(element);
        element.setProps(props);
      },
      /**
       *
       */
      unmount: function() {
        var _a3;
        (_a3 = element.projection) === null || _a3 === void 0 ? void 0 : _a3.unmount();
        cancelSync.update(update2);
        cancelSync.render(render);
        valueSubscriptions.forEach(function(remove) {
          return remove();
        });
        removeFromVariantTree === null || removeFromVariantTree === void 0 ? void 0 : removeFromVariantTree();
        parent === null || parent === void 0 ? void 0 : parent.children.delete(element);
        lifecycles.clearAllListeners();
        instance = void 0;
        isMounted = false;
      },
      /**
       * Add a child visual element to our set of children.
       */
      addVariantChild: function(child) {
        var _a3;
        var closestVariantNode = element.getClosestVariantNode();
        if (closestVariantNode) {
          (_a3 = closestVariantNode.variantChildren) === null || _a3 === void 0 ? void 0 : _a3.add(child);
          return function() {
            return closestVariantNode.variantChildren.delete(child);
          };
        }
      },
      sortNodePosition: function(other) {
        if (!sortNodePosition || treeType !== other.treeType)
          return 0;
        return sortNodePosition(element.getInstance(), other.getInstance());
      },
      /**
       * Returns the closest variant node in the tree starting from
       * this visual element.
       */
      getClosestVariantNode: function() {
        return isVariantNode ? element : parent === null || parent === void 0 ? void 0 : parent.getClosestVariantNode();
      },
      /**
       * Expose the latest layoutId prop.
       */
      getLayoutId: function() {
        return props.layoutId;
      },
      /**
       * Returns the current instance.
       */
      getInstance: function() {
        return instance;
      },
      /**
       * Get/set the latest static values.
       */
      getStaticValue: function(key2) {
        return latestValues[key2];
      },
      setStaticValue: function(key2, value2) {
        return latestValues[key2] = value2;
      },
      /**
       * Returns the latest motion value state. Currently only used to take
       * a snapshot of the visual element - perhaps this can return the whole
       * visual state
       */
      getLatestValues: function() {
        return latestValues;
      },
      /**
       * Set the visiblity of the visual element. If it's changed, schedule
       * a render to reflect these changes.
       */
      setVisibility: function(visibility) {
        if (element.isVisible === visibility)
          return;
        element.isVisible = visibility;
        element.scheduleRender();
      },
      /**
       * Make a target animatable by Popmotion. For instance, if we're
       * trying to animate width from 100px to 100vw we need to measure 100vw
       * in pixels to determine what we really need to animate to. This is also
       * pluggable to support Framer's custom value types like Color,
       * and CSS variables.
       */
      makeTargetAnimatable: function(target, canMutate) {
        if (canMutate === void 0) {
          canMutate = true;
        }
        return makeTargetAnimatable(element, target, props, canMutate);
      },
      /**
       * Measure the current viewport box with or without transforms.
       * Only measures axis-aligned boxes, rotate and skew must be manually
       * removed with a re-render to work.
       */
      measureViewportBox: function() {
        return measureViewportBox2(instance, props);
      },
      // Motion values ========================
      /**
       * Add a motion value and bind it to this visual element.
       */
      addValue: function(key2, value2) {
        if (element.hasValue(key2))
          element.removeValue(key2);
        values.set(key2, value2);
        latestValues[key2] = value2.get();
        bindToMotionValue(key2, value2);
      },
      /**
       * Remove a motion value and unbind any active subscriptions.
       */
      removeValue: function(key2) {
        var _a3;
        values.delete(key2);
        (_a3 = valueSubscriptions.get(key2)) === null || _a3 === void 0 ? void 0 : _a3();
        valueSubscriptions.delete(key2);
        delete latestValues[key2];
        removeValueFromRenderState(key2, renderState);
      },
      /**
       * Check whether we have a motion value for this key
       */
      hasValue: function(key2) {
        return values.has(key2);
      },
      /**
       * Get a motion value for this key. If called with a default
       * value, we'll create one if none exists.
       */
      getValue: function(key2, defaultValue2) {
        var value2 = values.get(key2);
        if (value2 === void 0 && defaultValue2 !== void 0) {
          value2 = motionValue(defaultValue2);
          element.addValue(key2, value2);
        }
        return value2;
      },
      /**
       * Iterate over our motion values.
       */
      forEachValue: function(callback) {
        return values.forEach(callback);
      },
      /**
       * If we're trying to animate to a previously unencountered value,
       * we need to check for it in our state and as a last resort read it
       * directly from the instance (which might have performance implications).
       */
      readValue: function(key2) {
        var _a3;
        return (_a3 = latestValues[key2]) !== null && _a3 !== void 0 ? _a3 : readValueFromInstance(instance, key2, options);
      },
      /**
       * Set the base target to later animate back to. This is currently
       * only hydrated on creation and when we first read a value.
       */
      setBaseTarget: function(key2, value2) {
        baseTarget[key2] = value2;
      },
      /**
       * Find the base target for a value thats been removed from all animation
       * props.
       */
      getBaseTarget: function(key2) {
        if (getBaseTarget) {
          var target = getBaseTarget(props, key2);
          if (target !== void 0 && !isMotionValue(target))
            return target;
        }
        return baseTarget[key2];
      }
    }, lifecycles), {
      /**
       * Build the renderer state based on the latest visual state.
       */
      build: function() {
        triggerBuild();
        return renderState;
      },
      /**
       * Schedule a render on the next animation frame.
       */
      scheduleRender: function() {
        sync.render(render, false, true);
      },
      /**
       * Synchronously fire render. It's prefered that we batch renders but
       * in many circumstances, like layout measurement, we need to run this
       * synchronously. However in those instances other measures should be taken
       * to batch reads/writes.
       */
      syncRender: render,
      /**
       * Update the provided props. Ensure any newly-added motion values are
       * added to our map, old ones removed, and listeners updated.
       */
      setProps: function(newProps) {
        if (newProps.transformTemplate || props.transformTemplate) {
          element.scheduleRender();
        }
        props = newProps;
        lifecycles.updatePropListeners(newProps);
        prevMotionValues = updateMotionValuesFromProps(element, scrapeMotionValuesFromProps2(props), prevMotionValues);
      },
      getProps: function() {
        return props;
      },
      // Variants ==============================
      /**
       * Returns the variant definition with a given name.
       */
      getVariant: function(name) {
        var _a3;
        return (_a3 = props.variants) === null || _a3 === void 0 ? void 0 : _a3[name];
      },
      /**
       * Returns the defined default transition on this component.
       */
      getDefaultTransition: function() {
        return props.transition;
      },
      getTransformPagePoint: function() {
        return props.transformPagePoint;
      },
      /**
       * Used by child variant nodes to get the closest ancestor variant props.
       */
      getVariantContext: function(startAtParent) {
        if (startAtParent === void 0) {
          startAtParent = false;
        }
        if (startAtParent)
          return parent === null || parent === void 0 ? void 0 : parent.getVariantContext();
        if (!isControllingVariants) {
          var context_1 = (parent === null || parent === void 0 ? void 0 : parent.getVariantContext()) || {};
          if (props.initial !== void 0) {
            context_1.initial = props.initial;
          }
          return context_1;
        }
        var context = {};
        for (var i3 = 0; i3 < numVariantProps; i3++) {
          var name_1 = variantProps[i3];
          var prop = props[name_1];
          if (isVariantLabel(prop) || prop === false) {
            context[name_1] = prop;
          }
        }
        return context;
      }
    });
    return element;
  };
};
var variantProps = __spreadArray$1(["initial"], __read(variantPriorityOrder), false);
var numVariantProps = variantProps.length;
function isCSSVariable(value) {
  return typeof value === "string" && value.startsWith("var(--");
}
var cssVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function parseCSSVariable(current) {
  var match2 = cssVariableRegex.exec(current);
  if (!match2)
    return [,];
  var _a = __read(match2, 3), token = _a[1], fallback = _a[2];
  return [token, fallback];
}
var maxDepth = 4;
function getVariableValue(current, element, depth) {
  if (depth === void 0) {
    depth = 1;
  }
  invariant$1(depth <= maxDepth, 'Max CSS variable fallback depth detected in property "'.concat(current, '". This may indicate a circular fallback dependency.'));
  var _a = __read(parseCSSVariable(current), 2), token = _a[0], fallback = _a[1];
  if (!token)
    return;
  var resolved = window.getComputedStyle(element).getPropertyValue(token);
  if (resolved) {
    return resolved.trim();
  } else if (isCSSVariable(fallback)) {
    return getVariableValue(fallback, element, depth + 1);
  } else {
    return fallback;
  }
}
function resolveCSSVariables(visualElement2, _a, transitionEnd) {
  var _b;
  var target = __rest$1(_a, []);
  var element = visualElement2.getInstance();
  if (!(element instanceof Element))
    return { target, transitionEnd };
  if (transitionEnd) {
    transitionEnd = __assign$1({}, transitionEnd);
  }
  visualElement2.forEachValue(function(value) {
    var current2 = value.get();
    if (!isCSSVariable(current2))
      return;
    var resolved2 = getVariableValue(current2, element);
    if (resolved2)
      value.set(resolved2);
  });
  for (var key in target) {
    var current = target[key];
    if (!isCSSVariable(current))
      continue;
    var resolved = getVariableValue(current, element);
    if (!resolved)
      continue;
    target[key] = resolved;
    if (transitionEnd)
      (_b = transitionEnd[key]) !== null && _b !== void 0 ? _b : transitionEnd[key] = current;
  }
  return { target, transitionEnd };
}
var positionalKeys = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  "x",
  "y"
]);
var isPositionalKey = function(key) {
  return positionalKeys.has(key);
};
var hasPositionalKey = function(target) {
  return Object.keys(target).some(isPositionalKey);
};
var setAndResetVelocity = function(value, to) {
  value.set(to, false);
  value.set(to);
};
var isNumOrPxType = function(v2) {
  return v2 === number$3 || v2 === px;
};
var BoundingBoxDimension;
(function(BoundingBoxDimension2) {
  BoundingBoxDimension2["width"] = "width";
  BoundingBoxDimension2["height"] = "height";
  BoundingBoxDimension2["left"] = "left";
  BoundingBoxDimension2["right"] = "right";
  BoundingBoxDimension2["top"] = "top";
  BoundingBoxDimension2["bottom"] = "bottom";
})(BoundingBoxDimension || (BoundingBoxDimension = {}));
var getPosFromMatrix = function(matrix, pos) {
  return parseFloat(matrix.split(", ")[pos]);
};
var getTranslateFromMatrix = function(pos2, pos3) {
  return function(_bbox, _a) {
    var transform = _a.transform;
    if (transform === "none" || !transform)
      return 0;
    var matrix3d = transform.match(/^matrix3d\((.+)\)$/);
    if (matrix3d) {
      return getPosFromMatrix(matrix3d[1], pos3);
    } else {
      var matrix = transform.match(/^matrix\((.+)\)$/);
      if (matrix) {
        return getPosFromMatrix(matrix[1], pos2);
      } else {
        return 0;
      }
    }
  };
};
var transformKeys = /* @__PURE__ */ new Set(["x", "y", "z"]);
var nonTranslationalTransformKeys = transformProps.filter(function(key) {
  return !transformKeys.has(key);
});
function removeNonTranslationalTransform(visualElement2) {
  var removedTransforms = [];
  nonTranslationalTransformKeys.forEach(function(key) {
    var value = visualElement2.getValue(key);
    if (value !== void 0) {
      removedTransforms.push([key, value.get()]);
      value.set(key.startsWith("scale") ? 1 : 0);
    }
  });
  if (removedTransforms.length)
    visualElement2.syncRender();
  return removedTransforms;
}
var positionalValues = {
  // Dimensions
  width: function(_a, _b) {
    var x3 = _a.x;
    var _c = _b.paddingLeft, paddingLeft = _c === void 0 ? "0" : _c, _d = _b.paddingRight, paddingRight = _d === void 0 ? "0" : _d;
    return x3.max - x3.min - parseFloat(paddingLeft) - parseFloat(paddingRight);
  },
  height: function(_a, _b) {
    var y4 = _a.y;
    var _c = _b.paddingTop, paddingTop = _c === void 0 ? "0" : _c, _d = _b.paddingBottom, paddingBottom = _d === void 0 ? "0" : _d;
    return y4.max - y4.min - parseFloat(paddingTop) - parseFloat(paddingBottom);
  },
  top: function(_bbox, _a) {
    var top = _a.top;
    return parseFloat(top);
  },
  left: function(_bbox, _a) {
    var left = _a.left;
    return parseFloat(left);
  },
  bottom: function(_a, _b) {
    var y4 = _a.y;
    var top = _b.top;
    return parseFloat(top) + (y4.max - y4.min);
  },
  right: function(_a, _b) {
    var x3 = _a.x;
    var left = _b.left;
    return parseFloat(left) + (x3.max - x3.min);
  },
  // Transform
  x: getTranslateFromMatrix(4, 13),
  y: getTranslateFromMatrix(5, 14)
};
var convertChangedValueTypes = function(target, visualElement2, changedKeys) {
  var originBbox = visualElement2.measureViewportBox();
  var element = visualElement2.getInstance();
  var elementComputedStyle = getComputedStyle(element);
  var display = elementComputedStyle.display;
  var origin = {};
  if (display === "none") {
    visualElement2.setStaticValue("display", target.display || "block");
  }
  changedKeys.forEach(function(key) {
    origin[key] = positionalValues[key](originBbox, elementComputedStyle);
  });
  visualElement2.syncRender();
  var targetBbox = visualElement2.measureViewportBox();
  changedKeys.forEach(function(key) {
    var value = visualElement2.getValue(key);
    setAndResetVelocity(value, origin[key]);
    target[key] = positionalValues[key](targetBbox, elementComputedStyle);
  });
  return target;
};
var checkAndConvertChangedValueTypes = function(visualElement2, target, origin, transitionEnd) {
  if (origin === void 0) {
    origin = {};
  }
  if (transitionEnd === void 0) {
    transitionEnd = {};
  }
  target = __assign$1({}, target);
  transitionEnd = __assign$1({}, transitionEnd);
  var targetPositionalKeys = Object.keys(target).filter(isPositionalKey);
  var removedTransformValues = [];
  var hasAttemptedToRemoveTransformValues = false;
  var changedValueTypeKeys = [];
  targetPositionalKeys.forEach(function(key) {
    var value = visualElement2.getValue(key);
    if (!visualElement2.hasValue(key))
      return;
    var from = origin[key];
    var fromType = findDimensionValueType(from);
    var to = target[key];
    var toType;
    if (isKeyframesTarget(to)) {
      var numKeyframes = to.length;
      var fromIndex = to[0] === null ? 1 : 0;
      from = to[fromIndex];
      fromType = findDimensionValueType(from);
      for (var i3 = fromIndex; i3 < numKeyframes; i3++) {
        if (!toType) {
          toType = findDimensionValueType(to[i3]);
          invariant$1(toType === fromType || isNumOrPxType(fromType) && isNumOrPxType(toType), "Keyframes must be of the same dimension as the current value");
        } else {
          invariant$1(findDimensionValueType(to[i3]) === toType, "All keyframes must be of the same type");
        }
      }
    } else {
      toType = findDimensionValueType(to);
    }
    if (fromType !== toType) {
      if (isNumOrPxType(fromType) && isNumOrPxType(toType)) {
        var current = value.get();
        if (typeof current === "string") {
          value.set(parseFloat(current));
        }
        if (typeof to === "string") {
          target[key] = parseFloat(to);
        } else if (Array.isArray(to) && toType === px) {
          target[key] = to.map(parseFloat);
        }
      } else if ((fromType === null || fromType === void 0 ? void 0 : fromType.transform) && (toType === null || toType === void 0 ? void 0 : toType.transform) && (from === 0 || to === 0)) {
        if (from === 0) {
          value.set(toType.transform(from));
        } else {
          target[key] = fromType.transform(to);
        }
      } else {
        if (!hasAttemptedToRemoveTransformValues) {
          removedTransformValues = removeNonTranslationalTransform(visualElement2);
          hasAttemptedToRemoveTransformValues = true;
        }
        changedValueTypeKeys.push(key);
        transitionEnd[key] = transitionEnd[key] !== void 0 ? transitionEnd[key] : target[key];
        setAndResetVelocity(value, to);
      }
    }
  });
  if (changedValueTypeKeys.length) {
    var scrollY_1 = changedValueTypeKeys.indexOf("height") >= 0 ? window.pageYOffset : null;
    var convertedTarget = convertChangedValueTypes(target, visualElement2, changedValueTypeKeys);
    if (removedTransformValues.length) {
      removedTransformValues.forEach(function(_a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        visualElement2.getValue(key).set(value);
      });
    }
    visualElement2.syncRender();
    if (scrollY_1 !== null)
      window.scrollTo({ top: scrollY_1 });
    return { target: convertedTarget, transitionEnd };
  } else {
    return { target, transitionEnd };
  }
};
function unitConversion(visualElement2, target, origin, transitionEnd) {
  return hasPositionalKey(target) ? checkAndConvertChangedValueTypes(visualElement2, target, origin, transitionEnd) : { target, transitionEnd };
}
var parseDomVariant = function(visualElement2, target, origin, transitionEnd) {
  var resolved = resolveCSSVariables(visualElement2, target, transitionEnd);
  target = resolved.target;
  transitionEnd = resolved.transitionEnd;
  return unitConversion(visualElement2, target, origin, transitionEnd);
};
function getComputedStyle$1(element) {
  return window.getComputedStyle(element);
}
var htmlConfig = {
  treeType: "dom",
  readValueFromInstance: function(domElement, key) {
    if (isTransformProp(key)) {
      var defaultType = getDefaultValueType(key);
      return defaultType ? defaultType.default || 0 : 0;
    } else {
      var computedStyle = getComputedStyle$1(domElement);
      return (isCSSVariable$1(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
    }
  },
  sortNodePosition: function(a4, b3) {
    return a4.compareDocumentPosition(b3) & 2 ? 1 : -1;
  },
  getBaseTarget: function(props, key) {
    var _a;
    return (_a = props.style) === null || _a === void 0 ? void 0 : _a[key];
  },
  measureViewportBox: function(element, _a) {
    var transformPagePoint = _a.transformPagePoint;
    return measureViewportBox(element, transformPagePoint);
  },
  /**
   * Reset the transform on the current Element. This is called as part
   * of a batched process across the entire layout tree. To remove this write
   * cycle it'd be interesting to see if it's possible to "undo" all the current
   * layout transforms up the tree in the same way this.getBoundingBoxWithoutTransforms
   * works
   */
  resetTransform: function(element, domElement, props) {
    var transformTemplate = props.transformTemplate;
    domElement.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
    element.scheduleRender();
  },
  restoreTransform: function(instance, mutableState) {
    instance.style.transform = mutableState.style.transform;
  },
  removeValueFromRenderState: function(key, _a) {
    var vars = _a.vars, style = _a.style;
    delete vars[key];
    delete style[key];
  },
  /**
   * Ensure that HTML and Framer-specific value types like `px`->`%` and `Color`
   * can be animated by Motion.
   */
  makeTargetAnimatable: function(element, _a, _b, isMounted) {
    var transformValues = _b.transformValues;
    if (isMounted === void 0) {
      isMounted = true;
    }
    var transition = _a.transition, transitionEnd = _a.transitionEnd, target = __rest$1(_a, ["transition", "transitionEnd"]);
    var origin = getOrigin(target, transition || {}, element);
    if (transformValues) {
      if (transitionEnd)
        transitionEnd = transformValues(transitionEnd);
      if (target)
        target = transformValues(target);
      if (origin)
        origin = transformValues(origin);
    }
    if (isMounted) {
      checkTargetForNewValues(element, target, origin);
      var parsed = parseDomVariant(element, target, origin, transitionEnd);
      transitionEnd = parsed.transitionEnd;
      target = parsed.target;
    }
    return __assign$1({ transition, transitionEnd }, target);
  },
  scrapeMotionValuesFromProps: scrapeMotionValuesFromProps$1,
  build: function(element, renderState, latestValues, options, props) {
    if (element.isVisible !== void 0) {
      renderState.style.visibility = element.isVisible ? "visible" : "hidden";
    }
    buildHTMLStyles(renderState, latestValues, options, props.transformTemplate);
  },
  render: renderHTML
};
var htmlVisualElement = visualElement(htmlConfig);
var svgVisualElement = visualElement(__assign$1(__assign$1({}, htmlConfig), { getBaseTarget: function(props, key) {
  return props[key];
}, readValueFromInstance: function(domElement, key) {
  var _a;
  if (isTransformProp(key)) {
    return ((_a = getDefaultValueType(key)) === null || _a === void 0 ? void 0 : _a.default) || 0;
  }
  key = !camelCaseAttributes.has(key) ? camelToDash(key) : key;
  return domElement.getAttribute(key);
}, scrapeMotionValuesFromProps, build: function(_element, renderState, latestValues, options, props) {
  buildSVGAttrs(renderState, latestValues, options, props.transformTemplate);
}, render: renderSVG }));
var createDomVisualElement = function(Component2, options) {
  return isSVGComponent(Component2) ? svgVisualElement(options, { enableHardwareAcceleration: false }) : htmlVisualElement(options, { enableHardwareAcceleration: true });
};
function pixelsToPercent(pixels, axis) {
  if (axis.max === axis.min)
    return 0;
  return pixels / (axis.max - axis.min) * 100;
}
var correctBorderRadius = {
  correct: function(latest, node) {
    if (!node.target)
      return latest;
    if (typeof latest === "string") {
      if (px.test(latest)) {
        latest = parseFloat(latest);
      } else {
        return latest;
      }
    }
    var x3 = pixelsToPercent(latest, node.target.x);
    var y4 = pixelsToPercent(latest, node.target.y);
    return "".concat(x3, "% ").concat(y4, "%");
  }
};
var varToken = "_$css";
var correctBoxShadow = {
  correct: function(latest, _a) {
    var treeScale = _a.treeScale, projectionDelta = _a.projectionDelta;
    var original = latest;
    var containsCSSVariables = latest.includes("var(");
    var cssVariables = [];
    if (containsCSSVariables) {
      latest = latest.replace(cssVariableRegex, function(match2) {
        cssVariables.push(match2);
        return varToken;
      });
    }
    var shadow = complex.parse(latest);
    if (shadow.length > 5)
      return original;
    var template = complex.createTransformer(latest);
    var offset2 = typeof shadow[0] !== "number" ? 1 : 0;
    var xScale = projectionDelta.x.scale * treeScale.x;
    var yScale = projectionDelta.y.scale * treeScale.y;
    shadow[0 + offset2] /= xScale;
    shadow[1 + offset2] /= yScale;
    var averageScale = mix(xScale, yScale, 0.5);
    if (typeof shadow[2 + offset2] === "number")
      shadow[2 + offset2] /= averageScale;
    if (typeof shadow[3 + offset2] === "number")
      shadow[3 + offset2] /= averageScale;
    var output = template(shadow);
    if (containsCSSVariables) {
      var i_1 = 0;
      output = output.replace(varToken, function() {
        var cssVariable = cssVariables[i_1];
        i_1++;
        return cssVariable;
      });
    }
    return output;
  }
};
var MeasureLayoutWithContext = (
  /** @class */
  function(_super) {
    __extends(MeasureLayoutWithContext2, _super);
    function MeasureLayoutWithContext2() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    MeasureLayoutWithContext2.prototype.componentDidMount = function() {
      var _this = this;
      var _a = this.props, visualElement2 = _a.visualElement, layoutGroup = _a.layoutGroup, switchLayoutGroup = _a.switchLayoutGroup, layoutId = _a.layoutId;
      var projection = visualElement2.projection;
      addScaleCorrector(defaultScaleCorrectors);
      if (projection) {
        if (layoutGroup === null || layoutGroup === void 0 ? void 0 : layoutGroup.group)
          layoutGroup.group.add(projection);
        if ((switchLayoutGroup === null || switchLayoutGroup === void 0 ? void 0 : switchLayoutGroup.register) && layoutId) {
          switchLayoutGroup.register(projection);
        }
        projection.root.didUpdate();
        projection.addEventListener("animationComplete", function() {
          _this.safeToRemove();
        });
        projection.setOptions(__assign$1(__assign$1({}, projection.options), { onExitComplete: function() {
          return _this.safeToRemove();
        } }));
      }
      globalProjectionState.hasEverUpdated = true;
    };
    MeasureLayoutWithContext2.prototype.getSnapshotBeforeUpdate = function(prevProps) {
      var _this = this;
      var _a = this.props, layoutDependency = _a.layoutDependency, visualElement2 = _a.visualElement, drag2 = _a.drag, isPresent = _a.isPresent;
      var projection = visualElement2.projection;
      if (!projection)
        return null;
      projection.isPresent = isPresent;
      if (drag2 || prevProps.layoutDependency !== layoutDependency || layoutDependency === void 0) {
        projection.willUpdate();
      } else {
        this.safeToRemove();
      }
      if (prevProps.isPresent !== isPresent) {
        if (isPresent) {
          projection.promote();
        } else if (!projection.relegate()) {
          sync.postRender(function() {
            var _a2;
            if (!((_a2 = projection.getStack()) === null || _a2 === void 0 ? void 0 : _a2.members.length)) {
              _this.safeToRemove();
            }
          });
        }
      }
      return null;
    };
    MeasureLayoutWithContext2.prototype.componentDidUpdate = function() {
      var projection = this.props.visualElement.projection;
      if (projection) {
        projection.root.didUpdate();
        if (!projection.currentAnimation && projection.isLead()) {
          this.safeToRemove();
        }
      }
    };
    MeasureLayoutWithContext2.prototype.componentWillUnmount = function() {
      var _a = this.props, visualElement2 = _a.visualElement, layoutGroup = _a.layoutGroup, promoteContext = _a.switchLayoutGroup;
      var projection = visualElement2.projection;
      if (projection) {
        projection.scheduleCheckAfterUnmount();
        if (layoutGroup === null || layoutGroup === void 0 ? void 0 : layoutGroup.group)
          layoutGroup.group.remove(projection);
        if (promoteContext === null || promoteContext === void 0 ? void 0 : promoteContext.deregister)
          promoteContext.deregister(projection);
      }
    };
    MeasureLayoutWithContext2.prototype.safeToRemove = function() {
      var safeToRemove = this.props.safeToRemove;
      safeToRemove === null || safeToRemove === void 0 ? void 0 : safeToRemove();
    };
    MeasureLayoutWithContext2.prototype.render = function() {
      return null;
    };
    return MeasureLayoutWithContext2;
  }(React__default.Component)
);
function MeasureLayout(props) {
  var _a = __read(usePresence(), 2), isPresent = _a[0], safeToRemove = _a[1];
  var layoutGroup = useContext(LayoutGroupContext);
  return React__default.createElement(MeasureLayoutWithContext, __assign$1({}, props, { layoutGroup, switchLayoutGroup: useContext(SwitchLayoutGroupContext), isPresent, safeToRemove }));
}
var defaultScaleCorrectors = {
  borderRadius: __assign$1(__assign$1({}, correctBorderRadius), { applyTo: [
    "borderTopLeftRadius",
    "borderTopRightRadius",
    "borderBottomLeftRadius",
    "borderBottomRightRadius"
  ] }),
  borderTopLeftRadius: correctBorderRadius,
  borderTopRightRadius: correctBorderRadius,
  borderBottomLeftRadius: correctBorderRadius,
  borderBottomRightRadius: correctBorderRadius,
  boxShadow: correctBoxShadow
};
var layoutFeatures = {
  measureLayout: MeasureLayout
};
function animate(from, to, transition) {
  if (transition === void 0) {
    transition = {};
  }
  var value = isMotionValue(from) ? from : motionValue(from);
  startAnimation("", value, to, transition);
  return {
    stop: function() {
      return value.stop();
    },
    isAnimating: function() {
      return value.isAnimating();
    }
  };
}
var borders = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"];
var numBorders = borders.length;
var asNumber = function(value) {
  return typeof value === "string" ? parseFloat(value) : value;
};
var isPx = function(value) {
  return typeof value === "number" || px.test(value);
};
function mixValues(target, follow, lead, progress2, shouldCrossfadeOpacity, isOnlyMember) {
  var _a, _b, _c, _d;
  if (shouldCrossfadeOpacity) {
    target.opacity = mix(
      0,
      // (follow?.opacity as number) ?? 0,
      // TODO Reinstate this if only child
      (_a = lead.opacity) !== null && _a !== void 0 ? _a : 1,
      easeCrossfadeIn(progress2)
    );
    target.opacityExit = mix((_b = follow.opacity) !== null && _b !== void 0 ? _b : 1, 0, easeCrossfadeOut(progress2));
  } else if (isOnlyMember) {
    target.opacity = mix((_c = follow.opacity) !== null && _c !== void 0 ? _c : 1, (_d = lead.opacity) !== null && _d !== void 0 ? _d : 1, progress2);
  }
  for (var i3 = 0; i3 < numBorders; i3++) {
    var borderLabel = "border".concat(borders[i3], "Radius");
    var followRadius = getRadius$1(follow, borderLabel);
    var leadRadius = getRadius$1(lead, borderLabel);
    if (followRadius === void 0 && leadRadius === void 0)
      continue;
    followRadius || (followRadius = 0);
    leadRadius || (leadRadius = 0);
    var canMix = followRadius === 0 || leadRadius === 0 || isPx(followRadius) === isPx(leadRadius);
    if (canMix) {
      target[borderLabel] = Math.max(mix(asNumber(followRadius), asNumber(leadRadius), progress2), 0);
      if (percent.test(leadRadius) || percent.test(followRadius)) {
        target[borderLabel] += "%";
      }
    } else {
      target[borderLabel] = leadRadius;
    }
  }
  if (follow.rotate || lead.rotate) {
    target.rotate = mix(follow.rotate || 0, lead.rotate || 0, progress2);
  }
}
function getRadius$1(values, radiusName) {
  var _a;
  return (_a = values[radiusName]) !== null && _a !== void 0 ? _a : values.borderRadius;
}
var easeCrossfadeIn = compress(0, 0.5, circOut);
var easeCrossfadeOut = compress(0.5, 0.95, linear$2);
function compress(min2, max2, easing) {
  return function(p2) {
    if (p2 < min2)
      return 0;
    if (p2 > max2)
      return 1;
    return easing(progress(min2, max2, p2));
  };
}
function copyAxisInto(axis, originAxis) {
  axis.min = originAxis.min;
  axis.max = originAxis.max;
}
function copyBoxInto(box, originBox) {
  copyAxisInto(box.x, originBox.x);
  copyAxisInto(box.y, originBox.y);
}
function removePointDelta(point2, translate, scale2, originPoint, boxScale) {
  point2 -= translate;
  point2 = scalePoint(point2, 1 / scale2, originPoint);
  if (boxScale !== void 0) {
    point2 = scalePoint(point2, 1 / boxScale, originPoint);
  }
  return point2;
}
function removeAxisDelta(axis, translate, scale2, origin, boxScale, originAxis, sourceAxis) {
  if (translate === void 0) {
    translate = 0;
  }
  if (scale2 === void 0) {
    scale2 = 1;
  }
  if (origin === void 0) {
    origin = 0.5;
  }
  if (originAxis === void 0) {
    originAxis = axis;
  }
  if (sourceAxis === void 0) {
    sourceAxis = axis;
  }
  if (percent.test(translate)) {
    translate = parseFloat(translate);
    var relativeProgress = mix(sourceAxis.min, sourceAxis.max, translate / 100);
    translate = relativeProgress - sourceAxis.min;
  }
  if (typeof translate !== "number")
    return;
  var originPoint = mix(originAxis.min, originAxis.max, origin);
  if (axis === originAxis)
    originPoint -= translate;
  axis.min = removePointDelta(axis.min, translate, scale2, originPoint, boxScale);
  axis.max = removePointDelta(axis.max, translate, scale2, originPoint, boxScale);
}
function removeAxisTransforms(axis, transforms, _a, origin, sourceAxis) {
  var _b = __read(_a, 3), key = _b[0], scaleKey = _b[1], originKey = _b[2];
  removeAxisDelta(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
var xKeys = ["x", "scaleX", "originX"];
var yKeys = ["y", "scaleY", "originY"];
function removeBoxTransforms(box, transforms, originBox, sourceBox) {
  removeAxisTransforms(box.x, transforms, xKeys, originBox === null || originBox === void 0 ? void 0 : originBox.x, sourceBox === null || sourceBox === void 0 ? void 0 : sourceBox.x);
  removeAxisTransforms(box.y, transforms, yKeys, originBox === null || originBox === void 0 ? void 0 : originBox.y, sourceBox === null || sourceBox === void 0 ? void 0 : sourceBox.y);
}
function isAxisDeltaZero(delta) {
  return delta.translate === 0 && delta.scale === 1;
}
function isDeltaZero(delta) {
  return isAxisDeltaZero(delta.x) && isAxisDeltaZero(delta.y);
}
function boxEquals(a4, b3) {
  return a4.x.min === b3.x.min && a4.x.max === b3.x.max && a4.y.min === b3.y.min && a4.y.max === b3.y.max;
}
var NodeStack = (
  /** @class */
  function() {
    function NodeStack2() {
      this.members = [];
    }
    NodeStack2.prototype.add = function(node) {
      addUniqueItem(this.members, node);
      node.scheduleRender();
    };
    NodeStack2.prototype.remove = function(node) {
      removeItem(this.members, node);
      if (node === this.prevLead) {
        this.prevLead = void 0;
      }
      if (node === this.lead) {
        var prevLead = this.members[this.members.length - 1];
        if (prevLead) {
          this.promote(prevLead);
        }
      }
    };
    NodeStack2.prototype.relegate = function(node) {
      var indexOfNode = this.members.findIndex(function(member2) {
        return node === member2;
      });
      if (indexOfNode === 0)
        return false;
      var prevLead;
      for (var i3 = indexOfNode; i3 >= 0; i3--) {
        var member = this.members[i3];
        if (member.isPresent !== false) {
          prevLead = member;
          break;
        }
      }
      if (prevLead) {
        this.promote(prevLead);
        return true;
      } else {
        return false;
      }
    };
    NodeStack2.prototype.promote = function(node, preserveFollowOpacity) {
      var _a;
      var prevLead = this.lead;
      if (node === prevLead)
        return;
      this.prevLead = prevLead;
      this.lead = node;
      node.show();
      if (prevLead) {
        prevLead.instance && prevLead.scheduleRender();
        node.scheduleRender();
        node.resumeFrom = prevLead;
        if (preserveFollowOpacity) {
          node.resumeFrom.preserveOpacity = true;
        }
        if (prevLead.snapshot) {
          node.snapshot = prevLead.snapshot;
          node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
          node.snapshot.isShared = true;
        }
        if ((_a = node.root) === null || _a === void 0 ? void 0 : _a.isUpdating) {
          node.isLayoutDirty = true;
        }
        var crossfade = node.options.crossfade;
        if (crossfade === false) {
          prevLead.hide();
        }
      }
    };
    NodeStack2.prototype.exitAnimationComplete = function() {
      this.members.forEach(function(node) {
        var _a, _b, _c, _d, _e;
        (_b = (_a = node.options).onExitComplete) === null || _b === void 0 ? void 0 : _b.call(_a);
        (_e = (_c = node.resumingFrom) === null || _c === void 0 ? void 0 : (_d = _c.options).onExitComplete) === null || _e === void 0 ? void 0 : _e.call(_d);
      });
    };
    NodeStack2.prototype.scheduleRender = function() {
      this.members.forEach(function(node) {
        node.instance && node.scheduleRender(false);
      });
    };
    NodeStack2.prototype.removeLeadSnapshot = function() {
      if (this.lead && this.lead.snapshot) {
        this.lead.snapshot = void 0;
      }
    };
    return NodeStack2;
  }()
);
var identityProjection = "translate3d(0px, 0px, 0) scale(1, 1) scale(1, 1)";
function buildProjectionTransform(delta, treeScale, latestTransform) {
  var xTranslate = delta.x.translate / treeScale.x;
  var yTranslate = delta.y.translate / treeScale.y;
  var transform = "translate3d(".concat(xTranslate, "px, ").concat(yTranslate, "px, 0) ");
  transform += "scale(".concat(1 / treeScale.x, ", ").concat(1 / treeScale.y, ") ");
  if (latestTransform) {
    var rotate = latestTransform.rotate, rotateX = latestTransform.rotateX, rotateY = latestTransform.rotateY;
    if (rotate)
      transform += "rotate(".concat(rotate, "deg) ");
    if (rotateX)
      transform += "rotateX(".concat(rotateX, "deg) ");
    if (rotateY)
      transform += "rotateY(".concat(rotateY, "deg) ");
  }
  var elementScaleX = delta.x.scale * treeScale.x;
  var elementScaleY = delta.y.scale * treeScale.y;
  transform += "scale(".concat(elementScaleX, ", ").concat(elementScaleY, ")");
  return transform === identityProjection ? "none" : transform;
}
var compareByDepth = function(a4, b3) {
  return a4.depth - b3.depth;
};
var FlatTree = (
  /** @class */
  function() {
    function FlatTree2() {
      this.children = [];
      this.isDirty = false;
    }
    FlatTree2.prototype.add = function(child) {
      addUniqueItem(this.children, child);
      this.isDirty = true;
    };
    FlatTree2.prototype.remove = function(child) {
      removeItem(this.children, child);
      this.isDirty = true;
    };
    FlatTree2.prototype.forEach = function(callback) {
      this.isDirty && this.children.sort(compareByDepth);
      this.isDirty = false;
      this.children.forEach(callback);
    };
    return FlatTree2;
  }()
);
var animationTarget = 1e3;
function createProjectionNode(_a) {
  var attachResizeListener = _a.attachResizeListener, defaultParent = _a.defaultParent, measureScroll = _a.measureScroll, checkIsScrollRoot = _a.checkIsScrollRoot, resetTransform = _a.resetTransform;
  return (
    /** @class */
    function() {
      function ProjectionNode(id2, latestValues, parent) {
        var _this = this;
        if (latestValues === void 0) {
          latestValues = {};
        }
        if (parent === void 0) {
          parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent();
        }
        this.children = /* @__PURE__ */ new Set();
        this.options = {};
        this.isTreeAnimating = false;
        this.isAnimationBlocked = false;
        this.isLayoutDirty = false;
        this.updateManuallyBlocked = false;
        this.updateBlockedByResize = false;
        this.isUpdating = false;
        this.isSVG = false;
        this.needsReset = false;
        this.shouldResetTransform = false;
        this.treeScale = { x: 1, y: 1 };
        this.eventHandlers = /* @__PURE__ */ new Map();
        this.potentialNodes = /* @__PURE__ */ new Map();
        this.checkUpdateFailed = function() {
          if (_this.isUpdating) {
            _this.isUpdating = false;
            _this.clearAllSnapshots();
          }
        };
        this.updateProjection = function() {
          _this.nodes.forEach(resolveTargetDelta);
          _this.nodes.forEach(calcProjection);
        };
        this.hasProjected = false;
        this.isVisible = true;
        this.animationProgress = 0;
        this.sharedNodes = /* @__PURE__ */ new Map();
        this.id = id2;
        this.latestValues = latestValues;
        this.root = parent ? parent.root || parent : this;
        this.path = parent ? __spreadArray$1(__spreadArray$1([], __read(parent.path), false), [parent], false) : [];
        this.parent = parent;
        this.depth = parent ? parent.depth + 1 : 0;
        id2 && this.root.registerPotentialNode(id2, this);
        for (var i3 = 0; i3 < this.path.length; i3++) {
          this.path[i3].shouldResetTransform = true;
        }
        if (this.root === this)
          this.nodes = new FlatTree();
      }
      ProjectionNode.prototype.addEventListener = function(name, handler) {
        if (!this.eventHandlers.has(name)) {
          this.eventHandlers.set(name, new SubscriptionManager());
        }
        return this.eventHandlers.get(name).add(handler);
      };
      ProjectionNode.prototype.notifyListeners = function(name) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
          args[_i - 1] = arguments[_i];
        }
        var subscriptionManager = this.eventHandlers.get(name);
        subscriptionManager === null || subscriptionManager === void 0 ? void 0 : subscriptionManager.notify.apply(subscriptionManager, __spreadArray$1([], __read(args), false));
      };
      ProjectionNode.prototype.hasListeners = function(name) {
        return this.eventHandlers.has(name);
      };
      ProjectionNode.prototype.registerPotentialNode = function(id2, node) {
        this.potentialNodes.set(id2, node);
      };
      ProjectionNode.prototype.mount = function(instance, isLayoutDirty) {
        var _this = this;
        var _a2;
        if (isLayoutDirty === void 0) {
          isLayoutDirty = false;
        }
        if (this.instance)
          return;
        this.isSVG = instance instanceof SVGElement && instance.tagName !== "svg";
        this.instance = instance;
        var _b = this.options, layoutId = _b.layoutId, layout = _b.layout, visualElement2 = _b.visualElement;
        if (visualElement2 && !visualElement2.getInstance()) {
          visualElement2.mount(instance);
        }
        this.root.nodes.add(this);
        (_a2 = this.parent) === null || _a2 === void 0 ? void 0 : _a2.children.add(this);
        this.id && this.root.potentialNodes.delete(this.id);
        if (isLayoutDirty && (layout || layoutId)) {
          this.isLayoutDirty = true;
        }
        if (attachResizeListener) {
          var unblockTimeout_1;
          var resizeUnblockUpdate_1 = function() {
            return _this.root.updateBlockedByResize = false;
          };
          attachResizeListener(instance, function() {
            _this.root.updateBlockedByResize = true;
            clearTimeout(unblockTimeout_1);
            unblockTimeout_1 = window.setTimeout(resizeUnblockUpdate_1, 250);
            if (globalProjectionState.hasAnimatedSinceResize) {
              globalProjectionState.hasAnimatedSinceResize = false;
              _this.nodes.forEach(finishAnimation);
            }
          });
        }
        if (layoutId) {
          this.root.registerSharedNode(layoutId, this);
        }
        if (this.options.animate !== false && visualElement2 && (layoutId || layout)) {
          this.addEventListener("didUpdate", function(_a3) {
            var _b2, _c, _d, _e, _f;
            var delta = _a3.delta, hasLayoutChanged = _a3.hasLayoutChanged, hasRelativeTargetChanged = _a3.hasRelativeTargetChanged, newLayout = _a3.layout;
            if (_this.isTreeAnimationBlocked()) {
              _this.target = void 0;
              _this.relativeTarget = void 0;
              return;
            }
            var layoutTransition = (_c = (_b2 = _this.options.transition) !== null && _b2 !== void 0 ? _b2 : visualElement2.getDefaultTransition()) !== null && _c !== void 0 ? _c : defaultLayoutTransition;
            var _g = visualElement2.getProps(), onLayoutAnimationStart = _g.onLayoutAnimationStart, onLayoutAnimationComplete = _g.onLayoutAnimationComplete;
            var targetChanged = !_this.targetLayout || !boxEquals(_this.targetLayout, newLayout) || hasRelativeTargetChanged;
            var hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
            if (((_d = _this.resumeFrom) === null || _d === void 0 ? void 0 : _d.instance) || hasOnlyRelativeTargetChanged || hasLayoutChanged && (targetChanged || !_this.currentAnimation)) {
              if (_this.resumeFrom) {
                _this.resumingFrom = _this.resumeFrom;
                _this.resumingFrom.resumingFrom = void 0;
              }
              _this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
              var animationOptions = __assign$1(__assign$1({}, getValueTransition(layoutTransition, "layout")), { onPlay: onLayoutAnimationStart, onComplete: onLayoutAnimationComplete });
              if (visualElement2.shouldReduceMotion) {
                animationOptions.delay = 0;
                animationOptions.type = false;
              }
              _this.startAnimation(animationOptions);
            } else {
              if (!hasLayoutChanged && _this.animationProgress === 0) {
                _this.finishAnimation();
              }
              _this.isLead() && ((_f = (_e = _this.options).onExitComplete) === null || _f === void 0 ? void 0 : _f.call(_e));
            }
            _this.targetLayout = newLayout;
          });
        }
      };
      ProjectionNode.prototype.unmount = function() {
        var _a2, _b;
        this.options.layoutId && this.willUpdate();
        this.root.nodes.remove(this);
        (_a2 = this.getStack()) === null || _a2 === void 0 ? void 0 : _a2.remove(this);
        (_b = this.parent) === null || _b === void 0 ? void 0 : _b.children.delete(this);
        this.instance = void 0;
        cancelSync.preRender(this.updateProjection);
      };
      ProjectionNode.prototype.blockUpdate = function() {
        this.updateManuallyBlocked = true;
      };
      ProjectionNode.prototype.unblockUpdate = function() {
        this.updateManuallyBlocked = false;
      };
      ProjectionNode.prototype.isUpdateBlocked = function() {
        return this.updateManuallyBlocked || this.updateBlockedByResize;
      };
      ProjectionNode.prototype.isTreeAnimationBlocked = function() {
        var _a2;
        return this.isAnimationBlocked || ((_a2 = this.parent) === null || _a2 === void 0 ? void 0 : _a2.isTreeAnimationBlocked()) || false;
      };
      ProjectionNode.prototype.startUpdate = function() {
        var _a2;
        if (this.isUpdateBlocked())
          return;
        this.isUpdating = true;
        (_a2 = this.nodes) === null || _a2 === void 0 ? void 0 : _a2.forEach(resetRotation);
      };
      ProjectionNode.prototype.willUpdate = function(shouldNotifyListeners) {
        var _a2, _b, _c;
        if (shouldNotifyListeners === void 0) {
          shouldNotifyListeners = true;
        }
        if (this.root.isUpdateBlocked()) {
          (_b = (_a2 = this.options).onExitComplete) === null || _b === void 0 ? void 0 : _b.call(_a2);
          return;
        }
        !this.root.isUpdating && this.root.startUpdate();
        if (this.isLayoutDirty)
          return;
        this.isLayoutDirty = true;
        for (var i3 = 0; i3 < this.path.length; i3++) {
          var node = this.path[i3];
          node.shouldResetTransform = true;
          node.updateScroll();
        }
        var _d = this.options, layoutId = _d.layoutId, layout = _d.layout;
        if (layoutId === void 0 && !layout)
          return;
        var transformTemplate = (_c = this.options.visualElement) === null || _c === void 0 ? void 0 : _c.getProps().transformTemplate;
        this.prevTransformTemplateValue = transformTemplate === null || transformTemplate === void 0 ? void 0 : transformTemplate(this.latestValues, "");
        this.updateSnapshot();
        shouldNotifyListeners && this.notifyListeners("willUpdate");
      };
      ProjectionNode.prototype.didUpdate = function() {
        var updateWasBlocked = this.isUpdateBlocked();
        if (updateWasBlocked) {
          this.unblockUpdate();
          this.clearAllSnapshots();
          this.nodes.forEach(clearMeasurements);
          return;
        }
        if (!this.isUpdating)
          return;
        this.isUpdating = false;
        if (this.potentialNodes.size) {
          this.potentialNodes.forEach(mountNodeEarly);
          this.potentialNodes.clear();
        }
        this.nodes.forEach(resetTransformStyle);
        this.nodes.forEach(updateLayout);
        this.nodes.forEach(notifyLayoutUpdate);
        this.clearAllSnapshots();
        flushSync.update();
        flushSync.preRender();
        flushSync.render();
      };
      ProjectionNode.prototype.clearAllSnapshots = function() {
        this.nodes.forEach(clearSnapshot);
        this.sharedNodes.forEach(removeLeadSnapshots);
      };
      ProjectionNode.prototype.scheduleUpdateProjection = function() {
        sync.preRender(this.updateProjection, false, true);
      };
      ProjectionNode.prototype.scheduleCheckAfterUnmount = function() {
        var _this = this;
        sync.postRender(function() {
          if (_this.isLayoutDirty) {
            _this.root.didUpdate();
          } else {
            _this.root.checkUpdateFailed();
          }
        });
      };
      ProjectionNode.prototype.updateSnapshot = function() {
        if (this.snapshot || !this.instance)
          return;
        var measured = this.measure();
        var layout = this.removeTransform(this.removeElementScroll(measured));
        roundBox(layout);
        this.snapshot = {
          measured,
          layout,
          latestValues: {}
        };
      };
      ProjectionNode.prototype.updateLayout = function() {
        var _a2;
        if (!this.instance)
          return;
        this.updateScroll();
        if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) {
          return;
        }
        if (this.resumeFrom && !this.resumeFrom.instance) {
          for (var i3 = 0; i3 < this.path.length; i3++) {
            var node = this.path[i3];
            node.updateScroll();
          }
        }
        var measured = this.measure();
        roundBox(measured);
        var prevLayout = this.layout;
        this.layout = {
          measured,
          actual: this.removeElementScroll(measured)
        };
        this.layoutCorrected = createBox();
        this.isLayoutDirty = false;
        this.projectionDelta = void 0;
        this.notifyListeners("measure", this.layout.actual);
        (_a2 = this.options.visualElement) === null || _a2 === void 0 ? void 0 : _a2.notifyLayoutMeasure(this.layout.actual, prevLayout === null || prevLayout === void 0 ? void 0 : prevLayout.actual);
      };
      ProjectionNode.prototype.updateScroll = function() {
        if (this.options.layoutScroll && this.instance) {
          this.isScrollRoot = checkIsScrollRoot(this.instance);
          this.scroll = measureScroll(this.instance);
        }
      };
      ProjectionNode.prototype.resetTransform = function() {
        var _a2;
        if (!resetTransform)
          return;
        var isResetRequested = this.isLayoutDirty || this.shouldResetTransform;
        var hasProjection = this.projectionDelta && !isDeltaZero(this.projectionDelta);
        var transformTemplate = (_a2 = this.options.visualElement) === null || _a2 === void 0 ? void 0 : _a2.getProps().transformTemplate;
        var transformTemplateValue = transformTemplate === null || transformTemplate === void 0 ? void 0 : transformTemplate(this.latestValues, "");
        var transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
        if (isResetRequested && (hasProjection || hasTransform(this.latestValues) || transformTemplateHasChanged)) {
          resetTransform(this.instance, transformTemplateValue);
          this.shouldResetTransform = false;
          this.scheduleRender();
        }
      };
      ProjectionNode.prototype.measure = function() {
        var visualElement2 = this.options.visualElement;
        if (!visualElement2)
          return createBox();
        var box = visualElement2.measureViewportBox();
        var scroll2 = this.root.scroll;
        if (scroll2) {
          translateAxis(box.x, scroll2.x);
          translateAxis(box.y, scroll2.y);
        }
        return box;
      };
      ProjectionNode.prototype.removeElementScroll = function(box) {
        var boxWithoutScroll = createBox();
        copyBoxInto(boxWithoutScroll, box);
        for (var i3 = 0; i3 < this.path.length; i3++) {
          var node = this.path[i3];
          var scroll_1 = node.scroll, options = node.options, isScrollRoot = node.isScrollRoot;
          if (node !== this.root && scroll_1 && options.layoutScroll) {
            if (isScrollRoot) {
              copyBoxInto(boxWithoutScroll, box);
              var rootScroll = this.root.scroll;
              if (rootScroll) {
                translateAxis(boxWithoutScroll.x, -rootScroll.x);
                translateAxis(boxWithoutScroll.y, -rootScroll.y);
              }
            }
            translateAxis(boxWithoutScroll.x, scroll_1.x);
            translateAxis(boxWithoutScroll.y, scroll_1.y);
          }
        }
        return boxWithoutScroll;
      };
      ProjectionNode.prototype.applyTransform = function(box, transformOnly) {
        if (transformOnly === void 0) {
          transformOnly = false;
        }
        var withTransforms = createBox();
        copyBoxInto(withTransforms, box);
        for (var i3 = 0; i3 < this.path.length; i3++) {
          var node = this.path[i3];
          if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) {
            transformBox(withTransforms, {
              x: -node.scroll.x,
              y: -node.scroll.y
            });
          }
          if (!hasTransform(node.latestValues))
            continue;
          transformBox(withTransforms, node.latestValues);
        }
        if (hasTransform(this.latestValues)) {
          transformBox(withTransforms, this.latestValues);
        }
        return withTransforms;
      };
      ProjectionNode.prototype.removeTransform = function(box) {
        var _a2;
        var boxWithoutTransform = createBox();
        copyBoxInto(boxWithoutTransform, box);
        for (var i3 = 0; i3 < this.path.length; i3++) {
          var node = this.path[i3];
          if (!node.instance)
            continue;
          if (!hasTransform(node.latestValues))
            continue;
          hasScale(node.latestValues) && node.updateSnapshot();
          var sourceBox = createBox();
          var nodeBox = node.measure();
          copyBoxInto(sourceBox, nodeBox);
          removeBoxTransforms(boxWithoutTransform, node.latestValues, (_a2 = node.snapshot) === null || _a2 === void 0 ? void 0 : _a2.layout, sourceBox);
        }
        if (hasTransform(this.latestValues)) {
          removeBoxTransforms(boxWithoutTransform, this.latestValues);
        }
        return boxWithoutTransform;
      };
      ProjectionNode.prototype.setTargetDelta = function(delta) {
        this.targetDelta = delta;
        this.root.scheduleUpdateProjection();
      };
      ProjectionNode.prototype.setOptions = function(options) {
        var _a2;
        this.options = __assign$1(__assign$1(__assign$1({}, this.options), options), { crossfade: (_a2 = options.crossfade) !== null && _a2 !== void 0 ? _a2 : true });
      };
      ProjectionNode.prototype.clearMeasurements = function() {
        this.scroll = void 0;
        this.layout = void 0;
        this.snapshot = void 0;
        this.prevTransformTemplateValue = void 0;
        this.targetDelta = void 0;
        this.target = void 0;
        this.isLayoutDirty = false;
      };
      ProjectionNode.prototype.resolveTargetDelta = function() {
        var _a2;
        var _b = this.options, layout = _b.layout, layoutId = _b.layoutId;
        if (!this.layout || !(layout || layoutId))
          return;
        if (!this.targetDelta && !this.relativeTarget) {
          this.relativeParent = this.getClosestProjectingParent();
          if (this.relativeParent && this.relativeParent.layout) {
            this.relativeTarget = createBox();
            this.relativeTargetOrigin = createBox();
            calcRelativePosition(this.relativeTargetOrigin, this.layout.actual, this.relativeParent.layout.actual);
            copyBoxInto(this.relativeTarget, this.relativeTargetOrigin);
          }
        }
        if (!this.relativeTarget && !this.targetDelta)
          return;
        if (!this.target) {
          this.target = createBox();
          this.targetWithTransforms = createBox();
        }
        if (this.relativeTarget && this.relativeTargetOrigin && ((_a2 = this.relativeParent) === null || _a2 === void 0 ? void 0 : _a2.target)) {
          calcRelativeBox(this.target, this.relativeTarget, this.relativeParent.target);
        } else if (this.targetDelta) {
          if (Boolean(this.resumingFrom)) {
            this.target = this.applyTransform(this.layout.actual);
          } else {
            copyBoxInto(this.target, this.layout.actual);
          }
          applyBoxDelta(this.target, this.targetDelta);
        } else {
          copyBoxInto(this.target, this.layout.actual);
        }
        if (this.attemptToResolveRelativeTarget) {
          this.attemptToResolveRelativeTarget = false;
          this.relativeParent = this.getClosestProjectingParent();
          if (this.relativeParent && Boolean(this.relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !this.relativeParent.options.layoutScroll && this.relativeParent.target) {
            this.relativeTarget = createBox();
            this.relativeTargetOrigin = createBox();
            calcRelativePosition(this.relativeTargetOrigin, this.target, this.relativeParent.target);
            copyBoxInto(this.relativeTarget, this.relativeTargetOrigin);
          }
        }
      };
      ProjectionNode.prototype.getClosestProjectingParent = function() {
        if (!this.parent || hasTransform(this.parent.latestValues))
          return void 0;
        if ((this.parent.relativeTarget || this.parent.targetDelta) && this.parent.layout) {
          return this.parent;
        } else {
          return this.parent.getClosestProjectingParent();
        }
      };
      ProjectionNode.prototype.calcProjection = function() {
        var _a2;
        var _b = this.options, layout = _b.layout, layoutId = _b.layoutId;
        this.isTreeAnimating = Boolean(((_a2 = this.parent) === null || _a2 === void 0 ? void 0 : _a2.isTreeAnimating) || this.currentAnimation || this.pendingAnimation);
        if (!this.isTreeAnimating) {
          this.targetDelta = this.relativeTarget = void 0;
        }
        if (!this.layout || !(layout || layoutId))
          return;
        var lead = this.getLead();
        copyBoxInto(this.layoutCorrected, this.layout.actual);
        applyTreeDeltas(this.layoutCorrected, this.treeScale, this.path, Boolean(this.resumingFrom) || this !== lead);
        var target = lead.target;
        if (!target)
          return;
        if (!this.projectionDelta) {
          this.projectionDelta = createDelta();
          this.projectionDeltaWithTransform = createDelta();
        }
        var prevTreeScaleX = this.treeScale.x;
        var prevTreeScaleY = this.treeScale.y;
        var prevProjectionTransform = this.projectionTransform;
        calcBoxDelta(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
        this.projectionTransform = buildProjectionTransform(this.projectionDelta, this.treeScale);
        if (this.projectionTransform !== prevProjectionTransform || this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY) {
          this.hasProjected = true;
          this.scheduleRender();
          this.notifyListeners("projectionUpdate", target);
        }
      };
      ProjectionNode.prototype.hide = function() {
        this.isVisible = false;
      };
      ProjectionNode.prototype.show = function() {
        this.isVisible = true;
      };
      ProjectionNode.prototype.scheduleRender = function(notifyAll) {
        var _a2, _b, _c;
        if (notifyAll === void 0) {
          notifyAll = true;
        }
        (_b = (_a2 = this.options).scheduleRender) === null || _b === void 0 ? void 0 : _b.call(_a2);
        notifyAll && ((_c = this.getStack()) === null || _c === void 0 ? void 0 : _c.scheduleRender());
        if (this.resumingFrom && !this.resumingFrom.instance) {
          this.resumingFrom = void 0;
        }
      };
      ProjectionNode.prototype.setAnimationOrigin = function(delta, hasOnlyRelativeTargetChanged) {
        var _this = this;
        var _a2;
        if (hasOnlyRelativeTargetChanged === void 0) {
          hasOnlyRelativeTargetChanged = false;
        }
        var snapshot = this.snapshot;
        var snapshotLatestValues = (snapshot === null || snapshot === void 0 ? void 0 : snapshot.latestValues) || {};
        var mixedValues = __assign$1({}, this.latestValues);
        var targetDelta = createDelta();
        this.relativeTarget = this.relativeTargetOrigin = void 0;
        this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
        var relativeLayout = createBox();
        var isSharedLayoutAnimation = snapshot === null || snapshot === void 0 ? void 0 : snapshot.isShared;
        var isOnlyMember = (((_a2 = this.getStack()) === null || _a2 === void 0 ? void 0 : _a2.members.length) || 0) <= 1;
        var shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some(hasOpacityCrossfade));
        this.animationProgress = 0;
        this.mixTargetDelta = function(latest) {
          var _a3;
          var progress2 = latest / 1e3;
          mixAxisDelta(targetDelta.x, delta.x, progress2);
          mixAxisDelta(targetDelta.y, delta.y, progress2);
          _this.setTargetDelta(targetDelta);
          if (_this.relativeTarget && _this.relativeTargetOrigin && _this.layout && ((_a3 = _this.relativeParent) === null || _a3 === void 0 ? void 0 : _a3.layout)) {
            calcRelativePosition(relativeLayout, _this.layout.actual, _this.relativeParent.layout.actual);
            mixBox(_this.relativeTarget, _this.relativeTargetOrigin, relativeLayout, progress2);
          }
          if (isSharedLayoutAnimation) {
            _this.animationValues = mixedValues;
            mixValues(mixedValues, snapshotLatestValues, _this.latestValues, progress2, shouldCrossfadeOpacity, isOnlyMember);
          }
          _this.root.scheduleUpdateProjection();
          _this.scheduleRender();
          _this.animationProgress = progress2;
        };
        this.mixTargetDelta(0);
      };
      ProjectionNode.prototype.startAnimation = function(options) {
        var _this = this;
        var _a2, _b;
        this.notifyListeners("animationStart");
        (_a2 = this.currentAnimation) === null || _a2 === void 0 ? void 0 : _a2.stop();
        if (this.resumingFrom) {
          (_b = this.resumingFrom.currentAnimation) === null || _b === void 0 ? void 0 : _b.stop();
        }
        if (this.pendingAnimation) {
          cancelSync.update(this.pendingAnimation);
          this.pendingAnimation = void 0;
        }
        this.pendingAnimation = sync.update(function() {
          globalProjectionState.hasAnimatedSinceResize = true;
          _this.currentAnimation = animate(0, animationTarget, __assign$1(__assign$1({}, options), { onUpdate: function(latest) {
            var _a3;
            _this.mixTargetDelta(latest);
            (_a3 = options.onUpdate) === null || _a3 === void 0 ? void 0 : _a3.call(options, latest);
          }, onComplete: function() {
            var _a3;
            (_a3 = options.onComplete) === null || _a3 === void 0 ? void 0 : _a3.call(options);
            _this.completeAnimation();
          } }));
          if (_this.resumingFrom) {
            _this.resumingFrom.currentAnimation = _this.currentAnimation;
          }
          _this.pendingAnimation = void 0;
        });
      };
      ProjectionNode.prototype.completeAnimation = function() {
        var _a2;
        if (this.resumingFrom) {
          this.resumingFrom.currentAnimation = void 0;
          this.resumingFrom.preserveOpacity = void 0;
        }
        (_a2 = this.getStack()) === null || _a2 === void 0 ? void 0 : _a2.exitAnimationComplete();
        this.resumingFrom = this.currentAnimation = this.animationValues = void 0;
        this.notifyListeners("animationComplete");
      };
      ProjectionNode.prototype.finishAnimation = function() {
        var _a2;
        if (this.currentAnimation) {
          (_a2 = this.mixTargetDelta) === null || _a2 === void 0 ? void 0 : _a2.call(this, animationTarget);
          this.currentAnimation.stop();
        }
        this.completeAnimation();
      };
      ProjectionNode.prototype.applyTransformsToTarget = function() {
        var _a2 = this.getLead(), targetWithTransforms = _a2.targetWithTransforms, target = _a2.target, layout = _a2.layout, latestValues = _a2.latestValues;
        if (!targetWithTransforms || !target || !layout)
          return;
        copyBoxInto(targetWithTransforms, target);
        transformBox(targetWithTransforms, latestValues);
        calcBoxDelta(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
      };
      ProjectionNode.prototype.registerSharedNode = function(layoutId, node) {
        var _a2, _b, _c;
        if (!this.sharedNodes.has(layoutId)) {
          this.sharedNodes.set(layoutId, new NodeStack());
        }
        var stack = this.sharedNodes.get(layoutId);
        stack.add(node);
        node.promote({
          transition: (_a2 = node.options.initialPromotionConfig) === null || _a2 === void 0 ? void 0 : _a2.transition,
          preserveFollowOpacity: (_c = (_b = node.options.initialPromotionConfig) === null || _b === void 0 ? void 0 : _b.shouldPreserveFollowOpacity) === null || _c === void 0 ? void 0 : _c.call(_b, node)
        });
      };
      ProjectionNode.prototype.isLead = function() {
        var stack = this.getStack();
        return stack ? stack.lead === this : true;
      };
      ProjectionNode.prototype.getLead = function() {
        var _a2;
        var layoutId = this.options.layoutId;
        return layoutId ? ((_a2 = this.getStack()) === null || _a2 === void 0 ? void 0 : _a2.lead) || this : this;
      };
      ProjectionNode.prototype.getPrevLead = function() {
        var _a2;
        var layoutId = this.options.layoutId;
        return layoutId ? (_a2 = this.getStack()) === null || _a2 === void 0 ? void 0 : _a2.prevLead : void 0;
      };
      ProjectionNode.prototype.getStack = function() {
        var layoutId = this.options.layoutId;
        if (layoutId)
          return this.root.sharedNodes.get(layoutId);
      };
      ProjectionNode.prototype.promote = function(_a2) {
        var _b = _a2 === void 0 ? {} : _a2, needsReset = _b.needsReset, transition = _b.transition, preserveFollowOpacity = _b.preserveFollowOpacity;
        var stack = this.getStack();
        if (stack)
          stack.promote(this, preserveFollowOpacity);
        if (needsReset) {
          this.projectionDelta = void 0;
          this.needsReset = true;
        }
        if (transition)
          this.setOptions({ transition });
      };
      ProjectionNode.prototype.relegate = function() {
        var stack = this.getStack();
        if (stack) {
          return stack.relegate(this);
        } else {
          return false;
        }
      };
      ProjectionNode.prototype.resetRotation = function() {
        var visualElement2 = this.options.visualElement;
        if (!visualElement2)
          return;
        var hasRotate = false;
        var resetValues = {};
        for (var i3 = 0; i3 < transformAxes.length; i3++) {
          var axis = transformAxes[i3];
          var key = "rotate" + axis;
          if (!visualElement2.getStaticValue(key)) {
            continue;
          }
          hasRotate = true;
          resetValues[key] = visualElement2.getStaticValue(key);
          visualElement2.setStaticValue(key, 0);
        }
        if (!hasRotate)
          return;
        visualElement2 === null || visualElement2 === void 0 ? void 0 : visualElement2.syncRender();
        for (var key in resetValues) {
          visualElement2.setStaticValue(key, resetValues[key]);
        }
        visualElement2.scheduleRender();
      };
      ProjectionNode.prototype.getProjectionStyles = function(styleProp) {
        var _a2, _b, _c, _d, _e, _f;
        if (styleProp === void 0) {
          styleProp = {};
        }
        var styles = {};
        if (!this.instance || this.isSVG)
          return styles;
        if (!this.isVisible) {
          return { visibility: "hidden" };
        } else {
          styles.visibility = "";
        }
        var transformTemplate = (_a2 = this.options.visualElement) === null || _a2 === void 0 ? void 0 : _a2.getProps().transformTemplate;
        if (this.needsReset) {
          this.needsReset = false;
          styles.opacity = "";
          styles.pointerEvents = resolveMotionValue(styleProp.pointerEvents) || "";
          styles.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
          return styles;
        }
        var lead = this.getLead();
        if (!this.projectionDelta || !this.layout || !lead.target) {
          var emptyStyles = {};
          if (this.options.layoutId) {
            emptyStyles.opacity = (_b = this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1;
            emptyStyles.pointerEvents = resolveMotionValue(styleProp.pointerEvents) || "";
          }
          if (this.hasProjected && !hasTransform(this.latestValues)) {
            emptyStyles.transform = transformTemplate ? transformTemplate({}, "") : "none";
            this.hasProjected = false;
          }
          return emptyStyles;
        }
        var valuesToRender = lead.animationValues || lead.latestValues;
        this.applyTransformsToTarget();
        styles.transform = buildProjectionTransform(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
        if (transformTemplate) {
          styles.transform = transformTemplate(valuesToRender, styles.transform);
        }
        var _g = this.projectionDelta, x3 = _g.x, y4 = _g.y;
        styles.transformOrigin = "".concat(x3.origin * 100, "% ").concat(y4.origin * 100, "% 0");
        if (lead.animationValues) {
          styles.opacity = lead === this ? (_d = (_c = valuesToRender.opacity) !== null && _c !== void 0 ? _c : this.latestValues.opacity) !== null && _d !== void 0 ? _d : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
        } else {
          styles.opacity = lead === this ? (_e = valuesToRender.opacity) !== null && _e !== void 0 ? _e : "" : (_f = valuesToRender.opacityExit) !== null && _f !== void 0 ? _f : 0;
        }
        for (var key in scaleCorrectors) {
          if (valuesToRender[key] === void 0)
            continue;
          var _h = scaleCorrectors[key], correct = _h.correct, applyTo = _h.applyTo;
          var corrected = correct(valuesToRender[key], lead);
          if (applyTo) {
            var num = applyTo.length;
            for (var i3 = 0; i3 < num; i3++) {
              styles[applyTo[i3]] = corrected;
            }
          } else {
            styles[key] = corrected;
          }
        }
        if (this.options.layoutId) {
          styles.pointerEvents = lead === this ? resolveMotionValue(styleProp.pointerEvents) || "" : "none";
        }
        return styles;
      };
      ProjectionNode.prototype.clearSnapshot = function() {
        this.resumeFrom = this.snapshot = void 0;
      };
      ProjectionNode.prototype.resetTree = function() {
        this.root.nodes.forEach(function(node) {
          var _a2;
          return (_a2 = node.currentAnimation) === null || _a2 === void 0 ? void 0 : _a2.stop();
        });
        this.root.nodes.forEach(clearMeasurements);
        this.root.sharedNodes.clear();
      };
      return ProjectionNode;
    }()
  );
}
function updateLayout(node) {
  node.updateLayout();
}
function notifyLayoutUpdate(node) {
  var _a, _b, _c, _d;
  var snapshot = (_b = (_a = node.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) !== null && _b !== void 0 ? _b : node.snapshot;
  if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
    var _e = node.layout, layout_1 = _e.actual, measuredLayout = _e.measured;
    if (node.options.animationType === "size") {
      eachAxis(function(axis) {
        var axisSnapshot = snapshot.isShared ? snapshot.measured[axis] : snapshot.layout[axis];
        var length = calcLength(axisSnapshot);
        axisSnapshot.min = layout_1[axis].min;
        axisSnapshot.max = axisSnapshot.min + length;
      });
    } else if (node.options.animationType === "position") {
      eachAxis(function(axis) {
        var axisSnapshot = snapshot.isShared ? snapshot.measured[axis] : snapshot.layout[axis];
        var length = calcLength(layout_1[axis]);
        axisSnapshot.max = axisSnapshot.min + length;
      });
    }
    var layoutDelta = createDelta();
    calcBoxDelta(layoutDelta, layout_1, snapshot.layout);
    var visualDelta = createDelta();
    if (snapshot.isShared) {
      calcBoxDelta(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measured);
    } else {
      calcBoxDelta(visualDelta, layout_1, snapshot.layout);
    }
    var hasLayoutChanged = !isDeltaZero(layoutDelta);
    var hasRelativeTargetChanged = false;
    if (!node.resumeFrom) {
      node.relativeParent = node.getClosestProjectingParent();
      if (node.relativeParent && !node.relativeParent.resumeFrom) {
        var _f = node.relativeParent, parentSnapshot = _f.snapshot, parentLayout = _f.layout;
        if (parentSnapshot && parentLayout) {
          var relativeSnapshot = createBox();
          calcRelativePosition(relativeSnapshot, snapshot.layout, parentSnapshot.layout);
          var relativeLayout = createBox();
          calcRelativePosition(relativeLayout, layout_1, parentLayout.actual);
          if (!boxEquals(relativeSnapshot, relativeLayout)) {
            hasRelativeTargetChanged = true;
          }
        }
      }
    }
    node.notifyListeners("didUpdate", {
      layout: layout_1,
      snapshot,
      delta: visualDelta,
      layoutDelta,
      hasLayoutChanged,
      hasRelativeTargetChanged
    });
  } else if (node.isLead()) {
    (_d = (_c = node.options).onExitComplete) === null || _d === void 0 ? void 0 : _d.call(_c);
  }
  node.options.transition = void 0;
}
function clearSnapshot(node) {
  node.clearSnapshot();
}
function clearMeasurements(node) {
  node.clearMeasurements();
}
function resetTransformStyle(node) {
  var visualElement2 = node.options.visualElement;
  if (visualElement2 === null || visualElement2 === void 0 ? void 0 : visualElement2.getProps().onBeforeLayoutMeasure) {
    visualElement2.notifyBeforeLayoutMeasure();
  }
  node.resetTransform();
}
function finishAnimation(node) {
  node.finishAnimation();
  node.targetDelta = node.relativeTarget = node.target = void 0;
}
function resolveTargetDelta(node) {
  node.resolveTargetDelta();
}
function calcProjection(node) {
  node.calcProjection();
}
function resetRotation(node) {
  node.resetRotation();
}
function removeLeadSnapshots(stack) {
  stack.removeLeadSnapshot();
}
function mixAxisDelta(output, delta, p2) {
  output.translate = mix(delta.translate, 0, p2);
  output.scale = mix(delta.scale, 1, p2);
  output.origin = delta.origin;
  output.originPoint = delta.originPoint;
}
function mixAxis(output, from, to, p2) {
  output.min = mix(from.min, to.min, p2);
  output.max = mix(from.max, to.max, p2);
}
function mixBox(output, from, to, p2) {
  mixAxis(output.x, from.x, to.x, p2);
  mixAxis(output.y, from.y, to.y, p2);
}
function hasOpacityCrossfade(node) {
  return node.animationValues && node.animationValues.opacityExit !== void 0;
}
var defaultLayoutTransition = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
};
function mountNodeEarly(node, id2) {
  var searchNode = node.root;
  for (var i3 = node.path.length - 1; i3 >= 0; i3--) {
    if (Boolean(node.path[i3].instance)) {
      searchNode = node.path[i3];
      break;
    }
  }
  var searchElement = searchNode && searchNode !== node.root ? searchNode.instance : document;
  var element = searchElement.querySelector('[data-projection-id="'.concat(id2, '"]'));
  if (element)
    node.mount(element, true);
}
function roundAxis(axis) {
  axis.min = Math.round(axis.min);
  axis.max = Math.round(axis.max);
}
function roundBox(box) {
  roundAxis(box.x);
  roundAxis(box.y);
}
var DocumentProjectionNode = createProjectionNode({
  attachResizeListener: function(ref, notify) {
    return addDomEvent(ref, "resize", notify);
  },
  measureScroll: function() {
    return {
      x: document.documentElement.scrollLeft || document.body.scrollLeft,
      y: document.documentElement.scrollTop || document.body.scrollTop
    };
  },
  checkIsScrollRoot: function() {
    return true;
  }
});
var rootProjectionNode = {
  current: void 0
};
var HTMLProjectionNode = createProjectionNode({
  measureScroll: function(instance) {
    return {
      x: instance.scrollLeft,
      y: instance.scrollTop
    };
  },
  defaultParent: function() {
    if (!rootProjectionNode.current) {
      var documentNode = new DocumentProjectionNode(0, {});
      documentNode.mount(window);
      documentNode.setOptions({ layoutScroll: true });
      rootProjectionNode.current = documentNode;
    }
    return rootProjectionNode.current;
  },
  resetTransform: function(instance, value) {
    instance.style.transform = value !== null && value !== void 0 ? value : "none";
  },
  checkIsScrollRoot: function(instance) {
    return Boolean(window.getComputedStyle(instance).position === "fixed");
  }
});
var featureBundle = __assign$1(__assign$1(__assign$1(__assign$1({}, animations), gestureAnimations), drag), layoutFeatures);
var motion = /* @__PURE__ */ createMotionProxy(function(Component2, config2) {
  return createDomMotionConfig(Component2, config2, featureBundle, createDomVisualElement, HTMLProjectionNode);
});
function useIsMounted() {
  var isMounted = useRef(false);
  useIsomorphicLayoutEffect$2(function() {
    isMounted.current = true;
    return function() {
      isMounted.current = false;
    };
  }, []);
  return isMounted;
}
function useForceUpdate() {
  var isMounted = useIsMounted();
  var _a = __read(useState(0), 2), forcedRenderCount = _a[0], setForcedRenderCount = _a[1];
  var forceRender = useCallback(function() {
    isMounted.current && setForcedRenderCount(forcedRenderCount + 1);
  }, [forcedRenderCount]);
  var deferredForceRender = useCallback(function() {
    return sync.postRender(forceRender);
  }, [forceRender]);
  return [deferredForceRender, forcedRenderCount];
}
var PresenceChild = function(_a) {
  var children = _a.children, initial = _a.initial, isPresent = _a.isPresent, onExitComplete = _a.onExitComplete, custom = _a.custom, presenceAffectsLayout = _a.presenceAffectsLayout;
  var presenceChildren = useConstant(newChildrenMap);
  var id2 = useId();
  var context = useMemo(
    function() {
      return {
        id: id2,
        initial,
        isPresent,
        custom,
        onExitComplete: function(childId) {
          var e_1, _a2;
          presenceChildren.set(childId, true);
          try {
            for (var _b = __values$1(presenceChildren.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
              var isComplete = _c.value;
              if (!isComplete)
                return;
            }
          } catch (e_1_1) {
            e_1 = { error: e_1_1 };
          } finally {
            try {
              if (_c && !_c.done && (_a2 = _b.return)) _a2.call(_b);
            } finally {
              if (e_1) throw e_1.error;
            }
          }
          onExitComplete === null || onExitComplete === void 0 ? void 0 : onExitComplete();
        },
        register: function(childId) {
          presenceChildren.set(childId, false);
          return function() {
            return presenceChildren.delete(childId);
          };
        }
      };
    },
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    presenceAffectsLayout ? void 0 : [isPresent]
  );
  useMemo(function() {
    presenceChildren.forEach(function(_, key) {
      return presenceChildren.set(key, false);
    });
  }, [isPresent]);
  React.useEffect(function() {
    !isPresent && !presenceChildren.size && (onExitComplete === null || onExitComplete === void 0 ? void 0 : onExitComplete());
  }, [isPresent]);
  return React.createElement(PresenceContext.Provider, { value: context }, children);
};
function newChildrenMap() {
  return /* @__PURE__ */ new Map();
}
var getChildKey = function(child) {
  return child.key || "";
};
function updateChildLookup(children, allChildren) {
  children.forEach(function(child) {
    var key = getChildKey(child);
    allChildren.set(key, child);
  });
}
function onlyElements(children) {
  var filtered = [];
  Children.forEach(children, function(child) {
    if (isValidElement(child))
      filtered.push(child);
  });
  return filtered;
}
var AnimatePresence = function(_a) {
  var children = _a.children, custom = _a.custom, _b = _a.initial, initial = _b === void 0 ? true : _b, onExitComplete = _a.onExitComplete, exitBeforeEnter = _a.exitBeforeEnter, _c = _a.presenceAffectsLayout, presenceAffectsLayout = _c === void 0 ? true : _c;
  var _d = __read(useForceUpdate(), 1), forceRender = _d[0];
  var forceRenderLayoutGroup = useContext(LayoutGroupContext).forceRender;
  if (forceRenderLayoutGroup)
    forceRender = forceRenderLayoutGroup;
  var isMounted = useIsMounted();
  var filteredChildren = onlyElements(children);
  var childrenToRender = filteredChildren;
  var exiting = /* @__PURE__ */ new Set();
  var presentChildren = useRef(childrenToRender);
  var allChildren = useRef(/* @__PURE__ */ new Map()).current;
  var isInitialRender = useRef(true);
  useIsomorphicLayoutEffect$2(function() {
    isInitialRender.current = false;
    updateChildLookup(filteredChildren, allChildren);
    presentChildren.current = childrenToRender;
  });
  useUnmountEffect(function() {
    isInitialRender.current = true;
    allChildren.clear();
    exiting.clear();
  });
  if (isInitialRender.current) {
    return React.createElement(React.Fragment, null, childrenToRender.map(function(child) {
      return React.createElement(PresenceChild, { key: getChildKey(child), isPresent: true, initial: initial ? void 0 : false, presenceAffectsLayout }, child);
    }));
  }
  childrenToRender = __spreadArray$1([], __read(childrenToRender), false);
  var presentKeys = presentChildren.current.map(getChildKey);
  var targetKeys = filteredChildren.map(getChildKey);
  var numPresent = presentKeys.length;
  for (var i3 = 0; i3 < numPresent; i3++) {
    var key = presentKeys[i3];
    if (targetKeys.indexOf(key) === -1) {
      exiting.add(key);
    }
  }
  if (exitBeforeEnter && exiting.size) {
    childrenToRender = [];
  }
  exiting.forEach(function(key2) {
    if (targetKeys.indexOf(key2) !== -1)
      return;
    var child = allChildren.get(key2);
    if (!child)
      return;
    var insertionIndex = presentKeys.indexOf(key2);
    var onExit = function() {
      allChildren.delete(key2);
      exiting.delete(key2);
      var removeIndex = presentChildren.current.findIndex(function(presentChild) {
        return presentChild.key === key2;
      });
      presentChildren.current.splice(removeIndex, 1);
      if (!exiting.size) {
        presentChildren.current = filteredChildren;
        if (isMounted.current === false)
          return;
        forceRender();
        onExitComplete && onExitComplete();
      }
    };
    childrenToRender.splice(insertionIndex, 0, React.createElement(PresenceChild, { key: getChildKey(child), isPresent: false, onExitComplete: onExit, custom, presenceAffectsLayout }, child));
  });
  childrenToRender = childrenToRender.map(function(child) {
    var key2 = child.key;
    return exiting.has(key2) ? child : React.createElement(PresenceChild, { key: getChildKey(child), isPresent: true, presenceAffectsLayout }, child);
  });
  if (env !== "production" && exitBeforeEnter && childrenToRender.length > 1) {
    console.warn("You're attempting to animate multiple children within AnimatePresence, but its exitBeforeEnter prop is set to true. This will lead to odd visual behaviour.");
  }
  return React.createElement(React.Fragment, null, exiting.size ? childrenToRender : childrenToRender.map(function(child) {
    return cloneElement(child);
  }));
};
function animationControls() {
  var hasMounted = false;
  var pendingAnimations = [];
  var subscribers = /* @__PURE__ */ new Set();
  var controls = {
    subscribe: function(visualElement2) {
      subscribers.add(visualElement2);
      return function() {
        return void subscribers.delete(visualElement2);
      };
    },
    start: function(definition, transitionOverride) {
      if (hasMounted) {
        var animations_1 = [];
        subscribers.forEach(function(visualElement2) {
          animations_1.push(animateVisualElement(visualElement2, definition, {
            transitionOverride
          }));
        });
        return Promise.all(animations_1);
      } else {
        return new Promise(function(resolve) {
          pendingAnimations.push({
            animation: [definition, transitionOverride],
            resolve
          });
        });
      }
    },
    set: function(definition) {
      invariant$1(hasMounted, "controls.set() should only be called after a component has mounted. Consider calling within a useEffect hook.");
      return subscribers.forEach(function(visualElement2) {
        setValues(visualElement2, definition);
      });
    },
    stop: function() {
      subscribers.forEach(function(visualElement2) {
        stopAnimation(visualElement2);
      });
    },
    mount: function() {
      hasMounted = true;
      pendingAnimations.forEach(function(_a) {
        var animation = _a.animation, resolve = _a.resolve;
        controls.start.apply(controls, __spreadArray$1([], __read(animation), false)).then(resolve);
      });
      return function() {
        hasMounted = false;
        controls.stop();
      };
    }
  };
  return controls;
}
function useAnimationControls() {
  var controls = useConstant(animationControls);
  useEffect(controls.mount, []);
  return controls;
}
var useAnimation = useAnimationControls;
const DialogDrawer = React.forwardRef(function DialogDrawer2(props, ref) {
  var _a, _b;
  const dialog = useCurrentDialog();
  const className = clsx(
    "absolute top-0  -ml-[4px] hidden h-full w-full overflow-y-auto rounded-r bg-white p-6 text-left",
    props.className
  );
  return /* @__PURE__ */ React.createElement(
    motion.div,
    {
      ...props,
      className,
      "data-taco": "dialog-drawer",
      "aria-hidden": !((_a = dialog.drawer) == null ? void 0 : _a.open),
      variants: {
        visible: {
          left: "100%",
          display: "block",
          transition: { ease: "easeOut", duration: 0.2 }
        },
        hidden: {
          left: "0%",
          transition: { ease: "easeOut", duration: 0.2 },
          transitionEnd: {
            display: "none"
          }
        }
      },
      animate: ((_b = dialog.drawer) == null ? void 0 : _b.open) ? "visible" : "hidden",
      ref
    },
    typeof props.children === "function" ? props.children(dialog.drawer) : props.children
  );
});
DialogDrawer.displayName = "DialogDrawer";
const Extra = React.forwardRef(function DialogExtra(props, ref) {
  const className = clsx(
    "wcag-grey-100 absolute top-full left-0 -mt-px w-full rounded-t-none rounded-b p-6 text-left",
    props.className
  );
  return /* @__PURE__ */ React.createElement("div", { ...props, className, "data-taco": "dialog-extra", ref });
});
Extra.displayName = "DialogExtra";
const useSeparatedChildren = (initialChildren) => {
  return React.useMemo(() => {
    const children = [];
    let drawer;
    let extra;
    React.Children.toArray(initialChildren).forEach((child) => {
      var _a, _b;
      if (((_a = child.type) == null ? void 0 : _a.displayName) === DialogDrawer.displayName) {
        drawer = child;
      } else if (((_b = child.type) == null ? void 0 : _b.displayName) === Extra.displayName) {
        extra = child;
      } else {
        children.push(child);
      }
    });
    return [children, drawer, extra];
  }, [initialChildren]);
};
const Dialog = React.forwardRef(function Dialog2(props, ref) {
  const {
    children: initialChildren,
    closeOnEscape = true,
    defaultOpen,
    draggable = false,
    onChange,
    onClose,
    open,
    showCloseButton = true,
    size: size2 = "sm",
    trigger,
    ...otherProps
  } = props;
  const [children, drawer, extra] = useSeparatedChildren(initialChildren);
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const context = React.useMemo(
    () => ({
      closeOnEscape,
      draggable,
      drawer: {
        open: drawerOpen,
        toggle: () => setDrawerOpen((isDrawerOpen) => !isDrawerOpen)
      },
      elements: {
        drawer,
        extra
      },
      onClose,
      props: otherProps,
      showCloseButton,
      size: size2,
      ref
    }),
    [closeOnEscape, drawerOpen, draggable, drawer, extra, open, otherProps, showCloseButton]
  );
  return /* @__PURE__ */ React.createElement(DialogContext.Provider, { value: context }, /* @__PURE__ */ React.createElement($5d3850c4d0b4e6c7$export$be92b6f5f03c0fe9, { defaultOpen, open, onOpenChange: onChange }, trigger && /* @__PURE__ */ React.createElement(Trigger$4, null, trigger), children));
});
Dialog.Trigger = Trigger$4;
Dialog.Content = Content$6;
Dialog.Title = Title$4;
Dialog.Footer = Footer$2;
Dialog.Extra = Extra;
Dialog.Drawer = DialogDrawer;
Dialog.Close = Close$1;
const Group$6 = React.forwardRef(function Group2(props, ref) {
  const { as: Tag2 = "span", orientation = "horizontal", ...otherProps } = props;
  const className = clsx(
    'flex gap-2 [&:has([data-taco="tag"])]:!gap-1',
    { "flex-col ": orientation === "vertical" },
    props.className
  );
  return /* @__PURE__ */ React.createElement(Tag2, { ...otherProps, className, "data-taco": "group", ref });
});
const MenuContext = React.createContext(void 0);
const useCurrentMenu = () => {
  return React.useContext(MenuContext);
};
const DrawerContext = React.createContext({
  closeOnEscape: true,
  showCloseButton: true,
  onClickBack: () => {
  },
  onClose: () => {
  },
  onResize: () => {
  },
  props: {},
  ref: null,
  size: "md",
  variant: "embedded"
});
const useCurrentDrawer = () => {
  return React.useContext(DrawerContext);
};
const getDrawerSizeClassnames = (size2) => {
  switch (size2) {
    case "lg":
      return "w-[600px]";
    case "md":
    default:
      return "w-[420px]";
  }
};
const getDrawerContentClassNames = (size2, variant, open) => {
  return clsx(
    "bg-white h-full bottom-0 top-0 right-0 transition-none",
    {
      block: open,
      hidden: !open,
      fixed: variant === "overlay",
      "relative h-full overflow-hidden": variant === "embedded"
    },
    getDrawerSizeClassnames(size2)
  );
};
const getDrawerContainerClassNames = (variant) => {
  return clsx("bg-white mx-auto absolute h-full w-full flex flex-col ", {
    "shadow-[0_6px_9px_0_rgba(89,85,98,0.3),0_0_1px_0_rgba(89,85,98,0.2)]": variant === "overlay",
    "border-l border-grey-300 h-full": variant === "embedded"
  });
};
const getDrawerDragHandlerClassNames = () => {
  return clsx("border-[2px] absolute border-transparent top-0 w-2 h-full cursor-ew-resize left-0 hover:border-l-blue-500");
};
const getBackdropClassNames = (open) => {
  return clsx({
    block: open,
    hidden: !open
  });
};
const $f631663db3294ace$var$DirectionContext = /* @__PURE__ */ createContext(void 0);
function $f631663db3294ace$export$b39126d51d94e6f3(localDir) {
  const globalDir = useContext($f631663db3294ace$var$DirectionContext);
  return localDir || globalDir || "ltr";
}
const $9f79659886946c16$export$e5c5a5f917a5871c$1 = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) ? useLayoutEffect : () => {
};
function $ae6933e535247d3d$export$7d15b64cf5a3a4c4(value, [min2, max2]) {
  return Math.min(max2, Math.max(min2, value));
}
function $6c2e24571c90391f$export$3e6543de14f8614f(initialState, machine) {
  return useReducer((state, event) => {
    const nextState = machine[state][event];
    return nextState !== null && nextState !== void 0 ? nextState : state;
  }, initialState);
}
const $57acba87d6e25586$var$SCROLL_AREA_NAME = "ScrollArea";
const [$57acba87d6e25586$var$createScrollAreaContext, $57acba87d6e25586$export$488468afe3a6f2b1] = $c512c27ab02ef895$export$50c7b4e9d9f19c1$1($57acba87d6e25586$var$SCROLL_AREA_NAME);
const [$57acba87d6e25586$var$ScrollAreaProvider, $57acba87d6e25586$var$useScrollAreaContext] = $57acba87d6e25586$var$createScrollAreaContext($57acba87d6e25586$var$SCROLL_AREA_NAME);
const $57acba87d6e25586$export$ccf8d8d7bbf3c2cc = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeScrollArea, type = "hover", dir, scrollHideDelay = 600, ...scrollAreaProps } = props;
  const [scrollArea, setScrollArea] = useState(null);
  const [viewport, setViewport] = useState(null);
  const [content, setContent] = useState(null);
  const [scrollbarX, setScrollbarX] = useState(null);
  const [scrollbarY, setScrollbarY] = useState(null);
  const [cornerWidth, setCornerWidth] = useState(0);
  const [cornerHeight, setCornerHeight] = useState(0);
  const [scrollbarXEnabled, setScrollbarXEnabled] = useState(false);
  const [scrollbarYEnabled, setScrollbarYEnabled] = useState(false);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05$1(
    forwardedRef,
    (node) => setScrollArea(node)
  );
  const direction = $f631663db3294ace$export$b39126d51d94e6f3(dir);
  return /* @__PURE__ */ createElement($57acba87d6e25586$var$ScrollAreaProvider, {
    scope: __scopeScrollArea,
    type,
    dir: direction,
    scrollHideDelay,
    scrollArea,
    viewport,
    onViewportChange: setViewport,
    content,
    onContentChange: setContent,
    scrollbarX,
    onScrollbarXChange: setScrollbarX,
    scrollbarXEnabled,
    onScrollbarXEnabledChange: setScrollbarXEnabled,
    scrollbarY,
    onScrollbarYChange: setScrollbarY,
    scrollbarYEnabled,
    onScrollbarYEnabledChange: setScrollbarYEnabled,
    onCornerWidthChange: setCornerWidth,
    onCornerHeightChange: setCornerHeight
  }, /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.div, _extends$z({
    dir: direction
  }, scrollAreaProps, {
    ref: composedRefs,
    style: {
      position: "relative",
      // Pass corner sizes as CSS vars to reduce re-renders of context consumers
      ["--radix-scroll-area-corner-width"]: cornerWidth + "px",
      ["--radix-scroll-area-corner-height"]: cornerHeight + "px",
      ...props.style
    }
  })));
});
const $57acba87d6e25586$var$VIEWPORT_NAME = "ScrollAreaViewport";
const $57acba87d6e25586$export$a21cbf9f11fca853 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeScrollArea, children, ...viewportProps } = props;
  const context = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$VIEWPORT_NAME, __scopeScrollArea);
  const ref = useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05$1(forwardedRef, ref, context.onViewportChange);
  return /* @__PURE__ */ createElement(Fragment, null, /* @__PURE__ */ createElement("style", {
    dangerouslySetInnerHTML: {
      __html: `[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}`
    }
  }), /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.div, _extends$z({
    "data-radix-scroll-area-viewport": ""
  }, viewportProps, {
    ref: composedRefs,
    style: {
      /**
      * We don't support `visible` because the intention is to have at least one scrollbar
      * if this component is used and `visible` will behave like `auto` in that case
      * https://developer.mozilla.org/en-US/docs/Web/CSS/overflowed#description
      *
      * We don't handle `auto` because the intention is for the native implementation
      * to be hidden if using this component. We just want to ensure the node is scrollable
      * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
      * the browser from having to work out whether to render native scrollbars or not,
      * we tell it to with the intention of hiding them in CSS.
      */
      overflowX: context.scrollbarXEnabled ? "scroll" : "hidden",
      overflowY: context.scrollbarYEnabled ? "scroll" : "hidden",
      ...props.style
    }
  }), /* @__PURE__ */ createElement("div", {
    ref: context.onContentChange,
    style: {
      minWidth: "100%",
      display: "table"
    }
  }, children)));
});
const $57acba87d6e25586$var$SCROLLBAR_NAME = "ScrollAreaScrollbar";
const $57acba87d6e25586$export$2fabd85d0eba3c57 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { forceMount, ...scrollbarProps } = props;
  const context = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$SCROLLBAR_NAME, props.__scopeScrollArea);
  const { onScrollbarXEnabledChange, onScrollbarYEnabledChange } = context;
  const isHorizontal = props.orientation === "horizontal";
  useEffect(() => {
    isHorizontal ? onScrollbarXEnabledChange(true) : onScrollbarYEnabledChange(true);
    return () => {
      isHorizontal ? onScrollbarXEnabledChange(false) : onScrollbarYEnabledChange(false);
    };
  }, [
    isHorizontal,
    onScrollbarXEnabledChange,
    onScrollbarYEnabledChange
  ]);
  return context.type === "hover" ? /* @__PURE__ */ createElement($57acba87d6e25586$var$ScrollAreaScrollbarHover, _extends$z({}, scrollbarProps, {
    ref: forwardedRef,
    forceMount
  })) : context.type === "scroll" ? /* @__PURE__ */ createElement($57acba87d6e25586$var$ScrollAreaScrollbarScroll, _extends$z({}, scrollbarProps, {
    ref: forwardedRef,
    forceMount
  })) : context.type === "auto" ? /* @__PURE__ */ createElement($57acba87d6e25586$var$ScrollAreaScrollbarAuto, _extends$z({}, scrollbarProps, {
    ref: forwardedRef,
    forceMount
  })) : context.type === "always" ? /* @__PURE__ */ createElement($57acba87d6e25586$var$ScrollAreaScrollbarVisible, _extends$z({}, scrollbarProps, {
    ref: forwardedRef
  })) : null;
});
const $57acba87d6e25586$var$ScrollAreaScrollbarHover = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { forceMount, ...scrollbarProps } = props;
  const context = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$SCROLLBAR_NAME, props.__scopeScrollArea);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const scrollArea = context.scrollArea;
    let hideTimer = 0;
    if (scrollArea) {
      const handlePointerEnter = () => {
        window.clearTimeout(hideTimer);
        setVisible(true);
      };
      const handlePointerLeave = () => {
        hideTimer = window.setTimeout(
          () => setVisible(false),
          context.scrollHideDelay
        );
      };
      scrollArea.addEventListener("pointerenter", handlePointerEnter);
      scrollArea.addEventListener("pointerleave", handlePointerLeave);
      return () => {
        window.clearTimeout(hideTimer);
        scrollArea.removeEventListener("pointerenter", handlePointerEnter);
        scrollArea.removeEventListener("pointerleave", handlePointerLeave);
      };
    }
  }, [
    context.scrollArea,
    context.scrollHideDelay
  ]);
  return /* @__PURE__ */ createElement($921a889cee6df7e8$export$99c2b779aa4e8b8b$1, {
    present: forceMount || visible
  }, /* @__PURE__ */ createElement($57acba87d6e25586$var$ScrollAreaScrollbarAuto, _extends$z({
    "data-state": visible ? "visible" : "hidden"
  }, scrollbarProps, {
    ref: forwardedRef
  })));
});
const $57acba87d6e25586$var$ScrollAreaScrollbarScroll = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { forceMount, ...scrollbarProps } = props;
  const context = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$SCROLLBAR_NAME, props.__scopeScrollArea);
  const isHorizontal = props.orientation === "horizontal";
  const debounceScrollEnd = $57acba87d6e25586$var$useDebounceCallback(
    () => send("SCROLL_END"),
    100
  );
  const [state, send] = $6c2e24571c90391f$export$3e6543de14f8614f("hidden", {
    hidden: {
      SCROLL: "scrolling"
    },
    scrolling: {
      SCROLL_END: "idle",
      POINTER_ENTER: "interacting"
    },
    interacting: {
      SCROLL: "interacting",
      POINTER_LEAVE: "idle"
    },
    idle: {
      HIDE: "hidden",
      SCROLL: "scrolling",
      POINTER_ENTER: "interacting"
    }
  });
  useEffect(() => {
    if (state === "idle") {
      const hideTimer = window.setTimeout(
        () => send("HIDE"),
        context.scrollHideDelay
      );
      return () => window.clearTimeout(hideTimer);
    }
  }, [
    state,
    context.scrollHideDelay,
    send
  ]);
  useEffect(() => {
    const viewport = context.viewport;
    const scrollDirection = isHorizontal ? "scrollLeft" : "scrollTop";
    if (viewport) {
      let prevScrollPos = viewport[scrollDirection];
      const handleScroll2 = () => {
        const scrollPos = viewport[scrollDirection];
        const hasScrollInDirectionChanged = prevScrollPos !== scrollPos;
        if (hasScrollInDirectionChanged) {
          send("SCROLL");
          debounceScrollEnd();
        }
        prevScrollPos = scrollPos;
      };
      viewport.addEventListener("scroll", handleScroll2);
      return () => viewport.removeEventListener("scroll", handleScroll2);
    }
  }, [
    context.viewport,
    isHorizontal,
    send,
    debounceScrollEnd
  ]);
  return /* @__PURE__ */ createElement($921a889cee6df7e8$export$99c2b779aa4e8b8b$1, {
    present: forceMount || state !== "hidden"
  }, /* @__PURE__ */ createElement($57acba87d6e25586$var$ScrollAreaScrollbarVisible, _extends$z({
    "data-state": state === "hidden" ? "hidden" : "visible"
  }, scrollbarProps, {
    ref: forwardedRef,
    onPointerEnter: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(
      props.onPointerEnter,
      () => send("POINTER_ENTER")
    ),
    onPointerLeave: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(
      props.onPointerLeave,
      () => send("POINTER_LEAVE")
    )
  })));
});
const $57acba87d6e25586$var$ScrollAreaScrollbarAuto = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const context = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$SCROLLBAR_NAME, props.__scopeScrollArea);
  const { forceMount, ...scrollbarProps } = props;
  const [visible, setVisible] = useState(false);
  const isHorizontal = props.orientation === "horizontal";
  const handleResize = $57acba87d6e25586$var$useDebounceCallback(() => {
    if (context.viewport) {
      const isOverflowX = context.viewport.offsetWidth < context.viewport.scrollWidth;
      const isOverflowY = context.viewport.offsetHeight < context.viewport.scrollHeight;
      setVisible(isHorizontal ? isOverflowX : isOverflowY);
    }
  }, 10);
  $57acba87d6e25586$var$useResizeObserver(context.viewport, handleResize);
  $57acba87d6e25586$var$useResizeObserver(context.content, handleResize);
  return /* @__PURE__ */ createElement($921a889cee6df7e8$export$99c2b779aa4e8b8b$1, {
    present: forceMount || visible
  }, /* @__PURE__ */ createElement($57acba87d6e25586$var$ScrollAreaScrollbarVisible, _extends$z({
    "data-state": visible ? "visible" : "hidden"
  }, scrollbarProps, {
    ref: forwardedRef
  })));
});
const $57acba87d6e25586$var$ScrollAreaScrollbarVisible = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { orientation = "vertical", ...scrollbarProps } = props;
  const context = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$SCROLLBAR_NAME, props.__scopeScrollArea);
  const thumbRef = useRef(null);
  const pointerOffsetRef = useRef(0);
  const [sizes, setSizes] = useState({
    content: 0,
    viewport: 0,
    scrollbar: {
      size: 0,
      paddingStart: 0,
      paddingEnd: 0
    }
  });
  const thumbRatio = $57acba87d6e25586$var$getThumbRatio(sizes.viewport, sizes.content);
  const commonProps = {
    ...scrollbarProps,
    sizes,
    onSizesChange: setSizes,
    hasThumb: Boolean(thumbRatio > 0 && thumbRatio < 1),
    onThumbChange: (thumb) => thumbRef.current = thumb,
    onThumbPointerUp: () => pointerOffsetRef.current = 0,
    onThumbPointerDown: (pointerPos) => pointerOffsetRef.current = pointerPos
  };
  function getScrollPosition2(pointerPos, dir) {
    return $57acba87d6e25586$var$getScrollPositionFromPointer(pointerPos, pointerOffsetRef.current, sizes, dir);
  }
  if (orientation === "horizontal") return /* @__PURE__ */ createElement($57acba87d6e25586$var$ScrollAreaScrollbarX, _extends$z({}, commonProps, {
    ref: forwardedRef,
    onThumbPositionChange: () => {
      if (context.viewport && thumbRef.current) {
        const scrollPos = context.viewport.scrollLeft;
        const offset2 = $57acba87d6e25586$var$getThumbOffsetFromScroll(scrollPos, sizes, context.dir);
        thumbRef.current.style.transform = `translate3d(${offset2}px, 0, 0)`;
      }
    },
    onWheelScroll: (scrollPos) => {
      if (context.viewport) context.viewport.scrollLeft = scrollPos;
    },
    onDragScroll: (pointerPos) => {
      if (context.viewport) context.viewport.scrollLeft = getScrollPosition2(pointerPos, context.dir);
    }
  }));
  if (orientation === "vertical") return /* @__PURE__ */ createElement($57acba87d6e25586$var$ScrollAreaScrollbarY, _extends$z({}, commonProps, {
    ref: forwardedRef,
    onThumbPositionChange: () => {
      if (context.viewport && thumbRef.current) {
        const scrollPos = context.viewport.scrollTop;
        const offset2 = $57acba87d6e25586$var$getThumbOffsetFromScroll(scrollPos, sizes);
        thumbRef.current.style.transform = `translate3d(0, ${offset2}px, 0)`;
      }
    },
    onWheelScroll: (scrollPos) => {
      if (context.viewport) context.viewport.scrollTop = scrollPos;
    },
    onDragScroll: (pointerPos) => {
      if (context.viewport) context.viewport.scrollTop = getScrollPosition2(pointerPos);
    }
  }));
  return null;
});
const $57acba87d6e25586$var$ScrollAreaScrollbarX = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { sizes, onSizesChange, ...scrollbarProps } = props;
  const context = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$SCROLLBAR_NAME, props.__scopeScrollArea);
  const [computedStyle, setComputedStyle] = useState();
  const ref = useRef(null);
  const composeRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05$1(forwardedRef, ref, context.onScrollbarXChange);
  useEffect(() => {
    if (ref.current) setComputedStyle(getComputedStyle(ref.current));
  }, [
    ref
  ]);
  return /* @__PURE__ */ createElement($57acba87d6e25586$var$ScrollAreaScrollbarImpl, _extends$z({
    "data-orientation": "horizontal"
  }, scrollbarProps, {
    ref: composeRefs,
    sizes,
    style: {
      bottom: 0,
      left: context.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
      right: context.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
      ["--radix-scroll-area-thumb-width"]: $57acba87d6e25586$var$getThumbSize(sizes) + "px",
      ...props.style
    },
    onThumbPointerDown: (pointerPos) => props.onThumbPointerDown(pointerPos.x),
    onDragScroll: (pointerPos) => props.onDragScroll(pointerPos.x),
    onWheelScroll: (event, maxScrollPos) => {
      if (context.viewport) {
        const scrollPos = context.viewport.scrollLeft + event.deltaX;
        props.onWheelScroll(scrollPos);
        if ($57acba87d6e25586$var$isScrollingWithinScrollbarBounds(scrollPos, maxScrollPos)) event.preventDefault();
      }
    },
    onResize: () => {
      if (ref.current && context.viewport && computedStyle) onSizesChange({
        content: context.viewport.scrollWidth,
        viewport: context.viewport.offsetWidth,
        scrollbar: {
          size: ref.current.clientWidth,
          paddingStart: $57acba87d6e25586$var$toInt(computedStyle.paddingLeft),
          paddingEnd: $57acba87d6e25586$var$toInt(computedStyle.paddingRight)
        }
      });
    }
  }));
});
const $57acba87d6e25586$var$ScrollAreaScrollbarY = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { sizes, onSizesChange, ...scrollbarProps } = props;
  const context = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$SCROLLBAR_NAME, props.__scopeScrollArea);
  const [computedStyle, setComputedStyle] = useState();
  const ref = useRef(null);
  const composeRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05$1(forwardedRef, ref, context.onScrollbarYChange);
  useEffect(() => {
    if (ref.current) setComputedStyle(getComputedStyle(ref.current));
  }, [
    ref
  ]);
  return /* @__PURE__ */ createElement($57acba87d6e25586$var$ScrollAreaScrollbarImpl, _extends$z({
    "data-orientation": "vertical"
  }, scrollbarProps, {
    ref: composeRefs,
    sizes,
    style: {
      top: 0,
      right: context.dir === "ltr" ? 0 : void 0,
      left: context.dir === "rtl" ? 0 : void 0,
      bottom: "var(--radix-scroll-area-corner-height)",
      ["--radix-scroll-area-thumb-height"]: $57acba87d6e25586$var$getThumbSize(sizes) + "px",
      ...props.style
    },
    onThumbPointerDown: (pointerPos) => props.onThumbPointerDown(pointerPos.y),
    onDragScroll: (pointerPos) => props.onDragScroll(pointerPos.y),
    onWheelScroll: (event, maxScrollPos) => {
      if (context.viewport) {
        const scrollPos = context.viewport.scrollTop + event.deltaY;
        props.onWheelScroll(scrollPos);
        if ($57acba87d6e25586$var$isScrollingWithinScrollbarBounds(scrollPos, maxScrollPos)) event.preventDefault();
      }
    },
    onResize: () => {
      if (ref.current && context.viewport && computedStyle) onSizesChange({
        content: context.viewport.scrollHeight,
        viewport: context.viewport.offsetHeight,
        scrollbar: {
          size: ref.current.clientHeight,
          paddingStart: $57acba87d6e25586$var$toInt(computedStyle.paddingTop),
          paddingEnd: $57acba87d6e25586$var$toInt(computedStyle.paddingBottom)
        }
      });
    }
  }));
});
const [$57acba87d6e25586$var$ScrollbarProvider, $57acba87d6e25586$var$useScrollbarContext] = $57acba87d6e25586$var$createScrollAreaContext($57acba87d6e25586$var$SCROLLBAR_NAME);
const $57acba87d6e25586$var$ScrollAreaScrollbarImpl = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeScrollArea, sizes, hasThumb, onThumbChange, onThumbPointerUp, onThumbPointerDown, onThumbPositionChange, onDragScroll, onWheelScroll, onResize, ...scrollbarProps } = props;
  const context = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$SCROLLBAR_NAME, __scopeScrollArea);
  const [scrollbar, setScrollbar] = useState(null);
  const composeRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05$1(
    forwardedRef,
    (node) => setScrollbar(node)
  );
  const rectRef = useRef(null);
  const prevWebkitUserSelectRef = useRef("");
  const viewport = context.viewport;
  const maxScrollPos = sizes.content - sizes.viewport;
  const handleWheelScroll = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a$1(onWheelScroll);
  const handleThumbPositionChange = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a$1(onThumbPositionChange);
  const handleResize = $57acba87d6e25586$var$useDebounceCallback(onResize, 10);
  function handleDragScroll(event) {
    if (rectRef.current) {
      const x3 = event.clientX - rectRef.current.left;
      const y4 = event.clientY - rectRef.current.top;
      onDragScroll({
        x: x3,
        y: y4
      });
    }
  }
  useEffect(() => {
    const handleWheel = (event) => {
      const element = event.target;
      const isScrollbarWheel = scrollbar === null || scrollbar === void 0 ? void 0 : scrollbar.contains(element);
      if (isScrollbarWheel) handleWheelScroll(event, maxScrollPos);
    };
    document.addEventListener("wheel", handleWheel, {
      passive: false
    });
    return () => document.removeEventListener("wheel", handleWheel, {
      passive: false
    });
  }, [
    viewport,
    scrollbar,
    maxScrollPos,
    handleWheelScroll
  ]);
  useEffect(handleThumbPositionChange, [
    sizes,
    handleThumbPositionChange
  ]);
  $57acba87d6e25586$var$useResizeObserver(scrollbar, handleResize);
  $57acba87d6e25586$var$useResizeObserver(context.content, handleResize);
  return /* @__PURE__ */ createElement($57acba87d6e25586$var$ScrollbarProvider, {
    scope: __scopeScrollArea,
    scrollbar,
    hasThumb,
    onThumbChange: $b1b2314f5f9a1d84$export$25bec8c6f54ee79a$1(onThumbChange),
    onThumbPointerUp: $b1b2314f5f9a1d84$export$25bec8c6f54ee79a$1(onThumbPointerUp),
    onThumbPositionChange: handleThumbPositionChange,
    onThumbPointerDown: $b1b2314f5f9a1d84$export$25bec8c6f54ee79a$1(onThumbPointerDown)
  }, /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.div, _extends$z({}, scrollbarProps, {
    ref: composeRefs,
    style: {
      position: "absolute",
      ...scrollbarProps.style
    },
    onPointerDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(props.onPointerDown, (event) => {
      const mainPointer = 0;
      if (event.button === mainPointer) {
        const element = event.target;
        element.setPointerCapture(event.pointerId);
        rectRef.current = scrollbar.getBoundingClientRect();
        prevWebkitUserSelectRef.current = document.body.style.webkitUserSelect;
        document.body.style.webkitUserSelect = "none";
        handleDragScroll(event);
      }
    }),
    onPointerMove: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(props.onPointerMove, handleDragScroll),
    onPointerUp: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(props.onPointerUp, (event) => {
      const element = event.target;
      element.releasePointerCapture(event.pointerId);
      document.body.style.webkitUserSelect = prevWebkitUserSelectRef.current;
      rectRef.current = null;
    })
  })));
});
const $57acba87d6e25586$var$THUMB_NAME = "ScrollAreaThumb";
const $57acba87d6e25586$export$9fba1154677d7cd2 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { forceMount, ...thumbProps } = props;
  const scrollbarContext = $57acba87d6e25586$var$useScrollbarContext($57acba87d6e25586$var$THUMB_NAME, props.__scopeScrollArea);
  return /* @__PURE__ */ createElement($921a889cee6df7e8$export$99c2b779aa4e8b8b$1, {
    present: forceMount || scrollbarContext.hasThumb
  }, /* @__PURE__ */ createElement($57acba87d6e25586$var$ScrollAreaThumbImpl, _extends$z({
    ref: forwardedRef
  }, thumbProps)));
});
const $57acba87d6e25586$var$ScrollAreaThumbImpl = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeScrollArea, style, ...thumbProps } = props;
  const scrollAreaContext = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$THUMB_NAME, __scopeScrollArea);
  const scrollbarContext = $57acba87d6e25586$var$useScrollbarContext($57acba87d6e25586$var$THUMB_NAME, __scopeScrollArea);
  const { onThumbPositionChange } = scrollbarContext;
  const composedRef = $6ed0406888f73fc4$export$c7b2cbe3552a0d05$1(
    forwardedRef,
    (node) => scrollbarContext.onThumbChange(node)
  );
  const removeUnlinkedScrollListenerRef = useRef();
  const debounceScrollEnd = $57acba87d6e25586$var$useDebounceCallback(() => {
    if (removeUnlinkedScrollListenerRef.current) {
      removeUnlinkedScrollListenerRef.current();
      removeUnlinkedScrollListenerRef.current = void 0;
    }
  }, 100);
  useEffect(() => {
    const viewport = scrollAreaContext.viewport;
    if (viewport) {
      const handleScroll2 = () => {
        debounceScrollEnd();
        if (!removeUnlinkedScrollListenerRef.current) {
          const listener = $57acba87d6e25586$var$addUnlinkedScrollListener(viewport, onThumbPositionChange);
          removeUnlinkedScrollListenerRef.current = listener;
          onThumbPositionChange();
        }
      };
      onThumbPositionChange();
      viewport.addEventListener("scroll", handleScroll2);
      return () => viewport.removeEventListener("scroll", handleScroll2);
    }
  }, [
    scrollAreaContext.viewport,
    debounceScrollEnd,
    onThumbPositionChange
  ]);
  return /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.div, _extends$z({
    "data-state": scrollbarContext.hasThumb ? "visible" : "hidden"
  }, thumbProps, {
    ref: composedRef,
    style: {
      width: "var(--radix-scroll-area-thumb-width)",
      height: "var(--radix-scroll-area-thumb-height)",
      ...style
    },
    onPointerDownCapture: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(props.onPointerDownCapture, (event) => {
      const thumb = event.target;
      const thumbRect = thumb.getBoundingClientRect();
      const x3 = event.clientX - thumbRect.left;
      const y4 = event.clientY - thumbRect.top;
      scrollbarContext.onThumbPointerDown({
        x: x3,
        y: y4
      });
    }),
    onPointerUp: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(props.onPointerUp, scrollbarContext.onThumbPointerUp)
  }));
});
const $57acba87d6e25586$var$CORNER_NAME = "ScrollAreaCorner";
const $57acba87d6e25586$export$56969d565df7cc4b = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const context = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$CORNER_NAME, props.__scopeScrollArea);
  const hasBothScrollbarsVisible = Boolean(context.scrollbarX && context.scrollbarY);
  const hasCorner = context.type !== "scroll" && hasBothScrollbarsVisible;
  return hasCorner ? /* @__PURE__ */ createElement($57acba87d6e25586$var$ScrollAreaCornerImpl, _extends$z({}, props, {
    ref: forwardedRef
  })) : null;
});
const $57acba87d6e25586$var$ScrollAreaCornerImpl = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeScrollArea, ...cornerProps } = props;
  const context = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$CORNER_NAME, __scopeScrollArea);
  const [width1, setWidth] = useState(0);
  const [height1, setHeight] = useState(0);
  const hasSize = Boolean(width1 && height1);
  $57acba87d6e25586$var$useResizeObserver(context.scrollbarX, () => {
    var _context$scrollbarX;
    const height = ((_context$scrollbarX = context.scrollbarX) === null || _context$scrollbarX === void 0 ? void 0 : _context$scrollbarX.offsetHeight) || 0;
    context.onCornerHeightChange(height);
    setHeight(height);
  });
  $57acba87d6e25586$var$useResizeObserver(context.scrollbarY, () => {
    var _context$scrollbarY;
    const width = ((_context$scrollbarY = context.scrollbarY) === null || _context$scrollbarY === void 0 ? void 0 : _context$scrollbarY.offsetWidth) || 0;
    context.onCornerWidthChange(width);
    setWidth(width);
  });
  return hasSize ? /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.div, _extends$z({}, cornerProps, {
    ref: forwardedRef,
    style: {
      width: width1,
      height: height1,
      position: "absolute",
      right: context.dir === "ltr" ? 0 : void 0,
      left: context.dir === "rtl" ? 0 : void 0,
      bottom: 0,
      ...props.style
    }
  })) : null;
});
function $57acba87d6e25586$var$toInt(value) {
  return value ? parseInt(value, 10) : 0;
}
function $57acba87d6e25586$var$getThumbRatio(viewportSize, contentSize) {
  const ratio = viewportSize / contentSize;
  return isNaN(ratio) ? 0 : ratio;
}
function $57acba87d6e25586$var$getThumbSize(sizes) {
  const ratio = $57acba87d6e25586$var$getThumbRatio(sizes.viewport, sizes.content);
  const scrollbarPadding = sizes.scrollbar.paddingStart + sizes.scrollbar.paddingEnd;
  const thumbSize = (sizes.scrollbar.size - scrollbarPadding) * ratio;
  return Math.max(thumbSize, 18);
}
function $57acba87d6e25586$var$getScrollPositionFromPointer(pointerPos, pointerOffset, sizes, dir = "ltr") {
  const thumbSizePx = $57acba87d6e25586$var$getThumbSize(sizes);
  const thumbCenter = thumbSizePx / 2;
  const offset2 = pointerOffset || thumbCenter;
  const thumbOffsetFromEnd = thumbSizePx - offset2;
  const minPointerPos = sizes.scrollbar.paddingStart + offset2;
  const maxPointerPos = sizes.scrollbar.size - sizes.scrollbar.paddingEnd - thumbOffsetFromEnd;
  const maxScrollPos = sizes.content - sizes.viewport;
  const scrollRange = dir === "ltr" ? [
    0,
    maxScrollPos
  ] : [
    maxScrollPos * -1,
    0
  ];
  const interpolate2 = $57acba87d6e25586$var$linearScale([
    minPointerPos,
    maxPointerPos
  ], scrollRange);
  return interpolate2(pointerPos);
}
function $57acba87d6e25586$var$getThumbOffsetFromScroll(scrollPos, sizes, dir = "ltr") {
  const thumbSizePx = $57acba87d6e25586$var$getThumbSize(sizes);
  const scrollbarPadding = sizes.scrollbar.paddingStart + sizes.scrollbar.paddingEnd;
  const scrollbar = sizes.scrollbar.size - scrollbarPadding;
  const maxScrollPos = sizes.content - sizes.viewport;
  const maxThumbPos = scrollbar - thumbSizePx;
  const scrollClampRange = dir === "ltr" ? [
    0,
    maxScrollPos
  ] : [
    maxScrollPos * -1,
    0
  ];
  const scrollWithoutMomentum = $ae6933e535247d3d$export$7d15b64cf5a3a4c4(scrollPos, scrollClampRange);
  const interpolate2 = $57acba87d6e25586$var$linearScale([
    0,
    maxScrollPos
  ], [
    0,
    maxThumbPos
  ]);
  return interpolate2(scrollWithoutMomentum);
}
function $57acba87d6e25586$var$linearScale(input, output) {
  return (value) => {
    if (input[0] === input[1] || output[0] === output[1]) return output[0];
    const ratio = (output[1] - output[0]) / (input[1] - input[0]);
    return output[0] + ratio * (value - input[0]);
  };
}
function $57acba87d6e25586$var$isScrollingWithinScrollbarBounds(scrollPos, maxScrollPos) {
  return scrollPos > 0 && scrollPos < maxScrollPos;
}
const $57acba87d6e25586$var$addUnlinkedScrollListener = (node, handler = () => {
}) => {
  let prevPosition = {
    left: node.scrollLeft,
    top: node.scrollTop
  };
  let rAF = 0;
  (function loop() {
    const position = {
      left: node.scrollLeft,
      top: node.scrollTop
    };
    const isHorizontalScroll = prevPosition.left !== position.left;
    const isVerticalScroll = prevPosition.top !== position.top;
    if (isHorizontalScroll || isVerticalScroll) handler();
    prevPosition = position;
    rAF = window.requestAnimationFrame(loop);
  })();
  return () => window.cancelAnimationFrame(rAF);
};
function $57acba87d6e25586$var$useDebounceCallback(callback, delay) {
  const handleCallback = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a$1(callback);
  const debounceTimerRef = useRef(0);
  useEffect(
    () => () => window.clearTimeout(debounceTimerRef.current),
    []
  );
  return useCallback(() => {
    window.clearTimeout(debounceTimerRef.current);
    debounceTimerRef.current = window.setTimeout(handleCallback, delay);
  }, [
    handleCallback,
    delay
  ]);
}
function $57acba87d6e25586$var$useResizeObserver(element, onResize) {
  const handleResize = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a$1(onResize);
  $9f79659886946c16$export$e5c5a5f917a5871c$1(() => {
    let rAF = 0;
    if (element) {
      const resizeObserver = new ResizeObserver(() => {
        cancelAnimationFrame(rAF);
        rAF = window.requestAnimationFrame(handleResize);
      });
      resizeObserver.observe(element);
      return () => {
        window.cancelAnimationFrame(rAF);
        resizeObserver.unobserve(element);
      };
    }
  }, [
    element,
    handleResize
  ]);
}
const $57acba87d6e25586$export$be92b6f5f03c0fe9 = $57acba87d6e25586$export$ccf8d8d7bbf3c2cc;
const $57acba87d6e25586$export$d5c6c08dc2d3ca7 = $57acba87d6e25586$export$a21cbf9f11fca853;
const $57acba87d6e25586$export$9a4e88b92edfce6b = $57acba87d6e25586$export$2fabd85d0eba3c57;
const $57acba87d6e25586$export$6521433ed15a34db = $57acba87d6e25586$export$9fba1154677d7cd2;
const $57acba87d6e25586$export$ac61190d9fc311a9 = $57acba87d6e25586$export$56969d565df7cc4b;
const Bar$2 = (props) => {
  const className = clsx(`flex select-none touch-none transition-colors hover:bg-grey`, {
    "w-[7px] hover:w-[14px] mr-[2px] hover:px-[2px] hover:mr-0": props.orientation === "vertical",
    "flex-col h-[7px] hover:h-[14px] mb-[2px] hover:py-[2px] hover:mb-0": props.orientation === "horizontal"
  });
  return /* @__PURE__ */ React__default.createElement($57acba87d6e25586$export$9a4e88b92edfce6b, { ...props, className });
};
const Thumb = () => /* @__PURE__ */ React__default.createElement($57acba87d6e25586$export$6521433ed15a34db, { className: "flex-[1] rounded bg-black opacity-50" });
const Corner = () => /* @__PURE__ */ React__default.createElement($57acba87d6e25586$export$ac61190d9fc311a9, { className: "bg-grey-500" });
const ScrollArea = (props) => {
  const { children, ...otherProps } = props;
  return /* @__PURE__ */ React__default.createElement($57acba87d6e25586$export$be92b6f5f03c0fe9, { ...otherProps, className: clsx("overflow-hidden", props.className), "data-taco": "scrollarea" }, /* @__PURE__ */ React__default.createElement($57acba87d6e25586$export$d5c6c08dc2d3ca7, { className: "h-full w-full" }, children), /* @__PURE__ */ React__default.createElement(Bar$2, { orientation: "vertical" }, /* @__PURE__ */ React__default.createElement(Thumb, null)), /* @__PURE__ */ React__default.createElement(Bar$2, { orientation: "horizontal" }, /* @__PURE__ */ React__default.createElement(Thumb, null)), /* @__PURE__ */ React__default.createElement(Corner, null));
};
const RESIZE_MIN = 360;
const RESIZE_MAX = 1e3;
const RenderPropWrapper = React__default.forwardRef(function RenderPropWrapper23({ children, onClick, renderProps }, ref) {
  const close = () => {
    onClick(new CustomEvent("close"));
  };
  return children({ close, ref, ...renderProps });
});
const Title$3 = React__default.forwardRef(function DrawerTitle(props, externalRef) {
  const { className, children, ...otherProps } = props;
  const ref = useMergedRef(externalRef);
  const [style, setStyle] = React__default.useState({});
  const { texts } = useLocalization();
  const { onClickBack } = useCurrentDrawer();
  const cName = clsx("grow-0 py-4 px-4 justify-self-start mb-0 border-b-[1px] border-grey-300 flex items-start", className);
  React__default.useEffect(() => {
    var _a;
    const drawer = (_a = ref == null ? void 0 : ref.current) == null ? void 0 : _a.closest('[data-taco="drawer"]');
    const marginAdjust = 4;
    const closeButton = (drawer == null ? void 0 : drawer.querySelector(`[aria-label="${texts.drawer.close}"]`)) ?? null;
    const closeButtonWidth = (closeButton == null ? void 0 : closeButton.offsetWidth) ?? 0;
    const closeButtonRightMargin = 8;
    const actionsWrapper = (drawer == null ? void 0 : drawer.querySelector(`#taco-drawer-actions[data-taco="group"]`)) ?? null;
    const actionsWrapperWidth = (actionsWrapper == null ? void 0 : actionsWrapper.offsetWidth) ?? 0;
    const actionsWrapperRightMargin = 8;
    const marginRight = closeButtonWidth + actionsWrapperWidth + closeButtonRightMargin + actionsWrapperRightMargin - marginAdjust;
    setStyle({ marginRight });
  }, [ref, texts.drawer.close]);
  return /* @__PURE__ */ React__default.createElement($5d3850c4d0b4e6c7$export$f99233281efd08a0, { className: cName, ...otherProps, ref }, onClickBack ? /* @__PURE__ */ React__default.createElement(
    IconButton,
    {
      appearance: "discrete",
      "aria-label": texts.drawer.back,
      className: "mr-3 text-base",
      icon: "chevron-left",
      onClick: onClickBack
    }
  ) : null, /* @__PURE__ */ React__default.createElement("span", { className: "line-clamp-2 inline-block overflow-y-hidden", style }, children));
});
const Footer$1 = React__default.forwardRef(function DrawerFooter(props, ref) {
  const { className, ...otherProps } = props;
  const cName = clsx("mt-auto flex justify-end grow-0 p-4 border-t-[1px] border-grey-300", props.className);
  return /* @__PURE__ */ React__default.createElement("div", { ...otherProps, className: cName, ref });
});
const Actions$1 = React__default.forwardRef(function Actions2(props, ref) {
  const { className, ...otherProps } = props;
  const cName = clsx("absolute top-0 right-10 mr-[8px] mt-4", className);
  return /* @__PURE__ */ React__default.createElement(Group$6, { ...otherProps, className: cName, id: "taco-drawer-actions", ref });
});
const Close = React__default.forwardRef(function DrawerClose(props, ref) {
  const { onClose } = useCurrentDrawer();
  return /* @__PURE__ */ React__default.createElement($5d3850c4d0b4e6c7$export$f39c2d165cd861fe, { ...props, onClick: onClose, ref, asChild: true });
});
const InnerContent = React__default.forwardRef(function InnerContent2(props, ref) {
  const { className, isScrollable: isScrollable2 = true, children, ...otherProps } = props;
  const cName = clsx(
    "grow flex flex-col",
    {
      "overflow-y-hidden": isScrollable2,
      "p-4": !isScrollable2
    },
    className
  );
  return /* @__PURE__ */ React__default.createElement("div", { ...otherProps, className: cName, ref }, isScrollable2 ? /* @__PURE__ */ React__default.createElement(ScrollArea, { className: "w-full gap-y-0.5 p-4" }, children) : children);
});
const Portal$1 = (props) => {
  const { children, ...otherProps } = props;
  const { open = false, variant, outlet } = useCurrentDrawer();
  const backdropClassNames = React__default.useMemo(() => {
    return getBackdropClassNames(open);
  }, [open]);
  if (!outlet) {
    return null;
  }
  return /* @__PURE__ */ React__default.createElement($5d3850c4d0b4e6c7$export$602eac185826482c, { ...otherProps, container: outlet ?? void 0 }, variant === "overlay" ? /* @__PURE__ */ React__default.createElement($5d3850c4d0b4e6c7$export$c6fdb837b070b4ff, { forceMount: true }, /* @__PURE__ */ React__default.createElement(Backdrop, { className: backdropClassNames })) : null, children);
};
const UntrappedFocusDrawerContent = React__default.forwardRef(function EmbeddedDrawerContent(props, ref) {
  const { onEscape, children, ...otherProps } = props;
  useGlobalKeyDown("Escape", onEscape);
  return /* @__PURE__ */ React__default.createElement("div", { ...otherProps, ref }, /* @__PURE__ */ React__default.createElement($9bf71ea28793e738$export$20e40289641fbbb6, { autoFocus: true, restoreFocus: true }, children));
});
const DrawerContent = React__default.forwardRef(function Content2(props, externalRef) {
  const {
    size: size2,
    onClose,
    onResize,
    open = false,
    closeOnEscape,
    variant,
    focusTrap,
    showCloseButton,
    setOpen
  } = useCurrentDrawer();
  const { className, style, children, ...otherProps } = props;
  const { texts } = useLocalization();
  const ref = useMergedRef(externalRef);
  const menu = useCurrentMenu();
  let handleCloseAutoFocus;
  if (menu) {
    handleCloseAutoFocus = () => {
      menu.close();
    };
  }
  const containerClassName = React__default.useMemo(() => clsx(getDrawerContainerClassNames(variant), className), [className]);
  const { contentClassName, dragHandlerClassName } = React__default.useMemo(() => {
    const contentClassName2 = getDrawerContentClassNames(size2, variant, open);
    const dragHandlerClassName2 = getDrawerDragHandlerClassNames();
    return { contentClassName: contentClassName2, dragHandlerClassName: dragHandlerClassName2 };
  }, [size2, variant, open]);
  const handleEscapeKeyDown = (event) => {
    var _a;
    const isTargetInsideDrawerContent = (_a = ref.current) == null ? void 0 : _a.contains(event.target);
    if (isTargetInsideDrawerContent) {
      if (!closeOnEscape) {
        event.preventDefault();
      } else {
        setOpen && setOpen(false);
        if (onClose) {
          onClose();
        }
      }
    }
  };
  const [containerWidth, setContainerWidth] = React__default.useState();
  const dragHandlerRef = React__default.useRef(null);
  const {
    position,
    dragging,
    handleProps: dragHandleProps,
    resetPosition
  } = useDraggable$1(useMergedRef(dragHandlerRef));
  const contentRef = React__default.useRef(null);
  React__default.useEffect(() => {
    if (onResize) {
      onResize(position.x);
    }
  }, [position]);
  React__default.useEffect(() => {
    var _a;
    setContainerWidth((_a = contentRef.current) == null ? void 0 : _a.offsetWidth);
  }, [contentRef, open]);
  const resizedWidth = React__default.useMemo(() => {
    if (containerWidth) {
      return Math.min(RESIZE_MAX, Math.max(RESIZE_MIN, containerWidth - position.x || 0));
    }
    return;
  }, [containerWidth, position]);
  React__default.useEffect(() => {
    if (!dragging && resizedWidth) {
      setContainerWidth(resizedWidth);
      resetPosition();
    }
  }, [dragging]);
  let output;
  if (typeof children === "function") {
    output = /* @__PURE__ */ React__default.createElement(Close, null, /* @__PURE__ */ React__default.createElement(RenderPropWrapper, null, children));
  } else {
    output = children;
  }
  const content = /* @__PURE__ */ React__default.createElement("div", { ref: contentRef, "data-taco": "drawer", className: containerClassName }, output, /* @__PURE__ */ React__default.createElement("div", { className: dragHandlerClassName, ...dragHandleProps, "data-testid": "resize-handler", ref: dragHandlerRef }, dragging ? /* @__PURE__ */ React__default.createElement("div", { "data-testid": "resize-hit-area", className: "fixed bottom-0 left-0 right-0 top-0" }) : null), showCloseButton ? /* @__PURE__ */ React__default.createElement(Close, null, /* @__PURE__ */ React__default.createElement(
    IconButton,
    {
      appearance: "discrete",
      "aria-label": texts.drawer.close,
      className: "absolute right-0 top-0 mr-2 mt-4",
      icon: "close"
    }
  )) : null);
  const styleProp = {
    ...style,
    ...{ width: resizedWidth }
  };
  return focusTrap ? /* @__PURE__ */ React__default.createElement(
    $5d3850c4d0b4e6c7$export$7c6e2c02157bb7d2,
    {
      forceMount: true,
      ...otherProps,
      className: contentClassName,
      onEscapeKeyDown: handleEscapeKeyDown,
      onInteractOutside: variant === "overlay" ? void 0 : (event) => event.preventDefault(),
      onCloseAutoFocus: handleCloseAutoFocus,
      ref,
      style: styleProp
    },
    content
  ) : /* @__PURE__ */ React__default.createElement(UntrappedFocusDrawerContent, { onEscape: handleEscapeKeyDown, className: contentClassName, style: styleProp, ref }, content);
});
const Content$5 = React__default.forwardRef(function Content3(props, externalRef) {
  const { children } = props;
  return /* @__PURE__ */ React__default.createElement(Portal$1, null, /* @__PURE__ */ React__default.createElement(DrawerContent, { ...props, ref: externalRef }, children));
});
const Trigger$3 = React.forwardRef(function DrawerTrigger(props, ref) {
  return /* @__PURE__ */ React.createElement($5d3850c4d0b4e6c7$export$41fb9f06171c75f4, { ...props, ref, asChild: true });
});
const DEFAULT_OUTLET_NAME = "default";
const Outlet = React.forwardRef(function Outlet2(props, ref) {
  const className = clsx("h-full ml-auto overflow-hidden flex-shrink-0", props.className);
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      ...props,
      className,
      "data-taco": "drawer-outlet",
      "data-taco-outlet-name": props.name ?? DEFAULT_OUTLET_NAME,
      ref
    }
  );
});
let drawerStack;
const Drawer = React.forwardRef(function Drawer2(props, ref) {
  const {
    open: openProp,
    defaultOpen: defaultOpenProp,
    // if onChange is not provided, then replace it with empty function, needed for useControllableState
    onChange = () => {
    },
    variant = "embedded",
    className,
    closeOnEscape = true,
    onResize,
    onClose,
    onClickBack,
    size: size2 = "md",
    trigger,
    children,
    focusTrap = props.focusTrap === void 0 && props.variant === "overlay" ? true : props.focusTrap,
    showCloseButton = true,
    outletName,
    ...otherProps
  } = props;
  const [open, setOpen] = $71cd76cc60e0454e$export$6f32135080cb4c3$1({
    prop: openProp,
    defaultProp: defaultOpenProp,
    onChange
  });
  const [outlet, setOutlet] = React.useState();
  const context = React.useMemo(
    () => ({
      closeOnEscape,
      onClickBack,
      onClose,
      onResize,
      props: otherProps,
      size: size2,
      ref,
      open,
      setOpen,
      variant,
      focusTrap,
      showCloseButton,
      outlet
    }),
    [
      closeOnEscape,
      open,
      setOpen,
      otherProps,
      variant,
      onResize,
      onClose,
      size2,
      focusTrap,
      showCloseButton,
      outlet,
      onClickBack
    ]
  );
  const close = React.useCallback(() => {
    setOpen(false);
    onClose && onClose();
  }, []);
  React.useEffect(() => {
    const outletSelector = `[data-taco="drawer-outlet"][data-taco-outlet-name="${outletName ?? DEFAULT_OUTLET_NAME}"]`;
    const outletElement = document.querySelector(outletSelector) ?? document.body;
    setOutlet(outletElement);
  }, [outletName]);
  React.useEffect(() => {
    if (open) {
      if (drawerStack) {
        drawerStack();
      }
      drawerStack = close;
    } else {
      if (drawerStack === close) {
        drawerStack = void 0;
      }
    }
  }, [open]);
  return /* @__PURE__ */ React.createElement(DrawerContext.Provider, { value: context }, /* @__PURE__ */ React.createElement($5d3850c4d0b4e6c7$export$be92b6f5f03c0fe9, { modal: variant === "overlay" ? true : false, open, onOpenChange: setOpen }, trigger && /* @__PURE__ */ React.createElement(Trigger$3, null, trigger), children));
});
Drawer.Trigger = Trigger$3;
Drawer.Content = Content$5;
Drawer.InnerContent = InnerContent;
Drawer.Title = Title$3;
Drawer.Footer = Footer$1;
Drawer.Close = Close;
Drawer.Actions = Actions$1;
Drawer.Outlet = Outlet;
const Field = React.forwardRef(function Field2(props, ref) {
  const messageRef = React.useRef(null);
  const { disabled, children, invalid = false, warning: warning2 = false, message, ...otherProps } = props;
  const className = clsx(
    "flex flex-col font-bold text-xs leading-loose pb-4 min-h-[theme(spacing.18)]",
    {
      "text-grey-300": disabled
    },
    props.className
  );
  const messageClassName = clsx("h-4 text-xs text-left leading-normal font-normal truncate -mb-4", {
    "text-grey-700": !invalid && !warning2,
    "text-red-500": invalid,
    "text-yellow-700": warning2 && !invalid,
    "opacity-50": disabled
  });
  return /* @__PURE__ */ React.createElement("label", { ...otherProps, className, "data-taco": "label", ref }, children, message && /* @__PURE__ */ React.createElement(Truncate, { tooltip: message }, /* @__PURE__ */ React.createElement(
    "span",
    {
      className: messageClassName,
      "data-taco": "label-message",
      ref: messageRef,
      role: invalid ? "alert" : void 0
    },
    message
  )));
});
const Form = React.forwardRef(function Form2(props, ref) {
  const { horizontal = false, ...otherProps } = props;
  const className = clsx(
    "yt-form",
    {
      "yt-form--horizontal flex flex-wrap": horizontal
    },
    props.className
  );
  return /* @__PURE__ */ React.createElement("form", { ...otherProps, className, "data-taco": "form", ref });
});
const HangerContext = React.createContext({
  onClose: void 0,
  props: {},
  ref: null
});
const Anchor = React.forwardRef(function HangerAnchor(props, externalRef) {
  var _a;
  const { ref: parentRef, props: parentProps } = React.useContext(HangerContext);
  const refCallback = mergeRefs([parentRef, externalRef]);
  let children = props.children;
  if (React.isValidElement(props.children) && typeof ((_a = props.children) == null ? void 0 : _a.type) === "function") {
    console.warn(
      `Hanger.Anchor requires its child to forwardRef so that it can attach to the dom element. Did you mean to wrap '${props.children.type.name}' in React.forwardRef()? Taco has wrapped '${props.children.type.name}' in a 'span' to maintain functionality, but this may cause unintended behaviour`
    );
    children = /* @__PURE__ */ React.createElement("span", null, props.children);
  }
  return /* @__PURE__ */ React.createElement($cb5cc270b50c6fcd$export$b688253958b8dfe7, { ...parentProps, ...props, ref: refCallback, asChild: true }, children);
});
const Title$2 = React.forwardRef(function DialogTitle2(props, ref) {
  const className = clsx("mb-1 text-base font-bold flex w-full", props.className);
  return /* @__PURE__ */ React.createElement("span", { ...props, className, ref });
});
const Content$4 = React.forwardRef(function HangerContent(props, ref) {
  const { placement: side, hideWhenDetached = false } = props;
  const context = React.useContext(HangerContext);
  const { texts } = useLocalization();
  const className = clsx(
    "wcag-blue-500 border border-transparent rounded p-3 pr-12 yt-shadow focus:border-transparent max-w-sm",
    props.className
  );
  const handleInteractOutside = (event) => {
    event.preventDefault();
  };
  return /* @__PURE__ */ React.createElement($cb5cc270b50c6fcd$export$602eac185826482c, null, /* @__PURE__ */ React.createElement(
    $cb5cc270b50c6fcd$export$7c6e2c02157bb7d2,
    {
      className,
      "data-taco": "hanger",
      onInteractOutside: handleInteractOutside,
      side,
      sideOffset: 1,
      ref,
      hideWhenDetached
    },
    props.children,
    /* @__PURE__ */ React.createElement(UnstyledArrow$1, { className: "text-blue-500" }),
    /* @__PURE__ */ React.createElement($cb5cc270b50c6fcd$export$f39c2d165cd861fe, { asChild: true }, /* @__PURE__ */ React.createElement(
      IconButton,
      {
        appearance: "primary",
        "aria-label": texts.hanger.close,
        className: "absolute right-0 top-0 ml-2 mr-2 mt-2 text-white",
        icon: "close",
        onClick: context.onClose
      }
    ))
  ));
});
const Hanger = React.forwardRef(function Hanger2(props, ref) {
  const { anchor, children, defaultOpen = true, onClose, ...otherProps } = props;
  const context = React.useMemo(() => ({ onClose, props: otherProps, ref }), [onClose, otherProps]);
  const [open, setOpen] = React.useState(false);
  React.useEffect(() => {
    if (defaultOpen) {
      setOpen(defaultOpen);
    }
  }, []);
  return /* @__PURE__ */ React.createElement(HangerContext.Provider, { value: context }, /* @__PURE__ */ React.createElement($cb5cc270b50c6fcd$export$be92b6f5f03c0fe9, { key: String(open), defaultOpen: open }, anchor && /* @__PURE__ */ React.createElement(Anchor, null, anchor), children));
});
Hanger.Anchor = Anchor;
Hanger.Content = Content$4;
Hanger.Title = Title$2;
let $cef8881cdc69808e$var$originalBodyUserSelect;
const $cef8881cdc69808e$var$HOVERCARD_NAME = "HoverCard";
const [$cef8881cdc69808e$var$createHoverCardContext, $cef8881cdc69808e$export$47b6998a836b7260] = $c512c27ab02ef895$export$50c7b4e9d9f19c1$1($cef8881cdc69808e$var$HOVERCARD_NAME, [
  $cf1ac5d9fe0e8206$export$722aac194ae923
]);
const $cef8881cdc69808e$var$usePopperScope = $cf1ac5d9fe0e8206$export$722aac194ae923();
const [$cef8881cdc69808e$var$HoverCardProvider, $cef8881cdc69808e$var$useHoverCardContext] = $cef8881cdc69808e$var$createHoverCardContext($cef8881cdc69808e$var$HOVERCARD_NAME);
const $cef8881cdc69808e$export$57a077cc9fbe653e = (props) => {
  const { __scopeHoverCard, children, open: openProp, defaultOpen, onOpenChange, openDelay = 700, closeDelay = 300 } = props;
  const popperScope = $cef8881cdc69808e$var$usePopperScope(__scopeHoverCard);
  const openTimerRef = useRef(0);
  const closeTimerRef = useRef(0);
  const hasSelectionRef = useRef(false);
  const isPointerDownOnContentRef = useRef(false);
  const [open = false, setOpen] = $71cd76cc60e0454e$export$6f32135080cb4c3$1({
    prop: openProp,
    defaultProp: defaultOpen,
    onChange: onOpenChange
  });
  const handleOpen = useCallback(() => {
    clearTimeout(closeTimerRef.current);
    openTimerRef.current = window.setTimeout(
      () => setOpen(true),
      openDelay
    );
  }, [
    openDelay,
    setOpen
  ]);
  const handleClose = useCallback(() => {
    clearTimeout(openTimerRef.current);
    if (!hasSelectionRef.current && !isPointerDownOnContentRef.current) closeTimerRef.current = window.setTimeout(
      () => setOpen(false),
      closeDelay
    );
  }, [
    closeDelay,
    setOpen
  ]);
  const handleDismiss = useCallback(
    () => setOpen(false),
    [
      setOpen
    ]
  );
  useEffect(() => {
    return () => {
      clearTimeout(openTimerRef.current);
      clearTimeout(closeTimerRef.current);
    };
  }, []);
  return /* @__PURE__ */ createElement($cef8881cdc69808e$var$HoverCardProvider, {
    scope: __scopeHoverCard,
    open,
    onOpenChange: setOpen,
    onOpen: handleOpen,
    onClose: handleClose,
    onDismiss: handleDismiss,
    hasSelectionRef,
    isPointerDownOnContentRef
  }, /* @__PURE__ */ createElement($cf1ac5d9fe0e8206$export$be92b6f5f03c0fe9, popperScope, children));
};
const $cef8881cdc69808e$var$TRIGGER_NAME = "HoverCardTrigger";
const $cef8881cdc69808e$export$ef9f7fd8e4ba882f = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeHoverCard, ...triggerProps } = props;
  const context = $cef8881cdc69808e$var$useHoverCardContext($cef8881cdc69808e$var$TRIGGER_NAME, __scopeHoverCard);
  const popperScope = $cef8881cdc69808e$var$usePopperScope(__scopeHoverCard);
  return /* @__PURE__ */ createElement($cf1ac5d9fe0e8206$export$b688253958b8dfe7, _extends$z({
    asChild: true
  }, popperScope), /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.a, _extends$z({
    "data-state": context.open ? "open" : "closed"
  }, triggerProps, {
    ref: forwardedRef,
    onPointerEnter: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(props.onPointerEnter, $cef8881cdc69808e$var$excludeTouch(context.onOpen)),
    onPointerLeave: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(props.onPointerLeave, $cef8881cdc69808e$var$excludeTouch(context.onClose)),
    onFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(props.onFocus, context.onOpen),
    onBlur: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(props.onBlur, context.onClose),
    onTouchStart: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(
      props.onTouchStart,
      (event) => event.preventDefault()
    )
  })));
});
const $cef8881cdc69808e$var$PORTAL_NAME = "HoverCardPortal";
const [$cef8881cdc69808e$var$PortalProvider, $cef8881cdc69808e$var$usePortalContext] = $cef8881cdc69808e$var$createHoverCardContext($cef8881cdc69808e$var$PORTAL_NAME, {
  forceMount: void 0
});
const $cef8881cdc69808e$export$b384c6e0a789f88b = (props) => {
  const { __scopeHoverCard, forceMount, children, container } = props;
  const context = $cef8881cdc69808e$var$useHoverCardContext($cef8881cdc69808e$var$PORTAL_NAME, __scopeHoverCard);
  return /* @__PURE__ */ createElement($cef8881cdc69808e$var$PortalProvider, {
    scope: __scopeHoverCard,
    forceMount
  }, /* @__PURE__ */ createElement($921a889cee6df7e8$export$99c2b779aa4e8b8b$1, {
    present: forceMount || context.open
  }, /* @__PURE__ */ createElement($f1701beae083dbae$export$602eac185826482c, {
    asChild: true,
    container
  }, children)));
};
const $cef8881cdc69808e$var$CONTENT_NAME = "HoverCardContent";
const $cef8881cdc69808e$export$aa4724a5938c586 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const portalContext = $cef8881cdc69808e$var$usePortalContext($cef8881cdc69808e$var$CONTENT_NAME, props.__scopeHoverCard);
  const { forceMount = portalContext.forceMount, ...contentProps } = props;
  const context = $cef8881cdc69808e$var$useHoverCardContext($cef8881cdc69808e$var$CONTENT_NAME, props.__scopeHoverCard);
  return /* @__PURE__ */ createElement($921a889cee6df7e8$export$99c2b779aa4e8b8b$1, {
    present: forceMount || context.open
  }, /* @__PURE__ */ createElement($cef8881cdc69808e$var$HoverCardContentImpl, _extends$z({
    "data-state": context.open ? "open" : "closed"
  }, contentProps, {
    onPointerEnter: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(props.onPointerEnter, $cef8881cdc69808e$var$excludeTouch(context.onOpen)),
    onPointerLeave: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(props.onPointerLeave, $cef8881cdc69808e$var$excludeTouch(context.onClose)),
    ref: forwardedRef
  })));
});
const $cef8881cdc69808e$var$HoverCardContentImpl = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeHoverCard, onEscapeKeyDown, onPointerDownOutside, onFocusOutside, onInteractOutside, ...contentProps } = props;
  const context = $cef8881cdc69808e$var$useHoverCardContext($cef8881cdc69808e$var$CONTENT_NAME, __scopeHoverCard);
  const popperScope = $cef8881cdc69808e$var$usePopperScope(__scopeHoverCard);
  const ref = useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05$1(forwardedRef, ref);
  const [containSelection, setContainSelection] = useState(false);
  useEffect(() => {
    if (containSelection) {
      const body = document.body;
      $cef8881cdc69808e$var$originalBodyUserSelect = body.style.userSelect || body.style.webkitUserSelect;
      body.style.userSelect = "none";
      body.style.webkitUserSelect = "none";
      return () => {
        body.style.userSelect = $cef8881cdc69808e$var$originalBodyUserSelect;
        body.style.webkitUserSelect = $cef8881cdc69808e$var$originalBodyUserSelect;
      };
    }
  }, [
    containSelection
  ]);
  useEffect(() => {
    if (ref.current) {
      const handlePointerUp = () => {
        setContainSelection(false);
        context.isPointerDownOnContentRef.current = false;
        setTimeout(() => {
          var _document$getSelectio;
          const hasSelection = ((_document$getSelectio = document.getSelection()) === null || _document$getSelectio === void 0 ? void 0 : _document$getSelectio.toString()) !== "";
          if (hasSelection) context.hasSelectionRef.current = true;
        });
      };
      document.addEventListener("pointerup", handlePointerUp);
      return () => {
        document.removeEventListener("pointerup", handlePointerUp);
        context.hasSelectionRef.current = false;
        context.isPointerDownOnContentRef.current = false;
      };
    }
  }, [
    context.isPointerDownOnContentRef,
    context.hasSelectionRef
  ]);
  useEffect(() => {
    if (ref.current) {
      const tabbables = $cef8881cdc69808e$var$getTabbableNodes(ref.current);
      tabbables.forEach(
        (tabbable) => tabbable.setAttribute("tabindex", "-1")
      );
    }
  });
  return /* @__PURE__ */ createElement($5cb92bef7577960e$export$177fb62ff3ec1f22, {
    asChild: true,
    disableOutsidePointerEvents: false,
    onInteractOutside,
    onEscapeKeyDown,
    onPointerDownOutside,
    onFocusOutside: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(onFocusOutside, (event) => {
      event.preventDefault();
    }),
    onDismiss: context.onDismiss
  }, /* @__PURE__ */ createElement($cf1ac5d9fe0e8206$export$7c6e2c02157bb7d2, _extends$z({}, popperScope, contentProps, {
    onPointerDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(contentProps.onPointerDown, (event) => {
      if (event.currentTarget.contains(event.target)) setContainSelection(true);
      context.hasSelectionRef.current = false;
      context.isPointerDownOnContentRef.current = true;
    }),
    ref: composedRefs,
    style: {
      ...contentProps.style,
      // re-namespace exposed content custom property
      ["--radix-hover-card-content-transform-origin"]: "var(--radix-popper-transform-origin)",
      userSelect: containSelection ? "text" : void 0,
      // Safari requires prefix
      WebkitUserSelect: containSelection ? "text" : void 0
    }
  })));
});
const $cef8881cdc69808e$export$b9744d3e7456d806 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeHoverCard, ...arrowProps } = props;
  const popperScope = $cef8881cdc69808e$var$usePopperScope(__scopeHoverCard);
  return /* @__PURE__ */ createElement($cf1ac5d9fe0e8206$export$21b07c8f274aebd5, _extends$z({}, popperScope, arrowProps, {
    ref: forwardedRef
  }));
});
function $cef8881cdc69808e$var$excludeTouch(eventHandler) {
  return (event) => event.pointerType === "touch" ? void 0 : eventHandler();
}
function $cef8881cdc69808e$var$getTabbableNodes(container) {
  const nodes = [];
  const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (node) => {
      return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  while (walker.nextNode()) nodes.push(walker.currentNode);
  return nodes;
}
const $cef8881cdc69808e$export$be92b6f5f03c0fe9 = $cef8881cdc69808e$export$57a077cc9fbe653e;
const $cef8881cdc69808e$export$41fb9f06171c75f4 = $cef8881cdc69808e$export$ef9f7fd8e4ba882f;
const $cef8881cdc69808e$export$602eac185826482c = $cef8881cdc69808e$export$b384c6e0a789f88b;
const $cef8881cdc69808e$export$7c6e2c02157bb7d2 = $cef8881cdc69808e$export$aa4724a5938c586;
const $cef8881cdc69808e$export$21b07c8f274aebd5 = $cef8881cdc69808e$export$b9744d3e7456d806;
const UnstyledArrow = React.forwardRef(function HoverCardArrow(props, ref) {
  return /* @__PURE__ */ React.createElement($cef8881cdc69808e$export$21b07c8f274aebd5, { className: "pointer-events-none -mt-px", asChild: true, offset: 2, width: 30, height: 11 }, /* @__PURE__ */ React.createElement("svg", { ...props, ref, viewBox: "0 19 30 11", style: { transform: "rotateZ(180deg)" } }, /* @__PURE__ */ React.createElement(
    "path",
    {
      className: "text-grey-300 fill-current group-focus:text-blue-300",
      d: "M23.7,27.1L17,19.9C16.5,19.3,15.8,19,15,19s-1.6,0.3-2.1,0.9l-6.6,7.2C5.3,28.1,3.4,29,2,29h26 C26.7,29,24.6,28.1,23.7,27.1z"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      className: "fill-current",
      d: "M23,27.8c1.1,1.2,3.4,2.2,5,2.2h2H0h2c1.7,0,3.9-1,5-2.2l6.6-7.2c0.7-0.8,2-0.8,2.7,0L23,27.8L23,27.8z"
    }
  )));
});
const Trigger$2 = React.forwardRef(function HoverCardTrigger(props, ref) {
  return /* @__PURE__ */ React.createElement($cef8881cdc69808e$export$41fb9f06171c75f4, { ...props, asChild: true, ref });
});
const Content$3 = React.forwardRef(function HoverCardContent(props, ref) {
  const { placement: side } = props;
  const className = clsx(getPopoverStyleClassnames(), "min-w-[theme(spacing.40)] max-w-[theme(spacing.96)]", props.className);
  return /* @__PURE__ */ React.createElement($cef8881cdc69808e$export$602eac185826482c, null, /* @__PURE__ */ React.createElement($cef8881cdc69808e$export$7c6e2c02157bb7d2, { className, "data-taco": "hover-card", side, sideOffset: 1, ref }, props.children, /* @__PURE__ */ React.createElement(UnstyledArrow, { className: "text-white" })));
});
const HoverCard = (props) => {
  return /* @__PURE__ */ React.createElement($cef8881cdc69808e$export$be92b6f5f03c0fe9, { ...props, openDelay: 300 });
};
HoverCard.Trigger = Trigger$2;
HoverCard.Content = Content$3;
const Group$5 = React__default.forwardRef(function Group22(props, ref) {
  return /* @__PURE__ */ React__default.createElement("div", { ...props, "data-taco": "list-group", ref });
});
const Item$3 = React__default.forwardRef(function Item2(props, ref) {
  const { as: Tag2 = "div", control, description, disabled, icon, color: color2, tabIndex = 0, title, ...attributes } = props;
  const iconClassName = clsx(
    "flex shrink-0 h-10 w-10 items-center justify-center rounded-md border border-black/10",
    getSubtleColorShadeClasses(color2 ?? "transparent")
  );
  return /* @__PURE__ */ React__default.createElement(
    Tag2,
    {
      ...attributes,
      "aria-disabled": disabled ? true : void 0,
      "data-taco": "list-item",
      ref,
      tabIndex: disabled ? -1 : tabIndex
    },
    icon ? /* @__PURE__ */ React__default.createElement("span", { className: iconClassName }, /* @__PURE__ */ React__default.createElement(Icon$1, { name: icon })) : null,
    /* @__PURE__ */ React__default.createElement("div", { className: "flex grow flex-col justify-center" }, /* @__PURE__ */ React__default.createElement("span", { className: "font-bold text-black" }, title), description ? /* @__PURE__ */ React__default.createElement("span", { className: "text-grey-700" }, description) : null),
    /* @__PURE__ */ React__default.createElement("div", { className: "text-grey-700 flex shrink-0 items-center" }, control)
  );
});
const Link$3 = React__default.forwardRef(function Link2(props, ref) {
  const isExternal = props.href.startsWith("http");
  const control = /* @__PURE__ */ React__default.createElement(Icon$1, { name: isExternal ? "link-external" : "chevron-right" });
  if (isExternal) {
    return /* @__PURE__ */ React__default.createElement(Item$3, { ...props, as: "a", target: "_blank", rel: "noopener noreferrer", control, ref });
  }
  return /* @__PURE__ */ React__default.createElement(Item$3, { ...props, as: "a", control, ref });
});
function $e42e1063c40fb3ef$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented = true } = {}) {
  return function handleEvent(event) {
    originalEventHandler === null || originalEventHandler === void 0 || originalEventHandler(event);
    if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
  };
}
function $c512c27ab02ef895$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
  let defaultContexts = [];
  function $c512c27ab02ef895$export$fd42f52fd3ae11092(rootComponentName, defaultContext) {
    const BaseContext = /* @__PURE__ */ createContext(defaultContext);
    const index2 = defaultContexts.length;
    defaultContexts = [
      ...defaultContexts,
      defaultContext
    ];
    function Provider2(props) {
      const { scope, children, ...context } = props;
      const Context2 = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index2]) || BaseContext;
      const value = useMemo(
        () => context,
        Object.values(context)
      );
      return /* @__PURE__ */ createElement(Context2.Provider, {
        value
      }, children);
    }
    function useContext$1(consumerName, scope) {
      const Context2 = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index2]) || BaseContext;
      const context = useContext(Context2);
      if (context) return context;
      if (defaultContext !== void 0) return defaultContext;
      throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider2.displayName = rootComponentName + "Provider";
    return [
      Provider2,
      useContext$1
    ];
  }
  const createScope = () => {
    const scopeContexts = defaultContexts.map((defaultContext) => {
      return /* @__PURE__ */ createContext(defaultContext);
    });
    return function useScope(scope) {
      const contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
      return useMemo(
        () => ({
          [`__scope${scopeName}`]: {
            ...scope,
            [scopeName]: contexts
          }
        }),
        [
          scope,
          contexts
        ]
      );
    };
  };
  createScope.scopeName = scopeName;
  return [
    $c512c27ab02ef895$export$fd42f52fd3ae11092,
    $c512c27ab02ef895$var$composeContextScopes(createScope, ...createContextScopeDeps)
  ];
}
function $c512c27ab02ef895$var$composeContextScopes(...scopes) {
  const baseScope = scopes[0];
  if (scopes.length === 1) return baseScope;
  const createScope1 = () => {
    const scopeHooks = scopes.map(
      (createScope) => ({
        useScope: createScope(),
        scopeName: createScope.scopeName
      })
    );
    return function useComposedScopes(overrideScopes) {
      const nextScopes1 = scopeHooks.reduce((nextScopes, { useScope, scopeName }) => {
        const scopeProps = useScope(overrideScopes);
        const currentScope = scopeProps[`__scope${scopeName}`];
        return {
          ...nextScopes,
          ...currentScope
        };
      }, {});
      return useMemo(
        () => ({
          [`__scope${baseScope.scopeName}`]: nextScopes1
        }),
        [
          nextScopes1
        ]
      );
    };
  };
  createScope1.scopeName = baseScope.scopeName;
  return createScope1;
}
function $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(callback) {
  const callbackRef = useRef(callback);
  useEffect(() => {
    callbackRef.current = callback;
  });
  return useMemo(
    () => (...args) => {
      var _callbackRef$current;
      return (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 ? void 0 : _callbackRef$current.call(callbackRef, ...args);
    },
    []
  );
}
function $71cd76cc60e0454e$export$6f32135080cb4c3({ prop, defaultProp, onChange = () => {
} }) {
  const [uncontrolledProp, setUncontrolledProp] = $71cd76cc60e0454e$var$useUncontrolledState({
    defaultProp,
    onChange
  });
  const isControlled = prop !== void 0;
  const value1 = isControlled ? prop : uncontrolledProp;
  const handleChange = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onChange);
  const setValue = useCallback((nextValue) => {
    if (isControlled) {
      const setter = nextValue;
      const value = typeof nextValue === "function" ? setter(prop) : nextValue;
      if (value !== prop) handleChange(value);
    } else setUncontrolledProp(nextValue);
  }, [
    isControlled,
    prop,
    setUncontrolledProp,
    handleChange
  ]);
  return [
    value1,
    setValue
  ];
}
function $71cd76cc60e0454e$var$useUncontrolledState({ defaultProp, onChange }) {
  const uncontrolledState = useState(defaultProp);
  const [value] = uncontrolledState;
  const prevValueRef = useRef(value);
  const handleChange = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onChange);
  useEffect(() => {
    if (prevValueRef.current !== value) {
      handleChange(value);
      prevValueRef.current = value;
    }
  }, [
    value,
    prevValueRef,
    handleChange
  ]);
  return uncontrolledState;
}
const $9f79659886946c16$export$e5c5a5f917a5871c = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) ? useLayoutEffect : () => {
};
function $6ed0406888f73fc4$var$setRef(ref, value) {
  if (typeof ref === "function") ref(value);
  else if (ref !== null && ref !== void 0) ref.current = value;
}
function $6ed0406888f73fc4$export$43e446d32b3d21af(...refs) {
  return (node) => refs.forEach(
    (ref) => $6ed0406888f73fc4$var$setRef(ref, node)
  );
}
function $6ed0406888f73fc4$export$c7b2cbe3552a0d05(...refs) {
  return useCallback($6ed0406888f73fc4$export$43e446d32b3d21af(...refs), refs);
}
const $5e63c961fc1ce211$export$8c6ed5c666ac1360 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { children, ...slotProps } = props;
  const childrenArray = Children.toArray(children);
  const slottable = childrenArray.find($5e63c961fc1ce211$var$isSlottable);
  if (slottable) {
    const newElement = slottable.props.children;
    const newChildren = childrenArray.map((child) => {
      if (child === slottable) {
        if (Children.count(newElement) > 1) return Children.only(null);
        return /* @__PURE__ */ isValidElement(newElement) ? newElement.props.children : null;
      } else return child;
    });
    return /* @__PURE__ */ createElement($5e63c961fc1ce211$var$SlotClone, _extends$z({}, slotProps, {
      ref: forwardedRef
    }), /* @__PURE__ */ isValidElement(newElement) ? /* @__PURE__ */ cloneElement(newElement, void 0, newChildren) : null);
  }
  return /* @__PURE__ */ createElement($5e63c961fc1ce211$var$SlotClone, _extends$z({}, slotProps, {
    ref: forwardedRef
  }), children);
});
$5e63c961fc1ce211$export$8c6ed5c666ac1360.displayName = "Slot";
const $5e63c961fc1ce211$var$SlotClone = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { children, ...slotProps } = props;
  if (/* @__PURE__ */ isValidElement(children)) return /* @__PURE__ */ cloneElement(children, {
    ...$5e63c961fc1ce211$var$mergeProps(slotProps, children.props),
    ref: forwardedRef ? $6ed0406888f73fc4$export$43e446d32b3d21af(forwardedRef, children.ref) : children.ref
  });
  return Children.count(children) > 1 ? Children.only(null) : null;
});
$5e63c961fc1ce211$var$SlotClone.displayName = "SlotClone";
const $5e63c961fc1ce211$export$d9f1ccf0bdb05d45 = ({ children }) => {
  return /* @__PURE__ */ createElement(Fragment, null, children);
};
function $5e63c961fc1ce211$var$isSlottable(child) {
  return /* @__PURE__ */ isValidElement(child) && child.type === $5e63c961fc1ce211$export$d9f1ccf0bdb05d45;
}
function $5e63c961fc1ce211$var$mergeProps(slotProps, childProps) {
  const overrideProps = {
    ...childProps
  };
  for (const propName in childProps) {
    const slotPropValue = slotProps[propName];
    const childPropValue = childProps[propName];
    const isHandler = /^on[A-Z]/.test(propName);
    if (isHandler) {
      if (slotPropValue && childPropValue) overrideProps[propName] = (...args) => {
        childPropValue(...args);
        slotPropValue(...args);
      };
      else if (slotPropValue) overrideProps[propName] = slotPropValue;
    } else if (propName === "style") overrideProps[propName] = {
      ...slotPropValue,
      ...childPropValue
    };
    else if (propName === "className") overrideProps[propName] = [
      slotPropValue,
      childPropValue
    ].filter(Boolean).join(" ");
  }
  return {
    ...slotProps,
    ...overrideProps
  };
}
const $8927f6f2acc4f386$var$NODES = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
];
const $8927f6f2acc4f386$export$250ffa63cdc0d034 = $8927f6f2acc4f386$var$NODES.reduce((primitive, node) => {
  const Node2 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
    const { asChild, ...primitiveProps } = props;
    const Comp = asChild ? $5e63c961fc1ce211$export$8c6ed5c666ac1360 : node;
    useEffect(() => {
      window[Symbol.for("radix-ui")] = true;
    }, []);
    return /* @__PURE__ */ createElement(Comp, _extends$z({}, primitiveProps, {
      ref: forwardedRef
    }));
  });
  Node2.displayName = `Primitive.${node}`;
  return {
    ...primitive,
    [node]: Node2
  };
}, {});
function $fe963b355347cc68$export$3e6543de14f8614f(initialState, machine) {
  return useReducer((state, event) => {
    const nextState = machine[state][event];
    return nextState !== null && nextState !== void 0 ? nextState : state;
  }, initialState);
}
const $921a889cee6df7e8$export$99c2b779aa4e8b8b = (props) => {
  const { present, children } = props;
  const presence = $921a889cee6df7e8$var$usePresence(present);
  const child = typeof children === "function" ? children({
    present: presence.isPresent
  }) : Children.only(children);
  const ref = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(presence.ref, child.ref);
  const forceMount = typeof children === "function";
  return forceMount || presence.isPresent ? /* @__PURE__ */ cloneElement(child, {
    ref
  }) : null;
};
$921a889cee6df7e8$export$99c2b779aa4e8b8b.displayName = "Presence";
function $921a889cee6df7e8$var$usePresence(present) {
  const [node1, setNode] = useState();
  const stylesRef = useRef({});
  const prevPresentRef = useRef(present);
  const prevAnimationNameRef = useRef("none");
  const initialState = present ? "mounted" : "unmounted";
  const [state, send] = $fe963b355347cc68$export$3e6543de14f8614f(initialState, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  useEffect(() => {
    const currentAnimationName = $921a889cee6df7e8$var$getAnimationName(stylesRef.current);
    prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
  }, [
    state
  ]);
  $9f79659886946c16$export$e5c5a5f917a5871c(() => {
    const styles = stylesRef.current;
    const wasPresent = prevPresentRef.current;
    const hasPresentChanged = wasPresent !== present;
    if (hasPresentChanged) {
      const prevAnimationName = prevAnimationNameRef.current;
      const currentAnimationName = $921a889cee6df7e8$var$getAnimationName(styles);
      if (present) send("MOUNT");
      else if (currentAnimationName === "none" || (styles === null || styles === void 0 ? void 0 : styles.display) === "none")
        send("UNMOUNT");
      else {
        const isAnimating = prevAnimationName !== currentAnimationName;
        if (wasPresent && isAnimating) send("ANIMATION_OUT");
        else send("UNMOUNT");
      }
      prevPresentRef.current = present;
    }
  }, [
    present,
    send
  ]);
  $9f79659886946c16$export$e5c5a5f917a5871c(() => {
    if (node1) {
      const handleAnimationEnd = (event) => {
        const currentAnimationName = $921a889cee6df7e8$var$getAnimationName(stylesRef.current);
        const isCurrentAnimation = currentAnimationName.includes(event.animationName);
        if (event.target === node1 && isCurrentAnimation)
          flushSync$1(
            () => send("ANIMATION_END")
          );
      };
      const handleAnimationStart = (event) => {
        if (event.target === node1)
          prevAnimationNameRef.current = $921a889cee6df7e8$var$getAnimationName(stylesRef.current);
      };
      node1.addEventListener("animationstart", handleAnimationStart);
      node1.addEventListener("animationcancel", handleAnimationEnd);
      node1.addEventListener("animationend", handleAnimationEnd);
      return () => {
        node1.removeEventListener("animationstart", handleAnimationStart);
        node1.removeEventListener("animationcancel", handleAnimationEnd);
        node1.removeEventListener("animationend", handleAnimationEnd);
      };
    } else
      send("ANIMATION_END");
  }, [
    node1,
    send
  ]);
  return {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(state),
    ref: useCallback((node) => {
      if (node) stylesRef.current = getComputedStyle(node);
      setNode(node);
    }, [])
  };
}
function $921a889cee6df7e8$var$getAnimationName(styles) {
  return (styles === null || styles === void 0 ? void 0 : styles.animationName) || "none";
}
const $1746a345f3d73bb7$var$useReactId = React["useId".toString()] || (() => void 0);
let $1746a345f3d73bb7$var$count = 0;
function $1746a345f3d73bb7$export$f680877a34711e37(deterministicId) {
  const [id2, setId] = React.useState($1746a345f3d73bb7$var$useReactId());
  $9f79659886946c16$export$e5c5a5f917a5871c(() => {
    setId(
      (reactId) => reactId !== null && reactId !== void 0 ? reactId : String($1746a345f3d73bb7$var$count++)
    );
  }, [
    deterministicId
  ]);
  return deterministicId || (id2 ? `radix-${id2}` : "");
}
const $409067139f391064$var$COLLAPSIBLE_NAME = "Collapsible";
const [$409067139f391064$var$createCollapsibleContext, $409067139f391064$export$952b32dcbe73087a] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($409067139f391064$var$COLLAPSIBLE_NAME);
const [$409067139f391064$var$CollapsibleProvider, $409067139f391064$var$useCollapsibleContext] = $409067139f391064$var$createCollapsibleContext($409067139f391064$var$COLLAPSIBLE_NAME);
const $409067139f391064$export$6eb0f7ddcda6131f = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeCollapsible, open: openProp, defaultOpen, disabled, onOpenChange, ...collapsibleProps } = props;
  const [open = false, setOpen] = $71cd76cc60e0454e$export$6f32135080cb4c3({
    prop: openProp,
    defaultProp: defaultOpen,
    onChange: onOpenChange
  });
  return /* @__PURE__ */ createElement($409067139f391064$var$CollapsibleProvider, {
    scope: __scopeCollapsible,
    disabled,
    contentId: $1746a345f3d73bb7$export$f680877a34711e37(),
    open,
    onOpenToggle: useCallback(
      () => setOpen(
        (prevOpen) => !prevOpen
      ),
      [
        setOpen
      ]
    )
  }, /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends$z({
    "data-state": $409067139f391064$var$getState(open),
    "data-disabled": disabled ? "" : void 0
  }, collapsibleProps, {
    ref: forwardedRef
  })));
});
const $409067139f391064$var$TRIGGER_NAME = "CollapsibleTrigger";
const $409067139f391064$export$c135dce7b15bbbdc = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeCollapsible, ...triggerProps } = props;
  const context = $409067139f391064$var$useCollapsibleContext($409067139f391064$var$TRIGGER_NAME, __scopeCollapsible);
  return /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.button, _extends$z({
    type: "button",
    "aria-controls": context.contentId,
    "aria-expanded": context.open || false,
    "data-state": $409067139f391064$var$getState(context.open),
    "data-disabled": context.disabled ? "" : void 0,
    disabled: context.disabled
  }, triggerProps, {
    ref: forwardedRef,
    onClick: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onClick, context.onOpenToggle)
  }));
});
const $409067139f391064$var$CONTENT_NAME = "CollapsibleContent";
const $409067139f391064$export$aadde00976f34151 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { forceMount, ...contentProps } = props;
  const context = $409067139f391064$var$useCollapsibleContext($409067139f391064$var$CONTENT_NAME, props.__scopeCollapsible);
  return /* @__PURE__ */ createElement(
    $921a889cee6df7e8$export$99c2b779aa4e8b8b,
    {
      present: forceMount || context.open
    },
    ({ present }) => /* @__PURE__ */ createElement($409067139f391064$var$CollapsibleContentImpl, _extends$z({}, contentProps, {
      ref: forwardedRef,
      present
    }))
  );
});
const $409067139f391064$var$CollapsibleContentImpl = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeCollapsible, present, children, ...contentProps } = props;
  const context = $409067139f391064$var$useCollapsibleContext($409067139f391064$var$CONTENT_NAME, __scopeCollapsible);
  const [isPresent, setIsPresent] = useState(present);
  const ref = useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref);
  const heightRef = useRef(0);
  const height = heightRef.current;
  const widthRef = useRef(0);
  const width = widthRef.current;
  const isOpen = context.open || isPresent;
  const isMountAnimationPreventedRef = useRef(isOpen);
  const originalStylesRef = useRef();
  useEffect(() => {
    const rAF = requestAnimationFrame(
      () => isMountAnimationPreventedRef.current = false
    );
    return () => cancelAnimationFrame(rAF);
  }, []);
  $9f79659886946c16$export$e5c5a5f917a5871c(() => {
    const node = ref.current;
    if (node) {
      originalStylesRef.current = originalStylesRef.current || {
        transitionDuration: node.style.transitionDuration,
        animationName: node.style.animationName
      };
      node.style.transitionDuration = "0s";
      node.style.animationName = "none";
      const rect = node.getBoundingClientRect();
      heightRef.current = rect.height;
      widthRef.current = rect.width;
      if (!isMountAnimationPreventedRef.current) {
        node.style.transitionDuration = originalStylesRef.current.transitionDuration;
        node.style.animationName = originalStylesRef.current.animationName;
      }
      setIsPresent(present);
    }
  }, [
    context.open,
    present
  ]);
  return /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends$z({
    "data-state": $409067139f391064$var$getState(context.open),
    "data-disabled": context.disabled ? "" : void 0,
    id: context.contentId,
    hidden: !isOpen
  }, contentProps, {
    ref: composedRefs,
    style: {
      [`--radix-collapsible-content-height`]: height ? `${height}px` : void 0,
      [`--radix-collapsible-content-width`]: width ? `${width}px` : void 0,
      ...props.style
    }
  }), isOpen && children);
});
function $409067139f391064$var$getState(open) {
  return open ? "open" : "closed";
}
const $409067139f391064$export$be92b6f5f03c0fe9 = $409067139f391064$export$6eb0f7ddcda6131f;
const $409067139f391064$export$41fb9f06171c75f4 = $409067139f391064$export$c135dce7b15bbbdc;
const $409067139f391064$export$7c6e2c02157bb7d2 = $409067139f391064$export$aadde00976f34151;
const Collapsible = React__default.forwardRef(function Accordion2(props, ref) {
  const { defaultOpen = false, ...attributes } = props;
  const [open, setOpen] = React__default.useState(defaultOpen);
  const control = /* @__PURE__ */ React__default.createElement(Icon$1, { name: open ? "chevron-up" : "chevron-down" });
  return /* @__PURE__ */ React__default.createElement($409067139f391064$export$be92b6f5f03c0fe9, { "data-taco": "list-item-collapsible", disabled: props.disabled, open, onOpenChange: setOpen }, /* @__PURE__ */ React__default.createElement($409067139f391064$export$41fb9f06171c75f4, { asChild: true }, /* @__PURE__ */ React__default.createElement(Item$3, { ...attributes, as: "button", control, ref })), /* @__PURE__ */ React__default.createElement($409067139f391064$export$7c6e2c02157bb7d2, null, props.children));
});
const $6be4966fd9bbc698$var$SWITCH_NAME = "Switch";
const [$6be4966fd9bbc698$var$createSwitchContext, $6be4966fd9bbc698$export$cf7f5f17f69cbd43] = $c512c27ab02ef895$export$50c7b4e9d9f19c1$1($6be4966fd9bbc698$var$SWITCH_NAME);
const [$6be4966fd9bbc698$var$SwitchProvider, $6be4966fd9bbc698$var$useSwitchContext] = $6be4966fd9bbc698$var$createSwitchContext($6be4966fd9bbc698$var$SWITCH_NAME);
const $6be4966fd9bbc698$export$b5d5cf8927ab7262 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeSwitch, name, checked: checkedProp, defaultChecked, required, disabled, value = "on", onCheckedChange, ...switchProps } = props;
  const [button, setButton] = useState(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05$1(
    forwardedRef,
    (node) => setButton(node)
  );
  const hasConsumerStoppedPropagationRef = useRef(false);
  const isFormControl = button ? Boolean(button.closest("form")) : true;
  const [checked = false, setChecked] = $71cd76cc60e0454e$export$6f32135080cb4c3$1({
    prop: checkedProp,
    defaultProp: defaultChecked,
    onChange: onCheckedChange
  });
  return /* @__PURE__ */ createElement($6be4966fd9bbc698$var$SwitchProvider, {
    scope: __scopeSwitch,
    checked,
    disabled
  }, /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.button, _extends$z({
    type: "button",
    role: "switch",
    "aria-checked": checked,
    "aria-required": required,
    "data-state": $6be4966fd9bbc698$var$getState(checked),
    "data-disabled": disabled ? "" : void 0,
    disabled,
    value
  }, switchProps, {
    ref: composedRefs,
    onClick: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(props.onClick, (event) => {
      setChecked(
        (prevChecked) => !prevChecked
      );
      if (isFormControl) {
        hasConsumerStoppedPropagationRef.current = event.isPropagationStopped();
        if (!hasConsumerStoppedPropagationRef.current) event.stopPropagation();
      }
    })
  })), isFormControl && /* @__PURE__ */ createElement($6be4966fd9bbc698$var$BubbleInput, {
    control: button,
    bubbles: !hasConsumerStoppedPropagationRef.current,
    name,
    value,
    checked,
    required,
    disabled,
    style: {
      transform: "translateX(-100%)"
    }
  }));
});
const $6be4966fd9bbc698$var$THUMB_NAME = "SwitchThumb";
const $6be4966fd9bbc698$export$4d07bf653ea69106 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeSwitch, ...thumbProps } = props;
  const context = $6be4966fd9bbc698$var$useSwitchContext($6be4966fd9bbc698$var$THUMB_NAME, __scopeSwitch);
  return /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.span, _extends$z({
    "data-state": $6be4966fd9bbc698$var$getState(context.checked),
    "data-disabled": context.disabled ? "" : void 0
  }, thumbProps, {
    ref: forwardedRef
  }));
});
const $6be4966fd9bbc698$var$BubbleInput = (props) => {
  const { control, checked, bubbles = true, ...inputProps } = props;
  const ref = useRef(null);
  const prevChecked = $010c2913dbd2fe3d$export$5cae361ad82dce8b(checked);
  const controlSize = $db6c3485150b8e66$export$1ab7ae714698c4b8(control);
  useEffect(() => {
    const input = ref.current;
    const inputProto = window.HTMLInputElement.prototype;
    const descriptor = Object.getOwnPropertyDescriptor(inputProto, "checked");
    const setChecked = descriptor.set;
    if (prevChecked !== checked && setChecked) {
      const event = new Event("click", {
        bubbles
      });
      setChecked.call(input, checked);
      input.dispatchEvent(event);
    }
  }, [
    prevChecked,
    checked,
    bubbles
  ]);
  return /* @__PURE__ */ createElement("input", _extends$z({
    type: "checkbox",
    "aria-hidden": true,
    defaultChecked: checked
  }, inputProps, {
    tabIndex: -1,
    ref,
    style: {
      ...props.style,
      ...controlSize,
      position: "absolute",
      pointerEvents: "none",
      opacity: 0,
      margin: 0
    }
  }));
};
function $6be4966fd9bbc698$var$getState(checked) {
  return checked ? "checked" : "unchecked";
}
const $6be4966fd9bbc698$export$be92b6f5f03c0fe9 = $6be4966fd9bbc698$export$b5d5cf8927ab7262;
const $6be4966fd9bbc698$export$6521433ed15a34db = $6be4966fd9bbc698$export$4d07bf653ea69106;
const Switch$1 = React.forwardRef(function Switch2(props, ref) {
  const { label, onChange, ...otherProps } = props;
  const id2 = useId$1(props.id);
  const className = clsx(
    "group h-5 w-9 flex flex-shrink-0 rounded-full inline-flex focus-visible:yt-focus",
    {
      "mr-2": !!label,
      "bg-grey-500 hover:bg-grey-700 aria-checked:bg-blue-500 aria-checked:hover:bg-blue-700": !props.disabled,
      "bg-grey-500/50 aria-checked:bg-blue-500/50 cursor-not-allowed": props.disabled
    },
    props.className
  );
  let labelledByProps = null;
  if (label) {
    labelledByProps = {
      "aria-labelledby": `${id2}-label`,
      id: id2
    };
  }
  const element = /* @__PURE__ */ React.createElement(
    $6be4966fd9bbc698$export$be92b6f5f03c0fe9,
    {
      ...otherProps,
      ...labelledByProps,
      className,
      "data-taco": "switch",
      onCheckedChange: onChange,
      ref
    },
    /* @__PURE__ */ React.createElement($6be4966fd9bbc698$export$6521433ed15a34db, { className: "pointer-events-none mt-0.5 h-4 w-4 translate-x-[0.15rem] rounded-full bg-white transition-transform will-change-transform group-disabled:opacity-50 group-aria-checked:translate-x-[1.1rem]" })
  );
  if (label) {
    const labelContainerClassName = clsx("flex self-start cursor-pointer", {
      "cursor-not-allowed text-grey-300": props.disabled
    });
    return /* @__PURE__ */ React.createElement("span", { className: labelContainerClassName, "data-taco": "switch-container" }, element, /* @__PURE__ */ React.createElement("label", { htmlFor: id2, id: `${id2}-label` }, label));
  }
  return element;
});
Switch$1.displayName = "Switch";
const ToggleItem = React__default.forwardRef(function Toggle(props, ref) {
  const { controlRef, onToggle, ...attributes } = props;
  function handleClick(event) {
    var _a;
    if (typeof props.onClick === "function") {
      props.onClick(event);
    }
    if (event.isDefaultPrevented()) {
      return;
    }
    if (event.target !== controlRef.current && !((_a = controlRef.current) == null ? void 0 : _a.contains(event.target))) {
      onToggle();
      return;
    }
  }
  function handleKeyDown(event) {
    var _a;
    if (typeof props.onKeyDown === "function") {
      props.onKeyDown(event);
    }
    if (event.isDefaultPrevented()) {
      return;
    }
    if ((event.key === "Enter" || event.key === " ") && event.target !== controlRef.current && !((_a = controlRef.current) == null ? void 0 : _a.contains(event.target))) {
      onToggle();
      return;
    }
  }
  const className = clsx("group/toggle", props.className);
  return /* @__PURE__ */ React__default.createElement(Item$3, { ...attributes, className, onClick: handleClick, onKeyDown: handleKeyDown, ref });
});
const Switch = React__default.forwardRef(function Switch22(props, ref) {
  const { checked: externalChecked, onChange, ...attributes } = props;
  const [checked, setChecked] = React__default.useState(externalChecked);
  const switchRef = React__default.useRef(null);
  const toggle = React__default.useCallback(() => {
    setChecked(!checked);
    onChange(!checked);
  }, [checked, onChange]);
  const control = /* @__PURE__ */ React__default.createElement(
    Switch$1,
    {
      checked,
      className: "group-hover/toggle:[&[aria-checked=false]]:bg-grey-700 group-hover/toggle:[&[aria-checked=true]]:bg-blue-700",
      disabled: props.disabled,
      onChange: toggle,
      ref: switchRef,
      tabIndex: -1
    }
  );
  return /* @__PURE__ */ React__default.createElement(ToggleItem, { ...attributes, control, controlRef: switchRef, ref, onToggle: toggle });
});
const Checkbox$1 = React__default.forwardRef(function Switch3(props, ref) {
  const { checked: externalChecked, onChange, ...attributes } = props;
  const [checked, setChecked] = React__default.useState(externalChecked);
  const checkboxRef = React__default.useRef(null);
  const toggle = React__default.useCallback(() => {
    setChecked(!checked);
    onChange(!checked);
  }, [checked, onChange]);
  const control = /* @__PURE__ */ React__default.createElement(
    Checkbox$2,
    {
      checked,
      className: "group-hover/toggle:[&[aria-checked=false]]:border-grey-700 group-hover/toggle:[&[aria-checked=true]]:border-blue-700 group-hover/checkbox:[&[aria-checked=true]]:bg-blue-700",
      disabled: props.disabled,
      onChange: toggle,
      ref: checkboxRef,
      tabIndex: -1
    }
  );
  return /* @__PURE__ */ React__default.createElement(ToggleItem, { ...attributes, control, controlRef: checkboxRef, ref, onToggle: toggle });
});
const Button$2 = React__default.forwardRef(function Link(props, ref) {
  return /* @__PURE__ */ React__default.createElement(Item$3, { ...props, as: "button", ref });
});
function List$1(props) {
  return /* @__PURE__ */ React__default.createElement("div", { ...props, "data-taco": "list" });
}
List$1.Button = Button$2;
List$1.Link = Link$3;
List$1.Collapsible = Collapsible;
List$1.Switch = Switch;
List$1.Checkbox = Checkbox$1;
List$1.Group = Group$5;
function useTimer(duration = 0, callback) {
  const timer = React.useRef();
  const [tracker, setTracker] = React.useState({
    remaining: duration,
    started: null
  });
  React.useEffect(() => {
    if (duration) {
      if (tracker.started) {
        timer.current = window.setTimeout(callback, tracker.remaining);
      } else {
        clearTimeout(timer.current);
      }
    }
    return () => {
      clearTimeout(timer.current);
    };
  }, [tracker.started]);
  return {
    running: !!tracker.started,
    start: () => {
      setTracker({
        remaining: duration,
        started: Date.now()
      });
    },
    pause: () => {
      if (tracker.started) {
        setTracker({
          remaining: tracker.remaining - (Date.now() - tracker.started),
          started: null
        });
      }
    },
    resume: () => {
      if (tracker.remaining && !tracker.started) {
        setTracker({
          remaining: tracker.remaining,
          started: Date.now()
        });
      }
    }
  };
}
const useTypeahead = ({ data, currentIndex }) => {
  const typeaheadQuery = React.useRef();
  const typeaheadQueryTimer = useTimer(1e3, () => {
    typeaheadQuery.current = void 0;
  });
  const getNextIndex2 = (charKey) => {
    const query = (typeaheadQuery.current ? typeaheadQuery.current + charKey : charKey).toLowerCase();
    const nextIndex = findNextIndexByValue(data, query, currentIndex);
    typeaheadQueryTimer.start();
    typeaheadQuery.current = query;
    return nextIndex;
  };
  return { getNextIndex: getNextIndex2 };
};
const useListbox = ({
  data: externalData = [],
  defaultValue: defaultValue2,
  disabled,
  emptyValue,
  id: nativeId,
  invalid,
  name,
  onChange,
  onFocus,
  onKeyDown,
  value = emptyValue,
  ...otherProps
}, ref) => {
  const data = useFlattenedData(emptyValue !== void 0 ? [{ text: "", value: emptyValue }, ...externalData] : externalData);
  const id2 = React.useMemo(() => nativeId || nanoid(), [nativeId]);
  const inputRef = useMergedRef(ref);
  const currentIndex = value !== void 0 ? getIndexFromValue(data, value) : void 0;
  const { getNextIndex: getNextIndex2 } = useTypeahead({ data, currentIndex });
  const setInputValueByIndex = (index2) => {
    if (index2 !== void 0) {
      const option = data[index2];
      if (option && !option.disabled) {
        setInputValueByRef(inputRef.current, option.value);
      }
    }
  };
  const handleListboxChange = (index2) => {
    setInputValueByIndex(index2);
  };
  React.useEffect(() => {
    if (data.length && currentIndex === void 0) {
      if (defaultValue2 !== void 0) {
        const defaultValueIndex = getIndexFromValue(data, defaultValue2);
        if (defaultValueIndex !== void 0) {
          setInputValueByIndex(defaultValueIndex);
        }
      } else {
        setInputValueByIndex(0);
      }
    }
  }, [data]);
  const handleListboxKeyDown = (event) => {
    const charKey = event.key;
    if (charKey.length === 1 && /(\w)/g.test(charKey)) {
      const nextIndex = getNextIndex2(charKey);
      if (nextIndex > -1 && nextIndex !== currentIndex) {
        setInputValueByIndex(nextIndex);
      }
      return;
    }
    if (onKeyDown) {
      event.persist();
      onKeyDown(event);
    }
  };
  const handleListboxFocus = (event) => {
    if (currentIndex === void 0 && data.length) {
      setInputValueByIndex(0);
    }
    if (onFocus) {
      event.persist();
      onFocus(event);
    }
  };
  const handleInputChange = (event) => {
    var _a;
    event.persist();
    if (onChange) {
      const item = findByValue(data, event.target.value);
      event.detail = sanitizeItem(item);
      const indexes = ((_a = item == null ? void 0 : item.path) == null ? void 0 : _a.split(".")) ?? [];
      if (indexes.length > 1) {
        indexes.pop();
        let lastPath;
        event.detail.parents = indexes.map((i3) => {
          lastPath = lastPath ? [lastPath, i3].join(".") : i3;
          return sanitizeItem(data.find((i22) => i22.path === lastPath));
        });
      }
      onChange(event);
    }
  };
  const list = {
    ...otherProps,
    "aria-activedescendant": getActiveDescendant(data, currentIndex, id2),
    data,
    disabled,
    id: id2,
    invalid,
    onChange: handleListboxChange,
    onFocus: handleListboxFocus,
    onKeyDown: handleListboxKeyDown,
    scrollOnFocus: true,
    tabIndex: disabled ? -1 : otherProps.tabIndex ? otherProps.tabIndex : 0,
    value: currentIndex
  };
  const input = {
    name,
    onChange: handleInputChange,
    ref: inputRef,
    tabIndex: -1,
    value: value ?? ""
  };
  return { list, input };
};
const useMultiListbox = ({
  data: externalData = [],
  defaultValue: defaultValue2,
  disabled,
  emptyValue: _,
  id: nativeId,
  name,
  onClick,
  onChange,
  onFocus,
  onKeyDown,
  value,
  ...otherProps
}, ref) => {
  const { texts } = useLocalization();
  const id2 = React.useMemo(() => nativeId || nanoid(), [nativeId]);
  const inputRef = useMergedRef(ref);
  const data = React.useMemo(() => {
    return [{ text: texts.listbox.allOption, value: "#ALL-OPTIONS#" }, ...externalData];
  }, [externalData]);
  const [currentIndex, setCurrentIndex] = React.useState(getIndexFromValue(data, value) || 0);
  const [allOptionsSelected, setAllOptionsSelected] = React.useState(false);
  const { getNextIndex: getNextIndex2 } = useTypeahead({ data, currentIndex });
  const [selectedIndexes, setSelectedIndexes] = React.useState(getSelectedIndexesFromValue(data, value));
  React.useEffect(() => {
    if (defaultValue2 && !value) {
      setInputValueByRef(inputRef.current, defaultValue2.toString());
    }
  }, []);
  React.useEffect(() => {
    const selectableItemsCount = data.filter((item) => !item.disabled).length - 1;
    if (selectableItemsCount === selectedIndexes.length) {
      setAllOptionsSelected(true);
    } else {
      setAllOptionsSelected(false);
    }
  }, [selectedIndexes, data]);
  const setInputValueByIndex = (index2) => {
    var _a;
    if (index2 !== void 0) {
      const option = data[index2];
      if (option && !option.disabled) {
        let newInputValue = "";
        const currentInputValue = (_a = inputRef.current) == null ? void 0 : _a.value;
        const currentValuesArray = (currentInputValue == null ? void 0 : currentInputValue.split(",")) || [];
        const optionAlreadySelected = currentValuesArray.findIndex((val) => val === String(option.value)) !== -1;
        if (option.value === "#ALL-OPTIONS#") {
          if (!allOptionsSelected) {
            newInputValue = data.filter((option2, index22) => index22 !== 0 && !option2.disabled).map((option2) => option2.value).join(",");
          } else {
            newInputValue = "";
          }
        } else {
          if (optionAlreadySelected) {
            newInputValue = currentValuesArray.filter((val) => val !== String(option.value)).join(",");
          } else {
            newInputValue = currentInputValue ? `${currentInputValue},${option.value}` : option.value;
          }
        }
        setInputValueByRef(inputRef.current, newInputValue);
      }
    }
  };
  const handleListboxClick = (event, index2) => {
    event.preventDefault();
    if (!data[index2].disabled) {
      setCurrentIndex(index2);
      setInputValueByIndex(index2);
    }
    if (onClick) {
      onClick(event);
    }
  };
  const handleListboxKeyDown = (event, index2) => {
    const charKey = event.key;
    if (charKey.length === 1 && /(\w)/g.test(charKey)) {
      const nextIndex = getNextIndex2(charKey);
      if (nextIndex > -1 && nextIndex !== currentIndex) {
        setCurrentIndex(nextIndex);
      }
      return;
    }
    switch (event.key) {
      case " ": {
        event.preventDefault();
        setInputValueByIndex(index2);
        break;
      }
      case "Enter": {
        setInputValueByIndex(index2);
        break;
      }
    }
    setCurrentIndex(index2 !== void 0 ? index2 : 0);
    if (onKeyDown) {
      event.persist();
      onKeyDown(event);
    }
  };
  const handleListboxFocus = (event) => {
    if (onFocus) {
      event.persist();
      onFocus(event);
    }
  };
  const handleInputChange = (event) => {
    event.persist();
    setSelectedIndexes(getSelectedIndexesFromValue(data, event.target.value));
    if (onChange) {
      const detail = [];
      const valuesArray = event.target.value.split(",");
      valuesArray.forEach((val) => {
        const item = findByValue(data, val);
        if (item) {
          detail.push(item);
        }
      });
      event.detail = detail;
      onChange(event);
    }
  };
  const list = {
    ...otherProps,
    "aria-activedescendant": getActiveDescendant(data, currentIndex, id2),
    "aria-multiselectable": true,
    data,
    disabled,
    id: id2,
    onChange: () => null,
    onClick: handleListboxClick,
    onFocus: handleListboxFocus,
    onKeyDown: handleListboxKeyDown,
    scrollOnFocus: false,
    tabIndex: disabled ? -1 : otherProps.tabIndex ? otherProps.tabIndex : 0,
    value: currentIndex,
    selectedIndexes,
    multiselect: true,
    allOptionsSelected
  };
  const input = {
    name,
    onChange: handleInputChange,
    ref: inputRef,
    tabIndex: -1,
    value: value ?? ""
  };
  return { list, input };
};
const Listbox = React.forwardRef(function Listbox2(props, ref) {
  const { className: externalClassName, ...otherProps } = props;
  const { list, input } = useListbox(otherProps, ref);
  const className = clsx("bg-white inline-flex relative w-full", externalClassName);
  return /* @__PURE__ */ React.createElement("span", { "data-taco": "listbox", className }, /* @__PURE__ */ React.createElement(
    ScrollableList,
    {
      ...list,
      style: {
        ...list.style,
        maxHeight: "calc(12rem + 2px)"
        /* (6 * option height) + listbox border */
      }
    }
  ), /* @__PURE__ */ React.createElement("input", { ...input, className: "hidden", type: "text" }));
});
const MultiListbox = React.forwardRef(function Listbox3(props, ref) {
  const { className: externalClassName, ...otherProps } = props;
  const { list, input } = useMultiListbox(otherProps, ref);
  const className = clsx("bg-white inline-flex relative w-full", externalClassName);
  return /* @__PURE__ */ React.createElement("span", { "data-taco": "listbox", className }, /* @__PURE__ */ React.createElement(
    ScrollableList,
    {
      ...list,
      style: {
        ...list.style,
        maxHeight: "calc(12rem + 2px + 2px)"
      }
    }
  ), /* @__PURE__ */ React.createElement("input", { ...input, className: "hidden", type: "text" }));
});
function $e02a7d9cb1dc128c$export$c74125a8e3af6bb2(name) {
  const PROVIDER_NAME = name + "CollectionProvider";
  const [createCollectionContext, createCollectionScope] = $c512c27ab02ef895$export$50c7b4e9d9f19c1$1(PROVIDER_NAME);
  const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
    collectionRef: {
      current: null
    },
    itemMap: /* @__PURE__ */ new Map()
  });
  const CollectionProvider = (props) => {
    const { scope, children } = props;
    const ref = React__default.useRef(null);
    const itemMap = React__default.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ React__default.createElement(CollectionProviderImpl, {
      scope,
      itemMap,
      collectionRef: ref
    }, children);
  };
  const COLLECTION_SLOT_NAME = name + "CollectionSlot";
  const CollectionSlot = /* @__PURE__ */ React__default.forwardRef((props, forwardedRef) => {
    const { scope, children } = props;
    const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05$1(forwardedRef, context.collectionRef);
    return /* @__PURE__ */ React__default.createElement($5e63c961fc1ce211$export$8c6ed5c666ac1360$1, {
      ref: composedRefs
    }, children);
  });
  const ITEM_SLOT_NAME = name + "CollectionItemSlot";
  const ITEM_DATA_ATTR = "data-radix-collection-item";
  const CollectionItemSlot = /* @__PURE__ */ React__default.forwardRef((props, forwardedRef) => {
    const { scope, children, ...itemData } = props;
    const ref = React__default.useRef(null);
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05$1(forwardedRef, ref);
    const context = useCollectionContext(ITEM_SLOT_NAME, scope);
    React__default.useEffect(() => {
      context.itemMap.set(ref, {
        ref,
        ...itemData
      });
      return () => void context.itemMap.delete(ref);
    });
    return /* @__PURE__ */ React__default.createElement($5e63c961fc1ce211$export$8c6ed5c666ac1360$1, {
      [ITEM_DATA_ATTR]: "",
      ref: composedRefs
    }, children);
  });
  function useCollection(scope) {
    const context = useCollectionContext(name + "CollectionConsumer", scope);
    const getItems = React__default.useCallback(() => {
      const collectionNode = context.collectionRef.current;
      if (!collectionNode) return [];
      const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
      const items = Array.from(context.itemMap.values());
      const orderedItems = items.sort(
        (a4, b3) => orderedNodes.indexOf(a4.ref.current) - orderedNodes.indexOf(b3.ref.current)
      );
      return orderedItems;
    }, [
      context.collectionRef,
      context.itemMap
    ]);
    return getItems;
  }
  return [
    {
      Provider: CollectionProvider,
      Slot: CollectionSlot,
      ItemSlot: CollectionItemSlot
    },
    useCollection,
    createCollectionScope
  ];
}
const $d7bdfb9eb0fdf311$var$ENTRY_FOCUS = "rovingFocusGroup.onEntryFocus";
const $d7bdfb9eb0fdf311$var$EVENT_OPTIONS = {
  bubbles: false,
  cancelable: true
};
const $d7bdfb9eb0fdf311$var$GROUP_NAME = "RovingFocusGroup";
const [$d7bdfb9eb0fdf311$var$Collection, $d7bdfb9eb0fdf311$var$useCollection, $d7bdfb9eb0fdf311$var$createCollectionScope] = $e02a7d9cb1dc128c$export$c74125a8e3af6bb2($d7bdfb9eb0fdf311$var$GROUP_NAME);
const [$d7bdfb9eb0fdf311$var$createRovingFocusGroupContext, $d7bdfb9eb0fdf311$export$c7109489551a4f4] = $c512c27ab02ef895$export$50c7b4e9d9f19c1$1($d7bdfb9eb0fdf311$var$GROUP_NAME, [
  $d7bdfb9eb0fdf311$var$createCollectionScope
]);
const [$d7bdfb9eb0fdf311$var$RovingFocusProvider, $d7bdfb9eb0fdf311$var$useRovingFocusContext] = $d7bdfb9eb0fdf311$var$createRovingFocusGroupContext($d7bdfb9eb0fdf311$var$GROUP_NAME);
const $d7bdfb9eb0fdf311$export$8699f7c8af148338 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  return /* @__PURE__ */ createElement($d7bdfb9eb0fdf311$var$Collection.Provider, {
    scope: props.__scopeRovingFocusGroup
  }, /* @__PURE__ */ createElement($d7bdfb9eb0fdf311$var$Collection.Slot, {
    scope: props.__scopeRovingFocusGroup
  }, /* @__PURE__ */ createElement($d7bdfb9eb0fdf311$var$RovingFocusGroupImpl, _extends$z({}, props, {
    ref: forwardedRef
  }))));
});
const $d7bdfb9eb0fdf311$var$RovingFocusGroupImpl = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeRovingFocusGroup, orientation, loop = false, dir, currentTabStopId: currentTabStopIdProp, defaultCurrentTabStopId, onCurrentTabStopIdChange, onEntryFocus, ...groupProps } = props;
  const ref = useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05$1(forwardedRef, ref);
  const direction = $f631663db3294ace$export$b39126d51d94e6f3(dir);
  const [currentTabStopId = null, setCurrentTabStopId] = $71cd76cc60e0454e$export$6f32135080cb4c3$1({
    prop: currentTabStopIdProp,
    defaultProp: defaultCurrentTabStopId,
    onChange: onCurrentTabStopIdChange
  });
  const [isTabbingBackOut, setIsTabbingBackOut] = useState(false);
  const handleEntryFocus = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a$1(onEntryFocus);
  const getItems = $d7bdfb9eb0fdf311$var$useCollection(__scopeRovingFocusGroup);
  const isClickFocusRef = useRef(false);
  const [focusableItemsCount, setFocusableItemsCount] = useState(0);
  useEffect(() => {
    const node = ref.current;
    if (node) {
      node.addEventListener($d7bdfb9eb0fdf311$var$ENTRY_FOCUS, handleEntryFocus);
      return () => node.removeEventListener($d7bdfb9eb0fdf311$var$ENTRY_FOCUS, handleEntryFocus);
    }
  }, [
    handleEntryFocus
  ]);
  return /* @__PURE__ */ createElement($d7bdfb9eb0fdf311$var$RovingFocusProvider, {
    scope: __scopeRovingFocusGroup,
    orientation,
    dir: direction,
    loop,
    currentTabStopId,
    onItemFocus: useCallback(
      (tabStopId) => setCurrentTabStopId(tabStopId),
      [
        setCurrentTabStopId
      ]
    ),
    onItemShiftTab: useCallback(
      () => setIsTabbingBackOut(true),
      []
    ),
    onFocusableItemAdd: useCallback(
      () => setFocusableItemsCount(
        (prevCount) => prevCount + 1
      ),
      []
    ),
    onFocusableItemRemove: useCallback(
      () => setFocusableItemsCount(
        (prevCount) => prevCount - 1
      ),
      []
    )
  }, /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.div, _extends$z({
    tabIndex: isTabbingBackOut || focusableItemsCount === 0 ? -1 : 0,
    "data-orientation": orientation
  }, groupProps, {
    ref: composedRefs,
    style: {
      outline: "none",
      ...props.style
    },
    onMouseDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(props.onMouseDown, () => {
      isClickFocusRef.current = true;
    }),
    onFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(props.onFocus, (event) => {
      const isKeyboardFocus = !isClickFocusRef.current;
      if (event.target === event.currentTarget && isKeyboardFocus && !isTabbingBackOut) {
        const entryFocusEvent = new CustomEvent($d7bdfb9eb0fdf311$var$ENTRY_FOCUS, $d7bdfb9eb0fdf311$var$EVENT_OPTIONS);
        event.currentTarget.dispatchEvent(entryFocusEvent);
        if (!entryFocusEvent.defaultPrevented) {
          const items = getItems().filter(
            (item) => item.focusable
          );
          const activeItem = items.find(
            (item) => item.active
          );
          const currentItem = items.find(
            (item) => item.id === currentTabStopId
          );
          const candidateItems = [
            activeItem,
            currentItem,
            ...items
          ].filter(Boolean);
          const candidateNodes = candidateItems.map(
            (item) => item.ref.current
          );
          $d7bdfb9eb0fdf311$var$focusFirst(candidateNodes);
        }
      }
      isClickFocusRef.current = false;
    }),
    onBlur: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(
      props.onBlur,
      () => setIsTabbingBackOut(false)
    )
  })));
});
const $d7bdfb9eb0fdf311$var$ITEM_NAME = "RovingFocusGroupItem";
const $d7bdfb9eb0fdf311$export$ab9df7c53fe8454 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeRovingFocusGroup, focusable = true, active = false, ...itemProps } = props;
  const id2 = $1746a345f3d73bb7$export$f680877a34711e37$1();
  const context = $d7bdfb9eb0fdf311$var$useRovingFocusContext($d7bdfb9eb0fdf311$var$ITEM_NAME, __scopeRovingFocusGroup);
  const isCurrentTabStop = context.currentTabStopId === id2;
  const getItems = $d7bdfb9eb0fdf311$var$useCollection(__scopeRovingFocusGroup);
  const { onFocusableItemAdd, onFocusableItemRemove } = context;
  useEffect(() => {
    if (focusable) {
      onFocusableItemAdd();
      return () => onFocusableItemRemove();
    }
  }, [
    focusable,
    onFocusableItemAdd,
    onFocusableItemRemove
  ]);
  return /* @__PURE__ */ createElement($d7bdfb9eb0fdf311$var$Collection.ItemSlot, {
    scope: __scopeRovingFocusGroup,
    id: id2,
    focusable,
    active
  }, /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.span, _extends$z({
    tabIndex: isCurrentTabStop ? 0 : -1,
    "data-orientation": context.orientation
  }, itemProps, {
    ref: forwardedRef,
    onMouseDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(props.onMouseDown, (event) => {
      if (!focusable) event.preventDefault();
      else context.onItemFocus(id2);
    }),
    onFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(
      props.onFocus,
      () => context.onItemFocus(id2)
    ),
    onKeyDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(props.onKeyDown, (event) => {
      if (event.key === "Tab" && event.shiftKey) {
        context.onItemShiftTab();
        return;
      }
      if (event.target !== event.currentTarget) return;
      const focusIntent = $d7bdfb9eb0fdf311$var$getFocusIntent(event, context.orientation, context.dir);
      if (focusIntent !== void 0) {
        event.preventDefault();
        const items = getItems().filter(
          (item) => item.focusable
        );
        let candidateNodes = items.map(
          (item) => item.ref.current
        );
        if (focusIntent === "last") candidateNodes.reverse();
        else if (focusIntent === "prev" || focusIntent === "next") {
          if (focusIntent === "prev") candidateNodes.reverse();
          const currentIndex = candidateNodes.indexOf(event.currentTarget);
          candidateNodes = context.loop ? $d7bdfb9eb0fdf311$var$wrapArray(candidateNodes, currentIndex + 1) : candidateNodes.slice(currentIndex + 1);
        }
        setTimeout(
          () => $d7bdfb9eb0fdf311$var$focusFirst(candidateNodes)
        );
      }
    })
  })));
});
const $d7bdfb9eb0fdf311$var$MAP_KEY_TO_FOCUS_INTENT = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function $d7bdfb9eb0fdf311$var$getDirectionAwareKey(key, dir) {
  if (dir !== "rtl") return key;
  return key === "ArrowLeft" ? "ArrowRight" : key === "ArrowRight" ? "ArrowLeft" : key;
}
function $d7bdfb9eb0fdf311$var$getFocusIntent(event, orientation, dir) {
  const key = $d7bdfb9eb0fdf311$var$getDirectionAwareKey(event.key, dir);
  if (orientation === "vertical" && [
    "ArrowLeft",
    "ArrowRight"
  ].includes(key)) return void 0;
  if (orientation === "horizontal" && [
    "ArrowUp",
    "ArrowDown"
  ].includes(key)) return void 0;
  return $d7bdfb9eb0fdf311$var$MAP_KEY_TO_FOCUS_INTENT[key];
}
function $d7bdfb9eb0fdf311$var$focusFirst(candidates) {
  const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
  for (const candidate of candidates) {
    if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
    candidate.focus();
    if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
  }
}
function $d7bdfb9eb0fdf311$var$wrapArray(array2, startIndex) {
  return array2.map(
    (_, index2) => array2[(startIndex + index2) % array2.length]
  );
}
const $d7bdfb9eb0fdf311$export$be92b6f5f03c0fe9 = $d7bdfb9eb0fdf311$export$8699f7c8af148338;
const $d7bdfb9eb0fdf311$export$6d08773d2e66f8f2 = $d7bdfb9eb0fdf311$export$ab9df7c53fe8454;
const $6cc32821e9371a1c$var$SELECTION_KEYS = [
  "Enter",
  " "
];
const $6cc32821e9371a1c$var$FIRST_KEYS = [
  "ArrowDown",
  "PageUp",
  "Home"
];
const $6cc32821e9371a1c$var$LAST_KEYS = [
  "ArrowUp",
  "PageDown",
  "End"
];
const $6cc32821e9371a1c$var$FIRST_LAST_KEYS = [
  ...$6cc32821e9371a1c$var$FIRST_KEYS,
  ...$6cc32821e9371a1c$var$LAST_KEYS
];
const $6cc32821e9371a1c$var$SUB_OPEN_KEYS = {
  ltr: [
    ...$6cc32821e9371a1c$var$SELECTION_KEYS,
    "ArrowRight"
  ],
  rtl: [
    ...$6cc32821e9371a1c$var$SELECTION_KEYS,
    "ArrowLeft"
  ]
};
const $6cc32821e9371a1c$var$SUB_CLOSE_KEYS = {
  ltr: [
    "ArrowLeft"
  ],
  rtl: [
    "ArrowRight"
  ]
};
const $6cc32821e9371a1c$var$MENU_NAME = "Menu";
const [$6cc32821e9371a1c$var$Collection, $6cc32821e9371a1c$var$useCollection, $6cc32821e9371a1c$var$createCollectionScope] = $e02a7d9cb1dc128c$export$c74125a8e3af6bb2($6cc32821e9371a1c$var$MENU_NAME);
const [$6cc32821e9371a1c$var$createMenuContext, $6cc32821e9371a1c$export$4027731b685e72eb] = $c512c27ab02ef895$export$50c7b4e9d9f19c1$1($6cc32821e9371a1c$var$MENU_NAME, [
  $6cc32821e9371a1c$var$createCollectionScope,
  $cf1ac5d9fe0e8206$export$722aac194ae923,
  $d7bdfb9eb0fdf311$export$c7109489551a4f4
]);
const $6cc32821e9371a1c$var$usePopperScope = $cf1ac5d9fe0e8206$export$722aac194ae923();
const $6cc32821e9371a1c$var$useRovingFocusGroupScope = $d7bdfb9eb0fdf311$export$c7109489551a4f4();
const [$6cc32821e9371a1c$var$MenuProvider, $6cc32821e9371a1c$var$useMenuContext] = $6cc32821e9371a1c$var$createMenuContext($6cc32821e9371a1c$var$MENU_NAME);
const [$6cc32821e9371a1c$var$MenuRootProvider, $6cc32821e9371a1c$var$useMenuRootContext] = $6cc32821e9371a1c$var$createMenuContext($6cc32821e9371a1c$var$MENU_NAME);
const $6cc32821e9371a1c$export$d9b273488cd8ce6f = (props) => {
  const { __scopeMenu, open = false, children, dir, onOpenChange, modal = true } = props;
  const popperScope = $6cc32821e9371a1c$var$usePopperScope(__scopeMenu);
  const [content, setContent] = useState(null);
  const isUsingKeyboardRef = useRef(false);
  const handleOpenChange = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a$1(onOpenChange);
  const direction = $f631663db3294ace$export$b39126d51d94e6f3(dir);
  useEffect(() => {
    const handleKeyDown = () => {
      isUsingKeyboardRef.current = true;
      document.addEventListener("pointerdown", handlePointer, {
        capture: true,
        once: true
      });
      document.addEventListener("pointermove", handlePointer, {
        capture: true,
        once: true
      });
    };
    const handlePointer = () => isUsingKeyboardRef.current = false;
    document.addEventListener("keydown", handleKeyDown, {
      capture: true
    });
    return () => {
      document.removeEventListener("keydown", handleKeyDown, {
        capture: true
      });
      document.removeEventListener("pointerdown", handlePointer, {
        capture: true
      });
      document.removeEventListener("pointermove", handlePointer, {
        capture: true
      });
    };
  }, []);
  return /* @__PURE__ */ createElement($cf1ac5d9fe0e8206$export$be92b6f5f03c0fe9, popperScope, /* @__PURE__ */ createElement($6cc32821e9371a1c$var$MenuProvider, {
    scope: __scopeMenu,
    open,
    onOpenChange: handleOpenChange,
    content,
    onContentChange: setContent
  }, /* @__PURE__ */ createElement($6cc32821e9371a1c$var$MenuRootProvider, {
    scope: __scopeMenu,
    onClose: useCallback(
      () => handleOpenChange(false),
      [
        handleOpenChange
      ]
    ),
    isUsingKeyboardRef,
    dir: direction,
    modal
  }, children)));
};
const $6cc32821e9371a1c$export$9fa5ebd18bee4d43 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeMenu, ...anchorProps } = props;
  const popperScope = $6cc32821e9371a1c$var$usePopperScope(__scopeMenu);
  return /* @__PURE__ */ createElement($cf1ac5d9fe0e8206$export$b688253958b8dfe7, _extends$z({}, popperScope, anchorProps, {
    ref: forwardedRef
  }));
});
const $6cc32821e9371a1c$var$PORTAL_NAME = "MenuPortal";
const [$6cc32821e9371a1c$var$PortalProvider, $6cc32821e9371a1c$var$usePortalContext] = $6cc32821e9371a1c$var$createMenuContext($6cc32821e9371a1c$var$PORTAL_NAME, {
  forceMount: void 0
});
const $6cc32821e9371a1c$export$793392f970497feb = (props) => {
  const { __scopeMenu, forceMount, children, container } = props;
  const context = $6cc32821e9371a1c$var$useMenuContext($6cc32821e9371a1c$var$PORTAL_NAME, __scopeMenu);
  return /* @__PURE__ */ createElement($6cc32821e9371a1c$var$PortalProvider, {
    scope: __scopeMenu,
    forceMount
  }, /* @__PURE__ */ createElement($921a889cee6df7e8$export$99c2b779aa4e8b8b$1, {
    present: forceMount || context.open
  }, /* @__PURE__ */ createElement($f1701beae083dbae$export$602eac185826482c, {
    asChild: true,
    container
  }, children)));
};
const $6cc32821e9371a1c$var$CONTENT_NAME = "MenuContent";
const [$6cc32821e9371a1c$var$MenuContentProvider, $6cc32821e9371a1c$var$useMenuContentContext] = $6cc32821e9371a1c$var$createMenuContext($6cc32821e9371a1c$var$CONTENT_NAME);
const $6cc32821e9371a1c$export$479f0f2f71193efe = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const portalContext = $6cc32821e9371a1c$var$usePortalContext($6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
  const { forceMount = portalContext.forceMount, ...contentProps } = props;
  const context = $6cc32821e9371a1c$var$useMenuContext($6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
  const rootContext = $6cc32821e9371a1c$var$useMenuRootContext($6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
  return /* @__PURE__ */ createElement($6cc32821e9371a1c$var$Collection.Provider, {
    scope: props.__scopeMenu
  }, /* @__PURE__ */ createElement($921a889cee6df7e8$export$99c2b779aa4e8b8b$1, {
    present: forceMount || context.open
  }, /* @__PURE__ */ createElement($6cc32821e9371a1c$var$Collection.Slot, {
    scope: props.__scopeMenu
  }, rootContext.modal ? /* @__PURE__ */ createElement($6cc32821e9371a1c$var$MenuRootContentModal, _extends$z({}, contentProps, {
    ref: forwardedRef
  })) : /* @__PURE__ */ createElement($6cc32821e9371a1c$var$MenuRootContentNonModal, _extends$z({}, contentProps, {
    ref: forwardedRef
  })))));
});
const $6cc32821e9371a1c$var$MenuRootContentModal = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const context = $6cc32821e9371a1c$var$useMenuContext($6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
  const ref = useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05$1(forwardedRef, ref);
  useEffect(() => {
    const content = ref.current;
    if (content) return hideOthers(content);
  }, []);
  return /* @__PURE__ */ createElement($6cc32821e9371a1c$var$MenuContentImpl, _extends$z({}, props, {
    ref: composedRefs,
    trapFocus: context.open,
    disableOutsidePointerEvents: context.open,
    disableOutsideScroll: true,
    onFocusOutside: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(
      props.onFocusOutside,
      (event) => event.preventDefault(),
      {
        checkForDefaultPrevented: false
      }
    ),
    onDismiss: () => context.onOpenChange(false)
  }));
});
const $6cc32821e9371a1c$var$MenuRootContentNonModal = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const context = $6cc32821e9371a1c$var$useMenuContext($6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
  return /* @__PURE__ */ createElement($6cc32821e9371a1c$var$MenuContentImpl, _extends$z({}, props, {
    ref: forwardedRef,
    trapFocus: false,
    disableOutsidePointerEvents: false,
    disableOutsideScroll: false,
    onDismiss: () => context.onOpenChange(false)
  }));
});
const $6cc32821e9371a1c$var$MenuContentImpl = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeMenu, loop = false, trapFocus, onOpenAutoFocus, onCloseAutoFocus, disableOutsidePointerEvents, onEscapeKeyDown, onPointerDownOutside, onFocusOutside, onInteractOutside, onDismiss, disableOutsideScroll, ...contentProps } = props;
  const context = $6cc32821e9371a1c$var$useMenuContext($6cc32821e9371a1c$var$CONTENT_NAME, __scopeMenu);
  const rootContext = $6cc32821e9371a1c$var$useMenuRootContext($6cc32821e9371a1c$var$CONTENT_NAME, __scopeMenu);
  const popperScope = $6cc32821e9371a1c$var$usePopperScope(__scopeMenu);
  const rovingFocusGroupScope = $6cc32821e9371a1c$var$useRovingFocusGroupScope(__scopeMenu);
  const getItems = $6cc32821e9371a1c$var$useCollection(__scopeMenu);
  const [currentItemId, setCurrentItemId] = useState(null);
  const contentRef = useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05$1(forwardedRef, contentRef, context.onContentChange);
  const timerRef = useRef(0);
  const searchRef = useRef("");
  const pointerGraceTimerRef = useRef(0);
  const pointerGraceIntentRef = useRef(null);
  const pointerDirRef = useRef("right");
  const lastPointerXRef = useRef(0);
  const ScrollLockWrapper = disableOutsideScroll ? ReactRemoveScroll : Fragment;
  const scrollLockWrapperProps = disableOutsideScroll ? {
    as: $5e63c961fc1ce211$export$8c6ed5c666ac1360$1,
    allowPinchZoom: true
  } : void 0;
  const handleTypeaheadSearch = (key) => {
    var _items$find, _items$find2;
    const search = searchRef.current + key;
    const items = getItems().filter(
      (item) => !item.disabled
    );
    const currentItem = document.activeElement;
    const currentMatch = (_items$find = items.find(
      (item) => item.ref.current === currentItem
    )) === null || _items$find === void 0 ? void 0 : _items$find.textValue;
    const values = items.map(
      (item) => item.textValue
    );
    const nextMatch = $6cc32821e9371a1c$var$getNextMatch(values, search, currentMatch);
    const newItem = (_items$find2 = items.find(
      (item) => item.textValue === nextMatch
    )) === null || _items$find2 === void 0 ? void 0 : _items$find2.ref.current;
    (function updateSearch(value) {
      searchRef.current = value;
      window.clearTimeout(timerRef.current);
      if (value !== "") timerRef.current = window.setTimeout(
        () => updateSearch(""),
        1e3
      );
    })(search);
    if (newItem)
      setTimeout(
        () => newItem.focus()
      );
  };
  useEffect(() => {
    return () => window.clearTimeout(timerRef.current);
  }, []);
  $3db38b7d1fb3fe6a$export$b7ece24a22aeda8c();
  const isPointerMovingToSubmenu = useCallback((event) => {
    var _pointerGraceIntentRe, _pointerGraceIntentRe2;
    const isMovingTowards = pointerDirRef.current === ((_pointerGraceIntentRe = pointerGraceIntentRef.current) === null || _pointerGraceIntentRe === void 0 ? void 0 : _pointerGraceIntentRe.side);
    return isMovingTowards && $6cc32821e9371a1c$var$isPointerInGraceArea(event, (_pointerGraceIntentRe2 = pointerGraceIntentRef.current) === null || _pointerGraceIntentRe2 === void 0 ? void 0 : _pointerGraceIntentRe2.area);
  }, []);
  return /* @__PURE__ */ createElement($6cc32821e9371a1c$var$MenuContentProvider, {
    scope: __scopeMenu,
    searchRef,
    onItemEnter: useCallback((event) => {
      if (isPointerMovingToSubmenu(event)) event.preventDefault();
    }, [
      isPointerMovingToSubmenu
    ]),
    onItemLeave: useCallback((event) => {
      var _contentRef$current;
      if (isPointerMovingToSubmenu(event)) return;
      (_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 || _contentRef$current.focus();
      setCurrentItemId(null);
    }, [
      isPointerMovingToSubmenu
    ]),
    onTriggerLeave: useCallback((event) => {
      if (isPointerMovingToSubmenu(event)) event.preventDefault();
    }, [
      isPointerMovingToSubmenu
    ]),
    pointerGraceTimerRef,
    onPointerGraceIntentChange: useCallback((intent) => {
      pointerGraceIntentRef.current = intent;
    }, [])
  }, /* @__PURE__ */ createElement(ScrollLockWrapper, scrollLockWrapperProps, /* @__PURE__ */ createElement($d3863c46a17e8a28$export$20e40289641fbbb6, {
    asChild: true,
    trapped: trapFocus,
    onMountAutoFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(onOpenAutoFocus, (event) => {
      var _contentRef$current2;
      event.preventDefault();
      (_contentRef$current2 = contentRef.current) === null || _contentRef$current2 === void 0 || _contentRef$current2.focus();
    }),
    onUnmountAutoFocus: onCloseAutoFocus
  }, /* @__PURE__ */ createElement($5cb92bef7577960e$export$177fb62ff3ec1f22, {
    asChild: true,
    disableOutsidePointerEvents,
    onEscapeKeyDown,
    onPointerDownOutside,
    onFocusOutside,
    onInteractOutside,
    onDismiss
  }, /* @__PURE__ */ createElement($d7bdfb9eb0fdf311$export$be92b6f5f03c0fe9, _extends$z({
    asChild: true
  }, rovingFocusGroupScope, {
    dir: rootContext.dir,
    orientation: "vertical",
    loop,
    currentTabStopId: currentItemId,
    onCurrentTabStopIdChange: setCurrentItemId,
    onEntryFocus: (event) => {
      if (!rootContext.isUsingKeyboardRef.current) event.preventDefault();
    }
  }), /* @__PURE__ */ createElement($cf1ac5d9fe0e8206$export$7c6e2c02157bb7d2, _extends$z({
    role: "menu",
    "aria-orientation": "vertical",
    "data-state": $6cc32821e9371a1c$var$getOpenState(context.open),
    "data-radix-menu-content": "",
    dir: rootContext.dir
  }, popperScope, contentProps, {
    ref: composedRefs,
    style: {
      outline: "none",
      ...contentProps.style
    },
    onKeyDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(contentProps.onKeyDown, (event) => {
      const target = event.target;
      const isKeyDownInside = target.closest("[data-radix-menu-content]") === event.currentTarget;
      const isModifierKey = event.ctrlKey || event.altKey || event.metaKey;
      const isCharacterKey = event.key.length === 1;
      if (isKeyDownInside) {
        if (event.key === "Tab") event.preventDefault();
        if (!isModifierKey && isCharacterKey) handleTypeaheadSearch(event.key);
      }
      const content = contentRef.current;
      if (event.target !== content) return;
      if (!$6cc32821e9371a1c$var$FIRST_LAST_KEYS.includes(event.key)) return;
      event.preventDefault();
      const items = getItems().filter(
        (item) => !item.disabled
      );
      const candidateNodes = items.map(
        (item) => item.ref.current
      );
      if ($6cc32821e9371a1c$var$LAST_KEYS.includes(event.key)) candidateNodes.reverse();
      $6cc32821e9371a1c$var$focusFirst(candidateNodes);
    }),
    onBlur: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(props.onBlur, (event) => {
      if (!event.currentTarget.contains(event.target)) {
        window.clearTimeout(timerRef.current);
        searchRef.current = "";
      }
    }),
    onPointerMove: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(props.onPointerMove, $6cc32821e9371a1c$var$whenMouse((event) => {
      const target = event.target;
      const pointerXHasChanged = lastPointerXRef.current !== event.clientX;
      if (event.currentTarget.contains(target) && pointerXHasChanged) {
        const newDir = event.clientX > lastPointerXRef.current ? "right" : "left";
        pointerDirRef.current = newDir;
        lastPointerXRef.current = event.clientX;
      }
    }))
  })))))));
});
const $6cc32821e9371a1c$export$22a631d1f72787bb = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeMenu, ...groupProps } = props;
  return /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.div, _extends$z({
    role: "group"
  }, groupProps, {
    ref: forwardedRef
  }));
});
const $6cc32821e9371a1c$export$dd37bec0e8a99143 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeMenu, ...labelProps } = props;
  return /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.div, _extends$z({}, labelProps, {
    ref: forwardedRef
  }));
});
const $6cc32821e9371a1c$var$ITEM_NAME = "MenuItem";
const $6cc32821e9371a1c$var$ITEM_SELECT = "menu.itemSelect";
const $6cc32821e9371a1c$export$2ce376c2cc3355c8 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { disabled = false, onSelect, ...itemProps } = props;
  const ref = useRef(null);
  const rootContext = $6cc32821e9371a1c$var$useMenuRootContext($6cc32821e9371a1c$var$ITEM_NAME, props.__scopeMenu);
  const contentContext = $6cc32821e9371a1c$var$useMenuContentContext($6cc32821e9371a1c$var$ITEM_NAME, props.__scopeMenu);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05$1(forwardedRef, ref);
  const isPointerDownRef = useRef(false);
  const handleSelect = () => {
    const menuItem = ref.current;
    if (!disabled && menuItem) {
      const itemSelectEvent = new CustomEvent($6cc32821e9371a1c$var$ITEM_SELECT, {
        bubbles: true,
        cancelable: true
      });
      menuItem.addEventListener(
        $6cc32821e9371a1c$var$ITEM_SELECT,
        (event) => onSelect === null || onSelect === void 0 ? void 0 : onSelect(event),
        {
          once: true
        }
      );
      $8927f6f2acc4f386$export$6d1a0317bde7de7f(menuItem, itemSelectEvent);
      if (itemSelectEvent.defaultPrevented) isPointerDownRef.current = false;
      else rootContext.onClose();
    }
  };
  return /* @__PURE__ */ createElement($6cc32821e9371a1c$var$MenuItemImpl, _extends$z({}, itemProps, {
    ref: composedRefs,
    disabled,
    onClick: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(props.onClick, handleSelect),
    onPointerDown: (event) => {
      var _props$onPointerDown;
      (_props$onPointerDown = props.onPointerDown) === null || _props$onPointerDown === void 0 || _props$onPointerDown.call(props, event);
      isPointerDownRef.current = true;
    },
    onPointerUp: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(props.onPointerUp, (event) => {
      var _event$currentTarget;
      if (!isPointerDownRef.current) (_event$currentTarget = event.currentTarget) === null || _event$currentTarget === void 0 || _event$currentTarget.click();
    }),
    onKeyDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(props.onKeyDown, (event) => {
      const isTypingAhead = contentContext.searchRef.current !== "";
      if (disabled || isTypingAhead && event.key === " ") return;
      if ($6cc32821e9371a1c$var$SELECTION_KEYS.includes(event.key)) {
        event.currentTarget.click();
        event.preventDefault();
      }
    })
  }));
});
const $6cc32821e9371a1c$var$MenuItemImpl = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeMenu, disabled = false, textValue, ...itemProps } = props;
  const contentContext = $6cc32821e9371a1c$var$useMenuContentContext($6cc32821e9371a1c$var$ITEM_NAME, __scopeMenu);
  const rovingFocusGroupScope = $6cc32821e9371a1c$var$useRovingFocusGroupScope(__scopeMenu);
  const ref = useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05$1(forwardedRef, ref);
  const [isFocused, setIsFocused] = useState(false);
  const [textContent, setTextContent] = useState("");
  useEffect(() => {
    const menuItem = ref.current;
    if (menuItem) {
      var _menuItem$textContent;
      setTextContent(((_menuItem$textContent = menuItem.textContent) !== null && _menuItem$textContent !== void 0 ? _menuItem$textContent : "").trim());
    }
  }, [
    itemProps.children
  ]);
  return /* @__PURE__ */ createElement($6cc32821e9371a1c$var$Collection.ItemSlot, {
    scope: __scopeMenu,
    disabled,
    textValue: textValue !== null && textValue !== void 0 ? textValue : textContent
  }, /* @__PURE__ */ createElement($d7bdfb9eb0fdf311$export$6d08773d2e66f8f2, _extends$z({
    asChild: true
  }, rovingFocusGroupScope, {
    focusable: !disabled
  }), /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.div, _extends$z({
    role: "menuitem",
    "data-highlighted": isFocused ? "" : void 0,
    "aria-disabled": disabled || void 0,
    "data-disabled": disabled ? "" : void 0
  }, itemProps, {
    ref: composedRefs,
    onPointerMove: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(props.onPointerMove, $6cc32821e9371a1c$var$whenMouse((event) => {
      if (disabled) contentContext.onItemLeave(event);
      else {
        contentContext.onItemEnter(event);
        if (!event.defaultPrevented) {
          const item = event.currentTarget;
          item.focus();
        }
      }
    })),
    onPointerLeave: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(props.onPointerLeave, $6cc32821e9371a1c$var$whenMouse(
      (event) => contentContext.onItemLeave(event)
    )),
    onFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(
      props.onFocus,
      () => setIsFocused(true)
    ),
    onBlur: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(
      props.onBlur,
      () => setIsFocused(false)
    )
  }))));
});
const $6cc32821e9371a1c$export$f6f243521332502d = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { checked = false, onCheckedChange, ...checkboxItemProps } = props;
  return /* @__PURE__ */ createElement($6cc32821e9371a1c$var$ItemIndicatorProvider, {
    scope: props.__scopeMenu,
    checked
  }, /* @__PURE__ */ createElement($6cc32821e9371a1c$export$2ce376c2cc3355c8, _extends$z({
    role: "menuitemcheckbox",
    "aria-checked": $6cc32821e9371a1c$var$isIndeterminate(checked) ? "mixed" : checked
  }, checkboxItemProps, {
    ref: forwardedRef,
    "data-state": $6cc32821e9371a1c$var$getCheckedState(checked),
    onSelect: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(
      checkboxItemProps.onSelect,
      () => onCheckedChange === null || onCheckedChange === void 0 ? void 0 : onCheckedChange($6cc32821e9371a1c$var$isIndeterminate(checked) ? true : !checked),
      {
        checkForDefaultPrevented: false
      }
    )
  })));
});
const $6cc32821e9371a1c$var$RADIO_GROUP_NAME = "MenuRadioGroup";
const [$6cc32821e9371a1c$var$RadioGroupProvider, $6cc32821e9371a1c$var$useRadioGroupContext] = $6cc32821e9371a1c$var$createMenuContext($6cc32821e9371a1c$var$RADIO_GROUP_NAME, {
  value: void 0,
  onValueChange: () => {
  }
});
const $6cc32821e9371a1c$export$ea2200c9eee416b3 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { value, onValueChange, ...groupProps } = props;
  const handleValueChange = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a$1(onValueChange);
  return /* @__PURE__ */ createElement($6cc32821e9371a1c$var$RadioGroupProvider, {
    scope: props.__scopeMenu,
    value,
    onValueChange: handleValueChange
  }, /* @__PURE__ */ createElement($6cc32821e9371a1c$export$22a631d1f72787bb, _extends$z({}, groupProps, {
    ref: forwardedRef
  })));
});
const $6cc32821e9371a1c$var$RADIO_ITEM_NAME = "MenuRadioItem";
const $6cc32821e9371a1c$export$69bd225e9817f6d0 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { value, ...radioItemProps } = props;
  const context = $6cc32821e9371a1c$var$useRadioGroupContext($6cc32821e9371a1c$var$RADIO_ITEM_NAME, props.__scopeMenu);
  const checked = value === context.value;
  return /* @__PURE__ */ createElement($6cc32821e9371a1c$var$ItemIndicatorProvider, {
    scope: props.__scopeMenu,
    checked
  }, /* @__PURE__ */ createElement($6cc32821e9371a1c$export$2ce376c2cc3355c8, _extends$z({
    role: "menuitemradio",
    "aria-checked": checked
  }, radioItemProps, {
    ref: forwardedRef,
    "data-state": $6cc32821e9371a1c$var$getCheckedState(checked),
    onSelect: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(radioItemProps.onSelect, () => {
      var _context$onValueChang;
      return (_context$onValueChang = context.onValueChange) === null || _context$onValueChang === void 0 ? void 0 : _context$onValueChang.call(context, value);
    }, {
      checkForDefaultPrevented: false
    })
  })));
});
const $6cc32821e9371a1c$var$ITEM_INDICATOR_NAME = "MenuItemIndicator";
const [$6cc32821e9371a1c$var$ItemIndicatorProvider, $6cc32821e9371a1c$var$useItemIndicatorContext] = $6cc32821e9371a1c$var$createMenuContext($6cc32821e9371a1c$var$ITEM_INDICATOR_NAME, {
  checked: false
});
const $6cc32821e9371a1c$export$a2593e23056970a3 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeMenu, forceMount, ...itemIndicatorProps } = props;
  const indicatorContext = $6cc32821e9371a1c$var$useItemIndicatorContext($6cc32821e9371a1c$var$ITEM_INDICATOR_NAME, __scopeMenu);
  return /* @__PURE__ */ createElement($921a889cee6df7e8$export$99c2b779aa4e8b8b$1, {
    present: forceMount || $6cc32821e9371a1c$var$isIndeterminate(indicatorContext.checked) || indicatorContext.checked === true
  }, /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.span, _extends$z({}, itemIndicatorProps, {
    ref: forwardedRef,
    "data-state": $6cc32821e9371a1c$var$getCheckedState(indicatorContext.checked)
  })));
});
const $6cc32821e9371a1c$export$1cec7dcdd713e220 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeMenu, ...separatorProps } = props;
  return /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.div, _extends$z({
    role: "separator",
    "aria-orientation": "horizontal"
  }, separatorProps, {
    ref: forwardedRef
  }));
});
const $6cc32821e9371a1c$var$SUB_NAME = "MenuSub";
const [$6cc32821e9371a1c$var$MenuSubProvider, $6cc32821e9371a1c$var$useMenuSubContext] = $6cc32821e9371a1c$var$createMenuContext($6cc32821e9371a1c$var$SUB_NAME);
const $6cc32821e9371a1c$export$71bdb9d1e2909932 = (props) => {
  const { __scopeMenu, children, open = false, onOpenChange } = props;
  const parentMenuContext = $6cc32821e9371a1c$var$useMenuContext($6cc32821e9371a1c$var$SUB_NAME, __scopeMenu);
  const popperScope = $6cc32821e9371a1c$var$usePopperScope(__scopeMenu);
  const [trigger, setTrigger] = useState(null);
  const [content, setContent] = useState(null);
  const handleOpenChange = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a$1(onOpenChange);
  useEffect(() => {
    if (parentMenuContext.open === false) handleOpenChange(false);
    return () => handleOpenChange(false);
  }, [
    parentMenuContext.open,
    handleOpenChange
  ]);
  return /* @__PURE__ */ createElement($cf1ac5d9fe0e8206$export$be92b6f5f03c0fe9, popperScope, /* @__PURE__ */ createElement($6cc32821e9371a1c$var$MenuProvider, {
    scope: __scopeMenu,
    open,
    onOpenChange: handleOpenChange,
    content,
    onContentChange: setContent
  }, /* @__PURE__ */ createElement($6cc32821e9371a1c$var$MenuSubProvider, {
    scope: __scopeMenu,
    contentId: $1746a345f3d73bb7$export$f680877a34711e37$1(),
    triggerId: $1746a345f3d73bb7$export$f680877a34711e37$1(),
    trigger,
    onTriggerChange: setTrigger
  }, children)));
};
const $6cc32821e9371a1c$var$SUB_TRIGGER_NAME = "MenuSubTrigger";
const $6cc32821e9371a1c$export$5fbbb3ba7297405f = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const context = $6cc32821e9371a1c$var$useMenuContext($6cc32821e9371a1c$var$SUB_TRIGGER_NAME, props.__scopeMenu);
  const rootContext = $6cc32821e9371a1c$var$useMenuRootContext($6cc32821e9371a1c$var$SUB_TRIGGER_NAME, props.__scopeMenu);
  const subContext = $6cc32821e9371a1c$var$useMenuSubContext($6cc32821e9371a1c$var$SUB_TRIGGER_NAME, props.__scopeMenu);
  const contentContext = $6cc32821e9371a1c$var$useMenuContentContext($6cc32821e9371a1c$var$SUB_TRIGGER_NAME, props.__scopeMenu);
  const openTimerRef = useRef(null);
  const { pointerGraceTimerRef, onPointerGraceIntentChange } = contentContext;
  const scope = {
    __scopeMenu: props.__scopeMenu
  };
  const clearOpenTimer = useCallback(() => {
    if (openTimerRef.current) window.clearTimeout(openTimerRef.current);
    openTimerRef.current = null;
  }, []);
  useEffect(
    () => clearOpenTimer,
    [
      clearOpenTimer
    ]
  );
  useEffect(() => {
    const pointerGraceTimer = pointerGraceTimerRef.current;
    return () => {
      window.clearTimeout(pointerGraceTimer);
      onPointerGraceIntentChange(null);
    };
  }, [
    pointerGraceTimerRef,
    onPointerGraceIntentChange
  ]);
  return /* @__PURE__ */ createElement($6cc32821e9371a1c$export$9fa5ebd18bee4d43, _extends$z({
    asChild: true
  }, scope), /* @__PURE__ */ createElement($6cc32821e9371a1c$var$MenuItemImpl, _extends$z({
    id: subContext.triggerId,
    "aria-haspopup": "menu",
    "aria-expanded": context.open,
    "aria-controls": subContext.contentId,
    "data-state": $6cc32821e9371a1c$var$getOpenState(context.open)
  }, props, {
    ref: $6ed0406888f73fc4$export$43e446d32b3d21af$1(forwardedRef, subContext.onTriggerChange),
    onClick: (event) => {
      var _props$onClick;
      (_props$onClick = props.onClick) === null || _props$onClick === void 0 || _props$onClick.call(props, event);
      if (props.disabled || event.defaultPrevented) return;
      event.currentTarget.focus();
      if (!context.open) context.onOpenChange(true);
    },
    onPointerMove: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(props.onPointerMove, $6cc32821e9371a1c$var$whenMouse((event) => {
      contentContext.onItemEnter(event);
      if (event.defaultPrevented) return;
      if (!props.disabled && !context.open && !openTimerRef.current) {
        contentContext.onPointerGraceIntentChange(null);
        openTimerRef.current = window.setTimeout(() => {
          context.onOpenChange(true);
          clearOpenTimer();
        }, 100);
      }
    })),
    onPointerLeave: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(props.onPointerLeave, $6cc32821e9371a1c$var$whenMouse((event) => {
      var _context$content;
      clearOpenTimer();
      const contentRect = (_context$content = context.content) === null || _context$content === void 0 ? void 0 : _context$content.getBoundingClientRect();
      if (contentRect) {
        var _context$content2;
        const side = (_context$content2 = context.content) === null || _context$content2 === void 0 ? void 0 : _context$content2.dataset.side;
        const rightSide = side === "right";
        const bleed = rightSide ? -5 : 5;
        const contentNearEdge = contentRect[rightSide ? "left" : "right"];
        const contentFarEdge = contentRect[rightSide ? "right" : "left"];
        contentContext.onPointerGraceIntentChange({
          area: [
            // consistently within polygon bounds
            {
              x: event.clientX + bleed,
              y: event.clientY
            },
            {
              x: contentNearEdge,
              y: contentRect.top
            },
            {
              x: contentFarEdge,
              y: contentRect.top
            },
            {
              x: contentFarEdge,
              y: contentRect.bottom
            },
            {
              x: contentNearEdge,
              y: contentRect.bottom
            }
          ],
          side
        });
        window.clearTimeout(pointerGraceTimerRef.current);
        pointerGraceTimerRef.current = window.setTimeout(
          () => contentContext.onPointerGraceIntentChange(null),
          300
        );
      } else {
        contentContext.onTriggerLeave(event);
        if (event.defaultPrevented) return;
        contentContext.onPointerGraceIntentChange(null);
      }
    })),
    onKeyDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(props.onKeyDown, (event) => {
      const isTypingAhead = contentContext.searchRef.current !== "";
      if (props.disabled || isTypingAhead && event.key === " ") return;
      if ($6cc32821e9371a1c$var$SUB_OPEN_KEYS[rootContext.dir].includes(event.key)) {
        var _context$content3;
        context.onOpenChange(true);
        (_context$content3 = context.content) === null || _context$content3 === void 0 || _context$content3.focus();
        event.preventDefault();
      }
    })
  })));
});
const $6cc32821e9371a1c$var$SUB_CONTENT_NAME = "MenuSubContent";
const $6cc32821e9371a1c$export$e7142ab31822bde6 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const portalContext = $6cc32821e9371a1c$var$usePortalContext($6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
  const { forceMount = portalContext.forceMount, ...subContentProps } = props;
  const context = $6cc32821e9371a1c$var$useMenuContext($6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
  const rootContext = $6cc32821e9371a1c$var$useMenuRootContext($6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
  const subContext = $6cc32821e9371a1c$var$useMenuSubContext($6cc32821e9371a1c$var$SUB_CONTENT_NAME, props.__scopeMenu);
  const ref = useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05$1(forwardedRef, ref);
  return /* @__PURE__ */ createElement($6cc32821e9371a1c$var$Collection.Provider, {
    scope: props.__scopeMenu
  }, /* @__PURE__ */ createElement($921a889cee6df7e8$export$99c2b779aa4e8b8b$1, {
    present: forceMount || context.open
  }, /* @__PURE__ */ createElement($6cc32821e9371a1c$var$Collection.Slot, {
    scope: props.__scopeMenu
  }, /* @__PURE__ */ createElement($6cc32821e9371a1c$var$MenuContentImpl, _extends$z({
    id: subContext.contentId,
    "aria-labelledby": subContext.triggerId
  }, subContentProps, {
    ref: composedRefs,
    align: "start",
    side: rootContext.dir === "rtl" ? "left" : "right",
    disableOutsidePointerEvents: false,
    disableOutsideScroll: false,
    trapFocus: false,
    onOpenAutoFocus: (event) => {
      var _ref$current;
      if (rootContext.isUsingKeyboardRef.current) (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.focus();
      event.preventDefault();
    },
    onCloseAutoFocus: (event) => event.preventDefault(),
    onFocusOutside: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(props.onFocusOutside, (event) => {
      if (event.target !== subContext.trigger) context.onOpenChange(false);
    }),
    onEscapeKeyDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(props.onEscapeKeyDown, rootContext.onClose),
    onKeyDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(props.onKeyDown, (event) => {
      const isKeyDownInside = event.currentTarget.contains(event.target);
      const isCloseKey = $6cc32821e9371a1c$var$SUB_CLOSE_KEYS[rootContext.dir].includes(event.key);
      if (isKeyDownInside && isCloseKey) {
        var _subContext$trigger;
        context.onOpenChange(false);
        (_subContext$trigger = subContext.trigger) === null || _subContext$trigger === void 0 || _subContext$trigger.focus();
        event.preventDefault();
      }
    })
  })))));
});
function $6cc32821e9371a1c$var$getOpenState(open) {
  return open ? "open" : "closed";
}
function $6cc32821e9371a1c$var$isIndeterminate(checked) {
  return checked === "indeterminate";
}
function $6cc32821e9371a1c$var$getCheckedState(checked) {
  return $6cc32821e9371a1c$var$isIndeterminate(checked) ? "indeterminate" : checked ? "checked" : "unchecked";
}
function $6cc32821e9371a1c$var$focusFirst(candidates) {
  const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
  for (const candidate of candidates) {
    if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
    candidate.focus();
    if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
  }
}
function $6cc32821e9371a1c$var$wrapArray(array2, startIndex) {
  return array2.map(
    (_, index2) => array2[(startIndex + index2) % array2.length]
  );
}
function $6cc32821e9371a1c$var$getNextMatch(values, search, currentMatch) {
  const isRepeated = search.length > 1 && Array.from(search).every(
    (char) => char === search[0]
  );
  const normalizedSearch = isRepeated ? search[0] : search;
  const currentMatchIndex = currentMatch ? values.indexOf(currentMatch) : -1;
  let wrappedValues = $6cc32821e9371a1c$var$wrapArray(values, Math.max(currentMatchIndex, 0));
  const excludeCurrentMatch = normalizedSearch.length === 1;
  if (excludeCurrentMatch) wrappedValues = wrappedValues.filter(
    (v2) => v2 !== currentMatch
  );
  const nextMatch = wrappedValues.find(
    (value) => value.toLowerCase().startsWith(normalizedSearch.toLowerCase())
  );
  return nextMatch !== currentMatch ? nextMatch : void 0;
}
function $6cc32821e9371a1c$var$isPointInPolygon(point2, polygon) {
  const { x: x3, y: y4 } = point2;
  let inside = false;
  for (let i3 = 0, j = polygon.length - 1; i3 < polygon.length; j = i3++) {
    const xi = polygon[i3].x;
    const yi = polygon[i3].y;
    const xj = polygon[j].x;
    const yj = polygon[j].y;
    const intersect = yi > y4 !== yj > y4 && x3 < (xj - xi) * (y4 - yi) / (yj - yi) + xi;
    if (intersect) inside = !inside;
  }
  return inside;
}
function $6cc32821e9371a1c$var$isPointerInGraceArea(event, area) {
  if (!area) return false;
  const cursorPos = {
    x: event.clientX,
    y: event.clientY
  };
  return $6cc32821e9371a1c$var$isPointInPolygon(cursorPos, area);
}
function $6cc32821e9371a1c$var$whenMouse(handler) {
  return (event) => event.pointerType === "mouse" ? handler(event) : void 0;
}
const $6cc32821e9371a1c$export$be92b6f5f03c0fe9 = $6cc32821e9371a1c$export$d9b273488cd8ce6f;
const $6cc32821e9371a1c$export$b688253958b8dfe7 = $6cc32821e9371a1c$export$9fa5ebd18bee4d43;
const $6cc32821e9371a1c$export$602eac185826482c = $6cc32821e9371a1c$export$793392f970497feb;
const $6cc32821e9371a1c$export$7c6e2c02157bb7d2 = $6cc32821e9371a1c$export$479f0f2f71193efe;
const $6cc32821e9371a1c$export$b04be29aa201d4f5 = $6cc32821e9371a1c$export$dd37bec0e8a99143;
const $6cc32821e9371a1c$export$6d08773d2e66f8f2 = $6cc32821e9371a1c$export$2ce376c2cc3355c8;
const $6cc32821e9371a1c$export$16ce288f89fa631c = $6cc32821e9371a1c$export$f6f243521332502d;
const $6cc32821e9371a1c$export$a98f0dcb43a68a25 = $6cc32821e9371a1c$export$ea2200c9eee416b3;
const $6cc32821e9371a1c$export$371ab307eab489c0 = $6cc32821e9371a1c$export$69bd225e9817f6d0;
const $6cc32821e9371a1c$export$c3468e2714d175fa = $6cc32821e9371a1c$export$a2593e23056970a3;
const $6cc32821e9371a1c$export$1ff3c3f08ae963c0 = $6cc32821e9371a1c$export$1cec7dcdd713e220;
const $6cc32821e9371a1c$export$d7a01e11500dfb6f = $6cc32821e9371a1c$export$71bdb9d1e2909932;
const $6cc32821e9371a1c$export$2ea8a7a591ac5eac = $6cc32821e9371a1c$export$5fbbb3ba7297405f;
const $6cc32821e9371a1c$export$6d4de93b380beddf = $6cc32821e9371a1c$export$e7142ab31822bde6;
const $d08ef79370b62062$var$DROPDOWN_MENU_NAME = "DropdownMenu";
const [$d08ef79370b62062$var$createDropdownMenuContext, $d08ef79370b62062$export$c0623cd925aeb687] = $c512c27ab02ef895$export$50c7b4e9d9f19c1$1($d08ef79370b62062$var$DROPDOWN_MENU_NAME, [
  $6cc32821e9371a1c$export$4027731b685e72eb
]);
const $d08ef79370b62062$var$useMenuScope = $6cc32821e9371a1c$export$4027731b685e72eb();
const [$d08ef79370b62062$var$DropdownMenuProvider, $d08ef79370b62062$var$useDropdownMenuContext] = $d08ef79370b62062$var$createDropdownMenuContext($d08ef79370b62062$var$DROPDOWN_MENU_NAME);
const $d08ef79370b62062$export$e44a253a59704894 = (props) => {
  const { __scopeDropdownMenu, children, dir, open: openProp, defaultOpen, onOpenChange, modal = true } = props;
  const menuScope = $d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
  const triggerRef = useRef(null);
  const [open = false, setOpen] = $71cd76cc60e0454e$export$6f32135080cb4c3$1({
    prop: openProp,
    defaultProp: defaultOpen,
    onChange: onOpenChange
  });
  return /* @__PURE__ */ createElement($d08ef79370b62062$var$DropdownMenuProvider, {
    scope: __scopeDropdownMenu,
    triggerId: $1746a345f3d73bb7$export$f680877a34711e37$1(),
    triggerRef,
    contentId: $1746a345f3d73bb7$export$f680877a34711e37$1(),
    open,
    onOpenChange: setOpen,
    onOpenToggle: useCallback(
      () => setOpen(
        (prevOpen) => !prevOpen
      ),
      [
        setOpen
      ]
    ),
    modal
  }, /* @__PURE__ */ createElement($6cc32821e9371a1c$export$be92b6f5f03c0fe9, _extends$z({}, menuScope, {
    open,
    onOpenChange: setOpen,
    dir,
    modal
  }), children));
};
const $d08ef79370b62062$var$TRIGGER_NAME = "DropdownMenuTrigger";
const $d08ef79370b62062$export$d2469213b3befba9 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeDropdownMenu, disabled = false, ...triggerProps } = props;
  const context = $d08ef79370b62062$var$useDropdownMenuContext($d08ef79370b62062$var$TRIGGER_NAME, __scopeDropdownMenu);
  const menuScope = $d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
  return /* @__PURE__ */ createElement($6cc32821e9371a1c$export$b688253958b8dfe7, _extends$z({
    asChild: true
  }, menuScope), /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.button, _extends$z({
    type: "button",
    id: context.triggerId,
    "aria-haspopup": "menu",
    "aria-expanded": context.open,
    "aria-controls": context.open ? context.contentId : void 0,
    "data-state": context.open ? "open" : "closed",
    "data-disabled": disabled ? "" : void 0,
    disabled
  }, triggerProps, {
    ref: $6ed0406888f73fc4$export$43e446d32b3d21af$1(forwardedRef, context.triggerRef),
    onPointerDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(props.onPointerDown, (event) => {
      if (!disabled && event.button === 0 && event.ctrlKey === false) {
        context.onOpenToggle();
        if (!context.open) event.preventDefault();
      }
    }),
    onKeyDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(props.onKeyDown, (event) => {
      if (disabled) return;
      if ([
        "Enter",
        " "
      ].includes(event.key)) context.onOpenToggle();
      if (event.key === "ArrowDown") context.onOpenChange(true);
      if ([
        "Enter",
        " ",
        "ArrowDown"
      ].includes(event.key)) event.preventDefault();
    })
  })));
});
const $d08ef79370b62062$export$cd369b4d4d54efc9 = (props) => {
  const { __scopeDropdownMenu, ...portalProps } = props;
  const menuScope = $d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
  return /* @__PURE__ */ createElement($6cc32821e9371a1c$export$602eac185826482c, _extends$z({}, menuScope, portalProps));
};
const $d08ef79370b62062$var$CONTENT_NAME = "DropdownMenuContent";
const $d08ef79370b62062$export$6e76d93a37c01248 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeDropdownMenu, ...contentProps } = props;
  const context = $d08ef79370b62062$var$useDropdownMenuContext($d08ef79370b62062$var$CONTENT_NAME, __scopeDropdownMenu);
  const menuScope = $d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
  const hasInteractedOutsideRef = useRef(false);
  return /* @__PURE__ */ createElement($6cc32821e9371a1c$export$7c6e2c02157bb7d2, _extends$z({
    id: context.contentId,
    "aria-labelledby": context.triggerId
  }, menuScope, contentProps, {
    ref: forwardedRef,
    onCloseAutoFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(props.onCloseAutoFocus, (event) => {
      var _context$triggerRef$c;
      if (!hasInteractedOutsideRef.current) (_context$triggerRef$c = context.triggerRef.current) === null || _context$triggerRef$c === void 0 || _context$triggerRef$c.focus();
      hasInteractedOutsideRef.current = false;
      event.preventDefault();
    }),
    onInteractOutside: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(props.onInteractOutside, (event) => {
      const originalEvent = event.detail.originalEvent;
      const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
      const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
      if (!context.modal || isRightClick) hasInteractedOutsideRef.current = true;
    }),
    style: {
      ...props.style,
      // re-namespace exposed content custom property
      ["--radix-dropdown-menu-content-transform-origin"]: "var(--radix-popper-transform-origin)"
    }
  }));
});
const $d08ef79370b62062$export$76e48c5b57f24495 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeDropdownMenu, ...labelProps } = props;
  const menuScope = $d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
  return /* @__PURE__ */ createElement($6cc32821e9371a1c$export$b04be29aa201d4f5, _extends$z({}, menuScope, labelProps, {
    ref: forwardedRef
  }));
});
const $d08ef79370b62062$export$ed97964d1871885d = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeDropdownMenu, ...itemProps } = props;
  const menuScope = $d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
  return /* @__PURE__ */ createElement($6cc32821e9371a1c$export$6d08773d2e66f8f2, _extends$z({}, menuScope, itemProps, {
    ref: forwardedRef
  }));
});
const $d08ef79370b62062$export$53a69729da201fa9 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeDropdownMenu, ...checkboxItemProps } = props;
  const menuScope = $d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
  return /* @__PURE__ */ createElement($6cc32821e9371a1c$export$16ce288f89fa631c, _extends$z({}, menuScope, checkboxItemProps, {
    ref: forwardedRef
  }));
});
const $d08ef79370b62062$export$3323ad73d55f587e = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeDropdownMenu, ...radioGroupProps } = props;
  const menuScope = $d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
  return /* @__PURE__ */ createElement($6cc32821e9371a1c$export$a98f0dcb43a68a25, _extends$z({}, menuScope, radioGroupProps, {
    ref: forwardedRef
  }));
});
const $d08ef79370b62062$export$e4f69b41b1637536 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeDropdownMenu, ...radioItemProps } = props;
  const menuScope = $d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
  return /* @__PURE__ */ createElement($6cc32821e9371a1c$export$371ab307eab489c0, _extends$z({}, menuScope, radioItemProps, {
    ref: forwardedRef
  }));
});
const $d08ef79370b62062$export$42355ae145153fb6 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeDropdownMenu, ...itemIndicatorProps } = props;
  const menuScope = $d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
  return /* @__PURE__ */ createElement($6cc32821e9371a1c$export$c3468e2714d175fa, _extends$z({}, menuScope, itemIndicatorProps, {
    ref: forwardedRef
  }));
});
const $d08ef79370b62062$export$da160178fd3bc7e9 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeDropdownMenu, ...separatorProps } = props;
  const menuScope = $d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
  return /* @__PURE__ */ createElement($6cc32821e9371a1c$export$1ff3c3f08ae963c0, _extends$z({}, menuScope, separatorProps, {
    ref: forwardedRef
  }));
});
const $d08ef79370b62062$export$2f307d81a64f5442 = (props) => {
  const { __scopeDropdownMenu, children, open: openProp, onOpenChange, defaultOpen } = props;
  const menuScope = $d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
  const [open = false, setOpen] = $71cd76cc60e0454e$export$6f32135080cb4c3$1({
    prop: openProp,
    defaultProp: defaultOpen,
    onChange: onOpenChange
  });
  return /* @__PURE__ */ createElement($6cc32821e9371a1c$export$d7a01e11500dfb6f, _extends$z({}, menuScope, {
    open,
    onOpenChange: setOpen
  }), children);
};
const $d08ef79370b62062$export$21dcb7ec56f874cf = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeDropdownMenu, ...subTriggerProps } = props;
  const menuScope = $d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
  return /* @__PURE__ */ createElement($6cc32821e9371a1c$export$2ea8a7a591ac5eac, _extends$z({}, menuScope, subTriggerProps, {
    ref: forwardedRef
  }));
});
const $d08ef79370b62062$export$f34ec8bc2482cc5f = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeDropdownMenu, ...subContentProps } = props;
  const menuScope = $d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
  return /* @__PURE__ */ createElement($6cc32821e9371a1c$export$6d4de93b380beddf, _extends$z({}, menuScope, subContentProps, {
    ref: forwardedRef,
    style: {
      ...props.style,
      // re-namespace exposed content custom property
      ["--radix-dropdown-menu-content-transform-origin"]: "var(--radix-popper-transform-origin)"
    }
  }));
});
const $d08ef79370b62062$export$be92b6f5f03c0fe9 = $d08ef79370b62062$export$e44a253a59704894;
const $d08ef79370b62062$export$41fb9f06171c75f4 = $d08ef79370b62062$export$d2469213b3befba9;
const $d08ef79370b62062$export$602eac185826482c = $d08ef79370b62062$export$cd369b4d4d54efc9;
const $d08ef79370b62062$export$7c6e2c02157bb7d2 = $d08ef79370b62062$export$6e76d93a37c01248;
const $d08ef79370b62062$export$b04be29aa201d4f5 = $d08ef79370b62062$export$76e48c5b57f24495;
const $d08ef79370b62062$export$6d08773d2e66f8f2 = $d08ef79370b62062$export$ed97964d1871885d;
const $d08ef79370b62062$export$16ce288f89fa631c = $d08ef79370b62062$export$53a69729da201fa9;
const $d08ef79370b62062$export$a98f0dcb43a68a25 = $d08ef79370b62062$export$3323ad73d55f587e;
const $d08ef79370b62062$export$371ab307eab489c0 = $d08ef79370b62062$export$e4f69b41b1637536;
const $d08ef79370b62062$export$c3468e2714d175fa = $d08ef79370b62062$export$42355ae145153fb6;
const $d08ef79370b62062$export$1ff3c3f08ae963c0 = $d08ef79370b62062$export$da160178fd3bc7e9;
const $d08ef79370b62062$export$d7a01e11500dfb6f = $d08ef79370b62062$export$2f307d81a64f5442;
const $d08ef79370b62062$export$2ea8a7a591ac5eac = $d08ef79370b62062$export$21dcb7ec56f874cf;
const $d08ef79370b62062$export$6d4de93b380beddf = $d08ef79370b62062$export$f34ec8bc2482cc5f;
const Content$2 = React.forwardRef(function MenuContent(props, ref) {
  const internalRef = useMergedRef(ref);
  const menu = useCurrentMenu();
  const { align = "start", children, placement: side, ...otherProps } = props;
  const className = clsx("border border-transparent rounded block outline-none p-1 yt-shadow wcag-white", props.className);
  const childrenRefs = React.useRef([]);
  const childrenWithRefs = React.Children.toArray(props.children).filter((child) => !!child).map((child, index2) => {
    childrenRefs.current[index2] = React.createRef();
    return React.cloneElement(child, { ref: childrenRefs.current[index2] });
  });
  React.useEffect(() => {
    const shortcuts = [];
    childrenWithRefs.forEach((child, index2) => {
      if (child.props.shortcut) {
        shortcuts.push(
          createShortcutKeyDownHandler(child.props.shortcut, (event) => {
            event.preventDefault();
            const dialog = document.querySelector('[role="dialog"]');
            if (dialog && !(dialog == null ? void 0 : dialog.contains(internalRef.current))) {
              return;
            }
            menu == null ? void 0 : menu.open();
            setTimeout(() => {
              var _a, _b;
              return (_b = (_a = childrenRefs.current[index2]) == null ? void 0 : _a.current) == null ? void 0 : _b.click();
            }, 1);
          })
        );
      }
    });
    shortcuts.forEach((handler) => document.addEventListener("keydown", handler));
    return () => {
      shortcuts.forEach((handler) => document.removeEventListener("keydown", handler));
    };
  }, [childrenWithRefs]);
  return /* @__PURE__ */ React.createElement($d08ef79370b62062$export$602eac185826482c, null, /* @__PURE__ */ React.createElement(
    $d08ef79370b62062$export$7c6e2c02157bb7d2,
    {
      ...otherProps,
      align,
      className,
      "data-taco": "menu",
      side,
      sideOffset: 3,
      style: { minWidth: menu == null ? void 0 : menu.minWidth },
      ref: internalRef
    },
    childrenWithRefs
  ));
});
const replaceWithShortform = (key) => {
  switch (key) {
    case "Escape":
      return "Esc";
    case "Delete":
      return "Del";
    case "Space":
    case " ":
      return "Space";
    case "ArrowLeft":
      return "◄";
    case "ArrowRight":
      return "►";
    case "ArrowUp":
      return "▲";
    case "ArrowDown":
      return "▼";
    default:
      return key.length === 1 ? key.toLocaleUpperCase() : key;
  }
};
const getShortcutText = (key) => {
  if (!key) {
    return [];
  }
  if (typeof key === "string") {
    return [replaceWithShortform(key)];
  }
  const keys2 = [];
  if (key.shift) {
    keys2.push(isMacOs() ? "⇧" : "Shift");
  }
  if (key.meta) {
    keys2.push(isMacOs() ? "⌘" : "Ctrl");
  }
  keys2.push(replaceWithShortform(key.key));
  return keys2;
};
const Shortcut = ({ keys: keys2, ...props }) => {
  const className = clsx("inline-flex gap-0.5", props.className);
  const texts = getShortcutText(keys2);
  return /* @__PURE__ */ React__default.createElement("span", { ...props, className }, texts.map((key) => /* @__PURE__ */ React__default.createElement(
    "kbd",
    {
      key,
      className: "font-display text-grey-700 [[data-taco=tooltip]_&]:bg-grey-300/[0.25] rounded-sm bg-black/[0.09] px-1 text-center font-bold [[data-appearance=danger]_&]:text-white [[data-appearance=primary]_&]:text-white [[data-taco=tooltip]_&]:text-white"
    },
    key
  )));
};
const Icon = ({ name }) => /* @__PURE__ */ React.createElement("span", { className: "absolute left-0 ml-1" }, /* @__PURE__ */ React.createElement(Icon$1, { className: "-ml-px -mt-px !h-5 !w-5", name }));
const useItemStyling = ({
  disabled,
  indented,
  className
}) => {
  const menu = useCurrentMenu();
  React.useEffect(() => {
    if (indented && !(menu == null ? void 0 : menu.indented)) {
      menu == null ? void 0 : menu.registerIndentation();
    }
  }, [indented]);
  return clsx(
    "flex items-center justify-start h-8 pr-1.5 relative rounded w-full focus:outline-none group",
    {
      "pl-7": menu == null ? void 0 : menu.indented,
      "pl-1.5": !(menu == null ? void 0 : menu.indented),
      "cursor-pointer text-black hover:wcag-grey-200 data-[highlighted]:wcag-grey-200": !disabled,
      "cursor-not-allowed hover:bg-white text-grey-300": disabled
    },
    className
  );
};
const Item$2 = React.forwardRef(function MenuItem(props, ref) {
  const { dialog, icon, onClick, popover, shortcut: shortcut2, subMenu, ...otherProps } = props;
  const menu = useCurrentMenu();
  const className = useItemStyling({
    disabled: props.disabled,
    indented: !!icon,
    className: props.className
  });
  const disabled = props.disabled ?? props["aria-disabled"];
  let handleClick;
  if (disabled) {
    handleClick = (event) => {
      event.preventDefault();
      event.stopPropagation();
    };
  }
  if (subMenu) {
    return /* @__PURE__ */ React.createElement($d08ef79370b62062$export$d7a01e11500dfb6f, null, /* @__PURE__ */ React.createElement($d08ef79370b62062$export$2ea8a7a591ac5eac, { ...otherProps, className, onClick: handleClick, ref }, icon ? /* @__PURE__ */ React.createElement(Icon, { name: icon }) : null, props.children, /* @__PURE__ */ React.createElement(Icon$1, { className: "-mr-1.5 ml-auto !h-5 !w-5", name: "chevron-right" })), subMenu());
  }
  const handleSelect = (event) => {
    if (onClick) {
      onClick(event);
    }
    if (props["aria-haspopup"] || typeof dialog === "function" || typeof popover === "function") {
      event.preventDefault();
    }
  };
  let button = /* @__PURE__ */ React.createElement($d08ef79370b62062$export$6d08773d2e66f8f2, { ...otherProps, className, onClick: handleClick, onSelect: handleSelect, ref }, icon ? /* @__PURE__ */ React.createElement(Icon, { name: icon }) : null, props.children, shortcut2 ? /* @__PURE__ */ React.createElement("span", { className: "ml-auto pl-5" }, /* @__PURE__ */ React.createElement(Shortcut, { keys: shortcut2, className: "text-grey-700" })) : null);
  if (typeof dialog === "function") {
    button = dialog({ trigger: button, onClose: menu == null ? void 0 : menu.close });
  } else if (typeof popover === "function") {
    button = popover({ trigger: button });
  }
  return button;
});
const Link$2 = React.forwardRef(function MenuLink(props, ref) {
  const { href, icon, onClick, ...otherProps } = props;
  const menu = useCurrentMenu();
  const className = useItemStyling({
    disabled: props.disabled,
    indented: !!icon,
    className: props.className
  });
  const handleClick = (event) => {
    onClick == null ? void 0 : onClick(event);
    menu == null ? void 0 : menu.close();
  };
  return /* @__PURE__ */ React.createElement($d08ef79370b62062$export$6d08773d2e66f8f2, { ...otherProps, asChild: true, className, ref, onClick: handleClick }, /* @__PURE__ */ React.createElement("a", { href, target: "_blank" }, icon && /* @__PURE__ */ React.createElement(Icon, { name: icon }), props.children));
});
const Trigger$1 = React.forwardRef(function MenuTrigger(props, ref) {
  const menu = useCurrentMenu();
  const internalRef = useMergedRef(ref);
  const handleKeyDown = (event) => {
    var _a;
    if (event.key === "ArrowDown") {
      if (isElementInsideTable3OrReport(event.currentTarget)) {
        event.preventDefault();
        (_a = event.currentTarget.parentNode) == null ? void 0 : _a.dispatchEvent(
          createCustomKeyboardEvent(event)
        );
      }
    }
  };
  React.useEffect(() => {
    if (internalRef.current) {
      menu == null ? void 0 : menu.setMinWidth(internalRef.current.getBoundingClientRect().width);
    }
  }, [internalRef]);
  return /* @__PURE__ */ React.createElement($d08ef79370b62062$export$41fb9f06171c75f4, { ...props, asChild: true, ref: internalRef, onKeyDown: handleKeyDown });
});
const Checkbox = React.forwardRef(function MenuCheckboxItem(props, ref) {
  const { checked, children, onChange, ...otherProps } = props;
  const className = useItemStyling({
    disabled: props.disabled,
    indented: true,
    className: props.className
  });
  return /* @__PURE__ */ React.createElement(
    $d08ef79370b62062$export$16ce288f89fa631c,
    {
      ...otherProps,
      checked,
      className,
      onCheckedChange: onChange,
      ref
    },
    /* @__PURE__ */ React.createElement($d08ef79370b62062$export$c3468e2714d175fa, { className: "absolute left-0 ml-1.5" }, /* @__PURE__ */ React.createElement(Icon$1, { name: "tick", className: "-ml-px !h-4 !w-4" })),
    children
  );
});
const getRadioItemByValue = (values, valueAsString) => values.find((value) => String(value) === valueAsString);
const MenuRadioGroupContext = React.createContext({});
const RadioItem = (props) => {
  const { children, disabled, value, ...otherProps } = props;
  const context = React.useContext(MenuRadioGroupContext);
  const isDisabled = context.disabled || disabled;
  const className = useItemStyling({
    disabled: isDisabled,
    indented: true,
    className: props.className
  });
  return /* @__PURE__ */ React.createElement($d08ef79370b62062$export$371ab307eab489c0, { ...otherProps, className, disabled: isDisabled, value: String(value ?? "") }, /* @__PURE__ */ React.createElement($d08ef79370b62062$export$c3468e2714d175fa, { className: "absolute left-0 ml-1.5" }, /* @__PURE__ */ React.createElement("span", { className: "ml-1 flex h-1.5 w-1.5 rounded-full bg-current" })), children);
};
const RadioGroup$1 = React.forwardRef(function MenuRadioItem(props, ref) {
  const values = React.useMemo(() => {
    const radioGroupItemValues = [];
    React.Children.forEach(props.children, (child) => {
      if (React.isValidElement(child)) {
        radioGroupItemValues.push(child.props.value);
      }
    });
    return radioGroupItemValues;
  }, [props.children]);
  const handleChange = (value2) => props.onChange(getRadioItemByValue(values, value2));
  const value = String(props.value ?? "");
  return /* @__PURE__ */ React.createElement(MenuRadioGroupContext.Provider, { value: { disabled: props.disabled } }, /* @__PURE__ */ React.createElement(
    $d08ef79370b62062$export$a98f0dcb43a68a25,
    {
      ...props,
      className: "flex flex-col",
      onValueChange: handleChange,
      ref,
      value
    }
  ));
});
RadioGroup$1.Item = RadioItem;
const Separator = React.forwardRef(function Separator2(props, ref) {
  return /* @__PURE__ */ React.createElement($d08ef79370b62062$export$1ff3c3f08ae963c0, { className: "bg-grey-300 my-1 h-px", ...props, ref });
});
const Header$6 = React.forwardRef(function MenuHeader(props, ref) {
  const menu = useCurrentMenu();
  const className = clsx(
    "flex items-center justify-start h-7 pr-1.5 text-xs text-grey-700",
    {
      "pl-7": menu == null ? void 0 : menu.indented,
      "pl-1.5": !(menu == null ? void 0 : menu.indented)
    },
    props.className
  );
  return /* @__PURE__ */ React.createElement($d08ef79370b62062$export$b04be29aa201d4f5, { ...props, className, ref });
});
const SubMenu = React.forwardRef(function MenuSubMenu(props, ref) {
  const internalRef = useMergedRef(ref);
  const { children, ...otherProps } = props;
  const className = clsx("border border-transparent rounded block outline-none p-1 yt-shadow wcag-white", props.className);
  return /* @__PURE__ */ React.createElement($d08ef79370b62062$export$602eac185826482c, null, /* @__PURE__ */ React.createElement(
    $d08ef79370b62062$export$6d4de93b380beddf,
    {
      ...otherProps,
      className,
      "data-taco": "menu-submenu",
      sideOffset: 4,
      ref: internalRef
    },
    children
  ));
});
const Menu$1 = React.forwardRef(function Menu2(externalProps, ref) {
  const { children, defaultOpen: defaultProp, onChange, open: prop, trigger, ...props } = externalProps;
  const [indented, setIndented] = React.useState(false);
  const [minWidth, setMinWidth] = React.useState(void 0);
  const [open, setOpen] = $71cd76cc60e0454e$export$6f32135080cb4c3$1({
    // uncontrolled
    defaultProp,
    // controlled
    onChange,
    prop
  });
  const context = React.useMemo(
    () => ({
      indented,
      registerIndentation: () => setIndented(true),
      minWidth,
      setMinWidth: (width) => setMinWidth(width),
      open: () => setOpen(true),
      close: () => setOpen(false)
    }),
    [indented, minWidth]
  );
  return /* @__PURE__ */ React.createElement(MenuContext.Provider, { value: context }, /* @__PURE__ */ React.createElement($d08ef79370b62062$export$be92b6f5f03c0fe9, { ...props, modal: false, open, onOpenChange: setOpen }, trigger && /* @__PURE__ */ React.createElement(Trigger$1, { ref }, trigger), children));
});
Menu$1.Trigger = Trigger$1;
Menu$1.Content = Content$2;
Menu$1.Item = Item$2;
Menu$1.Link = Link$2;
Menu$1.Checkbox = Checkbox;
Menu$1.Separator = Separator;
Menu$1.Header = Header$6;
Menu$1.RadioGroup = RadioGroup$1;
Menu$1.SubMenu = SubMenu;
const ModeSwitch = React.forwardRef(function ModeSwitch2(props, ref) {
  const { onChange, ...otherProps } = props;
  const className = clsx(
    "group w-14 h-8 flex flex-shrink-0 rounded-full inline-flex focus-visible:yt-focus p-1",
    {
      "bg-grey-500 hover:bg-grey-700 aria-checked:bg-blue-500 aria-checked:hover:bg-blue-700": !props.disabled,
      "bg-grey-500 aria-checked:bg-blue-500 cursor-not-allowed opacity-50": props.disabled
    },
    props.className
  );
  return /* @__PURE__ */ React.createElement($6be4966fd9bbc698$export$be92b6f5f03c0fe9, { ...otherProps, className, "data-taco": "mode", onCheckedChange: onChange, ref }, /* @__PURE__ */ React.createElement($6be4966fd9bbc698$export$6521433ed15a34db, { className: "pointer-events-none flex h-6 w-6 items-center justify-center rounded-full bg-white transition-transform will-change-transform group-disabled:opacity-50 group-aria-checked:translate-x-[100%]" }, /* @__PURE__ */ React.createElement(Icon$1, { name: "edit-simple", className: "pointer-events-none !h-5 !w-5" })));
});
ModeSwitch.displayName = "ModeSwitch";
const TreeviewItem = React__default.forwardRef(function TreeviewItem2(props, ref) {
  return /* @__PURE__ */ React__default.createElement("a", { ...props, ref });
});
const TreeviewGroup = React__default.forwardRef(function TreeviewGroup2(props, ref) {
  const {
    children,
    className: externalClassName,
    expanded: initialExpanded = false,
    title,
    fixed,
    onClick,
    ...otherProps
  } = props;
  const [expanded, setExpanded] = React__default.useState(fixed || initialExpanded);
  React__default.useEffect(() => {
    if (!fixed) {
      setExpanded(fixed || initialExpanded);
    }
  }, [fixed, initialExpanded]);
  const listClassName = clsx("flex-col mb-0", {
    flex: expanded,
    hidden: !expanded
  });
  const itemProps = {
    ...otherProps,
    "aria-expanded": expanded,
    role: "treeitem",
    tabIndex: -1
  };
  const handleClick = (event) => {
    const nextState = !expanded;
    if (!fixed) {
      setExpanded(nextState);
    }
    if (onClick) {
      onClick(event, nextState);
    }
  };
  const className = typeof externalClassName === "function" ? externalClassName(expanded) : externalClassName;
  return /* @__PURE__ */ React__default.createElement("div", { ...itemProps, className, ref }, /* @__PURE__ */ React__default.createElement("div", { onClick: handleClick }, typeof title === "function" ? title(expanded) : title), /* @__PURE__ */ React__default.createElement("ul", { role: "group", className: listClassName }, React__default.Children.toArray(children).filter((item) => !!item).map((item, i3) => /* @__PURE__ */ React__default.createElement("li", { key: i3, role: "none" }, React__default.cloneElement(item, { role: "treeitem" })))));
});
const Treeview = React__default.forwardRef(function Treeview2(props, ref) {
  return /* @__PURE__ */ React__default.createElement("div", { ...props, ref, role: "tree" });
});
Treeview.Group = TreeviewGroup;
Treeview.Item = TreeviewItem;
const useDropTarget = (onDrop) => {
  const [isDraggedOver, setDraggedOver] = React__default.useState(false);
  const handleDragEnter = React__default.useCallback((event) => {
    event.preventDefault();
    setDraggedOver(true);
  }, []);
  const handleDragLeave = React__default.useCallback((event) => {
    event.preventDefault();
    if (event.target === event.currentTarget || event.relatedTarget && !event.currentTarget.contains(event.relatedTarget)) {
      setDraggedOver(false);
    }
  }, []);
  const handleDragOver = React__default.useCallback((event) => {
    event.preventDefault();
  }, []);
  const handleDrop = React__default.useCallback(
    (event) => {
      event.preventDefault();
      event.persist();
      setDraggedOver(false);
      if (onDrop) {
        onDrop(event);
      }
    },
    [onDrop]
  );
  const props = onDrop ? {
    onDragEnter: handleDragEnter,
    onDragLeave: handleDragLeave,
    onDragOver: handleDragOver,
    onDrop: handleDrop
  } : void 0;
  return [isDraggedOver, props];
};
const Item$1 = React__default.forwardRef(function Item22(props, ref) {
  const { active, children, onDrop, postfix, prefix: prefix2, role, ...otherProps } = props;
  const proxyRef = useMergedRef(ref);
  const [isDraggedOver, dropTargetProps] = useDropTarget(onDrop);
  const isTreeitem = role === "treeitem";
  const className = clsx(
    "yt-navigation__item cursor-pointer",
    {
      "w-full mb-px py-1 px-3 flex items-center hover:bg-grey-300": isTreeitem,
      "bg-white w-full h-10 px-3 flex-shrink-0 flex items-center justify-between cursor-pointer": !isTreeitem,
      "yt-navigation__item--active": active && !isDraggedOver,
      "bg-grey-300": isTreeitem && active && !isDraggedOver,
      "yt-navigation__item--dropping bg-blue-500": isDraggedOver
    },
    props.className
  );
  const handleClick = (event) => {
    if (event.target instanceof HTMLAnchorElement || event.target instanceof HTMLButtonElement) {
      return;
    }
    if (proxyRef.current) {
      proxyRef.current.click();
    }
  };
  return /* @__PURE__ */ React__default.createElement("span", { ...dropTargetProps, className, onClick: handleClick, role }, prefix2 && /* @__PURE__ */ React__default.createElement("span", { className: "yt-navigation__item__prefix flex items-center" }, prefix2), /* @__PURE__ */ React__default.createElement("a", { ...otherProps, className: "block flex-grow truncate", ref: proxyRef }, children), postfix && /* @__PURE__ */ React__default.createElement("span", { className: "yt-navigation__item__postfix ml-1" }, postfix));
});
const Panel = React__default.forwardRef(function Panel2(props, ref) {
  return /* @__PURE__ */ React__default.createElement("div", { ...props, className: clsx("w-full bg-white p-3", props.className), ref });
});
const MenuGroup = React__default.forwardRef(function MenuGroup2(props, ref) {
  const className = clsx(
    "flex-shrink-0 space-y-1 outline-none",
    {
      "bg-white pb-2": props.fixed
    },
    typeof props.className === "function" ? props.className(false) : props.className
  );
  const title = (expanded) => {
    const className2 = clsx("bg-white h-10 pl-3 pr-1 flex items-center justify-between w-full", {
      "mb-1": expanded,
      "cursor-pointer hover:text-blue-500": !props.fixed
    });
    return /* @__PURE__ */ React__default.createElement("span", { className: className2 }, typeof props.title === "function" ? props.title(expanded) : props.title, !props.fixed && /* @__PURE__ */ React__default.createElement(Icon$1, { name: expanded ? "chevron-up" : "chevron-down" }));
  };
  return /* @__PURE__ */ React__default.createElement(Treeview.Group, { ...props, className, title, ref });
});
const Menu = React__default.forwardRef(function Menu22(props, ref) {
  const scrollableAreas = React__default.useMemo(() => {
    const scrollableAreas2 = [];
    const children = React__default.Children.toArray(props.children).filter(
      (child) => !!child
    );
    children.forEach((child) => {
      if (child.props.fixed) {
        scrollableAreas2.push(child);
      } else {
        const x3 = scrollableAreas2[scrollableAreas2.length - 1];
        if (Array.isArray(x3)) {
          x3.push(child);
        } else {
          scrollableAreas2.push([child]);
        }
      }
    });
    return scrollableAreas2;
  }, [props.children]);
  return /* @__PURE__ */ React__default.createElement(
    Treeview,
    {
      ...props,
      className: clsx("divide-grey-100 flex flex-grow flex-col divide-y-2 overflow-y-auto", props.className),
      ref
    },
    scrollableAreas.map(
      (area, i3) => Array.isArray(area) ? /* @__PURE__ */ React__default.createElement(
        "div",
        {
          className: "divide-grey-100 flex h-0 flex-auto flex-shrink-0 flex-grow flex-col divide-y-2 overflow-y-auto",
          key: i3
        },
        area
      ) : area
    )
  );
});
Menu.Group = MenuGroup;
const Navigation = React__default.forwardRef(function Navigation2(props, ref) {
  const { children, ...otherProps } = props;
  const className = clsx("h-full flex flex-col bg-grey-100 divide-y-2 divide-grey-100", props.className);
  return /* @__PURE__ */ React__default.createElement("div", { ...otherProps, className, "data-taco": "navigation", ref }, children);
});
Navigation.Menu = Menu;
Navigation.Item = Item$1;
Navigation.Panel = Panel;
const useIntersectionObserver = (ref, offset2) => {
  const [intersectedIndexes, setIntersectedIndexes] = React__default.useState({});
  const handleIntersection = (entries, observer) => {
    if (observer.root) {
      const children = Array.from(observer.root.children);
      const map2 = {};
      entries.forEach((entry) => {
        map2[children.indexOf(entry.target)] = entry.isIntersecting;
      });
      setIntersectedIndexes((prev) => ({ ...prev, ...map2 }));
    }
  };
  const intersectedChildIndex = React__default.useMemo(() => {
    const index2 = Object.values(intersectedIndexes).indexOf(false);
    return index2 > -1 ? index2 : void 0;
  }, [intersectedIndexes]);
  const hasRootMargin = intersectedChildIndex !== void 0 && offset2;
  React__default.useEffect(() => {
    const observer = new IntersectionObserver(handleIntersection, {
      root: ref.current,
      // offset the button, but only after the first item has been intersected
      rootMargin: hasRootMargin ? `0px -${offset2}px 0px 0px` : void 0,
      threshold: 1
    });
    if (observer.root) {
      Array.from(observer.root.children).forEach((item) => {
        if (!item.hasAttribute("data-observer-ignore")) {
          observer.observe(item);
        }
      });
    }
    return () => {
      observer.disconnect();
    };
  }, [hasRootMargin]);
  return intersectedChildIndex;
};
const sanitizeButtonPropsForMenuItem = (button, index2) => {
  const href = button.props.to || button.props.href;
  const Tag2 = href ? Menu$1.Link : Menu$1.Item;
  const {
    as,
    className: _,
    appearance: _1,
    drawer: _2,
    fluid: _3,
    hanger: _4,
    menu: _5,
    popover: _6,
    tooltip: _7,
    ...attributes
  } = button.props;
  const props = {
    ...attributes,
    key: index2,
    target: href ? href.startsWith("http") ? "_blank" : "_self" : void 0
  };
  if (as) {
    return React__default.cloneElement(button, { as: Tag2, ...props });
  }
  return /* @__PURE__ */ React__default.createElement(Tag2, { ...props });
};
const DEFAULT_OFFSET = 32 + 8;
const OverflowGroup = React__default.forwardRef(function OverflowGroup2(props, ref) {
  const { moreButton, wrapChild, ...attributes } = props;
  const internalRef = useMergedRef(ref);
  const [buttonWidth, setButtonWidth] = React__default.useState(DEFAULT_OFFSET);
  const buttonRefCallback = React__default.useCallback((el) => {
    var _a;
    return setButtonWidth((_a = el == null ? void 0 : el.getBoundingClientRect()) == null ? void 0 : _a.width);
  }, []);
  const { texts } = useLocalization();
  const intersectedChildIndex = useIntersectionObserver(internalRef, buttonWidth);
  const children = React__default.Children.toArray(props.children);
  const hiddenChildren = intersectedChildIndex !== void 0 ? children.slice(intersectedChildIndex) : [];
  const hiddenChildrenCount = hiddenChildren.length;
  const moreButtonText = hiddenChildrenCount ? `${hiddenChildrenCount} ${texts.header.more}` : "";
  const MoreButton = (moreButton == null ? void 0 : moreButton(moreButtonText)) ?? /* @__PURE__ */ React__default.createElement(IconButton, { icon: "more" });
  const className = clsx("flex overflow-hidden", props.className);
  return /* @__PURE__ */ React__default.createElement("div", { ...attributes, className, "data-taco": "overflow-group", ref: internalRef }, children.map(
    (child, index2) => React__default.cloneElement(child, {
      className: clsx(child.props.className, {
        visible: intersectedChildIndex === void 0 || index2 < intersectedChildIndex,
        "invisible order-[100] pointer-events-none": intersectedChildIndex !== void 0 && index2 >= intersectedChildIndex
      })
    })
  ), hiddenChildren.length ? React__default.cloneElement(MoreButton, {
    className: clsx("sticky right-0 order-[99]", MoreButton.props.className),
    "data-observer-ignore": true,
    menu: (menuProps) => /* @__PURE__ */ React__default.createElement(Menu$1, { ...menuProps }, /* @__PURE__ */ React__default.createElement(Menu$1.Content, null, hiddenChildren.map(
      (child, index2) => wrapChild ? /* @__PURE__ */ React__default.createElement(Menu$1.Item, { key: index2 }, child) : sanitizeButtonPropsForMenuItem(child, index2)
    ))),
    ref: buttonRefCallback
  }) : null);
});
const createPageRange = (pageCount, pageNumber) => {
  let lowerLimit = Math.min(pageNumber, pageCount);
  let upperLimit = Math.min(pageNumber, pageCount);
  for (let b3 = 1; b3 < 5 && b3 < pageCount; ) {
    if (lowerLimit > 1) {
      lowerLimit--;
      b3++;
    }
    if (b3 < 5 && upperLimit < pageCount) {
      upperLimit++;
      b3++;
    }
  }
  const range3 = [];
  for (let i3 = lowerLimit; i3 <= upperLimit; i3++) {
    range3.push(i3);
  }
  return range3;
};
const PageNumbers = ({ currentPageIndex = 0, onClick: handleClick, pageCount }) => {
  const range3 = createPageRange(pageCount, currentPageIndex + 1);
  const { texts } = useLocalization();
  return /* @__PURE__ */ React.createElement(React.Fragment, null, range3.map((pageNumber) => /* @__PURE__ */ React.createElement(
    Button$4,
    {
      appearance: pageNumber === currentPageIndex + 1 ? "primary" : "default",
      "aria-current": pageNumber === currentPageIndex + 1 ? "page" : void 0,
      key: pageNumber,
      onClick: () => handleClick(pageNumber - 1),
      "aria-label": texts.pagination.actions.pageX.replace("[X]", String(pageNumber)),
      tooltip: texts.pagination.actions.pageX.replace("[X]", String(pageNumber))
    },
    pageNumber
  )));
};
const useSelect = ({
  "aria-label": ariaLabel,
  "aria-labelledby": ariaLabelledBy,
  data = [],
  defaultValue: defaultValue2,
  disabled,
  emptyValue,
  id: nativeId,
  multiselect,
  onBlur,
  onClick,
  onChange,
  readOnly,
  tabIndex,
  value,
  ...otherProps
}, ref) => {
  var _a;
  const { texts } = useLocalization();
  const flattenedData = useFlattenedData(data);
  const listboxInputRef = useMergedRef(ref);
  const [open, setOpen] = React.useState(false);
  const id2 = React.useMemo(() => nativeId || `select_${nanoid()}`, [nativeId]);
  const inputRef = React.useRef(null);
  const buttonId = `${id2}-button`;
  const [lastValue, setLastValue] = React.useState(value);
  React.useEffect(() => {
    setLastValue(value);
  }, [open]);
  React.useEffect(() => {
    if (value === void 0) {
      if (defaultValue2 !== void 0 && findByValue(flattenedData, defaultValue2)) {
        setInputValueByRef(inputRef.current, defaultValue2);
      } else {
        if (emptyValue !== void 0) {
          setInputValueByRef(inputRef.current, emptyValue);
        } else if (data.length > 0) {
          setInputValueByRef(inputRef.current, data[0].value);
        }
      }
    } else {
      if (!multiselect && !findByValue(flattenedData, value)) {
        if (emptyValue !== void 0) {
          setInputValueByRef(inputRef.current, emptyValue);
        } else if (data.length > 0) {
          setInputValueByRef(inputRef.current, data[0].value);
        }
      }
    }
  }, []);
  const handleButtonKeyDown = (event) => {
    if (event.key === "ArrowUp" || event.key === "ArrowDown") {
      event.preventDefault();
      setOpen(true);
    }
  };
  const handleListboxKeyDown = (event) => {
    switch (event.key) {
      case "Escape": {
        event.preventDefault();
        if (lastValue !== void 0) {
          setInputValueByRef(listboxInputRef.current, lastValue);
        }
        setOpen(false);
        break;
      }
      case "Tab":
      case "Enter": {
        if (event.key !== "Tab") {
          event.preventDefault();
        }
        setOpen(false);
        break;
      }
    }
    if (otherProps.onKeyDown) {
      otherProps.onKeyDown(event);
    }
  };
  const handleListboxClick = (event) => {
    event.preventDefault();
    if (!multiselect) {
      setOpen(false);
      if (onBlur) {
        onBlur(createCustomEvent("blur"));
      }
    }
  };
  let text2 = "";
  let more = 0;
  if (value !== void 0) {
    if (multiselect) {
      const selectedValues = (value == null ? void 0 : value.toString().split(",")) || [];
      if (selectedValues.length === flattenedData.filter((item) => !item.disabled).length) {
        text2 = texts.select.allOptionsSelected;
      } else {
        text2 = ((_a = findByValue(flattenedData, selectedValues[0])) == null ? void 0 : _a.text) ?? "";
        more = selectedValues.length > 1 ? selectedValues.length - 1 : 0;
      }
    } else {
      const item = findByValue(flattenedData, value);
      if (item) {
        text2 = item.icon ? /* @__PURE__ */ React.createElement(React.Fragment, null, React.cloneElement(item.icon, {
          className: clsx(item.icon.props.className, "mr-1 -mt-px")
        }), item.text) : item.text;
      }
    }
  }
  const handleInputChange = (event) => {
    var _a2;
    event.persist();
    if (onChange) {
      const item = findByValue(flattenedData, event.target.value);
      event.detail = sanitizeItem(item);
      const indexes = ((_a2 = item == null ? void 0 : item.path) == null ? void 0 : _a2.split(".")) ?? [];
      if (indexes.length > 1) {
        indexes.pop();
        let lastPath;
        event.detail.parents = indexes.map((i3) => {
          lastPath = lastPath ? [lastPath, i3].join(".") : i3;
          return sanitizeItem(flattenedData.find((i22) => i22.path === lastPath));
        });
      }
      onChange(event);
    }
  };
  const handleButtonClick = (event) => {
    if (readOnly) {
      event.preventDefault();
    }
  };
  const handleButtonFocus = (event) => {
    var _a2, _b;
    if (readOnly) {
      const value2 = event.currentTarget.querySelector(":first-child");
      if (value2) {
        (_b = (_a2 = window.getSelection()) == null ? void 0 : _a2.selectAllChildren) == null ? void 0 : _b.call(_a2, value2);
      }
    }
  };
  const button = {
    "aria-haspopup": "listbox",
    "aria-label": ariaLabel ? `${ariaLabel} ${text2}` : void 0,
    "aria-labelledby": ariaLabelledBy ? `${ariaLabelledBy} ${buttonId}` : void 0,
    "aria-readonly": readOnly ? "true" : void 0,
    disabled,
    id: buttonId,
    onClick: handleButtonClick,
    onFocus: handleButtonFocus,
    onKeyDown: !disabled && !readOnly ? handleButtonKeyDown : void 0,
    tabIndex,
    type: "button"
  };
  const listbox = {
    ...otherProps,
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy,
    data,
    disabled,
    emptyValue,
    onBlur,
    onClick: handleListboxClick,
    onChange: (event) => {
      setInputValueByRef(inputRef.current, event.target.value);
    },
    onKeyDown: handleListboxKeyDown,
    ref: listboxInputRef,
    value
  };
  const input = {
    onChange: handleInputChange,
    ref: inputRef,
    value: String(value ?? "")
  };
  return {
    button,
    listbox,
    input,
    popover: {
      open,
      onOpenChange: (open2) => {
        if (!open2 && onBlur) {
          onBlur(createCustomEvent("blur"));
        }
        setOpen(open2);
      }
    },
    text: text2,
    more
  };
};
const BaseSelect = React.forwardRef(function BaseSelect2(props, ref) {
  const { autoFocus, className: externalClassName, highlighted, style, ...otherProps } = props;
  const { button, listbox, popover, input, text: text2, more = 0 } = useSelect(otherProps, ref);
  const internalRef = React.useRef(null);
  const selectDimensions = useBoundingClientRectListener(internalRef);
  const className = clsx("inline-flex relative w-full", { "yt-select--readonly": props.readOnly }, externalClassName);
  const inputClassname = clsx(getInputClasses(props), "h-8 text-left !pr-0", {
    "border-blue-500": popover.open,
    "select-text": otherProps.readOnly
  });
  React.useEffect(() => {
    if (autoFocus && internalRef.current) {
      internalRef.current.focus();
    }
  }, []);
  const renderMultiSelection = () => {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("span", { className: "flex-grow truncate text-left" }, text2), more > 0 && /* @__PURE__ */ React.createElement(Badge2, { className: "ml-2" }, `+${more}`));
  };
  const commonListboxProps = {
    ...listbox,
    className: "w-auto",
    invalid: void 0,
    style: { minWidth: selectDimensions == null ? void 0 : selectDimensions.width },
    tabIndex: popover.open ? 0 : -1
  };
  return /* @__PURE__ */ React.createElement("span", { className, "data-taco": "select", style }, /* @__PURE__ */ React.createElement($cb5cc270b50c6fcd$export$be92b6f5f03c0fe9, { ...popover }, /* @__PURE__ */ React.createElement($cb5cc270b50c6fcd$export$41fb9f06171c75f4, { ...button, className: inputClassname, ref: internalRef }, props.multiselect ? renderMultiSelection() : /* @__PURE__ */ React.createElement("span", { className: "flex-grow truncate text-left" }, text2), /* @__PURE__ */ React.createElement("span", { className: "flex h-8 w-8 items-center justify-center" }, /* @__PURE__ */ React.createElement(Icon$1, { className: "pointer-events-none", name: popover.open ? "chevron-up" : "chevron-down" }))), /* @__PURE__ */ React.createElement($cb5cc270b50c6fcd$export$602eac185826482c, null, /* @__PURE__ */ React.createElement($cb5cc270b50c6fcd$export$7c6e2c02157bb7d2, { align: "start", sideOffset: 4 }, props.multiselect ? /* @__PURE__ */ React.createElement(MultiListbox, { ...commonListboxProps }) : /* @__PURE__ */ React.createElement(Listbox, { ...commonListboxProps }))), /* @__PURE__ */ React.createElement("input", { ...input, className: "hidden", type: "text" })));
});
const Select = React.forwardRef(function Select2(props, ref) {
  const { editable, ...otherProps } = props;
  if (editable) {
    return /* @__PURE__ */ React.createElement(Combobox, { ...otherProps, dialog: void 0, inline: true, ref });
  }
  return /* @__PURE__ */ React.createElement(BaseSelect, { ...otherProps, ref });
});
const usePaginationShortcuts = ({
  setPageIndex,
  maxPageIndex,
  pageIndex,
  dangerouslyHijackGlobalKeyboardNavigation: useGlobalKeyboardNavigation
}) => {
  const onKeyDown = (event) => {
    if (setPageIndex && event.key === "Home") {
      event.preventDefault();
      setPageIndex(0);
      return;
    }
    if (setPageIndex && event.key === "End") {
      event.preventDefault();
      setPageIndex(maxPageIndex);
      return;
    }
    if (setPageIndex && event.key === "PageUp") {
      event.preventDefault();
      setPageIndex(Math.max(0, pageIndex - 1));
      return;
    }
    if (setPageIndex && event.key === "PageDown") {
      event.preventDefault();
      setPageIndex(Math.min(maxPageIndex, pageIndex + 1));
      return;
    }
  };
  React__default.useEffect(() => {
    if (useGlobalKeyboardNavigation) {
      window.addEventListener("keydown", onKeyDown);
    }
    return () => {
      if (useGlobalKeyboardNavigation) {
        window.removeEventListener("keydown", onKeyDown);
      }
    };
  }, [onKeyDown, useGlobalKeyboardNavigation]);
};
const usePagination = (initialPageIndex = 0, initialPageSize = 10) => {
  const [pageIndex, setPageIndex] = React__default.useState(initialPageIndex);
  const [pageSize, setPageSize] = React__default.useState(initialPageSize);
  return {
    pageIndex,
    pageSize,
    setPageIndex,
    setPageSize
  };
};
const getShowingLabel = (length, pageIndex, pageSize, texts) => {
  const minItemIndex = pageIndex * pageSize + 1;
  const maxItemIndex = (pageIndex + 1) * pageSize;
  return texts.pagination.showingXofYofTotal.replace("[X]", length === 0 ? "0" : String(minItemIndex)).replace("[Y]", String(maxItemIndex > length ? length : maxItemIndex)).replace("[total]", String(length));
};
const Pagination = React.forwardRef(function Pagination2(props, ref) {
  const {
    length,
    pageIndex,
    pageSize,
    pageSizes = [10, 25, 50, 100, 500],
    setPageIndex,
    setPageSize,
    showPageControls = true,
    showPageNumbers = true,
    showPageSize = true,
    dangerouslyHijackGlobalKeyboardNavigation = false,
    ...otherProps
  } = props;
  const { texts } = useLocalization();
  const maxPageIndex = Math.ceil(length / pageSize) - 1;
  const showShortcutTexts = dangerouslyHijackGlobalKeyboardNavigation;
  usePaginationShortcuts({
    setPageIndex,
    maxPageIndex,
    pageIndex,
    dangerouslyHijackGlobalKeyboardNavigation
  });
  const pageCount = Math.ceil(length / pageSize);
  const canPreviousPage = pageIndex > 0;
  const canNextPage = pageIndex < pageCount - 1;
  const className = clsx("inline-flex relative justify-between items-center", props.className);
  return /* @__PURE__ */ React.createElement("div", { ...otherProps, className, "data-taco": "pagination", ref }, showPageSize && /* @__PURE__ */ React.createElement("span", { className: "mr-4" }, getShowingLabel(length, pageIndex, pageSize, texts), /* @__PURE__ */ React.createElement(
    Select,
    {
      "aria-label": texts.pagination.pageSize,
      className: "ml-4 !w-20",
      data: pageSizes.map((pageSize2) => ({
        text: String(pageSize2),
        value: pageSize2
      })),
      onChange: (event) => {
        setPageIndex(0);
        setPageSize(Number(event.target.value));
      },
      value: pageSize
    }
  )), showPageControls && /* @__PURE__ */ React.createElement(Group$6, { as: "nav", "aria-label": texts.pagination.label }, /* @__PURE__ */ React.createElement(
    IconButton,
    {
      appearance: "default",
      disabled: !canPreviousPage,
      icon: "arrow-start",
      onClick: () => setPageIndex(0),
      "aria-label": showShortcutTexts ? texts.pagination.actions.firstPageWithShortcut : texts.pagination.actions.firstPage,
      tooltip: showShortcutTexts ? texts.pagination.actions.firstPageWithShortcut : texts.pagination.actions.firstPage
    }
  ), /* @__PURE__ */ React.createElement(
    IconButton,
    {
      appearance: "default",
      disabled: !canPreviousPage,
      icon: "arrow-left",
      onClick: () => setPageIndex(pageIndex - 1),
      "aria-label": showShortcutTexts ? texts.pagination.actions.previousPageWithShortcut : texts.pagination.actions.previousPage,
      tooltip: showShortcutTexts ? texts.pagination.actions.previousPageWithShortcut : texts.pagination.actions.previousPage
    }
  ), showPageNumbers && pageCount > 0 && /* @__PURE__ */ React.createElement(PageNumbers, { pageCount, currentPageIndex: pageIndex, onClick: setPageIndex }), /* @__PURE__ */ React.createElement(
    IconButton,
    {
      appearance: "default",
      disabled: !canNextPage,
      icon: "arrow-right",
      onClick: () => setPageIndex(pageIndex + 1),
      "aria-label": showShortcutTexts ? texts.pagination.actions.nextPageWithShortcut : texts.pagination.actions.nextPage,
      tooltip: showShortcutTexts ? texts.pagination.actions.nextPageWithShortcut : texts.pagination.actions.nextPage
    }
  ), /* @__PURE__ */ React.createElement(
    IconButton,
    {
      appearance: "default",
      disabled: !canNextPage,
      icon: "arrow-end",
      onClick: () => setPageIndex(pageCount - 1),
      "aria-label": showShortcutTexts ? texts.pagination.actions.lastPageWithShortcut : texts.pagination.actions.lastPage,
      tooltip: showShortcutTexts ? texts.pagination.actions.lastPageWithShortcut : texts.pagination.actions.lastPage
    }
  )));
});
const Progress = ({ duration = void 0, ...props }) => {
  let style;
  if (duration) {
    style = {
      animationDuration: `${duration}ms`
    };
  }
  const className = clsx("bg-grey-100 rounded block h-1 overflow-hidden w-full", props.className);
  const progressClassName = clsx("yt-progress__bar block h-1", {
    "w-full before:h-1 before:bg-grey-300 before:block before:animate-[progress-indeterminate_2s_cubic-bezier(0.4,0,0.2,1)_infinite] before:content-[' ']": !duration,
    [`w-0 bg-grey-300 animate-[progress_linear]`]: duration
  });
  return /* @__PURE__ */ React__default.createElement("span", { ...props, "data-taco": "progress", className }, /* @__PURE__ */ React__default.createElement("span", { className: progressClassName, "data-taco": "progress-bar", style }));
};
const getBadgeIcon = (type) => {
  return /* @__PURE__ */ React__default.createElement("div", { className: "mr-2 mt-[5px] flex-shrink-0 self-start" }, (() => {
    switch (type) {
      case "success":
        return /* @__PURE__ */ React__default.createElement(BadgeIcon, { icon: "tick", color: "green" });
      case "error":
        return /* @__PURE__ */ React__default.createElement(BadgeIcon, { icon: "close", color: "red" });
      case "warning":
        return /* @__PURE__ */ React__default.createElement(BadgeIcon, { icon: "warning", color: "yellow" });
      case "information":
        return /* @__PURE__ */ React__default.createElement(BadgeIcon, { icon: "info", color: "blue" });
      case "loading":
        return /* @__PURE__ */ React__default.createElement(Spinner, { delay: 0, className: "h-5 w-5" });
      default:
        return null;
    }
  })());
};
const getToastEmptyContentWarning = (content) => `Toast requires 'content' property, which can't be empty string, null or undefined. Current content value is set to ${content === "" ? "empty string" : content}.`;
const Toast = ({ content, lastUpdated, onClose: handleClose, options, ...props }) => {
  const { texts } = useLocalization();
  const { autoClose, type = "default" } = options;
  const className = clsx("bg-white relative flex items-center py-1 px-2 mt-3 w-full rounded yt-shadow print:hidden", {
    "border border-grey-200": type === "default" || type === "loading" || !type,
    "border border-grey-500": type === "success",
    "border border-blue-500": type === "information",
    "border border-yellow-700": type === "warning",
    "border border-red": type === "error"
  });
  const timer = useTimer(autoClose, handleClose);
  const controls = useAnimation();
  if (!content) {
    console.warn(getToastEmptyContentWarning(content));
  }
  React__default.useEffect(() => {
    if (autoClose) {
      timer.start();
    }
  }, [autoClose]);
  const triggerUpdateAnimation = async () => {
    await controls.start({ scale: 1.05 });
    await controls.start({ scale: 1 });
  };
  React__default.useEffect(() => {
    if (lastUpdated) {
      triggerUpdateAnimation();
      if (timer.running) {
        timer.start();
      }
    }
  }, [lastUpdated]);
  return /* @__PURE__ */ React__default.createElement(
    motion.div,
    {
      ...props,
      animate: controls,
      className,
      "data-taco": "toast",
      onMouseEnter: timer.pause,
      onMouseLeave: timer.resume
    },
    getBadgeIcon(type),
    /* @__PURE__ */ React__default.createElement("div", { className: "flex-grow" }, content),
    /* @__PURE__ */ React__default.createElement(
      IconButton,
      {
        appearance: "discrete",
        className: "text-grey-700 -mr-2 cursor-pointer self-start !px-0",
        icon: "close",
        "aria-label": texts.toasts.dismiss,
        onClick: handleClose
      }
    )
  );
};
const DEFAULT_AUTO_CLOSE_TIMEOUT = 7500;
const ToastContext = React.createContext({});
const insertToastWithoutDuplicates = (currentToasts, id2, content, options, close) => {
  const nextToasts = [...currentToasts];
  const existingToastIndex = currentToasts.findIndex((toast) => JSON.stringify(toast.content) === JSON.stringify(content));
  if (existingToastIndex > -1) {
    nextToasts[existingToastIndex].lastDuplicateId = id2;
    nextToasts[existingToastIndex].lastUpdated = Date.now();
  } else {
    nextToasts.push({
      id: id2,
      content: typeof content === "function" ? content(close) : content,
      options
    });
  }
  return nextToasts;
};
const Portal = (props) => {
  var _a;
  const { children, container: containerProp, ...portalProps } = props;
  const [mounted, setMounted] = React.useState(false);
  React.useLayoutEffect(() => setMounted(true), []);
  const container = containerProp || mounted && ((_a = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : _a.body);
  return container ? ReactDOM__default.createPortal(
    /* @__PURE__ */ React.createElement("div", { ...portalProps, "data-taco": "portal" }, children),
    container
  ) : null;
};
const ToastProvider = ({ children, ...props }) => {
  const [toasts, setToasts] = React.useState([]);
  const handleClose = (id2) => {
    setToasts((currentToasts) => currentToasts.filter((toast) => toast.id !== id2));
  };
  const toaster = React.useCallback((content, options) => {
    const id2 = nanoid();
    const close = () => handleClose(id2);
    setToasts((currentToasts) => insertToastWithoutDuplicates(currentToasts, id2, content, options, close));
    const update2 = (content2, options2) => {
      setToasts((currentToasts) => {
        const nextToasts = currentToasts.filter((toast) => {
          if (toast.lastDuplicateId) {
            return toast.lastDuplicateId !== id2;
          }
          return toast.id !== id2;
        });
        return insertToastWithoutDuplicates(nextToasts, nanoid(), content2, options2, close);
      });
    };
    const success = (content2, options2) => {
      update2(content2, { autoClose: DEFAULT_AUTO_CLOSE_TIMEOUT, ...options2, type: "success" });
    };
    const error = (content2, options2) => {
      update2(content2, { ...options2, type: "error" });
    };
    const warning2 = (content2, options2) => {
      update2(content2, { ...options2, type: "warning" });
    };
    const information = (content2, options2) => {
      update2(content2, { ...options2, type: "information" });
    };
    const loading = (content2, options2) => {
      update2(content2, { ...options2, type: "loading" });
    };
    return {
      success,
      error,
      warning: warning2,
      information,
      loading,
      close
    };
  }, []);
  React.useEffect(() => {
    toaster.success = (content, options) => toaster(content, { autoClose: DEFAULT_AUTO_CLOSE_TIMEOUT, ...options, type: "success" });
    toaster.error = (content, options) => toaster(content, { ...options, type: "error" });
    toaster.warning = (content, options) => toaster(content, { ...options, type: "warning" });
    toaster.information = (content, options) => toaster(content, { ...options, type: "information" });
    toaster.loading = (content, options) => toaster(content, { ...options, type: "loading" });
  }, []);
  return /* @__PURE__ */ React.createElement(ToastContext.Provider, { ...props, value: toaster }, children, /* @__PURE__ */ React.createElement(Portal, null, /* @__PURE__ */ React.createElement(
    "div",
    {
      id: "yt-toast__container",
      className: "pointer-events-all absolute !left-auto bottom-0 right-0 z-[1000] mb-4 mr-4 flex max-w-md flex-col items-end justify-end",
      role: "log"
    },
    /* @__PURE__ */ React.createElement(AnimatePresence, { initial: false }, toasts.map((toast) => /* @__PURE__ */ React.createElement(
      motion.div,
      {
        key: toast.id,
        transition: {
          type: "spring",
          damping: 20,
          stiffness: 300
        },
        initial: { opacity: 0, y: 10, scale: 0.5 },
        animate: { opacity: 1, y: 0, scale: 1 },
        exit: { opacity: 0, scale: 0.5, transition: { duration: 0.2 } }
      },
      /* @__PURE__ */ React.createElement(Toast, { ...toast, onClose: () => handleClose(toast.id) })
    )))
  )));
};
const useToast = () => React.useContext(ToastContext);
const TacoContext = React.createContext({
  uniqueUserIdentifier: ""
});
const Provider = (props) => {
  const { children, localization, settings } = props;
  const context = React.useMemo(() => settings, [JSON.stringify(settings)]);
  return /* @__PURE__ */ React.createElement(LocalizationProvider, { localization }, /* @__PURE__ */ React.createElement(TacoContext.Provider, { value: context }, /* @__PURE__ */ React.createElement($a093c7e1ec25a057$export$2881499e37b75b9a, null, /* @__PURE__ */ React.createElement(ToastProvider, null, children))));
};
const RadioGroupItem = React.forwardRef(function RadioGroupItem2(props, ref) {
  return /* @__PURE__ */ React.createElement(
    $b6c3ddc6086f204d$export$d7b12c4107be0d61,
    {
      ...props,
      "data-taco": "radio-group-item",
      isDisabled: props.disabled,
      inputRef: ref,
      value: String(props.value ?? "")
    }
  );
});
const RadioGroup2 = React.forwardRef(function RadioGroup22(props, ref) {
  const { disabled, invalid, required, readOnly, orientation = "vertical", ...otherProps } = props;
  const values = React.useMemo(() => {
    const radioGroupItemValues = [];
    React.Children.forEach(props.children, (child) => {
      if (React.isValidElement(child)) {
        radioGroupItemValues.push(child.props.value);
      }
    });
    return radioGroupItemValues;
  }, [props.children]);
  let handleChange;
  let value;
  let defaultValue2;
  if (props.onChange) {
    handleChange = (value2) => props.onChange(getRadioItemByValue(values, value2));
    value = props.value !== void 0 ? String(props.value ?? "") : void 0;
  } else {
    defaultValue2 = props.defaultValue !== void 0 ? String(props.defaultValue ?? "") : void 0;
  }
  const className = clsx(
    "flex items-start",
    {
      "flex-wrap gap-x-4": orientation === "horizontal",
      "flex-col gap-y-2": orientation === "vertical"
    },
    props.className
  );
  return /* @__PURE__ */ React.createElement(
    $b6c3ddc6086f204d$export$a98f0dcb43a68a25,
    {
      ...otherProps,
      className,
      "data-taco": "radio-group",
      defaultValue: defaultValue2,
      onChange: handleChange,
      orientation,
      ref,
      value,
      isInvalid: props.invalid,
      isRequired: props.required,
      isReadOnly: props.readOnly,
      isDisabled: props.disabled
    }
  );
});
RadioGroup2.Item = RadioGroupItem;
var FontSizes = /* @__PURE__ */ ((FontSizes2) => {
  FontSizes2["small"] = "small";
  FontSizes2["medium"] = "medium";
  FontSizes2["large"] = "large";
  return FontSizes2;
})(FontSizes || {});
const fixedForwardRef = React__default.forwardRef;
/**
   * table-core
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function createColumnHelper() {
  return {
    accessor: (accessor, column) => {
      return typeof accessor === "function" ? {
        ...column,
        accessorFn: accessor
      } : {
        ...column,
        accessorKey: accessor
      };
    },
    display: (column) => column,
    group: (column) => column
  };
}
function functionalUpdate(updater, input) {
  return typeof updater === "function" ? updater(input) : updater;
}
function makeStateUpdater(key, instance) {
  return (updater) => {
    instance.setState((old) => {
      return {
        ...old,
        [key]: functionalUpdate(updater, old[key])
      };
    });
  };
}
function isFunction$4(d4) {
  return d4 instanceof Function;
}
function isNumberArray$1(d4) {
  return Array.isArray(d4) && d4.every((val) => typeof val === "number");
}
function flattenBy(arr, getChildren) {
  const flat = [];
  const recurse = (subArr) => {
    subArr.forEach((item) => {
      flat.push(item);
      const children = getChildren(item);
      if (children != null && children.length) {
        recurse(children);
      }
    });
  };
  recurse(arr);
  return flat;
}
function memo$1(getDeps, fn, opts) {
  let deps = [];
  let result;
  return (depArgs) => {
    let depTime;
    if (opts.key && opts.debug) depTime = Date.now();
    const newDeps = getDeps(depArgs);
    const depsChanged = newDeps.length !== deps.length || newDeps.some((dep, index2) => deps[index2] !== dep);
    if (!depsChanged) {
      return result;
    }
    deps = newDeps;
    let resultTime;
    if (opts.key && opts.debug) resultTime = Date.now();
    result = fn(...newDeps);
    opts == null || opts.onChange == null || opts.onChange(result);
    if (opts.key && opts.debug) {
      if (opts != null && opts.debug()) {
        const depEndTime = Math.round((Date.now() - depTime) * 100) / 100;
        const resultEndTime = Math.round((Date.now() - resultTime) * 100) / 100;
        const resultFpsPercentage = resultEndTime / 16;
        const pad2 = (str, num) => {
          str = String(str);
          while (str.length < num) {
            str = " " + str;
          }
          return str;
        };
        console.info(`%c⏱ ${pad2(resultEndTime, 5)} /${pad2(depEndTime, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * resultFpsPercentage, 120))}deg 100% 31%);`, opts == null ? void 0 : opts.key);
      }
    }
    return result;
  };
}
function getMemoOptions(tableOptions, debugLevel, key, onChange) {
  return {
    debug: () => {
      var _tableOptions$debugAl;
      return (_tableOptions$debugAl = tableOptions == null ? void 0 : tableOptions.debugAll) != null ? _tableOptions$debugAl : tableOptions[debugLevel];
    },
    key: process.env.NODE_ENV === "development" && key,
    onChange
  };
}
function createCell(table, row, column, columnId) {
  const getRenderValue = () => {
    var _cell$getValue;
    return (_cell$getValue = cell.getValue()) != null ? _cell$getValue : table.options.renderFallbackValue;
  };
  const cell = {
    id: `${row.id}_${column.id}`,
    row,
    column,
    getValue: () => row.getValue(columnId),
    renderValue: getRenderValue,
    getContext: memo$1(() => [table, column, row, cell], (table2, column2, row2, cell2) => ({
      table: table2,
      column: column2,
      row: row2,
      cell: cell2,
      getValue: cell2.getValue,
      renderValue: cell2.renderValue
    }), getMemoOptions(table.options, "debugCells", "cell.getContext"))
  };
  table._features.forEach((feature) => {
    feature.createCell == null || feature.createCell(cell, column, row, table);
  }, {});
  return cell;
}
function createColumn(table, columnDef, depth, parent) {
  var _ref, _resolvedColumnDef$id;
  const defaultColumn = table._getDefaultColumnDef();
  const resolvedColumnDef = {
    ...defaultColumn,
    ...columnDef
  };
  const accessorKey = resolvedColumnDef.accessorKey;
  let id2 = (_ref = (_resolvedColumnDef$id = resolvedColumnDef.id) != null ? _resolvedColumnDef$id : accessorKey ? typeof String.prototype.replaceAll === "function" ? accessorKey.replaceAll(".", "_") : accessorKey.replace(/\./g, "_") : void 0) != null ? _ref : typeof resolvedColumnDef.header === "string" ? resolvedColumnDef.header : void 0;
  let accessorFn;
  if (resolvedColumnDef.accessorFn) {
    accessorFn = resolvedColumnDef.accessorFn;
  } else if (accessorKey) {
    if (accessorKey.includes(".")) {
      accessorFn = (originalRow) => {
        let result = originalRow;
        for (const key of accessorKey.split(".")) {
          var _result;
          result = (_result = result) == null ? void 0 : _result[key];
          if (process.env.NODE_ENV !== "production" && result === void 0) {
            console.warn(`"${key}" in deeply nested key "${accessorKey}" returned undefined.`);
          }
        }
        return result;
      };
    } else {
      accessorFn = (originalRow) => originalRow[resolvedColumnDef.accessorKey];
    }
  }
  if (!id2) {
    if (process.env.NODE_ENV !== "production") {
      throw new Error(resolvedColumnDef.accessorFn ? `Columns require an id when using an accessorFn` : `Columns require an id when using a non-string header`);
    }
    throw new Error();
  }
  let column = {
    id: `${String(id2)}`,
    accessorFn,
    parent,
    depth,
    columnDef: resolvedColumnDef,
    columns: [],
    getFlatColumns: memo$1(() => [true], () => {
      var _column$columns;
      return [column, ...(_column$columns = column.columns) == null ? void 0 : _column$columns.flatMap((d4) => d4.getFlatColumns())];
    }, getMemoOptions(table.options, "debugColumns", "column.getFlatColumns")),
    getLeafColumns: memo$1(() => [table._getOrderColumnsFn()], (orderColumns2) => {
      var _column$columns2;
      if ((_column$columns2 = column.columns) != null && _column$columns2.length) {
        let leafColumns = column.columns.flatMap((column2) => column2.getLeafColumns());
        return orderColumns2(leafColumns);
      }
      return [column];
    }, getMemoOptions(table.options, "debugColumns", "column.getLeafColumns"))
  };
  for (const feature of table._features) {
    feature.createColumn == null || feature.createColumn(column, table);
  }
  return column;
}
const debug = "debugHeaders";
function createHeader(table, column, options) {
  var _options$id;
  const id2 = (_options$id = options.id) != null ? _options$id : column.id;
  let header = {
    id: id2,
    column,
    index: options.index,
    isPlaceholder: !!options.isPlaceholder,
    placeholderId: options.placeholderId,
    depth: options.depth,
    subHeaders: [],
    colSpan: 0,
    rowSpan: 0,
    headerGroup: null,
    getLeafHeaders: () => {
      const leafHeaders = [];
      const recurseHeader = (h4) => {
        if (h4.subHeaders && h4.subHeaders.length) {
          h4.subHeaders.map(recurseHeader);
        }
        leafHeaders.push(h4);
      };
      recurseHeader(header);
      return leafHeaders;
    },
    getContext: () => ({
      table,
      header,
      column
    })
  };
  table._features.forEach((feature) => {
    feature.createHeader == null || feature.createHeader(header, table);
  });
  return header;
}
const Headers = {
  createTable: (table) => {
    table.getHeaderGroups = memo$1(() => [table.getAllColumns(), table.getVisibleLeafColumns(), table.getState().columnPinning.left, table.getState().columnPinning.right], (allColumns, leafColumns, left, right) => {
      var _left$map$filter, _right$map$filter;
      const leftColumns = (_left$map$filter = left == null ? void 0 : left.map((columnId) => leafColumns.find((d4) => d4.id === columnId)).filter(Boolean)) != null ? _left$map$filter : [];
      const rightColumns = (_right$map$filter = right == null ? void 0 : right.map((columnId) => leafColumns.find((d4) => d4.id === columnId)).filter(Boolean)) != null ? _right$map$filter : [];
      const centerColumns = leafColumns.filter((column) => !(left != null && left.includes(column.id)) && !(right != null && right.includes(column.id)));
      const headerGroups = buildHeaderGroups(allColumns, [...leftColumns, ...centerColumns, ...rightColumns], table);
      return headerGroups;
    }, getMemoOptions(table.options, debug, "getHeaderGroups"));
    table.getCenterHeaderGroups = memo$1(() => [table.getAllColumns(), table.getVisibleLeafColumns(), table.getState().columnPinning.left, table.getState().columnPinning.right], (allColumns, leafColumns, left, right) => {
      leafColumns = leafColumns.filter((column) => !(left != null && left.includes(column.id)) && !(right != null && right.includes(column.id)));
      return buildHeaderGroups(allColumns, leafColumns, table, "center");
    }, getMemoOptions(table.options, debug, "getCenterHeaderGroups"));
    table.getLeftHeaderGroups = memo$1(() => [table.getAllColumns(), table.getVisibleLeafColumns(), table.getState().columnPinning.left], (allColumns, leafColumns, left) => {
      var _left$map$filter2;
      const orderedLeafColumns = (_left$map$filter2 = left == null ? void 0 : left.map((columnId) => leafColumns.find((d4) => d4.id === columnId)).filter(Boolean)) != null ? _left$map$filter2 : [];
      return buildHeaderGroups(allColumns, orderedLeafColumns, table, "left");
    }, getMemoOptions(table.options, debug, "getLeftHeaderGroups"));
    table.getRightHeaderGroups = memo$1(() => [table.getAllColumns(), table.getVisibleLeafColumns(), table.getState().columnPinning.right], (allColumns, leafColumns, right) => {
      var _right$map$filter2;
      const orderedLeafColumns = (_right$map$filter2 = right == null ? void 0 : right.map((columnId) => leafColumns.find((d4) => d4.id === columnId)).filter(Boolean)) != null ? _right$map$filter2 : [];
      return buildHeaderGroups(allColumns, orderedLeafColumns, table, "right");
    }, getMemoOptions(table.options, debug, "getRightHeaderGroups"));
    table.getFooterGroups = memo$1(() => [table.getHeaderGroups()], (headerGroups) => {
      return [...headerGroups].reverse();
    }, getMemoOptions(table.options, debug, "getFooterGroups"));
    table.getLeftFooterGroups = memo$1(() => [table.getLeftHeaderGroups()], (headerGroups) => {
      return [...headerGroups].reverse();
    }, getMemoOptions(table.options, debug, "getLeftFooterGroups"));
    table.getCenterFooterGroups = memo$1(() => [table.getCenterHeaderGroups()], (headerGroups) => {
      return [...headerGroups].reverse();
    }, getMemoOptions(table.options, debug, "getCenterFooterGroups"));
    table.getRightFooterGroups = memo$1(() => [table.getRightHeaderGroups()], (headerGroups) => {
      return [...headerGroups].reverse();
    }, getMemoOptions(table.options, debug, "getRightFooterGroups"));
    table.getFlatHeaders = memo$1(() => [table.getHeaderGroups()], (headerGroups) => {
      return headerGroups.map((headerGroup) => {
        return headerGroup.headers;
      }).flat();
    }, getMemoOptions(table.options, debug, "getFlatHeaders"));
    table.getLeftFlatHeaders = memo$1(() => [table.getLeftHeaderGroups()], (left) => {
      return left.map((headerGroup) => {
        return headerGroup.headers;
      }).flat();
    }, getMemoOptions(table.options, debug, "getLeftFlatHeaders"));
    table.getCenterFlatHeaders = memo$1(() => [table.getCenterHeaderGroups()], (left) => {
      return left.map((headerGroup) => {
        return headerGroup.headers;
      }).flat();
    }, getMemoOptions(table.options, debug, "getCenterFlatHeaders"));
    table.getRightFlatHeaders = memo$1(() => [table.getRightHeaderGroups()], (left) => {
      return left.map((headerGroup) => {
        return headerGroup.headers;
      }).flat();
    }, getMemoOptions(table.options, debug, "getRightFlatHeaders"));
    table.getCenterLeafHeaders = memo$1(() => [table.getCenterFlatHeaders()], (flatHeaders) => {
      return flatHeaders.filter((header) => {
        var _header$subHeaders;
        return !((_header$subHeaders = header.subHeaders) != null && _header$subHeaders.length);
      });
    }, getMemoOptions(table.options, debug, "getCenterLeafHeaders"));
    table.getLeftLeafHeaders = memo$1(() => [table.getLeftFlatHeaders()], (flatHeaders) => {
      return flatHeaders.filter((header) => {
        var _header$subHeaders2;
        return !((_header$subHeaders2 = header.subHeaders) != null && _header$subHeaders2.length);
      });
    }, getMemoOptions(table.options, debug, "getLeftLeafHeaders"));
    table.getRightLeafHeaders = memo$1(() => [table.getRightFlatHeaders()], (flatHeaders) => {
      return flatHeaders.filter((header) => {
        var _header$subHeaders3;
        return !((_header$subHeaders3 = header.subHeaders) != null && _header$subHeaders3.length);
      });
    }, getMemoOptions(table.options, debug, "getRightLeafHeaders"));
    table.getLeafHeaders = memo$1(() => [table.getLeftHeaderGroups(), table.getCenterHeaderGroups(), table.getRightHeaderGroups()], (left, center, right) => {
      var _left$0$headers, _left$, _center$0$headers, _center$, _right$0$headers, _right$;
      return [...(_left$0$headers = (_left$ = left[0]) == null ? void 0 : _left$.headers) != null ? _left$0$headers : [], ...(_center$0$headers = (_center$ = center[0]) == null ? void 0 : _center$.headers) != null ? _center$0$headers : [], ...(_right$0$headers = (_right$ = right[0]) == null ? void 0 : _right$.headers) != null ? _right$0$headers : []].map((header) => {
        return header.getLeafHeaders();
      }).flat();
    }, getMemoOptions(table.options, debug, "getLeafHeaders"));
  }
};
function buildHeaderGroups(allColumns, columnsToGroup, table, headerFamily) {
  var _headerGroups$0$heade, _headerGroups$;
  let maxDepth2 = 0;
  const findMaxDepth = function(columns, depth) {
    if (depth === void 0) {
      depth = 1;
    }
    maxDepth2 = Math.max(maxDepth2, depth);
    columns.filter((column) => column.getIsVisible()).forEach((column) => {
      var _column$columns;
      if ((_column$columns = column.columns) != null && _column$columns.length) {
        findMaxDepth(column.columns, depth + 1);
      }
    }, 0);
  };
  findMaxDepth(allColumns);
  let headerGroups = [];
  const createHeaderGroup = (headersToGroup, depth) => {
    const headerGroup = {
      depth,
      id: [headerFamily, `${depth}`].filter(Boolean).join("_"),
      headers: []
    };
    const pendingParentHeaders = [];
    headersToGroup.forEach((headerToGroup) => {
      const latestPendingParentHeader = [...pendingParentHeaders].reverse()[0];
      const isLeafHeader = headerToGroup.column.depth === headerGroup.depth;
      let column;
      let isPlaceholder = false;
      if (isLeafHeader && headerToGroup.column.parent) {
        column = headerToGroup.column.parent;
      } else {
        column = headerToGroup.column;
        isPlaceholder = true;
      }
      if (latestPendingParentHeader && (latestPendingParentHeader == null ? void 0 : latestPendingParentHeader.column) === column) {
        latestPendingParentHeader.subHeaders.push(headerToGroup);
      } else {
        const header = createHeader(table, column, {
          id: [headerFamily, depth, column.id, headerToGroup == null ? void 0 : headerToGroup.id].filter(Boolean).join("_"),
          isPlaceholder,
          placeholderId: isPlaceholder ? `${pendingParentHeaders.filter((d4) => d4.column === column).length}` : void 0,
          depth,
          index: pendingParentHeaders.length
        });
        header.subHeaders.push(headerToGroup);
        pendingParentHeaders.push(header);
      }
      headerGroup.headers.push(headerToGroup);
      headerToGroup.headerGroup = headerGroup;
    });
    headerGroups.push(headerGroup);
    if (depth > 0) {
      createHeaderGroup(pendingParentHeaders, depth - 1);
    }
  };
  const bottomHeaders = columnsToGroup.map((column, index2) => createHeader(table, column, {
    depth: maxDepth2,
    index: index2
  }));
  createHeaderGroup(bottomHeaders, maxDepth2 - 1);
  headerGroups.reverse();
  const recurseHeadersForSpans = (headers) => {
    const filteredHeaders = headers.filter((header) => header.column.getIsVisible());
    return filteredHeaders.map((header) => {
      let colSpan = 0;
      let rowSpan = 0;
      let childRowSpans = [0];
      if (header.subHeaders && header.subHeaders.length) {
        childRowSpans = [];
        recurseHeadersForSpans(header.subHeaders).forEach((_ref) => {
          let {
            colSpan: childColSpan,
            rowSpan: childRowSpan
          } = _ref;
          colSpan += childColSpan;
          childRowSpans.push(childRowSpan);
        });
      } else {
        colSpan = 1;
      }
      const minChildRowSpan = Math.min(...childRowSpans);
      rowSpan = rowSpan + minChildRowSpan;
      header.colSpan = colSpan;
      header.rowSpan = rowSpan;
      return {
        colSpan,
        rowSpan
      };
    });
  };
  recurseHeadersForSpans((_headerGroups$0$heade = (_headerGroups$ = headerGroups[0]) == null ? void 0 : _headerGroups$.headers) != null ? _headerGroups$0$heade : []);
  return headerGroups;
}
const createRow = (table, id2, original, rowIndex, depth, subRows, parentId) => {
  let row = {
    id: id2,
    index: rowIndex,
    original,
    depth,
    parentId,
    _valuesCache: {},
    _uniqueValuesCache: {},
    getValue: (columnId) => {
      if (row._valuesCache.hasOwnProperty(columnId)) {
        return row._valuesCache[columnId];
      }
      const column = table.getColumn(columnId);
      if (!(column != null && column.accessorFn)) {
        return void 0;
      }
      row._valuesCache[columnId] = column.accessorFn(row.original, rowIndex);
      return row._valuesCache[columnId];
    },
    getUniqueValues: (columnId) => {
      if (row._uniqueValuesCache.hasOwnProperty(columnId)) {
        return row._uniqueValuesCache[columnId];
      }
      const column = table.getColumn(columnId);
      if (!(column != null && column.accessorFn)) {
        return void 0;
      }
      if (!column.columnDef.getUniqueValues) {
        row._uniqueValuesCache[columnId] = [row.getValue(columnId)];
        return row._uniqueValuesCache[columnId];
      }
      row._uniqueValuesCache[columnId] = column.columnDef.getUniqueValues(row.original, rowIndex);
      return row._uniqueValuesCache[columnId];
    },
    renderValue: (columnId) => {
      var _row$getValue;
      return (_row$getValue = row.getValue(columnId)) != null ? _row$getValue : table.options.renderFallbackValue;
    },
    subRows: subRows != null ? subRows : [],
    getLeafRows: () => flattenBy(row.subRows, (d4) => d4.subRows),
    getParentRow: () => row.parentId ? table.getRow(row.parentId, true) : void 0,
    getParentRows: () => {
      let parentRows = [];
      let currentRow = row;
      while (true) {
        const parentRow = currentRow.getParentRow();
        if (!parentRow) break;
        parentRows.push(parentRow);
        currentRow = parentRow;
      }
      return parentRows.reverse();
    },
    getAllCells: memo$1(() => [table.getAllLeafColumns()], (leafColumns) => {
      return leafColumns.map((column) => {
        return createCell(table, row, column, column.id);
      });
    }, getMemoOptions(table.options, "debugRows", "getAllCells")),
    _getAllCellsByColumnId: memo$1(() => [row.getAllCells()], (allCells) => {
      return allCells.reduce((acc, cell) => {
        acc[cell.column.id] = cell;
        return acc;
      }, {});
    }, getMemoOptions(table.options, "debugRows", "getAllCellsByColumnId"))
  };
  for (let i3 = 0; i3 < table._features.length; i3++) {
    const feature = table._features[i3];
    feature == null || feature.createRow == null || feature.createRow(row, table);
  }
  return row;
};
const ColumnFaceting = {
  createColumn: (column, table) => {
    column._getFacetedRowModel = table.options.getFacetedRowModel && table.options.getFacetedRowModel(table, column.id);
    column.getFacetedRowModel = () => {
      if (!column._getFacetedRowModel) {
        return table.getPreFilteredRowModel();
      }
      return column._getFacetedRowModel();
    };
    column._getFacetedUniqueValues = table.options.getFacetedUniqueValues && table.options.getFacetedUniqueValues(table, column.id);
    column.getFacetedUniqueValues = () => {
      if (!column._getFacetedUniqueValues) {
        return /* @__PURE__ */ new Map();
      }
      return column._getFacetedUniqueValues();
    };
    column._getFacetedMinMaxValues = table.options.getFacetedMinMaxValues && table.options.getFacetedMinMaxValues(table, column.id);
    column.getFacetedMinMaxValues = () => {
      if (!column._getFacetedMinMaxValues) {
        return void 0;
      }
      return column._getFacetedMinMaxValues();
    };
  }
};
const includesString = (row, columnId, filterValue) => {
  var _filterValue$toString, _row$getValue;
  const search = filterValue == null || (_filterValue$toString = filterValue.toString()) == null ? void 0 : _filterValue$toString.toLowerCase();
  return Boolean((_row$getValue = row.getValue(columnId)) == null || (_row$getValue = _row$getValue.toString()) == null || (_row$getValue = _row$getValue.toLowerCase()) == null ? void 0 : _row$getValue.includes(search));
};
includesString.autoRemove = (val) => testFalsey(val);
const includesStringSensitive = (row, columnId, filterValue) => {
  var _row$getValue2;
  return Boolean((_row$getValue2 = row.getValue(columnId)) == null || (_row$getValue2 = _row$getValue2.toString()) == null ? void 0 : _row$getValue2.includes(filterValue));
};
includesStringSensitive.autoRemove = (val) => testFalsey(val);
const equalsString = (row, columnId, filterValue) => {
  var _row$getValue3;
  return ((_row$getValue3 = row.getValue(columnId)) == null || (_row$getValue3 = _row$getValue3.toString()) == null ? void 0 : _row$getValue3.toLowerCase()) === (filterValue == null ? void 0 : filterValue.toLowerCase());
};
equalsString.autoRemove = (val) => testFalsey(val);
const arrIncludes = (row, columnId, filterValue) => {
  var _row$getValue4;
  return (_row$getValue4 = row.getValue(columnId)) == null ? void 0 : _row$getValue4.includes(filterValue);
};
arrIncludes.autoRemove = (val) => testFalsey(val);
const arrIncludesAll = (row, columnId, filterValue) => {
  return !filterValue.some((val) => {
    var _row$getValue5;
    return !((_row$getValue5 = row.getValue(columnId)) != null && _row$getValue5.includes(val));
  });
};
arrIncludesAll.autoRemove = (val) => testFalsey(val) || !(val != null && val.length);
const arrIncludesSome = (row, columnId, filterValue) => {
  return filterValue.some((val) => {
    var _row$getValue6;
    return (_row$getValue6 = row.getValue(columnId)) == null ? void 0 : _row$getValue6.includes(val);
  });
};
arrIncludesSome.autoRemove = (val) => testFalsey(val) || !(val != null && val.length);
const equals = (row, columnId, filterValue) => {
  return row.getValue(columnId) === filterValue;
};
equals.autoRemove = (val) => testFalsey(val);
const weakEquals = (row, columnId, filterValue) => {
  return row.getValue(columnId) == filterValue;
};
weakEquals.autoRemove = (val) => testFalsey(val);
const inNumberRange = (row, columnId, filterValue) => {
  let [min2, max2] = filterValue;
  const rowValue = row.getValue(columnId);
  return rowValue >= min2 && rowValue <= max2;
};
inNumberRange.resolveFilterValue = (val) => {
  let [unsafeMin, unsafeMax] = val;
  let parsedMin = typeof unsafeMin !== "number" ? parseFloat(unsafeMin) : unsafeMin;
  let parsedMax = typeof unsafeMax !== "number" ? parseFloat(unsafeMax) : unsafeMax;
  let min2 = unsafeMin === null || Number.isNaN(parsedMin) ? -Infinity : parsedMin;
  let max2 = unsafeMax === null || Number.isNaN(parsedMax) ? Infinity : parsedMax;
  if (min2 > max2) {
    const temp = min2;
    min2 = max2;
    max2 = temp;
  }
  return [min2, max2];
};
inNumberRange.autoRemove = (val) => testFalsey(val) || testFalsey(val[0]) && testFalsey(val[1]);
const filterFns = {
  includesString,
  includesStringSensitive,
  equalsString,
  arrIncludes,
  arrIncludesAll,
  arrIncludesSome,
  equals,
  weakEquals,
  inNumberRange
};
function testFalsey(val) {
  return val === void 0 || val === null || val === "";
}
const ColumnFiltering = {
  getDefaultColumnDef: () => {
    return {
      filterFn: "auto"
    };
  },
  getInitialState: (state) => {
    return {
      columnFilters: [],
      ...state
    };
  },
  getDefaultOptions: (table) => {
    return {
      onColumnFiltersChange: makeStateUpdater("columnFilters", table),
      filterFromLeafRows: false,
      maxLeafRowFilterDepth: 100
    };
  },
  createColumn: (column, table) => {
    column.getAutoFilterFn = () => {
      const firstRow = table.getCoreRowModel().flatRows[0];
      const value = firstRow == null ? void 0 : firstRow.getValue(column.id);
      if (typeof value === "string") {
        return filterFns.includesString;
      }
      if (typeof value === "number") {
        return filterFns.inNumberRange;
      }
      if (typeof value === "boolean") {
        return filterFns.equals;
      }
      if (value !== null && typeof value === "object") {
        return filterFns.equals;
      }
      if (Array.isArray(value)) {
        return filterFns.arrIncludes;
      }
      return filterFns.weakEquals;
    };
    column.getFilterFn = () => {
      var _table$options$filter, _table$options$filter2;
      return isFunction$4(column.columnDef.filterFn) ? column.columnDef.filterFn : column.columnDef.filterFn === "auto" ? column.getAutoFilterFn() : (
        // @ts-ignore
        (_table$options$filter = (_table$options$filter2 = table.options.filterFns) == null ? void 0 : _table$options$filter2[column.columnDef.filterFn]) != null ? _table$options$filter : filterFns[column.columnDef.filterFn]
      );
    };
    column.getCanFilter = () => {
      var _column$columnDef$ena, _table$options$enable, _table$options$enable2;
      return ((_column$columnDef$ena = column.columnDef.enableColumnFilter) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableColumnFilters) != null ? _table$options$enable : true) && ((_table$options$enable2 = table.options.enableFilters) != null ? _table$options$enable2 : true) && !!column.accessorFn;
    };
    column.getIsFiltered = () => column.getFilterIndex() > -1;
    column.getFilterValue = () => {
      var _table$getState$colum;
      return (_table$getState$colum = table.getState().columnFilters) == null || (_table$getState$colum = _table$getState$colum.find((d4) => d4.id === column.id)) == null ? void 0 : _table$getState$colum.value;
    };
    column.getFilterIndex = () => {
      var _table$getState$colum2, _table$getState$colum3;
      return (_table$getState$colum2 = (_table$getState$colum3 = table.getState().columnFilters) == null ? void 0 : _table$getState$colum3.findIndex((d4) => d4.id === column.id)) != null ? _table$getState$colum2 : -1;
    };
    column.setFilterValue = (value) => {
      table.setColumnFilters((old) => {
        const filterFn = column.getFilterFn();
        const previousFilter = old == null ? void 0 : old.find((d4) => d4.id === column.id);
        const newFilter = functionalUpdate(value, previousFilter ? previousFilter.value : void 0);
        if (shouldAutoRemoveFilter(filterFn, newFilter, column)) {
          var _old$filter;
          return (_old$filter = old == null ? void 0 : old.filter((d4) => d4.id !== column.id)) != null ? _old$filter : [];
        }
        const newFilterObj = {
          id: column.id,
          value: newFilter
        };
        if (previousFilter) {
          var _old$map;
          return (_old$map = old == null ? void 0 : old.map((d4) => {
            if (d4.id === column.id) {
              return newFilterObj;
            }
            return d4;
          })) != null ? _old$map : [];
        }
        if (old != null && old.length) {
          return [...old, newFilterObj];
        }
        return [newFilterObj];
      });
    };
  },
  createRow: (row, _table) => {
    row.columnFilters = {};
    row.columnFiltersMeta = {};
  },
  createTable: (table) => {
    table.setColumnFilters = (updater) => {
      const leafColumns = table.getAllLeafColumns();
      const updateFn = (old) => {
        var _functionalUpdate;
        return (_functionalUpdate = functionalUpdate(updater, old)) == null ? void 0 : _functionalUpdate.filter((filter2) => {
          const column = leafColumns.find((d4) => d4.id === filter2.id);
          if (column) {
            const filterFn = column.getFilterFn();
            if (shouldAutoRemoveFilter(filterFn, filter2.value, column)) {
              return false;
            }
          }
          return true;
        });
      };
      table.options.onColumnFiltersChange == null || table.options.onColumnFiltersChange(updateFn);
    };
    table.resetColumnFilters = (defaultState2) => {
      var _table$initialState$c, _table$initialState;
      table.setColumnFilters(defaultState2 ? [] : (_table$initialState$c = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.columnFilters) != null ? _table$initialState$c : []);
    };
    table.getPreFilteredRowModel = () => table.getCoreRowModel();
    table.getFilteredRowModel = () => {
      if (!table._getFilteredRowModel && table.options.getFilteredRowModel) {
        table._getFilteredRowModel = table.options.getFilteredRowModel(table);
      }
      if (table.options.manualFiltering || !table._getFilteredRowModel) {
        return table.getPreFilteredRowModel();
      }
      return table._getFilteredRowModel();
    };
  }
};
function shouldAutoRemoveFilter(filterFn, value, column) {
  return (filterFn && filterFn.autoRemove ? filterFn.autoRemove(value, column) : false) || typeof value === "undefined" || typeof value === "string" && !value;
}
const sum = (columnId, _leafRows, childRows) => {
  return childRows.reduce((sum2, next) => {
    const nextValue = next.getValue(columnId);
    return sum2 + (typeof nextValue === "number" ? nextValue : 0);
  }, 0);
};
const min$2 = (columnId, _leafRows, childRows) => {
  let min2;
  childRows.forEach((row) => {
    const value = row.getValue(columnId);
    if (value != null && (min2 > value || min2 === void 0 && value >= value)) {
      min2 = value;
    }
  });
  return min2;
};
const max$2 = (columnId, _leafRows, childRows) => {
  let max2;
  childRows.forEach((row) => {
    const value = row.getValue(columnId);
    if (value != null && (max2 < value || max2 === void 0 && value >= value)) {
      max2 = value;
    }
  });
  return max2;
};
const extent = (columnId, _leafRows, childRows) => {
  let min2;
  let max2;
  childRows.forEach((row) => {
    const value = row.getValue(columnId);
    if (value != null) {
      if (min2 === void 0) {
        if (value >= value) min2 = max2 = value;
      } else {
        if (min2 > value) min2 = value;
        if (max2 < value) max2 = value;
      }
    }
  });
  return [min2, max2];
};
const mean = (columnId, leafRows) => {
  let count2 = 0;
  let sum2 = 0;
  leafRows.forEach((row) => {
    let value = row.getValue(columnId);
    if (value != null && (value = +value) >= value) {
      ++count2, sum2 += value;
    }
  });
  if (count2) return sum2 / count2;
  return;
};
const median = (columnId, leafRows) => {
  if (!leafRows.length) {
    return;
  }
  const values = leafRows.map((row) => row.getValue(columnId));
  if (!isNumberArray$1(values)) {
    return;
  }
  if (values.length === 1) {
    return values[0];
  }
  const mid = Math.floor(values.length / 2);
  const nums = values.sort((a4, b3) => a4 - b3);
  return values.length % 2 !== 0 ? nums[mid] : (nums[mid - 1] + nums[mid]) / 2;
};
const unique = (columnId, leafRows) => {
  return Array.from(new Set(leafRows.map((d4) => d4.getValue(columnId))).values());
};
const uniqueCount = (columnId, leafRows) => {
  return new Set(leafRows.map((d4) => d4.getValue(columnId))).size;
};
const count = (_columnId, leafRows) => {
  return leafRows.length;
};
const aggregationFns = {
  sum,
  min: min$2,
  max: max$2,
  extent,
  mean,
  median,
  unique,
  uniqueCount,
  count
};
const ColumnGrouping = {
  getDefaultColumnDef: () => {
    return {
      aggregatedCell: (props) => {
        var _toString, _props$getValue;
        return (_toString = (_props$getValue = props.getValue()) == null || _props$getValue.toString == null ? void 0 : _props$getValue.toString()) != null ? _toString : null;
      },
      aggregationFn: "auto"
    };
  },
  getInitialState: (state) => {
    return {
      grouping: [],
      ...state
    };
  },
  getDefaultOptions: (table) => {
    return {
      onGroupingChange: makeStateUpdater("grouping", table),
      groupedColumnMode: "reorder"
    };
  },
  createColumn: (column, table) => {
    column.toggleGrouping = () => {
      table.setGrouping((old) => {
        if (old != null && old.includes(column.id)) {
          return old.filter((d4) => d4 !== column.id);
        }
        return [...old != null ? old : [], column.id];
      });
    };
    column.getCanGroup = () => {
      var _column$columnDef$ena, _table$options$enable;
      return ((_column$columnDef$ena = column.columnDef.enableGrouping) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableGrouping) != null ? _table$options$enable : true) && (!!column.accessorFn || !!column.columnDef.getGroupingValue);
    };
    column.getIsGrouped = () => {
      var _table$getState$group;
      return (_table$getState$group = table.getState().grouping) == null ? void 0 : _table$getState$group.includes(column.id);
    };
    column.getGroupedIndex = () => {
      var _table$getState$group2;
      return (_table$getState$group2 = table.getState().grouping) == null ? void 0 : _table$getState$group2.indexOf(column.id);
    };
    column.getToggleGroupingHandler = () => {
      const canGroup = column.getCanGroup();
      return () => {
        if (!canGroup) return;
        column.toggleGrouping();
      };
    };
    column.getAutoAggregationFn = () => {
      const firstRow = table.getCoreRowModel().flatRows[0];
      const value = firstRow == null ? void 0 : firstRow.getValue(column.id);
      if (typeof value === "number") {
        return aggregationFns.sum;
      }
      if (Object.prototype.toString.call(value) === "[object Date]") {
        return aggregationFns.extent;
      }
    };
    column.getAggregationFn = () => {
      var _table$options$aggreg, _table$options$aggreg2;
      if (!column) {
        throw new Error();
      }
      return isFunction$4(column.columnDef.aggregationFn) ? column.columnDef.aggregationFn : column.columnDef.aggregationFn === "auto" ? column.getAutoAggregationFn() : (_table$options$aggreg = (_table$options$aggreg2 = table.options.aggregationFns) == null ? void 0 : _table$options$aggreg2[column.columnDef.aggregationFn]) != null ? _table$options$aggreg : aggregationFns[column.columnDef.aggregationFn];
    };
  },
  createTable: (table) => {
    table.setGrouping = (updater) => table.options.onGroupingChange == null ? void 0 : table.options.onGroupingChange(updater);
    table.resetGrouping = (defaultState2) => {
      var _table$initialState$g, _table$initialState;
      table.setGrouping(defaultState2 ? [] : (_table$initialState$g = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.grouping) != null ? _table$initialState$g : []);
    };
    table.getPreGroupedRowModel = () => table.getFilteredRowModel();
    table.getGroupedRowModel = () => {
      if (!table._getGroupedRowModel && table.options.getGroupedRowModel) {
        table._getGroupedRowModel = table.options.getGroupedRowModel(table);
      }
      if (table.options.manualGrouping || !table._getGroupedRowModel) {
        return table.getPreGroupedRowModel();
      }
      return table._getGroupedRowModel();
    };
  },
  createRow: (row, table) => {
    row.getIsGrouped = () => !!row.groupingColumnId;
    row.getGroupingValue = (columnId) => {
      if (row._groupingValuesCache.hasOwnProperty(columnId)) {
        return row._groupingValuesCache[columnId];
      }
      const column = table.getColumn(columnId);
      if (!(column != null && column.columnDef.getGroupingValue)) {
        return row.getValue(columnId);
      }
      row._groupingValuesCache[columnId] = column.columnDef.getGroupingValue(row.original);
      return row._groupingValuesCache[columnId];
    };
    row._groupingValuesCache = {};
  },
  createCell: (cell, column, row, table) => {
    cell.getIsGrouped = () => column.getIsGrouped() && column.id === row.groupingColumnId;
    cell.getIsPlaceholder = () => !cell.getIsGrouped() && column.getIsGrouped();
    cell.getIsAggregated = () => {
      var _row$subRows;
      return !cell.getIsGrouped() && !cell.getIsPlaceholder() && !!((_row$subRows = row.subRows) != null && _row$subRows.length);
    };
  }
};
function orderColumns(leafColumns, grouping, groupedColumnMode) {
  if (!(grouping != null && grouping.length) || !groupedColumnMode) {
    return leafColumns;
  }
  const nonGroupingColumns = leafColumns.filter((col) => !grouping.includes(col.id));
  if (groupedColumnMode === "remove") {
    return nonGroupingColumns;
  }
  const groupingColumns = grouping.map((g2) => leafColumns.find((col) => col.id === g2)).filter(Boolean);
  return [...groupingColumns, ...nonGroupingColumns];
}
const ColumnOrdering = {
  getInitialState: (state) => {
    return {
      columnOrder: [],
      ...state
    };
  },
  getDefaultOptions: (table) => {
    return {
      onColumnOrderChange: makeStateUpdater("columnOrder", table)
    };
  },
  createColumn: (column, table) => {
    column.getIndex = memo$1((position) => [_getVisibleLeafColumns(table, position)], (columns) => columns.findIndex((d4) => d4.id === column.id), getMemoOptions(table.options, "debugColumns", "getIndex"));
    column.getIsFirstColumn = (position) => {
      var _columns$;
      const columns = _getVisibleLeafColumns(table, position);
      return ((_columns$ = columns[0]) == null ? void 0 : _columns$.id) === column.id;
    };
    column.getIsLastColumn = (position) => {
      var _columns;
      const columns = _getVisibleLeafColumns(table, position);
      return ((_columns = columns[columns.length - 1]) == null ? void 0 : _columns.id) === column.id;
    };
  },
  createTable: (table) => {
    table.setColumnOrder = (updater) => table.options.onColumnOrderChange == null ? void 0 : table.options.onColumnOrderChange(updater);
    table.resetColumnOrder = (defaultState2) => {
      var _table$initialState$c;
      table.setColumnOrder(defaultState2 ? [] : (_table$initialState$c = table.initialState.columnOrder) != null ? _table$initialState$c : []);
    };
    table._getOrderColumnsFn = memo$1(() => [table.getState().columnOrder, table.getState().grouping, table.options.groupedColumnMode], (columnOrder, grouping, groupedColumnMode) => (columns) => {
      let orderedColumns = [];
      if (!(columnOrder != null && columnOrder.length)) {
        orderedColumns = columns;
      } else {
        const columnOrderCopy = [...columnOrder];
        const columnsCopy = [...columns];
        while (columnsCopy.length && columnOrderCopy.length) {
          const targetColumnId = columnOrderCopy.shift();
          const foundIndex = columnsCopy.findIndex((d4) => d4.id === targetColumnId);
          if (foundIndex > -1) {
            orderedColumns.push(columnsCopy.splice(foundIndex, 1)[0]);
          }
        }
        orderedColumns = [...orderedColumns, ...columnsCopy];
      }
      return orderColumns(orderedColumns, grouping, groupedColumnMode);
    }, getMemoOptions(table.options, "debugTable", "_getOrderColumnsFn"));
  }
};
const getDefaultColumnPinningState = () => ({
  left: [],
  right: []
});
const ColumnPinning = {
  getInitialState: (state) => {
    return {
      columnPinning: getDefaultColumnPinningState(),
      ...state
    };
  },
  getDefaultOptions: (table) => {
    return {
      onColumnPinningChange: makeStateUpdater("columnPinning", table)
    };
  },
  createColumn: (column, table) => {
    column.pin = (position) => {
      const columnIds = column.getLeafColumns().map((d4) => d4.id).filter(Boolean);
      table.setColumnPinning((old) => {
        var _old$left3, _old$right3;
        if (position === "right") {
          var _old$left, _old$right;
          return {
            left: ((_old$left = old == null ? void 0 : old.left) != null ? _old$left : []).filter((d4) => !(columnIds != null && columnIds.includes(d4))),
            right: [...((_old$right = old == null ? void 0 : old.right) != null ? _old$right : []).filter((d4) => !(columnIds != null && columnIds.includes(d4))), ...columnIds]
          };
        }
        if (position === "left") {
          var _old$left2, _old$right2;
          return {
            left: [...((_old$left2 = old == null ? void 0 : old.left) != null ? _old$left2 : []).filter((d4) => !(columnIds != null && columnIds.includes(d4))), ...columnIds],
            right: ((_old$right2 = old == null ? void 0 : old.right) != null ? _old$right2 : []).filter((d4) => !(columnIds != null && columnIds.includes(d4)))
          };
        }
        return {
          left: ((_old$left3 = old == null ? void 0 : old.left) != null ? _old$left3 : []).filter((d4) => !(columnIds != null && columnIds.includes(d4))),
          right: ((_old$right3 = old == null ? void 0 : old.right) != null ? _old$right3 : []).filter((d4) => !(columnIds != null && columnIds.includes(d4)))
        };
      });
    };
    column.getCanPin = () => {
      const leafColumns = column.getLeafColumns();
      return leafColumns.some((d4) => {
        var _d$columnDef$enablePi, _ref, _table$options$enable;
        return ((_d$columnDef$enablePi = d4.columnDef.enablePinning) != null ? _d$columnDef$enablePi : true) && ((_ref = (_table$options$enable = table.options.enableColumnPinning) != null ? _table$options$enable : table.options.enablePinning) != null ? _ref : true);
      });
    };
    column.getIsPinned = () => {
      const leafColumnIds = column.getLeafColumns().map((d4) => d4.id);
      const {
        left,
        right
      } = table.getState().columnPinning;
      const isLeft = leafColumnIds.some((d4) => left == null ? void 0 : left.includes(d4));
      const isRight = leafColumnIds.some((d4) => right == null ? void 0 : right.includes(d4));
      return isLeft ? "left" : isRight ? "right" : false;
    };
    column.getPinnedIndex = () => {
      var _table$getState$colum, _table$getState$colum2;
      const position = column.getIsPinned();
      return position ? (_table$getState$colum = (_table$getState$colum2 = table.getState().columnPinning) == null || (_table$getState$colum2 = _table$getState$colum2[position]) == null ? void 0 : _table$getState$colum2.indexOf(column.id)) != null ? _table$getState$colum : -1 : 0;
    };
  },
  createRow: (row, table) => {
    row.getCenterVisibleCells = memo$1(() => [row._getAllVisibleCells(), table.getState().columnPinning.left, table.getState().columnPinning.right], (allCells, left, right) => {
      const leftAndRight = [...left != null ? left : [], ...right != null ? right : []];
      return allCells.filter((d4) => !leftAndRight.includes(d4.column.id));
    }, getMemoOptions(table.options, "debugRows", "getCenterVisibleCells"));
    row.getLeftVisibleCells = memo$1(() => [row._getAllVisibleCells(), table.getState().columnPinning.left], (allCells, left) => {
      const cells = (left != null ? left : []).map((columnId) => allCells.find((cell) => cell.column.id === columnId)).filter(Boolean).map((d4) => ({
        ...d4,
        position: "left"
      }));
      return cells;
    }, getMemoOptions(table.options, "debugRows", "getLeftVisibleCells"));
    row.getRightVisibleCells = memo$1(() => [row._getAllVisibleCells(), table.getState().columnPinning.right], (allCells, right) => {
      const cells = (right != null ? right : []).map((columnId) => allCells.find((cell) => cell.column.id === columnId)).filter(Boolean).map((d4) => ({
        ...d4,
        position: "right"
      }));
      return cells;
    }, getMemoOptions(table.options, "debugRows", "getRightVisibleCells"));
  },
  createTable: (table) => {
    table.setColumnPinning = (updater) => table.options.onColumnPinningChange == null ? void 0 : table.options.onColumnPinningChange(updater);
    table.resetColumnPinning = (defaultState2) => {
      var _table$initialState$c, _table$initialState;
      return table.setColumnPinning(defaultState2 ? getDefaultColumnPinningState() : (_table$initialState$c = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.columnPinning) != null ? _table$initialState$c : getDefaultColumnPinningState());
    };
    table.getIsSomeColumnsPinned = (position) => {
      var _pinningState$positio;
      const pinningState = table.getState().columnPinning;
      if (!position) {
        var _pinningState$left, _pinningState$right;
        return Boolean(((_pinningState$left = pinningState.left) == null ? void 0 : _pinningState$left.length) || ((_pinningState$right = pinningState.right) == null ? void 0 : _pinningState$right.length));
      }
      return Boolean((_pinningState$positio = pinningState[position]) == null ? void 0 : _pinningState$positio.length);
    };
    table.getLeftLeafColumns = memo$1(() => [table.getAllLeafColumns(), table.getState().columnPinning.left], (allColumns, left) => {
      return (left != null ? left : []).map((columnId) => allColumns.find((column) => column.id === columnId)).filter(Boolean);
    }, getMemoOptions(table.options, "debugColumns", "getLeftLeafColumns"));
    table.getRightLeafColumns = memo$1(() => [table.getAllLeafColumns(), table.getState().columnPinning.right], (allColumns, right) => {
      return (right != null ? right : []).map((columnId) => allColumns.find((column) => column.id === columnId)).filter(Boolean);
    }, getMemoOptions(table.options, "debugColumns", "getRightLeafColumns"));
    table.getCenterLeafColumns = memo$1(() => [table.getAllLeafColumns(), table.getState().columnPinning.left, table.getState().columnPinning.right], (allColumns, left, right) => {
      const leftAndRight = [...left != null ? left : [], ...right != null ? right : []];
      return allColumns.filter((d4) => !leftAndRight.includes(d4.id));
    }, getMemoOptions(table.options, "debugColumns", "getCenterLeafColumns"));
  }
};
const defaultColumnSizing = {
  size: 150,
  minSize: 20,
  maxSize: Number.MAX_SAFE_INTEGER
};
const getDefaultColumnSizingInfoState = () => ({
  startOffset: null,
  startSize: null,
  deltaOffset: null,
  deltaPercentage: null,
  isResizingColumn: false,
  columnSizingStart: []
});
const ColumnSizing = {
  getDefaultColumnDef: () => {
    return defaultColumnSizing;
  },
  getInitialState: (state) => {
    return {
      columnSizing: {},
      columnSizingInfo: getDefaultColumnSizingInfoState(),
      ...state
    };
  },
  getDefaultOptions: (table) => {
    return {
      columnResizeMode: "onEnd",
      columnResizeDirection: "ltr",
      onColumnSizingChange: makeStateUpdater("columnSizing", table),
      onColumnSizingInfoChange: makeStateUpdater("columnSizingInfo", table)
    };
  },
  createColumn: (column, table) => {
    column.getSize = () => {
      var _column$columnDef$min, _ref, _column$columnDef$max;
      const columnSize = table.getState().columnSizing[column.id];
      return Math.min(Math.max((_column$columnDef$min = column.columnDef.minSize) != null ? _column$columnDef$min : defaultColumnSizing.minSize, (_ref = columnSize != null ? columnSize : column.columnDef.size) != null ? _ref : defaultColumnSizing.size), (_column$columnDef$max = column.columnDef.maxSize) != null ? _column$columnDef$max : defaultColumnSizing.maxSize);
    };
    column.getStart = memo$1((position) => [position, _getVisibleLeafColumns(table, position), table.getState().columnSizing], (position, columns) => columns.slice(0, column.getIndex(position)).reduce((sum2, column2) => sum2 + column2.getSize(), 0), getMemoOptions(table.options, "debugColumns", "getStart"));
    column.getAfter = memo$1((position) => [position, _getVisibleLeafColumns(table, position), table.getState().columnSizing], (position, columns) => columns.slice(column.getIndex(position) + 1).reduce((sum2, column2) => sum2 + column2.getSize(), 0), getMemoOptions(table.options, "debugColumns", "getAfter"));
    column.resetSize = () => {
      table.setColumnSizing((_ref2) => {
        let {
          [column.id]: _,
          ...rest
        } = _ref2;
        return rest;
      });
    };
    column.getCanResize = () => {
      var _column$columnDef$ena, _table$options$enable;
      return ((_column$columnDef$ena = column.columnDef.enableResizing) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableColumnResizing) != null ? _table$options$enable : true);
    };
    column.getIsResizing = () => {
      return table.getState().columnSizingInfo.isResizingColumn === column.id;
    };
  },
  createHeader: (header, table) => {
    header.getSize = () => {
      let sum2 = 0;
      const recurse = (header2) => {
        if (header2.subHeaders.length) {
          header2.subHeaders.forEach(recurse);
        } else {
          var _header$column$getSiz;
          sum2 += (_header$column$getSiz = header2.column.getSize()) != null ? _header$column$getSiz : 0;
        }
      };
      recurse(header);
      return sum2;
    };
    header.getStart = () => {
      if (header.index > 0) {
        const prevSiblingHeader = header.headerGroup.headers[header.index - 1];
        return prevSiblingHeader.getStart() + prevSiblingHeader.getSize();
      }
      return 0;
    };
    header.getResizeHandler = (_contextDocument) => {
      const column = table.getColumn(header.column.id);
      const canResize = column == null ? void 0 : column.getCanResize();
      return (e3) => {
        if (!column || !canResize) {
          return;
        }
        e3.persist == null || e3.persist();
        if (isTouchStartEvent(e3)) {
          if (e3.touches && e3.touches.length > 1) {
            return;
          }
        }
        const startSize = header.getSize();
        const columnSizingStart = header ? header.getLeafHeaders().map((d4) => [d4.column.id, d4.column.getSize()]) : [[column.id, column.getSize()]];
        const clientX = isTouchStartEvent(e3) ? Math.round(e3.touches[0].clientX) : e3.clientX;
        const newColumnSizing = {};
        const updateOffset = (eventType, clientXPos) => {
          if (typeof clientXPos !== "number") {
            return;
          }
          table.setColumnSizingInfo((old) => {
            var _old$startOffset, _old$startSize;
            const deltaDirection = table.options.columnResizeDirection === "rtl" ? -1 : 1;
            const deltaOffset = (clientXPos - ((_old$startOffset = old == null ? void 0 : old.startOffset) != null ? _old$startOffset : 0)) * deltaDirection;
            const deltaPercentage = Math.max(deltaOffset / ((_old$startSize = old == null ? void 0 : old.startSize) != null ? _old$startSize : 0), -0.999999);
            old.columnSizingStart.forEach((_ref3) => {
              let [columnId, headerSize] = _ref3;
              newColumnSizing[columnId] = Math.round(Math.max(headerSize + headerSize * deltaPercentage, 0) * 100) / 100;
            });
            return {
              ...old,
              deltaOffset,
              deltaPercentage
            };
          });
          if (table.options.columnResizeMode === "onChange" || eventType === "end") {
            table.setColumnSizing((old) => ({
              ...old,
              ...newColumnSizing
            }));
          }
        };
        const onMove = (clientXPos) => updateOffset("move", clientXPos);
        const onEnd = (clientXPos) => {
          updateOffset("end", clientXPos);
          table.setColumnSizingInfo((old) => ({
            ...old,
            isResizingColumn: false,
            startOffset: null,
            startSize: null,
            deltaOffset: null,
            deltaPercentage: null,
            columnSizingStart: []
          }));
        };
        const contextDocument = _contextDocument || typeof document !== "undefined" ? document : null;
        const mouseEvents = {
          moveHandler: (e4) => onMove(e4.clientX),
          upHandler: (e4) => {
            contextDocument == null || contextDocument.removeEventListener("mousemove", mouseEvents.moveHandler);
            contextDocument == null || contextDocument.removeEventListener("mouseup", mouseEvents.upHandler);
            onEnd(e4.clientX);
          }
        };
        const touchEvents = {
          moveHandler: (e4) => {
            if (e4.cancelable) {
              e4.preventDefault();
              e4.stopPropagation();
            }
            onMove(e4.touches[0].clientX);
            return false;
          },
          upHandler: (e4) => {
            var _e$touches$;
            contextDocument == null || contextDocument.removeEventListener("touchmove", touchEvents.moveHandler);
            contextDocument == null || contextDocument.removeEventListener("touchend", touchEvents.upHandler);
            if (e4.cancelable) {
              e4.preventDefault();
              e4.stopPropagation();
            }
            onEnd((_e$touches$ = e4.touches[0]) == null ? void 0 : _e$touches$.clientX);
          }
        };
        const passiveIfSupported = passiveEventSupported() ? {
          passive: false
        } : false;
        if (isTouchStartEvent(e3)) {
          contextDocument == null || contextDocument.addEventListener("touchmove", touchEvents.moveHandler, passiveIfSupported);
          contextDocument == null || contextDocument.addEventListener("touchend", touchEvents.upHandler, passiveIfSupported);
        } else {
          contextDocument == null || contextDocument.addEventListener("mousemove", mouseEvents.moveHandler, passiveIfSupported);
          contextDocument == null || contextDocument.addEventListener("mouseup", mouseEvents.upHandler, passiveIfSupported);
        }
        table.setColumnSizingInfo((old) => ({
          ...old,
          startOffset: clientX,
          startSize,
          deltaOffset: 0,
          deltaPercentage: 0,
          columnSizingStart,
          isResizingColumn: column.id
        }));
      };
    };
  },
  createTable: (table) => {
    table.setColumnSizing = (updater) => table.options.onColumnSizingChange == null ? void 0 : table.options.onColumnSizingChange(updater);
    table.setColumnSizingInfo = (updater) => table.options.onColumnSizingInfoChange == null ? void 0 : table.options.onColumnSizingInfoChange(updater);
    table.resetColumnSizing = (defaultState2) => {
      var _table$initialState$c;
      table.setColumnSizing(defaultState2 ? {} : (_table$initialState$c = table.initialState.columnSizing) != null ? _table$initialState$c : {});
    };
    table.resetHeaderSizeInfo = (defaultState2) => {
      var _table$initialState$c2;
      table.setColumnSizingInfo(defaultState2 ? getDefaultColumnSizingInfoState() : (_table$initialState$c2 = table.initialState.columnSizingInfo) != null ? _table$initialState$c2 : getDefaultColumnSizingInfoState());
    };
    table.getTotalSize = () => {
      var _table$getHeaderGroup, _table$getHeaderGroup2;
      return (_table$getHeaderGroup = (_table$getHeaderGroup2 = table.getHeaderGroups()[0]) == null ? void 0 : _table$getHeaderGroup2.headers.reduce((sum2, header) => {
        return sum2 + header.getSize();
      }, 0)) != null ? _table$getHeaderGroup : 0;
    };
    table.getLeftTotalSize = () => {
      var _table$getLeftHeaderG, _table$getLeftHeaderG2;
      return (_table$getLeftHeaderG = (_table$getLeftHeaderG2 = table.getLeftHeaderGroups()[0]) == null ? void 0 : _table$getLeftHeaderG2.headers.reduce((sum2, header) => {
        return sum2 + header.getSize();
      }, 0)) != null ? _table$getLeftHeaderG : 0;
    };
    table.getCenterTotalSize = () => {
      var _table$getCenterHeade, _table$getCenterHeade2;
      return (_table$getCenterHeade = (_table$getCenterHeade2 = table.getCenterHeaderGroups()[0]) == null ? void 0 : _table$getCenterHeade2.headers.reduce((sum2, header) => {
        return sum2 + header.getSize();
      }, 0)) != null ? _table$getCenterHeade : 0;
    };
    table.getRightTotalSize = () => {
      var _table$getRightHeader, _table$getRightHeader2;
      return (_table$getRightHeader = (_table$getRightHeader2 = table.getRightHeaderGroups()[0]) == null ? void 0 : _table$getRightHeader2.headers.reduce((sum2, header) => {
        return sum2 + header.getSize();
      }, 0)) != null ? _table$getRightHeader : 0;
    };
  }
};
let passiveSupported = null;
function passiveEventSupported() {
  if (typeof passiveSupported === "boolean") return passiveSupported;
  let supported = false;
  try {
    const options = {
      get passive() {
        supported = true;
        return false;
      }
    };
    const noop2 = () => {
    };
    window.addEventListener("test", noop2, options);
    window.removeEventListener("test", noop2);
  } catch (err) {
    supported = false;
  }
  passiveSupported = supported;
  return passiveSupported;
}
function isTouchStartEvent(e3) {
  return e3.type === "touchstart";
}
const ColumnVisibility = {
  getInitialState: (state) => {
    return {
      columnVisibility: {},
      ...state
    };
  },
  getDefaultOptions: (table) => {
    return {
      onColumnVisibilityChange: makeStateUpdater("columnVisibility", table)
    };
  },
  createColumn: (column, table) => {
    column.toggleVisibility = (value) => {
      if (column.getCanHide()) {
        table.setColumnVisibility((old) => ({
          ...old,
          [column.id]: value != null ? value : !column.getIsVisible()
        }));
      }
    };
    column.getIsVisible = () => {
      var _ref, _table$getState$colum;
      const childColumns = column.columns;
      return (_ref = childColumns.length ? childColumns.some((c3) => c3.getIsVisible()) : (_table$getState$colum = table.getState().columnVisibility) == null ? void 0 : _table$getState$colum[column.id]) != null ? _ref : true;
    };
    column.getCanHide = () => {
      var _column$columnDef$ena, _table$options$enable;
      return ((_column$columnDef$ena = column.columnDef.enableHiding) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableHiding) != null ? _table$options$enable : true);
    };
    column.getToggleVisibilityHandler = () => {
      return (e3) => {
        column.toggleVisibility == null || column.toggleVisibility(e3.target.checked);
      };
    };
  },
  createRow: (row, table) => {
    row._getAllVisibleCells = memo$1(() => [row.getAllCells(), table.getState().columnVisibility], (cells) => {
      return cells.filter((cell) => cell.column.getIsVisible());
    }, getMemoOptions(table.options, "debugRows", "_getAllVisibleCells"));
    row.getVisibleCells = memo$1(() => [row.getLeftVisibleCells(), row.getCenterVisibleCells(), row.getRightVisibleCells()], (left, center, right) => [...left, ...center, ...right], getMemoOptions(table.options, "debugRows", "getVisibleCells"));
  },
  createTable: (table) => {
    const makeVisibleColumnsMethod = (key, getColumns) => {
      return memo$1(() => [getColumns(), getColumns().filter((d4) => d4.getIsVisible()).map((d4) => d4.id).join("_")], (columns) => {
        return columns.filter((d4) => d4.getIsVisible == null ? void 0 : d4.getIsVisible());
      }, getMemoOptions(table.options, "debugColumns", key));
    };
    table.getVisibleFlatColumns = makeVisibleColumnsMethod("getVisibleFlatColumns", () => table.getAllFlatColumns());
    table.getVisibleLeafColumns = makeVisibleColumnsMethod("getVisibleLeafColumns", () => table.getAllLeafColumns());
    table.getLeftVisibleLeafColumns = makeVisibleColumnsMethod("getLeftVisibleLeafColumns", () => table.getLeftLeafColumns());
    table.getRightVisibleLeafColumns = makeVisibleColumnsMethod("getRightVisibleLeafColumns", () => table.getRightLeafColumns());
    table.getCenterVisibleLeafColumns = makeVisibleColumnsMethod("getCenterVisibleLeafColumns", () => table.getCenterLeafColumns());
    table.setColumnVisibility = (updater) => table.options.onColumnVisibilityChange == null ? void 0 : table.options.onColumnVisibilityChange(updater);
    table.resetColumnVisibility = (defaultState2) => {
      var _table$initialState$c;
      table.setColumnVisibility(defaultState2 ? {} : (_table$initialState$c = table.initialState.columnVisibility) != null ? _table$initialState$c : {});
    };
    table.toggleAllColumnsVisible = (value) => {
      var _value;
      value = (_value = value) != null ? _value : !table.getIsAllColumnsVisible();
      table.setColumnVisibility(table.getAllLeafColumns().reduce((obj, column) => ({
        ...obj,
        [column.id]: !value ? !(column.getCanHide != null && column.getCanHide()) : value
      }), {}));
    };
    table.getIsAllColumnsVisible = () => !table.getAllLeafColumns().some((column) => !(column.getIsVisible != null && column.getIsVisible()));
    table.getIsSomeColumnsVisible = () => table.getAllLeafColumns().some((column) => column.getIsVisible == null ? void 0 : column.getIsVisible());
    table.getToggleAllColumnsVisibilityHandler = () => {
      return (e3) => {
        var _target;
        table.toggleAllColumnsVisible((_target = e3.target) == null ? void 0 : _target.checked);
      };
    };
  }
};
function _getVisibleLeafColumns(table, position) {
  return !position ? table.getVisibleLeafColumns() : position === "center" ? table.getCenterVisibleLeafColumns() : position === "left" ? table.getLeftVisibleLeafColumns() : table.getRightVisibleLeafColumns();
}
const GlobalFaceting = {
  createTable: (table) => {
    table._getGlobalFacetedRowModel = table.options.getFacetedRowModel && table.options.getFacetedRowModel(table, "__global__");
    table.getGlobalFacetedRowModel = () => {
      if (table.options.manualFiltering || !table._getGlobalFacetedRowModel) {
        return table.getPreFilteredRowModel();
      }
      return table._getGlobalFacetedRowModel();
    };
    table._getGlobalFacetedUniqueValues = table.options.getFacetedUniqueValues && table.options.getFacetedUniqueValues(table, "__global__");
    table.getGlobalFacetedUniqueValues = () => {
      if (!table._getGlobalFacetedUniqueValues) {
        return /* @__PURE__ */ new Map();
      }
      return table._getGlobalFacetedUniqueValues();
    };
    table._getGlobalFacetedMinMaxValues = table.options.getFacetedMinMaxValues && table.options.getFacetedMinMaxValues(table, "__global__");
    table.getGlobalFacetedMinMaxValues = () => {
      if (!table._getGlobalFacetedMinMaxValues) {
        return;
      }
      return table._getGlobalFacetedMinMaxValues();
    };
  }
};
const GlobalFiltering = {
  getInitialState: (state) => {
    return {
      globalFilter: void 0,
      ...state
    };
  },
  getDefaultOptions: (table) => {
    return {
      onGlobalFilterChange: makeStateUpdater("globalFilter", table),
      globalFilterFn: "auto",
      getColumnCanGlobalFilter: (column) => {
        var _table$getCoreRowMode;
        const value = (_table$getCoreRowMode = table.getCoreRowModel().flatRows[0]) == null || (_table$getCoreRowMode = _table$getCoreRowMode._getAllCellsByColumnId()[column.id]) == null ? void 0 : _table$getCoreRowMode.getValue();
        return typeof value === "string" || typeof value === "number";
      }
    };
  },
  createColumn: (column, table) => {
    column.getCanGlobalFilter = () => {
      var _column$columnDef$ena, _table$options$enable, _table$options$enable2, _table$options$getCol;
      return ((_column$columnDef$ena = column.columnDef.enableGlobalFilter) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableGlobalFilter) != null ? _table$options$enable : true) && ((_table$options$enable2 = table.options.enableFilters) != null ? _table$options$enable2 : true) && ((_table$options$getCol = table.options.getColumnCanGlobalFilter == null ? void 0 : table.options.getColumnCanGlobalFilter(column)) != null ? _table$options$getCol : true) && !!column.accessorFn;
    };
  },
  createTable: (table) => {
    table.getGlobalAutoFilterFn = () => {
      return filterFns.includesString;
    };
    table.getGlobalFilterFn = () => {
      var _table$options$filter, _table$options$filter2;
      const {
        globalFilterFn: globalFilterFn2
      } = table.options;
      return isFunction$4(globalFilterFn2) ? globalFilterFn2 : globalFilterFn2 === "auto" ? table.getGlobalAutoFilterFn() : (_table$options$filter = (_table$options$filter2 = table.options.filterFns) == null ? void 0 : _table$options$filter2[globalFilterFn2]) != null ? _table$options$filter : filterFns[globalFilterFn2];
    };
    table.setGlobalFilter = (updater) => {
      table.options.onGlobalFilterChange == null || table.options.onGlobalFilterChange(updater);
    };
    table.resetGlobalFilter = (defaultState2) => {
      table.setGlobalFilter(defaultState2 ? void 0 : table.initialState.globalFilter);
    };
  }
};
const RowExpanding = {
  getInitialState: (state) => {
    return {
      expanded: {},
      ...state
    };
  },
  getDefaultOptions: (table) => {
    return {
      onExpandedChange: makeStateUpdater("expanded", table),
      paginateExpandedRows: true
    };
  },
  createTable: (table) => {
    let registered = false;
    let queued = false;
    table._autoResetExpanded = () => {
      var _ref, _table$options$autoRe;
      if (!registered) {
        table._queue(() => {
          registered = true;
        });
        return;
      }
      if ((_ref = (_table$options$autoRe = table.options.autoResetAll) != null ? _table$options$autoRe : table.options.autoResetExpanded) != null ? _ref : !table.options.manualExpanding) {
        if (queued) return;
        queued = true;
        table._queue(() => {
          table.resetExpanded();
          queued = false;
        });
      }
    };
    table.setExpanded = (updater) => table.options.onExpandedChange == null ? void 0 : table.options.onExpandedChange(updater);
    table.toggleAllRowsExpanded = (expanded) => {
      if (expanded != null ? expanded : !table.getIsAllRowsExpanded()) {
        table.setExpanded(true);
      } else {
        table.setExpanded({});
      }
    };
    table.resetExpanded = (defaultState2) => {
      var _table$initialState$e, _table$initialState;
      table.setExpanded(defaultState2 ? {} : (_table$initialState$e = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.expanded) != null ? _table$initialState$e : {});
    };
    table.getCanSomeRowsExpand = () => {
      return table.getPrePaginationRowModel().flatRows.some((row) => row.getCanExpand());
    };
    table.getToggleAllRowsExpandedHandler = () => {
      return (e3) => {
        e3.persist == null || e3.persist();
        table.toggleAllRowsExpanded();
      };
    };
    table.getIsSomeRowsExpanded = () => {
      const expanded = table.getState().expanded;
      return expanded === true || Object.values(expanded).some(Boolean);
    };
    table.getIsAllRowsExpanded = () => {
      const expanded = table.getState().expanded;
      if (typeof expanded === "boolean") {
        return expanded === true;
      }
      if (!Object.keys(expanded).length) {
        return false;
      }
      if (table.getRowModel().flatRows.some((row) => !row.getIsExpanded())) {
        return false;
      }
      return true;
    };
    table.getExpandedDepth = () => {
      let maxDepth2 = 0;
      const rowIds = table.getState().expanded === true ? Object.keys(table.getRowModel().rowsById) : Object.keys(table.getState().expanded);
      rowIds.forEach((id2) => {
        const splitId = id2.split(".");
        maxDepth2 = Math.max(maxDepth2, splitId.length);
      });
      return maxDepth2;
    };
    table.getPreExpandedRowModel = () => table.getSortedRowModel();
    table.getExpandedRowModel = () => {
      if (!table._getExpandedRowModel && table.options.getExpandedRowModel) {
        table._getExpandedRowModel = table.options.getExpandedRowModel(table);
      }
      if (table.options.manualExpanding || !table._getExpandedRowModel) {
        return table.getPreExpandedRowModel();
      }
      return table._getExpandedRowModel();
    };
  },
  createRow: (row, table) => {
    row.toggleExpanded = (expanded) => {
      table.setExpanded((old) => {
        var _expanded;
        const exists = old === true ? true : !!(old != null && old[row.id]);
        let oldExpanded = {};
        if (old === true) {
          Object.keys(table.getRowModel().rowsById).forEach((rowId) => {
            oldExpanded[rowId] = true;
          });
        } else {
          oldExpanded = old;
        }
        expanded = (_expanded = expanded) != null ? _expanded : !exists;
        if (!exists && expanded) {
          return {
            ...oldExpanded,
            [row.id]: true
          };
        }
        if (exists && !expanded) {
          const {
            [row.id]: _,
            ...rest
          } = oldExpanded;
          return rest;
        }
        return old;
      });
    };
    row.getIsExpanded = () => {
      var _table$options$getIsR;
      const expanded = table.getState().expanded;
      return !!((_table$options$getIsR = table.options.getIsRowExpanded == null ? void 0 : table.options.getIsRowExpanded(row)) != null ? _table$options$getIsR : expanded === true || (expanded == null ? void 0 : expanded[row.id]));
    };
    row.getCanExpand = () => {
      var _table$options$getRow, _table$options$enable, _row$subRows;
      return (_table$options$getRow = table.options.getRowCanExpand == null ? void 0 : table.options.getRowCanExpand(row)) != null ? _table$options$getRow : ((_table$options$enable = table.options.enableExpanding) != null ? _table$options$enable : true) && !!((_row$subRows = row.subRows) != null && _row$subRows.length);
    };
    row.getIsAllParentsExpanded = () => {
      let isFullyExpanded = true;
      let currentRow = row;
      while (isFullyExpanded && currentRow.parentId) {
        currentRow = table.getRow(currentRow.parentId, true);
        isFullyExpanded = currentRow.getIsExpanded();
      }
      return isFullyExpanded;
    };
    row.getToggleExpandedHandler = () => {
      const canExpand = row.getCanExpand();
      return () => {
        if (!canExpand) return;
        row.toggleExpanded();
      };
    };
  }
};
const defaultPageIndex = 0;
const defaultPageSize = 10;
const getDefaultPaginationState = () => ({
  pageIndex: defaultPageIndex,
  pageSize: defaultPageSize
});
const RowPagination = {
  getInitialState: (state) => {
    return {
      ...state,
      pagination: {
        ...getDefaultPaginationState(),
        ...state == null ? void 0 : state.pagination
      }
    };
  },
  getDefaultOptions: (table) => {
    return {
      onPaginationChange: makeStateUpdater("pagination", table)
    };
  },
  createTable: (table) => {
    let registered = false;
    let queued = false;
    table._autoResetPageIndex = () => {
      var _ref, _table$options$autoRe;
      if (!registered) {
        table._queue(() => {
          registered = true;
        });
        return;
      }
      if ((_ref = (_table$options$autoRe = table.options.autoResetAll) != null ? _table$options$autoRe : table.options.autoResetPageIndex) != null ? _ref : !table.options.manualPagination) {
        if (queued) return;
        queued = true;
        table._queue(() => {
          table.resetPageIndex();
          queued = false;
        });
      }
    };
    table.setPagination = (updater) => {
      const safeUpdater = (old) => {
        let newState = functionalUpdate(updater, old);
        return newState;
      };
      return table.options.onPaginationChange == null ? void 0 : table.options.onPaginationChange(safeUpdater);
    };
    table.resetPagination = (defaultState2) => {
      var _table$initialState$p;
      table.setPagination(defaultState2 ? getDefaultPaginationState() : (_table$initialState$p = table.initialState.pagination) != null ? _table$initialState$p : getDefaultPaginationState());
    };
    table.setPageIndex = (updater) => {
      table.setPagination((old) => {
        let pageIndex = functionalUpdate(updater, old.pageIndex);
        const maxPageIndex = typeof table.options.pageCount === "undefined" || table.options.pageCount === -1 ? Number.MAX_SAFE_INTEGER : table.options.pageCount - 1;
        pageIndex = Math.max(0, Math.min(pageIndex, maxPageIndex));
        return {
          ...old,
          pageIndex
        };
      });
    };
    table.resetPageIndex = (defaultState2) => {
      var _table$initialState$p2, _table$initialState;
      table.setPageIndex(defaultState2 ? defaultPageIndex : (_table$initialState$p2 = (_table$initialState = table.initialState) == null || (_table$initialState = _table$initialState.pagination) == null ? void 0 : _table$initialState.pageIndex) != null ? _table$initialState$p2 : defaultPageIndex);
    };
    table.resetPageSize = (defaultState2) => {
      var _table$initialState$p3, _table$initialState2;
      table.setPageSize(defaultState2 ? defaultPageSize : (_table$initialState$p3 = (_table$initialState2 = table.initialState) == null || (_table$initialState2 = _table$initialState2.pagination) == null ? void 0 : _table$initialState2.pageSize) != null ? _table$initialState$p3 : defaultPageSize);
    };
    table.setPageSize = (updater) => {
      table.setPagination((old) => {
        const pageSize = Math.max(1, functionalUpdate(updater, old.pageSize));
        const topRowIndex = old.pageSize * old.pageIndex;
        const pageIndex = Math.floor(topRowIndex / pageSize);
        return {
          ...old,
          pageIndex,
          pageSize
        };
      });
    };
    table.setPageCount = (updater) => table.setPagination((old) => {
      var _table$options$pageCo;
      let newPageCount = functionalUpdate(updater, (_table$options$pageCo = table.options.pageCount) != null ? _table$options$pageCo : -1);
      if (typeof newPageCount === "number") {
        newPageCount = Math.max(-1, newPageCount);
      }
      return {
        ...old,
        pageCount: newPageCount
      };
    });
    table.getPageOptions = memo$1(() => [table.getPageCount()], (pageCount) => {
      let pageOptions = [];
      if (pageCount && pageCount > 0) {
        pageOptions = [...new Array(pageCount)].fill(null).map((_, i3) => i3);
      }
      return pageOptions;
    }, getMemoOptions(table.options, "debugTable", "getPageOptions"));
    table.getCanPreviousPage = () => table.getState().pagination.pageIndex > 0;
    table.getCanNextPage = () => {
      const {
        pageIndex
      } = table.getState().pagination;
      const pageCount = table.getPageCount();
      if (pageCount === -1) {
        return true;
      }
      if (pageCount === 0) {
        return false;
      }
      return pageIndex < pageCount - 1;
    };
    table.previousPage = () => {
      return table.setPageIndex((old) => old - 1);
    };
    table.nextPage = () => {
      return table.setPageIndex((old) => {
        return old + 1;
      });
    };
    table.firstPage = () => {
      return table.setPageIndex(0);
    };
    table.lastPage = () => {
      return table.setPageIndex(table.getPageCount() - 1);
    };
    table.getPrePaginationRowModel = () => table.getExpandedRowModel();
    table.getPaginationRowModel = () => {
      if (!table._getPaginationRowModel && table.options.getPaginationRowModel) {
        table._getPaginationRowModel = table.options.getPaginationRowModel(table);
      }
      if (table.options.manualPagination || !table._getPaginationRowModel) {
        return table.getPrePaginationRowModel();
      }
      return table._getPaginationRowModel();
    };
    table.getPageCount = () => {
      var _table$options$pageCo2;
      return (_table$options$pageCo2 = table.options.pageCount) != null ? _table$options$pageCo2 : Math.ceil(table.getRowCount() / table.getState().pagination.pageSize);
    };
    table.getRowCount = () => {
      var _table$options$rowCou;
      return (_table$options$rowCou = table.options.rowCount) != null ? _table$options$rowCou : table.getPrePaginationRowModel().rows.length;
    };
  }
};
const getDefaultRowPinningState = () => ({
  top: [],
  bottom: []
});
const RowPinning = {
  getInitialState: (state) => {
    return {
      rowPinning: getDefaultRowPinningState(),
      ...state
    };
  },
  getDefaultOptions: (table) => {
    return {
      onRowPinningChange: makeStateUpdater("rowPinning", table)
    };
  },
  createRow: (row, table) => {
    row.pin = (position, includeLeafRows, includeParentRows) => {
      const leafRowIds = includeLeafRows ? row.getLeafRows().map((_ref) => {
        let {
          id: id2
        } = _ref;
        return id2;
      }) : [];
      const parentRowIds = includeParentRows ? row.getParentRows().map((_ref2) => {
        let {
          id: id2
        } = _ref2;
        return id2;
      }) : [];
      const rowIds = /* @__PURE__ */ new Set([...parentRowIds, row.id, ...leafRowIds]);
      table.setRowPinning((old) => {
        var _old$top3, _old$bottom3;
        if (position === "bottom") {
          var _old$top, _old$bottom;
          return {
            top: ((_old$top = old == null ? void 0 : old.top) != null ? _old$top : []).filter((d4) => !(rowIds != null && rowIds.has(d4))),
            bottom: [...((_old$bottom = old == null ? void 0 : old.bottom) != null ? _old$bottom : []).filter((d4) => !(rowIds != null && rowIds.has(d4))), ...Array.from(rowIds)]
          };
        }
        if (position === "top") {
          var _old$top2, _old$bottom2;
          return {
            top: [...((_old$top2 = old == null ? void 0 : old.top) != null ? _old$top2 : []).filter((d4) => !(rowIds != null && rowIds.has(d4))), ...Array.from(rowIds)],
            bottom: ((_old$bottom2 = old == null ? void 0 : old.bottom) != null ? _old$bottom2 : []).filter((d4) => !(rowIds != null && rowIds.has(d4)))
          };
        }
        return {
          top: ((_old$top3 = old == null ? void 0 : old.top) != null ? _old$top3 : []).filter((d4) => !(rowIds != null && rowIds.has(d4))),
          bottom: ((_old$bottom3 = old == null ? void 0 : old.bottom) != null ? _old$bottom3 : []).filter((d4) => !(rowIds != null && rowIds.has(d4)))
        };
      });
    };
    row.getCanPin = () => {
      var _ref3;
      const {
        enableRowPinning,
        enablePinning
      } = table.options;
      if (typeof enableRowPinning === "function") {
        return enableRowPinning(row);
      }
      return (_ref3 = enableRowPinning != null ? enableRowPinning : enablePinning) != null ? _ref3 : true;
    };
    row.getIsPinned = () => {
      const rowIds = [row.id];
      const {
        top,
        bottom
      } = table.getState().rowPinning;
      const isTop = rowIds.some((d4) => top == null ? void 0 : top.includes(d4));
      const isBottom = rowIds.some((d4) => bottom == null ? void 0 : bottom.includes(d4));
      return isTop ? "top" : isBottom ? "bottom" : false;
    };
    row.getPinnedIndex = () => {
      var _ref4, _visiblePinnedRowIds$;
      const position = row.getIsPinned();
      if (!position) return -1;
      const visiblePinnedRowIds = (_ref4 = position === "top" ? table.getTopRows() : table.getBottomRows()) == null ? void 0 : _ref4.map((_ref5) => {
        let {
          id: id2
        } = _ref5;
        return id2;
      });
      return (_visiblePinnedRowIds$ = visiblePinnedRowIds == null ? void 0 : visiblePinnedRowIds.indexOf(row.id)) != null ? _visiblePinnedRowIds$ : -1;
    };
  },
  createTable: (table) => {
    table.setRowPinning = (updater) => table.options.onRowPinningChange == null ? void 0 : table.options.onRowPinningChange(updater);
    table.resetRowPinning = (defaultState2) => {
      var _table$initialState$r, _table$initialState;
      return table.setRowPinning(defaultState2 ? getDefaultRowPinningState() : (_table$initialState$r = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.rowPinning) != null ? _table$initialState$r : getDefaultRowPinningState());
    };
    table.getIsSomeRowsPinned = (position) => {
      var _pinningState$positio;
      const pinningState = table.getState().rowPinning;
      if (!position) {
        var _pinningState$top, _pinningState$bottom;
        return Boolean(((_pinningState$top = pinningState.top) == null ? void 0 : _pinningState$top.length) || ((_pinningState$bottom = pinningState.bottom) == null ? void 0 : _pinningState$bottom.length));
      }
      return Boolean((_pinningState$positio = pinningState[position]) == null ? void 0 : _pinningState$positio.length);
    };
    table._getPinnedRows = (visibleRows, pinnedRowIds, position) => {
      var _table$options$keepPi;
      const rows = ((_table$options$keepPi = table.options.keepPinnedRows) != null ? _table$options$keepPi : true) ? (
        //get all rows that are pinned even if they would not be otherwise visible
        //account for expanded parent rows, but not pagination or filtering
        (pinnedRowIds != null ? pinnedRowIds : []).map((rowId) => {
          const row = table.getRow(rowId, true);
          return row.getIsAllParentsExpanded() ? row : null;
        })
      ) : (
        //else get only visible rows that are pinned
        (pinnedRowIds != null ? pinnedRowIds : []).map((rowId) => visibleRows.find((row) => row.id === rowId))
      );
      return rows.filter(Boolean).map((d4) => ({
        ...d4,
        position
      }));
    };
    table.getTopRows = memo$1(() => [table.getRowModel().rows, table.getState().rowPinning.top], (allRows, topPinnedRowIds) => table._getPinnedRows(allRows, topPinnedRowIds, "top"), getMemoOptions(table.options, "debugRows", "getTopRows"));
    table.getBottomRows = memo$1(() => [table.getRowModel().rows, table.getState().rowPinning.bottom], (allRows, bottomPinnedRowIds) => table._getPinnedRows(allRows, bottomPinnedRowIds, "bottom"), getMemoOptions(table.options, "debugRows", "getBottomRows"));
    table.getCenterRows = memo$1(() => [table.getRowModel().rows, table.getState().rowPinning.top, table.getState().rowPinning.bottom], (allRows, top, bottom) => {
      const topAndBottom = /* @__PURE__ */ new Set([...top != null ? top : [], ...bottom != null ? bottom : []]);
      return allRows.filter((d4) => !topAndBottom.has(d4.id));
    }, getMemoOptions(table.options, "debugRows", "getCenterRows"));
  }
};
const RowSelection = {
  getInitialState: (state) => {
    return {
      rowSelection: {},
      ...state
    };
  },
  getDefaultOptions: (table) => {
    return {
      onRowSelectionChange: makeStateUpdater("rowSelection", table),
      enableRowSelection: true,
      enableMultiRowSelection: true,
      enableSubRowSelection: true
      // enableGroupingRowSelection: false,
      // isAdditiveSelectEvent: (e: unknown) => !!e.metaKey,
      // isInclusiveSelectEvent: (e: unknown) => !!e.shiftKey,
    };
  },
  createTable: (table) => {
    table.setRowSelection = (updater) => table.options.onRowSelectionChange == null ? void 0 : table.options.onRowSelectionChange(updater);
    table.resetRowSelection = (defaultState2) => {
      var _table$initialState$r;
      return table.setRowSelection(defaultState2 ? {} : (_table$initialState$r = table.initialState.rowSelection) != null ? _table$initialState$r : {});
    };
    table.toggleAllRowsSelected = (value) => {
      table.setRowSelection((old) => {
        value = typeof value !== "undefined" ? value : !table.getIsAllRowsSelected();
        const rowSelection = {
          ...old
        };
        const preGroupedFlatRows = table.getPreGroupedRowModel().flatRows;
        if (value) {
          preGroupedFlatRows.forEach((row) => {
            if (!row.getCanSelect()) {
              return;
            }
            rowSelection[row.id] = true;
          });
        } else {
          preGroupedFlatRows.forEach((row) => {
            delete rowSelection[row.id];
          });
        }
        return rowSelection;
      });
    };
    table.toggleAllPageRowsSelected = (value) => table.setRowSelection((old) => {
      const resolvedValue = typeof value !== "undefined" ? value : !table.getIsAllPageRowsSelected();
      const rowSelection = {
        ...old
      };
      table.getRowModel().rows.forEach((row) => {
        mutateRowIsSelected(rowSelection, row.id, resolvedValue, true, table);
      });
      return rowSelection;
    });
    table.getPreSelectedRowModel = () => table.getCoreRowModel();
    table.getSelectedRowModel = memo$1(() => [table.getState().rowSelection, table.getCoreRowModel()], (rowSelection, rowModel) => {
      if (!Object.keys(rowSelection).length) {
        return {
          rows: [],
          flatRows: [],
          rowsById: {}
        };
      }
      return selectRowsFn(table, rowModel);
    }, getMemoOptions(table.options, "debugTable", "getSelectedRowModel"));
    table.getFilteredSelectedRowModel = memo$1(() => [table.getState().rowSelection, table.getFilteredRowModel()], (rowSelection, rowModel) => {
      if (!Object.keys(rowSelection).length) {
        return {
          rows: [],
          flatRows: [],
          rowsById: {}
        };
      }
      return selectRowsFn(table, rowModel);
    }, getMemoOptions(table.options, "debugTable", "getFilteredSelectedRowModel"));
    table.getGroupedSelectedRowModel = memo$1(() => [table.getState().rowSelection, table.getSortedRowModel()], (rowSelection, rowModel) => {
      if (!Object.keys(rowSelection).length) {
        return {
          rows: [],
          flatRows: [],
          rowsById: {}
        };
      }
      return selectRowsFn(table, rowModel);
    }, getMemoOptions(table.options, "debugTable", "getGroupedSelectedRowModel"));
    table.getIsAllRowsSelected = () => {
      const preGroupedFlatRows = table.getFilteredRowModel().flatRows;
      const {
        rowSelection
      } = table.getState();
      let isAllRowsSelected = Boolean(preGroupedFlatRows.length && Object.keys(rowSelection).length);
      if (isAllRowsSelected) {
        if (preGroupedFlatRows.some((row) => row.getCanSelect() && !rowSelection[row.id])) {
          isAllRowsSelected = false;
        }
      }
      return isAllRowsSelected;
    };
    table.getIsAllPageRowsSelected = () => {
      const paginationFlatRows = table.getPaginationRowModel().flatRows.filter((row) => row.getCanSelect());
      const {
        rowSelection
      } = table.getState();
      let isAllPageRowsSelected = !!paginationFlatRows.length;
      if (isAllPageRowsSelected && paginationFlatRows.some((row) => !rowSelection[row.id])) {
        isAllPageRowsSelected = false;
      }
      return isAllPageRowsSelected;
    };
    table.getIsSomeRowsSelected = () => {
      var _table$getState$rowSe;
      const totalSelected = Object.keys((_table$getState$rowSe = table.getState().rowSelection) != null ? _table$getState$rowSe : {}).length;
      return totalSelected > 0 && totalSelected < table.getFilteredRowModel().flatRows.length;
    };
    table.getIsSomePageRowsSelected = () => {
      const paginationFlatRows = table.getPaginationRowModel().flatRows;
      return table.getIsAllPageRowsSelected() ? false : paginationFlatRows.filter((row) => row.getCanSelect()).some((d4) => d4.getIsSelected() || d4.getIsSomeSelected());
    };
    table.getToggleAllRowsSelectedHandler = () => {
      return (e3) => {
        table.toggleAllRowsSelected(e3.target.checked);
      };
    };
    table.getToggleAllPageRowsSelectedHandler = () => {
      return (e3) => {
        table.toggleAllPageRowsSelected(e3.target.checked);
      };
    };
  },
  createRow: (row, table) => {
    row.toggleSelected = (value, opts) => {
      const isSelected = row.getIsSelected();
      table.setRowSelection((old) => {
        var _opts$selectChildren;
        value = typeof value !== "undefined" ? value : !isSelected;
        if (row.getCanSelect() && isSelected === value) {
          return old;
        }
        const selectedRowIds = {
          ...old
        };
        mutateRowIsSelected(selectedRowIds, row.id, value, (_opts$selectChildren = opts == null ? void 0 : opts.selectChildren) != null ? _opts$selectChildren : true, table);
        return selectedRowIds;
      });
    };
    row.getIsSelected = () => {
      const {
        rowSelection
      } = table.getState();
      return isRowSelected(row, rowSelection);
    };
    row.getIsSomeSelected = () => {
      const {
        rowSelection
      } = table.getState();
      return isSubRowSelected(row, rowSelection) === "some";
    };
    row.getIsAllSubRowsSelected = () => {
      const {
        rowSelection
      } = table.getState();
      return isSubRowSelected(row, rowSelection) === "all";
    };
    row.getCanSelect = () => {
      var _table$options$enable;
      if (typeof table.options.enableRowSelection === "function") {
        return table.options.enableRowSelection(row);
      }
      return (_table$options$enable = table.options.enableRowSelection) != null ? _table$options$enable : true;
    };
    row.getCanSelectSubRows = () => {
      var _table$options$enable2;
      if (typeof table.options.enableSubRowSelection === "function") {
        return table.options.enableSubRowSelection(row);
      }
      return (_table$options$enable2 = table.options.enableSubRowSelection) != null ? _table$options$enable2 : true;
    };
    row.getCanMultiSelect = () => {
      var _table$options$enable3;
      if (typeof table.options.enableMultiRowSelection === "function") {
        return table.options.enableMultiRowSelection(row);
      }
      return (_table$options$enable3 = table.options.enableMultiRowSelection) != null ? _table$options$enable3 : true;
    };
    row.getToggleSelectedHandler = () => {
      const canSelect = row.getCanSelect();
      return (e3) => {
        var _target;
        if (!canSelect) return;
        row.toggleSelected((_target = e3.target) == null ? void 0 : _target.checked);
      };
    };
  }
};
const mutateRowIsSelected = (selectedRowIds, id2, value, includeChildren, table) => {
  var _row$subRows;
  const row = table.getRow(id2, true);
  if (value) {
    if (!row.getCanMultiSelect()) {
      Object.keys(selectedRowIds).forEach((key) => delete selectedRowIds[key]);
    }
    if (row.getCanSelect()) {
      selectedRowIds[id2] = true;
    }
  } else {
    delete selectedRowIds[id2];
  }
  if (includeChildren && (_row$subRows = row.subRows) != null && _row$subRows.length && row.getCanSelectSubRows()) {
    row.subRows.forEach((row2) => mutateRowIsSelected(selectedRowIds, row2.id, value, includeChildren, table));
  }
};
function selectRowsFn(table, rowModel) {
  const rowSelection = table.getState().rowSelection;
  const newSelectedFlatRows = [];
  const newSelectedRowsById = {};
  const recurseRows = function(rows, depth) {
    return rows.map((row) => {
      var _row$subRows2;
      const isSelected = isRowSelected(row, rowSelection);
      if (isSelected) {
        newSelectedFlatRows.push(row);
        newSelectedRowsById[row.id] = row;
      }
      if ((_row$subRows2 = row.subRows) != null && _row$subRows2.length) {
        row = {
          ...row,
          subRows: recurseRows(row.subRows)
        };
      }
      if (isSelected) {
        return row;
      }
    }).filter(Boolean);
  };
  return {
    rows: recurseRows(rowModel.rows),
    flatRows: newSelectedFlatRows,
    rowsById: newSelectedRowsById
  };
}
function isRowSelected(row, selection) {
  var _selection$row$id;
  return (_selection$row$id = selection[row.id]) != null ? _selection$row$id : false;
}
function isSubRowSelected(row, selection, table) {
  var _row$subRows3;
  if (!((_row$subRows3 = row.subRows) != null && _row$subRows3.length)) return false;
  let allChildrenSelected = true;
  let someSelected = false;
  row.subRows.forEach((subRow) => {
    if (someSelected && !allChildrenSelected) {
      return;
    }
    if (subRow.getCanSelect()) {
      if (isRowSelected(subRow, selection)) {
        someSelected = true;
      } else {
        allChildrenSelected = false;
      }
    }
    if (subRow.subRows && subRow.subRows.length) {
      const subRowChildrenSelected = isSubRowSelected(subRow, selection);
      if (subRowChildrenSelected === "all") {
        someSelected = true;
      } else if (subRowChildrenSelected === "some") {
        someSelected = true;
        allChildrenSelected = false;
      } else {
        allChildrenSelected = false;
      }
    }
  });
  return allChildrenSelected ? "all" : someSelected ? "some" : false;
}
const reSplitAlphaNumeric = /([0-9]+)/gm;
const alphanumeric = (rowA, rowB, columnId) => {
  return compareAlphanumeric(toString$1(rowA.getValue(columnId)).toLowerCase(), toString$1(rowB.getValue(columnId)).toLowerCase());
};
const alphanumericCaseSensitive = (rowA, rowB, columnId) => {
  return compareAlphanumeric(toString$1(rowA.getValue(columnId)), toString$1(rowB.getValue(columnId)));
};
const text = (rowA, rowB, columnId) => {
  return compareBasic$1(toString$1(rowA.getValue(columnId)).toLowerCase(), toString$1(rowB.getValue(columnId)).toLowerCase());
};
const textCaseSensitive = (rowA, rowB, columnId) => {
  return compareBasic$1(toString$1(rowA.getValue(columnId)), toString$1(rowB.getValue(columnId)));
};
const datetime = (rowA, rowB, columnId) => {
  const a4 = rowA.getValue(columnId);
  const b3 = rowB.getValue(columnId);
  return a4 > b3 ? 1 : a4 < b3 ? -1 : 0;
};
const basic = (rowA, rowB, columnId) => {
  return compareBasic$1(rowA.getValue(columnId), rowB.getValue(columnId));
};
function compareBasic$1(a4, b3) {
  return a4 === b3 ? 0 : a4 > b3 ? 1 : -1;
}
function toString$1(a4) {
  if (typeof a4 === "number") {
    if (isNaN(a4) || a4 === Infinity || a4 === -Infinity) {
      return "";
    }
    return String(a4);
  }
  if (typeof a4 === "string") {
    return a4;
  }
  return "";
}
function compareAlphanumeric(aStr, bStr) {
  const a4 = aStr.split(reSplitAlphaNumeric).filter(Boolean);
  const b3 = bStr.split(reSplitAlphaNumeric).filter(Boolean);
  while (a4.length && b3.length) {
    const aa = a4.shift();
    const bb = b3.shift();
    const an = parseInt(aa, 10);
    const bn = parseInt(bb, 10);
    const combo = [an, bn].sort();
    if (isNaN(combo[0])) {
      if (aa > bb) {
        return 1;
      }
      if (bb > aa) {
        return -1;
      }
      continue;
    }
    if (isNaN(combo[1])) {
      return isNaN(an) ? -1 : 1;
    }
    if (an > bn) {
      return 1;
    }
    if (bn > an) {
      return -1;
    }
  }
  return a4.length - b3.length;
}
const sortingFns = {
  alphanumeric,
  alphanumericCaseSensitive,
  text,
  textCaseSensitive,
  datetime,
  basic
};
const RowSorting = {
  getInitialState: (state) => {
    return {
      sorting: [],
      ...state
    };
  },
  getDefaultColumnDef: () => {
    return {
      sortingFn: "auto",
      sortUndefined: 1
    };
  },
  getDefaultOptions: (table) => {
    return {
      onSortingChange: makeStateUpdater("sorting", table),
      isMultiSortEvent: (e3) => {
        return e3.shiftKey;
      }
    };
  },
  createColumn: (column, table) => {
    column.getAutoSortingFn = () => {
      const firstRows = table.getFilteredRowModel().flatRows.slice(10);
      let isString2 = false;
      for (const row of firstRows) {
        const value = row == null ? void 0 : row.getValue(column.id);
        if (Object.prototype.toString.call(value) === "[object Date]") {
          return sortingFns.datetime;
        }
        if (typeof value === "string") {
          isString2 = true;
          if (value.split(reSplitAlphaNumeric).length > 1) {
            return sortingFns.alphanumeric;
          }
        }
      }
      if (isString2) {
        return sortingFns.text;
      }
      return sortingFns.basic;
    };
    column.getAutoSortDir = () => {
      const firstRow = table.getFilteredRowModel().flatRows[0];
      const value = firstRow == null ? void 0 : firstRow.getValue(column.id);
      if (typeof value === "string") {
        return "asc";
      }
      return "desc";
    };
    column.getSortingFn = () => {
      var _table$options$sortin, _table$options$sortin2;
      if (!column) {
        throw new Error();
      }
      return isFunction$4(column.columnDef.sortingFn) ? column.columnDef.sortingFn : column.columnDef.sortingFn === "auto" ? column.getAutoSortingFn() : (_table$options$sortin = (_table$options$sortin2 = table.options.sortingFns) == null ? void 0 : _table$options$sortin2[column.columnDef.sortingFn]) != null ? _table$options$sortin : sortingFns[column.columnDef.sortingFn];
    };
    column.toggleSorting = (desc, multi) => {
      const nextSortingOrder = column.getNextSortingOrder();
      const hasManualValue = typeof desc !== "undefined" && desc !== null;
      table.setSorting((old) => {
        const existingSorting = old == null ? void 0 : old.find((d4) => d4.id === column.id);
        const existingIndex = old == null ? void 0 : old.findIndex((d4) => d4.id === column.id);
        let newSorting = [];
        let sortAction;
        let nextDesc = hasManualValue ? desc : nextSortingOrder === "desc";
        if (old != null && old.length && column.getCanMultiSort() && multi) {
          if (existingSorting) {
            sortAction = "toggle";
          } else {
            sortAction = "add";
          }
        } else {
          if (old != null && old.length && existingIndex !== old.length - 1) {
            sortAction = "replace";
          } else if (existingSorting) {
            sortAction = "toggle";
          } else {
            sortAction = "replace";
          }
        }
        if (sortAction === "toggle") {
          if (!hasManualValue) {
            if (!nextSortingOrder) {
              sortAction = "remove";
            }
          }
        }
        if (sortAction === "add") {
          var _table$options$maxMul;
          newSorting = [...old, {
            id: column.id,
            desc: nextDesc
          }];
          newSorting.splice(0, newSorting.length - ((_table$options$maxMul = table.options.maxMultiSortColCount) != null ? _table$options$maxMul : Number.MAX_SAFE_INTEGER));
        } else if (sortAction === "toggle") {
          newSorting = old.map((d4) => {
            if (d4.id === column.id) {
              return {
                ...d4,
                desc: nextDesc
              };
            }
            return d4;
          });
        } else if (sortAction === "remove") {
          newSorting = old.filter((d4) => d4.id !== column.id);
        } else {
          newSorting = [{
            id: column.id,
            desc: nextDesc
          }];
        }
        return newSorting;
      });
    };
    column.getFirstSortDir = () => {
      var _ref, _column$columnDef$sor;
      const sortDescFirst = (_ref = (_column$columnDef$sor = column.columnDef.sortDescFirst) != null ? _column$columnDef$sor : table.options.sortDescFirst) != null ? _ref : column.getAutoSortDir() === "desc";
      return sortDescFirst ? "desc" : "asc";
    };
    column.getNextSortingOrder = (multi) => {
      var _table$options$enable, _table$options$enable2;
      const firstSortDirection = column.getFirstSortDir();
      const isSorted = column.getIsSorted();
      if (!isSorted) {
        return firstSortDirection;
      }
      if (isSorted !== firstSortDirection && ((_table$options$enable = table.options.enableSortingRemoval) != null ? _table$options$enable : true) && // If enableSortRemove, enable in general
      (multi ? (_table$options$enable2 = table.options.enableMultiRemove) != null ? _table$options$enable2 : true : true)) {
        return false;
      }
      return isSorted === "desc" ? "asc" : "desc";
    };
    column.getCanSort = () => {
      var _column$columnDef$ena, _table$options$enable3;
      return ((_column$columnDef$ena = column.columnDef.enableSorting) != null ? _column$columnDef$ena : true) && ((_table$options$enable3 = table.options.enableSorting) != null ? _table$options$enable3 : true) && !!column.accessorFn;
    };
    column.getCanMultiSort = () => {
      var _ref2, _column$columnDef$ena2;
      return (_ref2 = (_column$columnDef$ena2 = column.columnDef.enableMultiSort) != null ? _column$columnDef$ena2 : table.options.enableMultiSort) != null ? _ref2 : !!column.accessorFn;
    };
    column.getIsSorted = () => {
      var _table$getState$sorti;
      const columnSort = (_table$getState$sorti = table.getState().sorting) == null ? void 0 : _table$getState$sorti.find((d4) => d4.id === column.id);
      return !columnSort ? false : columnSort.desc ? "desc" : "asc";
    };
    column.getSortIndex = () => {
      var _table$getState$sorti2, _table$getState$sorti3;
      return (_table$getState$sorti2 = (_table$getState$sorti3 = table.getState().sorting) == null ? void 0 : _table$getState$sorti3.findIndex((d4) => d4.id === column.id)) != null ? _table$getState$sorti2 : -1;
    };
    column.clearSorting = () => {
      table.setSorting((old) => old != null && old.length ? old.filter((d4) => d4.id !== column.id) : []);
    };
    column.getToggleSortingHandler = () => {
      const canSort = column.getCanSort();
      return (e3) => {
        if (!canSort) return;
        e3.persist == null || e3.persist();
        column.toggleSorting == null || column.toggleSorting(void 0, column.getCanMultiSort() ? table.options.isMultiSortEvent == null ? void 0 : table.options.isMultiSortEvent(e3) : false);
      };
    };
  },
  createTable: (table) => {
    table.setSorting = (updater) => table.options.onSortingChange == null ? void 0 : table.options.onSortingChange(updater);
    table.resetSorting = (defaultState2) => {
      var _table$initialState$s, _table$initialState;
      table.setSorting(defaultState2 ? [] : (_table$initialState$s = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.sorting) != null ? _table$initialState$s : []);
    };
    table.getPreSortedRowModel = () => table.getGroupedRowModel();
    table.getSortedRowModel = () => {
      if (!table._getSortedRowModel && table.options.getSortedRowModel) {
        table._getSortedRowModel = table.options.getSortedRowModel(table);
      }
      if (table.options.manualSorting || !table._getSortedRowModel) {
        return table.getPreSortedRowModel();
      }
      return table._getSortedRowModel();
    };
  }
};
const builtInFeatures = [
  Headers,
  ColumnVisibility,
  ColumnOrdering,
  ColumnPinning,
  ColumnFaceting,
  ColumnFiltering,
  GlobalFaceting,
  //depends on ColumnFaceting
  GlobalFiltering,
  //depends on ColumnFiltering
  RowSorting,
  ColumnGrouping,
  //depends on RowSorting
  RowExpanding,
  RowPagination,
  RowPinning,
  RowSelection,
  ColumnSizing
];
function createTable(options) {
  var _options$_features, _options$initialState;
  if (process.env.NODE_ENV !== "production" && (options.debugAll || options.debugTable)) {
    console.info("Creating Table Instance...");
  }
  const _features = [...builtInFeatures, ...(_options$_features = options._features) != null ? _options$_features : []];
  let table = {
    _features
  };
  const defaultOptions2 = table._features.reduce((obj, feature) => {
    return Object.assign(obj, feature.getDefaultOptions == null ? void 0 : feature.getDefaultOptions(table));
  }, {});
  const mergeOptions = (options2) => {
    if (table.options.mergeOptions) {
      return table.options.mergeOptions(defaultOptions2, options2);
    }
    return {
      ...defaultOptions2,
      ...options2
    };
  };
  const coreInitialState = {};
  let initialState = {
    ...coreInitialState,
    ...(_options$initialState = options.initialState) != null ? _options$initialState : {}
  };
  table._features.forEach((feature) => {
    var _feature$getInitialSt;
    initialState = (_feature$getInitialSt = feature.getInitialState == null ? void 0 : feature.getInitialState(initialState)) != null ? _feature$getInitialSt : initialState;
  });
  const queued = [];
  let queuedTimeout = false;
  const coreInstance = {
    _features,
    options: {
      ...defaultOptions2,
      ...options
    },
    initialState,
    _queue: (cb2) => {
      queued.push(cb2);
      if (!queuedTimeout) {
        queuedTimeout = true;
        Promise.resolve().then(() => {
          while (queued.length) {
            queued.shift()();
          }
          queuedTimeout = false;
        }).catch((error) => setTimeout(() => {
          throw error;
        }));
      }
    },
    reset: () => {
      table.setState(table.initialState);
    },
    setOptions: (updater) => {
      const newOptions = functionalUpdate(updater, table.options);
      table.options = mergeOptions(newOptions);
    },
    getState: () => {
      return table.options.state;
    },
    setState: (updater) => {
      table.options.onStateChange == null || table.options.onStateChange(updater);
    },
    _getRowId: (row, index2, parent) => {
      var _table$options$getRow;
      return (_table$options$getRow = table.options.getRowId == null ? void 0 : table.options.getRowId(row, index2, parent)) != null ? _table$options$getRow : `${parent ? [parent.id, index2].join(".") : index2}`;
    },
    getCoreRowModel: () => {
      if (!table._getCoreRowModel) {
        table._getCoreRowModel = table.options.getCoreRowModel(table);
      }
      return table._getCoreRowModel();
    },
    // The final calls start at the bottom of the model,
    // expanded rows, which then work their way up
    getRowModel: () => {
      return table.getPaginationRowModel();
    },
    //in next version, we should just pass in the row model as the optional 2nd arg
    getRow: (id2, searchAll) => {
      let row = (searchAll ? table.getPrePaginationRowModel() : table.getRowModel()).rowsById[id2];
      if (!row) {
        row = table.getCoreRowModel().rowsById[id2];
        if (!row) {
          if (process.env.NODE_ENV !== "production") {
            throw new Error(`getRow could not find row with ID: ${id2}`);
          }
          throw new Error();
        }
      }
      return row;
    },
    _getDefaultColumnDef: memo$1(() => [table.options.defaultColumn], (defaultColumn) => {
      var _defaultColumn;
      defaultColumn = (_defaultColumn = defaultColumn) != null ? _defaultColumn : {};
      return {
        header: (props) => {
          const resolvedColumnDef = props.header.column.columnDef;
          if (resolvedColumnDef.accessorKey) {
            return resolvedColumnDef.accessorKey;
          }
          if (resolvedColumnDef.accessorFn) {
            return resolvedColumnDef.id;
          }
          return null;
        },
        // footer: props => props.header.column.id,
        cell: (props) => {
          var _props$renderValue$to, _props$renderValue;
          return (_props$renderValue$to = (_props$renderValue = props.renderValue()) == null || _props$renderValue.toString == null ? void 0 : _props$renderValue.toString()) != null ? _props$renderValue$to : null;
        },
        ...table._features.reduce((obj, feature) => {
          return Object.assign(obj, feature.getDefaultColumnDef == null ? void 0 : feature.getDefaultColumnDef());
        }, {}),
        ...defaultColumn
      };
    }, getMemoOptions(options, "debugColumns", "_getDefaultColumnDef")),
    _getColumnDefs: () => table.options.columns,
    getAllColumns: memo$1(() => [table._getColumnDefs()], (columnDefs) => {
      const recurseColumns = function(columnDefs2, parent, depth) {
        if (depth === void 0) {
          depth = 0;
        }
        return columnDefs2.map((columnDef) => {
          const column = createColumn(table, columnDef, depth, parent);
          const groupingColumnDef = columnDef;
          column.columns = groupingColumnDef.columns ? recurseColumns(groupingColumnDef.columns, column, depth + 1) : [];
          return column;
        });
      };
      return recurseColumns(columnDefs);
    }, getMemoOptions(options, "debugColumns", "getAllColumns")),
    getAllFlatColumns: memo$1(() => [table.getAllColumns()], (allColumns) => {
      return allColumns.flatMap((column) => {
        return column.getFlatColumns();
      });
    }, getMemoOptions(options, "debugColumns", "getAllFlatColumns")),
    _getAllFlatColumnsById: memo$1(() => [table.getAllFlatColumns()], (flatColumns) => {
      return flatColumns.reduce((acc, column) => {
        acc[column.id] = column;
        return acc;
      }, {});
    }, getMemoOptions(options, "debugColumns", "getAllFlatColumnsById")),
    getAllLeafColumns: memo$1(() => [table.getAllColumns(), table._getOrderColumnsFn()], (allColumns, orderColumns2) => {
      let leafColumns = allColumns.flatMap((column) => column.getLeafColumns());
      return orderColumns2(leafColumns);
    }, getMemoOptions(options, "debugColumns", "getAllLeafColumns")),
    getColumn: (columnId) => {
      const column = table._getAllFlatColumnsById()[columnId];
      if (process.env.NODE_ENV !== "production" && !column) {
        console.error(`[Table] Column with id '${columnId}' does not exist.`);
      }
      return column;
    }
  };
  Object.assign(table, coreInstance);
  for (let index2 = 0; index2 < table._features.length; index2++) {
    const feature = table._features[index2];
    feature == null || feature.createTable == null || feature.createTable(table);
  }
  return table;
}
function getCoreRowModel() {
  return (table) => memo$1(() => [table.options.data], (data) => {
    const rowModel = {
      rows: [],
      flatRows: [],
      rowsById: {}
    };
    const accessRows = function(originalRows, depth, parentRow) {
      if (depth === void 0) {
        depth = 0;
      }
      const rows = [];
      for (let i3 = 0; i3 < originalRows.length; i3++) {
        const row = createRow(table, table._getRowId(originalRows[i3], i3, parentRow), originalRows[i3], i3, depth, void 0, parentRow == null ? void 0 : parentRow.id);
        rowModel.flatRows.push(row);
        rowModel.rowsById[row.id] = row;
        rows.push(row);
        if (table.options.getSubRows) {
          var _row$originalSubRows;
          row.originalSubRows = table.options.getSubRows(originalRows[i3], i3);
          if ((_row$originalSubRows = row.originalSubRows) != null && _row$originalSubRows.length) {
            row.subRows = accessRows(row.originalSubRows, depth + 1, row);
          }
        }
      }
      return rows;
    };
    rowModel.rows = accessRows(data);
    return rowModel;
  }, getMemoOptions(table.options, "debugTable", "getRowModel", () => table._autoResetPageIndex()));
}
function getExpandedRowModel() {
  return (table) => memo$1(() => [table.getState().expanded, table.getPreExpandedRowModel(), table.options.paginateExpandedRows], (expanded, rowModel, paginateExpandedRows) => {
    if (!rowModel.rows.length || expanded !== true && !Object.keys(expanded != null ? expanded : {}).length) {
      return rowModel;
    }
    if (!paginateExpandedRows) {
      return rowModel;
    }
    return expandRows(rowModel);
  }, getMemoOptions(table.options, "debugTable", "getExpandedRowModel"));
}
function expandRows(rowModel) {
  const expandedRows = [];
  const handleRow = (row) => {
    var _row$subRows;
    expandedRows.push(row);
    if ((_row$subRows = row.subRows) != null && _row$subRows.length && row.getIsExpanded()) {
      row.subRows.forEach(handleRow);
    }
  };
  rowModel.rows.forEach(handleRow);
  return {
    rows: expandedRows,
    flatRows: rowModel.flatRows,
    rowsById: rowModel.rowsById
  };
}
function filterRows(rows, filterRowImpl, table) {
  if (table.options.filterFromLeafRows) {
    return filterRowModelFromLeafs(rows, filterRowImpl, table);
  }
  return filterRowModelFromRoot(rows, filterRowImpl, table);
}
function filterRowModelFromLeafs(rowsToFilter, filterRow, table) {
  var _table$options$maxLea;
  const newFilteredFlatRows = [];
  const newFilteredRowsById = {};
  const maxDepth2 = (_table$options$maxLea = table.options.maxLeafRowFilterDepth) != null ? _table$options$maxLea : 100;
  const recurseFilterRows = function(rowsToFilter2, depth) {
    if (depth === void 0) {
      depth = 0;
    }
    const rows = [];
    for (let i3 = 0; i3 < rowsToFilter2.length; i3++) {
      var _row$subRows;
      let row = rowsToFilter2[i3];
      const newRow = createRow(table, row.id, row.original, row.index, row.depth, void 0, row.parentId);
      newRow.columnFilters = row.columnFilters;
      if ((_row$subRows = row.subRows) != null && _row$subRows.length && depth < maxDepth2) {
        newRow.subRows = recurseFilterRows(row.subRows, depth + 1);
        row = newRow;
        if (filterRow(row) && !newRow.subRows.length) {
          rows.push(row);
          newFilteredRowsById[row.id] = row;
          newFilteredFlatRows.push(row);
          continue;
        }
        if (filterRow(row) || newRow.subRows.length) {
          rows.push(row);
          newFilteredRowsById[row.id] = row;
          newFilteredFlatRows.push(row);
          continue;
        }
      } else {
        row = newRow;
        if (filterRow(row)) {
          rows.push(row);
          newFilteredRowsById[row.id] = row;
          newFilteredFlatRows.push(row);
        }
      }
    }
    return rows;
  };
  return {
    rows: recurseFilterRows(rowsToFilter),
    flatRows: newFilteredFlatRows,
    rowsById: newFilteredRowsById
  };
}
function filterRowModelFromRoot(rowsToFilter, filterRow, table) {
  var _table$options$maxLea2;
  const newFilteredFlatRows = [];
  const newFilteredRowsById = {};
  const maxDepth2 = (_table$options$maxLea2 = table.options.maxLeafRowFilterDepth) != null ? _table$options$maxLea2 : 100;
  const recurseFilterRows = function(rowsToFilter2, depth) {
    if (depth === void 0) {
      depth = 0;
    }
    const rows = [];
    for (let i3 = 0; i3 < rowsToFilter2.length; i3++) {
      let row = rowsToFilter2[i3];
      const pass = filterRow(row);
      if (pass) {
        var _row$subRows2;
        if ((_row$subRows2 = row.subRows) != null && _row$subRows2.length && depth < maxDepth2) {
          const newRow = createRow(table, row.id, row.original, row.index, row.depth, void 0, row.parentId);
          newRow.subRows = recurseFilterRows(row.subRows, depth + 1);
          row = newRow;
        }
        rows.push(row);
        newFilteredFlatRows.push(row);
        newFilteredRowsById[row.id] = row;
      }
    }
    return rows;
  };
  return {
    rows: recurseFilterRows(rowsToFilter),
    flatRows: newFilteredFlatRows,
    rowsById: newFilteredRowsById
  };
}
function getFilteredRowModel() {
  return (table) => memo$1(() => [table.getPreFilteredRowModel(), table.getState().columnFilters, table.getState().globalFilter], (rowModel, columnFilters, globalFilter) => {
    if (!rowModel.rows.length || !(columnFilters != null && columnFilters.length) && !globalFilter) {
      for (let i3 = 0; i3 < rowModel.flatRows.length; i3++) {
        rowModel.flatRows[i3].columnFilters = {};
        rowModel.flatRows[i3].columnFiltersMeta = {};
      }
      return rowModel;
    }
    const resolvedColumnFilters = [];
    const resolvedGlobalFilters = [];
    (columnFilters != null ? columnFilters : []).forEach((d4) => {
      var _filterFn$resolveFilt;
      const column = table.getColumn(d4.id);
      if (!column) {
        return;
      }
      const filterFn = column.getFilterFn();
      if (!filterFn) {
        if (process.env.NODE_ENV !== "production") {
          console.warn(`Could not find a valid 'column.filterFn' for column with the ID: ${column.id}.`);
        }
        return;
      }
      resolvedColumnFilters.push({
        id: d4.id,
        filterFn,
        resolvedValue: (_filterFn$resolveFilt = filterFn.resolveFilterValue == null ? void 0 : filterFn.resolveFilterValue(d4.value)) != null ? _filterFn$resolveFilt : d4.value
      });
    });
    const filterableIds = (columnFilters != null ? columnFilters : []).map((d4) => d4.id);
    const globalFilterFn2 = table.getGlobalFilterFn();
    const globallyFilterableColumns = table.getAllLeafColumns().filter((column) => column.getCanGlobalFilter());
    if (globalFilter && globalFilterFn2 && globallyFilterableColumns.length) {
      filterableIds.push("__global__");
      globallyFilterableColumns.forEach((column) => {
        var _globalFilterFn$resol;
        resolvedGlobalFilters.push({
          id: column.id,
          filterFn: globalFilterFn2,
          resolvedValue: (_globalFilterFn$resol = globalFilterFn2.resolveFilterValue == null ? void 0 : globalFilterFn2.resolveFilterValue(globalFilter)) != null ? _globalFilterFn$resol : globalFilter
        });
      });
    }
    let currentColumnFilter;
    let currentGlobalFilter;
    for (let j = 0; j < rowModel.flatRows.length; j++) {
      const row = rowModel.flatRows[j];
      row.columnFilters = {};
      if (resolvedColumnFilters.length) {
        for (let i3 = 0; i3 < resolvedColumnFilters.length; i3++) {
          currentColumnFilter = resolvedColumnFilters[i3];
          const id2 = currentColumnFilter.id;
          row.columnFilters[id2] = currentColumnFilter.filterFn(row, id2, currentColumnFilter.resolvedValue, (filterMeta) => {
            row.columnFiltersMeta[id2] = filterMeta;
          });
        }
      }
      if (resolvedGlobalFilters.length) {
        for (let i3 = 0; i3 < resolvedGlobalFilters.length; i3++) {
          currentGlobalFilter = resolvedGlobalFilters[i3];
          const id2 = currentGlobalFilter.id;
          if (currentGlobalFilter.filterFn(row, id2, currentGlobalFilter.resolvedValue, (filterMeta) => {
            row.columnFiltersMeta[id2] = filterMeta;
          })) {
            row.columnFilters.__global__ = true;
            break;
          }
        }
        if (row.columnFilters.__global__ !== true) {
          row.columnFilters.__global__ = false;
        }
      }
    }
    const filterRowsImpl = (row) => {
      for (let i3 = 0; i3 < filterableIds.length; i3++) {
        if (row.columnFilters[filterableIds[i3]] === false) {
          return false;
        }
      }
      return true;
    };
    return filterRows(rowModel.rows, filterRowsImpl, table);
  }, getMemoOptions(table.options, "debugTable", "getFilteredRowModel", () => table._autoResetPageIndex()));
}
function getGroupedRowModel() {
  return (table) => memo$1(() => [table.getState().grouping, table.getPreGroupedRowModel()], (grouping, rowModel) => {
    if (!rowModel.rows.length || !grouping.length) {
      rowModel.rows.forEach((row) => {
        row.depth = 0;
        row.parentId = void 0;
      });
      return rowModel;
    }
    const existingGrouping = grouping.filter((columnId) => table.getColumn(columnId));
    const groupedFlatRows = [];
    const groupedRowsById = {};
    const groupUpRecursively = function(rows, depth, parentId) {
      if (depth === void 0) {
        depth = 0;
      }
      if (depth >= existingGrouping.length) {
        return rows.map((row) => {
          row.depth = depth;
          groupedFlatRows.push(row);
          groupedRowsById[row.id] = row;
          if (row.subRows) {
            row.subRows = groupUpRecursively(row.subRows, depth + 1, row.id);
          }
          return row;
        });
      }
      const columnId = existingGrouping[depth];
      const rowGroupsMap = groupBy(rows, columnId);
      const aggregatedGroupedRows = Array.from(rowGroupsMap.entries()).map((_ref, index2) => {
        let [groupingValue, groupedRows2] = _ref;
        let id2 = `${columnId}:${groupingValue}`;
        id2 = parentId ? `${parentId}>${id2}` : id2;
        const subRows = groupUpRecursively(groupedRows2, depth + 1, id2);
        subRows.forEach((subRow) => {
          subRow.parentId = id2;
        });
        const leafRows = depth ? flattenBy(groupedRows2, (row2) => row2.subRows) : groupedRows2;
        const row = createRow(table, id2, leafRows[0].original, index2, depth, void 0, parentId);
        Object.assign(row, {
          groupingColumnId: columnId,
          groupingValue,
          subRows,
          leafRows,
          getValue: (columnId2) => {
            if (existingGrouping.includes(columnId2)) {
              if (row._valuesCache.hasOwnProperty(columnId2)) {
                return row._valuesCache[columnId2];
              }
              if (groupedRows2[0]) {
                var _groupedRows$0$getVal;
                row._valuesCache[columnId2] = (_groupedRows$0$getVal = groupedRows2[0].getValue(columnId2)) != null ? _groupedRows$0$getVal : void 0;
              }
              return row._valuesCache[columnId2];
            }
            if (row._groupingValuesCache.hasOwnProperty(columnId2)) {
              return row._groupingValuesCache[columnId2];
            }
            const column = table.getColumn(columnId2);
            const aggregateFn = column == null ? void 0 : column.getAggregationFn();
            if (aggregateFn) {
              row._groupingValuesCache[columnId2] = aggregateFn(columnId2, leafRows, groupedRows2);
              return row._groupingValuesCache[columnId2];
            }
          }
        });
        subRows.forEach((subRow) => {
          groupedFlatRows.push(subRow);
          groupedRowsById[subRow.id] = subRow;
        });
        return row;
      });
      return aggregatedGroupedRows;
    };
    const groupedRows = groupUpRecursively(rowModel.rows, 0);
    groupedRows.forEach((subRow) => {
      groupedFlatRows.push(subRow);
      groupedRowsById[subRow.id] = subRow;
    });
    return {
      rows: groupedRows,
      flatRows: groupedFlatRows,
      rowsById: groupedRowsById
    };
  }, getMemoOptions(table.options, "debugTable", "getGroupedRowModel", () => {
    table._queue(() => {
      table._autoResetExpanded();
      table._autoResetPageIndex();
    });
  }));
}
function groupBy(rows, columnId) {
  const groupMap = /* @__PURE__ */ new Map();
  return rows.reduce((map2, row) => {
    const resKey = `${row.getGroupingValue(columnId)}`;
    const previous = map2.get(resKey);
    if (!previous) {
      map2.set(resKey, [row]);
    } else {
      previous.push(row);
    }
    return map2;
  }, groupMap);
}
function getSortedRowModel() {
  return (table) => memo$1(() => [table.getState().sorting, table.getPreSortedRowModel()], (sorting, rowModel) => {
    if (!rowModel.rows.length || !(sorting != null && sorting.length)) {
      return rowModel;
    }
    const sortingState = table.getState().sorting;
    const sortedFlatRows = [];
    const availableSorting = sortingState.filter((sort) => {
      var _table$getColumn;
      return (_table$getColumn = table.getColumn(sort.id)) == null ? void 0 : _table$getColumn.getCanSort();
    });
    const columnInfoById = {};
    availableSorting.forEach((sortEntry) => {
      const column = table.getColumn(sortEntry.id);
      if (!column) return;
      columnInfoById[sortEntry.id] = {
        sortUndefined: column.columnDef.sortUndefined,
        invertSorting: column.columnDef.invertSorting,
        sortingFn: column.getSortingFn()
      };
    });
    const sortData = (rows) => {
      const sortedData = rows.map((row) => ({
        ...row
      }));
      sortedData.sort((rowA, rowB) => {
        for (let i3 = 0; i3 < availableSorting.length; i3 += 1) {
          var _sortEntry$desc;
          const sortEntry = availableSorting[i3];
          const columnInfo = columnInfoById[sortEntry.id];
          const sortUndefined = columnInfo.sortUndefined;
          const isDesc = (_sortEntry$desc = sortEntry == null ? void 0 : sortEntry.desc) != null ? _sortEntry$desc : false;
          let sortInt = 0;
          if (sortUndefined) {
            const aValue = rowA.getValue(sortEntry.id);
            const bValue = rowB.getValue(sortEntry.id);
            const aUndefined = aValue === void 0;
            const bUndefined = bValue === void 0;
            if (aUndefined || bUndefined) {
              if (sortUndefined === "first") return aUndefined ? -1 : 1;
              if (sortUndefined === "last") return aUndefined ? 1 : -1;
              sortInt = aUndefined && bUndefined ? 0 : aUndefined ? sortUndefined : -sortUndefined;
            }
          }
          if (sortInt === 0) {
            sortInt = columnInfo.sortingFn(rowA, rowB, sortEntry.id);
          }
          if (sortInt !== 0) {
            if (isDesc) {
              sortInt *= -1;
            }
            if (columnInfo.invertSorting) {
              sortInt *= -1;
            }
            return sortInt;
          }
        }
        return rowA.index - rowB.index;
      });
      sortedData.forEach((row) => {
        var _row$subRows;
        sortedFlatRows.push(row);
        if ((_row$subRows = row.subRows) != null && _row$subRows.length) {
          row.subRows = sortData(row.subRows);
        }
      });
      return sortedData;
    };
    return {
      rows: sortData(rowModel.rows),
      flatRows: sortedFlatRows,
      rowsById: rowModel.rowsById
    };
  }, getMemoOptions(table.options, "debugTable", "getSortedRowModel", () => table._autoResetPageIndex()));
}
/**
   * react-table
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function flexRender(Comp, props) {
  return !Comp ? null : isReactComponent(Comp) ? /* @__PURE__ */ React.createElement(Comp, props) : Comp;
}
function isReactComponent(component) {
  return isClassComponent(component) || typeof component === "function" || isExoticComponent(component);
}
function isClassComponent(component) {
  return typeof component === "function" && (() => {
    const proto = Object.getPrototypeOf(component);
    return proto.prototype && proto.prototype.isReactComponent;
  })();
}
function isExoticComponent(component) {
  return typeof component === "object" && typeof component.$$typeof === "symbol" && ["react.memo", "react.forward_ref"].includes(component.$$typeof.description);
}
function useReactTable(options) {
  const resolvedOptions = {
    state: {},
    // Dummy state
    onStateChange: () => {
    },
    // noop
    renderFallbackValue: null,
    ...options
  };
  const [tableRef] = React.useState(() => ({
    current: createTable(resolvedOptions)
  }));
  const [state, setState] = React.useState(() => tableRef.current.initialState);
  tableRef.current.setOptions((prev) => ({
    ...prev,
    ...options,
    state: {
      ...state,
      ...options.state
    },
    // Similarly, we'll maintain both our internal state and any user-provided
    // state.
    onStateChange: (updater) => {
      setState(updater);
      options.onStateChange == null || options.onStateChange(updater);
    }
  }));
  return tableRef.current;
}
var isArray_1;
var hasRequiredIsArray;
function requireIsArray() {
  if (hasRequiredIsArray) return isArray_1;
  hasRequiredIsArray = 1;
  var isArray2 = Array.isArray;
  isArray_1 = isArray2;
  return isArray_1;
}
var _isKey;
var hasRequired_isKey;
function require_isKey() {
  if (hasRequired_isKey) return _isKey;
  hasRequired_isKey = 1;
  var isArray2 = requireIsArray(), isSymbol = requireIsSymbol();
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
  function isKey(value, object2) {
    if (isArray2(value)) {
      return false;
    }
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) {
      return true;
    }
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object2 != null && value in Object(object2);
  }
  _isKey = isKey;
  return _isKey;
}
var isFunction_1;
var hasRequiredIsFunction;
function requireIsFunction() {
  if (hasRequiredIsFunction) return isFunction_1;
  hasRequiredIsFunction = 1;
  var baseGetTag = require_baseGetTag(), isObject2 = requireIsObject();
  var asyncTag = "[object AsyncFunction]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
  function isFunction2(value) {
    if (!isObject2(value)) {
      return false;
    }
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
  }
  isFunction_1 = isFunction2;
  return isFunction_1;
}
var _coreJsData;
var hasRequired_coreJsData;
function require_coreJsData() {
  if (hasRequired_coreJsData) return _coreJsData;
  hasRequired_coreJsData = 1;
  var root = require_root();
  var coreJsData = root["__core-js_shared__"];
  _coreJsData = coreJsData;
  return _coreJsData;
}
var _isMasked;
var hasRequired_isMasked;
function require_isMasked() {
  if (hasRequired_isMasked) return _isMasked;
  hasRequired_isMasked = 1;
  var coreJsData = require_coreJsData();
  var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
  }();
  function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
  }
  _isMasked = isMasked;
  return _isMasked;
}
var _toSource;
var hasRequired_toSource;
function require_toSource() {
  if (hasRequired_toSource) return _toSource;
  hasRequired_toSource = 1;
  var funcProto = Function.prototype;
  var funcToString = funcProto.toString;
  function toSource(func) {
    if (func != null) {
      try {
        return funcToString.call(func);
      } catch (e3) {
      }
      try {
        return func + "";
      } catch (e3) {
      }
    }
    return "";
  }
  _toSource = toSource;
  return _toSource;
}
var _baseIsNative;
var hasRequired_baseIsNative;
function require_baseIsNative() {
  if (hasRequired_baseIsNative) return _baseIsNative;
  hasRequired_baseIsNative = 1;
  var isFunction2 = requireIsFunction(), isMasked = require_isMasked(), isObject2 = requireIsObject(), toSource = require_toSource();
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
  var reIsHostCtor = /^\[object .+?Constructor\]$/;
  var funcProto = Function.prototype, objectProto = Object.prototype;
  var funcToString = funcProto.toString;
  var hasOwnProperty2 = objectProto.hasOwnProperty;
  var reIsNative = RegExp(
    "^" + funcToString.call(hasOwnProperty2).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function baseIsNative(value) {
    if (!isObject2(value) || isMasked(value)) {
      return false;
    }
    var pattern = isFunction2(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
  }
  _baseIsNative = baseIsNative;
  return _baseIsNative;
}
var _getValue;
var hasRequired_getValue;
function require_getValue() {
  if (hasRequired_getValue) return _getValue;
  hasRequired_getValue = 1;
  function getValue2(object2, key) {
    return object2 == null ? void 0 : object2[key];
  }
  _getValue = getValue2;
  return _getValue;
}
var _getNative;
var hasRequired_getNative;
function require_getNative() {
  if (hasRequired_getNative) return _getNative;
  hasRequired_getNative = 1;
  var baseIsNative = require_baseIsNative(), getValue2 = require_getValue();
  function getNative(object2, key) {
    var value = getValue2(object2, key);
    return baseIsNative(value) ? value : void 0;
  }
  _getNative = getNative;
  return _getNative;
}
var _nativeCreate;
var hasRequired_nativeCreate;
function require_nativeCreate() {
  if (hasRequired_nativeCreate) return _nativeCreate;
  hasRequired_nativeCreate = 1;
  var getNative = require_getNative();
  var nativeCreate = getNative(Object, "create");
  _nativeCreate = nativeCreate;
  return _nativeCreate;
}
var _hashClear;
var hasRequired_hashClear;
function require_hashClear() {
  if (hasRequired_hashClear) return _hashClear;
  hasRequired_hashClear = 1;
  var nativeCreate = require_nativeCreate();
  function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
  }
  _hashClear = hashClear;
  return _hashClear;
}
var _hashDelete;
var hasRequired_hashDelete;
function require_hashDelete() {
  if (hasRequired_hashDelete) return _hashDelete;
  hasRequired_hashDelete = 1;
  function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
  }
  _hashDelete = hashDelete;
  return _hashDelete;
}
var _hashGet;
var hasRequired_hashGet;
function require_hashGet() {
  if (hasRequired_hashGet) return _hashGet;
  hasRequired_hashGet = 1;
  var nativeCreate = require_nativeCreate();
  var HASH_UNDEFINED = "__lodash_hash_undefined__";
  var objectProto = Object.prototype;
  var hasOwnProperty2 = objectProto.hasOwnProperty;
  function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
      var result = data[key];
      return result === HASH_UNDEFINED ? void 0 : result;
    }
    return hasOwnProperty2.call(data, key) ? data[key] : void 0;
  }
  _hashGet = hashGet;
  return _hashGet;
}
var _hashHas;
var hasRequired_hashHas;
function require_hashHas() {
  if (hasRequired_hashHas) return _hashHas;
  hasRequired_hashHas = 1;
  var nativeCreate = require_nativeCreate();
  var objectProto = Object.prototype;
  var hasOwnProperty2 = objectProto.hasOwnProperty;
  function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== void 0 : hasOwnProperty2.call(data, key);
  }
  _hashHas = hashHas;
  return _hashHas;
}
var _hashSet;
var hasRequired_hashSet;
function require_hashSet() {
  if (hasRequired_hashSet) return _hashSet;
  hasRequired_hashSet = 1;
  var nativeCreate = require_nativeCreate();
  var HASH_UNDEFINED = "__lodash_hash_undefined__";
  function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === void 0 ? HASH_UNDEFINED : value;
    return this;
  }
  _hashSet = hashSet;
  return _hashSet;
}
var _Hash;
var hasRequired_Hash;
function require_Hash() {
  if (hasRequired_Hash) return _Hash;
  hasRequired_Hash = 1;
  var hashClear = require_hashClear(), hashDelete = require_hashDelete(), hashGet = require_hashGet(), hashHas = require_hashHas(), hashSet = require_hashSet();
  function Hash2(entries) {
    var index2 = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while (++index2 < length) {
      var entry = entries[index2];
      this.set(entry[0], entry[1]);
    }
  }
  Hash2.prototype.clear = hashClear;
  Hash2.prototype["delete"] = hashDelete;
  Hash2.prototype.get = hashGet;
  Hash2.prototype.has = hashHas;
  Hash2.prototype.set = hashSet;
  _Hash = Hash2;
  return _Hash;
}
var _listCacheClear;
var hasRequired_listCacheClear;
function require_listCacheClear() {
  if (hasRequired_listCacheClear) return _listCacheClear;
  hasRequired_listCacheClear = 1;
  function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
  }
  _listCacheClear = listCacheClear;
  return _listCacheClear;
}
var eq_1;
var hasRequiredEq;
function requireEq() {
  if (hasRequiredEq) return eq_1;
  hasRequiredEq = 1;
  function eq(value, other) {
    return value === other || value !== value && other !== other;
  }
  eq_1 = eq;
  return eq_1;
}
var _assocIndexOf;
var hasRequired_assocIndexOf;
function require_assocIndexOf() {
  if (hasRequired_assocIndexOf) return _assocIndexOf;
  hasRequired_assocIndexOf = 1;
  var eq = requireEq();
  function assocIndexOf(array2, key) {
    var length = array2.length;
    while (length--) {
      if (eq(array2[length][0], key)) {
        return length;
      }
    }
    return -1;
  }
  _assocIndexOf = assocIndexOf;
  return _assocIndexOf;
}
var _listCacheDelete;
var hasRequired_listCacheDelete;
function require_listCacheDelete() {
  if (hasRequired_listCacheDelete) return _listCacheDelete;
  hasRequired_listCacheDelete = 1;
  var assocIndexOf = require_assocIndexOf();
  var arrayProto = Array.prototype;
  var splice = arrayProto.splice;
  function listCacheDelete(key) {
    var data = this.__data__, index2 = assocIndexOf(data, key);
    if (index2 < 0) {
      return false;
    }
    var lastIndex = data.length - 1;
    if (index2 == lastIndex) {
      data.pop();
    } else {
      splice.call(data, index2, 1);
    }
    --this.size;
    return true;
  }
  _listCacheDelete = listCacheDelete;
  return _listCacheDelete;
}
var _listCacheGet;
var hasRequired_listCacheGet;
function require_listCacheGet() {
  if (hasRequired_listCacheGet) return _listCacheGet;
  hasRequired_listCacheGet = 1;
  var assocIndexOf = require_assocIndexOf();
  function listCacheGet(key) {
    var data = this.__data__, index2 = assocIndexOf(data, key);
    return index2 < 0 ? void 0 : data[index2][1];
  }
  _listCacheGet = listCacheGet;
  return _listCacheGet;
}
var _listCacheHas;
var hasRequired_listCacheHas;
function require_listCacheHas() {
  if (hasRequired_listCacheHas) return _listCacheHas;
  hasRequired_listCacheHas = 1;
  var assocIndexOf = require_assocIndexOf();
  function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
  }
  _listCacheHas = listCacheHas;
  return _listCacheHas;
}
var _listCacheSet;
var hasRequired_listCacheSet;
function require_listCacheSet() {
  if (hasRequired_listCacheSet) return _listCacheSet;
  hasRequired_listCacheSet = 1;
  var assocIndexOf = require_assocIndexOf();
  function listCacheSet(key, value) {
    var data = this.__data__, index2 = assocIndexOf(data, key);
    if (index2 < 0) {
      ++this.size;
      data.push([key, value]);
    } else {
      data[index2][1] = value;
    }
    return this;
  }
  _listCacheSet = listCacheSet;
  return _listCacheSet;
}
var _ListCache;
var hasRequired_ListCache;
function require_ListCache() {
  if (hasRequired_ListCache) return _ListCache;
  hasRequired_ListCache = 1;
  var listCacheClear = require_listCacheClear(), listCacheDelete = require_listCacheDelete(), listCacheGet = require_listCacheGet(), listCacheHas = require_listCacheHas(), listCacheSet = require_listCacheSet();
  function ListCache(entries) {
    var index2 = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while (++index2 < length) {
      var entry = entries[index2];
      this.set(entry[0], entry[1]);
    }
  }
  ListCache.prototype.clear = listCacheClear;
  ListCache.prototype["delete"] = listCacheDelete;
  ListCache.prototype.get = listCacheGet;
  ListCache.prototype.has = listCacheHas;
  ListCache.prototype.set = listCacheSet;
  _ListCache = ListCache;
  return _ListCache;
}
var _Map;
var hasRequired_Map;
function require_Map() {
  if (hasRequired_Map) return _Map;
  hasRequired_Map = 1;
  var getNative = require_getNative(), root = require_root();
  var Map2 = getNative(root, "Map");
  _Map = Map2;
  return _Map;
}
var _mapCacheClear;
var hasRequired_mapCacheClear;
function require_mapCacheClear() {
  if (hasRequired_mapCacheClear) return _mapCacheClear;
  hasRequired_mapCacheClear = 1;
  var Hash2 = require_Hash(), ListCache = require_ListCache(), Map2 = require_Map();
  function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
      "hash": new Hash2(),
      "map": new (Map2 || ListCache)(),
      "string": new Hash2()
    };
  }
  _mapCacheClear = mapCacheClear;
  return _mapCacheClear;
}
var _isKeyable;
var hasRequired_isKeyable;
function require_isKeyable() {
  if (hasRequired_isKeyable) return _isKeyable;
  hasRequired_isKeyable = 1;
  function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
  }
  _isKeyable = isKeyable;
  return _isKeyable;
}
var _getMapData;
var hasRequired_getMapData;
function require_getMapData() {
  if (hasRequired_getMapData) return _getMapData;
  hasRequired_getMapData = 1;
  var isKeyable = require_isKeyable();
  function getMapData(map2, key) {
    var data = map2.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
  }
  _getMapData = getMapData;
  return _getMapData;
}
var _mapCacheDelete;
var hasRequired_mapCacheDelete;
function require_mapCacheDelete() {
  if (hasRequired_mapCacheDelete) return _mapCacheDelete;
  hasRequired_mapCacheDelete = 1;
  var getMapData = require_getMapData();
  function mapCacheDelete(key) {
    var result = getMapData(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
  }
  _mapCacheDelete = mapCacheDelete;
  return _mapCacheDelete;
}
var _mapCacheGet;
var hasRequired_mapCacheGet;
function require_mapCacheGet() {
  if (hasRequired_mapCacheGet) return _mapCacheGet;
  hasRequired_mapCacheGet = 1;
  var getMapData = require_getMapData();
  function mapCacheGet(key) {
    return getMapData(this, key).get(key);
  }
  _mapCacheGet = mapCacheGet;
  return _mapCacheGet;
}
var _mapCacheHas;
var hasRequired_mapCacheHas;
function require_mapCacheHas() {
  if (hasRequired_mapCacheHas) return _mapCacheHas;
  hasRequired_mapCacheHas = 1;
  var getMapData = require_getMapData();
  function mapCacheHas(key) {
    return getMapData(this, key).has(key);
  }
  _mapCacheHas = mapCacheHas;
  return _mapCacheHas;
}
var _mapCacheSet;
var hasRequired_mapCacheSet;
function require_mapCacheSet() {
  if (hasRequired_mapCacheSet) return _mapCacheSet;
  hasRequired_mapCacheSet = 1;
  var getMapData = require_getMapData();
  function mapCacheSet(key, value) {
    var data = getMapData(this, key), size2 = data.size;
    data.set(key, value);
    this.size += data.size == size2 ? 0 : 1;
    return this;
  }
  _mapCacheSet = mapCacheSet;
  return _mapCacheSet;
}
var _MapCache;
var hasRequired_MapCache;
function require_MapCache() {
  if (hasRequired_MapCache) return _MapCache;
  hasRequired_MapCache = 1;
  var mapCacheClear = require_mapCacheClear(), mapCacheDelete = require_mapCacheDelete(), mapCacheGet = require_mapCacheGet(), mapCacheHas = require_mapCacheHas(), mapCacheSet = require_mapCacheSet();
  function MapCache(entries) {
    var index2 = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while (++index2 < length) {
      var entry = entries[index2];
      this.set(entry[0], entry[1]);
    }
  }
  MapCache.prototype.clear = mapCacheClear;
  MapCache.prototype["delete"] = mapCacheDelete;
  MapCache.prototype.get = mapCacheGet;
  MapCache.prototype.has = mapCacheHas;
  MapCache.prototype.set = mapCacheSet;
  _MapCache = MapCache;
  return _MapCache;
}
var memoize_1;
var hasRequiredMemoize;
function requireMemoize() {
  if (hasRequiredMemoize) return memoize_1;
  hasRequiredMemoize = 1;
  var MapCache = require_MapCache();
  var FUNC_ERROR_TEXT = "Expected a function";
  function memoize3(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") {
      throw new TypeError(FUNC_ERROR_TEXT);
    }
    var memoized = function() {
      var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
      if (cache.has(key)) {
        return cache.get(key);
      }
      var result = func.apply(this, args);
      memoized.cache = cache.set(key, result) || cache;
      return result;
    };
    memoized.cache = new (memoize3.Cache || MapCache)();
    return memoized;
  }
  memoize3.Cache = MapCache;
  memoize_1 = memoize3;
  return memoize_1;
}
var _memoizeCapped;
var hasRequired_memoizeCapped;
function require_memoizeCapped() {
  if (hasRequired_memoizeCapped) return _memoizeCapped;
  hasRequired_memoizeCapped = 1;
  var memoize3 = requireMemoize();
  var MAX_MEMOIZE_SIZE = 500;
  function memoizeCapped(func) {
    var result = memoize3(func, function(key) {
      if (cache.size === MAX_MEMOIZE_SIZE) {
        cache.clear();
      }
      return key;
    });
    var cache = result.cache;
    return result;
  }
  _memoizeCapped = memoizeCapped;
  return _memoizeCapped;
}
var _stringToPath;
var hasRequired_stringToPath;
function require_stringToPath() {
  if (hasRequired_stringToPath) return _stringToPath;
  hasRequired_stringToPath = 1;
  var memoizeCapped = require_memoizeCapped();
  var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
  var reEscapeChar = /\\(\\)?/g;
  var stringToPath = memoizeCapped(function(string2) {
    var result = [];
    if (string2.charCodeAt(0) === 46) {
      result.push("");
    }
    string2.replace(rePropName, function(match2, number2, quote, subString) {
      result.push(quote ? subString.replace(reEscapeChar, "$1") : number2 || match2);
    });
    return result;
  });
  _stringToPath = stringToPath;
  return _stringToPath;
}
var _arrayMap;
var hasRequired_arrayMap;
function require_arrayMap() {
  if (hasRequired_arrayMap) return _arrayMap;
  hasRequired_arrayMap = 1;
  function arrayMap(array2, iteratee) {
    var index2 = -1, length = array2 == null ? 0 : array2.length, result = Array(length);
    while (++index2 < length) {
      result[index2] = iteratee(array2[index2], index2, array2);
    }
    return result;
  }
  _arrayMap = arrayMap;
  return _arrayMap;
}
var _baseToString;
var hasRequired_baseToString;
function require_baseToString() {
  if (hasRequired_baseToString) return _baseToString;
  hasRequired_baseToString = 1;
  var Symbol2 = require_Symbol(), arrayMap = require_arrayMap(), isArray2 = requireIsArray(), isSymbol = requireIsSymbol();
  var symbolProto = Symbol2 ? Symbol2.prototype : void 0, symbolToString = symbolProto ? symbolProto.toString : void 0;
  function baseToString(value) {
    if (typeof value == "string") {
      return value;
    }
    if (isArray2(value)) {
      return arrayMap(value, baseToString) + "";
    }
    if (isSymbol(value)) {
      return symbolToString ? symbolToString.call(value) : "";
    }
    var result = value + "";
    return result == "0" && 1 / value == -Infinity ? "-0" : result;
  }
  _baseToString = baseToString;
  return _baseToString;
}
var toString_1;
var hasRequiredToString;
function requireToString() {
  if (hasRequiredToString) return toString_1;
  hasRequiredToString = 1;
  var baseToString = require_baseToString();
  function toString2(value) {
    return value == null ? "" : baseToString(value);
  }
  toString_1 = toString2;
  return toString_1;
}
var _castPath;
var hasRequired_castPath;
function require_castPath() {
  if (hasRequired_castPath) return _castPath;
  hasRequired_castPath = 1;
  var isArray2 = requireIsArray(), isKey = require_isKey(), stringToPath = require_stringToPath(), toString2 = requireToString();
  function castPath(value, object2) {
    if (isArray2(value)) {
      return value;
    }
    return isKey(value, object2) ? [value] : stringToPath(toString2(value));
  }
  _castPath = castPath;
  return _castPath;
}
var _toKey;
var hasRequired_toKey;
function require_toKey() {
  if (hasRequired_toKey) return _toKey;
  hasRequired_toKey = 1;
  var isSymbol = requireIsSymbol();
  function toKey(value) {
    if (typeof value == "string" || isSymbol(value)) {
      return value;
    }
    var result = value + "";
    return result == "0" && 1 / value == -Infinity ? "-0" : result;
  }
  _toKey = toKey;
  return _toKey;
}
var _baseGet;
var hasRequired_baseGet;
function require_baseGet() {
  if (hasRequired_baseGet) return _baseGet;
  hasRequired_baseGet = 1;
  var castPath = require_castPath(), toKey = require_toKey();
  function baseGet(object2, path) {
    path = castPath(path, object2);
    var index2 = 0, length = path.length;
    while (object2 != null && index2 < length) {
      object2 = object2[toKey(path[index2++])];
    }
    return index2 && index2 == length ? object2 : void 0;
  }
  _baseGet = baseGet;
  return _baseGet;
}
var get_1;
var hasRequiredGet;
function requireGet() {
  if (hasRequiredGet) return get_1;
  hasRequiredGet = 1;
  var baseGet = require_baseGet();
  function get2(object2, path, defaultValue2) {
    var result = object2 == null ? void 0 : baseGet(object2, path);
    return result === void 0 ? defaultValue2 : result;
  }
  get_1 = get2;
  return get_1;
}
var getExports = requireGet();
const get = /* @__PURE__ */ getDefaultExportFromCjs(getExports);
var TableFilterComparator = /* @__PURE__ */ ((TableFilterComparator2) => {
  TableFilterComparator2[TableFilterComparator2["Contains"] = 0] = "Contains";
  TableFilterComparator2[TableFilterComparator2["DoesNotContain"] = 1] = "DoesNotContain";
  TableFilterComparator2[TableFilterComparator2["IsEqualTo"] = 2] = "IsEqualTo";
  TableFilterComparator2[TableFilterComparator2["IsNotEqualTo"] = 3] = "IsNotEqualTo";
  TableFilterComparator2[TableFilterComparator2["IsGreaterThan"] = 4] = "IsGreaterThan";
  TableFilterComparator2[TableFilterComparator2["IsLessThan"] = 5] = "IsLessThan";
  TableFilterComparator2[TableFilterComparator2["IsBetween"] = 6] = "IsBetween";
  TableFilterComparator2[TableFilterComparator2["IsEmpty"] = 7] = "IsEmpty";
  TableFilterComparator2[TableFilterComparator2["IsNotEmpty"] = 8] = "IsNotEmpty";
  TableFilterComparator2[TableFilterComparator2["IsLessThanOrEqualTo"] = 9] = "IsLessThanOrEqualTo";
  TableFilterComparator2[TableFilterComparator2["IsGreaterThanOrEqualTo"] = 10] = "IsGreaterThanOrEqualTo";
  TableFilterComparator2[TableFilterComparator2["HasAnyOf"] = 11] = "HasAnyOf";
  TableFilterComparator2[TableFilterComparator2["HasAllOf"] = 12] = "HasAllOf";
  TableFilterComparator2[TableFilterComparator2["HasNoneOf"] = 13] = "HasNoneOf";
  TableFilterComparator2[TableFilterComparator2["IsOneOf"] = 14] = "IsOneOf";
  TableFilterComparator2[TableFilterComparator2["IsNoneOf"] = 15] = "IsNoneOf";
  return TableFilterComparator2;
})(TableFilterComparator || {});
const dataTypes = {
  auto: {
    sortingFn: "auto",
    filterComparators: [
      TableFilterComparator.Contains,
      TableFilterComparator.DoesNotContain,
      TableFilterComparator.IsEqualTo,
      TableFilterComparator.IsNotEqualTo,
      TableFilterComparator.IsEmpty,
      TableFilterComparator.IsNotEmpty
    ]
  },
  // base
  text: {
    sortingFn: "alphanumeric",
    filterComparators: [
      TableFilterComparator.Contains,
      TableFilterComparator.DoesNotContain,
      TableFilterComparator.IsEqualTo,
      TableFilterComparator.IsNotEqualTo,
      TableFilterComparator.IsEmpty,
      TableFilterComparator.IsNotEmpty
    ]
  },
  boolean: {
    sortingFn: "basic",
    filterComparators: [TableFilterComparator.IsEqualTo, TableFilterComparator.IsNotEqualTo]
  },
  // dates
  date: createDatetimeDataType({
    day: "2-digit",
    month: "2-digit",
    year: "2-digit"
  }),
  time: createDatetimeDataType({
    hour: "2-digit",
    minute: "2-digit"
  }),
  datetime: createDatetimeDataType({
    day: "2-digit",
    month: "2-digit",
    year: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  }),
  // numbers
  number: createNumberDataType("left"),
  amount: createNumberDataType("right", { decimals: 2, useGrouping: true }),
  percentage: createNumberDataType("right", { useGrouping: true, percent: true })
};
function createDatetimeDataType(defaultOptions2) {
  return {
    sortingFn: "datetime",
    filterComparators: [
      TableFilterComparator.IsEqualTo,
      TableFilterComparator.IsNotEqualTo,
      TableFilterComparator.IsGreaterThan,
      TableFilterComparator.IsLessThan,
      TableFilterComparator.IsGreaterThanOrEqualTo,
      TableFilterComparator.IsLessThanOrEqualTo,
      TableFilterComparator.IsBetween,
      TableFilterComparator.IsEmpty,
      TableFilterComparator.IsNotEmpty
    ],
    getDisplayValue: (value, row, options) => {
      var _a;
      if (value === void 0) {
        return "";
      }
      return new Intl.DateTimeFormat((_a = options == null ? void 0 : options.localization) == null ? void 0 : _a.locale, defaultOptions2).format(
        typeof value === "string" ? Date.parse(value) : value
      );
    }
  };
}
function createNumberDataType(align, defaultOptions2) {
  return {
    align,
    sortingFn: "basic",
    filterComparators: [
      TableFilterComparator.IsEqualTo,
      TableFilterComparator.IsNotEqualTo,
      TableFilterComparator.IsGreaterThan,
      TableFilterComparator.IsLessThan,
      TableFilterComparator.IsGreaterThanOrEqualTo,
      TableFilterComparator.IsLessThanOrEqualTo,
      TableFilterComparator.IsBetween,
      TableFilterComparator.IsEmpty,
      TableFilterComparator.IsNotEmpty
    ],
    getDisplayValue: (value, row, options) => {
      var _a, _b;
      if (value === void 0) {
        return "";
      }
      const dataTypeOptions = typeof (options == null ? void 0 : options.dataTypeOptions) === "function" ? options == null ? void 0 : options.dataTypeOptions(row) : options == null ? void 0 : options.dataTypeOptions;
      const numberFormatOptions = {
        // format
        useGrouping: (dataTypeOptions == null ? void 0 : dataTypeOptions.useGrouping) ?? (defaultOptions2 == null ? void 0 : defaultOptions2.useGrouping) ?? false,
        // decimals
        minimumFractionDigits: (dataTypeOptions == null ? void 0 : dataTypeOptions.decimals) ?? (defaultOptions2 == null ? void 0 : defaultOptions2.decimals),
        maximumFractionDigits: (dataTypeOptions == null ? void 0 : dataTypeOptions.decimals) ?? (defaultOptions2 == null ? void 0 : defaultOptions2.decimals)
      };
      if (defaultOptions2 == null ? void 0 : defaultOptions2.percent) {
        numberFormatOptions.style = "percent";
      } else if (dataTypeOptions == null ? void 0 : dataTypeOptions.currency) {
        numberFormatOptions.style = "currency";
        numberFormatOptions.currency = dataTypeOptions.currency;
        numberFormatOptions.currencyDisplay = "code";
      }
      let localisedValue = new Intl.NumberFormat((_a = options == null ? void 0 : options.localization) == null ? void 0 : _a.locale, numberFormatOptions).format(Number(value));
      if (!numberFormatOptions.useGrouping) {
        return localisedValue;
      }
      let localisedValueWithoutThousandsSeperator = new Intl.NumberFormat((_b = options == null ? void 0 : options.localization) == null ? void 0 : _b.locale, {
        ...numberFormatOptions,
        useGrouping: false
      }).format(Number(value));
      if (numberFormatOptions.style === "percent" || numberFormatOptions.style === "currency") {
        localisedValue = localisedValue.replace(/\u00A0/g, " ");
        localisedValueWithoutThousandsSeperator = localisedValueWithoutThousandsSeperator.replace(/\u00A0/g, " ");
      }
      return [localisedValue, localisedValueWithoutThousandsSeperator];
    }
  };
}
function getDataTypeProperties(dataType) {
  return dataTypes[dataType ?? "text"] ?? dataTypes.text;
}
function getSortingFn(dataType, customFnOrBuiltIn) {
  if (typeof customFnOrBuiltIn === "function") {
    return (rowA, rowB, columnId) => customFnOrBuiltIn(rowA.original, rowB.original, columnId);
  }
  if (customFnOrBuiltIn) {
    return customFnOrBuiltIn;
  }
  return getDataTypeProperties(dataType).sortingFn;
}
const toLowerCase = (value) => String(value ?? "").toLocaleLowerCase();
const isWeakContains = (left, right) => toLowerCase(left).includes(toLowerCase(right));
const isWeakEqual = (left, right) => toLowerCase(left) === toLowerCase(right);
function columnFilterFn(value, filter2) {
  try {
    if (filter2.comparator === TableFilterComparator.IsEmpty || filter2.comparator === TableFilterComparator.IsNotEmpty) {
      const isEmpty = value === void 0 || value === null || value === "";
      return filter2.comparator === TableFilterComparator.IsEmpty ? isEmpty : !isEmpty;
    }
    if (filter2.value === void 0 || filter2.value === null || filter2.value === "") {
      return true;
    }
    const valueAsDate = new Date(value);
    switch (filter2.comparator) {
      case TableFilterComparator.Contains:
        return isWeakContains(value, filter2.value);
      case TableFilterComparator.DoesNotContain:
        return !isWeakContains(value, filter2.value);
      case TableFilterComparator.IsEqualTo: {
        if (isDate(valueAsDate)) {
          return isDate(filter2.value) && isWeakEqual$1(valueAsDate, filter2.value);
        } else if (typeof filter2.value === "boolean") {
          return value === filter2.value;
        }
        return isWeakEqual(value, filter2.value);
      }
      case TableFilterComparator.IsNotEqualTo: {
        if (isDate(valueAsDate)) {
          return isDate(filter2.value) && isWeakEqual$1(valueAsDate, filter2.value) === false;
        } else if (typeof filter2.value === "boolean") {
          return value !== filter2.value;
        }
        return !isWeakEqual(value, filter2.value);
      }
      case TableFilterComparator.IsGreaterThan: {
        if (isDate(valueAsDate)) {
          return isDate(filter2.value) && isAfter(valueAsDate, filter2.value);
        } else {
          const valueAsNumber = parseInt(value);
          return !isNaN(valueAsNumber) && filter2.value !== void 0 && valueAsNumber > filter2.value;
        }
      }
      case TableFilterComparator.IsLessThan: {
        if (isDate(valueAsDate)) {
          return isDate(filter2.value) && isBefore(valueAsDate, filter2.value);
        } else {
          const valueAsNumber = parseInt(value);
          return !isNaN(valueAsNumber) && filter2.value !== void 0 && valueAsNumber < filter2.value;
        }
      }
      case TableFilterComparator.IsLessThanOrEqualTo: {
        if (isDate(valueAsDate)) {
          return isDate(filter2.value) && (isBefore(valueAsDate, filter2.value) || isEqual$2(valueAsDate, filter2.value));
        } else {
          const valueAsNumber = parseInt(value);
          return !isNaN(valueAsNumber) && filter2.value !== void 0 && valueAsNumber <= filter2.value;
        }
      }
      case TableFilterComparator.IsGreaterThanOrEqualTo: {
        if (isDate(valueAsDate)) {
          return isDate(filter2.value) && (isAfter(valueAsDate, filter2.value) || isEqual$2(valueAsDate, filter2.value));
        } else {
          const valueAsNumber = parseInt(value);
          return !isNaN(valueAsNumber) && filter2.value !== void 0 && valueAsNumber >= filter2.value;
        }
      }
      case TableFilterComparator.IsBetween: {
        const [fromValue, toValue2] = filter2.value;
        if (isDate(valueAsDate)) {
          if (isDate(fromValue) && isBefore(valueAsDate, fromValue)) {
            return false;
          } else if (isDate(toValue2) && isAfter(valueAsDate, toValue2)) {
            return false;
          }
          return true;
        } else {
          const valueAsNumber = parseInt(value);
          if (isNaN(valueAsNumber)) {
            return false;
          }
          if (fromValue !== void 0 && valueAsNumber < fromValue) {
            return false;
          } else if (toValue2 !== void 0 && valueAsNumber > toValue2) {
            return false;
          }
          return true;
        }
      }
      case TableFilterComparator.HasAnyOf:
        return Array.isArray(filter2.value) && Array.isArray(value) ? filter2.value.some((item) => value.includes(item)) : false;
      case TableFilterComparator.HasNoneOf:
        return Array.isArray(filter2.value) && Array.isArray(value) ? filter2.value.every((item) => value.includes(item) === false) : false;
      case TableFilterComparator.HasAllOf:
        return Array.isArray(filter2.value) && Array.isArray(value) ? filter2.value.filter((v2) => value.includes(v2)).length === filter2.value.length : false;
      case TableFilterComparator.IsOneOf:
        if (!Array.isArray(filter2.value)) return false;
        return filter2.value.some((v2) => isWeakEqual(value, v2));
      case TableFilterComparator.IsNoneOf:
        if (!Array.isArray(filter2.value)) return false;
        return filter2.value.every((v2) => !isWeakEqual(value, v2));
    }
    return false;
  } catch (e3) {
    console.error(e3);
    return true;
  }
}
const flattenCellValue = (cellValue) => {
  return typeof cellValue === "object" ? Object.values(cellValue).map(flattenCellValue) : cellValue;
};
function isMatched(searchQuery, cellValue, rowValue, dataType, dataTypeOptions, localization) {
  if (typeof cellValue === "object") {
    return flattenCellValue(cellValue).flat(Infinity).find((y4) => isWeakContains(y4, searchQuery));
  } else {
    const cellValueAsString = String(cellValue ?? "");
    if (cellValueAsString !== void 0 && isWeakContains(cellValueAsString, searchQuery)) {
      return true;
    } else {
      const dataTypeProperties = getDataTypeProperties(dataType);
      if (dataTypeProperties.getDisplayValue) {
        const cellDisplayValue = dataTypeProperties.getDisplayValue(cellValue, rowValue, {
          dataTypeOptions,
          localization
        });
        if (Array.isArray(cellDisplayValue)) {
          for (const displayValue of cellDisplayValue) {
            if (isWeakContains(displayValue, searchQuery)) {
              return true;
            }
          }
        } else if (cellDisplayValue !== void 0 && isWeakContains(cellDisplayValue, searchQuery)) {
          return true;
        }
      }
    }
  }
  return false;
}
function globalFilterFn(row, columnId, searchQuery, localization) {
  var _a;
  try {
    if (row.original) {
      const cellValue = row.getValue(columnId);
      const columnMeta = (_a = row._getAllCellsByColumnId()[columnId]) == null ? void 0 : _a.column.columnDef.meta;
      return isMatched(
        searchQuery,
        cellValue,
        row.original,
        columnMeta == null ? void 0 : columnMeta.dataType,
        columnMeta == null ? void 0 : columnMeta.dataTypeOptions,
        localization
      );
    }
  } catch {
  }
  return false;
}
function resetHighlightedColumnIndexes(searchQuery, table, localization) {
  const tableMeta = table.options.meta;
  let firstRowIndex;
  if (searchQuery) {
    const indexes = [];
    const columns = table.getVisibleLeafColumns();
    const rowGrouping = table.getState().grouping;
    table.getRowModel().rows.forEach((row, rowIndex) => {
      columns.forEach((column, columnIndex) => {
        var _a, _b;
        try {
          let allowSearch = true;
          if (rowGrouping == null ? void 0 : rowGrouping.length) {
            if (row.getIsGrouped()) {
              allowSearch = column.getIsGrouped();
            } else if (rowGrouping.includes(column.id)) {
              allowSearch = false;
            }
          }
          if (column.getIsVisible() && column.columnDef.enableGlobalFilter && allowSearch) {
            const cellValue = row.getValue(column.id);
            const dataType = (_a = column.columnDef.meta) == null ? void 0 : _a.dataType;
            const dataTypeOptions = (_b = column.columnDef.meta) == null ? void 0 : _b.dataTypeOptions;
            if (isMatched(searchQuery, cellValue, row.original, dataType, dataTypeOptions, localization)) {
              indexes.push([rowIndex, columnIndex]);
            }
          }
        } catch (e3) {
        }
      });
    });
    tableMeta.search.setHighlightedColumnIndexes(indexes);
    if (indexes.length) {
      firstRowIndex = indexes[0][0];
      tableMeta.search.setCurrentHighlightColumnIndex(0);
    } else {
      tableMeta.search.setCurrentHighlightColumnIndex(void 0);
    }
  } else {
    tableMeta.search.setHighlightedColumnIndexes([]);
    tableMeta.search.setCurrentHighlightColumnIndex(void 0);
  }
  if (firstRowIndex !== void 0) {
    tableMeta.rowActive.setRowActiveIndex(firstRowIndex);
  }
  return firstRowIndex;
}
function isInternalColumn(id2) {
  return id2 == null ? void 0 : id2.startsWith("__");
}
const getCellMinWidth = (fontSize = "medium") => {
  switch (fontSize) {
    case FontSizes.small:
      return 57;
    case FontSizes.large:
      return 83;
    default:
    case FontSizes.medium:
      return 72;
  }
};
function isCellHighlighted(query, value, row, dataType, dataTypeOptions, localization) {
  if (value === void 0 || value === null) {
    return false;
  }
  return isMatched(query, value, row, dataType, dataTypeOptions, localization);
}
function orderColumn(column, { orderingDisabled, orderingEnabled }) {
  var _a;
  const groupedColumn = column;
  if (Array.isArray(groupedColumn.columns) && groupedColumn.columns.length > 0) {
    groupedColumn.columns.forEach(
      (subcolumn) => orderColumn(subcolumn, { orderingDisabled, orderingEnabled })
    );
  } else {
    if ((_a = column.meta) == null ? void 0 : _a.enableOrdering) {
      orderingEnabled.push(column.id);
    } else {
      orderingDisabled.push(column.id);
    }
  }
}
function ensureOrdering(columns, settingsOrder, pinnedOrder = [], internalColumnsPinnedToTheRight = ["__actions"]) {
  const internalColumns = columns.filter((column) => isInternalColumn(column.id) && !internalColumnsPinnedToTheRight.includes(String(column.id))).map((column) => column.id);
  const orderingDisabled = [];
  let orderingEnabled = [];
  let orderedColumns = columns;
  if (Array.isArray(settingsOrder)) {
    orderedColumns = columns.slice().sort(
      // the magic >>> 0 here ensures that columns that aren't found in settings, but are children, are pushed to the end
      (a4, b3) => (settingsOrder.indexOf(a4.id) >>> 0) - (settingsOrder.indexOf(b3.id) >>> 0)
    );
  }
  orderedColumns.forEach((column) => {
    if (isInternalColumn(column.id)) {
      return;
    }
    orderColumn(column, { orderingDisabled, orderingEnabled });
  });
  if (settingsOrder && settingsOrder.length > 0) {
    const columnsAbsentInSettingsOrder = [];
    orderingEnabled = orderingEnabled.reduce((acc, column) => {
      const index2 = settingsOrder.indexOf(column);
      if (index2 > -1) {
        acc[index2] = column;
      } else {
        columnsAbsentInSettingsOrder.push(column);
      }
      return acc;
    }, []).filter((column) => !!column).concat(columnsAbsentInSettingsOrder);
  }
  if (Array.isArray(pinnedOrder)) {
    orderingEnabled.sort(
      // the magic >>> 0 here ensures that columns that aren't found in settings, but are children, are pushed to the end
      (a4, b3) => (pinnedOrder.indexOf(a4) >>> 0) - (pinnedOrder.indexOf(b3) >>> 0)
    );
  }
  const order2 = [...internalColumns, ...orderingDisabled, ...orderingEnabled];
  internalColumnsPinnedToTheRight.forEach((id2) => {
    if (columns.findIndex((column) => column.id === id2) > -1) {
      order2.push(id2);
    }
  });
  return order2;
}
function unfreezeAllExternalColumns(leftPinnedState) {
  return (leftPinnedState == null ? void 0 : leftPinnedState.filter((id2) => isInternalColumn(id2) && id2 !== "__actions")) ?? [];
}
function freezeUptoExternalColumn(index2, columns) {
  return columns.slice(0, index2 + 1);
}
function getHiddenColumns(columnVisibility = {}) {
  return Object.keys(columnVisibility).filter((c3) => columnVisibility[c3] === false);
}
function getSettings(table) {
  const meta = table.options.meta;
  const state = table.getState();
  return {
    // commented out properties are here to highlight things we explicitly don't want them saved
    //columnFilters: table.options.enableColumnFilters ? state.columnFilters : undefined,
    columnOrder: meta.columnOrdering.isEnabled ? state.columnOrder : void 0,
    columnPinning: state.columnPinning,
    columnSizing: ignoreInternalColumns(state.columnSizing),
    columnVisibility: table.options.enableHiding ? state.columnVisibility : void 0,
    excludeUnmatchedRecordsInSearch: table.options.enableGlobalFilter,
    fontSize: meta.fontSize.isEnabled ? meta.fontSize.size : void 0,
    //grouping: table.options.enableGrouping ? state.grouping : undefined,
    rowHeight: meta.rowHeight.isEnabled ? meta.rowHeight.height : void 0,
    //searchQuery: table.options.enableGlobalFilter ? state.globalFilter : undefined,
    sorting: state.sorting
  };
}
function ignoreInternalColumns(data) {
  return Object.keys(data).reduce((accum, key) => {
    if (isInternalColumn(key)) {
      return accum;
    }
    return {
      ...accum,
      [key]: data[key]
    };
  }, {});
}
function processChildren(child, columns, defaultSizing, defaultSorting, defaultVisibility, settings, defaultRowGroupColumnId, localization) {
  const columnHelper = createColumnHelper();
  if (React__default.isValidElement(child) && child.props.children) {
    const { children, id: id2, header } = child.props;
    columns.push(
      columnHelper.group({
        id: id2,
        header,
        columns: React__default.Children.toArray(children).reduce(
          (columns2, child2) => processChildren(
            child2,
            columns2,
            defaultSizing,
            defaultSorting,
            defaultVisibility,
            settings,
            defaultRowGroupColumnId,
            localization
          ),
          []
        ),
        // we don't want to let column groups be grouped/aggregrated
        enableGrouping: false
      })
    );
  } else if (React__default.isValidElement(child) && (child.props.accessor || child.props.id)) {
    const {
      id: untypedId,
      accessor: accessorKey,
      // renderers
      renderer: renderer2,
      aggregate,
      footer,
      header,
      // options
      aggregationFn,
      defaultHidden,
      defaultWidth,
      enableEditing = !!child.props.control,
      enableFiltering: enableColumnFilter = true,
      enableGrouping = false,
      enableHiding = true,
      enableOrdering = true,
      enablePrinting = true,
      enableResizing = true,
      enableSearch: enableGlobalFilter = true,
      enableSorting = true,
      enableTruncate = false,
      minWidth: minSize = getCellMinWidth(settings.fontSize),
      sort,
      sortFn,
      ...meta
    } = child.props;
    const id2 = untypedId ?? accessorKey;
    const dataTypeProperties = getDataTypeProperties(child.props.dataType);
    if (defaultHidden && enableHiding) {
      defaultVisibility[id2] = false;
    }
    if (defaultWidth) {
      defaultSizing[id2] = defaultWidth;
    }
    const isGrouped = defaultRowGroupColumnId === id2;
    if (child.props.sort !== void 0 || isGrouped) {
      defaultSorting.push({
        id: id2,
        desc: sort === "desc"
      });
    }
    const column = {
      id: id2,
      // dot notated accessors will throw if they return null or undefined, so use accessorFn (instead of accessorKey) to avoid that
      accessorFn: (row) => get(row, accessorKey),
      // The header can be either a string or a JSX.Element, but react-table expects it to be a string or a
      // renderer function, so `() => header` ensures compatibility when header is a JSX.Element.
      // If we just pass `() => header`, then we will loose truncation for string headers.
      header: typeof header === "string" ? header : () => header,
      // features
      enableColumnFilter,
      enableGlobalFilter,
      enableGrouping,
      enableHiding: isGrouped ? false : enableHiding,
      enableResizing,
      enableSorting,
      // config - sizing
      minSize,
      // meta
      meta: {
        ...meta,
        align: meta.align ?? dataTypeProperties.align,
        defaultWidth,
        enableOrdering: isGrouped ? false : enableOrdering,
        enablePrinting,
        enableTruncate,
        enableEditing,
        header
      }
    };
    const formattedValueRenderer = (value, row) => {
      var _a;
      const displayValue = (_a = dataTypeProperties.getDisplayValue) == null ? void 0 : _a.call(dataTypeProperties, value, row, {
        dataTypeOptions: meta.dataTypeOptions,
        localization
      });
      const safeValue = value !== void 0 && value !== null ? String(value) : value;
      if (Array.isArray(displayValue)) {
        return displayValue[0] ?? safeValue;
      }
      return displayValue ?? safeValue;
    };
    const rendererArgs = (info) => ({
      formattedValue: formattedValueRenderer(info.getValue(), info.row.original),
      row: info.row.original,
      value: info.getValue()
    });
    if (typeof renderer2 === "function") {
      column.cell = (info) => renderer2(rendererArgs(info));
    } else {
      column.cell = (info) => formattedValueRenderer(info.getValue(), info.row.original);
    }
    if (typeof footer === "function") {
      column.footer = (info) => footer(info.table.getRowModel().rows.flatMap((row) => row.original !== void 0 ? row.original : []));
    }
    if (enableColumnFilter) {
      column.filterFn = "tacoFilter";
    }
    if (enableGrouping) {
      column.aggregationFn = aggregationFn;
      if (typeof aggregate === "function") {
        column.aggregatedCell = (info) => aggregate(rendererArgs(info));
      }
    }
    if (enableSorting) {
      column.sortingFn = getSortingFn(child.props.dataType, sortFn);
      column.sortDescFirst = false;
      column.sortUndefined = 1;
    }
    columns.push(column);
  }
  return columns;
}
function createInternalColumn(id2, column, defaultSizing) {
  if (column.size) {
    defaultSizing[id2] = column.size;
  }
  return {
    id: id2,
    accessorKey: id2,
    header: column.header,
    cell: column.renderer,
    // features
    enableColumnFilter: false,
    enableGlobalFilter: false,
    enableGrouping: false,
    enableHiding: false,
    enableResizing: false,
    enableSorting: false,
    // config - sizing
    size: column.size,
    minSize: column.size,
    // meta
    meta: {
      ...column.meta,
      enableOrdering: false,
      enablePrinting: false,
      enableTruncate: false
    }
  };
}
function mapTableChildrenToColumns(props, settings, options, internalColumns, localization) {
  var _a;
  const { children, defaultRowGroupColumnId } = props;
  const defaultSizing = {};
  const defaultSorting = [];
  const defaultVisibility = {};
  const columns = React__default.Children.toArray(children).reduce(
    (columns2, child) => processChildren(
      child,
      columns2,
      defaultSizing,
      defaultSorting,
      defaultVisibility,
      settings,
      defaultRowGroupColumnId,
      localization
    ),
    []
  );
  if (internalColumns) {
    if (options.enableRowExpansion && props.rowExpansionRenderer && internalColumns.rowExpansion) {
      const column = createInternalColumn("__expansion", internalColumns.rowExpansion, defaultSizing);
      columns.unshift(column);
    }
    if (options.enableRowSelection && internalColumns.rowSelection) {
      const column = createInternalColumn("__select", internalColumns.rowSelection, defaultSizing);
      columns.unshift(column);
    }
    if (options.enableRowDrag && props.onRowDrag && internalColumns.rowDrag) {
      const column = createInternalColumn("__drag", internalColumns.rowDrag, defaultSizing);
      columns.unshift(column);
    }
    if (options.enableRowActions && ((_a = props.rowActions) == null ? void 0 : _a.length) && internalColumns.rowActions) {
      const column = createInternalColumn("__actions", internalColumns.rowActions, defaultSizing);
      columns.push(column);
    }
  }
  return { columns, defaultSizing, defaultSorting, defaultVisibility };
}
function configureReactTableOptions(options, props, localization) {
  const reactTableEnableRowSelection = typeof options.enableRowSelection === "function" ? (row) => options.enableRowSelection(row.original) : options.enableRowSelection;
  let getRowId;
  if (props.rowIdentityAccessor) {
    getRowId = (originalRow, index2) => {
      if (originalRow) {
        return String(originalRow[props.rowIdentityAccessor]);
      }
      return String(index2);
    };
  }
  const tableOptions = {
    defaultColumn: {
      enableColumnFilter: options.enableFiltering || true,
      enableGrouping: false,
      enableHiding: options.enableColumnHiding || true,
      enableResizing: options.enableColumnResizing || true,
      enableGlobalFilter: options.enableSearch || true,
      enableSorting: options.enableSorting || true,
      minSize: 1,
      // the default is 150, which is a bit random
      size: 1
    },
    enableColumnFilters: options.enableFiltering ?? false,
    enableColumnResizing: options.enableColumnResizing ?? false,
    enableExpanding: options.enableRowExpansion ?? false,
    enableGrouping: true,
    // users can't customise row grouping, so it can just be always enabled and left to the defaultRowGroupColumnId prop
    enableHiding: options.enableColumnHiding ?? false,
    enablePinning: options.enableColumnFreezing ?? false,
    enableRowPinning: true,
    // users can't customise row pinning, so it can just be always enabled
    enableRowSelection: reactTableEnableRowSelection ?? false,
    enableSorting: options.enableSorting ?? false,
    // models for default features
    getExpandedRowModel: getExpandedRowModel(),
    getGroupedRowModel: getGroupedRowModel(),
    getRowId,
    groupedColumnMode: false,
    keepPinnedRows: false
  };
  if (tableOptions.enableColumnResizing) {
    tableOptions.columnResizeMode = "onChange";
  }
  if (tableOptions.enableColumnFilters) {
    if (props.onChangeFilter) ;
    else {
      tableOptions.getFilteredRowModel = getFilteredRowModel();
      tableOptions.filterFns = {
        tacoFilter: (row, columnId, filter2) => columnFilterFn(row.getValue(columnId), filter2)
      };
    }
  }
  if (options.enableSearch) {
    tableOptions.getFilteredRowModel = getFilteredRowModel();
    tableOptions.globalFilterFn = (row, columnId, searchQuery) => globalFilterFn(row, columnId, searchQuery, localization);
    tableOptions.getColumnCanGlobalFilter = (column) => {
      var _a;
      return ((_a = column.columnDef.meta) == null ? void 0 : _a.enableSearch) !== false && column.getIsVisible();
    };
    if (props.onChangeSearch) {
      if (props._experimentalDataLoader2) {
        tableOptions.manualFiltering = true;
      }
    }
  }
  if (tableOptions.enableSorting) {
    if (props.onChangeSort) {
      tableOptions.manualSorting = true;
    } else {
      tableOptions.getSortedRowModel = getSortedRowModel();
    }
  }
  return tableOptions;
}
function useReactTableInitialState(props, columns, persistedSettings, defaults2) {
  return React__default.useMemo(() => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const ignoreNotDefinedColumns = (column) => columns.find((definedColumn) => definedColumn.id === column.id);
    const columnPinning = persistedSettings.columnPinning ?? ((_a = props.defaultSettings) == null ? void 0 : _a.columnPinning) ?? {};
    const columnOrder = ensureOrdering(
      columns,
      persistedSettings.columnOrder ?? ((_b = props.defaultSettings) == null ? void 0 : _b.columnOrder),
      columnPinning.left
    );
    if ((_c = columnPinning == null ? void 0 : columnPinning.left) == null ? void 0 : _c.length) {
      columnPinning.left = freezeUptoExternalColumn(
        columnOrder.indexOf(columnPinning.left[columnPinning.left.length - 1]),
        columnOrder
      );
    } else {
      if (props.defaultColumnFreezingIndex) {
        columnPinning.left = freezeUptoExternalColumn(props.defaultColumnFreezingIndex, columnOrder);
      } else {
        columnPinning.left = unfreezeAllExternalColumns(columnOrder);
      }
    }
    const state = {
      columnFilters: persistedSettings.columnFilters ?? ((_d = props.defaultSettings) == null ? void 0 : _d.columnFilters) ?? [],
      columnOrder,
      columnPinning,
      columnSizing: ignoreInternalColumns(
        persistedSettings.columnSizing ?? ((_e = props.defaultSettings) == null ? void 0 : _e.columnSizing) ?? defaults2.defaultSizing ?? {}
      ),
      columnVisibility: persistedSettings.columnVisibility ?? ((_f = props.defaultSettings) == null ? void 0 : _f.columnVisibility) ?? defaults2.defaultVisibility ?? {},
      globalFilter: persistedSettings.searchQuery ?? ((_g = props.defaultSettings) == null ? void 0 : _g.searchQuery),
      sorting: persistedSettings.sorting ? persistedSettings.sorting.filter(ignoreNotDefinedColumns) : ((_h = props.defaultSettings) == null ? void 0 : _h.sorting) ?? defaults2.defaultSorting
    };
    if (props.defaultRowGroupColumnId) {
      state.grouping = [props.defaultRowGroupColumnId];
      state.expanded = true;
    }
    return state;
  }, []);
}
const DEFAULT_PRESET = {
  // react-table built-in
  enableFiltering: false,
  enableSearch: false,
  enableSorting: false,
  enableColumnFreezing: false,
  enableColumnHiding: false,
  enableColumnResizing: false,
  enableRowExpansion: false,
  enableRowExpansionAll: true,
  enableRowSelection: false,
  // custom -- common between all table types
  enableColumnOrdering: false,
  enableFontSize: false,
  enableFooter: false,
  enablePrinting: false,
  enableRowActive: true,
  enableRowActions: true,
  enableRowClick: false,
  enableRowDrag: false,
  enableRowDrop: false,
  enableRowGoto: false,
  enableRowHeight: false,
  enableSaveSettings: false
};
const presets = {
  // View/edit/create on page
  complex: {
    // react-table built-in
    enableFiltering: true,
    enableSearch: true,
    enableSorting: true,
    enableColumnFreezing: true,
    enableColumnHiding: true,
    enableColumnResizing: true,
    enableRowExpansion: true,
    enableRowExpansionAll: true,
    enableRowSelection: true,
    // custom -- common between all table types
    enableColumnOrdering: true,
    enableFontSize: true,
    enableFooter: true,
    enablePrinting: true,
    enableRowActive: true,
    enableRowActions: true,
    enableRowClick: true,
    enableRowDrag: true,
    enableRowDrop: true,
    enableRowGoto: true,
    enableRowHeight: true,
    enableSaveSettings: true
  },
  // View/create in dialog
  list: {
    // react-table built-in
    enableFiltering: false,
    enableSearch: true,
    enableSorting: true,
    enableColumnFreezing: false,
    enableColumnHiding: false,
    enableColumnResizing: false,
    enableRowExpansion: true,
    enableRowExpansionAll: true,
    enableRowSelection: true,
    // custom -- common between all table types
    enableColumnOrdering: false,
    enableFontSize: false,
    enableFooter: false,
    enablePrinting: false,
    enableRowActive: true,
    enableRowActions: true,
    enableRowClick: true,
    enableRowDrag: false,
    enableRowDrop: false,
    enableRowGoto: false,
    enableRowHeight: false,
    enableSaveSettings: true
  },
  // View in card or dialog
  simple: {
    // react-table built-in
    enableFiltering: false,
    enableSearch: false,
    enableSorting: true,
    enableColumnFreezing: false,
    enableColumnHiding: false,
    enableColumnResizing: false,
    enableRowExpansion: true,
    enableRowExpansionAll: true,
    enableRowSelection: false,
    // custom -- common between all table types
    enableColumnOrdering: false,
    enableFontSize: false,
    enableFooter: false,
    enablePrinting: false,
    enableRowActive: true,
    enableRowActions: false,
    enableRowClick: true,
    enableRowDrag: false,
    enableRowDrop: false,
    enableRowGoto: false,
    enableRowHeight: false,
    enableSaveSettings: true
  }
};
function getTableFeaturePreset(props) {
  var _a;
  const presetOptions = props.preset ? presets[props.preset] : DEFAULT_PRESET;
  const enableRowActions = props.enableRowActions ?? presetOptions.enableRowActions;
  const enableRowClick = props.enableRowClick ?? presetOptions.enableRowClick;
  const enableRowDrag = props.enableRowDrag ?? presetOptions.enableRowDrag;
  const enableRowDrop = props.enableRowDrop ?? presetOptions.enableRowDrop;
  const enableRowGoto = props.enableRowGoto ?? presetOptions.enableRowGoto;
  const enableRowExpansion = props.enableRowExpansion ?? presetOptions.enableRowExpansion;
  const enableRowExpansionAll = props.enableRowExpansionAll ?? presetOptions.enableRowExpansionAll;
  const enableRowSelection = props.enableRowSelection ?? presetOptions.enableRowSelection;
  return {
    // react-table built-in
    enableFiltering: props.enableFiltering ?? presetOptions.enableFiltering,
    enableSearch: props.enableSearch ?? presetOptions.enableSearch,
    enableSorting: props.enableSorting ?? presetOptions.enableSorting,
    enableColumnFreezing: props.enableColumnFreezing ?? presetOptions.enableColumnFreezing,
    enableColumnHiding: props.enableColumnHiding ?? presetOptions.enableColumnHiding,
    enableColumnResizing: props.enableColumnResizing ?? presetOptions.enableColumnResizing,
    enableRowExpansion: enableRowExpansion && !!props.rowExpansionRenderer,
    enableRowSelection: !!props.onRowSelect && enableRowSelection,
    // custom -- common between all table types
    enableColumnOrdering: props.enableColumnOrdering ?? presetOptions.enableColumnOrdering,
    enableFontSize: props.enableFontSize ?? presetOptions.enableFontSize,
    enableFooter: props.enableFooter ?? presetOptions.enableFooter,
    enablePrinting: props.enablePrinting ?? presetOptions.enablePrinting,
    enableRowActive: props.enableRowActive ?? presetOptions.enableRowActive,
    enableRowActions: enableRowActions && !!((_a = props.rowActions) == null ? void 0 : _a.length),
    // enableRowClick can be either function or boolean, that is why we need to pass exactly enableRowClick,
    // and not just result of the condition
    enableRowClick: enableRowClick && !!props.onRowClick ? enableRowClick : false,
    enableRowDrag: enableRowDrag && !!props.onRowDrag,
    enableRowDrop: enableRowDrop && !!props.onRowDrop,
    enableRowGoto: enableRowGoto && !!props.onRowGoto,
    enableRowExpansionAll: enableRowExpansion && enableRowExpansionAll && !!props.rowExpansionRenderer,
    enableRowHeight: props.enableRowHeight ?? presetOptions.enableRowHeight,
    enableSaveSettings: props.enableSaveSettings ?? presetOptions.enableSaveSettings
  };
}
function useTableColumnFreezing(isEnabled = false) {
  const [isHorizontallyScrolled, setHorizontallyScrolled] = React__default.useState(false);
  const handleScroll2 = (event) => {
    if (event.currentTarget.scrollLeft > 0 && !isHorizontallyScrolled) {
      setHorizontallyScrolled(true);
    } else if (event.currentTarget.scrollLeft === 0 && isHorizontallyScrolled) {
      setHorizontallyScrolled(false);
    }
  };
  return {
    isEnabled,
    isHorizontallyScrolled,
    handleScroll: handleScroll2
  };
}
function useTableColumnOrdering(isEnabled = false) {
  return {
    isEnabled
  };
}
function useTableFooter(isEnabled = false) {
  return {
    isEnabled
  };
}
function useTableFontSize(isEnabled = false, defaultFontSize = "medium") {
  const [size2, setSize] = React__default.useState(defaultFontSize);
  return {
    isEnabled,
    size: size2,
    setSize: isEnabled ? setSize : () => void 0
  };
}
function useTacoSettings() {
  return React__default.useContext(TacoContext);
}
const useLocalStorage = (key, initialValue) => {
  const [state, setState] = React__default.useState(() => {
    if (!key) {
      return initialValue;
    }
    try {
      const localStorageValue = localStorage.getItem(key);
      if (typeof localStorageValue !== "string") {
        localStorage.setItem(key, JSON.stringify(initialValue));
        return initialValue;
      } else {
        return JSON.parse(localStorageValue || "null");
      }
    } catch {
      return initialValue;
    }
  });
  React__default.useEffect(() => {
    if (!key) {
      return;
    }
    try {
      const serializedState = JSON.stringify(state);
      localStorage.setItem(key, serializedState);
    } catch {
    }
  }, [key, state]);
  const clear = () => {
    if (key) {
      localStorage.removeItem(key);
    }
  };
  return [state, setState, clear];
};
function useTablePrinting(isEnabled = false, tableId) {
  const [isPrinting, setIsPrinting] = React__default.useState(false);
  const [settings, setSetting] = useTablePrintingSettings(tableId);
  return {
    isEnabled,
    isPrinting,
    setIsPrinting,
    settings,
    setSetting
  };
}
const DEFAULT_PRINT_SETTINGS = {
  size: "A4",
  orientation: "portrait",
  allRows: true,
  splitGroups: true
};
function useTablePrintingSettings(tableId) {
  const tacoSettings = useTacoSettings();
  const uniqueId3 = `taco.${tacoSettings.uniqueUserIdentifier}.table.${tableId}.print.settings`;
  const [persistedSettings, setPersistedSettings] = useLocalStorage(uniqueId3, DEFAULT_PRINT_SETTINGS);
  function setSetting(key, value) {
    setPersistedSettings((currentSettings) => ({
      ...currentSettings,
      [key]: value
    }));
  }
  return [persistedSettings, setSetting];
}
const DEFAULT_ROW_ACTIONS_LENGTH = 4;
function useTableRowActions(isEnabled = false, rowActions, rowActionsLength = DEFAULT_ROW_ACTIONS_LENGTH) {
  const [handlers, setHandlers] = React__default.useState({});
  const registerHandler = (key, handler) => {
    return setHandlers((h4) => ({
      ...h4,
      [key]: handler
    }));
  };
  return {
    handlers,
    isEnabled,
    registerHandler,
    rowActions: isEnabled ? rowActions : void 0,
    rowActionsLength: rowActions ? Math.min(rowActions.length, rowActionsLength) : 0
  };
}
const useIsHoverStatePaused = () => {
  const [shouldPauseHoverState, setShouldPauseHoverState] = React__default.useState(false);
  React__default.useEffect(() => {
    const move = () => setShouldPauseHoverState(false);
    if (shouldPauseHoverState) {
      document.addEventListener("mousemove", move);
    }
    return () => {
      document.removeEventListener("mousemove", move);
    };
  }, [shouldPauseHoverState]);
  return [shouldPauseHoverState, setShouldPauseHoverState];
};
function useTableRowActive$1(isEnabled = false, initialRowActiveIndex) {
  const [rowActiveIndex, setRowActiveIndex] = React__default.useState(initialRowActiveIndex);
  const [rowHoverIndex, setRowHoverIndex] = React__default.useState(void 0);
  const [isHoverStatePaused, setHoverStatePaused] = useIsHoverStatePaused();
  const move = (direction, length, scrollToIndex) => {
    const nextIndex = rowActiveIndex !== void 0 ? getNextIndex(direction, rowActiveIndex, length) : 0;
    scrollToIndex(nextIndex);
    setTimeout(() => setRowActiveIndex(nextIndex), 50);
  };
  const onKeyDown = React__default.useCallback(
    (event, length, scrollToIndex) => {
      if (!isEnabled || event.defaultPrevented) {
        return;
      }
      if (event.key === "ArrowUp" || event.key === "ArrowDown") {
        setHoverStatePaused(true);
      }
      if (event.key === "ArrowUp") {
        event.preventDefault();
        if (event.ctrlKey || event.metaKey) {
          const newIndex = 0;
          scrollToIndex(newIndex);
          setRowActiveIndex(newIndex);
        } else {
          move(-1, length, scrollToIndex);
        }
        return;
      } else if (event.key === "ArrowDown") {
        event.preventDefault();
        if (event.ctrlKey || event.metaKey) {
          const newIndex = length - 1;
          scrollToIndex(newIndex);
          setRowActiveIndex(newIndex);
        } else {
          move(1, length, scrollToIndex);
        }
        return;
      }
    },
    [isEnabled, rowActiveIndex]
  );
  const onFocus = React__default.useCallback(
    (event, length, scrollToIndex) => {
      if (!isEnabled || event.isDefaultPrevented()) {
        return;
      }
      if (event.target.closest("tbody") || isElementInsideOrTriggeredFromContainer(event.target, event.currentTarget)) {
        return;
      }
      if (rowActiveIndex === void 0 && length > 0) {
        setRowActiveIndex((index2) => {
          if (index2 === void 0) {
            scrollToIndex(0);
            return 0;
          }
          return index2;
        });
      }
    },
    [rowActiveIndex, isEnabled]
  );
  return {
    isEnabled,
    rowActiveIndex,
    setRowActiveIndex: isEnabled ? setRowActiveIndex : () => void 0,
    rowHoverIndex,
    setRowHoverIndex,
    isHoverStatePaused,
    setHoverStatePaused: isEnabled ? setHoverStatePaused : () => void 0,
    handleFocus: isEnabled ? onFocus : () => void 0,
    handleKeyDown: isEnabled ? onKeyDown : () => void 0
  };
}
function getNextIndex(direction, currentIndex, length) {
  if (direction === -1) {
    return currentIndex - 1 > 0 ? currentIndex - 1 : 0;
  }
  return currentIndex + 1 < length ? currentIndex + 1 : currentIndex;
}
function useTableRowClick(isEnabled = false, onRowClick) {
  const isRowClickEnabled = React__default.useCallback(
    (row) => {
      return typeof isEnabled === "boolean" ? isEnabled : isEnabled(row);
    },
    [isEnabled]
  );
  const handleKeyDown = React__default.useCallback(
    function(event, rowData) {
      if (!isRowClickEnabled(rowData) || typeof onRowClick !== "function" || event.defaultPrevented) {
        return;
      }
      if (rowData && event.key === "Enter") {
        event.preventDefault();
        onRowClick(rowData);
        return;
      }
    },
    [isEnabled, onRowClick]
  );
  const handleClick = React__default.useCallback(
    function(event, rowData) {
      if (!isRowClickEnabled(rowData) || typeof onRowClick !== "function" || event.defaultPrevented) {
        return;
      }
      event.preventDefault();
      onRowClick(rowData);
      return;
    },
    [isEnabled, onRowClick]
  );
  return {
    isEnabled: isRowClickEnabled,
    handleClick,
    handleKeyDown
  };
}
function useTableRowExpansion(isEnabled = false, canExpandAll = true, rowExpansionRenderer) {
  return {
    isEnabled,
    canExpandAll,
    rowExpansionRenderer: isEnabled ? rowExpansionRenderer : void 0
  };
}
function useTableRowGoto(isEnabled = false, handler) {
  return {
    isEnabled,
    handleGoto: isEnabled ? handler : void 0
  };
}
function useTableRowGroups(rowActionsForGroup) {
  return {
    isEnabled: true,
    rowActionsForGroup
  };
}
function useTableRowHeight(isEnabled = false, defaultRowHeight = "medium") {
  const [height, setHeight] = React__default.useState(defaultRowHeight);
  return {
    isEnabled,
    height,
    setHeight: isEnabled ? setHeight : () => void 0
  };
}
function useTableRowSelection(isEnabled = false) {
  const lastSelectedRowIndex = React__default.useRef();
  const onKeyDown = React__default.useCallback(
    (event, table) => {
      var _a, _b, _c;
      if (!isEnabled || !table.options.enableRowSelection || event.defaultPrevented) {
        return;
      }
      const rows = table.getRowModel().rows;
      const tableMeta = table.options.meta;
      if (event.key === " ") {
        event.preventDefault();
        const rowActiveIndex = tableMeta.rowActive.rowActiveIndex;
        if (rowActiveIndex !== void 0 && ((_a = rows[rowActiveIndex]) == null ? void 0 : _a.getCanSelect())) {
          (_b = rows[rowActiveIndex]) == null ? void 0 : _b.toggleSelected();
        }
        return;
      } else if ((event.ctrlKey || event.metaKey) && event.key === "a" && !["INPUT", "TEXTAREA"].includes((_c = event.target) == null ? void 0 : _c.tagName)) {
        event.preventDefault();
        table.toggleAllRowsSelected();
        return;
      }
    },
    [isEnabled]
  );
  return {
    isEnabled,
    handleKeyDown: isEnabled ? onKeyDown : () => void 0,
    lastSelectedRowIndex
  };
}
function useTableSearch(isEnabled = false, onChangeSearch, defaultEnableGlobalFilter = false) {
  const [enableGlobalFilter, _setEnableGlobalFilter] = React__default.useState(defaultEnableGlobalFilter);
  function setEnableGlobalFilter(enabled, instance) {
    _setEnableGlobalFilter(enabled);
    const currentFilter = instance.getState().globalFilter;
    if (currentFilter) {
      instance.resetGlobalFilter(true);
      window.requestAnimationFrame(() => {
        instance.setGlobalFilter(currentFilter);
      });
    }
  }
  const [highlightedColumnIndexes, setHighlightedColumnIndexes] = React__default.useState([]);
  const [currentHighlightColumnIndex, setCurrentHighlightColumnIndex] = React__default.useState(void 0);
  return {
    isEnabled,
    // filtering - built-in
    enableGlobalFilter,
    setEnableGlobalFilter,
    // highlighting - custom
    highlightedColumnIndexes,
    setHighlightedColumnIndexes,
    currentHighlightColumnIndex,
    setCurrentHighlightColumnIndex,
    handleSearch: isEnabled && typeof onChangeSearch === "function" ? onChangeSearch : void 0
  };
}
const DEFAULT_PAGE_SIZE$1 = 100;
function useTableDataLoader(fetchPage, fetchAll, options = { pageSize: DEFAULT_PAGE_SIZE$1 }) {
  const { pageSize } = options;
  const length = React__default.useRef(void 0);
  const [data, setData] = React__default.useState([]);
  const _pendingPageRequests = React__default.useRef({});
  const _lastUsedSorting = React__default.useRef([]);
  const _lastUsedFilters = React__default.useRef([]);
  const _lastUsedSearch = React__default.useRef();
  const _lastUsedHiddenColumns = React__default.useRef([]);
  const _lastUsedPageIndex = React__default.useRef();
  const loadPage = async (pageIndex, sorting, filters, hiddenColumns) => {
    let reset = false;
    if (JSON.stringify(sorting) !== JSON.stringify(_lastUsedSorting.current) || JSON.stringify(filters) !== JSON.stringify(_lastUsedFilters.current)) {
      _pendingPageRequests.current = {};
      reset = true;
    }
    if (_pendingPageRequests.current[pageIndex]) {
      return;
    } else {
      _pendingPageRequests.current[pageIndex] = true;
    }
    _lastUsedPageIndex.current = pageIndex;
    _lastUsedSorting.current = sorting;
    _lastUsedFilters.current = filters;
    _lastUsedHiddenColumns.current = hiddenColumns;
    try {
      const response = await fetchPage(pageIndex, pageSize, sorting, filters, hiddenColumns);
      setData((currentData) => {
        let nextData;
        if (reset || length.current !== response.length) {
          length.current = response.length;
          nextData = Array(length.current).fill(void 0);
        } else {
          nextData = [...currentData];
        }
        const startIndex = pageIndex * pageSize;
        nextData.splice(startIndex, pageSize, ...response.data);
        return nextData;
      });
    } catch {
    } finally {
      _pendingPageRequests.current[pageIndex] = false;
    }
  };
  const loadAll = async (sorting, filters, hiddenColumns) => {
    _lastUsedSorting.current = sorting;
    _lastUsedFilters.current = filters;
    _lastUsedHiddenColumns.current = hiddenColumns;
    try {
      const response = await fetchAll(sorting, filters, hiddenColumns);
      length.current = response.length;
      setData(() => {
        let nextData;
        if (response.data.length !== response.length) {
          nextData = Array(response.length).fill(void 0);
          nextData.splice(0, response.data.length, ...response.data);
        } else {
          nextData = [...response.data];
        }
        return nextData;
      });
    } catch {
    }
  };
  const reloadCurrentPages = async (pageIndex, sorting, filters, hiddenColumns) => {
    _lastUsedPageIndex.current;
    const pageIndexes = pageIndex === 0 ? [0, 1] : [pageIndex - 1, pageIndex];
    if (length.current !== void 0) {
      const pageCount = Math.ceil(length.current / pageSize);
      if (pageIndex + 1 < pageCount) {
        pageIndexes.push(pageIndex + 1);
      }
    }
    _pendingPageRequests.current = pageIndexes.reduce((accum, index2) => ({ ...accum, [index2]: true }), {});
    _lastUsedPageIndex.current = pageIndex;
    _lastUsedSorting.current = sorting;
    _lastUsedFilters.current = filters;
    _lastUsedHiddenColumns.current = hiddenColumns;
    try {
      const responses = await Promise.all(
        pageIndexes.map((pageIndex2) => fetchPage(pageIndex2, pageSize, sorting, filters, hiddenColumns))
      );
      length.current = responses[0].length;
      const nextData = Array(length.current).fill(void 0);
      responses.forEach((response, index2) => {
        const startIndex = pageIndexes[index2] * pageSize;
        nextData.splice(startIndex, pageSize, ...response.data);
      });
      setData(nextData);
    } catch {
    } finally {
      _pendingPageRequests.current = {};
    }
  };
  const invalidate = async () => {
    if (_lastUsedSearch.current) {
      return loadAll(_lastUsedSorting.current, _lastUsedFilters.current, _lastUsedHiddenColumns.current);
    } else {
      return reloadCurrentPages(
        _lastUsedPageIndex.current ?? 0,
        _lastUsedSorting.current,
        _lastUsedFilters.current,
        _lastUsedHiddenColumns.current
      );
    }
  };
  const handleSort = async (sorting) => {
    if (_lastUsedSearch.current) {
      return loadAll(sorting, _lastUsedFilters.current, _lastUsedHiddenColumns.current);
    } else {
      return reloadCurrentPages(
        _lastUsedPageIndex.current ?? 0,
        sorting,
        _lastUsedFilters.current,
        _lastUsedHiddenColumns.current
      );
    }
  };
  const handleFilter = async (filters) => {
    if (_lastUsedSearch.current) {
      return loadAll(_lastUsedSorting.current, filters, _lastUsedHiddenColumns.current);
    } else {
      return loadPage(_lastUsedPageIndex.current ?? 0, _lastUsedSorting.current, filters, _lastUsedHiddenColumns.current);
    }
  };
  const handleSearch = async (search) => {
    _lastUsedSearch.current = search || void 0;
  };
  return [
    {
      data,
      length: length.current,
      loadAll,
      loadPage,
      onChangeFilter: handleFilter,
      onChangeSearch: handleSearch,
      onChangeSort: handleSort,
      pageSize
    },
    invalidate
  ];
}
function useTableServerLoading(length, data, loadPage, loadAll, pages, pageSize = DEFAULT_PAGE_SIZE$1, _experimentalDataLoader2 = false) {
  const isEnabled = !!loadPage && !!loadAll;
  const [isReady, setReady] = React__default.useState(false);
  const [loading, setLoading] = React__default.useState(false);
  const hasLoadedAll = React__default.useMemo(() => {
    var _a;
    if (data.length !== length || !!((_a = data.some) == null ? void 0 : _a.call(data, (x3) => x3 === void 0))) {
      return false;
    }
    return true;
  }, [data, length]);
  let _loadPage;
  let _loadAll;
  let _loadAllIfNeeded;
  if (typeof loadPage === "function") {
    _loadPage = async (...args) => {
      if (typeof loadPage === "function") {
        await loadPage(...args);
        setReady(true);
      }
    };
  }
  if (typeof loadAll === "function") {
    _loadAll = async (...args) => {
      if (typeof loadAll === "function") {
        setLoading(true);
        await loadAll(...args);
        setLoading(false);
        setReady(true);
      }
    };
    _loadAllIfNeeded = async (...args) => {
      if (!hasLoadedAll) {
        await (_loadAll == null ? void 0 : _loadAll(...args));
      }
    };
  }
  const pageCount = Math.ceil(length / pageSize);
  return {
    pages,
    isEnabled,
    isReady,
    loadPage: _loadPage,
    loadAll: _loadAll,
    loadAllIfNeeded: _loadAllIfNeeded,
    loading,
    pageSize,
    pageCount,
    _experimentalDataLoader2
  };
}
const DEFAULT_ENABLED_OPTIONS = {
  columnOrder: true,
  columnPinning: true,
  columnSizing: true,
  columnVisibility: true,
  excludeUnmatchedRecordsInSearch: true,
  fontSize: true,
  grouping: true,
  rowHeight: true,
  sorting: true
};
function useUniqueTableId(tableId) {
  const tacoSettings = useTacoSettings();
  return `taco.${tacoSettings.uniqueUserIdentifier}.table.${tableId}.settings`;
}
function useEnabledSettings(isEnabled) {
  return React__default.useMemo(() => {
    if (isEnabled === false) {
      return [
        Object.keys(DEFAULT_ENABLED_OPTIONS).reduce(
          (o2, key) => ({ ...o2, [key]: false }),
          {}
        ),
        false
      ];
    } else if (isEnabled === true) {
      return [DEFAULT_ENABLED_OPTIONS, true];
    }
    const options = { ...DEFAULT_ENABLED_OPTIONS, ...isEnabled };
    return [options, Object.values(options).some((o2) => o2 === true)];
  }, [isEnabled]);
}
function useTableSettings(isEnabled = false, id2, defaultSettings = {}, onChangeSettings) {
  const uniqueId3 = useUniqueTableId(id2);
  const [enabledSettings, hasSomeEnabledSettings] = useEnabledSettings(isEnabled);
  const [persistedSettings, _setPersistedSettings] = useLocalStorage(
    hasSomeEnabledSettings ? uniqueId3 : void 0,
    removeDisabledSettings(defaultSettings, enabledSettings)
  );
  const setPersistedSettings = React__default.useCallback(
    (value) => {
      if (!hasSomeEnabledSettings) {
        return;
      }
      const sanitizedSettings = removeDisabledSettings(value, enabledSettings);
      _setPersistedSettings(sanitizedSettings);
      if (typeof onChangeSettings === "function") {
        onChangeSettings(sanitizedSettings);
      }
    },
    [hasSomeEnabledSettings, onChangeSettings, JSON.stringify(enabledSettings)]
  );
  if (!hasSomeEnabledSettings) {
    return [defaultSettings, () => void 0];
  }
  return [persistedSettings, setPersistedSettings];
}
function removeDisabledSettings(settings, enabledSettings) {
  const sanitizedSettings = { ...settings };
  Object.keys(enabledSettings).forEach((setting) => {
    if (!enabledSettings[setting]) {
      delete sanitizedSettings[setting];
    }
  });
  return sanitizedSettings;
}
function useLazyEffect(effect, deps) {
  const readyRef = React__default.useRef(false);
  React__default.useEffect(() => {
    if (readyRef.current) {
      return effect();
    } else {
      readyRef.current = true;
    }
  }, deps);
  React__default.useEffect(
    () => () => {
      readyRef.current = false;
    },
    []
  );
}
function useTableDataListener(table, length) {
  const meta = table.options.meta;
  useLazyEffect(() => {
    const rowActiveIndex = meta.rowActive.rowActiveIndex;
    if (rowActiveIndex !== void 0 && rowActiveIndex > length) {
      meta.rowActive.setRowActiveIndex(0);
    }
  }, [length]);
}
function useTableFilterListener(table, onFilter) {
  const columnFilters = table.getState().columnFilters;
  useLazyEffect(() => {
    if (table.options.enableColumnFilters && typeof onFilter === "function") {
      const hiddenColumns = getHiddenColumns(table.getState().columnVisibility);
      onFilter(columnFilters, hiddenColumns);
      if (table.options.enableRowSelection) {
        table.resetRowSelection();
      }
    }
  }, [table.options.enableColumnFilters, columnFilters]);
}
function useTableFontSizeListener(table) {
  const meta = table.options.meta;
  const previousFontSizeRef = React__default.useRef(meta.fontSize.size);
  useLazyEffect(() => {
    const cellWidthDifference = getCellWidthDifference(`${previousFontSizeRef.current}-${meta.fontSize.size}`);
    const globalMinSize = getCellMinWidth(meta.fontSize.size);
    table.setColumnSizing((sizes) => {
      return Object.fromEntries(
        Object.entries(sizes).map(([columnName, prevColumnSize]) => {
          const column = table.getAllColumns().find((x3) => x3.id === columnName);
          if (isInternalColumn(columnName)) {
            return [columnName, (column == null ? void 0 : column.getSize()) ?? prevColumnSize];
          }
          const minColumnSize = (column == null ? void 0 : column.columnDef.minSize) ?? globalMinSize;
          const newSize = Math.max(minColumnSize, prevColumnSize + cellWidthDifference);
          return [columnName, newSize];
        })
      );
    });
    previousFontSizeRef.current = meta.fontSize.size;
  }, [meta.fontSize.size]);
}
function getCellWidthDifference(fontSizeKey) {
  switch (fontSizeKey) {
    case `${FontSizes.small}-${FontSizes.medium}`:
    case `${FontSizes.medium}-${FontSizes.large}`:
      return 8;
    case `${FontSizes.medium}-${FontSizes.small}`:
    case `${FontSizes.large}-${FontSizes.medium}`:
      return -8;
    case `${FontSizes.small}-${FontSizes.large}`:
      return 16;
    case `${FontSizes.large}-${FontSizes.small}`:
      return -16;
    default:
      return 0;
  }
}
function useTableRowHeightListener(table) {
  const meta = table.options.meta;
  useLazyEffect(() => {
    if (meta.rowHeight.height === "short" && meta.fontSize.size === FontSizes.large) {
      meta.fontSize.setSize(FontSizes.medium);
    }
  }, [meta.rowHeight.height]);
}
function useTableRowSelectionListener(table, onRowSelect) {
  const rows = table.getSelectedRowModel().flatRows;
  const state = table.getState().rowSelection;
  useLazyEffect(() => {
    if (table.options.enableRowSelection && typeof onRowSelect === "function") {
      onRowSelect(
        rows.map((row) => row.original),
        Object.keys(state)
      );
    }
  }, [!!table.options.enableRowSelection, JSON.stringify(state)]);
}
function useTableSearchListener(table) {
  const meta = table.options.meta;
  const localization = useLocalization();
  const hiddenColumns = getHiddenColumns(table.getState().columnVisibility);
  const query = table.getState().globalFilter;
  useLazyEffect(() => {
    if (meta.search.isEnabled) {
      const currentFilter = query;
      requestAnimationFrame(() => {
        table.resetGlobalFilter();
        table.setGlobalFilter(currentFilter);
      });
      if (meta.search.handleSearch && meta.search.enableGlobalFilter && query) {
        meta.search.handleSearch(query, hiddenColumns);
      }
    }
  }, [hiddenColumns.length]);
  useLazyEffect(() => {
    if (meta.search.isEnabled) {
      resetHighlightedColumnIndexes(query, table, localization);
    }
  }, [
    meta.server.loading,
    meta.search.isEnabled,
    meta.search.enableGlobalFilter,
    table.getRowModel().rows.length,
    query,
    JSON.stringify(table.getState().sorting)
  ]);
}
function useTableSettingsListener(table, onChangeSettings) {
  const meta = table.options.meta;
  const state = table.getState();
  React__default.useEffect(() => {
    let handler;
    if (typeof onChangeSettings === "function") {
      handler = setTimeout(() => {
        onChangeSettings(getSettings(table));
      }, 250);
    }
    return () => clearTimeout(handler);
  }, [
    //state.columnFilters,
    state.columnOrder,
    state.columnPinning,
    state.columnSizing,
    state.columnVisibility,
    table.options.enableGlobalFilter,
    meta.fontSize.size,
    //state.grouping,
    meta.rowHeight.height,
    //state.globalFilter,
    state.sorting
  ]);
}
function useTableShortcutsListener(table, tableRef, shortcuts, localShortcuts = false) {
  const meta = table.options.meta;
  const rows = table.getRowModel().rows;
  const listenerTarget = localShortcuts ? tableRef.current : document;
  React__default.useEffect(() => {
    const shortcutKeys = Object.keys(shortcuts ?? {});
    const globalHandlers = [];
    if (shortcuts && shortcutKeys.length && meta.rowActive.rowActiveIndex !== void 0) {
      const rowActive = rows[meta.rowActive.rowActiveIndex];
      shortcutKeys.forEach((key) => {
        const handler = shortcuts[key];
        let keyDownHandler;
        let keyDownHandlerOptions;
        if (typeof handler === "function") {
          keyDownHandler = handler;
          keyDownHandlerOptions = {
            key
          };
        } else {
          const handlerObject = handler;
          keyDownHandler = handlerObject.handler;
          keyDownHandlerOptions = {
            key,
            meta: handlerObject.meta,
            shift: handlerObject.shift
          };
        }
        globalHandlers.push(
          createShortcutKeyDownHandler(keyDownHandlerOptions, (event) => {
            event.preventDefault();
            keyDownHandler(rowActive == null ? void 0 : rowActive.original);
          })
        );
      });
    }
    globalHandlers.forEach((handler) => {
      listenerTarget == null ? void 0 : listenerTarget.addEventListener("keydown", handler);
    });
    return () => {
      globalHandlers.forEach((handler) => {
        listenerTarget == null ? void 0 : listenerTarget.removeEventListener("keydown", handler);
      });
    };
  }, [shortcuts, meta.rowActive.rowActiveIndex, rows.length]);
}
function useLazyDebouncedEffect(effect, deps, ms = 200) {
  const readyRef = React__default.useRef(false);
  const timeoutRef = React__default.useRef();
  React__default.useEffect(() => {
    if (readyRef.current) {
      timeoutRef.current = setTimeout(effect, ms);
    } else {
      readyRef.current = true;
    }
    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, deps);
  React__default.useEffect(
    () => () => {
      readyRef.current = false;
    },
    []
  );
}
function useTableSortingListener$1(table, onSort) {
  const sorting = table.getState().sorting;
  useLazyDebouncedEffect(() => {
    if (table.options.enableSorting && typeof onSort === "function") {
      onSort(sorting);
      if (table.options.enableRowSelection) {
        table.resetRowSelection();
      }
    }
  }, [table.options.enableSorting, sorting]);
}
function useTableServerLoadingListener(table, loadPage) {
  const meta = table.options.meta;
  React__default.useEffect(() => {
    if (loadPage) {
      const sorting = table.getState().sorting;
      const columnFilters = table.getState().columnFilters;
      const hiddenColumns = getHiddenColumns(table.getState().columnVisibility);
      const search = meta.search.enableGlobalFilter ? table.getState().globalFilter : void 0;
      loadPage(0, sorting, columnFilters, hiddenColumns, search);
      if (meta.server._experimentalDataLoader2) {
        loadPage(1, sorting, columnFilters, hiddenColumns, search);
      }
    }
  }, []);
}
function useTableRowDrag(isEnabled = false, onRowDrag) {
  const [dragging, setDragging] = React__default.useState({});
  return {
    isEnabled,
    dragging,
    setDragging: isEnabled ? setDragging : void 0,
    handleRowDrag: isEnabled ? onRowDrag : void 0
  };
}
function useTableRowDrop(isEnabled = false, onRowDrop) {
  return {
    isEnabled,
    handleDrop: isEnabled ? onRowDrop : void 0
  };
}
const DEFAULT_EMPTY_ARRAY = [];
function useTableManager(props, ref, meta, internalColumns) {
  var _a;
  const localization = useLocalization();
  const safeId = props.id.replace(".", "_");
  const options = getTableFeaturePreset(props);
  const [settings, setSettings] = useTableSettings(
    options.enableSaveSettings,
    safeId,
    props.defaultSettings,
    props.onChangeSettings
  );
  const data = props.data ?? DEFAULT_EMPTY_ARRAY;
  const length = props.length ?? data.length;
  const columnFreezing = useTableColumnFreezing(options.enableColumnFreezing);
  const columnOrdering = useTableColumnOrdering(options.enableColumnOrdering);
  const fontSize = useTableFontSize(options.enableFontSize, settings.fontSize);
  const footer = useTableFooter(options.enableFooter);
  const printing = useTablePrinting(options.enablePrinting, safeId);
  const rowActive = useTableRowActive$1(options.enableRowActive, props.defaultRowActiveIndex);
  const rowActions = useTableRowActions(options.enableRowActions, props.rowActions, props.rowActionsLength);
  const rowClick = useTableRowClick(options.enableRowClick, props.onRowClick);
  const rowDrag = useTableRowDrag(options.enableRowDrag && !((_a = meta == null ? void 0 : meta.editing) == null ? void 0 : _a.isEditing), props.onRowDrag);
  const rowDrop = useTableRowDrop(options.enableRowDrop, props.onRowDrop);
  const rowExpansion = useTableRowExpansion(
    options.enableRowExpansion,
    options.enableRowExpansionAll,
    props.rowExpansionRenderer
  );
  const rowGoto = useTableRowGoto(options.enableRowGoto, props.onRowGoto);
  const rowGroups = useTableRowGroups(props.rowActionsForGroup);
  const rowHeight = useTableRowHeight(options.enableRowHeight, settings.rowHeight);
  const rowSelection = useTableRowSelection(!!options.enableRowSelection);
  const search = useTableSearch(options.enableSearch, props.onChangeSearch, settings.excludeUnmatchedRecordsInSearch);
  const server = useTableServerLoading(
    length,
    data,
    props.loadPage,
    props.loadAll,
    props.pages,
    props.pageSize,
    props._experimentalDataLoader2
  );
  const { columns, ...defaultState2 } = mapTableChildrenToColumns(
    props,
    settings,
    options,
    internalColumns,
    localization
  );
  const initialState = useReactTableInitialState(props, columns, settings, defaultState2);
  const instance = useReactTable({
    data,
    columns,
    // configure initial table state
    initialState,
    getCoreRowModel: getCoreRowModel(),
    // configure react-table built-in features
    ...configureReactTableOptions(options, props, localization),
    // settings that can be toggled by the user, and therefore require our own state
    enableGlobalFilter: search.enableGlobalFilter,
    // custom context
    meta: {
      // spread features from specific implementations
      ...meta,
      columnFreezing,
      columnOrdering,
      fontSize,
      footer,
      length,
      onEvent: props.onEvent,
      printing,
      rowActions,
      // no other way around ReturnType<typeof X> not supporting generics
      rowActive,
      rowClick,
      // no other way around ReturnType<typeof X> not supporting generics
      rowDrag,
      rowDrop,
      // no other way around ReturnType<typeof X> not supporting generics
      rowExpansion,
      // no other way around ReturnType<typeof X> not supporting generics
      rowIdentityAccessor: props.rowIdentityAccessor,
      rowGoto,
      rowGroups,
      // no other way around ReturnType<typeof X> not supporting generics
      rowHeight,
      rowSelection,
      search,
      server
    }
  });
  useTableDataListener(instance, length);
  useTableFilterListener(instance, props.onChangeFilter);
  useTableFontSizeListener(instance);
  useTableRowHeightListener(instance);
  useTableRowSelectionListener(instance, props.onRowSelect);
  useTableSearchListener(instance);
  useTableServerLoadingListener(instance, server.loadPage);
  useTableSettingsListener(instance, setSettings);
  useTableShortcutsListener(instance, ref, props.shortcuts, props.enableLocalKeyboardShortcuts);
  useTableSortingListener$1(instance, props.onChangeSort);
  return {
    id: safeId,
    instance,
    meta: instance.options.meta ?? {},
    state: instance.getState()
  };
}
function useTableStyleGrid(tableId, table, fontSize) {
  const tableMeta = table.options.meta;
  const allVisibleColumns = table.getVisibleLeafColumns();
  const columnSizing = table.getState().columnSizing;
  const globalMinSize = getCellMinWidth(fontSize);
  const gridTemplateRows = table.getRowModel().rows.length ? "min-content 1fr min-content" : "min-content 1fr";
  return React__default.useMemo(() => {
    let printGridTemplateColumns = 0;
    const printHiddenColumns = [];
    const gridTemplateColumns = allVisibleColumns.reduce((accum, column, index2) => {
      var _a;
      if (table.options.enableGrouping && column.getIsGrouped()) {
        return accum;
      }
      const minSize = column.columnDef.minSize ?? globalMinSize;
      const width = columnSizing[column.id];
      let size2;
      if (isInternalColumn(column.id)) {
        if (column.id === "__actions") {
          const minWidth = tableMeta.rowActions.rowActionsLength * 32 + 8;
          size2 = `minmax(${minWidth}px, auto)`;
        } else {
          size2 = `${column.getSize()}px`;
        }
      } else if (width !== void 0) {
        const isLastColumn = index2 === allVisibleColumns.length - 1;
        if (width === "grow" || Number.isNaN(width) && !isLastColumn) {
          size2 = `minmax(max-content, 1fr)`;
        } else {
          const minWidth = width < minSize ? minSize : width;
          if (isLastColumn) {
            size2 = `minmax(${minWidth}px, auto)`;
          } else {
            size2 = `${minWidth}px`;
          }
        }
      } else {
        size2 = `minmax(max-content, auto)`;
      }
      if (((_a = column.columnDef.meta) == null ? void 0 : _a.enablePrinting) === false) {
        printHiddenColumns.push(column.id);
      } else {
        printGridTemplateColumns++;
      }
      return `${accum} ${size2}`.trim();
    }, "");
    const style = {
      gridTemplateColumns,
      gridTemplateRows
    };
    const hiddenColumns = printHiddenColumns.map(
      (id2) => `table[data-taco^='table']#${tableId} > thead > tr > th[data-cell-id='${id2}']
,table[data-taco^='table']#${tableId} tr > td[data-cell-id='${id2}']
`
    ).join(",");
    const stylesheet = `@media print { table[data-taco^='table']#${tableId} { grid-template-columns: repeat(${printGridTemplateColumns}, auto) !important; }
        table[data-taco^='table']#${tableId} [data-cell-id^='__']${hiddenColumns ? `, ${hiddenColumns}` : ""} { display: none; } table[data-taco^='table']#${tableId} tr { page-break-inside: avoid; break-inside: avoid;}}`;
    return { style, stylesheet };
  }, [allVisibleColumns, columnSizing, globalMinSize, tableMeta.rowActions.rowActionsLength]);
}
function useTableStyleColumnFreezing(tableId, table) {
  const { columnPinning, columnSizing } = table.getState();
  const stylesheet = React__default.useMemo(() => {
    const styles = [];
    const all = table.getFlatHeaders().filter((column) => !column.subHeaders.length).map((x3) => x3.id);
    const left = table.getLeftFlatHeaders().filter((column) => !column.subHeaders.length);
    const right = table.getRightFlatHeaders().filter((column) => !column.subHeaders.length);
    if (left.length) {
      left.forEach((cell) => {
        styles.push(`table[data-taco^='table']#${tableId} [data-cell-id="${cell.column.id}"] {
                    left: ${cell.column.getStart(cell.column.getIsPinned())}px;
                }`);
      });
      const leftIds = left.map((x3) => x3.id);
      const index2 = all.indexOf(leftIds[leftIds.length - 1]);
      styles.push(`table[data-taco^='table']#${tableId} > thead > tr > th:nth-child(${index2 + 1}),
                table[data-taco^='table']#${tableId} > tbody > tr  > td:nth-child(${index2 + 1}),
                table[data-taco^='table']#${tableId} > tfoot > tr  > td:nth-child(${index2 + 1}):not([data-cell-id^="__"]) {
                    border-right-width: 1px;
                }
table[data-taco^='table']#${tableId} > thead > tr  > th:nth-child(${index2 + 1})[data-cell-id^="__"],
                table[data-taco^='table']#${tableId} > tbody > tr  > td:nth-child(${index2 + 1})[data-cell-id^="__"] {
                    border-right-color: transparent;
                }
table[data-taco^='table']#${tableId} > thead > tr  > th:nth-child(${index2 + 1}):after {
                    content: none;
                }
table[data-taco^='table'][data-table-horizontally-scrolled="true"]#${tableId} > thead > tr  > th:nth-child(${index2 + 1}),
                table[data-taco^='table'][data-table-horizontally-scrolled="true"]#${tableId} > tbody > tr  > td:nth-child(${index2 + 1}),
                table[data-taco^='table'][data-table-horizontally-scrolled="true"]#${tableId} > tfoot > tr  > td:nth-child(${index2 + 1}) {
                    border-right-color: rgb(221, 221, 221);
                    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), 6px 0px 6px rgb(0 0 0/8%);
                }`);
    }
    if (right.length) {
      right.forEach((cell) => {
        styles.push(`table[data-taco^='table']#${tableId} [data-cell-id="${cell.column.id}"] {
                    right: ${cell.column.getStart(cell.column.getIsPinned())}px;
                }`);
      });
      const rightIds = right.map((x3) => x3.id);
      const index2 = all.indexOf(rightIds[rightIds.length - 1]);
      styles.push(`table[data-taco^='table']#${tableId} > thead > tr > th:nth-child(${index2 + 1}):not([data-cell-id^="__"]),
                table[data-taco^='table']#${tableId} > tbody > tr > td:nth-child(${index2 + 1}):not([data-cell-id^="__"]) {
                    border-left-width: 1px;
                }`);
    }
    return styles.join("\n");
  }, [columnPinning, columnSizing]);
  return { stylesheet };
}
function useTableStyle(tableId, table) {
  const tableMeta = table.options.meta;
  const { style: cssGridStyle, stylesheet: cssGridStylesheet } = useTableStyleGrid(
    tableId,
    table,
    tableMeta.fontSize.size
  );
  const { stylesheet: columnFreezingStylesheet } = useTableStyleColumnFreezing(tableId, table);
  const style = {
    // css vars required by children of table
    "--table-header-group-depth": table.getHeaderGroups().length,
    "--table-cell-padding-x": getCellWidthPadding(tableMeta.fontSize.size),
    "--table-cell-padding-y": getCellHeightPadding(tableMeta.rowHeight.height, tableMeta.fontSize.size),
    ...cssGridStyle
  };
  const stylesheet = [cssGridStylesheet, columnFreezingStylesheet].filter((s4) => !!s4).join("\n");
  return { style, stylesheet };
}
function getCellHeightPadding(height, fontSize) {
  switch (height) {
    case "short": {
      switch (fontSize) {
        case "small":
          return "8px";
        default:
          return "6px";
      }
    }
    case "tall": {
      switch (fontSize) {
        case "small":
          return "16px";
        case "large":
          return "12px";
        default:
          return "14px";
      }
    }
    case "extra-tall": {
      switch (fontSize) {
        case "small":
          return "22px";
        case "large":
          return "18px";
        default:
          return "20px";
      }
    }
    default: {
      switch (fontSize) {
        case "small":
          return "12px";
        case "large":
          return "8px";
        default:
          return "10px";
      }
    }
  }
}
function getCellWidthPadding(fontSize) {
  switch (fontSize) {
    case "small":
      return "8px";
    case "medium":
      return "12px";
    default:
      return "16px";
  }
}
function useTableGlobalShortcuts(table, tableRef, scrollToIndex, localShortcuts = false) {
  const tableMeta = table.options.meta;
  const rows = table.getRowModel().rows;
  const listenerTarget = localShortcuts ? tableRef.current : document;
  React__default.useEffect(
    () => {
      const handleKeyDown = (event) => {
        var _a;
        const trigger = event.target;
        if (isElementInsideOverlay(trigger) && !isSiblingElementInsideSameParentOverlay(trigger, tableRef.current) || isElementInteractive(trigger) && !isElementInsideOrTriggeredFromContainer(trigger, tableRef.current)) {
          return;
        }
        tableMeta.rowActive.handleKeyDown(event, tableMeta.length, scrollToIndex);
        tableMeta.rowSelection.handleKeyDown(event, table);
        if (tableMeta.rowActive.rowActiveIndex !== void 0) {
          tableMeta.rowClick.handleKeyDown(event, (_a = rows[tableMeta.rowActive.rowActiveIndex]) == null ? void 0 : _a.original);
        }
      };
      listenerTarget == null ? void 0 : listenerTarget.addEventListener("keydown", handleKeyDown);
      return () => {
        listenerTarget == null ? void 0 : listenerTarget.removeEventListener("keydown", handleKeyDown);
      };
    },
    // scrollToIndex function changes when row count changes, so it is important to update handlers
    [tableRef.current, tableMeta.length, tableMeta.rowActive.rowActiveIndex, scrollToIndex]
  );
}
function useTableRef(table, ref) {
  React__default.useEffect(() => {
    if (ref.current) {
      ref.current.instance = {
        resetFiltering: () => table.resetColumnFilters(),
        resetRowExpansion: () => table.resetExpanded(),
        resetRowSelection: () => table.resetRowSelection(),
        resetSorting: () => table.resetSorting()
      };
    }
  }, [table, ref.current]);
}
/**
 * react-virtual
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function _extends$y() {
  _extends$y = Object.assign ? Object.assign.bind() : function(target) {
    for (var i3 = 1; i3 < arguments.length; i3++) {
      var source = arguments[i3];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$y.apply(this, arguments);
}
/**
 * virtual-core
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function _extends$x() {
  _extends$x = Object.assign ? Object.assign.bind() : function(target) {
    for (var i3 = 1; i3 < arguments.length; i3++) {
      var source = arguments[i3];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$x.apply(this, arguments);
}
/**
 * virtual-core
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function memo(getDeps, fn, opts) {
  var _opts$initialDeps;
  var deps = (_opts$initialDeps = opts.initialDeps) != null ? _opts$initialDeps : [];
  var result;
  return function() {
    var depTime;
    if (opts.key && opts.debug != null && opts.debug()) depTime = Date.now();
    var newDeps = getDeps();
    var depsChanged = newDeps.length !== deps.length || newDeps.some(function(dep, index2) {
      return deps[index2] !== dep;
    });
    if (!depsChanged) {
      return result;
    }
    deps = newDeps;
    var resultTime;
    if (opts.key && opts.debug != null && opts.debug()) resultTime = Date.now();
    result = fn.apply(void 0, newDeps);
    if (opts.key && opts.debug != null && opts.debug()) {
      var depEndTime = Math.round((Date.now() - depTime) * 100) / 100;
      var resultEndTime = Math.round((Date.now() - resultTime) * 100) / 100;
      var resultFpsPercentage = resultEndTime / 16;
      var pad2 = function pad3(str, num) {
        str = String(str);
        while (str.length < num) {
          str = " " + str;
        }
        return str;
      };
      console.info("%c⏱ " + pad2(resultEndTime, 5) + " /" + pad2(depEndTime, 5) + " ms", "\n            font-size: .6rem;\n            font-weight: bold;\n            color: hsl(" + Math.max(0, Math.min(120 - 120 * resultFpsPercentage, 120)) + "deg 100% 31%);", opts == null ? void 0 : opts.key);
    }
    opts == null || opts.onChange == null || opts.onChange(result);
    return result;
  };
}
function notUndefined(value, msg) {
  if (value === void 0) {
    throw new Error("Unexpected undefined");
  } else {
    return value;
  }
}
var approxEqual = function approxEqual2(a4, b3) {
  return Math.abs(a4 - b3) < 1;
};
/**
 * virtual-core
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
var defaultKeyExtractor = function defaultKeyExtractor2(index2) {
  return index2;
};
var defaultRangeExtractor = function defaultRangeExtractor2(range3) {
  var start = Math.max(range3.startIndex - range3.overscan, 0);
  var end = Math.min(range3.endIndex + range3.overscan, range3.count - 1);
  var arr = [];
  for (var _i = start; _i <= end; _i++) {
    arr.push(_i);
  }
  return arr;
};
var observeElementRect = function observeElementRect2(instance, cb2) {
  var element = instance.scrollElement;
  if (!element) {
    return;
  }
  var handler = function handler2(rect) {
    var width = rect.width, height = rect.height;
    cb2({
      width: Math.round(width),
      height: Math.round(height)
    });
  };
  handler(element.getBoundingClientRect());
  var observer = new ResizeObserver(function(entries) {
    var entry = entries[0];
    if (entry != null && entry.borderBoxSize) {
      var box = entry.borderBoxSize[0];
      if (box) {
        handler({
          width: box.inlineSize,
          height: box.blockSize
        });
        return;
      }
    }
    handler(element.getBoundingClientRect());
  });
  observer.observe(element, {
    box: "border-box"
  });
  return function() {
    observer.unobserve(element);
  };
};
var observeElementOffset = function observeElementOffset2(instance, cb2) {
  var element = instance.scrollElement;
  if (!element) {
    return;
  }
  var handler = function handler2() {
    cb2(element[instance.options.horizontal ? "scrollLeft" : "scrollTop"]);
  };
  handler();
  element.addEventListener("scroll", handler, {
    passive: true
  });
  return function() {
    element.removeEventListener("scroll", handler);
  };
};
var measureElement = function measureElement2(element, entry, instance) {
  if (entry != null && entry.borderBoxSize) {
    var box = entry.borderBoxSize[0];
    if (box) {
      var size2 = Math.round(box[instance.options.horizontal ? "inlineSize" : "blockSize"]);
      return size2;
    }
  }
  return Math.round(element.getBoundingClientRect()[instance.options.horizontal ? "width" : "height"]);
};
var elementScroll = function elementScroll2(offset2, _ref2, instance) {
  var _instance$scrollEleme3, _instance$scrollEleme4;
  var _ref2$adjustments = _ref2.adjustments, adjustments = _ref2$adjustments === void 0 ? 0 : _ref2$adjustments, behavior = _ref2.behavior;
  var toOffset = offset2 + adjustments;
  (_instance$scrollEleme3 = instance.scrollElement) == null || _instance$scrollEleme3.scrollTo == null || _instance$scrollEleme3.scrollTo((_instance$scrollEleme4 = {}, _instance$scrollEleme4[instance.options.horizontal ? "left" : "top"] = toOffset, _instance$scrollEleme4.behavior = behavior, _instance$scrollEleme4));
};
var Virtualizer = function Virtualizer2(_opts) {
  var _this = this;
  this.unsubs = [];
  this.scrollElement = null;
  this.isScrolling = false;
  this.isScrollingTimeoutId = null;
  this.scrollToIndexTimeoutId = null;
  this.measurementsCache = [];
  this.itemSizeCache = /* @__PURE__ */ new Map();
  this.pendingMeasuredCacheIndexes = [];
  this.scrollDirection = null;
  this.scrollAdjustments = 0;
  this.measureElementCache = /* @__PURE__ */ new Map();
  this.observer = /* @__PURE__ */ function() {
    var _ro = null;
    var get2 = function get3() {
      if (_ro) {
        return _ro;
      } else if (typeof ResizeObserver !== "undefined") {
        return _ro = new ResizeObserver(function(entries) {
          entries.forEach(function(entry) {
            _this._measureElement(entry.target, entry);
          });
        });
      } else {
        return null;
      }
    };
    return {
      disconnect: function disconnect() {
        var _get;
        return (_get = get2()) == null ? void 0 : _get.disconnect();
      },
      observe: function observe2(target) {
        var _get2;
        return (_get2 = get2()) == null ? void 0 : _get2.observe(target, {
          box: "border-box"
        });
      },
      unobserve: function unobserve(target) {
        var _get3;
        return (_get3 = get2()) == null ? void 0 : _get3.unobserve(target);
      }
    };
  }();
  this.range = null;
  this.setOptions = function(opts) {
    Object.entries(opts).forEach(function(_ref3) {
      var key = _ref3[0], value = _ref3[1];
      if (typeof value === "undefined") delete opts[key];
    });
    _this.options = _extends$x({
      debug: false,
      initialOffset: 0,
      overscan: 1,
      paddingStart: 0,
      paddingEnd: 0,
      scrollPaddingStart: 0,
      scrollPaddingEnd: 0,
      horizontal: false,
      getItemKey: defaultKeyExtractor,
      rangeExtractor: defaultRangeExtractor,
      onChange: function onChange() {
      },
      measureElement,
      initialRect: {
        width: 0,
        height: 0
      },
      scrollMargin: 0,
      scrollingDelay: 150,
      indexAttribute: "data-index",
      initialMeasurementsCache: [],
      lanes: 1
    }, opts);
  };
  this.notify = function(sync2) {
    _this.options.onChange == null || _this.options.onChange(_this, sync2);
  };
  this.maybeNotify = memo(function() {
    _this.calculateRange();
    return [_this.isScrolling, _this.range ? _this.range.startIndex : null, _this.range ? _this.range.endIndex : null];
  }, function(isScrolling) {
    _this.notify(isScrolling);
  }, {
    key: process.env.NODE_ENV !== "production" && "maybeNotify",
    debug: function debug2() {
      return _this.options.debug;
    },
    initialDeps: [this.isScrolling, this.range ? this.range.startIndex : null, this.range ? this.range.endIndex : null]
  });
  this.cleanup = function() {
    _this.unsubs.filter(Boolean).forEach(function(d4) {
      return d4();
    });
    _this.unsubs = [];
    _this.scrollElement = null;
  };
  this._didMount = function() {
    _this.measureElementCache.forEach(_this.observer.observe);
    return function() {
      _this.observer.disconnect();
      _this.cleanup();
    };
  };
  this._willUpdate = function() {
    var scrollElement = _this.options.getScrollElement();
    if (_this.scrollElement !== scrollElement) {
      _this.cleanup();
      _this.scrollElement = scrollElement;
      _this._scrollToOffset(_this.scrollOffset, {
        adjustments: void 0,
        behavior: void 0
      });
      _this.unsubs.push(_this.options.observeElementRect(_this, function(rect) {
        _this.scrollRect = rect;
        _this.maybeNotify();
      }));
      _this.unsubs.push(_this.options.observeElementOffset(_this, function(offset2) {
        _this.scrollAdjustments = 0;
        if (_this.scrollOffset === offset2) {
          return;
        }
        if (_this.isScrollingTimeoutId !== null) {
          clearTimeout(_this.isScrollingTimeoutId);
          _this.isScrollingTimeoutId = null;
        }
        _this.isScrolling = true;
        _this.scrollDirection = _this.scrollOffset < offset2 ? "forward" : "backward";
        _this.scrollOffset = offset2;
        _this.maybeNotify();
        _this.isScrollingTimeoutId = setTimeout(function() {
          _this.isScrollingTimeoutId = null;
          _this.isScrolling = false;
          _this.scrollDirection = null;
          _this.maybeNotify();
        }, _this.options.scrollingDelay);
      }));
    }
  };
  this.getSize = function() {
    return _this.scrollRect[_this.options.horizontal ? "width" : "height"];
  };
  this.memoOptions = memo(function() {
    return [_this.options.count, _this.options.paddingStart, _this.options.scrollMargin, _this.options.getItemKey];
  }, function(count2, paddingStart, scrollMargin, getItemKey) {
    _this.pendingMeasuredCacheIndexes = [];
    return {
      count: count2,
      paddingStart,
      scrollMargin,
      getItemKey
    };
  }, {
    key: false
  });
  this.getFurthestMeasurement = function(measurements, index2) {
    var furthestMeasurementsFound = /* @__PURE__ */ new Map();
    var furthestMeasurements = /* @__PURE__ */ new Map();
    for (var m4 = index2 - 1; m4 >= 0; m4--) {
      var measurement = measurements[m4];
      if (furthestMeasurementsFound.has(measurement.lane)) {
        continue;
      }
      var previousFurthestMeasurement = furthestMeasurements.get(measurement.lane);
      if (previousFurthestMeasurement == null || measurement.end > previousFurthestMeasurement.end) {
        furthestMeasurements.set(measurement.lane, measurement);
      } else if (measurement.end < previousFurthestMeasurement.end) {
        furthestMeasurementsFound.set(measurement.lane, true);
      }
      if (furthestMeasurementsFound.size === _this.options.lanes) {
        break;
      }
    }
    return furthestMeasurements.size === _this.options.lanes ? Array.from(furthestMeasurements.values()).sort(function(a4, b3) {
      return a4.end - b3.end;
    })[0] : void 0;
  };
  this.getMeasurements = memo(function() {
    return [_this.memoOptions(), _this.itemSizeCache];
  }, function(_ref4, itemSizeCache) {
    var count2 = _ref4.count, paddingStart = _ref4.paddingStart, scrollMargin = _ref4.scrollMargin, getItemKey = _ref4.getItemKey;
    var min2 = _this.pendingMeasuredCacheIndexes.length > 0 ? Math.min.apply(Math, _this.pendingMeasuredCacheIndexes) : 0;
    _this.pendingMeasuredCacheIndexes = [];
    var measurements = _this.measurementsCache.slice(0, min2);
    for (var _i2 = min2; _i2 < count2; _i2++) {
      var key = getItemKey(_i2);
      var furthestMeasurement = _this.options.lanes === 1 ? measurements[_i2 - 1] : _this.getFurthestMeasurement(measurements, _i2);
      var start = furthestMeasurement ? furthestMeasurement.end : paddingStart + scrollMargin;
      var measuredSize = itemSizeCache.get(key);
      var size2 = typeof measuredSize === "number" ? measuredSize : _this.options.estimateSize(_i2);
      var end = start + size2;
      var lane = furthestMeasurement ? furthestMeasurement.lane : _i2 % _this.options.lanes;
      measurements[_i2] = {
        index: _i2,
        start,
        size: size2,
        end,
        key,
        lane
      };
    }
    _this.measurementsCache = measurements;
    return measurements;
  }, {
    key: process.env.NODE_ENV !== "production" && "getMeasurements",
    debug: function debug2() {
      return _this.options.debug;
    }
  });
  this.calculateRange = memo(function() {
    return [_this.getMeasurements(), _this.getSize(), _this.scrollOffset];
  }, function(measurements, outerSize, scrollOffset) {
    return _this.range = measurements.length > 0 && outerSize > 0 ? calculateRange({
      measurements,
      outerSize,
      scrollOffset
    }) : null;
  }, {
    key: process.env.NODE_ENV !== "production" && "calculateRange",
    debug: function debug2() {
      return _this.options.debug;
    }
  });
  this.getIndexes = memo(function() {
    return [_this.options.rangeExtractor, _this.calculateRange(), _this.options.overscan, _this.options.count];
  }, function(rangeExtractor, range3, overscan, count2) {
    return range3 === null ? [] : rangeExtractor(_extends$x({}, range3, {
      overscan,
      count: count2
    }));
  }, {
    key: process.env.NODE_ENV !== "production" && "getIndexes",
    debug: function debug2() {
      return _this.options.debug;
    }
  });
  this.indexFromElement = function(node) {
    var attributeName = _this.options.indexAttribute;
    var indexStr = node.getAttribute(attributeName);
    if (!indexStr) {
      console.warn("Missing attribute name '" + attributeName + "={index}' on measured element.");
      return -1;
    }
    return parseInt(indexStr, 10);
  };
  this._measureElement = function(node, entry) {
    var item = _this.measurementsCache[_this.indexFromElement(node)];
    if (!item || !node.isConnected) {
      _this.measureElementCache.forEach(function(cached, key) {
        if (cached === node) {
          _this.observer.unobserve(node);
          _this.measureElementCache["delete"](key);
        }
      });
      return;
    }
    var prevNode = _this.measureElementCache.get(item.key);
    if (prevNode !== node) {
      if (prevNode) {
        _this.observer.unobserve(prevNode);
      }
      _this.observer.observe(node);
      _this.measureElementCache.set(item.key, node);
    }
    var measuredItemSize = _this.options.measureElement(node, entry, _this);
    _this.resizeItem(item, measuredItemSize);
  };
  this.resizeItem = function(item, size2) {
    var _this$itemSizeCache$g;
    var itemSize = (_this$itemSizeCache$g = _this.itemSizeCache.get(item.key)) != null ? _this$itemSizeCache$g : item.size;
    var delta = size2 - itemSize;
    if (delta !== 0) {
      if (item.start < _this.scrollOffset) {
        if (process.env.NODE_ENV !== "production" && _this.options.debug) {
          console.info("correction", delta);
        }
        _this._scrollToOffset(_this.scrollOffset, {
          adjustments: _this.scrollAdjustments += delta,
          behavior: void 0
        });
      }
      _this.pendingMeasuredCacheIndexes.push(item.index);
      _this.itemSizeCache = new Map(_this.itemSizeCache.set(item.key, size2));
      _this.notify(false);
    }
  };
  this.measureElement = function(node) {
    if (!node) {
      return;
    }
    _this._measureElement(node, void 0);
  };
  this.getVirtualItems = memo(function() {
    return [_this.getIndexes(), _this.getMeasurements()];
  }, function(indexes, measurements) {
    var virtualItems = [];
    for (var k3 = 0, len = indexes.length; k3 < len; k3++) {
      var _i3 = indexes[k3];
      var measurement = measurements[_i3];
      virtualItems.push(measurement);
    }
    return virtualItems;
  }, {
    key: process.env.NODE_ENV !== "production" && "getIndexes",
    debug: function debug2() {
      return _this.options.debug;
    }
  });
  this.getVirtualItemForOffset = function(offset2) {
    var measurements = _this.getMeasurements();
    return notUndefined(measurements[findNearestBinarySearch(0, measurements.length - 1, function(index2) {
      return notUndefined(measurements[index2]).start;
    }, offset2)]);
  };
  this.getOffsetForAlignment = function(toOffset, align) {
    var size2 = _this.getSize();
    if (align === "auto") {
      if (toOffset <= _this.scrollOffset) {
        align = "start";
      } else if (toOffset >= _this.scrollOffset + size2) {
        align = "end";
      } else {
        align = "start";
      }
    }
    if (align === "start") {
      toOffset = toOffset;
    } else if (align === "end") {
      toOffset = toOffset - size2;
    } else if (align === "center") {
      toOffset = toOffset - size2 / 2;
    }
    var scrollSizeProp = _this.options.horizontal ? "scrollWidth" : "scrollHeight";
    var scrollSize = _this.scrollElement ? "document" in _this.scrollElement ? _this.scrollElement.document.documentElement[scrollSizeProp] : _this.scrollElement[scrollSizeProp] : 0;
    var maxOffset = scrollSize - _this.getSize();
    return Math.max(Math.min(maxOffset, toOffset), 0);
  };
  this.getOffsetForIndex = function(index2, align) {
    if (align === void 0) {
      align = "auto";
    }
    index2 = Math.max(0, Math.min(index2, _this.options.count - 1));
    var measurement = notUndefined(_this.getMeasurements()[index2]);
    if (align === "auto") {
      if (measurement.end >= _this.scrollOffset + _this.getSize() - _this.options.scrollPaddingEnd) {
        align = "end";
      } else if (measurement.start <= _this.scrollOffset + _this.options.scrollPaddingStart) {
        align = "start";
      } else {
        return [_this.scrollOffset, align];
      }
    }
    var toOffset = align === "end" ? measurement.end + _this.options.scrollPaddingEnd : measurement.start - _this.options.scrollPaddingStart;
    return [_this.getOffsetForAlignment(toOffset, align), align];
  };
  this.isDynamicMode = function() {
    return _this.measureElementCache.size > 0;
  };
  this.cancelScrollToIndex = function() {
    if (_this.scrollToIndexTimeoutId !== null) {
      clearTimeout(_this.scrollToIndexTimeoutId);
      _this.scrollToIndexTimeoutId = null;
    }
  };
  this.scrollToOffset = function(toOffset, _temp) {
    var _ref5 = _temp === void 0 ? {} : _temp, _ref5$align = _ref5.align, align = _ref5$align === void 0 ? "start" : _ref5$align, behavior = _ref5.behavior;
    _this.cancelScrollToIndex();
    if (behavior === "smooth" && _this.isDynamicMode()) {
      console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
    }
    _this._scrollToOffset(_this.getOffsetForAlignment(toOffset, align), {
      adjustments: void 0,
      behavior
    });
  };
  this.scrollToIndex = function(index2, _temp2) {
    var _ref6 = _temp2 === void 0 ? {} : _temp2, _ref6$align = _ref6.align, initialAlign = _ref6$align === void 0 ? "auto" : _ref6$align, behavior = _ref6.behavior;
    index2 = Math.max(0, Math.min(index2, _this.options.count - 1));
    _this.cancelScrollToIndex();
    if (behavior === "smooth" && _this.isDynamicMode()) {
      console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
    }
    var _this$getOffsetForInd = _this.getOffsetForIndex(index2, initialAlign), toOffset = _this$getOffsetForInd[0], align = _this$getOffsetForInd[1];
    _this._scrollToOffset(toOffset, {
      adjustments: void 0,
      behavior
    });
    if (behavior !== "smooth" && _this.isDynamicMode()) {
      _this.scrollToIndexTimeoutId = setTimeout(function() {
        _this.scrollToIndexTimeoutId = null;
        var elementInDOM = _this.measureElementCache.has(_this.options.getItemKey(index2));
        if (elementInDOM) {
          var _this$getOffsetForInd2 = _this.getOffsetForIndex(index2, align), _toOffset = _this$getOffsetForInd2[0];
          if (!approxEqual(_toOffset, _this.scrollOffset)) {
            _this.scrollToIndex(index2, {
              align,
              behavior
            });
          }
        } else {
          _this.scrollToIndex(index2, {
            align,
            behavior
          });
        }
      });
    }
  };
  this.scrollBy = function(delta, _temp3) {
    var _ref7 = _temp3 === void 0 ? {} : _temp3, behavior = _ref7.behavior;
    _this.cancelScrollToIndex();
    if (behavior === "smooth" && _this.isDynamicMode()) {
      console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
    }
    _this._scrollToOffset(_this.scrollOffset + delta, {
      adjustments: void 0,
      behavior
    });
  };
  this.getTotalSize = function() {
    var _this$getMeasurements;
    return (((_this$getMeasurements = _this.getMeasurements()[_this.options.count - 1]) == null ? void 0 : _this$getMeasurements.end) || _this.options.paddingStart) - _this.options.scrollMargin + _this.options.paddingEnd;
  };
  this._scrollToOffset = function(offset2, _ref8) {
    var adjustments = _ref8.adjustments, behavior = _ref8.behavior;
    _this.options.scrollToFn(offset2, {
      behavior,
      adjustments
    }, _this);
  };
  this.measure = function() {
    _this.itemSizeCache = /* @__PURE__ */ new Map();
    _this.notify(false);
  };
  this.setOptions(_opts);
  this.scrollRect = this.options.initialRect;
  this.scrollOffset = this.options.initialOffset;
  this.measurementsCache = this.options.initialMeasurementsCache;
  this.measurementsCache.forEach(function(item) {
    _this.itemSizeCache.set(item.key, item.size);
  });
  this.maybeNotify();
};
var findNearestBinarySearch = function findNearestBinarySearch2(low, high, getCurrentValue, value) {
  while (low <= high) {
    var middle = (low + high) / 2 | 0;
    var currentValue = getCurrentValue(middle);
    if (currentValue < value) {
      low = middle + 1;
    } else if (currentValue > value) {
      high = middle - 1;
    } else {
      return middle;
    }
  }
  if (low > 0) {
    return low - 1;
  } else {
    return 0;
  }
};
function calculateRange(_ref9) {
  var measurements = _ref9.measurements, outerSize = _ref9.outerSize, scrollOffset = _ref9.scrollOffset;
  var count2 = measurements.length - 1;
  var getOffset3 = function getOffset4(index2) {
    return measurements[index2].start;
  };
  var startIndex = findNearestBinarySearch(0, count2, getOffset3, scrollOffset);
  var endIndex = startIndex;
  while (endIndex < count2 && measurements[endIndex].end < scrollOffset + outerSize) {
    endIndex++;
  }
  return {
    startIndex,
    endIndex
  };
}
/**
 * react-virtual
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
var useIsomorphicLayoutEffect$1 = typeof document !== "undefined" ? React.useLayoutEffect : React.useEffect;
function useVirtualizerBase(options) {
  var rerender = React.useReducer(function() {
    return {};
  }, {})[1];
  var resolvedOptions = _extends$y({}, options, {
    onChange: function onChange(instance2, sync2) {
      if (sync2) {
        flushSync$1(rerender);
      } else {
        rerender();
      }
      options.onChange == null || options.onChange(instance2, sync2);
    }
  });
  var _React$useState = React.useState(function() {
    return new Virtualizer(resolvedOptions);
  }), instance = _React$useState[0];
  instance.setOptions(resolvedOptions);
  React.useEffect(function() {
    return instance._didMount();
  }, []);
  useIsomorphicLayoutEffect$1(function() {
    return instance._willUpdate();
  });
  return instance;
}
function useVirtualizer(options) {
  return useVirtualizerBase(_extends$y({
    observeElementRect,
    observeElementOffset,
    scrollToFn: elementScroll
  }, options));
}
const ROW_HEIGHT_ESTIMATES = {
  short: 33,
  medium: 41,
  tall: 49,
  "extra-tall": 57
};
const RowContext = React__default.createContext({
  hideInternalColumns: false,
  hideRowActions: false,
  isHovered: false,
  rowIndex: -1
});
const DELAY_BEFORE_LOAD_MS$1 = 250;
function Row$2(props) {
  const {
    renderer: RowRenderer,
    cellRenderer: CellRenderer,
    hideInternalColumns = false,
    hideRowActions = false,
    scrollDirection,
    skipPageLoading = false,
    ...displayRowProps
  } = props;
  const tableMeta = props.table.options.meta;
  const isHovered = tableMeta.rowActive.rowHoverIndex === props.index;
  const contextValue = React__default.useMemo(
    () => ({ isHovered, rowIndex: props.index, hideInternalColumns, hideRowActions }),
    [isHovered, props.index, hideInternalColumns, hideRowActions]
  );
  React__default.useEffect(() => {
    let timeout;
    if (tableMeta.server.isEnabled && tableMeta.server._experimentalDataLoader2 && !skipPageLoading) {
      const pageIndex = Math.floor(props.index / tableMeta.server.pageSize) * tableMeta.server.pageSize / tableMeta.server.pageSize;
      const sorting = props.table.getState().sorting;
      const filters = props.table.getState().columnFilters;
      const search = props.table.getState().globalFilter;
      const hiddenColumns = getHiddenColumns(props.table.getState().columnVisibility);
      const pageIndexesToFetch = [];
      if (scrollDirection === "backward" || !scrollDirection) {
        const backIndex = pageIndex - 1;
        if (backIndex > -1) {
          pageIndexesToFetch.push(backIndex);
        }
      }
      if ((scrollDirection === "forward" || !scrollDirection) && pageIndex + 2 < tableMeta.server.pageCount) {
        pageIndexesToFetch.push(pageIndex + 1);
      }
      if (pageIndexesToFetch.length) {
        timeout = setTimeout(() => {
          pageIndexesToFetch.forEach((index2) => {
            var _a, _b;
            (_b = (_a = tableMeta.server).loadPage) == null ? void 0 : _b.call(
              _a,
              index2,
              sorting,
              filters,
              hiddenColumns,
              tableMeta.search.enableGlobalFilter ? search : void 0
            );
          });
        }, DELAY_BEFORE_LOAD_MS$1);
      }
    }
    return () => {
      clearTimeout(timeout);
    };
  }, [tableMeta.server.pages]);
  return /* @__PURE__ */ React__default.createElement(RowContext.Provider, { value: contextValue }, /* @__PURE__ */ React__default.createElement(RowRenderer, { ...displayRowProps, cellRenderer: CellRenderer }));
}
const DELAY_BEFORE_LOAD_MS = 150;
function SkeletonRow(props) {
  const { index: index2, table } = props;
  const tableMeta = table.options.meta;
  if (tableMeta.server.isEnabled) {
    return /* @__PURE__ */ React__default.createElement(RowWithServerLoading, { ...props });
  }
  return /* @__PURE__ */ React__default.createElement(Skeleton, { cellsCount: table.getVisibleFlatColumns().length, index: index2 });
}
function RowWithServerLoading(props) {
  var _a;
  const { index: index2, table } = props;
  const tableMeta = table.options.meta;
  const pageIndex = Math.floor(index2 / tableMeta.server.pageSize) * tableMeta.server.pageSize / tableMeta.server.pageSize;
  React__default.useEffect(() => {
    let timeout;
    if (tableMeta.server.isEnabled) {
      const sorting = props.table.getState().sorting;
      const filters = props.table.getState().columnFilters;
      const search = props.table.getState().globalFilter;
      const hiddenColumns = getHiddenColumns(props.table.getState().columnVisibility);
      timeout = setTimeout(() => {
        var _a2, _b;
        (_b = (_a2 = tableMeta.server).loadPage) == null ? void 0 : _b.call(
          _a2,
          pageIndex,
          sorting,
          filters,
          hiddenColumns,
          tableMeta.search.enableGlobalFilter ? search : void 0
        );
      }, DELAY_BEFORE_LOAD_MS);
    }
    return () => {
      clearTimeout(timeout);
    };
  }, []);
  const groupedCellCount = ((_a = table.getState()) == null ? void 0 : _a.grouping.length) ?? 0;
  const ungroupedCellCount = table.getVisibleFlatColumns().length - groupedCellCount;
  return /* @__PURE__ */ React__default.createElement(Skeleton, { cellsCount: ungroupedCellCount, index: index2 });
}
const Skeleton = React__default.forwardRef(function Skeleton2(props, ref) {
  const { cellsCount, index: index2 } = props;
  return /* @__PURE__ */ React__default.createElement("tr", { "data-row-index": index2, "data-row-id": index2, ref }, Array(cellsCount).fill(null).map((_, index22) => /* @__PURE__ */ React__default.createElement("td", { key: index22 }, /* @__PURE__ */ React__default.createElement("span", { className: "bg-grey-100 text-grey-700 h-4 w-full text-center text-xs" }))));
});
function getScrollPaddingEndOffset(table) {
  const tableMeta = table.options.meta;
  let offset2 = 2;
  if (tableMeta.footer.isEnabled) {
    offset2 += 1;
  }
  if (table.getHeaderGroups().length > 1) {
    offset2 += table.getHeaderGroups().length - 1;
  }
  let height = ROW_HEIGHT_ESTIMATES.medium * offset2;
  const bottomRows = table.getBottomRows();
  if (bottomRows.length) {
    height += ROW_HEIGHT_ESTIMATES[tableMeta.rowHeight.height] * 1.4 * bottomRows.length;
  }
  return height;
}
function getPaddingEndOffset(table, options) {
  const bottomRows = table.getBottomRows() ?? [];
  return ROW_HEIGHT_ESTIMATES.medium * ((options == null ? void 0 : options.virtualiserPaddingEndOffset) ?? 1) * bottomRows.length;
}
const OVERSCAN_ROW_COUNT = 8;
function useTableRenderer(renderers, table, tableRef, length, defaultRowActiveIndex, options) {
  var _a, _b, _c, _d, _e;
  const tableMeta = table.options.meta;
  const isTableRowGrouped = !!((_a = table.getState().grouping) == null ? void 0 : _a.length);
  const rows = table.getCenterRows() ?? [];
  const rangeExtractor = useRowGroupVirtualisation(table);
  const scrollPaddingStart = ROW_HEIGHT_ESTIMATES.medium;
  const count2 = tableMeta.server.isEnabled && tableMeta.server._experimentalDataLoader2 ? length : rows.length;
  const virtualiser = useVirtualizer({
    count: count2,
    estimateSize: () => {
      return tableMeta.rowHeight.height ? ROW_HEIGHT_ESTIMATES[tableMeta.rowHeight.height] : ROW_HEIGHT_ESTIMATES.medium;
    },
    getScrollElement: () => tableRef.current,
    overscan: tableMeta.printing.isPrinting ? count2 : OVERSCAN_ROW_COUNT,
    rangeExtractor,
    // correctly sets the scroll padding offset, e.g. when keyboard navigating rows in the list
    scrollPaddingStart,
    scrollPaddingEnd: getScrollPaddingEndOffset(table),
    paddingEnd: getPaddingEndOffset(table, options)
  });
  const expandedState = table.getState().expanded;
  const previousExpandedStateRef = React__default.useRef(false);
  React__default.useEffect(() => {
    const isEmpty = JSON.stringify(expandedState) === "{}";
    if (expandedState === true || isEmpty && previousExpandedStateRef.current === true) {
      previousExpandedStateRef.current = expandedState === true;
      virtualiser.measure();
    }
  }, [expandedState]);
  const totalSize = virtualiser.getTotalSize();
  const virtualItems = virtualiser.getVirtualItems();
  const scrollToIndex = React__default.useCallback(
    (index2, options2 = { align: "auto", behavior: "smooth" }) => {
      const notSmooth = { ...options2, behavior: "auto" };
      if (tableRef.current) {
        if (index2 === 0) {
          virtualiser.scrollToOffset(0, notSmooth);
        } else if (index2 === count2 - 1) {
          tableRef.current.scrollTop = tableRef.current.scrollHeight;
        } else {
          virtualiser.scrollToIndex(index2, options2);
        }
      }
    },
    [virtualItems.length, tableRef.current, totalSize, count2]
  );
  const paddingStartIndex = isTableRowGrouped && count2 > 1 ? 1 : 0;
  const startValue = isTableRowGrouped ? ((_b = virtualItems[paddingStartIndex]) == null ? void 0 : _b.start) - ((_c = virtualItems[paddingStartIndex]) == null ? void 0 : _c.size) : (_d = virtualItems[paddingStartIndex]) == null ? void 0 : _d.start;
  const [paddingTop, paddingBottom] = virtualItems.length > 0 ? [Math.max(0, startValue ?? 0), Math.max(0, totalSize - (((_e = virtualItems[virtualItems.length - 1]) == null ? void 0 : _e.end) ?? 0))] : [0, 0];
  React__default.useEffect(() => {
    if (defaultRowActiveIndex) {
      scrollToIndex(defaultRowActiveIndex, { align: "center", behavior: "auto" });
    }
  }, []);
  let style = {};
  let content = null;
  if (count2 || table.getBottomRows().length) {
    style = {
      height: totalSize,
      paddingBottom: isNaN(paddingBottom) ? 0 : paddingBottom,
      paddingTop: isNaN(paddingTop) ? 0 : paddingTop
    };
  }
  if (count2) {
    content = virtualItems.map((virtualRow) => {
      var _a2;
      if (!virtualRow) {
        return null;
      }
      let row;
      if (tableMeta.server.isEnabled && tableMeta.server._experimentalDataLoader2) {
        const currentPageIndex = Math.floor(virtualRow.index / tableMeta.server.pageSize) * tableMeta.server.pageSize / tableMeta.server.pageSize;
        const pagePosition = ((_a2 = tableMeta.server.pages) == null ? void 0 : _a2.indexOf(currentPageIndex)) ?? -1;
        if (pagePosition > -1) {
          const fakeIndex = pagePosition * tableMeta.server.pageSize + virtualRow.index % tableMeta.server.pageSize;
          row = rows[fakeIndex];
        }
      } else {
        row = rows[virtualRow.index];
      }
      if (!(row == null ? void 0 : row.original)) {
        return /* @__PURE__ */ React__default.createElement(
          SkeletonRow,
          {
            key: virtualRow.index,
            index: virtualRow.index,
            scrollDirection: virtualiser.scrollDirection ?? void 0,
            table
          }
        );
      }
      const measureRow = (rowHeight) => {
        virtualiser.resizeItem(virtualRow, rowHeight);
      };
      return /* @__PURE__ */ React__default.createElement(
        Row$2,
        {
          key: row.id,
          row,
          index: virtualRow.index,
          scrollDirection: virtualiser.scrollDirection ?? void 0,
          table,
          measureRow,
          renderer: renderers.row,
          cellRenderer: renderers.cell
        }
      );
    });
  }
  return {
    rows: content,
    style,
    scrollToIndex
  };
}
function useRowGroupVirtualisation(table) {
  const rows = table.getRowModel().rows;
  const isTableGrouped = !!table.getState().grouping.length;
  const rowGroupIndexes = React__default.useMemo(() => {
    const indexes = [];
    if (isTableGrouped) {
      rows.forEach((row, index2) => {
        if (row.getIsGrouped()) {
          indexes.push(index2);
        }
      });
    }
    return indexes;
  }, [rows]);
  const rangeExtractor = React__default.useCallback(
    (range3) => {
      const activeRowGroupIndex = [...rowGroupIndexes].reverse().find((index2) => range3.startIndex >= index2) ?? rowGroupIndexes[0];
      const next = /* @__PURE__ */ new Set([activeRowGroupIndex, ...defaultRangeExtractor(range3)]);
      return [...next].sort((a4, b3) => a4 - b3);
    },
    [rowGroupIndexes]
  );
  return isTableGrouped ? rangeExtractor : void 0;
}
function useTableRowActiveListener(table, tableRef) {
  const tableMeta = table.options.meta;
  React__default.useEffect(() => {
    var _a, _b;
    if (tableMeta.rowActive.rowActiveIndex !== void 0) {
      const activeRow = ((_a = tableRef.current) == null ? void 0 : _a.querySelector('tbody tr[data-row-active="true"]')) ?? null;
      if (!isElementInsideOrTriggeredFromContainer(document.activeElement, activeRow) && !isElementInteractive(document.activeElement)) {
        (_b = activeRow == null ? void 0 : activeRow.focus) == null ? void 0 : _b.call(activeRow, { preventScroll: true });
      }
    }
  }, [tableMeta.rowActive.rowActiveIndex]);
}
function Actions(props) {
  const { actions, actionsLength, data, isActiveRow, rowId, table } = props;
  const { texts } = useLocalization();
  const tableMeta = table.options.meta;
  const visibleActions = actions.map((action) => action(data, rowId, tableMeta.rowActions.handlers["cleanup"], table)).filter((action) => !!action);
  const actionsOnRow = visibleActions.length === actionsLength ? visibleActions : visibleActions.slice(0, actionsLength - 1);
  const actionsInMenu = visibleActions.slice(visibleActions.length === actionsLength ? actionsLength : actionsLength - 1);
  const className = clsx(
    "flex justify-end text-right bg-[inherit] shadow-[-6px_0px_6px_var(--table-row-actions-shadow)] print:hidden"
  );
  return /* @__PURE__ */ React__default.createElement("span", { className }, actionsOnRow.map((button, index2) => {
    const tooltip = String(button.props.tooltip ?? button.props["aria-label"] ?? "");
    return React__default.cloneElement(button, {
      appearance: "transparent",
      key: index2,
      tabIndex: isActiveRow ? 0 : -1,
      tooltip: button.props.shortcut ? /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, tooltip, /* @__PURE__ */ React__default.createElement(Shortcut, { className: "ml-2", keys: button.props.shortcut })) : tooltip
    });
  }), actionsInMenu.length ? /* @__PURE__ */ React__default.createElement(
    IconButton,
    {
      appearance: "transparent",
      "aria-label": texts.table.columns.actions.tooltip,
      icon: "more",
      tabIndex: isActiveRow ? 0 : -1,
      menu: (menuProps) => /* @__PURE__ */ React__default.createElement(Menu$1, { ...menuProps }, /* @__PURE__ */ React__default.createElement(Menu$1.Content, null, actionsInMenu.map((action, i3) => /* @__PURE__ */ React__default.createElement(Menu$1.Item, { key: i3, ...action.props, shortcut: action.props.shortcut }, action.props["aria-label"]))))
    }
  ) : null);
}
function Header$5() {
  return null;
}
const Cell$6 = React__default.memo(function MemoedCell(context) {
  const { row, table } = context;
  const { hideRowActions, isHovered, rowIndex } = React__default.useContext(RowContext);
  const tableMeta = table.options.meta;
  const actions = tableMeta.rowActions.rowActions;
  const actionsLength = tableMeta.rowActions.rowActionsLength;
  const isActiveRow = tableMeta.rowActive.rowActiveIndex === rowIndex;
  const isResizingColumn = !!table.getState().columnSizingInfo.isResizingColumn;
  const isHoverStatePaused = tableMeta.rowActive.isHoverStatePaused;
  const isRowGrouped = row.getIsGrouped();
  if (!hideRowActions && !isRowGrouped && (actions == null ? void 0 : actions.length) && (isActiveRow || isHovered && !isHoverStatePaused && !isResizingColumn)) {
    return /* @__PURE__ */ React__default.createElement(
      Actions,
      {
        actions,
        actionsLength,
        data: row.original,
        isActiveRow,
        rowId: row.id,
        table
      }
    );
  }
  return null;
});
const renderer$3 = {
  header: Header$5,
  renderer: Cell$6,
  meta: {
    align: "right",
    className: clsx(
      'print:opacity-0 !px-0 !pr-1 overflow-hidden [table_&]:group-[[data-row-active="true"]]/row:sticky right-0',
      'group-[[data-row-active="true"][data-selected="false"]]/row:text-grey-200',
      'group-[[data-row-selected="true"]]/row:text-blue-100',
      'group-[[data-row-selected="false"]:hover]/row:text-grey-100'
    ),
    // TODO: remove when table3 is migrated, this satisfies the legacy table3 type
    enableSearch: false,
    header: ""
  }
};
function Header$4() {
  return null;
}
function Cell$5() {
  const { texts } = useLocalization();
  const { hideInternalColumns } = React__default.useContext(RowContext);
  if (hideInternalColumns) {
    return null;
  }
  return /* @__PURE__ */ React__default.createElement(
    Icon$1,
    {
      "aria-label": texts.table.columns.drag.tooltip,
      name: "drag",
      className: clsx(
        "text-grey-darkest invisible -mt-1 ml-[2px] cursor-grab active:cursor-grabbing group-hover/row:visible group-[[aria-grabbed='true']]/row:text-white",
        "[[data-table-editing-mode]_&]:!invisible"
      )
    }
  );
}
const renderer$2 = {
  header: Header$4,
  renderer: Cell$5,
  size: 20,
  meta: {
    align: "center",
    className: "!px-0 !pb-0 justify-end",
    // TODO: remove when table3 is migrated, this satisfies the legacy table3 type
    enableSearch: false,
    header: "",
    headerClassName: "!p-0"
  }
};
function Header$3(context) {
  const { texts } = useLocalization();
  const { table } = context;
  const tableMeta = table.options.meta;
  if (!tableMeta.rowExpansion.canExpandAll) {
    return null;
  }
  const isSomeRowsExpanded = table.getIsSomeRowsExpanded();
  const handleClick = (event) => {
    event.stopPropagation();
    table.toggleAllRowsExpanded(!isSomeRowsExpanded);
  };
  const title = isSomeRowsExpanded ? texts.table.columns.expansion.collapseAll : texts.table.columns.expansion.expandAll;
  return /* @__PURE__ */ React__default.createElement(Tooltip$3, { title }, /* @__PURE__ */ React__default.createElement(
    IconButton,
    {
      appearance: "transparent",
      icon: isSomeRowsExpanded ? "chevron-down-double" : "chevron-right-double",
      onClick: handleClick,
      tabIndex: -1,
      title
    }
  ));
}
function Cell$4(context) {
  var _a, _b;
  const { texts } = useLocalization();
  const { hideInternalColumns } = React__default.useContext(RowContext);
  const tableMeta = context.table.options.meta;
  if (hideInternalColumns) {
    return null;
  }
  const hasExpandedRow = (_b = (_a = tableMeta.rowExpansion).rowExpansionRenderer) == null ? void 0 : _b.call(_a, context.row.original);
  if (hasExpandedRow) {
    const isActiveRow = tableMeta.rowActive.rowActiveIndex === context.row.index;
    const isExpanded = context.row.getIsExpanded();
    const handleClick = (event) => {
      event.stopPropagation();
      context.row.toggleExpanded();
    };
    const title = isExpanded ? texts.table.columns.expansion.collapse : texts.table.columns.expansion.expand;
    const tabIndex = isActiveRow ? 0 : -1;
    return /* @__PURE__ */ React__default.createElement(Tooltip$3, { title }, /* @__PURE__ */ React__default.createElement(
      IconButton,
      {
        appearance: "discrete",
        icon: isExpanded ? "chevron-down" : "chevron-right",
        onClick: handleClick,
        tabIndex,
        title
      }
    ));
  }
  return null;
}
const renderer$1 = {
  header: Header$3,
  renderer: Cell$4,
  size: 40,
  meta: {
    align: "center",
    // TODO: remove when table3 is migrated, this satisfies the legacy table3 type
    enableSearch: false,
    header: "",
    headerClassName: "!p-0"
  }
};
function Header$2(context) {
  const { texts } = useLocalization();
  const { table } = context;
  const tableMeta = table.options.meta;
  const isAllRowsSelected = table.getIsAllRowsSelected();
  const isSomeRowsSelected = table.getIsSomeRowsSelected();
  const title = isAllRowsSelected ? texts.table.columns.select.deselectAll : texts.table.columns.select.selectAll;
  const handleChange = async (checked) => {
    if (tableMeta.server.loadAllIfNeeded) {
      const hiddenColumns = getHiddenColumns(table.getState().columnVisibility);
      await tableMeta.server.loadAllIfNeeded(
        table.getState().sorting,
        table.getState().columnFilters,
        hiddenColumns,
        tableMeta.search.enableGlobalFilter ? table.getState().globalFilter : void 0
      );
    }
    table.toggleAllRowsSelected(checked);
  };
  return /* @__PURE__ */ React__default.createElement(Tooltip$3, { title }, /* @__PURE__ */ React__default.createElement(
    Checkbox$2,
    {
      "aria-label": title,
      className: "hover:border-blue !-mt-px",
      checked: isAllRowsSelected,
      indeterminate: isSomeRowsSelected && !isAllRowsSelected,
      loading: tableMeta.server.loading,
      onChange: handleChange
    }
  ));
}
const toggleBetween$1 = (fromRowIndex, toRowIndex) => {
  const fromIndex = toRowIndex < fromRowIndex ? toRowIndex : fromRowIndex;
  const toIndex = toRowIndex > fromRowIndex ? toRowIndex : fromRowIndex;
  return [fromIndex, toIndex];
};
function Cell$3(context) {
  var _a;
  const { texts } = useLocalization();
  const { row, table } = context;
  const { hideInternalColumns, rowIndex } = React__default.useContext(RowContext);
  const tableMeta = table.options.meta;
  if (hideInternalColumns || table.options.enableGrouping && ((_a = table.getState().grouping) == null ? void 0 : _a.length) && !row.getIsGrouped()) {
    return null;
  }
  const isSelected = row.getIsGrouped() ? row.getIsAllSubRowsSelected() : row.getIsSelected();
  const canSelect = row.getCanSelect();
  const title = isSelected ? texts.table.columns.select.deselect : texts.table.columns.select.select;
  const handleClick = async (event) => {
    event.stopPropagation();
    if (row.getIsGrouped()) {
      row.subRows.forEach((row2) => row2.toggleSelected());
    } else if (event.shiftKey) {
      const [fromIndex, toIndex] = toggleBetween$1(tableMeta.rowSelection.lastSelectedRowIndex.current ?? 0, rowIndex);
      if (tableMeta.server.loadAllIfNeeded) {
        const hiddenColumns = getHiddenColumns(table.getState().columnVisibility);
        await tableMeta.server.loadAllIfNeeded(
          table.getState().sorting,
          table.getState().columnFilters,
          hiddenColumns,
          tableMeta.search.enableGlobalFilter ? table.getState().globalFilter : void 0
        );
      }
      const selectedRows = table.getRowModel().rows.slice(fromIndex, toIndex + 1);
      table.setRowSelection((currentRowSelection) => ({
        ...currentRowSelection,
        ...selectedRows.filter((row2) => row2.getCanSelect()).reduce((state, row2) => ({ ...state, [row2.id]: true }), {})
      }));
    } else {
      row.toggleSelected();
    }
    tableMeta.rowSelection.lastSelectedRowIndex.current = row.index;
  };
  return /* @__PURE__ */ React__default.createElement(
    Tooltip$3,
    {
      hidden: !canSelect,
      title: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, title, /* @__PURE__ */ React__default.createElement(Shortcut, { className: "ml-2", keys: "Space" }))
    },
    /* @__PURE__ */ React__default.createElement(
      Checkbox$2,
      {
        "aria-label": title,
        className: "!mt-0",
        checked: isSelected,
        onClick: handleClick,
        disabled: !canSelect,
        onChange: () => false
      }
    )
  );
}
const renderer = {
  header: Header$2,
  renderer: Cell$3,
  size: 40,
  meta: {
    align: "center",
    className: "!px-1",
    // TODO: remove when table3 is migrated, this satisfies the legacy table3 type
    enableSearch: false,
    header: "",
    headerClassName: "!px-1"
  }
};
const INTERNAL_RENDERERS = {
  rowActions: renderer$3,
  rowDrag: renderer$2,
  rowExpansion: renderer$1,
  rowSelection: renderer
};
function useTable$1(props, externalRef, renderers, meta, options) {
  const ref = useMergedRef(externalRef);
  const manager = useTableManager(props, ref, meta, INTERNAL_RENDERERS);
  const renderer2 = useTableRenderer(
    renderers,
    manager.instance,
    ref,
    manager.meta.length,
    props.defaultRowActiveIndex,
    options
  );
  const { style, stylesheet } = useTableStyle(manager.id, manager.instance);
  useTableGlobalShortcuts(manager.instance, ref, renderer2.scrollToIndex, props.enableLocalKeyboardShortcuts);
  useTableRef(manager.instance, ref);
  useTableRowActiveListener(manager.instance, ref);
  return {
    ...manager,
    props: {
      customSettings: props.customSettings,
      emptyState: props.emptyState,
      toolbarLeft: props.toolbarLeft,
      toolbarPanel: props.toolbarPanel,
      toolbarRight: props.toolbarRight
    },
    renderer: renderer2,
    style,
    stylesheet,
    ref
  };
}
function getCellAttributes(cell, index2, isHighlighted) {
  const columnMeta = cell.column.columnDef.meta;
  const isPinned = cell.column.getIsPinned();
  return {
    "data-cell-align": columnMeta == null ? void 0 : columnMeta.align,
    "data-cell-highlighted": isHighlighted,
    "data-cell-id": cell.column.id,
    "data-cell-index": index2,
    "data-cell-pinned": isPinned ? true : void 0,
    "data-cell-truncate": columnMeta.enableTruncate ? true : void 0,
    className: typeof columnMeta.className === "function" ? columnMeta.className(cell.row.original) : columnMeta.className
  };
}
function useSearchHighlighting(cell, cellIndex, ref) {
  const localization = useLocalization();
  const { rowIndex } = React__default.useContext(RowContext);
  const context = cell.getContext();
  const tableMeta = context.table.options.meta;
  const columnMeta = cell.column.columnDef.meta;
  const isHighlighted = React__default.useMemo(() => {
    if (!cell.column.columnDef.enableGlobalFilter || isInternalColumn(cell.column.id) || cell.getIsAggregated() || cell.getIsPlaceholder()) {
      return void 0;
    }
    let isHighlighted2 = false;
    if (context.table.getState().globalFilter) {
      isHighlighted2 = isCellHighlighted(
        context.table.getState().globalFilter,
        cell.getValue(),
        cell.row.original,
        columnMeta.dataType,
        columnMeta.dataTypeOptions,
        localization
      );
    }
    if (!isHighlighted2 || tableMeta.search.currentHighlightColumnIndex === void 0) {
      return void 0;
    }
    const [rowActiveIndex, currentColumnIndex] = tableMeta.search.highlightedColumnIndexes[tableMeta.search.currentHighlightColumnIndex] ?? [];
    if (rowActiveIndex === rowIndex && currentColumnIndex === cellIndex) {
      return "current";
    }
    return true;
  }, [
    cell.getValue(),
    context.table.getState().globalFilter,
    tableMeta.search.highlightedColumnIndexes.length,
    tableMeta.search.currentHighlightColumnIndex
  ]);
  React__default.useEffect(() => {
    if (ref.current && isHighlighted === "current") {
      ref.current.scrollIntoView({ block: "nearest", inline: "nearest" });
      setTimeout(() => {
        if (ref.current) {
          const tableEl = ref.current.closest('table[data-taco^="table"]');
          setTimeout(() => {
            var _a;
            const pinnedColumns = tableEl == null ? void 0 : tableEl.querySelectorAll('thead tr:last-child th[data-cell-pinned="left"]');
            if (pinnedColumns == null ? void 0 : pinnedColumns.length) {
              const lastFrozenRect = (_a = pinnedColumns.item(pinnedColumns.length - 1)) == null ? void 0 : _a.getBoundingClientRect();
              if (lastFrozenRect && cell.column.getStart() < lastFrozenRect.right) {
                tableEl == null ? void 0 : tableEl.scrollTo(cell.column.getStart() - lastFrozenRect.right, tableEl.scrollTop);
              }
            }
          }, 1);
        }
      }, 1);
    }
  }, [isHighlighted]);
  return isHighlighted;
}
function GroupedCell(props) {
  const { cell, cellRef, index: index2, isHighlighted } = props;
  const { table } = cell.getContext();
  const tableMeta = table.options.meta;
  const attributes = getCellAttributes(cell, index2, isHighlighted);
  const { isHovered, rowIndex } = React__default.useContext(RowContext);
  const isActiveRow = tableMeta.rowActive.rowActiveIndex === rowIndex;
  const canShowActions = isActiveRow || isHovered && !tableMeta.rowActive.isHoverStatePaused;
  const colSpan = cell.row.getVisibleCells().filter((c3) => c3.column.id === "__actions" || !isInternalColumn(c3.column.id)).length - 1;
  const subRows = cell.getContext().row.subRows.map((row) => row.original);
  const content = typeof cell.column.columnDef.cell === "function" ? cell.column.columnDef.cell(cell.getContext()) : null;
  return /* @__PURE__ */ React__default.createElement(
    MemoedGroupedCell,
    {
      ...attributes,
      canShowActions,
      cellRef,
      colSpan,
      rowActions: tableMeta.rowGroups.rowActionsForGroup,
      rowId: cell.row.id,
      subRows,
      table
    },
    content
  );
}
const MemoedGroupedCell = React__default.memo(function MemoedGroupedCell2(props) {
  const { canShowActions, cellRef, children, colSpan, rowActions, rowId, subRows, table, ...attributes } = props;
  return (
    // pr-1 is needed to align group row actions with row actions in sibling rows, if present
    /* @__PURE__ */ React__default.createElement("td", { ...attributes, className: "!pr-1", ref: cellRef, style: { gridColumn: `span ${colSpan} / span ${colSpan}` } }, /* @__PURE__ */ React__default.createElement("span", { className: "grow" }, children), (rowActions == null ? void 0 : rowActions.length) && canShowActions ? /* @__PURE__ */ React__default.createElement(
      Actions,
      {
        actions: rowActions,
        actionsLength: 4,
        data: subRows,
        isActiveRow: true,
        rowId,
        table
      }
    ) : null)
  );
});
function Cell$2(props) {
  const { cell, index: index2, renderer: CellRenderer } = props;
  const cellRef = React__default.useRef(null);
  const isHighlighted = useSearchHighlighting(cell, index2, cellRef);
  if ((cell.getIsAggregated() || cell.getIsPlaceholder()) && !isInternalColumn(cell.column.id)) {
    return null;
  }
  const cellProps = {
    cell,
    cellRef,
    index: index2,
    isHighlighted
  };
  if (cell.getIsGrouped()) {
    return /* @__PURE__ */ React__default.createElement(GroupedCell, { ...cellProps });
  }
  return /* @__PURE__ */ React__default.createElement(CellRenderer, { ...cellProps });
}
const DisplayRow = React__default.memo(function DisplayRow2(props) {
  var _a, _b, _c;
  const { children, cellRenderer: CellRenderer, index: index2, measureRow, row, table, ...otherAttributes } = props;
  const tableMeta = table.options.meta;
  const attributes = {
    ...otherAttributes,
    "data-row-id": row.id,
    "data-row-index": index2,
    tabIndex: -1
  };
  const handleClick = React__default.useCallback(
    (event) => {
      var _a2;
      const clickedElement = event.target;
      if (!((_a2 = event.currentTarget) == null ? void 0 : _a2.contains(event.target)) || isElementInteractive(clickedElement)) {
        return;
      }
      tableMeta.rowClick.handleClick(event, row.original);
    },
    [row.original]
  );
  const handleClickCapture = React__default.useCallback(() => {
    tableMeta.rowActive.setRowActiveIndex(index2);
  }, [index2]);
  if (tableMeta.rowActive.isEnabled) {
    attributes["data-row-active"] = tableMeta.rowActive.rowActiveIndex === index2 ? true : void 0;
    attributes.onClickCapture = handleClickCapture;
  }
  if (tableMeta.rowClick.isEnabled(row.original)) {
    attributes.onClick = handleClick;
  }
  if (tableMeta.rowDrag.isEnabled) {
    attributes["aria-grabbed"] = !!tableMeta.rowDrag.dragging[row.id];
    attributes.draggable = true;
    const GHOST_ELEMENT_ID = "taco_table_dragging";
    attributes.onDragStart = (event) => {
      var _a2, _b2, _c2, _d;
      let rows = [row];
      if (row.getCanSelect()) {
        rows = row.getIsSelected() ? table.getSelectedRowModel().rows : [row, ...table.getSelectedRowModel().rows];
      }
      const data = rows.map((row2) => row2.original);
      (_b2 = (_a2 = tableMeta.rowDrag).setDragging) == null ? void 0 : _b2.call(
        _a2,
        rows.reduce((dragging, rowBeingDragged) => ({ ...dragging, [rowBeingDragged.id]: true }), {})
      );
      event.dataTransfer.setData("text", JSON.stringify(data));
      const showPlaceholder = (text2) => {
        const ghost = document.createElement("div");
        ghost.id = GHOST_ELEMENT_ID;
        ghost.className = "wcag-blue rounded flex w-48 p-4 absolute -ml-[100vw]";
        ghost.innerText = text2;
        document.body.appendChild(ghost);
        event.dataTransfer.setDragImage(ghost, 0, 0);
      };
      const setDataTransfer = (text2) => event.dataTransfer.setData("text", text2);
      (_d = (_c2 = tableMeta.rowDrag).handleRowDrag) == null ? void 0 : _d.call(_c2, data, showPlaceholder, setDataTransfer);
    };
    attributes.onDragEnd = () => {
      var _a2, _b2, _c2;
      (_a2 = document.getElementById(GHOST_ELEMENT_ID)) == null ? void 0 : _a2.remove();
      (_c2 = (_b2 = tableMeta.rowDrag).setDragging) == null ? void 0 : _c2.call(_b2, {});
    };
  }
  const [isDraggedOver, dropTargetProps] = useDropTarget((event) => {
    var _a2, _b2;
    return (_b2 = (_a2 = tableMeta.rowDrop).handleDrop) == null ? void 0 : _b2.call(_a2, event, row.original);
  });
  if (tableMeta.rowDrop.isEnabled) {
    attributes.onDragEnter = dropTargetProps == null ? void 0 : dropTargetProps.onDragEnter;
    attributes.onDragLeave = dropTargetProps == null ? void 0 : dropTargetProps.onDragLeave;
    attributes.onDragOver = dropTargetProps == null ? void 0 : dropTargetProps.onDragOver;
    attributes.onDrop = dropTargetProps == null ? void 0 : dropTargetProps.onDrop;
    attributes["data-row-dragged-over"] = isDraggedOver;
  }
  if (table.options.enableGrouping) {
    attributes["data-row-group"] = row.getIsGrouped() ? true : void 0;
  }
  if (row.getCanSelect()) {
    attributes["data-row-selected"] = row.getIsSelected() || row.getIsAllSubRowsSelected() ? true : void 0;
  }
  let expandedRow;
  if (tableMeta.rowExpansion.isEnabled && row.getIsExpanded()) {
    attributes["data-row-expanded"] = true;
    expandedRow = (_c = (_b = (_a = tableMeta.rowExpansion).rowExpansionRenderer) == null ? void 0 : _b.call(_a, row.original)) == null ? void 0 : _c();
  }
  const rowMeta = row.original._meta;
  if (rowMeta) {
    if (rowMeta.layout) {
      attributes["data-row-meta-layout"] = rowMeta.layout;
    }
  }
  const ref = React__default.useRef(null);
  const expansionRef = React__default.useRef(null);
  React__default.useEffect(() => {
    var _a2, _b2;
    const rowHeight = ((_a2 = ref.current) == null ? void 0 : _a2.getBoundingClientRect().height) ?? 0;
    const expansionHeight = ((_b2 = expansionRef.current) == null ? void 0 : _b2.getBoundingClientRect().height) ?? 0;
    measureRow(rowHeight + expansionHeight);
  }, [expansionRef.current]);
  const className = clsx("group/row", otherAttributes.className, {
    "hover:cursor-grab": tableMeta.rowDrag.isEnabled && typeof attributes.onClick !== "function",
    "hover:cursor-pointer": typeof attributes.onClick === "function"
  });
  const isGrouped = row.getIsGrouped();
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("tr", { ...attributes, className, ref }, children, row.getVisibleCells().filter((cell) => !(isGrouped && cell.column.id === "__actions")).map((cell, cellIndex) => /* @__PURE__ */ React__default.createElement(Cell$2, { key: cell.id, cell, index: cellIndex, renderer: CellRenderer }))), expandedRow ? /* @__PURE__ */ React__default.createElement("tr", { "data-row-parent-id": row.id, ref: expansionRef }, /* @__PURE__ */ React__default.createElement("td", { className: "col-span-full" }, expandedRow)) : null);
});
function DisplayCell(props) {
  const { cell, cellRef, index: index2, isHighlighted, ...cellAttributes } = props;
  const columnMeta = cell.column.columnDef.meta;
  const attributes = getCellAttributes(cell, index2, isHighlighted);
  const isTruncated = !!columnMeta.enableTruncate;
  let content;
  if (isInternalColumn(cell.column.id)) {
    content = flexRender(cell.column.columnDef.cell, cell.getContext());
  } else {
    content = typeof cell.column.columnDef.cell === "function" ? cell.column.columnDef.cell(cell.getContext()) : cell.getValue();
  }
  return /* @__PURE__ */ React__default.createElement(MemoedDisplayCell, { ...cellAttributes, ...attributes, cellRef, isTruncated }, content);
}
const MemoedDisplayCell = React__default.memo(function MemoedDisplayCell2(props) {
  const { cellRef, children, isTruncated, ...cellAttributes } = props;
  return /* @__PURE__ */ React__default.createElement("td", { ...cellAttributes, ref: cellRef }, isTruncated ? /* @__PURE__ */ React__default.createElement("span", { className: "truncate print:overflow-visible print:whitespace-normal" }, children) : children);
});
const RENDERERS$1 = {
  row: DisplayRow,
  cell: DisplayCell
};
function useReport(props, ref) {
  return useTable$1(props, ref, RENDERERS$1);
}
const indicators = {
  asc: /* @__PURE__ */ React__default.createElement(Icon$1, { name: "chevron-up-solid", className: "pointer-events-none -my-0.5" }),
  desc: /* @__PURE__ */ React__default.createElement(Icon$1, { name: "chevron-down-solid", className: "pointer-events-none -my-0.5" })
};
function SortIndicator(props) {
  return indicators[props.direction] ?? null;
}
const ariaSort = {
  asc: "ascending",
  desc: "descending"
};
function getSortAttributes(canSort, toggleSorting, sortDirection) {
  if (!canSort) {
    return {};
  }
  const handleClick = (event) => {
    if (event.isDefaultPrevented() || !event.currentTarget.contains(event.target)) {
      return;
    }
    event.preventDefault();
    toggleSorting == null ? void 0 : toggleSorting(event);
  };
  return {
    "aria-sort": ariaSort[sortDirection] ?? "none",
    onClick: handleClick
  };
}
function Resizer(props) {
  const { headerRef, id: id2, isResizing, onResetSize, onResize, setColumnSizing, width } = props;
  const { texts } = useLocalization();
  const handleClick = (event) => {
    event.stopPropagation();
    event.preventDefault();
  };
  const handleResize = (event) => {
    if (event.detail >= 2) {
      onResetSize();
    } else {
      if (!Number.isInteger(width) && headerRef) {
        setColumnSizing((sizes) => ({
          ...sizes,
          [id2]: headerRef.getBoundingClientRect().width
        }));
        setTimeout(() => {
          onResize == null ? void 0 : onResize(event);
        }, 1);
      } else {
        onResize == null ? void 0 : onResize(event);
      }
    }
  };
  const handle = /* @__PURE__ */ React__default.createElement(
    "div",
    {
      className: clsx(
        "invisible absolute right-0 top-0 z-10 -mr-2 flex h-full w-4 cursor-col-resize touch-none select-none justify-center rounded py-0.5",
        "group-hover/header:visible",
        "[th:last-child>&]:!mr-0 [th:last-child>&]:w-2",
        {
          "!visible": isResizing
        }
      ),
      onClick: handleClick,
      onMouseDown: handleResize,
      onTouchStart: handleResize
    },
    /* @__PURE__ */ React__default.createElement(
      "div",
      {
        className: clsx("h-full w-1 rounded", {
          "!bg-blue-500": isResizing,
          "bg-grey-500 hover:bg-grey-700": !isResizing
        })
      }
    )
  );
  if (isResizing) {
    return handle;
  }
  return /* @__PURE__ */ React__default.createElement(Tooltip$3, { placement: "top", title: texts.table.columns.resize.tooltip }, handle);
}
const SearchInput = React.forwardRef(function SearchInput2({ onSearch, ...props }, ref) {
  const internalRef = useMergedRef(ref);
  const { texts } = useLocalization();
  const handleClick = () => {
    var _a;
    onSearch == null ? void 0 : onSearch(((_a = internalRef.current) == null ? void 0 : _a.value) ?? "");
  };
  const handleCancelClick = () => {
    setInputValueByRef$1(internalRef.current, "");
  };
  const handleKeyDown = (event) => {
    var _a;
    (_a = props.onKeyDown) == null ? void 0 : _a.call(props, event);
    if (event.isDefaultPrevented()) {
      return;
    }
    if (event.key === "Enter") {
      event.preventDefault();
      handleClick();
      return;
    }
    if (event.key === "Escape") {
      onSearch == null ? void 0 : onSearch("");
      return;
    }
  };
  return /* @__PURE__ */ React.createElement(
    Input,
    {
      "aria-label": texts.searchInput.placeholder,
      placeholder: texts.searchInput.placeholder,
      ...props,
      onKeyDown: handleKeyDown,
      postfix: /* @__PURE__ */ React.createElement(React.Fragment, null, props.disabled || props.readOnly || !props.value ? null : /* @__PURE__ */ React.createElement(
        IconButton,
        {
          "aria-hidden": true,
          "aria-label": texts.searchInput.clear,
          className: "group-peer-focus:visible group-peer-hover:visible !text-grey-700 invisible mr-0.5 !h-5 !min-h-[theme(spacing.4)] !w-5 !min-w-[theme(spacing.4)] text-xs hover:visible group-hover:visible",
          icon: "close",
          onClick: handleCancelClick,
          rounded: true,
          tabIndex: -1,
          tooltip: texts.searchInput.clear
        }
      ), /* @__PURE__ */ React.createElement(
        IconButton,
        {
          "aria-label": texts.searchInput.button,
          icon: "search",
          className: "group-peer-focus:!border-transparent group-peer-focus:group-peer-active:!border-transparent -mr-2 !border-transparent !bg-transparent focus:!border-transparent",
          disabled: props.disabled || props.readOnly,
          onClick: handleClick,
          tabIndex: -1,
          tooltip: texts.searchInput.button
        }
      )),
      ref: internalRef,
      type: "search"
    }
  );
});
function GotoPopover(props) {
  const { onGoto: handleGoto, trigger, ...popoverProps } = props;
  const { texts } = useLocalization();
  const handleSearch = (value) => handleGoto(value);
  return /* @__PURE__ */ React__default.createElement(Popover, { ...popoverProps, anchor: trigger }, /* @__PURE__ */ React__default.createElement(Popover.Content, null, /* @__PURE__ */ React__default.createElement(
    SearchInput,
    {
      "aria-label": texts.table.columns.menu.gotoRow,
      name: "query",
      onSearch: handleSearch,
      onKeyDown: (event) => event.stopPropagation(),
      placeholder: `${texts.table.columns.menu.gotoRow}...`
    }
  )));
}
function HeaderMenu(props) {
  const {
    canFilter,
    canGoto,
    canHide,
    canPin,
    canSort,
    columnId,
    customMenu,
    index: index2,
    isFiltered,
    onFilter: handleFilter,
    onGoto: handleGoto,
    onHide: handleHide,
    onPin: handlePin,
    onSortToggle: handleSortToggle,
    scrollToIndex,
    setRowActiveIndex,
    sortDirection
  } = props;
  const { texts } = useLocalization();
  const [popover, setPopover] = React__default.useState(void 0);
  let popoverElement;
  if (popover) {
    const handleClosePopover = () => setPopover(void 0);
    switch (popover) {
      case "goto": {
        if (handleGoto) {
          const goto = async (query) => {
            try {
              const index22 = await handleGoto(query);
              setRowActiveIndex(index22);
              scrollToIndex(index22);
            } catch (e3) {
              console.error(e3);
            } finally {
              handleClosePopover();
            }
          };
          popoverElement = (props2) => /* @__PURE__ */ React__default.createElement(GotoPopover, { ...props2, open: true, onChange: handleClosePopover, onGoto: goto });
        }
      }
    }
  }
  const memoedMenuItems = React__default.useMemo(() => {
    const menuItems = [];
    if (canHide && handleHide) {
      const handleClick = (event) => setTimeout(() => handleHide(event), 1);
      menuItems.push(
        /* @__PURE__ */ React__default.createElement(Menu$1.Item, { icon: "eye-off", onClick: handleClick }, texts.table.columns.menu.hideColumn)
      );
    }
    if (canSort) {
      menuItems.push(
        /* @__PURE__ */ React__default.createElement(
          Menu$1.Item,
          {
            icon: "sort-by",
            subMenu: () => /* @__PURE__ */ React__default.createElement(Menu$1.SubMenu, null, /* @__PURE__ */ React__default.createElement(Menu$1.RadioGroup, { onChange: handleSortToggle, value: sortDirection }, /* @__PURE__ */ React__default.createElement(Menu$1.RadioGroup.Item, { value: "asc" }, texts.table.columns.menu.sortingOrder.ascending), /* @__PURE__ */ React__default.createElement(Menu$1.RadioGroup.Item, { value: "desc" }, texts.table.columns.menu.sortingOrder.descending), /* @__PURE__ */ React__default.createElement(Menu$1.RadioGroup.Item, { value: false }, texts.table.columns.menu.sortingOrder.unsorted)))
          },
          texts.table.columns.menu.sorting
        )
      );
    }
    if (canGoto) {
      menuItems.push(
        /* @__PURE__ */ React__default.createElement(Menu$1.Item, { icon: "move", onClick: () => setPopover("goto"), shortcut: "g" }, texts.table.columns.menu.gotoRow, "...")
      );
    }
    if (canPin && handlePin) {
      menuItems.push(
        /* @__PURE__ */ React__default.createElement(Menu$1.Item, { icon: "column-freeze", onClick: () => handlePin(index2) }, index2 === 0 ? texts.table.columns.menu.freezeFirstColumn : texts.table.columns.menu.freezeUptoColumn.replace("[TOTAL]", String(index2 + 1)))
      );
      menuItems.push(
        /* @__PURE__ */ React__default.createElement(Menu$1.Item, { icon: "column-unfreeze", onClick: () => handlePin(void 0) }, texts.table.columns.menu.unfreezeColumns)
      );
    }
    if (canFilter && handleFilter) {
      menuItems.push(
        /* @__PURE__ */ React__default.createElement(Menu$1.Item, { icon: isFiltered ? "filter-solid" : "filter", onClick: () => handleFilter() }, isFiltered ? texts.table.columns.menu.editFilter : texts.table.columns.menu.filter)
      );
    }
    if (customMenu) {
      const customItems = customMenu.map((menuItem) => menuItem(columnId)).filter((action) => !!action);
      if (customItems.length) {
        if (menuItems.length) {
          menuItems.push(/* @__PURE__ */ React__default.createElement(Menu$1.Separator, null));
        }
        menuItems.push(...customItems);
      }
    }
    return menuItems.map((item, key) => React__default.cloneElement(item, { key }));
  }, [
    canFilter,
    canGoto,
    canHide,
    canPin,
    canSort,
    customMenu,
    handleGoto,
    handleSortToggle,
    index2,
    isFiltered,
    sortDirection
  ]);
  const className = clsx(
    // positioning
    "justify-end overflow-hidden",
    // sizing
    "!h-6 !w-0 !min-h-[theme(spacing.6)] !min-w-0",
    // visible - hover
    "group-hover/header:!w-6 group-hover/header:!min-w-[theme(spacing.6)] group-hover/header:-mr-1",
    // visible - expanded
    "aria-expanded:!w-6 aria-expanded:!min-w-[theme(spacing.6)]",
    // visible - focus
    "focus:!w-6 focus:!min-w-[theme(spacing.6)]",
    {
      "!w-6 !min-w-[theme(spacing.6)]": !!popoverElement
    },
    props.className
  );
  return /* @__PURE__ */ React__default.createElement(
    IconButton,
    {
      className,
      icon: "more",
      menu: popoverElement ? void 0 : (menuProps) => /* @__PURE__ */ React__default.createElement(Menu$1, { ...menuProps }, /* @__PURE__ */ React__default.createElement(Menu$1.Content, null, memoedMenuItems)),
      popover: popoverElement,
      onClickCapture: (event) => event.preventDefault(),
      onKeyDown: (event) => {
        var _a;
        if (event.key === "ArrowUp" || event.key === "ArrowDown") {
          (_a = event.currentTarget) == null ? void 0 : _a.blur();
        }
      }
    }
  );
}
function useSetInitialColumnSizing(id2, defaultWidth, width, element, canMeasureSize, setColumnSizing) {
  React__default.useLayoutEffect(() => {
    if (canMeasureSize && element && !Number.isInteger(width) && !isInternalColumn(id2)) {
      const setWidth = () => setColumnSizing((sizes) => ({
        ...sizes,
        [id2]: element.getBoundingClientRect().width
      }));
      if (defaultWidth === "grow") {
        requestAnimationFrame(setWidth);
      } else {
        setWidth();
      }
    }
  }, [element, canMeasureSize, width]);
}
function getIsPinned(header) {
  var _a, _b;
  return ((_a = header.subHeaders) == null ? void 0 : _a.length) ? (_b = header.subHeaders.find((x3) => x3.column.getIsPinned())) == null ? void 0 : _b.column.getIsPinned() : header.column.getIsPinned();
}
const HeaderContent = ({ children, tooltip, isInternalColumnHeader }) => {
  if (isInternalColumnHeader || typeof children !== "string") {
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, children);
  }
  return /* @__PURE__ */ React__default.createElement(Tooltip$3, { title: String(tooltip ?? children), placement: "top" }, /* @__PURE__ */ React__default.createElement("span", { className: "truncate" }, children));
};
function Header$1(props) {
  const { header, scrollToIndex } = props;
  if (header.column.getIsGrouped()) {
    return null;
  }
  const { table } = header.getContext();
  const tableMeta = table.options.meta;
  const columnMeta = header.column.columnDef.meta ?? {};
  const isGroup2 = !!header.subHeaders.length;
  const isPinned = getIsPinned(header);
  const canFilter = !header.isPlaceholder && header.column.getCanFilter() && !!table.options.enableColumnFilters;
  const canHide = !header.isPlaceholder && !isGroup2 && header.column.getCanHide();
  const canMeasureSize = !!table.getRowModel().rows.length;
  const canPin = !header.isPlaceholder && !isGroup2 && header.column.getCanPin();
  const canResize = !header.isPlaceholder && !isGroup2 && header.column.getCanResize();
  const canSort = !header.isPlaceholder && !isGroup2 && header.column.getCanSort();
  const canGoto = canSort && !header.isPlaceholder && !isGroup2 && tableMeta.rowGoto.isEnabled && !!header.column.getIsSorted();
  const hasMenu = !isInternalColumn(header.id) && (canHide || canGoto || canPin || canSort || !!columnMeta.menu);
  const sorting = table.getState().sorting;
  const filters = table.getState().columnFilters;
  const search = table.getState().globalFilter;
  const memoedProps = {
    align: columnMeta.align,
    canFilter,
    canHide,
    canGoto,
    canMeasureSize,
    canPin,
    canResize,
    canSort,
    className: clsx("group/header", columnMeta.headerClassName),
    children: flexRender(header.column.columnDef.header, header.getContext()),
    colSpan: header.colSpan,
    customMenu: columnMeta.menu,
    defaultWidth: columnMeta.defaultWidth,
    hasMenu,
    id: header.id,
    isFiltered: header.column.getIsFiltered(),
    index: header.index,
    isGroup: isGroup2,
    isPinned,
    isPlaceholder: header.isPlaceholder,
    offset: header.column.getStart(isPinned),
    scrollToIndex,
    setRowActiveIndex: tableMeta.rowActive.setRowActiveIndex,
    setColumnSizing: table.setColumnSizing,
    tooltip: columnMeta.tooltip,
    width: table.getState().columnSizing[header.id]
  };
  if (header.isPlaceholder) {
    const nextHeader = header.headerGroup.headers[header.index + 1];
    memoedProps.className = clsx("!bg-white before:!content-none", memoedProps.className, {
      "after:!content-none": nextHeader == null ? void 0 : nextHeader.isPlaceholder
    });
  }
  if (canFilter) {
    memoedProps.onFilter = () => {
      header.column.setFilterValue({ comparator: TableFilterComparator.Contains });
    };
  }
  if (canGoto) {
    memoedProps.onGoto = (query) => {
      var _a, _b;
      return (_b = (_a = tableMeta.rowGoto).handleGoto) == null ? void 0 : _b.call(_a, header.id, query, sorting, filters, search);
    };
  }
  if (canHide) {
    memoedProps.onHide = header.column.getToggleVisibilityHandler();
  }
  if (canPin) {
    memoedProps.onPin = (index2) => {
      table.setColumnPinning((pinningState) => {
        return {
          ...pinningState,
          left: index2 === void 0 ? unfreezeAllExternalColumns(pinningState.left) : freezeUptoExternalColumn(
            index2,
            table.getAllLeafColumns().map((column) => column.id)
          )
        };
      });
    };
  }
  if (canResize) {
    memoedProps.isResizing = header.column.getIsResizing();
    memoedProps.onResize = header.getResizeHandler();
    memoedProps.resetSize = header.column.resetSize;
  }
  if (canSort) {
    const handleSortToggle = (sortDirection) => {
      if (sortDirection === false) {
        header.column.clearSorting();
      } else {
        header.column.toggleSorting(sortDirection === "desc");
      }
    };
    memoedProps.onSort = header.column.getToggleSortingHandler();
    memoedProps.onSortToggle = handleSortToggle;
    memoedProps.sortDirection = header.column.getIsSorted();
  }
  return /* @__PURE__ */ React__default.createElement(MemoedHeader, { key: header.id, ...memoedProps });
}
const MemoedHeader = React__default.memo(function MemoedHeader2(props) {
  const {
    align,
    canFilter,
    canGoto,
    canHide,
    canMeasureSize,
    canPin,
    canResize,
    canSort,
    children,
    className,
    colSpan,
    customMenu,
    defaultWidth,
    hasMenu,
    id: id2,
    index: index2,
    isFiltered,
    isGroup: isGroup2,
    isPinned,
    isPlaceholder,
    isResizing,
    offset: offset2,
    onFilter: handleFilter,
    onGoto: handleGoto,
    onHide: handleHide,
    onPin: handlePin,
    onResize: handleResize,
    onSort: handleSort,
    onSortToggle: handleSortToggle,
    resetSize: handleResetSize,
    scrollToIndex,
    setRowActiveIndex,
    setColumnSizing,
    sortDirection,
    tooltip,
    width
  } = props;
  const [ref, setRef] = React__default.useState(null);
  useSetInitialColumnSizing(id2, defaultWidth, width, ref, canMeasureSize, setColumnSizing);
  const style = {};
  if (colSpan > 1) {
    style.gridColumn = `span ${colSpan}`;
  }
  if (isPinned) {
    style[isPinned] = `${offset2}px`;
  }
  return /* @__PURE__ */ React__default.createElement(
    "th",
    {
      ...getSortAttributes(canSort, handleSort, sortDirection),
      className,
      "data-cell-align": isGroup2 ? "center" : align,
      "data-cell-id": id2,
      "data-cell-pinned": isPinned ? isPinned : void 0,
      "data-taco": isGroup2 ? "grouped-column-header" : "column-header",
      style,
      ref: setRef
    },
    !isPlaceholder ? /* @__PURE__ */ React__default.createElement(HeaderContent, { children, tooltip, isInternalColumnHeader: !!isInternalColumn(id2) }) : null,
    sortDirection ? /* @__PURE__ */ React__default.createElement(SortIndicator, { direction: sortDirection }) : null,
    hasMenu ? /* @__PURE__ */ React__default.createElement(
      HeaderMenu,
      {
        canFilter,
        canGoto,
        canHide,
        canPin,
        canSort,
        className: clsx({
          "ml-auto": align !== "right",
          "ml-0": align === "right"
        }),
        customMenu,
        index: index2,
        isFiltered,
        onFilter: handleFilter,
        onGoto: handleGoto,
        onHide: handleHide,
        onPin: handlePin,
        onSortToggle: handleSortToggle,
        scrollToIndex,
        setRowActiveIndex,
        sortDirection,
        columnId: id2
      }
    ) : null,
    canResize ? /* @__PURE__ */ React__default.createElement(
      Resizer,
      {
        headerRef: ref,
        id: id2,
        isResizing,
        onResize: handleResize,
        onResetSize: handleResetSize,
        setColumnSizing,
        width
      }
    ) : null
  );
});
const FOCUS_MANAGER_OPTIONS_TAB = {
  accept: (element) => !!element.closest('tr[data-row-active="true"]'),
  tabbable: true
};
const FOCUS_MANAGER_OPTIONS_ARROW_KEYS = {
  accept: (element) => {
    const acceptTabbable = isElementInteractive(element) ? element.getAttribute("tabindex") !== "-1" : true;
    return !!element.closest('tr[data-row-active="true"]') && !hasFocusableElement(element) && acceptTabbable;
  }
};
function useAugmentedFocusManager() {
  const focusManager = $9bf71ea28793e738$export$10c5169755ce7bd7();
  const focusPrevious = (arrowNavigation = false) => focusManager == null ? void 0 : focusManager.focusPrevious(arrowNavigation ? FOCUS_MANAGER_OPTIONS_ARROW_KEYS : FOCUS_MANAGER_OPTIONS_TAB);
  const focusNext = (arrowNavigation = false) => focusManager == null ? void 0 : focusManager.focusNext(arrowNavigation ? FOCUS_MANAGER_OPTIONS_ARROW_KEYS : FOCUS_MANAGER_OPTIONS_TAB);
  const focusFirst = () => focusManager == null ? void 0 : focusManager.focusFirst(FOCUS_MANAGER_OPTIONS_TAB);
  const focusLast = () => focusManager == null ? void 0 : focusManager.focusLast(FOCUS_MANAGER_OPTIONS_TAB);
  return {
    focusPrevious,
    focusNext,
    focusFirst,
    focusLast
  };
}
function Body(props) {
  const { enableHorizontalArrowKeyNavigation = false, scrollToIndex, table, tableElement, ...attributes } = props;
  const ref = React__default.useRef(null);
  const focusManager = useAugmentedFocusManager();
  const tableMeta = table.options.meta;
  const handleKeyDown = (event) => {
    if (event.isDefaultPrevented() || event.isPropagationStopped()) {
      return;
    }
    if (tableMeta.rowActive.rowActiveIndex !== void 0) {
      const isFirstRow = tableMeta.rowActive.rowActiveIndex === 0;
      const isLastRow = tableMeta.rowActive.rowActiveIndex === tableMeta.length - 1;
      if (event.key === "Tab" || enableHorizontalArrowKeyNavigation && (event.key === "ArrowLeft" || event.key === "ArrowRight")) {
        if (event.key === "Tab" && !hasFocusableElement(event.target.closest("tr[data-row-id]"))) {
          return;
        }
        tableMeta.rowActive.setHoverStatePaused(true);
        const isMetaKeyPressed = isPressingMetaKey(event);
        let focusedElement;
        switch (event.key) {
          case "ArrowLeft":
            focusedElement = isMetaKeyPressed ? focusManager.focusFirst() : focusManager.focusPrevious(true);
            break;
          case "ArrowRight":
            focusedElement = isMetaKeyPressed ? focusManager.focusLast() : focusManager.focusNext(true);
            if (isMetaKeyPressed && tableElement) {
              tableElement.scrollLeft = tableElement.scrollWidth;
            }
            break;
          default:
            focusedElement = event.shiftKey ? focusManager.focusPrevious() : focusManager.focusNext();
            break;
        }
        if (focusedElement) {
          event.preventDefault();
          return;
        }
        if (event.shiftKey || event.key === "ArrowLeft") {
          if (!isFirstRow) {
            event.preventDefault();
            const prevIndex = tableMeta.rowActive.rowActiveIndex - 1;
            tableMeta.rowActive.setRowActiveIndex(prevIndex);
            requestAnimationFrame(() => {
              focusManager.focusLast();
              scrollToIndex(prevIndex);
            });
          }
        } else {
          if (!isLastRow) {
            event.preventDefault();
            const nextIndex = tableMeta.rowActive.rowActiveIndex + 1;
            tableMeta.rowActive.setRowActiveIndex(nextIndex);
            requestAnimationFrame(() => {
              focusManager.focusFirst();
              scrollToIndex(nextIndex);
            });
          }
        }
      }
    }
  };
  const handleMouseMove = React__default.useCallback(
    (event) => {
      var _a, _b;
      if (!(event.target instanceof HTMLElement)) {
        return;
      }
      const currentTable = (_a = ref.current) == null ? void 0 : _a.closest("table");
      const targetTable = event.target.closest("table");
      if (targetTable !== currentTable) {
        return;
      }
      const rowIndex = (_b = event.target.closest("tr[data-row-id]")) == null ? void 0 : _b.getAttribute("data-row-index");
      if (!rowIndex) {
        tableMeta.rowActive.setRowHoverIndex(void 0);
        return;
      }
      tableMeta.rowActive.setRowHoverIndex(Number(rowIndex));
    },
    [ref]
  );
  const handleMouseLeave = React__default.useCallback(() => tableMeta.rowActive.setRowHoverIndex(void 0), []);
  return /* @__PURE__ */ React__default.createElement(
    "tbody",
    {
      ...attributes,
      onKeyDown: handleKeyDown,
      onMouseLeave: handleMouseLeave,
      onMouseMove: handleMouseMove,
      onFocus: (e3) => e3.stopPropagation(),
      ref
    }
  );
}
function Summary(props) {
  var _a;
  const { table } = props;
  const { locale: locale2, texts } = useLocalization();
  const tableMeta = table.options.meta;
  const length = tableMeta.length;
  const currentLength = table.getRowModel().rows.length;
  let label;
  let count2;
  const rowsSelectedLength = Object.keys(table.getState().rowSelection).length;
  if (rowsSelectedLength > 0) {
    label = texts.table.footer.summary.selected;
    count2 = /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("strong", null, new Intl.NumberFormat(locale2).format(rowsSelectedLength)), " ", texts.table.footer.summary.count, " ", /* @__PURE__ */ React__default.createElement("strong", null, new Intl.NumberFormat(locale2).format(length)));
  } else if (!tableMeta.server.isEnabled && (((_a = table.getState().columnFilters) == null ? void 0 : _a.length) || // filtered data
  !!table.getState().globalFilter && table.options.enableGlobalFilter)) {
    label = texts.table.footer.summary.records;
    count2 = /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("strong", null, new Intl.NumberFormat(locale2).format(currentLength)), " ", texts.table.footer.summary.count, " ", /* @__PURE__ */ React__default.createElement("strong", null, new Intl.NumberFormat(locale2).format(length)));
  } else {
    label = texts.table.footer.summary.records;
    count2 = /* @__PURE__ */ React__default.createElement("strong", null, new Intl.NumberFormat(locale2).format(length));
  }
  return /* @__PURE__ */ React__default.createElement(
    "div",
    {
      className: "sticky left-0 z-20 flex h-full w-fit items-center whitespace-nowrap bg-white pr-1 shadow-[12px_0px_6px_white]",
      "data-taco": "table-footer-summary"
    },
    label,
    " ",
    count2
  );
}
function Foot(props) {
  var _a;
  const { children, table, ...attributes } = props;
  const tableMeta = table.options.meta;
  const nonGroupedHeaders = table.getFooterGroups()[0].headers.filter((header) => !header.column.getIsGrouped());
  const firstVisibleExternalColumnIndex = (_a = nonGroupedHeaders.find(
    (header) => {
      var _a2;
      return !isInternalColumn(header.id) && ((_a2 = header.column.columnDef.meta) == null ? void 0 : _a2.enablePrinting) !== false;
    }
  )) == null ? void 0 : _a.index;
  const summaryColumnIndex = tableMeta.printing.isPrinting ? firstVisibleExternalColumnIndex : 0;
  return /* @__PURE__ */ React__default.createElement("tfoot", { ...attributes }, children, /* @__PURE__ */ React__default.createElement("tr", null, nonGroupedHeaders.map((header, index2) => /* @__PURE__ */ React__default.createElement(Footer, { key: header.id, header, showSummary: index2 === summaryColumnIndex }))));
}
function Footer(props) {
  return /* @__PURE__ */ React__default.createElement(MemoedFooter, { footer: props.header, showSummary: props.showSummary });
}
const MemoedFooter = React__default.memo(function MemoedFooter2(props) {
  var _a, _b;
  const { footer, showSummary } = props;
  const columnMeta = footer.column.columnDef.meta;
  const isHeaderGroup = !!((_a = footer.subHeaders) == null ? void 0 : _a.length);
  const isPinned = isHeaderGroup ? (_b = footer.subHeaders.find((x3) => x3.column.getIsPinned())) == null ? void 0 : _b.column.getIsPinned() : footer.column.getIsPinned();
  const style = {};
  if (isPinned) {
    style[isPinned] = `${footer.column.getStart(isPinned)}px`;
  }
  let content;
  let align;
  if (showSummary) {
    align = "left";
    content = /* @__PURE__ */ React__default.createElement(Summary, { table: footer.getContext().table });
  } else {
    align = columnMeta.align;
    content = footer.isPlaceholder ? null : flexRender(footer.column.columnDef.footer, footer.getContext());
  }
  return /* @__PURE__ */ React__default.createElement(
    "td",
    {
      key: footer.id,
      "data-cell-align": align,
      "data-cell-id": footer.id,
      "data-cell-pinned": isPinned ? isPinned : void 0,
      style
    },
    content
  );
});
function EmptyStateBody(props) {
  var _a, _b;
  const { emptyState: Placeholder2, isReady, reason, ...attributes } = props;
  const ref = React__default.useRef(null);
  if (!isReady) {
    return /* @__PURE__ */ React__default.createElement("tbody", { ...attributes, className: "!auto-rows-fr" });
  }
  return /* @__PURE__ */ React__default.createElement("tbody", { ...attributes, ref, className: "!auto-rows-fr", "data-taco": "empty-state" }, /* @__PURE__ */ React__default.createElement("tr", { className: "!auto-rows-fr " }, /* @__PURE__ */ React__default.createElement(
    "td",
    {
      style: { maxWidth: (_b = (_a = ref == null ? void 0 : ref.current) == null ? void 0 : _a.parentNode) == null ? void 0 : _b.clientWidth },
      className: "col-span-full !border-0 !p-0 hover:!bg-white"
    },
    Placeholder2 ? /* @__PURE__ */ React__default.createElement(Placeholder2, { reason }) : void 0
  )));
}
const SearchInput22 = React__default.forwardRef(function SearchInput222(props, ref) {
  const {
    findCurrent,
    findTotal,
    loading = false,
    onChange: handleChange,
    onClear,
    onClickFindNext: handleClickFindNext,
    onClickFindPrevious: handleClickFindPrevious,
    settingsContent,
    shortcut: shortcut2,
    showTotal = true,
    value,
    ...attributes
  } = props;
  const internalRef = useMergedRef(ref);
  const containerRef = React__default.useRef(null);
  const [focused, setFocused] = React__default.useState(false);
  const { texts } = useLocalization();
  const isActive = value == null ? void 0 : value.length;
  const hasFind = handleClickFindNext !== void 0 && handleClickFindPrevious !== void 0 && findCurrent !== void 0 && findTotal !== void 0;
  useGlobalKeyDown(shortcut2, (event) => {
    var _a;
    if (document.activeElement !== internalRef.current) {
      event.preventDefault();
      (_a = internalRef.current) == null ? void 0 : _a.focus();
    }
  });
  const handleBlur = (event) => {
    var _a, _b;
    if (containerRef.current && (containerRef.current === event.relatedTarget || ((_a = containerRef.current) == null ? void 0 : _a.contains(event.relatedTarget)))) {
      return;
    }
    setFocused(false);
    (_b = attributes.onBlur) == null ? void 0 : _b.call(attributes, event);
  };
  const handleClear = () => {
    requestAnimationFrame(() => {
      var _a;
      return (_a = internalRef.current) == null ? void 0 : _a.blur();
    });
    handleChange("");
    onClear == null ? void 0 : onClear();
  };
  const handleFocus = (event) => {
    var _a;
    setFocused(true);
    (_a = attributes.onFocus) == null ? void 0 : _a.call(attributes, event);
  };
  const handleKeyDown = (event) => {
    var _a;
    (_a = props.onKeyDown) == null ? void 0 : _a.call(props, event);
    if (event.isDefaultPrevented()) {
      return;
    }
    if (event.key === "Enter") {
      event.preventDefault();
      if (hasFind && isActive) {
        if (event.shiftKey) {
          handleClickFindPrevious == null ? void 0 : handleClickFindPrevious();
        } else {
          handleClickFindNext == null ? void 0 : handleClickFindNext();
        }
      }
      return;
    }
    if (event.key === "Escape") {
      handleClear();
      event.stopPropagation();
      return;
    }
  };
  let postfix;
  if (!attributes.disabled && !attributes.readOnly && (value || focused)) {
    if (value) {
      postfix = /* @__PURE__ */ React__default.createElement(
        IconButton,
        {
          "aria-label": texts.searchInput.clear,
          className: "scale-75 !bg-transparent hover:!bg-black/[0.08] [&>svg]:scale-125",
          icon: "close",
          onMouseDown: handleClear,
          tabIndex: -1,
          tooltip: focused ? /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, texts.searchInput.clear, " ", /* @__PURE__ */ React__default.createElement(Shortcut, { keys: "Escape" })) : texts.searchInput.clear
        }
      );
    }
    if (hasFind && isActive) {
      postfix = /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("span", { className: "text-grey-700 flex h-4 items-center" }, loading ? /* @__PURE__ */ React__default.createElement(Spinner, { className: "h-4 w-4" }) : showTotal ? /* @__PURE__ */ React__default.createElement("span", { className: "border-r border-black/[0.25] pr-2" }, `${findCurrent ?? 0}/${findTotal ?? 0}`) : null), findCurrent ? /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(
        IconButton,
        {
          "aria-label": texts.searchInput.findPrevious,
          className: "scale-75 !bg-transparent hover:!bg-black/[0.08] [&>svg]:scale-125",
          icon: "chevron-up",
          onMouseDown: handleClickFindPrevious,
          tabIndex: -1,
          tooltip: focused ? /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, texts.searchInput.findPrevious, " ", /* @__PURE__ */ React__default.createElement(Shortcut, { keys: { shift: true, key: "Enter" } })) : texts.searchInput.findPrevious
        }
      ), /* @__PURE__ */ React__default.createElement(
        IconButton,
        {
          "aria-label": texts.searchInput.findNext,
          className: "scale-75 !bg-transparent hover:!bg-black/[0.08] [&>svg]:scale-125",
          icon: "chevron-down",
          onMouseDown: handleClickFindNext,
          tabIndex: -1,
          tooltip: focused ? /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, texts.searchInput.findNext, " ", /* @__PURE__ */ React__default.createElement(Shortcut, { keys: "Enter" })) : texts.searchInput.findNext
        }
      )) : null, postfix);
    }
  } else if (shortcut2 && !focused && !value) {
    postfix = /* @__PURE__ */ React__default.createElement(Shortcut, { keys: shortcut2, onClickCapture: () => {
      var _a;
      return (_a = internalRef.current) == null ? void 0 : _a.focus();
    } });
  }
  const className = clsx(
    "!pl-7 group-focus-within:!w-72 group-focus-within:yt-focus",
    hasFind ? {
      "!w-48": !value,
      "!w-72": value
    } : "!w-48",
    {
      "!wcag-blue-100": isActive
    },
    props.className
  );
  const icon = /* @__PURE__ */ React__default.createElement(
    Icon$1,
    {
      "aria-label": texts.searchInput.button,
      className: "-ml-0.5 scale-95",
      name: "search",
      onClickCapture: () => {
        var _a;
        return (_a = internalRef.current) == null ? void 0 : _a.focus();
      }
    }
  );
  const input = /* @__PURE__ */ React__default.createElement(
    Input,
    {
      ...attributes,
      "aria-label": attributes["aria-label"] ?? texts.searchInput.placeholder,
      className,
      "data-taco": "search-input2",
      onBlur: handleBlur,
      onChange: (event) => handleChange(event.target.value),
      onFocus: handleFocus,
      onKeyDown: handleKeyDown,
      placeholder: attributes.placeholder ?? texts.searchInput.placeholder,
      prefix: icon,
      postfix,
      ref: internalRef,
      value: value ?? ""
    }
  );
  if (settingsContent) {
    const settingsClassname = clsx(
      "border-grey-300 absolute left-0 right-0 -mt-0.5 hidden top-full group-focus-within:flex focus-within:flex flex-col gap-y-4 rounded-b border border-t-0 bg-white p-3 shadow !pt-[calc(theme(spacing.3)_+_theme(spacing[0.5]))]"
    );
    return /* @__PURE__ */ React__default.createElement(
      "div",
      {
        className: clsx("group relative", { "z-10 [&_[data-taco=input-container]]:z-10": focused }),
        ref: containerRef,
        style: { opacity: 0.999 }
      },
      input,
      /* @__PURE__ */ React__default.createElement(
        "div",
        {
          onBlur: handleBlur,
          className: settingsClassname,
          onClickCapture: () => {
            var _a;
            return (_a = internalRef.current) == null ? void 0 : _a.focus();
          },
          tabIndex: -1
        },
        settingsContent
      )
    );
  }
  return input;
});
function Search$1(props) {
  var _a;
  const { scrollToIndex, table, tableRef } = props;
  const { texts } = useLocalization();
  const ref = React__default.useRef(null);
  const lastResultQuery = React__default.useRef();
  const tableMeta = table.options.meta;
  const query = table.getState().globalFilter;
  const scrollTo2 = (rowIndex) => scrollToIndex(rowIndex, { align: "center" });
  const hiddenColumns = getHiddenColumns(table.getState().columnVisibility);
  React__default.useEffect(() => {
    if (!tableMeta.server._experimentalDataLoader2 && tableMeta.search.highlightedColumnIndexes.length) {
      scrollTo2(tableMeta.search.highlightedColumnIndexes[0][0]);
    }
  }, [tableMeta.search.highlightedColumnIndexes.length]);
  React__default.useEffect(() => {
    if (tableMeta.server._experimentalDataLoader2 && tableMeta.search.highlightedColumnIndexes.length) {
      if (query !== lastResultQuery.current) {
        lastResultQuery.current = query;
        scrollTo2(tableMeta.search.highlightedColumnIndexes[0][0]);
      }
    }
  }, [tableMeta.search.highlightedColumnIndexes.length, query]);
  const handleFocus = async () => {
    if (tableMeta.server.loadAllIfNeeded && !tableMeta.server._experimentalDataLoader2) {
      await tableMeta.server.loadAllIfNeeded(
        table.getState().sorting,
        table.getState().columnFilters,
        hiddenColumns,
        // the old data loader doesn't have server side search
        void 0
      );
    }
  };
  const [loading, setLoading] = React__default.useState(false);
  const searchTimeoutRef = React__default.useRef();
  const handleChange = (query2) => {
    table.setGlobalFilter(String(query2 ?? ""));
    if (tableMeta.search.enableGlobalFilter && tableMeta.search.handleSearch) {
      clearTimeout(searchTimeoutRef.current);
      searchTimeoutRef.current = setTimeout(() => {
        var _a2, _b;
        setLoading(true);
        (_b = (_a2 = tableMeta.search).handleSearch) == null ? void 0 : _b.call(_a2, query2, hiddenColumns).then(() => {
          setLoading(false);
        });
      }, 150);
    }
  };
  const handleToggleExcludeUnmatchedResults = (enabled) => {
    tableMeta.search.setEnableGlobalFilter(enabled, table);
    requestAnimationFrame(() => {
      var _a2;
      return (_a2 = ref.current) == null ? void 0 : _a2.focus();
    });
    if (tableMeta.search.handleSearch) {
      setLoading(true);
      tableMeta.search.handleSearch(enabled ? query : void 0, hiddenColumns).then(() => {
        setLoading(false);
      });
    }
  };
  const handleNextResult = () => {
    if (!tableMeta.search.highlightedColumnIndexes.length) {
      return;
    }
    const nextIndex = tableMeta.search.currentHighlightColumnIndex === void 0 || tableMeta.search.currentHighlightColumnIndex === tableMeta.search.highlightedColumnIndexes.length - 1 ? 0 : tableMeta.search.currentHighlightColumnIndex + 1;
    tableMeta.search.setCurrentHighlightColumnIndex(nextIndex);
    scrollTo2(tableMeta.search.highlightedColumnIndexes[nextIndex][0]);
  };
  const handlePreviousResult = () => {
    if (!tableMeta.search.highlightedColumnIndexes.length) {
      return;
    }
    const nextIndex = tableMeta.search.currentHighlightColumnIndex === void 0 ? 0 : tableMeta.search.currentHighlightColumnIndex === 0 ? tableMeta.search.highlightedColumnIndexes.length - 1 : tableMeta.search.currentHighlightColumnIndex - 1;
    tableMeta.search.setCurrentHighlightColumnIndex(nextIndex);
    scrollTo2(tableMeta.search.highlightedColumnIndexes[nextIndex][0]);
  };
  const settings = /* @__PURE__ */ React__default.createElement(
    Switch$1,
    {
      label: texts.table.search.excludeUnmatchedResults,
      checked: !!table.options.enableGlobalFilter,
      onChange: handleToggleExcludeUnmatchedResults
    }
  );
  const handleKeyDown = (event) => {
    if (event.key === "Escape" && tableMeta.search.currentHighlightColumnIndex !== void 0) {
      const [rowIndex, cellIndex] = tableMeta.search.highlightedColumnIndexes[tableMeta.search.currentHighlightColumnIndex];
      if (rowIndex !== void 0 && cellIndex !== void 0) {
        tableMeta.rowActive.setRowActiveIndex(rowIndex);
        requestAnimationFrame(() => {
          var _a2, _b;
          const cell = (_a2 = tableRef.current) == null ? void 0 : _a2.querySelector(
            `tbody > tr[data-row-index="${rowIndex}"] > td[data-cell-index="${cellIndex}"]`
          );
          if (cell) {
            (_b = cell.focus) == null ? void 0 : _b.call(cell);
          }
        });
      }
    }
  };
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(
    SearchInput22,
    {
      findCurrent: tableMeta.search.currentHighlightColumnIndex !== void 0 ? tableMeta.search.currentHighlightColumnIndex + 1 : null,
      findTotal: ((_a = tableMeta.search.highlightedColumnIndexes) == null ? void 0 : _a.length) ?? null,
      loading: tableMeta.server._experimentalDataLoader2 ? loading : tableMeta.server.loading,
      name: "table-search",
      onClickFindPrevious: handlePreviousResult,
      onClickFindNext: handleNextResult,
      onChange: handleChange,
      onFocus: handleFocus,
      onKeyDown: handleKeyDown,
      placeholder: texts.table.search.placeholder,
      settingsContent: settings,
      ref,
      shortcut: { key: "f", meta: true, shift: false },
      showTotal: !tableMeta.server._experimentalDataLoader2,
      value: query
    }
  ));
}
function useCombinedRefs() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }
  return useMemo(
    () => (node) => {
      refs.forEach((ref) => ref(node));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    refs
  );
}
const canUseDOM$2 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
function isWindow(element) {
  const elementString = Object.prototype.toString.call(element);
  return elementString === "[object Window]" || // In Electron context the Window object serializes to [object global]
  elementString === "[object global]";
}
function isNode(node) {
  return "nodeType" in node;
}
function getWindow$1(target) {
  var _target$ownerDocument, _target$ownerDocument2;
  if (!target) {
    return window;
  }
  if (isWindow(target)) {
    return target;
  }
  if (!isNode(target)) {
    return window;
  }
  return (_target$ownerDocument = (_target$ownerDocument2 = target.ownerDocument) == null ? void 0 : _target$ownerDocument2.defaultView) != null ? _target$ownerDocument : window;
}
function isDocument(node) {
  const {
    Document: Document2
  } = getWindow$1(node);
  return node instanceof Document2;
}
function isHTMLElement(node) {
  if (isWindow(node)) {
    return false;
  }
  return node instanceof getWindow$1(node).HTMLElement;
}
function isSVGElement(node) {
  return node instanceof getWindow$1(node).SVGElement;
}
function getOwnerDocument(target) {
  if (!target) {
    return document;
  }
  if (isWindow(target)) {
    return target.document;
  }
  if (!isNode(target)) {
    return document;
  }
  if (isDocument(target)) {
    return target;
  }
  if (isHTMLElement(target) || isSVGElement(target)) {
    return target.ownerDocument;
  }
  return document;
}
const useIsomorphicLayoutEffect = canUseDOM$2 ? useLayoutEffect : useEffect;
function useEvent(handler) {
  const handlerRef = useRef(handler);
  useIsomorphicLayoutEffect(() => {
    handlerRef.current = handler;
  });
  return useCallback(function() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return handlerRef.current == null ? void 0 : handlerRef.current(...args);
  }, []);
}
function useInterval() {
  const intervalRef = useRef(null);
  const set2 = useCallback((listener, duration) => {
    intervalRef.current = setInterval(listener, duration);
  }, []);
  const clear = useCallback(() => {
    if (intervalRef.current !== null) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  }, []);
  return [set2, clear];
}
function useLatestValue(value, dependencies) {
  if (dependencies === void 0) {
    dependencies = [value];
  }
  const valueRef = useRef(value);
  useIsomorphicLayoutEffect(() => {
    if (valueRef.current !== value) {
      valueRef.current = value;
    }
  }, dependencies);
  return valueRef;
}
function useLazyMemo(callback, dependencies) {
  const valueRef = useRef();
  return useMemo(
    () => {
      const newValue = callback(valueRef.current);
      valueRef.current = newValue;
      return newValue;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [...dependencies]
  );
}
function useNodeRef(onChange) {
  const onChangeHandler = useEvent(onChange);
  const node = useRef(null);
  const setNodeRef = useCallback(
    (element) => {
      if (element !== node.current) {
        onChangeHandler == null ? void 0 : onChangeHandler(element, node.current);
      }
      node.current = element;
    },
    //eslint-disable-next-line
    []
  );
  return [node, setNodeRef];
}
function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}
let ids = {};
function useUniqueId(prefix2, value) {
  return useMemo(() => {
    if (value) {
      return value;
    }
    const id2 = ids[prefix2] == null ? 0 : ids[prefix2] + 1;
    ids[prefix2] = id2;
    return prefix2 + "-" + id2;
  }, [prefix2, value]);
}
function createAdjustmentFn(modifier) {
  return function(object2) {
    for (var _len = arguments.length, adjustments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      adjustments[_key - 1] = arguments[_key];
    }
    return adjustments.reduce((accumulator, adjustment) => {
      const entries = Object.entries(adjustment);
      for (const [key, valueAdjustment] of entries) {
        const value = accumulator[key];
        if (value != null) {
          accumulator[key] = value + modifier * valueAdjustment;
        }
      }
      return accumulator;
    }, {
      ...object2
    });
  };
}
const add$1 = /* @__PURE__ */ createAdjustmentFn(1);
const subtract$1 = /* @__PURE__ */ createAdjustmentFn(-1);
function hasViewportRelativeCoordinates(event) {
  return "clientX" in event && "clientY" in event;
}
function isKeyboardEvent(event) {
  if (!event) {
    return false;
  }
  const {
    KeyboardEvent: KeyboardEvent2
  } = getWindow$1(event.target);
  return KeyboardEvent2 && event instanceof KeyboardEvent2;
}
function isTouchEvent(event) {
  if (!event) {
    return false;
  }
  const {
    TouchEvent
  } = getWindow$1(event.target);
  return TouchEvent && event instanceof TouchEvent;
}
function getEventCoordinates(event) {
  if (isTouchEvent(event)) {
    if (event.touches && event.touches.length) {
      const {
        clientX: x3,
        clientY: y4
      } = event.touches[0];
      return {
        x: x3,
        y: y4
      };
    } else if (event.changedTouches && event.changedTouches.length) {
      const {
        clientX: x3,
        clientY: y4
      } = event.changedTouches[0];
      return {
        x: x3,
        y: y4
      };
    }
  }
  if (hasViewportRelativeCoordinates(event)) {
    return {
      x: event.clientX,
      y: event.clientY
    };
  }
  return null;
}
const CSS$1 = /* @__PURE__ */ Object.freeze({
  Translate: {
    toString(transform) {
      if (!transform) {
        return;
      }
      const {
        x: x3,
        y: y4
      } = transform;
      return "translate3d(" + (x3 ? Math.round(x3) : 0) + "px, " + (y4 ? Math.round(y4) : 0) + "px, 0)";
    }
  },
  Scale: {
    toString(transform) {
      if (!transform) {
        return;
      }
      const {
        scaleX,
        scaleY
      } = transform;
      return "scaleX(" + scaleX + ") scaleY(" + scaleY + ")";
    }
  },
  Transform: {
    toString(transform) {
      if (!transform) {
        return;
      }
      return [CSS$1.Translate.toString(transform), CSS$1.Scale.toString(transform)].join(" ");
    }
  },
  Transition: {
    toString(_ref) {
      let {
        property,
        duration,
        easing
      } = _ref;
      return property + " " + duration + "ms " + easing;
    }
  }
});
const SELECTOR = "a,frame,iframe,input:not([type=hidden]):not(:disabled),select:not(:disabled),textarea:not(:disabled),button:not(:disabled),*[tabindex]";
function findFirstFocusableNode(element) {
  if (element.matches(SELECTOR)) {
    return element;
  }
  return element.querySelector(SELECTOR);
}
const hiddenStyles = {
  display: "none"
};
function HiddenText(_ref) {
  let {
    id: id2,
    value
  } = _ref;
  return React__default.createElement("div", {
    id: id2,
    style: hiddenStyles
  }, value);
}
function LiveRegion(_ref) {
  let {
    id: id2,
    announcement,
    ariaLiveType = "assertive"
  } = _ref;
  const visuallyHidden = {
    position: "fixed",
    top: 0,
    left: 0,
    width: 1,
    height: 1,
    margin: -1,
    border: 0,
    padding: 0,
    overflow: "hidden",
    clip: "rect(0 0 0 0)",
    clipPath: "inset(100%)",
    whiteSpace: "nowrap"
  };
  return React__default.createElement("div", {
    id: id2,
    style: visuallyHidden,
    role: "status",
    "aria-live": ariaLiveType,
    "aria-atomic": true
  }, announcement);
}
function useAnnouncement() {
  const [announcement, setAnnouncement] = useState("");
  const announce = useCallback((value) => {
    if (value != null) {
      setAnnouncement(value);
    }
  }, []);
  return {
    announce,
    announcement
  };
}
const DndMonitorContext = /* @__PURE__ */ createContext(null);
function useDndMonitor(listener) {
  const registerListener = useContext(DndMonitorContext);
  useEffect(() => {
    if (!registerListener) {
      throw new Error("useDndMonitor must be used within a children of <DndContext>");
    }
    const unsubscribe = registerListener(listener);
    return unsubscribe;
  }, [listener, registerListener]);
}
function useDndMonitorProvider() {
  const [listeners] = useState(() => /* @__PURE__ */ new Set());
  const registerListener = useCallback((listener) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  }, [listeners]);
  const dispatch = useCallback((_ref) => {
    let {
      type,
      event
    } = _ref;
    listeners.forEach((listener) => {
      var _listener$type;
      return (_listener$type = listener[type]) == null ? void 0 : _listener$type.call(listener, event);
    });
  }, [listeners]);
  return [dispatch, registerListener];
}
const defaultScreenReaderInstructions = {
  draggable: "\n    To pick up a draggable item, press the space bar.\n    While dragging, use the arrow keys to move the item.\n    Press space again to drop the item in its new position, or press escape to cancel.\n  "
};
const defaultAnnouncements = {
  onDragStart(_ref) {
    let {
      active
    } = _ref;
    return "Picked up draggable item " + active.id + ".";
  },
  onDragOver(_ref2) {
    let {
      active,
      over
    } = _ref2;
    if (over) {
      return "Draggable item " + active.id + " was moved over droppable area " + over.id + ".";
    }
    return "Draggable item " + active.id + " is no longer over a droppable area.";
  },
  onDragEnd(_ref3) {
    let {
      active,
      over
    } = _ref3;
    if (over) {
      return "Draggable item " + active.id + " was dropped over droppable area " + over.id;
    }
    return "Draggable item " + active.id + " was dropped.";
  },
  onDragCancel(_ref4) {
    let {
      active
    } = _ref4;
    return "Dragging was cancelled. Draggable item " + active.id + " was dropped.";
  }
};
function Accessibility(_ref) {
  let {
    announcements = defaultAnnouncements,
    container,
    hiddenTextDescribedById,
    screenReaderInstructions = defaultScreenReaderInstructions
  } = _ref;
  const {
    announce,
    announcement
  } = useAnnouncement();
  const liveRegionId = useUniqueId("DndLiveRegion");
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);
  useDndMonitor(useMemo(() => ({
    onDragStart(_ref2) {
      let {
        active
      } = _ref2;
      announce(announcements.onDragStart({
        active
      }));
    },
    onDragMove(_ref3) {
      let {
        active,
        over
      } = _ref3;
      if (announcements.onDragMove) {
        announce(announcements.onDragMove({
          active,
          over
        }));
      }
    },
    onDragOver(_ref4) {
      let {
        active,
        over
      } = _ref4;
      announce(announcements.onDragOver({
        active,
        over
      }));
    },
    onDragEnd(_ref5) {
      let {
        active,
        over
      } = _ref5;
      announce(announcements.onDragEnd({
        active,
        over
      }));
    },
    onDragCancel(_ref6) {
      let {
        active,
        over
      } = _ref6;
      announce(announcements.onDragCancel({
        active,
        over
      }));
    }
  }), [announce, announcements]));
  if (!mounted) {
    return null;
  }
  const markup = React__default.createElement(React__default.Fragment, null, React__default.createElement(HiddenText, {
    id: hiddenTextDescribedById,
    value: screenReaderInstructions.draggable
  }), React__default.createElement(LiveRegion, {
    id: liveRegionId,
    announcement
  }));
  return container ? createPortal(markup, container) : markup;
}
var Action;
(function(Action2) {
  Action2["DragStart"] = "dragStart";
  Action2["DragMove"] = "dragMove";
  Action2["DragEnd"] = "dragEnd";
  Action2["DragCancel"] = "dragCancel";
  Action2["DragOver"] = "dragOver";
  Action2["RegisterDroppable"] = "registerDroppable";
  Action2["SetDroppableDisabled"] = "setDroppableDisabled";
  Action2["UnregisterDroppable"] = "unregisterDroppable";
})(Action || (Action = {}));
function noop$3() {
}
const defaultCoordinates = /* @__PURE__ */ Object.freeze({
  x: 0,
  y: 0
});
function distanceBetween(p1, p2) {
  return Math.sqrt(Math.pow(p1.x - p2.x, 2) + Math.pow(p1.y - p2.y, 2));
}
function sortCollisionsAsc(_ref, _ref2) {
  let {
    data: {
      value: a4
    }
  } = _ref;
  let {
    data: {
      value: b3
    }
  } = _ref2;
  return a4 - b3;
}
function sortCollisionsDesc(_ref3, _ref4) {
  let {
    data: {
      value: a4
    }
  } = _ref3;
  let {
    data: {
      value: b3
    }
  } = _ref4;
  return b3 - a4;
}
function getFirstCollision(collisions, property) {
  if (!collisions || collisions.length === 0) {
    return null;
  }
  const [firstCollision] = collisions;
  return firstCollision[property];
}
function centerOfRectangle(rect, left, top) {
  if (left === void 0) {
    left = rect.left;
  }
  if (top === void 0) {
    top = rect.top;
  }
  return {
    x: left + rect.width * 0.5,
    y: top + rect.height * 0.5
  };
}
const closestCenter = (_ref) => {
  let {
    collisionRect,
    droppableRects,
    droppableContainers
  } = _ref;
  const centerRect = centerOfRectangle(collisionRect, collisionRect.left, collisionRect.top);
  const collisions = [];
  for (const droppableContainer of droppableContainers) {
    const {
      id: id2
    } = droppableContainer;
    const rect = droppableRects.get(id2);
    if (rect) {
      const distBetween = distanceBetween(centerOfRectangle(rect), centerRect);
      collisions.push({
        id: id2,
        data: {
          droppableContainer,
          value: distBetween
        }
      });
    }
  }
  return collisions.sort(sortCollisionsAsc);
};
function getIntersectionRatio(entry, target) {
  const top = Math.max(target.top, entry.top);
  const left = Math.max(target.left, entry.left);
  const right = Math.min(target.left + target.width, entry.left + entry.width);
  const bottom = Math.min(target.top + target.height, entry.top + entry.height);
  const width = right - left;
  const height = bottom - top;
  if (left < right && top < bottom) {
    const targetArea = target.width * target.height;
    const entryArea = entry.width * entry.height;
    const intersectionArea = width * height;
    const intersectionRatio = intersectionArea / (targetArea + entryArea - intersectionArea);
    return Number(intersectionRatio.toFixed(4));
  }
  return 0;
}
const rectIntersection = (_ref) => {
  let {
    collisionRect,
    droppableRects,
    droppableContainers
  } = _ref;
  const collisions = [];
  for (const droppableContainer of droppableContainers) {
    const {
      id: id2
    } = droppableContainer;
    const rect = droppableRects.get(id2);
    if (rect) {
      const intersectionRatio = getIntersectionRatio(rect, collisionRect);
      if (intersectionRatio > 0) {
        collisions.push({
          id: id2,
          data: {
            droppableContainer,
            value: intersectionRatio
          }
        });
      }
    }
  }
  return collisions.sort(sortCollisionsDesc);
};
function adjustScale(transform, rect1, rect2) {
  return {
    ...transform,
    scaleX: rect1 && rect2 ? rect1.width / rect2.width : 1,
    scaleY: rect1 && rect2 ? rect1.height / rect2.height : 1
  };
}
function getRectDelta(rect1, rect2) {
  return rect1 && rect2 ? {
    x: rect1.left - rect2.left,
    y: rect1.top - rect2.top
  } : defaultCoordinates;
}
function createRectAdjustmentFn(modifier) {
  return function adjustClientRect(rect) {
    for (var _len = arguments.length, adjustments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      adjustments[_key - 1] = arguments[_key];
    }
    return adjustments.reduce((acc, adjustment) => ({
      ...acc,
      top: acc.top + modifier * adjustment.y,
      bottom: acc.bottom + modifier * adjustment.y,
      left: acc.left + modifier * adjustment.x,
      right: acc.right + modifier * adjustment.x
    }), {
      ...rect
    });
  };
}
const getAdjustedRect = /* @__PURE__ */ createRectAdjustmentFn(1);
function parseTransform(transform) {
  if (transform.startsWith("matrix3d(")) {
    const transformArray = transform.slice(9, -1).split(/, /);
    return {
      x: +transformArray[12],
      y: +transformArray[13],
      scaleX: +transformArray[0],
      scaleY: +transformArray[5]
    };
  } else if (transform.startsWith("matrix(")) {
    const transformArray = transform.slice(7, -1).split(/, /);
    return {
      x: +transformArray[4],
      y: +transformArray[5],
      scaleX: +transformArray[0],
      scaleY: +transformArray[3]
    };
  }
  return null;
}
function inverseTransform(rect, transform, transformOrigin) {
  const parsedTransform = parseTransform(transform);
  if (!parsedTransform) {
    return rect;
  }
  const {
    scaleX,
    scaleY,
    x: translateX,
    y: translateY
  } = parsedTransform;
  const x3 = rect.left - translateX - (1 - scaleX) * parseFloat(transformOrigin);
  const y4 = rect.top - translateY - (1 - scaleY) * parseFloat(transformOrigin.slice(transformOrigin.indexOf(" ") + 1));
  const w3 = scaleX ? rect.width / scaleX : rect.width;
  const h4 = scaleY ? rect.height / scaleY : rect.height;
  return {
    width: w3,
    height: h4,
    top: y4,
    right: x3 + w3,
    bottom: y4 + h4,
    left: x3
  };
}
const defaultOptions$2 = {
  ignoreTransform: false
};
function getClientRect$2(element, options) {
  if (options === void 0) {
    options = defaultOptions$2;
  }
  let rect = element.getBoundingClientRect();
  if (options.ignoreTransform) {
    const {
      transform,
      transformOrigin
    } = getWindow$1(element).getComputedStyle(element);
    if (transform) {
      rect = inverseTransform(rect, transform, transformOrigin);
    }
  }
  const {
    top,
    left,
    width,
    height,
    bottom,
    right
  } = rect;
  return {
    top,
    left,
    width,
    height,
    bottom,
    right
  };
}
function getTransformAgnosticClientRect(element) {
  return getClientRect$2(element, {
    ignoreTransform: true
  });
}
function getWindowClientRect(element) {
  const width = element.innerWidth;
  const height = element.innerHeight;
  return {
    top: 0,
    left: 0,
    right: width,
    bottom: height,
    width,
    height
  };
}
function isFixed$1(node, computedStyle) {
  if (computedStyle === void 0) {
    computedStyle = getWindow$1(node).getComputedStyle(node);
  }
  return computedStyle.position === "fixed";
}
function isScrollable(element, computedStyle) {
  if (computedStyle === void 0) {
    computedStyle = getWindow$1(element).getComputedStyle(element);
  }
  const overflowRegex = /(auto|scroll|overlay)/;
  const properties2 = ["overflow", "overflowX", "overflowY"];
  return properties2.some((property) => {
    const value = computedStyle[property];
    return typeof value === "string" ? overflowRegex.test(value) : false;
  });
}
function getScrollableAncestors(element, limit) {
  const scrollParents = [];
  function findScrollableAncestors(node) {
    if (limit != null && scrollParents.length >= limit) {
      return scrollParents;
    }
    if (!node) {
      return scrollParents;
    }
    if (isDocument(node) && node.scrollingElement != null && !scrollParents.includes(node.scrollingElement)) {
      scrollParents.push(node.scrollingElement);
      return scrollParents;
    }
    if (!isHTMLElement(node) || isSVGElement(node)) {
      return scrollParents;
    }
    if (scrollParents.includes(node)) {
      return scrollParents;
    }
    const computedStyle = getWindow$1(element).getComputedStyle(node);
    if (node !== element) {
      if (isScrollable(node, computedStyle)) {
        scrollParents.push(node);
      }
    }
    if (isFixed$1(node, computedStyle)) {
      return scrollParents;
    }
    return findScrollableAncestors(node.parentNode);
  }
  if (!element) {
    return scrollParents;
  }
  return findScrollableAncestors(element);
}
function getFirstScrollableAncestor(node) {
  const [firstScrollableAncestor] = getScrollableAncestors(node, 1);
  return firstScrollableAncestor != null ? firstScrollableAncestor : null;
}
function getScrollableElement(element) {
  if (!canUseDOM$2 || !element) {
    return null;
  }
  if (isWindow(element)) {
    return element;
  }
  if (!isNode(element)) {
    return null;
  }
  if (isDocument(element) || element === getOwnerDocument(element).scrollingElement) {
    return window;
  }
  if (isHTMLElement(element)) {
    return element;
  }
  return null;
}
function getScrollXCoordinate(element) {
  if (isWindow(element)) {
    return element.scrollX;
  }
  return element.scrollLeft;
}
function getScrollYCoordinate(element) {
  if (isWindow(element)) {
    return element.scrollY;
  }
  return element.scrollTop;
}
function getScrollCoordinates(element) {
  return {
    x: getScrollXCoordinate(element),
    y: getScrollYCoordinate(element)
  };
}
var Direction;
(function(Direction2) {
  Direction2[Direction2["Forward"] = 1] = "Forward";
  Direction2[Direction2["Backward"] = -1] = "Backward";
})(Direction || (Direction = {}));
function isDocumentScrollingElement(element) {
  if (!canUseDOM$2 || !element) {
    return false;
  }
  return element === document.scrollingElement;
}
function getScrollPosition(scrollingContainer) {
  const minScroll = {
    x: 0,
    y: 0
  };
  const dimensions = isDocumentScrollingElement(scrollingContainer) ? {
    height: window.innerHeight,
    width: window.innerWidth
  } : {
    height: scrollingContainer.clientHeight,
    width: scrollingContainer.clientWidth
  };
  const maxScroll = {
    x: scrollingContainer.scrollWidth - dimensions.width,
    y: scrollingContainer.scrollHeight - dimensions.height
  };
  const isTop = scrollingContainer.scrollTop <= minScroll.y;
  const isLeft = scrollingContainer.scrollLeft <= minScroll.x;
  const isBottom = scrollingContainer.scrollTop >= maxScroll.y;
  const isRight = scrollingContainer.scrollLeft >= maxScroll.x;
  return {
    isTop,
    isLeft,
    isBottom,
    isRight,
    maxScroll,
    minScroll
  };
}
const defaultThreshold = {
  x: 0.2,
  y: 0.2
};
function getScrollDirectionAndSpeed(scrollContainer, scrollContainerRect, _ref, acceleration, thresholdPercentage) {
  let {
    top,
    left,
    right,
    bottom
  } = _ref;
  if (acceleration === void 0) {
    acceleration = 10;
  }
  if (thresholdPercentage === void 0) {
    thresholdPercentage = defaultThreshold;
  }
  const {
    isTop,
    isBottom,
    isLeft,
    isRight
  } = getScrollPosition(scrollContainer);
  const direction = {
    x: 0,
    y: 0
  };
  const speed = {
    x: 0,
    y: 0
  };
  const threshold2 = {
    height: scrollContainerRect.height * thresholdPercentage.y,
    width: scrollContainerRect.width * thresholdPercentage.x
  };
  if (!isTop && top <= scrollContainerRect.top + threshold2.height) {
    direction.y = Direction.Backward;
    speed.y = acceleration * Math.abs((scrollContainerRect.top + threshold2.height - top) / threshold2.height);
  } else if (!isBottom && bottom >= scrollContainerRect.bottom - threshold2.height) {
    direction.y = Direction.Forward;
    speed.y = acceleration * Math.abs((scrollContainerRect.bottom - threshold2.height - bottom) / threshold2.height);
  }
  if (!isRight && right >= scrollContainerRect.right - threshold2.width) {
    direction.x = Direction.Forward;
    speed.x = acceleration * Math.abs((scrollContainerRect.right - threshold2.width - right) / threshold2.width);
  } else if (!isLeft && left <= scrollContainerRect.left + threshold2.width) {
    direction.x = Direction.Backward;
    speed.x = acceleration * Math.abs((scrollContainerRect.left + threshold2.width - left) / threshold2.width);
  }
  return {
    direction,
    speed
  };
}
function getScrollElementRect(element) {
  if (element === document.scrollingElement) {
    const {
      innerWidth,
      innerHeight
    } = window;
    return {
      top: 0,
      left: 0,
      right: innerWidth,
      bottom: innerHeight,
      width: innerWidth,
      height: innerHeight
    };
  }
  const {
    top,
    left,
    right,
    bottom
  } = element.getBoundingClientRect();
  return {
    top,
    left,
    right,
    bottom,
    width: element.clientWidth,
    height: element.clientHeight
  };
}
function getScrollOffsets(scrollableAncestors) {
  return scrollableAncestors.reduce((acc, node) => {
    return add$1(acc, getScrollCoordinates(node));
  }, defaultCoordinates);
}
function getScrollXOffset(scrollableAncestors) {
  return scrollableAncestors.reduce((acc, node) => {
    return acc + getScrollXCoordinate(node);
  }, 0);
}
function getScrollYOffset(scrollableAncestors) {
  return scrollableAncestors.reduce((acc, node) => {
    return acc + getScrollYCoordinate(node);
  }, 0);
}
function scrollIntoViewIfNeeded(element, measure) {
  if (measure === void 0) {
    measure = getClientRect$2;
  }
  if (!element) {
    return;
  }
  const {
    top,
    left,
    bottom,
    right
  } = measure(element);
  const firstScrollableAncestor = getFirstScrollableAncestor(element);
  if (!firstScrollableAncestor) {
    return;
  }
  if (bottom <= 0 || right <= 0 || top >= window.innerHeight || left >= window.innerWidth) {
    element.scrollIntoView({
      block: "center",
      inline: "center"
    });
  }
}
const properties = [["x", ["left", "right"], getScrollXOffset], ["y", ["top", "bottom"], getScrollYOffset]];
class Rect {
  constructor(rect, element) {
    this.rect = void 0;
    this.width = void 0;
    this.height = void 0;
    this.top = void 0;
    this.bottom = void 0;
    this.right = void 0;
    this.left = void 0;
    const scrollableAncestors = getScrollableAncestors(element);
    const scrollOffsets = getScrollOffsets(scrollableAncestors);
    this.rect = {
      ...rect
    };
    this.width = rect.width;
    this.height = rect.height;
    for (const [axis, keys2, getScrollOffset] of properties) {
      for (const key of keys2) {
        Object.defineProperty(this, key, {
          get: () => {
            const currentOffsets = getScrollOffset(scrollableAncestors);
            const scrollOffsetsDeltla = scrollOffsets[axis] - currentOffsets;
            return this.rect[key] + scrollOffsetsDeltla;
          },
          enumerable: true
        });
      }
    }
    Object.defineProperty(this, "rect", {
      enumerable: false
    });
  }
}
class Listeners {
  constructor(target) {
    this.target = void 0;
    this.listeners = [];
    this.removeAll = () => {
      this.listeners.forEach((listener) => {
        var _this$target;
        return (_this$target = this.target) == null ? void 0 : _this$target.removeEventListener(...listener);
      });
    };
    this.target = target;
  }
  add(eventName, handler, options) {
    var _this$target2;
    (_this$target2 = this.target) == null ? void 0 : _this$target2.addEventListener(eventName, handler, options);
    this.listeners.push([eventName, handler, options]);
  }
}
function getEventListenerTarget(target) {
  const {
    EventTarget
  } = getWindow$1(target);
  return target instanceof EventTarget ? target : getOwnerDocument(target);
}
function hasExceededDistance(delta, measurement) {
  const dx = Math.abs(delta.x);
  const dy = Math.abs(delta.y);
  if (typeof measurement === "number") {
    return Math.sqrt(dx ** 2 + dy ** 2) > measurement;
  }
  if ("x" in measurement && "y" in measurement) {
    return dx > measurement.x && dy > measurement.y;
  }
  if ("x" in measurement) {
    return dx > measurement.x;
  }
  if ("y" in measurement) {
    return dy > measurement.y;
  }
  return false;
}
var EventName;
(function(EventName2) {
  EventName2["Click"] = "click";
  EventName2["DragStart"] = "dragstart";
  EventName2["Keydown"] = "keydown";
  EventName2["ContextMenu"] = "contextmenu";
  EventName2["Resize"] = "resize";
  EventName2["SelectionChange"] = "selectionchange";
  EventName2["VisibilityChange"] = "visibilitychange";
})(EventName || (EventName = {}));
function preventDefault(event) {
  event.preventDefault();
}
function stopPropagation(event) {
  event.stopPropagation();
}
var KeyboardCode;
(function(KeyboardCode2) {
  KeyboardCode2["Space"] = "Space";
  KeyboardCode2["Down"] = "ArrowDown";
  KeyboardCode2["Right"] = "ArrowRight";
  KeyboardCode2["Left"] = "ArrowLeft";
  KeyboardCode2["Up"] = "ArrowUp";
  KeyboardCode2["Esc"] = "Escape";
  KeyboardCode2["Enter"] = "Enter";
  KeyboardCode2["Tab"] = "Tab";
})(KeyboardCode || (KeyboardCode = {}));
const defaultKeyboardCodes = {
  start: [KeyboardCode.Space, KeyboardCode.Enter],
  cancel: [KeyboardCode.Esc],
  end: [KeyboardCode.Space, KeyboardCode.Enter, KeyboardCode.Tab]
};
const defaultKeyboardCoordinateGetter = (event, _ref) => {
  let {
    currentCoordinates
  } = _ref;
  switch (event.code) {
    case KeyboardCode.Right:
      return {
        ...currentCoordinates,
        x: currentCoordinates.x + 25
      };
    case KeyboardCode.Left:
      return {
        ...currentCoordinates,
        x: currentCoordinates.x - 25
      };
    case KeyboardCode.Down:
      return {
        ...currentCoordinates,
        y: currentCoordinates.y + 25
      };
    case KeyboardCode.Up:
      return {
        ...currentCoordinates,
        y: currentCoordinates.y - 25
      };
  }
  return void 0;
};
class KeyboardSensor {
  constructor(props) {
    this.props = void 0;
    this.autoScrollEnabled = false;
    this.referenceCoordinates = void 0;
    this.listeners = void 0;
    this.windowListeners = void 0;
    this.props = props;
    const {
      event: {
        target
      }
    } = props;
    this.props = props;
    this.listeners = new Listeners(getOwnerDocument(target));
    this.windowListeners = new Listeners(getWindow$1(target));
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.attach();
  }
  attach() {
    this.handleStart();
    this.windowListeners.add(EventName.Resize, this.handleCancel);
    this.windowListeners.add(EventName.VisibilityChange, this.handleCancel);
    setTimeout(() => this.listeners.add(EventName.Keydown, this.handleKeyDown));
  }
  handleStart() {
    const {
      activeNode,
      onStart
    } = this.props;
    const node = activeNode.node.current;
    if (node) {
      scrollIntoViewIfNeeded(node);
    }
    onStart(defaultCoordinates);
  }
  handleKeyDown(event) {
    if (isKeyboardEvent(event)) {
      const {
        active,
        context,
        options
      } = this.props;
      const {
        keyboardCodes = defaultKeyboardCodes,
        coordinateGetter = defaultKeyboardCoordinateGetter,
        scrollBehavior = "smooth"
      } = options;
      const {
        code
      } = event;
      if (keyboardCodes.end.includes(code)) {
        this.handleEnd(event);
        return;
      }
      if (keyboardCodes.cancel.includes(code)) {
        this.handleCancel(event);
        return;
      }
      const {
        collisionRect
      } = context.current;
      const currentCoordinates = collisionRect ? {
        x: collisionRect.left,
        y: collisionRect.top
      } : defaultCoordinates;
      if (!this.referenceCoordinates) {
        this.referenceCoordinates = currentCoordinates;
      }
      const newCoordinates = coordinateGetter(event, {
        active,
        context: context.current,
        currentCoordinates
      });
      if (newCoordinates) {
        const coordinatesDelta = subtract$1(newCoordinates, currentCoordinates);
        const scrollDelta = {
          x: 0,
          y: 0
        };
        const {
          scrollableAncestors
        } = context.current;
        for (const scrollContainer of scrollableAncestors) {
          const direction = event.code;
          const {
            isTop,
            isRight,
            isLeft,
            isBottom,
            maxScroll,
            minScroll
          } = getScrollPosition(scrollContainer);
          const scrollElementRect = getScrollElementRect(scrollContainer);
          const clampedCoordinates = {
            x: Math.min(direction === KeyboardCode.Right ? scrollElementRect.right - scrollElementRect.width / 2 : scrollElementRect.right, Math.max(direction === KeyboardCode.Right ? scrollElementRect.left : scrollElementRect.left + scrollElementRect.width / 2, newCoordinates.x)),
            y: Math.min(direction === KeyboardCode.Down ? scrollElementRect.bottom - scrollElementRect.height / 2 : scrollElementRect.bottom, Math.max(direction === KeyboardCode.Down ? scrollElementRect.top : scrollElementRect.top + scrollElementRect.height / 2, newCoordinates.y))
          };
          const canScrollX = direction === KeyboardCode.Right && !isRight || direction === KeyboardCode.Left && !isLeft;
          const canScrollY = direction === KeyboardCode.Down && !isBottom || direction === KeyboardCode.Up && !isTop;
          if (canScrollX && clampedCoordinates.x !== newCoordinates.x) {
            const newScrollCoordinates = scrollContainer.scrollLeft + coordinatesDelta.x;
            const canScrollToNewCoordinates = direction === KeyboardCode.Right && newScrollCoordinates <= maxScroll.x || direction === KeyboardCode.Left && newScrollCoordinates >= minScroll.x;
            if (canScrollToNewCoordinates && !coordinatesDelta.y) {
              scrollContainer.scrollTo({
                left: newScrollCoordinates,
                behavior: scrollBehavior
              });
              return;
            }
            if (canScrollToNewCoordinates) {
              scrollDelta.x = scrollContainer.scrollLeft - newScrollCoordinates;
            } else {
              scrollDelta.x = direction === KeyboardCode.Right ? scrollContainer.scrollLeft - maxScroll.x : scrollContainer.scrollLeft - minScroll.x;
            }
            if (scrollDelta.x) {
              scrollContainer.scrollBy({
                left: -scrollDelta.x,
                behavior: scrollBehavior
              });
            }
            break;
          } else if (canScrollY && clampedCoordinates.y !== newCoordinates.y) {
            const newScrollCoordinates = scrollContainer.scrollTop + coordinatesDelta.y;
            const canScrollToNewCoordinates = direction === KeyboardCode.Down && newScrollCoordinates <= maxScroll.y || direction === KeyboardCode.Up && newScrollCoordinates >= minScroll.y;
            if (canScrollToNewCoordinates && !coordinatesDelta.x) {
              scrollContainer.scrollTo({
                top: newScrollCoordinates,
                behavior: scrollBehavior
              });
              return;
            }
            if (canScrollToNewCoordinates) {
              scrollDelta.y = scrollContainer.scrollTop - newScrollCoordinates;
            } else {
              scrollDelta.y = direction === KeyboardCode.Down ? scrollContainer.scrollTop - maxScroll.y : scrollContainer.scrollTop - minScroll.y;
            }
            if (scrollDelta.y) {
              scrollContainer.scrollBy({
                top: -scrollDelta.y,
                behavior: scrollBehavior
              });
            }
            break;
          }
        }
        this.handleMove(event, add$1(subtract$1(newCoordinates, this.referenceCoordinates), scrollDelta));
      }
    }
  }
  handleMove(event, coordinates) {
    const {
      onMove
    } = this.props;
    event.preventDefault();
    onMove(coordinates);
  }
  handleEnd(event) {
    const {
      onEnd
    } = this.props;
    event.preventDefault();
    this.detach();
    onEnd();
  }
  handleCancel(event) {
    const {
      onCancel
    } = this.props;
    event.preventDefault();
    this.detach();
    onCancel();
  }
  detach() {
    this.listeners.removeAll();
    this.windowListeners.removeAll();
  }
}
KeyboardSensor.activators = [{
  eventName: "onKeyDown",
  handler: (event, _ref, _ref2) => {
    let {
      keyboardCodes = defaultKeyboardCodes,
      onActivation
    } = _ref;
    let {
      active
    } = _ref2;
    const {
      code
    } = event.nativeEvent;
    if (keyboardCodes.start.includes(code)) {
      const activator = active.activatorNode.current;
      if (activator && event.target !== activator) {
        return false;
      }
      event.preventDefault();
      onActivation == null ? void 0 : onActivation({
        event: event.nativeEvent
      });
      return true;
    }
    return false;
  }
}];
function isDistanceConstraint(constraint) {
  return Boolean(constraint && "distance" in constraint);
}
function isDelayConstraint(constraint) {
  return Boolean(constraint && "delay" in constraint);
}
class AbstractPointerSensor {
  constructor(props, events2, listenerTarget) {
    var _getEventCoordinates;
    if (listenerTarget === void 0) {
      listenerTarget = getEventListenerTarget(props.event.target);
    }
    this.props = void 0;
    this.events = void 0;
    this.autoScrollEnabled = true;
    this.document = void 0;
    this.activated = false;
    this.initialCoordinates = void 0;
    this.timeoutId = null;
    this.listeners = void 0;
    this.documentListeners = void 0;
    this.windowListeners = void 0;
    this.props = props;
    this.events = events2;
    const {
      event
    } = props;
    const {
      target
    } = event;
    this.props = props;
    this.events = events2;
    this.document = getOwnerDocument(target);
    this.documentListeners = new Listeners(this.document);
    this.listeners = new Listeners(listenerTarget);
    this.windowListeners = new Listeners(getWindow$1(target));
    this.initialCoordinates = (_getEventCoordinates = getEventCoordinates(event)) != null ? _getEventCoordinates : defaultCoordinates;
    this.handleStart = this.handleStart.bind(this);
    this.handleMove = this.handleMove.bind(this);
    this.handleEnd = this.handleEnd.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
    this.removeTextSelection = this.removeTextSelection.bind(this);
    this.attach();
  }
  attach() {
    const {
      events: events2,
      props: {
        options: {
          activationConstraint,
          bypassActivationConstraint
        }
      }
    } = this;
    this.listeners.add(events2.move.name, this.handleMove, {
      passive: false
    });
    this.listeners.add(events2.end.name, this.handleEnd);
    if (events2.cancel) {
      this.listeners.add(events2.cancel.name, this.handleCancel);
    }
    this.windowListeners.add(EventName.Resize, this.handleCancel);
    this.windowListeners.add(EventName.DragStart, preventDefault);
    this.windowListeners.add(EventName.VisibilityChange, this.handleCancel);
    this.windowListeners.add(EventName.ContextMenu, preventDefault);
    this.documentListeners.add(EventName.Keydown, this.handleKeydown);
    if (activationConstraint) {
      if (bypassActivationConstraint != null && bypassActivationConstraint({
        event: this.props.event,
        activeNode: this.props.activeNode,
        options: this.props.options
      })) {
        return this.handleStart();
      }
      if (isDelayConstraint(activationConstraint)) {
        this.timeoutId = setTimeout(this.handleStart, activationConstraint.delay);
        this.handlePending(activationConstraint);
        return;
      }
      if (isDistanceConstraint(activationConstraint)) {
        this.handlePending(activationConstraint);
        return;
      }
    }
    this.handleStart();
  }
  detach() {
    this.listeners.removeAll();
    this.windowListeners.removeAll();
    setTimeout(this.documentListeners.removeAll, 50);
    if (this.timeoutId !== null) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
  }
  handlePending(constraint, offset2) {
    const {
      active,
      onPending
    } = this.props;
    onPending(active, constraint, this.initialCoordinates, offset2);
  }
  handleStart() {
    const {
      initialCoordinates
    } = this;
    const {
      onStart
    } = this.props;
    if (initialCoordinates) {
      this.activated = true;
      this.documentListeners.add(EventName.Click, stopPropagation, {
        capture: true
      });
      this.removeTextSelection();
      this.documentListeners.add(EventName.SelectionChange, this.removeTextSelection);
      onStart(initialCoordinates);
    }
  }
  handleMove(event) {
    var _getEventCoordinates2;
    const {
      activated,
      initialCoordinates,
      props
    } = this;
    const {
      onMove,
      options: {
        activationConstraint
      }
    } = props;
    if (!initialCoordinates) {
      return;
    }
    const coordinates = (_getEventCoordinates2 = getEventCoordinates(event)) != null ? _getEventCoordinates2 : defaultCoordinates;
    const delta = subtract$1(initialCoordinates, coordinates);
    if (!activated && activationConstraint) {
      if (isDistanceConstraint(activationConstraint)) {
        if (activationConstraint.tolerance != null && hasExceededDistance(delta, activationConstraint.tolerance)) {
          return this.handleCancel();
        }
        if (hasExceededDistance(delta, activationConstraint.distance)) {
          return this.handleStart();
        }
      }
      if (isDelayConstraint(activationConstraint)) {
        if (hasExceededDistance(delta, activationConstraint.tolerance)) {
          return this.handleCancel();
        }
      }
      this.handlePending(activationConstraint, delta);
      return;
    }
    if (event.cancelable) {
      event.preventDefault();
    }
    onMove(coordinates);
  }
  handleEnd() {
    const {
      onAbort,
      onEnd
    } = this.props;
    this.detach();
    if (!this.activated) {
      onAbort(this.props.active);
    }
    onEnd();
  }
  handleCancel() {
    const {
      onAbort,
      onCancel
    } = this.props;
    this.detach();
    if (!this.activated) {
      onAbort(this.props.active);
    }
    onCancel();
  }
  handleKeydown(event) {
    if (event.code === KeyboardCode.Esc) {
      this.handleCancel();
    }
  }
  removeTextSelection() {
    var _this$document$getSel;
    (_this$document$getSel = this.document.getSelection()) == null ? void 0 : _this$document$getSel.removeAllRanges();
  }
}
const events = {
  cancel: {
    name: "pointercancel"
  },
  move: {
    name: "pointermove"
  },
  end: {
    name: "pointerup"
  }
};
class PointerSensor extends AbstractPointerSensor {
  constructor(props) {
    const {
      event
    } = props;
    const listenerTarget = getOwnerDocument(event.target);
    super(props, events, listenerTarget);
  }
}
PointerSensor.activators = [{
  eventName: "onPointerDown",
  handler: (_ref, _ref2) => {
    let {
      nativeEvent: event
    } = _ref;
    let {
      onActivation
    } = _ref2;
    if (!event.isPrimary || event.button !== 0) {
      return false;
    }
    onActivation == null ? void 0 : onActivation({
      event
    });
    return true;
  }
}];
const events$1 = {
  move: {
    name: "mousemove"
  },
  end: {
    name: "mouseup"
  }
};
var MouseButton;
(function(MouseButton2) {
  MouseButton2[MouseButton2["RightClick"] = 2] = "RightClick";
})(MouseButton || (MouseButton = {}));
class MouseSensor extends AbstractPointerSensor {
  constructor(props) {
    super(props, events$1, getOwnerDocument(props.event.target));
  }
}
MouseSensor.activators = [{
  eventName: "onMouseDown",
  handler: (_ref, _ref2) => {
    let {
      nativeEvent: event
    } = _ref;
    let {
      onActivation
    } = _ref2;
    if (event.button === MouseButton.RightClick) {
      return false;
    }
    onActivation == null ? void 0 : onActivation({
      event
    });
    return true;
  }
}];
const events$2 = {
  cancel: {
    name: "touchcancel"
  },
  move: {
    name: "touchmove"
  },
  end: {
    name: "touchend"
  }
};
class TouchSensor extends AbstractPointerSensor {
  constructor(props) {
    super(props, events$2);
  }
  static setup() {
    window.addEventListener(events$2.move.name, noop2, {
      capture: false,
      passive: false
    });
    return function teardown() {
      window.removeEventListener(events$2.move.name, noop2);
    };
    function noop2() {
    }
  }
}
TouchSensor.activators = [{
  eventName: "onTouchStart",
  handler: (_ref, _ref2) => {
    let {
      nativeEvent: event
    } = _ref;
    let {
      onActivation
    } = _ref2;
    const {
      touches
    } = event;
    if (touches.length > 1) {
      return false;
    }
    onActivation == null ? void 0 : onActivation({
      event
    });
    return true;
  }
}];
var AutoScrollActivator;
(function(AutoScrollActivator2) {
  AutoScrollActivator2[AutoScrollActivator2["Pointer"] = 0] = "Pointer";
  AutoScrollActivator2[AutoScrollActivator2["DraggableRect"] = 1] = "DraggableRect";
})(AutoScrollActivator || (AutoScrollActivator = {}));
var TraversalOrder;
(function(TraversalOrder2) {
  TraversalOrder2[TraversalOrder2["TreeOrder"] = 0] = "TreeOrder";
  TraversalOrder2[TraversalOrder2["ReversedTreeOrder"] = 1] = "ReversedTreeOrder";
})(TraversalOrder || (TraversalOrder = {}));
function useAutoScroller(_ref) {
  let {
    acceleration,
    activator = AutoScrollActivator.Pointer,
    canScroll,
    draggingRect,
    enabled,
    interval = 5,
    order: order2 = TraversalOrder.TreeOrder,
    pointerCoordinates,
    scrollableAncestors,
    scrollableAncestorRects,
    delta,
    threshold: threshold2
  } = _ref;
  const scrollIntent = useScrollIntent({
    delta,
    disabled: !enabled
  });
  const [setAutoScrollInterval, clearAutoScrollInterval] = useInterval();
  const scrollSpeed = useRef({
    x: 0,
    y: 0
  });
  const scrollDirection = useRef({
    x: 0,
    y: 0
  });
  const rect = useMemo(() => {
    switch (activator) {
      case AutoScrollActivator.Pointer:
        return pointerCoordinates ? {
          top: pointerCoordinates.y,
          bottom: pointerCoordinates.y,
          left: pointerCoordinates.x,
          right: pointerCoordinates.x
        } : null;
      case AutoScrollActivator.DraggableRect:
        return draggingRect;
    }
  }, [activator, draggingRect, pointerCoordinates]);
  const scrollContainerRef = useRef(null);
  const autoScroll = useCallback(() => {
    const scrollContainer = scrollContainerRef.current;
    if (!scrollContainer) {
      return;
    }
    const scrollLeft = scrollSpeed.current.x * scrollDirection.current.x;
    const scrollTop = scrollSpeed.current.y * scrollDirection.current.y;
    scrollContainer.scrollBy(scrollLeft, scrollTop);
  }, []);
  const sortedScrollableAncestors = useMemo(() => order2 === TraversalOrder.TreeOrder ? [...scrollableAncestors].reverse() : scrollableAncestors, [order2, scrollableAncestors]);
  useEffect(
    () => {
      if (!enabled || !scrollableAncestors.length || !rect) {
        clearAutoScrollInterval();
        return;
      }
      for (const scrollContainer of sortedScrollableAncestors) {
        if ((canScroll == null ? void 0 : canScroll(scrollContainer)) === false) {
          continue;
        }
        const index2 = scrollableAncestors.indexOf(scrollContainer);
        const scrollContainerRect = scrollableAncestorRects[index2];
        if (!scrollContainerRect) {
          continue;
        }
        const {
          direction,
          speed
        } = getScrollDirectionAndSpeed(scrollContainer, scrollContainerRect, rect, acceleration, threshold2);
        for (const axis of ["x", "y"]) {
          if (!scrollIntent[axis][direction[axis]]) {
            speed[axis] = 0;
            direction[axis] = 0;
          }
        }
        if (speed.x > 0 || speed.y > 0) {
          clearAutoScrollInterval();
          scrollContainerRef.current = scrollContainer;
          setAutoScrollInterval(autoScroll, interval);
          scrollSpeed.current = speed;
          scrollDirection.current = direction;
          return;
        }
      }
      scrollSpeed.current = {
        x: 0,
        y: 0
      };
      scrollDirection.current = {
        x: 0,
        y: 0
      };
      clearAutoScrollInterval();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      acceleration,
      autoScroll,
      canScroll,
      clearAutoScrollInterval,
      enabled,
      interval,
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(rect),
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(scrollIntent),
      setAutoScrollInterval,
      scrollableAncestors,
      sortedScrollableAncestors,
      scrollableAncestorRects,
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(threshold2)
    ]
  );
}
const defaultScrollIntent = {
  x: {
    [Direction.Backward]: false,
    [Direction.Forward]: false
  },
  y: {
    [Direction.Backward]: false,
    [Direction.Forward]: false
  }
};
function useScrollIntent(_ref2) {
  let {
    delta,
    disabled
  } = _ref2;
  const previousDelta = usePrevious(delta);
  return useLazyMemo((previousIntent) => {
    if (disabled || !previousDelta || !previousIntent) {
      return defaultScrollIntent;
    }
    const direction = {
      x: Math.sign(delta.x - previousDelta.x),
      y: Math.sign(delta.y - previousDelta.y)
    };
    return {
      x: {
        [Direction.Backward]: previousIntent.x[Direction.Backward] || direction.x === -1,
        [Direction.Forward]: previousIntent.x[Direction.Forward] || direction.x === 1
      },
      y: {
        [Direction.Backward]: previousIntent.y[Direction.Backward] || direction.y === -1,
        [Direction.Forward]: previousIntent.y[Direction.Forward] || direction.y === 1
      }
    };
  }, [disabled, delta, previousDelta]);
}
function useCachedNode(draggableNodes, id2) {
  const draggableNode = id2 != null ? draggableNodes.get(id2) : void 0;
  const node = draggableNode ? draggableNode.node.current : null;
  return useLazyMemo((cachedNode) => {
    var _ref;
    if (id2 == null) {
      return null;
    }
    return (_ref = node != null ? node : cachedNode) != null ? _ref : null;
  }, [node, id2]);
}
function useCombineActivators(sensors, getSyntheticHandler) {
  return useMemo(() => sensors.reduce((accumulator, sensor) => {
    const {
      sensor: Sensor
    } = sensor;
    const sensorActivators = Sensor.activators.map((activator) => ({
      eventName: activator.eventName,
      handler: getSyntheticHandler(activator.handler, sensor)
    }));
    return [...accumulator, ...sensorActivators];
  }, []), [sensors, getSyntheticHandler]);
}
var MeasuringStrategy;
(function(MeasuringStrategy2) {
  MeasuringStrategy2[MeasuringStrategy2["Always"] = 0] = "Always";
  MeasuringStrategy2[MeasuringStrategy2["BeforeDragging"] = 1] = "BeforeDragging";
  MeasuringStrategy2[MeasuringStrategy2["WhileDragging"] = 2] = "WhileDragging";
})(MeasuringStrategy || (MeasuringStrategy = {}));
var MeasuringFrequency;
(function(MeasuringFrequency2) {
  MeasuringFrequency2["Optimized"] = "optimized";
})(MeasuringFrequency || (MeasuringFrequency = {}));
const defaultValue = /* @__PURE__ */ new Map();
function useDroppableMeasuring(containers, _ref) {
  let {
    dragging,
    dependencies,
    config: config2
  } = _ref;
  const [queue, setQueue] = useState(null);
  const {
    frequency,
    measure,
    strategy
  } = config2;
  const containersRef = useRef(containers);
  const disabled = isDisabled();
  const disabledRef = useLatestValue(disabled);
  const measureDroppableContainers = useCallback(function(ids2) {
    if (ids2 === void 0) {
      ids2 = [];
    }
    if (disabledRef.current) {
      return;
    }
    setQueue((value) => {
      if (value === null) {
        return ids2;
      }
      return value.concat(ids2.filter((id2) => !value.includes(id2)));
    });
  }, [disabledRef]);
  const timeoutId = useRef(null);
  const droppableRects = useLazyMemo((previousValue) => {
    if (disabled && !dragging) {
      return defaultValue;
    }
    if (!previousValue || previousValue === defaultValue || containersRef.current !== containers || queue != null) {
      const map2 = /* @__PURE__ */ new Map();
      for (let container of containers) {
        if (!container) {
          continue;
        }
        if (queue && queue.length > 0 && !queue.includes(container.id) && container.rect.current) {
          map2.set(container.id, container.rect.current);
          continue;
        }
        const node = container.node.current;
        const rect = node ? new Rect(measure(node), node) : null;
        container.rect.current = rect;
        if (rect) {
          map2.set(container.id, rect);
        }
      }
      return map2;
    }
    return previousValue;
  }, [containers, queue, dragging, disabled, measure]);
  useEffect(() => {
    containersRef.current = containers;
  }, [containers]);
  useEffect(
    () => {
      if (disabled) {
        return;
      }
      measureDroppableContainers();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dragging, disabled]
  );
  useEffect(
    () => {
      if (queue && queue.length > 0) {
        setQueue(null);
      }
    },
    //eslint-disable-next-line react-hooks/exhaustive-deps
    [JSON.stringify(queue)]
  );
  useEffect(
    () => {
      if (disabled || typeof frequency !== "number" || timeoutId.current !== null) {
        return;
      }
      timeoutId.current = setTimeout(() => {
        measureDroppableContainers();
        timeoutId.current = null;
      }, frequency);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [frequency, disabled, measureDroppableContainers, ...dependencies]
  );
  return {
    droppableRects,
    measureDroppableContainers,
    measuringScheduled: queue != null
  };
  function isDisabled() {
    switch (strategy) {
      case MeasuringStrategy.Always:
        return false;
      case MeasuringStrategy.BeforeDragging:
        return dragging;
      default:
        return !dragging;
    }
  }
}
function useInitialValue(value, computeFn) {
  return useLazyMemo((previousValue) => {
    if (!value) {
      return null;
    }
    if (previousValue) {
      return previousValue;
    }
    return typeof computeFn === "function" ? computeFn(value) : value;
  }, [computeFn, value]);
}
function useInitialRect(node, measure) {
  return useInitialValue(node, measure);
}
function useMutationObserver(_ref) {
  let {
    callback,
    disabled
  } = _ref;
  const handleMutations = useEvent(callback);
  const mutationObserver = useMemo(() => {
    if (disabled || typeof window === "undefined" || typeof window.MutationObserver === "undefined") {
      return void 0;
    }
    const {
      MutationObserver: MutationObserver2
    } = window;
    return new MutationObserver2(handleMutations);
  }, [handleMutations, disabled]);
  useEffect(() => {
    return () => mutationObserver == null ? void 0 : mutationObserver.disconnect();
  }, [mutationObserver]);
  return mutationObserver;
}
function useResizeObserver(_ref) {
  let {
    callback,
    disabled
  } = _ref;
  const handleResize = useEvent(callback);
  const resizeObserver = useMemo(
    () => {
      if (disabled || typeof window === "undefined" || typeof window.ResizeObserver === "undefined") {
        return void 0;
      }
      const {
        ResizeObserver: ResizeObserver2
      } = window;
      return new ResizeObserver2(handleResize);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [disabled]
  );
  useEffect(() => {
    return () => resizeObserver == null ? void 0 : resizeObserver.disconnect();
  }, [resizeObserver]);
  return resizeObserver;
}
function defaultMeasure(element) {
  return new Rect(getClientRect$2(element), element);
}
function useRect(element, measure, fallbackRect) {
  if (measure === void 0) {
    measure = defaultMeasure;
  }
  const [rect, setRect] = useState(null);
  function measureRect() {
    setRect((currentRect) => {
      if (!element) {
        return null;
      }
      if (element.isConnected === false) {
        var _ref;
        return (_ref = currentRect != null ? currentRect : fallbackRect) != null ? _ref : null;
      }
      const newRect = measure(element);
      if (JSON.stringify(currentRect) === JSON.stringify(newRect)) {
        return currentRect;
      }
      return newRect;
    });
  }
  const mutationObserver = useMutationObserver({
    callback(records) {
      if (!element) {
        return;
      }
      for (const record of records) {
        const {
          type,
          target
        } = record;
        if (type === "childList" && target instanceof HTMLElement && target.contains(element)) {
          measureRect();
          break;
        }
      }
    }
  });
  const resizeObserver = useResizeObserver({
    callback: measureRect
  });
  useIsomorphicLayoutEffect(() => {
    measureRect();
    if (element) {
      resizeObserver == null ? void 0 : resizeObserver.observe(element);
      mutationObserver == null ? void 0 : mutationObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    } else {
      resizeObserver == null ? void 0 : resizeObserver.disconnect();
      mutationObserver == null ? void 0 : mutationObserver.disconnect();
    }
  }, [element]);
  return rect;
}
function useRectDelta(rect) {
  const initialRect = useInitialValue(rect);
  return getRectDelta(rect, initialRect);
}
const defaultValue$1 = [];
function useScrollableAncestors(node) {
  const previousNode = useRef(node);
  const ancestors = useLazyMemo((previousValue) => {
    if (!node) {
      return defaultValue$1;
    }
    if (previousValue && previousValue !== defaultValue$1 && node && previousNode.current && node.parentNode === previousNode.current.parentNode) {
      return previousValue;
    }
    return getScrollableAncestors(node);
  }, [node]);
  useEffect(() => {
    previousNode.current = node;
  }, [node]);
  return ancestors;
}
function useScrollOffsets(elements) {
  const [scrollCoordinates, setScrollCoordinates] = useState(null);
  const prevElements = useRef(elements);
  const handleScroll2 = useCallback((event) => {
    const scrollingElement = getScrollableElement(event.target);
    if (!scrollingElement) {
      return;
    }
    setScrollCoordinates((scrollCoordinates2) => {
      if (!scrollCoordinates2) {
        return null;
      }
      scrollCoordinates2.set(scrollingElement, getScrollCoordinates(scrollingElement));
      return new Map(scrollCoordinates2);
    });
  }, []);
  useEffect(() => {
    const previousElements = prevElements.current;
    if (elements !== previousElements) {
      cleanup(previousElements);
      const entries = elements.map((element) => {
        const scrollableElement = getScrollableElement(element);
        if (scrollableElement) {
          scrollableElement.addEventListener("scroll", handleScroll2, {
            passive: true
          });
          return [scrollableElement, getScrollCoordinates(scrollableElement)];
        }
        return null;
      }).filter((entry) => entry != null);
      setScrollCoordinates(entries.length ? new Map(entries) : null);
      prevElements.current = elements;
    }
    return () => {
      cleanup(elements);
      cleanup(previousElements);
    };
    function cleanup(elements2) {
      elements2.forEach((element) => {
        const scrollableElement = getScrollableElement(element);
        scrollableElement == null ? void 0 : scrollableElement.removeEventListener("scroll", handleScroll2);
      });
    }
  }, [handleScroll2, elements]);
  return useMemo(() => {
    if (elements.length) {
      return scrollCoordinates ? Array.from(scrollCoordinates.values()).reduce((acc, coordinates) => add$1(acc, coordinates), defaultCoordinates) : getScrollOffsets(elements);
    }
    return defaultCoordinates;
  }, [elements, scrollCoordinates]);
}
function useScrollOffsetsDelta(scrollOffsets, dependencies) {
  if (dependencies === void 0) {
    dependencies = [];
  }
  const initialScrollOffsets = useRef(null);
  useEffect(
    () => {
      initialScrollOffsets.current = null;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    dependencies
  );
  useEffect(() => {
    const hasScrollOffsets = scrollOffsets !== defaultCoordinates;
    if (hasScrollOffsets && !initialScrollOffsets.current) {
      initialScrollOffsets.current = scrollOffsets;
    }
    if (!hasScrollOffsets && initialScrollOffsets.current) {
      initialScrollOffsets.current = null;
    }
  }, [scrollOffsets]);
  return initialScrollOffsets.current ? subtract$1(scrollOffsets, initialScrollOffsets.current) : defaultCoordinates;
}
function useSensorSetup(sensors) {
  useEffect(
    () => {
      if (!canUseDOM$2) {
        return;
      }
      const teardownFns = sensors.map((_ref) => {
        let {
          sensor
        } = _ref;
        return sensor.setup == null ? void 0 : sensor.setup();
      });
      return () => {
        for (const teardown of teardownFns) {
          teardown == null ? void 0 : teardown();
        }
      };
    },
    // TO-DO: Sensors length could theoretically change which would not be a valid dependency
    // eslint-disable-next-line react-hooks/exhaustive-deps
    sensors.map((_ref2) => {
      let {
        sensor
      } = _ref2;
      return sensor;
    })
  );
}
function useSyntheticListeners(listeners, id2) {
  return useMemo(() => {
    return listeners.reduce((acc, _ref) => {
      let {
        eventName,
        handler
      } = _ref;
      acc[eventName] = (event) => {
        handler(event, id2);
      };
      return acc;
    }, {});
  }, [listeners, id2]);
}
function useWindowRect(element) {
  return useMemo(() => element ? getWindowClientRect(element) : null, [element]);
}
const defaultValue$2 = [];
function useRects(elements, measure) {
  if (measure === void 0) {
    measure = getClientRect$2;
  }
  const [firstElement] = elements;
  const windowRect = useWindowRect(firstElement ? getWindow$1(firstElement) : null);
  const [rects, setRects] = useState(defaultValue$2);
  function measureRects() {
    setRects(() => {
      if (!elements.length) {
        return defaultValue$2;
      }
      return elements.map((element) => isDocumentScrollingElement(element) ? windowRect : new Rect(measure(element), element));
    });
  }
  const resizeObserver = useResizeObserver({
    callback: measureRects
  });
  useIsomorphicLayoutEffect(() => {
    resizeObserver == null ? void 0 : resizeObserver.disconnect();
    measureRects();
    elements.forEach((element) => resizeObserver == null ? void 0 : resizeObserver.observe(element));
  }, [elements]);
  return rects;
}
function getMeasurableNode(node) {
  if (!node) {
    return null;
  }
  if (node.children.length > 1) {
    return node;
  }
  const firstChild = node.children[0];
  return isHTMLElement(firstChild) ? firstChild : node;
}
function useDragOverlayMeasuring(_ref) {
  let {
    measure
  } = _ref;
  const [rect, setRect] = useState(null);
  const handleResize = useCallback((entries) => {
    for (const {
      target
    } of entries) {
      if (isHTMLElement(target)) {
        setRect((rect2) => {
          const newRect = measure(target);
          return rect2 ? {
            ...rect2,
            width: newRect.width,
            height: newRect.height
          } : newRect;
        });
        break;
      }
    }
  }, [measure]);
  const resizeObserver = useResizeObserver({
    callback: handleResize
  });
  const handleNodeChange = useCallback((element) => {
    const node = getMeasurableNode(element);
    resizeObserver == null ? void 0 : resizeObserver.disconnect();
    if (node) {
      resizeObserver == null ? void 0 : resizeObserver.observe(node);
    }
    setRect(node ? measure(node) : null);
  }, [measure, resizeObserver]);
  const [nodeRef, setRef] = useNodeRef(handleNodeChange);
  return useMemo(() => ({
    nodeRef,
    rect,
    setRef
  }), [rect, nodeRef, setRef]);
}
const defaultSensors = [{
  sensor: PointerSensor,
  options: {}
}, {
  sensor: KeyboardSensor,
  options: {}
}];
const defaultData = {
  current: {}
};
const defaultMeasuringConfiguration = {
  draggable: {
    measure: getTransformAgnosticClientRect
  },
  droppable: {
    measure: getTransformAgnosticClientRect,
    strategy: MeasuringStrategy.WhileDragging,
    frequency: MeasuringFrequency.Optimized
  },
  dragOverlay: {
    measure: getClientRect$2
  }
};
class DroppableContainersMap extends Map {
  get(id2) {
    var _super$get;
    return id2 != null ? (_super$get = super.get(id2)) != null ? _super$get : void 0 : void 0;
  }
  toArray() {
    return Array.from(this.values());
  }
  getEnabled() {
    return this.toArray().filter((_ref) => {
      let {
        disabled
      } = _ref;
      return !disabled;
    });
  }
  getNodeFor(id2) {
    var _this$get$node$curren, _this$get;
    return (_this$get$node$curren = (_this$get = this.get(id2)) == null ? void 0 : _this$get.node.current) != null ? _this$get$node$curren : void 0;
  }
}
const defaultPublicContext = {
  activatorEvent: null,
  active: null,
  activeNode: null,
  activeNodeRect: null,
  collisions: null,
  containerNodeRect: null,
  draggableNodes: /* @__PURE__ */ new Map(),
  droppableRects: /* @__PURE__ */ new Map(),
  droppableContainers: /* @__PURE__ */ new DroppableContainersMap(),
  over: null,
  dragOverlay: {
    nodeRef: {
      current: null
    },
    rect: null,
    setRef: noop$3
  },
  scrollableAncestors: [],
  scrollableAncestorRects: [],
  measuringConfiguration: defaultMeasuringConfiguration,
  measureDroppableContainers: noop$3,
  windowRect: null,
  measuringScheduled: false
};
const defaultInternalContext = {
  activatorEvent: null,
  activators: [],
  active: null,
  activeNodeRect: null,
  ariaDescribedById: {
    draggable: ""
  },
  dispatch: noop$3,
  draggableNodes: /* @__PURE__ */ new Map(),
  over: null,
  measureDroppableContainers: noop$3
};
const InternalContext = /* @__PURE__ */ createContext(defaultInternalContext);
const PublicContext = /* @__PURE__ */ createContext(defaultPublicContext);
function getInitialState() {
  return {
    draggable: {
      active: null,
      initialCoordinates: {
        x: 0,
        y: 0
      },
      nodes: /* @__PURE__ */ new Map(),
      translate: {
        x: 0,
        y: 0
      }
    },
    droppable: {
      containers: new DroppableContainersMap()
    }
  };
}
function reducer$3(state, action) {
  switch (action.type) {
    case Action.DragStart:
      return {
        ...state,
        draggable: {
          ...state.draggable,
          initialCoordinates: action.initialCoordinates,
          active: action.active
        }
      };
    case Action.DragMove:
      if (state.draggable.active == null) {
        return state;
      }
      return {
        ...state,
        draggable: {
          ...state.draggable,
          translate: {
            x: action.coordinates.x - state.draggable.initialCoordinates.x,
            y: action.coordinates.y - state.draggable.initialCoordinates.y
          }
        }
      };
    case Action.DragEnd:
    case Action.DragCancel:
      return {
        ...state,
        draggable: {
          ...state.draggable,
          active: null,
          initialCoordinates: {
            x: 0,
            y: 0
          },
          translate: {
            x: 0,
            y: 0
          }
        }
      };
    case Action.RegisterDroppable: {
      const {
        element
      } = action;
      const {
        id: id2
      } = element;
      const containers = new DroppableContainersMap(state.droppable.containers);
      containers.set(id2, element);
      return {
        ...state,
        droppable: {
          ...state.droppable,
          containers
        }
      };
    }
    case Action.SetDroppableDisabled: {
      const {
        id: id2,
        key,
        disabled
      } = action;
      const element = state.droppable.containers.get(id2);
      if (!element || key !== element.key) {
        return state;
      }
      const containers = new DroppableContainersMap(state.droppable.containers);
      containers.set(id2, {
        ...element,
        disabled
      });
      return {
        ...state,
        droppable: {
          ...state.droppable,
          containers
        }
      };
    }
    case Action.UnregisterDroppable: {
      const {
        id: id2,
        key
      } = action;
      const element = state.droppable.containers.get(id2);
      if (!element || key !== element.key) {
        return state;
      }
      const containers = new DroppableContainersMap(state.droppable.containers);
      containers.delete(id2);
      return {
        ...state,
        droppable: {
          ...state.droppable,
          containers
        }
      };
    }
    default: {
      return state;
    }
  }
}
function RestoreFocus(_ref) {
  let {
    disabled
  } = _ref;
  const {
    active,
    activatorEvent,
    draggableNodes
  } = useContext(InternalContext);
  const previousActivatorEvent = usePrevious(activatorEvent);
  const previousActiveId = usePrevious(active == null ? void 0 : active.id);
  useEffect(() => {
    if (disabled) {
      return;
    }
    if (!activatorEvent && previousActivatorEvent && previousActiveId != null) {
      if (!isKeyboardEvent(previousActivatorEvent)) {
        return;
      }
      if (document.activeElement === previousActivatorEvent.target) {
        return;
      }
      const draggableNode = draggableNodes.get(previousActiveId);
      if (!draggableNode) {
        return;
      }
      const {
        activatorNode,
        node
      } = draggableNode;
      if (!activatorNode.current && !node.current) {
        return;
      }
      requestAnimationFrame(() => {
        for (const element of [activatorNode.current, node.current]) {
          if (!element) {
            continue;
          }
          const focusableNode = findFirstFocusableNode(element);
          if (focusableNode) {
            focusableNode.focus();
            break;
          }
        }
      });
    }
  }, [activatorEvent, disabled, draggableNodes, previousActiveId, previousActivatorEvent]);
  return null;
}
function applyModifiers(modifiers2, _ref) {
  let {
    transform,
    ...args
  } = _ref;
  return modifiers2 != null && modifiers2.length ? modifiers2.reduce((accumulator, modifier) => {
    return modifier({
      transform: accumulator,
      ...args
    });
  }, transform) : transform;
}
function useMeasuringConfiguration(config2) {
  return useMemo(
    () => ({
      draggable: {
        ...defaultMeasuringConfiguration.draggable,
        ...config2 == null ? void 0 : config2.draggable
      },
      droppable: {
        ...defaultMeasuringConfiguration.droppable,
        ...config2 == null ? void 0 : config2.droppable
      },
      dragOverlay: {
        ...defaultMeasuringConfiguration.dragOverlay,
        ...config2 == null ? void 0 : config2.dragOverlay
      }
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [config2 == null ? void 0 : config2.draggable, config2 == null ? void 0 : config2.droppable, config2 == null ? void 0 : config2.dragOverlay]
  );
}
function useLayoutShiftScrollCompensation(_ref) {
  let {
    activeNode,
    measure,
    initialRect,
    config: config2 = true
  } = _ref;
  const initialized = useRef(false);
  const {
    x: x3,
    y: y4
  } = typeof config2 === "boolean" ? {
    x: config2,
    y: config2
  } : config2;
  useIsomorphicLayoutEffect(() => {
    const disabled = !x3 && !y4;
    if (disabled || !activeNode) {
      initialized.current = false;
      return;
    }
    if (initialized.current || !initialRect) {
      return;
    }
    const node = activeNode == null ? void 0 : activeNode.node.current;
    if (!node || node.isConnected === false) {
      return;
    }
    const rect = measure(node);
    const rectDelta = getRectDelta(rect, initialRect);
    if (!x3) {
      rectDelta.x = 0;
    }
    if (!y4) {
      rectDelta.y = 0;
    }
    initialized.current = true;
    if (Math.abs(rectDelta.x) > 0 || Math.abs(rectDelta.y) > 0) {
      const firstScrollableAncestor = getFirstScrollableAncestor(node);
      if (firstScrollableAncestor) {
        firstScrollableAncestor.scrollBy({
          top: rectDelta.y,
          left: rectDelta.x
        });
      }
    }
  }, [activeNode, x3, y4, initialRect, measure]);
}
const ActiveDraggableContext = /* @__PURE__ */ createContext({
  ...defaultCoordinates,
  scaleX: 1,
  scaleY: 1
});
var Status;
(function(Status2) {
  Status2[Status2["Uninitialized"] = 0] = "Uninitialized";
  Status2[Status2["Initializing"] = 1] = "Initializing";
  Status2[Status2["Initialized"] = 2] = "Initialized";
})(Status || (Status = {}));
const DndContext = /* @__PURE__ */ memo$2(function DndContext2(_ref) {
  var _sensorContext$curren, _dragOverlay$nodeRef$, _dragOverlay$rect, _over$rect;
  let {
    id: id2,
    accessibility,
    autoScroll = true,
    children,
    sensors = defaultSensors,
    collisionDetection = rectIntersection,
    measuring,
    modifiers: modifiers2,
    ...props
  } = _ref;
  const store = useReducer(reducer$3, void 0, getInitialState);
  const [state, dispatch] = store;
  const [dispatchMonitorEvent, registerMonitorListener] = useDndMonitorProvider();
  const [status, setStatus] = useState(Status.Uninitialized);
  const isInitialized = status === Status.Initialized;
  const {
    draggable: {
      active: activeId,
      nodes: draggableNodes,
      translate
    },
    droppable: {
      containers: droppableContainers
    }
  } = state;
  const node = activeId != null ? draggableNodes.get(activeId) : null;
  const activeRects = useRef({
    initial: null,
    translated: null
  });
  const active = useMemo(() => {
    var _node$data;
    return activeId != null ? {
      id: activeId,
      // It's possible for the active node to unmount while dragging
      data: (_node$data = node == null ? void 0 : node.data) != null ? _node$data : defaultData,
      rect: activeRects
    } : null;
  }, [activeId, node]);
  const activeRef = useRef(null);
  const [activeSensor, setActiveSensor] = useState(null);
  const [activatorEvent, setActivatorEvent] = useState(null);
  const latestProps = useLatestValue(props, Object.values(props));
  const draggableDescribedById = useUniqueId("DndDescribedBy", id2);
  const enabledDroppableContainers = useMemo(() => droppableContainers.getEnabled(), [droppableContainers]);
  const measuringConfiguration = useMeasuringConfiguration(measuring);
  const {
    droppableRects,
    measureDroppableContainers,
    measuringScheduled
  } = useDroppableMeasuring(enabledDroppableContainers, {
    dragging: isInitialized,
    dependencies: [translate.x, translate.y],
    config: measuringConfiguration.droppable
  });
  const activeNode = useCachedNode(draggableNodes, activeId);
  const activationCoordinates = useMemo(() => activatorEvent ? getEventCoordinates(activatorEvent) : null, [activatorEvent]);
  const autoScrollOptions = getAutoScrollerOptions();
  const initialActiveNodeRect = useInitialRect(activeNode, measuringConfiguration.draggable.measure);
  useLayoutShiftScrollCompensation({
    activeNode: activeId != null ? draggableNodes.get(activeId) : null,
    config: autoScrollOptions.layoutShiftCompensation,
    initialRect: initialActiveNodeRect,
    measure: measuringConfiguration.draggable.measure
  });
  const activeNodeRect = useRect(activeNode, measuringConfiguration.draggable.measure, initialActiveNodeRect);
  const containerNodeRect = useRect(activeNode ? activeNode.parentElement : null);
  const sensorContext = useRef({
    activatorEvent: null,
    active: null,
    activeNode,
    collisionRect: null,
    collisions: null,
    droppableRects,
    draggableNodes,
    draggingNode: null,
    draggingNodeRect: null,
    droppableContainers,
    over: null,
    scrollableAncestors: [],
    scrollAdjustedTranslate: null
  });
  const overNode = droppableContainers.getNodeFor((_sensorContext$curren = sensorContext.current.over) == null ? void 0 : _sensorContext$curren.id);
  const dragOverlay = useDragOverlayMeasuring({
    measure: measuringConfiguration.dragOverlay.measure
  });
  const draggingNode = (_dragOverlay$nodeRef$ = dragOverlay.nodeRef.current) != null ? _dragOverlay$nodeRef$ : activeNode;
  const draggingNodeRect = isInitialized ? (_dragOverlay$rect = dragOverlay.rect) != null ? _dragOverlay$rect : activeNodeRect : null;
  const usesDragOverlay = Boolean(dragOverlay.nodeRef.current && dragOverlay.rect);
  const nodeRectDelta = useRectDelta(usesDragOverlay ? null : activeNodeRect);
  const windowRect = useWindowRect(draggingNode ? getWindow$1(draggingNode) : null);
  const scrollableAncestors = useScrollableAncestors(isInitialized ? overNode != null ? overNode : activeNode : null);
  const scrollableAncestorRects = useRects(scrollableAncestors);
  const modifiedTranslate = applyModifiers(modifiers2, {
    transform: {
      x: translate.x - nodeRectDelta.x,
      y: translate.y - nodeRectDelta.y,
      scaleX: 1,
      scaleY: 1
    },
    activatorEvent,
    active,
    activeNodeRect,
    containerNodeRect,
    draggingNodeRect,
    over: sensorContext.current.over,
    overlayNodeRect: dragOverlay.rect,
    scrollableAncestors,
    scrollableAncestorRects,
    windowRect
  });
  const pointerCoordinates = activationCoordinates ? add$1(activationCoordinates, translate) : null;
  const scrollOffsets = useScrollOffsets(scrollableAncestors);
  const scrollAdjustment = useScrollOffsetsDelta(scrollOffsets);
  const activeNodeScrollDelta = useScrollOffsetsDelta(scrollOffsets, [activeNodeRect]);
  const scrollAdjustedTranslate = add$1(modifiedTranslate, scrollAdjustment);
  const collisionRect = draggingNodeRect ? getAdjustedRect(draggingNodeRect, modifiedTranslate) : null;
  const collisions = active && collisionRect ? collisionDetection({
    active,
    collisionRect,
    droppableRects,
    droppableContainers: enabledDroppableContainers,
    pointerCoordinates
  }) : null;
  const overId = getFirstCollision(collisions, "id");
  const [over, setOver] = useState(null);
  const appliedTranslate = usesDragOverlay ? modifiedTranslate : add$1(modifiedTranslate, activeNodeScrollDelta);
  const transform = adjustScale(appliedTranslate, (_over$rect = over == null ? void 0 : over.rect) != null ? _over$rect : null, activeNodeRect);
  const activeSensorRef = useRef(null);
  const instantiateSensor = useCallback(
    (event, _ref2) => {
      let {
        sensor: Sensor,
        options
      } = _ref2;
      if (activeRef.current == null) {
        return;
      }
      const activeNode2 = draggableNodes.get(activeRef.current);
      if (!activeNode2) {
        return;
      }
      const activatorEvent2 = event.nativeEvent;
      const sensorInstance = new Sensor({
        active: activeRef.current,
        activeNode: activeNode2,
        event: activatorEvent2,
        options,
        // Sensors need to be instantiated with refs for arguments that change over time
        // otherwise they are frozen in time with the stale arguments
        context: sensorContext,
        onAbort(id3) {
          const draggableNode = draggableNodes.get(id3);
          if (!draggableNode) {
            return;
          }
          const {
            onDragAbort
          } = latestProps.current;
          const event2 = {
            id: id3
          };
          onDragAbort == null ? void 0 : onDragAbort(event2);
          dispatchMonitorEvent({
            type: "onDragAbort",
            event: event2
          });
        },
        onPending(id3, constraint, initialCoordinates, offset2) {
          const draggableNode = draggableNodes.get(id3);
          if (!draggableNode) {
            return;
          }
          const {
            onDragPending
          } = latestProps.current;
          const event2 = {
            id: id3,
            constraint,
            initialCoordinates,
            offset: offset2
          };
          onDragPending == null ? void 0 : onDragPending(event2);
          dispatchMonitorEvent({
            type: "onDragPending",
            event: event2
          });
        },
        onStart(initialCoordinates) {
          const id3 = activeRef.current;
          if (id3 == null) {
            return;
          }
          const draggableNode = draggableNodes.get(id3);
          if (!draggableNode) {
            return;
          }
          const {
            onDragStart
          } = latestProps.current;
          const event2 = {
            activatorEvent: activatorEvent2,
            active: {
              id: id3,
              data: draggableNode.data,
              rect: activeRects
            }
          };
          unstable_batchedUpdates(() => {
            onDragStart == null ? void 0 : onDragStart(event2);
            setStatus(Status.Initializing);
            dispatch({
              type: Action.DragStart,
              initialCoordinates,
              active: id3
            });
            dispatchMonitorEvent({
              type: "onDragStart",
              event: event2
            });
            setActiveSensor(activeSensorRef.current);
            setActivatorEvent(activatorEvent2);
          });
        },
        onMove(coordinates) {
          dispatch({
            type: Action.DragMove,
            coordinates
          });
        },
        onEnd: createHandler(Action.DragEnd),
        onCancel: createHandler(Action.DragCancel)
      });
      activeSensorRef.current = sensorInstance;
      function createHandler(type) {
        return async function handler() {
          const {
            active: active2,
            collisions: collisions2,
            over: over2,
            scrollAdjustedTranslate: scrollAdjustedTranslate2
          } = sensorContext.current;
          let event2 = null;
          if (active2 && scrollAdjustedTranslate2) {
            const {
              cancelDrop
            } = latestProps.current;
            event2 = {
              activatorEvent: activatorEvent2,
              active: active2,
              collisions: collisions2,
              delta: scrollAdjustedTranslate2,
              over: over2
            };
            if (type === Action.DragEnd && typeof cancelDrop === "function") {
              const shouldCancel = await Promise.resolve(cancelDrop(event2));
              if (shouldCancel) {
                type = Action.DragCancel;
              }
            }
          }
          activeRef.current = null;
          unstable_batchedUpdates(() => {
            dispatch({
              type
            });
            setStatus(Status.Uninitialized);
            setOver(null);
            setActiveSensor(null);
            setActivatorEvent(null);
            activeSensorRef.current = null;
            const eventName = type === Action.DragEnd ? "onDragEnd" : "onDragCancel";
            if (event2) {
              const handler2 = latestProps.current[eventName];
              handler2 == null ? void 0 : handler2(event2);
              dispatchMonitorEvent({
                type: eventName,
                event: event2
              });
            }
          });
        };
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [draggableNodes]
  );
  const bindActivatorToSensorInstantiator = useCallback((handler, sensor) => {
    return (event, active2) => {
      const nativeEvent = event.nativeEvent;
      const activeDraggableNode = draggableNodes.get(active2);
      if (
        // Another sensor is already instantiating
        activeRef.current !== null || // No active draggable
        !activeDraggableNode || // Event has already been captured
        nativeEvent.dndKit || nativeEvent.defaultPrevented
      ) {
        return;
      }
      const activationContext = {
        active: activeDraggableNode
      };
      const shouldActivate = handler(event, sensor.options, activationContext);
      if (shouldActivate === true) {
        nativeEvent.dndKit = {
          capturedBy: sensor.sensor
        };
        activeRef.current = active2;
        instantiateSensor(event, sensor);
      }
    };
  }, [draggableNodes, instantiateSensor]);
  const activators = useCombineActivators(sensors, bindActivatorToSensorInstantiator);
  useSensorSetup(sensors);
  useIsomorphicLayoutEffect(() => {
    if (activeNodeRect && status === Status.Initializing) {
      setStatus(Status.Initialized);
    }
  }, [activeNodeRect, status]);
  useEffect(
    () => {
      const {
        onDragMove
      } = latestProps.current;
      const {
        active: active2,
        activatorEvent: activatorEvent2,
        collisions: collisions2,
        over: over2
      } = sensorContext.current;
      if (!active2 || !activatorEvent2) {
        return;
      }
      const event = {
        active: active2,
        activatorEvent: activatorEvent2,
        collisions: collisions2,
        delta: {
          x: scrollAdjustedTranslate.x,
          y: scrollAdjustedTranslate.y
        },
        over: over2
      };
      unstable_batchedUpdates(() => {
        onDragMove == null ? void 0 : onDragMove(event);
        dispatchMonitorEvent({
          type: "onDragMove",
          event
        });
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [scrollAdjustedTranslate.x, scrollAdjustedTranslate.y]
  );
  useEffect(
    () => {
      const {
        active: active2,
        activatorEvent: activatorEvent2,
        collisions: collisions2,
        droppableContainers: droppableContainers2,
        scrollAdjustedTranslate: scrollAdjustedTranslate2
      } = sensorContext.current;
      if (!active2 || activeRef.current == null || !activatorEvent2 || !scrollAdjustedTranslate2) {
        return;
      }
      const {
        onDragOver
      } = latestProps.current;
      const overContainer = droppableContainers2.get(overId);
      const over2 = overContainer && overContainer.rect.current ? {
        id: overContainer.id,
        rect: overContainer.rect.current,
        data: overContainer.data,
        disabled: overContainer.disabled
      } : null;
      const event = {
        active: active2,
        activatorEvent: activatorEvent2,
        collisions: collisions2,
        delta: {
          x: scrollAdjustedTranslate2.x,
          y: scrollAdjustedTranslate2.y
        },
        over: over2
      };
      unstable_batchedUpdates(() => {
        setOver(over2);
        onDragOver == null ? void 0 : onDragOver(event);
        dispatchMonitorEvent({
          type: "onDragOver",
          event
        });
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [overId]
  );
  useIsomorphicLayoutEffect(() => {
    sensorContext.current = {
      activatorEvent,
      active,
      activeNode,
      collisionRect,
      collisions,
      droppableRects,
      draggableNodes,
      draggingNode,
      draggingNodeRect,
      droppableContainers,
      over,
      scrollableAncestors,
      scrollAdjustedTranslate
    };
    activeRects.current = {
      initial: draggingNodeRect,
      translated: collisionRect
    };
  }, [active, activeNode, collisions, collisionRect, draggableNodes, draggingNode, draggingNodeRect, droppableRects, droppableContainers, over, scrollableAncestors, scrollAdjustedTranslate]);
  useAutoScroller({
    ...autoScrollOptions,
    delta: translate,
    draggingRect: collisionRect,
    pointerCoordinates,
    scrollableAncestors,
    scrollableAncestorRects
  });
  const publicContext = useMemo(() => {
    const context = {
      active,
      activeNode,
      activeNodeRect,
      activatorEvent,
      collisions,
      containerNodeRect,
      dragOverlay,
      draggableNodes,
      droppableContainers,
      droppableRects,
      over,
      measureDroppableContainers,
      scrollableAncestors,
      scrollableAncestorRects,
      measuringConfiguration,
      measuringScheduled,
      windowRect
    };
    return context;
  }, [active, activeNode, activeNodeRect, activatorEvent, collisions, containerNodeRect, dragOverlay, draggableNodes, droppableContainers, droppableRects, over, measureDroppableContainers, scrollableAncestors, scrollableAncestorRects, measuringConfiguration, measuringScheduled, windowRect]);
  const internalContext = useMemo(() => {
    const context = {
      activatorEvent,
      activators,
      active,
      activeNodeRect,
      ariaDescribedById: {
        draggable: draggableDescribedById
      },
      dispatch,
      draggableNodes,
      over,
      measureDroppableContainers
    };
    return context;
  }, [activatorEvent, activators, active, activeNodeRect, dispatch, draggableDescribedById, draggableNodes, over, measureDroppableContainers]);
  return React__default.createElement(DndMonitorContext.Provider, {
    value: registerMonitorListener
  }, React__default.createElement(InternalContext.Provider, {
    value: internalContext
  }, React__default.createElement(PublicContext.Provider, {
    value: publicContext
  }, React__default.createElement(ActiveDraggableContext.Provider, {
    value: transform
  }, children)), React__default.createElement(RestoreFocus, {
    disabled: (accessibility == null ? void 0 : accessibility.restoreFocus) === false
  })), React__default.createElement(Accessibility, {
    ...accessibility,
    hiddenTextDescribedById: draggableDescribedById
  }));
  function getAutoScrollerOptions() {
    const activeSensorDisablesAutoscroll = (activeSensor == null ? void 0 : activeSensor.autoScrollEnabled) === false;
    const autoScrollGloballyDisabled = typeof autoScroll === "object" ? autoScroll.enabled === false : autoScroll === false;
    const enabled = isInitialized && !activeSensorDisablesAutoscroll && !autoScrollGloballyDisabled;
    if (typeof autoScroll === "object") {
      return {
        ...autoScroll,
        enabled
      };
    }
    return {
      enabled
    };
  }
});
const NullContext = /* @__PURE__ */ createContext(null);
const defaultRole = "button";
const ID_PREFIX$1 = "Draggable";
function useDraggable(_ref) {
  let {
    id: id2,
    data,
    disabled = false,
    attributes
  } = _ref;
  const key = useUniqueId(ID_PREFIX$1);
  const {
    activators,
    activatorEvent,
    active,
    activeNodeRect,
    ariaDescribedById,
    draggableNodes,
    over
  } = useContext(InternalContext);
  const {
    role = defaultRole,
    roleDescription = "draggable",
    tabIndex = 0
  } = attributes != null ? attributes : {};
  const isDragging = (active == null ? void 0 : active.id) === id2;
  const transform = useContext(isDragging ? ActiveDraggableContext : NullContext);
  const [node, setNodeRef] = useNodeRef();
  const [activatorNode, setActivatorNodeRef] = useNodeRef();
  const listeners = useSyntheticListeners(activators, id2);
  const dataRef = useLatestValue(data);
  useIsomorphicLayoutEffect(
    () => {
      draggableNodes.set(id2, {
        id: id2,
        key,
        node,
        activatorNode,
        data: dataRef
      });
      return () => {
        const node2 = draggableNodes.get(id2);
        if (node2 && node2.key === key) {
          draggableNodes.delete(id2);
        }
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [draggableNodes, id2]
  );
  const memoizedAttributes = useMemo(() => ({
    role,
    tabIndex,
    "aria-disabled": disabled,
    "aria-pressed": isDragging && role === defaultRole ? true : void 0,
    "aria-roledescription": roleDescription,
    "aria-describedby": ariaDescribedById.draggable
  }), [disabled, role, tabIndex, isDragging, roleDescription, ariaDescribedById.draggable]);
  return {
    active,
    activatorEvent,
    activeNodeRect,
    attributes: memoizedAttributes,
    isDragging,
    listeners: disabled ? void 0 : listeners,
    node,
    over,
    setNodeRef,
    setActivatorNodeRef,
    transform
  };
}
function useDndContext() {
  return useContext(PublicContext);
}
const ID_PREFIX$1$1 = "Droppable";
const defaultResizeObserverConfig = {
  timeout: 25
};
function useDroppable(_ref) {
  let {
    data,
    disabled = false,
    id: id2,
    resizeObserverConfig
  } = _ref;
  const key = useUniqueId(ID_PREFIX$1$1);
  const {
    active,
    dispatch,
    over,
    measureDroppableContainers
  } = useContext(InternalContext);
  const previous = useRef({
    disabled
  });
  const resizeObserverConnected = useRef(false);
  const rect = useRef(null);
  const callbackId = useRef(null);
  const {
    disabled: resizeObserverDisabled,
    updateMeasurementsFor,
    timeout: resizeObserverTimeout
  } = {
    ...defaultResizeObserverConfig,
    ...resizeObserverConfig
  };
  const ids2 = useLatestValue(updateMeasurementsFor != null ? updateMeasurementsFor : id2);
  const handleResize = useCallback(
    () => {
      if (!resizeObserverConnected.current) {
        resizeObserverConnected.current = true;
        return;
      }
      if (callbackId.current != null) {
        clearTimeout(callbackId.current);
      }
      callbackId.current = setTimeout(() => {
        measureDroppableContainers(Array.isArray(ids2.current) ? ids2.current : [ids2.current]);
        callbackId.current = null;
      }, resizeObserverTimeout);
    },
    //eslint-disable-next-line react-hooks/exhaustive-deps
    [resizeObserverTimeout]
  );
  const resizeObserver = useResizeObserver({
    callback: handleResize,
    disabled: resizeObserverDisabled || !active
  });
  const handleNodeChange = useCallback((newElement, previousElement) => {
    if (!resizeObserver) {
      return;
    }
    if (previousElement) {
      resizeObserver.unobserve(previousElement);
      resizeObserverConnected.current = false;
    }
    if (newElement) {
      resizeObserver.observe(newElement);
    }
  }, [resizeObserver]);
  const [nodeRef, setNodeRef] = useNodeRef(handleNodeChange);
  const dataRef = useLatestValue(data);
  useEffect(() => {
    if (!resizeObserver || !nodeRef.current) {
      return;
    }
    resizeObserver.disconnect();
    resizeObserverConnected.current = false;
    resizeObserver.observe(nodeRef.current);
  }, [nodeRef, resizeObserver]);
  useEffect(
    () => {
      dispatch({
        type: Action.RegisterDroppable,
        element: {
          id: id2,
          key,
          disabled,
          node: nodeRef,
          rect,
          data: dataRef
        }
      });
      return () => dispatch({
        type: Action.UnregisterDroppable,
        key,
        id: id2
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [id2]
  );
  useEffect(() => {
    if (disabled !== previous.current.disabled) {
      dispatch({
        type: Action.SetDroppableDisabled,
        id: id2,
        key,
        disabled
      });
      previous.current.disabled = disabled;
    }
  }, [id2, key, disabled, dispatch]);
  return {
    active,
    rect,
    isOver: (over == null ? void 0 : over.id) === id2,
    node: nodeRef,
    over,
    setNodeRef
  };
}
const restrictToVerticalAxis = (_ref) => {
  let {
    transform
  } = _ref;
  return {
    ...transform,
    x: 0
  };
};
function getContainerById(children, id2) {
  var _a;
  const lists = React__default.Children.toArray(children).filter(
    (child) => child.type.displayName === "SortableList"
  );
  const list = lists.find(
    (list2) => list2.props.id === id2
  );
  if (list) {
    return list == null ? void 0 : list.props;
  }
  return (_a = lists.find((l2) => React__default.Children.toArray(l2.props.children).findIndex((child) => child.props.id === id2) > -1)) == null ? void 0 : _a.props;
}
function Container$1(externalProps) {
  const { children, reorder, move } = externalProps;
  function handleDragOver(event) {
    const { active, over } = event;
    if (!(active == null ? void 0 : active.id) || !(over == null ? void 0 : over.id)) {
      return;
    }
    const activeList = getContainerById(children, active.id);
    const overList = getContainerById(children, over.id);
    if (!(activeList == null ? void 0 : activeList.id) || !(overList == null ? void 0 : overList.id) || activeList.id === overList.id) {
      return;
    }
    move(active.id, activeList == null ? void 0 : activeList.id, overList.id);
  }
  function handleDragEnd(event) {
    const { active, over } = event;
    if (!(active == null ? void 0 : active.id) || !(over == null ? void 0 : over.id)) {
      return;
    }
    const activeList = getContainerById(children, active.id);
    const overList = getContainerById(children, over.id);
    if (!(activeList == null ? void 0 : activeList.id) || !(overList == null ? void 0 : overList.id) || activeList.id !== overList.id) {
      return;
    }
    reorder(active.id, over.id, overList.id);
  }
  return /* @__PURE__ */ React__default.createElement(
    DndContext,
    {
      collisionDetection: closestCenter,
      ...externalProps,
      modifiers: [restrictToVerticalAxis],
      onDragOver: handleDragOver,
      onDragEnd: handleDragEnd
    },
    children
  );
}
Container$1.displayName = "SortableContainer";
function arrayMove(array2, from, to) {
  const newArray = array2.slice();
  newArray.splice(to < 0 ? newArray.length + to : to, 0, newArray.splice(from, 1)[0]);
  return newArray;
}
function getSortedRects(items, rects) {
  return items.reduce((accumulator, id2, index2) => {
    const rect = rects.get(id2);
    if (rect) {
      accumulator[index2] = rect;
    }
    return accumulator;
  }, Array(items.length));
}
function isValidIndex(index2) {
  return index2 !== null && index2 >= 0;
}
function itemsEqual(a4, b3) {
  if (a4 === b3) {
    return true;
  }
  if (a4.length !== b3.length) {
    return false;
  }
  for (let i3 = 0; i3 < a4.length; i3++) {
    if (a4[i3] !== b3[i3]) {
      return false;
    }
  }
  return true;
}
function normalizeDisabled(disabled) {
  if (typeof disabled === "boolean") {
    return {
      draggable: disabled,
      droppable: disabled
    };
  }
  return disabled;
}
const rectSortingStrategy = (_ref) => {
  let {
    rects,
    activeIndex,
    overIndex,
    index: index2
  } = _ref;
  const newRects = arrayMove(rects, overIndex, activeIndex);
  const oldRect = rects[index2];
  const newRect = newRects[index2];
  if (!newRect || !oldRect) {
    return null;
  }
  return {
    x: newRect.left - oldRect.left,
    y: newRect.top - oldRect.top,
    scaleX: newRect.width / oldRect.width,
    scaleY: newRect.height / oldRect.height
  };
};
const defaultScale$1 = {
  scaleX: 1,
  scaleY: 1
};
const verticalListSortingStrategy = (_ref) => {
  var _rects$activeIndex;
  let {
    activeIndex,
    activeNodeRect: fallbackActiveRect,
    index: index2,
    rects,
    overIndex
  } = _ref;
  const activeNodeRect = (_rects$activeIndex = rects[activeIndex]) != null ? _rects$activeIndex : fallbackActiveRect;
  if (!activeNodeRect) {
    return null;
  }
  if (index2 === activeIndex) {
    const overIndexRect = rects[overIndex];
    if (!overIndexRect) {
      return null;
    }
    return {
      x: 0,
      y: activeIndex < overIndex ? overIndexRect.top + overIndexRect.height - (activeNodeRect.top + activeNodeRect.height) : overIndexRect.top - activeNodeRect.top,
      ...defaultScale$1
    };
  }
  const itemGap = getItemGap$1(rects, index2, activeIndex);
  if (index2 > activeIndex && index2 <= overIndex) {
    return {
      x: 0,
      y: -activeNodeRect.height - itemGap,
      ...defaultScale$1
    };
  }
  if (index2 < activeIndex && index2 >= overIndex) {
    return {
      x: 0,
      y: activeNodeRect.height + itemGap,
      ...defaultScale$1
    };
  }
  return {
    x: 0,
    y: 0,
    ...defaultScale$1
  };
};
function getItemGap$1(clientRects, index2, activeIndex) {
  const currentRect = clientRects[index2];
  const previousRect = clientRects[index2 - 1];
  const nextRect = clientRects[index2 + 1];
  if (!currentRect) {
    return 0;
  }
  if (activeIndex < index2) {
    return previousRect ? currentRect.top - (previousRect.top + previousRect.height) : nextRect ? nextRect.top - (currentRect.top + currentRect.height) : 0;
  }
  return nextRect ? nextRect.top - (currentRect.top + currentRect.height) : previousRect ? currentRect.top - (previousRect.top + previousRect.height) : 0;
}
const ID_PREFIX = "Sortable";
const Context = /* @__PURE__ */ React__default.createContext({
  activeIndex: -1,
  containerId: ID_PREFIX,
  disableTransforms: false,
  items: [],
  overIndex: -1,
  useDragOverlay: false,
  sortedRects: [],
  strategy: rectSortingStrategy,
  disabled: {
    draggable: false,
    droppable: false
  }
});
function SortableContext(_ref) {
  let {
    children,
    id: id2,
    items: userDefinedItems,
    strategy = rectSortingStrategy,
    disabled: disabledProp = false
  } = _ref;
  const {
    active,
    dragOverlay,
    droppableRects,
    over,
    measureDroppableContainers
  } = useDndContext();
  const containerId = useUniqueId(ID_PREFIX, id2);
  const useDragOverlay = Boolean(dragOverlay.rect !== null);
  const items = useMemo(() => userDefinedItems.map((item) => typeof item === "object" && "id" in item ? item.id : item), [userDefinedItems]);
  const isDragging = active != null;
  const activeIndex = active ? items.indexOf(active.id) : -1;
  const overIndex = over ? items.indexOf(over.id) : -1;
  const previousItemsRef = useRef(items);
  const itemsHaveChanged = !itemsEqual(items, previousItemsRef.current);
  const disableTransforms = overIndex !== -1 && activeIndex === -1 || itemsHaveChanged;
  const disabled = normalizeDisabled(disabledProp);
  useIsomorphicLayoutEffect(() => {
    if (itemsHaveChanged && isDragging) {
      measureDroppableContainers(items);
    }
  }, [itemsHaveChanged, items, isDragging, measureDroppableContainers]);
  useEffect(() => {
    previousItemsRef.current = items;
  }, [items]);
  const contextValue = useMemo(
    () => ({
      activeIndex,
      containerId,
      disabled,
      disableTransforms,
      items,
      overIndex,
      useDragOverlay,
      sortedRects: getSortedRects(items, droppableRects),
      strategy
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [activeIndex, containerId, disabled.draggable, disabled.droppable, disableTransforms, items, overIndex, droppableRects, useDragOverlay, strategy]
  );
  return React__default.createElement(Context.Provider, {
    value: contextValue
  }, children);
}
const defaultNewIndexGetter = (_ref) => {
  let {
    id: id2,
    items,
    activeIndex,
    overIndex
  } = _ref;
  return arrayMove(items, activeIndex, overIndex).indexOf(id2);
};
const defaultAnimateLayoutChanges = (_ref2) => {
  let {
    containerId,
    isSorting,
    wasDragging,
    index: index2,
    items,
    newIndex,
    previousItems,
    previousContainerId,
    transition
  } = _ref2;
  if (!transition || !wasDragging) {
    return false;
  }
  if (previousItems !== items && index2 === newIndex) {
    return false;
  }
  if (isSorting) {
    return true;
  }
  return newIndex !== index2 && containerId === previousContainerId;
};
const defaultTransition = {
  duration: 200,
  easing: "ease"
};
const transitionProperty = "transform";
const disabledTransition = /* @__PURE__ */ CSS$1.Transition.toString({
  property: transitionProperty,
  duration: 0,
  easing: "linear"
});
const defaultAttributes = {
  roleDescription: "sortable"
};
function useDerivedTransform(_ref) {
  let {
    disabled,
    index: index2,
    node,
    rect
  } = _ref;
  const [derivedTransform, setDerivedtransform] = useState(null);
  const previousIndex = useRef(index2);
  useIsomorphicLayoutEffect(() => {
    if (!disabled && index2 !== previousIndex.current && node.current) {
      const initial = rect.current;
      if (initial) {
        const current = getClientRect$2(node.current, {
          ignoreTransform: true
        });
        const delta = {
          x: initial.left - current.left,
          y: initial.top - current.top,
          scaleX: initial.width / current.width,
          scaleY: initial.height / current.height
        };
        if (delta.x || delta.y) {
          setDerivedtransform(delta);
        }
      }
    }
    if (index2 !== previousIndex.current) {
      previousIndex.current = index2;
    }
  }, [disabled, index2, node, rect]);
  useEffect(() => {
    if (derivedTransform) {
      setDerivedtransform(null);
    }
  }, [derivedTransform]);
  return derivedTransform;
}
function useSortable(_ref) {
  let {
    animateLayoutChanges = defaultAnimateLayoutChanges,
    attributes: userDefinedAttributes,
    disabled: localDisabled,
    data: customData,
    getNewIndex = defaultNewIndexGetter,
    id: id2,
    strategy: localStrategy,
    resizeObserverConfig,
    transition = defaultTransition
  } = _ref;
  const {
    items,
    containerId,
    activeIndex,
    disabled: globalDisabled,
    disableTransforms,
    sortedRects,
    overIndex,
    useDragOverlay,
    strategy: globalStrategy
  } = useContext(Context);
  const disabled = normalizeLocalDisabled(localDisabled, globalDisabled);
  const index2 = items.indexOf(id2);
  const data = useMemo(() => ({
    sortable: {
      containerId,
      index: index2,
      items
    },
    ...customData
  }), [containerId, customData, index2, items]);
  const itemsAfterCurrentSortable = useMemo(() => items.slice(items.indexOf(id2)), [items, id2]);
  const {
    rect,
    node,
    isOver,
    setNodeRef: setDroppableNodeRef
  } = useDroppable({
    id: id2,
    data,
    disabled: disabled.droppable,
    resizeObserverConfig: {
      updateMeasurementsFor: itemsAfterCurrentSortable,
      ...resizeObserverConfig
    }
  });
  const {
    active,
    activatorEvent,
    activeNodeRect,
    attributes,
    setNodeRef: setDraggableNodeRef,
    listeners,
    isDragging,
    over,
    setActivatorNodeRef,
    transform
  } = useDraggable({
    id: id2,
    data,
    attributes: {
      ...defaultAttributes,
      ...userDefinedAttributes
    },
    disabled: disabled.draggable
  });
  const setNodeRef = useCombinedRefs(setDroppableNodeRef, setDraggableNodeRef);
  const isSorting = Boolean(active);
  const displaceItem = isSorting && !disableTransforms && isValidIndex(activeIndex) && isValidIndex(overIndex);
  const shouldDisplaceDragSource = !useDragOverlay && isDragging;
  const dragSourceDisplacement = shouldDisplaceDragSource && displaceItem ? transform : null;
  const strategy = localStrategy != null ? localStrategy : globalStrategy;
  const finalTransform = displaceItem ? dragSourceDisplacement != null ? dragSourceDisplacement : strategy({
    rects: sortedRects,
    activeNodeRect,
    activeIndex,
    overIndex,
    index: index2
  }) : null;
  const newIndex = isValidIndex(activeIndex) && isValidIndex(overIndex) ? getNewIndex({
    id: id2,
    items,
    activeIndex,
    overIndex
  }) : index2;
  const activeId = active == null ? void 0 : active.id;
  const previous = useRef({
    activeId,
    items,
    newIndex,
    containerId
  });
  const itemsHaveChanged = items !== previous.current.items;
  const shouldAnimateLayoutChanges = animateLayoutChanges({
    active,
    containerId,
    isDragging,
    isSorting,
    id: id2,
    index: index2,
    items,
    newIndex: previous.current.newIndex,
    previousItems: previous.current.items,
    previousContainerId: previous.current.containerId,
    transition,
    wasDragging: previous.current.activeId != null
  });
  const derivedTransform = useDerivedTransform({
    disabled: !shouldAnimateLayoutChanges,
    index: index2,
    node,
    rect
  });
  useEffect(() => {
    if (isSorting && previous.current.newIndex !== newIndex) {
      previous.current.newIndex = newIndex;
    }
    if (containerId !== previous.current.containerId) {
      previous.current.containerId = containerId;
    }
    if (items !== previous.current.items) {
      previous.current.items = items;
    }
  }, [isSorting, newIndex, containerId, items]);
  useEffect(() => {
    if (activeId === previous.current.activeId) {
      return;
    }
    if (activeId && !previous.current.activeId) {
      previous.current.activeId = activeId;
      return;
    }
    const timeoutId = setTimeout(() => {
      previous.current.activeId = activeId;
    }, 50);
    return () => clearTimeout(timeoutId);
  }, [activeId]);
  return {
    active,
    activeIndex,
    attributes,
    data,
    rect,
    index: index2,
    newIndex,
    items,
    isOver,
    isSorting,
    isDragging,
    listeners,
    node,
    overIndex,
    over,
    setNodeRef,
    setActivatorNodeRef,
    setDroppableNodeRef,
    setDraggableNodeRef,
    transform: derivedTransform != null ? derivedTransform : finalTransform,
    transition: getTransition()
  };
  function getTransition() {
    if (
      // Temporarily disable transitions for a single frame to set up derived transforms
      derivedTransform || // Or to prevent items jumping to back to their "new" position when items change
      itemsHaveChanged && previous.current.newIndex === index2
    ) {
      return disabledTransition;
    }
    if (shouldDisplaceDragSource && !isKeyboardEvent(activatorEvent) || !transition) {
      return void 0;
    }
    if (isSorting || shouldAnimateLayoutChanges) {
      return CSS$1.Transition.toString({
        ...transition,
        property: transitionProperty
      });
    }
    return void 0;
  }
}
function normalizeLocalDisabled(localDisabled, globalDisabled) {
  var _localDisabled$dragga, _localDisabled$droppa;
  if (typeof localDisabled === "boolean") {
    return {
      draggable: localDisabled,
      // Backwards compatibility
      droppable: false
    };
  }
  return {
    draggable: (_localDisabled$dragga = localDisabled == null ? void 0 : localDisabled.draggable) != null ? _localDisabled$dragga : globalDisabled.draggable,
    droppable: (_localDisabled$droppa = localDisabled == null ? void 0 : localDisabled.droppable) != null ? _localDisabled$droppa : globalDisabled.droppable
  };
}
[KeyboardCode.Down, KeyboardCode.Right, KeyboardCode.Up, KeyboardCode.Left];
const isFormElement = (element) => {
  const formElementNodeNames = ["BUTTON", "INPUT", "TEXTAREA", "SELECT", "FIELDSET"];
  return formElementNodeNames.includes(element.nodeName);
};
function Item(props) {
  const { asChild, children, disabled = false, id: id2 } = props;
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ disabled, id: id2 });
  const style = {
    transform: CSS$1.Transform.toString(transform),
    transition
  };
  const onPointerDown = (event) => {
    if (event.currentTarget.contains(event.target) && !isFormElement(event.target)) {
      listeners == null ? void 0 : listeners.onPointerDown(event);
    }
  };
  const elProps = { ...attributes, ...listeners, onPointerDown, ref: setNodeRef, style };
  if (asChild) {
    return React__default.cloneElement(children, elProps);
  }
  return /* @__PURE__ */ React__default.createElement("div", { ...elProps }, children);
}
Item.displayName = "SortableListItem";
function List(externalProps) {
  const { children, id: id2, ...props } = externalProps;
  const { setNodeRef } = useDroppable({ id: id2 });
  const items = React__default.Children.toArray(children).map((child) => child.props);
  return /* @__PURE__ */ React__default.createElement(SortableContext, { id: id2, items, strategy: verticalListSortingStrategy }, /* @__PURE__ */ React__default.createElement("div", { ...props, ref: id2 ? setNodeRef : void 0 }, children));
}
List.displayName = "SortableList";
const Column$3 = React__default.forwardRef(function Column2(props, ref) {
  var _a, _b, _c;
  const { column, draggable = false, ...dragAttributes } = props;
  const canHide = column.getCanHide();
  const className = clsx("group/column flex items-center gap-x-2 rounded py-1 px-2", {
    "hover:bg-grey-200": canHide || draggable,
    "hover:cursor-pointer": canHide,
    "active:cursor-move active:bg-grey-300": draggable
  });
  const attributes = draggable ? dragAttributes : void 0;
  const isVisible2 = column.getIsVisible();
  const parentHeader = (_b = (_a = column.parent) == null ? void 0 : _a.columnDef) == null ? void 0 : _b.header;
  return /* @__PURE__ */ React__default.createElement("div", { ...attributes, className, onClick: () => column.toggleVisibility(!isVisible2), ref }, draggable ? /* @__PURE__ */ React__default.createElement(Icon$1, { name: "drag", className: "text-grey-500 group-hover/column:text-grey-700 -mx-2 !h-5" }) : null, /* @__PURE__ */ React__default.createElement("span", { className: "flex-grow truncate" }, (_c = column.columnDef.meta) == null ? void 0 : _c.header, parentHeader ? /* @__PURE__ */ React__default.createElement("span", { className: "italic" }, "(", parentHeader, ")") : null), canHide ? /* @__PURE__ */ React__default.createElement(Checkbox$2, { checked: isVisible2, onChange: () => column.toggleVisibility(!isVisible2) }) : null);
});
function HideOrOrderPopover(props) {
  const { table, trigger, ...popoverProps } = props;
  const { texts } = useLocalization();
  const [query, setQuery] = React__default.useState("");
  const allColumns = table.getAllLeafColumns();
  const tableMeta = table.options.meta;
  const columns = React__default.useMemo(
    () => allColumns.filter((column) => !isInternalColumn(column.id)).filter(
      (column) => {
        var _a, _b, _c;
        return (query == null ? void 0 : query.length) ? ((_a = column.columnDef.meta) == null ? void 0 : _a.header.toLowerCase().includes(query.toLowerCase())) || ((_c = (_b = column.parent) == null ? void 0 : _b.columnDef.meta) == null ? void 0 : _c.header.toLowerCase().includes(query.toLowerCase())) : true;
      }
    ),
    [allColumns, query]
  );
  const listClassName = "flex max-h-64 flex-col gap-y-px overflow-auto";
  const handleReorder = (activeId, overId) => {
    var _a;
    if (columns.find((column) => {
      var _a2;
      return column.id === overId && ((_a2 = column.columnDef.meta) == null ? void 0 : _a2.enableOrdering) === false;
    })) {
      return;
    }
    const currentOrder = table.getState().columnOrder;
    const nextOrder = ensureOrdering(
      allColumns,
      arrayMove(
        currentOrder,
        currentOrder.findIndex((c3) => c3 === activeId),
        currentOrder.findIndex((c3) => c3 === overId)
      )
    );
    table.setColumnOrder(nextOrder);
    if (table.getIsSomeColumnsPinned()) {
      const currentFrozenIndex = ((_a = table.getState().columnPinning.left) == null ? void 0 : _a.length) ?? -1;
      if (currentFrozenIndex > -1) {
        table.setColumnPinning((currentPinning) => ({
          ...currentPinning,
          left: nextOrder.slice(0, currentFrozenIndex)
        }));
      }
    }
  };
  return /* @__PURE__ */ React__default.createElement(Popover, { ...popoverProps, anchor: trigger }, /* @__PURE__ */ React__default.createElement(Popover.Content, null, /* @__PURE__ */ React__default.createElement("div", { className: "flex min-w-[100px] max-w-sm flex-col gap-2" }, table.options.enableHiding ? /* @__PURE__ */ React__default.createElement(
    Input,
    {
      onChange: (event) => setQuery(event.target.value),
      placeholder: texts.table.columnSettings.search,
      value: query
    }
  ) : null, tableMeta.columnOrdering.isEnabled && columns.length && !(query == null ? void 0 : query.length) ? /* @__PURE__ */ React__default.createElement(Container$1, { reorder: handleReorder }, /* @__PURE__ */ React__default.createElement(List, { id: "columns", className: listClassName }, columns.filter((column) => !column.getIsGrouped()).map((column) => {
    var _a, _b;
    return /* @__PURE__ */ React__default.createElement(
      Item,
      {
        key: column.id,
        id: column.id,
        disabled: !((_a = column.columnDef.meta) == null ? void 0 : _a.enableOrdering),
        asChild: true
      },
      /* @__PURE__ */ React__default.createElement(Column$3, { column, draggable: (_b = column.columnDef.meta) == null ? void 0 : _b.enableOrdering })
    );
  }))) : /* @__PURE__ */ React__default.createElement("div", { className: listClassName }, columns.length ? columns.map((column) => /* @__PURE__ */ React__default.createElement(Column$3, { column, key: column.id })) : texts.table.columnSettings.noResults))));
}
function Settings(props) {
  const { customSettings, table } = props;
  const { texts } = useLocalization();
  const tableMeta = table.options.meta;
  const canHideOrOrder = table.options.enableHiding || tableMeta.columnOrdering.isEnabled;
  const canChangeFontSize = tableMeta.fontSize.isEnabled;
  const canChangeRowHeight = tableMeta.rowHeight.isEnabled;
  const [popover, setPopover] = React__default.useState(void 0);
  let popoverElement;
  if (popover) {
    const handleClosePopover = () => setPopover(void 0);
    switch (popover) {
      case "columnSettings": {
        if (canHideOrOrder) {
          popoverElement = (popoverProps) => /* @__PURE__ */ React__default.createElement(HideOrOrderPopover, { ...popoverProps, open: true, onChange: handleClosePopover, table });
        }
      }
    }
  }
  return /* @__PURE__ */ React__default.createElement(
    IconButton,
    {
      "aria-label": texts.table.otherOptions.tooltip,
      icon: "sliders",
      menu: popoverElement ? void 0 : (menuProps) => /* @__PURE__ */ React__default.createElement(Menu$1, { ...menuProps }, /* @__PURE__ */ React__default.createElement(Menu$1.Content, { align: "end" }, canHideOrOrder ? /* @__PURE__ */ React__default.createElement(Menu$1.Item, { icon: "columns", onClick: () => setPopover("columnSettings") }, texts.table.columnSettings.button) : null, canHideOrOrder && (canChangeRowHeight || canChangeFontSize || customSettings) ? /* @__PURE__ */ React__default.createElement(Menu$1.Separator, null) : null, canChangeRowHeight ? /* @__PURE__ */ React__default.createElement(
        Menu$1.Item,
        {
          icon: `height-${tableMeta.rowHeight.height}`,
          subMenu: () => /* @__PURE__ */ React__default.createElement(RowHeightMenuItem, { tableMeta })
        },
        texts.table.rowHeight.tooltip
      ) : null, canChangeFontSize ? /* @__PURE__ */ React__default.createElement(Menu$1.Item, { icon: "font-size", subMenu: () => /* @__PURE__ */ React__default.createElement(FontSizeMenuItem, { tableMeta }) }, texts.table.fontSize.tooltip) : null, customSettings ? /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, canChangeRowHeight || canChangeFontSize ? /* @__PURE__ */ React__default.createElement(Menu$1.Separator, null) : null, customSettings(getSettings(table)).map((item, index2) => /* @__PURE__ */ React__default.createElement(React__default.Fragment, { key: index2 }, item))) : null)),
      popover: popoverElement,
      onClickCapture: (event) => event.preventDefault(),
      tooltip: texts.table.otherOptions.tooltip
    }
  );
}
function FontSizeMenuItem({ tableMeta }) {
  const { texts } = useLocalization();
  return /* @__PURE__ */ React__default.createElement(Menu$1.SubMenu, null, /* @__PURE__ */ React__default.createElement(Menu$1.RadioGroup, { onChange: tableMeta.fontSize.setSize, value: tableMeta.fontSize.size }, /* @__PURE__ */ React__default.createElement(Menu$1.RadioGroup.Item, { value: FontSizes.small }, texts.table.fontSize.sizes.small), /* @__PURE__ */ React__default.createElement(Menu$1.RadioGroup.Item, { value: FontSizes.medium }, texts.table.fontSize.sizes.medium), /* @__PURE__ */ React__default.createElement(Menu$1.RadioGroup.Item, { disabled: tableMeta.rowHeight.height === "short", value: FontSizes.large }, texts.table.fontSize.sizes.large)));
}
function RowHeightMenuItem({ tableMeta }) {
  const { texts } = useLocalization();
  return /* @__PURE__ */ React__default.createElement(Menu$1.SubMenu, null, /* @__PURE__ */ React__default.createElement(Menu$1.RadioGroup, { onChange: tableMeta.rowHeight.setHeight, value: tableMeta.rowHeight.height }, /* @__PURE__ */ React__default.createElement(Menu$1.RadioGroup.Item, { value: "short" }, texts.table.rowHeight.sizes.short), /* @__PURE__ */ React__default.createElement(Menu$1.RadioGroup.Item, { value: "medium" }, texts.table.rowHeight.sizes.medium), /* @__PURE__ */ React__default.createElement(Menu$1.RadioGroup.Item, { value: "tall" }, texts.table.rowHeight.sizes.tall), /* @__PURE__ */ React__default.createElement(Menu$1.RadioGroup.Item, { value: "extra-tall" }, texts.table.rowHeight.sizes.extraTall)));
}
const isAriaSelectionKey = (event) => {
  if (event.key === "Enter" || event.key === " " || event.key === "Tab") {
    return true;
  }
  return false;
};
const isAriaDirectionKey = (event) => {
  if (event.key === "ArrowUp" || event.key === "ArrowDown" || event.key === "Home" || event.key === "End") {
    return true;
  }
  return false;
};
const getOptionsFromCollection = (collection, selector) => collection.querySelectorAll(selector);
const Root$1 = React__default.forwardRef(function CollectionRoot(props, ref) {
  const { querySelector: querySelector2, resetOnChange, tabIndex = 0, ...otherProps } = props;
  const internalRef = useMergedRef(ref);
  const [activeIndex, setActiveIndex] = React__default.useState();
  const isMultiselectable = props["aria-multiselectable"];
  const setActiveOption = (index2, collection, option) => {
    var _a;
    (_a = collection.querySelector(`[aria-current]`)) == null ? void 0 : _a.removeAttribute("aria-current");
    option.setAttribute("aria-current", "true");
    option.scrollIntoView({ block: "nearest" });
    setActiveIndex(index2);
  };
  const setActiveIndexByElement = React__default.useCallback(
    (option) => {
      if (internalRef.current) {
        if (option.matches(querySelector2)) {
          const options = getOptionsFromCollection(internalRef.current, querySelector2);
          const nextActiveIndex = Array.from(options).indexOf(option);
          if (nextActiveIndex > -1) {
            setActiveOption(nextActiveIndex, internalRef.current, option);
          }
        }
      }
    },
    [internalRef.current, querySelector2]
  );
  React__default.useEffect(() => {
    if (internalRef.current) {
      internalRef.current.setActiveIndexByElement = setActiveIndexByElement;
    }
  }, [internalRef.current]);
  React__default.useEffect(() => {
    if (internalRef.current) {
      const options = getOptionsFromCollection(internalRef.current, querySelector2);
      if (options.length && !isMultiselectable) {
        const firstSelected = internalRef.current.querySelector(`[aria-selected]`);
        if (firstSelected) {
          const selectedIndex = Array.from(options).indexOf(firstSelected);
          if (selectedIndex > -1 && selectedIndex !== activeIndex) {
            setActiveOption(selectedIndex, internalRef.current, firstSelected);
          }
        }
      }
    }
  }, [resetOnChange, isMultiselectable]);
  React__default.useEffect(() => {
    if (internalRef.current) {
      const options = getOptionsFromCollection(internalRef.current, querySelector2);
      if (options.length) {
        let selected = internalRef.current.querySelectorAll(`[aria-current="true"]`);
        if (selected.length === 0) {
          selected = internalRef.current.querySelectorAll(`[aria-selected]`);
        }
        if (selected.length === 1) {
          if (options) {
            const firstSelected = selected.item(0);
            const selectedIndex = Array.from(options).indexOf(firstSelected);
            if (selectedIndex > -1) {
              setActiveOption(selectedIndex, internalRef.current, firstSelected);
            }
          }
        } else {
          setActiveOption(0, internalRef.current, options.item(0));
        }
      }
    }
  }, [props.children]);
  const handleClick = (event) => {
    const target = event.target;
    const option = target.matches(querySelector2) ? target : target.closest(querySelector2);
    if (option) {
      const options = getOptionsFromCollection(event.currentTarget, querySelector2);
      const nextActiveIndex = Array.from(options).indexOf(option);
      if (nextActiveIndex > -1) {
        setActiveOption(nextActiveIndex, event.currentTarget, option);
      }
    }
  };
  const handleKeyDown = (event) => {
    var _a;
    if (event.target !== event.currentTarget) {
      return;
    }
    if (otherProps.onKeyDown) {
      otherProps.onKeyDown(event);
    }
    if (event.isDefaultPrevented()) {
      return;
    }
    const options = getOptionsFromCollection(event.currentTarget, querySelector2);
    if (options) {
      if (isAriaDirectionKey(event)) {
        event.preventDefault();
        event.stopPropagation();
        const nextActiveIndex = getNextEnabledItem(event, options, activeIndex);
        if (nextActiveIndex !== void 0 && nextActiveIndex !== activeIndex) {
          setActiveOption(nextActiveIndex, event.currentTarget, options.item(nextActiveIndex));
        }
      } else if (activeIndex !== void 0 && !!options.item(activeIndex)) {
        (_a = options.item(activeIndex)) == null ? void 0 : _a.dispatchEvent(createCustomKeyboardEvent(event));
      }
    }
  };
  return /* @__PURE__ */ React__default.createElement("div", { ...otherProps, onClick: handleClick, onKeyDown: handleKeyDown, ref: internalRef, tabIndex });
});
const getNextIndexFromKeycode = (event, length, activeIndex) => {
  switch (event.key) {
    case "ArrowUp":
      return activeIndex === void 0 ? length - 1 : activeIndex > 0 ? activeIndex - 1 : activeIndex;
    case "ArrowDown":
      return activeIndex === void 0 ? 0 : activeIndex < length - 1 ? activeIndex + 1 : activeIndex;
    case "Home":
      return 0;
    case "End":
      return length - 1;
    default:
      return;
  }
};
const getNextEnabledItem = (event, options, activeIndex, recurse = true) => {
  const nextIndex = getNextIndexFromKeycode(event, options.length, activeIndex);
  if (nextIndex !== void 0) {
    if (nextIndex === activeIndex) {
      return activeIndex;
    } else if (options.item(nextIndex) && isSkippableItem(options.item(nextIndex))) {
      if (recurse) {
        if (nextIndex === 0) {
          return getNextEnabledItem(
            new KeyboardEvent(event.type, { ...event, key: "ArrowDown" }),
            options,
            nextIndex,
            false
          );
        } else if (nextIndex === options.length - 1) {
          return getNextEnabledItem(
            new KeyboardEvent(event.type, { ...event, key: "ArrowUp" }),
            options,
            nextIndex,
            false
          );
        }
      }
      return getNextEnabledItem(event, options, nextIndex, recurse);
    }
  }
  return nextIndex;
};
const isSkippableItem = (element) => {
  return element.getAttribute("role") === "presentation" || !!element.hasAttribute("disabled") || !!element.getAttribute("aria-disabled") || !!element.getAttribute("aria-hidden");
};
const Collection$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Root: Root$1
}, Symbol.toStringTag, { value: "Module" }));
const Listbox2Context = React__default.createContext({});
const useListbox2Context = () => React__default.useContext(Listbox2Context);
const DEFAULT_SELECTOR = '[role="option"]';
const Root = React__default.forwardRef(function Listbox22(props, ref) {
  const {
    children,
    customSelector,
    disabled = false,
    id: nativeId,
    multiple,
    readOnly = false,
    setValue,
    title,
    value,
    ...otherProps
  } = props;
  const id2 = "listbox2-" + useId$1(nativeId);
  const context = React__default.useMemo(
    () => ({
      disabled,
      readOnly,
      setValue,
      value
    }),
    [disabled, readOnly, value]
  );
  return /* @__PURE__ */ React__default.createElement(Listbox2Context.Provider, { value: context }, /* @__PURE__ */ React__default.createElement("div", { "data-taco": "listbox2" }, /* @__PURE__ */ React__default.createElement(
    Root$1,
    {
      ...otherProps,
      "aria-multiselectable": multiple ? true : void 0,
      id: id2,
      querySelector: customSelector ? `${DEFAULT_SELECTOR}, ${customSelector}` : DEFAULT_SELECTOR,
      ref,
      resetOnChange: value,
      role: "listbox"
    },
    children
  )));
});
const createListboxValueSetter = (multiple, setValue) => (nextValue) => {
  setValue((value) => {
    if (Array.isArray(nextValue)) {
      return nextValue;
    }
    if (multiple) {
      if (value === void 0) {
        return [nextValue];
      } else if (Array.isArray(value)) {
        if (value.includes(nextValue)) {
          return value.filter((v2) => v2 !== nextValue);
        }
        return [...value, nextValue];
      } else if (value === nextValue) {
        return [];
      }
      return [value, nextValue];
    }
    return nextValue;
  });
};
const Option$1 = React__default.forwardRef(function Listbox2Option(props, ref) {
  const { disabled, id: nativeId, title, value, ...otherProps } = props;
  const { disabled: listboxDisabled, readOnly: listboxReadOnly, setValue, value: currentValue } = useListbox2Context();
  const id2 = "option-" + useId$1(nativeId);
  const selected = Array.isArray(currentValue) ? currentValue.includes(value) : currentValue === value;
  const handleClick = (event) => {
    if (disabled || listboxDisabled || listboxReadOnly) {
      event.stopPropagation();
      return;
    } else {
      setValue(value);
    }
    if (typeof props.onClick === "function") {
      props.onClick(event);
    }
  };
  const handleKeyDown = (event) => {
    if (disabled || listboxDisabled || listboxReadOnly) {
      event.stopPropagation();
      return;
    } else if (isAriaSelectionKey(event)) {
      setValue(value);
    }
    if (typeof props.onKeyDown === "function") {
      props.onKeyDown(event);
    }
  };
  return /* @__PURE__ */ React__default.createElement(
    "div",
    {
      ...otherProps,
      "aria-disabled": listboxDisabled || disabled ? "true" : void 0,
      "aria-selected": selected ? "true" : void 0,
      id: id2,
      onClick: handleClick,
      onKeyDown: handleKeyDown,
      ref,
      role: "option"
    }
  );
});
const Group$4 = React__default.forwardRef(function Listbox2Group(props, ref) {
  const [labelledById, setLabelledById] = React__default.useState();
  return /* @__PURE__ */ React__default.createElement(Listbox2GroupContext.Provider, { value: { setLabelledById } }, /* @__PURE__ */ React__default.createElement("div", { ...props, "aria-labelledby": labelledById, ref, role: "group" }));
});
const Listbox2GroupContext = React__default.createContext({});
const useListbox2GroupContext = () => React__default.useContext(Listbox2GroupContext);
const Title$1 = React__default.forwardRef(function Listbox2Group2(props, ref) {
  const { id: nativeId, ...otherProps } = props;
  const { setLabelledById } = useListbox2GroupContext();
  const id2 = useId$1(nativeId);
  React__default.useEffect(() => {
    setLabelledById(id2);
  }, [id2]);
  return /* @__PURE__ */ React__default.createElement("div", { ...otherProps, id: id2, ref, role: "presentation" });
});
const Tag = React__default.forwardRef((props, ref) => {
  const { children, color: color2, disabled, icon, readOnly, onDelete, ...otherProps } = props;
  const textRef = React__default.useRef(null);
  const className = clsx(
    "inline-flex items-center rounded h-6 cursor-default",
    {
      "opacity-50": disabled,
      "hover:bg-opacity-75": !disabled,
      "cursor-pointer": !!otherProps.onClick,
      "pointer-events-none": disabled || readOnly
    },
    getSubtleColorShadeClasses(color2),
    props.className
  );
  return /* @__PURE__ */ React__default.createElement("span", { ...otherProps, className, ref, "data-taco": "tag" }, /* @__PURE__ */ React__default.createElement("span", { className: "flex items-center truncate px-2", ref: textRef }, icon ? typeof icon === "string" ? /* @__PURE__ */ React__default.createElement(Icon$1, { name: icon, className: "-ml-1 mr-1 !h-5 !w-5" }) : React__default.cloneElement(icon, {
    className: clsx(icon.props.className, "mr-1 -ml-1")
  }) : null, /* @__PURE__ */ React__default.createElement("span", { className: "truncate" }, children)), onDelete ? /* @__PURE__ */ React__default.createElement(
    Icon$1,
    {
      name: "close",
      onClick: onDelete,
      className: "-ml-1.5 !h-6 !w-5 flex-shrink-0 cursor-pointer rounded-r p-0.5 hover:bg-black/5"
    }
  ) : null);
});
const createOptionClassName = (shouldPauseHoverState = false) => clsx(
  "group mb-px flex w-full text-sm flex-shrink-0 font-normal cursor-pointer items-center rounded bg-white px-2 leading-8 text-black aria-hidden:hidden gap-1.5 bg-white aria-current:wcag-grey-200 aria-disabled:text-black/25 aria-disabled:pointer-events-none !justify-normal",
  {
    "hover:wcag-grey-200": !shouldPauseHoverState
  }
);
const createCollectionClassName = () => "flex flex-col gap-px";
const getFontSize = (fontSize) => {
  switch (fontSize) {
    case FontSizes.small:
      return "text-xs";
    case FontSizes.large:
      return "text-base";
    case FontSizes.medium:
    default:
      return "text-sm";
  }
};
const filterOption = (child, searchQuery) => {
  var _a, _b;
  if ((_a = child.props.textValue) == null ? void 0 : _a.toLowerCase().includes(searchQuery.toLowerCase())) {
    return true;
  }
  if ((_b = child.props.description) == null ? void 0 : _b.toLowerCase().includes(searchQuery.toLowerCase())) {
    return true;
  }
  return String(child.props.children).toLowerCase().includes(searchQuery.toLowerCase());
};
const Select2Context = React__default.createContext({});
const useSelect2Context = () => React__default.useContext(Select2Context);
const EditPopover = (props) => {
  const { color: initialColor, text: initialName, value, ...popoverProps } = props;
  const ref = React__default.useRef(null);
  const { onDelete, onEdit, searchRef, ref: selectRef } = useSelect2Context();
  const { texts } = useLocalization();
  const [name, setName] = React__default.useState(initialName);
  const [color2, setColor] = React__default.useState(initialColor);
  const [validationError, setValidationError] = React__default.useState();
  const handleInputChange = (event) => {
    setName(event.target.value);
    setValidationError(void 0);
  };
  const handleInputKeyDown = (close) => async (event) => {
    event.stopPropagation();
    if (event.key === "Escape") {
      close();
    } else if (event.key === "Enter") {
      handleSave(close)(event);
    }
  };
  const handleDelete = (close) => async (event) => {
    event.stopPropagation();
    close();
    if (onDelete) {
      await onDelete(value);
    }
  };
  const handleSave = (close) => async (event) => {
    var _a;
    if (onEdit && (name !== initialName || color2 !== initialColor)) {
      try {
        await onEdit(value, name, color2);
        close();
      } catch (error) {
        event.preventDefault();
        event.stopPropagation();
        setValidationError(error);
        (_a = ref.current) == null ? void 0 : _a.focus();
      }
    } else {
      close();
    }
  };
  const handleCloseAutoFocus = (event) => {
    var _a, _b;
    event.preventDefault();
    setName(initialName);
    setColor(initialColor);
    setValidationError(void 0);
    if (searchRef == null ? void 0 : searchRef.current) {
      (_a = searchRef.current) == null ? void 0 : _a.focus();
    } else {
      (_b = selectRef.current) == null ? void 0 : _b.focus();
    }
  };
  const handleInteractOutside = () => {
    setName(initialName);
    setColor(initialColor);
  };
  const preventKeyDownPropagation = (event) => {
    if (event.key === "Escape" || event.key === "Tab" || event.key === "Tab" && event.shiftKey) {
      return;
    } else {
      event.stopPropagation();
    }
  };
  const popoverContentKeyDown = (event) => {
    if (event.key === "Tab" || event.key === "Tab" && event.shiftKey) {
      event.stopPropagation();
    }
  };
  return /* @__PURE__ */ React__default.createElement(Popover, { ...popoverProps }, /* @__PURE__ */ React__default.createElement(
    Popover.Content,
    {
      onCloseAutoFocus: handleCloseAutoFocus,
      onInteractOutside: handleInteractOutside,
      onClick: (event) => event.stopPropagation(),
      onKeyDown: popoverContentKeyDown,
      placement: "right",
      tabIndex: -1,
      className: "focus:!shadow-none"
    },
    ({ close }) => /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("div", { className: "flex w-32 flex-col space-y-2" }, onEdit ? /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(
      Field,
      {
        className: clsx("!min-h-fit", { "!pb-0": !validationError }),
        invalid: !!validationError,
        message: validationError == null ? void 0 : validationError.message
      },
      /* @__PURE__ */ React__default.createElement(
        Input,
        {
          invalid: !!validationError,
          onChange: handleInputChange,
          onKeyDown: handleInputKeyDown(close),
          ref,
          value: name
        }
      )
    ), initialColor ? /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("h5", null, "Colours"), /* @__PURE__ */ React__default.createElement(
      Colours,
      {
        color: color2,
        onChangeColor: setColor,
        onKeyDown: preventKeyDownPropagation
      }
    )) : null, /* @__PURE__ */ React__default.createElement(Group$6, null, /* @__PURE__ */ React__default.createElement(Button$4, { onClick: close }, texts.select2.cancel), /* @__PURE__ */ React__default.createElement(Button$4, { appearance: "primary", onClick: handleSave(close) }, texts.select2.save))) : null, onEdit && onDelete ? /* @__PURE__ */ React__default.createElement("hr", null) : null, onDelete ? /* @__PURE__ */ React__default.createElement(
      "button",
      {
        className: "hover:text-grey-700 flex items-center justify-start gap-1",
        onClick: handleDelete(close),
        onKeyDown: preventKeyDownPropagation
      },
      /* @__PURE__ */ React__default.createElement(Icon$1, { className: "!h-5 !w-5", name: "delete-permanently" }),
      " ",
      texts.select2.delete
    ) : null))
  ));
};
const Colours = (props) => {
  const { color: color2, onChangeColor, onKeyDown } = props;
  const { texts } = useLocalization();
  return /* @__PURE__ */ React__default.createElement(
    $b6c3ddc6086f204d$export$a98f0dcb43a68a25,
    {
      "aria-label": texts.select2.chooseColor,
      className: "grid grid-cols-4 gap-2 focus:outline-none",
      onChange: (value) => onChangeColor(value),
      value: color2
    },
    AVAILABLE_COLORS.map((availableColor) => /* @__PURE__ */ React__default.createElement($b6c3ddc6086f204d$export$d7b12c4107be0d61, { key: availableColor, "aria-label": color2, onKeyDown, value: availableColor }, (state) => /* @__PURE__ */ React__default.createElement(
      "div",
      {
        className: clsx(
          "flex h-6 w-6 cursor-pointer items-center justify-center rounded",
          getSubtleColorShadeClasses(availableColor),
          state.isFocusVisible && "ring-2 ring-blue-500"
        )
      },
      state.isSelected && /* @__PURE__ */ React__default.createElement(Icon$1, { name: "tick", className: "!h-5 !w-5" })
    )))
  );
};
const mobiles = /iPhone|iPad|iPod|Android/i;
const isMobileDevice = (navigator2) => !!(navigator2 == null ? void 0 : navigator2.userAgent) && mobiles.test(navigator2.userAgent);
const Option = React__default.forwardRef(function Select2Option(props, ref) {
  const { children, color: color2, description, prefix: prefix2, postfix, className: cName, ...otherProps } = props;
  const {
    fontSize,
    listboxRef,
    multiple,
    onDelete,
    onEdit,
    ref: selectRef,
    setOpen,
    shouldPauseHoverState,
    tags,
    value
  } = useSelect2Context();
  const className = clsx(createOptionClassName(shouldPauseHoverState), getFontSize(fontSize), cName);
  const hasValue2 = Array.isArray(value) ? !!value.length : value !== void 0;
  const isTag = tags && !!color2;
  const handleClick = () => {
    var _a;
    if (!multiple) {
      setOpen(false);
    } else {
      (_a = selectRef.current) == null ? void 0 : _a.focus();
    }
  };
  const handleKeyDown = (event) => {
    if (isAriaSelectionKey(event)) {
      if (!multiple || event.key === "Tab") {
        setOpen(false);
      }
    }
  };
  const isEmptyOption = children !== "";
  const popover = isEmptyOption && (onEdit || onDelete) ? (popoverProps) => /* @__PURE__ */ React__default.createElement(
    EditPopover,
    {
      ...popoverProps,
      color: props.color,
      key: props.textValue ?? String(props.children),
      text: props.textValue ?? String(props.children),
      value: props.value
    }
  ) : void 0;
  return /* @__PURE__ */ React__default.createElement(Option$1, { ...otherProps, className, onClick: handleClick, onKeyDown: handleKeyDown, ref }, hasValue2 ? /* @__PURE__ */ React__default.createElement(Icon$1, { name: "tick", className: "pointer-events-none invisible -mx-0.5 !h-4 !w-4 group-aria-selected:visible" }) : null, typeof children !== "string" ? /* @__PURE__ */ React__default.createElement("span", null, children) : isTag ? /* @__PURE__ */ React__default.createElement(Tag, { className: "pointer-events-none my-1", color: color2, icon: prefix2 }, children) : /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, prefix2 ? typeof prefix2 === "string" ? /* @__PURE__ */ React__default.createElement(Icon$1, { name: prefix2, className: "!h-5 !w-5" }) : prefix2 : null, /* @__PURE__ */ React__default.createElement("span", { className: "flex w-full justify-between" }, /* @__PURE__ */ React__default.createElement("span", { className: "flex flex-col" }, /* @__PURE__ */ React__default.createElement("span", null, children), description ? /* @__PURE__ */ React__default.createElement("span", { className: "text-grey-700 -mt-1.5 mb-1.5 text-xs" }, description) : null), /* @__PURE__ */ React__default.createElement("span", { className: "flex flex-col self-center" }, postfix ? typeof postfix === "string" ? /* @__PURE__ */ React__default.createElement(Icon$1, { name: postfix, className: "!h-5 !w-5" }) : postfix : null))), popover ? /* @__PURE__ */ React__default.createElement(
    IconButton,
    {
      icon: "ellipsis-vertical",
      appearance: "discrete",
      className: clsx(
        "group-aria-current:visible invisible -mr-1 ml-auto !h-5 min-h-[theme(spacing.6)] !w-5 min-w-[theme(spacing.6)] hover:!bg-black/[.08] focus:!shadow-none group-hover:visible",
        {
          "!visible": isMobileDevice(window == null ? void 0 : window.navigator)
        }
      ),
      onClick: (event) => {
        var _a;
        event.stopPropagation();
        (_a = listboxRef == null ? void 0 : listboxRef.current) == null ? void 0 : _a.setActiveIndexByElement(event.currentTarget.parentElement);
      },
      popover,
      tabIndex: -1
    }
  ) : null);
});
const Group$3 = React__default.forwardRef(function Select2Group(props, ref) {
  const { children, heading, hasSeparator, ...attributes } = props;
  const className = clsx(
    createCollectionClassName(),
    {
      "last:after:content-none after:content-[''] after:bg-grey-300 after:mx-2 after:my-1 after:h-px": hasSeparator && children.length
    },
    props.className
  );
  return /* @__PURE__ */ React__default.createElement(Group$4, { ...attributes, className, ref }, /* @__PURE__ */ React__default.createElement(Title$1, { className: "sticky top-0 bg-white px-2 font-bold leading-8" }, heading), children);
});
const Title = React__default.forwardRef(function Select2Title(props, ref) {
  const className = clsx("flex items-center text-xs pl-2 h-8", props.className);
  return /* @__PURE__ */ React__default.createElement(Title$1, { ...props, className, ref });
});
const Placeholder = ({ disabled, readOnly, ...props }) => {
  if (readOnly) {
    return null;
  }
  return /* @__PURE__ */ React__default.createElement("div", { ...props, className: clsx({ "text-grey-500": disabled, "text-grey-700": !disabled }) });
};
const Trigger = React__default.forwardRef(function Select2Trigger(props, ref) {
  const { multiple, value } = useSelect2Context();
  if (Array.isArray(value) || multiple) {
    const values = Array.isArray(value) ? value : value !== void 0 ? [value] : void 0;
    return /* @__PURE__ */ React__default.createElement(Multiple, { ...props, ref, values });
  }
  return /* @__PURE__ */ React__default.createElement(Single, { ...props, ref, value });
});
const Button$1 = React__default.forwardRef(function Select2TriggerButton(props, ref) {
  var _a;
  const { children, onBlur, onClick, onFocus, tabIndex = 0, ...otherProps } = props;
  const { disabled, fontSize, highlighted, invalid, open, readOnly } = useSelect2Context();
  const className = clsx(
    "px-1.5 h-fit",
    getInputClasses({ ...props, disabled, highlighted, invalid, readOnly }).replace("w-full", "").replace("px-2", ""),
    getFontSize(fontSize),
    {
      "select-text": readOnly,
      "w-full": !((_a = props.className) == null ? void 0 : _a.includes("w-"))
    },
    props.className
  );
  const handleClick = (event) => {
    if (disabled || readOnly) {
      event.preventDefault();
      return;
    }
    if (typeof onClick === "function") {
      onClick(event);
    }
  };
  let handleBlur;
  if (typeof onBlur === "function") {
    handleBlur = (event) => {
      if (isElementInsideOrTriggeredFromContainer(event.relatedTarget, event.currentTarget)) {
        return;
      }
      onBlur(event);
    };
  }
  const handleFocus = (event) => {
    var _a2, _b;
    if (readOnly) {
      const value = event.currentTarget.querySelector(":first-child");
      if (value) {
        (_b = (_a2 = window.getSelection()) == null ? void 0 : _a2.selectAllChildren) == null ? void 0 : _b.call(_a2, value);
      }
    }
    if (typeof onFocus === "function") {
      onFocus(event);
    }
  };
  return /* @__PURE__ */ React__default.createElement(
    "button",
    {
      ...otherProps,
      "aria-invalid": invalid ? true : void 0,
      "aria-readonly": readOnly ? true : void 0,
      className,
      disabled,
      onClick: handleClick,
      onBlur: handleBlur,
      onFocus: handleFocus,
      ref,
      role: "combobox",
      tabIndex: disabled ? -1 : tabIndex,
      type: "button"
    },
    children,
    readOnly ? null : /* @__PURE__ */ React__default.createElement(Icon$1, { name: open ? "chevron-up" : "chevron-down", className: "pointer-events-none -mr-1 ml-auto" })
  );
});
const Single = React__default.forwardRef(function Select2TriggerSingle(props, ref) {
  const { children, emptyValue, value, placeholder, ...buttonProps } = props;
  const { disabled, readOnly, tags } = useSelect2Context();
  const contentClassName = clsx("truncate flex items-center gap-1");
  const currentValue = children.find(matchesValue(value));
  let output;
  if (placeholder && currentValue === void 0) {
    output = /* @__PURE__ */ React__default.createElement(Placeholder, { disabled, readOnly }, placeholder);
  } else if (currentValue) {
    if (tags && emptyValue !== value) {
      if (typeof currentValue.props.children === "string")
        output = /* @__PURE__ */ React__default.createElement(
          Tag,
          {
            className: "truncate",
            color: currentValue.props.color,
            disabled,
            icon: currentValue.props.prefix,
            readOnly
          },
          currentValue.props.children
        );
      else output = currentValue.props.children;
    } else {
      output = /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, currentValue.props.prefix ? typeof currentValue.props.prefix === "string" ? /* @__PURE__ */ React__default.createElement(Icon$1, { name: currentValue.props.prefix, className: "mr-1 !h-5 !w-5" }) : currentValue.props.prefix : null, currentValue.props.children);
    }
  }
  return /* @__PURE__ */ React__default.createElement(Button$1, { ...buttonProps, ref }, /* @__PURE__ */ React__default.createElement("div", { className: contentClassName }, output));
});
const Multiple = React__default.forwardRef(function Select2TriggerMultiple(props, ref) {
  var _a;
  const { children, emptyValue: _, values = [], placeholder, ...buttonProps } = props;
  const { disabled, open, readOnly, setValue, tags } = useSelect2Context();
  const buttonRef = useMergedRef(ref);
  const valuesAsChildren = values.map((value) => children.find((c3) => c3.props.value === value)).filter((c3) => !!c3);
  const forwardClick = (event) => {
    var _a2;
    event.preventDefault();
    (_a2 = buttonRef.current) == null ? void 0 : _a2.click();
  };
  let content;
  let { className } = buttonProps;
  if (open) {
    className = clsx("!absolute z-20 !h-fit", buttonProps.className);
    content = /* @__PURE__ */ React__default.createElement(ScrollArea, { className: "my-1 flex max-h-[5.5rem] flex-col", onClick: forwardClick }, /* @__PURE__ */ React__default.createElement("div", { className: "flex flex-wrap gap-1" }, valuesAsChildren.length === 0 ? /* @__PURE__ */ React__default.createElement(Placeholder, { disabled, readOnly }, placeholder) : valuesAsChildren.map(
      (child) => typeof child.props.children === "string" ? /* @__PURE__ */ React__default.createElement(
        Tag,
        {
          key: String(child.props.value),
          className: "truncate",
          color: tags ? child.props.color : void 0,
          disabled,
          icon: child.props.prefix,
          onDelete: (event) => {
            event == null ? void 0 : event.stopPropagation();
            event == null ? void 0 : event.preventDefault();
            if (!disabled && !readOnly) {
              setValue(child.props.value);
            }
          },
          readOnly
        },
        child.props.children
      ) : React__default.cloneElement(
        child.props.children,
        {
          key: String(child.props.value),
          className: "!pr-0 !pl-1.5",
          children: /* @__PURE__ */ React__default.createElement("span", { className: "flex items-center" }, child.props.children.props.children, /* @__PURE__ */ React__default.createElement(
            Icon$1,
            {
              name: "close",
              onClick: (event) => {
                event == null ? void 0 : event.stopPropagation();
                event == null ? void 0 : event.preventDefault();
                if (!disabled && !readOnly) {
                  setValue(child.props.value);
                }
              },
              className: "ml-0.5 !h-5 !w-5 shrink-0 cursor-pointer rounded-r p-0.5 hover:bg-black/5"
            }
          ))
        }
      )
    )));
  } else {
    content = /* @__PURE__ */ React__default.createElement(MultipleValue, { onClick: forwardClick, valuesAsChildren, placeholder });
  }
  return /* @__PURE__ */ React__default.createElement(
    "div",
    {
      className: "relative inline-flex h-fit flex-grow",
      "data-taco": "select2-container",
      style: { width: open ? (_a = buttonRef.current) == null ? void 0 : _a.offsetWidth : void 0 }
    },
    /* @__PURE__ */ React__default.createElement(Button$1, { ...buttonProps, className, ref: buttonRef }, content)
  );
});
const MultipleValue = ({ onClick, valuesAsChildren, placeholder }) => {
  const { disabled, readOnly, tags } = useSelect2Context();
  const [contentRef, setContentRef] = React__default.useState(null);
  const boundaryIndex = contentRef ? getIndexOfFirstChildOverflowingParent(contentRef, 30) : void 0;
  const getTooltipTitle = (child) => {
    const children = child.props.children;
    if (typeof children === "string") return children;
    if (typeof children.props.children === "string") {
      return children.props.children;
    }
    if (Array.isArray(children.props.children)) {
      return children.props.children.filter((item) => typeof item === "string");
    }
    return "";
  };
  return /* @__PURE__ */ React__default.createElement("div", { className: "relative flex w-full items-center gap-1 overflow-hidden", onClick }, /* @__PURE__ */ React__default.createElement("div", { className: "flex flex-1 gap-1 truncate", ref: (ref) => setContentRef(ref) }, valuesAsChildren.length === 0 ? /* @__PURE__ */ React__default.createElement(Placeholder, { disabled, readOnly }, placeholder) : valuesAsChildren.map((child, index2) => {
    const classNames = {
      truncate: index2 === boundaryIndex,
      hidden: boundaryIndex !== void 0 && boundaryIndex !== null ? index2 > boundaryIndex : false
    };
    let output;
    if (typeof child.props.children === "string") {
      output = /* @__PURE__ */ React__default.createElement(
        Tag,
        {
          key: String(child.props.value),
          className: clsx("cursor-pointer", classNames),
          color: tags ? child.props.color : void 0,
          disabled,
          icon: child.props.prefix,
          readOnly
        },
        child.props.children
      );
    } else
      output = React__default.cloneElement(
        child.props.children,
        {
          className: clsx("cursor-pointer", { "shrink-0": index2 !== boundaryIndex }, classNames),
          key: String(child.props.value)
        }
      );
    if (index2 === boundaryIndex) {
      return /* @__PURE__ */ React__default.createElement(Tooltip$3, { key: String(child.props.value), title: String(getTooltipTitle(child)) }, output);
    }
    return output;
  })), boundaryIndex !== void 0 && boundaryIndex !== null && boundaryIndex < valuesAsChildren.length - 1 ? /* @__PURE__ */ React__default.createElement(
    Tooltip$3,
    {
      title: valuesAsChildren.slice(boundaryIndex + 1).map((child) => child ? String(getTooltipTitle(child)) : "").join(", ")
    },
    /* @__PURE__ */ React__default.createElement(Badge2, { className: "flex-shrink-0" }, "+", valuesAsChildren.length - (boundaryIndex + 1))
  ) : null);
};
const matchesValue = (value) => (child) => {
  if (Array.isArray(value)) {
    return value.includes(child.props.value);
  }
  return child.props.value === value;
};
const useIsFormControl = (ref, reset) => {
  const [isFormControl, setIsFormControl] = React.useState(false);
  React.useEffect(() => {
    var _a;
    let formElement;
    if (ref.current) {
      formElement = ref.current.closest("form");
      setIsFormControl(!!formElement);
      if (reset && formElement) {
        formElement.addEventListener("reset", reset);
      }
      (_a = ref.current.closest("form")) == null ? void 0 : _a.addEventListener("reset", reset);
    }
    return () => {
      if (formElement) {
        formElement.removeEventListener("reset", reset);
      }
    };
  }, [ref.current]);
  return isFormControl;
};
function usePreviousValue(value) {
  const ref = React__default.useRef(value);
  React__default.useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}
const BubbleSelect = (props) => {
  const { value, ...selectProps } = props;
  const ref = React__default.useRef(null);
  const prevValue = usePreviousValue(value);
  React__default.useEffect(() => {
    const select = ref.current;
    const descriptor = Object.getOwnPropertyDescriptor(window.HTMLSelectElement.prototype, "value");
    const setValue = descriptor.set;
    if (prevValue !== value && setValue) {
      if (Array.isArray(value)) {
        value.forEach((v2) => {
          const option = select.querySelector(`option[value='${CSS.escape(v2)}']`);
          if (option) {
            option.selected = true;
          }
        });
      } else {
        setValue.call(select, value);
      }
      const event = new Event("change", { bubbles: true });
      select.dispatchEvent(event);
    }
  }, [prevValue, value]);
  return /* @__PURE__ */ React__default.createElement("select", { ...selectProps, defaultValue: value, ref, style: { display: "none" } });
};
const Search = React__default.forwardRef(function ListboxSearch(props, ref) {
  const { listboxRef, searchQuery, setSearchQuery, setValidationError, validationError } = useSelect2Context();
  const handleChange = (event) => {
    if (validationError) {
      setValidationError(void 0);
    }
    setSearchQuery(event.target.value);
  };
  const handleKeyDown = (event) => {
    var _a;
    if (event.key === " ") {
      return;
    }
    if (isAriaSelectionKey(event) || event.key === "ArrowDown" || event.key === "ArrowUp") {
      event.preventDefault();
      (_a = listboxRef == null ? void 0 : listboxRef.current) == null ? void 0 : _a.dispatchEvent(createCustomKeyboardEvent(event));
      return;
    }
  };
  return /* @__PURE__ */ React__default.createElement(
    Field,
    {
      className: clsx("mx-1.5 mb-1.5 !min-h-fit", { "!pb-0": !validationError }),
      invalid: !!validationError,
      message: validationError == null ? void 0 : validationError.message
    },
    /* @__PURE__ */ React__default.createElement(
      Input,
      {
        ...props,
        autoFocus: true,
        invalid: !!validationError,
        onChange: handleChange,
        onKeyDown: handleKeyDown,
        ref,
        value: searchQuery
      }
    )
  );
});
const isGroup = (child) => !!child.props.heading || !!child.props.hasSeparator;
const useChildren = ({ children: initialChildren, emptyValue, multiple, open, setValue, value }) => {
  const [searchQuery, setSearchQuery] = React__default.useState("");
  const flattenedChildren = React__default.useMemo(() => {
    const initial = (initialChildren == null ? void 0 : initialChildren.map((child) => {
      if (isGroup(child)) {
        return child.props.children;
      }
      return child;
    }).flatMap((c3) => c3)) || [];
    return initial;
  }, [initialChildren]);
  React__default.useEffect(() => {
    var _a;
    if (!multiple && emptyValue === void 0 && value === void 0) {
      setValue((_a = flattenedChildren == null ? void 0 : flattenedChildren[0]) == null ? void 0 : _a.props.value);
    }
  }, []);
  React__default.useEffect(() => {
    if (!open) {
      setSearchQuery("");
    }
  }, [open]);
  const filteredChildren = React__default.useMemo(() => {
    return initialChildren.map((child) => {
      if (isGroup(child)) {
        const filteredGroupChildren = child.props.children.filter(
          (groupChild) => filterOption(groupChild, searchQuery)
        );
        return filteredGroupChildren.length ? React__default.cloneElement(child, {}, filteredGroupChildren) : null;
      }
      return filterOption(child, searchQuery) ? child : null;
    }).filter((child) => !!child);
  }, [flattenedChildren, searchQuery]);
  return {
    flattenedChildren,
    filteredChildren,
    searchQuery,
    setSearchQuery
  };
};
const getNextColor = (options) => {
  let occurrences = {};
  AVAILABLE_COLORS.filter((color2) => color2 !== "transparent").forEach((color2) => {
    occurrences = { ...occurrences, [color2]: 0 };
  });
  options.reduce((occurrences2, option) => {
    if (option.props.color) {
      occurrences2[option.props.color] = occurrences2[option.props.color] ? occurrences2[option.props.color] + 1 : 1;
    }
    return occurrences2;
  }, occurrences);
  const colors2 = Object.keys(occurrences);
  if (colors2.length) {
    return colors2.sort((a4, b3) => occurrences[a4] - occurrences[b3])[0];
  }
  return void 0;
};
const Create = (props) => {
  const { onCreate: handleCreate, options } = props;
  const { multiple, searchQuery, setOpen, setSearchQuery, setValidationError, setValue, createDialog, createTriggerText } = useSelect2Context();
  const { texts } = useLocalization();
  const nextColor = React__default.useMemo(() => getNextColor(options), [options]);
  const onCreateDialogClose = React__default.useCallback(() => {
    setOpen(false);
  }, [setOpen]);
  if (!createDialog && !searchQuery) {
    return null;
  }
  const create = async (value) => {
    try {
      const item = await handleCreate(value, nextColor);
      setValue(item.value);
      if (multiple) {
        setSearchQuery("");
      } else {
        setOpen(false);
      }
    } catch (error) {
      setValidationError(error);
    }
  };
  const handleKeyDown = (event) => {
    if (isAriaSelectionKey(event)) {
      event.currentTarget.click();
    }
  };
  const className = clsx(createOptionClassName(), {
    "!w-[calc(100%_-_theme(spacing.3))] ml-1.5": !createDialog,
    "leading-normal border-grey-300 h-9 border-t py-2.5 px-4 !-mb-1.5": !!createDialog
  });
  const creationOptions = createDialog ? {
    dialog: (props2) => createDialog({ ...props2, onClose: onCreateDialogClose }, searchQuery, create)
  } : {
    onClick: () => create(searchQuery)
  };
  const createText = createTriggerText || texts.select2.create;
  return /* @__PURE__ */ React__default.createElement(
    Button$4,
    {
      className,
      ...creationOptions,
      onKeyDown: handleKeyDown,
      appearance: createDialog ? "discrete" : "default"
    },
    /* @__PURE__ */ React__default.createElement("span", { className: "flex items-center gap-1.5" }, createDialog ? /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Icon$1, { className: "text-xs", name: "circle-plus" }), " ", createText) : /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, createText, /* @__PURE__ */ React__default.createElement(Tag, { color: nextColor, className: "cursor-pointer" }, searchQuery)))
  );
};
const Collection = (props) => {
  const { children } = props;
  return /* @__PURE__ */ React__default.createElement(ScrollArea, { className: "flex max-h-[11.5rem] w-full flex-col gap-y-0.5 px-1.5" }, children);
};
const Select22 = React__default.forwardRef(function Select222(props, ref) {
  const {
    children: initChildren,
    defaultValue: defaultProp,
    disabled = false,
    emptyValue = void 0,
    fontSize,
    highlighted = false,
    invalid = false,
    loading,
    multiple = false,
    name,
    onChange,
    onCreate: onCreate2,
    onDelete,
    onEdit,
    placeholder,
    readOnly = false,
    tags = false,
    value: prop,
    createDialog,
    createTriggerText,
    ...otherProps
  } = props;
  const emptyOption = React__default.useMemo(() => {
    if (emptyValue !== void 0 && !multiple) {
      return /* @__PURE__ */ React__default.createElement(Option, { key: "__empty", children: "", value: emptyValue, className: "h-8" });
    }
    return;
  }, [emptyValue, multiple]);
  const initialChildren = React__default.useMemo(() => {
    if (emptyOption) {
      return [emptyOption, ...initChildren];
    }
    return initChildren;
  }, [emptyOption, initChildren]);
  const internalRef = useMergedRef(ref);
  const listboxRef = React__default.useRef(null);
  const searchRef = React__default.useRef(null);
  const { texts } = useLocalization();
  const dimensions = useBoundingClientRectListener(internalRef);
  const [open, setOpen] = React__default.useState(false);
  const [value, _setValue] = $71cd76cc60e0454e$export$6f32135080cb4c3$1({
    // uncontrolled
    defaultProp,
    // controlled
    onChange,
    prop
  });
  const setValue = createListboxValueSetter(multiple, _setValue);
  const [validationError, setValidationError] = React__default.useState();
  const [shouldPauseHoverState, setShouldPauseHoverState] = useIsHoverStatePaused();
  const { flattenedChildren, filteredChildren, searchQuery, setSearchQuery } = useChildren({
    children: initialChildren,
    emptyValue,
    multiple,
    open,
    setValue,
    value
  });
  const context = {
    disabled,
    highlighted,
    invalid,
    listboxRef,
    multiple,
    onCreate: onCreate2,
    onDelete,
    onEdit,
    open,
    readOnly,
    ref: internalRef,
    searchQuery,
    searchRef,
    setOpen,
    setSearchQuery,
    setValidationError,
    setValue,
    shouldPauseHoverState,
    setShouldPauseHoverState,
    tags,
    fontSize,
    validationError,
    value,
    createDialog,
    createTriggerText
  };
  const hasInlineCreation = onCreate2 && !createDialog;
  const hasSearch = flattenedChildren.length > 5 || hasInlineCreation;
  const visibleChildren = searchQuery === "" ? initialChildren : filteredChildren;
  const selectOptions = searchQuery === "" ? flattenedChildren.map((child) => child.props.value) : filteredChildren.map(
    (child) => isGroup(child) ? Array.isArray(child.props.children) && child.props.children.map((subChild) => subChild.props.value) : child.props.value
  ).flatMap((c3) => c3) || [];
  const queryTimeoutRef = React__default.useRef("");
  const typeahead = debounce$2(function() {
    if (!queryTimeoutRef.current) {
      return;
    }
    const matchedValueIndex = visibleChildren.findIndex(
      (child) => filterOption(child, queryTimeoutRef.current)
    );
    if (matchedValueIndex > -1) {
      setValue(selectOptions[matchedValueIndex]);
    }
    queryTimeoutRef.current = "";
  }, 200);
  const setValueIfMatched = (query) => {
    queryTimeoutRef.current = queryTimeoutRef.current + query;
    typeahead();
  };
  const handleKeyDown = (event) => {
    var _a;
    if (open) {
      event.preventDefault();
    } else if (isElementInsideTable3OrReport(event.currentTarget) && isAriaDirectionKey(event)) {
      return;
    } else if (!event.ctrlKey && !event.metaKey && (event.key === "ArrowDown" || /^[a-z0-9]$/i.test(event.key))) {
      setOpen(true);
      if (!hasSearch) {
        setValueIfMatched(event.key);
      }
    }
    (_a = listboxRef.current) == null ? void 0 : _a.dispatchEvent(createCustomKeyboardEvent(event));
  };
  const shouldFocusNextRef = React__default.useRef(false);
  const handleListboxKeyDown = (event) => {
    if (isAriaDirectionKey(event)) {
      setShouldPauseHoverState(true);
      return;
    }
    if (event.key === "Tab") {
      shouldFocusNextRef.current = true;
      setOpen(false);
      return;
    }
    if (!hasSearch && /^[a-z0-9]$/i.test(event.key)) {
      setValueIfMatched(event.key);
      return;
    }
  };
  const handleCloseAutoFocus = (event) => {
    var _a, _b;
    if (shouldFocusNextRef.current) {
      event.preventDefault();
      shouldFocusNextRef.current = false;
      (_a = otherProps.onBlur) == null ? void 0 : _a.call(otherProps, event);
      (_b = getNextFocussableElement(internalRef.current)) == null ? void 0 : _b.focus();
      return;
    }
  };
  const areAllSelected = Array.isArray(value) && selectOptions.every((option) => value.includes(option));
  const selectAllText = React__default.useMemo(() => {
    if (searchQuery === "") {
      if (areAllSelected) {
        return texts.select2.deselectAll;
      } else {
        return texts.select2.selectAll;
      }
    } else if (areAllSelected) {
      return texts.select2.deselectAllResults;
    } else {
      return texts.select2.selectAllResults;
    }
  }, [areAllSelected, searchQuery]);
  const selectAll = () => {
    if (!Array.isArray(value) || value.length === 0) {
      setValue(selectOptions);
    } else {
      const preselectedValues = selectOptions.filter((option) => !value.includes(option));
      setValue([...value, ...preselectedValues]);
    }
  };
  const deselectAll = () => {
    if (searchQuery === "") {
      setValue([]);
    } else {
      const nextValue = Array.isArray(value) && value.filter((subValue) => !selectOptions.includes(subValue));
      setValue(nextValue);
    }
  };
  const className = clsx(
    "border-grey-300 rounded border bg-white py-1.5 shadow-md ",
    {
      "focus-within:yt-focus": !hasSearch,
      "outline-none": hasSearch
    },
    createCollectionClassName()
  );
  return /* @__PURE__ */ React__default.createElement(Select2Context.Provider, { value: context }, /* @__PURE__ */ React__default.createElement($cb5cc270b50c6fcd$export$be92b6f5f03c0fe9, { open, onOpenChange: setOpen }, /* @__PURE__ */ React__default.createElement($cb5cc270b50c6fcd$export$41fb9f06171c75f4, { asChild: true, "data-taco": "Select2" }, /* @__PURE__ */ React__default.createElement(
    Trigger,
    {
      ...otherProps,
      "aria-haspopup": "listbox",
      emptyValue,
      onKeyDown: handleKeyDown,
      placeholder,
      ref: internalRef
    },
    flattenedChildren
  )), /* @__PURE__ */ React__default.createElement($cb5cc270b50c6fcd$export$602eac185826482c, null, /* @__PURE__ */ React__default.createElement(
    $cb5cc270b50c6fcd$export$7c6e2c02157bb7d2,
    {
      asChild: true,
      align: "start",
      onCloseAutoFocus: handleCloseAutoFocus,
      onPointerDownOutside: otherProps.onBlur,
      sideOffset: 4,
      tabIndex: -1
    },
    /* @__PURE__ */ React__default.createElement("div", { className, style: { minWidth: (dimensions == null ? void 0 : dimensions.width) ? `${dimensions.width}px` : void 0 } }, hasSearch ? /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(
      Search,
      {
        placeholder: hasInlineCreation ? texts.select2.searchOrCreate : texts.select2.search,
        ref: searchRef
      }
    ), multiple && selectOptions.length > 1 && /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(
      Button$4,
      {
        className: "!justify-start",
        appearance: "discrete",
        onClick: areAllSelected ? deselectAll : selectAll
      },
      selectAllText
    ), /* @__PURE__ */ React__default.createElement("div", { className: "border-grey-300 mx-3 rounded border-t" }))) : null, loading ? /* @__PURE__ */ React__default.createElement("span", { className: clsx("text-grey-700 flex items-center italic", fontSize && getFontSize(fontSize)) }, /* @__PURE__ */ React__default.createElement("span", null, /* @__PURE__ */ React__default.createElement(
      Spinner,
      {
        delay: 0,
        className: clsx("ml-3 mr-2 mt-1.5 h-5 w-5", {
          "!mt-1 !h-3.5 !w-3.5": fontSize === FontSizes.small,
          "!h-4 !w-4": fontSize === FontSizes.medium,
          "!h-5 !w-5": fontSize === FontSizes.large
        })
      }
    )), /* @__PURE__ */ React__default.createElement("span", null, texts.listbox.loading)) : flattenedChildren.length <= 0 ? /* @__PURE__ */ React__default.createElement("div", { className: "text-grey-700 -mt-0.5 flex h-8 items-center px-2", role: "presentation" }, texts.listbox.empty) : /* @__PURE__ */ React__default.createElement(
      Root,
      {
        className: "flex flex-col gap-0.5 focus-visible:outline-none",
        customSelector: ":scope > button",
        disabled,
        multiple,
        onKeyDown: handleListboxKeyDown,
        readOnly,
        ref: listboxRef,
        setValue,
        value
      },
      /* @__PURE__ */ React__default.createElement(Collection, null, visibleChildren),
      onCreate2 ? /* @__PURE__ */ React__default.createElement(Create, { onCreate: onCreate2, options: flattenedChildren }) : null
    ))
  )), /* @__PURE__ */ React__default.createElement(
    ControlledHiddenField,
    {
      emptyValue,
      multiple: multiple || tags,
      name,
      options: flattenedChildren.map((child) => child.props.value),
      parentRef: internalRef,
      setValue,
      value
    }
  )));
});
Select22.Option = Option;
Select22.Group = Group$3;
Select22.Title = Title;
const ControlledHiddenField = (props) => {
  const { emptyValue, multiple, name, options, parentRef, value, setValue } = props;
  const isFormControl = useIsFormControl(parentRef, () => setValue(multiple ? [] : void 0));
  let bubbleValue;
  if (isFormControl) {
    if (value !== void 0) {
      if (multiple) {
        bubbleValue = Array.isArray(value) ? value.map(String) : [value === null ? "" : String(value)];
      } else {
        bubbleValue = value === null ? "" : String(value);
      }
    }
    return /* @__PURE__ */ React__default.createElement(BubbleSelect, { "aria-hidden": true, key: String(bubbleValue), multiple, name, tabIndex: -1, value: bubbleValue }, emptyValue !== void 0 ? /* @__PURE__ */ React__default.createElement("option", { value: emptyValue }) : null, options.map((option) => /* @__PURE__ */ React__default.createElement("option", { key: String(option), value: String(option) })));
  }
  return null;
};
Select22.displayName = "Select2";
const SAFE_PRINT_CELL_COUNT = 1e4;
function PrintDialog(props) {
  var _a, _b;
  const {
    onAccept,
    table,
    orientation,
    setOrientation,
    size: size2,
    setSize,
    allRows,
    setAllRows,
    splitGroups,
    setSplitGroups,
    ...dialogProps
  } = props;
  const { texts } = useLocalization();
  const columns = table.getVisibleFlatColumns();
  const cellCount = table.getRowModel().rows.length * columns.length;
  const rowGroupingColumnName = table.getState().grouping.length ? (_b = (_a = columns.find((column) => column.id === table.getState().grouping[0])) == null ? void 0 : _a.columnDef.meta) == null ? void 0 : _b.header : void 0;
  return /* @__PURE__ */ React__default.createElement(Dialog, { ...dialogProps, size: "xs" }, /* @__PURE__ */ React__default.createElement(Dialog.Content, { "aria-label": texts.table.print.warningDialog.title }, ({ close }) => /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Dialog.Title, null, texts.table.print.settingsDialog.title), /* @__PURE__ */ React__default.createElement("div", { className: "mt-4 flex flex-col gap-2" }, /* @__PURE__ */ React__default.createElement("div", { className: "grid grid-cols-2 gap-4" }, /* @__PURE__ */ React__default.createElement(Field, null, texts.table.print.settingsDialog.size, /* @__PURE__ */ React__default.createElement(Select22, { onChange: setSize, value: size2 }, /* @__PURE__ */ React__default.createElement(Select22.Option, { value: "A5" }, texts.table.print.settingsDialog.sizeA5), /* @__PURE__ */ React__default.createElement(Select22.Option, { value: "A4" }, texts.table.print.settingsDialog.sizeA4), /* @__PURE__ */ React__default.createElement(Select22.Option, { value: "A3" }, texts.table.print.settingsDialog.sizeA3), /* @__PURE__ */ React__default.createElement(Select22.Option, { value: "letter" }, texts.table.print.settingsDialog.sizeLetter), /* @__PURE__ */ React__default.createElement(Select22.Option, { value: "legal" }, texts.table.print.settingsDialog.sizeLegal))), /* @__PURE__ */ React__default.createElement(Field, null, texts.table.print.settingsDialog.orientation, /* @__PURE__ */ React__default.createElement(Select22, { onChange: setOrientation, value: orientation }, /* @__PURE__ */ React__default.createElement(Select22.Option, { value: "landscape" }, texts.table.print.settingsDialog.orientationLandscape), /* @__PURE__ */ React__default.createElement(Select22.Option, { value: "portrait" }, texts.table.print.settingsDialog.orientationPortrait)))), table.options.enableRowSelection && table.getIsSomeRowsSelected() ? /* @__PURE__ */ React__default.createElement(Field, null, texts.table.print.settingsDialog.rows, /* @__PURE__ */ React__default.createElement(RadioGroup2, { onChange: setAllRows, value: allRows }, /* @__PURE__ */ React__default.createElement(RadioGroup2.Item, { value: true }, texts.table.print.settingsDialog.rowsAll), /* @__PURE__ */ React__default.createElement(RadioGroup2.Item, { value: false }, texts.table.print.settingsDialog.rowsSelected))) : void 0, rowGroupingColumnName ? /* @__PURE__ */ React__default.createElement(Field, null, texts.table.print.settingsDialog.layout, /* @__PURE__ */ React__default.createElement(
    Checkbox$2,
    {
      label: texts.table.print.settingsDialog.layoutSplitGroups.replace(
        "[COLUMN]",
        rowGroupingColumnName
      ),
      checked: splitGroups,
      onChange: setSplitGroups
    }
  )) : null, cellCount > SAFE_PRINT_CELL_COUNT ? /* @__PURE__ */ React__default.createElement(Alert$1, { state: "warning" }, texts.table.print.warningDialog.description) : null), /* @__PURE__ */ React__default.createElement(Dialog.Footer, null, /* @__PURE__ */ React__default.createElement(Group$6, null, /* @__PURE__ */ React__default.createElement(Dialog.Close, null, /* @__PURE__ */ React__default.createElement(Button$4, null, texts.table.print.warningDialog.cancelButtonText)), /* @__PURE__ */ React__default.createElement(
    Button$4,
    {
      appearance: "primary",
      autoFocus: true,
      onClick: () => {
        close();
        setTimeout(() => onAccept(), 1);
      }
    },
    texts.table.print.warningDialog.printButtonText
  ))))));
}
function Print(props) {
  const { table, tableId, tableRef } = props;
  const { texts } = useLocalization();
  const ref = React__default.useRef(null);
  const lastScrollTopRef = React__default.useRef();
  const toast = useToast();
  const tableMeta = table.options.meta;
  const { allRows, orientation, size: size2, splitGroups } = tableMeta.printing.settings;
  const togglePrinting = React__default.useCallback(
    (enabled) => {
      tableMeta.printing.setIsPrinting(enabled);
      if (tableRef.current) {
        if (enabled) {
          lastScrollTopRef.current = tableRef.current.scrollTop;
        } else if (lastScrollTopRef.current !== void 0) {
          tableRef.current.scrollTop = lastScrollTopRef.current;
          lastScrollTopRef.current = void 0;
        }
      }
    },
    [tableRef.current]
  );
  React__default.useEffect(() => {
    const afterPrint = () => {
      togglePrinting(false);
    };
    window.addEventListener("afterprint", afterPrint);
    return () => {
      window.removeEventListener("afterprint", afterPrint);
    };
  }, []);
  const print = async () => {
    const toastRef = toast.loading(texts.table.print.loading);
    if (tableMeta.server.isEnabled && tableMeta.server.loadAllIfNeeded) {
      const hiddenColumns = getHiddenColumns(table.getState().columnVisibility);
      try {
        await tableMeta.server.loadAllIfNeeded(
          table.getState().sorting,
          table.getState().columnFilters,
          hiddenColumns,
          tableMeta.search.enableGlobalFilter ? table.getState().globalFilter : void 0
        );
      } catch (error) {
        const errorMessage = `${texts.table.print.error}: ${error}`;
        console.error(errorMessage);
        toastRef.error(errorMessage);
      }
    }
    toastRef.close();
    setTimeout(() => {
      togglePrinting(true);
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
          if (isSafari) {
            try {
              document.execCommand("print", false, void 0);
            } catch (error) {
              window.print();
            }
          } else {
            window.print();
          }
        });
      });
    }, 150);
  };
  const printStyle = [`@page { size: ${size2} ${orientation}; }`];
  if (!allRows) {
    printStyle.push(`table[data-taco^='table']#${tableId} tr:not([data-row-selected="true"]) { display: none; }`);
  }
  if (splitGroups) {
    printStyle.push(`table[data-taco^='table']#${tableId} tr[data-row-group]:not(:first-child) { break-before: page; }`);
  }
  const shortcut2 = { key: "p", meta: true, shift: false };
  const tooltip = /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, texts.table.print.tooltip, /* @__PURE__ */ React__default.createElement(Shortcut, { className: "ml-2", keys: shortcut2 }));
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("style", { media: "print" }, printStyle.join("\n")), /* @__PURE__ */ React__default.createElement(
    IconButton,
    {
      icon: "print",
      "aria-label": texts.table.print.tooltip,
      dialog: (dialogProps) => /* @__PURE__ */ React__default.createElement(
        PrintDialog,
        {
          ...dialogProps,
          table,
          onAccept: print,
          orientation,
          setOrientation: (value) => tableMeta.printing.setSetting("orientation", value),
          size: size2,
          setSize: (value) => tableMeta.printing.setSetting("size", value),
          allRows,
          setAllRows: (value) => tableMeta.printing.setSetting("allRows", value),
          splitGroups,
          setSplitGroups: (value) => tableMeta.printing.setSetting("splitGroups", value)
        }
      ),
      ref,
      shortcut: shortcut2,
      tooltip
    }
  ));
}
const useMatchMedia = (query, defaultMatches = false) => {
  const [matches, setMatches] = React__default.useState(defaultMatches);
  const handleChange = React__default.useCallback((event) => setMatches(event.matches), []);
  React__default.useEffect(() => {
    const mediaQuery = window.matchMedia(query);
    setMatches(mediaQuery.matches);
    mediaQuery.addEventListener("change", handleChange);
    return () => {
      mediaQuery.removeEventListener("change", handleChange);
    };
  }, []);
  return matches;
};
const useIsLargeScreen = () => useMatchMedia("(min-width: 1024px)", window.innerWidth > 1024);
function sortByHeader(a4, b3) {
  var _a, _b, _c, _d;
  return (_d = (_b = (_a = a4.columnDef.meta) == null ? void 0 : _a.header) == null ? void 0 : _b.localeCompare) == null ? void 0 : _d.call(_b, (_c = b3.columnDef.meta) == null ? void 0 : _c.header);
}
function isEmptyFilter(filter2) {
  return !filter2.value.hasOwnProperty("value");
}
function guessComparatorsBasedOnControl(column) {
  const columnMeta = (column == null ? void 0 : column.columnDef.meta) ?? {};
  if (Array.isArray(columnMeta.filters)) {
    return columnMeta.filters;
  }
  if (typeof columnMeta.control === "function") {
    const renderedControl = columnMeta.control({
      onBlur: () => void 0,
      onFocus: () => void 0,
      setValue: () => void 0,
      value: void 0,
      disabled: false,
      readOnly: false,
      ref: void 0
    });
    if (React__default.isValidElement(renderedControl)) {
      const { props, type } = renderedControl;
      if (type.displayName === "Select2") {
        if (props.multiple) {
          return [
            TableFilterComparator.HasAnyOf,
            TableFilterComparator.HasAllOf,
            TableFilterComparator.IsEqualTo,
            TableFilterComparator.HasNoneOf,
            TableFilterComparator.IsEmpty,
            TableFilterComparator.IsNotEmpty
          ];
        }
        return [
          TableFilterComparator.IsEqualTo,
          TableFilterComparator.IsNotEqualTo,
          TableFilterComparator.IsEmpty,
          TableFilterComparator.IsNotEmpty
        ];
      }
    }
  }
  if (columnMeta.control === "datepicker") {
    return getDataTypeProperties("datetime").filterComparators;
  }
  if (columnMeta.control === "switch") {
    return getDataTypeProperties("boolean").filterComparators;
  }
  return getDataTypeProperties(columnMeta.dataType).filterComparators;
}
const FilterContext = React__default.createContext([]);
const FilterColumn = React__default.forwardRef((props, ref) => {
  const { allColumns, onChange: handleChange, value = null, ...attributes } = props;
  const { texts } = useLocalization();
  const filters = React__default.useContext(FilterContext);
  const selectedColumn = allColumns.find((column) => column.id === value);
  const warning2 = selectedColumn && !selectedColumn.getIsVisible();
  return /* @__PURE__ */ React__default.createElement("div", { className: "flex flex-col" }, /* @__PURE__ */ React__default.createElement(
    Field,
    {
      message: warning2 ? texts.table.filters.hiddenColumn : void 0,
      warning: warning2,
      className: "min-h-[theme(spacing.8)]"
    },
    /* @__PURE__ */ React__default.createElement(
      Select22,
      {
        ...attributes,
        ref,
        className: "focus:yt-focus !w-32 flex-shrink-0 ",
        emptyValue: null,
        onChange: handleChange,
        value
      },
      allColumns.map((column) => {
        var _a, _b, _c;
        return /* @__PURE__ */ React__default.createElement(
          Select22.Option,
          {
            key: column.id,
            value: column.id,
            postfix: !column.getIsVisible() || column.getIsGrouped() ? /* @__PURE__ */ React__default.createElement(
              Tooltip$3,
              {
                title: column.getIsGrouped() ? texts.table.filters.hiddenGroupedColumn : texts.table.filters.hiddenColumn
              },
              /* @__PURE__ */ React__default.createElement(Icon$1, { name: "eye-off", className: "text-grey-500 !h-5 !w-5" })
            ) : void 0,
            disabled: column.id !== value && (!column.getCanFilter() || !!filters.find((f2) => f2.id === column.id))
          },
          ((_a = column.columnDef.meta) == null ? void 0 : _a.header) + (column.parent ? ` (${(_c = (_b = column.parent) == null ? void 0 : _b.columnDef.meta) == null ? void 0 : _c.header})` : "")
        );
      })
    )
  ));
});
function FilterComparator(props) {
  const { column, onChange: handleChange, value, ...attributes } = props;
  const { texts } = useLocalization();
  const validComparators = guessComparatorsBasedOnControl(column);
  return /* @__PURE__ */ React__default.createElement(Select22, { ...attributes, className: "!w-32 flex-shrink-0", disabled: !column, onChange: handleChange, value }, validComparators.map((comparator) => /* @__PURE__ */ React__default.createElement(Select22.Option, { key: comparator, value: comparator }, getComparatorText(comparator, texts, column))));
}
function getComparatorText(comparator, texts, column) {
  var _a, _b;
  const isDate2 = ((_b = (_a = column == null ? void 0 : column.columnDef) == null ? void 0 : _a.meta) == null ? void 0 : _b.control) === "datepicker";
  switch (comparator) {
    case TableFilterComparator.Contains:
      return texts.table.filters.comparators.contains;
    case TableFilterComparator.DoesNotContain:
      return texts.table.filters.comparators.doesNotContain;
    case TableFilterComparator.IsEqualTo:
      return texts.table.filters.comparators.isEqualTo;
    case TableFilterComparator.IsNotEqualTo:
      return texts.table.filters.comparators.isNotEqualTo;
    case TableFilterComparator.IsGreaterThan:
      return isDate2 ? texts.table.filters.comparators.isAfter : texts.table.filters.comparators.isGreaterThan;
    case TableFilterComparator.IsLessThan:
      return isDate2 ? texts.table.filters.comparators.isBefore : texts.table.filters.comparators.isLessThan;
    case TableFilterComparator.IsBetween:
      return texts.table.filters.comparators.isBetween;
    case TableFilterComparator.IsEmpty:
      return texts.table.filters.comparators.isEmpty;
    case TableFilterComparator.IsNotEmpty:
      return texts.table.filters.comparators.isNotEmpty;
    case TableFilterComparator.IsLessThanOrEqualTo:
      return isDate2 ? texts.table.filters.comparators.isOnOrBefore : texts.table.filters.comparators.isLessThanOrEqualTo;
    case TableFilterComparator.IsGreaterThanOrEqualTo:
      return isDate2 ? texts.table.filters.comparators.isOnOrAfter : texts.table.filters.comparators.isGreaterThanOrEqualTo;
    case TableFilterComparator.HasAnyOf:
      return texts.table.filters.comparators.hasAnyOf;
    case TableFilterComparator.HasAllOf:
      return texts.table.filters.comparators.hasAllOf;
    case TableFilterComparator.HasNoneOf:
      return texts.table.filters.comparators.hasNoneOf;
    case TableFilterComparator.IsOneOf:
      return texts.table.filters.comparators.isOneOf;
    case TableFilterComparator.IsNoneOf:
      return texts.table.filters.comparators.isNoneOf;
    default:
      return "";
  }
}
const querySelector = "filter-value";
function FilterValue(props) {
  var _a, _b;
  const { column, comparator, onChange: handleChange, value } = props;
  const { texts } = useLocalization();
  if (comparator === TableFilterComparator.IsEmpty || comparator === TableFilterComparator.IsNotEmpty) {
    return null;
  }
  if (comparator === TableFilterComparator.IsBetween) {
    const fromValue = Array.isArray(value) ? value[0] : void 0;
    const toValue2 = Array.isArray(value) ? value[1] : void 0;
    if (column === void 0) {
      return /* @__PURE__ */ React__default.createElement(
        Input,
        {
          "aria-label": texts.table.filters.emptyFilter.value,
          className: "flex-grow",
          "data-query-selector": querySelector,
          disabled: true,
          value: texts.table.filters.emptyFilter.value
        }
      );
    }
    if (((_a = column.columnDef.meta) == null ? void 0 : _a.dataType) === "datetime" || ((_b = column.columnDef.meta) == null ? void 0 : _b.dataType) === "date") {
      return /* @__PURE__ */ React__default.createElement("div", { className: "flex flex-grow items-center gap-2" }, /* @__PURE__ */ React__default.createElement(
        Control,
        {
          column,
          "data-query-selector": querySelector,
          onChange: (value2) => handleChange([value2, toValue2]),
          value: fromValue
        }
      ), /* @__PURE__ */ React__default.createElement(
        Control,
        {
          column,
          "data-query-selector": querySelector,
          onChange: (value2) => handleChange([fromValue, value2]),
          value: toValue2
        }
      ));
    }
    return /* @__PURE__ */ React__default.createElement("div", { className: "flex flex-grow items-center gap-2" }, /* @__PURE__ */ React__default.createElement(
      Control,
      {
        column,
        "data-query-selector": querySelector,
        onChange: (value2) => handleChange([isNaN(value2) ? void 0 : value2, toValue2]),
        placeholder: "from",
        value: fromValue ?? ""
      }
    ), /* @__PURE__ */ React__default.createElement(
      Control,
      {
        column,
        "data-query-selector": querySelector,
        onChange: (value2) => handleChange([fromValue, isNaN(value2) ? void 0 : value2]),
        placeholder: "to",
        value: toValue2 ?? ""
      }
    ));
  }
  return /* @__PURE__ */ React__default.createElement(
    Control,
    {
      comparator,
      column,
      "data-query-selector": querySelector,
      onChange: handleChange,
      value
    }
  );
}
function Control(props) {
  var _a, _b;
  const { column, comparator, onChange, value, ...attributes } = props;
  const controlRenderer = (_a = column == null ? void 0 : column.columnDef.meta) == null ? void 0 : _a.control;
  const dataType = (_b = column == null ? void 0 : column.columnDef.meta) == null ? void 0 : _b.dataType;
  const filters = React__default.useContext(FilterContext);
  useEffect(() => {
    if ((controlRenderer === "switch" || controlRenderer === "checkbox") && value === void 0) {
      onChange(false);
    }
  }, [controlRenderer]);
  if (typeof controlRenderer === "function") {
    const control = controlRenderer(
      {
        ...attributes,
        setValue: (value2) => onChange(value2),
        value
      },
      void 0,
      filters
    );
    if (control) {
      return React__default.cloneElement(control, { ["data-query-selector"]: querySelector, className: "focus:yt-focus" });
    }
  }
  if (controlRenderer === "datepicker" || dataType === "datetime" || dataType === "date") {
    return /* @__PURE__ */ React__default.createElement(Datepicker, { ...attributes, onChange: (event) => onChange(event.detail), value });
  } else if (controlRenderer === "switch") {
    return /* @__PURE__ */ React__default.createElement(Switch$1, { ...attributes, className: "m-1.5", checked: Boolean(value), onChange });
  } else if (controlRenderer === "checkbox") {
    return /* @__PURE__ */ React__default.createElement(Checkbox$2, { ...attributes, className: "!m-1.5", checked: Boolean(value), onChange });
  } else if ((controlRenderer === "input" || controlRenderer === void 0) && dataType === "number") {
    return /* @__PURE__ */ React__default.createElement(
      Input,
      {
        ...attributes,
        className: "flex-grow",
        type: "number",
        onChange: (event) => onChange(event.target.valueAsNumber),
        value: String(value ?? "")
      }
    );
  }
  return /* @__PURE__ */ React__default.createElement(
    Input,
    {
      disabled: !column,
      ...attributes,
      className: "flex-grow",
      onChange: (event) => onChange(event.target.value),
      value: String(value ?? "")
    }
  );
}
function Filter(props) {
  const { allColumns, filter: filter2, onChange: handleChange, onRemove, position } = props;
  const { texts } = useLocalization();
  const column = allColumns.find((c3) => c3.id === filter2.id);
  const ref = React__default.useRef(null);
  const {
    id: id2,
    value: { comparator, value }
  } = filter2;
  const handleChangeColumn = (columnId) => {
    var _a, _b, _c;
    const previousColumn = allColumns.find((column2) => column2.id === id2);
    const nextColumn = allColumns.find((column2) => column2.id === columnId);
    if (((_a = previousColumn == null ? void 0 : previousColumn.columnDef.meta) == null ? void 0 : _a.dataType) && ((_b = previousColumn == null ? void 0 : previousColumn.columnDef.meta) == null ? void 0 : _b.dataType) === ((_c = nextColumn == null ? void 0 : nextColumn.columnDef.meta) == null ? void 0 : _c.dataType)) {
      handleChange(position, { id: columnId, value: filter2.value });
      return;
    }
    const validComparators = guessComparatorsBasedOnControl(nextColumn);
    const value2 = {
      comparator: validComparators[0],
      value: void 0
    };
    handleChange(position, { id: columnId, value: value2 });
  };
  const handleChangeComparator = (comparator2) => {
    let nextValue = filter2.value.value;
    if (comparator2 === TableFilterComparator.IsEmpty || comparator2 === TableFilterComparator.IsNotEmpty) {
      nextValue = void 0;
    }
    handleChange(position, { id: id2, value: { comparator: comparator2, value: nextValue } });
  };
  const handleChangeValue = (value2) => {
    handleChange(position, { id: id2, value: { ...filter2.value, value: value2 } });
  };
  const handleRemove = () => onRemove == null ? void 0 : onRemove(position);
  React__default.useEffect(() => {
    if (ref.current && !id2) {
      ref.current.focus();
    }
  }, [id2]);
  return /* @__PURE__ */ React__default.createElement("div", { className: "flex items-start gap-2" }, /* @__PURE__ */ React__default.createElement("div", { className: "flex min-h-[theme(spacing.8)] w-14 flex-shrink-0 items-center justify-end pr-2 text-right" }, position > 0 ? texts.table.filters.conditions.and : texts.table.filters.conditions.where), /* @__PURE__ */ React__default.createElement(FilterColumn, { allColumns, onChange: handleChangeColumn, value: id2, ref }), /* @__PURE__ */ React__default.createElement(FilterComparator, { column, onChange: handleChangeComparator, value: comparator }), /* @__PURE__ */ React__default.createElement(FilterValue, { column, comparator, onChange: handleChangeValue, value }), onRemove ? /* @__PURE__ */ React__default.createElement(IconButton, { appearance: "discrete", className: "ml-auto", icon: "close", onClick: handleRemove }) : null);
}
const placeholderFilter = { id: "", value: { comparator: TableFilterComparator.Contains, value: void 0 } };
function ManageFiltersPopover(props) {
  const { length, table, ...popoverProps } = props;
  const { locale: locale2, texts } = useLocalization();
  const allColumns = table.getAllLeafColumns().filter((column) => !isInternalColumn(column.id)).sort(sortByHeader);
  const columnFilters = table.getState().columnFilters;
  const [filters, setFilters] = React__default.useState(columnFilters.length ? columnFilters : [placeholderFilter]);
  React__default.useEffect(() => {
    setFilters(columnFilters.length === 0 ? [placeholderFilter] : columnFilters);
    requestAnimationFrame(() => {
      const filterValues = document.querySelectorAll('[data-query-selector="filter-value"]');
      const lastFilter = filterValues.length ? filterValues[filterValues.length - 1] : void 0;
      lastFilter == null ? void 0 : lastFilter.focus();
    });
  }, [columnFilters]);
  const handleChangeFilter = (position, filter2) => {
    setFilters((currentFilters) => {
      return currentFilters.map((current, index2) => {
        if (index2 === position) {
          return filter2;
        }
        return current;
      });
    });
  };
  const handleRemoveFilter = (position) => {
    if (filters.length === 1) {
      setFilters([placeholderFilter]);
      return;
    }
    setFilters((currentFilters) => currentFilters.filter((_, index2) => index2 !== position));
  };
  const handleCreate = () => {
    setFilters(filters.concat(placeholderFilter));
  };
  const handleApply = () => {
    table.setColumnFilters(() => {
      const newFilters = filters.filter((f2) => {
        var _a, _b;
        if (f2.id === null || f2.id === "") {
          return false;
        }
        const controlRenderer = (_b = (_a = allColumns.find((c3) => c3.id === f2.id)) == null ? void 0 : _a.columnDef.meta) == null ? void 0 : _b.control;
        if (f2.value.comparator === TableFilterComparator.IsEmpty || f2.value.comparator === TableFilterComparator.IsNotEmpty || controlRenderer === "switch") {
          return true;
        }
        const value = f2.value.value;
        return value !== void 0 && value !== null && value !== "";
      });
      return newFilters;
    });
  };
  const handleClear = () => {
    table.resetColumnFilters();
    setFilters([placeholderFilter]);
  };
  const handleClose = (open) => {
    if (!open) {
      const nonEmptyFilters = columnFilters.filter((f2) => !isEmptyFilter(f2));
      table.setColumnFilters(nonEmptyFilters);
      setFilters(nonEmptyFilters.length === 0 ? [placeholderFilter] : nonEmptyFilters);
    }
  };
  return /* @__PURE__ */ React__default.createElement(Popover, { ...popoverProps, onChange: handleClose }, /* @__PURE__ */ React__default.createElement(Popover.Content, null, /* @__PURE__ */ React__default.createElement(FilterContext.Provider, { value: filters }, /* @__PURE__ */ React__default.createElement("div", { className: "flex w-[40rem] flex-col gap-4" }, /* @__PURE__ */ React__default.createElement("div", { className: "flex h-8" }, /* @__PURE__ */ React__default.createElement("div", { className: "flex w-full items-center gap-2" }, /* @__PURE__ */ React__default.createElement("h4", { className: "mb-0 inline-flex" }, texts.table.filters.button), /* @__PURE__ */ React__default.createElement("p", { className: "text-grey-700 mb-0 mr-auto mt-px inline-flex" }, texts.table.filters.total.replace(
    "[CURRENT]",
    new Intl.NumberFormat(locale2).format(table.getFilteredRowModel().rows.length)
  ).replace("[TOTAL]", new Intl.NumberFormat(locale2).format(length))))), /* @__PURE__ */ React__default.createElement("div", { className: "flex flex-col gap-2" }, filters.map((filter2, index2) => /* @__PURE__ */ React__default.createElement(
    Filter,
    {
      key: `filter_${index2}`,
      allColumns,
      filter: filter2,
      position: index2,
      onChange: handleChangeFilter,
      onRemove: filters.length > 0 && filters.some((f2) => f2.id) || filters.length > 1 ? handleRemoveFilter : void 0
    }
  )), /* @__PURE__ */ React__default.createElement("div", { className: "justify-start" }, /* @__PURE__ */ React__default.createElement(Button$4, { appearance: "discrete", onClick: handleCreate }, "+ ", texts.table.filters.buttons.addFilter))), /* @__PURE__ */ React__default.createElement(Group$6, { className: "ml-auto" }, /* @__PURE__ */ React__default.createElement(Popover.Close, null, /* @__PURE__ */ React__default.createElement(Button$4, null, texts.table.filters.buttons.cancel)), /* @__PURE__ */ React__default.createElement(Button$4, { onClick: handleClear }, texts.table.filters.buttons.clear), /* @__PURE__ */ React__default.createElement(Button$4, { appearance: "primary", onClick: handleApply }, texts.table.filters.buttons.apply))))));
}
function Filters(props) {
  const { length, table } = props;
  const { texts } = useLocalization();
  const isLargeScreen = useIsLargeScreen();
  const columnFilters = table.getState().columnFilters;
  const appliedFilters = columnFilters.filter((f2) => !isEmptyFilter(f2));
  const ref = React__default.useRef(null);
  const shortcut2 = { key: "f", meta: true, shift: true };
  const buttonProps = {
    "aria-label": texts.table.filters.tooltip,
    className: appliedFilters.length ? "!wcag-blue-100" : void 0,
    popover: (popoverProps) => /* @__PURE__ */ React__default.createElement(ManageFiltersPopover, { ...popoverProps, length, table }),
    shortcut: shortcut2,
    ref,
    tooltip: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, texts.table.filters.tooltip, /* @__PURE__ */ React__default.createElement(Shortcut, { className: "ml-2", keys: shortcut2 }))
  };
  React__default.useEffect(() => {
    var _a;
    const emptyFilter = columnFilters.find(isEmptyFilter);
    if (emptyFilter) {
      (_a = ref.current) == null ? void 0 : _a.click();
    }
  }, [columnFilters]);
  if (!isLargeScreen && !appliedFilters.length) {
    return /* @__PURE__ */ React__default.createElement(IconButton, { ...buttonProps, icon: "filter" });
  }
  return /* @__PURE__ */ React__default.createElement(Button$4, { ...buttonProps }, /* @__PURE__ */ React__default.createElement(Icon$1, { className: !isLargeScreen ? "-mr-1.5" : void 0, name: appliedFilters.length ? "filter-solid" : "filter" }), isLargeScreen ? texts.table.filters.button : "", appliedFilters.length ? `(${appliedFilters.length})` : "");
}
function TableToolbar(props) {
  const { children: customTools, table, ...attributes } = props;
  if (!isToolbarVisible(table, !!customTools)) {
    return null;
  }
  const canFilter = table.instance.options.enableColumnFilters;
  const canPrint = table.meta.printing.isEnabled;
  const canSettings = canChangeSettings(table.instance, table.props.customSettings);
  const canSearch = table.meta.search.isEnabled;
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(
    "div",
    {
      ...attributes,
      className: "mb-4 flex flex-shrink flex-grow-0 flex-wrap gap-2 print:hidden",
      "data-taco": "table-toolbar"
    },
    table.props.toolbarLeft,
    /* @__PURE__ */ React__default.createElement(Group$6, { className: "ml-auto flex-shrink-0 items-center print:hidden" }, customTools, canFilter ? /* @__PURE__ */ React__default.createElement(Filters, { length: table.meta.length, table: table.instance }) : null, table.props.toolbarRight, canPrint ? /* @__PURE__ */ React__default.createElement(Print, { table: table.instance, tableId: table.id, tableRef: table.ref }) : null, canSettings ? /* @__PURE__ */ React__default.createElement(Settings, { customSettings: table.props.customSettings, table: table.instance }) : null, canSearch ? /* @__PURE__ */ React__default.createElement(Search$1, { scrollToIndex: table.renderer.scrollToIndex, table: table.instance, tableRef: table.ref }) : null)
  ), table.props.toolbarPanel ? /* @__PURE__ */ React__default.createElement("div", { className: "mb-4" }, table.props.toolbarPanel) : void 0);
}
function canChangeSettings(table, customSettings) {
  const tableMeta = table.options.meta;
  return table.options.enableHiding || tableMeta.columnOrdering.isEnabled || tableMeta.fontSize.isEnabled || tableMeta.rowHeight.isEnabled || typeof customSettings === "function";
}
function isToolbarVisible(table, customTools) {
  const hasInternalToolbar = customTools || table.instance.options.enableColumnFilters || table.meta.printing.isEnabled || canChangeSettings(table.instance, table.props.customSettings) || table.meta.search.isEnabled;
  return hasInternalToolbar || !!table.props.toolbarLeft || !!table.props.toolbarRight;
}
function Table$1(props) {
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, props.children);
}
Table$1.Toolbar = TableToolbar;
Table$1.Grid = TableGrid;
function getEmptyStateReason(table) {
  if (table.instance.getFilteredRowModel().rows.length === 0 && table.instance.getCoreRowModel().rows.length !== 0) {
    const state = table.instance.getState();
    if (table.meta.search.enableGlobalFilter && !!state.globalFilter) {
      return "searching";
    }
    return "filtering";
  }
  if (table.instance.getCoreRowModel().rows.length === 0) {
    return "empty";
  }
  return null;
}
function TableGrid(props) {
  var _a;
  const { enableHorizontalArrowKeyNavigation, footerRows, table, ...attributes } = props;
  const handleFocus = table.meta.rowActive.rowActiveIndex === void 0 ? (event) => {
    table.meta.rowActive.handleFocus(event, table.meta.length, table.renderer.scrollToIndex);
  } : void 0;
  const emptyStateReason = getEmptyStateReason(table);
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("style", null, table.stylesheet), /* @__PURE__ */ React__default.createElement($9bf71ea28793e738$export$20e40289641fbbb6, null, /* @__PURE__ */ React__default.createElement(
    "table",
    {
      ...attributes,
      id: table.id,
      "data-table-font-size": table.meta.fontSize.size,
      "data-table-grouped": !!((_a = table.state.grouping) == null ? void 0 : _a.length),
      "data-table-horizontally-scrolled": table.meta.columnFreezing.isHorizontallyScrolled ? true : void 0,
      "data-table-status": table.meta.server.isEnabled ? table.meta.server.isReady ? "ready" : void 0 : "ready",
      "data-table-pause-hover": table.meta.rowActive.isHoverStatePaused ? true : void 0,
      "data-table-resizing": table.state.columnSizingInfo.isResizingColumn ? true : void 0,
      "data-table-row-height": table.meta.rowHeight.height,
      onFocus: handleFocus,
      onScroll: table.meta.columnFreezing.handleScroll,
      ref: table.ref,
      style: table.style,
      tabIndex: -1
    },
    /* @__PURE__ */ React__default.createElement("thead", null, table.instance.getHeaderGroups().map((headerGroup) => /* @__PURE__ */ React__default.createElement("tr", { key: headerGroup.id }, headerGroup.headers.map((props2) => /* @__PURE__ */ React__default.createElement(Header$1, { key: props2.id, header: props2, scrollToIndex: table.renderer.scrollToIndex }))))),
    emptyStateReason ? /* @__PURE__ */ React__default.createElement(
      EmptyStateBody,
      {
        emptyState: props.table.props.emptyState,
        isReady: table.meta.server.isEnabled ? table.meta.server.isReady : true,
        reason: emptyStateReason
      }
    ) : /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(
      Body,
      {
        enableHorizontalArrowKeyNavigation,
        table: table.instance,
        tableElement: table.ref.current,
        scrollToIndex: table.renderer.scrollToIndex,
        style: props.children ? {
          ...table.renderer.style,
          height: table.renderer.style.height + ROW_HEIGHT_ESTIMATES[table.meta.rowHeight.height]
        } : table.renderer.style
      },
      table.renderer.rows,
      props.children
    ), table.meta.footer.isEnabled ? /* @__PURE__ */ React__default.createElement(Foot, { table: table.instance }, footerRows) : null)
  )));
}
const Column$2 = () => null;
Column$2.displayName = "Table3Column";
function Group$2(_) {
  return null;
}
const BaseReport = fixedForwardRef(function BaseReport2(props, ref) {
  const report = useReport(props, ref);
  return /* @__PURE__ */ React__default.createElement(Table$1, null, /* @__PURE__ */ React__default.createElement(Table$1.Toolbar, { table: report }), /* @__PURE__ */ React__default.createElement(Table$1.Grid, { "data-taco": "table-report", table: report }));
});
const Report = fixedForwardRef(function Report2(props, ref) {
  const stringifiedChildren = String(props.children);
  const key = React__default.useMemo(() => String("tableKey_" + stringifiedChildren), [stringifiedChildren]);
  return /* @__PURE__ */ React__default.createElement(BaseReport, { ...props, key, ref });
});
Report.Column = Column$2;
Report.Group = Group$2;
var reactTable = { exports: {} };
var reactTable_production_min$1 = { exports: {} };
var reactTable_production_min = reactTable_production_min$1.exports;
var hasRequiredReactTable_production_min;
function requireReactTable_production_min() {
  if (hasRequiredReactTable_production_min) return reactTable_production_min$1.exports;
  hasRequiredReactTable_production_min = 1;
  (function(module, exports) {
    !function(e3, t3) {
      t3(exports, React__default);
    }(reactTable_production_min, function(e3, t3) {
      function n2(e4, t4, n3, o3, r3, i4, u4) {
        try {
          var l3 = e4[i4](u4), s5 = l3.value;
        } catch (e6) {
          return void n3(e6);
        }
        l3.done ? t4(s5) : Promise.resolve(s5).then(o3, r3);
      }
      function o2(e4) {
        return function() {
          var t4 = this, o3 = arguments;
          return new Promise(function(r3, i4) {
            var u4 = e4.apply(t4, o3);
            function l3(e6) {
              n2(u4, r3, i4, l3, s5, "next", e6);
            }
            function s5(e6) {
              n2(u4, r3, i4, l3, s5, "throw", e6);
            }
            l3(void 0);
          });
        };
      }
      function r2() {
        return (r2 = Object.assign || function(e4) {
          for (var t4 = 1; t4 < arguments.length; t4++) {
            var n3 = arguments[t4];
            for (var o3 in n3) Object.prototype.hasOwnProperty.call(n3, o3) && (e4[o3] = n3[o3]);
          }
          return e4;
        }).apply(this, arguments);
      }
      function i3(e4, t4) {
        if (null == e4) return {};
        var n3, o3, r3 = {}, i4 = Object.keys(e4);
        for (o3 = 0; o3 < i4.length; o3++) n3 = i4[o3], t4.indexOf(n3) >= 0 || (r3[n3] = e4[n3]);
        return r3;
      }
      function u3(e4) {
        var t4 = function(e6, t5) {
          if ("object" != typeof e6 || null === e6) return e6;
          var n3 = e6[Symbol.toPrimitive];
          if (void 0 !== n3) {
            var o3 = n3.call(e6, t5);
            if ("object" != typeof o3) return o3;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return String(e6);
        }(e4, "string");
        return "symbol" == typeof t4 ? t4 : String(t4);
      }
      t3 = t3 && Object.prototype.hasOwnProperty.call(t3, "default") ? t3.default : t3;
      var l2 = { init: "init" }, s4 = function(e4) {
        var t4 = e4.value;
        return void 0 === t4 ? "" : t4;
      }, a4 = function() {
        return t3.createElement(t3.Fragment, null, " ");
      }, c3 = { Cell: s4, width: 150, minWidth: 0, maxWidth: Number.MAX_SAFE_INTEGER };
      function d4() {
        for (var e4 = arguments.length, t4 = new Array(e4), n3 = 0; n3 < e4; n3++) t4[n3] = arguments[n3];
        return t4.reduce(function(e6, t5) {
          var n4 = t5.style, o3 = t5.className;
          return e6 = r2({}, e6, {}, i3(t5, ["style", "className"])), n4 && (e6.style = e6.style ? r2({}, e6.style || {}, {}, n4 || {}) : n4), o3 && (e6.className = e6.className ? e6.className + " " + o3 : o3), "" === e6.className && delete e6.className, e6;
        }, {});
      }
      var f2 = function(e4, t4) {
        return void 0 === t4 && (t4 = {}), function(n3) {
          return void 0 === n3 && (n3 = {}), [].concat(e4, [n3]).reduce(function(e6, o3) {
            return function e7(t5, n4, o4) {
              return "function" == typeof n4 ? e7({}, n4(t5, o4)) : Array.isArray(n4) ? d4.apply(void 0, [t5].concat(n4)) : d4(t5, n4);
            }(e6, o3, r2({}, t4, { userProps: n3 }));
          }, {});
        };
      }, p2 = function(e4, t4, n3, o3) {
        return void 0 === n3 && (n3 = {}), e4.reduce(function(e6, t5) {
          return t5(e6, n3);
        }, t4);
      }, g2 = function(e4, t4, n3) {
        return void 0 === n3 && (n3 = {}), e4.forEach(function(e6) {
          e6(t4, n3);
        });
      };
      function v2(e4, t4, n3, o3) {
        e4.findIndex(function(e6) {
          return e6.pluginName === n3;
        });
        t4.forEach(function(t5) {
          e4.findIndex(function(e6) {
            return e6.pluginName === t5;
          });
        });
      }
      function m4(e4, t4) {
        return "function" == typeof e4 ? e4(t4) : e4;
      }
      function h4(e4) {
        var n3 = t3.useRef();
        return n3.current = e4, t3.useCallback(function() {
          return n3.current;
        }, []);
      }
      var y4 = "undefined" != typeof document ? t3.useLayoutEffect : t3.useEffect;
      function w3(e4, n3) {
        var o3 = t3.useRef(false);
        y4(function() {
          o3.current && e4(), o3.current = true;
        }, n3);
      }
      function R3(e4, t4, n3) {
        return void 0 === n3 && (n3 = {}), function(o3, i4) {
          void 0 === i4 && (i4 = {});
          var u4 = "string" == typeof o3 ? t4[o3] : o3;
          if (void 0 === u4) throw console.info(t4), new Error("Renderer Error ☝️");
          return b3(u4, r2({}, e4, { column: t4 }, n3, {}, i4));
        };
      }
      function b3(e4, n3) {
        return function(e6) {
          return "function" == typeof e6 && ((t4 = Object.getPrototypeOf(e6)).prototype && t4.prototype.isReactComponent);
          var t4;
        }(o3 = e4) || "function" == typeof o3 || function(e6) {
          return "object" == typeof e6 && "symbol" == typeof e6.$$typeof && ["react.memo", "react.forward_ref"].includes(e6.$$typeof.description);
        }(o3) ? t3.createElement(e4, n3) : e4;
        var o3;
      }
      function S4(e4, t4, n3) {
        return void 0 === n3 && (n3 = 0), e4.map(function(e6) {
          return x3(e6 = r2({}, e6, { parent: t4, depth: n3 })), e6.columns && (e6.columns = S4(e6.columns, e6, n3 + 1)), e6;
        });
      }
      function C2(e4) {
        return G2(e4, "columns");
      }
      function x3(e4) {
        var t4 = e4.id, n3 = e4.accessor, o3 = e4.Header;
        if ("string" == typeof n3) {
          t4 = t4 || n3;
          var r3 = n3.split(".");
          n3 = function(e6) {
            return function(e7, t5, n4) {
              if (!t5) return e7;
              var o4, r4 = "function" == typeof t5 ? t5 : JSON.stringify(t5), i4 = E3.get(r4) || function() {
                var e8 = function(e9) {
                  return function e11(t6, n5) {
                    void 0 === n5 && (n5 = []);
                    if (Array.isArray(t6)) for (var o5 = 0; o5 < t6.length; o5 += 1) e11(t6[o5], n5);
                    else n5.push(t6);
                    return n5;
                  }(e9).map(function(e11) {
                    return String(e11).replace(".", "_");
                  }).join(".").replace(T3, ".").replace(O3, "").split(".");
                }(t5);
                return E3.set(r4, e8), e8;
              }();
              try {
                o4 = i4.reduce(function(e8, t6) {
                  return e8[t6];
                }, e7);
              } catch (e8) {
              }
              return void 0 !== o4 ? o4 : n4;
            }(e6, r3);
          };
        }
        if (!t4 && "string" == typeof o3 && o3 && (t4 = o3), !t4 && e4.columns) throw console.error(e4), new Error('A column ID (or unique "Header" value) is required!');
        if (!t4) throw console.error(e4), new Error("A column ID (or string accessor) is required!");
        return Object.assign(e4, { id: t4, accessor: n3 }), e4;
      }
      function P2(e4, t4) {
        if (!t4) throw new Error();
        return Object.assign(e4, r2({ Header: a4, Footer: a4 }, c3, {}, t4, {}, e4)), Object.assign(e4, { originalWidth: e4.width }), e4;
      }
      function B2(e4, t4, n3) {
        void 0 === n3 && (n3 = function() {
          return {};
        });
        for (var o3 = [], i4 = e4, u4 = 0, l3 = function() {
          return u4++;
        }, s5 = function() {
          var e6 = { headers: [] }, u5 = [], s6 = i4.some(function(e7) {
            return e7.parent;
          });
          i4.forEach(function(o4) {
            var i5, a5 = [].concat(u5).reverse()[0];
            if (s6) {
              if (o4.parent) i5 = r2({}, o4.parent, { originalId: o4.parent.id, id: o4.parent.id + "_" + l3(), headers: [o4] }, n3(o4));
              else i5 = P2(r2({ originalId: o4.id + "_placeholder", id: o4.id + "_placeholder_" + l3(), placeholderOf: o4, headers: [o4] }, n3(o4)), t4);
              a5 && a5.originalId === i5.originalId ? a5.headers.push(o4) : u5.push(i5);
            }
            e6.headers.push(o4);
          }), o3.push(e6), i4 = u5;
        }; i4.length; ) s5();
        return o3.reverse();
      }
      var E3 = /* @__PURE__ */ new Map();
      function I2() {
        for (var e4 = arguments.length, t4 = new Array(e4), n3 = 0; n3 < e4; n3++) t4[n3] = arguments[n3];
        for (var o3 = 0; o3 < t4.length; o3 += 1) if (void 0 !== t4[o3]) return t4[o3];
      }
      function F(e4) {
        if ("function" == typeof e4) return e4;
      }
      function G2(e4, t4) {
        var n3 = [];
        return function e6(o3) {
          o3.forEach(function(o4) {
            o4[t4] ? e6(o4[t4]) : n3.push(o4);
          });
        }(e4), n3;
      }
      function A2(e4, t4) {
        var n3 = t4.manualExpandedKey, o3 = t4.expanded, r3 = t4.expandSubRows, i4 = void 0 === r3 || r3, u4 = [];
        return e4.forEach(function(e6) {
          return function e7(t5, r4) {
            void 0 === r4 && (r4 = true), t5.isExpanded = t5.original && t5.original[n3] || o3[t5.id], t5.canExpand = t5.subRows && !!t5.subRows.length, r4 && u4.push(t5), t5.subRows && t5.subRows.length && t5.isExpanded && t5.subRows.forEach(function(t6) {
              return e7(t6, i4);
            });
          }(e6);
        }), u4;
      }
      function k3(e4, t4, n3) {
        return F(e4) || t4[e4] || n3[e4] || n3.text;
      }
      function H4(e4, t4, n3) {
        return e4 ? e4(t4, n3) : void 0 === t4;
      }
      function W2() {
        throw new Error("React-Table: You have not called prepareRow(row) one or more rows you are attempting to render.");
      }
      var z3 = null;
      var T3 = /\[/g, O3 = /\]/g;
      var M3 = function(e4) {
        return r2({ role: "table" }, e4);
      }, j = function(e4) {
        return r2({ role: "rowgroup" }, e4);
      }, L3 = function(e4, t4) {
        var n3 = t4.column;
        return r2({ key: "header_" + n3.id, colSpan: n3.totalVisibleHeaderCount, role: "columnheader" }, e4);
      }, N2 = function(e4, t4) {
        var n3 = t4.column;
        return r2({ key: "footer_" + n3.id, colSpan: n3.totalVisibleHeaderCount }, e4);
      }, D3 = function(e4, t4) {
        return r2({ key: "headerGroup_" + t4.index, role: "row" }, e4);
      }, V = function(e4, t4) {
        return r2({ key: "footerGroup_" + t4.index }, e4);
      }, _ = function(e4, t4) {
        return r2({ key: "row_" + t4.row.id, role: "row" }, e4);
      }, X2 = function(e4, t4) {
        var n3 = t4.cell;
        return r2({ key: "cell_" + n3.row.id + "_" + n3.column.id, role: "cell" }, e4);
      };
      function q2() {
        return { useOptions: [], stateReducers: [], useControlledState: [], columns: [], columnsDeps: [], allColumns: [], allColumnsDeps: [], accessValue: [], materializedColumns: [], materializedColumnsDeps: [], useInstanceAfterData: [], visibleColumns: [], visibleColumnsDeps: [], headerGroups: [], headerGroupsDeps: [], useInstanceBeforeDimensions: [], useInstance: [], prepareRow: [], getTableProps: [M3], getTableBodyProps: [j], getHeaderGroupProps: [D3], getFooterGroupProps: [V], getHeaderProps: [L3], getFooterProps: [N2], getRowProps: [_], getCellProps: [X2], useFinalInstance: [] };
      }
      l2.resetHiddenColumns = "resetHiddenColumns", l2.toggleHideColumn = "toggleHideColumn", l2.setHiddenColumns = "setHiddenColumns", l2.toggleHideAllColumns = "toggleHideAllColumns";
      var K2 = function(e4) {
        e4.getToggleHiddenProps = [U], e4.getToggleHideAllColumnsProps = [$], e4.stateReducers.push(J), e4.useInstanceBeforeDimensions.push(Y2), e4.headerGroupsDeps.push(function(e6, t4) {
          var n3 = t4.instance;
          return [].concat(e6, [n3.state.hiddenColumns]);
        }), e4.useInstance.push(Q2);
      };
      K2.pluginName = "useColumnVisibility";
      var U = function(e4, t4) {
        var n3 = t4.column;
        return [e4, { onChange: function(e6) {
          n3.toggleHidden(!e6.target.checked);
        }, style: { cursor: "pointer" }, checked: n3.isVisible, title: "Toggle Column Visible" }];
      }, $ = function(e4, t4) {
        var n3 = t4.instance;
        return [e4, { onChange: function(e6) {
          n3.toggleHideAllColumns(!e6.target.checked);
        }, style: { cursor: "pointer" }, checked: !n3.allColumnsHidden && !n3.state.hiddenColumns.length, title: "Toggle All Columns Hidden", indeterminate: !n3.allColumnsHidden && n3.state.hiddenColumns.length }];
      };
      function J(e4, t4, n3, o3) {
        if (t4.type === l2.init) return r2({ hiddenColumns: [] }, e4);
        if (t4.type === l2.resetHiddenColumns) return r2({}, e4, { hiddenColumns: o3.initialState.hiddenColumns || [] });
        if (t4.type === l2.toggleHideColumn) {
          var i4 = (void 0 !== t4.value ? t4.value : !e4.hiddenColumns.includes(t4.columnId)) ? [].concat(e4.hiddenColumns, [t4.columnId]) : e4.hiddenColumns.filter(function(e6) {
            return e6 !== t4.columnId;
          });
          return r2({}, e4, { hiddenColumns: i4 });
        }
        return t4.type === l2.setHiddenColumns ? r2({}, e4, { hiddenColumns: m4(t4.value, e4.hiddenColumns) }) : t4.type === l2.toggleHideAllColumns ? r2({}, e4, { hiddenColumns: (void 0 !== t4.value ? t4.value : !e4.hiddenColumns.length) ? o3.allColumns.map(function(e6) {
          return e6.id;
        }) : [] }) : void 0;
      }
      function Y2(e4) {
        var n3 = e4.headers, o3 = e4.state.hiddenColumns;
        t3.useRef(false).current;
        var r3 = 0;
        n3.forEach(function(e6) {
          return r3 += function e7(t4, n4) {
            t4.isVisible = n4 && !o3.includes(t4.id);
            var r4 = 0;
            return t4.headers && t4.headers.length ? t4.headers.forEach(function(n5) {
              return r4 += e7(n5, t4.isVisible);
            }) : r4 = t4.isVisible ? 1 : 0, t4.totalVisibleHeaderCount = r4, r4;
          }(e6, true);
        });
      }
      function Q2(e4) {
        var n3 = e4.columns, o3 = e4.flatHeaders, r3 = e4.dispatch, i4 = e4.allColumns, u4 = e4.getHooks, s5 = e4.state.hiddenColumns, a5 = e4.autoResetHiddenColumns, c4 = void 0 === a5 || a5, d5 = h4(e4), p3 = i4.length === s5.length, g3 = t3.useCallback(function(e6, t4) {
          return r3({ type: l2.toggleHideColumn, columnId: e6, value: t4 });
        }, [r3]), v3 = t3.useCallback(function(e6) {
          return r3({ type: l2.setHiddenColumns, value: e6 });
        }, [r3]), m5 = t3.useCallback(function(e6) {
          return r3({ type: l2.toggleHideAllColumns, value: e6 });
        }, [r3]), y5 = f2(u4().getToggleHideAllColumnsProps, { instance: d5() });
        o3.forEach(function(e6) {
          e6.toggleHidden = function(t4) {
            r3({ type: l2.toggleHideColumn, columnId: e6.id, value: t4 });
          }, e6.getToggleHiddenProps = f2(u4().getToggleHiddenProps, { instance: d5(), column: e6 });
        });
        var R4 = h4(c4);
        w3(function() {
          R4() && r3({ type: l2.resetHiddenColumns });
        }, [r3, n3]), Object.assign(e4, { allColumnsHidden: p3, toggleHideColumn: g3, setHiddenColumns: v3, toggleHideAllColumns: m5, getToggleHideAllColumnsProps: y5 });
      }
      var Z = {}, ee = {}, te = function(e4, t4, n3) {
        return e4;
      }, ne = function(e4, t4) {
        return e4.subRows || [];
      }, oe = function(e4, t4, n3) {
        return "" + (n3 ? [n3.id, t4].join(".") : t4);
      }, re2 = function(e4) {
        return e4;
      };
      function ie(e4) {
        var t4 = e4.initialState, n3 = void 0 === t4 ? Z : t4, o3 = e4.defaultColumn, u4 = void 0 === o3 ? ee : o3, l3 = e4.getSubRows, s5 = void 0 === l3 ? ne : l3, a5 = e4.getRowId, c4 = void 0 === a5 ? oe : a5, d5 = e4.stateReducer, f3 = void 0 === d5 ? te : d5, p3 = e4.useControlledState, g3 = void 0 === p3 ? re2 : p3;
        return r2({}, i3(e4, ["initialState", "defaultColumn", "getSubRows", "getRowId", "stateReducer", "useControlledState"]), { initialState: n3, defaultColumn: u4, getSubRows: s5, getRowId: c4, stateReducer: f3, useControlledState: g3 });
      }
      function ue(e4, t4) {
        void 0 === t4 && (t4 = 0);
        var n3 = 0, o3 = 0, r3 = 0, i4 = 0;
        return e4.forEach(function(e6) {
          var u4 = e6.headers;
          if (e6.totalLeft = t4, u4 && u4.length) {
            var l3 = ue(u4, t4), s5 = l3[0], a5 = l3[1], c4 = l3[2], d5 = l3[3];
            e6.totalMinWidth = s5, e6.totalWidth = a5, e6.totalMaxWidth = c4, e6.totalFlexWidth = d5;
          } else e6.totalMinWidth = e6.minWidth, e6.totalWidth = Math.min(Math.max(e6.minWidth, e6.width), e6.maxWidth), e6.totalMaxWidth = e6.maxWidth, e6.totalFlexWidth = e6.canResize ? e6.totalWidth : 0;
          e6.isVisible && (t4 += e6.totalWidth, n3 += e6.totalMinWidth, o3 += e6.totalWidth, r3 += e6.totalMaxWidth, i4 += e6.totalFlexWidth);
        }), [n3, o3, r3, i4];
      }
      function le(e4) {
        var t4 = e4.data, n3 = e4.rows, o3 = e4.flatRows, r3 = e4.rowsById, i4 = e4.column, u4 = e4.getRowId, l3 = e4.getSubRows, s5 = e4.accessValueHooks, a5 = e4.getInstance;
        t4.forEach(function(e6, c4) {
          return function e7(n4, c5, d5, f3, g3) {
            void 0 === d5 && (d5 = 0);
            var v3 = n4, m5 = u4(n4, c5, f3), h5 = r3[m5];
            if (h5) h5.subRows && h5.originalSubRows.forEach(function(t5, n5) {
              return e7(t5, n5, d5 + 1, h5);
            });
            else if ((h5 = { id: m5, original: v3, index: c5, depth: d5, cells: [{}] }).cells.map = W2, h5.cells.filter = W2, h5.cells.forEach = W2, h5.cells[0].getCellProps = W2, h5.values = {}, g3.push(h5), o3.push(h5), r3[m5] = h5, h5.originalSubRows = l3(n4, c5), h5.originalSubRows) {
              var y5 = [];
              h5.originalSubRows.forEach(function(t5, n5) {
                return e7(t5, n5, d5 + 1, h5, y5);
              }), h5.subRows = y5;
            }
            i4.accessor && (h5.values[i4.id] = i4.accessor(n4, c5, h5, g3, t4)), h5.values[i4.id] = p2(s5, h5.values[i4.id], { row: h5, column: i4, instance: a5() });
          }(e6, c4, 0, void 0, n3);
        });
      }
      l2.resetExpanded = "resetExpanded", l2.toggleRowExpanded = "toggleRowExpanded", l2.toggleAllRowsExpanded = "toggleAllRowsExpanded";
      var se = function(e4) {
        e4.getToggleAllRowsExpandedProps = [ae], e4.getToggleRowExpandedProps = [ce], e4.stateReducers.push(de), e4.useInstance.push(fe), e4.prepareRow.push(pe);
      };
      se.pluginName = "useExpanded";
      var ae = function(e4, t4) {
        var n3 = t4.instance;
        return [e4, { onClick: function(e6) {
          n3.toggleAllRowsExpanded();
        }, style: { cursor: "pointer" }, title: "Toggle All Rows Expanded" }];
      }, ce = function(e4, t4) {
        var n3 = t4.row;
        return [e4, { onClick: function() {
          n3.toggleRowExpanded();
        }, style: { cursor: "pointer" }, title: "Toggle Row Expanded" }];
      };
      function de(e4, t4, n3, o3) {
        if (t4.type === l2.init) return r2({ expanded: {} }, e4);
        if (t4.type === l2.resetExpanded) return r2({}, e4, { expanded: o3.initialState.expanded || {} });
        if (t4.type === l2.toggleAllRowsExpanded) {
          var s5 = t4.value, a5 = o3.rowsById, c4 = Object.keys(a5).length === Object.keys(e4.expanded).length;
          if (void 0 !== s5 ? s5 : !c4) {
            var d5 = {};
            return Object.keys(a5).forEach(function(e6) {
              d5[e6] = true;
            }), r2({}, e4, { expanded: d5 });
          }
          return r2({}, e4, { expanded: {} });
        }
        if (t4.type === l2.toggleRowExpanded) {
          var f3, p3 = t4.id, g3 = t4.value, v3 = e4.expanded[p3], m5 = void 0 !== g3 ? g3 : !v3;
          if (!v3 && m5) return r2({}, e4, { expanded: r2({}, e4.expanded, (f3 = {}, f3[p3] = true, f3)) });
          if (v3 && !m5) {
            var h5 = e4.expanded;
            h5[p3];
            return r2({}, e4, { expanded: i3(h5, [p3].map(u3)) });
          }
          return e4;
        }
      }
      function fe(e4) {
        var n3 = e4.data, o3 = e4.rows, r3 = e4.rowsById, i4 = e4.manualExpandedKey, u4 = void 0 === i4 ? "expanded" : i4, s5 = e4.paginateExpandedRows, a5 = void 0 === s5 || s5, c4 = e4.expandSubRows, d5 = void 0 === c4 || c4, p3 = e4.autoResetExpanded, g3 = void 0 === p3 || p3, m5 = e4.getHooks, y5 = e4.plugins, R4 = e4.state.expanded, b4 = e4.dispatch;
        v2(y5, ["useSortBy", "useGroupBy", "usePivotColumns", "useGlobalFilter"], "useExpanded");
        var S5 = h4(g3), C3 = Boolean(Object.keys(r3).length && Object.keys(R4).length);
        C3 && Object.keys(r3).some(function(e6) {
          return !R4[e6];
        }) && (C3 = false), w3(function() {
          S5() && b4({ type: l2.resetExpanded });
        }, [b4, n3]);
        var x4 = t3.useCallback(function(e6, t4) {
          b4({ type: l2.toggleRowExpanded, id: e6, value: t4 });
        }, [b4]), P3 = t3.useCallback(function(e6) {
          return b4({ type: l2.toggleAllRowsExpanded, value: e6 });
        }, [b4]), B3 = t3.useMemo(function() {
          return a5 ? A2(o3, { manualExpandedKey: u4, expanded: R4, expandSubRows: d5 }) : o3;
        }, [a5, o3, u4, R4, d5]), E4 = t3.useMemo(function() {
          return function(e6) {
            var t4 = 0;
            return Object.keys(e6).forEach(function(e7) {
              var n4 = e7.split(".");
              t4 = Math.max(t4, n4.length);
            }), t4;
          }(R4);
        }, [R4]), I3 = h4(e4), F2 = f2(m5().getToggleAllRowsExpandedProps, { instance: I3() });
        Object.assign(e4, { preExpandedRows: o3, expandedRows: B3, rows: B3, expandedDepth: E4, isAllRowsExpanded: C3, toggleRowExpanded: x4, toggleAllRowsExpanded: P3, getToggleAllRowsExpandedProps: F2 });
      }
      function pe(e4, t4) {
        var n3 = t4.instance.getHooks, o3 = t4.instance;
        e4.toggleRowExpanded = function(t5) {
          return o3.toggleRowExpanded(e4.id, t5);
        }, e4.getToggleRowExpandedProps = f2(n3().getToggleRowExpandedProps, { instance: o3, row: e4 });
      }
      var ge = function(e4, t4, n3) {
        return e4 = e4.filter(function(e6) {
          return t4.some(function(t5) {
            var o3 = e6.values[t5];
            return String(o3).toLowerCase().includes(String(n3).toLowerCase());
          });
        });
      };
      ge.autoRemove = function(e4) {
        return !e4;
      };
      var ve = function(e4, t4, n3) {
        return e4.filter(function(e6) {
          return t4.some(function(t5) {
            var o3 = e6.values[t5];
            return void 0 === o3 || String(o3).toLowerCase() === String(n3).toLowerCase();
          });
        });
      };
      ve.autoRemove = function(e4) {
        return !e4;
      };
      var me = function(e4, t4, n3) {
        return e4.filter(function(e6) {
          return t4.some(function(t5) {
            var o3 = e6.values[t5];
            return void 0 === o3 || String(o3) === String(n3);
          });
        });
      };
      me.autoRemove = function(e4) {
        return !e4;
      };
      var he = function(e4, t4, n3) {
        return e4.filter(function(e6) {
          return t4.some(function(t5) {
            return e6.values[t5].includes(n3);
          });
        });
      };
      he.autoRemove = function(e4) {
        return !e4 || !e4.length;
      };
      var ye = function(e4, t4, n3) {
        return e4.filter(function(e6) {
          return t4.some(function(t5) {
            var o3 = e6.values[t5];
            return o3 && o3.length && n3.every(function(e7) {
              return o3.includes(e7);
            });
          });
        });
      };
      ye.autoRemove = function(e4) {
        return !e4 || !e4.length;
      };
      var we = function(e4, t4, n3) {
        return e4.filter(function(e6) {
          return t4.some(function(t5) {
            var o3 = e6.values[t5];
            return o3 && o3.length && n3.some(function(e7) {
              return o3.includes(e7);
            });
          });
        });
      };
      we.autoRemove = function(e4) {
        return !e4 || !e4.length;
      };
      var Re = function(e4, t4, n3) {
        return e4.filter(function(e6) {
          return t4.some(function(t5) {
            var o3 = e6.values[t5];
            return n3.includes(o3);
          });
        });
      };
      Re.autoRemove = function(e4) {
        return !e4 || !e4.length;
      };
      var be = function(e4, t4, n3) {
        return e4.filter(function(e6) {
          return t4.some(function(t5) {
            return e6.values[t5] === n3;
          });
        });
      };
      be.autoRemove = function(e4) {
        return void 0 === e4;
      };
      var Se = function(e4, t4, n3) {
        return e4.filter(function(e6) {
          return t4.some(function(t5) {
            return e6.values[t5] == n3;
          });
        });
      };
      Se.autoRemove = function(e4) {
        return null == e4;
      };
      var Ce = function(e4, t4, n3) {
        var o3 = n3 || [], r3 = o3[0], i4 = o3[1];
        if ((r3 = "number" == typeof r3 ? r3 : -1 / 0) > (i4 = "number" == typeof i4 ? i4 : 1 / 0)) {
          var u4 = r3;
          r3 = i4, i4 = u4;
        }
        return e4.filter(function(e6) {
          return t4.some(function(t5) {
            var n4 = e6.values[t5];
            return n4 >= r3 && n4 <= i4;
          });
        });
      };
      Ce.autoRemove = function(e4) {
        return !e4 || "number" != typeof e4[0] && "number" != typeof e4[1];
      };
      var xe = Object.freeze({ __proto__: null, text: ge, exactText: ve, exactTextCase: me, includes: he, includesAll: ye, includesSome: we, includesValue: Re, exact: be, equals: Se, between: Ce });
      l2.resetFilters = "resetFilters", l2.setFilter = "setFilter", l2.setAllFilters = "setAllFilters";
      var Pe = function(e4) {
        e4.stateReducers.push(Be), e4.useInstance.push(Ee);
      };
      function Be(e4, t4, n3, o3) {
        if (t4.type === l2.init) return r2({ filters: [] }, e4);
        if (t4.type === l2.resetFilters) return r2({}, e4, { filters: o3.initialState.filters || [] });
        if (t4.type === l2.setFilter) {
          var i4 = t4.columnId, u4 = t4.filterValue, s5 = o3.allColumns, a5 = o3.filterTypes, c4 = s5.find(function(e6) {
            return e6.id === i4;
          });
          if (!c4) throw new Error("React-Table: Could not find a column with id: " + i4);
          var d5 = k3(c4.filter, a5 || {}, xe), f3 = e4.filters.find(function(e6) {
            return e6.id === i4;
          }), p3 = m4(u4, f3 && f3.value);
          return H4(d5.autoRemove, p3, c4) ? r2({}, e4, { filters: e4.filters.filter(function(e6) {
            return e6.id !== i4;
          }) }) : r2({}, e4, f3 ? { filters: e4.filters.map(function(e6) {
            return e6.id === i4 ? { id: i4, value: p3 } : e6;
          }) } : { filters: [].concat(e4.filters, [{ id: i4, value: p3 }]) });
        }
        if (t4.type === l2.setAllFilters) {
          var g3 = t4.filters, v3 = o3.allColumns, h5 = o3.filterTypes;
          return r2({}, e4, { filters: m4(g3, e4.filters).filter(function(e6) {
            var t5 = v3.find(function(t6) {
              return t6.id === e6.id;
            });
            return !H4(k3(t5.filter, h5 || {}, xe).autoRemove, e6.value, t5);
          }) });
        }
      }
      function Ee(e4) {
        var n3 = e4.data, o3 = e4.rows, r3 = e4.flatRows, i4 = e4.rowsById, u4 = e4.allColumns, s5 = e4.filterTypes, a5 = e4.manualFilters, c4 = e4.defaultCanFilter, d5 = void 0 !== c4 && c4, f3 = e4.disableFilters, p3 = e4.state.filters, g3 = e4.dispatch, v3 = e4.autoResetFilters, m5 = void 0 === v3 || v3, y5 = t3.useCallback(function(e6, t4) {
          g3({ type: l2.setFilter, columnId: e6, filterValue: t4 });
        }, [g3]), R4 = t3.useCallback(function(e6) {
          g3({ type: l2.setAllFilters, filters: e6 });
        }, [g3]);
        u4.forEach(function(e6) {
          var t4 = e6.id, n4 = e6.accessor, o4 = e6.defaultCanFilter, r4 = e6.disableFilters;
          e6.canFilter = n4 ? I2(true !== r4 && void 0, true !== f3 && void 0, true) : I2(o4, d5, false), e6.setFilter = function(t5) {
            return y5(e6.id, t5);
          };
          var i5 = p3.find(function(e7) {
            return e7.id === t4;
          });
          e6.filterValue = i5 && i5.value;
        });
        var b4 = t3.useMemo(function() {
          if (a5 || !p3.length) return [o3, r3, i4];
          var e6 = [], t4 = {};
          return [function n4(o4, r4) {
            void 0 === r4 && (r4 = 0);
            var i5 = o4;
            return (i5 = p3.reduce(function(e7, t5) {
              var n5 = t5.id, o5 = t5.value, i6 = u4.find(function(e8) {
                return e8.id === n5;
              });
              if (!i6) return e7;
              0 === r4 && (i6.preFilteredRows = e7);
              var l3 = k3(i6.filter, s5 || {}, xe);
              return l3 ? (i6.filteredRows = l3(e7, [n5], o5), i6.filteredRows) : (console.warn("Could not find a valid 'column.filter' for column with the ID: " + i6.id + "."), e7);
            }, o4)).forEach(function(o5) {
              e6.push(o5), t4[o5.id] = o5, o5.subRows && (o5.subRows = o5.subRows && o5.subRows.length > 0 ? n4(o5.subRows, r4 + 1) : o5.subRows);
            }), i5;
          }(o3), e6, t4];
        }, [a5, p3, o3, r3, i4, u4, s5]), S5 = b4[0], C3 = b4[1], x4 = b4[2];
        t3.useMemo(function() {
          u4.filter(function(e6) {
            return !p3.find(function(t4) {
              return t4.id === e6.id;
            });
          }).forEach(function(e6) {
            e6.preFilteredRows = S5, e6.filteredRows = S5;
          });
        }, [S5, p3, u4]);
        var P3 = h4(m5);
        w3(function() {
          P3() && g3({ type: l2.resetFilters });
        }, [g3, a5 ? null : n3]), Object.assign(e4, { preFilteredRows: o3, preFilteredFlatRows: r3, preFilteredRowsById: i4, filteredRows: S5, filteredFlatRows: C3, filteredRowsById: x4, rows: S5, flatRows: C3, rowsById: x4, setFilter: y5, setAllFilters: R4 });
      }
      Pe.pluginName = "useFilters", l2.resetGlobalFilter = "resetGlobalFilter", l2.setGlobalFilter = "setGlobalFilter";
      var Ie = function(e4) {
        e4.stateReducers.push(Fe), e4.useInstance.push(Ge);
      };
      function Fe(e4, t4, n3, o3) {
        if (t4.type === l2.resetGlobalFilter) return r2({}, e4, { globalFilter: o3.initialState.globalFilter || void 0 });
        if (t4.type === l2.setGlobalFilter) {
          var u4 = t4.filterValue, s5 = o3.userFilterTypes, a5 = k3(o3.globalFilter, s5 || {}, xe), c4 = m4(u4, e4.globalFilter);
          if (H4(a5.autoRemove, c4)) {
            e4.globalFilter;
            return i3(e4, ["globalFilter"]);
          }
          return r2({}, e4, { globalFilter: c4 });
        }
      }
      function Ge(e4) {
        var n3 = e4.data, o3 = e4.rows, r3 = e4.flatRows, i4 = e4.rowsById, u4 = e4.allColumns, s5 = e4.filterTypes, a5 = e4.globalFilter, c4 = e4.manualGlobalFilter, d5 = e4.state.globalFilter, f3 = e4.dispatch, p3 = e4.autoResetGlobalFilter, g3 = void 0 === p3 || p3, v3 = e4.disableGlobalFilter, m5 = t3.useCallback(function(e6) {
          f3({ type: l2.setGlobalFilter, filterValue: e6 });
        }, [f3]), y5 = t3.useMemo(function() {
          if (c4 || void 0 === d5) return [o3, r3, i4];
          var e6 = [], t4 = {}, n4 = k3(a5, s5 || {}, xe);
          if (!n4) return console.warn("Could not find a valid 'globalFilter' option."), o3;
          u4.forEach(function(e7) {
            var t5 = e7.disableGlobalFilter;
            e7.canFilter = I2(true !== t5 && void 0, true !== v3 && void 0, true);
          });
          var l3 = u4.filter(function(e7) {
            return true === e7.canFilter;
          });
          return [function o4(r4) {
            return (r4 = n4(r4, l3.map(function(e7) {
              return e7.id;
            }), d5)).forEach(function(n5) {
              e6.push(n5), t4[n5.id] = n5, n5.subRows = n5.subRows && n5.subRows.length ? o4(n5.subRows) : n5.subRows;
            }), r4;
          }(o3), e6, t4];
        }, [c4, d5, a5, s5, u4, o3, r3, i4, v3]), R4 = y5[0], b4 = y5[1], S5 = y5[2], C3 = h4(g3);
        w3(function() {
          C3() && f3({ type: l2.resetGlobalFilter });
        }, [f3, c4 ? null : n3]), Object.assign(e4, { preGlobalFilteredRows: o3, preGlobalFilteredFlatRows: r3, preGlobalFilteredRowsById: i4, globalFilteredRows: R4, globalFilteredFlatRows: b4, globalFilteredRowsById: S5, rows: R4, flatRows: b4, rowsById: S5, setGlobalFilter: m5, disableGlobalFilter: v3 });
      }
      function Ae(e4, t4) {
        return t4.reduce(function(e6, t5) {
          return e6 + ("number" == typeof t5 ? t5 : 0);
        }, 0);
      }
      Ie.pluginName = "useGlobalFilter";
      var ke = Object.freeze({ __proto__: null, sum: Ae, min: function(e4) {
        var t4 = e4[0] || 0;
        return e4.forEach(function(e6) {
          "number" == typeof e6 && (t4 = Math.min(t4, e6));
        }), t4;
      }, max: function(e4) {
        var t4 = e4[0] || 0;
        return e4.forEach(function(e6) {
          "number" == typeof e6 && (t4 = Math.max(t4, e6));
        }), t4;
      }, minMax: function(e4) {
        var t4 = e4[0] || 0, n3 = e4[0] || 0;
        return e4.forEach(function(e6) {
          "number" == typeof e6 && (t4 = Math.min(t4, e6), n3 = Math.max(n3, e6));
        }), t4 + ".." + n3;
      }, average: function(e4) {
        return Ae(0, e4) / e4.length;
      }, median: function(e4) {
        if (!e4.length) return null;
        var t4 = Math.floor(e4.length / 2), n3 = [].concat(e4).sort(function(e6, t5) {
          return e6 - t5;
        });
        return e4.length % 2 != 0 ? n3[t4] : (n3[t4 - 1] + n3[t4]) / 2;
      }, unique: function(e4) {
        return Array.from(new Set(e4).values());
      }, uniqueCount: function(e4) {
        return new Set(e4).size;
      }, count: function(e4) {
        return e4.length;
      } }), He = [], We = {};
      l2.resetGroupBy = "resetGroupBy", l2.setGroupBy = "setGroupBy", l2.toggleGroupBy = "toggleGroupBy";
      var ze = function(e4) {
        e4.getGroupByToggleProps = [Te], e4.stateReducers.push(Oe), e4.visibleColumnsDeps.push(function(e6, t4) {
          var n3 = t4.instance;
          return [].concat(e6, [n3.state.groupBy]);
        }), e4.visibleColumns.push(Me), e4.useInstance.push(Le), e4.prepareRow.push(Ne);
      };
      ze.pluginName = "useGroupBy";
      var Te = function(e4, t4) {
        var n3 = t4.header;
        return [e4, { onClick: n3.canGroupBy ? function(e6) {
          e6.persist(), n3.toggleGroupBy();
        } : void 0, style: { cursor: n3.canGroupBy ? "pointer" : void 0 }, title: "Toggle GroupBy" }];
      };
      function Oe(e4, t4, n3, o3) {
        if (t4.type === l2.init) return r2({ groupBy: [] }, e4);
        if (t4.type === l2.resetGroupBy) return r2({}, e4, { groupBy: o3.initialState.groupBy || [] });
        if (t4.type === l2.setGroupBy) return r2({}, e4, { groupBy: t4.value });
        if (t4.type === l2.toggleGroupBy) {
          var i4 = t4.columnId, u4 = t4.value, s5 = void 0 !== u4 ? u4 : !e4.groupBy.includes(i4);
          return r2({}, e4, s5 ? { groupBy: [].concat(e4.groupBy, [i4]) } : { groupBy: e4.groupBy.filter(function(e6) {
            return e6 !== i4;
          }) });
        }
      }
      function Me(e4, t4) {
        var n3 = t4.instance.state.groupBy, o3 = n3.map(function(t5) {
          return e4.find(function(e6) {
            return e6.id === t5;
          });
        }).filter(Boolean), r3 = e4.filter(function(e6) {
          return !n3.includes(e6.id);
        });
        return (e4 = [].concat(o3, r3)).forEach(function(e6) {
          e6.isGrouped = n3.includes(e6.id), e6.groupedIndex = n3.indexOf(e6.id);
        }), e4;
      }
      var je = {};
      function Le(e4) {
        var n3 = e4.data, o3 = e4.rows, i4 = e4.flatRows, u4 = e4.rowsById, s5 = e4.allColumns, a5 = e4.flatHeaders, c4 = e4.groupByFn, d5 = void 0 === c4 ? De : c4, p3 = e4.manualGroupBy, g3 = e4.aggregations, m5 = void 0 === g3 ? je : g3, y5 = e4.plugins, R4 = e4.state.groupBy, b4 = e4.dispatch, S5 = e4.autoResetGroupBy, C3 = void 0 === S5 || S5, x4 = e4.disableGroupBy, P3 = e4.defaultCanGroupBy, B3 = e4.getHooks;
        v2(y5, ["useColumnOrder", "useFilters"], "useGroupBy");
        var E4 = h4(e4);
        s5.forEach(function(t4) {
          var n4 = t4.accessor, o4 = t4.defaultGroupBy, r3 = t4.disableGroupBy;
          t4.canGroupBy = n4 ? I2(t4.canGroupBy, true !== r3 && void 0, true !== x4 && void 0, true) : I2(t4.canGroupBy, o4, P3, false), t4.canGroupBy && (t4.toggleGroupBy = function() {
            return e4.toggleGroupBy(t4.id);
          }), t4.Aggregated = t4.Aggregated || t4.Cell;
        });
        var F2 = t3.useCallback(function(e6, t4) {
          b4({ type: l2.toggleGroupBy, columnId: e6, value: t4 });
        }, [b4]), A3 = t3.useCallback(function(e6) {
          b4({ type: l2.setGroupBy, value: e6 });
        }, [b4]);
        a5.forEach(function(e6) {
          e6.getGroupByToggleProps = f2(B3().getGroupByToggleProps, { instance: E4(), header: e6 });
        });
        var k4 = t3.useMemo(function() {
          if (p3 || !R4.length) return [o3, i4, u4, He, We, i4, u4];
          var e6 = R4.filter(function(e7) {
            return s5.find(function(t5) {
              return t5.id === e7;
            });
          }), t4 = [], n4 = {}, l3 = [], a6 = {}, c5 = [], f3 = {}, g4 = function o4(i5, u5, p4) {
            if (void 0 === u5 && (u5 = 0), u5 === e6.length) return i5.map(function(e7) {
              return r2({}, e7, { depth: u5 });
            });
            var g5 = e6[u5], v3 = d5(i5, g5);
            return Object.entries(v3).map(function(r3, i6) {
              var d6 = r3[0], v4 = r3[1], h5 = g5 + ":" + d6, y6 = o4(v4, u5 + 1, h5 = p4 ? p4 + ">" + h5 : h5), w4 = u5 ? G2(v4, "leafRows") : v4, R5 = function(t5, n5, o5) {
                var r4 = {};
                return s5.forEach(function(i7) {
                  if (e6.includes(i7.id)) r4[i7.id] = n5[0] ? n5[0].values[i7.id] : null;
                  else {
                    var u6 = "function" == typeof i7.aggregate ? i7.aggregate : m5[i7.aggregate] || ke[i7.aggregate];
                    if (u6) {
                      var l4 = n5.map(function(e7) {
                        return e7.values[i7.id];
                      }), s6 = t5.map(function(e7) {
                        var t6 = e7.values[i7.id];
                        if (!o5 && i7.aggregateValue) {
                          var n6 = "function" == typeof i7.aggregateValue ? i7.aggregateValue : m5[i7.aggregateValue] || ke[i7.aggregateValue];
                          if (!n6) throw console.info({ column: i7 }), new Error("React Table: Invalid column.aggregateValue option for column listed above");
                          t6 = n6(t6, e7, i7);
                        }
                        return t6;
                      });
                      r4[i7.id] = u6(s6, l4);
                    } else {
                      if (i7.aggregate) throw console.info({ column: i7 }), new Error("React Table: Invalid column.aggregate option for column listed above");
                      r4[i7.id] = null;
                    }
                  }
                }), r4;
              }(w4, v4, u5), b5 = { id: h5, isGrouped: true, groupByID: g5, groupByVal: d6, values: R5, subRows: y6, leafRows: w4, depth: u5, index: i6 };
              return y6.forEach(function(e7) {
                t4.push(e7), n4[e7.id] = e7, e7.isGrouped ? (l3.push(e7), a6[e7.id] = e7) : (c5.push(e7), f3[e7.id] = e7);
              }), b5;
            });
          }(o3);
          return g4.forEach(function(e7) {
            t4.push(e7), n4[e7.id] = e7, e7.isGrouped ? (l3.push(e7), a6[e7.id] = e7) : (c5.push(e7), f3[e7.id] = e7);
          }), [g4, t4, n4, l3, a6, c5, f3];
        }, [p3, R4, o3, i4, u4, s5, m5, d5]), H5 = k4[0], W3 = k4[1], z4 = k4[2], T4 = k4[3], O4 = k4[4], M4 = k4[5], j2 = k4[6], L4 = h4(C3);
        w3(function() {
          L4() && b4({ type: l2.resetGroupBy });
        }, [b4, p3 ? null : n3]), Object.assign(e4, { preGroupedRows: o3, preGroupedFlatRow: i4, preGroupedRowsById: u4, groupedRows: H5, groupedFlatRows: W3, groupedRowsById: z4, onlyGroupedFlatRows: T4, onlyGroupedRowsById: O4, nonGroupedFlatRows: M4, nonGroupedRowsById: j2, rows: H5, flatRows: W3, rowsById: z4, toggleGroupBy: F2, setGroupBy: A3 });
      }
      function Ne(e4) {
        e4.allCells.forEach(function(t4) {
          var n3;
          t4.isGrouped = t4.column.isGrouped && t4.column.id === e4.groupByID, t4.isPlaceholder = !t4.isGrouped && t4.column.isGrouped, t4.isAggregated = !t4.isGrouped && !t4.isPlaceholder && (null == (n3 = e4.subRows) ? void 0 : n3.length);
        });
      }
      function De(e4, t4) {
        return e4.reduce(function(e6, n3, o3) {
          var r3 = "" + n3.values[t4];
          return e6[r3] = Array.isArray(e6[r3]) ? e6[r3] : [], e6[r3].push(n3), e6;
        }, {});
      }
      var Ve = /([0-9]+)/gm;
      function _e(e4, t4) {
        return e4 === t4 ? 0 : e4 > t4 ? 1 : -1;
      }
      function Xe(e4, t4, n3) {
        return [e4.values[n3], t4.values[n3]];
      }
      function qe(e4) {
        return "number" == typeof e4 ? isNaN(e4) || e4 === 1 / 0 || e4 === -1 / 0 ? "" : String(e4) : "string" == typeof e4 ? e4 : "";
      }
      var Ke = Object.freeze({ __proto__: null, alphanumeric: function(e4, t4, n3) {
        var o3 = Xe(e4, t4, n3), r3 = o3[0], i4 = o3[1];
        for (r3 = qe(r3), i4 = qe(i4), r3 = r3.split(Ve).filter(Boolean), i4 = i4.split(Ve).filter(Boolean); r3.length && i4.length; ) {
          var u4 = r3.shift(), l3 = i4.shift(), s5 = parseInt(u4, 10), a5 = parseInt(l3, 10), c4 = [s5, a5].sort();
          if (isNaN(c4[0])) {
            if (u4 > l3) return 1;
            if (l3 > u4) return -1;
          } else {
            if (isNaN(c4[1])) return isNaN(s5) ? -1 : 1;
            if (s5 > a5) return 1;
            if (a5 > s5) return -1;
          }
        }
        return r3.length - i4.length;
      }, datetime: function(e4, t4, n3) {
        var o3 = Xe(e4, t4, n3), r3 = o3[0], i4 = o3[1];
        return _e(r3 = r3.getTime(), i4 = i4.getTime());
      }, basic: function(e4, t4, n3) {
        var o3 = Xe(e4, t4, n3);
        return _e(o3[0], o3[1]);
      }, string: function(e4, t4, n3) {
        var o3 = Xe(e4, t4, n3), r3 = o3[0], i4 = o3[1];
        for (r3 = r3.split("").filter(Boolean), i4 = i4.split("").filter(Boolean); r3.length && i4.length; ) {
          var u4 = r3.shift(), l3 = i4.shift(), s5 = u4.toLowerCase(), a5 = l3.toLowerCase();
          if (s5 > a5) return 1;
          if (a5 > s5) return -1;
          if (u4 > l3) return 1;
          if (l3 > u4) return -1;
        }
        return r3.length - i4.length;
      }, number: function(e4, t4, n3) {
        var o3 = Xe(e4, t4, n3), r3 = o3[0], i4 = o3[1], u4 = /[^0-9.]/gi;
        return _e(r3 = Number(String(r3).replace(u4, "")), i4 = Number(String(i4).replace(u4, "")));
      } });
      l2.resetSortBy = "resetSortBy", l2.setSortBy = "setSortBy", l2.toggleSortBy = "toggleSortBy", l2.clearSortBy = "clearSortBy", c3.sortType = "alphanumeric", c3.sortDescFirst = false;
      var Ue = function(e4) {
        e4.getSortByToggleProps = [$e], e4.stateReducers.push(Je), e4.useInstance.push(Ye);
      };
      Ue.pluginName = "useSortBy";
      var $e = function(e4, t4) {
        var n3 = t4.instance, o3 = t4.column, r3 = n3.isMultiSortEvent, i4 = void 0 === r3 ? function(e6) {
          return e6.shiftKey;
        } : r3;
        return [e4, { onClick: o3.canSort ? function(e6) {
          e6.persist(), o3.toggleSortBy(void 0, !n3.disableMultiSort && i4(e6));
        } : void 0, style: { cursor: o3.canSort ? "pointer" : void 0 }, title: o3.canSort ? "Toggle SortBy" : void 0 }];
      };
      function Je(e4, t4, n3, o3) {
        if (t4.type === l2.init) return r2({ sortBy: [] }, e4);
        if (t4.type === l2.resetSortBy) return r2({}, e4, { sortBy: o3.initialState.sortBy || [] });
        if (t4.type === l2.clearSortBy) return r2({}, e4, { sortBy: e4.sortBy.filter(function(e6) {
          return e6.id !== t4.columnId;
        }) });
        if (t4.type === l2.setSortBy) return r2({}, e4, { sortBy: t4.sortBy });
        if (t4.type === l2.toggleSortBy) {
          var i4, u4 = t4.columnId, s5 = t4.desc, a5 = t4.multi, c4 = o3.allColumns, d5 = o3.disableMultiSort, f3 = o3.disableSortRemove, p3 = o3.disableMultiRemove, g3 = o3.maxMultiSortColCount, v3 = void 0 === g3 ? Number.MAX_SAFE_INTEGER : g3, m5 = e4.sortBy, h5 = c4.find(function(e6) {
            return e6.id === u4;
          }).sortDescFirst, y5 = m5.find(function(e6) {
            return e6.id === u4;
          }), w4 = m5.findIndex(function(e6) {
            return e6.id === u4;
          }), R4 = null != s5, b4 = [];
          return "toggle" !== (i4 = !d5 && a5 ? y5 ? "toggle" : "add" : w4 !== m5.length - 1 || 1 !== m5.length ? "replace" : y5 ? "toggle" : "replace") || f3 || R4 || a5 && p3 || !(y5 && y5.desc && !h5 || !y5.desc && h5) || (i4 = "remove"), "replace" === i4 ? b4 = [{ id: u4, desc: R4 ? s5 : h5 }] : "add" === i4 ? (b4 = [].concat(m5, [{ id: u4, desc: R4 ? s5 : h5 }])).splice(0, b4.length - v3) : "toggle" === i4 ? b4 = m5.map(function(e6) {
            return e6.id === u4 ? r2({}, e6, { desc: R4 ? s5 : !y5.desc }) : e6;
          }) : "remove" === i4 && (b4 = m5.filter(function(e6) {
            return e6.id !== u4;
          })), r2({}, e4, { sortBy: b4 });
        }
      }
      function Ye(e4) {
        var n3 = e4.data, o3 = e4.rows, r3 = e4.flatRows, i4 = e4.allColumns, u4 = e4.orderByFn, s5 = void 0 === u4 ? Qe : u4, a5 = e4.sortTypes, c4 = e4.manualSortBy, d5 = e4.defaultCanSort, p3 = e4.disableSortBy, g3 = e4.flatHeaders, m5 = e4.state.sortBy, y5 = e4.dispatch, R4 = e4.plugins, b4 = e4.getHooks, S5 = e4.autoResetSortBy, C3 = void 0 === S5 || S5;
        v2(R4, ["useFilters", "useGlobalFilter", "useGroupBy", "usePivotColumns"], "useSortBy");
        var x4 = t3.useCallback(function(e6) {
          y5({ type: l2.setSortBy, sortBy: e6 });
        }, [y5]), P3 = t3.useCallback(function(e6, t4, n4) {
          y5({ type: l2.toggleSortBy, columnId: e6, desc: t4, multi: n4 });
        }, [y5]), B3 = h4(e4);
        g3.forEach(function(e6) {
          var t4 = e6.accessor, n4 = e6.canSort, o4 = e6.disableSortBy, r4 = e6.id, i5 = t4 ? I2(true !== o4 && void 0, true !== p3 && void 0, true) : I2(d5, n4, false);
          e6.canSort = i5, e6.canSort && (e6.toggleSortBy = function(t5, n5) {
            return P3(e6.id, t5, n5);
          }, e6.clearSortBy = function() {
            y5({ type: l2.clearSortBy, columnId: e6.id });
          }), e6.getSortByToggleProps = f2(b4().getSortByToggleProps, { instance: B3(), column: e6 });
          var u5 = m5.find(function(e7) {
            return e7.id === r4;
          });
          e6.isSorted = !!u5, e6.sortedIndex = m5.findIndex(function(e7) {
            return e7.id === r4;
          }), e6.isSortedDesc = e6.isSorted ? u5.desc : void 0;
        });
        var E4 = t3.useMemo(function() {
          if (c4 || !m5.length) return [o3, r3];
          var e6 = [], t4 = m5.filter(function(e7) {
            return i4.find(function(t5) {
              return t5.id === e7.id;
            });
          });
          return [function n4(o4) {
            var r4 = s5(o4, t4.map(function(e7) {
              var t5 = i4.find(function(t6) {
                return t6.id === e7.id;
              });
              if (!t5) throw new Error("React-Table: Could not find a column with id: " + e7.id + " while sorting");
              var n5 = t5.sortType, o5 = F(n5) || (a5 || {})[n5] || Ke[n5];
              if (!o5) throw new Error("React-Table: Could not find a valid sortType of '" + n5 + "' for column '" + e7.id + "'.");
              return function(t6, n6) {
                return o5(t6, n6, e7.id, e7.desc);
              };
            }), t4.map(function(e7) {
              var t5 = i4.find(function(t6) {
                return t6.id === e7.id;
              });
              return t5 && t5.sortInverted ? e7.desc : !e7.desc;
            }));
            return r4.forEach(function(t5) {
              e6.push(t5), t5.subRows && 0 !== t5.subRows.length && (t5.subRows = n4(t5.subRows));
            }), r4;
          }(o3), e6];
        }, [c4, m5, o3, r3, i4, s5, a5]), G3 = E4[0], A3 = E4[1], k4 = h4(C3);
        w3(function() {
          k4() && y5({ type: l2.resetSortBy });
        }, [c4 ? null : n3]), Object.assign(e4, { preSortedRows: o3, preSortedFlatRows: r3, sortedRows: G3, sortedFlatRows: A3, rows: G3, flatRows: A3, setSortBy: x4, toggleSortBy: P3 });
      }
      function Qe(e4, t4, n3) {
        return [].concat(e4).sort(function(e6, o3) {
          for (var r3 = 0; r3 < t4.length; r3 += 1) {
            var i4 = t4[r3], u4 = false === n3[r3] || "desc" === n3[r3], l3 = i4(e6, o3);
            if (0 !== l3) return u4 ? -l3 : l3;
          }
          return n3[0] ? e6.index - o3.index : o3.index - e6.index;
        });
      }
      l2.resetPage = "resetPage", l2.gotoPage = "gotoPage", l2.setPageSize = "setPageSize";
      var Ze = function(e4) {
        e4.stateReducers.push(et), e4.useInstance.push(tt);
      };
      function et(e4, t4, n3, o3) {
        if (t4.type === l2.init) return r2({ pageSize: 10, pageIndex: 0 }, e4);
        if (t4.type === l2.resetPage) return r2({}, e4, { pageIndex: o3.initialState.pageIndex || 0 });
        if (t4.type === l2.gotoPage) {
          var i4 = o3.pageCount, u4 = o3.page, s5 = m4(t4.pageIndex, e4.pageIndex), a5 = false;
          return s5 > e4.pageIndex ? a5 = -1 === i4 ? u4.length >= e4.pageSize : s5 < i4 : s5 < e4.pageIndex && (a5 = s5 > -1), a5 ? r2({}, e4, { pageIndex: s5 }) : e4;
        }
        if (t4.type === l2.setPageSize) {
          var c4 = t4.pageSize, d5 = e4.pageSize * e4.pageIndex;
          return r2({}, e4, { pageIndex: Math.floor(d5 / c4), pageSize: c4 });
        }
      }
      function tt(e4) {
        var n3 = e4.rows, o3 = e4.autoResetPage, r3 = void 0 === o3 || o3, i4 = e4.manualExpandedKey, u4 = void 0 === i4 ? "expanded" : i4, s5 = e4.plugins, a5 = e4.pageCount, c4 = e4.paginateExpandedRows, d5 = void 0 === c4 || c4, f3 = e4.expandSubRows, p3 = void 0 === f3 || f3, g3 = e4.state, m5 = g3.pageSize, y5 = g3.pageIndex, R4 = g3.expanded, b4 = g3.globalFilter, S5 = g3.filters, C3 = g3.groupBy, x4 = g3.sortBy, P3 = e4.dispatch, B3 = e4.data, E4 = e4.manualPagination;
        v2(s5, ["useGlobalFilter", "useFilters", "useGroupBy", "useSortBy", "useExpanded"], "usePagination");
        var I3 = h4(r3);
        w3(function() {
          I3() && P3({ type: l2.resetPage });
        }, [P3, E4 ? null : B3, b4, S5, C3, x4]);
        var F2 = E4 ? a5 : Math.ceil(n3.length / m5), G3 = t3.useMemo(function() {
          return F2 > 0 ? [].concat(new Array(F2)).fill(null).map(function(e6, t4) {
            return t4;
          }) : [];
        }, [F2]), k4 = t3.useMemo(function() {
          var e6;
          if (E4) e6 = n3;
          else {
            var t4 = m5 * y5, o4 = t4 + m5;
            e6 = n3.slice(t4, o4);
          }
          return d5 ? e6 : A2(e6, { manualExpandedKey: u4, expanded: R4, expandSubRows: p3 });
        }, [p3, R4, u4, E4, y5, m5, d5, n3]), H5 = y5 > 0, W3 = -1 === F2 ? k4.length >= m5 : y5 < F2 - 1, z4 = t3.useCallback(function(e6) {
          P3({ type: l2.gotoPage, pageIndex: e6 });
        }, [P3]), T4 = t3.useCallback(function() {
          return z4(function(e6) {
            return e6 - 1;
          });
        }, [z4]), O4 = t3.useCallback(function() {
          return z4(function(e6) {
            return e6 + 1;
          });
        }, [z4]), M4 = t3.useCallback(function(e6) {
          P3({ type: l2.setPageSize, pageSize: e6 });
        }, [P3]);
        Object.assign(e4, { pageOptions: G3, pageCount: F2, page: k4, canPreviousPage: H5, canNextPage: W3, gotoPage: z4, previousPage: T4, nextPage: O4, setPageSize: M4 });
      }
      Ze.pluginName = "usePagination", l2.resetPivot = "resetPivot", l2.togglePivot = "togglePivot";
      var nt = function(e4) {
        e4.getPivotToggleProps = [rt], e4.stateReducers.push(it), e4.useInstanceAfterData.push(ut), e4.allColumns.push(lt), e4.accessValue.push(st), e4.materializedColumns.push(at), e4.materializedColumnsDeps.push(ct), e4.visibleColumns.push(dt), e4.visibleColumnsDeps.push(ft), e4.useInstance.push(pt), e4.prepareRow.push(gt);
      };
      nt.pluginName = "usePivotColumns";
      var ot = [], rt = function(e4, t4) {
        var n3 = t4.header;
        return [e4, { onClick: n3.canPivot ? function(e6) {
          e6.persist(), n3.togglePivot();
        } : void 0, style: { cursor: n3.canPivot ? "pointer" : void 0 }, title: "Toggle Pivot" }];
      };
      function it(e4, t4, n3, o3) {
        if (t4.type === l2.init) return r2({ pivotColumns: ot }, e4);
        if (t4.type === l2.resetPivot) return r2({}, e4, { pivotColumns: o3.initialState.pivotColumns || ot });
        if (t4.type === l2.togglePivot) {
          var i4 = t4.columnId, u4 = t4.value, s5 = void 0 !== u4 ? u4 : !e4.pivotColumns.includes(i4);
          return r2({}, e4, s5 ? { pivotColumns: [].concat(e4.pivotColumns, [i4]) } : { pivotColumns: e4.pivotColumns.filter(function(e6) {
            return e6 !== i4;
          }) });
        }
      }
      function ut(e4) {
        e4.allColumns.forEach(function(t4) {
          t4.isPivotSource = e4.state.pivotColumns.includes(t4.id);
        });
      }
      function lt(e4, t4) {
        var n3 = t4.instance;
        return e4.forEach(function(e6) {
          e6.isPivotSource = n3.state.pivotColumns.includes(e6.id), e6.uniqueValues = /* @__PURE__ */ new Set();
        }), e4;
      }
      function st(e4, t4) {
        var n3 = t4.column;
        return n3.uniqueValues && void 0 !== e4 && n3.uniqueValues.add(e4), e4;
      }
      function at(e4, t4) {
        var n3 = t4.instance, o3 = n3.allColumns, i4 = n3.state;
        if (!i4.pivotColumns.length || !i4.groupBy || !i4.groupBy.length) return e4;
        var u4 = i4.pivotColumns.map(function(e6) {
          return o3.find(function(t5) {
            return t5.id === e6;
          });
        }).filter(Boolean), l3 = o3.filter(function(e6) {
          return !e6.isPivotSource && !i4.groupBy.includes(e6.id) && !i4.pivotColumns.includes(e6.id);
        }), s5 = C2(function e6(t5, n4, o4) {
          void 0 === t5 && (t5 = 0), void 0 === o4 && (o4 = []);
          var i5 = u4[t5];
          return i5 ? Array.from(i5.uniqueValues).sort().map(function(u5) {
            var l4 = r2({}, i5, { Header: i5.PivotHeader || "string" == typeof i5.header ? i5.Header + ": " + u5 : u5, isPivotGroup: true, parent: n4, depth: t5, id: n4 ? n4.id + "." + i5.id + "." + u5 : i5.id + "." + u5, pivotValue: u5 });
            return l4.columns = e6(t5 + 1, l4, [].concat(o4, [function(e7) {
              return e7.values[i5.id] === u5;
            }])), l4;
          }) : l3.map(function(e7) {
            return r2({}, e7, { canPivot: false, isPivoted: true, parent: n4, depth: t5, id: "" + (n4 ? n4.id + "." + e7.id : e7.id), accessor: function(t6, n5, r3) {
              if (o4.every(function(e8) {
                return e8(r3);
              })) return r3.values[e7.id];
            } });
          });
        }());
        return [].concat(e4, s5);
      }
      function ct(e4, t4) {
        var n3 = t4.instance.state, o3 = n3.pivotColumns, r3 = n3.groupBy;
        return [].concat(e4, [o3, r3]);
      }
      function dt(e4, t4) {
        var n3 = t4.instance.state;
        return e4 = e4.filter(function(e6) {
          return !e6.isPivotSource;
        }), n3.pivotColumns.length && n3.groupBy && n3.groupBy.length && (e4 = e4.filter(function(e6) {
          return e6.isGrouped || e6.isPivoted;
        })), e4;
      }
      function ft(e4, t4) {
        var n3 = t4.instance;
        return [].concat(e4, [n3.state.pivotColumns, n3.state.groupBy]);
      }
      function pt(e4) {
        var t4 = e4.columns, n3 = e4.allColumns, o3 = e4.flatHeaders, r3 = e4.getHooks, i4 = e4.plugins, u4 = e4.dispatch, s5 = e4.autoResetPivot, a5 = void 0 === s5 || s5, c4 = e4.manaulPivot, d5 = e4.disablePivot, p3 = e4.defaultCanPivot;
        v2(i4, ["useGroupBy"], "usePivotColumns");
        var g3 = h4(e4);
        n3.forEach(function(t5) {
          var n4 = t5.accessor, o4 = t5.defaultPivot, r4 = t5.disablePivot;
          t5.canPivot = n4 ? I2(t5.canPivot, true !== r4 && void 0, true !== d5 && void 0, true) : I2(t5.canPivot, o4, p3, false), t5.canPivot && (t5.togglePivot = function() {
            return e4.togglePivot(t5.id);
          }), t5.Aggregated = t5.Aggregated || t5.Cell;
        });
        o3.forEach(function(e6) {
          e6.getPivotToggleProps = f2(r3().getPivotToggleProps, { instance: g3(), header: e6 });
        });
        var m5 = h4(a5);
        w3(function() {
          m5() && u4({ type: l2.resetPivot });
        }, [u4, c4 ? null : t4]), Object.assign(e4, { togglePivot: function(e6, t5) {
          u4({ type: l2.togglePivot, columnId: e6, value: t5 });
        } });
      }
      function gt(e4) {
        e4.allCells.forEach(function(e6) {
          e6.isPivoted = e6.column.isPivoted;
        });
      }
      l2.resetSelectedRows = "resetSelectedRows", l2.toggleAllRowsSelected = "toggleAllRowsSelected", l2.toggleRowSelected = "toggleRowSelected", l2.toggleAllPageRowsSelected = "toggleAllPageRowsSelected";
      var vt = function(e4) {
        e4.getToggleRowSelectedProps = [mt], e4.getToggleAllRowsSelectedProps = [ht], e4.getToggleAllPageRowsSelectedProps = [yt], e4.stateReducers.push(wt), e4.useInstance.push(Rt), e4.prepareRow.push(bt);
      };
      vt.pluginName = "useRowSelect";
      var mt = function(e4, t4) {
        var n3 = t4.instance, o3 = t4.row, r3 = n3.manualRowSelectedKey, i4 = void 0 === r3 ? "isSelected" : r3;
        return [e4, { onChange: function(e6) {
          o3.toggleRowSelected(e6.target.checked);
        }, style: { cursor: "pointer" }, checked: !(!o3.original || !o3.original[i4]) || o3.isSelected, title: "Toggle Row Selected", indeterminate: o3.isSomeSelected }];
      }, ht = function(e4, t4) {
        var n3 = t4.instance;
        return [e4, { onChange: function(e6) {
          n3.toggleAllRowsSelected(e6.target.checked);
        }, style: { cursor: "pointer" }, checked: n3.isAllRowsSelected, title: "Toggle All Rows Selected", indeterminate: Boolean(!n3.isAllRowsSelected && Object.keys(n3.state.selectedRowIds).length) }];
      }, yt = function(e4, t4) {
        var n3 = t4.instance;
        return [e4, { onChange: function(e6) {
          n3.toggleAllPageRowsSelected(e6.target.checked);
        }, style: { cursor: "pointer" }, checked: n3.isAllPageRowsSelected, title: "Toggle All Current Page Rows Selected", indeterminate: Boolean(!n3.isAllPageRowsSelected && n3.page.some(function(e6) {
          var t5 = e6.id;
          return n3.state.selectedRowIds[t5];
        })) }];
      };
      function wt(e4, t4, n3, o3) {
        if (t4.type === l2.init) return r2({ selectedRowIds: {} }, e4);
        if (t4.type === l2.resetSelectedRows) return r2({}, e4, { selectedRowIds: o3.initialState.selectedRowIds || {} });
        if (t4.type === l2.toggleAllRowsSelected) {
          var i4 = t4.value, u4 = o3.isAllRowsSelected, s5 = o3.rowsById, a5 = o3.nonGroupedRowsById, c4 = void 0 === a5 ? s5 : a5, d5 = void 0 !== i4 ? i4 : !u4, f3 = Object.assign({}, e4.selectedRowIds);
          return d5 ? Object.keys(c4).forEach(function(e6) {
            f3[e6] = true;
          }) : Object.keys(c4).forEach(function(e6) {
            delete f3[e6];
          }), r2({}, e4, { selectedRowIds: f3 });
        }
        if (t4.type === l2.toggleRowSelected) {
          var p3 = t4.id, g3 = t4.value, v3 = o3.rowsById, m5 = o3.selectSubRows, h5 = void 0 === m5 || m5, y5 = o3.getSubRows, w4 = e4.selectedRowIds[p3], R4 = void 0 !== g3 ? g3 : !w4;
          if (w4 === R4) return e4;
          var b4 = r2({}, e4.selectedRowIds);
          return function e6(t5) {
            var n4 = v3[t5];
            if (n4 && (n4.isGrouped || (R4 ? b4[t5] = true : delete b4[t5]), h5 && y5(n4))) return y5(n4).forEach(function(t6) {
              return e6(t6.id);
            });
          }(p3), r2({}, e4, { selectedRowIds: b4 });
        }
        if (t4.type === l2.toggleAllPageRowsSelected) {
          var S5 = t4.value, C3 = o3.page, x4 = o3.rowsById, P3 = o3.selectSubRows, B3 = void 0 === P3 || P3, E4 = o3.isAllPageRowsSelected, I3 = o3.getSubRows, F2 = void 0 !== S5 ? S5 : !E4, G3 = r2({}, e4.selectedRowIds);
          return C3.forEach(function(e6) {
            return function e7(t5) {
              var n4 = x4[t5];
              if (n4.isGrouped || (F2 ? G3[t5] = true : delete G3[t5]), B3 && I3(n4)) return I3(n4).forEach(function(t6) {
                return e7(t6.id);
              });
            }(e6.id);
          }), r2({}, e4, { selectedRowIds: G3 });
        }
        return e4;
      }
      function Rt(e4) {
        var n3 = e4.data, o3 = e4.rows, r3 = e4.getHooks, i4 = e4.plugins, u4 = e4.rowsById, s5 = e4.nonGroupedRowsById, a5 = void 0 === s5 ? u4 : s5, c4 = e4.autoResetSelectedRows, d5 = void 0 === c4 || c4, p3 = e4.state.selectedRowIds, g3 = e4.selectSubRows, m5 = void 0 === g3 || g3, y5 = e4.dispatch, R4 = e4.page, b4 = e4.getSubRows;
        v2(i4, ["useFilters", "useGroupBy", "useSortBy", "useExpanded", "usePagination"], "useRowSelect");
        var S5 = t3.useMemo(function() {
          var e6 = [];
          return o3.forEach(function(t4) {
            var n4 = m5 ? function e7(t5, n5, o4) {
              if (n5[t5.id]) return true;
              var r4 = o4(t5);
              if (r4 && r4.length) {
                var i5 = true, u5 = false;
                return r4.forEach(function(t6) {
                  u5 && !i5 || (e7(t6, n5, o4) ? u5 = true : i5 = false);
                }), !!i5 || !!u5 && null;
              }
              return false;
            }(t4, p3, b4) : !!p3[t4.id];
            t4.isSelected = !!n4, t4.isSomeSelected = null === n4, n4 && e6.push(t4);
          }), e6;
        }, [o3, m5, p3, b4]), C3 = Boolean(Object.keys(a5).length && Object.keys(p3).length), x4 = C3;
        C3 && Object.keys(a5).some(function(e6) {
          return !p3[e6];
        }) && (C3 = false), C3 || R4 && R4.length && R4.some(function(e6) {
          var t4 = e6.id;
          return !p3[t4];
        }) && (x4 = false);
        var P3 = h4(d5);
        w3(function() {
          P3() && y5({ type: l2.resetSelectedRows });
        }, [y5, n3]);
        var B3 = t3.useCallback(function(e6) {
          return y5({ type: l2.toggleAllRowsSelected, value: e6 });
        }, [y5]), E4 = t3.useCallback(function(e6) {
          return y5({ type: l2.toggleAllPageRowsSelected, value: e6 });
        }, [y5]), I3 = t3.useCallback(function(e6, t4) {
          return y5({ type: l2.toggleRowSelected, id: e6, value: t4 });
        }, [y5]), F2 = h4(e4), G3 = f2(r3().getToggleAllRowsSelectedProps, { instance: F2() }), A3 = f2(r3().getToggleAllPageRowsSelectedProps, { instance: F2() });
        Object.assign(e4, { selectedFlatRows: S5, isAllRowsSelected: C3, isAllPageRowsSelected: x4, toggleRowSelected: I3, toggleAllRowsSelected: B3, getToggleAllRowsSelectedProps: G3, getToggleAllPageRowsSelectedProps: A3, toggleAllPageRowsSelected: E4 });
      }
      function bt(e4, t4) {
        var n3 = t4.instance;
        e4.toggleRowSelected = function(t5) {
          return n3.toggleRowSelected(e4.id, t5);
        }, e4.getToggleRowSelectedProps = f2(n3.getHooks().getToggleRowSelectedProps, { instance: n3, row: e4 });
      }
      var St = function(e4) {
        return {};
      }, Ct = function(e4) {
        return {};
      };
      l2.setRowState = "setRowState", l2.setCellState = "setCellState", l2.resetRowState = "resetRowState";
      var xt = function(e4) {
        e4.stateReducers.push(Pt), e4.useInstance.push(Bt), e4.prepareRow.push(Et);
      };
      function Pt(e4, t4, n3, o3) {
        var i4 = o3.initialRowStateAccessor, u4 = void 0 === i4 ? St : i4, s5 = o3.initialCellStateAccessor, a5 = void 0 === s5 ? Ct : s5, c4 = o3.rowsById;
        if (t4.type === l2.init) return r2({ rowState: {} }, e4);
        if (t4.type === l2.resetRowState) return r2({}, e4, { rowState: o3.initialState.rowState || {} });
        if (t4.type === l2.setRowState) {
          var d5, f3 = t4.rowId, p3 = t4.value, g3 = void 0 !== e4.rowState[f3] ? e4.rowState[f3] : u4(c4[f3]);
          return r2({}, e4, { rowState: r2({}, e4.rowState, (d5 = {}, d5[f3] = m4(p3, g3), d5)) });
        }
        if (t4.type === l2.setCellState) {
          var v3, h5, y5, w4, R4, b4 = t4.rowId, S5 = t4.columnId, C3 = t4.value, x4 = void 0 !== e4.rowState[b4] ? e4.rowState[b4] : u4(c4[b4]), P3 = void 0 !== (null == x4 ? void 0 : null == (v3 = x4.cellState) ? void 0 : v3[S5]) ? x4.cellState[S5] : a5(null == (h5 = c4[b4]) ? void 0 : null == (y5 = h5.cells) ? void 0 : y5.find(function(e6) {
            return e6.column.id === S5;
          }));
          return r2({}, e4, { rowState: r2({}, e4.rowState, (R4 = {}, R4[b4] = r2({}, x4, { cellState: r2({}, x4.cellState || {}, (w4 = {}, w4[S5] = m4(C3, P3), w4)) }), R4)) });
        }
      }
      function Bt(e4) {
        var n3 = e4.autoResetRowState, o3 = void 0 === n3 || n3, r3 = e4.data, i4 = e4.dispatch, u4 = t3.useCallback(function(e6, t4) {
          return i4({ type: l2.setRowState, rowId: e6, value: t4 });
        }, [i4]), s5 = t3.useCallback(function(e6, t4, n4) {
          return i4({ type: l2.setCellState, rowId: e6, columnId: t4, value: n4 });
        }, [i4]), a5 = h4(o3);
        w3(function() {
          a5() && i4({ type: l2.resetRowState });
        }, [r3]), Object.assign(e4, { setRowState: u4, setCellState: s5 });
      }
      function Et(e4, t4) {
        var n3 = t4.instance, o3 = n3.initialRowStateAccessor, r3 = void 0 === o3 ? St : o3, i4 = n3.initialCellStateAccessor, u4 = void 0 === i4 ? Ct : i4, l3 = n3.state.rowState;
        e4 && (e4.state = void 0 !== l3[e4.id] ? l3[e4.id] : r3(e4), e4.setState = function(t5) {
          return n3.setRowState(e4.id, t5);
        }, e4.cells.forEach(function(t5) {
          e4.state.cellState || (e4.state.cellState = {}), t5.state = void 0 !== e4.state.cellState[t5.column.id] ? e4.state.cellState[t5.column.id] : u4(t5), t5.setState = function(o4) {
            return n3.setCellState(e4.id, t5.column.id, o4);
          };
        }));
      }
      xt.pluginName = "useRowState", l2.resetColumnOrder = "resetColumnOrder", l2.setColumnOrder = "setColumnOrder";
      var It = function(e4) {
        e4.stateReducers.push(Ft), e4.visibleColumnsDeps.push(function(e6, t4) {
          var n3 = t4.instance;
          return [].concat(e6, [n3.state.columnOrder]);
        }), e4.visibleColumns.push(Gt), e4.useInstance.push(At);
      };
      function Ft(e4, t4, n3, o3) {
        return t4.type === l2.init ? r2({ columnOrder: [] }, e4) : t4.type === l2.resetColumnOrder ? r2({}, e4, { columnOrder: o3.initialState.columnOrder || [] }) : t4.type === l2.setColumnOrder ? r2({}, e4, { columnOrder: m4(t4.columnOrder, e4.columnOrder) }) : void 0;
      }
      function Gt(e4, t4) {
        var n3 = t4.instance.state.columnOrder;
        if (!n3 || !n3.length) return e4;
        for (var o3 = [].concat(n3), r3 = [].concat(e4), i4 = [], u4 = function() {
          var e6 = o3.shift(), t5 = r3.findIndex(function(t6) {
            return t6.id === e6;
          });
          t5 > -1 && i4.push(r3.splice(t5, 1)[0]);
        }; r3.length && o3.length; ) u4();
        return [].concat(i4, r3);
      }
      function At(e4) {
        var n3 = e4.dispatch;
        e4.setColumnOrder = t3.useCallback(function(e6) {
          return n3({ type: l2.setColumnOrder, columnOrder: e6 });
        }, [n3]);
      }
      It.pluginName = "useColumnOrder", c3.canResize = true, l2.columnStartResizing = "columnStartResizing", l2.columnResizing = "columnResizing", l2.columnDoneResizing = "columnDoneResizing", l2.resetResize = "resetResize";
      var kt = function(e4) {
        e4.getResizerProps = [Ht], e4.getHeaderProps.push({ style: { position: "relative" } }), e4.stateReducers.push(Wt), e4.useInstance.push(Tt), e4.useInstanceBeforeDimensions.push(zt);
      }, Ht = function(e4, t4) {
        var n3 = t4.instance, o3 = t4.header, r3 = n3.dispatch, i4 = function(e6, t5) {
          var n4 = false;
          if ("touchstart" === e6.type) {
            if (e6.touches && e6.touches.length > 1) return;
            n4 = true;
          }
          var o4, i5, u4 = function(e7) {
            var t6 = [];
            return function e8(n5) {
              n5.columns && n5.columns.length && n5.columns.map(e8);
              t6.push(n5);
            }(e7), t6;
          }(t5).map(function(e7) {
            return [e7.id, e7.totalWidth];
          }), s5 = n4 ? Math.round(e6.touches[0].clientX) : e6.clientX, a5 = function() {
            window.cancelAnimationFrame(o4), o4 = null, r3({ type: l2.columnDoneResizing });
          }, c4 = function() {
            window.cancelAnimationFrame(o4), o4 = null, r3({ type: l2.columnResizing, clientX: i5 });
          }, d5 = function(e7) {
            i5 = e7, o4 || (o4 = window.requestAnimationFrame(c4));
          }, f3 = { mouse: { moveEvent: "mousemove", moveHandler: function(e7) {
            return d5(e7.clientX);
          }, upEvent: "mouseup", upHandler: function(e7) {
            document.removeEventListener("mousemove", f3.mouse.moveHandler), document.removeEventListener("mouseup", f3.mouse.upHandler), a5();
          } }, touch: { moveEvent: "touchmove", moveHandler: function(e7) {
            return e7.cancelable && (e7.preventDefault(), e7.stopPropagation()), d5(e7.touches[0].clientX), false;
          }, upEvent: "touchend", upHandler: function(e7) {
            document.removeEventListener(f3.touch.moveEvent, f3.touch.moveHandler), document.removeEventListener(f3.touch.upEvent, f3.touch.moveHandler), a5();
          } } }, p3 = n4 ? f3.touch : f3.mouse, g3 = !!function() {
            if ("boolean" == typeof z3) return z3;
            var e7 = false;
            try {
              var t6 = { get passive() {
                return e7 = true, false;
              } };
              window.addEventListener("test", null, t6), window.removeEventListener("test", null, t6);
            } catch (t7) {
              e7 = false;
            }
            return z3 = e7;
          }() && { passive: false };
          document.addEventListener(p3.moveEvent, p3.moveHandler, g3), document.addEventListener(p3.upEvent, p3.upHandler, g3), r3({ type: l2.columnStartResizing, columnId: t5.id, columnWidth: t5.totalWidth, headerIdWidths: u4, clientX: s5 });
        };
        return [e4, { onMouseDown: function(e6) {
          return e6.persist() || i4(e6, o3);
        }, onTouchStart: function(e6) {
          return e6.persist() || i4(e6, o3);
        }, style: { cursor: "col-resize" }, draggable: false, role: "separator" }];
      };
      function Wt(e4, t4) {
        if (t4.type === l2.init) return r2({ columnResizing: { columnWidths: {} } }, e4);
        if (t4.type === l2.resetResize) return r2({}, e4, { columnResizing: { columnWidths: {} } });
        if (t4.type === l2.columnStartResizing) {
          var n3 = t4.clientX, o3 = t4.columnId, i4 = t4.columnWidth, u4 = t4.headerIdWidths;
          return r2({}, e4, { columnResizing: r2({}, e4.columnResizing, { startX: n3, headerIdWidths: u4, columnWidth: i4, isResizingColumn: o3 }) });
        }
        if (t4.type === l2.columnResizing) {
          var s5 = t4.clientX, a5 = e4.columnResizing, c4 = a5.startX, d5 = a5.columnWidth, f3 = a5.headerIdWidths, p3 = (s5 - c4) / d5, g3 = {};
          return (void 0 === f3 ? [] : f3).forEach(function(e6) {
            var t5 = e6[0], n4 = e6[1];
            g3[t5] = Math.max(n4 + n4 * p3, 0);
          }), r2({}, e4, { columnResizing: r2({}, e4.columnResizing, { columnWidths: r2({}, e4.columnResizing.columnWidths, {}, g3) }) });
        }
        return t4.type === l2.columnDoneResizing ? r2({}, e4, { columnResizing: r2({}, e4.columnResizing, { startX: null, isResizingColumn: null }) }) : void 0;
      }
      kt.pluginName = "useResizeColumns";
      var zt = function(e4) {
        var t4 = e4.flatHeaders, n3 = e4.disableResizing, o3 = e4.getHooks, r3 = e4.state.columnResizing, i4 = h4(e4);
        t4.forEach(function(e6) {
          var t5 = I2(true !== e6.disableResizing && void 0, true !== n3 && void 0, true);
          e6.canResize = t5, e6.width = r3.columnWidths[e6.id] || e6.originalWidth || e6.width, e6.isResizing = r3.isResizingColumn === e6.id, t5 && (e6.getResizerProps = f2(o3().getResizerProps, { instance: i4(), header: e6 }));
        });
      };
      function Tt(e4) {
        var n3 = e4.plugins, o3 = e4.dispatch, r3 = e4.autoResetResize, i4 = void 0 === r3 || r3, u4 = e4.columns;
        v2(n3, ["useAbsoluteLayout"], "useResizeColumns");
        var s5 = h4(i4);
        w3(function() {
          s5() && o3({ type: l2.resetResize });
        }, [u4]);
        var a5 = t3.useCallback(function() {
          return o3({ type: l2.resetResize });
        }, [o3]);
        Object.assign(e4, { resetResizing: a5 });
      }
      var Ot = { position: "absolute", top: 0 }, Mt = function(e4) {
        e4.getTableBodyProps.push(jt), e4.getRowProps.push(jt), e4.getHeaderGroupProps.push(jt), e4.getFooterGroupProps.push(jt), e4.getHeaderProps.push(function(e6, t4) {
          var n3 = t4.column;
          return [e6, { style: r2({}, Ot, { left: n3.totalLeft + "px", width: n3.totalWidth + "px" }) }];
        }), e4.getCellProps.push(function(e6, t4) {
          var n3 = t4.cell;
          return [e6, { style: r2({}, Ot, { left: n3.column.totalLeft + "px", width: n3.column.totalWidth + "px" }) }];
        }), e4.getFooterProps.push(function(e6, t4) {
          var n3 = t4.column;
          return [e6, { style: r2({}, Ot, { left: n3.totalLeft + "px", width: n3.totalWidth + "px" }) }];
        });
      };
      Mt.pluginName = "useAbsoluteLayout";
      var jt = function(e4, t4) {
        return [e4, { style: { position: "relative", width: t4.instance.totalColumnsWidth + "px" } }];
      }, Lt = { display: "inline-block", boxSizing: "border-box" }, Nt = function(e4, t4) {
        return [e4, { style: { display: "flex", width: t4.instance.totalColumnsWidth + "px" } }];
      }, Dt = function(e4) {
        e4.getRowProps.push(Nt), e4.getHeaderGroupProps.push(Nt), e4.getFooterGroupProps.push(Nt), e4.getHeaderProps.push(function(e6, t4) {
          var n3 = t4.column;
          return [e6, { style: r2({}, Lt, { width: n3.totalWidth + "px" }) }];
        }), e4.getCellProps.push(function(e6, t4) {
          var n3 = t4.cell;
          return [e6, { style: r2({}, Lt, { width: n3.column.totalWidth + "px" }) }];
        }), e4.getFooterProps.push(function(e6, t4) {
          var n3 = t4.column;
          return [e6, { style: r2({}, Lt, { width: n3.totalWidth + "px" }) }];
        });
      };
      function Vt(e4) {
        e4.getTableProps.push(_t), e4.getRowProps.push(Xt), e4.getHeaderGroupProps.push(Xt), e4.getFooterGroupProps.push(Xt), e4.getHeaderProps.push(qt), e4.getCellProps.push(Kt), e4.getFooterProps.push(Ut);
      }
      Dt.pluginName = "useBlockLayout", Vt.pluginName = "useFlexLayout";
      var _t = function(e4, t4) {
        return [e4, { style: { minWidth: t4.instance.totalColumnsMinWidth + "px" } }];
      }, Xt = function(e4, t4) {
        return [e4, { style: { display: "flex", flex: "1 0 auto", minWidth: t4.instance.totalColumnsMinWidth + "px" } }];
      }, qt = function(e4, t4) {
        var n3 = t4.column;
        return [e4, { style: { boxSizing: "border-box", flex: n3.totalFlexWidth ? n3.totalFlexWidth + " 0 auto" : void 0, minWidth: n3.totalMinWidth + "px", width: n3.totalWidth + "px" } }];
      }, Kt = function(e4, t4) {
        var n3 = t4.cell;
        return [e4, { style: { boxSizing: "border-box", flex: n3.column.totalFlexWidth + " 0 auto", minWidth: n3.column.totalMinWidth + "px", width: n3.column.totalWidth + "px" } }];
      }, Ut = function(e4, t4) {
        var n3 = t4.column;
        return [e4, { style: { boxSizing: "border-box", flex: n3.totalFlexWidth ? n3.totalFlexWidth + " 0 auto" : void 0, minWidth: n3.totalMinWidth + "px", width: n3.totalWidth + "px" } }];
      };
      function $t(e4) {
        e4.stateReducers.push(Zt), e4.getTableProps.push(Jt), e4.getHeaderProps.push(Yt), e4.getRowProps.push(Qt);
      }
      l2.columnStartResizing = "columnStartResizing", l2.columnResizing = "columnResizing", l2.columnDoneResizing = "columnDoneResizing", l2.resetResize = "resetResize", $t.pluginName = "useGridLayout";
      var Jt = function(e4, t4) {
        var n3 = t4.instance;
        return [e4, { style: { display: "grid", gridTemplateColumns: n3.visibleColumns.map(function(e6) {
          var t5;
          return n3.state.gridLayout.columnWidths[e6.id] ? n3.state.gridLayout.columnWidths[e6.id] + "px" : (null == (t5 = n3.state.columnResizing) ? void 0 : t5.isResizingColumn) ? n3.state.gridLayout.startWidths[e6.id] + "px" : "number" == typeof e6.width ? e6.width + "px" : e6.width;
        }).join(" ") } }];
      }, Yt = function(e4, t4) {
        var n3 = t4.column;
        return [e4, { id: "header-cell-" + n3.id, style: { position: "sticky", gridColumn: "span " + n3.totalVisibleHeaderCount } }];
      }, Qt = function(e4, t4) {
        var n3 = t4.row;
        return n3.isExpanded ? [e4, { style: { gridColumn: "1 / " + (n3.cells.length + 1) } }] : [e4, {}];
      };
      function Zt(e4, t4, n3, o3) {
        if (t4.type === l2.init) return r2({ gridLayout: { columnWidths: {} } }, e4);
        if (t4.type === l2.resetResize) return r2({}, e4, { gridLayout: { columnWidths: {} } });
        if (t4.type === l2.columnStartResizing) {
          var i4 = t4.columnId, u4 = t4.headerIdWidths, s5 = en(i4);
          if (void 0 !== s5) {
            var a5 = o3.visibleColumns.reduce(function(e6, t5) {
              var n4;
              return r2({}, e6, ((n4 = {})[t5.id] = en(t5.id), n4));
            }, {}), c4 = o3.visibleColumns.reduce(function(e6, t5) {
              var n4;
              return r2({}, e6, ((n4 = {})[t5.id] = t5.minWidth, n4));
            }, {}), d5 = o3.visibleColumns.reduce(function(e6, t5) {
              var n4;
              return r2({}, e6, ((n4 = {})[t5.id] = t5.maxWidth, n4));
            }, {}), f3 = u4.map(function(e6) {
              var t5 = e6[0];
              return [t5, en(t5)];
            });
            return r2({}, e4, { gridLayout: r2({}, e4.gridLayout, { startWidths: a5, minWidths: c4, maxWidths: d5, headerIdGridWidths: f3, columnWidth: s5 }) });
          }
          return e4;
        }
        if (t4.type === l2.columnResizing) {
          var p3 = t4.clientX, g3 = e4.columnResizing.startX, v3 = e4.gridLayout, m5 = v3.columnWidth, h5 = v3.minWidths, y5 = v3.maxWidths, w4 = v3.headerIdGridWidths, R4 = (p3 - g3) / m5, b4 = {};
          return (void 0 === w4 ? [] : w4).forEach(function(e6) {
            var t5 = e6[0], n4 = e6[1];
            b4[t5] = Math.min(Math.max(h5[t5], n4 + n4 * R4), y5[t5]);
          }), r2({}, e4, { gridLayout: r2({}, e4.gridLayout, { columnWidths: r2({}, e4.gridLayout.columnWidths, {}, b4) }) });
        }
        return t4.type === l2.columnDoneResizing ? r2({}, e4, { gridLayout: r2({}, e4.gridLayout, { startWidths: {}, minWidths: {}, maxWidths: {} }) }) : void 0;
      }
      function en(e4) {
        var t4, n3 = null == (t4 = document.getElementById("header-cell-" + e4)) ? void 0 : t4.offsetWidth;
        if (void 0 !== n3) return n3;
      }
      e3._UNSTABLE_usePivotColumns = nt, e3.actions = l2, e3.defaultColumn = c3, e3.defaultGroupByFn = De, e3.defaultOrderByFn = Qe, e3.defaultRenderer = s4, e3.emptyRenderer = a4, e3.ensurePluginOrder = v2, e3.flexRender = b3, e3.functionalUpdate = m4, e3.loopHooks = g2, e3.makePropGetter = f2, e3.makeRenderer = R3, e3.reduceHooks = p2, e3.safeUseLayoutEffect = y4, e3.useAbsoluteLayout = Mt, e3.useAsyncDebounce = function(e4, n3) {
        void 0 === n3 && (n3 = 0);
        var r3 = t3.useRef({}), i4 = h4(e4), u4 = h4(n3);
        return t3.useCallback(function() {
          var e6 = o2(regeneratorRuntime.mark(function e7() {
            var t4, n4, l3, s5 = arguments;
            return regeneratorRuntime.wrap(function(e8) {
              for (; ; ) switch (e8.prev = e8.next) {
                case 0:
                  for (t4 = s5.length, n4 = new Array(t4), l3 = 0; l3 < t4; l3++) n4[l3] = s5[l3];
                  return r3.current.promise || (r3.current.promise = new Promise(function(e9, t5) {
                    r3.current.resolve = e9, r3.current.reject = t5;
                  })), r3.current.timeout && clearTimeout(r3.current.timeout), r3.current.timeout = setTimeout(o2(regeneratorRuntime.mark(function e9() {
                    return regeneratorRuntime.wrap(function(e11) {
                      for (; ; ) switch (e11.prev = e11.next) {
                        case 0:
                          return delete r3.current.timeout, e11.prev = 1, e11.t0 = r3.current, e11.next = 5, i4().apply(void 0, n4);
                        case 5:
                          e11.t1 = e11.sent, e11.t0.resolve.call(e11.t0, e11.t1), e11.next = 12;
                          break;
                        case 9:
                          e11.prev = 9, e11.t2 = e11.catch(1), r3.current.reject(e11.t2);
                        case 12:
                          return e11.prev = 12, delete r3.current.promise, e11.finish(12);
                        case 15:
                        case "end":
                          return e11.stop();
                      }
                    }, e9, null, [[1, 9, 12, 15]]);
                  })), u4()), e8.abrupt("return", r3.current.promise);
                case 5:
                case "end":
                  return e8.stop();
              }
            }, e7);
          }));
          return function() {
            return e6.apply(this, arguments);
          };
        }(), [i4, u4]);
      }, e3.useBlockLayout = Dt, e3.useColumnOrder = It, e3.useExpanded = se, e3.useFilters = Pe, e3.useFlexLayout = Vt, e3.useGetLatest = h4, e3.useGlobalFilter = Ie, e3.useGridLayout = $t, e3.useGroupBy = ze, e3.useMountedLayoutEffect = w3, e3.usePagination = Ze, e3.useResizeColumns = kt, e3.useRowSelect = vt, e3.useRowState = xt, e3.useSortBy = Ue, e3.useTable = function(e4) {
        for (var n3 = arguments.length, o3 = new Array(n3 > 1 ? n3 - 1 : 0), i4 = 1; i4 < n3; i4++) o3[i4 - 1] = arguments[i4];
        e4 = ie(e4), o3 = [K2].concat(o3);
        var u4 = t3.useRef({}), s5 = h4(u4.current);
        Object.assign(s5(), r2({}, e4, { plugins: o3, hooks: q2() })), o3.filter(Boolean).forEach(function(e6) {
          e6(s5().hooks);
        });
        var a5 = h4(s5().hooks);
        s5().getHooks = a5, delete s5().hooks, Object.assign(s5(), p2(a5().useOptions, ie(e4)));
        var c4 = s5(), d5 = c4.data, v3 = c4.columns, m5 = c4.initialState, y5 = c4.defaultColumn, w4 = c4.getSubRows, b4 = c4.getRowId, E4 = c4.stateReducer, I3 = c4.useControlledState, F2 = h4(E4), G3 = t3.useCallback(function(e6, t4) {
          if (!t4.type) throw console.info({ action: t4 }), new Error("Unknown Action 👆");
          return [].concat(a5().stateReducers, Array.isArray(F2()) ? F2() : [F2()]).reduce(function(n4, o4) {
            return o4(n4, t4, e6, s5()) || n4;
          }, e6);
        }, [a5, F2, s5]), A3 = t3.useReducer(G3, void 0, function() {
          return G3(m5, { type: l2.init });
        }), k4 = A3[0], H5 = A3[1], W3 = p2([].concat(a5().useControlledState, [I3]), k4, { instance: s5() });
        Object.assign(s5(), { state: W3, dispatch: H5 });
        var z4 = t3.useMemo(function() {
          return S4(p2(a5().columns, v3, { instance: s5() }));
        }, [a5, s5, v3].concat(p2(a5().columnsDeps, [], { instance: s5() })));
        s5().columns = z4;
        var T4 = t3.useMemo(function() {
          return p2(a5().allColumns, C2(z4), { instance: s5() }).map(x3);
        }, [z4, a5, s5].concat(p2(a5().allColumnsDeps, [], { instance: s5() })));
        s5().allColumns = T4;
        var O4 = t3.useMemo(function() {
          for (var e6 = [], t4 = [], n4 = {}, o4 = [].concat(T4); o4.length; ) {
            var r3 = o4.shift();
            le({ data: d5, rows: e6, flatRows: t4, rowsById: n4, column: r3, getRowId: b4, getSubRows: w4, accessValueHooks: a5().accessValue, getInstance: s5 });
          }
          return [e6, t4, n4];
        }, [T4, d5, b4, w4, a5, s5]), M4 = O4[0], j2 = O4[1], L4 = O4[2];
        Object.assign(s5(), { rows: M4, initialRows: [].concat(M4), flatRows: j2, rowsById: L4 }), g2(a5().useInstanceAfterData, s5());
        var N3 = t3.useMemo(function() {
          return p2(a5().visibleColumns, T4, { instance: s5() }).map(function(e6) {
            return P2(e6, y5);
          });
        }, [a5, T4, s5, y5].concat(p2(a5().visibleColumnsDeps, [], { instance: s5() })));
        T4 = t3.useMemo(function() {
          var e6 = [].concat(N3);
          return T4.forEach(function(t4) {
            e6.find(function(e7) {
              return e7.id === t4.id;
            }) || e6.push(t4);
          }), e6;
        }, [T4, N3]), s5().allColumns = T4;
        var D4 = t3.useMemo(function() {
          return p2(a5().headerGroups, B2(N3, y5), s5());
        }, [a5, N3, y5, s5].concat(p2(a5().headerGroupsDeps, [], { instance: s5() })));
        s5().headerGroups = D4;
        var V2 = t3.useMemo(function() {
          return D4.length ? D4[0].headers : [];
        }, [D4]);
        s5().headers = V2, s5().flatHeaders = D4.reduce(function(e6, t4) {
          return [].concat(e6, t4.headers);
        }, []), g2(a5().useInstanceBeforeDimensions, s5());
        var _2 = N3.filter(function(e6) {
          return e6.isVisible;
        }).map(function(e6) {
          return e6.id;
        }).sort().join("_");
        N3 = t3.useMemo(function() {
          return N3.filter(function(e6) {
            return e6.isVisible;
          });
        }, [N3, _2]), s5().visibleColumns = N3;
        var X3 = ue(V2), U2 = X3[0], $2 = X3[1], J2 = X3[2];
        return s5().totalColumnsMinWidth = U2, s5().totalColumnsWidth = $2, s5().totalColumnsMaxWidth = J2, g2(a5().useInstance, s5()), [].concat(s5().flatHeaders, s5().allColumns).forEach(function(e6) {
          e6.render = R3(s5(), e6), e6.getHeaderProps = f2(a5().getHeaderProps, { instance: s5(), column: e6 }), e6.getFooterProps = f2(a5().getFooterProps, { instance: s5(), column: e6 });
        }), s5().headerGroups = t3.useMemo(function() {
          return D4.filter(function(e6, t4) {
            return e6.headers = e6.headers.filter(function(e7) {
              return e7.headers ? function e8(t5) {
                return t5.filter(function(t6) {
                  return t6.headers ? e8(t6.headers) : t6.isVisible;
                }).length;
              }(e7.headers) : e7.isVisible;
            }), !!e6.headers.length && (e6.getHeaderGroupProps = f2(a5().getHeaderGroupProps, { instance: s5(), headerGroup: e6, index: t4 }), e6.getFooterGroupProps = f2(a5().getFooterGroupProps, { instance: s5(), headerGroup: e6, index: t4 }), true);
          });
        }, [D4, s5, a5]), s5().footerGroups = [].concat(s5().headerGroups).reverse(), s5().prepareRow = t3.useCallback(function(e6) {
          e6.getRowProps = f2(a5().getRowProps, { instance: s5(), row: e6 }), e6.allCells = T4.map(function(t4) {
            var n4 = e6.values[t4.id], o4 = { column: t4, row: e6, value: n4 };
            return o4.getCellProps = f2(a5().getCellProps, { instance: s5(), cell: o4 }), o4.render = R3(s5(), t4, { row: e6, cell: o4, value: n4 }), o4;
          }), e6.cells = N3.map(function(t4) {
            return e6.allCells.find(function(e7) {
              return e7.column.id === t4.id;
            });
          }), g2(a5().prepareRow, e6, { instance: s5() });
        }, [a5, s5, T4, N3]), s5().getTableProps = f2(a5().getTableProps, { instance: s5() }), s5().getTableBodyProps = f2(a5().getTableBodyProps, { instance: s5() }), g2(a5().useFinalInstance, s5()), s5();
      }, Object.defineProperty(e3, "__esModule", { value: true });
    });
  })(reactTable_production_min$1, reactTable_production_min$1.exports);
  return reactTable_production_min$1.exports;
}
var reactTable_development$1 = { exports: {} };
var reactTable_development = reactTable_development$1.exports;
var hasRequiredReactTable_development;
function requireReactTable_development() {
  if (hasRequiredReactTable_development) return reactTable_development$1.exports;
  hasRequiredReactTable_development = 1;
  (function(module, exports) {
    (function(global2, factory) {
      factory(exports, React__default);
    })(reactTable_development, function(exports2, React2) {
      React2 = React2 && Object.prototype.hasOwnProperty.call(React2, "default") ? React2["default"] : React2;
      function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          Promise.resolve(value).then(_next, _throw);
        }
      }
      function _asyncToGenerator(fn) {
        return function() {
          var self2 = this, args = arguments;
          return new Promise(function(resolve, reject) {
            var gen = fn.apply(self2, args);
            function _next(value) {
              asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
              asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(void 0);
          });
        };
      }
      function _extends2() {
        _extends2 = Object.assign || function(target) {
          for (var i3 = 1; i3 < arguments.length; i3++) {
            var source = arguments[i3];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        return _extends2.apply(this, arguments);
      }
      function _objectWithoutPropertiesLoose2(source, excluded) {
        if (source == null) return {};
        var target = {};
        var sourceKeys = Object.keys(source);
        var key, i3;
        for (i3 = 0; i3 < sourceKeys.length; i3++) {
          key = sourceKeys[i3];
          if (excluded.indexOf(key) >= 0) continue;
          target[key] = source[key];
        }
        return target;
      }
      function _toPrimitive2(input, hint) {
        if (typeof input !== "object" || input === null) return input;
        var prim = input[Symbol.toPrimitive];
        if (prim !== void 0) {
          var res = prim.call(input, hint);
          if (typeof res !== "object") return res;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return String(input);
      }
      function _toPropertyKey2(arg) {
        var key = _toPrimitive2(arg, "string");
        return typeof key === "symbol" ? key : String(key);
      }
      var renderErr = "Renderer Error ☝️";
      var actions = {
        init: "init"
      };
      var defaultRenderer = function defaultRenderer2(_ref) {
        var _ref$value = _ref.value, value = _ref$value === void 0 ? "" : _ref$value;
        return value;
      };
      var emptyRenderer = function emptyRenderer2() {
        return React2.createElement(React2.Fragment, null, " ");
      };
      var defaultColumn = {
        Cell: defaultRenderer,
        width: 150,
        minWidth: 0,
        maxWidth: Number.MAX_SAFE_INTEGER
      };
      function mergeProps() {
        for (var _len = arguments.length, propList = new Array(_len), _key = 0; _key < _len; _key++) {
          propList[_key] = arguments[_key];
        }
        return propList.reduce(function(props, next) {
          var style = next.style, className = next.className, rest = _objectWithoutPropertiesLoose2(next, ["style", "className"]);
          props = _extends2({}, props, {}, rest);
          if (style) {
            props.style = props.style ? _extends2({}, props.style || {}, {}, style || {}) : style;
          }
          if (className) {
            props.className = props.className ? props.className + " " + className : className;
          }
          if (props.className === "") {
            delete props.className;
          }
          return props;
        }, {});
      }
      function handlePropGetter(prevProps, userProps, meta) {
        if (typeof userProps === "function") {
          return handlePropGetter({}, userProps(prevProps, meta));
        }
        if (Array.isArray(userProps)) {
          return mergeProps.apply(void 0, [prevProps].concat(userProps));
        }
        return mergeProps(prevProps, userProps);
      }
      var makePropGetter = function makePropGetter2(hooks, meta) {
        if (meta === void 0) {
          meta = {};
        }
        return function(userProps) {
          if (userProps === void 0) {
            userProps = {};
          }
          return [].concat(hooks, [userProps]).reduce(function(prev, next) {
            return handlePropGetter(prev, next, _extends2({}, meta, {
              userProps
            }));
          }, {});
        };
      };
      var reduceHooks = function reduceHooks2(hooks, initial, meta, allowUndefined) {
        if (meta === void 0) {
          meta = {};
        }
        return hooks.reduce(function(prev, next) {
          var nextValue = next(prev, meta);
          {
            if (!allowUndefined && typeof nextValue === "undefined") {
              console.info(next);
              throw new Error("React Table: A reducer hook ☝️ just returned undefined! This is not allowed.");
            }
          }
          return nextValue;
        }, initial);
      };
      var loopHooks = function loopHooks2(hooks, context, meta) {
        if (meta === void 0) {
          meta = {};
        }
        return hooks.forEach(function(hook) {
          var nextValue = hook(context, meta);
          {
            if (typeof nextValue !== "undefined") {
              console.info(hook, nextValue);
              throw new Error("React Table: A loop-type hook ☝️ just returned a value! This is not allowed.");
            }
          }
        });
      };
      function ensurePluginOrder(plugins, befores, pluginName3, afters) {
        if (afters) {
          throw new Error('Defining plugins in the "after" section of ensurePluginOrder is no longer supported (see plugin ' + pluginName3 + ")");
        }
        var pluginIndex = plugins.findIndex(function(plugin) {
          return plugin.pluginName === pluginName3;
        });
        if (pluginIndex === -1) {
          {
            throw new Error('The plugin "' + pluginName3 + `" was not found in the plugin list!
This usually means you need to need to name your plugin hook by setting the 'pluginName' property of the hook function, eg:

  ` + pluginName3 + ".pluginName = '" + pluginName3 + "'\n");
          }
        }
        befores.forEach(function(before) {
          var beforeIndex = plugins.findIndex(function(plugin) {
            return plugin.pluginName === before;
          });
          if (beforeIndex > -1 && beforeIndex > pluginIndex) {
            {
              throw new Error("React Table: The " + pluginName3 + " plugin hook must be placed after the " + before + " plugin hook!");
            }
          }
        });
      }
      function functionalUpdate2(updater, old) {
        return typeof updater === "function" ? updater(old) : updater;
      }
      function useGetLatest(obj) {
        var ref = React2.useRef();
        ref.current = obj;
        return React2.useCallback(function() {
          return ref.current;
        }, []);
      }
      var safeUseLayoutEffect = typeof document !== "undefined" ? React2.useLayoutEffect : React2.useEffect;
      function useMountedLayoutEffect(fn, deps) {
        var mountedRef = React2.useRef(false);
        safeUseLayoutEffect(function() {
          if (mountedRef.current) {
            fn();
          }
          mountedRef.current = true;
        }, deps);
      }
      function useAsyncDebounce(defaultFn, defaultWait) {
        if (defaultWait === void 0) {
          defaultWait = 0;
        }
        var debounceRef = React2.useRef({});
        var getDefaultFn = useGetLatest(defaultFn);
        var getDefaultWait = useGetLatest(defaultWait);
        return React2.useCallback(
          /* @__PURE__ */ function() {
            var _ref2 = _asyncToGenerator(
              /* @__PURE__ */ regeneratorRuntime.mark(function _callee2() {
                var _len2, args, _key2, _args2 = arguments;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        for (_len2 = _args2.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                          args[_key2] = _args2[_key2];
                        }
                        if (!debounceRef.current.promise) {
                          debounceRef.current.promise = new Promise(function(resolve, reject) {
                            debounceRef.current.resolve = resolve;
                            debounceRef.current.reject = reject;
                          });
                        }
                        if (debounceRef.current.timeout) {
                          clearTimeout(debounceRef.current.timeout);
                        }
                        debounceRef.current.timeout = setTimeout(
                          /* @__PURE__ */ _asyncToGenerator(
                            /* @__PURE__ */ regeneratorRuntime.mark(function _callee() {
                              return regeneratorRuntime.wrap(function _callee$(_context) {
                                while (1) {
                                  switch (_context.prev = _context.next) {
                                    case 0:
                                      delete debounceRef.current.timeout;
                                      _context.prev = 1;
                                      _context.t0 = debounceRef.current;
                                      _context.next = 5;
                                      return getDefaultFn().apply(void 0, args);
                                    case 5:
                                      _context.t1 = _context.sent;
                                      _context.t0.resolve.call(_context.t0, _context.t1);
                                      _context.next = 12;
                                      break;
                                    case 9:
                                      _context.prev = 9;
                                      _context.t2 = _context["catch"](1);
                                      debounceRef.current.reject(_context.t2);
                                    case 12:
                                      _context.prev = 12;
                                      delete debounceRef.current.promise;
                                      return _context.finish(12);
                                    case 15:
                                    case "end":
                                      return _context.stop();
                                  }
                                }
                              }, _callee, null, [[1, 9, 12, 15]]);
                            })
                          ),
                          getDefaultWait()
                        );
                        return _context2.abrupt("return", debounceRef.current.promise);
                      case 5:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2);
              })
            );
            return function() {
              return _ref2.apply(this, arguments);
            };
          }(),
          [getDefaultFn, getDefaultWait]
        );
      }
      function makeRenderer(instance, column, meta) {
        if (meta === void 0) {
          meta = {};
        }
        return function(type, userProps) {
          if (userProps === void 0) {
            userProps = {};
          }
          var Comp = typeof type === "string" ? column[type] : type;
          if (typeof Comp === "undefined") {
            console.info(column);
            throw new Error(renderErr);
          }
          return flexRender2(Comp, _extends2({}, instance, {
            column
          }, meta, {}, userProps));
        };
      }
      function flexRender2(Comp, props) {
        return isReactComponent2(Comp) ? React2.createElement(Comp, props) : Comp;
      }
      function isReactComponent2(component) {
        return isClassComponent2(component) || typeof component === "function" || isExoticComponent2(component);
      }
      function isClassComponent2(component) {
        return typeof component === "function" && function() {
          var proto = Object.getPrototypeOf(component);
          return proto.prototype && proto.prototype.isReactComponent;
        }();
      }
      function isExoticComponent2(component) {
        return typeof component === "object" && typeof component.$$typeof === "symbol" && ["react.memo", "react.forward_ref"].includes(component.$$typeof.description);
      }
      function linkColumnStructure(columns, parent, depth) {
        if (depth === void 0) {
          depth = 0;
        }
        return columns.map(function(column) {
          column = _extends2({}, column, {
            parent,
            depth
          });
          assignColumnAccessor(column);
          if (column.columns) {
            column.columns = linkColumnStructure(column.columns, column, depth + 1);
          }
          return column;
        });
      }
      function flattenColumns(columns) {
        return flattenBy2(columns, "columns");
      }
      function assignColumnAccessor(column) {
        var id2 = column.id, accessor = column.accessor, Header3 = column.Header;
        if (typeof accessor === "string") {
          id2 = id2 || accessor;
          var accessorPath = accessor.split(".");
          accessor = function accessor2(row) {
            return getBy(row, accessorPath);
          };
        }
        if (!id2 && typeof Header3 === "string" && Header3) {
          id2 = Header3;
        }
        if (!id2 && column.columns) {
          console.error(column);
          throw new Error('A column ID (or unique "Header" value) is required!');
        }
        if (!id2) {
          console.error(column);
          throw new Error("A column ID (or string accessor) is required!");
        }
        Object.assign(column, {
          id: id2,
          accessor
        });
        return column;
      }
      function decorateColumn(column, userDefaultColumn) {
        if (!userDefaultColumn) {
          throw new Error();
        }
        Object.assign(column, _extends2({
          // Make sure there is a fallback header, just in case
          Header: emptyRenderer,
          Footer: emptyRenderer
        }, defaultColumn, {}, userDefaultColumn, {}, column));
        Object.assign(column, {
          originalWidth: column.width
        });
        return column;
      }
      function makeHeaderGroups(allColumns2, defaultColumn2, additionalHeaderProperties) {
        if (additionalHeaderProperties === void 0) {
          additionalHeaderProperties = function additionalHeaderProperties2() {
            return {};
          };
        }
        var headerGroups = [];
        var scanColumns = allColumns2;
        var uid = 0;
        var getUID = function getUID2() {
          return uid++;
        };
        var _loop = function _loop2() {
          var headerGroup = {
            headers: []
          };
          var parentColumns = [];
          var hasParents = scanColumns.some(function(d4) {
            return d4.parent;
          });
          scanColumns.forEach(function(column) {
            var latestParentColumn = [].concat(parentColumns).reverse()[0];
            var newParent;
            if (hasParents) {
              if (column.parent) {
                newParent = _extends2({}, column.parent, {
                  originalId: column.parent.id,
                  id: column.parent.id + "_" + getUID(),
                  headers: [column]
                }, additionalHeaderProperties(column));
              } else {
                var originalId = column.id + "_placeholder";
                newParent = decorateColumn(_extends2({
                  originalId,
                  id: column.id + "_placeholder_" + getUID(),
                  placeholderOf: column,
                  headers: [column]
                }, additionalHeaderProperties(column)), defaultColumn2);
              }
              if (latestParentColumn && latestParentColumn.originalId === newParent.originalId) {
                latestParentColumn.headers.push(column);
              } else {
                parentColumns.push(newParent);
              }
            }
            headerGroup.headers.push(column);
          });
          headerGroups.push(headerGroup);
          scanColumns = parentColumns;
        };
        while (scanColumns.length) {
          _loop();
        }
        return headerGroups.reverse();
      }
      var pathObjCache = /* @__PURE__ */ new Map();
      function getBy(obj, path, def) {
        if (!path) {
          return obj;
        }
        var cacheKey = typeof path === "function" ? path : JSON.stringify(path);
        var pathObj = pathObjCache.get(cacheKey) || function() {
          var pathObj2 = makePathArray(path);
          pathObjCache.set(cacheKey, pathObj2);
          return pathObj2;
        }();
        var val;
        try {
          val = pathObj.reduce(function(cursor, pathPart) {
            return cursor[pathPart];
          }, obj);
        } catch (e3) {
        }
        return typeof val !== "undefined" ? val : def;
      }
      function getFirstDefined() {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        for (var i3 = 0; i3 < args.length; i3 += 1) {
          if (typeof args[i3] !== "undefined") {
            return args[i3];
          }
        }
      }
      function isFunction2(a4) {
        if (typeof a4 === "function") {
          return a4;
        }
      }
      function flattenBy2(arr, key) {
        var flat = [];
        var recurse = function recurse2(arr2) {
          arr2.forEach(function(d4) {
            if (!d4[key]) {
              flat.push(d4);
            } else {
              recurse2(d4[key]);
            }
          });
        };
        recurse(arr);
        return flat;
      }
      function expandRows2(rows, _ref) {
        var manualExpandedKey = _ref.manualExpandedKey, expanded = _ref.expanded, _ref$expandSubRows = _ref.expandSubRows, expandSubRows = _ref$expandSubRows === void 0 ? true : _ref$expandSubRows;
        var expandedRows = [];
        var handleRow = function handleRow2(row, addToExpandedRows) {
          if (addToExpandedRows === void 0) {
            addToExpandedRows = true;
          }
          row.isExpanded = row.original && row.original[manualExpandedKey] || expanded[row.id];
          row.canExpand = row.subRows && !!row.subRows.length;
          if (addToExpandedRows) {
            expandedRows.push(row);
          }
          if (row.subRows && row.subRows.length && row.isExpanded) {
            row.subRows.forEach(function(row2) {
              return handleRow2(row2, expandSubRows);
            });
          }
        };
        rows.forEach(function(row) {
          return handleRow(row);
        });
        return expandedRows;
      }
      function getFilterMethod(filter2, userFilterTypes, filterTypes2) {
        return isFunction2(filter2) || userFilterTypes[filter2] || filterTypes2[filter2] || filterTypes2.text;
      }
      function shouldAutoRemoveFilter2(autoRemove, value, column) {
        return autoRemove ? autoRemove(value, column) : typeof value === "undefined";
      }
      function unpreparedAccessWarning() {
        throw new Error("React-Table: You have not called prepareRow(row) one or more rows you are attempting to render.");
      }
      var passiveSupported2 = null;
      function passiveEventSupported2() {
        if (typeof passiveSupported2 === "boolean") return passiveSupported2;
        var supported = false;
        try {
          var options = {
            get passive() {
              supported = true;
              return false;
            }
          };
          window.addEventListener("test", null, options);
          window.removeEventListener("test", null, options);
        } catch (err) {
          supported = false;
        }
        passiveSupported2 = supported;
        return passiveSupported2;
      }
      var reOpenBracket = /\[/g;
      var reCloseBracket = /\]/g;
      function makePathArray(obj) {
        return flattenDeep(obj).map(function(d4) {
          return String(d4).replace(".", "_");
        }).join(".").replace(reOpenBracket, ".").replace(reCloseBracket, "").split(".");
      }
      function flattenDeep(arr, newArr) {
        if (newArr === void 0) {
          newArr = [];
        }
        if (!Array.isArray(arr)) {
          newArr.push(arr);
        } else {
          for (var i3 = 0; i3 < arr.length; i3 += 1) {
            flattenDeep(arr[i3], newArr);
          }
        }
        return newArr;
      }
      var defaultGetTableProps = function defaultGetTableProps2(props) {
        return _extends2({
          role: "table"
        }, props);
      };
      var defaultGetTableBodyProps = function defaultGetTableBodyProps2(props) {
        return _extends2({
          role: "rowgroup"
        }, props);
      };
      var defaultGetHeaderProps = function defaultGetHeaderProps2(props, _ref) {
        var column = _ref.column;
        return _extends2({
          key: "header_" + column.id,
          colSpan: column.totalVisibleHeaderCount,
          role: "columnheader"
        }, props);
      };
      var defaultGetFooterProps = function defaultGetFooterProps2(props, _ref2) {
        var column = _ref2.column;
        return _extends2({
          key: "footer_" + column.id,
          colSpan: column.totalVisibleHeaderCount
        }, props);
      };
      var defaultGetHeaderGroupProps = function defaultGetHeaderGroupProps2(props, _ref3) {
        var index2 = _ref3.index;
        return _extends2({
          key: "headerGroup_" + index2,
          role: "row"
        }, props);
      };
      var defaultGetFooterGroupProps = function defaultGetFooterGroupProps2(props, _ref4) {
        var index2 = _ref4.index;
        return _extends2({
          key: "footerGroup_" + index2
        }, props);
      };
      var defaultGetRowProps = function defaultGetRowProps2(props, _ref5) {
        var row = _ref5.row;
        return _extends2({
          key: "row_" + row.id,
          role: "row"
        }, props);
      };
      var defaultGetCellProps = function defaultGetCellProps2(props, _ref6) {
        var cell = _ref6.cell;
        return _extends2({
          key: "cell_" + cell.row.id + "_" + cell.column.id,
          role: "cell"
        }, props);
      };
      function makeDefaultPluginHooks() {
        return {
          useOptions: [],
          stateReducers: [],
          useControlledState: [],
          columns: [],
          columnsDeps: [],
          allColumns: [],
          allColumnsDeps: [],
          accessValue: [],
          materializedColumns: [],
          materializedColumnsDeps: [],
          useInstanceAfterData: [],
          visibleColumns: [],
          visibleColumnsDeps: [],
          headerGroups: [],
          headerGroupsDeps: [],
          useInstanceBeforeDimensions: [],
          useInstance: [],
          prepareRow: [],
          getTableProps: [defaultGetTableProps],
          getTableBodyProps: [defaultGetTableBodyProps],
          getHeaderGroupProps: [defaultGetHeaderGroupProps],
          getFooterGroupProps: [defaultGetFooterGroupProps],
          getHeaderProps: [defaultGetHeaderProps],
          getFooterProps: [defaultGetFooterProps],
          getRowProps: [defaultGetRowProps],
          getCellProps: [defaultGetCellProps],
          useFinalInstance: []
        };
      }
      actions.resetHiddenColumns = "resetHiddenColumns";
      actions.toggleHideColumn = "toggleHideColumn";
      actions.setHiddenColumns = "setHiddenColumns";
      actions.toggleHideAllColumns = "toggleHideAllColumns";
      var useColumnVisibility = function useColumnVisibility2(hooks) {
        hooks.getToggleHiddenProps = [defaultGetToggleHiddenProps];
        hooks.getToggleHideAllColumnsProps = [defaultGetToggleHideAllColumnsProps];
        hooks.stateReducers.push(reducer2);
        hooks.useInstanceBeforeDimensions.push(useInstanceBeforeDimensions);
        hooks.headerGroupsDeps.push(function(deps, _ref) {
          var instance = _ref.instance;
          return [].concat(deps, [instance.state.hiddenColumns]);
        });
        hooks.useInstance.push(useInstance2);
      };
      useColumnVisibility.pluginName = "useColumnVisibility";
      var defaultGetToggleHiddenProps = function defaultGetToggleHiddenProps2(props, _ref2) {
        var column = _ref2.column;
        return [props, {
          onChange: function onChange(e3) {
            column.toggleHidden(!e3.target.checked);
          },
          style: {
            cursor: "pointer"
          },
          checked: column.isVisible,
          title: "Toggle Column Visible"
        }];
      };
      var defaultGetToggleHideAllColumnsProps = function defaultGetToggleHideAllColumnsProps2(props, _ref3) {
        var instance = _ref3.instance;
        return [props, {
          onChange: function onChange(e3) {
            instance.toggleHideAllColumns(!e3.target.checked);
          },
          style: {
            cursor: "pointer"
          },
          checked: !instance.allColumnsHidden && !instance.state.hiddenColumns.length,
          title: "Toggle All Columns Hidden",
          indeterminate: !instance.allColumnsHidden && instance.state.hiddenColumns.length
        }];
      };
      function reducer2(state, action, previousState, instance) {
        if (action.type === actions.init) {
          return _extends2({
            hiddenColumns: []
          }, state);
        }
        if (action.type === actions.resetHiddenColumns) {
          return _extends2({}, state, {
            hiddenColumns: instance.initialState.hiddenColumns || []
          });
        }
        if (action.type === actions.toggleHideColumn) {
          var should = typeof action.value !== "undefined" ? action.value : !state.hiddenColumns.includes(action.columnId);
          var hiddenColumns = should ? [].concat(state.hiddenColumns, [action.columnId]) : state.hiddenColumns.filter(function(d4) {
            return d4 !== action.columnId;
          });
          return _extends2({}, state, {
            hiddenColumns
          });
        }
        if (action.type === actions.setHiddenColumns) {
          return _extends2({}, state, {
            hiddenColumns: functionalUpdate2(action.value, state.hiddenColumns)
          });
        }
        if (action.type === actions.toggleHideAllColumns) {
          var shouldAll = typeof action.value !== "undefined" ? action.value : !state.hiddenColumns.length;
          return _extends2({}, state, {
            hiddenColumns: shouldAll ? instance.allColumns.map(function(d4) {
              return d4.id;
            }) : []
          });
        }
      }
      function useInstanceBeforeDimensions(instance) {
        var headers = instance.headers, hiddenColumns = instance.state.hiddenColumns;
        var isMountedRef = React2.useRef(false);
        if (!isMountedRef.current) ;
        var handleColumn = function handleColumn2(column, parentVisible) {
          column.isVisible = parentVisible && !hiddenColumns.includes(column.id);
          var totalVisibleHeaderCount2 = 0;
          if (column.headers && column.headers.length) {
            column.headers.forEach(function(subColumn) {
              return totalVisibleHeaderCount2 += handleColumn2(subColumn, column.isVisible);
            });
          } else {
            totalVisibleHeaderCount2 = column.isVisible ? 1 : 0;
          }
          column.totalVisibleHeaderCount = totalVisibleHeaderCount2;
          return totalVisibleHeaderCount2;
        };
        var totalVisibleHeaderCount = 0;
        headers.forEach(function(subHeader) {
          return totalVisibleHeaderCount += handleColumn(subHeader, true);
        });
      }
      function useInstance2(instance) {
        var columns = instance.columns, flatHeaders = instance.flatHeaders, dispatch = instance.dispatch, allColumns2 = instance.allColumns, getHooks = instance.getHooks, hiddenColumns = instance.state.hiddenColumns, _instance$autoResetHi = instance.autoResetHiddenColumns, autoResetHiddenColumns = _instance$autoResetHi === void 0 ? true : _instance$autoResetHi;
        var getInstance = useGetLatest(instance);
        var allColumnsHidden = allColumns2.length === hiddenColumns.length;
        var toggleHideColumn = React2.useCallback(function(columnId, value) {
          return dispatch({
            type: actions.toggleHideColumn,
            columnId,
            value
          });
        }, [dispatch]);
        var setHiddenColumns = React2.useCallback(function(value) {
          return dispatch({
            type: actions.setHiddenColumns,
            value
          });
        }, [dispatch]);
        var toggleHideAllColumns = React2.useCallback(function(value) {
          return dispatch({
            type: actions.toggleHideAllColumns,
            value
          });
        }, [dispatch]);
        var getToggleHideAllColumnsProps = makePropGetter(getHooks().getToggleHideAllColumnsProps, {
          instance: getInstance()
        });
        flatHeaders.forEach(function(column) {
          column.toggleHidden = function(value) {
            dispatch({
              type: actions.toggleHideColumn,
              columnId: column.id,
              value
            });
          };
          column.getToggleHiddenProps = makePropGetter(getHooks().getToggleHiddenProps, {
            instance: getInstance(),
            column
          });
        });
        var getAutoResetHiddenColumns = useGetLatest(autoResetHiddenColumns);
        useMountedLayoutEffect(function() {
          if (getAutoResetHiddenColumns()) {
            dispatch({
              type: actions.resetHiddenColumns
            });
          }
        }, [dispatch, columns]);
        Object.assign(instance, {
          allColumnsHidden,
          toggleHideColumn,
          setHiddenColumns,
          toggleHideAllColumns,
          getToggleHideAllColumnsProps
        });
      }
      var defaultInitialState = {};
      var defaultColumnInstance = {};
      var defaultReducer = function defaultReducer2(state, action, prevState) {
        return state;
      };
      var defaultGetSubRows = function defaultGetSubRows2(row, index2) {
        return row.subRows || [];
      };
      var defaultGetRowId = function defaultGetRowId2(row, index2, parent) {
        return "" + (parent ? [parent.id, index2].join(".") : index2);
      };
      var defaultUseControlledState = function defaultUseControlledState2(d4) {
        return d4;
      };
      function applyDefaults(props) {
        var _props$initialState = props.initialState, initialState = _props$initialState === void 0 ? defaultInitialState : _props$initialState, _props$defaultColumn = props.defaultColumn, defaultColumn2 = _props$defaultColumn === void 0 ? defaultColumnInstance : _props$defaultColumn, _props$getSubRows = props.getSubRows, getSubRows = _props$getSubRows === void 0 ? defaultGetSubRows : _props$getSubRows, _props$getRowId = props.getRowId, getRowId = _props$getRowId === void 0 ? defaultGetRowId : _props$getRowId, _props$stateReducer = props.stateReducer, stateReducer = _props$stateReducer === void 0 ? defaultReducer : _props$stateReducer, _props$useControlledS = props.useControlledState, useControlledState = _props$useControlledS === void 0 ? defaultUseControlledState : _props$useControlledS, rest = _objectWithoutPropertiesLoose2(props, ["initialState", "defaultColumn", "getSubRows", "getRowId", "stateReducer", "useControlledState"]);
        return _extends2({}, rest, {
          initialState,
          defaultColumn: defaultColumn2,
          getSubRows,
          getRowId,
          stateReducer,
          useControlledState
        });
      }
      var useTable2 = function useTable4(props) {
        for (var _len = arguments.length, plugins = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          plugins[_key - 1] = arguments[_key];
        }
        props = applyDefaults(props);
        plugins = [useColumnVisibility].concat(plugins);
        var instanceRef = React2.useRef({});
        var getInstance = useGetLatest(instanceRef.current);
        Object.assign(getInstance(), _extends2({}, props, {
          plugins,
          hooks: makeDefaultPluginHooks()
        }));
        plugins.filter(Boolean).forEach(function(plugin) {
          plugin(getInstance().hooks);
        });
        var getHooks = useGetLatest(getInstance().hooks);
        getInstance().getHooks = getHooks;
        delete getInstance().hooks;
        Object.assign(getInstance(), reduceHooks(getHooks().useOptions, applyDefaults(props)));
        var _getInstance = getInstance(), data = _getInstance.data, userColumns = _getInstance.columns, initialState = _getInstance.initialState, defaultColumn2 = _getInstance.defaultColumn, getSubRows = _getInstance.getSubRows, getRowId = _getInstance.getRowId, stateReducer = _getInstance.stateReducer, useControlledState = _getInstance.useControlledState;
        var getStateReducer = useGetLatest(stateReducer);
        var reducer3 = React2.useCallback(function(state2, action) {
          if (!action.type) {
            console.info({
              action
            });
            throw new Error("Unknown Action 👆");
          }
          return [].concat(getHooks().stateReducers, Array.isArray(getStateReducer()) ? getStateReducer() : [getStateReducer()]).reduce(function(s4, handler) {
            return handler(s4, action, state2, getInstance()) || s4;
          }, state2);
        }, [getHooks, getStateReducer, getInstance]);
        var _React$useReducer = React2.useReducer(reducer3, void 0, function() {
          return reducer3(initialState, {
            type: actions.init
          });
        }), reducerState = _React$useReducer[0], dispatch = _React$useReducer[1];
        var state = reduceHooks([].concat(getHooks().useControlledState, [useControlledState]), reducerState, {
          instance: getInstance()
        });
        Object.assign(getInstance(), {
          state,
          dispatch
        });
        var columns = React2.useMemo(function() {
          return linkColumnStructure(reduceHooks(getHooks().columns, userColumns, {
            instance: getInstance()
          }));
        }, [getHooks, getInstance, userColumns].concat(reduceHooks(getHooks().columnsDeps, [], {
          instance: getInstance()
        })));
        getInstance().columns = columns;
        var allColumns2 = React2.useMemo(function() {
          return reduceHooks(getHooks().allColumns, flattenColumns(columns), {
            instance: getInstance()
          }).map(assignColumnAccessor);
        }, [columns, getHooks, getInstance].concat(reduceHooks(getHooks().allColumnsDeps, [], {
          instance: getInstance()
        })));
        getInstance().allColumns = allColumns2;
        var _React$useMemo = React2.useMemo(function() {
          var rows2 = [];
          var flatRows2 = [];
          var rowsById2 = {};
          var allColumnsQueue = [].concat(allColumns2);
          while (allColumnsQueue.length) {
            var column = allColumnsQueue.shift();
            accessRowsForColumn({
              data,
              rows: rows2,
              flatRows: flatRows2,
              rowsById: rowsById2,
              column,
              getRowId,
              getSubRows,
              accessValueHooks: getHooks().accessValue,
              getInstance
            });
          }
          return [rows2, flatRows2, rowsById2];
        }, [allColumns2, data, getRowId, getSubRows, getHooks, getInstance]), rows = _React$useMemo[0], flatRows = _React$useMemo[1], rowsById = _React$useMemo[2];
        Object.assign(getInstance(), {
          rows,
          initialRows: [].concat(rows),
          flatRows,
          rowsById
          // materializedColumns,
        });
        loopHooks(getHooks().useInstanceAfterData, getInstance());
        var visibleColumns3 = React2.useMemo(function() {
          return reduceHooks(getHooks().visibleColumns, allColumns2, {
            instance: getInstance()
          }).map(function(d4) {
            return decorateColumn(d4, defaultColumn2);
          });
        }, [getHooks, allColumns2, getInstance, defaultColumn2].concat(reduceHooks(getHooks().visibleColumnsDeps, [], {
          instance: getInstance()
        })));
        allColumns2 = React2.useMemo(function() {
          var columns2 = [].concat(visibleColumns3);
          allColumns2.forEach(function(column) {
            if (!columns2.find(function(d4) {
              return d4.id === column.id;
            })) {
              columns2.push(column);
            }
          });
          return columns2;
        }, [allColumns2, visibleColumns3]);
        getInstance().allColumns = allColumns2;
        {
          var duplicateColumns = allColumns2.filter(function(column, i3) {
            return allColumns2.findIndex(function(d4) {
              return d4.id === column.id;
            }) !== i3;
          });
          if (duplicateColumns.length) {
            console.info(allColumns2);
            throw new Error('Duplicate columns were found with ids: "' + duplicateColumns.map(function(d4) {
              return d4.id;
            }).join(", ") + '" in the columns array above');
          }
        }
        var headerGroups = React2.useMemo(function() {
          return reduceHooks(getHooks().headerGroups, makeHeaderGroups(visibleColumns3, defaultColumn2), getInstance());
        }, [getHooks, visibleColumns3, defaultColumn2, getInstance].concat(reduceHooks(getHooks().headerGroupsDeps, [], {
          instance: getInstance()
        })));
        getInstance().headerGroups = headerGroups;
        var headers = React2.useMemo(function() {
          return headerGroups.length ? headerGroups[0].headers : [];
        }, [headerGroups]);
        getInstance().headers = headers;
        getInstance().flatHeaders = headerGroups.reduce(function(all, headerGroup) {
          return [].concat(all, headerGroup.headers);
        }, []);
        loopHooks(getHooks().useInstanceBeforeDimensions, getInstance());
        var visibleColumnsDep = visibleColumns3.filter(function(d4) {
          return d4.isVisible;
        }).map(function(d4) {
          return d4.id;
        }).sort().join("_");
        visibleColumns3 = React2.useMemo(
          function() {
            return visibleColumns3.filter(function(d4) {
              return d4.isVisible;
            });
          },
          // eslint-disable-next-line react-hooks/exhaustive-deps
          [visibleColumns3, visibleColumnsDep]
        );
        getInstance().visibleColumns = visibleColumns3;
        var _calculateHeaderWidth = calculateHeaderWidths(headers), totalColumnsMinWidth = _calculateHeaderWidth[0], totalColumnsWidth = _calculateHeaderWidth[1], totalColumnsMaxWidth = _calculateHeaderWidth[2];
        getInstance().totalColumnsMinWidth = totalColumnsMinWidth;
        getInstance().totalColumnsWidth = totalColumnsWidth;
        getInstance().totalColumnsMaxWidth = totalColumnsMaxWidth;
        loopHooks(getHooks().useInstance, getInstance());
        [].concat(getInstance().flatHeaders, getInstance().allColumns).forEach(function(column) {
          column.render = makeRenderer(getInstance(), column);
          column.getHeaderProps = makePropGetter(getHooks().getHeaderProps, {
            instance: getInstance(),
            column
          });
          column.getFooterProps = makePropGetter(getHooks().getFooterProps, {
            instance: getInstance(),
            column
          });
        });
        getInstance().headerGroups = React2.useMemo(function() {
          return headerGroups.filter(function(headerGroup, i3) {
            headerGroup.headers = headerGroup.headers.filter(function(column) {
              var recurse = function recurse2(headers2) {
                return headers2.filter(function(column2) {
                  if (column2.headers) {
                    return recurse2(column2.headers);
                  }
                  return column2.isVisible;
                }).length;
              };
              if (column.headers) {
                return recurse(column.headers);
              }
              return column.isVisible;
            });
            if (headerGroup.headers.length) {
              headerGroup.getHeaderGroupProps = makePropGetter(getHooks().getHeaderGroupProps, {
                instance: getInstance(),
                headerGroup,
                index: i3
              });
              headerGroup.getFooterGroupProps = makePropGetter(getHooks().getFooterGroupProps, {
                instance: getInstance(),
                headerGroup,
                index: i3
              });
              return true;
            }
            return false;
          });
        }, [headerGroups, getInstance, getHooks]);
        getInstance().footerGroups = [].concat(getInstance().headerGroups).reverse();
        getInstance().prepareRow = React2.useCallback(function(row) {
          row.getRowProps = makePropGetter(getHooks().getRowProps, {
            instance: getInstance(),
            row
          });
          row.allCells = allColumns2.map(function(column) {
            var value = row.values[column.id];
            var cell = {
              column,
              row,
              value
            };
            cell.getCellProps = makePropGetter(getHooks().getCellProps, {
              instance: getInstance(),
              cell
            });
            cell.render = makeRenderer(getInstance(), column, {
              row,
              cell,
              value
            });
            return cell;
          });
          row.cells = visibleColumns3.map(function(column) {
            return row.allCells.find(function(cell) {
              return cell.column.id === column.id;
            });
          });
          loopHooks(getHooks().prepareRow, row, {
            instance: getInstance()
          });
        }, [getHooks, getInstance, allColumns2, visibleColumns3]);
        getInstance().getTableProps = makePropGetter(getHooks().getTableProps, {
          instance: getInstance()
        });
        getInstance().getTableBodyProps = makePropGetter(getHooks().getTableBodyProps, {
          instance: getInstance()
        });
        loopHooks(getHooks().useFinalInstance, getInstance());
        return getInstance();
      };
      function calculateHeaderWidths(headers, left) {
        if (left === void 0) {
          left = 0;
        }
        var sumTotalMinWidth = 0;
        var sumTotalWidth = 0;
        var sumTotalMaxWidth = 0;
        var sumTotalFlexWidth = 0;
        headers.forEach(function(header) {
          var subHeaders = header.headers;
          header.totalLeft = left;
          if (subHeaders && subHeaders.length) {
            var _calculateHeaderWidth2 = calculateHeaderWidths(subHeaders, left), totalMinWidth = _calculateHeaderWidth2[0], totalWidth = _calculateHeaderWidth2[1], totalMaxWidth = _calculateHeaderWidth2[2], totalFlexWidth = _calculateHeaderWidth2[3];
            header.totalMinWidth = totalMinWidth;
            header.totalWidth = totalWidth;
            header.totalMaxWidth = totalMaxWidth;
            header.totalFlexWidth = totalFlexWidth;
          } else {
            header.totalMinWidth = header.minWidth;
            header.totalWidth = Math.min(Math.max(header.minWidth, header.width), header.maxWidth);
            header.totalMaxWidth = header.maxWidth;
            header.totalFlexWidth = header.canResize ? header.totalWidth : 0;
          }
          if (header.isVisible) {
            left += header.totalWidth;
            sumTotalMinWidth += header.totalMinWidth;
            sumTotalWidth += header.totalWidth;
            sumTotalMaxWidth += header.totalMaxWidth;
            sumTotalFlexWidth += header.totalFlexWidth;
          }
        });
        return [sumTotalMinWidth, sumTotalWidth, sumTotalMaxWidth, sumTotalFlexWidth];
      }
      function accessRowsForColumn(_ref) {
        var data = _ref.data, rows = _ref.rows, flatRows = _ref.flatRows, rowsById = _ref.rowsById, column = _ref.column, getRowId = _ref.getRowId, getSubRows = _ref.getSubRows, accessValueHooks = _ref.accessValueHooks, getInstance = _ref.getInstance;
        var accessRow = function accessRow2(originalRow, rowIndex, depth, parent, parentRows) {
          if (depth === void 0) {
            depth = 0;
          }
          var original = originalRow;
          var id2 = getRowId(originalRow, rowIndex, parent);
          var row = rowsById[id2];
          if (!row) {
            row = {
              id: id2,
              original,
              index: rowIndex,
              depth,
              cells: [{}]
              // This is a dummy cell
            };
            row.cells.map = unpreparedAccessWarning;
            row.cells.filter = unpreparedAccessWarning;
            row.cells.forEach = unpreparedAccessWarning;
            row.cells[0].getCellProps = unpreparedAccessWarning;
            row.values = {};
            parentRows.push(row);
            flatRows.push(row);
            rowsById[id2] = row;
            row.originalSubRows = getSubRows(originalRow, rowIndex);
            if (row.originalSubRows) {
              var subRows = [];
              row.originalSubRows.forEach(function(d4, i3) {
                return accessRow2(d4, i3, depth + 1, row, subRows);
              });
              row.subRows = subRows;
            }
          } else if (row.subRows) {
            row.originalSubRows.forEach(function(d4, i3) {
              return accessRow2(d4, i3, depth + 1, row);
            });
          }
          if (column.accessor) {
            row.values[column.id] = column.accessor(originalRow, rowIndex, row, parentRows, data);
          }
          row.values[column.id] = reduceHooks(accessValueHooks, row.values[column.id], {
            row,
            column,
            instance: getInstance()
          }, true);
        };
        data.forEach(function(originalRow, rowIndex) {
          return accessRow(originalRow, rowIndex, 0, void 0, rows);
        });
      }
      actions.resetExpanded = "resetExpanded";
      actions.toggleRowExpanded = "toggleRowExpanded";
      actions.toggleAllRowsExpanded = "toggleAllRowsExpanded";
      var useExpanded = function useExpanded2(hooks) {
        hooks.getToggleAllRowsExpandedProps = [defaultGetToggleAllRowsExpandedProps];
        hooks.getToggleRowExpandedProps = [defaultGetToggleRowExpandedProps];
        hooks.stateReducers.push(reducer$12);
        hooks.useInstance.push(useInstance$1);
        hooks.prepareRow.push(prepareRow2);
      };
      useExpanded.pluginName = "useExpanded";
      var defaultGetToggleAllRowsExpandedProps = function defaultGetToggleAllRowsExpandedProps2(props, _ref) {
        var instance = _ref.instance;
        return [props, {
          onClick: function onClick(e3) {
            instance.toggleAllRowsExpanded();
          },
          style: {
            cursor: "pointer"
          },
          title: "Toggle All Rows Expanded"
        }];
      };
      var defaultGetToggleRowExpandedProps = function defaultGetToggleRowExpandedProps2(props, _ref2) {
        var row = _ref2.row;
        return [props, {
          onClick: function onClick() {
            row.toggleRowExpanded();
          },
          style: {
            cursor: "pointer"
          },
          title: "Toggle Row Expanded"
        }];
      };
      function reducer$12(state, action, previousState, instance) {
        if (action.type === actions.init) {
          return _extends2({
            expanded: {}
          }, state);
        }
        if (action.type === actions.resetExpanded) {
          return _extends2({}, state, {
            expanded: instance.initialState.expanded || {}
          });
        }
        if (action.type === actions.toggleAllRowsExpanded) {
          var value = action.value;
          var rowsById = instance.rowsById;
          var isAllRowsExpanded = Object.keys(rowsById).length === Object.keys(state.expanded).length;
          var expandAll = typeof value !== "undefined" ? value : !isAllRowsExpanded;
          if (expandAll) {
            var expanded = {};
            Object.keys(rowsById).forEach(function(rowId) {
              expanded[rowId] = true;
            });
            return _extends2({}, state, {
              expanded
            });
          }
          return _extends2({}, state, {
            expanded: {}
          });
        }
        if (action.type === actions.toggleRowExpanded) {
          var id2 = action.id, setExpanded = action.value;
          var exists = state.expanded[id2];
          var shouldExist = typeof setExpanded !== "undefined" ? setExpanded : !exists;
          if (!exists && shouldExist) {
            var _extends22;
            return _extends2({}, state, {
              expanded: _extends2({}, state.expanded, (_extends22 = {}, _extends22[id2] = true, _extends22))
            });
          } else if (exists && !shouldExist) {
            var _state$expanded = state.expanded;
            _state$expanded[id2];
            var rest = _objectWithoutPropertiesLoose2(_state$expanded, [id2].map(_toPropertyKey2));
            return _extends2({}, state, {
              expanded: rest
            });
          } else {
            return state;
          }
        }
      }
      function useInstance$1(instance) {
        var data = instance.data, rows = instance.rows, rowsById = instance.rowsById, _instance$manualExpan = instance.manualExpandedKey, manualExpandedKey = _instance$manualExpan === void 0 ? "expanded" : _instance$manualExpan, _instance$paginateExp = instance.paginateExpandedRows, paginateExpandedRows = _instance$paginateExp === void 0 ? true : _instance$paginateExp, _instance$expandSubRo = instance.expandSubRows, expandSubRows = _instance$expandSubRo === void 0 ? true : _instance$expandSubRo, _instance$autoResetEx = instance.autoResetExpanded, autoResetExpanded = _instance$autoResetEx === void 0 ? true : _instance$autoResetEx, getHooks = instance.getHooks, plugins = instance.plugins, expanded = instance.state.expanded, dispatch = instance.dispatch;
        ensurePluginOrder(plugins, ["useSortBy", "useGroupBy", "usePivotColumns", "useGlobalFilter"], "useExpanded");
        var getAutoResetExpanded = useGetLatest(autoResetExpanded);
        var isAllRowsExpanded = Boolean(Object.keys(rowsById).length && Object.keys(expanded).length);
        if (isAllRowsExpanded) {
          if (Object.keys(rowsById).some(function(id2) {
            return !expanded[id2];
          })) {
            isAllRowsExpanded = false;
          }
        }
        useMountedLayoutEffect(function() {
          if (getAutoResetExpanded()) {
            dispatch({
              type: actions.resetExpanded
            });
          }
        }, [dispatch, data]);
        var toggleRowExpanded = React2.useCallback(function(id2, value) {
          dispatch({
            type: actions.toggleRowExpanded,
            id: id2,
            value
          });
        }, [dispatch]);
        var toggleAllRowsExpanded = React2.useCallback(function(value) {
          return dispatch({
            type: actions.toggleAllRowsExpanded,
            value
          });
        }, [dispatch]);
        var expandedRows = React2.useMemo(function() {
          if (paginateExpandedRows) {
            return expandRows2(rows, {
              manualExpandedKey,
              expanded,
              expandSubRows
            });
          }
          return rows;
        }, [paginateExpandedRows, rows, manualExpandedKey, expanded, expandSubRows]);
        var expandedDepth = React2.useMemo(function() {
          return findExpandedDepth(expanded);
        }, [expanded]);
        var getInstance = useGetLatest(instance);
        var getToggleAllRowsExpandedProps = makePropGetter(getHooks().getToggleAllRowsExpandedProps, {
          instance: getInstance()
        });
        Object.assign(instance, {
          preExpandedRows: rows,
          expandedRows,
          rows: expandedRows,
          expandedDepth,
          isAllRowsExpanded,
          toggleRowExpanded,
          toggleAllRowsExpanded,
          getToggleAllRowsExpandedProps
        });
      }
      function prepareRow2(row, _ref3) {
        var getHooks = _ref3.instance.getHooks, instance = _ref3.instance;
        row.toggleRowExpanded = function(set2) {
          return instance.toggleRowExpanded(row.id, set2);
        };
        row.getToggleRowExpandedProps = makePropGetter(getHooks().getToggleRowExpandedProps, {
          instance,
          row
        });
      }
      function findExpandedDepth(expanded) {
        var maxDepth2 = 0;
        Object.keys(expanded).forEach(function(id2) {
          var splitId = id2.split(".");
          maxDepth2 = Math.max(maxDepth2, splitId.length);
        });
        return maxDepth2;
      }
      var text2 = function text3(rows, ids2, filterValue) {
        rows = rows.filter(function(row) {
          return ids2.some(function(id2) {
            var rowValue = row.values[id2];
            return String(rowValue).toLowerCase().includes(String(filterValue).toLowerCase());
          });
        });
        return rows;
      };
      text2.autoRemove = function(val) {
        return !val;
      };
      var exactText = function exactText2(rows, ids2, filterValue) {
        return rows.filter(function(row) {
          return ids2.some(function(id2) {
            var rowValue = row.values[id2];
            return rowValue !== void 0 ? String(rowValue).toLowerCase() === String(filterValue).toLowerCase() : true;
          });
        });
      };
      exactText.autoRemove = function(val) {
        return !val;
      };
      var exactTextCase = function exactTextCase2(rows, ids2, filterValue) {
        return rows.filter(function(row) {
          return ids2.some(function(id2) {
            var rowValue = row.values[id2];
            return rowValue !== void 0 ? String(rowValue) === String(filterValue) : true;
          });
        });
      };
      exactTextCase.autoRemove = function(val) {
        return !val;
      };
      var includes = function includes2(rows, ids2, filterValue) {
        return rows.filter(function(row) {
          return ids2.some(function(id2) {
            var rowValue = row.values[id2];
            return rowValue.includes(filterValue);
          });
        });
      };
      includes.autoRemove = function(val) {
        return !val || !val.length;
      };
      var includesAll = function includesAll2(rows, ids2, filterValue) {
        return rows.filter(function(row) {
          return ids2.some(function(id2) {
            var rowValue = row.values[id2];
            return rowValue && rowValue.length && filterValue.every(function(val) {
              return rowValue.includes(val);
            });
          });
        });
      };
      includesAll.autoRemove = function(val) {
        return !val || !val.length;
      };
      var includesSome = function includesSome2(rows, ids2, filterValue) {
        return rows.filter(function(row) {
          return ids2.some(function(id2) {
            var rowValue = row.values[id2];
            return rowValue && rowValue.length && filterValue.some(function(val) {
              return rowValue.includes(val);
            });
          });
        });
      };
      includesSome.autoRemove = function(val) {
        return !val || !val.length;
      };
      var includesValue = function includesValue2(rows, ids2, filterValue) {
        return rows.filter(function(row) {
          return ids2.some(function(id2) {
            var rowValue = row.values[id2];
            return filterValue.includes(rowValue);
          });
        });
      };
      includesValue.autoRemove = function(val) {
        return !val || !val.length;
      };
      var exact = function exact2(rows, ids2, filterValue) {
        return rows.filter(function(row) {
          return ids2.some(function(id2) {
            var rowValue = row.values[id2];
            return rowValue === filterValue;
          });
        });
      };
      exact.autoRemove = function(val) {
        return typeof val === "undefined";
      };
      var equals2 = function equals3(rows, ids2, filterValue) {
        return rows.filter(function(row) {
          return ids2.some(function(id2) {
            var rowValue = row.values[id2];
            return rowValue == filterValue;
          });
        });
      };
      equals2.autoRemove = function(val) {
        return val == null;
      };
      var between = function between2(rows, ids2, filterValue) {
        var _ref = filterValue || [], min3 = _ref[0], max3 = _ref[1];
        min3 = typeof min3 === "number" ? min3 : -Infinity;
        max3 = typeof max3 === "number" ? max3 : Infinity;
        if (min3 > max3) {
          var temp = min3;
          min3 = max3;
          max3 = temp;
        }
        return rows.filter(function(row) {
          return ids2.some(function(id2) {
            var rowValue = row.values[id2];
            return rowValue >= min3 && rowValue <= max3;
          });
        });
      };
      between.autoRemove = function(val) {
        return !val || typeof val[0] !== "number" && typeof val[1] !== "number";
      };
      var filterTypes = /* @__PURE__ */ Object.freeze({
        __proto__: null,
        text: text2,
        exactText,
        exactTextCase,
        includes,
        includesAll,
        includesSome,
        includesValue,
        exact,
        equals: equals2,
        between
      });
      actions.resetFilters = "resetFilters";
      actions.setFilter = "setFilter";
      actions.setAllFilters = "setAllFilters";
      var useFilters = function useFilters2(hooks) {
        hooks.stateReducers.push(reducer$22);
        hooks.useInstance.push(useInstance$2);
      };
      useFilters.pluginName = "useFilters";
      function reducer$22(state, action, previousState, instance) {
        if (action.type === actions.init) {
          return _extends2({
            filters: []
          }, state);
        }
        if (action.type === actions.resetFilters) {
          return _extends2({}, state, {
            filters: instance.initialState.filters || []
          });
        }
        if (action.type === actions.setFilter) {
          var columnId = action.columnId, filterValue = action.filterValue;
          var allColumns2 = instance.allColumns, userFilterTypes = instance.filterTypes;
          var column = allColumns2.find(function(d4) {
            return d4.id === columnId;
          });
          if (!column) {
            throw new Error("React-Table: Could not find a column with id: " + columnId);
          }
          var filterMethod = getFilterMethod(column.filter, userFilterTypes || {}, filterTypes);
          var previousfilter = state.filters.find(function(d4) {
            return d4.id === columnId;
          });
          var newFilter = functionalUpdate2(filterValue, previousfilter && previousfilter.value);
          if (shouldAutoRemoveFilter2(filterMethod.autoRemove, newFilter, column)) {
            return _extends2({}, state, {
              filters: state.filters.filter(function(d4) {
                return d4.id !== columnId;
              })
            });
          }
          if (previousfilter) {
            return _extends2({}, state, {
              filters: state.filters.map(function(d4) {
                if (d4.id === columnId) {
                  return {
                    id: columnId,
                    value: newFilter
                  };
                }
                return d4;
              })
            });
          }
          return _extends2({}, state, {
            filters: [].concat(state.filters, [{
              id: columnId,
              value: newFilter
            }])
          });
        }
        if (action.type === actions.setAllFilters) {
          var filters = action.filters;
          var _allColumns = instance.allColumns, _userFilterTypes = instance.filterTypes;
          return _extends2({}, state, {
            // Filter out undefined values
            filters: functionalUpdate2(filters, state.filters).filter(function(filter2) {
              var column2 = _allColumns.find(function(d4) {
                return d4.id === filter2.id;
              });
              var filterMethod2 = getFilterMethod(column2.filter, _userFilterTypes || {}, filterTypes);
              if (shouldAutoRemoveFilter2(filterMethod2.autoRemove, filter2.value, column2)) {
                return false;
              }
              return true;
            })
          });
        }
      }
      function useInstance$2(instance) {
        var data = instance.data, rows = instance.rows, flatRows = instance.flatRows, rowsById = instance.rowsById, allColumns2 = instance.allColumns, userFilterTypes = instance.filterTypes, manualFilters = instance.manualFilters, _instance$defaultCanF = instance.defaultCanFilter, defaultCanFilter = _instance$defaultCanF === void 0 ? false : _instance$defaultCanF, disableFilters = instance.disableFilters, filters = instance.state.filters, dispatch = instance.dispatch, _instance$autoResetFi = instance.autoResetFilters, autoResetFilters = _instance$autoResetFi === void 0 ? true : _instance$autoResetFi;
        var setFilter = React2.useCallback(function(columnId, filterValue) {
          dispatch({
            type: actions.setFilter,
            columnId,
            filterValue
          });
        }, [dispatch]);
        var setAllFilters = React2.useCallback(function(filters2) {
          dispatch({
            type: actions.setAllFilters,
            filters: filters2
          });
        }, [dispatch]);
        allColumns2.forEach(function(column) {
          var id2 = column.id, accessor = column.accessor, columnDefaultCanFilter = column.defaultCanFilter, columnDisableFilters = column.disableFilters;
          column.canFilter = accessor ? getFirstDefined(columnDisableFilters === true ? false : void 0, disableFilters === true ? false : void 0, true) : getFirstDefined(columnDefaultCanFilter, defaultCanFilter, false);
          column.setFilter = function(val) {
            return setFilter(column.id, val);
          };
          var found = filters.find(function(d4) {
            return d4.id === id2;
          });
          column.filterValue = found && found.value;
        });
        var _React$useMemo = React2.useMemo(function() {
          if (manualFilters || !filters.length) {
            return [rows, flatRows, rowsById];
          }
          var filteredFlatRows2 = [];
          var filteredRowsById2 = {};
          var filterRows2 = function filterRows3(rows2, depth) {
            if (depth === void 0) {
              depth = 0;
            }
            var filteredRows2 = rows2;
            filteredRows2 = filters.reduce(function(filteredSoFar, _ref) {
              var columnId = _ref.id, filterValue = _ref.value;
              var column = allColumns2.find(function(d4) {
                return d4.id === columnId;
              });
              if (!column) {
                return filteredSoFar;
              }
              if (depth === 0) {
                column.preFilteredRows = filteredSoFar;
              }
              var filterMethod = getFilterMethod(column.filter, userFilterTypes || {}, filterTypes);
              if (!filterMethod) {
                console.warn("Could not find a valid 'column.filter' for column with the ID: " + column.id + ".");
                return filteredSoFar;
              }
              column.filteredRows = filterMethod(filteredSoFar, [columnId], filterValue);
              return column.filteredRows;
            }, rows2);
            filteredRows2.forEach(function(row) {
              filteredFlatRows2.push(row);
              filteredRowsById2[row.id] = row;
              if (!row.subRows) {
                return;
              }
              row.subRows = row.subRows && row.subRows.length > 0 ? filterRows3(row.subRows, depth + 1) : row.subRows;
            });
            return filteredRows2;
          };
          return [filterRows2(rows), filteredFlatRows2, filteredRowsById2];
        }, [manualFilters, filters, rows, flatRows, rowsById, allColumns2, userFilterTypes]), filteredRows = _React$useMemo[0], filteredFlatRows = _React$useMemo[1], filteredRowsById = _React$useMemo[2];
        React2.useMemo(function() {
          var nonFilteredColumns = allColumns2.filter(function(column) {
            return !filters.find(function(d4) {
              return d4.id === column.id;
            });
          });
          nonFilteredColumns.forEach(function(column) {
            column.preFilteredRows = filteredRows;
            column.filteredRows = filteredRows;
          });
        }, [filteredRows, filters, allColumns2]);
        var getAutoResetFilters = useGetLatest(autoResetFilters);
        useMountedLayoutEffect(function() {
          if (getAutoResetFilters()) {
            dispatch({
              type: actions.resetFilters
            });
          }
        }, [dispatch, manualFilters ? null : data]);
        Object.assign(instance, {
          preFilteredRows: rows,
          preFilteredFlatRows: flatRows,
          preFilteredRowsById: rowsById,
          filteredRows,
          filteredFlatRows,
          filteredRowsById,
          rows: filteredRows,
          flatRows: filteredFlatRows,
          rowsById: filteredRowsById,
          setFilter,
          setAllFilters
        });
      }
      actions.resetGlobalFilter = "resetGlobalFilter";
      actions.setGlobalFilter = "setGlobalFilter";
      var useGlobalFilter = function useGlobalFilter2(hooks) {
        hooks.stateReducers.push(reducer$32);
        hooks.useInstance.push(useInstance$3);
      };
      useGlobalFilter.pluginName = "useGlobalFilter";
      function reducer$32(state, action, previousState, instance) {
        if (action.type === actions.resetGlobalFilter) {
          return _extends2({}, state, {
            globalFilter: instance.initialState.globalFilter || void 0
          });
        }
        if (action.type === actions.setGlobalFilter) {
          var filterValue = action.filterValue;
          var userFilterTypes = instance.userFilterTypes;
          var filterMethod = getFilterMethod(instance.globalFilter, userFilterTypes || {}, filterTypes);
          var newFilter = functionalUpdate2(filterValue, state.globalFilter);
          if (shouldAutoRemoveFilter2(filterMethod.autoRemove, newFilter)) {
            state.globalFilter;
            var stateWithoutGlobalFilter = _objectWithoutPropertiesLoose2(state, ["globalFilter"]);
            return stateWithoutGlobalFilter;
          }
          return _extends2({}, state, {
            globalFilter: newFilter
          });
        }
      }
      function useInstance$3(instance) {
        var data = instance.data, rows = instance.rows, flatRows = instance.flatRows, rowsById = instance.rowsById, allColumns2 = instance.allColumns, userFilterTypes = instance.filterTypes, globalFilter = instance.globalFilter, manualGlobalFilter = instance.manualGlobalFilter, globalFilterValue = instance.state.globalFilter, dispatch = instance.dispatch, _instance$autoResetGl = instance.autoResetGlobalFilter, autoResetGlobalFilter = _instance$autoResetGl === void 0 ? true : _instance$autoResetGl, disableGlobalFilter = instance.disableGlobalFilter;
        var setGlobalFilter = React2.useCallback(function(filterValue) {
          dispatch({
            type: actions.setGlobalFilter,
            filterValue
          });
        }, [dispatch]);
        var _React$useMemo = React2.useMemo(function() {
          if (manualGlobalFilter || typeof globalFilterValue === "undefined") {
            return [rows, flatRows, rowsById];
          }
          var filteredFlatRows = [];
          var filteredRowsById = {};
          var filterMethod = getFilterMethod(globalFilter, userFilterTypes || {}, filterTypes);
          if (!filterMethod) {
            console.warn("Could not find a valid 'globalFilter' option.");
            return rows;
          }
          allColumns2.forEach(function(column) {
            var columnDisableGlobalFilter = column.disableGlobalFilter;
            column.canFilter = getFirstDefined(columnDisableGlobalFilter === true ? false : void 0, disableGlobalFilter === true ? false : void 0, true);
          });
          var filterableColumns = allColumns2.filter(function(c3) {
            return c3.canFilter === true;
          });
          var filterRows2 = function filterRows3(filteredRows) {
            filteredRows = filterMethod(filteredRows, filterableColumns.map(function(d4) {
              return d4.id;
            }), globalFilterValue);
            filteredRows.forEach(function(row) {
              filteredFlatRows.push(row);
              filteredRowsById[row.id] = row;
              row.subRows = row.subRows && row.subRows.length ? filterRows3(row.subRows) : row.subRows;
            });
            return filteredRows;
          };
          return [filterRows2(rows), filteredFlatRows, filteredRowsById];
        }, [manualGlobalFilter, globalFilterValue, globalFilter, userFilterTypes, allColumns2, rows, flatRows, rowsById, disableGlobalFilter]), globalFilteredRows = _React$useMemo[0], globalFilteredFlatRows = _React$useMemo[1], globalFilteredRowsById = _React$useMemo[2];
        var getAutoResetGlobalFilter = useGetLatest(autoResetGlobalFilter);
        useMountedLayoutEffect(function() {
          if (getAutoResetGlobalFilter()) {
            dispatch({
              type: actions.resetGlobalFilter
            });
          }
        }, [dispatch, manualGlobalFilter ? null : data]);
        Object.assign(instance, {
          preGlobalFilteredRows: rows,
          preGlobalFilteredFlatRows: flatRows,
          preGlobalFilteredRowsById: rowsById,
          globalFilteredRows,
          globalFilteredFlatRows,
          globalFilteredRowsById,
          rows: globalFilteredRows,
          flatRows: globalFilteredFlatRows,
          rowsById: globalFilteredRowsById,
          setGlobalFilter,
          disableGlobalFilter
        });
      }
      function sum2(values, aggregatedValues) {
        return aggregatedValues.reduce(function(sum3, next) {
          return sum3 + (typeof next === "number" ? next : 0);
        }, 0);
      }
      function min2(values) {
        var min3 = values[0] || 0;
        values.forEach(function(value) {
          if (typeof value === "number") {
            min3 = Math.min(min3, value);
          }
        });
        return min3;
      }
      function max2(values) {
        var max3 = values[0] || 0;
        values.forEach(function(value) {
          if (typeof value === "number") {
            max3 = Math.max(max3, value);
          }
        });
        return max3;
      }
      function minMax(values) {
        var min3 = values[0] || 0;
        var max3 = values[0] || 0;
        values.forEach(function(value) {
          if (typeof value === "number") {
            min3 = Math.min(min3, value);
            max3 = Math.max(max3, value);
          }
        });
        return min3 + ".." + max3;
      }
      function average(values) {
        return sum2(null, values) / values.length;
      }
      function median2(values) {
        if (!values.length) {
          return null;
        }
        var mid = Math.floor(values.length / 2);
        var nums = [].concat(values).sort(function(a4, b3) {
          return a4 - b3;
        });
        return values.length % 2 !== 0 ? nums[mid] : (nums[mid - 1] + nums[mid]) / 2;
      }
      function unique2(values) {
        return Array.from(new Set(values).values());
      }
      function uniqueCount2(values) {
        return new Set(values).size;
      }
      function count2(values) {
        return values.length;
      }
      var aggregations = /* @__PURE__ */ Object.freeze({
        __proto__: null,
        sum: sum2,
        min: min2,
        max: max2,
        minMax,
        average,
        median: median2,
        unique: unique2,
        uniqueCount: uniqueCount2,
        count: count2
      });
      var emptyArray = [];
      var emptyObject = {};
      actions.resetGroupBy = "resetGroupBy";
      actions.setGroupBy = "setGroupBy";
      actions.toggleGroupBy = "toggleGroupBy";
      var useGroupBy = function useGroupBy2(hooks) {
        hooks.getGroupByToggleProps = [defaultGetGroupByToggleProps];
        hooks.stateReducers.push(reducer$4);
        hooks.visibleColumnsDeps.push(function(deps, _ref) {
          var instance = _ref.instance;
          return [].concat(deps, [instance.state.groupBy]);
        });
        hooks.visibleColumns.push(visibleColumns2);
        hooks.useInstance.push(useInstance$4);
        hooks.prepareRow.push(prepareRow$12);
      };
      useGroupBy.pluginName = "useGroupBy";
      var defaultGetGroupByToggleProps = function defaultGetGroupByToggleProps2(props, _ref2) {
        var header = _ref2.header;
        return [props, {
          onClick: header.canGroupBy ? function(e3) {
            e3.persist();
            header.toggleGroupBy();
          } : void 0,
          style: {
            cursor: header.canGroupBy ? "pointer" : void 0
          },
          title: "Toggle GroupBy"
        }];
      };
      function reducer$4(state, action, previousState, instance) {
        if (action.type === actions.init) {
          return _extends2({
            groupBy: []
          }, state);
        }
        if (action.type === actions.resetGroupBy) {
          return _extends2({}, state, {
            groupBy: instance.initialState.groupBy || []
          });
        }
        if (action.type === actions.setGroupBy) {
          var value = action.value;
          return _extends2({}, state, {
            groupBy: value
          });
        }
        if (action.type === actions.toggleGroupBy) {
          var columnId = action.columnId, setGroupBy = action.value;
          var resolvedGroupBy = typeof setGroupBy !== "undefined" ? setGroupBy : !state.groupBy.includes(columnId);
          if (resolvedGroupBy) {
            return _extends2({}, state, {
              groupBy: [].concat(state.groupBy, [columnId])
            });
          }
          return _extends2({}, state, {
            groupBy: state.groupBy.filter(function(d4) {
              return d4 !== columnId;
            })
          });
        }
      }
      function visibleColumns2(columns, _ref3) {
        var groupBy2 = _ref3.instance.state.groupBy;
        var groupByColumns = groupBy2.map(function(g2) {
          return columns.find(function(col) {
            return col.id === g2;
          });
        }).filter(Boolean);
        var nonGroupByColumns = columns.filter(function(col) {
          return !groupBy2.includes(col.id);
        });
        columns = [].concat(groupByColumns, nonGroupByColumns);
        columns.forEach(function(column) {
          column.isGrouped = groupBy2.includes(column.id);
          column.groupedIndex = groupBy2.indexOf(column.id);
        });
        return columns;
      }
      var defaultUserAggregations = {};
      function useInstance$4(instance) {
        var data = instance.data, rows = instance.rows, flatRows = instance.flatRows, rowsById = instance.rowsById, allColumns2 = instance.allColumns, flatHeaders = instance.flatHeaders, _instance$groupByFn = instance.groupByFn, groupByFn = _instance$groupByFn === void 0 ? defaultGroupByFn : _instance$groupByFn, manualGroupBy = instance.manualGroupBy, _instance$aggregation = instance.aggregations, userAggregations = _instance$aggregation === void 0 ? defaultUserAggregations : _instance$aggregation, plugins = instance.plugins, groupBy2 = instance.state.groupBy, dispatch = instance.dispatch, _instance$autoResetGr = instance.autoResetGroupBy, autoResetGroupBy = _instance$autoResetGr === void 0 ? true : _instance$autoResetGr, disableGroupBy = instance.disableGroupBy, defaultCanGroupBy = instance.defaultCanGroupBy, getHooks = instance.getHooks;
        ensurePluginOrder(plugins, ["useColumnOrder", "useFilters"], "useGroupBy");
        var getInstance = useGetLatest(instance);
        allColumns2.forEach(function(column) {
          var accessor = column.accessor, defaultColumnGroupBy = column.defaultGroupBy, columnDisableGroupBy = column.disableGroupBy;
          column.canGroupBy = accessor ? getFirstDefined(column.canGroupBy, columnDisableGroupBy === true ? false : void 0, disableGroupBy === true ? false : void 0, true) : getFirstDefined(column.canGroupBy, defaultColumnGroupBy, defaultCanGroupBy, false);
          if (column.canGroupBy) {
            column.toggleGroupBy = function() {
              return instance.toggleGroupBy(column.id);
            };
          }
          column.Aggregated = column.Aggregated || column.Cell;
        });
        var toggleGroupBy = React2.useCallback(function(columnId, value) {
          dispatch({
            type: actions.toggleGroupBy,
            columnId,
            value
          });
        }, [dispatch]);
        var setGroupBy = React2.useCallback(function(value) {
          dispatch({
            type: actions.setGroupBy,
            value
          });
        }, [dispatch]);
        flatHeaders.forEach(function(header) {
          header.getGroupByToggleProps = makePropGetter(getHooks().getGroupByToggleProps, {
            instance: getInstance(),
            header
          });
        });
        var _React$useMemo = React2.useMemo(function() {
          if (manualGroupBy || !groupBy2.length) {
            return [rows, flatRows, rowsById, emptyArray, emptyObject, flatRows, rowsById];
          }
          var existingGroupBy = groupBy2.filter(function(g2) {
            return allColumns2.find(function(col) {
              return col.id === g2;
            });
          });
          var aggregateRowsToValues = function aggregateRowsToValues2(leafRows, groupedRows3, depth) {
            var values = {};
            allColumns2.forEach(function(column) {
              if (existingGroupBy.includes(column.id)) {
                values[column.id] = groupedRows3[0] ? groupedRows3[0].values[column.id] : null;
                return;
              }
              var aggregateFn = typeof column.aggregate === "function" ? column.aggregate : userAggregations[column.aggregate] || aggregations[column.aggregate];
              if (aggregateFn) {
                var groupedValues = groupedRows3.map(function(row) {
                  return row.values[column.id];
                });
                var leafValues = leafRows.map(function(row) {
                  var columnValue = row.values[column.id];
                  if (!depth && column.aggregateValue) {
                    var aggregateValueFn = typeof column.aggregateValue === "function" ? column.aggregateValue : userAggregations[column.aggregateValue] || aggregations[column.aggregateValue];
                    if (!aggregateValueFn) {
                      console.info({
                        column
                      });
                      throw new Error("React Table: Invalid column.aggregateValue option for column listed above");
                    }
                    columnValue = aggregateValueFn(columnValue, row, column);
                  }
                  return columnValue;
                });
                values[column.id] = aggregateFn(leafValues, groupedValues);
              } else if (column.aggregate) {
                console.info({
                  column
                });
                throw new Error("React Table: Invalid column.aggregate option for column listed above");
              } else {
                values[column.id] = null;
              }
            });
            return values;
          };
          var groupedFlatRows2 = [];
          var groupedRowsById2 = {};
          var onlyGroupedFlatRows2 = [];
          var onlyGroupedRowsById2 = {};
          var nonGroupedFlatRows2 = [];
          var nonGroupedRowsById2 = {};
          var groupUpRecursively = function groupUpRecursively2(rows2, depth, parentId) {
            if (depth === void 0) {
              depth = 0;
            }
            if (depth === existingGroupBy.length) {
              return rows2.map(function(row) {
                return _extends2({}, row, {
                  depth
                });
              });
            }
            var columnId = existingGroupBy[depth];
            var rowGroupsMap = groupByFn(rows2, columnId);
            var aggregatedGroupedRows = Object.entries(rowGroupsMap).map(function(_ref4, index2) {
              var groupByVal = _ref4[0], groupedRows3 = _ref4[1];
              var id2 = columnId + ":" + groupByVal;
              id2 = parentId ? parentId + ">" + id2 : id2;
              var subRows = groupUpRecursively2(groupedRows3, depth + 1, id2);
              var leafRows = depth ? flattenBy2(groupedRows3, "leafRows") : groupedRows3;
              var values = aggregateRowsToValues(leafRows, groupedRows3, depth);
              var row = {
                id: id2,
                isGrouped: true,
                groupByID: columnId,
                groupByVal,
                values,
                subRows,
                leafRows,
                depth,
                index: index2
              };
              subRows.forEach(function(subRow) {
                groupedFlatRows2.push(subRow);
                groupedRowsById2[subRow.id] = subRow;
                if (subRow.isGrouped) {
                  onlyGroupedFlatRows2.push(subRow);
                  onlyGroupedRowsById2[subRow.id] = subRow;
                } else {
                  nonGroupedFlatRows2.push(subRow);
                  nonGroupedRowsById2[subRow.id] = subRow;
                }
              });
              return row;
            });
            return aggregatedGroupedRows;
          };
          var groupedRows2 = groupUpRecursively(rows);
          groupedRows2.forEach(function(subRow) {
            groupedFlatRows2.push(subRow);
            groupedRowsById2[subRow.id] = subRow;
            if (subRow.isGrouped) {
              onlyGroupedFlatRows2.push(subRow);
              onlyGroupedRowsById2[subRow.id] = subRow;
            } else {
              nonGroupedFlatRows2.push(subRow);
              nonGroupedRowsById2[subRow.id] = subRow;
            }
          });
          return [groupedRows2, groupedFlatRows2, groupedRowsById2, onlyGroupedFlatRows2, onlyGroupedRowsById2, nonGroupedFlatRows2, nonGroupedRowsById2];
        }, [manualGroupBy, groupBy2, rows, flatRows, rowsById, allColumns2, userAggregations, groupByFn]), groupedRows = _React$useMemo[0], groupedFlatRows = _React$useMemo[1], groupedRowsById = _React$useMemo[2], onlyGroupedFlatRows = _React$useMemo[3], onlyGroupedRowsById = _React$useMemo[4], nonGroupedFlatRows = _React$useMemo[5], nonGroupedRowsById = _React$useMemo[6];
        var getAutoResetGroupBy = useGetLatest(autoResetGroupBy);
        useMountedLayoutEffect(function() {
          if (getAutoResetGroupBy()) {
            dispatch({
              type: actions.resetGroupBy
            });
          }
        }, [dispatch, manualGroupBy ? null : data]);
        Object.assign(instance, {
          preGroupedRows: rows,
          preGroupedFlatRow: flatRows,
          preGroupedRowsById: rowsById,
          groupedRows,
          groupedFlatRows,
          groupedRowsById,
          onlyGroupedFlatRows,
          onlyGroupedRowsById,
          nonGroupedFlatRows,
          nonGroupedRowsById,
          rows: groupedRows,
          flatRows: groupedFlatRows,
          rowsById: groupedRowsById,
          toggleGroupBy,
          setGroupBy
        });
      }
      function prepareRow$12(row) {
        row.allCells.forEach(function(cell) {
          var _row$subRows;
          cell.isGrouped = cell.column.isGrouped && cell.column.id === row.groupByID;
          cell.isPlaceholder = !cell.isGrouped && cell.column.isGrouped;
          cell.isAggregated = !cell.isGrouped && !cell.isPlaceholder && ((_row$subRows = row.subRows) == null ? void 0 : _row$subRows.length);
        });
      }
      function defaultGroupByFn(rows, columnId) {
        return rows.reduce(function(prev, row, i3) {
          var resKey = "" + row.values[columnId];
          prev[resKey] = Array.isArray(prev[resKey]) ? prev[resKey] : [];
          prev[resKey].push(row);
          return prev;
        }, {});
      }
      var reSplitAlphaNumeric2 = /([0-9]+)/gm;
      var alphanumeric2 = function alphanumeric3(rowA, rowB, columnId) {
        var _getRowValuesByColumn = getRowValuesByColumnID(rowA, rowB, columnId), a4 = _getRowValuesByColumn[0], b3 = _getRowValuesByColumn[1];
        a4 = toString2(a4);
        b3 = toString2(b3);
        a4 = a4.split(reSplitAlphaNumeric2).filter(Boolean);
        b3 = b3.split(reSplitAlphaNumeric2).filter(Boolean);
        while (a4.length && b3.length) {
          var aa = a4.shift();
          var bb = b3.shift();
          var an = parseInt(aa, 10);
          var bn = parseInt(bb, 10);
          var combo = [an, bn].sort();
          if (isNaN(combo[0])) {
            if (aa > bb) {
              return 1;
            }
            if (bb > aa) {
              return -1;
            }
            continue;
          }
          if (isNaN(combo[1])) {
            return isNaN(an) ? -1 : 1;
          }
          if (an > bn) {
            return 1;
          }
          if (bn > an) {
            return -1;
          }
        }
        return a4.length - b3.length;
      };
      function datetime2(rowA, rowB, columnId) {
        var _getRowValuesByColumn2 = getRowValuesByColumnID(rowA, rowB, columnId), a4 = _getRowValuesByColumn2[0], b3 = _getRowValuesByColumn2[1];
        a4 = a4.getTime();
        b3 = b3.getTime();
        return compareBasic2(a4, b3);
      }
      function basic2(rowA, rowB, columnId) {
        var _getRowValuesByColumn3 = getRowValuesByColumnID(rowA, rowB, columnId), a4 = _getRowValuesByColumn3[0], b3 = _getRowValuesByColumn3[1];
        return compareBasic2(a4, b3);
      }
      function string2(rowA, rowB, columnId) {
        var _getRowValuesByColumn4 = getRowValuesByColumnID(rowA, rowB, columnId), a4 = _getRowValuesByColumn4[0], b3 = _getRowValuesByColumn4[1];
        a4 = a4.split("").filter(Boolean);
        b3 = b3.split("").filter(Boolean);
        while (a4.length && b3.length) {
          var aa = a4.shift();
          var bb = b3.shift();
          var alower = aa.toLowerCase();
          var blower = bb.toLowerCase();
          if (alower > blower) {
            return 1;
          }
          if (blower > alower) {
            return -1;
          }
          if (aa > bb) {
            return 1;
          }
          if (bb > aa) {
            return -1;
          }
          continue;
        }
        return a4.length - b3.length;
      }
      function number2(rowA, rowB, columnId) {
        var _getRowValuesByColumn5 = getRowValuesByColumnID(rowA, rowB, columnId), a4 = _getRowValuesByColumn5[0], b3 = _getRowValuesByColumn5[1];
        var replaceNonNumeric = /[^0-9.]/gi;
        a4 = Number(String(a4).replace(replaceNonNumeric, ""));
        b3 = Number(String(b3).replace(replaceNonNumeric, ""));
        return compareBasic2(a4, b3);
      }
      function compareBasic2(a4, b3) {
        return a4 === b3 ? 0 : a4 > b3 ? 1 : -1;
      }
      function getRowValuesByColumnID(row1, row2, columnId) {
        return [row1.values[columnId], row2.values[columnId]];
      }
      function toString2(a4) {
        if (typeof a4 === "number") {
          if (isNaN(a4) || a4 === Infinity || a4 === -Infinity) {
            return "";
          }
          return String(a4);
        }
        if (typeof a4 === "string") {
          return a4;
        }
        return "";
      }
      var sortTypes2 = /* @__PURE__ */ Object.freeze({
        __proto__: null,
        alphanumeric: alphanumeric2,
        datetime: datetime2,
        basic: basic2,
        string: string2,
        number: number2
      });
      actions.resetSortBy = "resetSortBy";
      actions.setSortBy = "setSortBy";
      actions.toggleSortBy = "toggleSortBy";
      actions.clearSortBy = "clearSortBy";
      defaultColumn.sortType = "alphanumeric";
      defaultColumn.sortDescFirst = false;
      var useSortBy = function useSortBy2(hooks) {
        hooks.getSortByToggleProps = [defaultGetSortByToggleProps];
        hooks.stateReducers.push(reducer$5);
        hooks.useInstance.push(useInstance$5);
      };
      useSortBy.pluginName = "useSortBy";
      var defaultGetSortByToggleProps = function defaultGetSortByToggleProps2(props, _ref) {
        var instance = _ref.instance, column = _ref.column;
        var _instance$isMultiSort = instance.isMultiSortEvent, isMultiSortEvent = _instance$isMultiSort === void 0 ? function(e3) {
          return e3.shiftKey;
        } : _instance$isMultiSort;
        return [props, {
          onClick: column.canSort ? function(e3) {
            e3.persist();
            column.toggleSortBy(void 0, !instance.disableMultiSort && isMultiSortEvent(e3));
          } : void 0,
          style: {
            cursor: column.canSort ? "pointer" : void 0
          },
          title: column.canSort ? "Toggle SortBy" : void 0
        }];
      };
      function reducer$5(state, action, previousState, instance) {
        if (action.type === actions.init) {
          return _extends2({
            sortBy: []
          }, state);
        }
        if (action.type === actions.resetSortBy) {
          return _extends2({}, state, {
            sortBy: instance.initialState.sortBy || []
          });
        }
        if (action.type === actions.clearSortBy) {
          var sortBy2 = state.sortBy;
          var newSortBy = sortBy2.filter(function(d4) {
            return d4.id !== action.columnId;
          });
          return _extends2({}, state, {
            sortBy: newSortBy
          });
        }
        if (action.type === actions.setSortBy) {
          var _sortBy = action.sortBy;
          return _extends2({}, state, {
            sortBy: _sortBy
          });
        }
        if (action.type === actions.toggleSortBy) {
          var columnId = action.columnId, desc = action.desc, multi = action.multi;
          var allColumns2 = instance.allColumns, disableMultiSort = instance.disableMultiSort, disableSortRemove = instance.disableSortRemove, disableMultiRemove = instance.disableMultiRemove, _instance$maxMultiSor = instance.maxMultiSortColCount, maxMultiSortColCount = _instance$maxMultiSor === void 0 ? Number.MAX_SAFE_INTEGER : _instance$maxMultiSor;
          var _sortBy2 = state.sortBy;
          var column = allColumns2.find(function(d4) {
            return d4.id === columnId;
          });
          var sortDescFirst = column.sortDescFirst;
          var existingSortBy = _sortBy2.find(function(d4) {
            return d4.id === columnId;
          });
          var existingIndex = _sortBy2.findIndex(function(d4) {
            return d4.id === columnId;
          });
          var hasDescDefined = typeof desc !== "undefined" && desc !== null;
          var _newSortBy = [];
          var sortAction;
          if (!disableMultiSort && multi) {
            if (existingSortBy) {
              sortAction = "toggle";
            } else {
              sortAction = "add";
            }
          } else {
            if (existingIndex !== _sortBy2.length - 1 || _sortBy2.length !== 1) {
              sortAction = "replace";
            } else if (existingSortBy) {
              sortAction = "toggle";
            } else {
              sortAction = "replace";
            }
          }
          if (sortAction === "toggle" && // Must be toggling
          !disableSortRemove && // If disableSortRemove, disable in general
          !hasDescDefined && // Must not be setting desc
          (multi ? !disableMultiRemove : true) && // If multi, don't allow if disableMultiRemove
          (existingSortBy && // Finally, detect if it should indeed be removed
          existingSortBy.desc && !sortDescFirst || !existingSortBy.desc && sortDescFirst)) {
            sortAction = "remove";
          }
          if (sortAction === "replace") {
            _newSortBy = [{
              id: columnId,
              desc: hasDescDefined ? desc : sortDescFirst
            }];
          } else if (sortAction === "add") {
            _newSortBy = [].concat(_sortBy2, [{
              id: columnId,
              desc: hasDescDefined ? desc : sortDescFirst
            }]);
            _newSortBy.splice(0, _newSortBy.length - maxMultiSortColCount);
          } else if (sortAction === "toggle") {
            _newSortBy = _sortBy2.map(function(d4) {
              if (d4.id === columnId) {
                return _extends2({}, d4, {
                  desc: hasDescDefined ? desc : !existingSortBy.desc
                });
              }
              return d4;
            });
          } else if (sortAction === "remove") {
            _newSortBy = _sortBy2.filter(function(d4) {
              return d4.id !== columnId;
            });
          }
          return _extends2({}, state, {
            sortBy: _newSortBy
          });
        }
      }
      function useInstance$5(instance) {
        var data = instance.data, rows = instance.rows, flatRows = instance.flatRows, allColumns2 = instance.allColumns, _instance$orderByFn = instance.orderByFn, orderByFn = _instance$orderByFn === void 0 ? defaultOrderByFn : _instance$orderByFn, userSortTypes = instance.sortTypes, manualSortBy = instance.manualSortBy, defaultCanSort = instance.defaultCanSort, disableSortBy = instance.disableSortBy, flatHeaders = instance.flatHeaders, sortBy2 = instance.state.sortBy, dispatch = instance.dispatch, plugins = instance.plugins, getHooks = instance.getHooks, _instance$autoResetSo = instance.autoResetSortBy, autoResetSortBy = _instance$autoResetSo === void 0 ? true : _instance$autoResetSo;
        ensurePluginOrder(plugins, ["useFilters", "useGlobalFilter", "useGroupBy", "usePivotColumns"], "useSortBy");
        var setSortBy = React2.useCallback(function(sortBy3) {
          dispatch({
            type: actions.setSortBy,
            sortBy: sortBy3
          });
        }, [dispatch]);
        var toggleSortBy = React2.useCallback(function(columnId, desc, multi) {
          dispatch({
            type: actions.toggleSortBy,
            columnId,
            desc,
            multi
          });
        }, [dispatch]);
        var getInstance = useGetLatest(instance);
        flatHeaders.forEach(function(column) {
          var accessor = column.accessor, defaultColumnCanSort = column.canSort, columnDisableSortBy = column.disableSortBy, id2 = column.id;
          var canSort = accessor ? getFirstDefined(columnDisableSortBy === true ? false : void 0, disableSortBy === true ? false : void 0, true) : getFirstDefined(defaultCanSort, defaultColumnCanSort, false);
          column.canSort = canSort;
          if (column.canSort) {
            column.toggleSortBy = function(desc, multi) {
              return toggleSortBy(column.id, desc, multi);
            };
            column.clearSortBy = function() {
              dispatch({
                type: actions.clearSortBy,
                columnId: column.id
              });
            };
          }
          column.getSortByToggleProps = makePropGetter(getHooks().getSortByToggleProps, {
            instance: getInstance(),
            column
          });
          var columnSort = sortBy2.find(function(d4) {
            return d4.id === id2;
          });
          column.isSorted = !!columnSort;
          column.sortedIndex = sortBy2.findIndex(function(d4) {
            return d4.id === id2;
          });
          column.isSortedDesc = column.isSorted ? columnSort.desc : void 0;
        });
        var _React$useMemo = React2.useMemo(function() {
          if (manualSortBy || !sortBy2.length) {
            return [rows, flatRows];
          }
          var sortedFlatRows2 = [];
          var availableSortBy = sortBy2.filter(function(sort) {
            return allColumns2.find(function(col) {
              return col.id === sort.id;
            });
          });
          var sortData = function sortData2(rows2) {
            var sortedData = orderByFn(
              rows2,
              availableSortBy.map(function(sort) {
                var column = allColumns2.find(function(d4) {
                  return d4.id === sort.id;
                });
                if (!column) {
                  throw new Error("React-Table: Could not find a column with id: " + sort.id + " while sorting");
                }
                var sortType = column.sortType;
                var sortMethod = isFunction2(sortType) || (userSortTypes || {})[sortType] || sortTypes2[sortType];
                if (!sortMethod) {
                  throw new Error("React-Table: Could not find a valid sortType of '" + sortType + "' for column '" + sort.id + "'.");
                }
                return function(a4, b3) {
                  return sortMethod(a4, b3, sort.id, sort.desc);
                };
              }),
              // Map the directions
              availableSortBy.map(function(sort) {
                var column = allColumns2.find(function(d4) {
                  return d4.id === sort.id;
                });
                if (column && column.sortInverted) {
                  return sort.desc;
                }
                return !sort.desc;
              })
            );
            sortedData.forEach(function(row) {
              sortedFlatRows2.push(row);
              if (!row.subRows || row.subRows.length === 0) {
                return;
              }
              row.subRows = sortData2(row.subRows);
            });
            return sortedData;
          };
          return [sortData(rows), sortedFlatRows2];
        }, [manualSortBy, sortBy2, rows, flatRows, allColumns2, orderByFn, userSortTypes]), sortedRows = _React$useMemo[0], sortedFlatRows = _React$useMemo[1];
        var getAutoResetSortBy = useGetLatest(autoResetSortBy);
        useMountedLayoutEffect(function() {
          if (getAutoResetSortBy()) {
            dispatch({
              type: actions.resetSortBy
            });
          }
        }, [manualSortBy ? null : data]);
        Object.assign(instance, {
          preSortedRows: rows,
          preSortedFlatRows: flatRows,
          sortedRows,
          sortedFlatRows,
          rows: sortedRows,
          flatRows: sortedFlatRows,
          setSortBy,
          toggleSortBy
        });
      }
      function defaultOrderByFn(arr, funcs, dirs) {
        return [].concat(arr).sort(function(rowA, rowB) {
          for (var i3 = 0; i3 < funcs.length; i3 += 1) {
            var sortFn = funcs[i3];
            var desc = dirs[i3] === false || dirs[i3] === "desc";
            var sortInt = sortFn(rowA, rowB);
            if (sortInt !== 0) {
              return desc ? -sortInt : sortInt;
            }
          }
          return dirs[0] ? rowA.index - rowB.index : rowB.index - rowA.index;
        });
      }
      var pluginName2 = "usePagination";
      actions.resetPage = "resetPage";
      actions.gotoPage = "gotoPage";
      actions.setPageSize = "setPageSize";
      var usePagination2 = function usePagination3(hooks) {
        hooks.stateReducers.push(reducer$6);
        hooks.useInstance.push(useInstance$6);
      };
      usePagination2.pluginName = pluginName2;
      function reducer$6(state, action, previousState, instance) {
        if (action.type === actions.init) {
          return _extends2({
            pageSize: 10,
            pageIndex: 0
          }, state);
        }
        if (action.type === actions.resetPage) {
          return _extends2({}, state, {
            pageIndex: instance.initialState.pageIndex || 0
          });
        }
        if (action.type === actions.gotoPage) {
          var pageCount = instance.pageCount, page = instance.page;
          var newPageIndex = functionalUpdate2(action.pageIndex, state.pageIndex);
          var canNavigate = false;
          if (newPageIndex > state.pageIndex) {
            canNavigate = pageCount === -1 ? page.length >= state.pageSize : newPageIndex < pageCount;
          } else if (newPageIndex < state.pageIndex) {
            canNavigate = newPageIndex > -1;
          }
          if (!canNavigate) {
            return state;
          }
          return _extends2({}, state, {
            pageIndex: newPageIndex
          });
        }
        if (action.type === actions.setPageSize) {
          var pageSize = action.pageSize;
          var topRowIndex = state.pageSize * state.pageIndex;
          var pageIndex = Math.floor(topRowIndex / pageSize);
          return _extends2({}, state, {
            pageIndex,
            pageSize
          });
        }
      }
      function useInstance$6(instance) {
        var rows = instance.rows, _instance$autoResetPa = instance.autoResetPage, autoResetPage = _instance$autoResetPa === void 0 ? true : _instance$autoResetPa, _instance$manualExpan = instance.manualExpandedKey, manualExpandedKey = _instance$manualExpan === void 0 ? "expanded" : _instance$manualExpan, plugins = instance.plugins, userPageCount = instance.pageCount, _instance$paginateExp = instance.paginateExpandedRows, paginateExpandedRows = _instance$paginateExp === void 0 ? true : _instance$paginateExp, _instance$expandSubRo = instance.expandSubRows, expandSubRows = _instance$expandSubRo === void 0 ? true : _instance$expandSubRo, _instance$state = instance.state, pageSize = _instance$state.pageSize, pageIndex = _instance$state.pageIndex, expanded = _instance$state.expanded, globalFilter = _instance$state.globalFilter, filters = _instance$state.filters, groupBy2 = _instance$state.groupBy, sortBy2 = _instance$state.sortBy, dispatch = instance.dispatch, data = instance.data, manualPagination = instance.manualPagination;
        ensurePluginOrder(plugins, ["useGlobalFilter", "useFilters", "useGroupBy", "useSortBy", "useExpanded"], "usePagination");
        var getAutoResetPage = useGetLatest(autoResetPage);
        useMountedLayoutEffect(function() {
          if (getAutoResetPage()) {
            dispatch({
              type: actions.resetPage
            });
          }
        }, [dispatch, manualPagination ? null : data, globalFilter, filters, groupBy2, sortBy2]);
        var pageCount = manualPagination ? userPageCount : Math.ceil(rows.length / pageSize);
        var pageOptions = React2.useMemo(function() {
          return pageCount > 0 ? [].concat(new Array(pageCount)).fill(null).map(function(d4, i3) {
            return i3;
          }) : [];
        }, [pageCount]);
        var page = React2.useMemo(function() {
          var page2;
          if (manualPagination) {
            page2 = rows;
          } else {
            var pageStart = pageSize * pageIndex;
            var pageEnd = pageStart + pageSize;
            page2 = rows.slice(pageStart, pageEnd);
          }
          if (paginateExpandedRows) {
            return page2;
          }
          return expandRows2(page2, {
            manualExpandedKey,
            expanded,
            expandSubRows
          });
        }, [expandSubRows, expanded, manualExpandedKey, manualPagination, pageIndex, pageSize, paginateExpandedRows, rows]);
        var canPreviousPage = pageIndex > 0;
        var canNextPage = pageCount === -1 ? page.length >= pageSize : pageIndex < pageCount - 1;
        var gotoPage = React2.useCallback(function(pageIndex2) {
          dispatch({
            type: actions.gotoPage,
            pageIndex: pageIndex2
          });
        }, [dispatch]);
        var previousPage = React2.useCallback(function() {
          return gotoPage(function(old) {
            return old - 1;
          });
        }, [gotoPage]);
        var nextPage = React2.useCallback(function() {
          return gotoPage(function(old) {
            return old + 1;
          });
        }, [gotoPage]);
        var setPageSize = React2.useCallback(function(pageSize2) {
          dispatch({
            type: actions.setPageSize,
            pageSize: pageSize2
          });
        }, [dispatch]);
        Object.assign(instance, {
          pageOptions,
          pageCount,
          page,
          canPreviousPage,
          canNextPage,
          gotoPage,
          previousPage,
          nextPage,
          setPageSize
        });
      }
      actions.resetPivot = "resetPivot";
      actions.togglePivot = "togglePivot";
      var _UNSTABLE_usePivotColumns = function _UNSTABLE_usePivotColumns2(hooks) {
        hooks.getPivotToggleProps = [defaultGetPivotToggleProps];
        hooks.stateReducers.push(reducer$7);
        hooks.useInstanceAfterData.push(useInstanceAfterData);
        hooks.allColumns.push(allColumns);
        hooks.accessValue.push(accessValue);
        hooks.materializedColumns.push(materializedColumns);
        hooks.materializedColumnsDeps.push(materializedColumnsDeps);
        hooks.visibleColumns.push(visibleColumns$1);
        hooks.visibleColumnsDeps.push(visibleColumnsDeps);
        hooks.useInstance.push(useInstance$7);
        hooks.prepareRow.push(prepareRow$2);
      };
      _UNSTABLE_usePivotColumns.pluginName = "usePivotColumns";
      var defaultPivotColumns = [];
      var defaultGetPivotToggleProps = function defaultGetPivotToggleProps2(props, _ref) {
        var header = _ref.header;
        return [props, {
          onClick: header.canPivot ? function(e3) {
            e3.persist();
            header.togglePivot();
          } : void 0,
          style: {
            cursor: header.canPivot ? "pointer" : void 0
          },
          title: "Toggle Pivot"
        }];
      };
      function reducer$7(state, action, previousState, instance) {
        if (action.type === actions.init) {
          return _extends2({
            pivotColumns: defaultPivotColumns
          }, state);
        }
        if (action.type === actions.resetPivot) {
          return _extends2({}, state, {
            pivotColumns: instance.initialState.pivotColumns || defaultPivotColumns
          });
        }
        if (action.type === actions.togglePivot) {
          var columnId = action.columnId, setPivot = action.value;
          var resolvedPivot = typeof setPivot !== "undefined" ? setPivot : !state.pivotColumns.includes(columnId);
          if (resolvedPivot) {
            return _extends2({}, state, {
              pivotColumns: [].concat(state.pivotColumns, [columnId])
            });
          }
          return _extends2({}, state, {
            pivotColumns: state.pivotColumns.filter(function(d4) {
              return d4 !== columnId;
            })
          });
        }
      }
      function useInstanceAfterData(instance) {
        instance.allColumns.forEach(function(column) {
          column.isPivotSource = instance.state.pivotColumns.includes(column.id);
        });
      }
      function allColumns(columns, _ref2) {
        var instance = _ref2.instance;
        columns.forEach(function(column) {
          column.isPivotSource = instance.state.pivotColumns.includes(column.id);
          column.uniqueValues = /* @__PURE__ */ new Set();
        });
        return columns;
      }
      function accessValue(value, _ref3) {
        var column = _ref3.column;
        if (column.uniqueValues && typeof value !== "undefined") {
          column.uniqueValues.add(value);
        }
        return value;
      }
      function materializedColumns(materialized, _ref4) {
        var instance = _ref4.instance;
        var allColumns2 = instance.allColumns, state = instance.state;
        if (!state.pivotColumns.length || !state.groupBy || !state.groupBy.length) {
          return materialized;
        }
        var pivotColumns = state.pivotColumns.map(function(id2) {
          return allColumns2.find(function(d4) {
            return d4.id === id2;
          });
        }).filter(Boolean);
        var sourceColumns = allColumns2.filter(function(d4) {
          return !d4.isPivotSource && !state.groupBy.includes(d4.id) && !state.pivotColumns.includes(d4.id);
        });
        var buildPivotColumns = function buildPivotColumns2(depth, parent, pivotFilters) {
          if (depth === void 0) {
            depth = 0;
          }
          if (pivotFilters === void 0) {
            pivotFilters = [];
          }
          var pivotColumn = pivotColumns[depth];
          if (!pivotColumn) {
            return sourceColumns.map(function(sourceColumn) {
              return _extends2({}, sourceColumn, {
                canPivot: false,
                isPivoted: true,
                parent,
                depth,
                id: "" + (parent ? parent.id + "." + sourceColumn.id : sourceColumn.id),
                accessor: function accessor(originalRow, i3, row) {
                  if (pivotFilters.every(function(filter2) {
                    return filter2(row);
                  })) {
                    return row.values[sourceColumn.id];
                  }
                }
              });
            });
          }
          var uniqueValues = Array.from(pivotColumn.uniqueValues).sort();
          return uniqueValues.map(function(uniqueValue) {
            var columnGroup = _extends2({}, pivotColumn, {
              Header: pivotColumn.PivotHeader || typeof pivotColumn.header === "string" ? pivotColumn.Header + ": " + uniqueValue : uniqueValue,
              isPivotGroup: true,
              parent,
              depth,
              id: parent ? parent.id + "." + pivotColumn.id + "." + uniqueValue : pivotColumn.id + "." + uniqueValue,
              pivotValue: uniqueValue
            });
            columnGroup.columns = buildPivotColumns2(depth + 1, columnGroup, [].concat(pivotFilters, [function(row) {
              return row.values[pivotColumn.id] === uniqueValue;
            }]));
            return columnGroup;
          });
        };
        var newMaterialized = flattenColumns(buildPivotColumns());
        return [].concat(materialized, newMaterialized);
      }
      function materializedColumnsDeps(deps, _ref5) {
        var _ref5$instance$state = _ref5.instance.state, pivotColumns = _ref5$instance$state.pivotColumns, groupBy2 = _ref5$instance$state.groupBy;
        return [].concat(deps, [pivotColumns, groupBy2]);
      }
      function visibleColumns$1(visibleColumns3, _ref6) {
        var state = _ref6.instance.state;
        visibleColumns3 = visibleColumns3.filter(function(d4) {
          return !d4.isPivotSource;
        });
        if (state.pivotColumns.length && state.groupBy && state.groupBy.length) {
          visibleColumns3 = visibleColumns3.filter(function(column) {
            return column.isGrouped || column.isPivoted;
          });
        }
        return visibleColumns3;
      }
      function visibleColumnsDeps(deps, _ref7) {
        var instance = _ref7.instance;
        return [].concat(deps, [instance.state.pivotColumns, instance.state.groupBy]);
      }
      function useInstance$7(instance) {
        var columns = instance.columns, allColumns2 = instance.allColumns, flatHeaders = instance.flatHeaders, getHooks = instance.getHooks, plugins = instance.plugins, dispatch = instance.dispatch, _instance$autoResetPi = instance.autoResetPivot, autoResetPivot = _instance$autoResetPi === void 0 ? true : _instance$autoResetPi, manaulPivot = instance.manaulPivot, disablePivot = instance.disablePivot, defaultCanPivot = instance.defaultCanPivot;
        ensurePluginOrder(plugins, ["useGroupBy"], "usePivotColumns");
        var getInstance = useGetLatest(instance);
        allColumns2.forEach(function(column) {
          var accessor = column.accessor, defaultColumnPivot = column.defaultPivot, columnDisablePivot = column.disablePivot;
          column.canPivot = accessor ? getFirstDefined(column.canPivot, columnDisablePivot === true ? false : void 0, disablePivot === true ? false : void 0, true) : getFirstDefined(column.canPivot, defaultColumnPivot, defaultCanPivot, false);
          if (column.canPivot) {
            column.togglePivot = function() {
              return instance.togglePivot(column.id);
            };
          }
          column.Aggregated = column.Aggregated || column.Cell;
        });
        var togglePivot = function togglePivot2(columnId, value) {
          dispatch({
            type: actions.togglePivot,
            columnId,
            value
          });
        };
        flatHeaders.forEach(function(header) {
          header.getPivotToggleProps = makePropGetter(getHooks().getPivotToggleProps, {
            instance: getInstance(),
            header
          });
        });
        var getAutoResetPivot = useGetLatest(autoResetPivot);
        useMountedLayoutEffect(function() {
          if (getAutoResetPivot()) {
            dispatch({
              type: actions.resetPivot
            });
          }
        }, [dispatch, manaulPivot ? null : columns]);
        Object.assign(instance, {
          togglePivot
        });
      }
      function prepareRow$2(row) {
        row.allCells.forEach(function(cell) {
          cell.isPivoted = cell.column.isPivoted;
        });
      }
      var pluginName$12 = "useRowSelect";
      actions.resetSelectedRows = "resetSelectedRows";
      actions.toggleAllRowsSelected = "toggleAllRowsSelected";
      actions.toggleRowSelected = "toggleRowSelected";
      actions.toggleAllPageRowsSelected = "toggleAllPageRowsSelected";
      var useRowSelect2 = function useRowSelect3(hooks) {
        hooks.getToggleRowSelectedProps = [defaultGetToggleRowSelectedProps];
        hooks.getToggleAllRowsSelectedProps = [defaultGetToggleAllRowsSelectedProps];
        hooks.getToggleAllPageRowsSelectedProps = [defaultGetToggleAllPageRowsSelectedProps];
        hooks.stateReducers.push(reducer$8);
        hooks.useInstance.push(useInstance$8);
        hooks.prepareRow.push(prepareRow$3);
      };
      useRowSelect2.pluginName = pluginName$12;
      var defaultGetToggleRowSelectedProps = function defaultGetToggleRowSelectedProps2(props, _ref) {
        var instance = _ref.instance, row = _ref.row;
        var _instance$manualRowSe = instance.manualRowSelectedKey, manualRowSelectedKey = _instance$manualRowSe === void 0 ? "isSelected" : _instance$manualRowSe;
        var checked = false;
        if (row.original && row.original[manualRowSelectedKey]) {
          checked = true;
        } else {
          checked = row.isSelected;
        }
        return [props, {
          onChange: function onChange(e3) {
            row.toggleRowSelected(e3.target.checked);
          },
          style: {
            cursor: "pointer"
          },
          checked,
          title: "Toggle Row Selected",
          indeterminate: row.isSomeSelected
        }];
      };
      var defaultGetToggleAllRowsSelectedProps = function defaultGetToggleAllRowsSelectedProps2(props, _ref2) {
        var instance = _ref2.instance;
        return [props, {
          onChange: function onChange(e3) {
            instance.toggleAllRowsSelected(e3.target.checked);
          },
          style: {
            cursor: "pointer"
          },
          checked: instance.isAllRowsSelected,
          title: "Toggle All Rows Selected",
          indeterminate: Boolean(!instance.isAllRowsSelected && Object.keys(instance.state.selectedRowIds).length)
        }];
      };
      var defaultGetToggleAllPageRowsSelectedProps = function defaultGetToggleAllPageRowsSelectedProps2(props, _ref3) {
        var instance = _ref3.instance;
        return [props, {
          onChange: function onChange(e3) {
            instance.toggleAllPageRowsSelected(e3.target.checked);
          },
          style: {
            cursor: "pointer"
          },
          checked: instance.isAllPageRowsSelected,
          title: "Toggle All Current Page Rows Selected",
          indeterminate: Boolean(!instance.isAllPageRowsSelected && instance.page.some(function(_ref4) {
            var id2 = _ref4.id;
            return instance.state.selectedRowIds[id2];
          }))
        }];
      };
      function reducer$8(state, action, previousState, instance) {
        if (action.type === actions.init) {
          return _extends2({
            selectedRowIds: {}
          }, state);
        }
        if (action.type === actions.resetSelectedRows) {
          return _extends2({}, state, {
            selectedRowIds: instance.initialState.selectedRowIds || {}
          });
        }
        if (action.type === actions.toggleAllRowsSelected) {
          var setSelected = action.value;
          var isAllRowsSelected = instance.isAllRowsSelected, rowsById = instance.rowsById, _instance$nonGroupedR = instance.nonGroupedRowsById, nonGroupedRowsById = _instance$nonGroupedR === void 0 ? rowsById : _instance$nonGroupedR;
          var selectAll = typeof setSelected !== "undefined" ? setSelected : !isAllRowsSelected;
          var selectedRowIds = Object.assign({}, state.selectedRowIds);
          if (selectAll) {
            Object.keys(nonGroupedRowsById).forEach(function(rowId) {
              selectedRowIds[rowId] = true;
            });
          } else {
            Object.keys(nonGroupedRowsById).forEach(function(rowId) {
              delete selectedRowIds[rowId];
            });
          }
          return _extends2({}, state, {
            selectedRowIds
          });
        }
        if (action.type === actions.toggleRowSelected) {
          var id2 = action.id, _setSelected = action.value;
          var _rowsById = instance.rowsById, _instance$selectSubRo = instance.selectSubRows, selectSubRows = _instance$selectSubRo === void 0 ? true : _instance$selectSubRo, getSubRows = instance.getSubRows;
          var isSelected = state.selectedRowIds[id2];
          var shouldExist = typeof _setSelected !== "undefined" ? _setSelected : !isSelected;
          if (isSelected === shouldExist) {
            return state;
          }
          var newSelectedRowIds = _extends2({}, state.selectedRowIds);
          var handleRowById = function handleRowById2(id3) {
            var row = _rowsById[id3];
            if (row) {
              if (!row.isGrouped) {
                if (shouldExist) {
                  newSelectedRowIds[id3] = true;
                } else {
                  delete newSelectedRowIds[id3];
                }
              }
              if (selectSubRows && getSubRows(row)) {
                return getSubRows(row).forEach(function(row2) {
                  return handleRowById2(row2.id);
                });
              }
            }
          };
          handleRowById(id2);
          return _extends2({}, state, {
            selectedRowIds: newSelectedRowIds
          });
        }
        if (action.type === actions.toggleAllPageRowsSelected) {
          var _setSelected2 = action.value;
          var page = instance.page, _rowsById2 = instance.rowsById, _instance$selectSubRo2 = instance.selectSubRows, _selectSubRows = _instance$selectSubRo2 === void 0 ? true : _instance$selectSubRo2, isAllPageRowsSelected = instance.isAllPageRowsSelected, _getSubRows = instance.getSubRows;
          var _selectAll = typeof _setSelected2 !== "undefined" ? _setSelected2 : !isAllPageRowsSelected;
          var _newSelectedRowIds = _extends2({}, state.selectedRowIds);
          var _handleRowById = function _handleRowById2(id3) {
            var row = _rowsById2[id3];
            if (!row.isGrouped) {
              if (_selectAll) {
                _newSelectedRowIds[id3] = true;
              } else {
                delete _newSelectedRowIds[id3];
              }
            }
            if (_selectSubRows && _getSubRows(row)) {
              return _getSubRows(row).forEach(function(row2) {
                return _handleRowById2(row2.id);
              });
            }
          };
          page.forEach(function(row) {
            return _handleRowById(row.id);
          });
          return _extends2({}, state, {
            selectedRowIds: _newSelectedRowIds
          });
        }
        return state;
      }
      function useInstance$8(instance) {
        var data = instance.data, rows = instance.rows, getHooks = instance.getHooks, plugins = instance.plugins, rowsById = instance.rowsById, _instance$nonGroupedR2 = instance.nonGroupedRowsById, nonGroupedRowsById = _instance$nonGroupedR2 === void 0 ? rowsById : _instance$nonGroupedR2, _instance$autoResetSe = instance.autoResetSelectedRows, autoResetSelectedRows = _instance$autoResetSe === void 0 ? true : _instance$autoResetSe, selectedRowIds = instance.state.selectedRowIds, _instance$selectSubRo3 = instance.selectSubRows, selectSubRows = _instance$selectSubRo3 === void 0 ? true : _instance$selectSubRo3, dispatch = instance.dispatch, page = instance.page, getSubRows = instance.getSubRows;
        ensurePluginOrder(plugins, ["useFilters", "useGroupBy", "useSortBy", "useExpanded", "usePagination"], "useRowSelect");
        var selectedFlatRows = React2.useMemo(function() {
          var selectedFlatRows2 = [];
          rows.forEach(function(row) {
            var isSelected = selectSubRows ? getRowIsSelected(row, selectedRowIds, getSubRows) : !!selectedRowIds[row.id];
            row.isSelected = !!isSelected;
            row.isSomeSelected = isSelected === null;
            if (isSelected) {
              selectedFlatRows2.push(row);
            }
          });
          return selectedFlatRows2;
        }, [rows, selectSubRows, selectedRowIds, getSubRows]);
        var isAllRowsSelected = Boolean(Object.keys(nonGroupedRowsById).length && Object.keys(selectedRowIds).length);
        var isAllPageRowsSelected = isAllRowsSelected;
        if (isAllRowsSelected) {
          if (Object.keys(nonGroupedRowsById).some(function(id2) {
            return !selectedRowIds[id2];
          })) {
            isAllRowsSelected = false;
          }
        }
        if (!isAllRowsSelected) {
          if (page && page.length && page.some(function(_ref5) {
            var id2 = _ref5.id;
            return !selectedRowIds[id2];
          })) {
            isAllPageRowsSelected = false;
          }
        }
        var getAutoResetSelectedRows = useGetLatest(autoResetSelectedRows);
        useMountedLayoutEffect(function() {
          if (getAutoResetSelectedRows()) {
            dispatch({
              type: actions.resetSelectedRows
            });
          }
        }, [dispatch, data]);
        var toggleAllRowsSelected = React2.useCallback(function(value) {
          return dispatch({
            type: actions.toggleAllRowsSelected,
            value
          });
        }, [dispatch]);
        var toggleAllPageRowsSelected = React2.useCallback(function(value) {
          return dispatch({
            type: actions.toggleAllPageRowsSelected,
            value
          });
        }, [dispatch]);
        var toggleRowSelected = React2.useCallback(function(id2, value) {
          return dispatch({
            type: actions.toggleRowSelected,
            id: id2,
            value
          });
        }, [dispatch]);
        var getInstance = useGetLatest(instance);
        var getToggleAllRowsSelectedProps = makePropGetter(getHooks().getToggleAllRowsSelectedProps, {
          instance: getInstance()
        });
        var getToggleAllPageRowsSelectedProps = makePropGetter(getHooks().getToggleAllPageRowsSelectedProps, {
          instance: getInstance()
        });
        Object.assign(instance, {
          selectedFlatRows,
          isAllRowsSelected,
          isAllPageRowsSelected,
          toggleRowSelected,
          toggleAllRowsSelected,
          getToggleAllRowsSelectedProps,
          getToggleAllPageRowsSelectedProps,
          toggleAllPageRowsSelected
        });
      }
      function prepareRow$3(row, _ref6) {
        var instance = _ref6.instance;
        row.toggleRowSelected = function(set2) {
          return instance.toggleRowSelected(row.id, set2);
        };
        row.getToggleRowSelectedProps = makePropGetter(instance.getHooks().getToggleRowSelectedProps, {
          instance,
          row
        });
      }
      function getRowIsSelected(row, selectedRowIds, getSubRows) {
        if (selectedRowIds[row.id]) {
          return true;
        }
        var subRows = getSubRows(row);
        if (subRows && subRows.length) {
          var allChildrenSelected = true;
          var someSelected = false;
          subRows.forEach(function(subRow) {
            if (someSelected && !allChildrenSelected) {
              return;
            }
            if (getRowIsSelected(subRow, selectedRowIds, getSubRows)) {
              someSelected = true;
            } else {
              allChildrenSelected = false;
            }
          });
          return allChildrenSelected ? true : someSelected ? null : false;
        }
        return false;
      }
      var defaultInitialRowStateAccessor = function defaultInitialRowStateAccessor2(row) {
        return {};
      };
      var defaultInitialCellStateAccessor = function defaultInitialCellStateAccessor2(cell) {
        return {};
      };
      actions.setRowState = "setRowState";
      actions.setCellState = "setCellState";
      actions.resetRowState = "resetRowState";
      var useRowState = function useRowState2(hooks) {
        hooks.stateReducers.push(reducer$9);
        hooks.useInstance.push(useInstance$9);
        hooks.prepareRow.push(prepareRow$4);
      };
      useRowState.pluginName = "useRowState";
      function reducer$9(state, action, previousState, instance) {
        var _instance$initialRowS = instance.initialRowStateAccessor, initialRowStateAccessor = _instance$initialRowS === void 0 ? defaultInitialRowStateAccessor : _instance$initialRowS, _instance$initialCell = instance.initialCellStateAccessor, initialCellStateAccessor = _instance$initialCell === void 0 ? defaultInitialCellStateAccessor : _instance$initialCell, rowsById = instance.rowsById;
        if (action.type === actions.init) {
          return _extends2({
            rowState: {}
          }, state);
        }
        if (action.type === actions.resetRowState) {
          return _extends2({}, state, {
            rowState: instance.initialState.rowState || {}
          });
        }
        if (action.type === actions.setRowState) {
          var _extends22;
          var rowId = action.rowId, value = action.value;
          var oldRowState = typeof state.rowState[rowId] !== "undefined" ? state.rowState[rowId] : initialRowStateAccessor(rowsById[rowId]);
          return _extends2({}, state, {
            rowState: _extends2({}, state.rowState, (_extends22 = {}, _extends22[rowId] = functionalUpdate2(value, oldRowState), _extends22))
          });
        }
        if (action.type === actions.setCellState) {
          var _oldRowState$cellStat, _rowsById$_rowId, _rowsById$_rowId$cell, _extends3, _extends4;
          var _rowId = action.rowId, columnId = action.columnId, _value = action.value;
          var _oldRowState = typeof state.rowState[_rowId] !== "undefined" ? state.rowState[_rowId] : initialRowStateAccessor(rowsById[_rowId]);
          var oldCellState = typeof (_oldRowState == null ? void 0 : (_oldRowState$cellStat = _oldRowState.cellState) == null ? void 0 : _oldRowState$cellStat[columnId]) !== "undefined" ? _oldRowState.cellState[columnId] : initialCellStateAccessor((_rowsById$_rowId = rowsById[_rowId]) == null ? void 0 : (_rowsById$_rowId$cell = _rowsById$_rowId.cells) == null ? void 0 : _rowsById$_rowId$cell.find(function(cell) {
            return cell.column.id === columnId;
          }));
          return _extends2({}, state, {
            rowState: _extends2({}, state.rowState, (_extends4 = {}, _extends4[_rowId] = _extends2({}, _oldRowState, {
              cellState: _extends2({}, _oldRowState.cellState || {}, (_extends3 = {}, _extends3[columnId] = functionalUpdate2(_value, oldCellState), _extends3))
            }), _extends4))
          });
        }
      }
      function useInstance$9(instance) {
        var _instance$autoResetRo = instance.autoResetRowState, autoResetRowState = _instance$autoResetRo === void 0 ? true : _instance$autoResetRo, data = instance.data, dispatch = instance.dispatch;
        var setRowState = React2.useCallback(function(rowId, value) {
          return dispatch({
            type: actions.setRowState,
            rowId,
            value
          });
        }, [dispatch]);
        var setCellState = React2.useCallback(function(rowId, columnId, value) {
          return dispatch({
            type: actions.setCellState,
            rowId,
            columnId,
            value
          });
        }, [dispatch]);
        var getAutoResetRowState = useGetLatest(autoResetRowState);
        useMountedLayoutEffect(function() {
          if (getAutoResetRowState()) {
            dispatch({
              type: actions.resetRowState
            });
          }
        }, [data]);
        Object.assign(instance, {
          setRowState,
          setCellState
        });
      }
      function prepareRow$4(row, _ref) {
        var instance = _ref.instance;
        var _instance$initialRowS2 = instance.initialRowStateAccessor, initialRowStateAccessor = _instance$initialRowS2 === void 0 ? defaultInitialRowStateAccessor : _instance$initialRowS2, _instance$initialCell2 = instance.initialCellStateAccessor, initialCellStateAccessor = _instance$initialCell2 === void 0 ? defaultInitialCellStateAccessor : _instance$initialCell2, rowState = instance.state.rowState;
        if (row) {
          row.state = typeof rowState[row.id] !== "undefined" ? rowState[row.id] : initialRowStateAccessor(row);
          row.setState = function(updater) {
            return instance.setRowState(row.id, updater);
          };
          row.cells.forEach(function(cell) {
            if (!row.state.cellState) {
              row.state.cellState = {};
            }
            cell.state = typeof row.state.cellState[cell.column.id] !== "undefined" ? row.state.cellState[cell.column.id] : initialCellStateAccessor(cell);
            cell.setState = function(updater) {
              return instance.setCellState(row.id, cell.column.id, updater);
            };
          });
        }
      }
      actions.resetColumnOrder = "resetColumnOrder";
      actions.setColumnOrder = "setColumnOrder";
      var useColumnOrder = function useColumnOrder2(hooks) {
        hooks.stateReducers.push(reducer$a);
        hooks.visibleColumnsDeps.push(function(deps, _ref) {
          var instance = _ref.instance;
          return [].concat(deps, [instance.state.columnOrder]);
        });
        hooks.visibleColumns.push(visibleColumns$2);
        hooks.useInstance.push(useInstance$a);
      };
      useColumnOrder.pluginName = "useColumnOrder";
      function reducer$a(state, action, previousState, instance) {
        if (action.type === actions.init) {
          return _extends2({
            columnOrder: []
          }, state);
        }
        if (action.type === actions.resetColumnOrder) {
          return _extends2({}, state, {
            columnOrder: instance.initialState.columnOrder || []
          });
        }
        if (action.type === actions.setColumnOrder) {
          return _extends2({}, state, {
            columnOrder: functionalUpdate2(action.columnOrder, state.columnOrder)
          });
        }
      }
      function visibleColumns$2(columns, _ref2) {
        var columnOrder = _ref2.instance.state.columnOrder;
        if (!columnOrder || !columnOrder.length) {
          return columns;
        }
        var columnOrderCopy = [].concat(columnOrder);
        var columnsCopy = [].concat(columns);
        var columnsInOrder = [];
        var _loop = function _loop2() {
          var targetColumnId = columnOrderCopy.shift();
          var foundIndex = columnsCopy.findIndex(function(d4) {
            return d4.id === targetColumnId;
          });
          if (foundIndex > -1) {
            columnsInOrder.push(columnsCopy.splice(foundIndex, 1)[0]);
          }
        };
        while (columnsCopy.length && columnOrderCopy.length) {
          _loop();
        }
        return [].concat(columnsInOrder, columnsCopy);
      }
      function useInstance$a(instance) {
        var dispatch = instance.dispatch;
        instance.setColumnOrder = React2.useCallback(function(columnOrder) {
          return dispatch({
            type: actions.setColumnOrder,
            columnOrder
          });
        }, [dispatch]);
      }
      defaultColumn.canResize = true;
      actions.columnStartResizing = "columnStartResizing";
      actions.columnResizing = "columnResizing";
      actions.columnDoneResizing = "columnDoneResizing";
      actions.resetResize = "resetResize";
      var useResizeColumns = function useResizeColumns2(hooks) {
        hooks.getResizerProps = [defaultGetResizerProps];
        hooks.getHeaderProps.push({
          style: {
            position: "relative"
          }
        });
        hooks.stateReducers.push(reducer$b);
        hooks.useInstance.push(useInstance$b);
        hooks.useInstanceBeforeDimensions.push(useInstanceBeforeDimensions$1);
      };
      var defaultGetResizerProps = function defaultGetResizerProps2(props, _ref) {
        var instance = _ref.instance, header = _ref.header;
        var dispatch = instance.dispatch;
        var onResizeStart = function onResizeStart2(e3, header2) {
          var isTouchEvent2 = false;
          if (e3.type === "touchstart") {
            if (e3.touches && e3.touches.length > 1) {
              return;
            }
            isTouchEvent2 = true;
          }
          var headersToResize = getLeafHeaders(header2);
          var headerIdWidths = headersToResize.map(function(d4) {
            return [d4.id, d4.totalWidth];
          });
          var clientX = isTouchEvent2 ? Math.round(e3.touches[0].clientX) : e3.clientX;
          var raf;
          var mostRecentClientX;
          var dispatchEnd = function dispatchEnd2() {
            window.cancelAnimationFrame(raf);
            raf = null;
            dispatch({
              type: actions.columnDoneResizing
            });
          };
          var dispatchMove = function dispatchMove2() {
            window.cancelAnimationFrame(raf);
            raf = null;
            dispatch({
              type: actions.columnResizing,
              clientX: mostRecentClientX
            });
          };
          var scheduleDispatchMoveOnNextAnimationFrame = function scheduleDispatchMoveOnNextAnimationFrame2(clientXPos) {
            mostRecentClientX = clientXPos;
            if (!raf) {
              raf = window.requestAnimationFrame(dispatchMove);
            }
          };
          var handlersAndEvents = {
            mouse: {
              moveEvent: "mousemove",
              moveHandler: function moveHandler(e4) {
                return scheduleDispatchMoveOnNextAnimationFrame(e4.clientX);
              },
              upEvent: "mouseup",
              upHandler: function upHandler(e4) {
                document.removeEventListener("mousemove", handlersAndEvents.mouse.moveHandler);
                document.removeEventListener("mouseup", handlersAndEvents.mouse.upHandler);
                dispatchEnd();
              }
            },
            touch: {
              moveEvent: "touchmove",
              moveHandler: function moveHandler(e4) {
                if (e4.cancelable) {
                  e4.preventDefault();
                  e4.stopPropagation();
                }
                scheduleDispatchMoveOnNextAnimationFrame(e4.touches[0].clientX);
                return false;
              },
              upEvent: "touchend",
              upHandler: function upHandler(e4) {
                document.removeEventListener(handlersAndEvents.touch.moveEvent, handlersAndEvents.touch.moveHandler);
                document.removeEventListener(handlersAndEvents.touch.upEvent, handlersAndEvents.touch.moveHandler);
                dispatchEnd();
              }
            }
          };
          var events2 = isTouchEvent2 ? handlersAndEvents.touch : handlersAndEvents.mouse;
          var passiveIfSupported = passiveEventSupported2() ? {
            passive: false
          } : false;
          document.addEventListener(events2.moveEvent, events2.moveHandler, passiveIfSupported);
          document.addEventListener(events2.upEvent, events2.upHandler, passiveIfSupported);
          dispatch({
            type: actions.columnStartResizing,
            columnId: header2.id,
            columnWidth: header2.totalWidth,
            headerIdWidths,
            clientX
          });
        };
        return [props, {
          onMouseDown: function onMouseDown(e3) {
            return e3.persist() || onResizeStart(e3, header);
          },
          onTouchStart: function onTouchStart(e3) {
            return e3.persist() || onResizeStart(e3, header);
          },
          style: {
            cursor: "col-resize"
          },
          draggable: false,
          role: "separator"
        }];
      };
      useResizeColumns.pluginName = "useResizeColumns";
      function reducer$b(state, action) {
        if (action.type === actions.init) {
          return _extends2({
            columnResizing: {
              columnWidths: {}
            }
          }, state);
        }
        if (action.type === actions.resetResize) {
          return _extends2({}, state, {
            columnResizing: {
              columnWidths: {}
            }
          });
        }
        if (action.type === actions.columnStartResizing) {
          var clientX = action.clientX, columnId = action.columnId, columnWidth = action.columnWidth, headerIdWidths = action.headerIdWidths;
          return _extends2({}, state, {
            columnResizing: _extends2({}, state.columnResizing, {
              startX: clientX,
              headerIdWidths,
              columnWidth,
              isResizingColumn: columnId
            })
          });
        }
        if (action.type === actions.columnResizing) {
          var _clientX = action.clientX;
          var _state$columnResizing = state.columnResizing, startX = _state$columnResizing.startX, _columnWidth = _state$columnResizing.columnWidth, _state$columnResizing2 = _state$columnResizing.headerIdWidths, _headerIdWidths = _state$columnResizing2 === void 0 ? [] : _state$columnResizing2;
          var deltaX = _clientX - startX;
          var percentageDeltaX = deltaX / _columnWidth;
          var newColumnWidths = {};
          _headerIdWidths.forEach(function(_ref2) {
            var headerId = _ref2[0], headerWidth = _ref2[1];
            newColumnWidths[headerId] = Math.max(headerWidth + headerWidth * percentageDeltaX, 0);
          });
          return _extends2({}, state, {
            columnResizing: _extends2({}, state.columnResizing, {
              columnWidths: _extends2({}, state.columnResizing.columnWidths, {}, newColumnWidths)
            })
          });
        }
        if (action.type === actions.columnDoneResizing) {
          return _extends2({}, state, {
            columnResizing: _extends2({}, state.columnResizing, {
              startX: null,
              isResizingColumn: null
            })
          });
        }
      }
      var useInstanceBeforeDimensions$1 = function useInstanceBeforeDimensions2(instance) {
        var flatHeaders = instance.flatHeaders, disableResizing = instance.disableResizing, getHooks = instance.getHooks, columnResizing = instance.state.columnResizing;
        var getInstance = useGetLatest(instance);
        flatHeaders.forEach(function(header) {
          var canResize = getFirstDefined(header.disableResizing === true ? false : void 0, disableResizing === true ? false : void 0, true);
          header.canResize = canResize;
          header.width = columnResizing.columnWidths[header.id] || header.originalWidth || header.width;
          header.isResizing = columnResizing.isResizingColumn === header.id;
          if (canResize) {
            header.getResizerProps = makePropGetter(getHooks().getResizerProps, {
              instance: getInstance(),
              header
            });
          }
        });
      };
      function useInstance$b(instance) {
        var plugins = instance.plugins, dispatch = instance.dispatch, _instance$autoResetRe = instance.autoResetResize, autoResetResize = _instance$autoResetRe === void 0 ? true : _instance$autoResetRe, columns = instance.columns;
        ensurePluginOrder(plugins, ["useAbsoluteLayout"], "useResizeColumns");
        var getAutoResetResize = useGetLatest(autoResetResize);
        useMountedLayoutEffect(function() {
          if (getAutoResetResize()) {
            dispatch({
              type: actions.resetResize
            });
          }
        }, [columns]);
        var resetResizing = React2.useCallback(function() {
          return dispatch({
            type: actions.resetResize
          });
        }, [dispatch]);
        Object.assign(instance, {
          resetResizing
        });
      }
      function getLeafHeaders(header) {
        var leafHeaders = [];
        var recurseHeader = function recurseHeader2(header2) {
          if (header2.columns && header2.columns.length) {
            header2.columns.map(recurseHeader2);
          }
          leafHeaders.push(header2);
        };
        recurseHeader(header);
        return leafHeaders;
      }
      var cellStyles = {
        position: "absolute",
        top: 0
      };
      var useAbsoluteLayout = function useAbsoluteLayout2(hooks) {
        hooks.getTableBodyProps.push(getRowStyles);
        hooks.getRowProps.push(getRowStyles);
        hooks.getHeaderGroupProps.push(getRowStyles);
        hooks.getFooterGroupProps.push(getRowStyles);
        hooks.getHeaderProps.push(function(props, _ref) {
          var column = _ref.column;
          return [props, {
            style: _extends2({}, cellStyles, {
              left: column.totalLeft + "px",
              width: column.totalWidth + "px"
            })
          }];
        });
        hooks.getCellProps.push(function(props, _ref2) {
          var cell = _ref2.cell;
          return [props, {
            style: _extends2({}, cellStyles, {
              left: cell.column.totalLeft + "px",
              width: cell.column.totalWidth + "px"
            })
          }];
        });
        hooks.getFooterProps.push(function(props, _ref3) {
          var column = _ref3.column;
          return [props, {
            style: _extends2({}, cellStyles, {
              left: column.totalLeft + "px",
              width: column.totalWidth + "px"
            })
          }];
        });
      };
      useAbsoluteLayout.pluginName = "useAbsoluteLayout";
      var getRowStyles = function getRowStyles2(props, _ref4) {
        var instance = _ref4.instance;
        return [props, {
          style: {
            position: "relative",
            width: instance.totalColumnsWidth + "px"
          }
        }];
      };
      var cellStyles$1 = {
        display: "inline-block",
        boxSizing: "border-box"
      };
      var getRowStyles$1 = function getRowStyles2(props, _ref) {
        var instance = _ref.instance;
        return [props, {
          style: {
            display: "flex",
            width: instance.totalColumnsWidth + "px"
          }
        }];
      };
      var useBlockLayout = function useBlockLayout2(hooks) {
        hooks.getRowProps.push(getRowStyles$1);
        hooks.getHeaderGroupProps.push(getRowStyles$1);
        hooks.getFooterGroupProps.push(getRowStyles$1);
        hooks.getHeaderProps.push(function(props, _ref2) {
          var column = _ref2.column;
          return [props, {
            style: _extends2({}, cellStyles$1, {
              width: column.totalWidth + "px"
            })
          }];
        });
        hooks.getCellProps.push(function(props, _ref3) {
          var cell = _ref3.cell;
          return [props, {
            style: _extends2({}, cellStyles$1, {
              width: cell.column.totalWidth + "px"
            })
          }];
        });
        hooks.getFooterProps.push(function(props, _ref4) {
          var column = _ref4.column;
          return [props, {
            style: _extends2({}, cellStyles$1, {
              width: column.totalWidth + "px"
            })
          }];
        });
      };
      useBlockLayout.pluginName = "useBlockLayout";
      function useFlexLayout(hooks) {
        hooks.getTableProps.push(getTableProps);
        hooks.getRowProps.push(getRowStyles$2);
        hooks.getHeaderGroupProps.push(getRowStyles$2);
        hooks.getFooterGroupProps.push(getRowStyles$2);
        hooks.getHeaderProps.push(getHeaderProps);
        hooks.getCellProps.push(getCellProps);
        hooks.getFooterProps.push(getFooterProps);
      }
      useFlexLayout.pluginName = "useFlexLayout";
      var getTableProps = function getTableProps2(props, _ref) {
        var instance = _ref.instance;
        return [props, {
          style: {
            minWidth: instance.totalColumnsMinWidth + "px"
          }
        }];
      };
      var getRowStyles$2 = function getRowStyles2(props, _ref2) {
        var instance = _ref2.instance;
        return [props, {
          style: {
            display: "flex",
            flex: "1 0 auto",
            minWidth: instance.totalColumnsMinWidth + "px"
          }
        }];
      };
      var getHeaderProps = function getHeaderProps2(props, _ref3) {
        var column = _ref3.column;
        return [props, {
          style: {
            boxSizing: "border-box",
            flex: column.totalFlexWidth ? column.totalFlexWidth + " 0 auto" : void 0,
            minWidth: column.totalMinWidth + "px",
            width: column.totalWidth + "px"
          }
        }];
      };
      var getCellProps = function getCellProps2(props, _ref4) {
        var cell = _ref4.cell;
        return [props, {
          style: {
            boxSizing: "border-box",
            flex: cell.column.totalFlexWidth + " 0 auto",
            minWidth: cell.column.totalMinWidth + "px",
            width: cell.column.totalWidth + "px"
          }
        }];
      };
      var getFooterProps = function getFooterProps2(props, _ref5) {
        var column = _ref5.column;
        return [props, {
          style: {
            boxSizing: "border-box",
            flex: column.totalFlexWidth ? column.totalFlexWidth + " 0 auto" : void 0,
            minWidth: column.totalMinWidth + "px",
            width: column.totalWidth + "px"
          }
        }];
      };
      actions.columnStartResizing = "columnStartResizing";
      actions.columnResizing = "columnResizing";
      actions.columnDoneResizing = "columnDoneResizing";
      actions.resetResize = "resetResize";
      function useGridLayout(hooks) {
        hooks.stateReducers.push(reducer$c);
        hooks.getTableProps.push(getTableProps$1);
        hooks.getHeaderProps.push(getHeaderProps$1);
        hooks.getRowProps.push(getRowProps2);
      }
      useGridLayout.pluginName = "useGridLayout";
      var getTableProps$1 = function getTableProps2(props, _ref) {
        var instance = _ref.instance;
        var gridTemplateColumns = instance.visibleColumns.map(function(column) {
          var _instance$state$colum;
          if (instance.state.gridLayout.columnWidths[column.id]) return instance.state.gridLayout.columnWidths[column.id] + "px";
          if ((_instance$state$colum = instance.state.columnResizing) == null ? void 0 : _instance$state$colum.isResizingColumn) return instance.state.gridLayout.startWidths[column.id] + "px";
          if (typeof column.width === "number") return column.width + "px";
          return column.width;
        });
        return [props, {
          style: {
            display: "grid",
            gridTemplateColumns: gridTemplateColumns.join(" ")
          }
        }];
      };
      var getHeaderProps$1 = function getHeaderProps2(props, _ref2) {
        var column = _ref2.column;
        return [props, {
          id: "header-cell-" + column.id,
          style: {
            position: "sticky",
            //enables a scroll wrapper to be placed around the table and have sticky headers
            gridColumn: "span " + column.totalVisibleHeaderCount
          }
        }];
      };
      var getRowProps2 = function getRowProps3(props, _ref3) {
        var row = _ref3.row;
        if (row.isExpanded) {
          return [props, {
            style: {
              gridColumn: "1 / " + (row.cells.length + 1)
            }
          }];
        }
        return [props, {}];
      };
      function reducer$c(state, action, previousState, instance) {
        if (action.type === actions.init) {
          return _extends2({
            gridLayout: {
              columnWidths: {}
            }
          }, state);
        }
        if (action.type === actions.resetResize) {
          return _extends2({}, state, {
            gridLayout: {
              columnWidths: {}
            }
          });
        }
        if (action.type === actions.columnStartResizing) {
          var columnId = action.columnId, headerIdWidths = action.headerIdWidths;
          var columnWidth = getElementWidth(columnId);
          if (columnWidth !== void 0) {
            var startWidths = instance.visibleColumns.reduce(function(acc, column) {
              var _extends22;
              return _extends2({}, acc, (_extends22 = {}, _extends22[column.id] = getElementWidth(column.id), _extends22));
            }, {});
            var minWidths = instance.visibleColumns.reduce(function(acc, column) {
              var _extends3;
              return _extends2({}, acc, (_extends3 = {}, _extends3[column.id] = column.minWidth, _extends3));
            }, {});
            var maxWidths = instance.visibleColumns.reduce(function(acc, column) {
              var _extends4;
              return _extends2({}, acc, (_extends4 = {}, _extends4[column.id] = column.maxWidth, _extends4));
            }, {});
            var headerIdGridWidths = headerIdWidths.map(function(_ref4) {
              var headerId = _ref4[0];
              return [headerId, getElementWidth(headerId)];
            });
            return _extends2({}, state, {
              gridLayout: _extends2({}, state.gridLayout, {
                startWidths,
                minWidths,
                maxWidths,
                headerIdGridWidths,
                columnWidth
              })
            });
          } else {
            return state;
          }
        }
        if (action.type === actions.columnResizing) {
          var clientX = action.clientX;
          var startX = state.columnResizing.startX;
          var _state$gridLayout = state.gridLayout, _columnWidth = _state$gridLayout.columnWidth, _minWidths = _state$gridLayout.minWidths, _maxWidths = _state$gridLayout.maxWidths, _state$gridLayout$hea = _state$gridLayout.headerIdGridWidths, _headerIdGridWidths = _state$gridLayout$hea === void 0 ? [] : _state$gridLayout$hea;
          var deltaX = clientX - startX;
          var percentageDeltaX = deltaX / _columnWidth;
          var newColumnWidths = {};
          _headerIdGridWidths.forEach(function(_ref5) {
            var headerId = _ref5[0], headerWidth = _ref5[1];
            newColumnWidths[headerId] = Math.min(Math.max(_minWidths[headerId], headerWidth + headerWidth * percentageDeltaX), _maxWidths[headerId]);
          });
          return _extends2({}, state, {
            gridLayout: _extends2({}, state.gridLayout, {
              columnWidths: _extends2({}, state.gridLayout.columnWidths, {}, newColumnWidths)
            })
          });
        }
        if (action.type === actions.columnDoneResizing) {
          return _extends2({}, state, {
            gridLayout: _extends2({}, state.gridLayout, {
              startWidths: {},
              minWidths: {},
              maxWidths: {}
            })
          });
        }
      }
      function getElementWidth(columnId) {
        var _document$getElementB;
        var width = (_document$getElementB = document.getElementById("header-cell-" + columnId)) == null ? void 0 : _document$getElementB.offsetWidth;
        if (width !== void 0) {
          return width;
        }
      }
      exports2._UNSTABLE_usePivotColumns = _UNSTABLE_usePivotColumns;
      exports2.actions = actions;
      exports2.defaultColumn = defaultColumn;
      exports2.defaultGroupByFn = defaultGroupByFn;
      exports2.defaultOrderByFn = defaultOrderByFn;
      exports2.defaultRenderer = defaultRenderer;
      exports2.emptyRenderer = emptyRenderer;
      exports2.ensurePluginOrder = ensurePluginOrder;
      exports2.flexRender = flexRender2;
      exports2.functionalUpdate = functionalUpdate2;
      exports2.loopHooks = loopHooks;
      exports2.makePropGetter = makePropGetter;
      exports2.makeRenderer = makeRenderer;
      exports2.reduceHooks = reduceHooks;
      exports2.safeUseLayoutEffect = safeUseLayoutEffect;
      exports2.useAbsoluteLayout = useAbsoluteLayout;
      exports2.useAsyncDebounce = useAsyncDebounce;
      exports2.useBlockLayout = useBlockLayout;
      exports2.useColumnOrder = useColumnOrder;
      exports2.useExpanded = useExpanded;
      exports2.useFilters = useFilters;
      exports2.useFlexLayout = useFlexLayout;
      exports2.useGetLatest = useGetLatest;
      exports2.useGlobalFilter = useGlobalFilter;
      exports2.useGridLayout = useGridLayout;
      exports2.useGroupBy = useGroupBy;
      exports2.useMountedLayoutEffect = useMountedLayoutEffect;
      exports2.usePagination = usePagination2;
      exports2.useResizeColumns = useResizeColumns;
      exports2.useRowSelect = useRowSelect2;
      exports2.useRowState = useRowState;
      exports2.useSortBy = useSortBy;
      exports2.useTable = useTable2;
      Object.defineProperty(exports2, "__esModule", { value: true });
    });
  })(reactTable_development$1, reactTable_development$1.exports);
  return reactTable_development$1.exports;
}
var hasRequiredReactTable;
function requireReactTable() {
  if (hasRequiredReactTable) return reactTable.exports;
  hasRequiredReactTable = 1;
  if (process.env.NODE_ENV === "production") {
    reactTable.exports = requireReactTable_production_min();
  } else {
    reactTable.exports = requireReactTable_development();
  }
  return reactTable.exports;
}
var reactTableExports = requireReactTable();
const sanitizeRowProps = (row, rowExpansionRenderer) => {
  var _a;
  const props = {
    index: row.index,
    indexPath: row.id,
    values: row.original
  };
  if (((_a = row.subRows) == null ? void 0 : _a.length) > 0) {
    props.isExpanded = !!row.isExpanded;
    props.depth = row.depth;
    props.toggleRowExpanded = () => row.toggleRowExpanded(!props.isExpanded);
  } else if (rowExpansionRenderer) {
    props.isExpanded = !!row.isExpanded;
    props.toggleRowExpanded = () => row.toggleRowExpanded(!props.isExpanded);
  }
  if (row.toggleRowEditing) {
    props.isEditing = !!row.isEditing;
    props.toggleRowEditing = row.toggleRowEditing;
  }
  return props;
};
const getColumnsFromChildren = (children, rowExpansionRenderer) => {
  const sortRules = [];
  const columns = React__default.Children.toArray(children).filter((child) => !!child && !child.props.hidden).map(({ props: { children: groupChildren, ...props } }) => {
    const column = { ...props };
    column.sortType = column.sortType || "auto";
    column.disableSortBy = column.disableSorting;
    if (props.title && groupChildren) {
      column.Header = props.title;
      const { columns: groupColumns, sortRules: groupSortRules } = getColumnsFromChildren(
        groupChildren,
        rowExpansionRenderer
      );
      column.columns = groupColumns;
      groupSortRules.forEach((sort) => sortRules.push(sort));
    } else {
      column.accessor = props.accessor;
      column.Header = props.headRenderer || "";
      column.Cell = (columnProps) => {
        const cell = {
          accessor: columnProps.cell.column.id,
          row: sanitizeRowProps(columnProps.cell.row, rowExpansionRenderer),
          value: columnProps.cell.value
        };
        if (cell.row.isEditing && typeof props.editRenderer === "function") {
          return props.editRenderer(cell);
        }
        return typeof props.cellRenderer === "function" ? props.cellRenderer(cell) ?? null : cell.value ?? null;
      };
      column.align = props.align;
      column.flex = props.flex;
      if (props.sort && !props.disableSorting) {
        sortRules.push({
          id: props.accessor,
          desc: props.sort === "desc"
        });
      }
    }
    return column;
  });
  return { columns, sortRules };
};
const getInternalSortRules = (sortRules) => {
  return sortRules == null ? void 0 : sortRules.map((rule) => ({ id: rule.accessor, desc: rule.desc }));
};
const getTime = (value) => {
  const parsedValue = typeof value === "string" ? new Date(value) : value;
  return (parsedValue == null ? void 0 : parsedValue.getTime) ? parsedValue.getTime() : void 0;
};
const getNumber = (amount = "", decimalSeparator = ",") => {
  if (typeof amount === "number") {
    return amount;
  }
  if (amount === null || !amount.length) {
    return void 0;
  }
  let value;
  if (decimalSeparator === ",") {
    value = Number(amount.replace(/\./g, "").replace(",", "."));
  } else {
    value = Number(amount.replace(/,/g, ""));
  }
  return Number.isNaN(value) ? void 0 : value;
};
const getString = (value) => {
  if (value) {
    return String(value).toLowerCase();
  }
  return void 0;
};
const guess = (value) => {
  if (typeof value === "boolean") {
    return value;
  }
  return isNaN(value) ? getString(value) : Number(value);
};
const compareBasic = (a4, b3) => {
  if (a4 !== void 0 && b3 === void 0) {
    return 1;
  }
  return a4 === b3 ? 0 : a4 > b3 ? 1 : -1;
};
const stringsLocaleCompare = (a4, b3, locale2) => {
  const compareResult = a4.localeCompare(b3, locale2);
  return compareResult === 0 ? 0 : compareResult > 0 ? 1 : -1;
};
const compareBasicStrings = (a4, b3, locale2) => {
  if (a4 && b3) {
    return stringsLocaleCompare(a4, b3, locale2);
  }
  return compareBasic(a4, b3);
};
const sortTypes = (locale2) => {
  return {
    datetime: (rowA, rowB, columnId) => {
      const a4 = getTime(rowA.values[columnId]);
      const b3 = getTime(rowB.values[columnId]);
      return compareBasic(a4, b3);
    },
    string: (rowA, rowB, columnId) => {
      const a4 = getString(rowA.values[columnId]);
      const b3 = getString(rowB.values[columnId]);
      return compareBasicStrings(a4, b3, locale2);
    },
    number: (rowA, rowB, columnId) => {
      const a4 = getNumber(rowA.values[columnId]);
      const b3 = getNumber(rowB.values[columnId]);
      return compareBasic(a4, b3);
    },
    boolean: (rowA, rowB, columnId) => {
      const a4 = !!rowA.values[columnId];
      const b3 = !!rowB.values[columnId];
      return compareBasic(a4, b3);
    },
    auto: (rowA, rowB, columnId) => {
      const a4 = guess(rowA.values[columnId]);
      const b3 = guess(rowB.values[columnId]);
      if (typeof a4 === "string" && typeof b3 === "string") {
        return compareBasicStrings(a4, b3, locale2);
      } else {
        return compareBasic(a4, b3);
      }
    }
  };
};
const pluginName$1 = "useRowEditing";
reactTableExports.actions.resetRowEditing = "resetRowEditing";
reactTableExports.actions.toggleRowEditing = "toggleRowEditing";
reactTableExports.actions.toggleEditing = "toggleEditing";
function reducer$2(state, action) {
  if (action.type === reactTableExports.actions.init) {
    return {
      allowEditing: true,
      editingRowUniqueId: null,
      ...state
    };
  }
  if (action.type === reactTableExports.actions.resetRowEditing || action.type === reactTableExports.actions.resetPage || action.type === reactTableExports.actions.gotoPage) {
    return {
      ...state,
      editingRowUniqueId: null
    };
  }
  if (action.type === reactTableExports.actions.toggleRowEditing) {
    const { id: id2 } = action;
    return {
      ...state,
      editingRowUniqueId: id2
    };
  }
  if (action.type === reactTableExports.actions.toggleEditing) {
    return {
      ...state,
      allowEditing: !state.allowEditing
    };
  }
  return state;
}
function useInstance(instance) {
  const { dispatch } = instance;
  const resetRowEditing = React__default.useCallback(() => {
    dispatch({ type: reactTableExports.actions.resetRowEditing });
  }, [dispatch]);
  const toggleRowEditing = React__default.useCallback(
    (id2) => {
      dispatch({ type: reactTableExports.actions.toggleRowEditing, id: id2 });
    },
    [dispatch]
  );
  const toggleEditing = React__default.useCallback(() => {
    dispatch({ type: reactTableExports.actions.toggleEditing });
  }, [dispatch]);
  Object.assign(instance, {
    resetRowEditing,
    toggleRowEditing,
    toggleEditing
  });
}
const prepareRow$1 = (uniqueId3) => (row, { instance }) => {
  const id2 = row.original[uniqueId3];
  row.toggleRowEditing = () => {
    if (instance.state.editingRowUniqueId === id2) {
      instance.resetRowEditing();
    } else {
      instance.toggleRowEditing(id2);
    }
  };
  row.isEditing = row.original._createKey ? instance.state.editingRowUniqueId === row.original._createKey : instance.state.editingRowUniqueId === id2;
  row.canEdit = instance.state.allowEditing && (row.isEditing || !instance.state.editingRowUniqueId);
};
const useRowEditing = (uniqueId3) => {
  const plugin = (hooks) => {
    if (uniqueId3) {
      hooks.stateReducers.push(reducer$2);
      hooks.useInstance.push(useInstance);
      hooks.prepareRow.push(prepareRow$1(uniqueId3));
    }
  };
  plugin.pluginName = pluginName$1;
  return plugin;
};
var __defProp$1 = Object.defineProperty;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField$1 = (obj, key, value) => __defNormalProp$1(obj, typeof key !== "symbol" ? key + "" : key, value);
var observerMap = /* @__PURE__ */ new Map();
var RootIds = /* @__PURE__ */ new WeakMap();
var rootId = 0;
var unsupportedValue = void 0;
function getRootId(root) {
  if (!root) return "0";
  if (RootIds.has(root)) return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
function optionsToId(options) {
  return Object.keys(options).sort().filter(
    (key) => options[key] !== void 0
  ).map((key) => {
    return `${key}_${key === "root" ? getRootId(options.root) : options[key]}`;
  }).toString();
}
function createObserver(options) {
  const id2 = optionsToId(options);
  let instance = observerMap.get(id2);
  if (!instance) {
    const elements = /* @__PURE__ */ new Map();
    let thresholds;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        var _a;
        const inView = entry.isIntersecting && thresholds.some((threshold2) => entry.intersectionRatio >= threshold2);
        if (options.trackVisibility && typeof entry.isVisible === "undefined") {
          entry.isVisible = inView;
        }
        (_a = elements.get(entry.target)) == null ? void 0 : _a.forEach((callback) => {
          callback(inView, entry);
        });
      });
    }, options);
    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id: id2,
      observer,
      elements
    };
    observerMap.set(id2, instance);
  }
  return instance;
}
function observe(element, callback, options = {}, fallbackInView = unsupportedValue) {
  if (typeof window.IntersectionObserver === "undefined" && fallbackInView !== void 0) {
    const bounds = element.getBoundingClientRect();
    callback(fallbackInView, {
      isIntersecting: fallbackInView,
      target: element,
      intersectionRatio: typeof options.threshold === "number" ? options.threshold : 0,
      time: 0,
      boundingClientRect: bounds,
      intersectionRect: bounds,
      rootBounds: bounds
    });
    return () => {
    };
  }
  const { id: id2, observer, elements } = createObserver(options);
  const callbacks = elements.get(element) || [];
  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }
  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    callbacks.splice(callbacks.indexOf(callback), 1);
    if (callbacks.length === 0) {
      elements.delete(element);
      observer.unobserve(element);
    }
    if (elements.size === 0) {
      observer.disconnect();
      observerMap.delete(id2);
    }
  };
}
function isPlainChildren(props) {
  return typeof props.children !== "function";
}
var InView = class extends React.Component {
  constructor(props) {
    super(props);
    __publicField$1(this, "node", null);
    __publicField$1(this, "_unobserveCb", null);
    __publicField$1(this, "handleNode", (node) => {
      if (this.node) {
        this.unobserve();
        if (!node && !this.props.triggerOnce && !this.props.skip) {
          this.setState({ inView: !!this.props.initialInView, entry: void 0 });
        }
      }
      this.node = node ? node : null;
      this.observeNode();
    });
    __publicField$1(this, "handleChange", (inView, entry) => {
      if (inView && this.props.triggerOnce) {
        this.unobserve();
      }
      if (!isPlainChildren(this.props)) {
        this.setState({ inView, entry });
      }
      if (this.props.onChange) {
        this.props.onChange(inView, entry);
      }
    });
    this.state = {
      inView: !!props.initialInView,
      entry: void 0
    };
  }
  componentDidMount() {
    this.unobserve();
    this.observeNode();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
      this.unobserve();
      this.observeNode();
    }
  }
  componentWillUnmount() {
    this.unobserve();
  }
  observeNode() {
    if (!this.node || this.props.skip) return;
    const {
      threshold: threshold2,
      root,
      rootMargin,
      trackVisibility,
      delay,
      fallbackInView
    } = this.props;
    this._unobserveCb = observe(
      this.node,
      this.handleChange,
      {
        threshold: threshold2,
        root,
        rootMargin,
        // @ts-ignore
        trackVisibility,
        // @ts-ignore
        delay
      },
      fallbackInView
    );
  }
  unobserve() {
    if (this._unobserveCb) {
      this._unobserveCb();
      this._unobserveCb = null;
    }
  }
  render() {
    const { children } = this.props;
    if (typeof children === "function") {
      const { inView, entry } = this.state;
      return children({ inView, entry, ref: this.handleNode });
    }
    const {
      as,
      triggerOnce,
      threshold: threshold2,
      root,
      rootMargin,
      onChange,
      skip,
      trackVisibility,
      delay,
      initialInView,
      fallbackInView,
      ...props
    } = this.props;
    return React.createElement(
      as || "div",
      { ref: this.handleNode, ...props },
      children
    );
  }
};
const actionGroupClassName = "-mt-1 -mb-1 h-8 flex";
const hasActions = (inlineEditingUniqueId, handlers, actions) => {
  return !!actions || handlers.onRowCreate || handlers.onRowCopy || handlers.onRowDelete || !!inlineEditingUniqueId || handlers.onRowEdit;
};
const getActions = (actions, row = void 0) => {
  const primary = [];
  const secondary = [];
  if (actions) {
    let visibleActions = actions.filter((x3) => !!x3 && typeof x3 !== "boolean");
    if (row) {
      visibleActions = visibleActions.filter((action) => {
        if (action.visible !== void 0) {
          if (typeof action.visible === "function") {
            return action.visible(row);
          }
          return action.visible;
        }
        return true;
      });
    }
    visibleActions.forEach((action) => {
      if (action.showOnRow) {
        primary.push(action);
      } else {
        secondary.push(action);
      }
    });
  }
  return [primary, secondary];
};
const getLength = (inlineEditingUniqueId, handlers, actions) => {
  const [primaryActions, secondaryActions] = getActions(actions);
  let length = primaryActions.length + (secondaryActions.length ? 1 : 0);
  if (handlers.onRowCreate) {
    length++;
  }
  if (handlers.onRowCopy) {
    length++;
  }
  if (handlers.onRowDelete) {
    length++;
  }
  if (!!inlineEditingUniqueId || handlers.onRowEdit) {
    length++;
    if (length < 2) {
      length++;
    }
  }
  return length;
};
const getActionProps = (action, row) => {
  return {
    "aria-label": typeof action.tooltip === "function" ? action.tooltip(row) : action.tooltip,
    disabled: typeof action.disabled === "function" ? action.disabled(row) : action.disabled,
    onClick: (event) => {
      action.onClick(row, event);
    }
  };
};
const EditModeActions = () => {
  React__default.useEffect(() => {
    const listener = (event) => {
      var _a, _b;
      if (event.key === "Escape" && ((_b = (_a = event.target) == null ? void 0 : _a.form) == null ? void 0 : _b.reset)) {
        event.preventDefault();
        event.target.form.reset();
      }
    };
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
  }, []);
  return /* @__PURE__ */ React__default.createElement("div", { className: actionGroupClassName }, /* @__PURE__ */ React__default.createElement(IconButton, { appearance: "primary", icon: "tick", type: "submit", className: "mr-2" }), /* @__PURE__ */ React__default.createElement(IconButton, { appearance: "ghost", icon: "close", type: "reset" }));
};
const useRowActions = (inlineEditingUniqueId, handlers, actions, rowExpansionRenderer, texts, windowed = false) => {
  const inlineEditing = !!inlineEditingUniqueId;
  const actionsLength = getLength(inlineEditingUniqueId, handlers, actions);
  const plugin = (hooks) => {
    if (hasActions(inlineEditingUniqueId, handlers, actions)) {
      hooks.visibleColumns.push((columns) => [
        ...columns,
        {
          id: "_actions",
          className: "flex justify-end px-1 overflow-visible",
          flex: `0 0 calc((${actionsLength} * 2rem) + .5rem)`,
          Cell: ({ row }) => {
            if (row.isEditing) {
              return /* @__PURE__ */ React__default.createElement(EditModeActions, null);
            }
            const sanitizedRow = sanitizeRowProps(row, rowExpansionRenderer);
            const [primaryActions, secondaryActions] = getActions(actions, sanitizedRow);
            const output = /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, handlers.onRowCreate && /* @__PURE__ */ React__default.createElement(
              IconButton,
              {
                appearance: "discrete",
                icon: "circle-plus",
                "aria-label": texts.legacyTable.newSubRow,
                tooltip: texts.legacyTable.newSubRow,
                disabled: inlineEditing && !row.canEdit,
                onClick: (event) => {
                  event.stopPropagation();
                  event.persist();
                  row.setActive();
                  if (!row.isExpanded) {
                    row.toggleRowExpanded();
                  }
                  handlers.onRowCreate(sanitizedRow, event);
                }
              }
            ), (inlineEditing || handlers.onRowEdit) && /* @__PURE__ */ React__default.createElement(
              IconButton,
              {
                appearance: "discrete",
                icon: "edit",
                "aria-label": texts.legacyTable.edit,
                tooltip: texts.legacyTable.edit,
                disabled: inlineEditing && !row.canEdit,
                onClick: (event) => {
                  event.stopPropagation();
                  row.setActive();
                  if (inlineEditing) {
                    row.toggleRowEditing();
                  } else if (handlers.onRowEdit) {
                    event.persist();
                    handlers.onRowEdit(sanitizedRow, event);
                  }
                }
              }
            ), handlers.onRowCopy && /* @__PURE__ */ React__default.createElement(
              IconButton,
              {
                appearance: "discrete",
                icon: "copy",
                "aria-label": texts.legacyTable.copy,
                tooltip: texts.legacyTable.copy,
                disabled: inlineEditing && !row.canEdit,
                onClick: (event) => {
                  event.stopPropagation();
                  event.persist();
                  row.setActive();
                  handlers.onRowCopy(sanitizedRow, event);
                }
              }
            ), handlers.onRowDelete && /* @__PURE__ */ React__default.createElement(
              IconButton,
              {
                appearance: "discrete",
                icon: "delete",
                "aria-label": texts.legacyTable.del,
                tooltip: texts.legacyTable.del,
                disabled: inlineEditing && !row.canEdit,
                onClick: (event) => {
                  event.stopPropagation();
                  event.persist();
                  row.setActive();
                  handlers.onRowDelete(sanitizedRow, event);
                }
              }
            ), primaryActions.map((action, index2) => /* @__PURE__ */ React__default.createElement(
              IconButton,
              {
                ...getActionProps(action, sanitizedRow),
                key: index2,
                appearance: "discrete",
                icon: typeof action.icon === "function" ? action.icon(sanitizedRow) : action.icon,
                tooltip: typeof action.tooltip === "function" ? action.tooltip(sanitizedRow) : action.tooltip
              }
            )), secondaryActions.length ? /* @__PURE__ */ React__default.createElement(Menu$1, null, /* @__PURE__ */ React__default.createElement(Menu$1.Trigger, null, /* @__PURE__ */ React__default.createElement(
              IconButton,
              {
                appearance: "discrete",
                icon: "ellipsis-vertical",
                "aria-label": texts.legacyTable.actions,
                tooltip: texts.legacyTable.actions,
                disabled: inlineEditing && !row.canEdit,
                onClick: (event) => {
                  event.stopPropagation();
                  row.setActive();
                }
              }
            )), /* @__PURE__ */ React__default.createElement(Menu$1.Content, null, secondaryActions.map((action, index2) => /* @__PURE__ */ React__default.createElement(
              Menu$1.Item,
              {
                key: index2,
                icon: typeof action.icon === "function" ? action.icon(sanitizedRow) : action.icon,
                ...getActionProps(action, sanitizedRow)
              },
              typeof action.text === "function" ? action.text(sanitizedRow) : action.text
            )))) : null);
            if (windowed) {
              return /* @__PURE__ */ React__default.createElement("div", { className: actionGroupClassName }, output);
            }
            return /* @__PURE__ */ React__default.createElement(InView, { rootMargin: "100px 0px" }, ({ inView, ref }) => /* @__PURE__ */ React__default.createElement("div", { className: actionGroupClassName, ref }, inView ? output : null));
          }
        }
      ]);
    }
  };
  plugin.pluginName = "useRowActions";
  return plugin;
};
const toggleBetween = (fromRowIndex, toRowIndex) => {
  const fromIndex = toRowIndex < fromRowIndex ? toRowIndex : fromRowIndex;
  const toIndex = toRowIndex > fromRowIndex ? toRowIndex : fromRowIndex;
  return [fromIndex, toIndex];
};
const useRowSelect = (onSelectedRows) => {
  const plugin = (hooks) => {
    reactTableExports.useRowSelect(hooks);
    if (onSelectedRows) {
      const toggleRowSelected = (indexPath, checked) => onSelectedRows((state) => {
        const nextState = { ...state };
        if (checked) {
          nextState[indexPath] = true;
        } else {
          delete nextState[indexPath];
        }
        return nextState;
      });
      const prepareRow2 = (row) => {
        row.toggleRowSelected = () => toggleRowSelected(row.id, !row.isSelected);
      };
      hooks.prepareRow.push(prepareRow2);
      const lastSelectedSortedIndex = React__default.useRef();
      hooks.visibleColumns.push((columns) => [
        {
          id: "selection",
          Header: ({ getToggleAllRowsSelectedProps, rows }) => {
            const { onChange: _, ...props } = getToggleAllRowsSelectedProps();
            const onChange = (checked) => {
              if (checked) {
                onSelectedRows(Object.assign({}, Array(rows.length).fill(true)));
              } else {
                onSelectedRows({});
              }
            };
            return /* @__PURE__ */ React__default.createElement(Checkbox$2, { ...props, onChange });
          },
          Cell: ({ row, rows }) => {
            const { onChange: _, ...props } = row.getToggleRowSelectedProps();
            const sortedIndex = rows.findIndex((r2) => r2.index === row.index);
            const onClick = (event) => {
              if (event.shiftKey) {
                const [fromIndex, toIndex] = toggleBetween(lastSelectedSortedIndex.current || 0, sortedIndex);
                for (let i3 = fromIndex; i3 <= toIndex; i3++) {
                  toggleRowSelected(rows[i3].id, true);
                }
              } else {
                toggleRowSelected(row.id, !props.checked);
              }
              lastSelectedSortedIndex.current = sortedIndex;
            };
            return /* @__PURE__ */ React__default.createElement(
              Checkbox$2,
              {
                ...props,
                className: "!mt-2.5",
                onClick,
                onChange: () => false
              }
            );
          },
          flex: "0 0 36px",
          className: "flex-col justify-start !py-0"
        },
        ...columns
      ]);
    }
  };
  plugin.pluginName = "useRowSelect";
  return plugin;
};
const useTableKeyboardNavigation = (props, rows, rowProps, ref) => {
  const useGlobalKeyboardNavigation = props.dangerouslyHijackGlobalKeyboardNavigation;
  const [activeIndex, setActiveIndex] = $71cd76cc60e0454e$export$6f32135080cb4c3$1({
    prop: props.activeIndex,
    defaultProp: props.defaultActiveIndex !== void 0 ? props.defaultActiveIndex : useGlobalKeyboardNavigation ? 0 : void 0,
    onChange: (index2) => {
      var _a;
      if (index2 !== void 0) {
        (_a = props.onChangeActiveIndex) == null ? void 0 : _a.call(props, index2);
      }
    }
  });
  const onKeyDown = (event) => {
    var _a, _b;
    const isModifierKeyPressed = event.metaKey || event.ctrlKey || event.altKey || event.shiftKey;
    if (useGlobalKeyboardNavigation && document.activeElement !== ref.current && ((_a = document.activeElement) == null ? void 0 : _a.getAttribute("type")) !== "search" && document.activeElement !== document.body && ((_b = document.activeElement) == null ? void 0 : _b.getAttribute("role")) !== "dialog") {
      return;
    }
    if (!useGlobalKeyboardNavigation && document.activeElement !== ref.current) {
      return;
    }
    if (activeIndex !== void 0) {
      const currentRow = rows[activeIndex];
      if (currentRow) {
        const sanitizedRow = sanitizeRowProps(currentRow, rowProps.rowExpansionRenderer);
        if (rowProps.onRowClick && event.key === "Enter") {
          event.preventDefault();
          rowProps.onRowClick(sanitizedRow);
          return;
        }
        if (currentRow.toggleRowSelected && event.key === " ") {
          event.preventDefault();
          currentRow.toggleRowSelected();
          return;
        }
        if (currentRow.toggleRowExpanded) {
          if (currentRow.isExpanded && event.key === "ArrowLeft") {
            event.preventDefault();
            currentRow.toggleRowExpanded();
            return;
          } else if (!currentRow.isExpanded && event.key === "ArrowRight") {
            event.preventDefault();
            currentRow.toggleRowExpanded();
            return;
          }
        }
        if (currentRow.toggleRowEditing) {
          if (currentRow.canEdit && !currentRow.isEditing) {
            if (rowProps.onRowCreate && event.shiftKey && event.key === "n") {
              event.preventDefault();
              if (!currentRow.isExpanded) {
                currentRow.toggleRowExpanded();
              }
              rowProps.onRowCreate(sanitizedRow, event);
              return;
            }
            if (event.key === "e") {
              event.preventDefault();
              currentRow.toggleRowEditing();
              return;
            }
          }
        }
        if (rowProps.onRowEdit && event.key === "e" && !isModifierKeyPressed) {
          event.preventDefault();
          rowProps.onRowEdit(sanitizedRow, event);
          return;
        }
        if (rowProps.onRowCopy && event.key === "c" && !isModifierKeyPressed) {
          event.preventDefault();
          rowProps.onRowCopy(sanitizedRow, event);
          return;
        }
        if (rowProps.onRowDelete && event.key === "Delete" && !isModifierKeyPressed) {
          event.preventDefault();
          rowProps.onRowDelete(sanitizedRow, event);
          return;
        }
      }
    }
    const nextIndex = getNextIndexFromKey(event.key, rows.length, activeIndex);
    if (nextIndex !== void 0) {
      event.preventDefault();
      setActiveIndex(nextIndex);
    }
  };
  const handleKeyDown = (event) => {
    if (!useGlobalKeyboardNavigation) {
      onKeyDown(event.nativeEvent);
    }
  };
  React__default.useEffect(() => {
    if (useGlobalKeyboardNavigation) {
      window.addEventListener("keydown", onKeyDown);
    }
    return () => {
      if (useGlobalKeyboardNavigation) {
        window.removeEventListener("keydown", onKeyDown);
      }
    };
  }, [onKeyDown]);
  const handleFocus = () => {
    if (activeIndex === void 0 && rows.length) {
      setActiveIndex(0);
    }
  };
  return [activeIndex, setActiveIndex, handleKeyDown, handleFocus];
};
const pluginName = "useRowDraggable";
reactTableExports.actions.resetRowDragging = "resetRowDragging";
reactTableExports.actions.toggleRowDragging = "toggleRowDragging";
function reducer$1(state, action) {
  if (action.type === reactTableExports.actions.init) {
    return {
      draggingRowIndexPath: null,
      ...state
    };
  }
  if (action.type === reactTableExports.actions.resetRowDragging) {
    return {
      ...state,
      draggingRowIndexPath: null
    };
  }
  if (action.type === reactTableExports.actions.toggleRowDragging) {
    const { indexPath } = action;
    return {
      ...state,
      draggingRowIndexPath: indexPath
    };
  }
  return state;
}
const prepareRow = (row, { instance }) => {
  var _a;
  row.toggleRowDragging = () => {
    if (instance.state.draggingRowIndexPath === row.id) {
      instance.dispatch({ type: reactTableExports.actions.resetRowDragging });
    } else {
      instance.dispatch({ type: reactTableExports.actions.toggleRowDragging, indexPath: row.id });
    }
  };
  if (instance.state.draggingRowIndexPath) {
    row.isDragging = instance.state.draggingRowIndexPath === row.id || !!((_a = instance.state.selectedRowIds) == null ? void 0 : _a[row.id]);
  } else {
    row.isDragging = false;
  }
};
const visibleColumns = (columns) => {
  return [
    {
      id: "draggable",
      className: "yt-table__cell--draggable flex-col px-0",
      Cell: () => /* @__PURE__ */ React__default.createElement(Icon$1, { name: "drag", className: "text-grey-700 invisible w-[20px] cursor-grab" }),
      flex: "0 0 20px"
    },
    ...columns
  ];
};
const getRowProps = (onRowDrag) => (props, { instance, row }) => {
  const onDragStart = (event) => {
    event.persist();
    row.toggleRowDragging();
    const indexPaths = [row.id, ...Object.keys(instance.state.selectedRowIds)];
    const data = instance.rows.filter((r2) => indexPaths.includes(r2.id)).map(sanitizeRowProps);
    const showPlaceholder = (placeholder) => {
      const element = window.document.createElement("div");
      element.id = "yt-table__drag__placeholder";
      element.innerText = placeholder;
      window.document.body.appendChild(element);
      if (typeof DataTransfer.prototype.setDragImage === "function") {
        event.dataTransfer.setDragImage(element, 0, 20);
      }
    };
    onRowDrag(data, showPlaceholder, event);
  };
  const onDragEnd = () => {
    const element = document.getElementById("yt-table__drag__placeholder");
    if (element && element.parentNode) {
      element.parentNode.removeChild(element);
    }
    row.toggleRowDragging();
  };
  return [
    props,
    {
      draggable: true,
      onDragStart,
      onDragEnd
    }
  ];
};
const useRowDraggable = (onRowDrag) => {
  const plugin = (hooks) => {
    if (onRowDrag) {
      hooks.stateReducers.push(reducer$1);
      hooks.prepareRow.push(prepareRow);
      hooks.visibleColumns.push(visibleColumns);
      hooks.getRowProps.push(getRowProps(onRowDrag));
    }
  };
  plugin.pluginName = pluginName;
  return plugin;
};
const useTableRowActive = (activeIndex, rows, rowExpansionRenderer, handleonRowActive) => {
  React__default.useEffect(() => {
    if (activeIndex !== void 0 && rows.length && handleonRowActive) {
      const focusedRow = rows[activeIndex];
      if (focusedRow) {
        const sanitizedFocusedRow = sanitizeRowProps(focusedRow, rowExpansionRenderer);
        handleonRowActive(sanitizedFocusedRow);
      }
    }
  }, [activeIndex, rows]);
};
const useTableInstance = (instance, ref) => {
  const sanitizedInstance = React__default.useMemo(
    () => ({
      toggleAllRowsExpanded: instance.toggleAllRowsExpanded,
      toggleHideAllColumns: instance.toggleHideAllColumns,
      toggleHideColumn: instance.toggleHideColumn,
      toggleEditing: instance.toggleEditing,
      toggleRowEditing: instance.toggleRowEditing,
      resetRowEditing: instance.resetRowEditing,
      toggleRowExpanded: instance.toggleRowExpanded,
      toggleSortBy: instance.toggleSortBy
    }),
    []
  );
  React__default.useEffect(() => {
    if (ref == null ? void 0 : ref.current) {
      ref.current.instance = sanitizedInstance;
    }
  }, [ref]);
  return sanitizedInstance;
};
const useTablePaginationListener = (disablePagination, onPaginate, state) => {
  React__default.useEffect(() => {
    if (!disablePagination && onPaginate) {
      onPaginate(state.pageIndex, state.pageSize);
    }
  }, [state.pageIndex, state.pageSize]);
};
const useTableSortingListener = (data, sortedRows, onSort, manualSorting, state) => {
  React__default.useEffect(() => {
    if (onSort) {
      const sortRules = state.sortBy.map((rule) => ({ accessor: rule.id, desc: rule.desc }));
      if (manualSorting) {
        onSort(sortRules);
      } else {
        let sortedData;
        if (sortRules.length && (sortedRows == null ? void 0 : sortedRows.length)) {
          sortedData = sortedRows.map((row) => row.original);
        }
        onSort(sortRules, sortedData || data);
      }
    }
  }, [onSort && JSON.stringify(state.sortBy), manualSorting]);
};
const DEFAULT_PAGE_SIZE = 10;
const useTable = (props, ref) => {
  const {
    children,
    data,
    dangerouslyHijackGlobalKeyboardNavigation: _,
    onRowClick,
    onRowDrag,
    onSelectedRows,
    rowClassName,
    rowExpansionRenderer,
    rowHeight,
    selectedRows,
    // sorting
    disableSorting,
    manualSorting,
    onSort,
    sortRules,
    //index
    activeIndex: _1,
    defaultActiveIndex: _2,
    onChangeActiveIndex: _3,
    // pagination
    disablePagination = true,
    length,
    onPaginate,
    pageSize = DEFAULT_PAGE_SIZE,
    pageIndex = 0,
    // row editing
    inlineEditingUniqueId = void 0,
    onRowCreate,
    // actions
    actions,
    onRowEdit,
    onRowCopy,
    onRowDelete,
    onRowActive,
    windowed = false,
    ...otherProps
  } = props;
  if (onSelectedRows && !selectedRows || !onSelectedRows && selectedRows) {
    throw new Error(
      "Selected rows in a Table component are fully controlled - you must pass both the `onSelectedRows` and `selectedRows` props when using row selection"
    );
  }
  const { texts, locale: locale2 } = useLocalization();
  const { columns, sortRules: defaultSortRules } = React__default.useMemo(
    () => getColumnsFromChildren(children, rowExpansionRenderer),
    [children, rowExpansionRenderer]
  );
  const manualPagination = !disablePagination && !!onPaginate && !!length;
  const {
    headerGroups,
    rows,
    sortedRows,
    prepareRow: prepareBaseRow,
    state,
    // pagination
    page,
    gotoPage,
    setPageSize,
    ...instance
  } = reactTableExports.useTable(
    {
      columns,
      data,
      initialState: {
        // @ts-expect-error: not sure how to type this correctly right now
        sortBy: getInternalSortRules(sortRules) || defaultSortRules,
        pageSize: !disablePagination ? pageSize : void 0,
        pageIndex: !disablePagination ? pageIndex : void 0
      },
      manualPagination,
      pageCount: manualPagination && length ? Math.ceil(length / pageSize) : -1,
      manualSortBy: manualSorting,
      disableSortBy: disableSorting,
      // most of these resets preventions are needed for editing mode
      autoResetExpanded: false,
      autoResetSelectedRows: false,
      autoResetSortBy: false,
      autoResetPage: false,
      sortTypes: React__default.useMemo(() => sortTypes(locale2), []),
      useControlledState: (currentState) => {
        return React__default.useMemo(
          () => ({
            ...currentState,
            selectedRowIds: selectedRows || []
          }),
          [currentState, selectedRows]
        );
      }
    },
    reactTableExports.useRowState,
    reactTableExports.useSortBy,
    reactTableExports.useExpanded,
    reactTableExports.usePagination,
    useRowSelect(onSelectedRows),
    useRowDraggable(onRowDrag),
    useRowEditing(inlineEditingUniqueId),
    useRowActions(
      inlineEditingUniqueId,
      { onRowCreate, onRowEdit, onRowCopy, onRowDelete },
      actions,
      rowExpansionRenderer,
      texts,
      windowed
    )
  );
  useTablePaginationListener(disablePagination, onPaginate, state);
  useTableSortingListener(data, sortedRows, onSort, !!manualSorting, state);
  const sanitizedInstance = useTableInstance(instance, ref);
  const visibleRows = !disablePagination && !manualPagination ? page : rows;
  const [activeIndex, setActiveIndex, handleKeyDown, handleFocus] = useTableKeyboardNavigation(
    props,
    visibleRows,
    { onRowClick, onRowCreate, onRowEdit, onRowCopy, onRowDelete, rowExpansionRenderer },
    ref
  );
  useTableRowActive(activeIndex, rows, rowExpansionRenderer, onRowActive);
  const prepareRow2 = React__default.useCallback(
    (row, index2) => {
      prepareBaseRow(row);
      row.setActive = () => setActiveIndex(index2);
    },
    [prepareBaseRow, setActiveIndex]
  );
  return {
    rowProps: {
      activeIndex,
      setActiveIndex,
      onRowClick,
      rowClassName,
      rowExpansionRenderer,
      rowHeight,
      inlineEditingUniqueId
    },
    tableProps: {
      ...otherProps,
      headerGroups,
      onFocus: handleFocus,
      onKeyDown: handleKeyDown,
      tabIndex: otherProps.tabIndex ?? 0
    },
    state,
    pagination: !disablePagination ? {
      length: manualPagination && length ? length : data.length,
      pageIndex: state.pageIndex,
      pageSize: state.pageSize,
      setPageIndex: gotoPage,
      setPageSize
    } : null,
    rows: visibleRows,
    prepareRow: prepareRow2,
    instance: sanitizedInstance
  };
};
const renderCell = (cell, row) => {
  const props = {
    ...cell.getCellProps(),
    className: clsx("yt-table__cell flex-1 truncate p-2 align-middle", cell.column.className, {
      "justify-start text-left": cell.column.align === "left",
      "justify-end text-right": cell.column.align === "right",
      "text-center": !cell.column.align
    }),
    style: {
      ...cell.column.style,
      flex: typeof cell.column.flex === "function" ? cell.column.flex(row) : cell.column.flex
    }
  };
  return /* @__PURE__ */ React__default.createElement("div", { ...props, role: "gridcell", "data-taco": "table-cell" }, cell.render("Cell") || null);
};
const Row$1 = React__default.forwardRef(function TableRow({ row, index: index2, instance, headerGroups, ...rowProps }, ref) {
  const {
    activeIndex,
    onRowClick,
    rowClassName,
    rowExpansionRenderer,
    rowHeight,
    setActiveIndex,
    style,
    inlineEditingUniqueId
  } = rowProps;
  const sanitizedRow = sanitizeRowProps(row, rowExpansionRenderer);
  const props = {
    ...row.getRowProps(),
    style: {
      ...style,
      minHeight: rowHeight ? `${rowHeight}px` : void 0,
      paddingLeft: row.depth ? `${row.depth * 2}rem` : void 0
    },
    className: clsx(
      "yt-table__row border-grey-300 flex border-b min-h-[2.5rem] hover:bg-grey-100",
      {
        "yt-table__row--active bg-grey-200 hover:bg-grey-200": activeIndex === index2,
        "yt-table__row--clickable": !!onRowClick,
        "yt-table__row--dragging": !!row.isDragging,
        "yt-table__row--editing": !!row.isEditing
      },
      typeof rowClassName === "function" ? rowClassName(sanitizedRow) : rowClassName
    ),
    onClick: onRowClick ? (event) => {
      if (event.target === event.currentTarget || event.target.classList.contains("yt-table__cell")) {
        event.preventDefault();
        event.persist();
        setActiveIndex(index2);
        onRowClick(sanitizedRow);
      }
    } : () => {
      setActiveIndex(index2);
    }
  };
  let cells = row.cells;
  if (row.depth > 0) {
    cells = row.cells.filter((cell) => !cell.column.hiddenOnSubRows);
  }
  const expandedRow = rowExpansionRenderer && row.isExpanded && /* @__PURE__ */ React__default.createElement("div", null, rowExpansionRenderer(sanitizedRow, instance));
  const rowContent = React__default.useMemo(() => {
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement($9bf71ea28793e738$export$20e40289641fbbb6, { key: row.original._createKey, contain: true, restoreFocus: true, autoFocus: true }, /* @__PURE__ */ React__default.createElement("div", { ...props, role: "row", ref }, /* @__PURE__ */ React__default.createElement("input", { type: "hidden", name: "_rowIndexPath", value: row.id }), /* @__PURE__ */ React__default.createElement("input", { type: "hidden", name: "_inlineEditingUniqueId", value: row.original[inlineEditingUniqueId] }), cells.map((cell) => renderCell(cell, sanitizedRow)))), expandedRow);
  }, [row.original._createKey]);
  if (row.isEditing) {
    return rowContent;
  }
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("div", { ...props, role: "row", ref }, cells.map((cell) => renderCell(cell, sanitizedRow))), expandedRow);
});
const Column$1 = ({ cell }) => {
  const props = {
    ...cell.getHeaderProps(),
    ...cell.getSortByToggleProps && cell.getSortByToggleProps({ title: void 0 }),
    className: clsx("yt-table__cell flex flex-1 truncate p-2 align-middle text-grey-700 hover:text-black", cell.className, {
      "yt-table__cell__group": !!cell.columns,
      "cursor-pointer": !cell.disableSorting,
      "justify-start text-left": cell.align === "left",
      "justify-end text-right": cell.align === "right",
      "justify-center text-center": cell.align === "center" || !cell.align
    }),
    style: { ...cell.style, flex: cell.flex }
  };
  if (cell.isSorted) {
    props["aria-sort"] = cell.isSortedDesc ? "descending" : "ascending";
  }
  return /* @__PURE__ */ React__default.createElement("div", { ...props, key: cell.id, "data-taco": "table-column" }, /* @__PURE__ */ React__default.createElement("span", { className: "truncate" }, cell.render("Header")), cell.isSorted ? /* @__PURE__ */ React__default.createElement(Icon$1, { name: cell.isSortedDesc ? "chevron-down-solid" : "chevron-up-solid", className: "-mt-0.5" }) : null);
};
const DefaultEmptyState = () => null;
const BaseTable = React__default.forwardRef(function BaseTable2(props, ref) {
  const tableRef = useMergedRef(ref);
  const { autoFocus, children, disableSorting: _, headerGroups, headerRef, bodyRef, ...otherProps } = props;
  React__default.useEffect(() => {
    if (autoFocus && tableRef.current) {
      tableRef.current.focus();
    }
  }, []);
  const className = clsx("yt-table flex flex-col focus:yt-focus focus:rounded-sm", props.className);
  return /* @__PURE__ */ React__default.createElement("div", { ...otherProps, role: "table", className, ref: tableRef }, /* @__PURE__ */ React__default.createElement("div", { role: "rowgroup", className: "yt-table__head", ref: headerRef }, headerGroups == null ? void 0 : headerGroups.map((headerGroup, index2) => /* @__PURE__ */ React__default.createElement(
    "div",
    {
      key: index2,
      role: "row",
      className: "border-grey-300 flex h-auto min-h-[2.5rem] w-full select-none border-b-2 border-t-0 font-bold"
    },
    headerGroup.headers.map((cell, index22) => /* @__PURE__ */ React__default.createElement(Column$1, { key: index22, index: index22, cell }))
  ))), /* @__PURE__ */ React__default.createElement("div", { role: "rowgroup", className: "yt-table__body", ref: bodyRef }, children));
});
const Table = React__default.forwardRef(function Table2(props, ref) {
  const { emptyStateRenderer = DefaultEmptyState, ...otherProps } = props;
  const tableRef = useMergedRef(ref);
  const { rowProps, tableProps, rows, prepareRow: prepareRow2, pagination, instance } = useTable(otherProps, tableRef);
  let paginationElement;
  if (pagination) {
    paginationElement = /* @__PURE__ */ React__default.createElement(
      Pagination,
      {
        className: "my-4 w-full",
        length: pagination.length,
        pageIndex: pagination.pageIndex,
        pageSize: pagination.pageSize,
        setPageIndex: pagination.setPageIndex,
        setPageSize: pagination.setPageSize,
        showPageControls: pagination.length > pagination.pageSize,
        dangerouslyHijackGlobalKeyboardNavigation: props.dangerouslyHijackGlobalKeyboardNavigation
      }
    );
  }
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, paginationElement, /* @__PURE__ */ React__default.createElement(BaseTable, { ...tableProps, ref: tableRef }, rows.length ? rows.map((row, index2) => {
    prepareRow2(row, index2);
    return /* @__PURE__ */ React__default.createElement(
      Row$1,
      {
        ...rowProps,
        key: index2,
        index: index2,
        row,
        instance,
        headerGroups: tableProps.headerGroups
      }
    );
  }) : emptyStateRenderer()), paginationElement);
});
Table.Column = () => null;
Table.Group = () => null;
const PaginatedTable = React__default.forwardRef(function PaginatedTable2(props, ref) {
  return /* @__PURE__ */ React__default.createElement(Table, { ...props, disablePagination: false, ref });
});
PaginatedTable.Column = () => null;
PaginatedTable.Group = () => null;
function _inheritsLoose(t3, o2) {
  t3.prototype = Object.create(o2.prototype), t3.prototype.constructor = t3, _setPrototypeOf$l(t3, o2);
}
var safeIsNaN = Number.isNaN || function ponyfill(value) {
  return typeof value === "number" && value !== value;
};
function isEqual$1(first, second2) {
  if (first === second2) {
    return true;
  }
  if (safeIsNaN(first) && safeIsNaN(second2)) {
    return true;
  }
  return false;
}
function areInputsEqual(newInputs, lastInputs) {
  if (newInputs.length !== lastInputs.length) {
    return false;
  }
  for (var i3 = 0; i3 < newInputs.length; i3++) {
    if (!isEqual$1(newInputs[i3], lastInputs[i3])) {
      return false;
    }
  }
  return true;
}
function memoizeOne(resultFn, isEqual2) {
  if (isEqual2 === void 0) {
    isEqual2 = areInputsEqual;
  }
  var lastThis;
  var lastArgs = [];
  var lastResult2;
  var calledOnce = false;
  function memoized() {
    var newArgs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      newArgs[_i] = arguments[_i];
    }
    if (calledOnce && lastThis === this && isEqual2(newArgs, lastArgs)) {
      return lastResult2;
    }
    lastResult2 = resultFn.apply(this, newArgs);
    calledOnce = true;
    lastThis = this;
    lastArgs = newArgs;
    return lastResult2;
  }
  return memoized;
}
function _objectWithoutPropertiesLoose$m(r2, e3) {
  if (null == r2) return {};
  var t3 = {};
  for (var n2 in r2) if ({}.hasOwnProperty.call(r2, n2)) {
    if (-1 !== e3.indexOf(n2)) continue;
    t3[n2] = r2[n2];
  }
  return t3;
}
var hasNativePerformanceNow = typeof performance === "object" && typeof performance.now === "function";
var now = hasNativePerformanceNow ? function() {
  return performance.now();
} : function() {
  return Date.now();
};
function cancelTimeout(timeoutID) {
  cancelAnimationFrame(timeoutID.id);
}
function requestTimeout(callback, delay) {
  var start = now();
  function tick() {
    if (now() - start >= delay) {
      callback.call(null);
    } else {
      timeoutID.id = requestAnimationFrame(tick);
    }
  }
  var timeoutID = {
    id: requestAnimationFrame(tick)
  };
  return timeoutID;
}
var size = -1;
function getScrollbarSize(recalculate) {
  if (recalculate === void 0) {
    recalculate = false;
  }
  if (size === -1 || recalculate) {
    var div = document.createElement("div");
    var style = div.style;
    style.width = "50px";
    style.height = "50px";
    style.overflow = "scroll";
    document.body.appendChild(div);
    size = div.offsetWidth - div.clientWidth;
    document.body.removeChild(div);
  }
  return size;
}
var cachedRTLResult = null;
function getRTLOffsetType(recalculate) {
  if (recalculate === void 0) {
    recalculate = false;
  }
  if (cachedRTLResult === null || recalculate) {
    var outerDiv = document.createElement("div");
    var outerStyle = outerDiv.style;
    outerStyle.width = "50px";
    outerStyle.height = "50px";
    outerStyle.overflow = "scroll";
    outerStyle.direction = "rtl";
    var innerDiv = document.createElement("div");
    var innerStyle = innerDiv.style;
    innerStyle.width = "100px";
    innerStyle.height = "100px";
    outerDiv.appendChild(innerDiv);
    document.body.appendChild(outerDiv);
    if (outerDiv.scrollLeft > 0) {
      cachedRTLResult = "positive-descending";
    } else {
      outerDiv.scrollLeft = 1;
      if (outerDiv.scrollLeft === 0) {
        cachedRTLResult = "negative";
      } else {
        cachedRTLResult = "positive-ascending";
      }
    }
    document.body.removeChild(outerDiv);
    return cachedRTLResult;
  }
  return cachedRTLResult;
}
if (process.env.NODE_ENV !== "production") ;
var IS_SCROLLING_DEBOUNCE_INTERVAL$1 = 150;
var defaultItemKey$1 = function defaultItemKey(index2, data) {
  return index2;
};
var devWarningsDirection = null;
var devWarningsTagName$1 = null;
if (process.env.NODE_ENV !== "production") {
  if (typeof window !== "undefined" && typeof window.WeakSet !== "undefined") {
    devWarningsDirection = /* @__PURE__ */ new WeakSet();
    devWarningsTagName$1 = /* @__PURE__ */ new WeakSet();
  }
}
function createListComponent(_ref) {
  var _class;
  var getItemOffset2 = _ref.getItemOffset, getEstimatedTotalSize3 = _ref.getEstimatedTotalSize, getItemSize2 = _ref.getItemSize, getOffsetForIndexAndAlignment2 = _ref.getOffsetForIndexAndAlignment, getStartIndexForOffset2 = _ref.getStartIndexForOffset, getStopIndexForStartIndex2 = _ref.getStopIndexForStartIndex, initInstanceProps2 = _ref.initInstanceProps, shouldResetStyleCacheOnItemSizeChange = _ref.shouldResetStyleCacheOnItemSizeChange, validateProps2 = _ref.validateProps;
  return _class = /* @__PURE__ */ function(_PureComponent) {
    _inheritsLoose(List2, _PureComponent);
    function List2(props) {
      var _this;
      _this = _PureComponent.call(this, props) || this;
      _this._instanceProps = initInstanceProps2(_this.props, _assertThisInitialized$l(_this));
      _this._outerRef = void 0;
      _this._resetIsScrollingTimeoutId = null;
      _this.state = {
        instance: _assertThisInitialized$l(_this),
        isScrolling: false,
        scrollDirection: "forward",
        scrollOffset: typeof _this.props.initialScrollOffset === "number" ? _this.props.initialScrollOffset : 0,
        scrollUpdateWasRequested: false
      };
      _this._callOnItemsRendered = void 0;
      _this._callOnItemsRendered = memoizeOne(function(overscanStartIndex, overscanStopIndex, visibleStartIndex, visibleStopIndex) {
        return _this.props.onItemsRendered({
          overscanStartIndex,
          overscanStopIndex,
          visibleStartIndex,
          visibleStopIndex
        });
      });
      _this._callOnScroll = void 0;
      _this._callOnScroll = memoizeOne(function(scrollDirection, scrollOffset, scrollUpdateWasRequested) {
        return _this.props.onScroll({
          scrollDirection,
          scrollOffset,
          scrollUpdateWasRequested
        });
      });
      _this._getItemStyle = void 0;
      _this._getItemStyle = function(index2) {
        var _this$props = _this.props, direction = _this$props.direction, itemSize = _this$props.itemSize, layout = _this$props.layout;
        var itemStyleCache = _this._getItemStyleCache(shouldResetStyleCacheOnItemSizeChange && itemSize, shouldResetStyleCacheOnItemSizeChange && layout, shouldResetStyleCacheOnItemSizeChange && direction);
        var style;
        if (itemStyleCache.hasOwnProperty(index2)) {
          style = itemStyleCache[index2];
        } else {
          var _offset = getItemOffset2(_this.props, index2, _this._instanceProps);
          var size2 = getItemSize2(_this.props, index2, _this._instanceProps);
          var isHorizontal = direction === "horizontal" || layout === "horizontal";
          var isRtl = direction === "rtl";
          var offsetHorizontal = isHorizontal ? _offset : 0;
          itemStyleCache[index2] = style = {
            position: "absolute",
            left: isRtl ? void 0 : offsetHorizontal,
            right: isRtl ? offsetHorizontal : void 0,
            top: !isHorizontal ? _offset : 0,
            height: !isHorizontal ? size2 : "100%",
            width: isHorizontal ? size2 : "100%"
          };
        }
        return style;
      };
      _this._getItemStyleCache = void 0;
      _this._getItemStyleCache = memoizeOne(function(_, __, ___) {
        return {};
      });
      _this._onScrollHorizontal = function(event) {
        var _event$currentTarget = event.currentTarget, clientWidth = _event$currentTarget.clientWidth, scrollLeft = _event$currentTarget.scrollLeft, scrollWidth = _event$currentTarget.scrollWidth;
        _this.setState(function(prevState) {
          if (prevState.scrollOffset === scrollLeft) {
            return null;
          }
          var direction = _this.props.direction;
          var scrollOffset = scrollLeft;
          if (direction === "rtl") {
            switch (getRTLOffsetType()) {
              case "negative":
                scrollOffset = -scrollLeft;
                break;
              case "positive-descending":
                scrollOffset = scrollWidth - clientWidth - scrollLeft;
                break;
            }
          }
          scrollOffset = Math.max(0, Math.min(scrollOffset, scrollWidth - clientWidth));
          return {
            isScrolling: true,
            scrollDirection: prevState.scrollOffset < scrollOffset ? "forward" : "backward",
            scrollOffset,
            scrollUpdateWasRequested: false
          };
        }, _this._resetIsScrollingDebounced);
      };
      _this._onScrollVertical = function(event) {
        var _event$currentTarget2 = event.currentTarget, clientHeight = _event$currentTarget2.clientHeight, scrollHeight = _event$currentTarget2.scrollHeight, scrollTop = _event$currentTarget2.scrollTop;
        _this.setState(function(prevState) {
          if (prevState.scrollOffset === scrollTop) {
            return null;
          }
          var scrollOffset = Math.max(0, Math.min(scrollTop, scrollHeight - clientHeight));
          return {
            isScrolling: true,
            scrollDirection: prevState.scrollOffset < scrollOffset ? "forward" : "backward",
            scrollOffset,
            scrollUpdateWasRequested: false
          };
        }, _this._resetIsScrollingDebounced);
      };
      _this._outerRefSetter = function(ref) {
        var outerRef = _this.props.outerRef;
        _this._outerRef = ref;
        if (typeof outerRef === "function") {
          outerRef(ref);
        } else if (outerRef != null && typeof outerRef === "object" && outerRef.hasOwnProperty("current")) {
          outerRef.current = ref;
        }
      };
      _this._resetIsScrollingDebounced = function() {
        if (_this._resetIsScrollingTimeoutId !== null) {
          cancelTimeout(_this._resetIsScrollingTimeoutId);
        }
        _this._resetIsScrollingTimeoutId = requestTimeout(_this._resetIsScrolling, IS_SCROLLING_DEBOUNCE_INTERVAL$1);
      };
      _this._resetIsScrolling = function() {
        _this._resetIsScrollingTimeoutId = null;
        _this.setState({
          isScrolling: false
        }, function() {
          _this._getItemStyleCache(-1, null);
        });
      };
      return _this;
    }
    List2.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
      validateSharedProps$1(nextProps, prevState);
      validateProps2(nextProps);
      return null;
    };
    var _proto = List2.prototype;
    _proto.scrollTo = function scrollTo2(scrollOffset) {
      scrollOffset = Math.max(0, scrollOffset);
      this.setState(function(prevState) {
        if (prevState.scrollOffset === scrollOffset) {
          return null;
        }
        return {
          scrollDirection: prevState.scrollOffset < scrollOffset ? "forward" : "backward",
          scrollOffset,
          scrollUpdateWasRequested: true
        };
      }, this._resetIsScrollingDebounced);
    };
    _proto.scrollToItem = function scrollToItem(index2, align) {
      if (align === void 0) {
        align = "auto";
      }
      var _this$props2 = this.props, itemCount = _this$props2.itemCount, layout = _this$props2.layout;
      var scrollOffset = this.state.scrollOffset;
      index2 = Math.max(0, Math.min(index2, itemCount - 1));
      var scrollbarSize = 0;
      if (this._outerRef) {
        var outerRef = this._outerRef;
        if (layout === "vertical") {
          scrollbarSize = outerRef.scrollWidth > outerRef.clientWidth ? getScrollbarSize() : 0;
        } else {
          scrollbarSize = outerRef.scrollHeight > outerRef.clientHeight ? getScrollbarSize() : 0;
        }
      }
      this.scrollTo(getOffsetForIndexAndAlignment2(this.props, index2, align, scrollOffset, this._instanceProps, scrollbarSize));
    };
    _proto.componentDidMount = function componentDidMount() {
      var _this$props3 = this.props, direction = _this$props3.direction, initialScrollOffset = _this$props3.initialScrollOffset, layout = _this$props3.layout;
      if (typeof initialScrollOffset === "number" && this._outerRef != null) {
        var outerRef = this._outerRef;
        if (direction === "horizontal" || layout === "horizontal") {
          outerRef.scrollLeft = initialScrollOffset;
        } else {
          outerRef.scrollTop = initialScrollOffset;
        }
      }
      this._callPropsCallbacks();
    };
    _proto.componentDidUpdate = function componentDidUpdate() {
      var _this$props4 = this.props, direction = _this$props4.direction, layout = _this$props4.layout;
      var _this$state = this.state, scrollOffset = _this$state.scrollOffset, scrollUpdateWasRequested = _this$state.scrollUpdateWasRequested;
      if (scrollUpdateWasRequested && this._outerRef != null) {
        var outerRef = this._outerRef;
        if (direction === "horizontal" || layout === "horizontal") {
          if (direction === "rtl") {
            switch (getRTLOffsetType()) {
              case "negative":
                outerRef.scrollLeft = -scrollOffset;
                break;
              case "positive-ascending":
                outerRef.scrollLeft = scrollOffset;
                break;
              default:
                var clientWidth = outerRef.clientWidth, scrollWidth = outerRef.scrollWidth;
                outerRef.scrollLeft = scrollWidth - clientWidth - scrollOffset;
                break;
            }
          } else {
            outerRef.scrollLeft = scrollOffset;
          }
        } else {
          outerRef.scrollTop = scrollOffset;
        }
      }
      this._callPropsCallbacks();
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
      if (this._resetIsScrollingTimeoutId !== null) {
        cancelTimeout(this._resetIsScrollingTimeoutId);
      }
    };
    _proto.render = function render() {
      var _this$props5 = this.props, children = _this$props5.children, className = _this$props5.className, direction = _this$props5.direction, height = _this$props5.height, innerRef = _this$props5.innerRef, innerElementType = _this$props5.innerElementType, innerTagName = _this$props5.innerTagName, itemCount = _this$props5.itemCount, itemData = _this$props5.itemData, _this$props5$itemKey = _this$props5.itemKey, itemKey = _this$props5$itemKey === void 0 ? defaultItemKey$1 : _this$props5$itemKey, layout = _this$props5.layout, outerElementType = _this$props5.outerElementType, outerTagName = _this$props5.outerTagName, style = _this$props5.style, useIsScrolling = _this$props5.useIsScrolling, width = _this$props5.width;
      var isScrolling = this.state.isScrolling;
      var isHorizontal = direction === "horizontal" || layout === "horizontal";
      var onScroll = isHorizontal ? this._onScrollHorizontal : this._onScrollVertical;
      var _this$_getRangeToRend = this._getRangeToRender(), startIndex = _this$_getRangeToRend[0], stopIndex = _this$_getRangeToRend[1];
      var items = [];
      if (itemCount > 0) {
        for (var _index = startIndex; _index <= stopIndex; _index++) {
          items.push(createElement(children, {
            data: itemData,
            key: itemKey(_index, itemData),
            index: _index,
            isScrolling: useIsScrolling ? isScrolling : void 0,
            style: this._getItemStyle(_index)
          }));
        }
      }
      var estimatedTotalSize = getEstimatedTotalSize3(this.props, this._instanceProps);
      return createElement(outerElementType || outerTagName || "div", {
        className,
        onScroll,
        ref: this._outerRefSetter,
        style: _extends$z({
          position: "relative",
          height,
          width,
          overflow: "auto",
          WebkitOverflowScrolling: "touch",
          willChange: "transform",
          direction
        }, style)
      }, createElement(innerElementType || innerTagName || "div", {
        children: items,
        ref: innerRef,
        style: {
          height: isHorizontal ? "100%" : estimatedTotalSize,
          pointerEvents: isScrolling ? "none" : void 0,
          width: isHorizontal ? estimatedTotalSize : "100%"
        }
      }));
    };
    _proto._callPropsCallbacks = function _callPropsCallbacks() {
      if (typeof this.props.onItemsRendered === "function") {
        var itemCount = this.props.itemCount;
        if (itemCount > 0) {
          var _this$_getRangeToRend2 = this._getRangeToRender(), _overscanStartIndex = _this$_getRangeToRend2[0], _overscanStopIndex = _this$_getRangeToRend2[1], _visibleStartIndex = _this$_getRangeToRend2[2], _visibleStopIndex = _this$_getRangeToRend2[3];
          this._callOnItemsRendered(_overscanStartIndex, _overscanStopIndex, _visibleStartIndex, _visibleStopIndex);
        }
      }
      if (typeof this.props.onScroll === "function") {
        var _this$state2 = this.state, _scrollDirection = _this$state2.scrollDirection, _scrollOffset = _this$state2.scrollOffset, _scrollUpdateWasRequested = _this$state2.scrollUpdateWasRequested;
        this._callOnScroll(_scrollDirection, _scrollOffset, _scrollUpdateWasRequested);
      }
    };
    _proto._getRangeToRender = function _getRangeToRender() {
      var _this$props6 = this.props, itemCount = _this$props6.itemCount, overscanCount = _this$props6.overscanCount;
      var _this$state3 = this.state, isScrolling = _this$state3.isScrolling, scrollDirection = _this$state3.scrollDirection, scrollOffset = _this$state3.scrollOffset;
      if (itemCount === 0) {
        return [0, 0, 0, 0];
      }
      var startIndex = getStartIndexForOffset2(this.props, scrollOffset, this._instanceProps);
      var stopIndex = getStopIndexForStartIndex2(this.props, startIndex, scrollOffset, this._instanceProps);
      var overscanBackward = !isScrolling || scrollDirection === "backward" ? Math.max(1, overscanCount) : 1;
      var overscanForward = !isScrolling || scrollDirection === "forward" ? Math.max(1, overscanCount) : 1;
      return [Math.max(0, startIndex - overscanBackward), Math.max(0, Math.min(itemCount - 1, stopIndex + overscanForward)), startIndex, stopIndex];
    };
    return List2;
  }(PureComponent), _class.defaultProps = {
    direction: "ltr",
    itemData: void 0,
    layout: "vertical",
    overscanCount: 2,
    useIsScrolling: false
  }, _class;
}
var validateSharedProps$1 = function validateSharedProps(_ref2, _ref3) {
  var children = _ref2.children, direction = _ref2.direction, height = _ref2.height, layout = _ref2.layout, innerTagName = _ref2.innerTagName, outerTagName = _ref2.outerTagName, width = _ref2.width;
  var instance = _ref3.instance;
  if (process.env.NODE_ENV !== "production") {
    if (innerTagName != null || outerTagName != null) {
      if (devWarningsTagName$1 && !devWarningsTagName$1.has(instance)) {
        devWarningsTagName$1.add(instance);
        console.warn("The innerTagName and outerTagName props have been deprecated. Please use the innerElementType and outerElementType props instead.");
      }
    }
    var isHorizontal = direction === "horizontal" || layout === "horizontal";
    switch (direction) {
      case "horizontal":
      case "vertical":
        if (devWarningsDirection && !devWarningsDirection.has(instance)) {
          devWarningsDirection.add(instance);
          console.warn('The direction prop should be either "ltr" (default) or "rtl". Please use the layout prop to specify "vertical" (default) or "horizontal" orientation.');
        }
        break;
      case "ltr":
      case "rtl":
        break;
      default:
        throw Error('An invalid "direction" prop has been specified. Value should be either "ltr" or "rtl". ' + ('"' + direction + '" was specified.'));
    }
    switch (layout) {
      case "horizontal":
      case "vertical":
        break;
      default:
        throw Error('An invalid "layout" prop has been specified. Value should be either "horizontal" or "vertical". ' + ('"' + layout + '" was specified.'));
    }
    if (children == null) {
      throw Error('An invalid "children" prop has been specified. Value should be a React component. ' + ('"' + (children === null ? "null" : typeof children) + '" was specified.'));
    }
    if (isHorizontal && typeof width !== "number") {
      throw Error('An invalid "width" prop has been specified. Horizontal lists must specify a number for width. ' + ('"' + (width === null ? "null" : typeof width) + '" was specified.'));
    } else if (!isHorizontal && typeof height !== "number") {
      throw Error('An invalid "height" prop has been specified. Vertical lists must specify a number for height. ' + ('"' + (height === null ? "null" : typeof height) + '" was specified.'));
    }
  }
};
var DEFAULT_ESTIMATED_ITEM_SIZE$1 = 50;
var getItemMetadata$1 = function getItemMetadata(props, index2, instanceProps) {
  var _ref = props, itemSize = _ref.itemSize;
  var itemMetadataMap = instanceProps.itemMetadataMap, lastMeasuredIndex = instanceProps.lastMeasuredIndex;
  if (index2 > lastMeasuredIndex) {
    var offset2 = 0;
    if (lastMeasuredIndex >= 0) {
      var itemMetadata = itemMetadataMap[lastMeasuredIndex];
      offset2 = itemMetadata.offset + itemMetadata.size;
    }
    for (var i3 = lastMeasuredIndex + 1; i3 <= index2; i3++) {
      var size2 = itemSize(i3);
      itemMetadataMap[i3] = {
        offset: offset2,
        size: size2
      };
      offset2 += size2;
    }
    instanceProps.lastMeasuredIndex = index2;
  }
  return itemMetadataMap[index2];
};
var findNearestItem$1 = function findNearestItem(props, instanceProps, offset2) {
  var itemMetadataMap = instanceProps.itemMetadataMap, lastMeasuredIndex = instanceProps.lastMeasuredIndex;
  var lastMeasuredItemOffset = lastMeasuredIndex > 0 ? itemMetadataMap[lastMeasuredIndex].offset : 0;
  if (lastMeasuredItemOffset >= offset2) {
    return findNearestItemBinarySearch$1(props, instanceProps, lastMeasuredIndex, 0, offset2);
  } else {
    return findNearestItemExponentialSearch$1(props, instanceProps, Math.max(0, lastMeasuredIndex), offset2);
  }
};
var findNearestItemBinarySearch$1 = function findNearestItemBinarySearch(props, instanceProps, high, low, offset2) {
  while (low <= high) {
    var middle = low + Math.floor((high - low) / 2);
    var currentOffset = getItemMetadata$1(props, middle, instanceProps).offset;
    if (currentOffset === offset2) {
      return middle;
    } else if (currentOffset < offset2) {
      low = middle + 1;
    } else if (currentOffset > offset2) {
      high = middle - 1;
    }
  }
  if (low > 0) {
    return low - 1;
  } else {
    return 0;
  }
};
var findNearestItemExponentialSearch$1 = function findNearestItemExponentialSearch(props, instanceProps, index2, offset2) {
  var itemCount = props.itemCount;
  var interval = 1;
  while (index2 < itemCount && getItemMetadata$1(props, index2, instanceProps).offset < offset2) {
    index2 += interval;
    interval *= 2;
  }
  return findNearestItemBinarySearch$1(props, instanceProps, Math.min(index2, itemCount - 1), Math.floor(index2 / 2), offset2);
};
var getEstimatedTotalSize = function getEstimatedTotalSize2(_ref2, _ref3) {
  var itemCount = _ref2.itemCount;
  var itemMetadataMap = _ref3.itemMetadataMap, estimatedItemSize = _ref3.estimatedItemSize, lastMeasuredIndex = _ref3.lastMeasuredIndex;
  var totalSizeOfMeasuredItems = 0;
  if (lastMeasuredIndex >= itemCount) {
    lastMeasuredIndex = itemCount - 1;
  }
  if (lastMeasuredIndex >= 0) {
    var itemMetadata = itemMetadataMap[lastMeasuredIndex];
    totalSizeOfMeasuredItems = itemMetadata.offset + itemMetadata.size;
  }
  var numUnmeasuredItems = itemCount - lastMeasuredIndex - 1;
  var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedItemSize;
  return totalSizeOfMeasuredItems + totalSizeOfUnmeasuredItems;
};
var VariableSizeList = /* @__PURE__ */ createListComponent({
  getItemOffset: function getItemOffset(props, index2, instanceProps) {
    return getItemMetadata$1(props, index2, instanceProps).offset;
  },
  getItemSize: function getItemSize(props, index2, instanceProps) {
    return instanceProps.itemMetadataMap[index2].size;
  },
  getEstimatedTotalSize,
  getOffsetForIndexAndAlignment: function getOffsetForIndexAndAlignment(props, index2, align, scrollOffset, instanceProps, scrollbarSize) {
    var direction = props.direction, height = props.height, layout = props.layout, width = props.width;
    var isHorizontal = direction === "horizontal" || layout === "horizontal";
    var size2 = isHorizontal ? width : height;
    var itemMetadata = getItemMetadata$1(props, index2, instanceProps);
    var estimatedTotalSize = getEstimatedTotalSize(props, instanceProps);
    var maxOffset = Math.max(0, Math.min(estimatedTotalSize - size2, itemMetadata.offset));
    var minOffset = Math.max(0, itemMetadata.offset - size2 + itemMetadata.size + scrollbarSize);
    if (align === "smart") {
      if (scrollOffset >= minOffset - size2 && scrollOffset <= maxOffset + size2) {
        align = "auto";
      } else {
        align = "center";
      }
    }
    switch (align) {
      case "start":
        return maxOffset;
      case "end":
        return minOffset;
      case "center":
        return Math.round(minOffset + (maxOffset - minOffset) / 2);
      case "auto":
      default:
        if (scrollOffset >= minOffset && scrollOffset <= maxOffset) {
          return scrollOffset;
        } else if (scrollOffset < minOffset) {
          return minOffset;
        } else {
          return maxOffset;
        }
    }
  },
  getStartIndexForOffset: function getStartIndexForOffset(props, offset2, instanceProps) {
    return findNearestItem$1(props, instanceProps, offset2);
  },
  getStopIndexForStartIndex: function getStopIndexForStartIndex(props, startIndex, scrollOffset, instanceProps) {
    var direction = props.direction, height = props.height, itemCount = props.itemCount, layout = props.layout, width = props.width;
    var isHorizontal = direction === "horizontal" || layout === "horizontal";
    var size2 = isHorizontal ? width : height;
    var itemMetadata = getItemMetadata$1(props, startIndex, instanceProps);
    var maxOffset = scrollOffset + size2;
    var offset2 = itemMetadata.offset + itemMetadata.size;
    var stopIndex = startIndex;
    while (stopIndex < itemCount - 1 && offset2 < maxOffset) {
      stopIndex++;
      offset2 += getItemMetadata$1(props, stopIndex, instanceProps).size;
    }
    return stopIndex;
  },
  initInstanceProps: function initInstanceProps(props, instance) {
    var _ref4 = props, estimatedItemSize = _ref4.estimatedItemSize;
    var instanceProps = {
      itemMetadataMap: {},
      estimatedItemSize: estimatedItemSize || DEFAULT_ESTIMATED_ITEM_SIZE$1,
      lastMeasuredIndex: -1
    };
    instance.resetAfterIndex = function(index2, shouldForceUpdate) {
      if (shouldForceUpdate === void 0) {
        shouldForceUpdate = true;
      }
      instanceProps.lastMeasuredIndex = Math.min(instanceProps.lastMeasuredIndex, index2 - 1);
      instance._getItemStyleCache(-1);
      if (shouldForceUpdate) {
        instance.forceUpdate();
      }
    };
    return instanceProps;
  },
  shouldResetStyleCacheOnItemSizeChange: false,
  validateProps: function validateProps(_ref5) {
    var itemSize = _ref5.itemSize;
    if (process.env.NODE_ENV !== "production") {
      if (typeof itemSize !== "function") {
        throw Error('An invalid "itemSize" prop has been specified. Value should be a function. ' + ('"' + (itemSize === null ? "null" : typeof itemSize) + '" was specified.'));
      }
    }
  }
});
function shallowDiffers(prev, next) {
  for (var attribute in prev) {
    if (!(attribute in next)) {
      return true;
    }
  }
  for (var _attribute in next) {
    if (prev[_attribute] !== next[_attribute]) {
      return true;
    }
  }
  return false;
}
var _excluded$m = ["style"], _excluded2$9 = ["style"];
function areEqual(prevProps, nextProps) {
  var prevStyle = prevProps.style, prevRest = _objectWithoutPropertiesLoose$m(prevProps, _excluded$m);
  var nextStyle = nextProps.style, nextRest = _objectWithoutPropertiesLoose$m(nextProps, _excluded2$9);
  return !shallowDiffers(prevStyle, nextStyle) && !shallowDiffers(prevRest, nextRest);
}
function isInteger(value) {
  return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
}
function isRangeVisible(_ref) {
  var lastRenderedStartIndex = _ref.lastRenderedStartIndex, lastRenderedStopIndex = _ref.lastRenderedStopIndex, startIndex = _ref.startIndex, stopIndex = _ref.stopIndex;
  return !(startIndex > lastRenderedStopIndex || stopIndex < lastRenderedStartIndex);
}
function scanForUnloadedRanges(_ref) {
  var isItemLoaded = _ref.isItemLoaded, itemCount = _ref.itemCount, minimumBatchSize = _ref.minimumBatchSize, startIndex = _ref.startIndex, stopIndex = _ref.stopIndex;
  var unloadedRanges = [];
  var rangeStartIndex = null;
  var rangeStopIndex = null;
  for (var _index = startIndex; _index <= stopIndex; _index++) {
    var loaded = isItemLoaded(_index);
    if (!loaded) {
      rangeStopIndex = _index;
      if (rangeStartIndex === null) {
        rangeStartIndex = _index;
      }
    } else if (rangeStopIndex !== null) {
      unloadedRanges.push(rangeStartIndex, rangeStopIndex);
      rangeStartIndex = rangeStopIndex = null;
    }
  }
  if (rangeStopIndex !== null) {
    var potentialStopIndex = Math.min(Math.max(rangeStopIndex, rangeStartIndex + minimumBatchSize - 1), itemCount - 1);
    for (var _index2 = rangeStopIndex + 1; _index2 <= potentialStopIndex; _index2++) {
      if (!isItemLoaded(_index2)) {
        rangeStopIndex = _index2;
      } else {
        break;
      }
    }
    unloadedRanges.push(rangeStartIndex, rangeStopIndex);
  }
  if (unloadedRanges.length) {
    while (unloadedRanges[1] - unloadedRanges[0] + 1 < minimumBatchSize && unloadedRanges[0] > 0) {
      var _index3 = unloadedRanges[0] - 1;
      if (!isItemLoaded(_index3)) {
        unloadedRanges[0] = _index3;
      } else {
        break;
      }
    }
  }
  return unloadedRanges;
}
var classCallCheck$1 = function(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};
var createClass$1 = /* @__PURE__ */ function() {
  function defineProperties(target, props) {
    for (var i3 = 0; i3 < props.length; i3++) {
      var descriptor = props[i3];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var inherits = function(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var possibleConstructorReturn = function(self2, call) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self2;
};
var InfiniteLoader = function(_PureComponent) {
  inherits(InfiniteLoader2, _PureComponent);
  function InfiniteLoader2() {
    var _ref;
    var _temp, _this, _ret;
    classCallCheck$1(this, InfiniteLoader2);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = InfiniteLoader2.__proto__ || Object.getPrototypeOf(InfiniteLoader2)).call.apply(_ref, [this].concat(args))), _this), _this._lastRenderedStartIndex = -1, _this._lastRenderedStopIndex = -1, _this._memoizedUnloadedRanges = [], _this._onItemsRendered = function(_ref2) {
      var visibleStartIndex = _ref2.visibleStartIndex, visibleStopIndex = _ref2.visibleStopIndex;
      if (process.env.NODE_ENV !== "production") {
        if (!isInteger(visibleStartIndex) || !isInteger(visibleStopIndex)) {
          console.warn("Invalid onItemsRendered signature; please refer to InfiniteLoader documentation.");
        }
        if (typeof _this.props.loadMoreRows === "function") {
          console.warn('InfiniteLoader "loadMoreRows" prop has been renamed to "loadMoreItems".');
        }
      }
      _this._lastRenderedStartIndex = visibleStartIndex;
      _this._lastRenderedStopIndex = visibleStopIndex;
      _this._ensureRowsLoaded(visibleStartIndex, visibleStopIndex);
    }, _this._setRef = function(listRef) {
      _this._listRef = listRef;
    }, _temp), possibleConstructorReturn(_this, _ret);
  }
  createClass$1(InfiniteLoader2, [{
    key: "resetloadMoreItemsCache",
    value: function resetloadMoreItemsCache() {
      var autoReload = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
      this._memoizedUnloadedRanges = [];
      if (autoReload) {
        this._ensureRowsLoaded(this._lastRenderedStartIndex, this._lastRenderedStopIndex);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (process.env.NODE_ENV !== "production") {
        if (this._listRef == null) {
          console.warn("Invalid list ref; please refer to InfiniteLoader documentation.");
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return children({
        onItemsRendered: this._onItemsRendered,
        ref: this._setRef
      });
    }
  }, {
    key: "_ensureRowsLoaded",
    value: function _ensureRowsLoaded(startIndex, stopIndex) {
      var _props = this.props, isItemLoaded = _props.isItemLoaded, itemCount = _props.itemCount, _props$minimumBatchSi = _props.minimumBatchSize, minimumBatchSize = _props$minimumBatchSi === void 0 ? 10 : _props$minimumBatchSi, _props$threshold = _props.threshold, threshold2 = _props$threshold === void 0 ? 15 : _props$threshold;
      var unloadedRanges = scanForUnloadedRanges({
        isItemLoaded,
        itemCount,
        minimumBatchSize,
        startIndex: Math.max(0, startIndex - threshold2),
        stopIndex: Math.min(itemCount - 1, stopIndex + threshold2)
      });
      if (this._memoizedUnloadedRanges.length !== unloadedRanges.length || this._memoizedUnloadedRanges.some(function(startOrStop, index2) {
        return unloadedRanges[index2] !== startOrStop;
      })) {
        this._memoizedUnloadedRanges = unloadedRanges;
        this._loadUnloadedRanges(unloadedRanges);
      }
    }
  }, {
    key: "_loadUnloadedRanges",
    value: function _loadUnloadedRanges(unloadedRanges) {
      var _this2 = this;
      var loadMoreItems = this.props.loadMoreItems || this.props.loadMoreRows;
      var _loop = function _loop2(i4) {
        var startIndex = unloadedRanges[i4];
        var stopIndex = unloadedRanges[i4 + 1];
        var promise = loadMoreItems(startIndex, stopIndex);
        if (promise != null) {
          promise.then(function() {
            if (isRangeVisible({
              lastRenderedStartIndex: _this2._lastRenderedStartIndex,
              lastRenderedStopIndex: _this2._lastRenderedStopIndex,
              startIndex,
              stopIndex
            })) {
              if (_this2._listRef == null) {
                return;
              }
              if (typeof _this2._listRef.resetAfterIndex === "function") {
                _this2._listRef.resetAfterIndex(startIndex, true);
              } else {
                if (typeof _this2._listRef._getItemStyleCache === "function") {
                  _this2._listRef._getItemStyleCache(-1);
                }
                _this2._listRef.forceUpdate();
              }
            }
          });
        }
      };
      for (var i3 = 0; i3 < unloadedRanges.length; i3 += 2) {
        _loop(i3);
      }
    }
  }]);
  return InfiniteLoader2;
}(PureComponent);
const ROW_HEIGHT = 40;
const VariableRow = React__default.memo(({ data, index: index2, style: { height: _, ...style } }) => {
  const { texts } = useLocalization();
  const { rows, setRowHeight, rowProps, tableProps, instance, prepareRow: prepareRow2, rowHeights } = data;
  const row = rows[index2];
  const ref = React__default.useRef(null);
  React__default.useEffect(() => {
    if (ref == null ? void 0 : ref.current) {
      setRowHeight(index2, ref.current.getBoundingClientRect().height);
    }
  }, [rowHeights[index2]]);
  if (row) {
    prepareRow2(row, index2);
    return /* @__PURE__ */ React__default.createElement(
      Row$1,
      {
        ...rowProps,
        style,
        key: index2,
        index: index2,
        row,
        instance,
        headerGroups: tableProps.headerGroups,
        setRowHeight,
        ref
      }
    );
  }
  return /* @__PURE__ */ React__default.createElement("div", { className: "yt-table__row", role: "row", style }, /* @__PURE__ */ React__default.createElement("div", { className: "yt-table__cell text-grey-300" }, texts.legacyTable.loading));
}, areEqual);
const getAverageRowHeight = (rowHeights = {}) => {
  const keys2 = Object.keys(rowHeights);
  const estimatedHeight = keys2.reduce((p2, i3) => p2 + rowHeights[i3], 0);
  return estimatedHeight / keys2.length;
};
const WindowedTable = React__default.forwardRef(function WindowedTable2(props, ref) {
  const tableRef = useMergedRef(ref);
  const { emptyStateRenderer = DefaultEmptyState, length, loadMore, ...otherProps } = props;
  const { rowProps, tableProps, rows, prepareRow: prepareRow2, instance, state } = useTable({ ...otherProps, windowed: true }, tableRef);
  const headerRef = React__default.useRef(null);
  const [rowsRef, setRowsRef] = React__default.useState(null);
  const tableDimensions = useBoundingClientRectListener(tableRef);
  const headerDimensions = useBoundingClientRectListener(headerRef);
  const height = tableDimensions && headerDimensions ? tableDimensions.height - headerDimensions.height : null;
  const estimatedRowHeight = rowProps.rowHeight || ROW_HEIGHT;
  const rowHeights = React__default.useRef({});
  const setRowHeight = React__default.useCallback((index2, size2) => {
    if (rowHeights.current[index2] !== size2) {
      rowHeights.current = {
        ...rowHeights.current,
        [index2]: size2
      };
      if (rowsRef) {
        rowsRef.resetAfterIndex(0);
      }
    }
  }, []);
  const getRowHeight = React__default.useCallback((index2) => rowHeights.current[index2] || estimatedRowHeight, []);
  React__default.useEffect(() => {
    if (rowsRef && rowProps.activeIndex !== void 0) {
      rowsRef.scrollToItem(rowProps.activeIndex, "start");
    }
  }, [rowsRef, rowProps.activeIndex]);
  React__default.useEffect(() => {
    rowHeights.current = {};
    if (rowsRef) {
      rowsRef.resetAfterIndex(0);
    }
  }, [rows.length]);
  const contentHeight = estimatedRowHeight * props.data.length || 0;
  const isScrollbarVisible = height !== null ? contentHeight > height : false;
  const className = clsx(tableProps.className, "yt-table--windowed", { "table-with-scrollbar": isScrollbarVisible });
  let list;
  const itemData = {
    rows,
    setRowHeight,
    rowProps,
    tableProps,
    instance,
    prepareRow: prepareRow2,
    state,
    rowHeights: rowHeights.current
  };
  if (height && rows.length) {
    const listProps = {
      height,
      itemData,
      estimatedItemSize: getAverageRowHeight(rowHeights.current),
      itemSize: getRowHeight,
      width: "100%"
    };
    if (loadMore && length) {
      const isLoaded = (index2) => !!rows[index2];
      list = /* @__PURE__ */ React__default.createElement(InfiniteLoader, { isItemLoaded: isLoaded, itemCount: length, loadMoreItems: loadMore }, ({ onItemsRendered, ref: ref2 }) => /* @__PURE__ */ React__default.createElement(
        VariableSizeList,
        {
          ...listProps,
          itemCount: length,
          onItemsRendered,
          ref: (list2) => {
            ref2(list2);
            setRowsRef(list2);
          }
        },
        VariableRow
      ));
    } else {
      list = /* @__PURE__ */ React__default.createElement(
        VariableSizeList,
        {
          ...listProps,
          itemCount: rows.length,
          ref: (ref2) => {
            setRowsRef(ref2);
          }
        },
        VariableRow
      );
    }
  }
  return /* @__PURE__ */ React__default.createElement(BaseTable, { ...tableProps, className, headerRef, ref: tableRef }, list ? list : emptyStateRenderer());
});
WindowedTable.Column = () => null;
WindowedTable.Group = () => null;
var _defineProperty$K;
var hasRequired_defineProperty;
function require_defineProperty() {
  if (hasRequired_defineProperty) return _defineProperty$K;
  hasRequired_defineProperty = 1;
  var getNative = require_getNative();
  var defineProperty2 = function() {
    try {
      var func = getNative(Object, "defineProperty");
      func({}, "", {});
      return func;
    } catch (e3) {
    }
  }();
  _defineProperty$K = defineProperty2;
  return _defineProperty$K;
}
var _baseAssignValue;
var hasRequired_baseAssignValue;
function require_baseAssignValue() {
  if (hasRequired_baseAssignValue) return _baseAssignValue;
  hasRequired_baseAssignValue = 1;
  var defineProperty2 = require_defineProperty();
  function baseAssignValue(object2, key, value) {
    if (key == "__proto__" && defineProperty2) {
      defineProperty2(object2, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
      });
    } else {
      object2[key] = value;
    }
  }
  _baseAssignValue = baseAssignValue;
  return _baseAssignValue;
}
var _assignValue;
var hasRequired_assignValue;
function require_assignValue() {
  if (hasRequired_assignValue) return _assignValue;
  hasRequired_assignValue = 1;
  var baseAssignValue = require_baseAssignValue(), eq = requireEq();
  var objectProto = Object.prototype;
  var hasOwnProperty2 = objectProto.hasOwnProperty;
  function assignValue(object2, key, value) {
    var objValue = object2[key];
    if (!(hasOwnProperty2.call(object2, key) && eq(objValue, value)) || value === void 0 && !(key in object2)) {
      baseAssignValue(object2, key, value);
    }
  }
  _assignValue = assignValue;
  return _assignValue;
}
var _isIndex;
var hasRequired_isIndex;
function require_isIndex() {
  if (hasRequired_isIndex) return _isIndex;
  hasRequired_isIndex = 1;
  var MAX_SAFE_INTEGER2 = 9007199254740991;
  var reIsUint = /^(?:0|[1-9]\d*)$/;
  function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER2 : length;
    return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
  }
  _isIndex = isIndex;
  return _isIndex;
}
var _baseSet;
var hasRequired_baseSet;
function require_baseSet() {
  if (hasRequired_baseSet) return _baseSet;
  hasRequired_baseSet = 1;
  var assignValue = require_assignValue(), castPath = require_castPath(), isIndex = require_isIndex(), isObject2 = requireIsObject(), toKey = require_toKey();
  function baseSet(object2, path, value, customizer) {
    if (!isObject2(object2)) {
      return object2;
    }
    path = castPath(path, object2);
    var index2 = -1, length = path.length, lastIndex = length - 1, nested2 = object2;
    while (nested2 != null && ++index2 < length) {
      var key = toKey(path[index2]), newValue = value;
      if (key === "__proto__" || key === "constructor" || key === "prototype") {
        return object2;
      }
      if (index2 != lastIndex) {
        var objValue = nested2[key];
        newValue = customizer ? customizer(objValue, key, nested2) : void 0;
        if (newValue === void 0) {
          newValue = isObject2(objValue) ? objValue : isIndex(path[index2 + 1]) ? [] : {};
        }
      }
      assignValue(nested2, key, newValue);
      nested2 = nested2[key];
    }
    return object2;
  }
  _baseSet = baseSet;
  return _baseSet;
}
var set_1;
var hasRequiredSet;
function requireSet() {
  if (hasRequiredSet) return set_1;
  hasRequiredSet = 1;
  var baseSet = require_baseSet();
  function set2(object2, path, value) {
    return object2 == null ? object2 : baseSet(object2, path, value);
  }
  set_1 = set2;
  return set_1;
}
var setExports = requireSet();
const set = /* @__PURE__ */ getDefaultExportFromCjs(setExports);
const convertRowIndexPathToNumberArray = (rowIndexPath) => (rowIndexPath == null ? void 0 : rowIndexPath.split(".").map(Number)) ?? [];
const getByRowIndexPath = (data, rowIndexPath) => {
  if (!rowIndexPath) {
    return void 0;
  }
  const currenTRow = [...data];
  const indexes = convertRowIndexPathToNumberArray(String(rowIndexPath));
  if (indexes.length) {
    const startIndex = indexes.shift();
    return indexes.reduce((value, index2) => {
      var _a;
      return (_a = value == null ? void 0 : value.subRows) == null ? void 0 : _a[index2];
    }, currenTRow[startIndex]);
  }
  return void 0;
};
const setByRowIndexPath = (data, rowIndexPath, values) => {
  const nexTRow = [...data];
  const rowIndexes = convertRowIndexPathToNumberArray(rowIndexPath);
  const rootIndex = rowIndexes.shift();
  if (rowIndexes.length) {
    const path = rowIndexes.map((index2) => `subRows[${index2}]`).join(".");
    set(nexTRow[rootIndex], path, values);
  } else {
    nexTRow[rootIndex] = values;
  }
  return nexTRow;
};
const getParentRowIndexPath = (rowIndexPath) => {
  let parentIndexPath;
  if (rowIndexPath) {
    const rowIndexes = convertRowIndexPathToNumberArray(rowIndexPath);
    rowIndexes.pop();
    if (rowIndexes.length) {
      parentIndexPath = rowIndexes.join(".");
    }
  }
  return parentIndexPath;
};
var last_1;
var hasRequiredLast;
function requireLast() {
  if (hasRequiredLast) return last_1;
  hasRequiredLast = 1;
  function last2(array2) {
    var length = array2 == null ? 0 : array2.length;
    return length ? array2[length - 1] : void 0;
  }
  last_1 = last2;
  return last_1;
}
var _baseSlice;
var hasRequired_baseSlice;
function require_baseSlice() {
  if (hasRequired_baseSlice) return _baseSlice;
  hasRequired_baseSlice = 1;
  function baseSlice(array2, start, end) {
    var index2 = -1, length = array2.length;
    if (start < 0) {
      start = -start > length ? 0 : length + start;
    }
    end = end > length ? length : end;
    if (end < 0) {
      end += length;
    }
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while (++index2 < length) {
      result[index2] = array2[index2 + start];
    }
    return result;
  }
  _baseSlice = baseSlice;
  return _baseSlice;
}
var _parent;
var hasRequired_parent;
function require_parent() {
  if (hasRequired_parent) return _parent;
  hasRequired_parent = 1;
  var baseGet = require_baseGet(), baseSlice = require_baseSlice();
  function parent(object2, path) {
    return path.length < 2 ? object2 : baseGet(object2, baseSlice(path, 0, -1));
  }
  _parent = parent;
  return _parent;
}
var _baseUnset;
var hasRequired_baseUnset;
function require_baseUnset() {
  if (hasRequired_baseUnset) return _baseUnset;
  hasRequired_baseUnset = 1;
  var castPath = require_castPath(), last2 = requireLast(), parent = require_parent(), toKey = require_toKey();
  function baseUnset(object2, path) {
    path = castPath(path, object2);
    object2 = parent(object2, path);
    return object2 == null || delete object2[toKey(last2(path))];
  }
  _baseUnset = baseUnset;
  return _baseUnset;
}
var unset_1;
var hasRequiredUnset;
function requireUnset() {
  if (hasRequiredUnset) return unset_1;
  hasRequiredUnset = 1;
  var baseUnset = require_baseUnset();
  function unset2(object2, path) {
    return object2 == null ? true : baseUnset(object2, path);
  }
  unset_1 = unset2;
  return unset_1;
}
var unsetExports = requireUnset();
const unset = /* @__PURE__ */ getDefaultExportFromCjs(unsetExports);
var compact_1;
var hasRequiredCompact;
function requireCompact() {
  if (hasRequiredCompact) return compact_1;
  hasRequiredCompact = 1;
  function compact2(array2) {
    var index2 = -1, length = array2 == null ? 0 : array2.length, resIndex = 0, result = [];
    while (++index2 < length) {
      var value = array2[index2];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  }
  compact_1 = compact2;
  return compact_1;
}
var compactExports = requireCompact();
const compact = /* @__PURE__ */ getDefaultExportFromCjs(compactExports);
var _baseAt;
var hasRequired_baseAt;
function require_baseAt() {
  if (hasRequired_baseAt) return _baseAt;
  hasRequired_baseAt = 1;
  var get2 = requireGet();
  function baseAt(object2, paths) {
    var index2 = -1, length = paths.length, result = Array(length), skip = object2 == null;
    while (++index2 < length) {
      result[index2] = skip ? void 0 : get2(object2, paths[index2]);
    }
    return result;
  }
  _baseAt = baseAt;
  return _baseAt;
}
var _basePullAt;
var hasRequired_basePullAt;
function require_basePullAt() {
  if (hasRequired_basePullAt) return _basePullAt;
  hasRequired_basePullAt = 1;
  var baseUnset = require_baseUnset(), isIndex = require_isIndex();
  var arrayProto = Array.prototype;
  var splice = arrayProto.splice;
  function basePullAt(array2, indexes) {
    var length = array2 ? indexes.length : 0, lastIndex = length - 1;
    while (length--) {
      var index2 = indexes[length];
      if (length == lastIndex || index2 !== previous) {
        var previous = index2;
        if (isIndex(index2)) {
          splice.call(array2, index2, 1);
        } else {
          baseUnset(array2, index2);
        }
      }
    }
    return array2;
  }
  _basePullAt = basePullAt;
  return _basePullAt;
}
var _compareAscending;
var hasRequired_compareAscending;
function require_compareAscending() {
  if (hasRequired_compareAscending) return _compareAscending;
  hasRequired_compareAscending = 1;
  var isSymbol = requireIsSymbol();
  function compareAscending(value, other) {
    if (value !== other) {
      var valIsDefined = value !== void 0, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
      var othIsDefined = other !== void 0, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
      if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
        return 1;
      }
      if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
        return -1;
      }
    }
    return 0;
  }
  _compareAscending = compareAscending;
  return _compareAscending;
}
var _arrayPush;
var hasRequired_arrayPush;
function require_arrayPush() {
  if (hasRequired_arrayPush) return _arrayPush;
  hasRequired_arrayPush = 1;
  function arrayPush(array2, values) {
    var index2 = -1, length = values.length, offset2 = array2.length;
    while (++index2 < length) {
      array2[offset2 + index2] = values[index2];
    }
    return array2;
  }
  _arrayPush = arrayPush;
  return _arrayPush;
}
var _baseIsArguments;
var hasRequired_baseIsArguments;
function require_baseIsArguments() {
  if (hasRequired_baseIsArguments) return _baseIsArguments;
  hasRequired_baseIsArguments = 1;
  var baseGetTag = require_baseGetTag(), isObjectLike = requireIsObjectLike();
  var argsTag = "[object Arguments]";
  function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
  }
  _baseIsArguments = baseIsArguments;
  return _baseIsArguments;
}
var isArguments_1;
var hasRequiredIsArguments;
function requireIsArguments() {
  if (hasRequiredIsArguments) return isArguments_1;
  hasRequiredIsArguments = 1;
  var baseIsArguments = require_baseIsArguments(), isObjectLike = requireIsObjectLike();
  var objectProto = Object.prototype;
  var hasOwnProperty2 = objectProto.hasOwnProperty;
  var propertyIsEnumerable = objectProto.propertyIsEnumerable;
  var isArguments = baseIsArguments(/* @__PURE__ */ function() {
    return arguments;
  }()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty2.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
  };
  isArguments_1 = isArguments;
  return isArguments_1;
}
var _isFlattenable;
var hasRequired_isFlattenable;
function require_isFlattenable() {
  if (hasRequired_isFlattenable) return _isFlattenable;
  hasRequired_isFlattenable = 1;
  var Symbol2 = require_Symbol(), isArguments = requireIsArguments(), isArray2 = requireIsArray();
  var spreadableSymbol = Symbol2 ? Symbol2.isConcatSpreadable : void 0;
  function isFlattenable(value) {
    return isArray2(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
  }
  _isFlattenable = isFlattenable;
  return _isFlattenable;
}
var _baseFlatten;
var hasRequired_baseFlatten;
function require_baseFlatten() {
  if (hasRequired_baseFlatten) return _baseFlatten;
  hasRequired_baseFlatten = 1;
  var arrayPush = require_arrayPush(), isFlattenable = require_isFlattenable();
  function baseFlatten(array2, depth, predicate, isStrict, result) {
    var index2 = -1, length = array2.length;
    predicate || (predicate = isFlattenable);
    result || (result = []);
    while (++index2 < length) {
      var value = array2[index2];
      if (depth > 0 && predicate(value)) {
        if (depth > 1) {
          baseFlatten(value, depth - 1, predicate, isStrict, result);
        } else {
          arrayPush(result, value);
        }
      } else if (!isStrict) {
        result[result.length] = value;
      }
    }
    return result;
  }
  _baseFlatten = baseFlatten;
  return _baseFlatten;
}
var flatten_1;
var hasRequiredFlatten;
function requireFlatten() {
  if (hasRequiredFlatten) return flatten_1;
  hasRequiredFlatten = 1;
  var baseFlatten = require_baseFlatten();
  function flatten(array2) {
    var length = array2 == null ? 0 : array2.length;
    return length ? baseFlatten(array2, 1) : [];
  }
  flatten_1 = flatten;
  return flatten_1;
}
var _apply;
var hasRequired_apply;
function require_apply() {
  if (hasRequired_apply) return _apply;
  hasRequired_apply = 1;
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0:
        return func.call(thisArg);
      case 1:
        return func.call(thisArg, args[0]);
      case 2:
        return func.call(thisArg, args[0], args[1]);
      case 3:
        return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }
  _apply = apply;
  return _apply;
}
var _overRest;
var hasRequired_overRest;
function require_overRest() {
  if (hasRequired_overRest) return _overRest;
  hasRequired_overRest = 1;
  var apply = require_apply();
  var nativeMax = Math.max;
  function overRest(func, start, transform) {
    start = nativeMax(start === void 0 ? func.length - 1 : start, 0);
    return function() {
      var args = arguments, index2 = -1, length = nativeMax(args.length - start, 0), array2 = Array(length);
      while (++index2 < length) {
        array2[index2] = args[start + index2];
      }
      index2 = -1;
      var otherArgs = Array(start + 1);
      while (++index2 < start) {
        otherArgs[index2] = args[index2];
      }
      otherArgs[start] = transform(array2);
      return apply(func, this, otherArgs);
    };
  }
  _overRest = overRest;
  return _overRest;
}
var constant_1;
var hasRequiredConstant;
function requireConstant() {
  if (hasRequiredConstant) return constant_1;
  hasRequiredConstant = 1;
  function constant2(value) {
    return function() {
      return value;
    };
  }
  constant_1 = constant2;
  return constant_1;
}
var identity_1;
var hasRequiredIdentity;
function requireIdentity() {
  if (hasRequiredIdentity) return identity_1;
  hasRequiredIdentity = 1;
  function identity4(value) {
    return value;
  }
  identity_1 = identity4;
  return identity_1;
}
var _baseSetToString;
var hasRequired_baseSetToString;
function require_baseSetToString() {
  if (hasRequired_baseSetToString) return _baseSetToString;
  hasRequired_baseSetToString = 1;
  var constant2 = requireConstant(), defineProperty2 = require_defineProperty(), identity4 = requireIdentity();
  var baseSetToString = !defineProperty2 ? identity4 : function(func, string2) {
    return defineProperty2(func, "toString", {
      "configurable": true,
      "enumerable": false,
      "value": constant2(string2),
      "writable": true
    });
  };
  _baseSetToString = baseSetToString;
  return _baseSetToString;
}
var _shortOut;
var hasRequired_shortOut;
function require_shortOut() {
  if (hasRequired_shortOut) return _shortOut;
  hasRequired_shortOut = 1;
  var HOT_COUNT = 800, HOT_SPAN = 16;
  var nativeNow = Date.now;
  function shortOut(func) {
    var count2 = 0, lastCalled = 0;
    return function() {
      var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
      lastCalled = stamp;
      if (remaining > 0) {
        if (++count2 >= HOT_COUNT) {
          return arguments[0];
        }
      } else {
        count2 = 0;
      }
      return func.apply(void 0, arguments);
    };
  }
  _shortOut = shortOut;
  return _shortOut;
}
var _setToString;
var hasRequired_setToString;
function require_setToString() {
  if (hasRequired_setToString) return _setToString;
  hasRequired_setToString = 1;
  var baseSetToString = require_baseSetToString(), shortOut = require_shortOut();
  var setToString = shortOut(baseSetToString);
  _setToString = setToString;
  return _setToString;
}
var _flatRest;
var hasRequired_flatRest;
function require_flatRest() {
  if (hasRequired_flatRest) return _flatRest;
  hasRequired_flatRest = 1;
  var flatten = requireFlatten(), overRest = require_overRest(), setToString = require_setToString();
  function flatRest(func) {
    return setToString(overRest(func, void 0, flatten), func + "");
  }
  _flatRest = flatRest;
  return _flatRest;
}
var pullAt_1;
var hasRequiredPullAt;
function requirePullAt() {
  if (hasRequiredPullAt) return pullAt_1;
  hasRequiredPullAt = 1;
  var arrayMap = require_arrayMap(), baseAt = require_baseAt(), basePullAt = require_basePullAt(), compareAscending = require_compareAscending(), flatRest = require_flatRest(), isIndex = require_isIndex();
  var pullAt2 = flatRest(function(array2, indexes) {
    var length = array2 == null ? 0 : array2.length, result = baseAt(array2, indexes);
    basePullAt(array2, arrayMap(indexes, function(index2) {
      return isIndex(index2, length) ? +index2 : index2;
    }).sort(compareAscending));
    return result;
  });
  pullAt_1 = pullAt2;
  return pullAt_1;
}
var pullAtExports = requirePullAt();
const pullAt = /* @__PURE__ */ getDefaultExportFromCjs(pullAtExports);
const insertChildTableRow = (data, rowIndexPath = void 0, values = {}) => {
  const nexTRow = JSON.parse(JSON.stringify(data));
  let childRowIndexPath;
  if (rowIndexPath) {
    const rowIndexes = convertRowIndexPathToNumberArray(rowIndexPath);
    const currentRow = getByRowIndexPath(nexTRow, rowIndexes.join("."));
    const nextSubRows = (currentRow == null ? void 0 : currentRow.subRows) ?? [];
    const path = rowIndexes.map((i3) => `[${i3}]`).join(".subRows") + ".subRows";
    nextSubRows.unshift(values);
    set(nexTRow, path, nextSubRows);
    rowIndexes.push(0);
    childRowIndexPath = rowIndexes.join(".");
  } else {
    nexTRow.unshift(values);
    childRowIndexPath = "0";
  }
  return [nexTRow, childRowIndexPath];
};
const removeChildTableRow = (data, rowIndexPath) => {
  const nexTRow = JSON.parse(JSON.stringify(data));
  const rowIndexes = convertRowIndexPathToNumberArray(rowIndexPath);
  const rootIndex = Number(rowIndexes.shift());
  if (rowIndexes.length) {
    const unsetPath = rowIndexes.map((index2) => `subRows[${index2}]`).join(".");
    unset(nexTRow[rootIndex], unsetPath);
    rowIndexes.pop();
    const setPath = rowIndexes.length ? rowIndexes.map((index2) => `subRows[${index2}]`).join(".") + ".subRows" : "subRows";
    set(nexTRow[rootIndex], setPath, compact(get(nexTRow[rootIndex], setPath)));
  } else {
    pullAt(nexTRow, rootIndex);
  }
  return nexTRow;
};
const useTableRowCreation = (data, tableRef) => {
  const [internalData, setInternalData] = React__default.useState(JSON.parse(JSON.stringify(data)));
  const [activeRowIndexPath, setActiveRowIndexPath] = React__default.useState(void 0);
  React__default.useEffect(() => {
    if (activeRowIndexPath !== void 0) {
      const currentRow = getByRowIndexPath(internalData, activeRowIndexPath);
      const parentId = getParentRowIndexPath(activeRowIndexPath);
      const [nexTRow, newRowIndexPath] = insertChildTableRow(JSON.parse(JSON.stringify(data)), parentId, currentRow);
      setActiveRowIndexPath(newRowIndexPath);
      setInternalData(nexTRow);
      if (tableRef == null ? void 0 : tableRef.current) {
        tableRef.current.instance.toggleRowEditing(currentRow == null ? void 0 : currentRow._createKey);
      }
    } else {
      setInternalData(data);
    }
  }, [JSON.stringify(data)]);
  const create = (rowIndexPath = void 0, values = {}) => {
    const _createKey = nanoid();
    const [nexTRow, newRowIndexPath] = insertChildTableRow(internalData, rowIndexPath, { ...values, _createKey });
    setActiveRowIndexPath(newRowIndexPath);
    setInternalData(nexTRow);
    if (tableRef == null ? void 0 : tableRef.current) {
      tableRef.current.instance.toggleRowEditing(_createKey);
    }
    return newRowIndexPath;
  };
  const remove = (rowIndexPath) => {
    const nexTRow = removeChildTableRow(internalData, rowIndexPath);
    setInternalData(nexTRow);
    setActiveRowIndexPath(void 0);
  };
  return {
    data: internalData,
    create,
    remove,
    isCreating: activeRowIndexPath !== void 0
  };
};
function willRowMove(cell, change, rowIndex, localization) {
  const { table } = cell.getContext();
  if (willRowMoveAfterSearch(cell, change, table, localization)) {
    return "search";
  } else if (willRowMoveAfterFilter(cell, change)) {
    return "filter";
  } else if (willRowMoveAfterSorting(cell, change, rowIndex)) {
    return "sorting";
  }
  return void 0;
}
function willRowMoveAfterSearch(cell, change, table, localization) {
  const searchQuery = table.getState().globalFilter;
  if (!table.options.enableGlobalFilter || !searchQuery) {
    return false;
  }
  const rowWithChange = { ...cell.row, original: { ...cell.row.original, [cell.column.id]: change } };
  return !globalFilterFn(rowWithChange, cell.column.id, searchQuery, localization);
}
function willRowMoveAfterFilter(cell, change) {
  if (!cell.column.getIsFiltered()) {
    return false;
  }
  return !columnFilterFn(change, cell.column.getFilterValue());
}
function willRowMoveAfterSorting(cell, change, rowIndex) {
  var _a;
  if (!cell.column.getIsSorted()) {
    return false;
  }
  const { table } = cell.getContext();
  const rows = table.getRowModel().rows;
  const miniSortRows = [
    {
      ...cell.row,
      original: {
        ...cell.row.original,
        [cell.column.id]: change
      },
      getValue: () => change
    }
  ];
  let index2 = 0;
  if (rowIndex > 0) {
    miniSortRows.unshift(rows[rowIndex - 1]);
    index2 = 1;
  }
  if (rowIndex < rows.length - 1) {
    miniSortRows.push(rows[rowIndex + 1]);
  }
  const resortedRows = [...miniSortRows].sort((rowA, rowB) => {
    const sortFn = cell.column.getSortingFn();
    const sortUndefined = cell.column.columnDef.sortUndefined;
    if (!table.options.manualSorting && sortUndefined) {
      const aValue = rowA.getValue(cell.column.id);
      const bValue = rowB.getValue(cell.column.id);
      const aUndefined = aValue === void 0;
      const bUndefined = bValue === void 0;
      if (aUndefined || bUndefined) {
        if (sortUndefined === "first") return aUndefined ? -1 : 1;
        if (sortUndefined === "last") return aUndefined ? 1 : -1;
        return aUndefined && bUndefined ? 0 : aUndefined ? sortUndefined : -sortUndefined;
      }
    }
    return sortFn(rowA, rowB, cell.column.id);
  });
  if (cell.column.getIsSorted() === "desc") {
    resortedRows.reverse();
  }
  return ((_a = resortedRows[index2]) == null ? void 0 : _a.id) !== cell.row.id;
}
const TEMPORARY_ROW_ID_PREFIX = "temp-";
function isTemporaryRow(rowId) {
  if (rowId === void 0) {
    return false;
  }
  return String(rowId).startsWith(TEMPORARY_ROW_ID_PREFIX);
}
const shortcut = { key: "e", meta: true, shift: false };
function isTableScrolled(ref) {
  var _a, _b, _c, _d;
  if (ref.current) {
    const height = parseFloat(((_b = (_a = ref.current) == null ? void 0 : _a.querySelector("tbody")) == null ? void 0 : _b.style.height) || "0") + parseFloat(((_d = (_c = ref.current) == null ? void 0 : _c.querySelector("tbody")) == null ? void 0 : _d.style.paddingBottom) || "0");
    return height > ref.current.scrollHeight;
  }
  return false;
}
function useTableEditingListener(table, tableRef, scrollToIndex) {
  const tableMeta = table.options.meta;
  const localization = useLocalization();
  useLazyEffect(() => {
    return () => {
      var _a;
      if (tableMeta.editing.isEditing && tableMeta.rowActive.rowActiveIndex !== void 0) {
        tableMeta.editing.saveChanges(table, (_a = table.getRowModel().rows[tableMeta.rowActive.rowActiveIndex]) == null ? void 0 : _a.id);
      }
    };
  }, [tableMeta.rowActive.rowActiveIndex]);
  const hasChanges = tableMeta.editing.hasChanges();
  React__default.useEffect(() => {
    function showUnsavedChangesWarning(event) {
      if (tableMeta.editing.isEditing && hasChanges) {
        event.returnValue = true;
        return true;
      }
      return false;
    }
    window.addEventListener("beforeunload", showUnsavedChangesWarning);
    return () => {
      window.removeEventListener("beforeunload", showUnsavedChangesWarning);
    };
  }, [tableMeta.editing.isEditing, hasChanges]);
  const hasSavedChanges = tableMeta.editing.hasSaved();
  useLazyEffect(() => {
    if (hasSavedChanges) {
      resetHighlightedColumnIndexes(table.getState().globalFilter, table, localization);
    }
  }, [hasSavedChanges]);
  React__default.useEffect(() => {
    const onClickOutside = (event) => {
      if (tableMeta.editing.isEditing) {
        const element = event.target;
        const isTableOrIsInsideTable = element.tagName === "TABLE" || element.tagName === "TBODY" || element.getAttribute("data-taco") === "backdrop" || element.getAttribute("data-table") === "editing-toggle" || !document.body.contains(element) || isElementInsideOrTriggeredFromContainer(element, tableRef.current);
        if (!isTableOrIsInsideTable) {
          tableMeta.editing.saveChanges(table);
        }
      }
    };
    document.addEventListener("click", onClickOutside);
    return () => document.removeEventListener("click", onClickOutside);
  }, [tableMeta.editing.isEditing, tableMeta.editing.saveChanges]);
  React__default.useEffect(() => {
    if (tableMeta.editing.isEnabled) {
      tableMeta.rowActions.registerHandler("cleanup", (rowId) => {
        tableMeta.editing.discardChanges(rowId, table);
      });
    }
  }, []);
  useGlobalKeyDown(tableMeta.editing.isEnabled ? shortcut : void 0, (event) => {
    event.preventDefault();
    tableMeta.editing.toggleEditing(!tableMeta.editing.isEditing, table, scrollToIndex);
  });
  useGlobalKeyDown(tableMeta.editing.isEditing ? { key: "s", meta: true, shift: false } : void 0, (event) => {
    event.preventDefault();
    tableMeta.editing.saveChanges(table);
  });
}
var _stackClear;
var hasRequired_stackClear;
function require_stackClear() {
  if (hasRequired_stackClear) return _stackClear;
  hasRequired_stackClear = 1;
  var ListCache = require_ListCache();
  function stackClear() {
    this.__data__ = new ListCache();
    this.size = 0;
  }
  _stackClear = stackClear;
  return _stackClear;
}
var _stackDelete;
var hasRequired_stackDelete;
function require_stackDelete() {
  if (hasRequired_stackDelete) return _stackDelete;
  hasRequired_stackDelete = 1;
  function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
  }
  _stackDelete = stackDelete;
  return _stackDelete;
}
var _stackGet;
var hasRequired_stackGet;
function require_stackGet() {
  if (hasRequired_stackGet) return _stackGet;
  hasRequired_stackGet = 1;
  function stackGet(key) {
    return this.__data__.get(key);
  }
  _stackGet = stackGet;
  return _stackGet;
}
var _stackHas;
var hasRequired_stackHas;
function require_stackHas() {
  if (hasRequired_stackHas) return _stackHas;
  hasRequired_stackHas = 1;
  function stackHas(key) {
    return this.__data__.has(key);
  }
  _stackHas = stackHas;
  return _stackHas;
}
var _stackSet;
var hasRequired_stackSet;
function require_stackSet() {
  if (hasRequired_stackSet) return _stackSet;
  hasRequired_stackSet = 1;
  var ListCache = require_ListCache(), Map2 = require_Map(), MapCache = require_MapCache();
  var LARGE_ARRAY_SIZE = 200;
  function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
      var pairs = data.__data__;
      if (!Map2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
        pairs.push([key, value]);
        this.size = ++data.size;
        return this;
      }
      data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
  }
  _stackSet = stackSet;
  return _stackSet;
}
var _Stack;
var hasRequired_Stack;
function require_Stack() {
  if (hasRequired_Stack) return _Stack;
  hasRequired_Stack = 1;
  var ListCache = require_ListCache(), stackClear = require_stackClear(), stackDelete = require_stackDelete(), stackGet = require_stackGet(), stackHas = require_stackHas(), stackSet = require_stackSet();
  function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
  }
  Stack.prototype.clear = stackClear;
  Stack.prototype["delete"] = stackDelete;
  Stack.prototype.get = stackGet;
  Stack.prototype.has = stackHas;
  Stack.prototype.set = stackSet;
  _Stack = Stack;
  return _Stack;
}
var _arrayEach;
var hasRequired_arrayEach;
function require_arrayEach() {
  if (hasRequired_arrayEach) return _arrayEach;
  hasRequired_arrayEach = 1;
  function arrayEach(array2, iteratee) {
    var index2 = -1, length = array2 == null ? 0 : array2.length;
    while (++index2 < length) {
      if (iteratee(array2[index2], index2, array2) === false) {
        break;
      }
    }
    return array2;
  }
  _arrayEach = arrayEach;
  return _arrayEach;
}
var _copyObject;
var hasRequired_copyObject;
function require_copyObject() {
  if (hasRequired_copyObject) return _copyObject;
  hasRequired_copyObject = 1;
  var assignValue = require_assignValue(), baseAssignValue = require_baseAssignValue();
  function copyObject(source, props, object2, customizer) {
    var isNew = !object2;
    object2 || (object2 = {});
    var index2 = -1, length = props.length;
    while (++index2 < length) {
      var key = props[index2];
      var newValue = customizer ? customizer(object2[key], source[key], key, object2, source) : void 0;
      if (newValue === void 0) {
        newValue = source[key];
      }
      if (isNew) {
        baseAssignValue(object2, key, newValue);
      } else {
        assignValue(object2, key, newValue);
      }
    }
    return object2;
  }
  _copyObject = copyObject;
  return _copyObject;
}
var _baseTimes;
var hasRequired_baseTimes;
function require_baseTimes() {
  if (hasRequired_baseTimes) return _baseTimes;
  hasRequired_baseTimes = 1;
  function baseTimes(n2, iteratee) {
    var index2 = -1, result = Array(n2);
    while (++index2 < n2) {
      result[index2] = iteratee(index2);
    }
    return result;
  }
  _baseTimes = baseTimes;
  return _baseTimes;
}
var isBuffer = { exports: {} };
var stubFalse_1;
var hasRequiredStubFalse;
function requireStubFalse() {
  if (hasRequiredStubFalse) return stubFalse_1;
  hasRequiredStubFalse = 1;
  function stubFalse() {
    return false;
  }
  stubFalse_1 = stubFalse;
  return stubFalse_1;
}
isBuffer.exports;
var hasRequiredIsBuffer;
function requireIsBuffer() {
  if (hasRequiredIsBuffer) return isBuffer.exports;
  hasRequiredIsBuffer = 1;
  (function(module, exports) {
    var root = require_root(), stubFalse = requireStubFalse();
    var freeExports = exports && !exports.nodeType && exports;
    var freeModule = freeExports && true && module && !module.nodeType && module;
    var moduleExports = freeModule && freeModule.exports === freeExports;
    var Buffer = moduleExports ? root.Buffer : void 0;
    var nativeIsBuffer = Buffer ? Buffer.isBuffer : void 0;
    var isBuffer2 = nativeIsBuffer || stubFalse;
    module.exports = isBuffer2;
  })(isBuffer, isBuffer.exports);
  return isBuffer.exports;
}
var isLength_1;
var hasRequiredIsLength;
function requireIsLength() {
  if (hasRequiredIsLength) return isLength_1;
  hasRequiredIsLength = 1;
  var MAX_SAFE_INTEGER2 = 9007199254740991;
  function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER2;
  }
  isLength_1 = isLength;
  return isLength_1;
}
var _baseIsTypedArray;
var hasRequired_baseIsTypedArray;
function require_baseIsTypedArray() {
  if (hasRequired_baseIsTypedArray) return _baseIsTypedArray;
  hasRequired_baseIsTypedArray = 1;
  var baseGetTag = require_baseGetTag(), isLength = requireIsLength(), isObjectLike = requireIsObjectLike();
  var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", weakMapTag = "[object WeakMap]";
  var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
  function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
  }
  _baseIsTypedArray = baseIsTypedArray;
  return _baseIsTypedArray;
}
var _baseUnary;
var hasRequired_baseUnary;
function require_baseUnary() {
  if (hasRequired_baseUnary) return _baseUnary;
  hasRequired_baseUnary = 1;
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }
  _baseUnary = baseUnary;
  return _baseUnary;
}
var _nodeUtil = { exports: {} };
_nodeUtil.exports;
var hasRequired_nodeUtil;
function require_nodeUtil() {
  if (hasRequired_nodeUtil) return _nodeUtil.exports;
  hasRequired_nodeUtil = 1;
  (function(module, exports) {
    var freeGlobal = require_freeGlobal();
    var freeExports = exports && !exports.nodeType && exports;
    var freeModule = freeExports && true && module && !module.nodeType && module;
    var moduleExports = freeModule && freeModule.exports === freeExports;
    var freeProcess = moduleExports && freeGlobal.process;
    var nodeUtil = function() {
      try {
        var types2 = freeModule && freeModule.require && freeModule.require("util").types;
        if (types2) {
          return types2;
        }
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
      } catch (e3) {
      }
    }();
    module.exports = nodeUtil;
  })(_nodeUtil, _nodeUtil.exports);
  return _nodeUtil.exports;
}
var isTypedArray_1;
var hasRequiredIsTypedArray;
function requireIsTypedArray() {
  if (hasRequiredIsTypedArray) return isTypedArray_1;
  hasRequiredIsTypedArray = 1;
  var baseIsTypedArray = require_baseIsTypedArray(), baseUnary = require_baseUnary(), nodeUtil = require_nodeUtil();
  var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
  var isTypedArray2 = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
  isTypedArray_1 = isTypedArray2;
  return isTypedArray_1;
}
var _arrayLikeKeys;
var hasRequired_arrayLikeKeys;
function require_arrayLikeKeys() {
  if (hasRequired_arrayLikeKeys) return _arrayLikeKeys;
  hasRequired_arrayLikeKeys = 1;
  var baseTimes = require_baseTimes(), isArguments = requireIsArguments(), isArray2 = requireIsArray(), isBuffer2 = requireIsBuffer(), isIndex = require_isIndex(), isTypedArray2 = requireIsTypedArray();
  var objectProto = Object.prototype;
  var hasOwnProperty2 = objectProto.hasOwnProperty;
  function arrayLikeKeys(value, inherited) {
    var isArr = isArray2(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer2(value), isType = !isArr && !isArg && !isBuff && isTypedArray2(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for (var key in value) {
      if ((inherited || hasOwnProperty2.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
      (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
      isIndex(key, length)))) {
        result.push(key);
      }
    }
    return result;
  }
  _arrayLikeKeys = arrayLikeKeys;
  return _arrayLikeKeys;
}
var _isPrototype;
var hasRequired_isPrototype;
function require_isPrototype() {
  if (hasRequired_isPrototype) return _isPrototype;
  hasRequired_isPrototype = 1;
  var objectProto = Object.prototype;
  function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
  }
  _isPrototype = isPrototype;
  return _isPrototype;
}
var _overArg;
var hasRequired_overArg;
function require_overArg() {
  if (hasRequired_overArg) return _overArg;
  hasRequired_overArg = 1;
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }
  _overArg = overArg;
  return _overArg;
}
var _nativeKeys;
var hasRequired_nativeKeys;
function require_nativeKeys() {
  if (hasRequired_nativeKeys) return _nativeKeys;
  hasRequired_nativeKeys = 1;
  var overArg = require_overArg();
  var nativeKeys = overArg(Object.keys, Object);
  _nativeKeys = nativeKeys;
  return _nativeKeys;
}
var _baseKeys;
var hasRequired_baseKeys;
function require_baseKeys() {
  if (hasRequired_baseKeys) return _baseKeys;
  hasRequired_baseKeys = 1;
  var isPrototype = require_isPrototype(), nativeKeys = require_nativeKeys();
  var objectProto = Object.prototype;
  var hasOwnProperty2 = objectProto.hasOwnProperty;
  function baseKeys(object2) {
    if (!isPrototype(object2)) {
      return nativeKeys(object2);
    }
    var result = [];
    for (var key in Object(object2)) {
      if (hasOwnProperty2.call(object2, key) && key != "constructor") {
        result.push(key);
      }
    }
    return result;
  }
  _baseKeys = baseKeys;
  return _baseKeys;
}
var isArrayLike_1;
var hasRequiredIsArrayLike;
function requireIsArrayLike() {
  if (hasRequiredIsArrayLike) return isArrayLike_1;
  hasRequiredIsArrayLike = 1;
  var isFunction2 = requireIsFunction(), isLength = requireIsLength();
  function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction2(value);
  }
  isArrayLike_1 = isArrayLike;
  return isArrayLike_1;
}
var keys_1;
var hasRequiredKeys;
function requireKeys() {
  if (hasRequiredKeys) return keys_1;
  hasRequiredKeys = 1;
  var arrayLikeKeys = require_arrayLikeKeys(), baseKeys = require_baseKeys(), isArrayLike = requireIsArrayLike();
  function keys2(object2) {
    return isArrayLike(object2) ? arrayLikeKeys(object2) : baseKeys(object2);
  }
  keys_1 = keys2;
  return keys_1;
}
var _baseAssign;
var hasRequired_baseAssign;
function require_baseAssign() {
  if (hasRequired_baseAssign) return _baseAssign;
  hasRequired_baseAssign = 1;
  var copyObject = require_copyObject(), keys2 = requireKeys();
  function baseAssign(object2, source) {
    return object2 && copyObject(source, keys2(source), object2);
  }
  _baseAssign = baseAssign;
  return _baseAssign;
}
var _nativeKeysIn;
var hasRequired_nativeKeysIn;
function require_nativeKeysIn() {
  if (hasRequired_nativeKeysIn) return _nativeKeysIn;
  hasRequired_nativeKeysIn = 1;
  function nativeKeysIn(object2) {
    var result = [];
    if (object2 != null) {
      for (var key in Object(object2)) {
        result.push(key);
      }
    }
    return result;
  }
  _nativeKeysIn = nativeKeysIn;
  return _nativeKeysIn;
}
var _baseKeysIn;
var hasRequired_baseKeysIn;
function require_baseKeysIn() {
  if (hasRequired_baseKeysIn) return _baseKeysIn;
  hasRequired_baseKeysIn = 1;
  var isObject2 = requireIsObject(), isPrototype = require_isPrototype(), nativeKeysIn = require_nativeKeysIn();
  var objectProto = Object.prototype;
  var hasOwnProperty2 = objectProto.hasOwnProperty;
  function baseKeysIn(object2) {
    if (!isObject2(object2)) {
      return nativeKeysIn(object2);
    }
    var isProto = isPrototype(object2), result = [];
    for (var key in object2) {
      if (!(key == "constructor" && (isProto || !hasOwnProperty2.call(object2, key)))) {
        result.push(key);
      }
    }
    return result;
  }
  _baseKeysIn = baseKeysIn;
  return _baseKeysIn;
}
var keysIn_1;
var hasRequiredKeysIn;
function requireKeysIn() {
  if (hasRequiredKeysIn) return keysIn_1;
  hasRequiredKeysIn = 1;
  var arrayLikeKeys = require_arrayLikeKeys(), baseKeysIn = require_baseKeysIn(), isArrayLike = requireIsArrayLike();
  function keysIn(object2) {
    return isArrayLike(object2) ? arrayLikeKeys(object2, true) : baseKeysIn(object2);
  }
  keysIn_1 = keysIn;
  return keysIn_1;
}
var _baseAssignIn;
var hasRequired_baseAssignIn;
function require_baseAssignIn() {
  if (hasRequired_baseAssignIn) return _baseAssignIn;
  hasRequired_baseAssignIn = 1;
  var copyObject = require_copyObject(), keysIn = requireKeysIn();
  function baseAssignIn(object2, source) {
    return object2 && copyObject(source, keysIn(source), object2);
  }
  _baseAssignIn = baseAssignIn;
  return _baseAssignIn;
}
var _cloneBuffer = { exports: {} };
_cloneBuffer.exports;
var hasRequired_cloneBuffer;
function require_cloneBuffer() {
  if (hasRequired_cloneBuffer) return _cloneBuffer.exports;
  hasRequired_cloneBuffer = 1;
  (function(module, exports) {
    var root = require_root();
    var freeExports = exports && !exports.nodeType && exports;
    var freeModule = freeExports && true && module && !module.nodeType && module;
    var moduleExports = freeModule && freeModule.exports === freeExports;
    var Buffer = moduleExports ? root.Buffer : void 0, allocUnsafe = Buffer ? Buffer.allocUnsafe : void 0;
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
      buffer.copy(result);
      return result;
    }
    module.exports = cloneBuffer;
  })(_cloneBuffer, _cloneBuffer.exports);
  return _cloneBuffer.exports;
}
var _copyArray;
var hasRequired_copyArray;
function require_copyArray() {
  if (hasRequired_copyArray) return _copyArray;
  hasRequired_copyArray = 1;
  function copyArray(source, array2) {
    var index2 = -1, length = source.length;
    array2 || (array2 = Array(length));
    while (++index2 < length) {
      array2[index2] = source[index2];
    }
    return array2;
  }
  _copyArray = copyArray;
  return _copyArray;
}
var _arrayFilter;
var hasRequired_arrayFilter;
function require_arrayFilter() {
  if (hasRequired_arrayFilter) return _arrayFilter;
  hasRequired_arrayFilter = 1;
  function arrayFilter(array2, predicate) {
    var index2 = -1, length = array2 == null ? 0 : array2.length, resIndex = 0, result = [];
    while (++index2 < length) {
      var value = array2[index2];
      if (predicate(value, index2, array2)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }
  _arrayFilter = arrayFilter;
  return _arrayFilter;
}
var stubArray_1;
var hasRequiredStubArray;
function requireStubArray() {
  if (hasRequiredStubArray) return stubArray_1;
  hasRequiredStubArray = 1;
  function stubArray() {
    return [];
  }
  stubArray_1 = stubArray;
  return stubArray_1;
}
var _getSymbols;
var hasRequired_getSymbols;
function require_getSymbols() {
  if (hasRequired_getSymbols) return _getSymbols;
  hasRequired_getSymbols = 1;
  var arrayFilter = require_arrayFilter(), stubArray = requireStubArray();
  var objectProto = Object.prototype;
  var propertyIsEnumerable = objectProto.propertyIsEnumerable;
  var nativeGetSymbols = Object.getOwnPropertySymbols;
  var getSymbols = !nativeGetSymbols ? stubArray : function(object2) {
    if (object2 == null) {
      return [];
    }
    object2 = Object(object2);
    return arrayFilter(nativeGetSymbols(object2), function(symbol) {
      return propertyIsEnumerable.call(object2, symbol);
    });
  };
  _getSymbols = getSymbols;
  return _getSymbols;
}
var _copySymbols;
var hasRequired_copySymbols;
function require_copySymbols() {
  if (hasRequired_copySymbols) return _copySymbols;
  hasRequired_copySymbols = 1;
  var copyObject = require_copyObject(), getSymbols = require_getSymbols();
  function copySymbols(source, object2) {
    return copyObject(source, getSymbols(source), object2);
  }
  _copySymbols = copySymbols;
  return _copySymbols;
}
var _getPrototype;
var hasRequired_getPrototype;
function require_getPrototype() {
  if (hasRequired_getPrototype) return _getPrototype;
  hasRequired_getPrototype = 1;
  var overArg = require_overArg();
  var getPrototype = overArg(Object.getPrototypeOf, Object);
  _getPrototype = getPrototype;
  return _getPrototype;
}
var _getSymbolsIn;
var hasRequired_getSymbolsIn;
function require_getSymbolsIn() {
  if (hasRequired_getSymbolsIn) return _getSymbolsIn;
  hasRequired_getSymbolsIn = 1;
  var arrayPush = require_arrayPush(), getPrototype = require_getPrototype(), getSymbols = require_getSymbols(), stubArray = requireStubArray();
  var nativeGetSymbols = Object.getOwnPropertySymbols;
  var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object2) {
    var result = [];
    while (object2) {
      arrayPush(result, getSymbols(object2));
      object2 = getPrototype(object2);
    }
    return result;
  };
  _getSymbolsIn = getSymbolsIn;
  return _getSymbolsIn;
}
var _copySymbolsIn;
var hasRequired_copySymbolsIn;
function require_copySymbolsIn() {
  if (hasRequired_copySymbolsIn) return _copySymbolsIn;
  hasRequired_copySymbolsIn = 1;
  var copyObject = require_copyObject(), getSymbolsIn = require_getSymbolsIn();
  function copySymbolsIn(source, object2) {
    return copyObject(source, getSymbolsIn(source), object2);
  }
  _copySymbolsIn = copySymbolsIn;
  return _copySymbolsIn;
}
var _baseGetAllKeys;
var hasRequired_baseGetAllKeys;
function require_baseGetAllKeys() {
  if (hasRequired_baseGetAllKeys) return _baseGetAllKeys;
  hasRequired_baseGetAllKeys = 1;
  var arrayPush = require_arrayPush(), isArray2 = requireIsArray();
  function baseGetAllKeys(object2, keysFunc, symbolsFunc) {
    var result = keysFunc(object2);
    return isArray2(object2) ? result : arrayPush(result, symbolsFunc(object2));
  }
  _baseGetAllKeys = baseGetAllKeys;
  return _baseGetAllKeys;
}
var _getAllKeys;
var hasRequired_getAllKeys;
function require_getAllKeys() {
  if (hasRequired_getAllKeys) return _getAllKeys;
  hasRequired_getAllKeys = 1;
  var baseGetAllKeys = require_baseGetAllKeys(), getSymbols = require_getSymbols(), keys2 = requireKeys();
  function getAllKeys(object2) {
    return baseGetAllKeys(object2, keys2, getSymbols);
  }
  _getAllKeys = getAllKeys;
  return _getAllKeys;
}
var _getAllKeysIn;
var hasRequired_getAllKeysIn;
function require_getAllKeysIn() {
  if (hasRequired_getAllKeysIn) return _getAllKeysIn;
  hasRequired_getAllKeysIn = 1;
  var baseGetAllKeys = require_baseGetAllKeys(), getSymbolsIn = require_getSymbolsIn(), keysIn = requireKeysIn();
  function getAllKeysIn(object2) {
    return baseGetAllKeys(object2, keysIn, getSymbolsIn);
  }
  _getAllKeysIn = getAllKeysIn;
  return _getAllKeysIn;
}
var _DataView;
var hasRequired_DataView;
function require_DataView() {
  if (hasRequired_DataView) return _DataView;
  hasRequired_DataView = 1;
  var getNative = require_getNative(), root = require_root();
  var DataView2 = getNative(root, "DataView");
  _DataView = DataView2;
  return _DataView;
}
var _Promise;
var hasRequired_Promise;
function require_Promise() {
  if (hasRequired_Promise) return _Promise;
  hasRequired_Promise = 1;
  var getNative = require_getNative(), root = require_root();
  var Promise2 = getNative(root, "Promise");
  _Promise = Promise2;
  return _Promise;
}
var _Set;
var hasRequired_Set;
function require_Set() {
  if (hasRequired_Set) return _Set;
  hasRequired_Set = 1;
  var getNative = require_getNative(), root = require_root();
  var Set2 = getNative(root, "Set");
  _Set = Set2;
  return _Set;
}
var _WeakMap;
var hasRequired_WeakMap;
function require_WeakMap() {
  if (hasRequired_WeakMap) return _WeakMap;
  hasRequired_WeakMap = 1;
  var getNative = require_getNative(), root = require_root();
  var WeakMap2 = getNative(root, "WeakMap");
  _WeakMap = WeakMap2;
  return _WeakMap;
}
var _getTag;
var hasRequired_getTag;
function require_getTag() {
  if (hasRequired_getTag) return _getTag;
  hasRequired_getTag = 1;
  var DataView2 = require_DataView(), Map2 = require_Map(), Promise2 = require_Promise(), Set2 = require_Set(), WeakMap2 = require_WeakMap(), baseGetTag = require_baseGetTag(), toSource = require_toSource();
  var mapTag = "[object Map]", objectTag = "[object Object]", promiseTag = "[object Promise]", setTag = "[object Set]", weakMapTag = "[object WeakMap]";
  var dataViewTag = "[object DataView]";
  var dataViewCtorString = toSource(DataView2), mapCtorString = toSource(Map2), promiseCtorString = toSource(Promise2), setCtorString = toSource(Set2), weakMapCtorString = toSource(WeakMap2);
  var getTag2 = baseGetTag;
  if (DataView2 && getTag2(new DataView2(new ArrayBuffer(1))) != dataViewTag || Map2 && getTag2(new Map2()) != mapTag || Promise2 && getTag2(Promise2.resolve()) != promiseTag || Set2 && getTag2(new Set2()) != setTag || WeakMap2 && getTag2(new WeakMap2()) != weakMapTag) {
    getTag2 = function(value) {
      var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : void 0, ctorString = Ctor ? toSource(Ctor) : "";
      if (ctorString) {
        switch (ctorString) {
          case dataViewCtorString:
            return dataViewTag;
          case mapCtorString:
            return mapTag;
          case promiseCtorString:
            return promiseTag;
          case setCtorString:
            return setTag;
          case weakMapCtorString:
            return weakMapTag;
        }
      }
      return result;
    };
  }
  _getTag = getTag2;
  return _getTag;
}
var _initCloneArray;
var hasRequired_initCloneArray;
function require_initCloneArray() {
  if (hasRequired_initCloneArray) return _initCloneArray;
  hasRequired_initCloneArray = 1;
  var objectProto = Object.prototype;
  var hasOwnProperty2 = objectProto.hasOwnProperty;
  function initCloneArray(array2) {
    var length = array2.length, result = new array2.constructor(length);
    if (length && typeof array2[0] == "string" && hasOwnProperty2.call(array2, "index")) {
      result.index = array2.index;
      result.input = array2.input;
    }
    return result;
  }
  _initCloneArray = initCloneArray;
  return _initCloneArray;
}
var _Uint8Array;
var hasRequired_Uint8Array;
function require_Uint8Array() {
  if (hasRequired_Uint8Array) return _Uint8Array;
  hasRequired_Uint8Array = 1;
  var root = require_root();
  var Uint8Array2 = root.Uint8Array;
  _Uint8Array = Uint8Array2;
  return _Uint8Array;
}
var _cloneArrayBuffer;
var hasRequired_cloneArrayBuffer;
function require_cloneArrayBuffer() {
  if (hasRequired_cloneArrayBuffer) return _cloneArrayBuffer;
  hasRequired_cloneArrayBuffer = 1;
  var Uint8Array2 = require_Uint8Array();
  function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array2(result).set(new Uint8Array2(arrayBuffer));
    return result;
  }
  _cloneArrayBuffer = cloneArrayBuffer;
  return _cloneArrayBuffer;
}
var _cloneDataView;
var hasRequired_cloneDataView;
function require_cloneDataView() {
  if (hasRequired_cloneDataView) return _cloneDataView;
  hasRequired_cloneDataView = 1;
  var cloneArrayBuffer = require_cloneArrayBuffer();
  function cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
  }
  _cloneDataView = cloneDataView;
  return _cloneDataView;
}
var _cloneRegExp;
var hasRequired_cloneRegExp;
function require_cloneRegExp() {
  if (hasRequired_cloneRegExp) return _cloneRegExp;
  hasRequired_cloneRegExp = 1;
  var reFlags = /\w*$/;
  function cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
  }
  _cloneRegExp = cloneRegExp;
  return _cloneRegExp;
}
var _cloneSymbol;
var hasRequired_cloneSymbol;
function require_cloneSymbol() {
  if (hasRequired_cloneSymbol) return _cloneSymbol;
  hasRequired_cloneSymbol = 1;
  var Symbol2 = require_Symbol();
  var symbolProto = Symbol2 ? Symbol2.prototype : void 0, symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
  function cloneSymbol(symbol) {
    return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
  }
  _cloneSymbol = cloneSymbol;
  return _cloneSymbol;
}
var _cloneTypedArray;
var hasRequired_cloneTypedArray;
function require_cloneTypedArray() {
  if (hasRequired_cloneTypedArray) return _cloneTypedArray;
  hasRequired_cloneTypedArray = 1;
  var cloneArrayBuffer = require_cloneArrayBuffer();
  function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
  }
  _cloneTypedArray = cloneTypedArray;
  return _cloneTypedArray;
}
var _initCloneByTag;
var hasRequired_initCloneByTag;
function require_initCloneByTag() {
  if (hasRequired_initCloneByTag) return _initCloneByTag;
  hasRequired_initCloneByTag = 1;
  var cloneArrayBuffer = require_cloneArrayBuffer(), cloneDataView = require_cloneDataView(), cloneRegExp = require_cloneRegExp(), cloneSymbol = require_cloneSymbol(), cloneTypedArray = require_cloneTypedArray();
  var boolTag = "[object Boolean]", dateTag = "[object Date]", mapTag = "[object Map]", numberTag = "[object Number]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]";
  var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
  function initCloneByTag(object2, tag, isDeep) {
    var Ctor = object2.constructor;
    switch (tag) {
      case arrayBufferTag:
        return cloneArrayBuffer(object2);
      case boolTag:
      case dateTag:
        return new Ctor(+object2);
      case dataViewTag:
        return cloneDataView(object2, isDeep);
      case float32Tag:
      case float64Tag:
      case int8Tag:
      case int16Tag:
      case int32Tag:
      case uint8Tag:
      case uint8ClampedTag:
      case uint16Tag:
      case uint32Tag:
        return cloneTypedArray(object2, isDeep);
      case mapTag:
        return new Ctor();
      case numberTag:
      case stringTag:
        return new Ctor(object2);
      case regexpTag:
        return cloneRegExp(object2);
      case setTag:
        return new Ctor();
      case symbolTag:
        return cloneSymbol(object2);
    }
  }
  _initCloneByTag = initCloneByTag;
  return _initCloneByTag;
}
var _baseCreate;
var hasRequired_baseCreate;
function require_baseCreate() {
  if (hasRequired_baseCreate) return _baseCreate;
  hasRequired_baseCreate = 1;
  var isObject2 = requireIsObject();
  var objectCreate = Object.create;
  var baseCreate = /* @__PURE__ */ function() {
    function object2() {
    }
    return function(proto) {
      if (!isObject2(proto)) {
        return {};
      }
      if (objectCreate) {
        return objectCreate(proto);
      }
      object2.prototype = proto;
      var result = new object2();
      object2.prototype = void 0;
      return result;
    };
  }();
  _baseCreate = baseCreate;
  return _baseCreate;
}
var _initCloneObject;
var hasRequired_initCloneObject;
function require_initCloneObject() {
  if (hasRequired_initCloneObject) return _initCloneObject;
  hasRequired_initCloneObject = 1;
  var baseCreate = require_baseCreate(), getPrototype = require_getPrototype(), isPrototype = require_isPrototype();
  function initCloneObject(object2) {
    return typeof object2.constructor == "function" && !isPrototype(object2) ? baseCreate(getPrototype(object2)) : {};
  }
  _initCloneObject = initCloneObject;
  return _initCloneObject;
}
var _baseIsMap;
var hasRequired_baseIsMap;
function require_baseIsMap() {
  if (hasRequired_baseIsMap) return _baseIsMap;
  hasRequired_baseIsMap = 1;
  var getTag2 = require_getTag(), isObjectLike = requireIsObjectLike();
  var mapTag = "[object Map]";
  function baseIsMap(value) {
    return isObjectLike(value) && getTag2(value) == mapTag;
  }
  _baseIsMap = baseIsMap;
  return _baseIsMap;
}
var isMap_1;
var hasRequiredIsMap;
function requireIsMap() {
  if (hasRequiredIsMap) return isMap_1;
  hasRequiredIsMap = 1;
  var baseIsMap = require_baseIsMap(), baseUnary = require_baseUnary(), nodeUtil = require_nodeUtil();
  var nodeIsMap = nodeUtil && nodeUtil.isMap;
  var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
  isMap_1 = isMap;
  return isMap_1;
}
var _baseIsSet;
var hasRequired_baseIsSet;
function require_baseIsSet() {
  if (hasRequired_baseIsSet) return _baseIsSet;
  hasRequired_baseIsSet = 1;
  var getTag2 = require_getTag(), isObjectLike = requireIsObjectLike();
  var setTag = "[object Set]";
  function baseIsSet(value) {
    return isObjectLike(value) && getTag2(value) == setTag;
  }
  _baseIsSet = baseIsSet;
  return _baseIsSet;
}
var isSet_1;
var hasRequiredIsSet;
function requireIsSet() {
  if (hasRequiredIsSet) return isSet_1;
  hasRequiredIsSet = 1;
  var baseIsSet = require_baseIsSet(), baseUnary = require_baseUnary(), nodeUtil = require_nodeUtil();
  var nodeIsSet = nodeUtil && nodeUtil.isSet;
  var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
  isSet_1 = isSet;
  return isSet_1;
}
var _baseClone;
var hasRequired_baseClone;
function require_baseClone() {
  if (hasRequired_baseClone) return _baseClone;
  hasRequired_baseClone = 1;
  var Stack = require_Stack(), arrayEach = require_arrayEach(), assignValue = require_assignValue(), baseAssign = require_baseAssign(), baseAssignIn = require_baseAssignIn(), cloneBuffer = require_cloneBuffer(), copyArray = require_copyArray(), copySymbols = require_copySymbols(), copySymbolsIn = require_copySymbolsIn(), getAllKeys = require_getAllKeys(), getAllKeysIn = require_getAllKeysIn(), getTag2 = require_getTag(), initCloneArray = require_initCloneArray(), initCloneByTag = require_initCloneByTag(), initCloneObject = require_initCloneObject(), isArray2 = requireIsArray(), isBuffer2 = requireIsBuffer(), isMap = requireIsMap(), isObject2 = requireIsObject(), isSet = requireIsSet(), keys2 = requireKeys(), keysIn = requireKeysIn();
  var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
  var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", weakMapTag = "[object WeakMap]";
  var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
  function baseClone(value, bitmask, customizer, key, object2, stack) {
    var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
    if (customizer) {
      result = object2 ? customizer(value, key, object2, stack) : customizer(value);
    }
    if (result !== void 0) {
      return result;
    }
    if (!isObject2(value)) {
      return value;
    }
    var isArr = isArray2(value);
    if (isArr) {
      result = initCloneArray(value);
      if (!isDeep) {
        return copyArray(value, result);
      }
    } else {
      var tag = getTag2(value), isFunc = tag == funcTag || tag == genTag;
      if (isBuffer2(value)) {
        return cloneBuffer(value, isDeep);
      }
      if (tag == objectTag || tag == argsTag || isFunc && !object2) {
        result = isFlat || isFunc ? {} : initCloneObject(value);
        if (!isDeep) {
          return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
        }
      } else {
        if (!cloneableTags[tag]) {
          return object2 ? value : {};
        }
        result = initCloneByTag(value, tag, isDeep);
      }
    }
    stack || (stack = new Stack());
    var stacked = stack.get(value);
    if (stacked) {
      return stacked;
    }
    stack.set(value, result);
    if (isSet(value)) {
      value.forEach(function(subValue) {
        result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
      });
    } else if (isMap(value)) {
      value.forEach(function(subValue, key2) {
        result.set(key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
      });
    }
    var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys2;
    var props = isArr ? void 0 : keysFunc(value);
    arrayEach(props || value, function(subValue, key2) {
      if (props) {
        key2 = subValue;
        subValue = value[key2];
      }
      assignValue(result, key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
    });
    return result;
  }
  _baseClone = baseClone;
  return _baseClone;
}
var isPlainObject_1;
var hasRequiredIsPlainObject;
function requireIsPlainObject() {
  if (hasRequiredIsPlainObject) return isPlainObject_1;
  hasRequiredIsPlainObject = 1;
  var baseGetTag = require_baseGetTag(), getPrototype = require_getPrototype(), isObjectLike = requireIsObjectLike();
  var objectTag = "[object Object]";
  var funcProto = Function.prototype, objectProto = Object.prototype;
  var funcToString = funcProto.toString;
  var hasOwnProperty2 = objectProto.hasOwnProperty;
  var objectCtorString = funcToString.call(Object);
  function isPlainObject2(value) {
    if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
      return false;
    }
    var proto = getPrototype(value);
    if (proto === null) {
      return true;
    }
    var Ctor = hasOwnProperty2.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
  }
  isPlainObject_1 = isPlainObject2;
  return isPlainObject_1;
}
var _customOmitClone;
var hasRequired_customOmitClone;
function require_customOmitClone() {
  if (hasRequired_customOmitClone) return _customOmitClone;
  hasRequired_customOmitClone = 1;
  var isPlainObject2 = requireIsPlainObject();
  function customOmitClone(value) {
    return isPlainObject2(value) ? void 0 : value;
  }
  _customOmitClone = customOmitClone;
  return _customOmitClone;
}
var omit_1;
var hasRequiredOmit;
function requireOmit() {
  if (hasRequiredOmit) return omit_1;
  hasRequiredOmit = 1;
  var arrayMap = require_arrayMap(), baseClone = require_baseClone(), baseUnset = require_baseUnset(), castPath = require_castPath(), copyObject = require_copyObject(), customOmitClone = require_customOmitClone(), flatRest = require_flatRest(), getAllKeysIn = require_getAllKeysIn();
  var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
  var omit2 = flatRest(function(object2, paths) {
    var result = {};
    if (object2 == null) {
      return result;
    }
    var isDeep = false;
    paths = arrayMap(paths, function(path) {
      path = castPath(path, object2);
      isDeep || (isDeep = path.length > 1);
      return path;
    });
    copyObject(object2, getAllKeysIn(object2), result);
    if (isDeep) {
      result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
    }
    var length = paths.length;
    while (length--) {
      baseUnset(result, paths[length]);
    }
    return result;
  });
  omit_1 = omit2;
  return omit_1;
}
var omitExports = requireOmit();
const omit$1 = /* @__PURE__ */ getDefaultExportFromCjs(omitExports);
var setWith_1;
var hasRequiredSetWith;
function requireSetWith() {
  if (hasRequiredSetWith) return setWith_1;
  hasRequiredSetWith = 1;
  var baseSet = require_baseSet();
  function setWith2(object2, path, value, customizer) {
    customizer = typeof customizer == "function" ? customizer : void 0;
    return object2 == null ? object2 : baseSet(object2, path, value, customizer);
  }
  setWith_1 = setWith2;
  return setWith_1;
}
var setWithExports = requireSetWith();
const setWith = /* @__PURE__ */ getDefaultExportFromCjs(setWithExports);
const DELAY_BEFORE_REMOVING_SAVE_STATUS = 3e3;
function reducer(state, action) {
  const { type, rowId, payload } = action;
  switch (type) {
    case "setCellValue": {
      const { columnId, index: index2, row, value } = payload;
      return {
        ...state,
        changes: {
          ...state.changes,
          rows: setWith(state.changes.rows, `${rowId}.${columnId}`, value, Object),
          originals: setWith(state.changes.originals, rowId, row, Object)
        },
        indexes: setWith(state.indexes, rowId, index2, Object)
      };
    }
    case "removeCellValue": {
      const { columnId, rowIdentityAccessor } = payload;
      const changes = omit$1(state.changes.rows, `${rowId}.${columnId}`);
      if (!Object.keys(changes[rowId]).length) {
        return reducer(state, { type: "removeRow", rowId, payload: { rowIdentityAccessor } });
      }
      return {
        ...state,
        changes: {
          ...state.changes,
          rows: omit$1(state.changes.rows, `${rowId}.${columnId}`),
          errors: omit$1(state.changes.errors, `${rowId}.cells.${columnId}`),
          moveReasons: omit$1(state.changes.moveReasons, `${rowId}.${columnId}`)
        }
      };
    }
    case "updateRow": {
      const { cellErrors, index: index2, moveReasons, original, value } = payload;
      return {
        ...state,
        changes: {
          ...state.changes,
          rows: setWith(state.changes.rows, rowId, value, Object),
          errors: setWith(
            state.changes.errors,
            `${rowId}.cells`,
            cellErrors ?? state.changes.errors.cells[rowId],
            Object
          ),
          originals: setWith(state.changes.originals, rowId, original ?? state.changes.originals[rowId], Object),
          moveReasons: setWith(
            state.changes.moveReasons,
            rowId,
            moveReasons ?? state.changes.moveReasons[rowId],
            Object
          ),
          // status can be undefined, so don't use ??
          status: setWith(state.changes.status, rowId, void 0, Object)
        },
        indexes: setWith(state.indexes, rowId, index2, Object)
      };
    }
    case "removeRow": {
      const { rowIdentityAccessor } = payload;
      return {
        ...state,
        changes: {
          ...state.changes,
          rows: omit$1(state.changes.rows, rowId),
          errors: omit$1(state.changes.errors, rowId),
          moveReasons: omit$1(state.changes.moveReasons, rowId),
          originals: omit$1(state.changes.originals, rowId),
          status: omit$1(state.changes.status, rowId)
        },
        indexes: omit$1(state.indexes, rowId),
        temporaryRows: state.temporaryRows.filter((row) => row[rowIdentityAccessor] !== rowId)
      };
    }
    case "complete": {
      const { changes, handleDiscard } = payload;
      if (JSON.stringify(changes) !== JSON.stringify(state.changes.rows[rowId])) {
        return {
          ...state,
          changes: {
            ...state.changes,
            originals: setWith(
              state.changes.originals,
              rowId,
              { ...state.changes.originals[rowId], ...changes },
              Object
            )
          }
        };
      }
      if (typeof handleDiscard === "function") {
        handleDiscard();
      }
      return state;
    }
    case "setRowStatus": {
      const { status } = payload;
      return {
        ...state,
        changes: {
          ...state.changes,
          status: status ? setWith(state.changes.status, rowId, status, Object) : omit$1(state.changes.status, rowId)
        }
      };
    }
    case "setRowErrors": {
      const { ...errors } = payload;
      return {
        ...state,
        changes: {
          ...state.changes,
          errors: setWith(state.changes.errors, rowId, errors, Object)
        }
      };
    }
    case "insertTemporaryRow": {
      const { index: index2, value } = payload;
      return {
        ...state,
        temporaryRows: state.temporaryRows.concat(value),
        changes: {
          ...state.changes,
          rows: setWith(state.changes.rows, rowId, value, Object),
          originals: setWith(state.changes.originals, rowId, value, Object)
        },
        indexes: setWith(state.indexes, rowId, index2, Object)
      };
    }
    default:
      return state;
  }
}
function usePendingChangesState(handleSave, handleChange, handleDiscard, rowIdentityAccessor, validator) {
  const localization = useLocalization();
  const [state, dispatch] = React__default.useReducer(reducer, {
    changes: { rows: {}, errors: {}, moveReasons: {}, originals: {}, status: {} },
    indexes: {},
    temporaryRows: []
  });
  function getRowValue(rowId) {
    var _a;
    return ((_a = state.changes.rows) == null ? void 0 : _a[rowId]) ?? void 0;
  }
  function getRowMoveReason(rowId) {
    var _a;
    return Object.values(((_a = state.changes.moveReasons) == null ? void 0 : _a[rowId]) ?? {})[0] ?? void 0;
  }
  function hasRowErrors(rowId) {
    var _a, _b;
    return !!((_a = state.changes.errors[rowId]) == null ? void 0 : _a.row) || !!Object.keys(((_b = state.changes.errors[rowId]) == null ? void 0 : _b.cells) ?? {}).length;
  }
  function hasRowErrorsShownInAlert(rowId) {
    var _a;
    return hasRowErrors(rowId) && !!((_a = state.changes.errors[rowId]) == null ? void 0 : _a.shouldShowErrorAlert);
  }
  function hasTemporaryRowErrors() {
    var _a, _b, _c;
    const newRow = (_a = state.temporaryRows) == null ? void 0 : _a[0];
    if (!newRow) {
      return false;
    }
    const rowId = newRow[rowIdentityAccessor];
    return !!((_b = state.changes.errors[rowId]) == null ? void 0 : _b.row) || !!Object.keys(((_c = state.changes.errors[rowId]) == null ? void 0 : _c.cells) ?? {}).length;
  }
  function getRowStatus(rowId) {
    return state.changes.status[rowId];
  }
  function setRowStatus(rowId, status) {
    dispatch({
      type: "setRowStatus",
      rowId,
      payload: {
        status
      }
    });
  }
  function insertTemporaryRow(data, rowIndex) {
    const newRowId = `${TEMPORARY_ROW_ID_PREFIX}${nanoid()}`;
    const value = {
      ...data,
      [rowIdentityAccessor]: newRowId
    };
    dispatch({
      type: "insertTemporaryRow",
      rowId: newRowId,
      payload: { index: rowIndex, value }
    });
    return newRowId;
  }
  function setCellValue(cell, rowIndex, value) {
    const rowId = cell.row.id;
    const columnId = cell.column.id;
    if (value !== cell.row.original[columnId]) {
      dispatch({
        type: "setCellValue",
        rowId,
        payload: {
          columnId,
          index: rowIndex,
          row: cell.row.original,
          value
        }
      });
    } else if (cell.row.id in state.changes.rows) {
      dispatch({
        type: "removeCellValue",
        rowId,
        payload: {
          columnId,
          rowIdentityAccessor
        }
      });
    }
  }
  function getCellValue(cell) {
    var _a, _b;
    return (_b = (_a = state.changes.rows) == null ? void 0 : _a[cell.row.id]) == null ? void 0 : _b[cell.column.id];
  }
  function getCellError(cell) {
    var _a, _b, _c;
    return (_c = (_b = (_a = state.changes.errors) == null ? void 0 : _a[cell.row.id]) == null ? void 0 : _b.cells) == null ? void 0 : _c[cell.column.id];
  }
  async function onCellChanged(cell, rowIndex, nextValue, shouldRunUpdaters = true) {
    var _a;
    const changes = nextValue !== void 0 ? { ...state.changes.rows[cell.row.id], [cell.column.id]: nextValue } : { ...state.changes.rows[cell.row.id] };
    if (!Object.keys(changes).length) {
      return;
    }
    let updatesForOtherCells = {};
    if (typeof handleChange === "function" && shouldRunUpdaters) {
      const previousRowValue = {
        ...state.changes.originals[cell.row.id]
        //...getRowChangeset(updatersRef.current[cell.row.id], rowIdentityAccessor),
      };
      const nextRowValue = {
        ...state.changes.originals[cell.row.id],
        ...changes
      };
      updatesForOtherCells = await handleChange(
        cell.column.id,
        changes[cell.column.id],
        nextRowValue,
        previousRowValue
      ) ?? {};
    }
    const nextChanges = { ...changes, ...updatesForOtherCells };
    const nextMoveReasons = { ...state.changes.moveReasons[cell.row.id] };
    const nextCellErrors = { ...(_a = state.changes.errors[cell.row.id]) == null ? void 0 : _a.cells };
    let validationErrors = {};
    if (validator && Object.keys(nextChanges).length && state.changes.originals[cell.row.id]) {
      const nextRowValue = { ...state.changes.originals[cell.row.id], ...changes, ...updatesForOtherCells };
      validationErrors = await validator(nextRowValue) ?? {};
    }
    const cellsToActOn = [cell.column.id, ...Object.keys(updatesForOtherCells)];
    const allCells = cell.row._getAllCellsByColumnId();
    cellsToActOn.forEach((accessor) => {
      var _a2;
      if (validationErrors[accessor]) {
        nextCellErrors[accessor] = validationErrors[accessor];
        delete nextMoveReasons[accessor];
      } else {
        delete nextCellErrors[accessor];
        if ((_a2 = allCells[accessor]) == null ? void 0 : _a2.column.getIsSorted()) {
          const reason = willRowMove(cell, nextChanges[accessor], rowIndex, localization);
          if (reason) {
            nextMoveReasons[accessor] = reason;
          } else {
            delete nextMoveReasons[accessor];
          }
        }
      }
    });
    dispatch({
      type: "updateRow",
      rowId: cell.row.id,
      payload: {
        cellErrors: nextCellErrors,
        index: rowIndex,
        moveReasons: nextMoveReasons,
        value: nextChanges
      }
    });
  }
  function getErrorsShownInAlert() {
    const rowsWithErrors = Object.keys(state.changes.errors);
    if (!rowsWithErrors.length) {
      return [];
    }
    return rowsWithErrors.filter(hasRowErrorsShownInAlert).map((rowId) => ({
      rowId,
      index: state.indexes[rowId],
      changes: state.changes.rows[rowId],
      errors: state.changes.errors[rowId]
    }));
  }
  function hasSaved() {
    return !!Object.values(state.changes.status).filter((value) => value === "saved").length;
  }
  function hasChanges(rowId) {
    return rowId ? !!state.changes.rows[rowId] : !!Object.keys(state.changes.rows).length;
  }
  async function saveChanges(table, rowId = void 0) {
    var _a, _b, _c;
    if (!handleSave) {
      console.warn("Tried to save, but Table has no onEditingSave handler");
      return false;
    }
    const changes = rowId ? { [rowId]: state.changes.rows[rowId] } : state.changes.rows;
    let completed = true;
    for (const rowId2 of Object.keys(changes)) {
      const status = getRowStatus(rowId2);
      try {
        const rowChanges = JSON.parse(JSON.stringify(changes[rowId2] ?? {}));
        if (!Object.keys(rowChanges).length || status === "saving" || status === "errored") {
          continue;
        }
        setRowStatus(rowId2, "saving");
        const changeSet = { ...state.changes.originals[rowId2], ...rowChanges };
        if (isTemporaryRow(changeSet[rowIdentityAccessor])) {
          delete changeSet[rowIdentityAccessor];
        }
        if (validator) {
          const errors = await validator(changeSet);
          if (errors && Object.keys(errors).length) {
            throw errors;
          }
        }
        await handleSave(changeSet);
        await complete(rowId2, table, rowChanges);
        setRowStatus(rowId2, "saved");
        setTimeout(() => {
          setRowStatus(rowId2, void 0);
        }, DELAY_BEFORE_REMOVING_SAVE_STATUS);
      } catch (error) {
        if (error instanceof ReferenceError || error instanceof TypeError || ((_a = error == null ? void 0 : error.response) == null ? void 0 : _a.status) >= 500) {
          console.error(error);
        }
        let rowError;
        let cellErrors;
        if (typeof error === "string") {
          rowError = error;
        } else if (error instanceof Error) {
          rowError = error.message;
          if (typeof ((_b = error.response) == null ? void 0 : _b.data) === "object") {
            cellErrors = (_c = error.response) == null ? void 0 : _c.data;
          }
        } else if (typeof error === "object") {
          cellErrors = error;
        }
        if (rowError || cellErrors) {
          dispatch({
            type: "setRowErrors",
            rowId: rowId2,
            payload: {
              row: rowError,
              cells: cellErrors,
              shouldShowErrorAlert: true
            }
          });
        }
        setRowStatus(rowId2, "errored");
        completed = false;
      }
    }
    return completed;
  }
  async function discardChanges(rowId, table) {
    table.resetRowPinning(true);
    dispatch({
      type: "removeRow",
      rowId,
      payload: { rowIdentityAccessor }
    });
    if (typeof handleDiscard === "function") {
      await handleDiscard();
    }
  }
  async function complete(rowId, table, changes) {
    const handleDiscard2 = async () => {
      await discardChanges(rowId, table);
    };
    dispatch({
      type: "complete",
      rowId,
      payload: { rowIdentityAccessor, changes, handleDiscard: handleDiscard2 }
    });
  }
  return {
    // row
    getRowValue,
    getRowMoveReason,
    hasRowErrors,
    hasRowErrorsShownInAlert,
    hasTemporaryRowErrors,
    getRowStatus,
    setRowStatus,
    // cells
    setCellValue,
    getCellValue,
    getCellError,
    onCellChanged,
    // general
    getErrorsShownInAlert,
    hasChanges,
    saveChanges,
    discardChanges,
    hasSaved,
    // new rows
    insertTemporaryRow,
    temporaryRows: state.temporaryRows
  };
}
function useTableEditing(isEnabled = false, handleSave, handleChange, handleCreate, handleDiscard, rowIdentityAccessor, validator) {
  const [isEditing, setEditing] = React__default.useState(false);
  const [isDetailedMode, toggleDetailedMode] = React__default.useState(false);
  const createRowButtonRef = React__default.useRef(null);
  const [lastFocusedCellIndex, setLastFocusedCellIndex] = React__default.useState(void 0);
  const pendingChangesFns = usePendingChangesState(
    handleSave,
    handleChange,
    handleDiscard,
    rowIdentityAccessor,
    validator
  );
  function toggleEditing(enabled, table, scrollToIndex) {
    var _a, _b;
    const tableMeta = table.options.meta;
    if (enabled) {
      const index2 = tableMeta.rowActive.rowActiveIndex ?? 0;
      if (tableMeta.rowActive.rowActiveIndex === void 0) {
        tableMeta.rowActive.setRowActiveIndex(index2);
      }
      if (!isTemporaryRow((_a = table.getRowModel().rows[index2]) == null ? void 0 : _a.id)) {
        scrollToIndex(index2);
      }
    } else if (!enabled) {
      toggleDetailedMode(false);
      setLastFocusedCellIndex(void 0);
    }
    setEditing(enabled);
    pendingChangesFns.saveChanges(table);
    (_b = tableMeta.onEvent) == null ? void 0 : _b.call(tableMeta, "editing-mode", { enabled });
  }
  async function createRow2(table, row) {
    if (!handleCreate) {
      return;
    }
    const tableMeta = table.options.meta;
    if (tableMeta.rowActive.rowActiveIndex !== void 0) {
      const saved = await tableMeta.editing.saveChanges(table);
      if (!saved) {
        return;
      }
    }
    const changeset = row ?? handleCreate();
    try {
      if (changeset) {
        const temporaryRows = tableMeta.editing.temporaryRows;
        const nextRowIndex = temporaryRows.length ? tableMeta.length + 1 : tableMeta.length;
        const newRowId = pendingChangesFns.insertTemporaryRow(changeset, nextRowIndex);
        table.setRowPinning((currentState) => {
          var _a;
          return {
            ...currentState,
            bottom: (_a = currentState.bottom ?? []) == null ? void 0 : _a.concat(newRowId)
          };
        });
        toggleDetailedMode(false);
        setLastFocusedCellIndex(void 0);
        requestAnimationFrame(() => {
          tableMeta.rowActive.setRowActiveIndex(nextRowIndex);
          table.resetRowSelection();
          if (!tableMeta.editing.isEditing) {
            setEditing(true);
          }
        });
      }
    } catch (error) {
      console.error(error);
    }
  }
  return {
    isEnabled,
    isEditing,
    isDetailedMode,
    toggleDetailedMode: isEnabled ? toggleDetailedMode : () => void 0,
    toggleEditing: isEnabled ? toggleEditing : () => void 0,
    lastFocusedCellIndex,
    setLastFocusedCellIndex,
    createRow: createRow2,
    createRowButtonRef,
    ...pendingChangesFns
  };
}
function RowMoveIndicator(props) {
  const { cell, cellRef, isActiveRow } = props;
  const { texts } = useLocalization();
  const [show, setShow] = React__default.useState(false);
  const tableMeta = cell.getContext().table.options.meta;
  const columnMeta = cell.column.columnDef.meta ?? {};
  const moveReason = tableMeta.editing.getRowMoveReason(cell.row.id);
  React__default.useEffect(() => {
    var _a, _b, _c;
    if (cellRef.current) {
      if (isActiveRow && !!moveReason) {
        const firstChild = (_a = cellRef.current.parentElement) == null ? void 0 : _a.querySelector(`td[data-taco="cell-control"]`);
        if (cellRef.current === firstChild) {
          setShow(true);
          (_b = cellRef.current.parentElement) == null ? void 0 : _b.setAttribute("data-row-editing-move", "true");
        }
      } else {
        setShow(false);
        (_c = cellRef.current.parentElement) == null ? void 0 : _c.removeAttribute("data-row-editing-move");
      }
    }
    return () => {
      var _a2;
      if (cellRef.current) {
        (_a2 = cellRef.current.parentElement) == null ? void 0 : _a2.removeAttribute("data-row-editing-move");
      }
    };
  }, [cellRef, isActiveRow, moveReason]);
  if (!show) {
    return null;
  }
  const { title, description } = getMessageFromReason(texts, moveReason);
  return /* @__PURE__ */ React__default.createElement(Tooltip$3, { placement: "bottom", title: description.replace("[COLUMN]", columnMeta.header) }, /* @__PURE__ */ React__default.createElement("span", { "data-row-move-indicator": true }, /* @__PURE__ */ React__default.createElement(Icon$1, { name: "info", className: "-mt-0.5 mr-1 !h-4 !w-4 rounded-full bg-white !p-0 text-blue-500" }), title));
}
function getMessageFromReason(texts, reason) {
  let title = "";
  let description = "";
  switch (reason) {
    case "filter":
      title = texts.table3.editing.rowIndicator.rowWillBeHidden;
      description = texts.table3.editing.rowIndicator.rowWillMoveReasonFilter;
      break;
    case "search":
      title = texts.table3.editing.rowIndicator.rowWillBeHidden;
      description = texts.table3.editing.rowIndicator.rowWillMoveReasonSearch;
      break;
    case "sorting":
      title = texts.table3.editing.rowIndicator.rowWillMove;
      description = texts.table3.editing.rowIndicator.rowWillMoveReasonSorting;
      break;
  }
  return { title, description };
}
const Textarea = React.forwardRef(function Textarea2(props, ref) {
  const { defaultValue: _, highlighted, invalid, onKeyDown, ...otherProps } = props;
  const classNames = clsx(
    getInputClasses(props),
    "pt-[5px] pb-[7px] min-h-[75px] disabled:resize-none !leading-5",
    props.className
  );
  const handleKeyDown = (event) => {
    if (event.key.length === 1 && !isPressingMetaKey(event)) {
      event.stopPropagation();
    }
    if (event.key === "Home" || event.key === "End") {
      event.preventDefault();
      const position = event.key === "End" ? event.currentTarget.value.length : 0;
      event.currentTarget.setSelectionRange(position, position);
      event.currentTarget.scrollTop = event.key === "End" ? event.currentTarget.scrollHeight : 0;
    }
    if (onKeyDown) {
      onKeyDown(event);
    }
  };
  return /* @__PURE__ */ React.createElement("textarea", { ...otherProps, className: classNames, "data-taco": "textarea", onKeyDown: handleKeyDown, ref });
});
const TextareaWithAutosizing = React__default.forwardRef(
  function TextareaWithAutosizing2(props, ref) {
    const { fontSize, isTruncated, ...attributes } = props;
    const internalRef = useMergedRef(ref);
    const initialHeightRef = React__default.useRef(0);
    React__default.useLayoutEffect(() => {
      if (internalRef.current) {
        initialHeightRef.current = internalRef.current.getBoundingClientRect().height;
        if (!isTruncated) {
          toggleHeight();
        }
      }
    }, [fontSize]);
    const toggleHeight = (reset = false) => {
      if (internalRef.current) {
        if (reset) {
          if (isTruncated) {
            internalRef.current.style.height = `${initialHeightRef.current}px`;
          }
        } else {
          internalRef.current.style.height = "inherit";
          if (isTruncated) {
            internalRef.current.style.height = `${Math.min(
              internalRef.current.scrollHeight,
              initialHeightRef.current * 3
            )}px`;
          } else {
            internalRef.current.style.height = `${internalRef.current.scrollHeight}px`;
          }
        }
      }
    };
    const handleFocus = (event) => {
      var _a;
      toggleHeight();
      (_a = props.onFocus) == null ? void 0 : _a.call(props, event);
    };
    const handleBlur = (event) => {
      var _a;
      if (isTruncated) {
        toggleHeight(true);
      }
      event.target.scrollTop = 0;
      (_a = props.onBlur) == null ? void 0 : _a.call(props, event);
    };
    const handleChange = (event) => {
      var _a;
      toggleHeight();
      (_a = props.onChange) == null ? void 0 : _a.call(props, event);
    };
    const textarea = /* @__PURE__ */ React__default.createElement(
      Textarea,
      {
        ...attributes,
        rows: 1,
        onBlur: handleBlur,
        onChange: handleChange,
        onFocus: handleFocus,
        ref: internalRef
      }
    );
    if (isTruncated) {
      return /* @__PURE__ */ React__default.createElement("div", { className: "relative inline-flex w-full focus-within:z-30", "data-taco": "input-container" }, textarea);
    }
    return textarea;
  }
);
function useEditingCellAutofocus(props) {
  const focusManager = useAugmentedFocusManager();
  const { rowIndex } = React__default.useContext(RowContext);
  const table = props.cell.getContext().table;
  const tableMeta = table.options.meta;
  const isActiveRow = tableMeta.rowActive.rowActiveIndex === rowIndex;
  const autoFocus = props.index === tableMeta.editing.lastFocusedCellIndex && isActiveRow;
  React__default.useEffect(() => {
    var _a, _b, _c, _d;
    if (props.cellRef.current) {
      const isFocusedElementInCurrentRow = (_a = props.cellRef.current.closest("tr")) == null ? void 0 : _a.contains(document.activeElement);
      const isFocusedElementSearch = ((_b = document.activeElement) == null ? void 0 : _b.getAttribute("name")) === "table-search";
      const isFocusedElementMenu = ((_c = document.activeElement) == null ? void 0 : _c.getAttribute("role")) === "menu";
      if (autoFocus && !isFocusedElementInCurrentRow && !isFocusedElementSearch && !isFocusedElementMenu) {
        (_d = props.cellRef.current) == null ? void 0 : _d.focus();
      }
    }
  }, [tableMeta.rowActive.rowActiveIndex]);
  const handleFocus = (event) => {
    var _a;
    const tableElement = (_a = props.cellRef.current) == null ? void 0 : _a.closest("table");
    if (tableElement && table.getIsSomeColumnsPinned() && !props.cell.column.getIsPinned()) {
      const columnFreezingOffset = table.getLeftTotalSize();
      const targetRect = event.currentTarget.getBoundingClientRect();
      const tableRect = tableElement.getBoundingClientRect();
      const leftOffsetFromScrollContainer = targetRect.left - tableRect.left;
      const scrollbarWidth = tableElement.offsetWidth - tableElement.clientWidth;
      const isFocusedElementMenu = event.currentTarget.getAttribute("data-cell-id") === "__actions";
      if (
        // When pinned column overlaps the focused cell
        (leftOffsetFromScrollContainer < columnFreezingOffset || // When focused cell goes behidn the edge of the table
        leftOffsetFromScrollContainer + targetRect.width > tableRect.width - scrollbarWidth) && !isFocusedElementMenu
      ) {
        tableElement.scrollTo(props.cell.column.getStart() - columnFreezingOffset, tableElement.scrollTop);
      }
    }
    if (event.target === event.currentTarget && hasFocusableElement(event.currentTarget)) {
      focusManager.focusNext();
    }
  };
  return handleFocus;
}
function EditingControlCell(props) {
  const { cell, cellRef, isHighlighted, index: index2 } = props;
  const { rowIndex } = React__default.useContext(RowContext);
  const { table } = cell.getContext();
  const tableMeta = table.options.meta;
  const columnMeta = cell.column.columnDef.meta;
  const isActiveRow = tableMeta.rowActive.rowActiveIndex === rowIndex;
  const type = columnMeta.control ?? "input";
  const handleFocus = useEditingCellAutofocus(props);
  const value = cell.getValue();
  const hasNonTextControl = React__default.useMemo(() => {
    var _a;
    return typeof type === "function" && !!((_a = cellRef.current) == null ? void 0 : _a.querySelector('[data-taco="Select2"],[data-taco="switch"],[data-taco="checkbox"]'));
  }, [cellRef.current]);
  const handleChange = React__default.useCallback(
    (nextValue) => {
      if (nextValue !== value) {
        tableMeta.editing.setCellValue(cell, rowIndex, nextValue);
        if (hasNonTextControl) {
          requestAnimationFrame(() => tableMeta.editing.onCellChanged(cell, rowIndex, nextValue));
        }
      }
    },
    [hasNonTextControl, cell.row.id, cell.column.id, cell.row.original, rowIndex, value]
  );
  const blur = React__default.useCallback(
    function blur2() {
      requestAnimationFrame(() => {
        tableMeta.editing.toggleDetailedMode(false);
        tableMeta.editing.onCellChanged(cell, rowIndex, void 0, !hasNonTextControl);
      });
    },
    [hasNonTextControl, cell.row.id, cell.column.id, cell.row.original, rowIndex]
  );
  const handleBlur = React__default.useCallback(
    (event) => {
      if (isElementInsideOrTriggeredFromContainer(event.relatedTarget, event.currentTarget)) {
        return;
      }
      blur();
    },
    [blur]
  );
  React__default.useEffect(() => {
    const ref = cellRef.current;
    return () => {
      if (document.activeElement === ref || isElementInsideOrTriggeredFromContainer(document.activeElement, ref)) {
        blur();
      }
    };
  }, []);
  const error = tableMeta.editing.getCellError(cell);
  const controlProps = {
    dataType: columnMeta.dataType,
    fontSize: tableMeta.fontSize.size,
    id: cell.column.id,
    invalid: !!error,
    isDetailedMode: tableMeta.editing.isDetailedMode,
    isTruncated: !!columnMeta.enableTruncate,
    onBlur: handleBlur,
    onChange: handleChange,
    row: cell.row.original,
    rowPendingChanges: tableMeta.editing.getRowValue(cell.row.id),
    tabIndex: isActiveRow ? 0 : -1,
    toggleDetailedMode: tableMeta.editing.toggleDetailedMode,
    type,
    value
  };
  const cellAttributes = {
    ...getCellAttributes(cell, index2, isHighlighted),
    "data-cell-editing-invalid": error ? true : void 0,
    "data-taco": "cell-control",
    onFocus: handleFocus,
    ref: cellRef,
    tabIndex: -1
  };
  return /* @__PURE__ */ React__default.createElement("td", { ...cellAttributes }, /* @__PURE__ */ React__default.createElement(Field, { invalid: !!error, message: error }, /* @__PURE__ */ React__default.createElement(MemoedEditingCell, { ...controlProps })), /* @__PURE__ */ React__default.createElement(RowMoveIndicator, { cell, cellRef, isActiveRow }));
}
const MemoedEditingCell = React__default.memo(function MemoedEditingCell2(props) {
  const {
    dataType,
    fontSize,
    id: id2,
    invalid,
    isDetailedMode,
    isTruncated,
    onBlur,
    onChange,
    row,
    rowPendingChanges,
    tabIndex = -1,
    toggleDetailedMode,
    type = "input",
    value
  } = props;
  const controlRef = React__default.useRef(null);
  const currentValue = row[id2];
  const commonProps = {
    onBlur,
    ref: controlRef,
    tabIndex
  };
  const handleInputKeyDown = (event) => {
    var _a, _b, _c, _d;
    const target = event.target;
    if (target.readOnly) {
      return;
    }
    if (isDetailedMode && (event.key === "ArrowUp" || event.key === "ArrowDown" || event.key === "ArrowLeft" || event.key === "ArrowRight")) {
      event.stopPropagation();
    }
    if (event.key === "Enter") {
      if (event.shiftKey && isDetailedMode) {
        return;
      }
      event.preventDefault();
      if (isDetailedMode) {
        (_a = target.select) == null ? void 0 : _a.call(target);
      } else {
        (_d = target.setSelectionRange) == null ? void 0 : _d.call(target, (_b = target.value) == null ? void 0 : _b.length, (_c = target.value) == null ? void 0 : _c.length);
      }
      toggleDetailedMode((editing) => !editing);
      return;
    }
    if (event.key === "Escape") {
      if (isDetailedMode) {
        event.preventDefault();
        toggleDetailedMode(false);
        if (value !== currentValue) {
          props.onChange(currentValue);
        }
        requestAnimationFrame(() => {
          var _a2;
          return (_a2 = target.select) == null ? void 0 : _a2.call(target);
        });
      }
      return;
    }
    if (!isPressingMetaKey(event) && (/^[a-z0-9]$/i.test(event.key) || event.key === "Backspace")) {
      toggleDetailedMode(true);
    }
  };
  if (typeof type === "function") {
    const controlFnProps = {
      ...commonProps,
      invalid,
      setValue: onChange,
      onKeyDown: (event) => {
        const target = event.target || null;
        if (target && (target.tagName === "INPUT" || target.tagName === "TEXTAREA")) {
          handleInputKeyDown(event);
        }
      },
      value
    };
    return type(controlFnProps, { ...row, ...rowPendingChanges });
  }
  if (type === "switch") {
    return /* @__PURE__ */ React__default.createElement(
      Switch$1,
      {
        ...commonProps,
        checked: Boolean(value),
        onChange,
        ref: controlRef
      }
    );
  }
  if (type === "checkbox") {
    return /* @__PURE__ */ React__default.createElement(
      Checkbox$2,
      {
        ...commonProps,
        checked: Boolean(value),
        onChange,
        ref: controlRef
      }
    );
  }
  const handleFocus = (event) => {
    if (!isDetailedMode) {
      event.target.select();
    }
  };
  if (type === "datepicker") {
    const valueAsDate = parse$1(value);
    const handleChange2 = (event) => {
      const newDate2 = event.detail;
      if (!valueAsDate || !newDate2 || isDate(valueAsDate) && isDate(newDate2) && !isWeakEqual$1(valueAsDate, newDate2)) {
        props.onChange(newDate2);
      }
    };
    const handleDatepickerInputKeyDown = (event) => {
      var _a, _b;
      if (isDetailedMode && event.key === "Enter" && event.target.value !== "") {
        (_b = (_a = event.target).select) == null ? void 0 : _b.call(_a);
        return;
      }
      handleInputKeyDown(event);
    };
    return /* @__PURE__ */ React__default.createElement(
      Datepicker,
      {
        ...commonProps,
        invalid,
        onChange: handleChange2,
        onFocus: handleFocus,
        onKeyDown: handleDatepickerInputKeyDown,
        ref: controlRef,
        value: valueAsDate
      }
    );
  }
  if (type === "textarea") {
    const handleChange2 = (event) => {
      onChange(event.target.value);
    };
    return /* @__PURE__ */ React__default.createElement(
      TextareaWithAutosizing,
      {
        ...commonProps,
        fontSize,
        invalid,
        isTruncated,
        onChange: handleChange2,
        onFocus: handleFocus,
        onKeyDown: handleInputKeyDown,
        ref: controlRef,
        value: String(value ?? "")
      }
    );
  }
  const handleChange = (event) => {
    onChange(dataType === "number" && event.target.value ? Number.parseInt(event.target.value) : event.target.value);
  };
  return /* @__PURE__ */ React__default.createElement(
    Input,
    {
      ...commonProps,
      invalid,
      onChange: handleChange,
      onFocus: handleFocus,
      onKeyDown: handleInputKeyDown,
      ref: controlRef,
      type: dataType === "number" ? "number" : void 0,
      value: dataType === "number" ? value : String(value ?? "")
    }
  );
});
const EditingDisplayCell = React__default.memo(function EditingDisplayCell2(props) {
  const handleFocus = useEditingCellAutofocus(props);
  return /* @__PURE__ */ React__default.createElement(DisplayCell, { ...props, onFocus: handleFocus, tabIndex: -1 });
});
function Cell$1(props) {
  const { cell } = props;
  const { isHovered, rowIndex } = React__default.useContext(RowContext);
  const tableMeta = cell.getContext().table.options.meta;
  const columnMeta = cell.column.columnDef.meta;
  if (tableMeta.editing.isEditing) {
    if (columnMeta.control && columnMeta.enableEditing) {
      const isActiveRow = tableMeta.rowActive.rowActiveIndex === rowIndex;
      const cellError = tableMeta.editing.getCellError(cell);
      const hasErrorAndIsEditing = cellError ? tableMeta.editing.isEditing : true;
      const changedValue = tableMeta.editing.getCellValue(cell);
      if (changedValue !== void 0 && changedValue !== cell.getValue() && hasErrorAndIsEditing) {
        cell.getValue = () => changedValue;
      }
      if (isActiveRow || !!cellError || isHovered && !isActiveRow && !tableMeta.rowActive.isHoverStatePaused) {
        return /* @__PURE__ */ React__default.createElement(EditingControlCell, { ...props });
      }
    }
    return /* @__PURE__ */ React__default.createElement(EditingDisplayCell, { ...props });
  }
  return /* @__PURE__ */ React__default.createElement(DisplayCell, { ...props });
}
function DiscardChangesConfirmationDialog(props) {
  const { onDiscard: handleDiscard, ...dialogProps } = props;
  const { texts } = useLocalization();
  const handleClickInsideDialogContent = (event) => {
    event.stopPropagation();
  };
  return /* @__PURE__ */ React__default.createElement(Dialog, { ...dialogProps }, /* @__PURE__ */ React__default.createElement(
    Dialog.Content,
    {
      "aria-label": texts.table3.editing.clearChangesConfirmationDialog.title,
      onClick: handleClickInsideDialogContent
    },
    /* @__PURE__ */ React__default.createElement(Dialog.Title, null, texts.table3.editing.clearChangesConfirmationDialog.title),
    /* @__PURE__ */ React__default.createElement("p", null, texts.table3.editing.clearChangesConfirmationDialog.description),
    /* @__PURE__ */ React__default.createElement(Dialog.Footer, null, /* @__PURE__ */ React__default.createElement(Group$6, null, /* @__PURE__ */ React__default.createElement(Dialog.Close, null, /* @__PURE__ */ React__default.createElement(Button$4, { tabIndex: 0 }, texts.table3.editing.clearChangesConfirmationDialog.cancel)), /* @__PURE__ */ React__default.createElement(Dialog.Close, null, /* @__PURE__ */ React__default.createElement(Button$4, { tabIndex: 0, appearance: "primary", onClick: handleDiscard }, texts.table3.editing.clearChangesConfirmationDialog.confirm))))
  ));
}
function EditingActionsMenu(props) {
  const { hasChanges, hasErrors, onDiscard: handleDiscard, onEditingSave: handleSave, isLastRow } = props;
  const { texts } = useLocalization();
  const handleKeyDown = (event) => {
    if (isLastRow && hasChanges && event.key === "Tab") {
      handleSave();
    }
  };
  const handleMenuContentKeyDown = (event) => {
    if (event.key === "ArrowLeft" || event.key === "ArrowRight") {
      event.stopPropagation();
    }
  };
  return /* @__PURE__ */ React__default.createElement(
    IconButton,
    {
      appearance: "transparent",
      "aria-label": texts.table3.editing.actions.tooltip,
      icon: "more",
      onKeyDown: handleKeyDown,
      menu: (menuProps) => /* @__PURE__ */ React__default.createElement(Menu$1, { ...menuProps }, /* @__PURE__ */ React__default.createElement(Menu$1.Content, { onKeyDown: handleMenuContentKeyDown }, /* @__PURE__ */ React__default.createElement(Menu$1.Item, { icon: "tick", disabled: !hasChanges || hasErrors, onClick: handleSave }, texts.table3.editing.actions.save), /* @__PURE__ */ React__default.createElement(
        Menu$1.Item,
        {
          icon: "close",
          disabled: !hasChanges,
          dialog: (props2) => /* @__PURE__ */ React__default.createElement(DiscardChangesConfirmationDialog, { ...props2, onDiscard: handleDiscard })
        },
        texts.table3.editing.actions.clear
      )))
    }
  );
}
function SaveStatus(props) {
  const { rowId, table } = props;
  const { texts } = useLocalization();
  const tableMeta = table.options.meta;
  const status = tableMeta.editing.getRowStatus(rowId);
  const className = clsx(
    "col-span-full sticky ml-auto right-0 top-0 -mb-[100%] z-10 h-8 bg-[inherit] flex items-center px-1.5 shadow-[-6px_0px_6px_var(--table-row-actions-shadow)]",
    {
      "mt-0.5": tableMeta.rowHeight.height === "short",
      "mt-1": tableMeta.rowHeight.height === "medium",
      "mt-1.5": tableMeta.rowHeight.height === "tall",
      "mt-2": tableMeta.rowHeight.height === "extra-tall"
    }
  );
  return /* @__PURE__ */ React__default.createElement("td", { className: "!contents" }, /* @__PURE__ */ React__default.createElement("span", { className }, status === "saving" ? /* @__PURE__ */ React__default.createElement(Tooltip$3, { title: texts.table3.editing.saving.progress }, /* @__PURE__ */ React__default.createElement(Spinner, { delay: 0, className: "mr-1 !h-5 !w-5" })) : /* @__PURE__ */ React__default.createElement(Tooltip$3, { title: texts.table3.editing.saving.complete }, /* @__PURE__ */ React__default.createElement(BadgeIcon, { icon: "tick", color: "green", subtle: true, className: "mr-1" }))));
}
function Row(props) {
  const { row, index: index2, table } = props;
  const focusManager = useAugmentedFocusManager();
  const tableMeta = table.options.meta;
  const isActiveRow = tableMeta.rowActive.rowActiveIndex === index2;
  React__default.useEffect(() => {
    if (tableMeta.editing.isEditing && isActiveRow && tableMeta.editing.lastFocusedCellIndex === void 0) {
      const element = focusManager.focusFirst();
      if (element) {
        setDataFocusAttribute(element);
      }
    }
  }, [tableMeta.editing.isEditing, tableMeta.rowActive.rowActiveIndex, tableMeta.editing.lastFocusedCellIndex]);
  const handleFocus = React__default.useCallback(
    (event) => {
      var _a;
      if (tableMeta.editing.isEditing) {
        const cellIndex = Number(((_a = event.target.closest("td")) == null ? void 0 : _a.getAttribute("data-cell-index")) ?? void 0);
        if (!isNaN(cellIndex)) {
          tableMeta.editing.setLastFocusedCellIndex(Number(cellIndex));
        }
      }
    },
    [tableMeta.editing.isEditing, isActiveRow]
  );
  const rowStatus = tableMeta.editing.getRowStatus(row.id);
  const [showDiscardDialog, setShowDiscardDialog] = React__default.useState(false);
  function handleDiscard() {
    tableMeta.editing.discardChanges(row.id, table);
    requestAnimationFrame(() => {
      var _a;
      if (isTemporaryRow(row.id)) {
        (_a = tableMeta.editing.createRowButtonRef.current) == null ? void 0 : _a.focus();
      } else {
        focusManager.focusFirst();
      }
    });
  }
  function handleKeyDown(event) {
    if (props.onKeyDown) {
      props.onKeyDown(event);
    }
    if (event.isDefaultPrevented() || event.isPropagationStopped()) {
      return;
    }
    if (event.key === "Escape" && tableMeta.editing.hasChanges(row.id) && !isElementTriggeredFromContainer(event.target, event.currentTarget)) {
      event.preventDefault();
      setShowDiscardDialog(true);
    }
  }
  const attributes = {
    "data-row-editing-invalid": tableMeta.editing.hasRowErrors(row.id) ? !tableMeta.editing.hasRowErrorsShownInAlert(row.id) ? "unseen" : true : void 0,
    "data-row-editing-status": rowStatus,
    onFocus: handleFocus,
    onKeyDown: handleKeyDown
  };
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(DisplayRow, { ...props, ...attributes }, rowStatus === "saving" || rowStatus === "saved" ? /* @__PURE__ */ React__default.createElement(SaveStatus, { rowId: row.id, table }) : null), /* @__PURE__ */ React__default.createElement(
    DiscardChangesConfirmationDialog,
    {
      open: showDiscardDialog,
      onChange: setShowDiscardDialog,
      onDiscard: handleDiscard
    }
  ));
}
const RENDERERS = {
  row: Row,
  cell: Cell$1
};
function useTable3(props, ref) {
  const editing = useTableEditing(
    props.enableEditing,
    props.onEditingSave,
    props.onEditingChange,
    props.onEditingCreate,
    props.onEditingDiscard,
    props.rowIdentityAccessor,
    props.validator
  );
  const creationEnabled = editing.isEnabled && !!props.onEditingCreate;
  const data = React__default.useMemo(() => {
    if (editing.temporaryRows.length) {
      return (props.data ?? []).concat(editing.temporaryRows);
    }
    return props.data;
  }, [JSON.stringify(props.data), editing.temporaryRows.length]);
  const extendedProps = {
    ...props,
    data,
    enableRowActions: editing.isEditing ? true : props.enableRowActions,
    // Display EditingActionMenu instead of row actions while editing
    rowActions: editing.isEditing ? [
      (_, rowId, __, table2) => {
        const tableMeta = table2.options.meta;
        return /* @__PURE__ */ React__default.createElement(
          EditingActionsMenu,
          {
            hasChanges: editing.hasChanges(rowId),
            hasErrors: editing.hasRowErrors(rowId),
            onDiscard: () => {
              editing.discardChanges(rowId, table2);
              if (editing.temporaryRows.length) {
                requestAnimationFrame(() => {
                  var _a;
                  return (_a = editing.createRowButtonRef.current) == null ? void 0 : _a.focus();
                });
              }
            },
            onEditingSave: async () => {
              await editing.saveChanges(table2, rowId);
            },
            isLastRow: !creationEnabled && tableMeta.rowActive.rowActiveIndex === tableMeta.length - 1
          }
        );
      }
    ] : props.rowActions
  };
  const meta = { editing };
  const options = {
    virtualiserPaddingEndOffset: props.enableEditing && props.onEditingCreate ? editing.hasTemporaryRowErrors() ? 1.4 : 1 : 0
  };
  const table = useTable$1(extendedProps, ref, RENDERERS, meta, options);
  useTableEditingListener(table.instance, table.ref, table.renderer.scrollToIndex);
  React__default.useEffect(() => {
    if (table.ref.current) {
      table.ref.current.instance.toggleEditing = (enabled) => table.meta.editing.toggleEditing(enabled ?? ((editing2) => !editing2), table.instance, table.renderer.scrollToIndex);
      if (props.onEditingCreate) {
        table.ref.current.instance.createRow = (row) => table.meta.editing.createRow(table.instance, row);
      }
    }
  }, [table.ref.current]);
  return table;
}
function Alert(props) {
  const { scrollToIndex, table, tableRef, ...attributes } = props;
  const { texts } = useLocalization();
  const validationTexts = texts.table3.editing.validation;
  const tableMeta = table.options.meta;
  const [showFilterResetDialog, setShowFilterResetDialog] = React__default.useState(false);
  const pendingChangesWithErrors = tableMeta.editing.getErrorsShownInAlert();
  function scrollToRow(rowIndex) {
    tableMeta.rowActive.setRowActiveIndex(rowIndex);
    scrollToIndex(rowIndex, { align: "center" });
    requestAnimationFrame(() => {
      var _a, _b;
      const cell = (_a = tableRef.current) == null ? void 0 : _a.querySelector(
        'tbody > tr[data-row-active="true"] > td[data-cell-editing-invalid="true"]'
      );
      if (cell) {
        (_b = cell.focus) == null ? void 0 : _b.call(cell);
      }
    });
  }
  const title = (pendingChangesWithErrors.length === 1 ? validationTexts.alert.titleOne : validationTexts.alert.titlePlural).replace("[COUNT]", String(pendingChangesWithErrors.length));
  const links = [];
  const visibleColumns2 = table.getVisibleFlatColumns().map((c3) => c3.id);
  const rowIdentityColumn = tableMeta.rowIdentityAccessor && visibleColumns2.includes(String(tableMeta.rowIdentityAccessor)) ? (
    // table.getColumn(columName) throw error in strict dev mode. Related thread: https://github.com/TanStack/table/discussions/5505
    table.getAllColumns().find((x3) => x3.id === String(tableMeta.rowIdentityAccessor))
  ) : void 0;
  pendingChangesWithErrors.forEach((pendingChangeWithError, index2) => {
    var _a, _b;
    if (pendingChangesWithErrors.length > 1 && index2 === pendingChangesWithErrors.length - 1) {
      links.push(` ${validationTexts.alert.messageAnd} `);
    }
    const handleClick = () => {
      if (pendingChangeWithError.index > -1) {
        scrollToRow(pendingChangeWithError.index);
        tableMeta.rowActive.setRowActiveIndex(pendingChangeWithError.index);
      } else {
        setShowFilterResetDialog(pendingChangeWithError.index);
      }
    };
    let tooltip;
    if (pendingChangeWithError.errors.row) {
      tooltip = pendingChangeWithError.errors.row;
    } else {
      const firstCellErrorColumnId = Object.keys(pendingChangeWithError.errors.cells)[0];
      const columnName = (_b = (_a = table.getAllColumns().find((column) => column.id === firstCellErrorColumnId)) == null ? void 0 : _a.columnDef.meta) == null ? void 0 : _b.header;
      tooltip = `${columnName}: ${pendingChangeWithError.errors.cells[firstCellErrorColumnId]}`;
    }
    let row;
    try {
      row = table.getRow(pendingChangeWithError.rowId).original;
    } catch {
    }
    links.push(
      /* @__PURE__ */ React__default.createElement(Tooltip$3, { key: pendingChangeWithError.rowId, title: tooltip }, /* @__PURE__ */ React__default.createElement("span", { className: "text-blue", onClick: handleClick, role: "button" }, rowIdentityColumn ? row == null ? void 0 : row[rowIdentityColumn.id] : pendingChangeWithError.index + 1))
    );
    if (pendingChangesWithErrors.length > 2 && index2 < pendingChangesWithErrors.length - 2) {
      links.push(", ");
    }
  });
  const message = (links.length === 1 ? validationTexts.alert.messageOne : validationTexts.alert.messagePlural).split(/(\[\w+\])/).map((part) => {
    var _a;
    if (part === "[COLUMN]") {
      return ((_a = rowIdentityColumn == null ? void 0 : rowIdentityColumn.columnDef.meta) == null ? void 0 : _a.header) ?? validationTexts.alert.messageRow;
    }
    if (part === "[ROW]") {
      return links;
    }
    return part;
  });
  const handleResetFilters = () => {
    table.resetGlobalFilter();
    table.resetColumnFilters();
    requestAnimationFrame(() => {
      if (showFilterResetDialog && showFilterResetDialog > -1) {
        scrollToRow(showFilterResetDialog);
      }
      setShowFilterResetDialog(false);
    });
  };
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Alert$1, { ...attributes, state: "error" }, /* @__PURE__ */ React__default.createElement("span", { className: "font-bold" }, title), " ", message), /* @__PURE__ */ React__default.createElement(
    FilterResetDialog,
    {
      open: showFilterResetDialog !== false,
      onChange: () => setShowFilterResetDialog(false),
      onSubmit: handleResetFilters
    }
  ));
}
function FilterResetDialog(props) {
  const { onSubmit: handleSubmit, ...dialogProps } = props;
  const { texts } = useLocalization();
  return /* @__PURE__ */ React__default.createElement(Dialog, { ...dialogProps, size: "xs" }, /* @__PURE__ */ React__default.createElement(Dialog.Content, { "aria-label": "Create a new account" }, /* @__PURE__ */ React__default.createElement(Dialog.Title, null, texts.table3.editing.validation.resetFiltersDialog.title), /* @__PURE__ */ React__default.createElement("p", null, texts.table3.editing.validation.resetFiltersDialog.description), /* @__PURE__ */ React__default.createElement(Dialog.Footer, null, /* @__PURE__ */ React__default.createElement(Group$6, null, /* @__PURE__ */ React__default.createElement(Dialog.Close, null, /* @__PURE__ */ React__default.createElement(Button$4, null, texts.table3.editing.validation.resetFiltersDialog.cancel)), /* @__PURE__ */ React__default.createElement(Button$4, { appearance: "primary", onClick: handleSubmit }, texts.table3.editing.validation.resetFiltersDialog.confirm)))));
}
function Editing(props) {
  const { scrollToIndex, table } = props;
  const { texts } = useLocalization();
  const ref = React__default.useRef(null);
  const tableMeta = table.options.meta;
  const handleChange = (enabled) => {
    tableMeta.editing.toggleEditing(enabled, table, scrollToIndex);
  };
  const tooltip = /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, texts.table3.editing.buttons.edit.tooltip, /* @__PURE__ */ React__default.createElement(Shortcut, { className: "ml-2", keys: shortcut }));
  return /* @__PURE__ */ React__default.createElement(Tooltip$3, { title: tooltip }, /* @__PURE__ */ React__default.createElement(ModeSwitch, { "data-table": "editing-toggle", checked: tableMeta.editing.isEditing, onChange: handleChange, ref }));
}
function CreateNewRow(props) {
  var _a, _b;
  const { buttonRef, isScrolled, table, tableMeta } = props;
  const { texts } = useLocalization();
  const temporaryRows = tableMeta.editing.temporaryRows;
  const temporaryRowId = ((_a = temporaryRows[0]) == null ? void 0 : _a[tableMeta.rowIdentityAccessor]) ?? "";
  const isDisabled = !!table.getState().globalFilter || !!((_b = table.getState().columnFilters) == null ? void 0 : _b.length) || !!temporaryRowId && !!tableMeta.editing.hasRowErrors(temporaryRowId);
  const isSaving = !!temporaryRowId && tableMeta.editing.getRowStatus(temporaryRowId) === "saving";
  const handleCreate = async () => {
    if (isDisabled) {
      return;
    }
    await tableMeta.editing.createRow(table);
  };
  const shortcut2 = { key: "Enter", meta: true };
  let tooltip;
  if (isSaving) {
    tooltip = texts.table3.editing.buttons.create.saving;
  } else if (isDisabled) {
    tooltip = texts.table3.editing.buttons.create.disabled;
  } else {
    tooltip = /* @__PURE__ */ React__default.createElement(Shortcut, { keys: shortcut2 });
  }
  const className = clsx("group/row border-grey-300 !sticky z-[21]", {
    "bottom-10": tableMeta.footer.isEnabled,
    "bottom-0": !tableMeta.footer.isEnabled,
    "border-b": !isScrolled
  });
  return /* @__PURE__ */ React__default.createElement("tr", { "data-row-create": true, className, tabIndex: -1 }, /* @__PURE__ */ React__default.createElement("td", { className: "!bg-grey-50 col-span-full !border-b-0 !px-1" }, /* @__PURE__ */ React__default.createElement(
    Button$4,
    {
      appearance: "transparent",
      className: "group-hover:bg-grey-200 sticky left-[4px]",
      disabled: isDisabled,
      onClick: handleCreate,
      ref: buttonRef,
      shortcut: shortcut2,
      tooltip
    },
    /* @__PURE__ */ React__default.createElement(Icon$1, { name: "circle-plus" }),
    texts.table3.editing.buttons.create.label
  )));
}
function TemporaryRow(props) {
  const { createRowButtonRef, isScrolled, table, tableMeta, tableRef } = props;
  const handleKeyDown = async (event) => {
    var _a, _b;
    if (event.key === "ArrowDown") {
      event.preventDefault();
      if (!isElementTriggeredFromContainer(event.target, event.currentTarget)) {
        const saved = await tableMeta.editing.saveChanges(table);
        if (saved) {
          (_a = createRowButtonRef.current) == null ? void 0 : _a.focus();
        }
      }
    } else if (event.key === "ArrowUp") {
      event.preventDefault();
      event.stopPropagation();
      if (tableRef.current) {
        const availableRows = Array.from(
          tableRef.current.querySelectorAll(`tbody tr:not([data-row-id^='${TEMPORARY_ROW_ID_PREFIX}'])`) ?? []
        );
        const footerHeight = ((_b = tableRef.current.querySelector("tfoot")) == null ? void 0 : _b.getBoundingClientRect().height) ?? 0;
        const newRowHeight = event.currentTarget.getBoundingClientRect().height;
        const visibleHeight = tableRef.current.clientHeight - footerHeight - newRowHeight;
        const tableTopOffset = tableRef.current.getBoundingClientRect().top;
        let nextRowIndex;
        for (let index2 = availableRows.length - 1; index2 >= 0; index2--) {
          const rowRect = availableRows[index2].getBoundingClientRect();
          const topPlusHalfRow = rowRect.top + rowRect.height / 2;
          if (topPlusHalfRow - tableTopOffset <= visibleHeight) {
            nextRowIndex = index2;
            break;
          }
        }
        if (nextRowIndex) {
          tableMeta.rowActive.setRowActiveIndex(
            Number(availableRows[nextRowIndex < 0 ? 0 : nextRowIndex].getAttribute("data-row-index"))
          );
        }
      }
    }
  };
  const handleKeyDownCapture = (event) => {
    if (event.key === "ArrowLeft" && tableMeta.editing.lastFocusedCellIndex === 0) {
      event.preventDefault();
      event.stopPropagation();
    } else if (event.key === "ArrowRight" && tableMeta.editing.lastFocusedCellIndex) {
      if (tableMeta.editing.lastFocusedCellIndex === table.getVisibleFlatColumns().length - 1) {
        event.preventDefault();
        event.stopPropagation();
      }
    }
  };
  const className = clsx("group/row border-grey-300 !sticky z-[22] print:hidden", {
    "bottom-[calc(5rem_+_2px)] data-[row-editing-move]:bottom-[calc(5rem_+_2px)]": tableMeta.footer.isEnabled,
    "bottom-[calc(2.5rem_+_2px)] data-[row-editing-move]:bottom-[calc(2.5rem_+_2px)]": !tableMeta.footer.isEnabled,
    "border-t-2 shadow-[0px_-5px_20px_0px_rgba(0,0,0,0.1)] [&>td]:!border-b-0": isScrolled
  });
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, table.getBottomRows().map((row) => /* @__PURE__ */ React__default.createElement(
    Row$2,
    {
      key: row.id,
      cellRenderer: RENDERERS.cell,
      index: tableMeta.length,
      measureRow: () => null,
      renderer: RENDERERS.row,
      row,
      table,
      className,
      onKeyDown: handleKeyDown,
      onKeyDownCapture: handleKeyDownCapture,
      hideInternalColumns: true,
      hideRowActions: !tableMeta.editing.isEditing,
      skipPageLoading: true
    }
  )));
}
const Column = () => null;
Column.displayName = "Table3Column";
function Group$1(_) {
  return null;
}
Group$1.displayName = "Table3Group";
const BaseTable3 = fixedForwardRef(function BaseTable32(props, ref) {
  var _a, _b;
  const table3 = useTable3(props, ref);
  const gridAttributes = {
    "data-table-editing-mode": ((_a = table3.meta.editing) == null ? void 0 : _a.isEditing) ? ((_b = table3.meta.editing) == null ? void 0 : _b.isDetailedMode) ? "detailed" : "normal" : void 0,
    enableHorizontalArrowKeyNavigation: table3.meta.editing.isEditing
  };
  const rowsById = table3.instance.getCoreRowModel().rowsById;
  const hasAlertErrors = table3.meta.editing.getErrorsShownInAlert().filter((row) => {
    if (table3.meta.server._experimentalDataLoader2) {
      return true;
    }
    return rowsById[row.rowId];
  }).length;
  const hasCreateWorkflow = table3.meta.editing.isEnabled && props.onEditingCreate;
  const isScrolled = isTableScrolled(table3.ref);
  let createWorkflow;
  if (hasCreateWorkflow) {
    createWorkflow = /* @__PURE__ */ React__default.createElement(
      CreateNewRow,
      {
        buttonRef: table3.meta.editing.createRowButtonRef,
        isScrolled,
        table: table3.instance,
        tableMeta: table3.meta
      }
    );
  }
  return /* @__PURE__ */ React__default.createElement(Table$1, null, /* @__PURE__ */ React__default.createElement(Table$1.Toolbar, { table: table3 }, table3.meta.editing.isEnabled ? /* @__PURE__ */ React__default.createElement(Editing, { scrollToIndex: table3.renderer.scrollToIndex, table: table3.instance }) : null), hasAlertErrors ? /* @__PURE__ */ React__default.createElement(
    Alert,
    {
      className: "mb-4",
      scrollToIndex: table3.renderer.scrollToIndex,
      table: table3.instance,
      tableRef: table3.ref
    }
  ) : null, /* @__PURE__ */ React__default.createElement(
    Table$1.Grid,
    {
      ...gridAttributes,
      "data-taco": "table3",
      footerRows: hasCreateWorkflow && isScrolled ? createWorkflow : void 0,
      table: table3
    },
    hasCreateWorkflow ? /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(
      TemporaryRow,
      {
        createRowButtonRef: table3.meta.editing.createRowButtonRef,
        isScrolled,
        table: table3.instance,
        tableMeta: table3.meta,
        tableRef: table3.ref
      }
    ), !isScrolled ? createWorkflow : null) : null
  ));
});
const Table3 = fixedForwardRef(function Table32(props, ref) {
  const stringifiedChildren = String(props.children);
  const key = React__default.useMemo(() => String("tableKey_" + stringifiedChildren), [stringifiedChildren]);
  return /* @__PURE__ */ React__default.createElement(BaseTable3, { ...props, key, ref });
});
Table3.Column = Column;
Table3.Group = Group$1;
const $69cb30bb0017df05$var$TABS_NAME = "Tabs";
const [$69cb30bb0017df05$var$createTabsContext, $69cb30bb0017df05$export$355f5bd209d7b13a] = $c512c27ab02ef895$export$50c7b4e9d9f19c1$1($69cb30bb0017df05$var$TABS_NAME, [
  $d7bdfb9eb0fdf311$export$c7109489551a4f4
]);
const $69cb30bb0017df05$var$useRovingFocusGroupScope = $d7bdfb9eb0fdf311$export$c7109489551a4f4();
const [$69cb30bb0017df05$var$TabsProvider, $69cb30bb0017df05$var$useTabsContext] = $69cb30bb0017df05$var$createTabsContext($69cb30bb0017df05$var$TABS_NAME);
const $69cb30bb0017df05$export$b2539bed5023c21c = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeTabs, value: valueProp, onValueChange, defaultValue: defaultValue2, orientation = "horizontal", dir, activationMode = "automatic", ...tabsProps } = props;
  const direction = $f631663db3294ace$export$b39126d51d94e6f3(dir);
  const [value, setValue] = $71cd76cc60e0454e$export$6f32135080cb4c3$1({
    prop: valueProp,
    onChange: onValueChange,
    defaultProp: defaultValue2
  });
  return /* @__PURE__ */ createElement($69cb30bb0017df05$var$TabsProvider, {
    scope: __scopeTabs,
    baseId: $1746a345f3d73bb7$export$f680877a34711e37$1(),
    value,
    onValueChange: setValue,
    orientation,
    dir: direction,
    activationMode
  }, /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.div, _extends$z({
    dir: direction,
    "data-orientation": orientation
  }, tabsProps, {
    ref: forwardedRef
  })));
});
const $69cb30bb0017df05$var$TAB_LIST_NAME = "TabsList";
const $69cb30bb0017df05$export$9712d22edc0d78c1 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeTabs, loop = true, ...listProps } = props;
  const context = $69cb30bb0017df05$var$useTabsContext($69cb30bb0017df05$var$TAB_LIST_NAME, __scopeTabs);
  const rovingFocusGroupScope = $69cb30bb0017df05$var$useRovingFocusGroupScope(__scopeTabs);
  return /* @__PURE__ */ createElement($d7bdfb9eb0fdf311$export$be92b6f5f03c0fe9, _extends$z({
    asChild: true
  }, rovingFocusGroupScope, {
    orientation: context.orientation,
    dir: context.dir,
    loop
  }), /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.div, _extends$z({
    role: "tablist",
    "aria-orientation": context.orientation
  }, listProps, {
    ref: forwardedRef
  })));
});
const $69cb30bb0017df05$var$TRIGGER_NAME = "TabsTrigger";
const $69cb30bb0017df05$export$8114b9fdfdf9f3ba = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeTabs, value, disabled = false, ...triggerProps } = props;
  const context = $69cb30bb0017df05$var$useTabsContext($69cb30bb0017df05$var$TRIGGER_NAME, __scopeTabs);
  const rovingFocusGroupScope = $69cb30bb0017df05$var$useRovingFocusGroupScope(__scopeTabs);
  const triggerId = $69cb30bb0017df05$var$makeTriggerId(context.baseId, value);
  const contentId = $69cb30bb0017df05$var$makeContentId(context.baseId, value);
  const isSelected = value === context.value;
  return /* @__PURE__ */ createElement($d7bdfb9eb0fdf311$export$6d08773d2e66f8f2, _extends$z({
    asChild: true
  }, rovingFocusGroupScope, {
    focusable: !disabled,
    active: isSelected
  }), /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.button, _extends$z({
    type: "button",
    role: "tab",
    "aria-selected": isSelected,
    "aria-controls": contentId,
    "data-state": isSelected ? "active" : "inactive",
    "data-disabled": disabled ? "" : void 0,
    disabled,
    id: triggerId
  }, triggerProps, {
    ref: forwardedRef,
    onMouseDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(props.onMouseDown, (event) => {
      if (!disabled && event.button === 0 && event.ctrlKey === false) context.onValueChange(value);
      else
        event.preventDefault();
    }),
    onKeyDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(props.onKeyDown, (event) => {
      if ([
        " ",
        "Enter"
      ].includes(event.key)) context.onValueChange(value);
    }),
    onFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10$1(props.onFocus, () => {
      const isAutomaticActivation = context.activationMode !== "manual";
      if (!isSelected && !disabled && isAutomaticActivation) context.onValueChange(value);
    })
  })));
});
const $69cb30bb0017df05$var$CONTENT_NAME = "TabsContent";
const $69cb30bb0017df05$export$bd905d70e8fd2ebb = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeTabs, value, forceMount, children, ...contentProps } = props;
  const context = $69cb30bb0017df05$var$useTabsContext($69cb30bb0017df05$var$CONTENT_NAME, __scopeTabs);
  const triggerId = $69cb30bb0017df05$var$makeTriggerId(context.baseId, value);
  const contentId = $69cb30bb0017df05$var$makeContentId(context.baseId, value);
  const isSelected = value === context.value;
  const isMountAnimationPreventedRef = useRef(isSelected);
  useEffect(() => {
    const rAF = requestAnimationFrame(
      () => isMountAnimationPreventedRef.current = false
    );
    return () => cancelAnimationFrame(rAF);
  }, []);
  return /* @__PURE__ */ createElement(
    $921a889cee6df7e8$export$99c2b779aa4e8b8b$1,
    {
      present: forceMount || isSelected
    },
    ({ present }) => /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$1.div, _extends$z({
      "data-state": isSelected ? "active" : "inactive",
      "data-orientation": context.orientation,
      role: "tabpanel",
      "aria-labelledby": triggerId,
      hidden: !present,
      id: contentId,
      tabIndex: 0
    }, contentProps, {
      ref: forwardedRef,
      style: {
        ...props.style,
        animationDuration: isMountAnimationPreventedRef.current ? "0s" : void 0
      }
    }), present && children)
  );
});
function $69cb30bb0017df05$var$makeTriggerId(baseId, value) {
  return `${baseId}-trigger-${value}`;
}
function $69cb30bb0017df05$var$makeContentId(baseId, value) {
  return `${baseId}-content-${value}`;
}
const $69cb30bb0017df05$export$be92b6f5f03c0fe9 = $69cb30bb0017df05$export$b2539bed5023c21c;
const $69cb30bb0017df05$export$54c2e3dc7acea9f5 = $69cb30bb0017df05$export$9712d22edc0d78c1;
const $69cb30bb0017df05$export$41fb9f06171c75f4 = $69cb30bb0017df05$export$8114b9fdfdf9f3ba;
const $69cb30bb0017df05$export$7c6e2c02157bb7d2 = $69cb30bb0017df05$export$bd905d70e8fd2ebb;
const Tabs = React.forwardRef(function Tabs2(props, ref) {
  const { id: id2, defaultId, children, onChange, orientation = "horizontal", ...otherProps } = props;
  const className = clsx(
    {
      "flex w-full": orientation === "vertical"
    },
    props.className
  );
  return /* @__PURE__ */ React.createElement(
    $69cb30bb0017df05$export$be92b6f5f03c0fe9,
    {
      ...otherProps,
      className,
      "data-taco": "tabs",
      defaultValue: defaultId,
      dir: "ltr",
      onValueChange: onChange,
      orientation,
      ref,
      value: id2
    },
    children
  );
});
const TabList = React.forwardRef(function Tab(props, ref) {
  const { children } = props;
  const className = clsx(
    "border-grey-300 flex flex-row m-0 mb-4 print:hidden",
    "aria-orientation-horizontal:border-b",
    "aria-orientation-vertical:border-r aria-orientation-vertical:m-0 aria-orientation-vertical:mr-4 aria-orientation-vertical:flex-col",
    props.className
  );
  return /* @__PURE__ */ React.createElement($69cb30bb0017df05$export$54c2e3dc7acea9f5, { ...props, className, ref }, /* @__PURE__ */ React.createElement(
    OverflowGroup,
    {
      wrapChild: true,
      className: 'w-full [[aria-orientation="vertical"]_&]:flex-col',
      moreButton: (text2) => /* @__PURE__ */ React.createElement(Button$4, null, text2)
    },
    React.Children.toArray(children).filter((child) => {
      if (React.isValidElement(child)) {
        return !child.props.hidden;
      }
      return true;
    })
  ));
});
const TabTrigger = React.forwardRef(function Tab2(props, ref) {
  const { children, id: id2, disabled, tooltip, ...otherProps } = props;
  const triggerClassName = clsx(
    props.className,
    "group relative p-0.5 outline-none disabled:cursor-not-allowed disabled:text-black/50",
    // horizontal
    '[[aria-orientation="horizontal"]_&]:pb-1',
    // horizontal
    '[[aria-orientation="vertical"]_&]:pr-1'
  );
  const buttonClassName = clsx(
    getButtonClasses$1(),
    "group-focus-visible:yt-focus-inset group-enabled:group-hover:wcag-grey-200 pointer-events-none rounded px-3"
  );
  const activeClassName = clsx(
    "pointer-events-none absolute hidden bg-blue-500 group-aria-selected:flex",
    // horizontal
    '[[aria-orientation="horizontal"]_&]:rounded-t-sm [[aria-orientation="horizontal"]_&]:bottom-0 [[aria-orientation="horizontal"]_&]:left-0 [[aria-orientation="horizontal"]_&]:right-0 [[aria-orientation="horizontal"]_&]:-mb-px [[aria-orientation="horizontal"]_&]:h-0.5',
    // vertical
    '[[aria-orientation="vertical"]_&]:rounded-l-sm [[aria-orientation="vertical"]_&]:right-0 [[aria-orientation="vertical"]_&]:top-0 [[aria-orientation="vertical"]_&]:bottom-0 [[aria-orientation="vertical"]_&]:-mr-px [[aria-orientation="vertical"]_&]:w-0.5'
  );
  const trigger = /* @__PURE__ */ React.createElement($69cb30bb0017df05$export$41fb9f06171c75f4, { ...otherProps, className: triggerClassName, disabled, ref, value: id2 }, /* @__PURE__ */ React.createElement("span", { className: buttonClassName }, children), /* @__PURE__ */ React.createElement("span", { className: activeClassName }));
  if (tooltip) {
    return /* @__PURE__ */ React.createElement(Tooltip$3, { title: tooltip }, trigger);
  }
  return trigger;
});
const TabContent = React.forwardRef(function Tab3(props, ref) {
  const { id: id2, ...otherProps } = props;
  const className = clsx('[&[data-orientation="vertical"]]:grow outline-none', props.className);
  return /* @__PURE__ */ React.createElement($69cb30bb0017df05$export$7c6e2c02157bb7d2, { ...otherProps, className, ref, value: id2 });
});
Tabs.List = TabList;
Tabs.Trigger = TabTrigger;
Tabs.Content = TabContent;
function isOfType$3(type) {
  return (value) => typeof value === type;
}
var isFunction$3 = isOfType$3("function");
var isNull$1 = (value) => {
  return value === null;
};
var isRegex$1 = (value) => {
  return Object.prototype.toString.call(value).slice(8, -1) === "RegExp";
};
var isObject$2 = (value) => {
  return !isUndefined$1(value) && !isNull$1(value) && (isFunction$3(value) || typeof value === "object");
};
var isUndefined$1 = isOfType$3("undefined");
function equalArray$1(left, right) {
  const { length } = left;
  if (length !== right.length) {
    return false;
  }
  for (let index2 = length; index2-- !== 0; ) {
    if (!equal$1(left[index2], right[index2])) {
      return false;
    }
  }
  return true;
}
function equalArrayBuffer$1(left, right) {
  if (left.byteLength !== right.byteLength) {
    return false;
  }
  const view1 = new DataView(left.buffer);
  const view2 = new DataView(right.buffer);
  let index2 = left.byteLength;
  while (index2--) {
    if (view1.getUint8(index2) !== view2.getUint8(index2)) {
      return false;
    }
  }
  return true;
}
function equalMap$1(left, right) {
  if (left.size !== right.size) {
    return false;
  }
  for (const index2 of left.entries()) {
    if (!right.has(index2[0])) {
      return false;
    }
  }
  for (const index2 of left.entries()) {
    if (!equal$1(index2[1], right.get(index2[0]))) {
      return false;
    }
  }
  return true;
}
function equalSet$1(left, right) {
  if (left.size !== right.size) {
    return false;
  }
  for (const index2 of left.entries()) {
    if (!right.has(index2[0])) {
      return false;
    }
  }
  return true;
}
function equal$1(left, right) {
  if (left === right) {
    return true;
  }
  if (left && isObject$2(left) && right && isObject$2(right)) {
    if (left.constructor !== right.constructor) {
      return false;
    }
    if (Array.isArray(left) && Array.isArray(right)) {
      return equalArray$1(left, right);
    }
    if (left instanceof Map && right instanceof Map) {
      return equalMap$1(left, right);
    }
    if (left instanceof Set && right instanceof Set) {
      return equalSet$1(left, right);
    }
    if (ArrayBuffer.isView(left) && ArrayBuffer.isView(right)) {
      return equalArrayBuffer$1(left, right);
    }
    if (isRegex$1(left) && isRegex$1(right)) {
      return left.source === right.source && left.flags === right.flags;
    }
    if (left.valueOf !== Object.prototype.valueOf) {
      return left.valueOf() === right.valueOf();
    }
    if (left.toString !== Object.prototype.toString) {
      return left.toString() === right.toString();
    }
    const leftKeys = Object.keys(left);
    const rightKeys = Object.keys(right);
    if (leftKeys.length !== rightKeys.length) {
      return false;
    }
    for (let index2 = leftKeys.length; index2-- !== 0; ) {
      if (!Object.prototype.hasOwnProperty.call(right, leftKeys[index2])) {
        return false;
      }
    }
    for (let index2 = leftKeys.length; index2-- !== 0; ) {
      const key = leftKeys[index2];
      if (key === "_owner" && left.$$typeof) {
        continue;
      }
      if (!equal$1(left[key], right[key])) {
        return false;
      }
    }
    return true;
  }
  if (Number.isNaN(left) && Number.isNaN(right)) {
    return true;
  }
  return left === right;
}
var objectTypes$1 = [
  "Array",
  "ArrayBuffer",
  "AsyncFunction",
  "AsyncGenerator",
  "AsyncGeneratorFunction",
  "Date",
  "Error",
  "Function",
  "Generator",
  "GeneratorFunction",
  "HTMLElement",
  "Map",
  "Object",
  "Promise",
  "RegExp",
  "Set",
  "WeakMap",
  "WeakSet"
];
var primitiveTypes$1 = [
  "bigint",
  "boolean",
  "null",
  "number",
  "string",
  "symbol",
  "undefined"
];
function getObjectType$2(value) {
  const objectTypeName = Object.prototype.toString.call(value).slice(8, -1);
  if (/HTML\w+Element/.test(objectTypeName)) {
    return "HTMLElement";
  }
  if (isObjectType$1(objectTypeName)) {
    return objectTypeName;
  }
  return void 0;
}
function isObjectOfType$1(type) {
  return (value) => getObjectType$2(value) === type;
}
function isObjectType$1(name) {
  return objectTypes$1.includes(name);
}
function isOfType$2(type) {
  return (value) => typeof value === type;
}
function isPrimitiveType$1(name) {
  return primitiveTypes$1.includes(name);
}
var DOM_PROPERTIES_TO_CHECK$1 = [
  "innerHTML",
  "ownerDocument",
  "style",
  "attributes",
  "nodeValue"
];
function is$1(value) {
  if (value === null) {
    return "null";
  }
  switch (typeof value) {
    case "bigint":
      return "bigint";
    case "boolean":
      return "boolean";
    case "number":
      return "number";
    case "string":
      return "string";
    case "symbol":
      return "symbol";
    case "undefined":
      return "undefined";
  }
  if (is$1.array(value)) {
    return "Array";
  }
  if (is$1.plainFunction(value)) {
    return "Function";
  }
  const tagType = getObjectType$2(value);
  if (tagType) {
    return tagType;
  }
  return "Object";
}
is$1.array = Array.isArray;
is$1.arrayOf = (target, predicate) => {
  if (!is$1.array(target) && !is$1.function(predicate)) {
    return false;
  }
  return target.every((d4) => predicate(d4));
};
is$1.asyncGeneratorFunction = (value) => getObjectType$2(value) === "AsyncGeneratorFunction";
is$1.asyncFunction = isObjectOfType$1("AsyncFunction");
is$1.bigint = isOfType$2("bigint");
is$1.boolean = (value) => {
  return value === true || value === false;
};
is$1.date = isObjectOfType$1("Date");
is$1.defined = (value) => !is$1.undefined(value);
is$1.domElement = (value) => {
  return is$1.object(value) && !is$1.plainObject(value) && value.nodeType === 1 && is$1.string(value.nodeName) && DOM_PROPERTIES_TO_CHECK$1.every((property) => property in value);
};
is$1.empty = (value) => {
  return is$1.string(value) && value.length === 0 || is$1.array(value) && value.length === 0 || is$1.object(value) && !is$1.map(value) && !is$1.set(value) && Object.keys(value).length === 0 || is$1.set(value) && value.size === 0 || is$1.map(value) && value.size === 0;
};
is$1.error = isObjectOfType$1("Error");
is$1.function = isOfType$2("function");
is$1.generator = (value) => {
  return is$1.iterable(value) && is$1.function(value.next) && is$1.function(value.throw);
};
is$1.generatorFunction = isObjectOfType$1("GeneratorFunction");
is$1.instanceOf = (instance, class_) => {
  if (!instance || !class_) {
    return false;
  }
  return Object.getPrototypeOf(instance) === class_.prototype;
};
is$1.iterable = (value) => {
  return !is$1.nullOrUndefined(value) && is$1.function(value[Symbol.iterator]);
};
is$1.map = isObjectOfType$1("Map");
is$1.nan = (value) => {
  return Number.isNaN(value);
};
is$1.null = (value) => {
  return value === null;
};
is$1.nullOrUndefined = (value) => {
  return is$1.null(value) || is$1.undefined(value);
};
is$1.number = (value) => {
  return isOfType$2("number")(value) && !is$1.nan(value);
};
is$1.numericString = (value) => {
  return is$1.string(value) && value.length > 0 && !Number.isNaN(Number(value));
};
is$1.object = (value) => {
  return !is$1.nullOrUndefined(value) && (is$1.function(value) || typeof value === "object");
};
is$1.oneOf = (target, value) => {
  if (!is$1.array(target)) {
    return false;
  }
  return target.indexOf(value) > -1;
};
is$1.plainFunction = isObjectOfType$1("Function");
is$1.plainObject = (value) => {
  if (getObjectType$2(value) !== "Object") {
    return false;
  }
  const prototype = Object.getPrototypeOf(value);
  return prototype === null || prototype === Object.getPrototypeOf({});
};
is$1.primitive = (value) => is$1.null(value) || isPrimitiveType$1(typeof value);
is$1.promise = isObjectOfType$1("Promise");
is$1.propertyOf = (target, key, predicate) => {
  if (!is$1.object(target) || !key) {
    return false;
  }
  const value = target[key];
  if (is$1.function(predicate)) {
    return predicate(value);
  }
  return is$1.defined(value);
};
is$1.regexp = isObjectOfType$1("RegExp");
is$1.set = isObjectOfType$1("Set");
is$1.string = isOfType$2("string");
is$1.symbol = isOfType$2("symbol");
is$1.undefined = isOfType$2("undefined");
is$1.weakMap = isObjectOfType$1("WeakMap");
is$1.weakSet = isObjectOfType$1("WeakSet");
var src_default = is$1;
function canHaveLength$1(...arguments_) {
  return arguments_.every((d4) => src_default.string(d4) || src_default.array(d4) || src_default.plainObject(d4));
}
function checkEquality$1(left, right, value) {
  if (!isSameType$1(left, right)) {
    return false;
  }
  if ([left, right].every(src_default.array)) {
    return !left.some(hasValue$1(value)) && right.some(hasValue$1(value));
  }
  if ([left, right].every(src_default.plainObject)) {
    return !Object.entries(left).some(hasEntry$1(value)) && Object.entries(right).some(hasEntry$1(value));
  }
  return right === value;
}
function compareNumbers$1(previousData, data, options) {
  const { actual, key, previous, type } = options;
  const left = nested$1(previousData, key);
  const right = nested$1(data, key);
  let changed = [left, right].every(src_default.number) && (type === "increased" ? left < right : left > right);
  if (!src_default.undefined(actual)) {
    changed = changed && right === actual;
  }
  if (!src_default.undefined(previous)) {
    changed = changed && left === previous;
  }
  return changed;
}
function compareValues$1(previousData, data, options) {
  const { key, type, value } = options;
  const left = nested$1(previousData, key);
  const right = nested$1(data, key);
  const primary = type === "added" ? left : right;
  const secondary = type === "added" ? right : left;
  if (!src_default.nullOrUndefined(value)) {
    if (src_default.defined(primary)) {
      if (src_default.array(primary) || src_default.plainObject(primary)) {
        return checkEquality$1(primary, secondary, value);
      }
    } else {
      return equal$1(secondary, value);
    }
    return false;
  }
  if ([left, right].every(src_default.array)) {
    return !secondary.every(isEqualPredicate$1(primary));
  }
  if ([left, right].every(src_default.plainObject)) {
    return hasExtraKeys$1(Object.keys(primary), Object.keys(secondary));
  }
  return ![left, right].every((d4) => src_default.primitive(d4) && src_default.defined(d4)) && (type === "added" ? !src_default.defined(left) && src_default.defined(right) : src_default.defined(left) && !src_default.defined(right));
}
function getIterables$1(previousData, data, { key } = {}) {
  let left = nested$1(previousData, key);
  let right = nested$1(data, key);
  if (!isSameType$1(left, right)) {
    throw new TypeError("Inputs have different types");
  }
  if (!canHaveLength$1(left, right)) {
    throw new TypeError("Inputs don't have length");
  }
  if ([left, right].every(src_default.plainObject)) {
    left = Object.keys(left);
    right = Object.keys(right);
  }
  return [left, right];
}
function hasEntry$1(input) {
  return ([key, value]) => {
    if (src_default.array(input)) {
      return equal$1(input, value) || input.some((d4) => equal$1(d4, value) || src_default.array(value) && isEqualPredicate$1(value)(d4));
    }
    if (src_default.plainObject(input) && input[key]) {
      return !!input[key] && equal$1(input[key], value);
    }
    return equal$1(input, value);
  };
}
function hasExtraKeys$1(left, right) {
  return right.some((d4) => !left.includes(d4));
}
function hasValue$1(input) {
  return (value) => {
    if (src_default.array(input)) {
      return input.some((d4) => equal$1(d4, value) || src_default.array(value) && isEqualPredicate$1(value)(d4));
    }
    return equal$1(input, value);
  };
}
function includesOrEqualsTo$1(previousValue, value) {
  return src_default.array(previousValue) ? previousValue.some((d4) => equal$1(d4, value)) : equal$1(previousValue, value);
}
function isEqualPredicate$1(data) {
  return (value) => data.some((d4) => equal$1(d4, value));
}
function isSameType$1(...arguments_) {
  return arguments_.every(src_default.array) || arguments_.every(src_default.number) || arguments_.every(src_default.plainObject) || arguments_.every(src_default.string);
}
function nested$1(data, property) {
  if (src_default.plainObject(data) || src_default.array(data)) {
    if (src_default.string(property)) {
      const props = property.split(".");
      return props.reduce((acc, d4) => acc && acc[d4], data);
    }
    if (src_default.number(property)) {
      return data[property];
    }
    return data;
  }
  return data;
}
function treeChanges$1(previousData, data) {
  if ([previousData, data].some(src_default.nullOrUndefined)) {
    throw new Error("Missing required parameters");
  }
  if (![previousData, data].every((d4) => src_default.plainObject(d4) || src_default.array(d4))) {
    throw new Error("Expected plain objects or array");
  }
  const added = (key, value) => {
    try {
      return compareValues$1(previousData, data, { key, type: "added", value });
    } catch {
      return false;
    }
  };
  const changed = (key, actual, previous) => {
    try {
      const left = nested$1(previousData, key);
      const right = nested$1(data, key);
      const hasActual = src_default.defined(actual);
      const hasPrevious = src_default.defined(previous);
      if (hasActual || hasPrevious) {
        const leftComparator = hasPrevious ? includesOrEqualsTo$1(previous, left) : !includesOrEqualsTo$1(actual, left);
        const rightComparator = includesOrEqualsTo$1(actual, right);
        return leftComparator && rightComparator;
      }
      if ([left, right].every(src_default.array) || [left, right].every(src_default.plainObject)) {
        return !equal$1(left, right);
      }
      return left !== right;
    } catch {
      return false;
    }
  };
  const changedFrom = (key, previous, actual) => {
    if (!src_default.defined(key)) {
      return false;
    }
    try {
      const left = nested$1(previousData, key);
      const right = nested$1(data, key);
      const hasActual = src_default.defined(actual);
      return includesOrEqualsTo$1(previous, left) && (hasActual ? includesOrEqualsTo$1(actual, right) : !hasActual);
    } catch {
      return false;
    }
  };
  const decreased = (key, actual, previous) => {
    if (!src_default.defined(key)) {
      return false;
    }
    try {
      return compareNumbers$1(previousData, data, { key, actual, previous, type: "decreased" });
    } catch {
      return false;
    }
  };
  const emptied = (key) => {
    try {
      const [left, right] = getIterables$1(previousData, data, { key });
      return !!left.length && !right.length;
    } catch {
      return false;
    }
  };
  const filled = (key) => {
    try {
      const [left, right] = getIterables$1(previousData, data, { key });
      return !left.length && !!right.length;
    } catch {
      return false;
    }
  };
  const increased = (key, actual, previous) => {
    if (!src_default.defined(key)) {
      return false;
    }
    try {
      return compareNumbers$1(previousData, data, { key, actual, previous, type: "increased" });
    } catch {
      return false;
    }
  };
  const removed = (key, value) => {
    try {
      return compareValues$1(previousData, data, { key, type: "removed", value });
    } catch {
      return false;
    }
  };
  return { added, changed, changedFrom, decreased, emptied, filled, increased, removed };
}
var scroll$1;
var hasRequiredScroll;
function requireScroll() {
  if (hasRequiredScroll) return scroll$1;
  hasRequiredScroll = 1;
  var E_NOSCROLL = new Error("Element already at target scroll position");
  var E_CANCELLED = new Error("Scroll cancelled");
  var min2 = Math.min;
  var ms = Date.now;
  scroll$1 = {
    left: make("scrollLeft"),
    top: make("scrollTop")
  };
  function make(prop) {
    return function scroll2(el, to, opts, cb2) {
      opts = opts || {};
      if (typeof opts == "function") cb2 = opts, opts = {};
      if (typeof cb2 != "function") cb2 = noop2;
      var start = ms();
      var from = el[prop];
      var ease = opts.ease || inOutSine;
      var duration = !isNaN(opts.duration) ? +opts.duration : 350;
      var cancelled = false;
      return from === to ? cb2(E_NOSCROLL, el[prop]) : requestAnimationFrame(animate2), cancel;
      function cancel() {
        cancelled = true;
      }
      function animate2(timestamp) {
        if (cancelled) return cb2(E_CANCELLED, el[prop]);
        var now2 = ms();
        var time2 = min2(1, (now2 - start) / duration);
        var eased = ease(time2);
        el[prop] = eased * (to - from) + from;
        time2 < 1 ? requestAnimationFrame(animate2) : requestAnimationFrame(function() {
          cb2(null, el[prop]);
        });
      }
    };
  }
  function inOutSine(n2) {
    return 0.5 * (1 - Math.cos(Math.PI * n2));
  }
  function noop2() {
  }
  return scroll$1;
}
var scrollExports = requireScroll();
const scroll = /* @__PURE__ */ getDefaultExportFromCjs(scrollExports);
var scrollparent$1 = { exports: {} };
var scrollparent = scrollparent$1.exports;
var hasRequiredScrollparent;
function requireScrollparent() {
  if (hasRequiredScrollparent) return scrollparent$1.exports;
  hasRequiredScrollparent = 1;
  (function(module) {
    (function(root, factory) {
      if (module.exports) {
        module.exports = factory();
      } else {
        root.Scrollparent = factory();
      }
    })(scrollparent, function() {
      function isScrolling(node) {
        var overflow = getComputedStyle(node, null).getPropertyValue("overflow");
        return overflow.indexOf("scroll") > -1 || overflow.indexOf("auto") > -1;
      }
      function scrollParent2(node) {
        if (!(node instanceof HTMLElement || node instanceof SVGElement)) {
          return void 0;
        }
        var current = node.parentNode;
        while (current.parentNode) {
          if (isScrolling(current)) {
            return current;
          }
          current = current.parentNode;
        }
        return document.scrollingElement || document.documentElement;
      }
      return scrollParent2;
    });
  })(scrollparent$1);
  return scrollparent$1.exports;
}
var scrollparentExports = requireScrollparent();
const scrollParent = /* @__PURE__ */ getDefaultExportFromCjs(scrollparentExports);
var reactInnertext;
var hasRequiredReactInnertext;
function requireReactInnertext() {
  if (hasRequiredReactInnertext) return reactInnertext;
  hasRequiredReactInnertext = 1;
  var hasProps = function(jsx2) {
    return Object.prototype.hasOwnProperty.call(jsx2, "props");
  };
  var reduceJsxToString = function(previous, current) {
    return previous + innerText2(current);
  };
  var innerText2 = function(jsx2) {
    if (jsx2 === null || typeof jsx2 === "boolean" || typeof jsx2 === "undefined") {
      return "";
    }
    if (typeof jsx2 === "number") {
      return jsx2.toString();
    }
    if (typeof jsx2 === "string") {
      return jsx2;
    }
    if (Array.isArray(jsx2)) {
      return jsx2.reduce(reduceJsxToString, "");
    }
    if (hasProps(jsx2) && Object.prototype.hasOwnProperty.call(jsx2.props, "children")) {
      return innerText2(jsx2.props.children);
    }
    return "";
  };
  innerText2.default = innerText2;
  reactInnertext = innerText2;
  return reactInnertext;
}
var reactInnertextExports = requireReactInnertext();
const innerText = /* @__PURE__ */ getDefaultExportFromCjs(reactInnertextExports);
var cjs;
var hasRequiredCjs;
function requireCjs() {
  if (hasRequiredCjs) return cjs;
  hasRequiredCjs = 1;
  var isMergeableObject = function isMergeableObject2(value) {
    return isNonNullObject(value) && !isSpecial(value);
  };
  function isNonNullObject(value) {
    return !!value && typeof value === "object";
  }
  function isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === "[object RegExp]" || stringValue === "[object Date]" || isReactElement(value);
  }
  var canUseSymbol = typeof Symbol === "function" && Symbol.for;
  var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for("react.element") : 60103;
  function isReactElement(value) {
    return value.$$typeof === REACT_ELEMENT_TYPE;
  }
  function emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
  }
  function cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? deepmerge(emptyTarget(value), value, options) : value;
  }
  function defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function(element) {
      return cloneUnlessOtherwiseSpecified(element, options);
    });
  }
  function getMergeFunction(key, options) {
    if (!options.customMerge) {
      return deepmerge;
    }
    var customMerge = options.customMerge(key);
    return typeof customMerge === "function" ? customMerge : deepmerge;
  }
  function getEnumerableOwnPropertySymbols(target) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function(symbol) {
      return Object.propertyIsEnumerable.call(target, symbol);
    }) : [];
  }
  function getKeys(target) {
    return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target));
  }
  function propertyIsOnObject(object2, property) {
    try {
      return property in object2;
    } catch (_) {
      return false;
    }
  }
  function propertyIsUnsafe(target, key) {
    return propertyIsOnObject(target, key) && !(Object.hasOwnProperty.call(target, key) && Object.propertyIsEnumerable.call(target, key));
  }
  function mergeObject(target, source, options) {
    var destination = {};
    if (options.isMergeableObject(target)) {
      getKeys(target).forEach(function(key) {
        destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
      });
    }
    getKeys(source).forEach(function(key) {
      if (propertyIsUnsafe(target, key)) {
        return;
      }
      if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
        destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
      } else {
        destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
      }
    });
    return destination;
  }
  function deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || isMergeableObject;
    options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) {
      return cloneUnlessOtherwiseSpecified(source, options);
    } else if (sourceIsArray) {
      return options.arrayMerge(target, source, options);
    } else {
      return mergeObject(target, source, options);
    }
  }
  deepmerge.all = function deepmergeAll(array2, options) {
    if (!Array.isArray(array2)) {
      throw new Error("first argument should be an array");
    }
    return array2.reduce(function(prev, next) {
      return deepmerge(prev, next, options);
    }, {});
  };
  var deepmerge_1 = deepmerge;
  cjs = deepmerge_1;
  return cjs;
}
var cjsExports = requireCjs();
const deepmerge2 = /* @__PURE__ */ getDefaultExportFromCjs(cjsExports);
var propTypes = { exports: {} };
var reactIs$1 = { exports: {} };
var reactIs_production_min$1 = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min$1;
function requireReactIs_production_min$1() {
  if (hasRequiredReactIs_production_min$1) return reactIs_production_min$1;
  hasRequiredReactIs_production_min$1 = 1;
  var b3 = "function" === typeof Symbol && Symbol.for, c3 = b3 ? Symbol.for("react.element") : 60103, d4 = b3 ? Symbol.for("react.portal") : 60106, e3 = b3 ? Symbol.for("react.fragment") : 60107, f2 = b3 ? Symbol.for("react.strict_mode") : 60108, g2 = b3 ? Symbol.for("react.profiler") : 60114, h4 = b3 ? Symbol.for("react.provider") : 60109, k3 = b3 ? Symbol.for("react.context") : 60110, l2 = b3 ? Symbol.for("react.async_mode") : 60111, m4 = b3 ? Symbol.for("react.concurrent_mode") : 60111, n2 = b3 ? Symbol.for("react.forward_ref") : 60112, p2 = b3 ? Symbol.for("react.suspense") : 60113, q2 = b3 ? Symbol.for("react.suspense_list") : 60120, r2 = b3 ? Symbol.for("react.memo") : 60115, t3 = b3 ? Symbol.for("react.lazy") : 60116, v2 = b3 ? Symbol.for("react.block") : 60121, w3 = b3 ? Symbol.for("react.fundamental") : 60117, x3 = b3 ? Symbol.for("react.responder") : 60118, y4 = b3 ? Symbol.for("react.scope") : 60119;
  function z3(a4) {
    if ("object" === typeof a4 && null !== a4) {
      var u3 = a4.$$typeof;
      switch (u3) {
        case c3:
          switch (a4 = a4.type, a4) {
            case l2:
            case m4:
            case e3:
            case g2:
            case f2:
            case p2:
              return a4;
            default:
              switch (a4 = a4 && a4.$$typeof, a4) {
                case k3:
                case n2:
                case t3:
                case r2:
                case h4:
                  return a4;
                default:
                  return u3;
              }
          }
        case d4:
          return u3;
      }
    }
  }
  function A2(a4) {
    return z3(a4) === m4;
  }
  reactIs_production_min$1.AsyncMode = l2;
  reactIs_production_min$1.ConcurrentMode = m4;
  reactIs_production_min$1.ContextConsumer = k3;
  reactIs_production_min$1.ContextProvider = h4;
  reactIs_production_min$1.Element = c3;
  reactIs_production_min$1.ForwardRef = n2;
  reactIs_production_min$1.Fragment = e3;
  reactIs_production_min$1.Lazy = t3;
  reactIs_production_min$1.Memo = r2;
  reactIs_production_min$1.Portal = d4;
  reactIs_production_min$1.Profiler = g2;
  reactIs_production_min$1.StrictMode = f2;
  reactIs_production_min$1.Suspense = p2;
  reactIs_production_min$1.isAsyncMode = function(a4) {
    return A2(a4) || z3(a4) === l2;
  };
  reactIs_production_min$1.isConcurrentMode = A2;
  reactIs_production_min$1.isContextConsumer = function(a4) {
    return z3(a4) === k3;
  };
  reactIs_production_min$1.isContextProvider = function(a4) {
    return z3(a4) === h4;
  };
  reactIs_production_min$1.isElement = function(a4) {
    return "object" === typeof a4 && null !== a4 && a4.$$typeof === c3;
  };
  reactIs_production_min$1.isForwardRef = function(a4) {
    return z3(a4) === n2;
  };
  reactIs_production_min$1.isFragment = function(a4) {
    return z3(a4) === e3;
  };
  reactIs_production_min$1.isLazy = function(a4) {
    return z3(a4) === t3;
  };
  reactIs_production_min$1.isMemo = function(a4) {
    return z3(a4) === r2;
  };
  reactIs_production_min$1.isPortal = function(a4) {
    return z3(a4) === d4;
  };
  reactIs_production_min$1.isProfiler = function(a4) {
    return z3(a4) === g2;
  };
  reactIs_production_min$1.isStrictMode = function(a4) {
    return z3(a4) === f2;
  };
  reactIs_production_min$1.isSuspense = function(a4) {
    return z3(a4) === p2;
  };
  reactIs_production_min$1.isValidElementType = function(a4) {
    return "string" === typeof a4 || "function" === typeof a4 || a4 === e3 || a4 === m4 || a4 === g2 || a4 === f2 || a4 === p2 || a4 === q2 || "object" === typeof a4 && null !== a4 && (a4.$$typeof === t3 || a4.$$typeof === r2 || a4.$$typeof === h4 || a4.$$typeof === k3 || a4.$$typeof === n2 || a4.$$typeof === w3 || a4.$$typeof === x3 || a4.$$typeof === y4 || a4.$$typeof === v2);
  };
  reactIs_production_min$1.typeOf = z3;
  return reactIs_production_min$1;
}
var reactIs_development$1 = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development$1;
function requireReactIs_development$1() {
  if (hasRequiredReactIs_development$1) return reactIs_development$1;
  hasRequiredReactIs_development$1 = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      var hasSymbol = typeof Symbol === "function" && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 60103;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 60107;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110;
      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 60120;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 60121;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 60117;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 60118;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 60119;
      function isValidElementType(type) {
        return typeof type === "string" || typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }
      function typeOf(object2) {
        if (typeof object2 === "object" && object2 !== null) {
          var $$typeof = object2.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object2.type;
              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;
                default:
                  var $$typeofType = type && type.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return void 0;
      }
      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element2 = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment2 = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal2 = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;
      function isAsyncMode(object2) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
          }
        }
        return isConcurrentMode(object2) || typeOf(object2) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object2) {
        return typeOf(object2) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object2) {
        return typeOf(object2) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object2) {
        return typeOf(object2) === REACT_PROVIDER_TYPE;
      }
      function isElement(object2) {
        return typeof object2 === "object" && object2 !== null && object2.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object2) {
        return typeOf(object2) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object2) {
        return typeOf(object2) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object2) {
        return typeOf(object2) === REACT_LAZY_TYPE;
      }
      function isMemo(object2) {
        return typeOf(object2) === REACT_MEMO_TYPE;
      }
      function isPortal(object2) {
        return typeOf(object2) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object2) {
        return typeOf(object2) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object2) {
        return typeOf(object2) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object2) {
        return typeOf(object2) === REACT_SUSPENSE_TYPE;
      }
      reactIs_development$1.AsyncMode = AsyncMode;
      reactIs_development$1.ConcurrentMode = ConcurrentMode;
      reactIs_development$1.ContextConsumer = ContextConsumer;
      reactIs_development$1.ContextProvider = ContextProvider;
      reactIs_development$1.Element = Element2;
      reactIs_development$1.ForwardRef = ForwardRef;
      reactIs_development$1.Fragment = Fragment2;
      reactIs_development$1.Lazy = Lazy;
      reactIs_development$1.Memo = Memo;
      reactIs_development$1.Portal = Portal2;
      reactIs_development$1.Profiler = Profiler;
      reactIs_development$1.StrictMode = StrictMode;
      reactIs_development$1.Suspense = Suspense;
      reactIs_development$1.isAsyncMode = isAsyncMode;
      reactIs_development$1.isConcurrentMode = isConcurrentMode;
      reactIs_development$1.isContextConsumer = isContextConsumer;
      reactIs_development$1.isContextProvider = isContextProvider;
      reactIs_development$1.isElement = isElement;
      reactIs_development$1.isForwardRef = isForwardRef;
      reactIs_development$1.isFragment = isFragment;
      reactIs_development$1.isLazy = isLazy;
      reactIs_development$1.isMemo = isMemo;
      reactIs_development$1.isPortal = isPortal;
      reactIs_development$1.isProfiler = isProfiler;
      reactIs_development$1.isStrictMode = isStrictMode;
      reactIs_development$1.isSuspense = isSuspense;
      reactIs_development$1.isValidElementType = isValidElementType;
      reactIs_development$1.typeOf = typeOf;
    })();
  }
  return reactIs_development$1;
}
var hasRequiredReactIs$1;
function requireReactIs$1() {
  if (hasRequiredReactIs$1) return reactIs$1.exports;
  hasRequiredReactIs$1 = 1;
  if (process.env.NODE_ENV === "production") {
    reactIs$1.exports = requireReactIs_production_min$1();
  } else {
    reactIs$1.exports = requireReactIs_development$1();
  }
  return reactIs$1.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var objectAssign;
var hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign) return objectAssign;
  hasRequiredObjectAssign = 1;
  var getOwnPropertySymbols2 = Object.getOwnPropertySymbols;
  var hasOwnProperty2 = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;
  function toObject(val) {
    if (val === null || val === void 0) {
      throw new TypeError("Object.assign cannot be called with null or undefined");
    }
    return Object(val);
  }
  function shouldUseNative() {
    try {
      if (!Object.assign) {
        return false;
      }
      var test1 = new String("abc");
      test1[5] = "de";
      if (Object.getOwnPropertyNames(test1)[0] === "5") {
        return false;
      }
      var test2 = {};
      for (var i3 = 0; i3 < 10; i3++) {
        test2["_" + String.fromCharCode(i3)] = i3;
      }
      var order2 = Object.getOwnPropertyNames(test2).map(function(n2) {
        return test2[n2];
      });
      if (order2.join("") !== "0123456789") {
        return false;
      }
      var test3 = {};
      "abcdefghijklmnopqrst".split("").forEach(function(letter) {
        test3[letter] = letter;
      });
      if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
        return false;
      }
      return true;
    } catch (err) {
      return false;
    }
  }
  objectAssign = shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = toObject(target);
    var symbols;
    for (var s4 = 1; s4 < arguments.length; s4++) {
      from = Object(arguments[s4]);
      for (var key in from) {
        if (hasOwnProperty2.call(from, key)) {
          to[key] = from[key];
        }
      }
      if (getOwnPropertySymbols2) {
        symbols = getOwnPropertySymbols2(from);
        for (var i3 = 0; i3 < symbols.length; i3++) {
          if (propIsEnumerable.call(from, symbols[i3])) {
            to[symbols[i3]] = from[symbols[i3]];
          }
        }
      }
    }
    return to;
  };
  return objectAssign;
}
var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  ReactPropTypesSecret_1 = ReactPropTypesSecret;
  return ReactPropTypesSecret_1;
}
var has;
var hasRequiredHas;
function requireHas() {
  if (hasRequiredHas) return has;
  hasRequiredHas = 1;
  has = Function.call.bind(Object.prototype.hasOwnProperty);
  return has;
}
var checkPropTypes_1;
var hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes) return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var printWarning = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var ReactPropTypesSecret = /* @__PURE__ */ requireReactPropTypesSecret();
    var loggedTypeFailures = {};
    var has2 = /* @__PURE__ */ requireHas();
    printWarning = function(text2) {
      var message = "Warning: " + text2;
      if (typeof console !== "undefined") {
        console.error(message);
      }
      try {
        throw new Error(message);
      } catch (x3) {
      }
    };
  }
  function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    if (process.env.NODE_ENV !== "production") {
      for (var typeSpecName in typeSpecs) {
        if (has2(typeSpecs, typeSpecName)) {
          var error;
          try {
            if (typeof typeSpecs[typeSpecName] !== "function") {
              var err = Error(
                (componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              err.name = "Invariant Violation";
              throw err;
            }
            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
          } catch (ex) {
            error = ex;
          }
          if (error && !(error instanceof Error)) {
            printWarning(
              (componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
            );
          }
          if (error instanceof Error && !(error.message in loggedTypeFailures)) {
            loggedTypeFailures[error.message] = true;
            var stack = getStack ? getStack() : "";
            printWarning(
              "Failed " + location + " type: " + error.message + (stack != null ? stack : "")
            );
          }
        }
      }
    }
  }
  checkPropTypes.resetWarningCache = function() {
    if (process.env.NODE_ENV !== "production") {
      loggedTypeFailures = {};
    }
  };
  checkPropTypes_1 = checkPropTypes;
  return checkPropTypes_1;
}
var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var ReactIs = requireReactIs$1();
  var assign2 = requireObjectAssign();
  var ReactPropTypesSecret = /* @__PURE__ */ requireReactPropTypesSecret();
  var has2 = /* @__PURE__ */ requireHas();
  var checkPropTypes = /* @__PURE__ */ requireCheckPropTypes();
  var printWarning = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    printWarning = function(text2) {
      var message = "Warning: " + text2;
      if (typeof console !== "undefined") {
        console.error(message);
      }
      try {
        throw new Error(message);
      } catch (x3) {
      }
    };
  }
  function emptyFunctionThatReturnsNull() {
    return null;
  }
  factoryWithTypeCheckers = function(isValidElement2, throwOnDirectAccess) {
    var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
      var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
      if (typeof iteratorFn === "function") {
        return iteratorFn;
      }
    }
    var ANONYMOUS = "<<anonymous>>";
    var ReactPropTypes = {
      array: createPrimitiveTypeChecker("array"),
      bigint: createPrimitiveTypeChecker("bigint"),
      bool: createPrimitiveTypeChecker("boolean"),
      func: createPrimitiveTypeChecker("function"),
      number: createPrimitiveTypeChecker("number"),
      object: createPrimitiveTypeChecker("object"),
      string: createPrimitiveTypeChecker("string"),
      symbol: createPrimitiveTypeChecker("symbol"),
      any: createAnyTypeChecker(),
      arrayOf: createArrayOfTypeChecker,
      element: createElementTypeChecker(),
      elementType: createElementTypeTypeChecker(),
      instanceOf: createInstanceTypeChecker,
      node: createNodeChecker(),
      objectOf: createObjectOfTypeChecker,
      oneOf: createEnumTypeChecker,
      oneOfType: createUnionTypeChecker,
      shape: createShapeTypeChecker,
      exact: createStrictShapeTypeChecker
    };
    function is2(x3, y4) {
      if (x3 === y4) {
        return x3 !== 0 || 1 / x3 === 1 / y4;
      } else {
        return x3 !== x3 && y4 !== y4;
      }
    }
    function PropTypeError(message, data) {
      this.message = message;
      this.data = data && typeof data === "object" ? data : {};
      this.stack = "";
    }
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
      if (process.env.NODE_ENV !== "production") {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
      }
      function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
        componentName = componentName || ANONYMOUS;
        propFullName = propFullName || propName;
        if (secret !== ReactPropTypesSecret) {
          if (throwOnDirectAccess) {
            var err = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            err.name = "Invariant Violation";
            throw err;
          } else if (process.env.NODE_ENV !== "production" && typeof console !== "undefined") {
            var cacheKey = componentName + ":" + propName;
            if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3) {
              printWarning(
                "You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
              );
              manualPropTypeCallCache[cacheKey] = true;
              manualPropTypeWarningCount++;
            }
          }
        }
        if (props[propName] == null) {
          if (isRequired) {
            if (props[propName] === null) {
              return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
            }
            return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
          }
          return null;
        } else {
          return validate(props, propName, componentName, location, propFullName);
        }
      }
      var chainedCheckType = checkType.bind(null, false);
      chainedCheckType.isRequired = checkType.bind(null, true);
      return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
      function validate(props, propName, componentName, location, propFullName, secret) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== expectedType) {
          var preciseType = getPreciseType(propValue);
          return new PropTypeError(
            "Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."),
            { expectedType }
          );
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
      return createChainableTypeChecker(emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== "function") {
          return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
        }
        var propValue = props[propName];
        if (!Array.isArray(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
        }
        for (var i3 = 0; i3 < propValue.length; i3++) {
          var error = typeChecker(propValue, i3, componentName, location, propFullName + "[" + i3 + "]", ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!isValidElement2(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!ReactIs.isValidElementType(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
      function validate(props, propName, componentName, location, propFullName) {
        if (!(props[propName] instanceof expectedClass)) {
          var expectedClassName = expectedClass.name || ANONYMOUS;
          var actualClassName = getClassName(props[propName]);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
      if (!Array.isArray(expectedValues)) {
        if (process.env.NODE_ENV !== "production") {
          if (arguments.length > 1) {
            printWarning(
              "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
            );
          } else {
            printWarning("Invalid argument supplied to oneOf, expected an array.");
          }
        }
        return emptyFunctionThatReturnsNull;
      }
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        for (var i3 = 0; i3 < expectedValues.length; i3++) {
          if (is2(propValue, expectedValues[i3])) {
            return null;
          }
        }
        var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
          var type = getPreciseType(value);
          if (type === "symbol") {
            return String(value);
          }
          return value;
        });
        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
      }
      return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== "function") {
          return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
        }
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
        }
        for (var key in propValue) {
          if (has2(propValue, key)) {
            var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
            if (error instanceof Error) {
              return error;
            }
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
      if (!Array.isArray(arrayOfTypeCheckers)) {
        process.env.NODE_ENV !== "production" ? printWarning("Invalid argument supplied to oneOfType, expected an instance of array.") : void 0;
        return emptyFunctionThatReturnsNull;
      }
      for (var i3 = 0; i3 < arrayOfTypeCheckers.length; i3++) {
        var checker = arrayOfTypeCheckers[i3];
        if (typeof checker !== "function") {
          printWarning(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i3 + "."
          );
          return emptyFunctionThatReturnsNull;
        }
      }
      function validate(props, propName, componentName, location, propFullName) {
        var expectedTypes = [];
        for (var i4 = 0; i4 < arrayOfTypeCheckers.length; i4++) {
          var checker2 = arrayOfTypeCheckers[i4];
          var checkerResult = checker2(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
          if (checkerResult == null) {
            return null;
          }
          if (checkerResult.data && has2(checkerResult.data, "expectedType")) {
            expectedTypes.push(checkerResult.data.expectedType);
          }
        }
        var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
        return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
      }
      return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        if (!isNode2(props[propName])) {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function invalidValidatorError(componentName, location, propFullName, key, type) {
      return new PropTypeError(
        (componentName || "React class") + ": " + location + " type `" + propFullName + "." + key + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + type + "`."
      );
    }
    function createShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
        }
        for (var key in shapeTypes) {
          var checker = shapeTypes[key];
          if (typeof checker !== "function") {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }
          var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
        }
        var allKeys = assign2({}, props[propName], shapeTypes);
        for (var key in allKeys) {
          var checker = shapeTypes[key];
          if (has2(shapeTypes, key) && typeof checker !== "function") {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }
          if (!checker) {
            return new PropTypeError(
              "Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  ")
            );
          }
          var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function isNode2(propValue) {
      switch (typeof propValue) {
        case "number":
        case "string":
        case "undefined":
          return true;
        case "boolean":
          return !propValue;
        case "object":
          if (Array.isArray(propValue)) {
            return propValue.every(isNode2);
          }
          if (propValue === null || isValidElement2(propValue)) {
            return true;
          }
          var iteratorFn = getIteratorFn(propValue);
          if (iteratorFn) {
            var iterator = iteratorFn.call(propValue);
            var step;
            if (iteratorFn !== propValue.entries) {
              while (!(step = iterator.next()).done) {
                if (!isNode2(step.value)) {
                  return false;
                }
              }
            } else {
              while (!(step = iterator.next()).done) {
                var entry = step.value;
                if (entry) {
                  if (!isNode2(entry[1])) {
                    return false;
                  }
                }
              }
            }
          } else {
            return false;
          }
          return true;
        default:
          return false;
      }
    }
    function isSymbol(propType, propValue) {
      if (propType === "symbol") {
        return true;
      }
      if (!propValue) {
        return false;
      }
      if (propValue["@@toStringTag"] === "Symbol") {
        return true;
      }
      if (typeof Symbol === "function" && propValue instanceof Symbol) {
        return true;
      }
      return false;
    }
    function getPropType(propValue) {
      var propType = typeof propValue;
      if (Array.isArray(propValue)) {
        return "array";
      }
      if (propValue instanceof RegExp) {
        return "object";
      }
      if (isSymbol(propType, propValue)) {
        return "symbol";
      }
      return propType;
    }
    function getPreciseType(propValue) {
      if (typeof propValue === "undefined" || propValue === null) {
        return "" + propValue;
      }
      var propType = getPropType(propValue);
      if (propType === "object") {
        if (propValue instanceof Date) {
          return "date";
        } else if (propValue instanceof RegExp) {
          return "regexp";
        }
      }
      return propType;
    }
    function getPostfixForTypeWarning(value) {
      var type = getPreciseType(value);
      switch (type) {
        case "array":
        case "object":
          return "an " + type;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + type;
        default:
          return type;
      }
    }
    function getClassName(propValue) {
      if (!propValue.constructor || !propValue.constructor.name) {
        return ANONYMOUS;
      }
      return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = checkPropTypes;
    ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithTypeCheckers;
}
var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var ReactPropTypesSecret = /* @__PURE__ */ requireReactPropTypesSecret();
  function emptyFunction() {
  }
  function emptyFunctionWithReset() {
  }
  emptyFunctionWithReset.resetWarningCache = emptyFunction;
  factoryWithThrowingShims = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
      if (secret === ReactPropTypesSecret) {
        return;
      }
      var err = new Error(
        "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
      );
      err.name = "Invariant Violation";
      throw err;
    }
    shim.isRequired = shim;
    function getShim() {
      return shim;
    }
    var ReactPropTypes = {
      array: shim,
      bigint: shim,
      bool: shim,
      func: shim,
      number: shim,
      object: shim,
      string: shim,
      symbol: shim,
      any: shim,
      arrayOf: getShim,
      element: shim,
      elementType: shim,
      instanceOf: getShim,
      node: shim,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim,
      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithThrowingShims;
}
var hasRequiredPropTypes;
function requirePropTypes() {
  if (hasRequiredPropTypes) return propTypes.exports;
  hasRequiredPropTypes = 1;
  if (process.env.NODE_ENV !== "production") {
    var ReactIs = requireReactIs$1();
    var throwOnDirectAccess = true;
    propTypes.exports = /* @__PURE__ */ requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
  } else {
    propTypes.exports = /* @__PURE__ */ requireFactoryWithThrowingShims()();
  }
  return propTypes.exports;
}
var propTypesExports = /* @__PURE__ */ requirePropTypes();
const PropTypes = /* @__PURE__ */ getDefaultExportFromCjs(propTypesExports);
/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== "undefined" && typeof document !== "undefined" && typeof navigator !== "undefined";
var timeoutDuration = function() {
  var longerTimeoutBrowsers = ["Edge", "Trident", "Firefox"];
  for (var i3 = 0; i3 < longerTimeoutBrowsers.length; i3 += 1) {
    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i3]) >= 0) {
      return 1;
    }
  }
  return 0;
}();
function microtaskDebounce(fn) {
  var called = false;
  return function() {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function() {
      called = false;
      fn();
    });
  };
}
function taskDebounce(fn) {
  var scheduled = false;
  return function() {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function() {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}
var supportsMicroTasks = isBrowser && window.Promise;
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;
function isFunction$2(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === "[object Function]";
}
function getStyleComputedProperty$1(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  var window2 = element.ownerDocument.defaultView;
  var css = window2.getComputedStyle(element, null);
  return property ? css[property] : css;
}
function getParentNode(element) {
  if (element.nodeName === "HTML") {
    return element;
  }
  return element.parentNode || element.host;
}
function getScrollParent$1(element) {
  if (!element) {
    return document.body;
  }
  switch (element.nodeName) {
    case "HTML":
    case "BODY":
      return element.ownerDocument.body;
    case "#document":
      return element.body;
  }
  var _getStyleComputedProp = getStyleComputedProperty$1(element), overflow = _getStyleComputedProp.overflow, overflowX = _getStyleComputedProp.overflowX, overflowY = _getStyleComputedProp.overflowY;
  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }
  return getScrollParent$1(getParentNode(element));
}
function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}
var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }
  var noOffsetParent = isIE(10) ? document.body : null;
  var offsetParent = element.offsetParent || null;
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }
  var nodeName = offsetParent && offsetParent.nodeName;
  if (!nodeName || nodeName === "BODY" || nodeName === "HTML") {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }
  if (["TH", "TD", "TABLE"].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty$1(offsetParent, "position") === "static") {
    return getOffsetParent(offsetParent);
  }
  return offsetParent;
}
function isOffsetContainer(element) {
  var nodeName = element.nodeName;
  if (nodeName === "BODY") {
    return false;
  }
  return nodeName === "HTML" || getOffsetParent(element.firstElementChild) === element;
}
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }
  return node;
}
function findCommonOffsetParent(element1, element2) {
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }
  var order2 = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order2 ? element1 : element2;
  var end = order2 ? element2 : element1;
  var range3 = document.createRange();
  range3.setStart(start, 0);
  range3.setEnd(end, 0);
  var commonAncestorContainer = range3.commonAncestorContainer;
  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }
    return getOffsetParent(commonAncestorContainer);
  }
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "top";
  var upperSide = side === "top" ? "scrollTop" : "scrollLeft";
  var nodeName = element.nodeName;
  if (nodeName === "BODY" || nodeName === "HTML") {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }
  return element[upperSide];
}
function includeScroll(rect, element) {
  var subtract2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
  var scrollTop = getScroll(element, "top");
  var scrollLeft = getScroll(element, "left");
  var modifier = subtract2 ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}
function getBordersSize(styles, axis) {
  var sideA = axis === "x" ? "Left" : "Top";
  var sideB = sideA === "Left" ? "Right" : "Bottom";
  return parseFloat(styles["border" + sideA + "Width"]) + parseFloat(styles["border" + sideB + "Width"]);
}
function getSize(axis, body, html, computedStyle) {
  return Math.max(body["offset" + axis], body["scroll" + axis], html["client" + axis], html["offset" + axis], html["scroll" + axis], isIE(10) ? parseInt(html["offset" + axis]) + parseInt(computedStyle["margin" + (axis === "Height" ? "Top" : "Left")]) + parseInt(computedStyle["margin" + (axis === "Height" ? "Bottom" : "Right")]) : 0);
}
function getWindowSizes(document2) {
  var body = document2.body;
  var html = document2.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);
  return {
    height: getSize("Height", body, html, computedStyle),
    width: getSize("Width", body, html, computedStyle)
  };
}
var classCallCheck = function(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};
var createClass = /* @__PURE__ */ function() {
  function defineProperties(target, props) {
    for (var i3 = 0; i3 < props.length; i3++) {
      var descriptor = props[i3];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var defineProperty = function(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
};
var _extends$w = Object.assign || function(target) {
  for (var i3 = 1; i3 < arguments.length; i3++) {
    var source = arguments[i3];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function getClientRect$1(offsets) {
  return _extends$w({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}
function getBoundingClientRect(element) {
  var rect = {};
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, "top");
      var scrollLeft = getScroll(element, "left");
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e3) {
  }
  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };
  var sizes = element.nodeName === "HTML" ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.width;
  var height = sizes.height || element.clientHeight || result.height;
  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty$1(element);
    horizScrollbar -= getBordersSize(styles, "x");
    vertScrollbar -= getBordersSize(styles, "y");
    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }
  return getClientRect$1(result);
}
function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
  var isIE102 = isIE(10);
  var isHTML = parent.nodeName === "HTML";
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent2 = getScrollParent$1(children);
  var styles = getStyleComputedProperty$1(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth);
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect$1({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;
  if (!isIE102 && isHTML) {
    var marginTop = parseFloat(styles.marginTop);
    var marginLeft = parseFloat(styles.marginLeft);
    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }
  if (isIE102 && !fixedPosition ? parent.contains(scrollParent2) : parent === scrollParent2 && scrollParent2.nodeName !== "BODY") {
    offsets = includeScroll(offsets, parent);
  }
  return offsets;
}
function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);
  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, "left") : 0;
  var offset2 = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width,
    height
  };
  return getClientRect$1(offset2);
}
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === "BODY" || nodeName === "HTML") {
    return false;
  }
  if (getStyleComputedProperty$1(element, "position") === "fixed") {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}
function getFixedPositionOffsetParent(element) {
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty$1(el, "transform") === "none") {
    el = el.parentElement;
  }
  return el || document.documentElement;
}
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  if (boundariesElement === "viewport") {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    var boundariesNode = void 0;
    if (boundariesElement === "scrollParent") {
      boundariesNode = getScrollParent$1(getParentNode(reference));
      if (boundariesNode.nodeName === "BODY") {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === "window") {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }
    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
    if (boundariesNode.nodeName === "HTML" && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument), height = _getWindowSizes.height, width = _getWindowSizes.width;
      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      boundaries = offsets;
    }
  }
  padding = padding || 0;
  var isPaddingNumber = typeof padding === "number";
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
  return boundaries;
}
function getArea(_ref) {
  var width = _ref.width, height = _ref.height;
  return width * height;
}
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 0;
  if (placement.indexOf("auto") === -1) {
    return placement;
  }
  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);
  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };
  var sortedAreas = Object.keys(rects).map(function(key) {
    return _extends$w({
      key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function(a4, b3) {
    return b3.area - a4.area;
  });
  var filteredAreas = sortedAreas.filter(function(_ref2) {
    var width = _ref2.width, height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });
  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
  var variation = placement.split("-")[1];
  return computedPlacement + (variation ? "-" + variation : "");
}
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}
function getOuterSizes(element) {
  var window2 = element.ownerDocument.defaultView;
  var styles = window2.getComputedStyle(element);
  var x3 = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y4 = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y4,
    height: element.offsetHeight + x3
  };
  return result;
}
function getOppositePlacement(placement) {
  var hash = { left: "right", right: "left", bottom: "top", top: "bottom" };
  return placement.replace(/left|right|bottom|top/g, function(matched) {
    return hash[matched];
  });
}
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split("-")[0];
  var popperRect = getOuterSizes(popper);
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };
  var isHoriz = ["right", "left"].indexOf(placement) !== -1;
  var mainSide = isHoriz ? "top" : "left";
  var secondarySide = isHoriz ? "left" : "top";
  var measurement = isHoriz ? "height" : "width";
  var secondaryMeasurement = !isHoriz ? "height" : "width";
  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }
  return popperOffsets;
}
function find$1(arr, check) {
  if (Array.prototype.find) {
    return arr.find(check);
  }
  return arr.filter(check)[0];
}
function findIndex(arr, prop, value) {
  if (Array.prototype.findIndex) {
    return arr.findIndex(function(cur) {
      return cur[prop] === value;
    });
  }
  var match2 = find$1(arr, function(obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match2);
}
function runModifiers(modifiers2, data, ends) {
  var modifiersToRun = ends === void 0 ? modifiers2 : modifiers2.slice(0, findIndex(modifiers2, "name", ends));
  modifiersToRun.forEach(function(modifier) {
    if (modifier["function"]) {
      console.warn("`modifier.function` is deprecated, use `modifier.fn`!");
    }
    var fn = modifier["function"] || modifier.fn;
    if (modifier.enabled && isFunction$2(fn)) {
      data.offsets.popper = getClientRect$1(data.offsets.popper);
      data.offsets.reference = getClientRect$1(data.offsets.reference);
      data = fn(data, modifier);
    }
  });
  return data;
}
function update() {
  if (this.state.isDestroyed) {
    return;
  }
  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
  data.originalPlacement = data.placement;
  data.positionFixed = this.options.positionFixed;
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
  data.offsets.popper.position = this.options.positionFixed ? "fixed" : "absolute";
  data = runModifiers(this.modifiers, data);
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}
function isModifierEnabled(modifiers2, modifierName) {
  return modifiers2.some(function(_ref) {
    var name = _ref.name, enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}
function getSupportedPropertyName(property) {
  var prefixes2 = [false, "ms", "Webkit", "Moz", "O"];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
  for (var i3 = 0; i3 < prefixes2.length; i3++) {
    var prefix2 = prefixes2[i3];
    var toCheck = prefix2 ? "" + prefix2 + upperProp : property;
    if (typeof document.body.style[toCheck] !== "undefined") {
      return toCheck;
    }
  }
  return null;
}
function destroy() {
  this.state.isDestroyed = true;
  if (isModifierEnabled(this.modifiers, "applyStyle")) {
    this.popper.removeAttribute("x-placement");
    this.popper.style.position = "";
    this.popper.style.top = "";
    this.popper.style.left = "";
    this.popper.style.right = "";
    this.popper.style.bottom = "";
    this.popper.style.willChange = "";
    this.popper.style[getSupportedPropertyName("transform")] = "";
  }
  this.disableEventListeners();
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}
function attachToScrollParents(scrollParent2, event, callback, scrollParents) {
  var isBody = scrollParent2.nodeName === "BODY";
  var target = isBody ? scrollParent2.ownerDocument.defaultView : scrollParent2;
  target.addEventListener(event, callback, { passive: true });
  if (!isBody) {
    attachToScrollParents(getScrollParent$1(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}
function setupEventListeners(reference, options, state, updateBound) {
  state.updateBound = updateBound;
  getWindow(reference).addEventListener("resize", state.updateBound, { passive: true });
  var scrollElement = getScrollParent$1(reference);
  attachToScrollParents(scrollElement, "scroll", state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;
  return state;
}
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}
function removeEventListeners(reference, state) {
  getWindow(reference).removeEventListener("resize", state.updateBound);
  state.scrollParents.forEach(function(target) {
    target.removeEventListener("scroll", state.updateBound);
  });
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}
function isNumeric(n2) {
  return n2 !== "" && !isNaN(parseFloat(n2)) && isFinite(n2);
}
function setStyles(element, styles) {
  Object.keys(styles).forEach(function(prop) {
    var unit2 = "";
    if (["width", "height", "top", "right", "bottom", "left"].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit2 = "px";
    }
    element.style[prop] = styles[prop] + unit2;
  });
}
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function(prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}
function applyStyle(data) {
  setStyles(data.instance.popper, data.styles);
  setAttributes(data.instance.popper, data.attributes);
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }
  return data;
}
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
  popper.setAttribute("x-placement", placement);
  setStyles(popper, { position: options.positionFixed ? "fixed" : "absolute" });
  return options;
}
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
  var round2 = Math.round, floor = Math.floor;
  var noRound = function noRound2(v2) {
    return v2;
  };
  var referenceWidth = round2(reference.width);
  var popperWidth = round2(popper.width);
  var isVertical = ["left", "right"].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf("-") !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round2 : floor;
  var verticalToInteger = !shouldRound ? noRound : round2;
  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}
var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);
function computeStyle(data, options) {
  var x3 = options.x, y4 = options.y;
  var popper = data.offsets.popper;
  var legacyGpuAccelerationOption = find$1(data.instance.modifiers, function(modifier) {
    return modifier.name === "applyStyle";
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== void 0) {
    console.warn("WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!");
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== void 0 ? legacyGpuAccelerationOption : options.gpuAcceleration;
  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);
  var styles = {
    position: popper.position
  };
  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);
  var sideA = x3 === "bottom" ? "top" : "bottom";
  var sideB = y4 === "right" ? "left" : "right";
  var prefixedProperty = getSupportedPropertyName("transform");
  var left = void 0, top = void 0;
  if (sideA === "bottom") {
    if (offsetParent.nodeName === "HTML") {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === "right") {
    if (offsetParent.nodeName === "HTML") {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = "translate3d(" + left + "px, " + top + "px, 0)";
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = "transform";
  } else {
    var invertTop = sideA === "bottom" ? -1 : 1;
    var invertLeft = sideB === "right" ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ", " + sideB;
  }
  var attributes = {
    "x-placement": data.placement
  };
  data.attributes = _extends$w({}, attributes, data.attributes);
  data.styles = _extends$w({}, styles, data.styles);
  data.arrowStyles = _extends$w({}, data.offsets.arrow, data.arrowStyles);
  return data;
}
function isModifierRequired(modifiers2, requestingName, requestedName) {
  var requesting = find$1(modifiers2, function(_ref) {
    var name = _ref.name;
    return name === requestingName;
  });
  var isRequired = !!requesting && modifiers2.some(function(modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });
  if (!isRequired) {
    var _requesting = "`" + requestingName + "`";
    var requested = "`" + requestedName + "`";
    console.warn(requested + " modifier is required by " + _requesting + " modifier in order to work, be sure to include it before " + _requesting + "!");
  }
  return isRequired;
}
function arrow(data, options) {
  var _data$offsets$arrow;
  if (!isModifierRequired(data.instance.modifiers, "arrow", "keepTogether")) {
    return data;
  }
  var arrowElement = options.element;
  if (typeof arrowElement === "string") {
    arrowElement = data.instance.popper.querySelector(arrowElement);
    if (!arrowElement) {
      return data;
    }
  } else {
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn("WARNING: `arrow.element` must be child of its popper element!");
      return data;
    }
  }
  var placement = data.placement.split("-")[0];
  var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
  var isVertical = ["left", "right"].indexOf(placement) !== -1;
  var len = isVertical ? "height" : "width";
  var sideCapitalized = isVertical ? "Top" : "Left";
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? "left" : "top";
  var opSide = isVertical ? "bottom" : "right";
  var arrowElementSize = getOuterSizes(arrowElement)[len];
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect$1(data.offsets.popper);
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
  var css = getStyleComputedProperty$1(data.instance.popper);
  var popperMarginSide = parseFloat(css["margin" + sideCapitalized]);
  var popperBorderSide = parseFloat(css["border" + sideCapitalized + "Width"]);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ""), _data$offsets$arrow);
  return data;
}
function getOppositeVariation(variation) {
  if (variation === "end") {
    return "start";
  } else if (variation === "start") {
    return "end";
  }
  return variation;
}
var placements = ["auto-start", "auto", "auto-end", "top-start", "top", "top-end", "right-start", "right", "right-end", "bottom-end", "bottom", "bottom-start", "left-end", "left", "left-start"];
var validPlacements = placements.slice(3);
function clockwise(placement) {
  var counter2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
  var index2 = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index2 + 1).concat(validPlacements.slice(0, index2));
  return counter2 ? arr.reverse() : arr;
}
var BEHAVIORS = {
  FLIP: "flip",
  CLOCKWISE: "clockwise",
  COUNTERCLOCKWISE: "counterclockwise"
};
function flip(data, options) {
  if (isModifierEnabled(data.instance.modifiers, "inner")) {
    return data;
  }
  if (data.flipped && data.placement === data.originalPlacement) {
    return data;
  }
  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
  var placement = data.placement.split("-")[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split("-")[1] || "";
  var flipOrder = [];
  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }
  flipOrder.forEach(function(step, index2) {
    if (placement !== step || flipOrder.length === index2 + 1) {
      return data;
    }
    placement = data.placement.split("-")[0];
    placementOpposite = getOppositePlacement(placement);
    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;
    var floor = Math.floor;
    var overlapsRef = placement === "left" && floor(popperOffsets.right) > floor(refOffsets.left) || placement === "right" && floor(popperOffsets.left) < floor(refOffsets.right) || placement === "top" && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === "bottom" && floor(popperOffsets.top) < floor(refOffsets.bottom);
    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
    var overflowsBoundaries = placement === "left" && overflowsLeft || placement === "right" && overflowsRight || placement === "top" && overflowsTop || placement === "bottom" && overflowsBottom;
    var isVertical = ["top", "bottom"].indexOf(placement) !== -1;
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === "start" && overflowsLeft || isVertical && variation === "end" && overflowsRight || !isVertical && variation === "start" && overflowsTop || !isVertical && variation === "end" && overflowsBottom);
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === "start" && overflowsRight || isVertical && variation === "end" && overflowsLeft || !isVertical && variation === "start" && overflowsBottom || !isVertical && variation === "end" && overflowsTop);
    var flippedVariation = flippedVariationByRef || flippedVariationByContent;
    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      data.flipped = true;
      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index2 + 1];
      }
      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }
      data.placement = placement + (variation ? "-" + variation : "");
      data.offsets.popper = _extends$w({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
      data = runModifiers(data.instance.modifiers, data, "flip");
    }
  });
  return data;
}
function keepTogether(data) {
  var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
  var placement = data.placement.split("-")[0];
  var floor = Math.floor;
  var isVertical = ["top", "bottom"].indexOf(placement) !== -1;
  var side = isVertical ? "right" : "bottom";
  var opSide = isVertical ? "left" : "top";
  var measurement = isVertical ? "width" : "height";
  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }
  return data;
}
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit2 = split[2];
  if (!value) {
    return str;
  }
  if (unit2.indexOf("%") === 0) {
    var element = void 0;
    switch (unit2) {
      case "%p":
        element = popperOffsets;
        break;
      case "%":
      case "%r":
      default:
        element = referenceOffsets;
    }
    var rect = getClientRect$1(element);
    return rect[measurement] / 100 * value;
  } else if (unit2 === "vh" || unit2 === "vw") {
    var size2 = void 0;
    if (unit2 === "vh") {
      size2 = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size2 = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size2 / 100 * value;
  } else {
    return value;
  }
}
function parseOffset(offset2, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];
  var useHeight = ["right", "left"].indexOf(basePlacement) !== -1;
  var fragments = offset2.split(/(\+|\-)/).map(function(frag) {
    return frag.trim();
  });
  var divider = fragments.indexOf(find$1(fragments, function(frag) {
    return frag.search(/,|\s/) !== -1;
  }));
  if (fragments[divider] && fragments[divider].indexOf(",") === -1) {
    console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead.");
  }
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];
  ops = ops.map(function(op, index2) {
    var measurement = (index2 === 1 ? !useHeight : useHeight) ? "height" : "width";
    var mergeWithPrevious = false;
    return op.reduce(function(a4, b3) {
      if (a4[a4.length - 1] === "" && ["+", "-"].indexOf(b3) !== -1) {
        a4[a4.length - 1] = b3;
        mergeWithPrevious = true;
        return a4;
      } else if (mergeWithPrevious) {
        a4[a4.length - 1] += b3;
        mergeWithPrevious = false;
        return a4;
      } else {
        return a4.concat(b3);
      }
    }, []).map(function(str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });
  ops.forEach(function(op, index2) {
    op.forEach(function(frag, index22) {
      if (isNumeric(frag)) {
        offsets[index2] += frag * (op[index22 - 1] === "-" ? -1 : 1);
      }
    });
  });
  return offsets;
}
function offset(data, _ref) {
  var offset2 = _ref.offset;
  var placement = data.placement, _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
  var basePlacement = placement.split("-")[0];
  var offsets = void 0;
  if (isNumeric(+offset2)) {
    offsets = [+offset2, 0];
  } else {
    offsets = parseOffset(offset2, popper, reference, basePlacement);
  }
  if (basePlacement === "left") {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === "right") {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === "top") {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === "bottom") {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }
  data.popper = popper;
  return data;
}
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }
  var transformProp = getSupportedPropertyName("transform");
  var popperStyles = data.instance.popper.style;
  var top = popperStyles.top, left = popperStyles.left, transform = popperStyles[transformProp];
  popperStyles.top = "";
  popperStyles.left = "";
  popperStyles[transformProp] = "";
  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;
  options.boundaries = boundaries;
  var order2 = options.priority;
  var popper = data.offsets.popper;
  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === "right" ? "left" : "top";
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === "right" ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };
  order2.forEach(function(placement) {
    var side = ["left", "top"].indexOf(placement) !== -1 ? "primary" : "secondary";
    popper = _extends$w({}, popper, check[side](placement));
  });
  data.offsets.popper = popper;
  return data;
}
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split("-")[0];
  var shiftvariation = placement.split("-")[1];
  if (shiftvariation) {
    var _data$offsets = data.offsets, reference = _data$offsets.reference, popper = _data$offsets.popper;
    var isVertical = ["bottom", "top"].indexOf(basePlacement) !== -1;
    var side = isVertical ? "left" : "top";
    var measurement = isVertical ? "width" : "height";
    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };
    data.offsets.popper = _extends$w({}, popper, shiftOffsets[shiftvariation]);
  }
  return data;
}
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, "hide", "preventOverflow")) {
    return data;
  }
  var refRect = data.offsets.reference;
  var bound = find$1(data.instance.modifiers, function(modifier) {
    return modifier.name === "preventOverflow";
  }).boundaries;
  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    if (data.hide === true) {
      return data;
    }
    data.hide = true;
    data.attributes["x-out-of-boundaries"] = "";
  } else {
    if (data.hide === false) {
      return data;
    }
    data.hide = false;
    data.attributes["x-out-of-boundaries"] = false;
  }
  return data;
}
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split("-")[0];
  var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
  var isHoriz = ["left", "right"].indexOf(basePlacement) !== -1;
  var subtractLength = ["top", "left"].indexOf(basePlacement) === -1;
  popper[isHoriz ? "left" : "top"] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? "width" : "height"] : 0);
  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect$1(popper);
  return data;
}
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },
  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },
  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ["left", "right", "top", "bottom"],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: "scrollParent"
  },
  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },
  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: "[x-arrow]"
  },
  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: "flip",
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: "viewport",
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },
  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },
  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },
  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: "bottom",
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: "right"
  },
  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: void 0
  }
};
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: "bottom",
  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,
  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,
  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,
  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {
  },
  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {
  },
  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers
};
var Popper = function() {
  function Popper2(reference, popper) {
    var _this = this;
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    classCallCheck(this, Popper2);
    this.scheduleUpdate = function() {
      return requestAnimationFrame(_this.update);
    };
    this.update = debounce(this.update.bind(this));
    this.options = _extends$w({}, Popper2.Defaults, options);
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;
    this.options.modifiers = {};
    Object.keys(_extends$w({}, Popper2.Defaults.modifiers, options.modifiers)).forEach(function(name) {
      _this.options.modifiers[name] = _extends$w({}, Popper2.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });
    this.modifiers = Object.keys(this.options.modifiers).map(function(name) {
      return _extends$w({
        name
      }, _this.options.modifiers[name]);
    }).sort(function(a4, b3) {
      return a4.order - b3.order;
    });
    this.modifiers.forEach(function(modifierOptions) {
      if (modifierOptions.enabled && isFunction$2(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });
    this.update();
    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      this.enableEventListeners();
    }
    this.state.eventsEnabled = eventsEnabled;
  }
  createClass(Popper2, [{
    key: "update",
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: "destroy",
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: "enableEventListeners",
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: "disableEventListeners",
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }
    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */
    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */
  }]);
  return Popper2;
}();
Popper.Utils = (typeof window !== "undefined" ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;
var DOM_PROPERTIES_TO_CHECK = [
  "innerHTML",
  "ownerDocument",
  "style",
  "attributes",
  "nodeValue"
];
var objectTypes = [
  "Array",
  "ArrayBuffer",
  "AsyncFunction",
  "AsyncGenerator",
  "AsyncGeneratorFunction",
  "Date",
  "Error",
  "Function",
  "Generator",
  "GeneratorFunction",
  "HTMLElement",
  "Map",
  "Object",
  "Promise",
  "RegExp",
  "Set",
  "WeakMap",
  "WeakSet"
];
var primitiveTypes = [
  "bigint",
  "boolean",
  "null",
  "number",
  "string",
  "symbol",
  "undefined"
];
function getObjectType$1(value) {
  var objectTypeName = Object.prototype.toString.call(value).slice(8, -1);
  if (/HTML\w+Element/.test(objectTypeName)) {
    return "HTMLElement";
  }
  if (isObjectType(objectTypeName)) {
    return objectTypeName;
  }
  return void 0;
}
function isObjectOfType(type) {
  return function(value) {
    return getObjectType$1(value) === type;
  };
}
function isObjectType(name) {
  return objectTypes.includes(name);
}
function isOfType$1(type) {
  return function(value) {
    return typeof value === type;
  };
}
function isPrimitiveType(name) {
  return primitiveTypes.includes(name);
}
function is(value) {
  if (value === null) {
    return "null";
  }
  switch (typeof value) {
    case "bigint":
      return "bigint";
    case "boolean":
      return "boolean";
    case "number":
      return "number";
    case "string":
      return "string";
    case "symbol":
      return "symbol";
    case "undefined":
      return "undefined";
  }
  if (is.array(value)) {
    return "Array";
  }
  if (is.plainFunction(value)) {
    return "Function";
  }
  var tagType = getObjectType$1(value);
  if (tagType) {
    return tagType;
  }
  return "Object";
}
is.array = Array.isArray;
is.arrayOf = function(target, predicate) {
  if (!is.array(target) && !is.function(predicate)) {
    return false;
  }
  return target.every(function(d4) {
    return predicate(d4);
  });
};
is.asyncGeneratorFunction = function(value) {
  return getObjectType$1(value) === "AsyncGeneratorFunction";
};
is.asyncFunction = isObjectOfType("AsyncFunction");
is.bigint = isOfType$1("bigint");
is.boolean = function(value) {
  return value === true || value === false;
};
is.date = isObjectOfType("Date");
is.defined = function(value) {
  return !is.undefined(value);
};
is.domElement = function(value) {
  return is.object(value) && !is.plainObject(value) && value.nodeType === 1 && is.string(value.nodeName) && DOM_PROPERTIES_TO_CHECK.every(function(property) {
    return property in value;
  });
};
is.empty = function(value) {
  return is.string(value) && value.length === 0 || is.array(value) && value.length === 0 || is.object(value) && !is.map(value) && !is.set(value) && Object.keys(value).length === 0 || is.set(value) && value.size === 0 || is.map(value) && value.size === 0;
};
is.error = isObjectOfType("Error");
is.function = isOfType$1("function");
is.generator = function(value) {
  return is.iterable(value) && is.function(value.next) && is.function(value.throw);
};
is.generatorFunction = isObjectOfType("GeneratorFunction");
is.instanceOf = function(instance, class_) {
  if (!instance || !class_) {
    return false;
  }
  return Object.getPrototypeOf(instance) === class_.prototype;
};
is.iterable = function(value) {
  return !is.nullOrUndefined(value) && is.function(value[Symbol.iterator]);
};
is.map = isObjectOfType("Map");
is.nan = function(value) {
  return Number.isNaN(value);
};
is.null = function(value) {
  return value === null;
};
is.nullOrUndefined = function(value) {
  return is.null(value) || is.undefined(value);
};
is.number = function(value) {
  return isOfType$1("number")(value) && !is.nan(value);
};
is.numericString = function(value) {
  return is.string(value) && value.length > 0 && !Number.isNaN(Number(value));
};
is.object = function(value) {
  return !is.nullOrUndefined(value) && (is.function(value) || typeof value === "object");
};
is.oneOf = function(target, value) {
  if (!is.array(target)) {
    return false;
  }
  return target.indexOf(value) > -1;
};
is.plainFunction = isObjectOfType("Function");
is.plainObject = function(value) {
  if (getObjectType$1(value) !== "Object") {
    return false;
  }
  var prototype = Object.getPrototypeOf(value);
  return prototype === null || prototype === Object.getPrototypeOf({});
};
is.primitive = function(value) {
  return is.null(value) || isPrimitiveType(typeof value);
};
is.promise = isObjectOfType("Promise");
is.propertyOf = function(target, key, predicate) {
  if (!is.object(target) || !key) {
    return false;
  }
  var value = target[key];
  if (is.function(predicate)) {
    return predicate(value);
  }
  return is.defined(value);
};
is.regexp = isObjectOfType("RegExp");
is.set = isObjectOfType("Set");
is.string = isOfType$1("string");
is.symbol = isOfType$1("symbol");
is.undefined = isOfType$1("undefined");
is.weakMap = isObjectOfType("WeakMap");
is.weakSet = isObjectOfType("WeakSet");
function isOfType(type) {
  return function(value) {
    return typeof value === type;
  };
}
var isFunction$1 = isOfType("function");
var isNull = function(value) {
  return value === null;
};
var isRegex = function(value) {
  return Object.prototype.toString.call(value).slice(8, -1) === "RegExp";
};
var isObject$1 = function(value) {
  return !isUndefined(value) && !isNull(value) && (isFunction$1(value) || typeof value === "object");
};
var isUndefined = isOfType("undefined");
var __values = function(o2) {
  var s4 = typeof Symbol === "function" && Symbol.iterator, m4 = s4 && o2[s4], i3 = 0;
  if (m4) return m4.call(o2);
  if (o2 && typeof o2.length === "number") return {
    next: function() {
      if (o2 && i3 >= o2.length) o2 = void 0;
      return { value: o2 && o2[i3++], done: !o2 };
    }
  };
  throw new TypeError(s4 ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function equalArray(left, right) {
  var length = left.length;
  if (length !== right.length) {
    return false;
  }
  for (var index2 = length; index2-- !== 0; ) {
    if (!equal(left[index2], right[index2])) {
      return false;
    }
  }
  return true;
}
function equalArrayBuffer(left, right) {
  if (left.byteLength !== right.byteLength) {
    return false;
  }
  var view1 = new DataView(left.buffer);
  var view2 = new DataView(right.buffer);
  var index2 = left.byteLength;
  while (index2--) {
    if (view1.getUint8(index2) !== view2.getUint8(index2)) {
      return false;
    }
  }
  return true;
}
function equalMap(left, right) {
  var e_1, _a, e_2, _b;
  if (left.size !== right.size) {
    return false;
  }
  try {
    for (var _c = __values(left.entries()), _d = _c.next(); !_d.done; _d = _c.next()) {
      var index2 = _d.value;
      if (!right.has(index2[0])) {
        return false;
      }
    }
  } catch (e_1_1) {
    e_1 = { error: e_1_1 };
  } finally {
    try {
      if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
    } finally {
      if (e_1) throw e_1.error;
    }
  }
  try {
    for (var _e = __values(left.entries()), _f = _e.next(); !_f.done; _f = _e.next()) {
      var index2 = _f.value;
      if (!equal(index2[1], right.get(index2[0]))) {
        return false;
      }
    }
  } catch (e_2_1) {
    e_2 = { error: e_2_1 };
  } finally {
    try {
      if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
    } finally {
      if (e_2) throw e_2.error;
    }
  }
  return true;
}
function equalSet(left, right) {
  var e_3, _a;
  if (left.size !== right.size) {
    return false;
  }
  try {
    for (var _b = __values(left.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
      var index2 = _c.value;
      if (!right.has(index2[0])) {
        return false;
      }
    }
  } catch (e_3_1) {
    e_3 = { error: e_3_1 };
  } finally {
    try {
      if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
    } finally {
      if (e_3) throw e_3.error;
    }
  }
  return true;
}
function equal(left, right) {
  if (left === right) {
    return true;
  }
  if (left && isObject$1(left) && right && isObject$1(right)) {
    if (left.constructor !== right.constructor) {
      return false;
    }
    if (Array.isArray(left) && Array.isArray(right)) {
      return equalArray(left, right);
    }
    if (left instanceof Map && right instanceof Map) {
      return equalMap(left, right);
    }
    if (left instanceof Set && right instanceof Set) {
      return equalSet(left, right);
    }
    if (ArrayBuffer.isView(left) && ArrayBuffer.isView(right)) {
      return equalArrayBuffer(left, right);
    }
    if (isRegex(left) && isRegex(right)) {
      return left.source === right.source && left.flags === right.flags;
    }
    if (left.valueOf !== Object.prototype.valueOf) {
      return left.valueOf() === right.valueOf();
    }
    if (left.toString !== Object.prototype.toString) {
      return left.toString() === right.toString();
    }
    var leftKeys = Object.keys(left);
    var rightKeys = Object.keys(right);
    if (leftKeys.length !== rightKeys.length) {
      return false;
    }
    for (var index2 = leftKeys.length; index2-- !== 0; ) {
      if (!Object.prototype.hasOwnProperty.call(right, leftKeys[index2])) {
        return false;
      }
    }
    for (var index2 = leftKeys.length; index2-- !== 0; ) {
      var key = leftKeys[index2];
      if (key === "_owner" && left.$$typeof) {
        continue;
      }
      if (!equal(left[key], right[key])) {
        return false;
      }
    }
    return true;
  }
  if (Number.isNaN(left) && Number.isNaN(right)) {
    return true;
  }
  return left === right;
}
function canHaveLength() {
  var arguments_ = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    arguments_[_i] = arguments[_i];
  }
  return arguments_.every(function(d4) {
    return is.string(d4) || is.array(d4) || is.plainObject(d4);
  });
}
function checkEquality(left, right, value) {
  if (!isSameType(left, right)) {
    return false;
  }
  if ([left, right].every(is.array)) {
    return !left.some(hasValue(value)) && right.some(hasValue(value));
  }
  if ([left, right].every(is.plainObject)) {
    return !Object.entries(left).some(hasEntry(value)) && Object.entries(right).some(hasEntry(value));
  }
  return right === value;
}
function compareNumbers(previousData, data, options) {
  var actual = options.actual, key = options.key, previous = options.previous, type = options.type;
  var left = nested(previousData, key);
  var right = nested(data, key);
  var changed = [left, right].every(is.number) && (type === "increased" ? left < right : left > right);
  if (!is.undefined(actual)) {
    changed = changed && right === actual;
  }
  if (!is.undefined(previous)) {
    changed = changed && left === previous;
  }
  return changed;
}
function compareValues(previousData, data, options) {
  var key = options.key, type = options.type, value = options.value;
  var left = nested(previousData, key);
  var right = nested(data, key);
  var primary = type === "added" ? left : right;
  var secondary = type === "added" ? right : left;
  if (!is.nullOrUndefined(value)) {
    if (is.defined(primary)) {
      if (is.array(primary) || is.plainObject(primary)) {
        return checkEquality(primary, secondary, value);
      }
    } else {
      return equal(secondary, value);
    }
    return false;
  }
  if ([left, right].every(is.array)) {
    return !secondary.every(isEqualPredicate(primary));
  }
  if ([left, right].every(is.plainObject)) {
    return hasExtraKeys(Object.keys(primary), Object.keys(secondary));
  }
  return ![left, right].every(function(d4) {
    return is.primitive(d4) && is.defined(d4);
  }) && (type === "added" ? !is.defined(left) && is.defined(right) : is.defined(left) && !is.defined(right));
}
function getIterables(previousData, data, _a) {
  var _b = _a === void 0 ? {} : _a, key = _b.key;
  var left = nested(previousData, key);
  var right = nested(data, key);
  if (!isSameType(left, right)) {
    throw new TypeError("Inputs have different types");
  }
  if (!canHaveLength(left, right)) {
    throw new TypeError("Inputs don't have length");
  }
  if ([left, right].every(is.plainObject)) {
    left = Object.keys(left);
    right = Object.keys(right);
  }
  return [left, right];
}
function hasEntry(input) {
  return function(_a) {
    var key = _a[0], value = _a[1];
    if (is.array(input)) {
      return equal(input, value) || input.some(function(d4) {
        return equal(d4, value) || is.array(value) && isEqualPredicate(value)(d4);
      });
    }
    if (is.plainObject(input) && input[key]) {
      return !!input[key] && equal(input[key], value);
    }
    return equal(input, value);
  };
}
function hasExtraKeys(left, right) {
  return right.some(function(d4) {
    return !left.includes(d4);
  });
}
function hasValue(input) {
  return function(value) {
    if (is.array(input)) {
      return input.some(function(d4) {
        return equal(d4, value) || is.array(value) && isEqualPredicate(value)(d4);
      });
    }
    return equal(input, value);
  };
}
function includesOrEqualsTo(previousValue, value) {
  return is.array(previousValue) ? previousValue.some(function(d4) {
    return equal(d4, value);
  }) : equal(previousValue, value);
}
function isEqualPredicate(data) {
  return function(value) {
    return data.some(function(d4) {
      return equal(d4, value);
    });
  };
}
function isSameType() {
  var arguments_ = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    arguments_[_i] = arguments[_i];
  }
  return arguments_.every(is.array) || arguments_.every(is.number) || arguments_.every(is.plainObject) || arguments_.every(is.string);
}
function nested(data, property) {
  if (is.plainObject(data) || is.array(data)) {
    if (is.string(property)) {
      var props = property.split(".");
      return props.reduce(function(acc, d4) {
        return acc && acc[d4];
      }, data);
    }
    if (is.number(property)) {
      return data[property];
    }
    return data;
  }
  return data;
}
function treeChanges(previousData, data) {
  if ([previousData, data].some(is.nullOrUndefined)) {
    throw new Error("Missing required parameters");
  }
  if (![previousData, data].every(function(d4) {
    return is.plainObject(d4) || is.array(d4);
  })) {
    throw new Error("Expected plain objects or array");
  }
  var added = function(key, value) {
    try {
      return compareValues(previousData, data, { key, type: "added", value });
    } catch (_a) {
      return false;
    }
  };
  var changed = function(key, actual, previous) {
    try {
      var left = nested(previousData, key);
      var right = nested(data, key);
      var hasActual = is.defined(actual);
      var hasPrevious = is.defined(previous);
      if (hasActual || hasPrevious) {
        var leftComparator = hasPrevious ? includesOrEqualsTo(previous, left) : !includesOrEqualsTo(actual, left);
        var rightComparator = includesOrEqualsTo(actual, right);
        return leftComparator && rightComparator;
      }
      if ([left, right].every(is.array) || [left, right].every(is.plainObject)) {
        return !equal(left, right);
      }
      return left !== right;
    } catch (_a) {
      return false;
    }
  };
  var changedFrom = function(key, previous, actual) {
    if (!is.defined(key)) {
      return false;
    }
    try {
      var left = nested(previousData, key);
      var right = nested(data, key);
      var hasActual = is.defined(actual);
      return includesOrEqualsTo(previous, left) && (hasActual ? includesOrEqualsTo(actual, right) : !hasActual);
    } catch (_a) {
      return false;
    }
  };
  var changedTo = function(key, actual) {
    if (!is.defined(key)) {
      return false;
    }
    if (process.env.NODE_ENV === "development") {
      console.warn("`changedTo` is deprecated! Replace it with `change`");
    }
    return changed(key, actual);
  };
  var decreased = function(key, actual, previous) {
    if (!is.defined(key)) {
      return false;
    }
    try {
      return compareNumbers(previousData, data, { key, actual, previous, type: "decreased" });
    } catch (_a) {
      return false;
    }
  };
  var emptied = function(key) {
    try {
      var _a = getIterables(previousData, data, { key }), left = _a[0], right = _a[1];
      return !!left.length && !right.length;
    } catch (_b) {
      return false;
    }
  };
  var filled = function(key) {
    try {
      var _a = getIterables(previousData, data, { key }), left = _a[0], right = _a[1];
      return !left.length && !!right.length;
    } catch (_b) {
      return false;
    }
  };
  var increased = function(key, actual, previous) {
    if (!is.defined(key)) {
      return false;
    }
    try {
      return compareNumbers(previousData, data, { key, actual, previous, type: "increased" });
    } catch (_a) {
      return false;
    }
  };
  var removed = function(key, value) {
    try {
      return compareValues(previousData, data, { key, type: "removed", value });
    } catch (_a) {
      return false;
    }
  };
  return { added, changed, changedFrom, changedTo, decreased, emptied, filled, increased, removed };
}
function ownKeys$E(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e3);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread2(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$E(Object(t3), true).forEach(function(r3) {
      _defineProperty$J(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$E(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
function _classCallCheck$n(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$n(target, props) {
  for (var i3 = 0; i3 < props.length; i3++) {
    var descriptor = props[i3];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$K(descriptor.key), descriptor);
  }
}
function _createClass$n(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$n(Constructor.prototype, protoProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty$J(obj, key, value) {
  key = _toPropertyKey$K(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _inherits$k(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf$k(subClass, superClass);
}
function _getPrototypeOf$k(o2) {
  _getPrototypeOf$k = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o3) {
    return o3.__proto__ || Object.getPrototypeOf(o3);
  };
  return _getPrototypeOf$k(o2);
}
function _setPrototypeOf$k(o2, p2) {
  _setPrototypeOf$k = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o3, p3) {
    o3.__proto__ = p3;
    return o3;
  };
  return _setPrototypeOf$k(o2, p2);
}
function _isNativeReflectConstruct$k() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e3) {
    return false;
  }
}
function _objectWithoutPropertiesLoose$l(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i3;
  for (i3 = 0; i3 < sourceKeys.length; i3++) {
    key = sourceKeys[i3];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties$l(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$l(source, excluded);
  var key, i3;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i3 = 0; i3 < sourceSymbolKeys.length; i3++) {
      key = sourceSymbolKeys[i3];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _assertThisInitialized$k(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _possibleConstructorReturn$k(self2, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$k(self2);
}
function _createSuper$1(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$k();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$k(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$k(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$k(this, result);
  };
}
function _toPrimitive$K(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint);
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey$K(arg) {
  var key = _toPrimitive$K(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
var DEFAULTS = { flip: { padding: 20 }, preventOverflow: { padding: 10 } };
var VALIDATOR_ARG_ERROR_MESSAGE = "The typeValidator argument must be a function with the signature function(props, propName, componentName).";
var MESSAGE_ARG_ERROR_MESSAGE = "The error message is optional, but must be a string if provided.";
function propIsRequired(condition, props, propName, componentName) {
  if (typeof condition === "boolean") {
    return condition;
  }
  if (typeof condition === "function") {
    return condition(props, propName, componentName);
  }
  if (Boolean(condition) === true) {
    return Boolean(condition);
  }
  return false;
}
function propExists(props, propName) {
  return Object.hasOwnProperty.call(props, propName);
}
function missingPropError(props, propName, componentName, message) {
  return new Error("Required ".concat(props[propName], " `").concat(propName, "` was not specified in `").concat(componentName, "`."));
}
function guardAgainstInvalidArgTypes(typeValidator, message) {
  if (typeof typeValidator !== "function") {
    throw new TypeError(VALIDATOR_ARG_ERROR_MESSAGE);
  }
  if (Boolean(message) && true) {
    throw new TypeError(MESSAGE_ARG_ERROR_MESSAGE);
  }
}
function isRequiredIf(typeValidator, condition, message) {
  guardAgainstInvalidArgTypes(typeValidator, message);
  return function(props, propName, componentName) {
    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }
    if (propIsRequired(condition, props, propName, componentName)) {
      if (propExists(props, propName)) {
        return typeValidator.apply(void 0, [props, propName, componentName].concat(rest));
      }
      return missingPropError(props, propName, componentName);
    }
    return typeValidator.apply(void 0, [props, propName, componentName].concat(rest));
  };
}
var STATUS$1 = { INIT: "init", IDLE: "idle", OPENING: "opening", OPEN: "open", CLOSING: "closing" };
var isReact16$1 = ReactDOM__default.createPortal !== void 0;
function canUseDOM$1() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}
function isMobile() {
  return "ontouchstart" in window && /Mobi/.test(navigator.userAgent);
}
function log$2(_ref) {
  var title = _ref.title, data = _ref.data, _ref$warn = _ref.warn, warn4 = _ref$warn === void 0 ? false : _ref$warn, _ref$debug = _ref.debug, debug2 = _ref$debug === void 0 ? false : _ref$debug;
  var logFn = warn4 ? console.warn || console.error : console.log;
  if (debug2 && title && data) {
    console.groupCollapsed("%creact-floater: ".concat(title), "color: #9b00ff; font-weight: bold; font-size: 12px;");
    if (Array.isArray(data)) {
      data.forEach(function(d4) {
        if (is.plainObject(d4) && d4.key) {
          logFn.apply(console, [d4.key, d4.value]);
        } else {
          logFn.apply(console, [d4]);
        }
      });
    } else {
      logFn.apply(console, [data]);
    }
    console.groupEnd();
  }
}
function on(element, event, cb2) {
  var capture = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
  element.addEventListener(event, cb2, capture);
}
function off(element, event, cb2) {
  var capture = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
  element.removeEventListener(event, cb2, capture);
}
function once(element, event, cb2) {
  var capture = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
  var _nextCB;
  _nextCB = function nextCB(e3) {
    cb2(e3);
    off(element, event, _nextCB);
  };
  on(element, event, _nextCB, capture);
}
function noop$2() {
}
var ReactFloaterPortal = /* @__PURE__ */ function(_React$Component) {
  _inherits$k(ReactFloaterPortal2, _React$Component);
  var _super = _createSuper$1(ReactFloaterPortal2);
  function ReactFloaterPortal2() {
    _classCallCheck$n(this, ReactFloaterPortal2);
    return _super.apply(this, arguments);
  }
  _createClass$n(ReactFloaterPortal2, [{ key: "componentDidMount", value: function componentDidMount() {
    if (!canUseDOM$1()) return;
    if (!this.node) {
      this.appendNode();
    }
    if (!isReact16$1) {
      this.renderPortal();
    }
  } }, { key: "componentDidUpdate", value: function componentDidUpdate() {
    if (!canUseDOM$1()) return;
    if (!isReact16$1) {
      this.renderPortal();
    }
  } }, { key: "componentWillUnmount", value: function componentWillUnmount() {
    if (!canUseDOM$1() || !this.node) return;
    if (!isReact16$1) {
      ReactDOM__default.unmountComponentAtNode(this.node);
    }
    if (this.node && this.node.parentNode === document.body) {
      document.body.removeChild(this.node);
      this.node = void 0;
    }
  } }, { key: "appendNode", value: function appendNode() {
    var _this$props = this.props, id2 = _this$props.id, zIndex = _this$props.zIndex;
    if (!this.node) {
      this.node = document.createElement("div");
      if (id2) {
        this.node.id = id2;
      }
      if (zIndex) {
        this.node.style.zIndex = zIndex;
      }
      document.body.appendChild(this.node);
    }
  } }, { key: "renderPortal", value: function renderPortal() {
    if (!canUseDOM$1()) return null;
    var _this$props2 = this.props, children = _this$props2.children, setRef = _this$props2.setRef;
    if (!this.node) {
      this.appendNode();
    }
    if (isReact16$1) {
      return /* @__PURE__ */ ReactDOM__default.createPortal(children, this.node);
    }
    var portal = ReactDOM__default.unstable_renderSubtreeIntoContainer(this, children.length > 1 ? /* @__PURE__ */ React__default.createElement("div", null, children) : children[0], this.node);
    setRef(portal);
    return null;
  } }, { key: "renderReact16", value: function renderReact16() {
    var _this$props3 = this.props, hasChildren = _this$props3.hasChildren, placement = _this$props3.placement, target = _this$props3.target;
    if (!hasChildren) {
      if (target || placement === "center") {
        return this.renderPortal();
      }
      return null;
    }
    return this.renderPortal();
  } }, { key: "render", value: function render() {
    if (!isReact16$1) {
      return null;
    }
    return this.renderReact16();
  } }]);
  return ReactFloaterPortal2;
}(React__default.Component);
_defineProperty$J(ReactFloaterPortal, "propTypes", { children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]), hasChildren: PropTypes.bool, id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), placement: PropTypes.string, setRef: PropTypes.func.isRequired, target: PropTypes.oneOfType([PropTypes.object, PropTypes.string]), zIndex: PropTypes.number });
var FloaterArrow = /* @__PURE__ */ function(_React$Component) {
  _inherits$k(FloaterArrow2, _React$Component);
  var _super = _createSuper$1(FloaterArrow2);
  function FloaterArrow2() {
    _classCallCheck$n(this, FloaterArrow2);
    return _super.apply(this, arguments);
  }
  _createClass$n(FloaterArrow2, [{ key: "parentStyle", get: function get2() {
    var _this$props = this.props, placement = _this$props.placement, styles = _this$props.styles;
    var length = styles.arrow.length;
    var arrow2 = { pointerEvents: "none", position: "absolute", width: "100%" };
    if (placement.startsWith("top")) {
      arrow2.bottom = 0;
      arrow2.left = 0;
      arrow2.right = 0;
      arrow2.height = length;
    } else if (placement.startsWith("bottom")) {
      arrow2.left = 0;
      arrow2.right = 0;
      arrow2.top = 0;
      arrow2.height = length;
    } else if (placement.startsWith("left")) {
      arrow2.right = 0;
      arrow2.top = 0;
      arrow2.bottom = 0;
    } else if (placement.startsWith("right")) {
      arrow2.left = 0;
      arrow2.top = 0;
    }
    return arrow2;
  } }, { key: "render", value: function render() {
    var _this$props2 = this.props, placement = _this$props2.placement, setArrowRef = _this$props2.setArrowRef, styles = _this$props2.styles;
    var _styles$arrow = styles.arrow, color2 = _styles$arrow.color, display = _styles$arrow.display, length = _styles$arrow.length, margin = _styles$arrow.margin, position = _styles$arrow.position, spread = _styles$arrow.spread;
    var arrowStyles = { display, position };
    var points;
    var x3 = spread;
    var y4 = length;
    if (placement.startsWith("top")) {
      points = "0,0 ".concat(x3 / 2, ",").concat(y4, " ").concat(x3, ",0");
      arrowStyles.bottom = 0;
      arrowStyles.marginLeft = margin;
      arrowStyles.marginRight = margin;
    } else if (placement.startsWith("bottom")) {
      points = "".concat(x3, ",").concat(y4, " ").concat(x3 / 2, ",0 0,").concat(y4);
      arrowStyles.top = 0;
      arrowStyles.marginLeft = margin;
      arrowStyles.marginRight = margin;
    } else if (placement.startsWith("left")) {
      y4 = spread;
      x3 = length;
      points = "0,0 ".concat(x3, ",").concat(y4 / 2, " 0,").concat(y4);
      arrowStyles.right = 0;
      arrowStyles.marginTop = margin;
      arrowStyles.marginBottom = margin;
    } else if (placement.startsWith("right")) {
      y4 = spread;
      x3 = length;
      points = "".concat(x3, ",").concat(y4, " ").concat(x3, ",0 0,").concat(y4 / 2);
      arrowStyles.left = 0;
      arrowStyles.marginTop = margin;
      arrowStyles.marginBottom = margin;
    }
    return /* @__PURE__ */ React__default.createElement("div", { className: "__floater__arrow", style: this.parentStyle }, /* @__PURE__ */ React__default.createElement("span", { ref: setArrowRef, style: arrowStyles }, /* @__PURE__ */ React__default.createElement("svg", { width: x3, height: y4, version: "1.1", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React__default.createElement("polygon", { points, fill: color2 }))));
  } }]);
  return FloaterArrow2;
}(React__default.Component);
_defineProperty$J(FloaterArrow, "propTypes", { placement: PropTypes.string.isRequired, setArrowRef: PropTypes.func.isRequired, styles: PropTypes.object.isRequired });
var _excluded$1$1 = ["color", "height", "width"];
function FloaterCloseBtn(_ref) {
  var handleClick = _ref.handleClick, styles = _ref.styles;
  var color2 = styles.color, height = styles.height, width = styles.width, style = _objectWithoutProperties$l(styles, _excluded$1$1);
  return /* @__PURE__ */ React__default.createElement("button", { "aria-label": "close", onClick: handleClick, style, type: "button" }, /* @__PURE__ */ React__default.createElement("svg", { width: "".concat(width, "px"), height: "".concat(height, "px"), viewBox: "0 0 18 18", version: "1.1", xmlns: "http://www.w3.org/2000/svg", preserveAspectRatio: "xMidYMid" }, /* @__PURE__ */ React__default.createElement("g", null, /* @__PURE__ */ React__default.createElement("path", { d: "M8.13911129,9.00268191 L0.171521827,17.0258467 C-0.0498027049,17.248715 -0.0498027049,17.6098394 0.171521827,17.8327545 C0.28204354,17.9443526 0.427188206,17.9998706 0.572051765,17.9998706 C0.71714958,17.9998706 0.862013139,17.9443526 0.972581703,17.8327545 L9.0000937,9.74924618 L17.0276057,17.8327545 C17.1384085,17.9443526 17.2832721,17.9998706 17.4281356,17.9998706 C17.5729992,17.9998706 17.718097,17.9443526 17.8286656,17.8327545 C18.0499901,17.6098862 18.0499901,17.2487618 17.8286656,17.0258467 L9.86135722,9.00268191 L17.8340066,0.973848225 C18.0553311,0.750979934 18.0553311,0.389855532 17.8340066,0.16694039 C17.6126821,-0.0556467968 17.254037,-0.0556467968 17.0329467,0.16694039 L9.00042166,8.25611765 L0.967006424,0.167268345 C0.745681892,-0.0553188426 0.387317931,-0.0553188426 0.165993399,0.167268345 C-0.0553311331,0.390136635 -0.0553311331,0.751261038 0.165993399,0.974176179 L8.13920499,9.00268191 L8.13911129,9.00268191 Z", fill: color2 }))));
}
FloaterCloseBtn.propTypes = { handleClick: PropTypes.func.isRequired, styles: PropTypes.object.isRequired };
function FloaterContainer(_ref) {
  var content = _ref.content, footer = _ref.footer, handleClick = _ref.handleClick, open = _ref.open, positionWrapper = _ref.positionWrapper, showCloseButton = _ref.showCloseButton, title = _ref.title, styles = _ref.styles;
  var output = { content: /* @__PURE__ */ React__default.isValidElement(content) ? content : /* @__PURE__ */ React__default.createElement("div", { className: "__floater__content", style: styles.content }, content) };
  if (title) {
    output.title = /* @__PURE__ */ React__default.isValidElement(title) ? title : /* @__PURE__ */ React__default.createElement("div", { className: "__floater__title", style: styles.title }, title);
  }
  if (footer) {
    output.footer = /* @__PURE__ */ React__default.isValidElement(footer) ? footer : /* @__PURE__ */ React__default.createElement("div", { className: "__floater__footer", style: styles.footer }, footer);
  }
  if ((showCloseButton || positionWrapper) && !is["boolean"](open)) {
    output.close = /* @__PURE__ */ React__default.createElement(FloaterCloseBtn, { styles: styles.close, handleClick });
  }
  return /* @__PURE__ */ React__default.createElement("div", { className: "__floater__container", style: styles.container }, output.close, output.title, output.content, output.footer);
}
FloaterContainer.propTypes = { content: PropTypes.node.isRequired, footer: PropTypes.node, handleClick: PropTypes.func.isRequired, open: PropTypes.bool, positionWrapper: PropTypes.bool.isRequired, showCloseButton: PropTypes.bool.isRequired, styles: PropTypes.object.isRequired, title: PropTypes.node };
var Floater = /* @__PURE__ */ function(_React$Component) {
  _inherits$k(Floater2, _React$Component);
  var _super = _createSuper$1(Floater2);
  function Floater2() {
    _classCallCheck$n(this, Floater2);
    return _super.apply(this, arguments);
  }
  _createClass$n(Floater2, [{ key: "style", get: function get2() {
    var _this$props = this.props, disableAnimation = _this$props.disableAnimation, component = _this$props.component, placement = _this$props.placement, hideArrow = _this$props.hideArrow, status = _this$props.status, styles = _this$props.styles;
    var length = styles.arrow.length, floater = styles.floater, floaterCentered = styles.floaterCentered, floaterClosing = styles.floaterClosing, floaterOpening = styles.floaterOpening, floaterWithAnimation = styles.floaterWithAnimation, floaterWithComponent = styles.floaterWithComponent;
    var element = {};
    if (!hideArrow) {
      if (placement.startsWith("top")) {
        element.padding = "0 0 ".concat(length, "px");
      } else if (placement.startsWith("bottom")) {
        element.padding = "".concat(length, "px 0 0");
      } else if (placement.startsWith("left")) {
        element.padding = "0 ".concat(length, "px 0 0");
      } else if (placement.startsWith("right")) {
        element.padding = "0 0 0 ".concat(length, "px");
      }
    }
    if ([STATUS$1.OPENING, STATUS$1.OPEN].indexOf(status) !== -1) {
      element = _objectSpread2(_objectSpread2({}, element), floaterOpening);
    }
    if (status === STATUS$1.CLOSING) {
      element = _objectSpread2(_objectSpread2({}, element), floaterClosing);
    }
    if (status === STATUS$1.OPEN && !disableAnimation) {
      element = _objectSpread2(_objectSpread2({}, element), floaterWithAnimation);
    }
    if (placement === "center") {
      element = _objectSpread2(_objectSpread2({}, element), floaterCentered);
    }
    if (component) {
      element = _objectSpread2(_objectSpread2({}, element), floaterWithComponent);
    }
    return _objectSpread2(_objectSpread2({}, floater), element);
  } }, { key: "render", value: function render() {
    var _this$props2 = this.props, component = _this$props2.component, closeFn = _this$props2.handleClick, hideArrow = _this$props2.hideArrow, setFloaterRef = _this$props2.setFloaterRef, status = _this$props2.status;
    var output = {};
    var classes = ["__floater"];
    if (component) {
      if (/* @__PURE__ */ React__default.isValidElement(component)) {
        output.content = /* @__PURE__ */ React__default.cloneElement(component, { closeFn });
      } else {
        output.content = component({ closeFn });
      }
    } else {
      output.content = /* @__PURE__ */ React__default.createElement(FloaterContainer, this.props);
    }
    if (status === STATUS$1.OPEN) {
      classes.push("__floater__open");
    }
    if (!hideArrow) {
      output.arrow = /* @__PURE__ */ React__default.createElement(FloaterArrow, this.props);
    }
    return /* @__PURE__ */ React__default.createElement("div", { ref: setFloaterRef, className: classes.join(" "), style: this.style }, /* @__PURE__ */ React__default.createElement("div", { className: "__floater__body" }, output.content, output.arrow));
  } }]);
  return Floater2;
}(React__default.Component);
_defineProperty$J(Floater, "propTypes", { component: PropTypes.oneOfType([PropTypes.func, PropTypes.element]), content: PropTypes.node, disableAnimation: PropTypes.bool.isRequired, footer: PropTypes.node, handleClick: PropTypes.func.isRequired, hideArrow: PropTypes.bool.isRequired, open: PropTypes.bool, placement: PropTypes.string.isRequired, positionWrapper: PropTypes.bool.isRequired, setArrowRef: PropTypes.func.isRequired, setFloaterRef: PropTypes.func.isRequired, showCloseButton: PropTypes.bool, status: PropTypes.string.isRequired, styles: PropTypes.object.isRequired, title: PropTypes.node });
var ReactFloaterWrapper = /* @__PURE__ */ function(_React$Component) {
  _inherits$k(ReactFloaterWrapper2, _React$Component);
  var _super = _createSuper$1(ReactFloaterWrapper2);
  function ReactFloaterWrapper2() {
    _classCallCheck$n(this, ReactFloaterWrapper2);
    return _super.apply(this, arguments);
  }
  _createClass$n(ReactFloaterWrapper2, [{ key: "render", value: function render() {
    var _this$props = this.props, children = _this$props.children, handleClick = _this$props.handleClick, handleMouseEnter = _this$props.handleMouseEnter, handleMouseLeave = _this$props.handleMouseLeave, setChildRef = _this$props.setChildRef, setWrapperRef = _this$props.setWrapperRef, style = _this$props.style, styles = _this$props.styles;
    var element;
    if (children) {
      if (React__default.Children.count(children) === 1) {
        if (!/* @__PURE__ */ React__default.isValidElement(children)) {
          element = /* @__PURE__ */ React__default.createElement("span", null, children);
        } else {
          var refProp = is["function"](children.type) ? "innerRef" : "ref";
          element = /* @__PURE__ */ React__default.cloneElement(React__default.Children.only(children), _defineProperty$J({}, refProp, setChildRef));
        }
      } else {
        element = children;
      }
    }
    if (!element) {
      return null;
    }
    return /* @__PURE__ */ React__default.createElement("span", { ref: setWrapperRef, style: _objectSpread2(_objectSpread2({}, styles), style), onClick: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave }, element);
  } }]);
  return ReactFloaterWrapper2;
}(React__default.Component);
_defineProperty$J(ReactFloaterWrapper, "propTypes", { children: PropTypes.node, handleClick: PropTypes.func.isRequired, handleMouseEnter: PropTypes.func.isRequired, handleMouseLeave: PropTypes.func.isRequired, setChildRef: PropTypes.func.isRequired, setWrapperRef: PropTypes.func.isRequired, style: PropTypes.object, styles: PropTypes.object.isRequired });
var defaultOptions$1 = { zIndex: 100 };
function getStyles$1(styles) {
  var options = deepmerge2(defaultOptions$1, styles.options || {});
  return { wrapper: { cursor: "help", display: "inline-flex", flexDirection: "column", zIndex: options.zIndex }, wrapperPosition: { left: -1e3, position: "absolute", top: -1e3, visibility: "hidden" }, floater: { display: "inline-block", filter: "drop-shadow(0 0 3px rgba(0, 0, 0, 0.3))", maxWidth: 300, opacity: 0, position: "relative", transition: "opacity 0.3s", visibility: "hidden", zIndex: options.zIndex }, floaterOpening: { opacity: 1, visibility: "visible" }, floaterWithAnimation: { opacity: 1, transition: "opacity 0.3s, transform 0.2s", visibility: "visible" }, floaterWithComponent: { maxWidth: "100%" }, floaterClosing: { opacity: 0, visibility: "visible" }, floaterCentered: { left: "50%", position: "fixed", top: "50%", transform: "translate(-50%, -50%)" }, container: { backgroundColor: "#fff", color: "#666", minHeight: 60, minWidth: 200, padding: 20, position: "relative", zIndex: 10 }, title: { borderBottom: "1px solid #555", color: "#555", fontSize: 18, marginBottom: 5, paddingBottom: 6, paddingRight: 18 }, content: { fontSize: 15 }, close: { backgroundColor: "transparent", border: 0, borderRadius: 0, color: "#555", fontSize: 0, height: 15, outline: "none", padding: 10, position: "absolute", right: 0, top: 0, width: 15, WebkitAppearance: "none" }, footer: { borderTop: "1px solid #ccc", fontSize: 13, marginTop: 10, paddingTop: 5 }, arrow: { color: "#fff", display: "inline-flex", length: 16, margin: 8, position: "absolute", spread: 32 }, options };
}
var _excluded$l = ["arrow", "flip", "offset"];
var POSITIONING_PROPS = ["position", "top", "right", "bottom", "left"];
var ReactFloater = /* @__PURE__ */ function(_React$Component) {
  _inherits$k(ReactFloater2, _React$Component);
  var _super = _createSuper$1(ReactFloater2);
  function ReactFloater2(props) {
    var _this;
    _classCallCheck$n(this, ReactFloater2);
    _this = _super.call(this, props);
    _defineProperty$J(_assertThisInitialized$k(_this), "setArrowRef", function(ref) {
      _this.arrowRef = ref;
    });
    _defineProperty$J(_assertThisInitialized$k(_this), "setChildRef", function(ref) {
      _this.childRef = ref;
    });
    _defineProperty$J(_assertThisInitialized$k(_this), "setFloaterRef", function(ref) {
      _this.floaterRef = ref;
    });
    _defineProperty$J(_assertThisInitialized$k(_this), "setWrapperRef", function(ref) {
      _this.wrapperRef = ref;
    });
    _defineProperty$J(_assertThisInitialized$k(_this), "handleTransitionEnd", function() {
      var status = _this.state.status;
      var callback = _this.props.callback;
      if (_this.wrapperPopper) {
        _this.wrapperPopper.instance.update();
      }
      _this.setState({ status: status === STATUS$1.OPENING ? STATUS$1.OPEN : STATUS$1.IDLE }, function() {
        var newStatus = _this.state.status;
        callback(newStatus === STATUS$1.OPEN ? "open" : "close", _this.props);
      });
    });
    _defineProperty$J(_assertThisInitialized$k(_this), "handleClick", function() {
      var _this$props = _this.props, event = _this$props.event, open = _this$props.open;
      if (is["boolean"](open)) return;
      var _this$state = _this.state, positionWrapper = _this$state.positionWrapper, status = _this$state.status;
      if (_this.event === "click" || _this.event === "hover" && positionWrapper) {
        log$2({ title: "click", data: [{ event, status: status === STATUS$1.OPEN ? "closing" : "opening" }], debug: _this.debug });
        _this.toggle();
      }
    });
    _defineProperty$J(_assertThisInitialized$k(_this), "handleMouseEnter", function() {
      var _this$props2 = _this.props, event = _this$props2.event, open = _this$props2.open;
      if (is["boolean"](open) || isMobile()) return;
      var status = _this.state.status;
      if (_this.event === "hover" && status === STATUS$1.IDLE) {
        log$2({ title: "mouseEnter", data: [{ key: "originalEvent", value: event }], debug: _this.debug });
        clearTimeout(_this.eventDelayTimeout);
        _this.toggle();
      }
    });
    _defineProperty$J(_assertThisInitialized$k(_this), "handleMouseLeave", function() {
      var _this$props3 = _this.props, event = _this$props3.event, eventDelay = _this$props3.eventDelay, open = _this$props3.open;
      if (is["boolean"](open) || isMobile()) return;
      var _this$state2 = _this.state, status = _this$state2.status, positionWrapper = _this$state2.positionWrapper;
      if (_this.event === "hover") {
        log$2({ title: "mouseLeave", data: [{ key: "originalEvent", value: event }], debug: _this.debug });
        if (!eventDelay) {
          _this.toggle(STATUS$1.IDLE);
        } else if ([STATUS$1.OPENING, STATUS$1.OPEN].indexOf(status) !== -1 && !positionWrapper && !_this.eventDelayTimeout) {
          _this.eventDelayTimeout = setTimeout(function() {
            delete _this.eventDelayTimeout;
            _this.toggle();
          }, eventDelay * 1e3);
        }
      }
    });
    _this.state = { currentPlacement: props.placement, needsUpdate: false, positionWrapper: props.wrapperOptions.position && !!props.target, status: STATUS$1.INIT, statusWrapper: STATUS$1.INIT };
    _this._isMounted = false;
    _this.hasMounted = false;
    if (canUseDOM$1()) {
      window.addEventListener("load", function() {
        if (_this.popper) {
          _this.popper.instance.update();
        }
        if (_this.wrapperPopper) {
          _this.wrapperPopper.instance.update();
        }
      });
    }
    return _this;
  }
  _createClass$n(ReactFloater2, [{ key: "componentDidMount", value: function componentDidMount() {
    if (!canUseDOM$1()) return;
    var positionWrapper = this.state.positionWrapper;
    var _this$props5 = this.props, children = _this$props5.children, open = _this$props5.open, target = _this$props5.target;
    this._isMounted = true;
    log$2({ title: "init", data: { hasChildren: !!children, hasTarget: !!target, isControlled: is["boolean"](open), positionWrapper, target: this.target, floater: this.floaterRef }, debug: this.debug });
    if (!this.hasMounted) {
      this.initPopper();
      this.hasMounted = true;
    }
    if (!children && target && !is["boolean"](open)) ;
  } }, { key: "componentDidUpdate", value: function componentDidUpdate(prevProps, prevState) {
    if (!canUseDOM$1()) return;
    var _this$props6 = this.props, autoOpen = _this$props6.autoOpen, open = _this$props6.open, target = _this$props6.target, wrapperOptions = _this$props6.wrapperOptions;
    var _treeChanges = treeChanges(prevState, this.state), changedFrom = _treeChanges.changedFrom, changed = _treeChanges.changed;
    if (prevProps.open !== open) {
      var forceStatus;
      if (is["boolean"](open)) {
        forceStatus = open ? STATUS$1.OPENING : STATUS$1.CLOSING;
      }
      this.toggle(forceStatus);
    }
    if (prevProps.wrapperOptions.position !== wrapperOptions.position || prevProps.target !== target) {
      this.changeWrapperPosition(this.props);
    }
    if (changed("status", STATUS$1.IDLE) && open) {
      this.toggle(STATUS$1.OPEN);
    } else if (changedFrom("status", STATUS$1.INIT, STATUS$1.IDLE) && autoOpen) {
      this.toggle(STATUS$1.OPEN);
    }
    if (this.popper && changed("status", STATUS$1.OPENING)) {
      this.popper.instance.update();
    }
    if (this.floaterRef && (changed("status", STATUS$1.OPENING) || changed("status", STATUS$1.CLOSING))) {
      once(this.floaterRef, "transitionend", this.handleTransitionEnd);
    }
    if (changed("needsUpdate", true)) {
      this.rebuildPopper();
    }
  } }, { key: "componentWillUnmount", value: function componentWillUnmount() {
    if (!canUseDOM$1()) return;
    this._isMounted = false;
    if (this.popper) {
      this.popper.instance.destroy();
    }
    if (this.wrapperPopper) {
      this.wrapperPopper.instance.destroy();
    }
  } }, { key: "initPopper", value: function initPopper() {
    var _this2 = this;
    var target = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.target;
    var positionWrapper = this.state.positionWrapper;
    var _this$props7 = this.props, disableFlip = _this$props7.disableFlip, getPopper = _this$props7.getPopper, hideArrow = _this$props7.hideArrow, offset2 = _this$props7.offset, placement = _this$props7.placement, wrapperOptions = _this$props7.wrapperOptions;
    var flipBehavior = placement === "top" || placement === "bottom" ? "flip" : ["right", "bottom-end", "top-end", "left", "top-start", "bottom-start"];
    if (placement === "center") {
      this.setState({ status: STATUS$1.IDLE });
    } else if (target && this.floaterRef) {
      var _this$options = this.options, arrow2 = _this$options.arrow, flip2 = _this$options.flip, offsetOptions = _this$options.offset, rest = _objectWithoutProperties$l(_this$options, _excluded$l);
      new Popper(target, this.floaterRef, { placement, modifiers: _objectSpread2({ arrow: _objectSpread2({ enabled: !hideArrow, element: this.arrowRef }, arrow2), flip: _objectSpread2({ enabled: !disableFlip, behavior: flipBehavior }, flip2), offset: _objectSpread2({ offset: "0, ".concat(offset2, "px") }, offsetOptions) }, rest), onCreate: function onCreate2(data) {
        var _this2$floaterRef;
        _this2.popper = data;
        if (!((_this2$floaterRef = _this2.floaterRef) !== null && _this2$floaterRef !== void 0 && _this2$floaterRef.isConnected)) {
          _this2.setState({ needsUpdate: true });
          return;
        }
        getPopper(data, "floater");
        if (_this2._isMounted) {
          _this2.setState({ currentPlacement: data.placement, status: STATUS$1.IDLE });
        }
        if (placement !== data.placement) {
          setTimeout(function() {
            data.instance.update();
          }, 1);
        }
      }, onUpdate: function onUpdate2(data) {
        _this2.popper = data;
        var currentPlacement = _this2.state.currentPlacement;
        if (_this2._isMounted && data.placement !== currentPlacement) {
          _this2.setState({ currentPlacement: data.placement });
        }
      } });
    }
    if (positionWrapper) {
      var wrapperOffset = !is.undefined(wrapperOptions.offset) ? wrapperOptions.offset : 0;
      new Popper(this.target, this.wrapperRef, { placement: wrapperOptions.placement || placement, modifiers: { arrow: { enabled: false }, offset: { offset: "0, ".concat(wrapperOffset, "px") }, flip: { enabled: false } }, onCreate: function onCreate2(data) {
        _this2.wrapperPopper = data;
        if (_this2._isMounted) {
          _this2.setState({ statusWrapper: STATUS$1.IDLE });
        }
        getPopper(data, "wrapper");
        if (placement !== data.placement) {
          setTimeout(function() {
            data.instance.update();
          }, 1);
        }
      } });
    }
  } }, { key: "rebuildPopper", value: function rebuildPopper() {
    var _this3 = this;
    this.floaterRefInterval = setInterval(function() {
      var _this3$floaterRef;
      if ((_this3$floaterRef = _this3.floaterRef) !== null && _this3$floaterRef !== void 0 && _this3$floaterRef.isConnected) {
        clearInterval(_this3.floaterRefInterval);
        _this3.setState({ needsUpdate: false });
        _this3.initPopper();
      }
    }, 50);
  } }, { key: "changeWrapperPosition", value: function changeWrapperPosition(_ref) {
    var target = _ref.target, wrapperOptions = _ref.wrapperOptions;
    this.setState({ positionWrapper: wrapperOptions.position && !!target });
  } }, { key: "toggle", value: function toggle(forceStatus) {
    var status = this.state.status;
    var nextStatus = status === STATUS$1.OPEN ? STATUS$1.CLOSING : STATUS$1.OPENING;
    if (!is.undefined(forceStatus)) {
      nextStatus = forceStatus;
    }
    this.setState({ status: nextStatus });
  } }, { key: "debug", get: function get2() {
    var debug2 = this.props.debug;
    return debug2 || canUseDOM$1() && "ReactFloaterDebug" in window && !!window.ReactFloaterDebug;
  } }, { key: "event", get: function get2() {
    var _this$props8 = this.props, disableHoverToClick = _this$props8.disableHoverToClick, event = _this$props8.event;
    if (event === "hover" && isMobile() && !disableHoverToClick) {
      return "click";
    }
    return event;
  } }, { key: "options", get: function get2() {
    var options = this.props.options;
    return deepmerge2(DEFAULTS, options || {});
  } }, { key: "styles", get: function get2() {
    var _this4 = this;
    var _this$state3 = this.state, status = _this$state3.status, positionWrapper = _this$state3.positionWrapper, statusWrapper = _this$state3.statusWrapper;
    var styles = this.props.styles;
    var nextStyles = deepmerge2(getStyles$1(styles), styles);
    if (positionWrapper) {
      var wrapperStyles;
      if (!([STATUS$1.IDLE].indexOf(status) !== -1) || !([STATUS$1.IDLE].indexOf(statusWrapper) !== -1)) {
        wrapperStyles = nextStyles.wrapperPosition;
      } else {
        wrapperStyles = this.wrapperPopper.styles;
      }
      nextStyles.wrapper = _objectSpread2(_objectSpread2({}, nextStyles.wrapper), wrapperStyles);
    }
    if (this.target) {
      var targetStyles = window.getComputedStyle(this.target);
      if (this.wrapperStyles) {
        nextStyles.wrapper = _objectSpread2(_objectSpread2({}, nextStyles.wrapper), this.wrapperStyles);
      } else if (!(["relative", "static"].indexOf(targetStyles.position) !== -1)) {
        this.wrapperStyles = {};
        if (!positionWrapper) {
          POSITIONING_PROPS.forEach(function(d4) {
            _this4.wrapperStyles[d4] = targetStyles[d4];
          });
          nextStyles.wrapper = _objectSpread2(_objectSpread2({}, nextStyles.wrapper), this.wrapperStyles);
          this.target.style.position = "relative";
          this.target.style.top = "auto";
          this.target.style.right = "auto";
          this.target.style.bottom = "auto";
          this.target.style.left = "auto";
        }
      }
    }
    return nextStyles;
  } }, { key: "target", get: function get2() {
    if (!canUseDOM$1()) return null;
    var target = this.props.target;
    if (target) {
      if (is.domElement(target)) {
        return target;
      }
      return document.querySelector(target);
    }
    return this.childRef || this.wrapperRef;
  } }, { key: "render", value: function render() {
    var _this$state4 = this.state, currentPlacement = _this$state4.currentPlacement, positionWrapper = _this$state4.positionWrapper, status = _this$state4.status;
    var _this$props9 = this.props, children = _this$props9.children, component = _this$props9.component, content = _this$props9.content, disableAnimation = _this$props9.disableAnimation, footer = _this$props9.footer, hideArrow = _this$props9.hideArrow, id2 = _this$props9.id, open = _this$props9.open, showCloseButton = _this$props9.showCloseButton, style = _this$props9.style, target = _this$props9.target, title = _this$props9.title;
    var wrapper = /* @__PURE__ */ React__default.createElement(ReactFloaterWrapper, { handleClick: this.handleClick, handleMouseEnter: this.handleMouseEnter, handleMouseLeave: this.handleMouseLeave, setChildRef: this.setChildRef, setWrapperRef: this.setWrapperRef, style, styles: this.styles.wrapper }, children);
    var output = {};
    if (positionWrapper) {
      output.wrapperInPortal = wrapper;
    } else {
      output.wrapperAsChildren = wrapper;
    }
    return /* @__PURE__ */ React__default.createElement("span", null, /* @__PURE__ */ React__default.createElement(ReactFloaterPortal, { hasChildren: !!children, id: id2, placement: currentPlacement, setRef: this.setFloaterRef, target, zIndex: this.styles.options.zIndex }, /* @__PURE__ */ React__default.createElement(Floater, { component, content, disableAnimation, footer, handleClick: this.handleClick, hideArrow: hideArrow || currentPlacement === "center", open, placement: currentPlacement, positionWrapper, setArrowRef: this.setArrowRef, setFloaterRef: this.setFloaterRef, showCloseButton, status, styles: this.styles, title }), output.wrapperInPortal), output.wrapperAsChildren);
  } }]);
  return ReactFloater2;
}(React__default.Component);
_defineProperty$J(ReactFloater, "propTypes", { autoOpen: PropTypes.bool, callback: PropTypes.func, children: PropTypes.node, component: isRequiredIf(PropTypes.oneOfType([PropTypes.func, PropTypes.element]), function(props) {
  return !props.content;
}), content: isRequiredIf(PropTypes.node, function(props) {
  return !props.component;
}), debug: PropTypes.bool, disableAnimation: PropTypes.bool, disableFlip: PropTypes.bool, disableHoverToClick: PropTypes.bool, event: PropTypes.oneOf(["hover", "click"]), eventDelay: PropTypes.number, footer: PropTypes.node, getPopper: PropTypes.func, hideArrow: PropTypes.bool, id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), offset: PropTypes.number, open: PropTypes.bool, options: PropTypes.object, placement: PropTypes.oneOf(["top", "top-start", "top-end", "bottom", "bottom-start", "bottom-end", "left", "left-start", "left-end", "right", "right-start", "right-end", "auto", "center"]), showCloseButton: PropTypes.bool, style: PropTypes.object, styles: PropTypes.object, target: PropTypes.oneOfType([PropTypes.object, PropTypes.string]), title: PropTypes.node, wrapperOptions: PropTypes.shape({ offset: PropTypes.number, placement: PropTypes.oneOf(["top", "top-start", "top-end", "bottom", "bottom-start", "bottom-end", "left", "left-start", "left-end", "right", "right-start", "right-end", "auto"]), position: PropTypes.bool }) });
_defineProperty$J(ReactFloater, "defaultProps", { autoOpen: false, callback: noop$2, debug: false, disableAnimation: false, disableFlip: false, disableHoverToClick: false, event: "click", eventDelay: 0.4, getPopper: noop$2, hideArrow: false, offset: 15, placement: "bottom", showCloseButton: false, styles: {}, target: null, wrapperOptions: { position: false } });
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var ACTIONS = {
  INIT: "init",
  START: "start",
  STOP: "stop",
  RESET: "reset",
  PREV: "prev",
  NEXT: "next",
  GO: "go",
  CLOSE: "close",
  SKIP: "skip",
  UPDATE: "update"
};
var EVENTS = {
  TOUR_START: "tour:start",
  STEP_BEFORE: "step:before",
  BEACON: "beacon",
  TOOLTIP: "tooltip",
  STEP_AFTER: "step:after",
  TOUR_END: "tour:end",
  TOUR_STATUS: "tour:status",
  TARGET_NOT_FOUND: "error:target_not_found"
};
var LIFECYCLE = {
  INIT: "init",
  READY: "ready",
  BEACON: "beacon",
  TOOLTIP: "tooltip",
  COMPLETE: "complete",
  ERROR: "error"
};
var STATUS = {
  IDLE: "idle",
  READY: "ready",
  WAITING: "waiting",
  RUNNING: "running",
  PAUSED: "paused",
  SKIPPED: "skipped",
  FINISHED: "finished"
};
function canUseDOM() {
  var _a;
  return !!(typeof window !== "undefined" && ((_a = window.document) == null ? void 0 : _a.createElement));
}
function getClientRect(element) {
  if (!element) {
    return null;
  }
  return element.getBoundingClientRect();
}
function getDocumentHeight(median2 = false) {
  const { body, documentElement } = document;
  if (!body || !documentElement) {
    return 0;
  }
  if (median2) {
    const heights = [
      body.scrollHeight,
      body.offsetHeight,
      documentElement.clientHeight,
      documentElement.scrollHeight,
      documentElement.offsetHeight
    ].sort((a4, b3) => a4 - b3);
    const middle = Math.floor(heights.length / 2);
    if (heights.length % 2 === 0) {
      return (heights[middle - 1] + heights[middle]) / 2;
    }
    return heights[middle];
  }
  return Math.max(
    body.scrollHeight,
    body.offsetHeight,
    documentElement.clientHeight,
    documentElement.scrollHeight,
    documentElement.offsetHeight
  );
}
function getElement(element) {
  if (typeof element === "string") {
    try {
      return document.querySelector(element);
    } catch (error) {
      if (process.env.NODE_ENV !== "production") {
        console.error(error);
      }
      return null;
    }
  }
  return element;
}
function getStyleComputedProperty(el) {
  if (!el || el.nodeType !== 1) {
    return null;
  }
  return getComputedStyle(el);
}
function getScrollParent(element, skipFix, forListener) {
  if (!element) {
    return scrollDocument();
  }
  const parent = scrollParent(element);
  if (parent) {
    if (parent.isSameNode(scrollDocument())) {
      if (forListener) {
        return document;
      }
      return scrollDocument();
    }
    const hasScrolling = parent.scrollHeight > parent.offsetHeight;
    if (!hasScrolling && !skipFix) {
      parent.style.overflow = "initial";
      return scrollDocument();
    }
  }
  return parent;
}
function hasCustomScrollParent(element, skipFix) {
  if (!element) {
    return false;
  }
  const parent = getScrollParent(element, skipFix);
  return parent ? !parent.isSameNode(scrollDocument()) : false;
}
function hasCustomOffsetParent(element) {
  return element.offsetParent !== document.body;
}
function hasPosition(el, type = "fixed") {
  if (!el || !(el instanceof HTMLElement)) {
    return false;
  }
  const { nodeName } = el;
  const styles = getStyleComputedProperty(el);
  if (nodeName === "BODY" || nodeName === "HTML") {
    return false;
  }
  if (styles && styles.position === type) {
    return true;
  }
  if (!el.parentNode) {
    return false;
  }
  return hasPosition(el.parentNode, type);
}
function isElementVisible(element) {
  var _a;
  if (!element) {
    return false;
  }
  let parentElement = element;
  while (parentElement) {
    if (parentElement === document.body) {
      break;
    }
    if (parentElement instanceof HTMLElement) {
      const { display, visibility } = getComputedStyle(parentElement);
      if (display === "none" || visibility === "hidden") {
        return false;
      }
    }
    parentElement = (_a = parentElement.parentElement) != null ? _a : null;
  }
  return true;
}
function getElementPosition(element, offset2, skipFix) {
  var _a, _b, _c;
  const elementRect = getClientRect(element);
  const parent = getScrollParent(element, skipFix);
  const hasScrollParent = hasCustomScrollParent(element, skipFix);
  const isFixedTarget = hasPosition(element);
  let parentTop = 0;
  let top = (_a = elementRect == null ? void 0 : elementRect.top) != null ? _a : 0;
  if (hasScrollParent && isFixedTarget) {
    const offsetTop = (_b = element == null ? void 0 : element.offsetTop) != null ? _b : 0;
    const parentScrollTop = (_c = parent == null ? void 0 : parent.scrollTop) != null ? _c : 0;
    top = offsetTop - parentScrollTop;
  } else if (parent instanceof HTMLElement) {
    parentTop = parent.scrollTop;
    if (!hasScrollParent && !hasPosition(element)) {
      top += parentTop;
    }
    if (!parent.isSameNode(scrollDocument())) {
      top += scrollDocument().scrollTop;
    }
  }
  return Math.floor(top - offset2);
}
function getScrollTo(element, offset2, skipFix) {
  var _a;
  if (!element) {
    return 0;
  }
  const { offsetTop = 0, scrollTop = 0 } = (_a = scrollParent(element)) != null ? _a : {};
  let top = element.getBoundingClientRect().top + scrollTop;
  if (!!offsetTop && (hasCustomScrollParent(element, skipFix) || hasCustomOffsetParent(element))) {
    top -= offsetTop;
  }
  const output = Math.floor(top - offset2);
  return output < 0 ? 0 : output;
}
function scrollDocument() {
  var _a;
  return (_a = document.scrollingElement) != null ? _a : document.documentElement;
}
function scrollTo(value, options) {
  const { duration, element } = options;
  return new Promise((resolve, reject) => {
    const { scrollTop } = element;
    const limit = value > scrollTop ? value - scrollTop : scrollTop - value;
    scroll.top(element, value, { duration: limit < 100 ? 50 : duration }, (error) => {
      if (error && error.message !== "Element already at target scroll position") {
        return reject(error);
      }
      return resolve();
    });
  });
}
var isReact16 = createPortal !== void 0;
function getBrowser(userAgent = navigator.userAgent) {
  let browser = userAgent;
  if (typeof window === "undefined") {
    browser = "node";
  } else if (document.documentMode) {
    browser = "ie";
  } else if (/Edge/.test(userAgent)) {
    browser = "edge";
  } else if (Boolean(window.opera) || userAgent.includes(" OPR/")) {
    browser = "opera";
  } else if (typeof window.InstallTrigger !== "undefined") {
    browser = "firefox";
  } else if (window.chrome) {
    browser = "chrome";
  } else if (/(Version\/([\d._]+).*Safari|CriOS|FxiOS| Mobile\/)/.test(userAgent)) {
    browser = "safari";
  }
  return browser;
}
function getObjectType(value) {
  return Object.prototype.toString.call(value).slice(8, -1).toLowerCase();
}
function getReactNodeText(input, options = {}) {
  const { defaultValue: defaultValue2, step, steps: steps2 } = options;
  let text2 = innerText(input);
  if (!text2) {
    if (isValidElement(input) && !Object.values(input.props).length && getObjectType(input.type) === "function") {
      const component = input.type({});
      text2 = getReactNodeText(component, options);
    } else {
      text2 = innerText(defaultValue2);
    }
  } else if ((text2.includes("{step}") || text2.includes("{steps}")) && step && steps2) {
    text2 = text2.replace("{step}", step.toString()).replace("{steps}", steps2.toString());
  }
  return text2;
}
function hasValidKeys(object2, keys2) {
  if (!src_default.plainObject(object2) || !src_default.array(keys2)) {
    return false;
  }
  return Object.keys(object2).every((d4) => keys2.includes(d4));
}
function hexToRGB(hex2) {
  const shorthandRegex = /^#?([\da-f])([\da-f])([\da-f])$/i;
  const properHex = hex2.replace(shorthandRegex, (_m, r2, g2, b3) => r2 + r2 + g2 + g2 + b3 + b3);
  const result = /^#?([\da-f]{2})([\da-f]{2})([\da-f]{2})$/i.exec(properHex);
  return result ? [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)] : [];
}
function hideBeacon(step) {
  return step.disableBeacon || step.placement === "center";
}
function isLegacy() {
  return !["chrome", "safari", "firefox", "opera"].includes(getBrowser());
}
function log$1({ data, debug: debug2 = false, title, warn: warn4 = false }) {
  const logFn = warn4 ? console.warn || console.error : console.log;
  if (debug2) {
    if (title && data) {
      console.groupCollapsed(
        `%creact-joyride: ${title}`,
        "color: #ff0044; font-weight: bold; font-size: 12px;"
      );
      if (Array.isArray(data)) {
        data.forEach((d4) => {
          if (src_default.plainObject(d4) && d4.key) {
            logFn.apply(console, [d4.key, d4.value]);
          } else {
            logFn.apply(console, [d4]);
          }
        });
      } else {
        logFn.apply(console, [data]);
      }
      console.groupEnd();
    } else {
      console.error("Missing title or data props");
    }
  }
}
function noop$1() {
  return void 0;
}
function objectKeys(input) {
  return Object.keys(input);
}
function omit(input, ...filter2) {
  if (!src_default.plainObject(input)) {
    throw new TypeError("Expected an object");
  }
  const output = {};
  for (const key in input) {
    if ({}.hasOwnProperty.call(input, key)) {
      if (!filter2.includes(key)) {
        output[key] = input[key];
      }
    }
  }
  return output;
}
function pick(input, ...filter2) {
  if (!src_default.plainObject(input)) {
    throw new TypeError("Expected an object");
  }
  if (!filter2.length) {
    return input;
  }
  const output = {};
  for (const key in input) {
    if ({}.hasOwnProperty.call(input, key)) {
      if (filter2.includes(key)) {
        output[key] = input[key];
      }
    }
  }
  return output;
}
function replaceLocaleContent(input, step, steps2) {
  const replacer = (text2) => text2.replace("{step}", String(step)).replace("{steps}", String(steps2));
  if (getObjectType(input) === "string") {
    return replacer(input);
  }
  if (!isValidElement(input)) {
    return input;
  }
  const { children } = input.props;
  if (getObjectType(children) === "string" && children.includes("{step}")) {
    return cloneElement(input, {
      children: replacer(children)
    });
  }
  if (Array.isArray(children)) {
    return cloneElement(input, {
      children: children.map((child) => {
        if (typeof child === "string") {
          return replacer(child);
        }
        return replaceLocaleContent(child, step, steps2);
      })
    });
  }
  if (getObjectType(input.type) === "function" && !Object.values(input.props).length) {
    const component = input.type({});
    return replaceLocaleContent(component, step, steps2);
  }
  return input;
}
function shouldScroll(options) {
  const { isFirstStep, lifecycle, previousLifecycle, scrollToFirstStep, step, target } = options;
  return !step.disableScrolling && (!isFirstStep || scrollToFirstStep || lifecycle === LIFECYCLE.TOOLTIP) && step.placement !== "center" && (!step.isFixed || !hasPosition(target)) && // fixed steps don't need to scroll
  previousLifecycle !== lifecycle && [LIFECYCLE.BEACON, LIFECYCLE.TOOLTIP].includes(lifecycle);
}
var defaultFloaterProps = {
  options: {
    preventOverflow: {
      boundariesElement: "scrollParent"
    }
  },
  wrapperOptions: {
    offset: -18,
    position: true
  }
};
var defaultLocale$2 = {
  back: "Back",
  close: "Close",
  last: "Last",
  next: "Next",
  nextLabelWithProgress: "Next (Step {step} of {steps})",
  open: "Open the dialog",
  skip: "Skip"
};
var defaultStep = {
  event: "click",
  placement: "bottom",
  offset: 10,
  disableBeacon: false,
  disableCloseOnEsc: false,
  disableOverlay: false,
  disableOverlayClose: false,
  disableScrollParentFix: false,
  disableScrolling: false,
  hideBackButton: false,
  hideCloseButton: false,
  hideFooter: false,
  isFixed: false,
  locale: defaultLocale$2,
  showProgress: false,
  showSkipButton: false,
  spotlightClicks: false,
  spotlightPadding: 10
};
var defaultProps$4 = {
  continuous: false,
  debug: false,
  disableCloseOnEsc: false,
  disableOverlay: false,
  disableOverlayClose: false,
  disableScrolling: false,
  disableScrollParentFix: false,
  getHelpers: noop$1(),
  hideBackButton: false,
  run: true,
  scrollOffset: 20,
  scrollDuration: 300,
  scrollToFirstStep: false,
  showSkipButton: false,
  showProgress: false,
  spotlightClicks: false,
  spotlightPadding: 10,
  steps: []
};
var defaultOptions = {
  arrowColor: "#fff",
  backgroundColor: "#fff",
  beaconSize: 36,
  overlayColor: "rgba(0, 0, 0, 0.5)",
  primaryColor: "#f04",
  spotlightShadow: "0 0 15px rgba(0, 0, 0, 0.5)",
  textColor: "#333",
  width: 380,
  zIndex: 100
};
var buttonBase = {
  backgroundColor: "transparent",
  border: 0,
  borderRadius: 0,
  color: "#555",
  cursor: "pointer",
  fontSize: 16,
  lineHeight: 1,
  padding: 8,
  WebkitAppearance: "none"
};
var spotlight = {
  borderRadius: 4,
  position: "absolute"
};
function getStyles(props, step) {
  var _a, _b, _c, _d, _e;
  const { floaterProps, styles } = props;
  const mergedFloaterProps = deepmerge2((_a = step.floaterProps) != null ? _a : {}, floaterProps != null ? floaterProps : {});
  const mergedStyles = deepmerge2(styles != null ? styles : {}, (_b = step.styles) != null ? _b : {});
  const options = deepmerge2(defaultOptions, mergedStyles.options || {});
  const hideBeacon2 = step.placement === "center" || step.disableBeacon;
  let { width } = options;
  if (window.innerWidth > 480) {
    width = 380;
  }
  if ("width" in options) {
    width = typeof options.width === "number" && window.innerWidth < options.width ? window.innerWidth - 30 : options.width;
  }
  const overlay = {
    bottom: 0,
    left: 0,
    overflow: "hidden",
    position: "absolute",
    right: 0,
    top: 0,
    zIndex: options.zIndex
  };
  const defaultStyles = {
    beacon: {
      ...buttonBase,
      display: hideBeacon2 ? "none" : "inline-block",
      height: options.beaconSize,
      position: "relative",
      width: options.beaconSize,
      zIndex: options.zIndex
    },
    beaconInner: {
      animation: "joyride-beacon-inner 1.2s infinite ease-in-out",
      backgroundColor: options.primaryColor,
      borderRadius: "50%",
      display: "block",
      height: "50%",
      left: "50%",
      opacity: 0.7,
      position: "absolute",
      top: "50%",
      transform: "translate(-50%, -50%)",
      width: "50%"
    },
    beaconOuter: {
      animation: "joyride-beacon-outer 1.2s infinite ease-in-out",
      backgroundColor: `rgba(${hexToRGB(options.primaryColor).join(",")}, 0.2)`,
      border: `2px solid ${options.primaryColor}`,
      borderRadius: "50%",
      boxSizing: "border-box",
      display: "block",
      height: "100%",
      left: 0,
      opacity: 0.9,
      position: "absolute",
      top: 0,
      transformOrigin: "center",
      width: "100%"
    },
    tooltip: {
      backgroundColor: options.backgroundColor,
      borderRadius: 5,
      boxSizing: "border-box",
      color: options.textColor,
      fontSize: 16,
      maxWidth: "100%",
      padding: 15,
      position: "relative",
      width
    },
    tooltipContainer: {
      lineHeight: 1.4,
      textAlign: "center"
    },
    tooltipTitle: {
      fontSize: 18,
      margin: 0
    },
    tooltipContent: {
      padding: "20px 10px"
    },
    tooltipFooter: {
      alignItems: "center",
      display: "flex",
      justifyContent: "flex-end",
      marginTop: 15
    },
    tooltipFooterSpacer: {
      flex: 1
    },
    buttonNext: {
      ...buttonBase,
      backgroundColor: options.primaryColor,
      borderRadius: 4,
      color: "#fff"
    },
    buttonBack: {
      ...buttonBase,
      color: options.primaryColor,
      marginLeft: "auto",
      marginRight: 5
    },
    buttonClose: {
      ...buttonBase,
      color: options.textColor,
      height: 14,
      padding: 15,
      position: "absolute",
      right: 0,
      top: 0,
      width: 14
    },
    buttonSkip: {
      ...buttonBase,
      color: options.textColor,
      fontSize: 14
    },
    overlay: {
      ...overlay,
      backgroundColor: options.overlayColor,
      mixBlendMode: "hard-light"
    },
    overlayLegacy: {
      ...overlay
    },
    overlayLegacyCenter: {
      ...overlay,
      backgroundColor: options.overlayColor
    },
    spotlight: {
      ...spotlight,
      backgroundColor: "gray"
    },
    spotlightLegacy: {
      ...spotlight,
      boxShadow: `0 0 0 9999px ${options.overlayColor}, ${options.spotlightShadow}`
    },
    floaterStyles: {
      arrow: {
        color: (_e = (_d = (_c = mergedFloaterProps == null ? void 0 : mergedFloaterProps.styles) == null ? void 0 : _c.arrow) == null ? void 0 : _d.color) != null ? _e : options.arrowColor
      },
      options: {
        zIndex: options.zIndex + 100
      }
    },
    options
  };
  return deepmerge2(defaultStyles, mergedStyles);
}
function getTourProps(props) {
  return pick(
    props,
    "beaconComponent",
    "disableCloseOnEsc",
    "disableOverlay",
    "disableOverlayClose",
    "disableScrolling",
    "disableScrollParentFix",
    "floaterProps",
    "hideBackButton",
    "hideCloseButton",
    "locale",
    "showProgress",
    "showSkipButton",
    "spotlightClicks",
    "spotlightPadding",
    "styles",
    "tooltipComponent"
  );
}
function getMergedStep(props, currentStep) {
  var _a, _b, _c, _d, _e, _f;
  const step = currentStep != null ? currentStep : {};
  const mergedStep = deepmerge2.all([defaultStep, getTourProps(props), step], {
    isMergeableObject: src_default.plainObject
  });
  const mergedStyles = getStyles(props, mergedStep);
  const scrollParent2 = hasCustomScrollParent(
    getElement(mergedStep.target),
    mergedStep.disableScrollParentFix
  );
  const floaterProps = deepmerge2.all([
    defaultFloaterProps,
    (_a = props.floaterProps) != null ? _a : {},
    (_b = mergedStep.floaterProps) != null ? _b : {}
  ]);
  floaterProps.offset = mergedStep.offset;
  floaterProps.styles = deepmerge2((_c = floaterProps.styles) != null ? _c : {}, mergedStyles.floaterStyles);
  floaterProps.offset += (_e = (_d = props.spotlightPadding) != null ? _d : mergedStep.spotlightPadding) != null ? _e : 0;
  if (mergedStep.placementBeacon && floaterProps.wrapperOptions) {
    floaterProps.wrapperOptions.placement = mergedStep.placementBeacon;
  }
  if (scrollParent2 && floaterProps.options.preventOverflow) {
    floaterProps.options.preventOverflow.boundariesElement = "window";
  }
  return {
    ...mergedStep,
    locale: deepmerge2.all([defaultLocale$2, (_f = props.locale) != null ? _f : {}, mergedStep.locale || {}]),
    floaterProps,
    styles: omit(mergedStyles, "floaterStyles")
  };
}
function validateStep(step, debug2 = false) {
  if (!src_default.plainObject(step)) {
    log$1({
      title: "validateStep",
      data: "step must be an object",
      warn: true,
      debug: debug2
    });
    return false;
  }
  if (!step.target) {
    log$1({
      title: "validateStep",
      data: "target is missing from the step",
      warn: true,
      debug: debug2
    });
    return false;
  }
  return true;
}
function validateSteps(steps2, debug2 = false) {
  if (!src_default.array(steps2)) {
    log$1({
      title: "validateSteps",
      data: "steps must be an array",
      warn: true,
      debug: debug2
    });
    return false;
  }
  return steps2.every((d4) => validateStep(d4, debug2));
}
var defaultState = {
  action: "init",
  controlled: false,
  index: 0,
  lifecycle: LIFECYCLE.INIT,
  origin: null,
  size: 0,
  status: STATUS.IDLE
};
var validKeys = objectKeys(omit(defaultState, "controlled", "size"));
var Store = class {
  constructor(options) {
    __publicField(this, "beaconPopper");
    __publicField(this, "tooltipPopper");
    __publicField(this, "data", /* @__PURE__ */ new Map());
    __publicField(this, "listener");
    __publicField(this, "store", /* @__PURE__ */ new Map());
    __publicField(this, "addListener", (listener) => {
      this.listener = listener;
    });
    __publicField(this, "setSteps", (steps3) => {
      const { size: size2, status } = this.getState();
      const state = {
        size: steps3.length,
        status
      };
      this.data.set("steps", steps3);
      if (status === STATUS.WAITING && !size2 && steps3.length) {
        state.status = STATUS.RUNNING;
      }
      this.setState(state);
    });
    __publicField(this, "getPopper", (name) => {
      if (name === "beacon") {
        return this.beaconPopper;
      }
      return this.tooltipPopper;
    });
    __publicField(this, "setPopper", (name, popper) => {
      if (name === "beacon") {
        this.beaconPopper = popper;
      } else {
        this.tooltipPopper = popper;
      }
    });
    __publicField(this, "cleanupPoppers", () => {
      this.beaconPopper = null;
      this.tooltipPopper = null;
    });
    __publicField(this, "close", (origin = null) => {
      const { index: index2, status } = this.getState();
      if (status !== STATUS.RUNNING) {
        return;
      }
      this.setState({
        ...this.getNextState({ action: ACTIONS.CLOSE, index: index2 + 1, origin })
      });
    });
    __publicField(this, "go", (nextIndex) => {
      const { controlled, status } = this.getState();
      if (controlled || status !== STATUS.RUNNING) {
        return;
      }
      const step = this.getSteps()[nextIndex];
      this.setState({
        ...this.getNextState({ action: ACTIONS.GO, index: nextIndex }),
        status: step ? status : STATUS.FINISHED
      });
    });
    __publicField(this, "info", () => this.getState());
    __publicField(this, "next", () => {
      const { index: index2, status } = this.getState();
      if (status !== STATUS.RUNNING) {
        return;
      }
      this.setState(this.getNextState({ action: ACTIONS.NEXT, index: index2 + 1 }));
    });
    __publicField(this, "open", () => {
      const { status } = this.getState();
      if (status !== STATUS.RUNNING) {
        return;
      }
      this.setState({
        ...this.getNextState({ action: ACTIONS.UPDATE, lifecycle: LIFECYCLE.TOOLTIP })
      });
    });
    __publicField(this, "prev", () => {
      const { index: index2, status } = this.getState();
      if (status !== STATUS.RUNNING) {
        return;
      }
      this.setState({
        ...this.getNextState({ action: ACTIONS.PREV, index: index2 - 1 })
      });
    });
    __publicField(this, "reset", (restart = false) => {
      const { controlled } = this.getState();
      if (controlled) {
        return;
      }
      this.setState({
        ...this.getNextState({ action: ACTIONS.RESET, index: 0 }),
        status: restart ? STATUS.RUNNING : STATUS.READY
      });
    });
    __publicField(this, "skip", () => {
      const { status } = this.getState();
      if (status !== STATUS.RUNNING) {
        return;
      }
      this.setState({
        action: ACTIONS.SKIP,
        lifecycle: LIFECYCLE.INIT,
        status: STATUS.SKIPPED
      });
    });
    __publicField(this, "start", (nextIndex) => {
      const { index: index2, size: size2 } = this.getState();
      this.setState({
        ...this.getNextState(
          {
            action: ACTIONS.START,
            index: src_default.number(nextIndex) ? nextIndex : index2
          },
          true
        ),
        status: size2 ? STATUS.RUNNING : STATUS.WAITING
      });
    });
    __publicField(this, "stop", (advance = false) => {
      const { index: index2, status } = this.getState();
      if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
        return;
      }
      this.setState({
        ...this.getNextState({ action: ACTIONS.STOP, index: index2 + (advance ? 1 : 0) }),
        status: STATUS.PAUSED
      });
    });
    __publicField(this, "update", (state) => {
      var _a, _b;
      if (!hasValidKeys(state, validKeys)) {
        throw new Error(`State is not valid. Valid keys: ${validKeys.join(", ")}`);
      }
      this.setState({
        ...this.getNextState(
          {
            ...this.getState(),
            ...state,
            action: (_a = state.action) != null ? _a : ACTIONS.UPDATE,
            origin: (_b = state.origin) != null ? _b : null
          },
          true
        )
      });
    });
    const { continuous: continuous2 = false, stepIndex, steps: steps2 = [] } = options != null ? options : {};
    this.setState(
      {
        action: ACTIONS.INIT,
        controlled: src_default.number(stepIndex),
        continuous: continuous2,
        index: src_default.number(stepIndex) ? stepIndex : 0,
        lifecycle: LIFECYCLE.INIT,
        origin: null,
        status: steps2.length ? STATUS.READY : STATUS.IDLE
      },
      true
    );
    this.beaconPopper = null;
    this.tooltipPopper = null;
    this.listener = null;
    this.setSteps(steps2);
  }
  getState() {
    if (!this.store.size) {
      return { ...defaultState };
    }
    return {
      action: this.store.get("action") || "",
      controlled: this.store.get("controlled") || false,
      index: parseInt(this.store.get("index"), 10),
      lifecycle: this.store.get("lifecycle") || "",
      origin: this.store.get("origin") || null,
      size: this.store.get("size") || 0,
      status: this.store.get("status") || ""
    };
  }
  getNextState(state, force = false) {
    var _a, _b, _c, _d, _e;
    const { action, controlled, index: index2, size: size2, status } = this.getState();
    const newIndex = src_default.number(state.index) ? state.index : index2;
    const nextIndex = controlled && !force ? index2 : Math.min(Math.max(newIndex, 0), size2);
    return {
      action: (_a = state.action) != null ? _a : action,
      controlled,
      index: nextIndex,
      lifecycle: (_b = state.lifecycle) != null ? _b : LIFECYCLE.INIT,
      origin: (_c = state.origin) != null ? _c : null,
      size: (_d = state.size) != null ? _d : size2,
      status: nextIndex === size2 ? STATUS.FINISHED : (_e = state.status) != null ? _e : status
    };
  }
  getSteps() {
    const steps2 = this.data.get("steps");
    return Array.isArray(steps2) ? steps2 : [];
  }
  hasUpdatedState(oldState) {
    const before = JSON.stringify(oldState);
    const after = JSON.stringify(this.getState());
    return before !== after;
  }
  setState(nextState, initial = false) {
    const state = this.getState();
    const {
      action,
      index: index2,
      lifecycle,
      origin = null,
      size: size2,
      status
    } = {
      ...state,
      ...nextState
    };
    this.store.set("action", action);
    this.store.set("index", index2);
    this.store.set("lifecycle", lifecycle);
    this.store.set("origin", origin);
    this.store.set("size", size2);
    this.store.set("status", status);
    if (initial) {
      this.store.set("controlled", nextState.controlled);
      this.store.set("continuous", nextState.continuous);
    }
    if (this.listener && this.hasUpdatedState(state)) {
      this.listener(this.getState());
    }
  }
  getHelpers() {
    return {
      close: this.close,
      go: this.go,
      info: this.info,
      next: this.next,
      open: this.open,
      prev: this.prev,
      reset: this.reset,
      skip: this.skip
    };
  }
};
function createStore(options) {
  return new Store(options);
}
function JoyrideSpotlight({ styles }) {
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      key: "JoyrideSpotlight",
      className: "react-joyride__spotlight",
      "data-test-id": "spotlight",
      style: styles
    }
  );
}
var Spotlight_default = JoyrideSpotlight;
var JoyrideOverlay = class extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "isActive", false);
    __publicField(this, "resizeTimeout");
    __publicField(this, "scrollTimeout");
    __publicField(this, "scrollParent");
    __publicField(this, "state", {
      isScrolling: false,
      mouseOverSpotlight: false,
      showSpotlight: true
    });
    __publicField(this, "hideSpotlight", () => {
      const { continuous: continuous2, disableOverlay, lifecycle } = this.props;
      const hiddenLifecycles = [
        LIFECYCLE.INIT,
        LIFECYCLE.BEACON,
        LIFECYCLE.COMPLETE,
        LIFECYCLE.ERROR
      ];
      return disableOverlay || (continuous2 ? hiddenLifecycles.includes(lifecycle) : lifecycle !== LIFECYCLE.TOOLTIP);
    });
    __publicField(this, "handleMouseMove", (event) => {
      const { mouseOverSpotlight } = this.state;
      const { height, left, position, top, width } = this.spotlightStyles;
      const offsetY = position === "fixed" ? event.clientY : event.pageY;
      const offsetX = position === "fixed" ? event.clientX : event.pageX;
      const inSpotlightHeight = offsetY >= top && offsetY <= top + height;
      const inSpotlightWidth = offsetX >= left && offsetX <= left + width;
      const inSpotlight = inSpotlightWidth && inSpotlightHeight;
      if (inSpotlight !== mouseOverSpotlight) {
        this.updateState({ mouseOverSpotlight: inSpotlight });
      }
    });
    __publicField(this, "handleScroll", () => {
      const { target } = this.props;
      const element = getElement(target);
      if (this.scrollParent !== document) {
        const { isScrolling } = this.state;
        if (!isScrolling) {
          this.updateState({ isScrolling: true, showSpotlight: false });
        }
        clearTimeout(this.scrollTimeout);
        this.scrollTimeout = window.setTimeout(() => {
          this.updateState({ isScrolling: false, showSpotlight: true });
        }, 50);
      } else if (hasPosition(element, "sticky")) {
        this.updateState({});
      }
    });
    __publicField(this, "handleResize", () => {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = window.setTimeout(() => {
        if (!this.isActive) {
          return;
        }
        this.forceUpdate();
      }, 100);
    });
  }
  componentDidMount() {
    const { debug: debug2, disableScrolling, disableScrollParentFix = false, target } = this.props;
    const element = getElement(target);
    this.scrollParent = getScrollParent(element != null ? element : document.body, disableScrollParentFix, true);
    this.isActive = true;
    if (process.env.NODE_ENV !== "production") {
      if (!disableScrolling && hasCustomScrollParent(element, true)) {
        log$1({
          title: "step has a custom scroll parent and can cause trouble with scrolling",
          data: [{ key: "parent", value: this.scrollParent }],
          debug: debug2
        });
      }
    }
    window.addEventListener("resize", this.handleResize);
  }
  componentDidUpdate(previousProps) {
    var _a;
    const { disableScrollParentFix, lifecycle, spotlightClicks, target } = this.props;
    const { changed } = treeChanges$1(previousProps, this.props);
    if (changed("target") || changed("disableScrollParentFix")) {
      const element = getElement(target);
      this.scrollParent = getScrollParent(element != null ? element : document.body, disableScrollParentFix, true);
    }
    if (changed("lifecycle", LIFECYCLE.TOOLTIP)) {
      (_a = this.scrollParent) == null ? void 0 : _a.addEventListener("scroll", this.handleScroll, { passive: true });
      setTimeout(() => {
        const { isScrolling } = this.state;
        if (!isScrolling) {
          this.updateState({ showSpotlight: true });
        }
      }, 100);
    }
    if (changed("spotlightClicks") || changed("disableOverlay") || changed("lifecycle")) {
      if (spotlightClicks && lifecycle === LIFECYCLE.TOOLTIP) {
        window.addEventListener("mousemove", this.handleMouseMove, false);
      } else if (lifecycle !== LIFECYCLE.TOOLTIP) {
        window.removeEventListener("mousemove", this.handleMouseMove);
      }
    }
  }
  componentWillUnmount() {
    var _a;
    this.isActive = false;
    window.removeEventListener("mousemove", this.handleMouseMove);
    window.removeEventListener("resize", this.handleResize);
    clearTimeout(this.resizeTimeout);
    clearTimeout(this.scrollTimeout);
    (_a = this.scrollParent) == null ? void 0 : _a.removeEventListener("scroll", this.handleScroll);
  }
  get overlayStyles() {
    const { mouseOverSpotlight } = this.state;
    const { disableOverlayClose, placement, styles } = this.props;
    let baseStyles = styles.overlay;
    if (isLegacy()) {
      baseStyles = placement === "center" ? styles.overlayLegacyCenter : styles.overlayLegacy;
    }
    return {
      cursor: disableOverlayClose ? "default" : "pointer",
      height: getDocumentHeight(),
      pointerEvents: mouseOverSpotlight ? "none" : "auto",
      ...baseStyles
    };
  }
  get spotlightStyles() {
    var _a, _b, _c;
    const { showSpotlight } = this.state;
    const {
      disableScrollParentFix = false,
      spotlightClicks,
      spotlightPadding = 0,
      styles,
      target
    } = this.props;
    const element = getElement(target);
    const elementRect = getClientRect(element);
    const isFixedTarget = hasPosition(element);
    const top = getElementPosition(element, spotlightPadding, disableScrollParentFix);
    return {
      ...isLegacy() ? styles.spotlightLegacy : styles.spotlight,
      height: Math.round(((_a = elementRect == null ? void 0 : elementRect.height) != null ? _a : 0) + spotlightPadding * 2),
      left: Math.round(((_b = elementRect == null ? void 0 : elementRect.left) != null ? _b : 0) - spotlightPadding),
      opacity: showSpotlight ? 1 : 0,
      pointerEvents: spotlightClicks ? "none" : "auto",
      position: isFixedTarget ? "fixed" : "absolute",
      top,
      transition: "opacity 0.2s",
      width: Math.round(((_c = elementRect == null ? void 0 : elementRect.width) != null ? _c : 0) + spotlightPadding * 2)
    };
  }
  updateState(state) {
    if (!this.isActive) {
      return;
    }
    this.setState((previousState) => ({ ...previousState, ...state }));
  }
  render() {
    const { showSpotlight } = this.state;
    const { onClickOverlay, placement } = this.props;
    const { hideSpotlight, overlayStyles, spotlightStyles } = this;
    if (hideSpotlight()) {
      return null;
    }
    let spotlight2 = placement !== "center" && showSpotlight && /* @__PURE__ */ React.createElement(Spotlight_default, { styles: spotlightStyles });
    if (getBrowser() === "safari") {
      const { mixBlendMode, zIndex, ...safariOverlay } = overlayStyles;
      spotlight2 = /* @__PURE__ */ React.createElement("div", { style: { ...safariOverlay } }, spotlight2);
      delete overlayStyles.backgroundColor;
    }
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "react-joyride__overlay",
        "data-test-id": "overlay",
        onClick: onClickOverlay,
        role: "presentation",
        style: overlayStyles
      },
      spotlight2
    );
  }
};
var JoyridePortal = class extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "node", null);
  }
  componentDidMount() {
    const { id: id2 } = this.props;
    if (!canUseDOM()) {
      return;
    }
    this.node = document.createElement("div");
    this.node.id = id2;
    document.body.appendChild(this.node);
    if (!isReact16) {
      this.renderReact15();
    }
  }
  componentDidUpdate() {
    if (!canUseDOM()) {
      return;
    }
    if (!isReact16) {
      this.renderReact15();
    }
  }
  componentWillUnmount() {
    if (!canUseDOM() || !this.node) {
      return;
    }
    if (!isReact16) {
      ReactDOM.unmountComponentAtNode(this.node);
    }
    if (this.node.parentNode === document.body) {
      document.body.removeChild(this.node);
      this.node = null;
    }
  }
  renderReact15() {
    if (!canUseDOM()) {
      return;
    }
    const { children } = this.props;
    if (this.node) {
      ReactDOM.unstable_renderSubtreeIntoContainer(this, children, this.node);
    }
  }
  renderReact16() {
    if (!canUseDOM() || !isReact16) {
      return null;
    }
    const { children } = this.props;
    if (!this.node) {
      return null;
    }
    return ReactDOM.createPortal(children, this.node);
  }
  render() {
    if (!isReact16) {
      return null;
    }
    return this.renderReact16();
  }
};
var Scope = class {
  constructor(element, options) {
    __publicField(this, "element");
    __publicField(this, "options");
    __publicField(this, "canBeTabbed", (element2) => {
      const { tabIndex } = element2;
      if (tabIndex === null || tabIndex < 0) {
        return false;
      }
      return this.canHaveFocus(element2);
    });
    __publicField(this, "canHaveFocus", (element2) => {
      const validTabNodes = /input|select|textarea|button|object/;
      const nodeName = element2.nodeName.toLowerCase();
      const isValid2 = validTabNodes.test(nodeName) && !element2.getAttribute("disabled") || nodeName === "a" && !!element2.getAttribute("href");
      return isValid2 && this.isVisible(element2);
    });
    __publicField(this, "findValidTabElements", () => [].slice.call(this.element.querySelectorAll("*"), 0).filter(this.canBeTabbed));
    __publicField(this, "handleKeyDown", (event) => {
      const { code = "Tab" } = this.options;
      if (event.code === code) {
        this.interceptTab(event);
      }
    });
    __publicField(this, "interceptTab", (event) => {
      event.preventDefault();
      const elements = this.findValidTabElements();
      const { shiftKey } = event;
      if (!elements.length) {
        return;
      }
      let x3 = document.activeElement ? elements.indexOf(document.activeElement) : 0;
      if (x3 === -1 || !shiftKey && x3 + 1 === elements.length) {
        x3 = 0;
      } else if (shiftKey && x3 === 0) {
        x3 = elements.length - 1;
      } else {
        x3 += shiftKey ? -1 : 1;
      }
      elements[x3].focus();
    });
    __publicField(this, "isHidden", (element2) => {
      const noSize = element2.offsetWidth <= 0 && element2.offsetHeight <= 0;
      const style = window.getComputedStyle(element2);
      if (noSize && !element2.innerHTML) {
        return true;
      }
      return noSize && style.getPropertyValue("overflow") !== "visible" || style.getPropertyValue("display") === "none";
    });
    __publicField(this, "isVisible", (element2) => {
      let parentElement = element2;
      while (parentElement) {
        if (parentElement instanceof HTMLElement) {
          if (parentElement === document.body) {
            break;
          }
          if (this.isHidden(parentElement)) {
            return false;
          }
          parentElement = parentElement.parentNode;
        }
      }
      return true;
    });
    __publicField(this, "removeScope", () => {
      window.removeEventListener("keydown", this.handleKeyDown);
    });
    __publicField(this, "checkFocus", (target) => {
      if (document.activeElement !== target) {
        target.focus();
        window.requestAnimationFrame(() => this.checkFocus(target));
      }
    });
    __publicField(this, "setFocus", () => {
      const { selector } = this.options;
      if (!selector) {
        return;
      }
      const target = this.element.querySelector(selector);
      if (target) {
        window.requestAnimationFrame(() => this.checkFocus(target));
      }
    });
    if (!(element instanceof HTMLElement)) {
      throw new TypeError("Invalid parameter: element must be an HTMLElement");
    }
    this.element = element;
    this.options = options;
    window.addEventListener("keydown", this.handleKeyDown, false);
    this.setFocus();
  }
};
var JoyrideBeacon = class extends React.Component {
  constructor(props) {
    super(props);
    __publicField(this, "beacon", null);
    __publicField(this, "setBeaconRef", (c3) => {
      this.beacon = c3;
    });
    if (props.beaconComponent) {
      return;
    }
    const head = document.head || document.getElementsByTagName("head")[0];
    const style = document.createElement("style");
    style.id = "joyride-beacon-animation";
    if (props.nonce) {
      style.setAttribute("nonce", props.nonce);
    }
    const css = `
        @keyframes joyride-beacon-inner {
          20% {
            opacity: 0.9;
          }
        
          90% {
            opacity: 0.7;
          }
        }
        
        @keyframes joyride-beacon-outer {
          0% {
            transform: scale(1);
          }
        
          45% {
            opacity: 0.7;
            transform: scale(0.75);
          }
        
          100% {
            opacity: 0.9;
            transform: scale(1);
          }
        }
      `;
    style.appendChild(document.createTextNode(css));
    head.appendChild(style);
  }
  componentDidMount() {
    const { shouldFocus } = this.props;
    if (process.env.NODE_ENV !== "production") {
      if (!src_default.domElement(this.beacon)) {
        console.warn("beacon is not a valid DOM element");
      }
    }
    setTimeout(() => {
      if (src_default.domElement(this.beacon) && shouldFocus) {
        this.beacon.focus();
      }
    }, 0);
  }
  componentWillUnmount() {
    const style = document.getElementById("joyride-beacon-animation");
    if (style == null ? void 0 : style.parentNode) {
      style.parentNode.removeChild(style);
    }
  }
  render() {
    const {
      beaconComponent,
      continuous: continuous2,
      index: index2,
      isLastStep,
      locale: locale2,
      onClickOrHover,
      size: size2,
      step,
      styles
    } = this.props;
    const title = getReactNodeText(locale2.open);
    const sharedProps = {
      "aria-label": title,
      onClick: onClickOrHover,
      onMouseEnter: onClickOrHover,
      ref: this.setBeaconRef,
      title
    };
    let component;
    if (beaconComponent) {
      const BeaconComponent = beaconComponent;
      component = /* @__PURE__ */ React.createElement(
        BeaconComponent,
        {
          continuous: continuous2,
          index: index2,
          isLastStep,
          size: size2,
          step,
          ...sharedProps
        }
      );
    } else {
      component = /* @__PURE__ */ React.createElement(
        "button",
        {
          key: "JoyrideBeacon",
          className: "react-joyride__beacon",
          "data-test-id": "button-beacon",
          style: styles.beacon,
          type: "button",
          ...sharedProps
        },
        /* @__PURE__ */ React.createElement("span", { style: styles.beaconInner }),
        /* @__PURE__ */ React.createElement("span", { style: styles.beaconOuter })
      );
    }
    return component;
  }
};
function JoyrideTooltipCloseButton({ styles, ...props }) {
  const { color: color2, height, width, ...style } = styles;
  return /* @__PURE__ */ React__default.createElement("button", { style, type: "button", ...props }, /* @__PURE__ */ React__default.createElement(
    "svg",
    {
      height: typeof height === "number" ? `${height}px` : height,
      preserveAspectRatio: "xMidYMid",
      version: "1.1",
      viewBox: "0 0 18 18",
      width: typeof width === "number" ? `${width}px` : width,
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React__default.createElement("g", null, /* @__PURE__ */ React__default.createElement(
      "path",
      {
        d: "M8.13911129,9.00268191 L0.171521827,17.0258467 C-0.0498027049,17.248715 -0.0498027049,17.6098394 0.171521827,17.8327545 C0.28204354,17.9443526 0.427188206,17.9998706 0.572051765,17.9998706 C0.71714958,17.9998706 0.862013139,17.9443526 0.972581703,17.8327545 L9.0000937,9.74924618 L17.0276057,17.8327545 C17.1384085,17.9443526 17.2832721,17.9998706 17.4281356,17.9998706 C17.5729992,17.9998706 17.718097,17.9443526 17.8286656,17.8327545 C18.0499901,17.6098862 18.0499901,17.2487618 17.8286656,17.0258467 L9.86135722,9.00268191 L17.8340066,0.973848225 C18.0553311,0.750979934 18.0553311,0.389855532 17.8340066,0.16694039 C17.6126821,-0.0556467968 17.254037,-0.0556467968 17.0329467,0.16694039 L9.00042166,8.25611765 L0.967006424,0.167268345 C0.745681892,-0.0553188426 0.387317931,-0.0553188426 0.165993399,0.167268345 C-0.0553311331,0.390136635 -0.0553311331,0.751261038 0.165993399,0.974176179 L8.13920499,9.00268191 L8.13911129,9.00268191 Z",
        fill: color2
      }
    ))
  ));
}
var CloseButton_default = JoyrideTooltipCloseButton;
function JoyrideTooltipContainer(props) {
  const { backProps, closeProps, index: index2, isLastStep, primaryProps, skipProps, step, tooltipProps } = props;
  const { content, hideBackButton, hideCloseButton, hideFooter, showSkipButton, styles, title } = step;
  const output = {};
  output.primary = /* @__PURE__ */ React.createElement(
    "button",
    {
      "data-test-id": "button-primary",
      style: styles.buttonNext,
      type: "button",
      ...primaryProps
    }
  );
  if (showSkipButton && !isLastStep) {
    output.skip = /* @__PURE__ */ React.createElement(
      "button",
      {
        "aria-live": "off",
        "data-test-id": "button-skip",
        style: styles.buttonSkip,
        type: "button",
        ...skipProps
      }
    );
  }
  if (!hideBackButton && index2 > 0) {
    output.back = /* @__PURE__ */ React.createElement("button", { "data-test-id": "button-back", style: styles.buttonBack, type: "button", ...backProps });
  }
  output.close = !hideCloseButton && /* @__PURE__ */ React.createElement(CloseButton_default, { "data-test-id": "button-close", styles: styles.buttonClose, ...closeProps });
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      key: "JoyrideTooltip",
      "aria-label": getReactNodeText(title != null ? title : content),
      className: "react-joyride__tooltip",
      style: styles.tooltip,
      ...tooltipProps
    },
    /* @__PURE__ */ React.createElement("div", { style: styles.tooltipContainer }, title && /* @__PURE__ */ React.createElement("h1", { "aria-label": getReactNodeText(title), style: styles.tooltipTitle }, title), /* @__PURE__ */ React.createElement("div", { style: styles.tooltipContent }, content)),
    !hideFooter && /* @__PURE__ */ React.createElement("div", { style: styles.tooltipFooter }, /* @__PURE__ */ React.createElement("div", { style: styles.tooltipFooterSpacer }, output.skip), output.back, output.primary),
    output.close
  );
}
var Container_default = JoyrideTooltipContainer;
var JoyrideTooltip = class extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "handleClickBack", (event) => {
      event.preventDefault();
      const { helpers } = this.props;
      helpers.prev();
    });
    __publicField(this, "handleClickClose", (event) => {
      event.preventDefault();
      const { helpers } = this.props;
      helpers.close("button_close");
    });
    __publicField(this, "handleClickPrimary", (event) => {
      event.preventDefault();
      const { continuous: continuous2, helpers } = this.props;
      if (!continuous2) {
        helpers.close("button_primary");
        return;
      }
      helpers.next();
    });
    __publicField(this, "handleClickSkip", (event) => {
      event.preventDefault();
      const { helpers } = this.props;
      helpers.skip();
    });
    __publicField(this, "getElementsProps", () => {
      const { continuous: continuous2, index: index2, isLastStep, setTooltipRef, size: size2, step } = this.props;
      const { back, close, last: last2, next, nextLabelWithProgress, skip } = step.locale;
      const backText = getReactNodeText(back);
      const closeText = getReactNodeText(close);
      const lastText = getReactNodeText(last2);
      const nextText = getReactNodeText(next);
      const skipText = getReactNodeText(skip);
      let primary = close;
      let primaryText = closeText;
      if (continuous2) {
        primary = next;
        primaryText = nextText;
        if (step.showProgress && !isLastStep) {
          const labelWithProgress = getReactNodeText(nextLabelWithProgress, {
            step: index2 + 1,
            steps: size2
          });
          primary = replaceLocaleContent(nextLabelWithProgress, index2 + 1, size2);
          primaryText = labelWithProgress;
        }
        if (isLastStep) {
          primary = last2;
          primaryText = lastText;
        }
      }
      return {
        backProps: {
          "aria-label": backText,
          children: back,
          "data-action": "back",
          onClick: this.handleClickBack,
          role: "button",
          title: backText
        },
        closeProps: {
          "aria-label": closeText,
          children: close,
          "data-action": "close",
          onClick: this.handleClickClose,
          role: "button",
          title: closeText
        },
        primaryProps: {
          "aria-label": primaryText,
          children: primary,
          "data-action": "primary",
          onClick: this.handleClickPrimary,
          role: "button",
          title: primaryText
        },
        skipProps: {
          "aria-label": skipText,
          children: skip,
          "data-action": "skip",
          onClick: this.handleClickSkip,
          role: "button",
          title: skipText
        },
        tooltipProps: {
          "aria-modal": true,
          ref: setTooltipRef,
          role: "alertdialog"
        }
      };
    });
  }
  render() {
    const { continuous: continuous2, index: index2, isLastStep, setTooltipRef, size: size2, step } = this.props;
    const { beaconComponent, tooltipComponent, ...cleanStep } = step;
    let component;
    if (tooltipComponent) {
      const renderProps = {
        ...this.getElementsProps(),
        continuous: continuous2,
        index: index2,
        isLastStep,
        size: size2,
        step: cleanStep,
        setTooltipRef
      };
      const TooltipComponent = tooltipComponent;
      component = /* @__PURE__ */ React.createElement(TooltipComponent, { ...renderProps });
    } else {
      component = /* @__PURE__ */ React.createElement(
        Container_default,
        {
          ...this.getElementsProps(),
          continuous: continuous2,
          index: index2,
          isLastStep,
          size: size2,
          step
        }
      );
    }
    return component;
  }
};
var JoyrideStep = class extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "scope", null);
    __publicField(this, "tooltip", null);
    __publicField(this, "handleClickHoverBeacon", (event) => {
      const { step, store } = this.props;
      if (event.type === "mouseenter" && step.event !== "hover") {
        return;
      }
      store.update({ lifecycle: LIFECYCLE.TOOLTIP });
    });
    __publicField(this, "setTooltipRef", (element) => {
      this.tooltip = element;
    });
    __publicField(this, "setPopper", (popper, type) => {
      var _a;
      const { action, lifecycle, step, store } = this.props;
      if (type === "wrapper") {
        store.setPopper("beacon", popper);
      } else {
        store.setPopper("tooltip", popper);
      }
      if (store.getPopper("beacon") && (store.getPopper("tooltip") || step.placement === "center") && lifecycle === LIFECYCLE.INIT) {
        store.update({
          action,
          lifecycle: LIFECYCLE.READY
        });
      }
      if ((_a = step.floaterProps) == null ? void 0 : _a.getPopper) {
        step.floaterProps.getPopper(popper, type);
      }
    });
    __publicField(this, "renderTooltip", (renderProps) => {
      const { continuous: continuous2, helpers, index: index2, size: size2, step } = this.props;
      return /* @__PURE__ */ React.createElement(
        JoyrideTooltip,
        {
          continuous: continuous2,
          helpers,
          index: index2,
          isLastStep: index2 + 1 === size2,
          setTooltipRef: this.setTooltipRef,
          size: size2,
          step,
          ...renderProps
        }
      );
    });
  }
  componentDidMount() {
    const { debug: debug2, index: index2 } = this.props;
    log$1({
      title: `step:${index2}`,
      data: [{ key: "props", value: this.props }],
      debug: debug2
    });
  }
  componentDidUpdate(previousProps) {
    var _a;
    const {
      action,
      callback,
      continuous: continuous2,
      controlled,
      debug: debug2,
      helpers,
      index: index2,
      lifecycle,
      shouldScroll: shouldScroll2,
      status,
      step,
      store
    } = this.props;
    const { changed, changedFrom } = treeChanges$1(previousProps, this.props);
    const state = helpers.info();
    const skipBeacon = continuous2 && action !== ACTIONS.CLOSE && (index2 > 0 || action === ACTIONS.PREV);
    const hasStoreChanged = changed("action") || changed("index") || changed("lifecycle") || changed("status");
    const isInitial = changedFrom("lifecycle", [LIFECYCLE.TOOLTIP, LIFECYCLE.INIT], LIFECYCLE.INIT);
    const isAfterAction = changed("action", [
      ACTIONS.NEXT,
      ACTIONS.PREV,
      ACTIONS.SKIP,
      ACTIONS.CLOSE
    ]);
    const isControlled = controlled && index2 === previousProps.index;
    if (isAfterAction && (isInitial || isControlled)) {
      callback({
        ...state,
        index: previousProps.index,
        lifecycle: LIFECYCLE.COMPLETE,
        step: previousProps.step,
        type: EVENTS.STEP_AFTER
      });
    }
    if (step.placement === "center" && status === STATUS.RUNNING && changed("index") && action !== ACTIONS.START && lifecycle === LIFECYCLE.INIT) {
      store.update({ lifecycle: LIFECYCLE.READY });
    }
    if (hasStoreChanged) {
      const element = getElement(step.target);
      const elementExists = !!element;
      const hasRenderedTarget = elementExists && isElementVisible(element);
      if (hasRenderedTarget) {
        if (changedFrom("status", STATUS.READY, STATUS.RUNNING) || changedFrom("lifecycle", LIFECYCLE.INIT, LIFECYCLE.READY)) {
          callback({
            ...state,
            step,
            type: EVENTS.STEP_BEFORE
          });
        }
      } else {
        console.warn(elementExists ? "Target not visible" : "Target not mounted", step);
        callback({
          ...state,
          type: EVENTS.TARGET_NOT_FOUND,
          step
        });
        if (!controlled) {
          store.update({ index: index2 + (action === ACTIONS.PREV ? -1 : 1) });
        }
      }
    }
    if (changedFrom("lifecycle", LIFECYCLE.INIT, LIFECYCLE.READY)) {
      store.update({
        lifecycle: hideBeacon(step) || skipBeacon ? LIFECYCLE.TOOLTIP : LIFECYCLE.BEACON
      });
    }
    if (changed("index")) {
      log$1({
        title: `step:${lifecycle}`,
        data: [{ key: "props", value: this.props }],
        debug: debug2
      });
    }
    if (changed("lifecycle", LIFECYCLE.BEACON)) {
      callback({
        ...state,
        step,
        type: EVENTS.BEACON
      });
    }
    if (changed("lifecycle", LIFECYCLE.TOOLTIP)) {
      callback({
        ...state,
        step,
        type: EVENTS.TOOLTIP
      });
      if (shouldScroll2 && this.tooltip) {
        this.scope = new Scope(this.tooltip, { selector: "[data-action=primary]" });
        this.scope.setFocus();
      }
    }
    if (changedFrom("lifecycle", [LIFECYCLE.TOOLTIP, LIFECYCLE.INIT], LIFECYCLE.INIT)) {
      (_a = this.scope) == null ? void 0 : _a.removeScope();
      store.cleanupPoppers();
    }
  }
  componentWillUnmount() {
    var _a;
    (_a = this.scope) == null ? void 0 : _a.removeScope();
  }
  get open() {
    const { lifecycle, step } = this.props;
    return hideBeacon(step) || lifecycle === LIFECYCLE.TOOLTIP;
  }
  render() {
    const { continuous: continuous2, debug: debug2, index: index2, nonce, shouldScroll: shouldScroll2, size: size2, step } = this.props;
    const target = getElement(step.target);
    if (!validateStep(step) || !src_default.domElement(target)) {
      return null;
    }
    return /* @__PURE__ */ React.createElement("div", { key: `JoyrideStep-${index2}`, className: "react-joyride__step" }, /* @__PURE__ */ React.createElement(
      ReactFloater,
      {
        ...step.floaterProps,
        component: this.renderTooltip,
        debug: debug2,
        getPopper: this.setPopper,
        id: `react-joyride-step-${index2}`,
        open: this.open,
        placement: step.placement,
        target: step.target
      },
      /* @__PURE__ */ React.createElement(
        JoyrideBeacon,
        {
          beaconComponent: step.beaconComponent,
          continuous: continuous2,
          index: index2,
          isLastStep: index2 + 1 === size2,
          locale: step.locale,
          nonce,
          onClickOrHover: this.handleClickHoverBeacon,
          shouldFocus: shouldScroll2,
          size: size2,
          step,
          styles: step.styles
        }
      )
    ));
  }
};
var Joyride = class extends React.Component {
  constructor(props) {
    super(props);
    __publicField(this, "helpers");
    __publicField(this, "store");
    __publicField(this, "callback", (data) => {
      const { callback } = this.props;
      if (src_default.function(callback)) {
        callback(data);
      }
    });
    __publicField(this, "handleKeyboard", (event) => {
      const { index: index2, lifecycle } = this.state;
      const { steps: steps2 } = this.props;
      const step = steps2[index2];
      if (lifecycle === LIFECYCLE.TOOLTIP) {
        if (event.code === "Escape" && step && !step.disableCloseOnEsc) {
          this.store.close("keyboard");
        }
      }
    });
    __publicField(this, "handleClickOverlay", () => {
      const { index: index2 } = this.state;
      const { steps: steps2 } = this.props;
      const step = getMergedStep(this.props, steps2[index2]);
      if (!step.disableOverlayClose) {
        this.helpers.close("overlay");
      }
    });
    __publicField(this, "syncState", (state) => {
      this.setState(state);
    });
    const { debug: debug2, getHelpers, run = true, stepIndex } = props;
    this.store = createStore({
      ...props,
      controlled: run && src_default.number(stepIndex)
    });
    this.helpers = this.store.getHelpers();
    const { addListener } = this.store;
    log$1({
      title: "init",
      data: [
        { key: "props", value: this.props },
        { key: "state", value: this.state }
      ],
      debug: debug2
    });
    addListener(this.syncState);
    if (getHelpers) {
      getHelpers(this.helpers);
    }
    this.state = this.store.getState();
  }
  componentDidMount() {
    if (!canUseDOM()) {
      return;
    }
    const { debug: debug2, disableCloseOnEsc, run, steps: steps2 } = this.props;
    const { start } = this.store;
    if (validateSteps(steps2, debug2) && run) {
      start();
    }
    if (!disableCloseOnEsc) {
      document.body.addEventListener("keydown", this.handleKeyboard, { passive: true });
    }
  }
  componentDidUpdate(previousProps, previousState) {
    if (!canUseDOM()) {
      return;
    }
    const { action, controlled, index: index2, status } = this.state;
    const { debug: debug2, run, stepIndex, steps: steps2 } = this.props;
    const { stepIndex: previousStepIndex, steps: previousSteps } = previousProps;
    const { reset, setSteps, start, stop, update: update2 } = this.store;
    const { changed: changedProps } = treeChanges$1(previousProps, this.props);
    const { changed, changedFrom } = treeChanges$1(previousState, this.state);
    const step = getMergedStep(this.props, steps2[index2]);
    const stepsChanged = !equal$1(previousSteps, steps2);
    const stepIndexChanged = src_default.number(stepIndex) && changedProps("stepIndex");
    const target = getElement(step.target);
    if (stepsChanged) {
      if (validateSteps(steps2, debug2)) {
        setSteps(steps2);
      } else {
        console.warn("Steps are not valid", steps2);
      }
    }
    if (changedProps("run")) {
      if (run) {
        start(stepIndex);
      } else {
        stop();
      }
    }
    if (stepIndexChanged) {
      let nextAction = src_default.number(previousStepIndex) && previousStepIndex < stepIndex ? ACTIONS.NEXT : ACTIONS.PREV;
      if (action === ACTIONS.STOP) {
        nextAction = ACTIONS.START;
      }
      if (![STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
        update2({
          action: action === ACTIONS.CLOSE ? ACTIONS.CLOSE : nextAction,
          index: stepIndex,
          lifecycle: LIFECYCLE.INIT
        });
      }
    }
    if (!controlled && status === STATUS.RUNNING && index2 === 0 && !target) {
      this.store.update({ index: index2 + 1 });
      this.callback({
        ...this.state,
        type: EVENTS.TARGET_NOT_FOUND,
        step
      });
    }
    const callbackData = {
      ...this.state,
      index: index2,
      step
    };
    const isAfterAction = changed("action", [
      ACTIONS.NEXT,
      ACTIONS.PREV,
      ACTIONS.SKIP,
      ACTIONS.CLOSE
    ]);
    if (isAfterAction && changed("status", STATUS.PAUSED)) {
      const previousStep = getMergedStep(this.props, steps2[previousState.index]);
      this.callback({
        ...callbackData,
        index: previousState.index,
        lifecycle: LIFECYCLE.COMPLETE,
        step: previousStep,
        type: EVENTS.STEP_AFTER
      });
    }
    if (changed("status", [STATUS.FINISHED, STATUS.SKIPPED])) {
      const previousStep = getMergedStep(this.props, steps2[previousState.index]);
      if (!controlled) {
        this.callback({
          ...callbackData,
          index: previousState.index,
          lifecycle: LIFECYCLE.COMPLETE,
          step: previousStep,
          type: EVENTS.STEP_AFTER
        });
      }
      this.callback({
        ...callbackData,
        type: EVENTS.TOUR_END,
        // Return the last step when the tour is finished
        step: previousStep,
        index: previousState.index
      });
      reset();
    } else if (changedFrom("status", [STATUS.IDLE, STATUS.READY], STATUS.RUNNING)) {
      this.callback({
        ...callbackData,
        type: EVENTS.TOUR_START
      });
    } else if (changed("status") || changed("action", ACTIONS.RESET)) {
      this.callback({
        ...callbackData,
        type: EVENTS.TOUR_STATUS
      });
    }
    this.scrollToStep(previousState);
  }
  componentWillUnmount() {
    const { disableCloseOnEsc } = this.props;
    if (!disableCloseOnEsc) {
      document.body.removeEventListener("keydown", this.handleKeyboard);
    }
  }
  scrollToStep(previousState) {
    const { index: index2, lifecycle, status } = this.state;
    const {
      debug: debug2,
      disableScrollParentFix = false,
      scrollDuration,
      scrollOffset = 20,
      scrollToFirstStep = false,
      steps: steps2
    } = this.props;
    const step = getMergedStep(this.props, steps2[index2]);
    const target = getElement(step.target);
    const shouldScrollToStep = shouldScroll({
      isFirstStep: index2 === 0,
      lifecycle,
      previousLifecycle: previousState.lifecycle,
      scrollToFirstStep,
      step,
      target
    });
    if (status === STATUS.RUNNING && shouldScrollToStep) {
      const hasCustomScroll = hasCustomScrollParent(target, disableScrollParentFix);
      const scrollParent2 = getScrollParent(target, disableScrollParentFix);
      let scrollY = Math.floor(getScrollTo(target, scrollOffset, disableScrollParentFix)) || 0;
      log$1({
        title: "scrollToStep",
        data: [
          { key: "index", value: index2 },
          { key: "lifecycle", value: lifecycle },
          { key: "status", value: status }
        ],
        debug: debug2
      });
      const beaconPopper = this.store.getPopper("beacon");
      const tooltipPopper = this.store.getPopper("tooltip");
      if (lifecycle === LIFECYCLE.BEACON && beaconPopper) {
        const { offsets, placement } = beaconPopper;
        if (!["bottom"].includes(placement) && !hasCustomScroll) {
          scrollY = Math.floor(offsets.popper.top - scrollOffset);
        }
      } else if (lifecycle === LIFECYCLE.TOOLTIP && tooltipPopper) {
        const { flipped, offsets, placement } = tooltipPopper;
        if (["top", "right", "left"].includes(placement) && !flipped && !hasCustomScroll) {
          scrollY = Math.floor(offsets.popper.top - scrollOffset);
        } else {
          scrollY -= step.spotlightPadding;
        }
      }
      scrollY = scrollY >= 0 ? scrollY : 0;
      if (status === STATUS.RUNNING) {
        scrollTo(scrollY, { element: scrollParent2, duration: scrollDuration }).then(
          () => {
            setTimeout(() => {
              var _a;
              (_a = this.store.getPopper("tooltip")) == null ? void 0 : _a.instance.update();
            }, 10);
          }
        );
      }
    }
  }
  render() {
    if (!canUseDOM()) {
      return null;
    }
    const { index: index2, lifecycle, status } = this.state;
    const {
      continuous: continuous2 = false,
      debug: debug2 = false,
      nonce,
      scrollToFirstStep = false,
      steps: steps2
    } = this.props;
    const isRunning = status === STATUS.RUNNING;
    const content = {};
    if (isRunning && steps2[index2]) {
      const step = getMergedStep(this.props, steps2[index2]);
      content.step = /* @__PURE__ */ React.createElement(
        JoyrideStep,
        {
          ...this.state,
          callback: this.callback,
          continuous: continuous2,
          debug: debug2,
          helpers: this.helpers,
          nonce,
          shouldScroll: !step.disableScrolling && (index2 !== 0 || scrollToFirstStep),
          step,
          store: this.store
        }
      );
      content.overlay = /* @__PURE__ */ React.createElement(JoyridePortal, { id: "react-joyride-portal" }, /* @__PURE__ */ React.createElement(
        JoyrideOverlay,
        {
          ...step,
          continuous: continuous2,
          debug: debug2,
          lifecycle,
          onClickOverlay: this.handleClickOverlay
        }
      ));
    }
    return /* @__PURE__ */ React.createElement("div", { className: "react-joyride" }, content.step, content.overlay);
  }
};
__publicField(Joyride, "defaultProps", defaultProps$4);
var components_default = Joyride;
const Tooltip$2 = ({
  continuous: continuous2,
  index: index2,
  isLastStep,
  step,
  backProps,
  primaryProps,
  skipProps,
  tooltipProps,
  size: size2,
  locale: locale2,
  disableTourSkipOnEsc
}) => {
  const skipButtonRef = React.useRef(null);
  React.useEffect(() => {
    const onWindowKeyDown = (event) => {
      if (!disableTourSkipOnEsc) {
        if (event.key === "Escape" && skipButtonRef.current !== null) {
          event.preventDefault();
          skipButtonRef.current.click();
          return;
        }
      }
    };
    window.addEventListener("keydown", onWindowKeyDown);
    return () => {
      window.removeEventListener("keydown", onWindowKeyDown);
    };
  }, []);
  return /* @__PURE__ */ React.createElement("div", { ...tooltipProps, className: "yt-tour__step w-88 relative rounded bg-white p-4" }, /* @__PURE__ */ React.createElement(
    IconButton,
    {
      ...skipProps,
      ref: skipButtonRef,
      appearance: "discrete",
      icon: "close",
      title: locale2.skip,
      "aria-label": locale2.skip,
      className: "absolute right-0 top-0 mr-1 mt-1"
    }
  ), step.title && /* @__PURE__ */ React.createElement("h5", null, step.title), step.content, /* @__PURE__ */ React.createElement(Group$6, { className: "mt-4 justify-end" }, index2 > 0 && /* @__PURE__ */ React.createElement(Button$4, { ...backProps, appearance: "discrete" }, locale2.back), /* @__PURE__ */ React.createElement(Button$4, { ...primaryProps, appearance: "primary" }, continuous2 ? isLastStep ? `${locale2.last} (${index2 + 1}/${size2})` : `${locale2.next} (${index2 + 1}/${size2})` : locale2.close)));
};
const TourStep = (_props) => null;
const Tour = (props) => {
  const {
    texts: { tour }
  } = useLocalization();
  const {
    autoStart: run,
    onComplete,
    onClose,
    onReady,
    spotlightClicks,
    disableCloseOnEsc: disableTourSkipOnEsc,
    disableScrollParentFix = false,
    scrollOffset,
    ...rest
  } = props;
  const steps2 = React.useMemo(() => {
    return React.Children.map(props.children, (child) => {
      const step = {
        disableBeacon: !child.props.showBeacon,
        target: child.props.selector,
        placement: child.props.position,
        title: child.props.title,
        content: child.props.children
      };
      return step;
    });
  }, [props.children]);
  const getStep = React.useCallback(
    (selector) => {
      var _a;
      return (_a = props.children.find((child) => child.props.selector === selector)) == null ? void 0 : _a.props;
    },
    [props.children]
  );
  const callback = (state) => {
    if (state.action === ACTIONS.SKIP && state.lifecycle === LIFECYCLE.COMPLETE) {
      if (onClose) {
        onClose(getStep(state.step.target));
      }
    }
    if (state.type === EVENTS.TOUR_END) {
      if (onComplete) {
        onComplete();
      }
    }
    if (state.lifecycle === LIFECYCLE.READY) {
      if (onReady) {
        onReady(getStep(state.step.target));
      }
    }
  };
  return /* @__PURE__ */ React.createElement(
    components_default,
    {
      ...rest,
      run,
      steps: steps2,
      showProgress: true,
      floaterProps: {
        disableAnimation: true
      },
      tooltipComponent: (tooltipProps) => /* @__PURE__ */ React.createElement(Tooltip$2, { ...tooltipProps, locale: tour, disableTourSkipOnEsc }),
      locale: tour,
      spotlightPadding: 8,
      spotlightClicks,
      disableScrollParentFix,
      callback,
      scrollOffset,
      styles: {
        /** style beacon */
        options: {
          // tailwind.theme.colors.blue.300
          primaryColor: "#6ba4ff"
        }
      },
      disableCloseOnEsc: true
    }
  );
};
Tour.Step = TourStep;
var isNil_1;
var hasRequiredIsNil;
function requireIsNil() {
  if (hasRequiredIsNil) return isNil_1;
  hasRequiredIsNil = 1;
  function isNil2(value) {
    return value == null;
  }
  isNil_1 = isNil2;
  return isNil_1;
}
var isNilExports = requireIsNil();
const isNil = /* @__PURE__ */ getDefaultExportFromCjs(isNilExports);
var isString_1;
var hasRequiredIsString;
function requireIsString() {
  if (hasRequiredIsString) return isString_1;
  hasRequiredIsString = 1;
  var baseGetTag = require_baseGetTag(), isArray2 = requireIsArray(), isObjectLike = requireIsObjectLike();
  var stringTag = "[object String]";
  function isString2(value) {
    return typeof value == "string" || !isArray2(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
  }
  isString_1 = isString2;
  return isString_1;
}
var isStringExports = requireIsString();
const isString = /* @__PURE__ */ getDefaultExportFromCjs(isStringExports);
var isFunctionExports = requireIsFunction();
const isFunction = /* @__PURE__ */ getDefaultExportFromCjs(isFunctionExports);
var isObjectExports = requireIsObject();
const isObject = /* @__PURE__ */ getDefaultExportFromCjs(isObjectExports);
var reactIs = { exports: {} };
var reactIs_production_min = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min) return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var b3 = Symbol.for("react.element"), c3 = Symbol.for("react.portal"), d4 = Symbol.for("react.fragment"), e3 = Symbol.for("react.strict_mode"), f2 = Symbol.for("react.profiler"), g2 = Symbol.for("react.provider"), h4 = Symbol.for("react.context"), k3 = Symbol.for("react.server_context"), l2 = Symbol.for("react.forward_ref"), m4 = Symbol.for("react.suspense"), n2 = Symbol.for("react.suspense_list"), p2 = Symbol.for("react.memo"), q2 = Symbol.for("react.lazy"), t3 = Symbol.for("react.offscreen"), u3;
  u3 = Symbol.for("react.module.reference");
  function v2(a4) {
    if ("object" === typeof a4 && null !== a4) {
      var r2 = a4.$$typeof;
      switch (r2) {
        case b3:
          switch (a4 = a4.type, a4) {
            case d4:
            case f2:
            case e3:
            case m4:
            case n2:
              return a4;
            default:
              switch (a4 = a4 && a4.$$typeof, a4) {
                case k3:
                case h4:
                case l2:
                case q2:
                case p2:
                case g2:
                  return a4;
                default:
                  return r2;
              }
          }
        case c3:
          return r2;
      }
    }
  }
  reactIs_production_min.ContextConsumer = h4;
  reactIs_production_min.ContextProvider = g2;
  reactIs_production_min.Element = b3;
  reactIs_production_min.ForwardRef = l2;
  reactIs_production_min.Fragment = d4;
  reactIs_production_min.Lazy = q2;
  reactIs_production_min.Memo = p2;
  reactIs_production_min.Portal = c3;
  reactIs_production_min.Profiler = f2;
  reactIs_production_min.StrictMode = e3;
  reactIs_production_min.Suspense = m4;
  reactIs_production_min.SuspenseList = n2;
  reactIs_production_min.isAsyncMode = function() {
    return false;
  };
  reactIs_production_min.isConcurrentMode = function() {
    return false;
  };
  reactIs_production_min.isContextConsumer = function(a4) {
    return v2(a4) === h4;
  };
  reactIs_production_min.isContextProvider = function(a4) {
    return v2(a4) === g2;
  };
  reactIs_production_min.isElement = function(a4) {
    return "object" === typeof a4 && null !== a4 && a4.$$typeof === b3;
  };
  reactIs_production_min.isForwardRef = function(a4) {
    return v2(a4) === l2;
  };
  reactIs_production_min.isFragment = function(a4) {
    return v2(a4) === d4;
  };
  reactIs_production_min.isLazy = function(a4) {
    return v2(a4) === q2;
  };
  reactIs_production_min.isMemo = function(a4) {
    return v2(a4) === p2;
  };
  reactIs_production_min.isPortal = function(a4) {
    return v2(a4) === c3;
  };
  reactIs_production_min.isProfiler = function(a4) {
    return v2(a4) === f2;
  };
  reactIs_production_min.isStrictMode = function(a4) {
    return v2(a4) === e3;
  };
  reactIs_production_min.isSuspense = function(a4) {
    return v2(a4) === m4;
  };
  reactIs_production_min.isSuspenseList = function(a4) {
    return v2(a4) === n2;
  };
  reactIs_production_min.isValidElementType = function(a4) {
    return "string" === typeof a4 || "function" === typeof a4 || a4 === d4 || a4 === f2 || a4 === e3 || a4 === m4 || a4 === n2 || a4 === t3 || "object" === typeof a4 && null !== a4 && (a4.$$typeof === q2 || a4.$$typeof === p2 || a4.$$typeof === g2 || a4.$$typeof === h4 || a4.$$typeof === l2 || a4.$$typeof === u3 || void 0 !== a4.getModuleId) ? true : false;
  };
  reactIs_production_min.typeOf = v2;
  return reactIs_production_min;
}
var reactIs_development = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development;
function requireReactIs_development() {
  if (hasRequiredReactIs_development) return reactIs_development;
  hasRequiredReactIs_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      var REACT_ELEMENT_TYPE = Symbol.for("react.element");
      var REACT_PORTAL_TYPE = Symbol.for("react.portal");
      var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
      var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
      var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
      var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
      var REACT_CONTEXT_TYPE = Symbol.for("react.context");
      var REACT_SERVER_CONTEXT_TYPE = Symbol.for("react.server_context");
      var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
      var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
      var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
      var REACT_MEMO_TYPE = Symbol.for("react.memo");
      var REACT_LAZY_TYPE = Symbol.for("react.lazy");
      var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
      var enableScopeAPI = false;
      var enableCacheElement = false;
      var enableTransitionTracing = false;
      var enableLegacyHidden = false;
      var enableDebugTracing = false;
      var REACT_MODULE_REFERENCE;
      {
        REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
      }
      function isValidElementType(type) {
        if (typeof type === "string" || typeof type === "function") {
          return true;
        }
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) {
          return true;
        }
        if (typeof type === "object" && type !== null) {
          if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
          // types supported by any Flight configuration anywhere since
          // we don't know which Flight build this will end up being used
          // with.
          type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== void 0) {
            return true;
          }
        }
        return false;
      }
      function typeOf(object2) {
        if (typeof object2 === "object" && object2 !== null) {
          var $$typeof = object2.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object2.type;
              switch (type) {
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                case REACT_SUSPENSE_LIST_TYPE:
                  return type;
                default:
                  var $$typeofType = type && type.$$typeof;
                  switch ($$typeofType) {
                    case REACT_SERVER_CONTEXT_TYPE:
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return void 0;
      }
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element2 = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment2 = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal2 = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var SuspenseList = REACT_SUSPENSE_LIST_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;
      var hasWarnedAboutDeprecatedIsConcurrentMode = false;
      function isAsyncMode(object2) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.");
          }
        }
        return false;
      }
      function isConcurrentMode(object2) {
        {
          if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
            hasWarnedAboutDeprecatedIsConcurrentMode = true;
            console["warn"]("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.");
          }
        }
        return false;
      }
      function isContextConsumer(object2) {
        return typeOf(object2) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object2) {
        return typeOf(object2) === REACT_PROVIDER_TYPE;
      }
      function isElement(object2) {
        return typeof object2 === "object" && object2 !== null && object2.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object2) {
        return typeOf(object2) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object2) {
        return typeOf(object2) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object2) {
        return typeOf(object2) === REACT_LAZY_TYPE;
      }
      function isMemo(object2) {
        return typeOf(object2) === REACT_MEMO_TYPE;
      }
      function isPortal(object2) {
        return typeOf(object2) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object2) {
        return typeOf(object2) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object2) {
        return typeOf(object2) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object2) {
        return typeOf(object2) === REACT_SUSPENSE_TYPE;
      }
      function isSuspenseList(object2) {
        return typeOf(object2) === REACT_SUSPENSE_LIST_TYPE;
      }
      reactIs_development.ContextConsumer = ContextConsumer;
      reactIs_development.ContextProvider = ContextProvider;
      reactIs_development.Element = Element2;
      reactIs_development.ForwardRef = ForwardRef;
      reactIs_development.Fragment = Fragment2;
      reactIs_development.Lazy = Lazy;
      reactIs_development.Memo = Memo;
      reactIs_development.Portal = Portal2;
      reactIs_development.Profiler = Profiler;
      reactIs_development.StrictMode = StrictMode;
      reactIs_development.Suspense = Suspense;
      reactIs_development.SuspenseList = SuspenseList;
      reactIs_development.isAsyncMode = isAsyncMode;
      reactIs_development.isConcurrentMode = isConcurrentMode;
      reactIs_development.isContextConsumer = isContextConsumer;
      reactIs_development.isContextProvider = isContextProvider;
      reactIs_development.isElement = isElement;
      reactIs_development.isForwardRef = isForwardRef;
      reactIs_development.isFragment = isFragment;
      reactIs_development.isLazy = isLazy;
      reactIs_development.isMemo = isMemo;
      reactIs_development.isPortal = isPortal;
      reactIs_development.isProfiler = isProfiler;
      reactIs_development.isStrictMode = isStrictMode;
      reactIs_development.isSuspense = isSuspense;
      reactIs_development.isSuspenseList = isSuspenseList;
      reactIs_development.isValidElementType = isValidElementType;
      reactIs_development.typeOf = typeOf;
    })();
  }
  return reactIs_development;
}
var hasRequiredReactIs;
function requireReactIs() {
  if (hasRequiredReactIs) return reactIs.exports;
  hasRequiredReactIs = 1;
  if (process.env.NODE_ENV === "production") {
    reactIs.exports = requireReactIs_production_min();
  } else {
    reactIs.exports = requireReactIs_development();
  }
  return reactIs.exports;
}
var reactIsExports = requireReactIs();
var isNumber_1;
var hasRequiredIsNumber;
function requireIsNumber() {
  if (hasRequiredIsNumber) return isNumber_1;
  hasRequiredIsNumber = 1;
  var baseGetTag = require_baseGetTag(), isObjectLike = requireIsObjectLike();
  var numberTag = "[object Number]";
  function isNumber3(value) {
    return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
  }
  isNumber_1 = isNumber3;
  return isNumber_1;
}
var _isNaN;
var hasRequired_isNaN;
function require_isNaN() {
  if (hasRequired_isNaN) return _isNaN;
  hasRequired_isNaN = 1;
  var isNumber3 = requireIsNumber();
  function isNaN2(value) {
    return isNumber3(value) && value != +value;
  }
  _isNaN = isNaN2;
  return _isNaN;
}
var _isNaNExports = require_isNaN();
const isNan = /* @__PURE__ */ getDefaultExportFromCjs(_isNaNExports);
var isNumberExports = requireIsNumber();
const isNumber$1 = /* @__PURE__ */ getDefaultExportFromCjs(isNumberExports);
var mathSign = function mathSign2(value) {
  if (value === 0) {
    return 0;
  }
  if (value > 0) {
    return 1;
  }
  return -1;
};
var isPercent = function isPercent2(value) {
  return isString(value) && value.indexOf("%") === value.length - 1;
};
var isNumber = function isNumber2(value) {
  return isNumber$1(value) && !isNan(value);
};
var isNumOrStr = function isNumOrStr2(value) {
  return isNumber(value) || isString(value);
};
var idCounter = 0;
var uniqueId = function uniqueId2(prefix2) {
  var id2 = ++idCounter;
  return "".concat(prefix2 || "").concat(id2);
};
var getPercentValue = function getPercentValue2(percent2, totalValue) {
  var defaultValue2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
  var validate = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
  if (!isNumber(percent2) && !isString(percent2)) {
    return defaultValue2;
  }
  var value;
  if (isPercent(percent2)) {
    var index2 = percent2.indexOf("%");
    value = totalValue * parseFloat(percent2.slice(0, index2)) / 100;
  } else {
    value = +percent2;
  }
  if (isNan(value)) {
    value = defaultValue2;
  }
  if (validate && value > totalValue) {
    value = totalValue;
  }
  return value;
};
var getAnyElementOfObject = function getAnyElementOfObject2(obj) {
  if (!obj) {
    return null;
  }
  var keys2 = Object.keys(obj);
  if (keys2 && keys2.length) {
    return obj[keys2[0]];
  }
  return null;
};
var hasDuplicate = function hasDuplicate2(ary) {
  if (!Array.isArray(ary)) {
    return false;
  }
  var len = ary.length;
  var cache = {};
  for (var i3 = 0; i3 < len; i3++) {
    if (!cache[ary[i3]]) {
      cache[ary[i3]] = true;
    } else {
      return true;
    }
  }
  return false;
};
var interpolateNumber$2 = function interpolateNumber(numberA, numberB) {
  if (isNumber(numberA) && isNumber(numberB)) {
    return function(t3) {
      return numberA + t3 * (numberB - numberA);
    };
  }
  return function() {
    return numberB;
  };
};
function findEntryInArray(ary, specifiedKey, specifiedValue) {
  if (!ary || !ary.length) {
    return null;
  }
  return ary.find(function(entry) {
    return entry && (typeof specifiedKey === "function" ? specifiedKey(entry) : get(entry, specifiedKey)) === specifiedValue;
  });
}
function shallowEqual(a4, b3) {
  for (var key in a4) {
    if ({}.hasOwnProperty.call(a4, key) && (!{}.hasOwnProperty.call(b3, key) || a4[key] !== b3[key])) {
      return false;
    }
  }
  for (var _key in b3) {
    if ({}.hasOwnProperty.call(b3, _key) && !{}.hasOwnProperty.call(a4, _key)) {
      return false;
    }
  }
  return true;
}
function _typeof$N(o2) {
  "@babel/helpers - typeof";
  return _typeof$N = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof$N(o2);
}
var SVGContainerPropKeys = ["viewBox", "children"];
var SVGElementPropKeys = [
  "aria-activedescendant",
  "aria-atomic",
  "aria-autocomplete",
  "aria-busy",
  "aria-checked",
  "aria-colcount",
  "aria-colindex",
  "aria-colspan",
  "aria-controls",
  "aria-current",
  "aria-describedby",
  "aria-details",
  "aria-disabled",
  "aria-errormessage",
  "aria-expanded",
  "aria-flowto",
  "aria-haspopup",
  "aria-hidden",
  "aria-invalid",
  "aria-keyshortcuts",
  "aria-label",
  "aria-labelledby",
  "aria-level",
  "aria-live",
  "aria-modal",
  "aria-multiline",
  "aria-multiselectable",
  "aria-orientation",
  "aria-owns",
  "aria-placeholder",
  "aria-posinset",
  "aria-pressed",
  "aria-readonly",
  "aria-relevant",
  "aria-required",
  "aria-roledescription",
  "aria-rowcount",
  "aria-rowindex",
  "aria-rowspan",
  "aria-selected",
  "aria-setsize",
  "aria-sort",
  "aria-valuemax",
  "aria-valuemin",
  "aria-valuenow",
  "aria-valuetext",
  "className",
  "color",
  "height",
  "id",
  "lang",
  "max",
  "media",
  "method",
  "min",
  "name",
  "style",
  /*
   * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
   * that can use it and it conflicts with the recharts prop 'type'
   * https://github.com/recharts/recharts/pull/3327
   * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
   */
  // 'type',
  "target",
  "width",
  "role",
  "tabIndex",
  "accentHeight",
  "accumulate",
  "additive",
  "alignmentBaseline",
  "allowReorder",
  "alphabetic",
  "amplitude",
  "arabicForm",
  "ascent",
  "attributeName",
  "attributeType",
  "autoReverse",
  "azimuth",
  "baseFrequency",
  "baselineShift",
  "baseProfile",
  "bbox",
  "begin",
  "bias",
  "by",
  "calcMode",
  "capHeight",
  "clip",
  "clipPath",
  "clipPathUnits",
  "clipRule",
  "colorInterpolation",
  "colorInterpolationFilters",
  "colorProfile",
  "colorRendering",
  "contentScriptType",
  "contentStyleType",
  "cursor",
  "cx",
  "cy",
  "d",
  "decelerate",
  "descent",
  "diffuseConstant",
  "direction",
  "display",
  "divisor",
  "dominantBaseline",
  "dur",
  "dx",
  "dy",
  "edgeMode",
  "elevation",
  "enableBackground",
  "end",
  "exponent",
  "externalResourcesRequired",
  "fill",
  "fillOpacity",
  "fillRule",
  "filter",
  "filterRes",
  "filterUnits",
  "floodColor",
  "floodOpacity",
  "focusable",
  "fontFamily",
  "fontSize",
  "fontSizeAdjust",
  "fontStretch",
  "fontStyle",
  "fontVariant",
  "fontWeight",
  "format",
  "from",
  "fx",
  "fy",
  "g1",
  "g2",
  "glyphName",
  "glyphOrientationHorizontal",
  "glyphOrientationVertical",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "hanging",
  "horizAdvX",
  "horizOriginX",
  "href",
  "ideographic",
  "imageRendering",
  "in2",
  "in",
  "intercept",
  "k1",
  "k2",
  "k3",
  "k4",
  "k",
  "kernelMatrix",
  "kernelUnitLength",
  "kerning",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "letterSpacing",
  "lightingColor",
  "limitingConeAngle",
  "local",
  "markerEnd",
  "markerHeight",
  "markerMid",
  "markerStart",
  "markerUnits",
  "markerWidth",
  "mask",
  "maskContentUnits",
  "maskUnits",
  "mathematical",
  "mode",
  "numOctaves",
  "offset",
  "opacity",
  "operator",
  "order",
  "orient",
  "orientation",
  "origin",
  "overflow",
  "overlinePosition",
  "overlineThickness",
  "paintOrder",
  "panose1",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointerEvents",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "r",
  "radius",
  "refX",
  "refY",
  "renderingIntent",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "restart",
  "result",
  "rotate",
  "rx",
  "ry",
  "seed",
  "shapeRendering",
  "slope",
  "spacing",
  "specularConstant",
  "specularExponent",
  "speed",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stemh",
  "stemv",
  "stitchTiles",
  "stopColor",
  "stopOpacity",
  "strikethroughPosition",
  "strikethroughThickness",
  "string",
  "stroke",
  "strokeDasharray",
  "strokeDashoffset",
  "strokeLinecap",
  "strokeLinejoin",
  "strokeMiterlimit",
  "strokeOpacity",
  "strokeWidth",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textAnchor",
  "textDecoration",
  "textLength",
  "textRendering",
  "to",
  "transform",
  "u1",
  "u2",
  "underlinePosition",
  "underlineThickness",
  "unicode",
  "unicodeBidi",
  "unicodeRange",
  "unitsPerEm",
  "vAlphabetic",
  "values",
  "vectorEffect",
  "version",
  "vertAdvY",
  "vertOriginX",
  "vertOriginY",
  "vHanging",
  "vIdeographic",
  "viewTarget",
  "visibility",
  "vMathematical",
  "widths",
  "wordSpacing",
  "writingMode",
  "x1",
  "x2",
  "x",
  "xChannelSelector",
  "xHeight",
  "xlinkActuate",
  "xlinkArcrole",
  "xlinkHref",
  "xlinkRole",
  "xlinkShow",
  "xlinkTitle",
  "xlinkType",
  "xmlBase",
  "xmlLang",
  "xmlns",
  "xmlnsXlink",
  "xmlSpace",
  "y1",
  "y2",
  "y",
  "yChannelSelector",
  "z",
  "zoomAndPan",
  "ref",
  "key",
  "angle"
];
var PolyElementKeys = ["points", "pathLength"];
var FilteredElementKeyMap = {
  svg: SVGContainerPropKeys,
  polygon: PolyElementKeys,
  polyline: PolyElementKeys
};
var EventKeys = ["dangerouslySetInnerHTML", "onCopy", "onCopyCapture", "onCut", "onCutCapture", "onPaste", "onPasteCapture", "onCompositionEnd", "onCompositionEndCapture", "onCompositionStart", "onCompositionStartCapture", "onCompositionUpdate", "onCompositionUpdateCapture", "onFocus", "onFocusCapture", "onBlur", "onBlurCapture", "onChange", "onChangeCapture", "onBeforeInput", "onBeforeInputCapture", "onInput", "onInputCapture", "onReset", "onResetCapture", "onSubmit", "onSubmitCapture", "onInvalid", "onInvalidCapture", "onLoad", "onLoadCapture", "onError", "onErrorCapture", "onKeyDown", "onKeyDownCapture", "onKeyPress", "onKeyPressCapture", "onKeyUp", "onKeyUpCapture", "onAbort", "onAbortCapture", "onCanPlay", "onCanPlayCapture", "onCanPlayThrough", "onCanPlayThroughCapture", "onDurationChange", "onDurationChangeCapture", "onEmptied", "onEmptiedCapture", "onEncrypted", "onEncryptedCapture", "onEnded", "onEndedCapture", "onLoadedData", "onLoadedDataCapture", "onLoadedMetadata", "onLoadedMetadataCapture", "onLoadStart", "onLoadStartCapture", "onPause", "onPauseCapture", "onPlay", "onPlayCapture", "onPlaying", "onPlayingCapture", "onProgress", "onProgressCapture", "onRateChange", "onRateChangeCapture", "onSeeked", "onSeekedCapture", "onSeeking", "onSeekingCapture", "onStalled", "onStalledCapture", "onSuspend", "onSuspendCapture", "onTimeUpdate", "onTimeUpdateCapture", "onVolumeChange", "onVolumeChangeCapture", "onWaiting", "onWaitingCapture", "onAuxClick", "onAuxClickCapture", "onClick", "onClickCapture", "onContextMenu", "onContextMenuCapture", "onDoubleClick", "onDoubleClickCapture", "onDrag", "onDragCapture", "onDragEnd", "onDragEndCapture", "onDragEnter", "onDragEnterCapture", "onDragExit", "onDragExitCapture", "onDragLeave", "onDragLeaveCapture", "onDragOver", "onDragOverCapture", "onDragStart", "onDragStartCapture", "onDrop", "onDropCapture", "onMouseDown", "onMouseDownCapture", "onMouseEnter", "onMouseLeave", "onMouseMove", "onMouseMoveCapture", "onMouseOut", "onMouseOutCapture", "onMouseOver", "onMouseOverCapture", "onMouseUp", "onMouseUpCapture", "onSelect", "onSelectCapture", "onTouchCancel", "onTouchCancelCapture", "onTouchEnd", "onTouchEndCapture", "onTouchMove", "onTouchMoveCapture", "onTouchStart", "onTouchStartCapture", "onPointerDown", "onPointerDownCapture", "onPointerMove", "onPointerMoveCapture", "onPointerUp", "onPointerUpCapture", "onPointerCancel", "onPointerCancelCapture", "onPointerEnter", "onPointerEnterCapture", "onPointerLeave", "onPointerLeaveCapture", "onPointerOver", "onPointerOverCapture", "onPointerOut", "onPointerOutCapture", "onGotPointerCapture", "onGotPointerCaptureCapture", "onLostPointerCapture", "onLostPointerCaptureCapture", "onScroll", "onScrollCapture", "onWheel", "onWheelCapture", "onAnimationStart", "onAnimationStartCapture", "onAnimationEnd", "onAnimationEndCapture", "onAnimationIteration", "onAnimationIterationCapture", "onTransitionEnd", "onTransitionEndCapture"];
var adaptEventHandlers = function adaptEventHandlers2(props, newHandler) {
  if (!props || typeof props === "function" || typeof props === "boolean") {
    return null;
  }
  var inputProps = props;
  if (/* @__PURE__ */ isValidElement(props)) {
    inputProps = props.props;
  }
  if (!isObject(inputProps)) {
    return null;
  }
  var out = {};
  Object.keys(inputProps).forEach(function(key) {
    if (EventKeys.includes(key)) {
      out[key] = newHandler || function(e3) {
        return inputProps[key](inputProps, e3);
      };
    }
  });
  return out;
};
var getEventHandlerOfChild = function getEventHandlerOfChild2(originalHandler, data, index2) {
  return function(e3) {
    originalHandler(data, index2, e3);
    return null;
  };
};
var adaptEventsOfChild = function adaptEventsOfChild2(props, data, index2) {
  if (!isObject(props) || _typeof$N(props) !== "object") {
    return null;
  }
  var out = null;
  Object.keys(props).forEach(function(key) {
    var item = props[key];
    if (EventKeys.includes(key) && typeof item === "function") {
      if (!out) out = {};
      out[key] = getEventHandlerOfChild(item, data, index2);
    }
  });
  return out;
};
var _excluded$k = ["children"], _excluded2$8 = ["children"];
function _objectWithoutProperties$k(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$k(source, excluded);
  var key, i3;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i3 = 0; i3 < sourceSymbolKeys.length; i3++) {
      key = sourceSymbolKeys[i3];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$k(source, excluded) {
  if (source == null) return {};
  var target = {};
  for (var key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _typeof$M(o2) {
  "@babel/helpers - typeof";
  return _typeof$M = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof$M(o2);
}
var REACT_BROWSER_EVENT_MAP = {
  click: "onClick",
  mousedown: "onMouseDown",
  mouseup: "onMouseUp",
  mouseover: "onMouseOver",
  mousemove: "onMouseMove",
  mouseout: "onMouseOut",
  mouseenter: "onMouseEnter",
  mouseleave: "onMouseLeave",
  touchcancel: "onTouchCancel",
  touchend: "onTouchEnd",
  touchmove: "onTouchMove",
  touchstart: "onTouchStart",
  contextmenu: "onContextMenu",
  dblclick: "onDoubleClick"
};
var getDisplayName = function getDisplayName2(Comp) {
  if (typeof Comp === "string") {
    return Comp;
  }
  if (!Comp) {
    return "";
  }
  return Comp.displayName || Comp.name || "Component";
};
var lastChildren = null;
var lastResult = null;
var toArray = function toArray2(children) {
  if (children === lastChildren && Array.isArray(lastResult)) {
    return lastResult;
  }
  var result = [];
  Children.forEach(children, function(child) {
    if (isNil(child)) return;
    if (reactIsExports.isFragment(child)) {
      result = result.concat(toArray2(child.props.children));
    } else {
      result.push(child);
    }
  });
  lastResult = result;
  lastChildren = children;
  return result;
};
function findAllByType(children, type) {
  var result = [];
  var types2 = [];
  if (Array.isArray(type)) {
    types2 = type.map(function(t3) {
      return getDisplayName(t3);
    });
  } else {
    types2 = [getDisplayName(type)];
  }
  toArray(children).forEach(function(child) {
    var childType = get(child, "type.displayName") || get(child, "type.name");
    if (types2.indexOf(childType) !== -1) {
      result.push(child);
    }
  });
  return result;
}
function findChildByType(children, type) {
  var result = findAllByType(children, type);
  return result && result[0];
}
var validateWidthHeight = function validateWidthHeight2(el) {
  if (!el || !el.props) {
    return false;
  }
  var _el$props = el.props, width = _el$props.width, height = _el$props.height;
  if (!isNumber(width) || width <= 0 || !isNumber(height) || height <= 0) {
    return false;
  }
  return true;
};
var SVG_TAGS = ["a", "altGlyph", "altGlyphDef", "altGlyphItem", "animate", "animateColor", "animateMotion", "animateTransform", "circle", "clipPath", "color-profile", "cursor", "defs", "desc", "ellipse", "feBlend", "feColormatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "filter", "font", "font-face", "font-face-format", "font-face-name", "font-face-url", "foreignObject", "g", "glyph", "glyphRef", "hkern", "image", "line", "lineGradient", "marker", "mask", "metadata", "missing-glyph", "mpath", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "script", "set", "stop", "style", "svg", "switch", "symbol", "text", "textPath", "title", "tref", "tspan", "use", "view", "vkern"];
var isSvgElement = function isSvgElement2(child) {
  return child && child.type && isString(child.type) && SVG_TAGS.indexOf(child.type) >= 0;
};
var hasClipDot = function hasClipDot2(dot) {
  return dot && _typeof$M(dot) === "object" && "clipDot" in dot;
};
var isValidSpreadableProp = function isValidSpreadableProp2(property, key, includeEvents, svgElementType) {
  var _FilteredElementKeyMa;
  var matchingElementTypeKeys = (_FilteredElementKeyMa = FilteredElementKeyMap === null || FilteredElementKeyMap === void 0 ? void 0 : FilteredElementKeyMap[svgElementType]) !== null && _FilteredElementKeyMa !== void 0 ? _FilteredElementKeyMa : [];
  return !isFunction(property) && (svgElementType && matchingElementTypeKeys.includes(key) || SVGElementPropKeys.includes(key)) || includeEvents && EventKeys.includes(key);
};
var filterProps = function filterProps2(props, includeEvents, svgElementType) {
  if (!props || typeof props === "function" || typeof props === "boolean") {
    return null;
  }
  var inputProps = props;
  if (/* @__PURE__ */ isValidElement(props)) {
    inputProps = props.props;
  }
  if (!isObject(inputProps)) {
    return null;
  }
  var out = {};
  Object.keys(inputProps).forEach(function(key) {
    var _inputProps;
    if (isValidSpreadableProp((_inputProps = inputProps) === null || _inputProps === void 0 ? void 0 : _inputProps[key], key, includeEvents, svgElementType)) {
      out[key] = inputProps[key];
    }
  });
  return out;
};
var isChildrenEqual = function isChildrenEqual2(nextChildren, prevChildren) {
  if (nextChildren === prevChildren) {
    return true;
  }
  var count2 = Children.count(nextChildren);
  if (count2 !== Children.count(prevChildren)) {
    return false;
  }
  if (count2 === 0) {
    return true;
  }
  if (count2 === 1) {
    return isSingleChildEqual(Array.isArray(nextChildren) ? nextChildren[0] : nextChildren, Array.isArray(prevChildren) ? prevChildren[0] : prevChildren);
  }
  for (var i3 = 0; i3 < count2; i3++) {
    var nextChild = nextChildren[i3];
    var prevChild = prevChildren[i3];
    if (Array.isArray(nextChild) || Array.isArray(prevChild)) {
      if (!isChildrenEqual2(nextChild, prevChild)) {
        return false;
      }
    } else if (!isSingleChildEqual(nextChild, prevChild)) {
      return false;
    }
  }
  return true;
};
var isSingleChildEqual = function isSingleChildEqual2(nextChild, prevChild) {
  if (isNil(nextChild) && isNil(prevChild)) {
    return true;
  }
  if (!isNil(nextChild) && !isNil(prevChild)) {
    var _ref = nextChild.props || {}, nextChildren = _ref.children, nextProps = _objectWithoutProperties$k(_ref, _excluded$k);
    var _ref2 = prevChild.props || {}, prevChildren = _ref2.children, prevProps = _objectWithoutProperties$k(_ref2, _excluded2$8);
    if (nextChildren && prevChildren) {
      return shallowEqual(nextProps, prevProps) && isChildrenEqual(nextChildren, prevChildren);
    }
    if (!nextChildren && !prevChildren) {
      return shallowEqual(nextProps, prevProps);
    }
    return false;
  }
  return false;
};
var renderByOrder = function renderByOrder2(children, renderMap) {
  var elements = [];
  var record = {};
  toArray(children).forEach(function(child, index2) {
    if (isSvgElement(child)) {
      elements.push(child);
    } else if (child) {
      var displayName = getDisplayName(child.type);
      var _ref3 = renderMap[displayName] || {}, handler = _ref3.handler, once2 = _ref3.once;
      if (handler && (!once2 || !record[displayName])) {
        var results = handler(child, displayName, index2);
        elements.push(results);
        record[displayName] = true;
      }
    }
  });
  return elements;
};
var getReactEventByType = function getReactEventByType2(e3) {
  var type = e3 && e3.type;
  if (type && REACT_BROWSER_EVENT_MAP[type]) {
    return REACT_BROWSER_EVENT_MAP[type];
  }
  return null;
};
var parseChildIndex = function parseChildIndex2(child, children) {
  return toArray(children).indexOf(child);
};
var _excluded$j = ["children", "width", "height", "viewBox", "className", "style", "title", "desc"];
function _extends$v() {
  _extends$v = Object.assign ? Object.assign.bind() : function(target) {
    for (var i3 = 1; i3 < arguments.length; i3++) {
      var source = arguments[i3];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$v.apply(this, arguments);
}
function _objectWithoutProperties$j(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$j(source, excluded);
  var key, i3;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i3 = 0; i3 < sourceSymbolKeys.length; i3++) {
      key = sourceSymbolKeys[i3];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$j(source, excluded) {
  if (source == null) return {};
  var target = {};
  for (var key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function Surface(props) {
  var children = props.children, width = props.width, height = props.height, viewBox = props.viewBox, className = props.className, style = props.style, title = props.title, desc = props.desc, others = _objectWithoutProperties$j(props, _excluded$j);
  var svgView = viewBox || {
    width,
    height,
    x: 0,
    y: 0
  };
  var layerClass = clsx("recharts-surface", className);
  return /* @__PURE__ */ React__default.createElement("svg", _extends$v({}, filterProps(others, true, "svg"), {
    className: layerClass,
    width,
    height,
    style,
    viewBox: "".concat(svgView.x, " ").concat(svgView.y, " ").concat(svgView.width, " ").concat(svgView.height)
  }), /* @__PURE__ */ React__default.createElement("title", null, title), /* @__PURE__ */ React__default.createElement("desc", null, desc), children);
}
var _excluded$i = ["children", "className"];
function _extends$u() {
  _extends$u = Object.assign ? Object.assign.bind() : function(target) {
    for (var i3 = 1; i3 < arguments.length; i3++) {
      var source = arguments[i3];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$u.apply(this, arguments);
}
function _objectWithoutProperties$i(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$i(source, excluded);
  var key, i3;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i3 = 0; i3 < sourceSymbolKeys.length; i3++) {
      key = sourceSymbolKeys[i3];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$i(source, excluded) {
  if (source == null) return {};
  var target = {};
  for (var key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
  }
  return target;
}
var Layer = /* @__PURE__ */ React__default.forwardRef(function(props, ref) {
  var children = props.children, className = props.className, others = _objectWithoutProperties$i(props, _excluded$i);
  var layerClass = clsx("recharts-layer", className);
  return /* @__PURE__ */ React__default.createElement("g", _extends$u({
    className: layerClass
  }, filterProps(others, true), {
    ref
  }), children);
});
var isDev$1 = process.env.NODE_ENV !== "production";
var warn$1 = function warn(condition, format2) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }
  if (isDev$1 && typeof console !== "undefined" && console.warn) {
    if (format2 === void 0) {
      console.warn("LogUtils requires an error message argument");
    }
    if (!condition) {
      if (format2 === void 0) {
        console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
      } else {
        var argIndex = 0;
        console.warn(format2.replace(/%s/g, function() {
          return args[argIndex++];
        }));
      }
    }
  }
};
var _castSlice;
var hasRequired_castSlice;
function require_castSlice() {
  if (hasRequired_castSlice) return _castSlice;
  hasRequired_castSlice = 1;
  var baseSlice = require_baseSlice();
  function castSlice(array2, start, end) {
    var length = array2.length;
    end = end === void 0 ? length : end;
    return !start && end >= length ? array2 : baseSlice(array2, start, end);
  }
  _castSlice = castSlice;
  return _castSlice;
}
var _hasUnicode;
var hasRequired_hasUnicode;
function require_hasUnicode() {
  if (hasRequired_hasUnicode) return _hasUnicode;
  hasRequired_hasUnicode = 1;
  var rsAstralRange = "\\ud800-\\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsVarRange = "\\ufe0e\\ufe0f";
  var rsZWJ = "\\u200d";
  var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
  function hasUnicode(string2) {
    return reHasUnicode.test(string2);
  }
  _hasUnicode = hasUnicode;
  return _hasUnicode;
}
var _asciiToArray;
var hasRequired_asciiToArray;
function require_asciiToArray() {
  if (hasRequired_asciiToArray) return _asciiToArray;
  hasRequired_asciiToArray = 1;
  function asciiToArray(string2) {
    return string2.split("");
  }
  _asciiToArray = asciiToArray;
  return _asciiToArray;
}
var _unicodeToArray;
var hasRequired_unicodeToArray;
function require_unicodeToArray() {
  if (hasRequired_unicodeToArray) return _unicodeToArray;
  hasRequired_unicodeToArray = 1;
  var rsAstralRange = "\\ud800-\\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsVarRange = "\\ufe0e\\ufe0f";
  var rsAstral = "[" + rsAstralRange + "]", rsCombo = "[" + rsComboRange + "]", rsFitz = "\\ud83c[\\udffb-\\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}", rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]", rsZWJ = "\\u200d";
  var reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsSymbol = "(?:" + [rsNonAstral + rsCombo + "?", rsCombo, rsRegional, rsSurrPair, rsAstral].join("|") + ")";
  var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
  function unicodeToArray(string2) {
    return string2.match(reUnicode) || [];
  }
  _unicodeToArray = unicodeToArray;
  return _unicodeToArray;
}
var _stringToArray;
var hasRequired_stringToArray;
function require_stringToArray() {
  if (hasRequired_stringToArray) return _stringToArray;
  hasRequired_stringToArray = 1;
  var asciiToArray = require_asciiToArray(), hasUnicode = require_hasUnicode(), unicodeToArray = require_unicodeToArray();
  function stringToArray(string2) {
    return hasUnicode(string2) ? unicodeToArray(string2) : asciiToArray(string2);
  }
  _stringToArray = stringToArray;
  return _stringToArray;
}
var _createCaseFirst;
var hasRequired_createCaseFirst;
function require_createCaseFirst() {
  if (hasRequired_createCaseFirst) return _createCaseFirst;
  hasRequired_createCaseFirst = 1;
  var castSlice = require_castSlice(), hasUnicode = require_hasUnicode(), stringToArray = require_stringToArray(), toString2 = requireToString();
  function createCaseFirst(methodName) {
    return function(string2) {
      string2 = toString2(string2);
      var strSymbols = hasUnicode(string2) ? stringToArray(string2) : void 0;
      var chr = strSymbols ? strSymbols[0] : string2.charAt(0);
      var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string2.slice(1);
      return chr[methodName]() + trailing;
    };
  }
  _createCaseFirst = createCaseFirst;
  return _createCaseFirst;
}
var upperFirst_1;
var hasRequiredUpperFirst;
function requireUpperFirst() {
  if (hasRequiredUpperFirst) return upperFirst_1;
  hasRequiredUpperFirst = 1;
  var createCaseFirst = require_createCaseFirst();
  var upperFirst2 = createCaseFirst("toUpperCase");
  upperFirst_1 = upperFirst2;
  return upperFirst_1;
}
var upperFirstExports = requireUpperFirst();
const upperFirst = /* @__PURE__ */ getDefaultExportFromCjs(upperFirstExports);
function constant$1(x3) {
  return function constant2() {
    return x3;
  };
}
const cos = Math.cos;
const sin = Math.sin;
const sqrt$1 = Math.sqrt;
const pi$1 = Math.PI;
const tau$1 = 2 * pi$1;
const pi = Math.PI, tau = 2 * pi, epsilon = 1e-6, tauEpsilon = tau - epsilon;
function append(strings) {
  this._ += strings[0];
  for (let i3 = 1, n2 = strings.length; i3 < n2; ++i3) {
    this._ += arguments[i3] + strings[i3];
  }
}
function appendRound(digits) {
  let d4 = Math.floor(digits);
  if (!(d4 >= 0)) throw new Error(`invalid digits: ${digits}`);
  if (d4 > 15) return append;
  const k3 = 10 ** d4;
  return function(strings) {
    this._ += strings[0];
    for (let i3 = 1, n2 = strings.length; i3 < n2; ++i3) {
      this._ += Math.round(arguments[i3] * k3) / k3 + strings[i3];
    }
  };
}
class Path {
  constructor(digits) {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null;
    this._ = "";
    this._append = digits == null ? append : appendRound(digits);
  }
  moveTo(x3, y4) {
    this._append`M${this._x0 = this._x1 = +x3},${this._y0 = this._y1 = +y4}`;
  }
  closePath() {
    if (this._x1 !== null) {
      this._x1 = this._x0, this._y1 = this._y0;
      this._append`Z`;
    }
  }
  lineTo(x3, y4) {
    this._append`L${this._x1 = +x3},${this._y1 = +y4}`;
  }
  quadraticCurveTo(x1, y1, x3, y4) {
    this._append`Q${+x1},${+y1},${this._x1 = +x3},${this._y1 = +y4}`;
  }
  bezierCurveTo(x1, y1, x22, y22, x3, y4) {
    this._append`C${+x1},${+y1},${+x22},${+y22},${this._x1 = +x3},${this._y1 = +y4}`;
  }
  arcTo(x1, y1, x22, y22, r2) {
    x1 = +x1, y1 = +y1, x22 = +x22, y22 = +y22, r2 = +r2;
    if (r2 < 0) throw new Error(`negative radius: ${r2}`);
    let x0 = this._x1, y0 = this._y1, x21 = x22 - x1, y21 = y22 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
    if (this._x1 === null) {
      this._append`M${this._x1 = x1},${this._y1 = y1}`;
    } else if (!(l01_2 > epsilon)) ;
    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r2) {
      this._append`L${this._x1 = x1},${this._y1 = y1}`;
    } else {
      let x20 = x22 - x0, y20 = y22 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l2 = r2 * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l2 / l01, t21 = l2 / l21;
      if (Math.abs(t01 - 1) > epsilon) {
        this._append`L${x1 + t01 * x01},${y1 + t01 * y01}`;
      }
      this._append`A${r2},${r2},0,0,${+(y01 * x20 > x01 * y20)},${this._x1 = x1 + t21 * x21},${this._y1 = y1 + t21 * y21}`;
    }
  }
  arc(x3, y4, r2, a0, a1, ccw) {
    x3 = +x3, y4 = +y4, r2 = +r2, ccw = !!ccw;
    if (r2 < 0) throw new Error(`negative radius: ${r2}`);
    let dx = r2 * Math.cos(a0), dy = r2 * Math.sin(a0), x0 = x3 + dx, y0 = y4 + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
    if (this._x1 === null) {
      this._append`M${x0},${y0}`;
    } else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
      this._append`L${x0},${y0}`;
    }
    if (!r2) return;
    if (da < 0) da = da % tau + tau;
    if (da > tauEpsilon) {
      this._append`A${r2},${r2},0,1,${cw},${x3 - dx},${y4 - dy}A${r2},${r2},0,1,${cw},${this._x1 = x0},${this._y1 = y0}`;
    } else if (da > epsilon) {
      this._append`A${r2},${r2},0,${+(da >= pi)},${cw},${this._x1 = x3 + r2 * Math.cos(a1)},${this._y1 = y4 + r2 * Math.sin(a1)}`;
    }
  }
  rect(x3, y4, w3, h4) {
    this._append`M${this._x0 = this._x1 = +x3},${this._y0 = this._y1 = +y4}h${w3 = +w3}v${+h4}h${-w3}Z`;
  }
  toString() {
    return this._;
  }
}
function withPath(shape) {
  let digits = 3;
  shape.digits = function(_) {
    if (!arguments.length) return digits;
    if (_ == null) {
      digits = null;
    } else {
      const d4 = Math.floor(_);
      if (!(d4 >= 0)) throw new RangeError(`invalid digits: ${_}`);
      digits = d4;
    }
    return shape;
  };
  return () => new Path(digits);
}
function array(x3) {
  return typeof x3 === "object" && "length" in x3 ? x3 : Array.from(x3);
}
function Linear(context) {
  this._context = context;
}
Linear.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x3, y4) {
    x3 = +x3, y4 = +y4;
    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x3, y4) : this._context.moveTo(x3, y4);
        break;
      case 1:
        this._point = 2;
      // falls through
      default:
        this._context.lineTo(x3, y4);
        break;
    }
  }
};
function curveLinear(context) {
  return new Linear(context);
}
function x2(p2) {
  return p2[0];
}
function y3(p2) {
  return p2[1];
}
function shapeLine(x$12, y$12) {
  var defined3 = constant$1(true), context = null, curve = curveLinear, output = null, path = withPath(line);
  x$12 = typeof x$12 === "function" ? x$12 : x$12 === void 0 ? x2 : constant$1(x$12);
  y$12 = typeof y$12 === "function" ? y$12 : y$12 === void 0 ? y3 : constant$1(y$12);
  function line(data) {
    var i3, n2 = (data = array(data)).length, d4, defined0 = false, buffer;
    if (context == null) output = curve(buffer = path());
    for (i3 = 0; i3 <= n2; ++i3) {
      if (!(i3 < n2 && defined3(d4 = data[i3], i3, data)) === defined0) {
        if (defined0 = !defined0) output.lineStart();
        else output.lineEnd();
      }
      if (defined0) output.point(+x$12(d4, i3, data), +y$12(d4, i3, data));
    }
    if (buffer) return output = null, buffer + "" || null;
  }
  line.x = function(_) {
    return arguments.length ? (x$12 = typeof _ === "function" ? _ : constant$1(+_), line) : x$12;
  };
  line.y = function(_) {
    return arguments.length ? (y$12 = typeof _ === "function" ? _ : constant$1(+_), line) : y$12;
  };
  line.defined = function(_) {
    return arguments.length ? (defined3 = typeof _ === "function" ? _ : constant$1(!!_), line) : defined3;
  };
  line.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
  };
  line.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
  };
  return line;
}
function shapeArea(x0, y0, y1) {
  var x1 = null, defined3 = constant$1(true), context = null, curve = curveLinear, output = null, path = withPath(area);
  x0 = typeof x0 === "function" ? x0 : x0 === void 0 ? x2 : constant$1(+x0);
  y0 = typeof y0 === "function" ? y0 : y0 === void 0 ? constant$1(0) : constant$1(+y0);
  y1 = typeof y1 === "function" ? y1 : y1 === void 0 ? y3 : constant$1(+y1);
  function area(data) {
    var i3, j, k3, n2 = (data = array(data)).length, d4, defined0 = false, buffer, x0z = new Array(n2), y0z = new Array(n2);
    if (context == null) output = curve(buffer = path());
    for (i3 = 0; i3 <= n2; ++i3) {
      if (!(i3 < n2 && defined3(d4 = data[i3], i3, data)) === defined0) {
        if (defined0 = !defined0) {
          j = i3;
          output.areaStart();
          output.lineStart();
        } else {
          output.lineEnd();
          output.lineStart();
          for (k3 = i3 - 1; k3 >= j; --k3) {
            output.point(x0z[k3], y0z[k3]);
          }
          output.lineEnd();
          output.areaEnd();
        }
      }
      if (defined0) {
        x0z[i3] = +x0(d4, i3, data), y0z[i3] = +y0(d4, i3, data);
        output.point(x1 ? +x1(d4, i3, data) : x0z[i3], y1 ? +y1(d4, i3, data) : y0z[i3]);
      }
    }
    if (buffer) return output = null, buffer + "" || null;
  }
  function arealine() {
    return shapeLine().defined(defined3).curve(curve).context(context);
  }
  area.x = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant$1(+_), x1 = null, area) : x0;
  };
  area.x0 = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant$1(+_), area) : x0;
  };
  area.x1 = function(_) {
    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : constant$1(+_), area) : x1;
  };
  area.y = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant$1(+_), y1 = null, area) : y0;
  };
  area.y0 = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant$1(+_), area) : y0;
  };
  area.y1 = function(_) {
    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : constant$1(+_), area) : y1;
  };
  area.lineX0 = area.lineY0 = function() {
    return arealine().x(x0).y(y0);
  };
  area.lineY1 = function() {
    return arealine().x(x0).y(y1);
  };
  area.lineX1 = function() {
    return arealine().x(x1).y(y0);
  };
  area.defined = function(_) {
    return arguments.length ? (defined3 = typeof _ === "function" ? _ : constant$1(!!_), area) : defined3;
  };
  area.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
  };
  area.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
  };
  return area;
}
class Bump {
  constructor(context, x3) {
    this._context = context;
    this._x = x3;
  }
  areaStart() {
    this._line = 0;
  }
  areaEnd() {
    this._line = NaN;
  }
  lineStart() {
    this._point = 0;
  }
  lineEnd() {
    if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
    this._line = 1 - this._line;
  }
  point(x3, y4) {
    x3 = +x3, y4 = +y4;
    switch (this._point) {
      case 0: {
        this._point = 1;
        if (this._line) this._context.lineTo(x3, y4);
        else this._context.moveTo(x3, y4);
        break;
      }
      case 1:
        this._point = 2;
      // falls through
      default: {
        if (this._x) this._context.bezierCurveTo(this._x0 = (this._x0 + x3) / 2, this._y0, this._x0, y4, x3, y4);
        else this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + y4) / 2, x3, this._y0, x3, y4);
        break;
      }
    }
    this._x0 = x3, this._y0 = y4;
  }
}
function bumpX(context) {
  return new Bump(context, true);
}
function bumpY(context) {
  return new Bump(context, false);
}
const symbolCircle = {
  draw(context, size2) {
    const r2 = sqrt$1(size2 / pi$1);
    context.moveTo(r2, 0);
    context.arc(0, 0, r2, 0, tau$1);
  }
};
const symbolCross = {
  draw(context, size2) {
    const r2 = sqrt$1(size2 / 5) / 2;
    context.moveTo(-3 * r2, -r2);
    context.lineTo(-r2, -r2);
    context.lineTo(-r2, -3 * r2);
    context.lineTo(r2, -3 * r2);
    context.lineTo(r2, -r2);
    context.lineTo(3 * r2, -r2);
    context.lineTo(3 * r2, r2);
    context.lineTo(r2, r2);
    context.lineTo(r2, 3 * r2);
    context.lineTo(-r2, 3 * r2);
    context.lineTo(-r2, r2);
    context.lineTo(-3 * r2, r2);
    context.closePath();
  }
};
const tan30 = sqrt$1(1 / 3);
const tan30_2 = tan30 * 2;
const symbolDiamond = {
  draw(context, size2) {
    const y4 = sqrt$1(size2 / tan30_2);
    const x3 = y4 * tan30;
    context.moveTo(0, -y4);
    context.lineTo(x3, 0);
    context.lineTo(0, y4);
    context.lineTo(-x3, 0);
    context.closePath();
  }
};
const symbolSquare = {
  draw(context, size2) {
    const w3 = sqrt$1(size2);
    const x3 = -w3 / 2;
    context.rect(x3, x3, w3, w3);
  }
};
const ka = 0.8908130915292852;
const kr = sin(pi$1 / 10) / sin(7 * pi$1 / 10);
const kx = sin(tau$1 / 10) * kr;
const ky = -cos(tau$1 / 10) * kr;
const symbolStar = {
  draw(context, size2) {
    const r2 = sqrt$1(size2 * ka);
    const x3 = kx * r2;
    const y4 = ky * r2;
    context.moveTo(0, -r2);
    context.lineTo(x3, y4);
    for (let i3 = 1; i3 < 5; ++i3) {
      const a4 = tau$1 * i3 / 5;
      const c3 = cos(a4);
      const s4 = sin(a4);
      context.lineTo(s4 * r2, -c3 * r2);
      context.lineTo(c3 * x3 - s4 * y4, s4 * x3 + c3 * y4);
    }
    context.closePath();
  }
};
const sqrt3 = sqrt$1(3);
const symbolTriangle = {
  draw(context, size2) {
    const y4 = -sqrt$1(size2 / (sqrt3 * 3));
    context.moveTo(0, y4 * 2);
    context.lineTo(-sqrt3 * y4, -y4);
    context.lineTo(sqrt3 * y4, -y4);
    context.closePath();
  }
};
const c2 = -0.5;
const s3 = sqrt$1(3) / 2;
const k2 = 1 / sqrt$1(12);
const a3 = (k2 / 2 + 1) * 3;
const symbolWye = {
  draw(context, size2) {
    const r2 = sqrt$1(size2 / a3);
    const x0 = r2 / 2, y0 = r2 * k2;
    const x1 = x0, y1 = r2 * k2 + r2;
    const x22 = -x1, y22 = y1;
    context.moveTo(x0, y0);
    context.lineTo(x1, y1);
    context.lineTo(x22, y22);
    context.lineTo(c2 * x0 - s3 * y0, s3 * x0 + c2 * y0);
    context.lineTo(c2 * x1 - s3 * y1, s3 * x1 + c2 * y1);
    context.lineTo(c2 * x22 - s3 * y22, s3 * x22 + c2 * y22);
    context.lineTo(c2 * x0 + s3 * y0, c2 * y0 - s3 * x0);
    context.lineTo(c2 * x1 + s3 * y1, c2 * y1 - s3 * x1);
    context.lineTo(c2 * x22 + s3 * y22, c2 * y22 - s3 * x22);
    context.closePath();
  }
};
function Symbol$1(type, size2) {
  let context = null, path = withPath(symbol);
  type = typeof type === "function" ? type : constant$1(type || symbolCircle);
  size2 = typeof size2 === "function" ? size2 : constant$1(size2 === void 0 ? 64 : +size2);
  function symbol() {
    let buffer;
    if (!context) context = buffer = path();
    type.apply(this, arguments).draw(context, +size2.apply(this, arguments));
    if (buffer) return context = null, buffer + "" || null;
  }
  symbol.type = function(_) {
    return arguments.length ? (type = typeof _ === "function" ? _ : constant$1(_), symbol) : type;
  };
  symbol.size = function(_) {
    return arguments.length ? (size2 = typeof _ === "function" ? _ : constant$1(+_), symbol) : size2;
  };
  symbol.context = function(_) {
    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
  };
  return symbol;
}
function noop() {
}
function point$2(that, x3, y4) {
  that._context.bezierCurveTo(
    (2 * that._x0 + that._x1) / 3,
    (2 * that._y0 + that._y1) / 3,
    (that._x0 + 2 * that._x1) / 3,
    (that._y0 + 2 * that._y1) / 3,
    (that._x0 + 4 * that._x1 + x3) / 6,
    (that._y0 + 4 * that._y1 + y4) / 6
  );
}
function Basis(context) {
  this._context = context;
}
Basis.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3:
        point$2(this, this._x1, this._y1);
      // falls through
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
    }
    if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x3, y4) {
    x3 = +x3, y4 = +y4;
    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x3, y4) : this._context.moveTo(x3, y4);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
      // falls through
      default:
        point$2(this, x3, y4);
        break;
    }
    this._x0 = this._x1, this._x1 = x3;
    this._y0 = this._y1, this._y1 = y4;
  }
};
function curveBasis(context) {
  return new Basis(context);
}
function BasisClosed(context) {
  this._context = context;
}
BasisClosed.prototype = {
  areaStart: noop,
  areaEnd: noop,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2);
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(x3, y4) {
    x3 = +x3, y4 = +y4;
    switch (this._point) {
      case 0:
        this._point = 1;
        this._x2 = x3, this._y2 = y4;
        break;
      case 1:
        this._point = 2;
        this._x3 = x3, this._y3 = y4;
        break;
      case 2:
        this._point = 3;
        this._x4 = x3, this._y4 = y4;
        this._context.moveTo((this._x0 + 4 * this._x1 + x3) / 6, (this._y0 + 4 * this._y1 + y4) / 6);
        break;
      default:
        point$2(this, x3, y4);
        break;
    }
    this._x0 = this._x1, this._x1 = x3;
    this._y0 = this._y1, this._y1 = y4;
  }
};
function curveBasisClosed(context) {
  return new BasisClosed(context);
}
function BasisOpen(context) {
  this._context = context;
}
BasisOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x3, y4) {
    x3 = +x3, y4 = +y4;
    switch (this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        var x0 = (this._x0 + 4 * this._x1 + x3) / 6, y0 = (this._y0 + 4 * this._y1 + y4) / 6;
        this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
        break;
      case 3:
        this._point = 4;
      // falls through
      default:
        point$2(this, x3, y4);
        break;
    }
    this._x0 = this._x1, this._x1 = x3;
    this._y0 = this._y1, this._y1 = y4;
  }
};
function curveBasisOpen(context) {
  return new BasisOpen(context);
}
function LinearClosed(context) {
  this._context = context;
}
LinearClosed.prototype = {
  areaStart: noop,
  areaEnd: noop,
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._point) this._context.closePath();
  },
  point: function(x3, y4) {
    x3 = +x3, y4 = +y4;
    if (this._point) this._context.lineTo(x3, y4);
    else this._point = 1, this._context.moveTo(x3, y4);
  }
};
function curveLinearClosed(context) {
  return new LinearClosed(context);
}
function sign(x3) {
  return x3 < 0 ? -1 : 1;
}
function slope3(that, x22, y22) {
  var h0 = that._x1 - that._x0, h1 = x22 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y22 - that._y1) / (h1 || h0 < 0 && -0), p2 = (s0 * h1 + s1 * h0) / (h0 + h1);
  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p2)) || 0;
}
function slope2(that, t3) {
  var h4 = that._x1 - that._x0;
  return h4 ? (3 * (that._y1 - that._y0) / h4 - t3) / 2 : t3;
}
function point$1(that, t02, t12) {
  var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
  that._context.bezierCurveTo(x0 + dx, y0 + dx * t02, x1 - dx, y1 - dx * t12, x1, y1);
}
function MonotoneX(context) {
  this._context = context;
}
MonotoneX.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
      case 3:
        point$1(this, this._t0, slope2(this, this._t0));
        break;
    }
    if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x3, y4) {
    var t12 = NaN;
    x3 = +x3, y4 = +y4;
    if (x3 === this._x1 && y4 === this._y1) return;
    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x3, y4) : this._context.moveTo(x3, y4);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        point$1(this, slope2(this, t12 = slope3(this, x3, y4)), t12);
        break;
      default:
        point$1(this, this._t0, t12 = slope3(this, x3, y4));
        break;
    }
    this._x0 = this._x1, this._x1 = x3;
    this._y0 = this._y1, this._y1 = y4;
    this._t0 = t12;
  }
};
function MonotoneY(context) {
  this._context = new ReflectContext(context);
}
(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x3, y4) {
  MonotoneX.prototype.point.call(this, y4, x3);
};
function ReflectContext(context) {
  this._context = context;
}
ReflectContext.prototype = {
  moveTo: function(x3, y4) {
    this._context.moveTo(y4, x3);
  },
  closePath: function() {
    this._context.closePath();
  },
  lineTo: function(x3, y4) {
    this._context.lineTo(y4, x3);
  },
  bezierCurveTo: function(x1, y1, x22, y22, x3, y4) {
    this._context.bezierCurveTo(y1, x1, y22, x22, y4, x3);
  }
};
function monotoneX(context) {
  return new MonotoneX(context);
}
function monotoneY(context) {
  return new MonotoneY(context);
}
function Natural(context) {
  this._context = context;
}
Natural.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [];
    this._y = [];
  },
  lineEnd: function() {
    var x3 = this._x, y4 = this._y, n2 = x3.length;
    if (n2) {
      this._line ? this._context.lineTo(x3[0], y4[0]) : this._context.moveTo(x3[0], y4[0]);
      if (n2 === 2) {
        this._context.lineTo(x3[1], y4[1]);
      } else {
        var px2 = controlPoints(x3), py = controlPoints(y4);
        for (var i0 = 0, i1 = 1; i1 < n2; ++i0, ++i1) {
          this._context.bezierCurveTo(px2[0][i0], py[0][i0], px2[1][i0], py[1][i0], x3[i1], y4[i1]);
        }
      }
    }
    if (this._line || this._line !== 0 && n2 === 1) this._context.closePath();
    this._line = 1 - this._line;
    this._x = this._y = null;
  },
  point: function(x3, y4) {
    this._x.push(+x3);
    this._y.push(+y4);
  }
};
function controlPoints(x3) {
  var i3, n2 = x3.length - 1, m4, a4 = new Array(n2), b3 = new Array(n2), r2 = new Array(n2);
  a4[0] = 0, b3[0] = 2, r2[0] = x3[0] + 2 * x3[1];
  for (i3 = 1; i3 < n2 - 1; ++i3) a4[i3] = 1, b3[i3] = 4, r2[i3] = 4 * x3[i3] + 2 * x3[i3 + 1];
  a4[n2 - 1] = 2, b3[n2 - 1] = 7, r2[n2 - 1] = 8 * x3[n2 - 1] + x3[n2];
  for (i3 = 1; i3 < n2; ++i3) m4 = a4[i3] / b3[i3 - 1], b3[i3] -= m4, r2[i3] -= m4 * r2[i3 - 1];
  a4[n2 - 1] = r2[n2 - 1] / b3[n2 - 1];
  for (i3 = n2 - 2; i3 >= 0; --i3) a4[i3] = (r2[i3] - a4[i3 + 1]) / b3[i3];
  b3[n2 - 1] = (x3[n2] + a4[n2 - 1]) / 2;
  for (i3 = 0; i3 < n2 - 1; ++i3) b3[i3] = 2 * x3[i3 + 1] - a4[i3 + 1];
  return [a4, b3];
}
function curveNatural(context) {
  return new Natural(context);
}
function Step(context, t3) {
  this._context = context;
  this._t = t3;
}
Step.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
    if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
  },
  point: function(x3, y4) {
    x3 = +x3, y4 = +y4;
    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x3, y4) : this._context.moveTo(x3, y4);
        break;
      case 1:
        this._point = 2;
      // falls through
      default: {
        if (this._t <= 0) {
          this._context.lineTo(this._x, y4);
          this._context.lineTo(x3, y4);
        } else {
          var x1 = this._x * (1 - this._t) + x3 * this._t;
          this._context.lineTo(x1, this._y);
          this._context.lineTo(x1, y4);
        }
        break;
      }
    }
    this._x = x3, this._y = y4;
  }
};
function curveStep(context) {
  return new Step(context, 0.5);
}
function stepBefore(context) {
  return new Step(context, 0);
}
function stepAfter(context) {
  return new Step(context, 1);
}
function stackOffsetNone(series, order2) {
  if (!((n2 = series.length) > 1)) return;
  for (var i3 = 1, j, s0, s1 = series[order2[0]], n2, m4 = s1.length; i3 < n2; ++i3) {
    s0 = s1, s1 = series[order2[i3]];
    for (j = 0; j < m4; ++j) {
      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
  }
}
function stackOrderNone(series) {
  var n2 = series.length, o2 = new Array(n2);
  while (--n2 >= 0) o2[n2] = n2;
  return o2;
}
function stackValue(d4, key) {
  return d4[key];
}
function stackSeries(key) {
  const series = [];
  series.key = key;
  return series;
}
function shapeStack() {
  var keys2 = constant$1([]), order2 = stackOrderNone, offset2 = stackOffsetNone, value = stackValue;
  function stack(data) {
    var sz = Array.from(keys2.apply(this, arguments), stackSeries), i3, n2 = sz.length, j = -1, oz;
    for (const d4 of data) {
      for (i3 = 0, ++j; i3 < n2; ++i3) {
        (sz[i3][j] = [0, +value(d4, sz[i3].key, j, data)]).data = d4;
      }
    }
    for (i3 = 0, oz = array(order2(sz)); i3 < n2; ++i3) {
      sz[oz[i3]].index = i3;
    }
    offset2(sz, oz);
    return sz;
  }
  stack.keys = function(_) {
    return arguments.length ? (keys2 = typeof _ === "function" ? _ : constant$1(Array.from(_)), stack) : keys2;
  };
  stack.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : constant$1(+_), stack) : value;
  };
  stack.order = function(_) {
    return arguments.length ? (order2 = _ == null ? stackOrderNone : typeof _ === "function" ? _ : constant$1(Array.from(_)), stack) : order2;
  };
  stack.offset = function(_) {
    return arguments.length ? (offset2 = _ == null ? stackOffsetNone : _, stack) : offset2;
  };
  return stack;
}
function stackOffsetExpand(series, order2) {
  if (!((n2 = series.length) > 0)) return;
  for (var i3, n2, j = 0, m4 = series[0].length, y4; j < m4; ++j) {
    for (y4 = i3 = 0; i3 < n2; ++i3) y4 += series[i3][j][1] || 0;
    if (y4) for (i3 = 0; i3 < n2; ++i3) series[i3][j][1] /= y4;
  }
  stackOffsetNone(series, order2);
}
function stackOffsetSilhouette(series, order2) {
  if (!((n2 = series.length) > 0)) return;
  for (var j = 0, s0 = series[order2[0]], n2, m4 = s0.length; j < m4; ++j) {
    for (var i3 = 0, y4 = 0; i3 < n2; ++i3) y4 += series[i3][j][1] || 0;
    s0[j][1] += s0[j][0] = -y4 / 2;
  }
  stackOffsetNone(series, order2);
}
function stackOffsetWiggle(series, order2) {
  if (!((n2 = series.length) > 0) || !((m4 = (s0 = series[order2[0]]).length) > 0)) return;
  for (var y4 = 0, j = 1, s0, m4, n2; j < m4; ++j) {
    for (var i3 = 0, s1 = 0, s22 = 0; i3 < n2; ++i3) {
      var si = series[order2[i3]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s32 = (sij0 - sij1) / 2;
      for (var k3 = 0; k3 < i3; ++k3) {
        var sk = series[order2[k3]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
        s32 += skj0 - skj1;
      }
      s1 += sij0, s22 += s32 * sij0;
    }
    s0[j - 1][1] += s0[j - 1][0] = y4;
    if (s1) y4 -= s22 / s1;
  }
  s0[j - 1][1] += s0[j - 1][0] = y4;
  stackOffsetNone(series, order2);
}
function _typeof$L(o2) {
  "@babel/helpers - typeof";
  return _typeof$L = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof$L(o2);
}
var _excluded$h = ["type", "size", "sizeType"];
function _extends$t() {
  _extends$t = Object.assign ? Object.assign.bind() : function(target) {
    for (var i3 = 1; i3 < arguments.length; i3++) {
      var source = arguments[i3];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$t.apply(this, arguments);
}
function ownKeys$D(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e3);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$D(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$D(Object(t3), true).forEach(function(r3) {
      _defineProperty$I(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$D(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
function _defineProperty$I(obj, key, value) {
  key = _toPropertyKey$J(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$J(t3) {
  var i3 = _toPrimitive$J(t3, "string");
  return "symbol" == _typeof$L(i3) ? i3 : i3 + "";
}
function _toPrimitive$J(t3, r2) {
  if ("object" != _typeof$L(t3) || !t3) return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i3 = e3.call(t3, r2);
    if ("object" != _typeof$L(i3)) return i3;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t3);
}
function _objectWithoutProperties$h(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$h(source, excluded);
  var key, i3;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i3 = 0; i3 < sourceSymbolKeys.length; i3++) {
      key = sourceSymbolKeys[i3];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$h(source, excluded) {
  if (source == null) return {};
  var target = {};
  for (var key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
  }
  return target;
}
var symbolFactories = {
  symbolCircle,
  symbolCross,
  symbolDiamond,
  symbolSquare,
  symbolStar,
  symbolTriangle,
  symbolWye
};
var RADIAN$3 = Math.PI / 180;
var getSymbolFactory = function getSymbolFactory2(type) {
  var name = "symbol".concat(upperFirst(type));
  return symbolFactories[name] || symbolCircle;
};
var calculateAreaSize = function calculateAreaSize2(size2, sizeType, type) {
  if (sizeType === "area") {
    return size2;
  }
  switch (type) {
    case "cross":
      return 5 * size2 * size2 / 9;
    case "diamond":
      return 0.5 * size2 * size2 / Math.sqrt(3);
    case "square":
      return size2 * size2;
    case "star": {
      var angle = 18 * RADIAN$3;
      return 1.25 * size2 * size2 * (Math.tan(angle) - Math.tan(angle * 2) * Math.pow(Math.tan(angle), 2));
    }
    case "triangle":
      return Math.sqrt(3) * size2 * size2 / 4;
    case "wye":
      return (21 - 10 * Math.sqrt(3)) * size2 * size2 / 8;
    default:
      return Math.PI * size2 * size2 / 4;
  }
};
var registerSymbol = function registerSymbol2(key, factory) {
  symbolFactories["symbol".concat(upperFirst(key))] = factory;
};
var Symbols = function Symbols2(_ref) {
  var _ref$type = _ref.type, type = _ref$type === void 0 ? "circle" : _ref$type, _ref$size = _ref.size, size2 = _ref$size === void 0 ? 64 : _ref$size, _ref$sizeType = _ref.sizeType, sizeType = _ref$sizeType === void 0 ? "area" : _ref$sizeType, rest = _objectWithoutProperties$h(_ref, _excluded$h);
  var props = _objectSpread$D(_objectSpread$D({}, rest), {}, {
    type,
    size: size2,
    sizeType
  });
  var getPath4 = function getPath5() {
    var symbolFactory = getSymbolFactory(type);
    var symbol = Symbol$1().type(symbolFactory).size(calculateAreaSize(size2, sizeType, type));
    return symbol();
  };
  var className = props.className, cx = props.cx, cy = props.cy;
  var filteredProps = filterProps(props, true);
  if (cx === +cx && cy === +cy && size2 === +size2) {
    return /* @__PURE__ */ React__default.createElement("path", _extends$t({}, filteredProps, {
      className: clsx("recharts-symbols", className),
      transform: "translate(".concat(cx, ", ").concat(cy, ")"),
      d: getPath4()
    }));
  }
  return null;
};
Symbols.registerSymbol = registerSymbol;
function _typeof$K(o2) {
  "@babel/helpers - typeof";
  return _typeof$K = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof$K(o2);
}
function _extends$s() {
  _extends$s = Object.assign ? Object.assign.bind() : function(target) {
    for (var i3 = 1; i3 < arguments.length; i3++) {
      var source = arguments[i3];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$s.apply(this, arguments);
}
function ownKeys$C(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e3);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$C(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$C(Object(t3), true).forEach(function(r3) {
      _defineProperty$H(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$C(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
function _classCallCheck$m(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$m(target, props) {
  for (var i3 = 0; i3 < props.length; i3++) {
    var descriptor = props[i3];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$I(descriptor.key), descriptor);
  }
}
function _createClass$m(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$m(Constructor.prototype, protoProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _callSuper$i(t3, o2, e3) {
  return o2 = _getPrototypeOf$j(o2), _possibleConstructorReturn$j(t3, _isNativeReflectConstruct$j() ? Reflect.construct(o2, e3 || [], _getPrototypeOf$j(t3).constructor) : o2.apply(t3, e3));
}
function _possibleConstructorReturn$j(self2, call) {
  if (call && (_typeof$K(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$j(self2);
}
function _assertThisInitialized$j(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$j() {
  try {
    var t3 = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$j = function _isNativeReflectConstruct2() {
    return !!t3;
  })();
}
function _getPrototypeOf$j(o2) {
  _getPrototypeOf$j = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o3) {
    return o3.__proto__ || Object.getPrototypeOf(o3);
  };
  return _getPrototypeOf$j(o2);
}
function _inherits$j(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass) _setPrototypeOf$j(subClass, superClass);
}
function _setPrototypeOf$j(o2, p2) {
  _setPrototypeOf$j = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o3, p3) {
    o3.__proto__ = p3;
    return o3;
  };
  return _setPrototypeOf$j(o2, p2);
}
function _defineProperty$H(obj, key, value) {
  key = _toPropertyKey$I(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$I(t3) {
  var i3 = _toPrimitive$I(t3, "string");
  return "symbol" == _typeof$K(i3) ? i3 : i3 + "";
}
function _toPrimitive$I(t3, r2) {
  if ("object" != _typeof$K(t3) || !t3) return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i3 = e3.call(t3, r2);
    if ("object" != _typeof$K(i3)) return i3;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t3);
}
var SIZE = 32;
var DefaultLegendContent = /* @__PURE__ */ function(_PureComponent) {
  function DefaultLegendContent2() {
    _classCallCheck$m(this, DefaultLegendContent2);
    return _callSuper$i(this, DefaultLegendContent2, arguments);
  }
  _inherits$j(DefaultLegendContent2, _PureComponent);
  return _createClass$m(DefaultLegendContent2, [{
    key: "renderIcon",
    value: (
      /**
       * Render the path of icon
       * @param {Object} data Data of each legend item
       * @return {String} Path element
       */
      function renderIcon(data) {
        var inactiveColor = this.props.inactiveColor;
        var halfSize = SIZE / 2;
        var sixthSize = SIZE / 6;
        var thirdSize = SIZE / 3;
        var color2 = data.inactive ? inactiveColor : data.color;
        if (data.type === "plainline") {
          return /* @__PURE__ */ React__default.createElement("line", {
            strokeWidth: 4,
            fill: "none",
            stroke: color2,
            strokeDasharray: data.payload.strokeDasharray,
            x1: 0,
            y1: halfSize,
            x2: SIZE,
            y2: halfSize,
            className: "recharts-legend-icon"
          });
        }
        if (data.type === "line") {
          return /* @__PURE__ */ React__default.createElement("path", {
            strokeWidth: 4,
            fill: "none",
            stroke: color2,
            d: "M0,".concat(halfSize, "h").concat(thirdSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(2 * thirdSize, ",").concat(halfSize, "\n            H").concat(SIZE, "M").concat(2 * thirdSize, ",").concat(halfSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(thirdSize, ",").concat(halfSize),
            className: "recharts-legend-icon"
          });
        }
        if (data.type === "rect") {
          return /* @__PURE__ */ React__default.createElement("path", {
            stroke: "none",
            fill: color2,
            d: "M0,".concat(SIZE / 8, "h").concat(SIZE, "v").concat(SIZE * 3 / 4, "h").concat(-32, "z"),
            className: "recharts-legend-icon"
          });
        }
        if (/* @__PURE__ */ React__default.isValidElement(data.legendIcon)) {
          var iconProps = _objectSpread$C({}, data);
          delete iconProps.legendIcon;
          return /* @__PURE__ */ React__default.cloneElement(data.legendIcon, iconProps);
        }
        return /* @__PURE__ */ React__default.createElement(Symbols, {
          fill: color2,
          cx: halfSize,
          cy: halfSize,
          size: SIZE,
          sizeType: "diameter",
          type: data.type
        });
      }
    )
    /**
     * Draw items of legend
     * @return {ReactElement} Items
     */
  }, {
    key: "renderItems",
    value: function renderItems() {
      var _this = this;
      var _this$props = this.props, payload = _this$props.payload, iconSize = _this$props.iconSize, layout = _this$props.layout, formatter = _this$props.formatter, inactiveColor = _this$props.inactiveColor;
      var viewBox = {
        x: 0,
        y: 0,
        width: SIZE,
        height: SIZE
      };
      var itemStyle = {
        display: layout === "horizontal" ? "inline-block" : "block",
        marginRight: 10
      };
      var svgStyle = {
        display: "inline-block",
        verticalAlign: "middle",
        marginRight: 4
      };
      return payload.map(function(entry, i3) {
        var finalFormatter = entry.formatter || formatter;
        var className = clsx(_defineProperty$H(_defineProperty$H({
          "recharts-legend-item": true
        }, "legend-item-".concat(i3), true), "inactive", entry.inactive));
        if (entry.type === "none") {
          return null;
        }
        var entryValue = !isFunction(entry.value) ? entry.value : null;
        warn$1(
          !isFunction(entry.value),
          `The name property is also required when using a function for the dataKey of a chart's cartesian components. Ex: <Bar name="Name of my Data"/>`
          // eslint-disable-line max-len
        );
        var color2 = entry.inactive ? inactiveColor : entry.color;
        return /* @__PURE__ */ React__default.createElement("li", _extends$s({
          className,
          style: itemStyle,
          key: "legend-item-".concat(i3)
        }, adaptEventsOfChild(_this.props, entry, i3)), /* @__PURE__ */ React__default.createElement(Surface, {
          width: iconSize,
          height: iconSize,
          viewBox,
          style: svgStyle
        }, _this.renderIcon(entry)), /* @__PURE__ */ React__default.createElement("span", {
          className: "recharts-legend-item-text",
          style: {
            color: color2
          }
        }, finalFormatter ? finalFormatter(entryValue, entry, i3) : entryValue));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props, payload = _this$props2.payload, layout = _this$props2.layout, align = _this$props2.align;
      if (!payload || !payload.length) {
        return null;
      }
      var finalStyle = {
        padding: 0,
        margin: 0,
        textAlign: layout === "horizontal" ? align : "left"
      };
      return /* @__PURE__ */ React__default.createElement("ul", {
        className: "recharts-default-legend",
        style: finalStyle
      }, this.renderItems());
    }
  }]);
}(PureComponent);
_defineProperty$H(DefaultLegendContent, "displayName", "Legend");
_defineProperty$H(DefaultLegendContent, "defaultProps", {
  iconSize: 14,
  layout: "horizontal",
  align: "center",
  verticalAlign: "middle",
  inactiveColor: "#ccc"
});
var _setCacheAdd;
var hasRequired_setCacheAdd;
function require_setCacheAdd() {
  if (hasRequired_setCacheAdd) return _setCacheAdd;
  hasRequired_setCacheAdd = 1;
  var HASH_UNDEFINED = "__lodash_hash_undefined__";
  function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
  }
  _setCacheAdd = setCacheAdd;
  return _setCacheAdd;
}
var _setCacheHas;
var hasRequired_setCacheHas;
function require_setCacheHas() {
  if (hasRequired_setCacheHas) return _setCacheHas;
  hasRequired_setCacheHas = 1;
  function setCacheHas(value) {
    return this.__data__.has(value);
  }
  _setCacheHas = setCacheHas;
  return _setCacheHas;
}
var _SetCache;
var hasRequired_SetCache;
function require_SetCache() {
  if (hasRequired_SetCache) return _SetCache;
  hasRequired_SetCache = 1;
  var MapCache = require_MapCache(), setCacheAdd = require_setCacheAdd(), setCacheHas = require_setCacheHas();
  function SetCache(values) {
    var index2 = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache();
    while (++index2 < length) {
      this.add(values[index2]);
    }
  }
  SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
  SetCache.prototype.has = setCacheHas;
  _SetCache = SetCache;
  return _SetCache;
}
var _arraySome;
var hasRequired_arraySome;
function require_arraySome() {
  if (hasRequired_arraySome) return _arraySome;
  hasRequired_arraySome = 1;
  function arraySome(array2, predicate) {
    var index2 = -1, length = array2 == null ? 0 : array2.length;
    while (++index2 < length) {
      if (predicate(array2[index2], index2, array2)) {
        return true;
      }
    }
    return false;
  }
  _arraySome = arraySome;
  return _arraySome;
}
var _cacheHas;
var hasRequired_cacheHas;
function require_cacheHas() {
  if (hasRequired_cacheHas) return _cacheHas;
  hasRequired_cacheHas = 1;
  function cacheHas(cache, key) {
    return cache.has(key);
  }
  _cacheHas = cacheHas;
  return _cacheHas;
}
var _equalArrays;
var hasRequired_equalArrays;
function require_equalArrays() {
  if (hasRequired_equalArrays) return _equalArrays;
  hasRequired_equalArrays = 1;
  var SetCache = require_SetCache(), arraySome = require_arraySome(), cacheHas = require_cacheHas();
  var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
  function equalArrays(array2, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array2.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
      return false;
    }
    var arrStacked = stack.get(array2);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) {
      return arrStacked == other && othStacked == array2;
    }
    var index2 = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : void 0;
    stack.set(array2, other);
    stack.set(other, array2);
    while (++index2 < arrLength) {
      var arrValue = array2[index2], othValue = other[index2];
      if (customizer) {
        var compared = isPartial ? customizer(othValue, arrValue, index2, other, array2, stack) : customizer(arrValue, othValue, index2, array2, other, stack);
      }
      if (compared !== void 0) {
        if (compared) {
          continue;
        }
        result = false;
        break;
      }
      if (seen) {
        if (!arraySome(other, function(othValue2, othIndex) {
          if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
            return seen.push(othIndex);
          }
        })) {
          result = false;
          break;
        }
      } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
        result = false;
        break;
      }
    }
    stack["delete"](array2);
    stack["delete"](other);
    return result;
  }
  _equalArrays = equalArrays;
  return _equalArrays;
}
var _mapToArray;
var hasRequired_mapToArray;
function require_mapToArray() {
  if (hasRequired_mapToArray) return _mapToArray;
  hasRequired_mapToArray = 1;
  function mapToArray(map2) {
    var index2 = -1, result = Array(map2.size);
    map2.forEach(function(value, key) {
      result[++index2] = [key, value];
    });
    return result;
  }
  _mapToArray = mapToArray;
  return _mapToArray;
}
var _setToArray;
var hasRequired_setToArray;
function require_setToArray() {
  if (hasRequired_setToArray) return _setToArray;
  hasRequired_setToArray = 1;
  function setToArray(set2) {
    var index2 = -1, result = Array(set2.size);
    set2.forEach(function(value) {
      result[++index2] = value;
    });
    return result;
  }
  _setToArray = setToArray;
  return _setToArray;
}
var _equalByTag;
var hasRequired_equalByTag;
function require_equalByTag() {
  if (hasRequired_equalByTag) return _equalByTag;
  hasRequired_equalByTag = 1;
  var Symbol2 = require_Symbol(), Uint8Array2 = require_Uint8Array(), eq = requireEq(), equalArrays = require_equalArrays(), mapToArray = require_mapToArray(), setToArray = require_setToArray();
  var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
  var boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", mapTag = "[object Map]", numberTag = "[object Number]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]";
  var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]";
  var symbolProto = Symbol2 ? Symbol2.prototype : void 0, symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
  function equalByTag(object2, other, tag, bitmask, customizer, equalFunc, stack) {
    switch (tag) {
      case dataViewTag:
        if (object2.byteLength != other.byteLength || object2.byteOffset != other.byteOffset) {
          return false;
        }
        object2 = object2.buffer;
        other = other.buffer;
      case arrayBufferTag:
        if (object2.byteLength != other.byteLength || !equalFunc(new Uint8Array2(object2), new Uint8Array2(other))) {
          return false;
        }
        return true;
      case boolTag:
      case dateTag:
      case numberTag:
        return eq(+object2, +other);
      case errorTag:
        return object2.name == other.name && object2.message == other.message;
      case regexpTag:
      case stringTag:
        return object2 == other + "";
      case mapTag:
        var convert = mapToArray;
      case setTag:
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
        convert || (convert = setToArray);
        if (object2.size != other.size && !isPartial) {
          return false;
        }
        var stacked = stack.get(object2);
        if (stacked) {
          return stacked == other;
        }
        bitmask |= COMPARE_UNORDERED_FLAG;
        stack.set(object2, other);
        var result = equalArrays(convert(object2), convert(other), bitmask, customizer, equalFunc, stack);
        stack["delete"](object2);
        return result;
      case symbolTag:
        if (symbolValueOf) {
          return symbolValueOf.call(object2) == symbolValueOf.call(other);
        }
    }
    return false;
  }
  _equalByTag = equalByTag;
  return _equalByTag;
}
var _equalObjects;
var hasRequired_equalObjects;
function require_equalObjects() {
  if (hasRequired_equalObjects) return _equalObjects;
  hasRequired_equalObjects = 1;
  var getAllKeys = require_getAllKeys();
  var COMPARE_PARTIAL_FLAG = 1;
  var objectProto = Object.prototype;
  var hasOwnProperty2 = objectProto.hasOwnProperty;
  function equalObjects(object2, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object2), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) {
      return false;
    }
    var index2 = objLength;
    while (index2--) {
      var key = objProps[index2];
      if (!(isPartial ? key in other : hasOwnProperty2.call(other, key))) {
        return false;
      }
    }
    var objStacked = stack.get(object2);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) {
      return objStacked == other && othStacked == object2;
    }
    var result = true;
    stack.set(object2, other);
    stack.set(other, object2);
    var skipCtor = isPartial;
    while (++index2 < objLength) {
      key = objProps[index2];
      var objValue = object2[key], othValue = other[key];
      if (customizer) {
        var compared = isPartial ? customizer(othValue, objValue, key, other, object2, stack) : customizer(objValue, othValue, key, object2, other, stack);
      }
      if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
        result = false;
        break;
      }
      skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
      var objCtor = object2.constructor, othCtor = other.constructor;
      if (objCtor != othCtor && ("constructor" in object2 && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
        result = false;
      }
    }
    stack["delete"](object2);
    stack["delete"](other);
    return result;
  }
  _equalObjects = equalObjects;
  return _equalObjects;
}
var _baseIsEqualDeep;
var hasRequired_baseIsEqualDeep;
function require_baseIsEqualDeep() {
  if (hasRequired_baseIsEqualDeep) return _baseIsEqualDeep;
  hasRequired_baseIsEqualDeep = 1;
  var Stack = require_Stack(), equalArrays = require_equalArrays(), equalByTag = require_equalByTag(), equalObjects = require_equalObjects(), getTag2 = require_getTag(), isArray2 = requireIsArray(), isBuffer2 = requireIsBuffer(), isTypedArray2 = requireIsTypedArray();
  var COMPARE_PARTIAL_FLAG = 1;
  var argsTag = "[object Arguments]", arrayTag = "[object Array]", objectTag = "[object Object]";
  var objectProto = Object.prototype;
  var hasOwnProperty2 = objectProto.hasOwnProperty;
  function baseIsEqualDeep(object2, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray2(object2), othIsArr = isArray2(other), objTag = objIsArr ? arrayTag : getTag2(object2), othTag = othIsArr ? arrayTag : getTag2(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer2(object2)) {
      if (!isBuffer2(other)) {
        return false;
      }
      objIsArr = true;
      objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
      stack || (stack = new Stack());
      return objIsArr || isTypedArray2(object2) ? equalArrays(object2, other, bitmask, customizer, equalFunc, stack) : equalByTag(object2, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
      var objIsWrapped = objIsObj && hasOwnProperty2.call(object2, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty2.call(other, "__wrapped__");
      if (objIsWrapped || othIsWrapped) {
        var objUnwrapped = objIsWrapped ? object2.value() : object2, othUnwrapped = othIsWrapped ? other.value() : other;
        stack || (stack = new Stack());
        return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
      }
    }
    if (!isSameTag) {
      return false;
    }
    stack || (stack = new Stack());
    return equalObjects(object2, other, bitmask, customizer, equalFunc, stack);
  }
  _baseIsEqualDeep = baseIsEqualDeep;
  return _baseIsEqualDeep;
}
var _baseIsEqual;
var hasRequired_baseIsEqual;
function require_baseIsEqual() {
  if (hasRequired_baseIsEqual) return _baseIsEqual;
  hasRequired_baseIsEqual = 1;
  var baseIsEqualDeep = require_baseIsEqualDeep(), isObjectLike = requireIsObjectLike();
  function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) {
      return true;
    }
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
      return value !== value && other !== other;
    }
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
  }
  _baseIsEqual = baseIsEqual;
  return _baseIsEqual;
}
var _baseIsMatch;
var hasRequired_baseIsMatch;
function require_baseIsMatch() {
  if (hasRequired_baseIsMatch) return _baseIsMatch;
  hasRequired_baseIsMatch = 1;
  var Stack = require_Stack(), baseIsEqual = require_baseIsEqual();
  var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
  function baseIsMatch(object2, source, matchData, customizer) {
    var index2 = matchData.length, length = index2, noCustomizer = !customizer;
    if (object2 == null) {
      return !length;
    }
    object2 = Object(object2);
    while (index2--) {
      var data = matchData[index2];
      if (noCustomizer && data[2] ? data[1] !== object2[data[0]] : !(data[0] in object2)) {
        return false;
      }
    }
    while (++index2 < length) {
      data = matchData[index2];
      var key = data[0], objValue = object2[key], srcValue = data[1];
      if (noCustomizer && data[2]) {
        if (objValue === void 0 && !(key in object2)) {
          return false;
        }
      } else {
        var stack = new Stack();
        if (customizer) {
          var result = customizer(objValue, srcValue, key, object2, source, stack);
        }
        if (!(result === void 0 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) {
          return false;
        }
      }
    }
    return true;
  }
  _baseIsMatch = baseIsMatch;
  return _baseIsMatch;
}
var _isStrictComparable;
var hasRequired_isStrictComparable;
function require_isStrictComparable() {
  if (hasRequired_isStrictComparable) return _isStrictComparable;
  hasRequired_isStrictComparable = 1;
  var isObject2 = requireIsObject();
  function isStrictComparable(value) {
    return value === value && !isObject2(value);
  }
  _isStrictComparable = isStrictComparable;
  return _isStrictComparable;
}
var _getMatchData;
var hasRequired_getMatchData;
function require_getMatchData() {
  if (hasRequired_getMatchData) return _getMatchData;
  hasRequired_getMatchData = 1;
  var isStrictComparable = require_isStrictComparable(), keys2 = requireKeys();
  function getMatchData(object2) {
    var result = keys2(object2), length = result.length;
    while (length--) {
      var key = result[length], value = object2[key];
      result[length] = [key, value, isStrictComparable(value)];
    }
    return result;
  }
  _getMatchData = getMatchData;
  return _getMatchData;
}
var _matchesStrictComparable;
var hasRequired_matchesStrictComparable;
function require_matchesStrictComparable() {
  if (hasRequired_matchesStrictComparable) return _matchesStrictComparable;
  hasRequired_matchesStrictComparable = 1;
  function matchesStrictComparable(key, srcValue) {
    return function(object2) {
      if (object2 == null) {
        return false;
      }
      return object2[key] === srcValue && (srcValue !== void 0 || key in Object(object2));
    };
  }
  _matchesStrictComparable = matchesStrictComparable;
  return _matchesStrictComparable;
}
var _baseMatches;
var hasRequired_baseMatches;
function require_baseMatches() {
  if (hasRequired_baseMatches) return _baseMatches;
  hasRequired_baseMatches = 1;
  var baseIsMatch = require_baseIsMatch(), getMatchData = require_getMatchData(), matchesStrictComparable = require_matchesStrictComparable();
  function baseMatches(source) {
    var matchData = getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) {
      return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    }
    return function(object2) {
      return object2 === source || baseIsMatch(object2, source, matchData);
    };
  }
  _baseMatches = baseMatches;
  return _baseMatches;
}
var _baseHasIn;
var hasRequired_baseHasIn;
function require_baseHasIn() {
  if (hasRequired_baseHasIn) return _baseHasIn;
  hasRequired_baseHasIn = 1;
  function baseHasIn(object2, key) {
    return object2 != null && key in Object(object2);
  }
  _baseHasIn = baseHasIn;
  return _baseHasIn;
}
var _hasPath;
var hasRequired_hasPath;
function require_hasPath() {
  if (hasRequired_hasPath) return _hasPath;
  hasRequired_hasPath = 1;
  var castPath = require_castPath(), isArguments = requireIsArguments(), isArray2 = requireIsArray(), isIndex = require_isIndex(), isLength = requireIsLength(), toKey = require_toKey();
  function hasPath(object2, path, hasFunc) {
    path = castPath(path, object2);
    var index2 = -1, length = path.length, result = false;
    while (++index2 < length) {
      var key = toKey(path[index2]);
      if (!(result = object2 != null && hasFunc(object2, key))) {
        break;
      }
      object2 = object2[key];
    }
    if (result || ++index2 != length) {
      return result;
    }
    length = object2 == null ? 0 : object2.length;
    return !!length && isLength(length) && isIndex(key, length) && (isArray2(object2) || isArguments(object2));
  }
  _hasPath = hasPath;
  return _hasPath;
}
var hasIn_1;
var hasRequiredHasIn;
function requireHasIn() {
  if (hasRequiredHasIn) return hasIn_1;
  hasRequiredHasIn = 1;
  var baseHasIn = require_baseHasIn(), hasPath = require_hasPath();
  function hasIn(object2, path) {
    return object2 != null && hasPath(object2, path, baseHasIn);
  }
  hasIn_1 = hasIn;
  return hasIn_1;
}
var _baseMatchesProperty;
var hasRequired_baseMatchesProperty;
function require_baseMatchesProperty() {
  if (hasRequired_baseMatchesProperty) return _baseMatchesProperty;
  hasRequired_baseMatchesProperty = 1;
  var baseIsEqual = require_baseIsEqual(), get2 = requireGet(), hasIn = requireHasIn(), isKey = require_isKey(), isStrictComparable = require_isStrictComparable(), matchesStrictComparable = require_matchesStrictComparable(), toKey = require_toKey();
  var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
  function baseMatchesProperty(path, srcValue) {
    if (isKey(path) && isStrictComparable(srcValue)) {
      return matchesStrictComparable(toKey(path), srcValue);
    }
    return function(object2) {
      var objValue = get2(object2, path);
      return objValue === void 0 && objValue === srcValue ? hasIn(object2, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
    };
  }
  _baseMatchesProperty = baseMatchesProperty;
  return _baseMatchesProperty;
}
var _baseProperty;
var hasRequired_baseProperty;
function require_baseProperty() {
  if (hasRequired_baseProperty) return _baseProperty;
  hasRequired_baseProperty = 1;
  function baseProperty(key) {
    return function(object2) {
      return object2 == null ? void 0 : object2[key];
    };
  }
  _baseProperty = baseProperty;
  return _baseProperty;
}
var _basePropertyDeep;
var hasRequired_basePropertyDeep;
function require_basePropertyDeep() {
  if (hasRequired_basePropertyDeep) return _basePropertyDeep;
  hasRequired_basePropertyDeep = 1;
  var baseGet = require_baseGet();
  function basePropertyDeep(path) {
    return function(object2) {
      return baseGet(object2, path);
    };
  }
  _basePropertyDeep = basePropertyDeep;
  return _basePropertyDeep;
}
var property_1;
var hasRequiredProperty;
function requireProperty() {
  if (hasRequiredProperty) return property_1;
  hasRequiredProperty = 1;
  var baseProperty = require_baseProperty(), basePropertyDeep = require_basePropertyDeep(), isKey = require_isKey(), toKey = require_toKey();
  function property(path) {
    return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
  }
  property_1 = property;
  return property_1;
}
var _baseIteratee;
var hasRequired_baseIteratee;
function require_baseIteratee() {
  if (hasRequired_baseIteratee) return _baseIteratee;
  hasRequired_baseIteratee = 1;
  var baseMatches = require_baseMatches(), baseMatchesProperty = require_baseMatchesProperty(), identity4 = requireIdentity(), isArray2 = requireIsArray(), property = requireProperty();
  function baseIteratee(value) {
    if (typeof value == "function") {
      return value;
    }
    if (value == null) {
      return identity4;
    }
    if (typeof value == "object") {
      return isArray2(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
    }
    return property(value);
  }
  _baseIteratee = baseIteratee;
  return _baseIteratee;
}
var _baseFindIndex;
var hasRequired_baseFindIndex;
function require_baseFindIndex() {
  if (hasRequired_baseFindIndex) return _baseFindIndex;
  hasRequired_baseFindIndex = 1;
  function baseFindIndex(array2, predicate, fromIndex, fromRight) {
    var length = array2.length, index2 = fromIndex + (fromRight ? 1 : -1);
    while (fromRight ? index2-- : ++index2 < length) {
      if (predicate(array2[index2], index2, array2)) {
        return index2;
      }
    }
    return -1;
  }
  _baseFindIndex = baseFindIndex;
  return _baseFindIndex;
}
var _baseIsNaN;
var hasRequired_baseIsNaN;
function require_baseIsNaN() {
  if (hasRequired_baseIsNaN) return _baseIsNaN;
  hasRequired_baseIsNaN = 1;
  function baseIsNaN(value) {
    return value !== value;
  }
  _baseIsNaN = baseIsNaN;
  return _baseIsNaN;
}
var _strictIndexOf;
var hasRequired_strictIndexOf;
function require_strictIndexOf() {
  if (hasRequired_strictIndexOf) return _strictIndexOf;
  hasRequired_strictIndexOf = 1;
  function strictIndexOf(array2, value, fromIndex) {
    var index2 = fromIndex - 1, length = array2.length;
    while (++index2 < length) {
      if (array2[index2] === value) {
        return index2;
      }
    }
    return -1;
  }
  _strictIndexOf = strictIndexOf;
  return _strictIndexOf;
}
var _baseIndexOf;
var hasRequired_baseIndexOf;
function require_baseIndexOf() {
  if (hasRequired_baseIndexOf) return _baseIndexOf;
  hasRequired_baseIndexOf = 1;
  var baseFindIndex = require_baseFindIndex(), baseIsNaN = require_baseIsNaN(), strictIndexOf = require_strictIndexOf();
  function baseIndexOf(array2, value, fromIndex) {
    return value === value ? strictIndexOf(array2, value, fromIndex) : baseFindIndex(array2, baseIsNaN, fromIndex);
  }
  _baseIndexOf = baseIndexOf;
  return _baseIndexOf;
}
var _arrayIncludes;
var hasRequired_arrayIncludes;
function require_arrayIncludes() {
  if (hasRequired_arrayIncludes) return _arrayIncludes;
  hasRequired_arrayIncludes = 1;
  var baseIndexOf = require_baseIndexOf();
  function arrayIncludes(array2, value) {
    var length = array2 == null ? 0 : array2.length;
    return !!length && baseIndexOf(array2, value, 0) > -1;
  }
  _arrayIncludes = arrayIncludes;
  return _arrayIncludes;
}
var _arrayIncludesWith;
var hasRequired_arrayIncludesWith;
function require_arrayIncludesWith() {
  if (hasRequired_arrayIncludesWith) return _arrayIncludesWith;
  hasRequired_arrayIncludesWith = 1;
  function arrayIncludesWith(array2, value, comparator) {
    var index2 = -1, length = array2 == null ? 0 : array2.length;
    while (++index2 < length) {
      if (comparator(value, array2[index2])) {
        return true;
      }
    }
    return false;
  }
  _arrayIncludesWith = arrayIncludesWith;
  return _arrayIncludesWith;
}
var noop_1;
var hasRequiredNoop;
function requireNoop() {
  if (hasRequiredNoop) return noop_1;
  hasRequiredNoop = 1;
  function noop2() {
  }
  noop_1 = noop2;
  return noop_1;
}
var _createSet;
var hasRequired_createSet;
function require_createSet() {
  if (hasRequired_createSet) return _createSet;
  hasRequired_createSet = 1;
  var Set2 = require_Set(), noop2 = requireNoop(), setToArray = require_setToArray();
  var INFINITY = 1 / 0;
  var createSet = !(Set2 && 1 / setToArray(new Set2([, -0]))[1] == INFINITY) ? noop2 : function(values) {
    return new Set2(values);
  };
  _createSet = createSet;
  return _createSet;
}
var _baseUniq;
var hasRequired_baseUniq;
function require_baseUniq() {
  if (hasRequired_baseUniq) return _baseUniq;
  hasRequired_baseUniq = 1;
  var SetCache = require_SetCache(), arrayIncludes = require_arrayIncludes(), arrayIncludesWith = require_arrayIncludesWith(), cacheHas = require_cacheHas(), createSet = require_createSet(), setToArray = require_setToArray();
  var LARGE_ARRAY_SIZE = 200;
  function baseUniq(array2, iteratee, comparator) {
    var index2 = -1, includes = arrayIncludes, length = array2.length, isCommon = true, result = [], seen = result;
    if (comparator) {
      isCommon = false;
      includes = arrayIncludesWith;
    } else if (length >= LARGE_ARRAY_SIZE) {
      var set2 = iteratee ? null : createSet(array2);
      if (set2) {
        return setToArray(set2);
      }
      isCommon = false;
      includes = cacheHas;
      seen = new SetCache();
    } else {
      seen = iteratee ? [] : result;
    }
    outer:
      while (++index2 < length) {
        var value = array2[index2], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        } else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
    return result;
  }
  _baseUniq = baseUniq;
  return _baseUniq;
}
var uniqBy_1;
var hasRequiredUniqBy;
function requireUniqBy() {
  if (hasRequiredUniqBy) return uniqBy_1;
  hasRequiredUniqBy = 1;
  var baseIteratee = require_baseIteratee(), baseUniq = require_baseUniq();
  function uniqBy2(array2, iteratee) {
    return array2 && array2.length ? baseUniq(array2, baseIteratee(iteratee, 2)) : [];
  }
  uniqBy_1 = uniqBy2;
  return uniqBy_1;
}
var uniqByExports = requireUniqBy();
const uniqBy = /* @__PURE__ */ getDefaultExportFromCjs(uniqByExports);
function getUniqPayload(payload, option, defaultUniqBy2) {
  if (option === true) {
    return uniqBy(payload, defaultUniqBy2);
  }
  if (isFunction(option)) {
    return uniqBy(payload, option);
  }
  return payload;
}
function _typeof$J(o2) {
  "@babel/helpers - typeof";
  return _typeof$J = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof$J(o2);
}
var _excluded$g = ["ref"];
function ownKeys$B(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e3);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$B(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$B(Object(t3), true).forEach(function(r3) {
      _defineProperty$G(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$B(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
function _classCallCheck$l(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$l(target, props) {
  for (var i3 = 0; i3 < props.length; i3++) {
    var descriptor = props[i3];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$H(descriptor.key), descriptor);
  }
}
function _createClass$l(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$l(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$l(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _callSuper$h(t3, o2, e3) {
  return o2 = _getPrototypeOf$i(o2), _possibleConstructorReturn$i(t3, _isNativeReflectConstruct$i() ? Reflect.construct(o2, e3 || [], _getPrototypeOf$i(t3).constructor) : o2.apply(t3, e3));
}
function _possibleConstructorReturn$i(self2, call) {
  if (call && (_typeof$J(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$i(self2);
}
function _assertThisInitialized$i(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$i() {
  try {
    var t3 = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$i = function _isNativeReflectConstruct2() {
    return !!t3;
  })();
}
function _getPrototypeOf$i(o2) {
  _getPrototypeOf$i = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o3) {
    return o3.__proto__ || Object.getPrototypeOf(o3);
  };
  return _getPrototypeOf$i(o2);
}
function _inherits$i(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass) _setPrototypeOf$i(subClass, superClass);
}
function _setPrototypeOf$i(o2, p2) {
  _setPrototypeOf$i = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o3, p3) {
    o3.__proto__ = p3;
    return o3;
  };
  return _setPrototypeOf$i(o2, p2);
}
function _defineProperty$G(obj, key, value) {
  key = _toPropertyKey$H(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$H(t3) {
  var i3 = _toPrimitive$H(t3, "string");
  return "symbol" == _typeof$J(i3) ? i3 : i3 + "";
}
function _toPrimitive$H(t3, r2) {
  if ("object" != _typeof$J(t3) || !t3) return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i3 = e3.call(t3, r2);
    if ("object" != _typeof$J(i3)) return i3;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t3);
}
function _objectWithoutProperties$g(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$g(source, excluded);
  var key, i3;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i3 = 0; i3 < sourceSymbolKeys.length; i3++) {
      key = sourceSymbolKeys[i3];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$g(source, excluded) {
  if (source == null) return {};
  var target = {};
  for (var key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function defaultUniqBy$1(entry) {
  return entry.value;
}
function renderContent$1(content, props) {
  if (/* @__PURE__ */ React__default.isValidElement(content)) {
    return /* @__PURE__ */ React__default.cloneElement(content, props);
  }
  if (typeof content === "function") {
    return /* @__PURE__ */ React__default.createElement(content, props);
  }
  props.ref;
  var otherProps = _objectWithoutProperties$g(props, _excluded$g);
  return /* @__PURE__ */ React__default.createElement(DefaultLegendContent, otherProps);
}
var EPS$1 = 1;
var Legend$2 = /* @__PURE__ */ function(_PureComponent) {
  function Legend2() {
    var _this;
    _classCallCheck$l(this, Legend2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$h(this, Legend2, [].concat(args));
    _defineProperty$G(_this, "lastBoundingBox", {
      width: -1,
      height: -1
    });
    return _this;
  }
  _inherits$i(Legend2, _PureComponent);
  return _createClass$l(Legend2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateBBox();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.updateBBox();
    }
  }, {
    key: "getBBox",
    value: function getBBox() {
      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var box = this.wrapperNode.getBoundingClientRect();
        box.height = this.wrapperNode.offsetHeight;
        box.width = this.wrapperNode.offsetWidth;
        return box;
      }
      return null;
    }
  }, {
    key: "updateBBox",
    value: function updateBBox() {
      var onBBoxUpdate = this.props.onBBoxUpdate;
      var box = this.getBBox();
      if (box) {
        if (Math.abs(box.width - this.lastBoundingBox.width) > EPS$1 || Math.abs(box.height - this.lastBoundingBox.height) > EPS$1) {
          this.lastBoundingBox.width = box.width;
          this.lastBoundingBox.height = box.height;
          if (onBBoxUpdate) {
            onBBoxUpdate(box);
          }
        }
      } else if (this.lastBoundingBox.width !== -1 || this.lastBoundingBox.height !== -1) {
        this.lastBoundingBox.width = -1;
        this.lastBoundingBox.height = -1;
        if (onBBoxUpdate) {
          onBBoxUpdate(null);
        }
      }
    }
  }, {
    key: "getBBoxSnapshot",
    value: function getBBoxSnapshot() {
      if (this.lastBoundingBox.width >= 0 && this.lastBoundingBox.height >= 0) {
        return _objectSpread$B({}, this.lastBoundingBox);
      }
      return {
        width: 0,
        height: 0
      };
    }
  }, {
    key: "getDefaultPosition",
    value: function getDefaultPosition(style) {
      var _this$props = this.props, layout = _this$props.layout, align = _this$props.align, verticalAlign = _this$props.verticalAlign, margin = _this$props.margin, chartWidth = _this$props.chartWidth, chartHeight = _this$props.chartHeight;
      var hPos, vPos;
      if (!style || (style.left === void 0 || style.left === null) && (style.right === void 0 || style.right === null)) {
        if (align === "center" && layout === "vertical") {
          var box = this.getBBoxSnapshot();
          hPos = {
            left: ((chartWidth || 0) - box.width) / 2
          };
        } else {
          hPos = align === "right" ? {
            right: margin && margin.right || 0
          } : {
            left: margin && margin.left || 0
          };
        }
      }
      if (!style || (style.top === void 0 || style.top === null) && (style.bottom === void 0 || style.bottom === null)) {
        if (verticalAlign === "middle") {
          var _box = this.getBBoxSnapshot();
          vPos = {
            top: ((chartHeight || 0) - _box.height) / 2
          };
        } else {
          vPos = verticalAlign === "bottom" ? {
            bottom: margin && margin.bottom || 0
          } : {
            top: margin && margin.top || 0
          };
        }
      }
      return _objectSpread$B(_objectSpread$B({}, hPos), vPos);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props, content = _this$props2.content, width = _this$props2.width, height = _this$props2.height, wrapperStyle = _this$props2.wrapperStyle, payloadUniqBy = _this$props2.payloadUniqBy, payload = _this$props2.payload;
      var outerStyle = _objectSpread$B(_objectSpread$B({
        position: "absolute",
        width: width || "auto",
        height: height || "auto"
      }, this.getDefaultPosition(wrapperStyle)), wrapperStyle);
      return /* @__PURE__ */ React__default.createElement("div", {
        className: "recharts-legend-wrapper",
        style: outerStyle,
        ref: function ref(node) {
          _this2.wrapperNode = node;
        }
      }, renderContent$1(content, _objectSpread$B(_objectSpread$B({}, this.props), {}, {
        payload: getUniqPayload(payload, payloadUniqBy, defaultUniqBy$1)
      })));
    }
  }], [{
    key: "getWithHeight",
    value: function getWithHeight(item, chartWidth) {
      var _this$defaultProps$it = _objectSpread$B(_objectSpread$B({}, this.defaultProps), item.props), layout = _this$defaultProps$it.layout;
      if (layout === "vertical" && isNumber(item.props.height)) {
        return {
          height: item.props.height
        };
      }
      if (layout === "horizontal") {
        return {
          width: item.props.width || chartWidth
        };
      }
      return null;
    }
  }]);
}(PureComponent);
_defineProperty$G(Legend$2, "displayName", "Legend");
_defineProperty$G(Legend$2, "defaultProps", {
  iconSize: 14,
  layout: "horizontal",
  align: "center",
  verticalAlign: "bottom"
});
var _createBaseFor;
var hasRequired_createBaseFor;
function require_createBaseFor() {
  if (hasRequired_createBaseFor) return _createBaseFor;
  hasRequired_createBaseFor = 1;
  function createBaseFor(fromRight) {
    return function(object2, iteratee, keysFunc) {
      var index2 = -1, iterable = Object(object2), props = keysFunc(object2), length = props.length;
      while (length--) {
        var key = props[fromRight ? length : ++index2];
        if (iteratee(iterable[key], key, iterable) === false) {
          break;
        }
      }
      return object2;
    };
  }
  _createBaseFor = createBaseFor;
  return _createBaseFor;
}
var _baseFor;
var hasRequired_baseFor;
function require_baseFor() {
  if (hasRequired_baseFor) return _baseFor;
  hasRequired_baseFor = 1;
  var createBaseFor = require_createBaseFor();
  var baseFor = createBaseFor();
  _baseFor = baseFor;
  return _baseFor;
}
var _baseForOwn;
var hasRequired_baseForOwn;
function require_baseForOwn() {
  if (hasRequired_baseForOwn) return _baseForOwn;
  hasRequired_baseForOwn = 1;
  var baseFor = require_baseFor(), keys2 = requireKeys();
  function baseForOwn(object2, iteratee) {
    return object2 && baseFor(object2, iteratee, keys2);
  }
  _baseForOwn = baseForOwn;
  return _baseForOwn;
}
var _createBaseEach;
var hasRequired_createBaseEach;
function require_createBaseEach() {
  if (hasRequired_createBaseEach) return _createBaseEach;
  hasRequired_createBaseEach = 1;
  var isArrayLike = requireIsArrayLike();
  function createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
      if (collection == null) {
        return collection;
      }
      if (!isArrayLike(collection)) {
        return eachFunc(collection, iteratee);
      }
      var length = collection.length, index2 = fromRight ? length : -1, iterable = Object(collection);
      while (fromRight ? index2-- : ++index2 < length) {
        if (iteratee(iterable[index2], index2, iterable) === false) {
          break;
        }
      }
      return collection;
    };
  }
  _createBaseEach = createBaseEach;
  return _createBaseEach;
}
var _baseEach;
var hasRequired_baseEach;
function require_baseEach() {
  if (hasRequired_baseEach) return _baseEach;
  hasRequired_baseEach = 1;
  var baseForOwn = require_baseForOwn(), createBaseEach = require_createBaseEach();
  var baseEach = createBaseEach(baseForOwn);
  _baseEach = baseEach;
  return _baseEach;
}
var _baseMap;
var hasRequired_baseMap;
function require_baseMap() {
  if (hasRequired_baseMap) return _baseMap;
  hasRequired_baseMap = 1;
  var baseEach = require_baseEach(), isArrayLike = requireIsArrayLike();
  function baseMap(collection, iteratee) {
    var index2 = -1, result = isArrayLike(collection) ? Array(collection.length) : [];
    baseEach(collection, function(value, key, collection2) {
      result[++index2] = iteratee(value, key, collection2);
    });
    return result;
  }
  _baseMap = baseMap;
  return _baseMap;
}
var _baseSortBy;
var hasRequired_baseSortBy;
function require_baseSortBy() {
  if (hasRequired_baseSortBy) return _baseSortBy;
  hasRequired_baseSortBy = 1;
  function baseSortBy(array2, comparer) {
    var length = array2.length;
    array2.sort(comparer);
    while (length--) {
      array2[length] = array2[length].value;
    }
    return array2;
  }
  _baseSortBy = baseSortBy;
  return _baseSortBy;
}
var _compareMultiple;
var hasRequired_compareMultiple;
function require_compareMultiple() {
  if (hasRequired_compareMultiple) return _compareMultiple;
  hasRequired_compareMultiple = 1;
  var compareAscending = require_compareAscending();
  function compareMultiple(object2, other, orders) {
    var index2 = -1, objCriteria = object2.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while (++index2 < length) {
      var result = compareAscending(objCriteria[index2], othCriteria[index2]);
      if (result) {
        if (index2 >= ordersLength) {
          return result;
        }
        var order2 = orders[index2];
        return result * (order2 == "desc" ? -1 : 1);
      }
    }
    return object2.index - other.index;
  }
  _compareMultiple = compareMultiple;
  return _compareMultiple;
}
var _baseOrderBy;
var hasRequired_baseOrderBy;
function require_baseOrderBy() {
  if (hasRequired_baseOrderBy) return _baseOrderBy;
  hasRequired_baseOrderBy = 1;
  var arrayMap = require_arrayMap(), baseGet = require_baseGet(), baseIteratee = require_baseIteratee(), baseMap = require_baseMap(), baseSortBy = require_baseSortBy(), baseUnary = require_baseUnary(), compareMultiple = require_compareMultiple(), identity4 = requireIdentity(), isArray2 = requireIsArray();
  function baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) {
      iteratees = arrayMap(iteratees, function(iteratee) {
        if (isArray2(iteratee)) {
          return function(value) {
            return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
          };
        }
        return iteratee;
      });
    } else {
      iteratees = [identity4];
    }
    var index2 = -1;
    iteratees = arrayMap(iteratees, baseUnary(baseIteratee));
    var result = baseMap(collection, function(value, key, collection2) {
      var criteria = arrayMap(iteratees, function(iteratee) {
        return iteratee(value);
      });
      return { "criteria": criteria, "index": ++index2, "value": value };
    });
    return baseSortBy(result, function(object2, other) {
      return compareMultiple(object2, other, orders);
    });
  }
  _baseOrderBy = baseOrderBy;
  return _baseOrderBy;
}
var _baseRest;
var hasRequired_baseRest;
function require_baseRest() {
  if (hasRequired_baseRest) return _baseRest;
  hasRequired_baseRest = 1;
  var identity4 = requireIdentity(), overRest = require_overRest(), setToString = require_setToString();
  function baseRest(func, start) {
    return setToString(overRest(func, start, identity4), func + "");
  }
  _baseRest = baseRest;
  return _baseRest;
}
var _isIterateeCall;
var hasRequired_isIterateeCall;
function require_isIterateeCall() {
  if (hasRequired_isIterateeCall) return _isIterateeCall;
  hasRequired_isIterateeCall = 1;
  var eq = requireEq(), isArrayLike = requireIsArrayLike(), isIndex = require_isIndex(), isObject2 = requireIsObject();
  function isIterateeCall(value, index2, object2) {
    if (!isObject2(object2)) {
      return false;
    }
    var type = typeof index2;
    if (type == "number" ? isArrayLike(object2) && isIndex(index2, object2.length) : type == "string" && index2 in object2) {
      return eq(object2[index2], value);
    }
    return false;
  }
  _isIterateeCall = isIterateeCall;
  return _isIterateeCall;
}
var sortBy_1;
var hasRequiredSortBy;
function requireSortBy() {
  if (hasRequiredSortBy) return sortBy_1;
  hasRequiredSortBy = 1;
  var baseFlatten = require_baseFlatten(), baseOrderBy = require_baseOrderBy(), baseRest = require_baseRest(), isIterateeCall = require_isIterateeCall();
  var sortBy2 = baseRest(function(collection, iteratees) {
    if (collection == null) {
      return [];
    }
    var length = iteratees.length;
    if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
      iteratees = [];
    } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
      iteratees = [iteratees[0]];
    }
    return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
  });
  sortBy_1 = sortBy2;
  return sortBy_1;
}
var sortByExports = requireSortBy();
const sortBy = /* @__PURE__ */ getDefaultExportFromCjs(sortByExports);
function _typeof$I(o2) {
  "@babel/helpers - typeof";
  return _typeof$I = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof$I(o2);
}
function _extends$r() {
  _extends$r = Object.assign ? Object.assign.bind() : function(target) {
    for (var i3 = 1; i3 < arguments.length; i3++) {
      var source = arguments[i3];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$r.apply(this, arguments);
}
function _slicedToArray$c(arr, i3) {
  return _arrayWithHoles$d(arr) || _iterableToArrayLimit$c(arr, i3) || _unsupportedIterableToArray$l(arr, i3) || _nonIterableRest$d();
}
function _nonIterableRest$d() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$l(o2, minLen) {
  if (!o2) return;
  if (typeof o2 === "string") return _arrayLikeToArray$l(o2, minLen);
  var n2 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n2 === "Object" && o2.constructor) n2 = o2.constructor.name;
  if (n2 === "Map" || n2 === "Set") return Array.from(o2);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray$l(o2, minLen);
}
function _arrayLikeToArray$l(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i3 = 0, arr2 = new Array(len); i3 < len; i3++) arr2[i3] = arr[i3];
  return arr2;
}
function _iterableToArrayLimit$c(r2, l2) {
  var t3 = null == r2 ? null : "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];
  if (null != t3) {
    var e3, n2, i3, u3, a4 = [], f2 = true, o2 = false;
    try {
      if (i3 = (t3 = t3.call(r2)).next, 0 === l2) ;
      else for (; !(f2 = (e3 = i3.call(t3)).done) && (a4.push(e3.value), a4.length !== l2); f2 = true) ;
    } catch (r3) {
      o2 = true, n2 = r3;
    } finally {
      try {
        if (!f2 && null != t3["return"] && (u3 = t3["return"](), Object(u3) !== u3)) return;
      } finally {
        if (o2) throw n2;
      }
    }
    return a4;
  }
}
function _arrayWithHoles$d(arr) {
  if (Array.isArray(arr)) return arr;
}
function ownKeys$A(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e3);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$A(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$A(Object(t3), true).forEach(function(r3) {
      _defineProperty$F(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$A(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
function _defineProperty$F(obj, key, value) {
  key = _toPropertyKey$G(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$G(t3) {
  var i3 = _toPrimitive$G(t3, "string");
  return "symbol" == _typeof$I(i3) ? i3 : i3 + "";
}
function _toPrimitive$G(t3, r2) {
  if ("object" != _typeof$I(t3) || !t3) return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i3 = e3.call(t3, r2);
    if ("object" != _typeof$I(i3)) return i3;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t3);
}
function defaultFormatter(value) {
  return Array.isArray(value) && isNumOrStr(value[0]) && isNumOrStr(value[1]) ? value.join(" ~ ") : value;
}
var DefaultTooltipContent = function DefaultTooltipContent2(props) {
  var _props$separator = props.separator, separator = _props$separator === void 0 ? " : " : _props$separator, _props$contentStyle = props.contentStyle, contentStyle = _props$contentStyle === void 0 ? {} : _props$contentStyle, _props$itemStyle = props.itemStyle, itemStyle = _props$itemStyle === void 0 ? {} : _props$itemStyle, _props$labelStyle = props.labelStyle, labelStyle = _props$labelStyle === void 0 ? {} : _props$labelStyle, payload = props.payload, formatter = props.formatter, itemSorter = props.itemSorter, wrapperClassName = props.wrapperClassName, labelClassName = props.labelClassName, label = props.label, labelFormatter = props.labelFormatter, _props$accessibilityL = props.accessibilityLayer, accessibilityLayer = _props$accessibilityL === void 0 ? false : _props$accessibilityL;
  var renderContent2 = function renderContent3() {
    if (payload && payload.length) {
      var listStyle = {
        padding: 0,
        margin: 0
      };
      var items = (itemSorter ? sortBy(payload, itemSorter) : payload).map(function(entry, i3) {
        if (entry.type === "none") {
          return null;
        }
        var finalItemStyle = _objectSpread$A({
          display: "block",
          paddingTop: 4,
          paddingBottom: 4,
          color: entry.color || "#000"
        }, itemStyle);
        var finalFormatter = entry.formatter || formatter || defaultFormatter;
        var value = entry.value, name = entry.name;
        var finalValue = value;
        var finalName = name;
        if (finalFormatter && finalValue != null && finalName != null) {
          var formatted = finalFormatter(value, name, entry, i3, payload);
          if (Array.isArray(formatted)) {
            var _formatted = _slicedToArray$c(formatted, 2);
            finalValue = _formatted[0];
            finalName = _formatted[1];
          } else {
            finalValue = formatted;
          }
        }
        return (
          // eslint-disable-next-line react/no-array-index-key
          /* @__PURE__ */ React__default.createElement("li", {
            className: "recharts-tooltip-item",
            key: "tooltip-item-".concat(i3),
            style: finalItemStyle
          }, isNumOrStr(finalName) ? /* @__PURE__ */ React__default.createElement("span", {
            className: "recharts-tooltip-item-name"
          }, finalName) : null, isNumOrStr(finalName) ? /* @__PURE__ */ React__default.createElement("span", {
            className: "recharts-tooltip-item-separator"
          }, separator) : null, /* @__PURE__ */ React__default.createElement("span", {
            className: "recharts-tooltip-item-value"
          }, finalValue), /* @__PURE__ */ React__default.createElement("span", {
            className: "recharts-tooltip-item-unit"
          }, entry.unit || ""))
        );
      });
      return /* @__PURE__ */ React__default.createElement("ul", {
        className: "recharts-tooltip-item-list",
        style: listStyle
      }, items);
    }
    return null;
  };
  var finalStyle = _objectSpread$A({
    margin: 0,
    padding: 10,
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    whiteSpace: "nowrap"
  }, contentStyle);
  var finalLabelStyle = _objectSpread$A({
    margin: 0
  }, labelStyle);
  var hasLabel = !isNil(label);
  var finalLabel = hasLabel ? label : "";
  var wrapperCN = clsx("recharts-default-tooltip", wrapperClassName);
  var labelCN = clsx("recharts-tooltip-label", labelClassName);
  if (hasLabel && labelFormatter && payload !== void 0 && payload !== null) {
    finalLabel = labelFormatter(label, payload);
  }
  var accessibilityAttributes = accessibilityLayer ? {
    role: "status",
    "aria-live": "assertive"
  } : {};
  return /* @__PURE__ */ React__default.createElement("div", _extends$r({
    className: wrapperCN,
    style: finalStyle
  }, accessibilityAttributes), /* @__PURE__ */ React__default.createElement("p", {
    className: labelCN,
    style: finalLabelStyle
  }, /* @__PURE__ */ React__default.isValidElement(finalLabel) ? finalLabel : "".concat(finalLabel)), renderContent2());
};
function _typeof$H(o2) {
  "@babel/helpers - typeof";
  return _typeof$H = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof$H(o2);
}
function _defineProperty$E(obj, key, value) {
  key = _toPropertyKey$F(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$F(t3) {
  var i3 = _toPrimitive$F(t3, "string");
  return "symbol" == _typeof$H(i3) ? i3 : i3 + "";
}
function _toPrimitive$F(t3, r2) {
  if ("object" != _typeof$H(t3) || !t3) return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i3 = e3.call(t3, r2);
    if ("object" != _typeof$H(i3)) return i3;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t3);
}
var CSS_CLASS_PREFIX = "recharts-tooltip-wrapper";
var TOOLTIP_HIDDEN = {
  visibility: "hidden"
};
function getTooltipCSSClassName(_ref) {
  var coordinate = _ref.coordinate, translateX = _ref.translateX, translateY = _ref.translateY;
  return clsx(CSS_CLASS_PREFIX, _defineProperty$E(_defineProperty$E(_defineProperty$E(_defineProperty$E({}, "".concat(CSS_CLASS_PREFIX, "-right"), isNumber(translateX) && coordinate && isNumber(coordinate.x) && translateX >= coordinate.x), "".concat(CSS_CLASS_PREFIX, "-left"), isNumber(translateX) && coordinate && isNumber(coordinate.x) && translateX < coordinate.x), "".concat(CSS_CLASS_PREFIX, "-bottom"), isNumber(translateY) && coordinate && isNumber(coordinate.y) && translateY >= coordinate.y), "".concat(CSS_CLASS_PREFIX, "-top"), isNumber(translateY) && coordinate && isNumber(coordinate.y) && translateY < coordinate.y));
}
function getTooltipTranslateXY(_ref2) {
  var allowEscapeViewBox = _ref2.allowEscapeViewBox, coordinate = _ref2.coordinate, key = _ref2.key, offsetTopLeft = _ref2.offsetTopLeft, position = _ref2.position, reverseDirection = _ref2.reverseDirection, tooltipDimension = _ref2.tooltipDimension, viewBox = _ref2.viewBox, viewBoxDimension = _ref2.viewBoxDimension;
  if (position && isNumber(position[key])) {
    return position[key];
  }
  var negative = coordinate[key] - tooltipDimension - offsetTopLeft;
  var positive = coordinate[key] + offsetTopLeft;
  if (allowEscapeViewBox[key]) {
    return reverseDirection[key] ? negative : positive;
  }
  if (reverseDirection[key]) {
    var _tooltipBoundary = negative;
    var _viewBoxBoundary = viewBox[key];
    if (_tooltipBoundary < _viewBoxBoundary) {
      return Math.max(positive, viewBox[key]);
    }
    return Math.max(negative, viewBox[key]);
  }
  var tooltipBoundary = positive + tooltipDimension;
  var viewBoxBoundary = viewBox[key] + viewBoxDimension;
  if (tooltipBoundary > viewBoxBoundary) {
    return Math.max(negative, viewBox[key]);
  }
  return Math.max(positive, viewBox[key]);
}
function getTransformStyle(_ref3) {
  var translateX = _ref3.translateX, translateY = _ref3.translateY, useTranslate3d = _ref3.useTranslate3d;
  return {
    transform: useTranslate3d ? "translate3d(".concat(translateX, "px, ").concat(translateY, "px, 0)") : "translate(".concat(translateX, "px, ").concat(translateY, "px)")
  };
}
function getTooltipTranslate(_ref4) {
  var allowEscapeViewBox = _ref4.allowEscapeViewBox, coordinate = _ref4.coordinate, offsetTopLeft = _ref4.offsetTopLeft, position = _ref4.position, reverseDirection = _ref4.reverseDirection, tooltipBox = _ref4.tooltipBox, useTranslate3d = _ref4.useTranslate3d, viewBox = _ref4.viewBox;
  var cssProperties, translateX, translateY;
  if (tooltipBox.height > 0 && tooltipBox.width > 0 && coordinate) {
    translateX = getTooltipTranslateXY({
      allowEscapeViewBox,
      coordinate,
      key: "x",
      offsetTopLeft,
      position,
      reverseDirection,
      tooltipDimension: tooltipBox.width,
      viewBox,
      viewBoxDimension: viewBox.width
    });
    translateY = getTooltipTranslateXY({
      allowEscapeViewBox,
      coordinate,
      key: "y",
      offsetTopLeft,
      position,
      reverseDirection,
      tooltipDimension: tooltipBox.height,
      viewBox,
      viewBoxDimension: viewBox.height
    });
    cssProperties = getTransformStyle({
      translateX,
      translateY,
      useTranslate3d
    });
  } else {
    cssProperties = TOOLTIP_HIDDEN;
  }
  return {
    cssProperties,
    cssClasses: getTooltipCSSClassName({
      translateX,
      translateY,
      coordinate
    })
  };
}
function _typeof$G(o2) {
  "@babel/helpers - typeof";
  return _typeof$G = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof$G(o2);
}
function ownKeys$z(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e3);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$z(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$z(Object(t3), true).forEach(function(r3) {
      _defineProperty$D(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$z(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
function _classCallCheck$k(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$k(target, props) {
  for (var i3 = 0; i3 < props.length; i3++) {
    var descriptor = props[i3];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$E(descriptor.key), descriptor);
  }
}
function _createClass$k(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$k(Constructor.prototype, protoProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _callSuper$g(t3, o2, e3) {
  return o2 = _getPrototypeOf$h(o2), _possibleConstructorReturn$h(t3, _isNativeReflectConstruct$h() ? Reflect.construct(o2, e3 || [], _getPrototypeOf$h(t3).constructor) : o2.apply(t3, e3));
}
function _possibleConstructorReturn$h(self2, call) {
  if (call && (_typeof$G(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$h(self2);
}
function _assertThisInitialized$h(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$h() {
  try {
    var t3 = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$h = function _isNativeReflectConstruct2() {
    return !!t3;
  })();
}
function _getPrototypeOf$h(o2) {
  _getPrototypeOf$h = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o3) {
    return o3.__proto__ || Object.getPrototypeOf(o3);
  };
  return _getPrototypeOf$h(o2);
}
function _inherits$h(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass) _setPrototypeOf$h(subClass, superClass);
}
function _setPrototypeOf$h(o2, p2) {
  _setPrototypeOf$h = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o3, p3) {
    o3.__proto__ = p3;
    return o3;
  };
  return _setPrototypeOf$h(o2, p2);
}
function _defineProperty$D(obj, key, value) {
  key = _toPropertyKey$E(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$E(t3) {
  var i3 = _toPrimitive$E(t3, "string");
  return "symbol" == _typeof$G(i3) ? i3 : i3 + "";
}
function _toPrimitive$E(t3, r2) {
  if ("object" != _typeof$G(t3) || !t3) return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i3 = e3.call(t3, r2);
    if ("object" != _typeof$G(i3)) return i3;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t3);
}
var EPSILON = 1;
var TooltipBoundingBox = /* @__PURE__ */ function(_PureComponent) {
  function TooltipBoundingBox2() {
    var _this;
    _classCallCheck$k(this, TooltipBoundingBox2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$g(this, TooltipBoundingBox2, [].concat(args));
    _defineProperty$D(_this, "state", {
      dismissed: false,
      dismissedAtCoordinate: {
        x: 0,
        y: 0
      },
      lastBoundingBox: {
        width: -1,
        height: -1
      }
    });
    _defineProperty$D(_this, "handleKeyDown", function(event) {
      if (event.key === "Escape") {
        var _this$props$coordinat, _this$props$coordinat2, _this$props$coordinat3, _this$props$coordinat4;
        _this.setState({
          dismissed: true,
          dismissedAtCoordinate: {
            x: (_this$props$coordinat = (_this$props$coordinat2 = _this.props.coordinate) === null || _this$props$coordinat2 === void 0 ? void 0 : _this$props$coordinat2.x) !== null && _this$props$coordinat !== void 0 ? _this$props$coordinat : 0,
            y: (_this$props$coordinat3 = (_this$props$coordinat4 = _this.props.coordinate) === null || _this$props$coordinat4 === void 0 ? void 0 : _this$props$coordinat4.y) !== null && _this$props$coordinat3 !== void 0 ? _this$props$coordinat3 : 0
          }
        });
      }
    });
    return _this;
  }
  _inherits$h(TooltipBoundingBox2, _PureComponent);
  return _createClass$k(TooltipBoundingBox2, [{
    key: "updateBBox",
    value: function updateBBox() {
      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var box = this.wrapperNode.getBoundingClientRect();
        if (Math.abs(box.width - this.state.lastBoundingBox.width) > EPSILON || Math.abs(box.height - this.state.lastBoundingBox.height) > EPSILON) {
          this.setState({
            lastBoundingBox: {
              width: box.width,
              height: box.height
            }
          });
        }
      } else if (this.state.lastBoundingBox.width !== -1 || this.state.lastBoundingBox.height !== -1) {
        this.setState({
          lastBoundingBox: {
            width: -1,
            height: -1
          }
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener("keydown", this.handleKeyDown);
      this.updateBBox();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("keydown", this.handleKeyDown);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this$props$coordinat5, _this$props$coordinat6;
      if (this.props.active) {
        this.updateBBox();
      }
      if (!this.state.dismissed) {
        return;
      }
      if (((_this$props$coordinat5 = this.props.coordinate) === null || _this$props$coordinat5 === void 0 ? void 0 : _this$props$coordinat5.x) !== this.state.dismissedAtCoordinate.x || ((_this$props$coordinat6 = this.props.coordinate) === null || _this$props$coordinat6 === void 0 ? void 0 : _this$props$coordinat6.y) !== this.state.dismissedAtCoordinate.y) {
        this.state.dismissed = false;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props, active = _this$props.active, allowEscapeViewBox = _this$props.allowEscapeViewBox, animationDuration = _this$props.animationDuration, animationEasing = _this$props.animationEasing, children = _this$props.children, coordinate = _this$props.coordinate, hasPayload = _this$props.hasPayload, isAnimationActive = _this$props.isAnimationActive, offset2 = _this$props.offset, position = _this$props.position, reverseDirection = _this$props.reverseDirection, useTranslate3d = _this$props.useTranslate3d, viewBox = _this$props.viewBox, wrapperStyle = _this$props.wrapperStyle;
      var _getTooltipTranslate = getTooltipTranslate({
        allowEscapeViewBox,
        coordinate,
        offsetTopLeft: offset2,
        position,
        reverseDirection,
        tooltipBox: this.state.lastBoundingBox,
        useTranslate3d,
        viewBox
      }), cssClasses = _getTooltipTranslate.cssClasses, cssProperties = _getTooltipTranslate.cssProperties;
      var outerStyle = _objectSpread$z(_objectSpread$z({
        transition: isAnimationActive && active ? "transform ".concat(animationDuration, "ms ").concat(animationEasing) : void 0
      }, cssProperties), {}, {
        pointerEvents: "none",
        visibility: !this.state.dismissed && active && hasPayload ? "visible" : "hidden",
        position: "absolute",
        top: 0,
        left: 0
      }, wrapperStyle);
      return (
        // This element allow listening to the `Escape` key.
        // See https://github.com/recharts/recharts/pull/2925
        /* @__PURE__ */ React__default.createElement("div", {
          tabIndex: -1,
          className: cssClasses,
          style: outerStyle,
          ref: function ref(node) {
            _this2.wrapperNode = node;
          }
        }, children)
      );
    }
  }]);
}(PureComponent);
var parseIsSsrByDefault = function parseIsSsrByDefault2() {
  return !(typeof window !== "undefined" && window.document && window.document.createElement && window.setTimeout);
};
var Global = {
  isSsr: parseIsSsrByDefault()
};
function _typeof$F(o2) {
  "@babel/helpers - typeof";
  return _typeof$F = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof$F(o2);
}
function ownKeys$y(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e3);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$y(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$y(Object(t3), true).forEach(function(r3) {
      _defineProperty$C(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$y(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
function _classCallCheck$j(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$j(target, props) {
  for (var i3 = 0; i3 < props.length; i3++) {
    var descriptor = props[i3];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$D(descriptor.key), descriptor);
  }
}
function _createClass$j(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$j(Constructor.prototype, protoProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _callSuper$f(t3, o2, e3) {
  return o2 = _getPrototypeOf$g(o2), _possibleConstructorReturn$g(t3, _isNativeReflectConstruct$g() ? Reflect.construct(o2, e3 || [], _getPrototypeOf$g(t3).constructor) : o2.apply(t3, e3));
}
function _possibleConstructorReturn$g(self2, call) {
  if (call && (_typeof$F(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$g(self2);
}
function _assertThisInitialized$g(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$g() {
  try {
    var t3 = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$g = function _isNativeReflectConstruct2() {
    return !!t3;
  })();
}
function _getPrototypeOf$g(o2) {
  _getPrototypeOf$g = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o3) {
    return o3.__proto__ || Object.getPrototypeOf(o3);
  };
  return _getPrototypeOf$g(o2);
}
function _inherits$g(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass) _setPrototypeOf$g(subClass, superClass);
}
function _setPrototypeOf$g(o2, p2) {
  _setPrototypeOf$g = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o3, p3) {
    o3.__proto__ = p3;
    return o3;
  };
  return _setPrototypeOf$g(o2, p2);
}
function _defineProperty$C(obj, key, value) {
  key = _toPropertyKey$D(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$D(t3) {
  var i3 = _toPrimitive$D(t3, "string");
  return "symbol" == _typeof$F(i3) ? i3 : i3 + "";
}
function _toPrimitive$D(t3, r2) {
  if ("object" != _typeof$F(t3) || !t3) return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i3 = e3.call(t3, r2);
    if ("object" != _typeof$F(i3)) return i3;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t3);
}
function defaultUniqBy(entry) {
  return entry.dataKey;
}
function renderContent(content, props) {
  if (/* @__PURE__ */ React__default.isValidElement(content)) {
    return /* @__PURE__ */ React__default.cloneElement(content, props);
  }
  if (typeof content === "function") {
    return /* @__PURE__ */ React__default.createElement(content, props);
  }
  return /* @__PURE__ */ React__default.createElement(DefaultTooltipContent, props);
}
var Tooltip$1 = /* @__PURE__ */ function(_PureComponent) {
  function Tooltip3() {
    _classCallCheck$j(this, Tooltip3);
    return _callSuper$f(this, Tooltip3, arguments);
  }
  _inherits$g(Tooltip3, _PureComponent);
  return _createClass$j(Tooltip3, [{
    key: "render",
    value: function render() {
      var _this = this;
      var _this$props = this.props, active = _this$props.active, allowEscapeViewBox = _this$props.allowEscapeViewBox, animationDuration = _this$props.animationDuration, animationEasing = _this$props.animationEasing, content = _this$props.content, coordinate = _this$props.coordinate, filterNull = _this$props.filterNull, isAnimationActive = _this$props.isAnimationActive, offset2 = _this$props.offset, payload = _this$props.payload, payloadUniqBy = _this$props.payloadUniqBy, position = _this$props.position, reverseDirection = _this$props.reverseDirection, useTranslate3d = _this$props.useTranslate3d, viewBox = _this$props.viewBox, wrapperStyle = _this$props.wrapperStyle;
      var finalPayload = payload !== null && payload !== void 0 ? payload : [];
      if (filterNull && finalPayload.length) {
        finalPayload = getUniqPayload(payload.filter(function(entry) {
          return entry.value != null && (entry.hide !== true || _this.props.includeHidden);
        }), payloadUniqBy, defaultUniqBy);
      }
      var hasPayload = finalPayload.length > 0;
      return /* @__PURE__ */ React__default.createElement(TooltipBoundingBox, {
        allowEscapeViewBox,
        animationDuration,
        animationEasing,
        isAnimationActive,
        active,
        coordinate,
        hasPayload,
        offset: offset2,
        position,
        reverseDirection,
        useTranslate3d,
        viewBox,
        wrapperStyle
      }, renderContent(content, _objectSpread$y(_objectSpread$y({}, this.props), {}, {
        payload: finalPayload
      })));
    }
  }]);
}(PureComponent);
_defineProperty$C(Tooltip$1, "displayName", "Tooltip");
_defineProperty$C(Tooltip$1, "defaultProps", {
  accessibilityLayer: false,
  allowEscapeViewBox: {
    x: false,
    y: false
  },
  animationDuration: 400,
  animationEasing: "ease",
  contentStyle: {},
  coordinate: {
    x: 0,
    y: 0
  },
  cursor: true,
  cursorStyle: {},
  filterNull: true,
  isAnimationActive: !Global.isSsr,
  itemStyle: {},
  labelStyle: {},
  offset: 10,
  reverseDirection: {
    x: false,
    y: false
  },
  separator: " : ",
  trigger: "hover",
  useTranslate3d: false,
  viewBox: {
    x: 0,
    y: 0,
    height: 0,
    width: 0
  },
  wrapperStyle: {}
});
var throttle_1;
var hasRequiredThrottle;
function requireThrottle() {
  if (hasRequiredThrottle) return throttle_1;
  hasRequiredThrottle = 1;
  var debounce2 = requireDebounce(), isObject2 = requireIsObject();
  var FUNC_ERROR_TEXT = "Expected a function";
  function throttle2(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") {
      throw new TypeError(FUNC_ERROR_TEXT);
    }
    if (isObject2(options)) {
      leading = "leading" in options ? !!options.leading : leading;
      trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return debounce2(func, wait, {
      "leading": leading,
      "maxWait": wait,
      "trailing": trailing
    });
  }
  throttle_1 = throttle2;
  return throttle_1;
}
var throttleExports = requireThrottle();
const throttle = /* @__PURE__ */ getDefaultExportFromCjs(throttleExports);
function _typeof$E(o2) {
  "@babel/helpers - typeof";
  return _typeof$E = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof$E(o2);
}
function ownKeys$x(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e3);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$x(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$x(Object(t3), true).forEach(function(r3) {
      _defineProperty$B(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$x(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
function _defineProperty$B(obj, key, value) {
  key = _toPropertyKey$C(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$C(t3) {
  var i3 = _toPrimitive$C(t3, "string");
  return "symbol" == _typeof$E(i3) ? i3 : i3 + "";
}
function _toPrimitive$C(t3, r2) {
  if ("object" != _typeof$E(t3) || !t3) return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i3 = e3.call(t3, r2);
    if ("object" != _typeof$E(i3)) return i3;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t3);
}
function _slicedToArray$b(arr, i3) {
  return _arrayWithHoles$c(arr) || _iterableToArrayLimit$b(arr, i3) || _unsupportedIterableToArray$k(arr, i3) || _nonIterableRest$c();
}
function _nonIterableRest$c() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$k(o2, minLen) {
  if (!o2) return;
  if (typeof o2 === "string") return _arrayLikeToArray$k(o2, minLen);
  var n2 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n2 === "Object" && o2.constructor) n2 = o2.constructor.name;
  if (n2 === "Map" || n2 === "Set") return Array.from(o2);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray$k(o2, minLen);
}
function _arrayLikeToArray$k(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i3 = 0, arr2 = new Array(len); i3 < len; i3++) arr2[i3] = arr[i3];
  return arr2;
}
function _iterableToArrayLimit$b(r2, l2) {
  var t3 = null == r2 ? null : "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];
  if (null != t3) {
    var e3, n2, i3, u3, a4 = [], f2 = true, o2 = false;
    try {
      if (i3 = (t3 = t3.call(r2)).next, 0 === l2) ;
      else for (; !(f2 = (e3 = i3.call(t3)).done) && (a4.push(e3.value), a4.length !== l2); f2 = true) ;
    } catch (r3) {
      o2 = true, n2 = r3;
    } finally {
      try {
        if (!f2 && null != t3["return"] && (u3 = t3["return"](), Object(u3) !== u3)) return;
      } finally {
        if (o2) throw n2;
      }
    }
    return a4;
  }
}
function _arrayWithHoles$c(arr) {
  if (Array.isArray(arr)) return arr;
}
var ResponsiveContainer = /* @__PURE__ */ forwardRef(function(_ref, ref) {
  var aspect = _ref.aspect, _ref$initialDimension = _ref.initialDimension, initialDimension = _ref$initialDimension === void 0 ? {
    width: -1,
    height: -1
  } : _ref$initialDimension, _ref$width = _ref.width, width = _ref$width === void 0 ? "100%" : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? "100%" : _ref$height, _ref$minWidth = _ref.minWidth, minWidth = _ref$minWidth === void 0 ? 0 : _ref$minWidth, minHeight = _ref.minHeight, maxHeight = _ref.maxHeight, children = _ref.children, _ref$debounce = _ref.debounce, debounce2 = _ref$debounce === void 0 ? 0 : _ref$debounce, id2 = _ref.id, className = _ref.className, onResize = _ref.onResize, _ref$style = _ref.style, style = _ref$style === void 0 ? {} : _ref$style;
  var containerRef = useRef(null);
  var onResizeRef = useRef();
  onResizeRef.current = onResize;
  useImperativeHandle(ref, function() {
    return Object.defineProperty(containerRef.current, "current", {
      get: function get2() {
        console.warn("The usage of ref.current.current is deprecated and will no longer be supported.");
        return containerRef.current;
      },
      configurable: true
    });
  });
  var _useState = useState({
    containerWidth: initialDimension.width,
    containerHeight: initialDimension.height
  }), _useState2 = _slicedToArray$b(_useState, 2), sizes = _useState2[0], setSizes = _useState2[1];
  var setContainerSize = useCallback(function(newWidth, newHeight) {
    setSizes(function(prevState) {
      var roundedWidth = Math.round(newWidth);
      var roundedHeight = Math.round(newHeight);
      if (prevState.containerWidth === roundedWidth && prevState.containerHeight === roundedHeight) {
        return prevState;
      }
      return {
        containerWidth: roundedWidth,
        containerHeight: roundedHeight
      };
    });
  }, []);
  useEffect(function() {
    var callback = function callback2(entries) {
      var _onResizeRef$current;
      var _entries$0$contentRec = entries[0].contentRect, containerWidth2 = _entries$0$contentRec.width, containerHeight2 = _entries$0$contentRec.height;
      setContainerSize(containerWidth2, containerHeight2);
      (_onResizeRef$current = onResizeRef.current) === null || _onResizeRef$current === void 0 || _onResizeRef$current.call(onResizeRef, containerWidth2, containerHeight2);
    };
    if (debounce2 > 0) {
      callback = throttle(callback, debounce2, {
        trailing: true,
        leading: false
      });
    }
    var observer = new ResizeObserver(callback);
    var _containerRef$current = containerRef.current.getBoundingClientRect(), containerWidth = _containerRef$current.width, containerHeight = _containerRef$current.height;
    setContainerSize(containerWidth, containerHeight);
    observer.observe(containerRef.current);
    return function() {
      observer.disconnect();
    };
  }, [setContainerSize, debounce2]);
  var chartContent = useMemo(function() {
    var containerWidth = sizes.containerWidth, containerHeight = sizes.containerHeight;
    if (containerWidth < 0 || containerHeight < 0) {
      return null;
    }
    warn$1(isPercent(width) || isPercent(height), "The width(%s) and height(%s) are both fixed numbers,\n       maybe you don't need to use a ResponsiveContainer.", width, height);
    warn$1(!aspect || aspect > 0, "The aspect(%s) must be greater than zero.", aspect);
    var calculatedWidth = isPercent(width) ? containerWidth : width;
    var calculatedHeight = isPercent(height) ? containerHeight : height;
    if (aspect && aspect > 0) {
      if (calculatedWidth) {
        calculatedHeight = calculatedWidth / aspect;
      } else if (calculatedHeight) {
        calculatedWidth = calculatedHeight * aspect;
      }
      if (maxHeight && calculatedHeight > maxHeight) {
        calculatedHeight = maxHeight;
      }
    }
    warn$1(calculatedWidth > 0 || calculatedHeight > 0, "The width(%s) and height(%s) of chart should be greater than 0,\n       please check the style of container, or the props width(%s) and height(%s),\n       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the\n       height and width.", calculatedWidth, calculatedHeight, width, height, minWidth, minHeight, aspect);
    var isCharts = !Array.isArray(children) && getDisplayName(children.type).endsWith("Chart");
    return React__default.Children.map(children, function(child) {
      if (/* @__PURE__ */ React__default.isValidElement(child)) {
        return /* @__PURE__ */ cloneElement(child, _objectSpread$x({
          width: calculatedWidth,
          height: calculatedHeight
        }, isCharts ? {
          style: _objectSpread$x({
            height: "100%",
            width: "100%",
            maxHeight: calculatedHeight,
            maxWidth: calculatedWidth
          }, child.props.style)
        } : {}));
      }
      return child;
    });
  }, [aspect, children, height, maxHeight, minHeight, minWidth, sizes, width]);
  return /* @__PURE__ */ React__default.createElement("div", {
    id: id2 ? "".concat(id2) : void 0,
    className: clsx("recharts-responsive-container", className),
    style: _objectSpread$x(_objectSpread$x({}, style), {}, {
      width,
      height,
      minWidth,
      minHeight,
      maxHeight
    }),
    ref: containerRef
  }, chartContent);
});
var Cell = function Cell2(_props) {
  return null;
};
Cell.displayName = "Cell";
function _typeof$D(o2) {
  "@babel/helpers - typeof";
  return _typeof$D = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof$D(o2);
}
function ownKeys$w(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e3);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$w(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$w(Object(t3), true).forEach(function(r3) {
      _defineProperty$A(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$w(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
function _defineProperty$A(obj, key, value) {
  key = _toPropertyKey$B(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$B(t3) {
  var i3 = _toPrimitive$B(t3, "string");
  return "symbol" == _typeof$D(i3) ? i3 : i3 + "";
}
function _toPrimitive$B(t3, r2) {
  if ("object" != _typeof$D(t3) || !t3) return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i3 = e3.call(t3, r2);
    if ("object" != _typeof$D(i3)) return i3;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t3);
}
var stringCache = {
  widthCache: {},
  cacheCount: 0
};
var MAX_CACHE_NUM = 2e3;
var SPAN_STYLE = {
  position: "absolute",
  top: "-20000px",
  left: 0,
  padding: 0,
  margin: 0,
  border: "none",
  whiteSpace: "pre"
};
var MEASUREMENT_SPAN_ID = "recharts_measurement_span";
function removeInvalidKeys(obj) {
  var copyObj = _objectSpread$w({}, obj);
  Object.keys(copyObj).forEach(function(key) {
    if (!copyObj[key]) {
      delete copyObj[key];
    }
  });
  return copyObj;
}
var getStringSize = function getStringSize2(text2) {
  var style = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (text2 === void 0 || text2 === null || Global.isSsr) {
    return {
      width: 0,
      height: 0
    };
  }
  var copyStyle = removeInvalidKeys(style);
  var cacheKey = JSON.stringify({
    text: text2,
    copyStyle
  });
  if (stringCache.widthCache[cacheKey]) {
    return stringCache.widthCache[cacheKey];
  }
  try {
    var measurementSpan = document.getElementById(MEASUREMENT_SPAN_ID);
    if (!measurementSpan) {
      measurementSpan = document.createElement("span");
      measurementSpan.setAttribute("id", MEASUREMENT_SPAN_ID);
      measurementSpan.setAttribute("aria-hidden", "true");
      document.body.appendChild(measurementSpan);
    }
    var measurementSpanStyle = _objectSpread$w(_objectSpread$w({}, SPAN_STYLE), copyStyle);
    Object.assign(measurementSpan.style, measurementSpanStyle);
    measurementSpan.textContent = "".concat(text2);
    var rect = measurementSpan.getBoundingClientRect();
    var result = {
      width: rect.width,
      height: rect.height
    };
    stringCache.widthCache[cacheKey] = result;
    if (++stringCache.cacheCount > MAX_CACHE_NUM) {
      stringCache.cacheCount = 0;
      stringCache.widthCache = {};
    }
    return result;
  } catch (e3) {
    return {
      width: 0,
      height: 0
    };
  }
};
var getOffset = function getOffset2(rect) {
  return {
    top: rect.top + window.scrollY - document.documentElement.clientTop,
    left: rect.left + window.scrollX - document.documentElement.clientLeft
  };
};
function _typeof$C(o2) {
  "@babel/helpers - typeof";
  return _typeof$C = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof$C(o2);
}
function _slicedToArray$a(arr, i3) {
  return _arrayWithHoles$b(arr) || _iterableToArrayLimit$a(arr, i3) || _unsupportedIterableToArray$j(arr, i3) || _nonIterableRest$b();
}
function _nonIterableRest$b() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$j(o2, minLen) {
  if (!o2) return;
  if (typeof o2 === "string") return _arrayLikeToArray$j(o2, minLen);
  var n2 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n2 === "Object" && o2.constructor) n2 = o2.constructor.name;
  if (n2 === "Map" || n2 === "Set") return Array.from(o2);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray$j(o2, minLen);
}
function _arrayLikeToArray$j(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i3 = 0, arr2 = new Array(len); i3 < len; i3++) arr2[i3] = arr[i3];
  return arr2;
}
function _iterableToArrayLimit$a(r2, l2) {
  var t3 = null == r2 ? null : "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];
  if (null != t3) {
    var e3, n2, i3, u3, a4 = [], f2 = true, o2 = false;
    try {
      if (i3 = (t3 = t3.call(r2)).next, 0 === l2) {
        if (Object(t3) !== t3) return;
        f2 = false;
      } else for (; !(f2 = (e3 = i3.call(t3)).done) && (a4.push(e3.value), a4.length !== l2); f2 = true) ;
    } catch (r3) {
      o2 = true, n2 = r3;
    } finally {
      try {
        if (!f2 && null != t3["return"] && (u3 = t3["return"](), Object(u3) !== u3)) return;
      } finally {
        if (o2) throw n2;
      }
    }
    return a4;
  }
}
function _arrayWithHoles$b(arr) {
  if (Array.isArray(arr)) return arr;
}
function _classCallCheck$i(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$i(target, props) {
  for (var i3 = 0; i3 < props.length; i3++) {
    var descriptor = props[i3];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$A(descriptor.key), descriptor);
  }
}
function _createClass$i(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$i(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$i(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$A(t3) {
  var i3 = _toPrimitive$A(t3, "string");
  return "symbol" == _typeof$C(i3) ? i3 : i3 + "";
}
function _toPrimitive$A(t3, r2) {
  if ("object" != _typeof$C(t3) || !t3) return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i3 = e3.call(t3, r2);
    if ("object" != _typeof$C(i3)) return i3;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t3);
}
var MULTIPLY_OR_DIVIDE_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([*/])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/;
var ADD_OR_SUBTRACT_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([+-])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/;
var CSS_LENGTH_UNIT_REGEX = /^px|cm|vh|vw|em|rem|%|mm|in|pt|pc|ex|ch|vmin|vmax|Q$/;
var NUM_SPLIT_REGEX = /(-?\d+(?:\.\d+)?)([a-zA-Z%]+)?/;
var CONVERSION_RATES = {
  cm: 96 / 2.54,
  mm: 96 / 25.4,
  pt: 96 / 72,
  pc: 96 / 6,
  "in": 96,
  Q: 96 / (2.54 * 40),
  px: 1
};
var FIXED_CSS_LENGTH_UNITS = Object.keys(CONVERSION_RATES);
var STR_NAN = "NaN";
function convertToPx(value, unit2) {
  return value * CONVERSION_RATES[unit2];
}
var DecimalCSS = /* @__PURE__ */ function() {
  function DecimalCSS2(num, unit2) {
    _classCallCheck$i(this, DecimalCSS2);
    this.num = num;
    this.unit = unit2;
    this.num = num;
    this.unit = unit2;
    if (Number.isNaN(num)) {
      this.unit = "";
    }
    if (unit2 !== "" && !CSS_LENGTH_UNIT_REGEX.test(unit2)) {
      this.num = NaN;
      this.unit = "";
    }
    if (FIXED_CSS_LENGTH_UNITS.includes(unit2)) {
      this.num = convertToPx(num, unit2);
      this.unit = "px";
    }
  }
  return _createClass$i(DecimalCSS2, [{
    key: "add",
    value: function add2(other) {
      if (this.unit !== other.unit) {
        return new DecimalCSS2(NaN, "");
      }
      return new DecimalCSS2(this.num + other.num, this.unit);
    }
  }, {
    key: "subtract",
    value: function subtract2(other) {
      if (this.unit !== other.unit) {
        return new DecimalCSS2(NaN, "");
      }
      return new DecimalCSS2(this.num - other.num, this.unit);
    }
  }, {
    key: "multiply",
    value: function multiply(other) {
      if (this.unit !== "" && other.unit !== "" && this.unit !== other.unit) {
        return new DecimalCSS2(NaN, "");
      }
      return new DecimalCSS2(this.num * other.num, this.unit || other.unit);
    }
  }, {
    key: "divide",
    value: function divide2(other) {
      if (this.unit !== "" && other.unit !== "" && this.unit !== other.unit) {
        return new DecimalCSS2(NaN, "");
      }
      return new DecimalCSS2(this.num / other.num, this.unit || other.unit);
    }
  }, {
    key: "toString",
    value: function toString2() {
      return "".concat(this.num).concat(this.unit);
    }
  }, {
    key: "isNaN",
    value: function isNaN2() {
      return Number.isNaN(this.num);
    }
  }], [{
    key: "parse",
    value: function parse2(str) {
      var _NUM_SPLIT_REGEX$exec;
      var _ref = (_NUM_SPLIT_REGEX$exec = NUM_SPLIT_REGEX.exec(str)) !== null && _NUM_SPLIT_REGEX$exec !== void 0 ? _NUM_SPLIT_REGEX$exec : [], _ref2 = _slicedToArray$a(_ref, 3), numStr = _ref2[1], unit2 = _ref2[2];
      return new DecimalCSS2(parseFloat(numStr), unit2 !== null && unit2 !== void 0 ? unit2 : "");
    }
  }]);
}();
function calculateArithmetic(expr) {
  if (expr.includes(STR_NAN)) {
    return STR_NAN;
  }
  var newExpr = expr;
  while (newExpr.includes("*") || newExpr.includes("/")) {
    var _MULTIPLY_OR_DIVIDE_R;
    var _ref3 = (_MULTIPLY_OR_DIVIDE_R = MULTIPLY_OR_DIVIDE_REGEX.exec(newExpr)) !== null && _MULTIPLY_OR_DIVIDE_R !== void 0 ? _MULTIPLY_OR_DIVIDE_R : [], _ref4 = _slicedToArray$a(_ref3, 4), leftOperand = _ref4[1], operator = _ref4[2], rightOperand = _ref4[3];
    var lTs = DecimalCSS.parse(leftOperand !== null && leftOperand !== void 0 ? leftOperand : "");
    var rTs = DecimalCSS.parse(rightOperand !== null && rightOperand !== void 0 ? rightOperand : "");
    var result = operator === "*" ? lTs.multiply(rTs) : lTs.divide(rTs);
    if (result.isNaN()) {
      return STR_NAN;
    }
    newExpr = newExpr.replace(MULTIPLY_OR_DIVIDE_REGEX, result.toString());
  }
  while (newExpr.includes("+") || /.-\d+(?:\.\d+)?/.test(newExpr)) {
    var _ADD_OR_SUBTRACT_REGE;
    var _ref5 = (_ADD_OR_SUBTRACT_REGE = ADD_OR_SUBTRACT_REGEX.exec(newExpr)) !== null && _ADD_OR_SUBTRACT_REGE !== void 0 ? _ADD_OR_SUBTRACT_REGE : [], _ref6 = _slicedToArray$a(_ref5, 4), _leftOperand = _ref6[1], _operator = _ref6[2], _rightOperand = _ref6[3];
    var _lTs = DecimalCSS.parse(_leftOperand !== null && _leftOperand !== void 0 ? _leftOperand : "");
    var _rTs = DecimalCSS.parse(_rightOperand !== null && _rightOperand !== void 0 ? _rightOperand : "");
    var _result = _operator === "+" ? _lTs.add(_rTs) : _lTs.subtract(_rTs);
    if (_result.isNaN()) {
      return STR_NAN;
    }
    newExpr = newExpr.replace(ADD_OR_SUBTRACT_REGEX, _result.toString());
  }
  return newExpr;
}
var PARENTHESES_REGEX = /\(([^()]*)\)/;
function calculateParentheses(expr) {
  var newExpr = expr;
  while (newExpr.includes("(")) {
    var _PARENTHESES_REGEX$ex = PARENTHESES_REGEX.exec(newExpr), _PARENTHESES_REGEX$ex2 = _slicedToArray$a(_PARENTHESES_REGEX$ex, 2), parentheticalExpression = _PARENTHESES_REGEX$ex2[1];
    newExpr = newExpr.replace(PARENTHESES_REGEX, calculateArithmetic(parentheticalExpression));
  }
  return newExpr;
}
function evaluateExpression(expression) {
  var newExpr = expression.replace(/\s+/g, "");
  newExpr = calculateParentheses(newExpr);
  newExpr = calculateArithmetic(newExpr);
  return newExpr;
}
function safeEvaluateExpression(expression) {
  try {
    return evaluateExpression(expression);
  } catch (e3) {
    return STR_NAN;
  }
}
function reduceCSSCalc(expression) {
  var result = safeEvaluateExpression(expression.slice(5, -1));
  if (result === STR_NAN) {
    return "";
  }
  return result;
}
var _excluded$f = ["x", "y", "lineHeight", "capHeight", "scaleToFit", "textAnchor", "verticalAnchor", "fill"], _excluded2$7 = ["dx", "dy", "angle", "className", "breakAll"];
function _extends$q() {
  _extends$q = Object.assign ? Object.assign.bind() : function(target) {
    for (var i3 = 1; i3 < arguments.length; i3++) {
      var source = arguments[i3];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$q.apply(this, arguments);
}
function _objectWithoutProperties$f(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$f(source, excluded);
  var key, i3;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i3 = 0; i3 < sourceSymbolKeys.length; i3++) {
      key = sourceSymbolKeys[i3];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$f(source, excluded) {
  if (source == null) return {};
  var target = {};
  for (var key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _slicedToArray$9(arr, i3) {
  return _arrayWithHoles$a(arr) || _iterableToArrayLimit$9(arr, i3) || _unsupportedIterableToArray$i(arr, i3) || _nonIterableRest$a();
}
function _nonIterableRest$a() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$i(o2, minLen) {
  if (!o2) return;
  if (typeof o2 === "string") return _arrayLikeToArray$i(o2, minLen);
  var n2 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n2 === "Object" && o2.constructor) n2 = o2.constructor.name;
  if (n2 === "Map" || n2 === "Set") return Array.from(o2);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray$i(o2, minLen);
}
function _arrayLikeToArray$i(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i3 = 0, arr2 = new Array(len); i3 < len; i3++) arr2[i3] = arr[i3];
  return arr2;
}
function _iterableToArrayLimit$9(r2, l2) {
  var t3 = null == r2 ? null : "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];
  if (null != t3) {
    var e3, n2, i3, u3, a4 = [], f2 = true, o2 = false;
    try {
      if (i3 = (t3 = t3.call(r2)).next, 0 === l2) {
        if (Object(t3) !== t3) return;
        f2 = false;
      } else for (; !(f2 = (e3 = i3.call(t3)).done) && (a4.push(e3.value), a4.length !== l2); f2 = true) ;
    } catch (r3) {
      o2 = true, n2 = r3;
    } finally {
      try {
        if (!f2 && null != t3["return"] && (u3 = t3["return"](), Object(u3) !== u3)) return;
      } finally {
        if (o2) throw n2;
      }
    }
    return a4;
  }
}
function _arrayWithHoles$a(arr) {
  if (Array.isArray(arr)) return arr;
}
var BREAKING_SPACES = /[ \f\n\r\t\v\u2028\u2029]+/;
var calculateWordWidths = function calculateWordWidths2(_ref) {
  var children = _ref.children, breakAll = _ref.breakAll, style = _ref.style;
  try {
    var words = [];
    if (!isNil(children)) {
      if (breakAll) {
        words = children.toString().split("");
      } else {
        words = children.toString().split(BREAKING_SPACES);
      }
    }
    var wordsWithComputedWidth = words.map(function(word) {
      return {
        word,
        width: getStringSize(word, style).width
      };
    });
    var spaceWidth = breakAll ? 0 : getStringSize(" ", style).width;
    return {
      wordsWithComputedWidth,
      spaceWidth
    };
  } catch (e3) {
    return null;
  }
};
var calculateWordsByLines = function calculateWordsByLines2(_ref2, initialWordsWithComputedWith, spaceWidth, lineWidth, scaleToFit) {
  var maxLines = _ref2.maxLines, children = _ref2.children, style = _ref2.style, breakAll = _ref2.breakAll;
  var shouldLimitLines = isNumber(maxLines);
  var text2 = children;
  var calculate = function calculate2() {
    var words = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return words.reduce(function(result2, _ref3) {
      var word = _ref3.word, width = _ref3.width;
      var currentLine = result2[result2.length - 1];
      if (currentLine && (lineWidth == null || scaleToFit || currentLine.width + width + spaceWidth < Number(lineWidth))) {
        currentLine.words.push(word);
        currentLine.width += width + spaceWidth;
      } else {
        var newLine = {
          words: [word],
          width
        };
        result2.push(newLine);
      }
      return result2;
    }, []);
  };
  var originalResult = calculate(initialWordsWithComputedWith);
  var findLongestLine = function findLongestLine2(words) {
    return words.reduce(function(a4, b3) {
      return a4.width > b3.width ? a4 : b3;
    });
  };
  if (!shouldLimitLines) {
    return originalResult;
  }
  var suffix = "…";
  var checkOverflow = function checkOverflow2(index2) {
    var tempText = text2.slice(0, index2);
    var words = calculateWordWidths({
      breakAll,
      style,
      children: tempText + suffix
    }).wordsWithComputedWidth;
    var result2 = calculate(words);
    var doesOverflow = result2.length > maxLines || findLongestLine(result2).width > Number(lineWidth);
    return [doesOverflow, result2];
  };
  var start = 0;
  var end = text2.length - 1;
  var iterations = 0;
  var trimmedResult;
  while (start <= end && iterations <= text2.length - 1) {
    var middle = Math.floor((start + end) / 2);
    var prev = middle - 1;
    var _checkOverflow = checkOverflow(prev), _checkOverflow2 = _slicedToArray$9(_checkOverflow, 2), doesPrevOverflow = _checkOverflow2[0], result = _checkOverflow2[1];
    var _checkOverflow3 = checkOverflow(middle), _checkOverflow4 = _slicedToArray$9(_checkOverflow3, 1), doesMiddleOverflow = _checkOverflow4[0];
    if (!doesPrevOverflow && !doesMiddleOverflow) {
      start = middle + 1;
    }
    if (doesPrevOverflow && doesMiddleOverflow) {
      end = middle - 1;
    }
    if (!doesPrevOverflow && doesMiddleOverflow) {
      trimmedResult = result;
      break;
    }
    iterations++;
  }
  return trimmedResult || originalResult;
};
var getWordsWithoutCalculate = function getWordsWithoutCalculate2(children) {
  var words = !isNil(children) ? children.toString().split(BREAKING_SPACES) : [];
  return [{
    words
  }];
};
var getWordsByLines = function getWordsByLines2(_ref4) {
  var width = _ref4.width, scaleToFit = _ref4.scaleToFit, children = _ref4.children, style = _ref4.style, breakAll = _ref4.breakAll, maxLines = _ref4.maxLines;
  if ((width || scaleToFit) && !Global.isSsr) {
    var wordsWithComputedWidth, spaceWidth;
    var wordWidths = calculateWordWidths({
      breakAll,
      children,
      style
    });
    if (wordWidths) {
      var wcw = wordWidths.wordsWithComputedWidth, sw = wordWidths.spaceWidth;
      wordsWithComputedWidth = wcw;
      spaceWidth = sw;
    } else {
      return getWordsWithoutCalculate(children);
    }
    return calculateWordsByLines({
      breakAll,
      children,
      maxLines,
      style
    }, wordsWithComputedWidth, spaceWidth, width, scaleToFit);
  }
  return getWordsWithoutCalculate(children);
};
var DEFAULT_FILL = "#808080";
var Text = function Text2(_ref5) {
  var _ref5$x = _ref5.x, propsX = _ref5$x === void 0 ? 0 : _ref5$x, _ref5$y = _ref5.y, propsY = _ref5$y === void 0 ? 0 : _ref5$y, _ref5$lineHeight = _ref5.lineHeight, lineHeight = _ref5$lineHeight === void 0 ? "1em" : _ref5$lineHeight, _ref5$capHeight = _ref5.capHeight, capHeight = _ref5$capHeight === void 0 ? "0.71em" : _ref5$capHeight, _ref5$scaleToFit = _ref5.scaleToFit, scaleToFit = _ref5$scaleToFit === void 0 ? false : _ref5$scaleToFit, _ref5$textAnchor = _ref5.textAnchor, textAnchor = _ref5$textAnchor === void 0 ? "start" : _ref5$textAnchor, _ref5$verticalAnchor = _ref5.verticalAnchor, verticalAnchor = _ref5$verticalAnchor === void 0 ? "end" : _ref5$verticalAnchor, _ref5$fill = _ref5.fill, fill = _ref5$fill === void 0 ? DEFAULT_FILL : _ref5$fill, props = _objectWithoutProperties$f(_ref5, _excluded$f);
  var wordsByLines = useMemo(function() {
    return getWordsByLines({
      breakAll: props.breakAll,
      children: props.children,
      maxLines: props.maxLines,
      scaleToFit,
      style: props.style,
      width: props.width
    });
  }, [props.breakAll, props.children, props.maxLines, scaleToFit, props.style, props.width]);
  var dx = props.dx, dy = props.dy, angle = props.angle, className = props.className, breakAll = props.breakAll, textProps = _objectWithoutProperties$f(props, _excluded2$7);
  if (!isNumOrStr(propsX) || !isNumOrStr(propsY)) {
    return null;
  }
  var x3 = propsX + (isNumber(dx) ? dx : 0);
  var y4 = propsY + (isNumber(dy) ? dy : 0);
  var startDy;
  switch (verticalAnchor) {
    case "start":
      startDy = reduceCSSCalc("calc(".concat(capHeight, ")"));
      break;
    case "middle":
      startDy = reduceCSSCalc("calc(".concat((wordsByLines.length - 1) / 2, " * -").concat(lineHeight, " + (").concat(capHeight, " / 2))"));
      break;
    default:
      startDy = reduceCSSCalc("calc(".concat(wordsByLines.length - 1, " * -").concat(lineHeight, ")"));
      break;
  }
  var transforms = [];
  if (scaleToFit) {
    var lineWidth = wordsByLines[0].width;
    var width = props.width;
    transforms.push("scale(".concat((isNumber(width) ? width / lineWidth : 1) / lineWidth, ")"));
  }
  if (angle) {
    transforms.push("rotate(".concat(angle, ", ").concat(x3, ", ").concat(y4, ")"));
  }
  if (transforms.length) {
    textProps.transform = transforms.join(" ");
  }
  return /* @__PURE__ */ React__default.createElement("text", _extends$q({}, filterProps(textProps, true), {
    x: x3,
    y: y4,
    className: clsx("recharts-text", className),
    textAnchor,
    fill: fill.includes("url") ? DEFAULT_FILL : fill
  }), wordsByLines.map(function(line, index2) {
    var words = line.words.join(breakAll ? "" : " ");
    return (
      // duplicate words will cause duplicate keys
      // eslint-disable-next-line react/no-array-index-key
      /* @__PURE__ */ React__default.createElement("tspan", {
        x: x3,
        dy: index2 === 0 ? startDy : lineHeight,
        key: "".concat(words, "-").concat(index2)
      }, words)
    );
  }));
};
function ascending(a4, b3) {
  return a4 == null || b3 == null ? NaN : a4 < b3 ? -1 : a4 > b3 ? 1 : a4 >= b3 ? 0 : NaN;
}
function descending(a4, b3) {
  return a4 == null || b3 == null ? NaN : b3 < a4 ? -1 : b3 > a4 ? 1 : b3 >= a4 ? 0 : NaN;
}
function bisector(f2) {
  let compare1, compare2, delta;
  if (f2.length !== 2) {
    compare1 = ascending;
    compare2 = (d4, x3) => ascending(f2(d4), x3);
    delta = (d4, x3) => f2(d4) - x3;
  } else {
    compare1 = f2 === ascending || f2 === descending ? f2 : zero$1;
    compare2 = f2;
    delta = f2;
  }
  function left(a4, x3, lo = 0, hi = a4.length) {
    if (lo < hi) {
      if (compare1(x3, x3) !== 0) return hi;
      do {
        const mid = lo + hi >>> 1;
        if (compare2(a4[mid], x3) < 0) lo = mid + 1;
        else hi = mid;
      } while (lo < hi);
    }
    return lo;
  }
  function right(a4, x3, lo = 0, hi = a4.length) {
    if (lo < hi) {
      if (compare1(x3, x3) !== 0) return hi;
      do {
        const mid = lo + hi >>> 1;
        if (compare2(a4[mid], x3) <= 0) lo = mid + 1;
        else hi = mid;
      } while (lo < hi);
    }
    return lo;
  }
  function center(a4, x3, lo = 0, hi = a4.length) {
    const i3 = left(a4, x3, lo, hi - 1);
    return i3 > lo && delta(a4[i3 - 1], x3) > -delta(a4[i3], x3) ? i3 - 1 : i3;
  }
  return { left, center, right };
}
function zero$1() {
  return 0;
}
function number$2(x3) {
  return x3 === null ? NaN : +x3;
}
function* numbers(values, valueof) {
  {
    for (let value of values) {
      if (value != null && (value = +value) >= value) {
        yield value;
      }
    }
  }
}
const ascendingBisect = bisector(ascending);
const bisectRight = ascendingBisect.right;
bisector(number$2).center;
class InternMap extends Map {
  constructor(entries, key = keyof) {
    super();
    Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: key } });
    if (entries != null) for (const [key2, value] of entries) this.set(key2, value);
  }
  get(key) {
    return super.get(intern_get(this, key));
  }
  has(key) {
    return super.has(intern_get(this, key));
  }
  set(key, value) {
    return super.set(intern_set(this, key), value);
  }
  delete(key) {
    return super.delete(intern_delete(this, key));
  }
}
function intern_get({ _intern, _key }, value) {
  const key = _key(value);
  return _intern.has(key) ? _intern.get(key) : value;
}
function intern_set({ _intern, _key }, value) {
  const key = _key(value);
  if (_intern.has(key)) return _intern.get(key);
  _intern.set(key, value);
  return value;
}
function intern_delete({ _intern, _key }, value) {
  const key = _key(value);
  if (_intern.has(key)) {
    value = _intern.get(key);
    _intern.delete(key);
  }
  return value;
}
function keyof(value) {
  return value !== null && typeof value === "object" ? value.valueOf() : value;
}
function compareDefined(compare = ascending) {
  if (compare === ascending) return ascendingDefined;
  if (typeof compare !== "function") throw new TypeError("compare is not a function");
  return (a4, b3) => {
    const x3 = compare(a4, b3);
    if (x3 || x3 === 0) return x3;
    return (compare(b3, b3) === 0) - (compare(a4, a4) === 0);
  };
}
function ascendingDefined(a4, b3) {
  return (a4 == null || !(a4 >= a4)) - (b3 == null || !(b3 >= b3)) || (a4 < b3 ? -1 : a4 > b3 ? 1 : 0);
}
const e10 = Math.sqrt(50), e5 = Math.sqrt(10), e22 = Math.sqrt(2);
function tickSpec(start, stop, count2) {
  const step = (stop - start) / Math.max(0, count2), power = Math.floor(Math.log10(step)), error = step / Math.pow(10, power), factor = error >= e10 ? 10 : error >= e5 ? 5 : error >= e22 ? 2 : 1;
  let i1, i22, inc;
  if (power < 0) {
    inc = Math.pow(10, -power) / factor;
    i1 = Math.round(start * inc);
    i22 = Math.round(stop * inc);
    if (i1 / inc < start) ++i1;
    if (i22 / inc > stop) --i22;
    inc = -inc;
  } else {
    inc = Math.pow(10, power) * factor;
    i1 = Math.round(start / inc);
    i22 = Math.round(stop / inc);
    if (i1 * inc < start) ++i1;
    if (i22 * inc > stop) --i22;
  }
  if (i22 < i1 && 0.5 <= count2 && count2 < 2) return tickSpec(start, stop, count2 * 2);
  return [i1, i22, inc];
}
function ticks(start, stop, count2) {
  stop = +stop, start = +start, count2 = +count2;
  if (!(count2 > 0)) return [];
  if (start === stop) return [start];
  const reverse3 = stop < start, [i1, i22, inc] = reverse3 ? tickSpec(stop, start, count2) : tickSpec(start, stop, count2);
  if (!(i22 >= i1)) return [];
  const n2 = i22 - i1 + 1, ticks2 = new Array(n2);
  if (reverse3) {
    if (inc < 0) for (let i3 = 0; i3 < n2; ++i3) ticks2[i3] = (i22 - i3) / -inc;
    else for (let i3 = 0; i3 < n2; ++i3) ticks2[i3] = (i22 - i3) * inc;
  } else {
    if (inc < 0) for (let i3 = 0; i3 < n2; ++i3) ticks2[i3] = (i1 + i3) / -inc;
    else for (let i3 = 0; i3 < n2; ++i3) ticks2[i3] = (i1 + i3) * inc;
  }
  return ticks2;
}
function tickIncrement(start, stop, count2) {
  stop = +stop, start = +start, count2 = +count2;
  return tickSpec(start, stop, count2)[2];
}
function tickStep(start, stop, count2) {
  stop = +stop, start = +start, count2 = +count2;
  const reverse3 = stop < start, inc = reverse3 ? tickIncrement(stop, start, count2) : tickIncrement(start, stop, count2);
  return (reverse3 ? -1 : 1) * (inc < 0 ? 1 / -inc : inc);
}
function max$1(values, valueof) {
  let max2;
  {
    for (const value of values) {
      if (value != null && (max2 < value || max2 === void 0 && value >= value)) {
        max2 = value;
      }
    }
  }
  return max2;
}
function min$1(values, valueof) {
  let min2;
  {
    for (const value of values) {
      if (value != null && (min2 > value || min2 === void 0 && value >= value)) {
        min2 = value;
      }
    }
  }
  return min2;
}
function quickselect(array2, k3, left = 0, right = Infinity, compare) {
  k3 = Math.floor(k3);
  left = Math.floor(Math.max(0, left));
  right = Math.floor(Math.min(array2.length - 1, right));
  if (!(left <= k3 && k3 <= right)) return array2;
  compare = compare === void 0 ? ascendingDefined : compareDefined(compare);
  while (right > left) {
    if (right - left > 600) {
      const n2 = right - left + 1;
      const m4 = k3 - left + 1;
      const z3 = Math.log(n2);
      const s4 = 0.5 * Math.exp(2 * z3 / 3);
      const sd = 0.5 * Math.sqrt(z3 * s4 * (n2 - s4) / n2) * (m4 - n2 / 2 < 0 ? -1 : 1);
      const newLeft = Math.max(left, Math.floor(k3 - m4 * s4 / n2 + sd));
      const newRight = Math.min(right, Math.floor(k3 + (n2 - m4) * s4 / n2 + sd));
      quickselect(array2, k3, newLeft, newRight, compare);
    }
    const t3 = array2[k3];
    let i3 = left;
    let j = right;
    swap(array2, left, k3);
    if (compare(array2[right], t3) > 0) swap(array2, left, right);
    while (i3 < j) {
      swap(array2, i3, j), ++i3, --j;
      while (compare(array2[i3], t3) < 0) ++i3;
      while (compare(array2[j], t3) > 0) --j;
    }
    if (compare(array2[left], t3) === 0) swap(array2, left, j);
    else ++j, swap(array2, j, right);
    if (j <= k3) left = j + 1;
    if (k3 <= j) right = j - 1;
  }
  return array2;
}
function swap(array2, i3, j) {
  const t3 = array2[i3];
  array2[i3] = array2[j];
  array2[j] = t3;
}
function quantile$1(values, p2, valueof) {
  values = Float64Array.from(numbers(values));
  if (!(n2 = values.length) || isNaN(p2 = +p2)) return;
  if (p2 <= 0 || n2 < 2) return min$1(values);
  if (p2 >= 1) return max$1(values);
  var n2, i3 = (n2 - 1) * p2, i0 = Math.floor(i3), value0 = max$1(quickselect(values, i0).subarray(0, i0 + 1)), value1 = min$1(values.subarray(i0 + 1));
  return value0 + (value1 - value0) * (i3 - i0);
}
function quantileSorted(values, p2, valueof = number$2) {
  if (!(n2 = values.length) || isNaN(p2 = +p2)) return;
  if (p2 <= 0 || n2 < 2) return +valueof(values[0], 0, values);
  if (p2 >= 1) return +valueof(values[n2 - 1], n2 - 1, values);
  var n2, i3 = (n2 - 1) * p2, i0 = Math.floor(i3), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
  return value0 + (value1 - value0) * (i3 - i0);
}
function range$2(start, stop, step) {
  start = +start, stop = +stop, step = (n2 = arguments.length) < 2 ? (stop = start, start = 0, 1) : n2 < 3 ? 1 : +step;
  var i3 = -1, n2 = Math.max(0, Math.ceil((stop - start) / step)) | 0, range3 = new Array(n2);
  while (++i3 < n2) {
    range3[i3] = start + i3 * step;
  }
  return range3;
}
function initRange(domain, range3) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(domain);
      break;
    default:
      this.range(range3).domain(domain);
      break;
  }
  return this;
}
function initInterpolator(domain, interpolator) {
  switch (arguments.length) {
    case 0:
      break;
    case 1: {
      if (typeof domain === "function") this.interpolator(domain);
      else this.range(domain);
      break;
    }
    default: {
      this.domain(domain);
      if (typeof interpolator === "function") this.interpolator(interpolator);
      else this.range(interpolator);
      break;
    }
  }
  return this;
}
const implicit = Symbol("implicit");
function ordinal() {
  var index2 = new InternMap(), domain = [], range3 = [], unknown = implicit;
  function scale2(d4) {
    let i3 = index2.get(d4);
    if (i3 === void 0) {
      if (unknown !== implicit) return unknown;
      index2.set(d4, i3 = domain.push(d4) - 1);
    }
    return range3[i3 % range3.length];
  }
  scale2.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [], index2 = new InternMap();
    for (const value of _) {
      if (index2.has(value)) continue;
      index2.set(value, domain.push(value) - 1);
    }
    return scale2;
  };
  scale2.range = function(_) {
    return arguments.length ? (range3 = Array.from(_), scale2) : range3.slice();
  };
  scale2.unknown = function(_) {
    return arguments.length ? (unknown = _, scale2) : unknown;
  };
  scale2.copy = function() {
    return ordinal(domain, range3).unknown(unknown);
  };
  initRange.apply(scale2, arguments);
  return scale2;
}
function band() {
  var scale2 = ordinal().unknown(void 0), domain = scale2.domain, ordinalRange = scale2.range, r0 = 0, r1 = 1, step, bandwidth, round2 = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
  delete scale2.unknown;
  function rescale() {
    var n2 = domain().length, reverse3 = r1 < r0, start = reverse3 ? r1 : r0, stop = reverse3 ? r0 : r1;
    step = (stop - start) / Math.max(1, n2 - paddingInner + paddingOuter * 2);
    if (round2) step = Math.floor(step);
    start += (stop - start - step * (n2 - paddingInner)) * align;
    bandwidth = step * (1 - paddingInner);
    if (round2) start = Math.round(start), bandwidth = Math.round(bandwidth);
    var values = range$2(n2).map(function(i3) {
      return start + step * i3;
    });
    return ordinalRange(reverse3 ? values.reverse() : values);
  }
  scale2.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };
  scale2.range = function(_) {
    return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [r0, r1];
  };
  scale2.rangeRound = function(_) {
    return [r0, r1] = _, r0 = +r0, r1 = +r1, round2 = true, rescale();
  };
  scale2.bandwidth = function() {
    return bandwidth;
  };
  scale2.step = function() {
    return step;
  };
  scale2.round = function(_) {
    return arguments.length ? (round2 = !!_, rescale()) : round2;
  };
  scale2.padding = function(_) {
    return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
  };
  scale2.paddingInner = function(_) {
    return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
  };
  scale2.paddingOuter = function(_) {
    return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
  };
  scale2.align = function(_) {
    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
  };
  scale2.copy = function() {
    return band(domain(), [r0, r1]).round(round2).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
  };
  return initRange.apply(rescale(), arguments);
}
function pointish(scale2) {
  var copy2 = scale2.copy;
  scale2.padding = scale2.paddingOuter;
  delete scale2.paddingInner;
  delete scale2.paddingOuter;
  scale2.copy = function() {
    return pointish(copy2());
  };
  return scale2;
}
function point() {
  return pointish(band.apply(null, arguments).paddingInner(1));
}
function define(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
}
function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) prototype[key] = definition[key];
  return prototype;
}
function Color() {
}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
define(Color, color, {
  copy(channels) {
    return Object.assign(new this.constructor(), this, channels);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: color_formatHex,
  // Deprecated! Use color.formatHex.
  formatHex: color_formatHex,
  formatHex8: color_formatHex8,
  formatHsl: color_formatHsl,
  formatRgb: color_formatRgb,
  toString: color_formatRgb
});
function color_formatHex() {
  return this.rgb().formatHex();
}
function color_formatHex8() {
  return this.rgb().formatHex8();
}
function color_formatHsl() {
  return hslConvert(this).formatHsl();
}
function color_formatRgb() {
  return this.rgb().formatRgb();
}
function color(format2) {
  var m4, l2;
  format2 = (format2 + "").trim().toLowerCase();
  return (m4 = reHex.exec(format2)) ? (l2 = m4[1].length, m4 = parseInt(m4[1], 16), l2 === 6 ? rgbn(m4) : l2 === 3 ? new Rgb(m4 >> 8 & 15 | m4 >> 4 & 240, m4 >> 4 & 15 | m4 & 240, (m4 & 15) << 4 | m4 & 15, 1) : l2 === 8 ? rgba(m4 >> 24 & 255, m4 >> 16 & 255, m4 >> 8 & 255, (m4 & 255) / 255) : l2 === 4 ? rgba(m4 >> 12 & 15 | m4 >> 8 & 240, m4 >> 8 & 15 | m4 >> 4 & 240, m4 >> 4 & 15 | m4 & 240, ((m4 & 15) << 4 | m4 & 15) / 255) : null) : (m4 = reRgbInteger.exec(format2)) ? new Rgb(m4[1], m4[2], m4[3], 1) : (m4 = reRgbPercent.exec(format2)) ? new Rgb(m4[1] * 255 / 100, m4[2] * 255 / 100, m4[3] * 255 / 100, 1) : (m4 = reRgbaInteger.exec(format2)) ? rgba(m4[1], m4[2], m4[3], m4[4]) : (m4 = reRgbaPercent.exec(format2)) ? rgba(m4[1] * 255 / 100, m4[2] * 255 / 100, m4[3] * 255 / 100, m4[4]) : (m4 = reHslPercent.exec(format2)) ? hsla(m4[1], m4[2] / 100, m4[3] / 100, 1) : (m4 = reHslaPercent.exec(format2)) ? hsla(m4[1], m4[2] / 100, m4[3] / 100, m4[4]) : named.hasOwnProperty(format2) ? rgbn(named[format2]) : format2 === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n2) {
  return new Rgb(n2 >> 16 & 255, n2 >> 8 & 255, n2 & 255, 1);
}
function rgba(r2, g2, b3, a4) {
  if (a4 <= 0) r2 = g2 = b3 = NaN;
  return new Rgb(r2, g2, b3, a4);
}
function rgbConvert(o2) {
  if (!(o2 instanceof Color)) o2 = color(o2);
  if (!o2) return new Rgb();
  o2 = o2.rgb();
  return new Rgb(o2.r, o2.g, o2.b, o2.opacity);
}
function rgb$1(r2, g2, b3, opacity) {
  return arguments.length === 1 ? rgbConvert(r2) : new Rgb(r2, g2, b3, opacity == null ? 1 : opacity);
}
function Rgb(r2, g2, b3, opacity) {
  this.r = +r2;
  this.g = +g2;
  this.b = +b3;
  this.opacity = +opacity;
}
define(Rgb, rgb$1, extend(Color, {
  brighter(k3) {
    k3 = k3 == null ? brighter : Math.pow(brighter, k3);
    return new Rgb(this.r * k3, this.g * k3, this.b * k3, this.opacity);
  },
  darker(k3) {
    k3 = k3 == null ? darker : Math.pow(darker, k3);
    return new Rgb(this.r * k3, this.g * k3, this.b * k3, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && (-0.5 <= this.g && this.g < 255.5) && (-0.5 <= this.b && this.b < 255.5) && (0 <= this.opacity && this.opacity <= 1);
  },
  hex: rgb_formatHex,
  // Deprecated! Use color.formatHex.
  formatHex: rgb_formatHex,
  formatHex8: rgb_formatHex8,
  formatRgb: rgb_formatRgb,
  toString: rgb_formatRgb
}));
function rgb_formatHex() {
  return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
  return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
  const a4 = clampa(this.opacity);
  return `${a4 === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a4 === 1 ? ")" : `, ${a4})`}`;
}
function clampa(opacity) {
  return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
  return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
  value = clampi(value);
  return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h4, s4, l2, a4) {
  if (a4 <= 0) h4 = s4 = l2 = NaN;
  else if (l2 <= 0 || l2 >= 1) h4 = s4 = NaN;
  else if (s4 <= 0) h4 = NaN;
  return new Hsl(h4, s4, l2, a4);
}
function hslConvert(o2) {
  if (o2 instanceof Hsl) return new Hsl(o2.h, o2.s, o2.l, o2.opacity);
  if (!(o2 instanceof Color)) o2 = color(o2);
  if (!o2) return new Hsl();
  if (o2 instanceof Hsl) return o2;
  o2 = o2.rgb();
  var r2 = o2.r / 255, g2 = o2.g / 255, b3 = o2.b / 255, min2 = Math.min(r2, g2, b3), max2 = Math.max(r2, g2, b3), h4 = NaN, s4 = max2 - min2, l2 = (max2 + min2) / 2;
  if (s4) {
    if (r2 === max2) h4 = (g2 - b3) / s4 + (g2 < b3) * 6;
    else if (g2 === max2) h4 = (b3 - r2) / s4 + 2;
    else h4 = (r2 - g2) / s4 + 4;
    s4 /= l2 < 0.5 ? max2 + min2 : 2 - max2 - min2;
    h4 *= 60;
  } else {
    s4 = l2 > 0 && l2 < 1 ? 0 : h4;
  }
  return new Hsl(h4, s4, l2, o2.opacity);
}
function hsl(h4, s4, l2, opacity) {
  return arguments.length === 1 ? hslConvert(h4) : new Hsl(h4, s4, l2, opacity == null ? 1 : opacity);
}
function Hsl(h4, s4, l2, opacity) {
  this.h = +h4;
  this.s = +s4;
  this.l = +l2;
  this.opacity = +opacity;
}
define(Hsl, hsl, extend(Color, {
  brighter(k3) {
    k3 = k3 == null ? brighter : Math.pow(brighter, k3);
    return new Hsl(this.h, this.s, this.l * k3, this.opacity);
  },
  darker(k3) {
    k3 = k3 == null ? darker : Math.pow(darker, k3);
    return new Hsl(this.h, this.s, this.l * k3, this.opacity);
  },
  rgb() {
    var h4 = this.h % 360 + (this.h < 0) * 360, s4 = isNaN(h4) || isNaN(this.s) ? 0 : this.s, l2 = this.l, m22 = l2 + (l2 < 0.5 ? l2 : 1 - l2) * s4, m1 = 2 * l2 - m22;
    return new Rgb(
      hsl2rgb(h4 >= 240 ? h4 - 240 : h4 + 120, m1, m22),
      hsl2rgb(h4, m1, m22),
      hsl2rgb(h4 < 120 ? h4 + 240 : h4 - 120, m1, m22),
      this.opacity
    );
  },
  clamp() {
    return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && (0 <= this.l && this.l <= 1) && (0 <= this.opacity && this.opacity <= 1);
  },
  formatHsl() {
    const a4 = clampa(this.opacity);
    return `${a4 === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a4 === 1 ? ")" : `, ${a4})`}`;
  }
}));
function clamph(value) {
  value = (value || 0) % 360;
  return value < 0 ? value + 360 : value;
}
function clampt(value) {
  return Math.max(0, Math.min(1, value || 0));
}
function hsl2rgb(h4, m1, m22) {
  return (h4 < 60 ? m1 + (m22 - m1) * h4 / 60 : h4 < 180 ? m22 : h4 < 240 ? m1 + (m22 - m1) * (240 - h4) / 60 : m1) * 255;
}
const constant = (x3) => () => x3;
function linear$1(a4, d4) {
  return function(t3) {
    return a4 + t3 * d4;
  };
}
function exponential(a4, b3, y4) {
  return a4 = Math.pow(a4, y4), b3 = Math.pow(b3, y4) - a4, y4 = 1 / y4, function(t3) {
    return Math.pow(a4 + t3 * b3, y4);
  };
}
function gamma(y4) {
  return (y4 = +y4) === 1 ? nogamma : function(a4, b3) {
    return b3 - a4 ? exponential(a4, b3, y4) : constant(isNaN(a4) ? b3 : a4);
  };
}
function nogamma(a4, b3) {
  var d4 = b3 - a4;
  return d4 ? linear$1(a4, d4) : constant(isNaN(a4) ? b3 : a4);
}
const rgb = function rgbGamma(y4) {
  var color2 = gamma(y4);
  function rgb2(start, end) {
    var r2 = color2((start = rgb$1(start)).r, (end = rgb$1(end)).r), g2 = color2(start.g, end.g), b3 = color2(start.b, end.b), opacity = nogamma(start.opacity, end.opacity);
    return function(t3) {
      start.r = r2(t3);
      start.g = g2(t3);
      start.b = b3(t3);
      start.opacity = opacity(t3);
      return start + "";
    };
  }
  rgb2.gamma = rgbGamma;
  return rgb2;
}(1);
function numberArray(a4, b3) {
  if (!b3) b3 = [];
  var n2 = a4 ? Math.min(b3.length, a4.length) : 0, c3 = b3.slice(), i3;
  return function(t3) {
    for (i3 = 0; i3 < n2; ++i3) c3[i3] = a4[i3] * (1 - t3) + b3[i3] * t3;
    return c3;
  };
}
function isNumberArray(x3) {
  return ArrayBuffer.isView(x3) && !(x3 instanceof DataView);
}
function genericArray(a4, b3) {
  var nb = b3 ? b3.length : 0, na = a4 ? Math.min(nb, a4.length) : 0, x3 = new Array(na), c3 = new Array(nb), i3;
  for (i3 = 0; i3 < na; ++i3) x3[i3] = interpolate(a4[i3], b3[i3]);
  for (; i3 < nb; ++i3) c3[i3] = b3[i3];
  return function(t3) {
    for (i3 = 0; i3 < na; ++i3) c3[i3] = x3[i3](t3);
    return c3;
  };
}
function date$1(a4, b3) {
  var d4 = /* @__PURE__ */ new Date();
  return a4 = +a4, b3 = +b3, function(t3) {
    return d4.setTime(a4 * (1 - t3) + b3 * t3), d4;
  };
}
function interpolateNumber$1(a4, b3) {
  return a4 = +a4, b3 = +b3, function(t3) {
    return a4 * (1 - t3) + b3 * t3;
  };
}
function object(a4, b3) {
  var i3 = {}, c3 = {}, k3;
  if (a4 === null || typeof a4 !== "object") a4 = {};
  if (b3 === null || typeof b3 !== "object") b3 = {};
  for (k3 in b3) {
    if (k3 in a4) {
      i3[k3] = interpolate(a4[k3], b3[k3]);
    } else {
      c3[k3] = b3[k3];
    }
  }
  return function(t3) {
    for (k3 in i3) c3[k3] = i3[k3](t3);
    return c3;
  };
}
var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, reB = new RegExp(reA.source, "g");
function zero(b3) {
  return function() {
    return b3;
  };
}
function one(b3) {
  return function(t3) {
    return b3(t3) + "";
  };
}
function string(a4, b3) {
  var bi = reA.lastIndex = reB.lastIndex = 0, am, bm, bs, i3 = -1, s4 = [], q2 = [];
  a4 = a4 + "", b3 = b3 + "";
  while ((am = reA.exec(a4)) && (bm = reB.exec(b3))) {
    if ((bs = bm.index) > bi) {
      bs = b3.slice(bi, bs);
      if (s4[i3]) s4[i3] += bs;
      else s4[++i3] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) {
      if (s4[i3]) s4[i3] += bm;
      else s4[++i3] = bm;
    } else {
      s4[++i3] = null;
      q2.push({ i: i3, x: interpolateNumber$1(am, bm) });
    }
    bi = reB.lastIndex;
  }
  if (bi < b3.length) {
    bs = b3.slice(bi);
    if (s4[i3]) s4[i3] += bs;
    else s4[++i3] = bs;
  }
  return s4.length < 2 ? q2[0] ? one(q2[0].x) : zero(b3) : (b3 = q2.length, function(t3) {
    for (var i4 = 0, o2; i4 < b3; ++i4) s4[(o2 = q2[i4]).i] = o2.x(t3);
    return s4.join("");
  });
}
function interpolate(a4, b3) {
  var t3 = typeof b3, c3;
  return b3 == null || t3 === "boolean" ? constant(b3) : (t3 === "number" ? interpolateNumber$1 : t3 === "string" ? (c3 = color(b3)) ? (b3 = c3, rgb) : string : b3 instanceof color ? rgb : b3 instanceof Date ? date$1 : isNumberArray(b3) ? numberArray : Array.isArray(b3) ? genericArray : typeof b3.valueOf !== "function" && typeof b3.toString !== "function" || isNaN(b3) ? object : interpolateNumber$1)(a4, b3);
}
function interpolateRound(a4, b3) {
  return a4 = +a4, b3 = +b3, function(t3) {
    return Math.round(a4 * (1 - t3) + b3 * t3);
  };
}
function piecewise(interpolate$12, values) {
  if (values === void 0) values = interpolate$12, interpolate$12 = interpolate;
  var i3 = 0, n2 = values.length - 1, v2 = values[0], I2 = new Array(n2 < 0 ? 0 : n2);
  while (i3 < n2) I2[i3] = interpolate$12(v2, v2 = values[++i3]);
  return function(t3) {
    var i4 = Math.max(0, Math.min(n2 - 1, Math.floor(t3 *= n2)));
    return I2[i4](t3 - i4);
  };
}
function constants(x3) {
  return function() {
    return x3;
  };
}
function number$1(x3) {
  return +x3;
}
var unit = [0, 1];
function identity$4(x3) {
  return x3;
}
function normalize(a4, b3) {
  return (b3 -= a4 = +a4) ? function(x3) {
    return (x3 - a4) / b3;
  } : constants(isNaN(b3) ? NaN : 0.5);
}
function clamper(a4, b3) {
  var t3;
  if (a4 > b3) t3 = a4, a4 = b3, b3 = t3;
  return function(x3) {
    return Math.max(a4, Math.min(b3, x3));
  };
}
function bimap(domain, range3, interpolate2) {
  var d0 = domain[0], d1 = domain[1], r0 = range3[0], r1 = range3[1];
  if (d1 < d0) d0 = normalize(d1, d0), r0 = interpolate2(r1, r0);
  else d0 = normalize(d0, d1), r0 = interpolate2(r0, r1);
  return function(x3) {
    return r0(d0(x3));
  };
}
function polymap(domain, range3, interpolate2) {
  var j = Math.min(domain.length, range3.length) - 1, d4 = new Array(j), r2 = new Array(j), i3 = -1;
  if (domain[j] < domain[0]) {
    domain = domain.slice().reverse();
    range3 = range3.slice().reverse();
  }
  while (++i3 < j) {
    d4[i3] = normalize(domain[i3], domain[i3 + 1]);
    r2[i3] = interpolate2(range3[i3], range3[i3 + 1]);
  }
  return function(x3) {
    var i4 = bisectRight(domain, x3, 1, j) - 1;
    return r2[i4](d4[i4](x3));
  };
}
function copy$1(source, target) {
  return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function transformer$2() {
  var domain = unit, range3 = unit, interpolate$12 = interpolate, transform, untransform, unknown, clamp2 = identity$4, piecewise2, output, input;
  function rescale() {
    var n2 = Math.min(domain.length, range3.length);
    if (clamp2 !== identity$4) clamp2 = clamper(domain[0], domain[n2 - 1]);
    piecewise2 = n2 > 2 ? polymap : bimap;
    output = input = null;
    return scale2;
  }
  function scale2(x3) {
    return x3 == null || isNaN(x3 = +x3) ? unknown : (output || (output = piecewise2(domain.map(transform), range3, interpolate$12)))(transform(clamp2(x3)));
  }
  scale2.invert = function(y4) {
    return clamp2(untransform((input || (input = piecewise2(range3, domain.map(transform), interpolateNumber$1)))(y4)));
  };
  scale2.domain = function(_) {
    return arguments.length ? (domain = Array.from(_, number$1), rescale()) : domain.slice();
  };
  scale2.range = function(_) {
    return arguments.length ? (range3 = Array.from(_), rescale()) : range3.slice();
  };
  scale2.rangeRound = function(_) {
    return range3 = Array.from(_), interpolate$12 = interpolateRound, rescale();
  };
  scale2.clamp = function(_) {
    return arguments.length ? (clamp2 = _ ? true : identity$4, rescale()) : clamp2 !== identity$4;
  };
  scale2.interpolate = function(_) {
    return arguments.length ? (interpolate$12 = _, rescale()) : interpolate$12;
  };
  scale2.unknown = function(_) {
    return arguments.length ? (unknown = _, scale2) : unknown;
  };
  return function(t3, u3) {
    transform = t3, untransform = u3;
    return rescale();
  };
}
function continuous() {
  return transformer$2()(identity$4, identity$4);
}
function formatDecimal(x3) {
  return Math.abs(x3 = Math.round(x3)) >= 1e21 ? x3.toLocaleString("en").replace(/,/g, "") : x3.toString(10);
}
function formatDecimalParts(x3, p2) {
  if ((i3 = (x3 = p2 ? x3.toExponential(p2 - 1) : x3.toExponential()).indexOf("e")) < 0) return null;
  var i3, coefficient = x3.slice(0, i3);
  return [
    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
    +x3.slice(i3 + 1)
  ];
}
function exponent(x3) {
  return x3 = formatDecimalParts(Math.abs(x3)), x3 ? x3[1] : NaN;
}
function formatGroup(grouping, thousands) {
  return function(value, width) {
    var i3 = value.length, t3 = [], j = 0, g2 = grouping[0], length = 0;
    while (i3 > 0 && g2 > 0) {
      if (length + g2 + 1 > width) g2 = Math.max(1, width - length);
      t3.push(value.substring(i3 -= g2, i3 + g2));
      if ((length += g2 + 1) > width) break;
      g2 = grouping[j = (j + 1) % grouping.length];
    }
    return t3.reverse().join(thousands);
  };
}
function formatNumerals(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i3) {
      return numerals[+i3];
    });
  };
}
var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function formatSpecifier(specifier) {
  if (!(match2 = re.exec(specifier))) throw new Error("invalid format: " + specifier);
  var match2;
  return new FormatSpecifier({
    fill: match2[1],
    align: match2[2],
    sign: match2[3],
    symbol: match2[4],
    zero: match2[5],
    width: match2[6],
    comma: match2[7],
    precision: match2[8] && match2[8].slice(1),
    trim: match2[9],
    type: match2[10]
  });
}
formatSpecifier.prototype = FormatSpecifier.prototype;
function FormatSpecifier(specifier) {
  this.fill = specifier.fill === void 0 ? " " : specifier.fill + "";
  this.align = specifier.align === void 0 ? ">" : specifier.align + "";
  this.sign = specifier.sign === void 0 ? "-" : specifier.sign + "";
  this.symbol = specifier.symbol === void 0 ? "" : specifier.symbol + "";
  this.zero = !!specifier.zero;
  this.width = specifier.width === void 0 ? void 0 : +specifier.width;
  this.comma = !!specifier.comma;
  this.precision = specifier.precision === void 0 ? void 0 : +specifier.precision;
  this.trim = !!specifier.trim;
  this.type = specifier.type === void 0 ? "" : specifier.type + "";
}
FormatSpecifier.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function formatTrim(s4) {
  out: for (var n2 = s4.length, i3 = 1, i0 = -1, i1; i3 < n2; ++i3) {
    switch (s4[i3]) {
      case ".":
        i0 = i1 = i3;
        break;
      case "0":
        if (i0 === 0) i0 = i3;
        i1 = i3;
        break;
      default:
        if (!+s4[i3]) break out;
        if (i0 > 0) i0 = 0;
        break;
    }
  }
  return i0 > 0 ? s4.slice(0, i0) + s4.slice(i1 + 1) : s4;
}
var prefixExponent;
function formatPrefixAuto(x3, p2) {
  var d4 = formatDecimalParts(x3, p2);
  if (!d4) return x3 + "";
  var coefficient = d4[0], exponent2 = d4[1], i3 = exponent2 - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent2 / 3))) * 3) + 1, n2 = coefficient.length;
  return i3 === n2 ? coefficient : i3 > n2 ? coefficient + new Array(i3 - n2 + 1).join("0") : i3 > 0 ? coefficient.slice(0, i3) + "." + coefficient.slice(i3) : "0." + new Array(1 - i3).join("0") + formatDecimalParts(x3, Math.max(0, p2 + i3 - 1))[0];
}
function formatRounded(x3, p2) {
  var d4 = formatDecimalParts(x3, p2);
  if (!d4) return x3 + "";
  var coefficient = d4[0], exponent2 = d4[1];
  return exponent2 < 0 ? "0." + new Array(-exponent2).join("0") + coefficient : coefficient.length > exponent2 + 1 ? coefficient.slice(0, exponent2 + 1) + "." + coefficient.slice(exponent2 + 1) : coefficient + new Array(exponent2 - coefficient.length + 2).join("0");
}
const formatTypes = {
  "%": (x3, p2) => (x3 * 100).toFixed(p2),
  "b": (x3) => Math.round(x3).toString(2),
  "c": (x3) => x3 + "",
  "d": formatDecimal,
  "e": (x3, p2) => x3.toExponential(p2),
  "f": (x3, p2) => x3.toFixed(p2),
  "g": (x3, p2) => x3.toPrecision(p2),
  "o": (x3) => Math.round(x3).toString(8),
  "p": (x3, p2) => formatRounded(x3 * 100, p2),
  "r": formatRounded,
  "s": formatPrefixAuto,
  "X": (x3) => Math.round(x3).toString(16).toUpperCase(),
  "x": (x3) => Math.round(x3).toString(16)
};
function identity$3(x3) {
  return x3;
}
var map$1 = Array.prototype.map, prefixes = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function formatLocale$1(locale2) {
  var group = locale2.grouping === void 0 || locale2.thousands === void 0 ? identity$3 : formatGroup(map$1.call(locale2.grouping, Number), locale2.thousands + ""), currencyPrefix = locale2.currency === void 0 ? "" : locale2.currency[0] + "", currencySuffix = locale2.currency === void 0 ? "" : locale2.currency[1] + "", decimal = locale2.decimal === void 0 ? "." : locale2.decimal + "", numerals = locale2.numerals === void 0 ? identity$3 : formatNumerals(map$1.call(locale2.numerals, String)), percent2 = locale2.percent === void 0 ? "%" : locale2.percent + "", minus = locale2.minus === void 0 ? "−" : locale2.minus + "", nan = locale2.nan === void 0 ? "NaN" : locale2.nan + "";
  function newFormat(specifier) {
    specifier = formatSpecifier(specifier);
    var fill = specifier.fill, align = specifier.align, sign2 = specifier.sign, symbol = specifier.symbol, zero2 = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
    if (type === "n") comma = true, type = "g";
    else if (!formatTypes[type]) precision === void 0 && (precision = 12), trim = true, type = "g";
    if (zero2 || fill === "0" && align === "=") zero2 = true, fill = "0", align = "=";
    var prefix2 = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent2 : "";
    var formatType = formatTypes[type], maybeSuffix = /[defgprs%]/.test(type);
    precision = precision === void 0 ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
    function format2(value) {
      var valuePrefix = prefix2, valueSuffix = suffix, i3, n2, c3;
      if (type === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;
        var valueNegative = value < 0 || 1 / value < 0;
        value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
        if (trim) value = formatTrim(value);
        if (valueNegative && +value === 0 && sign2 !== "+") valueNegative = false;
        valuePrefix = (valueNegative ? sign2 === "(" ? sign2 : minus : sign2 === "-" || sign2 === "(" ? "" : sign2) + valuePrefix;
        valueSuffix = (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign2 === "(" ? ")" : "");
        if (maybeSuffix) {
          i3 = -1, n2 = value.length;
          while (++i3 < n2) {
            if (c3 = value.charCodeAt(i3), 48 > c3 || c3 > 57) {
              valueSuffix = (c3 === 46 ? decimal + value.slice(i3 + 1) : value.slice(i3)) + valueSuffix;
              value = value.slice(0, i3);
              break;
            }
          }
        }
      }
      if (comma && !zero2) value = group(value, Infinity);
      var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
      if (comma && zero2) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
      switch (align) {
        case "<":
          value = valuePrefix + value + valueSuffix + padding;
          break;
        case "=":
          value = valuePrefix + padding + value + valueSuffix;
          break;
        case "^":
          value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
          break;
        default:
          value = padding + valuePrefix + value + valueSuffix;
          break;
      }
      return numerals(value);
    }
    format2.toString = function() {
      return specifier + "";
    };
    return format2;
  }
  function formatPrefix2(specifier, value) {
    var f2 = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)), e3 = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3, k3 = Math.pow(10, -e3), prefix2 = prefixes[8 + e3 / 3];
    return function(value2) {
      return f2(k3 * value2) + prefix2;
    };
  }
  return {
    format: newFormat,
    formatPrefix: formatPrefix2
  };
}
var locale$1;
var format;
var formatPrefix;
defaultLocale$1({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function defaultLocale$1(definition) {
  locale$1 = formatLocale$1(definition);
  format = locale$1.format;
  formatPrefix = locale$1.formatPrefix;
  return locale$1;
}
function precisionFixed(step) {
  return Math.max(0, -exponent(Math.abs(step)));
}
function precisionPrefix(step, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3 - exponent(Math.abs(step)));
}
function precisionRound(step, max2) {
  step = Math.abs(step), max2 = Math.abs(max2) - step;
  return Math.max(0, exponent(max2) - exponent(step)) + 1;
}
function tickFormat(start, stop, count2, specifier) {
  var step = tickStep(start, stop, count2), precision;
  specifier = formatSpecifier(specifier == null ? ",f" : specifier);
  switch (specifier.type) {
    case "s": {
      var value = Math.max(Math.abs(start), Math.abs(stop));
      if (specifier.precision == null && !isNaN(precision = precisionPrefix(step, value))) specifier.precision = precision;
      return formatPrefix(specifier, value);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      if (specifier.precision == null && !isNaN(precision = precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
      break;
    }
    case "f":
    case "%": {
      if (specifier.precision == null && !isNaN(precision = precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
      break;
    }
  }
  return format(specifier);
}
function linearish(scale2) {
  var domain = scale2.domain;
  scale2.ticks = function(count2) {
    var d4 = domain();
    return ticks(d4[0], d4[d4.length - 1], count2 == null ? 10 : count2);
  };
  scale2.tickFormat = function(count2, specifier) {
    var d4 = domain();
    return tickFormat(d4[0], d4[d4.length - 1], count2 == null ? 10 : count2, specifier);
  };
  scale2.nice = function(count2) {
    if (count2 == null) count2 = 10;
    var d4 = domain();
    var i0 = 0;
    var i1 = d4.length - 1;
    var start = d4[i0];
    var stop = d4[i1];
    var prestep;
    var step;
    var maxIter = 10;
    if (stop < start) {
      step = start, start = stop, stop = step;
      step = i0, i0 = i1, i1 = step;
    }
    while (maxIter-- > 0) {
      step = tickIncrement(start, stop, count2);
      if (step === prestep) {
        d4[i0] = start;
        d4[i1] = stop;
        return domain(d4);
      } else if (step > 0) {
        start = Math.floor(start / step) * step;
        stop = Math.ceil(stop / step) * step;
      } else if (step < 0) {
        start = Math.ceil(start * step) / step;
        stop = Math.floor(stop * step) / step;
      } else {
        break;
      }
      prestep = step;
    }
    return scale2;
  };
  return scale2;
}
function linear() {
  var scale2 = continuous();
  scale2.copy = function() {
    return copy$1(scale2, linear());
  };
  initRange.apply(scale2, arguments);
  return linearish(scale2);
}
function identity$2(domain) {
  var unknown;
  function scale2(x3) {
    return x3 == null || isNaN(x3 = +x3) ? unknown : x3;
  }
  scale2.invert = scale2;
  scale2.domain = scale2.range = function(_) {
    return arguments.length ? (domain = Array.from(_, number$1), scale2) : domain.slice();
  };
  scale2.unknown = function(_) {
    return arguments.length ? (unknown = _, scale2) : unknown;
  };
  scale2.copy = function() {
    return identity$2(domain).unknown(unknown);
  };
  domain = arguments.length ? Array.from(domain, number$1) : [0, 1];
  return linearish(scale2);
}
function nice(domain, interval) {
  domain = domain.slice();
  var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t3;
  if (x1 < x0) {
    t3 = i0, i0 = i1, i1 = t3;
    t3 = x0, x0 = x1, x1 = t3;
  }
  domain[i0] = interval.floor(x0);
  domain[i1] = interval.ceil(x1);
  return domain;
}
function transformLog(x3) {
  return Math.log(x3);
}
function transformExp(x3) {
  return Math.exp(x3);
}
function transformLogn(x3) {
  return -Math.log(-x3);
}
function transformExpn(x3) {
  return -Math.exp(-x3);
}
function pow10(x3) {
  return isFinite(x3) ? +("1e" + x3) : x3 < 0 ? 0 : x3;
}
function powp(base) {
  return base === 10 ? pow10 : base === Math.E ? Math.exp : (x3) => Math.pow(base, x3);
}
function logp(base) {
  return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), (x3) => Math.log(x3) / base);
}
function reflect(f2) {
  return (x3, k3) => -f2(-x3, k3);
}
function loggish(transform) {
  const scale2 = transform(transformLog, transformExp);
  const domain = scale2.domain;
  let base = 10;
  let logs;
  let pows;
  function rescale() {
    logs = logp(base), pows = powp(base);
    if (domain()[0] < 0) {
      logs = reflect(logs), pows = reflect(pows);
      transform(transformLogn, transformExpn);
    } else {
      transform(transformLog, transformExp);
    }
    return scale2;
  }
  scale2.base = function(_) {
    return arguments.length ? (base = +_, rescale()) : base;
  };
  scale2.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };
  scale2.ticks = (count2) => {
    const d4 = domain();
    let u3 = d4[0];
    let v2 = d4[d4.length - 1];
    const r2 = v2 < u3;
    if (r2) [u3, v2] = [v2, u3];
    let i3 = logs(u3);
    let j = logs(v2);
    let k3;
    let t3;
    const n2 = count2 == null ? 10 : +count2;
    let z3 = [];
    if (!(base % 1) && j - i3 < n2) {
      i3 = Math.floor(i3), j = Math.ceil(j);
      if (u3 > 0) for (; i3 <= j; ++i3) {
        for (k3 = 1; k3 < base; ++k3) {
          t3 = i3 < 0 ? k3 / pows(-i3) : k3 * pows(i3);
          if (t3 < u3) continue;
          if (t3 > v2) break;
          z3.push(t3);
        }
      }
      else for (; i3 <= j; ++i3) {
        for (k3 = base - 1; k3 >= 1; --k3) {
          t3 = i3 > 0 ? k3 / pows(-i3) : k3 * pows(i3);
          if (t3 < u3) continue;
          if (t3 > v2) break;
          z3.push(t3);
        }
      }
      if (z3.length * 2 < n2) z3 = ticks(u3, v2, n2);
    } else {
      z3 = ticks(i3, j, Math.min(j - i3, n2)).map(pows);
    }
    return r2 ? z3.reverse() : z3;
  };
  scale2.tickFormat = (count2, specifier) => {
    if (count2 == null) count2 = 10;
    if (specifier == null) specifier = base === 10 ? "s" : ",";
    if (typeof specifier !== "function") {
      if (!(base % 1) && (specifier = formatSpecifier(specifier)).precision == null) specifier.trim = true;
      specifier = format(specifier);
    }
    if (count2 === Infinity) return specifier;
    const k3 = Math.max(1, base * count2 / scale2.ticks().length);
    return (d4) => {
      let i3 = d4 / pows(Math.round(logs(d4)));
      if (i3 * base < base - 0.5) i3 *= base;
      return i3 <= k3 ? specifier(d4) : "";
    };
  };
  scale2.nice = () => {
    return domain(nice(domain(), {
      floor: (x3) => pows(Math.floor(logs(x3))),
      ceil: (x3) => pows(Math.ceil(logs(x3)))
    }));
  };
  return scale2;
}
function log() {
  const scale2 = loggish(transformer$2()).domain([1, 10]);
  scale2.copy = () => copy$1(scale2, log()).base(scale2.base());
  initRange.apply(scale2, arguments);
  return scale2;
}
function transformSymlog(c3) {
  return function(x3) {
    return Math.sign(x3) * Math.log1p(Math.abs(x3 / c3));
  };
}
function transformSymexp(c3) {
  return function(x3) {
    return Math.sign(x3) * Math.expm1(Math.abs(x3)) * c3;
  };
}
function symlogish(transform) {
  var c3 = 1, scale2 = transform(transformSymlog(c3), transformSymexp(c3));
  scale2.constant = function(_) {
    return arguments.length ? transform(transformSymlog(c3 = +_), transformSymexp(c3)) : c3;
  };
  return linearish(scale2);
}
function symlog() {
  var scale2 = symlogish(transformer$2());
  scale2.copy = function() {
    return copy$1(scale2, symlog()).constant(scale2.constant());
  };
  return initRange.apply(scale2, arguments);
}
function transformPow(exponent2) {
  return function(x3) {
    return x3 < 0 ? -Math.pow(-x3, exponent2) : Math.pow(x3, exponent2);
  };
}
function transformSqrt(x3) {
  return x3 < 0 ? -Math.sqrt(-x3) : Math.sqrt(x3);
}
function transformSquare(x3) {
  return x3 < 0 ? -x3 * x3 : x3 * x3;
}
function powish(transform) {
  var scale2 = transform(identity$4, identity$4), exponent2 = 1;
  function rescale() {
    return exponent2 === 1 ? transform(identity$4, identity$4) : exponent2 === 0.5 ? transform(transformSqrt, transformSquare) : transform(transformPow(exponent2), transformPow(1 / exponent2));
  }
  scale2.exponent = function(_) {
    return arguments.length ? (exponent2 = +_, rescale()) : exponent2;
  };
  return linearish(scale2);
}
function pow() {
  var scale2 = powish(transformer$2());
  scale2.copy = function() {
    return copy$1(scale2, pow()).exponent(scale2.exponent());
  };
  initRange.apply(scale2, arguments);
  return scale2;
}
function sqrt() {
  return pow.apply(null, arguments).exponent(0.5);
}
function square(x3) {
  return Math.sign(x3) * x3 * x3;
}
function unsquare(x3) {
  return Math.sign(x3) * Math.sqrt(Math.abs(x3));
}
function radial() {
  var squared = continuous(), range3 = [0, 1], round2 = false, unknown;
  function scale2(x3) {
    var y4 = unsquare(squared(x3));
    return isNaN(y4) ? unknown : round2 ? Math.round(y4) : y4;
  }
  scale2.invert = function(y4) {
    return squared.invert(square(y4));
  };
  scale2.domain = function(_) {
    return arguments.length ? (squared.domain(_), scale2) : squared.domain();
  };
  scale2.range = function(_) {
    return arguments.length ? (squared.range((range3 = Array.from(_, number$1)).map(square)), scale2) : range3.slice();
  };
  scale2.rangeRound = function(_) {
    return scale2.range(_).round(true);
  };
  scale2.round = function(_) {
    return arguments.length ? (round2 = !!_, scale2) : round2;
  };
  scale2.clamp = function(_) {
    return arguments.length ? (squared.clamp(_), scale2) : squared.clamp();
  };
  scale2.unknown = function(_) {
    return arguments.length ? (unknown = _, scale2) : unknown;
  };
  scale2.copy = function() {
    return radial(squared.domain(), range3).round(round2).clamp(squared.clamp()).unknown(unknown);
  };
  initRange.apply(scale2, arguments);
  return linearish(scale2);
}
function quantile() {
  var domain = [], range3 = [], thresholds = [], unknown;
  function rescale() {
    var i3 = 0, n2 = Math.max(1, range3.length);
    thresholds = new Array(n2 - 1);
    while (++i3 < n2) thresholds[i3 - 1] = quantileSorted(domain, i3 / n2);
    return scale2;
  }
  function scale2(x3) {
    return x3 == null || isNaN(x3 = +x3) ? unknown : range3[bisectRight(thresholds, x3)];
  }
  scale2.invertExtent = function(y4) {
    var i3 = range3.indexOf(y4);
    return i3 < 0 ? [NaN, NaN] : [
      i3 > 0 ? thresholds[i3 - 1] : domain[0],
      i3 < thresholds.length ? thresholds[i3] : domain[domain.length - 1]
    ];
  };
  scale2.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [];
    for (let d4 of _) if (d4 != null && !isNaN(d4 = +d4)) domain.push(d4);
    domain.sort(ascending);
    return rescale();
  };
  scale2.range = function(_) {
    return arguments.length ? (range3 = Array.from(_), rescale()) : range3.slice();
  };
  scale2.unknown = function(_) {
    return arguments.length ? (unknown = _, scale2) : unknown;
  };
  scale2.quantiles = function() {
    return thresholds.slice();
  };
  scale2.copy = function() {
    return quantile().domain(domain).range(range3).unknown(unknown);
  };
  return initRange.apply(scale2, arguments);
}
function quantize() {
  var x0 = 0, x1 = 1, n2 = 1, domain = [0.5], range3 = [0, 1], unknown;
  function scale2(x3) {
    return x3 != null && x3 <= x3 ? range3[bisectRight(domain, x3, 0, n2)] : unknown;
  }
  function rescale() {
    var i3 = -1;
    domain = new Array(n2);
    while (++i3 < n2) domain[i3] = ((i3 + 1) * x1 - (i3 - n2) * x0) / (n2 + 1);
    return scale2;
  }
  scale2.domain = function(_) {
    return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [x0, x1];
  };
  scale2.range = function(_) {
    return arguments.length ? (n2 = (range3 = Array.from(_)).length - 1, rescale()) : range3.slice();
  };
  scale2.invertExtent = function(y4) {
    var i3 = range3.indexOf(y4);
    return i3 < 0 ? [NaN, NaN] : i3 < 1 ? [x0, domain[0]] : i3 >= n2 ? [domain[n2 - 1], x1] : [domain[i3 - 1], domain[i3]];
  };
  scale2.unknown = function(_) {
    return arguments.length ? (unknown = _, scale2) : scale2;
  };
  scale2.thresholds = function() {
    return domain.slice();
  };
  scale2.copy = function() {
    return quantize().domain([x0, x1]).range(range3).unknown(unknown);
  };
  return initRange.apply(linearish(scale2), arguments);
}
function threshold() {
  var domain = [0.5], range3 = [0, 1], unknown, n2 = 1;
  function scale2(x3) {
    return x3 != null && x3 <= x3 ? range3[bisectRight(domain, x3, 0, n2)] : unknown;
  }
  scale2.domain = function(_) {
    return arguments.length ? (domain = Array.from(_), n2 = Math.min(domain.length, range3.length - 1), scale2) : domain.slice();
  };
  scale2.range = function(_) {
    return arguments.length ? (range3 = Array.from(_), n2 = Math.min(domain.length, range3.length - 1), scale2) : range3.slice();
  };
  scale2.invertExtent = function(y4) {
    var i3 = range3.indexOf(y4);
    return [domain[i3 - 1], domain[i3]];
  };
  scale2.unknown = function(_) {
    return arguments.length ? (unknown = _, scale2) : unknown;
  };
  scale2.copy = function() {
    return threshold().domain(domain).range(range3).unknown(unknown);
  };
  return initRange.apply(scale2, arguments);
}
const t0 = /* @__PURE__ */ new Date(), t1 = /* @__PURE__ */ new Date();
function timeInterval(floori, offseti, count2, field) {
  function interval(date2) {
    return floori(date2 = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+date2)), date2;
  }
  interval.floor = (date2) => {
    return floori(date2 = /* @__PURE__ */ new Date(+date2)), date2;
  };
  interval.ceil = (date2) => {
    return floori(date2 = new Date(date2 - 1)), offseti(date2, 1), floori(date2), date2;
  };
  interval.round = (date2) => {
    const d0 = interval(date2), d1 = interval.ceil(date2);
    return date2 - d0 < d1 - date2 ? d0 : d1;
  };
  interval.offset = (date2, step) => {
    return offseti(date2 = /* @__PURE__ */ new Date(+date2), step == null ? 1 : Math.floor(step)), date2;
  };
  interval.range = (start, stop, step) => {
    const range3 = [];
    start = interval.ceil(start);
    step = step == null ? 1 : Math.floor(step);
    if (!(start < stop) || !(step > 0)) return range3;
    let previous;
    do
      range3.push(previous = /* @__PURE__ */ new Date(+start)), offseti(start, step), floori(start);
    while (previous < start && start < stop);
    return range3;
  };
  interval.filter = (test2) => {
    return timeInterval((date2) => {
      if (date2 >= date2) while (floori(date2), !test2(date2)) date2.setTime(date2 - 1);
    }, (date2, step) => {
      if (date2 >= date2) {
        if (step < 0) while (++step <= 0) {
          while (offseti(date2, -1), !test2(date2)) {
          }
        }
        else while (--step >= 0) {
          while (offseti(date2, 1), !test2(date2)) {
          }
        }
      }
    });
  };
  if (count2) {
    interval.count = (start, end) => {
      t0.setTime(+start), t1.setTime(+end);
      floori(t0), floori(t1);
      return Math.floor(count2(t0, t1));
    };
    interval.every = (step) => {
      step = Math.floor(step);
      return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? (d4) => field(d4) % step === 0 : (d4) => interval.count(0, d4) % step === 0);
    };
  }
  return interval;
}
const millisecond = timeInterval(() => {
}, (date2, step) => {
  date2.setTime(+date2 + step);
}, (start, end) => {
  return end - start;
});
millisecond.every = (k3) => {
  k3 = Math.floor(k3);
  if (!isFinite(k3) || !(k3 > 0)) return null;
  if (!(k3 > 1)) return millisecond;
  return timeInterval((date2) => {
    date2.setTime(Math.floor(date2 / k3) * k3);
  }, (date2, step) => {
    date2.setTime(+date2 + step * k3);
  }, (start, end) => {
    return (end - start) / k3;
  });
};
millisecond.range;
const durationSecond = 1e3;
const durationMinute = durationSecond * 60;
const durationHour = durationMinute * 60;
const durationDay = durationHour * 24;
const durationWeek = durationDay * 7;
const durationMonth = durationDay * 30;
const durationYear = durationDay * 365;
const second = timeInterval((date2) => {
  date2.setTime(date2 - date2.getMilliseconds());
}, (date2, step) => {
  date2.setTime(+date2 + step * durationSecond);
}, (start, end) => {
  return (end - start) / durationSecond;
}, (date2) => {
  return date2.getUTCSeconds();
});
second.range;
const timeMinute = timeInterval((date2) => {
  date2.setTime(date2 - date2.getMilliseconds() - date2.getSeconds() * durationSecond);
}, (date2, step) => {
  date2.setTime(+date2 + step * durationMinute);
}, (start, end) => {
  return (end - start) / durationMinute;
}, (date2) => {
  return date2.getMinutes();
});
timeMinute.range;
const utcMinute = timeInterval((date2) => {
  date2.setUTCSeconds(0, 0);
}, (date2, step) => {
  date2.setTime(+date2 + step * durationMinute);
}, (start, end) => {
  return (end - start) / durationMinute;
}, (date2) => {
  return date2.getUTCMinutes();
});
utcMinute.range;
const timeHour = timeInterval((date2) => {
  date2.setTime(date2 - date2.getMilliseconds() - date2.getSeconds() * durationSecond - date2.getMinutes() * durationMinute);
}, (date2, step) => {
  date2.setTime(+date2 + step * durationHour);
}, (start, end) => {
  return (end - start) / durationHour;
}, (date2) => {
  return date2.getHours();
});
timeHour.range;
const utcHour = timeInterval((date2) => {
  date2.setUTCMinutes(0, 0, 0);
}, (date2, step) => {
  date2.setTime(+date2 + step * durationHour);
}, (start, end) => {
  return (end - start) / durationHour;
}, (date2) => {
  return date2.getUTCHours();
});
utcHour.range;
const timeDay = timeInterval(
  (date2) => date2.setHours(0, 0, 0, 0),
  (date2, step) => date2.setDate(date2.getDate() + step),
  (start, end) => (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationDay,
  (date2) => date2.getDate() - 1
);
timeDay.range;
const utcDay = timeInterval((date2) => {
  date2.setUTCHours(0, 0, 0, 0);
}, (date2, step) => {
  date2.setUTCDate(date2.getUTCDate() + step);
}, (start, end) => {
  return (end - start) / durationDay;
}, (date2) => {
  return date2.getUTCDate() - 1;
});
utcDay.range;
const unixDay = timeInterval((date2) => {
  date2.setUTCHours(0, 0, 0, 0);
}, (date2, step) => {
  date2.setUTCDate(date2.getUTCDate() + step);
}, (start, end) => {
  return (end - start) / durationDay;
}, (date2) => {
  return Math.floor(date2 / durationDay);
});
unixDay.range;
function timeWeekday(i3) {
  return timeInterval((date2) => {
    date2.setDate(date2.getDate() - (date2.getDay() + 7 - i3) % 7);
    date2.setHours(0, 0, 0, 0);
  }, (date2, step) => {
    date2.setDate(date2.getDate() + step * 7);
  }, (start, end) => {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationWeek;
  });
}
const timeSunday = timeWeekday(0);
const timeMonday = timeWeekday(1);
const timeTuesday = timeWeekday(2);
const timeWednesday = timeWeekday(3);
const timeThursday = timeWeekday(4);
const timeFriday = timeWeekday(5);
const timeSaturday = timeWeekday(6);
timeSunday.range;
timeMonday.range;
timeTuesday.range;
timeWednesday.range;
timeThursday.range;
timeFriday.range;
timeSaturday.range;
function utcWeekday(i3) {
  return timeInterval((date2) => {
    date2.setUTCDate(date2.getUTCDate() - (date2.getUTCDay() + 7 - i3) % 7);
    date2.setUTCHours(0, 0, 0, 0);
  }, (date2, step) => {
    date2.setUTCDate(date2.getUTCDate() + step * 7);
  }, (start, end) => {
    return (end - start) / durationWeek;
  });
}
const utcSunday = utcWeekday(0);
const utcMonday = utcWeekday(1);
const utcTuesday = utcWeekday(2);
const utcWednesday = utcWeekday(3);
const utcThursday = utcWeekday(4);
const utcFriday = utcWeekday(5);
const utcSaturday = utcWeekday(6);
utcSunday.range;
utcMonday.range;
utcTuesday.range;
utcWednesday.range;
utcThursday.range;
utcFriday.range;
utcSaturday.range;
const timeMonth = timeInterval((date2) => {
  date2.setDate(1);
  date2.setHours(0, 0, 0, 0);
}, (date2, step) => {
  date2.setMonth(date2.getMonth() + step);
}, (start, end) => {
  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, (date2) => {
  return date2.getMonth();
});
timeMonth.range;
const utcMonth = timeInterval((date2) => {
  date2.setUTCDate(1);
  date2.setUTCHours(0, 0, 0, 0);
}, (date2, step) => {
  date2.setUTCMonth(date2.getUTCMonth() + step);
}, (start, end) => {
  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, (date2) => {
  return date2.getUTCMonth();
});
utcMonth.range;
const timeYear = timeInterval((date2) => {
  date2.setMonth(0, 1);
  date2.setHours(0, 0, 0, 0);
}, (date2, step) => {
  date2.setFullYear(date2.getFullYear() + step);
}, (start, end) => {
  return end.getFullYear() - start.getFullYear();
}, (date2) => {
  return date2.getFullYear();
});
timeYear.every = (k3) => {
  return !isFinite(k3 = Math.floor(k3)) || !(k3 > 0) ? null : timeInterval((date2) => {
    date2.setFullYear(Math.floor(date2.getFullYear() / k3) * k3);
    date2.setMonth(0, 1);
    date2.setHours(0, 0, 0, 0);
  }, (date2, step) => {
    date2.setFullYear(date2.getFullYear() + step * k3);
  });
};
timeYear.range;
const utcYear = timeInterval((date2) => {
  date2.setUTCMonth(0, 1);
  date2.setUTCHours(0, 0, 0, 0);
}, (date2, step) => {
  date2.setUTCFullYear(date2.getUTCFullYear() + step);
}, (start, end) => {
  return end.getUTCFullYear() - start.getUTCFullYear();
}, (date2) => {
  return date2.getUTCFullYear();
});
utcYear.every = (k3) => {
  return !isFinite(k3 = Math.floor(k3)) || !(k3 > 0) ? null : timeInterval((date2) => {
    date2.setUTCFullYear(Math.floor(date2.getUTCFullYear() / k3) * k3);
    date2.setUTCMonth(0, 1);
    date2.setUTCHours(0, 0, 0, 0);
  }, (date2, step) => {
    date2.setUTCFullYear(date2.getUTCFullYear() + step * k3);
  });
};
utcYear.range;
function ticker(year, month, week, day, hour, minute) {
  const tickIntervals = [
    [second, 1, durationSecond],
    [second, 5, 5 * durationSecond],
    [second, 15, 15 * durationSecond],
    [second, 30, 30 * durationSecond],
    [minute, 1, durationMinute],
    [minute, 5, 5 * durationMinute],
    [minute, 15, 15 * durationMinute],
    [minute, 30, 30 * durationMinute],
    [hour, 1, durationHour],
    [hour, 3, 3 * durationHour],
    [hour, 6, 6 * durationHour],
    [hour, 12, 12 * durationHour],
    [day, 1, durationDay],
    [day, 2, 2 * durationDay],
    [week, 1, durationWeek],
    [month, 1, durationMonth],
    [month, 3, 3 * durationMonth],
    [year, 1, durationYear]
  ];
  function ticks2(start, stop, count2) {
    const reverse3 = stop < start;
    if (reverse3) [start, stop] = [stop, start];
    const interval = count2 && typeof count2.range === "function" ? count2 : tickInterval(start, stop, count2);
    const ticks3 = interval ? interval.range(start, +stop + 1) : [];
    return reverse3 ? ticks3.reverse() : ticks3;
  }
  function tickInterval(start, stop, count2) {
    const target = Math.abs(stop - start) / count2;
    const i3 = bisector(([, , step2]) => step2).right(tickIntervals, target);
    if (i3 === tickIntervals.length) return year.every(tickStep(start / durationYear, stop / durationYear, count2));
    if (i3 === 0) return millisecond.every(Math.max(tickStep(start, stop, count2), 1));
    const [t3, step] = tickIntervals[target / tickIntervals[i3 - 1][2] < tickIntervals[i3][2] / target ? i3 - 1 : i3];
    return t3.every(step);
  }
  return [ticks2, tickInterval];
}
const [utcTicks, utcTickInterval] = ticker(utcYear, utcMonth, utcSunday, unixDay, utcHour, utcMinute);
const [timeTicks, timeTickInterval] = ticker(timeYear, timeMonth, timeSunday, timeDay, timeHour, timeMinute);
function localDate(d4) {
  if (0 <= d4.y && d4.y < 100) {
    var date2 = new Date(-1, d4.m, d4.d, d4.H, d4.M, d4.S, d4.L);
    date2.setFullYear(d4.y);
    return date2;
  }
  return new Date(d4.y, d4.m, d4.d, d4.H, d4.M, d4.S, d4.L);
}
function utcDate(d4) {
  if (0 <= d4.y && d4.y < 100) {
    var date2 = new Date(Date.UTC(-1, d4.m, d4.d, d4.H, d4.M, d4.S, d4.L));
    date2.setUTCFullYear(d4.y);
    return date2;
  }
  return new Date(Date.UTC(d4.y, d4.m, d4.d, d4.H, d4.M, d4.S, d4.L));
}
function newDate(y4, m4, d4) {
  return { y: y4, m: m4, d: d4, H: 0, M: 0, S: 0, L: 0 };
}
function formatLocale(locale2) {
  var locale_dateTime = locale2.dateTime, locale_date = locale2.date, locale_time = locale2.time, locale_periods = locale2.periods, locale_weekdays = locale2.days, locale_shortWeekdays = locale2.shortDays, locale_months = locale2.months, locale_shortMonths = locale2.shortMonths;
  var periodRe = formatRe(locale_periods), periodLookup = formatLookup(locale_periods), weekdayRe = formatRe(locale_weekdays), weekdayLookup = formatLookup(locale_weekdays), shortWeekdayRe = formatRe(locale_shortWeekdays), shortWeekdayLookup = formatLookup(locale_shortWeekdays), monthRe = formatRe(locale_months), monthLookup = formatLookup(locale_months), shortMonthRe = formatRe(locale_shortMonths), shortMonthLookup = formatLookup(locale_shortMonths);
  var formats = {
    "a": formatShortWeekday,
    "A": formatWeekday,
    "b": formatShortMonth,
    "B": formatMonth,
    "c": null,
    "d": formatDayOfMonth,
    "e": formatDayOfMonth,
    "f": formatMicroseconds,
    "g": formatYearISO,
    "G": formatFullYearISO,
    "H": formatHour24,
    "I": formatHour12,
    "j": formatDayOfYear,
    "L": formatMilliseconds,
    "m": formatMonthNumber,
    "M": formatMinutes,
    "p": formatPeriod,
    "q": formatQuarter,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatSeconds,
    "u": formatWeekdayNumberMonday,
    "U": formatWeekNumberSunday,
    "V": formatWeekNumberISO,
    "w": formatWeekdayNumberSunday,
    "W": formatWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatYear,
    "Y": formatFullYear,
    "Z": formatZone,
    "%": formatLiteralPercent
  };
  var utcFormats = {
    "a": formatUTCShortWeekday,
    "A": formatUTCWeekday,
    "b": formatUTCShortMonth,
    "B": formatUTCMonth,
    "c": null,
    "d": formatUTCDayOfMonth,
    "e": formatUTCDayOfMonth,
    "f": formatUTCMicroseconds,
    "g": formatUTCYearISO,
    "G": formatUTCFullYearISO,
    "H": formatUTCHour24,
    "I": formatUTCHour12,
    "j": formatUTCDayOfYear,
    "L": formatUTCMilliseconds,
    "m": formatUTCMonthNumber,
    "M": formatUTCMinutes,
    "p": formatUTCPeriod,
    "q": formatUTCQuarter,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatUTCSeconds,
    "u": formatUTCWeekdayNumberMonday,
    "U": formatUTCWeekNumberSunday,
    "V": formatUTCWeekNumberISO,
    "w": formatUTCWeekdayNumberSunday,
    "W": formatUTCWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatUTCYear,
    "Y": formatUTCFullYear,
    "Z": formatUTCZone,
    "%": formatLiteralPercent
  };
  var parses = {
    "a": parseShortWeekday,
    "A": parseWeekday,
    "b": parseShortMonth,
    "B": parseMonth,
    "c": parseLocaleDateTime,
    "d": parseDayOfMonth,
    "e": parseDayOfMonth,
    "f": parseMicroseconds,
    "g": parseYear,
    "G": parseFullYear,
    "H": parseHour24,
    "I": parseHour24,
    "j": parseDayOfYear,
    "L": parseMilliseconds,
    "m": parseMonthNumber,
    "M": parseMinutes,
    "p": parsePeriod,
    "q": parseQuarter,
    "Q": parseUnixTimestamp,
    "s": parseUnixTimestampSeconds,
    "S": parseSeconds,
    "u": parseWeekdayNumberMonday,
    "U": parseWeekNumberSunday,
    "V": parseWeekNumberISO,
    "w": parseWeekdayNumberSunday,
    "W": parseWeekNumberMonday,
    "x": parseLocaleDate,
    "X": parseLocaleTime,
    "y": parseYear,
    "Y": parseFullYear,
    "Z": parseZone,
    "%": parseLiteralPercent
  };
  formats.x = newFormat(locale_date, formats);
  formats.X = newFormat(locale_time, formats);
  formats.c = newFormat(locale_dateTime, formats);
  utcFormats.x = newFormat(locale_date, utcFormats);
  utcFormats.X = newFormat(locale_time, utcFormats);
  utcFormats.c = newFormat(locale_dateTime, utcFormats);
  function newFormat(specifier, formats2) {
    return function(date2) {
      var string2 = [], i3 = -1, j = 0, n2 = specifier.length, c3, pad2, format2;
      if (!(date2 instanceof Date)) date2 = /* @__PURE__ */ new Date(+date2);
      while (++i3 < n2) {
        if (specifier.charCodeAt(i3) === 37) {
          string2.push(specifier.slice(j, i3));
          if ((pad2 = pads[c3 = specifier.charAt(++i3)]) != null) c3 = specifier.charAt(++i3);
          else pad2 = c3 === "e" ? " " : "0";
          if (format2 = formats2[c3]) c3 = format2(date2, pad2);
          string2.push(c3);
          j = i3 + 1;
        }
      }
      string2.push(specifier.slice(j, i3));
      return string2.join("");
    };
  }
  function newParse(specifier, Z) {
    return function(string2) {
      var d4 = newDate(1900, void 0, 1), i3 = parseSpecifier(d4, specifier, string2 += "", 0), week, day;
      if (i3 != string2.length) return null;
      if ("Q" in d4) return new Date(d4.Q);
      if ("s" in d4) return new Date(d4.s * 1e3 + ("L" in d4 ? d4.L : 0));
      if (Z && !("Z" in d4)) d4.Z = 0;
      if ("p" in d4) d4.H = d4.H % 12 + d4.p * 12;
      if (d4.m === void 0) d4.m = "q" in d4 ? d4.q : 0;
      if ("V" in d4) {
        if (d4.V < 1 || d4.V > 53) return null;
        if (!("w" in d4)) d4.w = 1;
        if ("Z" in d4) {
          week = utcDate(newDate(d4.y, 0, 1)), day = week.getUTCDay();
          week = day > 4 || day === 0 ? utcMonday.ceil(week) : utcMonday(week);
          week = utcDay.offset(week, (d4.V - 1) * 7);
          d4.y = week.getUTCFullYear();
          d4.m = week.getUTCMonth();
          d4.d = week.getUTCDate() + (d4.w + 6) % 7;
        } else {
          week = localDate(newDate(d4.y, 0, 1)), day = week.getDay();
          week = day > 4 || day === 0 ? timeMonday.ceil(week) : timeMonday(week);
          week = timeDay.offset(week, (d4.V - 1) * 7);
          d4.y = week.getFullYear();
          d4.m = week.getMonth();
          d4.d = week.getDate() + (d4.w + 6) % 7;
        }
      } else if ("W" in d4 || "U" in d4) {
        if (!("w" in d4)) d4.w = "u" in d4 ? d4.u % 7 : "W" in d4 ? 1 : 0;
        day = "Z" in d4 ? utcDate(newDate(d4.y, 0, 1)).getUTCDay() : localDate(newDate(d4.y, 0, 1)).getDay();
        d4.m = 0;
        d4.d = "W" in d4 ? (d4.w + 6) % 7 + d4.W * 7 - (day + 5) % 7 : d4.w + d4.U * 7 - (day + 6) % 7;
      }
      if ("Z" in d4) {
        d4.H += d4.Z / 100 | 0;
        d4.M += d4.Z % 100;
        return utcDate(d4);
      }
      return localDate(d4);
    };
  }
  function parseSpecifier(d4, specifier, string2, j) {
    var i3 = 0, n2 = specifier.length, m4 = string2.length, c3, parse2;
    while (i3 < n2) {
      if (j >= m4) return -1;
      c3 = specifier.charCodeAt(i3++);
      if (c3 === 37) {
        c3 = specifier.charAt(i3++);
        parse2 = parses[c3 in pads ? specifier.charAt(i3++) : c3];
        if (!parse2 || (j = parse2(d4, string2, j)) < 0) return -1;
      } else if (c3 != string2.charCodeAt(j++)) {
        return -1;
      }
    }
    return j;
  }
  function parsePeriod(d4, string2, i3) {
    var n2 = periodRe.exec(string2.slice(i3));
    return n2 ? (d4.p = periodLookup.get(n2[0].toLowerCase()), i3 + n2[0].length) : -1;
  }
  function parseShortWeekday(d4, string2, i3) {
    var n2 = shortWeekdayRe.exec(string2.slice(i3));
    return n2 ? (d4.w = shortWeekdayLookup.get(n2[0].toLowerCase()), i3 + n2[0].length) : -1;
  }
  function parseWeekday(d4, string2, i3) {
    var n2 = weekdayRe.exec(string2.slice(i3));
    return n2 ? (d4.w = weekdayLookup.get(n2[0].toLowerCase()), i3 + n2[0].length) : -1;
  }
  function parseShortMonth(d4, string2, i3) {
    var n2 = shortMonthRe.exec(string2.slice(i3));
    return n2 ? (d4.m = shortMonthLookup.get(n2[0].toLowerCase()), i3 + n2[0].length) : -1;
  }
  function parseMonth(d4, string2, i3) {
    var n2 = monthRe.exec(string2.slice(i3));
    return n2 ? (d4.m = monthLookup.get(n2[0].toLowerCase()), i3 + n2[0].length) : -1;
  }
  function parseLocaleDateTime(d4, string2, i3) {
    return parseSpecifier(d4, locale_dateTime, string2, i3);
  }
  function parseLocaleDate(d4, string2, i3) {
    return parseSpecifier(d4, locale_date, string2, i3);
  }
  function parseLocaleTime(d4, string2, i3) {
    return parseSpecifier(d4, locale_time, string2, i3);
  }
  function formatShortWeekday(d4) {
    return locale_shortWeekdays[d4.getDay()];
  }
  function formatWeekday(d4) {
    return locale_weekdays[d4.getDay()];
  }
  function formatShortMonth(d4) {
    return locale_shortMonths[d4.getMonth()];
  }
  function formatMonth(d4) {
    return locale_months[d4.getMonth()];
  }
  function formatPeriod(d4) {
    return locale_periods[+(d4.getHours() >= 12)];
  }
  function formatQuarter(d4) {
    return 1 + ~~(d4.getMonth() / 3);
  }
  function formatUTCShortWeekday(d4) {
    return locale_shortWeekdays[d4.getUTCDay()];
  }
  function formatUTCWeekday(d4) {
    return locale_weekdays[d4.getUTCDay()];
  }
  function formatUTCShortMonth(d4) {
    return locale_shortMonths[d4.getUTCMonth()];
  }
  function formatUTCMonth(d4) {
    return locale_months[d4.getUTCMonth()];
  }
  function formatUTCPeriod(d4) {
    return locale_periods[+(d4.getUTCHours() >= 12)];
  }
  function formatUTCQuarter(d4) {
    return 1 + ~~(d4.getUTCMonth() / 3);
  }
  return {
    format: function(specifier) {
      var f2 = newFormat(specifier += "", formats);
      f2.toString = function() {
        return specifier;
      };
      return f2;
    },
    parse: function(specifier) {
      var p2 = newParse(specifier += "", false);
      p2.toString = function() {
        return specifier;
      };
      return p2;
    },
    utcFormat: function(specifier) {
      var f2 = newFormat(specifier += "", utcFormats);
      f2.toString = function() {
        return specifier;
      };
      return f2;
    },
    utcParse: function(specifier) {
      var p2 = newParse(specifier += "", true);
      p2.toString = function() {
        return specifier;
      };
      return p2;
    }
  };
}
var pads = { "-": "", "_": " ", "0": "0" }, numberRe = /^\s*\d+/, percentRe = /^%/, requoteRe = /[\\^$*+?|[\]().{}]/g;
function pad(value, fill, width) {
  var sign2 = value < 0 ? "-" : "", string2 = (sign2 ? -value : value) + "", length = string2.length;
  return sign2 + (length < width ? new Array(width - length + 1).join(fill) + string2 : string2);
}
function requote(s4) {
  return s4.replace(requoteRe, "\\$&");
}
function formatRe(names2) {
  return new RegExp("^(?:" + names2.map(requote).join("|") + ")", "i");
}
function formatLookup(names2) {
  return new Map(names2.map((name, i3) => [name.toLowerCase(), i3]));
}
function parseWeekdayNumberSunday(d4, string2, i3) {
  var n2 = numberRe.exec(string2.slice(i3, i3 + 1));
  return n2 ? (d4.w = +n2[0], i3 + n2[0].length) : -1;
}
function parseWeekdayNumberMonday(d4, string2, i3) {
  var n2 = numberRe.exec(string2.slice(i3, i3 + 1));
  return n2 ? (d4.u = +n2[0], i3 + n2[0].length) : -1;
}
function parseWeekNumberSunday(d4, string2, i3) {
  var n2 = numberRe.exec(string2.slice(i3, i3 + 2));
  return n2 ? (d4.U = +n2[0], i3 + n2[0].length) : -1;
}
function parseWeekNumberISO(d4, string2, i3) {
  var n2 = numberRe.exec(string2.slice(i3, i3 + 2));
  return n2 ? (d4.V = +n2[0], i3 + n2[0].length) : -1;
}
function parseWeekNumberMonday(d4, string2, i3) {
  var n2 = numberRe.exec(string2.slice(i3, i3 + 2));
  return n2 ? (d4.W = +n2[0], i3 + n2[0].length) : -1;
}
function parseFullYear(d4, string2, i3) {
  var n2 = numberRe.exec(string2.slice(i3, i3 + 4));
  return n2 ? (d4.y = +n2[0], i3 + n2[0].length) : -1;
}
function parseYear(d4, string2, i3) {
  var n2 = numberRe.exec(string2.slice(i3, i3 + 2));
  return n2 ? (d4.y = +n2[0] + (+n2[0] > 68 ? 1900 : 2e3), i3 + n2[0].length) : -1;
}
function parseZone(d4, string2, i3) {
  var n2 = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string2.slice(i3, i3 + 6));
  return n2 ? (d4.Z = n2[1] ? 0 : -(n2[2] + (n2[3] || "00")), i3 + n2[0].length) : -1;
}
function parseQuarter(d4, string2, i3) {
  var n2 = numberRe.exec(string2.slice(i3, i3 + 1));
  return n2 ? (d4.q = n2[0] * 3 - 3, i3 + n2[0].length) : -1;
}
function parseMonthNumber(d4, string2, i3) {
  var n2 = numberRe.exec(string2.slice(i3, i3 + 2));
  return n2 ? (d4.m = n2[0] - 1, i3 + n2[0].length) : -1;
}
function parseDayOfMonth(d4, string2, i3) {
  var n2 = numberRe.exec(string2.slice(i3, i3 + 2));
  return n2 ? (d4.d = +n2[0], i3 + n2[0].length) : -1;
}
function parseDayOfYear(d4, string2, i3) {
  var n2 = numberRe.exec(string2.slice(i3, i3 + 3));
  return n2 ? (d4.m = 0, d4.d = +n2[0], i3 + n2[0].length) : -1;
}
function parseHour24(d4, string2, i3) {
  var n2 = numberRe.exec(string2.slice(i3, i3 + 2));
  return n2 ? (d4.H = +n2[0], i3 + n2[0].length) : -1;
}
function parseMinutes(d4, string2, i3) {
  var n2 = numberRe.exec(string2.slice(i3, i3 + 2));
  return n2 ? (d4.M = +n2[0], i3 + n2[0].length) : -1;
}
function parseSeconds(d4, string2, i3) {
  var n2 = numberRe.exec(string2.slice(i3, i3 + 2));
  return n2 ? (d4.S = +n2[0], i3 + n2[0].length) : -1;
}
function parseMilliseconds(d4, string2, i3) {
  var n2 = numberRe.exec(string2.slice(i3, i3 + 3));
  return n2 ? (d4.L = +n2[0], i3 + n2[0].length) : -1;
}
function parseMicroseconds(d4, string2, i3) {
  var n2 = numberRe.exec(string2.slice(i3, i3 + 6));
  return n2 ? (d4.L = Math.floor(n2[0] / 1e3), i3 + n2[0].length) : -1;
}
function parseLiteralPercent(d4, string2, i3) {
  var n2 = percentRe.exec(string2.slice(i3, i3 + 1));
  return n2 ? i3 + n2[0].length : -1;
}
function parseUnixTimestamp(d4, string2, i3) {
  var n2 = numberRe.exec(string2.slice(i3));
  return n2 ? (d4.Q = +n2[0], i3 + n2[0].length) : -1;
}
function parseUnixTimestampSeconds(d4, string2, i3) {
  var n2 = numberRe.exec(string2.slice(i3));
  return n2 ? (d4.s = +n2[0], i3 + n2[0].length) : -1;
}
function formatDayOfMonth(d4, p2) {
  return pad(d4.getDate(), p2, 2);
}
function formatHour24(d4, p2) {
  return pad(d4.getHours(), p2, 2);
}
function formatHour12(d4, p2) {
  return pad(d4.getHours() % 12 || 12, p2, 2);
}
function formatDayOfYear(d4, p2) {
  return pad(1 + timeDay.count(timeYear(d4), d4), p2, 3);
}
function formatMilliseconds(d4, p2) {
  return pad(d4.getMilliseconds(), p2, 3);
}
function formatMicroseconds(d4, p2) {
  return formatMilliseconds(d4, p2) + "000";
}
function formatMonthNumber(d4, p2) {
  return pad(d4.getMonth() + 1, p2, 2);
}
function formatMinutes(d4, p2) {
  return pad(d4.getMinutes(), p2, 2);
}
function formatSeconds(d4, p2) {
  return pad(d4.getSeconds(), p2, 2);
}
function formatWeekdayNumberMonday(d4) {
  var day = d4.getDay();
  return day === 0 ? 7 : day;
}
function formatWeekNumberSunday(d4, p2) {
  return pad(timeSunday.count(timeYear(d4) - 1, d4), p2, 2);
}
function dISO(d4) {
  var day = d4.getDay();
  return day >= 4 || day === 0 ? timeThursday(d4) : timeThursday.ceil(d4);
}
function formatWeekNumberISO(d4, p2) {
  d4 = dISO(d4);
  return pad(timeThursday.count(timeYear(d4), d4) + (timeYear(d4).getDay() === 4), p2, 2);
}
function formatWeekdayNumberSunday(d4) {
  return d4.getDay();
}
function formatWeekNumberMonday(d4, p2) {
  return pad(timeMonday.count(timeYear(d4) - 1, d4), p2, 2);
}
function formatYear(d4, p2) {
  return pad(d4.getFullYear() % 100, p2, 2);
}
function formatYearISO(d4, p2) {
  d4 = dISO(d4);
  return pad(d4.getFullYear() % 100, p2, 2);
}
function formatFullYear(d4, p2) {
  return pad(d4.getFullYear() % 1e4, p2, 4);
}
function formatFullYearISO(d4, p2) {
  var day = d4.getDay();
  d4 = day >= 4 || day === 0 ? timeThursday(d4) : timeThursday.ceil(d4);
  return pad(d4.getFullYear() % 1e4, p2, 4);
}
function formatZone(d4) {
  var z3 = d4.getTimezoneOffset();
  return (z3 > 0 ? "-" : (z3 *= -1, "+")) + pad(z3 / 60 | 0, "0", 2) + pad(z3 % 60, "0", 2);
}
function formatUTCDayOfMonth(d4, p2) {
  return pad(d4.getUTCDate(), p2, 2);
}
function formatUTCHour24(d4, p2) {
  return pad(d4.getUTCHours(), p2, 2);
}
function formatUTCHour12(d4, p2) {
  return pad(d4.getUTCHours() % 12 || 12, p2, 2);
}
function formatUTCDayOfYear(d4, p2) {
  return pad(1 + utcDay.count(utcYear(d4), d4), p2, 3);
}
function formatUTCMilliseconds(d4, p2) {
  return pad(d4.getUTCMilliseconds(), p2, 3);
}
function formatUTCMicroseconds(d4, p2) {
  return formatUTCMilliseconds(d4, p2) + "000";
}
function formatUTCMonthNumber(d4, p2) {
  return pad(d4.getUTCMonth() + 1, p2, 2);
}
function formatUTCMinutes(d4, p2) {
  return pad(d4.getUTCMinutes(), p2, 2);
}
function formatUTCSeconds(d4, p2) {
  return pad(d4.getUTCSeconds(), p2, 2);
}
function formatUTCWeekdayNumberMonday(d4) {
  var dow = d4.getUTCDay();
  return dow === 0 ? 7 : dow;
}
function formatUTCWeekNumberSunday(d4, p2) {
  return pad(utcSunday.count(utcYear(d4) - 1, d4), p2, 2);
}
function UTCdISO(d4) {
  var day = d4.getUTCDay();
  return day >= 4 || day === 0 ? utcThursday(d4) : utcThursday.ceil(d4);
}
function formatUTCWeekNumberISO(d4, p2) {
  d4 = UTCdISO(d4);
  return pad(utcThursday.count(utcYear(d4), d4) + (utcYear(d4).getUTCDay() === 4), p2, 2);
}
function formatUTCWeekdayNumberSunday(d4) {
  return d4.getUTCDay();
}
function formatUTCWeekNumberMonday(d4, p2) {
  return pad(utcMonday.count(utcYear(d4) - 1, d4), p2, 2);
}
function formatUTCYear(d4, p2) {
  return pad(d4.getUTCFullYear() % 100, p2, 2);
}
function formatUTCYearISO(d4, p2) {
  d4 = UTCdISO(d4);
  return pad(d4.getUTCFullYear() % 100, p2, 2);
}
function formatUTCFullYear(d4, p2) {
  return pad(d4.getUTCFullYear() % 1e4, p2, 4);
}
function formatUTCFullYearISO(d4, p2) {
  var day = d4.getUTCDay();
  d4 = day >= 4 || day === 0 ? utcThursday(d4) : utcThursday.ceil(d4);
  return pad(d4.getUTCFullYear() % 1e4, p2, 4);
}
function formatUTCZone() {
  return "+0000";
}
function formatLiteralPercent() {
  return "%";
}
function formatUnixTimestamp(d4) {
  return +d4;
}
function formatUnixTimestampSeconds(d4) {
  return Math.floor(+d4 / 1e3);
}
var locale;
var timeFormat;
var utcFormat;
defaultLocale({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function defaultLocale(definition) {
  locale = formatLocale(definition);
  timeFormat = locale.format;
  locale.parse;
  utcFormat = locale.utcFormat;
  locale.utcParse;
  return locale;
}
function date(t3) {
  return new Date(t3);
}
function number(t3) {
  return t3 instanceof Date ? +t3 : +/* @__PURE__ */ new Date(+t3);
}
function calendar(ticks2, tickInterval, year, month, week, day, hour, minute, second2, format2) {
  var scale2 = continuous(), invert = scale2.invert, domain = scale2.domain;
  var formatMillisecond = format2(".%L"), formatSecond = format2(":%S"), formatMinute = format2("%I:%M"), formatHour = format2("%I %p"), formatDay2 = format2("%a %d"), formatWeek = format2("%b %d"), formatMonth = format2("%B"), formatYear2 = format2("%Y");
  function tickFormat2(date2) {
    return (second2(date2) < date2 ? formatMillisecond : minute(date2) < date2 ? formatSecond : hour(date2) < date2 ? formatMinute : day(date2) < date2 ? formatHour : month(date2) < date2 ? week(date2) < date2 ? formatDay2 : formatWeek : year(date2) < date2 ? formatMonth : formatYear2)(date2);
  }
  scale2.invert = function(y4) {
    return new Date(invert(y4));
  };
  scale2.domain = function(_) {
    return arguments.length ? domain(Array.from(_, number)) : domain().map(date);
  };
  scale2.ticks = function(interval) {
    var d4 = domain();
    return ticks2(d4[0], d4[d4.length - 1], interval == null ? 10 : interval);
  };
  scale2.tickFormat = function(count2, specifier) {
    return specifier == null ? tickFormat2 : format2(specifier);
  };
  scale2.nice = function(interval) {
    var d4 = domain();
    if (!interval || typeof interval.range !== "function") interval = tickInterval(d4[0], d4[d4.length - 1], interval == null ? 10 : interval);
    return interval ? domain(nice(d4, interval)) : scale2;
  };
  scale2.copy = function() {
    return copy$1(scale2, calendar(ticks2, tickInterval, year, month, week, day, hour, minute, second2, format2));
  };
  return scale2;
}
function time() {
  return initRange.apply(calendar(timeTicks, timeTickInterval, timeYear, timeMonth, timeSunday, timeDay, timeHour, timeMinute, second, timeFormat).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
}
function utcTime() {
  return initRange.apply(calendar(utcTicks, utcTickInterval, utcYear, utcMonth, utcSunday, utcDay, utcHour, utcMinute, second, utcFormat).domain([Date.UTC(2e3, 0, 1), Date.UTC(2e3, 0, 2)]), arguments);
}
function transformer$1() {
  var x0 = 0, x1 = 1, t02, t12, k10, transform, interpolator = identity$4, clamp2 = false, unknown;
  function scale2(x3) {
    return x3 == null || isNaN(x3 = +x3) ? unknown : interpolator(k10 === 0 ? 0.5 : (x3 = (transform(x3) - t02) * k10, clamp2 ? Math.max(0, Math.min(1, x3)) : x3));
  }
  scale2.domain = function(_) {
    return arguments.length ? ([x0, x1] = _, t02 = transform(x0 = +x0), t12 = transform(x1 = +x1), k10 = t02 === t12 ? 0 : 1 / (t12 - t02), scale2) : [x0, x1];
  };
  scale2.clamp = function(_) {
    return arguments.length ? (clamp2 = !!_, scale2) : clamp2;
  };
  scale2.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale2) : interpolator;
  };
  function range3(interpolate2) {
    return function(_) {
      var r0, r1;
      return arguments.length ? ([r0, r1] = _, interpolator = interpolate2(r0, r1), scale2) : [interpolator(0), interpolator(1)];
    };
  }
  scale2.range = range3(interpolate);
  scale2.rangeRound = range3(interpolateRound);
  scale2.unknown = function(_) {
    return arguments.length ? (unknown = _, scale2) : unknown;
  };
  return function(t3) {
    transform = t3, t02 = t3(x0), t12 = t3(x1), k10 = t02 === t12 ? 0 : 1 / (t12 - t02);
    return scale2;
  };
}
function copy(source, target) {
  return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function sequential() {
  var scale2 = linearish(transformer$1()(identity$4));
  scale2.copy = function() {
    return copy(scale2, sequential());
  };
  return initInterpolator.apply(scale2, arguments);
}
function sequentialLog() {
  var scale2 = loggish(transformer$1()).domain([1, 10]);
  scale2.copy = function() {
    return copy(scale2, sequentialLog()).base(scale2.base());
  };
  return initInterpolator.apply(scale2, arguments);
}
function sequentialSymlog() {
  var scale2 = symlogish(transformer$1());
  scale2.copy = function() {
    return copy(scale2, sequentialSymlog()).constant(scale2.constant());
  };
  return initInterpolator.apply(scale2, arguments);
}
function sequentialPow() {
  var scale2 = powish(transformer$1());
  scale2.copy = function() {
    return copy(scale2, sequentialPow()).exponent(scale2.exponent());
  };
  return initInterpolator.apply(scale2, arguments);
}
function sequentialSqrt() {
  return sequentialPow.apply(null, arguments).exponent(0.5);
}
function sequentialQuantile() {
  var domain = [], interpolator = identity$4;
  function scale2(x3) {
    if (x3 != null && !isNaN(x3 = +x3)) return interpolator((bisectRight(domain, x3, 1) - 1) / (domain.length - 1));
  }
  scale2.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [];
    for (let d4 of _) if (d4 != null && !isNaN(d4 = +d4)) domain.push(d4);
    domain.sort(ascending);
    return scale2;
  };
  scale2.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale2) : interpolator;
  };
  scale2.range = function() {
    return domain.map((d4, i3) => interpolator(i3 / (domain.length - 1)));
  };
  scale2.quantiles = function(n2) {
    return Array.from({ length: n2 + 1 }, (_, i3) => quantile$1(domain, i3 / n2));
  };
  scale2.copy = function() {
    return sequentialQuantile(interpolator).domain(domain);
  };
  return initInterpolator.apply(scale2, arguments);
}
function transformer() {
  var x0 = 0, x1 = 0.5, x22 = 1, s4 = 1, t02, t12, t22, k10, k21, interpolator = identity$4, transform, clamp2 = false, unknown;
  function scale2(x3) {
    return isNaN(x3 = +x3) ? unknown : (x3 = 0.5 + ((x3 = +transform(x3)) - t12) * (s4 * x3 < s4 * t12 ? k10 : k21), interpolator(clamp2 ? Math.max(0, Math.min(1, x3)) : x3));
  }
  scale2.domain = function(_) {
    return arguments.length ? ([x0, x1, x22] = _, t02 = transform(x0 = +x0), t12 = transform(x1 = +x1), t22 = transform(x22 = +x22), k10 = t02 === t12 ? 0 : 0.5 / (t12 - t02), k21 = t12 === t22 ? 0 : 0.5 / (t22 - t12), s4 = t12 < t02 ? -1 : 1, scale2) : [x0, x1, x22];
  };
  scale2.clamp = function(_) {
    return arguments.length ? (clamp2 = !!_, scale2) : clamp2;
  };
  scale2.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale2) : interpolator;
  };
  function range3(interpolate2) {
    return function(_) {
      var r0, r1, r2;
      return arguments.length ? ([r0, r1, r2] = _, interpolator = piecewise(interpolate2, [r0, r1, r2]), scale2) : [interpolator(0), interpolator(0.5), interpolator(1)];
    };
  }
  scale2.range = range3(interpolate);
  scale2.rangeRound = range3(interpolateRound);
  scale2.unknown = function(_) {
    return arguments.length ? (unknown = _, scale2) : unknown;
  };
  return function(t3) {
    transform = t3, t02 = t3(x0), t12 = t3(x1), t22 = t3(x22), k10 = t02 === t12 ? 0 : 0.5 / (t12 - t02), k21 = t12 === t22 ? 0 : 0.5 / (t22 - t12), s4 = t12 < t02 ? -1 : 1;
    return scale2;
  };
}
function diverging() {
  var scale2 = linearish(transformer()(identity$4));
  scale2.copy = function() {
    return copy(scale2, diverging());
  };
  return initInterpolator.apply(scale2, arguments);
}
function divergingLog() {
  var scale2 = loggish(transformer()).domain([0.1, 1, 10]);
  scale2.copy = function() {
    return copy(scale2, divergingLog()).base(scale2.base());
  };
  return initInterpolator.apply(scale2, arguments);
}
function divergingSymlog() {
  var scale2 = symlogish(transformer());
  scale2.copy = function() {
    return copy(scale2, divergingSymlog()).constant(scale2.constant());
  };
  return initInterpolator.apply(scale2, arguments);
}
function divergingPow() {
  var scale2 = powish(transformer());
  scale2.copy = function() {
    return copy(scale2, divergingPow()).exponent(scale2.exponent());
  };
  return initInterpolator.apply(scale2, arguments);
}
function divergingSqrt() {
  return divergingPow.apply(null, arguments).exponent(0.5);
}
const d3Scales = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  scaleBand: band,
  scaleDiverging: diverging,
  scaleDivergingLog: divergingLog,
  scaleDivergingPow: divergingPow,
  scaleDivergingSqrt: divergingSqrt,
  scaleDivergingSymlog: divergingSymlog,
  scaleIdentity: identity$2,
  scaleImplicit: implicit,
  scaleLinear: linear,
  scaleLog: log,
  scaleOrdinal: ordinal,
  scalePoint: point,
  scalePow: pow,
  scaleQuantile: quantile,
  scaleQuantize: quantize,
  scaleRadial: radial,
  scaleSequential: sequential,
  scaleSequentialLog: sequentialLog,
  scaleSequentialPow: sequentialPow,
  scaleSequentialQuantile: sequentialQuantile,
  scaleSequentialSqrt: sequentialSqrt,
  scaleSequentialSymlog: sequentialSymlog,
  scaleSqrt: sqrt,
  scaleSymlog: symlog,
  scaleThreshold: threshold,
  scaleTime: time,
  scaleUtc: utcTime,
  tickFormat
}, Symbol.toStringTag, { value: "Module" }));
var _baseExtremum;
var hasRequired_baseExtremum;
function require_baseExtremum() {
  if (hasRequired_baseExtremum) return _baseExtremum;
  hasRequired_baseExtremum = 1;
  var isSymbol = requireIsSymbol();
  function baseExtremum(array2, iteratee, comparator) {
    var index2 = -1, length = array2.length;
    while (++index2 < length) {
      var value = array2[index2], current = iteratee(value);
      if (current != null && (computed === void 0 ? current === current && !isSymbol(current) : comparator(current, computed))) {
        var computed = current, result = value;
      }
    }
    return result;
  }
  _baseExtremum = baseExtremum;
  return _baseExtremum;
}
var _baseGt;
var hasRequired_baseGt;
function require_baseGt() {
  if (hasRequired_baseGt) return _baseGt;
  hasRequired_baseGt = 1;
  function baseGt(value, other) {
    return value > other;
  }
  _baseGt = baseGt;
  return _baseGt;
}
var max_1;
var hasRequiredMax;
function requireMax() {
  if (hasRequiredMax) return max_1;
  hasRequiredMax = 1;
  var baseExtremum = require_baseExtremum(), baseGt = require_baseGt(), identity4 = requireIdentity();
  function max2(array2) {
    return array2 && array2.length ? baseExtremum(array2, identity4, baseGt) : void 0;
  }
  max_1 = max2;
  return max_1;
}
var maxExports = requireMax();
const max = /* @__PURE__ */ getDefaultExportFromCjs(maxExports);
var _baseLt;
var hasRequired_baseLt;
function require_baseLt() {
  if (hasRequired_baseLt) return _baseLt;
  hasRequired_baseLt = 1;
  function baseLt(value, other) {
    return value < other;
  }
  _baseLt = baseLt;
  return _baseLt;
}
var min_1;
var hasRequiredMin;
function requireMin() {
  if (hasRequiredMin) return min_1;
  hasRequiredMin = 1;
  var baseExtremum = require_baseExtremum(), baseLt = require_baseLt(), identity4 = requireIdentity();
  function min2(array2) {
    return array2 && array2.length ? baseExtremum(array2, identity4, baseLt) : void 0;
  }
  min_1 = min2;
  return min_1;
}
var minExports = requireMin();
const min = /* @__PURE__ */ getDefaultExportFromCjs(minExports);
var map_1;
var hasRequiredMap;
function requireMap() {
  if (hasRequiredMap) return map_1;
  hasRequiredMap = 1;
  var arrayMap = require_arrayMap(), baseIteratee = require_baseIteratee(), baseMap = require_baseMap(), isArray2 = requireIsArray();
  function map2(collection, iteratee) {
    var func = isArray2(collection) ? arrayMap : baseMap;
    return func(collection, baseIteratee(iteratee, 3));
  }
  map_1 = map2;
  return map_1;
}
var flatMap_1;
var hasRequiredFlatMap;
function requireFlatMap() {
  if (hasRequiredFlatMap) return flatMap_1;
  hasRequiredFlatMap = 1;
  var baseFlatten = require_baseFlatten(), map2 = requireMap();
  function flatMap2(collection, iteratee) {
    return baseFlatten(map2(collection, iteratee), 1);
  }
  flatMap_1 = flatMap2;
  return flatMap_1;
}
var flatMapExports = requireFlatMap();
const flatMap = /* @__PURE__ */ getDefaultExportFromCjs(flatMapExports);
var isEqual_1;
var hasRequiredIsEqual;
function requireIsEqual() {
  if (hasRequiredIsEqual) return isEqual_1;
  hasRequiredIsEqual = 1;
  var baseIsEqual = require_baseIsEqual();
  function isEqual2(value, other) {
    return baseIsEqual(value, other);
  }
  isEqual_1 = isEqual2;
  return isEqual_1;
}
var isEqualExports = requireIsEqual();
const isEqual = /* @__PURE__ */ getDefaultExportFromCjs(isEqualExports);
var MAX_DIGITS = 1e9, defaults = {
  // These values must be integers within the stated ranges (inclusive).
  // Most of these values can be changed during run-time using `Decimal.config`.
  // The maximum number of significant digits of the result of a calculation or base conversion.
  // E.g. `Decimal.config({ precision: 20 });`
  precision: 20,
  // 1 to MAX_DIGITS
  // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
  // `toFixed`, `toPrecision` and `toSignificantDigits`.
  //
  // ROUND_UP         0 Away from zero.
  // ROUND_DOWN       1 Towards zero.
  // ROUND_CEIL       2 Towards +Infinity.
  // ROUND_FLOOR      3 Towards -Infinity.
  // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
  // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
  // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
  // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
  // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
  //
  // E.g.
  // `Decimal.rounding = 4;`
  // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
  rounding: 4,
  // 0 to 8
  // The exponent value at and beneath which `toString` returns exponential notation.
  // JavaScript numbers: -7
  toExpNeg: -7,
  // 0 to -MAX_E
  // The exponent value at and above which `toString` returns exponential notation.
  // JavaScript numbers: 21
  toExpPos: 21,
  // 0 to MAX_E
  // The natural logarithm of 10.
  // 115 digits
  LN10: "2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286"
}, Decimal, external = true, decimalError = "[DecimalError] ", invalidArgument = decimalError + "Invalid argument: ", exponentOutOfRange = decimalError + "Exponent out of range: ", mathfloor = Math.floor, mathpow = Math.pow, isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, ONE, BASE = 1e7, LOG_BASE = 7, MAX_SAFE_INTEGER = 9007199254740991, MAX_E = mathfloor(MAX_SAFE_INTEGER / LOG_BASE), P = {};
P.absoluteValue = P.abs = function() {
  var x3 = new this.constructor(this);
  if (x3.s) x3.s = 1;
  return x3;
};
P.comparedTo = P.cmp = function(y4) {
  var i3, j, xdL, ydL, x3 = this;
  y4 = new x3.constructor(y4);
  if (x3.s !== y4.s) return x3.s || -y4.s;
  if (x3.e !== y4.e) return x3.e > y4.e ^ x3.s < 0 ? 1 : -1;
  xdL = x3.d.length;
  ydL = y4.d.length;
  for (i3 = 0, j = xdL < ydL ? xdL : ydL; i3 < j; ++i3) {
    if (x3.d[i3] !== y4.d[i3]) return x3.d[i3] > y4.d[i3] ^ x3.s < 0 ? 1 : -1;
  }
  return xdL === ydL ? 0 : xdL > ydL ^ x3.s < 0 ? 1 : -1;
};
P.decimalPlaces = P.dp = function() {
  var x3 = this, w3 = x3.d.length - 1, dp = (w3 - x3.e) * LOG_BASE;
  w3 = x3.d[w3];
  if (w3) for (; w3 % 10 == 0; w3 /= 10) dp--;
  return dp < 0 ? 0 : dp;
};
P.dividedBy = P.div = function(y4) {
  return divide(this, new this.constructor(y4));
};
P.dividedToIntegerBy = P.idiv = function(y4) {
  var x3 = this, Ctor = x3.constructor;
  return round(divide(x3, new Ctor(y4), 0, 1), Ctor.precision);
};
P.equals = P.eq = function(y4) {
  return !this.cmp(y4);
};
P.exponent = function() {
  return getBase10Exponent(this);
};
P.greaterThan = P.gt = function(y4) {
  return this.cmp(y4) > 0;
};
P.greaterThanOrEqualTo = P.gte = function(y4) {
  return this.cmp(y4) >= 0;
};
P.isInteger = P.isint = function() {
  return this.e > this.d.length - 2;
};
P.isNegative = P.isneg = function() {
  return this.s < 0;
};
P.isPositive = P.ispos = function() {
  return this.s > 0;
};
P.isZero = function() {
  return this.s === 0;
};
P.lessThan = P.lt = function(y4) {
  return this.cmp(y4) < 0;
};
P.lessThanOrEqualTo = P.lte = function(y4) {
  return this.cmp(y4) < 1;
};
P.logarithm = P.log = function(base) {
  var r2, x3 = this, Ctor = x3.constructor, pr = Ctor.precision, wpr = pr + 5;
  if (base === void 0) {
    base = new Ctor(10);
  } else {
    base = new Ctor(base);
    if (base.s < 1 || base.eq(ONE)) throw Error(decimalError + "NaN");
  }
  if (x3.s < 1) throw Error(decimalError + (x3.s ? "NaN" : "-Infinity"));
  if (x3.eq(ONE)) return new Ctor(0);
  external = false;
  r2 = divide(ln(x3, wpr), ln(base, wpr), wpr);
  external = true;
  return round(r2, pr);
};
P.minus = P.sub = function(y4) {
  var x3 = this;
  y4 = new x3.constructor(y4);
  return x3.s == y4.s ? subtract(x3, y4) : add(x3, (y4.s = -y4.s, y4));
};
P.modulo = P.mod = function(y4) {
  var q2, x3 = this, Ctor = x3.constructor, pr = Ctor.precision;
  y4 = new Ctor(y4);
  if (!y4.s) throw Error(decimalError + "NaN");
  if (!x3.s) return round(new Ctor(x3), pr);
  external = false;
  q2 = divide(x3, y4, 0, 1).times(y4);
  external = true;
  return x3.minus(q2);
};
P.naturalExponential = P.exp = function() {
  return exp(this);
};
P.naturalLogarithm = P.ln = function() {
  return ln(this);
};
P.negated = P.neg = function() {
  var x3 = new this.constructor(this);
  x3.s = -x3.s || 0;
  return x3;
};
P.plus = P.add = function(y4) {
  var x3 = this;
  y4 = new x3.constructor(y4);
  return x3.s == y4.s ? add(x3, y4) : subtract(x3, (y4.s = -y4.s, y4));
};
P.precision = P.sd = function(z3) {
  var e3, sd, w3, x3 = this;
  if (z3 !== void 0 && z3 !== !!z3 && z3 !== 1 && z3 !== 0) throw Error(invalidArgument + z3);
  e3 = getBase10Exponent(x3) + 1;
  w3 = x3.d.length - 1;
  sd = w3 * LOG_BASE + 1;
  w3 = x3.d[w3];
  if (w3) {
    for (; w3 % 10 == 0; w3 /= 10) sd--;
    for (w3 = x3.d[0]; w3 >= 10; w3 /= 10) sd++;
  }
  return z3 && e3 > sd ? e3 : sd;
};
P.squareRoot = P.sqrt = function() {
  var e3, n2, pr, r2, s4, t3, wpr, x3 = this, Ctor = x3.constructor;
  if (x3.s < 1) {
    if (!x3.s) return new Ctor(0);
    throw Error(decimalError + "NaN");
  }
  e3 = getBase10Exponent(x3);
  external = false;
  s4 = Math.sqrt(+x3);
  if (s4 == 0 || s4 == 1 / 0) {
    n2 = digitsToString(x3.d);
    if ((n2.length + e3) % 2 == 0) n2 += "0";
    s4 = Math.sqrt(n2);
    e3 = mathfloor((e3 + 1) / 2) - (e3 < 0 || e3 % 2);
    if (s4 == 1 / 0) {
      n2 = "5e" + e3;
    } else {
      n2 = s4.toExponential();
      n2 = n2.slice(0, n2.indexOf("e") + 1) + e3;
    }
    r2 = new Ctor(n2);
  } else {
    r2 = new Ctor(s4.toString());
  }
  pr = Ctor.precision;
  s4 = wpr = pr + 3;
  for (; ; ) {
    t3 = r2;
    r2 = t3.plus(divide(x3, t3, wpr + 2)).times(0.5);
    if (digitsToString(t3.d).slice(0, wpr) === (n2 = digitsToString(r2.d)).slice(0, wpr)) {
      n2 = n2.slice(wpr - 3, wpr + 1);
      if (s4 == wpr && n2 == "4999") {
        round(t3, pr + 1, 0);
        if (t3.times(t3).eq(x3)) {
          r2 = t3;
          break;
        }
      } else if (n2 != "9999") {
        break;
      }
      wpr += 4;
    }
  }
  external = true;
  return round(r2, pr);
};
P.times = P.mul = function(y4) {
  var carry, e3, i3, k3, r2, rL, t3, xdL, ydL, x3 = this, Ctor = x3.constructor, xd = x3.d, yd = (y4 = new Ctor(y4)).d;
  if (!x3.s || !y4.s) return new Ctor(0);
  y4.s *= x3.s;
  e3 = x3.e + y4.e;
  xdL = xd.length;
  ydL = yd.length;
  if (xdL < ydL) {
    r2 = xd;
    xd = yd;
    yd = r2;
    rL = xdL;
    xdL = ydL;
    ydL = rL;
  }
  r2 = [];
  rL = xdL + ydL;
  for (i3 = rL; i3--; ) r2.push(0);
  for (i3 = ydL; --i3 >= 0; ) {
    carry = 0;
    for (k3 = xdL + i3; k3 > i3; ) {
      t3 = r2[k3] + yd[i3] * xd[k3 - i3 - 1] + carry;
      r2[k3--] = t3 % BASE | 0;
      carry = t3 / BASE | 0;
    }
    r2[k3] = (r2[k3] + carry) % BASE | 0;
  }
  for (; !r2[--rL]; ) r2.pop();
  if (carry) ++e3;
  else r2.shift();
  y4.d = r2;
  y4.e = e3;
  return external ? round(y4, Ctor.precision) : y4;
};
P.toDecimalPlaces = P.todp = function(dp, rm) {
  var x3 = this, Ctor = x3.constructor;
  x3 = new Ctor(x3);
  if (dp === void 0) return x3;
  checkInt32(dp, 0, MAX_DIGITS);
  if (rm === void 0) rm = Ctor.rounding;
  else checkInt32(rm, 0, 8);
  return round(x3, dp + getBase10Exponent(x3) + 1, rm);
};
P.toExponential = function(dp, rm) {
  var str, x3 = this, Ctor = x3.constructor;
  if (dp === void 0) {
    str = toString(x3, true);
  } else {
    checkInt32(dp, 0, MAX_DIGITS);
    if (rm === void 0) rm = Ctor.rounding;
    else checkInt32(rm, 0, 8);
    x3 = round(new Ctor(x3), dp + 1, rm);
    str = toString(x3, true, dp + 1);
  }
  return str;
};
P.toFixed = function(dp, rm) {
  var str, y4, x3 = this, Ctor = x3.constructor;
  if (dp === void 0) return toString(x3);
  checkInt32(dp, 0, MAX_DIGITS);
  if (rm === void 0) rm = Ctor.rounding;
  else checkInt32(rm, 0, 8);
  y4 = round(new Ctor(x3), dp + getBase10Exponent(x3) + 1, rm);
  str = toString(y4.abs(), false, dp + getBase10Exponent(y4) + 1);
  return x3.isneg() && !x3.isZero() ? "-" + str : str;
};
P.toInteger = P.toint = function() {
  var x3 = this, Ctor = x3.constructor;
  return round(new Ctor(x3), getBase10Exponent(x3) + 1, Ctor.rounding);
};
P.toNumber = function() {
  return +this;
};
P.toPower = P.pow = function(y4) {
  var e3, k3, pr, r2, sign2, yIsInt, x3 = this, Ctor = x3.constructor, guard = 12, yn = +(y4 = new Ctor(y4));
  if (!y4.s) return new Ctor(ONE);
  x3 = new Ctor(x3);
  if (!x3.s) {
    if (y4.s < 1) throw Error(decimalError + "Infinity");
    return x3;
  }
  if (x3.eq(ONE)) return x3;
  pr = Ctor.precision;
  if (y4.eq(ONE)) return round(x3, pr);
  e3 = y4.e;
  k3 = y4.d.length - 1;
  yIsInt = e3 >= k3;
  sign2 = x3.s;
  if (!yIsInt) {
    if (sign2 < 0) throw Error(decimalError + "NaN");
  } else if ((k3 = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
    r2 = new Ctor(ONE);
    e3 = Math.ceil(pr / LOG_BASE + 4);
    external = false;
    for (; ; ) {
      if (k3 % 2) {
        r2 = r2.times(x3);
        truncate(r2.d, e3);
      }
      k3 = mathfloor(k3 / 2);
      if (k3 === 0) break;
      x3 = x3.times(x3);
      truncate(x3.d, e3);
    }
    external = true;
    return y4.s < 0 ? new Ctor(ONE).div(r2) : round(r2, pr);
  }
  sign2 = sign2 < 0 && y4.d[Math.max(e3, k3)] & 1 ? -1 : 1;
  x3.s = 1;
  external = false;
  r2 = y4.times(ln(x3, pr + guard));
  external = true;
  r2 = exp(r2);
  r2.s = sign2;
  return r2;
};
P.toPrecision = function(sd, rm) {
  var e3, str, x3 = this, Ctor = x3.constructor;
  if (sd === void 0) {
    e3 = getBase10Exponent(x3);
    str = toString(x3, e3 <= Ctor.toExpNeg || e3 >= Ctor.toExpPos);
  } else {
    checkInt32(sd, 1, MAX_DIGITS);
    if (rm === void 0) rm = Ctor.rounding;
    else checkInt32(rm, 0, 8);
    x3 = round(new Ctor(x3), sd, rm);
    e3 = getBase10Exponent(x3);
    str = toString(x3, sd <= e3 || e3 <= Ctor.toExpNeg, sd);
  }
  return str;
};
P.toSignificantDigits = P.tosd = function(sd, rm) {
  var x3 = this, Ctor = x3.constructor;
  if (sd === void 0) {
    sd = Ctor.precision;
    rm = Ctor.rounding;
  } else {
    checkInt32(sd, 1, MAX_DIGITS);
    if (rm === void 0) rm = Ctor.rounding;
    else checkInt32(rm, 0, 8);
  }
  return round(new Ctor(x3), sd, rm);
};
P.toString = P.valueOf = P.val = P.toJSON = P[Symbol.for("nodejs.util.inspect.custom")] = function() {
  var x3 = this, e3 = getBase10Exponent(x3), Ctor = x3.constructor;
  return toString(x3, e3 <= Ctor.toExpNeg || e3 >= Ctor.toExpPos);
};
function add(x3, y4) {
  var carry, d4, e3, i3, k3, len, xd, yd, Ctor = x3.constructor, pr = Ctor.precision;
  if (!x3.s || !y4.s) {
    if (!y4.s) y4 = new Ctor(x3);
    return external ? round(y4, pr) : y4;
  }
  xd = x3.d;
  yd = y4.d;
  k3 = x3.e;
  e3 = y4.e;
  xd = xd.slice();
  i3 = k3 - e3;
  if (i3) {
    if (i3 < 0) {
      d4 = xd;
      i3 = -i3;
      len = yd.length;
    } else {
      d4 = yd;
      e3 = k3;
      len = xd.length;
    }
    k3 = Math.ceil(pr / LOG_BASE);
    len = k3 > len ? k3 + 1 : len + 1;
    if (i3 > len) {
      i3 = len;
      d4.length = 1;
    }
    d4.reverse();
    for (; i3--; ) d4.push(0);
    d4.reverse();
  }
  len = xd.length;
  i3 = yd.length;
  if (len - i3 < 0) {
    i3 = len;
    d4 = yd;
    yd = xd;
    xd = d4;
  }
  for (carry = 0; i3; ) {
    carry = (xd[--i3] = xd[i3] + yd[i3] + carry) / BASE | 0;
    xd[i3] %= BASE;
  }
  if (carry) {
    xd.unshift(carry);
    ++e3;
  }
  for (len = xd.length; xd[--len] == 0; ) xd.pop();
  y4.d = xd;
  y4.e = e3;
  return external ? round(y4, pr) : y4;
}
function checkInt32(i3, min2, max2) {
  if (i3 !== ~~i3 || i3 < min2 || i3 > max2) {
    throw Error(invalidArgument + i3);
  }
}
function digitsToString(d4) {
  var i3, k3, ws, indexOfLastWord = d4.length - 1, str = "", w3 = d4[0];
  if (indexOfLastWord > 0) {
    str += w3;
    for (i3 = 1; i3 < indexOfLastWord; i3++) {
      ws = d4[i3] + "";
      k3 = LOG_BASE - ws.length;
      if (k3) str += getZeroString(k3);
      str += ws;
    }
    w3 = d4[i3];
    ws = w3 + "";
    k3 = LOG_BASE - ws.length;
    if (k3) str += getZeroString(k3);
  } else if (w3 === 0) {
    return "0";
  }
  for (; w3 % 10 === 0; ) w3 /= 10;
  return str + w3;
}
var divide = /* @__PURE__ */ function() {
  function multiplyInteger(x3, k3) {
    var temp, carry = 0, i3 = x3.length;
    for (x3 = x3.slice(); i3--; ) {
      temp = x3[i3] * k3 + carry;
      x3[i3] = temp % BASE | 0;
      carry = temp / BASE | 0;
    }
    if (carry) x3.unshift(carry);
    return x3;
  }
  function compare(a4, b3, aL, bL) {
    var i3, r2;
    if (aL != bL) {
      r2 = aL > bL ? 1 : -1;
    } else {
      for (i3 = r2 = 0; i3 < aL; i3++) {
        if (a4[i3] != b3[i3]) {
          r2 = a4[i3] > b3[i3] ? 1 : -1;
          break;
        }
      }
    }
    return r2;
  }
  function subtract2(a4, b3, aL) {
    var i3 = 0;
    for (; aL--; ) {
      a4[aL] -= i3;
      i3 = a4[aL] < b3[aL] ? 1 : 0;
      a4[aL] = i3 * BASE + a4[aL] - b3[aL];
    }
    for (; !a4[0] && a4.length > 1; ) a4.shift();
  }
  return function(x3, y4, pr, dp) {
    var cmp, e3, i3, k3, prod, prodL, q2, qd, rem, remL, rem0, sd, t3, xi, xL, yd0, yL, yz, Ctor = x3.constructor, sign2 = x3.s == y4.s ? 1 : -1, xd = x3.d, yd = y4.d;
    if (!x3.s) return new Ctor(x3);
    if (!y4.s) throw Error(decimalError + "Division by zero");
    e3 = x3.e - y4.e;
    yL = yd.length;
    xL = xd.length;
    q2 = new Ctor(sign2);
    qd = q2.d = [];
    for (i3 = 0; yd[i3] == (xd[i3] || 0); ) ++i3;
    if (yd[i3] > (xd[i3] || 0)) --e3;
    if (pr == null) {
      sd = pr = Ctor.precision;
    } else if (dp) {
      sd = pr + (getBase10Exponent(x3) - getBase10Exponent(y4)) + 1;
    } else {
      sd = pr;
    }
    if (sd < 0) return new Ctor(0);
    sd = sd / LOG_BASE + 2 | 0;
    i3 = 0;
    if (yL == 1) {
      k3 = 0;
      yd = yd[0];
      sd++;
      for (; (i3 < xL || k3) && sd--; i3++) {
        t3 = k3 * BASE + (xd[i3] || 0);
        qd[i3] = t3 / yd | 0;
        k3 = t3 % yd | 0;
      }
    } else {
      k3 = BASE / (yd[0] + 1) | 0;
      if (k3 > 1) {
        yd = multiplyInteger(yd, k3);
        xd = multiplyInteger(xd, k3);
        yL = yd.length;
        xL = xd.length;
      }
      xi = yL;
      rem = xd.slice(0, yL);
      remL = rem.length;
      for (; remL < yL; ) rem[remL++] = 0;
      yz = yd.slice();
      yz.unshift(0);
      yd0 = yd[0];
      if (yd[1] >= BASE / 2) ++yd0;
      do {
        k3 = 0;
        cmp = compare(yd, rem, yL, remL);
        if (cmp < 0) {
          rem0 = rem[0];
          if (yL != remL) rem0 = rem0 * BASE + (rem[1] || 0);
          k3 = rem0 / yd0 | 0;
          if (k3 > 1) {
            if (k3 >= BASE) k3 = BASE - 1;
            prod = multiplyInteger(yd, k3);
            prodL = prod.length;
            remL = rem.length;
            cmp = compare(prod, rem, prodL, remL);
            if (cmp == 1) {
              k3--;
              subtract2(prod, yL < prodL ? yz : yd, prodL);
            }
          } else {
            if (k3 == 0) cmp = k3 = 1;
            prod = yd.slice();
          }
          prodL = prod.length;
          if (prodL < remL) prod.unshift(0);
          subtract2(rem, prod, remL);
          if (cmp == -1) {
            remL = rem.length;
            cmp = compare(yd, rem, yL, remL);
            if (cmp < 1) {
              k3++;
              subtract2(rem, yL < remL ? yz : yd, remL);
            }
          }
          remL = rem.length;
        } else if (cmp === 0) {
          k3++;
          rem = [0];
        }
        qd[i3++] = k3;
        if (cmp && rem[0]) {
          rem[remL++] = xd[xi] || 0;
        } else {
          rem = [xd[xi]];
          remL = 1;
        }
      } while ((xi++ < xL || rem[0] !== void 0) && sd--);
    }
    if (!qd[0]) qd.shift();
    q2.e = e3;
    return round(q2, dp ? pr + getBase10Exponent(q2) + 1 : pr);
  };
}();
function exp(x3, sd) {
  var denominator, guard, pow2, sum2, t3, wpr, i3 = 0, k3 = 0, Ctor = x3.constructor, pr = Ctor.precision;
  if (getBase10Exponent(x3) > 16) throw Error(exponentOutOfRange + getBase10Exponent(x3));
  if (!x3.s) return new Ctor(ONE);
  {
    external = false;
    wpr = pr;
  }
  t3 = new Ctor(0.03125);
  while (x3.abs().gte(0.1)) {
    x3 = x3.times(t3);
    k3 += 5;
  }
  guard = Math.log(mathpow(2, k3)) / Math.LN10 * 2 + 5 | 0;
  wpr += guard;
  denominator = pow2 = sum2 = new Ctor(ONE);
  Ctor.precision = wpr;
  for (; ; ) {
    pow2 = round(pow2.times(x3), wpr);
    denominator = denominator.times(++i3);
    t3 = sum2.plus(divide(pow2, denominator, wpr));
    if (digitsToString(t3.d).slice(0, wpr) === digitsToString(sum2.d).slice(0, wpr)) {
      while (k3--) sum2 = round(sum2.times(sum2), wpr);
      Ctor.precision = pr;
      return sd == null ? (external = true, round(sum2, pr)) : sum2;
    }
    sum2 = t3;
  }
}
function getBase10Exponent(x3) {
  var e3 = x3.e * LOG_BASE, w3 = x3.d[0];
  for (; w3 >= 10; w3 /= 10) e3++;
  return e3;
}
function getLn10(Ctor, sd, pr) {
  if (sd > Ctor.LN10.sd()) {
    external = true;
    if (pr) Ctor.precision = pr;
    throw Error(decimalError + "LN10 precision limit exceeded");
  }
  return round(new Ctor(Ctor.LN10), sd);
}
function getZeroString(k3) {
  var zs = "";
  for (; k3--; ) zs += "0";
  return zs;
}
function ln(y4, sd) {
  var c3, c0, denominator, e3, numerator, sum2, t3, wpr, x22, n2 = 1, guard = 10, x3 = y4, xd = x3.d, Ctor = x3.constructor, pr = Ctor.precision;
  if (x3.s < 1) throw Error(decimalError + (x3.s ? "NaN" : "-Infinity"));
  if (x3.eq(ONE)) return new Ctor(0);
  if (sd == null) {
    external = false;
    wpr = pr;
  } else {
    wpr = sd;
  }
  if (x3.eq(10)) {
    if (sd == null) external = true;
    return getLn10(Ctor, wpr);
  }
  wpr += guard;
  Ctor.precision = wpr;
  c3 = digitsToString(xd);
  c0 = c3.charAt(0);
  e3 = getBase10Exponent(x3);
  if (Math.abs(e3) < 15e14) {
    while (c0 < 7 && c0 != 1 || c0 == 1 && c3.charAt(1) > 3) {
      x3 = x3.times(y4);
      c3 = digitsToString(x3.d);
      c0 = c3.charAt(0);
      n2++;
    }
    e3 = getBase10Exponent(x3);
    if (c0 > 1) {
      x3 = new Ctor("0." + c3);
      e3++;
    } else {
      x3 = new Ctor(c0 + "." + c3.slice(1));
    }
  } else {
    t3 = getLn10(Ctor, wpr + 2, pr).times(e3 + "");
    x3 = ln(new Ctor(c0 + "." + c3.slice(1)), wpr - guard).plus(t3);
    Ctor.precision = pr;
    return sd == null ? (external = true, round(x3, pr)) : x3;
  }
  sum2 = numerator = x3 = divide(x3.minus(ONE), x3.plus(ONE), wpr);
  x22 = round(x3.times(x3), wpr);
  denominator = 3;
  for (; ; ) {
    numerator = round(numerator.times(x22), wpr);
    t3 = sum2.plus(divide(numerator, new Ctor(denominator), wpr));
    if (digitsToString(t3.d).slice(0, wpr) === digitsToString(sum2.d).slice(0, wpr)) {
      sum2 = sum2.times(2);
      if (e3 !== 0) sum2 = sum2.plus(getLn10(Ctor, wpr + 2, pr).times(e3 + ""));
      sum2 = divide(sum2, new Ctor(n2), wpr);
      Ctor.precision = pr;
      return sd == null ? (external = true, round(sum2, pr)) : sum2;
    }
    sum2 = t3;
    denominator += 2;
  }
}
function parseDecimal(x3, str) {
  var e3, i3, len;
  if ((e3 = str.indexOf(".")) > -1) str = str.replace(".", "");
  if ((i3 = str.search(/e/i)) > 0) {
    if (e3 < 0) e3 = i3;
    e3 += +str.slice(i3 + 1);
    str = str.substring(0, i3);
  } else if (e3 < 0) {
    e3 = str.length;
  }
  for (i3 = 0; str.charCodeAt(i3) === 48; ) ++i3;
  for (len = str.length; str.charCodeAt(len - 1) === 48; ) --len;
  str = str.slice(i3, len);
  if (str) {
    len -= i3;
    e3 = e3 - i3 - 1;
    x3.e = mathfloor(e3 / LOG_BASE);
    x3.d = [];
    i3 = (e3 + 1) % LOG_BASE;
    if (e3 < 0) i3 += LOG_BASE;
    if (i3 < len) {
      if (i3) x3.d.push(+str.slice(0, i3));
      for (len -= LOG_BASE; i3 < len; ) x3.d.push(+str.slice(i3, i3 += LOG_BASE));
      str = str.slice(i3);
      i3 = LOG_BASE - str.length;
    } else {
      i3 -= len;
    }
    for (; i3--; ) str += "0";
    x3.d.push(+str);
    if (external && (x3.e > MAX_E || x3.e < -MAX_E)) throw Error(exponentOutOfRange + e3);
  } else {
    x3.s = 0;
    x3.e = 0;
    x3.d = [0];
  }
  return x3;
}
function round(x3, sd, rm) {
  var i3, j, k3, n2, rd, doRound, w3, xdi, xd = x3.d;
  for (n2 = 1, k3 = xd[0]; k3 >= 10; k3 /= 10) n2++;
  i3 = sd - n2;
  if (i3 < 0) {
    i3 += LOG_BASE;
    j = sd;
    w3 = xd[xdi = 0];
  } else {
    xdi = Math.ceil((i3 + 1) / LOG_BASE);
    k3 = xd.length;
    if (xdi >= k3) return x3;
    w3 = k3 = xd[xdi];
    for (n2 = 1; k3 >= 10; k3 /= 10) n2++;
    i3 %= LOG_BASE;
    j = i3 - LOG_BASE + n2;
  }
  if (rm !== void 0) {
    k3 = mathpow(10, n2 - j - 1);
    rd = w3 / k3 % 10 | 0;
    doRound = sd < 0 || xd[xdi + 1] !== void 0 || w3 % k3;
    doRound = rm < 4 ? (rd || doRound) && (rm == 0 || rm == (x3.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || doRound || rm == 6 && // Check whether the digit to the left of the rounding digit is odd.
    (i3 > 0 ? j > 0 ? w3 / mathpow(10, n2 - j) : 0 : xd[xdi - 1]) % 10 & 1 || rm == (x3.s < 0 ? 8 : 7));
  }
  if (sd < 1 || !xd[0]) {
    if (doRound) {
      k3 = getBase10Exponent(x3);
      xd.length = 1;
      sd = sd - k3 - 1;
      xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
      x3.e = mathfloor(-sd / LOG_BASE) || 0;
    } else {
      xd.length = 1;
      xd[0] = x3.e = x3.s = 0;
    }
    return x3;
  }
  if (i3 == 0) {
    xd.length = xdi;
    k3 = 1;
    xdi--;
  } else {
    xd.length = xdi + 1;
    k3 = mathpow(10, LOG_BASE - i3);
    xd[xdi] = j > 0 ? (w3 / mathpow(10, n2 - j) % mathpow(10, j) | 0) * k3 : 0;
  }
  if (doRound) {
    for (; ; ) {
      if (xdi == 0) {
        if ((xd[0] += k3) == BASE) {
          xd[0] = 1;
          ++x3.e;
        }
        break;
      } else {
        xd[xdi] += k3;
        if (xd[xdi] != BASE) break;
        xd[xdi--] = 0;
        k3 = 1;
      }
    }
  }
  for (i3 = xd.length; xd[--i3] === 0; ) xd.pop();
  if (external && (x3.e > MAX_E || x3.e < -MAX_E)) {
    throw Error(exponentOutOfRange + getBase10Exponent(x3));
  }
  return x3;
}
function subtract(x3, y4) {
  var d4, e3, i3, j, k3, len, xd, xe, xLTy, yd, Ctor = x3.constructor, pr = Ctor.precision;
  if (!x3.s || !y4.s) {
    if (y4.s) y4.s = -y4.s;
    else y4 = new Ctor(x3);
    return external ? round(y4, pr) : y4;
  }
  xd = x3.d;
  yd = y4.d;
  e3 = y4.e;
  xe = x3.e;
  xd = xd.slice();
  k3 = xe - e3;
  if (k3) {
    xLTy = k3 < 0;
    if (xLTy) {
      d4 = xd;
      k3 = -k3;
      len = yd.length;
    } else {
      d4 = yd;
      e3 = xe;
      len = xd.length;
    }
    i3 = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;
    if (k3 > i3) {
      k3 = i3;
      d4.length = 1;
    }
    d4.reverse();
    for (i3 = k3; i3--; ) d4.push(0);
    d4.reverse();
  } else {
    i3 = xd.length;
    len = yd.length;
    xLTy = i3 < len;
    if (xLTy) len = i3;
    for (i3 = 0; i3 < len; i3++) {
      if (xd[i3] != yd[i3]) {
        xLTy = xd[i3] < yd[i3];
        break;
      }
    }
    k3 = 0;
  }
  if (xLTy) {
    d4 = xd;
    xd = yd;
    yd = d4;
    y4.s = -y4.s;
  }
  len = xd.length;
  for (i3 = yd.length - len; i3 > 0; --i3) xd[len++] = 0;
  for (i3 = yd.length; i3 > k3; ) {
    if (xd[--i3] < yd[i3]) {
      for (j = i3; j && xd[--j] === 0; ) xd[j] = BASE - 1;
      --xd[j];
      xd[i3] += BASE;
    }
    xd[i3] -= yd[i3];
  }
  for (; xd[--len] === 0; ) xd.pop();
  for (; xd[0] === 0; xd.shift()) --e3;
  if (!xd[0]) return new Ctor(0);
  y4.d = xd;
  y4.e = e3;
  return external ? round(y4, pr) : y4;
}
function toString(x3, isExp, sd) {
  var k3, e3 = getBase10Exponent(x3), str = digitsToString(x3.d), len = str.length;
  if (isExp) {
    if (sd && (k3 = sd - len) > 0) {
      str = str.charAt(0) + "." + str.slice(1) + getZeroString(k3);
    } else if (len > 1) {
      str = str.charAt(0) + "." + str.slice(1);
    }
    str = str + (e3 < 0 ? "e" : "e+") + e3;
  } else if (e3 < 0) {
    str = "0." + getZeroString(-e3 - 1) + str;
    if (sd && (k3 = sd - len) > 0) str += getZeroString(k3);
  } else if (e3 >= len) {
    str += getZeroString(e3 + 1 - len);
    if (sd && (k3 = sd - e3 - 1) > 0) str = str + "." + getZeroString(k3);
  } else {
    if ((k3 = e3 + 1) < len) str = str.slice(0, k3) + "." + str.slice(k3);
    if (sd && (k3 = sd - len) > 0) {
      if (e3 + 1 === len) str += ".";
      str += getZeroString(k3);
    }
  }
  return x3.s < 0 ? "-" + str : str;
}
function truncate(arr, len) {
  if (arr.length > len) {
    arr.length = len;
    return true;
  }
}
function clone(obj) {
  var i3, p2, ps;
  function Decimal2(value) {
    var x3 = this;
    if (!(x3 instanceof Decimal2)) return new Decimal2(value);
    x3.constructor = Decimal2;
    if (value instanceof Decimal2) {
      x3.s = value.s;
      x3.e = value.e;
      x3.d = (value = value.d) ? value.slice() : value;
      return;
    }
    if (typeof value === "number") {
      if (value * 0 !== 0) {
        throw Error(invalidArgument + value);
      }
      if (value > 0) {
        x3.s = 1;
      } else if (value < 0) {
        value = -value;
        x3.s = -1;
      } else {
        x3.s = 0;
        x3.e = 0;
        x3.d = [0];
        return;
      }
      if (value === ~~value && value < 1e7) {
        x3.e = 0;
        x3.d = [value];
        return;
      }
      return parseDecimal(x3, value.toString());
    } else if (typeof value !== "string") {
      throw Error(invalidArgument + value);
    }
    if (value.charCodeAt(0) === 45) {
      value = value.slice(1);
      x3.s = -1;
    } else {
      x3.s = 1;
    }
    if (isDecimal.test(value)) parseDecimal(x3, value);
    else throw Error(invalidArgument + value);
  }
  Decimal2.prototype = P;
  Decimal2.ROUND_UP = 0;
  Decimal2.ROUND_DOWN = 1;
  Decimal2.ROUND_CEIL = 2;
  Decimal2.ROUND_FLOOR = 3;
  Decimal2.ROUND_HALF_UP = 4;
  Decimal2.ROUND_HALF_DOWN = 5;
  Decimal2.ROUND_HALF_EVEN = 6;
  Decimal2.ROUND_HALF_CEIL = 7;
  Decimal2.ROUND_HALF_FLOOR = 8;
  Decimal2.clone = clone;
  Decimal2.config = Decimal2.set = config;
  if (obj === void 0) obj = {};
  if (obj) {
    ps = ["precision", "rounding", "toExpNeg", "toExpPos", "LN10"];
    for (i3 = 0; i3 < ps.length; ) if (!obj.hasOwnProperty(p2 = ps[i3++])) obj[p2] = this[p2];
  }
  Decimal2.config(obj);
  return Decimal2;
}
function config(obj) {
  if (!obj || typeof obj !== "object") {
    throw Error(decimalError + "Object expected");
  }
  var i3, p2, v2, ps = [
    "precision",
    1,
    MAX_DIGITS,
    "rounding",
    0,
    8,
    "toExpNeg",
    -1 / 0,
    0,
    "toExpPos",
    0,
    1 / 0
  ];
  for (i3 = 0; i3 < ps.length; i3 += 3) {
    if ((v2 = obj[p2 = ps[i3]]) !== void 0) {
      if (mathfloor(v2) === v2 && v2 >= ps[i3 + 1] && v2 <= ps[i3 + 2]) this[p2] = v2;
      else throw Error(invalidArgument + p2 + ": " + v2);
    }
  }
  if ((v2 = obj[p2 = "LN10"]) !== void 0) {
    if (v2 == Math.LN10) this[p2] = new this(v2);
    else throw Error(invalidArgument + p2 + ": " + v2);
  }
  return this;
}
var Decimal = clone(defaults);
ONE = new Decimal(1);
const Decimal$1 = Decimal;
function _toConsumableArray$b(arr) {
  return _arrayWithoutHoles$b(arr) || _iterableToArray$c(arr) || _unsupportedIterableToArray$h(arr) || _nonIterableSpread$b();
}
function _nonIterableSpread$b() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$h(o2, minLen) {
  if (!o2) return;
  if (typeof o2 === "string") return _arrayLikeToArray$h(o2, minLen);
  var n2 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n2 === "Object" && o2.constructor) n2 = o2.constructor.name;
  if (n2 === "Map" || n2 === "Set") return Array.from(o2);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray$h(o2, minLen);
}
function _iterableToArray$c(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function _arrayWithoutHoles$b(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$h(arr);
}
function _arrayLikeToArray$h(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i3 = 0, arr2 = new Array(len); i3 < len; i3++) {
    arr2[i3] = arr[i3];
  }
  return arr2;
}
var identity$1 = function identity(i3) {
  return i3;
};
var PLACE_HOLDER = {};
var isPlaceHolder = function isPlaceHolder2(val) {
  return val === PLACE_HOLDER;
};
var curry0 = function curry02(fn) {
  return function _curried() {
    if (arguments.length === 0 || arguments.length === 1 && isPlaceHolder(arguments.length <= 0 ? void 0 : arguments[0])) {
      return _curried;
    }
    return fn.apply(void 0, arguments);
  };
};
var curryN = function curryN2(n2, fn) {
  if (n2 === 1) {
    return fn;
  }
  return curry0(function() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var argsLength = args.filter(function(arg) {
      return arg !== PLACE_HOLDER;
    }).length;
    if (argsLength >= n2) {
      return fn.apply(void 0, args);
    }
    return curryN2(n2 - argsLength, curry0(function() {
      for (var _len2 = arguments.length, restArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        restArgs[_key2] = arguments[_key2];
      }
      var newArgs = args.map(function(arg) {
        return isPlaceHolder(arg) ? restArgs.shift() : arg;
      });
      return fn.apply(void 0, _toConsumableArray$b(newArgs).concat(restArgs));
    }));
  });
};
var curry = function curry2(fn) {
  return curryN(fn.length, fn);
};
var range$1 = function range(begin, end) {
  var arr = [];
  for (var i3 = begin; i3 < end; ++i3) {
    arr[i3 - begin] = i3;
  }
  return arr;
};
var map = curry(function(fn, arr) {
  if (Array.isArray(arr)) {
    return arr.map(fn);
  }
  return Object.keys(arr).map(function(key) {
    return arr[key];
  }).map(fn);
});
var compose = function compose2() {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }
  if (!args.length) {
    return identity$1;
  }
  var fns = args.reverse();
  var firstFn = fns[0];
  var tailsFn = fns.slice(1);
  return function() {
    return tailsFn.reduce(function(res, fn) {
      return fn(res);
    }, firstFn.apply(void 0, arguments));
  };
};
var reverse = function reverse2(arr) {
  if (Array.isArray(arr)) {
    return arr.reverse();
  }
  return arr.split("").reverse.join("");
};
var memoize$1 = function memoize(fn) {
  var lastArgs = null;
  var lastResult2 = null;
  return function() {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }
    if (lastArgs && args.every(function(val, i3) {
      return val === lastArgs[i3];
    })) {
      return lastResult2;
    }
    lastArgs = args;
    lastResult2 = fn.apply(void 0, args);
    return lastResult2;
  };
};
function getDigitCount(value) {
  var result;
  if (value === 0) {
    result = 1;
  } else {
    result = Math.floor(new Decimal$1(value).abs().log(10).toNumber()) + 1;
  }
  return result;
}
function rangeStep(start, end, step) {
  var num = new Decimal$1(start);
  var i3 = 0;
  var result = [];
  while (num.lt(end) && i3 < 1e5) {
    result.push(num.toNumber());
    num = num.add(step);
    i3++;
  }
  return result;
}
var interpolateNumber2 = curry(function(a4, b3, t3) {
  var newA = +a4;
  var newB = +b3;
  return newA + t3 * (newB - newA);
});
var uninterpolateNumber = curry(function(a4, b3, x3) {
  var diff = b3 - +a4;
  diff = diff || Infinity;
  return (x3 - a4) / diff;
});
var uninterpolateTruncation = curry(function(a4, b3, x3) {
  var diff = b3 - +a4;
  diff = diff || Infinity;
  return Math.max(0, Math.min(1, (x3 - a4) / diff));
});
const Arithmetic = {
  rangeStep,
  getDigitCount,
  interpolateNumber: interpolateNumber2,
  uninterpolateNumber,
  uninterpolateTruncation
};
function _toConsumableArray$a(arr) {
  return _arrayWithoutHoles$a(arr) || _iterableToArray$b(arr) || _unsupportedIterableToArray$g(arr) || _nonIterableSpread$a();
}
function _nonIterableSpread$a() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray$b(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function _arrayWithoutHoles$a(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$g(arr);
}
function _slicedToArray$8(arr, i3) {
  return _arrayWithHoles$9(arr) || _iterableToArrayLimit$8(arr, i3) || _unsupportedIterableToArray$g(arr, i3) || _nonIterableRest$9();
}
function _nonIterableRest$9() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$g(o2, minLen) {
  if (!o2) return;
  if (typeof o2 === "string") return _arrayLikeToArray$g(o2, minLen);
  var n2 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n2 === "Object" && o2.constructor) n2 = o2.constructor.name;
  if (n2 === "Map" || n2 === "Set") return Array.from(o2);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray$g(o2, minLen);
}
function _arrayLikeToArray$g(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i3 = 0, arr2 = new Array(len); i3 < len; i3++) {
    arr2[i3] = arr[i3];
  }
  return arr2;
}
function _iterableToArrayLimit$8(arr, i3) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = void 0;
  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i3 && _arr.length === i3) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles$9(arr) {
  if (Array.isArray(arr)) return arr;
}
function getValidInterval(_ref) {
  var _ref2 = _slicedToArray$8(_ref, 2), min2 = _ref2[0], max2 = _ref2[1];
  var validMin = min2, validMax = max2;
  if (min2 > max2) {
    validMin = max2;
    validMax = min2;
  }
  return [validMin, validMax];
}
function getFormatStep(roughStep, allowDecimals, correctionFactor) {
  if (roughStep.lte(0)) {
    return new Decimal$1(0);
  }
  var digitCount = Arithmetic.getDigitCount(roughStep.toNumber());
  var digitCountValue = new Decimal$1(10).pow(digitCount);
  var stepRatio = roughStep.div(digitCountValue);
  var stepRatioScale = digitCount !== 1 ? 0.05 : 0.1;
  var amendStepRatio = new Decimal$1(Math.ceil(stepRatio.div(stepRatioScale).toNumber())).add(correctionFactor).mul(stepRatioScale);
  var formatStep = amendStepRatio.mul(digitCountValue);
  return allowDecimals ? formatStep : new Decimal$1(Math.ceil(formatStep));
}
function getTickOfSingleValue(value, tickCount, allowDecimals) {
  var step = 1;
  var middle = new Decimal$1(value);
  if (!middle.isint() && allowDecimals) {
    var absVal = Math.abs(value);
    if (absVal < 1) {
      step = new Decimal$1(10).pow(Arithmetic.getDigitCount(value) - 1);
      middle = new Decimal$1(Math.floor(middle.div(step).toNumber())).mul(step);
    } else if (absVal > 1) {
      middle = new Decimal$1(Math.floor(value));
    }
  } else if (value === 0) {
    middle = new Decimal$1(Math.floor((tickCount - 1) / 2));
  } else if (!allowDecimals) {
    middle = new Decimal$1(Math.floor(value));
  }
  var middleIndex = Math.floor((tickCount - 1) / 2);
  var fn = compose(map(function(n2) {
    return middle.add(new Decimal$1(n2 - middleIndex).mul(step)).toNumber();
  }), range$1);
  return fn(0, tickCount);
}
function calculateStep(min2, max2, tickCount, allowDecimals) {
  var correctionFactor = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0;
  if (!Number.isFinite((max2 - min2) / (tickCount - 1))) {
    return {
      step: new Decimal$1(0),
      tickMin: new Decimal$1(0),
      tickMax: new Decimal$1(0)
    };
  }
  var step = getFormatStep(new Decimal$1(max2).sub(min2).div(tickCount - 1), allowDecimals, correctionFactor);
  var middle;
  if (min2 <= 0 && max2 >= 0) {
    middle = new Decimal$1(0);
  } else {
    middle = new Decimal$1(min2).add(max2).div(2);
    middle = middle.sub(new Decimal$1(middle).mod(step));
  }
  var belowCount = Math.ceil(middle.sub(min2).div(step).toNumber());
  var upCount = Math.ceil(new Decimal$1(max2).sub(middle).div(step).toNumber());
  var scaleCount = belowCount + upCount + 1;
  if (scaleCount > tickCount) {
    return calculateStep(min2, max2, tickCount, allowDecimals, correctionFactor + 1);
  }
  if (scaleCount < tickCount) {
    upCount = max2 > 0 ? upCount + (tickCount - scaleCount) : upCount;
    belowCount = max2 > 0 ? belowCount : belowCount + (tickCount - scaleCount);
  }
  return {
    step,
    tickMin: middle.sub(new Decimal$1(belowCount).mul(step)),
    tickMax: middle.add(new Decimal$1(upCount).mul(step))
  };
}
function getNiceTickValuesFn(_ref3) {
  var _ref4 = _slicedToArray$8(_ref3, 2), min2 = _ref4[0], max2 = _ref4[1];
  var tickCount = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 6;
  var allowDecimals = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
  var count2 = Math.max(tickCount, 2);
  var _getValidInterval = getValidInterval([min2, max2]), _getValidInterval2 = _slicedToArray$8(_getValidInterval, 2), cormin = _getValidInterval2[0], cormax = _getValidInterval2[1];
  if (cormin === -Infinity || cormax === Infinity) {
    var _values = cormax === Infinity ? [cormin].concat(_toConsumableArray$a(range$1(0, tickCount - 1).map(function() {
      return Infinity;
    }))) : [].concat(_toConsumableArray$a(range$1(0, tickCount - 1).map(function() {
      return -Infinity;
    })), [cormax]);
    return min2 > max2 ? reverse(_values) : _values;
  }
  if (cormin === cormax) {
    return getTickOfSingleValue(cormin, tickCount, allowDecimals);
  }
  var _calculateStep = calculateStep(cormin, cormax, count2, allowDecimals), step = _calculateStep.step, tickMin = _calculateStep.tickMin, tickMax = _calculateStep.tickMax;
  var values = Arithmetic.rangeStep(tickMin, tickMax.add(new Decimal$1(0.1).mul(step)), step);
  return min2 > max2 ? reverse(values) : values;
}
function getTickValuesFixedDomainFn(_ref7, tickCount) {
  var _ref8 = _slicedToArray$8(_ref7, 2), min2 = _ref8[0], max2 = _ref8[1];
  var allowDecimals = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
  var _getValidInterval5 = getValidInterval([min2, max2]), _getValidInterval6 = _slicedToArray$8(_getValidInterval5, 2), cormin = _getValidInterval6[0], cormax = _getValidInterval6[1];
  if (cormin === -Infinity || cormax === Infinity) {
    return [min2, max2];
  }
  if (cormin === cormax) {
    return [cormin];
  }
  var count2 = Math.max(tickCount, 2);
  var step = getFormatStep(new Decimal$1(cormax).sub(cormin).div(count2 - 1), allowDecimals, 0);
  var values = [].concat(_toConsumableArray$a(Arithmetic.rangeStep(new Decimal$1(cormin), new Decimal$1(cormax).sub(new Decimal$1(0.99).mul(step)), step)), [cormax]);
  return min2 > max2 ? reverse(values) : values;
}
var getNiceTickValues = memoize$1(getNiceTickValuesFn);
var getTickValuesFixedDomain = memoize$1(getTickValuesFixedDomainFn);
var isProduction = process.env.NODE_ENV === "production";
var prefix = "Invariant failed";
function invariant(condition, message) {
  if (isProduction) {
    throw new Error(prefix);
  }
  var provided = typeof message === "function" ? message() : message;
  var value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
  throw new Error(value);
}
var _excluded$e = ["offset", "layout", "width", "dataKey", "data", "dataPointFormatter", "xAxis", "yAxis"];
function _typeof$B(o2) {
  "@babel/helpers - typeof";
  return _typeof$B = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof$B(o2);
}
function _extends$p() {
  _extends$p = Object.assign ? Object.assign.bind() : function(target) {
    for (var i3 = 1; i3 < arguments.length; i3++) {
      var source = arguments[i3];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$p.apply(this, arguments);
}
function _slicedToArray$7(arr, i3) {
  return _arrayWithHoles$8(arr) || _iterableToArrayLimit$7(arr, i3) || _unsupportedIterableToArray$f(arr, i3) || _nonIterableRest$8();
}
function _nonIterableRest$8() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$f(o2, minLen) {
  if (!o2) return;
  if (typeof o2 === "string") return _arrayLikeToArray$f(o2, minLen);
  var n2 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n2 === "Object" && o2.constructor) n2 = o2.constructor.name;
  if (n2 === "Map" || n2 === "Set") return Array.from(o2);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray$f(o2, minLen);
}
function _arrayLikeToArray$f(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i3 = 0, arr2 = new Array(len); i3 < len; i3++) arr2[i3] = arr[i3];
  return arr2;
}
function _iterableToArrayLimit$7(r2, l2) {
  var t3 = null == r2 ? null : "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];
  if (null != t3) {
    var e3, n2, i3, u3, a4 = [], f2 = true, o2 = false;
    try {
      if (i3 = (t3 = t3.call(r2)).next, 0 === l2) ;
      else for (; !(f2 = (e3 = i3.call(t3)).done) && (a4.push(e3.value), a4.length !== l2); f2 = true) ;
    } catch (r3) {
      o2 = true, n2 = r3;
    } finally {
      try {
        if (!f2 && null != t3["return"] && (u3 = t3["return"](), Object(u3) !== u3)) return;
      } finally {
        if (o2) throw n2;
      }
    }
    return a4;
  }
}
function _arrayWithHoles$8(arr) {
  if (Array.isArray(arr)) return arr;
}
function _objectWithoutProperties$e(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$e(source, excluded);
  var key, i3;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i3 = 0; i3 < sourceSymbolKeys.length; i3++) {
      key = sourceSymbolKeys[i3];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$e(source, excluded) {
  if (source == null) return {};
  var target = {};
  for (var key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _classCallCheck$h(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$h(target, props) {
  for (var i3 = 0; i3 < props.length; i3++) {
    var descriptor = props[i3];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$z(descriptor.key), descriptor);
  }
}
function _createClass$h(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$h(Constructor.prototype, protoProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _callSuper$e(t3, o2, e3) {
  return o2 = _getPrototypeOf$f(o2), _possibleConstructorReturn$f(t3, _isNativeReflectConstruct$f() ? Reflect.construct(o2, e3 || [], _getPrototypeOf$f(t3).constructor) : o2.apply(t3, e3));
}
function _possibleConstructorReturn$f(self2, call) {
  if (call && (_typeof$B(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$f(self2);
}
function _assertThisInitialized$f(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$f() {
  try {
    var t3 = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$f = function _isNativeReflectConstruct2() {
    return !!t3;
  })();
}
function _getPrototypeOf$f(o2) {
  _getPrototypeOf$f = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o3) {
    return o3.__proto__ || Object.getPrototypeOf(o3);
  };
  return _getPrototypeOf$f(o2);
}
function _inherits$f(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass) _setPrototypeOf$f(subClass, superClass);
}
function _setPrototypeOf$f(o2, p2) {
  _setPrototypeOf$f = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o3, p3) {
    o3.__proto__ = p3;
    return o3;
  };
  return _setPrototypeOf$f(o2, p2);
}
function _defineProperty$z(obj, key, value) {
  key = _toPropertyKey$z(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$z(t3) {
  var i3 = _toPrimitive$z(t3, "string");
  return "symbol" == _typeof$B(i3) ? i3 : i3 + "";
}
function _toPrimitive$z(t3, r2) {
  if ("object" != _typeof$B(t3) || !t3) return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i3 = e3.call(t3, r2);
    if ("object" != _typeof$B(i3)) return i3;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t3);
}
var ErrorBar = /* @__PURE__ */ function(_React$Component) {
  function ErrorBar2() {
    _classCallCheck$h(this, ErrorBar2);
    return _callSuper$e(this, ErrorBar2, arguments);
  }
  _inherits$f(ErrorBar2, _React$Component);
  return _createClass$h(ErrorBar2, [{
    key: "render",
    value: function render() {
      var _this$props = this.props, offset2 = _this$props.offset, layout = _this$props.layout, width = _this$props.width, dataKey = _this$props.dataKey, data = _this$props.data, dataPointFormatter = _this$props.dataPointFormatter, xAxis = _this$props.xAxis, yAxis = _this$props.yAxis, others = _objectWithoutProperties$e(_this$props, _excluded$e);
      var svgProps = filterProps(others, false);
      !!(this.props.direction === "x" && xAxis.type !== "number") ? process.env.NODE_ENV !== "production" ? invariant(false, 'ErrorBar requires Axis type property to be "number".') : invariant() : void 0;
      var errorBars = data.map(function(entry) {
        var _dataPointFormatter = dataPointFormatter(entry, dataKey), x3 = _dataPointFormatter.x, y4 = _dataPointFormatter.y, value = _dataPointFormatter.value, errorVal = _dataPointFormatter.errorVal;
        if (!errorVal) {
          return null;
        }
        var lineCoordinates = [];
        var lowBound, highBound;
        if (Array.isArray(errorVal)) {
          var _errorVal = _slicedToArray$7(errorVal, 2);
          lowBound = _errorVal[0];
          highBound = _errorVal[1];
        } else {
          lowBound = highBound = errorVal;
        }
        if (layout === "vertical") {
          var scale2 = xAxis.scale;
          var yMid = y4 + offset2;
          var yMin = yMid + width;
          var yMax = yMid - width;
          var xMin = scale2(value - lowBound);
          var xMax = scale2(value + highBound);
          lineCoordinates.push({
            x1: xMax,
            y1: yMin,
            x2: xMax,
            y2: yMax
          });
          lineCoordinates.push({
            x1: xMin,
            y1: yMid,
            x2: xMax,
            y2: yMid
          });
          lineCoordinates.push({
            x1: xMin,
            y1: yMin,
            x2: xMin,
            y2: yMax
          });
        } else if (layout === "horizontal") {
          var _scale = yAxis.scale;
          var xMid = x3 + offset2;
          var _xMin = xMid - width;
          var _xMax = xMid + width;
          var _yMin = _scale(value - lowBound);
          var _yMax = _scale(value + highBound);
          lineCoordinates.push({
            x1: _xMin,
            y1: _yMax,
            x2: _xMax,
            y2: _yMax
          });
          lineCoordinates.push({
            x1: xMid,
            y1: _yMin,
            x2: xMid,
            y2: _yMax
          });
          lineCoordinates.push({
            x1: _xMin,
            y1: _yMin,
            x2: _xMax,
            y2: _yMin
          });
        }
        return /* @__PURE__ */ React__default.createElement(Layer, _extends$p({
          className: "recharts-errorBar",
          key: "bar-".concat(lineCoordinates.map(function(c3) {
            return "".concat(c3.x1, "-").concat(c3.x2, "-").concat(c3.y1, "-").concat(c3.y2);
          }))
        }, svgProps), lineCoordinates.map(function(coordinates) {
          return /* @__PURE__ */ React__default.createElement("line", _extends$p({}, coordinates, {
            key: "line-".concat(coordinates.x1, "-").concat(coordinates.x2, "-").concat(coordinates.y1, "-").concat(coordinates.y2)
          }));
        }));
      });
      return /* @__PURE__ */ React__default.createElement(Layer, {
        className: "recharts-errorBars"
      }, errorBars);
    }
  }]);
}(React__default.Component);
_defineProperty$z(ErrorBar, "defaultProps", {
  stroke: "black",
  strokeWidth: 1.5,
  width: 5,
  offset: 0,
  layout: "horizontal"
});
_defineProperty$z(ErrorBar, "displayName", "ErrorBar");
function _typeof$A(o2) {
  "@babel/helpers - typeof";
  return _typeof$A = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof$A(o2);
}
function ownKeys$v(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e3);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$v(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$v(Object(t3), true).forEach(function(r3) {
      _defineProperty$y(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$v(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
function _defineProperty$y(obj, key, value) {
  key = _toPropertyKey$y(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$y(t3) {
  var i3 = _toPrimitive$y(t3, "string");
  return "symbol" == _typeof$A(i3) ? i3 : i3 + "";
}
function _toPrimitive$y(t3, r2) {
  if ("object" != _typeof$A(t3) || !t3) return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i3 = e3.call(t3, r2);
    if ("object" != _typeof$A(i3)) return i3;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t3);
}
var getLegendProps = function getLegendProps2(_ref) {
  var children = _ref.children, formattedGraphicalItems = _ref.formattedGraphicalItems, legendWidth = _ref.legendWidth, legendContent = _ref.legendContent;
  var legendItem = findChildByType(children, Legend$2);
  if (!legendItem) {
    return null;
  }
  var legendDefaultProps = Legend$2.defaultProps;
  var legendProps = legendDefaultProps !== void 0 ? _objectSpread$v(_objectSpread$v({}, legendDefaultProps), legendItem.props) : {};
  var legendData;
  if (legendItem.props && legendItem.props.payload) {
    legendData = legendItem.props && legendItem.props.payload;
  } else if (legendContent === "children") {
    legendData = (formattedGraphicalItems || []).reduce(function(result, _ref2) {
      var item = _ref2.item, props = _ref2.props;
      var data = props.sectors || props.data || [];
      return result.concat(data.map(function(entry) {
        return {
          type: legendItem.props.iconType || item.props.legendType,
          value: entry.name,
          color: entry.fill,
          payload: entry
        };
      }));
    }, []);
  } else {
    legendData = (formattedGraphicalItems || []).map(function(_ref3) {
      var item = _ref3.item;
      var itemDefaultProps = item.type.defaultProps;
      var itemProps = itemDefaultProps !== void 0 ? _objectSpread$v(_objectSpread$v({}, itemDefaultProps), item.props) : {};
      var dataKey = itemProps.dataKey, name = itemProps.name, legendType = itemProps.legendType, hide2 = itemProps.hide;
      return {
        inactive: hide2,
        dataKey,
        type: legendProps.iconType || legendType || "square",
        color: getMainColorOfGraphicItem(item),
        value: name || dataKey,
        // @ts-expect-error property strokeDasharray is required in Payload but optional in props
        payload: itemProps
      };
    });
  }
  return _objectSpread$v(_objectSpread$v(_objectSpread$v({}, legendProps), Legend$2.getWithHeight(legendItem, legendWidth)), {}, {
    payload: legendData,
    item: legendItem
  });
};
function _typeof$z(o2) {
  "@babel/helpers - typeof";
  return _typeof$z = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof$z(o2);
}
function _toConsumableArray$9(arr) {
  return _arrayWithoutHoles$9(arr) || _iterableToArray$a(arr) || _unsupportedIterableToArray$e(arr) || _nonIterableSpread$9();
}
function _nonIterableSpread$9() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$e(o2, minLen) {
  if (!o2) return;
  if (typeof o2 === "string") return _arrayLikeToArray$e(o2, minLen);
  var n2 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n2 === "Object" && o2.constructor) n2 = o2.constructor.name;
  if (n2 === "Map" || n2 === "Set") return Array.from(o2);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray$e(o2, minLen);
}
function _iterableToArray$a(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles$9(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$e(arr);
}
function _arrayLikeToArray$e(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i3 = 0, arr2 = new Array(len); i3 < len; i3++) arr2[i3] = arr[i3];
  return arr2;
}
function ownKeys$u(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e3);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$u(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$u(Object(t3), true).forEach(function(r3) {
      _defineProperty$x(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$u(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
function _defineProperty$x(obj, key, value) {
  key = _toPropertyKey$x(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$x(t3) {
  var i3 = _toPrimitive$x(t3, "string");
  return "symbol" == _typeof$z(i3) ? i3 : i3 + "";
}
function _toPrimitive$x(t3, r2) {
  if ("object" != _typeof$z(t3) || !t3) return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i3 = e3.call(t3, r2);
    if ("object" != _typeof$z(i3)) return i3;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t3);
}
function getValueByDataKey(obj, dataKey, defaultValue2) {
  if (isNil(obj) || isNil(dataKey)) {
    return defaultValue2;
  }
  if (isNumOrStr(dataKey)) {
    return get(obj, dataKey, defaultValue2);
  }
  if (isFunction(dataKey)) {
    return dataKey(obj);
  }
  return defaultValue2;
}
function getDomainOfDataByKey(data, key, type, filterNil) {
  var flattenData = flatMap(data, function(entry) {
    return getValueByDataKey(entry, key);
  });
  if (type === "number") {
    var domain = flattenData.filter(function(entry) {
      return isNumber(entry) || parseFloat(entry);
    });
    return domain.length ? [min(domain), max(domain)] : [Infinity, -Infinity];
  }
  var validateData = filterNil ? flattenData.filter(function(entry) {
    return !isNil(entry);
  }) : flattenData;
  return validateData.map(function(entry) {
    return isNumOrStr(entry) || entry instanceof Date ? entry : "";
  });
}
var calculateActiveTickIndex = function calculateActiveTickIndex2(coordinate) {
  var _ticks$length;
  var ticks2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  var unsortedTicks = arguments.length > 2 ? arguments[2] : void 0;
  var axis = arguments.length > 3 ? arguments[3] : void 0;
  var index2 = -1;
  var len = (_ticks$length = ticks2 === null || ticks2 === void 0 ? void 0 : ticks2.length) !== null && _ticks$length !== void 0 ? _ticks$length : 0;
  if (len <= 1) {
    return 0;
  }
  if (axis && axis.axisType === "angleAxis" && Math.abs(Math.abs(axis.range[1] - axis.range[0]) - 360) <= 1e-6) {
    var range3 = axis.range;
    for (var i3 = 0; i3 < len; i3++) {
      var before = i3 > 0 ? unsortedTicks[i3 - 1].coordinate : unsortedTicks[len - 1].coordinate;
      var cur = unsortedTicks[i3].coordinate;
      var after = i3 >= len - 1 ? unsortedTicks[0].coordinate : unsortedTicks[i3 + 1].coordinate;
      var sameDirectionCoord = void 0;
      if (mathSign(cur - before) !== mathSign(after - cur)) {
        var diffInterval = [];
        if (mathSign(after - cur) === mathSign(range3[1] - range3[0])) {
          sameDirectionCoord = after;
          var curInRange = cur + range3[1] - range3[0];
          diffInterval[0] = Math.min(curInRange, (curInRange + before) / 2);
          diffInterval[1] = Math.max(curInRange, (curInRange + before) / 2);
        } else {
          sameDirectionCoord = before;
          var afterInRange = after + range3[1] - range3[0];
          diffInterval[0] = Math.min(cur, (afterInRange + cur) / 2);
          diffInterval[1] = Math.max(cur, (afterInRange + cur) / 2);
        }
        var sameInterval = [Math.min(cur, (sameDirectionCoord + cur) / 2), Math.max(cur, (sameDirectionCoord + cur) / 2)];
        if (coordinate > sameInterval[0] && coordinate <= sameInterval[1] || coordinate >= diffInterval[0] && coordinate <= diffInterval[1]) {
          index2 = unsortedTicks[i3].index;
          break;
        }
      } else {
        var minValue = Math.min(before, after);
        var maxValue = Math.max(before, after);
        if (coordinate > (minValue + cur) / 2 && coordinate <= (maxValue + cur) / 2) {
          index2 = unsortedTicks[i3].index;
          break;
        }
      }
    }
  } else {
    for (var _i = 0; _i < len; _i++) {
      if (_i === 0 && coordinate <= (ticks2[_i].coordinate + ticks2[_i + 1].coordinate) / 2 || _i > 0 && _i < len - 1 && coordinate > (ticks2[_i].coordinate + ticks2[_i - 1].coordinate) / 2 && coordinate <= (ticks2[_i].coordinate + ticks2[_i + 1].coordinate) / 2 || _i === len - 1 && coordinate > (ticks2[_i].coordinate + ticks2[_i - 1].coordinate) / 2) {
        index2 = ticks2[_i].index;
        break;
      }
    }
  }
  return index2;
};
var getMainColorOfGraphicItem = function getMainColorOfGraphicItem2(item) {
  var _item$type;
  var _ref = item, displayName = _ref.type.displayName;
  var defaultedProps = (_item$type = item.type) !== null && _item$type !== void 0 && _item$type.defaultProps ? _objectSpread$u(_objectSpread$u({}, item.type.defaultProps), item.props) : item.props;
  var stroke = defaultedProps.stroke, fill = defaultedProps.fill;
  var result;
  switch (displayName) {
    case "Line":
      result = stroke;
      break;
    case "Area":
    case "Radar":
      result = stroke && stroke !== "none" ? stroke : fill;
      break;
    default:
      result = fill;
      break;
  }
  return result;
};
var getBarSizeList = function getBarSizeList2(_ref2) {
  var globalSize = _ref2.barSize, totalSize = _ref2.totalSize, _ref2$stackGroups = _ref2.stackGroups, stackGroups = _ref2$stackGroups === void 0 ? {} : _ref2$stackGroups;
  if (!stackGroups) {
    return {};
  }
  var result = {};
  var numericAxisIds = Object.keys(stackGroups);
  for (var i3 = 0, len = numericAxisIds.length; i3 < len; i3++) {
    var sgs = stackGroups[numericAxisIds[i3]].stackGroups;
    var stackIds = Object.keys(sgs);
    for (var j = 0, sLen = stackIds.length; j < sLen; j++) {
      var _sgs$stackIds$j = sgs[stackIds[j]], items = _sgs$stackIds$j.items, cateAxisId = _sgs$stackIds$j.cateAxisId;
      var barItems = items.filter(function(item) {
        return getDisplayName(item.type).indexOf("Bar") >= 0;
      });
      if (barItems && barItems.length) {
        var barItemDefaultProps = barItems[0].type.defaultProps;
        var barItemProps = barItemDefaultProps !== void 0 ? _objectSpread$u(_objectSpread$u({}, barItemDefaultProps), barItems[0].props) : barItems[0].props;
        var selfSize = barItemProps.barSize;
        var cateId = barItemProps[cateAxisId];
        if (!result[cateId]) {
          result[cateId] = [];
        }
        var barSize = isNil(selfSize) ? globalSize : selfSize;
        result[cateId].push({
          item: barItems[0],
          stackList: barItems.slice(1),
          barSize: isNil(barSize) ? void 0 : getPercentValue(barSize, totalSize, 0)
        });
      }
    }
  }
  return result;
};
var getBarPosition = function getBarPosition2(_ref3) {
  var barGap = _ref3.barGap, barCategoryGap = _ref3.barCategoryGap, bandSize = _ref3.bandSize, _ref3$sizeList = _ref3.sizeList, sizeList = _ref3$sizeList === void 0 ? [] : _ref3$sizeList, maxBarSize = _ref3.maxBarSize;
  var len = sizeList.length;
  if (len < 1) return null;
  var realBarGap = getPercentValue(barGap, bandSize, 0, true);
  var result;
  var initialValue = [];
  if (sizeList[0].barSize === +sizeList[0].barSize) {
    var useFull = false;
    var fullBarSize = bandSize / len;
    var sum2 = sizeList.reduce(function(res, entry) {
      return res + entry.barSize || 0;
    }, 0);
    sum2 += (len - 1) * realBarGap;
    if (sum2 >= bandSize) {
      sum2 -= (len - 1) * realBarGap;
      realBarGap = 0;
    }
    if (sum2 >= bandSize && fullBarSize > 0) {
      useFull = true;
      fullBarSize *= 0.9;
      sum2 = len * fullBarSize;
    }
    var offset2 = (bandSize - sum2) / 2 >> 0;
    var prev = {
      offset: offset2 - realBarGap,
      size: 0
    };
    result = sizeList.reduce(function(res, entry) {
      var newPosition = {
        item: entry.item,
        position: {
          offset: prev.offset + prev.size + realBarGap,
          // @ts-expect-error the type check above does not check for type number explicitly
          size: useFull ? fullBarSize : entry.barSize
        }
      };
      var newRes = [].concat(_toConsumableArray$9(res), [newPosition]);
      prev = newRes[newRes.length - 1].position;
      if (entry.stackList && entry.stackList.length) {
        entry.stackList.forEach(function(item) {
          newRes.push({
            item,
            position: prev
          });
        });
      }
      return newRes;
    }, initialValue);
  } else {
    var _offset = getPercentValue(barCategoryGap, bandSize, 0, true);
    if (bandSize - 2 * _offset - (len - 1) * realBarGap <= 0) {
      realBarGap = 0;
    }
    var originalSize = (bandSize - 2 * _offset - (len - 1) * realBarGap) / len;
    if (originalSize > 1) {
      originalSize >>= 0;
    }
    var size2 = maxBarSize === +maxBarSize ? Math.min(originalSize, maxBarSize) : originalSize;
    result = sizeList.reduce(function(res, entry, i3) {
      var newRes = [].concat(_toConsumableArray$9(res), [{
        item: entry.item,
        position: {
          offset: _offset + (originalSize + realBarGap) * i3 + (originalSize - size2) / 2,
          size: size2
        }
      }]);
      if (entry.stackList && entry.stackList.length) {
        entry.stackList.forEach(function(item) {
          newRes.push({
            item,
            position: newRes[newRes.length - 1].position
          });
        });
      }
      return newRes;
    }, initialValue);
  }
  return result;
};
var appendOffsetOfLegend = function appendOffsetOfLegend2(offset2, _unused, props, legendBox) {
  var children = props.children, width = props.width, margin = props.margin;
  var legendWidth = width - (margin.left || 0) - (margin.right || 0);
  var legendProps = getLegendProps({
    children,
    legendWidth
  });
  if (legendProps) {
    var _ref4 = legendBox || {}, boxWidth = _ref4.width, boxHeight = _ref4.height;
    var align = legendProps.align, verticalAlign = legendProps.verticalAlign, layout = legendProps.layout;
    if ((layout === "vertical" || layout === "horizontal" && verticalAlign === "middle") && align !== "center" && isNumber(offset2[align])) {
      return _objectSpread$u(_objectSpread$u({}, offset2), {}, _defineProperty$x({}, align, offset2[align] + (boxWidth || 0)));
    }
    if ((layout === "horizontal" || layout === "vertical" && align === "center") && verticalAlign !== "middle" && isNumber(offset2[verticalAlign])) {
      return _objectSpread$u(_objectSpread$u({}, offset2), {}, _defineProperty$x({}, verticalAlign, offset2[verticalAlign] + (boxHeight || 0)));
    }
  }
  return offset2;
};
var isErrorBarRelevantForAxis = function isErrorBarRelevantForAxis2(layout, axisType, direction) {
  if (isNil(axisType)) {
    return true;
  }
  if (layout === "horizontal") {
    return axisType === "yAxis";
  }
  if (layout === "vertical") {
    return axisType === "xAxis";
  }
  if (direction === "x") {
    return axisType === "xAxis";
  }
  if (direction === "y") {
    return axisType === "yAxis";
  }
  return true;
};
var getDomainOfErrorBars = function getDomainOfErrorBars2(data, item, dataKey, layout, axisType) {
  var children = item.props.children;
  var errorBars = findAllByType(children, ErrorBar).filter(function(errorBarChild) {
    return isErrorBarRelevantForAxis(layout, axisType, errorBarChild.props.direction);
  });
  if (errorBars && errorBars.length) {
    var keys2 = errorBars.map(function(errorBarChild) {
      return errorBarChild.props.dataKey;
    });
    return data.reduce(function(result, entry) {
      var entryValue = getValueByDataKey(entry, dataKey);
      if (isNil(entryValue)) return result;
      var mainValue = Array.isArray(entryValue) ? [min(entryValue), max(entryValue)] : [entryValue, entryValue];
      var errorDomain = keys2.reduce(function(prevErrorArr, k3) {
        var errorValue = getValueByDataKey(entry, k3, 0);
        var lowerValue = mainValue[0] - Math.abs(Array.isArray(errorValue) ? errorValue[0] : errorValue);
        var upperValue = mainValue[1] + Math.abs(Array.isArray(errorValue) ? errorValue[1] : errorValue);
        return [Math.min(lowerValue, prevErrorArr[0]), Math.max(upperValue, prevErrorArr[1])];
      }, [Infinity, -Infinity]);
      return [Math.min(errorDomain[0], result[0]), Math.max(errorDomain[1], result[1])];
    }, [Infinity, -Infinity]);
  }
  return null;
};
var parseErrorBarsOfAxis = function parseErrorBarsOfAxis2(data, items, dataKey, axisType, layout) {
  var domains = items.map(function(item) {
    return getDomainOfErrorBars(data, item, dataKey, layout, axisType);
  }).filter(function(entry) {
    return !isNil(entry);
  });
  if (domains && domains.length) {
    return domains.reduce(function(result, entry) {
      return [Math.min(result[0], entry[0]), Math.max(result[1], entry[1])];
    }, [Infinity, -Infinity]);
  }
  return null;
};
var getDomainOfItemsWithSameAxis = function getDomainOfItemsWithSameAxis2(data, items, type, layout, filterNil) {
  var domains = items.map(function(item) {
    var dataKey = item.props.dataKey;
    if (type === "number" && dataKey) {
      return getDomainOfErrorBars(data, item, dataKey, layout) || getDomainOfDataByKey(data, dataKey, type, filterNil);
    }
    return getDomainOfDataByKey(data, dataKey, type, filterNil);
  });
  if (type === "number") {
    return domains.reduce(
      // @ts-expect-error if (type === number) means that the domain is numerical type
      // - but this link is missing in the type definition
      function(result, entry) {
        return [Math.min(result[0], entry[0]), Math.max(result[1], entry[1])];
      },
      [Infinity, -Infinity]
    );
  }
  var tag = {};
  return domains.reduce(function(result, entry) {
    for (var i3 = 0, len = entry.length; i3 < len; i3++) {
      if (!tag[entry[i3]]) {
        tag[entry[i3]] = true;
        result.push(entry[i3]);
      }
    }
    return result;
  }, []);
};
var isCategoricalAxis = function isCategoricalAxis2(layout, axisType) {
  return layout === "horizontal" && axisType === "xAxis" || layout === "vertical" && axisType === "yAxis" || layout === "centric" && axisType === "angleAxis" || layout === "radial" && axisType === "radiusAxis";
};
var getCoordinatesOfGrid = function getCoordinatesOfGrid2(ticks2, minValue, maxValue, syncWithTicks) {
  if (syncWithTicks) {
    return ticks2.map(function(entry) {
      return entry.coordinate;
    });
  }
  var hasMin, hasMax;
  var values = ticks2.map(function(entry) {
    if (entry.coordinate === minValue) {
      hasMin = true;
    }
    if (entry.coordinate === maxValue) {
      hasMax = true;
    }
    return entry.coordinate;
  });
  if (!hasMin) {
    values.push(minValue);
  }
  if (!hasMax) {
    values.push(maxValue);
  }
  return values;
};
var getTicksOfAxis = function getTicksOfAxis2(axis, isGrid, isAll) {
  if (!axis) return null;
  var scale2 = axis.scale;
  var duplicateDomain = axis.duplicateDomain, type = axis.type, range3 = axis.range;
  var offsetForBand = axis.realScaleType === "scaleBand" ? scale2.bandwidth() / 2 : 2;
  var offset2 = (isGrid || isAll) && type === "category" && scale2.bandwidth ? scale2.bandwidth() / offsetForBand : 0;
  offset2 = axis.axisType === "angleAxis" && (range3 === null || range3 === void 0 ? void 0 : range3.length) >= 2 ? mathSign(range3[0] - range3[1]) * 2 * offset2 : offset2;
  if (isGrid && (axis.ticks || axis.niceTicks)) {
    var result = (axis.ticks || axis.niceTicks).map(function(entry) {
      var scaleContent = duplicateDomain ? duplicateDomain.indexOf(entry) : entry;
      return {
        // If the scaleContent is not a number, the coordinate will be NaN.
        // That could be the case for example with a PointScale and a string as domain.
        coordinate: scale2(scaleContent) + offset2,
        value: entry,
        offset: offset2
      };
    });
    return result.filter(function(row) {
      return !isNan(row.coordinate);
    });
  }
  if (axis.isCategorical && axis.categoricalDomain) {
    return axis.categoricalDomain.map(function(entry, index2) {
      return {
        coordinate: scale2(entry) + offset2,
        value: entry,
        index: index2,
        offset: offset2
      };
    });
  }
  if (scale2.ticks && !isAll) {
    return scale2.ticks(axis.tickCount).map(function(entry) {
      return {
        coordinate: scale2(entry) + offset2,
        value: entry,
        offset: offset2
      };
    });
  }
  return scale2.domain().map(function(entry, index2) {
    return {
      coordinate: scale2(entry) + offset2,
      value: duplicateDomain ? duplicateDomain[entry] : entry,
      index: index2,
      offset: offset2
    };
  });
};
var handlerWeakMap = /* @__PURE__ */ new WeakMap();
var combineEventHandlers = function combineEventHandlers2(defaultHandler, childHandler) {
  if (typeof childHandler !== "function") {
    return defaultHandler;
  }
  if (!handlerWeakMap.has(defaultHandler)) {
    handlerWeakMap.set(defaultHandler, /* @__PURE__ */ new WeakMap());
  }
  var childWeakMap = handlerWeakMap.get(defaultHandler);
  if (childWeakMap.has(childHandler)) {
    return childWeakMap.get(childHandler);
  }
  var combineHandler = function combineHandler2() {
    defaultHandler.apply(void 0, arguments);
    childHandler.apply(void 0, arguments);
  };
  childWeakMap.set(childHandler, combineHandler);
  return combineHandler;
};
var parseScale = function parseScale2(axis, chartType, hasBar) {
  var scale2 = axis.scale, type = axis.type, layout = axis.layout, axisType = axis.axisType;
  if (scale2 === "auto") {
    if (layout === "radial" && axisType === "radiusAxis") {
      return {
        scale: band(),
        realScaleType: "band"
      };
    }
    if (layout === "radial" && axisType === "angleAxis") {
      return {
        scale: linear(),
        realScaleType: "linear"
      };
    }
    if (type === "category" && chartType && (chartType.indexOf("LineChart") >= 0 || chartType.indexOf("AreaChart") >= 0 || chartType.indexOf("ComposedChart") >= 0 && !hasBar)) {
      return {
        scale: point(),
        realScaleType: "point"
      };
    }
    if (type === "category") {
      return {
        scale: band(),
        realScaleType: "band"
      };
    }
    return {
      scale: linear(),
      realScaleType: "linear"
    };
  }
  if (isString(scale2)) {
    var name = "scale".concat(upperFirst(scale2));
    return {
      scale: (d3Scales[name] || point)(),
      realScaleType: d3Scales[name] ? name : "point"
    };
  }
  return isFunction(scale2) ? {
    scale: scale2
  } : {
    scale: point(),
    realScaleType: "point"
  };
};
var EPS = 1e-4;
var checkDomainOfScale = function checkDomainOfScale2(scale2) {
  var domain = scale2.domain();
  if (!domain || domain.length <= 2) {
    return;
  }
  var len = domain.length;
  var range3 = scale2.range();
  var minValue = Math.min(range3[0], range3[1]) - EPS;
  var maxValue = Math.max(range3[0], range3[1]) + EPS;
  var first = scale2(domain[0]);
  var last2 = scale2(domain[len - 1]);
  if (first < minValue || first > maxValue || last2 < minValue || last2 > maxValue) {
    scale2.domain([domain[0], domain[len - 1]]);
  }
};
var findPositionOfBar = function findPositionOfBar2(barPosition, child) {
  if (!barPosition) {
    return null;
  }
  for (var i3 = 0, len = barPosition.length; i3 < len; i3++) {
    if (barPosition[i3].item === child) {
      return barPosition[i3].position;
    }
  }
  return null;
};
var truncateByDomain = function truncateByDomain2(value, domain) {
  if (!domain || domain.length !== 2 || !isNumber(domain[0]) || !isNumber(domain[1])) {
    return value;
  }
  var minValue = Math.min(domain[0], domain[1]);
  var maxValue = Math.max(domain[0], domain[1]);
  var result = [value[0], value[1]];
  if (!isNumber(value[0]) || value[0] < minValue) {
    result[0] = minValue;
  }
  if (!isNumber(value[1]) || value[1] > maxValue) {
    result[1] = maxValue;
  }
  if (result[0] > maxValue) {
    result[0] = maxValue;
  }
  if (result[1] < minValue) {
    result[1] = minValue;
  }
  return result;
};
var offsetSign = function offsetSign2(series) {
  var n2 = series.length;
  if (n2 <= 0) {
    return;
  }
  for (var j = 0, m4 = series[0].length; j < m4; ++j) {
    var positive = 0;
    var negative = 0;
    for (var i3 = 0; i3 < n2; ++i3) {
      var value = isNan(series[i3][j][1]) ? series[i3][j][0] : series[i3][j][1];
      if (value >= 0) {
        series[i3][j][0] = positive;
        series[i3][j][1] = positive + value;
        positive = series[i3][j][1];
      } else {
        series[i3][j][0] = negative;
        series[i3][j][1] = negative + value;
        negative = series[i3][j][1];
      }
    }
  }
};
var offsetPositive = function offsetPositive2(series) {
  var n2 = series.length;
  if (n2 <= 0) {
    return;
  }
  for (var j = 0, m4 = series[0].length; j < m4; ++j) {
    var positive = 0;
    for (var i3 = 0; i3 < n2; ++i3) {
      var value = isNan(series[i3][j][1]) ? series[i3][j][0] : series[i3][j][1];
      if (value >= 0) {
        series[i3][j][0] = positive;
        series[i3][j][1] = positive + value;
        positive = series[i3][j][1];
      } else {
        series[i3][j][0] = 0;
        series[i3][j][1] = 0;
      }
    }
  }
};
var STACK_OFFSET_MAP = {
  sign: offsetSign,
  // @ts-expect-error definitelytyped types are incorrect
  expand: stackOffsetExpand,
  // @ts-expect-error definitelytyped types are incorrect
  none: stackOffsetNone,
  // @ts-expect-error definitelytyped types are incorrect
  silhouette: stackOffsetSilhouette,
  // @ts-expect-error definitelytyped types are incorrect
  wiggle: stackOffsetWiggle,
  positive: offsetPositive
};
var getStackedData = function getStackedData2(data, stackItems, offsetType) {
  var dataKeys = stackItems.map(function(item) {
    return item.props.dataKey;
  });
  var offsetAccessor = STACK_OFFSET_MAP[offsetType];
  var stack = shapeStack().keys(dataKeys).value(function(d4, key) {
    return +getValueByDataKey(d4, key, 0);
  }).order(stackOrderNone).offset(offsetAccessor);
  return stack(data);
};
var getStackGroupsByAxisId = function getStackGroupsByAxisId2(data, _items, numericAxisId, cateAxisId, offsetType, reverseStackOrder) {
  if (!data) {
    return null;
  }
  var items = reverseStackOrder ? _items.reverse() : _items;
  var parentStackGroupsInitialValue = {};
  var stackGroups = items.reduce(function(result, item) {
    var _item$type2;
    var defaultedProps = (_item$type2 = item.type) !== null && _item$type2 !== void 0 && _item$type2.defaultProps ? _objectSpread$u(_objectSpread$u({}, item.type.defaultProps), item.props) : item.props;
    var stackId = defaultedProps.stackId, hide2 = defaultedProps.hide;
    if (hide2) {
      return result;
    }
    var axisId = defaultedProps[numericAxisId];
    var parentGroup = result[axisId] || {
      hasStack: false,
      stackGroups: {}
    };
    if (isNumOrStr(stackId)) {
      var childGroup = parentGroup.stackGroups[stackId] || {
        numericAxisId,
        cateAxisId,
        items: []
      };
      childGroup.items.push(item);
      parentGroup.hasStack = true;
      parentGroup.stackGroups[stackId] = childGroup;
    } else {
      parentGroup.stackGroups[uniqueId("_stackId_")] = {
        numericAxisId,
        cateAxisId,
        items: [item]
      };
    }
    return _objectSpread$u(_objectSpread$u({}, result), {}, _defineProperty$x({}, axisId, parentGroup));
  }, parentStackGroupsInitialValue);
  var axisStackGroupsInitialValue = {};
  return Object.keys(stackGroups).reduce(function(result, axisId) {
    var group = stackGroups[axisId];
    if (group.hasStack) {
      var stackGroupsInitialValue = {};
      group.stackGroups = Object.keys(group.stackGroups).reduce(function(res, stackId) {
        var g2 = group.stackGroups[stackId];
        return _objectSpread$u(_objectSpread$u({}, res), {}, _defineProperty$x({}, stackId, {
          numericAxisId,
          cateAxisId,
          items: g2.items,
          stackedData: getStackedData(data, g2.items, offsetType)
        }));
      }, stackGroupsInitialValue);
    }
    return _objectSpread$u(_objectSpread$u({}, result), {}, _defineProperty$x({}, axisId, group));
  }, axisStackGroupsInitialValue);
};
var getTicksOfScale = function getTicksOfScale2(scale2, opts) {
  var realScaleType = opts.realScaleType, type = opts.type, tickCount = opts.tickCount, originalDomain = opts.originalDomain, allowDecimals = opts.allowDecimals;
  var scaleType = realScaleType || opts.scale;
  if (scaleType !== "auto" && scaleType !== "linear") {
    return null;
  }
  if (tickCount && type === "number" && originalDomain && (originalDomain[0] === "auto" || originalDomain[1] === "auto")) {
    var domain = scale2.domain();
    if (!domain.length) {
      return null;
    }
    var tickValues = getNiceTickValues(domain, tickCount, allowDecimals);
    scale2.domain([min(tickValues), max(tickValues)]);
    return {
      niceTicks: tickValues
    };
  }
  if (tickCount && type === "number") {
    var _domain = scale2.domain();
    var _tickValues = getTickValuesFixedDomain(_domain, tickCount, allowDecimals);
    return {
      niceTicks: _tickValues
    };
  }
  return null;
};
function getCateCoordinateOfLine(_ref5) {
  var axis = _ref5.axis, ticks2 = _ref5.ticks, bandSize = _ref5.bandSize, entry = _ref5.entry, index2 = _ref5.index, dataKey = _ref5.dataKey;
  if (axis.type === "category") {
    if (!axis.allowDuplicatedCategory && axis.dataKey && !isNil(entry[axis.dataKey])) {
      var matchedTick = findEntryInArray(ticks2, "value", entry[axis.dataKey]);
      if (matchedTick) {
        return matchedTick.coordinate + bandSize / 2;
      }
    }
    return ticks2[index2] ? ticks2[index2].coordinate + bandSize / 2 : null;
  }
  var value = getValueByDataKey(entry, !isNil(dataKey) ? dataKey : axis.dataKey);
  return !isNil(value) ? axis.scale(value) : null;
}
var getCateCoordinateOfBar = function getCateCoordinateOfBar2(_ref6) {
  var axis = _ref6.axis, ticks2 = _ref6.ticks, offset2 = _ref6.offset, bandSize = _ref6.bandSize, entry = _ref6.entry, index2 = _ref6.index;
  if (axis.type === "category") {
    return ticks2[index2] ? ticks2[index2].coordinate + offset2 : null;
  }
  var value = getValueByDataKey(entry, axis.dataKey, axis.domain[index2]);
  return !isNil(value) ? axis.scale(value) - bandSize / 2 + offset2 : null;
};
var getBaseValueOfBar = function getBaseValueOfBar2(_ref7) {
  var numericAxis = _ref7.numericAxis;
  var domain = numericAxis.scale.domain();
  if (numericAxis.type === "number") {
    var minValue = Math.min(domain[0], domain[1]);
    var maxValue = Math.max(domain[0], domain[1]);
    if (minValue <= 0 && maxValue >= 0) {
      return 0;
    }
    if (maxValue < 0) {
      return maxValue;
    }
    return minValue;
  }
  return domain[0];
};
var getStackedDataOfItem = function getStackedDataOfItem2(item, stackGroups) {
  var _item$type3;
  var defaultedProps = (_item$type3 = item.type) !== null && _item$type3 !== void 0 && _item$type3.defaultProps ? _objectSpread$u(_objectSpread$u({}, item.type.defaultProps), item.props) : item.props;
  var stackId = defaultedProps.stackId;
  if (isNumOrStr(stackId)) {
    var group = stackGroups[stackId];
    if (group) {
      var itemIndex = group.items.indexOf(item);
      return itemIndex >= 0 ? group.stackedData[itemIndex] : null;
    }
  }
  return null;
};
var getDomainOfSingle = function getDomainOfSingle2(data) {
  return data.reduce(function(result, entry) {
    return [min(entry.concat([result[0]]).filter(isNumber)), max(entry.concat([result[1]]).filter(isNumber))];
  }, [Infinity, -Infinity]);
};
var getDomainOfStackGroups = function getDomainOfStackGroups2(stackGroups, startIndex, endIndex) {
  return Object.keys(stackGroups).reduce(function(result, stackId) {
    var group = stackGroups[stackId];
    var stackedData = group.stackedData;
    var domain = stackedData.reduce(function(res, entry) {
      var s4 = getDomainOfSingle(entry.slice(startIndex, endIndex + 1));
      return [Math.min(res[0], s4[0]), Math.max(res[1], s4[1])];
    }, [Infinity, -Infinity]);
    return [Math.min(domain[0], result[0]), Math.max(domain[1], result[1])];
  }, [Infinity, -Infinity]).map(function(result) {
    return result === Infinity || result === -Infinity ? 0 : result;
  });
};
var MIN_VALUE_REG = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var MAX_VALUE_REG = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var parseSpecifiedDomain = function parseSpecifiedDomain2(specifiedDomain, dataDomain, allowDataOverflow) {
  if (isFunction(specifiedDomain)) {
    return specifiedDomain(dataDomain, allowDataOverflow);
  }
  if (!Array.isArray(specifiedDomain)) {
    return dataDomain;
  }
  var domain = [];
  if (isNumber(specifiedDomain[0])) {
    domain[0] = allowDataOverflow ? specifiedDomain[0] : Math.min(specifiedDomain[0], dataDomain[0]);
  } else if (MIN_VALUE_REG.test(specifiedDomain[0])) {
    var value = +MIN_VALUE_REG.exec(specifiedDomain[0])[1];
    domain[0] = dataDomain[0] - value;
  } else if (isFunction(specifiedDomain[0])) {
    domain[0] = specifiedDomain[0](dataDomain[0]);
  } else {
    domain[0] = dataDomain[0];
  }
  if (isNumber(specifiedDomain[1])) {
    domain[1] = allowDataOverflow ? specifiedDomain[1] : Math.max(specifiedDomain[1], dataDomain[1]);
  } else if (MAX_VALUE_REG.test(specifiedDomain[1])) {
    var _value = +MAX_VALUE_REG.exec(specifiedDomain[1])[1];
    domain[1] = dataDomain[1] + _value;
  } else if (isFunction(specifiedDomain[1])) {
    domain[1] = specifiedDomain[1](dataDomain[1]);
  } else {
    domain[1] = dataDomain[1];
  }
  return domain;
};
var getBandSizeOfAxis = function getBandSizeOfAxis2(axis, ticks2, isBar) {
  if (axis && axis.scale && axis.scale.bandwidth) {
    var bandWidth = axis.scale.bandwidth();
    if (!isBar || bandWidth > 0) {
      return bandWidth;
    }
  }
  if (axis && ticks2 && ticks2.length >= 2) {
    var orderedTicks = sortBy(ticks2, function(o2) {
      return o2.coordinate;
    });
    var bandSize = Infinity;
    for (var i3 = 1, len = orderedTicks.length; i3 < len; i3++) {
      var cur = orderedTicks[i3];
      var prev = orderedTicks[i3 - 1];
      bandSize = Math.min((cur.coordinate || 0) - (prev.coordinate || 0), bandSize);
    }
    return bandSize === Infinity ? 0 : bandSize;
  }
  return isBar ? void 0 : 0;
};
var parseDomainOfCategoryAxis = function parseDomainOfCategoryAxis2(specifiedDomain, calculatedDomain, axisChild) {
  if (!specifiedDomain || !specifiedDomain.length) {
    return calculatedDomain;
  }
  if (isEqual(specifiedDomain, get(axisChild, "type.defaultProps.domain"))) {
    return calculatedDomain;
  }
  return specifiedDomain;
};
var getTooltipItem = function getTooltipItem2(graphicalItem, payload) {
  var defaultedProps = graphicalItem.type.defaultProps ? _objectSpread$u(_objectSpread$u({}, graphicalItem.type.defaultProps), graphicalItem.props) : graphicalItem.props;
  var dataKey = defaultedProps.dataKey, name = defaultedProps.name, unit2 = defaultedProps.unit, formatter = defaultedProps.formatter, tooltipType = defaultedProps.tooltipType, chartType = defaultedProps.chartType, hide2 = defaultedProps.hide;
  return _objectSpread$u(_objectSpread$u({}, filterProps(graphicalItem, false)), {}, {
    dataKey,
    unit: unit2,
    formatter,
    name: name || dataKey,
    color: getMainColorOfGraphicItem(graphicalItem),
    value: getValueByDataKey(payload, dataKey),
    type: tooltipType,
    payload,
    chartType,
    hide: hide2
  });
};
function _typeof$y(o2) {
  "@babel/helpers - typeof";
  return _typeof$y = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof$y(o2);
}
function ownKeys$t(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e3);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$t(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$t(Object(t3), true).forEach(function(r3) {
      _defineProperty$w(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$t(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
function _defineProperty$w(obj, key, value) {
  key = _toPropertyKey$w(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$w(t3) {
  var i3 = _toPrimitive$w(t3, "string");
  return "symbol" == _typeof$y(i3) ? i3 : i3 + "";
}
function _toPrimitive$w(t3, r2) {
  if ("object" != _typeof$y(t3) || !t3) return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i3 = e3.call(t3, r2);
    if ("object" != _typeof$y(i3)) return i3;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t3);
}
function _slicedToArray$6(arr, i3) {
  return _arrayWithHoles$7(arr) || _iterableToArrayLimit$6(arr, i3) || _unsupportedIterableToArray$d(arr, i3) || _nonIterableRest$7();
}
function _nonIterableRest$7() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$d(o2, minLen) {
  if (!o2) return;
  if (typeof o2 === "string") return _arrayLikeToArray$d(o2, minLen);
  var n2 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n2 === "Object" && o2.constructor) n2 = o2.constructor.name;
  if (n2 === "Map" || n2 === "Set") return Array.from(o2);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray$d(o2, minLen);
}
function _arrayLikeToArray$d(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i3 = 0, arr2 = new Array(len); i3 < len; i3++) arr2[i3] = arr[i3];
  return arr2;
}
function _iterableToArrayLimit$6(r2, l2) {
  var t3 = null == r2 ? null : "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];
  if (null != t3) {
    var e3, n2, i3, u3, a4 = [], f2 = true, o2 = false;
    try {
      if (i3 = (t3 = t3.call(r2)).next, 0 === l2) ;
      else for (; !(f2 = (e3 = i3.call(t3)).done) && (a4.push(e3.value), a4.length !== l2); f2 = true) ;
    } catch (r3) {
      o2 = true, n2 = r3;
    } finally {
      try {
        if (!f2 && null != t3["return"] && (u3 = t3["return"](), Object(u3) !== u3)) return;
      } finally {
        if (o2) throw n2;
      }
    }
    return a4;
  }
}
function _arrayWithHoles$7(arr) {
  if (Array.isArray(arr)) return arr;
}
var RADIAN$2 = Math.PI / 180;
var radianToDegree = function radianToDegree2(angleInRadian) {
  return angleInRadian * 180 / Math.PI;
};
var polarToCartesian = function polarToCartesian2(cx, cy, radius, angle) {
  return {
    x: cx + Math.cos(-RADIAN$2 * angle) * radius,
    y: cy + Math.sin(-RADIAN$2 * angle) * radius
  };
};
var getMaxRadius = function getMaxRadius2(width, height) {
  var offset2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
  return Math.min(Math.abs(width - (offset2.left || 0) - (offset2.right || 0)), Math.abs(height - (offset2.top || 0) - (offset2.bottom || 0))) / 2;
};
var formatAxisMap$1 = function formatAxisMap(props, axisMap, offset2, axisType, chartName) {
  var width = props.width, height = props.height;
  var startAngle = props.startAngle, endAngle = props.endAngle;
  var cx = getPercentValue(props.cx, width, width / 2);
  var cy = getPercentValue(props.cy, height, height / 2);
  var maxRadius = getMaxRadius(width, height, offset2);
  var innerRadius = getPercentValue(props.innerRadius, maxRadius, 0);
  var outerRadius = getPercentValue(props.outerRadius, maxRadius, maxRadius * 0.8);
  var ids2 = Object.keys(axisMap);
  return ids2.reduce(function(result, id2) {
    var axis = axisMap[id2];
    var domain = axis.domain, reversed = axis.reversed;
    var range3;
    if (isNil(axis.range)) {
      if (axisType === "angleAxis") {
        range3 = [startAngle, endAngle];
      } else if (axisType === "radiusAxis") {
        range3 = [innerRadius, outerRadius];
      }
      if (reversed) {
        range3 = [range3[1], range3[0]];
      }
    } else {
      range3 = axis.range;
      var _range = range3;
      var _range2 = _slicedToArray$6(_range, 2);
      startAngle = _range2[0];
      endAngle = _range2[1];
    }
    var _parseScale = parseScale(axis, chartName), realScaleType = _parseScale.realScaleType, scale2 = _parseScale.scale;
    scale2.domain(domain).range(range3);
    checkDomainOfScale(scale2);
    var ticks2 = getTicksOfScale(scale2, _objectSpread$t(_objectSpread$t({}, axis), {}, {
      realScaleType
    }));
    var finalAxis = _objectSpread$t(_objectSpread$t(_objectSpread$t({}, axis), ticks2), {}, {
      range: range3,
      radius: outerRadius,
      realScaleType,
      scale: scale2,
      cx,
      cy,
      innerRadius,
      outerRadius,
      startAngle,
      endAngle
    });
    return _objectSpread$t(_objectSpread$t({}, result), {}, _defineProperty$w({}, id2, finalAxis));
  }, {});
};
var distanceBetweenPoints = function distanceBetweenPoints2(point2, anotherPoint) {
  var x1 = point2.x, y1 = point2.y;
  var x22 = anotherPoint.x, y22 = anotherPoint.y;
  return Math.sqrt(Math.pow(x1 - x22, 2) + Math.pow(y1 - y22, 2));
};
var getAngleOfPoint = function getAngleOfPoint2(_ref, _ref2) {
  var x3 = _ref.x, y4 = _ref.y;
  var cx = _ref2.cx, cy = _ref2.cy;
  var radius = distanceBetweenPoints({
    x: x3,
    y: y4
  }, {
    x: cx,
    y: cy
  });
  if (radius <= 0) {
    return {
      radius
    };
  }
  var cos2 = (x3 - cx) / radius;
  var angleInRadian = Math.acos(cos2);
  if (y4 > cy) {
    angleInRadian = 2 * Math.PI - angleInRadian;
  }
  return {
    radius,
    angle: radianToDegree(angleInRadian),
    angleInRadian
  };
};
var formatAngleOfSector = function formatAngleOfSector2(_ref3) {
  var startAngle = _ref3.startAngle, endAngle = _ref3.endAngle;
  var startCnt = Math.floor(startAngle / 360);
  var endCnt = Math.floor(endAngle / 360);
  var min2 = Math.min(startCnt, endCnt);
  return {
    startAngle: startAngle - min2 * 360,
    endAngle: endAngle - min2 * 360
  };
};
var reverseFormatAngleOfSetor = function reverseFormatAngleOfSetor2(angle, _ref4) {
  var startAngle = _ref4.startAngle, endAngle = _ref4.endAngle;
  var startCnt = Math.floor(startAngle / 360);
  var endCnt = Math.floor(endAngle / 360);
  var min2 = Math.min(startCnt, endCnt);
  return angle + min2 * 360;
};
var inRangeOfSector = function inRangeOfSector2(_ref5, sector) {
  var x3 = _ref5.x, y4 = _ref5.y;
  var _getAngleOfPoint = getAngleOfPoint({
    x: x3,
    y: y4
  }, sector), radius = _getAngleOfPoint.radius, angle = _getAngleOfPoint.angle;
  var innerRadius = sector.innerRadius, outerRadius = sector.outerRadius;
  if (radius < innerRadius || radius > outerRadius) {
    return false;
  }
  if (radius === 0) {
    return true;
  }
  var _formatAngleOfSector = formatAngleOfSector(sector), startAngle = _formatAngleOfSector.startAngle, endAngle = _formatAngleOfSector.endAngle;
  var formatAngle = angle;
  var inRange;
  if (startAngle <= endAngle) {
    while (formatAngle > endAngle) {
      formatAngle -= 360;
    }
    while (formatAngle < startAngle) {
      formatAngle += 360;
    }
    inRange = formatAngle >= startAngle && formatAngle <= endAngle;
  } else {
    while (formatAngle > startAngle) {
      formatAngle -= 360;
    }
    while (formatAngle < endAngle) {
      formatAngle += 360;
    }
    inRange = formatAngle >= endAngle && formatAngle <= startAngle;
  }
  if (inRange) {
    return _objectSpread$t(_objectSpread$t({}, sector), {}, {
      radius,
      angle: reverseFormatAngleOfSetor(formatAngle, sector)
    });
  }
  return null;
};
var getTickClassName = function getTickClassName2(tick) {
  return !/* @__PURE__ */ isValidElement(tick) && !isFunction(tick) && typeof tick !== "boolean" ? tick.className : "";
};
function _typeof$x(o2) {
  "@babel/helpers - typeof";
  return _typeof$x = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof$x(o2);
}
var _excluded$d = ["offset"];
function _toConsumableArray$8(arr) {
  return _arrayWithoutHoles$8(arr) || _iterableToArray$9(arr) || _unsupportedIterableToArray$c(arr) || _nonIterableSpread$8();
}
function _nonIterableSpread$8() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$c(o2, minLen) {
  if (!o2) return;
  if (typeof o2 === "string") return _arrayLikeToArray$c(o2, minLen);
  var n2 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n2 === "Object" && o2.constructor) n2 = o2.constructor.name;
  if (n2 === "Map" || n2 === "Set") return Array.from(o2);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray$c(o2, minLen);
}
function _iterableToArray$9(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles$8(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$c(arr);
}
function _arrayLikeToArray$c(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i3 = 0, arr2 = new Array(len); i3 < len; i3++) arr2[i3] = arr[i3];
  return arr2;
}
function _objectWithoutProperties$d(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$d(source, excluded);
  var key, i3;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i3 = 0; i3 < sourceSymbolKeys.length; i3++) {
      key = sourceSymbolKeys[i3];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$d(source, excluded) {
  if (source == null) return {};
  var target = {};
  for (var key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function ownKeys$s(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e3);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$s(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$s(Object(t3), true).forEach(function(r3) {
      _defineProperty$v(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$s(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
function _defineProperty$v(obj, key, value) {
  key = _toPropertyKey$v(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$v(t3) {
  var i3 = _toPrimitive$v(t3, "string");
  return "symbol" == _typeof$x(i3) ? i3 : i3 + "";
}
function _toPrimitive$v(t3, r2) {
  if ("object" != _typeof$x(t3) || !t3) return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i3 = e3.call(t3, r2);
    if ("object" != _typeof$x(i3)) return i3;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t3);
}
function _extends$o() {
  _extends$o = Object.assign ? Object.assign.bind() : function(target) {
    for (var i3 = 1; i3 < arguments.length; i3++) {
      var source = arguments[i3];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$o.apply(this, arguments);
}
var getLabel = function getLabel2(props) {
  var value = props.value, formatter = props.formatter;
  var label = isNil(props.children) ? value : props.children;
  if (isFunction(formatter)) {
    return formatter(label);
  }
  return label;
};
var getDeltaAngle$1 = function getDeltaAngle(startAngle, endAngle) {
  var sign2 = mathSign(endAngle - startAngle);
  var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
  return sign2 * deltaAngle;
};
var renderRadialLabel = function renderRadialLabel2(labelProps, label, attrs) {
  var position = labelProps.position, viewBox = labelProps.viewBox, offset2 = labelProps.offset, className = labelProps.className;
  var _ref = viewBox, cx = _ref.cx, cy = _ref.cy, innerRadius = _ref.innerRadius, outerRadius = _ref.outerRadius, startAngle = _ref.startAngle, endAngle = _ref.endAngle, clockWise = _ref.clockWise;
  var radius = (innerRadius + outerRadius) / 2;
  var deltaAngle = getDeltaAngle$1(startAngle, endAngle);
  var sign2 = deltaAngle >= 0 ? 1 : -1;
  var labelAngle, direction;
  if (position === "insideStart") {
    labelAngle = startAngle + sign2 * offset2;
    direction = clockWise;
  } else if (position === "insideEnd") {
    labelAngle = endAngle - sign2 * offset2;
    direction = !clockWise;
  } else if (position === "end") {
    labelAngle = endAngle + sign2 * offset2;
    direction = clockWise;
  }
  direction = deltaAngle <= 0 ? direction : !direction;
  var startPoint = polarToCartesian(cx, cy, radius, labelAngle);
  var endPoint = polarToCartesian(cx, cy, radius, labelAngle + (direction ? 1 : -1) * 359);
  var path = "M".concat(startPoint.x, ",").concat(startPoint.y, "\n    A").concat(radius, ",").concat(radius, ",0,1,").concat(direction ? 0 : 1, ",\n    ").concat(endPoint.x, ",").concat(endPoint.y);
  var id2 = isNil(labelProps.id) ? uniqueId("recharts-radial-line-") : labelProps.id;
  return /* @__PURE__ */ React__default.createElement("text", _extends$o({}, attrs, {
    dominantBaseline: "central",
    className: clsx("recharts-radial-bar-label", className)
  }), /* @__PURE__ */ React__default.createElement("defs", null, /* @__PURE__ */ React__default.createElement("path", {
    id: id2,
    d: path
  })), /* @__PURE__ */ React__default.createElement("textPath", {
    xlinkHref: "#".concat(id2)
  }, label));
};
var getAttrsOfPolarLabel = function getAttrsOfPolarLabel2(props) {
  var viewBox = props.viewBox, offset2 = props.offset, position = props.position;
  var _ref2 = viewBox, cx = _ref2.cx, cy = _ref2.cy, innerRadius = _ref2.innerRadius, outerRadius = _ref2.outerRadius, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle;
  var midAngle = (startAngle + endAngle) / 2;
  if (position === "outside") {
    var _polarToCartesian = polarToCartesian(cx, cy, outerRadius + offset2, midAngle), _x = _polarToCartesian.x, _y = _polarToCartesian.y;
    return {
      x: _x,
      y: _y,
      textAnchor: _x >= cx ? "start" : "end",
      verticalAnchor: "middle"
    };
  }
  if (position === "center") {
    return {
      x: cx,
      y: cy,
      textAnchor: "middle",
      verticalAnchor: "middle"
    };
  }
  if (position === "centerTop") {
    return {
      x: cx,
      y: cy,
      textAnchor: "middle",
      verticalAnchor: "start"
    };
  }
  if (position === "centerBottom") {
    return {
      x: cx,
      y: cy,
      textAnchor: "middle",
      verticalAnchor: "end"
    };
  }
  var r2 = (innerRadius + outerRadius) / 2;
  var _polarToCartesian2 = polarToCartesian(cx, cy, r2, midAngle), x3 = _polarToCartesian2.x, y4 = _polarToCartesian2.y;
  return {
    x: x3,
    y: y4,
    textAnchor: "middle",
    verticalAnchor: "middle"
  };
};
var getAttrsOfCartesianLabel = function getAttrsOfCartesianLabel2(props) {
  var viewBox = props.viewBox, parentViewBox = props.parentViewBox, offset2 = props.offset, position = props.position;
  var _ref3 = viewBox, x3 = _ref3.x, y4 = _ref3.y, width = _ref3.width, height = _ref3.height;
  var verticalSign = height >= 0 ? 1 : -1;
  var verticalOffset = verticalSign * offset2;
  var verticalEnd = verticalSign > 0 ? "end" : "start";
  var verticalStart = verticalSign > 0 ? "start" : "end";
  var horizontalSign = width >= 0 ? 1 : -1;
  var horizontalOffset = horizontalSign * offset2;
  var horizontalEnd = horizontalSign > 0 ? "end" : "start";
  var horizontalStart = horizontalSign > 0 ? "start" : "end";
  if (position === "top") {
    var attrs = {
      x: x3 + width / 2,
      y: y4 - verticalSign * offset2,
      textAnchor: "middle",
      verticalAnchor: verticalEnd
    };
    return _objectSpread$s(_objectSpread$s({}, attrs), parentViewBox ? {
      height: Math.max(y4 - parentViewBox.y, 0),
      width
    } : {});
  }
  if (position === "bottom") {
    var _attrs = {
      x: x3 + width / 2,
      y: y4 + height + verticalOffset,
      textAnchor: "middle",
      verticalAnchor: verticalStart
    };
    return _objectSpread$s(_objectSpread$s({}, _attrs), parentViewBox ? {
      height: Math.max(parentViewBox.y + parentViewBox.height - (y4 + height), 0),
      width
    } : {});
  }
  if (position === "left") {
    var _attrs2 = {
      x: x3 - horizontalOffset,
      y: y4 + height / 2,
      textAnchor: horizontalEnd,
      verticalAnchor: "middle"
    };
    return _objectSpread$s(_objectSpread$s({}, _attrs2), parentViewBox ? {
      width: Math.max(_attrs2.x - parentViewBox.x, 0),
      height
    } : {});
  }
  if (position === "right") {
    var _attrs3 = {
      x: x3 + width + horizontalOffset,
      y: y4 + height / 2,
      textAnchor: horizontalStart,
      verticalAnchor: "middle"
    };
    return _objectSpread$s(_objectSpread$s({}, _attrs3), parentViewBox ? {
      width: Math.max(parentViewBox.x + parentViewBox.width - _attrs3.x, 0),
      height
    } : {});
  }
  var sizeAttrs = parentViewBox ? {
    width,
    height
  } : {};
  if (position === "insideLeft") {
    return _objectSpread$s({
      x: x3 + horizontalOffset,
      y: y4 + height / 2,
      textAnchor: horizontalStart,
      verticalAnchor: "middle"
    }, sizeAttrs);
  }
  if (position === "insideRight") {
    return _objectSpread$s({
      x: x3 + width - horizontalOffset,
      y: y4 + height / 2,
      textAnchor: horizontalEnd,
      verticalAnchor: "middle"
    }, sizeAttrs);
  }
  if (position === "insideTop") {
    return _objectSpread$s({
      x: x3 + width / 2,
      y: y4 + verticalOffset,
      textAnchor: "middle",
      verticalAnchor: verticalStart
    }, sizeAttrs);
  }
  if (position === "insideBottom") {
    return _objectSpread$s({
      x: x3 + width / 2,
      y: y4 + height - verticalOffset,
      textAnchor: "middle",
      verticalAnchor: verticalEnd
    }, sizeAttrs);
  }
  if (position === "insideTopLeft") {
    return _objectSpread$s({
      x: x3 + horizontalOffset,
      y: y4 + verticalOffset,
      textAnchor: horizontalStart,
      verticalAnchor: verticalStart
    }, sizeAttrs);
  }
  if (position === "insideTopRight") {
    return _objectSpread$s({
      x: x3 + width - horizontalOffset,
      y: y4 + verticalOffset,
      textAnchor: horizontalEnd,
      verticalAnchor: verticalStart
    }, sizeAttrs);
  }
  if (position === "insideBottomLeft") {
    return _objectSpread$s({
      x: x3 + horizontalOffset,
      y: y4 + height - verticalOffset,
      textAnchor: horizontalStart,
      verticalAnchor: verticalEnd
    }, sizeAttrs);
  }
  if (position === "insideBottomRight") {
    return _objectSpread$s({
      x: x3 + width - horizontalOffset,
      y: y4 + height - verticalOffset,
      textAnchor: horizontalEnd,
      verticalAnchor: verticalEnd
    }, sizeAttrs);
  }
  if (isObject(position) && (isNumber(position.x) || isPercent(position.x)) && (isNumber(position.y) || isPercent(position.y))) {
    return _objectSpread$s({
      x: x3 + getPercentValue(position.x, width),
      y: y4 + getPercentValue(position.y, height),
      textAnchor: "end",
      verticalAnchor: "end"
    }, sizeAttrs);
  }
  return _objectSpread$s({
    x: x3 + width / 2,
    y: y4 + height / 2,
    textAnchor: "middle",
    verticalAnchor: "middle"
  }, sizeAttrs);
};
var isPolar = function isPolar2(viewBox) {
  return "cx" in viewBox && isNumber(viewBox.cx);
};
function Label$1(_ref4) {
  var _ref4$offset = _ref4.offset, offset2 = _ref4$offset === void 0 ? 5 : _ref4$offset, restProps = _objectWithoutProperties$d(_ref4, _excluded$d);
  var props = _objectSpread$s({
    offset: offset2
  }, restProps);
  var viewBox = props.viewBox, position = props.position, value = props.value, children = props.children, content = props.content, _props$className = props.className, className = _props$className === void 0 ? "" : _props$className, textBreakAll = props.textBreakAll;
  if (!viewBox || isNil(value) && isNil(children) && !/* @__PURE__ */ isValidElement(content) && !isFunction(content)) {
    return null;
  }
  if (/* @__PURE__ */ isValidElement(content)) {
    return /* @__PURE__ */ cloneElement(content, props);
  }
  var label;
  if (isFunction(content)) {
    label = /* @__PURE__ */ createElement(content, props);
    if (/* @__PURE__ */ isValidElement(label)) {
      return label;
    }
  } else {
    label = getLabel(props);
  }
  var isPolarLabel = isPolar(viewBox);
  var attrs = filterProps(props, true);
  if (isPolarLabel && (position === "insideStart" || position === "insideEnd" || position === "end")) {
    return renderRadialLabel(props, label, attrs);
  }
  var positionAttrs = isPolarLabel ? getAttrsOfPolarLabel(props) : getAttrsOfCartesianLabel(props);
  return /* @__PURE__ */ React__default.createElement(Text, _extends$o({
    className: clsx("recharts-label", className)
  }, attrs, positionAttrs, {
    breakAll: textBreakAll
  }), label);
}
Label$1.displayName = "Label";
var parseViewBox = function parseViewBox2(props) {
  var cx = props.cx, cy = props.cy, angle = props.angle, startAngle = props.startAngle, endAngle = props.endAngle, r2 = props.r, radius = props.radius, innerRadius = props.innerRadius, outerRadius = props.outerRadius, x3 = props.x, y4 = props.y, top = props.top, left = props.left, width = props.width, height = props.height, clockWise = props.clockWise, labelViewBox = props.labelViewBox;
  if (labelViewBox) {
    return labelViewBox;
  }
  if (isNumber(width) && isNumber(height)) {
    if (isNumber(x3) && isNumber(y4)) {
      return {
        x: x3,
        y: y4,
        width,
        height
      };
    }
    if (isNumber(top) && isNumber(left)) {
      return {
        x: top,
        y: left,
        width,
        height
      };
    }
  }
  if (isNumber(x3) && isNumber(y4)) {
    return {
      x: x3,
      y: y4,
      width: 0,
      height: 0
    };
  }
  if (isNumber(cx) && isNumber(cy)) {
    return {
      cx,
      cy,
      startAngle: startAngle || angle || 0,
      endAngle: endAngle || angle || 0,
      innerRadius: innerRadius || 0,
      outerRadius: outerRadius || radius || r2 || 0,
      clockWise
    };
  }
  if (props.viewBox) {
    return props.viewBox;
  }
  return {};
};
var parseLabel = function parseLabel2(label, viewBox) {
  if (!label) {
    return null;
  }
  if (label === true) {
    return /* @__PURE__ */ React__default.createElement(Label$1, {
      key: "label-implicit",
      viewBox
    });
  }
  if (isNumOrStr(label)) {
    return /* @__PURE__ */ React__default.createElement(Label$1, {
      key: "label-implicit",
      viewBox,
      value: label
    });
  }
  if (/* @__PURE__ */ isValidElement(label)) {
    if (label.type === Label$1) {
      return /* @__PURE__ */ cloneElement(label, {
        key: "label-implicit",
        viewBox
      });
    }
    return /* @__PURE__ */ React__default.createElement(Label$1, {
      key: "label-implicit",
      content: label,
      viewBox
    });
  }
  if (isFunction(label)) {
    return /* @__PURE__ */ React__default.createElement(Label$1, {
      key: "label-implicit",
      content: label,
      viewBox
    });
  }
  if (isObject(label)) {
    return /* @__PURE__ */ React__default.createElement(Label$1, _extends$o({
      viewBox
    }, label, {
      key: "label-implicit"
    }));
  }
  return null;
};
var renderCallByParent$1 = function renderCallByParent(parentProps, viewBox) {
  var checkPropsLabel = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
  if (!parentProps || !parentProps.children && checkPropsLabel && !parentProps.label) {
    return null;
  }
  var children = parentProps.children;
  var parentViewBox = parseViewBox(parentProps);
  var explicitChildren = findAllByType(children, Label$1).map(function(child, index2) {
    return /* @__PURE__ */ cloneElement(child, {
      viewBox: viewBox || parentViewBox,
      // eslint-disable-next-line react/no-array-index-key
      key: "label-".concat(index2)
    });
  });
  if (!checkPropsLabel) {
    return explicitChildren;
  }
  var implicitLabel = parseLabel(parentProps.label, viewBox || parentViewBox);
  return [implicitLabel].concat(_toConsumableArray$8(explicitChildren));
};
Label$1.parseViewBox = parseViewBox;
Label$1.renderCallByParent = renderCallByParent$1;
var lastExports = requireLast();
const last = /* @__PURE__ */ getDefaultExportFromCjs(lastExports);
function _typeof$w(o2) {
  "@babel/helpers - typeof";
  return _typeof$w = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof$w(o2);
}
var _excluded$c = ["valueAccessor"], _excluded2$6 = ["data", "dataKey", "clockWise", "id", "textBreakAll"];
function _toConsumableArray$7(arr) {
  return _arrayWithoutHoles$7(arr) || _iterableToArray$8(arr) || _unsupportedIterableToArray$b(arr) || _nonIterableSpread$7();
}
function _nonIterableSpread$7() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$b(o2, minLen) {
  if (!o2) return;
  if (typeof o2 === "string") return _arrayLikeToArray$b(o2, minLen);
  var n2 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n2 === "Object" && o2.constructor) n2 = o2.constructor.name;
  if (n2 === "Map" || n2 === "Set") return Array.from(o2);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray$b(o2, minLen);
}
function _iterableToArray$8(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles$7(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$b(arr);
}
function _arrayLikeToArray$b(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i3 = 0, arr2 = new Array(len); i3 < len; i3++) arr2[i3] = arr[i3];
  return arr2;
}
function _extends$n() {
  _extends$n = Object.assign ? Object.assign.bind() : function(target) {
    for (var i3 = 1; i3 < arguments.length; i3++) {
      var source = arguments[i3];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$n.apply(this, arguments);
}
function ownKeys$r(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e3);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$r(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$r(Object(t3), true).forEach(function(r3) {
      _defineProperty$u(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$r(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
function _defineProperty$u(obj, key, value) {
  key = _toPropertyKey$u(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$u(t3) {
  var i3 = _toPrimitive$u(t3, "string");
  return "symbol" == _typeof$w(i3) ? i3 : i3 + "";
}
function _toPrimitive$u(t3, r2) {
  if ("object" != _typeof$w(t3) || !t3) return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i3 = e3.call(t3, r2);
    if ("object" != _typeof$w(i3)) return i3;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t3);
}
function _objectWithoutProperties$c(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$c(source, excluded);
  var key, i3;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i3 = 0; i3 < sourceSymbolKeys.length; i3++) {
      key = sourceSymbolKeys[i3];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$c(source, excluded) {
  if (source == null) return {};
  var target = {};
  for (var key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
  }
  return target;
}
var defaultAccessor = function defaultAccessor2(entry) {
  return Array.isArray(entry.value) ? last(entry.value) : entry.value;
};
function LabelList(_ref) {
  var _ref$valueAccessor = _ref.valueAccessor, valueAccessor = _ref$valueAccessor === void 0 ? defaultAccessor : _ref$valueAccessor, restProps = _objectWithoutProperties$c(_ref, _excluded$c);
  var data = restProps.data, dataKey = restProps.dataKey, clockWise = restProps.clockWise, id2 = restProps.id, textBreakAll = restProps.textBreakAll, others = _objectWithoutProperties$c(restProps, _excluded2$6);
  if (!data || !data.length) {
    return null;
  }
  return /* @__PURE__ */ React__default.createElement(Layer, {
    className: "recharts-label-list"
  }, data.map(function(entry, index2) {
    var value = isNil(dataKey) ? valueAccessor(entry, index2) : getValueByDataKey(entry && entry.payload, dataKey);
    var idProps = isNil(id2) ? {} : {
      id: "".concat(id2, "-").concat(index2)
    };
    return /* @__PURE__ */ React__default.createElement(Label$1, _extends$n({}, filterProps(entry, true), others, idProps, {
      parentViewBox: entry.parentViewBox,
      value,
      textBreakAll,
      viewBox: Label$1.parseViewBox(isNil(clockWise) ? entry : _objectSpread$r(_objectSpread$r({}, entry), {}, {
        clockWise
      })),
      key: "label-".concat(index2),
      index: index2
    }));
  }));
}
LabelList.displayName = "LabelList";
function parseLabelList(label, data) {
  if (!label) {
    return null;
  }
  if (label === true) {
    return /* @__PURE__ */ React__default.createElement(LabelList, {
      key: "labelList-implicit",
      data
    });
  }
  if (/* @__PURE__ */ React__default.isValidElement(label) || isFunction(label)) {
    return /* @__PURE__ */ React__default.createElement(LabelList, {
      key: "labelList-implicit",
      data,
      content: label
    });
  }
  if (isObject(label)) {
    return /* @__PURE__ */ React__default.createElement(LabelList, _extends$n({
      data
    }, label, {
      key: "labelList-implicit"
    }));
  }
  return null;
}
function renderCallByParent2(parentProps, data) {
  var checkPropsLabel = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
  if (!parentProps || !parentProps.children && checkPropsLabel && !parentProps.label) {
    return null;
  }
  var children = parentProps.children;
  var explicitChildren = findAllByType(children, LabelList).map(function(child, index2) {
    return /* @__PURE__ */ cloneElement(child, {
      data,
      // eslint-disable-next-line react/no-array-index-key
      key: "labelList-".concat(index2)
    });
  });
  if (!checkPropsLabel) {
    return explicitChildren;
  }
  var implicitLabelList = parseLabelList(parentProps.label, data);
  return [implicitLabelList].concat(_toConsumableArray$7(explicitChildren));
}
LabelList.renderCallByParent = renderCallByParent2;
function _typeof$v(o2) {
  "@babel/helpers - typeof";
  return _typeof$v = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof$v(o2);
}
function _extends$m() {
  _extends$m = Object.assign ? Object.assign.bind() : function(target) {
    for (var i3 = 1; i3 < arguments.length; i3++) {
      var source = arguments[i3];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$m.apply(this, arguments);
}
function ownKeys$q(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e3);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$q(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$q(Object(t3), true).forEach(function(r3) {
      _defineProperty$t(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$q(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
function _defineProperty$t(obj, key, value) {
  key = _toPropertyKey$t(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$t(t3) {
  var i3 = _toPrimitive$t(t3, "string");
  return "symbol" == _typeof$v(i3) ? i3 : i3 + "";
}
function _toPrimitive$t(t3, r2) {
  if ("object" != _typeof$v(t3) || !t3) return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i3 = e3.call(t3, r2);
    if ("object" != _typeof$v(i3)) return i3;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t3);
}
var getDeltaAngle2 = function getDeltaAngle3(startAngle, endAngle) {
  var sign2 = mathSign(endAngle - startAngle);
  var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 359.999);
  return sign2 * deltaAngle;
};
var getTangentCircle = function getTangentCircle2(_ref) {
  var cx = _ref.cx, cy = _ref.cy, radius = _ref.radius, angle = _ref.angle, sign2 = _ref.sign, isExternal = _ref.isExternal, cornerRadius = _ref.cornerRadius, cornerIsExternal = _ref.cornerIsExternal;
  var centerRadius = cornerRadius * (isExternal ? 1 : -1) + radius;
  var theta = Math.asin(cornerRadius / centerRadius) / RADIAN$2;
  var centerAngle = cornerIsExternal ? angle : angle + sign2 * theta;
  var center = polarToCartesian(cx, cy, centerRadius, centerAngle);
  var circleTangency = polarToCartesian(cx, cy, radius, centerAngle);
  var lineTangencyAngle = cornerIsExternal ? angle - sign2 * theta : angle;
  var lineTangency = polarToCartesian(cx, cy, centerRadius * Math.cos(theta * RADIAN$2), lineTangencyAngle);
  return {
    center,
    circleTangency,
    lineTangency,
    theta
  };
};
var getSectorPath = function getSectorPath2(_ref2) {
  var cx = _ref2.cx, cy = _ref2.cy, innerRadius = _ref2.innerRadius, outerRadius = _ref2.outerRadius, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle;
  var angle = getDeltaAngle2(startAngle, endAngle);
  var tempEndAngle = startAngle + angle;
  var outerStartPoint = polarToCartesian(cx, cy, outerRadius, startAngle);
  var outerEndPoint = polarToCartesian(cx, cy, outerRadius, tempEndAngle);
  var path = "M ".concat(outerStartPoint.x, ",").concat(outerStartPoint.y, "\n    A ").concat(outerRadius, ",").concat(outerRadius, ",0,\n    ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle > tempEndAngle), ",\n    ").concat(outerEndPoint.x, ",").concat(outerEndPoint.y, "\n  ");
  if (innerRadius > 0) {
    var innerStartPoint = polarToCartesian(cx, cy, innerRadius, startAngle);
    var innerEndPoint = polarToCartesian(cx, cy, innerRadius, tempEndAngle);
    path += "L ".concat(innerEndPoint.x, ",").concat(innerEndPoint.y, "\n            A ").concat(innerRadius, ",").concat(innerRadius, ",0,\n            ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle <= tempEndAngle), ",\n            ").concat(innerStartPoint.x, ",").concat(innerStartPoint.y, " Z");
  } else {
    path += "L ".concat(cx, ",").concat(cy, " Z");
  }
  return path;
};
var getSectorWithCorner = function getSectorWithCorner2(_ref3) {
  var cx = _ref3.cx, cy = _ref3.cy, innerRadius = _ref3.innerRadius, outerRadius = _ref3.outerRadius, cornerRadius = _ref3.cornerRadius, forceCornerRadius = _ref3.forceCornerRadius, cornerIsExternal = _ref3.cornerIsExternal, startAngle = _ref3.startAngle, endAngle = _ref3.endAngle;
  var sign2 = mathSign(endAngle - startAngle);
  var _getTangentCircle = getTangentCircle({
    cx,
    cy,
    radius: outerRadius,
    angle: startAngle,
    sign: sign2,
    cornerRadius,
    cornerIsExternal
  }), soct = _getTangentCircle.circleTangency, solt = _getTangentCircle.lineTangency, sot = _getTangentCircle.theta;
  var _getTangentCircle2 = getTangentCircle({
    cx,
    cy,
    radius: outerRadius,
    angle: endAngle,
    sign: -sign2,
    cornerRadius,
    cornerIsExternal
  }), eoct = _getTangentCircle2.circleTangency, eolt = _getTangentCircle2.lineTangency, eot = _getTangentCircle2.theta;
  var outerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sot - eot;
  if (outerArcAngle < 0) {
    if (forceCornerRadius) {
      return "M ".concat(solt.x, ",").concat(solt.y, "\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(cornerRadius * 2, ",0\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(-cornerRadius * 2, ",0\n      ");
    }
    return getSectorPath({
      cx,
      cy,
      innerRadius,
      outerRadius,
      startAngle,
      endAngle
    });
  }
  var path = "M ".concat(solt.x, ",").concat(solt.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign2 < 0), ",").concat(soct.x, ",").concat(soct.y, "\n    A").concat(outerRadius, ",").concat(outerRadius, ",0,").concat(+(outerArcAngle > 180), ",").concat(+(sign2 < 0), ",").concat(eoct.x, ",").concat(eoct.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign2 < 0), ",").concat(eolt.x, ",").concat(eolt.y, "\n  ");
  if (innerRadius > 0) {
    var _getTangentCircle3 = getTangentCircle({
      cx,
      cy,
      radius: innerRadius,
      angle: startAngle,
      sign: sign2,
      isExternal: true,
      cornerRadius,
      cornerIsExternal
    }), sict = _getTangentCircle3.circleTangency, silt = _getTangentCircle3.lineTangency, sit = _getTangentCircle3.theta;
    var _getTangentCircle4 = getTangentCircle({
      cx,
      cy,
      radius: innerRadius,
      angle: endAngle,
      sign: -sign2,
      isExternal: true,
      cornerRadius,
      cornerIsExternal
    }), eict = _getTangentCircle4.circleTangency, eilt = _getTangentCircle4.lineTangency, eit = _getTangentCircle4.theta;
    var innerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sit - eit;
    if (innerArcAngle < 0 && cornerRadius === 0) {
      return "".concat(path, "L").concat(cx, ",").concat(cy, "Z");
    }
    path += "L".concat(eilt.x, ",").concat(eilt.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign2 < 0), ",").concat(eict.x, ",").concat(eict.y, "\n      A").concat(innerRadius, ",").concat(innerRadius, ",0,").concat(+(innerArcAngle > 180), ",").concat(+(sign2 > 0), ",").concat(sict.x, ",").concat(sict.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign2 < 0), ",").concat(silt.x, ",").concat(silt.y, "Z");
  } else {
    path += "L".concat(cx, ",").concat(cy, "Z");
  }
  return path;
};
var defaultProps$3 = {
  cx: 0,
  cy: 0,
  innerRadius: 0,
  outerRadius: 0,
  startAngle: 0,
  endAngle: 0,
  cornerRadius: 0,
  forceCornerRadius: false,
  cornerIsExternal: false
};
var Sector = function Sector2(sectorProps) {
  var props = _objectSpread$q(_objectSpread$q({}, defaultProps$3), sectorProps);
  var cx = props.cx, cy = props.cy, innerRadius = props.innerRadius, outerRadius = props.outerRadius, cornerRadius = props.cornerRadius, forceCornerRadius = props.forceCornerRadius, cornerIsExternal = props.cornerIsExternal, startAngle = props.startAngle, endAngle = props.endAngle, className = props.className;
  if (outerRadius < innerRadius || startAngle === endAngle) {
    return null;
  }
  var layerClass = clsx("recharts-sector", className);
  var deltaRadius = outerRadius - innerRadius;
  var cr = getPercentValue(cornerRadius, deltaRadius, 0, true);
  var path;
  if (cr > 0 && Math.abs(startAngle - endAngle) < 360) {
    path = getSectorWithCorner({
      cx,
      cy,
      innerRadius,
      outerRadius,
      cornerRadius: Math.min(cr, deltaRadius / 2),
      forceCornerRadius,
      cornerIsExternal,
      startAngle,
      endAngle
    });
  } else {
    path = getSectorPath({
      cx,
      cy,
      innerRadius,
      outerRadius,
      startAngle,
      endAngle
    });
  }
  return /* @__PURE__ */ React__default.createElement("path", _extends$m({}, filterProps(props, true), {
    className: layerClass,
    d: path,
    role: "img"
  }));
};
function _typeof$u(o2) {
  "@babel/helpers - typeof";
  return _typeof$u = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof$u(o2);
}
function _extends$l() {
  _extends$l = Object.assign ? Object.assign.bind() : function(target) {
    for (var i3 = 1; i3 < arguments.length; i3++) {
      var source = arguments[i3];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$l.apply(this, arguments);
}
function ownKeys$p(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e3);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$p(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$p(Object(t3), true).forEach(function(r3) {
      _defineProperty$s(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$p(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
function _defineProperty$s(obj, key, value) {
  key = _toPropertyKey$s(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$s(t3) {
  var i3 = _toPrimitive$s(t3, "string");
  return "symbol" == _typeof$u(i3) ? i3 : i3 + "";
}
function _toPrimitive$s(t3, r2) {
  if ("object" != _typeof$u(t3) || !t3) return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i3 = e3.call(t3, r2);
    if ("object" != _typeof$u(i3)) return i3;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t3);
}
var CURVE_FACTORIES = {
  curveBasisClosed,
  curveBasisOpen,
  curveBasis,
  curveBumpX: bumpX,
  curveBumpY: bumpY,
  curveLinearClosed,
  curveLinear,
  curveMonotoneX: monotoneX,
  curveMonotoneY: monotoneY,
  curveNatural,
  curveStep,
  curveStepAfter: stepAfter,
  curveStepBefore: stepBefore
};
var defined = function defined2(p2) {
  return p2.x === +p2.x && p2.y === +p2.y;
};
var getX = function getX2(p2) {
  return p2.x;
};
var getY = function getY2(p2) {
  return p2.y;
};
var getCurveFactory = function getCurveFactory2(type, layout) {
  if (isFunction(type)) {
    return type;
  }
  var name = "curve".concat(upperFirst(type));
  if ((name === "curveMonotone" || name === "curveBump") && layout) {
    return CURVE_FACTORIES["".concat(name).concat(layout === "vertical" ? "Y" : "X")];
  }
  return CURVE_FACTORIES[name] || curveLinear;
};
var getPath$1 = function getPath(_ref) {
  var _ref$type = _ref.type, type = _ref$type === void 0 ? "linear" : _ref$type, _ref$points = _ref.points, points = _ref$points === void 0 ? [] : _ref$points, baseLine = _ref.baseLine, layout = _ref.layout, _ref$connectNulls = _ref.connectNulls, connectNulls = _ref$connectNulls === void 0 ? false : _ref$connectNulls;
  var curveFactory = getCurveFactory(type, layout);
  var formatPoints = connectNulls ? points.filter(function(entry) {
    return defined(entry);
  }) : points;
  var lineFunction;
  if (Array.isArray(baseLine)) {
    var formatBaseLine = connectNulls ? baseLine.filter(function(base) {
      return defined(base);
    }) : baseLine;
    var areaPoints = formatPoints.map(function(entry, index2) {
      return _objectSpread$p(_objectSpread$p({}, entry), {}, {
        base: formatBaseLine[index2]
      });
    });
    if (layout === "vertical") {
      lineFunction = shapeArea().y(getY).x1(getX).x0(function(d4) {
        return d4.base.x;
      });
    } else {
      lineFunction = shapeArea().x(getX).y1(getY).y0(function(d4) {
        return d4.base.y;
      });
    }
    lineFunction.defined(defined).curve(curveFactory);
    return lineFunction(areaPoints);
  }
  if (layout === "vertical" && isNumber(baseLine)) {
    lineFunction = shapeArea().y(getY).x1(getX).x0(baseLine);
  } else if (isNumber(baseLine)) {
    lineFunction = shapeArea().x(getX).y1(getY).y0(baseLine);
  } else {
    lineFunction = shapeLine().x(getX).y(getY);
  }
  lineFunction.defined(defined).curve(curveFactory);
  return lineFunction(formatPoints);
};
var Curve = function Curve2(props) {
  var className = props.className, points = props.points, path = props.path, pathRef = props.pathRef;
  if ((!points || !points.length) && !path) {
    return null;
  }
  var realPath = points && points.length ? getPath$1(props) : path;
  return /* @__PURE__ */ React__default.createElement("path", _extends$l({}, filterProps(props, false), adaptEventHandlers(props), {
    className: clsx("recharts-curve", className),
    d: realPath,
    ref: pathRef
  }));
};
var getOwnPropertyNames = Object.getOwnPropertyNames, getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
function combineComparators(comparatorA, comparatorB) {
  return function isEqual2(a4, b3, state) {
    return comparatorA(a4, b3, state) && comparatorB(a4, b3, state);
  };
}
function createIsCircular(areItemsEqual) {
  return function isCircular(a4, b3, state) {
    if (!a4 || !b3 || typeof a4 !== "object" || typeof b3 !== "object") {
      return areItemsEqual(a4, b3, state);
    }
    var cache = state.cache;
    var cachedA = cache.get(a4);
    var cachedB = cache.get(b3);
    if (cachedA && cachedB) {
      return cachedA === b3 && cachedB === a4;
    }
    cache.set(a4, b3);
    cache.set(b3, a4);
    var result = areItemsEqual(a4, b3, state);
    cache.delete(a4);
    cache.delete(b3);
    return result;
  };
}
function getStrictProperties(object2) {
  return getOwnPropertyNames(object2).concat(getOwnPropertySymbols(object2));
}
var hasOwn = Object.hasOwn || function(object2, property) {
  return hasOwnProperty.call(object2, property);
};
function sameValueZeroEqual(a4, b3) {
  return a4 === b3 || !a4 && !b3 && a4 !== a4 && b3 !== b3;
}
var PREACT_VNODE = "__v";
var PREACT_OWNER = "__o";
var REACT_OWNER = "_owner";
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor, keys = Object.keys;
function areArraysEqual(a4, b3, state) {
  var index2 = a4.length;
  if (b3.length !== index2) {
    return false;
  }
  while (index2-- > 0) {
    if (!state.equals(a4[index2], b3[index2], index2, index2, a4, b3, state)) {
      return false;
    }
  }
  return true;
}
function areDatesEqual(a4, b3) {
  return sameValueZeroEqual(a4.getTime(), b3.getTime());
}
function areErrorsEqual(a4, b3) {
  return a4.name === b3.name && a4.message === b3.message && a4.cause === b3.cause && a4.stack === b3.stack;
}
function areFunctionsEqual(a4, b3) {
  return a4 === b3;
}
function areMapsEqual(a4, b3, state) {
  var size2 = a4.size;
  if (size2 !== b3.size) {
    return false;
  }
  if (!size2) {
    return true;
  }
  var matchedIndices = new Array(size2);
  var aIterable = a4.entries();
  var aResult;
  var bResult;
  var index2 = 0;
  while (aResult = aIterable.next()) {
    if (aResult.done) {
      break;
    }
    var bIterable = b3.entries();
    var hasMatch = false;
    var matchIndex = 0;
    while (bResult = bIterable.next()) {
      if (bResult.done) {
        break;
      }
      if (matchedIndices[matchIndex]) {
        matchIndex++;
        continue;
      }
      var aEntry = aResult.value;
      var bEntry = bResult.value;
      if (state.equals(aEntry[0], bEntry[0], index2, matchIndex, a4, b3, state) && state.equals(aEntry[1], bEntry[1], aEntry[0], bEntry[0], a4, b3, state)) {
        hasMatch = matchedIndices[matchIndex] = true;
        break;
      }
      matchIndex++;
    }
    if (!hasMatch) {
      return false;
    }
    index2++;
  }
  return true;
}
var areNumbersEqual = sameValueZeroEqual;
function areObjectsEqual(a4, b3, state) {
  var properties2 = keys(a4);
  var index2 = properties2.length;
  if (keys(b3).length !== index2) {
    return false;
  }
  while (index2-- > 0) {
    if (!isPropertyEqual(a4, b3, state, properties2[index2])) {
      return false;
    }
  }
  return true;
}
function areObjectsEqualStrict(a4, b3, state) {
  var properties2 = getStrictProperties(a4);
  var index2 = properties2.length;
  if (getStrictProperties(b3).length !== index2) {
    return false;
  }
  var property;
  var descriptorA;
  var descriptorB;
  while (index2-- > 0) {
    property = properties2[index2];
    if (!isPropertyEqual(a4, b3, state, property)) {
      return false;
    }
    descriptorA = getOwnPropertyDescriptor(a4, property);
    descriptorB = getOwnPropertyDescriptor(b3, property);
    if ((descriptorA || descriptorB) && (!descriptorA || !descriptorB || descriptorA.configurable !== descriptorB.configurable || descriptorA.enumerable !== descriptorB.enumerable || descriptorA.writable !== descriptorB.writable)) {
      return false;
    }
  }
  return true;
}
function arePrimitiveWrappersEqual(a4, b3) {
  return sameValueZeroEqual(a4.valueOf(), b3.valueOf());
}
function areRegExpsEqual(a4, b3) {
  return a4.source === b3.source && a4.flags === b3.flags;
}
function areSetsEqual(a4, b3, state) {
  var size2 = a4.size;
  if (size2 !== b3.size) {
    return false;
  }
  if (!size2) {
    return true;
  }
  var matchedIndices = new Array(size2);
  var aIterable = a4.values();
  var aResult;
  var bResult;
  while (aResult = aIterable.next()) {
    if (aResult.done) {
      break;
    }
    var bIterable = b3.values();
    var hasMatch = false;
    var matchIndex = 0;
    while (bResult = bIterable.next()) {
      if (bResult.done) {
        break;
      }
      if (!matchedIndices[matchIndex] && state.equals(aResult.value, bResult.value, aResult.value, bResult.value, a4, b3, state)) {
        hasMatch = matchedIndices[matchIndex] = true;
        break;
      }
      matchIndex++;
    }
    if (!hasMatch) {
      return false;
    }
  }
  return true;
}
function areTypedArraysEqual(a4, b3) {
  var index2 = a4.length;
  if (b3.length !== index2) {
    return false;
  }
  while (index2-- > 0) {
    if (a4[index2] !== b3[index2]) {
      return false;
    }
  }
  return true;
}
function areUrlsEqual(a4, b3) {
  return a4.hostname === b3.hostname && a4.pathname === b3.pathname && a4.protocol === b3.protocol && a4.port === b3.port && a4.hash === b3.hash && a4.username === b3.username && a4.password === b3.password;
}
function isPropertyEqual(a4, b3, state, property) {
  if ((property === REACT_OWNER || property === PREACT_OWNER || property === PREACT_VNODE) && (a4.$$typeof || b3.$$typeof)) {
    return true;
  }
  return hasOwn(b3, property) && state.equals(a4[property], b3[property], property, property, a4, b3, state);
}
var ARGUMENTS_TAG = "[object Arguments]";
var BOOLEAN_TAG = "[object Boolean]";
var DATE_TAG = "[object Date]";
var ERROR_TAG = "[object Error]";
var MAP_TAG = "[object Map]";
var NUMBER_TAG = "[object Number]";
var OBJECT_TAG = "[object Object]";
var REG_EXP_TAG = "[object RegExp]";
var SET_TAG = "[object Set]";
var STRING_TAG = "[object String]";
var URL_TAG = "[object URL]";
var isArray = Array.isArray;
var isTypedArray = typeof ArrayBuffer === "function" && ArrayBuffer.isView ? ArrayBuffer.isView : null;
var assign = Object.assign;
var getTag = Object.prototype.toString.call.bind(Object.prototype.toString);
function createEqualityComparator(_a) {
  var areArraysEqual2 = _a.areArraysEqual, areDatesEqual2 = _a.areDatesEqual, areErrorsEqual2 = _a.areErrorsEqual, areFunctionsEqual2 = _a.areFunctionsEqual, areMapsEqual2 = _a.areMapsEqual, areNumbersEqual2 = _a.areNumbersEqual, areObjectsEqual2 = _a.areObjectsEqual, arePrimitiveWrappersEqual2 = _a.arePrimitiveWrappersEqual, areRegExpsEqual2 = _a.areRegExpsEqual, areSetsEqual2 = _a.areSetsEqual, areTypedArraysEqual2 = _a.areTypedArraysEqual, areUrlsEqual2 = _a.areUrlsEqual;
  return function comparator(a4, b3, state) {
    if (a4 === b3) {
      return true;
    }
    if (a4 == null || b3 == null) {
      return false;
    }
    var type = typeof a4;
    if (type !== typeof b3) {
      return false;
    }
    if (type !== "object") {
      if (type === "number") {
        return areNumbersEqual2(a4, b3, state);
      }
      if (type === "function") {
        return areFunctionsEqual2(a4, b3, state);
      }
      return false;
    }
    var constructor = a4.constructor;
    if (constructor !== b3.constructor) {
      return false;
    }
    if (constructor === Object) {
      return areObjectsEqual2(a4, b3, state);
    }
    if (isArray(a4)) {
      return areArraysEqual2(a4, b3, state);
    }
    if (isTypedArray != null && isTypedArray(a4)) {
      return areTypedArraysEqual2(a4, b3, state);
    }
    if (constructor === Date) {
      return areDatesEqual2(a4, b3, state);
    }
    if (constructor === RegExp) {
      return areRegExpsEqual2(a4, b3, state);
    }
    if (constructor === Map) {
      return areMapsEqual2(a4, b3, state);
    }
    if (constructor === Set) {
      return areSetsEqual2(a4, b3, state);
    }
    var tag = getTag(a4);
    if (tag === DATE_TAG) {
      return areDatesEqual2(a4, b3, state);
    }
    if (tag === REG_EXP_TAG) {
      return areRegExpsEqual2(a4, b3, state);
    }
    if (tag === MAP_TAG) {
      return areMapsEqual2(a4, b3, state);
    }
    if (tag === SET_TAG) {
      return areSetsEqual2(a4, b3, state);
    }
    if (tag === OBJECT_TAG) {
      return typeof a4.then !== "function" && typeof b3.then !== "function" && areObjectsEqual2(a4, b3, state);
    }
    if (tag === URL_TAG) {
      return areUrlsEqual2(a4, b3, state);
    }
    if (tag === ERROR_TAG) {
      return areErrorsEqual2(a4, b3, state);
    }
    if (tag === ARGUMENTS_TAG) {
      return areObjectsEqual2(a4, b3, state);
    }
    if (tag === BOOLEAN_TAG || tag === NUMBER_TAG || tag === STRING_TAG) {
      return arePrimitiveWrappersEqual2(a4, b3, state);
    }
    return false;
  };
}
function createEqualityComparatorConfig(_a) {
  var circular = _a.circular, createCustomConfig = _a.createCustomConfig, strict = _a.strict;
  var config2 = {
    areArraysEqual: strict ? areObjectsEqualStrict : areArraysEqual,
    areDatesEqual,
    areErrorsEqual,
    areFunctionsEqual,
    areMapsEqual: strict ? combineComparators(areMapsEqual, areObjectsEqualStrict) : areMapsEqual,
    areNumbersEqual,
    areObjectsEqual: strict ? areObjectsEqualStrict : areObjectsEqual,
    arePrimitiveWrappersEqual,
    areRegExpsEqual,
    areSetsEqual: strict ? combineComparators(areSetsEqual, areObjectsEqualStrict) : areSetsEqual,
    areTypedArraysEqual: strict ? areObjectsEqualStrict : areTypedArraysEqual,
    areUrlsEqual
  };
  if (createCustomConfig) {
    config2 = assign({}, config2, createCustomConfig(config2));
  }
  if (circular) {
    var areArraysEqual$1 = createIsCircular(config2.areArraysEqual);
    var areMapsEqual$1 = createIsCircular(config2.areMapsEqual);
    var areObjectsEqual$1 = createIsCircular(config2.areObjectsEqual);
    var areSetsEqual$1 = createIsCircular(config2.areSetsEqual);
    config2 = assign({}, config2, {
      areArraysEqual: areArraysEqual$1,
      areMapsEqual: areMapsEqual$1,
      areObjectsEqual: areObjectsEqual$1,
      areSetsEqual: areSetsEqual$1
    });
  }
  return config2;
}
function createInternalEqualityComparator(compare) {
  return function(a4, b3, _indexOrKeyA, _indexOrKeyB, _parentA, _parentB, state) {
    return compare(a4, b3, state);
  };
}
function createIsEqual(_a) {
  var circular = _a.circular, comparator = _a.comparator, createState2 = _a.createState, equals2 = _a.equals, strict = _a.strict;
  if (createState2) {
    return function isEqual2(a4, b3) {
      var _a2 = createState2(), _b = _a2.cache, cache = _b === void 0 ? circular ? /* @__PURE__ */ new WeakMap() : void 0 : _b, meta = _a2.meta;
      return comparator(a4, b3, {
        cache,
        equals: equals2,
        meta,
        strict
      });
    };
  }
  if (circular) {
    return function isEqual2(a4, b3) {
      return comparator(a4, b3, {
        cache: /* @__PURE__ */ new WeakMap(),
        equals: equals2,
        meta: void 0,
        strict
      });
    };
  }
  var state = {
    cache: void 0,
    equals: equals2,
    meta: void 0,
    strict
  };
  return function isEqual2(a4, b3) {
    return comparator(a4, b3, state);
  };
}
var deepEqual = createCustomEqual();
createCustomEqual({ strict: true });
createCustomEqual({ circular: true });
createCustomEqual({
  circular: true,
  strict: true
});
createCustomEqual({
  createInternalComparator: function() {
    return sameValueZeroEqual;
  }
});
createCustomEqual({
  strict: true,
  createInternalComparator: function() {
    return sameValueZeroEqual;
  }
});
createCustomEqual({
  circular: true,
  createInternalComparator: function() {
    return sameValueZeroEqual;
  }
});
createCustomEqual({
  circular: true,
  createInternalComparator: function() {
    return sameValueZeroEqual;
  },
  strict: true
});
function createCustomEqual(options) {
  if (options === void 0) {
    options = {};
  }
  var _a = options.circular, circular = _a === void 0 ? false : _a, createCustomInternalComparator = options.createInternalComparator, createState2 = options.createState, _b = options.strict, strict = _b === void 0 ? false : _b;
  var config2 = createEqualityComparatorConfig(options);
  var comparator = createEqualityComparator(config2);
  var equals2 = createCustomInternalComparator ? createCustomInternalComparator(comparator) : createInternalEqualityComparator(comparator);
  return createIsEqual({ circular, comparator, createState: createState2, equals: equals2, strict });
}
function safeRequestAnimationFrame(callback) {
  if (typeof requestAnimationFrame !== "undefined") requestAnimationFrame(callback);
}
function setRafTimeout(callback) {
  var timeout = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  var currTime = -1;
  var shouldUpdate = function shouldUpdate2(now2) {
    if (currTime < 0) {
      currTime = now2;
    }
    if (now2 - currTime > timeout) {
      callback(now2);
      currTime = -1;
    } else {
      safeRequestAnimationFrame(shouldUpdate2);
    }
  };
  requestAnimationFrame(shouldUpdate);
}
function _typeof$t(o2) {
  "@babel/helpers - typeof";
  return _typeof$t = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof$t(o2);
}
function _toArray(arr) {
  return _arrayWithHoles$6(arr) || _iterableToArray$7(arr) || _unsupportedIterableToArray$a(arr) || _nonIterableRest$6();
}
function _nonIterableRest$6() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$a(o2, minLen) {
  if (!o2) return;
  if (typeof o2 === "string") return _arrayLikeToArray$a(o2, minLen);
  var n2 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n2 === "Object" && o2.constructor) n2 = o2.constructor.name;
  if (n2 === "Map" || n2 === "Set") return Array.from(o2);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray$a(o2, minLen);
}
function _arrayLikeToArray$a(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i3 = 0, arr2 = new Array(len); i3 < len; i3++) arr2[i3] = arr[i3];
  return arr2;
}
function _iterableToArray$7(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithHoles$6(arr) {
  if (Array.isArray(arr)) return arr;
}
function createAnimateManager() {
  var currStyle = {};
  var handleChange = function handleChange2() {
    return null;
  };
  var shouldStop = false;
  var setStyle = function setStyle2(_style) {
    if (shouldStop) {
      return;
    }
    if (Array.isArray(_style)) {
      if (!_style.length) {
        return;
      }
      var styles = _style;
      var _styles = _toArray(styles), curr = _styles[0], restStyles = _styles.slice(1);
      if (typeof curr === "number") {
        setRafTimeout(setStyle2.bind(null, restStyles), curr);
        return;
      }
      setStyle2(curr);
      setRafTimeout(setStyle2.bind(null, restStyles));
      return;
    }
    if (_typeof$t(_style) === "object") {
      currStyle = _style;
      handleChange(currStyle);
    }
    if (typeof _style === "function") {
      _style();
    }
  };
  return {
    stop: function stop() {
      shouldStop = true;
    },
    start: function start(style) {
      shouldStop = false;
      setStyle(style);
    },
    subscribe: function subscribe(_handleChange) {
      handleChange = _handleChange;
      return function() {
        handleChange = function handleChange2() {
          return null;
        };
      };
    }
  };
}
function _typeof$s(o2) {
  "@babel/helpers - typeof";
  return _typeof$s = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof$s(o2);
}
function ownKeys$o(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e3);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$o(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$o(Object(t3), true).forEach(function(r3) {
      _defineProperty$r(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$o(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
function _defineProperty$r(obj, key, value) {
  key = _toPropertyKey$r(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$r(arg) {
  var key = _toPrimitive$r(arg, "string");
  return _typeof$s(key) === "symbol" ? key : String(key);
}
function _toPrimitive$r(input, hint) {
  if (_typeof$s(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint);
    if (_typeof$s(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
var getIntersectionKeys = function getIntersectionKeys2(preObj, nextObj) {
  return [Object.keys(preObj), Object.keys(nextObj)].reduce(function(a4, b3) {
    return a4.filter(function(c3) {
      return b3.includes(c3);
    });
  });
};
var identity2 = function identity3(param) {
  return param;
};
var getDashCase = function getDashCase2(name) {
  return name.replace(/([A-Z])/g, function(v2) {
    return "-".concat(v2.toLowerCase());
  });
};
var mapObject = function mapObject2(fn, obj) {
  return Object.keys(obj).reduce(function(res, key) {
    return _objectSpread$o(_objectSpread$o({}, res), {}, _defineProperty$r({}, key, fn(key, obj[key])));
  }, {});
};
var getTransitionVal = function getTransitionVal2(props, duration, easing) {
  return props.map(function(prop) {
    return "".concat(getDashCase(prop), " ").concat(duration, "ms ").concat(easing);
  }).join(",");
};
var isDev = process.env.NODE_ENV !== "production";
var warn2 = function warn3(condition, format2, a4, b3, c3, d4, e3, f2) {
  if (isDev && typeof console !== "undefined" && console.warn) {
    if (format2 === void 0) {
      console.warn("LogUtils requires an error message argument");
    }
    if (!condition) {
      if (format2 === void 0) {
        console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
      } else {
        var args = [a4, b3, c3, d4, e3, f2];
        var argIndex = 0;
        console.warn(format2.replace(/%s/g, function() {
          return args[argIndex++];
        }));
      }
    }
  }
};
function _slicedToArray$5(arr, i3) {
  return _arrayWithHoles$5(arr) || _iterableToArrayLimit$5(arr, i3) || _unsupportedIterableToArray$9(arr, i3) || _nonIterableRest$5();
}
function _nonIterableRest$5() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit$5(r2, l2) {
  var t3 = null == r2 ? null : "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];
  if (null != t3) {
    var e3, n2, i3, u3, a4 = [], f2 = true, o2 = false;
    try {
      if (i3 = (t3 = t3.call(r2)).next, 0 === l2) ;
      else for (; !(f2 = (e3 = i3.call(t3)).done) && (a4.push(e3.value), a4.length !== l2); f2 = true) ;
    } catch (r3) {
      o2 = true, n2 = r3;
    } finally {
      try {
        if (!f2 && null != t3.return && (u3 = t3.return(), Object(u3) !== u3)) return;
      } finally {
        if (o2) throw n2;
      }
    }
    return a4;
  }
}
function _arrayWithHoles$5(arr) {
  if (Array.isArray(arr)) return arr;
}
function _toConsumableArray$6(arr) {
  return _arrayWithoutHoles$6(arr) || _iterableToArray$6(arr) || _unsupportedIterableToArray$9(arr) || _nonIterableSpread$6();
}
function _nonIterableSpread$6() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$9(o2, minLen) {
  if (!o2) return;
  if (typeof o2 === "string") return _arrayLikeToArray$9(o2, minLen);
  var n2 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n2 === "Object" && o2.constructor) n2 = o2.constructor.name;
  if (n2 === "Map" || n2 === "Set") return Array.from(o2);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray$9(o2, minLen);
}
function _iterableToArray$6(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles$6(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$9(arr);
}
function _arrayLikeToArray$9(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i3 = 0, arr2 = new Array(len); i3 < len; i3++) arr2[i3] = arr[i3];
  return arr2;
}
var ACCURACY = 1e-4;
var cubicBezierFactor = function cubicBezierFactor2(c1, c22) {
  return [0, 3 * c1, 3 * c22 - 6 * c1, 3 * c1 - 3 * c22 + 1];
};
var multyTime = function multyTime2(params, t3) {
  return params.map(function(param, i3) {
    return param * Math.pow(t3, i3);
  }).reduce(function(pre, curr) {
    return pre + curr;
  });
};
var cubicBezier = function cubicBezier2(c1, c22) {
  return function(t3) {
    var params = cubicBezierFactor(c1, c22);
    return multyTime(params, t3);
  };
};
var derivativeCubicBezier = function derivativeCubicBezier2(c1, c22) {
  return function(t3) {
    var params = cubicBezierFactor(c1, c22);
    var newParams = [].concat(_toConsumableArray$6(params.map(function(param, i3) {
      return param * i3;
    }).slice(1)), [0]);
    return multyTime(newParams, t3);
  };
};
var configBezier = function configBezier2() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var x1 = args[0], y1 = args[1], x22 = args[2], y22 = args[3];
  if (args.length === 1) {
    switch (args[0]) {
      case "linear":
        x1 = 0;
        y1 = 0;
        x22 = 1;
        y22 = 1;
        break;
      case "ease":
        x1 = 0.25;
        y1 = 0.1;
        x22 = 0.25;
        y22 = 1;
        break;
      case "ease-in":
        x1 = 0.42;
        y1 = 0;
        x22 = 1;
        y22 = 1;
        break;
      case "ease-out":
        x1 = 0.42;
        y1 = 0;
        x22 = 0.58;
        y22 = 1;
        break;
      case "ease-in-out":
        x1 = 0;
        y1 = 0;
        x22 = 0.58;
        y22 = 1;
        break;
      default: {
        var easing = args[0].split("(");
        if (easing[0] === "cubic-bezier" && easing[1].split(")")[0].split(",").length === 4) {
          var _easing$1$split$0$spl = easing[1].split(")")[0].split(",").map(function(x3) {
            return parseFloat(x3);
          });
          var _easing$1$split$0$spl2 = _slicedToArray$5(_easing$1$split$0$spl, 4);
          x1 = _easing$1$split$0$spl2[0];
          y1 = _easing$1$split$0$spl2[1];
          x22 = _easing$1$split$0$spl2[2];
          y22 = _easing$1$split$0$spl2[3];
        } else {
          warn2(false, "[configBezier]: arguments should be one of oneOf 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', instead received %s", args);
        }
      }
    }
  }
  warn2([x1, x22, y1, y22].every(function(num) {
    return typeof num === "number" && num >= 0 && num <= 1;
  }), "[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s", args);
  var curveX = cubicBezier(x1, x22);
  var curveY = cubicBezier(y1, y22);
  var derCurveX = derivativeCubicBezier(x1, x22);
  var rangeValue = function rangeValue2(value) {
    if (value > 1) {
      return 1;
    }
    if (value < 0) {
      return 0;
    }
    return value;
  };
  var bezier = function bezier2(_t) {
    var t3 = _t > 1 ? 1 : _t;
    var x3 = t3;
    for (var i3 = 0; i3 < 8; ++i3) {
      var evalT = curveX(x3) - t3;
      var derVal = derCurveX(x3);
      if (Math.abs(evalT - t3) < ACCURACY || derVal < ACCURACY) {
        return curveY(x3);
      }
      x3 = rangeValue(x3 - evalT / derVal);
    }
    return curveY(x3);
  };
  bezier.isStepper = false;
  return bezier;
};
var configSpring = function configSpring2() {
  var config2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  var _config$stiff = config2.stiff, stiff = _config$stiff === void 0 ? 100 : _config$stiff, _config$damping = config2.damping, damping = _config$damping === void 0 ? 8 : _config$damping, _config$dt = config2.dt, dt = _config$dt === void 0 ? 17 : _config$dt;
  var stepper = function stepper2(currX, destX, currV) {
    var FSpring = -(currX - destX) * stiff;
    var FDamping = currV * damping;
    var newV = currV + (FSpring - FDamping) * dt / 1e3;
    var newX = currV * dt / 1e3 + currX;
    if (Math.abs(newX - destX) < ACCURACY && Math.abs(newV) < ACCURACY) {
      return [destX, 0];
    }
    return [newX, newV];
  };
  stepper.isStepper = true;
  stepper.dt = dt;
  return stepper;
};
var configEasing = function configEasing2() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  var easing = args[0];
  if (typeof easing === "string") {
    switch (easing) {
      case "ease":
      case "ease-in-out":
      case "ease-out":
      case "ease-in":
      case "linear":
        return configBezier(easing);
      case "spring":
        return configSpring();
      default:
        if (easing.split("(")[0] === "cubic-bezier") {
          return configBezier(easing);
        }
        warn2(false, "[configEasing]: first argument should be one of 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', 'linear' and 'spring', instead  received %s", args);
    }
  }
  if (typeof easing === "function") {
    return easing;
  }
  warn2(false, "[configEasing]: first argument type should be function or string, instead received %s", args);
  return null;
};
function _typeof$r(o2) {
  "@babel/helpers - typeof";
  return _typeof$r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof$r(o2);
}
function _toConsumableArray$5(arr) {
  return _arrayWithoutHoles$5(arr) || _iterableToArray$5(arr) || _unsupportedIterableToArray$8(arr) || _nonIterableSpread$5();
}
function _nonIterableSpread$5() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray$5(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles$5(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$8(arr);
}
function ownKeys$n(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e3);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$n(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$n(Object(t3), true).forEach(function(r3) {
      _defineProperty$q(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$n(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
function _defineProperty$q(obj, key, value) {
  key = _toPropertyKey$q(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$q(arg) {
  var key = _toPrimitive$q(arg, "string");
  return _typeof$r(key) === "symbol" ? key : String(key);
}
function _toPrimitive$q(input, hint) {
  if (_typeof$r(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint);
    if (_typeof$r(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _slicedToArray$4(arr, i3) {
  return _arrayWithHoles$4(arr) || _iterableToArrayLimit$4(arr, i3) || _unsupportedIterableToArray$8(arr, i3) || _nonIterableRest$4();
}
function _nonIterableRest$4() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$8(o2, minLen) {
  if (!o2) return;
  if (typeof o2 === "string") return _arrayLikeToArray$8(o2, minLen);
  var n2 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n2 === "Object" && o2.constructor) n2 = o2.constructor.name;
  if (n2 === "Map" || n2 === "Set") return Array.from(o2);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray$8(o2, minLen);
}
function _arrayLikeToArray$8(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i3 = 0, arr2 = new Array(len); i3 < len; i3++) arr2[i3] = arr[i3];
  return arr2;
}
function _iterableToArrayLimit$4(r2, l2) {
  var t3 = null == r2 ? null : "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];
  if (null != t3) {
    var e3, n2, i3, u3, a4 = [], f2 = true, o2 = false;
    try {
      if (i3 = (t3 = t3.call(r2)).next, 0 === l2) ;
      else for (; !(f2 = (e3 = i3.call(t3)).done) && (a4.push(e3.value), a4.length !== l2); f2 = true) ;
    } catch (r3) {
      o2 = true, n2 = r3;
    } finally {
      try {
        if (!f2 && null != t3.return && (u3 = t3.return(), Object(u3) !== u3)) return;
      } finally {
        if (o2) throw n2;
      }
    }
    return a4;
  }
}
function _arrayWithHoles$4(arr) {
  if (Array.isArray(arr)) return arr;
}
var alpha = function alpha2(begin, end, k3) {
  return begin + (end - begin) * k3;
};
var needContinue = function needContinue2(_ref) {
  var from = _ref.from, to = _ref.to;
  return from !== to;
};
var calStepperVals = function calStepperVals2(easing, preVals, steps2) {
  var nextStepVals = mapObject(function(key, val) {
    if (needContinue(val)) {
      var _easing = easing(val.from, val.to, val.velocity), _easing2 = _slicedToArray$4(_easing, 2), newX = _easing2[0], newV = _easing2[1];
      return _objectSpread$n(_objectSpread$n({}, val), {}, {
        from: newX,
        velocity: newV
      });
    }
    return val;
  }, preVals);
  if (steps2 < 1) {
    return mapObject(function(key, val) {
      if (needContinue(val)) {
        return _objectSpread$n(_objectSpread$n({}, val), {}, {
          velocity: alpha(val.velocity, nextStepVals[key].velocity, steps2),
          from: alpha(val.from, nextStepVals[key].from, steps2)
        });
      }
      return val;
    }, preVals);
  }
  return calStepperVals2(easing, nextStepVals, steps2 - 1);
};
const configUpdate = function(from, to, easing, duration, render) {
  var interKeys = getIntersectionKeys(from, to);
  var timingStyle = interKeys.reduce(function(res, key) {
    return _objectSpread$n(_objectSpread$n({}, res), {}, _defineProperty$q({}, key, [from[key], to[key]]));
  }, {});
  var stepperStyle = interKeys.reduce(function(res, key) {
    return _objectSpread$n(_objectSpread$n({}, res), {}, _defineProperty$q({}, key, {
      from: from[key],
      velocity: 0,
      to: to[key]
    }));
  }, {});
  var cafId = -1;
  var preTime;
  var beginTime;
  var update2 = function update3() {
    return null;
  };
  var getCurrStyle = function getCurrStyle2() {
    return mapObject(function(key, val) {
      return val.from;
    }, stepperStyle);
  };
  var shouldStopAnimation = function shouldStopAnimation2() {
    return !Object.values(stepperStyle).filter(needContinue).length;
  };
  var stepperUpdate = function stepperUpdate2(now2) {
    if (!preTime) {
      preTime = now2;
    }
    var deltaTime = now2 - preTime;
    var steps2 = deltaTime / easing.dt;
    stepperStyle = calStepperVals(easing, stepperStyle, steps2);
    render(_objectSpread$n(_objectSpread$n(_objectSpread$n({}, from), to), getCurrStyle()));
    preTime = now2;
    if (!shouldStopAnimation()) {
      cafId = requestAnimationFrame(update2);
    }
  };
  var timingUpdate = function timingUpdate2(now2) {
    if (!beginTime) {
      beginTime = now2;
    }
    var t3 = (now2 - beginTime) / duration;
    var currStyle = mapObject(function(key, val) {
      return alpha.apply(void 0, _toConsumableArray$5(val).concat([easing(t3)]));
    }, timingStyle);
    render(_objectSpread$n(_objectSpread$n(_objectSpread$n({}, from), to), currStyle));
    if (t3 < 1) {
      cafId = requestAnimationFrame(update2);
    } else {
      var finalStyle = mapObject(function(key, val) {
        return alpha.apply(void 0, _toConsumableArray$5(val).concat([easing(1)]));
      }, timingStyle);
      render(_objectSpread$n(_objectSpread$n(_objectSpread$n({}, from), to), finalStyle));
    }
  };
  update2 = easing.isStepper ? stepperUpdate : timingUpdate;
  return function() {
    requestAnimationFrame(update2);
    return function() {
      cancelAnimationFrame(cafId);
    };
  };
};
function _typeof$q(o2) {
  "@babel/helpers - typeof";
  return _typeof$q = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof$q(o2);
}
var _excluded$b = ["children", "begin", "duration", "attributeName", "easing", "isActive", "steps", "from", "to", "canBegin", "onAnimationEnd", "shouldReAnimate", "onAnimationReStart"];
function _objectWithoutProperties$b(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$b(source, excluded);
  var key, i3;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i3 = 0; i3 < sourceSymbolKeys.length; i3++) {
      key = sourceSymbolKeys[i3];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$b(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i3;
  for (i3 = 0; i3 < sourceKeys.length; i3++) {
    key = sourceKeys[i3];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _toConsumableArray$4(arr) {
  return _arrayWithoutHoles$4(arr) || _iterableToArray$4(arr) || _unsupportedIterableToArray$7(arr) || _nonIterableSpread$4();
}
function _nonIterableSpread$4() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$7(o2, minLen) {
  if (!o2) return;
  if (typeof o2 === "string") return _arrayLikeToArray$7(o2, minLen);
  var n2 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n2 === "Object" && o2.constructor) n2 = o2.constructor.name;
  if (n2 === "Map" || n2 === "Set") return Array.from(o2);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray$7(o2, minLen);
}
function _iterableToArray$4(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles$4(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$7(arr);
}
function _arrayLikeToArray$7(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i3 = 0, arr2 = new Array(len); i3 < len; i3++) arr2[i3] = arr[i3];
  return arr2;
}
function ownKeys$m(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e3);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$m(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$m(Object(t3), true).forEach(function(r3) {
      _defineProperty$p(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$m(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
function _defineProperty$p(obj, key, value) {
  key = _toPropertyKey$p(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _classCallCheck$g(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$g(target, props) {
  for (var i3 = 0; i3 < props.length; i3++) {
    var descriptor = props[i3];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$p(descriptor.key), descriptor);
  }
}
function _createClass$g(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$g(Constructor.prototype, protoProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$p(arg) {
  var key = _toPrimitive$p(arg, "string");
  return _typeof$q(key) === "symbol" ? key : String(key);
}
function _toPrimitive$p(input, hint) {
  if (_typeof$q(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint);
    if (_typeof$q(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits$e(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass) _setPrototypeOf$e(subClass, superClass);
}
function _setPrototypeOf$e(o2, p2) {
  _setPrototypeOf$e = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o3, p3) {
    o3.__proto__ = p3;
    return o3;
  };
  return _setPrototypeOf$e(o2, p2);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$e();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$e(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$e(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$e(this, result);
  };
}
function _possibleConstructorReturn$e(self2, call) {
  if (call && (_typeof$q(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$e(self2);
}
function _assertThisInitialized$e(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$e() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e3) {
    return false;
  }
}
function _getPrototypeOf$e(o2) {
  _getPrototypeOf$e = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o3) {
    return o3.__proto__ || Object.getPrototypeOf(o3);
  };
  return _getPrototypeOf$e(o2);
}
var Animate = /* @__PURE__ */ function(_PureComponent) {
  _inherits$e(Animate2, _PureComponent);
  var _super = _createSuper(Animate2);
  function Animate2(props, context) {
    var _this;
    _classCallCheck$g(this, Animate2);
    _this = _super.call(this, props, context);
    var _this$props = _this.props, isActive = _this$props.isActive, attributeName = _this$props.attributeName, from = _this$props.from, to = _this$props.to, steps2 = _this$props.steps, children = _this$props.children, duration = _this$props.duration;
    _this.handleStyleChange = _this.handleStyleChange.bind(_assertThisInitialized$e(_this));
    _this.changeStyle = _this.changeStyle.bind(_assertThisInitialized$e(_this));
    if (!isActive || duration <= 0) {
      _this.state = {
        style: {}
      };
      if (typeof children === "function") {
        _this.state = {
          style: to
        };
      }
      return _possibleConstructorReturn$e(_this);
    }
    if (steps2 && steps2.length) {
      _this.state = {
        style: steps2[0].style
      };
    } else if (from) {
      if (typeof children === "function") {
        _this.state = {
          style: from
        };
        return _possibleConstructorReturn$e(_this);
      }
      _this.state = {
        style: attributeName ? _defineProperty$p({}, attributeName, from) : from
      };
    } else {
      _this.state = {
        style: {}
      };
    }
    return _this;
  }
  _createClass$g(Animate2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props, isActive = _this$props2.isActive, canBegin = _this$props2.canBegin;
      this.mounted = true;
      if (!isActive || !canBegin) {
        return;
      }
      this.runAnimation(this.props);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props3 = this.props, isActive = _this$props3.isActive, canBegin = _this$props3.canBegin, attributeName = _this$props3.attributeName, shouldReAnimate = _this$props3.shouldReAnimate, to = _this$props3.to, currentFrom = _this$props3.from;
      var style = this.state.style;
      if (!canBegin) {
        return;
      }
      if (!isActive) {
        var newState = {
          style: attributeName ? _defineProperty$p({}, attributeName, to) : to
        };
        if (this.state && style) {
          if (attributeName && style[attributeName] !== to || !attributeName && style !== to) {
            this.setState(newState);
          }
        }
        return;
      }
      if (deepEqual(prevProps.to, to) && prevProps.canBegin && prevProps.isActive) {
        return;
      }
      var isTriggered = !prevProps.canBegin || !prevProps.isActive;
      if (this.manager) {
        this.manager.stop();
      }
      if (this.stopJSAnimation) {
        this.stopJSAnimation();
      }
      var from = isTriggered || shouldReAnimate ? currentFrom : prevProps.to;
      if (this.state && style) {
        var _newState = {
          style: attributeName ? _defineProperty$p({}, attributeName, from) : from
        };
        if (attributeName && style[attributeName] !== from || !attributeName && style !== from) {
          this.setState(_newState);
        }
      }
      this.runAnimation(_objectSpread$m(_objectSpread$m({}, this.props), {}, {
        from,
        begin: 0
      }));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
      var onAnimationEnd2 = this.props.onAnimationEnd;
      if (this.unSubscribe) {
        this.unSubscribe();
      }
      if (this.manager) {
        this.manager.stop();
        this.manager = null;
      }
      if (this.stopJSAnimation) {
        this.stopJSAnimation();
      }
      if (onAnimationEnd2) {
        onAnimationEnd2();
      }
    }
  }, {
    key: "handleStyleChange",
    value: function handleStyleChange(style) {
      this.changeStyle(style);
    }
  }, {
    key: "changeStyle",
    value: function changeStyle(style) {
      if (this.mounted) {
        this.setState({
          style
        });
      }
    }
  }, {
    key: "runJSAnimation",
    value: function runJSAnimation(props) {
      var _this2 = this;
      var from = props.from, to = props.to, duration = props.duration, easing = props.easing, begin = props.begin, onAnimationEnd2 = props.onAnimationEnd, onAnimationStart2 = props.onAnimationStart;
      var startAnimation2 = configUpdate(from, to, configEasing(easing), duration, this.changeStyle);
      var finalStartAnimation = function finalStartAnimation2() {
        _this2.stopJSAnimation = startAnimation2();
      };
      this.manager.start([onAnimationStart2, begin, finalStartAnimation, duration, onAnimationEnd2]);
    }
  }, {
    key: "runStepAnimation",
    value: function runStepAnimation(props) {
      var _this3 = this;
      var steps2 = props.steps, begin = props.begin, onAnimationStart2 = props.onAnimationStart;
      var _steps$ = steps2[0], initialStyle = _steps$.style, _steps$$duration = _steps$.duration, initialTime = _steps$$duration === void 0 ? 0 : _steps$$duration;
      var addStyle = function addStyle2(sequence, nextItem, index2) {
        if (index2 === 0) {
          return sequence;
        }
        var duration = nextItem.duration, _nextItem$easing = nextItem.easing, easing = _nextItem$easing === void 0 ? "ease" : _nextItem$easing, style = nextItem.style, nextProperties = nextItem.properties, onAnimationEnd2 = nextItem.onAnimationEnd;
        var preItem = index2 > 0 ? steps2[index2 - 1] : nextItem;
        var properties2 = nextProperties || Object.keys(style);
        if (typeof easing === "function" || easing === "spring") {
          return [].concat(_toConsumableArray$4(sequence), [_this3.runJSAnimation.bind(_this3, {
            from: preItem.style,
            to: style,
            duration,
            easing
          }), duration]);
        }
        var transition = getTransitionVal(properties2, duration, easing);
        var newStyle = _objectSpread$m(_objectSpread$m(_objectSpread$m({}, preItem.style), style), {}, {
          transition
        });
        return [].concat(_toConsumableArray$4(sequence), [newStyle, duration, onAnimationEnd2]).filter(identity2);
      };
      return this.manager.start([onAnimationStart2].concat(_toConsumableArray$4(steps2.reduce(addStyle, [initialStyle, Math.max(initialTime, begin)])), [props.onAnimationEnd]));
    }
  }, {
    key: "runAnimation",
    value: function runAnimation(props) {
      if (!this.manager) {
        this.manager = createAnimateManager();
      }
      var begin = props.begin, duration = props.duration, attributeName = props.attributeName, propsTo = props.to, easing = props.easing, onAnimationStart2 = props.onAnimationStart, onAnimationEnd2 = props.onAnimationEnd, steps2 = props.steps, children = props.children;
      var manager = this.manager;
      this.unSubscribe = manager.subscribe(this.handleStyleChange);
      if (typeof easing === "function" || typeof children === "function" || easing === "spring") {
        this.runJSAnimation(props);
        return;
      }
      if (steps2.length > 1) {
        this.runStepAnimation(props);
        return;
      }
      var to = attributeName ? _defineProperty$p({}, attributeName, propsTo) : propsTo;
      var transition = getTransitionVal(Object.keys(to), duration, easing);
      manager.start([onAnimationStart2, begin, _objectSpread$m(_objectSpread$m({}, to), {}, {
        transition
      }), duration, onAnimationEnd2]);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props, children = _this$props4.children;
      _this$props4.begin;
      var duration = _this$props4.duration;
      _this$props4.attributeName;
      _this$props4.easing;
      var isActive = _this$props4.isActive;
      _this$props4.steps;
      _this$props4.from;
      _this$props4.to;
      _this$props4.canBegin;
      _this$props4.onAnimationEnd;
      _this$props4.shouldReAnimate;
      _this$props4.onAnimationReStart;
      var others = _objectWithoutProperties$b(_this$props4, _excluded$b);
      var count2 = Children.count(children);
      var stateStyle = this.state.style;
      if (typeof children === "function") {
        return children(stateStyle);
      }
      if (!isActive || count2 === 0 || duration <= 0) {
        return children;
      }
      var cloneContainer = function cloneContainer2(container) {
        var _container$props = container.props, _container$props$styl = _container$props.style, style = _container$props$styl === void 0 ? {} : _container$props$styl, className = _container$props.className;
        var res = /* @__PURE__ */ cloneElement(container, _objectSpread$m(_objectSpread$m({}, others), {}, {
          style: _objectSpread$m(_objectSpread$m({}, style), stateStyle),
          className
        }));
        return res;
      };
      if (count2 === 1) {
        return cloneContainer(Children.only(children));
      }
      return /* @__PURE__ */ React__default.createElement("div", null, Children.map(children, function(child) {
        return cloneContainer(child);
      }));
    }
  }]);
  return Animate2;
}(PureComponent);
Animate.displayName = "Animate";
Animate.defaultProps = {
  begin: 0,
  duration: 1e3,
  from: "",
  to: "",
  attributeName: "",
  easing: "ease",
  isActive: true,
  canBegin: true,
  steps: [],
  onAnimationEnd: function onAnimationEnd() {
  },
  onAnimationStart: function onAnimationStart() {
  }
};
Animate.propTypes = {
  from: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  to: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  attributeName: PropTypes.string,
  // animation duration
  duration: PropTypes.number,
  begin: PropTypes.number,
  easing: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  steps: PropTypes.arrayOf(PropTypes.shape({
    duration: PropTypes.number.isRequired,
    style: PropTypes.object.isRequired,
    easing: PropTypes.oneOfType([PropTypes.oneOf(["ease", "ease-in", "ease-out", "ease-in-out", "linear"]), PropTypes.func]),
    // transition css properties(dash case), optional
    properties: PropTypes.arrayOf("string"),
    onAnimationEnd: PropTypes.func
  })),
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  isActive: PropTypes.bool,
  canBegin: PropTypes.bool,
  onAnimationEnd: PropTypes.func,
  // decide if it should reanimate with initial from style when props change
  shouldReAnimate: PropTypes.bool,
  onAnimationStart: PropTypes.func,
  onAnimationReStart: PropTypes.func
};
function _typeof$p(o2) {
  "@babel/helpers - typeof";
  return _typeof$p = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof$p(o2);
}
function _extends$k() {
  _extends$k = Object.assign ? Object.assign.bind() : function(target) {
    for (var i3 = 1; i3 < arguments.length; i3++) {
      var source = arguments[i3];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$k.apply(this, arguments);
}
function _slicedToArray$3(arr, i3) {
  return _arrayWithHoles$3(arr) || _iterableToArrayLimit$3(arr, i3) || _unsupportedIterableToArray$6(arr, i3) || _nonIterableRest$3();
}
function _nonIterableRest$3() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$6(o2, minLen) {
  if (!o2) return;
  if (typeof o2 === "string") return _arrayLikeToArray$6(o2, minLen);
  var n2 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n2 === "Object" && o2.constructor) n2 = o2.constructor.name;
  if (n2 === "Map" || n2 === "Set") return Array.from(o2);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray$6(o2, minLen);
}
function _arrayLikeToArray$6(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i3 = 0, arr2 = new Array(len); i3 < len; i3++) arr2[i3] = arr[i3];
  return arr2;
}
function _iterableToArrayLimit$3(r2, l2) {
  var t3 = null == r2 ? null : "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];
  if (null != t3) {
    var e3, n2, i3, u3, a4 = [], f2 = true, o2 = false;
    try {
      if (i3 = (t3 = t3.call(r2)).next, 0 === l2) ;
      else for (; !(f2 = (e3 = i3.call(t3)).done) && (a4.push(e3.value), a4.length !== l2); f2 = true) ;
    } catch (r3) {
      o2 = true, n2 = r3;
    } finally {
      try {
        if (!f2 && null != t3["return"] && (u3 = t3["return"](), Object(u3) !== u3)) return;
      } finally {
        if (o2) throw n2;
      }
    }
    return a4;
  }
}
function _arrayWithHoles$3(arr) {
  if (Array.isArray(arr)) return arr;
}
function ownKeys$l(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e3);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$l(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$l(Object(t3), true).forEach(function(r3) {
      _defineProperty$o(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$l(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
function _defineProperty$o(obj, key, value) {
  key = _toPropertyKey$o(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$o(t3) {
  var i3 = _toPrimitive$o(t3, "string");
  return "symbol" == _typeof$p(i3) ? i3 : i3 + "";
}
function _toPrimitive$o(t3, r2) {
  if ("object" != _typeof$p(t3) || !t3) return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i3 = e3.call(t3, r2);
    if ("object" != _typeof$p(i3)) return i3;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t3);
}
var getRectanglePath = function getRectanglePath2(x3, y4, width, height, radius) {
  var maxRadius = Math.min(Math.abs(width) / 2, Math.abs(height) / 2);
  var ySign = height >= 0 ? 1 : -1;
  var xSign = width >= 0 ? 1 : -1;
  var clockWise = height >= 0 && width >= 0 || height < 0 && width < 0 ? 1 : 0;
  var path;
  if (maxRadius > 0 && radius instanceof Array) {
    var newRadius = [0, 0, 0, 0];
    for (var i3 = 0, len = 4; i3 < len; i3++) {
      newRadius[i3] = radius[i3] > maxRadius ? maxRadius : radius[i3];
    }
    path = "M".concat(x3, ",").concat(y4 + ySign * newRadius[0]);
    if (newRadius[0] > 0) {
      path += "A ".concat(newRadius[0], ",").concat(newRadius[0], ",0,0,").concat(clockWise, ",").concat(x3 + xSign * newRadius[0], ",").concat(y4);
    }
    path += "L ".concat(x3 + width - xSign * newRadius[1], ",").concat(y4);
    if (newRadius[1] > 0) {
      path += "A ".concat(newRadius[1], ",").concat(newRadius[1], ",0,0,").concat(clockWise, ",\n        ").concat(x3 + width, ",").concat(y4 + ySign * newRadius[1]);
    }
    path += "L ".concat(x3 + width, ",").concat(y4 + height - ySign * newRadius[2]);
    if (newRadius[2] > 0) {
      path += "A ".concat(newRadius[2], ",").concat(newRadius[2], ",0,0,").concat(clockWise, ",\n        ").concat(x3 + width - xSign * newRadius[2], ",").concat(y4 + height);
    }
    path += "L ".concat(x3 + xSign * newRadius[3], ",").concat(y4 + height);
    if (newRadius[3] > 0) {
      path += "A ".concat(newRadius[3], ",").concat(newRadius[3], ",0,0,").concat(clockWise, ",\n        ").concat(x3, ",").concat(y4 + height - ySign * newRadius[3]);
    }
    path += "Z";
  } else if (maxRadius > 0 && radius === +radius && radius > 0) {
    var _newRadius = Math.min(maxRadius, radius);
    path = "M ".concat(x3, ",").concat(y4 + ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x3 + xSign * _newRadius, ",").concat(y4, "\n            L ").concat(x3 + width - xSign * _newRadius, ",").concat(y4, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x3 + width, ",").concat(y4 + ySign * _newRadius, "\n            L ").concat(x3 + width, ",").concat(y4 + height - ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x3 + width - xSign * _newRadius, ",").concat(y4 + height, "\n            L ").concat(x3 + xSign * _newRadius, ",").concat(y4 + height, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x3, ",").concat(y4 + height - ySign * _newRadius, " Z");
  } else {
    path = "M ".concat(x3, ",").concat(y4, " h ").concat(width, " v ").concat(height, " h ").concat(-width, " Z");
  }
  return path;
};
var isInRectangle = function isInRectangle2(point2, rect) {
  if (!point2 || !rect) {
    return false;
  }
  var px2 = point2.x, py = point2.y;
  var x3 = rect.x, y4 = rect.y, width = rect.width, height = rect.height;
  if (Math.abs(width) > 0 && Math.abs(height) > 0) {
    var minX = Math.min(x3, x3 + width);
    var maxX = Math.max(x3, x3 + width);
    var minY = Math.min(y4, y4 + height);
    var maxY = Math.max(y4, y4 + height);
    return px2 >= minX && px2 <= maxX && py >= minY && py <= maxY;
  }
  return false;
};
var defaultProps$2 = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  // The radius of border
  // The radius of four corners when radius is a number
  // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
  radius: 0,
  isAnimationActive: false,
  isUpdateAnimationActive: false,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
};
var Rectangle = function Rectangle2(rectangleProps) {
  var props = _objectSpread$l(_objectSpread$l({}, defaultProps$2), rectangleProps);
  var pathRef = useRef();
  var _useState = useState(-1), _useState2 = _slicedToArray$3(_useState, 2), totalLength = _useState2[0], setTotalLength = _useState2[1];
  useEffect(function() {
    if (pathRef.current && pathRef.current.getTotalLength) {
      try {
        var pathTotalLength = pathRef.current.getTotalLength();
        if (pathTotalLength) {
          setTotalLength(pathTotalLength);
        }
      } catch (err) {
      }
    }
  }, []);
  var x3 = props.x, y4 = props.y, width = props.width, height = props.height, radius = props.radius, className = props.className;
  var animationEasing = props.animationEasing, animationDuration = props.animationDuration, animationBegin = props.animationBegin, isAnimationActive = props.isAnimationActive, isUpdateAnimationActive = props.isUpdateAnimationActive;
  if (x3 !== +x3 || y4 !== +y4 || width !== +width || height !== +height || width === 0 || height === 0) {
    return null;
  }
  var layerClass = clsx("recharts-rectangle", className);
  if (!isUpdateAnimationActive) {
    return /* @__PURE__ */ React__default.createElement("path", _extends$k({}, filterProps(props, true), {
      className: layerClass,
      d: getRectanglePath(x3, y4, width, height, radius)
    }));
  }
  return /* @__PURE__ */ React__default.createElement(Animate, {
    canBegin: totalLength > 0,
    from: {
      width,
      height,
      x: x3,
      y: y4
    },
    to: {
      width,
      height,
      x: x3,
      y: y4
    },
    duration: animationDuration,
    animationEasing,
    isActive: isUpdateAnimationActive
  }, function(_ref) {
    var currWidth = _ref.width, currHeight = _ref.height, currX = _ref.x, currY = _ref.y;
    return /* @__PURE__ */ React__default.createElement(Animate, {
      canBegin: totalLength > 0,
      from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
      to: "".concat(totalLength, "px 0px"),
      attributeName: "strokeDasharray",
      begin: animationBegin,
      duration: animationDuration,
      isActive: isAnimationActive,
      easing: animationEasing
    }, /* @__PURE__ */ React__default.createElement("path", _extends$k({}, filterProps(props, true), {
      className: layerClass,
      d: getRectanglePath(currX, currY, currWidth, currHeight, radius),
      ref: pathRef
    })));
  });
};
var _excluded$a = ["points", "className", "baseLinePoints", "connectNulls"];
function _extends$j() {
  _extends$j = Object.assign ? Object.assign.bind() : function(target) {
    for (var i3 = 1; i3 < arguments.length; i3++) {
      var source = arguments[i3];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$j.apply(this, arguments);
}
function _objectWithoutProperties$a(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$a(source, excluded);
  var key, i3;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i3 = 0; i3 < sourceSymbolKeys.length; i3++) {
      key = sourceSymbolKeys[i3];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$a(source, excluded) {
  if (source == null) return {};
  var target = {};
  for (var key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _toConsumableArray$3(arr) {
  return _arrayWithoutHoles$3(arr) || _iterableToArray$3(arr) || _unsupportedIterableToArray$5(arr) || _nonIterableSpread$3();
}
function _nonIterableSpread$3() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$5(o2, minLen) {
  if (!o2) return;
  if (typeof o2 === "string") return _arrayLikeToArray$5(o2, minLen);
  var n2 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n2 === "Object" && o2.constructor) n2 = o2.constructor.name;
  if (n2 === "Map" || n2 === "Set") return Array.from(o2);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray$5(o2, minLen);
}
function _iterableToArray$3(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles$3(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$5(arr);
}
function _arrayLikeToArray$5(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i3 = 0, arr2 = new Array(len); i3 < len; i3++) arr2[i3] = arr[i3];
  return arr2;
}
var isValidatePoint = function isValidatePoint2(point2) {
  return point2 && point2.x === +point2.x && point2.y === +point2.y;
};
var getParsedPoints = function getParsedPoints2() {
  var points = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  var segmentPoints = [[]];
  points.forEach(function(entry) {
    if (isValidatePoint(entry)) {
      segmentPoints[segmentPoints.length - 1].push(entry);
    } else if (segmentPoints[segmentPoints.length - 1].length > 0) {
      segmentPoints.push([]);
    }
  });
  if (isValidatePoint(points[0])) {
    segmentPoints[segmentPoints.length - 1].push(points[0]);
  }
  if (segmentPoints[segmentPoints.length - 1].length <= 0) {
    segmentPoints = segmentPoints.slice(0, -1);
  }
  return segmentPoints;
};
var getSinglePolygonPath = function getSinglePolygonPath2(points, connectNulls) {
  var segmentPoints = getParsedPoints(points);
  if (connectNulls) {
    segmentPoints = [segmentPoints.reduce(function(res, segPoints) {
      return [].concat(_toConsumableArray$3(res), _toConsumableArray$3(segPoints));
    }, [])];
  }
  var polygonPath = segmentPoints.map(function(segPoints) {
    return segPoints.reduce(function(path, point2, index2) {
      return "".concat(path).concat(index2 === 0 ? "M" : "L").concat(point2.x, ",").concat(point2.y);
    }, "");
  }).join("");
  return segmentPoints.length === 1 ? "".concat(polygonPath, "Z") : polygonPath;
};
var getRanglePath = function getRanglePath2(points, baseLinePoints, connectNulls) {
  var outerPath = getSinglePolygonPath(points, connectNulls);
  return "".concat(outerPath.slice(-1) === "Z" ? outerPath.slice(0, -1) : outerPath, "L").concat(getSinglePolygonPath(baseLinePoints.reverse(), connectNulls).slice(1));
};
var Polygon = function Polygon2(props) {
  var points = props.points, className = props.className, baseLinePoints = props.baseLinePoints, connectNulls = props.connectNulls, others = _objectWithoutProperties$a(props, _excluded$a);
  if (!points || !points.length) {
    return null;
  }
  var layerClass = clsx("recharts-polygon", className);
  if (baseLinePoints && baseLinePoints.length) {
    var hasStroke = others.stroke && others.stroke !== "none";
    var rangePath = getRanglePath(points, baseLinePoints, connectNulls);
    return /* @__PURE__ */ React__default.createElement("g", {
      className: layerClass
    }, /* @__PURE__ */ React__default.createElement("path", _extends$j({}, filterProps(others, true), {
      fill: rangePath.slice(-1) === "Z" ? others.fill : "none",
      stroke: "none",
      d: rangePath
    })), hasStroke ? /* @__PURE__ */ React__default.createElement("path", _extends$j({}, filterProps(others, true), {
      fill: "none",
      d: getSinglePolygonPath(points, connectNulls)
    })) : null, hasStroke ? /* @__PURE__ */ React__default.createElement("path", _extends$j({}, filterProps(others, true), {
      fill: "none",
      d: getSinglePolygonPath(baseLinePoints, connectNulls)
    })) : null);
  }
  var singlePath = getSinglePolygonPath(points, connectNulls);
  return /* @__PURE__ */ React__default.createElement("path", _extends$j({}, filterProps(others, true), {
    fill: singlePath.slice(-1) === "Z" ? others.fill : "none",
    className: layerClass,
    d: singlePath
  }));
};
function _extends$i() {
  _extends$i = Object.assign ? Object.assign.bind() : function(target) {
    for (var i3 = 1; i3 < arguments.length; i3++) {
      var source = arguments[i3];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$i.apply(this, arguments);
}
var Dot = function Dot2(props) {
  var cx = props.cx, cy = props.cy, r2 = props.r, className = props.className;
  var layerClass = clsx("recharts-dot", className);
  if (cx === +cx && cy === +cy && r2 === +r2) {
    return /* @__PURE__ */ React__default.createElement("circle", _extends$i({}, filterProps(props, false), adaptEventHandlers(props), {
      className: layerClass,
      cx,
      cy,
      r: r2
    }));
  }
  return null;
};
function _typeof$o(o2) {
  "@babel/helpers - typeof";
  return _typeof$o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof$o(o2);
}
var _excluded$9 = ["x", "y", "top", "left", "width", "height", "className"];
function _extends$h() {
  _extends$h = Object.assign ? Object.assign.bind() : function(target) {
    for (var i3 = 1; i3 < arguments.length; i3++) {
      var source = arguments[i3];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$h.apply(this, arguments);
}
function ownKeys$k(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e3);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$k(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$k(Object(t3), true).forEach(function(r3) {
      _defineProperty$n(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$k(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
function _defineProperty$n(obj, key, value) {
  key = _toPropertyKey$n(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$n(t3) {
  var i3 = _toPrimitive$n(t3, "string");
  return "symbol" == _typeof$o(i3) ? i3 : i3 + "";
}
function _toPrimitive$n(t3, r2) {
  if ("object" != _typeof$o(t3) || !t3) return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i3 = e3.call(t3, r2);
    if ("object" != _typeof$o(i3)) return i3;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t3);
}
function _objectWithoutProperties$9(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$9(source, excluded);
  var key, i3;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i3 = 0; i3 < sourceSymbolKeys.length; i3++) {
      key = sourceSymbolKeys[i3];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$9(source, excluded) {
  if (source == null) return {};
  var target = {};
  for (var key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
  }
  return target;
}
var getPath2 = function getPath3(x3, y4, width, height, top, left) {
  return "M".concat(x3, ",").concat(top, "v").concat(height, "M").concat(left, ",").concat(y4, "h").concat(width);
};
var Cross = function Cross2(_ref) {
  var _ref$x = _ref.x, x3 = _ref$x === void 0 ? 0 : _ref$x, _ref$y = _ref.y, y4 = _ref$y === void 0 ? 0 : _ref$y, _ref$top = _ref.top, top = _ref$top === void 0 ? 0 : _ref$top, _ref$left = _ref.left, left = _ref$left === void 0 ? 0 : _ref$left, _ref$width = _ref.width, width = _ref$width === void 0 ? 0 : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? 0 : _ref$height, className = _ref.className, rest = _objectWithoutProperties$9(_ref, _excluded$9);
  var props = _objectSpread$k({
    x: x3,
    y: y4,
    top,
    left,
    width,
    height
  }, rest);
  if (!isNumber(x3) || !isNumber(y4) || !isNumber(width) || !isNumber(height) || !isNumber(top) || !isNumber(left)) {
    return null;
  }
  return /* @__PURE__ */ React__default.createElement("path", _extends$h({}, filterProps(props, true), {
    className: clsx("recharts-cross", className),
    d: getPath2(x3, y4, width, height, top, left)
  }));
};
var maxBy_1;
var hasRequiredMaxBy;
function requireMaxBy() {
  if (hasRequiredMaxBy) return maxBy_1;
  hasRequiredMaxBy = 1;
  var baseExtremum = require_baseExtremum(), baseGt = require_baseGt(), baseIteratee = require_baseIteratee();
  function maxBy2(array2, iteratee) {
    return array2 && array2.length ? baseExtremum(array2, baseIteratee(iteratee, 2), baseGt) : void 0;
  }
  maxBy_1 = maxBy2;
  return maxBy_1;
}
var maxByExports = requireMaxBy();
const maxBy = /* @__PURE__ */ getDefaultExportFromCjs(maxByExports);
var minBy_1;
var hasRequiredMinBy;
function requireMinBy() {
  if (hasRequiredMinBy) return minBy_1;
  hasRequiredMinBy = 1;
  var baseExtremum = require_baseExtremum(), baseIteratee = require_baseIteratee(), baseLt = require_baseLt();
  function minBy2(array2, iteratee) {
    return array2 && array2.length ? baseExtremum(array2, baseIteratee(iteratee, 2), baseLt) : void 0;
  }
  minBy_1 = minBy2;
  return minBy_1;
}
var minByExports = requireMinBy();
const minBy = /* @__PURE__ */ getDefaultExportFromCjs(minByExports);
var _excluded$8 = ["cx", "cy", "angle", "ticks", "axisLine"], _excluded2$5 = ["ticks", "tick", "angle", "tickFormatter", "stroke"];
function _typeof$n(o2) {
  "@babel/helpers - typeof";
  return _typeof$n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof$n(o2);
}
function _extends$g() {
  _extends$g = Object.assign ? Object.assign.bind() : function(target) {
    for (var i3 = 1; i3 < arguments.length; i3++) {
      var source = arguments[i3];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$g.apply(this, arguments);
}
function ownKeys$j(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e3);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$j(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$j(Object(t3), true).forEach(function(r3) {
      _defineProperty$m(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$j(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
function _objectWithoutProperties$8(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$8(source, excluded);
  var key, i3;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i3 = 0; i3 < sourceSymbolKeys.length; i3++) {
      key = sourceSymbolKeys[i3];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$8(source, excluded) {
  if (source == null) return {};
  var target = {};
  for (var key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _classCallCheck$f(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$f(target, props) {
  for (var i3 = 0; i3 < props.length; i3++) {
    var descriptor = props[i3];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$m(descriptor.key), descriptor);
  }
}
function _createClass$f(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$f(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$f(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _callSuper$d(t3, o2, e3) {
  return o2 = _getPrototypeOf$d(o2), _possibleConstructorReturn$d(t3, _isNativeReflectConstruct$d() ? Reflect.construct(o2, e3 || [], _getPrototypeOf$d(t3).constructor) : o2.apply(t3, e3));
}
function _possibleConstructorReturn$d(self2, call) {
  if (call && (_typeof$n(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$d(self2);
}
function _assertThisInitialized$d(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$d() {
  try {
    var t3 = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$d = function _isNativeReflectConstruct2() {
    return !!t3;
  })();
}
function _getPrototypeOf$d(o2) {
  _getPrototypeOf$d = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o3) {
    return o3.__proto__ || Object.getPrototypeOf(o3);
  };
  return _getPrototypeOf$d(o2);
}
function _inherits$d(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass) _setPrototypeOf$d(subClass, superClass);
}
function _setPrototypeOf$d(o2, p2) {
  _setPrototypeOf$d = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o3, p3) {
    o3.__proto__ = p3;
    return o3;
  };
  return _setPrototypeOf$d(o2, p2);
}
function _defineProperty$m(obj, key, value) {
  key = _toPropertyKey$m(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$m(t3) {
  var i3 = _toPrimitive$m(t3, "string");
  return "symbol" == _typeof$n(i3) ? i3 : i3 + "";
}
function _toPrimitive$m(t3, r2) {
  if ("object" != _typeof$n(t3) || !t3) return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i3 = e3.call(t3, r2);
    if ("object" != _typeof$n(i3)) return i3;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t3);
}
var PolarRadiusAxis = /* @__PURE__ */ function(_PureComponent) {
  function PolarRadiusAxis2() {
    _classCallCheck$f(this, PolarRadiusAxis2);
    return _callSuper$d(this, PolarRadiusAxis2, arguments);
  }
  _inherits$d(PolarRadiusAxis2, _PureComponent);
  return _createClass$f(PolarRadiusAxis2, [{
    key: "getTickValueCoord",
    value: (
      /**
       * Calculate the coordinate of tick
       * @param  {Number} coordinate The radius of tick
       * @return {Object} (x, y)
       */
      function getTickValueCoord(_ref) {
        var coordinate = _ref.coordinate;
        var _this$props = this.props, angle = _this$props.angle, cx = _this$props.cx, cy = _this$props.cy;
        return polarToCartesian(cx, cy, coordinate, angle);
      }
    )
  }, {
    key: "getTickTextAnchor",
    value: function getTickTextAnchor() {
      var orientation = this.props.orientation;
      var textAnchor;
      switch (orientation) {
        case "left":
          textAnchor = "end";
          break;
        case "right":
          textAnchor = "start";
          break;
        default:
          textAnchor = "middle";
          break;
      }
      return textAnchor;
    }
  }, {
    key: "getViewBox",
    value: function getViewBox() {
      var _this$props2 = this.props, cx = _this$props2.cx, cy = _this$props2.cy, angle = _this$props2.angle, ticks2 = _this$props2.ticks;
      var maxRadiusTick = maxBy(ticks2, function(entry) {
        return entry.coordinate || 0;
      });
      var minRadiusTick = minBy(ticks2, function(entry) {
        return entry.coordinate || 0;
      });
      return {
        cx,
        cy,
        startAngle: angle,
        endAngle: angle,
        innerRadius: minRadiusTick.coordinate || 0,
        outerRadius: maxRadiusTick.coordinate || 0
      };
    }
  }, {
    key: "renderAxisLine",
    value: function renderAxisLine() {
      var _this$props3 = this.props, cx = _this$props3.cx, cy = _this$props3.cy, angle = _this$props3.angle, ticks2 = _this$props3.ticks, axisLine = _this$props3.axisLine, others = _objectWithoutProperties$8(_this$props3, _excluded$8);
      var extent2 = ticks2.reduce(function(result, entry) {
        return [Math.min(result[0], entry.coordinate), Math.max(result[1], entry.coordinate)];
      }, [Infinity, -Infinity]);
      var point0 = polarToCartesian(cx, cy, extent2[0], angle);
      var point1 = polarToCartesian(cx, cy, extent2[1], angle);
      var props = _objectSpread$j(_objectSpread$j(_objectSpread$j({}, filterProps(others, false)), {}, {
        fill: "none"
      }, filterProps(axisLine, false)), {}, {
        x1: point0.x,
        y1: point0.y,
        x2: point1.x,
        y2: point1.y
      });
      return /* @__PURE__ */ React__default.createElement("line", _extends$g({
        className: "recharts-polar-radius-axis-line"
      }, props));
    }
  }, {
    key: "renderTicks",
    value: function renderTicks() {
      var _this = this;
      var _this$props4 = this.props, ticks2 = _this$props4.ticks, tick = _this$props4.tick, angle = _this$props4.angle, tickFormatter = _this$props4.tickFormatter, stroke = _this$props4.stroke, others = _objectWithoutProperties$8(_this$props4, _excluded2$5);
      var textAnchor = this.getTickTextAnchor();
      var axisProps = filterProps(others, false);
      var customTickProps = filterProps(tick, false);
      var items = ticks2.map(function(entry, i3) {
        var coord = _this.getTickValueCoord(entry);
        var tickProps = _objectSpread$j(_objectSpread$j(_objectSpread$j(_objectSpread$j({
          textAnchor,
          transform: "rotate(".concat(90 - angle, ", ").concat(coord.x, ", ").concat(coord.y, ")")
        }, axisProps), {}, {
          stroke: "none",
          fill: stroke
        }, customTickProps), {}, {
          index: i3
        }, coord), {}, {
          payload: entry
        });
        return /* @__PURE__ */ React__default.createElement(Layer, _extends$g({
          className: clsx("recharts-polar-radius-axis-tick", getTickClassName(tick)),
          key: "tick-".concat(entry.coordinate)
        }, adaptEventsOfChild(_this.props, entry, i3)), PolarRadiusAxis2.renderTickItem(tick, tickProps, tickFormatter ? tickFormatter(entry.value, i3) : entry.value));
      });
      return /* @__PURE__ */ React__default.createElement(Layer, {
        className: "recharts-polar-radius-axis-ticks"
      }, items);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props, ticks2 = _this$props5.ticks, axisLine = _this$props5.axisLine, tick = _this$props5.tick;
      if (!ticks2 || !ticks2.length) {
        return null;
      }
      return /* @__PURE__ */ React__default.createElement(Layer, {
        className: clsx("recharts-polar-radius-axis", this.props.className)
      }, axisLine && this.renderAxisLine(), tick && this.renderTicks(), Label$1.renderCallByParent(this.props, this.getViewBox()));
    }
  }], [{
    key: "renderTickItem",
    value: function renderTickItem(option, props, value) {
      var tickItem;
      if (/* @__PURE__ */ React__default.isValidElement(option)) {
        tickItem = /* @__PURE__ */ React__default.cloneElement(option, props);
      } else if (isFunction(option)) {
        tickItem = option(props);
      } else {
        tickItem = /* @__PURE__ */ React__default.createElement(Text, _extends$g({}, props, {
          className: "recharts-polar-radius-axis-tick-value"
        }), value);
      }
      return tickItem;
    }
  }]);
}(PureComponent);
_defineProperty$m(PolarRadiusAxis, "displayName", "PolarRadiusAxis");
_defineProperty$m(PolarRadiusAxis, "axisType", "radiusAxis");
_defineProperty$m(PolarRadiusAxis, "defaultProps", {
  type: "number",
  radiusAxisId: 0,
  cx: 0,
  cy: 0,
  angle: 0,
  orientation: "right",
  stroke: "#ccc",
  axisLine: true,
  tick: true,
  tickCount: 5,
  allowDataOverflow: false,
  scale: "auto",
  allowDuplicatedCategory: true
});
function _typeof$m(o2) {
  "@babel/helpers - typeof";
  return _typeof$m = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof$m(o2);
}
function _extends$f() {
  _extends$f = Object.assign ? Object.assign.bind() : function(target) {
    for (var i3 = 1; i3 < arguments.length; i3++) {
      var source = arguments[i3];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$f.apply(this, arguments);
}
function ownKeys$i(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e3);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$i(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$i(Object(t3), true).forEach(function(r3) {
      _defineProperty$l(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$i(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
function _classCallCheck$e(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$e(target, props) {
  for (var i3 = 0; i3 < props.length; i3++) {
    var descriptor = props[i3];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$l(descriptor.key), descriptor);
  }
}
function _createClass$e(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$e(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$e(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _callSuper$c(t3, o2, e3) {
  return o2 = _getPrototypeOf$c(o2), _possibleConstructorReturn$c(t3, _isNativeReflectConstruct$c() ? Reflect.construct(o2, e3 || [], _getPrototypeOf$c(t3).constructor) : o2.apply(t3, e3));
}
function _possibleConstructorReturn$c(self2, call) {
  if (call && (_typeof$m(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$c(self2);
}
function _assertThisInitialized$c(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$c() {
  try {
    var t3 = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$c = function _isNativeReflectConstruct2() {
    return !!t3;
  })();
}
function _getPrototypeOf$c(o2) {
  _getPrototypeOf$c = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o3) {
    return o3.__proto__ || Object.getPrototypeOf(o3);
  };
  return _getPrototypeOf$c(o2);
}
function _inherits$c(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass) _setPrototypeOf$c(subClass, superClass);
}
function _setPrototypeOf$c(o2, p2) {
  _setPrototypeOf$c = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o3, p3) {
    o3.__proto__ = p3;
    return o3;
  };
  return _setPrototypeOf$c(o2, p2);
}
function _defineProperty$l(obj, key, value) {
  key = _toPropertyKey$l(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$l(t3) {
  var i3 = _toPrimitive$l(t3, "string");
  return "symbol" == _typeof$m(i3) ? i3 : i3 + "";
}
function _toPrimitive$l(t3, r2) {
  if ("object" != _typeof$m(t3) || !t3) return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i3 = e3.call(t3, r2);
    if ("object" != _typeof$m(i3)) return i3;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t3);
}
var RADIAN$1 = Math.PI / 180;
var eps = 1e-5;
var PolarAngleAxis = /* @__PURE__ */ function(_PureComponent) {
  function PolarAngleAxis2() {
    _classCallCheck$e(this, PolarAngleAxis2);
    return _callSuper$c(this, PolarAngleAxis2, arguments);
  }
  _inherits$c(PolarAngleAxis2, _PureComponent);
  return _createClass$e(PolarAngleAxis2, [{
    key: "getTickLineCoord",
    value: (
      /**
       * Calculate the coordinate of line endpoint
       * @param  {Object} data The Data if ticks
       * @return {Object} (x0, y0): The start point of text,
       *                  (x1, y1): The end point close to text,
       *                  (x2, y2): The end point close to axis
       */
      function getTickLineCoord(data) {
        var _this$props = this.props, cx = _this$props.cx, cy = _this$props.cy, radius = _this$props.radius, orientation = _this$props.orientation, tickSize = _this$props.tickSize;
        var tickLineSize = tickSize || 8;
        var p1 = polarToCartesian(cx, cy, radius, data.coordinate);
        var p2 = polarToCartesian(cx, cy, radius + (orientation === "inner" ? -1 : 1) * tickLineSize, data.coordinate);
        return {
          x1: p1.x,
          y1: p1.y,
          x2: p2.x,
          y2: p2.y
        };
      }
    )
    /**
     * Get the text-anchor of each tick
     * @param  {Object} data Data of ticks
     * @return {String} text-anchor
     */
  }, {
    key: "getTickTextAnchor",
    value: function getTickTextAnchor(data) {
      var orientation = this.props.orientation;
      var cos2 = Math.cos(-data.coordinate * RADIAN$1);
      var textAnchor;
      if (cos2 > eps) {
        textAnchor = orientation === "outer" ? "start" : "end";
      } else if (cos2 < -1e-5) {
        textAnchor = orientation === "outer" ? "end" : "start";
      } else {
        textAnchor = "middle";
      }
      return textAnchor;
    }
  }, {
    key: "renderAxisLine",
    value: function renderAxisLine() {
      var _this$props2 = this.props, cx = _this$props2.cx, cy = _this$props2.cy, radius = _this$props2.radius, axisLine = _this$props2.axisLine, axisLineType = _this$props2.axisLineType;
      var props = _objectSpread$i(_objectSpread$i({}, filterProps(this.props, false)), {}, {
        fill: "none"
      }, filterProps(axisLine, false));
      if (axisLineType === "circle") {
        return /* @__PURE__ */ React__default.createElement(Dot, _extends$f({
          className: "recharts-polar-angle-axis-line"
        }, props, {
          cx,
          cy,
          r: radius
        }));
      }
      var ticks2 = this.props.ticks;
      var points = ticks2.map(function(entry) {
        return polarToCartesian(cx, cy, radius, entry.coordinate);
      });
      return /* @__PURE__ */ React__default.createElement(Polygon, _extends$f({
        className: "recharts-polar-angle-axis-line"
      }, props, {
        points
      }));
    }
  }, {
    key: "renderTicks",
    value: function renderTicks() {
      var _this = this;
      var _this$props3 = this.props, ticks2 = _this$props3.ticks, tick = _this$props3.tick, tickLine = _this$props3.tickLine, tickFormatter = _this$props3.tickFormatter, stroke = _this$props3.stroke;
      var axisProps = filterProps(this.props, false);
      var customTickProps = filterProps(tick, false);
      var tickLineProps = _objectSpread$i(_objectSpread$i({}, axisProps), {}, {
        fill: "none"
      }, filterProps(tickLine, false));
      var items = ticks2.map(function(entry, i3) {
        var lineCoord = _this.getTickLineCoord(entry);
        var textAnchor = _this.getTickTextAnchor(entry);
        var tickProps = _objectSpread$i(_objectSpread$i(_objectSpread$i({
          textAnchor
        }, axisProps), {}, {
          stroke: "none",
          fill: stroke
        }, customTickProps), {}, {
          index: i3,
          payload: entry,
          x: lineCoord.x2,
          y: lineCoord.y2
        });
        return /* @__PURE__ */ React__default.createElement(Layer, _extends$f({
          className: clsx("recharts-polar-angle-axis-tick", getTickClassName(tick)),
          key: "tick-".concat(entry.coordinate)
        }, adaptEventsOfChild(_this.props, entry, i3)), tickLine && /* @__PURE__ */ React__default.createElement("line", _extends$f({
          className: "recharts-polar-angle-axis-tick-line"
        }, tickLineProps, lineCoord)), tick && PolarAngleAxis2.renderTickItem(tick, tickProps, tickFormatter ? tickFormatter(entry.value, i3) : entry.value));
      });
      return /* @__PURE__ */ React__default.createElement(Layer, {
        className: "recharts-polar-angle-axis-ticks"
      }, items);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props, ticks2 = _this$props4.ticks, radius = _this$props4.radius, axisLine = _this$props4.axisLine;
      if (radius <= 0 || !ticks2 || !ticks2.length) {
        return null;
      }
      return /* @__PURE__ */ React__default.createElement(Layer, {
        className: clsx("recharts-polar-angle-axis", this.props.className)
      }, axisLine && this.renderAxisLine(), this.renderTicks());
    }
  }], [{
    key: "renderTickItem",
    value: function renderTickItem(option, props, value) {
      var tickItem;
      if (/* @__PURE__ */ React__default.isValidElement(option)) {
        tickItem = /* @__PURE__ */ React__default.cloneElement(option, props);
      } else if (isFunction(option)) {
        tickItem = option(props);
      } else {
        tickItem = /* @__PURE__ */ React__default.createElement(Text, _extends$f({}, props, {
          className: "recharts-polar-angle-axis-tick-value"
        }), value);
      }
      return tickItem;
    }
  }]);
}(PureComponent);
_defineProperty$l(PolarAngleAxis, "displayName", "PolarAngleAxis");
_defineProperty$l(PolarAngleAxis, "axisType", "angleAxis");
_defineProperty$l(PolarAngleAxis, "defaultProps", {
  type: "category",
  angleAxisId: 0,
  scale: "auto",
  cx: 0,
  cy: 0,
  orientation: "outer",
  axisLine: true,
  tickLine: true,
  tickSize: 8,
  tick: true,
  hide: false,
  allowDuplicatedCategory: true
});
var isPlainObjectExports = requireIsPlainObject();
const isPlainObject = /* @__PURE__ */ getDefaultExportFromCjs(isPlainObjectExports);
var isBoolean_1;
var hasRequiredIsBoolean;
function requireIsBoolean() {
  if (hasRequiredIsBoolean) return isBoolean_1;
  hasRequiredIsBoolean = 1;
  var baseGetTag = require_baseGetTag(), isObjectLike = requireIsObjectLike();
  var boolTag = "[object Boolean]";
  function isBoolean2(value) {
    return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
  }
  isBoolean_1 = isBoolean2;
  return isBoolean_1;
}
var isBooleanExports = requireIsBoolean();
const isBoolean = /* @__PURE__ */ getDefaultExportFromCjs(isBooleanExports);
function _typeof$l(o2) {
  "@babel/helpers - typeof";
  return _typeof$l = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof$l(o2);
}
function _extends$e() {
  _extends$e = Object.assign ? Object.assign.bind() : function(target) {
    for (var i3 = 1; i3 < arguments.length; i3++) {
      var source = arguments[i3];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$e.apply(this, arguments);
}
function _slicedToArray$2(arr, i3) {
  return _arrayWithHoles$2(arr) || _iterableToArrayLimit$2(arr, i3) || _unsupportedIterableToArray$4(arr, i3) || _nonIterableRest$2();
}
function _nonIterableRest$2() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$4(o2, minLen) {
  if (!o2) return;
  if (typeof o2 === "string") return _arrayLikeToArray$4(o2, minLen);
  var n2 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n2 === "Object" && o2.constructor) n2 = o2.constructor.name;
  if (n2 === "Map" || n2 === "Set") return Array.from(o2);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray$4(o2, minLen);
}
function _arrayLikeToArray$4(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i3 = 0, arr2 = new Array(len); i3 < len; i3++) arr2[i3] = arr[i3];
  return arr2;
}
function _iterableToArrayLimit$2(r2, l2) {
  var t3 = null == r2 ? null : "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];
  if (null != t3) {
    var e3, n2, i3, u3, a4 = [], f2 = true, o2 = false;
    try {
      if (i3 = (t3 = t3.call(r2)).next, 0 === l2) ;
      else for (; !(f2 = (e3 = i3.call(t3)).done) && (a4.push(e3.value), a4.length !== l2); f2 = true) ;
    } catch (r3) {
      o2 = true, n2 = r3;
    } finally {
      try {
        if (!f2 && null != t3["return"] && (u3 = t3["return"](), Object(u3) !== u3)) return;
      } finally {
        if (o2) throw n2;
      }
    }
    return a4;
  }
}
function _arrayWithHoles$2(arr) {
  if (Array.isArray(arr)) return arr;
}
function ownKeys$h(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e3);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$h(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$h(Object(t3), true).forEach(function(r3) {
      _defineProperty$k(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$h(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
function _defineProperty$k(obj, key, value) {
  key = _toPropertyKey$k(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$k(t3) {
  var i3 = _toPrimitive$k(t3, "string");
  return "symbol" == _typeof$l(i3) ? i3 : i3 + "";
}
function _toPrimitive$k(t3, r2) {
  if ("object" != _typeof$l(t3) || !t3) return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i3 = e3.call(t3, r2);
    if ("object" != _typeof$l(i3)) return i3;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t3);
}
var getTrapezoidPath = function getTrapezoidPath2(x3, y4, upperWidth, lowerWidth, height) {
  var widthGap = upperWidth - lowerWidth;
  var path;
  path = "M ".concat(x3, ",").concat(y4);
  path += "L ".concat(x3 + upperWidth, ",").concat(y4);
  path += "L ".concat(x3 + upperWidth - widthGap / 2, ",").concat(y4 + height);
  path += "L ".concat(x3 + upperWidth - widthGap / 2 - lowerWidth, ",").concat(y4 + height);
  path += "L ".concat(x3, ",").concat(y4, " Z");
  return path;
};
var defaultProps$1 = {
  x: 0,
  y: 0,
  upperWidth: 0,
  lowerWidth: 0,
  height: 0,
  isUpdateAnimationActive: false,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
};
var Trapezoid = function Trapezoid2(props) {
  var trapezoidProps = _objectSpread$h(_objectSpread$h({}, defaultProps$1), props);
  var pathRef = useRef();
  var _useState = useState(-1), _useState2 = _slicedToArray$2(_useState, 2), totalLength = _useState2[0], setTotalLength = _useState2[1];
  useEffect(function() {
    if (pathRef.current && pathRef.current.getTotalLength) {
      try {
        var pathTotalLength = pathRef.current.getTotalLength();
        if (pathTotalLength) {
          setTotalLength(pathTotalLength);
        }
      } catch (err) {
      }
    }
  }, []);
  var x3 = trapezoidProps.x, y4 = trapezoidProps.y, upperWidth = trapezoidProps.upperWidth, lowerWidth = trapezoidProps.lowerWidth, height = trapezoidProps.height, className = trapezoidProps.className;
  var animationEasing = trapezoidProps.animationEasing, animationDuration = trapezoidProps.animationDuration, animationBegin = trapezoidProps.animationBegin, isUpdateAnimationActive = trapezoidProps.isUpdateAnimationActive;
  if (x3 !== +x3 || y4 !== +y4 || upperWidth !== +upperWidth || lowerWidth !== +lowerWidth || height !== +height || upperWidth === 0 && lowerWidth === 0 || height === 0) {
    return null;
  }
  var layerClass = clsx("recharts-trapezoid", className);
  if (!isUpdateAnimationActive) {
    return /* @__PURE__ */ React__default.createElement("g", null, /* @__PURE__ */ React__default.createElement("path", _extends$e({}, filterProps(trapezoidProps, true), {
      className: layerClass,
      d: getTrapezoidPath(x3, y4, upperWidth, lowerWidth, height)
    })));
  }
  return /* @__PURE__ */ React__default.createElement(Animate, {
    canBegin: totalLength > 0,
    from: {
      upperWidth: 0,
      lowerWidth: 0,
      height,
      x: x3,
      y: y4
    },
    to: {
      upperWidth,
      lowerWidth,
      height,
      x: x3,
      y: y4
    },
    duration: animationDuration,
    animationEasing,
    isActive: isUpdateAnimationActive
  }, function(_ref) {
    var currUpperWidth = _ref.upperWidth, currLowerWidth = _ref.lowerWidth, currHeight = _ref.height, currX = _ref.x, currY = _ref.y;
    return /* @__PURE__ */ React__default.createElement(Animate, {
      canBegin: totalLength > 0,
      from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
      to: "".concat(totalLength, "px 0px"),
      attributeName: "strokeDasharray",
      begin: animationBegin,
      duration: animationDuration,
      easing: animationEasing
    }, /* @__PURE__ */ React__default.createElement("path", _extends$e({}, filterProps(trapezoidProps, true), {
      className: layerClass,
      d: getTrapezoidPath(currX, currY, currUpperWidth, currLowerWidth, currHeight),
      ref: pathRef
    })));
  });
};
var _excluded$7 = ["option", "shapeType", "propTransformer", "activeClassName", "isActive"];
function _typeof$k(o2) {
  "@babel/helpers - typeof";
  return _typeof$k = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof$k(o2);
}
function _objectWithoutProperties$7(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$7(source, excluded);
  var key, i3;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i3 = 0; i3 < sourceSymbolKeys.length; i3++) {
      key = sourceSymbolKeys[i3];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$7(source, excluded) {
  if (source == null) return {};
  var target = {};
  for (var key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function ownKeys$g(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e3);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$g(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$g(Object(t3), true).forEach(function(r3) {
      _defineProperty$j(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$g(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
function _defineProperty$j(obj, key, value) {
  key = _toPropertyKey$j(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$j(t3) {
  var i3 = _toPrimitive$j(t3, "string");
  return "symbol" == _typeof$k(i3) ? i3 : i3 + "";
}
function _toPrimitive$j(t3, r2) {
  if ("object" != _typeof$k(t3) || !t3) return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i3 = e3.call(t3, r2);
    if ("object" != _typeof$k(i3)) return i3;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t3);
}
function defaultPropTransformer(option, props) {
  return _objectSpread$g(_objectSpread$g({}, props), option);
}
function isSymbolsProps(shapeType, _elementProps) {
  return shapeType === "symbols";
}
function ShapeSelector(_ref) {
  var shapeType = _ref.shapeType, elementProps = _ref.elementProps;
  switch (shapeType) {
    case "rectangle":
      return /* @__PURE__ */ React__default.createElement(Rectangle, elementProps);
    case "trapezoid":
      return /* @__PURE__ */ React__default.createElement(Trapezoid, elementProps);
    case "sector":
      return /* @__PURE__ */ React__default.createElement(Sector, elementProps);
    case "symbols":
      if (isSymbolsProps(shapeType)) {
        return /* @__PURE__ */ React__default.createElement(Symbols, elementProps);
      }
      break;
    default:
      return null;
  }
}
function getPropsFromShapeOption(option) {
  if (/* @__PURE__ */ isValidElement(option)) {
    return option.props;
  }
  return option;
}
function Shape(_ref2) {
  var option = _ref2.option, shapeType = _ref2.shapeType, _ref2$propTransformer = _ref2.propTransformer, propTransformer = _ref2$propTransformer === void 0 ? defaultPropTransformer : _ref2$propTransformer, _ref2$activeClassName = _ref2.activeClassName, activeClassName = _ref2$activeClassName === void 0 ? "recharts-active-shape" : _ref2$activeClassName, isActive = _ref2.isActive, props = _objectWithoutProperties$7(_ref2, _excluded$7);
  var shape;
  if (/* @__PURE__ */ isValidElement(option)) {
    shape = /* @__PURE__ */ cloneElement(option, _objectSpread$g(_objectSpread$g({}, props), getPropsFromShapeOption(option)));
  } else if (isFunction(option)) {
    shape = option(props);
  } else if (isPlainObject(option) && !isBoolean(option)) {
    var nextProps = propTransformer(option, props);
    shape = /* @__PURE__ */ React__default.createElement(ShapeSelector, {
      shapeType,
      elementProps: nextProps
    });
  } else {
    var elementProps = props;
    shape = /* @__PURE__ */ React__default.createElement(ShapeSelector, {
      shapeType,
      elementProps
    });
  }
  if (isActive) {
    return /* @__PURE__ */ React__default.createElement(Layer, {
      className: activeClassName
    }, shape);
  }
  return shape;
}
function isFunnel(graphicalItem, _item) {
  return _item != null && "trapezoids" in graphicalItem.props;
}
function isPie(graphicalItem, _item) {
  return _item != null && "sectors" in graphicalItem.props;
}
function isScatter(graphicalItem, _item) {
  return _item != null && "points" in graphicalItem.props;
}
function compareFunnel(shapeData, activeTooltipItem) {
  var _activeTooltipItem$la, _activeTooltipItem$la2;
  var xMatches = shapeData.x === (activeTooltipItem === null || activeTooltipItem === void 0 || (_activeTooltipItem$la = activeTooltipItem.labelViewBox) === null || _activeTooltipItem$la === void 0 ? void 0 : _activeTooltipItem$la.x) || shapeData.x === activeTooltipItem.x;
  var yMatches = shapeData.y === (activeTooltipItem === null || activeTooltipItem === void 0 || (_activeTooltipItem$la2 = activeTooltipItem.labelViewBox) === null || _activeTooltipItem$la2 === void 0 ? void 0 : _activeTooltipItem$la2.y) || shapeData.y === activeTooltipItem.y;
  return xMatches && yMatches;
}
function comparePie(shapeData, activeTooltipItem) {
  var startAngleMatches = shapeData.endAngle === activeTooltipItem.endAngle;
  var endAngleMatches = shapeData.startAngle === activeTooltipItem.startAngle;
  return startAngleMatches && endAngleMatches;
}
function compareScatter(shapeData, activeTooltipItem) {
  var xMatches = shapeData.x === activeTooltipItem.x;
  var yMatches = shapeData.y === activeTooltipItem.y;
  var zMatches = shapeData.z === activeTooltipItem.z;
  return xMatches && yMatches && zMatches;
}
function getComparisonFn(graphicalItem, activeItem) {
  var comparison;
  if (isFunnel(graphicalItem, activeItem)) {
    comparison = compareFunnel;
  } else if (isPie(graphicalItem, activeItem)) {
    comparison = comparePie;
  } else if (isScatter(graphicalItem, activeItem)) {
    comparison = compareScatter;
  }
  return comparison;
}
function getShapeDataKey(graphicalItem, activeItem) {
  var shapeKey;
  if (isFunnel(graphicalItem, activeItem)) {
    shapeKey = "trapezoids";
  } else if (isPie(graphicalItem, activeItem)) {
    shapeKey = "sectors";
  } else if (isScatter(graphicalItem, activeItem)) {
    shapeKey = "points";
  }
  return shapeKey;
}
function getActiveShapeTooltipPayload(graphicalItem, activeItem) {
  if (isFunnel(graphicalItem, activeItem)) {
    var _activeItem$tooltipPa;
    return (_activeItem$tooltipPa = activeItem.tooltipPayload) === null || _activeItem$tooltipPa === void 0 || (_activeItem$tooltipPa = _activeItem$tooltipPa[0]) === null || _activeItem$tooltipPa === void 0 || (_activeItem$tooltipPa = _activeItem$tooltipPa.payload) === null || _activeItem$tooltipPa === void 0 ? void 0 : _activeItem$tooltipPa.payload;
  }
  if (isPie(graphicalItem, activeItem)) {
    var _activeItem$tooltipPa2;
    return (_activeItem$tooltipPa2 = activeItem.tooltipPayload) === null || _activeItem$tooltipPa2 === void 0 || (_activeItem$tooltipPa2 = _activeItem$tooltipPa2[0]) === null || _activeItem$tooltipPa2 === void 0 || (_activeItem$tooltipPa2 = _activeItem$tooltipPa2.payload) === null || _activeItem$tooltipPa2 === void 0 ? void 0 : _activeItem$tooltipPa2.payload;
  }
  if (isScatter(graphicalItem, activeItem)) {
    return activeItem.payload;
  }
  return {};
}
function getActiveShapeIndexForTooltip(_ref3) {
  var activeTooltipItem = _ref3.activeTooltipItem, graphicalItem = _ref3.graphicalItem, itemData = _ref3.itemData;
  var shapeKey = getShapeDataKey(graphicalItem, activeTooltipItem);
  var tooltipPayload = getActiveShapeTooltipPayload(graphicalItem, activeTooltipItem);
  var activeItemMatches = itemData.filter(function(datum, dataIndex) {
    var valuesMatch = isEqual(tooltipPayload, datum);
    var mouseCoordinateMatches = graphicalItem.props[shapeKey].filter(function(shapeData) {
      var comparison = getComparisonFn(graphicalItem, activeTooltipItem);
      return comparison(shapeData, activeTooltipItem);
    });
    var indexOfMouseCoordinates = graphicalItem.props[shapeKey].indexOf(mouseCoordinateMatches[mouseCoordinateMatches.length - 1]);
    var coordinatesMatch = dataIndex === indexOfMouseCoordinates;
    return valuesMatch && coordinatesMatch;
  });
  var activeIndex = itemData.indexOf(activeItemMatches[activeItemMatches.length - 1]);
  return activeIndex;
}
var _Pie;
function _typeof$j(o2) {
  "@babel/helpers - typeof";
  return _typeof$j = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof$j(o2);
}
function _extends$d() {
  _extends$d = Object.assign ? Object.assign.bind() : function(target) {
    for (var i3 = 1; i3 < arguments.length; i3++) {
      var source = arguments[i3];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$d.apply(this, arguments);
}
function ownKeys$f(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e3);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$f(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$f(Object(t3), true).forEach(function(r3) {
      _defineProperty$i(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$f(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
function _classCallCheck$d(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$d(target, props) {
  for (var i3 = 0; i3 < props.length; i3++) {
    var descriptor = props[i3];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$i(descriptor.key), descriptor);
  }
}
function _createClass$d(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$d(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$d(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _callSuper$b(t3, o2, e3) {
  return o2 = _getPrototypeOf$b(o2), _possibleConstructorReturn$b(t3, _isNativeReflectConstruct$b() ? Reflect.construct(o2, e3 || [], _getPrototypeOf$b(t3).constructor) : o2.apply(t3, e3));
}
function _possibleConstructorReturn$b(self2, call) {
  if (call && (_typeof$j(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$b(self2);
}
function _assertThisInitialized$b(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$b() {
  try {
    var t3 = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$b = function _isNativeReflectConstruct2() {
    return !!t3;
  })();
}
function _getPrototypeOf$b(o2) {
  _getPrototypeOf$b = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o3) {
    return o3.__proto__ || Object.getPrototypeOf(o3);
  };
  return _getPrototypeOf$b(o2);
}
function _inherits$b(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass) _setPrototypeOf$b(subClass, superClass);
}
function _setPrototypeOf$b(o2, p2) {
  _setPrototypeOf$b = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o3, p3) {
    o3.__proto__ = p3;
    return o3;
  };
  return _setPrototypeOf$b(o2, p2);
}
function _defineProperty$i(obj, key, value) {
  key = _toPropertyKey$i(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$i(t3) {
  var i3 = _toPrimitive$i(t3, "string");
  return "symbol" == _typeof$j(i3) ? i3 : i3 + "";
}
function _toPrimitive$i(t3, r2) {
  if ("object" != _typeof$j(t3) || !t3) return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i3 = e3.call(t3, r2);
    if ("object" != _typeof$j(i3)) return i3;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t3);
}
var Pie = /* @__PURE__ */ function(_PureComponent) {
  function Pie2(props) {
    var _this;
    _classCallCheck$d(this, Pie2);
    _this = _callSuper$b(this, Pie2, [props]);
    _defineProperty$i(_this, "pieRef", null);
    _defineProperty$i(_this, "sectorRefs", []);
    _defineProperty$i(_this, "id", uniqueId("recharts-pie-"));
    _defineProperty$i(_this, "handleAnimationEnd", function() {
      var onAnimationEnd2 = _this.props.onAnimationEnd;
      _this.setState({
        isAnimationFinished: true
      });
      if (isFunction(onAnimationEnd2)) {
        onAnimationEnd2();
      }
    });
    _defineProperty$i(_this, "handleAnimationStart", function() {
      var onAnimationStart2 = _this.props.onAnimationStart;
      _this.setState({
        isAnimationFinished: false
      });
      if (isFunction(onAnimationStart2)) {
        onAnimationStart2();
      }
    });
    _this.state = {
      isAnimationFinished: !props.isAnimationActive,
      prevIsAnimationActive: props.isAnimationActive,
      prevAnimationId: props.animationId,
      sectorToFocus: 0
    };
    return _this;
  }
  _inherits$b(Pie2, _PureComponent);
  return _createClass$d(Pie2, [{
    key: "isActiveIndex",
    value: function isActiveIndex(i3) {
      var activeIndex = this.props.activeIndex;
      if (Array.isArray(activeIndex)) {
        return activeIndex.indexOf(i3) !== -1;
      }
      return i3 === activeIndex;
    }
  }, {
    key: "hasActiveIndex",
    value: function hasActiveIndex() {
      var activeIndex = this.props.activeIndex;
      return Array.isArray(activeIndex) ? activeIndex.length !== 0 : activeIndex || activeIndex === 0;
    }
  }, {
    key: "renderLabels",
    value: function renderLabels(sectors) {
      var isAnimationActive = this.props.isAnimationActive;
      if (isAnimationActive && !this.state.isAnimationFinished) {
        return null;
      }
      var _this$props = this.props, label = _this$props.label, labelLine = _this$props.labelLine, dataKey = _this$props.dataKey, valueKey = _this$props.valueKey;
      var pieProps = filterProps(this.props, false);
      var customLabelProps = filterProps(label, false);
      var customLabelLineProps = filterProps(labelLine, false);
      var offsetRadius = label && label.offsetRadius || 20;
      var labels2 = sectors.map(function(entry, i3) {
        var midAngle = (entry.startAngle + entry.endAngle) / 2;
        var endPoint = polarToCartesian(entry.cx, entry.cy, entry.outerRadius + offsetRadius, midAngle);
        var labelProps = _objectSpread$f(_objectSpread$f(_objectSpread$f(_objectSpread$f({}, pieProps), entry), {}, {
          stroke: "none"
        }, customLabelProps), {}, {
          index: i3,
          textAnchor: Pie2.getTextAnchor(endPoint.x, entry.cx)
        }, endPoint);
        var lineProps = _objectSpread$f(_objectSpread$f(_objectSpread$f(_objectSpread$f({}, pieProps), entry), {}, {
          fill: "none",
          stroke: entry.fill
        }, customLabelLineProps), {}, {
          index: i3,
          points: [polarToCartesian(entry.cx, entry.cy, entry.outerRadius, midAngle), endPoint]
        });
        var realDataKey = dataKey;
        if (isNil(dataKey) && isNil(valueKey)) {
          realDataKey = "value";
        } else if (isNil(dataKey)) {
          realDataKey = valueKey;
        }
        return (
          // eslint-disable-next-line react/no-array-index-key
          /* @__PURE__ */ React__default.createElement(Layer, {
            key: "label-".concat(entry.startAngle, "-").concat(entry.endAngle, "-").concat(entry.midAngle, "-").concat(i3)
          }, labelLine && Pie2.renderLabelLineItem(labelLine, lineProps, "line"), Pie2.renderLabelItem(label, labelProps, getValueByDataKey(entry, realDataKey)))
        );
      });
      return /* @__PURE__ */ React__default.createElement(Layer, {
        className: "recharts-pie-labels"
      }, labels2);
    }
  }, {
    key: "renderSectorsStatically",
    value: function renderSectorsStatically(sectors) {
      var _this2 = this;
      var _this$props2 = this.props, activeShape = _this$props2.activeShape, blendStroke = _this$props2.blendStroke, inactiveShapeProp = _this$props2.inactiveShape;
      return sectors.map(function(entry, i3) {
        if ((entry === null || entry === void 0 ? void 0 : entry.startAngle) === 0 && (entry === null || entry === void 0 ? void 0 : entry.endAngle) === 0 && sectors.length !== 1) return null;
        var isActive = _this2.isActiveIndex(i3);
        var inactiveShape = inactiveShapeProp && _this2.hasActiveIndex() ? inactiveShapeProp : null;
        var sectorOptions = isActive ? activeShape : inactiveShape;
        var sectorProps = _objectSpread$f(_objectSpread$f({}, entry), {}, {
          stroke: blendStroke ? entry.fill : entry.stroke,
          tabIndex: -1
        });
        return /* @__PURE__ */ React__default.createElement(Layer, _extends$d({
          ref: function ref(_ref) {
            if (_ref && !_this2.sectorRefs.includes(_ref)) {
              _this2.sectorRefs.push(_ref);
            }
          },
          tabIndex: -1,
          className: "recharts-pie-sector"
        }, adaptEventsOfChild(_this2.props, entry, i3), {
          // eslint-disable-next-line react/no-array-index-key
          key: "sector-".concat(entry === null || entry === void 0 ? void 0 : entry.startAngle, "-").concat(entry === null || entry === void 0 ? void 0 : entry.endAngle, "-").concat(entry.midAngle, "-").concat(i3)
        }), /* @__PURE__ */ React__default.createElement(Shape, _extends$d({
          option: sectorOptions,
          isActive,
          shapeType: "sector"
        }, sectorProps)));
      });
    }
  }, {
    key: "renderSectorsWithAnimation",
    value: function renderSectorsWithAnimation() {
      var _this3 = this;
      var _this$props3 = this.props, sectors = _this$props3.sectors, isAnimationActive = _this$props3.isAnimationActive, animationBegin = _this$props3.animationBegin, animationDuration = _this$props3.animationDuration, animationEasing = _this$props3.animationEasing, animationId = _this$props3.animationId;
      var _this$state = this.state, prevSectors = _this$state.prevSectors, prevIsAnimationActive = _this$state.prevIsAnimationActive;
      return /* @__PURE__ */ React__default.createElement(Animate, {
        begin: animationBegin,
        duration: animationDuration,
        isActive: isAnimationActive,
        easing: animationEasing,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "pie-".concat(animationId, "-").concat(prevIsAnimationActive),
        onAnimationStart: this.handleAnimationStart,
        onAnimationEnd: this.handleAnimationEnd
      }, function(_ref2) {
        var t3 = _ref2.t;
        var stepData = [];
        var first = sectors && sectors[0];
        var curAngle = first.startAngle;
        sectors.forEach(function(entry, index2) {
          var prev = prevSectors && prevSectors[index2];
          var paddingAngle = index2 > 0 ? get(entry, "paddingAngle", 0) : 0;
          if (prev) {
            var angleIp = interpolateNumber$2(prev.endAngle - prev.startAngle, entry.endAngle - entry.startAngle);
            var latest = _objectSpread$f(_objectSpread$f({}, entry), {}, {
              startAngle: curAngle + paddingAngle,
              endAngle: curAngle + angleIp(t3) + paddingAngle
            });
            stepData.push(latest);
            curAngle = latest.endAngle;
          } else {
            var endAngle = entry.endAngle, startAngle = entry.startAngle;
            var interpolatorAngle = interpolateNumber$2(0, endAngle - startAngle);
            var deltaAngle = interpolatorAngle(t3);
            var _latest = _objectSpread$f(_objectSpread$f({}, entry), {}, {
              startAngle: curAngle + paddingAngle,
              endAngle: curAngle + deltaAngle + paddingAngle
            });
            stepData.push(_latest);
            curAngle = _latest.endAngle;
          }
        });
        return /* @__PURE__ */ React__default.createElement(Layer, null, _this3.renderSectorsStatically(stepData));
      });
    }
  }, {
    key: "attachKeyboardHandlers",
    value: function attachKeyboardHandlers(pieRef) {
      var _this4 = this;
      pieRef.onkeydown = function(e3) {
        if (!e3.altKey) {
          switch (e3.key) {
            case "ArrowLeft": {
              var next = ++_this4.state.sectorToFocus % _this4.sectorRefs.length;
              _this4.sectorRefs[next].focus();
              _this4.setState({
                sectorToFocus: next
              });
              break;
            }
            case "ArrowRight": {
              var _next = --_this4.state.sectorToFocus < 0 ? _this4.sectorRefs.length - 1 : _this4.state.sectorToFocus % _this4.sectorRefs.length;
              _this4.sectorRefs[_next].focus();
              _this4.setState({
                sectorToFocus: _next
              });
              break;
            }
            case "Escape": {
              _this4.sectorRefs[_this4.state.sectorToFocus].blur();
              _this4.setState({
                sectorToFocus: 0
              });
              break;
            }
          }
        }
      };
    }
  }, {
    key: "renderSectors",
    value: function renderSectors() {
      var _this$props4 = this.props, sectors = _this$props4.sectors, isAnimationActive = _this$props4.isAnimationActive;
      var prevSectors = this.state.prevSectors;
      if (isAnimationActive && sectors && sectors.length && (!prevSectors || !isEqual(prevSectors, sectors))) {
        return this.renderSectorsWithAnimation();
      }
      return this.renderSectorsStatically(sectors);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.pieRef) {
        this.attachKeyboardHandlers(this.pieRef);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;
      var _this$props5 = this.props, hide2 = _this$props5.hide, sectors = _this$props5.sectors, className = _this$props5.className, label = _this$props5.label, cx = _this$props5.cx, cy = _this$props5.cy, innerRadius = _this$props5.innerRadius, outerRadius = _this$props5.outerRadius, isAnimationActive = _this$props5.isAnimationActive;
      var isAnimationFinished = this.state.isAnimationFinished;
      if (hide2 || !sectors || !sectors.length || !isNumber(cx) || !isNumber(cy) || !isNumber(innerRadius) || !isNumber(outerRadius)) {
        return null;
      }
      var layerClass = clsx("recharts-pie", className);
      return /* @__PURE__ */ React__default.createElement(Layer, {
        tabIndex: this.props.rootTabIndex,
        className: layerClass,
        ref: function ref(_ref3) {
          _this5.pieRef = _ref3;
        }
      }, this.renderSectors(), label && this.renderLabels(sectors), Label$1.renderCallByParent(this.props, null, false), (!isAnimationActive || isAnimationFinished) && LabelList.renderCallByParent(this.props, sectors, false));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (prevState.prevIsAnimationActive !== nextProps.isAnimationActive) {
        return {
          prevIsAnimationActive: nextProps.isAnimationActive,
          prevAnimationId: nextProps.animationId,
          curSectors: nextProps.sectors,
          prevSectors: [],
          isAnimationFinished: true
        };
      }
      if (nextProps.isAnimationActive && nextProps.animationId !== prevState.prevAnimationId) {
        return {
          prevAnimationId: nextProps.animationId,
          curSectors: nextProps.sectors,
          prevSectors: prevState.curSectors,
          isAnimationFinished: true
        };
      }
      if (nextProps.sectors !== prevState.curSectors) {
        return {
          curSectors: nextProps.sectors,
          isAnimationFinished: true
        };
      }
      return null;
    }
  }, {
    key: "getTextAnchor",
    value: function getTextAnchor(x3, cx) {
      if (x3 > cx) {
        return "start";
      }
      if (x3 < cx) {
        return "end";
      }
      return "middle";
    }
  }, {
    key: "renderLabelLineItem",
    value: function renderLabelLineItem(option, props, key) {
      if (/* @__PURE__ */ React__default.isValidElement(option)) {
        return /* @__PURE__ */ React__default.cloneElement(option, props);
      }
      if (isFunction(option)) {
        return option(props);
      }
      var className = clsx("recharts-pie-label-line", typeof option !== "boolean" ? option.className : "");
      return /* @__PURE__ */ React__default.createElement(Curve, _extends$d({}, props, {
        key,
        type: "linear",
        className
      }));
    }
  }, {
    key: "renderLabelItem",
    value: function renderLabelItem(option, props, value) {
      if (/* @__PURE__ */ React__default.isValidElement(option)) {
        return /* @__PURE__ */ React__default.cloneElement(option, props);
      }
      var label = value;
      if (isFunction(option)) {
        label = option(props);
        if (/* @__PURE__ */ React__default.isValidElement(label)) {
          return label;
        }
      }
      var className = clsx("recharts-pie-label-text", typeof option !== "boolean" && !isFunction(option) ? option.className : "");
      return /* @__PURE__ */ React__default.createElement(Text, _extends$d({}, props, {
        alignmentBaseline: "middle",
        className
      }), label);
    }
  }]);
}(PureComponent);
_Pie = Pie;
_defineProperty$i(Pie, "displayName", "Pie");
_defineProperty$i(Pie, "defaultProps", {
  stroke: "#fff",
  fill: "#808080",
  legendType: "rect",
  cx: "50%",
  cy: "50%",
  startAngle: 0,
  endAngle: 360,
  innerRadius: 0,
  outerRadius: "80%",
  paddingAngle: 0,
  labelLine: true,
  hide: false,
  minAngle: 0,
  isAnimationActive: !Global.isSsr,
  animationBegin: 400,
  animationDuration: 1500,
  animationEasing: "ease",
  nameKey: "name",
  blendStroke: false,
  rootTabIndex: 0
});
_defineProperty$i(Pie, "parseDeltaAngle", function(startAngle, endAngle) {
  var sign2 = mathSign(endAngle - startAngle);
  var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
  return sign2 * deltaAngle;
});
_defineProperty$i(Pie, "getRealPieData", function(itemProps) {
  var data = itemProps.data, children = itemProps.children;
  var presentationProps = filterProps(itemProps, false);
  var cells = findAllByType(children, Cell);
  if (data && data.length) {
    return data.map(function(entry, index2) {
      return _objectSpread$f(_objectSpread$f(_objectSpread$f({
        payload: entry
      }, presentationProps), entry), cells && cells[index2] && cells[index2].props);
    });
  }
  if (cells && cells.length) {
    return cells.map(function(cell) {
      return _objectSpread$f(_objectSpread$f({}, presentationProps), cell.props);
    });
  }
  return [];
});
_defineProperty$i(Pie, "parseCoordinateOfPie", function(itemProps, offset2) {
  var top = offset2.top, left = offset2.left, width = offset2.width, height = offset2.height;
  var maxPieRadius = getMaxRadius(width, height);
  var cx = left + getPercentValue(itemProps.cx, width, width / 2);
  var cy = top + getPercentValue(itemProps.cy, height, height / 2);
  var innerRadius = getPercentValue(itemProps.innerRadius, maxPieRadius, 0);
  var outerRadius = getPercentValue(itemProps.outerRadius, maxPieRadius, maxPieRadius * 0.8);
  var maxRadius = itemProps.maxRadius || Math.sqrt(width * width + height * height) / 2;
  return {
    cx,
    cy,
    innerRadius,
    outerRadius,
    maxRadius
  };
});
_defineProperty$i(Pie, "getComposedData", function(_ref4) {
  var item = _ref4.item, offset2 = _ref4.offset;
  var itemProps = item.type.defaultProps !== void 0 ? _objectSpread$f(_objectSpread$f({}, item.type.defaultProps), item.props) : item.props;
  var pieData = _Pie.getRealPieData(itemProps);
  if (!pieData || !pieData.length) {
    return null;
  }
  var cornerRadius = itemProps.cornerRadius, startAngle = itemProps.startAngle, endAngle = itemProps.endAngle, paddingAngle = itemProps.paddingAngle, dataKey = itemProps.dataKey, nameKey = itemProps.nameKey, valueKey = itemProps.valueKey, tooltipType = itemProps.tooltipType;
  var minAngle = Math.abs(itemProps.minAngle);
  var coordinate = _Pie.parseCoordinateOfPie(itemProps, offset2);
  var deltaAngle = _Pie.parseDeltaAngle(startAngle, endAngle);
  var absDeltaAngle = Math.abs(deltaAngle);
  var realDataKey = dataKey;
  if (isNil(dataKey) && isNil(valueKey)) {
    warn$1(false, 'Use "dataKey" to specify the value of pie,\n      the props "valueKey" will be deprecated in 1.1.0');
    realDataKey = "value";
  } else if (isNil(dataKey)) {
    warn$1(false, 'Use "dataKey" to specify the value of pie,\n      the props "valueKey" will be deprecated in 1.1.0');
    realDataKey = valueKey;
  }
  var notZeroItemCount = pieData.filter(function(entry) {
    return getValueByDataKey(entry, realDataKey, 0) !== 0;
  }).length;
  var totalPadingAngle = (absDeltaAngle >= 360 ? notZeroItemCount : notZeroItemCount - 1) * paddingAngle;
  var realTotalAngle = absDeltaAngle - notZeroItemCount * minAngle - totalPadingAngle;
  var sum2 = pieData.reduce(function(result, entry) {
    var val = getValueByDataKey(entry, realDataKey, 0);
    return result + (isNumber(val) ? val : 0);
  }, 0);
  var sectors;
  if (sum2 > 0) {
    var prev;
    sectors = pieData.map(function(entry, i3) {
      var val = getValueByDataKey(entry, realDataKey, 0);
      var name = getValueByDataKey(entry, nameKey, i3);
      var percent2 = (isNumber(val) ? val : 0) / sum2;
      var tempStartAngle;
      if (i3) {
        tempStartAngle = prev.endAngle + mathSign(deltaAngle) * paddingAngle * (val !== 0 ? 1 : 0);
      } else {
        tempStartAngle = startAngle;
      }
      var tempEndAngle = tempStartAngle + mathSign(deltaAngle) * ((val !== 0 ? minAngle : 0) + percent2 * realTotalAngle);
      var midAngle = (tempStartAngle + tempEndAngle) / 2;
      var middleRadius = (coordinate.innerRadius + coordinate.outerRadius) / 2;
      var tooltipPayload = [{
        name,
        value: val,
        payload: entry,
        dataKey: realDataKey,
        type: tooltipType
      }];
      var tooltipPosition = polarToCartesian(coordinate.cx, coordinate.cy, middleRadius, midAngle);
      prev = _objectSpread$f(_objectSpread$f(_objectSpread$f({
        percent: percent2,
        cornerRadius,
        name,
        tooltipPayload,
        midAngle,
        middleRadius,
        tooltipPosition
      }, entry), coordinate), {}, {
        value: getValueByDataKey(entry, realDataKey),
        startAngle: tempStartAngle,
        endAngle: tempEndAngle,
        payload: entry,
        paddingAngle: mathSign(deltaAngle) * paddingAngle
      });
      return prev;
    });
  }
  return _objectSpread$f(_objectSpread$f({}, coordinate), {}, {
    sectors,
    data: pieData
  });
});
var _baseRange;
var hasRequired_baseRange;
function require_baseRange() {
  if (hasRequired_baseRange) return _baseRange;
  hasRequired_baseRange = 1;
  var nativeCeil = Math.ceil, nativeMax = Math.max;
  function baseRange(start, end, step, fromRight) {
    var index2 = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
    while (length--) {
      result[fromRight ? length : ++index2] = start;
      start += step;
    }
    return result;
  }
  _baseRange = baseRange;
  return _baseRange;
}
var toFinite_1;
var hasRequiredToFinite;
function requireToFinite() {
  if (hasRequiredToFinite) return toFinite_1;
  hasRequiredToFinite = 1;
  var toNumber = requireToNumber();
  var INFINITY = 1 / 0, MAX_INTEGER = 17976931348623157e292;
  function toFinite(value) {
    if (!value) {
      return value === 0 ? value : 0;
    }
    value = toNumber(value);
    if (value === INFINITY || value === -Infinity) {
      var sign2 = value < 0 ? -1 : 1;
      return sign2 * MAX_INTEGER;
    }
    return value === value ? value : 0;
  }
  toFinite_1 = toFinite;
  return toFinite_1;
}
var _createRange;
var hasRequired_createRange;
function require_createRange() {
  if (hasRequired_createRange) return _createRange;
  hasRequired_createRange = 1;
  var baseRange = require_baseRange(), isIterateeCall = require_isIterateeCall(), toFinite = requireToFinite();
  function createRange(fromRight) {
    return function(start, end, step) {
      if (step && typeof step != "number" && isIterateeCall(start, end, step)) {
        end = step = void 0;
      }
      start = toFinite(start);
      if (end === void 0) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      step = step === void 0 ? start < end ? 1 : -1 : toFinite(step);
      return baseRange(start, end, step, fromRight);
    };
  }
  _createRange = createRange;
  return _createRange;
}
var range_1;
var hasRequiredRange;
function requireRange() {
  if (hasRequiredRange) return range_1;
  hasRequiredRange = 1;
  var createRange = require_createRange();
  var range3 = createRange();
  range_1 = range3;
  return range_1;
}
var rangeExports = requireRange();
const range2 = /* @__PURE__ */ getDefaultExportFromCjs(rangeExports);
function _typeof$i(o2) {
  "@babel/helpers - typeof";
  return _typeof$i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof$i(o2);
}
function ownKeys$e(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e3);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$e(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$e(Object(t3), true).forEach(function(r3) {
      _defineProperty$h(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$e(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
function _defineProperty$h(obj, key, value) {
  key = _toPropertyKey$h(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$h(t3) {
  var i3 = _toPrimitive$h(t3, "string");
  return "symbol" == _typeof$i(i3) ? i3 : i3 + "";
}
function _toPrimitive$h(t3, r2) {
  if ("object" != _typeof$i(t3) || !t3) return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i3 = e3.call(t3, r2);
    if ("object" != _typeof$i(i3)) return i3;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t3);
}
var PREFIX_LIST = ["Webkit", "Moz", "O", "ms"];
var generatePrefixStyle = function generatePrefixStyle2(name, value) {
  var camelName = name.replace(/(\w)/, function(v2) {
    return v2.toUpperCase();
  });
  var result = PREFIX_LIST.reduce(function(res, entry) {
    return _objectSpread$e(_objectSpread$e({}, res), {}, _defineProperty$h({}, entry + camelName, value));
  }, {});
  result[name] = value;
  return result;
};
function _typeof$h(o2) {
  "@babel/helpers - typeof";
  return _typeof$h = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof$h(o2);
}
function _extends$c() {
  _extends$c = Object.assign ? Object.assign.bind() : function(target) {
    for (var i3 = 1; i3 < arguments.length; i3++) {
      var source = arguments[i3];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$c.apply(this, arguments);
}
function ownKeys$d(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e3);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$d(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$d(Object(t3), true).forEach(function(r3) {
      _defineProperty$g(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$d(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
function _classCallCheck$c(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$c(target, props) {
  for (var i3 = 0; i3 < props.length; i3++) {
    var descriptor = props[i3];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$g(descriptor.key), descriptor);
  }
}
function _createClass$c(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$c(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$c(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _callSuper$a(t3, o2, e3) {
  return o2 = _getPrototypeOf$a(o2), _possibleConstructorReturn$a(t3, _isNativeReflectConstruct$a() ? Reflect.construct(o2, e3 || [], _getPrototypeOf$a(t3).constructor) : o2.apply(t3, e3));
}
function _possibleConstructorReturn$a(self2, call) {
  if (call && (_typeof$h(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$a(self2);
}
function _assertThisInitialized$a(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$a() {
  try {
    var t3 = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$a = function _isNativeReflectConstruct2() {
    return !!t3;
  })();
}
function _getPrototypeOf$a(o2) {
  _getPrototypeOf$a = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o3) {
    return o3.__proto__ || Object.getPrototypeOf(o3);
  };
  return _getPrototypeOf$a(o2);
}
function _inherits$a(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass) _setPrototypeOf$a(subClass, superClass);
}
function _setPrototypeOf$a(o2, p2) {
  _setPrototypeOf$a = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o3, p3) {
    o3.__proto__ = p3;
    return o3;
  };
  return _setPrototypeOf$a(o2, p2);
}
function _defineProperty$g(obj, key, value) {
  key = _toPropertyKey$g(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$g(t3) {
  var i3 = _toPrimitive$g(t3, "string");
  return "symbol" == _typeof$h(i3) ? i3 : i3 + "";
}
function _toPrimitive$g(t3, r2) {
  if ("object" != _typeof$h(t3) || !t3) return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i3 = e3.call(t3, r2);
    if ("object" != _typeof$h(i3)) return i3;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t3);
}
var createScale = function createScale2(_ref) {
  var data = _ref.data, startIndex = _ref.startIndex, endIndex = _ref.endIndex, x3 = _ref.x, width = _ref.width, travellerWidth = _ref.travellerWidth;
  if (!data || !data.length) {
    return {};
  }
  var len = data.length;
  var scale2 = point().domain(range2(0, len)).range([x3, x3 + width - travellerWidth]);
  var scaleValues = scale2.domain().map(function(entry) {
    return scale2(entry);
  });
  return {
    isTextActive: false,
    isSlideMoving: false,
    isTravellerMoving: false,
    isTravellerFocused: false,
    startX: scale2(startIndex),
    endX: scale2(endIndex),
    scale: scale2,
    scaleValues
  };
};
var isTouch = function isTouch2(e3) {
  return e3.changedTouches && !!e3.changedTouches.length;
};
var Brush = /* @__PURE__ */ function(_PureComponent) {
  function Brush2(props) {
    var _this;
    _classCallCheck$c(this, Brush2);
    _this = _callSuper$a(this, Brush2, [props]);
    _defineProperty$g(_this, "handleDrag", function(e3) {
      if (_this.leaveTimer) {
        clearTimeout(_this.leaveTimer);
        _this.leaveTimer = null;
      }
      if (_this.state.isTravellerMoving) {
        _this.handleTravellerMove(e3);
      } else if (_this.state.isSlideMoving) {
        _this.handleSlideDrag(e3);
      }
    });
    _defineProperty$g(_this, "handleTouchMove", function(e3) {
      if (e3.changedTouches != null && e3.changedTouches.length > 0) {
        _this.handleDrag(e3.changedTouches[0]);
      }
    });
    _defineProperty$g(_this, "handleDragEnd", function() {
      _this.setState({
        isTravellerMoving: false,
        isSlideMoving: false
      }, function() {
        var _this$props = _this.props, endIndex = _this$props.endIndex, onDragEnd = _this$props.onDragEnd, startIndex = _this$props.startIndex;
        onDragEnd === null || onDragEnd === void 0 || onDragEnd({
          endIndex,
          startIndex
        });
      });
      _this.detachDragEndListener();
    });
    _defineProperty$g(_this, "handleLeaveWrapper", function() {
      if (_this.state.isTravellerMoving || _this.state.isSlideMoving) {
        _this.leaveTimer = window.setTimeout(_this.handleDragEnd, _this.props.leaveTimeOut);
      }
    });
    _defineProperty$g(_this, "handleEnterSlideOrTraveller", function() {
      _this.setState({
        isTextActive: true
      });
    });
    _defineProperty$g(_this, "handleLeaveSlideOrTraveller", function() {
      _this.setState({
        isTextActive: false
      });
    });
    _defineProperty$g(_this, "handleSlideDragStart", function(e3) {
      var event = isTouch(e3) ? e3.changedTouches[0] : e3;
      _this.setState({
        isTravellerMoving: false,
        isSlideMoving: true,
        slideMoveStartX: event.pageX
      });
      _this.attachDragEndListener();
    });
    _this.travellerDragStartHandlers = {
      startX: _this.handleTravellerDragStart.bind(_this, "startX"),
      endX: _this.handleTravellerDragStart.bind(_this, "endX")
    };
    _this.state = {};
    return _this;
  }
  _inherits$a(Brush2, _PureComponent);
  return _createClass$c(Brush2, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.leaveTimer) {
        clearTimeout(this.leaveTimer);
        this.leaveTimer = null;
      }
      this.detachDragEndListener();
    }
  }, {
    key: "getIndex",
    value: function getIndex(_ref2) {
      var startX = _ref2.startX, endX = _ref2.endX;
      var scaleValues = this.state.scaleValues;
      var _this$props2 = this.props, gap = _this$props2.gap, data = _this$props2.data;
      var lastIndex = data.length - 1;
      var min2 = Math.min(startX, endX);
      var max2 = Math.max(startX, endX);
      var minIndex = Brush2.getIndexInRange(scaleValues, min2);
      var maxIndex = Brush2.getIndexInRange(scaleValues, max2);
      return {
        startIndex: minIndex - minIndex % gap,
        endIndex: maxIndex === lastIndex ? lastIndex : maxIndex - maxIndex % gap
      };
    }
  }, {
    key: "getTextOfTick",
    value: function getTextOfTick(index2) {
      var _this$props3 = this.props, data = _this$props3.data, tickFormatter = _this$props3.tickFormatter, dataKey = _this$props3.dataKey;
      var text2 = getValueByDataKey(data[index2], dataKey, index2);
      return isFunction(tickFormatter) ? tickFormatter(text2, index2) : text2;
    }
  }, {
    key: "attachDragEndListener",
    value: function attachDragEndListener() {
      window.addEventListener("mouseup", this.handleDragEnd, true);
      window.addEventListener("touchend", this.handleDragEnd, true);
      window.addEventListener("mousemove", this.handleDrag, true);
    }
  }, {
    key: "detachDragEndListener",
    value: function detachDragEndListener() {
      window.removeEventListener("mouseup", this.handleDragEnd, true);
      window.removeEventListener("touchend", this.handleDragEnd, true);
      window.removeEventListener("mousemove", this.handleDrag, true);
    }
  }, {
    key: "handleSlideDrag",
    value: function handleSlideDrag(e3) {
      var _this$state = this.state, slideMoveStartX = _this$state.slideMoveStartX, startX = _this$state.startX, endX = _this$state.endX;
      var _this$props4 = this.props, x3 = _this$props4.x, width = _this$props4.width, travellerWidth = _this$props4.travellerWidth, startIndex = _this$props4.startIndex, endIndex = _this$props4.endIndex, onChange = _this$props4.onChange;
      var delta = e3.pageX - slideMoveStartX;
      if (delta > 0) {
        delta = Math.min(delta, x3 + width - travellerWidth - endX, x3 + width - travellerWidth - startX);
      } else if (delta < 0) {
        delta = Math.max(delta, x3 - startX, x3 - endX);
      }
      var newIndex = this.getIndex({
        startX: startX + delta,
        endX: endX + delta
      });
      if ((newIndex.startIndex !== startIndex || newIndex.endIndex !== endIndex) && onChange) {
        onChange(newIndex);
      }
      this.setState({
        startX: startX + delta,
        endX: endX + delta,
        slideMoveStartX: e3.pageX
      });
    }
  }, {
    key: "handleTravellerDragStart",
    value: function handleTravellerDragStart(id2, e3) {
      var event = isTouch(e3) ? e3.changedTouches[0] : e3;
      this.setState({
        isSlideMoving: false,
        isTravellerMoving: true,
        movingTravellerId: id2,
        brushMoveStartX: event.pageX
      });
      this.attachDragEndListener();
    }
  }, {
    key: "handleTravellerMove",
    value: function handleTravellerMove(e3) {
      var _this$state2 = this.state, brushMoveStartX = _this$state2.brushMoveStartX, movingTravellerId = _this$state2.movingTravellerId, endX = _this$state2.endX, startX = _this$state2.startX;
      var prevValue = this.state[movingTravellerId];
      var _this$props5 = this.props, x3 = _this$props5.x, width = _this$props5.width, travellerWidth = _this$props5.travellerWidth, onChange = _this$props5.onChange, gap = _this$props5.gap, data = _this$props5.data;
      var params = {
        startX: this.state.startX,
        endX: this.state.endX
      };
      var delta = e3.pageX - brushMoveStartX;
      if (delta > 0) {
        delta = Math.min(delta, x3 + width - travellerWidth - prevValue);
      } else if (delta < 0) {
        delta = Math.max(delta, x3 - prevValue);
      }
      params[movingTravellerId] = prevValue + delta;
      var newIndex = this.getIndex(params);
      var startIndex = newIndex.startIndex, endIndex = newIndex.endIndex;
      var isFullGap = function isFullGap2() {
        var lastIndex = data.length - 1;
        if (movingTravellerId === "startX" && (endX > startX ? startIndex % gap === 0 : endIndex % gap === 0) || endX < startX && endIndex === lastIndex || movingTravellerId === "endX" && (endX > startX ? endIndex % gap === 0 : startIndex % gap === 0) || endX > startX && endIndex === lastIndex) {
          return true;
        }
        return false;
      };
      this.setState(_defineProperty$g(_defineProperty$g({}, movingTravellerId, prevValue + delta), "brushMoveStartX", e3.pageX), function() {
        if (onChange) {
          if (isFullGap()) {
            onChange(newIndex);
          }
        }
      });
    }
  }, {
    key: "handleTravellerMoveKeyboard",
    value: function handleTravellerMoveKeyboard(direction, id2) {
      var _this2 = this;
      var _this$state3 = this.state, scaleValues = _this$state3.scaleValues, startX = _this$state3.startX, endX = _this$state3.endX;
      var currentScaleValue = this.state[id2];
      var currentIndex = scaleValues.indexOf(currentScaleValue);
      if (currentIndex === -1) {
        return;
      }
      var newIndex = currentIndex + direction;
      if (newIndex === -1 || newIndex >= scaleValues.length) {
        return;
      }
      var newScaleValue = scaleValues[newIndex];
      if (id2 === "startX" && newScaleValue >= endX || id2 === "endX" && newScaleValue <= startX) {
        return;
      }
      this.setState(_defineProperty$g({}, id2, newScaleValue), function() {
        _this2.props.onChange(_this2.getIndex({
          startX: _this2.state.startX,
          endX: _this2.state.endX
        }));
      });
    }
  }, {
    key: "renderBackground",
    value: function renderBackground() {
      var _this$props6 = this.props, x3 = _this$props6.x, y4 = _this$props6.y, width = _this$props6.width, height = _this$props6.height, fill = _this$props6.fill, stroke = _this$props6.stroke;
      return /* @__PURE__ */ React__default.createElement("rect", {
        stroke,
        fill,
        x: x3,
        y: y4,
        width,
        height
      });
    }
  }, {
    key: "renderPanorama",
    value: function renderPanorama() {
      var _this$props7 = this.props, x3 = _this$props7.x, y4 = _this$props7.y, width = _this$props7.width, height = _this$props7.height, data = _this$props7.data, children = _this$props7.children, padding = _this$props7.padding;
      var chartElement = Children.only(children);
      if (!chartElement) {
        return null;
      }
      return /* @__PURE__ */ React__default.cloneElement(chartElement, {
        x: x3,
        y: y4,
        width,
        height,
        margin: padding,
        compact: true,
        data
      });
    }
  }, {
    key: "renderTravellerLayer",
    value: function renderTravellerLayer(travellerX, id2) {
      var _data$startIndex, _data$endIndex, _this3 = this;
      var _this$props8 = this.props, y4 = _this$props8.y, travellerWidth = _this$props8.travellerWidth, height = _this$props8.height, traveller = _this$props8.traveller, ariaLabel = _this$props8.ariaLabel, data = _this$props8.data, startIndex = _this$props8.startIndex, endIndex = _this$props8.endIndex;
      var x3 = Math.max(travellerX, this.props.x);
      var travellerProps = _objectSpread$d(_objectSpread$d({}, filterProps(this.props, false)), {}, {
        x: x3,
        y: y4,
        width: travellerWidth,
        height
      });
      var ariaLabelBrush = ariaLabel || "Min value: ".concat((_data$startIndex = data[startIndex]) === null || _data$startIndex === void 0 ? void 0 : _data$startIndex.name, ", Max value: ").concat((_data$endIndex = data[endIndex]) === null || _data$endIndex === void 0 ? void 0 : _data$endIndex.name);
      return /* @__PURE__ */ React__default.createElement(Layer, {
        tabIndex: 0,
        role: "slider",
        "aria-label": ariaLabelBrush,
        "aria-valuenow": travellerX,
        className: "recharts-brush-traveller",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.travellerDragStartHandlers[id2],
        onTouchStart: this.travellerDragStartHandlers[id2],
        onKeyDown: function onKeyDown(e3) {
          if (!["ArrowLeft", "ArrowRight"].includes(e3.key)) {
            return;
          }
          e3.preventDefault();
          e3.stopPropagation();
          _this3.handleTravellerMoveKeyboard(e3.key === "ArrowRight" ? 1 : -1, id2);
        },
        onFocus: function onFocus() {
          _this3.setState({
            isTravellerFocused: true
          });
        },
        onBlur: function onBlur() {
          _this3.setState({
            isTravellerFocused: false
          });
        },
        style: {
          cursor: "col-resize"
        }
      }, Brush2.renderTraveller(traveller, travellerProps));
    }
  }, {
    key: "renderSlide",
    value: function renderSlide(startX, endX) {
      var _this$props9 = this.props, y4 = _this$props9.y, height = _this$props9.height, stroke = _this$props9.stroke, travellerWidth = _this$props9.travellerWidth;
      var x3 = Math.min(startX, endX) + travellerWidth;
      var width = Math.max(Math.abs(endX - startX) - travellerWidth, 0);
      return /* @__PURE__ */ React__default.createElement("rect", {
        className: "recharts-brush-slide",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.handleSlideDragStart,
        onTouchStart: this.handleSlideDragStart,
        style: {
          cursor: "move"
        },
        stroke: "none",
        fill: stroke,
        fillOpacity: 0.2,
        x: x3,
        y: y4,
        width,
        height
      });
    }
  }, {
    key: "renderText",
    value: function renderText() {
      var _this$props10 = this.props, startIndex = _this$props10.startIndex, endIndex = _this$props10.endIndex, y4 = _this$props10.y, height = _this$props10.height, travellerWidth = _this$props10.travellerWidth, stroke = _this$props10.stroke;
      var _this$state4 = this.state, startX = _this$state4.startX, endX = _this$state4.endX;
      var offset2 = 5;
      var attrs = {
        pointerEvents: "none",
        fill: stroke
      };
      return /* @__PURE__ */ React__default.createElement(Layer, {
        className: "recharts-brush-texts"
      }, /* @__PURE__ */ React__default.createElement(Text, _extends$c({
        textAnchor: "end",
        verticalAnchor: "middle",
        x: Math.min(startX, endX) - offset2,
        y: y4 + height / 2
      }, attrs), this.getTextOfTick(startIndex)), /* @__PURE__ */ React__default.createElement(Text, _extends$c({
        textAnchor: "start",
        verticalAnchor: "middle",
        x: Math.max(startX, endX) + travellerWidth + offset2,
        y: y4 + height / 2
      }, attrs), this.getTextOfTick(endIndex)));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props11 = this.props, data = _this$props11.data, className = _this$props11.className, children = _this$props11.children, x3 = _this$props11.x, y4 = _this$props11.y, width = _this$props11.width, height = _this$props11.height, alwaysShowText = _this$props11.alwaysShowText;
      var _this$state5 = this.state, startX = _this$state5.startX, endX = _this$state5.endX, isTextActive = _this$state5.isTextActive, isSlideMoving = _this$state5.isSlideMoving, isTravellerMoving = _this$state5.isTravellerMoving, isTravellerFocused = _this$state5.isTravellerFocused;
      if (!data || !data.length || !isNumber(x3) || !isNumber(y4) || !isNumber(width) || !isNumber(height) || width <= 0 || height <= 0) {
        return null;
      }
      var layerClass = clsx("recharts-brush", className);
      var isPanoramic = React__default.Children.count(children) === 1;
      var style = generatePrefixStyle("userSelect", "none");
      return /* @__PURE__ */ React__default.createElement(Layer, {
        className: layerClass,
        onMouseLeave: this.handleLeaveWrapper,
        onTouchMove: this.handleTouchMove,
        style
      }, this.renderBackground(), isPanoramic && this.renderPanorama(), this.renderSlide(startX, endX), this.renderTravellerLayer(startX, "startX"), this.renderTravellerLayer(endX, "endX"), (isTextActive || isSlideMoving || isTravellerMoving || isTravellerFocused || alwaysShowText) && this.renderText());
    }
  }], [{
    key: "renderDefaultTraveller",
    value: function renderDefaultTraveller(props) {
      var x3 = props.x, y4 = props.y, width = props.width, height = props.height, stroke = props.stroke;
      var lineY = Math.floor(y4 + height / 2) - 1;
      return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("rect", {
        x: x3,
        y: y4,
        width,
        height,
        fill: stroke,
        stroke: "none"
      }), /* @__PURE__ */ React__default.createElement("line", {
        x1: x3 + 1,
        y1: lineY,
        x2: x3 + width - 1,
        y2: lineY,
        fill: "none",
        stroke: "#fff"
      }), /* @__PURE__ */ React__default.createElement("line", {
        x1: x3 + 1,
        y1: lineY + 2,
        x2: x3 + width - 1,
        y2: lineY + 2,
        fill: "none",
        stroke: "#fff"
      }));
    }
  }, {
    key: "renderTraveller",
    value: function renderTraveller(option, props) {
      var rectangle;
      if (/* @__PURE__ */ React__default.isValidElement(option)) {
        rectangle = /* @__PURE__ */ React__default.cloneElement(option, props);
      } else if (isFunction(option)) {
        rectangle = option(props);
      } else {
        rectangle = Brush2.renderDefaultTraveller(props);
      }
      return rectangle;
    }
  }, {
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var data = nextProps.data, width = nextProps.width, x3 = nextProps.x, travellerWidth = nextProps.travellerWidth, updateId = nextProps.updateId, startIndex = nextProps.startIndex, endIndex = nextProps.endIndex;
      if (data !== prevState.prevData || updateId !== prevState.prevUpdateId) {
        return _objectSpread$d({
          prevData: data,
          prevTravellerWidth: travellerWidth,
          prevUpdateId: updateId,
          prevX: x3,
          prevWidth: width
        }, data && data.length ? createScale({
          data,
          width,
          x: x3,
          travellerWidth,
          startIndex,
          endIndex
        }) : {
          scale: null,
          scaleValues: null
        });
      }
      if (prevState.scale && (width !== prevState.prevWidth || x3 !== prevState.prevX || travellerWidth !== prevState.prevTravellerWidth)) {
        prevState.scale.range([x3, x3 + width - travellerWidth]);
        var scaleValues = prevState.scale.domain().map(function(entry) {
          return prevState.scale(entry);
        });
        return {
          prevData: data,
          prevTravellerWidth: travellerWidth,
          prevUpdateId: updateId,
          prevX: x3,
          prevWidth: width,
          startX: prevState.scale(nextProps.startIndex),
          endX: prevState.scale(nextProps.endIndex),
          scaleValues
        };
      }
      return null;
    }
  }, {
    key: "getIndexInRange",
    value: function getIndexInRange(valueRange, x3) {
      var len = valueRange.length;
      var start = 0;
      var end = len - 1;
      while (end - start > 1) {
        var middle = Math.floor((start + end) / 2);
        if (valueRange[middle] > x3) {
          end = middle;
        } else {
          start = middle;
        }
      }
      return x3 >= valueRange[end] ? end : start;
    }
  }]);
}(PureComponent);
_defineProperty$g(Brush, "displayName", "Brush");
_defineProperty$g(Brush, "defaultProps", {
  height: 40,
  travellerWidth: 5,
  gap: 1,
  fill: "#fff",
  stroke: "#666",
  padding: {
    top: 1,
    right: 1,
    bottom: 1,
    left: 1
  },
  leaveTimeOut: 1e3,
  alwaysShowText: false
});
var _baseSome;
var hasRequired_baseSome;
function require_baseSome() {
  if (hasRequired_baseSome) return _baseSome;
  hasRequired_baseSome = 1;
  var baseEach = require_baseEach();
  function baseSome(collection, predicate) {
    var result;
    baseEach(collection, function(value, index2, collection2) {
      result = predicate(value, index2, collection2);
      return !result;
    });
    return !!result;
  }
  _baseSome = baseSome;
  return _baseSome;
}
var some_1;
var hasRequiredSome;
function requireSome() {
  if (hasRequiredSome) return some_1;
  hasRequiredSome = 1;
  var arraySome = require_arraySome(), baseIteratee = require_baseIteratee(), baseSome = require_baseSome(), isArray2 = requireIsArray(), isIterateeCall = require_isIterateeCall();
  function some2(collection, predicate, guard) {
    var func = isArray2(collection) ? arraySome : baseSome;
    if (guard && isIterateeCall(collection, predicate, guard)) {
      predicate = void 0;
    }
    return func(collection, baseIteratee(predicate, 3));
  }
  some_1 = some2;
  return some_1;
}
var someExports = requireSome();
const some = /* @__PURE__ */ getDefaultExportFromCjs(someExports);
var ifOverflowMatches = function ifOverflowMatches2(props, value) {
  var alwaysShow = props.alwaysShow;
  var ifOverflow = props.ifOverflow;
  if (alwaysShow) {
    ifOverflow = "extendDomain";
  }
  return ifOverflow === value;
};
var mapValues_1;
var hasRequiredMapValues;
function requireMapValues() {
  if (hasRequiredMapValues) return mapValues_1;
  hasRequiredMapValues = 1;
  var baseAssignValue = require_baseAssignValue(), baseForOwn = require_baseForOwn(), baseIteratee = require_baseIteratee();
  function mapValues2(object2, iteratee) {
    var result = {};
    iteratee = baseIteratee(iteratee, 3);
    baseForOwn(object2, function(value, key, object3) {
      baseAssignValue(result, key, iteratee(value, key, object3));
    });
    return result;
  }
  mapValues_1 = mapValues2;
  return mapValues_1;
}
var mapValuesExports = requireMapValues();
const mapValues = /* @__PURE__ */ getDefaultExportFromCjs(mapValuesExports);
var _arrayEvery;
var hasRequired_arrayEvery;
function require_arrayEvery() {
  if (hasRequired_arrayEvery) return _arrayEvery;
  hasRequired_arrayEvery = 1;
  function arrayEvery(array2, predicate) {
    var index2 = -1, length = array2 == null ? 0 : array2.length;
    while (++index2 < length) {
      if (!predicate(array2[index2], index2, array2)) {
        return false;
      }
    }
    return true;
  }
  _arrayEvery = arrayEvery;
  return _arrayEvery;
}
var _baseEvery;
var hasRequired_baseEvery;
function require_baseEvery() {
  if (hasRequired_baseEvery) return _baseEvery;
  hasRequired_baseEvery = 1;
  var baseEach = require_baseEach();
  function baseEvery(collection, predicate) {
    var result = true;
    baseEach(collection, function(value, index2, collection2) {
      result = !!predicate(value, index2, collection2);
      return result;
    });
    return result;
  }
  _baseEvery = baseEvery;
  return _baseEvery;
}
var every_1;
var hasRequiredEvery;
function requireEvery() {
  if (hasRequiredEvery) return every_1;
  hasRequiredEvery = 1;
  var arrayEvery = require_arrayEvery(), baseEvery = require_baseEvery(), baseIteratee = require_baseIteratee(), isArray2 = requireIsArray(), isIterateeCall = require_isIterateeCall();
  function every2(collection, predicate, guard) {
    var func = isArray2(collection) ? arrayEvery : baseEvery;
    if (guard && isIterateeCall(collection, predicate, guard)) {
      predicate = void 0;
    }
    return func(collection, baseIteratee(predicate, 3));
  }
  every_1 = every2;
  return every_1;
}
var everyExports = requireEvery();
const every = /* @__PURE__ */ getDefaultExportFromCjs(everyExports);
var _excluded$6 = ["x", "y"];
function _typeof$g(o2) {
  "@babel/helpers - typeof";
  return _typeof$g = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof$g(o2);
}
function _extends$b() {
  _extends$b = Object.assign ? Object.assign.bind() : function(target) {
    for (var i3 = 1; i3 < arguments.length; i3++) {
      var source = arguments[i3];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$b.apply(this, arguments);
}
function ownKeys$c(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e3);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$c(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$c(Object(t3), true).forEach(function(r3) {
      _defineProperty$f(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$c(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
function _defineProperty$f(obj, key, value) {
  key = _toPropertyKey$f(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$f(t3) {
  var i3 = _toPrimitive$f(t3, "string");
  return "symbol" == _typeof$g(i3) ? i3 : i3 + "";
}
function _toPrimitive$f(t3, r2) {
  if ("object" != _typeof$g(t3) || !t3) return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i3 = e3.call(t3, r2);
    if ("object" != _typeof$g(i3)) return i3;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t3);
}
function _objectWithoutProperties$6(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$6(source, excluded);
  var key, i3;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i3 = 0; i3 < sourceSymbolKeys.length; i3++) {
      key = sourceSymbolKeys[i3];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$6(source, excluded) {
  if (source == null) return {};
  var target = {};
  for (var key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function typeguardBarRectangleProps(_ref, props) {
  var xProp = _ref.x, yProp = _ref.y, option = _objectWithoutProperties$6(_ref, _excluded$6);
  var xValue = "".concat(xProp);
  var x3 = parseInt(xValue, 10);
  var yValue = "".concat(yProp);
  var y4 = parseInt(yValue, 10);
  var heightValue = "".concat(props.height || option.height);
  var height = parseInt(heightValue, 10);
  var widthValue = "".concat(props.width || option.width);
  var width = parseInt(widthValue, 10);
  return _objectSpread$c(_objectSpread$c(_objectSpread$c(_objectSpread$c(_objectSpread$c({}, props), option), x3 ? {
    x: x3
  } : {}), y4 ? {
    y: y4
  } : {}), {}, {
    height,
    width,
    name: props.name,
    radius: props.radius
  });
}
function BarRectangle(props) {
  return /* @__PURE__ */ React__default.createElement(Shape, _extends$b({
    shapeType: "rectangle",
    propTransformer: typeguardBarRectangleProps,
    activeClassName: "recharts-active-bar"
  }, props));
}
var minPointSizeCallback = function minPointSizeCallback2(minPointSize) {
  var defaultValue2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  return function(value, index2) {
    if (typeof minPointSize === "number") return minPointSize;
    var isValueNumber = typeof value === "number";
    if (isValueNumber) {
      return minPointSize(value, index2);
    }
    !isValueNumber ? process.env.NODE_ENV !== "production" ? invariant(false, "minPointSize callback function received a value with type of ".concat(_typeof$g(value), ". Currently only numbers are supported.")) : invariant() : void 0;
    return defaultValue2;
  };
};
var _excluded$5 = ["value", "background"];
var _Bar;
function _typeof$f(o2) {
  "@babel/helpers - typeof";
  return _typeof$f = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof$f(o2);
}
function _objectWithoutProperties$5(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$5(source, excluded);
  var key, i3;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i3 = 0; i3 < sourceSymbolKeys.length; i3++) {
      key = sourceSymbolKeys[i3];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$5(source, excluded) {
  if (source == null) return {};
  var target = {};
  for (var key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _extends$a() {
  _extends$a = Object.assign ? Object.assign.bind() : function(target) {
    for (var i3 = 1; i3 < arguments.length; i3++) {
      var source = arguments[i3];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$a.apply(this, arguments);
}
function ownKeys$b(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e3);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$b(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$b(Object(t3), true).forEach(function(r3) {
      _defineProperty$e(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$b(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
function _classCallCheck$b(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$b(target, props) {
  for (var i3 = 0; i3 < props.length; i3++) {
    var descriptor = props[i3];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$e(descriptor.key), descriptor);
  }
}
function _createClass$b(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$b(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$b(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _callSuper$9(t3, o2, e3) {
  return o2 = _getPrototypeOf$9(o2), _possibleConstructorReturn$9(t3, _isNativeReflectConstruct$9() ? Reflect.construct(o2, e3 || [], _getPrototypeOf$9(t3).constructor) : o2.apply(t3, e3));
}
function _possibleConstructorReturn$9(self2, call) {
  if (call && (_typeof$f(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$9(self2);
}
function _assertThisInitialized$9(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$9() {
  try {
    var t3 = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$9 = function _isNativeReflectConstruct2() {
    return !!t3;
  })();
}
function _getPrototypeOf$9(o2) {
  _getPrototypeOf$9 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o3) {
    return o3.__proto__ || Object.getPrototypeOf(o3);
  };
  return _getPrototypeOf$9(o2);
}
function _inherits$9(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass) _setPrototypeOf$9(subClass, superClass);
}
function _setPrototypeOf$9(o2, p2) {
  _setPrototypeOf$9 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o3, p3) {
    o3.__proto__ = p3;
    return o3;
  };
  return _setPrototypeOf$9(o2, p2);
}
function _defineProperty$e(obj, key, value) {
  key = _toPropertyKey$e(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$e(t3) {
  var i3 = _toPrimitive$e(t3, "string");
  return "symbol" == _typeof$f(i3) ? i3 : i3 + "";
}
function _toPrimitive$e(t3, r2) {
  if ("object" != _typeof$f(t3) || !t3) return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i3 = e3.call(t3, r2);
    if ("object" != _typeof$f(i3)) return i3;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t3);
}
var Bar$1 = /* @__PURE__ */ function(_PureComponent) {
  function Bar2() {
    var _this;
    _classCallCheck$b(this, Bar2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$9(this, Bar2, [].concat(args));
    _defineProperty$e(_this, "state", {
      isAnimationFinished: false
    });
    _defineProperty$e(_this, "id", uniqueId("recharts-bar-"));
    _defineProperty$e(_this, "handleAnimationEnd", function() {
      var onAnimationEnd2 = _this.props.onAnimationEnd;
      _this.setState({
        isAnimationFinished: true
      });
      if (onAnimationEnd2) {
        onAnimationEnd2();
      }
    });
    _defineProperty$e(_this, "handleAnimationStart", function() {
      var onAnimationStart2 = _this.props.onAnimationStart;
      _this.setState({
        isAnimationFinished: false
      });
      if (onAnimationStart2) {
        onAnimationStart2();
      }
    });
    return _this;
  }
  _inherits$9(Bar2, _PureComponent);
  return _createClass$b(Bar2, [{
    key: "renderRectanglesStatically",
    value: function renderRectanglesStatically(data) {
      var _this2 = this;
      var _this$props = this.props, shape = _this$props.shape, dataKey = _this$props.dataKey, activeIndex = _this$props.activeIndex, activeBar = _this$props.activeBar;
      var baseProps = filterProps(this.props, false);
      return data && data.map(function(entry, i3) {
        var isActive = i3 === activeIndex;
        var option = isActive ? activeBar : shape;
        var props = _objectSpread$b(_objectSpread$b(_objectSpread$b({}, baseProps), entry), {}, {
          isActive,
          option,
          index: i3,
          dataKey,
          onAnimationStart: _this2.handleAnimationStart,
          onAnimationEnd: _this2.handleAnimationEnd
        });
        return /* @__PURE__ */ React__default.createElement(Layer, _extends$a({
          className: "recharts-bar-rectangle"
        }, adaptEventsOfChild(_this2.props, entry, i3), {
          key: "rectangle-".concat(entry === null || entry === void 0 ? void 0 : entry.x, "-").concat(entry === null || entry === void 0 ? void 0 : entry.y, "-").concat(entry === null || entry === void 0 ? void 0 : entry.value)
        }), /* @__PURE__ */ React__default.createElement(BarRectangle, props));
      });
    }
  }, {
    key: "renderRectanglesWithAnimation",
    value: function renderRectanglesWithAnimation() {
      var _this3 = this;
      var _this$props2 = this.props, data = _this$props2.data, layout = _this$props2.layout, isAnimationActive = _this$props2.isAnimationActive, animationBegin = _this$props2.animationBegin, animationDuration = _this$props2.animationDuration, animationEasing = _this$props2.animationEasing, animationId = _this$props2.animationId;
      var prevData = this.state.prevData;
      return /* @__PURE__ */ React__default.createElement(Animate, {
        begin: animationBegin,
        duration: animationDuration,
        isActive: isAnimationActive,
        easing: animationEasing,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "bar-".concat(animationId),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(_ref) {
        var t3 = _ref.t;
        var stepData = data.map(function(entry, index2) {
          var prev = prevData && prevData[index2];
          if (prev) {
            var interpolatorX = interpolateNumber$2(prev.x, entry.x);
            var interpolatorY = interpolateNumber$2(prev.y, entry.y);
            var interpolatorWidth = interpolateNumber$2(prev.width, entry.width);
            var interpolatorHeight = interpolateNumber$2(prev.height, entry.height);
            return _objectSpread$b(_objectSpread$b({}, entry), {}, {
              x: interpolatorX(t3),
              y: interpolatorY(t3),
              width: interpolatorWidth(t3),
              height: interpolatorHeight(t3)
            });
          }
          if (layout === "horizontal") {
            var _interpolatorHeight = interpolateNumber$2(0, entry.height);
            var h4 = _interpolatorHeight(t3);
            return _objectSpread$b(_objectSpread$b({}, entry), {}, {
              y: entry.y + entry.height - h4,
              height: h4
            });
          }
          var interpolator = interpolateNumber$2(0, entry.width);
          var w3 = interpolator(t3);
          return _objectSpread$b(_objectSpread$b({}, entry), {}, {
            width: w3
          });
        });
        return /* @__PURE__ */ React__default.createElement(Layer, null, _this3.renderRectanglesStatically(stepData));
      });
    }
  }, {
    key: "renderRectangles",
    value: function renderRectangles() {
      var _this$props3 = this.props, data = _this$props3.data, isAnimationActive = _this$props3.isAnimationActive;
      var prevData = this.state.prevData;
      if (isAnimationActive && data && data.length && (!prevData || !isEqual(prevData, data))) {
        return this.renderRectanglesWithAnimation();
      }
      return this.renderRectanglesStatically(data);
    }
  }, {
    key: "renderBackground",
    value: function renderBackground() {
      var _this4 = this;
      var _this$props4 = this.props, data = _this$props4.data, dataKey = _this$props4.dataKey, activeIndex = _this$props4.activeIndex;
      var backgroundProps = filterProps(this.props.background, false);
      return data.map(function(entry, i3) {
        entry.value;
        var background = entry.background, rest = _objectWithoutProperties$5(entry, _excluded$5);
        if (!background) {
          return null;
        }
        var props = _objectSpread$b(_objectSpread$b(_objectSpread$b(_objectSpread$b(_objectSpread$b({}, rest), {}, {
          fill: "#eee"
        }, background), backgroundProps), adaptEventsOfChild(_this4.props, entry, i3)), {}, {
          onAnimationStart: _this4.handleAnimationStart,
          onAnimationEnd: _this4.handleAnimationEnd,
          dataKey,
          index: i3,
          className: "recharts-bar-background-rectangle"
        });
        return /* @__PURE__ */ React__default.createElement(BarRectangle, _extends$a({
          key: "background-bar-".concat(i3),
          option: _this4.props.background,
          isActive: i3 === activeIndex
        }, props));
      });
    }
  }, {
    key: "renderErrorBar",
    value: function renderErrorBar(needClip, clipPathId) {
      if (this.props.isAnimationActive && !this.state.isAnimationFinished) {
        return null;
      }
      var _this$props5 = this.props, data = _this$props5.data, xAxis = _this$props5.xAxis, yAxis = _this$props5.yAxis, layout = _this$props5.layout, children = _this$props5.children;
      var errorBarItems = findAllByType(children, ErrorBar);
      if (!errorBarItems) {
        return null;
      }
      var offset2 = layout === "vertical" ? data[0].height / 2 : data[0].width / 2;
      var dataPointFormatter = function dataPointFormatter2(dataPoint, dataKey) {
        var value = Array.isArray(dataPoint.value) ? dataPoint.value[1] : dataPoint.value;
        return {
          x: dataPoint.x,
          y: dataPoint.y,
          value,
          errorVal: getValueByDataKey(dataPoint, dataKey)
        };
      };
      var errorBarProps = {
        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
      };
      return /* @__PURE__ */ React__default.createElement(Layer, errorBarProps, errorBarItems.map(function(item) {
        return /* @__PURE__ */ React__default.cloneElement(item, {
          key: "error-bar-".concat(clipPathId, "-").concat(item.props.dataKey),
          data,
          xAxis,
          yAxis,
          layout,
          offset: offset2,
          dataPointFormatter
        });
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props, hide2 = _this$props6.hide, data = _this$props6.data, className = _this$props6.className, xAxis = _this$props6.xAxis, yAxis = _this$props6.yAxis, left = _this$props6.left, top = _this$props6.top, width = _this$props6.width, height = _this$props6.height, isAnimationActive = _this$props6.isAnimationActive, background = _this$props6.background, id2 = _this$props6.id;
      if (hide2 || !data || !data.length) {
        return null;
      }
      var isAnimationFinished = this.state.isAnimationFinished;
      var layerClass = clsx("recharts-bar", className);
      var needClipX = xAxis && xAxis.allowDataOverflow;
      var needClipY = yAxis && yAxis.allowDataOverflow;
      var needClip = needClipX || needClipY;
      var clipPathId = isNil(id2) ? this.id : id2;
      return /* @__PURE__ */ React__default.createElement(Layer, {
        className: layerClass
      }, needClipX || needClipY ? /* @__PURE__ */ React__default.createElement("defs", null, /* @__PURE__ */ React__default.createElement("clipPath", {
        id: "clipPath-".concat(clipPathId)
      }, /* @__PURE__ */ React__default.createElement("rect", {
        x: needClipX ? left : left - width / 2,
        y: needClipY ? top : top - height / 2,
        width: needClipX ? width : width * 2,
        height: needClipY ? height : height * 2
      }))) : null, /* @__PURE__ */ React__default.createElement(Layer, {
        className: "recharts-bar-rectangles",
        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
      }, background ? this.renderBackground() : null, this.renderRectangles()), this.renderErrorBar(needClip, clipPathId), (!isAnimationActive || isAnimationFinished) && LabelList.renderCallByParent(this.props, data));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.animationId !== prevState.prevAnimationId) {
        return {
          prevAnimationId: nextProps.animationId,
          curData: nextProps.data,
          prevData: prevState.curData
        };
      }
      if (nextProps.data !== prevState.curData) {
        return {
          curData: nextProps.data
        };
      }
      return null;
    }
  }]);
}(PureComponent);
_Bar = Bar$1;
_defineProperty$e(Bar$1, "displayName", "Bar");
_defineProperty$e(Bar$1, "defaultProps", {
  xAxisId: 0,
  yAxisId: 0,
  legendType: "rect",
  minPointSize: 0,
  hide: false,
  data: [],
  layout: "vertical",
  activeBar: false,
  isAnimationActive: !Global.isSsr,
  animationBegin: 0,
  animationDuration: 400,
  animationEasing: "ease"
});
_defineProperty$e(Bar$1, "getComposedData", function(_ref2) {
  var props = _ref2.props, item = _ref2.item, barPosition = _ref2.barPosition, bandSize = _ref2.bandSize, xAxis = _ref2.xAxis, yAxis = _ref2.yAxis, xAxisTicks = _ref2.xAxisTicks, yAxisTicks = _ref2.yAxisTicks, stackedData = _ref2.stackedData, dataStartIndex = _ref2.dataStartIndex, displayedData = _ref2.displayedData, offset2 = _ref2.offset;
  var pos = findPositionOfBar(barPosition, item);
  if (!pos) {
    return null;
  }
  var layout = props.layout;
  var itemDefaultProps = item.type.defaultProps;
  var itemProps = itemDefaultProps !== void 0 ? _objectSpread$b(_objectSpread$b({}, itemDefaultProps), item.props) : item.props;
  var dataKey = itemProps.dataKey, children = itemProps.children, minPointSizeProp = itemProps.minPointSize;
  var numericAxis = layout === "horizontal" ? yAxis : xAxis;
  var stackedDomain = stackedData ? numericAxis.scale.domain() : null;
  var baseValue = getBaseValueOfBar({
    numericAxis
  });
  var cells = findAllByType(children, Cell);
  var rects = displayedData.map(function(entry, index2) {
    var value, x3, y4, width, height, background;
    if (stackedData) {
      value = truncateByDomain(stackedData[dataStartIndex + index2], stackedDomain);
    } else {
      value = getValueByDataKey(entry, dataKey);
      if (!Array.isArray(value)) {
        value = [baseValue, value];
      }
    }
    var minPointSize = minPointSizeCallback(minPointSizeProp, _Bar.defaultProps.minPointSize)(value[1], index2);
    if (layout === "horizontal") {
      var _ref4;
      var _ref3 = [yAxis.scale(value[0]), yAxis.scale(value[1])], baseValueScale = _ref3[0], currentValueScale = _ref3[1];
      x3 = getCateCoordinateOfBar({
        axis: xAxis,
        ticks: xAxisTicks,
        bandSize,
        offset: pos.offset,
        entry,
        index: index2
      });
      y4 = (_ref4 = currentValueScale !== null && currentValueScale !== void 0 ? currentValueScale : baseValueScale) !== null && _ref4 !== void 0 ? _ref4 : void 0;
      width = pos.size;
      var computedHeight = baseValueScale - currentValueScale;
      height = Number.isNaN(computedHeight) ? 0 : computedHeight;
      background = {
        x: x3,
        y: yAxis.y,
        width,
        height: yAxis.height
      };
      if (Math.abs(minPointSize) > 0 && Math.abs(height) < Math.abs(minPointSize)) {
        var delta = mathSign(height || minPointSize) * (Math.abs(minPointSize) - Math.abs(height));
        y4 -= delta;
        height += delta;
      }
    } else {
      var _ref5 = [xAxis.scale(value[0]), xAxis.scale(value[1])], _baseValueScale = _ref5[0], _currentValueScale = _ref5[1];
      x3 = _baseValueScale;
      y4 = getCateCoordinateOfBar({
        axis: yAxis,
        ticks: yAxisTicks,
        bandSize,
        offset: pos.offset,
        entry,
        index: index2
      });
      width = _currentValueScale - _baseValueScale;
      height = pos.size;
      background = {
        x: xAxis.x,
        y: y4,
        width: xAxis.width,
        height
      };
      if (Math.abs(minPointSize) > 0 && Math.abs(width) < Math.abs(minPointSize)) {
        var _delta = mathSign(width || minPointSize) * (Math.abs(minPointSize) - Math.abs(width));
        width += _delta;
      }
    }
    return _objectSpread$b(_objectSpread$b(_objectSpread$b({}, entry), {}, {
      x: x3,
      y: y4,
      width,
      height,
      value: stackedData ? value : value[1],
      payload: entry,
      background
    }, cells && cells[index2] && cells[index2].props), {}, {
      tooltipPayload: [getTooltipItem(item, entry)],
      tooltipPosition: {
        x: x3 + width / 2,
        y: y4 + height / 2
      }
    });
  });
  return _objectSpread$b({
    data: rects,
    layout
  }, offset2);
});
function _typeof$e(o2) {
  "@babel/helpers - typeof";
  return _typeof$e = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof$e(o2);
}
function _classCallCheck$a(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$a(target, props) {
  for (var i3 = 0; i3 < props.length; i3++) {
    var descriptor = props[i3];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$d(descriptor.key), descriptor);
  }
}
function _createClass$a(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$a(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$a(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function ownKeys$a(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e3);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$a(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$a(Object(t3), true).forEach(function(r3) {
      _defineProperty$d(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$a(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
function _defineProperty$d(obj, key, value) {
  key = _toPropertyKey$d(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$d(t3) {
  var i3 = _toPrimitive$d(t3, "string");
  return "symbol" == _typeof$e(i3) ? i3 : i3 + "";
}
function _toPrimitive$d(t3, r2) {
  if ("object" != _typeof$e(t3) || !t3) return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i3 = e3.call(t3, r2);
    if ("object" != _typeof$e(i3)) return i3;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t3);
}
var formatAxisMap2 = function formatAxisMap3(props, axisMap, offset2, axisType, chartName) {
  var width = props.width, height = props.height, layout = props.layout, children = props.children;
  var ids2 = Object.keys(axisMap);
  var steps2 = {
    left: offset2.left,
    leftMirror: offset2.left,
    right: width - offset2.right,
    rightMirror: width - offset2.right,
    top: offset2.top,
    topMirror: offset2.top,
    bottom: height - offset2.bottom,
    bottomMirror: height - offset2.bottom
  };
  var hasBar = !!findChildByType(children, Bar$1);
  return ids2.reduce(function(result, id2) {
    var axis = axisMap[id2];
    var orientation = axis.orientation, domain = axis.domain, _axis$padding = axis.padding, padding = _axis$padding === void 0 ? {} : _axis$padding, mirror = axis.mirror, reversed = axis.reversed;
    var offsetKey = "".concat(orientation).concat(mirror ? "Mirror" : "");
    var calculatedPadding, range3, x3, y4, needSpace;
    if (axis.type === "number" && (axis.padding === "gap" || axis.padding === "no-gap")) {
      var diff = domain[1] - domain[0];
      var smallestDistanceBetweenValues = Infinity;
      var sortedValues = axis.categoricalDomain.sort();
      sortedValues.forEach(function(value, index2) {
        if (index2 > 0) {
          smallestDistanceBetweenValues = Math.min((value || 0) - (sortedValues[index2 - 1] || 0), smallestDistanceBetweenValues);
        }
      });
      if (Number.isFinite(smallestDistanceBetweenValues)) {
        var smallestDistanceInPercent = smallestDistanceBetweenValues / diff;
        var rangeWidth = axis.layout === "vertical" ? offset2.height : offset2.width;
        if (axis.padding === "gap") {
          calculatedPadding = smallestDistanceInPercent * rangeWidth / 2;
        }
        if (axis.padding === "no-gap") {
          var gap = getPercentValue(props.barCategoryGap, smallestDistanceInPercent * rangeWidth);
          var halfBand = smallestDistanceInPercent * rangeWidth / 2;
          calculatedPadding = halfBand - gap - (halfBand - gap) / rangeWidth * gap;
        }
      }
    }
    if (axisType === "xAxis") {
      range3 = [offset2.left + (padding.left || 0) + (calculatedPadding || 0), offset2.left + offset2.width - (padding.right || 0) - (calculatedPadding || 0)];
    } else if (axisType === "yAxis") {
      range3 = layout === "horizontal" ? [offset2.top + offset2.height - (padding.bottom || 0), offset2.top + (padding.top || 0)] : [offset2.top + (padding.top || 0) + (calculatedPadding || 0), offset2.top + offset2.height - (padding.bottom || 0) - (calculatedPadding || 0)];
    } else {
      range3 = axis.range;
    }
    if (reversed) {
      range3 = [range3[1], range3[0]];
    }
    var _parseScale = parseScale(axis, chartName, hasBar), scale2 = _parseScale.scale, realScaleType = _parseScale.realScaleType;
    scale2.domain(domain).range(range3);
    checkDomainOfScale(scale2);
    var ticks2 = getTicksOfScale(scale2, _objectSpread$a(_objectSpread$a({}, axis), {}, {
      realScaleType
    }));
    if (axisType === "xAxis") {
      needSpace = orientation === "top" && !mirror || orientation === "bottom" && mirror;
      x3 = offset2.left;
      y4 = steps2[offsetKey] - needSpace * axis.height;
    } else if (axisType === "yAxis") {
      needSpace = orientation === "left" && !mirror || orientation === "right" && mirror;
      x3 = steps2[offsetKey] - needSpace * axis.width;
      y4 = offset2.top;
    }
    var finalAxis = _objectSpread$a(_objectSpread$a(_objectSpread$a({}, axis), ticks2), {}, {
      realScaleType,
      x: x3,
      y: y4,
      scale: scale2,
      width: axisType === "xAxis" ? offset2.width : axis.width,
      height: axisType === "yAxis" ? offset2.height : axis.height
    });
    finalAxis.bandSize = getBandSizeOfAxis(finalAxis, ticks2);
    if (!axis.hide && axisType === "xAxis") {
      steps2[offsetKey] += (needSpace ? -1 : 1) * finalAxis.height;
    } else if (!axis.hide) {
      steps2[offsetKey] += (needSpace ? -1 : 1) * finalAxis.width;
    }
    return _objectSpread$a(_objectSpread$a({}, result), {}, _defineProperty$d({}, id2, finalAxis));
  }, {});
};
var rectWithPoints = function rectWithPoints2(_ref, _ref2) {
  var x1 = _ref.x, y1 = _ref.y;
  var x22 = _ref2.x, y22 = _ref2.y;
  return {
    x: Math.min(x1, x22),
    y: Math.min(y1, y22),
    width: Math.abs(x22 - x1),
    height: Math.abs(y22 - y1)
  };
};
var rectWithCoords = function rectWithCoords2(_ref3) {
  var x1 = _ref3.x1, y1 = _ref3.y1, x22 = _ref3.x2, y22 = _ref3.y2;
  return rectWithPoints({
    x: x1,
    y: y1
  }, {
    x: x22,
    y: y22
  });
};
var ScaleHelper = /* @__PURE__ */ function() {
  function ScaleHelper2(scale2) {
    _classCallCheck$a(this, ScaleHelper2);
    this.scale = scale2;
  }
  return _createClass$a(ScaleHelper2, [{
    key: "domain",
    get: function get2() {
      return this.scale.domain;
    }
  }, {
    key: "range",
    get: function get2() {
      return this.scale.range;
    }
  }, {
    key: "rangeMin",
    get: function get2() {
      return this.range()[0];
    }
  }, {
    key: "rangeMax",
    get: function get2() {
      return this.range()[1];
    }
  }, {
    key: "bandwidth",
    get: function get2() {
      return this.scale.bandwidth;
    }
  }, {
    key: "apply",
    value: function apply(value) {
      var _ref4 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, bandAware = _ref4.bandAware, position = _ref4.position;
      if (value === void 0) {
        return void 0;
      }
      if (position) {
        switch (position) {
          case "start": {
            return this.scale(value);
          }
          case "middle": {
            var offset2 = this.bandwidth ? this.bandwidth() / 2 : 0;
            return this.scale(value) + offset2;
          }
          case "end": {
            var _offset = this.bandwidth ? this.bandwidth() : 0;
            return this.scale(value) + _offset;
          }
          default: {
            return this.scale(value);
          }
        }
      }
      if (bandAware) {
        var _offset2 = this.bandwidth ? this.bandwidth() / 2 : 0;
        return this.scale(value) + _offset2;
      }
      return this.scale(value);
    }
  }, {
    key: "isInRange",
    value: function isInRange(value) {
      var range3 = this.range();
      var first = range3[0];
      var last2 = range3[range3.length - 1];
      return first <= last2 ? value >= first && value <= last2 : value >= last2 && value <= first;
    }
  }], [{
    key: "create",
    value: function create(obj) {
      return new ScaleHelper2(obj);
    }
  }]);
}();
_defineProperty$d(ScaleHelper, "EPS", 1e-4);
var createLabeledScales = function createLabeledScales2(options) {
  var scales = Object.keys(options).reduce(function(res, key) {
    return _objectSpread$a(_objectSpread$a({}, res), {}, _defineProperty$d({}, key, ScaleHelper.create(options[key])));
  }, {});
  return _objectSpread$a(_objectSpread$a({}, scales), {}, {
    apply: function apply(coord) {
      var _ref5 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, bandAware = _ref5.bandAware, position = _ref5.position;
      return mapValues(coord, function(value, label) {
        return scales[label].apply(value, {
          bandAware,
          position
        });
      });
    },
    isInRange: function isInRange(coord) {
      return every(coord, function(value, label) {
        return scales[label].isInRange(value);
      });
    }
  });
};
function normalizeAngle(angle) {
  return (angle % 180 + 180) % 180;
}
var getAngledRectangleWidth = function getAngledRectangleWidth2(_ref6) {
  var width = _ref6.width, height = _ref6.height;
  var angle = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  var normalizedAngle = normalizeAngle(angle);
  var angleRadians = normalizedAngle * Math.PI / 180;
  var angleThreshold = Math.atan(height / width);
  var angledWidth = angleRadians > angleThreshold && angleRadians < Math.PI - angleThreshold ? height / Math.sin(angleRadians) : width / Math.cos(angleRadians);
  return Math.abs(angledWidth);
};
var _createFind;
var hasRequired_createFind;
function require_createFind() {
  if (hasRequired_createFind) return _createFind;
  hasRequired_createFind = 1;
  var baseIteratee = require_baseIteratee(), isArrayLike = requireIsArrayLike(), keys2 = requireKeys();
  function createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
      var iterable = Object(collection);
      if (!isArrayLike(collection)) {
        var iteratee = baseIteratee(predicate, 3);
        collection = keys2(collection);
        predicate = function(key) {
          return iteratee(iterable[key], key, iterable);
        };
      }
      var index2 = findIndexFunc(collection, predicate, fromIndex);
      return index2 > -1 ? iterable[iteratee ? collection[index2] : index2] : void 0;
    };
  }
  _createFind = createFind;
  return _createFind;
}
var toInteger_1;
var hasRequiredToInteger;
function requireToInteger() {
  if (hasRequiredToInteger) return toInteger_1;
  hasRequiredToInteger = 1;
  var toFinite = requireToFinite();
  function toInteger2(value) {
    var result = toFinite(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
  }
  toInteger_1 = toInteger2;
  return toInteger_1;
}
var findIndex_1;
var hasRequiredFindIndex;
function requireFindIndex() {
  if (hasRequiredFindIndex) return findIndex_1;
  hasRequiredFindIndex = 1;
  var baseFindIndex = require_baseFindIndex(), baseIteratee = require_baseIteratee(), toInteger2 = requireToInteger();
  var nativeMax = Math.max;
  function findIndex2(array2, predicate, fromIndex) {
    var length = array2 == null ? 0 : array2.length;
    if (!length) {
      return -1;
    }
    var index2 = fromIndex == null ? 0 : toInteger2(fromIndex);
    if (index2 < 0) {
      index2 = nativeMax(length + index2, 0);
    }
    return baseFindIndex(array2, baseIteratee(predicate, 3), index2);
  }
  findIndex_1 = findIndex2;
  return findIndex_1;
}
var find_1;
var hasRequiredFind;
function requireFind() {
  if (hasRequiredFind) return find_1;
  hasRequiredFind = 1;
  var createFind = require_createFind(), findIndex2 = requireFindIndex();
  var find2 = createFind(findIndex2);
  find_1 = find2;
  return find_1;
}
var findExports = requireFind();
const find = /* @__PURE__ */ getDefaultExportFromCjs(findExports);
var memoizeExports = requireMemoize();
const memoize2 = /* @__PURE__ */ getDefaultExportFromCjs(memoizeExports);
var calculateViewBox = memoize2(function(offset2) {
  return {
    x: offset2.left,
    y: offset2.top,
    width: offset2.width,
    height: offset2.height
  };
}, function(offset2) {
  return ["l", offset2.left, "t", offset2.top, "w", offset2.width, "h", offset2.height].join("");
});
function _typeof$d(o2) {
  "@babel/helpers - typeof";
  return _typeof$d = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof$d(o2);
}
var XAxisContext = /* @__PURE__ */ createContext(void 0);
var YAxisContext = /* @__PURE__ */ createContext(void 0);
var ViewBoxContext = /* @__PURE__ */ createContext(void 0);
var OffsetContext = /* @__PURE__ */ createContext({});
var ClipPathIdContext = /* @__PURE__ */ createContext(void 0);
var ChartHeightContext = /* @__PURE__ */ createContext(0);
var ChartWidthContext = /* @__PURE__ */ createContext(0);
var ChartLayoutContextProvider = function ChartLayoutContextProvider2(props) {
  var _props$state = props.state, xAxisMap = _props$state.xAxisMap, yAxisMap = _props$state.yAxisMap, offset2 = _props$state.offset, clipPathId = props.clipPathId, children = props.children, width = props.width, height = props.height;
  var viewBox = calculateViewBox(offset2);
  return /* @__PURE__ */ React__default.createElement(XAxisContext.Provider, {
    value: xAxisMap
  }, /* @__PURE__ */ React__default.createElement(YAxisContext.Provider, {
    value: yAxisMap
  }, /* @__PURE__ */ React__default.createElement(OffsetContext.Provider, {
    value: offset2
  }, /* @__PURE__ */ React__default.createElement(ViewBoxContext.Provider, {
    value: viewBox
  }, /* @__PURE__ */ React__default.createElement(ClipPathIdContext.Provider, {
    value: clipPathId
  }, /* @__PURE__ */ React__default.createElement(ChartHeightContext.Provider, {
    value: height
  }, /* @__PURE__ */ React__default.createElement(ChartWidthContext.Provider, {
    value: width
  }, children)))))));
};
var useClipPathId = function useClipPathId2() {
  return useContext(ClipPathIdContext);
};
function getKeysForDebug(object2) {
  var keys2 = Object.keys(object2);
  if (keys2.length === 0) {
    return "There are no available ids.";
  }
  return "Available ids are: ".concat(keys2, ".");
}
var useXAxisOrThrow = function useXAxisOrThrow2(xAxisId) {
  var xAxisMap = useContext(XAxisContext);
  !(xAxisMap != null) ? process.env.NODE_ENV !== "production" ? invariant(false, "Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?") : invariant() : void 0;
  var xAxis = xAxisMap[xAxisId];
  !(xAxis != null) ? process.env.NODE_ENV !== "production" ? invariant(false, 'Could not find xAxis by id "'.concat(xAxisId, '" [').concat(_typeof$d(xAxisId), "]. ").concat(getKeysForDebug(xAxisMap))) : invariant() : void 0;
  return xAxis;
};
var useArbitraryXAxis = function useArbitraryXAxis2() {
  var xAxisMap = useContext(XAxisContext);
  return getAnyElementOfObject(xAxisMap);
};
var useYAxisWithFiniteDomainOrRandom = function useYAxisWithFiniteDomainOrRandom2() {
  var yAxisMap = useContext(YAxisContext);
  var yAxisWithFiniteDomain = find(yAxisMap, function(axis) {
    return every(axis.domain, Number.isFinite);
  });
  return yAxisWithFiniteDomain || getAnyElementOfObject(yAxisMap);
};
var useYAxisOrThrow = function useYAxisOrThrow2(yAxisId) {
  var yAxisMap = useContext(YAxisContext);
  !(yAxisMap != null) ? process.env.NODE_ENV !== "production" ? invariant(false, "Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?") : invariant() : void 0;
  var yAxis = yAxisMap[yAxisId];
  !(yAxis != null) ? process.env.NODE_ENV !== "production" ? invariant(false, 'Could not find yAxis by id "'.concat(yAxisId, '" [').concat(_typeof$d(yAxisId), "]. ").concat(getKeysForDebug(yAxisMap))) : invariant() : void 0;
  return yAxis;
};
var useViewBox = function useViewBox2() {
  var viewBox = useContext(ViewBoxContext);
  return viewBox;
};
var useOffset = function useOffset2() {
  return useContext(OffsetContext);
};
var useChartWidth = function useChartWidth2() {
  return useContext(ChartWidthContext);
};
var useChartHeight = function useChartHeight2() {
  return useContext(ChartHeightContext);
};
function _typeof$c(o2) {
  "@babel/helpers - typeof";
  return _typeof$c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof$c(o2);
}
function _classCallCheck$9(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$9(target, props) {
  for (var i3 = 0; i3 < props.length; i3++) {
    var descriptor = props[i3];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$c(descriptor.key), descriptor);
  }
}
function _createClass$9(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$9(Constructor.prototype, protoProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _callSuper$8(t3, o2, e3) {
  return o2 = _getPrototypeOf$8(o2), _possibleConstructorReturn$8(t3, _isNativeReflectConstruct$8() ? Reflect.construct(o2, e3 || [], _getPrototypeOf$8(t3).constructor) : o2.apply(t3, e3));
}
function _possibleConstructorReturn$8(self2, call) {
  if (call && (_typeof$c(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$8(self2);
}
function _assertThisInitialized$8(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$8() {
  try {
    var t3 = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$8 = function _isNativeReflectConstruct2() {
    return !!t3;
  })();
}
function _getPrototypeOf$8(o2) {
  _getPrototypeOf$8 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o3) {
    return o3.__proto__ || Object.getPrototypeOf(o3);
  };
  return _getPrototypeOf$8(o2);
}
function _inherits$8(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass) _setPrototypeOf$8(subClass, superClass);
}
function _setPrototypeOf$8(o2, p2) {
  _setPrototypeOf$8 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o3, p3) {
    o3.__proto__ = p3;
    return o3;
  };
  return _setPrototypeOf$8(o2, p2);
}
function ownKeys$9(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e3);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$9(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$9(Object(t3), true).forEach(function(r3) {
      _defineProperty$c(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$9(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
function _defineProperty$c(obj, key, value) {
  key = _toPropertyKey$c(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$c(t3) {
  var i3 = _toPrimitive$c(t3, "string");
  return "symbol" == _typeof$c(i3) ? i3 : i3 + "";
}
function _toPrimitive$c(t3, r2) {
  if ("object" != _typeof$c(t3) || !t3) return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i3 = e3.call(t3, r2);
    if ("object" != _typeof$c(i3)) return i3;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t3);
}
function _slicedToArray$1(arr, i3) {
  return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i3) || _unsupportedIterableToArray$3(arr, i3) || _nonIterableRest$1();
}
function _nonIterableRest$1() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$3(o2, minLen) {
  if (!o2) return;
  if (typeof o2 === "string") return _arrayLikeToArray$3(o2, minLen);
  var n2 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n2 === "Object" && o2.constructor) n2 = o2.constructor.name;
  if (n2 === "Map" || n2 === "Set") return Array.from(o2);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray$3(o2, minLen);
}
function _arrayLikeToArray$3(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i3 = 0, arr2 = new Array(len); i3 < len; i3++) arr2[i3] = arr[i3];
  return arr2;
}
function _iterableToArrayLimit$1(r2, l2) {
  var t3 = null == r2 ? null : "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];
  if (null != t3) {
    var e3, n2, i3, u3, a4 = [], f2 = true, o2 = false;
    try {
      if (i3 = (t3 = t3.call(r2)).next, 0 === l2) ;
      else for (; !(f2 = (e3 = i3.call(t3)).done) && (a4.push(e3.value), a4.length !== l2); f2 = true) ;
    } catch (r3) {
      o2 = true, n2 = r3;
    } finally {
      try {
        if (!f2 && null != t3["return"] && (u3 = t3["return"](), Object(u3) !== u3)) return;
      } finally {
        if (o2) throw n2;
      }
    }
    return a4;
  }
}
function _arrayWithHoles$1(arr) {
  if (Array.isArray(arr)) return arr;
}
function _extends$9() {
  _extends$9 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i3 = 1; i3 < arguments.length; i3++) {
      var source = arguments[i3];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$9.apply(this, arguments);
}
var renderLine = function renderLine2(option, props) {
  var line;
  if (/* @__PURE__ */ React__default.isValidElement(option)) {
    line = /* @__PURE__ */ React__default.cloneElement(option, props);
  } else if (isFunction(option)) {
    line = option(props);
  } else {
    line = /* @__PURE__ */ React__default.createElement("line", _extends$9({}, props, {
      className: "recharts-reference-line-line"
    }));
  }
  return line;
};
var getEndPoints = function getEndPoints2(scales, isFixedX, isFixedY, isSegment, viewBox, position, xAxisOrientation, yAxisOrientation, props) {
  var x3 = viewBox.x, y4 = viewBox.y, width = viewBox.width, height = viewBox.height;
  if (isFixedY) {
    var yCoord = props.y;
    var coord = scales.y.apply(yCoord, {
      position
    });
    if (ifOverflowMatches(props, "discard") && !scales.y.isInRange(coord)) {
      return null;
    }
    var points = [{
      x: x3 + width,
      y: coord
    }, {
      x: x3,
      y: coord
    }];
    return yAxisOrientation === "left" ? points.reverse() : points;
  }
  if (isFixedX) {
    var xCoord = props.x;
    var _coord = scales.x.apply(xCoord, {
      position
    });
    if (ifOverflowMatches(props, "discard") && !scales.x.isInRange(_coord)) {
      return null;
    }
    var _points = [{
      x: _coord,
      y: y4 + height
    }, {
      x: _coord,
      y: y4
    }];
    return xAxisOrientation === "top" ? _points.reverse() : _points;
  }
  if (isSegment) {
    var segment = props.segment;
    var _points2 = segment.map(function(p2) {
      return scales.apply(p2, {
        position
      });
    });
    if (ifOverflowMatches(props, "discard") && some(_points2, function(p2) {
      return !scales.isInRange(p2);
    })) {
      return null;
    }
    return _points2;
  }
  return null;
};
function ReferenceLineImpl(props) {
  var fixedX = props.x, fixedY = props.y, segment = props.segment, xAxisId = props.xAxisId, yAxisId = props.yAxisId, shape = props.shape, className = props.className, alwaysShow = props.alwaysShow;
  var clipPathId = useClipPathId();
  var xAxis = useXAxisOrThrow(xAxisId);
  var yAxis = useYAxisOrThrow(yAxisId);
  var viewBox = useViewBox();
  if (!clipPathId || !viewBox) {
    return null;
  }
  warn$1(alwaysShow === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
  var scales = createLabeledScales({
    x: xAxis.scale,
    y: yAxis.scale
  });
  var isX = isNumOrStr(fixedX);
  var isY = isNumOrStr(fixedY);
  var isSegment = segment && segment.length === 2;
  var endPoints = getEndPoints(scales, isX, isY, isSegment, viewBox, props.position, xAxis.orientation, yAxis.orientation, props);
  if (!endPoints) {
    return null;
  }
  var _endPoints = _slicedToArray$1(endPoints, 2), _endPoints$ = _endPoints[0], x1 = _endPoints$.x, y1 = _endPoints$.y, _endPoints$2 = _endPoints[1], x22 = _endPoints$2.x, y22 = _endPoints$2.y;
  var clipPath = ifOverflowMatches(props, "hidden") ? "url(#".concat(clipPathId, ")") : void 0;
  var lineProps = _objectSpread$9(_objectSpread$9({
    clipPath
  }, filterProps(props, true)), {}, {
    x1,
    y1,
    x2: x22,
    y2: y22
  });
  return /* @__PURE__ */ React__default.createElement(Layer, {
    className: clsx("recharts-reference-line", className)
  }, renderLine(shape, lineProps), Label$1.renderCallByParent(props, rectWithCoords({
    x1,
    y1,
    x2: x22,
    y2: y22
  })));
}
var ReferenceLine = /* @__PURE__ */ function(_React$Component) {
  function ReferenceLine2() {
    _classCallCheck$9(this, ReferenceLine2);
    return _callSuper$8(this, ReferenceLine2, arguments);
  }
  _inherits$8(ReferenceLine2, _React$Component);
  return _createClass$9(ReferenceLine2, [{
    key: "render",
    value: function render() {
      return /* @__PURE__ */ React__default.createElement(ReferenceLineImpl, this.props);
    }
  }]);
}(React__default.Component);
_defineProperty$c(ReferenceLine, "displayName", "ReferenceLine");
_defineProperty$c(ReferenceLine, "defaultProps", {
  isFront: false,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  fill: "none",
  stroke: "#ccc",
  fillOpacity: 1,
  strokeWidth: 1,
  position: "middle"
});
function _extends$8() {
  _extends$8 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i3 = 1; i3 < arguments.length; i3++) {
      var source = arguments[i3];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$8.apply(this, arguments);
}
function _typeof$b(o2) {
  "@babel/helpers - typeof";
  return _typeof$b = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof$b(o2);
}
function ownKeys$8(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e3);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$8(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$8(Object(t3), true).forEach(function(r3) {
      _defineProperty$b(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$8(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
function _classCallCheck$8(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$8(target, props) {
  for (var i3 = 0; i3 < props.length; i3++) {
    var descriptor = props[i3];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$b(descriptor.key), descriptor);
  }
}
function _createClass$8(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$8(Constructor.prototype, protoProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _callSuper$7(t3, o2, e3) {
  return o2 = _getPrototypeOf$7(o2), _possibleConstructorReturn$7(t3, _isNativeReflectConstruct$7() ? Reflect.construct(o2, e3 || [], _getPrototypeOf$7(t3).constructor) : o2.apply(t3, e3));
}
function _possibleConstructorReturn$7(self2, call) {
  if (call && (_typeof$b(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$7(self2);
}
function _assertThisInitialized$7(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$7() {
  try {
    var t3 = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$7 = function _isNativeReflectConstruct2() {
    return !!t3;
  })();
}
function _getPrototypeOf$7(o2) {
  _getPrototypeOf$7 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o3) {
    return o3.__proto__ || Object.getPrototypeOf(o3);
  };
  return _getPrototypeOf$7(o2);
}
function _inherits$7(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass) _setPrototypeOf$7(subClass, superClass);
}
function _setPrototypeOf$7(o2, p2) {
  _setPrototypeOf$7 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o3, p3) {
    o3.__proto__ = p3;
    return o3;
  };
  return _setPrototypeOf$7(o2, p2);
}
function _defineProperty$b(obj, key, value) {
  key = _toPropertyKey$b(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$b(t3) {
  var i3 = _toPrimitive$b(t3, "string");
  return "symbol" == _typeof$b(i3) ? i3 : i3 + "";
}
function _toPrimitive$b(t3, r2) {
  if ("object" != _typeof$b(t3) || !t3) return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i3 = e3.call(t3, r2);
    if ("object" != _typeof$b(i3)) return i3;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t3);
}
var getCoordinate = function getCoordinate2(props) {
  var x3 = props.x, y4 = props.y, xAxis = props.xAxis, yAxis = props.yAxis;
  var scales = createLabeledScales({
    x: xAxis.scale,
    y: yAxis.scale
  });
  var result = scales.apply({
    x: x3,
    y: y4
  }, {
    bandAware: true
  });
  if (ifOverflowMatches(props, "discard") && !scales.isInRange(result)) {
    return null;
  }
  return result;
};
var ReferenceDot = /* @__PURE__ */ function(_React$Component) {
  function ReferenceDot2() {
    _classCallCheck$8(this, ReferenceDot2);
    return _callSuper$7(this, ReferenceDot2, arguments);
  }
  _inherits$7(ReferenceDot2, _React$Component);
  return _createClass$8(ReferenceDot2, [{
    key: "render",
    value: function render() {
      var _this$props = this.props, x3 = _this$props.x, y4 = _this$props.y, r2 = _this$props.r, alwaysShow = _this$props.alwaysShow, clipPathId = _this$props.clipPathId;
      var isX = isNumOrStr(x3);
      var isY = isNumOrStr(y4);
      warn$1(alwaysShow === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
      if (!isX || !isY) {
        return null;
      }
      var coordinate = getCoordinate(this.props);
      if (!coordinate) {
        return null;
      }
      var cx = coordinate.x, cy = coordinate.y;
      var _this$props2 = this.props, shape = _this$props2.shape, className = _this$props2.className;
      var clipPath = ifOverflowMatches(this.props, "hidden") ? "url(#".concat(clipPathId, ")") : void 0;
      var dotProps = _objectSpread$8(_objectSpread$8({
        clipPath
      }, filterProps(this.props, true)), {}, {
        cx,
        cy
      });
      return /* @__PURE__ */ React__default.createElement(Layer, {
        className: clsx("recharts-reference-dot", className)
      }, ReferenceDot2.renderDot(shape, dotProps), Label$1.renderCallByParent(this.props, {
        x: cx - r2,
        y: cy - r2,
        width: 2 * r2,
        height: 2 * r2
      }));
    }
  }]);
}(React__default.Component);
_defineProperty$b(ReferenceDot, "displayName", "ReferenceDot");
_defineProperty$b(ReferenceDot, "defaultProps", {
  isFront: false,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: "#fff",
  stroke: "#ccc",
  fillOpacity: 1,
  strokeWidth: 1
});
_defineProperty$b(ReferenceDot, "renderDot", function(option, props) {
  var dot;
  if (/* @__PURE__ */ React__default.isValidElement(option)) {
    dot = /* @__PURE__ */ React__default.cloneElement(option, props);
  } else if (isFunction(option)) {
    dot = option(props);
  } else {
    dot = /* @__PURE__ */ React__default.createElement(Dot, _extends$8({}, props, {
      cx: props.cx,
      cy: props.cy,
      className: "recharts-reference-dot-dot"
    }));
  }
  return dot;
});
function _extends$7() {
  _extends$7 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i3 = 1; i3 < arguments.length; i3++) {
      var source = arguments[i3];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$7.apply(this, arguments);
}
function _typeof$a(o2) {
  "@babel/helpers - typeof";
  return _typeof$a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof$a(o2);
}
function ownKeys$7(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e3);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$7(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$7(Object(t3), true).forEach(function(r3) {
      _defineProperty$a(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$7(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
function _classCallCheck$7(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$7(target, props) {
  for (var i3 = 0; i3 < props.length; i3++) {
    var descriptor = props[i3];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$a(descriptor.key), descriptor);
  }
}
function _createClass$7(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$7(Constructor.prototype, protoProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _callSuper$6(t3, o2, e3) {
  return o2 = _getPrototypeOf$6(o2), _possibleConstructorReturn$6(t3, _isNativeReflectConstruct$6() ? Reflect.construct(o2, e3 || [], _getPrototypeOf$6(t3).constructor) : o2.apply(t3, e3));
}
function _possibleConstructorReturn$6(self2, call) {
  if (call && (_typeof$a(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$6(self2);
}
function _assertThisInitialized$6(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$6() {
  try {
    var t3 = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$6 = function _isNativeReflectConstruct2() {
    return !!t3;
  })();
}
function _getPrototypeOf$6(o2) {
  _getPrototypeOf$6 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o3) {
    return o3.__proto__ || Object.getPrototypeOf(o3);
  };
  return _getPrototypeOf$6(o2);
}
function _inherits$6(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass) _setPrototypeOf$6(subClass, superClass);
}
function _setPrototypeOf$6(o2, p2) {
  _setPrototypeOf$6 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o3, p3) {
    o3.__proto__ = p3;
    return o3;
  };
  return _setPrototypeOf$6(o2, p2);
}
function _defineProperty$a(obj, key, value) {
  key = _toPropertyKey$a(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$a(t3) {
  var i3 = _toPrimitive$a(t3, "string");
  return "symbol" == _typeof$a(i3) ? i3 : i3 + "";
}
function _toPrimitive$a(t3, r2) {
  if ("object" != _typeof$a(t3) || !t3) return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i3 = e3.call(t3, r2);
    if ("object" != _typeof$a(i3)) return i3;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t3);
}
var getRect = function getRect2(hasX1, hasX2, hasY1, hasY2, props) {
  var xValue1 = props.x1, xValue2 = props.x2, yValue1 = props.y1, yValue2 = props.y2, xAxis = props.xAxis, yAxis = props.yAxis;
  if (!xAxis || !yAxis) return null;
  var scales = createLabeledScales({
    x: xAxis.scale,
    y: yAxis.scale
  });
  var p1 = {
    x: hasX1 ? scales.x.apply(xValue1, {
      position: "start"
    }) : scales.x.rangeMin,
    y: hasY1 ? scales.y.apply(yValue1, {
      position: "start"
    }) : scales.y.rangeMin
  };
  var p2 = {
    x: hasX2 ? scales.x.apply(xValue2, {
      position: "end"
    }) : scales.x.rangeMax,
    y: hasY2 ? scales.y.apply(yValue2, {
      position: "end"
    }) : scales.y.rangeMax
  };
  if (ifOverflowMatches(props, "discard") && (!scales.isInRange(p1) || !scales.isInRange(p2))) {
    return null;
  }
  return rectWithPoints(p1, p2);
};
var ReferenceArea = /* @__PURE__ */ function(_React$Component) {
  function ReferenceArea2() {
    _classCallCheck$7(this, ReferenceArea2);
    return _callSuper$6(this, ReferenceArea2, arguments);
  }
  _inherits$6(ReferenceArea2, _React$Component);
  return _createClass$7(ReferenceArea2, [{
    key: "render",
    value: function render() {
      var _this$props = this.props, x1 = _this$props.x1, x22 = _this$props.x2, y1 = _this$props.y1, y22 = _this$props.y2, className = _this$props.className, alwaysShow = _this$props.alwaysShow, clipPathId = _this$props.clipPathId;
      warn$1(alwaysShow === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
      var hasX1 = isNumOrStr(x1);
      var hasX2 = isNumOrStr(x22);
      var hasY1 = isNumOrStr(y1);
      var hasY2 = isNumOrStr(y22);
      var shape = this.props.shape;
      if (!hasX1 && !hasX2 && !hasY1 && !hasY2 && !shape) {
        return null;
      }
      var rect = getRect(hasX1, hasX2, hasY1, hasY2, this.props);
      if (!rect && !shape) {
        return null;
      }
      var clipPath = ifOverflowMatches(this.props, "hidden") ? "url(#".concat(clipPathId, ")") : void 0;
      return /* @__PURE__ */ React__default.createElement(Layer, {
        className: clsx("recharts-reference-area", className)
      }, ReferenceArea2.renderRect(shape, _objectSpread$7(_objectSpread$7({
        clipPath
      }, filterProps(this.props, true)), rect)), Label$1.renderCallByParent(this.props, rect));
    }
  }]);
}(React__default.Component);
_defineProperty$a(ReferenceArea, "displayName", "ReferenceArea");
_defineProperty$a(ReferenceArea, "defaultProps", {
  isFront: false,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: "#ccc",
  fillOpacity: 0.5,
  stroke: "none",
  strokeWidth: 1
});
_defineProperty$a(ReferenceArea, "renderRect", function(option, props) {
  var rect;
  if (/* @__PURE__ */ React__default.isValidElement(option)) {
    rect = /* @__PURE__ */ React__default.cloneElement(option, props);
  } else if (isFunction(option)) {
    rect = option(props);
  } else {
    rect = /* @__PURE__ */ React__default.createElement(Rectangle, _extends$7({}, props, {
      className: "recharts-reference-area-rect"
    }));
  }
  return rect;
});
function getEveryNthWithCondition(array2, n2, isValid2) {
  if (n2 < 1) {
    return [];
  }
  if (n2 === 1 && isValid2 === void 0) {
    return array2;
  }
  var result = [];
  for (var i3 = 0; i3 < array2.length; i3 += n2) {
    {
      result.push(array2[i3]);
    }
  }
  return result;
}
function getAngledTickWidth(contentSize, unitSize, angle) {
  var size2 = {
    width: contentSize.width + unitSize.width,
    height: contentSize.height + unitSize.height
  };
  return getAngledRectangleWidth(size2, angle);
}
function getTickBoundaries(viewBox, sign2, sizeKey) {
  var isWidth = sizeKey === "width";
  var x3 = viewBox.x, y4 = viewBox.y, width = viewBox.width, height = viewBox.height;
  if (sign2 === 1) {
    return {
      start: isWidth ? x3 : y4,
      end: isWidth ? x3 + width : y4 + height
    };
  }
  return {
    start: isWidth ? x3 + width : y4 + height,
    end: isWidth ? x3 : y4
  };
}
function isVisible(sign2, tickPosition, getSize2, start, end) {
  if (sign2 * tickPosition < sign2 * start || sign2 * tickPosition > sign2 * end) {
    return false;
  }
  var size2 = getSize2();
  return sign2 * (tickPosition - sign2 * size2 / 2 - start) >= 0 && sign2 * (tickPosition + sign2 * size2 / 2 - end) <= 0;
}
function getNumberIntervalTicks(ticks2, interval) {
  return getEveryNthWithCondition(ticks2, interval + 1);
}
function getEquidistantTicks(sign2, boundaries, getTickSize, ticks2, minTickGap) {
  var result = (ticks2 || []).slice();
  var initialStart = boundaries.start, end = boundaries.end;
  var index2 = 0;
  var stepsize = 1;
  var start = initialStart;
  var _loop = function _loop2() {
    var entry = ticks2 === null || ticks2 === void 0 ? void 0 : ticks2[index2];
    if (entry === void 0) {
      return {
        v: getEveryNthWithCondition(ticks2, stepsize)
      };
    }
    var i3 = index2;
    var size2;
    var getSize2 = function getSize3() {
      if (size2 === void 0) {
        size2 = getTickSize(entry, i3);
      }
      return size2;
    };
    var tickCoord = entry.coordinate;
    var isShow = index2 === 0 || isVisible(sign2, tickCoord, getSize2, start, end);
    if (!isShow) {
      index2 = 0;
      start = initialStart;
      stepsize += 1;
    }
    if (isShow) {
      start = tickCoord + sign2 * (getSize2() / 2 + minTickGap);
      index2 += stepsize;
    }
  }, _ret;
  while (stepsize <= result.length) {
    _ret = _loop();
    if (_ret) return _ret.v;
  }
  return [];
}
function _typeof$9(o2) {
  "@babel/helpers - typeof";
  return _typeof$9 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof$9(o2);
}
function ownKeys$6(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e3);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$6(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$6(Object(t3), true).forEach(function(r3) {
      _defineProperty$9(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$6(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
function _defineProperty$9(obj, key, value) {
  key = _toPropertyKey$9(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$9(t3) {
  var i3 = _toPrimitive$9(t3, "string");
  return "symbol" == _typeof$9(i3) ? i3 : i3 + "";
}
function _toPrimitive$9(t3, r2) {
  if ("object" != _typeof$9(t3) || !t3) return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i3 = e3.call(t3, r2);
    if ("object" != _typeof$9(i3)) return i3;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t3);
}
function getTicksEnd(sign2, boundaries, getTickSize, ticks2, minTickGap) {
  var result = (ticks2 || []).slice();
  var len = result.length;
  var start = boundaries.start;
  var end = boundaries.end;
  var _loop = function _loop2(i4) {
    var entry = result[i4];
    var size2;
    var getSize2 = function getSize3() {
      if (size2 === void 0) {
        size2 = getTickSize(entry, i4);
      }
      return size2;
    };
    if (i4 === len - 1) {
      var gap = sign2 * (entry.coordinate + sign2 * getSize2() / 2 - end);
      result[i4] = entry = _objectSpread$6(_objectSpread$6({}, entry), {}, {
        tickCoord: gap > 0 ? entry.coordinate - gap * sign2 : entry.coordinate
      });
    } else {
      result[i4] = entry = _objectSpread$6(_objectSpread$6({}, entry), {}, {
        tickCoord: entry.coordinate
      });
    }
    var isShow = isVisible(sign2, entry.tickCoord, getSize2, start, end);
    if (isShow) {
      end = entry.tickCoord - sign2 * (getSize2() / 2 + minTickGap);
      result[i4] = _objectSpread$6(_objectSpread$6({}, entry), {}, {
        isShow: true
      });
    }
  };
  for (var i3 = len - 1; i3 >= 0; i3--) {
    _loop(i3);
  }
  return result;
}
function getTicksStart(sign2, boundaries, getTickSize, ticks2, minTickGap, preserveEnd) {
  var result = (ticks2 || []).slice();
  var len = result.length;
  var start = boundaries.start, end = boundaries.end;
  if (preserveEnd) {
    var tail = ticks2[len - 1];
    var tailSize = getTickSize(tail, len - 1);
    var tailGap = sign2 * (tail.coordinate + sign2 * tailSize / 2 - end);
    result[len - 1] = tail = _objectSpread$6(_objectSpread$6({}, tail), {}, {
      tickCoord: tailGap > 0 ? tail.coordinate - tailGap * sign2 : tail.coordinate
    });
    var isTailShow = isVisible(sign2, tail.tickCoord, function() {
      return tailSize;
    }, start, end);
    if (isTailShow) {
      end = tail.tickCoord - sign2 * (tailSize / 2 + minTickGap);
      result[len - 1] = _objectSpread$6(_objectSpread$6({}, tail), {}, {
        isShow: true
      });
    }
  }
  var count2 = preserveEnd ? len - 1 : len;
  var _loop2 = function _loop22(i4) {
    var entry = result[i4];
    var size2;
    var getSize2 = function getSize3() {
      if (size2 === void 0) {
        size2 = getTickSize(entry, i4);
      }
      return size2;
    };
    if (i4 === 0) {
      var gap = sign2 * (entry.coordinate - sign2 * getSize2() / 2 - start);
      result[i4] = entry = _objectSpread$6(_objectSpread$6({}, entry), {}, {
        tickCoord: gap < 0 ? entry.coordinate - gap * sign2 : entry.coordinate
      });
    } else {
      result[i4] = entry = _objectSpread$6(_objectSpread$6({}, entry), {}, {
        tickCoord: entry.coordinate
      });
    }
    var isShow = isVisible(sign2, entry.tickCoord, getSize2, start, end);
    if (isShow) {
      start = entry.tickCoord + sign2 * (getSize2() / 2 + minTickGap);
      result[i4] = _objectSpread$6(_objectSpread$6({}, entry), {}, {
        isShow: true
      });
    }
  };
  for (var i3 = 0; i3 < count2; i3++) {
    _loop2(i3);
  }
  return result;
}
function getTicks(props, fontSize, letterSpacing) {
  var tick = props.tick, ticks2 = props.ticks, viewBox = props.viewBox, minTickGap = props.minTickGap, orientation = props.orientation, interval = props.interval, tickFormatter = props.tickFormatter, unit2 = props.unit, angle = props.angle;
  if (!ticks2 || !ticks2.length || !tick) {
    return [];
  }
  if (isNumber(interval) || Global.isSsr) {
    return getNumberIntervalTicks(ticks2, typeof interval === "number" && isNumber(interval) ? interval : 0);
  }
  var candidates = [];
  var sizeKey = orientation === "top" || orientation === "bottom" ? "width" : "height";
  var unitSize = unit2 && sizeKey === "width" ? getStringSize(unit2, {
    fontSize,
    letterSpacing
  }) : {
    width: 0,
    height: 0
  };
  var getTickSize = function getTickSize2(content, index2) {
    var value = isFunction(tickFormatter) ? tickFormatter(content.value, index2) : content.value;
    return sizeKey === "width" ? getAngledTickWidth(getStringSize(value, {
      fontSize,
      letterSpacing
    }), unitSize, angle) : getStringSize(value, {
      fontSize,
      letterSpacing
    })[sizeKey];
  };
  var sign2 = ticks2.length >= 2 ? mathSign(ticks2[1].coordinate - ticks2[0].coordinate) : 1;
  var boundaries = getTickBoundaries(viewBox, sign2, sizeKey);
  if (interval === "equidistantPreserveStart") {
    return getEquidistantTicks(sign2, boundaries, getTickSize, ticks2, minTickGap);
  }
  if (interval === "preserveStart" || interval === "preserveStartEnd") {
    candidates = getTicksStart(sign2, boundaries, getTickSize, ticks2, minTickGap, interval === "preserveStartEnd");
  } else {
    candidates = getTicksEnd(sign2, boundaries, getTickSize, ticks2, minTickGap);
  }
  return candidates.filter(function(entry) {
    return entry.isShow;
  });
}
var _excluded$4 = ["viewBox"], _excluded2$4 = ["viewBox"], _excluded3 = ["ticks"];
function _typeof$8(o2) {
  "@babel/helpers - typeof";
  return _typeof$8 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof$8(o2);
}
function _extends$6() {
  _extends$6 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i3 = 1; i3 < arguments.length; i3++) {
      var source = arguments[i3];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$6.apply(this, arguments);
}
function ownKeys$5(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e3);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$5(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$5(Object(t3), true).forEach(function(r3) {
      _defineProperty$8(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$5(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
function _objectWithoutProperties$4(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$4(source, excluded);
  var key, i3;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i3 = 0; i3 < sourceSymbolKeys.length; i3++) {
      key = sourceSymbolKeys[i3];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$4(source, excluded) {
  if (source == null) return {};
  var target = {};
  for (var key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _classCallCheck$6(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$6(target, props) {
  for (var i3 = 0; i3 < props.length; i3++) {
    var descriptor = props[i3];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$8(descriptor.key), descriptor);
  }
}
function _createClass$6(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$6(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$6(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _callSuper$5(t3, o2, e3) {
  return o2 = _getPrototypeOf$5(o2), _possibleConstructorReturn$5(t3, _isNativeReflectConstruct$5() ? Reflect.construct(o2, e3 || [], _getPrototypeOf$5(t3).constructor) : o2.apply(t3, e3));
}
function _possibleConstructorReturn$5(self2, call) {
  if (call && (_typeof$8(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$5(self2);
}
function _assertThisInitialized$5(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$5() {
  try {
    var t3 = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$5 = function _isNativeReflectConstruct2() {
    return !!t3;
  })();
}
function _getPrototypeOf$5(o2) {
  _getPrototypeOf$5 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o3) {
    return o3.__proto__ || Object.getPrototypeOf(o3);
  };
  return _getPrototypeOf$5(o2);
}
function _inherits$5(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass) _setPrototypeOf$5(subClass, superClass);
}
function _setPrototypeOf$5(o2, p2) {
  _setPrototypeOf$5 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o3, p3) {
    o3.__proto__ = p3;
    return o3;
  };
  return _setPrototypeOf$5(o2, p2);
}
function _defineProperty$8(obj, key, value) {
  key = _toPropertyKey$8(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$8(t3) {
  var i3 = _toPrimitive$8(t3, "string");
  return "symbol" == _typeof$8(i3) ? i3 : i3 + "";
}
function _toPrimitive$8(t3, r2) {
  if ("object" != _typeof$8(t3) || !t3) return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i3 = e3.call(t3, r2);
    if ("object" != _typeof$8(i3)) return i3;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t3);
}
var CartesianAxis = /* @__PURE__ */ function(_Component) {
  function CartesianAxis2(props) {
    var _this;
    _classCallCheck$6(this, CartesianAxis2);
    _this = _callSuper$5(this, CartesianAxis2, [props]);
    _this.state = {
      fontSize: "",
      letterSpacing: ""
    };
    return _this;
  }
  _inherits$5(CartesianAxis2, _Component);
  return _createClass$6(CartesianAxis2, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(_ref, nextState) {
      var viewBox = _ref.viewBox, restProps = _objectWithoutProperties$4(_ref, _excluded$4);
      var _this$props = this.props, viewBoxOld = _this$props.viewBox, restPropsOld = _objectWithoutProperties$4(_this$props, _excluded2$4);
      return !shallowEqual(viewBox, viewBoxOld) || !shallowEqual(restProps, restPropsOld) || !shallowEqual(nextState, this.state);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var htmlLayer = this.layerReference;
      if (!htmlLayer) return;
      var tick = htmlLayer.getElementsByClassName("recharts-cartesian-axis-tick-value")[0];
      if (tick) {
        this.setState({
          fontSize: window.getComputedStyle(tick).fontSize,
          letterSpacing: window.getComputedStyle(tick).letterSpacing
        });
      }
    }
    /**
     * Calculate the coordinates of endpoints in ticks
     * @param  {Object} data The data of a simple tick
     * @return {Object} (x1, y1): The coordinate of endpoint close to tick text
     *  (x2, y2): The coordinate of endpoint close to axis
     */
  }, {
    key: "getTickLineCoord",
    value: function getTickLineCoord(data) {
      var _this$props2 = this.props, x3 = _this$props2.x, y4 = _this$props2.y, width = _this$props2.width, height = _this$props2.height, orientation = _this$props2.orientation, tickSize = _this$props2.tickSize, mirror = _this$props2.mirror, tickMargin = _this$props2.tickMargin;
      var x1, x22, y1, y22, tx, ty;
      var sign2 = mirror ? -1 : 1;
      var finalTickSize = data.tickSize || tickSize;
      var tickCoord = isNumber(data.tickCoord) ? data.tickCoord : data.coordinate;
      switch (orientation) {
        case "top":
          x1 = x22 = data.coordinate;
          y22 = y4 + +!mirror * height;
          y1 = y22 - sign2 * finalTickSize;
          ty = y1 - sign2 * tickMargin;
          tx = tickCoord;
          break;
        case "left":
          y1 = y22 = data.coordinate;
          x22 = x3 + +!mirror * width;
          x1 = x22 - sign2 * finalTickSize;
          tx = x1 - sign2 * tickMargin;
          ty = tickCoord;
          break;
        case "right":
          y1 = y22 = data.coordinate;
          x22 = x3 + +mirror * width;
          x1 = x22 + sign2 * finalTickSize;
          tx = x1 + sign2 * tickMargin;
          ty = tickCoord;
          break;
        default:
          x1 = x22 = data.coordinate;
          y22 = y4 + +mirror * height;
          y1 = y22 + sign2 * finalTickSize;
          ty = y1 + sign2 * tickMargin;
          tx = tickCoord;
          break;
      }
      return {
        line: {
          x1,
          y1,
          x2: x22,
          y2: y22
        },
        tick: {
          x: tx,
          y: ty
        }
      };
    }
  }, {
    key: "getTickTextAnchor",
    value: function getTickTextAnchor() {
      var _this$props3 = this.props, orientation = _this$props3.orientation, mirror = _this$props3.mirror;
      var textAnchor;
      switch (orientation) {
        case "left":
          textAnchor = mirror ? "start" : "end";
          break;
        case "right":
          textAnchor = mirror ? "end" : "start";
          break;
        default:
          textAnchor = "middle";
          break;
      }
      return textAnchor;
    }
  }, {
    key: "getTickVerticalAnchor",
    value: function getTickVerticalAnchor() {
      var _this$props4 = this.props, orientation = _this$props4.orientation, mirror = _this$props4.mirror;
      var verticalAnchor = "end";
      switch (orientation) {
        case "left":
        case "right":
          verticalAnchor = "middle";
          break;
        case "top":
          verticalAnchor = mirror ? "start" : "end";
          break;
        default:
          verticalAnchor = mirror ? "end" : "start";
          break;
      }
      return verticalAnchor;
    }
  }, {
    key: "renderAxisLine",
    value: function renderAxisLine() {
      var _this$props5 = this.props, x3 = _this$props5.x, y4 = _this$props5.y, width = _this$props5.width, height = _this$props5.height, orientation = _this$props5.orientation, mirror = _this$props5.mirror, axisLine = _this$props5.axisLine;
      var props = _objectSpread$5(_objectSpread$5(_objectSpread$5({}, filterProps(this.props, false)), filterProps(axisLine, false)), {}, {
        fill: "none"
      });
      if (orientation === "top" || orientation === "bottom") {
        var needHeight = +(orientation === "top" && !mirror || orientation === "bottom" && mirror);
        props = _objectSpread$5(_objectSpread$5({}, props), {}, {
          x1: x3,
          y1: y4 + needHeight * height,
          x2: x3 + width,
          y2: y4 + needHeight * height
        });
      } else {
        var needWidth = +(orientation === "left" && !mirror || orientation === "right" && mirror);
        props = _objectSpread$5(_objectSpread$5({}, props), {}, {
          x1: x3 + needWidth * width,
          y1: y4,
          x2: x3 + needWidth * width,
          y2: y4 + height
        });
      }
      return /* @__PURE__ */ React__default.createElement("line", _extends$6({}, props, {
        className: clsx("recharts-cartesian-axis-line", get(axisLine, "className"))
      }));
    }
  }, {
    key: "renderTicks",
    value: (
      /**
       * render the ticks
       * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
       * @param {string} fontSize Fontsize to consider for tick spacing
       * @param {string} letterSpacing Letterspacing to consider for tick spacing
       * @return {ReactComponent} renderedTicks
       */
      function renderTicks(ticks2, fontSize, letterSpacing) {
        var _this2 = this;
        var _this$props6 = this.props, tickLine = _this$props6.tickLine, stroke = _this$props6.stroke, tick = _this$props6.tick, tickFormatter = _this$props6.tickFormatter, unit2 = _this$props6.unit;
        var finalTicks = getTicks(_objectSpread$5(_objectSpread$5({}, this.props), {}, {
          ticks: ticks2
        }), fontSize, letterSpacing);
        var textAnchor = this.getTickTextAnchor();
        var verticalAnchor = this.getTickVerticalAnchor();
        var axisProps = filterProps(this.props, false);
        var customTickProps = filterProps(tick, false);
        var tickLineProps = _objectSpread$5(_objectSpread$5({}, axisProps), {}, {
          fill: "none"
        }, filterProps(tickLine, false));
        var items = finalTicks.map(function(entry, i3) {
          var _this2$getTickLineCoo = _this2.getTickLineCoord(entry), lineCoord = _this2$getTickLineCoo.line, tickCoord = _this2$getTickLineCoo.tick;
          var tickProps = _objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5({
            textAnchor,
            verticalAnchor
          }, axisProps), {}, {
            stroke: "none",
            fill: stroke
          }, customTickProps), tickCoord), {}, {
            index: i3,
            payload: entry,
            visibleTicksCount: finalTicks.length,
            tickFormatter
          });
          return /* @__PURE__ */ React__default.createElement(Layer, _extends$6({
            className: "recharts-cartesian-axis-tick",
            key: "tick-".concat(entry.value, "-").concat(entry.coordinate, "-").concat(entry.tickCoord)
          }, adaptEventsOfChild(_this2.props, entry, i3)), tickLine && /* @__PURE__ */ React__default.createElement("line", _extends$6({}, tickLineProps, lineCoord, {
            className: clsx("recharts-cartesian-axis-tick-line", get(tickLine, "className"))
          })), tick && CartesianAxis2.renderTickItem(tick, tickProps, "".concat(isFunction(tickFormatter) ? tickFormatter(entry.value, i3) : entry.value).concat(unit2 || "")));
        });
        return /* @__PURE__ */ React__default.createElement("g", {
          className: "recharts-cartesian-axis-ticks"
        }, items);
      }
    )
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props7 = this.props, axisLine = _this$props7.axisLine, width = _this$props7.width, height = _this$props7.height, ticksGenerator = _this$props7.ticksGenerator, className = _this$props7.className, hide2 = _this$props7.hide;
      if (hide2) {
        return null;
      }
      var _this$props8 = this.props, ticks2 = _this$props8.ticks, noTicksProps = _objectWithoutProperties$4(_this$props8, _excluded3);
      var finalTicks = ticks2;
      if (isFunction(ticksGenerator)) {
        finalTicks = ticks2 && ticks2.length > 0 ? ticksGenerator(this.props) : ticksGenerator(noTicksProps);
      }
      if (width <= 0 || height <= 0 || !finalTicks || !finalTicks.length) {
        return null;
      }
      return /* @__PURE__ */ React__default.createElement(Layer, {
        className: clsx("recharts-cartesian-axis", className),
        ref: function ref(_ref2) {
          _this3.layerReference = _ref2;
        }
      }, axisLine && this.renderAxisLine(), this.renderTicks(finalTicks, this.state.fontSize, this.state.letterSpacing), Label$1.renderCallByParent(this.props));
    }
  }], [{
    key: "renderTickItem",
    value: function renderTickItem(option, props, value) {
      var tickItem;
      if (/* @__PURE__ */ React__default.isValidElement(option)) {
        tickItem = /* @__PURE__ */ React__default.cloneElement(option, props);
      } else if (isFunction(option)) {
        tickItem = option(props);
      } else {
        tickItem = /* @__PURE__ */ React__default.createElement(Text, _extends$6({}, props, {
          className: "recharts-cartesian-axis-tick-value"
        }), value);
      }
      return tickItem;
    }
  }]);
}(Component);
_defineProperty$8(CartesianAxis, "displayName", "CartesianAxis");
_defineProperty$8(CartesianAxis, "defaultProps", {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  viewBox: {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  // The orientation of axis
  orientation: "bottom",
  // The ticks
  ticks: [],
  stroke: "#666",
  tickLine: true,
  axisLine: true,
  tick: true,
  mirror: false,
  minTickGap: 5,
  // The width or height of tick
  tickSize: 6,
  tickMargin: 2,
  interval: "preserveEnd"
});
var _excluded$3 = ["x1", "y1", "x2", "y2", "key"], _excluded2$3 = ["offset"];
function _typeof$7(o2) {
  "@babel/helpers - typeof";
  return _typeof$7 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof$7(o2);
}
function ownKeys$4(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e3);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$4(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$4(Object(t3), true).forEach(function(r3) {
      _defineProperty$7(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$4(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
function _defineProperty$7(obj, key, value) {
  key = _toPropertyKey$7(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$7(t3) {
  var i3 = _toPrimitive$7(t3, "string");
  return "symbol" == _typeof$7(i3) ? i3 : i3 + "";
}
function _toPrimitive$7(t3, r2) {
  if ("object" != _typeof$7(t3) || !t3) return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i3 = e3.call(t3, r2);
    if ("object" != _typeof$7(i3)) return i3;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t3);
}
function _extends$5() {
  _extends$5 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i3 = 1; i3 < arguments.length; i3++) {
      var source = arguments[i3];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$5.apply(this, arguments);
}
function _objectWithoutProperties$3(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$3(source, excluded);
  var key, i3;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i3 = 0; i3 < sourceSymbolKeys.length; i3++) {
      key = sourceSymbolKeys[i3];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$3(source, excluded) {
  if (source == null) return {};
  var target = {};
  for (var key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
  }
  return target;
}
var Background = function Background2(props) {
  var fill = props.fill;
  if (!fill || fill === "none") {
    return null;
  }
  var fillOpacity = props.fillOpacity, x3 = props.x, y4 = props.y, width = props.width, height = props.height, ry = props.ry;
  return /* @__PURE__ */ React__default.createElement("rect", {
    x: x3,
    y: y4,
    ry,
    width,
    height,
    stroke: "none",
    fill,
    fillOpacity,
    className: "recharts-cartesian-grid-bg"
  });
};
function renderLineItem(option, props) {
  var lineItem;
  if (/* @__PURE__ */ React__default.isValidElement(option)) {
    lineItem = /* @__PURE__ */ React__default.cloneElement(option, props);
  } else if (isFunction(option)) {
    lineItem = option(props);
  } else {
    var x1 = props.x1, y1 = props.y1, x22 = props.x2, y22 = props.y2, key = props.key, others = _objectWithoutProperties$3(props, _excluded$3);
    var _filterProps = filterProps(others, false);
    _filterProps.offset;
    var restOfFilteredProps = _objectWithoutProperties$3(_filterProps, _excluded2$3);
    lineItem = /* @__PURE__ */ React__default.createElement("line", _extends$5({}, restOfFilteredProps, {
      x1,
      y1,
      x2: x22,
      y2: y22,
      fill: "none",
      key
    }));
  }
  return lineItem;
}
function HorizontalGridLines(props) {
  var x3 = props.x, width = props.width, _props$horizontal = props.horizontal, horizontal = _props$horizontal === void 0 ? true : _props$horizontal, horizontalPoints = props.horizontalPoints;
  if (!horizontal || !horizontalPoints || !horizontalPoints.length) {
    return null;
  }
  var items = horizontalPoints.map(function(entry, i3) {
    var lineItemProps = _objectSpread$4(_objectSpread$4({}, props), {}, {
      x1: x3,
      y1: entry,
      x2: x3 + width,
      y2: entry,
      key: "line-".concat(i3),
      index: i3
    });
    return renderLineItem(horizontal, lineItemProps);
  });
  return /* @__PURE__ */ React__default.createElement("g", {
    className: "recharts-cartesian-grid-horizontal"
  }, items);
}
function VerticalGridLines(props) {
  var y4 = props.y, height = props.height, _props$vertical = props.vertical, vertical = _props$vertical === void 0 ? true : _props$vertical, verticalPoints = props.verticalPoints;
  if (!vertical || !verticalPoints || !verticalPoints.length) {
    return null;
  }
  var items = verticalPoints.map(function(entry, i3) {
    var lineItemProps = _objectSpread$4(_objectSpread$4({}, props), {}, {
      x1: entry,
      y1: y4,
      x2: entry,
      y2: y4 + height,
      key: "line-".concat(i3),
      index: i3
    });
    return renderLineItem(vertical, lineItemProps);
  });
  return /* @__PURE__ */ React__default.createElement("g", {
    className: "recharts-cartesian-grid-vertical"
  }, items);
}
function HorizontalStripes(props) {
  var horizontalFill = props.horizontalFill, fillOpacity = props.fillOpacity, x3 = props.x, y4 = props.y, width = props.width, height = props.height, horizontalPoints = props.horizontalPoints, _props$horizontal2 = props.horizontal, horizontal = _props$horizontal2 === void 0 ? true : _props$horizontal2;
  if (!horizontal || !horizontalFill || !horizontalFill.length) {
    return null;
  }
  var roundedSortedHorizontalPoints = horizontalPoints.map(function(e3) {
    return Math.round(e3 + y4 - y4);
  }).sort(function(a4, b3) {
    return a4 - b3;
  });
  if (y4 !== roundedSortedHorizontalPoints[0]) {
    roundedSortedHorizontalPoints.unshift(0);
  }
  var items = roundedSortedHorizontalPoints.map(function(entry, i3) {
    var lastStripe = !roundedSortedHorizontalPoints[i3 + 1];
    var lineHeight = lastStripe ? y4 + height - entry : roundedSortedHorizontalPoints[i3 + 1] - entry;
    if (lineHeight <= 0) {
      return null;
    }
    var colorIndex = i3 % horizontalFill.length;
    return /* @__PURE__ */ React__default.createElement("rect", {
      key: "react-".concat(i3),
      y: entry,
      x: x3,
      height: lineHeight,
      width,
      stroke: "none",
      fill: horizontalFill[colorIndex],
      fillOpacity,
      className: "recharts-cartesian-grid-bg"
    });
  });
  return /* @__PURE__ */ React__default.createElement("g", {
    className: "recharts-cartesian-gridstripes-horizontal"
  }, items);
}
function VerticalStripes(props) {
  var _props$vertical2 = props.vertical, vertical = _props$vertical2 === void 0 ? true : _props$vertical2, verticalFill = props.verticalFill, fillOpacity = props.fillOpacity, x3 = props.x, y4 = props.y, width = props.width, height = props.height, verticalPoints = props.verticalPoints;
  if (!vertical || !verticalFill || !verticalFill.length) {
    return null;
  }
  var roundedSortedVerticalPoints = verticalPoints.map(function(e3) {
    return Math.round(e3 + x3 - x3);
  }).sort(function(a4, b3) {
    return a4 - b3;
  });
  if (x3 !== roundedSortedVerticalPoints[0]) {
    roundedSortedVerticalPoints.unshift(0);
  }
  var items = roundedSortedVerticalPoints.map(function(entry, i3) {
    var lastStripe = !roundedSortedVerticalPoints[i3 + 1];
    var lineWidth = lastStripe ? x3 + width - entry : roundedSortedVerticalPoints[i3 + 1] - entry;
    if (lineWidth <= 0) {
      return null;
    }
    var colorIndex = i3 % verticalFill.length;
    return /* @__PURE__ */ React__default.createElement("rect", {
      key: "react-".concat(i3),
      x: entry,
      y: y4,
      width: lineWidth,
      height,
      stroke: "none",
      fill: verticalFill[colorIndex],
      fillOpacity,
      className: "recharts-cartesian-grid-bg"
    });
  });
  return /* @__PURE__ */ React__default.createElement("g", {
    className: "recharts-cartesian-gridstripes-vertical"
  }, items);
}
var defaultVerticalCoordinatesGenerator = function defaultVerticalCoordinatesGenerator2(_ref, syncWithTicks) {
  var xAxis = _ref.xAxis, width = _ref.width, height = _ref.height, offset2 = _ref.offset;
  return getCoordinatesOfGrid(getTicks(_objectSpread$4(_objectSpread$4(_objectSpread$4({}, CartesianAxis.defaultProps), xAxis), {}, {
    ticks: getTicksOfAxis(xAxis, true),
    viewBox: {
      x: 0,
      y: 0,
      width,
      height
    }
  })), offset2.left, offset2.left + offset2.width, syncWithTicks);
};
var defaultHorizontalCoordinatesGenerator = function defaultHorizontalCoordinatesGenerator2(_ref2, syncWithTicks) {
  var yAxis = _ref2.yAxis, width = _ref2.width, height = _ref2.height, offset2 = _ref2.offset;
  return getCoordinatesOfGrid(getTicks(_objectSpread$4(_objectSpread$4(_objectSpread$4({}, CartesianAxis.defaultProps), yAxis), {}, {
    ticks: getTicksOfAxis(yAxis, true),
    viewBox: {
      x: 0,
      y: 0,
      width,
      height
    }
  })), offset2.top, offset2.top + offset2.height, syncWithTicks);
};
var defaultProps = {
  horizontal: true,
  vertical: true,
  stroke: "#ccc",
  fill: "none",
  // The fill of colors of grid lines
  verticalFill: [],
  horizontalFill: []
};
function CartesianGrid(props) {
  var _props$stroke, _props$fill, _props$horizontal3, _props$horizontalFill, _props$vertical3, _props$verticalFill;
  var chartWidth = useChartWidth();
  var chartHeight = useChartHeight();
  var offset2 = useOffset();
  var propsIncludingDefaults = _objectSpread$4(_objectSpread$4({}, props), {}, {
    stroke: (_props$stroke = props.stroke) !== null && _props$stroke !== void 0 ? _props$stroke : defaultProps.stroke,
    fill: (_props$fill = props.fill) !== null && _props$fill !== void 0 ? _props$fill : defaultProps.fill,
    horizontal: (_props$horizontal3 = props.horizontal) !== null && _props$horizontal3 !== void 0 ? _props$horizontal3 : defaultProps.horizontal,
    horizontalFill: (_props$horizontalFill = props.horizontalFill) !== null && _props$horizontalFill !== void 0 ? _props$horizontalFill : defaultProps.horizontalFill,
    vertical: (_props$vertical3 = props.vertical) !== null && _props$vertical3 !== void 0 ? _props$vertical3 : defaultProps.vertical,
    verticalFill: (_props$verticalFill = props.verticalFill) !== null && _props$verticalFill !== void 0 ? _props$verticalFill : defaultProps.verticalFill,
    x: isNumber(props.x) ? props.x : offset2.left,
    y: isNumber(props.y) ? props.y : offset2.top,
    width: isNumber(props.width) ? props.width : offset2.width,
    height: isNumber(props.height) ? props.height : offset2.height
  });
  var x3 = propsIncludingDefaults.x, y4 = propsIncludingDefaults.y, width = propsIncludingDefaults.width, height = propsIncludingDefaults.height, syncWithTicks = propsIncludingDefaults.syncWithTicks, horizontalValues = propsIncludingDefaults.horizontalValues, verticalValues = propsIncludingDefaults.verticalValues;
  var xAxis = useArbitraryXAxis();
  var yAxis = useYAxisWithFiniteDomainOrRandom();
  if (!isNumber(width) || width <= 0 || !isNumber(height) || height <= 0 || !isNumber(x3) || x3 !== +x3 || !isNumber(y4) || y4 !== +y4) {
    return null;
  }
  var verticalCoordinatesGenerator = propsIncludingDefaults.verticalCoordinatesGenerator || defaultVerticalCoordinatesGenerator;
  var horizontalCoordinatesGenerator = propsIncludingDefaults.horizontalCoordinatesGenerator || defaultHorizontalCoordinatesGenerator;
  var horizontalPoints = propsIncludingDefaults.horizontalPoints, verticalPoints = propsIncludingDefaults.verticalPoints;
  if ((!horizontalPoints || !horizontalPoints.length) && isFunction(horizontalCoordinatesGenerator)) {
    var isHorizontalValues = horizontalValues && horizontalValues.length;
    var generatorResult = horizontalCoordinatesGenerator({
      yAxis: yAxis ? _objectSpread$4(_objectSpread$4({}, yAxis), {}, {
        ticks: isHorizontalValues ? horizontalValues : yAxis.ticks
      }) : void 0,
      width: chartWidth,
      height: chartHeight,
      offset: offset2
    }, isHorizontalValues ? true : syncWithTicks);
    warn$1(Array.isArray(generatorResult), "horizontalCoordinatesGenerator should return Array but instead it returned [".concat(_typeof$7(generatorResult), "]"));
    if (Array.isArray(generatorResult)) {
      horizontalPoints = generatorResult;
    }
  }
  if ((!verticalPoints || !verticalPoints.length) && isFunction(verticalCoordinatesGenerator)) {
    var isVerticalValues = verticalValues && verticalValues.length;
    var _generatorResult = verticalCoordinatesGenerator({
      xAxis: xAxis ? _objectSpread$4(_objectSpread$4({}, xAxis), {}, {
        ticks: isVerticalValues ? verticalValues : xAxis.ticks
      }) : void 0,
      width: chartWidth,
      height: chartHeight,
      offset: offset2
    }, isVerticalValues ? true : syncWithTicks);
    warn$1(Array.isArray(_generatorResult), "verticalCoordinatesGenerator should return Array but instead it returned [".concat(_typeof$7(_generatorResult), "]"));
    if (Array.isArray(_generatorResult)) {
      verticalPoints = _generatorResult;
    }
  }
  return /* @__PURE__ */ React__default.createElement("g", {
    className: "recharts-cartesian-grid"
  }, /* @__PURE__ */ React__default.createElement(Background, {
    fill: propsIncludingDefaults.fill,
    fillOpacity: propsIncludingDefaults.fillOpacity,
    x: propsIncludingDefaults.x,
    y: propsIncludingDefaults.y,
    width: propsIncludingDefaults.width,
    height: propsIncludingDefaults.height,
    ry: propsIncludingDefaults.ry
  }), /* @__PURE__ */ React__default.createElement(HorizontalGridLines, _extends$5({}, propsIncludingDefaults, {
    offset: offset2,
    horizontalPoints,
    xAxis,
    yAxis
  })), /* @__PURE__ */ React__default.createElement(VerticalGridLines, _extends$5({}, propsIncludingDefaults, {
    offset: offset2,
    verticalPoints,
    xAxis,
    yAxis
  })), /* @__PURE__ */ React__default.createElement(HorizontalStripes, _extends$5({}, propsIncludingDefaults, {
    horizontalPoints
  })), /* @__PURE__ */ React__default.createElement(VerticalStripes, _extends$5({}, propsIncludingDefaults, {
    verticalPoints
  })));
}
CartesianGrid.displayName = "CartesianGrid";
var _excluded$2 = ["type", "layout", "connectNulls", "ref"], _excluded2$2 = ["key"];
function _typeof$6(o2) {
  "@babel/helpers - typeof";
  return _typeof$6 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof$6(o2);
}
function _objectWithoutProperties$2(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$2(source, excluded);
  var key, i3;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i3 = 0; i3 < sourceSymbolKeys.length; i3++) {
      key = sourceSymbolKeys[i3];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$2(source, excluded) {
  if (source == null) return {};
  var target = {};
  for (var key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _extends$4() {
  _extends$4 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i3 = 1; i3 < arguments.length; i3++) {
      var source = arguments[i3];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$4.apply(this, arguments);
}
function ownKeys$3(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e3);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$3(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$3(Object(t3), true).forEach(function(r3) {
      _defineProperty$6(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$3(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
function _toConsumableArray$2(arr) {
  return _arrayWithoutHoles$2(arr) || _iterableToArray$2(arr) || _unsupportedIterableToArray$2(arr) || _nonIterableSpread$2();
}
function _nonIterableSpread$2() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$2(o2, minLen) {
  if (!o2) return;
  if (typeof o2 === "string") return _arrayLikeToArray$2(o2, minLen);
  var n2 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n2 === "Object" && o2.constructor) n2 = o2.constructor.name;
  if (n2 === "Map" || n2 === "Set") return Array.from(o2);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray$2(o2, minLen);
}
function _iterableToArray$2(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles$2(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$2(arr);
}
function _arrayLikeToArray$2(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i3 = 0, arr2 = new Array(len); i3 < len; i3++) arr2[i3] = arr[i3];
  return arr2;
}
function _classCallCheck$5(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$5(target, props) {
  for (var i3 = 0; i3 < props.length; i3++) {
    var descriptor = props[i3];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$6(descriptor.key), descriptor);
  }
}
function _createClass$5(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$5(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$5(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _callSuper$4(t3, o2, e3) {
  return o2 = _getPrototypeOf$4(o2), _possibleConstructorReturn$4(t3, _isNativeReflectConstruct$4() ? Reflect.construct(o2, e3 || [], _getPrototypeOf$4(t3).constructor) : o2.apply(t3, e3));
}
function _possibleConstructorReturn$4(self2, call) {
  if (call && (_typeof$6(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$4(self2);
}
function _assertThisInitialized$4(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$4() {
  try {
    var t3 = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$4 = function _isNativeReflectConstruct2() {
    return !!t3;
  })();
}
function _getPrototypeOf$4(o2) {
  _getPrototypeOf$4 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o3) {
    return o3.__proto__ || Object.getPrototypeOf(o3);
  };
  return _getPrototypeOf$4(o2);
}
function _inherits$4(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass) _setPrototypeOf$4(subClass, superClass);
}
function _setPrototypeOf$4(o2, p2) {
  _setPrototypeOf$4 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o3, p3) {
    o3.__proto__ = p3;
    return o3;
  };
  return _setPrototypeOf$4(o2, p2);
}
function _defineProperty$6(obj, key, value) {
  key = _toPropertyKey$6(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$6(t3) {
  var i3 = _toPrimitive$6(t3, "string");
  return "symbol" == _typeof$6(i3) ? i3 : i3 + "";
}
function _toPrimitive$6(t3, r2) {
  if ("object" != _typeof$6(t3) || !t3) return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i3 = e3.call(t3, r2);
    if ("object" != _typeof$6(i3)) return i3;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t3);
}
var Line$1 = /* @__PURE__ */ function(_PureComponent) {
  function Line2() {
    var _this;
    _classCallCheck$5(this, Line2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$4(this, Line2, [].concat(args));
    _defineProperty$6(_this, "state", {
      isAnimationFinished: true,
      totalLength: 0
    });
    _defineProperty$6(_this, "generateSimpleStrokeDasharray", function(totalLength, length) {
      return "".concat(length, "px ").concat(totalLength - length, "px");
    });
    _defineProperty$6(_this, "getStrokeDasharray", function(length, totalLength, lines) {
      var lineLength = lines.reduce(function(pre, next) {
        return pre + next;
      });
      if (!lineLength) {
        return _this.generateSimpleStrokeDasharray(totalLength, length);
      }
      var count2 = Math.floor(length / lineLength);
      var remainLength = length % lineLength;
      var restLength = totalLength - length;
      var remainLines = [];
      for (var i3 = 0, sum2 = 0; i3 < lines.length; sum2 += lines[i3], ++i3) {
        if (sum2 + lines[i3] > remainLength) {
          remainLines = [].concat(_toConsumableArray$2(lines.slice(0, i3)), [remainLength - sum2]);
          break;
        }
      }
      var emptyLines = remainLines.length % 2 === 0 ? [0, restLength] : [restLength];
      return [].concat(_toConsumableArray$2(Line2.repeat(lines, count2)), _toConsumableArray$2(remainLines), emptyLines).map(function(line) {
        return "".concat(line, "px");
      }).join(", ");
    });
    _defineProperty$6(_this, "id", uniqueId("recharts-line-"));
    _defineProperty$6(_this, "pathRef", function(node) {
      _this.mainCurve = node;
    });
    _defineProperty$6(_this, "handleAnimationEnd", function() {
      _this.setState({
        isAnimationFinished: true
      });
      if (_this.props.onAnimationEnd) {
        _this.props.onAnimationEnd();
      }
    });
    _defineProperty$6(_this, "handleAnimationStart", function() {
      _this.setState({
        isAnimationFinished: false
      });
      if (_this.props.onAnimationStart) {
        _this.props.onAnimationStart();
      }
    });
    return _this;
  }
  _inherits$4(Line2, _PureComponent);
  return _createClass$5(Line2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.isAnimationActive) {
        return;
      }
      var totalLength = this.getTotalLength();
      this.setState({
        totalLength
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (!this.props.isAnimationActive) {
        return;
      }
      var totalLength = this.getTotalLength();
      if (totalLength !== this.state.totalLength) {
        this.setState({
          totalLength
        });
      }
    }
  }, {
    key: "getTotalLength",
    value: function getTotalLength() {
      var curveDom = this.mainCurve;
      try {
        return curveDom && curveDom.getTotalLength && curveDom.getTotalLength() || 0;
      } catch (err) {
        return 0;
      }
    }
  }, {
    key: "renderErrorBar",
    value: function renderErrorBar(needClip, clipPathId) {
      if (this.props.isAnimationActive && !this.state.isAnimationFinished) {
        return null;
      }
      var _this$props = this.props, points = _this$props.points, xAxis = _this$props.xAxis, yAxis = _this$props.yAxis, layout = _this$props.layout, children = _this$props.children;
      var errorBarItems = findAllByType(children, ErrorBar);
      if (!errorBarItems) {
        return null;
      }
      var dataPointFormatter = function dataPointFormatter2(dataPoint, dataKey) {
        return {
          x: dataPoint.x,
          y: dataPoint.y,
          value: dataPoint.value,
          errorVal: getValueByDataKey(dataPoint.payload, dataKey)
        };
      };
      var errorBarProps = {
        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
      };
      return /* @__PURE__ */ React__default.createElement(Layer, errorBarProps, errorBarItems.map(function(item) {
        return /* @__PURE__ */ React__default.cloneElement(item, {
          key: "bar-".concat(item.props.dataKey),
          data: points,
          xAxis,
          yAxis,
          layout,
          dataPointFormatter
        });
      }));
    }
  }, {
    key: "renderDots",
    value: function renderDots(needClip, clipDot, clipPathId) {
      var isAnimationActive = this.props.isAnimationActive;
      if (isAnimationActive && !this.state.isAnimationFinished) {
        return null;
      }
      var _this$props2 = this.props, dot = _this$props2.dot, points = _this$props2.points, dataKey = _this$props2.dataKey;
      var lineProps = filterProps(this.props, false);
      var customDotProps = filterProps(dot, true);
      var dots = points.map(function(entry, i3) {
        var dotProps = _objectSpread$3(_objectSpread$3(_objectSpread$3({
          key: "dot-".concat(i3),
          r: 3
        }, lineProps), customDotProps), {}, {
          value: entry.value,
          dataKey,
          cx: entry.x,
          cy: entry.y,
          index: i3,
          payload: entry.payload
        });
        return Line2.renderDotItem(dot, dotProps);
      });
      var dotsProps = {
        clipPath: needClip ? "url(#clipPath-".concat(clipDot ? "" : "dots-").concat(clipPathId, ")") : null
      };
      return /* @__PURE__ */ React__default.createElement(Layer, _extends$4({
        className: "recharts-line-dots",
        key: "dots"
      }, dotsProps), dots);
    }
  }, {
    key: "renderCurveStatically",
    value: function renderCurveStatically(points, needClip, clipPathId, props) {
      var _this$props3 = this.props, type = _this$props3.type, layout = _this$props3.layout, connectNulls = _this$props3.connectNulls;
      _this$props3.ref;
      var others = _objectWithoutProperties$2(_this$props3, _excluded$2);
      var curveProps = _objectSpread$3(_objectSpread$3(_objectSpread$3({}, filterProps(others, true)), {}, {
        fill: "none",
        className: "recharts-line-curve",
        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null,
        points
      }, props), {}, {
        type,
        layout,
        connectNulls
      });
      return /* @__PURE__ */ React__default.createElement(Curve, _extends$4({}, curveProps, {
        pathRef: this.pathRef
      }));
    }
  }, {
    key: "renderCurveWithAnimation",
    value: function renderCurveWithAnimation(needClip, clipPathId) {
      var _this2 = this;
      var _this$props4 = this.props, points = _this$props4.points, strokeDasharray = _this$props4.strokeDasharray, isAnimationActive = _this$props4.isAnimationActive, animationBegin = _this$props4.animationBegin, animationDuration = _this$props4.animationDuration, animationEasing = _this$props4.animationEasing, animationId = _this$props4.animationId, animateNewValues = _this$props4.animateNewValues, width = _this$props4.width, height = _this$props4.height;
      var _this$state = this.state, prevPoints = _this$state.prevPoints, totalLength = _this$state.totalLength;
      return /* @__PURE__ */ React__default.createElement(Animate, {
        begin: animationBegin,
        duration: animationDuration,
        isActive: isAnimationActive,
        easing: animationEasing,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "line-".concat(animationId),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(_ref) {
        var t3 = _ref.t;
        if (prevPoints) {
          var prevPointsDiffFactor = prevPoints.length / points.length;
          var stepData = points.map(function(entry, index2) {
            var prevPointIndex = Math.floor(index2 * prevPointsDiffFactor);
            if (prevPoints[prevPointIndex]) {
              var prev = prevPoints[prevPointIndex];
              var interpolatorX = interpolateNumber$2(prev.x, entry.x);
              var interpolatorY = interpolateNumber$2(prev.y, entry.y);
              return _objectSpread$3(_objectSpread$3({}, entry), {}, {
                x: interpolatorX(t3),
                y: interpolatorY(t3)
              });
            }
            if (animateNewValues) {
              var _interpolatorX = interpolateNumber$2(width * 2, entry.x);
              var _interpolatorY = interpolateNumber$2(height / 2, entry.y);
              return _objectSpread$3(_objectSpread$3({}, entry), {}, {
                x: _interpolatorX(t3),
                y: _interpolatorY(t3)
              });
            }
            return _objectSpread$3(_objectSpread$3({}, entry), {}, {
              x: entry.x,
              y: entry.y
            });
          });
          return _this2.renderCurveStatically(stepData, needClip, clipPathId);
        }
        var interpolator = interpolateNumber$2(0, totalLength);
        var curLength = interpolator(t3);
        var currentStrokeDasharray;
        if (strokeDasharray) {
          var lines = "".concat(strokeDasharray).split(/[,\s]+/gim).map(function(num) {
            return parseFloat(num);
          });
          currentStrokeDasharray = _this2.getStrokeDasharray(curLength, totalLength, lines);
        } else {
          currentStrokeDasharray = _this2.generateSimpleStrokeDasharray(totalLength, curLength);
        }
        return _this2.renderCurveStatically(points, needClip, clipPathId, {
          strokeDasharray: currentStrokeDasharray
        });
      });
    }
  }, {
    key: "renderCurve",
    value: function renderCurve(needClip, clipPathId) {
      var _this$props5 = this.props, points = _this$props5.points, isAnimationActive = _this$props5.isAnimationActive;
      var _this$state2 = this.state, prevPoints = _this$state2.prevPoints, totalLength = _this$state2.totalLength;
      if (isAnimationActive && points && points.length && (!prevPoints && totalLength > 0 || !isEqual(prevPoints, points))) {
        return this.renderCurveWithAnimation(needClip, clipPathId);
      }
      return this.renderCurveStatically(points, needClip, clipPathId);
    }
  }, {
    key: "render",
    value: function render() {
      var _filterProps;
      var _this$props6 = this.props, hide2 = _this$props6.hide, dot = _this$props6.dot, points = _this$props6.points, className = _this$props6.className, xAxis = _this$props6.xAxis, yAxis = _this$props6.yAxis, top = _this$props6.top, left = _this$props6.left, width = _this$props6.width, height = _this$props6.height, isAnimationActive = _this$props6.isAnimationActive, id2 = _this$props6.id;
      if (hide2 || !points || !points.length) {
        return null;
      }
      var isAnimationFinished = this.state.isAnimationFinished;
      var hasSinglePoint = points.length === 1;
      var layerClass = clsx("recharts-line", className);
      var needClipX = xAxis && xAxis.allowDataOverflow;
      var needClipY = yAxis && yAxis.allowDataOverflow;
      var needClip = needClipX || needClipY;
      var clipPathId = isNil(id2) ? this.id : id2;
      var _ref2 = (_filterProps = filterProps(dot, false)) !== null && _filterProps !== void 0 ? _filterProps : {
        r: 3,
        strokeWidth: 2
      }, _ref2$r = _ref2.r, r2 = _ref2$r === void 0 ? 3 : _ref2$r, _ref2$strokeWidth = _ref2.strokeWidth, strokeWidth = _ref2$strokeWidth === void 0 ? 2 : _ref2$strokeWidth;
      var _ref3 = hasClipDot(dot) ? dot : {}, _ref3$clipDot = _ref3.clipDot, clipDot = _ref3$clipDot === void 0 ? true : _ref3$clipDot;
      var dotSize = r2 * 2 + strokeWidth;
      return /* @__PURE__ */ React__default.createElement(Layer, {
        className: layerClass
      }, needClipX || needClipY ? /* @__PURE__ */ React__default.createElement("defs", null, /* @__PURE__ */ React__default.createElement("clipPath", {
        id: "clipPath-".concat(clipPathId)
      }, /* @__PURE__ */ React__default.createElement("rect", {
        x: needClipX ? left : left - width / 2,
        y: needClipY ? top : top - height / 2,
        width: needClipX ? width : width * 2,
        height: needClipY ? height : height * 2
      })), !clipDot && /* @__PURE__ */ React__default.createElement("clipPath", {
        id: "clipPath-dots-".concat(clipPathId)
      }, /* @__PURE__ */ React__default.createElement("rect", {
        x: left - dotSize / 2,
        y: top - dotSize / 2,
        width: width + dotSize,
        height: height + dotSize
      }))) : null, !hasSinglePoint && this.renderCurve(needClip, clipPathId), this.renderErrorBar(needClip, clipPathId), (hasSinglePoint || dot) && this.renderDots(needClip, clipDot, clipPathId), (!isAnimationActive || isAnimationFinished) && LabelList.renderCallByParent(this.props, points));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.animationId !== prevState.prevAnimationId) {
        return {
          prevAnimationId: nextProps.animationId,
          curPoints: nextProps.points,
          prevPoints: prevState.curPoints
        };
      }
      if (nextProps.points !== prevState.curPoints) {
        return {
          curPoints: nextProps.points
        };
      }
      return null;
    }
  }, {
    key: "repeat",
    value: function repeat(lines, count2) {
      var linesUnit = lines.length % 2 !== 0 ? [].concat(_toConsumableArray$2(lines), [0]) : lines;
      var result = [];
      for (var i3 = 0; i3 < count2; ++i3) {
        result = [].concat(_toConsumableArray$2(result), _toConsumableArray$2(linesUnit));
      }
      return result;
    }
  }, {
    key: "renderDotItem",
    value: function renderDotItem(option, props) {
      var dotItem;
      if (/* @__PURE__ */ React__default.isValidElement(option)) {
        dotItem = /* @__PURE__ */ React__default.cloneElement(option, props);
      } else if (isFunction(option)) {
        dotItem = option(props);
      } else {
        var key = props.key, dotProps = _objectWithoutProperties$2(props, _excluded2$2);
        var className = clsx("recharts-line-dot", typeof option !== "boolean" ? option.className : "");
        dotItem = /* @__PURE__ */ React__default.createElement(Dot, _extends$4({
          key
        }, dotProps, {
          className
        }));
      }
      return dotItem;
    }
  }]);
}(PureComponent);
_defineProperty$6(Line$1, "displayName", "Line");
_defineProperty$6(Line$1, "defaultProps", {
  xAxisId: 0,
  yAxisId: 0,
  connectNulls: false,
  activeDot: true,
  dot: true,
  legendType: "line",
  stroke: "#3182bd",
  strokeWidth: 1,
  fill: "#fff",
  points: [],
  isAnimationActive: !Global.isSsr,
  animateNewValues: true,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease",
  hide: false,
  label: false
});
_defineProperty$6(Line$1, "getComposedData", function(_ref4) {
  var props = _ref4.props, xAxis = _ref4.xAxis, yAxis = _ref4.yAxis, xAxisTicks = _ref4.xAxisTicks, yAxisTicks = _ref4.yAxisTicks, dataKey = _ref4.dataKey, bandSize = _ref4.bandSize, displayedData = _ref4.displayedData, offset2 = _ref4.offset;
  var layout = props.layout;
  var points = displayedData.map(function(entry, index2) {
    var value = getValueByDataKey(entry, dataKey);
    if (layout === "horizontal") {
      return {
        x: getCateCoordinateOfLine({
          axis: xAxis,
          ticks: xAxisTicks,
          bandSize,
          entry,
          index: index2
        }),
        y: isNil(value) ? null : yAxis.scale(value),
        value,
        payload: entry
      };
    }
    return {
      x: isNil(value) ? null : xAxis.scale(value),
      y: getCateCoordinateOfLine({
        axis: yAxis,
        ticks: yAxisTicks,
        bandSize,
        entry,
        index: index2
      }),
      value,
      payload: entry
    };
  });
  return _objectSpread$3({
    points,
    layout
  }, offset2);
});
var _excluded$1 = ["layout", "type", "stroke", "connectNulls", "isRange", "ref"], _excluded2$1 = ["key"];
var _Area;
function _typeof$5(o2) {
  "@babel/helpers - typeof";
  return _typeof$5 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof$5(o2);
}
function _objectWithoutProperties$1(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$1(source, excluded);
  var key, i3;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i3 = 0; i3 < sourceSymbolKeys.length; i3++) {
      key = sourceSymbolKeys[i3];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  for (var key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _extends$3() {
  _extends$3 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i3 = 1; i3 < arguments.length; i3++) {
      var source = arguments[i3];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$3.apply(this, arguments);
}
function ownKeys$2(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e3);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$2(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$2(Object(t3), true).forEach(function(r3) {
      _defineProperty$5(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$2(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
function _classCallCheck$4(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$4(target, props) {
  for (var i3 = 0; i3 < props.length; i3++) {
    var descriptor = props[i3];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$5(descriptor.key), descriptor);
  }
}
function _createClass$4(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$4(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$4(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _callSuper$3(t3, o2, e3) {
  return o2 = _getPrototypeOf$3(o2), _possibleConstructorReturn$3(t3, _isNativeReflectConstruct$3() ? Reflect.construct(o2, e3 || [], _getPrototypeOf$3(t3).constructor) : o2.apply(t3, e3));
}
function _possibleConstructorReturn$3(self2, call) {
  if (call && (_typeof$5(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$3(self2);
}
function _assertThisInitialized$3(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$3() {
  try {
    var t3 = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$3 = function _isNativeReflectConstruct2() {
    return !!t3;
  })();
}
function _getPrototypeOf$3(o2) {
  _getPrototypeOf$3 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o3) {
    return o3.__proto__ || Object.getPrototypeOf(o3);
  };
  return _getPrototypeOf$3(o2);
}
function _inherits$3(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass) _setPrototypeOf$3(subClass, superClass);
}
function _setPrototypeOf$3(o2, p2) {
  _setPrototypeOf$3 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o3, p3) {
    o3.__proto__ = p3;
    return o3;
  };
  return _setPrototypeOf$3(o2, p2);
}
function _defineProperty$5(obj, key, value) {
  key = _toPropertyKey$5(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$5(t3) {
  var i3 = _toPrimitive$5(t3, "string");
  return "symbol" == _typeof$5(i3) ? i3 : i3 + "";
}
function _toPrimitive$5(t3, r2) {
  if ("object" != _typeof$5(t3) || !t3) return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i3 = e3.call(t3, r2);
    if ("object" != _typeof$5(i3)) return i3;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t3);
}
var Area$1 = /* @__PURE__ */ function(_PureComponent) {
  function Area2() {
    var _this;
    _classCallCheck$4(this, Area2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$3(this, Area2, [].concat(args));
    _defineProperty$5(_this, "state", {
      isAnimationFinished: true
    });
    _defineProperty$5(_this, "id", uniqueId("recharts-area-"));
    _defineProperty$5(_this, "handleAnimationEnd", function() {
      var onAnimationEnd2 = _this.props.onAnimationEnd;
      _this.setState({
        isAnimationFinished: true
      });
      if (isFunction(onAnimationEnd2)) {
        onAnimationEnd2();
      }
    });
    _defineProperty$5(_this, "handleAnimationStart", function() {
      var onAnimationStart2 = _this.props.onAnimationStart;
      _this.setState({
        isAnimationFinished: false
      });
      if (isFunction(onAnimationStart2)) {
        onAnimationStart2();
      }
    });
    return _this;
  }
  _inherits$3(Area2, _PureComponent);
  return _createClass$4(Area2, [{
    key: "renderDots",
    value: function renderDots(needClip, clipDot, clipPathId) {
      var isAnimationActive = this.props.isAnimationActive;
      var isAnimationFinished = this.state.isAnimationFinished;
      if (isAnimationActive && !isAnimationFinished) {
        return null;
      }
      var _this$props = this.props, dot = _this$props.dot, points = _this$props.points, dataKey = _this$props.dataKey;
      var areaProps = filterProps(this.props, false);
      var customDotProps = filterProps(dot, true);
      var dots = points.map(function(entry, i3) {
        var dotProps = _objectSpread$2(_objectSpread$2(_objectSpread$2({
          key: "dot-".concat(i3),
          r: 3
        }, areaProps), customDotProps), {}, {
          index: i3,
          cx: entry.x,
          cy: entry.y,
          dataKey,
          value: entry.value,
          payload: entry.payload,
          points
        });
        return Area2.renderDotItem(dot, dotProps);
      });
      var dotsProps = {
        clipPath: needClip ? "url(#clipPath-".concat(clipDot ? "" : "dots-").concat(clipPathId, ")") : null
      };
      return /* @__PURE__ */ React__default.createElement(Layer, _extends$3({
        className: "recharts-area-dots"
      }, dotsProps), dots);
    }
  }, {
    key: "renderHorizontalRect",
    value: function renderHorizontalRect(alpha3) {
      var _this$props2 = this.props, baseLine = _this$props2.baseLine, points = _this$props2.points, strokeWidth = _this$props2.strokeWidth;
      var startX = points[0].x;
      var endX = points[points.length - 1].x;
      var width = alpha3 * Math.abs(startX - endX);
      var maxY = max(points.map(function(entry) {
        return entry.y || 0;
      }));
      if (isNumber(baseLine) && typeof baseLine === "number") {
        maxY = Math.max(baseLine, maxY);
      } else if (baseLine && Array.isArray(baseLine) && baseLine.length) {
        maxY = Math.max(max(baseLine.map(function(entry) {
          return entry.y || 0;
        })), maxY);
      }
      if (isNumber(maxY)) {
        return /* @__PURE__ */ React__default.createElement("rect", {
          x: startX < endX ? startX : startX - width,
          y: 0,
          width,
          height: Math.floor(maxY + (strokeWidth ? parseInt("".concat(strokeWidth), 10) : 1))
        });
      }
      return null;
    }
  }, {
    key: "renderVerticalRect",
    value: function renderVerticalRect(alpha3) {
      var _this$props3 = this.props, baseLine = _this$props3.baseLine, points = _this$props3.points, strokeWidth = _this$props3.strokeWidth;
      var startY = points[0].y;
      var endY = points[points.length - 1].y;
      var height = alpha3 * Math.abs(startY - endY);
      var maxX = max(points.map(function(entry) {
        return entry.x || 0;
      }));
      if (isNumber(baseLine) && typeof baseLine === "number") {
        maxX = Math.max(baseLine, maxX);
      } else if (baseLine && Array.isArray(baseLine) && baseLine.length) {
        maxX = Math.max(max(baseLine.map(function(entry) {
          return entry.x || 0;
        })), maxX);
      }
      if (isNumber(maxX)) {
        return /* @__PURE__ */ React__default.createElement("rect", {
          x: 0,
          y: startY < endY ? startY : startY - height,
          width: maxX + (strokeWidth ? parseInt("".concat(strokeWidth), 10) : 1),
          height: Math.floor(height)
        });
      }
      return null;
    }
  }, {
    key: "renderClipRect",
    value: function renderClipRect(alpha3) {
      var layout = this.props.layout;
      if (layout === "vertical") {
        return this.renderVerticalRect(alpha3);
      }
      return this.renderHorizontalRect(alpha3);
    }
  }, {
    key: "renderAreaStatically",
    value: function renderAreaStatically(points, baseLine, needClip, clipPathId) {
      var _this$props4 = this.props, layout = _this$props4.layout, type = _this$props4.type, stroke = _this$props4.stroke, connectNulls = _this$props4.connectNulls, isRange = _this$props4.isRange;
      _this$props4.ref;
      var others = _objectWithoutProperties$1(_this$props4, _excluded$1);
      return /* @__PURE__ */ React__default.createElement(Layer, {
        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
      }, /* @__PURE__ */ React__default.createElement(Curve, _extends$3({}, filterProps(others, true), {
        points,
        connectNulls,
        type,
        baseLine,
        layout,
        stroke: "none",
        className: "recharts-area-area"
      })), stroke !== "none" && /* @__PURE__ */ React__default.createElement(Curve, _extends$3({}, filterProps(this.props, false), {
        className: "recharts-area-curve",
        layout,
        type,
        connectNulls,
        fill: "none",
        points
      })), stroke !== "none" && isRange && /* @__PURE__ */ React__default.createElement(Curve, _extends$3({}, filterProps(this.props, false), {
        className: "recharts-area-curve",
        layout,
        type,
        connectNulls,
        fill: "none",
        points: baseLine
      })));
    }
  }, {
    key: "renderAreaWithAnimation",
    value: function renderAreaWithAnimation(needClip, clipPathId) {
      var _this2 = this;
      var _this$props5 = this.props, points = _this$props5.points, baseLine = _this$props5.baseLine, isAnimationActive = _this$props5.isAnimationActive, animationBegin = _this$props5.animationBegin, animationDuration = _this$props5.animationDuration, animationEasing = _this$props5.animationEasing, animationId = _this$props5.animationId;
      var _this$state = this.state, prevPoints = _this$state.prevPoints, prevBaseLine = _this$state.prevBaseLine;
      return /* @__PURE__ */ React__default.createElement(Animate, {
        begin: animationBegin,
        duration: animationDuration,
        isActive: isAnimationActive,
        easing: animationEasing,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "area-".concat(animationId),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(_ref) {
        var t3 = _ref.t;
        if (prevPoints) {
          var prevPointsDiffFactor = prevPoints.length / points.length;
          var stepPoints = points.map(function(entry, index2) {
            var prevPointIndex = Math.floor(index2 * prevPointsDiffFactor);
            if (prevPoints[prevPointIndex]) {
              var prev = prevPoints[prevPointIndex];
              var interpolatorX = interpolateNumber$2(prev.x, entry.x);
              var interpolatorY = interpolateNumber$2(prev.y, entry.y);
              return _objectSpread$2(_objectSpread$2({}, entry), {}, {
                x: interpolatorX(t3),
                y: interpolatorY(t3)
              });
            }
            return entry;
          });
          var stepBaseLine;
          if (isNumber(baseLine) && typeof baseLine === "number") {
            var interpolator = interpolateNumber$2(prevBaseLine, baseLine);
            stepBaseLine = interpolator(t3);
          } else if (isNil(baseLine) || isNan(baseLine)) {
            var _interpolator = interpolateNumber$2(prevBaseLine, 0);
            stepBaseLine = _interpolator(t3);
          } else {
            stepBaseLine = baseLine.map(function(entry, index2) {
              var prevPointIndex = Math.floor(index2 * prevPointsDiffFactor);
              if (prevBaseLine[prevPointIndex]) {
                var prev = prevBaseLine[prevPointIndex];
                var interpolatorX = interpolateNumber$2(prev.x, entry.x);
                var interpolatorY = interpolateNumber$2(prev.y, entry.y);
                return _objectSpread$2(_objectSpread$2({}, entry), {}, {
                  x: interpolatorX(t3),
                  y: interpolatorY(t3)
                });
              }
              return entry;
            });
          }
          return _this2.renderAreaStatically(stepPoints, stepBaseLine, needClip, clipPathId);
        }
        return /* @__PURE__ */ React__default.createElement(Layer, null, /* @__PURE__ */ React__default.createElement("defs", null, /* @__PURE__ */ React__default.createElement("clipPath", {
          id: "animationClipPath-".concat(clipPathId)
        }, _this2.renderClipRect(t3))), /* @__PURE__ */ React__default.createElement(Layer, {
          clipPath: "url(#animationClipPath-".concat(clipPathId, ")")
        }, _this2.renderAreaStatically(points, baseLine, needClip, clipPathId)));
      });
    }
  }, {
    key: "renderArea",
    value: function renderArea(needClip, clipPathId) {
      var _this$props6 = this.props, points = _this$props6.points, baseLine = _this$props6.baseLine, isAnimationActive = _this$props6.isAnimationActive;
      var _this$state2 = this.state, prevPoints = _this$state2.prevPoints, prevBaseLine = _this$state2.prevBaseLine, totalLength = _this$state2.totalLength;
      if (isAnimationActive && points && points.length && (!prevPoints && totalLength > 0 || !isEqual(prevPoints, points) || !isEqual(prevBaseLine, baseLine))) {
        return this.renderAreaWithAnimation(needClip, clipPathId);
      }
      return this.renderAreaStatically(points, baseLine, needClip, clipPathId);
    }
  }, {
    key: "render",
    value: function render() {
      var _filterProps;
      var _this$props7 = this.props, hide2 = _this$props7.hide, dot = _this$props7.dot, points = _this$props7.points, className = _this$props7.className, top = _this$props7.top, left = _this$props7.left, xAxis = _this$props7.xAxis, yAxis = _this$props7.yAxis, width = _this$props7.width, height = _this$props7.height, isAnimationActive = _this$props7.isAnimationActive, id2 = _this$props7.id;
      if (hide2 || !points || !points.length) {
        return null;
      }
      var isAnimationFinished = this.state.isAnimationFinished;
      var hasSinglePoint = points.length === 1;
      var layerClass = clsx("recharts-area", className);
      var needClipX = xAxis && xAxis.allowDataOverflow;
      var needClipY = yAxis && yAxis.allowDataOverflow;
      var needClip = needClipX || needClipY;
      var clipPathId = isNil(id2) ? this.id : id2;
      var _ref2 = (_filterProps = filterProps(dot, false)) !== null && _filterProps !== void 0 ? _filterProps : {
        r: 3,
        strokeWidth: 2
      }, _ref2$r = _ref2.r, r2 = _ref2$r === void 0 ? 3 : _ref2$r, _ref2$strokeWidth = _ref2.strokeWidth, strokeWidth = _ref2$strokeWidth === void 0 ? 2 : _ref2$strokeWidth;
      var _ref3 = hasClipDot(dot) ? dot : {}, _ref3$clipDot = _ref3.clipDot, clipDot = _ref3$clipDot === void 0 ? true : _ref3$clipDot;
      var dotSize = r2 * 2 + strokeWidth;
      return /* @__PURE__ */ React__default.createElement(Layer, {
        className: layerClass
      }, needClipX || needClipY ? /* @__PURE__ */ React__default.createElement("defs", null, /* @__PURE__ */ React__default.createElement("clipPath", {
        id: "clipPath-".concat(clipPathId)
      }, /* @__PURE__ */ React__default.createElement("rect", {
        x: needClipX ? left : left - width / 2,
        y: needClipY ? top : top - height / 2,
        width: needClipX ? width : width * 2,
        height: needClipY ? height : height * 2
      })), !clipDot && /* @__PURE__ */ React__default.createElement("clipPath", {
        id: "clipPath-dots-".concat(clipPathId)
      }, /* @__PURE__ */ React__default.createElement("rect", {
        x: left - dotSize / 2,
        y: top - dotSize / 2,
        width: width + dotSize,
        height: height + dotSize
      }))) : null, !hasSinglePoint ? this.renderArea(needClip, clipPathId) : null, (dot || hasSinglePoint) && this.renderDots(needClip, clipDot, clipPathId), (!isAnimationActive || isAnimationFinished) && LabelList.renderCallByParent(this.props, points));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.animationId !== prevState.prevAnimationId) {
        return {
          prevAnimationId: nextProps.animationId,
          curPoints: nextProps.points,
          curBaseLine: nextProps.baseLine,
          prevPoints: prevState.curPoints,
          prevBaseLine: prevState.curBaseLine
        };
      }
      if (nextProps.points !== prevState.curPoints || nextProps.baseLine !== prevState.curBaseLine) {
        return {
          curPoints: nextProps.points,
          curBaseLine: nextProps.baseLine
        };
      }
      return null;
    }
  }]);
}(PureComponent);
_Area = Area$1;
_defineProperty$5(Area$1, "displayName", "Area");
_defineProperty$5(Area$1, "defaultProps", {
  stroke: "#3182bd",
  fill: "#3182bd",
  fillOpacity: 0.6,
  xAxisId: 0,
  yAxisId: 0,
  legendType: "line",
  connectNulls: false,
  // points of area
  points: [],
  dot: false,
  activeDot: true,
  hide: false,
  isAnimationActive: !Global.isSsr,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
});
_defineProperty$5(Area$1, "getBaseValue", function(props, item, xAxis, yAxis) {
  var layout = props.layout, chartBaseValue = props.baseValue;
  var itemBaseValue = item.props.baseValue;
  var baseValue = itemBaseValue !== null && itemBaseValue !== void 0 ? itemBaseValue : chartBaseValue;
  if (isNumber(baseValue) && typeof baseValue === "number") {
    return baseValue;
  }
  var numericAxis = layout === "horizontal" ? yAxis : xAxis;
  var domain = numericAxis.scale.domain();
  if (numericAxis.type === "number") {
    var domainMax = Math.max(domain[0], domain[1]);
    var domainMin = Math.min(domain[0], domain[1]);
    if (baseValue === "dataMin") {
      return domainMin;
    }
    if (baseValue === "dataMax") {
      return domainMax;
    }
    return domainMax < 0 ? domainMax : Math.max(Math.min(domain[0], domain[1]), 0);
  }
  if (baseValue === "dataMin") {
    return domain[0];
  }
  if (baseValue === "dataMax") {
    return domain[1];
  }
  return domain[0];
});
_defineProperty$5(Area$1, "getComposedData", function(_ref4) {
  var props = _ref4.props, item = _ref4.item, xAxis = _ref4.xAxis, yAxis = _ref4.yAxis, xAxisTicks = _ref4.xAxisTicks, yAxisTicks = _ref4.yAxisTicks, bandSize = _ref4.bandSize, dataKey = _ref4.dataKey, stackedData = _ref4.stackedData, dataStartIndex = _ref4.dataStartIndex, displayedData = _ref4.displayedData, offset2 = _ref4.offset;
  var layout = props.layout;
  var hasStack = stackedData && stackedData.length;
  var baseValue = _Area.getBaseValue(props, item, xAxis, yAxis);
  var isHorizontalLayout = layout === "horizontal";
  var isRange = false;
  var points = displayedData.map(function(entry, index2) {
    var value;
    if (hasStack) {
      value = stackedData[dataStartIndex + index2];
    } else {
      value = getValueByDataKey(entry, dataKey);
      if (!Array.isArray(value)) {
        value = [baseValue, value];
      } else {
        isRange = true;
      }
    }
    var isBreakPoint = value[1] == null || hasStack && getValueByDataKey(entry, dataKey) == null;
    if (isHorizontalLayout) {
      return {
        x: getCateCoordinateOfLine({
          axis: xAxis,
          ticks: xAxisTicks,
          bandSize,
          entry,
          index: index2
        }),
        y: isBreakPoint ? null : yAxis.scale(value[1]),
        value,
        payload: entry
      };
    }
    return {
      x: isBreakPoint ? null : xAxis.scale(value[1]),
      y: getCateCoordinateOfLine({
        axis: yAxis,
        ticks: yAxisTicks,
        bandSize,
        entry,
        index: index2
      }),
      value,
      payload: entry
    };
  });
  var baseLine;
  if (hasStack || isRange) {
    baseLine = points.map(function(entry) {
      var x3 = Array.isArray(entry.value) ? entry.value[0] : null;
      if (isHorizontalLayout) {
        return {
          x: entry.x,
          y: x3 != null && entry.y != null ? yAxis.scale(x3) : null
        };
      }
      return {
        x: x3 != null ? xAxis.scale(x3) : null,
        y: entry.y
      };
    });
  } else {
    baseLine = isHorizontalLayout ? yAxis.scale(baseValue) : xAxis.scale(baseValue);
  }
  return _objectSpread$2({
    points,
    baseLine,
    layout,
    isRange
  }, offset2);
});
_defineProperty$5(Area$1, "renderDotItem", function(option, props) {
  var dotItem;
  if (/* @__PURE__ */ React__default.isValidElement(option)) {
    dotItem = /* @__PURE__ */ React__default.cloneElement(option, props);
  } else if (isFunction(option)) {
    dotItem = option(props);
  } else {
    var className = clsx("recharts-area-dot", typeof option !== "boolean" ? option.className : "");
    var key = props.key, rest = _objectWithoutProperties$1(props, _excluded2$1);
    dotItem = /* @__PURE__ */ React__default.createElement(Dot, _extends$3({}, rest, {
      key,
      className
    }));
  }
  return dotItem;
});
function _typeof$4(o2) {
  "@babel/helpers - typeof";
  return _typeof$4 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof$4(o2);
}
function _classCallCheck$3(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$3(target, props) {
  for (var i3 = 0; i3 < props.length; i3++) {
    var descriptor = props[i3];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$4(descriptor.key), descriptor);
  }
}
function _createClass$3(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$3(Constructor.prototype, protoProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _callSuper$2(t3, o2, e3) {
  return o2 = _getPrototypeOf$2(o2), _possibleConstructorReturn$2(t3, _isNativeReflectConstruct$2() ? Reflect.construct(o2, e3 || [], _getPrototypeOf$2(t3).constructor) : o2.apply(t3, e3));
}
function _possibleConstructorReturn$2(self2, call) {
  if (call && (_typeof$4(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$2(self2);
}
function _assertThisInitialized$2(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$2() {
  try {
    var t3 = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$2 = function _isNativeReflectConstruct2() {
    return !!t3;
  })();
}
function _getPrototypeOf$2(o2) {
  _getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o3) {
    return o3.__proto__ || Object.getPrototypeOf(o3);
  };
  return _getPrototypeOf$2(o2);
}
function _inherits$2(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass) _setPrototypeOf$2(subClass, superClass);
}
function _setPrototypeOf$2(o2, p2) {
  _setPrototypeOf$2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o3, p3) {
    o3.__proto__ = p3;
    return o3;
  };
  return _setPrototypeOf$2(o2, p2);
}
function _defineProperty$4(obj, key, value) {
  key = _toPropertyKey$4(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$4(t3) {
  var i3 = _toPrimitive$4(t3, "string");
  return "symbol" == _typeof$4(i3) ? i3 : i3 + "";
}
function _toPrimitive$4(t3, r2) {
  if ("object" != _typeof$4(t3) || !t3) return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i3 = e3.call(t3, r2);
    if ("object" != _typeof$4(i3)) return i3;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t3);
}
function _extends$2() {
  _extends$2 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i3 = 1; i3 < arguments.length; i3++) {
      var source = arguments[i3];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$2.apply(this, arguments);
}
function XAxisImpl(_ref) {
  var xAxisId = _ref.xAxisId;
  var width = useChartWidth();
  var height = useChartHeight();
  var axisOptions = useXAxisOrThrow(xAxisId);
  if (axisOptions == null) {
    return null;
  }
  return (
    // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    /* @__PURE__ */ React__default.createElement(CartesianAxis, _extends$2({}, axisOptions, {
      className: clsx("recharts-".concat(axisOptions.axisType, " ").concat(axisOptions.axisType), axisOptions.className),
      viewBox: {
        x: 0,
        y: 0,
        width,
        height
      },
      ticksGenerator: function ticksGenerator(axis) {
        return getTicksOfAxis(axis, true);
      }
    }))
  );
}
var XAxis = /* @__PURE__ */ function(_React$Component) {
  function XAxis2() {
    _classCallCheck$3(this, XAxis2);
    return _callSuper$2(this, XAxis2, arguments);
  }
  _inherits$2(XAxis2, _React$Component);
  return _createClass$3(XAxis2, [{
    key: "render",
    value: function render() {
      return /* @__PURE__ */ React__default.createElement(XAxisImpl, this.props);
    }
  }]);
}(React__default.Component);
_defineProperty$4(XAxis, "displayName", "XAxis");
_defineProperty$4(XAxis, "defaultProps", {
  allowDecimals: true,
  hide: false,
  orientation: "bottom",
  width: 0,
  height: 30,
  mirror: false,
  xAxisId: 0,
  tickCount: 5,
  type: "category",
  padding: {
    left: 0,
    right: 0
  },
  allowDataOverflow: false,
  scale: "auto",
  reversed: false,
  allowDuplicatedCategory: true
});
function _typeof$3(o2) {
  "@babel/helpers - typeof";
  return _typeof$3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof$3(o2);
}
function _classCallCheck$2(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$2(target, props) {
  for (var i3 = 0; i3 < props.length; i3++) {
    var descriptor = props[i3];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$3(descriptor.key), descriptor);
  }
}
function _createClass$2(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$2(Constructor.prototype, protoProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _callSuper$1(t3, o2, e3) {
  return o2 = _getPrototypeOf$1(o2), _possibleConstructorReturn$1(t3, _isNativeReflectConstruct$1() ? Reflect.construct(o2, e3 || [], _getPrototypeOf$1(t3).constructor) : o2.apply(t3, e3));
}
function _possibleConstructorReturn$1(self2, call) {
  if (call && (_typeof$3(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$1(self2);
}
function _assertThisInitialized$1(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$1() {
  try {
    var t3 = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$1 = function _isNativeReflectConstruct2() {
    return !!t3;
  })();
}
function _getPrototypeOf$1(o2) {
  _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o3) {
    return o3.__proto__ || Object.getPrototypeOf(o3);
  };
  return _getPrototypeOf$1(o2);
}
function _inherits$1(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass) _setPrototypeOf$1(subClass, superClass);
}
function _setPrototypeOf$1(o2, p2) {
  _setPrototypeOf$1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o3, p3) {
    o3.__proto__ = p3;
    return o3;
  };
  return _setPrototypeOf$1(o2, p2);
}
function _defineProperty$3(obj, key, value) {
  key = _toPropertyKey$3(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$3(t3) {
  var i3 = _toPrimitive$3(t3, "string");
  return "symbol" == _typeof$3(i3) ? i3 : i3 + "";
}
function _toPrimitive$3(t3, r2) {
  if ("object" != _typeof$3(t3) || !t3) return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i3 = e3.call(t3, r2);
    if ("object" != _typeof$3(i3)) return i3;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t3);
}
function _extends$1() {
  _extends$1 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i3 = 1; i3 < arguments.length; i3++) {
      var source = arguments[i3];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$1.apply(this, arguments);
}
var YAxisImpl = function YAxisImpl2(_ref) {
  var yAxisId = _ref.yAxisId;
  var width = useChartWidth();
  var height = useChartHeight();
  var axisOptions = useYAxisOrThrow(yAxisId);
  if (axisOptions == null) {
    return null;
  }
  return (
    // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    /* @__PURE__ */ React__default.createElement(CartesianAxis, _extends$1({}, axisOptions, {
      className: clsx("recharts-".concat(axisOptions.axisType, " ").concat(axisOptions.axisType), axisOptions.className),
      viewBox: {
        x: 0,
        y: 0,
        width,
        height
      },
      ticksGenerator: function ticksGenerator(axis) {
        return getTicksOfAxis(axis, true);
      }
    }))
  );
};
var YAxis = /* @__PURE__ */ function(_React$Component) {
  function YAxis2() {
    _classCallCheck$2(this, YAxis2);
    return _callSuper$1(this, YAxis2, arguments);
  }
  _inherits$1(YAxis2, _React$Component);
  return _createClass$2(YAxis2, [{
    key: "render",
    value: function render() {
      return /* @__PURE__ */ React__default.createElement(YAxisImpl, this.props);
    }
  }]);
}(React__default.Component);
_defineProperty$3(YAxis, "displayName", "YAxis");
_defineProperty$3(YAxis, "defaultProps", {
  allowDuplicatedCategory: true,
  allowDecimals: true,
  hide: false,
  orientation: "left",
  width: 60,
  height: 0,
  mirror: false,
  yAxisId: 0,
  tickCount: 5,
  type: "number",
  padding: {
    top: 0,
    bottom: 0
  },
  allowDataOverflow: false,
  scale: "auto",
  reversed: false
});
function _toConsumableArray$1(arr) {
  return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _unsupportedIterableToArray$1(arr) || _nonIterableSpread$1();
}
function _nonIterableSpread$1() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$1(o2, minLen) {
  if (!o2) return;
  if (typeof o2 === "string") return _arrayLikeToArray$1(o2, minLen);
  var n2 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n2 === "Object" && o2.constructor) n2 = o2.constructor.name;
  if (n2 === "Map" || n2 === "Set") return Array.from(o2);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray$1(o2, minLen);
}
function _iterableToArray$1(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles$1(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$1(arr);
}
function _arrayLikeToArray$1(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i3 = 0, arr2 = new Array(len); i3 < len; i3++) arr2[i3] = arr[i3];
  return arr2;
}
var detectReferenceElementsDomain = function detectReferenceElementsDomain2(children, domain, axisId, axisType, specifiedTicks) {
  var lines = findAllByType(children, ReferenceLine);
  var dots = findAllByType(children, ReferenceDot);
  var elements = [].concat(_toConsumableArray$1(lines), _toConsumableArray$1(dots));
  var areas = findAllByType(children, ReferenceArea);
  var idKey = "".concat(axisType, "Id");
  var valueKey = axisType[0];
  var finalDomain = domain;
  if (elements.length) {
    finalDomain = elements.reduce(function(result, el) {
      if (el.props[idKey] === axisId && ifOverflowMatches(el.props, "extendDomain") && isNumber(el.props[valueKey])) {
        var value = el.props[valueKey];
        return [Math.min(result[0], value), Math.max(result[1], value)];
      }
      return result;
    }, finalDomain);
  }
  if (areas.length) {
    var key1 = "".concat(valueKey, "1");
    var key2 = "".concat(valueKey, "2");
    finalDomain = areas.reduce(function(result, el) {
      if (el.props[idKey] === axisId && ifOverflowMatches(el.props, "extendDomain") && isNumber(el.props[key1]) && isNumber(el.props[key2])) {
        var value1 = el.props[key1];
        var value2 = el.props[key2];
        return [Math.min(result[0], value1, value2), Math.max(result[1], value1, value2)];
      }
      return result;
    }, finalDomain);
  }
  if (specifiedTicks && specifiedTicks.length) {
    finalDomain = specifiedTicks.reduce(function(result, tick) {
      if (isNumber(tick)) {
        return [Math.min(result[0], tick), Math.max(result[1], tick)];
      }
      return result;
    }, finalDomain);
  }
  return finalDomain;
};
var eventemitter3 = { exports: {} };
var hasRequiredEventemitter3;
function requireEventemitter3() {
  if (hasRequiredEventemitter3) return eventemitter3.exports;
  hasRequiredEventemitter3 = 1;
  (function(module) {
    var has2 = Object.prototype.hasOwnProperty, prefix2 = "~";
    function Events() {
    }
    if (Object.create) {
      Events.prototype = /* @__PURE__ */ Object.create(null);
      if (!new Events().__proto__) prefix2 = false;
    }
    function EE(fn, context, once2) {
      this.fn = fn;
      this.context = context;
      this.once = once2 || false;
    }
    function addListener(emitter, event, fn, context, once2) {
      if (typeof fn !== "function") {
        throw new TypeError("The listener must be a function");
      }
      var listener = new EE(fn, context || emitter, once2), evt = prefix2 ? prefix2 + event : event;
      if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
      else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
      else emitter._events[evt] = [emitter._events[evt], listener];
      return emitter;
    }
    function clearEvent(emitter, evt) {
      if (--emitter._eventsCount === 0) emitter._events = new Events();
      else delete emitter._events[evt];
    }
    function EventEmitter2() {
      this._events = new Events();
      this._eventsCount = 0;
    }
    EventEmitter2.prototype.eventNames = function eventNames() {
      var names2 = [], events2, name;
      if (this._eventsCount === 0) return names2;
      for (name in events2 = this._events) {
        if (has2.call(events2, name)) names2.push(prefix2 ? name.slice(1) : name);
      }
      if (Object.getOwnPropertySymbols) {
        return names2.concat(Object.getOwnPropertySymbols(events2));
      }
      return names2;
    };
    EventEmitter2.prototype.listeners = function listeners(event) {
      var evt = prefix2 ? prefix2 + event : event, handlers = this._events[evt];
      if (!handlers) return [];
      if (handlers.fn) return [handlers.fn];
      for (var i3 = 0, l2 = handlers.length, ee = new Array(l2); i3 < l2; i3++) {
        ee[i3] = handlers[i3].fn;
      }
      return ee;
    };
    EventEmitter2.prototype.listenerCount = function listenerCount(event) {
      var evt = prefix2 ? prefix2 + event : event, listeners = this._events[evt];
      if (!listeners) return 0;
      if (listeners.fn) return 1;
      return listeners.length;
    };
    EventEmitter2.prototype.emit = function emit(event, a1, a22, a32, a4, a5) {
      var evt = prefix2 ? prefix2 + event : event;
      if (!this._events[evt]) return false;
      var listeners = this._events[evt], len = arguments.length, args, i3;
      if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, void 0, true);
        switch (len) {
          case 1:
            return listeners.fn.call(listeners.context), true;
          case 2:
            return listeners.fn.call(listeners.context, a1), true;
          case 3:
            return listeners.fn.call(listeners.context, a1, a22), true;
          case 4:
            return listeners.fn.call(listeners.context, a1, a22, a32), true;
          case 5:
            return listeners.fn.call(listeners.context, a1, a22, a32, a4), true;
          case 6:
            return listeners.fn.call(listeners.context, a1, a22, a32, a4, a5), true;
        }
        for (i3 = 1, args = new Array(len - 1); i3 < len; i3++) {
          args[i3 - 1] = arguments[i3];
        }
        listeners.fn.apply(listeners.context, args);
      } else {
        var length = listeners.length, j;
        for (i3 = 0; i3 < length; i3++) {
          if (listeners[i3].once) this.removeListener(event, listeners[i3].fn, void 0, true);
          switch (len) {
            case 1:
              listeners[i3].fn.call(listeners[i3].context);
              break;
            case 2:
              listeners[i3].fn.call(listeners[i3].context, a1);
              break;
            case 3:
              listeners[i3].fn.call(listeners[i3].context, a1, a22);
              break;
            case 4:
              listeners[i3].fn.call(listeners[i3].context, a1, a22, a32);
              break;
            default:
              if (!args) for (j = 1, args = new Array(len - 1); j < len; j++) {
                args[j - 1] = arguments[j];
              }
              listeners[i3].fn.apply(listeners[i3].context, args);
          }
        }
      }
      return true;
    };
    EventEmitter2.prototype.on = function on2(event, fn, context) {
      return addListener(this, event, fn, context, false);
    };
    EventEmitter2.prototype.once = function once2(event, fn, context) {
      return addListener(this, event, fn, context, true);
    };
    EventEmitter2.prototype.removeListener = function removeListener(event, fn, context, once2) {
      var evt = prefix2 ? prefix2 + event : event;
      if (!this._events[evt]) return this;
      if (!fn) {
        clearEvent(this, evt);
        return this;
      }
      var listeners = this._events[evt];
      if (listeners.fn) {
        if (listeners.fn === fn && (!once2 || listeners.once) && (!context || listeners.context === context)) {
          clearEvent(this, evt);
        }
      } else {
        for (var i3 = 0, events2 = [], length = listeners.length; i3 < length; i3++) {
          if (listeners[i3].fn !== fn || once2 && !listeners[i3].once || context && listeners[i3].context !== context) {
            events2.push(listeners[i3]);
          }
        }
        if (events2.length) this._events[evt] = events2.length === 1 ? events2[0] : events2;
        else clearEvent(this, evt);
      }
      return this;
    };
    EventEmitter2.prototype.removeAllListeners = function removeAllListeners(event) {
      var evt;
      if (event) {
        evt = prefix2 ? prefix2 + event : event;
        if (this._events[evt]) clearEvent(this, evt);
      } else {
        this._events = new Events();
        this._eventsCount = 0;
      }
      return this;
    };
    EventEmitter2.prototype.off = EventEmitter2.prototype.removeListener;
    EventEmitter2.prototype.addListener = EventEmitter2.prototype.on;
    EventEmitter2.prefixed = prefix2;
    EventEmitter2.EventEmitter = EventEmitter2;
    {
      module.exports = EventEmitter2;
    }
  })(eventemitter3);
  return eventemitter3.exports;
}
var eventemitter3Exports = requireEventemitter3();
const EventEmitter = /* @__PURE__ */ getDefaultExportFromCjs(eventemitter3Exports);
var eventCenter = new EventEmitter();
var SYNC_EVENT = "recharts.syncMouseEvents";
function _typeof$2(o2) {
  "@babel/helpers - typeof";
  return _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof$2(o2);
}
function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1(target, props) {
  for (var i3 = 0; i3 < props.length; i3++) {
    var descriptor = props[i3];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$2(descriptor.key), descriptor);
  }
}
function _createClass$1(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _defineProperty$2(obj, key, value) {
  key = _toPropertyKey$2(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$2(t3) {
  var i3 = _toPrimitive$2(t3, "string");
  return "symbol" == _typeof$2(i3) ? i3 : i3 + "";
}
function _toPrimitive$2(t3, r2) {
  if ("object" != _typeof$2(t3) || !t3) return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i3 = e3.call(t3, r2);
    if ("object" != _typeof$2(i3)) return i3;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t3);
}
var AccessibilityManager = /* @__PURE__ */ function() {
  function AccessibilityManager2() {
    _classCallCheck$1(this, AccessibilityManager2);
    _defineProperty$2(this, "activeIndex", 0);
    _defineProperty$2(this, "coordinateList", []);
    _defineProperty$2(this, "layout", "horizontal");
  }
  return _createClass$1(AccessibilityManager2, [{
    key: "setDetails",
    value: function setDetails(_ref) {
      var _ref2;
      var _ref$coordinateList = _ref.coordinateList, coordinateList = _ref$coordinateList === void 0 ? null : _ref$coordinateList, _ref$container = _ref.container, container = _ref$container === void 0 ? null : _ref$container, _ref$layout = _ref.layout, layout = _ref$layout === void 0 ? null : _ref$layout, _ref$offset = _ref.offset, offset2 = _ref$offset === void 0 ? null : _ref$offset, _ref$mouseHandlerCall = _ref.mouseHandlerCallback, mouseHandlerCallback = _ref$mouseHandlerCall === void 0 ? null : _ref$mouseHandlerCall;
      this.coordinateList = (_ref2 = coordinateList !== null && coordinateList !== void 0 ? coordinateList : this.coordinateList) !== null && _ref2 !== void 0 ? _ref2 : [];
      this.container = container !== null && container !== void 0 ? container : this.container;
      this.layout = layout !== null && layout !== void 0 ? layout : this.layout;
      this.offset = offset2 !== null && offset2 !== void 0 ? offset2 : this.offset;
      this.mouseHandlerCallback = mouseHandlerCallback !== null && mouseHandlerCallback !== void 0 ? mouseHandlerCallback : this.mouseHandlerCallback;
      this.activeIndex = Math.min(Math.max(this.activeIndex, 0), this.coordinateList.length - 1);
    }
  }, {
    key: "focus",
    value: function focus() {
      this.spoofMouse();
    }
  }, {
    key: "keyboardEvent",
    value: function keyboardEvent(e3) {
      if (this.coordinateList.length === 0) {
        return;
      }
      switch (e3.key) {
        case "ArrowRight": {
          if (this.layout !== "horizontal") {
            return;
          }
          this.activeIndex = Math.min(this.activeIndex + 1, this.coordinateList.length - 1);
          this.spoofMouse();
          break;
        }
        case "ArrowLeft": {
          if (this.layout !== "horizontal") {
            return;
          }
          this.activeIndex = Math.max(this.activeIndex - 1, 0);
          this.spoofMouse();
          break;
        }
      }
    }
  }, {
    key: "setIndex",
    value: function setIndex(newIndex) {
      this.activeIndex = newIndex;
    }
  }, {
    key: "spoofMouse",
    value: function spoofMouse() {
      var _window, _window2;
      if (this.layout !== "horizontal") {
        return;
      }
      if (this.coordinateList.length === 0) {
        return;
      }
      var _this$container$getBo = this.container.getBoundingClientRect(), x3 = _this$container$getBo.x, y4 = _this$container$getBo.y, height = _this$container$getBo.height;
      var coordinate = this.coordinateList[this.activeIndex].coordinate;
      var scrollOffsetX = ((_window = window) === null || _window === void 0 ? void 0 : _window.scrollX) || 0;
      var scrollOffsetY = ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.scrollY) || 0;
      var pageX = x3 + coordinate + scrollOffsetX;
      var pageY = y4 + this.offset.top + height / 2 + scrollOffsetY;
      this.mouseHandlerCallback({
        pageX,
        pageY
      });
    }
  }]);
}();
function isDomainSpecifiedByUser(domain, allowDataOverflow, axisType) {
  if (axisType === "number" && allowDataOverflow === true && Array.isArray(domain)) {
    var domainStart = domain === null || domain === void 0 ? void 0 : domain[0];
    var domainEnd = domain === null || domain === void 0 ? void 0 : domain[1];
    if (!!domainStart && !!domainEnd && isNumber(domainStart) && isNumber(domainEnd)) {
      return true;
    }
  }
  return false;
}
function getCursorRectangle(layout, activeCoordinate, offset2, tooltipAxisBandSize) {
  var halfSize = tooltipAxisBandSize / 2;
  return {
    stroke: "none",
    fill: "#ccc",
    x: layout === "horizontal" ? activeCoordinate.x - halfSize : offset2.left + 0.5,
    y: layout === "horizontal" ? offset2.top + 0.5 : activeCoordinate.y - halfSize,
    width: layout === "horizontal" ? tooltipAxisBandSize : offset2.width - 1,
    height: layout === "horizontal" ? offset2.height - 1 : tooltipAxisBandSize
  };
}
function getRadialCursorPoints(activeCoordinate) {
  var cx = activeCoordinate.cx, cy = activeCoordinate.cy, radius = activeCoordinate.radius, startAngle = activeCoordinate.startAngle, endAngle = activeCoordinate.endAngle;
  var startPoint = polarToCartesian(cx, cy, radius, startAngle);
  var endPoint = polarToCartesian(cx, cy, radius, endAngle);
  return {
    points: [startPoint, endPoint],
    cx,
    cy,
    radius,
    startAngle,
    endAngle
  };
}
function getCursorPoints(layout, activeCoordinate, offset2) {
  var x1, y1, x22, y22;
  if (layout === "horizontal") {
    x1 = activeCoordinate.x;
    x22 = x1;
    y1 = offset2.top;
    y22 = offset2.top + offset2.height;
  } else if (layout === "vertical") {
    y1 = activeCoordinate.y;
    y22 = y1;
    x1 = offset2.left;
    x22 = offset2.left + offset2.width;
  } else if (activeCoordinate.cx != null && activeCoordinate.cy != null) {
    if (layout === "centric") {
      var cx = activeCoordinate.cx, cy = activeCoordinate.cy, innerRadius = activeCoordinate.innerRadius, outerRadius = activeCoordinate.outerRadius, angle = activeCoordinate.angle;
      var innerPoint = polarToCartesian(cx, cy, innerRadius, angle);
      var outerPoint = polarToCartesian(cx, cy, outerRadius, angle);
      x1 = innerPoint.x;
      y1 = innerPoint.y;
      x22 = outerPoint.x;
      y22 = outerPoint.y;
    } else {
      return getRadialCursorPoints(activeCoordinate);
    }
  }
  return [{
    x: x1,
    y: y1
  }, {
    x: x22,
    y: y22
  }];
}
function _typeof$1(o2) {
  "@babel/helpers - typeof";
  return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof$1(o2);
}
function ownKeys$1(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e3);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$1(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$1(Object(t3), true).forEach(function(r3) {
      _defineProperty$1(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$1(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
function _defineProperty$1(obj, key, value) {
  key = _toPropertyKey$1(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$1(t3) {
  var i3 = _toPrimitive$1(t3, "string");
  return "symbol" == _typeof$1(i3) ? i3 : i3 + "";
}
function _toPrimitive$1(t3, r2) {
  if ("object" != _typeof$1(t3) || !t3) return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i3 = e3.call(t3, r2);
    if ("object" != _typeof$1(i3)) return i3;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t3);
}
function Cursor(props) {
  var _element$props$cursor, _defaultProps;
  var element = props.element, tooltipEventType = props.tooltipEventType, isActive = props.isActive, activeCoordinate = props.activeCoordinate, activePayload = props.activePayload, offset2 = props.offset, activeTooltipIndex = props.activeTooltipIndex, tooltipAxisBandSize = props.tooltipAxisBandSize, layout = props.layout, chartName = props.chartName;
  var elementPropsCursor = (_element$props$cursor = element.props.cursor) !== null && _element$props$cursor !== void 0 ? _element$props$cursor : (_defaultProps = element.type.defaultProps) === null || _defaultProps === void 0 ? void 0 : _defaultProps.cursor;
  if (!element || !elementPropsCursor || !isActive || !activeCoordinate || chartName !== "ScatterChart" && tooltipEventType !== "axis") {
    return null;
  }
  var restProps;
  var cursorComp = Curve;
  if (chartName === "ScatterChart") {
    restProps = activeCoordinate;
    cursorComp = Cross;
  } else if (chartName === "BarChart") {
    restProps = getCursorRectangle(layout, activeCoordinate, offset2, tooltipAxisBandSize);
    cursorComp = Rectangle;
  } else if (layout === "radial") {
    var _getRadialCursorPoint = getRadialCursorPoints(activeCoordinate), cx = _getRadialCursorPoint.cx, cy = _getRadialCursorPoint.cy, radius = _getRadialCursorPoint.radius, startAngle = _getRadialCursorPoint.startAngle, endAngle = _getRadialCursorPoint.endAngle;
    restProps = {
      cx,
      cy,
      startAngle,
      endAngle,
      innerRadius: radius,
      outerRadius: radius
    };
    cursorComp = Sector;
  } else {
    restProps = {
      points: getCursorPoints(layout, activeCoordinate, offset2)
    };
    cursorComp = Curve;
  }
  var cursorProps = _objectSpread$1(_objectSpread$1(_objectSpread$1(_objectSpread$1({
    stroke: "#ccc",
    pointerEvents: "none"
  }, offset2), restProps), filterProps(elementPropsCursor, false)), {}, {
    payload: activePayload,
    payloadIndex: activeTooltipIndex,
    className: clsx("recharts-tooltip-cursor", elementPropsCursor.className)
  });
  return /* @__PURE__ */ isValidElement(elementPropsCursor) ? /* @__PURE__ */ cloneElement(elementPropsCursor, cursorProps) : /* @__PURE__ */ createElement(cursorComp, cursorProps);
}
var _excluded = ["item"], _excluded2 = ["children", "className", "width", "height", "style", "compact", "title", "desc"];
function _typeof(o2) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof(o2);
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i3 = 1; i3 < arguments.length; i3++) {
      var source = arguments[i3];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _slicedToArray(arr, i3) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i3) || _unsupportedIterableToArray(arr, i3) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(r2, l2) {
  var t3 = null == r2 ? null : "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];
  if (null != t3) {
    var e3, n2, i3, u3, a4 = [], f2 = true, o2 = false;
    try {
      if (i3 = (t3 = t3.call(r2)).next, 0 === l2) ;
      else for (; !(f2 = (e3 = i3.call(t3)).done) && (a4.push(e3.value), a4.length !== l2); f2 = true) ;
    } catch (r3) {
      o2 = true, n2 = r3;
    } finally {
      try {
        if (!f2 && null != t3["return"] && (u3 = t3["return"](), Object(u3) !== u3)) return;
      } finally {
        if (o2) throw n2;
      }
    }
    return a4;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i3;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i3 = 0; i3 < sourceSymbolKeys.length; i3++) {
      key = sourceSymbolKeys[i3];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  for (var key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i3 = 0; i3 < props.length; i3++) {
    var descriptor = props[i3];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _callSuper(t3, o2, e3) {
  return o2 = _getPrototypeOf(o2), _possibleConstructorReturn(t3, _isNativeReflectConstruct() ? Reflect.construct(o2, e3 || [], _getPrototypeOf(t3).constructor) : o2.apply(t3, e3));
}
function _possibleConstructorReturn(self2, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self2);
}
function _assertThisInitialized(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct() {
  try {
    var t3 = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct2() {
    return !!t3;
  })();
}
function _getPrototypeOf(o2) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o3) {
    return o3.__proto__ || Object.getPrototypeOf(o3);
  };
  return _getPrototypeOf(o2);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o2, p2) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o3, p3) {
    o3.__proto__ = p3;
    return o3;
  };
  return _setPrototypeOf(o2, p2);
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o2, minLen) {
  if (!o2) return;
  if (typeof o2 === "string") return _arrayLikeToArray(o2, minLen);
  var n2 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n2 === "Object" && o2.constructor) n2 = o2.constructor.name;
  if (n2 === "Map" || n2 === "Set") return Array.from(o2);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray(o2, minLen);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i3 = 0, arr2 = new Array(len); i3 < len; i3++) arr2[i3] = arr[i3];
  return arr2;
}
function ownKeys(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e3);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys(Object(t3), true).forEach(function(r3) {
      _defineProperty(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t3) {
  var i3 = _toPrimitive(t3, "string");
  return "symbol" == _typeof(i3) ? i3 : i3 + "";
}
function _toPrimitive(t3, r2) {
  if ("object" != _typeof(t3) || !t3) return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i3 = e3.call(t3, r2);
    if ("object" != _typeof(i3)) return i3;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t3);
}
var ORIENT_MAP = {
  xAxis: ["bottom", "top"],
  yAxis: ["left", "right"]
};
var FULL_WIDTH_AND_HEIGHT = {
  width: "100%",
  height: "100%"
};
var originCoordinate = {
  x: 0,
  y: 0
};
function renderAsIs(element) {
  return element;
}
var calculateTooltipPos = function calculateTooltipPos2(rangeObj, layout) {
  if (layout === "horizontal") {
    return rangeObj.x;
  }
  if (layout === "vertical") {
    return rangeObj.y;
  }
  if (layout === "centric") {
    return rangeObj.angle;
  }
  return rangeObj.radius;
};
var getActiveCoordinate = function getActiveCoordinate2(layout, tooltipTicks, activeIndex, rangeObj) {
  var entry = tooltipTicks.find(function(tick) {
    return tick && tick.index === activeIndex;
  });
  if (entry) {
    if (layout === "horizontal") {
      return {
        x: entry.coordinate,
        y: rangeObj.y
      };
    }
    if (layout === "vertical") {
      return {
        x: rangeObj.x,
        y: entry.coordinate
      };
    }
    if (layout === "centric") {
      var _angle = entry.coordinate;
      var _radius = rangeObj.radius;
      return _objectSpread(_objectSpread(_objectSpread({}, rangeObj), polarToCartesian(rangeObj.cx, rangeObj.cy, _radius, _angle)), {}, {
        angle: _angle,
        radius: _radius
      });
    }
    var radius = entry.coordinate;
    var angle = rangeObj.angle;
    return _objectSpread(_objectSpread(_objectSpread({}, rangeObj), polarToCartesian(rangeObj.cx, rangeObj.cy, radius, angle)), {}, {
      angle,
      radius
    });
  }
  return originCoordinate;
};
var getDisplayedData = function getDisplayedData2(data, _ref) {
  var graphicalItems = _ref.graphicalItems, dataStartIndex = _ref.dataStartIndex, dataEndIndex = _ref.dataEndIndex;
  var itemsData = (graphicalItems !== null && graphicalItems !== void 0 ? graphicalItems : []).reduce(function(result, child) {
    var itemData = child.props.data;
    if (itemData && itemData.length) {
      return [].concat(_toConsumableArray(result), _toConsumableArray(itemData));
    }
    return result;
  }, []);
  if (itemsData.length > 0) {
    return itemsData;
  }
  if (data && data.length && isNumber(dataStartIndex) && isNumber(dataEndIndex)) {
    return data.slice(dataStartIndex, dataEndIndex + 1);
  }
  return [];
};
function getDefaultDomainByAxisType(axisType) {
  return axisType === "number" ? [0, "auto"] : void 0;
}
var getTooltipContent = function getTooltipContent2(state, chartData, activeIndex, activeLabel) {
  var graphicalItems = state.graphicalItems, tooltipAxis = state.tooltipAxis;
  var displayedData = getDisplayedData(chartData, state);
  if (activeIndex < 0 || !graphicalItems || !graphicalItems.length || activeIndex >= displayedData.length) {
    return null;
  }
  return graphicalItems.reduce(function(result, child) {
    var _child$props$data;
    var data = (_child$props$data = child.props.data) !== null && _child$props$data !== void 0 ? _child$props$data : chartData;
    if (data && state.dataStartIndex + state.dataEndIndex !== 0 && // https://github.com/recharts/recharts/issues/4717
    // The data is sliced only when the active index is within the start/end index range.
    state.dataEndIndex - state.dataStartIndex >= activeIndex) {
      data = data.slice(state.dataStartIndex, state.dataEndIndex + 1);
    }
    var payload;
    if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
      var entries = data === void 0 ? displayedData : data;
      payload = findEntryInArray(entries, tooltipAxis.dataKey, activeLabel);
    } else {
      payload = data && data[activeIndex] || displayedData[activeIndex];
    }
    if (!payload) {
      return result;
    }
    return [].concat(_toConsumableArray(result), [getTooltipItem(child, payload)]);
  }, []);
};
var getTooltipData = function getTooltipData2(state, chartData, layout, rangeObj) {
  var rangeData = rangeObj || {
    x: state.chartX,
    y: state.chartY
  };
  var pos = calculateTooltipPos(rangeData, layout);
  var ticks2 = state.orderedTooltipTicks, axis = state.tooltipAxis, tooltipTicks = state.tooltipTicks;
  var activeIndex = calculateActiveTickIndex(pos, ticks2, tooltipTicks, axis);
  if (activeIndex >= 0 && tooltipTicks) {
    var activeLabel = tooltipTicks[activeIndex] && tooltipTicks[activeIndex].value;
    var activePayload = getTooltipContent(state, chartData, activeIndex, activeLabel);
    var activeCoordinate = getActiveCoordinate(layout, ticks2, activeIndex, rangeData);
    return {
      activeTooltipIndex: activeIndex,
      activeLabel,
      activePayload,
      activeCoordinate
    };
  }
  return null;
};
var getAxisMapByAxes = function getAxisMapByAxes2(props, _ref2) {
  var axes = _ref2.axes, graphicalItems = _ref2.graphicalItems, axisType = _ref2.axisType, axisIdKey = _ref2.axisIdKey, stackGroups = _ref2.stackGroups, dataStartIndex = _ref2.dataStartIndex, dataEndIndex = _ref2.dataEndIndex;
  var layout = props.layout, children = props.children, stackOffset = props.stackOffset;
  var isCategorical = isCategoricalAxis(layout, axisType);
  return axes.reduce(function(result, child) {
    var _childProps$domain2;
    var childProps = child.type.defaultProps !== void 0 ? _objectSpread(_objectSpread({}, child.type.defaultProps), child.props) : child.props;
    var type = childProps.type, dataKey = childProps.dataKey, allowDataOverflow = childProps.allowDataOverflow, allowDuplicatedCategory = childProps.allowDuplicatedCategory, scale2 = childProps.scale, ticks2 = childProps.ticks, includeHidden = childProps.includeHidden;
    var axisId = childProps[axisIdKey];
    if (result[axisId]) {
      return result;
    }
    var displayedData = getDisplayedData(props.data, {
      graphicalItems: graphicalItems.filter(function(item) {
        var _defaultProps;
        var itemAxisId = axisIdKey in item.props ? item.props[axisIdKey] : (_defaultProps = item.type.defaultProps) === null || _defaultProps === void 0 ? void 0 : _defaultProps[axisIdKey];
        return itemAxisId === axisId;
      }),
      dataStartIndex,
      dataEndIndex
    });
    var len = displayedData.length;
    var domain, duplicateDomain, categoricalDomain;
    if (isDomainSpecifiedByUser(childProps.domain, allowDataOverflow, type)) {
      domain = parseSpecifiedDomain(childProps.domain, null, allowDataOverflow);
      if (isCategorical && (type === "number" || scale2 !== "auto")) {
        categoricalDomain = getDomainOfDataByKey(displayedData, dataKey, "category");
      }
    }
    var defaultDomain = getDefaultDomainByAxisType(type);
    if (!domain || domain.length === 0) {
      var _childProps$domain;
      var childDomain = (_childProps$domain = childProps.domain) !== null && _childProps$domain !== void 0 ? _childProps$domain : defaultDomain;
      if (dataKey) {
        domain = getDomainOfDataByKey(displayedData, dataKey, type);
        if (type === "category" && isCategorical) {
          var duplicate = hasDuplicate(domain);
          if (allowDuplicatedCategory && duplicate) {
            duplicateDomain = domain;
            domain = range2(0, len);
          } else if (!allowDuplicatedCategory) {
            domain = parseDomainOfCategoryAxis(childDomain, domain, child).reduce(function(finalDomain, entry) {
              return finalDomain.indexOf(entry) >= 0 ? finalDomain : [].concat(_toConsumableArray(finalDomain), [entry]);
            }, []);
          }
        } else if (type === "category") {
          if (!allowDuplicatedCategory) {
            domain = parseDomainOfCategoryAxis(childDomain, domain, child).reduce(function(finalDomain, entry) {
              return finalDomain.indexOf(entry) >= 0 || entry === "" || isNil(entry) ? finalDomain : [].concat(_toConsumableArray(finalDomain), [entry]);
            }, []);
          } else {
            domain = domain.filter(function(entry) {
              return entry !== "" && !isNil(entry);
            });
          }
        } else if (type === "number") {
          var errorBarsDomain = parseErrorBarsOfAxis(displayedData, graphicalItems.filter(function(item) {
            var _defaultProps2, _defaultProps3;
            var itemAxisId = axisIdKey in item.props ? item.props[axisIdKey] : (_defaultProps2 = item.type.defaultProps) === null || _defaultProps2 === void 0 ? void 0 : _defaultProps2[axisIdKey];
            var itemHide = "hide" in item.props ? item.props.hide : (_defaultProps3 = item.type.defaultProps) === null || _defaultProps3 === void 0 ? void 0 : _defaultProps3.hide;
            return itemAxisId === axisId && (includeHidden || !itemHide);
          }), dataKey, axisType, layout);
          if (errorBarsDomain) {
            domain = errorBarsDomain;
          }
        }
        if (isCategorical && (type === "number" || scale2 !== "auto")) {
          categoricalDomain = getDomainOfDataByKey(displayedData, dataKey, "category");
        }
      } else if (isCategorical) {
        domain = range2(0, len);
      } else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack && type === "number") {
        domain = stackOffset === "expand" ? [0, 1] : getDomainOfStackGroups(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
      } else {
        domain = getDomainOfItemsWithSameAxis(displayedData, graphicalItems.filter(function(item) {
          var itemAxisId = axisIdKey in item.props ? item.props[axisIdKey] : item.type.defaultProps[axisIdKey];
          var itemHide = "hide" in item.props ? item.props.hide : item.type.defaultProps.hide;
          return itemAxisId === axisId && (includeHidden || !itemHide);
        }), type, layout, true);
      }
      if (type === "number") {
        domain = detectReferenceElementsDomain(children, domain, axisId, axisType, ticks2);
        if (childDomain) {
          domain = parseSpecifiedDomain(childDomain, domain, allowDataOverflow);
        }
      } else if (type === "category" && childDomain) {
        var axisDomain = childDomain;
        var isDomainValid = domain.every(function(entry) {
          return axisDomain.indexOf(entry) >= 0;
        });
        if (isDomainValid) {
          domain = axisDomain;
        }
      }
    }
    return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, axisId, _objectSpread(_objectSpread({}, childProps), {}, {
      axisType,
      domain,
      categoricalDomain,
      duplicateDomain,
      originalDomain: (_childProps$domain2 = childProps.domain) !== null && _childProps$domain2 !== void 0 ? _childProps$domain2 : defaultDomain,
      isCategorical,
      layout
    })));
  }, {});
};
var getAxisMapByItems = function getAxisMapByItems2(props, _ref3) {
  var graphicalItems = _ref3.graphicalItems, Axis = _ref3.Axis, axisType = _ref3.axisType, axisIdKey = _ref3.axisIdKey, stackGroups = _ref3.stackGroups, dataStartIndex = _ref3.dataStartIndex, dataEndIndex = _ref3.dataEndIndex;
  var layout = props.layout, children = props.children;
  var displayedData = getDisplayedData(props.data, {
    graphicalItems,
    dataStartIndex,
    dataEndIndex
  });
  var len = displayedData.length;
  var isCategorical = isCategoricalAxis(layout, axisType);
  var index2 = -1;
  return graphicalItems.reduce(function(result, child) {
    var childProps = child.type.defaultProps !== void 0 ? _objectSpread(_objectSpread({}, child.type.defaultProps), child.props) : child.props;
    var axisId = childProps[axisIdKey];
    var originalDomain = getDefaultDomainByAxisType("number");
    if (!result[axisId]) {
      index2++;
      var domain;
      if (isCategorical) {
        domain = range2(0, len);
      } else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack) {
        domain = getDomainOfStackGroups(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
        domain = detectReferenceElementsDomain(children, domain, axisId, axisType);
      } else {
        domain = parseSpecifiedDomain(originalDomain, getDomainOfItemsWithSameAxis(displayedData, graphicalItems.filter(function(item) {
          var _defaultProps4, _defaultProps5;
          var itemAxisId = axisIdKey in item.props ? item.props[axisIdKey] : (_defaultProps4 = item.type.defaultProps) === null || _defaultProps4 === void 0 ? void 0 : _defaultProps4[axisIdKey];
          var itemHide = "hide" in item.props ? item.props.hide : (_defaultProps5 = item.type.defaultProps) === null || _defaultProps5 === void 0 ? void 0 : _defaultProps5.hide;
          return itemAxisId === axisId && !itemHide;
        }), "number", layout), Axis.defaultProps.allowDataOverflow);
        domain = detectReferenceElementsDomain(children, domain, axisId, axisType);
      }
      return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, axisId, _objectSpread(_objectSpread({
        axisType
      }, Axis.defaultProps), {}, {
        hide: true,
        orientation: get(ORIENT_MAP, "".concat(axisType, ".").concat(index2 % 2), null),
        domain,
        originalDomain,
        isCategorical,
        layout
        // specify scale when no Axis
        // scale: isCategorical ? 'band' : 'linear',
      })));
    }
    return result;
  }, {});
};
var getAxisMap = function getAxisMap2(props, _ref4) {
  var _ref4$axisType = _ref4.axisType, axisType = _ref4$axisType === void 0 ? "xAxis" : _ref4$axisType, AxisComp = _ref4.AxisComp, graphicalItems = _ref4.graphicalItems, stackGroups = _ref4.stackGroups, dataStartIndex = _ref4.dataStartIndex, dataEndIndex = _ref4.dataEndIndex;
  var children = props.children;
  var axisIdKey = "".concat(axisType, "Id");
  var axes = findAllByType(children, AxisComp);
  var axisMap = {};
  if (axes && axes.length) {
    axisMap = getAxisMapByAxes(props, {
      axes,
      graphicalItems,
      axisType,
      axisIdKey,
      stackGroups,
      dataStartIndex,
      dataEndIndex
    });
  } else if (graphicalItems && graphicalItems.length) {
    axisMap = getAxisMapByItems(props, {
      Axis: AxisComp,
      graphicalItems,
      axisType,
      axisIdKey,
      stackGroups,
      dataStartIndex,
      dataEndIndex
    });
  }
  return axisMap;
};
var tooltipTicksGenerator = function tooltipTicksGenerator2(axisMap) {
  var axis = getAnyElementOfObject(axisMap);
  var tooltipTicks = getTicksOfAxis(axis, false, true);
  return {
    tooltipTicks,
    orderedTooltipTicks: sortBy(tooltipTicks, function(o2) {
      return o2.coordinate;
    }),
    tooltipAxis: axis,
    tooltipAxisBandSize: getBandSizeOfAxis(axis, tooltipTicks)
  };
};
var createDefaultState = function createDefaultState2(props) {
  var children = props.children, defaultShowTooltip = props.defaultShowTooltip;
  var brushItem = findChildByType(children, Brush);
  var startIndex = 0;
  var endIndex = 0;
  if (props.data && props.data.length !== 0) {
    endIndex = props.data.length - 1;
  }
  if (brushItem && brushItem.props) {
    if (brushItem.props.startIndex >= 0) {
      startIndex = brushItem.props.startIndex;
    }
    if (brushItem.props.endIndex >= 0) {
      endIndex = brushItem.props.endIndex;
    }
  }
  return {
    chartX: 0,
    chartY: 0,
    dataStartIndex: startIndex,
    dataEndIndex: endIndex,
    activeTooltipIndex: -1,
    isTooltipActive: Boolean(defaultShowTooltip)
  };
};
var hasGraphicalBarItem = function hasGraphicalBarItem2(graphicalItems) {
  if (!graphicalItems || !graphicalItems.length) {
    return false;
  }
  return graphicalItems.some(function(item) {
    var name = getDisplayName(item && item.type);
    return name && name.indexOf("Bar") >= 0;
  });
};
var getAxisNameByLayout = function getAxisNameByLayout2(layout) {
  if (layout === "horizontal") {
    return {
      numericAxisName: "yAxis",
      cateAxisName: "xAxis"
    };
  }
  if (layout === "vertical") {
    return {
      numericAxisName: "xAxis",
      cateAxisName: "yAxis"
    };
  }
  if (layout === "centric") {
    return {
      numericAxisName: "radiusAxis",
      cateAxisName: "angleAxis"
    };
  }
  return {
    numericAxisName: "angleAxis",
    cateAxisName: "radiusAxis"
  };
};
var calculateOffset = function calculateOffset2(_ref5, prevLegendBBox) {
  var props = _ref5.props, graphicalItems = _ref5.graphicalItems, _ref5$xAxisMap = _ref5.xAxisMap, xAxisMap = _ref5$xAxisMap === void 0 ? {} : _ref5$xAxisMap, _ref5$yAxisMap = _ref5.yAxisMap, yAxisMap = _ref5$yAxisMap === void 0 ? {} : _ref5$yAxisMap;
  var width = props.width, height = props.height, children = props.children;
  var margin = props.margin || {};
  var brushItem = findChildByType(children, Brush);
  var legendItem = findChildByType(children, Legend$2);
  var offsetH = Object.keys(yAxisMap).reduce(function(result, id2) {
    var entry = yAxisMap[id2];
    var orientation = entry.orientation;
    if (!entry.mirror && !entry.hide) {
      return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, orientation, result[orientation] + entry.width));
    }
    return result;
  }, {
    left: margin.left || 0,
    right: margin.right || 0
  });
  var offsetV = Object.keys(xAxisMap).reduce(function(result, id2) {
    var entry = xAxisMap[id2];
    var orientation = entry.orientation;
    if (!entry.mirror && !entry.hide) {
      return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, orientation, get(result, "".concat(orientation)) + entry.height));
    }
    return result;
  }, {
    top: margin.top || 0,
    bottom: margin.bottom || 0
  });
  var offset2 = _objectSpread(_objectSpread({}, offsetV), offsetH);
  var brushBottom = offset2.bottom;
  if (brushItem) {
    offset2.bottom += brushItem.props.height || Brush.defaultProps.height;
  }
  if (legendItem && prevLegendBBox) {
    offset2 = appendOffsetOfLegend(offset2, graphicalItems, props, prevLegendBBox);
  }
  var offsetWidth = width - offset2.left - offset2.right;
  var offsetHeight = height - offset2.top - offset2.bottom;
  return _objectSpread(_objectSpread({
    brushBottom
  }, offset2), {}, {
    // never return negative values for height and width
    width: Math.max(offsetWidth, 0),
    height: Math.max(offsetHeight, 0)
  });
};
var getCartesianAxisSize = function getCartesianAxisSize2(axisObj, axisName) {
  if (axisName === "xAxis") {
    return axisObj[axisName].width;
  }
  if (axisName === "yAxis") {
    return axisObj[axisName].height;
  }
  return void 0;
};
var generateCategoricalChart = function generateCategoricalChart2(_ref6) {
  var chartName = _ref6.chartName, GraphicalChild = _ref6.GraphicalChild, _ref6$defaultTooltipE = _ref6.defaultTooltipEventType, defaultTooltipEventType = _ref6$defaultTooltipE === void 0 ? "axis" : _ref6$defaultTooltipE, _ref6$validateTooltip = _ref6.validateTooltipEventTypes, validateTooltipEventTypes = _ref6$validateTooltip === void 0 ? ["axis"] : _ref6$validateTooltip, axisComponents = _ref6.axisComponents, legendContent = _ref6.legendContent, formatAxisMap4 = _ref6.formatAxisMap, defaultProps2 = _ref6.defaultProps;
  var getFormatItems = function getFormatItems2(props, currentState) {
    var graphicalItems = currentState.graphicalItems, stackGroups = currentState.stackGroups, offset2 = currentState.offset, updateId = currentState.updateId, dataStartIndex = currentState.dataStartIndex, dataEndIndex = currentState.dataEndIndex;
    var barSize = props.barSize, layout = props.layout, barGap = props.barGap, barCategoryGap = props.barCategoryGap, globalMaxBarSize = props.maxBarSize;
    var _getAxisNameByLayout = getAxisNameByLayout(layout), numericAxisName = _getAxisNameByLayout.numericAxisName, cateAxisName = _getAxisNameByLayout.cateAxisName;
    var hasBar = hasGraphicalBarItem(graphicalItems);
    var formattedItems = [];
    graphicalItems.forEach(function(item, index2) {
      var displayedData = getDisplayedData(props.data, {
        graphicalItems: [item],
        dataStartIndex,
        dataEndIndex
      });
      var itemProps = item.type.defaultProps !== void 0 ? _objectSpread(_objectSpread({}, item.type.defaultProps), item.props) : item.props;
      var dataKey = itemProps.dataKey, childMaxBarSize = itemProps.maxBarSize;
      var numericAxisId = itemProps["".concat(numericAxisName, "Id")];
      var cateAxisId = itemProps["".concat(cateAxisName, "Id")];
      var axisObjInitialValue = {};
      var axisObj = axisComponents.reduce(function(result, entry) {
        var _item$type$displayNam, _item$type;
        var axisMap = currentState["".concat(entry.axisType, "Map")];
        var id2 = itemProps["".concat(entry.axisType, "Id")];
        !(axisMap && axisMap[id2] || entry.axisType === "zAxis") ? process.env.NODE_ENV !== "production" ? invariant(false, "Specifying a(n) ".concat(entry.axisType, "Id requires a corresponding ").concat(
          entry.axisType,
          "Id on the targeted graphical component "
        ).concat((_item$type$displayNam = item === null || item === void 0 || (_item$type = item.type) === null || _item$type === void 0 ? void 0 : _item$type.displayName) !== null && _item$type$displayNam !== void 0 ? _item$type$displayNam : "")) : invariant() : void 0;
        var axis = axisMap[id2];
        return _objectSpread(_objectSpread({}, result), {}, _defineProperty(_defineProperty({}, entry.axisType, axis), "".concat(entry.axisType, "Ticks"), getTicksOfAxis(axis)));
      }, axisObjInitialValue);
      var cateAxis = axisObj[cateAxisName];
      var cateTicks = axisObj["".concat(cateAxisName, "Ticks")];
      var stackedData = stackGroups && stackGroups[numericAxisId] && stackGroups[numericAxisId].hasStack && getStackedDataOfItem(item, stackGroups[numericAxisId].stackGroups);
      var itemIsBar = getDisplayName(item.type).indexOf("Bar") >= 0;
      var bandSize = getBandSizeOfAxis(cateAxis, cateTicks);
      var barPosition = [];
      var sizeList = hasBar && getBarSizeList({
        barSize,
        stackGroups,
        totalSize: getCartesianAxisSize(axisObj, cateAxisName)
      });
      if (itemIsBar) {
        var _ref7, _getBandSizeOfAxis;
        var maxBarSize = isNil(childMaxBarSize) ? globalMaxBarSize : childMaxBarSize;
        var barBandSize = (_ref7 = (_getBandSizeOfAxis = getBandSizeOfAxis(cateAxis, cateTicks, true)) !== null && _getBandSizeOfAxis !== void 0 ? _getBandSizeOfAxis : maxBarSize) !== null && _ref7 !== void 0 ? _ref7 : 0;
        barPosition = getBarPosition({
          barGap,
          barCategoryGap,
          bandSize: barBandSize !== bandSize ? barBandSize : bandSize,
          sizeList: sizeList[cateAxisId],
          maxBarSize
        });
        if (barBandSize !== bandSize) {
          barPosition = barPosition.map(function(pos) {
            return _objectSpread(_objectSpread({}, pos), {}, {
              position: _objectSpread(_objectSpread({}, pos.position), {}, {
                offset: pos.position.offset - barBandSize / 2
              })
            });
          });
        }
      }
      var composedFn = item && item.type && item.type.getComposedData;
      if (composedFn) {
        formattedItems.push({
          props: _objectSpread(_objectSpread({}, composedFn(_objectSpread(_objectSpread({}, axisObj), {}, {
            displayedData,
            props,
            dataKey,
            item,
            bandSize,
            barPosition,
            offset: offset2,
            stackedData,
            layout,
            dataStartIndex,
            dataEndIndex
          }))), {}, _defineProperty(_defineProperty(_defineProperty({
            key: item.key || "item-".concat(index2)
          }, numericAxisName, axisObj[numericAxisName]), cateAxisName, axisObj[cateAxisName]), "animationId", updateId)),
          childIndex: parseChildIndex(item, props.children),
          item
        });
      }
    });
    return formattedItems;
  };
  var updateStateOfAxisMapsOffsetAndStackGroups = function updateStateOfAxisMapsOffsetAndStackGroups2(_ref8, prevState) {
    var props = _ref8.props, dataStartIndex = _ref8.dataStartIndex, dataEndIndex = _ref8.dataEndIndex, updateId = _ref8.updateId;
    if (!validateWidthHeight({
      props
    })) {
      return null;
    }
    var children = props.children, layout = props.layout, stackOffset = props.stackOffset, data = props.data, reverseStackOrder = props.reverseStackOrder;
    var _getAxisNameByLayout2 = getAxisNameByLayout(layout), numericAxisName = _getAxisNameByLayout2.numericAxisName, cateAxisName = _getAxisNameByLayout2.cateAxisName;
    var graphicalItems = findAllByType(children, GraphicalChild);
    var stackGroups = getStackGroupsByAxisId(data, graphicalItems, "".concat(numericAxisName, "Id"), "".concat(cateAxisName, "Id"), stackOffset, reverseStackOrder);
    var axisObj = axisComponents.reduce(function(result, entry) {
      var name = "".concat(entry.axisType, "Map");
      return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, name, getAxisMap(props, _objectSpread(_objectSpread({}, entry), {}, {
        graphicalItems,
        stackGroups: entry.axisType === numericAxisName && stackGroups,
        dataStartIndex,
        dataEndIndex
      }))));
    }, {});
    var offset2 = calculateOffset(_objectSpread(_objectSpread({}, axisObj), {}, {
      props,
      graphicalItems
    }), prevState === null || prevState === void 0 ? void 0 : prevState.legendBBox);
    Object.keys(axisObj).forEach(function(key) {
      axisObj[key] = formatAxisMap4(props, axisObj[key], offset2, key.replace("Map", ""), chartName);
    });
    var cateAxisMap = axisObj["".concat(cateAxisName, "Map")];
    var ticksObj = tooltipTicksGenerator(cateAxisMap);
    var formattedGraphicalItems = getFormatItems(props, _objectSpread(_objectSpread({}, axisObj), {}, {
      dataStartIndex,
      dataEndIndex,
      updateId,
      graphicalItems,
      stackGroups,
      offset: offset2
    }));
    return _objectSpread(_objectSpread({
      formattedGraphicalItems,
      graphicalItems,
      offset: offset2,
      stackGroups
    }, ticksObj), axisObj);
  };
  var CategoricalChartWrapper = /* @__PURE__ */ function(_Component) {
    function CategoricalChartWrapper2(_props) {
      var _props$id, _props$throttleDelay;
      var _this;
      _classCallCheck(this, CategoricalChartWrapper2);
      _this = _callSuper(this, CategoricalChartWrapper2, [_props]);
      _defineProperty(_this, "eventEmitterSymbol", Symbol("rechartsEventEmitter"));
      _defineProperty(_this, "accessibilityManager", new AccessibilityManager());
      _defineProperty(_this, "handleLegendBBoxUpdate", function(box) {
        if (box) {
          var _this$state = _this.state, dataStartIndex = _this$state.dataStartIndex, dataEndIndex = _this$state.dataEndIndex, updateId = _this$state.updateId;
          _this.setState(_objectSpread({
            legendBBox: box
          }, updateStateOfAxisMapsOffsetAndStackGroups({
            props: _this.props,
            dataStartIndex,
            dataEndIndex,
            updateId
          }, _objectSpread(_objectSpread({}, _this.state), {}, {
            legendBBox: box
          }))));
        }
      });
      _defineProperty(_this, "handleReceiveSyncEvent", function(cId, data, emitter) {
        if (_this.props.syncId === cId) {
          if (emitter === _this.eventEmitterSymbol && typeof _this.props.syncMethod !== "function") {
            return;
          }
          _this.applySyncEvent(data);
        }
      });
      _defineProperty(_this, "handleBrushChange", function(_ref9) {
        var startIndex = _ref9.startIndex, endIndex = _ref9.endIndex;
        if (startIndex !== _this.state.dataStartIndex || endIndex !== _this.state.dataEndIndex) {
          var updateId = _this.state.updateId;
          _this.setState(function() {
            return _objectSpread({
              dataStartIndex: startIndex,
              dataEndIndex: endIndex
            }, updateStateOfAxisMapsOffsetAndStackGroups({
              props: _this.props,
              dataStartIndex: startIndex,
              dataEndIndex: endIndex,
              updateId
            }, _this.state));
          });
          _this.triggerSyncEvent({
            dataStartIndex: startIndex,
            dataEndIndex: endIndex
          });
        }
      });
      _defineProperty(_this, "handleMouseEnter", function(e3) {
        var mouse = _this.getMouseInfo(e3);
        if (mouse) {
          var _nextState = _objectSpread(_objectSpread({}, mouse), {}, {
            isTooltipActive: true
          });
          _this.setState(_nextState);
          _this.triggerSyncEvent(_nextState);
          var onMouseEnter = _this.props.onMouseEnter;
          if (isFunction(onMouseEnter)) {
            onMouseEnter(_nextState, e3);
          }
        }
      });
      _defineProperty(_this, "triggeredAfterMouseMove", function(e3) {
        var mouse = _this.getMouseInfo(e3);
        var nextState = mouse ? _objectSpread(_objectSpread({}, mouse), {}, {
          isTooltipActive: true
        }) : {
          isTooltipActive: false
        };
        _this.setState(nextState);
        _this.triggerSyncEvent(nextState);
        var onMouseMove = _this.props.onMouseMove;
        if (isFunction(onMouseMove)) {
          onMouseMove(nextState, e3);
        }
      });
      _defineProperty(_this, "handleItemMouseEnter", function(el) {
        _this.setState(function() {
          return {
            isTooltipActive: true,
            activeItem: el,
            activePayload: el.tooltipPayload,
            activeCoordinate: el.tooltipPosition || {
              x: el.cx,
              y: el.cy
            }
          };
        });
      });
      _defineProperty(_this, "handleItemMouseLeave", function() {
        _this.setState(function() {
          return {
            isTooltipActive: false
          };
        });
      });
      _defineProperty(_this, "handleMouseMove", function(e3) {
        e3.persist();
        _this.throttleTriggeredAfterMouseMove(e3);
      });
      _defineProperty(_this, "handleMouseLeave", function(e3) {
        _this.throttleTriggeredAfterMouseMove.cancel();
        var nextState = {
          isTooltipActive: false
        };
        _this.setState(nextState);
        _this.triggerSyncEvent(nextState);
        var onMouseLeave = _this.props.onMouseLeave;
        if (isFunction(onMouseLeave)) {
          onMouseLeave(nextState, e3);
        }
      });
      _defineProperty(_this, "handleOuterEvent", function(e3) {
        var eventName = getReactEventByType(e3);
        var event = get(_this.props, "".concat(eventName));
        if (eventName && isFunction(event)) {
          var _mouse;
          var mouse;
          if (/.*touch.*/i.test(eventName)) {
            mouse = _this.getMouseInfo(e3.changedTouches[0]);
          } else {
            mouse = _this.getMouseInfo(e3);
          }
          event((_mouse = mouse) !== null && _mouse !== void 0 ? _mouse : {}, e3);
        }
      });
      _defineProperty(_this, "handleClick", function(e3) {
        var mouse = _this.getMouseInfo(e3);
        if (mouse) {
          var _nextState2 = _objectSpread(_objectSpread({}, mouse), {}, {
            isTooltipActive: true
          });
          _this.setState(_nextState2);
          _this.triggerSyncEvent(_nextState2);
          var onClick = _this.props.onClick;
          if (isFunction(onClick)) {
            onClick(_nextState2, e3);
          }
        }
      });
      _defineProperty(_this, "handleMouseDown", function(e3) {
        var onMouseDown = _this.props.onMouseDown;
        if (isFunction(onMouseDown)) {
          var _nextState3 = _this.getMouseInfo(e3);
          onMouseDown(_nextState3, e3);
        }
      });
      _defineProperty(_this, "handleMouseUp", function(e3) {
        var onMouseUp = _this.props.onMouseUp;
        if (isFunction(onMouseUp)) {
          var _nextState4 = _this.getMouseInfo(e3);
          onMouseUp(_nextState4, e3);
        }
      });
      _defineProperty(_this, "handleTouchMove", function(e3) {
        if (e3.changedTouches != null && e3.changedTouches.length > 0) {
          _this.throttleTriggeredAfterMouseMove(e3.changedTouches[0]);
        }
      });
      _defineProperty(_this, "handleTouchStart", function(e3) {
        if (e3.changedTouches != null && e3.changedTouches.length > 0) {
          _this.handleMouseDown(e3.changedTouches[0]);
        }
      });
      _defineProperty(_this, "handleTouchEnd", function(e3) {
        if (e3.changedTouches != null && e3.changedTouches.length > 0) {
          _this.handleMouseUp(e3.changedTouches[0]);
        }
      });
      _defineProperty(_this, "handleDoubleClick", function(e3) {
        var onDoubleClick = _this.props.onDoubleClick;
        if (isFunction(onDoubleClick)) {
          var _nextState5 = _this.getMouseInfo(e3);
          onDoubleClick(_nextState5, e3);
        }
      });
      _defineProperty(_this, "handleContextMenu", function(e3) {
        var onContextMenu = _this.props.onContextMenu;
        if (isFunction(onContextMenu)) {
          var _nextState6 = _this.getMouseInfo(e3);
          onContextMenu(_nextState6, e3);
        }
      });
      _defineProperty(_this, "triggerSyncEvent", function(data) {
        if (_this.props.syncId !== void 0) {
          eventCenter.emit(SYNC_EVENT, _this.props.syncId, data, _this.eventEmitterSymbol);
        }
      });
      _defineProperty(_this, "applySyncEvent", function(data) {
        var _this$props = _this.props, layout = _this$props.layout, syncMethod = _this$props.syncMethod;
        var updateId = _this.state.updateId;
        var dataStartIndex = data.dataStartIndex, dataEndIndex = data.dataEndIndex;
        if (data.dataStartIndex !== void 0 || data.dataEndIndex !== void 0) {
          _this.setState(_objectSpread({
            dataStartIndex,
            dataEndIndex
          }, updateStateOfAxisMapsOffsetAndStackGroups({
            props: _this.props,
            dataStartIndex,
            dataEndIndex,
            updateId
          }, _this.state)));
        } else if (data.activeTooltipIndex !== void 0) {
          var chartX = data.chartX, chartY = data.chartY;
          var activeTooltipIndex = data.activeTooltipIndex;
          var _this$state2 = _this.state, offset2 = _this$state2.offset, tooltipTicks = _this$state2.tooltipTicks;
          if (!offset2) {
            return;
          }
          if (typeof syncMethod === "function") {
            activeTooltipIndex = syncMethod(tooltipTicks, data);
          } else if (syncMethod === "value") {
            activeTooltipIndex = -1;
            for (var i3 = 0; i3 < tooltipTicks.length; i3++) {
              if (tooltipTicks[i3].value === data.activeLabel) {
                activeTooltipIndex = i3;
                break;
              }
            }
          }
          var viewBox = _objectSpread(_objectSpread({}, offset2), {}, {
            x: offset2.left,
            y: offset2.top
          });
          var validateChartX = Math.min(chartX, viewBox.x + viewBox.width);
          var validateChartY = Math.min(chartY, viewBox.y + viewBox.height);
          var activeLabel = tooltipTicks[activeTooltipIndex] && tooltipTicks[activeTooltipIndex].value;
          var activePayload = getTooltipContent(_this.state, _this.props.data, activeTooltipIndex);
          var activeCoordinate = tooltipTicks[activeTooltipIndex] ? {
            x: layout === "horizontal" ? tooltipTicks[activeTooltipIndex].coordinate : validateChartX,
            y: layout === "horizontal" ? validateChartY : tooltipTicks[activeTooltipIndex].coordinate
          } : originCoordinate;
          _this.setState(_objectSpread(_objectSpread({}, data), {}, {
            activeLabel,
            activeCoordinate,
            activePayload,
            activeTooltipIndex
          }));
        } else {
          _this.setState(data);
        }
      });
      _defineProperty(_this, "renderCursor", function(element) {
        var _element$props$active;
        var _this$state3 = _this.state, isTooltipActive = _this$state3.isTooltipActive, activeCoordinate = _this$state3.activeCoordinate, activePayload = _this$state3.activePayload, offset2 = _this$state3.offset, activeTooltipIndex = _this$state3.activeTooltipIndex, tooltipAxisBandSize = _this$state3.tooltipAxisBandSize;
        var tooltipEventType = _this.getTooltipEventType();
        var isActive = (_element$props$active = element.props.active) !== null && _element$props$active !== void 0 ? _element$props$active : isTooltipActive;
        var layout = _this.props.layout;
        var key = element.key || "_recharts-cursor";
        return /* @__PURE__ */ React__default.createElement(Cursor, {
          key,
          activeCoordinate,
          activePayload,
          activeTooltipIndex,
          chartName,
          element,
          isActive,
          layout,
          offset: offset2,
          tooltipAxisBandSize,
          tooltipEventType
        });
      });
      _defineProperty(_this, "renderPolarAxis", function(element, displayName, index2) {
        var axisType = get(element, "type.axisType");
        var axisMap = get(_this.state, "".concat(axisType, "Map"));
        var elementDefaultProps = element.type.defaultProps;
        var elementProps = elementDefaultProps !== void 0 ? _objectSpread(_objectSpread({}, elementDefaultProps), element.props) : element.props;
        var axisOption = axisMap && axisMap[elementProps["".concat(axisType, "Id")]];
        return /* @__PURE__ */ cloneElement(element, _objectSpread(_objectSpread({}, axisOption), {}, {
          className: clsx(axisType, axisOption.className),
          key: element.key || "".concat(displayName, "-").concat(index2),
          ticks: getTicksOfAxis(axisOption, true)
        }));
      });
      _defineProperty(_this, "renderPolarGrid", function(element) {
        var _element$props = element.props, radialLines = _element$props.radialLines, polarAngles = _element$props.polarAngles, polarRadius = _element$props.polarRadius;
        var _this$state4 = _this.state, radiusAxisMap = _this$state4.radiusAxisMap, angleAxisMap = _this$state4.angleAxisMap;
        var radiusAxis = getAnyElementOfObject(radiusAxisMap);
        var angleAxis = getAnyElementOfObject(angleAxisMap);
        var cx = angleAxis.cx, cy = angleAxis.cy, innerRadius = angleAxis.innerRadius, outerRadius = angleAxis.outerRadius;
        return /* @__PURE__ */ cloneElement(element, {
          polarAngles: Array.isArray(polarAngles) ? polarAngles : getTicksOfAxis(angleAxis, true).map(function(entry) {
            return entry.coordinate;
          }),
          polarRadius: Array.isArray(polarRadius) ? polarRadius : getTicksOfAxis(radiusAxis, true).map(function(entry) {
            return entry.coordinate;
          }),
          cx,
          cy,
          innerRadius,
          outerRadius,
          key: element.key || "polar-grid",
          radialLines
        });
      });
      _defineProperty(_this, "renderLegend", function() {
        var formattedGraphicalItems = _this.state.formattedGraphicalItems;
        var _this$props2 = _this.props, children = _this$props2.children, width = _this$props2.width, height = _this$props2.height;
        var margin = _this.props.margin || {};
        var legendWidth = width - (margin.left || 0) - (margin.right || 0);
        var props = getLegendProps({
          children,
          formattedGraphicalItems,
          legendWidth,
          legendContent
        });
        if (!props) {
          return null;
        }
        var item = props.item, otherProps = _objectWithoutProperties(props, _excluded);
        return /* @__PURE__ */ cloneElement(item, _objectSpread(_objectSpread({}, otherProps), {}, {
          chartWidth: width,
          chartHeight: height,
          margin,
          onBBoxUpdate: _this.handleLegendBBoxUpdate
        }));
      });
      _defineProperty(_this, "renderTooltip", function() {
        var _tooltipItem$props$ac;
        var _this$props3 = _this.props, children = _this$props3.children, accessibilityLayer = _this$props3.accessibilityLayer;
        var tooltipItem = findChildByType(children, Tooltip$1);
        if (!tooltipItem) {
          return null;
        }
        var _this$state5 = _this.state, isTooltipActive = _this$state5.isTooltipActive, activeCoordinate = _this$state5.activeCoordinate, activePayload = _this$state5.activePayload, activeLabel = _this$state5.activeLabel, offset2 = _this$state5.offset;
        var isActive = (_tooltipItem$props$ac = tooltipItem.props.active) !== null && _tooltipItem$props$ac !== void 0 ? _tooltipItem$props$ac : isTooltipActive;
        return /* @__PURE__ */ cloneElement(tooltipItem, {
          viewBox: _objectSpread(_objectSpread({}, offset2), {}, {
            x: offset2.left,
            y: offset2.top
          }),
          active: isActive,
          label: activeLabel,
          payload: isActive ? activePayload : [],
          coordinate: activeCoordinate,
          accessibilityLayer
        });
      });
      _defineProperty(_this, "renderBrush", function(element) {
        var _this$props4 = _this.props, margin = _this$props4.margin, data = _this$props4.data;
        var _this$state6 = _this.state, offset2 = _this$state6.offset, dataStartIndex = _this$state6.dataStartIndex, dataEndIndex = _this$state6.dataEndIndex, updateId = _this$state6.updateId;
        return /* @__PURE__ */ cloneElement(element, {
          key: element.key || "_recharts-brush",
          onChange: combineEventHandlers(_this.handleBrushChange, element.props.onChange),
          data,
          x: isNumber(element.props.x) ? element.props.x : offset2.left,
          y: isNumber(element.props.y) ? element.props.y : offset2.top + offset2.height + offset2.brushBottom - (margin.bottom || 0),
          width: isNumber(element.props.width) ? element.props.width : offset2.width,
          startIndex: dataStartIndex,
          endIndex: dataEndIndex,
          updateId: "brush-".concat(updateId)
        });
      });
      _defineProperty(_this, "renderReferenceElement", function(element, displayName, index2) {
        if (!element) {
          return null;
        }
        var _this2 = _this, clipPathId = _this2.clipPathId;
        var _this$state7 = _this.state, xAxisMap = _this$state7.xAxisMap, yAxisMap = _this$state7.yAxisMap, offset2 = _this$state7.offset;
        var elementDefaultProps = element.type.defaultProps || {};
        var _element$props2 = element.props, _element$props2$xAxis = _element$props2.xAxisId, xAxisId = _element$props2$xAxis === void 0 ? elementDefaultProps.xAxisId : _element$props2$xAxis, _element$props2$yAxis = _element$props2.yAxisId, yAxisId = _element$props2$yAxis === void 0 ? elementDefaultProps.yAxisId : _element$props2$yAxis;
        return /* @__PURE__ */ cloneElement(element, {
          key: element.key || "".concat(displayName, "-").concat(index2),
          xAxis: xAxisMap[xAxisId],
          yAxis: yAxisMap[yAxisId],
          viewBox: {
            x: offset2.left,
            y: offset2.top,
            width: offset2.width,
            height: offset2.height
          },
          clipPathId
        });
      });
      _defineProperty(_this, "renderActivePoints", function(_ref10) {
        var item = _ref10.item, activePoint = _ref10.activePoint, basePoint = _ref10.basePoint, childIndex = _ref10.childIndex, isRange = _ref10.isRange;
        var result = [];
        var key = item.props.key;
        var itemItemProps = item.item.type.defaultProps !== void 0 ? _objectSpread(_objectSpread({}, item.item.type.defaultProps), item.item.props) : item.item.props;
        var activeDot = itemItemProps.activeDot, dataKey = itemItemProps.dataKey;
        var dotProps = _objectSpread(_objectSpread({
          index: childIndex,
          dataKey,
          cx: activePoint.x,
          cy: activePoint.y,
          r: 4,
          fill: getMainColorOfGraphicItem(item.item),
          strokeWidth: 2,
          stroke: "#fff",
          payload: activePoint.payload,
          value: activePoint.value
        }, filterProps(activeDot, false)), adaptEventHandlers(activeDot));
        result.push(CategoricalChartWrapper2.renderActiveDot(activeDot, dotProps, "".concat(key, "-activePoint-").concat(childIndex)));
        if (basePoint) {
          result.push(CategoricalChartWrapper2.renderActiveDot(activeDot, _objectSpread(_objectSpread({}, dotProps), {}, {
            cx: basePoint.x,
            cy: basePoint.y
          }), "".concat(key, "-basePoint-").concat(childIndex)));
        } else if (isRange) {
          result.push(null);
        }
        return result;
      });
      _defineProperty(_this, "renderGraphicChild", function(element, displayName, index2) {
        var item = _this.filterFormatItem(element, displayName, index2);
        if (!item) {
          return null;
        }
        var tooltipEventType = _this.getTooltipEventType();
        var _this$state8 = _this.state, isTooltipActive = _this$state8.isTooltipActive, tooltipAxis = _this$state8.tooltipAxis, activeTooltipIndex = _this$state8.activeTooltipIndex, activeLabel = _this$state8.activeLabel;
        var children = _this.props.children;
        var tooltipItem = findChildByType(children, Tooltip$1);
        var _item$props = item.props, points = _item$props.points, isRange = _item$props.isRange, baseLine = _item$props.baseLine;
        var itemItemProps = item.item.type.defaultProps !== void 0 ? _objectSpread(_objectSpread({}, item.item.type.defaultProps), item.item.props) : item.item.props;
        var activeDot = itemItemProps.activeDot, hide2 = itemItemProps.hide, activeBar = itemItemProps.activeBar, activeShape = itemItemProps.activeShape;
        var hasActive = Boolean(!hide2 && isTooltipActive && tooltipItem && (activeDot || activeBar || activeShape));
        var itemEvents = {};
        if (tooltipEventType !== "axis" && tooltipItem && tooltipItem.props.trigger === "click") {
          itemEvents = {
            onClick: combineEventHandlers(_this.handleItemMouseEnter, element.props.onClick)
          };
        } else if (tooltipEventType !== "axis") {
          itemEvents = {
            onMouseLeave: combineEventHandlers(_this.handleItemMouseLeave, element.props.onMouseLeave),
            onMouseEnter: combineEventHandlers(_this.handleItemMouseEnter, element.props.onMouseEnter)
          };
        }
        var graphicalItem = /* @__PURE__ */ cloneElement(element, _objectSpread(_objectSpread({}, item.props), itemEvents));
        function findWithPayload(entry) {
          return typeof tooltipAxis.dataKey === "function" ? tooltipAxis.dataKey(entry.payload) : null;
        }
        if (hasActive) {
          if (activeTooltipIndex >= 0) {
            var activePoint, basePoint;
            if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
              var specifiedKey = typeof tooltipAxis.dataKey === "function" ? findWithPayload : "payload.".concat(tooltipAxis.dataKey.toString());
              activePoint = findEntryInArray(points, specifiedKey, activeLabel);
              basePoint = isRange && baseLine && findEntryInArray(baseLine, specifiedKey, activeLabel);
            } else {
              activePoint = points === null || points === void 0 ? void 0 : points[activeTooltipIndex];
              basePoint = isRange && baseLine && baseLine[activeTooltipIndex];
            }
            if (activeShape || activeBar) {
              var activeIndex = element.props.activeIndex !== void 0 ? element.props.activeIndex : activeTooltipIndex;
              return [/* @__PURE__ */ cloneElement(element, _objectSpread(_objectSpread(_objectSpread({}, item.props), itemEvents), {}, {
                activeIndex
              })), null, null];
            }
            if (!isNil(activePoint)) {
              return [graphicalItem].concat(_toConsumableArray(_this.renderActivePoints({
                item,
                activePoint,
                basePoint,
                childIndex: activeTooltipIndex,
                isRange
              })));
            }
          } else {
            var _this$getItemByXY;
            var _ref11 = (_this$getItemByXY = _this.getItemByXY(_this.state.activeCoordinate)) !== null && _this$getItemByXY !== void 0 ? _this$getItemByXY : {
              graphicalItem
            }, _ref11$graphicalItem = _ref11.graphicalItem, _ref11$graphicalItem$ = _ref11$graphicalItem.item, xyItem = _ref11$graphicalItem$ === void 0 ? element : _ref11$graphicalItem$, childIndex = _ref11$graphicalItem.childIndex;
            var elementProps = _objectSpread(_objectSpread(_objectSpread({}, item.props), itemEvents), {}, {
              activeIndex: childIndex
            });
            return [/* @__PURE__ */ cloneElement(xyItem, elementProps), null, null];
          }
        }
        if (isRange) {
          return [graphicalItem, null, null];
        }
        return [graphicalItem, null];
      });
      _defineProperty(_this, "renderCustomized", function(element, displayName, index2) {
        return /* @__PURE__ */ cloneElement(element, _objectSpread(_objectSpread({
          key: "recharts-customized-".concat(index2)
        }, _this.props), _this.state));
      });
      _defineProperty(_this, "renderMap", {
        CartesianGrid: {
          handler: renderAsIs,
          once: true
        },
        ReferenceArea: {
          handler: _this.renderReferenceElement
        },
        ReferenceLine: {
          handler: renderAsIs
        },
        ReferenceDot: {
          handler: _this.renderReferenceElement
        },
        XAxis: {
          handler: renderAsIs
        },
        YAxis: {
          handler: renderAsIs
        },
        Brush: {
          handler: _this.renderBrush,
          once: true
        },
        Bar: {
          handler: _this.renderGraphicChild
        },
        Line: {
          handler: _this.renderGraphicChild
        },
        Area: {
          handler: _this.renderGraphicChild
        },
        Radar: {
          handler: _this.renderGraphicChild
        },
        RadialBar: {
          handler: _this.renderGraphicChild
        },
        Scatter: {
          handler: _this.renderGraphicChild
        },
        Pie: {
          handler: _this.renderGraphicChild
        },
        Funnel: {
          handler: _this.renderGraphicChild
        },
        Tooltip: {
          handler: _this.renderCursor,
          once: true
        },
        PolarGrid: {
          handler: _this.renderPolarGrid,
          once: true
        },
        PolarAngleAxis: {
          handler: _this.renderPolarAxis
        },
        PolarRadiusAxis: {
          handler: _this.renderPolarAxis
        },
        Customized: {
          handler: _this.renderCustomized
        }
      });
      _this.clipPathId = "".concat((_props$id = _props.id) !== null && _props$id !== void 0 ? _props$id : uniqueId("recharts"), "-clip");
      _this.throttleTriggeredAfterMouseMove = throttle(_this.triggeredAfterMouseMove, (_props$throttleDelay = _props.throttleDelay) !== null && _props$throttleDelay !== void 0 ? _props$throttleDelay : 1e3 / 60);
      _this.state = {};
      return _this;
    }
    _inherits(CategoricalChartWrapper2, _Component);
    return _createClass(CategoricalChartWrapper2, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this$props$margin$le, _this$props$margin$to;
        this.addListener();
        this.accessibilityManager.setDetails({
          container: this.container,
          offset: {
            left: (_this$props$margin$le = this.props.margin.left) !== null && _this$props$margin$le !== void 0 ? _this$props$margin$le : 0,
            top: (_this$props$margin$to = this.props.margin.top) !== null && _this$props$margin$to !== void 0 ? _this$props$margin$to : 0
          },
          coordinateList: this.state.tooltipTicks,
          mouseHandlerCallback: this.triggeredAfterMouseMove,
          layout: this.props.layout
        });
        this.displayDefaultTooltip();
      }
    }, {
      key: "displayDefaultTooltip",
      value: function displayDefaultTooltip() {
        var _this$props5 = this.props, children = _this$props5.children, data = _this$props5.data, height = _this$props5.height, layout = _this$props5.layout;
        var tooltipElem = findChildByType(children, Tooltip$1);
        if (!tooltipElem) {
          return;
        }
        var defaultIndex = tooltipElem.props.defaultIndex;
        if (typeof defaultIndex !== "number" || defaultIndex < 0 || defaultIndex > this.state.tooltipTicks.length - 1) {
          return;
        }
        var activeLabel = this.state.tooltipTicks[defaultIndex] && this.state.tooltipTicks[defaultIndex].value;
        var activePayload = getTooltipContent(this.state, data, defaultIndex, activeLabel);
        var independentAxisCoord = this.state.tooltipTicks[defaultIndex].coordinate;
        var dependentAxisCoord = (this.state.offset.top + height) / 2;
        var isHorizontal = layout === "horizontal";
        var activeCoordinate = isHorizontal ? {
          x: independentAxisCoord,
          y: dependentAxisCoord
        } : {
          y: independentAxisCoord,
          x: dependentAxisCoord
        };
        var scatterPlotElement = this.state.formattedGraphicalItems.find(function(_ref12) {
          var item = _ref12.item;
          return item.type.name === "Scatter";
        });
        if (scatterPlotElement) {
          activeCoordinate = _objectSpread(_objectSpread({}, activeCoordinate), scatterPlotElement.props.points[defaultIndex].tooltipPosition);
          activePayload = scatterPlotElement.props.points[defaultIndex].tooltipPayload;
        }
        var nextState = {
          activeTooltipIndex: defaultIndex,
          isTooltipActive: true,
          activeLabel,
          activePayload,
          activeCoordinate
        };
        this.setState(nextState);
        this.renderCursor(tooltipElem);
        this.accessibilityManager.setIndex(defaultIndex);
      }
    }, {
      key: "getSnapshotBeforeUpdate",
      value: function getSnapshotBeforeUpdate(prevProps, prevState) {
        if (!this.props.accessibilityLayer) {
          return null;
        }
        if (this.state.tooltipTicks !== prevState.tooltipTicks) {
          this.accessibilityManager.setDetails({
            coordinateList: this.state.tooltipTicks
          });
        }
        if (this.props.layout !== prevProps.layout) {
          this.accessibilityManager.setDetails({
            layout: this.props.layout
          });
        }
        if (this.props.margin !== prevProps.margin) {
          var _this$props$margin$le2, _this$props$margin$to2;
          this.accessibilityManager.setDetails({
            offset: {
              left: (_this$props$margin$le2 = this.props.margin.left) !== null && _this$props$margin$le2 !== void 0 ? _this$props$margin$le2 : 0,
              top: (_this$props$margin$to2 = this.props.margin.top) !== null && _this$props$margin$to2 !== void 0 ? _this$props$margin$to2 : 0
            }
          });
        }
        return null;
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (!isChildrenEqual([findChildByType(prevProps.children, Tooltip$1)], [findChildByType(this.props.children, Tooltip$1)])) {
          this.displayDefaultTooltip();
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.removeListener();
        this.throttleTriggeredAfterMouseMove.cancel();
      }
    }, {
      key: "getTooltipEventType",
      value: function getTooltipEventType() {
        var tooltipItem = findChildByType(this.props.children, Tooltip$1);
        if (tooltipItem && typeof tooltipItem.props.shared === "boolean") {
          var eventType = tooltipItem.props.shared ? "axis" : "item";
          return validateTooltipEventTypes.indexOf(eventType) >= 0 ? eventType : defaultTooltipEventType;
        }
        return defaultTooltipEventType;
      }
      /**
       * Get the information of mouse in chart, return null when the mouse is not in the chart
       * @param  {MousePointer} event    The event object
       * @return {Object}          Mouse data
       */
    }, {
      key: "getMouseInfo",
      value: function getMouseInfo(event) {
        if (!this.container) {
          return null;
        }
        var element = this.container;
        var boundingRect = element.getBoundingClientRect();
        var containerOffset = getOffset(boundingRect);
        var e3 = {
          chartX: Math.round(event.pageX - containerOffset.left),
          chartY: Math.round(event.pageY - containerOffset.top)
        };
        var scale2 = boundingRect.width / element.offsetWidth || 1;
        var rangeObj = this.inRange(e3.chartX, e3.chartY, scale2);
        if (!rangeObj) {
          return null;
        }
        var _this$state9 = this.state, xAxisMap = _this$state9.xAxisMap, yAxisMap = _this$state9.yAxisMap;
        var tooltipEventType = this.getTooltipEventType();
        if (tooltipEventType !== "axis" && xAxisMap && yAxisMap) {
          var xScale = getAnyElementOfObject(xAxisMap).scale;
          var yScale = getAnyElementOfObject(yAxisMap).scale;
          var xValue = xScale && xScale.invert ? xScale.invert(e3.chartX) : null;
          var yValue = yScale && yScale.invert ? yScale.invert(e3.chartY) : null;
          return _objectSpread(_objectSpread({}, e3), {}, {
            xValue,
            yValue
          });
        }
        var toolTipData = getTooltipData(this.state, this.props.data, this.props.layout, rangeObj);
        if (toolTipData) {
          return _objectSpread(_objectSpread({}, e3), toolTipData);
        }
        return null;
      }
    }, {
      key: "inRange",
      value: function inRange(x3, y4) {
        var scale2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
        var layout = this.props.layout;
        var scaledX = x3 / scale2, scaledY = y4 / scale2;
        if (layout === "horizontal" || layout === "vertical") {
          var offset2 = this.state.offset;
          var isInRange = scaledX >= offset2.left && scaledX <= offset2.left + offset2.width && scaledY >= offset2.top && scaledY <= offset2.top + offset2.height;
          return isInRange ? {
            x: scaledX,
            y: scaledY
          } : null;
        }
        var _this$state10 = this.state, angleAxisMap = _this$state10.angleAxisMap, radiusAxisMap = _this$state10.radiusAxisMap;
        if (angleAxisMap && radiusAxisMap) {
          var angleAxis = getAnyElementOfObject(angleAxisMap);
          return inRangeOfSector({
            x: scaledX,
            y: scaledY
          }, angleAxis);
        }
        return null;
      }
    }, {
      key: "parseEventsOfWrapper",
      value: function parseEventsOfWrapper() {
        var children = this.props.children;
        var tooltipEventType = this.getTooltipEventType();
        var tooltipItem = findChildByType(children, Tooltip$1);
        var tooltipEvents = {};
        if (tooltipItem && tooltipEventType === "axis") {
          if (tooltipItem.props.trigger === "click") {
            tooltipEvents = {
              onClick: this.handleClick
            };
          } else {
            tooltipEvents = {
              onMouseEnter: this.handleMouseEnter,
              onDoubleClick: this.handleDoubleClick,
              onMouseMove: this.handleMouseMove,
              onMouseLeave: this.handleMouseLeave,
              onTouchMove: this.handleTouchMove,
              onTouchStart: this.handleTouchStart,
              onTouchEnd: this.handleTouchEnd,
              onContextMenu: this.handleContextMenu
            };
          }
        }
        var outerEvents = adaptEventHandlers(this.props, this.handleOuterEvent);
        return _objectSpread(_objectSpread({}, outerEvents), tooltipEvents);
      }
    }, {
      key: "addListener",
      value: function addListener() {
        eventCenter.on(SYNC_EVENT, this.handleReceiveSyncEvent);
      }
    }, {
      key: "removeListener",
      value: function removeListener() {
        eventCenter.removeListener(SYNC_EVENT, this.handleReceiveSyncEvent);
      }
    }, {
      key: "filterFormatItem",
      value: function filterFormatItem(item, displayName, childIndex) {
        var formattedGraphicalItems = this.state.formattedGraphicalItems;
        for (var i3 = 0, len = formattedGraphicalItems.length; i3 < len; i3++) {
          var entry = formattedGraphicalItems[i3];
          if (entry.item === item || entry.props.key === item.key || displayName === getDisplayName(entry.item.type) && childIndex === entry.childIndex) {
            return entry;
          }
        }
        return null;
      }
    }, {
      key: "renderClipPath",
      value: function renderClipPath() {
        var clipPathId = this.clipPathId;
        var _this$state$offset = this.state.offset, left = _this$state$offset.left, top = _this$state$offset.top, height = _this$state$offset.height, width = _this$state$offset.width;
        return /* @__PURE__ */ React__default.createElement("defs", null, /* @__PURE__ */ React__default.createElement("clipPath", {
          id: clipPathId
        }, /* @__PURE__ */ React__default.createElement("rect", {
          x: left,
          y: top,
          height,
          width
        })));
      }
    }, {
      key: "getXScales",
      value: function getXScales() {
        var xAxisMap = this.state.xAxisMap;
        return xAxisMap ? Object.entries(xAxisMap).reduce(function(res, _ref13) {
          var _ref14 = _slicedToArray(_ref13, 2), axisId = _ref14[0], axisProps = _ref14[1];
          return _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, axisId, axisProps.scale));
        }, {}) : null;
      }
    }, {
      key: "getYScales",
      value: function getYScales() {
        var yAxisMap = this.state.yAxisMap;
        return yAxisMap ? Object.entries(yAxisMap).reduce(function(res, _ref15) {
          var _ref16 = _slicedToArray(_ref15, 2), axisId = _ref16[0], axisProps = _ref16[1];
          return _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, axisId, axisProps.scale));
        }, {}) : null;
      }
    }, {
      key: "getXScaleByAxisId",
      value: function getXScaleByAxisId(axisId) {
        var _this$state$xAxisMap;
        return (_this$state$xAxisMap = this.state.xAxisMap) === null || _this$state$xAxisMap === void 0 || (_this$state$xAxisMap = _this$state$xAxisMap[axisId]) === null || _this$state$xAxisMap === void 0 ? void 0 : _this$state$xAxisMap.scale;
      }
    }, {
      key: "getYScaleByAxisId",
      value: function getYScaleByAxisId(axisId) {
        var _this$state$yAxisMap;
        return (_this$state$yAxisMap = this.state.yAxisMap) === null || _this$state$yAxisMap === void 0 || (_this$state$yAxisMap = _this$state$yAxisMap[axisId]) === null || _this$state$yAxisMap === void 0 ? void 0 : _this$state$yAxisMap.scale;
      }
    }, {
      key: "getItemByXY",
      value: function getItemByXY(chartXY) {
        var _this$state11 = this.state, formattedGraphicalItems = _this$state11.formattedGraphicalItems, activeItem = _this$state11.activeItem;
        if (formattedGraphicalItems && formattedGraphicalItems.length) {
          for (var i3 = 0, len = formattedGraphicalItems.length; i3 < len; i3++) {
            var graphicalItem = formattedGraphicalItems[i3];
            var props = graphicalItem.props, item = graphicalItem.item;
            var itemProps = item.type.defaultProps !== void 0 ? _objectSpread(_objectSpread({}, item.type.defaultProps), item.props) : item.props;
            var itemDisplayName = getDisplayName(item.type);
            if (itemDisplayName === "Bar") {
              var activeBarItem = (props.data || []).find(function(entry) {
                return isInRectangle(chartXY, entry);
              });
              if (activeBarItem) {
                return {
                  graphicalItem,
                  payload: activeBarItem
                };
              }
            } else if (itemDisplayName === "RadialBar") {
              var _activeBarItem = (props.data || []).find(function(entry) {
                return inRangeOfSector(chartXY, entry);
              });
              if (_activeBarItem) {
                return {
                  graphicalItem,
                  payload: _activeBarItem
                };
              }
            } else if (isFunnel(graphicalItem, activeItem) || isPie(graphicalItem, activeItem) || isScatter(graphicalItem, activeItem)) {
              var activeIndex = getActiveShapeIndexForTooltip({
                graphicalItem,
                activeTooltipItem: activeItem,
                itemData: itemProps.data
              });
              var childIndex = itemProps.activeIndex === void 0 ? activeIndex : itemProps.activeIndex;
              return {
                graphicalItem: _objectSpread(_objectSpread({}, graphicalItem), {}, {
                  childIndex
                }),
                payload: isScatter(graphicalItem, activeItem) ? itemProps.data[activeIndex] : graphicalItem.props.data[activeIndex]
              };
            }
          }
        }
        return null;
      }
    }, {
      key: "render",
      value: function render() {
        var _this3 = this;
        if (!validateWidthHeight(this)) {
          return null;
        }
        var _this$props6 = this.props, children = _this$props6.children, className = _this$props6.className, width = _this$props6.width, height = _this$props6.height, style = _this$props6.style, compact2 = _this$props6.compact, title = _this$props6.title, desc = _this$props6.desc, others = _objectWithoutProperties(_this$props6, _excluded2);
        var attrs = filterProps(others, false);
        if (compact2) {
          return /* @__PURE__ */ React__default.createElement(ChartLayoutContextProvider, {
            state: this.state,
            width: this.props.width,
            height: this.props.height,
            clipPathId: this.clipPathId
          }, /* @__PURE__ */ React__default.createElement(Surface, _extends({}, attrs, {
            width,
            height,
            title,
            desc
          }), this.renderClipPath(), renderByOrder(children, this.renderMap)));
        }
        if (this.props.accessibilityLayer) {
          var _this$props$tabIndex, _this$props$role;
          attrs.tabIndex = (_this$props$tabIndex = this.props.tabIndex) !== null && _this$props$tabIndex !== void 0 ? _this$props$tabIndex : 0;
          attrs.role = (_this$props$role = this.props.role) !== null && _this$props$role !== void 0 ? _this$props$role : "application";
          attrs.onKeyDown = function(e3) {
            _this3.accessibilityManager.keyboardEvent(e3);
          };
          attrs.onFocus = function() {
            _this3.accessibilityManager.focus();
          };
        }
        var events2 = this.parseEventsOfWrapper();
        return /* @__PURE__ */ React__default.createElement(ChartLayoutContextProvider, {
          state: this.state,
          width: this.props.width,
          height: this.props.height,
          clipPathId: this.clipPathId
        }, /* @__PURE__ */ React__default.createElement("div", _extends({
          className: clsx("recharts-wrapper", className),
          style: _objectSpread({
            position: "relative",
            cursor: "default",
            width,
            height
          }, style)
        }, events2, {
          ref: function ref(node) {
            _this3.container = node;
          }
        }), /* @__PURE__ */ React__default.createElement(Surface, _extends({}, attrs, {
          width,
          height,
          title,
          desc,
          style: FULL_WIDTH_AND_HEIGHT
        }), this.renderClipPath(), renderByOrder(children, this.renderMap)), this.renderLegend(), this.renderTooltip()));
      }
    }]);
  }(Component);
  _defineProperty(CategoricalChartWrapper, "displayName", chartName);
  _defineProperty(CategoricalChartWrapper, "defaultProps", _objectSpread({
    layout: "horizontal",
    stackOffset: "none",
    barCategoryGap: "10%",
    barGap: 4,
    margin: {
      top: 5,
      right: 5,
      bottom: 5,
      left: 5
    },
    reverseStackOrder: false,
    syncMethod: "index"
  }, defaultProps2));
  _defineProperty(CategoricalChartWrapper, "getDerivedStateFromProps", function(nextProps, prevState) {
    var dataKey = nextProps.dataKey, data = nextProps.data, children = nextProps.children, width = nextProps.width, height = nextProps.height, layout = nextProps.layout, stackOffset = nextProps.stackOffset, margin = nextProps.margin;
    var dataStartIndex = prevState.dataStartIndex, dataEndIndex = prevState.dataEndIndex;
    if (prevState.updateId === void 0) {
      var defaultState2 = createDefaultState(nextProps);
      return _objectSpread(_objectSpread(_objectSpread({}, defaultState2), {}, {
        updateId: 0
      }, updateStateOfAxisMapsOffsetAndStackGroups(_objectSpread(_objectSpread({
        props: nextProps
      }, defaultState2), {}, {
        updateId: 0
      }), prevState)), {}, {
        prevDataKey: dataKey,
        prevData: data,
        prevWidth: width,
        prevHeight: height,
        prevLayout: layout,
        prevStackOffset: stackOffset,
        prevMargin: margin,
        prevChildren: children
      });
    }
    if (dataKey !== prevState.prevDataKey || data !== prevState.prevData || width !== prevState.prevWidth || height !== prevState.prevHeight || layout !== prevState.prevLayout || stackOffset !== prevState.prevStackOffset || !shallowEqual(margin, prevState.prevMargin)) {
      var _defaultState = createDefaultState(nextProps);
      var keepFromPrevState = {
        // (chartX, chartY) are (0,0) in default state, but we want to keep the last mouse position to avoid
        // any flickering
        chartX: prevState.chartX,
        chartY: prevState.chartY,
        // The tooltip should stay active when it was active in the previous render. If this is not
        // the case, the tooltip disappears and immediately re-appears, causing a flickering effect
        isTooltipActive: prevState.isTooltipActive
      };
      var updatesToState = _objectSpread(_objectSpread({}, getTooltipData(prevState, data, layout)), {}, {
        updateId: prevState.updateId + 1
      });
      var newState = _objectSpread(_objectSpread(_objectSpread({}, _defaultState), keepFromPrevState), updatesToState);
      return _objectSpread(_objectSpread(_objectSpread({}, newState), updateStateOfAxisMapsOffsetAndStackGroups(_objectSpread({
        props: nextProps
      }, newState), prevState)), {}, {
        prevDataKey: dataKey,
        prevData: data,
        prevWidth: width,
        prevHeight: height,
        prevLayout: layout,
        prevStackOffset: stackOffset,
        prevMargin: margin,
        prevChildren: children
      });
    }
    if (!isChildrenEqual(children, prevState.prevChildren)) {
      var _brush$props$startInd, _brush$props, _brush$props$endIndex, _brush$props2;
      var brush = findChildByType(children, Brush);
      var startIndex = brush ? (_brush$props$startInd = (_brush$props = brush.props) === null || _brush$props === void 0 ? void 0 : _brush$props.startIndex) !== null && _brush$props$startInd !== void 0 ? _brush$props$startInd : dataStartIndex : dataStartIndex;
      var endIndex = brush ? (_brush$props$endIndex = (_brush$props2 = brush.props) === null || _brush$props2 === void 0 ? void 0 : _brush$props2.endIndex) !== null && _brush$props$endIndex !== void 0 ? _brush$props$endIndex : dataEndIndex : dataEndIndex;
      var hasDifferentStartOrEndIndex = startIndex !== dataStartIndex || endIndex !== dataEndIndex;
      var hasGlobalData = !isNil(data);
      var newUpdateId = hasGlobalData && !hasDifferentStartOrEndIndex ? prevState.updateId : prevState.updateId + 1;
      return _objectSpread(_objectSpread({
        updateId: newUpdateId
      }, updateStateOfAxisMapsOffsetAndStackGroups(_objectSpread(_objectSpread({
        props: nextProps
      }, prevState), {}, {
        updateId: newUpdateId,
        dataStartIndex: startIndex,
        dataEndIndex: endIndex
      }), prevState)), {}, {
        prevChildren: children,
        dataStartIndex: startIndex,
        dataEndIndex: endIndex
      });
    }
    return null;
  });
  _defineProperty(CategoricalChartWrapper, "renderActiveDot", function(option, props, key) {
    var dot;
    if (/* @__PURE__ */ isValidElement(option)) {
      dot = /* @__PURE__ */ cloneElement(option, props);
    } else if (isFunction(option)) {
      dot = option(props);
    } else {
      dot = /* @__PURE__ */ React__default.createElement(Dot, props);
    }
    return /* @__PURE__ */ React__default.createElement(Layer, {
      className: "recharts-active-dot",
      key
    }, dot);
  });
  var CategoricalChart = /* @__PURE__ */ forwardRef(function CategoricalChart2(props, ref) {
    return /* @__PURE__ */ React__default.createElement(CategoricalChartWrapper, _extends({}, props, {
      ref
    }));
  });
  CategoricalChart.displayName = CategoricalChartWrapper.displayName;
  return CategoricalChart;
};
var LineChart$1 = generateCategoricalChart({
  chartName: "LineChart",
  GraphicalChild: Line$1,
  axisComponents: [{
    axisType: "xAxis",
    AxisComp: XAxis
  }, {
    axisType: "yAxis",
    AxisComp: YAxis
  }],
  formatAxisMap: formatAxisMap2
});
var BarChart$1 = generateCategoricalChart({
  chartName: "BarChart",
  GraphicalChild: Bar$1,
  defaultTooltipEventType: "axis",
  validateTooltipEventTypes: ["axis", "item"],
  axisComponents: [{
    axisType: "xAxis",
    AxisComp: XAxis
  }, {
    axisType: "yAxis",
    AxisComp: YAxis
  }],
  formatAxisMap: formatAxisMap2
});
var PieChart$1 = generateCategoricalChart({
  chartName: "PieChart",
  GraphicalChild: Pie,
  validateTooltipEventTypes: ["item"],
  defaultTooltipEventType: "item",
  legendContent: "children",
  axisComponents: [{
    axisType: "angleAxis",
    AxisComp: PolarAngleAxis
  }, {
    axisType: "radiusAxis",
    AxisComp: PolarRadiusAxis
  }],
  formatAxisMap: formatAxisMap$1,
  defaultProps: {
    layout: "centric",
    startAngle: 0,
    endAngle: 360,
    cx: "50%",
    cy: "50%",
    innerRadius: 0,
    outerRadius: "80%"
  }
});
var AreaChart$1 = generateCategoricalChart({
  chartName: "AreaChart",
  GraphicalChild: Area$1,
  axisComponents: [{
    axisType: "xAxis",
    AxisComp: XAxis
  }, {
    axisType: "yAxis",
    AxisComp: YAxis
  }],
  formatAxisMap: formatAxisMap2
});
function getAxisProps(axis, props, inverted = false) {
  const { showXAxis = true, showYAxis = false } = props;
  const isYAxis = axis === "y";
  let hide2 = isYAxis ? !showYAxis : !showXAxis;
  let dataKey = isYAxis ? void 0 : props.dataKey;
  let minTickGap = 5;
  let type;
  if (inverted) {
    dataKey = isYAxis ? props.dataKey : void 0;
    hide2 = isYAxis ? !showXAxis : !showYAxis;
    minTickGap = isYAxis ? 1 : minTickGap;
    type = isYAxis ? "category" : "number";
  }
  return {
    axisLine: false,
    dataKey,
    fontSize: 11,
    hide: hide2,
    interval: "preserveStartEnd",
    minTickGap,
    scale: isYAxis ? props.yAxisScale : props.xAxisScale,
    tickLine: false,
    tickMargin: axis === "y" ? 2 : 6,
    tickFormatter: isYAxis ? props.yAxisTickFormatter : props.xAxisTickFormatter,
    type,
    width: (isYAxis ? props.yAxisWidth : void 0) ?? 55
  };
}
function stripCartesianProps(props) {
  const {
    dataKey,
    showXAxis,
    showYAxis,
    xAxisScale,
    xAxisTickFormatter,
    yAxisScale,
    yAxisTickFormatter,
    yAxisWidth,
    ...otherProps
  } = props;
  return otherProps;
}
function ChartWrapper(props) {
  const { onSetWidth: handleSetWidth, ...attributes } = props;
  const ref = React__default.useRef(null);
  React__default.useLayoutEffect(() => {
    if (ref.current && typeof handleSetWidth === "function") {
      const rect = ref.current.getBoundingClientRect();
      handleSetWidth(rect.width);
    }
  }, [ref]);
  const className = clsx("flex justify-center m-auto", attributes.className);
  return /* @__PURE__ */ React__default.createElement("div", { ...attributes, className, ref }, /* @__PURE__ */ React__default.createElement(ResponsiveContainer, null, props.children));
}
function Tooltip(props) {
  const { active, payload = [], style, title } = props;
  if (active && payload.length) {
    return /* @__PURE__ */ React__default.createElement("div", { className: "border-grey-300 z-20 z-[999] flex flex-col gap-y-1 rounded-md border bg-white px-2 py-1.5 text-xs shadow-sm" }, title ? /* @__PURE__ */ React__default.createElement("span", { className: "font-bold" }, title) : null, /* @__PURE__ */ React__default.createElement("dl", { className: "m-0 grid grid-cols-[max-content_max-content] gap-x-4 gap-y-0.5", style }, payload.map((entry, index2) => {
      const color2 = entry.color ?? entry.payload.color;
      const formatter = entry.formatter ?? entry.payload.formatter;
      const unit2 = entry.unit ?? entry.payload.unit;
      return /* @__PURE__ */ React__default.createElement(React__default.Fragment, { key: `${entry.name}-${index2}` }, /* @__PURE__ */ React__default.createElement("dt", { className: "text-grey-700 mb-0 flex items-center gap-1 font-normal", "data-taco": "chart-tooltip" }, /* @__PURE__ */ React__default.createElement("span", { className: "-mt-px h-2.5 w-2.5 rounded-sm", style: { background: color2 } }), entry.name), /* @__PURE__ */ React__default.createElement("dd", { className: "mb-0 text-right font-bold tabular-nums text-black" }, (formatter == null ? void 0 : formatter(entry.value ?? "", entry.name ?? "", entry, index2, entry.payload)) ?? entry.value, unit2 ? /* @__PURE__ */ React__default.createElement("span", { className: "text-grey-700 pl-0.5" }, unit2) : null));
    })));
  }
  return null;
}
function Legend$1(props) {
  const { hoverIndex, items, onHover: handleHover, onToggle: handleToggle } = props;
  const handleMouseEnter = (item, index2) => {
    if (item.isHidden) {
      return;
    }
    handleHover(index2);
  };
  const handleMouseLeave = () => handleHover(void 0);
  const handleClick = (item) => {
    if (!item.isHidden) {
      handleHover(void 0);
    }
    handleToggle(item.dataKey);
  };
  const moreButton = (moreButtonText) => /* @__PURE__ */ React__default.createElement(Button$4, { appearance: "transparent", className: "text-grey-700 !h-5 !min-h-[1.25rem] !px-1.5 text-xs" }, moreButtonText);
  return /* @__PURE__ */ React__default.createElement(OverflowGroup, { className: "mt-3 w-full gap-x-1", moreButton }, items.map((item, index2) => {
    const className = clsx("mr-1 flex h-3 w-3 rounded-sm", {
      border: item.isHidden
    });
    let style;
    if (!item.isHidden) {
      style = { backgroundColor: item.color };
    }
    return /* @__PURE__ */ React__default.createElement(
      "button",
      {
        key: `${item.label}_${index2}`,
        className: "hover:bg-grey-200 focus-visible:yt-focus flex items-center rounded px-1 !text-xs",
        onClick: (event) => {
          event == null ? void 0 : event.preventDefault();
          handleClick(item);
        },
        onMouseEnter: () => handleMouseEnter(item, index2),
        onMouseLeave: () => handleMouseLeave()
      },
      /* @__PURE__ */ React__default.createElement("span", { className, style }, hoverIndex === index2 ? /* @__PURE__ */ React__default.createElement(Icon$1, { name: "tick-bold", className: clsx("!h-full !w-full", { "text-white": !item.isHidden }) }) : null),
      item.label
    );
  }));
}
const THEME_COLORS = {
  transparent: "transparent",
  current: "currentColor",
  white: "#fff",
  black: "#1c1c1c",
  brand: {
    vismaRed: "#E70641",
    paleOrange: "#FFF5E5",
    sunsetOrange: "#E89C2E",
    midnightBlue: "#29283E",
    coolBlue: "#F5F7F9"
  },
  grey: {
    lightest: "#fafafa",
    light: "#F6F6F6",
    DEFAULT: "#EBEBEB",
    dark: "#DDDDDD",
    darker: "#ACACAC",
    darkest: "#595959",
    darkNew: "#a5a6a9",
    50: "#fafafa",
    100: "#F6F6F6",
    200: "#EBEBEB",
    300: "#DDDDDD",
    500: "#ACACAC",
    700: "#595959",
    900: "#303030"
  },
  purple: {
    lightest: "#585c74",
    light: "#4b4f64",
    DEFAULT: "#3d4153",
    dark: "#353a48",
    darker: "#29283e",
    darkest: "#212032",
    darkNew_1: "#373647",
    darkNew_2: "#414050",
    100: "#EEE5FF",
    200: "#ddd1ff",
    300: "#CBBCFE",
    500: "#9270FA",
    700: "#6542D1",
    900: "#412970"
  },
  blue: {
    lightest: "#DEEBFF",
    light: "#75A0F5",
    DEFAULT: "#4573D2",
    dark: "#2B57B4",
    100: "#DEEBFF",
    200: "#AACCFF",
    300: "#75A0F5",
    500: "#4573D2",
    700: "#2B57B4",
    900: "#29283E"
  },
  red: {
    lightest: "#FFDAD2",
    light: "#E66568",
    DEFAULT: "#CE3F42",
    dark: "#950027",
    100: "#FFDAD2",
    200: "#f3a09d",
    300: "#E66568",
    500: "#CE3F42",
    700: "#950027",
    900: "#64001B"
  },
  green: {
    lightest: "#cdf0e7",
    light: "#52C7AB",
    DEFAULT: "#08AE87",
    dark: "#028465",
    100: "#cdf0e7",
    200: "#9be1ce",
    300: "#52C7AB",
    500: "#08AE87",
    700: "#028465",
    900: "#14493A"
  },
  yellow: {
    lightest: "#FFF1C3",
    light: "#FFD665",
    DEFAULT: "#FFBD3B",
    dark: "#e89c2e",
    100: "#FFF1C3",
    200: "#ffe494",
    300: "#FFD665",
    500: "#FFBD3B",
    700: "#e89c2e",
    900: "#733700"
  },
  pink: {
    100: "#FFE3F7",
    200: "#fcb9e9",
    300: "#F98EDB",
    500: "#E165BF",
    700: "#CF49AA",
    900: "#870062"
  },
  brown: {
    100: "#EEE0DA",
    200: "#DFCCC2",
    300: "#C4AB9E",
    500: "#93715D",
    700: "#73503B",
    900: "#45291F"
  },
  orange: {
    100: "#FFE3BB",
    200: "#FCCB80",
    300: "#FAB64D",
    500: "#F99702",
    700: "#EF7D00",
    900: "#4A2811"
  }
};
const mapColor = (palette, prefix2 = "") => {
  return Object.keys(palette).reduce((accum, color2) => {
    if (color2 === "current") {
      return accum;
    } else if (typeof palette[color2] === "string") {
      return {
        ...accum,
        [prefix2 ? color2 === "DEFAULT" ? prefix2 : `${prefix2}-${color2}` : color2]: palette[color2]
      };
    } else {
      return {
        ...accum,
        ...mapColor(palette[color2], color2)
      };
    }
  }, {});
};
const colors = mapColor(THEME_COLORS);
const getThemeColor = (color2, def = "") => colors[color2 ?? def];
const getInverseThemeColor = (hexCode) => {
  const themeColor = Object.keys(colors)[Object.values(colors).indexOf(hexCode)];
  const [color2, number2] = String(themeColor).split("-");
  const shade = Number(number2);
  if (shade) {
    if (shade > 500) {
      return getThemeColor(`${color2}-100`);
    } else {
      if (shade === 500 && (color2 === "red" || color2 === "blue" || color2 === "brown" || color2 === "purple" || color2 === "green")) {
        return "white";
      }
      return getThemeColor(`${color2}-900`);
    }
  }
  return color2 === "black" ? "white" : "black";
};
function useChart(children, options) {
  const [activeIndex, setActiveIndex] = React__default.useState();
  const [hiddenItems, toggleItem] = useChartDataHiddenState();
  const localization = useLocalization();
  const defaultFormatter2 = (value) => new Intl.NumberFormat(localization.locale, { minimumFractionDigits: 2 }).format(value);
  const globalFormatter = (options == null ? void 0 : options.formatter) ?? defaultFormatter2;
  const { items, shapes } = React__default.useMemo(() => {
    const items2 = React__default.Children.toArray(children).filter((child) => React__default.isValidElement(child)).map((child) => {
      const dataKey = child.props.dataKey ?? child.props.label;
      return {
        ...child.props,
        dataKey,
        color: getThemeColor(child.props.color, "blue-300"),
        formatter: child.props.formatter ?? globalFormatter,
        isHidden: !!hiddenItems[dataKey],
        unit: child.props.unit ?? (options == null ? void 0 : options.unit)
      };
    });
    const shapes2 = items2.filter((item) => !hiddenItems[item.dataKey]).map((item) => {
      return {
        activeDot: {
          strokeWidth: 1
        },
        color: item.color,
        dataKey: item.dataKey,
        dot: {
          fillOpacity: 0.8
        },
        isAnimationActive: false,
        fill: item.color,
        fillOpacity: 0.8,
        formatter: item.formatter,
        name: item.label,
        stroke: item.color,
        strokeWidth: 1.5,
        unit: item.unit
      };
    });
    return { items: items2, shapes: shapes2 };
  }, [children, hiddenItems]);
  return { items, shapes, activeIndex, setActiveIndex, globalFormatter, toggleItem };
}
function useChartDataHiddenState() {
  const [state, setState] = React__default.useState({});
  function toggle(name) {
    setState((currentState) => {
      const nextState = { ...currentState };
      if (currentState[name]) {
        delete nextState[name];
      } else {
        nextState[name] = true;
      }
      return nextState;
    });
  }
  return [state, toggle];
}
function AreaChart(props) {
  const {
    children,
    className: customClassName,
    data,
    showLegend = false,
    showDots = false,
    stacked = false,
    tooltipTitle,
    type = "natural",
    ...attributes
  } = stripCartesianProps(props);
  const className = clsx("relative aspect-video", { "pb-8": showLegend }, customClassName);
  const { items, shapes, activeIndex, setActiveIndex, toggleItem } = useChart(children);
  return /* @__PURE__ */ React__default.createElement("div", { className, "data-taco": "chart-wrapper" }, /* @__PURE__ */ React__default.createElement(ChartWrapper, { ...attributes, className: "h-full w-full", "data-taco": "chart-area" }, /* @__PURE__ */ React__default.createElement(
    AreaChart$1,
    {
      data,
      margin: {
        bottom: 0,
        // ensures dots on the edges of the chart don't get cropped
        left: 4,
        right: 4,
        top: 4
      },
      stackOffset: stacked === "expand" ? "expand" : void 0
    },
    /* @__PURE__ */ React__default.createElement(CartesianGrid, { vertical: false }),
    /* @__PURE__ */ React__default.createElement(Tooltip$1, { content: /* @__PURE__ */ React__default.createElement(Tooltip, { title: tooltipTitle }) }),
    /* @__PURE__ */ React__default.createElement(XAxis, { ...getAxisProps("x", props) }),
    /* @__PURE__ */ React__default.createElement(YAxis, { ...getAxisProps("y", props) }),
    shapes.map((shape) => /* @__PURE__ */ React__default.createElement(
      Area$1,
      {
        key: shape.dataKey,
        ...shape,
        dot: showDots ? shape.dot : false,
        fillOpacity: 0.4,
        stackId: stacked ? "stack" : void 0,
        type
      }
    ))
  )), showLegend ? /* @__PURE__ */ React__default.createElement(Legend$1, { items, hoverIndex: activeIndex, onHover: setActiveIndex, onToggle: toggleItem }) : null);
}
function Area(_) {
  return null;
}
AreaChart.Area = Area;
const BAR_WIDTH = 18;
function BarChart(props) {
  const {
    children,
    className: customClassName,
    data,
    orientation,
    showLabels = false,
    showLegend = false,
    stacked = false,
    tooltipTitle,
    ...attributes
  } = stripCartesianProps(props);
  const isHorizontal = props.orientation === "horizontal";
  const className = clsx("relative aspect-video", { "pb-8": showLegend }, customClassName);
  const { items, shapes, activeIndex, setActiveIndex, toggleItem } = useChart(children);
  return /* @__PURE__ */ React__default.createElement("div", { className, "data-taco": "chart-wrapper" }, /* @__PURE__ */ React__default.createElement(ChartWrapper, { ...attributes, className: "h-full w-full", "data-taco": "chart-bar" }, /* @__PURE__ */ React__default.createElement(
    BarChart$1,
    {
      data,
      barCategoryGap: "15%",
      barGap: "7.5%",
      margin: {
        bottom: 0,
        left: 0,
        right: 0,
        // ensures labels on top of bars don't get cropped
        top: isHorizontal ? 0 : 10
      },
      layout: isHorizontal ? "vertical" : void 0,
      stackOffset: stacked === "expand" ? "expand" : void 0
    },
    /* @__PURE__ */ React__default.createElement(CartesianGrid, { horizontal: !isHorizontal, vertical: false }),
    /* @__PURE__ */ React__default.createElement(Tooltip$1, { content: /* @__PURE__ */ React__default.createElement(Tooltip, { title: tooltipTitle }) }),
    /* @__PURE__ */ React__default.createElement(XAxis, { ...getAxisProps("x", props, isHorizontal) }),
    /* @__PURE__ */ React__default.createElement(YAxis, { ...getAxisProps("y", props, isHorizontal) }),
    shapes.map((shape, index2) => /* @__PURE__ */ React__default.createElement(
      Bar$1,
      {
        key: shape.dataKey,
        ...shape,
        activeBar: { fillOpacity: 1, strokeWidth: 0 },
        maxBarSize: BAR_WIDTH,
        radius: getRadius(index2, shapes.length, !!stacked, isHorizontal),
        stackId: stacked ? "stack" : void 0,
        strokeWidth: 0
      },
      showLabels ? /* @__PURE__ */ React__default.createElement(
        LabelList,
        {
          position: isHorizontal ? "insideRight" : "top",
          formatter: shape.formatter,
          offset: 6,
          fill: isHorizontal ? getInverseThemeColor(shape.color ?? "") : "black",
          fontSize: 11
        }
      ) : null
    ))
  )), showLegend ? /* @__PURE__ */ React__default.createElement(Legend$1, { items, hoverIndex: activeIndex, onHover: setActiveIndex, onToggle: toggleItem }) : null);
}
function getRadius(index2, length, stacked, isHorizontal) {
  if (stacked) {
    if (index2 === 0) {
      return isHorizontal ? [3, 0, 0, 3] : [0, 0, 3, 3];
    }
    if (index2 === length - 1) {
      return isHorizontal ? [0, 3, 3, 0] : [3, 3, 0, 0];
    }
    return 0;
  }
  return 3;
}
function Bar(_) {
  return null;
}
BarChart.Bar = Bar;
const PIE_ACTIVE_WIDTH = 10;
const PIE_ACTIVE_WIDTH_OFFSET = 2;
function usePieChart(children, options) {
  const { items, shapes, activeIndex, setActiveIndex, globalFormatter, toggleItem } = useChart(children, options);
  const [radius, _setRadius] = React__default.useState(0);
  function setRadius(width) {
    _setRadius((width - 2 * (PIE_ACTIVE_WIDTH + PIE_ACTIVE_WIDTH_OFFSET)) / 2);
  }
  const pieProps = {
    activeIndex,
    activeShape: (props) => /* @__PURE__ */ React__default.createElement(ActiveShape$1, { ...props }),
    children: shapes.map((shape) => /* @__PURE__ */ React__default.createElement(Cell, { key: shape.dataKey, color: shape.color, fill: shape.fill })),
    // data props
    data: items.filter((item) => !item.isHidden),
    dataKey: "value",
    nameKey: "label",
    // style props
    isAnimationActive: false,
    startAngle: 90,
    endAngle: -270,
    stroke: "0",
    labelLine: false,
    outerRadius: radius
  };
  return { pieProps, radius, setRadius, items, activeIndex, setActiveIndex, globalFormatter, toggleItem, shapes };
}
const PIE_CHART_HOVER = 10;
const PIE_CHART_HOVER_OFFSET = 2;
function ActiveShape$1(props) {
  const { outerRadius = 0, ...attributes } = props;
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Sector, { ...attributes, outerRadius }), /* @__PURE__ */ React__default.createElement(
    Sector,
    {
      ...attributes,
      innerRadius: outerRadius + PIE_CHART_HOVER_OFFSET,
      outerRadius: outerRadius + PIE_CHART_HOVER,
      opacity: 0.4
    }
  ));
}
const DONUT_WIDTH$1 = 20;
function DonutChart(props) {
  const { children, formatter, showLegend = false, showTotal = false, tooltipTitle, unit: unit2, ...attributes } = props;
  const { pieProps, radius, setRadius, items, activeIndex, setActiveIndex, globalFormatter, toggleItem } = usePieChart(
    children,
    {
      formatter,
      unit: unit2
    }
  );
  const className = clsx("aspect-square", attributes.className);
  return /* @__PURE__ */ React__default.createElement("div", { className: "relative", "data-taco": "chart-wrapper" }, /* @__PURE__ */ React__default.createElement(ChartWrapper, { ...attributes, className, "data-taco": "chart-donut", onSetWidth: setRadius }, /* @__PURE__ */ React__default.createElement(PieChart$1, null, /* @__PURE__ */ React__default.createElement(Tooltip$1, { content: /* @__PURE__ */ React__default.createElement(Tooltip, { title: tooltipTitle }) }), /* @__PURE__ */ React__default.createElement(Pie, { ...pieProps, innerRadius: radius - DONUT_WIDTH$1 }))), showTotal ? /* @__PURE__ */ React__default.createElement(
    Total,
    {
      formatter: globalFormatter,
      items,
      unit: unit2,
      style: { top: radius + DONUT_WIDTH$1 / 2, width: radius + DONUT_WIDTH$1 * 2 }
    }
  ) : null, showLegend ? /* @__PURE__ */ React__default.createElement(Legend$1, { items, hoverIndex: activeIndex, onHover: setActiveIndex, onToggle: toggleItem }) : null);
}
function Segment$2(_) {
  return null;
}
DonutChart.Segment = Segment$2;
function Total(props) {
  const { formatter, items, unit: unit2, ...attributes } = props;
  const total = React__default.useMemo(() => {
    const total2 = items.filter((item) => !item.isHidden).reduce((acc, curr) => acc + curr.value, 0);
    return formatter(total2);
  }, [items]);
  return /* @__PURE__ */ React__default.createElement(
    "div",
    {
      ...attributes,
      className: "absolute-center flex aspect-video flex-col items-center justify-center overflow-hidden rounded-full",
      "data-taco": "chart-donut-total"
    },
    /* @__PURE__ */ React__default.createElement(Tooltip$3, { title: total }, /* @__PURE__ */ React__default.createElement("span", { className: "w-full truncate text-center text-lg font-bold tabular-nums" }, total)),
    unit2 ? /* @__PURE__ */ React__default.createElement("span", { className: "text-grey-700 -mb-1 -mt-0.5 truncate text-xs" }, unit2) : null
  );
}
const Legend = ({ hoveredItem, selectedItem, data, onClick, setHoveredItem, formatter, total, label }) => {
  const isTotalLegendSelected = selectedItem.length === data.length;
  const isTotalLegendHovered = hoveredItem.length === data.length;
  const handleMouseLeave = () => setHoveredItem([]);
  const renderLegendItem = (entry, index2) => {
    const isTotal = entry === null;
    const itemData = entry === null ? { id: "total", label, value: total, color: "grey-300" } : entry;
    const isSelected = isTotal ? isTotalLegendSelected : selectedItem.includes(itemData.id);
    const isHovered = isTotal ? isTotalLegendHovered : hoveredItem.includes(itemData.id);
    return /* @__PURE__ */ React__default.createElement(
      "li",
      {
        key: isTotal ? "total" : `${itemData.label}-${index2}`,
        className: clsx("mr-2 flex cursor-pointer gap-2 rounded pl-0 pr-1", {
          "bg-grey-100": isHovered,
          "bg-grey-200": isSelected
        }),
        onClick: () => onClick(isTotal ? data : itemData),
        onMouseEnter: () => setHoveredItem(isTotal ? data.map((item) => item.id) : [itemData.id]),
        onMouseLeave: handleMouseLeave
      },
      /* @__PURE__ */ React__default.createElement("span", { className: "ml-1 mt-1 h-9 w-2 rounded-[1px]", style: { backgroundColor: getThemeColor(itemData.color) } }),
      /* @__PURE__ */ React__default.createElement("div", null, itemData.label, /* @__PURE__ */ React__default.createElement("span", { className: "-mt-1 flex w-full text-lg font-bold" }, formatter ? formatter(itemData.value) : itemData.value))
    );
  };
  return /* @__PURE__ */ React__default.createElement("div", { className: "flex-grow pl-4" }, /* @__PURE__ */ React__default.createElement("ul", { className: "mb-0 ml-0 mt-4 flex flex-col justify-center gap-1 space-y-1" }, renderLegendItem(null), data.map(renderLegendItem)));
};
const DONUT_WIDTH = 16;
const HOVER_DONUT_WIDTH = 10;
const CenteredLabel = ({ radius, label, total, formatter }) => {
  const totalInset = HOVER_DONUT_WIDTH + DONUT_WIDTH + DONUT_WIDTH;
  const diameter = radius * 2;
  return /* @__PURE__ */ React__default.createElement(
    "div",
    {
      className: "absolute mt-1 flex h-12 flex-col text-center",
      style: {
        top: `calc(${radius}px - (3rem / 2))`,
        // h-12 is 3rem
        left: `${totalInset}px`,
        width: `${diameter - 2 * totalInset}px`
      }
    },
    /* @__PURE__ */ React__default.createElement("span", { className: "w-full truncate text-lg font-bold" }, formatter ? formatter(total) : total),
    label
  );
};
const ActiveShape = (props) => {
  const { cx, cy, id: id2, innerRadius, onClick, outerRadius = 0, pieColors, startAngle, endAngle, fill } = props;
  return /* @__PURE__ */ React__default.createElement("g", { onClick: () => onClick(id2), className: clsx({ "cursor-pointer": !!onClick }) }, /* @__PURE__ */ React__default.createElement(
    Sector,
    {
      cx,
      cy,
      innerRadius,
      outerRadius,
      startAngle,
      endAngle,
      fill
    }
  ), /* @__PURE__ */ React__default.createElement(
    Sector,
    {
      cx,
      cy,
      startAngle,
      endAngle,
      innerRadius: outerRadius + 2,
      outerRadius: outerRadius + HOVER_DONUT_WIDTH,
      fill: id2 !== void 0 ? getThemeColor(pieColors[id2], "blue-500") : getThemeColor("blue-500"),
      opacity: 0.4
    }
  ));
};
const Segment$1 = (_) => null;
const LegacyDonutChart = function LegacyDonutChart2({ children, formatter, onClick, label }) {
  const ref = React__default.useRef(null);
  const [radius, setRadius] = React__default.useState(0);
  const [hoveredItem, setHoveredItem] = React__default.useState([]);
  const [selectedItem, setSelectedItem] = React__default.useState([]);
  React__default.useEffect(() => {
    var _a;
    if (ref.current) {
      const rect = (_a = ref.current.parentElement) == null ? void 0 : _a.getBoundingClientRect();
      if (rect) {
        const width = rect.width / 2;
        const max2 = rect.height < width ? rect.height : width;
        setRadius(max2 / 2);
      }
    }
  }, [ref.current]);
  const diameter = radius * 2;
  const data = React__default.Children.map(children, (child) => ({
    id: child.props.id,
    color: child.props.color,
    label: child.props.label,
    value: child.props.value
  }));
  const total = data.reduce((accum, entry) => accum + entry.value, 0);
  const handleLegendClick = (entry) => {
    const nextSelectedItem = Array.isArray(entry) ? entry.map((entryItem) => entryItem.id) : [entry.id];
    const isCurrentSegmentActive = selectedItem.slice().sort().join(",") === nextSelectedItem.sort().join(",");
    if (onClick && !isCurrentSegmentActive) {
      onClick(entry);
    }
    setSelectedItem(isCurrentSegmentActive ? [] : nextSelectedItem);
  };
  const handlePieClick = React__default.useCallback(
    (pieId) => {
      if (onClick && pieId !== void 0) {
        const pieProps = data.find((item) => item.id === pieId);
        onClick(pieProps);
      }
    },
    [onClick, data]
  );
  const activeShapeColor = React__default.useMemo(() => {
    const getSegmentColor = (item) => item.reduce((colors2, itemId) => {
      const visibleHoveredItem = data.find((dataItem) => dataItem.id === itemId);
      if (visibleHoveredItem) {
        colors2[visibleHoveredItem.id] = visibleHoveredItem.color;
      }
      return colors2;
    }, {});
    const hoveredSegmentColor = getSegmentColor(hoveredItem);
    const selectedSegmentColor = getSegmentColor(selectedItem);
    return hoveredItem.length !== 0 ? hoveredSegmentColor : selectedSegmentColor;
  }, [hoveredItem, selectedItem]);
  if (ref.current && !radius) {
    return null;
  }
  const getActiveIndex = () => {
    if (hoveredItem.length > 0) {
      return hoveredItem.map((itemId) => data.findIndex((element) => element.id === itemId));
    }
    return selectedItem.map((selectedItemId) => data.findIndex((element) => element.id === selectedItemId));
  };
  const content = () => {
    const elements = React__default.Children.toArray(children).filter(
      (child) => React__default.isValidElement(child)
    );
    return elements.length > 0 ? elements.map((child, index2) => {
      return /* @__PURE__ */ React__default.createElement(
        Cell,
        {
          key: `cell-${index2}`,
          name: child.props.label,
          fill: getThemeColor(child.props.color) ?? getThemeColor("blue-300")
        }
      );
    }) : /* @__PURE__ */ React__default.createElement(Cell, { key: "empty-chart", name: "", fill: getThemeColor("grey-200") });
  };
  return /* @__PURE__ */ React__default.createElement("div", { className: "relative flex h-full w-full", ref }, /* @__PURE__ */ React__default.createElement(CenteredLabel, { radius, label, total, formatter }), /* @__PURE__ */ React__default.createElement(PieChart$1, { data, height: diameter, width: diameter, style: { transform: "rotate(90deg) scale(-1,1)" } }, /* @__PURE__ */ React__default.createElement(
    Pie,
    {
      isAnimationActive: false,
      activeIndex: getActiveIndex(),
      activeShape: /* @__PURE__ */ React__default.createElement(ActiveShape, { pieColors: activeShapeColor, onClick: handlePieClick }),
      data: data.length > 0 ? data : [],
      dataKey: "value",
      innerRadius: radius - HOVER_DONUT_WIDTH - DONUT_WIDTH,
      onMouseEnter: (segment) => data.length > 0 && setHoveredItem([segment.id]),
      onMouseLeave: () => setHoveredItem([]),
      outerRadius: radius - HOVER_DONUT_WIDTH,
      paddingAngle: 2.5,
      stroke: "0",
      rootTabIndex: -1
    },
    content()
  )), /* @__PURE__ */ React__default.createElement(
    Legend,
    {
      data,
      onClick: handleLegendClick,
      total,
      setHoveredItem,
      label,
      hoveredItem,
      selectedItem,
      formatter
    }
  ));
};
LegacyDonutChart.Segment = Segment$1;
function LineChart(props) {
  const {
    children,
    className: customClassName,
    data,
    showLegend = false,
    showDots = false,
    tooltipTitle,
    type = "natural",
    ...attributes
  } = stripCartesianProps(props);
  const className = clsx("relative aspect-video", { "pb-8": showLegend }, customClassName);
  const { items, shapes, activeIndex, setActiveIndex, toggleItem } = useChart(children);
  return /* @__PURE__ */ React__default.createElement("div", { className, "data-taco": "chart-wrapper" }, /* @__PURE__ */ React__default.createElement(ChartWrapper, { ...attributes, className: "h-full w-full", "data-taco": "chart-line" }, /* @__PURE__ */ React__default.createElement(
    LineChart$1,
    {
      data,
      margin: {
        bottom: 0,
        // ensures dots on the edges of the chart don't get cropped
        left: 4,
        right: 4,
        top: 4
      }
    },
    /* @__PURE__ */ React__default.createElement(CartesianGrid, { vertical: false }),
    /* @__PURE__ */ React__default.createElement(Tooltip$1, { content: /* @__PURE__ */ React__default.createElement(Tooltip, { title: tooltipTitle }) }),
    /* @__PURE__ */ React__default.createElement(XAxis, { ...getAxisProps("x", props) }),
    /* @__PURE__ */ React__default.createElement(YAxis, { ...getAxisProps("y", props) }),
    shapes.map((shape) => /* @__PURE__ */ React__default.createElement(Line$1, { key: shape.dataKey, ...shape, dot: showDots ? shape.dot : false, type }))
  )), showLegend ? /* @__PURE__ */ React__default.createElement(Legend$1, { items, hoverIndex: activeIndex, onHover: setActiveIndex, onToggle: toggleItem }) : null);
}
function Line(_) {
  return null;
}
LineChart.Line = Line;
function PieChart(props) {
  const { children, formatter, showLabels = false, showLegend = false, tooltipTitle, unit: unit2, ...attributes } = props;
  const { pieProps, setRadius, items, activeIndex, setActiveIndex, toggleItem } = usePieChart(children, {
    formatter,
    unit: unit2
  });
  const className = clsx("aspect-square", attributes.className);
  return /* @__PURE__ */ React__default.createElement("div", { className: "relative", "data-taco": "chart-wrapper" }, /* @__PURE__ */ React__default.createElement(ChartWrapper, { ...attributes, className, "data-taco": "chart-pie", onSetWidth: setRadius }, /* @__PURE__ */ React__default.createElement(PieChart$1, null, /* @__PURE__ */ React__default.createElement(Tooltip$1, { content: /* @__PURE__ */ React__default.createElement(Tooltip, { title: tooltipTitle }) }), /* @__PURE__ */ React__default.createElement(Pie, { ...pieProps, label: showLabels ? /* @__PURE__ */ React__default.createElement(Label, null) : void 0 }))), showLegend ? /* @__PURE__ */ React__default.createElement(Legend$1, { items, hoverIndex: activeIndex, onHover: setActiveIndex, onToggle: toggleItem }) : null);
}
function Segment(_) {
  return null;
}
PieChart.Segment = Segment;
const RADIAN = Math.PI / 180;
function Label(props) {
  var _a, _b;
  const { cx, cy, midAngle, name, innerRadius, outerRadius } = props;
  const radius = innerRadius + (outerRadius - innerRadius) * 0.7;
  const x3 = cx + radius * Math.cos(-midAngle * RADIAN);
  const y4 = cy + radius * Math.sin(-midAngle * RADIAN);
  return /* @__PURE__ */ React__default.createElement(
    "text",
    {
      x: x3,
      y: y4,
      fontSize: 12,
      fill: getInverseThemeColor(((_b = (_a = props.payload) == null ? void 0 : _a.payload) == null ? void 0 : _b.color) ?? ""),
      textAnchor: "middle",
      dominantBaseline: "middle"
    },
    name
  );
}
const Button4 = React__default.forwardRef(function Button23(props, ref) {
  const { ...attributes } = props;
  const className = clsx(getButtonClasses(), props.className);
  return /* @__PURE__ */ React__default.createElement(IconButton, { ...attributes, appearance: "discrete", className, "data-taco": "header-button", ref });
});
const getButtonClasses = (rounded = true) => clsx(
  "!h-9 !w-9 flex-shrink-0 flex-grow-0 cursor-pointer relative",
  "focus:!outline-none focus:!shadow-none focus-visible:!yt-focus-dark ",
  "bg-transparent enabled:hover:bg-white/[.08] focus:bg-white/[.08] aria-current-page:bg-white/[.08]",
  "text-white",
  {
    "!rounded-full": rounded
  }
);
const Link$1 = React__default.forwardRef(function Link22(props, ref) {
  const { children, icon, isNew, tooltip, ...otherProps } = props;
  const { texts } = useLocalization();
  const className = clsx(getLinkClasses(icon), "relative", props.className);
  const link = /* @__PURE__ */ React__default.createElement("a", { ...otherProps, className, "data-taco": "header-link", ref, tabIndex: 0 }, icon ? /* @__PURE__ */ React__default.createElement(Icon$1, { name: icon }) : null, children, isNew ? /* @__PURE__ */ React__default.createElement(
    Badge2,
    {
      color: "blue",
      small: true,
      className: "absolute right-0 top-0 -mr-2.5 -mt-1.5 !h-3 !px-0.5 text-[0.55rem] font-normal"
    },
    texts.header.new
  ) : null);
  if (tooltip) {
    return /* @__PURE__ */ React__default.createElement(Tooltip$3, { title: tooltip }, link);
  }
  return link;
});
const getLinkClasses = (icon = void 0) => clsx(
  "flex h-8 flex-shrink-0 flex-grow-0 cursor-pointer items-center justify-center ",
  "focus:!shadow-none focus:!outline-none focus-visible:!yt-focus-dark",
  "bg-transparent hover:bg-white/[.08] focus:bg-white/[.08] aria-current-page:bg-white/[.08]",
  "text-white hover:text-white focus:text-white",
  {
    "!rounded-full !h-9 !w-9": icon,
    "whitespace-nowrap px-3 rounded text-sm hidden lg:flex": !icon
  }
);
const Logo = React__default.forwardRef(function Logo2(props, ref) {
  const className = clsx("h-7 w-7 m-1 self-center justify-self-center flex-shrink-0 flex-grow-0", props.className);
  return /* @__PURE__ */ React__default.createElement("svg", { ...props, className, ref, viewBox: "0 0 28 28", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React__default.createElement("g", { className: "fill-brand-sunsetOrange" }, /* @__PURE__ */ React__default.createElement("path", { d: "M3.2496172 16.0366c-1.44938-.2893-2.857854.6517-3.1442248 2.1011-.2863702 1.4493.6516388 2.8578 2.1010248 3.1442 1.44938.2893 2.85786-.6517 3.14423-2.101.28929-1.4465-.65164-2.855-2.10103-3.1443z" }), /* @__PURE__ */ React__default.createElement("path", { d: "M18.9911672 19.1692c-2.4137-.4792-4.7602 1.0871-5.2423 3.5037-.4793 2.4137 1.087 4.7602 3.5036 5.2423 2.4137.4793 4.7602-1.087 5.2424-3.5036.4792-2.4166-1.0871-4.7631-3.5037-5.2424z" }), /* @__PURE__ */ React__default.createElement("path", { d: "M23.6958672.105135c-2.8988-.578585-5.7157 1.303275-6.2943 4.199125l-.5172 2.62116c-.3828 1.93446-2.2647 3.19098-4.1992 2.80819l-1.7474-.35651c-1.92569-.3828-3.18221-2.25589-2.79941-4.19035l.08766-.43832c.33021-1.68608-.7656-3.33417-2.45168-3.66438-1.69776-.336043-3.33709.75976-3.67606 2.45461-.33897 1.68607.76561 3.3254 2.45168 3.66437l.43833.09058c1.93446.3828 3.19098 2.26467 2.79941 4.19039l-.16948.8737c-.3828 1.9345.87372 3.8163 2.79945 4.1991 1.9344.3828 3.8163-.8737 4.1991-2.8082l.1695-.8737c.3828-1.9257 2.2646-3.1822 4.1903-2.7994l2.63.526c2.8987.5698 5.7157-1.31206 6.2855-4.20791.5844-2.90169-1.2974-5.718636-4.1962-6.288455z" })));
});
const LogoLegacy = React__default.forwardRef(function Logo3(props, ref) {
  const className = clsx("-mr-[156px] xs:-mr-14 md:!mr-0 h-9 shrink-0 w-[180px] px-1", props.className);
  return /* @__PURE__ */ React__default.createElement("svg", { ...props, className, ref, viewBox: "0 0 127 13", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React__default.createElement("g", { className: "fill-white" }, /* @__PURE__ */ React__default.createElement(
    "path",
    {
      className: "fill-white",
      d: "M5.716016 1.34924242c3.029712.25015152 6.374384 1.74121213 8.2804 3.86060606 2.4384 2.71227273 1.603248 5.42454542-1.877568 6.05681822-3.480816.6322727-8.2804-1.0498485-10.720832-3.76212125C-.471424 5.42848485-.41656 3.35242424 1.27 2.2080303l9.67232 6.92742425-5.226304-7.78621213z",
      fillRule: "nonzero"
    }
  ), /* @__PURE__ */ React__default.createElement("g", { className: "hidden md:flex" }, /* @__PURE__ */ React__default.createElement(
    "path",
    {
      d: "M53.67528 11.2509091l-1.2192-4.72727274c-.176784-.56333333-.24384-1.12666666-.36576-1.6880303h-.026416c-.107696.57515152-.148336 1.13848485-.308864 1.71363636l-1.22936 4.70954548h-2.101088l2.822448-9.87409093h1.647952l2.942336 9.86424243-2.162048.0019697z",
      fillRule: "nonzero"
    }
  ), /* @__PURE__ */ React__default.createElement(
    "path",
    {
      d: "M21.553424 1.38469697l1.2192 4.72727273c.174752.56333333.241808 1.12469697.363728 1.6880303h.026416c.107696-.57515152.148336-1.13848485.310896-1.71363636l1.2192-4.70954546h2.105152L23.9776 11.2410606h-1.64592l-2.938272-9.85636363h2.160016z",
      fillRule: "nonzero"
    }
  ), /* @__PURE__ */ React__default.createElement("path", { fillRule: "nonzero", d: "M28.313888 1.38666667h2.01168v9.86424243h-2.01168z" }), /* @__PURE__ */ React__default.createElement(
    "path",
    {
      fillRule: "nonzero",
      d: "M41.694608 1.38666667l.983488 5.82045454h.026416l.808736-5.82045454h2.700528l1.0668 9.86424243h-2.064512l-.485648-7.10469698h-.028448l-.323088 2.43257576-.865632 4.67212122h-1.550416l-.98552-4.72333334L40.64 4.32939394v-.18318182h-.026416l-.296672 7.10469698h-2.160016l.890016-9.86424243z"
    }
  ), /* @__PURE__ */ React__default.createElement(
    "path",
    {
      d: "M35.310064 1.38469697c-.3577988.27917284-.6303655.64756811-.788416 1.06560606-.526288 1.22909091.036576 2.16666667.534416 3.00575758.073152.12409091.148336.24818181.217424.37227272 1.085088 1.80424243 1.515872 3.13378788.705104 5.02863637-.056896.1339394-.191008.3939394-.191008.3939394h-2.424176c.3204254-.2482168.5741848-.5678542.739648-.9316667.556768-1.30196967-.099568-2.49166664-.735584-3.64393937-.764032-1.37878788-1.552448-2.81863636-.715264-4.78045455.079248-.18712121.254-.50424242.254-.50424242l2.403856-.00590909z",
      fillRule: "nonzero"
    }
  ))), /* @__PURE__ */ React__default.createElement("g", { className: "xs:flex xs:-translate-x-[40px] hidden md:!translate-x-0" }, /* @__PURE__ */ React__default.createElement("path", { className: "stroke-white", d: "M61.496448 0v12.8680303", strokeWidth: "1.68" }), /* @__PURE__ */ React__default.createElement("g", { className: "fill-white" }, /* @__PURE__ */ React__default.createElement(
    "path",
    {
      d: "M70.841616 9.70863636c-.999744 0-1.7888373-.29479798-2.36728-.88439394-.5784427-.58959596-.867664-1.40964646-.867664-2.46015151 0-1.05707071.2709333-1.89681818.8128-2.51924243.5304376-.61728629 1.3256457-.96197654 2.15392-.93363636.7626734-.03509605 1.5014967.26264579 2.013712.81151515.4944533.53969697.7410027 1.25272728.739648 2.13909091v.62833334h-4.659376c.022352.77015151.221488 1.35318181.6096 1.7530303.388112.39984848.916432.59090909 1.607312.59090909.743701-.00293405 1.4788698-.15377248 2.160016-.44318182v.88636364c-.3298144.14174433-.6736336.25063692-1.02616.325-.3855929.07188992-.7778273.1048941-1.170432.09848485m-.27432-5.95242425c-.4900374-.02138848-.9649513.16736328-1.298448.51606061-.3477231.40033357-.5485505.90121019-.570992 1.42409091h3.53568c0-.62636364-.14224-1.1069697-.430784-1.43984849-.3103282-.34233825-.7661196-.52691285-1.235456-.50030303",
      fillRule: "nonzero"
    }
  ), /* @__PURE__ */ React__default.createElement(
    "path",
    {
      d: "M75.053952 6.25575758c-.0151689-.21657791.0536783-.43083638.19304-.60075758.1381463-.1429001.3347885-.21871211.536448-.20681818.2081607-.01140173.4114497.0638378.5588.20681818.2680858.35762602.2680858.84191943 0 1.19954545-.3018073.26987298-.7638609.27916874-1.07696.02166667-.1529999-.17086259-.2265151-.39533511-.2032-.62045454",
      fillRule: "nonzero"
    }
  ), /* @__PURE__ */ React__default.createElement(
    "path",
    {
      d: "M81.586832 9.70863636c-.979424 0-1.73736-.29217171-2.273808-.87651515-.536448-.58434343-.8073813-1.41095959-.8128-2.47984848 0-1.09777778.2709333-1.94540404.8128-2.54287879.5418667-.59747475 1.318768-.89686869 2.330704-.89818182.3279782-.00003668.654999.03430434.97536.10242424.2639542.04817256.5206342.12824173.764032.23833334l-.31496.845c-.2397537-.0929503-.4871838-.16608946-.739648-.21863637-.2330197-.05435362-.4715521-.08342113-.7112-.08666666-1.373632 0-2.060448.84959596-2.060448 2.54878788 0 .80494949.1673013 1.42343434.501904 1.85545454.33528.42939394.83312.64606061 1.491488.64606061.5966181-.00678768 1.1861142-.12655871 1.735328-.35257576v.87848485c-.5339642.24467285-1.120715.3615322-1.710944.34075757",
      fillRule: "nonzero"
    }
  ), /* @__PURE__ */ React__default.createElement(
    "path",
    {
      d: "M90.690192 6.30893939c0 1.06757576-.278384 1.90207071-.835152 2.50348485-.556768.60141414-1.3241867.90146465-2.302256.90015152-.5660565.00980534-1.1238362-.13269357-1.611376-.41166667-.4744234-.28111893-.8520726-.69243374-1.085088-1.18181818-.2674171-.5661279-.3987341-1.18372355-.384048-1.80621212 0-1.06888889.2756747-1.90207071.827024-2.49954546.5513493-.59747474 1.316736-.89555555 2.29616-.89424242.8559447-.03726298 1.6841715.29875604 2.257552.91590909.556768.61060606.8358293 1.43656566.837184 2.47787879m-5.155184 0c0 .83777778.17272 1.47595959.51816 1.91454545.34544.43858586.85344.65787879 1.524.65787879s1.1799147-.21863636 1.528064-.65590909.522224-1.07611111.522224-1.91651515c0-.83515152-.1740747-1.46873738-.522224-1.90075758-.3481493-.4320202-.861568-.64868687-1.540256-.65-.67056 0-1.176528.21469697-1.517904.64015152-.341376.42545454-.512064 1.06363636-.512064 1.91060606",
      fillRule: "nonzero"
    }
  ), /* @__PURE__ */ React__default.createElement(
    "path",
    {
      d: "M96.989392 9.58848485V5.34575758c0-.53444445-.1253067-.9329798-.37592-1.19560606-.251968-.2639394-.644144-.3939394-1.180592-.3939394-.707136 0-1.225296.18580808-1.55448.55742424-.329184.37161617-.493776.98419192-.493776 1.83772728v3.43909091h-1.02616V3.03136364h.83312l.168656.89621212h.048768c.213947-.32669621.5199877-.58712571.881888-.75045455.3956439-.18075251.8285923-.27169306 1.265936-.26590909.8128 0 1.4257867.19040404 1.83896.57121212.4131733.38080808.6163733.99010101.6096 1.82787879v4.27818182h-1.016z",
      fillRule: "nonzero"
    }
  ), /* @__PURE__ */ React__default.createElement(
    "path",
    {
      d: "M105.759504 6.30893939c0 1.06757576-.277707 1.90207071-.83312 2.50348485-.555413.60141414-1.322832.90146465-2.302256.90015152-.566147.01053143-1.124127-.1320188-1.611376-.41166667-.474546-.2815508-.852738-.69268701-1.08712-1.18181818-.2666505-.56630799-.397268-1.18388155-.382016-1.80621212 0-1.06888889.2756747-1.90207071.827024-2.49954546.551349-.59747474 1.316736-.89555555 2.29616-.89424242.948267 0 1.700107.30530303 2.25552.91590909.555413.61060606.834475 1.43525253.837184 2.47393939m-5.155184 0c0 .83777778.17272 1.4759596.51816 1.91454546.34544.43924242.855472.65787879 1.526032.65787879.589088.03526465 1.159066-.20939357 1.528064-.65590909.348149-.43727273.521547-1.07611112.520192-1.91651516-.001355-.84040404-.174752-1.4739899-.520192-1.90075757-.349504-.43333334-.861568-.65-1.540256-.65-.678688 0-1.17856.21469697-1.519936.64015151-.341376.42545455-.512064 1.06363637-.512064 1.91060606",
      fillRule: "nonzero"
    }
  ), /* @__PURE__ */ React__default.createElement(
    "path",
    {
      d: "M116.1796 9.58848485V5.32409091c0-.52525253-.115147-.91919192-.34544-1.18181818-.229616-.26-.58928-.3939394-1.074928-.3939394-.635339 0-1.109472.1779293-1.4224.53378788-.312928.35585859-.465328.90212121-.4572 1.63878788v3.66166667h-1.016V5.32409091c0-.52525253-.115824-.91919192-.347472-1.18181818-.229616-.26-.58928-.3939394-1.078992-.3939394-.642112 0-1.113536.1969697-1.410208.55939394-.296672.36242425-.449072.98484849-.449072 1.83575758v3.43909091h-1.016V3.03136364h.83312l.166624.89621212h.0508c.192326-.31859024.474248-.57752095.8128-.74651515.36534-.18279258.771528-.27547583 1.182624-.26984849 1.05664 0 1.748197.3709596 2.074672 1.11287879h.048768c.20551-.34688729.509496-.62924665.875792-.81348485.403616-.20402984.853472-.30695163 1.308608-.29939394.765387 0 1.338411.19040404 1.719072.57121212.380661.38080808.570992.99010101.570992 1.82787879v4.27818182h-1.02616z",
      fillRule: "nonzero"
    }
  ), /* @__PURE__ */ React__default.createElement(
    "path",
    {
      d: "M119.16664 1.25272727c-.016875-.18221767.045768-.36295537.17272-.49833333.243232-.21393452.614272-.21393452.857504 0 .129279.13353172.194239.31385023.178816.49636364.015568.18371514-.049334.36530074-.178816.50030303-.240531.22061195-.616973.22061195-.857504 0-.125769-.13683457-.188192-.31765204-.17272-.50030303v.00196969zm1.111504 8.33378788h-1.02616V3.03136364h1.02616v6.55515151z",
      fillRule: "nonzero"
    }
  ), /* @__PURE__ */ React__default.createElement(
    "path",
    {
      d: "M125.091952 9.70863636c-.979424 0-1.738037-.29217171-2.27584-.87651515-.537803-.58434343-.808736-1.41095959-.8128-2.47984848 0-1.09777778.270933-1.94540404.8128-2.54287879.541867-.59747475 1.318768-.89686869 2.330704-.89818182.327978-.00003668.654999.03430434.97536.10242424.264596.04821437.521943.12827865.766064.23833334l-.31496.845c-.239852-.09267891-.487258-.16581103-.739648-.21863637-.233047-.05421-.471563-.08327549-.7112-.08666666-1.373632 0-2.061125.84959596-2.06248 2.54878788 0 .80494949.167979 1.42343434.503936 1.85545454.33528.42939394.83312.64606061 1.491488.64606061.595961-.00679074 1.184792-.12656681 1.733296-.35257576v.87848485c-.533172.24487796-1.119318.3617557-1.708912.34075757",
      fillRule: "nonzero"
    }
  ))));
});
const PrimaryNavigation = React__default.forwardRef(function PrimaryNavigation2(props, ref) {
  const { texts } = useLocalization();
  const internalRef = useMergedRef(ref);
  const className = clsx(
    "flex h-full w-full flex-grow items-center overflow-hidden active:outline-none relative",
    props.className
  );
  const moreButton = () => /* @__PURE__ */ React__default.createElement(Button$4, { className: clsx(getLinkClasses(), "!bg-transparent aria-expanded:!bg-white/[.08]") }, texts.header.more);
  return /* @__PURE__ */ React__default.createElement("nav", { ...props, className, ref: internalRef }, /* @__PURE__ */ React__default.createElement(OverflowGroup, { className: "h-full flex-grow items-center gap-1 px-1", moreButton }, props.children));
});
const SecondaryNavigation = React__default.forwardRef(function SecondaryNavigation2(props, ref) {
  const className = clsx("flex h-full items-center gap-2 mb-0 flex-shrink-0 mr-2", props.className);
  return /* @__PURE__ */ React__default.createElement("div", { ...props, className, ref });
});
const MenuButton = React__default.forwardRef(function MenuButton2(props, ref) {
  const className = clsx(
    getButtonClasses(false),
    "mr-1 !bg-transparent hover:!bg-white/[.08] focus:!bg-white/[.08]] lg:hidden z-[2] !text-white"
  );
  return /* @__PURE__ */ React__default.createElement(IconButton, { ...props, className, "data-taco": "header-toggle-sidebar", icon: "menu", ref });
});
const AgreementAvatar = React__default.forwardRef(function AgreementAvatar2(props, ref) {
  const { src, fallbackSrc, ...otherProps } = props;
  const [loaded, setLoaded] = React__default.useState(false);
  const handleLoad = () => setLoaded(true);
  const handleError = (event) => {
    event.target.src = fallbackSrc;
  };
  const className = clsx(
    "h-9 w-9 rounded-full shrink-0 group-focus:yt-focus-dark xl:group-focus:shadow-none",
    {
      visible: loaded
    },
    props.className
  );
  return /* @__PURE__ */ React__default.createElement("img", { ...otherProps, className, src, onLoad: handleLoad, onError: handleError, ref });
});
const AgreementBadge = ({ agreement, ...props }) => {
  if (agreement.isAdministrator) {
    return /* @__PURE__ */ React__default.createElement(Badge2, { ...props, color: "blue", small: true }, "Admin");
  } else if (agreement.isDeveloper) {
    return /* @__PURE__ */ React__default.createElement(Badge2, { ...props, color: "blue", small: true }, "Developer");
  }
  return null;
};
const AgreementItem = (props) => {
  const { children, className: customClassName, fallbackImageSrc, ...agreement } = props;
  const className = clsx("w-full rounded flex px-2 gap-2 overflow-hidden text-left items-center", customClassName);
  return /* @__PURE__ */ React__default.createElement("span", { className }, /* @__PURE__ */ React__default.createElement(
    AgreementAvatar,
    {
      fallbackSrc: fallbackImageSrc,
      src: agreement.imageSrc,
      title: `${agreement.name} - ${agreement.number} ${agreement.userId}`
    }
  ), /* @__PURE__ */ React__default.createElement("span", { className: "flex flex-col overflow-hidden" }, /* @__PURE__ */ React__default.createElement("span", { className: "flex truncate text-white", title: agreement.name }, /* @__PURE__ */ React__default.createElement("span", { className: "truncate" }, agreement.name), " ", agreement.secure ? /* @__PURE__ */ React__default.createElement(Icon$1, { name: "secure-tick", className: "mb-0.5 ml-1 mt-0.5 !h-4 !w-4 flex-shrink-0 flex-grow-0" }) : null), /* @__PURE__ */ React__default.createElement("span", { className: "text-grey-100 whitespace-nowrap text-xs" }, agreement.number, " ", agreement.userId, " ", /* @__PURE__ */ React__default.createElement(AgreementBadge, { agreement }))), children);
};
const AgreementDisplay$1 = (props) => {
  const { children, currentAgreement, fallbackImageSrc } = props;
  const isXlScreen = useMatchMedia("(min-width: 1280px)", window.innerWidth > 1280);
  if (isXlScreen) {
    const className = clsx("h-12 flex-grow xl:[button>&]:hover:bg-white/[0.16]", props.className);
    return /* @__PURE__ */ React__default.createElement(AgreementItem, { ...currentAgreement, children, className, fallbackImageSrc });
  }
  return /* @__PURE__ */ React__default.createElement("span", { className: "relative flex h-12 flex-grow items-center pr-2" }, /* @__PURE__ */ React__default.createElement(
    AgreementAvatar,
    {
      fallbackSrc: fallbackImageSrc,
      src: currentAgreement.imageSrc,
      title: `${currentAgreement.name} - ${currentAgreement.number} ${currentAgreement.userId}`
    }
  ), /* @__PURE__ */ React__default.createElement(AgreementBadge, { agreement: currentAgreement, className: "absolute right-0 top-0 -mr-1 w-8 !justify-start" }));
};
const Container = (props) => {
  return /* @__PURE__ */ React__default.createElement(
    "div",
    {
      className: "-ml-2 flex flex-shrink-0 flex-grow-0 items-center gap-2 pr-2 xl:ml-auto xl:w-64",
      "data-taco": "header-agreements"
    },
    /* @__PURE__ */ React__default.createElement("span", { className: "hidden h-8 w-px flex-shrink-0 flex-grow-0 bg-white/[0.3] xl:flex" }),
    props.children
  );
};
function AgreementSelector(props) {
  const {
    agreements,
    currentAgreement,
    fallbackImageSrc,
    filterAgreement = () => true,
    filterClientAgreement = () => true,
    onAddAgreement: handleAddAgreement,
    onChangeAgreement,
    onLogout: handleLogout,
    open: prop,
    setOpen: onChange
  } = props;
  const { texts } = useLocalization();
  const collectionRef = React__default.useRef(null);
  const [open, setOpen] = $71cd76cc60e0454e$export$6f32135080cb4c3$1({
    onChange,
    prop
  });
  const [search, setSearch] = React__default.useState("");
  React__default.useEffect(() => {
    setSearch("");
  }, [open]);
  const handleKeyDown = (event) => {
    var _a;
    if (event.key === "ArrowDown" || event.key === "ArrowUp" || event.key === "Enter") {
      event.preventDefault();
      (_a = collectionRef.current) == null ? void 0 : _a.dispatchEvent(createCustomKeyboardEvent(event));
    }
  };
  const handleChangeAgreement = (agreement) => {
    onChangeAgreement(agreement);
    setOpen(false);
  };
  return /* @__PURE__ */ React__default.createElement(Container, null, /* @__PURE__ */ React__default.createElement($cb5cc270b50c6fcd$export$be92b6f5f03c0fe9, { open, onOpenChange: setOpen }, /* @__PURE__ */ React__default.createElement($cb5cc270b50c6fcd$export$41fb9f06171c75f4, { className: "xl:focus-visible:yt-focus-dark [&:focus-visible_img]:yt-focus-dark w-full rounded outline-none xl:[&:focus-visible_img]:shadow-none" }, /* @__PURE__ */ React__default.createElement(AgreementDisplay$1, { currentAgreement, fallbackImageSrc }, agreements ? /* @__PURE__ */ React__default.createElement(
    Icon$1,
    {
      className: "ml-auto hidden flex-shrink-0 flex-grow-0 text-white xl:flex",
      name: open ? "chevron-up" : "chevron-down"
    }
  ) : null)), /* @__PURE__ */ React__default.createElement($cb5cc270b50c6fcd$export$7c6e2c02157bb7d2, { className: "z-[996] mt-2 flex h-[calc(100vh_-_theme(spacing.16))] w-64 flex-col gap-1 bg-blue-900" }, /* @__PURE__ */ React__default.createElement(
    SearchInput,
    {
      autoFocus: true,
      className: "focus-visible:!yt-focus-dark mx-2 !border-transparent !bg-white/[0.08] !text-white hover:!bg-white/[0.16] hover:!shadow-none focus:!bg-white/[0.16] active:!bg-white/[0.16] [&+div>button]:!text-white",
      onChange: (event) => setSearch(event.target.value),
      onKeyDown: handleKeyDown,
      placeholder: texts.header.search
    }
  ), /* @__PURE__ */ React__default.createElement(
    Root$1,
    {
      querySelector: "button",
      className: "-my-1 flex w-full flex-grow flex-col gap-1 overflow-auto px-2 py-1 outline-none",
      ref: collectionRef,
      tabIndex: -1
    },
    agreements == null ? void 0 : agreements.filter((agreement) => filterAgreement(agreement, filterBySearchValue(search))).map((agreement) => {
      const button = createAgreementButton(
        agreement,
        fallbackImageSrc,
        handleChangeAgreement,
        isCurrentAgreement(agreement, currentAgreement)
      );
      if (agreement.clients) {
        return /* @__PURE__ */ React__default.createElement(
          "span",
          {
            className: "flex flex-col gap-px [&>*:first-child>span]:!rounded-t [&>*:last-child>span]:!rounded-b [&>*>span]:!rounded-none",
            key: `${agreement.number}_${agreement.userId}_clients`
          },
          filterBySearchValue(search)(agreement) ? button : null,
          agreement.clients.filter(
            (agreement2) => filterClientAgreement(agreement2, search, filterBySearchValue(search))
          ).map(
            (clientAgreement) => createAgreementButton(
              clientAgreement,
              fallbackImageSrc,
              handleChangeAgreement,
              isCurrentAgreement(clientAgreement, currentAgreement)
            )
          )
        );
      }
      return button;
    })
  ), handleAddAgreement ? /* @__PURE__ */ React__default.createElement(
    Button$4,
    {
      className: "focus-visible:!yt-focus-dark mx-2 my-1 !h-9 shrink-0 !bg-white/[0.08] !text-white hover:!bg-white/[0.16]",
      onClick: handleAddAgreement
    },
    texts.header.addAgreement
  ) : null, /* @__PURE__ */ React__default.createElement("hr", { className: "my-0 h-px w-full bg-white/[0.08]" }), /* @__PURE__ */ React__default.createElement(
    "a",
    {
      className: "focus-visible:yt-focus-dark mx-2 mb-2 flex h-8 shrink-0 items-center justify-center rounded text-white hover:cursor-pointer hover:text-white hover:underline focus-visible:outline-none",
      onClick: handleLogout,
      tabIndex: 0
    },
    texts.header.logout
  ))));
}
const filterBySearchValue = (search) => (agreement) => {
  if (!search || !search.length) {
    return true;
  }
  const matchesAgreementNumber = String(agreement.number).indexOf(search) > -1;
  const matchesCompanyName = agreement.name.toLowerCase().indexOf(search.toLowerCase()) > -1;
  return matchesAgreementNumber || matchesCompanyName;
};
const isCurrentAgreement = (agreement, currentAgreement) => {
  return agreement.number === currentAgreement.number && agreement.userId === currentAgreement.userId;
};
const createAgreementButton = (agreement, fallbackImageSrc, onChangeAgreement, isCurrentAgreement2 = false) => {
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      onChangeAgreement(agreement);
    }
  };
  return /* @__PURE__ */ React__default.createElement(
    "button",
    {
      "aria-current": isCurrentAgreement2 ? "true" : void 0,
      className: "focus:yt-focus-dark w-full rounded outline-none",
      "data-taco": "header-agreements-agreement",
      key: `${agreement.number}_${agreement.userId}`,
      onClick: () => onChangeAgreement(agreement),
      onKeyDown: handleKeyDown,
      tabIndex: 0
    },
    /* @__PURE__ */ React__default.createElement(
      AgreementItem,
      {
        ...agreement,
        className: "h-14 bg-white/[0.08] xl:hover:bg-white/[0.16] [[aria-current='true']>&]:bg-white/[0.16]",
        fallbackImageSrc
      }
    )
  );
};
function AgreementDisplay(props) {
  const { currentAgreement, fallbackImageSrc } = props;
  return /* @__PURE__ */ React__default.createElement(Container, null, /* @__PURE__ */ React__default.createElement(AgreementDisplay$1, { currentAgreement, fallbackImageSrc }));
}
const Header = React__default.forwardRef(function Header2(props, ref) {
  const className = clsx(
    "bg-blue-900 flex h-16 w-full shrink-0 items-center gap-2 pl-4",
    "[&>*:focus-visible]:yt-focus-dark [&>*]:rounded",
    // styles for logo wrapped inside an anchor
    props.className
  );
  return /* @__PURE__ */ React__default.createElement("header", { ...props, className, ref });
});
Header.AgreementDisplay = AgreementDisplay;
Header.AgreementSelector = AgreementSelector;
Header.Button = Button4;
Header.Link = Link$1;
Header.Logo = Logo;
Header.LogoLegacy = LogoLegacy;
Header.PrimaryNavigation = PrimaryNavigation;
Header.SecondaryNavigation = SecondaryNavigation;
Header.MenuButton = MenuButton;
const LayoutContext = React__default.createContext({ sidebarOpen: false, setSidebarOpen: () => void 0 });
const Content$1 = React__default.forwardRef(function LayoutContent(props, ref) {
  const className = clsx(
    "flex-grow overflow-y-auto print:overflow-visible print:h-full print:!p-0 bg-white flex flex-shrink flex-col relative",
    props.className
  );
  return /* @__PURE__ */ React__default.createElement("main", { ...props, className, ref });
});
const SidebarBackdrop = motion(Backdrop);
const Sidebar = React__default.forwardRef(function LayoutSidebar(props, ref) {
  const { children, ...attributes } = props;
  const { sidebarOpen, setSidebarOpen } = React__default.useContext(LayoutContext);
  const isLargeScreen = useIsLargeScreen();
  const isSmallScreen = !isLargeScreen;
  const isVisible2 = isLargeScreen || sidebarOpen;
  React__default.useEffect(() => {
    setSidebarOpen(isLargeScreen);
  }, [isLargeScreen]);
  React__default.useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape") {
        event.preventDefault();
        event.stopPropagation();
        setSidebarOpen(false);
      }
    };
    if (isSmallScreen && sidebarOpen) {
      window.addEventListener("keydown", handleEscapeKey);
    }
    return () => {
      window.removeEventListener("keydown", handleEscapeKey);
    };
  }, [isSmallScreen, sidebarOpen]);
  const showBackdrop = isSmallScreen && sidebarOpen === true;
  const [ready, setReady] = React__default.useState(isSmallScreen);
  const className = clsx(
    "bg-grey-50 h-full w-64 flex-shrink-0 flex-grow-0 print:hidden",
    {
      "absolute z-10 aria-hidden:-translate-x-64 ": isSmallScreen,
      // prevent animation when crossing the boundary from large to small screen,
      // this prevents awkward animation in the edge case (resizing the browser, instead of starting at a given size)
      invisible: isSmallScreen && !ready,
      "transition-[transform] duration-300 visible": isSmallScreen && ready,
      "border-r-2 border-black/[.08] ": !showBackdrop
    },
    props.className
  );
  React__default.useEffect(() => {
    setTimeout(() => {
      setReady(isSmallScreen);
    }, 1);
  }, [isSmallScreen]);
  const toggleSidebar = () => setSidebarOpen((open) => !open);
  const content = typeof children === "function" ? children({ isLargeScreen, open: sidebarOpen, toggleSidebar }) : children;
  if (!content) {
    return null;
  }
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("nav", { ...attributes, "data-responsive": isSmallScreen, "aria-hidden": !isVisible2, className, ref }, content), /* @__PURE__ */ React__default.createElement(AnimatePresence, null, showBackdrop && /* @__PURE__ */ React__default.createElement(
    SidebarBackdrop,
    {
      initial: { opacity: 0 },
      animate: { opacity: 1 },
      exit: { opacity: 0 },
      className: "z-[1]",
      onClick: () => setSidebarOpen(false)
    }
  )));
});
const Top = (props) => {
  const { setSidebarOpen } = React__default.useContext(LayoutContext);
  const toggleSidebar = () => setSidebarOpen((open) => !open);
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, typeof props.children === "function" ? props.children({ toggleSidebar }) : props.children);
};
const Page = React__default.forwardRef(function LayoutPage(props, ref) {
  const className = clsx("flex flex-grow overflow-hidden print:overflow-visible print:h-full relative", props.className);
  return /* @__PURE__ */ React__default.createElement("div", { ...props, className, ref });
});
const Layout = React__default.forwardRef(function Layout2(props, ref) {
  const [sidebarOpen, setSidebarOpen] = React__default.useState(false);
  const className = clsx(
    "flex h-screen w-screen flex-col overflow-hidden print:overflow-visible print:h-full relative",
    props.className
  );
  return /* @__PURE__ */ React__default.createElement(LayoutContext.Provider, { value: { sidebarOpen, setSidebarOpen } }, /* @__PURE__ */ React__default.createElement("div", { ...props, className, ref }));
});
Layout.Top = Top;
Layout.Page = Page;
Layout.Sidebar = Sidebar;
Layout.Content = Content$1;
const Group = React__default.forwardRef(function Group23(props, ref) {
  const { children, defaultExpanded = false, heading, onClick, ...attributes } = props;
  const [expanded, setExpanded] = React__default.useState(defaultExpanded);
  const className = clsx(
    "flex w-full cursor-pointer items-center rounded px-3 font-bold text-left leading-8 hover:bg-black/[.06] focus-visible:yt-focus-dark",
    attributes.className
  );
  const handleClick = (event) => {
    setExpanded(!expanded);
    if (onClick) {
      onClick(event);
    }
  };
  return /* @__PURE__ */ React__default.createElement("li", { ...attributes, role: "none", className: "[[role=menubar]>&]:px-3", ref }, /* @__PURE__ */ React__default.createElement(
    "button",
    {
      "aria-haspopup": "true",
      "aria-expanded": expanded,
      "data-taco": "navigation2-group",
      className,
      onClick: handleClick,
      role: "menuitem"
    },
    /* @__PURE__ */ React__default.createElement(Icon$1, { className: "-ml-2 !h-5 !w-5", name: expanded ? "chevron-down-solid" : "chevron-right-solid" }),
    /* @__PURE__ */ React__default.createElement("span", { className: "flex-grow truncate" }, heading)
  ), /* @__PURE__ */ React__default.createElement("ul", { className: clsx("mb-0 flex flex-col gap-y-px pt-px", { hidden: !expanded }), role: "menu" }, children));
});
const getAdjacentClasses = () => clsx(
  // styling if the element is proceeded by a link item
  "[[role=menubar]>[data-taco=navigation2-link-item]+&]:mt-2",
  "[[role=menubar]>[data-taco='navigation2-link-item']+&]:border-t-2",
  "[[role=menubar]>[data-taco='navigation2-link-item']+&]:pt-2 ",
  // styling if the element is proceeded by content
  "[[role=menubar]>[data-taco='navigation2-content']+&]:border-t-2",
  "[[role=menubar]>[data-taco='navigation2-content']+&]:pt-2",
  // styling if the element is proceeded by a section
  "[[role=menubar]>[data-taco='navigation2-section']+&]:border-t-2",
  "[[role=menubar]>[data-taco='navigation2-section']+&]:pt-2"
);
const getNavigationLinkClasses = (isDraggedOver = false) => clsx(
  "group relative flex w-full items-center rounded leading-8 !text-black px-2 focus-visible:yt-focus-dark",
  // override styles for links that are children of collapsible menus
  "font-bold [[role=menu]>li>&]:font-normal [[role=menu]>li>&]:pl-5",
  // override styles to adjust icons included in menu links
  '[&_[data-taco="icon"]]:!h-5 [&_[data-taco="icon"]]:!w-5',
  // override styles to adjust badges included in menu links
  '[&>span_[data-taco="badge"]]:mr-2.5 [[role=menu]>li>&>span_[data-taco="badge"]]:mr-2',
  {
    "hover:bg-black/[.06] aria-current-page:bg-blue-500/[.1]": !isDraggedOver,
    "!bg-blue-500 !text-white [&>*]:!text-white": isDraggedOver
  }
);
const Link3 = React__default.forwardRef(function Link23(props, ref) {
  const { active, children, icon, menu, onDrop, total, ...attributes } = props;
  const [isDraggedOver, dropTargetProps] = useDropTarget(onDrop);
  const className = clsx(getNavigationLinkClasses(isDraggedOver), attributes.className);
  const listClassName = clsx("[[role=menubar]>&]:px-3 border-grey-200", getAdjacentClasses(), {
    "[&>*]:pointer-events-none": isDraggedOver
  });
  return /* @__PURE__ */ React__default.createElement("li", { ...dropTargetProps, className: listClassName, "data-taco": "navigation2-link-item", role: "none" }, /* @__PURE__ */ React__default.createElement(
    "a",
    {
      ...attributes,
      "aria-current": active ? "page" : void 0,
      className,
      "data-taco": "navigation2-link",
      ref,
      role: "menuitem",
      tabIndex: 0
    },
    icon ? /* @__PURE__ */ React__default.createElement(Icon$1, { className: "mr-1.5 [[role=menu]>li>a>&]:-ml-1.5 [[role=menu]>li>a>&]:mr-0.5", name: icon }) : null,
    /* @__PURE__ */ React__default.createElement("span", { className: "flex flex-grow items-center truncate" }, children),
    menu ? /* @__PURE__ */ React__default.createElement(
      IconButton,
      {
        appearance: "discrete",
        icon: "more",
        "aria-label": "More",
        rounded: true,
        className: clsx(
          "-mr-1.5 hidden flex-shrink-0 flex-grow-0 transition-none group-hover:flex aria-expanded:flex",
          {
            "absolute right-0 !mr-0.5": total !== void 0
          }
        ),
        menu,
        onClick: (event) => {
          event.preventDefault();
          event.stopPropagation();
        }
      }
    ) : null,
    total !== void 0 ? /* @__PURE__ */ React__default.createElement(
      Badge2,
      {
        className: clsx("flex-shrink-0 flex-grow-0 !font-normal", {
          'group-hover:hidden [[aria-expanded="true"]+&]:hidden ': menu
        }),
        color: "transparent"
      },
      total
    ) : null
  ));
});
const Section = React__default.forwardRef(function Navigation22(props, ref) {
  const { children, heading, ...attributes } = props;
  const className = clsx(
    "w-full overflow-auto px-3 py-2 flex-grow border-grey-200 bg-grey-50 [[role=menubar]>&:first-child]:pt-0",
    getAdjacentClasses(),
    props.className
  );
  return /* @__PURE__ */ React__default.createElement("li", { ...attributes, className, "data-taco": "navigation2-section", ref, role: "none" }, heading ? /* @__PURE__ */ React__default.createElement("span", { className: "text-grey-500 mb-px truncate pl-5 text-xs font-bold uppercase leading-8 lg:hidden" }, heading) : null, /* @__PURE__ */ React__default.createElement("ul", { className: "mb-0 flex flex-col gap-y-px" }, children));
});
const Content = React__default.forwardRef(function Navigation23(props, ref) {
  const { children, ...attributes } = props;
  const className = clsx(
    "w-full overflow-auto p-3 mt-auto border-grey-200 flex-shrink-0 z-10 bg-grey-50 [[role=menubar]>&:last-child]:pb-0",
    getAdjacentClasses(),
    props.className
  );
  return /* @__PURE__ */ React__default.createElement("li", { ...attributes, className, "data-taco": "navigation2-content", ref, role: "none" }, children);
});
const Navigation24 = React__default.forwardRef(function Navigation222(props, ref) {
  const { children, ...attributes } = props;
  const className = clsx("m-0 py-2 flex flex-col gap-y-px overflow-auto h-full w-full bg-grey-50", props.className);
  return /* @__PURE__ */ React__default.createElement("ul", { ...attributes, className, "data-taco": "navigation2", ref, role: "menubar", style: { opacity: 0.999 } }, children);
});
Navigation24.Group = Group;
Navigation24.Link = Link3;
Navigation24.Section = Section;
Navigation24.Content = Content;
const DATASET_SIZE_MULTIPLIER = 15;
function getDataKey(sorting, filters, hiddenColumns, search) {
  return [JSON.stringify(sorting), JSON.stringify(filters), JSON.stringify(hiddenColumns), JSON.stringify(search)].join("_");
}
function useTableDataLoader2(fetchPage, fetchAll, options = { pageSize: DEFAULT_PAGE_SIZE$1 }) {
  const { pageSize } = options;
  const DATASET_SIZE = DATASET_SIZE_MULTIPLIER * pageSize;
  const length = React__default.useRef(0);
  const [data, setData] = React__default.useState({ rows: [], pages: [], cache: {}, lastFetchedPage: void 0 });
  const _pendingPageRequests = React__default.useRef({});
  const _lastUsedSorting = React__default.useRef([]);
  const _lastUsedFilters = React__default.useRef([]);
  const _lastUsedHiddenColumns = React__default.useRef([]);
  const _lastUsedSearch = React__default.useRef();
  async function loadPage(pageIndex, sorting, filters, hiddenColumns, search) {
    const hasDataChanged = JSON.stringify(sorting) !== JSON.stringify(_lastUsedSorting.current) || JSON.stringify(filters) !== JSON.stringify(_lastUsedFilters.current) || JSON.stringify(hiddenColumns) !== JSON.stringify(_lastUsedHiddenColumns.current) || search !== _lastUsedSearch.current;
    if (hasDataChanged) {
      _lastUsedSorting.current = sorting;
      _lastUsedFilters.current = filters;
      _lastUsedSearch.current = search;
      _lastUsedHiddenColumns.current = hiddenColumns;
      _pendingPageRequests.current = {};
    } else {
      if (_pendingPageRequests.current[pageIndex]) {
        return;
      }
      if (data.cache[pageIndex] && data.cache[pageIndex][0]) {
        return;
      }
    }
    const dataKey = getDataKey(sorting, filters, hiddenColumns, search);
    _pendingPageRequests.current[pageIndex] = dataKey;
    try {
      const response = await fetchPage(pageIndex, pageSize, sorting, filters, hiddenColumns, search);
      if (dataKey !== _pendingPageRequests.current[pageIndex]) {
        return;
      }
      length.current = response.length;
      setData((currentData) => {
        const direction = getDirection(pageIndex, currentData.pages);
        const nextPages = getPages(
          pageIndex,
          currentData.lastFetchedPage,
          hasDataChanged ? [] : currentData.pages,
          direction
        );
        _lastUsedSorting.current = sorting;
        _lastUsedFilters.current = filters;
        _lastUsedSearch.current = search;
        _lastUsedHiddenColumns.current = hiddenColumns;
        let nextCache;
        if (hasDataChanged || !direction) {
          nextCache = nextPages.reduce((acc, p2) => ({ ...acc, [p2]: Array(pageSize).fill(void 0) }), {});
        } else {
          nextCache = { ...currentData.cache };
        }
        nextCache[pageIndex] = response.data;
        if (direction === "forward" && currentData.rows.length >= DATASET_SIZE) {
          delete nextCache[currentData.pages[0]];
        } else if (direction === "backward" && currentData.rows.length >= DATASET_SIZE) {
          delete nextCache[currentData.pages[currentData.pages.length - 1]];
        }
        const rows = Object.values(nextCache).reduce((acc, p2) => acc.concat(p2), []);
        return {
          cache: nextCache,
          pages: nextPages,
          rows,
          lastFetchedPage: pageIndex
        };
      });
      requestAnimationFrame(() => {
        delete _pendingPageRequests.current[pageIndex];
      });
    } catch {
    }
  }
  const loadAll = async (sorting, filters, hiddenColumns, search) => {
    _lastUsedSorting.current = sorting;
    _lastUsedFilters.current = filters;
    _lastUsedSearch.current = search;
    _lastUsedHiddenColumns.current = hiddenColumns;
    try {
      const response = await fetchAll(sorting, filters, hiddenColumns, search);
      length.current = response.length;
      const pages = [];
      const cache = {};
      const pageCount = Math.ceil(response.length / pageSize);
      Array.from(Array(pageCount).keys()).forEach((index2) => {
        pages.push(index2);
        const startIndex = index2 * pageSize;
        cache[index2] = response.data.slice(startIndex, startIndex + pageSize);
      });
      setData({
        cache,
        pages,
        rows: response.data,
        lastFetchedPage: void 0
      });
    } catch {
    } finally {
      _pendingPageRequests.current = {};
    }
  };
  async function reloadCurrentPages(currentPageIndex, sorting, filters, hiddenColumns, search) {
    const index2 = data.pages.indexOf(currentPageIndex);
    const pageIndexes = [data.pages[index2 - 1], currentPageIndex, data.pages[index2 + 1]].filter((x3) => x3 !== void 0);
    const dataKey = getDataKey(sorting, filters, hiddenColumns, search);
    _pendingPageRequests.current = pageIndexes.reduce((accum, index22) => ({ ...accum, [index22]: dataKey }), {});
    try {
      const responses = await Promise.all(
        pageIndexes.map((pageIndex) => fetchPage(pageIndex, pageSize, sorting, filters, hiddenColumns, search))
      );
      length.current = responses[0].length;
      const nextPages = pageIndexes;
      _lastUsedSorting.current = sorting;
      _lastUsedFilters.current = filters;
      _lastUsedSearch.current = search;
      _lastUsedHiddenColumns.current = hiddenColumns;
      const nextCache = nextPages.reduce(
        (acc, p2, index22) => ({ ...acc, [p2]: responses[index22].data }),
        {}
      );
      const rows = Object.values(nextCache).reduce((acc, p2) => acc.concat(p2), []);
      setData({
        cache: nextCache,
        pages: nextPages,
        rows,
        lastFetchedPage: pageIndexes[pageIndexes.length - 1]
      });
      requestAnimationFrame(() => {
        _pendingPageRequests.current = {};
      });
    } catch {
    }
  }
  const invalidate = async () => {
    return reloadCurrentPages(
      getCurrentPage(data.pages),
      _lastUsedSorting.current,
      _lastUsedFilters.current,
      _lastUsedHiddenColumns.current,
      _lastUsedSearch.current
    );
  };
  const handleSort = async (sorting) => {
    return reloadCurrentPages(
      getCurrentPage(data.pages),
      sorting,
      _lastUsedFilters.current,
      _lastUsedHiddenColumns.current,
      _lastUsedSearch.current
    );
  };
  const handleFilter = async (filters, hiddenColumns) => {
    return loadPage(0, _lastUsedSorting.current, filters, hiddenColumns, _lastUsedSearch.current);
  };
  const handleSearch = async (search, hiddenColumns) => {
    return loadPage(0, _lastUsedSorting.current, _lastUsedFilters.current, hiddenColumns, search);
  };
  return [
    {
      data: data.rows,
      pages: data.pages,
      length: length.current,
      loadAll,
      loadPage,
      onChangeFilter: handleFilter,
      onChangeSearch: handleSearch,
      onChangeSort: handleSort,
      pageSize,
      _experimentalDataLoader2: true
    },
    invalidate
  ];
}
function getCurrentPage(currentPages) {
  if (currentPages.length <= 2) {
    return currentPages[0];
  }
  const middle = Math.floor(currentPages.length / 2);
  return currentPages[middle];
}
function getDirection(pageIndex, currentPages) {
  if (currentPages.length) {
    if (pageIndex === currentPages[currentPages.length - 1] + 1) {
      return "forward";
    } else if (pageIndex === currentPages[0] - 1 || currentPages.length === 2 && currentPages[0] !== 0 && pageIndex === currentPages[0]) {
      return "backward";
    }
  }
  return void 0;
}
function getPages(pageIndex, lastUsedPageIndex, currentPages, direction) {
  if (currentPages.length && (pageIndex === lastUsedPageIndex || currentPages.includes(pageIndex))) {
    return currentPages;
  }
  if (direction === "forward") {
    const nextPages = currentPages.length === DATASET_SIZE_MULTIPLIER ? currentPages.slice(1) : currentPages;
    return nextPages.concat(pageIndex);
  }
  if (direction === "backward") {
    const nextPages = currentPages.length === DATASET_SIZE_MULTIPLIER ? currentPages.slice(0, -1) : currentPages;
    return [pageIndex].concat(nextPages);
  }
  return [pageIndex];
}
const useBoundaryOverflowDetection = (ref, dependencies = []) => {
  const [boundaryIndex, setBoundaryIndex] = React__default.useState();
  const dimensions = useBoundingClientRectListener(ref, dependencies);
  React__default.useEffect(() => {
    if (ref.current) {
      const boundaryChildIndex = getIndexOfFirstChildOverflowingParent(ref.current);
      setBoundaryIndex(boundaryChildIndex);
    }
  }, [ref, dimensions == null ? void 0 : dimensions.width, ...dependencies]);
  return boundaryIndex;
};
const useOnClickOutside = (ref, callback) => {
  React__default.useEffect(() => {
    const listener = (event) => {
      const refs = !Array.isArray(ref) ? [ref] : ref;
      if (refs.some((currentRef) => !currentRef.current || currentRef.current.contains(event.target))) {
        return;
      }
      callback(event);
    };
    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);
    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [ref, callback]);
};
export {
  Accordion,
  Alert$1 as Alert,
  AlertDialog,
  AreaChart,
  Backdrop,
  Badge2 as Badge,
  BadgeIcon,
  Banner,
  BarChart,
  Base$1 as Base,
  Button$4 as Button,
  Calendar,
  Card,
  Checkbox$2 as Checkbox,
  Collection$1 as CollectionPrimitive,
  Combobox,
  DEFAULT_PAGE_SIZE$1 as DEFAULT_PAGE_SIZE,
  Datepicker,
  Dialog,
  DonutChart,
  Drawer,
  Field,
  FontSizes,
  Form,
  Group$6 as Group,
  Hanger,
  Header,
  HoverCard,
  Icon$1 as Icon,
  IconButton,
  Input,
  Layout,
  LegacyDonutChart,
  LineChart,
  List$1 as List,
  Listbox,
  LocalizationContext,
  LocalizationProvider,
  Menu$1 as Menu,
  ModeSwitch,
  MultiListbox,
  Navigation,
  Navigation24 as Navigation2,
  OverflowGroup,
  PaginatedTable,
  Pagination,
  PieChart,
  Popover,
  Progress,
  Provider,
  RadioGroup2 as RadioGroup,
  Report,
  SearchInput,
  SearchInput22 as SearchInput2,
  Select,
  Select22 as Select2,
  Shortcut,
  Spinner,
  Switch$1 as Switch,
  Table,
  Table3,
  TableFilterComparator,
  Tabs,
  TacoContext,
  Tag,
  Textarea,
  Title$2 as Title,
  ToastProvider,
  Tooltip$3 as Tooltip,
  Tour,
  TourStep,
  Treeview,
  Truncate,
  VisuallyHidden,
  WindowedTable,
  convertRowIndexPathToNumberArray,
  createShortcutKeyDownHandler,
  defaultLocalisationTexts,
  defaultLocalizationContext,
  fixedForwardRef,
  format$1 as format,
  getByRowIndexPath,
  getNavigationLinkClasses,
  getNextIndexFromKey,
  getParentRowIndexPath,
  icons,
  insertChildTableRow,
  isMacOs,
  isPressingMetaKey,
  isWeakEqual$1 as isWeakEqual,
  mergeRefs,
  parse$1 as parse,
  parseFromCustomString,
  parseFromISOString,
  removeChildTableRow,
  setByRowIndexPath,
  shouldTriggerShortcut,
  useBoundaryOverflowDetection,
  useBoundingClientRectListener,
  useDropTarget,
  useIntersectionObserver,
  useIsLargeScreen,
  useLazyEffect,
  useListKeyboardNavigation,
  useListScrollTo,
  useLocalization,
  useMatchMedia,
  useMergedRef,
  useOnClickOutside,
  usePagination,
  useTableDataLoader,
  useTableDataLoader2,
  useTableRowCreation,
  useToast
};
//# sourceMappingURL=taco.js.map
